webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(436);


/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _freeze = __webpack_require__(86);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _typeof2 = __webpack_require__(28);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _classCallCheck2 = __webpack_require__(56);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(57);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _WebSocketRails = __webpack_require__(452);
	
	var _WebSocketRails2 = _interopRequireDefault(_WebSocketRails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function resolveOptionalEnddateArgs(enddateOrSuccess, successOrFailure, failure) {
	  if (typeof enddateOrSuccess === 'function') {
	    return { enddate: null, success: enddateOrSuccess, failure: successOrFailure };
	  }
	  return { enddate: enddateOrSuccess || null, success: successOrFailure, failure: failure };
	}
	
	function toDatetimeForApi(enddate) {
	  if (!enddate) return null;
	  if (/^\d{4}-\d{2}-\d{2}$/.test(enddate)) {
	    return enddate + ' 23:59:59';
	  }
	  return enddate;
	}
	
	function withOptionalEnddate(payload, enddate) {
	  var toDatetime = toDatetimeForApi(enddate);
	  if (toDatetime) payload.to_datetime = toDatetime;
	  return payload;
	}
	
	var Docendo = function () {
	  function Docendo() {
	    (0, _classCallCheck3.default)(this, Docendo);
	
	    console.log('open docendo connection');
	    Docendo.self = this;
	  }
	
	  (0, _createClass3.default)(Docendo, [{
	    key: 'open',
	    value: function open() {
	      console.log('open', this);
	      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
	      this.state.websocket =  true ? new _WebSocketRails2.default(window.location.host + '/websocket?tz=' + tz) : new _WebSocketRails2.default('localhost:3000/websocket?tz=' + tz);
	      this.state.websocket.on_open = this.opened;
	      this.state.websocket.bind('connection_closed', this.closed);
	    }
	  }, {
	    key: 'opened',
	    value: function opened() {
	      console.log('opened', this);
	      window.dispatcher = this;
	      Docendo.self.state.retries = 1;
	      Docendo.self.notifyConnected();
	    }
	  }, {
	    key: 'closed',
	    value: function closed() {
	      console.log('closed', this);
	      setTimeout(function () {
	        if (Docendo.self.state.retries < 16) Docendo.self.state.retries *= 2;
	        Docendo.self.open(Docendo.opened, Docendo.closed);
	      }, Docendo.self.state.reconnectTimeout * Docendo.self.state.retries);
	      Docendo.self.notifyDisconnected('closed', Docendo.self);
	    }
	  }, {
	    key: 'subscribeConnected',
	    value: function subscribeConnected(fn) {
	      this.state.observersConnected.push(fn);
	    }
	  }, {
	    key: 'subscribeDisconnected',
	    value: function subscribeDisconnected(fn) {
	      this.state.observersDisconnected.push(fn);
	    }
	  }, {
	    key: 'notifyConnected',
	    value: function notifyConnected() {
	      Docendo.self.state.observersConnected.forEach(function (item) {
	        item.call();
	      });
	    }
	  }, {
	    key: 'notifyDisconnected',
	    value: function notifyDisconnected() {
	      Docendo.self.state.observersDisconnected.forEach(function (item) {
	        item.call();
	      });
	    }
	  }, {
	    key: 'bind',
	    value: function bind(message, func) {
	      this.state.websocket.bind(message, func);
	    }
	  }, {
	    key: 'state',
	    value: function state() {
	      return this.state.websocket.state;
	    }
	  }, {
	    key: 'eventsFromCalendars',
	    value: function eventsFromCalendars(calendarIds, start, end, haveCollision, success, failure) {
	      this.state.websocket.trigger('api.events.list', {
	        calendar_ids: calendarIds,
	        start: start,
	        end: end,
	        have_collision: haveCollision
	      }, success, failure);
	    }
	  }, {
	    key: 'publicEventsFromCalendar',
	    value: function publicEventsFromCalendar(calendarId, start, end, success, failure) {
	      this.state.websocket.trigger('api.events.list_public', {
	        calendar_id: calendarId,
	        start: start,
	        end: end
	      }, success, failure);
	    }
	  }, {
	    key: 'calendarEvents2',
	    value: function calendarEvents2(calendarIds, start, end, eventTypeFilter, success, failure) {
	      this.state.websocket.trigger('api.events.list', {
	        calendar_ids: calendarIds,
	        start: start,
	        end: end,
	        event_type_filter: eventTypeFilter
	      }, success, failure);
	    }
	  }, {
	    key: 'eventsBySubjects',
	    value: function eventsBySubjects(subjectIds, start, end, success, failure) {
	      this.state.websocket.trigger('api.events.list_by_subjects', {
	        subject_ids: subjectIds,
	        start: start,
	        end: end
	      }, success, failure);
	    }
	  }, {
	    key: 'calendarPublicEvents',
	    value: function calendarPublicEvents(calendarId, start, end, notes, eventTypeFilter, noFormat, success, failure) {
	      this.state.websocket.trigger('api.calendars.public_events', {
	        calendar_id: calendarId,
	        start: start,
	        end: end,
	        notes: notes,
	        event_type_filter: eventTypeFilter,
	        no_format: noFormat
	      }, success, failure);
	    }
	  }, {
	    key: 'calendar',
	    value: function calendar(calendarId, success, failure) {
	      this.state.websocket.trigger('api.calendars.get', {
	        calendar_id: calendarId
	      }, success, failure);
	    }
	  }, {
	    key: 'calendarCopyWeeks',
	    value: function calendarCopyWeeks(calendarIds, sourceDate, destinationDates, deleteExisting, onlyEventTypes, exceptEventTypes, success, failure) {
	      this.state.websocket.trigger('api.calendars.copy_weeks', {
	        calendar_ids: calendarIds,
	        source_date: sourceDate,
	        destination_dates: destinationDates,
	        delete_existing: deleteExisting,
	        only_event_types: onlyEventTypes,
	        except_event_types: exceptEventTypes
	      }, success, failure);
	    }
	  }, {
	    key: 'subjectEventsCreate',
	    value: function subjectEventsCreate(schoolId, calendarId, sourceDate, destinationDates, deleteExisting, onlyEventTypes, exceptEventTypes, onlySubjectIds, onlyEventIds, success, failure) {
	      this.state.websocket.trigger('api.calendars.copy', {
	        school_id: schoolId,
	        calendar_id: calendarId,
	        source_date: sourceDate,
	        destination_dates: destinationDates,
	        delete_existing: deleteExisting,
	        only_event_types: onlyEventTypes,
	        except_event_types: exceptEventTypes,
	        only_subject_ids: onlySubjectIds,
	        only_event_ids: onlyEventIds
	      }, success, failure);
	    }
	  }, {
	    key: 'calendarCopyDays',
	    value: function calendarCopyDays(schoolId, calendarIds, sourceDates, destinationDates, success, failure) {
	      this.state.websocket.trigger('api.calendars.copy_days', {
	        school_id: schoolId,
	        calendar_ids: calendarIds,
	        source_dates: sourceDates,
	        destination_dates: destinationDates
	      }, success, failure);
	    }
	  }, {
	    key: 'mergeCalendar',
	    value: function mergeCalendar(schoolId, calendarId, mergeCalendarId, success, failure) {
	      this.state.websocket.trigger('api.calendars.merge', {
	        school_id: schoolId,
	        calendar_id: calendarId,
	        merge_calendar_id: mergeCalendarId
	      }, success, failure);
	    }
	  }, {
	    key: 'unmergeCalendar',
	    value: function unmergeCalendar(schoolId, calendarId, mergeCalendarId, success, failure) {
	      this.state.websocket.trigger('api.calendars.unmerge', {
	        school_id: schoolId,
	        calendar_id: calendarId,
	        merge_calendar_id: mergeCalendarId
	      }, success, failure);
	    }
	  }, {
	    key: 'listCalendarMerges',
	    value: function listCalendarMerges(schoolId, success, failure) {
	      this.state.websocket.trigger('api.calendars.merges', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'createEvent',
	    value: function createEvent(schoolId, calendarId, calendarIds, subjectId, start, end, learningGoal, description, notesForStudents, teacherNotes, successOrOptions, failureOrSuccess, maybeFailure) {
	      var away = false;
	      var substituteCalendarIds = null;
	      var success = successOrOptions;
	      var failure = failureOrSuccess;
	      if (typeof successOrOptions === 'boolean') {
	        away = successOrOptions;
	        success = failureOrSuccess;
	        failure = maybeFailure;
	      } else if (successOrOptions && (typeof successOrOptions === 'undefined' ? 'undefined' : (0, _typeof3.default)(successOrOptions)) === 'object') {
	        away = successOrOptions.away === true;
	        substituteCalendarIds = successOrOptions.substituteCalendarIds || null;
	        success = failureOrSuccess;
	        failure = maybeFailure;
	      }
	      var payload = {
	        school_id: schoolId,
	        calendar_id: calendarId,
	        calendar_ids: calendarIds,
	        subject_id: subjectId,
	        start: start,
	        end: end,
	        learning_goal: learningGoal,
	        description: description,
	        notes_for_students: notesForStudents,
	        teacher_notes: teacherNotes,
	        away: away
	      };
	      if (substituteCalendarIds && substituteCalendarIds.length > 0) {
	        payload.substitute_calendar_ids = substituteCalendarIds;
	      }
	      this.state.websocket.trigger('api.schools.events.create', payload, success, failure);
	    }
	  }, {
	    key: 'updateEvent',
	    value: function updateEvent(schoolId, eventId, eventParams, success, failure) {
	      this.state.websocket.trigger('api.schools.events.update', {
	        school_id: schoolId,
	        event_id: eventId,
	        event: eventParams
	      }, success, failure);
	    }
	  }, {
	    key: 'updateEvents',
	    value: function updateEvents(schoolId, updates, success, failure) {
	      this.state.websocket.trigger('api.events.update', {
	        school_id: schoolId,
	        updates: updates
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteEvent',
	    value: function deleteEvent(schoolId, eventId, success, failure) {
	      this.state.websocket.trigger('api.schools.events.delete', {
	        school_id: schoolId,
	        event_id: eventId
	      }, success, failure);
	    }
	  }, {
	    key: 'listEvents',
	    value: function listEvents(schoolId, date, success, failure) {
	      this.state.websocket.trigger('api.schools.events.list', {
	        school_id: schoolId,
	        date: date
	      }, success, failure);
	    }
	  }, {
	    key: 'listEventsForSchools',
	    value: function listEventsForSchools(schoolIds, date, success, failure) {
	      this.state.websocket.trigger('api.schools.events.list', {
	        school_ids: schoolIds,
	        date: date
	      }, success, failure);
	    }
	  }, {
	    key: 'calendarCopyCheck',
	    value: function calendarCopyCheck(calendarId, dates, success, failure) {
	      this.state.websocket.trigger('api.events.copy_check_weeks', {
	        calendar_id: calendarId,
	        dates: dates
	      }, success, failure);
	    }
	  }, {
	    key: 'splitEvent',
	    value: function splitEvent(eventId, splitTime, success, failure) {
	      this.state.websocket.trigger('api.events.split', {
	        event_id: eventId,
	        split_time: splitTime
	      }, success, failure);
	    }
	  }, {
	    key: 'calendarOverlaps',
	    value: function calendarOverlaps(eventIds, success, failure) {
	      this.state.websocket.trigger('api.events.calendar_overlaps', {
	        event_ids: eventIds
	      }, success, failure);
	    }
	  }, {
	    key: 'removeSubstitutionOfUser',
	    value: function removeSubstitutionOfUser(schoolId, eventIds, userId, substitutionStatus, success, failure) {
	      this.state.websocket.trigger('api.events.remove_substitution_of_user', {
	        school_id: schoolId,
	        event_ids: eventIds,
	        user_id: userId,
	        substitution_status: substitutionStatus
	      }, success, failure);
	    }
	  }, {
	    key: 'getNotificationsUnreadBeforeId',
	    value: function getNotificationsUnreadBeforeId(count, onlyUnread, beforeId, success, failure) {
	      this.state.websocket.trigger('api.notifications.list', {
	        count: count,
	        only_unread: onlyUnread,
	        before_id: beforeId
	      }, success, failure);
	    }
	  }, {
	    key: 'updateNotification',
	    value: function updateNotification(id, changes, success, failure) {
	      this.state.websocket.trigger('api.notifications.update', { id: id, changes: changes }, success, failure);
	    }
	  }, {
	    key: 'markAllNotificationsAsRead',
	    value: function markAllNotificationsAsRead(success, failure) {
	      this.state.websocket.trigger('api.notifications.mark_all_as_read', {}, success, failure);
	    }
	  }, {
	    key: 'notificationsUnreadCount',
	    value: function notificationsUnreadCount(success, failure) {
	      this.state.websocket.trigger('api.notifications.unread_count', {}, success, failure);
	    }
	  }, {
	    key: 'getNotificationsList',
	    value: function getNotificationsList(count, success, failure) {
	      this.state.websocket.trigger('api.notifications.list', { count: count }, success, failure);
	    }
	  }, {
	    key: 'getNotificationsListUnread',
	    value: function getNotificationsListUnread(count, onlyUnread, success, failure) {
	      this.state.websocket.trigger('api.notifications.list', { count: count, only_unread: onlyUnread }, success, failure);
	    }
	  }, {
	    key: 'getNotificationsBefore',
	    value: function getNotificationsBefore(count, beforeId, success, failure) {
	      this.state.websocket.trigger('api.notifications.list', { count: count, before_id: beforeId }, success, failure);
	    }
	  }, {
	    key: 'calendarsForSchool',
	    value: function calendarsForSchool(id, success, failure) {
	      this.state.websocket.trigger('api.calendars.for_school', { school_id: id }, success);
	    }
	  }, {
	    key: 'deleteEventsRange',
	    value: function deleteEventsRange(calendar, from, to, success, failure) {
	      this.state.websocket.trigger('api.events.delete', { calendar: calendar, from: from, to: to }, success, failure);
	    }
	  }, {
	    key: 'deleteEventCalendar',
	    value: function deleteEventCalendar(id, calendar, success, failure) {
	      this.state.websocket.trigger('api.events.delete_calendar', { id: id, calendar_id: calendar }, success, failure);
	    }
	  }, {
	    key: 'getUser',
	    value: function getUser(success, failure) {
	      this.state.websocket.trigger('api.users.get', {}, success);
	    }
	  }, {
	    key: 'showUser',
	    value: function showUser(userId, success, failure) {
	      this.state.websocket.trigger('api.users.show', { user_id: userId }, success);
	    }
	  }, {
	    key: 'getJwt',
	    value: function getJwt(success, failure) {
	      this.state.websocket.trigger('api.users.jwt', {}, success);
	    }
	  }, {
	    key: 'updateUser',
	    value: function updateUser(changes, success, failure) {
	      this.state.websocket.trigger('api.users.update', changes, success);
	    }
	  }, {
	    key: 'updateUserProfileImage',
	    value: function updateUserProfileImage(userId, profileImage, success, failure) {
	      this.state.websocket.trigger('api.users.update_profile_image', { id: userId, profile_image: profileImage }, success, failure);
	    }
	  }, {
	    key: 'updateUsers',
	    value: function updateUsers(schoolId, userId, changes, success, failure) {
	      this.state.websocket.trigger('api.schools.users.update', {
	        school_id: schoolId,
	        user_id: userId,
	        changes: changes
	      }, success, failure);
	    }
	  }, {
	    key: 'updateUserPhone',
	    value: function updateUserPhone(schoolId, userId, phone, success, failure) {
	      this.state.websocket.trigger('api.schools.user_phone.update', {
	        school_id: schoolId,
	        user_id: userId,
	        user: {
	          unconfirmed_phone: phone
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteUserPhone',
	    value: function deleteUserPhone(schoolId, userId, success, failure) {
	      this.state.websocket.trigger('api.schools.user_phone.delete', {
	        school_id: schoolId,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolVacationDaysCreate',
	    value: function schoolVacationDaysCreate(school, date, success, failure) {
	      this.state.websocket.trigger('api.school_vacation_days.create', { school: school, day: date }, success, failure);
	    }
	  }, {
	    key: 'schoolVacationDaysRead',
	    value: function schoolVacationDaysRead(school, success, failure) {
	      this.state.websocket.trigger('api.school_vacation_days.read', { school: school }, success, failure);
	    }
	  }, {
	    key: 'schoolVacationDaysDelete',
	    value: function schoolVacationDaysDelete(school, id, success, failure) {
	      this.state.websocket.trigger('api.school_vacation_days.delete', { school: school, id: id }, success, failure);
	    }
	  }, {
	    key: 'specialDaysIndex',
	    value: function specialDaysIndex(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.special_days.index', { school_id: schoolId, school_year_id: schoolYearId }, success, failure);
	    }
	  }, {
	    key: 'specialDaysShow',
	    value: function specialDaysShow(schoolId, schoolYearId, id, success, failure) {
	      this.state.websocket.trigger('api.special_days.show', { school_id: schoolId, school_year_id: schoolYearId, id: id }, success, failure);
	    }
	  }, {
	    key: 'specialDaysCreate',
	    value: function specialDaysCreate(schoolId, schoolYearId, attrs, success, failure) {
	      this.state.websocket.trigger('api.special_days.create', (0, _assign2.default)({ school_id: schoolId, school_year_id: schoolYearId }, attrs), success, failure);
	    }
	  }, {
	    key: 'specialDaysUpdate',
	    value: function specialDaysUpdate(schoolId, schoolYearId, id, attrs, success, failure) {
	      this.state.websocket.trigger('api.special_days.update', (0, _assign2.default)({ school_id: schoolId, school_year_id: schoolYearId, id: id }, attrs), success, failure);
	    }
	  }, {
	    key: 'specialDaysDestroy',
	    value: function specialDaysDestroy(schoolId, schoolYearId, id, success, failure) {
	      this.state.websocket.trigger('api.special_days.destroy', { school_id: schoolId, school_year_id: schoolYearId, id: id }, success, failure);
	    }
	  }, {
	    key: 'specialDaysUpdateReductions',
	    value: function specialDaysUpdateReductions(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.special_days.update_reductions', { school_id: schoolId, school_year_id: schoolYearId }, success, failure);
	    }
	  }, {
	    key: 'articlesIndex',
	    value: function articlesIndex(locale, success, failure) {
	      this.state.websocket.trigger('api.articles.index', { locale: locale }, success, failure);
	    }
	  }, {
	    key: 'articlesIndexNew',
	    value: function articlesIndexNew(locale, success, failure) {
	      this.state.websocket.trigger('api.articles.index_new', { locale: locale }, success, failure);
	    }
	  }, {
	    key: 'articlesGet',
	    value: function articlesGet(id, locale, success, failure) {
	      this.state.websocket.trigger('api.articles.get', { id: id, locale: locale }, success, failure);
	    }
	  }, {
	    key: 'articlesSearch',
	    value: function articlesSearch(query, locale, success, failure) {
	      this.state.websocket.trigger('api.articles.search', { query: query, locale: locale }, success, failure);
	    }
	  }, {
	    key: 'schoolYearsRead',
	    value: function schoolYearsRead(school, filter, sort, success, failure) {
	      this.state.websocket.trigger('api.school_years.read', {
	        school: school,
	        filter: filter,
	        sort: sort
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolYearsUpdate',
	    value: function schoolYearsUpdate(school, id, changes, success, failure) {
	      this.state.websocket.trigger('api.school_years.update', {
	        school: school,
	        id: id,
	        changes: changes
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolSubscribe',
	    value: function schoolSubscribe(school, subscription, success, failure) {
	      console.log('schoolSubscribe', subscription);
	      this.state.websocket.trigger('api.schools.subscribe', {
	        school_id: school,
	        subscription: subscription
	      }, success, failure);
	    }
	  }, {
	    key: 'weeknote',
	    value: function weeknote(calendarId, week, success, failure) {
	      this.state.websocket.trigger('api.weeknotes.show', { calendar_id: calendarId, week: week }, success, failure);
	    }
	  }, {
	    key: 'weeknoteUpdate',
	    value: function weeknoteUpdate(calendarId, week, note, success, failure) {
	      this.state.websocket.trigger('api.weeknotes.update', {
	        calendar_id: calendarId,
	        week: week,
	        note: note
	      }, success, failure);
	    }
	  }, {
	    key: 'bulkPresenceEvent',
	    value: function bulkPresenceEvent(calendarId, toCreate, toUpdate, toDelete, success, failure) {
	      this.state.websocket.trigger('api.presence.update', { bulk_presence_event: { to_create: toCreate, to_update: toUpdate, to_delete: toDelete } }, success, failure);
	    }
	  }, {
	    key: 'createPresenceForMany',
	    value: function createPresenceForMany(schoolId, calendarIds, weekDates, events, success, failure) {
	      this.state.websocket.trigger('api.presence.create', {
	        school_id: schoolId,
	        calendar_ids: calendarIds,
	        week_dates: weekDates,
	        events: events
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolEvents',
	    value: function schoolEvents(schoolId, from, to, userIdsFilter, eventTypeFilter, success, failure) {
	      this.state.websocket.trigger('api.school_user_events.read', {
	        school_id: schoolId,
	        from_datetime: from,
	        to_datetime: to,
	        user_ids_filter: userIdsFilter,
	        event_type_filter: eventTypeFilter
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolUsers',
	    value: function schoolUsers(schoolId, userIdsFilter, success, failure) {
	      this.state.websocket.trigger('api.schools.users.read', {
	        school_id: schoolId,
	        user_ids_filter: userIdsFilter
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolUsers2',
	    value: function schoolUsers2(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.users.read2', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolUsersCreate',
	    value: function schoolUsersCreate(schoolId, users, success, failure) {
	      this.state.websocket.trigger('api.schools.users.create', {
	        school_id: schoolId,
	        users: users
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolUsersAssignPermissionSet',
	    value: function schoolUsersAssignPermissionSet(schoolId, userIds, permissionSetId, success, failure) {
	      this.state.websocket.trigger('api.schools.users.assign_permission_set', {
	        school_id: schoolId,
	        user_ids: userIds,
	        permission_set_id: permissionSetId
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolEventSerialsList',
	    value: function schoolEventSerialsList(schoolId, date, success, failure) {
	      this.state.websocket.trigger('api.schools.event_serials.list', {
	        school_id: schoolId,
	        date: date
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolEventSerialsListKmd',
	    value: function schoolEventSerialsListKmd(schoolId, startDate, endDate, success, failure) {
	      this.state.websocket.trigger('api.schools.event_serials.list', {
	        school_id: schoolId,
	        start_date: startDate,
	        end_date: endDate
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolEventSerialsCreate',
	    value: function schoolEventSerialsCreate(schoolId, calendarId, subjectId, fromDate, toDate, fromTime, toTime, ongoing, internalNote, employmentId, useTime, additionalData, success, failure) {
	      this.state.websocket.trigger('api.schools.event_serials.create', {
	        school_id: schoolId,
	        calendar_id: calendarId,
	        subject_id: subjectId,
	        from_date: fromDate,
	        to_date: toDate,
	        from_time: fromTime,
	        to_time: toTime,
	        ongoing: ongoing,
	        internal_note: internalNote,
	        employment_id: employmentId,
	        use_time: useTime,
	        additional_data: additionalData
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolEventSerialsUpdate',
	    value: function schoolEventSerialsUpdate(schoolId, eventSerialId, calendarId, subjectId, fromDate, toDate, fromTime, toTime, ongoing, internalNote, employmentId, useTime, additionalData, success, failure) {
	      this.state.websocket.trigger('api.schools.event_serials.update', {
	        id: eventSerialId,
	        school_id: schoolId,
	        calendar_id: calendarId,
	        subject_id: subjectId,
	        from_date: fromDate,
	        to_date: toDate,
	        from_time: fromTime,
	        to_time: toTime,
	        ongoing: ongoing,
	        internal_note: internalNote,
	        employment_id: employmentId,
	        use_time: useTime,
	        additional_data: additionalData
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolEventSerialsDelete',
	    value: function schoolEventSerialsDelete(schoolId, eventSerialId, success, failure) {
	      this.state.websocket.trigger('api.schools.event_serials.destroy', {
	        school_id: schoolId,
	        id: eventSerialId
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolEventSerialsRetrySend',
	    value: function schoolEventSerialsRetrySend(schoolId, eventSerialId, success, failure) {
	      this.state.websocket.trigger('api.schools.event_serials.retry_send', {
	        school_id: schoolId,
	        id: eventSerialId
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolAbsenceSubjectsList',
	    value: function schoolAbsenceSubjectsList(schoolId, includeArchived, success, failure) {
	      this.state.websocket.trigger('api.schools.absence_subjects.list', {
	        school_id: schoolId,
	        include_archived: includeArchived
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolAbsenceSubjectsCreate',
	    value: function schoolAbsenceSubjectsCreate(schoolId, name, color, defaultPrivate, defaultOngoing, plannedAbsence, kmdAbsenceCodeId, sdAbsenceCodeId, canRequest, success, failure) {
	      this.state.websocket.trigger('api.schools.absence_subjects.create', {
	        school_id: schoolId,
	        name: name,
	        color: color,
	        default_private: defaultPrivate,
	        default_ongoing: defaultOngoing,
	        planned_absence: plannedAbsence,
	        kmd_absence_code_id: kmdAbsenceCodeId,
	        sd_absence_code_id: sdAbsenceCodeId,
	        can_request: canRequest
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolAbsenceSubjectsUpdate',
	    value: function schoolAbsenceSubjectsUpdate(id, schoolId, name, color, defaultPrivate, defaultOngoing, plannedAbsence, kmdAbsenceCodeId, sdAbsenceCodeId, canRequest, success, failure) {
	      this.state.websocket.trigger('api.schools.absence_subjects.update', {
	        id: id,
	        school_id: schoolId,
	        name: name,
	        color: color,
	        default_private: defaultPrivate,
	        default_ongoing: defaultOngoing,
	        planned_absence: plannedAbsence,
	        kmd_absence_code_id: kmdAbsenceCodeId,
	        sd_absence_code_id: sdAbsenceCodeId,
	        can_request: canRequest
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolAbsenceSubjectsArchive',
	    value: function schoolAbsenceSubjectsArchive(schoolId, id, success, failure) {
	      this.state.websocket.trigger('api.schools.absence_subjects.archive', {
	        school_id: schoolId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolAbsenceSubjectsUnarchive',
	    value: function schoolAbsenceSubjectsUnarchive(schoolId, id, success, failure) {
	      this.state.websocket.trigger('api.schools.absence_subjects.unarchive', {
	        school_id: schoolId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolBulkCreateCalendars',
	    value: function schoolBulkCreateCalendars(schoolId, schoolYearId, calendars, success, failure) {
	      this.state.websocket.trigger('api.calendars.bulk_create', {
	        school_id: schoolId,
	        schoolYearId: schoolYearId,
	        calendars: calendars
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolBulkUpdateCalendars',
	    value: function schoolBulkUpdateCalendars(schoolId, calendars, success, failure) {
	      this.state.websocket.trigger('api.calendars.bulk_update', {
	        school_id: schoolId,
	        calendars: calendars
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolCalendarsUpdate',
	    value: function schoolCalendarsUpdate(schoolId, calendarId, changes, success, failure) {
	      this.state.websocket.trigger('api.calendars.update', {
	        school_id: schoolId,
	        calendar_id: calendarId,
	        calendar: changes
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolCalendarsDelete',
	    value: function schoolCalendarsDelete(schoolId, calendarId, success, failure) {
	      this.state.websocket.trigger('api.calendars.delete', {
	        school_id: schoolId,
	        calendar_id: calendarId
	      }, success, failure);
	    }
	  }, {
	    key: 'subjectNormsSchool',
	    value: function subjectNormsSchool(schoolId, success, failure) {
	      this.state.websocket.trigger('api.subject_norms.index', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'eventAddSubstitute',
	    value: function eventAddSubstitute(event, added, subFor, success, failure) {
	      this.state.websocket.trigger('api.events.add_substitute', {
	        event: event,
	        user: added,
	        substitute_for_user: subFor
	      }, success, failure);
	    }
	  }, {
	    key: 'eventRemoveSubstitute',
	    value: function eventRemoveSubstitute(event, user, subFor, success, failure) {
	      this.state.websocket.trigger('api.events.remove_substitute', {
	        event: event,
	        user: user,
	        substitute_for_user: subFor
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolTags',
	    value: function schoolTags(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.tags.index', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolTagsBulkCreate',
	    value: function schoolTagsBulkCreate(schoolId, tags, userIds, success, failure) {
	      this.state.websocket.trigger('api.schools.tags.bulk_create', {
	        school_id: schoolId,
	        tags: tags,
	        user_ids: userIds
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolTagsBulkDelete',
	    value: function schoolTagsBulkDelete(schoolId, tags, userIds, success, failure) {
	      this.state.websocket.trigger('api.schools.tags.bulk_delete', {
	        school_id: schoolId,
	        tags: tags,
	        user_ids: userIds
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolAssignedHours',
	    value: function schoolAssignedHours(schoolId, year, userIdsFilter, success, failure) {
	      this.state.websocket.trigger('api.schools.assigned_hours.read', {
	        school_id: schoolId,
	        year: year,
	        user_ids_filter: userIdsFilter
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolRecalculateAll',
	    value: function schoolRecalculateAll(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.recalculate.recalculate_all', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolActualHours',
	    value: function schoolActualHours(schoolId, fromDateTime, toDateTime, userIdsFilter, success, failure) {
	      this.state.websocket.trigger('api.schools.actual_hours.read', {
	        school_id: schoolId,
	        from_datetime: fromDateTime,
	        to_datetime: toDateTime,
	        user_ids_filter: userIdsFilter
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolUserYearRead',
	    value: function schoolUserYearRead(schoolId, userId, year, success, failure) {
	      this.state.websocket.trigger('api.schools.user_years.read', {
	        school_id: schoolId,
	        user_id: userId,
	        year: year
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolUserYearsList',
	    value: function schoolUserYearsList(schoolId, schoolYearId, userId, success, failure) {
	      this.state.websocket.trigger('api.schools.user_years.list', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolUserYearUpdate',
	    value: function schoolUserYearUpdate(schoolId, userId, year, data, success, failure) {
	      this.state.websocket.trigger('api.schools.user_years.update', {
	        school_id: schoolId,
	        user_id: userId,
	        year: year,
	        user_data: data
	      }, success, failure);
	    }
	  }, {
	    key: 'bulkSchoolUserYearUpdate',
	    value: function bulkSchoolUserYearUpdate(schoolId, year, data, success, failure) {
	      this.state.websocket.trigger('api.schools.user_years.bulk_update', {
	        school_id: schoolId,
	        user_id: null,
	        year: year,
	        users_data: data
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolAvailabilities',
	    value: function schoolAvailabilities(schoolId, calendarType, startTime, endTime, success, failure) {
	      this.state.websocket.trigger('api.schools.availabilities.list', {
	        school_id: schoolId,
	        calendar_type: calendarType,
	        start_time: startTime,
	        end_time: endTime
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolSubstituteDayNoteRead',
	    value: function schoolSubstituteDayNoteRead(schoolId, day, success, failure) {
	      this.state.websocket.trigger('api.schools.substitute_day_notes.show', {
	        school_id: schoolId,
	        note: {
	          day: day
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolSubstituteDayNoteUpdate',
	    value: function schoolSubstituteDayNoteUpdate(schoolId, day, note, success, failure) {
	      this.state.websocket.trigger('api.schools.substitute_day_notes.update', {
	        school_id: schoolId,
	        note: {
	          day: day,
	          note: note
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolSubstituteHours',
	    value: function schoolSubstituteHours(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.substitute_hours.index', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'countSms',
	    value: function countSms(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.sms.count', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'sendSmses',
	    value: function sendSmses(schoolId, userIds, message, success, failure) {
	      this.state.websocket.trigger('api.schools.sms.ship', {
	        school_id: schoolId,
	        user_ids: userIds,
	        message: message
	      }, success, failure);
	    }
	  }, {
	    key: 'pastSmses',
	    value: function pastSmses(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.sms.past', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'sendEmails',
	    value: function sendEmails(schoolId, userIds, subject, message, success, failure) {
	      this.state.websocket.trigger('api.schools.email.ship', {
	        school_id: schoolId,
	        user_ids: userIds,
	        subject: subject,
	        message: message
	      }, success, failure);
	    }
	  }, {
	    key: 'readSmsTemplates',
	    value: function readSmsTemplates(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.sms_templates.read', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'createMessageTemplate',
	    value: function createMessageTemplate(schoolId, title, body, messageType, success, failure) {
	      this.state.websocket.trigger('api.schools.message_templates.create', {
	        school_id: schoolId,
	        title: title,
	        body: body,
	        message_type: messageType
	      }, success, failure);
	    }
	  }, {
	    key: 'readMessageTemplates',
	    value: function readMessageTemplates(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.message_templates.read', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'updateMessageTemplate',
	    value: function updateMessageTemplate(schoolId, id, title, body, messageType, success, failure) {
	      this.state.websocket.trigger('api.schools.message_templates.update', {
	        school_id: schoolId,
	        id: id,
	        title: title,
	        body: body,
	        message_type: messageType
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteMessageTemplate',
	    value: function deleteMessageTemplate(schoolId, id, success, failure) {
	      this.state.websocket.trigger('api.schools.message_templates.delete', {
	        school_id: schoolId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'eventChanges',
	    value: function eventChanges(schoolId, eventId, success, failure) {
	      this.state.websocket.trigger('api.schools.events.changes', {
	        school_id: schoolId,
	        event_id: eventId
	      }, success, failure);
	    }
	  }, {
	    key: 'createSubject',
	    value: function createSubject(name, color, calendarId, defaultDuration, preparation, hours, subjectType, schoolId, schoolYearId, calendarIds, subjectCode, away, fromDate, toDate, taskOverview, success, failure) {
	      var additionalCalendarIds = Array.isArray(calendarIds) ? calendarIds.filter(function (id) {
	        return id != null && Number(id) !== Number(calendarId);
	      }) : [];
	      var payload = {
	        name: name,
	        color: color,
	        calendar_id: calendarId,
	        default_duration: defaultDuration,
	        preparation: preparation,
	        hours: hours,
	        subject_type: subjectType,
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        calendar_ids: additionalCalendarIds,
	        subject_code: subjectCode,
	        away: away,
	        from_date: fromDate,
	        to_date: toDate
	      };
	
	      if (taskOverview !== null && taskOverview !== undefined) {
	        payload.task_overview = taskOverview;
	      }
	      this.state.websocket.trigger('api.subjects.create', payload, success, failure);
	    }
	  }, {
	    key: 'bulkCreateSubjects',
	    value: function bulkCreateSubjects(schoolId, schoolYearId, subjects, success, failure) {
	      var normalizedSubjects = Array.isArray(subjects) ? subjects.map(function (subject) {
	        var calendarId = subject.calendar_id;
	        var calendarIds = Array.isArray(subject.calendar_ids) ? subject.calendar_ids.filter(function (id) {
	          return id != null && Number(id) !== Number(calendarId);
	        }) : subject.calendar_ids;
	        return (0, _assign2.default)({}, subject, { calendar_ids: calendarIds });
	      }) : subjects;
	      this.state.websocket.trigger('api.subjects.bulk_create', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        subjects: normalizedSubjects
	      }, success, failure);
	    }
	  }, {
	    key: 'readSubjects',
	    value: function readSubjects(schoolId, schoolYearId, userId, success, failure) {
	      this.state.websocket.trigger('api.subjects.read', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'showSubject',
	    value: function showSubject(subjectId, success, failure) {
	      this.state.websocket.trigger('api.subjects.show', {
	        id: subjectId
	      }, success, failure);
	    }
	  }, {
	    key: 'updateSubject',
	    value: function updateSubject(id, name, color, calendarId, calendarIds, defaultDuration, preparation, hours, subjectType, schoolId, schoolYearId, subjectCode, away, defaultPrivate, fromDate, toDate, taskOverview, success, failure) {
	      var payload = {
	        id: id,
	        name: name,
	        color: color,
	        calendar_id: calendarId,
	        default_duration: defaultDuration,
	        hours: hours,
	        subject_type: subjectType,
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        calendar_ids: calendarIds,
	        subject_code: subjectCode,
	        preparation: preparation,
	        away: away,
	        default_private: defaultPrivate,
	        from_date: fromDate,
	        to_date: toDate
	      };
	
	      if (taskOverview !== null && taskOverview !== undefined) {
	        payload.task_overview = taskOverview;
	      }
	      this.state.websocket.trigger('api.subjects.update', payload, success, failure);
	    }
	  }, {
	    key: 'bulkUpdateSubjects',
	    value: function bulkUpdateSubjects(schoolId, ids, changes, success, failure) {
	      this.state.websocket.trigger('api.subjects.bulk_update', {
	        school_id: schoolId,
	        ids: ids,
	        changes: changes
	      }, success, failure);
	    }
	  }, {
	    key: 'bulkDeleteSubjects',
	    value: function bulkDeleteSubjects(schoolId, ids, success, failure) {
	      this.state.websocket.trigger('api.subjects.bulk_delete', {
	        school_id: schoolId,
	        ids: ids
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteSubject',
	    value: function deleteSubject(id, schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.subjects.delete', {
	        id: id,
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'setHoursForTeacherOnSubject',
	    value: function setHoursForTeacherOnSubject(id, schoolId, schoolYearId, calendarId, hours, success, failure) {
	      this.state.websocket.trigger('api.subjects.set_hours', {
	        id: id,
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        hours: hours,
	        calendar_id: calendarId
	      }, success, failure);
	    }
	  }, {
	    key: 'auditSubject',
	    value: function auditSubject(schoolId, subjectId, success, failure) {
	      this.state.websocket.trigger('api.audit.subject', {
	        subject_id: subjectId,
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'auditDeletedEventsBySubject',
	    value: function auditDeletedEventsBySubject(schoolId, subjectId, success, failure) {
	      this.state.websocket.trigger('api.audit.deleted_events_by_subject', {
	        subject_id: subjectId,
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'auditWeeknote',
	    value: function auditWeeknote(schoolId, weeknoteId, success, failure) {
	      this.state.websocket.trigger('api.audit.weeknote', {
	        school_id: schoolId,
	        weeknote_id: weeknoteId
	      }, success, failure);
	    }
	  }, {
	    key: 'auditUser',
	    value: function auditUser(success, failure) {
	      this.state.websocket.trigger('api.audit.user', {}, success, failure);
	    }
	  }, {
	    key: 'auditLogSchool',
	    value: function auditLogSchool(schoolId, success, failure) {
	      this.state.websocket.trigger('api.audit_logs.school', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'auditLogUser',
	    value: function auditLogUser(schoolId, userId, success, failure) {
	      this.state.websocket.trigger('api.audit_logs.user', {
	        school_id: schoolId,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'auditLogCalendar',
	    value: function auditLogCalendar(schoolId, calendarId, success, failure) {
	      this.state.websocket.trigger('api.audit_logs.calendar', {
	        school_id: schoolId,
	        calendar_id: calendarId
	      }, success, failure);
	    }
	  }, {
	    key: 'createTask',
	    value: function createTask(schoolId, schoolYearId, subjectType, hours, name, color, defaultDuration, preparation, belongsToCalendars, userCalendars, canSchedule, inUserCalendar, fromDate, toDate, success, failure) {
	      this.state.websocket.trigger('api.schools.tasks.create', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        task: {
	          subject_type: subjectType,
	          hours: hours,
	          name: name,
	          color: color,
	          default_duration: defaultDuration,
	          preparation: preparation,
	          belongs_to_calendars: belongsToCalendars,
	          user_calendars: userCalendars,
	          can_schedule: canSchedule,
	          in_user_calendar: inUserCalendar,
	          from_date: fromDate,
	          to_date: toDate
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'readTasks',
	    value: function readTasks(schoolId, schoolYearId, userId, success, failure) {
	      this.state.websocket.trigger('api.schools.tasks.read', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'updateTask',
	    value: function updateTask(schoolId, schoolYearId, id, name, color, hours, defaultDuration, preparation, belongsToCalendars, userCalendars, inUserCalendar, fromDate, toDate, success, failure) {
	      this.state.websocket.trigger('api.schools.tasks.update', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        id: id,
	        task: {
	          hours: hours,
	          name: name,
	          color: color,
	          default_duration: defaultDuration,
	          preparation: preparation,
	          belongs_to_calendars: belongsToCalendars,
	          user_calendars: userCalendars,
	          in_user_calendar: inUserCalendar,
	          from_date: fromDate,
	          to_date: toDate
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteTask',
	    value: function deleteTask(schoolId, schoolYearId, id, success, failure) {
	      this.state.websocket.trigger('api.schools.tasks.delete', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'createExport',
	    value: function createExport(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.exports.create', {
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'loadExportSettings',
	    value: function loadExportSettings(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.exports.load_settings', {
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'exportToZen',
	    value: function exportToZen(schoolId, schoolYearId, settings, success, failure) {
	      this.state.websocket.trigger('api.exports.export', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        settings: settings
	      }, success, failure);
	    }
	  }, {
	    key: 'permissionSetsPermissions',
	    value: function permissionSetsPermissions(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.permission_sets.permissions', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'permissionSetsRead',
	    value: function permissionSetsRead(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.permission_sets.read', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'permissionSetsCreate',
	    value: function permissionSetsCreate(schoolId, name, permissions, success, failure) {
	      this.state.websocket.trigger('api.schools.permission_sets.create', {
	        school_id: schoolId,
	        permission_set: {
	          name: name,
	          permissions: permissions
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'permissionSetsUpdate',
	    value: function permissionSetsUpdate(schoolId, id, name, permissions, success, failure) {
	      this.state.websocket.trigger('api.schools.permission_sets.update', {
	        school_id: schoolId,
	        permission_set: {
	          id: id,
	          name: name,
	          permissions: permissions
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'permissionSetsDelete',
	    value: function permissionSetsDelete(schoolId, id, success, failure) {
	      this.state.websocket.trigger('api.schools.permission_sets.delete', {
	        school_id: schoolId,
	        permission_set: {
	          id: id
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'employmentsForSchool',
	    value: function employmentsForSchool(schoolId, success, failure) {
	      this.state.websocket.trigger('api.employments.read', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'employmentsForUser',
	    value: function employmentsForUser(schoolId, userId, success, failure) {
	      this.state.websocket.trigger('api.employments.read', {
	        school_id: schoolId,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'employmentsForSchoolForUser',
	    value: function employmentsForSchoolForUser(schoolId, userId, success, failure) {
	      this.state.websocket.trigger('api.employments.read', {
	        school_id: schoolId,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'unusedEmployments',
	    value: function unusedEmployments(schoolId, success, failure) {
	      this.state.websocket.trigger('api.employments.unused_employments', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteUnusedEmployments',
	    value: function deleteUnusedEmployments(schoolId, success, failure) {
	      this.state.websocket.trigger('api.employments.unused_employments', {
	        school_id: schoolId,
	        delete: true
	      }, success, failure);
	    }
	  }, {
	    key: 'bulkCreateEmployment',
	    value: function bulkCreateEmployment(schoolId, userIds, titles, manualSalary, employmentTemplateIdOrSuccess, successOrFailure, failure) {
	      var employmentTemplateId = typeof employmentTemplateIdOrSuccess === 'function' ? null : employmentTemplateIdOrSuccess;
	      var success = typeof employmentTemplateIdOrSuccess === 'function' ? employmentTemplateIdOrSuccess : successOrFailure;
	      var theFailure = typeof employmentTemplateIdOrSuccess === 'function' ? successOrFailure : failure;
	      this.state.websocket.trigger('api.employments.bulk_create', {
	        school_id: schoolId,
	        user_ids: userIds,
	        titles: titles,
	        manual_salary: manualSalary,
	        employment_template_id: employmentTemplateId
	      }, success, theFailure);
	    }
	  }, {
	    key: 'createEmployment',
	    value: function createEmployment(schoolId, userId, employmentNumber, title, employmentTemplateId, manualSalary, success, failure) {
	      this.state.websocket.trigger('api.employments.create', {
	        school_id: schoolId,
	        employment: {
	          user_id: userId,
	          employment_number: employmentNumber,
	          title: title,
	          employment_template_id: employmentTemplateId,
	          manual_salary: manualSalary
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'importEmployment',
	    value: function importEmployment(schoolId, userId, employmentNumber, success, failure) {
	      this.state.websocket.trigger('api.employments.import', {
	        school_id: schoolId,
	        user_id: userId,
	        employment_number: employmentNumber
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteEmployment',
	    value: function deleteEmployment(schoolId, userId, employmentId, success, failure) {
	      this.state.websocket.trigger('api.employments.delete', {
	        school_id: schoolId,
	        user_id: userId,
	        id: employmentId
	      }, success, failure);
	    }
	  }, {
	    key: 'updateEmployment',
	    value: function updateEmployment(schoolId, userId, employmentId, manualSalary, defaultLoenart, defaultLoebenummer, defaultOmkostningssted, employmentTemplateId, salaryCodeId, success, failure) {
	      this.state.websocket.trigger('api.employments.update', {
	        school_id: schoolId,
	        id: employmentId,
	        employment: {
	          user_id: userId,
	          manual_salary: manualSalary,
	          default_loenart: defaultLoenart,
	          default_loebenummer: defaultLoebenummer,
	          employment_template_id: employmentTemplateId,
	          salary_code_id: salaryCodeId,
	          default_omkostningssted: defaultOmkostningssted
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'assignEmploymentTemplateToEmployment',
	    value: function assignEmploymentTemplateToEmployment(schoolId, employmentTemplateId, employmentIds, success, failure) {
	      this.state.websocket.trigger('api.employments.bulk_assign_template', {
	        school_id: schoolId,
	        employment_template_id: employmentTemplateId,
	        employment_ids: employmentIds
	      }, success, failure);
	    }
	  }, {
	    key: 'salaryDays',
	    value: function salaryDays(schoolId, schoolIds, fromDate, toDate, success, failure) {
	      this.state.websocket.trigger('api.salaries.read', {
	        school_id: schoolId,
	        school_ids: schoolIds,
	        from_date: fromDate,
	        to_date: toDate
	      }, success, failure);
	    }
	  }, {
	    key: 'salaryDayUpdate',
	    value: function salaryDayUpdate(schoolId, schoolIds, day, success, failure) {
	      this.state.websocket.trigger('api.salaries.update', {
	        school_id: schoolId,
	        school_ids: schoolIds,
	        day: day
	      }, success, failure);
	    }
	  }, {
	    key: 'salaryDaysBulkSend',
	    value: function salaryDaysBulkSend(schoolId, schoolIds, days, success, failure) {
	      this.state.websocket.trigger('api.salaries.bulk_send', {
	        school_id: schoolId,
	        school_ids: schoolIds,
	        days: days
	      }, success, failure);
	    }
	  }, {
	    key: 'salaryOpusRead',
	    value: function salaryOpusRead(schoolId, schoolIds, fromDate, toDate, userId, success, failure) {
	      this.state.websocket.trigger('api.salaries.opus_read', {
	        school_id: schoolId,
	        school_ids: schoolIds,
	        from_date: fromDate,
	        to_date: toDate,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'salaryCodes',
	    value: function salaryCodes(schoolId, success, failure) {
	      this.state.websocket.trigger('api.salary_codes.index', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'createSalaryCode',
	    value: function createSalaryCode(schoolId, name, loenart, tillaegsnummer, success, failure) {
	      this.state.websocket.trigger('api.salary_codes.create', {
	        school_id: schoolId,
	        salary_code: {
	          name: name,
	          loenart: loenart,
	          tillaegsnummer: tillaegsnummer
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'readTaskCategories',
	    value: function readTaskCategories(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.task_categories.index', {
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'createTaskCategory',
	    value: function createTaskCategory(schoolId, schoolYearId, name, rank, subjectTypes, success, failure) {
	      this.state.websocket.trigger('api.task_categories.create', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        name: name,
	        rank: rank,
	        subject_types: subjectTypes
	      }, success, failure);
	    }
	  }, {
	    key: 'updateTaskCategory',
	    value: function updateTaskCategory(schoolId, schoolYearId, id, name, rank, subjectTypes, success, failure) {
	      this.state.websocket.trigger('api.task_categories.update', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        id: id,
	        name: name,
	        rank: rank,
	        subject_types: subjectTypes
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteTaskCategory',
	    value: function deleteTaskCategory(schoolId, schoolYearId, id, success, failure) {
	      this.state.websocket.trigger('api.task_categories.destroy', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'readSubjectCalendars',
	    value: function readSubjectCalendars(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.subject_calendars.index', {
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'readUserHoursForSchoolYear',
	    value: function readUserHoursForSchoolYear(schoolId, schoolYearId, userId, success, failure, taskOverview) {
	      var payload = {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_id: userId
	      };
	      if (taskOverview !== null && taskOverview !== undefined) {
	        payload.task_overview = taskOverview;
	      }
	      this.state.websocket.trigger('api.user_hours_for_school_year.read', payload, success, failure);
	    }
	  }, {
	    key: 'bulkUpdateSubjectCalendars',
	    value: function bulkUpdateSubjectCalendars(schoolId, schoolYearId, updates, success, failure) {
	      this.state.websocket.trigger('api.subject_calendars.bulk_update', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        updates: updates
	      }, success, failure);
	    }
	  }, {
	    key: 'bulkUpdateSubjectCalendarsSalary',
	    value: function bulkUpdateSubjectCalendarsSalary(schoolId, schoolYearId, updates, success, failure) {
	      this.state.websocket.trigger('api.subject_calendars.bulk_update_salary', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        updates: updates
	      }, success, failure);
	    }
	  }, {
	    key: 'listImports',
	    value: function listImports(schoolId, success, failure) {
	      this.state.websocket.trigger('api.imports.index', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'enqueueImport',
	    value: function enqueueImport(schoolId, scheduleUuid, date, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.imports.create', {
	        school_id: schoolId,
	        schedule_uuid: scheduleUuid,
	        date: date,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'listZenImports',
	    value: function listZenImports(schoolId, success, failure) {
	      this.state.websocket.trigger('api.imports.list_zen_imports', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'subjectsForCalendarType',
	    value: function subjectsForCalendarType(calendarType, country, success, failure) {
	      this.state.websocket.trigger('api.subjects.subjects_for_calendar_type', {
	        calendar_type: calendarType,
	        country: country
	      }, success, failure);
	    }
	  }, {
	    key: 'subjectActuals',
	    value: function subjectActuals(schoolId, schoolYearId, userId, fromDate, toDate, success, failure) {
	      this.state.websocket.trigger('api.subject_actuals.read', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_id: userId,
	        from_date: fromDate,
	        to_date: toDate
	      }, success, failure);
	    }
	  }, {
	    key: 'userTasks',
	    value: function userTasks(userId, fromDate, toDate, taskOverview, success, failure) {
	      var payload = {
	        user_id: userId,
	        from_date: fromDate,
	        to_date: toDate
	      };
	
	      if (taskOverview !== null && taskOverview !== undefined) {
	        payload.task_overview = taskOverview;
	      }
	      this.state.websocket.trigger('api.users.tasks', payload, success, failure);
	    }
	  }, {
	    key: 'calendarActualHoursPerWeek',
	    value: function calendarActualHoursPerWeek(calendarId, fromDate, toDate, success, failure) {
	      this.state.websocket.trigger('api.calendars.actual_hours_per_week_per_master_type', {
	        calendar_id: calendarId,
	        from_date: fromDate,
	        to_date: toDate
	      }, success, failure);
	    }
	  }, {
	    key: 'createCalendarRelation',
	    value: function createCalendarRelation(schoolId, calendarId, otherCalendarId, relation, success, failure) {
	      this.state.websocket.trigger('api.calendar_relations.create', {
	        school_id: schoolId,
	        calendar_id: calendarId,
	        other_calendar_id: otherCalendarId,
	        relation: relation
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteCalendarRelation',
	    value: function deleteCalendarRelation(schoolId, id, success, failure) {
	      this.state.websocket.trigger('api.calendar_relations.destroy', {
	        school_id: schoolId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'indexCalendarRelations',
	    value: function indexCalendarRelations(schoolId, success, failure) {
	      this.state.websocket.trigger('api.calendar_relations.index', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'employmentTypesForSchool',
	    value: function employmentTypesForSchool(schoolId, success, failure) {
	      this.state.websocket.trigger('api.employment_types.read', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'createEmploymentType',
	    value: function createEmploymentType(schoolId, title, manualSalary, success, failure) {
	      this.state.websocket.trigger('api.employment_types.create', {
	        school_id: schoolId,
	        employment_type: {
	          title: title,
	          manual_salary: manualSalary
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'updateEmploymentType',
	    value: function updateEmploymentType(schoolId, id, title, manualSalary, success, failure) {
	      this.state.websocket.trigger('api.employment_types.update', {
	        id: id,
	        school_id: schoolId,
	        employment_type: {
	          title: title,
	          manual_salary: manualSalary
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteEmploymentType',
	    value: function deleteEmploymentType(schoolId, id, success, failure) {
	      this.state.websocket.trigger('api.employment_types.delete', {
	        id: id,
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'sidebar',
	    value: function sidebar(calendarId, date, success, failure) {
	      this.state.websocket.trigger('api.subjects.sidebar', {
	        calendar_id: calendarId,
	        date: date
	      }, success, failure);
	    }
	  }, {
	    key: 'listSchools',
	    value: function listSchools(success, failure) {
	      this.state.websocket.trigger('api.schools.index', {}, success, failure);
	    }
	  }, {
	    key: 'showSchool',
	    value: function showSchool(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.show', {
	        id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'absenceForDate',
	    value: function absenceForDate(schoolId, date, success, failure) {
	      this.state.websocket.trigger('api.schools.absence_for_date', {
	        id: schoolId,
	        date: date
	      }, success, failure);
	    }
	  }, {
	    key: 'listSalaryOrganisations',
	    value: function listSalaryOrganisations(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.list_salary_organisations', {
	        id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'employmentsOutsideSalaryOrganisations',
	    value: function employmentsOutsideSalaryOrganisations(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.employments_outside_salary_organisations', {
	        id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'updateSchool',
	    value: function updateSchool(schoolId, updates, success, failure) {
	      this.state.websocket.trigger('api.schools.update', {
	        id: schoolId,
	        school: updates
	      }, success, failure);
	    }
	  }, {
	    key: 'calendarCreateNormSubjects',
	    value: function calendarCreateNormSubjects(schoolId, calendarStepList, success, failure) {
	      this.state.websocket.trigger('api.calendars.create_norm_subjects', {
	        school_id: schoolId,
	        calendar_steps: calendarStepList
	      }, success, failure);
	    }
	  }, {
	    key: 'eventAvailability',
	    value: function eventAvailability(calendarId, eventId, start, end, success, failure) {
	      this.state.websocket.trigger('api.calendars.availability', {
	        calendar_id: calendarId,
	        event_id: eventId,
	        start: start,
	        end: end
	      }, success, failure);
	    }
	  }, {
	    key: 'subjectAvailability',
	    value: function subjectAvailability(calendarId, subjectId, start, end, success, failure) {
	      this.state.websocket.trigger('api.calendars.availability', {
	        calendar_id: calendarId,
	        subject_id: subjectId,
	        start: start,
	        end: end
	      }, success, failure);
	    }
	  }, {
	    key: 'showStilReport',
	    value: function showStilReport(schoolId, success, failure) {
	      this.state.websocket.trigger('api.stil_reports.show', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'updateStilReport',
	    value: function updateStilReport(schoolId, report, success, failure) {
	      this.state.websocket.trigger('api.stil_reports.update', {
	        school_id: schoolId,
	        report: report
	      }, success, failure);
	    }
	  }, {
	    key: 'submitStilReport',
	    value: function submitStilReport(schoolId, success, failure) {
	      this.state.websocket.trigger('api.stil_reports.submit', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'showStilCompetencyReport',
	    value: function showStilCompetencyReport(schoolId, success, failure) {
	      this.state.websocket.trigger('api.stil_competency.show', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'updateStilCompetencyReport',
	    value: function updateStilCompetencyReport(schoolId, report, success, failure) {
	      this.state.websocket.trigger('api.stil_competency.update', {
	        school_id: schoolId,
	        report: report
	      }, success, failure);
	    }
	  }, {
	    key: 'submitStilCompetencyReport',
	    value: function submitStilCompetencyReport(schoolId, success, failure) {
	      this.state.websocket.trigger('api.stil_competency.submit', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'listUserCompetencies',
	    value: function listUserCompetencies(schoolId, userId, success, failure) {
	      this.state.websocket.trigger('api.users.competencies.index', {
	        school_id: schoolId,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'updateUserCompetencies',
	    value: function updateUserCompetencies(schoolId, userId, competencies, success, failure) {
	      this.state.websocket.trigger('api.users.competencies.update', {
	        school_id: schoolId,
	        user_id: userId,
	        competencies: competencies
	      }, success, failure);
	    }
	  }, {
	    key: 'eventsDeleteThisAndFollowing',
	    value: function eventsDeleteThisAndFollowing(schoolId, eventId, success, failure) {
	      this.state.websocket.trigger('api.events.delete_this_and_following', {
	        school_id: schoolId,
	        event_id: eventId
	      }, success, failure);
	    }
	  }, {
	    key: 'eventSwap',
	    value: function eventSwap(schoolId, fromEventId, toEventId, success, failure) {
	      this.state.websocket.trigger('api.events.swap', {
	        school_id: schoolId,
	        from: fromEventId,
	        to: toEventId
	      }, success, failure);
	    }
	  }, {
	    key: 'eventReplace',
	    value: function eventReplace(schoolId, eventId, subjectId, success, failure) {
	      this.state.websocket.trigger('api.events.replace', {
	        school_id: schoolId,
	        event: eventId,
	        subject: subjectId
	      }, success, failure);
	    }
	  }, {
	    key: 'eventReplaceCalendar',
	    value: function eventReplaceCalendar(schoolId, eventId, calendarIdToReplace, calendarIdToReplaceWith, enddateOrSuccess, successOrFailure, failure) {
	      var args = resolveOptionalEnddateArgs(enddateOrSuccess, successOrFailure, failure);
	      this.state.websocket.trigger('api.events.replace_calendar', withOptionalEnddate({
	        school_id: schoolId,
	        event_id: eventId,
	        calendar_id_to_replace: calendarIdToReplace,
	        calendar_id_to_replace_with: calendarIdToReplaceWith
	      }, args.enddate), args.success, args.failure);
	    }
	  }, {
	    key: 'eventAddCalendar',
	    value: function eventAddCalendar(schoolId, eventId, calendarIdToAdd, enddateOrSuccess, successOrFailure, failure) {
	      var args = resolveOptionalEnddateArgs(enddateOrSuccess, successOrFailure, failure);
	      this.state.websocket.trigger('api.events.add_calendar', withOptionalEnddate({
	        school_id: schoolId,
	        event_id: eventId,
	        calendar_id_to_add: calendarIdToAdd
	      }, args.enddate), args.success, args.failure);
	    }
	  }, {
	    key: 'eventRemoveCalendar',
	    value: function eventRemoveCalendar(schoolId, eventId, calendarIdToRemove, enddateOrSuccess, successOrFailure, failure) {
	      var args = resolveOptionalEnddateArgs(enddateOrSuccess, successOrFailure, failure);
	      this.state.websocket.trigger('api.events.remove_calendar', withOptionalEnddate({
	        school_id: schoolId,
	        event_id: eventId,
	        calendar_id_to_remove: calendarIdToRemove
	      }, args.enddate), args.success, args.failure);
	    }
	  }, {
	    key: 'eventListSwapable',
	    value: function eventListSwapable(schoolId, eventId, success, failure) {
	      this.state.websocket.trigger('api.events.list_swapable_events', {
	        school_id: schoolId,
	        event_id: eventId
	      }, success, failure);
	    }
	  }, {
	    key: 'eventListReplaceable',
	    value: function eventListReplaceable(schoolId, eventId, success, failure) {
	      this.state.websocket.trigger('api.events.list_replaceable_events', {
	        school_id: schoolId,
	        event_id: eventId
	      }, success, failure);
	    }
	  }, {
	    key: 'hoursCountForCalendar',
	    value: function hoursCountForCalendar(schoolId, calendarId, start, end, success, failure) {
	      this.state.websocket.trigger('api.calendars.hours_count', {
	        school_id: schoolId,
	        calendar_id: calendarId,
	        start: start,
	        end: end
	      }, success, failure);
	    }
	  }, {
	    key: 'saveTaskOverview',
	    value: function saveTaskOverview(schoolId, schoolYearId, userId, title, success, failure) {
	      this.state.websocket.trigger('api.schools.task_overviews.create', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_id: userId,
	        title: title
	      }, success, failure);
	    }
	  }, {
	    key: 'bulkCreateTaskOverview',
	    value: function bulkCreateTaskOverview(schoolId, schoolYearId, userIds, title, success, failure) {
	      this.state.websocket.trigger('api.schools.task_overviews.bulk_create', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_ids: userIds,
	        title: title
	      }, success, failure);
	    }
	  }, {
	    key: 'readTaskOverviews',
	    value: function readTaskOverviews(schoolId, schoolYearId, userId, success, failure) {
	      this.state.websocket.trigger('api.schools.task_overviews.index', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteTaskOverview',
	    value: function deleteTaskOverview(schoolId, schoolYearId, userId, versionId, success, failure) {
	      this.state.websocket.trigger('api.schools.task_overviews.destroy', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_id: userId,
	        id: versionId
	      }, success, failure);
	    }
	  }, {
	    key: 'readAllTaskOverview',
	    value: function readAllTaskOverview(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.schools.task_overviews.latest_per_user', {
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'readAllTaskOverviewVersions',
	    value: function readAllTaskOverviewVersions(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.schools.task_overviews.index_all', {
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'bulkDeleteTaskOverviews',
	    value: function bulkDeleteTaskOverviews(schoolId, schoolYearId, userId, ids, success, failure) {
	      this.state.websocket.trigger('api.schools.task_overviews.destroy', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_id: userId,
	        ids: ids
	      }, success, failure);
	    }
	  }, {
	    key: 'createWorkedHoursStatement',
	    value: function createWorkedHoursStatement(schoolId, userId, fromDate, toDate, success, failure) {
	      this.state.websocket.trigger('api.schools.worked_hours_statements.create', {
	        school_id: schoolId,
	        user_id: userId,
	        from_date: fromDate,
	        to_date: toDate
	      }, success, failure);
	    }
	  }, {
	    key: 'listWorkedHoursStatements',
	    value: function listWorkedHoursStatements(schoolId, userId, success, failure) {
	      this.state.websocket.trigger('api.schools.worked_hours_statements.list', {
	        school_id: schoolId,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'readWorkedHoursStatements',
	    value: function readWorkedHoursStatements(schoolId, ids, success, failure) {
	      this.state.websocket.trigger('api.schools.worked_hours_statements.read', {
	        school_id: schoolId,
	        ids: ids
	      }, success, failure);
	    }
	  }, {
	    key: 'updateWorkedHoursStatement',
	    value: function updateWorkedHoursStatement(schoolId, id, attributes, success, failure) {
	      this.state.websocket.trigger('api.schools.worked_hours_statements.update', (0, _extends3.default)({
	        school_id: schoolId,
	        id: id
	      }, attributes), success, failure);
	    }
	  }, {
	    key: 'deleteWorkedHoursStatement',
	    value: function deleteWorkedHoursStatement(schoolId, id, success, failure) {
	      this.state.websocket.trigger('api.schools.worked_hours_statements.destroy', {
	        school_id: schoolId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'listSubjectRequests',
	    value: function listSubjectRequests(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.subject_requests.index', {
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'createSubjectRequest',
	    value: function createSubjectRequest(schoolId, schoolYearId, subjectId, success, failure) {
	      this.state.websocket.trigger('api.subject_requests.create', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        subject_id: subjectId
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteSubjectRequest',
	    value: function deleteSubjectRequest(schoolId, schoolYearId, id, success, failure) {
	      this.state.websocket.trigger('api.subject_requests.destroy', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'listSubjectReductions',
	    value: function listSubjectReductions(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.subject_reductions.index', {
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'refreshSubjectReductions',
	    value: function refreshSubjectReductions(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.subject_reductions.refresh', {
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'listSalarySupplements',
	    value: function listSalarySupplements(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.salary_supplements.index', {
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'createSalarySupplement',
	    value: function createSalarySupplement(schoolId, schoolYearId, userId, employmentId, yearNormHours, startDate, endDate, code, salaryCodeId, costCenterId, units, installments, unitsPerInstallment, success, failure) {
	      this.state.websocket.trigger('api.salary_supplements.create', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_id: userId,
	        employment_id: employmentId,
	        year_norm_hours: yearNormHours,
	        start_date: startDate,
	        end_date: endDate,
	        code: code,
	        salary_code_id: salaryCodeId,
	        cost_center_id: costCenterId,
	        units: units,
	        installments: installments,
	        units_per_installment: unitsPerInstallment
	      }, success, failure);
	    }
	  }, {
	    key: 'updateSalarySupplement',
	    value: function updateSalarySupplement(schoolId, schoolYearId, id, userId, employmentId, yearNormHours, startDate, endDate, code, salaryCodeId, costCenterId, units, installments, unitsPerInstallment, success, failure) {
	      this.state.websocket.trigger('api.salary_supplements.update', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        id: id,
	        user_id: userId,
	        employment_id: employmentId,
	        year_norm_hours: yearNormHours,
	        start_date: startDate,
	        end_date: endDate,
	        code: code,
	        salary_code_id: salaryCodeId,
	        cost_center_id: costCenterId,
	        units: units,
	        installments: installments,
	        units_per_installment: unitsPerInstallment
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteSalarySupplement',
	    value: function deleteSalarySupplement(schoolId, schoolYearId, id, success, failure) {
	      this.state.websocket.trigger('api.salary_supplements.delete', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'generateSalarySupplements',
	    value: function generateSalarySupplements(schoolId, schoolYearId, supplementType, success, failure) {
	      this.state.websocket.trigger('api.salary_supplements.generate', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        supplement_type: supplementType
	      }, success, failure);
	    }
	  }, {
	    key: 'approveSalarySupplements',
	    value: function approveSalarySupplements(schoolId, schoolYearId, ids, success, failure) {
	      this.state.websocket.trigger('api.salary_supplements.approve', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        ids: ids
	      }, success, failure);
	    }
	  }, {
	    key: 'listRequests',
	    value: function listRequests(schoolId, success, failure) {
	      this.state.websocket.trigger('api.requests.list', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'createRequest',
	    value: function createRequest(schoolId, subjectId, startTime, endTime, requestNote, success, failure) {
	      this.state.websocket.trigger('api.requests.create', {
	        school_id: schoolId,
	        subject_id: subjectId,
	        start_time: startTime,
	        end_time: endTime,
	        request_note: requestNote
	      }, success, failure);
	    }
	  }, {
	    key: 'updateRequest',
	    value: function updateRequest(schoolId, id, subjectId, startTime, endTime, requestNote, success, failure) {
	      this.state.websocket.trigger('api.requests.update', {
	        school_id: schoolId,
	        id: id,
	        subject_id: subjectId,
	        start_time: startTime,
	        end_time: endTime,
	        request_note: requestNote
	      }, success, failure);
	    }
	  }, {
	    key: 'approveRequest',
	    value: function approveRequest(schoolId, id, responseNote, subjectId, internalNote, employmentId, useTime, additionalData, ongoing, startTime, endTime, success, failure) {
	      this.state.websocket.trigger('api.requests.approve', {
	        school_id: schoolId,
	        id: id,
	        response_note: responseNote,
	        subject_id: subjectId,
	        internal_note: internalNote,
	        employment_id: employmentId,
	        use_time: useTime,
	        additional_data: additionalData,
	        ongoing: ongoing,
	        start_time: startTime,
	        end_time: endTime
	      }, success, failure);
	    }
	  }, {
	    key: 'rejectRequest',
	    value: function rejectRequest(schoolId, id, responseNote, success, failure) {
	      this.state.websocket.trigger('api.requests.reject', {
	        school_id: schoolId,
	        id: id,
	        response_note: responseNote
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteRequest',
	    value: function deleteRequest(schoolId, id, success, failure) {
	      this.state.websocket.trigger('api.requests.delete', {
	        school_id: schoolId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'trackEvent',
	    value: function trackEvent(schoolId, event, success, failure) {
	      this.state.websocket.trigger('api.track_events.track', {
	        school_id: schoolId,
	        event: event
	      }, success, failure);
	    }
	  }, {
	    key: 'getRecentUsers',
	    value: function getRecentUsers(id, limit, success, failure) {
	      this.state.websocket.trigger('api.schools.recent_users', { school: id, limit: limit }, success, failure);
	    }
	  }, {
	    key: 'createEmploymentTemplate',
	    value: function createEmploymentTemplate(schoolId, title, manualSalary, salaryCodeId, omkostningssted, hourLimit, hourLimitSalaryCodeId, specialHourLimitSalaryCodeId, enableEmploymentDecimal, success, failure) {
	      this.state.websocket.trigger('api.employment_templates.create', {
	        school_id: schoolId,
	        employment_template: {
	          title: title,
	          manual_salary: manualSalary,
	          salary_code_id: salaryCodeId,
	          omkostningssted: omkostningssted,
	          hour_limit: hourLimit,
	          hour_limit_salary_code_id: hourLimitSalaryCodeId,
	          special_hour_limit_salary_code_id: specialHourLimitSalaryCodeId,
	          enable_employment_decimal: enableEmploymentDecimal
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'employmentTemplatesForSchool',
	    value: function employmentTemplatesForSchool(schoolId, success, failure) {
	      this.state.websocket.trigger('api.employment_templates.read', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'updateEmploymentTemplate',
	    value: function updateEmploymentTemplate(schoolId, employmentTemplateId, title, manualSalary, salaryCodeId, omkostningssted, hourLimit, hourLimitSalaryCodeId, specialHourLimitSalaryCodeId, enableEmploymentDecimal, success, failure) {
	      this.state.websocket.trigger('api.employment_templates.update', {
	        school_id: schoolId,
	        id: employmentTemplateId,
	        employment_template: {
	          title: title,
	          manual_salary: manualSalary,
	          salary_code_id: salaryCodeId,
	          omkostningssted: omkostningssted,
	          hour_limit: hourLimit,
	          hour_limit_salary_code_id: hourLimitSalaryCodeId,
	          special_hour_limit_salary_code_id: specialHourLimitSalaryCodeId,
	          enable_employment_decimal: enableEmploymentDecimal
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteEmploymentTemplate',
	    value: function deleteEmploymentTemplate(schoolId, employmentTemplateId, success, failure) {
	      this.state.websocket.trigger('api.employment_templates.delete', {
	        school_id: schoolId,
	        id: employmentTemplateId
	      }, success, failure);
	    }
	  }, {
	    key: 'createSalaryCostCenter',
	    value: function createSalaryCostCenter(schoolId, name, code, success, failure) {
	      this.state.websocket.trigger('api.salary_cost_centers.create', {
	        school_id: schoolId,
	        name: name,
	        code: code
	      }, success, failure);
	    }
	  }, {
	    key: 'listSalaryCostCenter',
	    value: function listSalaryCostCenter(schoolId, success, failure) {
	      this.state.websocket.trigger('api.salary_cost_centers.index', {
	        school_id: schoolId,
	        include_archived: true
	      }, success, failure);
	    }
	  }, {
	    key: 'archiveSalaryCostCenter',
	    value: function archiveSalaryCostCenter(schoolId, id, success, failure) {
	      this.state.websocket.trigger('api.salary_cost_centers.archive', {
	        school_id: schoolId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'listSilkeborgDataFravaer',
	    value: function listSilkeborgDataFravaer(schoolId, startDate, endDate, success, failure) {
	      this.state.websocket.trigger('api.silkeborgdata_fravaer.index', {
	        school_id: schoolId,
	        start_date: startDate,
	        end_date: endDate
	      }, success, failure);
	    }
	  }, {
	    key: 'generateSilkeborgDataFravaer',
	    value: function generateSilkeborgDataFravaer(schoolId, startDate, endDate, success, failure) {
	      this.state.websocket.trigger('api.silkeborgdata_fravaer.generate_fravaer', {
	        school_id: schoolId,
	        start_date: startDate,
	        end_date: endDate
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteSilkeborgDataFravaer',
	    value: function deleteSilkeborgDataFravaer(schoolId, id, success, failure) {
	      this.state.websocket.trigger('api.silkeborgdata_fravaer.destroy', {
	        school_id: schoolId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'listSilkeborgDataEngangsydelser',
	    value: function listSilkeborgDataEngangsydelser(schoolId, sdType, success, failure) {
	      this.state.websocket.trigger('api.silkeborgdata_engangsydelser.index', {
	        school_id: schoolId,
	        sd_type: sdType
	      }, success, failure);
	    }
	  }, {
	    key: 'createSilkeborgDataEngangsydelse',
	    value: function createSilkeborgDataEngangsydelse(schoolId, engangsydelse, sdType, success, failure) {
	      this.state.websocket.trigger('api.silkeborgdata_engangsydelser.create', {
	        school_id: schoolId,
	        engangsydelse: engangsydelse,
	        sd_type: sdType
	      }, success, failure);
	    }
	  }, {
	    key: 'updateSilkeborgDataEngangsydelse',
	    value: function updateSilkeborgDataEngangsydelse(schoolId, id, engangsydelse, sdType, success, failure) {
	      this.state.websocket.trigger('api.silkeborgdata_engangsydelser.update', {
	        school_id: schoolId,
	        id: id,
	        engangsydelse: engangsydelse,
	        sd_type: sdType
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteSilkeborgDataEngangsydelse',
	    value: function deleteSilkeborgDataEngangsydelse(schoolId, id, sdType, success, failure) {
	      this.state.websocket.trigger('api.silkeborgdata_engangsydelser.destroy', {
	        school_id: schoolId,
	        id: id,
	        sd_type: sdType
	      }, success, failure);
	    }
	  }, {
	    key: 'bulkCreateSilkeborgDataEngangsydelser',
	    value: function bulkCreateSilkeborgDataEngangsydelser(schoolId, employmentIds, engangsydelse, sdType, success, failure) {
	      this.state.websocket.trigger('api.silkeborgdata_engangsydelser.bulk_create', {
	        school_id: schoolId,
	        employment_ids: employmentIds,
	        engangsydelse: engangsydelse,
	        sd_type: sdType
	      }, success, failure);
	    }
	  }, {
	    key: 'listSilkeborgDataLoenaendringer',
	    value: function listSilkeborgDataLoenaendringer(schoolId, success, failure) {
	      this.state.websocket.trigger('api.silkeborgdata_loenaendringer.index', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'createSilkeborgDataLoenaendring',
	    value: function createSilkeborgDataLoenaendring(schoolId, loenaendring, success, failure) {
	      this.state.websocket.trigger('api.silkeborgdata_loenaendringer.create', {
	        school_id: schoolId,
	        loenaendring: loenaendring
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteSilkeborgDataLoenaendring',
	    value: function deleteSilkeborgDataLoenaendring(schoolId, id, success, failure) {
	      this.state.websocket.trigger('api.silkeborgdata_loenaendringer.destroy', {
	        school_id: schoolId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'listSilkeborgDataTillaeg',
	    value: function listSilkeborgDataTillaeg(schoolId, success, failure) {
	      this.state.websocket.trigger('api.silkeborgdata_tillaeg.index', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'createSilkeborgDataTillaeg',
	    value: function createSilkeborgDataTillaeg(schoolId, tillaeg, success, failure) {
	      this.state.websocket.trigger('api.silkeborgdata_tillaeg.create', {
	        school_id: schoolId,
	        tillaeg: tillaeg
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteSilkeborgDataTillaeg',
	    value: function deleteSilkeborgDataTillaeg(schoolId, id, success, failure) {
	      this.state.websocket.trigger('api.silkeborgdata_tillaeg.destroy', {
	        school_id: schoolId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'bulkCreateSilkeborgDataTillaeg',
	    value: function bulkCreateSilkeborgDataTillaeg(schoolId, employmentIds, tillaeg, success, failure) {
	      this.state.websocket.trigger('api.silkeborgdata_tillaeg.bulk_create', {
	        school_id: schoolId,
	        employment_ids: employmentIds,
	        tillaeg: tillaeg
	      }, success, failure);
	    }
	  }, {
	    key: 'listSilkeborgDataAbsenceCodes',
	    value: function listSilkeborgDataAbsenceCodes(schoolId, success, failure) {
	      this.state.websocket.trigger('api.silkeborgdata_absence_codes.index', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'listKmdOpusAbsenceCodes',
	    value: function listKmdOpusAbsenceCodes(schoolId, success, failure) {
	      this.state.websocket.trigger('api.kmd_absence_codes.index', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'listAdditionalDataForAbsence',
	    value: function listAdditionalDataForAbsence(schoolId, employmentId, absenceCodeId, startDate, endDate, success, failure) {
	      this.state.websocket.trigger('api.kmd_absence.list_additional', {
	        school_id: schoolId,
	        employment_id: employmentId,
	        absence_code_id: absenceCodeId,
	        start_date: startDate,
	        end_date: endDate
	      }, success, failure);
	    }
	  }, {
	    key: 'listQuotas',
	    value: function listQuotas(schoolId, employmentIds, date, success, failure) {
	      this.state.websocket.trigger('api.kmd_absence.list_quotas', {
	        school_id: schoolId,
	        employment_ids: employmentIds,
	        date: date
	      }, success, failure);
	    }
	  }, {
	    key: 'listKmdOpusAbsence',
	    value: function listKmdOpusAbsence(schoolId, success, failure) {
	      this.state.websocket.trigger('api.kmd_absence.index', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'listKmdOpusAbsenceForEmployment',
	    value: function listKmdOpusAbsenceForEmployment(schoolId, employmentId, fromDate, toDate, success, failure) {
	      var data = {
	        school_id: schoolId,
	        employment_id: employmentId
	      };
	      if (fromDate) data.from_date = fromDate;
	      if (toDate) data.to_date = toDate;
	      this.state.websocket.trigger('api.kmd_absence.index', data, success, failure);
	    }
	  }, {
	    key: 'createKmdOpusAbsence',
	    value: function createKmdOpusAbsence(schoolId, employmentId, startDate, endDate, kmdAbsenceCodeId, success, failure) {
	      this.state.websocket.trigger('api.kmd_absence.create', {
	        school_id: schoolId,
	        absence: {
	          employment_id: employmentId,
	          start_date: startDate,
	          end_date: endDate,
	          kmd_absence_code_id: kmdAbsenceCodeId
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'listKmdEngangsydelser',
	    value: function listKmdEngangsydelser(schoolId, success, failure) {
	      this.state.websocket.trigger('api.kmd_engangsydelser.index', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'createKmdEngangsydelse',
	    value: function createKmdEngangsydelse(schoolId, employeeId, employmentId, engangsydelse, success, failure) {
	      this.state.websocket.trigger('api.kmd_engangsydelser.create', {
	        school_id: schoolId,
	        employee_id: employeeId,
	        employment_id: employmentId,
	        engangsydelse: engangsydelse
	      }, success, failure);
	    }
	  }, {
	    key: 'createKmdEngangsydelseForEmployees',
	    value: function createKmdEngangsydelseForEmployees(schoolId, employmentIds, engangsydelse, success, failure) {
	      this.state.websocket.trigger('api.kmd_engangsydelser.create_same_engangsydelse_on_multiple_employments', {
	        school_id: schoolId,
	        employment_ids: employmentIds,
	        engangsydelse: engangsydelse
	      }, success, failure);
	    }
	  }, {
	    key: 'createKmdEngangsydelserForEmployee',
	    value: function createKmdEngangsydelserForEmployee(schoolId, employmentId, engangsydelser, success, failure) {
	      this.state.websocket.trigger('api.kmd_engangsydelser.create_multiple_engangsydelser_on_same_employment', {
	        school_id: schoolId,
	        employment_id: employmentId,
	        engangsydelser: engangsydelser
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolCampsList',
	    value: function schoolCampsList(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.camps.index', {
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolCampsCreate',
	    value: function schoolCampsCreate(schoolId, schoolYearId, fromTime, toTime, title, calendarIds, existingHours, useAdditionalTasks, success, failure) {
	      this.state.websocket.trigger('api.camps.create', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        camp: {
	          title: title,
	          from_time: fromTime,
	          to_time: toTime,
	          calendar_ids: calendarIds,
	          existing_hours: existingHours,
	          use_additional_tasks: useAdditionalTasks
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolCampsUpdate',
	    value: function schoolCampsUpdate(schoolId, campId, schoolYearId, fromTime, toTime, title, calendarIds, existingHours, useAdditionalTasks, success, failure) {
	      this.state.websocket.trigger('api.camps.update', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        id: campId,
	        camp: {
	          title: title,
	          from_time: fromTime,
	          to_time: toTime,
	          calendar_ids: calendarIds,
	          existing_hours: existingHours,
	          use_additional_tasks: useAdditionalTasks
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolCampsDelete',
	    value: function schoolCampsDelete(schoolId, schoolYearId, campId, success, failure) {
	      this.state.websocket.trigger('api.camps.destroy', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        id: campId
	      }, success, failure);
	    }
	  }, {
	    key: 'listRecurringPayments',
	    value: function listRecurringPayments(schoolId, employmentId, success, failure) {
	      this.state.websocket.trigger('api.kmd_recurring_payments.read_recurring_payments', {
	        school_id: schoolId,
	        employment_id: employmentId
	      }, success, failure);
	    }
	  }, {
	    key: 'listRecurringPaymentsOutbox',
	    value: function listRecurringPaymentsOutbox(schoolId, employmentId, success, failure) {
	      var payload = { school_id: schoolId };
	      if (employmentId) {
	        payload.employment_id = employmentId;
	      }
	      this.state.websocket.trigger('api.kmd_recurring_payments.read_updates', payload, success, failure);
	    }
	  }, {
	    key: 'createRecurringPaymentForEmployees',
	    value: function createRecurringPaymentForEmployees(schoolId, employmentIds, recurringPayment, success, failure) {
	      this.state.websocket.trigger('api.kmd_recurring_payments.create_same_recurring_payment_on_multiple_employments', {
	        school_id: schoolId,
	        employment_ids: employmentIds,
	        recurring_payment: recurringPayment
	      }, success, failure);
	    }
	  }, {
	    key: 'createRecurringPaymentsForEmployee',
	    value: function createRecurringPaymentsForEmployee(schoolId, employmentId, recurringPayments, success, failure) {
	      this.state.websocket.trigger('api.kmd_recurring_payments.create_multiple_recurring_payments_on_same_employment', {
	        school_id: schoolId,
	        employment_id: employmentId,
	        recurring_payments: recurringPayments
	      }, success, failure);
	    }
	  }, {
	    key: 'delimitRecurringPayment',
	    value: function delimitRecurringPayment(schoolId, employmentId, objektId, startDate, stopDate, success, failure) {
	      this.state.websocket.trigger('api.kmd_recurring_payments.delimit', {
	        school_id: schoolId,
	        employment_id: employmentId,
	        objekt_id: objektId,
	        startdato: startDate,
	        stopdato: stopDate
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteRecurringPayment',
	    value: function deleteRecurringPayment(schoolId, employmentId, objektId, startDate, stopDate, success, failure) {
	      this.state.websocket.trigger('api.kmd_recurring_payments.delete', {
	        school_id: schoolId,
	        employment_id: employmentId,
	        objekt_id: objektId,
	        startdato: startDate,
	        stopdato: stopDate
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteFailedRecurringPayments',
	    value: function deleteFailedRecurringPayments(schoolId, recurringPaymentIds, success, failure) {
	      this.state.websocket.trigger('api.kmd_recurring_payments.delete_failed', {
	        school_id: schoolId,
	        recurring_payment_ids: recurringPaymentIds
	      }, success, failure);
	    }
	  }]);
	  return Docendo;
	}();
	
	var instance = new Docendo();
	instance.state = {};
	instance.state.reconnectTimeout = Math.floor(1000 + Math.random() * 2000);
	instance.state.retries = 1;
	instance.state.observersConnected = [];
	instance.state.observersDisconnected = [];
	instance.open();
	(0, _freeze2.default)(instance);
	exports.default = instance;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(41);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = new _vue2.default({
	  data: {
	    sideWideAnnouncement: false,
	    now: (0, _moment2.default)().utc(),
	    loadingEvents: false,
	    toast: {},
	    createModalOpen: false,
	    showOnboardingArrow: false,
	    showSetupWidget: false,
	    createUserModal: false,
	    createUserModalROR: false,
	    createKlassModal: false,
	    createRoomModal: false,
	    createMergeModal: false,
	    editCalendarNameModal: false,
	    editCalendarDeleteModal: false,
	    createdId: null,
	    isOpenYouTubePopup: false,
	    youTubeVideoId: '',
	    copyEventEvent: null,
	    copyEventsBulk: null,
	    isLessonNoteChangedWithoutSaving: false,
	    activeChangeRoleId: null,
	    calendars: [],
	    createCalendarsType: null,
	    isPrintCalendarsModal: false,
	    printCalendarType: null,
	    theKlassesToImportSubjectTo: []
	  }
	});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1132)
	
	/* script */
	__vue_exports__ = __webpack_require__(842)
	
	/* template */
	var __vue_template__ = __webpack_require__(1891)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4549b0c6"
	
	module.exports = __vue_exports__


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1040)
	
	/* script */
	__vue_exports__ = __webpack_require__(849)
	
	/* template */
	var __vue_template__ = __webpack_require__(1789)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1028)
	
	/* script */
	__vue_exports__ = __webpack_require__(840)
	
	/* template */
	var __vue_template__ = __webpack_require__(1777)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1251)
	
	/* script */
	__vue_exports__ = __webpack_require__(838)
	
	/* template */
	var __vue_template__ = __webpack_require__(2016)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7612b8c8"
	
	module.exports = __vue_exports__


/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1339)
	
	/* script */
	__vue_exports__ = __webpack_require__(547)
	
	/* template */
	var __vue_template__ = __webpack_require__(2106)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1366)
	
	/* script */
	__vue_exports__ = __webpack_require__(854)
	
	/* template */
	var __vue_template__ = __webpack_require__(2135)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d994f34a"
	
	module.exports = __vue_exports__


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1362)
	
	/* script */
	__vue_exports__ = __webpack_require__(858)
	
	/* template */
	var __vue_template__ = __webpack_require__(2131)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d433704e"
	
	module.exports = __vue_exports__


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1373)
	
	/* script */
	__vue_exports__ = __webpack_require__(688)
	
	/* template */
	var __vue_template__ = __webpack_require__(2143)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e014dd16"
	
	module.exports = __vue_exports__


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1293)
	
	/* script */
	__vue_exports__ = __webpack_require__(586)
	
	/* template */
	var __vue_template__ = __webpack_require__(2059)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-90089d60"
	
	module.exports = __vue_exports__


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1291)
	
	/* script */
	__vue_exports__ = __webpack_require__(535)
	
	/* template */
	var __vue_template__ = __webpack_require__(2056)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8ad5426c"
	
	module.exports = __vue_exports__


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1063)
	
	/* script */
	__vue_exports__ = __webpack_require__(856)
	
	/* template */
	var __vue_template__ = __webpack_require__(1814)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-26141f76"
	
	module.exports = __vue_exports__


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1278)
	
	/* script */
	__vue_exports__ = __webpack_require__(853)
	
	/* template */
	var __vue_template__ = __webpack_require__(2044)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8029c268"
	
	module.exports = __vue_exports__


/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1107)
	
	/* script */
	__vue_exports__ = __webpack_require__(802)
	
	/* template */
	var __vue_template__ = __webpack_require__(1866)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(539)
	
	/* template */
	var __vue_template__ = __webpack_require__(1850)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.parseNumericPreparationFactor = parseNumericPreparationFactor;
	exports.sameCalendarId = sameCalendarId;
	exports.clampDanishPreparationFactor = clampDanishPreparationFactor;
	exports.effectivePreparationFactor = effectivePreparationFactor;
	exports.getVHoursForSubject = getVHoursForSubject;
	exports.sumExplicitPrepTaskHoursForCalendar = sumExplicitPrepTaskHoursForCalendar;
	exports.computeWeightedPreparationHoursForCalendar = computeWeightedPreparationHoursForCalendar;
	exports.computePreparationHoursByCalendar = computePreparationHoursByCalendar;
	exports.computeWeightedPreparationFromTaskList = computeWeightedPreparationFromTaskList;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function parseNumericPreparationFactor(preparation) {
	  if (preparation === null || preparation === undefined || preparation === '') {
	    return null;
	  }
	  var n = typeof preparation === 'number' ? preparation : parseFloat(String(preparation).replace(',', '.'));
	  return isNaN(n) ? null : n;
	}
	
	function sameCalendarId(a, b) {
	  if (a === null || a === undefined || a === '' || b === null || b === undefined || b === '') {
	    return false;
	  }
	  var na = Number(a);
	  var nb = Number(b);
	  return !isNaN(na) && na === nb;
	}
	
	function clampDanishPreparationFactor(preparation) {
	  var parsed = parseNumericPreparationFactor(preparation);
	  if (parsed === null) {
	    return null;
	  }
	  if (parsed < -1) {
	    return -1;
	  }
	  if (parsed > 1) {
	    return 1;
	  }
	  return parsed;
	}
	
	function effectivePreparationFactor(entityPreparation, schoolPrepFactorNumeric) {
	  var parsedEntity = parseNumericPreparationFactor(entityPreparation);
	  if (parsedEntity !== null) {
	    return parsedEntity;
	  }
	  return schoolPrepFactorNumeric;
	}
	
	function getVHoursForSubject(subject, userCalId) {
	  if (!subject) return 0;
	
	  if (Array.isArray(subject.subject_calendars)) {
	    var userMatch = subject.subject_calendars.find(function (sc) {
	      return sameCalendarId(sc.calendar_id, userCalId) && sc.hours != null;
	    });
	    if (userMatch) {
	      var parsed = parseFloat(userMatch.hours);
	      return isNaN(parsed) ? 0 : parsed;
	    }
	  }
	
	  if (Array.isArray(subject.cals)) {
	    var klass = subject.cals.find(function (c) {
	      return c.calendar_type === 'klass';
	    });
	    if (klass && Array.isArray(subject.subject_calendars)) {
	      var klassMatch = subject.subject_calendars.find(function (sc) {
	        return sc.calendar_id === klass.id && sc.hours != null;
	      });
	      if (klassMatch) {
	        var _parsed = parseFloat(klassMatch.hours);
	        return isNaN(_parsed) ? 0 : _parsed;
	      }
	    }
	  }
	
	  var fallback = parseFloat(subject.hours);
	  return isNaN(fallback) ? 0 : fallback;
	}
	
	function getTeachingHoursForTask(task, calId, allUsersInCalIdHash) {
	  var userId = allUsersInCalIdHash[calId] ? allUsersInCalIdHash[calId].id : null;
	  if (!userId) {
	    return task.hours * 1;
	  }
	  var idx = task.teachers && task.teachers[0] ? task.teachers.findIndex(function (teacher) {
	    return teacher.user_id === userId;
	  }) : -1;
	  if (idx > -1) {
	    return task.teachers[idx].hours * 1;
	  }
	  return task.hours * 1;
	}
	
	function sumExplicitPrepTaskHoursForCalendar(calId, state, rootGetters) {
	  var allUsersInCalIdHash = rootGetters.allUsersInCalIdHash || {};
	  var total = 0;
	  state.tasks.forEach(function (task) {
	    if (task.subject_type === 'preparation' && Array.isArray(task.user_calendar_ids)) {
	      var factor = parseNumericPreparationFactor(task.preparation);
	      if (factor === null) {
	        return;
	      }
	      task.user_calendar_ids.forEach(function (ucalId) {
	        if (sameCalendarId(ucalId, calId)) {
	          var hours = getTeachingHoursForTask(task, calId, allUsersInCalIdHash);
	          total += hours * factor;
	        }
	      });
	    }
	  });
	  state.subjects.forEach(function (subject) {
	    if (subject.subject_type === 'preparation' && subject.task_overview !== false && Array.isArray(subject.cals)) {
	      var factor = parseNumericPreparationFactor(subject.preparation);
	      if (factor === null) {
	        return;
	      }
	      subject.cals.forEach(function (calendar) {
	        if (calendar.calendar_type === 'user' && sameCalendarId(calendar.id, calId)) {
	          var hours = getVHoursForSubject(subject, calId);
	          total += hours * factor;
	        }
	      });
	    }
	  });
	  return parseFloat(total.toFixed(2));
	}
	
	function computeWeightedPreparationHoursForCalendar(calId, state, rootGetters, rootState) {
	  var schoolSettings = rootState.schoolSettings || {};
	  var deactivatePools = schoolSettings.deactivatePools;
	  var schoolPrepRaw = schoolSettings.prepFactor;
	  var schoolPrepFactorNumeric = parseNumericPreparationFactor(schoolPrepRaw);
	
	  var locale = rootGetters.locale;
	  var schoolCountry = rootGetters.schoolCountry;
	
	  if (!deactivatePools || locale !== 'da' || String(schoolCountry).toLowerCase() !== 'dk') {
	    return null;
	  }
	  if (schoolPrepFactorNumeric === null) {
	    return null;
	  }
	
	  var allUsersInCalIdHash = rootGetters.allUsersInCalIdHash || {};
	
	  var total = 0;
	  var hasMatchingItems = false;
	
	  state.subjects.forEach(function (subject) {
	    if (subject.master_type === 'teaching' && subject.task_overview !== false && Array.isArray(subject.cals)) {
	      subject.cals.forEach(function (calendar) {
	        if (calendar.calendar_type === 'user' && sameCalendarId(calendar.id, calId)) {
	          hasMatchingItems = true;
	          var hours = getVHoursForSubject(subject, calId);
	          var factor = effectivePreparationFactor(subject.preparation, schoolPrepFactorNumeric);
	          total += hours * factor;
	        }
	      });
	    }
	  });
	
	  state.tasks.forEach(function (task) {
	    if (task.subject_type === 'preparation') {
	      return;
	    }
	    if (task.master_type === 'teaching' && Array.isArray(task.cals)) {
	      task.cals.forEach(function (calendar) {
	        if (calendar.calendar_type === 'user' && sameCalendarId(calendar.id, calId)) {
	          hasMatchingItems = true;
	          var hours = getTeachingHoursForTask(task, calId, allUsersInCalIdHash);
	          var factor = effectivePreparationFactor(task.preparation, schoolPrepFactorNumeric);
	          total += hours * factor;
	        }
	      });
	    }
	  });
	
	  total += sumExplicitPrepTaskHoursForCalendar(calId, state, rootGetters);
	
	  if (!hasMatchingItems && total === 0) {
	    return null;
	  }
	
	  return parseFloat(total.toFixed(2));
	}
	
	function calendarKey(calId) {
	  if (calId === null || calId === undefined || calId === '') {
	    return null;
	  }
	  var n = Number(calId);
	  return isNaN(n) ? null : n;
	}
	
	function addToKey(obj, key, value) {
	  obj[key] = (obj[key] || 0) + value;
	}
	
	function computePreparationHoursByCalendar(state, rootGetters, rootState) {
	  var allUsersInCalIdHash = rootGetters.allUsersInCalIdHash || {};
	  var explicitRaw = {};
	
	  state.tasks.forEach(function (task) {
	    if (task.subject_type === 'preparation' && Array.isArray(task.user_calendar_ids)) {
	      var factor = parseNumericPreparationFactor(task.preparation);
	      if (factor === null) {
	        return;
	      }
	      task.user_calendar_ids.forEach(function (ucalId) {
	        var key = calendarKey(ucalId);
	        if (key !== null) {
	          addToKey(explicitRaw, key, getTeachingHoursForTask(task, ucalId, allUsersInCalIdHash) * factor);
	        }
	      });
	    }
	  });
	  state.subjects.forEach(function (subject) {
	    if (subject.subject_type === 'preparation' && subject.task_overview !== false && Array.isArray(subject.cals)) {
	      var factor = parseNumericPreparationFactor(subject.preparation);
	      if (factor === null) {
	        return;
	      }
	      subject.cals.forEach(function (calendar) {
	        var key = calendarKey(calendar.id);
	        if (calendar.calendar_type === 'user' && key !== null) {
	          addToKey(explicitRaw, key, getVHoursForSubject(subject, calendar.id) * factor);
	        }
	      });
	    }
	  });
	
	  var explicit = {};
	  (0, _keys2.default)(explicitRaw).forEach(function (key) {
	    explicit[key] = parseFloat(explicitRaw[key].toFixed(2));
	  });
	
	  var schoolSettings = rootState.schoolSettings || {};
	  var schoolPrepFactorNumeric = parseNumericPreparationFactor(schoolSettings.prepFactor);
	  if (!schoolSettings.deactivatePools || rootGetters.locale !== 'da' || String(rootGetters.schoolCountry).toLowerCase() !== 'dk' || schoolPrepFactorNumeric === null) {
	    return { explicit: explicit, weighted: null };
	  }
	
	  var teachingRaw = {};
	  state.subjects.forEach(function (subject) {
	    if (subject.master_type === 'teaching' && subject.task_overview !== false && Array.isArray(subject.cals)) {
	      subject.cals.forEach(function (calendar) {
	        var key = calendarKey(calendar.id);
	        if (calendar.calendar_type === 'user' && key !== null) {
	          var factor = effectivePreparationFactor(subject.preparation, schoolPrepFactorNumeric);
	          addToKey(teachingRaw, key, getVHoursForSubject(subject, calendar.id) * factor);
	        }
	      });
	    }
	  });
	  state.tasks.forEach(function (task) {
	    if (task.subject_type === 'preparation') {
	      return;
	    }
	    if (task.master_type === 'teaching' && Array.isArray(task.cals)) {
	      task.cals.forEach(function (calendar) {
	        var key = calendarKey(calendar.id);
	        if (calendar.calendar_type === 'user' && key !== null) {
	          var factor = effectivePreparationFactor(task.preparation, schoolPrepFactorNumeric);
	          addToKey(teachingRaw, key, getTeachingHoursForTask(task, calendar.id, allUsersInCalIdHash) * factor);
	        }
	      });
	    }
	  });
	
	  var weighted = {};
	  (0, _keys2.default)(teachingRaw).forEach(function (key) {
	    weighted[key] = parseFloat((teachingRaw[key] + (explicit[key] || 0)).toFixed(2));
	  });
	  (0, _keys2.default)(explicit).forEach(function (key) {
	    if (!(key in weighted) && explicit[key] !== 0) {
	      weighted[key] = parseFloat(explicit[key].toFixed(2));
	    }
	  });
	  return { explicit: explicit, weighted: weighted };
	}
	
	function computeWeightedPreparationFromTaskList(tasks, schoolPrepFactorNumeric, options) {
	  var skipTeachingFactor = options && options.skipTeachingFactor;
	  if (!Array.isArray(tasks)) {
	    return 0;
	  }
	  var total = 0;
	  tasks.forEach(function (task) {
	    if (!task || task.substitute) {
	      return;
	    }
	    var isPrepType = task.subject_type === 'preparation' || task.master_type === 'preparation';
	    if (isPrepType) {
	      var factor = parseNumericPreparationFactor(task.preparation);
	      if (factor !== null) {
	        var hours = task.hours ? parseFloat(task.hours) : 0;
	        total += hours * factor;
	      }
	      return;
	    }
	    if (!skipTeachingFactor && task.master_type === 'teaching') {
	      var _hours = task.hours ? parseFloat(task.hours) : 0;
	      var _factor = effectivePreparationFactor(task.preparation, schoolPrepFactorNumeric);
	      if (_factor !== null) {
	        total += _hours * _factor;
	      }
	    }
	  });
	  return parseFloat(total.toFixed(2));
	}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1193)
	
	/* script */
	__vue_exports__ = __webpack_require__(787)
	
	/* template */
	var __vue_template__ = __webpack_require__(1953)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-609167cc"
	
	module.exports = __vue_exports__


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1290)
	
	/* script */
	__vue_exports__ = __webpack_require__(861)
	
	/* template */
	var __vue_template__ = __webpack_require__(2055)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8a18328c"
	
	module.exports = __vue_exports__


/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1279)
	
	/* script */
	__vue_exports__ = __webpack_require__(537)
	
	/* template */
	var __vue_template__ = __webpack_require__(2045)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8029cc62"
	
	module.exports = __vue_exports__


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1328)
	
	/* script */
	__vue_exports__ = __webpack_require__(627)
	
	/* template */
	var __vue_template__ = __webpack_require__(2095)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1364)
	
	/* script */
	__vue_exports__ = __webpack_require__(520)
	
	/* template */
	var __vue_template__ = __webpack_require__(2133)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d63297e4"
	
	module.exports = __vue_exports__


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1123)
	
	/* script */
	__vue_exports__ = __webpack_require__(811)
	
	/* template */
	var __vue_template__ = __webpack_require__(1883)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1398)
	
	/* script */
	__vue_exports__ = __webpack_require__(835)
	
	/* template */
	var __vue_template__ = __webpack_require__(2169)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1161)
	
	/* script */
	__vue_exports__ = __webpack_require__(728)
	
	/* template */
	var __vue_template__ = __webpack_require__(1920)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-53c96b37"
	
	module.exports = __vue_exports__


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var now = (0, _moment2.default)().utc();
	
	exports.default = {
	  showWeekends: true,
	  now: now
	};

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1386)
	
	/* script */
	__vue_exports__ = __webpack_require__(544)
	
	/* template */
	var __vue_template__ = __webpack_require__(2157)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f06f80e4"
	
	module.exports = __vue_exports__


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1395)
	
	/* script */
	__vue_exports__ = __webpack_require__(714)
	
	/* template */
	var __vue_template__ = __webpack_require__(2166)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f581df80"
	
	module.exports = __vue_exports__


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1145)
	
	/* script */
	__vue_exports__ = __webpack_require__(719)
	
	/* template */
	var __vue_template__ = __webpack_require__(1905)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4ab73c5c"
	
	module.exports = __vue_exports__


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1008)
	
	/* script */
	__vue_exports__ = __webpack_require__(721)
	
	/* template */
	var __vue_template__ = __webpack_require__(1757)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0c586aff"
	
	module.exports = __vue_exports__


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _freeze = __webpack_require__(86);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LESSON_CALENDAR_TYPES = ['klass', 'club'];
	
	exports.default = {
	  data: function data() {
	    return {
	      events: [],
	      isLoading: false,
	      startDate: null,
	      endDate: null,
	      reportEventTypeFilter: null,
	      readEventsRequestId: 0
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id * 1;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    schoolYear: function schoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    schoolYearStartDate: function schoolYearStartDate() {
	      return this.schoolYear ? this.schoolYear.student_time_start : null;
	    },
	    schoolYearEndDate: function schoolYearEndDate() {
	      return this.schoolYear ? this.schoolYear.student_time_end : null;
	    },
	    isDatesPristine: function isDatesPristine() {
	      return this.compareDates(this.schoolYearStartDate, this.startDate) && this.compareDates(this.schoolYearEndDate, this.endDate);
	    },
	    reportCalendars: function reportCalendars() {
	      return this.$store.getters.userCalendars || [];
	    },
	    eventsInRange: function eventsInRange() {
	      var startDate = (0, _moment2.default)(this.startDate).startOf('day');
	      var endDate = (0, _moment2.default)(this.endDate).endOf('day');
	      return this.events.filter(function (event) {
	        var start = (0, _moment2.default)(event.start);
	        return start.isSameOrAfter(startDate) && start.isSameOrBefore(endDate);
	      });
	    },
	    absenceEventsInRange: function absenceEventsInRange() {
	      return this.eventsInRange.filter(function (event) {
	        return event.event_type === 'absence';
	      });
	    },
	    lessonsInRange: function lessonsInRange() {
	      var _this = this;
	
	      return this.eventsInRange.filter(function (event) {
	        return event.event_type !== 'absence' && _this.getLessonKlasses(event).length > 0;
	      });
	    },
	    absenceEventsByCalId: function absenceEventsByCalId() {
	      var hash = {};
	      this.absenceEventsInRange.forEach(function (event) {
	        if (!hash[event.calendar_id]) {
	          hash[event.calendar_id] = [];
	        }
	        hash[event.calendar_id].push({
	          event: event,
	          startMs: (0, _moment2.default)(event.start).valueOf(),
	          endMs: (0, _moment2.default)(event.end).valueOf()
	        });
	      });
	      return hash;
	    },
	    affectedLessons: function affectedLessons() {
	      var _this2 = this;
	
	      var affected = [];
	      this.lessonsInRange.forEach(function (lesson) {
	        var startMs = (0, _moment2.default)(lesson.start).valueOf();
	        var endMs = (0, _moment2.default)(lesson.end).valueOf();
	        var teachers = _this2.getLessonTeachers(lesson);
	        var substitutes = _this2.getLessonSubstitutes(lesson);
	        var absentTeachers = [];
	        var absenceReasons = [];
	        teachers.forEach(function (teacher) {
	          var absences = (_this2.absenceEventsByCalId[teacher.calendar_id] || []).filter(function (absence) {
	            return absence.startMs < endMs && absence.endMs > startMs;
	          });
	          if (absences.length > 0) {
	            absentTeachers.push(teacher);
	            absences.forEach(function (absence) {
	              if (absenceReasons.indexOf(absence.event.title) < 0) {
	                absenceReasons.push(absence.event.title);
	              }
	            });
	          }
	        });
	        if (absentTeachers.length < 1 && substitutes.length < 1) {
	          return;
	        }
	        affected.push({
	          lesson: lesson,
	          minutes: _this2.getLessonMinutes(lesson),
	          klasses: _this2.getLessonKlasses(lesson),
	          teachers: teachers,
	          absentTeachers: absentTeachers,
	          substitutes: substitutes,
	          absenceReasons: absenceReasons,
	          hasCoTeacher: teachers.length > absentTeachers.length,
	          hasTeacherNotes: _this2.hasText(lesson.teacher_notes),
	          coverage: _this2.getCoverageCategory(lesson, absentTeachers, substitutes, teachers)
	        });
	      });
	      return affected;
	    }
	  },
	  watch: {
	    user: function user() {
	      this.$store.dispatch('readSchoolYears', this.schoolId);
	      this.$store.dispatch('getSchoolCalendars', this.schoolId);
	    },
	    reportCalendars: function reportCalendars() {
	      this.readEvents();
	    },
	    schoolYearEndDate: function schoolYearEndDate() {
	      this.setDates(this.schoolYearStartDate, this.schoolYearEndDate);
	    }
	  },
	  methods: {
	    resetDates: function resetDates() {
	      this.setDates(this.schoolYearStartDate, this.schoolYearEndDate);
	    },
	    setStartDate: function setStartDate(date) {
	      this.setDates(date, null);
	    },
	    setEndDate: function setEndDate(date) {
	      this.setDates(null, date);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.startDate = start;
	      }
	      if (end) {
	        this.endDate = end;
	      }
	    },
	    compareDates: function compareDates(firstDate, secondDate) {
	      return (0, _moment2.default)(firstDate).format('YYYY-MM-DD') === (0, _moment2.default)(secondDate).format('YYYY-MM-DD');
	    },
	    readEvents: function readEvents() {
	      var _this3 = this;
	
	      var calendarIds = this.reportCalendars.map(function (calendar) {
	        return calendar.id;
	      });
	      if (calendarIds.length < 1 || !this.schoolYearStartDate) {
	        return;
	      }
	      var requestId = ++this.readEventsRequestId;
	      this.isLoading = true;
	      this.fetchEvents(calendarIds, this.schoolYearStartDate, this.schoolYearEndDate, this.reportEventTypeFilter, function (events) {
	        if (requestId !== _this3.readEventsRequestId) {
	          return;
	        }
	        _this3.events = (0, _freeze2.default)(events);
	        _this3.isLoading = false;
	      });
	    },
	    fetchEvents: function fetchEvents(calendarIds, start, end, eventTypeFilter, callback) {
	      var _this4 = this;
	
	      _docendo2.default.calendarEvents2(calendarIds, start, end, eventTypeFilter, function (success) {
	        var events = success && success.length > 0 ? JSON.parse(success) : [];
	        var seen = {};
	        callback(events.filter(function (event) {
	          if (event.school_id !== _this4.schoolId || seen[event.event_id]) {
	            return false;
	          }
	          seen[event.event_id] = true;
	          return true;
	        }));
	      }, function (failure) {
	        console.log('failure', failure);
	        callback([]);
	      });
	    },
	    getLessonKlasses: function getLessonKlasses(lesson) {
	      return (lesson.calendars || []).filter(function (cal) {
	        return LESSON_CALENDAR_TYPES.indexOf(cal.calendar_type) > -1;
	      });
	    },
	    getLessonTeachers: function getLessonTeachers(lesson) {
	      return (lesson.calendars || []).filter(function (cal) {
	        return cal.calendar_type === 'user' && !cal.is_substitute && !cal.substitute;
	      });
	    },
	    getLessonSubstitutes: function getLessonSubstitutes(lesson) {
	      return (lesson.calendars || []).filter(function (cal) {
	        return cal.calendar_type === 'user' && (cal.is_substitute || cal.substitute);
	      });
	    },
	    getLessonMinutes: function getLessonMinutes(lesson) {
	      return (0, _moment2.default)(lesson.end).diff((0, _moment2.default)(lesson.start), 'minutes');
	    },
	    getCoverageCategory: function getCoverageCategory(lesson, absentTeachers, substitutes, teachers) {
	      if (lesson.canceled) {
	        return 'canceled';
	      }
	      if (lesson.away) {
	        return 'away';
	      }
	      if (substitutes.length > 0) {
	        return 'substitute';
	      }
	      if (teachers.length > absentTeachers.length) {
	        return 'coTeacher';
	      }
	      return 'uncovered';
	    },
	    getGradeName: function getGradeName(klassName) {
	      var name = (klassName || '').trim();
	      var digits = name.match(/^(\d+)/);
	      if (digits) {
	        return digits[1] * 1 + '. \xE5rgang';
	      }
	      if (/^(bh|0)/i.test(name)) {
	        return '0. årgang';
	      }
	      return 'Øvrige';
	    },
	    hasText: function hasText(html) {
	      return !!html && html.replace(/<[^>]*>?/gm, '').replace(/&nbsp;/g, ' ').trim().length > 0;
	    },
	    formatHours: function formatHours(minutes) {
	      return (minutes / 60).toFixed(1).replace('.', ',');
	    },
	    formatPercent: function formatPercent(part, total) {
	      if (!total) {
	        return '-';
	      }
	      return Math.round(part / total * 100) + ' %';
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUser');
	  },
	  mounted: function mounted() {
	    this.setDates(this.schoolYearStartDate, this.schoolYearEndDate);
	  }
	};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DK_PREPARATION_FACTOR_SUBJECT_TYPES = undefined;
	exports.isSubjectTypeWithDanishPreparationFactor = isSubjectTypeWithDanishPreparationFactor;
	exports.schoolHasDanishPreparationFactorConfigured = schoolHasDanishPreparationFactorConfigured;
	exports.isDanishPreparationBinaryPrepTaskSubjectType = isDanishPreparationBinaryPrepTaskSubjectType;
	exports.normalizeDanishPreparationForPrepTask = normalizeDanishPreparationForPrepTask;
	exports.preparationPayloadForSave = preparationPayloadForSave;
	exports.preparationFromApiForForm = preparationFromApiForForm;
	
	var _preparationFactor = __webpack_require__(42);
	
	var DK_PREPARATION_FACTOR_SUBJECT_TYPES = exports.DK_PREPARATION_FACTOR_SUBJECT_TYPES = ['subject', 'activity', 'person_resource', 'person_resource_visible', 'optional', 'supplemental', 'preparation'];
	
	function isSubjectTypeWithDanishPreparationFactor(subjectType) {
	  return DK_PREPARATION_FACTOR_SUBJECT_TYPES.indexOf(subjectType) > -1;
	}
	
	function schoolHasDanishPreparationFactorConfigured(schoolSettings) {
	  if (!schoolSettings) {
	    return false;
	  }
	  return (0, _preparationFactor.parseNumericPreparationFactor)(schoolSettings.prepFactor) !== null;
	}
	
	function isDanishPreparationBinaryPrepTaskSubjectType(subjectType) {
	  return subjectType === 'preparation';
	}
	
	function normalizeDanishPreparationForPrepTask(value) {
	  var n = (0, _preparationFactor.parseNumericPreparationFactor)(value);
	  if (n === 1) {
	    return 1;
	  }
	  return null;
	}
	
	function preparationPayloadForSave(value, isShowField, subjectType) {
	  if (!isShowField) {
	    return value;
	  }
	  if (isDanishPreparationBinaryPrepTaskSubjectType(subjectType)) {
	    return normalizeDanishPreparationForPrepTask(value);
	  }
	  return (0, _preparationFactor.clampDanishPreparationFactor)(value);
	}
	
	function preparationFromApiForForm(prep, isShowField, subjectType) {
	  if (prep == null) {
	    return null;
	  }
	  var n = prep * 1;
	  if (!isShowField) {
	    return n;
	  }
	  if (isDanishPreparationBinaryPrepTaskSubjectType(subjectType)) {
	    return normalizeDanishPreparationForPrepTask(n);
	  }
	  return (0, _preparationFactor.clampDanishPreparationFactor)(n);
	}

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1289)
	
	/* script */
	__vue_exports__ = __webpack_require__(516)
	
	/* template */
	var __vue_template__ = __webpack_require__(2054)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-894064e0"
	
	module.exports = __vue_exports__


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1257)
	
	/* script */
	__vue_exports__ = __webpack_require__(529)
	
	/* template */
	var __vue_template__ = __webpack_require__(2022)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1322)
	
	/* script */
	__vue_exports__ = __webpack_require__(592)
	
	/* template */
	var __vue_template__ = __webpack_require__(2089)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-aef65da6"
	
	module.exports = __vue_exports__


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1157)
	
	/* script */
	__vue_exports__ = __webpack_require__(744)
	
	/* template */
	var __vue_template__ = __webpack_require__(1916)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5166ab48"
	
	module.exports = __vue_exports__


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.schoolCanConfigureAssignedPoolNormWhenPoolsDeactivated = schoolCanConfigureAssignedPoolNormWhenPoolsDeactivated;
	exports.isAssignedPoolFromNormWhenPoolsDeactivated = isAssignedPoolFromNormWhenPoolsDeactivated;
	exports.effectiveAssignedPoolFromNormWhenPoolsDeactivated = effectiveAssignedPoolFromNormWhenPoolsDeactivated;
	exports.isPoolHoursEditableWhenPoolsDeactivated = isPoolHoursEditableWhenPoolsDeactivated;
	var SCHOOL_IDS_ASSIGNED_POOL_NORM_WHEN_POOLS_DEACTIVATED = exports.SCHOOL_IDS_ASSIGNED_POOL_NORM_WHEN_POOLS_DEACTIVATED = [63782, 62084];
	
	var ASSIGNED_POOL_FROM_NORM_SETTING_KEY = exports.ASSIGNED_POOL_FROM_NORM_SETTING_KEY = 'assignedPoolHoursFromNormWhenPoolsDeactivated';
	
	function schoolCanConfigureAssignedPoolNormWhenPoolsDeactivated(schoolId) {
	  if (schoolId == null) {
	    return false;
	  }
	  var id = Number(schoolId);
	  return SCHOOL_IDS_ASSIGNED_POOL_NORM_WHEN_POOLS_DEACTIVATED.indexOf(id) > -1;
	}
	
	function isAssignedPoolFromNormWhenPoolsDeactivated(schoolSettings) {
	  if (!schoolSettings || !schoolSettings.deactivatePools) {
	    return false;
	  }
	  return !!schoolSettings[ASSIGNED_POOL_FROM_NORM_SETTING_KEY];
	}
	
	function effectiveDeactivatePools(version, schoolSettings) {
	  var scd = version && version.overview && version.overview.school_custom_data;
	  if (scd && typeof scd.deactivatePools === 'boolean') {
	    return scd.deactivatePools;
	  }
	  return !!(schoolSettings && schoolSettings.deactivatePools);
	}
	
	function effectiveAssignedPoolFromNormWhenPoolsDeactivated(version, schoolSettings) {
	  if (!effectiveDeactivatePools(version, schoolSettings)) {
	    return false;
	  }
	  var scd = version && version.overview && version.overview.school_custom_data;
	  if (scd && typeof scd[ASSIGNED_POOL_FROM_NORM_SETTING_KEY] === 'boolean') {
	    return scd[ASSIGNED_POOL_FROM_NORM_SETTING_KEY];
	  }
	  return isAssignedPoolFromNormWhenPoolsDeactivated(schoolSettings);
	}
	
	function isPoolHoursEditableWhenPoolsDeactivated(type, schoolSettings) {
	  if (type === 'substitute_pool_hours') {
	    return true;
	  }
	  if (type === 'assigned_pool_hours' && isAssignedPoolFromNormWhenPoolsDeactivated(schoolSettings)) {
	    return true;
	  }
	  return false;
	}

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1175)
	
	/* script */
	__vue_exports__ = __webpack_require__(574)
	
	/* template */
	var __vue_template__ = __webpack_require__(1934)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-57d78ff0"
	
	module.exports = __vue_exports__


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1212)
	
	/* script */
	__vue_exports__ = __webpack_require__(596)
	
	/* template */
	var __vue_template__ = __webpack_require__(1972)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1197)
	
	/* script */
	__vue_exports__ = __webpack_require__(703)
	
	/* template */
	var __vue_template__ = __webpack_require__(1957)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1372)
	
	/* script */
	__vue_exports__ = __webpack_require__(717)
	
	/* template */
	var __vue_template__ = __webpack_require__(2141)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-dd80cc82"
	
	module.exports = __vue_exports__


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1104)
	
	/* script */
	__vue_exports__ = __webpack_require__(771)
	
	/* template */
	var __vue_template__ = __webpack_require__(1863)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-38bc317e"
	
	module.exports = __vue_exports__


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1093)
	
	/* script */
	__vue_exports__ = __webpack_require__(780)
	
	/* template */
	var __vue_template__ = __webpack_require__(1849)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-35454604"
	
	module.exports = __vue_exports__


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1122)
	
	/* script */
	__vue_exports__ = __webpack_require__(807)
	
	/* template */
	var __vue_template__ = __webpack_require__(1882)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-438256ad"
	
	module.exports = __vue_exports__


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1187)
	
	/* script */
	__vue_exports__ = __webpack_require__(837)
	
	/* template */
	var __vue_template__ = __webpack_require__(1947)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5d6c6e69"
	
	module.exports = __vue_exports__


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1169)
	
	/* script */
	__vue_exports__ = __webpack_require__(857)
	
	/* template */
	var __vue_template__ = __webpack_require__(1928)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(988)
	
	/* script */
	__vue_exports__ = __webpack_require__(862)
	
	/* template */
	var __vue_template__ = __webpack_require__(1737)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-052a48e9"
	
	module.exports = __vue_exports__


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(890)
	
	/* template */
	var __vue_template__ = __webpack_require__(1830)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 108 */,
/* 109 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EVENT_TYPE_ORDER = ['absence', 'frame', 'subject', 'optional', 'person_resource_visible', ['resource', 'person_resource'], 'supplemental', 'break', 'additional_tasks'];
	
	var EVENT_TYPE_PRIORITY = EVENT_TYPE_ORDER.reduce(function (acc, types, idx) {
	  ;[].concat(types).forEach(function (type) {
	    acc[type] = idx;
	  });
	  return acc;
	}, {});
	
	var getEventTypePriority = function getEventTypePriority(eventType) {
	  return eventType in EVENT_TYPE_PRIORITY ? EVENT_TYPE_PRIORITY[eventType] : EVENT_TYPE_ORDER.length;
	};
	
	var compareEventsByType = exports.compareEventsByType = function compareEventsByType(e1, e2) {
	  var diff = getEventTypePriority(e1.obj.event_type) - getEventTypePriority(e2.obj.event_type);
	  if (diff !== 0) return diff;
	  return (e1.obj.title || '').localeCompare(e2.obj.title || '', 'da');
	};

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hiddenAbsenceLabel = hiddenAbsenceLabel;
	exports.canSeeHiddenAbsenceTitles = canSeeHiddenAbsenceTitles;
	exports.isHiddenAbsenceTitle = isHiddenAbsenceTitle;
	exports.maskHiddenAbsenceTitlesInAvailability = maskHiddenAbsenceTitlesInAvailability;
	
	
	var HIDDEN_ABSENCE_LABELS = {
	  da: 'Fravær',
	  nb: 'Fravær',
	  en: 'Absence'
	};
	
	function hiddenAbsenceLabel(locale) {
	  var lang = typeof locale === 'string' ? locale.slice(0, 2).toLowerCase() : 'da';
	  return HIDDEN_ABSENCE_LABELS[lang] || HIDDEN_ABSENCE_LABELS.da;
	}
	
	function canSeeHiddenAbsenceTitles(store, schoolId) {
	  var user = store && store.state ? store.state.user : null;
	  if (!user) {
	    return false;
	  }
	  if (user.admin) {
	    return true;
	  }
	  var getters = store.getters || {};
	  if (getters.isPermissionsActivatedForSchool === false) {
	    return true;
	  }
	  var memberships = user.memberships || [];
	  var membership = memberships.find(function (m) {
	    return m && m.school_id * 1 === schoolId * 1;
	  });
	  var permissions = membership ? membership.permissions : getters.userPermissions;
	  return Array.isArray(permissions) && permissions.indexOf('can_manage_school') > -1;
	}
	
	function isHiddenAbsenceTitle(event, canSeeAll, isOwn) {
	  if (!event || event.event_type !== 'absence') {
	    return false;
	  }
	  if (canSeeAll || isOwn) {
	    return false;
	  }
	  return event.private !== false;
	}
	
	function isOwnCalendarRow(row, user) {
	  if (!row || !user) {
	    return false;
	  }
	  if (user.user_calendar_id && row.calendar_id === user.user_calendar_id) {
	    return true;
	  }
	  return !!(user.id && row.user_id && row.user_id === user.id);
	}
	
	function maskHiddenAbsenceTitlesInAvailability(rows, store, schoolId) {
	  if (!Array.isArray(rows) || canSeeHiddenAbsenceTitles(store, schoolId)) {
	    return rows;
	  }
	  var user = store && store.state ? store.state.user : null;
	  var label = hiddenAbsenceLabel(store && store.getters ? store.getters.locale : null);
	  rows.forEach(function (row) {
	    var isOwn = isOwnCalendarRow(row, user);
	    var events = row && Array.isArray(row.events) ? row.events : [];
	    events.forEach(function (event) {
	      if (isHiddenAbsenceTitle(event, false, isOwn)) {
	        event.title = label;
	      }
	    });
	  });
	  return rows;
	}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDifferentiatedPools = getDifferentiatedPools;
	exports.hasDifferentiatedPool = hasDifferentiatedPool;
	exports.shouldConfirmPoolsUpdate = shouldConfirmPoolsUpdate;
	function getDifferentiatedPools(subject, targetHours) {
	  if (!subject || !Array.isArray(subject.subject_calendars)) {
	    return [];
	  }
	  var target = parseFloat(targetHours);
	  var compareToTarget = targetHours !== undefined && !isNaN(target);
	  return subject.subject_calendars.filter(function (sc) {
	    if (!sc || sc.hours === null || sc.hours === undefined) return false;
	    if (!compareToTarget) return true;
	    return parseFloat(sc.hours) !== target;
	  }).map(function (sc) {
	    return {
	      calendarId: sc.calendar_id,
	      hours: sc.hours
	    };
	  });
	}
	
	function hasDifferentiatedPool(subject, targetHours) {
	  return getDifferentiatedPools(subject, targetHours).length > 0;
	}
	
	function toHoursNumber(value) {
	  if (value === null || value === undefined || value === '') return null;
	  var n = parseFloat(String(value).replace(',', '.'));
	  return isNaN(n) ? null : n;
	}
	
	function shouldConfirmPoolsUpdate(subject, targetHours) {
	  if (!subject) return false;
	  if (toHoursNumber(subject.hours) === toHoursNumber(targetHours)) return false;
	  return hasDifferentiatedPool(subject, targetHours);
	}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isSubstitute = isSubstitute;
	exports.eventMatchesFilter = eventMatchesFilter;
	exports.filterUserEvents = filterUserEvents;
	function isSubstitute(event, userId) {
	  return (event && event.substitutes || []).some(function (sub) {
	    return sub && Number(sub.id) === Number(userId);
	  });
	}
	
	function eventMatchesFilter(event, eventsFilter, userId) {
	  switch (eventsFilter) {
	    case null:
	      return event.event_type !== '';
	    case 'subject':
	      return event.event_type !== 'absence' && event.event_type !== 'other_tasks' && event.event_type !== 'other_stuff' && !isSubstitute(event, userId);
	    case 'substituteHours':
	      return isSubstitute(event, userId);
	    case 'absence':
	      return event.event_type === 'absence';
	  }
	}
	
	function filterUserEvents(events, eventsFilter, userId) {
	  return (events || []).filter(function (event) {
	    return eventMatchesFilter(event, eventsFilter, userId);
	  });
	}

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(56);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(57);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Event = function () {
	  function Event(data, success_callback, failure_callback) {
	    (0, _classCallCheck3.default)(this, Event);
	
	    this.success_callback = success_callback;
	    this.failure_callback = failure_callback;
	    this.name = data[0];
	    var attr = data[1];
	
	    if (attr) {
	      this.id = attr.id ? attr.id : (1 + Math.random()) * 0x10000 | 0;
	      this.channel = attr.channel ? attr.channel : undefined;
	      this.data = attr.data ? attr.data : attr;
	      this.token = attr.token ? attr.token : undefined;
	      this.connection_id = data[2];
	      if (attr.success) {
	        this.result = true;
	        this.success = attr.success;
	      } else {
	        this.result = false;
	        this.success = attr.success;
	      }
	    }
	  }
	
	  (0, _createClass3.default)(Event, [{
	    key: 'is_channel',
	    value: function is_channel() {
	      return !!this.channel;
	    }
	  }, {
	    key: 'is_result',
	    value: function is_result() {
	      return this.result;
	    }
	  }, {
	    key: 'is_ping',
	    value: function is_ping() {
	      return this.name === 'websocket_rails.ping';
	    }
	  }, {
	    key: 'serialize',
	    value: function serialize() {
	      return (0, _stringify2.default)([this.name, this.attributes()]);
	    }
	  }, {
	    key: 'attributes',
	    value: function attributes() {
	      return {
	        id: this.id,
	        channel: this.channel,
	        data: this.data,
	        token: this.token
	      };
	    }
	  }, {
	    key: 'run_callbacks',
	    value: function run_callbacks(success, result) {
	      this.success = success;
	      this.result = result;
	      if (this.success) {
	        return typeof this.success_callback === 'function' ? this.success_callback(this.result) : undefined;
	      }
	      return typeof this.failure_callback === 'function' ? this.failure_callback(this.result) : undefined;
	    }
	  }]);
	  return Event;
	}();
	
	exports.default = Event;

/***/ }),
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1377)
	
	/* script */
	__vue_exports__ = __webpack_require__(474)
	
	/* template */
	var __vue_template__ = __webpack_require__(2147)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e2b81218"
	
	module.exports = __vue_exports__


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1032)
	
	/* script */
	__vue_exports__ = __webpack_require__(546)
	
	/* template */
	var __vue_template__ = __webpack_require__(1781)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1240)
	
	/* script */
	__vue_exports__ = __webpack_require__(565)
	
	/* template */
	var __vue_template__ = __webpack_require__(2005)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1358)
	
	/* script */
	__vue_exports__ = __webpack_require__(583)
	
	/* template */
	var __vue_template__ = __webpack_require__(2127)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-cd76fcaa"
	
	module.exports = __vue_exports__


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1058)
	
	/* script */
	__vue_exports__ = __webpack_require__(610)
	
	/* template */
	var __vue_template__ = __webpack_require__(1809)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-251e5067"
	
	module.exports = __vue_exports__


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1081)
	
	/* script */
	__vue_exports__ = __webpack_require__(635)
	
	/* template */
	var __vue_template__ = __webpack_require__(1836)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2e471144"
	
	module.exports = __vue_exports__


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1117)
	
	/* script */
	__vue_exports__ = __webpack_require__(650)
	
	/* template */
	var __vue_template__ = __webpack_require__(1877)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-41a5a808"
	
	module.exports = __vue_exports__


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1344)
	
	/* script */
	__vue_exports__ = __webpack_require__(653)
	
	/* template */
	var __vue_template__ = __webpack_require__(2111)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-bccd80f6"
	
	module.exports = __vue_exports__


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1110)
	
	/* script */
	__vue_exports__ = __webpack_require__(659)
	
	/* template */
	var __vue_template__ = __webpack_require__(1869)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3bbe5ff6"
	
	module.exports = __vue_exports__


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1064)
	
	/* script */
	__vue_exports__ = __webpack_require__(667)
	
	/* template */
	var __vue_template__ = __webpack_require__(1815)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2671dc56"
	
	module.exports = __vue_exports__


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1216)
	
	/* script */
	__vue_exports__ = __webpack_require__(673)
	
	/* template */
	var __vue_template__ = __webpack_require__(1977)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-68922777"
	
	module.exports = __vue_exports__


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1244)
	
	/* script */
	__vue_exports__ = __webpack_require__(677)
	
	/* template */
	var __vue_template__ = __webpack_require__(2009)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-73b98f7c"
	
	module.exports = __vue_exports__


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(979)
	
	/* script */
	__vue_exports__ = __webpack_require__(716)
	
	/* template */
	var __vue_template__ = __webpack_require__(1727)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0083e5ba"
	
	module.exports = __vue_exports__


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1317)
	
	/* script */
	__vue_exports__ = __webpack_require__(739)
	
	/* template */
	var __vue_template__ = __webpack_require__(2084)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a9a6245c"
	
	module.exports = __vue_exports__


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1392)
	
	/* script */
	__vue_exports__ = __webpack_require__(806)
	
	/* template */
	var __vue_template__ = __webpack_require__(2163)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1073)
	
	/* script */
	__vue_exports__ = __webpack_require__(817)
	
	/* template */
	var __vue_template__ = __webpack_require__(1826)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2aec7768"
	
	module.exports = __vue_exports__


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(987)
	
	/* script */
	__vue_exports__ = __webpack_require__(819)
	
	/* template */
	var __vue_template__ = __webpack_require__(1736)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-04134a49"
	
	module.exports = __vue_exports__


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1182)
	
	/* script */
	__vue_exports__ = __webpack_require__(820)
	
	/* template */
	var __vue_template__ = __webpack_require__(1941)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-59b2419b"
	
	module.exports = __vue_exports__


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1134)
	
	/* script */
	__vue_exports__ = __webpack_require__(823)
	
	/* template */
	var __vue_template__ = __webpack_require__(1893)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-47649dd9"
	
	module.exports = __vue_exports__


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1376)
	
	/* script */
	__vue_exports__ = __webpack_require__(825)
	
	/* template */
	var __vue_template__ = __webpack_require__(2146)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1049)
	
	/* script */
	__vue_exports__ = __webpack_require__(826)
	
	/* template */
	var __vue_template__ = __webpack_require__(1799)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2195af68"
	
	module.exports = __vue_exports__


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(993)
	
	/* template */
	var __vue_template__ = __webpack_require__(1742)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-06917bc4"
	
	module.exports = __vue_exports__


/***/ }),
/* 155 */,
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.formatPhone = formatPhone;
	exports.normalizePhone = normalizePhone;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COUNTRY_CODES = { DK: '45', NO: '47', SE: '46' };
	
	function formatPhone(phone) {
	  if (!phone) {
	    return '';
	  }
	  var digits = String(phone).replace(/\D/g, '');
	  var code = (0, _keys2.default)(COUNTRY_CODES).map(function (key) {
	    return COUNTRY_CODES[key];
	  }).find(function (prefix) {
	    return digits.indexOf(prefix) === 0 && digits.length === prefix.length + 8;
	  });
	  if (!code) {
	    return phone;
	  }
	  var local = digits.slice(code.length);
	  return '+' + code + ' ' + local.replace(/(\d{2})(?=\d)/g, '$1 ');
	}
	
	function normalizePhone(value, country) {
	  if (!value || !String(value).trim()) {
	    return null;
	  }
	  var digits = String(value).replace(/\D/g, '');
	  var code = COUNTRY_CODES[(country || '').toUpperCase()];
	  if (code && digits.length === 8) {
	    return code + digits;
	  }
	  return digits;
	}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.kindergartenTypes = exports.allTypes = undefined;
	
	var _subject = __webpack_require__(1419);
	
	var _subject2 = _interopRequireDefault(_subject);
	
	var _optional = __webpack_require__(1418);
	
	var _optional2 = _interopRequireDefault(_optional);
	
	var _frame = __webpack_require__(1417);
	
	var _frame2 = _interopRequireDefault(_frame);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var allTypes = exports.allTypes = {
	  'subject': [{
	    lang: 'da',
	    name: 'Fag <span class="do-bagde-break">UV-tid</span>',
	    value: 'subject',
	    order: 1,
	    desc: 'Tæller UV-tid. To samtidige brikker tæller halvt.'
	  }, {
	    lang: 'en',
	    name: 'Subject',
	    value: 'subject',
	    order: 1,
	    desc: 'Counting hours for the class. Two simultaneous activities count as halves.'
	  }, {
	    lang: 'nb',
	    name: 'Fag',
	    value: 'subject',
	    order: 1,
	    desc: '<div style="width: 400px"><p class="marg-1-bottom marg-05-top">Fag: Standard for undervisningstimer. Legges to eller flere fag i samme tidsrom fordeles tiden likt mellom fagene.</p><img style="width: 80%;" src="' + _subject2.default + '" /><p style="font-style: italic;margin-top: 0.5rem;font-weight: normal">Eksempel: to 60 minutters undervisningstimer i Norsk og Matematikk i samme tidsrom i en klasse telles som 30 minutter norsk og 30 min matematikk.</p></div>'
	  }],
	  'optional': [{
	    lang: 'da',
	    name: 'Valgfag/Hold <span class="do-bagde-break">UV-tid</span>',
	    value: 'optional',
	    order: 2,
	    desc: 'Tæller UV-tid. Tæller 100%, uafhængigt af andre brikker i samme tidsrum i klassen.'
	  }, {
	    lang: 'en',
	    name: 'Optional grades/groups',
	    value: 'optional',
	    order: 2,
	    desc: 'Fully counting and independent from other activities in the same time period.'
	  }, {
	    lang: 'nb',
	    name: 'Valgfag/gruppe',
	    value: 'optional',
	    order: 2,
	    desc: '<div style="width: 400px"><p class="marg-1-bottom marg-05-top">Valgfag/gruppe: Undervisningstimer som ikke teller fra andre fag. Er særlig nyttig for valgfag og tilvalgsfag. </p><img style="width: 80%;" src="' + _optional2.default + '" /><p style="font-style: italic;margin-top: 0.5rem;font-weight: normal">Eksempel: to 60 minutters undervisningstimer i Spansk og Fransk i samme tidsrom telles som 60 min Spansk og 60 min Fransk.</p></div>'
	  }],
	  'supplemental': [{
	    lang: 'da',
	    name: 'UUV <span class="do-bagde-break">UV-tid</span>',
	    value: 'supplemental',
	    desc: 'Tæller UV-tid. Og selvstændigt på understøttende undervisning.',
	    order: 6
	  }, {
	    lang: 'en',
	    name: 'UUV',
	    value: 'supplemental',
	    desc: 'Tæller selvstændigt på understøttende undervisning.',
	    order: 6
	  }, {
	    lang: 'nb',
	    name: 'UUV',
	    value: 'supplemental',
	    desc: 'Tæller selvstændigt på understøttende undervisning.',
	    order: 6
	  }],
	  'frame': [{
	    lang: 'da',
	    name: 'Temavisning',
	    value: 'frame',
	    order: 3,
	    desc: 'Tæller ikke noget selv, men fagbrikker i samme tidsrum tæller 100%. Temavisning kan bruges til at markere temaer og anderledes dage i skemaet. Brikken er synlig, mens fag-brikker, der ligger samtidig med tema-brikken skjules for elever/forældre. '
	  }, {
	    lang: 'en',
	    name: 'Theme',
	    value: 'frame',
	    order: 3,
	    desc: 'Can be used for marking themes and special days in the class schedule. The themed activity is visible for the pupils and parents, while classes that are overlapping the themed activity will not be visible. Classes are fully counting, and the themed activity is not.'
	  }, {
	    lang: 'nb',
	    name: 'Temavisning',
	    value: 'frame',
	    order: 3,
	    desc: '<div style="width: 400px"><p class="marg-1-bottom marg-05-top">Temavisning (ramme): Brukes til å markere temaer eller spesielle dager/fag i timeplanen. Timer lagt inn med denne fagtype er synlig for elever/foresatte, og kan med fordel legges i samme tidsrom som andre fag, og vil da skjule disse for elever/foresatte. Temavisning telles ikke som undervisningstimer, det gjør derimot fagene som er lagt i samme tidsrom.</p><img style="width: 80%;" src="' + _frame2.default + '" /><p style="font-style: italic;margin-top: 0.5rem;font-weight: normal">Eksempel: \'Idrettsdag’\' opprettes som Temavisning, og legges over fagene som normalt ligger i timeplanen. Lærere ser alle timene, mens elever/foresatte ser ‘Idrettsdag’ i timeplanen. Kan også brukes på samme måte for å markere tilvalgsfag eller valgfag for elever. Legger man en temavisning over for eksempel fire tilvalgsfag, vil dette gi en forenklet visning til elevene.</p></div>'
	  }],
	  'break': [{
	    lang: 'da',
	    name: 'Pause <span class="do-bagde-break">UV-tid</span>',
	    value: 'break',
	    desc: 'Tæller UV-tid. Andre lektioner bør ikke overlappe med en pause.',
	    order: 7
	  }, { lang: 'en', name: 'Break', value: 'break', desc: 'Subjects should not overlap with breaks.', order: 7 }, { lang: 'nb', name: 'Pause', value: 'break', desc: 'Andre timer bør ikke overlapper med en pause.', order: 7 }],
	  'resource': [{
	    lang: 'da',
	    name: 'Ressource (skjult) <span class="do-bagde-break">UV-tid</span>',
	    value: 'resource',
	    order: 4,
	    desc: 'Tæller UV-tid for underviseren. Tæller ikke ned fra andre fag samtidig i klassen. Vises ikke i elev- og forældre visning.'
	  }, {
	    lang: 'en',
	    name: 'Resource (hidden)',
	    value: 'resource',
	    order: 4,
	    desc: 'Can be used to register teaching resources. Is not visible to students/parents.'
	  }, {
	    lang: 'nb',
	    name: 'Ressurs (skjult)',
	    value: 'resource',
	    order: 4,
	    desc: '<p style="width: 300px">Ressurs: Brukes til å markere ekstra ressurser i timeplanen. Teller ikke fra andre fag, og er særlig nyttig til å legge inn at det er en ekstra assistent (ressurs) til stede i klassen, f.eks.i form av SNO eller Barneveileder. Undervisningsfaget i samme tidsrom telles 100%, samme med ressursen. Faget er ikke synlig for elever/foresatte.</p>'
	  }],
	  'person_resource': [{
	    lang: 'da',
	    name: 'Ressource (skjult) <span class="do-bagde-break">UV-tid</span>',
	    value: 'person_resource',
	    order: 4,
	    desc: 'Tæller UV-tid for underviseren. Tæller ikke ned fra andre fag samtidig i klassen. Vises ikke i elev- og forældre visning.'
	  }, {
	    lang: 'en',
	    name: 'Resource (hidden)',
	    value: 'person_resource',
	    order: 4,
	    desc: 'Can be used to register teaching resources. Is not visible to students/parents.'
	  }, {
	    lang: 'nb',
	    name: 'Ressurs (skjult)',
	    value: 'person_resource',
	    order: 4,
	    desc: '<p style="width: 300px">Ressurs: Brukes til å markere ekstra ressurser i timeplanen. Teller ikke fra andre fag, og er særlig nyttig til å legge inn at det er en ekstra assistent (ressurs) til stede i klassen, f.eks.i form av SNO eller Barneveileder. Undervisningsfaget i samme tidsrom telles 100%, samme med ressursen. Faget er ikke synlig for elever/foresatte.</p>'
	  }],
	  'other_tasks': [{
	    lang: 'da',
	    name: 'Anden tid <span class="pill pill--grey hint--top-right hint--medium" aria-label="Udfases fra skoleåret 21/22 pga. den nye arbejdstidsaftale (A20)">udfases</span>',
	    value: 'other_tasks',
	    desc: 'Ikke undervisning',
	    order: 13
	  }, { lang: 'en', name: 'Other tasks', value: 'other_tasks', desc: 'Not teaching', order: 13 }, { lang: 'nb', name: 'Annen tid', value: 'other_tasks', desc: 'Ikke undervisning', order: 13 }],
	  'other_stuff': [{
	    lang: 'da',
	    name: 'Øvrig tid <span class="pill pill--grey hint--top-right hint--medium" aria-label="Udfases fra skoleåret 21/22 pga. den nye arbejdstidsaftale (A20)">udfases</span>',
	    value: 'other_stuff',
	    desc: 'Ikke undervisning, ikke elev-relateret.',
	    order: 12
	  }, {
	    lang: 'en',
	    name: 'Additional tasks',
	    value: 'other_stuff',
	    desc: 'Not classes and teaching, non-pupil related.',
	    order: 12
	  }, {
	    lang: 'nb',
	    name: 'Øvrig tid',
	    value: 'other_stuff',
	    desc: 'Ikke undervisning, ikke elevrelatert.',
	    order: 12
	  }],
	  'available': [{
	    lang: 'da',
	    name: 'Rådighedstime',
	    value: 'available',
	    desc: 'Brug til at vise, hvornår en underviser kan tage en vikartime',
	    order: 11
	  }, {
	    lang: 'nb',
	    name: 'Rådighetstime',
	    value: 'available',
	    desc: ' Brukes til å vise når en underviser kan ta en vikartime',
	    order: 11
	  }, {
	    lang: 'en',
	    name: 'On-Call',
	    value: 'available',
	    desc: 'The \'On-Call\' event indicates a timeslot when a teacher is available and ready to take over a course as a substitute. These events can be prioritized within the Substitute Management module, ensuring that available teachers can be quickly identified and assigned to cover classes as needed.',
	    order: 11
	  }],
	  'person_resource_visible': [{
	    lang: 'da',
	    name: 'Ressource (synlig) <span class="do-bagde-break">UV-tid</span>',
	    value: 'person_resource_visible',
	    order: 5,
	    desc: 'Tæller UV-tid for underviseren. Tæller ikke ned fra andre fag samtidig i klassen. Vises i elev- og forældre visning.'
	  }, {
	    lang: 'en',
	    name: 'Resource (Visible)',
	    value: 'person_resource_visible',
	    order: 5,
	    desc: 'Can be used to register teaching resources. Visible to students/parents.'
	  }, {
	    lang: 'nb',
	    name: 'Ressurs (Vises for elever)',
	    value: 'person_resource_visible',
	    order: 5,
	    desc: '<p style="width: 400px">Ressurs (vises for elever): Brukes til å markere ekstra ressurser i timeplanen. Teller ikke fra andre fag, og er synlig for elever/foresatte. Som fagtypen Ressurs, er denne også nyttig til å vise at det er ekstra personale til stede, f.eks en Miljøveileder, som også skal være synlig for elever/foresatte i timeplanen.</p>'
	  }],
	  'club': [{ lang: 'da', name: 'SFO tid', value: 'club', desc: 'Pædagogisk tid i SFO, FFO, DUS eller lignende', order: 8 }, { lang: 'en', name: 'SFO time', value: 'club', desc: 'Pedagogical time', order: 8 }, { lang: 'nb', name: 'SFO tid', value: 'club', desc: 'Pedagogisk tid', order: 8 }],
	  'additional_tasks': [{
	    lang: 'da',
	    name: 'Øvrige opgaver',
	    value: 'additional_tasks',
	    desc: 'Tæller som Øvrige Opgaver. Ikke undervisning',
	    order: 9
	  }, { lang: 'en', name: 'Not teaching', value: 'additional_tasks', desc: 'Not teaching', order: 9 }, { lang: 'nb', name: 'Øvrige oppgaver', value: 'additional_tasks', desc: 'Tæller som øvrige opgaver.', order: 9 }],
	  'preparation': [{
	    lang: 'da',
	    name: 'Forberedelse',
	    value: 'preparation',
	    desc: 'Kan bruges til individuel eller fælles forberedelse (f.eks. teammøder m.m)',
	    order: 10
	  }, {
	    lang: 'en',
	    name: 'Preparation',
	    value: 'preparation',
	    desc: 'Can be used for individual or joint preparation',
	    order: 10
	  }, {
	    lang: 'nb',
	    name: 'Forberedelse',
	    value: 'preparation',
	    desc: 'Kan brukes til individuell eller felles forberedelse',
	    order: 10
	  }],
	  'pool': [{
	    lang: 'da',
	    name: 'Lokalpulje',
	    value: 'pool',
	    desc: 'Kan bruges til f.eks. udvikling, forberedelse, overlevering, opgaver i tilknytning til afslutning',
	    order: 11
	  }, {
	    lang: 'nb',
	    name: 'Planleggingsdager',
	    value: 'pool',
	    desc: '',
	    order: 11
	  }],
	  'activity': [{
	    lang: 'da',
	    name: 'Aktivitet <span style="text-transform: initial">(m. reduktion)</span> <span class="do-bagde-break">UV-tid</span>',
	    value: 'activity',
	    desc: 'Bruges til at oprette aktiviteter i klasser, der skal reducere timepuljer fra andre fag.',
	    order: 11
	  }],
	  'reservation': [{
	    lang: 'da',
	    name: 'Reservation',
	    value: 'reservation',
	    desc: 'Bruges til f.eks. lokalebooking. Tæller intet og kommer IKKE i vikardækningen. Blokerer blot et tidsrum i en kalender',
	    order: 11
	  }, {
	    lang: 'nb',
	    name: 'Reservasjon',
	    value: 'reservation',
	    desc: 'Brukes til f.eks. rombestilling. Teller ingenting - men blokkerer bare et tidsrom i en kalender',
	    order: 11
	  }, {
	    lang: 'en',
	    name: 'Reservation',
	    value: 'reservation',
	    desc: 'Used for e.g. room booking. Counts for nothing - but simply blocks a time slot in a calendar',
	    order: 11
	  }]
	};
	
	var kindergartenTypes = exports.kindergartenTypes = {
	  'with_kids': [{ lang: 'da', name: 'Tid med børn', value: 'with_kids', desc: 'Tid sammen med børnene', order: 11 }, { lang: 'en', name: 'Tid med børn', value: 'with_kids', desc: 'Tid sammen med børnene', order: 11 }, { lang: 'nb', name: 'Tid med børn', value: 'with_kids', desc: 'Tid sammen med børnene', order: 11 }],
	  'without_kids': [{ lang: 'da', name: 'Tid uden børn', value: 'without_kids', desc: 'Tid uden børnene', order: 12 }, { lang: 'en', name: 'Tid uden børn', value: 'without_kids', desc: 'Tid uden børnene', order: 12 }, { lang: 'nb', name: 'Tid uden børn', value: 'without_kids', desc: 'Tid uden børnene', order: 12 }]
	};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _assignTeacherToScheduledEvents = __webpack_require__(445);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      showAssignTeacherToEventsConfirm: false,
	      assignTeacherToEventsAction: 'add',
	      assignTeacherToEventsKind: 'user',
	      assignTeacherToEventsCalendarIds: [],
	      assignTeacherToEventsQueue: [],
	      askedTeacherAssignKeys: [],
	      scheduledEventsForAssign: null,
	      isLoadingScheduledEventsForAssign: false,
	      continueUpdateAfterTeacherAssign: false
	    };
	  },
	
	  computed: {
	    assignTeacherToEventsNames: function assignTeacherToEventsNames() {
	      var _this = this;
	
	      return this.assignTeacherToEventsCalendarIds.map(function (calendarId) {
	        var calendar = _this.allCalendarsInHash && _this.allCalendarsInHash[calendarId];
	        return calendar && calendar.name ? calendar.name : '';
	      }).filter(function (name) {
	        return name;
	      }).join(', ');
	    },
	    assignTeacherToEventsInitialDate: function assignTeacherToEventsInitialDate() {
	      var weekStart = this.$store.getters.calendarStartDate;
	      if (weekStart) {
	        return (0, _moment2.default)(weekStart).format('YYYY-MM-DD');
	      }
	      return (0, _moment2.default)().format('YYYY-MM-DD');
	    }
	  },
	  methods: {
	    teacherAssignKey: function teacherAssignKey(action, calendarId) {
	      return action + ':' + calendarId;
	    },
	    currentIdsForAssignKind: function currentIdsForAssignKind(kind) {
	      if (kind === 'klass') return this.klassCalendarIds || [];
	      if (kind === 'room') return this.roomCalendarIds || [];
	      return this.userCalendarIds || [];
	    },
	    lockedIdsForAssignKind: function lockedIdsForAssignKind(kind) {
	      if (kind === 'klass') {
	        return this.calendarId ? [this.calendarId] : [];
	      }
	      if (kind === 'room') return [];
	      return this.lockedTeacherCalendarIds || [];
	    },
	    calendarIdsAlreadyOnSubjectForKind: function calendarIdsAlreadyOnSubjectForKind(kind) {
	      var _this2 = this;
	
	      if (!this.editSubject) return [];
	      var raw = this.editSubject.calendar_ids ? this.editSubject.calendar_ids : (this.editSubject.cals || []).map(function (cal) {
	        return cal.id;
	      });
	      return raw.filter(function (id) {
	        var calendar = _this2.allCalendarsInHash && _this2.allCalendarsInHash[id];
	        if (!calendar || calendar.type !== kind) return false;
	        if (kind === 'klass' && id === _this2.calendarId) return false;
	        return true;
	      });
	    },
	    addedCalendarIdsForAssign: function addedCalendarIdsForAssign(selectedItems, kind) {
	      var newIds = (selectedItems || []).map(function (item) {
	        return item.id;
	      });
	      var currentIds = this.currentIdsForAssignKind(kind);
	      var locked = this.lockedIdsForAssignKind(kind);
	      var alreadyOnSubject = this.calendarIdsAlreadyOnSubjectForKind(kind);
	      return newIds.filter(function (id) {
	        return currentIds.indexOf(id) < 0 && locked.indexOf(id) < 0 && alreadyOnSubject.indexOf(id) < 0;
	      });
	    },
	    removedCalendarIdsForAssign: function removedCalendarIdsForAssign(selectedItems, kind) {
	      var newIds = (selectedItems || []).map(function (item) {
	        return item.id;
	      });
	      var currentIds = this.currentIdsForAssignKind(kind);
	      var locked = this.lockedIdsForAssignKind(kind);
	      return currentIds.filter(function (id) {
	        return newIds.indexOf(id) < 0 && locked.indexOf(id) < 0;
	      });
	    },
	    unaskedIdsForAssignAction: function unaskedIdsForAssignAction(action, kind) {
	      var _this3 = this;
	
	      var locked = this.lockedIdsForAssignKind(kind);
	      var alreadyOnSubject = this.calendarIdsAlreadyOnSubjectForKind(kind);
	      var currentIds = this.currentIdsForAssignKind(kind);
	      if (action === 'add') {
	        return currentIds.filter(function (id) {
	          return alreadyOnSubject.indexOf(id) < 0 && locked.indexOf(id) < 0 && _this3.askedTeacherAssignKeys.indexOf(_this3.teacherAssignKey('add', id)) < 0;
	        });
	      }
	      return alreadyOnSubject.filter(function (id) {
	        return currentIds.indexOf(id) < 0 && locked.indexOf(id) < 0 && _this3.askedTeacherAssignKeys.indexOf(_this3.teacherAssignKey('remove', id)) < 0;
	      });
	    },
	    assignTeacherSchoolId: function assignTeacherSchoolId() {
	      if (this.editSubject && this.editSubject.school_id) return this.editSubject.school_id;
	      if (this.schoolId) return this.schoolId;
	      return window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id : null;
	    },
	    isAssignTeacherToEventsEnabled: function isAssignTeacherToEventsEnabled() {
	      return !!this.isInDCalendar;
	    },
	    onTeacherSelectionUpdated: function onTeacherSelectionUpdated(users) {
	      this.onCalendarSelectionUpdatedForAssign(users, 'user');
	    },
	    onKlassSelectionUpdated: function onKlassSelectionUpdated(klasses) {
	      this.onCalendarSelectionUpdatedForAssign(klasses, 'klass');
	    },
	    onRoomSelectionUpdated: function onRoomSelectionUpdated(rooms) {
	      this.onCalendarSelectionUpdatedForAssign(rooms, 'room');
	    },
	    onCalendarSelectionUpdatedForAssign: function onCalendarSelectionUpdatedForAssign(selectedItems, kind) {
	      var addedIds = this.addedCalendarIdsForAssign(selectedItems, kind);
	      var removedIds = this.removedCalendarIdsForAssign(selectedItems, kind);
	      var newIds = selectedItems.map(function (item) {
	        return item.id;
	      });
	      if (kind === 'klass') {
	        this.klassCalendarIds = newIds;
	      } else if (kind === 'room') {
	        this.roomCalendarIds = newIds;
	      } else {
	        this.userCalendarIds = newIds;
	      }
	      if (!this.editSubject || !this.isAssignTeacherToEventsEnabled()) return;
	      if (addedIds.length > 0) {
	        this.maybeAskAssignTeacherToScheduledEvents(addedIds, 'add', kind);
	      }
	      if (removedIds.length > 0) {
	        this.maybeAskAssignTeacherToScheduledEvents(removedIds, 'remove', kind);
	      }
	    },
	    isTeacherAssignPending: function isTeacherAssignPending(calendarId, action) {
	      var inQueue = this.assignTeacherToEventsQueue.some(function (item) {
	        return item.calendarId === calendarId && item.action === action;
	      });
	      var inModal = this.assignTeacherToEventsAction === action && this.assignTeacherToEventsCalendarIds.indexOf(calendarId) > -1;
	      return inQueue || inModal;
	    },
	    maybeAskAssignTeacherToScheduledEvents: function maybeAskAssignTeacherToScheduledEvents(calendarIds, action, kind) {
	      var _this4 = this;
	
	      var theKind = kind || 'user';
	      if (!this.isAssignTeacherToEventsEnabled()) return;
	      if (!this.editSubject || !calendarIds || !calendarIds.length) return;
	      var toAsk = calendarIds.filter(function (id) {
	        return !_this4.isTeacherAssignPending(id, action) && _this4.askedTeacherAssignKeys.indexOf(_this4.teacherAssignKey(action, id)) < 0;
	      });
	      if (!toAsk.length) return;
	      this.assignTeacherToEventsQueue = this.assignTeacherToEventsQueue.concat(toAsk.map(function (id) {
	        return { calendarId: id, action: action, kind: theKind };
	      }));
	      if (this.showAssignTeacherToEventsConfirm || this.isLoadingScheduledEventsForAssign) {
	        return;
	      }
	      this.loadScheduledEventsThenAsk();
	    },
	    loadScheduledEventsThenAsk: function loadScheduledEventsThenAsk() {
	      var _this5 = this;
	
	      if (this.scheduledEventsForAssign) {
	        this.openAssignTeacherToEventsIfNeeded();
	        return;
	      }
	      this.isLoadingScheduledEventsForAssign = true;
	      (0, _assignTeacherToScheduledEvents.loadEventsForSubject)(this.editSubject.id, function (events) {
	        _this5.scheduledEventsForAssign = events;
	        _this5.isLoadingScheduledEventsForAssign = false;
	        _this5.openAssignTeacherToEventsIfNeeded();
	      }, function () {
	        _this5.scheduledEventsForAssign = [];
	        _this5.isLoadingScheduledEventsForAssign = false;
	        _this5.markQueuedTeachersAsAsked();
	        _this5.finishTeacherAssignAndMaybeUpdate();
	      });
	    },
	    openAssignTeacherToEventsIfNeeded: function openAssignTeacherToEventsIfNeeded() {
	      var queued = this.assignTeacherToEventsQueue.slice();
	      if (!queued.length) {
	        this.finishTeacherAssignAndMaybeUpdate();
	        return;
	      }
	      if (!this.scheduledEventsForAssign || this.scheduledEventsForAssign.length < 1) {
	        this.markQueuedTeachersAsAsked();
	        this.finishTeacherAssignAndMaybeUpdate();
	        return;
	      }
	      var action = queued[0].action;
	      var kind = queued[0].kind || 'user';
	      var sameBatch = queued.filter(function (item) {
	        return item.action === action && (item.kind || 'user') === kind;
	      });
	      this.assignTeacherToEventsQueue = queued.filter(function (item) {
	        return item.action !== action || (item.kind || 'user') !== kind;
	      });
	      this.assignTeacherToEventsAction = action;
	      this.assignTeacherToEventsKind = kind;
	      this.assignTeacherToEventsCalendarIds = sameBatch.map(function (item) {
	        return item.calendarId;
	      });
	      this.showAssignTeacherToEventsConfirm = true;
	    },
	    markQueuedTeachersAsAsked: function markQueuedTeachersAsAsked() {
	      var _this6 = this;
	
	      this.assignTeacherToEventsQueue.forEach(function (item) {
	        _this6.markTeachersAsAsked([item.calendarId], item.action);
	      });
	      this.assignTeacherToEventsQueue = [];
	    },
	    markTeachersAsAsked: function markTeachersAsAsked(calendarIds, action) {
	      var _this7 = this;
	
	      var theAction = action || this.assignTeacherToEventsAction;(calendarIds || []).forEach(function (id) {
	        var key = _this7.teacherAssignKey(theAction, id);
	        if (_this7.askedTeacherAssignKeys.indexOf(key) < 0) {
	          _this7.askedTeacherAssignKeys.push(key);
	        }
	      });
	    },
	    onAssignTeacherToEventsConfirm: function onAssignTeacherToEventsConfirm(payload) {
	      var _this8 = this;
	
	      var fromDate = payload && payload.fromDate ? payload.fromDate : payload;
	      var enddate = payload && payload.enddate ? payload.enddate : null;
	      var calendarIds = this.assignTeacherToEventsCalendarIds.slice();
	      var action = this.assignTeacherToEventsAction;
	      this.markTeachersAsAsked(calendarIds, action);
	      this.showAssignTeacherToEventsConfirm = false;
	      this.assignTeacherToEventsCalendarIds = [];
	      this.applyTeacherChangeToBrickAndEvents(calendarIds, fromDate, action, function () {
	        _this8.processNextAssignTeacherOrUpdate();
	      }, enddate);
	    },
	    onAssignTeacherToEventsSkip: function onAssignTeacherToEventsSkip() {
	      this.markTeachersAsAsked(this.assignTeacherToEventsCalendarIds, this.assignTeacherToEventsAction);
	      this.showAssignTeacherToEventsConfirm = false;
	      this.assignTeacherToEventsCalendarIds = [];
	      this.processNextAssignTeacherOrUpdate();
	    },
	    processNextAssignTeacherOrUpdate: function processNextAssignTeacherOrUpdate() {
	      if (this.assignTeacherToEventsQueue.length > 0) {
	        this.openAssignTeacherToEventsIfNeeded();
	        return;
	      }
	      this.finishTeacherAssignAndMaybeUpdate();
	    },
	    finishTeacherAssignAndMaybeUpdate: function finishTeacherAssignAndMaybeUpdate() {
	      if (!this.continueUpdateAfterTeacherAssign) return;
	      this.continueUpdateAfterTeacherAssign = false;
	      this.doUpdateSubject();
	    },
	    shouldWaitForTeacherAssignBeforeUpdate: function shouldWaitForTeacherAssignBeforeUpdate() {
	      var _this9 = this;
	
	      if (!this.isAssignTeacherToEventsEnabled() || !this.editSubject) return false;
	      if (this.showAssignTeacherToEventsConfirm || this.isLoadingScheduledEventsForAssign) {
	        this.continueUpdateAfterTeacherAssign = true;
	        return true;
	      }
	      var foundUnasked = false;['user', 'klass', 'room'].forEach(function (kind) {
	        var unaskedAdd = _this9.unaskedIdsForAssignAction('add', kind);
	        var unaskedRemove = _this9.unaskedIdsForAssignAction('remove', kind);
	        if (unaskedAdd.length < 1 && unaskedRemove.length < 1) return;
	        foundUnasked = true;
	        _this9.continueUpdateAfterTeacherAssign = true;
	        if (unaskedAdd.length) _this9.maybeAskAssignTeacherToScheduledEvents(unaskedAdd, 'add', kind);
	        if (unaskedRemove.length) _this9.maybeAskAssignTeacherToScheduledEvents(unaskedRemove, 'remove', kind);
	      });
	      return foundUnasked;
	    },
	    applyTeacherChangeToBrickAndEvents: function applyTeacherChangeToBrickAndEvents(calendarIds, fromDate, action, done, enddate) {
	      var _this10 = this;
	
	      if (!calendarIds.length) {
	        if (done) done();
	        return;
	      }
	      var schoolId = this.assignTeacherSchoolId();
	      var subjectId = this.editSubject.id;
	      var isRemove = action === 'remove';
	      var applyOnEvents = isRemove ? _assignTeacherToScheduledEvents.removeTeacherFromScheduledEventsFromDate : _assignTeacherToScheduledEvents.addTeacherToScheduledEventsFromDate;
	      var remaining = calendarIds.length;
	      var next = function next() {
	        remaining--;
	        if (remaining < 1) {
	          _this10.refreshCalendarAfterTeacherAssign();
	          if (done) done();
	        }
	      };
	      calendarIds.forEach(function (calendarId) {
	        var changes = isRemove ? { remove_calendar_id: calendarId } : { add_calendar_id: calendarId };
	        _docendo2.default.bulkUpdateSubjects(schoolId, [subjectId], changes, function (data) {
	          if (Array.isArray(data)) {
	            var subjects = _this10.$store.state.subjects && _this10.$store.state.subjects.subjects;
	            data.forEach(function (subject) {
	              if (subjects && subjects.some(function (item) {
	                return item.id === subject.id;
	              })) {
	                _this10.$store.commit('updateSubject', subject);
	              }
	            });
	          }
	        });
	        applyOnEvents({
	          schoolId: schoolId,
	          calendarId: calendarId,
	          fromDate: fromDate,
	          enddate: enddate || null,
	          events: _this10.scheduledEventsForAssign
	        }, function (result) {
	          if (result && result.reason === 'no_events_from_date') {
	            _eventbus2.default.toast = {
	              text: _this10.assignTeacherToEventsI18n().no_events_from_date,
	              success: false
	            };
	          } else {
	            _eventbus2.default.toast = {
	              text: _this10.$t('vue2.substitution.lessons_updated'),
	              success: true
	            };
	          }
	          next();
	        }, function () {
	          _eventbus2.default.toast = { text: _this10.$t('vue2.sms.an_error_occured'), success: false };
	          next();
	        });
	      });
	    },
	    refreshCalendarAfterTeacherAssign: function refreshCalendarAfterTeacherAssign() {
	      var calendarState = this.$store.state.calendar;
	      var calendarId = calendarState && calendarState.calendarId;
	      if (calendarId) {
	        this.$store.dispatch('readCalendarEvents', {
	          calIds: [calendarId],
	          start: this.$store.getters.calendarStartDate,
	          end: this.$store.getters.calendarEndDate,
	          andReadSubjects: true
	        });
	        return;
	      }
	      if (this.isInDCalendar) {
	        this.$store.dispatch('readCalendarSubjects');
	      }
	    },
	    assignTeacherToEventsI18n: function assignTeacherToEventsI18n() {
	      var locale = this.locale || 'da';
	      var texts = {
	        da: { no_events_from_date: 'Der er ingen skemalagte brikker fra den valgte dato' },
	        en: { no_events_from_date: 'There are no scheduled lessons from the selected date' },
	        nb: { no_events_from_date: 'Det er ingen timeplanlagte brikker fra den valgte dato' }
	      };
	      return texts[locale] || texts.da;
	    }
	  }
	};

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	  if (typeof window.CustomEvent === 'function') return false;
	
	  function CustomEvent(event, params) {
	    params = params || { bubbles: false, cancelable: false, detail: undefined };
	    var evt = document.createEvent('CustomEvent');
	    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	    return evt;
	  }
	
	  CustomEvent.prototype = window.Event.prototype;
	
	  window.CustomEvent = CustomEvent;
	})();

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(56);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(57);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Event = __webpack_require__(113);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AbstractConnection = function () {
	  function AbstractConnection(url, dispatcher) {
	    (0, _classCallCheck3.default)(this, AbstractConnection);
	
	    this.dispatcher = dispatcher;
	    this.message_queue = [];
	  }
	
	  (0, _createClass3.default)(AbstractConnection, [{
	    key: 'close',
	    value: function close() {}
	  }, {
	    key: 'trigger',
	    value: function trigger(event) {
	      if (this.dispatcher.state !== 'connected') {
	        return this.message_queue.push(event);
	      }
	      return this.send_event(event);
	    }
	  }, {
	    key: 'send_event',
	    value: function send_event(event) {
	      if (this.connection_id) {
	        return event.connection_id = this.connection_id;
	      }
	    }
	  }, {
	    key: 'on_close',
	    value: function on_close(event) {
	      if (this.dispatcher && this.dispatcher._conn === this) {
	        var close_event = new _Event2.default(['connection_closed', event]);
	        this.dispatcher.state = 'disconnected';
	        return this.dispatcher.dispatch(close_event);
	      }
	    }
	  }, {
	    key: 'on_error',
	    value: function on_error(event) {
	      if (this.dispatcher && this.dispatcher._conn === this) {
	        var error_event = new _Event2.default(['connection_error', event]);
	        this.dispatcher.state = 'disconnected';
	        return this.dispatcher.dispatch(error_event);
	      }
	    }
	  }, {
	    key: 'on_message',
	    value: function on_message(event_data) {
	      if (this.dispatcher && this.dispatcher._conn === this) {
	        return this.dispatcher.new_message(event_data);
	      }
	    }
	  }, {
	    key: 'setConnectionId',
	    value: function setConnectionId(connection_id) {
	      this.connection_id = connection_id;
	    }
	  }, {
	    key: 'flush_queue',
	    value: function flush_queue() {
	      var _this = this;
	
	      this.message_queue.forEach(function (item) {
	        _this.trigger(item);
	      });
	
	      return this.message_queue = [];
	    }
	  }]);
	  return AbstractConnection;
	}();
	
	exports.default = AbstractConnection;

/***/ }),
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1181)
	
	/* script */
	__vue_exports__ = __webpack_require__(456)
	
	/* template */
	var __vue_template__ = __webpack_require__(1940)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-599cef24"
	
	module.exports = __vue_exports__


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1050)
	
	/* script */
	__vue_exports__ = __webpack_require__(462)
	
	/* template */
	var __vue_template__ = __webpack_require__(1800)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-223d07fd"
	
	module.exports = __vue_exports__


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1355)
	
	/* script */
	__vue_exports__ = __webpack_require__(463)
	
	/* template */
	var __vue_template__ = __webpack_require__(2123)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c74ee5a4"
	
	module.exports = __vue_exports__


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1180)
	
	/* script */
	__vue_exports__ = __webpack_require__(470)
	
	/* template */
	var __vue_template__ = __webpack_require__(1939)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5960870a"
	
	module.exports = __vue_exports__


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1250)
	
	/* script */
	__vue_exports__ = __webpack_require__(472)
	
	/* template */
	var __vue_template__ = __webpack_require__(2015)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-75af5a47"
	
	module.exports = __vue_exports__


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1353)
	
	/* script */
	__vue_exports__ = __webpack_require__(476)
	
	/* template */
	var __vue_template__ = __webpack_require__(2120)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1156)
	
	/* script */
	__vue_exports__ = __webpack_require__(478)
	
	/* template */
	var __vue_template__ = __webpack_require__(1915)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5061dab8"
	
	module.exports = __vue_exports__


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1029)
	
	/* script */
	__vue_exports__ = __webpack_require__(480)
	
	/* template */
	var __vue_template__ = __webpack_require__(1778)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-18c2f64c"
	
	module.exports = __vue_exports__


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1396)
	
	/* script */
	__vue_exports__ = __webpack_require__(487)
	
	/* template */
	var __vue_template__ = __webpack_require__(2167)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f73d31cc"
	
	module.exports = __vue_exports__


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1205)
	
	/* script */
	__vue_exports__ = __webpack_require__(491)
	
	/* template */
	var __vue_template__ = __webpack_require__(1965)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-64af2518"
	
	module.exports = __vue_exports__


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1099)
	
	/* script */
	__vue_exports__ = __webpack_require__(493)
	
	/* template */
	var __vue_template__ = __webpack_require__(1857)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-37033ca5"
	
	module.exports = __vue_exports__


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1021)
	
	/* script */
	__vue_exports__ = __webpack_require__(497)
	
	/* template */
	var __vue_template__ = __webpack_require__(1770)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-13e1ed8c"
	
	module.exports = __vue_exports__


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1359)
	
	/* script */
	__vue_exports__ = __webpack_require__(501)
	
	/* template */
	var __vue_template__ = __webpack_require__(2128)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d00a6530"
	
	module.exports = __vue_exports__


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1200)
	
	/* script */
	__vue_exports__ = __webpack_require__(503)
	
	/* template */
	var __vue_template__ = __webpack_require__(1960)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-63dcf620"
	
	module.exports = __vue_exports__


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1068)
	
	/* script */
	__vue_exports__ = __webpack_require__(505)
	
	/* template */
	var __vue_template__ = __webpack_require__(1820)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-29814708"
	
	module.exports = __vue_exports__


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1056)
	
	/* script */
	__vue_exports__ = __webpack_require__(524)
	
	/* template */
	var __vue_template__ = __webpack_require__(1807)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-246c188a"
	
	module.exports = __vue_exports__


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(536)
	
	/* template */
	var __vue_template__ = __webpack_require__(1839)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(538)
	
	/* template */
	var __vue_template__ = __webpack_require__(2125)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1022)
	
	/* script */
	__vue_exports__ = __webpack_require__(540)
	
	/* template */
	var __vue_template__ = __webpack_require__(1771)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-140f9b06"
	
	module.exports = __vue_exports__


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1152)
	
	/* script */
	__vue_exports__ = __webpack_require__(541)
	
	/* template */
	var __vue_template__ = __webpack_require__(1912)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4eea129d"
	
	module.exports = __vue_exports__


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(545)
	
	/* template */
	var __vue_template__ = __webpack_require__(1992)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1253)
	
	/* script */
	__vue_exports__ = __webpack_require__(551)
	
	/* template */
	var __vue_template__ = __webpack_require__(2018)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-77923726"
	
	module.exports = __vue_exports__


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1004)
	
	/* script */
	__vue_exports__ = __webpack_require__(556)
	
	/* template */
	var __vue_template__ = __webpack_require__(1753)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0a4468b0"
	
	module.exports = __vue_exports__


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1066)
	
	/* script */
	__vue_exports__ = __webpack_require__(560)
	
	/* template */
	var __vue_template__ = __webpack_require__(1817)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-284b8dcf"
	
	module.exports = __vue_exports__


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(567)
	
	/* template */
	var __vue_template__ = __webpack_require__(1978)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1210)
	
	/* script */
	__vue_exports__ = __webpack_require__(568)
	
	/* template */
	var __vue_template__ = __webpack_require__(1970)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-66c7628e"
	
	module.exports = __vue_exports__


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1316)
	
	/* script */
	__vue_exports__ = __webpack_require__(569)
	
	/* template */
	var __vue_template__ = __webpack_require__(2083)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a895afee"
	
	module.exports = __vue_exports__


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(991)
	
	/* script */
	__vue_exports__ = __webpack_require__(571)
	
	/* template */
	var __vue_template__ = __webpack_require__(1740)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0629c0ab"
	
	module.exports = __vue_exports__


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(575)
	
	/* template */
	var __vue_template__ = __webpack_require__(1945)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1126)
	__webpack_require__(1125)
	
	/* script */
	__vue_exports__ = __webpack_require__(577)
	
	/* template */
	var __vue_template__ = __webpack_require__(1885)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-44043770"
	
	module.exports = __vue_exports__


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1323)
	
	/* script */
	__vue_exports__ = __webpack_require__(582)
	
	/* template */
	var __vue_template__ = __webpack_require__(2090)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-af372fc4"
	
	module.exports = __vue_exports__


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1006)
	
	/* script */
	__vue_exports__ = __webpack_require__(585)
	
	/* template */
	var __vue_template__ = __webpack_require__(1755)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0b6a9ee6"
	
	module.exports = __vue_exports__


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1105)
	
	/* script */
	__vue_exports__ = __webpack_require__(590)
	
	/* template */
	var __vue_template__ = __webpack_require__(1864)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-38f50666"
	
	module.exports = __vue_exports__


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1368)
	
	/* script */
	__vue_exports__ = __webpack_require__(608)
	
	/* template */
	var __vue_template__ = __webpack_require__(2137)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-dab03e6e"
	
	module.exports = __vue_exports__


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1384)
	
	/* script */
	__vue_exports__ = __webpack_require__(609)
	
	/* template */
	var __vue_template__ = __webpack_require__(2154)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ec2fc8f0"
	
	module.exports = __vue_exports__


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(616)
	
	/* template */
	var __vue_template__ = __webpack_require__(1976)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1341)
	
	/* script */
	__vue_exports__ = __webpack_require__(630)
	
	/* template */
	var __vue_template__ = __webpack_require__(2108)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1284)
	
	/* script */
	__vue_exports__ = __webpack_require__(631)
	
	/* template */
	var __vue_template__ = __webpack_require__(2050)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1399)
	
	/* script */
	__vue_exports__ = __webpack_require__(632)
	
	/* template */
	var __vue_template__ = __webpack_require__(2170)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-fecede3e"
	
	module.exports = __vue_exports__


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1335)
	
	/* script */
	__vue_exports__ = __webpack_require__(633)
	
	/* template */
	var __vue_template__ = __webpack_require__(2102)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b7a05ab8"
	
	module.exports = __vue_exports__


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1121)
	
	/* script */
	__vue_exports__ = __webpack_require__(634)
	
	/* template */
	var __vue_template__ = __webpack_require__(1881)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-43485a14"
	
	module.exports = __vue_exports__


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1350)
	
	/* script */
	__vue_exports__ = __webpack_require__(639)
	
	/* template */
	var __vue_template__ = __webpack_require__(2117)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c15e7e38"
	
	module.exports = __vue_exports__


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1356)
	
	/* script */
	__vue_exports__ = __webpack_require__(649)
	
	/* template */
	var __vue_template__ = __webpack_require__(2124)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c8ebac1c"
	
	module.exports = __vue_exports__


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1333)
	
	/* script */
	__vue_exports__ = __webpack_require__(651)
	
	/* template */
	var __vue_template__ = __webpack_require__(2100)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b700d4fa"
	
	module.exports = __vue_exports__


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1306)
	
	/* script */
	__vue_exports__ = __webpack_require__(654)
	
	/* template */
	var __vue_template__ = __webpack_require__(2071)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9e4c8cd0"
	
	module.exports = __vue_exports__


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1027)
	
	/* script */
	__vue_exports__ = __webpack_require__(655)
	
	/* template */
	var __vue_template__ = __webpack_require__(1776)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-16c7a552"
	
	module.exports = __vue_exports__


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1215)
	
	/* script */
	__vue_exports__ = __webpack_require__(660)
	
	/* template */
	var __vue_template__ = __webpack_require__(1975)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-674316b0"
	
	module.exports = __vue_exports__


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1174)
	
	/* script */
	__vue_exports__ = __webpack_require__(670)
	
	/* template */
	var __vue_template__ = __webpack_require__(1933)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-57b76e06"
	
	module.exports = __vue_exports__


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1139)
	
	/* script */
	__vue_exports__ = __webpack_require__(672)
	
	/* template */
	var __vue_template__ = __webpack_require__(1898)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-488a89ef"
	
	module.exports = __vue_exports__


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1090)
	
	/* script */
	__vue_exports__ = __webpack_require__(678)
	
	/* template */
	var __vue_template__ = __webpack_require__(1846)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3383c5e6"
	
	module.exports = __vue_exports__


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1237)
	
	/* script */
	__vue_exports__ = __webpack_require__(691)
	
	/* template */
	var __vue_template__ = __webpack_require__(2002)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1276)
	
	/* script */
	__vue_exports__ = __webpack_require__(711)
	
	/* template */
	var __vue_template__ = __webpack_require__(2041)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1198)
	
	/* script */
	__vue_exports__ = __webpack_require__(715)
	
	/* template */
	var __vue_template__ = __webpack_require__(1958)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-62ed89bf"
	
	module.exports = __vue_exports__


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1264)
	
	/* script */
	__vue_exports__ = __webpack_require__(718)
	
	/* template */
	var __vue_template__ = __webpack_require__(2029)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7a1aaf70"
	
	module.exports = __vue_exports__


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1309)
	
	/* script */
	__vue_exports__ = __webpack_require__(720)
	
	/* template */
	var __vue_template__ = __webpack_require__(2074)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a1e02218"
	
	module.exports = __vue_exports__


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1059)
	
	/* script */
	__vue_exports__ = __webpack_require__(722)
	
	/* template */
	var __vue_template__ = __webpack_require__(1810)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2526293c"
	
	module.exports = __vue_exports__


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1314)
	
	/* script */
	__vue_exports__ = __webpack_require__(723)
	
	/* template */
	var __vue_template__ = __webpack_require__(2081)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a7f3a51e"
	
	module.exports = __vue_exports__


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1218)
	
	/* script */
	__vue_exports__ = __webpack_require__(724)
	
	/* template */
	var __vue_template__ = __webpack_require__(1980)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-69107416"
	
	module.exports = __vue_exports__


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1326)
	
	/* script */
	__vue_exports__ = __webpack_require__(729)
	
	/* template */
	var __vue_template__ = __webpack_require__(2093)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b0b59bca"
	
	module.exports = __vue_exports__


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1033)
	
	/* script */
	__vue_exports__ = __webpack_require__(730)
	
	/* template */
	var __vue_template__ = __webpack_require__(1782)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1a690d52"
	
	module.exports = __vue_exports__


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1312)
	
	/* script */
	__vue_exports__ = __webpack_require__(738)
	
	/* template */
	var __vue_template__ = __webpack_require__(2077)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a5458594"
	
	module.exports = __vue_exports__


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1003)
	
	/* script */
	__vue_exports__ = __webpack_require__(740)
	
	/* template */
	var __vue_template__ = __webpack_require__(1752)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-09fb3b83"
	
	module.exports = __vue_exports__


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1062)
	
	/* script */
	__vue_exports__ = __webpack_require__(743)
	
	/* template */
	var __vue_template__ = __webpack_require__(1813)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-25fd8e5a"
	
	module.exports = __vue_exports__


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1266)
	
	/* script */
	__vue_exports__ = __webpack_require__(745)
	
	/* template */
	var __vue_template__ = __webpack_require__(2031)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1011)
	
	/* script */
	__vue_exports__ = __webpack_require__(750)
	
	/* template */
	var __vue_template__ = __webpack_require__(1760)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0f93c863"
	
	module.exports = __vue_exports__


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1079)
	
	/* script */
	__vue_exports__ = __webpack_require__(754)
	
	/* template */
	var __vue_template__ = __webpack_require__(1833)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2d159440"
	
	module.exports = __vue_exports__


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1255)
	
	/* script */
	__vue_exports__ = __webpack_require__(777)
	
	/* template */
	var __vue_template__ = __webpack_require__(2020)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-77d4b4dc"
	
	module.exports = __vue_exports__


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1080)
	
	/* script */
	__vue_exports__ = __webpack_require__(782)
	
	/* template */
	var __vue_template__ = __webpack_require__(1835)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2e417e46"
	
	module.exports = __vue_exports__


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1227)
	
	/* script */
	__vue_exports__ = __webpack_require__(785)
	
	/* template */
	var __vue_template__ = __webpack_require__(1989)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6bfee519"
	
	module.exports = __vue_exports__


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1184)
	
	/* script */
	__vue_exports__ = __webpack_require__(790)
	
	/* template */
	var __vue_template__ = __webpack_require__(1943)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5b9f97b0"
	
	module.exports = __vue_exports__


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1383)
	
	/* script */
	__vue_exports__ = __webpack_require__(798)
	
	/* template */
	var __vue_template__ = __webpack_require__(2153)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ebad7330"
	
	module.exports = __vue_exports__


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1165)
	
	/* script */
	__vue_exports__ = __webpack_require__(810)
	
	/* template */
	var __vue_template__ = __webpack_require__(1923)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-549ddf9f"
	
	module.exports = __vue_exports__


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(980)
	
	/* script */
	__vue_exports__ = __webpack_require__(812)
	
	/* template */
	var __vue_template__ = __webpack_require__(1728)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1217)
	
	/* script */
	__vue_exports__ = __webpack_require__(815)
	
	/* template */
	var __vue_template__ = __webpack_require__(1979)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-68d5e0e0"
	
	module.exports = __vue_exports__


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1163)
	__webpack_require__(1162)
	
	/* script */
	__vue_exports__ = __webpack_require__(828)
	
	/* template */
	var __vue_template__ = __webpack_require__(1921)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-540947a6"
	
	module.exports = __vue_exports__


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1393)
	
	/* script */
	__vue_exports__ = __webpack_require__(829)
	
	/* template */
	var __vue_template__ = __webpack_require__(2164)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1375)
	
	/* script */
	__vue_exports__ = __webpack_require__(830)
	
	/* template */
	var __vue_template__ = __webpack_require__(2145)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1338)
	
	/* script */
	__vue_exports__ = __webpack_require__(839)
	
	/* template */
	var __vue_template__ = __webpack_require__(2105)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-bb56e46e"
	
	module.exports = __vue_exports__


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1113)
	
	/* script */
	__vue_exports__ = __webpack_require__(843)
	
	/* template */
	var __vue_template__ = __webpack_require__(1872)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3f1dafca"
	
	module.exports = __vue_exports__


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1018)
	
	/* template */
	var __vue_template__ = __webpack_require__(1767)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-12e33273"
	
	module.exports = __vue_exports__


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1273)
	
	/* script */
	__vue_exports__ = __webpack_require__(846)
	
	/* template */
	var __vue_template__ = __webpack_require__(2038)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7e62a5a2"
	
	module.exports = __vue_exports__


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1031)
	
	/* script */
	__vue_exports__ = __webpack_require__(847)
	
	/* template */
	var __vue_template__ = __webpack_require__(1780)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1000)
	
	/* script */
	__vue_exports__ = __webpack_require__(848)
	
	/* template */
	var __vue_template__ = __webpack_require__(1749)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0864a57e"
	
	module.exports = __vue_exports__


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1245)
	
	/* script */
	__vue_exports__ = __webpack_require__(851)
	
	/* template */
	var __vue_template__ = __webpack_require__(2010)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-73c8caf7"
	
	module.exports = __vue_exports__


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1052)
	
	/* script */
	__vue_exports__ = __webpack_require__(852)
	
	/* template */
	var __vue_template__ = __webpack_require__(1802)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-227e34f8"
	
	module.exports = __vue_exports__


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1023)
	
	/* script */
	__vue_exports__ = __webpack_require__(864)
	
	/* template */
	var __vue_template__ = __webpack_require__(1772)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-141ad5e2"
	
	module.exports = __vue_exports__


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1260)
	
	/* script */
	__vue_exports__ = __webpack_require__(885)
	
	/* template */
	var __vue_template__ = __webpack_require__(2025)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7906737e"
	
	module.exports = __vue_exports__


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1219)
	
	/* script */
	__vue_exports__ = __webpack_require__(887)
	
	/* template */
	var __vue_template__ = __webpack_require__(1981)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-694147c9"
	
	module.exports = __vue_exports__


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1151)
	
	/* script */
	__vue_exports__ = __webpack_require__(888)
	
	/* template */
	var __vue_template__ = __webpack_require__(1911)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4e8ebce4"
	
	module.exports = __vue_exports__


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(891)
	
	/* template */
	var __vue_template__ = __webpack_require__(2079)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var langs = [{ 'code': 'en', 'name': 'English (American)' }, { 'code': 'ar-dz', 'name': 'Arabic (Algeria)' }, { 'code': 'ar-kw', 'name': 'Arabic (Kuwait)' }, { 'code': 'ar-ly', 'name': 'Arabic (Libya)' }, { 'code': 'ar-ma', 'name': 'Arabic (Morocco)' }, { 'code': 'ar-sa', 'name': 'Arabic (Saudi Arabia)' }, { 'code': 'ar-tn', 'name': 'Arabic (Tunisia)' }, { 'code': 'ar', 'name': 'Arabic', 'nativeName': 'العربية' }, { 'code': 'bg', 'name': 'Bulgarian', 'nativeName': 'български език' }, { 'code': 'ca', 'name': 'Catalan; Valencian', 'nativeName': 'Català' }, { 'code': 'cs', 'name': 'Czech', 'nativeName': 'česky, čeština' }, { 'code': 'da', 'name': 'Danish', 'nativeName': 'dansk' }, { 'code': 'de-at', 'name': 'German (Austria)', 'nativeName': 'Deutsch (Österreich)' }, { 'code': 'de-ch', 'name': 'German (Switzerland)', 'nativeName': 'Deutsch (Schweiz)' }, { 'code': 'de', 'name': 'German', 'nativeName': 'Deutsch' }, { 'code': 'el', 'name': 'Greek, Modern', 'nativeName': 'Ελληνικά' }, { 'code': 'en-au', 'name': 'English (Australia)' }, { 'code': 'en-ca', 'name': 'English (Canada)' }, { 'code': 'en-gb', 'name': 'English (United Kingdom)' }, { 'code': 'en-ie', 'name': 'English (Ireland)' }, { 'code': 'en-nz', 'name': 'English (New Zealand)' }, { 'code': 'es-do', 'name': 'Spanish (Dominican Republic)' }, { 'code': 'es-us', 'name': 'Spanish (American)' }, { 'code': 'es', 'name': 'Spanish; Castilian', 'nativeName': 'español, castellano' }, { 'code': 'et', 'name': 'Estonian', 'nativeName': 'eesti, eesti keel' }, { 'code': 'fa', 'name': 'Persian', 'nativeName': 'فارسی' }, { 'code': 'fi', 'name': 'Finnish', 'nativeName': 'suomi, suomen kieli' }, { 'code': 'fr-ca', 'name': 'French (Canadian)', 'nativeName': 'français (Swiss)' }, { 'code': 'fr-ch', 'name': 'French (Switzerland)', 'nativeName': 'français (Swiss)' }, { 'code': 'fr', 'name': 'French', 'nativeName': 'français, langue française' }, { 'code': 'he', 'name': 'Hebrew (modern)', 'nativeName': 'עברית' }, { 'code': 'hi', 'name': 'Hindi', 'nativeName': 'हिन्दी, हिंदी' }, { 'code': 'hr', 'name': 'Croatian', 'nativeName': 'hrvatski' }, { 'code': 'hu', 'name': 'Hungarian', 'nativeName': 'Magyar' }, { 'code': 'id', 'name': 'Indonesian', 'nativeName': 'Bahasa Indonesia' }, { 'code': 'it', 'name': 'Italian', 'nativeName': 'Italiano' }, { 'code': 'ja', 'name': 'Japanese', 'nativeName': '日本語 (にほんご／にっぽんご)' }, { 'code': 'ko', 'name': 'Korean', 'nativeName': '한국어 (韓國語), 조선말 (朝鮮語)' }, { 'code': 'lt', 'name': 'Lithuanian', 'nativeName': 'lietuvių kalba' }, { 'code': 'lv', 'name': 'Latvian', 'nativeName': 'latviešu valoda' }, { 'code': 'ms-my', 'name': 'Malay (Malaysia)', 'nativeName': 'bahasa Melayu, بهاس ملايو‎' }, { 'code': 'ms', 'name': 'Malay', 'nativeName': 'bahasa Melayu, بهاس ملايو‎' }, { 'code': 'nb', 'name': 'Norwegian Bokmål', 'nativeName': 'Norsk bokmål' }, { 'code': 'nl-be', 'name': 'Belgian Dutch' }, { 'code': 'nl', 'name': 'Dutch', 'nativeName': 'Nederlands, Vlaams' }, { 'code': 'nn', 'name': 'Norwegian Nynorsk', 'nativeName': 'Norsk nynorsk' }, { 'code': 'pl', 'name': 'Polish', 'nativeName': 'polski' }, { 'code': 'pt-br', 'name': 'Brazilian Portuguese' }, { 'code': 'pt', 'name': 'Portuguese', 'nativeName': 'Português' }, { 'code': 'ro', 'name': 'Romanian, Moldavian, Moldovan', 'nativeName': 'română' }, { 'code': 'ru', 'name': 'Russian', 'nativeName': 'русский язык' }, { 'code': 'sk', 'name': 'Slovak', 'nativeName': 'slovenčina' }, { 'code': 'sl', 'name': 'Slovene', 'nativeName': 'slovenščina' }, { 'code': 'sr-cyrl', 'name': 'Serbian Cyrillic' }, { 'code': 'sr', 'name': 'Serbian', 'nativeName': 'српски језик' }, { 'code': 'sv', 'name': 'Swedish', 'nativeName': 'svenska' }, { 'code': 'th', 'name': 'Thai', 'nativeName': 'ไทย' }, { 'code': 'tr', 'name': 'Turkish', 'nativeName': 'Türkçe' }, { 'code': 'uk', 'name': 'Ukrainian', 'nativeName': 'українська' }, { 'code': 'vi', 'name': 'Vietnamese', 'nativeName': 'Tiếng Việt' }, { 'code': 'zh-cn', 'name': 'Mainland China' }, { 'code': 'zh-tw', 'name': 'Taiwan' }];
	exports.default = langs;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.constants = exports.__testing = undefined;
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.parsePastedTable = parsePastedTable;
	exports.buildCompetencyPayload = buildCompetencyPayload;
	exports.parseSubjectListPaste = parseSubjectListPaste;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SUBJECT_LEVEL_LINJEFAG = 'L';
	var SUBJECT_LEVEL_TILSVARENDE = 'K';
	var MAX_COMPETENCIES = 6;
	
	var SUBJECT_ALIASES = {
	  'religion': 'Kristendomskundskab/religion',
	  'kristendom': 'Kristendomskundskab',
	  'kristendomskundskab religion': 'Kristendomskundskab/religion',
	  'n/t': 'Natur/teknik',
	  'nt': 'Natur/teknik',
	  'natur og teknik': 'Natur/teknik',
	  'natur og teknologi': 'Natur/teknik',
	  'natur teknologi': 'Natur/teknik',
	  'natur/teknologi': 'Natur/teknik',
	  'natur teknik': 'Natur/teknik',
	  'fysik': 'Fysik/kemi',
	  'kemi': 'Fysik/kemi',
	  'fysik kemi': 'Fysik/kemi',
	  'haandarbejde': 'Håndarbejde',
	  'haandvaerk og design': 'Håndværk og design',
	  'sloejd': 'Sløjd',
	  'idraet': 'Idræt',
	  'boernehaveklasse': 'Børnehaveklasse',
	  'bhk': 'Børnehaveklasse',
	  'tysk valgfag': 'Tysk (valgfag)',
	  'tysk tilbudsfag': 'Tysk (tilbudsfag)',
	  'fransk valgfag': 'Fransk (valgfag)',
	  'fransk tilbudsfag': 'Fransk (tilbudsfag)'
	};
	
	function normalize(str) {
	  if (str === null || str === undefined) {
	    return '';
	  }
	  return String(str).replace(/\u00A0/g, ' ').trim().toLowerCase().replace(/\s+/g, ' ');
	}
	
	function stripQualifier(normalized) {
	  return normalized.replace(/\s*\([^)]*\)\s*$/g, '').trim();
	}
	
	function detectLevelSuffix(raw) {
	  var m = String(raw).match(/\((L|K|l|k)\)\s*$/);
	  if (m) {
	    return {
	      level: m[1].toUpperCase(),
	      stripped: raw.replace(/\s*\((L|K|l|k)\)\s*$/, '').trim()
	    };
	  }
	  return null;
	}
	
	function splitRowsAndCells(text) {
	  if (!text) {
	    return [];
	  }
	  var cleaned = String(text).replace(/^\uFEFF/, '').replace(/\r\n?/g, '\n');
	  var lines = cleaned.split('\n');
	  var rows = [];
	  lines.forEach(function (line) {
	    if (line.trim().length < 1) {
	      return;
	    }
	    var cells = line.split('\t').map(function (cell) {
	      return cell.trim();
	    });
	    rows.push(cells);
	  });
	  return rows;
	}
	
	function isHeaderRow(cells) {
	  if (cells.length < 1) {
	    return false;
	  }
	  var first = normalize(cells[0]);
	  return first === 'navn' || first === 'name' || first === 'lærer' || first === 'laerer';
	}
	
	function splitSubjectList(cell) {
	  if (!cell || cell.trim().length < 1) {
	    return [];
	  }
	  return cell.split(/[,;]/).map(function (s) {
	    return s.trim();
	  }).filter(function (s) {
	    return s.length > 0;
	  });
	}
	
	function buildSubjectIndex(standardSubjects) {
	  var byName = {};
	  var byStripped = {};
	  standardSubjects.forEach(function (subject) {
	    var normName = normalize(subject.name);
	    byName[normName] = subject;
	    var stripped = stripQualifier(normName);
	    if (!byStripped[stripped]) {
	      byStripped[stripped] = [];
	    }
	    byStripped[stripped].push(subject);
	  });
	  return { byName: byName, byStripped: byStripped };
	}
	
	function buildUserIndex(users) {
	  var byName = {};
	  users.forEach(function (user) {
	    var normName = normalize(user.name);
	    if (!byName[normName]) {
	      byName[normName] = [];
	    }
	    byName[normName].push(user);
	  });
	  return byName;
	}
	
	function matchUser(rawName, userIndex) {
	  var norm = normalize(rawName);
	  if (norm.length < 1) {
	    return { status: 'user_not_found', match: null, candidates: [] };
	  }
	  var exact = userIndex[norm];
	  if (exact && exact.length === 1) {
	    return { status: 'ok', match: exact[0], candidates: exact };
	  }
	  if (exact && exact.length > 1) {
	    return { status: 'user_multiple', match: null, candidates: exact };
	  }
	
	  var candidates = [];
	  (0, _keys2.default)(userIndex).forEach(function (key) {
	    if (key.indexOf(norm) > -1 || norm.indexOf(key) > -1) {
	      userIndex[key].forEach(function (u) {
	        return candidates.push(u);
	      });
	    }
	  });
	  if (candidates.length === 1) {
	    return { status: 'ok', match: candidates[0], candidates: candidates };
	  }
	  if (candidates.length > 1) {
	    return { status: 'user_multiple', match: null, candidates: candidates };
	  }
	  return { status: 'user_not_found', match: null, candidates: [] };
	}
	
	function matchSubject(rawSubject, defaultLevel, subjectIndex) {
	  var levelSuffix = detectLevelSuffix(rawSubject);
	  var queryRaw = rawSubject;
	  var level = defaultLevel;
	  if (levelSuffix) {
	    queryRaw = levelSuffix.stripped;
	    level = levelSuffix.level;
	  }
	  var norm = normalize(queryRaw);
	  var base = {
	    raw: rawSubject,
	    level: level,
	    status: 'subject_not_found',
	    match: null,
	    candidates: []
	  };
	  if (norm.length < 1) {
	    return base;
	  }
	
	  if (subjectIndex.byName[norm]) {
	    return (0, _assign2.default)(base, { status: 'ok', match: subjectIndex.byName[norm], candidates: [subjectIndex.byName[norm]] });
	  }
	
	  var aliasName = SUBJECT_ALIASES[norm];
	  if (aliasName) {
	    var aliased = subjectIndex.byName[normalize(aliasName)];
	    if (aliased) {
	      return (0, _assign2.default)(base, { status: 'ok', match: aliased, candidates: [aliased] });
	    }
	  }
	
	  var strippedNorm = stripQualifier(norm);
	  if (subjectIndex.byStripped[strippedNorm]) {
	    var list = subjectIndex.byStripped[strippedNorm];
	    if (list.length === 1) {
	      return (0, _assign2.default)(base, { status: 'ok', match: list[0], candidates: list });
	    }
	    return (0, _assign2.default)(base, { status: 'subject_multiple', match: null, candidates: list });
	  }
	  return base;
	}
	
	function parseRow(cells, defaults, userIndex, subjectIndex) {
	  var rawName = cells[0] || '';
	  var rawLinjefag = cells[1] || '';
	  var rawTilsvarende = cells[2] || '';
	
	  var userResult = matchUser(rawName, userIndex);
	
	  var linjefagItems = splitSubjectList(rawLinjefag).map(function (raw) {
	    return matchSubject(raw, SUBJECT_LEVEL_LINJEFAG, subjectIndex);
	  });
	  var tilsvarendeItems = splitSubjectList(rawTilsvarende).map(function (raw) {
	    return matchSubject(raw, SUBJECT_LEVEL_TILSVARENDE, subjectIndex);
	  });
	  var subjects = linjefagItems.concat(tilsvarendeItems);
	
	  var overLimit = subjects.length > MAX_COMPETENCIES;
	  var hasSubjectIssue = subjects.some(function (s) {
	    return s.status !== 'ok';
	  });
	  var isAmbiguous = userResult.status !== 'ok' || hasSubjectIssue || overLimit;
	
	  return {
	    rawName: rawName,
	    rawLinjefag: rawLinjefag,
	    rawTilsvarende: rawTilsvarende,
	    user: userResult,
	    subjects: subjects,
	    overLimit: overLimit,
	    isAmbiguous: isAmbiguous,
	    status: 'pending',
	    error: null
	  };
	}
	
	function parsePastedTable(text, users, standardSubjects) {
	  var rawRows = splitRowsAndCells(text);
	  if (rawRows.length < 1) {
	    return [];
	  }
	  var startIdx = isHeaderRow(rawRows[0]) ? 1 : 0;
	  var userIndex = buildUserIndex(users || []);
	  var subjectIndex = buildSubjectIndex(standardSubjects || []);
	  var dataRows = rawRows.slice(startIdx);
	  var rows = [];
	  dataRows.forEach(function (cells) {
	    if (cells.length < 1 || cells.every(function (c) {
	      return c.length < 1;
	    })) {
	      return;
	    }
	    rows.push(parseRow(cells, null, userIndex, subjectIndex));
	  });
	  return rows;
	}
	
	function buildCompetencyPayload(row) {
	  var out = [];
	  row.subjects.forEach(function (subject) {
	    if (subject.status !== 'ok' || !subject.match) {
	      return;
	    }
	    if (subject.skipped) {
	      return;
	    }
	    out.push({
	      subject_code: subject.match.subject_code,
	      level: subject.level
	    });
	  });
	  return out;
	}
	
	function parseSubjectListPaste(text, defaultLevel, items) {
	  var parts = splitSubjectList(String(text || '').replace(/\r\n?/g, '\n').replace(/[\n\t]/g, ','));
	  var matched = [];
	  var notFound = [];
	  var ambiguous = [];
	
	  var indexed = items.map(function (item) {
	    var baseRaw = String(item.name).replace(/\s*\((L|K)\)\s*$/i, '').trim();
	    return {
	      item: item,
	      baseNormalized: normalize(baseRaw),
	      strippedNormalized: stripQualifier(normalize(baseRaw))
	    };
	  });
	
	  parts.forEach(function (rawPart) {
	    var trimmed = rawPart.trim();
	    if (trimmed.length < 1) {
	      return;
	    }
	    var levelSuffix = detectLevelSuffix(trimmed);
	    var queryRaw = trimmed;
	    var level = defaultLevel;
	    if (levelSuffix) {
	      queryRaw = levelSuffix.stripped;
	      level = levelSuffix.level;
	    }
	    var norm = normalize(queryRaw);
	    var aliasName = SUBJECT_ALIASES[norm];
	    var targets = [];
	    if (aliasName) {
	      targets.push(normalize(aliasName));
	    }
	    targets.push(norm);
	
	    var candidates = [];
	
	    targets.some(function (target) {
	      candidates = indexed.filter(function (entry) {
	        return entry.item.level === level && entry.baseNormalized === target;
	      });
	      return candidates.length > 0;
	    });
	
	    if (candidates.length < 1) {
	      var stripped = stripQualifier(norm);
	      candidates = indexed.filter(function (entry) {
	        return entry.item.level === level && entry.strippedNormalized === stripped;
	      });
	    }
	
	    if (candidates.length === 1) {
	      matched.push({ raw: trimmed, item: candidates[0].item });
	    } else if (candidates.length > 1) {
	      ambiguous.push({ raw: trimmed, candidates: candidates.map(function (c) {
	          return c.item;
	        }) });
	    } else {
	      notFound.push({ raw: trimmed });
	    }
	  });
	
	  return { matched: matched, notFound: notFound, ambiguous: ambiguous };
	}
	
	var __testing = exports.__testing = {
	  normalize: normalize,
	  stripQualifier: stripQualifier,
	  detectLevelSuffix: detectLevelSuffix,
	  splitRowsAndCells: splitRowsAndCells,
	  isHeaderRow: isHeaderRow,
	  splitSubjectList: splitSubjectList,
	  matchUser: matchUser,
	  matchSubject: matchSubject
	};
	
	var constants = exports.constants = {
	  SUBJECT_LEVEL_LINJEFAG: SUBJECT_LEVEL_LINJEFAG,
	  SUBJECT_LEVEL_TILSVARENDE: SUBJECT_LEVEL_TILSVARENDE,
	  MAX_COMPETENCIES: MAX_COMPETENCIES
	};

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueChartjs = __webpack_require__(331);
	
	var reactiveProp = _vueChartjs.mixins.reactiveProp;
	exports.default = {
	  extends: _vueChartjs.Line,
	  mixins: [reactiveProp],
	  props: ['options'],
	  mounted: function mounted() {
	    this.renderChart(this.chartData, this.options);
	  }
	};

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueChartjs = __webpack_require__(331);
	
	var reactiveProp = _vueChartjs.mixins.reactiveProp;
	exports.default = {
	  extends: _vueChartjs.Bar,
	  mixins: [reactiveProp],
	  props: ['options'],
	  mounted: function mounted() {
	    this.renderChart(this.chartData, this.options);
	  }
	};

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  inserted: function inserted(el, bindings, _ref) {
	    var context = _ref.context;
	
	    if (context.appendToBody) {
	      var _context$$refs$toggle = context.$refs.toggle.getBoundingClientRect(),
	          height = _context$$refs$toggle.height,
	          top = _context$$refs$toggle.top,
	          left = _context$$refs$toggle.left;
	
	      context.calculatePosition(el, context, {
	        width: context.$refs.toggle.clientWidth + 2 + 'px',
	        top: window.scrollY + top + height + 'px',
	        left: window.scrollX + left + 'px'
	      });
	      document.body.appendChild(el);
	    }
	  },
	  unbind: function unbind(el, bindings, vnode) {
	    if (vnode.context.appendToBody && el.parentNode) {
	      el.parentNode.removeChild(el);
	    }
	  }
	};

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(41);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _arrow = __webpack_require__(1705);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	var _AssignHours = __webpack_require__(335);
	
	var _AssignHours2 = _interopRequireDefault(_AssignHours);
	
	var _Buy = __webpack_require__(1457);
	
	var _Buy2 = _interopRequireDefault(_Buy);
	
	var _ColorPicker = __webpack_require__(68);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	var _CopyCalendar = __webpack_require__(344);
	
	var _CopyCalendar2 = _interopRequireDefault(_CopyCalendar);
	
	var _CreateKlasses = __webpack_require__(1473);
	
	var _CreateKlasses2 = _interopRequireDefault(_CreateKlasses);
	
	var _CreateRoomsButton = __webpack_require__(1475);
	
	var _CreateRoomsButton2 = _interopRequireDefault(_CreateRoomsButton);
	
	var _CreateUser = __webpack_require__(1477);
	
	var _CreateUser2 = _interopRequireDefault(_CreateUser);
	
	var _CreateUserButton = __webpack_require__(1478);
	
	var _CreateUserButton2 = _interopRequireDefault(_CreateUserButton);
	
	var _CreateUserButtonROR = __webpack_require__(1479);
	
	var _CreateUserButtonROR2 = _interopRequireDefault(_CreateUserButtonROR);
	
	var _DeleteDayOrWeek = __webpack_require__(352);
	
	var _DeleteDayOrWeek2 = _interopRequireDefault(_DeleteDayOrWeek);
	
	var _DeleteUserSettings = __webpack_require__(1701);
	
	var _DeleteUserSettings2 = _interopRequireDefault(_DeleteUserSettings);
	
	var _DirectDaySelector = __webpack_require__(152);
	
	var _DirectDaySelector2 = _interopRequireDefault(_DirectDaySelector);
	
	var _DropUp = __webpack_require__(413);
	
	var _DropUp2 = _interopRequireDefault(_DropUp);
	
	var _DSelectUsers = __webpack_require__(67);
	
	var _DSelectUsers2 = _interopRequireDefault(_DSelectUsers);
	
	var _Hello = __webpack_require__(360);
	
	var _Hello2 = _interopRequireDefault(_Hello);
	
	var _HoursShow = __webpack_require__(1518);
	
	var _HoursShow2 = _interopRequireDefault(_HoursShow);
	
	var _ListWithSearch = __webpack_require__(1521);
	
	var _ListWithSearch2 = _interopRequireDefault(_ListWithSearch);
	
	var _Login = __webpack_require__(1522);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Modal = __webpack_require__(363);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Notifications = __webpack_require__(1523);
	
	var _Notifications2 = _interopRequireDefault(_Notifications);
	
	var _PublicContainer = __webpack_require__(419);
	
	var _PublicContainer2 = _interopRequireDefault(_PublicContainer);
	
	var _RecentUsers = __webpack_require__(1536);
	
	var _RecentUsers2 = _interopRequireDefault(_RecentUsers);
	
	var _Dashboard = __webpack_require__(1595);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _SchoolSideMenu = __webpack_require__(1608);
	
	var _SchoolSideMenu2 = _interopRequireDefault(_SchoolSideMenu);
	
	var _sms = __webpack_require__(1558);
	
	var _sms2 = _interopRequireDefault(_sms);
	
	var _SetupWidget = __webpack_require__(1703);
	
	var _SetupWidget2 = _interopRequireDefault(_SetupWidget);
	
	var _OnboardArrowVacationDaySelector = __webpack_require__(1702);
	
	var _OnboardArrowVacationDaySelector2 = _interopRequireDefault(_OnboardArrowVacationDaySelector);
	
	var _SideNav = __webpack_require__(99);
	
	var _SideNav2 = _interopRequireDefault(_SideNav);
	
	var _Subs = __webpack_require__(1641);
	
	var _Subs2 = _interopRequireDefault(_Subs);
	
	var _Tagging = __webpack_require__(1662);
	
	var _Tagging2 = _interopRequireDefault(_Tagging);
	
	var _TimeChanger = __webpack_require__(31);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _TlTest = __webpack_require__(1675);
	
	var _TlTest2 = _interopRequireDefault(_TlTest);
	
	var _Manager = __webpack_require__(421);
	
	var _Manager2 = _interopRequireDefault(_Manager);
	
	var _PresenceUser = __webpack_require__(82);
	
	var _PresenceUser2 = _interopRequireDefault(_PresenceUser);
	
	var _VacationDaysSelector = __webpack_require__(153);
	
	var _VacationDaysSelector2 = _interopRequireDefault(_VacationDaysSelector);
	
	var _VideoGuides = __webpack_require__(1704);
	
	var _VideoGuides2 = _interopRequireDefault(_VideoGuides);
	
	var _DoYouTube = __webpack_require__(408);
	
	var _DoYouTube2 = _interopRequireDefault(_DoYouTube);
	
	var _EventChanges = __webpack_require__(136);
	
	var _EventChanges2 = _interopRequireDefault(_EventChanges);
	
	var _TeamCalendar = __webpack_require__(402);
	
	var _TeamCalendar2 = _interopRequireDefault(_TeamCalendar);
	
	var _BulkCreateSubjects = __webpack_require__(391);
	
	var _BulkCreateSubjects2 = _interopRequireDefault(_BulkCreateSubjects);
	
	var _SubjectsDistribution = __webpack_require__(1624);
	
	var _SubjectsDistribution2 = _interopRequireDefault(_SubjectsDistribution);
	
	var _QuillOnLesson = __webpack_require__(1535);
	
	var _QuillOnLesson2 = _interopRequireDefault(_QuillOnLesson);
	
	var _DeleteEventOnward = __webpack_require__(359);
	
	var _DeleteEventOnward2 = _interopRequireDefault(_DeleteEventOnward);
	
	var _CopyEvent = __webpack_require__(135);
	
	var _CopyEvent2 = _interopRequireDefault(_CopyEvent);
	
	var _CopyEventButton = __webpack_require__(1513);
	
	var _CopyEventButton2 = _interopRequireDefault(_CopyEventButton);
	
	var _ExportCalendar = __webpack_require__(97);
	
	var _ExportCalendar2 = _interopRequireDefault(_ExportCalendar);
	
	var _Permissions = __webpack_require__(1524);
	
	var _Permissions2 = _interopRequireDefault(_Permissions);
	
	var _CalendarView = __webpack_require__(1461);
	
	var _CalendarView2 = _interopRequireDefault(_CalendarView);
	
	var _CalendarsBulk = __webpack_require__(1463);
	
	var _CalendarsBulk2 = _interopRequireDefault(_CalendarsBulk);
	
	var _Employment = __webpack_require__(1559);
	
	var _Employment2 = _interopRequireDefault(_Employment);
	
	var _SalarySubsPerf = __webpack_require__(1580);
	
	var _SalarySubsPerf2 = _interopRequireDefault(_SalarySubsPerf);
	
	var _ZenImport = __webpack_require__(1690);
	
	var _ZenImport2 = _interopRequireDefault(_ZenImport);
	
	var _CreateCalendars = __webpack_require__(1472);
	
	var _CreateCalendars2 = _interopRequireDefault(_CreateCalendars);
	
	var _CreateSubject = __webpack_require__(384);
	
	var _CreateSubject2 = _interopRequireDefault(_CreateSubject);
	
	var _UserTasks = __webpack_require__(54);
	
	var _UserTasks2 = _interopRequireDefault(_UserTasks);
	
	var _TaskOverviewPage = __webpack_require__(147);
	
	var _TaskOverviewPage2 = _interopRequireDefault(_TaskOverviewPage);
	
	var _Print = __webpack_require__(98);
	
	var _Print2 = _interopRequireDefault(_Print);
	
	var _HelpIcon = __webpack_require__(1517);
	
	var _HelpIcon2 = _interopRequireDefault(_HelpIcon);
	
	var _Students = __webpack_require__(1615);
	
	var _Students2 = _interopRequireDefault(_Students);
	
	var _ExternalCalendars = __webpack_require__(1466);
	
	var _ExternalCalendars2 = _interopRequireDefault(_ExternalCalendars);
	
	var _ImportSubjectsToKlass = __webpack_require__(385);
	
	var _ImportSubjectsToKlass2 = _interopRequireDefault(_ImportSubjectsToKlass);
	
	var _OverviewToday = __webpack_require__(396);
	
	var _OverviewToday2 = _interopRequireDefault(_OverviewToday);
	
	var _SendMessages = __webpack_require__(370);
	
	var _SendMessages2 = _interopRequireDefault(_SendMessages);
	
	var _AnnualNorm = __webpack_require__(1439);
	
	var _AnnualNorm2 = _interopRequireDefault(_AnnualNorm);
	
	var _Profile = __webpack_require__(1532);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _DShowEventFullCal = __webpack_require__(1514);
	
	var _DShowEventFullCal2 = _interopRequireDefault(_DShowEventFullCal);
	
	var _DCalendarHeader = __webpack_require__(347);
	
	var _DCalendarHeader2 = _interopRequireDefault(_DCalendarHeader);
	
	var _DoCalendar = __webpack_require__(343);
	
	var _DoCalendar2 = _interopRequireDefault(_DoCalendar);
	
	var _Arbeidsplan = __webpack_require__(1443);
	
	var _Arbeidsplan2 = _interopRequireDefault(_Arbeidsplan);
	
	var _BasisOverview = __webpack_require__(1456);
	
	var _BasisOverview2 = _interopRequireDefault(_BasisOverview);
	
	var _DutySchedule = __webpack_require__(354);
	
	var _DutySchedule2 = _interopRequireDefault(_DutySchedule);
	
	var _RequestSubjects = __webpack_require__(1621);
	
	var _RequestSubjects2 = _interopRequireDefault(_RequestSubjects);
	
	var _AbsenceReasons = __webpack_require__(1436);
	
	var _AbsenceReasons2 = _interopRequireDefault(_AbsenceReasons);
	
	var _Reductions = __webpack_require__(1537);
	
	var _Reductions2 = _interopRequireDefault(_Reductions);
	
	var _Supplements = __webpack_require__(102);
	
	var _Supplements2 = _interopRequireDefault(_Supplements);
	
	var _UserRequestList = __webpack_require__(151);
	
	var _UserRequestList2 = _interopRequireDefault(_UserRequestList);
	
	var _Salary = __webpack_require__(139);
	
	var _Salary2 = _interopRequireDefault(_Salary);
	
	var _SpecialDays = __webpack_require__(1614);
	
	var _SpecialDays2 = _interopRequireDefault(_SpecialDays);
	
	var _SchoolUsers = __webpack_require__(1606);
	
	var _SchoolUsers2 = _interopRequireDefault(_SchoolUsers);
	
	var _Helpdesk = __webpack_require__(361);
	
	var _Helpdesk2 = _interopRequireDefault(_Helpdesk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(977);
	
	_vue2.default.component('assign-users-hours', _AssignHours2.default);
	_vue2.default.component('buy', _Buy2.default);
	_vue2.default.component('color-picker', _ColorPicker2.default);
	_vue2.default.component('copy-calendar', _CopyCalendar2.default);
	_vue2.default.component('copy-calendar', _CopyCalendar2.default);
	_vue2.default.component('create-klasses', _CreateKlasses2.default);
	_vue2.default.component('create-rooms-button', _CreateRoomsButton2.default);
	_vue2.default.component('create-users', _CreateUser2.default);
	_vue2.default.component('create-users-button', _CreateUserButton2.default);
	_vue2.default.component('create-users-button-ror', _CreateUserButtonROR2.default);
	_vue2.default.component('d-select-users', _DSelectUsers2.default);
	_vue2.default.component('delete-day-or-week', _DeleteDayOrWeek2.default);
	_vue2.default.component('delete-user-settings', _DeleteUserSettings2.default);
	_vue2.default.component('direct-day-selector', _DirectDaySelector2.default);
	_vue2.default.component('dropup', _DropUp2.default);
	_vue2.default.component('hello', _Hello2.default);
	_vue2.default.component('hours-show', _HoursShow2.default);
	_vue2.default.component('list-with-search', _ListWithSearch2.default);
	_vue2.default.component('login', _Login2.default);
	_vue2.default.component('modal', _Modal2.default);
	_vue2.default.component('notifications', _Notifications2.default);
	_vue2.default.component('onboarding-arrow', _arrow2.default);
	_vue2.default.component('public-view', _PublicContainer2.default);
	_vue2.default.component('recent-users', _RecentUsers2.default);
	_vue2.default.component('school-dashboard', _Dashboard2.default);
	_vue2.default.component('school-sidebar', _SchoolSideMenu2.default);
	_vue2.default.component('send-sms', _sms2.default);
	_vue2.default.component('setup-widget', _SetupWidget2.default);
	_vue2.default.component('setup-widget-arrow', _OnboardArrowVacationDaySelector2.default);
	_vue2.default.component('side-nav', _SideNav2.default);
	_vue2.default.component('substitution', _Subs2.default);
	_vue2.default.component('tagging', _Tagging2.default);
	_vue2.default.component('time-changer', _TimeChanger2.default);
	_vue2.default.component('tl-test', _TlTest2.default);
	_vue2.default.component('toasts', _Manager2.default);
	_vue2.default.component('toasts', _Manager2.default);
	_vue2.default.component('user-presence', _PresenceUser2.default);
	_vue2.default.component('vacation-days-selector', _VacationDaysSelector2.default);
	_vue2.default.component('video-guides', _VideoGuides2.default);
	_vue2.default.component('do-youtube', _DoYouTube2.default);
	_vue2.default.component('event-changes', _EventChanges2.default);
	_vue2.default.component('team-calendar', _TeamCalendar2.default);
	_vue2.default.component('bulk-create-subjects', _BulkCreateSubjects2.default);
	_vue2.default.component('subjects-distribution', _SubjectsDistribution2.default);
	_vue2.default.component('quill-on-lesson', _QuillOnLesson2.default);
	_vue2.default.component('delete-event-onward', _DeleteEventOnward2.default);
	_vue2.default.component('copy-event', _CopyEvent2.default);
	_vue2.default.component('copy-event-button', _CopyEventButton2.default);
	_vue2.default.component('export-calendar', _ExportCalendar2.default);
	_vue2.default.component('permissions', _Permissions2.default);
	_vue2.default.component('user-calendar', _CalendarView2.default);
	_vue2.default.component('calendars-bulk', _CalendarsBulk2.default);
	_vue2.default.component('employment', _Employment2.default);
	_vue2.default.component('salary', _SalarySubsPerf2.default);
	_vue2.default.component('zen-import', _ZenImport2.default);
	_vue2.default.component('create-calendars', _CreateCalendars2.default);
	_vue2.default.component('create-subject', _CreateSubject2.default);
	
	_vue2.default.component('user-tasks', _TaskOverviewPage2.default);
	_vue2.default.component('user-hours', _UserTasks2.default);
	_vue2.default.component('print-calendars', _Print2.default);
	_vue2.default.component('help-icon', _HelpIcon2.default);
	_vue2.default.component('students', _Students2.default);
	_vue2.default.component('external-calendars', _ExternalCalendars2.default);
	_vue2.default.component('import-subjects-to-klass', _ImportSubjectsToKlass2.default);
	_vue2.default.component('subs-today', _OverviewToday2.default);
	_vue2.default.component('send-messages', _SendMessages2.default);
	_vue2.default.component('annual-norm', _AnnualNorm2.default);
	_vue2.default.component('d-profile', _Profile2.default);
	_vue2.default.component('d-show-event-full-cal', _DShowEventFullCal2.default);
	_vue2.default.component('d-cal-header', _DCalendarHeader2.default);
	_vue2.default.component('do-calendar', _DoCalendar2.default);
	_vue2.default.component('work-time', _Arbeidsplan2.default);
	_vue2.default.component('basis-overview', _BasisOverview2.default);
	_vue2.default.component('duty-schedule', _DutySchedule2.default);
	_vue2.default.component('request-subjects', _RequestSubjects2.default);
	_vue2.default.component('absences', _AbsenceReasons2.default);
	_vue2.default.component('subject-reductions', _Reductions2.default);
	_vue2.default.component('supplements', _Supplements2.default);
	_vue2.default.component('user-request-list', _UserRequestList2.default);
	_vue2.default.component('salary-overview', _Salary2.default);
	_vue2.default.component('special-days', _SpecialDays2.default);
	_vue2.default.component('school-users', _SchoolUsers2.default);
	_vue2.default.component('helpdesk', _Helpdesk2.default);

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filters = {
	  capitalize: function capitalize(string) {
	    return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
	  },
	  L: function L(date) {
	    return (0, _moment2.default)(date).format('L');
	  },
	  LL: function LL(date) {
	    return (0, _moment2.default)(date).format('LL');
	  },
	  LT: function LT(date) {
	    return (0, _moment2.default)(date).format('LT');
	  },
	  ddd: function ddd(date) {
	    return (0, _moment2.default)(date).format('ddd');
	  },
	  dddd: function dddd(date) {
	    return (0, _moment2.default)(date).format('dddd');
	  },
	  D: function D(date) {
	    return (0, _moment2.default)(date).format('D');
	  },
	  date: function date(_date) {
	    return (0, _moment2.default)(_date).format('D. MMMM YYYY');
	  },
	  dateNoYear: function dateNoYear(date) {
	    return (0, _moment2.default)(date).format('dddd, LL');
	  },
	  dayOfWeek: function dayOfWeek(date, num) {
	    return (0, _moment2.default)(date).isoWeekday(num);
	  },
	  timeStamp: function timeStamp(value) {
	    return (0, _moment2.default)(value).format('LT');
	  },
	  fromNow: function fromNow(m) {
	    return m ? (0, _moment2.default)(m).fromNow() : '';
	  }
	};
	
	exports.default = filters;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userLocale = window.USER && window.USER.language ? window.USER.language : 'da';
	
	exports.default = {
	  install: function install(Vue) {
	    Vue.prototype.$helpers = {
	      konsol: function konsol(e) {
	        console.log('$helpers', e);
	      },
	      sortArrOnName: function sortArrOnName(arr) {
	        var usersWithoutSpecialCase = arr.filter(function (item) {
	          return item.name && !item.name.startsWith('(');
	        });
	        var usersSorted = usersWithoutSpecialCase.sort(function (a, b) {
	          return a.name.localeCompare(b.name, userLocale, {
	            numeric: true,
	            sensitivity: 'base'
	          });
	        });
	        var usersWithSpecialCharacters = arr.filter(function (item) {
	          return item.name && item.name.startsWith('(');
	        });
	        var usersWithSpecialCharactersSorted = usersWithSpecialCharacters.sort(function (a, b) {
	          return a.name.localeCompare(b.name, userLocale, {
	            numeric: true,
	            sensitivity: 'base'
	          });
	        });
	        return usersSorted.concat(usersWithSpecialCharactersSorted);
	      },
	      filterEventsOnDate: function filterEventsOnDate(events, date) {
	        return events.filter(function (event) {
	          return (0, _moment2.default)(event.start_time).format('YYYY-MM-DD') === (0, _moment2.default)(date).format('YYYY-MM-DD');
	        });
	      },
	      sortEventsOnDateTime: function sortEventsOnDateTime(events) {
	        var arr = events;
	        return arr.sort(function (a, b) {
	          return (0, _moment2.default)(a.start_time).unix() - (0, _moment2.default)(b.start_time).unix();
	        });
	      },
	      eventsSortedInDaysArray: function eventsSortedInDaysArray(events) {
	        return events.reduce(function (acc, curr, index) {
	          var val = (0, _moment2.default)(curr['start_time']).format('YYYY-MM-DD');
	          acc[val] = acc[val] || [];
	          acc[val].push(curr);
	          return acc;
	        }, {});
	      },
	      eventsPackedInDays: function eventsPackedInDays(events) {
	        return (0, _keys2.default)(events).map(function (e) {
	          return { date: e, events: events[e] };
	        });
	      },
	      checkUserDevice: function checkUserDevice() {
	        var isMobile = /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	        if (isMobile) {
	          return 'Mobile';
	        } else if (/iPad/i.test(navigator.userAgent)) {
	          return 'IPad';
	        } else {
	          return 'Desktop';
	        }
	      },
	      setSessionStorage: function setSessionStorage(name, val) {
	        try {
	          if (typeof Storage !== 'undefined') {
	            window.sessionStorage[name] = val;
	          }
	        } catch (e) {}
	      },
	      getSessionStorage: function getSessionStorage(name) {
	        try {
	          if (typeof Storage !== 'undefined') {
	            if (window.sessionStorage.getItem(name) !== null) {
	              return window.sessionStorage.getItem(name);
	            }
	          }
	        } catch (e) {}
	      },
	      setLocalStorage: function setLocalStorage(name, val) {
	        try {
	          if (typeof Storage !== 'undefined') {
	            window.localStorage.setItem(name, val);
	          }
	        } catch (e) {}
	      },
	      getLocalStorage: function getLocalStorage(name) {
	        try {
	          if (typeof Storage !== 'undefined') {
	            if (window.localStorage.getItem(name) !== null) {
	              return window.localStorage.getItem(name);
	            }
	          }
	        } catch (e) {}
	      },
	      removeLocalStorage: function removeLocalStorage(name) {
	        try {
	          if (typeof Storage !== 'undefined') {
	            if (window.localStorage.getItem(name) !== null) {
	              return window.localStorage.removeItem(name);
	            }
	          }
	        } catch (e) {}
	      },
	      getCookie: function getCookie(cname) {
	        var name = cname + '=';
	        var decodedCookie = decodeURIComponent(document.cookie);
	        var ca = decodedCookie.split(';');
	        for (var i = 0; i < ca.length; i++) {
	          var c = ca[i];
	          while (c.charAt(0) === ' ') {
	            c = c.substring(1);
	          }
	          if (c.indexOf(name) === 0) {
	            return c.substring(name.length, c.length);
	          }
	        }
	        return '';
	      },
	      setCookie: function setCookie(cname, cvalue) {
	        var days = 100;
	        var expires = '';
	        if (days) {
	          var date = new Date();
	          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	          expires = '; expires=' + date.toUTCString();
	        }
	        document.cookie = cname + '=' + (cvalue || '') + expires + '; path=/';
	      },
	      deleteCookie: function deleteCookie(cname) {
	        document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
	      },
	      sendCustomEvt: function sendCustomEvt(evtName, val) {
	        var evt = new window.CustomEvent(evtName, { detail: val });
	        window.dispatchEvent(evt);
	      },
	      hashMap: function hashMap(arr, key) {
	        var filteredArr = arr.filter(function (item) {
	          return item[key];
	        });
	        if (!key) {
	          return filteredArr.reduce(function (obj, item) {
	            obj[item.id] = item;
	            return obj;
	          }, {});
	        } else {
	          return filteredArr.reduce(function (obj, item) {
	            obj[item[key]] = item;
	            return obj;
	          }, {});
	        }
	      },
	      expandTimeRangeForEvents: function expandTimeRangeForEvents(startTime, endTime, events) {
	        var startHour = parseInt(String(startTime).slice(0, 2), 10);
	        var endHour = parseInt(String(endTime).slice(0, 2), 10);
	        var pad = function pad(n) {
	          return String(n).padStart(2, '0');
	        };
	        if (!Array.isArray(events)) {
	          return { startTime: startTime, endTime: endTime };
	        }
	        events.forEach(function (ev) {
	          if (!ev || !ev.start || !ev.end) return;
	          var start = (0, _moment2.default)(ev.start);
	          var end = (0, _moment2.default)(ev.end);
	          if (!start.isValid() || !end.isValid()) return;
	          var eventStartHour = start.hours();
	
	          var eventEndHour = end.hours() + (end.minutes() > 0 || end.seconds() > 0 ? 1 : 0);
	          if (eventStartHour < startHour) startHour = eventStartHour;
	          if (eventEndHour > endHour) endHour = eventEndHour;
	        });
	        startHour = Math.max(0, Math.min(startHour, 23));
	        endHour = Math.max(startHour, Math.min(endHour, 23));
	        return {
	          startTime: pad(startHour) + ':00:00',
	          endTime: pad(endHour) + ':00:00'
	        };
	      },
	      calcLessonsPerWeek: function calcLessonsPerWeek(hours, subjectDefaultDuration, schoolYearWeeks) {
	        if (!hours) return '0.0';
	        var total = Math.abs(hours);
	        var weeks = schoolYearWeeks != null && schoolYearWeeks > 0 ? schoolYearWeeks : 40;
	        var lessonsPerWeek = weeks * ((subjectDefaultDuration || 45) / 60);
	        var raw = total / lessonsPerWeek;
	        var rounded = Math.round(raw * 10) / 10;
	        var sign = hours < 0 ? '-' : '';
	        return sign + rounded.toFixed(1);
	      }
	    };
	  }
	};

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var da = __webpack_require__(1403);
	var da2 = __webpack_require__(1404);
	da.da.vue2 = da2;
	
	exports.default = da;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var en = __webpack_require__(1405);
	var en2 = __webpack_require__(1406);
	en.en.vue2 = en2;
	
	exports.default = en;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var no = __webpack_require__(1407);
	
	var no2 = __webpack_require__(1408);
	no.nb.vue2 = no2;
	
	exports.default = no;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(41);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _filters = __webpack_require__(431);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	__webpack_require__(430);
	
	var _vueRouter = __webpack_require__(2172);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueI18n = __webpack_require__(1433);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _store = __webpack_require__(437);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vueTouch = __webpack_require__(2173);
	
	var _vueTouch2 = _interopRequireDefault(_vueTouch);
	
	var _App = __webpack_require__(1434);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1409);
	
	var _generalHelpers = __webpack_require__(432);
	
	var _generalHelpers2 = _interopRequireDefault(_generalHelpers);
	
	var _ComponentViewer = __webpack_require__(1435);
	
	var _ComponentViewer2 = _interopRequireDefault(_ComponentViewer);
	
	var _vueObserveVisibility = __webpack_require__(2171);
	
	var _vueObserveVisibility2 = _interopRequireDefault(_vueObserveVisibility);
	
	var _Show = __webpack_require__(1607);
	
	var _Show2 = _interopRequireDefault(_Show);
	
	var _OverviewTodayAbsentPublic = __webpack_require__(1633);
	
	var _OverviewTodayAbsentPublic2 = _interopRequireDefault(_OverviewTodayAbsentPublic);
	
	var _PublicContainer = __webpack_require__(419);
	
	var _PublicContainer2 = _interopRequireDefault(_PublicContainer);
	
	var _vueYoutube = __webpack_require__(2174);
	
	var _vueYoutube2 = _interopRequireDefault(_vueYoutube);
	
	var _vueTippyMin = __webpack_require__(448);
	
	var _vueTippyMin2 = _interopRequireDefault(_vueTippyMin);
	
	var _GrundskoleIndberetning = __webpack_require__(1538);
	
	var _GrundskoleIndberetning2 = _interopRequireDefault(_GrundskoleIndberetning);
	
	var _Timetalsindberetning = __webpack_require__(1557);
	
	var _Timetalsindberetning2 = _interopRequireDefault(_Timetalsindberetning);
	
	var _SchoolData = __webpack_require__(1597);
	
	var _SchoolData2 = _interopRequireDefault(_SchoolData);
	
	var _ProfileSSN = __webpack_require__(1533);
	
	var _ProfileSSN2 = _interopRequireDefault(_ProfileSSN);
	
	var _KompetenceIndberetning = __webpack_require__(1544);
	
	var _KompetenceIndberetning2 = _interopRequireDefault(_KompetenceIndberetning);
	
	var _SchoolDataAbsence = __webpack_require__(1598);
	
	var _SchoolDataAbsence2 = _interopRequireDefault(_SchoolDataAbsence);
	
	var _DoCalendar = __webpack_require__(343);
	
	var _DoCalendar2 = _interopRequireDefault(_DoCalendar);
	
	var _SchoolDataSubsAbsenceType = __webpack_require__(1604);
	
	var _SchoolDataSubsAbsenceType2 = _interopRequireDefault(_SchoolDataSubsAbsenceType);
	
	var _SchoolDataCoverage = __webpack_require__(1600);
	
	var _SchoolDataCoverage2 = _interopRequireDefault(_SchoolDataCoverage);
	
	var _SchoolDataSubContinuity = __webpack_require__(1603);
	
	var _SchoolDataSubContinuity2 = _interopRequireDefault(_SchoolDataSubContinuity);
	
	var _SchoolDataAbsenceDuration = __webpack_require__(1599);
	
	var _SchoolDataAbsenceDuration2 = _interopRequireDefault(_SchoolDataAbsenceDuration);
	
	var _DutySchedule = __webpack_require__(354);
	
	var _DutySchedule2 = _interopRequireDefault(_DutySchedule);
	
	var _DoHeader = __webpack_require__(1500);
	
	var _DoHeader2 = _interopRequireDefault(_DoHeader);
	
	var _Substitution = __webpack_require__(1656);
	
	var _Substitution2 = _interopRequireDefault(_Substitution);
	
	var _Academy = __webpack_require__(1438);
	
	var _Academy2 = _interopRequireDefault(_Academy);
	
	var _Helpdesk = __webpack_require__(361);
	
	var _Helpdesk2 = _interopRequireDefault(_Helpdesk);
	
	var _Salary = __webpack_require__(139);
	
	var _Salary2 = _interopRequireDefault(_Salary);
	
	var _da = __webpack_require__(433);
	
	var _da2 = _interopRequireDefault(_da);
	
	var _nb = __webpack_require__(435);
	
	var _nb2 = _interopRequireDefault(_nb);
	
	var _en = __webpack_require__(434);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _SideNav = __webpack_require__(99);
	
	var _SideNav2 = _interopRequireDefault(_SideNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.prototype.$filters = _filters2.default;
	
	
	_vue2.default.use(_vueTippyMin2.default, {
	  directive: 'tippy',
	  popperOptions: {
	    modifiers: {
	      preventOverflow: {
	        enabled: false
	      }
	    }
	  }
	});
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_generalHelpers2.default);
	_vue2.default.use(_vueYoutube2.default);
	_vue2.default.use(_vueObserveVisibility2.default);
	
	_vue2.default.use(_vueTouch2.default, { name: 'v-touch' });
	
	var router = new _vueRouter2.default({
	  routes: [{
	    path: '/subs/:school_id', components: {
	      default: _Substitution2.default,
	      SideNav: _SideNav2.default,
	      Header: _DoHeader2.default
	    }
	  }, {
	    name: 'Plan',
	    path: '/plan/:school_id', components: {
	      default: _DutySchedule2.default,
	      SideNav: _SideNav2.default,
	      Header: _DoHeader2.default
	    }
	  }, { path: '/', component: _ComponentViewer2.default }, { path: '/public/:calendar_id', component: _PublicContainer2.default }, { path: '/public/substitutes_teachers_show/:school_uuid', component: _OverviewTodayAbsentPublic2.default }, { path: '/show', component: _Show2.default }, {
	    path: '/calendar/:calendar_id',
	    components: {
	      default: _DoCalendar2.default,
	      SideNav: _SideNav2.default,
	      Header: _DoHeader2.default
	    }
	  }, { path: '/dashboard/:school_id', component: _SchoolData2.default }, { path: '/dashboard/absence/:school_id', component: _SchoolDataAbsence2.default }, { path: '/dashboard/absence/subs/:school_id', component: _SchoolDataSubsAbsenceType2.default }, { path: '/dashboard/absence/duration/:school_id', component: _SchoolDataAbsenceDuration2.default }, { path: '/dashboard/coverage/:school_id', component: _SchoolDataCoverage2.default }, { path: '/dashboard/continuity/:school_id', component: _SchoolDataSubContinuity2.default }, {
	    path: '/grundskoleindberetning/:school_id',
	    components: {
	      default: _GrundskoleIndberetning2.default
	    }
	  }, { path: '/timetalsindberetning/:school_id', component: _Timetalsindberetning2.default }, {
	    path: '/kompetenceindberetning/:school_id',
	    components: {
	      default: _KompetenceIndberetning2.default
	    }
	  }, {
	    path: '/users/:user_id',
	    components: {
	      default: _ProfileSSN2.default
	    }
	  }, { path: '/academy/:school_id', component: _Academy2.default }, { path: '/helpdesk', component: _Helpdesk2.default }, {
	    path: '/salary-overview/:school_id', components: {
	      default: _Salary2.default,
	      SideNav: _SideNav2.default,
	      Header: _DoHeader2.default
	    }
	  }]
	});
	
	_vue2.default.use(_vueI18n2.default);
	
	_vue2.default.prototype.$t = function (key) {
	  var i18n = this.$i18n;
	
	  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    values[_key - 1] = arguments[_key];
	  }
	
	  return i18n._t.apply(i18n, [key, i18n.locale, i18n._vm.messages, this].concat(values));
	};
	_vue2.default.prototype.$tc = function (key, choice) {
	  var i18n = this.$i18n;
	
	  for (var _len2 = arguments.length, values = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	    values[_key2 - 2] = arguments[_key2];
	  }
	
	  return i18n._tc.apply(i18n, [key, i18n.locale, i18n._vm.messages, this, choice].concat(values));
	};
	_vue2.default.prototype.$te = function (key, locale) {
	  var i18n = this.$i18n;
	  return i18n._te(key, i18n.locale, i18n._vm.messages, locale);
	};
	
	var fallBackTLD = 'en';
	if (window.location.host.indexOf('.dk') > -1) {
	  fallBackTLD = 'da';
	} else if (window.location.host.indexOf('.no') > -1) {
	  fallBackTLD = 'nb';
	}
	
	var i18n = new _vueI18n2.default({
	  locale: window.USER && window.USER.language ? window.USER.language : fallBackTLD,
	  fallbackLocale: fallBackTLD,
	  messages: {
	    da: _da2.default.da,
	    nb: _nb2.default.nb,
	    nn: _nb2.default.nb,
	    en: _en2.default.en
	  }
	});
	var userLocale = window.USER && window.USER.locale ? window.USER.locale : 'en';
	_moment2.default.locale(userLocale);
	
	window.use_i18n = i18n;
	window.use_vuex = _store2.default;
	
	var pageApp = new _vue2.default({
	  i18n: i18n,
	  store: _store2.default,
	  el: '#app',
	  router: router,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});
	
	exports.default = { pageApp: pageApp, router: router, i18n: i18n };

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(41);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(14);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _subs = __webpack_require__(444);
	
	var _subs2 = _interopRequireDefault(_subs);
	
	var _subjects = __webpack_require__(443);
	
	var _subjects2 = _interopRequireDefault(_subjects);
	
	var _employments = __webpack_require__(441);
	
	var _employments2 = _interopRequireDefault(_employments);
	
	var _flipper = __webpack_require__(442);
	
	var _flipper2 = _interopRequireDefault(_flipper);
	
	var _calendar = __webpack_require__(439);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _analytics = __webpack_require__(438);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _danishHolidays = __webpack_require__(440);
	
	var _danishHolidays2 = _interopRequireDefault(_danishHolidays);
	
	var _assignedPoolWhenPoolsDeactivated = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  user: null,
	  isDeviceMobile: false,
	  isUserLoaded: false,
	  userSettings: null,
	  schoolSettings: {},
	  isLoadingSchoolSettings: false,
	  activeSchool: window.SCHOOL ? window.SCHOOL : null,
	  allUsers: [],
	  isLoadingAllUsers: true,
	  calendars: [],
	  isLoadingSchoolCalenders: true,
	  schoolYears: [],
	  activeSchoolYears: [],
	  noActiveSchoolYears: false,
	  activatedSchoolYear: '',
	  localActivatedSchoolYear: '',
	  onboardingStep: 0,
	  selectedTags: [],
	  calendarRelations: [],
	  isLoadingCalendarRelations: true,
	  isUpdatingCalendars: false
	};
	
	var getters = {
	  locale: function locale(state) {
	    return state.user && state.user.locale ? state.user.locale : window.USER ? window.USER.language : 'en';
	  },
	  schoolId: function schoolId(state) {
	    return state.activeSchool ? state.activeSchool.id * 1 : window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id * 1 : null;
	  },
	  schoolYearId: function schoolYearId(state) {
	    return state.localActivatedSchoolYear ? state.localActivatedSchoolYear.id : null;
	  },
	  schoolCountry: function schoolCountry(state) {
	    return state.activeSchool && state.activeSchool.country ? state.activeSchool.country : window.SCHOOL && window.SCHOOL.country ? window.SCHOOL.country : 'DK';
	  },
	  isSchoolSystem: function isSchoolSystem(state) {
	    var school = state.activeSchool && state.activeSchool.state ? state.activeSchool : window.SCHOOL;
	    return !!school && school.state === 'system';
	  },
	  schoolFeatures: function schoolFeatures(state, getters, rootState) {
	    return state.activeSchool && state.activeSchool.features ? state.activeSchool.features : window.SCHOOL && window.SCHOOL.features ? window.SCHOOL.features : [];
	  },
	  salarySystem: function salarySystem() {
	    return state.activeSchool && state.activeSchool.salary_system ? state.activeSchool.salary_system : null;
	  },
	
	  isArbeidstidsplanActivated: function isArbeidstidsplanActivated(state) {
	    var features = state.activeSchool && state.activeSchool.features ? state.activeSchool.features : window.SCHOOL && window.SCHOOL.features ? window.SCHOOL.features : [];
	    return features.indexOf('work_time') > -1;
	  },
	  firstDayOfWeek: function firstDayOfWeek(state) {
	    return state.activeSchool && state.activeSchool.first_day_of_week_num !== undefined ? state.activeSchool.first_day_of_week_num : 1;
	  },
	  userSchools: function userSchools(state, getters, rootState, rootGetters) {
	    var schools = state.user && state.user.memberships ? state.user.memberships : [];
	    return schools.reduce(function (obj, item) {
	      obj[item.school_id] = item;
	      return obj;
	    }, {});
	  },
	  isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool(state) {
	    if (!state.user) {
	      return true;
	    }
	    if (state.user && state.user.admin) {
	      return false;
	    }
	    if (state.user && state.user.memberships) {
	      return state.user.current_school.authorize;
	    }
	  },
	  userPermissions: function userPermissions(state) {
	    if (state.user && state.user.memberships) {
	      var idx = state.user.memberships.findIndex(function (school) {
	        return school.school_id === state.activeSchool.id;
	      });
	      if (idx > -1) {
	        return state.user.memberships[idx].permissions;
	      } else {
	        return [];
	      }
	    } else {
	      return [];
	    }
	  },
	  usersSortedOnName: function usersSortedOnName(state) {
	    var users = state.allUsers.filter(function (user) {
	      return user.name !== null && user.name !== '';
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(users);
	  },
	  usersFilteredWithTags: function usersFilteredWithTags(state, getters) {
	    if (state.selectedTags.length < 1) {
	      return getters.usersSortedOnName;
	    }
	    return getters.usersSortedOnName.filter(function (user) {
	      return user.user_tags.some(function (tag) {
	        return state.selectedTags.indexOf(tag) >= 0;
	      });
	    });
	  },
	  allCalendarsInHash: function allCalendarsInHash(state, getters, rootState, rootGetters) {
	    var cals = state.calendars;
	    return cals.reduce(function (obj, item) {
	      obj[item.id] = item;
	      return obj;
	    }, {});
	  },
	  klassCalendars: function klassCalendars(state, getters) {
	    var klasses = state.calendars.filter(function (cal) {
	      return cal.type === 'klass' && cal.name !== null && cal.name !== '';
	    });
	    var klassesInActiveYear = klasses.filter(function (cal) {
	      return cal.school_year_id ? cal.school_year_id === state.localActivatedSchoolYear.id : cal.year === state.localActivatedSchoolYear.name;
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(klassesInActiveYear);
	  },
	  userCalendars: function userCalendars(state, getters) {
	    var cals = state.calendars.filter(function (cal) {
	      return cal.type === 'user' && cal.name !== null && cal.name !== '';
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(cals);
	  },
	  roomCalendars: function roomCalendars(state, getters) {
	    var cals = state.calendars.filter(function (cal) {
	      return cal.type === 'room' && !cal.archived_at && cal.name !== null && cal.name !== '';
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(cals);
	  },
	  roomCalendarsInclArchived: function roomCalendarsInclArchived(state, getters) {
	    var cals = state.calendars.filter(function (cal) {
	      return cal.type === 'room' && cal.name !== null && cal.name !== '';
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(cals);
	  },
	  mergeCalendars: function mergeCalendars(state, getters) {
	    var cals = state.calendars.filter(function (cal) {
	      return cal.type === 'merge' && cal.name !== '' && !cal.archived_at;
	    });
	    var calsInActiveYear = cals.filter(function (cal) {
	      return !cal.school_year_id || cal.school_year_id === state.localActivatedSchoolYear.id;
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(calsInActiveYear);
	  },
	  mergeCalendarsInclArchived: function mergeCalendarsInclArchived(state, getters) {
	    var cals = state.calendars.filter(function (cal) {
	      return cal.type === 'merge';
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(cals);
	  },
	  otherCalendars: function otherCalendars(state, getters) {
	    var otherCals = state.calendars.filter(function (cal) {
	      return cal.type === 'other' && cal.name !== '';
	    });
	    var otherCalsInActiveYear = otherCals.filter(function (cal) {
	      return cal.school_year_id ? cal.school_year_id === state.localActivatedSchoolYear.id : cal.year === state.localActivatedSchoolYear.name;
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(otherCalsInActiveYear);
	  },
	  clubCalendars: function clubCalendars(state, getters) {
	    var clubCals = state.calendars.filter(function (cal) {
	      return cal.type === 'club' && cal.name !== '';
	    });
	    var clubCalsInActiveYear = clubCals.filter(function (cal) {
	      return cal.school_year_id ? cal.school_year_id === state.localActivatedSchoolYear.id : cal.year === state.localActivatedSchoolYear.name;
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(clubCalsInActiveYear);
	  },
	  allStudentCalendars: function allStudentCalendars(state, getters) {
	    var cals = state.calendars.filter(function (cal) {
	      return cal.type === 'student' && cal.name !== '';
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(cals);
	  },
	  studentCalendars: function studentCalendars(state, getters) {
	    return getters.allStudentCalendars.filter(function (cal) {
	      return !cal.archived_at;
	    });
	  },
	  kindergartenCalendars: function kindergartenCalendars(state, getters) {
	    var cals = state.calendars.filter(function (cal) {
	      return cal.type === 'kindergarten' && cal.name !== '';
	    });
	    var calsInActiveYear = cals.filter(function (cal) {
	      return cal.school_year_id ? cal.school_year_id === state.localActivatedSchoolYear.id : cal.year === state.localActivatedSchoolYear.name;
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(calsInActiveYear);
	  },
	  allKlassCalendarsInHash: function allKlassCalendarsInHash(state, getters) {
	    var cals = state.calendars.filter(function (cal) {
	      return cal.type === 'klass';
	    });
	    var newCals = cals.reduce(function (obj, item) {
	      obj[item.id] = item;
	      return obj;
	    }, {});
	    return newCals;
	  },
	  allUsersInCalIdHash: function allUsersInCalIdHash(state, getters) {
	    return state.allUsers.reduce(function (obj, item) {
	      obj[item.user_calendar_id] = item;
	      return obj;
	    }, {});
	  },
	
	  allUsersInHash: function allUsersInHash(state) {
	    return state.allUsers.reduce(function (obj, item) {
	      obj[item.id] = item;
	      return obj;
	    }, {});
	  },
	  hiddenTaskDistributionCategories: function hiddenTaskDistributionCategories(state) {
	    return state.schoolSettings && state.schoolSettings.hiddenTaskDistributionCategories ? state.schoolSettings.hiddenTaskDistributionCategories : [];
	  },
	  shownOwnPools: function shownOwnPools(state) {
	    return state.schoolSettings && state.schoolSettings.shownOwnPools ? state.schoolSettings.shownOwnPools : [];
	  },
	  canConfigureAssignedPoolNormWhenPoolsDeactivated: function canConfigureAssignedPoolNormWhenPoolsDeactivated(state, getters) {
	    return (0, _assignedPoolWhenPoolsDeactivated.schoolCanConfigureAssignedPoolNormWhenPoolsDeactivated)(getters.schoolId);
	  },
	  isAssignedPoolFromNormWhenPoolsDeactivated: function isAssignedPoolFromNormWhenPoolsDeactivated(state) {
	    return (0, _assignedPoolWhenPoolsDeactivated.isAssignedPoolFromNormWhenPoolsDeactivated)(state.schoolSettings);
	  },
	  localPoolTitle: function localPoolTitle(state) {
	    if (!state.schoolSettings || !state.schoolSettings.localPoolTitle) {
	      return null;
	    }
	    if (typeof state.schoolSettings.localPoolTitle !== 'string') {
	      return state.schoolSettings.localPoolTitle;
	    }
	    var trimmed = state.schoolSettings.localPoolTitle.trim();
	    return trimmed.length > 0 ? trimmed : null;
	  },
	  standardSubjectCodes: function standardSubjectCodes() {
	    return [{ subject_code: 110, fagkode: '110', name: 'Dansk' }, { subject_code: 120, fagkode: '120', name: 'Engelsk' }, { subject_code: 130, fagkode: '130', name: 'Tysk (tilbudsfag)' }, { subject_code: 134, fagkode: '134', name: 'Tysk (valgfag)' }, { subject_code: 140, fagkode: '140', name: 'Fransk (tilbudsfag)' }, { subject_code: 144, fagkode: '144', name: 'Fransk (valgfag)' }, { subject_code: 170, fagkode: '170', name: 'Kristendomskundskab' }, { subject_code: 171, fagkode: '171', name: 'Kristendomskundskab/religion' }, { subject_code: 181, fagkode: '181', name: 'Historie' }, { subject_code: 182, fagkode: '182', name: 'Samfundsfag' }, { subject_code: 210, fagkode: '210', name: 'Idræt' }, { subject_code: 220, fagkode: '220', name: 'Musik' }, { subject_code: 230, fagkode: '230', name: 'Billedkunst' }, { subject_code: 240, fagkode: '240', name: 'Håndarbejde' }, { subject_code: 245, fagkode: '245', name: 'Håndværk og design' }, { subject_code: 250, fagkode: '250', name: 'Sløjd' }, { subject_code: 260, fagkode: '260', name: 'Madkundskab' }, { subject_code: 310, fagkode: '310', name: 'Matematik' }, { subject_code: 320, fagkode: '320', name: 'Fysik/kemi' }, { subject_code: 330, fagkode: '330', name: 'Geografi' }, { subject_code: 340, fagkode: '340', name: 'Biologi' }, { subject_code: 350, fagkode: '350', name: 'Natur/teknik' }, { subject_code: 511, fagkode: '511', name: 'Praktisk/Musisk valgfag: Håndværk/design' }, { subject_code: 520, fagkode: '520', name: 'Praktisk/Musisk valgfag: Musik' }, { subject_code: 531, fagkode: '531', name: 'Praktisk/Musisk valgfag: Billedkunst' }, { subject_code: 540, fagkode: '540', name: 'Praktisk/Musisk valgfag: Madkundskab' }, { subject_code: 600, fagkode: '600', name: 'Børnehaveklasse' }];
	  },
	  userTagsWithoutPrepFactor: function userTagsWithoutPrepFactor(state, getters) {
	    return state.schoolSettings.pedagogicalGroups ? state.schoolSettings.pedagogicalGroups : [];
	  },
	  userTagsForSumWorkHours: function userTagsForSumWorkHours(state) {
	    return state.schoolSettings.workHoursSumGroups ? state.schoolSettings.workHoursSumGroups : [];
	  }
	};
	
	var mutations = {
	  setIsUserLoaded: function setIsUserLoaded(state, boolean) {
	    state.isUserLoaded = boolean;
	  },
	  setSelectedTags: function setSelectedTags(state, tag) {
	    if (state.selectedTags.indexOf(tag) < 0) {
	      state.selectedTags.push(tag);
	    } else {
	      state.selectedTags.splice(state.selectedTags.indexOf(tag), 1);
	    }
	  },
	  setUser: function setUser(state, data) {
	    state.user = data;
	  },
	  updateUserProp: function updateUserProp(state, data) {
	    var prop = data.prop;
	    state.user[prop] = data[prop];
	  },
	  setIsDeviceMobile: function setIsDeviceMobile(state, boolean) {
	    state.isDeviceMobile = boolean;
	  },
	  setUserSettings: function setUserSettings(state, data) {
	    state.userSettings = JSON.parse(data);
	  },
	  setSchoolSettings: function setSchoolSettings(state, data) {
	    var parsedData = void 0;
	    try {
	      parsedData = data && data.settings ? data.settings : data;
	    } catch (err) {
	      parsedData = data;
	      console.error(err.message, err);
	    }
	    state.schoolSettings = parsedData;
	  },
	  updateSchoolUser: function updateSchoolUser(state, data) {
	    var idx = state.allUsers.findIndex(function (user) {
	      return user.id === data.id;
	    });
	    _vue2.default.set(state.allUsers, idx, data);
	  },
	  updatePropOnSchoolUser: function updatePropOnSchoolUser(state, data) {
	    var prop = data.prop;
	    var idx = state.allUsers.findIndex(function (user) {
	      return user.id === data.userId;
	    });
	    state.allUsers[idx][prop] = data[prop];
	  },
	  setActiveSchool: function setActiveSchool(state, data) {
	    state.activeSchool = data;
	  },
	  updateActiveSchoolDuration: function updateActiveSchoolDuration(state, subjectDefaultDuration) {
	    state.activeSchool.subject_default_duration = subjectDefaultDuration;
	  },
	  setCalendars: function setCalendars(state, data) {
	    state.calendars = data;
	  },
	  updateCalendars: function updateCalendars(state, calendars) {
	    calendars.forEach(function (calendar) {
	      var idx = state.calendars.findIndex(function (cal) {
	        return cal.id === calendar.id;
	      });
	      _vue2.default.set(state.calendars, idx, calendar);
	    });
	  },
	  updatePropsOnCalendars: function updatePropsOnCalendars(state, updatedCalendars) {
	    var props = (0, _keys2.default)(updatedCalendars[0]);
	    updatedCalendars.forEach(function (calendar) {
	      var idx = state.calendars.findIndex(function (cal) {
	        return cal.id === calendar.calendar_id;
	      });
	      var updatedCalendar = state.calendars[idx];
	      props.forEach(function (propName) {
	        if (propName !== 'calendar_id') {
	          updatedCalendar[propName] = calendar[propName];
	        }
	      });
	      _vue2.default.set(state.calendars, idx, updatedCalendar);
	    });
	  },
	  setIsLoadingSchoolCalenders: function setIsLoadingSchoolCalenders(state, boolean) {
	    state.isLoadingSchoolCalenders = boolean;
	  },
	  setUsers: function setUsers(state, data) {
	    state.allUsers = data;
	  },
	  setIsLoadingAllUsers: function setIsLoadingAllUsers(state, boolean) {
	    state.isLoadingAllUsers = boolean;
	  },
	  setOnboardingStep: function setOnboardingStep(state, num) {
	    state.onboardingStep = num;
	  },
	  setSchoolYears: function setSchoolYears(state, data) {
	    state.schoolYears = data;
	    state.activeSchoolYears = data.filter(function (year) {
	      return year.active;
	    });
	    if (state.activeSchoolYears.length === 0) {
	      state.noActiveSchoolYears = true;
	    } else {
	      state.noActiveSchoolYears = false;
	    }
	  },
	  setlocalActivatedSchoolYear: function setlocalActivatedSchoolYear(state, schoolYearId) {
	    var idx = state.activeSchoolYears.map(function (e) {
	      return e.id;
	    }).indexOf(schoolYearId * 1);
	    var activeYearId = '';
	    if (idx > -1) {
	      state.localActivatedSchoolYear = state.activeSchoolYears[idx];
	      activeYearId = schoolYearId;
	    } else {
	      state.localActivatedSchoolYear = state.activeSchoolYears[0];
	      activeYearId = state.activeSchoolYears[0].id;
	    }
	    try {
	      if (typeof Storage !== 'undefined') {
	        window.localStorage.setItem('doActiveSchoolYearId', activeYearId);
	      }
	    } catch (e) {}
	  },
	  updateSchoolCalendar: function updateSchoolCalendar(state, updateObj) {
	    var idx = state.calendars.findIndex(function (calendar) {
	      return calendar.id === updateObj.id;
	    });
	    var updatedCalendar = state.calendars[idx];
	
	    updatedCalendar.name = updateObj.name;
	    updatedCalendar.archived_at = updateObj.archived_at;
	    updatedCalendar.custom_data = updateObj.custom_data;
	    _vue2.default.set(state.calendars, idx, updatedCalendar);
	  },
	  deleteSchoolCalendar: function deleteSchoolCalendar(state, calId) {
	    var idx = state.calendars.findIndex(function (calendar) {
	      return calendar.id === calId;
	    });
	    state.calendars.splice(idx, 1);
	  },
	  setRelations: function setRelations(state, data) {
	    state.calendarRelations = data;
	  },
	  updateRelations: function updateRelations(state, data) {
	    var idx = state.calendarRelations.findIndex(function (relations) {
	      return relations.id === data.id;
	    });
	    _vue2.default.set(state.calendarRelations, idx, data);
	  },
	  addRelation: function addRelation(state, data) {
	    state.calendarRelations.push(data);
	  },
	  deleteRelation: function deleteRelation(state, data) {
	    var idx = state.calendarRelations.findIndex(function (relations) {
	      return relations.id === data.id;
	    });
	    state.calendarRelations.splice(idx, 1);
	  }
	};
	
	var actions = {
	  trackEvent: function trackEvent(context, eventName) {
	    var schoolId = context.rootGetters.schoolId;
	    _docendo2.default.trackEvent(schoolId, eventName, function (success) {}, function (failure) {
	      console.log(failure);
	    });
	  },
	  getUser: function getUser(context) {
	    context.commit('setIsUserLoaded', false);
	    _docendo2.default.getUser(function (data) {
	      if (data.status === 'error') {
	        var pathUrl = window.location.href.replace(window.location.origin, '');
	        window.location.replace(data.redirect_to + '?return_to=' + encodeURIComponent(pathUrl));
	        return;
	      }
	      context.commit('setIsUserLoaded', true);
	      context.commit('setUser', data);
	      context.commit('setUserSettings', data.settings);
	    });
	  },
	  readSchoolSettings: function readSchoolSettings(context) {
	    var schoolId = context.state.activeSchool.id;
	    context.state.isLoadingSchoolSettings = true;
	    _docendo2.default.showSchool(schoolId, function (data) {
	      context.commit('setSchoolSettings', data.custom_data);
	      context.state.isLoadingSchoolSettings = false;
	    }, function (failure) {
	      console.log('failure');
	    });
	  },
	  readActiveSchool: function readActiveSchool(context, school) {
	    var schoolId = school.id;
	    _docendo2.default.showSchool(schoolId, function (data) {
	      context.commit('setActiveSchool', data);
	      context.commit('setSchoolSettings', data.custom_data);
	    }, function (failure) {
	      console.log('failure');
	    });
	  },
	  loadActiveSchool: function loadActiveSchool(context, school) {
	    var schoolId = school.id;
	    context.commit('setActiveSchool', school);
	    context.dispatch('getSchoolCalendars', schoolId);
	    context.dispatch('readSchoolYears', schoolId);
	    context.dispatch('getUsersFromSchoolId', schoolId);
	  },
	  updateUserSettings: function updateUserSettings(context, obj) {
	    var str = context.state.userSettings || {};
	    var prop = (0, _keys2.default)(obj)[0];
	    var val = obj[prop];
	    str[prop] = val;
	    _docendo2.default.updateUser({ settings: (0, _stringify2.default)(str) }, function (success) {
	      return context.commit('setUserSettings', success.settings);
	    });
	  },
	  deleteUserSetting: function deleteUserSetting(context, prop) {
	    var str = context.state.userSettings;
	    delete str[prop];
	    _docendo2.default.updateUser({ settings: (0, _stringify2.default)(str) }, function (success) {
	      context.commit('setUserSettings', success.settings);
	      _eventbus2.default.toast = { text: window.use_i18n.t('vue2.common.saved'), 'success': true };
	    });
	  },
	  updateSchoolSettings: function updateSchoolSettings(context, obj) {
	    var schoolId = context.state.activeSchool.id;
	    var settingsObj = (0, _extends3.default)({}, context.state.schoolSettings || {});
	
	    (0, _keys2.default)(obj).forEach(function (prop) {
	      var val = obj[prop];
	      if (val === null || val === undefined) {
	        if (settingsObj.hasOwnProperty(prop)) {
	          delete settingsObj[prop];
	        }
	      } else {
	        settingsObj[prop] = Array.isArray(val) ? val.slice() : val;
	      }
	    });
	
	    _docendo2.default.updateSchool(schoolId, { custom_data: { settings: settingsObj } }, function (success) {
	      context.commit('setSchoolSettings', success.custom_data);
	      _eventbus2.default.toast = { text: window.use_i18n.t('vue2.common.saved'), 'success': true };
	    }, function (failure) {
	      console.log({ failure: failure });
	    });
	  },
	  deleteSchoolSetting: function deleteSchoolSetting(context, prop) {
	    var schoolId = context.state.activeSchool.id;
	    var settingsObj = (0, _extends3.default)({}, context.state.schoolSettings || {});
	
	    if (settingsObj.hasOwnProperty(prop)) {
	      delete settingsObj[prop];
	    }
	    _docendo2.default.updateSchool(schoolId, { custom_data: { settings: settingsObj } }, function (success) {
	      context.commit('setSchoolSettings', success.custom_data);
	      _eventbus2.default.toast = { text: window.use_i18n.t('vue2.common.saved'), success: true };
	    }, function (failure) {
	      console.log({ failure: failure });
	    });
	  },
	  updateSchoolSettingsForSchoolYear: function updateSchoolSettingsForSchoolYear(context, saveObj) {
	    var schoolId = context.state.activeSchool.id;
	    var schoolYearId = context.state.localActivatedSchoolYear.id;
	    var settingsObj = context.state.schoolSettings;
	    var prop = (0, _keys2.default)(saveObj)[0];
	    var val = saveObj[prop];
	    var dataProp = 'school_year_' + schoolYearId;
	    if (settingsObj.hasOwnProperty(dataProp)) {
	      settingsObj[dataProp][prop] = val;
	    } else {
	      settingsObj[dataProp] = (0, _defineProperty3.default)({}, prop, val);
	    }
	
	    _docendo2.default.updateSchool(schoolId, { custom_data: { settings: settingsObj } }, function (success) {
	      return context.commit('setSchoolSettings', success.custom_data);
	    });
	  },
	  deleteSchoolSettingForSchoolYear: function deleteSchoolSettingForSchoolYear(context, prop) {
	    var schoolId = context.state.activeSchool.id;
	    var schoolYearId = context.state.localActivatedSchoolYear.id;
	    var settingsObj = context.state.schoolSettings;
	    var dataProp = 'school_year_' + schoolYearId;
	    if (settingsObj[dataProp] && settingsObj[dataProp][prop]) {
	      delete settingsObj[dataProp][prop];
	      if ((0, _keys2.default)(settingsObj[dataProp]).length === 0) {
	        delete settingsObj[dataProp];
	      }
	      _docendo2.default.updateSchool(schoolId, { custom_data: { settings: settingsObj } }, function (success) {
	        return context.commit('setSchoolSettings', success.custom_data);
	      });
	    }
	  },
	
	  getSchoolCalendars: function getSchoolCalendars(context, id) {
	    context.commit('setIsLoadingSchoolCalenders', true);
	    _docendo2.default.calendarsForSchool(id, function (data) {
	      context.commit('setCalendars', data);
	      context.commit('setIsLoadingSchoolCalenders', false);
	      context.dispatch('setCalendarRelations');
	    });
	  },
	  updateSchoolCalendars: function updateSchoolCalendars(context, calendars) {
	    context.state.isUpdatingCalendars = true;
	    _docendo2.default.schoolBulkUpdateCalendars(window.SCHOOL.id, calendars, function (success) {
	      context.commit('updatePropsOnCalendars', calendars);
	      context.state.isUpdatingCalendars = false;
	    }, function (failure) {
	      console.log('failure', failure);
	    });
	  },
	
	  getUsers: function getUsers(context, schoolId, userIdsFilter) {
	    context.commit('setIsLoadingAllUsers', true);
	    _docendo2.default.schoolUsers(window.SCHOOL.id, userIdsFilter, function (data) {
	      context.commit('setIsLoadingAllUsers', false);
	      if (data.status) {
	        return;
	      }
	      context.commit('setUsers', data);
	    });
	  },
	  getUsersFromSchoolId: function getUsersFromSchoolId(context, schoolId) {
	    context.commit('setIsLoadingAllUsers', true);
	    _docendo2.default.schoolUsers2(schoolId, function (data) {
	      context.commit('setIsLoadingAllUsers', false);
	      if (data.status) {
	        return;
	      }
	      context.commit('setUsers', data);
	    });
	  },
	  readSchoolYears: function readSchoolYears(context, schoolId) {
	    var activeSchoolId = null;
	    if (schoolId) {
	      activeSchoolId = schoolId;
	    } else {
	      activeSchoolId = window.SCHOOL.id;
	    }
	    _docendo2.default.schoolYearsRead(activeSchoolId, '', 'id', function (data) {
	      context.commit('setSchoolYears', data);
	      try {
	        if (typeof Storage !== 'undefined') {
	          if (window.localStorage.getItem('doActiveSchoolYearId') !== null) {
	            context.commit('setlocalActivatedSchoolYear', window.localStorage.getItem('doActiveSchoolYearId'));
	          } else {
	            var activeYears = context.state.activeSchoolYears;
	            context.commit('setlocalActivatedSchoolYear', activeYears[0].id);
	          }
	        }
	      } catch (e) {}
	    });
	  },
	  updateCalendar: function updateCalendar(context, calObj) {
	    _docendo2.default.schoolCalendarsUpdate(window.SCHOOL.id, calObj.calendarId, calObj.changes, function (success) {
	      var updateObj = {
	        id: success.id,
	        name: success.name,
	        archived_at: success.archived_at,
	        custom_data: {}
	      };
	      if (success.custom_data) {
	        updateObj['custom_data'] = success.custom_data;
	      }
	      context.commit('updateSchoolCalendar', updateObj);
	      _eventbus2.default.toast = { text: 'Calendar updated', 'success': true };
	    }, function (failure) {
	      console.log('failure', failure);
	    });
	  },
	  deleteCalendar: function deleteCalendar(context, calId) {
	    _eventbus2.default.toast = { text: 'Deleting calendar', 'success': false };
	    _docendo2.default.schoolCalendarsDelete(window.SCHOOL.id, calId, function (success) {
	      context.commit('deleteSchoolCalendar', calId);
	      _eventbus2.default.toast = { text: 'Calendar deleted', 'success': true };
	    }, function (failure) {
	      console.log('failure', failure);
	    });
	  },
	
	  readCalendarRelations: function readCalendarRelations(context) {
	    context.state.isLoadingCalendarRelations = true;
	    _docendo2.default.indexCalendarRelations(window.SCHOOL.id, function (data) {
	      context.commit('setRelations', data);
	      context.state.isLoadingCalendarRelations = false;
	      context.dispatch('setCalendarRelations');
	    }, function (failure) {
	      console.log('failed read relations');
	    });
	  },
	  createRelation: function createRelation(context, obj) {
	    _docendo2.default.createCalendarRelation(window.SCHOOL.id, obj.calendarId, obj.otherCalendarId, obj.relation, function (data) {
	      context.commit('addRelation', data);
	      context.dispatch('setCalendarRelations');
	    }, function (failure) {
	      console.log('failed to set relation');
	    });
	  },
	  deleteRelation: function deleteRelation(context, relationId) {
	    _docendo2.default.deleteCalendarRelation(window.SCHOOL.id, relationId, function (data) {
	      context.commit('deleteRelation', data);
	      context.dispatch('setCalendarRelations');
	    }, function (failure) {
	      console.log('failed to set relation');
	    });
	  },
	  setCalendarRelations: function setCalendarRelations(context) {
	    if (context.state.isLoadingSchoolCalenders || context.state.isLoadingCalendarRelations) {
	      return;
	    }
	    context.state.calendars.forEach(function (calendar) {
	      if (calendar.type === 'klass') {
	        var students = [];
	        context.state.calendarRelations.forEach(function (relation) {
	          if (relation.other_calendar_id === calendar.id) {
	            var idx = students.indexOf(relation.other_calendar_id);
	            if (idx < 0) {
	              students.push(relation.calendar_id);
	            }
	          }
	        });
	        _vue2.default.set(calendar, 'students', students);
	      }
	      if (calendar.type === 'student') {
	        var calRelations = [];
	        var klasses = [];
	        context.state.calendarRelations.forEach(function (relation) {
	          if (relation.calendar_id === calendar.id) {
	            var idx = klasses.indexOf(relation.calendar_id);
	            if (idx < 0) {
	              calRelations.push(relation);
	              klasses.push(relation.other_calendar_id);
	            }
	          }
	        });
	        _vue2.default.set(calendar, 'klasses', klasses);
	        _vue2.default.set(calendar, 'calRelations', calRelations);
	      }
	    });
	  }
	};
	exports.default = new _vuex2.default.Store({
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions,
	  modules: {
	    subs: _subs2.default,
	    subjects: _subjects2.default,
	    employments: _employments2.default,
	    flipper: _flipper2.default,
	    calendar: _calendar2.default,
	    analytics: _analytics2.default,
	    danishHolidays: _danishHolidays2.default
	  }
	});

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actions = {
	  analyticsOnVisitedCalendar: function analyticsOnVisitedCalendar(context) {
	    if (window.$crisp) {
	      window.$crisp.push(['set', 'session:event', [[['do_visited_calendar']]]]);
	    }
	  },
	  analyticsOnVisitedBuy: function analyticsOnVisitedBuy(context) {
	    if (window.$crisp) {
	      window.$crisp.push(['set', 'session:event', [[['do_visited_buy']]]]);
	    }
	  },
	  analyticsOnSubscribe: function analyticsOnSubscribe(context) {
	    if (window.$crisp) {
	      window.$crisp.push(['set', 'session:event', [[['do_subscribed']]]]);
	    }
	    if (window.fbq) {
	      window.fbq('track', 'Subscribe', {});
	    }
	  },
	  analyticsCopyCalender: function analyticsCopyCalender(context) {
	    if (window.$crisp) {
	      window.$crisp.push(['set', 'session:event', [[['do_visited_buy']]]]);
	    }
	  }
	};
	
	exports.default = {
	  actions: actions
	};

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _vue = __webpack_require__(41);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  calendarId: null,
	  calendar: null,
	  date: (0, _moment2.default)(),
	  subjects: [],
	  isSubjectsLoading: true,
	  isSubjectsLoadingTimer: null,
	  events: [],
	  isEventsLoading: false,
	  isEventsLoadingTimer: null,
	  activeEventId: null,
	  isDeletingEvent: false,
	  editSubject: null,
	  availabilityEvents: [],
	  isCmdKeyDown: false,
	  selectedEventIds: []
	};
	
	var getters = {
	  calendarStartDate: function calendarStartDate(state, getters, rootState, rootGetters) {
	    var firstDay = window.SCHOOL && window.SCHOOL.first_day_of_week_num ? window.SCHOOL.first_day_of_week_num : 1;
	    return (0, _moment2.default)(state.date).isoWeekday(firstDay).format('YYYY-MM-DD 00:00');
	  },
	  calendarEndDate: function calendarEndDate(state) {
	    var firstDay = window.SCHOOL && window.SCHOOL.first_day_of_week_num ? window.SCHOOL.first_day_of_week_num : 1;
	    var lastDay = firstDay + 6;
	    return (0, _moment2.default)(state.date).isoWeekday(lastDay).endOf('day');
	  },
	  activeCalendar: function activeCalendar(state, getters, rootState, rootGetters) {
	    return rootGetters.allCalendarsInHash[state.calendarId] ? rootGetters.allCalendarsInHash[state.calendarId] : state.calendar;
	  },
	  isUserCanEditCalendar: function isUserCanEditCalendar(state, getters, rootState, rootGetters) {
	    if (rootGetters.isPermissionsActivatedForSchool) {
	      return rootGetters.userPermissions.indexOf('can_do_most_stuff') > -1;
	    } else {
	      return true;
	    }
	  },
	
	  activeFullCalendarEvents: function activeFullCalendarEvents(state, getters) {
	    return state.events.map(function (event) {
	      if (event.event_type === 'presence') {
	        _vue2.default.set(event, 'display', 'background');
	        _vue2.default.set(event, 'rendering', 'background');
	        _vue2.default.set(event, 'className', 'fc-bgevent__presence');
	        return event;
	      }
	      var hasNotes = event.description.replace(/<(?:.|\n)*?>/gm, '') || event.notes_for_students.replace(/<(?:.|\n)*?>/gm, '') || event.teacher_notes.replace(/<(?:.|\n)*?>/gm, '') || event.learning_goal.replace(/<(?:.|\n)*?>/gm, '');
	      _vue2.default.set(event, 'has_notes', hasNotes);
	      return event;
	    });
	  },
	  activeFullCalendarEventsInHash: function activeFullCalendarEventsInHash(state, getters) {
	    return getters.activeFullCalendarEvents.reduce(function (obj, item) {
	      obj[item.event_id] = item;
	      return obj;
	    }, {});
	  },
	  activeCalendarEvent: function activeCalendarEvent(state) {
	    var idx = state.activeEventId ? state.events.findIndex(function (event) {
	      return event.event_id === state.activeEventId;
	    }) : -1;
	    return idx > -1 ? state.events[idx] : null;
	  },
	
	  isMultiSelectActive: function isMultiSelectActive(state) {
	    return state.isCmdKeyDown || state.selectedEventIds.length > 0;
	  },
	  selectedCalendarEvents: function selectedCalendarEvents(state) {
	    return state.events.filter(function (event) {
	      return state.selectedEventIds.indexOf(event.event_id) > -1;
	    });
	  }
	};
	
	var mutations = {
	  setActiveCalendarId: function setActiveCalendarId(state, calendarId) {
	    state.calendarId = calendarId;
	  },
	  setActiveCalendarDate: function setActiveCalendarDate(state, date) {
	    state.date = date;
	  },
	  addCalendarSubject: function addCalendarSubject(state, subject) {
	    state.subjects.push(subject);
	  },
	  setEditSubject: function setEditSubject(state, subject) {
	    state.editSubject = subject;
	  },
	  updateCalendarEvents: function updateCalendarEvents(state, updatedLessons) {
	    updatedLessons.updates.forEach(function (updatedLessonObj) {
	      if (updatedLessonObj.start_time && updatedLessonObj.end_time) {
	        var idx = state.events.findIndex(function (event) {
	          return event.event_id === updatedLessonObj.event_id;
	        });
	        var currentLesson = state.events[idx];
	
	        currentLesson.start = updatedLessonObj.start_time;
	        currentLesson.end = updatedLessonObj.end_time;
	        _vue2.default.set(state.events, idx, currentLesson);
	      }
	    });
	  },
	  updateEventId: function updateEventId(state, lesson) {
	    var idx = state.events.findIndex(function (event) {
	      return event.event_id === lesson.event_id;
	    });
	    if (idx < 0) {
	      var idxEventWithNoId = state.events.findIndex(function (event) {
	        return event.event_id === 'd_temp_id';
	      });
	      state.events[idxEventWithNoId].event_id = lesson.event_id;
	    }
	  },
	  addActiveCalendarEvent: function addActiveCalendarEvent(state, lesson) {
	    state.events.push(lesson);
	  },
	  deleteActiveCalendarEvent: function deleteActiveCalendarEvent(state, lesson) {
	    var idx = state.events.findIndex(function (event) {
	      return event.event_id === lesson.event_id;
	    });
	    if (idx > -1) {
	      state.events.splice(idx, 1);
	    }
	  },
	  updateActiveCalendarEventNote: function updateActiveCalendarEventNote(state, updateObj) {
	    var idx = state.events.findIndex(function (event) {
	      return event.event_id === updateObj.payload.id;
	    });
	    var updatedLesson = state.events[idx];
	
	    updatedLesson[updateObj.noteType] = updateObj.payload[updateObj.noteType];
	    _vue2.default.set(state.events, idx, updatedLesson);
	  },
	  setActiveCalendar: function setActiveCalendar(state, calendar) {
	    state.calendar = calendar;
	    state.calendarId = calendar.id;
	  },
	  setActiveCalendarEventId: function setActiveCalendarEventId(state, eventId) {
	    state.activeEventId = eventId;
	  },
	  setCmdKeyDown: function setCmdKeyDown(state, bool) {
	    state.isCmdKeyDown = bool;
	  },
	  toggleSelectedEventId: function toggleSelectedEventId(state, eventId) {
	    var idx = state.selectedEventIds.indexOf(eventId);
	    if (idx > -1) {
	      state.selectedEventIds.splice(idx, 1);
	    } else {
	      state.selectedEventIds.push(eventId);
	    }
	  },
	  setSelectedEventIds: function setSelectedEventIds(state, ids) {
	    state.selectedEventIds = ids;
	  },
	  clearSelectedEventIds: function clearSelectedEventIds(state) {
	    state.selectedEventIds = [];
	  }
	};
	
	var actions = {
	  readCalendar: function readCalendar(context, calendarId) {
	    _docendo2.default.calendar(calendarId, function (data) {
	      context.commit('setActiveCalendar', data);
	    }, function (failure) {
	      console.log('failure', failure);
	    });
	  },
	  readCalendarSubjects: function readCalendarSubjects(context, isNewCalendar) {
	    if (context.state.isSubjectsLoadingTimer) {
	      clearTimeout(context.state.isSubjectsLoadingTimer);
	    }
	    if (!isNewCalendar) {
	      context.state.isSubjectsLoadingTimer = setTimeout(function (_) {
	        context.state.isSubjectsLoading = true;
	      }, 2000);
	    } else {
	      context.state.subjects = [];
	      context.state.isSubjectsLoading = true;
	    }
	    if (!context.state.calendarId) {
	      return;
	    }
	    _docendo2.default.sidebar(context.state.calendarId, context.state.date, function (success) {
	      clearTimeout(context.state.isSubjectsLoadingTimer);
	      context.state.isSubjectsLoading = false;
	      context.state.subjects = success;
	    }, function (failure) {
	      console.log('something went wrong');
	    });
	  },
	
	  createCalendarSubject: function createCalendarSubject(context, subject) {
	    console.log('vuex1::createCalendarSubject', subject);
	
	    function checkIfActiveCalendarDateIsSameOrInBetweenSchoolYear(schoolYearId) {
	      var schoolYear = context.rootState.schoolYears.find(function (schoolYear) {
	        return schoolYear.id === schoolYearId;
	      });
	      var schoolCalendarType = context.rootGetters.allCalendarsInHash[subject.calendarId] ? context.rootGetters.allCalendarsInHash[subject.calendarId]['type'] : null;
	      if (!schoolYear || !schoolCalendarType) {
	        return true;
	      }
	      var startDate = (0, _moment2.default)(schoolYear.employee_time_start);
	      var endDate = (0, _moment2.default)(schoolYear.employee_time_end);
	      if (schoolCalendarType === 'klass') {
	        startDate = (0, _moment2.default)(schoolYear.student_time_start);
	        endDate = (0, _moment2.default)(schoolYear.student_time_end);
	      }
	      var activeDate = context.state.date;
	      var isBetweenOrSame = (0, _moment2.default)(activeDate).isSameOrBefore(endDate) && (0, _moment2.default)(activeDate).isSameOrAfter(startDate);
	      return isBetweenOrSame;
	    }
	
	    var schoolId = context.rootState.activeSchool.id;
	    var preparation = subject.preparation != null && subject.preparation !== '' ? subject.preparation : null;
	    var away = subject.away ? subject.away : false;
	    _docendo2.default.createSubject(subject.name, subject.color, subject.calendarId, subject.defaultDuration, preparation, subject.hours, subject.subjectType, schoolId, subject.schoolYearId, subject.calendarIds, subject.subjectCode, away, null, null, subject.taskOverview, function (data) {
	      if (checkIfActiveCalendarDateIsSameOrInBetweenSchoolYear(data.school_year_id)) {
	        context.commit('addCalendarSubject', data);
	      } else {
	        var explainerI18n = window.use_i18n.t('vue2.create_subject.subject_is_not_created_in_this_school_year');
	        _eventbus2.default.toast = { text: explainerI18n, success: false };
	      }
	    }, function (failure) {
	      console.log('failure');
	    });
	  },
	  deleteCalendarSubject: function deleteCalendarSubject(context, subject) {
	    _docendo2.default.deleteSubject(subject.id, subject.school_id, subject.school_year_id, function (data) {
	      context.dispatch('readCalendarSubjects');
	    }, function (failure) {
	      console.log('failure updated Topics');
	    });
	  },
	  updateCalendarSubject: function updateCalendarSubject(context, updatedSubject) {
	    console.log('vuex1::updatedSubject', updatedSubject);
	    var preparation = updatedSubject.preparation != null && updatedSubject.preparation !== '' ? updatedSubject.preparation : null;
	    var away = updatedSubject.away ? updatedSubject.away : true;
	    _docendo2.default.updateSubject(updatedSubject.id, updatedSubject.name, updatedSubject.color, updatedSubject.calendarId, updatedSubject.calendarIds, updatedSubject.defaultDuration, preparation, updatedSubject.hours, updatedSubject.subjectType, updatedSubject.schoolId, updatedSubject.schoolYearId, updatedSubject.subjectCode, away, false, null, null, updatedSubject.taskOverview, function (data) {
	      context.dispatch('readCalendarSubjects');
	    }, function (failure) {
	      console.log('failure');
	    });
	  },
	  readCalendarEvents: function readCalendarEvents(context, obj) {
	    context.state.isEventsLoading = true;
	    _docendo2.default.calendarEvents2(obj.calIds, obj.start, obj.end, null, function (data) {
	      context.state.isEventsLoading = false;
	      clearTimeout(context.state.isEventsLoadingTimer);
	      context.state.events = data.length > 0 ? JSON.parse(data) : [];
	      if (obj.andReadSubjects) {
	        context.dispatch('readCalendarSubjects');
	      }
	    }, function (failure) {
	      console.log('failure', failure);
	    });
	  },
	  createCalendarEvent: function createCalendarEvent(context, eventObj) {
	    var tempEventId = new Date().getTime();
	    _vue2.default.set(eventObj, 'event_id', tempEventId);
	    var calendarIds = [];
	    if (eventObj.calendars && Array.isArray(eventObj.calendars)) {
	      eventObj.calendars.filter(function (calendar) {
	        return calendar && calendar.calendar_type && calendar.calendar_type !== 'school';
	      }).forEach(function (calendar) {
	        return calendarIds.push(calendar.id);
	      });
	    }
	    if (calendarIds.indexOf(eventObj.calendar_id) < 0) {
	      calendarIds.push(eventObj.calendar_id);
	    }
	    context.commit('addActiveCalendarEvent', eventObj);
	    _docendo2.default.createEvent(eventObj.school_id, eventObj.calendar_id, calendarIds, eventObj.subject_id, eventObj.start, eventObj.end, eventObj.learning_goal, eventObj.description, eventObj.notes_for_students, eventObj.teacher_notes, function (success) {
	      if (success && success.status === 'error') {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      }
	      var calendarInfo = {
	        calIds: [context.state.calendarId],
	        start: context.getters.calendarStartDate,
	        end: context.getters.calendarEndDate
	      };
	      context.dispatch('readCalendarEvents', calendarInfo);
	      context.dispatch('readCalendarSubjects');
	    }, function (failure) {
	      _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	    });
	    console.log('createEVentVuex', eventObj);
	  },
	  createCalendarEvents: function createCalendarEvents(context, eventArr) {
	    eventArr.forEach(function (eventObj, key) {
	      var tempEventId = new Date().getTime() + eventObj.event_id;
	      _vue2.default.set(eventObj, 'event_id', tempEventId);
	      var calendarIds = [];
	      eventObj.calendars.forEach(function (calendar) {
	        return calendarIds.push(calendar.calendar_id);
	      });
	      if (calendarIds.indexOf(eventObj.calendar_id) < 0) {
	        calendarIds.push(eventObj.calendar_id);
	      }
	      context.commit('addActiveCalendarEvent', eventObj);
	      _docendo2.default.createEvent(eventObj.school_id, eventObj.calendar_id, calendarIds, eventObj.subject_id, eventObj.start, eventObj.end, eventObj.learning_goal, eventObj.description, eventObj.notes_for_students, eventObj.teacher_notes, function (success) {
	        if (success && success.status === 'error') {
	          _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	        }
	        var allDone = key + 1 === eventArr.length;
	        if (allDone) {
	          var calendarInfo = {
	            calIds: [context.state.calendarId],
	            start: context.getters.calendarStartDate,
	            end: context.getters.calendarEndDate
	          };
	          context.dispatch('readCalendarEvents', calendarInfo);
	          context.dispatch('readCalendarSubjects');
	        }
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      });
	    });
	  },
	  updateCalendarEventNotes: function updateCalendarEventNotes(context, updatedLesson) {
	    _docendo2.default.updateEvent(updatedLesson.schoolId, updatedLesson.eventId, updatedLesson.updates, function (success) {
	      if (success && success.status === 'error') {
	        console.log('failure', success);
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      }
	      var calendarInfo = {
	        calIds: [context.state.calendarId],
	        start: context.getters.calendarStartDate,
	        end: context.getters.calendarEndDate
	      };
	      context.dispatch('readCalendarEvents', calendarInfo);
	    }, function (failure) {
	      _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	    });
	  },
	  updateCalendarEvent: function updateCalendarEvent(context, updatedLesson) {
	    context.commit('updateCalendarEvents', updatedLesson);
	
	    _docendo2.default.updateEvents(updatedLesson.school_id, updatedLesson.updates, function (success) {
	      if (success && success.status === 'error') {
	        console.log('failure', success);
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      }
	      var calendarInfo = {
	        calIds: [context.state.calendarId],
	        start: context.getters.calendarStartDate,
	        end: context.getters.calendarEndDate
	      };
	      context.dispatch('readCalendarEvents', calendarInfo);
	      context.dispatch('readCalendarSubjects');
	    }, function (failure) {
	      _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	    });
	  },
	  deleteEvent: function deleteEvent(context, lesson) {
	    context.state.isDeletingEvent = true;
	    _docendo2.default.deleteEvent(lesson.school_id, lesson.event_id, function (success) {
	      context.state.isDeletingEvent = false;
	      context.commit('setActiveCalendarEventId', null);
	      context.commit('deleteActiveCalendarEvent', lesson);
	      context.dispatch('readCalendarSubjects');
	      if (_vue2.default.prototype.$helpers.getLocalStorage('do_dont_ask_delete_event')) {
	        var title = lesson.title ? lesson.title : 'The event';
	        var capitalize = function capitalize(s) {
	          return s && s[0].toUpperCase() + s.slice(1) || '';
	        };
	        var lessonTime = lesson.start && lesson.end ? capitalize((0, _moment2.default)(lesson.start).format('dddd LT')) + ' - ' + (0, _moment2.default)(lesson.end).format('LT') : '';
	        var isDeleted = window.use_i18n.t('vue2.common.is_deleted');
	        _eventbus2.default.toast = { text: title + ' ' + isDeleted + ' ' + lessonTime, success: true };
	      }
	    }, function (failure) {
	      _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	    });
	  },
	  readEventAvailability: function readEventAvailability(context, lesson) {
	    _docendo2.default.eventAvailability(lesson.calendarId, lesson.eventId, context.getters.calendarStartDate, context.getters.calendarEndDate, function (success) {
	      context.state.availabilityEvents = success.length > 0 ? JSON.parse(success) : [];
	    }, function (failure) {
	      _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	    });
	  },
	  readSubjectAvailability: function readSubjectAvailability(context, subject) {
	    _docendo2.default.subjectAvailability(subject.calendarId, subject.subjectId, context.getters.calendarStartDate, context.getters.calendarEndDate, function (success) {
	      context.state.availabilityEvents = success.length > 0 ? JSON.parse(success) : [];
	    }, function (failure) {
	      _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	    });
	  },
	  clearAvailability: function clearAvailability(context) {
	    context.state.availabilityEvents = [];
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  danishHolidays: ['01-01-2022', '10-04-2022', '14-04-2022', '15-04-2022', '17-04-2022', '18-04-2022', '13-05-2022', '26-05-2022', '05-06-2022', '06-06-2022', '05-06-2022', '24-12-2022', '25-12-2022', '26-12-2022', '31-12-2022', '01-01-2023', '02-04-2023', '06-04-2023', '07-04-2023', '09-04-2023', '10-04-2023', '05-05-2023', '18-05-2023', '28-05-2023', '29-05-2023', '24-12-2023', '25-12-2023', '26-12-2023', '31-12-2023', '01-01-2024', '24-03-2024', '28-03-2024', '29-03-2024', '31-03-2024', '01-04-2024', '09-05-2024', '19-05-2024', '20-05-2024', '25-12-2024', '26-12-2024', '01-01-2025', '17-04-2025', '18-04-2025', '21-04-2025', '29-05-2025', '09-06-2025', '25-12-2025', '26-12-2025', '01-01-2026', '02-04-2026', '03-04-2026', '06-04-2026', '14-05-2026', '25-05-2026', '25-12-2026', '26-12-2026', '01-01-2027', '25-03-2027', '26-03-2027', '29-03-2027', '06-05-2027', '17-05-2027', '25-12-2027', '26-12-2027', '01-01-2028', '13-04-2028', '14-04-2028', '17-04-2028', '25-05-2028', '25-12-2028', '26-12-2028']
	};
	
	var getters = {
	  holidaysWithinActiveSchoolYear: function holidaysWithinActiveSchoolYear(state) {
	    return function (startDate, endDate) {
	      var start = (0, _moment2.default)(startDate, 'YYYY-MM-DD');
	      var end = (0, _moment2.default)(endDate, 'YYYY-MM-DD');
	
	      return state.danishHolidays.filter(function (date) {
	        var mDate = (0, _moment2.default)(date, 'DD-MM-YYYY');
	        var isAfterStart = mDate.isSameOrAfter(start);
	        var isBeforeEnd = mDate.isSameOrBefore(end);
	        var isNotWeekend = mDate.isoWeekday() < 6;
	        return isAfterStart && isBeforeEnd && isNotWeekend;
	      });
	    };
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters
	};

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(51);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vue = __webpack_require__(41);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isCostCenterArchived(costCenter) {
	  return !!(costCenter && (costCenter.archived === true || costCenter.archived_at));
	}
	
	function decorateCostCenters(costCenters) {
	  return costCenters.slice().sort(function (a, b) {
	    var aName = a.name || '';
	    var bName = b.name || '';
	    return aName.localeCompare(bName, 'da-DK');
	  }).map(function (cc) {
	    return (0, _extends3.default)({}, cc, {
	      title: cc.name
	    });
	  });
	}
	
	function upsertCostCenter(state, costCenter) {
	  var idx = state.costCenters.findIndex(function (cc) {
	    return cc.id === costCenter.id;
	  });
	  if (idx > -1) {
	    _vue2.default.set(state.costCenters, idx, costCenter);
	  } else {
	    state.costCenters.push(costCenter);
	  }
	}
	
	var state = {
	  isLoadingEmploymentsTypesForSchool: false,
	  employmentsTypes: [],
	  employments: [],
	  isSubmitting: false,
	  isSubmittingUser: false,
	  salaryCodes: [],
	  isLoadingSalaryCodes: false,
	  employmentTemplates: [],
	  costCenters: [],
	  isLoadingCostCenters: false,
	  isUpdatingCostCenters: false,
	  absenceCodes: [],
	  isLoadingAbsenceCodes: false
	};
	
	var getters = {
	  absenceCodesSorted: function absenceCodesSorted(state) {
	    return state.absenceCodes;
	  },
	  costCenters: function costCenters(state) {
	    return decorateCostCenters(state.costCenters.filter(function (cc) {
	      return !isCostCenterArchived(cc);
	    }));
	  },
	  costCentersArchived: function costCentersArchived(state) {
	    return decorateCostCenters(state.costCenters.filter(function (cc) {
	      return isCostCenterArchived(cc);
	    }));
	  },
	  costCentersAll: function costCentersAll(state) {
	    return decorateCostCenters(state.costCenters);
	  },
	  employmentTemplatesSorted: function employmentTemplatesSorted(state) {
	    return state.employmentTemplates.slice().sort(function (a, b) {
	      if (a.manual_salary !== b.manual_salary) {
	        return a.manual_salary ? 1 : -1;
	      }
	
	      return a.title.localeCompare(b.title, 'da-DK');
	    });
	  },
	  schoolIdLocal: function schoolIdLocal(state, getters, rootState, rootGetters) {
	    return rootGetters.schoolId;
	  },
	  salaryCodesSorted: function salaryCodesSorted(state, getters) {
	    var isSd = getters.salarySystem === 'SD';
	    return state.salaryCodes.map(function (salaryCode) {
	      var name = salaryCode.name || '';
	      var vSupplementTitle = void 0;
	      if (isSd) {
	        var hasTillaegsnummer = salaryCode.tillaegsnummer != null && salaryCode.tillaegsnummer !== '';
	        var hasLoenart = salaryCode.loenart != null && salaryCode.loenart !== '';
	        var prefix = void 0;
	        if (hasTillaegsnummer && hasLoenart) {
	          prefix = salaryCode.tillaegsnummer + '-' + salaryCode.loenart;
	        } else if (hasTillaegsnummer) {
	          prefix = String(salaryCode.tillaegsnummer);
	        } else {
	          prefix = String(salaryCode.loenart);
	        }
	        vSupplementTitle = prefix + (name ? ' ' + name : '');
	      } else {
	        vSupplementTitle = salaryCode.loenart + ' - ' + name;
	      }
	      return (0, _extends3.default)({}, salaryCode, {
	        code: salaryCode.loenart,
	        vTitle: salaryCode.loenart + ' - ' + name,
	        vSupplementTitle: vSupplementTitle
	      });
	    }).sort(function (a, b) {
	      var byName = (a.name || '').localeCompare(b.name || '', 'da-DK', { sensitivity: 'base' });
	      if (byName !== 0) return byName;
	      return String(a.loenart || '').localeCompare(String(b.loenart || ''), 'da-DK', { numeric: true });
	    });
	  },
	
	  employmentTypesActive: function employmentTypesActive(state) {
	    return [].concat((0, _toConsumableArray3.default)(state.employmentsTypes)).sort(function (a, b) {
	      return a.localeCompare(b);
	    });
	  },
	  employmentToSelectForRules: function employmentToSelectForRules(state) {
	    var addArr = ['*Stillingen fra lektionen før*', '*Stillingen fra lektionen efter*'];
	
	    var sortedEmployments = state.employmentsTypes.slice().sort(function (a, b) {
	      return a.localeCompare(b);
	    });
	
	    var templateTitles = state.employmentTemplates.map(function (t) {
	      return t.title;
	    }).filter(function (title) {
	      return !sortedEmployments.includes(title);
	    });
	
	    var combined = [].concat((0, _toConsumableArray3.default)(sortedEmployments), (0, _toConsumableArray3.default)(templateTitles)).sort(function (a, b) {
	      return a.localeCompare(b);
	    });
	
	    return [].concat((0, _toConsumableArray3.default)(combined), addArr);
	  },
	  employmentTitles: function employmentTitles(state) {
	    var uniqueTitles = [];
	    state.employments.forEach(function (employment) {
	      var idx = uniqueTitles.findIndex(function (uniqueTitle) {
	        return uniqueTitle === employment.title;
	      });
	      if (idx < 0) {
	        uniqueTitles.push(employment.title);
	      }
	    });
	    return uniqueTitles;
	  },
	  allSalaryCodes: function allSalaryCodes(state) {
	    var uniqueSalaryCodes = [];
	    state.employmentsTypes.forEach(function (employmentType) {
	      employmentType.salary_codes.forEach(function (salaryCode) {
	        var idx = uniqueSalaryCodes.findIndex(function (uniqueSalaryCode) {
	          return uniqueSalaryCode.code === salaryCode.code;
	        });
	        if (idx < 0) {
	          uniqueSalaryCodes.push(salaryCode);
	        }
	      });
	    });
	    return uniqueSalaryCodes.sort(function (a, b) {
	      return a.title.localeCompare(b.title);
	    });
	  },
	  employmentsInEmploymentTypeHash: function employmentsInEmploymentTypeHash(state, data) {
	    var hash = {};
	    state.employments.forEach(function (employment) {
	      if (employment.employment_type_id) {
	        if (hash[employment.employment_type_id]) {
	          hash[employment.employment_type_id].push(employment.user_id);
	        } else {
	          hash[employment.employment_type_id] = [employment.user_id];
	        }
	      }
	    });
	    return hash;
	  },
	  employmentsInUserIdHash: function employmentsInUserIdHash(state, getters) {
	    var hash = {};
	    state.employments.forEach(function (employment) {
	      if (hash[employment.user_id]) {
	        hash[employment.user_id].push(employment);
	      } else {
	        hash[employment.user_id] = [employment];
	      }
	    });
	    return hash;
	  }
	};
	
	var mutations = {
	  isLoadingEmploymentsTypesForSchool: function isLoadingEmploymentsTypesForSchool(state, boolean) {
	    state.isLoadingEmploymentsTypesForSchool = boolean;
	  },
	  setEmployments: function setEmployments(state, data) {
	    state.employments = data;
	  },
	  setEmploymentsTypes: function setEmploymentsTypes(state, data) {
	    state.employmentsTypes = data;
	  },
	  updateEmploymentsType: function updateEmploymentsType(state, obj) {
	    var idx = state.employmentsTypes.findIndex(function (type) {
	      return type.id === obj.id;
	    });
	    _vue2.default.set(state.employmentsTypes, idx, obj);
	  },
	  addEmploymentsType: function addEmploymentsType(state, obj) {
	    state.employmentsTypes.push(obj);
	  },
	  deleteEmploymentsType: function deleteEmploymentsType(state, id) {
	    var idx = state.employmentsTypes.findIndex(function (type) {
	      return type.id === id;
	    });
	    state.employmentsTypes.splice(idx, 1);
	  },
	  setAbsenceCodes: function setAbsenceCodes(state, data) {
	    state.absenceCodes = data;
	  }
	};
	
	var actions = {
	  readAbsenceCodes: function readAbsenceCodes(context) {
	    var schoolId = context.getters.schoolIdLocal;
	    context.state.isLoadingAbsenceCodes = true;
	    _docendo2.default.listSilkeborgDataAbsenceCodes(schoolId, function (success) {
	      context.commit('setAbsenceCodes', success);
	      context.state.isLoadingAbsenceCodes = false;
	    }, function (failure) {
	      console.log('failed read absence codes');
	    });
	  },
	  readEmploymentTemplates: function readEmploymentTemplates(context, data) {
	    var schoolId = context.getters.schoolIdLocal;
	    _docendo2.default.employmentTemplatesForSchool(schoolId, function (success) {
	      context.state.employmentTemplates = success;
	    }, function (failure) {
	      console.log('failed!');
	    });
	  },
	  readSalaryCodes: function readSalaryCodes(context) {
	    context.state.isLoadingSalaryCodes = true;
	    var schoolId = context.getters.schoolIdLocal;
	    _docendo2.default.salaryCodes(schoolId, function (success) {
	      context.state.salaryCodes = success;
	      context.state.isLoadingSalaryCodes = false;
	    });
	  },
	  readEmploymentTypes: function readEmploymentTypes(context) {
	    var schoolId = context.rootGetters.schoolId;
	    context.commit('isLoadingEmploymentsTypesForSchool', true);
	    _docendo2.default.employmentTypesForSchool(schoolId, function (data) {
	      context.commit('setEmploymentsTypes', data);
	      context.commit('isLoadingEmploymentsTypesForSchool', false);
	    }, function (failure) {
	      console.log('failed read subjects');
	    });
	  },
	  createEmploymentType: function createEmploymentType(context, obj) {
	    var schoolId = context.rootGetters.schoolId;
	    _docendo2.default.createEmploymentType(schoolId, obj.title, obj.manualSalary, function (success) {
	      context.commit('addEmploymentsType', success);
	    }, function (failure) {
	      console.log('failure');
	    });
	  },
	  updateEmploymentsType: function updateEmploymentsType(context, obj) {
	    var schoolId = context.rootGetters.schoolId;
	    _docendo2.default.updateEmploymentType(schoolId, obj.id, obj.title, obj.manualSalary, function (success) {
	      context.commit('updateEmploymentsType', success);
	    }, function (failure) {
	      console.log('failure');
	    });
	  },
	  readEmployments: function readEmployments(context) {
	    var schoolId = context.rootGetters.schoolId;
	    context.commit('isLoadingEmploymentsTypesForSchool', true);
	    _docendo2.default.employmentsForSchool(schoolId, function (data) {
	      context.commit('setEmployments', data);
	      context.commit('isLoadingEmploymentsTypesForSchool', false);
	    }, function (failure) {
	      console.log('failed read subjects');
	    });
	  },
	  createSalaryCode: function createSalaryCode(context, obj) {
	    context.state.isSubmitting = true;
	    _docendo2.default.createSalaryCode(obj.schoolId, obj.employmentTypeId, obj.code, obj.title, function (data) {
	      console.log('createSalaryCode::oprettet', data);
	      context.state.isSubmitting = false;
	      context.dispatch('readEmploymentTypes');
	      context.dispatch('readEmployments');
	    }, function (failure) {
	      console.log('failed read subjects');
	    });
	  },
	  createEmployments: function createEmployments(context, obj) {
	    context.state.isCreatingUserEmployments = true;
	    console.log('vuex::createEmployments', obj);
	    _docendo2.default.bulkCreateEmployment(obj.schoolId, obj.userIds, obj.employmentTypeIds, obj.isManualSalary, function (data) {
	      context.state.isCreatingUserEmployments = false;
	      context.dispatch('readEmploymentTypes');
	      context.dispatch('readEmployments');
	      _eventbus2.default.toast = { text: 'Oprettet', 'success': true };
	    }, function (failure) {
	      _eventbus2.default.toast = { text: failure.error, 'success': false };
	      console.log('failed read subjects');
	    });
	  },
	  deleteEmployment: function deleteEmployment(context, obj) {
	    _docendo2.default.deleteEmployment(obj.schoolId, obj.userId, obj.employmentId, function (data) {
	      if (data.status === 'error') {
	        _eventbus2.default.toast = { text: data.message, 'success': false };
	      }
	      context.dispatch('readEmployments');
	    }, function (failure) {
	      _eventbus2.default.toast = { text: failure.error, 'success': false };
	      console.log('failed read subjects');
	    });
	  },
	  archiveEmployment: function archiveEmployment(context, obj) {},
	  updateEmployment: function updateEmployment(context, obj) {
	    return new _promise2.default(function (resolve, reject) {
	      _docendo2.default.updateEmployment(obj.schoolId, obj.userId, obj.employmentId, obj.manualSalary, obj.defaultLoenart, obj.defaultLoebenummer, function (data) {
	        context.dispatch('readEmployments').then(function () {
	          resolve();
	        });
	      }, function (failure) {
	        _eventbus2.default.toast = { text: failure.error, success: false };
	        console.log('failed to update employment');
	        reject(failure.error);
	      });
	    });
	  },
	  readCostCenters: function readCostCenters(context) {
	    var schoolId = context.getters.schoolIdLocal;
	    context.state.isLoadingCostCenters = true;
	    _docendo2.default.listSalaryCostCenter(schoolId, function (success) {
	      context.state.costCenters = success;
	      context.state.isLoadingCostCenters = false;
	    }, function (failure) {
	      console.log('failed read subjects');
	    });
	  },
	  createCostCenter: function createCostCenter(context, costCenter) {
	    var schoolId = context.getters.schoolIdLocal;
	    context.state.isUpdatingCostCenters = true;
	    _docendo2.default.createSalaryCostCenter(schoolId, costCenter.name, costCenter.code, function (success) {
	      context.state.costCenters.push(success);
	      context.state.isUpdatingCostCenters = false;
	    }, function (failure) {
	      console.log('failed read subjects');
	    });
	  },
	  archiveCostCenter: function archiveCostCenter(context, costCenter) {
	    return new _promise2.default(function (resolve, reject) {
	      var schoolId = context.getters.schoolIdLocal;
	      _docendo2.default.archiveSalaryCostCenter(schoolId, costCenter.id, function (success) {
	        upsertCostCenter(context.state, success);
	        resolve(success);
	      }, function (failure) {
	        _eventbus2.default.toast = { text: failure && failure.error || 'Kunne ikke arkivere omkostningssted', success: false };
	        reject(failure);
	      });
	    });
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var state = {
	  schoolsTestingStudents: [58953, 58706, 56235, 54618, 41576, 50707, 54828, 51581, 51583, 51591, 51599, 51600, 51597, 50402, 51590, 51574, 51588, 51586, 51587, 51589, 51585, 51596, 51576, 51595, 51592, 51594, 51593, 51598, 51577, 51578, 51579, 51601, 51602, 51603, 51580, 8943, 51582, 51584, 51573, 33473, 9111, 37940, 50417, 50803, 51763, 52492, 51408, 50802, 54331, 54479, 54635, 56284, 43915, 55417, 55210, 56149, 54818, 56266, 57418, 57426, 57424, 57426, 57420, 57421, 57422, 57423, 57425, 57427, 57419, 57471]
	};
	
	var getters = {
	  modulesSchoolFeatures: function modulesSchoolFeatures(state, getters, rootState, rootGetters) {
	    return rootGetters.schoolFeatures;
	  },
	  isReductionsActive: function isReductionsActive(state, getters) {
	    return getters.modulesSchoolFeatures.indexOf('subject_reductions') > -1;
	  },
	  isKindergarten: function isKindergarten(state, getters, rootState) {
	    return getters.modulesSchoolFeatures.indexOf('calendar_kindergarten') > -1;
	  },
	  theSchool: function theSchool(state, getters, rootState) {
	    return rootState.activeSchool ? rootState.activeSchool : window.SCHOOL ? window.SCHOOL : null;
	  },
	  theSchoolCountry: function theSchoolCountry(state, getters, rootState) {
	    return getters.theSchool && getters.theSchool.country ? getters.theSchool.country.toUpperCase() : 'DK';
	  },
	  isSchoolFeatureLocalePool: function isSchoolFeatureLocalePool(state, getters) {
	    return getters.modulesSchoolFeatures.indexOf('lokalpulje') > -1;
	  },
	  isSchoolTestingStudents: function isSchoolTestingStudents(state, getters, rootState) {
	    if (window.SCHOOL && window.SCHOOL.features) {
	      return window.SCHOOL.features.includes('calendar_student');
	    }
	
	    var school = rootState && rootState.activeSchool ? rootState.activeSchool : window.SCHOOL;
	    var schoolId = school && school.id ? school.id : '';
	
	    return state.schoolsTestingStudents.includes(schoolId);
	  },
	  isSchoolSFOActive: function isSchoolSFOActive(state, getters, rootState) {
	    var isActivated = getters.modulesSchoolFeatures.indexOf('calendar_club') > -1;
	    var schoolId = getters.schoolId;
	    var danishSchoolsWithoutSFO = [57418];
	    if (isActivated) {
	      return true;
	    } else if (getters.theSchoolCountry === 'NO' || getters.theSchoolCountry === 'DK' && danishSchoolsWithoutSFO.indexOf(schoolId) < 0) {
	      return true;
	    } else {
	      return false;
	    }
	  },
	  isSubStatusPendingActive: function isSubStatusPendingActive(state, getters, rootState) {
	    var schoolId = getters.schoolId;
	    var schoolIdsTestingSubStatusPending = [51580];
	    return schoolIdsTestingSubStatusPending.includes(schoolId);
	  },
	  isSchoolTestingTaskOverviewDesigner: function isSchoolTestingTaskOverviewDesigner(state, getters) {
	    var schoolId = getters.schoolId;
	    var schoolIdsTestingTaskOverviewDesigner = [62000, 7272, 59488, 59489, 62084];
	    return schoolIdsTestingTaskOverviewDesigner.includes(schoolId);
	  },
	  isKmdUserQuotaActive: function isKmdUserQuotaActive(state, getters) {
	    return getters.modulesSchoolFeatures.indexOf('kmd_absence') > -1;
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters
	};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(51);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _values = __webpack_require__(33);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vue = __webpack_require__(41);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _preparationFactor = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  isSubmittingTask: false,
	  isLoading: true,
	  isLoadingSubjects: false,
	  isLoadingTasks: false,
	  isConfirmDeletion: false,
	  itemToDelete: null,
	  theDeletedItemId: null,
	  subjects: [],
	  usersAssignedHours: [],
	  tasks: [],
	  subjectTypeFilter: 'klass',
	  selectedSubjectTypeFilters: [],
	  subjectTypes: {
	    da: [{ name: 'Aktiviteter', value: 'activity', desc: 'Tæller UV-tid og reducerer timer på andre fag' }, { name: 'Fag', value: 'subject', desc: 'Tæller timer for klassen. To samtidige brikker tæller halvt.' }, { name: 'UUV', value: 'supplemental', desc: 'Tæller selvstændigt på understøttende undervisning.' }, {
	      name: 'Temavisning',
	      value: 'frame',
	      desc: 'Kan bruges til at markere temaer og anderledes dage i skemaet. Brikken er synlig for elever/forældre, mens fag-brikker, der ligger samtidig med tema-brikken, ikke er synlige. Fagbrikker tæller 100% i tidsrummet, og temabrikken tæller ikke.'
	    }, { name: 'Pause', value: 'break', desc: 'Andre lektioner bør ikke overlappe med en pause.' }, {
	      name: 'Ressource (skjult)',
	      value: 'resource',
	      desc: 'Bruges til at markere ressourcer i skemaet. Tæller ikke fra andre brikker. Vises som standard ikke i elev- og forældreskema.'
	    }, {
	      name: 'Valgfag/Hold',
	      value: 'optional',
	      desc: 'Tæller 100 % og uafhængigt af andre brikker i samme tidsrum.'
	    }, {
	      name: 'Ressource',
	      value: 'person_resource',
	      desc: 'Tæller UV-tid for underviseren. Tæller ikke ned fra andre fag samtidig i klassen. Vises ikke i elev- og forældre visning.'
	    }, {
	      name: 'Ressource (synlig)',
	      value: 'person_resource_visible',
	      desc: 'Bruges til at markere ekstra ressurser i skemaet. Tæller ikke fra andre brikker. Vises i elev- og forældreskema.'
	    }, { name: 'Anden tid', value: 'other_tasks', desc: 'Ikke undervisning.' }, { name: 'Øvrig tid', value: 'other_stuff', desc: 'Ikke undervisning, ikke elev-relateret.' }, { name: 'SFO', value: 'club', desc: 'Pædagogisk tid' }, { name: 'Øvrige opgaver', value: 'additional_tasks', desc: 'Tæller ikke UV' }],
	    en: [{
	      name: 'Subject',
	      value: 'subject',
	      desc: 'Counting hours for the class. Two simultaneous activities count as halves.'
	    }, {
	      name: 'Theme', value: 'frame',
	      desc: 'Can be used for marking themes and special days in the class schedule. The themed activity is visible for the pupils and parents, while classes that are overlapping the themed activity will not be visible. Classes are fully counting, and the themed activity is not.'
	    }, { name: 'Break', value: 'break', desc: 'Subjects should not overlap with breaks.' }, {
	      name: 'Ressource', value: 'resource',
	      desc: 'Can be used to register ressources. Is not visible to students/parents.'
	    }, {
	      name: 'Optional classes/groups',
	      value: 'optional',
	      desc: 'Fully counting and independent from other activities in the same time period.'
	    }, {
	      name: 'Ressource', value: 'resource',
	      desc: 'Can be used to register ressources. Is not visible to students/parents.'
	    }, { name: 'Other tasks', value: 'other_tasks', desc: 'Not teaching.' }, { name: 'Additional tasks', value: 'other_stuff', desc: 'Not classes and teaching, non-pupil related.' }],
	    nb: [{ name: 'Fag', value: 'subject', desc: 'Teller timer for klassen' }, {
	      name: 'Temavisning',
	      value: 'frame',
	      desc: 'Kan brukes til å markere temaer og spesielle dager/uker i timeplanen. Temavisning er synlig for elever/foreldre, og kan kombineres med fag. Fag teller 100% i perioden, og temaet teller ikke.'
	    }, { name: 'Pause', value: 'break', desc: 'Andre timer bør ikke overlapper med en pause.' }, {
	      name: 'Ressurs',
	      value: 'resource',
	      desc: 'Brukes til å markere ressursene i timeplanen. Teller ikke fra andre fag. Vises som standard ikke i elev- og foreldretimeplan.'
	    }, {
	      name: 'Valgfag/gruppe',
	      value: 'optional',
	      desc: 'Teller 100% og uavhengig av andre aktiviteter i samme tidsrom.'
	    }, {
	      name: 'Ressurs',
	      value: 'resource',
	      desc: 'Brukes til å markere ressursene i timeplanen. Teller ikke fra andre fag. Vises som standard ikke i elev- og foreldretimeplan.'
	    }, { name: 'Annen tid', value: 'other_tasks', desc: 'Ikke undervisning.' }, { name: 'Øvrig tid', value: 'other_stuff', desc: 'Ikke undervisning, ikke elevrelatert.' }]
	  },
	  userTableAcc: {
	    teaching: true
	  },
	  actualSubjectsForUser: [],
	  isLoadingTasksForUser: true,
	  userTasks: [],
	  userActualHours: {},
	  dbSubjectTypes: [{
	    key: 'absence',
	    i18n: {
	      da: 'Fravær',
	      en: 'Absence',
	      nb: 'Fravær'
	    }
	  }, {
	    key: 'additional_tasks',
	    i18n: {
	      da: 'Øvrige opgaver',
	      en: 'Additional tasks',
	      nb: 'Ekstra oppgaver'
	    }
	  }, {
	    key: 'activity',
	    i18n: {
	      da: 'Aktivitet',
	      en: 'Activity',
	      nb: 'Aktivitet'
	    }
	  }, {
	    key: 'available',
	    i18n: {
	      da: 'Rådighedstime',
	      en: 'Available',
	      nb: 'Tilgjengelig'
	    }
	  }, {
	    key: 'break',
	    i18n: {
	      da: 'Pause',
	      en: 'Break',
	      nb: 'Pause'
	    }
	  }, {
	    key: 'club',
	    i18n: {
	      da: 'SFO',
	      en: 'Club',
	      nb: 'Klubb'
	    }
	  }, {
	    key: 'exercise',
	    i18n: {
	      da: 'Bevægelse',
	      en: 'Exercise',
	      nb: 'Trening'
	    }
	  }, {
	    key: 'flexin',
	    i18n: {
	      da: 'Flex ind',
	      en: 'Flex in',
	      nb: 'Flex inn'
	    }
	  }, {
	    key: 'flexout',
	    i18n: {
	      da: 'Flex ud',
	      en: 'Flex out',
	      nb: 'Flex ut'
	    }
	  }, {
	    key: 'frame',
	    i18n: {
	      da: 'Temavisning',
	      en: 'Frame',
	      nb: 'Temavisning'
	    }
	  }, {
	    key: 'optional',
	    i18n: {
	      da: 'Valgfag',
	      en: 'Optional',
	      nb: 'Valgfritt'
	    }
	  }, {
	    key: 'other_stuff',
	    i18n: {
	      da: 'Øvrig tid',
	      en: 'Other stuff',
	      nb: 'Andre ting'
	    }
	  }, {
	    key: 'other_tasks',
	    i18n: {
	      da: 'Anden tid',
	      en: 'Other tasks',
	      nb: 'Annen tid'
	    }
	  }, {
	    key: 'resource',
	    i18n: {
	      da: 'Ressource (skjult)',
	      en: 'Resource',
	      nb: 'Ressurs'
	    }
	  }, {
	    key: 'person_resource',
	    i18n: {
	      da: 'Person ressource (skjult)',
	      en: 'Person resource',
	      nb: 'Personressurs'
	    }
	  }, {
	    key: 'person_resource_visible',
	    i18n: {
	      da: 'Ressource (synlig)',
	      en: 'Visible person resource',
	      nb: 'Synlig personressurs'
	    }
	  }, {
	    key: 'pool',
	    i18n: {
	      da: 'Lokalpulje',
	      en: 'Pool',
	      nb: 'Pulje'
	    }
	  }, {
	    key: 'preparation',
	    i18n: {
	      da: 'Forberedelse',
	      en: 'Preparation',
	      nb: 'Forberedelse'
	    }
	  }, {
	    key: 'reservation',
	    i18n: {
	      da: 'Reservation',
	      en: 'Reservation',
	      nb: 'Reservasjon'
	    }
	  }, {
	    key: 'subject',
	    i18n: {
	      da: 'Fag',
	      en: 'Subject',
	      nb: 'Fag'
	    }
	  }, {
	    key: 'supplemental',
	    i18n: {
	      da: 'UUV',
	      en: 'Supplemental',
	      nb: 'Supplerende'
	    }
	  }, {
	    key: 'with_kids',
	    i18n: {
	      da: 'Med børn',
	      en: 'With kids',
	      nb: 'Med barn'
	    }
	  }, {
	    key: 'without_kids',
	    i18n: {
	      da: 'Uden børn',
	      en: 'Without kids',
	      nb: 'Uten barn'
	    }
	  }],
	  subjectsRequests: [],
	  isLoadingSubjectsRequests: false,
	  reductions: [],
	  isLoadingReductions: false
	};
	
	var getters = {
	  reductionsInSubjectIdHash: function reductionsInSubjectIdHash(state, getters) {
	    var obj = {};
	    state.reductions.forEach(function (reduction) {
	      var activity = getters.subjectsInHash[reduction.activity_id] || {};
	      var reductionWithActivity = (0, _extends3.default)({}, reduction, {
	        vActivity: activity,
	        vActivityTitle: activity.name || '',
	        vActivityReductionHours: activity.hours || '?'
	      });
	
	      if (!obj[reduction.subject_id]) {
	        obj[reduction.subject_id] = [reductionWithActivity];
	      } else {
	        obj[reduction.subject_id].push(reductionWithActivity);
	      }
	    });
	    return obj;
	  },
	  activeSubjectTypeFilters: function activeSubjectTypeFilters(state, getters) {
	    var typesI18n = state.subjectTypes[getters.locale];
	    return state.selectedSubjectTypeFilters.filter(function (filter) {
	      return typesI18n.some(function (type) {
	        return type.name === filter;
	      });
	    }).map(function (filter) {
	      return typesI18n.find(function (type) {
	        return type.name === filter;
	      }).value;
	    });
	  },
	  subjectsFilteredOnType: function subjectsFilteredOnType(state, getters) {
	    var activeFilters = getters.activeSubjectTypeFilters;
	
	    if (!activeFilters || activeFilters.length === 0) {
	      return state.subjects;
	    }
	
	    return state.subjects.filter(function (subject) {
	      return activeFilters.includes(subject.subject_type);
	    });
	  },
	  klassCalIdsHashSortedOnName: function klassCalIdsHashSortedOnName(state, getters, rootState, rootGetters) {
	    var klasses = rootGetters.klassCalendars;
	    return klasses.map(function (cal) {
	      return cal.id;
	    });
	  },
	  subjectsInKlassHash: function subjectsInKlassHash(state, getters, rootState, rootGetters) {
	    var klassCalsWithSubjectIds = {};
	    state.subjects.forEach(function (subject) {
	      subject.calendar_ids.forEach(function (calId) {
	        if (rootGetters.allKlassCalendarsInHash[calId]) {
	          if (!klassCalsWithSubjectIds[calId]) {
	            klassCalsWithSubjectIds[calId] = [subject.id];
	          } else {
	            klassCalsWithSubjectIds[calId].push(subject.id);
	          }
	        }
	      });
	    });
	    return klassCalsWithSubjectIds;
	  },
	  subjectsInCalendarHash: function subjectsInCalendarHash(state, getters, rootState, rootGetters) {
	    var calsWithSubjectIds = {};
	    state.subjects.forEach(function (subject) {
	      var calId = subject.calendar_id;
	      if (!calsWithSubjectIds[calId]) {
	        calsWithSubjectIds[calId] = [subject.id];
	      } else {
	        calsWithSubjectIds[calId].push(subject.id);
	      }
	    });
	    return calsWithSubjectIds;
	  },
	  subjectsInUserHash: function subjectsInUserHash(state, getters, rootState, rootGetters) {
	    var calIdsWithSubjectIds = {};
	    state.subjects.forEach(function (subject) {
	      if (subject.master_type === 'teaching') {
	        subject.calendar_ids.forEach(function (calid) {
	          if (calid && rootGetters.allUsersInCalIdHash[calid]) {
	            if (!calIdsWithSubjectIds[calid]) {
	              calIdsWithSubjectIds[calid] = [subject.id];
	            } else if (calIdsWithSubjectIds[calid].indexOf(subject.id) < 0) {
	              calIdsWithSubjectIds[calid].push(subject.id);
	            }
	          }
	        });
	      }
	    });
	    return calIdsWithSubjectIds;
	  },
	  actualSubjectsForUserInHash: function actualSubjectsForUserInHash(state) {
	    var subjects = state.actualSubjectsForUser.reduce(function (obj, item) {
	      obj[item.id] = item;
	      return obj;
	    }, {});
	    return subjects;
	  },
	  subjectsInHash: function subjectsInHash(state, getters) {
	    return state.subjects.reduce(function (obj, item) {
	      obj[item.id] = item;
	      return obj;
	    }, {});
	  },
	  usersAssignedHoursHash: function usersAssignedHoursHash(state) {
	    if (!state.usersAssignedHours.length || state.usersAssignedHours.length < 1) {
	      return {};
	    }
	    return _assign2.default.apply(Object, [{}].concat((0, _toConsumableArray3.default)(state.usersAssignedHours.map(function (item) {
	      return (0, _defineProperty3.default)({}, item.user_id, item);
	    }))));
	  },
	  uniqueSubjects: function uniqueSubjects(state, getters, rootState, rootGetters) {
	    if (state.isLoading || rootGetters.klassCalendars.length === 0) {
	      return [];
	    }
	
	    var klassCalendars = rootGetters.klassCalendars;
	    var klassCalendarsInHash = rootGetters.allKlassCalendarsInHash;
	    var allCalendarsInHash = rootGetters.allCalendarsInHash;
	
	    var subjectsMap = {};
	
	    getters.subjectsFilteredOnType.forEach(function (subject) {
	      var calendar = allCalendarsInHash[subject.calendar_id];
	
	      if (!calendar || calendar.type !== state.subjectTypeFilter) return;
	
	      var groupKey = subject.name + '|' + subject.subject_type;
	
	      if (!subjectsMap[groupKey]) {
	        subjectsMap[groupKey] = (0, _extends3.default)({}, subject, {
	          klasses: klassCalendars.reduce(function (obj, klass) {
	            obj[klass.id] = { calendar_id: klass.id };
	            return obj;
	          }, {})
	        });
	      }
	
	      subject.calendar_ids.forEach(function (calId) {
	        if (klassCalendarsInHash[calId]) {
	          subjectsMap[groupKey].klasses[calId] = subject;
	        }
	      });
	    });
	
	    return (0, _values2.default)(subjectsMap).sort(function (a, b) {
	      return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
	    });
	  },
	  tasksInUserHash: function tasksInUserHash(state) {
	    var calIdsWithTasksIds = {};
	    state.tasks.forEach(function (task) {
	      if (task.user_calendar_ids) {
	        task.user_calendar_ids.forEach(function (calid) {
	          if (calid) {
	            if (!calIdsWithTasksIds[calid]) {
	              calIdsWithTasksIds[calid] = [task.id];
	            } else {
	              calIdsWithTasksIds[calid].push(task.id);
	            }
	          }
	        });
	      }
	    });
	    return calIdsWithTasksIds;
	  },
	  tasksInHash: function tasksInHash(state, getters) {
	    state.tasks.forEach(function (task) {
	      var teaching = task.subject_type === 'person_resource' || task.subject_type === 'person_resource_visible' || task.subject_type === 'subject' ? task.hours : null;
	      var tasks = task.subject_type === 'additional_tasks' ? task.hours : null;
	      var prep = task.subject_type === 'preparation' ? task.hours : null;
	      var pool = task.subject_type === 'pool' ? task.hours : null;
	      _vue2.default.set(task, 'timeTeaching', teaching);
	      _vue2.default.set(task, 'timeTasks', tasks);
	      _vue2.default.set(task, 'timePrep', prep);
	      _vue2.default.set(task, 'timePool', pool);
	    });
	    var tasks = state.tasks.reduce(function (obj, item) {
	      obj[item.id] = item;
	      return obj;
	    }, {});
	    return tasks;
	  },
	  userTasksSortedInTypes: function userTasksSortedInTypes() {
	    var selectSorting = {
	      teaching: 1,
	      substitute_hours: 2,
	      club: 3,
	      other: 4,
	      preparation: 5,
	      pool: 6,
	      absence: 10,
	      with_kids: 1,
	      without_kids: 2
	    };
	    var types = [];
	    state.userTasks.forEach(function (task) {
	      if (!task.actual && task.hours * 1 === 0) {
	        var arrOfSubjects = state.userTasks.filter(function (allTask) {
	          return allTask.id === task.id;
	        });
	
	        if (arrOfSubjects.length > 1) {
	          return;
	        }
	      }
	      var activeType = task.task_category_name ? task.task_category_name : task.master_type;
	      if (task.substitute) {
	        activeType = 'substitute_hours';
	      }
	      var idx = types.findIndex(function (type) {
	        return type.title === activeType;
	      });
	      if (idx > -1) {
	        types[idx].tasks.push(task);
	      } else {
	        var order = task.hasOwnProperty('task_category_rank') && task.task_category_rank !== null ? task.task_category_rank : selectSorting[activeType] !== undefined ? selectSorting[activeType] : 100;
	        var obj = {
	          title: activeType,
	          order: order,
	          tasks: [task]
	        };
	        types.push(obj);
	      }
	    });
	
	    return types.sort(function (a, b) {
	      if (a.order !== b.order) return a.order - b.order;
	      var aIsMasterType = Object.prototype.hasOwnProperty.call(selectSorting, a.title);
	      var bIsMasterType = Object.prototype.hasOwnProperty.call(selectSorting, b.title);
	      if (aIsMasterType !== bIsMasterType) return aIsMasterType ? 1 : -1;
	      return 0;
	    });
	  },
	  subjectsRequestsInHash: function subjectsRequestsInHash(state, getters) {
	    var obj = {};
	    state.subjectsRequests.forEach(function (req) {
	      if (obj[req.subject_id]) {
	        obj[req.subject_id].push(req.calendar_id);
	      } else {
	        obj[req.subject_id] = [req.calendar_id];
	      }
	    });
	    return obj;
	  },
	  teachingHoursPerUser: function teachingHoursPerUser(state, getters, rootState, rootGetters) {
	    var getVHours = function getVHours(subject, userCalId) {
	      if (!subject) return 0;
	
	      if (Array.isArray(subject.subject_calendars)) {
	        var userMatch = subject.subject_calendars.find(function (sc) {
	          return sc.calendar_id === userCalId && sc.hours != null;
	        });
	        if (userMatch) {
	          var parsed = parseFloat(userMatch.hours);
	          return isNaN(parsed) ? 0 : parsed;
	        }
	      }
	
	      if (Array.isArray(subject.cals)) {
	        var klass = subject.cals.find(function (c) {
	          return c.calendar_type === 'klass';
	        });
	        if (klass && Array.isArray(subject.subject_calendars)) {
	          var klassMatch = subject.subject_calendars.find(function (sc) {
	            return sc.calendar_id === klass.id && sc.hours != null;
	          });
	          if (klassMatch) {
	            var _parsed = parseFloat(klassMatch.hours);
	            return isNaN(_parsed) ? 0 : _parsed;
	          }
	        }
	      }
	
	      var fallback = parseFloat(subject.hours);
	      return isNaN(fallback) ? 0 : fallback;
	    };
	
	    var userTeachingHours = {};
	
	    state.subjects.forEach(function (subject) {
	      if (subject.master_type === 'teaching' && subject.task_overview !== false && Array.isArray(subject.cals)) {
	        subject.cals.forEach(function (calendar) {
	          if (calendar.calendar_type === 'user') {
	            var calId = calendar.id;
	            if (!userTeachingHours[calId]) {
	              userTeachingHours[calId] = 0;
	            }
	
	            var hours = getVHours(subject, calId);
	            userTeachingHours[calId] += hours;
	          }
	        });
	      }
	    });
	
	    return userTeachingHours;
	  },
	  taskHoursPerUser: function taskHoursPerUser(state, getters, rootState, rootGetters) {
	    var getSubjectHours = function getSubjectHours(subject, calId) {
	      var userId = rootGetters.allUsersInCalIdHash[calId] ? rootGetters.allUsersInCalIdHash[calId]['id'] : null;
	      if (!userId) {
	        subject.hours * 1;
	      }
	      var idx = subject.teachers[0] ? subject.teachers.findIndex(function (teacher) {
	        return teacher.user_id === userId;
	      }) : -1;
	      if (idx > -1) {
	        return subject.teachers[idx].hours * 1;
	      } else {
	        return subject.hours * 1;
	      }
	    };
	    var userHours = {};
	    state.tasks.forEach(function (subject) {
	      if (subject.master_type === 'teaching') {
	        subject.cals.forEach(function (calendar) {
	          if (calendar.calendar_type === 'user') {
	            var calId = calendar.id;
	            if (!userHours[calId]) {
	              userHours[calId] = 0;
	            }
	            var hours = getSubjectHours(subject, calId);
	            userHours[calId] += hours || 0;
	          }
	        });
	      }
	    });
	    return userHours;
	  },
	  tasksHoursInUserHash: function tasksHoursInUserHash(state) {
	    var subjectType = 'additional_tasks';
	    var userHours = {};
	    state.tasks.forEach(function (task) {
	      if (task.user_calendar_ids && task.subject_type === subjectType) {
	        task.user_calendar_ids.forEach(function (calId) {
	          if (calId) {
	            if (!userHours[calId]) {
	              userHours[calId] = 0;
	            }
	            var hours = task.hours;
	            userHours[calId] += hours || 0;
	          }
	        });
	      }
	    });
	    state.subjects.forEach(function (subject) {
	      if (subject.subject_type === subjectType && subject.task_overview !== false && Array.isArray(subject.cals)) {
	        subject.cals.forEach(function (calendar) {
	          if (calendar.calendar_type === 'user') {
	            var calId = calendar.id;
	            if (!userHours[calId]) {
	              userHours[calId] = 0;
	            }
	            userHours[calId] += (0, _preparationFactor.getVHoursForSubject)(subject, calId);
	          }
	        });
	      }
	    });
	    return userHours;
	  },
	  preparationHoursInUserHash: function preparationHoursInUserHash(state) {
	    var subjectType = 'preparation';
	    var userHours = {};
	    state.tasks.forEach(function (task) {
	      if (task.user_calendar_ids && task.subject_type === subjectType) {
	        task.user_calendar_ids.forEach(function (calId) {
	          if (calId) {
	            if (!userHours[calId]) {
	              userHours[calId] = 0;
	            }
	            var hours = task.hours;
	            userHours[calId] += hours || 0;
	          }
	        });
	      }
	    });
	    state.subjects.forEach(function (subject) {
	      if (subject.subject_type === subjectType && subject.task_overview !== false && Array.isArray(subject.cals)) {
	        subject.cals.forEach(function (calendar) {
	          if (calendar.calendar_type === 'user') {
	            var calId = calendar.id;
	            if (!userHours[calId]) {
	              userHours[calId] = 0;
	            }
	            userHours[calId] += (0, _preparationFactor.getVHoursForSubject)(subject, calId);
	          }
	        });
	      }
	    });
	    return userHours;
	  },
	  localPoolHoursInUserHash: function localPoolHoursInUserHash(state) {
	    var subjectType = 'pool';
	    var userHours = {};
	    state.tasks.forEach(function (task) {
	      if (task.user_calendar_ids && task.subject_type === subjectType) {
	        task.user_calendar_ids.forEach(function (calId) {
	          if (calId) {
	            if (!userHours[calId]) {
	              userHours[calId] = 0;
	            }
	            var hours = task.hours;
	            userHours[calId] += hours || 0;
	          }
	        });
	      }
	    });
	    state.subjects.forEach(function (subject) {
	      if (subject.subject_type === subjectType && subject.task_overview !== false && Array.isArray(subject.cals)) {
	        subject.cals.forEach(function (calendar) {
	          if (calendar.calendar_type === 'user') {
	            var calId = calendar.id;
	            if (!userHours[calId]) {
	              userHours[calId] = 0;
	            }
	            userHours[calId] += (0, _preparationFactor.getVHoursForSubject)(subject, calId);
	          }
	        });
	      }
	    });
	    return userHours;
	  },
	  clubHoursInUserHash: function clubHoursInUserHash(state) {
	    var subjectType = 'club';
	    var userHours = {};
	    state.tasks.forEach(function (task) {
	      if (task.user_calendars && task.subject_type === subjectType) {
	        task.user_calendars.forEach(function (calId) {
	          if (calId) {
	            if (!userHours[calId]) {
	              userHours[calId] = 0;
	            }
	            var hours = task.hours;
	            userHours[calId] += hours || 0;
	          }
	        });
	      }
	    });
	    state.subjects.forEach(function (subject) {
	      if (subject.subject_type === subjectType && subject.task_overview !== false && Array.isArray(subject.cals)) {
	        subject.cals.forEach(function (calendar) {
	          if (calendar.calendar_type === 'user') {
	            var calId = calendar.id;
	            if (!userHours[calId]) {
	              userHours[calId] = 0;
	            }
	            userHours[calId] += (0, _preparationFactor.getVHoursForSubject)(subject, calId);
	          }
	        });
	      }
	    });
	    return userHours;
	  },
	  weightedPreparationHoursForCalendarId: function weightedPreparationHoursForCalendarId(state, getters) {
	    var weighted = getters.preparationHoursByCalendar.weighted;
	    return function (calId) {
	      if (!weighted) {
	        return null;
	      }
	      var value = weighted[Number(calId)];
	      return value === undefined ? null : value;
	    };
	  },
	  explicitPrepTaskHoursForCalendarId: function explicitPrepTaskHoursForCalendarId(state, getters) {
	    var explicit = getters.preparationHoursByCalendar.explicit;
	    return function (calId) {
	      return explicit[Number(calId)] || 0;
	    };
	  },
	  preparationHoursByCalendar: function preparationHoursByCalendar(state, getters, rootState, rootGetters) {
	    return (0, _preparationFactor.computePreparationHoursByCalendar)(state, rootGetters, rootState);
	  }
	};
	
	var mutations = {
	  SET_SUBJECT_TYPE_FILTER: function SET_SUBJECT_TYPE_FILTER(state, subjectType) {
	    state.selectedSubjectTypeFilters = subjectType;
	  },
	  TOGGLE_SUBJECT_TYPE_FILTER: function TOGGLE_SUBJECT_TYPE_FILTER(state, filter) {
	    var index = state.selectedSubjectTypeFilters.indexOf(filter);
	    if (index === -1) {
	      state.selectedSubjectTypeFilters.push(filter);
	    } else {
	      state.selectedSubjectTypeFilters.splice(index, 1);
	    }
	  },
	  CLEAR_SUBJECT_TYPE_FILTERS: function CLEAR_SUBJECT_TYPE_FILTERS(state) {
	    state.selectedSubjectTypeFilters = [];
	  },
	  addSubjectRequest: function addSubjectRequest(state, payload) {
	    state.subjectsRequests.push(payload);
	  },
	  removeSubjectRequest: function removeSubjectRequest(state, payload) {
	    var idx = state.subjectsRequests.findIndex(function (request) {
	      return request.id === payload.id;
	    });
	    if (idx > -1) {
	      state.subjectsRequests.splice(idx, 1);
	    }
	  },
	  setUserTableAcc: function setUserTableAcc(state, accOpen) {
	    _vue2.default.set(state.userTableAcc, accOpen.title, accOpen.boolean);
	  },
	  setTheDeletedItemId: function setTheDeletedItemId(state, itemId) {
	    state.theDeletedItemId = itemId;
	  },
	  setItemToDelete: function setItemToDelete(state, item) {
	    state.itemToDelete = item;
	  },
	  setSubjects: function setSubjects(state, data) {
	    state.subjects = data;
	  },
	  createSubject: function createSubject(state, newSubject) {
	    _vue2.default.set(state.subjects, state.subjects.length, newSubject);
	  },
	  updateSubject: function updateSubject(state, updatedSubject) {
	    var idx = state.subjects.findIndex(function (subject) {
	      return subject.id === updatedSubject.id;
	    });
	    _vue2.default.set(state.subjects, idx, updatedSubject);
	  },
	  deleteSubject: function deleteSubject(state, deletedSubject) {
	    var idx = state.subjects.findIndex(function (subject) {
	      return subject.id === deletedSubject.id;
	    });
	    state.subjects.splice(idx, 1);
	  },
	  setUsersAssignedHours: function setUsersAssignedHours(state, data) {
	    state.usersAssignedHours = data;
	  },
	  createTask: function createTask(state, newTask) {
	    _vue2.default.set(state.tasks, state.tasks.length, newTask);
	  },
	  setTasks: function setTasks(state, data) {
	    state.tasks = data;
	  },
	  updateTask: function updateTask(state, updatedTask) {
	    var idx = state.tasks.findIndex(function (task) {
	      return task.id === updatedTask.oldId;
	    });
	    _vue2.default.set(state.tasks, idx, updatedTask);
	  },
	  setTaskHours: function setTaskHours(state, _ref2) {
	    var taskId = _ref2.taskId,
	        hours = _ref2.hours;
	
	    var task = state.tasks.find(function (t) {
	      return t.id === taskId;
	    });
	    if (task) {
	      _vue2.default.set(task, 'hours', hours);
	    }
	  },
	  deleteTask: function deleteTask(state, deletedTask) {
	    var idx = state.tasks.findIndex(function (task) {
	      return task.id === deletedTask.id;
	    });
	    state.tasks.splice(idx, 1);
	  },
	  setConfirmDeletion: function setConfirmDeletion(state, boolean) {
	    state.isConfirmDeletion = boolean;
	  },
	  updateTeacherHoursOnSubject: function updateTeacherHoursOnSubject(state, obj) {
	    var subjectIdx = state.subjects.findIndex(function (subject) {
	      return subject.id === obj.subject_id;
	    });
	
	    if (subjectIdx === -1) {
	      return;
	    }
	
	    var subject = state.subjects[subjectIdx];
	
	    if (!subject.teachers) subject.teachers = [];
	    if (!subject.subject_calendars) subject.subject_calendars = [];
	    if (!subject.calendar_ids) subject.calendar_ids = [];
	
	    var teacherIdx = -1;
	    for (var i = 0; i < subject.teachers.length; i++) {
	      if (subject.teachers[i] && subject.teachers[i].user_id === obj.user_id) {
	        teacherIdx = i;
	        break;
	      }
	    }
	
	    if (teacherIdx > -1) {
	      _vue2.default.set(subject.teachers, teacherIdx, obj);
	    } else {
	      if (subject.teachers.length === 1 && subject.teachers[0] === null) {
	        _vue2.default.set(subject.teachers, 0, obj);
	      } else {
	        subject.teachers.push(obj);
	      }
	    }
	
	    var scIdx = -1;
	    for (var _i = 0; _i < subject.subject_calendars.length; _i++) {
	      var sc = subject.subject_calendars[_i];
	      if (sc && sc.calendar_id === obj.calendar_id) {
	        scIdx = _i;
	        break;
	      }
	    }
	
	    if (scIdx > -1) {
	      var updated = (0, _assign2.default)({}, subject.subject_calendars[scIdx], {
	        calendar_id: obj.calendar_id,
	        hours: obj.hours
	      });
	      _vue2.default.set(subject.subject_calendars, scIdx, updated);
	    } else {
	      subject.subject_calendars.push({
	        calendar_id: obj.calendar_id,
	        hours: obj.hours
	      });
	    }
	
	    var hasCalId = false;
	    for (var _i2 = 0; _i2 < subject.calendar_ids.length; _i2++) {
	      if (subject.calendar_ids[_i2] === obj.calendar_id) {
	        hasCalId = true;
	        break;
	      }
	    }
	    if (!hasCalId) {
	      subject.calendar_ids.push(obj.calendar_id);
	    }
	
	    _vue2.default.set(state.subjects, subjectIdx, subject);
	  },
	  setActualSubjectsForUser: function setActualSubjectsForUser(state, arr) {
	    state.actualSubjectsForUser = arr;
	  },
	  setUserTasks: function setUserTasks(state, arr) {
	    var filterOutReservations = arr.filter(function (item) {
	      return item.subject_type !== 'reservation';
	    });
	    state.userTasks = filterOutReservations;
	  },
	  updateUserTaskHours: function updateUserTaskHours(state, obj) {
	    state.userTasks.forEach(function (task) {
	      if (task.id === obj.id && !task.substitute) {
	        var actual = task.actual ? task.actual * 1 : 0;
	        _vue2.default.set(task, 'hours', obj.hours);
	        _vue2.default.set(task, 'diff', obj.hours ? +(obj.hours - actual).toFixed(2) : '');
	      }
	    });
	  },
	  setUserTaskSubjectCalendarId: function setUserTaskSubjectCalendarId(state, obj) {
	    state.userTasks.forEach(function (task) {
	      if (task.id === obj.id && !task.substitute) {
	        _vue2.default.set(task, 'subject_calendar_id', obj.subjectCalendarId);
	      }
	    });
	  },
	  setUsersActualHours: function setUsersActualHours(state, arr) {
	    state.userActualHours = arr[0];
	  }
	};
	
	var actions = {
	  readReductions: function readReductions(context) {
	    var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    context.state.isLoadingReductions = true;
	    var schoolId = obj.schoolId || context.getters.schoolId;
	    var schoolYearId = obj.schoolYearId || context.getters.schoolYearId;
	    _docendo2.default.listSubjectReductions(schoolId, schoolYearId, function (success) {
	      context.state.reductions = success;
	      context.state.isLoadingReductions = false;
	    }, function (failure) {
	      console.log({ failure: failure });
	    });
	  },
	  readUserTasks: function readUserTasks(context, obj) {
	    if (!obj.isSilent) {
	      context.state.isLoadingTasksForUser = true;
	    }
	    _docendo2.default.userTasks(obj.userId, obj.fromDate, obj.toDate, null, function (data) {
	      if (data && data.status && data.status === 'error') {
	        _eventbus2.default.toast = { text: data.message, 'success': false };
	        return;
	      }
	      context.state.isLoadingTasksForUser = false;
	      context.commit('setUserTasks', data);
	    }, function (failure) {
	      console.log('failure', failure);
	    });
	  },
	
	  readTasksForUser: function readTasksForUser(context, objWithSchoolYearIdAndUserId) {
	    context.state.isLoadingTasksForUser = true;
	    _docendo2.default.readTasks(window.SCHOOL.id, objWithSchoolYearIdAndUserId.activeSchoolYearId, objWithSchoolYearIdAndUserId.userId, function (data) {
	      context.state.isLoadingTasksForUser = false;
	      context.commit('setTasks', data);
	    }, function (failure) {
	      console.log('failed read tasks');
	    });
	  },
	  readSubjectsForUser: function readSubjectsForUser(context, objWithSchoolYearIdAndUserId) {
	    context.state.isLoading = true;
	    _docendo2.default.readSubjects(window.SCHOOL.id, objWithSchoolYearIdAndUserId.activeSchoolYearId, objWithSchoolYearIdAndUserId.userId, function (data) {
	      state.isLoading = false;
	      context.commit('setSubjects', data);
	    }, function (failure) {
	      console.log('failed read subjects');
	    });
	  },
	  readActualSubjectsForUser: function readActualSubjectsForUser(context, objWithSchoolYearIdAndUserId) {
	    context.state.isLoadingActualUserHours = true;
	    _docendo2.default.subjectActuals(window.SCHOOL.id, objWithSchoolYearIdAndUserId.activeSchoolYearId, objWithSchoolYearIdAndUserId.userId, function (data) {
	      context.state.isLoadingActualUserHours = false;
	      context.commit('setActualSubjectsForUser', data);
	    }, function (failure) {
	      console.log('failed read subjects');
	    });
	  },
	  readUsersAssignedHoursForUser: function readUsersAssignedHoursForUser(context, schoolObj) {
	    _docendo2.default.schoolUserYearsList(schoolObj.schoolId, schoolObj.schoolYearId, schoolObj.userId, function (data) {
	      context.commit('setUsersAssignedHours', data);
	    }, function (failure) {
	      console.log('failure updated Topics');
	    });
	  },
	  readUsersActualHoursForUser: function readUsersActualHoursForUser(context, schoolObj) {
	    _docendo2.default.schoolActualHours(schoolObj.schoolId, schoolObj.fromDateTime, schoolObj.toDateTime, [schoolObj.userId], function (data) {
	      context.commit('setUsersActualHours', data);
	    }, function (failure) {
	      console.log('failure updated Topics');
	    });
	  },
	  readSubjects: function readSubjects(context, activeSchoolYearId) {
	    context.state.isLoading = true;
	    context.state.isLoadingSubjects = true;
	    var schoolId = context.getters.schoolId;
	    return new _promise2.default(function (resolve) {
	      _docendo2.default.readSubjects(schoolId, activeSchoolYearId, null, function (data) {
	        context.state.isLoading = false;
	        context.state.isLoadingSubjects = false;
	        context.commit('setSubjects', data);
	        resolve(data);
	      }, function (failure) {
	        context.state.isLoading = false;
	        context.state.isLoadingSubjects = false;
	        console.log('failed read subjects');
	        resolve(null);
	      });
	    });
	  },
	  createSubject: function createSubject(context, subject) {
	    var schoolId = subject.schoolId ? subject.schoolId : window.SCHOOL.id;
	    var preparation = subject.preparation != null && subject.preparation !== '' ? subject.preparation : null;
	    _docendo2.default.createSubject(subject.name, subject.color, subject.calendarId, subject.defaultDuration, preparation, subject.hours, subject.subjectType, schoolId, subject.schoolYearId, subject.calendarIds, subject.subjectCode, false, subject.fromDate, subject.toDate, subject.taskOverview, function (data) {
	      context.commit('createSubject', data);
	
	      data['calCurrentdate'] = subject.calCurrentdate;
	      window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: data }));
	    }, function (failure) {
	      console.log('failure');
	    });
	  },
	  updateSubject: function updateSubject(context, updatedSubject) {
	    var away = updatedSubject.away ? updatedSubject.away : false;
	    var preparation = updatedSubject.preparation != null && updatedSubject.preparation !== '' ? updatedSubject.preparation : null;
	    _docendo2.default.updateSubject(updatedSubject.id, updatedSubject.name, updatedSubject.color, updatedSubject.calendarId, updatedSubject.calendarIds, updatedSubject.defaultDuration, preparation, updatedSubject.hours, updatedSubject.subjectType, updatedSubject.schoolId, updatedSubject.schoolYearId, updatedSubject.subjectCode, away, false, updatedSubject.fromDate, updatedSubject.toDate, updatedSubject.taskOverview, function (data) {
	      context.commit('updateSubject', data);
	      window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: data }));
	    }, function (failure) {
	      console.log('failure');
	    });
	  },
	  deleteSubject: function deleteSubject(context, _deleteSubject) {
	    _docendo2.default.deleteSubject(_deleteSubject.id, _deleteSubject.school_id, _deleteSubject.school_year_id, function (data) {
	      context.commit('deleteSubject', data);
	      window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: data }));
	    }, function (failure) {
	      console.log('failure updated Topics');
	    });
	  },
	  readUsersAssignedHours: function readUsersAssignedHours(context, schoolObj) {
	    _docendo2.default.schoolUserYearsList(schoolObj.schoolId, schoolObj.schoolYearId, null, function (data) {
	      context.commit('setUsersAssignedHours', data);
	    }, function (failure) {
	      console.log('failure updated Topics');
	    });
	  },
	  readTasks: function readTasks(context, activeSchoolYearId) {
	    var schoolId = context.getters.schoolId;
	    context.state.isLoading = true;
	    context.state.isLoadingTasks = true;
	    _docendo2.default.readTasks(schoolId, activeSchoolYearId, null, function (data) {
	      state.isLoading = false;
	      context.commit('setTasks', data);
	      context.state.isLoadingTasks = false;
	      window.dispatchEvent(new window.CustomEvent('vueDoneLoadingTasks', { detail: data }));
	    }, function (failure) {
	      console.log('failed read tasks');
	    });
	  },
	  reloadTasks: function reloadTasks(context, activeSchoolYearId) {
	    var schoolId = context.getters.schoolId;
	    context.state.isSubmittingTask = true;
	    return new _promise2.default(function (resolve) {
	      _docendo2.default.readTasks(schoolId, activeSchoolYearId, null, function (data) {
	        context.commit('setTasks', data);
	        context.state.isSubmittingTask = false;
	        resolve(data);
	      }, function (failure) {
	        context.state.isSubmittingTask = false;
	        console.log('failed reload tasks');
	        resolve(null);
	      });
	      _docendo2.default.readSubjects(schoolId, activeSchoolYearId, null, function (data) {
	        context.commit('setSubjects', data);
	      }, function (failure) {
	        console.log('failed reload subjects');
	      });
	    });
	  },
	  createTask: function createTask(context, task) {
	    context.state.isSubmittingTask = true;
	    var preparation = task.preparation != null && task.preparation !== '' ? task.preparation * 1 : null;
	    var schoolId = context.getters.schoolId;
	    _docendo2.default.createTask(schoolId, task.schoolYearId, task.subjectType, task.hours, task.name, task.color, task.defaultDuration, preparation, task.belongsToCalendars, task.userCalendars, task.canSchedule, task.inUserCalendar, task.fromDate, task.toDate, function (data) {
	      if (data && data.status === 'error') {
	        console.warn('createTask backend error:', data.message);
	        _eventbus2.default.toast = { text: 'Kunne ikke oprette opgaven - prøv igen', success: false };
	        context.state.isSubmittingTask = false;
	        context.dispatch('reloadTasks', task.schoolYearId);
	        return;
	      }
	      context.commit('createTask', data);
	      context.state.isSubmittingTask = false;
	      context.dispatch('reloadTasks', task.schoolYearId);
	    }, function (failure) {
	      console.warn('createTask failure', failure);
	      _eventbus2.default.toast = { text: 'Kunne ikke oprette opgaven - prøv igen', success: false };
	      context.state.isSubmittingTask = false;
	      context.dispatch('reloadTasks', task.schoolYearId);
	    });
	  },
	  updateTask: function updateTask(context, task) {
	    context.state.isSubmittingTask = true;
	    var oldTaskId = task.id;
	    var preparation = task.preparation != null && task.preparation !== '' ? task.preparation * 1 : null;
	    _docendo2.default.updateTask(task.schoolId, task.schoolYearId, task.id, task.name, task.color, task.hours, task.defaultDuration, preparation, task.belongsToCalendars, task.userCalendars, task.inUserCalendar, task.fromDate, task.toDate, function (data) {
	      if (data && data.status === 'error') {
	        console.warn('updateTask backend error:', data.message);
	        _eventbus2.default.toast = { text: 'Kunne ikke gemme opgaven - prøv igen', success: false };
	        context.state.isSubmittingTask = false;
	        context.dispatch('reloadTasks', task.schoolYearId);
	        return;
	      }
	      var updated = data;
	      updated['oldId'] = oldTaskId;
	      context.commit('updateTask', updated);
	      context.state.isSubmittingTask = false;
	      context.dispatch('reloadTasks', updated.school_year_id);
	    }, function (failure) {
	      console.warn('updateTask failure', failure);
	      _eventbus2.default.toast = { text: 'Kunne ikke gemme opgaven - prøv igen', success: false };
	      context.state.isSubmittingTask = false;
	      context.dispatch('reloadTasks', task.schoolYearId);
	    });
	  },
	  deleteTask: function deleteTask(context, task) {
	    var subjectIds = task.subject_ids || [];
	    if (subjectIds.length === 0) {
	      context.commit('deleteTask', { id: task.id });
	      return;
	    }
	    var refreshSubjects = function refreshSubjects() {
	      _docendo2.default.readSubjects(task.school_id, task.school_year_id, null, function (subjects) {
	        context.commit('setSubjects', subjects);
	      }, function () {});
	    };
	    _docendo2.default.bulkDeleteSubjects(task.school_id, subjectIds, function (data) {
	      var result = typeof data === 'string' ? JSON.parse(data) : data;
	      if (result && Array.isArray(result.deleted)) {
	        result.deleted.forEach(function (subj) {
	          context.commit('deleteSubject', subj);
	          window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: subj }));
	        });
	      }
	      var hasErrors = result && Array.isArray(result.errors) && result.errors.length > 0;
	      if (hasErrors) {
	        _eventbus2.default.toast = { text: 'Nogle brikker kunne ikke slettes pga. skemalagte begivenheder', success: false };
	      } else {
	        context.commit('deleteTask', { id: task.id });
	      }
	      refreshSubjects();
	    }, function (failure) {
	      console.warn('deleteTask failure', failure);
	      _eventbus2.default.toast = { text: 'Kunne ikke slette opgaven - prøv igen', success: false };
	      refreshSubjects();
	    });
	  },
	  readSubjectRequests: function readSubjectRequests(context, activeSchoolYearId) {
	    var schoolId = context.getters.schoolId;
	    context.state.isLoadingSubjectsRequests = true;
	    _docendo2.default.listSubjectRequests(schoolId, activeSchoolYearId, function (data) {
	      if (data.status !== 'error') {
	        context.state.subjectsRequests = data;
	      }
	      context.state.isLoadingSubjectsRequests = false;
	    }, function (failure) {
	      console.log('failed read tasks');
	    });
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(51);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(35);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(50);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _getIterator2 = __webpack_require__(45);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vue = __webpack_require__(41);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _momentRange = __webpack_require__(39);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	
	
	var state = {
	  allUsers: [],
	  allUsersAndEvents: null,
	  allEvents: [],
	  allDayEventsRaw: [],
	  allEventsInAHash: {},
	  allEventsWithMultipleTeachersOn: {},
	  allCalsWithEventIdsInHash: {},
	  allAbsenceEventInEventSerialIdsHash: {},
	  date: moment().utc(),
	  activeEvent: null,
	  activeUser: null,
	  schedulerActiveEvent: { 'left': 0, 'right': 0, color: '' },
	  absenceReasons: [],
	  longAbsentList: [],
	  isSortSubActive: false,
	  sortSubs: 0,
	  usersAndSubstituteHours: {},
	  dataIsLoading: false,
	  eventsRequestId: 0,
	  sortingHierarchy: {
	    canceledHours: 0,
	    othersOnLesson: 3,
	    isInSameClassAtTheSameTime: 6,
	    hasHoursInClassOnDay: 9,
	    availableHour: 12,
	    presence: 15,
	    multipleLessonsInSameClasses: 18,
	    notOccupiedWithLessonsOnDay: 21,
	    notOccupiedWithoutLessonsOnDay: 24,
	    occupied: 27,
	    absence: 30
	  },
	  activeAbsenceReason: null,
	  isActiveAbsenceReasonIsReadyToDelete: false,
	  activeAbsentUser: null,
	  activeAbsentUserEvents: [],
	  activeAbsentUserOriginalEvents: [],
	  activeEvents: [],
	  isActiveEventsLoading: false,
	  theActiveEventsLoadingOnCalendarId: null
	};
	
	var getters = {
	  allUsersSortedOnName: function allUsersSortedOnName(state) {
	    var removeNullFromUsers = state.allUsers.filter(function (user) {
	      return user.name !== null && user.name !== '';
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(removeNullFromUsers);
	  },
	  allUsersSortedIds: function allUsersSortedIds(state, getters) {
	    return getters.allUsersSortedOnName.map(function (user) {
	      return user.user_calendar_id;
	    });
	  },
	  userSet: function userSet(state, getters) {
	    return getters.allUsersSortedIds.map(function (userId) {
	      return state.allUsersAndEvents[userId];
	    });
	  },
	  absentUsersFromUserSet: function absentUsersFromUserSet(state, getters) {
	    return getters.userSet.filter(function (user) {
	      return user.dayAbsence.length > 0;
	    });
	  },
	  substitutesToday: function substitutesToday(state, getters) {
	    return getters.userSet.filter(function (user) {
	      return user.daySubEvents.length > 0;
	    });
	  },
	  absentUsersGetDate: function absentUsersGetDate(state) {
	    return moment(state.date).format('YYYY_MM_DD');
	  },
	  absentUsersHandledHash: function absentUsersHandledHash(state, getters) {
	    var hash = {};
	
	    getters.absentUsersFromUserSet.forEach(function (user) {
	      var userStatus = 1;
	      var isAnyEventsPending = false;
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(user.dayAbsence), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var dayAbsence = _step.value;
	
	          var userEvents = user.dayEvents.map(function (dayEventId) {
	            return state.allEventsInAHash[dayEventId];
	          }).filter(function (dayEvent) {
	            return dayEvent && !dayEvent.v_is_event_from_other_school;
	          });
	
	          if (userEvents.length === 0) {
	            var absence = state.allEventsInAHash[dayAbsence] || {};
	            var subStatus = absence.substitution_status ? JSON.parse(absence.substitution_status) : {};
	            var status = subStatus[user.user_calendar_id] && subStatus[user.user_calendar_id].status !== undefined ? subStatus[user.user_calendar_id].status : 1;
	            if (status === 0) {
	              userStatus = 0;
	              break;
	            }
	          }
	
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = (0, _getIterator3.default)(userEvents), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var lesson = _step2.value;
	
	              var _absence = state.allEventsInAHash[dayAbsence] || {};
	              var normalizedStart = moment(_absence.start).millisecond(0);
	              var normalizedEnd = moment(_absence.end).millisecond(0);
	              var absenceRange = moment.range(normalizedStart, normalizedEnd);
	              var lessonRange = moment.range(lesson.start, lesson.end);
	
	              if (absenceRange.overlaps(lessonRange)) {
	                var _subStatus = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	                var _status = lesson.canceled === true ? 1 : _subStatus[user.user_calendar_id] && _subStatus[user.user_calendar_id].status !== undefined ? _subStatus[user.user_calendar_id].status : 0;
	                if (_status === 2) {
	                  isAnyEventsPending = true;
	                }
	
	                var isUserSubstituted = lesson.calendar_events.some(function (calEvent) {
	                  return calEvent.substitute_for_user_id === user.id;
	                });
	
	                if (!isUserSubstituted && _status === 0) {
	                  userStatus = 0;
	                  break;
	                }
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      hash[user.id] = userStatus === 1 && isAnyEventsPending ? 2 : userStatus;
	    });
	
	    return hash;
	  },
	  absentUsersUnhandled: function absentUsersUnhandled(state, getters) {
	    return getters.absentUsersFromUserSet.filter(function (user) {
	      return !getters.absentUsersHandledHash[user.id];
	    });
	  },
	  absentUsersHandled: function absentUsersHandled(state, getters) {
	    return getters.absentUsersFromUserSet.filter(function (user) {
	      return getters.absentUsersHandledHash[user.id];
	    });
	  },
	  notAbsentUsersFromUserSet: function notAbsentUsersFromUserSet(state, getters) {
	    return getters.userSet.filter(function (user) {
	      return user.dayAbsence.length < 1;
	    });
	  },
	  subsAbsenceReasonsSorted: function subsAbsenceReasonsSorted(state, getters) {
	    return state.absenceReasons.sort(function (a, b) {
	      var nameA = a.name.toUpperCase().trim();
	      var nameB = b.name.toUpperCase().trim();
	      if (nameA < nameB) return -1;
	      if (nameA > nameB) return 1;
	      return 0;
	    });
	  },
	
	  longAbsentListInHash: function longAbsentListInHash(state, getters) {
	    return state.longAbsentList.reduce(function (obj, item) {
	      obj[item.id] = item;
	      return obj;
	    }, {});
	  },
	  usersWithOngoingAbsenceInHash: function usersWithOngoingAbsenceInHash(state, getters) {
	    var users = {};
	    state.longAbsentList.filter(function (absence) {
	      return absence.ongoing;
	    }).forEach(function (absence) {
	      if (!users[absence.calendar_id]) {
	        _vue2.default.set(users, absence.calendar_id, { absenceArr: [absence.id] });
	      } else {
	        users[absence.calendar_id].absenceArr.push(absence.id);
	      }
	    });
	    return users;
	  },
	  activeAbsentUserEventsInHash: function activeAbsentUserEventsInHash(state, getters) {
	    return state.activeAbsentUserEvents.reduce(function (obj, item) {
	      obj[item.event_id] = item;
	      return obj;
	    }, {});
	  },
	  activeAbsentUserOriginalEventsInHash: function activeAbsentUserOriginalEventsInHash(state, getters) {
	    return state.activeAbsentUserOriginalEvents.reduce(function (obj, item) {
	      obj[item.event_id] = item;
	      return obj;
	    }, {});
	  }
	};
	
	function applySubPoolsToUser(item, state) {
	  var hoursRaw = state.usersAndSubstituteHours && state.usersAndSubstituteHours[item.id];
	  var used = hoursRaw !== undefined && hoursRaw !== null ? Number(hoursRaw) : 0;
	
	  var pool = 0;
	  if (item.current_user_year && item.current_user_year.substitute_pool_hours) {
	    pool = Number(item.current_user_year.substitute_pool_hours);
	  }
	
	  var diff = pool - used;
	  var subPolsDiff = Math.round(diff * 10) / 10;
	
	  var substituteHours = used.toFixed(1);
	
	  _vue2.default.set(item, 'substituteHours', substituteHours);
	  _vue2.default.set(item, 'subPoolsDiff', subPolsDiff);
	}
	
	function isAwayLesson(event) {
	  return !!(event && event.away && event.event_type !== 'absence');
	}
	
	function userHasRealAbsence(state, calId) {
	  var user = state.allUsersAndEvents && state.allUsersAndEvents[calId];
	  if (!user || !user.dayAbsence) {
	    return false;
	  }
	  for (var i = 0; i < user.dayAbsence.length; i++) {
	    var event = state.allEventsInAHash[user.dayAbsence[i]];
	    if (event && event.event_type === 'absence') {
	      return true;
	    }
	  }
	  return false;
	}
	
	function moveEventId(fromArr, toArr, eventId) {
	  if (!fromArr || !toArr) {
	    return;
	  }
	  var fromIdx = fromArr.indexOf(eventId);
	  if (fromIdx > -1) {
	    fromArr.splice(fromIdx, 1);
	  }
	  if (toArr.indexOf(eventId) < 0) {
	    toArr.push(eventId);
	  }
	}
	
	function invalidateInFlightEventReloads(state) {
	  state.eventsRequestId = (state.eventsRequestId || 0) + 1;
	}
	
	function _reclassifyAwayEventsForUser(state, calId) {
	  var user = state.allUsersAndEvents && state.allUsersAndEvents[calId];
	  if (!user) {
	    return;
	  }
	  var hasRealAbsence = userHasRealAbsence(state, calId);
	  var sourceIds = hasRealAbsence ? (user.dayAbsence || []).slice() : (user.dayEvents || []).slice();
	  for (var i = 0; i < sourceIds.length; i++) {
	    var eventId = sourceIds[i];
	    var event = state.allEventsInAHash[eventId];
	    if (!isAwayLesson(event)) {
	      continue;
	    }
	    if (hasRealAbsence) {
	      moveEventId(user.dayAbsence, user.dayEvents, eventId);
	    } else {
	      moveEventId(user.dayEvents, user.dayAbsence, eventId);
	    }
	  }
	}
	
	var mutations = {
	  setSubDate: function setSubDate(state, date) {
	    state.date = moment(date).format('YYYY-MM-DD');
	  },
	
	  setAllUsers: function setAllUsers(state, data) {
	    console.time('create User Arr');
	    state.allUsers = data;
	    var users = state.allUsers;
	
	    var allUsers = users.reduce(function (obj, item) {
	      _vue2.default.set(item, 'dayEvents', []);
	      _vue2.default.set(item, 'daySubEvents', []);
	      _vue2.default.set(item, 'dayAbsence', []);
	      _vue2.default.set(item, 'dayPresence', []);
	      _vue2.default.set(item, 'dayAllEvents', []);
	      _vue2.default.set(item, 'dayAvailability', []);
	      _vue2.default.set(item, 'canceledEvents', []);
	      _vue2.default.set(item, 'v_two_in_class_events', []);
	      _vue2.default.set(item, 'v_two_events_in_class_events', []);
	
	      applySubPoolsToUser(item, state);
	
	      obj[item.user_calendar_id] = item;
	      return obj;
	    }, {});
	
	    state.allUsersAndEvents = allUsers;
	    console.timeEnd('create User Arr');
	  },
	  addEventOnAllUsersWithEvents: function addEventOnAllUsersWithEvents(state, data) {
	    if (state.allUsersAndEvents[data.cal_id] && state.allUsersAndEvents[data.cal_id].dayEvents && !state.allUsersAndEvents[data.cal_id].dayEvents.includes(data.event_id)) {
	      state.allUsersAndEvents[data.cal_id].dayEvents.push(data.event_id);
	    }
	  },
	  addANewEvent: function addANewEvent(state, lesson) {
	    state.allEvents.push(lesson);
	    state.allEventsInAHash[lesson.id] = lesson;
	    lesson.calendar_events.forEach(function (user) {
	      if (state.allUsersAndEvents[user.calendar_id]) {
	        state.allUsersAndEvents[user.calendar_id].dayEvents.push(lesson.id);
	      }
	    });
	  },
	  addAbsenceToUserInAllUsersWithEvents: function addAbsenceToUserInAllUsersWithEvents(state, data) {
	    invalidateInFlightEventReloads(state);
	    state.allUsersAndEvents[data.cal_id].dayAbsence.push(data.event_id);
	    _reclassifyAwayEventsForUser(state, data.cal_id);
	  },
	  removeAbsenceOnAllUsersWithEvents: function removeAbsenceOnAllUsersWithEvents(state, data) {
	    var idx = state.allUsersAndEvents[data.cal_id].dayAbsence.indexOf(data.event_id);
	    if (idx > -1) {
	      state.allUsersAndEvents[data.cal_id].dayAbsence.splice(idx, 1);
	    }
	  },
	  removeEventOnAllUsersWithEvents: function removeEventOnAllUsersWithEvents(state, data) {
	    var idx = state.allUsersAndEvents[data.cal_id].dayEvents.indexOf(data.event_id);
	    if (idx > -1) {
	      state.allUsersAndEvents[data.cal_id].dayEvents.splice(idx, 1);
	    }
	  },
	  reclassifyAwayEventsForUser: function reclassifyAwayEventsForUser(state, calId) {
	    _reclassifyAwayEventsForUser(state, calId);
	  },
	  setAllEvents: function setAllEvents(state, data) {
	    state.allEvents = data;
	    var events = state.allEvents;
	    state.allEventsInAHash = events.reduce(function (obj, item) {
	      obj[item.id] = item;
	      return obj;
	    }, {});
	  },
	  updateEventOnAllEventsInAHash: function updateEventOnAllEventsInAHash(state, event) {
	    _vue2.default.set(state.allEventsInAHash, event.id, event);
	  },
	  updateTeacherNoteOnEvent: function updateTeacherNoteOnEvent(state, eventIdAndTeacherNote) {
	    state.allEventsInAHash[eventIdAndTeacherNote.eventId].teacher_notes = eventIdAndTeacherNote.note;
	  },
	  updateAllEventsWithMultipleTeachersOn: function updateAllEventsWithMultipleTeachersOn(state, data) {
	    _vue2.default.set(state.allEventsWithMultipleTeachersOn, data.userAndEventIds, data.userCalIds);
	  },
	  updateSubStatusOnEvent: function updateSubStatusOnEvent(state, eventIdAndsubstitutionStatus) {
	    state.allEventsInAHash[eventIdAndsubstitutionStatus.eventId].substitution_status = eventIdAndsubstitutionStatus.status;
	  },
	  setActiveUser: function setActiveUser(state, data) {
	    state.activeUser = data;
	  },
	  setActiveEvent: function setActiveEvent(state, data) {
	    state.activeEvents = [];
	    state.activeEvent = data;
	  },
	  clearActiveEvents: function clearActiveEvents(state) {
	    state.activeEvents = [];
	  },
	  setActiveEvents: function setActiveEvents(state, dbEvent) {
	    var idx = state.activeEvents.findIndex(function (e) {
	      return e.event_id === dbEvent.event_id && e.calendar_id === dbEvent.calendar_id;
	    });
	
	    if (idx !== -1) {
	      state.activeEvents.splice(idx, 1);
	    } else {
	      state.activeEvents.push(dbEvent);
	    }
	  },
	  subsSetAbsenceReasons: function subsSetAbsenceReasons(state, data) {
	    state.absenceReasons = data;
	  },
	  subsAddNewAbsenceReason: function subsAddNewAbsenceReason(state, data) {
	    state.absenceReasons.push(data);
	  },
	  subsSetLongAbsentList: function subsSetLongAbsentList(state, data) {
	    state.longAbsentList = data;
	  },
	  setIsSubScoreActive: function setIsSubScoreActive(state, boolean) {
	    state.isSortSubActive = boolean;
	  },
	
	  setUsersWithSubPools: function setUsersWithSubPools(state, data) {
	    state.usersAndSubstituteHours = data;
	
	    if (state.allUsers && state.allUsers.length) {
	      for (var i = 0; i < state.allUsers.length; i++) {
	        var item = state.allUsers[i];
	        applySubPoolsToUser(item, state);
	
	        if (state.allUsersAndEvents && item.user_calendar_id) {
	          _vue2.default.set(state.allUsersAndEvents, item.user_calendar_id, item);
	        }
	      }
	    }
	  },
	  setSortSubsAgain: function setSortSubsAgain() {
	    state.sortSubs++;
	  },
	  setCalsInAllCalsAndEvents: function setCalsInAllCalsAndEvents(state, data) {
	    _vue2.default.set(state.allCalsWithEventIdsInHash, data.calid, { lessons: [data.eventid] });
	  },
	  addEventInAllCalsAndEvents: function addEventInAllCalsAndEvents(state, data) {
	    state.allCalsWithEventIdsInHash[data.calid].lessons.push(data.eventid);
	  },
	  setSortingHierarchy: function setSortingHierarchy(state, obj) {
	    var isMissingCanceledHours = !('canceledHours' in obj);
	    var isMissingHasHoursInClassOnDay = !('hasHoursInClassOnDay' in obj);
	    (0, _entries2.default)(obj).forEach(function (_ref) {
	      var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	          key = _ref2[0],
	          value = _ref2[1];
	
	      state.sortingHierarchy[key] = isMissingCanceledHours ? value + 3 : value;
	    });
	    if (isMissingCanceledHours) {
	      var fixedDefaults = {
	        notOccupiedWithoutLessonsOnDay: 18,
	        occupied: 21,
	        absence: 24
	      };
	      (0, _entries2.default)(fixedDefaults).forEach(function (_ref3) {
	        var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
	            key = _ref4[0],
	            def = _ref4[1];
	
	        if (!(key in obj)) {
	          state.sortingHierarchy[key] = def + 3;
	        }
	      });
	      state.sortingHierarchy.canceledHours = 0;
	    }
	
	    if (isMissingHasHoursInClassOnDay) {
	      var insertAfter = state.sortingHierarchy.isInSameClassAtTheSameTime !== undefined ? state.sortingHierarchy.isInSameClassAtTheSameTime : 6;
	      (0, _keys2.default)(state.sortingHierarchy).forEach(function (key) {
	        if (key !== 'hasHoursInClassOnDay' && state.sortingHierarchy[key] > insertAfter) {
	          state.sortingHierarchy[key] += 3;
	        }
	      });
	      state.sortingHierarchy.hasHoursInClassOnDay = insertAfter + 3;
	    }
	  },
	  setActiveAbsenceReason: function setActiveAbsenceReason(state, obj) {
	    state.activeAbsenceReason = obj;
	  },
	  updateLongListAbsence: function updateLongListAbsence(state, data) {
	    var idx = state.longAbsentList.findIndex(function (absence) {
	      return absence.id === data.id;
	    });
	    _vue2.default.set(state.longAbsentList, idx, data);
	  },
	  deleteLongListAbsenceItem: function deleteLongListAbsenceItem(state, eventSerial) {
	    var idx = state.longAbsentList.findIndex(function (absence) {
	      return absence.id === eventSerial.eventSerialId;
	    });
	    if (idx > -1) {
	      state.longAbsentList.splice(idx, 1);
	    }
	  },
	  setIsActiveAbsenceReasonIsReadyToDelete: function setIsActiveAbsenceReasonIsReadyToDelete(state, boolean) {
	    state.isActiveAbsenceReasonIsReadyToDelete = boolean;
	  },
	  setActiveAbsentUser: function setActiveAbsentUser(state, user) {
	    state.activeAbsentUser = user;
	  },
	  setActiveAbsentUserEvents: function setActiveAbsentUserEvents(state, events) {
	    state.activeAbsentUserEvents = events;
	  },
	  setActiveAbsentUserOriginalEvents: function setActiveAbsentUserOriginalEvents(state, events) {
	    state.activeAbsentUserOriginalEvents = events;
	  },
	  setAllEventsOnUsers: function setAllEventsOnUsers(state, data) {
	    console.time('vuex::setAllEventsOnUsers');
	    state.allDayEventsRaw = data;
	    var includeReservations = !!(this.state.schoolSettings && this.state.schoolSettings.includeReservationsInSubstitution);
	    var events = includeReservations ? data : data.filter(function (event) {
	      return event.event_type !== 'reservation';
	    });
	
	    var activeSchoolId = window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id * 1 : null;
	    var hideOtherSchoolAbsenceSchoolIds = [64228, 64229];
	    var shouldHideOtherSchoolAbsence = hideOtherSchoolAbsenceSchoolIds.indexOf(activeSchoolId) > -1;
	    var eventsWithoutOtherSchoolAbsence = shouldHideOtherSchoolAbsence ? events.filter(function (event) {
	      if (event.event_type !== 'absence') {
	        return true;
	      }
	      return !event.school_id || event.school_id * 1 === activeSchoolId;
	    }) : events;
	    var allEvents = eventsWithoutOtherSchoolAbsence;
	    this.commit('setAllEvents', eventsWithoutOtherSchoolAbsence);
	
	    var usersWithEvents = state.allUsersAndEvents;
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	      for (var _iterator3 = (0, _getIterator3.default)((0, _keys2.default)(usersWithEvents)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	        var key = _step3.value;
	
	        _vue2.default.set(usersWithEvents[key], 'dayAllEvents', []);
	        _vue2.default.set(usersWithEvents[key], 'dayEvents', []);
	        _vue2.default.set(usersWithEvents[key], 'daySubEvents', []);
	        _vue2.default.set(usersWithEvents[key], 'dayAbsence', []);
	        _vue2.default.set(usersWithEvents[key], 'dayPresence', []);
	        _vue2.default.set(usersWithEvents[key], 'subScore', [0, 0, 0]);
	        _vue2.default.set(usersWithEvents[key], 'dayAvailability', []);
	        _vue2.default.set(usersWithEvents[key], 'canceledEvents', []);
	        _vue2.default.set(usersWithEvents[key], 'v_two_in_class_events', []);
	        _vue2.default.set(usersWithEvents[key], 'v_two_events_in_class_events', []);
	      }
	    } catch (err) {
	      _didIteratorError3 = true;
	      _iteratorError3 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion3 && _iterator3.return) {
	          _iterator3.return();
	        }
	      } finally {
	        if (_didIteratorError3) {
	          throw _iteratorError3;
	        }
	      }
	    }
	
	    state.allCalsWithEventIdsInHash = {};
	    state.allAbsenceEventInEventSerialIdsHash = {};
	    var usersWithRealAbsence = {};
	    for (var i = 0; i < allEvents.length; i++) {
	      var event = allEvents[i];
	      if (event.event_type !== 'absence' || !event.calendar_events) {
	        continue;
	      }
	      for (var j = 0; j < event.calendar_events.length; j++) {
	        usersWithRealAbsence[event.calendar_events[j].calendar_id] = true;
	      }
	    }
	
	    var klassEventsMap = {};
	
	    var _loop = function _loop(_i) {
	      var event = allEvents[_i];
	      var klassEvents = event.calendar_events.filter(function (ce) {
	        return ce.calendar_type === 'klass';
	      });
	
	      klassEvents.forEach(function (klassEvent) {
	        var klassId = klassEvent.calendar_id;
	        var start = event.start;
	        var end = event.end;
	
	        if (!klassEventsMap[klassId]) {
	          klassEventsMap[klassId] = [];
	        }
	
	        var overlapping = klassEventsMap[klassId].find(function (existingEvent) {
	          return existingEvent.start === start && existingEvent.end === end;
	        });
	        klassEventsMap[klassId].push({ start: start, end: end, event: event });
	        if (overlapping) {
	          overlapping.event.calendar_events.forEach(function (calEvent) {
	            var userCalId = calEvent.calendar_id;
	            var user = usersWithEvents[userCalId];
	            if (calEvent.calendar_type === 'user' && user) {
	              usersWithEvents[userCalId].v_two_events_in_class_events.push(overlapping.event.id);
	              usersWithEvents[userCalId].v_two_events_in_class_events.push(event.id);
	            }
	          });
	          event.calendar_events.forEach(function (calEvent) {
	            var userCalId = calEvent.calendar_id;
	            var user = usersWithEvents[userCalId];
	            if (calEvent.calendar_type === 'user' && user) {
	              var _userCalId = calEvent.calendar_id;
	              usersWithEvents[_userCalId].v_two_events_in_class_events.push(overlapping.event.id);
	              usersWithEvents[_userCalId].v_two_events_in_class_events.push(event.id);
	            }
	          });
	        }
	      });
	    };
	
	    for (var _i = 0; _i < allEvents.length; _i++) {
	      _loop(_i);
	    }
	
	    for (var _i2 = 0; _i2 < allEvents.length; _i2++) {
	      var _event = allEvents[_i2];
	      if (_event.calendar_events) {
	        var userCount = _event.calendar_events.filter(function (ce) {
	          return ce.calendar_type === 'user';
	        }).length;
	        var hasKlass = _event.calendar_events.some(function (ce) {
	          return ce.calendar_type === 'klass';
	        });
	        var hasTwoOrMoreTeachersInClass = userCount > 1 && hasKlass;
	
	        for (var _j = 0; _j < _event.calendar_events.length; _j++) {
	          var calendarEvent = _event.calendar_events[_j];
	          var calId = calendarEvent.calendar_id;
	
	          if (hasTwoOrMoreTeachersInClass && usersWithEvents[calId]) {
	            usersWithEvents[calId].v_two_in_class_events.push(_event.id);
	          }
	
	          if (state.allCalsWithEventIdsInHash[calId]) {
	            this.commit('addEventInAllCalsAndEvents', {
	              calid: calId,
	              eventid: _event.id
	            });
	          } else {
	            this.commit('setCalsInAllCalsAndEvents', {
	              calid: calId,
	              eventid: _event.id
	            });
	          }
	
	          if (usersWithEvents[calId]) {
	            state.allUsersAndEvents[calId].dayAllEvents.push(_event.id);
	            var treatAwayAsAbsence = _event.away && !usersWithRealAbsence[calId];
	            if (_event.event_type === 'absence' || treatAwayAsAbsence) {
	              state.allUsersAndEvents[calId].dayAbsence.push(_event.id);
	              if (_event.event_serial_id) {
	                _vue2.default.set(state.allAbsenceEventInEventSerialIdsHash, _event.event_serial_id, _event);
	              }
	            } else if (_event.away && usersWithRealAbsence[calId]) {
	              if (_event.canceled) {
	                state.allUsersAndEvents[calId].canceledEvents.push(_event.id);
	              }
	              state.allUsersAndEvents[calId].dayEvents.push(_event.id);
	            } else if (_event.event_type === null || _event.event_type === 'presence') {
	              state.allUsersAndEvents[calId].dayPresence.push(_event.id);
	            } else {
	              if (_event.event_type === 'available') {
	                state.allUsersAndEvents[calId].dayAvailability.push(_event.id);
	              }
	              if (_event.canceled) {
	                state.allUsersAndEvents[calId].canceledEvents.push(_event.id);
	              }
	              state.allUsersAndEvents[calId].dayEvents.push(_event.id);
	            }
	
	            if (calendarEvent.substitute || calendarEvent.is_substitute || calendarEvent.substitute_for_user_id) {
	              state.allUsersAndEvents[calId].daySubEvents.push(_event.id);
	            }
	          }
	        }
	      }
	    }
	
	    var usersWithEventsInArry = (0, _keys2.default)(usersWithEvents).map(function (key) {
	      return usersWithEvents[key];
	    });
	    state.usersWithEvents = usersWithEventsInArry;
	    state.dataIsLoading = false;
	    console.timeEnd('vuex::setAllEventsOnUsers');
	  }
	};
	
	var actions = {
	  updateStatusOnActiveEvents: function updateStatusOnActiveEvents(context, status) {
	    context.state.isActiveEventsLoading = true;
	    var updates = {};
	    context.state.activeEvents.forEach(function (event) {
	      var lesson = event.lesson;
	      var statusData = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	      statusData[event.calendar_id] = { 'status': status * 1 };
	      var eventMap = {
	        event_id: event.event_id,
	        substitution_status: (0, _stringify2.default)(statusData)
	      };
	      var schoolId = event && event.school_id ? event.school_id : null;
	      if (!updates[schoolId]) {
	        updates[schoolId] = [eventMap];
	      } else {
	        updates[schoolId].push(eventMap);
	      }
	    });
	    var successTxt = window.use_i18n.t('vue2.substitution.lessons_updated');
	    var errorTxt = 'Something went wrong';
	    (0, _keys2.default)(updates).forEach(function (schoolId) {
	      _docendo2.default.updateEvents(schoolId, updates[schoolId], function (success) {
	        context.state.activeEvents = [];
	        context.state.isActiveEventsLoading = false;
	        success.forEach(function (event) {
	          var lesson = JSON.parse(event);
	          context.commit('updateEventOnAllEventsInAHash', lesson);
	        });
	        _eventbus2.default.toast = { text: successTxt, success: true };
	      }, function (failure) {
	        context.state.isActiveEventsLoading = false;
	        _eventbus2.default.toast = { text: errorTxt, success: false };
	      });
	    });
	  },
	  addSubToActiveEvents: function addSubToActiveEvents(context, userCalendarId) {
	    context.state.isActiveEventsLoading = true;
	    context.state.theActiveEventsLoadingOnCalendarId = userCalendarId;
	    var updates = {};
	    context.state.activeEvents.forEach(function (event) {
	      var eventMap = {
	        event_id: event.event_id,
	        calendar_id: event.calendar_id,
	        add_substitute_calendar_id: userCalendarId
	      };
	      var schoolId = event && event.school_id ? event.school_id : null;
	      if (!updates[schoolId]) {
	        updates[schoolId] = [eventMap];
	      } else {
	        updates[schoolId].push(eventMap);
	      }
	    });
	    var successTxt = window.use_i18n.t('vue2.substitution.lessons_updated');
	    var errorTxt = 'Something went wrong';
	    (0, _keys2.default)(updates).forEach(function (schoolId) {
	      _docendo2.default.updateEvents(schoolId, updates[schoolId], function (success) {
	        context.state.activeEvents = [];
	        context.state.isActiveEventsLoading = false;
	        context.state.theActiveEventsLoadingOnCalendarId = null;
	        success.forEach(function (event) {
	          var lesson = JSON.parse(event);
	          context.commit('updateEventOnAllEventsInAHash', lesson);
	          var userEventObj = { cal_id: userCalendarId, event_id: lesson.id };
	          context.commit('addEventOnAllUsersWithEvents', userEventObj);
	        });
	        _eventbus2.default.toast = { text: successTxt, success: true };
	      }, function (failure) {
	        context.state.isActiveEventsLoading = false;
	        context.state.theActiveEventsLoadingOnCalendarId = null;
	        _eventbus2.default.toast = { text: errorTxt, success: false };
	      });
	    });
	  },
	  getAllUsers: function getAllUsers(context, schoolId, userIdsFilter) {
	    _docendo2.default.schoolUsers(window.SCHOOL.id, userIdsFilter, function (data) {
	      context.commit('setAllUsers', data);
	    });
	  },
	  readAllEvents: function readAllEvents(context, storeObj) {
	    var activeSchoolId = window.SCHOOL.id * 1;
	    var events = [];
	    var requestId = ++context.state.eventsRequestId;
	    var requestedDate = moment(context.state.date).format('YYYY-MM-DD');
	    context.state.dataIsLoading = true;
	    _docendo2.default.listEventsForSchools(storeObj.schoolIds, requestedDate, function (data) {
	      if (requestId !== context.state.eventsRequestId) {
	        return;
	      }
	      if (moment(context.state.date).format('YYYY-MM-DD') !== requestedDate) {
	        return;
	      }
	      if (data.status === 'error') {
	        context.dispatch('getAllDayEvents');
	      } else {
	        var parsedData = JSON.parse(data);
	        parsedData.forEach(function (event) {
	          var idx = events.findIndex(function (lesson) {
	            return lesson.id === event.id;
	          });
	          if (idx < 0) {
	            if (!storeObj.isShowEventsFromOtherThanActiveSchool && event.school_id * 1 !== activeSchoolId) {
	              _vue2.default.set(event, 'v_is_event_from_other_school', true);
	            }
	            events.push(event);
	          }
	        });
	        context.commit('setAllEventsOnUsers', events);
	      }
	    }, function (failure) {
	      if (requestId !== context.state.eventsRequestId) {
	        return;
	      }
	
	      window.alert('Something went wrong');
	      context.state.dataIsLoading = false;
	      context.commit('setAllEventsOnUsers', events);
	    });
	  },
	  getAllDayEvents: function getAllDayEvents(context) {
	    var requestId = ++context.state.eventsRequestId;
	    var requestedDate = moment(context.state.date).format('YYYY-MM-DD');
	    context.state.dataIsLoading = true;
	    _docendo2.default.listEvents(window.SCHOOL.id, requestedDate, function (data) {
	      if (requestId !== context.state.eventsRequestId) {
	        return;
	      }
	      if (moment(context.state.date).format('YYYY-MM-DD') !== requestedDate) {
	        return;
	      }
	      context.commit('setAllEventsOnUsers', JSON.parse(data));
	    });
	  },
	  getUserSubPools: function getUserSubPools(context) {
	    _docendo2.default.schoolSubstituteHours(window.SCHOOL.id, function (data) {
	      context.commit('setUsersWithSubPools', data);
	    });
	  },
	  subsGetAbsenceReasons: function subsGetAbsenceReasons(context) {
	    _docendo2.default.schoolAbsenceSubjectsList(window.SCHOOL.id, false, function (data) {
	      context.commit('subsSetAbsenceReasons', data);
	    });
	  },
	  subsGetLongAbsenceList: function subsGetLongAbsenceList(context) {
	    _docendo2.default.schoolEventSerialsList(window.SCHOOL.id, context.state.date, function (data) {
	      context.commit('subsSetLongAbsentList', data);
	    });
	  },
	  setActiveSchedulerEvent: function setActiveSchedulerEvent(context, data) {
	    context.state.schedulerActiveEvent = data;
	    if (!context.state.isSortSubActive || !data.userIsAbsent || data.obj.event_type === 'absence') {
	      return;
	    }
	    console.time('subScore');
	    var overlappingEvents = {
	      absence: {},
	      available: {},
	      presence: {},
	      severalOnLesson: {},
	      lessonsInSameClass: {},
	      lessons: {},
	      multipleLessonsInSameClasses: {},
	      canceledHours: {},
	      hasHoursInClassOnDay: {}
	    };
	    var otherOnlessonHash = {};
	    var overlappingLessonsInClassHash = {};
	
	    if (data.othersOnLesson) {
	      otherOnlessonHash = data.othersOnLesson.reduce(function (obj, item) {
	        obj[item.user_calendar_id] = item;
	        return obj;
	      }, {});
	    }
	    if (data.overlappingEvents) {
	      data.overlappingEvents.forEach(function (event) {
	        switch (event.event_type) {
	          case 'absence':
	            event.calendar_events.forEach(function (cal) {
	              overlappingEvents.absence[cal.calendar_id] = cal.calendar_id;
	            });
	            break;
	          case 'available':
	            event.calendar_events.forEach(function (cal) {
	              overlappingEvents.available[cal.calendar_id] = cal.calendar_id;
	            });
	            break;
	          case 'presence':
	            var overlapping = moment(context.state.schedulerActiveEvent.obj.start).isBetween(event.start, event.end, null, '[]') && moment(context.state.schedulerActiveEvent.obj.end).isBetween(event.start, event.end, null, '[]');
	            event.calendar_events.forEach(function (cal) {
	              if (overlapping) {
	                overlappingEvents.presence[cal.calendar_id] = cal.calendar_id;
	              }
	            });
	            break;
	          case null:
	            var overlap = moment(context.state.schedulerActiveEvent.obj.start).isBetween(event.start, event.end, null, '[]') && moment(context.state.schedulerActiveEvent.obj.end).isBetween(event.start, event.end, null, '[]');
	            event.calendar_events.forEach(function (cal) {
	              if (overlap) {
	                overlappingEvents.presence[cal.calendar_id] = cal.calendar_id;
	              }
	            });
	            break;
	          default:
	            if (event.canceled) {
	              event.calendar_events.forEach(function (cal) {
	                if (context.state.allUsersAndEvents[cal.calendar_id]) {
	                  overlappingEvents.canceledHours[cal.calendar_id] = cal.calendar_id;
	                }
	              });
	              break;
	            }
	            event.calendar_events.forEach(function (cal) {
	              var arrOfCalIdsOnActiveEvent = context.state.schedulerActiveEvent.obj.calendar_events.map(function (cal) {
	                return cal.calendar_id;
	              });
	
	              if (event.id !== context.state.schedulerActiveEvent.obj.id && arrOfCalIdsOnActiveEvent.indexOf(cal.calendar_id) > -1) {
	                event.calendar_events.forEach(function (cal) {
	                  overlappingEvents.lessonsInSameClass[cal.calendar_id] = cal.calendar_id;
	                });
	              }
	
	              if (context.rootGetters.allKlassCalendarsInHash[cal.calendar_id]) {
	                if (!overlappingLessonsInClassHash[cal.calendar_id]) {
	                  overlappingLessonsInClassHash[cal.calendar_id] = [event.id];
	                } else {
	                  overlappingLessonsInClassHash[cal.calendar_id].push(event.id);
	                }
	              }
	              if (context.state.allUsersAndEvents[cal.calendar_id]) {
	                var teachersOnLesson = event.calendar_events.filter(function (ce) {
	                  return ce.calendar_type === 'user' && !ce.substitute;
	                });
	                if (teachersOnLesson.length >= 2) {
	                  overlappingEvents.severalOnLesson[cal.calendar_id] = cal.calendar_id;
	                } else {
	                  overlappingEvents.lessons[cal.calendar_id] = cal.calendar_id;
	                }
	              }
	            });
	            break;
	        }
	      });
	    }
	
	    (0, _entries2.default)(overlappingLessonsInClassHash).forEach(function (eventIds, key) {
	      if (eventIds[1].length > 1) {
	        eventIds[1].forEach(function (eventId) {
	          context.state.allEventsInAHash[eventId].calendar_events.forEach(function (cal) {
	            if (context.state.allUsersAndEvents[cal.calendar_id]) {
	              overlappingEvents.multipleLessonsInSameClasses[cal.calendar_id] = eventIds[0];
	            }
	          });
	        });
	      }
	    });
	
	    var activeEvent = context.state.schedulerActiveEvent.obj;
	    var skippedEventTypes = { absence: true, available: true, presence: true, reservation: true };
	    var activeKlassCalIds = (activeEvent.calendar_events || []).filter(function (cal) {
	      return context.rootGetters.allKlassCalendarsInHash[cal.calendar_id];
	    }).map(function (cal) {
	      return cal.calendar_id;
	    });
	    activeKlassCalIds.forEach(function (klassCalId) {
	      var calData = context.state.allCalsWithEventIdsInHash[klassCalId];
	      if (!calData || !calData.lessons) {
	        return;
	      }
	      calData.lessons.forEach(function (eventId) {
	        if (eventId === activeEvent.id) {
	          return;
	        }
	        var event = context.state.allEventsInAHash[eventId];
	        if (!event || event.canceled || event.away || skippedEventTypes[event.event_type] || event.event_type === null) {
	          return;
	        }
	        event.calendar_events.forEach(function (cal) {
	          if (context.state.allUsersAndEvents[cal.calendar_id]) {
	            overlappingEvents.hasHoursInClassOnDay[cal.calendar_id] = klassCalId;
	          }
	        });
	      });
	    });
	
	    context.state.allUsers.forEach(function (user) {
	      context.state.allUsersAndEvents[user.user_calendar_id].subScore = new Array(36).fill(0);
	      var subScoreTags = 0;
	      var subScoreSubPools = 0;
	      if (!data.user) {
	        return;
	      }
	
	      data.user.user_tags.forEach(function (userTag) {
	        user.user_tags.forEach(function (subTag) {
	          if (subTag === userTag) {
	            subScoreTags < 10 ? subScoreTags++ : null;
	          }
	        });
	      });
	
	      var isOccupiedByLesson = !!overlappingEvents.lessons[user.user_calendar_id];
	      if (overlappingEvents.canceledHours[user.user_calendar_id] && !isOccupiedByLesson && context.state.sortingHierarchy.canceledHours !== undefined) {
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.canceledHours] = 1;
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.canceledHours + 1] = subScoreTags;
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.canceledHours + 2] = subScoreSubPools;
	      }
	
	      if (otherOnlessonHash[user.user_calendar_id]) {
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.othersOnLesson] = 1;
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.othersOnLesson + 1] = subScoreTags;
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.othersOnLesson + 2] = subScoreSubPools;
	      }
	
	      if (overlappingEvents.lessonsInSameClass[user.user_calendar_id]) {
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.isInSameClassAtTheSameTime] = 1;
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.isInSameClassAtTheSameTime + 1] = subScoreTags;
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.isInSameClassAtTheSameTime + 2] = subScoreSubPools;
	      }
	
	      if (overlappingEvents.hasHoursInClassOnDay[user.user_calendar_id] && context.state.sortingHierarchy.hasHoursInClassOnDay !== undefined) {
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.hasHoursInClassOnDay] = 1;
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.hasHoursInClassOnDay + 1] = subScoreTags;
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.hasHoursInClassOnDay + 2] = subScoreSubPools;
	      }
	
	      if (overlappingEvents.multipleLessonsInSameClasses[user.user_calendar_id]) {
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses] = 1;
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses + 1] = overlappingEvents.multipleLessonsInSameClasses[user.user_calendar_id];
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses + 2] = subScoreSubPools;
	      }
	
	      if (overlappingEvents.lessons[user.user_calendar_id]) {} else if (overlappingEvents.severalOnLesson[user.user_calendar_id]) {
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses] = 1;
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses + 1] = subScoreTags;
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses + 2] = subScoreSubPools;
	      } else {
	        if (overlappingEvents.available[user.user_calendar_id]) {
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.availableHour] = 1;
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.availableHour + 1] = subScoreTags;
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.availableHour + 2] = subScoreSubPools;
	        }
	
	        if (overlappingEvents.presence[user.user_calendar_id]) {
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.presence] = 1;
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.presence + 1] = subScoreTags;
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.presence + 2] = subScoreSubPools;
	        }
	
	        if (context.state.allUsersAndEvents[user.user_calendar_id].dayEvents.length > 0) {
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithLessonsOnDay] = 1;
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithLessonsOnDay + 1] = subScoreTags;
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithLessonsOnDay + 2] = subScoreSubPools;
	        } else {
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithoutLessonsOnDay] = 1;
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithoutLessonsOnDay + 1] = subScoreTags;
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithoutLessonsOnDay + 2] = subScoreSubPools;
	        }
	      }
	
	      context.state.allUsersAndEvents[user.user_calendar_id].subScore = context.state.allUsersAndEvents[user.user_calendar_id].subScore.join('');
	    });
	    context.state.sortSubs++;
	    console.timeEnd('subScore');
	  },
	  updateIsSubZenActive: function updateIsSubZenActive(context, boolean) {
	    context.commit('setIsSubScoreActive', boolean);
	    context.dispatch('updateUserSettings', { 'isSubZenActive': boolean });
	  },
	
	  removeSubsOnActiveEvents: function removeSubsOnActiveEvents(context) {
	    context.dispatch('trackEvent', 'substitution_popover_removeMultipleSubstitutes');
	    context.state.isActiveEventsLoading = true;
	
	    var eventsByCalId = {};
	    context.state.activeEvents.forEach(function (evt) {
	      var calId = evt.calendar_id;
	      if (!eventsByCalId[calId]) {
	        eventsByCalId[calId] = [];
	      }
	      eventsByCalId[calId].push(evt);
	    });
	    var requests = [];
	    (0, _keys2.default)(eventsByCalId).forEach(function (calIdStr) {
	      var calId = Number(calIdStr);
	      var absentUser = context.state.allUsersAndEvents[calId];
	      if (!absentUser) {
	        return;
	      }
	      var userId = absentUser.id;
	      var statusData = {};
	      statusData[calId] = { 'status': 0 };
	
	      var eventsForUser = eventsByCalId[calId];
	      var bySchool = {};
	      eventsForUser.forEach(function (ev) {
	        if (!bySchool[ev.school_id]) {
	          bySchool[ev.school_id] = [ev];
	        } else {
	          bySchool[ev.school_id].push(ev);
	        }
	      });
	      (0, _keys2.default)(bySchool).forEach(function (schoolIdStr) {
	        var schoolId = Number(schoolIdStr);
	        var eventIds = bySchool[schoolId].map(function (e) {
	          return e.event_id;
	        });
	        requests.push(new _promise2.default(function (resolve) {
	          _docendo2.default.removeSubstitutionOfUser(schoolId, eventIds, userId, statusData, function (success) {
	            var data = success.length > 0 ? JSON.parse(success) : [];
	            data.forEach(function (event) {
	              if (moment(event.start).format('YYYY_MM_DD') === moment(context.state.date).format('YYYY_MM_DD')) {
	                var before = context.state.allEventsInAHash[event.id];
	                context.commit('updateEventOnAllEventsInAHash', event);
	                if (before && before.calendar_events) {
	                  var diffCals = before.calendar_events.filter(function (o) {
	                    return !event.calendar_events.some(function (i) {
	                      return i.id === o.id;
	                    });
	                  });
	                  diffCals.forEach(function (cal) {
	                    context.commit('removeEventOnAllUsersWithEvents', {
	                      cal_id: cal.calendar_id,
	                      event_id: event.id
	                    });
	                  });
	                }
	              }
	            });
	            resolve(true);
	          }, function (failure) {
	            resolve(false);
	          });
	        }));
	      });
	    });
	    _promise2.default.all(requests).then(function (results) {
	      context.state.activeEvents = [];
	      context.state.isActiveEventsLoading = false;
	      var allOk = results.every(function (r) {
	        return r === true;
	      });
	      if (allOk) {
	        _eventbus2.default.toast = { text: window.use_i18n.t('vue2.subs_ongoing_absence.subs_removed'), success: true };
	      } else {
	        _eventbus2.default.toast = { text: window.use_i18n.t('vue2.subs_ongoing_absence.subs_remove_failed'), success: false };
	      }
	    });
	  },
	  updateSortingHierarchy: function updateSortingHierarchy(context, obj) {
	    var userSettingsObj = { 'subZenOrder': obj };
	    context.dispatch('updateUserSettings', userSettingsObj);
	    context.commit('setSortingHierarchy', obj);
	  },
	  updateEventsSerial: function updateEventsSerial(context, obj) {
	    _docendo2.default.schoolEventSerialsUpdate(obj.school_id, obj.id, obj.calendar_id, obj.subject_id, obj.from_date, obj.to_date, obj.from_time, obj.to_time, obj.ongoing, obj.internal_note, obj.employment_id || null, !!obj.use_time, obj.additional_data || null, function (success) {
	      var data = JSON.parse(success);
	
	      if (obj.employment_id !== undefined) data.employment_id = obj.employment_id;
	      if (obj.additional_data !== undefined) data.additional_data = obj.additional_data;
	      if (obj.use_time !== undefined) data.use_time = obj.use_time;
	      context.commit('updateLongListAbsence', data);
	      context.dispatch('getAllDayEvents');
	      _eventbus2.default.toast = { text: window.use_i18n.t('vue2.subs_ongoing_absence.absence_updated'), 'success': true };
	    }, function (failure) {
	      console.log('failed', failure);
	    });
	  },
	  removeSubsFromEvents: function removeSubsFromEvents(context, obj) {
	    var statusData = {};
	    statusData[obj.user_calendar_id] = { 'status': 0 };
	    var userId = obj.userId;
	
	    var eventsObj = {};
	    obj.events.forEach(function (event) {
	      if (!eventsObj[event.school_id]) {
	        eventsObj[event.school_id] = [event];
	      } else {
	        eventsObj[event.school_id].push(event);
	      }
	    });
	
	    (0, _keys2.default)(eventsObj).forEach(function (prop) {
	      var schoolId = Number(prop);
	      var eventIds = eventsObj[prop].map(function (event) {
	        return event.event_id;
	      });
	
	      _docendo2.default.removeSubstitutionOfUser(schoolId, eventIds, userId, statusData, function (success) {
	        var data = success.length > 0 ? JSON.parse(success) : [];
	
	        data.forEach(function (event) {
	          if (moment(event.start).format('YYYY_MM_DD') === moment(context.state.date).format('YYYY_MM_DD')) {
	            var eventBeforeUpdate = context.state.allEventsInAHash[event.id];
	            context.commit('updateEventOnAllEventsInAHash', event);
	            var diffCals = eventBeforeUpdate.calendar_events.filter(function (o) {
	              return !event.calendar_events.some(function (i) {
	                return i.id === o.id;
	              });
	            });
	
	            diffCals.forEach(function (cal) {
	              context.commit('removeEventOnAllUsersWithEvents', {
	                cal_id: cal.calendar_id,
	                event_id: event.id
	              });
	            });
	          }
	        });
	        _eventbus2.default.toast = {
	          text: window.use_i18n.t('vue2.subs_ongoing_absence.subs_removed'),
	          success: true
	        };
	      }, function (failure) {
	        console.log('API call failure:', failure);
	
	        _eventbus2.default.toast = {
	          text: window.use_i18n.t('vue2.subs_ongoing_absence.subs_remove_failed'),
	          success: false
	        };
	      });
	    });
	  },
	  deleteAbsence: function deleteAbsence(context, reasonObj) {
	    var deletedOnDate = moment(context.state.date).format('YYYY-MM-DD');
	    var applyLocalDelete = function applyLocalDelete(calId, eventId) {
	      if (moment(context.state.date).format('YYYY-MM-DD') !== deletedOnDate) {
	        return;
	      }
	      invalidateInFlightEventReloads(context.state);
	      context.commit('removeAbsenceOnAllUsersWithEvents', {
	        cal_id: calId,
	        event_id: eventId
	      });
	      context.commit('reclassifyAwayEventsForUser', calId);
	    };
	    if (reasonObj.event_serial_id) {
	      _docendo2.default.schoolEventSerialsDelete(window.SCHOOL.id, reasonObj.event_serial_id, function (success) {
	        applyLocalDelete(reasonObj.user_calendar_id, reasonObj.id);
	        context.commit('deleteLongListAbsenceItem', {
	          eventSerialId: reasonObj.event_serial_id
	        });
	        _eventbus2.default.toast = { text: window.use_i18n.t('vue2.subs_ongoing_absence.absence_deleted'), 'success': true };
	      });
	    } else {
	      _docendo2.default.deleteEvent(window.SCHOOL.id, reasonObj.id, function (data) {
	        var parsed = JSON.parse(data);
	        applyLocalDelete(parsed.calendar_id, parsed.id);
	        _eventbus2.default.toast = { text: window.use_i18n.t('vue2.subs_ongoing_absence.absence_deleted'), 'success': true };
	      });
	    }
	  }
	};
	
	exports.default = {
	  state: state,
	  mutations: mutations,
	  actions: actions,
	  getters: getters
	};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseSubjectEvents = parseSubjectEvents;
	exports.firstEventOnOrAfter = firstEventOnOrAfter;
	exports.loadEventsForSubject = loadEventsForSubject;
	exports.addTeacherToScheduledEventsFromDate = addTeacherToScheduledEventsFromDate;
	exports.removeTeacherFromScheduledEventsFromDate = removeTeacherFromScheduledEventsFromDate;
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function parseSubjectEvents(payload) {
	  if (Array.isArray(payload)) return payload;
	  if (typeof payload === 'string' && payload.length > 0) {
	    try {
	      var parsed = JSON.parse(payload);
	      return Array.isArray(parsed) ? parsed : [];
	    } catch (e) {
	      return [];
	    }
	  }
	  return [];
	}
	
	function firstEventOnOrAfter(events, fromDate) {
	  if (!Array.isArray(events) || !fromDate) return null;
	  var from = (0, _moment2.default)(fromDate).startOf('day');
	  return events.filter(function (event) {
	    return event && event.start && (0, _moment2.default)(event.start).isSameOrAfter(from);
	  }).sort(function (a, b) {
	    return (0, _moment2.default)(a.start).valueOf() - (0, _moment2.default)(b.start).valueOf();
	  })[0] || null;
	}
	
	function loadEventsForSubject(subjectId, success, failure) {
	  _docendo2.default.eventsBySubjects([subjectId], null, null, function (payload) {
	    success(parseSubjectEvents(payload));
	  }, failure);
	}
	
	function applyTeacherOnScheduledEventsFromDate(options, apiFn, success, failure) {
	  var schoolId = options.schoolId;
	  var calendarId = options.calendarId;
	  var fromDate = options.fromDate;
	  var events = options.events || [];
	  var event = firstEventOnOrAfter(events, fromDate);
	  if (!event || !event.event_id) {
	    success({ applied: false, reason: 'no_events_from_date' });
	    return;
	  }
	  var eventSchoolId = event.school_id || schoolId;
	  apiFn(eventSchoolId, event.event_id, calendarId, options.enddate || null, function () {
	    success({ applied: true, eventId: event.event_id });
	  }, failure);
	}
	
	function addTeacherToScheduledEventsFromDate(options, success, failure) {
	  applyTeacherOnScheduledEventsFromDate(options, _docendo2.default.eventAddCalendar.bind(_docendo2.default), success, failure);
	}
	
	function removeTeacherFromScheduledEventsFromDate(options, success, failure) {
	  applyTeacherOnScheduledEventsFromDate(options, _docendo2.default.eventRemoveCalendar.bind(_docendo2.default), success, failure);
	}

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MAX_RANDOM_NAMES = undefined;
	
	var _from = __webpack_require__(32);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _set = __webpack_require__(27);
	
	var _set2 = _interopRequireDefault(_set);
	
	exports.generateRandomNames = generateRandomNames;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var firstNames = ['Anna', 'Emma', 'Ida', 'Sofie', 'Freja', 'Clara', 'Laura', 'Ella', 'Alma', 'Karla', 'Maja', 'Josefine', 'Olivia', 'Agnes', 'Nora', 'Signe', 'Mathilde', 'Asta', 'Lærke', 'Liva', 'Caroline', 'Emilie', 'Marie', 'Julie', 'Cecilie', 'Louise', 'Camilla', 'Mette', 'Hanne', 'Lene', 'Susanne', 'Tina', 'Pia', 'Birgitte', 'Helle', 'Karen', 'Kirsten', 'Inge', 'Lone', 'Charlotte', 'Rikke', 'Maria', 'Stine', 'Trine', 'Line', 'Sara', 'Katrine', 'Malene', 'Dorthe', 'Gitte', 'William', 'Noah', 'Oscar', 'Lucas', 'Carl', 'Victor', 'Malthe', 'Alfred', 'Emil', 'Oliver', 'Magnus', 'Valdemar', 'Frederik', 'Elias', 'August', 'Aksel', 'Arthur', 'Johan', 'Anton', 'Viggo', 'Mads', 'Lars', 'Jens', 'Peter', 'Michael', 'Søren', 'Henrik', 'Thomas', 'Martin', 'Niels', 'Christian', 'Jesper', 'Morten', 'Rasmus', 'Anders', 'Kasper', 'Jakob', 'Mikkel', 'Simon', 'Jonas', 'Kim', 'Ole', 'Hans', 'Jørgen', 'Bo', 'Torben', 'Steen', 'Per', 'Claus', 'Brian'];
	
	var lastNames = ['Jensen', 'Nielsen', 'Hansen', 'Pedersen', 'Andersen', 'Christensen', 'Larsen', 'Sørensen', 'Rasmussen', 'Jørgensen', 'Petersen', 'Madsen', 'Kristensen', 'Olsen', 'Thomsen', 'Christiansen', 'Poulsen', 'Johansen', 'Møller', 'Mortensen', 'Knudsen', 'Jakobsen', 'Mikkelsen', 'Olesen', 'Frederiksen', 'Laursen', 'Henriksen', 'Lund', 'Schmidt', 'Eriksen', 'Holm', 'Kristiansen', 'Clausen', 'Simonsen', 'Svendsen', 'Andreasen', 'Iversen', 'Jeppesen', 'Mogensen', 'Jacobsen', 'Nissen', 'Lauridsen', 'Kjær', 'Jespersen', 'Mathiesen', 'Hald', 'Dahl', 'Bertelsen', 'Vestergaard', 'Østergaard', 'Nørgaard', 'Søndergaard', 'Lindberg', 'Bach', 'Friis', 'Berg', 'Kjeldsen', 'Lassen', 'Thygesen', 'Winther', 'Juhl', 'Bruun', 'Overgaard', 'Damgaard', 'Bisgaard', 'Holst', 'Toft', 'Skov', 'Krogh', 'Brandt', 'Munk', 'Koch', 'Dam', 'Beck', 'Bang', 'Mølgaard', 'Ravn', 'Kirkegaard', 'Engel', 'Steffensen'];
	
	var MAX_RANDOM_NAMES = exports.MAX_RANDOM_NAMES = firstNames.length * lastNames.length;
	
	function randomItem(list) {
	  return list[Math.floor(Math.random() * list.length)];
	}
	
	function generateRandomNames(count) {
	  var excludedNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var excluded = new _set2.default(excludedNames.map(function (name) {
	    return name.toLowerCase();
	  }));
	  var names = new _set2.default();
	  var target = Math.min(count, MAX_RANDOM_NAMES - excluded.size);
	  var attempts = 0;
	
	  while (names.size < target && attempts < target * 50) {
	    var name = randomItem(firstNames) + ' ' + randomItem(lastNames);
	    if (!excluded.has(name.toLowerCase())) {
	      names.add(name);
	    }
	    attempts++;
	  }
	
	  return (0, _from2.default)(names);
	}

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.effectiveDeactivatePoolsFromVersion = effectiveDeactivatePoolsFromVersion;
	
	var _assignedPoolWhenPoolsDeactivated = __webpack_require__(84);
	
	Object.defineProperty(exports, 'effectiveAssignedPoolFromNormWhenPoolsDeactivated', {
	  enumerable: true,
	  get: function get() {
	    return _assignedPoolWhenPoolsDeactivated.effectiveAssignedPoolFromNormWhenPoolsDeactivated;
	  }
	});
	exports.effectivePrepFactorFromVersion = effectivePrepFactorFromVersion;
	function effectiveDeactivatePoolsFromVersion(version, schoolSettings) {
	  var scd = version && version.overview && version.overview.school_custom_data;
	  if (scd && typeof scd.deactivatePools === 'boolean') {
	    return scd.deactivatePools;
	  }
	  return !!(schoolSettings && schoolSettings.deactivatePools);
	}
	
	function effectivePrepFactorFromVersion(version, schoolSettings) {
	  var scd = version && version.overview && version.overview.school_custom_data;
	  if (scd && scd.prepFactor !== undefined && scd.prepFactor !== null && scd.prepFactor !== '') {
	    return scd.prepFactor;
	  }
	  if (schoolSettings && schoolSettings.prepFactor !== undefined && schoolSettings.prepFactor !== null && schoolSettings.prepFactor !== '') {
	    return schoolSettings.prepFactor;
	  }
	  return null;
	}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _defineProperties = __webpack_require__(895);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	var _getOwnPropertyDescriptors = __webpack_require__(896);
	
	var _getOwnPropertyDescriptors2 = _interopRequireDefault(_getOwnPropertyDescriptors);
	
	var _getOwnPropertyDescriptor = __webpack_require__(162);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getOwnPropertySymbols = __webpack_require__(897);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _defineProperty = __webpack_require__(114);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VueTippy = function (t) {
	  "use strict";
	  var e = "undefined" != typeof window && "undefined" != typeof document && "undefined" != typeof navigator,
	      n = function () {
	    for (var t = ["Edge", "Trident", "Firefox"], n = 0; n < t.length; n += 1) {
	      if (e && navigator.userAgent.indexOf(t[n]) >= 0) return 1;
	    }return 0;
	  }();var r = e && window.Promise ? function (t) {
	    var e = !1;return function () {
	      e || (e = !0, window.Promise.resolve().then(function () {
	        e = !1, t();
	      }));
	    };
	  } : function (t) {
	    var e = !1;return function () {
	      e || (e = !0, setTimeout(function () {
	        e = !1, t();
	      }, n));
	    };
	  };function i(t) {
	    return t && "[object Function]" === {}.toString.call(t);
	  }function o(t, e) {
	    if (1 !== t.nodeType) return [];var n = t.ownerDocument.defaultView.getComputedStyle(t, null);return e ? n[e] : n;
	  }function a(t) {
	    return "HTML" === t.nodeName ? t : t.parentNode || t.host;
	  }function p(t) {
	    if (!t) return document.body;switch (t.nodeName) {case "HTML":case "BODY":
	        return t.ownerDocument.body;case "#document":
	        return t.body;}var e = o(t),
	        n = e.overflow,
	        r = e.overflowX,
	        i = e.overflowY;return (/(auto|scroll|overlay)/.test(n + i + r) ? t : p(a(t))
	    );
	  }function s(t) {
	    return t && t.referenceNode ? t.referenceNode : t;
	  }var c = e && !(!window.MSInputMethodContext || !document.documentMode),
	      l = e && /MSIE 10/.test(navigator.userAgent);function f(t) {
	    return 11 === t ? c : 10 === t ? l : c || l;
	  }function d(t) {
	    if (!t) return document.documentElement;for (var e = f(10) ? document.body : null, n = t.offsetParent || null; n === e && t.nextElementSibling;) {
	      n = (t = t.nextElementSibling).offsetParent;
	    }var r = n && n.nodeName;return r && "BODY" !== r && "HTML" !== r ? -1 !== ["TH", "TD", "TABLE"].indexOf(n.nodeName) && "static" === o(n, "position") ? d(n) : n : t ? t.ownerDocument.documentElement : document.documentElement;
	  }function u(t) {
	    return null !== t.parentNode ? u(t.parentNode) : t;
	  }function m(t, e) {
	    if (!(t && t.nodeType && e && e.nodeType)) return document.documentElement;var n = t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING,
	        r = n ? t : e,
	        i = n ? e : t,
	        o = document.createRange();o.setStart(r, 0), o.setEnd(i, 0);var a,
	        p,
	        s = o.commonAncestorContainer;if (t !== s && e !== s || r.contains(i)) return "BODY" === (p = (a = s).nodeName) || "HTML" !== p && d(a.firstElementChild) !== a ? d(s) : s;var c = u(t);return c.host ? m(c.host, e) : m(t, u(e).host);
	  }function h(t) {
	    var e = "top" === (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "top") ? "scrollTop" : "scrollLeft",
	        n = t.nodeName;if ("BODY" === n || "HTML" === n) {
	      var r = t.ownerDocument.documentElement;return (t.ownerDocument.scrollingElement || r)[e];
	    }return t[e];
	  }function b(t, e) {
	    var n = "x" === e ? "Left" : "Top",
	        r = "Left" === n ? "Right" : "Bottom";return parseFloat(t["border" + n + "Width"], 10) + parseFloat(t["border" + r + "Width"], 10);
	  }function v(t, e, n, r) {
	    return Math.max(e["offset" + t], e["scroll" + t], n["client" + t], n["offset" + t], n["scroll" + t], f(10) ? parseInt(n["offset" + t]) + parseInt(r["margin" + ("Height" === t ? "Top" : "Left")]) + parseInt(r["margin" + ("Height" === t ? "Bottom" : "Right")]) : 0);
	  }function y(t) {
	    var e = t.body,
	        n = t.documentElement,
	        r = f(10) && getComputedStyle(n);return { height: v("Height", e, n, r), width: v("Width", e, n, r) };
	  }var g = function g(t, e) {
	    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
	  },
	      w = function () {
	    function t(t, e) {
	      for (var n = 0; n < e.length; n++) {
	        var r = e[n];r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), (0, _defineProperty2.default)(t, r.key, r);
	      }
	    }return function (e, n, r) {
	      return n && t(e.prototype, n), r && t(e, r), e;
	    };
	  }(),
	      x = function x(t, e, n) {
	    return e in t ? (0, _defineProperty2.default)(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
	  },
	      k = _assign2.default || function (t) {
	    for (var e = 1; e < arguments.length; e++) {
	      var n = arguments[e];for (var r in n) {
	        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
	      }
	    }return t;
	  };function E(t) {
	    return k({}, t, { right: t.left + t.width, bottom: t.top + t.height });
	  }function O(t) {
	    var e = {};try {
	      if (f(10)) {
	        e = t.getBoundingClientRect();var n = h(t, "top"),
	            r = h(t, "left");e.top += n, e.left += r, e.bottom += n, e.right += r;
	      } else e = t.getBoundingClientRect();
	    } catch (t) {}var i = { left: e.left, top: e.top, width: e.right - e.left, height: e.bottom - e.top },
	        a = "HTML" === t.nodeName ? y(t.ownerDocument) : {},
	        p = a.width || t.clientWidth || i.width,
	        s = a.height || t.clientHeight || i.height,
	        c = t.offsetWidth - p,
	        l = t.offsetHeight - s;if (c || l) {
	      var d = o(t);c -= b(d, "x"), l -= b(d, "y"), i.width -= c, i.height -= l;
	    }return E(i);
	  }function A(t, e) {
	    var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
	        r = f(10),
	        i = "HTML" === e.nodeName,
	        a = O(t),
	        s = O(e),
	        c = p(t),
	        l = o(e),
	        d = parseFloat(l.borderTopWidth, 10),
	        u = parseFloat(l.borderLeftWidth, 10);n && i && (s.top = Math.max(s.top, 0), s.left = Math.max(s.left, 0));var m = E({ top: a.top - s.top - d, left: a.left - s.left - u, width: a.width, height: a.height });if (m.marginTop = 0, m.marginLeft = 0, !r && i) {
	      var b = parseFloat(l.marginTop, 10),
	          v = parseFloat(l.marginLeft, 10);m.top -= d - b, m.bottom -= d - b, m.left -= u - v, m.right -= u - v, m.marginTop = b, m.marginLeft = v;
	    }return (r && !n ? e.contains(c) : e === c && "BODY" !== c.nodeName) && (m = function (t, e) {
	      var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
	          r = h(e, "top"),
	          i = h(e, "left"),
	          o = n ? -1 : 1;return t.top += r * o, t.bottom += r * o, t.left += i * o, t.right += i * o, t;
	    }(m, e)), m;
	  }function C(t) {
	    if (!t || !t.parentElement || f()) return document.documentElement;for (var e = t.parentElement; e && "none" === o(e, "transform");) {
	      e = e.parentElement;
	    }return e || document.documentElement;
	  }function T(t, e, n, r) {
	    var i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
	        c = { top: 0, left: 0 },
	        l = i ? C(t) : m(t, s(e));if ("viewport" === r) c = function (t) {
	      var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
	          n = t.ownerDocument.documentElement,
	          r = A(t, n),
	          i = Math.max(n.clientWidth, window.innerWidth || 0),
	          o = Math.max(n.clientHeight, window.innerHeight || 0),
	          a = e ? 0 : h(n),
	          p = e ? 0 : h(n, "left");return E({ top: a - r.top + r.marginTop, left: p - r.left + r.marginLeft, width: i, height: o });
	    }(l, i);else {
	      var f = void 0;"scrollParent" === r ? "BODY" === (f = p(a(e))).nodeName && (f = t.ownerDocument.documentElement) : f = "window" === r ? t.ownerDocument.documentElement : r;var d = A(f, l, i);if ("HTML" !== f.nodeName || function t(e) {
	        var n = e.nodeName;if ("BODY" === n || "HTML" === n) return !1;if ("fixed" === o(e, "position")) return !0;var r = a(e);return !!r && t(r);
	      }(l)) c = d;else {
	        var u = y(t.ownerDocument),
	            b = u.height,
	            v = u.width;c.top += d.top - d.marginTop, c.bottom = b + d.top, c.left += d.left - d.marginLeft, c.right = v + d.left;
	      }
	    }var g = "number" == typeof (n = n || 0);return c.left += g ? n : n.left || 0, c.top += g ? n : n.top || 0, c.right -= g ? n : n.right || 0, c.bottom -= g ? n : n.bottom || 0, c;
	  }function L(t, e, n, r, i) {
	    var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;if (-1 === t.indexOf("auto")) return t;var a = T(n, r, o, i),
	        p = { top: { width: a.width, height: e.top - a.top }, right: { width: a.right - e.right, height: a.height }, bottom: { width: a.width, height: a.bottom - e.bottom }, left: { width: e.left - a.left, height: a.height } },
	        s = (0, _keys2.default)(p).map(function (t) {
	      return k({ key: t }, p[t], { area: (e = p[t], e.width * e.height) });var e;
	    }).sort(function (t, e) {
	      return e.area - t.area;
	    }),
	        c = s.filter(function (t) {
	      var e = t.width,
	          r = t.height;return e >= n.clientWidth && r >= n.clientHeight;
	    }),
	        l = c.length > 0 ? c[0].key : s[0].key,
	        f = t.split("-")[1];return l + (f ? "-" + f : "");
	  }function S(t, e, n) {
	    var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;return A(n, r ? C(e) : m(e, s(n)), r);
	  }function M(t) {
	    var e = t.ownerDocument.defaultView.getComputedStyle(t),
	        n = parseFloat(e.marginTop || 0) + parseFloat(e.marginBottom || 0),
	        r = parseFloat(e.marginLeft || 0) + parseFloat(e.marginRight || 0);return { width: t.offsetWidth + r, height: t.offsetHeight + n };
	  }function D(t) {
	    var e = { left: "right", right: "left", bottom: "top", top: "bottom" };return t.replace(/left|right|bottom|top/g, function (t) {
	      return e[t];
	    });
	  }function I(t, e, n) {
	    n = n.split("-")[0];var r = M(t),
	        i = { width: r.width, height: r.height },
	        o = -1 !== ["right", "left"].indexOf(n),
	        a = o ? "top" : "left",
	        p = o ? "left" : "top",
	        s = o ? "height" : "width",
	        c = o ? "width" : "height";return i[a] = e[a] + e[s] / 2 - r[s] / 2, i[p] = n === p ? e[p] - r[c] : e[D(p)], i;
	  }function N(t, e) {
	    return Array.prototype.find ? t.find(e) : t.filter(e)[0];
	  }function H(t, e, n) {
	    return (void 0 === n ? t : t.slice(0, function (t, e, n) {
	      if (Array.prototype.findIndex) return t.findIndex(function (t) {
	        return t[e] === n;
	      });var r = N(t, function (t) {
	        return t[e] === n;
	      });return t.indexOf(r);
	    }(t, "name", n))).forEach(function (t) {
	      t.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");var n = t.function || t.fn;t.enabled && i(n) && (e.offsets.popper = E(e.offsets.popper), e.offsets.reference = E(e.offsets.reference), e = n(e, t));
	    }), e;
	  }function P(t, e) {
	    return t.some(function (t) {
	      var n = t.name;return t.enabled && n === e;
	    });
	  }function _(t) {
	    for (var e = [!1, "ms", "Webkit", "Moz", "O"], n = t.charAt(0).toUpperCase() + t.slice(1), r = 0; r < e.length; r++) {
	      var i = e[r],
	          o = i ? "" + i + n : t;if (void 0 !== document.body.style[o]) return o;
	    }return null;
	  }function Y(t) {
	    var e = t.ownerDocument;return e ? e.defaultView : window;
	  }function F(t, e, n, r) {
	    n.updateBound = r, Y(t).addEventListener("resize", n.updateBound, { passive: !0 });var i = p(t);return function t(e, n, r, i) {
	      var o = "BODY" === e.nodeName,
	          a = o ? e.ownerDocument.defaultView : e;a.addEventListener(n, r, { passive: !0 }), o || t(p(a.parentNode), n, r, i), i.push(a);
	    }(i, "scroll", n.updateBound, n.scrollParents), n.scrollElement = i, n.eventsEnabled = !0, n;
	  }function j() {
	    var t, e;this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = (t = this.reference, e = this.state, Y(t).removeEventListener("resize", e.updateBound), e.scrollParents.forEach(function (t) {
	      t.removeEventListener("scroll", e.updateBound);
	    }), e.updateBound = null, e.scrollParents = [], e.scrollElement = null, e.eventsEnabled = !1, e));
	  }function X(t) {
	    return "" !== t && !isNaN(parseFloat(t)) && isFinite(t);
	  }function z(t, e) {
	    (0, _keys2.default)(e).forEach(function (n) {
	      var r = "";-1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(n) && X(e[n]) && (r = "px"), t.style[n] = e[n] + r;
	    });
	  }var B = e && /Firefox/i.test(navigator.userAgent);function W(t, e, n) {
	    var r = N(t, function (t) {
	      return t.name === e;
	    }),
	        i = !!r && t.some(function (t) {
	      return t.name === n && t.enabled && t.order < r.order;
	    });if (!i) {
	      var o = "`" + e + "`",
	          a = "`" + n + "`";console.warn(a + " modifier is required by " + o + " modifier in order to work, be sure to include it before " + o + "!");
	    }return i;
	  }var V = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"],
	      R = V.slice(3);function U(t) {
	    var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
	        n = R.indexOf(t),
	        r = R.slice(n + 1).concat(R.slice(0, n));return e ? r.reverse() : r;
	  }var $ = { FLIP: "flip", CLOCKWISE: "clockwise", COUNTERCLOCKWISE: "counterclockwise" };function q(t, e, n, r) {
	    var i = [0, 0],
	        o = -1 !== ["right", "left"].indexOf(r),
	        a = t.split(/(\+|\-)/).map(function (t) {
	      return t.trim();
	    }),
	        p = a.indexOf(N(a, function (t) {
	      return -1 !== t.search(/,|\s/);
	    }));a[p] && -1 === a[p].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");var s = /\s*,\s*|\s+/,
	        c = -1 !== p ? [a.slice(0, p).concat([a[p].split(s)[0]]), [a[p].split(s)[1]].concat(a.slice(p + 1))] : [a];return (c = c.map(function (t, r) {
	      var i = (1 === r ? !o : o) ? "height" : "width",
	          a = !1;return t.reduce(function (t, e) {
	        return "" === t[t.length - 1] && -1 !== ["+", "-"].indexOf(e) ? (t[t.length - 1] = e, a = !0, t) : a ? (t[t.length - 1] += e, a = !1, t) : t.concat(e);
	      }, []).map(function (t) {
	        return function (t, e, n, r) {
	          var i = t.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
	              o = +i[1],
	              a = i[2];if (!o) return t;if (0 === a.indexOf("%")) {
	            var p = void 0;switch (a) {case "%p":
	                p = n;break;case "%":case "%r":default:
	                p = r;}return E(p)[e] / 100 * o;
	          }if ("vh" === a || "vw" === a) return ("vh" === a ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * o;return o;
	        }(t, i, e, n);
	      });
	    })).forEach(function (t, e) {
	      t.forEach(function (n, r) {
	        X(n) && (i[e] += n * ("-" === t[r - 1] ? -1 : 1));
	      });
	    }), i;
	  }var K = { placement: "bottom", positionFixed: !1, eventsEnabled: !0, removeOnDestroy: !1, onCreate: function onCreate() {}, onUpdate: function onUpdate() {}, modifiers: { shift: { order: 100, enabled: !0, fn: function fn(t) {
	          var e = t.placement,
	              n = e.split("-")[0],
	              r = e.split("-")[1];if (r) {
	            var i = t.offsets,
	                o = i.reference,
	                a = i.popper,
	                p = -1 !== ["bottom", "top"].indexOf(n),
	                s = p ? "left" : "top",
	                c = p ? "width" : "height",
	                l = { start: x({}, s, o[s]), end: x({}, s, o[s] + o[c] - a[c]) };t.offsets.popper = k({}, a, l[r]);
	          }return t;
	        } }, offset: { order: 200, enabled: !0, fn: function fn(t, e) {
	          var n = e.offset,
	              r = t.placement,
	              i = t.offsets,
	              o = i.popper,
	              a = i.reference,
	              p = r.split("-")[0],
	              s = void 0;return s = X(+n) ? [+n, 0] : q(n, o, a, p), "left" === p ? (o.top += s[0], o.left -= s[1]) : "right" === p ? (o.top += s[0], o.left += s[1]) : "top" === p ? (o.left += s[0], o.top -= s[1]) : "bottom" === p && (o.left += s[0], o.top += s[1]), t.popper = o, t;
	        }, offset: 0 }, preventOverflow: { order: 300, enabled: !0, fn: function fn(t, e) {
	          var n = e.boundariesElement || d(t.instance.popper);t.instance.reference === n && (n = d(n));var r = _("transform"),
	              i = t.instance.popper.style,
	              o = i.top,
	              a = i.left,
	              p = i[r];i.top = "", i.left = "", i[r] = "";var s = T(t.instance.popper, t.instance.reference, e.padding, n, t.positionFixed);i.top = o, i.left = a, i[r] = p, e.boundaries = s;var c = e.priority,
	              l = t.offsets.popper,
	              f = { primary: function primary(t) {
	              var n = l[t];return l[t] < s[t] && !e.escapeWithReference && (n = Math.max(l[t], s[t])), x({}, t, n);
	            }, secondary: function secondary(t) {
	              var n = "right" === t ? "left" : "top",
	                  r = l[n];return l[t] > s[t] && !e.escapeWithReference && (r = Math.min(l[n], s[t] - ("right" === t ? l.width : l.height))), x({}, n, r);
	            } };return c.forEach(function (t) {
	            var e = -1 !== ["left", "top"].indexOf(t) ? "primary" : "secondary";l = k({}, l, f[e](t));
	          }), t.offsets.popper = l, t;
	        }, priority: ["left", "right", "top", "bottom"], padding: 5, boundariesElement: "scrollParent" }, keepTogether: { order: 400, enabled: !0, fn: function fn(t) {
	          var e = t.offsets,
	              n = e.popper,
	              r = e.reference,
	              i = t.placement.split("-")[0],
	              o = Math.floor,
	              a = -1 !== ["top", "bottom"].indexOf(i),
	              p = a ? "right" : "bottom",
	              s = a ? "left" : "top",
	              c = a ? "width" : "height";return n[p] < o(r[s]) && (t.offsets.popper[s] = o(r[s]) - n[c]), n[s] > o(r[p]) && (t.offsets.popper[s] = o(r[p])), t;
	        } }, arrow: { order: 500, enabled: !0, fn: function fn(t, e) {
	          var n;if (!W(t.instance.modifiers, "arrow", "keepTogether")) return t;var r = e.element;if ("string" == typeof r) {
	            if (!(r = t.instance.popper.querySelector(r))) return t;
	          } else if (!t.instance.popper.contains(r)) return console.warn("WARNING: `arrow.element` must be child of its popper element!"), t;var i = t.placement.split("-")[0],
	              a = t.offsets,
	              p = a.popper,
	              s = a.reference,
	              c = -1 !== ["left", "right"].indexOf(i),
	              l = c ? "height" : "width",
	              f = c ? "Top" : "Left",
	              d = f.toLowerCase(),
	              u = c ? "left" : "top",
	              m = c ? "bottom" : "right",
	              h = M(r)[l];s[m] - h < p[d] && (t.offsets.popper[d] -= p[d] - (s[m] - h)), s[d] + h > p[m] && (t.offsets.popper[d] += s[d] + h - p[m]), t.offsets.popper = E(t.offsets.popper);var b = s[d] + s[l] / 2 - h / 2,
	              v = o(t.instance.popper),
	              y = parseFloat(v["margin" + f], 10),
	              g = parseFloat(v["border" + f + "Width"], 10),
	              w = b - t.offsets.popper[d] - y - g;return w = Math.max(Math.min(p[l] - h, w), 0), t.arrowElement = r, t.offsets.arrow = (x(n = {}, d, Math.round(w)), x(n, u, ""), n), t;
	        }, element: "[x-arrow]" }, flip: { order: 600, enabled: !0, fn: function fn(t, e) {
	          if (P(t.instance.modifiers, "inner")) return t;if (t.flipped && t.placement === t.originalPlacement) return t;var n = T(t.instance.popper, t.instance.reference, e.padding, e.boundariesElement, t.positionFixed),
	              r = t.placement.split("-")[0],
	              i = D(r),
	              o = t.placement.split("-")[1] || "",
	              a = [];switch (e.behavior) {case $.FLIP:
	              a = [r, i];break;case $.CLOCKWISE:
	              a = U(r);break;case $.COUNTERCLOCKWISE:
	              a = U(r, !0);break;default:
	              a = e.behavior;}return a.forEach(function (p, s) {
	            if (r !== p || a.length === s + 1) return t;r = t.placement.split("-")[0], i = D(r);var c = t.offsets.popper,
	                l = t.offsets.reference,
	                f = Math.floor,
	                d = "left" === r && f(c.right) > f(l.left) || "right" === r && f(c.left) < f(l.right) || "top" === r && f(c.bottom) > f(l.top) || "bottom" === r && f(c.top) < f(l.bottom),
	                u = f(c.left) < f(n.left),
	                m = f(c.right) > f(n.right),
	                h = f(c.top) < f(n.top),
	                b = f(c.bottom) > f(n.bottom),
	                v = "left" === r && u || "right" === r && m || "top" === r && h || "bottom" === r && b,
	                y = -1 !== ["top", "bottom"].indexOf(r),
	                g = !!e.flipVariations && (y && "start" === o && u || y && "end" === o && m || !y && "start" === o && h || !y && "end" === o && b),
	                w = !!e.flipVariationsByContent && (y && "start" === o && m || y && "end" === o && u || !y && "start" === o && b || !y && "end" === o && h),
	                x = g || w;(d || v || x) && (t.flipped = !0, (d || v) && (r = a[s + 1]), x && (o = function (t) {
	              return "end" === t ? "start" : "start" === t ? "end" : t;
	            }(o)), t.placement = r + (o ? "-" + o : ""), t.offsets.popper = k({}, t.offsets.popper, I(t.instance.popper, t.offsets.reference, t.placement)), t = H(t.instance.modifiers, t, "flip"));
	          }), t;
	        }, behavior: "flip", padding: 5, boundariesElement: "viewport", flipVariations: !1, flipVariationsByContent: !1 }, inner: { order: 700, enabled: !1, fn: function fn(t) {
	          var e = t.placement,
	              n = e.split("-")[0],
	              r = t.offsets,
	              i = r.popper,
	              o = r.reference,
	              a = -1 !== ["left", "right"].indexOf(n),
	              p = -1 === ["top", "left"].indexOf(n);return i[a ? "left" : "top"] = o[n] - (p ? i[a ? "width" : "height"] : 0), t.placement = D(e), t.offsets.popper = E(i), t;
	        } }, hide: { order: 800, enabled: !0, fn: function fn(t) {
	          if (!W(t.instance.modifiers, "hide", "preventOverflow")) return t;var e = t.offsets.reference,
	              n = N(t.instance.modifiers, function (t) {
	            return "preventOverflow" === t.name;
	          }).boundaries;if (e.bottom < n.top || e.left > n.right || e.top > n.bottom || e.right < n.left) {
	            if (!0 === t.hide) return t;t.hide = !0, t.attributes["x-out-of-boundaries"] = "";
	          } else {
	            if (!1 === t.hide) return t;t.hide = !1, t.attributes["x-out-of-boundaries"] = !1;
	          }return t;
	        } }, computeStyle: { order: 850, enabled: !0, fn: function fn(t, e) {
	          var n = e.x,
	              r = e.y,
	              i = t.offsets.popper,
	              o = N(t.instance.modifiers, function (t) {
	            return "applyStyle" === t.name;
	          }).gpuAcceleration;void 0 !== o && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");var a = void 0 !== o ? o : e.gpuAcceleration,
	              p = d(t.instance.popper),
	              s = O(p),
	              c = { position: i.position },
	              l = function (t, e) {
	            var n = t.offsets,
	                r = n.popper,
	                i = n.reference,
	                o = Math.round,
	                a = Math.floor,
	                p = function p(t) {
	              return t;
	            },
	                s = o(i.width),
	                c = o(r.width),
	                l = -1 !== ["left", "right"].indexOf(t.placement),
	                f = -1 !== t.placement.indexOf("-"),
	                d = e ? l || f || s % 2 == c % 2 ? o : a : p,
	                u = e ? o : p;return { left: d(s % 2 == 1 && c % 2 == 1 && !f && e ? r.left - 1 : r.left), top: u(r.top), bottom: u(r.bottom), right: d(r.right) };
	          }(t, window.devicePixelRatio < 2 || !B),
	              f = "bottom" === n ? "top" : "bottom",
	              u = "right" === r ? "left" : "right",
	              m = _("transform"),
	              h = void 0,
	              b = void 0;if (b = "bottom" === f ? "HTML" === p.nodeName ? -p.clientHeight + l.bottom : -s.height + l.bottom : l.top, h = "right" === u ? "HTML" === p.nodeName ? -p.clientWidth + l.right : -s.width + l.right : l.left, a && m) c[m] = "translate3d(" + h + "px, " + b + "px, 0)", c[f] = 0, c[u] = 0, c.willChange = "transform";else {
	            var v = "bottom" === f ? -1 : 1,
	                y = "right" === u ? -1 : 1;c[f] = b * v, c[u] = h * y, c.willChange = f + ", " + u;
	          }var g = { "x-placement": t.placement };return t.attributes = k({}, g, t.attributes), t.styles = k({}, c, t.styles), t.arrowStyles = k({}, t.offsets.arrow, t.arrowStyles), t;
	        }, gpuAcceleration: !0, x: "bottom", y: "right" }, applyStyle: { order: 900, enabled: !0, fn: function fn(t) {
	          var e, n;return z(t.instance.popper, t.styles), e = t.instance.popper, n = t.attributes, (0, _keys2.default)(n).forEach(function (t) {
	            !1 !== n[t] ? e.setAttribute(t, n[t]) : e.removeAttribute(t);
	          }), t.arrowElement && (0, _keys2.default)(t.arrowStyles).length && z(t.arrowElement, t.arrowStyles), t;
	        }, onLoad: function onLoad(t, e, n, r, i) {
	          var o = S(i, e, t, n.positionFixed),
	              a = L(n.placement, o, e, t, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);return e.setAttribute("x-placement", a), z(e, { position: n.positionFixed ? "fixed" : "absolute" }), n;
	        }, gpuAcceleration: void 0 } } },
	      G = function () {
	    function t(e, n) {
	      var o = this,
	          a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};g(this, t), this.scheduleUpdate = function () {
	        return requestAnimationFrame(o.update);
	      }, this.update = r(this.update.bind(this)), this.options = k({}, t.Defaults, a), this.state = { isDestroyed: !1, isCreated: !1, scrollParents: [] }, this.reference = e && e.jquery ? e[0] : e, this.popper = n && n.jquery ? n[0] : n, this.options.modifiers = {}, (0, _keys2.default)(k({}, t.Defaults.modifiers, a.modifiers)).forEach(function (e) {
	        o.options.modifiers[e] = k({}, t.Defaults.modifiers[e] || {}, a.modifiers ? a.modifiers[e] : {});
	      }), this.modifiers = (0, _keys2.default)(this.options.modifiers).map(function (t) {
	        return k({ name: t }, o.options.modifiers[t]);
	      }).sort(function (t, e) {
	        return t.order - e.order;
	      }), this.modifiers.forEach(function (t) {
	        t.enabled && i(t.onLoad) && t.onLoad(o.reference, o.popper, o.options, t, o.state);
	      }), this.update();var p = this.options.eventsEnabled;p && this.enableEventListeners(), this.state.eventsEnabled = p;
	    }return w(t, [{ key: "update", value: function value() {
	        return function () {
	          if (!this.state.isDestroyed) {
	            var t = { instance: this, styles: {}, arrowStyles: {}, attributes: {}, flipped: !1, offsets: {} };t.offsets.reference = S(this.state, this.popper, this.reference, this.options.positionFixed), t.placement = L(this.options.placement, t.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), t.originalPlacement = t.placement, t.positionFixed = this.options.positionFixed, t.offsets.popper = I(this.popper, t.offsets.reference, t.placement), t.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", t = H(this.modifiers, t), this.state.isCreated ? this.options.onUpdate(t) : (this.state.isCreated = !0, this.options.onCreate(t));
	          }
	        }.call(this);
	      } }, { key: "destroy", value: function value() {
	        return function () {
	          return this.state.isDestroyed = !0, P(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[_("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
	        }.call(this);
	      } }, { key: "enableEventListeners", value: function value() {
	        return function () {
	          this.state.eventsEnabled || (this.state = F(this.reference, this.options, this.state, this.scheduleUpdate));
	        }.call(this);
	      } }, { key: "disableEventListeners", value: function value() {
	        return j.call(this);
	      } }]), t;
	  }();G.Utils = ("undefined" != typeof window ? window : global).PopperUtils, G.placements = V, G.Defaults = K;function J() {
	    return (J = _assign2.default || function (t) {
	      for (var e = 1; e < arguments.length; e++) {
	        var n = arguments[e];for (var r in n) {
	          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
	        }
	      }return t;
	    }).apply(this, arguments);
	  }var Z = "undefined" != typeof window && "undefined" != typeof document,
	      Q = Z ? navigator.userAgent : "",
	      tt = /MSIE |Trident\//.test(Q),
	      et = /UCBrowser\//.test(Q),
	      nt = Z && /iPhone|iPad|iPod/.test(navigator.platform) && !window.MSStream,
	      rt = { a11y: !0, allowHTML: !0, animateFill: !0, animation: "shift-away", appendTo: function appendTo() {
	      return document.body;
	    }, aria: "describedby", arrow: !1, arrowType: "sharp", boundary: "scrollParent", content: "", delay: 0, distance: 10, duration: [325, 275], flip: !0, flipBehavior: "flip", flipOnUpdate: !1, followCursor: !1, hideOnClick: !0, ignoreAttributes: !1, inertia: !1, interactive: !1, interactiveBorder: 2, interactiveDebounce: 0, lazy: !0, maxWidth: 350, multiple: !1, offset: 0, onHidden: function onHidden() {}, onHide: function onHide() {}, onMount: function onMount() {}, onShow: function onShow() {}, onShown: function onShown() {}, onTrigger: function onTrigger() {}, placement: "top", popperOptions: {}, role: "tooltip", showOnInit: !1, size: "regular", sticky: !1, target: "", theme: "dark", touch: !0, touchHold: !1, trigger: "mouseenter focus", triggerTarget: null, updateDuration: 0, wait: null, zIndex: 9999 },
	      it = ["arrow", "arrowType", "boundary", "distance", "flip", "flipBehavior", "flipOnUpdate", "offset", "placement", "popperOptions"],
	      ot = Z ? Element.prototype : {},
	      at = ot.matches || ot.matchesSelector || ot.webkitMatchesSelector || ot.mozMatchesSelector || ot.msMatchesSelector;function pt(t) {
	    return [].slice.call(t);
	  }function st(t, e) {
	    return ct(t, function (t) {
	      return at.call(t, e);
	    });
	  }function ct(t, e) {
	    for (; t;) {
	      if (e(t)) return t;t = t.parentElement;
	    }return null;
	  }var lt = { passive: !0 },
	      ft = 4,
	      dt = "x-placement",
	      ut = "x-out-of-boundaries",
	      mt = "tippy-iOS",
	      ht = "tippy-active",
	      bt = "tippy-popper",
	      vt = "tippy-tooltip",
	      yt = "tippy-content",
	      gt = "tippy-backdrop",
	      wt = "tippy-arrow",
	      xt = "tippy-roundarrow",
	      kt = ".".concat(bt),
	      Et = ".".concat(vt),
	      Ot = ".".concat(yt),
	      At = ".".concat(gt),
	      Ct = ".".concat(wt),
	      Tt = ".".concat(xt),
	      Lt = !1;function St() {
	    Lt || (Lt = !0, nt && document.body.classList.add(mt), window.performance && document.addEventListener("mousemove", Dt));
	  }var Mt = 0;function Dt() {
	    var t = performance.now();t - Mt < 20 && (Lt = !1, document.removeEventListener("mousemove", Dt), nt || document.body.classList.remove(mt)), Mt = t;
	  }function It() {
	    var t = document.activeElement;t && t.blur && t._tippy && t.blur();
	  }var Nt = (0, _keys2.default)(rt);function Ht(t, e) {
	    return {}.hasOwnProperty.call(t, e);
	  }function Pt(t, e, n) {
	    if (Array.isArray(t)) {
	      var r = t[e];return null == r ? n : r;
	    }return t;
	  }function _t(t, e) {
	    return 0 === e ? t : function (r) {
	      clearTimeout(n), n = setTimeout(function () {
	        t(r);
	      }, e);
	    };var n;
	  }function Yt(t, e) {
	    return t && t.modifiers && t.modifiers[e];
	  }function Ft(t, e) {
	    return t.indexOf(e) > -1;
	  }function jt(t) {
	    return t instanceof Element;
	  }function Xt(t) {
	    return !(!t || !Ht(t, "isVirtual")) || jt(t);
	  }function zt(t, e) {
	    return "function" == typeof t ? t.apply(null, e) : t;
	  }function Bt(t, e) {
	    t.filter(function (t) {
	      return "flip" === t.name;
	    })[0].enabled = e;
	  }function Wt() {
	    return document.createElement("div");
	  }function Vt(t, e) {
	    t.forEach(function (t) {
	      t && (t.style.transitionDuration = "".concat(e, "ms"));
	    });
	  }function Rt(t, e) {
	    t.forEach(function (t) {
	      t && t.setAttribute("data-state", e);
	    });
	  }function Ut(t, e) {
	    var n = J({}, e, { content: zt(e.content, [t]) }, e.ignoreAttributes ? {} : function (t) {
	      return Nt.reduce(function (e, n) {
	        var r = (t.getAttribute("data-tippy-".concat(n)) || "").trim();if (!r) return e;if ("content" === n) e[n] = r;else try {
	          e[n] = JSON.parse(r);
	        } catch (t) {
	          e[n] = r;
	        }return e;
	      }, {});
	    }(t));return (n.arrow || et) && (n.animateFill = !1), n;
	  }function $t(t, e) {
	    (0, _keys2.default)(t).forEach(function (t) {
	      if (!Ht(e, t)) throw new Error("[tippy]: `".concat(t, "` is not a valid option"));
	    });
	  }function qt(t, e) {
	    t.innerHTML = jt(e) ? e.innerHTML : e;
	  }function Kt(t, e) {
	    if (jt(e.content)) qt(t, ""), t.appendChild(e.content);else if ("function" != typeof e.content) {
	      t[e.allowHTML ? "innerHTML" : "textContent"] = e.content;
	    }
	  }function Gt(t) {
	    return { tooltip: t.querySelector(Et), backdrop: t.querySelector(At), content: t.querySelector(Ot), arrow: t.querySelector(Ct) || t.querySelector(Tt) };
	  }function Jt(t) {
	    t.setAttribute("data-inertia", "");
	  }function Zt(t) {
	    var e = Wt();return "round" === t ? (e.className = xt, qt(e, '<svg viewBox="0 0 18 7" xmlns="http://www.w3.org/2000/svg"><path d="M0 7s2.021-.015 5.253-4.218C6.584 1.051 7.797.007 9 0c1.203-.007 2.416 1.035 3.761 2.782C16.012 7.005 18 7 18 7H0z"/></svg>')) : e.className = wt, e;
	  }function Qt() {
	    var t = Wt();return t.className = gt, t.setAttribute("data-state", "hidden"), t;
	  }function te(t, e) {
	    t.setAttribute("tabindex", "-1"), e.setAttribute("data-interactive", "");
	  }function ee(t, e, n) {
	    var r = et && void 0 !== document.body.style.webkitTransition ? "webkitTransitionEnd" : "transitionend";t[e + "EventListener"](r, n);
	  }function ne(t) {
	    var e = t.getAttribute(dt);return e ? e.split("-")[0] : "";
	  }function re(t, e, n) {
	    n.split(" ").forEach(function (n) {
	      t.classList[e](n + "-theme");
	    });
	  }function ie(t, e) {
	    var n = Wt();n.className = bt, n.id = "tippy-".concat(t), n.style.zIndex = "" + e.zIndex, n.style.position = "absolute", n.style.top = "0", n.style.left = "0", e.role && n.setAttribute("role", e.role);var r = Wt();r.className = vt, r.style.maxWidth = e.maxWidth + ("number" == typeof e.maxWidth ? "px" : ""), r.setAttribute("data-size", e.size), r.setAttribute("data-animation", e.animation), r.setAttribute("data-state", "hidden"), re(r, "add", e.theme);var i = Wt();return i.className = yt, i.setAttribute("data-state", "hidden"), e.interactive && te(n, r), e.arrow && r.appendChild(Zt(e.arrowType)), e.animateFill && (r.appendChild(Qt()), r.setAttribute("data-animatefill", "")), e.inertia && Jt(r), Kt(i, e), r.appendChild(i), n.appendChild(r), n;
	  }function oe(t, e, n) {
	    var r = Gt(t),
	        i = r.tooltip,
	        o = r.content,
	        a = r.backdrop,
	        p = r.arrow;t.style.zIndex = "" + n.zIndex, i.setAttribute("data-size", n.size), i.setAttribute("data-animation", n.animation), i.style.maxWidth = n.maxWidth + ("number" == typeof n.maxWidth ? "px" : ""), n.role ? t.setAttribute("role", n.role) : t.removeAttribute("role"), e.content !== n.content && Kt(o, n), !e.animateFill && n.animateFill ? (i.appendChild(Qt()), i.setAttribute("data-animatefill", "")) : e.animateFill && !n.animateFill && (i.removeChild(a), i.removeAttribute("data-animatefill")), !e.arrow && n.arrow ? i.appendChild(Zt(n.arrowType)) : e.arrow && !n.arrow && i.removeChild(p), e.arrow && n.arrow && e.arrowType !== n.arrowType && i.replaceChild(Zt(n.arrowType), p), !e.interactive && n.interactive ? te(t, i) : e.interactive && !n.interactive && function (t, e) {
	      t.removeAttribute("tabindex"), e.removeAttribute("data-interactive");
	    }(t, i), !e.inertia && n.inertia ? Jt(i) : e.inertia && !n.inertia && function (t) {
	      t.removeAttribute("data-inertia");
	    }(i), e.theme !== n.theme && (re(i, "remove", e.theme), re(i, "add", n.theme));
	  }var ae = 1,
	      pe = [];function se(t, e) {
	    var n,
	        r,
	        i,
	        o,
	        a,
	        p = Ut(t, e);if (!p.multiple && t._tippy) return null;var s,
	        c,
	        l,
	        f,
	        d,
	        u = !1,
	        m = !1,
	        h = !1,
	        b = !1,
	        v = [],
	        y = _t(_, p.interactiveDebounce),
	        g = ae++,
	        w = ie(g, p),
	        x = Gt(w),
	        k = { id: g, reference: t, popper: w, popperChildren: x, popperInstance: null, props: p, state: { isEnabled: !0, isVisible: !1, isDestroyed: !1, isMounted: !1, isShown: !1 }, clearDelayTimeouts: $, set: q, setContent: function setContent(t) {
	        q({ content: t });
	      }, show: K, hide: Z, enable: function enable() {
	        k.state.isEnabled = !0;
	      }, disable: function disable() {
	        k.state.isEnabled = !1;
	      }, destroy: function destroy(e) {
	        if (k.state.isDestroyed) return;m = !0, k.state.isMounted && Z(0);N(), delete t._tippy;var n = k.props.target;n && e && jt(t) && pt(t.querySelectorAll(n)).forEach(function (t) {
	          t._tippy && t._tippy.destroy();
	        });k.popperInstance && k.popperInstance.destroy();m = !1, k.state.isDestroyed = !0;
	      } };return t._tippy = k, w._tippy = k, I(), p.lazy || W(), p.showOnInit && V(), !p.a11y || p.target || !jt(d = A()) || at.call(d, "a[href],area[href],button,details,input,textarea,select,iframe,[tabindex]") && !d.hasAttribute("disabled") || A().setAttribute("tabindex", "0"), w.addEventListener("mouseenter", function (t) {
	      k.props.interactive && k.state.isVisible && "mouseenter" === n && V(t, !0);
	    }), w.addEventListener("mouseleave", function () {
	      k.props.interactive && "mouseenter" === n && document.addEventListener("mousemove", y);
	    }), k;function E() {
	      document.removeEventListener("mousemove", H);
	    }function O() {
	      document.body.removeEventListener("mouseleave", R), document.removeEventListener("mousemove", y), pe = pe.filter(function (t) {
	        return t !== y;
	      });
	    }function A() {
	      return k.props.triggerTarget || t;
	    }function C() {
	      document.addEventListener("click", U, !0);
	    }function T() {
	      document.removeEventListener("click", U, !0);
	    }function L() {
	      return [k.popperChildren.tooltip, k.popperChildren.backdrop, k.popperChildren.content];
	    }function S() {
	      var t = k.props.followCursor;return t && "focus" !== n || Lt && "initial" === t;
	    }function M(t, e) {
	      var n = k.popperChildren.tooltip;function r(t) {
	        t.target === n && (ee(n, "remove", r), e());
	      }if (0 === t) return e();ee(n, "remove", l), ee(n, "add", r), l = r;
	    }function D(t, e) {
	      var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];A().addEventListener(t, e, n), v.push({ eventType: t, handler: e, options: n });
	    }function I() {
	      k.props.touchHold && !k.props.target && (D("touchstart", P, lt), D("touchend", Y, lt)), k.props.trigger.trim().split(" ").forEach(function (t) {
	        if ("manual" !== t) if (k.props.target) switch (t) {case "mouseenter":
	            D("mouseover", j), D("mouseout", X);break;case "focus":
	            D("focusin", j), D("focusout", X);break;case "click":
	            D(t, j);} else switch (D(t, P), t) {case "mouseenter":
	            D("mouseleave", Y);break;case "focus":
	            D(tt ? "focusout" : "blur", F);}
	      });
	    }function N() {
	      v.forEach(function (t) {
	        var e = t.eventType,
	            n = t.handler,
	            r = t.options;A().removeEventListener(e, n, r);
	      }), v = [];
	    }function H(e) {
	      var n = r = e,
	          i = n.clientX,
	          o = n.clientY;if (f) {
	        var a = ct(e.target, function (e) {
	          return e === t;
	        }),
	            p = t.getBoundingClientRect(),
	            s = k.props.followCursor,
	            c = "horizontal" === s,
	            l = "vertical" === s,
	            d = Ft(["top", "bottom"], ne(w)),
	            u = w.getAttribute(dt),
	            m = !!u && !!u.split("-")[1],
	            h = d ? w.offsetWidth : w.offsetHeight,
	            b = h / 2,
	            v = d ? 0 : m ? h : b,
	            y = d ? m ? h : b : 0;!a && k.props.interactive || (k.popperInstance.reference = J({}, k.popperInstance.reference, { referenceNode: t, clientWidth: 0, clientHeight: 0, getBoundingClientRect: function getBoundingClientRect() {
	            return { width: d ? h : 0, height: d ? 0 : h, top: (c ? p.top : o) - v, bottom: (c ? p.bottom : o) + v, left: (l ? p.left : i) - y, right: (l ? p.right : i) + y };
	          } }), k.popperInstance.update()), "initial" === s && k.state.isVisible && E();
	      }
	    }function P(t) {
	      k.state.isEnabled && !z(t) && (k.state.isVisible || (n = t.type, t instanceof MouseEvent && (r = t, pe.forEach(function (e) {
	        return e(t);
	      }))), "click" === t.type && !1 !== k.props.hideOnClick && k.state.isVisible ? R() : V(t));
	    }function _(e) {
	      var n = st(e.target, kt) === w,
	          r = ct(e.target, function (e) {
	        return e === t;
	      });n || r || function (t, e, n, r) {
	        if (!t) return !0;var i = n.clientX,
	            o = n.clientY,
	            a = r.interactiveBorder,
	            p = r.distance,
	            s = e.top - o > ("top" === t ? a + p : a),
	            c = o - e.bottom > ("bottom" === t ? a + p : a),
	            l = e.left - i > ("left" === t ? a + p : a),
	            f = i - e.right > ("right" === t ? a + p : a);return s || c || l || f;
	      }(ne(w), w.getBoundingClientRect(), e, k.props) && (O(), R());
	    }function Y(t) {
	      if (!z(t)) return k.props.interactive ? (document.body.addEventListener("mouseleave", R), document.addEventListener("mousemove", y), void pe.push(y)) : void R();
	    }function F(t) {
	      t.target === A() && (k.props.interactive && t.relatedTarget && w.contains(t.relatedTarget) || R());
	    }function j(t) {
	      st(t.target, k.props.target) && V(t);
	    }function X(t) {
	      st(t.target, k.props.target) && R();
	    }function z(t) {
	      var e = "ontouchstart" in window,
	          n = Ft(t.type, "touch"),
	          r = k.props.touchHold;return e && Lt && r && !n || Lt && !r && n;
	    }function B() {
	      !b && c && (b = !0, function (t) {
	        t.offsetHeight;
	      }(w), c());
	    }function W() {
	      var e = k.props.popperOptions,
	          n = k.popperChildren,
	          r = n.tooltip,
	          i = n.arrow,
	          o = Yt(e, "preventOverflow");function a(t) {
	        k.props.flip && !k.props.flipOnUpdate && (t.flipped && (k.popperInstance.options.placement = t.placement), Bt(k.popperInstance.modifiers, !1)), r.setAttribute(dt, t.placement), !1 !== t.attributes[ut] ? r.setAttribute(ut, "") : r.removeAttribute(ut), s && s !== t.placement && h && (r.style.transition = "none", requestAnimationFrame(function () {
	          r.style.transition = "";
	        })), s = t.placement, h = k.state.isVisible;var e = ne(w),
	            n = r.style;n.top = n.bottom = n.left = n.right = "", n[e] = -(k.props.distance - 10) + "px";var i = o && void 0 !== o.padding ? o.padding : ft,
	            a = "number" == typeof i,
	            p = J({ top: a ? i : i.top, bottom: a ? i : i.bottom, left: a ? i : i.left, right: a ? i : i.right }, !a && i);p[e] = a ? i + k.props.distance : (i[e] || 0) + k.props.distance, k.popperInstance.modifiers.filter(function (t) {
	          return "preventOverflow" === t.name;
	        })[0].padding = p, f = p;
	      }var p = J({ eventsEnabled: !1, placement: k.props.placement }, e, { modifiers: J({}, e ? e.modifiers : {}, { preventOverflow: J({ boundariesElement: k.props.boundary, padding: ft }, o), arrow: J({ element: i, enabled: !!i }, Yt(e, "arrow")), flip: J({ enabled: k.props.flip, padding: k.props.distance + ft, behavior: k.props.flipBehavior }, Yt(e, "flip")), offset: J({ offset: k.props.offset }, Yt(e, "offset")) }), onCreate: function onCreate(t) {
	          a(t), B(), e && e.onCreate && e.onCreate(t);
	        }, onUpdate: function onUpdate(t) {
	          a(t), B(), e && e.onUpdate && e.onUpdate(t);
	        } });k.popperInstance = new G(t, w, p);
	    }function V(t, n) {
	      if ($(), !k.state.isVisible) {
	        if (k.props.target) return function (t) {
	          if (t) {
	            var n = st(t.target, k.props.target);n && !n._tippy && se(n, J({}, k.props, { content: zt(e.content, [n]), appendTo: e.appendTo, target: "", showOnInit: !0 }));
	          }
	        }(t);if (u = !0, t && !n && k.props.onTrigger(k, t), k.props.wait) return k.props.wait(k, t);S() && !k.state.isMounted && (k.popperInstance || W(), document.addEventListener("mousemove", H)), C();var r = Pt(k.props.delay, 0, rt.delay);r ? i = setTimeout(function () {
	          K();
	        }, r) : K();
	      }
	    }function R() {
	      if ($(), !k.state.isVisible) return E(), void T();u = !1;var t = Pt(k.props.delay, 1, rt.delay);t ? o = setTimeout(function () {
	        k.state.isVisible && Z();
	      }, t) : a = requestAnimationFrame(function () {
	        Z();
	      });
	    }function U(t) {
	      if (!k.props.interactive || !w.contains(t.target)) {
	        if (A().contains(t.target)) {
	          if (Lt) return;if (k.state.isVisible && Ft(k.props.trigger, "click")) return;
	        }!0 === k.props.hideOnClick && ($(), Z());
	      }
	    }function $() {
	      clearTimeout(i), clearTimeout(o), cancelAnimationFrame(a);
	    }function q(e) {
	      $t(e = e || {}, rt), N();var n = k.props,
	          i = Ut(t, J({}, k.props, {}, e, { ignoreAttributes: !0 }));i.ignoreAttributes = Ht(e, "ignoreAttributes") ? e.ignoreAttributes || !1 : n.ignoreAttributes, k.props = i, I(), O(), y = _t(_, i.interactiveDebounce), oe(w, n, i), k.popperChildren = Gt(w), k.popperInstance && (it.some(function (t) {
	        return Ht(e, t) && e[t] !== n[t];
	      }) ? (k.popperInstance.destroy(), W(), k.state.isVisible && k.popperInstance.enableEventListeners(), k.props.followCursor && r && H(r)) : k.popperInstance.update());
	    }function K() {
	      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Pt(k.props.duration, 0, rt.duration[1]);if (!k.state.isDestroyed && k.state.isEnabled && (!Lt || k.props.touch) && !A().hasAttribute("disabled") && !1 !== k.props.onShow(k)) {
	        C(), w.style.visibility = "visible", k.state.isVisible = !0, k.props.interactive && A().classList.add(ht);var n = L();Vt(n.concat(w), 0), c = function c() {
	          if (k.state.isVisible) {
	            var i = S();i && r ? H(r) : i || k.popperInstance.update(), k.popperChildren.backdrop && (k.popperChildren.content.style.transitionDelay = Math.round(e / 12) + "ms"), k.props.sticky && function () {
	              Vt([w], tt ? 0 : k.props.updateDuration);var e = t.getBoundingClientRect();!function n() {
	                var r = t.getBoundingClientRect();e.top === r.top && e.right === r.right && e.bottom === r.bottom && e.left === r.left || k.popperInstance.scheduleUpdate(), e = r, k.state.isMounted && requestAnimationFrame(n);
	              }();
	            }(), Vt([w], k.props.updateDuration), Vt(n, e), Rt(n, "visible"), function (t, e) {
	              M(t, e);
	            }(e, function () {
	              k.props.aria && A().setAttribute("aria-".concat(k.props.aria), w.id), k.props.onShown(k), k.state.isShown = !0;
	            });
	          }
	        }, function () {
	          b = !1;var e = S();k.popperInstance ? (Bt(k.popperInstance.modifiers, k.props.flip), e || (k.popperInstance.reference = t, k.popperInstance.enableEventListeners()), k.popperInstance.scheduleUpdate()) : (W(), e || k.popperInstance.enableEventListeners());var n = k.props.appendTo,
	              r = "parent" === n ? t.parentNode : zt(n, [t]);r.contains(w) || (r.appendChild(w), k.props.onMount(k), k.state.isMounted = !0);
	        }();
	      }
	    }function Z() {
	      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Pt(k.props.duration, 1, rt.duration[1]);if (!k.state.isDestroyed && (k.state.isEnabled || m) && (!1 !== k.props.onHide(k) || m)) {
	        T(), w.style.visibility = "hidden", k.state.isVisible = !1, k.state.isShown = !1, h = !1, k.props.interactive && A().classList.remove(ht);var e = L();Vt(e, t), Rt(e, "hidden"), function (t, e) {
	          M(t, function () {
	            !k.state.isVisible && w.parentNode && w.parentNode.contains(w) && e();
	          });
	        }(t, function () {
	          u || E(), k.props.aria && A().removeAttribute("aria-".concat(k.props.aria)), k.popperInstance.disableEventListeners(), k.popperInstance.options.placement = k.props.placement, w.parentNode.removeChild(w), k.props.onHidden(k), k.state.isMounted = !1;
	        });
	      }
	    }
	  }var ce = !1;function le(t, e) {
	    $t(e || {}, rt), ce || (document.addEventListener("touchstart", St, lt), window.addEventListener("blur", It), ce = !0);var n,
	        r = J({}, rt, {}, e);n = t, "[object Object]" !== {}.toString.call(n) || n.addEventListener || function (t) {
	      var e = { isVirtual: !0, attributes: t.attributes || {}, contains: function contains() {}, setAttribute: function setAttribute(e, n) {
	          t.attributes[e] = n;
	        }, getAttribute: function getAttribute(e) {
	          return t.attributes[e];
	        }, removeAttribute: function removeAttribute(e) {
	          delete t.attributes[e];
	        }, hasAttribute: function hasAttribute(e) {
	          return e in t.attributes;
	        }, addEventListener: function addEventListener() {}, removeEventListener: function removeEventListener() {}, classList: { classNames: {}, add: function add(e) {
	            t.classList.classNames[e] = !0;
	          }, remove: function remove(e) {
	            delete t.classList.classNames[e];
	          }, contains: function contains(e) {
	            return e in t.classList.classNames;
	          } } };for (var n in e) {
	        t[n] = e[n];
	      }
	    }(t);var i = function (t) {
	      if (Xt(t)) return [t];if (t instanceof NodeList) return pt(t);if (Array.isArray(t)) return t;try {
	        return pt(document.querySelectorAll(t));
	      } catch (t) {
	        return [];
	      }
	    }(t).reduce(function (t, e) {
	      var n = e && se(e, r);return n && t.push(n), t;
	    }, []);return Xt(t) ? i[0] : i;
	  }le.version = "4.3.5", le.defaults = rt, le.setDefaults = function (t) {
	    (0, _keys2.default)(t).forEach(function (e) {
	      rt[e] = t[e];
	    });
	  }, le.hideAll = function () {
	    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
	        e = t.exclude,
	        n = t.duration;pt(document.querySelectorAll(kt)).forEach(function (t) {
	      var r,
	          i = t._tippy;if (i) {
	        var o = !1;e && (o = (r = e)._tippy && !at.call(r, kt) ? i.reference === e : t === e.popper), o || i.hide(n);
	      }
	    });
	  }, le.group = function (t) {
	    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
	        n = e.delay,
	        r = void 0 === n ? t[0].props.delay : n,
	        i = e.duration,
	        o = void 0 === i ? 0 : i,
	        a = !1;function p(t) {
	      a = t, f();
	    }function s(e) {
	      e._originalProps.onShow(e), t.forEach(function (t) {
	        t.set({ duration: o }), t.state.isVisible && t.hide();
	      }), p(!0);
	    }function c(t) {
	      t._originalProps.onHide(t), p(!1);
	    }function l(t) {
	      t._originalProps.onShown(t), t.set({ duration: t._originalProps.duration });
	    }function f() {
	      t.forEach(function (t) {
	        t.set({ onShow: s, onShown: l, onHide: c, delay: a ? [0, Array.isArray(r) ? r[1] : r] : r, duration: a ? o : t._originalProps.duration });
	      });
	    }t.forEach(function (t) {
	      t._originalProps ? t.set(t._originalProps) : t._originalProps = J({}, t.props);
	    }), f();
	  }, Z && setTimeout(function () {
	    pt(document.querySelectorAll("[data-tippy]")).forEach(function (t) {
	      var e = t.getAttribute("data-tippy");e && le(t, { content: e });
	    });
	  }), function (t) {
	    if (Z) {
	      var e = document.createElement("style");e.type = "text/css", e.textContent = t, e.setAttribute("data-tippy-stylesheet", "");var n = document.head,
	          r = n.querySelector("style,link");r ? n.insertBefore(e, r) : n.appendChild(e);
	    }
	  }('.tippy-iOS{cursor:pointer!important;-webkit-tap-highlight-color:transparent}.tippy-popper{transition-timing-function:cubic-bezier(.165,.84,.44,1);max-width:calc(100% - 8px);pointer-events:none;outline:0}.tippy-popper[x-placement^=top] .tippy-backdrop{border-radius:40% 40% 0 0}.tippy-popper[x-placement^=top] .tippy-roundarrow{bottom:-7px;bottom:-6.5px;-webkit-transform-origin:50% 0;transform-origin:50% 0;margin:0 3px}.tippy-popper[x-placement^=top] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.tippy-popper[x-placement^=top] .tippy-arrow{border-top:8px solid #333;border-right:8px solid transparent;border-left:8px solid transparent;bottom:-7px;margin:0 3px;-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=top] .tippy-backdrop{-webkit-transform-origin:0 25%;transform-origin:0 25%}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-55%);transform:scale(1) translate(-50%,-55%)}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-50%,-45%);transform:scale(.2) translate(-50%,-45%);opacity:0}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(-20px);transform:translateY(-20px)}.tippy-popper[x-placement^=top] [data-animation=perspective]{-webkit-transform-origin:bottom;transform-origin:bottom}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateY(-10px);transform:perspective(700px) translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) rotateX(60deg);transform:perspective(700px) rotateX(60deg)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=top] [data-animation=scale]{-webkit-transform-origin:bottom;transform-origin:bottom}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(-10px) scale(.5);transform:translateY(-10px) scale(.5)}.tippy-popper[x-placement^=bottom] .tippy-backdrop{border-radius:0 0 30% 30%}.tippy-popper[x-placement^=bottom] .tippy-roundarrow{top:-7px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%;margin:0 3px}.tippy-popper[x-placement^=bottom] .tippy-roundarrow svg{position:absolute;left:0}.tippy-popper[x-placement^=bottom] .tippy-arrow{border-bottom:8px solid #333;border-right:8px solid transparent;border-left:8px solid transparent;top:-7px;margin:0 3px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%}.tippy-popper[x-placement^=bottom] .tippy-backdrop{-webkit-transform-origin:0 -50%;transform-origin:0 -50%}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-45%);transform:scale(1) translate(-50%,-45%)}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-50%);transform:scale(.2) translate(-50%);opacity:0}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(20px);transform:translateY(20px)}.tippy-popper[x-placement^=bottom] [data-animation=perspective]{-webkit-transform-origin:top;transform-origin:top}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateY(10px);transform:perspective(700px) translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) rotateX(-60deg);transform:perspective(700px) rotateX(-60deg)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=bottom] [data-animation=scale]{-webkit-transform-origin:top;transform-origin:top}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(10px) scale(.5);transform:translateY(10px) scale(.5)}.tippy-popper[x-placement^=left] .tippy-backdrop{border-radius:50% 0 0 50%}.tippy-popper[x-placement^=left] .tippy-roundarrow{right:-12px;-webkit-transform-origin:33.33333333% 50%;transform-origin:33.33333333% 50%;margin:3px 0}.tippy-popper[x-placement^=left] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(90deg);transform:rotate(90deg)}.tippy-popper[x-placement^=left] .tippy-arrow{border-left:8px solid #333;border-top:8px solid transparent;border-bottom:8px solid transparent;right:-7px;margin:3px 0;-webkit-transform-origin:0 50%;transform-origin:0 50%}.tippy-popper[x-placement^=left] .tippy-backdrop{-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-50%);transform:scale(1) translate(-50%,-50%)}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-75%,-50%);transform:scale(.2) translate(-75%,-50%);opacity:0}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(-20px);transform:translateX(-20px)}.tippy-popper[x-placement^=left] [data-animation=perspective]{-webkit-transform-origin:right;transform-origin:right}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateX(-10px);transform:perspective(700px) translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) rotateY(-60deg);transform:perspective(700px) rotateY(-60deg)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=left] [data-animation=scale]{-webkit-transform-origin:right;transform-origin:right}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(-10px) scale(.5);transform:translateX(-10px) scale(.5)}.tippy-popper[x-placement^=right] .tippy-backdrop{border-radius:0 50% 50% 0}.tippy-popper[x-placement^=right] .tippy-roundarrow{left:-12px;-webkit-transform-origin:66.66666666% 50%;transform-origin:66.66666666% 50%;margin:3px 0}.tippy-popper[x-placement^=right] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.tippy-popper[x-placement^=right] .tippy-arrow{border-right:8px solid #333;border-top:8px solid transparent;border-bottom:8px solid transparent;left:-7px;margin:3px 0;-webkit-transform-origin:100% 50%;transform-origin:100% 50%}.tippy-popper[x-placement^=right] .tippy-backdrop{-webkit-transform-origin:-50% 0;transform-origin:-50% 0}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-50%);transform:scale(1) translate(-50%,-50%)}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-25%,-50%);transform:scale(.2) translate(-25%,-50%);opacity:0}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(20px);transform:translateX(20px)}.tippy-popper[x-placement^=right] [data-animation=perspective]{-webkit-transform-origin:left;transform-origin:left}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateX(10px);transform:perspective(700px) translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) rotateY(60deg);transform:perspective(700px) rotateY(60deg)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=right] [data-animation=scale]{-webkit-transform-origin:left;transform-origin:left}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(10px) scale(.5);transform:translateX(10px) scale(.5)}.tippy-tooltip{position:relative;color:#fff;border-radius:.25rem;font-size:.875rem;padding:.3125rem .5625rem;line-height:1.4;text-align:center;background-color:#333}.tippy-tooltip[data-size=small]{padding:.1875rem .375rem;font-size:.75rem}.tippy-tooltip[data-size=large]{padding:.375rem .75rem;font-size:1rem}.tippy-tooltip[data-animatefill]{overflow:hidden;background-color:initial}.tippy-tooltip[data-interactive],.tippy-tooltip[data-interactive] .tippy-roundarrow path{pointer-events:auto}.tippy-tooltip[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-tooltip[data-inertia][data-state=hidden]{transition-timing-function:ease}.tippy-arrow,.tippy-roundarrow{position:absolute;width:0;height:0}.tippy-roundarrow{width:18px;height:7px;fill:#333;pointer-events:none}.tippy-backdrop{position:absolute;background-color:#333;border-radius:50%;width:calc(110% + 2rem);left:50%;top:50%;z-index:-1;transition:all cubic-bezier(.46,.1,.52,.98);-webkit-backface-visibility:hidden;backface-visibility:hidden}.tippy-backdrop:after{content:"";float:left;padding-top:100%}.tippy-backdrop+.tippy-content{transition-property:opacity;will-change:opacity}.tippy-backdrop+.tippy-content[data-state=hidden]{opacity:0}');var fe = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};var de,
	      ue = (function (t) {
	    var e, _n, r, i, o, a, p, s, c, l, f, d, u, m, h;e = fe, _n = function n(t, e, r) {
	      if (!s(e) || l(e) || f(e) || d(e) || p(e)) return e;var i,
	          o = 0,
	          a = 0;if (c(e)) for (i = [], a = e.length; o < a; o++) {
	        i.push(_n(t, e[o], r));
	      } else for (var u in i = {}, e) {
	        Object.prototype.hasOwnProperty.call(e, u) && (i[t(u, r)] = _n(t, e[u], r));
	      }return i;
	    }, r = function r(t) {
	      return u(t) ? t : (t = t.replace(/[\-_\s]+(.)?/g, function (t, e) {
	        return e ? e.toUpperCase() : "";
	      })).substr(0, 1).toLowerCase() + t.substr(1);
	    }, i = function i(t) {
	      var e = r(t);return e.substr(0, 1).toUpperCase() + e.substr(1);
	    }, o = function o(t, e) {
	      return function (t, e) {
	        var n = (e = e || {}).separator || "_",
	            r = e.split || /(?=[A-Z])/;return t.split(r).join(n);
	      }(t, e).toLowerCase();
	    }, a = Object.prototype.toString, p = function p(t) {
	      return "function" == typeof t;
	    }, s = function s(t) {
	      return t === Object(t);
	    }, c = function c(t) {
	      return "[object Array]" == a.call(t);
	    }, l = function l(t) {
	      return "[object Date]" == a.call(t);
	    }, f = function f(t) {
	      return "[object RegExp]" == a.call(t);
	    }, d = function d(t) {
	      return "[object Boolean]" == a.call(t);
	    }, u = function u(t) {
	      return (t -= 0) == t;
	    }, m = function m(t, e) {
	      var n = e && "process" in e ? e.process : e;return "function" != typeof n ? t : function (e, r) {
	        return n(e, t, r);
	      };
	    }, h = { camelize: r, decamelize: o, pascalize: i, depascalize: o, camelizeKeys: function camelizeKeys(t, e) {
	        return _n(m(r, e), t);
	      }, decamelizeKeys: function decamelizeKeys(t, e) {
	        return _n(m(o, e), t, e);
	      }, pascalizeKeys: function pascalizeKeys(t, e) {
	        return _n(m(i, e), t);
	      }, depascalizeKeys: function depascalizeKeys() {
	        return this.decamelizeKeys.apply(this, arguments);
	      } }, t.exports ? t.exports = h : e.humps = h;
	  }(de = { exports: {} }, de.exports), de.exports);function me(t, e, n) {
	    return e in t ? (0, _defineProperty2.default)(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
	  }function he(t, e) {
	    var n = (0, _keys2.default)(t);if (_getOwnPropertySymbols2.default) {
	      var r = (0, _getOwnPropertySymbols2.default)(t);e && (r = r.filter(function (e) {
	        return (0, _getOwnPropertyDescriptor2.default)(t, e).enumerable;
	      })), n.push.apply(n, r);
	    }return n;
	  }var be = { a11y: !0, allowHTML: !0, animateFill: !0, arrow: !1, flip: !0, flipOnUpdate: !1, followCursor: !1, hideOnClick: !0, ignoreAttributes: !1, inertia: !1, interactive: !1, lazy: !0, multiple: !1, showOnInit: !1, sticky: !1, touch: !0, touchHold: !1 },
	      ve = function (t) {
	    for (var e = 1; e < arguments.length; e++) {
	      var n = null != arguments[e] ? arguments[e] : {};e % 2 ? he(Object(n), !0).forEach(function (e) {
	        me(t, e, n[e]);
	      }) : _getOwnPropertyDescriptors2.default ? (0, _defineProperties2.default)(t, (0, _getOwnPropertyDescriptors2.default)(n)) : he(Object(n)).forEach(function (e) {
	        (0, _defineProperty2.default)(t, e, (0, _getOwnPropertyDescriptor2.default)(n, e));
	      });
	    }return t;
	  }({ animation: "shift-away", appendTo: function appendTo() {
	      return document.body;
	    }, aria: "describedby", arrowType: "sharp", boundary: "scrollParent", content: "", delay: 0, distance: 10, duration: [325, 275], flipBehavior: "flip", interactiveBorder: 2, interactiveDebounce: 0, maxWidth: 350, offset: 0, onHidden: function onHidden() {}, onHide: function onHide() {}, onMount: function onMount() {}, onShow: function onShow() {}, onShown: function onShown() {}, placement: "top", popperOptions: {}, role: "tooltip", size: "regular", target: "", theme: "dark", trigger: "mouseenter focus", updateDuration: 0, wait: null, zIndex: 9999 }, be),
	      ye = { props: ["to", "toSelector", "toElement", "content", "enabled", "visible", "triggerTarget"], data: function data() {
	      return { tip: null, options: {} };
	    }, mounted: function mounted() {
	      this.init();
	    }, watch: { content: function content() {
	        this.tip && this.tip.set(this.getOptions());
	      }, enabled: function enabled(t) {
	        this.tip && (t ? this.tip.enable() : (this.tip.hide(), this.tip.disable()));
	      }, visible: function visible(t) {
	        this.tip && (t ? this.tip.show() : this.tip.hide());
	      } }, updated: function updated() {
	      this.tip && !this.content && this.tip.set(this.getOptions());
	    }, beforeDestroy: function beforeDestroy() {
	      this.tip && this.tip.destroy();
	    }, computed: { isManualTrigger: function isManualTrigger() {
	        return "manual" === this.options.trigger;
	      } }, methods: { init: function init() {
	        if (this.tip) {
	          try {
	            this.tip.destroy();
	          } catch (t) {}this.tip = null;
	        }var t = this.toElement;if (null == t && (t = this.to ? document.querySelector("[name='".concat(this.to, "']")) : this.toSelector ? document.querySelector(this.toSelector) : this.$refs.trigger && this.$refs.trigger.childElementCount > 0 ? this.$refs.trigger : this.$el.parentElement), t) {
	          var e = le(t, this.getOptions());if (e) {
	            if (Array.isArray(e)) {
	              if (!(e.length > 0)) return;this.tip = e[0];
	            }this.tip = e, this.$emit("onCreate", this.tip), this.$emit("init", this.tip), !1 === this.enabled && this.tip.disable(), this.isManualTrigger && !0 === this.visible && this.tip.show();
	          }
	        }
	      }, tippy: function tippy() {
	        return this.tip;
	      }, filterOptions: function filterOptions() {
	        for (var t = function t(_t2, e) {
	          if (be.hasOwnProperty(_t2)) {
	            if ("" === e) return !0;if ("false" === e) return !1;if ("true" === e) return !0;
	          }return e;
	        }, e = 0, n = (0, _keys2.default)(this.options); e < n.length; e++) {
	          var r = n[e];ve.hasOwnProperty(r) || delete this.options[r], this.options[r] = t(r, this.options[r]);
	        }return this.options;
	      }, getOptions: function getOptions() {
	        var t = this;return (0, _assign2.default)(this.options, ue.camelizeKeys(this.$attrs)), this.filterOptions(), !this.options.onShow && this.$listeners && this.$listeners.show && (this.options.onShow = function () {
	          var e;return (e = t.$listeners.show).fns.apply(e, arguments);
	        }), this.options.onShown || (this.options.onShown = function () {
	          for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
	            n[r] = arguments[r];
	          }t.$emit.apply(t, ["shown"].concat(n));
	        }), this.options.onHidden || (this.options.onHidden = function () {
	          for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
	            n[r] = arguments[r];
	          }t.$emit.apply(t, ["hidden"].concat(n));
	        }), !this.options.onHide && this.$listeners && this.$listeners.hide && (this.options.onHide = function () {
	          var e;return (e = t.$listeners.hide).fns.apply(e, arguments);
	        }), this.options.onMount || (this.options.onMount = function () {
	          for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
	            n[r] = arguments[r];
	          }t.$emit.apply(t, ["mount"].concat(n));
	        }), this.options.hasOwnProperty("content") || (this.options.content = this.content ? this.content : this.$refs.content), this.options.triggerTarget = this.triggerTarget, this.options;
	      } } };"undefined" != typeof navigator && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());var ge = function (t, e, n, r, i, o, a, p, s, c) {
	    "boolean" != typeof a && (s = p, p = a, a = !1);var l = "function" == typeof n ? n.options : n;var f = void 0;if (t && t.render && (l.render = t.render, l.staticRenderFns = t.staticRenderFns, l._compiled = !0, i && (l.functional = !0)), r && (l._scopeId = r), o ? (f = function f(t) {
	      (t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), e && e.call(this, s(t)), t && t._registeredComponents && t._registeredComponents.add(o);
	    }, l._ssrRegister = f) : e && (f = a ? function (t) {
	      e.call(this, c(t, this.$root.$options.shadowRoot));
	    } : function (t) {
	      e.call(this, p(t));
	    }), f) if (l.functional) {
	      var _t3 = l.render;l.render = function (e, n) {
	        return f.call(n), _t3(e, n);
	      };
	    } else {
	      var _t4 = l.beforeCreate;l.beforeCreate = _t4 ? [].concat(_t4, f) : [f];
	    }return n;
	  }({ render: function render() {
	      var t = this.$createElement,
	          e = this._self._c || t;return e("div", [e("div", { ref: "trigger" }, [this._t("trigger")], 2), this._v(" "), e("div", { ref: "content" }, [this._t("default")], 2)]);
	    }, staticRenderFns: [] }, void 0, ye, void 0, !1, void 0, !1, void 0, void 0, void 0),
	      we = "tippy",
	      xe = { install: function install(t) {
	      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};we = e.directive || "tippy", le.setDefaults(e || {}), t.directive(we, { inserted: function inserted(n, r, i) {
	          t.nextTick(function () {
	            !function (n, r, i) {
	              var o = i.data && i.data.on || i.componentOptions && i.componentOptions.listeners,
	                  a = r.value || {};a = (0, _assign2.default)({}, e, a), o && o.show && (a.onShow = function () {
	                var t;return (t = o.show).fns.apply(t, arguments);
	              }), o && o.shown && (a.onShown = function () {
	                var t;(t = o.shown).fns.apply(t, arguments);
	              }), o && o.hidden && (a.onHidden = function () {
	                var t;(t = o.hidden).fns.apply(t, arguments);
	              }), o && o.hide && (a.onHide = function () {
	                var t;return (t = o.hide).fns.apply(t, arguments);
	              }), o && o.mount && (a.onMount = function () {
	                var t;(t = o.mount).fns.apply(t, arguments);
	              }), n.getAttribute("title") && !a.content && (a.content = n.getAttribute("title")), n.getAttribute("content") && !a.content && (a.content = n.getAttribute("content")), le(n, a), a.showOnLoad && n._tippy.show(), t.nextTick(function () {
	                o && o.init && o.init.fns(n._tippy, n);
	              });
	            }(n, r, i);
	          });
	        }, unbind: function unbind(t) {
	          t._tippy && t._tippy.destroy();
	        }, componentUpdated: function componentUpdated(t, e, n) {
	          if (t._tippy) {
	            var r = e.value || {};t.getAttribute("title") && !r.content && (r.content = t.getAttribute("title")), t.getAttribute("content") && !r.content && (r.content = t.getAttribute("content")), t._tippy.set(r);
	          }
	        } });
	    } };return "undefined" != typeof window && window.Vue && (window.Vue.use(xe), window.Vue.component("tippy", ge)), t.TippyComponent = ge, t.default = xe, t.tippy = le, t;
	}({});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(56);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(57);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Event = __webpack_require__(113);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Channel = function () {
	  function Channel(name, _dispatcher) {
	    var is_private = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    var on_success = arguments[3];
	    var on_failure = arguments[4];
	    (0, _classCallCheck3.default)(this, Channel);
	
	    var event_name = void 0;
	
	    this.name = name;
	    this._dispatcher = _dispatcher;
	    this.is_private = is_private;
	    this.on_success = on_success;
	    this.on_failure = on_failure;
	    this._callbacks = {};
	    this._token = void 0;
	    this._queue = [];
	
	    if (this.is_private) {
	      event_name = 'websocket_rails.subscribe_private';
	    } else {
	      event_name = 'websocket_rails.subscribe';
	    }
	
	    if (this._dispatcher._conn) {
	      this.connection_id = this._dispatcher._conn.connection_id;
	    }
	
	    var event = new _Event2.default([event_name, {
	      data: {
	        channel: this.name
	      }
	    }, this.connection_id], this._success_launcher, this._failure_launcher);
	    this._dispatcher.trigger_event(event);
	  }
	
	  (0, _createClass3.default)(Channel, [{
	    key: 'destroy',
	    value: function destroy() {
	      if (this.connection_id === (this._dispatcher._conn && this._dispatcher._conn.connection_id)) {
	        var event_name = 'websocket_rails.unsubscribe';
	        var event = new _Event2.default([event_name, {
	          data: {
	            channel: this.name
	          }
	        }, this.connection_id]);
	        this._dispatcher.trigger_event(event);
	      }
	
	      return this._callbacks = {};
	    }
	  }, {
	    key: 'bind',
	    value: function bind(eventName, callback) {
	      var _callbacks = this._callbacks;
	
	
	      if (!_callbacks[eventName]) {
	        _callbacks[eventName] = [];
	      }
	
	      return _callbacks[eventName].push(callback);
	    }
	  }, {
	    key: 'unbind',
	    value: function unbind(eventName) {
	      return delete this._callbacks[eventName];
	    }
	  }, {
	    key: 'trigger',
	    value: function trigger(eventName, message) {
	      var name = this.name,
	          _token = this._token,
	          connection_id = this.connection_id,
	          _queue = this._queue,
	          _dispatcher = this._dispatcher;
	
	
	      var event = new _Event2.default([eventName, {
	        channel: name,
	        data: message,
	        token: _token
	      }, connection_id]);
	      if (!_token) {
	        return _queue.push(event);
	      }
	      return _dispatcher.trigger_event(event);
	    }
	  }, {
	    key: 'dispatch',
	    value: function dispatch(eventName, message) {
	      if (eventName === 'websocket_rails.channel_token') {
	        this.connection_id = this._dispatcher._conn && this._dispatcher._conn.connection_id;
	        this._token = message.token;
	        return this.flush_queue();
	      }
	
	      if (this._callbacks[eventName]) {
	        return this._callbacks[eventName].map(function (item) {
	          return item(message);
	        });
	      }
	    }
	  }, {
	    key: '_success_launcher',
	    value: function _success_launcher(data) {
	      var on_success = this.on_success;
	
	
	      if (on_success) {
	        return on_success(data);
	      }
	    }
	  }, {
	    key: '_failure_launcher',
	    value: function _failure_launcher(data) {
	      var on_failure = this.on_failure;
	
	
	      if (on_failure) {
	        return on_failure(data);
	      }
	    }
	  }, {
	    key: 'flush_queue',
	    value: function flush_queue() {
	      var _this = this;
	
	      this._queue.forEach(function (item) {
	        _this._dispatcher.trigger_event(item);
	      });
	
	      return this._queue = [];
	    }
	  }]);
	  return Channel;
	}();
	
	exports.default = Channel;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(115);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(56);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(57);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(165);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(163);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(164);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _AbstractConnection2 = __webpack_require__(160);
	
	var _AbstractConnection3 = _interopRequireDefault(_AbstractConnection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HttpConnection = function (_AbstractConnection) {
	  (0, _inherits3.default)(HttpConnection, _AbstractConnection);
	
	  function HttpConnection(url, dispatcher) {
	    (0, _classCallCheck3.default)(this, HttpConnection);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (HttpConnection.__proto__ || (0, _getPrototypeOf2.default)(HttpConnection)).call(this, url, dispatcher));
	
	    _this.connection_type = 'http';
	    _this.dispatcher = dispatcher;
	    _this._url = 'http://' + url;
	    _this._conn = _this._createXMLHttpObject();
	    _this.last_pos = 0;
	    try {
	      _this._conn.onreadystatechange = _this._parse_stream();
	      _this._conn.addEventListener('load', _this.on_close, false);
	    } catch (_error) {
	      _this._conn.onprogress = _this._parse_stream();
	      _this._conn.onload = _this.on_close;
	      _this._conn.readyState = 3;
	      console.error(_error);
	    }
	    _this._conn.open('GET', _this._url, true);
	    _this._conn.send();
	    return _this;
	  }
	
	  (0, _createClass3.default)(HttpConnection, [{
	    key: '_httpFactories',
	    value: function _httpFactories() {
	      var _window = window,
	          XDomainRequest = _window.XDomainRequest,
	          XMLHttpRequest = _window.XMLHttpRequest,
	          ActiveXObject = _window.ActiveXObject;
	
	
	      return [function () {
	        return new XDomainRequest();
	      }, function () {
	        return new XMLHttpRequest();
	      }, function () {
	        return new ActiveXObject('Msxml2.XMLHTTP');
	      }, function () {
	        return new ActiveXObject('Msxml3.XMLHTTP');
	      }, function () {
	        return new ActiveXObject('Microsoft.XMLHTTP');
	      }];
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      return this._conn.abort();
	    }
	  }, {
	    key: 'send_event',
	    value: function send_event(event) {
	      (0, _get3.default)(HttpConnection.prototype.__proto__ || (0, _getPrototypeOf2.default)(HttpConnection.prototype), 'send_event', this).call(this, event);
	      return this._post_data(event.serialize());
	    }
	  }, {
	    key: '_post_data',
	    value: function _post_data(payload) {
	      var formData = new FormData();
	      formData.append('client_id', this.connection_id);
	      formData.append('data', payload);
	      return fetch(this._url, {
	        method: 'POST',
	        body: formData
	      });
	    }
	  }, {
	    key: '_createXMLHttpObject',
	    value: function _createXMLHttpObject() {
	      var factories = void 0;
	      var factory = void 0;
	      var i = void 0;
	      var len = void 0;
	      var xmlhttp = void 0;
	
	      xmlhttp = false;
	      factories = this._httpFactories();
	
	      for (i = 0, len = factories.length; i < len; i++) {
	        factory = factories[i];
	        try {
	          xmlhttp = factory();
	        } catch (_error) {
	          continue;
	        }
	        break;
	      }
	      return xmlhttp;
	    }
	  }, {
	    key: '_parse_stream',
	    value: function _parse_stream() {
	      var data = void 0;
	      var event_data = void 0;
	
	      if (this._conn.readyState === 3) {
	        data = this._conn.responseText.substring(this.last_pos);
	        this.last_pos = this._conn.responseText.length;
	        data = data.replace(/\]\]\[\[/g, "],[");
	
	        try {
	          event_data = JSON.parse(data);
	          return this.on_message(event_data);
	        } catch (_error) {
	          console.error(_error);
	        }
	      }
	    }
	  }]);
	  return HttpConnection;
	}(_AbstractConnection3.default);
	
	exports.default = HttpConnection;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(115);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(56);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(57);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(165);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(163);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(164);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _AbstractConnection2 = __webpack_require__(160);
	
	var _AbstractConnection3 = _interopRequireDefault(_AbstractConnection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WebSocketConnection = function (_AbstractConnection) {
	  (0, _inherits3.default)(WebSocketConnection, _AbstractConnection);
	
	  function WebSocketConnection(url, dispatcher) {
	    (0, _classCallCheck3.default)(this, WebSocketConnection);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (WebSocketConnection.__proto__ || (0, _getPrototypeOf2.default)(WebSocketConnection)).call(this, url, dispatcher));
	
	    _this.url = url;
	    _this.connection_type = 'websocket';
	
	    if (_this.url.match(/^wss?:\/\//)) {
	      console.log('WARNING: Using connection urls with protocol specified is depricated');
	    } else if (window.location.protocol === 'https:') {
	      _this.url = 'wss://' + _this.url;
	    } else {
	      _this.url = 'ws://' + _this.url;
	    }
	
	    _this._conn = new WebSocket(_this.url);
	    _this._conn.onmessage = function (event) {
	      return _this.on_message(JSON.parse(event.data));
	    };
	
	    _this._conn.onclose = function (event) {
	      return _this.on_close(event);
	    };
	
	    _this._conn.onerror = function (event) {
	      return _this.on_error(event);
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(WebSocketConnection, [{
	    key: 'close',
	    value: function close() {
	      return this._conn.close();
	    }
	  }, {
	    key: 'send_event',
	    value: function send_event(event) {
	      (0, _get3.default)(WebSocketConnection.prototype.__proto__ || (0, _getPrototypeOf2.default)(WebSocketConnection.prototype), 'send_event', this).call(this, event);
	      return this._conn.send(event.serialize());
	    }
	  }]);
	  return WebSocketConnection;
	}(_AbstractConnection3.default);
	
	exports.default = WebSocketConnection;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(28);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(56);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(57);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Channel = __webpack_require__(449);
	
	var _Channel2 = _interopRequireDefault(_Channel);
	
	var _HttpConnection = __webpack_require__(450);
	
	var _HttpConnection2 = _interopRequireDefault(_HttpConnection);
	
	var _WebSocketConnection = __webpack_require__(451);
	
	var _WebSocketConnection2 = _interopRequireDefault(_WebSocketConnection);
	
	var _Event = __webpack_require__(113);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WebSocketRails = function () {
	  function WebSocketRails(url) {
	    var use_websockets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    (0, _classCallCheck3.default)(this, WebSocketRails);
	
	    this.url = url;
	    this.use_websockets = use_websockets;
	    this.callbacks = {};
	    this.channels = {};
	    this.queue = {};
	    this.connect();
	  }
	
	  (0, _createClass3.default)(WebSocketRails, [{
	    key: 'connect',
	    value: function connect() {
	      this.state = 'connecting';
	      if (!(this.supports_websockets() && this.use_websockets)) {
	        this._conn = new _HttpConnection2.default(this.url, this);
	      } else {
	        this._conn = new _WebSocketConnection2.default(this.url, this);
	      }
	      return this._conn.new_message = this.new_message;
	    }
	  }, {
	    key: 'disconnect',
	    value: function disconnect() {
	      if (this._conn) {
	        this._conn.close();
	        delete this._conn._conn;
	        delete this._conn;
	      }
	      return this.state = 'disconnected';
	    }
	  }, {
	    key: 'reconnect',
	    value: function reconnect() {
	      var _this = this;
	
	      var old_connection_id = this._conn && this._conn.connection_id;
	
	      this.disconnect();
	      this.connect();
	
	      (0, _keys2.default)(this.queue).forEach(function (key) {
	        var event = _this.queue[key];
	        if (event.connection_id === old_connection_id && !event.is_result()) {
	          _this.trigger_event(event);
	        }
	      });
	
	      return this.reconnect_channels();
	    }
	  }, {
	    key: 'new_message',
	    value: function new_message(data) {
	      var _this2 = this;
	
	      return data.map(function (message) {
	        var event = new _Event2.default(message);
	
	        if (event.is_result()) {
	          var queued = _this2.queue[event.id];
	          delete _this2.queue[event.id];
	          if (queued) {
	            queued.run_callbacks(event.success, event.data);
	          }
	        } else if (event.result === false && event.success === false && event.channel === undefined) {
	          var _queued = _this2.queue[event.id];
	          delete _this2.queue[event.id];
	          if (_queued) {
	            _queued.run_callbacks(event.success, event.data);
	          }
	        } else if (event.is_channel()) {
	          _this2.dispatch_channel(event);
	        } else if (event.is_ping()) {
	          _this2.pong();
	        } else {
	          _this2.dispatch(event);
	        }
	        if (_this2.state === 'connecting' && event.name === 'client_connected') {
	          return _this2.connection_established(event.data);
	        }
	      });
	    }
	  }, {
	    key: 'connection_established',
	    value: function connection_established(data) {
	      this.state = 'connected';
	      this._conn.setConnectionId(data.connection_id);
	      this._conn.flush_queue();
	      if (this.on_open) {
	        return this.on_open(data);
	      }
	    }
	  }, {
	    key: 'bind',
	    value: function bind(eventName, callback) {
	      if (!this.callbacks[eventName]) {
	        this.callbacks[eventName] = [];
	      }
	      return this.callbacks[eventName].push(callback);
	    }
	  }, {
	    key: 'unbind',
	    value: function unbind(event_name) {
	      return delete this.callbacks[event_name];
	    }
	  }, {
	    key: 'trigger',
	    value: function trigger(eventName, data, success, fail) {
	      var event = new _Event2.default([eventName, data, this._conn && this._conn.connection_id], success, fail);
	      return this.trigger_event(event);
	    }
	  }, {
	    key: 'trigger_event',
	    value: function trigger_event(event) {
	      var id = event.id;
	
	
	      if (!this.queue[id]) {
	        this.queue[id] = event;
	      }
	
	      if (this._conn) {
	        this._conn.trigger(event);
	      }
	      return event;
	    }
	  }, {
	    key: 'dispatch',
	    value: function dispatch(event) {
	      var name = event.name,
	          data = event.data;
	
	      if (this.callbacks[name]) {
	        return this.callbacks[name].map(function (callback) {
	          return callback(data);
	        });
	      }
	    }
	  }, {
	    key: 'subscribe',
	    value: function subscribe(channelName, success, fail) {
	      if (!this.channels[channelName]) {
	        this.channels[channelName] = new _Channel2.default(channelName, this, false, success, fail);
	      }
	
	      return this.channels[channelName];
	    }
	  }, {
	    key: 'subscribe_private',
	    value: function subscribe_private(channelName, success, fail) {
	      if (!this.channels[channelName]) {
	        this.channels[channelName] = new _Channel2.default(channelName, this, true, success, fail);
	      }
	      return this.channels[channelName];
	    }
	  }, {
	    key: 'unsubscribe',
	    value: function unsubscribe(channelName) {
	      if (this.channels[channelName]) {
	        this.channels[channelName].destroy();
	        return delete this.channels[channelName];
	      }
	    }
	  }, {
	    key: 'dispatch_channel',
	    value: function dispatch_channel(event) {
	      if (this.channels[event.channel]) {
	        return this.channels[event.channel].dispatch(event.name, event.data);
	      }
	    }
	  }, {
	    key: 'supports_websockets',
	    value: function supports_websockets() {
	      var _window = window,
	          WebSocket = _window.WebSocket;
	
	      return typeof WebSocket === 'function' || (typeof WebSocket === 'undefined' ? 'undefined' : (0, _typeof3.default)(WebSocket)) === 'object';
	    }
	  }, {
	    key: 'pong',
	    value: function pong() {
	      var pong = new _Event2.default(['websocket_rails.pong', {}, this._conn && this._conn.connection_id]);
	      return this._conn.trigger(pong);
	    }
	  }, {
	    key: 'connection_stale',
	    value: function connection_stale() {
	      return this.state !== 'connected';
	    }
	  }, {
	    key: 'reconnect_channels',
	    value: function reconnect_channels() {
	      var _this3 = this;
	
	      var channels = this.channels;
	
	
	      return (0, _keys2.default)(channels).map(function (key) {
	        var channel = channels[key];
	        var callbacks = channel._callbacks;
	        channel.destroy();
	        delete _this3.channels[key];
	
	        channel = channel.is_private ? _this3.subscribe_private(key) : _this3.subscribe(key);
	        channel._callbacks = callbacks;
	
	        return channel;
	      });
	    }
	  }]);
	  return WebSocketRails;
	}();
	
	exports.default = WebSocketRails;
	
	
	WebSocketRails.Event = _Event2.default;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SideNav = __webpack_require__(99);
	
	var _SideNav2 = _interopRequireDefault(_SideNav);
	
	var _Manager = __webpack_require__(421);
	
	var _Manager2 = _interopRequireDefault(_Manager);
	
	var _DocendoConnectionIndicator = __webpack_require__(1501);
	
	var _DocendoConnectionIndicator2 = _interopRequireDefault(_DocendoConnectionIndicator);
	
	var _appmanifest = __webpack_require__(2177);
	
	var _appmanifest2 = _interopRequireDefault(_appmanifest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DocendoConnnectionIndicator: _DocendoConnectionIndicator2.default, SideNav: _SideNav2.default, Toast: _Manager2.default
	  }
	};

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Setup = __webpack_require__(1455);
	
	var _Setup2 = _interopRequireDefault(_Setup);
	
	var _DirectDaySelector = __webpack_require__(152);
	
	var _DirectDaySelector2 = _interopRequireDefault(_DirectDaySelector);
	
	var _Hello = __webpack_require__(360);
	
	var _Hello2 = _interopRequireDefault(_Hello);
	
	var _VacationDaysSelector = __webpack_require__(153);
	
	var _VacationDaysSelector2 = _interopRequireDefault(_VacationDaysSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AulaSetup: _Setup2.default, DirectDaySelector: _DirectDaySelector2.default, Hello: _Hello2.default, VacationDaysSelector: _VacationDaysSelector2.default },
	  data: function data() {
	    return {
	      selected: 0,
	      components: [_Setup2.default, _DirectDaySelector2.default, _Hello2.default, _VacationDaysSelector2.default],
	      currentComponent: _Setup2.default
	    };
	  },
	  created: function created() {
	    this.select(this.selected);
	  },
	
	  methods: {
	    select: function select(index) {
	      this.currentComponent = this.components[index];
	    }
	  }
	};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _AssignHoursEmploymentEnded = __webpack_require__(133);
	
	var _AssignHoursEmploymentEnded2 = _interopRequireDefault(_AssignHoursEmploymentEnded);
	
	var _AbsenceReasonsTable = __webpack_require__(1437);
	
	var _AbsenceReasonsTable2 = _interopRequireDefault(_AbsenceReasonsTable);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _AbsenceReasonsCreate = __webpack_require__(332);
	
	var _AbsenceReasonsCreate2 = _interopRequireDefault(_AbsenceReasonsCreate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    absence_reasons: 'Fraværsårsager',
	    create_absence: 'Opret fraværsårsag',
	    title: 'Navn',
	    need_a_title: 'Mangler et navn',
	    no_absence_reasons_created: 'Ingen fraværsårsager oprettet',
	    hide_archived: 'Skjul arkiverede',
	    show_archived: 'Vis arkiverede',
	    hide_title: 'Skjul titel'
	  },
	  nb: {
	    absence_reasons: 'Fraværsårsaker',
	    create_absence: 'Opprett fraværsårsak',
	    title: 'Navn',
	    need_a_title: 'Mangler et navn',
	    no_absence_reasons_created: 'Ingen fraværsårsaker opprettet',
	    hide_archived: 'Skjul arkiverte',
	    show_archived: 'Vis arkiverte'
	  },
	  en: {
	    absence_reasons: 'Absence reasons',
	    create_absence: 'Create absence reason',
	    title: 'Name',
	    need_a_title: 'Missing a name',
	    no_absence_reasons_created: 'No absence reasons created',
	    hide_archived: 'Hide archived',
	    show_archived: 'Show archived'
	  }
	};
	exports.default = {
	  components: { AbsenceReasonsTable: _AbsenceReasonsTable2.default, AssignHoursEmploymentEnded: _AssignHoursEmploymentEnded2.default, DModal: _DModal2.default, Loader: _Loader2.default, AppToggle: _AppToggle2.default, AbsenceReasonsCreate: _AbsenceReasonsCreate2.default },
	  data: function data() {
	    return {
	      isLoading: false,
	      absenceReasons: [],
	      newReasonTitle: '',
	      isCreateAbsenceReason: false,
	      errors: {},
	      isCreating: false,
	      theUpdatingReasonId: null,
	      _keyListener: null,
	      isShowArchived: false,
	      absenceCodes: [],
	      sdAbsenceCodes: []
	    };
	  },
	
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        setTimeout(function (_) {
	          el.focus();
	        }, 150);
	      }
	    }
	  },
	  computed: {
	    salarySystem: function salarySystem() {
	      return this.$store.getters.salarySystem;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolFeatures: function schoolFeatures() {
	      return this.$store.getters.schoolFeatures;
	    },
	    isAbsenceRequestActivated: function isAbsenceRequestActivated() {
	      return this.schoolFeatures.indexOf('absence_requests') > -1;
	    },
	    isAbsenceIntegrationActive: function isAbsenceIntegrationActive() {
	      return this.isOpusAbsenceActivated || this.isSDIntegrationActive;
	    },
	    isOpusAbsenceActivated: function isOpusAbsenceActivated() {
	      return this.schoolFeatures && this.schoolFeatures.indexOf('kmd_absence') > -1;
	    },
	    isSDIntegrationActive: function isSDIntegrationActive() {
	      return this.schoolFeatures && this.schoolFeatures.indexOf('silkeborg_data_integration') > -1;
	    },
	    absenceReasonsSorted: function absenceReasonsSorted() {
	      return this.absenceReasons.slice().sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    absenceReasonsArchived: function absenceReasonsArchived() {
	      return this.absenceReasonsSorted.filter(function (reason) {
	        return reason.archived;
	      });
	    },
	    absenceReasonsActive: function absenceReasonsActive() {
	      return this.absenceReasonsSorted.filter(function (reason) {
	        return !reason.archived;
	      });
	    }
	  },
	  watch: {
	    schoolId: function schoolId() {
	      this.readAbsenceReasons();
	      this.readAbsenceCodes();
	    },
	    salarySystem: function salarySystem() {
	      this.readAbsenceCodes();
	    }
	  },
	  methods: {
	    handleCreateReason: function handleCreateReason(titleAndDefaultPrivate) {
	      var _this = this;
	
	      var title = titleAndDefaultPrivate.title;
	      var defaultPrivate = titleAndDefaultPrivate.defaultPrivate !== undefined ? titleAndDefaultPrivate.defaultPrivate : true;
	      var defaultOngoing = titleAndDefaultPrivate.defaultOngoing !== undefined ? titleAndDefaultPrivate.defaultOngoing : false;
	      var canRequest = titleAndDefaultPrivate.canRequest !== undefined ? titleAndDefaultPrivate.canRequest : true;
	      this.isCreating = true;
	      var plannedAbsence = false;
	      var kmdAbsenceCodeId = this.salarySystem === 'SD' ? null : titleAndDefaultPrivate.kmdAbsenceCodeId || null;
	      var sdAbsenceCodeId = this.salarySystem === 'SD' ? titleAndDefaultPrivate.sdAbsenceCodeId || null : null;
	      _docendo2.default.schoolAbsenceSubjectsCreate(this.schoolId, title, '#564437', defaultPrivate, defaultOngoing, plannedAbsence, kmdAbsenceCodeId, sdAbsenceCodeId, canRequest, function (success) {
	        _this.absenceReasons.push(success);
	        _this.setIsCreateAbsenceReason(false);
	      }, function (failure) {
	        console.log('error', failure);
	      });
	    },
	    updateAbsenceReasonWithDefaults: function updateAbsenceReasonWithDefaults(reason, updates, errorMessage, trackEvent) {
	      var _this2 = this;
	
	      var plannedAbsence = reason.planned_absence || false;
	      var kmdAbsenceCodeId = updates.kmdAbsenceCodeId !== undefined ? updates.kmdAbsenceCodeId : reason.kmd_absence_code_id || null;
	      var sdAbsenceCodeId = updates.sdAbsenceCodeId !== undefined ? updates.sdAbsenceCodeId : reason.sd_absence_code_id || null;
	      var defaultPrivate = updates.defaultPrivate !== undefined ? updates.defaultPrivate : reason.default_private;
	      var defaultOngoing = updates.defaultOngoing !== undefined ? updates.defaultOngoing : reason.default_ongoing;
	      var canRequest = updates.canRequest !== undefined ? updates.canRequest : reason.can_request;
	
	      this.$nextTick(function (_) {
	        _docendo2.default.schoolAbsenceSubjectsUpdate(reason.id, reason.school_id, reason.name, reason.color, defaultPrivate, defaultOngoing, plannedAbsence, kmdAbsenceCodeId, sdAbsenceCodeId, canRequest, function (success) {
	          if (success.status === 'error') {
	            _eventbus2.default.toast = { text: success.message, 'success': false };
	            return;
	          }
	          _this2.updateAbsenceReason(success);
	          if (trackEvent) {
	            _this2.$store.dispatch('trackEvent', trackEvent);
	          }
	        }, function (failure) {
	          console.log({ failure: failure });
	          if (errorMessage) {
	            _eventbus2.default.toast = { text: errorMessage, 'success': false };
	          }
	        });
	      });
	    },
	    editAbsencePrivate: function editAbsencePrivate(reason) {
	      this.updateAbsenceReasonWithDefaults(reason, {
	        defaultPrivate: !reason.default_private
	      });
	    },
	    editAbsenceCanRequest: function editAbsenceCanRequest(reason) {
	      this.updateAbsenceReasonWithDefaults(reason, {
	        canRequest: !reason.can_request
	      }, null, 'absenceReasons_settings_canRequest');
	    },
	    editAbsenceOngoing: function editAbsenceOngoing(reason) {
	      this.updateAbsenceReasonWithDefaults(reason, {
	        defaultOngoing: !reason.default_ongoing
	      }, null, 'absenceReasons_settings_defaultOngoing');
	    },
	    editAbsenceCode: function editAbsenceCode(reason, absenceCode, setDefaultOngoing, isSD) {
	      var absenceCodeValue = absenceCode && absenceCode.trim() !== '' ? absenceCode.trim() : null;
	      var codeId = absenceCodeValue ? parseInt(absenceCodeValue, 10) : null;
	
	      var updates = {};
	
	      if (isSD) {
	        updates.sdAbsenceCodeId = codeId;
	      } else {
	        updates.kmdAbsenceCodeId = codeId;
	
	        var selectedCode = codeId ? this.absenceCodes.find(function (c) {
	          return c.id === codeId;
	        }) : null;
	        var shouldDisableDefaultOngoing = selectedCode && this.isAbsenceIntegrationActive && selectedCode.allow_open === false;
	        var shouldEnableDefaultOngoing = selectedCode && this.isAbsenceIntegrationActive && selectedCode.allow_open === true;
	
	        if (shouldDisableDefaultOngoing || setDefaultOngoing === false) {
	          updates.defaultOngoing = false;
	        } else if (shouldEnableDefaultOngoing || setDefaultOngoing === true) {
	          updates.defaultOngoing = true;
	        }
	      }
	
	      this.updateAbsenceReasonWithDefaults(reason, updates, 'Kunne ikke opdatere fraværskode');
	    },
	    updateAbsenceReason: function updateAbsenceReason(updatedReason) {
	      var idx = this.absenceReasons.findIndex(function (r) {
	        return r.id === updatedReason.id;
	      });
	      if (idx !== -1) {
	        this.$set(this.absenceReasons, idx, updatedReason);
	      }
	      this.theUpdatingReasonId = null;
	    },
	    toggleArchived: function toggleArchived(reason) {
	      var _this3 = this;
	
	      var isArchived = reason.archived;
	      this.theUpdatingReasonId = reason.id;
	      if (!isArchived) {
	        _docendo2.default.schoolAbsenceSubjectsArchive(reason.school_id, reason.id, function (success) {
	          if (success.status === 'error') {
	            _eventbus2.default.toast = { text: success.message, 'success': false };
	            return;
	          }
	          _this3.updateAbsenceReason(success);
	        }, function (failure) {
	          console.log('failed!');
	        });
	      } else {
	        _docendo2.default.schoolAbsenceSubjectsUnarchive(reason.school_id, reason.id, function (success) {
	          _this3.updateAbsenceReason(success);
	        }, function (failure) {
	          console.log('failed!');
	        });
	      }
	    },
	    setIsCreateAbsenceReason: function setIsCreateAbsenceReason(bool) {
	      this.isCreateAbsenceReason = bool;
	      if (!bool) {
	        this.newReasonTitle = '';
	        this.errors = {};
	        this.isCreating = false;
	      }
	    },
	    readAbsenceReasons: function readAbsenceReasons() {
	      var _this4 = this;
	
	      if (!this.schoolId) {
	        return;
	      }
	      this.isLoading = true;
	      _docendo2.default.schoolAbsenceSubjectsList(this.schoolId, true, function (success) {
	        _this4.absenceReasons = success;
	        _this4.isLoading = false;
	      }, function (failure) {
	        _this4.isLoading = false;
	      });
	    },
	    readAbsenceCodes: function readAbsenceCodes() {
	      var _this5 = this;
	
	      if (!this.isAbsenceIntegrationActive || !this.schoolId) {
	        return;
	      }
	      if (this.salarySystem === 'SD') {
	        _docendo2.default.listSilkeborgDataAbsenceCodes(this.schoolId, function (success) {
	          _this5.sdAbsenceCodes = Array.isArray(success) ? success : [];
	        }, function (failure) {
	          _this5.sdAbsenceCodes = [];
	        });
	      } else {
	        this.listKmdOpusAbsenceCodes();
	      }
	    },
	    listKmdOpusAbsenceCodes: function listKmdOpusAbsenceCodes() {
	      var _this6 = this;
	
	      _docendo2.default.listKmdOpusAbsenceCodes(this.schoolId, function (success) {
	        _this6.absenceCodes = Array.isArray(success) ? success : [];
	      }, function (failure) {
	        _this6.absenceCodes = [];
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this7 = this;
	
	    this.readAbsenceReasons();
	    this.readAbsenceCodes();
	    this._keyListener = function (e) {
	      if (e.key === 'n' && e.target.tagName.toUpperCase() === 'BODY') {
	        _this7.setIsCreateAbsenceReason(true);
	      }
	    };
	
	    document.addEventListener('keydown', this._keyListener);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this._keyListener);
	  }
	};

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    absence_reasons: 'Fraværsårsager',
	    create_absence: 'Opret fraværsårsag',
	    need_a_title: 'Mangler et navn',
	    title: 'Titel på fraværsårsag',
	    hide_title: 'Skjul fraværstitel',
	    archive: 'Arkivér',
	    dearchive: 'Genskab',
	    no_absence_reasons_created: 'Ingen fraværsårsager oprettet',
	    tooltip_for_hide_title: 'Når "Skjul titel" er aktiveret, er fraværstitlen kun synlig for administratorer og brugeren med fraværet – for andre vises blot "Fravær". Hvis indstillingen deaktiveres, er titlen synlig for alle, også i Aula.',
	    default_private_explained: 'Hvis "Skjul fraværstitel" er slået til, vil administratorer – samt brugeren med fraværet – se fraværets titel,<br>mens andre brugere blot ser "Fravær" som titel på fraværet.',
	    default_ongoing: 'Automatisk løbende fravær',
	    default_ongoing_explained: 'Aktivér for automatisk at markere fraværet som løbende, når denne årsag vælges ved oprettelse af fravær',
	    can_be_requested: 'Kan anmodes',
	    can_be_requested_explained: 'Medarbejdere kan vælge denne årsag, når de anmoder om fravær'
	  },
	  nb: {
	    absence_reasons: 'Fraværsårsaker',
	    create_absence: 'Opprett fraværsårsak',
	    hide_title: 'Skjul tittel',
	    archive: 'Arkiver',
	    dearchive: 'Gjenopprett',
	    title: 'Tittel',
	    need_a_title: 'Mangler et navn',
	    no_absence_reasons_created: 'Ingen fraværsårsaker opprettet',
	    tooltip_for_hide_title: 'Når "Skjul tittel" er aktivert, er fraværstittelen kun synlig for administratorer og brukeren fraværet gjelder – for andre vises bare "Fravær". Hvis innstillingen deaktiveres, blir tittelen synlig for alle.',
	    default_private_explained: 'Hvis "Skjul fraværstittel" er aktivert, vil administratorer – samt brukeren med fraværet – se fraværets tittel,<br>mens andre brukere kun ser "Fravær" som tittel på fraværet.',
	    default_ongoing: 'Løpende fravær',
	    default_ongoing_explained: 'Aktiver for automatisk å merke fraværet som løpende når denne årsaken velges ved registrering av fravær',
	    can_be_requested: 'Kan forespørres',
	    can_be_requested_explained: 'Ansatte kan velge denne årsaken når de ber om fravær'
	  },
	  en: {
	    absence_reasons: 'Absence reasons',
	    create_absence: 'Create absence reason',
	    hide_title: 'Hide title',
	    archive: 'Archive',
	    dearchive: 'Restore',
	    title: 'Title',
	    need_a_title: 'Missing a name',
	    no_absence_reasons_created: 'No absence reasons created',
	    tooltip_for_hide_title: 'When "Hide title" is enabled, the absence title is only visible to administrators and the user the absence relates to – others will simply see "Absence". If the setting is disabled, the title becomes visible to everyone.',
	    default_private_explained: 'If "Hide absence title" is enabled, administrators – as well as the user with the absence – will see the absence title,<br>while other users will simply see "Absence" as the title.',
	    default_ongoing: 'Ongoing absence',
	    default_ongoing_explained: 'Enable to automatically mark the absence as ongoing when this reason is selected when creating an absence',
	    can_be_requested: 'Can be requested',
	    can_be_requested_explained: 'Employees can select this reason when requesting absence'
	  }
	};
	exports.default = {
	  components: { DModal: _DModal2.default, AppToggle: _AppToggle2.default, DSelect: _DSelect2.default },
	  props: {
	    initTitle: {
	      type: String,
	      default: ''
	    },
	    absenceCodes: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    sdAbsenceCodes: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isAbsenceIntegrationActive: {
	      type: Boolean,
	      default: false
	    },
	    salarySystem: {
	      type: String,
	      default: 'SD'
	    }
	  },
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        setTimeout(function () {
	          el.focus();
	        }, 150);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      newReasonTitle: '',
	      errors: {},
	      isCreating: false,
	      defaultPrivate: true,
	      defaultOngoing: false,
	      canRequest: true,
	      selectedAbsenceCodeId: null,
	      selectedSdAbsenceCodeId: null,
	      resetDSelectCounter: 0
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    isSalarySystemSD: function isSalarySystemSD() {
	      return this.salarySystem === 'SD';
	    },
	    isSalarySystemKMD: function isSalarySystemKMD() {
	      return this.salarySystem !== 'SD';
	    },
	    absenceCodesForDSelect: function absenceCodesForDSelect() {
	      if (!this.absenceCodes || !Array.isArray(this.absenceCodes)) {
	        return [];
	      }
	      return this.absenceCodes.map(function (code) {
	        var absenceType = code.absence_type || '';
	        var absenceTypeText = code.absence_type_text || '';
	        return {
	          id: code.id || '',
	          name: absenceType + (absenceTypeText ? ' - ' + absenceTypeText : ''),
	          value: code.id,
	          original: code
	        };
	      });
	    },
	    selectedAbsenceCodeForDSelect: function selectedAbsenceCodeForDSelect() {
	      var _this = this;
	
	      if (!this.selectedAbsenceCodeId) {
	        return [];
	      }
	      var found = this.absenceCodesForDSelect.find(function (item) {
	        return item.value === _this.selectedAbsenceCodeId;
	      });
	      return found ? [found] : [];
	    },
	    sdAbsenceCodesForDSelect: function sdAbsenceCodesForDSelect() {
	      if (!this.sdAbsenceCodes || !Array.isArray(this.sdAbsenceCodes)) {
	        return [];
	      }
	      return this.sdAbsenceCodes.map(function (code) {
	        var loenart = code.loenart ? String(code.loenart) : '';
	        var title = code.title || '';
	        return {
	          id: code.id || '',
	          name: (loenart ? loenart + ' - ' : '') + title,
	          value: code.id,
	          original: code
	        };
	      });
	    },
	    selectedSdAbsenceCodeForDSelect: function selectedSdAbsenceCodeForDSelect() {
	      var _this2 = this;
	
	      if (!this.selectedSdAbsenceCodeId) {
	        return [];
	      }
	      var found = this.sdAbsenceCodesForDSelect.find(function (item) {
	        return item.value === _this2.selectedSdAbsenceCodeId;
	      });
	      return found ? [found] : [];
	    },
	    shouldShowDefaultOngoing: function shouldShowDefaultOngoing() {
	      var _this3 = this;
	
	      if (!this.isAbsenceIntegrationActive) {
	        return true;
	      }
	
	      if (this.isSalarySystemSD) {
	        return true;
	      }
	
	      if (!this.selectedAbsenceCodeId) {
	        return true;
	      }
	
	      var selectedCode = this.absenceCodesForDSelect.find(function (item) {
	        return item.value === _this3.selectedAbsenceCodeId;
	      });
	      if (selectedCode && selectedCode.original) {
	        return selectedCode.original.allow_open === true;
	      }
	
	      return true;
	    }
	  },
	  methods: {
	    onCancel: function onCancel() {
	      this.$emit('cancel');
	      this.reset();
	    },
	    onCreate: function onCreate() {
	      if (this.newReasonTitle.length < 1) {
	        this.$set(this.errors, 'newReasonTitle', this.i18n.need_a_title);
	        return;
	      }
	      var titleAndDefaultPrivate = {
	        title: this.newReasonTitle,
	        defaultPrivate: this.defaultPrivate,
	        defaultOngoing: this.defaultOngoing,
	        canRequest: this.canRequest,
	        kmdAbsenceCodeId: this.isSalarySystemKMD ? this.selectedAbsenceCodeId : null,
	        sdAbsenceCodeId: this.isSalarySystemSD ? this.selectedSdAbsenceCodeId : null
	      };
	      this.isCreating = true;
	      this.$emit('create', titleAndDefaultPrivate);
	    },
	    clearErrors: function clearErrors() {
	      this.errors = {};
	    },
	    onSelectAbsenceCode: function onSelectAbsenceCode(item) {
	      if (!item) {
	        this.selectedAbsenceCodeId = null;
	        this.newReasonTitle = '';
	
	        this.defaultOngoing = false;
	      } else {
	        this.selectedAbsenceCodeId = item.value;
	
	        if (item.original && item.original.absence_type_text) {
	          this.newReasonTitle = item.original.absence_type_text;
	        } else if (item.name) {
	          var parts = item.name.split(' - ');
	          this.newReasonTitle = parts.length > 1 ? parts[1] : parts[0];
	        }
	
	        if (this.isAbsenceIntegrationActive && item.original && item.original.allow_open === true) {
	          this.defaultOngoing = true;
	        } else if (this.isAbsenceIntegrationActive && item.original && item.original.allow_open === false) {
	          this.defaultOngoing = false;
	        }
	      }
	    },
	    onSelectSdAbsenceCode: function onSelectSdAbsenceCode(item) {
	      if (!item) {
	        this.selectedSdAbsenceCodeId = null;
	        this.newReasonTitle = '';
	      } else {
	        this.selectedSdAbsenceCodeId = item.value;
	
	        if (item.original && item.original.title) {
	          this.newReasonTitle = item.original.title;
	        } else if (item.name) {
	          var parts = item.name.split(' - ');
	          this.newReasonTitle = parts.length > 1 ? parts[1] : parts[0];
	        }
	      }
	    },
	    reset: function reset() {
	      this.newReasonTitle = '';
	      this.errors = {};
	      this.isCreating = false;
	      this.defaultPrivate = true;
	      this.defaultOngoing = false;
	      this.canRequest = true;
	      this.selectedAbsenceCodeId = null;
	      this.selectedSdAbsenceCodeId = null;
	      this.resetDSelectCounter = this.resetDSelectCounter + 1;
	    }
	  },
	  mounted: function mounted() {
	    if (this.initTitle) {
	      this.newReasonTitle = this.initTitle;
	    }
	  }
	};

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    absence_reasons: 'Fraværsårsager',
	    create_absence: 'Opret fraværsårsag',
	    need_a_title: 'Mangler et navn',
	    title: 'Navn',
	    hide_title: 'Skjul titel',
	    archive: 'Arkivér',
	    dearchive: 'Genskab',
	    no_absence_reasons_created: 'Ingen fraværsårsager oprettet',
	    tooltip_for_hide_title: 'Når "Skjul titel" er aktiveret, er fraværstitlen kun synlig for administratorer og brugeren med fraværet – for andre vises blot "Fravær". Hvis indstillingen deaktiveres, er titlen synlig for alle, også i Aula.',
	    can_be_requested: 'Kan anmodes',
	    tooltip_for_can_be_requested: 'Medarbejdere kan vælge denne årsag, når de anmoder om fravær',
	    default_ongoing: 'Løbende fravær',
	    tooltip_for_default_ongoing: 'Aktivér for automatisk at markere fraværet som løbende, når denne årsag vælges ved oprettelse af fravær'
	  },
	  nb: {
	    absence_reasons: 'Fraværsårsaker',
	    create_absence: 'Opprett fraværsårsak',
	    hide_title: 'Skjul tittel',
	    archive: 'Arkiver',
	    dearchive: 'Gjenopprett',
	    title: 'Navn',
	    need_a_title: 'Mangler et navn',
	    no_absence_reasons_created: 'Ingen fraværsårsaker opprettet',
	    tooltip_for_hide_title: 'Når "Skjul tittel" er aktivert, er fraværstittelen kun synlig for administratorer og brukeren fraværet gjelder – for andre vises bare "Fravær". Hvis innstillingen deaktiveres, blir tittelen synlig for alle.',
	    can_be_requested: 'Kan forespørres',
	    tooltip_for_can_be_requested: 'Ansatte kan velge denne årsaken når de ber om fravær',
	    default_ongoing: 'Løpende fravær',
	    tooltip_for_default_ongoing: 'Aktiver for automatisk å merke fraværet som løpende når denne årsaken velges ved registrering av fravær'
	  },
	  en: {
	    absence_reasons: 'Absence reasons',
	    create_absence: 'Create absence reason',
	    hide_title: 'Hide title',
	    archive: 'Archive',
	    dearchive: 'Restore',
	    title: 'Name',
	    need_a_title: 'Missing a name',
	    no_absence_reasons_created: 'No absence reasons created',
	    tooltip_for_hide_title: 'When "Hide title" is enabled, the absence title is only visible to administrators and the user the absence relates to – others will simply see "Absence". If the setting is disabled, the title becomes visible to everyone.',
	    can_be_requested: 'Can be requested',
	    tooltip_for_can_be_requested: 'Employees can select this reason when requesting absence',
	    default_ongoing: 'Ongoing absence',
	    tooltip_for_default_ongoing: 'Enable to automatically mark the absence as ongoing when this reason is selected when creating an absence'
	  }
	};
	exports.default = {
	  components: { AppToggle: _AppToggle2.default },
	  data: function data() {
	    return {
	      editingAbsenceCodeId: null
	    };
	  },
	
	  props: {
	    items: {
	      default: []
	    },
	    theUpdatingReasonId: {
	      default: null
	    },
	    isAbsenceRequestActivated: {
	      default: false
	    },
	    isAbsenceIntegrationActive: {
	      type: Boolean,
	      default: false
	    },
	    absenceCodes: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    sdAbsenceCodes: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    salarySystem: {
	      type: String,
	      default: 'SD'
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    tooltipForHideTitle: function tooltipForHideTitle() {
	      return this.i18n['tooltip_for_hide_title'];
	    },
	    tooltipForCanBeRequested: function tooltipForCanBeRequested() {
	      return this.i18n['tooltip_for_can_be_requested'];
	    },
	    tooltipForDefaultOngoing: function tooltipForDefaultOngoing() {
	      return this.i18n['tooltip_for_default_ongoing'];
	    },
	    isSalarySystemSD: function isSalarySystemSD() {
	      return this.salarySystem === 'SD';
	    },
	    isSalarySystemKMD: function isSalarySystemKMD() {
	      return this.salarySystem !== 'SD';
	    }
	  },
	  methods: {
	    getAbsenceCodeName: function getAbsenceCodeName(codeId, isSD) {
	      if (!codeId) {
	        return '';
	      }
	      if (isSD) {
	        if (!this.sdAbsenceCodes || !Array.isArray(this.sdAbsenceCodes)) {
	          return '';
	        }
	        var code = this.sdAbsenceCodes.find(function (c) {
	          return String(c.id) === String(codeId);
	        });
	        if (!code) {
	          return '';
	        }
	        return (code.loenart ? code.loenart + ' - ' : '') + (code.title || '');
	      } else {
	        if (!this.absenceCodes || !Array.isArray(this.absenceCodes)) {
	          return '';
	        }
	        var _code = this.absenceCodes.find(function (c) {
	          return String(c.id) === String(codeId);
	        });
	        if (!_code) {
	          return '';
	        }
	        return _code.absence_type + (_code.absence_type_text ? ' - ' + _code.absence_type_text : '');
	      }
	    },
	    setEditingAbsenceCode: function setEditingAbsenceCode(reasonId) {
	      var _this = this;
	
	      this.editingAbsenceCodeId = reasonId;
	      this.$nextTick(function () {
	        var selectElement = _this.$el.querySelector('select[data-reason-id="' + reasonId + '"]');
	        if (selectElement) {
	          selectElement.focus();
	        }
	      });
	    },
	    onAbsenceCodeChange: function onAbsenceCodeChange(reason, value, isSD) {
	      if (isSD) {
	        this.$emit('editAbsenceCode', reason, value, null, true);
	      } else {
	        var selectedCode = value ? this.absenceCodes.find(function (c) {
	          return c.id === parseInt(value, 10);
	        }) : null;
	        var shouldDisableDefaultOngoing = selectedCode && this.isAbsenceIntegrationActive && selectedCode.allow_open === false;
	        var shouldEnableDefaultOngoing = selectedCode && this.isAbsenceIntegrationActive && selectedCode.allow_open === true;
	
	        if (shouldDisableDefaultOngoing && reason.default_ongoing) {
	          this.$emit('editAbsenceCode', reason, value, false, false);
	        } else if (shouldEnableDefaultOngoing && !reason.default_ongoing) {
	          this.$emit('editAbsenceCode', reason, value, true, false);
	        } else {
	          this.$emit('editAbsenceCode', reason, value, null, false);
	        }
	      }
	      this.editingAbsenceCodeId = null;
	    },
	    isDefaultOngoingDisabled: function isDefaultOngoingDisabled(reason) {
	      if (!this.isAbsenceIntegrationActive) {
	        return false;
	      }
	      if (this.isSalarySystemSD) {
	        return false;
	      }
	      if (!reason.kmd_absence_code_id) {
	        return false;
	      }
	      var code = this.absenceCodes.find(function (c) {
	        return c.id === reason.kmd_absence_code_id;
	      });
	      return code && code.allow_open === false;
	    },
	    onToggleDefaultPrivate: function onToggleDefaultPrivate(reason) {
	      this.$emit('editAbsencePrivate', reason);
	    },
	    onToggleDefaultOngoing: function onToggleDefaultOngoing(reason) {
	      if (!this.isDefaultOngoingDisabled(reason)) {
	        this.$emit('editAbsenceOngoing', reason);
	      }
	    },
	    onToggleCanRequest: function onToggleCanRequest(reason) {
	      this.$emit('editAbsenceCanRequest', reason);
	    }
	  }
	};

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VIMEO_USER_ID = '165243599';
	var VIMEO_TOKEN = '81c5429f7c98d1aed4901a829c791710';
	var ACADEMY_TABS = [{ id: '11997053', label: 'Introkursus' }, { id: '12164971', label: 'Vikardækning' }, { id: '12259500', label: 'Skemalægning' }, { id: '12164973', label: 'For medarbejdere' }, { id: '12286610', label: 'Drift af skemaer' }];
	
	exports.default = {
	  name: 'Academy',
	  data: function data() {
	    return {
	      videos: [],
	      activeVideo: null,
	      isLoading: false,
	      shouldAutoplay: false,
	      videoProgress: {},
	      activeShowcaseId: ACADEMY_TABS[0].id
	    };
	  },
	
	  computed: {
	    academyTabs: function academyTabs() {
	      return ACADEMY_TABS;
	    },
	    schoolName: function schoolName() {
	      return window.SCHOOL ? window.SCHOOL.name : '';
	    },
	    activeVideoSrc: function activeVideoSrc() {
	      if (!this.activeVideo) return '';
	      var url = this.activeVideo.player_embed_url || '';
	      if (this.shouldAutoplay && url) {
	        var separator = url.indexOf('?') > -1 ? '&' : '?';
	        url = url + separator + 'autoplay=1';
	      }
	      return url;
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUser');
	  },
	
	  watch: {
	    '$store.state.isUserLoaded': function $storeStateIsUserLoaded(loaded) {
	      if (loaded) {
	        var schoolId = this.$route.params.school_id;
	        _docendo2.default.trackEvent(schoolId, 'academy_page_view');
	      }
	    },
	    activeVideoSrc: function activeVideoSrc() {
	      var self = this;
	      self.$nextTick(function () {
	        self.initVimeoPlayer();
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.loadProgress();
	    this.loadVimeoSDK();
	    this.fetchVideos();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (typeof this.saveProgress === 'function') {
	      this.saveProgress();
	    }
	    if (this._vimeoPlayer) {
	      this._vimeoPlayer.off('timeupdate');
	      this._vimeoPlayer = null;
	    }
	  },
	
	  methods: {
	    fetchVideos: function fetchVideos() {
	      var self = this;
	      var activeTab = null;
	      for (var i = 0; i < ACADEMY_TABS.length; i++) {
	        if (ACADEMY_TABS[i].id === self.activeShowcaseId) {
	          activeTab = ACADEMY_TABS[i];
	          break;
	        }
	      }
	
	      if (activeTab && activeTab.videoId) {
	        self.isLoading = true;
	        var videoUrl = 'https://api.vimeo.com/videos/' + activeTab.videoId + '?fields=uri,name,description,description_html,duration,player_embed_url';
	        window.fetch(videoUrl, {
	          headers: {
	            Authorization: 'Bearer ' + VIMEO_TOKEN
	          }
	        }).then(function (res) {
	          return res.json();
	        }).then(function (json) {
	          if (json && json.uri) {
	            if (activeTab.videoHash && json.player_embed_url && json.player_embed_url.indexOf('h=') === -1) {
	              var sep = json.player_embed_url.indexOf('?') > -1 ? '&' : '?';
	              json.player_embed_url = json.player_embed_url + sep + 'h=' + activeTab.videoHash;
	            }
	            self.videos = [json];
	            self.activeVideo = json;
	          } else {
	            self.videos = [{
	              uri: '/videos/' + activeTab.videoId,
	              name: activeTab.label,
	              duration: 0,
	              description_html: '',
	              player_embed_url: 'https://player.vimeo.com/video/' + activeTab.videoId + (activeTab.videoHash ? '?h=' + activeTab.videoHash : '')
	            }];
	            self.activeVideo = self.videos[0];
	          }
	          self.isLoading = false;
	        }).catch(function () {
	          self.videos = [{
	            uri: '/videos/' + activeTab.videoId,
	            name: activeTab.label,
	            duration: 0,
	            description_html: '',
	            player_embed_url: 'https://player.vimeo.com/video/' + activeTab.videoId + (activeTab.videoHash ? '?h=' + activeTab.videoHash : '')
	          }];
	          self.activeVideo = self.videos[0];
	          self.isLoading = false;
	        });
	        return;
	      }
	
	      var url = 'https://api.vimeo.com/users/' + VIMEO_USER_ID + '/albums/' + self.activeShowcaseId + '/videos?fields=uri,name,description,description_html,duration,player_embed_url&sort=manual&per_page=100';
	      self.isLoading = true;
	      window.fetch(url, {
	        headers: {
	          Authorization: 'Bearer ' + VIMEO_TOKEN
	        }
	      }).then(function (res) {
	        return res.json();
	      }).then(function (json) {
	        self.videos = json.data || [];
	        if (self.videos.length) {
	          self.activeVideo = self.videos[0];
	        }
	        self.isLoading = false;
	      }).catch(function () {
	        self.videos = [];
	        self.isLoading = false;
	      });
	    },
	    switchShowcase: function switchShowcase(showcaseId) {
	      if (!showcaseId) return;
	      if (this.activeShowcaseId === showcaseId) return;
	      this.activeShowcaseId = showcaseId;
	      this.shouldAutoplay = false;
	      this.fetchVideos();
	    },
	    selectVideo: function selectVideo(video) {
	      this.shouldAutoplay = true;
	      this.activeVideo = video;
	    },
	    formatDuration: function formatDuration(seconds) {
	      if (!seconds && seconds !== 0) return '';
	      var m = Math.floor(seconds / 60);
	      var s = String(seconds % 60).padStart(2, '0');
	      return (m < 10 ? '0' : '') + m + ':' + s;
	    },
	    getProgress: function getProgress(video) {
	      return this.videoProgress[video.uri] || 0;
	    },
	    loadProgress: function loadProgress() {
	      try {
	        var stored = window.localStorage.getItem('academy_video_progress');
	        if (stored) {
	          this.videoProgress = JSON.parse(stored);
	        }
	      } catch (e) {}
	    },
	    saveProgress: function saveProgress() {
	      try {
	        window.localStorage.setItem('academy_video_progress', (0, _stringify2.default)(this.videoProgress));
	      } catch (e) {}
	    },
	    loadVimeoSDK: function loadVimeoSDK() {
	      if (window.Vimeo) return;
	      var self = this;
	      var script = document.createElement('script');
	      script.src = 'https://player.vimeo.com/api/player.js';
	      script.onload = function () {
	        if (self.activeVideo) {
	          self.$nextTick(function () {
	            self.initVimeoPlayer();
	          });
	        }
	      };
	      document.head.appendChild(script);
	    },
	    initVimeoPlayer: function initVimeoPlayer() {
	      var self = this;
	      if (self._vimeoPlayer) {
	        self._vimeoPlayer.off('timeupdate');
	        self._vimeoPlayer = null;
	      }
	      if (!window.Vimeo || !self.$refs.vimeoPlayer) return;
	      var player = new window.Vimeo.Player(self.$refs.vimeoPlayer);
	      self._vimeoPlayer = player;
	      player.on('timeupdate', function (data) {
	        if (!self.activeVideo) return;
	        var pct = Math.round(data.percent * 100);
	        var current = self.videoProgress[self.activeVideo.uri] || 0;
	        if (pct > current) {
	          self.$set(self.videoProgress, self.activeVideo.uri, pct);
	        }
	        var now = Date.now();
	        if (!self._lastProgressSave || now - self._lastProgressSave > 3000) {
	          self._lastProgressSave = now;
	          self.saveProgress();
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _AnnualNormWithoutKids = __webpack_require__(333);
	
	var _AnnualNormWithoutKids2 = _interopRequireDefault(_AnnualNormWithoutKids);
	
	var _AnnualNormWithKids = __webpack_require__(1441);
	
	var _AnnualNormWithKids2 = _interopRequireDefault(_AnnualNormWithKids);
	
	var _AssignHoursNorm = __webpack_require__(337);
	
	var _AssignHoursNorm2 = _interopRequireDefault(_AssignHoursNorm);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _AnnualNormResult = __webpack_require__(1440);
	
	var _AnnualNormResult2 = _interopRequireDefault(_AnnualNormResult);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _AssignHoursEmploymentEnded = __webpack_require__(133);
	
	var _AssignHoursEmploymentEnded2 = _interopRequireDefault(_AssignHoursEmploymentEnded);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DModal: _DModal2.default, AssignHoursEmploymentEnded: _AssignHoursEmploymentEnded2.default,
	    AnnualNormResult: _AnnualNormResult2.default,
	    ModalConfirmation: _ModalConfirmation2.default, AssignHoursNorm: _AssignHoursNorm2.default, AnnualNormWithKids: _AnnualNormWithKids2.default, Loader: _Loader2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, AnnualNormWithoutKids: _AnnualNormWithoutKids2.default
	  },
	  data: function data() {
	    return {
	      isShowEmploymentEnded: false,
	      viewIsResult: false,
	      isTasksView: true,
	      activeUserId: null,
	      allVacationsDays: [],
	      isUpdatingTasks: false,
	      activeNorm: null
	    };
	  },
	
	  computed: {
	    activeNormFormatted: function activeNormFormatted() {
	      return this.activeNorm.filter(function (item) {
	        return !item.title.startsWith('hidden_');
	      }).map(function (item) {
	        return (0, _extends3.default)({}, item, {
	          value: item.title === 'Periode start' || item.title === 'Periode slut' ? (0, _moment2.default)(item.value).format('ll') : item.value
	        });
	      });
	    },
	    isConfirmDeletion: function isConfirmDeletion() {
	      return this.$store.state.subjects.isConfirmDeletion;
	    },
	    itemToDelete: function itemToDelete() {
	      return this.$store.state.subjects.itemToDelete;
	    },
	    schoolId: function schoolId() {
	      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : window.SCHOOL.id;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.subjects.isLoading;
	    },
	    tasks: function tasks() {
	      return this.$store.state.subjects.tasks;
	    },
	    filteredTasks: function filteredTasks() {
	      return this.tasks.filter(function (task) {
	        return task.subject_type === 'without_kids';
	      });
	    },
	    tasksWithKids: function tasksWithKids() {
	      return this.tasks.filter(function (task) {
	        return task.subject_type === 'with_kids';
	      });
	    },
	    sortedTasks: function sortedTasks() {
	      return this.filteredTasks.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    sortedTasksWithKids: function sortedTasksWithKids() {
	      return this.tasksWithKids.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    tasksInHash: function tasksInHash() {
	      return this.filteredTasks.reduce(function (obj, item) {
	        obj[item.id] = item;
	        return obj;
	      }, {});
	    },
	    tasksWithKidsInHash: function tasksWithKidsInHash() {
	      return this.tasksWithKids.reduce(function (obj, item) {
	        obj[item.id] = item;
	        return obj;
	      }, {});
	    },
	    tasksInUserHash: function tasksInUserHash() {
	      var calIdsWithTasksIds = {};
	      this.sortedTasks.forEach(function (task) {
	        if (task.user_calendar_ids) {
	          task.user_calendar_ids.forEach(function (calid) {
	            if (calid) {
	              if (!calIdsWithTasksIds[calid]) {
	                calIdsWithTasksIds[calid] = [task.id];
	              } else {
	                calIdsWithTasksIds[calid].push(task.id);
	              }
	            }
	          });
	        }
	      });
	      return calIdsWithTasksIds;
	    },
	    tasksWithKidsInUserHash: function tasksWithKidsInUserHash() {
	      var calIdsWithTasksIds = {};
	      this.sortedTasksWithKids.forEach(function (task) {
	        if (task.user_calendar_ids) {
	          task.user_calendar_ids.forEach(function (calid) {
	            if (calid) {
	              if (!calIdsWithTasksIds[calid]) {
	                calIdsWithTasksIds[calid] = [task.id];
	              } else {
	                calIdsWithTasksIds[calid].push(task.id);
	              }
	            }
	          });
	        }
	      });
	      return calIdsWithTasksIds;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    usersAssignedHoursHash: function usersAssignedHoursHash() {
	      return this.$store.getters.usersAssignedHoursHash;
	    },
	    userWithProps: function userWithProps() {
	      var _this = this;
	
	      return this.users.map(function (user) {
	        var userInHash = _this.usersAssignedHoursHash[user.id];
	        var isActiveUser = user.id === _this.activeUserId;
	        var userTasksWithoutKidsIds = _this.tasksInUserHash[user.user_calendar_id];
	        var userTasksWithKidsIds = _this.tasksWithKidsInUserHash[user.user_calendar_id];
	        var userTotalHoursWithoutKids = 0;
	        var userTasksWithoutKids = [];
	        var userTasksWithKids = [];
	        if (userTasksWithoutKidsIds) {
	          userTasksWithoutKids = userTasksWithoutKidsIds.map(function (id) {
	            return _this.tasksInHash[id];
	          });
	          userTotalHoursWithoutKids = userTasksWithoutKidsIds.map(function (hash) {
	            return _this.tasksInHash[hash].hours;
	          }).reduce(function (acc, n) {
	            return acc + n;
	          });
	        }
	        if (userTasksWithKidsIds) {
	          userTasksWithKids = userTasksWithKidsIds.map(function (id) {
	            return _this.tasksWithKidsInHash[id];
	          });
	        }
	        var assignedTotalHours = 0;
	        if (userInHash) {
	          assignedTotalHours = userInHash.assigned_total_hours;
	        }
	
	        return (0, _extends3.default)({}, user, {
	          v_assigned_total_hours: parseFloat(assignedTotalHours).toFixed(2),
	          v_total_without_kids: parseFloat(userTotalHoursWithoutKids).toFixed(2),
	          v_total_with_kids: parseFloat(assignedTotalHours - userTotalHoursWithoutKids).toFixed(2),
	          v_is_active_user: isActiveUser,
	          v_user_tasks_without_kids: userTasksWithoutKids,
	          v_user_tasks_with_kids: userTasksWithKids
	        });
	      });
	    }
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear() {
	      this.readAssignedHours();
	      this.readSubjects();
	      this.$store.dispatch('readTasks', this.activeSchoolYear.id);
	    }
	  },
	  methods: {
	    setIsShowEmploymentEnded: function setIsShowEmploymentEnded(bool) {
	      this.isShowEmploymentEnded = bool;
	    },
	    readSubjects: function readSubjects() {
	      this.$store.dispatch('readSubjects', this.activeSchoolYear.id);
	    },
	    readTasks: function readTasks() {
	      this.$store.dispatch('readTasks', this.activeSchoolYear.id);
	    },
	    updateTasksFromServer: function updateTasksFromServer() {
	      this.isUpdatingTasks = true;
	      this.readTasks();
	    },
	    readAssignedHours: function readAssignedHours() {
	      var schoolObj = {
	        schoolId: this.schoolId,
	        schoolYearId: this.activeSchoolYear.id
	      };
	      this.$store.dispatch('getUsers', this.schoolId, null);
	      this.$store.dispatch('readUsersAssignedHours', schoolObj);
	      if (this.activeUserId) {
	        this.readUserNorm(this.activeUserId);
	      }
	    },
	    readUserNorm: function readUserNorm(userId) {
	      var _this2 = this;
	
	      this.activeNorm = null;
	      _docendo2.default.schoolUserYearRead(this.schoolId, userId, this.activeSchoolYear.name, function (success) {
	        _this2.activeNorm = success.norm ? success.norm : [];
	      }, function (failure) {
	        console.log('failed!');
	      });
	    },
	    setActiveUserId: function setActiveUserId(userId) {
	      if (this.activeUserId === userId) {
	        this.activeUserId = null;
	      } else {
	        this.readUserNorm(userId);
	        this.activeUserId = userId;
	      }
	    },
	    getSchoolDays: function getSchoolDays() {
	      var _this3 = this;
	
	      _docendo2.default.schoolVacationDaysRead(this.schoolId, function (success) {
	        _this3.allVacationsDays = success;
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    confirmDelete: function confirmDelete() {
	      if (this.itemToDelete && this.itemToDelete.itemType === 'task') {
	        this.$store.dispatch('deleteTask', this.itemToDelete);
	        this.$store.commit('setTheDeletedItemId', this.itemToDelete.id);
	      }
	      this.$store.commit('setConfirmDeletion', false);
	      this.$store.commit('setItemToDelete', null);
	    },
	    setUpdatingFromServer: function setUpdatingFromServer() {
	      this.isUpdatingTasks = false;
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    this.readAssignedHours();
	    this.getSchoolDays();
	    window.addEventListener('vueCRUDSubject', function () {
	      return _this4.updateTasksFromServer();
	    });
	    window.addEventListener('vueDoneLoadingTasks', function () {
	      return _this4.setUpdatingFromServer();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _this5 = this;
	
	    window.removeEventListener('vueDoneLoadingTasks', function () {
	      return _this5.setUpdatingFromServer();
	    });
	    window.removeEventListener('vueCRUDSubject', function () {
	      return _this5.updateTasksFromServer();
	    });
	  }
	};

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _AssignHoursAllUsersTheadTh = __webpack_require__(336);
	
	var _AssignHoursAllUsersTheadTh2 = _interopRequireDefault(_AssignHoursAllUsersTheadTh);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _UserTasks = __webpack_require__(54);
	
	var _UserTasks2 = _interopRequireDefault(_UserTasks);
	
	var _DatePickerRangeShortcuts = __webpack_require__(105);
	
	var _DatePickerRangeShortcuts2 = _interopRequireDefault(_DatePickerRangeShortcuts);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DDropdown: _DDropdown2.default, DatePickerRangeShortcuts: _DatePickerRangeShortcuts2.default, Loader: _Loader2.default, thUser: _AssignHoursAllUsersTheadTh2.default, DatePickerRange: _DatePickerRange2.default, DModal: _DModal2.default, UserTasks: _UserTasks2.default },
	  props: {
	    users: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    schoolId: {
	      type: Number,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      sortKey: 'name',
	      sortOrder: 1,
	      isLoadingUpdatedNumbers: false,
	      usersWithScheduledHours: {},
	      startDate: (0, _moment2.default)(),
	      endDate: (0, _moment2.default)(),
	      allVacationsDays: [],
	      theUserToShowTasks: null
	    };
	  },
	
	  computed: {
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isDatesPristine: function isDatesPristine() {
	      return this.compareDates(this.activeSchoolYear.employee_time_start, this.startDate) && this.compareDates(this.activeSchoolYear.employee_time_end, this.endDate);
	    },
	    workDayDates: function workDayDates() {
	      var self = this;
	
	      function isNotWeekend(m) {
	        return (0, _moment2.default)(m).isoWeekday() !== 6 && (0, _moment2.default)(m).isoWeekday() !== 7;
	      }
	
	      function isNotVacationDay(m) {
	        var idx = self.allVacationsDays.findIndex(function (date) {
	          return (0, _moment2.default)(date.day).format('YYYY-MM-DD') === m;
	        });
	        return idx < 0;
	      }
	
	      var startDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_start).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_end).format('YYYY-MM-DD');
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        if (isNotWeekend(m) && isNotVacationDay(m)) {
	          dateArray.push(m);
	        }
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray;
	    },
	    workDayDatesInPeriod: function workDayDatesInPeriod() {
	      var _this = this;
	
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        dateArray.push(m);
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray.filter(function (date) {
	        var m = (0, _moment2.default)(date).format('YYYY-MM-DD');
	        var idx = _this.workDayDates.indexOf(m);
	        return idx > -1;
	      });
	    },
	    numberOfWorkDays: function numberOfWorkDays() {
	      return this.workDayDates.length;
	    },
	    numberOfWorkDaysInPeriod: function numberOfWorkDaysInPeriod() {
	      return this.workDayDatesInPeriod.length;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    usersWithProps: function usersWithProps() {
	      var _this2 = this;
	
	      return this.users.map(function (user) {
	        var userHours = _this2.usersWithScheduledHours[user.id] || {};
	        var totalHoursAssignedInPeriod = _this2.getAssignedHoursForPeriod(user.v_assigned_total_hours);
	        var totalHoursActual = userHours.actual_total_hours || 0;
	        var totalHoursDiff = totalHoursAssignedInPeriod - totalHoursActual;
	        var withKidsAssignedForPeriod = _this2.getAssignedHoursForPeriod(user.v_total_with_kids);
	        var withKidsHoursActual = userHours.actual_with_kids_hours || 0;
	        var withKidsDiff = withKidsAssignedForPeriod - withKidsHoursActual;
	        var withoutKidsAssignedForPeriod = _this2.getAssignedHoursForPeriod(user.v_total_without_kids);
	        var withoutKidsHoursActual = userHours.actual_without_kids_hours || 0;
	        var withoutKidsDiff = withoutKidsAssignedForPeriod - withoutKidsHoursActual;
	        var withAndWithoutKidsAssignedForPeriod = _this2.getAssignedHoursForPeriod(user.v_assigned_total_hours);
	        var withAndWithoutKidsHoursActual = withKidsHoursActual + withoutKidsHoursActual;
	        var withAndWithoutKidsDiff = withAndWithoutKidsAssignedForPeriod - withAndWithoutKidsHoursActual;
	
	        return (0, _extends3.default)({}, user, {
	          v_total_hours_assigned_in_period: _this2.numToFixed(totalHoursAssignedInPeriod),
	          v_total_hours_actual: _this2.numToFixed(totalHoursActual),
	          v_total_hours_diff: _this2.numToFixed(totalHoursDiff),
	          v_with_kids_assigned_in_period: _this2.numToFixed(withKidsAssignedForPeriod),
	          v_with_kids_actual: _this2.numToFixed(withKidsHoursActual),
	          v_with_kids_diff: _this2.numToFixed(withKidsDiff),
	          v_without_kids_assigned_in_period: _this2.numToFixed(withoutKidsAssignedForPeriod),
	          v_without_kids_actual: _this2.numToFixed(withoutKidsHoursActual),
	          v_without_kids_diff: _this2.numToFixed(withoutKidsDiff),
	          v_with_and_without_kids_assigned_in_period: _this2.numToFixed(withAndWithoutKidsAssignedForPeriod),
	          v_with_and_without_kids_actual: _this2.numToFixed(withAndWithoutKidsHoursActual),
	          v_with_and_without_kids_diff: _this2.numToFixed(withAndWithoutKidsDiff)
	        });
	      });
	    },
	    sortedUsers: function sortedUsers() {
	      var sortKey = this.sortKey;
	      var order = this.sortOrder;
	      var data = this.usersWithProps;
	      if (sortKey === 'name') {
	        return this.$helpers.sortArrOnName(data);
	      }
	      return data.sort(function (a, b) {
	        return order < 0 ? a[sortKey] - b[sortKey] : b[sortKey] - a[sortKey];
	      });
	    }
	  },
	  methods: {
	    setTheUserToShowTasks: function setTheUserToShowTasks(user) {
	      if (this.allUsersInHash[user.id]) {
	        this.theUserToShowTasks = this.allUsersInHash[user.id];
	      }
	    },
	    closeTheUserToShowTasks: function closeTheUserToShowTasks() {
	      this.theUserToShowTasks = null;
	    },
	    numToFixed: function numToFixed(num) {
	      return parseFloat(num).toFixed(2);
	    },
	    createTooltip: function createTooltip(sumForYear) {
	      var hoursInYear = 222;
	      var hoursPerDay = sumForYear / hoursInYear;
	      var hoursForPeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      var hoursPerDayFixed = this.numToFixed(hoursPerDay);
	      var hoursForPeriodFixed = this.numToFixed(hoursForPeriod);
	      return '<p><i>N\xE5r du v\xE6lger et andet datointerval end hele \xE5ret, kan du her se, hvor mange timer, der skal planl\xE6gges for medarbejderen i perioden og i gennemsnit per dag. Udregningen tager h\xF8jde for institutionens ferie- og helligdage.</i></p><br></p><p><b>Beregning</b></p><p>For \xE5ret: ' + sumForYear + ' timer / ' + hoursInYear + ' dage = ' + hoursPerDayFixed + ' timer pr. dag</p><p>For perioden: ' + this.numberOfWorkDaysInPeriod + ' arbejdsdage * ' + hoursPerDayFixed + ' timer pr. dag = ' + hoursForPeriodFixed + ' timer</p>';
	    },
	    getAssignedHoursForPeriod: function getAssignedHoursForPeriod(hours) {
	      if (this.isDatesPristine) {
	        return hours;
	      } else {
	        var hoursPerDay = hours / 222;
	        return hoursPerDay * this.numberOfWorkDaysInPeriod;
	      }
	    },
	    sortBy: function sortBy(key) {
	      this.sortKey = key;
	      this.sortOrder = this.sortOrder * -1;
	    },
	    setTheActiveUserInAssignHours: function setTheActiveUserInAssignHours(user) {
	      this.setTheUserToShowTasks(user);
	    },
	    compareDates: function compareDates(firstDate, secondDate) {
	      return (0, _moment2.default)(firstDate).format('YYYY-MM-DD') === (0, _moment2.default)(secondDate).format('YYYY-MM-DD');
	    },
	    scaleIndicator: function scaleIndicator(diff) {
	      var color = 'rgba(62, 207, 142, 0.4)';
	      var newDiff = parseFloat(diff);
	      var indicatorPercentage = parseFloat(newDiff.toFixed(0));
	      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
	        indicatorPercentage = '0' + indicatorPercentage;
	      }
	      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
	        indicatorPercentage = '0' + indicatorPercentage * -1;
	      }
	      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
	        indicatorPercentage = indicatorPercentage * -1;
	      }
	      if (newDiff === 0) {
	        color = 'transparent';
	      }
	      if (newDiff < 0) {
	        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff < -99) {
	        color = 'rgba(250, 86, 90, 1)';
	      }
	      if (newDiff > 0) {
	        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff > 99) {
	        color = 'rgba(62, 207, 142, 1)';
	      }
	      return { '--bgScaleColor': color };
	    },
	    getUsersActualHours: function getUsersActualHours() {
	      var _this3 = this;
	
	      this.isLoadingUpdatedNumbers = true;
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD') + ' 00:00';
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD') + ' 23:59';
	      _docendo2.default.schoolActualHours(this.schoolId, startDate, endDate, null, function (data) {
	        var newUsers = {};
	        for (var i = 0; i < data.length; i++) {
	          newUsers[data[i].user_id] = data[i];
	        }
	        _this3.usersWithScheduledHours = newUsers;
	        _this3.isLoadingUpdatedNumbers = false;
	      });
	    },
	    updateUserHours: function updateUserHours() {
	      var _this4 = this;
	
	      this.isLoadingUpdatedNumbers = true;
	      _docendo2.default.schoolRecalculateAll(this.schoolId, function (data) {
	        _this4.getUsersActualHours();
	      }, function (error) {
	        console.log('error', error);
	        _this4.isLoadingUpdatedNumbers = false;
	      });
	    },
	    setStartDate: function setStartDate(date) {
	      this.setDates(date, null);
	    },
	    setEndDate: function setEndDate(date) {
	      this.setDates(null, date);
	    },
	    resetDates: function resetDates() {
	      if (this.activeSchoolYear) {
	        this.setDates(this.activeSchoolYear.employee_time_start, this.activeSchoolYear.employee_time_end);
	      }
	    },
	    setDatesFromRange: function setDatesFromRange(dateRange) {
	      this.setDates(dateRange.start, dateRange.end);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.startDate = start;
	      }
	      if (end) {
	        this.endDate = end;
	      }
	      this.getUsersActualHours();
	    },
	    readVacationDays: function readVacationDays() {
	      var _this5 = this;
	
	      _docendo2.default.schoolVacationDaysRead(this.schoolId, function (success) {
	        _this5.allVacationsDays = success;
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.readVacationDays();
	    this.resetDates();
	  }
	};

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _CreateSubjectForm = __webpack_require__(145);
	
	var _CreateSubjectForm2 = _interopRequireDefault(_CreateSubjectForm);
	
	var _AnnualNormWithoutKids = __webpack_require__(333);
	
	var _AnnualNormWithoutKids2 = _interopRequireDefault(_AnnualNormWithoutKids);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AnnualNormWithoutKids: _AnnualNormWithoutKids2.default, CreateSubjectForm: _CreateSubjectForm2.default },
	  data: function data() {
	    return {
	      isSubjectModal: false,
	      activeCalendar: null,
	      theEditSubject: null,
	      theEditSubjectId: null
	    };
	  },
	
	  computed: {
	    activeCalendarId: function activeCalendarId() {
	      return this.activeCalendar ? this.activeCalendar.id : null;
	    },
	    calendars: function calendars() {
	      return this.$store.state.calendars;
	    },
	    kindergartenCalendars: function kindergartenCalendars() {
	      return this.$store.getters.kindergartenCalendars;
	    },
	    kindergartenCalendarsWithProps: function kindergartenCalendarsWithProps() {
	      var _this = this;
	
	      return this.kindergartenCalendars.map(function (calendar) {
	        var arrOfSubjects = _this.tasksInCalendarHash[calendar.id] ? _this.tasksInCalendarHash[calendar.id] : [];
	        var subjects = arrOfSubjects.map(function (id) {
	          return _this.subjectsInHash[id];
	        });
	        return (0, _extends3.default)({}, calendar, {
	          v_tasks_with_kids: subjects
	        });
	      });
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    tasks: function tasks() {
	      return this.$store.state.subjects.subjects;
	    },
	    filteredTasks: function filteredTasks() {
	      return this.tasks.filter(function (task) {
	        return task.subject_type === 'with_kids';
	      });
	    },
	    sortedTasks: function sortedTasks() {
	      return this.filteredTasks.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    tasksInCalendarHash: function tasksInCalendarHash() {
	      var calsWithSubjectIds = {};
	      this.sortedTasks.forEach(function (subject) {
	        var calId = subject.calendar_id;
	        if (!calsWithSubjectIds[calId]) {
	          calsWithSubjectIds[calId] = [subject.id];
	        } else {
	          calsWithSubjectIds[calId].push(subject.id);
	        }
	      });
	      return calsWithSubjectIds;
	    }
	  },
	  methods: {
	    setIsCreate: function setIsCreate(calendar) {
	      this.activeCalendar = calendar;
	      this.isSubjectModal = true;
	    },
	    closeSubjectModal: function closeSubjectModal() {
	      this.activeCalendar = null;
	      this.isSubjectModal = false;
	      this.theEditSubject = null;
	      this.theEditSubjectId = null;
	    },
	    createNewSubject: function createNewSubject(newSubject) {
	      newSubject['schoolYearId'] = this.activeSchoolYear.id;
	      this.$store.dispatch('createSubject', newSubject);
	      this.closeSubjectModal();
	    },
	    setEditSubject: function setEditSubject(editSubject) {
	      this.theEditSubject = (0, _assign2.default)({}, editSubject);
	      this.theEditSubjectId = editSubject.id;
	      this.isSubjectModal = true;
	    },
	    updateSubject: function updateSubject(updatedSubject) {
	      this.$store.dispatch('updateSubject', updatedSubject);
	      this.closeSubjectModal();
	    },
	    deleteSubject: function deleteSubject(editSubject) {
	      this.$store.dispatch('deleteSubject', editSubject);
	      this.closeSubjectModal();
	    }
	  }
	};

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SubjectsDistributionTasksCreate = __webpack_require__(146);
	
	var _SubjectsDistributionTasksCreate2 = _interopRequireDefault(_SubjectsDistributionTasksCreate);
	
	var _DSelectCalsIds = __webpack_require__(40);
	
	var _DSelectCalsIds2 = _interopRequireDefault(_DSelectCalsIds);
	
	var _vueClickaway = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { DSelectCalendarIds: _DSelectCalsIds2.default, CreateTask: _SubjectsDistributionTasksCreate2.default },
	  props: {
	    isWithKids: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      theEditTask: null,
	      isTaskModal: false,
	      activeDSelectShow: false,
	      activeDSelect: null
	    };
	  },
	
	  computed: {
	    theActiveFilter: function theActiveFilter() {
	      return this.isWithKids ? 'with_kids' : 'without_kids';
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    schoolId: function schoolId() {
	      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : window.SCHOOL.id;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    tasks: function tasks() {
	      return this.$store.state.subjects.tasks;
	    },
	    filteredTasks: function filteredTasks() {
	      var _this = this;
	
	      if (!this.isWithKids) {
	        return this.tasks.filter(function (task) {
	          return task.subject_type === 'without_kids';
	        });
	      } else {
	        var isTaskInOtherCalendar = function isTaskInOtherCalendar(task) {
	          if (task.belongs_to_calendars.length !== 1) {
	            return false;
	          }
	          var calendarId = task.belongs_to_calendars[0];
	          var cal = _this.allCalendarsInHash[calendarId];
	          return cal && cal.type === 'other';
	        };
	
	        return this.tasks.filter(function (task) {
	          return task.subject_type === 'with_kids' && (task.in_user_calendar || isTaskInOtherCalendar(task));
	        });
	      }
	    },
	    sortedTasks: function sortedTasks() {
	      return this.filteredTasks.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    sortedTasksWithProps: function sortedTasksWithProps() {
	      var _this2 = this;
	
	      return this.sortedTasks.map(function (task) {
	        var userNames = _this2.getUsers(task.user_calendar_ids);
	        return (0, _extends3.default)({}, task, {
	          v_is_active_d_select: _this2.activeDSelect === task.id,
	          v_staff_names: userNames
	        });
	      });
	    }
	  },
	  methods: {
	    getUsers: function getUsers(userCalIds) {
	      var _this3 = this;
	
	      return userCalIds.filter(function (calId) {
	        return _this3.allCalendarsInHash[calId];
	      }).map(function (calId) {
	        return _this3.allCalendarsInHash[calId].name;
	      });
	    },
	    setCreateNewTask: function setCreateNewTask() {
	      this.theEditTask = null;
	      this.isTaskModal = true;
	    },
	    closeUpdateTask: function closeUpdateTask() {
	      this.isTaskModal = false;
	      this.theEditTask = null;
	    },
	    createTask: function createTask(task) {
	      var _this4 = this;
	
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          _ref$keepOpen = _ref.keepOpen,
	          keepOpen = _ref$keepOpen === undefined ? false : _ref$keepOpen;
	
	      this.isTaskModal = false;
	      task['schoolId'] = this.schoolId;
	      this.$store.dispatch('createTask', task);
	      if (keepOpen) {
	        setTimeout(function (_) {
	          _this4.isTaskModal = true;
	        }, 0);
	      }
	    },
	    setEditTask: function setEditTask(task) {
	      var _this5 = this;
	
	      this.isTaskModal = false;
	      this.theEditTask = task;
	      setTimeout(function (_) {
	        _this5.isTaskModal = true;
	      }, 0);
	    },
	    setActiveDSelect: function setActiveDSelect(task) {
	      if (task.user_calendar_ids.length < 1) {
	        this.activeDSelectShow = true;
	      } else {
	        this.activeDSelectShow = false;
	      }
	      this.activeDSelect = task.id;
	    },
	    closeDSelect: function closeDSelect() {
	      if (!this.activeDSelect) {
	        return;
	      }
	      this.activeDSelect = null;
	    },
	    usersWithEvents: function usersWithEvents(task) {
	      var usersWithEvents = [];
	      task.subjects.forEach(function (subject) {
	        if (subject.has_events) {
	          if (subject.user_calendars.length > 0) {
	            usersWithEvents = subject.user_calendars;
	          } else {
	            usersWithEvents.push(subject.calendar_id);
	          }
	        }
	      });
	      return usersWithEvents;
	    },
	    getUserNames: function getUserNames(calIds) {
	      var _this6 = this;
	
	      return calIds.map(function (calId) {
	        return _this6.allCalendarsInHash[calId] ? _this6.allCalendarsInHash[calId].name : '';
	      });
	    },
	    setSelectedUsers: function setSelectedUsers(users, task) {
	      if (!task) {
	        this.fastFormUsers = users;
	        return;
	      }
	      var belongsToCalendars = [];
	      var userCalendars = [];
	      var isInOtherCalendar = task.belongs_to_calendars[0] && this.allCalendarsInHash[task.belongs_to_calendars[0]] && this.allCalendarsInHash[task.belongs_to_calendars[0]].type === 'other';
	      if (isInOtherCalendar) {
	        belongsToCalendars = [task.belongs_to_calendars[0]];
	        userCalendars = users.map(function (user) {
	          return user.id;
	        });
	      } else {
	        belongsToCalendars = users.map(function (user) {
	          return user.id;
	        });
	      }
	      var updatedTask = {
	        schoolId: task.school_id,
	        schoolYearId: task.school_year_id,
	        id: task.id,
	        name: task.name,
	        color: task.color,
	        hours: task.hours,
	        defaultDuration: task.default_duration,
	        belongsToCalendars: belongsToCalendars,
	        userCalendars: userCalendars
	      };
	      this.updateTask(updatedTask);
	    },
	    updateTask: function updateTask(updatesForTask) {
	      this.$store.dispatch('updateTask', updatesForTask);
	      this.closeUpdateTask();
	    }
	  }
	};

/***/ }),
/* 463 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    steps: {
	      default: 6
	    },
	    stepNum: {
	      default: 3
	    },
	    animate: {
	      default: false
	    }
	  },
	  computed: {
	    stepClass: function stepClass() {
	      return 'css' + this.stepNum + '-' + this.steps;
	    }
	  }
	};

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _AssignHoursAllUsersTheadTh = __webpack_require__(336);
	
	var _AssignHoursAllUsersTheadTh2 = _interopRequireDefault(_AssignHoursAllUsersTheadTh);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _UserTasks = __webpack_require__(54);
	
	var _UserTasks2 = _interopRequireDefault(_UserTasks);
	
	var _DatePickerRangeShortcuts = __webpack_require__(105);
	
	var _DatePickerRangeShortcuts2 = _interopRequireDefault(_DatePickerRangeShortcuts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DatePickerRangeShortcuts: _DatePickerRangeShortcuts2.default, Loader: _Loader2.default, thUser: _AssignHoursAllUsersTheadTh2.default, DatePickerRange: _DatePickerRange2.default, DModal: _DModal2.default, UserTasks: _UserTasks2.default },
	  props: {
	    users: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    schoolId: {
	      type: Number,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      sortKey: 'name',
	      sortOrder: 1,
	      isLoadingUpdatedNumbers: false,
	      usersWithScheduledHours: {},
	      startDate: (0, _moment2.default)(),
	      endDate: (0, _moment2.default)(),
	      allVacationsDays: [],
	      theUserToShowTasks: null
	    };
	  },
	
	  computed: {
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isDatesPristine: function isDatesPristine() {
	      return this.compareDates(this.activeSchoolYear.employee_time_start, this.startDate) && this.compareDates(this.activeSchoolYear.employee_time_end, this.endDate);
	    },
	    workDayDates: function workDayDates() {
	      var self = this;
	
	      function isNotWeekend(m) {
	        return (0, _moment2.default)(m).isoWeekday() !== 6 && (0, _moment2.default)(m).isoWeekday() !== 7;
	      }
	
	      function isNotVacationDay(m) {
	        var idx = self.allVacationsDays.findIndex(function (date) {
	          return (0, _moment2.default)(date.day).format('YYYY-MM-DD') === m;
	        });
	        return idx < 0;
	      }
	
	      var startDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_start).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_end).format('YYYY-MM-DD');
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        if (isNotWeekend(m) && isNotVacationDay(m)) {
	          dateArray.push(m);
	        }
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray;
	    },
	    workDayDatesInPeriod: function workDayDatesInPeriod() {
	      var _this = this;
	
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        dateArray.push(m);
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray.filter(function (date) {
	        var m = (0, _moment2.default)(date).format('YYYY-MM-DD');
	        var idx = _this.workDayDates.indexOf(m);
	        return idx > -1;
	      });
	    },
	    numberOfWorkDays: function numberOfWorkDays() {
	      return this.workDayDates.length;
	    },
	    numberOfWorkDaysInPeriod: function numberOfWorkDaysInPeriod() {
	      return this.workDayDatesInPeriod.length;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    usersWithProps: function usersWithProps() {
	      var _this2 = this;
	
	      return this.users.map(function (user) {
	        var userHours = _this2.usersWithScheduledHours[user.id] || {};
	        var totalHoursAssignedInPeriod = _this2.getAssignedHoursForPeriod(user.v_assigned_total_hours);
	        var totalHoursActual = userHours.actual_total_hours || 0;
	        var totalHoursDiff = totalHoursAssignedInPeriod - totalHoursActual;
	        var withKidsAssignedForPeriod = _this2.getAssignedHoursForPeriod(user.v_total_with_kids);
	        var withKidsHoursActual = userHours.actual_with_kids_hours || 0;
	        var withKidsDiff = withKidsAssignedForPeriod - withKidsHoursActual;
	        var withoutKidsAssignedForPeriod = _this2.getAssignedHoursForPeriod(user.v_total_without_kids);
	        var withoutKidsHoursActual = userHours.actual_without_kids_hours || 0;
	        var withoutKidsDiff = withoutKidsAssignedForPeriod - withoutKidsHoursActual;
	        var withAndWithoutKidsAssignedForPeriod = _this2.getAssignedHoursForPeriod(user.v_assigned_total_hours);
	        var withAndWithoutKidsHoursActual = withKidsHoursActual + withoutKidsHoursActual;
	        var withAndWithoutKidsDiff = withAndWithoutKidsAssignedForPeriod - withAndWithoutKidsHoursActual;
	
	        return (0, _extends3.default)({}, user, {
	          v_total_hours_assigned_in_period: _this2.numToFixed(totalHoursAssignedInPeriod),
	          v_total_hours_actual: _this2.numToFixed(totalHoursActual),
	          v_total_hours_diff: _this2.numToFixed(totalHoursDiff),
	          v_with_kids_assigned_in_period: _this2.numToFixed(withKidsAssignedForPeriod),
	          v_with_kids_actual: _this2.numToFixed(withKidsHoursActual),
	          v_with_kids_diff: _this2.numToFixed(withKidsDiff),
	          v_without_kids_assigned_in_period: _this2.numToFixed(withoutKidsAssignedForPeriod),
	          v_without_kids_actual: _this2.numToFixed(withoutKidsHoursActual),
	          v_without_kids_diff: _this2.numToFixed(withoutKidsDiff),
	          v_with_and_without_kids_assigned_in_period: _this2.numToFixed(withAndWithoutKidsAssignedForPeriod),
	          v_with_and_without_kids_actual: _this2.numToFixed(withAndWithoutKidsHoursActual),
	          v_with_and_without_kids_diff: _this2.numToFixed(withAndWithoutKidsDiff)
	        });
	      });
	    },
	    sortedUsers: function sortedUsers() {
	      var sortKey = this.sortKey;
	      var order = this.sortOrder;
	      var data = this.usersWithProps;
	      if (sortKey === 'name') {
	        return this.$helpers.sortArrOnName(data);
	      }
	      return data.sort(function (a, b) {
	        return order < 0 ? a[sortKey] - b[sortKey] : b[sortKey] - a[sortKey];
	      });
	    }
	  },
	  methods: {
	    setTheUserToShowTasks: function setTheUserToShowTasks(user) {
	      if (this.allUsersInHash[user.id]) {
	        this.theUserToShowTasks = this.allUsersInHash[user.id];
	      }
	    },
	    closeTheUserToShowTasks: function closeTheUserToShowTasks() {
	      this.theUserToShowTasks = null;
	    },
	    numToFixed: function numToFixed(num) {
	      return parseFloat(num).toFixed(2);
	    },
	    createTooltip: function createTooltip(sumForYear) {
	      var hoursInYear = 222;
	      var hoursPerDay = sumForYear / hoursInYear;
	      var hoursForPeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      var hoursPerDayFixed = this.numToFixed(hoursPerDay);
	      var hoursForPeriodFixed = this.numToFixed(hoursForPeriod);
	      return '<p><i>N\xE5r du v\xE6lger et andet datointerval end hele \xE5ret, kan du her se, hvor mange timer, der skal planl\xE6gges for medarbejderen i perioden og i gennemsnit per dag. Udregningen tager h\xF8jde for institutionens ferie- og helligdage.</i></p><br></p><p><b>Beregning</b></p><p>For \xE5ret: ' + sumForYear + ' timer / ' + hoursInYear + ' dage = ' + hoursPerDayFixed + ' timer pr. dag</p><p>For perioden: ' + this.numberOfWorkDaysInPeriod + ' arbejdsdage * ' + hoursPerDayFixed + ' timer pr. dag = ' + hoursForPeriodFixed + ' timer</p>';
	    },
	    getAssignedHoursForPeriod: function getAssignedHoursForPeriod(hours) {
	      if (this.isDatesPristine) {
	        return hours;
	      } else {
	        var hoursPerDay = hours / 222;
	        return hoursPerDay * this.numberOfWorkDaysInPeriod;
	      }
	    },
	    sortBy: function sortBy(key) {
	      this.sortKey = key;
	      this.sortOrder = this.sortOrder * -1;
	    },
	    setTheActiveUserInAssignHours: function setTheActiveUserInAssignHours(user) {
	      this.setTheUserToShowTasks(user);
	    },
	    compareDates: function compareDates(firstDate, secondDate) {
	      return (0, _moment2.default)(firstDate).format('YYYY-MM-DD') === (0, _moment2.default)(secondDate).format('YYYY-MM-DD');
	    },
	    scaleIndicator: function scaleIndicator(diff) {
	      var color = 'rgba(62, 207, 142, 0.4)';
	      var newDiff = parseFloat(diff);
	      var indicatorPercentage = parseFloat(newDiff.toFixed(0));
	      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
	        indicatorPercentage = '0' + indicatorPercentage;
	      }
	      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
	        indicatorPercentage = '0' + indicatorPercentage * -1;
	      }
	      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
	        indicatorPercentage = indicatorPercentage * -1;
	      }
	      if (newDiff === 0) {
	        color = 'transparent';
	      }
	      if (newDiff < 0) {
	        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff < -99) {
	        color = 'rgba(250, 86, 90, 1)';
	      }
	      if (newDiff > 0) {
	        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff > 99) {
	        color = 'rgba(62, 207, 142, 1)';
	      }
	      return { '--bgScaleColor': color };
	    },
	    getUsersActualHours: function getUsersActualHours() {
	      var _this3 = this;
	
	      this.isLoadingUpdatedNumbers = true;
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD') + ' 00:00';
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD') + ' 23:59';
	      _docendo2.default.schoolActualHours(this.schoolId, startDate, endDate, null, function (data) {
	        var newUsers = {};
	        for (var i = 0; i < data.length; i++) {
	          newUsers[data[i].user_id] = data[i];
	        }
	        _this3.usersWithScheduledHours = newUsers;
	        _this3.isLoadingUpdatedNumbers = false;
	      });
	    },
	    updateUserHours: function updateUserHours() {
	      var _this4 = this;
	
	      this.isLoadingUpdatedNumbers = true;
	      _docendo2.default.schoolRecalculateAll(this.schoolId, function (data) {
	        _this4.getUsersActualHours();
	      }, function (error) {
	        console.log('error', error);
	        _this4.isLoadingUpdatedNumbers = false;
	      });
	    },
	    setStartDate: function setStartDate(date) {
	      this.setDates(date, null);
	    },
	    setEndDate: function setEndDate(date) {
	      this.setDates(null, date);
	    },
	    resetDates: function resetDates() {
	      if (this.activeSchoolYear) {
	        this.setDates(this.activeSchoolYear.employee_time_start, this.activeSchoolYear.employee_time_end);
	      }
	    },
	    setDatesFromRange: function setDatesFromRange(dateRange) {
	      this.setDates(dateRange.start, dateRange.end);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.startDate = start;
	      }
	      if (end) {
	        this.endDate = end;
	      }
	      this.getUsersActualHours();
	    },
	    readVacationDays: function readVacationDays() {
	      var _this5 = this;
	
	      _docendo2.default.schoolVacationDaysRead(this.schoolId, function (success) {
	        _this5.allVacationsDays = success;
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.readVacationDays();
	    this.resetDates();
	  }
	};

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _set = __webpack_require__(27);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ArbeidsplanSubjects = __webpack_require__(1446);
	
	var _ArbeidsplanSubjects2 = _interopRequireDefault(_ArbeidsplanSubjects);
	
	var _ArbeidsplanAssignHoursNorm = __webpack_require__(1444);
	
	var _ArbeidsplanAssignHoursNorm2 = _interopRequireDefault(_ArbeidsplanAssignHoursNorm);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _AnnualNormResult = __webpack_require__(1442);
	
	var _AnnualNormResult2 = _interopRequireDefault(_AnnualNormResult);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SubjectsDistributionTasks = __webpack_require__(392);
	
	var _SubjectsDistributionTasks2 = _interopRequireDefault(_SubjectsDistributionTasks);
	
	var _SubjectsDistributionUserAgreements = __webpack_require__(83);
	
	var _SubjectsDistributionUserAgreements2 = _interopRequireDefault(_SubjectsDistributionUserAgreements);
	
	var _ArbeidsplanUser = __webpack_require__(1447);
	
	var _ArbeidsplanUser2 = _interopRequireDefault(_ArbeidsplanUser);
	
	var _CreateSubjectForm = __webpack_require__(145);
	
	var _CreateSubjectForm2 = _interopRequireDefault(_CreateSubjectForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CreateSubjectForm: _CreateSubjectForm2.default,
	    ArbeidsplanUser: _ArbeidsplanUser2.default,
	    SubjectsDistributionUserAgreements: _SubjectsDistributionUserAgreements2.default,
	    SubjectsDistributionTasks: _SubjectsDistributionTasks2.default,
	    AnnualNormResult: _AnnualNormResult2.default,
	    ModalConfirmation: _ModalConfirmation2.default, ArbeidsplanAssignHoursNorm: _ArbeidsplanAssignHoursNorm2.default, ArbeidsplanSubjects: _ArbeidsplanSubjects2.default, Loader: _Loader2.default, ChangeSchoolYear: _ChangeSchoolYear2.default
	  },
	  data: function data() {
	    return {
	      theEditSubject: null,
	      theEditSubjectId: null,
	      activeCalendar: null,
	      isSubjectModal: false,
	      viewIsResult: false,
	      isTasksView: false,
	      activeUserId: null,
	      allVacationsDays: [],
	      isUpdatingTasks: false,
	      activeNorm: null,
	      activeUserAgreements: ''
	    };
	  },
	
	  computed: {
	    activeCalendarId: function activeCalendarId() {
	      return this.activeCalendar ? this.activeCalendar.id : null;
	    },
	    activeNormFormatted: function activeNormFormatted() {
	      var norm = this.activeNorm ? this.activeNorm : [];
	      return norm.filter(function (item) {
	        return !item.title.startsWith('hidden_');
	      }).map(function (item) {
	        return (0, _extends3.default)({}, item, {
	          value: item.title === 'Periode start' || item.title === 'Periode slut' ? (0, _moment2.default)(item.value).format('ll') : item.value
	        });
	      });
	    },
	    activeUser: function activeUser() {
	      var _this = this;
	
	      return this.userWithProps.find(function (user) {
	        return user.id === _this.activeUserId;
	      });
	    },
	    calendarsInHash: function calendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    isConfirmDeletion: function isConfirmDeletion() {
	      return this.$store.state.subjects.isConfirmDeletion;
	    },
	    itemToDelete: function itemToDelete() {
	      return this.$store.state.subjects.itemToDelete;
	    },
	    schoolId: function schoolId() {
	      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : window.SCHOOL.id;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.subjects.isLoading;
	    },
	    subjects: function subjects() {
	      return this.$store.state.subjects.subjects;
	    },
	    subjectsInUserHash: function subjectsInUserHash() {
	      return this.$store.getters.subjectsInUserHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    tasksInHash: function tasksInHash() {
	      return this.$store.getters.tasksInHash;
	    },
	    tasksInUserHash: function tasksInUserHash() {
	      return this.$store.getters.tasksInUserHash;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    usersAssignedHoursHash: function usersAssignedHoursHash() {
	      return this.$store.getters.usersAssignedHoursHash;
	    },
	    userWithProps: function userWithProps() {
	      var _this2 = this;
	
	      return this.users.map(function (user) {
	        var userInHash = _this2.usersAssignedHoursHash[user.id];
	        var isActiveUser = user.id === _this2.activeUserId;
	
	        var userTasksIds = _this2.tasksInUserHash[user.user_calendar_id] ? _this2.tasksInUserHash[user.user_calendar_id] : [];
	        var userAllTypeTasks = userTasksIds.map(function (id) {
	          return _this2.tasksInHash[id];
	        });
	        var tasks = [];
	        var tasksHours = 0;
	
	        var teachingTasks = [];
	        var teachingTaskHours = 0;
	        userAllTypeTasks.forEach(function (task) {
	          if (task.subject_type === 'additional_tasks') {
	            tasks.push((0, _extends3.default)({}, task, { v_hours_label: (task.hours * 1).toFixed(2) }));
	            tasksHours += task.hours * 1;
	          } else if (task.subject_type === 'person_resource' || task.subject_type === 'person_resource_visible' || task.subject_type === 'subject') {
	            teachingTasks.push(task);
	            teachingTaskHours += task.hours * 1;
	          }
	        });
	        var assignedTotalHours = 0;
	        if (userInHash && userInHash.assigned_total_hours) {
	          assignedTotalHours = userInHash.assigned_total_hours;
	        }
	
	        var userSubjectsWithAarsramme = [];
	        var userSubjectsWithIds = _this2.subjectsInUserHash[user.user_calendar_id];
	        var userSubjects = [];
	        if (userSubjectsWithIds) {
	          userSubjects = userSubjectsWithIds.map(function (id) {
	            return _this2.subjectsInHash[id];
	          }).filter(function (subject) {
	            if (!subject) return false;
	            var calendar = _this2.calendarsInHash[subject.calendar_id];
	            return !calendar || calendar.type !== 'user';
	          });
	        }
	        var includedSubjectIds = new _set2.default(userSubjects.map(function (subject) {
	          return String(subject.id);
	        }));
	        var extraTeachingTasks = teachingTasks.filter(function (task) {
	          var taskSubjectIds = (task.subject_ids || []).map(function (id) {
	            return String(id);
	          });
	          if (taskSubjectIds.length) {
	            return !taskSubjectIds.some(function (id) {
	              return includedSubjectIds.has(id);
	            });
	          }
	          return !includedSubjectIds.has(String(task.id));
	        });
	        userSubjects = userSubjects.concat(extraTeachingTasks);
	        var userSubjectHours = 0;
	        var userNorm = userInHash && userInHash['norm'] && userInHash['norm'].length > 0 ? userInHash['norm'] : [];
	        var sumOfTeachingReduction = userNorm.filter(function (item) {
	          return item.value && item.title.startsWith('hidden_reduction_teaching');
	        }).reduce(function (accumulator, item) {
	          return accumulator + item.value * 1;
	        }, 0);
	        var totalTeachingPercentage = sumOfTeachingReduction * 1;
	        userSubjectsWithAarsramme = userSubjects.map(function (subject) {
	          userSubjectHours += subject.hours * 1;
	          var subjectPreptime = subject.preparation ? subject.preparation : 741;
	          var calendarName = subject.calendar_id !== user.user_calendar_id ? _this2.calendarsInHash[subject.calendar_id] ? _this2.calendarsInHash[subject.calendar_id]['name'] : '' : '';
	          var teachingPercentage = subject.hours * 1 / subjectPreptime * 100;
	          totalTeachingPercentage += teachingPercentage;
	          return (0, _extends3.default)({}, subject, {
	            v_calendar: calendarName,
	            v_percentage: teachingPercentage,
	            v_percentage_label: teachingPercentage.toFixed(2) + '%',
	            v_hours_label: (subject.hours * 1).toFixed(2)
	          });
	        });
	
	        return (0, _extends3.default)({}, user, {
	          v_assigned_total_hours: parseFloat(assignedTotalHours).toFixed(2),
	          v_total_teaching_percentage: totalTeachingPercentage,
	          v_total_teaching_percentage_label: (totalTeachingPercentage * 1).toFixed(2) + '%',
	          v_is_active_user: isActiveUser,
	          v_user_tasks: tasks,
	          v_user_tasks_hours: tasksHours,
	          v_user_tasks_hours_label: parseFloat(tasksHours).toFixed(2),
	          v_user_subjects: userSubjectsWithAarsramme,
	          v_user_subjects_hours: userSubjectHours,
	          v_user_subjects_hours_label: parseFloat(userSubjectHours).toFixed(2)
	        });
	      });
	    }
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear() {
	      this.readAssignedHours();
	      this.readSubjects();
	      this.$store.dispatch('readTasks', this.activeSchoolYear.id);
	    }
	  },
	  methods: {
	    setEditSubject: function setEditSubject(editSubject) {
	      this.theEditSubject = (0, _assign2.default)({}, editSubject);
	      this.theEditSubjectId = editSubject.id;
	      this.isSubjectModal = true;
	    },
	    createNewSubject: function createNewSubject(newSubject) {
	      newSubject['schoolYearId'] = this.activeSchoolYear.id;
	      this.$store.dispatch('createSubject', newSubject);
	      this.closeSubjectModal();
	    },
	    closeSubjectModal: function closeSubjectModal() {
	      this.activeCalendar = null;
	      this.isSubjectModal = false;
	      this.theEditSubject = null;
	      this.theEditSubjectId = null;
	    },
	    setIsCreateSubject: function setIsCreateSubject(calendar) {
	      this.activeCalendar = calendar;
	      this.isSubjectModal = true;
	    },
	    updateSubject: function updateSubject(updatedSubject) {
	      this.$store.dispatch('updateSubject', updatedSubject);
	      this.closeSubjectModal();
	    },
	    deleteSubject: function deleteSubject(editSubject) {
	      this.$store.dispatch('deleteSubject', editSubject);
	      this.closeSubjectModal();
	    },
	    readSubjects: function readSubjects() {
	      this.$store.dispatch('readSubjects', this.activeSchoolYear.id);
	    },
	    readTasks: function readTasks() {
	      this.$store.dispatch('readTasks', this.activeSchoolYear.id);
	    },
	    updateTasksFromServer: function updateTasksFromServer() {
	      this.isUpdatingTasks = true;
	      this.readTasks();
	    },
	    readAssignedHours: function readAssignedHours() {
	      var schoolObj = {
	        schoolId: this.schoolId,
	        schoolYearId: this.activeSchoolYear.id
	      };
	      this.$store.dispatch('getUsers', this.schoolId, null);
	      this.$store.dispatch('readUsersAssignedHours', schoolObj);
	      if (this.activeUserId) {
	        this.readUserNorm(this.activeUserId);
	      }
	    },
	    readUserNorm: function readUserNorm(userId) {
	      var _this3 = this;
	
	      this.activeNorm = '';
	      this.activeUserAgreements = '';
	      _docendo2.default.schoolUserYearRead(this.schoolId, userId, this.activeSchoolYear.name, function (success) {
	        _this3.activeNorm = success.norm ? success.norm : [];
	        _this3.activeUserAgreements = success.agreements ? success.agreements : '';
	        console.log('readUserNorm', success);
	      }, function (failure) {
	        console.log('failed!');
	      });
	    },
	    setActiveUserId: function setActiveUserId(userId) {
	      if (this.activeUserId === userId) {
	        this.activeUserId = null;
	      } else {
	        this.readUserNorm(userId);
	        this.activeUserId = userId;
	      }
	    },
	    getSchoolDays: function getSchoolDays() {
	      var _this4 = this;
	
	      _docendo2.default.schoolVacationDaysRead(this.schoolId, function (success) {
	        _this4.allVacationsDays = success;
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    confirmDelete: function confirmDelete() {
	      if (this.itemToDelete && this.itemToDelete.itemType === 'task') {
	        this.$store.dispatch('deleteTask', this.itemToDelete);
	        this.$store.commit('setTheDeletedItemId', this.itemToDelete.id);
	      }
	      this.$store.commit('setConfirmDeletion', false);
	      this.$store.commit('setItemToDelete', null);
	    },
	    setUpdatingFromServer: function setUpdatingFromServer() {
	      this.isUpdatingTasks = false;
	    }
	  },
	  mounted: function mounted() {
	    var _this5 = this;
	
	    this.readAssignedHours();
	    this.getSchoolDays();
	    window.addEventListener('vueCRUDSubject', function () {
	      return _this5.updateTasksFromServer();
	    });
	    window.addEventListener('vueDoneLoadingTasks', function () {
	      return _this5.setUpdatingFromServer();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _this6 = this;
	
	    window.removeEventListener('vueDoneLoadingTasks', function () {
	      return _this6.setUpdatingFromServer();
	    });
	    window.removeEventListener('vueCRUDSubject', function () {
	      return _this6.updateTasksFromServer();
	    });
	  }
	};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _TaggingFilter = __webpack_require__(43);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _vuex = __webpack_require__(14);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _AppEIPWYZIWYG = __webpack_require__(55);
	
	var _AppEIPWYZIWYG2 = _interopRequireDefault(_AppEIPWYZIWYG);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _ArbeidsplanAssignHoursNormList = __webpack_require__(1445);
	
	var _ArbeidsplanAssignHoursNormList2 = _interopRequireDefault(_ArbeidsplanAssignHoursNormList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default, DModal: _DModal2.default, filterTags: _TaggingFilter2.default, AppEIPWYZIWYG: _AppEIPWYZIWYG2.default, ArbeidsplanAssignHoursNormList: _ArbeidsplanAssignHoursNormList2.default },
	  props: {
	    tags: {
	      default: function _default() {
	        return [];
	      }
	    },
	    isLocalPoolActivated: {
	      type: Boolean,
	      default: false
	    },
	    prepFactor: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isWarningActive: false,
	      isActive: false,
	      isSaving: false,
	      selectedUsers: [],
	      appliedFilters: [],
	      nettoItems: [],
	      items: [{ id: 'assigned_teaching_hours', name: 'Undervisning', hours: 800, isChecked: false }, { id: 'assigned_additional_task_hours', name: 'Øvrige oppgaver', hours: 400, isChecked: false }, { id: 'assigned_preparation_hours', name: 'Forberedelse', hours: 400, isChecked: false }, { id: 'assigned_pool_hours', name: 'Lokalpulje', hours: 80, isChecked: false }, { id: 'substitute_pool_hours', name: 'Vikartimer', hours: 0, isChecked: false }, { id: 'assigned_club_hours', name: 'SFO-timer', hours: 0, isChecked: false }],
	      originalItems: [],
	      agreements: '',
	      isShowAgreement: false,
	      activeTab: 1,
	      itemsToSave: [],
	      nettoTime: 1687.5,
	      theEditUserNorm: null
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usersSortedOnName']), {
	    schoolId: function schoolId() {
	      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : window.SCHOOL.id;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    usersSortedOnNameWithTags: function usersSortedOnNameWithTags() {
	      return this.usersSortedOnName.map(function (user) {
	        user.tags = user.user_tags;
	        return user;
	      });
	    },
	    filteredUsers: function filteredUsers() {
	      var _this = this;
	
	      var passedUsers = this.usersSortedOnName;
	
	      var _loop = function _loop(i) {
	        passedUsers = passedUsers.filter(function (user) {
	          return user.user_tags && user.user_tags.indexOf(_this.appliedFilters[i]) > -1;
	        });
	      };
	
	      for (var i = 0; i < this.appliedFilters.length; i++) {
	        _loop(i);
	      }
	      return passedUsers;
	    },
	    hoursForTeaching: function hoursForTeaching() {
	      var idx = this.items.findIndex(function (item) {
	        return item.id === 'assigned_teaching_hours';
	      });
	      return this.items[idx].hours;
	    }
	  }),
	  methods: {
	    setIsNormModal: function setIsNormModal() {
	      this.isActive = true;
	      if (this.prepFactor) {
	        var thePrep = this.hoursForTeaching * this.prepFactor;
	        var idx = this.items.findIndex(function (hoursItem) {
	          return hoursItem.id === 'assigned_preparation_hours';
	        });
	        this.items[idx].hours = thePrep;
	      }
	    },
	    onUpdatingHours: function onUpdatingHours(item) {
	      if (!this.prepFactor) {
	        return;
	      }
	      if (item.id === 'assigned_teaching_hours') {
	        var thePrep = item.hours * this.prepFactor;
	        var idx = this.items.findIndex(function (hoursItem) {
	          return hoursItem.id === 'assigned_preparation_hours';
	        });
	        this.items[idx].hours = thePrep;
	      }
	    },
	    toggleItem: function toggleItem(idx) {
	      this.items[idx].isChecked = !this.items[idx].isChecked;
	    },
	    isItemToggled: function isItemToggled(idx) {
	      return this.items[idx].isChecked;
	    },
	    setNettoTime: function setNettoTime(time) {
	      this.nettoTime = time;
	    },
	    setItemsToSave: function setItemsToSave(arr) {
	      console.log('setItemsToSave');
	      this.itemsToSave = arr;
	    },
	    getIsActiveTab: function getIsActiveTab(num) {
	      return this.activeTab === num;
	    },
	    setIsShowAgreement: function setIsShowAgreement() {
	      this.isShowAgreement = !this.isShowAgreement;
	    },
	    toggleAll: function toggleAll() {
	      var _this2 = this;
	
	      if (this.selectedUsers.length > 0) {
	        this.selectedUsers = [];
	      } else {
	        this.selectedUsers = [];
	        this.filteredUsers.forEach(function (user) {
	          return _this2.selectedUsers.push(user.id);
	        });
	      }
	    },
	    getIsUserSelected: function getIsUserSelected(user) {
	      var idx = this.selectedUsers.findIndex(function (selectedUser) {
	        return selectedUser === user.id;
	      });
	      return idx > -1;
	    },
	    toggleUser: function toggleUser(user) {
	      var idx = this.selectedUsers.findIndex(function (selectedUser) {
	        return selectedUser === user.id;
	      });
	      if (idx > -1) {
	        this.selectedUsers.splice(idx, 1);
	      } else {
	        this.selectedUsers.push(user.id);
	      }
	    },
	    setTagFromFilter: function setTagFromFilter(tag) {
	      this.selectedUsers = [];
	      this.appliedFilters.push(tag);
	    },
	    removeTagFromFilter: function removeTagFromFilter(tag) {
	      this.selectedUsers = [];
	      this.appliedFilters.splice(this.appliedFilters.indexOf(tag), 1);
	    },
	    close: function close() {
	      this.isActive = false;
	      this.selectedUsers = [];
	    },
	    save: function save() {
	      var _this3 = this;
	
	      if (this.selectedUsers.length < 1) {
	        return;
	      }
	
	      function validateNumber(item) {
	        var itemsNotToValidate = ['hidden_stillingsprosenten', 'Stillingsprosenten', 'Periode', 'hidden_periode_start', 'hidden_periode_end'];
	        if (item.dontValidate || itemsNotToValidate.indexOf(item.title) > -1 || item.title.startsWith('hidden_reduction_teaching')) {
	          return item.value;
	        } else {
	          var val = item.hours * 1;
	          return val.toFixed(1);
	        }
	      }
	
	      this.isSaving = true;
	      var itemsToSave = this.itemsToSave.map(function (item) {
	        return {
	          title: item.title,
	          value: validateNumber(item)
	        };
	      });
	      var data = {
	        norm: itemsToSave,
	        assigned_total_hours: this.nettoTime
	      };
	      if (this.isShowAgreement) {
	        data['agreements'] = this.agreements;
	      }
	      var activatedItems = this.items.filter(function (item) {
	        return item.isChecked;
	      });
	      activatedItems.forEach(function (item) {
	        data[item.id] = item.hours;
	      });
	
	      var dataToSave = this.selectedUsers.map(function (userId) {
	        return {
	          user_id: userId,
	          data: data
	        };
	      });
	      _docendo2.default.bulkSchoolUserYearUpdate(this.schoolId, this.activeSchoolYear.name, dataToSave, function (success) {
	        _this3.reset();
	        _this3.$emit('updateUsersHours');
	        _this3.close();
	        _eventbus2.default.toast = { text: 'Gemt', 'success': true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Noget gik galt', 'success': false };
	      });
	    },
	    reset: function reset() {
	      this.isSaving = false;
	      this.selectedUsers = [];
	      this.isShowAgreement = false;
	      this.agreements = '';
	      this.items = JSON.parse((0, _stringify2.default)(this.originalItems));
	      this.isWarningActive = false;
	    },
	    updateAgreements: function updateAgreements(val) {
	      this.agreements = val;
	    },
	    readUserNorm: function readUserNorm(user) {
	      var _this4 = this;
	
	      _docendo2.default.schoolUserYearRead(this.schoolId, user.id, this.activeSchoolYear.name, function (success) {
	        _this4.theEditUserNorm = success.norm ? success.norm : [];
	        _this4.userAgreements = success.agreements ? success.agreements : '';
	      }, function (failure) {
	        console.log('failed!');
	      });
	    },
	    editUserNorm: function editUserNorm(user) {
	      this.readUserNorm(user);
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (!this.isLocalPoolActivated) {
	      var idx = this.items.findIndex(function (item) {
	        return item.id === 'assigned_pool_hours';
	      });
	      this.items.splice(idx, 1);
	    }
	  },
	  mounted: function mounted() {
	    this.originalItems = JSON.parse((0, _stringify2.default)(this.items));
	  }
	};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default, DateSelector: _DateSelector2.default },
	  props: {
	    schoolYear: {},
	    theEditUserNorm: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isNetto: {
	      default: false,
	      type: Boolean
	    }
	  },
	  data: function data() {
	    return {
	      isEditPeriod: false,
	      initStartDate: null,
	      initEndDate: null,
	      startDate: null,
	      endDate: null,
	      employmentPercentage: {
	        id: 'employment_percentage',
	        title: 'Stillingsprosenten',
	        hours: 100,
	        standardHours: 100,
	        unit: '%',
	        isFixed: false
	      },
	      workingHours: {
	        id: 'working_hours',
	        title: 'Årsverk',
	        hours: 1687.5,
	        standardHours: 1687.5,
	        isFixed: true
	      },
	      planleggingsdager: {
	        id: 'planleggingsdager',
	        title: 'Planleggingsdager',
	        hours: 45,
	        standardHours: 45,
	        isFixed: true
	      },
	      teachingPercentage: {
	        id: 'working_hours',
	        title: 'Undervisningsprosent',
	        hours: 100,
	        standardHours: 100,
	        unit: 'percentage',
	        isFixed: true
	      },
	      standardItems: [{
	        id: 'reduction_employee_percentage',
	        title: 'Stillingsprosenten reduksjon',
	        hours: 0,
	        standardHours: 0,
	        unit: '%',
	        isSelected: false,
	        isHide: true
	      }, {
	        id: 'reduction_newly_educated',
	        title: 'Første yrkesåret etter utdanning',
	        hours: 6,
	        standardHours: 6,
	        unit: '%',
	        isSelected: false
	      }, {
	        id: 'reduction_57_60',
	        title: 'Fra 57 år til og med 59 år',
	        hours: 6,
	        standardHours: 6,
	        unit: '%',
	        isSelected: false
	      }, {
	        id: 'reduction_60',
	        title: '60 år og eldre',
	        hours: 12.5,
	        number: 12.5,
	        year_hours_reduction: 37.5,
	        standardHours: 12.5,
	        unit: '%',
	        isSelected: false
	      }],
	      isEdit: false,
	      isAddNew: false,
	      newItemTitle: '',
	      danishHolidays: ['01-01-2022', '10-04-2022', '14-04-2022', '15-04-2022', '17-04-2022', '18-04-2022', '13-05-2022', '26-05-2022', '05-06-2022', '06-06-2022', '05-06-2022', '24-12-2022', '25-12-2022', '26-12-2022', '31-12-2022', '01-01-2023', '02-04-2023', '06-04-2023', '07-04-2023', '09-04-2023', '10-04-2023', '05-05-2023', '18-05-2023', '28-05-2023', '29-05-2023', '24-12-2023', '25-12-2023', '26-12-2023', '31-12-2023', '01-01-2024', '24-03-2024', '28-03-2024', '29-03-2024', '31-03-2024', '01-04-2024', '09-05-2024', '19-05-2024', '20-05-2024', '25-12-2024', '26-12-2024', '01-01-2025', '13-04-2025', '17-04-2025', '18-04-2025', '20-04-2025', '21-04-2025', '29-05-2025', '08-06-2025', '09-06-2025', '25-12-2025', '26-12-2025', '01-01-2026', '29-03-2026', '02-04-2026', '03-04-2026', '05-04-2026', '06-04-2026', '01-05-2026', '14-05-2026', '24-05-2026', '25-05-2026', '05-06-2026', '24-12-2026', '25-12-2026', '26-12-2026', '31-12-2026']
	    };
	  },
	
	  computed: {
	    workingHoursWithoutPlanleggingsdager: function workingHoursWithoutPlanleggingsdager() {
	      return (this.workingHours.hours - this.planleggingsdager.hours).toFixed(2);
	    },
	    dateRangeFormatted: function dateRangeFormatted() {
	      return (0, _moment2.default)(this.startDate).format('ll') + ' - ' + (0, _moment2.default)(this.endDate).format('ll');
	    },
	    subtractedItems: function subtractedItems() {
	      return this.standardItems.filter(function (item) {
	        return item.isSelected;
	      });
	    },
	    possibleStandardItems: function possibleStandardItems() {
	      return this.standardItems.filter(function (item) {
	        return !item.isSelected && !item.isHide;
	      });
	    },
	    nettoTime: function nettoTime() {
	      return parseFloat(this.workingHours.hours).toFixed(2);
	    },
	    itemsToSave: function itemsToSave() {
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var periodStart = {
	        id: 'period_start',
	        title: 'hidden_periode_start',
	        isChecked: true,
	        value: startDate,
	        hours: startDate
	      };
	      var periodEnd = { id: 'period_end', title: 'hidden_periode_end', isChecked: true, value: endDate, hours: endDate };
	      var periodDates = { title: 'Periode', value: this.dateRangeFormatted };
	      var arr = [periodStart, periodEnd, periodDates];
	      arr.push({ title: this.employmentPercentage.title, value: this.employmentPercentage.hours + '%' });
	      arr.push({ title: 'hidden_stillingsprosenten', hours: this.employmentPercentage.hours });
	      arr.push(this.workingHours);
	      arr.push({ title: this.planleggingsdager.title, hours: this.planleggingsdager.hours * 1 });
	      arr.push({ title: 'Sum af arbedstid i 38 uker', hours: this.workingHoursWithoutPlanleggingsdager * 1 });
	      this.subtractedItems.forEach(function (item) {
	        var hiddenName = 'hidden_reduction_teaching_' + item.id;
	        var hours = item.hours * 1;
	        var value = item.hours + '%';
	        console.log({ value: value });
	        arr.push({ title: hiddenName, value: hours });
	        arr.push({ title: item.title, value: value, dontValidate: true });
	      });
	      return arr;
	    },
	    numberOfSchoolDays: function numberOfSchoolDays() {
	      function isNotWeekend(m) {
	        return (0, _moment2.default)(m).isoWeekday() !== 6 && (0, _moment2.default)(m).isoWeekday() !== 7;
	      }
	
	      var startDate = this.startDate;
	      var endDate = this.endDate;
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        if (isNotWeekend(m)) {
	          dateArray.push(m);
	        }
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray.length;
	    },
	    isOnlyPartOfSchoolYear: function isOnlyPartOfSchoolYear() {
	      var initStartDateFormatted = this.initStartDate.format('YYYY-MM-DD');
	      var startDateFormatted = this.startDate.format('YYYY-MM-DD');
	      var initEndDateFormatted = this.initEndDate.format('YYYY-MM-DD');
	      var endDateFormatted = this.endDate.format('YYYY-MM-DD');
	      return initStartDateFormatted !== startDateFormatted || initEndDateFormatted !== endDateFormatted;
	    }
	  },
	  watch: {
	    itemsToSave: function itemsToSave() {
	      this.$emit('updated', this.itemsToSave);
	    },
	    nettoTime: function nettoTime() {
	      this.$emit('changedSum', this.nettoTime);
	    },
	    theEditUserNorm: function theEditUserNorm() {
	      var _this = this;
	
	      this.isEdit = true;
	      this.standardItems.forEach(function (standardItem, idx) {
	        _this.standardItems[idx].isSelected = false;
	      });
	      this.initStartAndEndDate();
	      this.theEditUserNorm.forEach(function (normItem) {
	        var normItemHours = normItem.value * 1;
	        switch (normItem.title) {
	          case 'Periode start':
	          case 'hidden_periode_start':
	            _this.setStartDate(normItem.value);
	            break;
	          case 'Periode slut':
	          case 'hidden_periode_end':
	            _this.setEndDate(normItem.value);
	            break;
	          case 'Årsværk':
	            _this.workingHours.title = normItem.title;
	            _this.$emit('onEditNetto');
	            _this.workingHours.hours = normItemHours;
	            break;
	          case 'hidden_stillingsprosenten':
	            _this.employmentPercentage.hours = normItemHours;
	            break;
	          case 'Periode':
	          case 'Stillingsprosenten':
	          case 'Arbejdstid':
	            break;
	          default:
	            var idx = _this.standardItems.findIndex(function (item) {
	              return item.title === normItem.title;
	            });
	            if (idx > -1) {
	              _this.standardItems[idx].hours = normItemHours;
	              _this.standardItems[idx].isSelected = true;
	            } else {
	              _this.addOwn(normItem);
	            }
	            break;
	        }
	      });
	    },
	    numberOfSchoolDays: function numberOfSchoolDays() {
	      this.initData();
	    },
	    isNetto: function isNetto() {
	      if (!this.isEdit) {
	        this.initStartAndEndDate();
	      }
	      this.initData();
	    }
	  },
	  methods: {
	    initData: function initData() {
	      if (this.isEdit) {
	        return;
	      }
	      var hoursInPeriod = 1687.5;
	      if (this.isOnlyPartOfSchoolYear) {
	        hoursInPeriod = parseFloat(this.numberOfSchoolDays * 7.5).toFixed(2);
	      }
	      this.workingHours.hours = hoursInPeriod;
	      this.workingHours.standardHours = hoursInPeriod;
	    },
	    setStartDate: function setStartDate(date) {
	      var _this2 = this;
	
	      this.startDate = date;
	      setTimeout(function (_) {
	        _this2.isEdit = false;
	      });
	    },
	    setEndDate: function setEndDate(date) {
	      var _this3 = this;
	
	      this.endDate = date;
	      setTimeout(function (_) {
	        _this3.isEdit = false;
	      });
	    },
	    employmentPercentageChanged: function employmentPercentageChanged(val) {
	      var percentage = val / 100;
	      this.hoursPerWeekChanged(percentage, true);
	    },
	    hoursPerWeekChanged: function hoursPerWeekChanged(val, changePercentage) {
	      var employmentRate = val;
	      var percentage = employmentRate * 100;
	      if (changePercentage) {
	        percentage = percentage.toFixed(0);
	        this.employmentPercentage.hours = percentage;
	      }
	      this.workingHours.hours = parseFloat(this.workingHours.standardHours * employmentRate).toFixed(2);
	      this.planleggingsdager.hours = parseFloat(this.planleggingsdager.standardHours * employmentRate).toFixed(2);
	      var idx = this.standardItems.findIndex(function (standardItem) {
	        return standardItem.id === 'reduction_employee_percentage';
	      });
	      if (percentage < 100) {
	        this.standardItems[idx].hours = 100 - percentage;
	        this.standardItems[idx].isSelected = true;
	      } else {
	        this.standardItems[idx].hours = 0;
	        this.standardItems[idx].isSelected = false;
	      }
	    },
	    onEditWorkingHours: function onEditWorkingHours(value) {
	      this.workingHours.standardHours = value;
	      this.workingHours.isFixed = false;
	    },
	    onEditPlanleggingsdager: function onEditPlanleggingsdager(value) {
	      this.planleggingsdager.standardHours = value;
	      this.planleggingsdager.isFixed = false;
	    },
	    setSubtractedItemValue: function setSubtractedItemValue(item, value) {
	      var idx = this.standardItems.findIndex(function (standardItem) {
	        return standardItem.id === item.id;
	      });
	      if (item.userStandardHours) {
	        this.standardItems[idx].userStandardHours = value * 1;
	      }
	      if (!item.standardHours || item.standardHours * 1 !== value * 1) {
	        this.standardItems[idx].isFixed = false;
	      } else {
	        this.standardItems[idx].isFixed = true;
	      }
	    },
	    setItemValue: function setItemValue(item, idx, value) {
	      if (!this.items[idx].standardHours || this.items[idx].standardHours * 1 !== value * 1) {
	        this.items[idx].isFixed = false;
	      } else {
	        this.items[idx].isFixed = true;
	      }
	    },
	    setIsAddNew: function setIsAddNew(bool) {
	      var _this4 = this;
	
	      if (bool) {
	        this.isAddNew = true;
	        this.$nextTick(function (_) {
	          _this4.$refs.add_new_input.focus();
	        });
	      } else {
	        this.isAddNew = false;
	      }
	    },
	    addFromStandard: function addFromStandard(item) {
	      var idx = this.standardItems.findIndex(function (standardItem) {
	        return standardItem.id === item.id;
	      });
	      this.standardItems[idx].isSelected = true;
	    },
	    addOwn: function addOwn(item) {
	      var newItem = {
	        id: 'reduction_' + new Date().getTime(),
	        title: this.newItemTitle,
	        hours: 0,
	        unit: '%',
	        isFixed: false,
	        isSelected: true,
	        isOwn: true
	      };
	      if (item && item.title) {
	        newItem.id = item.title;
	        newItem.title = item.title;
	        newItem.hours = item.value * 1;
	      }
	      this.standardItems.push(newItem);
	      this.reset();
	    },
	    deleteItem: function deleteItem(item) {
	      var idx = this.standardItems.findIndex(function (standardItem) {
	        return standardItem.id === item.id;
	      });
	      if (item.isOwn) {
	        this.standardItems.splice(idx, 1);
	        return;
	      }
	      this.standardItems[idx].hours = this.standardItems[idx].standardHours;
	      this.standardItems[idx].isFixed = true;
	      this.standardItems[idx].isSelected = false;
	    },
	    reset: function reset() {
	      this.newItemTitle = '';
	      this.isAddNew = false;
	    },
	    initStartAndEndDate: function initStartAndEndDate() {
	      this.startDate = (0, _moment2.default)(this.schoolYear.student_time_start);
	      this.endDate = (0, _moment2.default)(this.schoolYear.student_time_end);
	      this.initStartDate = this.startDate.clone();
	      this.initEndDate = this.endDate.clone();
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.initStartAndEndDate();
	  }
	};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      isShowOnlySubjectsWithoutTeacher: true
	    };
	  },
	
	  computed: {
	    calendars: function calendars() {
	      return this.$store.state.calendars;
	    },
	    klassCalendars: function klassCalendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    calendarsWithProps: function calendarsWithProps() {
	      var _this = this;
	
	      return this.klassCalendars.map(function (calendar) {
	        var arrOfSubjects = _this.tasksInCalendarHash[calendar.id] ? _this.tasksInCalendarHash[calendar.id] : [];
	        var subjects = arrOfSubjects.map(function (id) {
	          return _this.subjectsInHash[id];
	        });
	        var subjectsWithProps = subjects.map(function (subject) {
	          return (0, _extends3.default)({}, subject, {
	            v_has_teacher: _this.subjectHasTeachers(subject),
	            v_has_room: _this.subjectHasRoom(subject),
	            v_teacher_names: _this.getTeacherNames(subject)
	          });
	        });
	        return (0, _extends3.default)({}, calendar, {
	          v_subjects: subjectsWithProps
	        });
	      });
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    tasks: function tasks() {
	      return this.$store.state.subjects.subjects;
	    },
	    filteredTasks: function filteredTasks() {
	      return this.tasks;
	    },
	    sortedTasks: function sortedTasks() {
	      return this.filteredTasks.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    tasksInCalendarHash: function tasksInCalendarHash() {
	      var calsWithSubjectIds = {};
	      this.sortedTasks.forEach(function (subject) {
	        var calId = subject.calendar_id;
	        if (!calsWithSubjectIds[calId]) {
	          calsWithSubjectIds[calId] = [subject.id];
	        } else {
	          calsWithSubjectIds[calId].push(subject.id);
	        }
	      });
	      return calsWithSubjectIds;
	    }
	  },
	  methods: {
	    subjectHasTeachers: function subjectHasTeachers(subject) {
	      var cals = subject.cals ? subject.cals : [];
	      return cals.some(function (cal) {
	        return cal.calendar_type === 'user';
	      });
	    },
	    subjectHasRoom: function subjectHasRoom(subject) {
	      var cals = subject.cals ? subject.cals : [];
	      return cals.some(function (cal) {
	        return cal.calendar_type === 'room';
	      });
	    },
	    getTeacherNames: function getTeacherNames(subject) {
	      var cals = subject.cals ? subject.cals : [];
	      var teachers = cals.filter(function (cal) {
	        return cal.calendar_type === 'user';
	      });
	      return teachers.map(function (cal) {
	        return cal.name;
	      }).join(', ');
	    },
	    setIsCreate: function setIsCreate(calendar) {
	      this.$emit('setIsCreate', calendar);
	    },
	    setEditSubject: function setEditSubject(editSubject) {
	      this.$emit('setEditSubject', editSubject);
	    }
	  }
	};

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SubjectsDistributionUserAgreements = __webpack_require__(83);
	
	var _SubjectsDistributionUserAgreements2 = _interopRequireDefault(_SubjectsDistributionUserAgreements);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    user: {
	      type: Object,
	      default: null
	    },
	    activeNorm: {
	      default: null
	    },
	    activeNormFormatted: {
	      type: Array,
	      default: null
	    }
	  },
	  components: { Loader: _Loader2.default, SubjectsDistributionUserAgreements: _SubjectsDistributionUserAgreements2.default },
	  computed: {
	    planfestet: function planfestet() {
	      var teaching = this.user.v_user_subjects_hours ? this.user.v_user_subjects_hours * 1 : 0;
	      var tasks = this.user.v_user_tasks_hours ? this.user.v_user_tasks_hours * 1 : 0;
	      return (teaching + tasks).toFixed(2);
	    },
	    egenDisponibel: function egenDisponibel() {
	      var teaching = this.user.v_user_subjects_hours ? this.user.v_user_subjects_hours * 1 : 0;
	      var tasks = this.user.v_user_tasks_hours ? this.user.v_user_tasks_hours * 1 : 0;
	      var totalHours = this.user.v_assigned_total_hours ? this.user.v_assigned_total_hours * 1 : 0;
	      return (totalHours - tasks - teaching).toFixed(2);
	    }
	  }
	};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _slicedToArray2 = __webpack_require__(35);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(50);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Tag = __webpack_require__(400);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _AssignHoursAllUsersFlat = __webpack_require__(1448);
	
	var _AssignHoursAllUsersFlat2 = _interopRequireDefault(_AssignHoursAllUsersFlat);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SpinnerButton = __webpack_require__(154);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _vuex = __webpack_require__(14);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _UserEventList = __webpack_require__(1679);
	
	var _UserEventList2 = _interopRequireDefault(_UserEventList);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _UserOverviewTabs = __webpack_require__(403);
	
	var _UserOverviewTabs2 = _interopRequireDefault(_UserOverviewTabs);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _AssignHoursNorm = __webpack_require__(337);
	
	var _AssignHoursNorm2 = _interopRequireDefault(_AssignHoursNorm);
	
	var _DatePickerRangeShortcuts = __webpack_require__(105);
	
	var _DatePickerRangeShortcuts2 = _interopRequireDefault(_DatePickerRangeShortcuts);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _SaveTaskOverview = __webpack_require__(1664);
	
	var _SaveTaskOverview2 = _interopRequireDefault(_SaveTaskOverview);
	
	var _DeleteTaskOverviews = __webpack_require__(1663);
	
	var _DeleteTaskOverviews2 = _interopRequireDefault(_DeleteTaskOverviews);
	
	var _PrintTaskOverviews = __webpack_require__(1529);
	
	var _PrintTaskOverviews2 = _interopRequireDefault(_PrintTaskOverviews);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _AssignHoursEmploymentEnded = __webpack_require__(133);
	
	var _AssignHoursEmploymentEnded2 = _interopRequireDefault(_AssignHoursEmploymentEnded);
	
	var _AssignHoursWorkedHoursStatement = __webpack_require__(339);
	
	var _AssignHoursWorkedHoursStatement2 = _interopRequireDefault(_AssignHoursWorkedHoursStatement);
	
	var _TaskOverviewSettings = __webpack_require__(401);
	
	var _TaskOverviewSettings2 = _interopRequireDefault(_TaskOverviewSettings);
	
	var _AssignHoursDeactivatePoolsModal = __webpack_require__(1449);
	
	var _AssignHoursDeactivatePoolsModal2 = _interopRequireDefault(_AssignHoursDeactivatePoolsModal);
	
	var _AssignHoursEmploymentRates = __webpack_require__(1450);
	
	var _AssignHoursEmploymentRates2 = _interopRequireDefault(_AssignHoursEmploymentRates);
	
	var _AvgTeachingHoursModal = __webpack_require__(1453);
	
	var _AvgTeachingHoursModal2 = _interopRequireDefault(_AvgTeachingHoursModal);
	
	var _AssignHoursTransferRestModal = __webpack_require__(1452);
	
	var _AssignHoursTransferRestModal2 = _interopRequireDefault(_AssignHoursTransferRestModal);
	
	var _ModalPedagogicalSetting = __webpack_require__(1454);
	
	var _ModalPedagogicalSetting2 = _interopRequireDefault(_ModalPedagogicalSetting);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _preparationFactor = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var XLSX = null;
	
	var I18N = {
	  da: {
	    name: 'Navn',
	    workTime: 'Arbejdstid',
	    assigned: 'Tildelt',
	    scheduled: 'Skemalagt',
	    difference: 'Forskel',
	    teaching: 'Undervisning',
	    otherTasks: 'Øvrige Opgaver',
	    preparation: 'Forberedelse',
	    absence: 'Fravær',
	    substitute: 'Vikartimer',
	    sfo: 'SFO',
	    download: 'Download',
	    download_to_excel: 'Download til Excel',
	    updating_numbesr_you_will_be_notified: 'Opdaterer alle tal, du får en notifikation, når alle tal er opdateret.',
	    show_assigned_title: 'Vis tildelt og forskel',
	    show_in_minutes_title: 'Vis skemalagt i minutter',
	    change_view: 'Ændre visningen',
	    employee_id: 'Medarbejder-ID',
	    pool: 'Lokalpulje'
	  },
	  en: {
	    name: 'Name',
	    workTime: 'Work Time',
	    assigned: 'Assigned',
	    scheduled: 'Scheduled',
	    difference: 'Difference',
	    teaching: 'Teaching',
	    otherTasks: 'Other Tasks',
	    preparation: 'Preparation',
	    absence: 'Absence',
	    substitute: 'Substitute',
	    sfo: 'SFO',
	    download: 'Download',
	    download_to_excel: 'Download to Excel',
	    updating_numbers_you_will_be_notified: 'Updating all numbers, you will be notified when everything is updated.',
	    show_assigned_title: 'Show assigned and difference',
	    show_in_minutes_title: 'Show actual hours in minutes',
	    change_view: 'Change view',
	    employee_id: 'Employee id',
	    pool: 'Pool'
	  },
	  nb: {
	    name: 'Navn',
	    workTime: 'Arbeidstid',
	    assigned: 'Tildelt',
	    scheduled: 'Planlagt',
	    difference: 'Forskjell',
	    teaching: 'Undervisning',
	    otherTasks: 'Andre oppgaver',
	    preparation: 'Forberedelse',
	    absence: 'Fravær',
	    substitute: 'Vikartimer',
	    sfo: 'SFO',
	    download: 'Last ned',
	    download_to_excel: 'Last ned til Excel',
	    updating_numbers_you_will_be_notified: 'Oppdaterer alle tall, du vil få en varsling når alle tall er oppdatert.',
	    show_assigned_title: 'Vis tildelt og forskjell',
	    show_in_minutes_title: 'Vis planlagt i minutter',
	    change_view: 'Endre visningen',
	    employee_id: 'Ansatt ID',
	    pool: 'Lokalpulje'
	  }
	};
	
	exports.default = {
	  components: {
	    ModalPedagogicalSetting: _ModalPedagogicalSetting2.default,
	    AssignHoursEmploymentRates: _AssignHoursEmploymentRates2.default,
	    AvgTeachingHoursModal: _AvgTeachingHoursModal2.default,
	    AssignHoursTransferRestModal: _AssignHoursTransferRestModal2.default,
	    AssignHoursDeactivatePoolsModal: _AssignHoursDeactivatePoolsModal2.default,
	    TaskOverviewSettings: _TaskOverviewSettings2.default,
	    AssignHoursEmploymentEnded: _AssignHoursEmploymentEnded2.default,
	    AssignHoursWorkedHoursStatement: _AssignHoursWorkedHoursStatement2.default,
	    DDropdown: _DDropdown2.default,
	    PrintTaskOverviews: _PrintTaskOverviews2.default,
	    SaveTaskOverview: _SaveTaskOverview2.default,
	    DeleteTaskOverviews: _DeleteTaskOverviews2.default,
	    DatePickerRangeShortcuts: _DatePickerRangeShortcuts2.default,
	    AssignHoursNorm: _AssignHoursNorm2.default,
	    DatePickerRange: _DatePickerRange2.default,
	    UserOverviewTabs: _UserOverviewTabs2.default, DModal: _DModal2.default, ShowUserAbsence: _UserEventList2.default, tag: _Tag2.default, Spinner: _Loader2.default, DoFiltersFilter: _DoFiltersFilter2.default, AllUsers: _AssignHoursAllUsersFlat2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, SpinnerButton: _SpinnerButton2.default
	  },
	  data: function data() {
	    return {
	      isModalPedagogicalSetting: false,
	      isShowTaskOverviewSettings: false,
	      isShowEmploymentRatesModal: false,
	      isShowAvgTeachingHoursModal: false,
	      isShowTransferRestModal: false,
	      isDeactivatePoolsModalVisible: false,
	      isShowEmploymentEnded: false,
	      isShowWorkedHoursStatement: false,
	      workedHoursStatementTitle: 'Opgørelse af ansættelse',
	      isSavingPrepFactor: false,
	      isThePrepFactorActive: false,
	      isThePrepFactorForSubstitutePools: false,
	      thePrepFactor: 0.5,
	      isChangePrepFactorModal: false,
	      selectedUsers: [],
	      tags: [],
	      createTagActive: false,
	      searchText: '',
	      appliedFilters: [],
	      usersWithScheduledHours: [],
	      usersWithAssignedHours: [],
	      isInitalLoad: true,
	      activeUserId: null,
	      activeUserEventFilter: 'absence',
	      theUserToShowTasks: null,
	      startDate: null,
	      endDate: null,
	      isLoadingUpdatedNumbers: false,
	      debounceTimer: null,
	      isDownloading: false,
	      allVacationsDays: [],
	      isUpdateBttnLoading: false,
	      isShowPrintTaskOverviewModal: false,
	      isShowSaveVersionTaskOverviewModal: false,
	      isShowDeleteTaskOverviewsModal: false,
	      isChangeViewModal: false,
	      viewSettings: {
	        show_assigned: {
	          title: 'Show assigned and difference',
	          active: true
	        },
	        show_in_minutes: {
	          title: 'Show actual hours in minutes',
	          active: false
	        }
	      }
	    };
	  },
	
	  filters: {
	    yearFormat: function yearFormat(date) {
	      return (0, _moment2.default)(date).format('L');
	    }
	  },
	  watch: {
	    schoolId: function schoolId() {
	      this.$store.dispatch('getUsersFromSchoolId', this.schoolId);
	      this.getTags();
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      this.setEndDate(this.activeSchoolYear.employee_time_end);
	      this.setStartDate(this.activeSchoolYear.employee_time_start);
	    },
	    userSettings: function userSettings(val) {
	      if (val && val.assign_hours_view_setting) {
	        this.updateViewSettingsFromUserSettings();
	      }
	    },
	    schoolPrepFactor: function schoolPrepFactor() {
	      if (this.isChangePrepFactorModal) {
	        this.setIsChangePrepFactorModal(false);
	        this.isSavingPrepFactor = false;
	      }
	    },
	    isPrepFactorForSubstitutePools: function isPrepFactorForSubstitutePools() {
	      if (this.isChangePrepFactorModal) {
	        this.setIsChangePrepFactorModal(false);
	        this.isSavingPrepFactor = false;
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usersSortedOnName', 'teachingHoursPerUser', 'tasksHoursInUserHash', 'preparationHoursInUserHash', 'localPoolHoursInUserHash', 'clubHoursInUserHash', 'schoolId', 'weightedPreparationHoursForCalendarId', 'explicitPrepTaskHoursForCalendarId', 'isAssignedPoolFromNormWhenPoolsDeactivated', 'isSchoolSystem']), {
	    isLoadingSubjects: function isLoadingSubjects() {
	      return this.$store.state.subjects.isLoadingSubjects;
	    },
	    isLoadingTasks: function isLoadingTasks() {
	      return this.$store.state.subjects.isLoadingTasks;
	    },
	    isLoadingSubjectsOrTasks: function isLoadingSubjectsOrTasks() {
	      return this.isLoadingSubjects || this.isLoadingTasks;
	    },
	    usersWithEmployeeId: function usersWithEmployeeId() {
	      return this.usersSortedOnName.filter(function (user) {
	        return user.employee_id;
	      });
	    },
	    viewSettingsI18N: function viewSettingsI18N() {
	      var _this = this;
	
	      var i18nSettings = {};
	      (0, _keys2.default)(this.viewSettings).forEach(function (key) {
	        var setting = (0, _extends3.default)({}, _this.viewSettings[key]);
	        setting.title = _this.i18n[key + '_title'] || setting.title;
	        i18nSettings[key] = setting;
	      });
	      return i18nSettings;
	    },
	    theUser: function theUser() {
	      return this.$store.state.user;
	    },
	    isLocalPoolActivated: function isLocalPoolActivated() {
	      return this.$store.getters.isSchoolFeatureLocalePool;
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool ? this.$store.state.activeSchool : window.SCHOOL ? window.SCHOOL : null;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    localPoolTitle: function localPoolTitle() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || this.$t('vue2.task_overview.pool');
	    },
	    isSchoolDanish: function isSchoolDanish() {
	      return this.activeSchool.country.toLowerCase() === 'dk';
	    },
	    isSchoolFromCO: function isSchoolFromCO() {
	      return this.locale.toLowerCase() === 'en';
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    theUserCanManageAssignedHours: function theUserCanManageAssignedHours() {
	      return this.userHasPermission('can_manage_school');
	    },
	    isDatesPristine: function isDatesPristine() {
	      return this.compareDates(this.activeSchoolYear.employee_time_start, this.startDate) && this.compareDates(this.activeSchoolYear.employee_time_end, this.endDate);
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    selectedSchoolYear: function selectedSchoolYear() {
	      return this.activeSchoolYear.name;
	    },
	    assignHoursTagFiltersStorageKey: function assignHoursTagFiltersStorageKey() {
	      if (this.schoolId == null) {
	        return null;
	      }
	      return 'docendo.assignHours.tagFilters.' + String(this.schoolId);
	    },
	    userTagsToShowSum: function userTagsToShowSum() {
	      return this.$store.getters.userTagsWithoutPrepFactor;
	    },
	    userTagsForSumWorkHours: function userTagsForSumWorkHours() {
	      return this.$store.getters.userTagsForSumWorkHours;
	    },
	    usersForList: function usersForList() {
	      var _this2 = this;
	
	      var getSafe = function getSafe(obj, key) {
	        return obj && obj[key] ? obj[key] : 0;
	      };
	      var toNum = function toNum(val) {
	        if (val === null || val === undefined || val === '') {
	          return 0;
	        }
	        var n = parseFloat(val);
	        return isNaN(n) ? 0 : n;
	      };
	      var toMinutes = function toMinutes(val) {
	        return _this2.viewSettings.show_in_minutes.active ? val * 60 : val;
	      };
	
	      var isPoolsDeactivated = this.isPoolsDeactivated;
	      var isAssignedPoolFromNorm = this.isAssignedPoolFromNormWhenPoolsDeactivated;
	      var userTagsToShowSum = this.userTagsToShowSum;
	      var userTagsForSumWorkHours = this.userTagsForSumWorkHours;
	      var hasEmployeeIds = this.usersWithEmployeeId.length > 0;
	      var usersWithAssignedHours = this.usersWithAssignedHours;
	      var usersWithScheduledHours = this.usersWithScheduledHours;
	      var hoursHashes = isPoolsDeactivated ? {
	        teaching: this.teachingHoursPerUser,
	        tasks: this.tasksHoursInUserHash,
	        club: this.clubHoursInUserHash,
	        localPool: this.localPoolHoursInUserHash,
	        preparation: this.preparationHoursInUserHash,
	        weightedPreparationFor: this.weightedPreparationHoursForCalendarId,
	        explicitPreparationFor: this.explicitPrepTaskHoursForCalendarId
	      } : null;
	
	      return this.usersSortedOnName.map(function (obj) {
	        var id = obj.id;
	        var calId = obj.user_calendar_id;
	        var isUserPedagog = userTagsToShowSum.length === 0 ? false : userTagsToShowSum.some(function (tag) {
	          return obj.user_tags.includes(tag);
	        });
	        var isUserWithSumWorkHours = userTagsForSumWorkHours.length === 0 ? false : userTagsForSumWorkHours.some(function (tag) {
	          return obj.user_tags.includes(tag);
	        });
	
	        var assigned = usersWithAssignedHours[id] || {};
	        var scheduled = usersWithScheduledHours[id] || {};
	
	        var assignedTotalHours = toNum(getSafe(assigned, 'assigned_total_hours'));
	        var substitutePoolHours = toNum(getSafe(assigned, 'substitute_pool_hours'));
	        var totalHoursAssignedInPeriod = assignedTotalHours ? toNum(_this2.getAssignedHoursForPeriod(assigned.assigned_total_hours)) : 0;
	
	        var assignedTeachingHours = 0;
	        var assignedAdditionalTaskHours = 0;
	        var assignedPreparationHours = 0;
	        var assignedClubHours = 0;
	        var assignedPoolHours = 0;
	        var sumHours = 0;
	        var restHours = 0;
	
	        if (!isPoolsDeactivated) {
	          assignedTeachingHours = toNum(getSafe(assigned, 'assigned_teaching_hours'));
	          assignedAdditionalTaskHours = toNum(getSafe(assigned, 'assigned_additional_task_hours'));
	          assignedPreparationHours = toNum(getSafe(assigned, 'assigned_preparation_hours'));
	          assignedClubHours = toNum(getSafe(assigned, 'assigned_club_hours'));
	          assignedPoolHours = toNum(getSafe(assigned, 'assigned_pool_hours'));
	        } else {
	          assignedTeachingHours = toNum(getSafe(hoursHashes.teaching, calId));
	          assignedAdditionalTaskHours = toNum(getSafe(hoursHashes.tasks, calId));
	          assignedPreparationHours = toNum(_this2.getPreparationForUser(assignedTeachingHours, calId, obj, substitutePoolHours, hoursHashes));
	          assignedClubHours = toNum(getSafe(hoursHashes.club, calId));
	          assignedPoolHours = isAssignedPoolFromNorm ? toNum(getSafe(assigned, 'assigned_pool_hours')) : toNum(getSafe(hoursHashes.localPool, calId));
	        }
	        sumHours = assignedTeachingHours + assignedAdditionalTaskHours + assignedPreparationHours + assignedClubHours + assignedPoolHours + substitutePoolHours;
	        restHours = assignedTotalHours - sumHours;
	
	        var actualTeachingHours = getSafe(scheduled, 'actual_teaching_hours');
	        var actualSubstituteHours = getSafe(scheduled, 'actual_substitute_hours');
	        var actualAbsenceHours = getSafe(scheduled, 'actual_absence_hours');
	        var actualAdditionalTaskHours = getSafe(scheduled, 'actual_additional_task_hours');
	        var actualPreparationHours = getSafe(scheduled, 'actual_preparation_hours');
	        var actualClubHours = getSafe(scheduled, 'actual_club_hours');
	        var actualPoolHours = getSafe(scheduled, 'actual_pool_hours');
	
	        var actualTotalHours = isUserWithSumWorkHours ? actualSubstituteHours + actualTeachingHours + actualAdditionalTaskHours + actualPreparationHours + actualClubHours + actualPoolHours : getSafe(scheduled, 'actual_total_hours');
	
	        actualTeachingHours = toMinutes(actualTeachingHours);
	        actualSubstituteHours = toMinutes(actualSubstituteHours);
	        actualAbsenceHours = toMinutes(actualAbsenceHours);
	        actualAdditionalTaskHours = toMinutes(actualAdditionalTaskHours);
	        actualPreparationHours = toMinutes(actualPreparationHours);
	        actualClubHours = toMinutes(actualClubHours);
	        actualPoolHours = toMinutes(actualPoolHours);
	        actualTotalHours = toMinutes(actualTotalHours);
	
	        var user = {
	          id: id,
	          user_calendar_id: calId,
	          v_rest_hours: Math.round(restHours * 100) / 100,
	          img: obj.default_thumb_url,
	          name: obj.name,
	          tags: obj.user_tags,
	          v_total_hours_assigned_in_period: _this2.humanizeNumber(totalHoursAssignedInPeriod),
	          assigned_total_hours: _this2.humanizeNumber(assignedTotalHours),
	          actual_total_hours: _this2.humanizeNumber(actualTotalHours),
	          diff_total_hours: _this2.humanizeNumber(totalHoursAssignedInPeriod - actualTotalHours),
	          assigned_teaching_hours: _this2.humanizeNumber(assignedTeachingHours),
	          actual_teaching_hours: _this2.humanizeNumber(actualTeachingHours),
	          diff_teaching_hours: _this2.humanizeNumber(assignedTeachingHours - actualTeachingHours),
	          substitute_pool_hours: _this2.humanizeNumber(substitutePoolHours),
	          actual_substitute_hours: _this2.humanizeNumber(actualSubstituteHours),
	          diff_substitute_hours: _this2.humanizeNumber(substitutePoolHours - actualSubstituteHours),
	          actual_absence_hours: _this2.humanizeNumber(actualAbsenceHours),
	          assigned_additional_task_hours: _this2.humanizeNumber(assignedAdditionalTaskHours),
	          actual_additional_task_hours: _this2.humanizeNumber(actualAdditionalTaskHours),
	          diff_additional_task_hours: _this2.humanizeNumber(assignedAdditionalTaskHours - actualAdditionalTaskHours),
	          assigned_preparation_hours: _this2.humanizeNumber(assignedPreparationHours),
	          actual_preparation_hours: _this2.humanizeNumber(actualPreparationHours),
	          diff_preparation_hours: _this2.humanizeNumber(assignedPreparationHours - actualPreparationHours),
	          assigned_club_hours: _this2.humanizeNumber(assignedClubHours),
	          actual_club_hours: _this2.humanizeNumber(actualClubHours),
	          diff_club_hours: _this2.humanizeNumber(assignedClubHours - actualClubHours),
	          assigned_pool_hours: _this2.humanizeNumber(assignedPoolHours),
	          actual_pool_hours: _this2.humanizeNumber(actualPoolHours),
	          diff_pool_hours: _this2.humanizeNumber(assignedPoolHours - actualPoolHours),
	          rest_hours: _this2.humanizeNumber(restHours),
	          sum_hours: _this2.humanizeNumber(sumHours)
	        };
	
	        if (hasEmployeeIds) {
	          user.employee_id = obj.employee_id || null;
	        }
	        if (isUserWithSumWorkHours) {
	          user['vIsPedagogog'] = true;
	        }
	        if (isUserPedagog) {
	          user['vNoPrepFactor'] = true;
	        }
	        return user;
	      });
	    },
	    usersWithPositiveRest: function usersWithPositiveRest() {
	      return this.usersForList.filter(function (user) {
	        return user.user_calendar_id && user.v_rest_hours > 0;
	      }).map(function (user) {
	        return {
	          id: user.id,
	          name: user.name,
	          user_calendar_id: user.user_calendar_id,
	          assigned_total_hours: user.assigned_total_hours,
	          rest: user.v_rest_hours
	        };
	      });
	    },
	    searchedUsers: function searchedUsers() {
	      var _this3 = this;
	
	      return this.usersForList.filter(function (user) {
	        return user.name.match(new RegExp(_this3.searchText, 'i'));
	      });
	    },
	    filteredUsers: function filteredUsers() {
	      var _this4 = this;
	
	      if (this.appliedFilters.length === 0) {
	        return this.searchedUsers;
	      }
	      return this.searchedUsers.filter(function (user) {
	        return _this4.appliedFilters.some(function (filter) {
	          return user.tags.indexOf(filter) > -1;
	        });
	      });
	    },
	    isLoadingUsers: function isLoadingUsers() {
	      return this.$store.state.isLoadingAllUsers;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    dataToExcel: function dataToExcel() {
	      var _this5 = this;
	
	      var users = this.filteredUsers.map(function (user) {
	        var userObject = {
	          'name': user.name,
	          'assigned_1': parseFloat(_this5.humanizeNumber(user.assigned_total_hours)),
	          'scheduled_1': parseFloat(user.actual_total_hours),
	          'diff_1': parseFloat(user.diff_total_hours),
	          'assigned_2': parseFloat(user.assigned_teaching_hours),
	          'scheduled_2': parseFloat(user.actual_teaching_hours),
	          'diff_2': parseFloat(user.diff_teaching_hours),
	          'assigned_3': parseFloat(user.assigned_additional_task_hours),
	          'scheduled_3': parseFloat(user.actual_additional_task_hours),
	          'diff_3': parseFloat(user.diff_additional_task_hours),
	          'assigned_4': parseFloat(user.assigned_preparation_hours),
	          'scheduled_4': parseFloat(user.actual_preparation_hours),
	          'diff_4': parseFloat(user.diff_preparation_hours),
	          'assigned_8': parseFloat(user.assigned_pool_hours),
	          'scheduled_8': parseFloat(user.actual_pool_hours),
	          'diff_8': parseFloat(user.diff_pool_hours),
	          'scheduled_5': parseFloat(user.actual_absence_hours),
	          'assigned_6': parseFloat(user.substitute_pool_hours),
	          'scheduled_6': parseFloat(user.actual_substitute_hours),
	          'diff_6': parseFloat(user.diff_substitute_hours),
	          'assigned_7': parseFloat(user.assigned_club_hours),
	          'scheduled_7': parseFloat(user.actual_club_hours),
	          'diff_7': parseFloat(user.diff_club_hours)
	        };
	
	        if (_this5.usersWithEmployeeId.length > 0) {
	          userObject['employee_id'] = user['employee_id'] ? user['employee_id'] : null;
	        }
	        return userObject;
	      });
	      var baseHeaders = {
	        'name': '',
	        'assigned_1': '',
	        'scheduled_1': '',
	        'diff_1': '',
	        'assigned_2': '',
	        'scheduled_2': '',
	        'diff_2': '',
	        'assigned_3': '',
	        'scheduled_3': '',
	        'diff_3': '',
	        'assigned_4': '',
	        'scheduled_4': '',
	        'diff_4': '',
	        'assigned_8': '',
	        'scheduled_8': '',
	        'diff_8': '',
	        'scheduled_5': '',
	        'assigned_6': '',
	        'scheduled_6': '',
	        'diff_6': '',
	        'assigned_7': '',
	        'scheduled_7': '',
	        'diff_7': ''
	      };
	
	      if (this.usersWithEmployeeId.length > 0) {
	        baseHeaders = (0, _extends3.default)({ 'employee_id': 'Employee ID' }, baseHeaders);
	      }
	
	      var headersRow1 = (0, _keys2.default)(baseHeaders).reduce(function (accumulator, currentKey) {
	        accumulator[currentKey] = '';
	        return accumulator;
	      }, {});
	
	      var headersRow2 = (0, _extends3.default)({}, baseHeaders);
	      users.unshift(headersRow2, headersRow1);
	      return users;
	    },
	    workDayDates: function workDayDates() {
	      var self = this;
	
	      function isNotWeekend(m) {
	        return (0, _moment2.default)(m).isoWeekday() !== 6 && (0, _moment2.default)(m).isoWeekday() !== 7;
	      }
	
	      function isNotVacationDay(m) {
	        var idx = self.allVacationsDays.findIndex(function (date) {
	          return (0, _moment2.default)(date.day).format('YYYY-MM-DD') === m;
	        });
	        return idx < 0;
	      }
	
	      var startDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_start).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_end).format('YYYY-MM-DD');
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        if (isNotWeekend(m) && isNotVacationDay(m)) {
	          dateArray.push(m);
	        }
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray;
	    },
	    workDayDatesInPeriod: function workDayDatesInPeriod() {
	      var _this6 = this;
	
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        dateArray.push(m);
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray.filter(function (date) {
	        var m = (0, _moment2.default)(date).format('YYYY-MM-DD');
	        var idx = _this6.workDayDates.indexOf(m);
	        return idx > -1;
	      });
	    },
	    numberOfWorkDays: function numberOfWorkDays() {
	      return this.workDayDates.length;
	    },
	    numberOfWorkDaysInPeriod: function numberOfWorkDaysInPeriod() {
	      return this.workDayDatesInPeriod.length;
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    schoolPrepFactor: function schoolPrepFactor() {
	      return this.schoolSettings && this.schoolSettings['prepFactor'] ? this.schoolSettings['prepFactor'] : null;
	    },
	    isPrepFactorForSubstitutePools: function isPrepFactorForSubstitutePools() {
	      return !!(this.schoolSettings && this.schoolSettings['prepFactorForSubstitutePools']);
	    },
	    schoolThresholdToHideTaskHours: function schoolThresholdToHideTaskHours() {
	      return this.schoolSettings && this.schoolSettings['thresholdToHideTaskHours'] ? this.schoolSettings['thresholdToHideTaskHours'] : null;
	    },
	    isPoolsDeactivated: function isPoolsDeactivated() {
	      return this.schoolSettings && this.schoolSettings['deactivatePools'] ? this.schoolSettings['deactivatePools'] : false;
	    },
	    isShowRestColumn: function isShowRestColumn() {
	      return this.schoolSettings && this.schoolSettings['showRestColumn'] ? this.schoolSettings['showRestColumn'] : false;
	    }
	  }),
	  methods: {
	    setIsModalPedagogicalSetting: function setIsModalPedagogicalSetting(bool) {
	      this.isModalPedagogicalSetting = bool;
	    },
	    getIsUserInGroupWithoutPrepFactor: function getIsUserInGroupWithoutPrepFactor(user) {
	      var groupsWithoutPrepFactor = this.userTagsToShowSum;
	      return user.user_tags.some(function (tag) {
	        return groupsWithoutPrepFactor.includes(tag);
	      });
	    },
	    getPreparationForUser: function getPreparationForUser(assignedTeachingHours, calId, userObj, substitutePoolHours, hoursHashes) {
	      var getSafe = function getSafe(obj, key) {
	        return obj && obj[key] ? obj[key] : 0;
	      };
	      if (this.getIsUserInGroupWithoutPrepFactor(userObj)) {
	        return hoursHashes.explicitPreparationFor(calId);
	      }
	      var prepFactorNum = (0, _preparationFactor.parseNumericPreparationFactor)(this.schoolPrepFactor);
	
	      var substitutePrepHours = this.isPrepFactorForSubstitutePools && prepFactorNum !== null ? (substitutePoolHours || 0) * prepFactorNum : 0;
	      var weighted = hoursHashes.weightedPreparationFor(calId);
	      if (weighted !== null && weighted !== undefined) {
	        return weighted + substitutePrepHours;
	      }
	      if (prepFactorNum !== null) {
	        return assignedTeachingHours * prepFactorNum + substitutePrepHours;
	      }
	      return getSafe(hoursHashes.preparation, calId);
	    },
	    setIsShowEmploymentEnded: function setIsShowEmploymentEnded(bool) {
	      this.isShowEmploymentEnded = bool;
	    },
	    setIsThePrepFactorActive: function setIsThePrepFactorActive() {
	      var _this7 = this;
	
	      this.isThePrepFactorActive = !this.isThePrepFactorActive;
	      if (this.isThePrepFactorActive) {
	        this.$nextTick(function (_) {
	          _this7.$refs.the_prep_factor_input.focus();
	        });
	      }
	    },
	    savePrepFactor: function savePrepFactor() {
	      this.isSavingPrepFactor = true;
	      if (!this.isThePrepFactorActive) {
	        this.$store.dispatch('updateSchoolSettings', { 'prepFactor': null, 'prepFactorForSubstitutePools': null });
	      } else {
	        var val = this.thePrepFactor * 1;
	        if (isNaN(Number(val))) {
	          _eventbus2.default.toast = { text: 'Kan ikke gemme. Skal være et tal', 'success': false };
	          this.isSavingPrepFactor = false;
	          return;
	        }
	        this.$store.dispatch('updateSchoolSettings', {
	          'prepFactor': val,
	          'prepFactorForSubstitutePools': this.isThePrepFactorForSubstitutePools ? true : null
	        });
	      }
	    },
	    setIsChangePrepFactorModal: function setIsChangePrepFactorModal(bool) {
	      this.isChangePrepFactorModal = bool;
	      if (bool && this.schoolPrepFactor) {
	        this.thePrepFactor = this.schoolPrepFactor;
	        this.isThePrepFactorActive = true;
	      }
	      if (bool) {
	        this.isThePrepFactorForSubstitutePools = this.isPrepFactorForSubstitutePools;
	      }
	    },
	    setIsDeactivatePoolsModalVisible: function setIsDeactivatePoolsModalVisible(bool) {
	      this.isDeactivatePoolsModalVisible = bool;
	    },
	    reReadNumbers: function reReadNumbers() {
	      this.isDeactivatePoolsModalVisible = false;
	      this.getUsersHours();
	      this.readSubjectsAndTasks();
	    },
	    updateViewSettingsFromUserSettings: function updateViewSettingsFromUserSettings() {
	      var _this8 = this;
	
	      var val = this.userSettings;
	      if (val && val.assign_hours_view_setting) {
	        var settingsChanged = (0, _entries2.default)(val.assign_hours_view_setting).some(function (_ref) {
	          var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	              key = _ref2[0],
	              setting = _ref2[1];
	
	          if (!_this8.viewSettings[key]) return true;
	          return _this8.viewSettings[key].active !== setting.active || _this8.viewSettings[key].title !== setting.title;
	        }) || (0, _keys2.default)(this.viewSettings).length !== (0, _keys2.default)(val.assign_hours_view_setting).length;
	
	        if (settingsChanged) {
	          this.viewSettings = JSON.parse((0, _stringify2.default)(val.assign_hours_view_setting));
	        }
	      }
	    },
	    setViewSetting: function setViewSetting(key) {
	      if (this.viewSettings[key]) {
	        this.viewSettings[key].active = !this.viewSettings[key].active;
	      }
	
	      this.$store.dispatch('updateUserSettings', { 'assign_hours_view_setting': this.viewSettings });
	    },
	    setIsChangeViewModal: function setIsChangeViewModal() {
	      if (this.isChangeViewModal) {
	        this.isChangeViewModal = false;
	      } else {
	        this.isChangeViewModal = true;
	      }
	    },
	    asyncLoadXLSXAndDownload: function asyncLoadXLSXAndDownload() {
	      var _this9 = this;
	
	      this.isDownloading = true;
	      if (window.XLSX && XLSX) {
	        this.download();
	      } else {
	        var cdnXLSX = document.createElement('script');
	        cdnXLSX.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.mini.min.js');
	        document.head.appendChild(cdnXLSX);
	        var intervalTimer = setInterval(function (_) {
	          if (window.XLSX) {
	            clearInterval(intervalTimer);
	            XLSX = window.XLSX;
	            _this9.download();
	          }
	        }, 500);
	      }
	    },
	    download: function download() {
	      var data = XLSX.utils.json_to_sheet(this.dataToExcel, { skipHeader: true });
	      if (this.usersWithEmployeeId.length === 0) {
	        data.A1 = { t: 's', v: this.i18n.name };
	        data.B1 = { t: 's', v: this.i18n.workTime };
	        data.B2 = { t: 's', v: this.i18n.assigned };
	        data.C2 = { t: 's', v: this.i18n.scheduled };
	        data.D2 = { t: 's', v: this.i18n.difference };
	        data.E1 = { t: 's', v: this.i18n.teaching };
	        data.E2 = { t: 's', v: this.i18n.assigned };
	        data.F2 = { t: 's', v: this.i18n.scheduled };
	        data.G2 = { t: 's', v: this.i18n.difference };
	        data.H1 = { t: 's', v: this.i18n.otherTasks };
	        data.H2 = { t: 's', v: this.i18n.assigned };
	        data.I2 = { t: 's', v: this.i18n.scheduled };
	        data.J2 = { t: 's', v: this.i18n.difference };
	        data.K1 = { t: 's', v: this.i18n.preparation };
	        data.K2 = { t: 's', v: this.i18n.assigned };
	        data.L2 = { t: 's', v: this.i18n.scheduled };
	        data.M2 = { t: 's', v: this.i18n.difference };
	        data.N1 = { t: 's', v: this.localPoolTitle };
	        data.N2 = { t: 's', v: this.i18n.assigned };
	        data.O2 = { t: 's', v: this.i18n.scheduled };
	        data.P2 = { t: 's', v: this.i18n.difference };
	        data.Q1 = { t: 's', v: this.i18n.absence };
	        data.Q2 = { t: 's', v: this.i18n.scheduled };
	        data.R1 = { t: 's', v: this.i18n.substitute };
	        data.R2 = { t: 's', v: this.i18n.assigned };
	        data.S2 = { t: 's', v: this.i18n.scheduled };
	        data.T2 = { t: 's', v: this.i18n.difference };
	        data.U1 = { t: 's', v: this.i18n.sfo };
	        data.U2 = { t: 's', v: this.i18n.assigned };
	        data.V2 = { t: 's', v: this.i18n.scheduled };
	        data.W2 = { t: 's', v: this.i18n.difference };
	
	        var merge = [{ s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, { s: { r: 0, c: 1 }, e: { r: 0, c: 3 } }, { s: { r: 0, c: 4 }, e: { r: 0, c: 6 } }, { s: { r: 0, c: 7 }, e: { r: 0, c: 9 } }, { s: { r: 0, c: 10 }, e: { r: 0, c: 12 } }, { s: { r: 0, c: 13 }, e: { r: 0, c: 15 } }, { s: { r: 0, c: 16 }, e: { r: 1, c: 16 } }, { s: { r: 0, c: 17 }, e: { r: 0, c: 19 } }, { s: { r: 0, c: 20 }, e: { r: 0, c: 22 } }];
	        data['!merges'] = merge;
	      } else {
	        data.A1 = { t: 's', v: this.i18n.employee_id };
	        data.B1 = { t: 's', v: this.i18n.name };
	        data.C1 = { t: 's', v: this.i18n.workTime };
	        data.C2 = { t: 's', v: this.i18n.assigned };
	        data.D2 = { t: 's', v: this.i18n.scheduled };
	        data.E2 = { t: 's', v: this.i18n.difference };
	        data.F1 = { t: 's', v: this.i18n.teaching };
	        data.F2 = { t: 's', v: this.i18n.assigned };
	        data.G2 = { t: 's', v: this.i18n.scheduled };
	        data.H2 = { t: 's', v: this.i18n.difference };
	        data.I1 = { t: 's', v: this.i18n.otherTasks };
	        data.I2 = { t: 's', v: this.i18n.assigned };
	        data.J2 = { t: 's', v: this.i18n.scheduled };
	        data.K2 = { t: 's', v: this.i18n.difference };
	        data.L1 = { t: 's', v: this.i18n.preparation };
	        data.L2 = { t: 's', v: this.i18n.assigned };
	        data.M2 = { t: 's', v: this.i18n.scheduled };
	        data.N2 = { t: 's', v: this.i18n.difference };
	        data.O1 = { t: 's', v: this.i18n.absence };
	        data.O2 = { t: 's', v: this.i18n.scheduled };
	        data.P1 = { t: 's', v: this.i18n.substitute };
	        data.P2 = { t: 's', v: this.i18n.assigned };
	        data.Q2 = { t: 's', v: this.i18n.scheduled };
	        data.R2 = { t: 's', v: this.i18n.difference };
	        data.S1 = { t: 's', v: this.i18n.sfo };
	        data.S2 = { t: 's', v: this.i18n.assigned };
	        data.T2 = { t: 's', v: this.i18n.scheduled };
	        data.U2 = { t: 's', v: this.i18n.difference };
	
	        var _merge = [{ s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }, { s: { r: 0, c: 2 }, e: { r: 0, c: 4 } }, { s: { r: 0, c: 5 }, e: { r: 0, c: 7 } }, { s: { r: 0, c: 8 }, e: { r: 0, c: 10 } }, { s: { r: 0, c: 11 }, e: { r: 0, c: 13 } }, { s: { r: 0, c: 14 }, e: { r: 0, c: 14 } }, { s: { r: 0, c: 15 }, e: { r: 0, c: 17 } }, { s: { r: 0, c: 18 }, e: { r: 0, c: 20 } }];
	        data['!merges'] = _merge;
	      }
	      var wb = XLSX.utils.book_new();
	      XLSX.utils.book_append_sheet(wb, data, 'data');
	      XLSX.writeFile(wb, 'docendo_tildel_timer.xlsx');
	      this.isDownloading = false;
	    },
	    getAssignedHoursForPeriod: function getAssignedHoursForPeriod(hours) {
	      if (this.isDatesPristine) {
	        return hours;
	      } else {
	        var hoursPerDay = hours / this.numberOfWorkDays;
	        return hoursPerDay * this.numberOfWorkDaysInPeriod;
	      }
	    },
	    humanizeNumber: function humanizeNumber(num) {
	      return parseFloat(num).toFixed(1);
	    },
	    debounceSearch: function debounceSearch(event) {
	      var _this10 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        _this10.searchText = event.target.value;
	      }, 400);
	    },
	    resetDates: function resetDates() {
	      this.setEndDate(this.activeSchoolYear.employee_time_end, false);
	      this.setStartDate(this.activeSchoolYear.employee_time_start);
	    },
	    setDatesFromRange: function setDatesFromRange(dateRange) {
	      this.setDates(dateRange.start, dateRange.end);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.startDate = start;
	      }
	      if (end) {
	        this.endDate = end;
	      }
	      this.getUsersActualHours();
	    },
	    setStartDate: function setStartDate(date) {
	      var isUnchanged = this.startDate && this.compareDates(this.startDate, date);
	      this.startDate = date;
	      if (!isUnchanged && (0, _moment2.default)(date).isValid()) {
	        this.getUsersHours();
	      }
	    },
	    setEndDate: function setEndDate(date, isCallServer) {
	      var isUnchanged = this.endDate && this.compareDates(this.endDate, date);
	      this.endDate = date;
	      if (!isCallServer || isUnchanged) {
	        return;
	      }
	      if ((0, _moment2.default)(date).isValid()) {
	        this.getUsersHours();
	      }
	    },
	    setTheUserToShowTasks: function setTheUserToShowTasks(user) {
	      if (this.allUsersInHash[user.id]) {
	        this.theUserToShowTasks = this.allUsersInHash[user.id];
	      }
	    },
	    closeTheUserToShowTasks: function closeTheUserToShowTasks() {
	      this.theUserToShowTasks = null;
	    },
	    setActiveUser: function setActiveUser(userAndFilter) {
	      this.activeUserId = userAndFilter.user.id;
	      this.activeUserEventFilter = userAndFilter.filter;
	    },
	    updateUserHours: function updateUserHours() {
	      var _this11 = this;
	
	      _eventbus2.default.toast = { text: this.i18n['updating_numbesr_you_will_be_notified'], 'success': false };
	      if (this.isUpdateBttnLoading) {
	        return;
	      }
	      this.isUpdateBttnLoading = true;
	      _docendo2.default.schoolRecalculateAll(this.schoolId, function (data) {
	        _this11.getUsersHours();
	        _this11.isUpdateBttnLoading = false;
	      }, function (error) {
	        console.log('error', error);
	      });
	    },
	    toggleTagFilter: function toggleTagFilter(tag) {
	      var idx = this.appliedFilters.indexOf(tag);
	      if (idx > -1) {
	        this.appliedFilters.splice(idx, 1);
	      } else {
	        this.appliedFilters.push(tag);
	      }
	      this.persistAppliedTagFilters();
	    },
	    clearTagFilters: function clearTagFilters() {
	      this.appliedFilters = [];
	      this.persistAppliedTagFilters();
	    },
	    persistAppliedTagFilters: function persistAppliedTagFilters() {
	      var key = this.assignHoursTagFiltersStorageKey;
	      if (!key) {
	        return;
	      }
	      this.$helpers.setLocalStorage(key, (0, _stringify2.default)(this.appliedFilters));
	    },
	    restoreAppliedTagFiltersFromStorage: function restoreAppliedTagFiltersFromStorage() {
	      var _this12 = this;
	
	      var key = this.assignHoursTagFiltersStorageKey;
	      if (!key) {
	        return;
	      }
	      var raw = this.$helpers.getLocalStorage(key);
	      if (!raw) {
	        return;
	      }
	      var parsed = null;
	      try {
	        parsed = JSON.parse(raw);
	      } catch (e) {
	        return;
	      }
	      if (!Array.isArray(parsed)) {
	        return;
	      }
	      this.appliedFilters = parsed.filter(function (tag) {
	        return _this12.tags.indexOf(tag) > -1;
	      });
	    },
	    toggleShowRestColumn: function toggleShowRestColumn() {
	      if (this.isShowRestColumn) {
	        this.$store.dispatch('deleteSchoolSetting', 'showRestColumn');
	      } else {
	        this.$store.dispatch('updateSchoolSettings', { 'showRestColumn': true });
	      }
	    },
	    removeAllSelectedUsers: function removeAllSelectedUsers() {
	      this.selectedUsers = [];
	      this.createTagActive = false;
	    },
	    setUser: function setUser(user, idx) {
	      if (this.selectedUsers.indexOf(user.id) > -1) {
	        this.selectedUsers.splice(this.selectedUsers.indexOf(user.id), 1);
	      } else {
	        this.selectedUsers.push(user.id);
	      }
	    },
	    setAllUsersSelected: function setAllUsersSelected() {
	      this.selectedUsers = [];
	      for (var i = 0; i < this.filteredUsers.length; i++) {
	        this.selectedUsers.push(this.filteredUsers[i].id);
	      }
	    },
	    updatedUser: function updatedUser(user) {
	      var id = user.user_id.toString();
	      this.$set(this.usersWithAssignedHours, id, user);
	    },
	    getTags: function getTags() {
	      var _this13 = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this13.tags = data;
	        _this13.restoreAppliedTagFiltersFromStorage();
	      });
	    },
	    getUsersActualHours: function getUsersActualHours() {
	      var _this14 = this;
	
	      this.isLoadingUpdatedNumbers = true;
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD') + ' 00:00';
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD') + ' 23:59';
	      _docendo2.default.schoolActualHours(this.schoolId, startDate, endDate, null, function (data) {
	        var newUsers = {};
	        for (var i = 0; i < data.length; i++) {
	          newUsers[data[i].user_id] = data[i];
	        }
	        _this14.usersWithScheduledHours = newUsers;
	        _this14.isLoadingUpdatedNumbers = false;
	      });
	    },
	    getUsersHours: function getUsersHours() {
	      var _this15 = this;
	
	      this.getUsersActualHours();
	      _docendo2.default.schoolAssignedHours(this.schoolId, this.selectedSchoolYear, null, function (data) {
	        var newUsers = {};
	        for (var i = 0; i < data.length; i++) {
	          newUsers[data[i].user_id] = data[i];
	        }
	        _this15.usersWithAssignedHours = newUsers;
	        _this15.isInitalLoad = false;
	      });
	      this.readSubjectsAndTasks();
	    },
	    readSubjectsAndTasks: function readSubjectsAndTasks() {
	      if (this.isPoolsDeactivated) {
	        this.$store.dispatch('readSubjects', this.activeSchoolYear.id);
	      }
	    },
	    compareDates: function compareDates(firstDate, secondDate) {
	      return (0, _moment2.default)(firstDate).format('YYYY-MM-DD') === (0, _moment2.default)(secondDate).format('YYYY-MM-DD');
	    },
	    readVacationDays: function readVacationDays() {
	      var _this16 = this;
	
	      _docendo2.default.schoolVacationDaysRead(window.SCHOOL.id, function (success) {
	        if (success.status !== 'error') {
	          _this16.allVacationsDays = success;
	        }
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.theUser) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.theUser.admin;
	      } else {
	        return true;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUsersFromSchoolId', this.activeSchool.id);
	    this.readVacationDays();
	    this.getTags();
	  },
	  mounted: function mounted() {
	    if (this.activeSchoolYear) {
	      this.setEndDate(this.activeSchoolYear.employee_time_end, false);
	      this.setStartDate(this.activeSchoolYear.employee_time_start);
	    }
	    this.updateViewSettingsFromUserSettings();
	  }
	};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _core = __webpack_require__(25);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _assignedPoolWhenPoolsDeactivated = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    tooltip: {
	      hours: 'timer',
	      days: 'dage',
	      work_days: 'arbejdsdage',
	      per_day: 'pr. dag',
	      calculation: 'Beregning',
	      forYear: 'For året:',
	      forPeriod: 'For perioden:',
	      explanation: '<p><i>Når du vælger et andet datointerval end hele perioden, kan du her se, hvor mange timer, der i gennemsnit skal planlægges for medarbejderen i perioden og per dag. Udregningen er baseret på antal arbejdsdage angivet for personalet, fratrukket weekender, feriedage og helligdage i \'Feriekalender\'</p>'
	    }
	  },
	  nb: {
	    tooltip: {
	      hours: 'timer',
	      days: 'dager',
	      per_day: 'per dag',
	      work_days: 'arbeidsdager',
	      calculation: 'Beregning',
	      forYear: 'For året:',
	      forPeriod: 'For perioden:',
	      explanation: '<p><i>Når du velger et annet datointerval enn hele året, kan du her se, hvor mange timer som skal planlegges for medarbeideren i perioden og i gjennomsnitt per dag. Beregningen trekker helger og ferie- og helligdager fra.</i></p>'
	    }
	  },
	  en: {
	    tooltip: {
	      hours: 'hours',
	      days: 'days',
	      per_day: 'per day',
	      work_days: 'work days',
	      calculation: 'Calculation',
	      forYear: 'For the year:',
	      forPeriod: 'For the period:',
	      explanation: '<p><i>When you choose a different date range than the whole year, you can see here how many hours need to be planned for the employee in the period and on average per day. The calculation subtracts weekends and holidays.</i></p>'
	    }
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    theUserCanManageAssignedHours: {
	      default: false
	    },
	    schoolid: {},
	    users: {
	      type: Array,
	      default: []
	    },
	    isDatesPristine: {
	      type: Boolean,
	      default: true
	    },
	    isLocalPoolActivated: {
	      type: Boolean,
	      default: false
	    },
	    numberOfWorkDaysInPeriod: {
	      required: true
	    },
	    numberOfWorkDays: {
	      required: true
	    },
	    locale: {
	      default: 'en'
	    },
	    viewSettings: {
	      type: Object
	    },
	    isPoolsDeactivated: {
	      type: Boolean,
	      default: false
	    },
	    isShowRestColumn: {
	      type: Boolean,
	      default: false
	    },
	    prepFactor: {
	      default: null
	    },
	    isPrepFactorForSubstitutePools: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      sortKey: 'name',
	      sortOrder: 1,
	      theEditNumberUserId: null,
	      theEditNumberType: '',
	      theEditNumberNumber: 0,
	      isDropdownPopperDone: false,
	      isUpdatingNumber: false
	    };
	  },
	
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        el.focus();
	        el.select();
	      }
	    }
	  },
	  computed: {
	    isAssignedPoolFromNormWhenPoolsDeactivated: function isAssignedPoolFromNormWhenPoolsDeactivated() {
	      return this.$store.getters.isAssignedPoolFromNormWhenPoolsDeactivated;
	    },
	    numberOfCols: function numberOfCols() {
	      var isShowAssignedActivated = this.viewSettings['show_assigned']['active'];
	      return isShowAssignedActivated ? 3 : 1;
	    },
	    isSFOActive: function isSFOActive() {
	      return this.$store.getters.isSchoolSFOActive;
	    },
	    filteredData: function filteredData() {
	      var sortKey = this.sortKey;
	      var order = this.sortOrder;
	      var data = this.users;
	      if (sortKey && sortKey !== 'name') {
	        data = data.sort(function (a, b) {
	          a = a[sortKey];
	          b = b[sortKey];
	          if (order < 0) {
	            return a - b;
	          } else {
	            return b - a;
	          }
	        });
	      } else {
	        return this.$helpers.sortArrOnName(data);
	      }
	      return data;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isSchoolYearWithNewEmploymentDeal: function isSchoolYearWithNewEmploymentDeal() {
	      return (0, _moment2.default)(this.$store.state.localActivatedSchoolYear.employee_time_start).isAfter('2021-01-01') || (0, _moment2.default)(this.$store.state.localActivatedSchoolYear.student_time_start).isAfter('2021-01-01');
	    },
	    localPoolTitle: function localPoolTitle() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || this.$t('vue2.task_overview.pool');
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    isShowPrepFactorCalculation: function isShowPrepFactorCalculation() {
	      return this.prepFactor !== null && this.isPoolsDeactivated && this.locale === 'da';
	    },
	    isShowRestColumnFinal: function isShowRestColumnFinal() {
	      return this.isPoolsDeactivated || this.isShowRestColumn;
	    }
	  },
	  methods: {
	    createPopper: function createPopper(parentPopper, childPopper) {
	      parentPopper.appendChild(childPopper);
	    },
	    setOpenEdit: function setOpenEdit(obj) {
	      var _this = this;
	
	      this.isDropdownPopperDone = false;
	      this.theEditNumberUserId = obj.userId;
	      this.theEditNumberType = obj.type;
	      this.theEditNumberNumber = obj.number;
	      this.$nextTick(function (_) {
	        _this.createPopper(obj.evt.target, _this.$refs.popper_child);
	        _this.isDropdownPopperDone = true;
	      });
	    },
	    sortBy: function sortBy(key) {
	      this.sortKey = key;
	      this.sortOrder = this.sortOrder * -1;
	    },
	    updatedUser: function updatedUser(user) {
	      this.$emit('updatedUser', user);
	    },
	    setActiveUser: function setActiveUser(userAndFilter) {
	      this.$emit('setActiveUser', userAndFilter);
	    },
	    setTheUserToShowTasks: function setTheUserToShowTasks(user) {
	      this.$emit('setTheUserToShowTasks', user);
	    },
	    closeEditing: function closeEditing() {
	      this.isDropdownPopperDone = false;
	      this.theEditNumberUserId = null;
	      this.theEditNumberType = '';
	      this.theEditNumberNumber = 0;
	    },
	    doneEditing: function doneEditing() {
	      this.docendoEditHours();
	    },
	    docendoEditHours: function docendoEditHours() {
	      var _this2 = this;
	
	      this.isUpdatingNumber = true;
	      var key = this.theEditNumberType;
	      var updateVal = (0, _defineProperty3.default)({}, key, this.theEditNumberNumber);
	      var user = this.users.find(function (user) {
	        return user.id === _this2.theEditNumberUserId;
	      });
	      var isEditingTeaching = key === 'assigned_teaching_hours';
	
	      var isEditingSubstituteWithPrep = this.isPrepFactorForSubstitutePools && key === 'substitute_pool_hours' && !this.isPoolsDeactivated;
	      var updatePrepWithPrepFactor = this.prepFactor && (isEditingTeaching || isEditingSubstituteWithPrep) && !user.vNoPrepFactor;
	      var thePrep = null;
	      if (updatePrepWithPrepFactor) {
	        var _updateVal2;
	
	        var toNum = function toNum(val) {
	          var n = parseFloat(val);
	          return isNaN(n) ? 0 : n;
	        };
	        var teachingHours = isEditingTeaching ? toNum(this.theEditNumberNumber) : toNum(user.assigned_teaching_hours);
	        var substituteHours = this.isPrepFactorForSubstitutePools ? key === 'substitute_pool_hours' ? toNum(this.theEditNumberNumber) : toNum(user.substitute_pool_hours) : 0;
	        thePrep = parseFloat(((teachingHours + substituteHours) * this.prepFactor).toFixed(2));
	        updateVal = (_updateVal2 = {}, (0, _defineProperty3.default)(_updateVal2, key, this.theEditNumberNumber), (0, _defineProperty3.default)(_updateVal2, 'assigned_preparation_hours', thePrep), _updateVal2);
	      }
	      _docendo2.default.schoolUserYearUpdate(this.schoolid, this.theEditNumberUserId, this.activeSchoolYear.name, updateVal, function (success) {
	        if (updatePrepWithPrepFactor) {
	          _eventbus2.default.toast = {
	            text: 'Gemt & automatisk opdateret forberedelsestid til ' + thePrep + ' timer',
	            'success': true
	          };
	        }
	        _this2.isUpdatingNumber = false;
	        _this2.closeEditing();
	        _this2.$emit('updatedUser', success);
	      });
	    },
	    isPoolHoursEditableWhenPoolsDeactivated: function isPoolHoursEditableWhenPoolsDeactivated(type) {
	      return (0, _assignedPoolWhenPoolsDeactivated.isPoolHoursEditableWhenPoolsDeactivated)(type, this.$store.state.schoolSettings);
	    },
	    setTheUserToShowTasksFor: function setTheUserToShowTasksFor(user) {
	      this.$emit('setTheUserToShowTasks', user);
	    },
	    setActiveUserFor: function setActiveUserFor(user, filter) {
	      this.$emit('setActiveUser', { user: user, filter: filter });
	    },
	    openEditFromRow: function openEditFromRow(user, num, type, evt) {
	      if (!this.theUserCanManageAssignedHours || this.isPoolsDeactivated && !this.isPoolHoursEditableWhenPoolsDeactivated(type)) {
	        return;
	      }
	      this.setOpenEdit({
	        userId: user.id,
	        number: num,
	        type: type,
	        evt: evt
	      });
	    },
	    getPrepFactorTooltipContent: function getPrepFactorTooltipContent(user) {
	      if (user.vNoPrepFactor) {
	        return 'Ingen foredelsesfaktor for denne gruppe';
	      }
	      if (this.isPoolsDeactivated && this.locale === 'da') {
	        if (this.isPrepFactorForSubstitutePools) {
	          return user.assigned_teaching_hours + ' UV-timer med forberedelsesfaktor (skole / fag / opgave) + ' + user.substitute_pool_hours + ' vikartimer * ' + this.prepFactor;
	        }
	        return user.assigned_teaching_hours + ' UV-timer med forberedelsesfaktor (skole / fag / opgave)';
	      }
	      if (this.isPrepFactorForSubstitutePools) {
	        return '(' + user.assigned_teaching_hours + ' UV-timer + ' + user.substitute_pool_hours + ' vikartimer) * ' + this.prepFactor + ' forberedelsesfaktor';
	      }
	      return user.assigned_teaching_hours + ' UV-timer * ' + this.prepFactor + ' forberedelsesfaktor';
	    },
	    numToFixed: function numToFixed(num) {
	      return parseFloat(num).toFixed(2);
	    },
	    createTooltip: function createTooltip(sumForYear) {
	      var hoursInYear = this.numberOfWorkDays;
	      var hoursPerDay = sumForYear / hoursInYear;
	      var hoursForPeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      var hoursPerDayFixed = this.numToFixed(hoursPerDay);
	      var hoursForPeriodFixed = this.numToFixed(hoursForPeriod);
	      return this.i18n.tooltip.explanation + '<br></p><p><b>' + this.i18n.tooltip.calculation + '</b></p><p>' + this.i18n.tooltip.forYear + ' ' + sumForYear + ' ' + this.i18n.tooltip.hours + ' / ' + hoursInYear + ' ' + this.i18n.tooltip.days + ' = ' + hoursPerDayFixed + ' ' + this.i18n.tooltip.hours + ' ' + this.i18n.tooltip.per_day + '</p><p>' + this.i18n.tooltip.forPeriod + ' ' + this.numberOfWorkDaysInPeriod + ' ' + this.i18n.tooltip.work_days + ' * ' + hoursPerDayFixed + ' ' + this.i18n.tooltip.hours + ' ' + this.i18n.tooltip.per_day + ' = ' + hoursForPeriodFixed + ' ' + this.i18n.tooltip.hours + '</p>';
	    },
	    scaleIndicator: function scaleIndicator(diff) {
	      var color = 'rgba(62, 207, 142, 0.4)';
	      var newDiff = parseFloat(diff);
	      var indicatorPercentage = parseFloat(newDiff.toFixed(0));
	      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
	        indicatorPercentage = '0' + indicatorPercentage;
	      }
	      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
	        indicatorPercentage = '0' + indicatorPercentage * -1;
	      }
	      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
	        indicatorPercentage = indicatorPercentage * -1;
	      }
	      if (newDiff === 0) {
	        color = 'transparent';
	      }
	      if (newDiff < 0) {
	        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff < -99) {
	        color = 'rgba(250, 86, 90, 1)';
	      }
	      if (newDiff > 0) {
	        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff > 99) {
	        color = 'rgba(62, 207, 142, 1)';
	      }
	      return { '--bgScaleColor': color };
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$refs.popper_child) {
	      this.$refs.popper_child.remove();
	    }
	  }
	};

/***/ }),
/* 472 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    activeSortKey: {
	      type: String
	    },
	    sortProp: {
	      type: String
	    },
	    title: {
	      type: String
	    }
	  },
	  methods: {
	    sortBy: function sortBy() {
	      this.$emit('sortby', this.sortProp);
	    }
	  }
	};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _vuex = __webpack_require__(14);
	
	var _assignedPoolWhenPoolsDeactivated = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    isPoolsDeactivated: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isDeactivatePoolsActive: false,
	      isAssignedPoolFromNormActive: false,
	      isSaving: false,
	      deactivatePoolsSettingKey: 'deactivatePools'
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['canConfigureAssignedPoolNormWhenPoolsDeactivated', 'localPoolTitle'])),
	  watch: {
	    isPoolsDeactivated: function isPoolsDeactivated(val, oldVal) {
	      if (val === oldVal) {
	        return;
	      }
	      this.$emit('reReadNumbers');
	      _eventbus2.default.toast = { text: 'Gemt for skolen', 'success': true };
	    }
	  },
	  methods: {
	    setDeactivatePoolsActive: function setDeactivatePoolsActive() {
	      var _this = this;
	
	      this.isDeactivatePoolsActive = !this.isDeactivatePoolsActive;
	      if (!this.isDeactivatePoolsActive) {
	        this.isAssignedPoolFromNormActive = false;
	      }
	      setTimeout(function (_) {
	        _this.onSaveDeactivatePools();
	      }, 250);
	    },
	    setAssignedPoolFromNormActive: function setAssignedPoolFromNormActive() {
	      var _this2 = this;
	
	      this.isAssignedPoolFromNormActive = !this.isAssignedPoolFromNormActive;
	      setTimeout(function (_) {
	        _this2.onSaveAssignedPoolFromNorm();
	      }, 250);
	    },
	    onSaveDeactivatePools: function onSaveDeactivatePools() {
	      this.isSaving = true;
	      if (!this.isDeactivatePoolsActive) {
	        var _$store$dispatch;
	
	        this.$store.dispatch('updateSchoolSettings', (_$store$dispatch = {}, (0, _defineProperty3.default)(_$store$dispatch, this.deactivatePoolsSettingKey, null), (0, _defineProperty3.default)(_$store$dispatch, _assignedPoolWhenPoolsDeactivated.ASSIGNED_POOL_FROM_NORM_SETTING_KEY, null), _$store$dispatch));
	      } else {
	        this.$store.dispatch('updateSchoolSettings', (0, _defineProperty3.default)({}, this.deactivatePoolsSettingKey, true));
	      }
	    },
	    onSaveAssignedPoolFromNorm: function onSaveAssignedPoolFromNorm() {
	      if (!this.isDeactivatePoolsActive) {
	        return;
	      }
	      this.isSaving = true;
	      if (!this.isAssignedPoolFromNormActive) {
	        this.$store.dispatch('deleteSchoolSetting', _assignedPoolWhenPoolsDeactivated.ASSIGNED_POOL_FROM_NORM_SETTING_KEY);
	      } else {
	        this.$store.dispatch('updateSchoolSettings', (0, _defineProperty3.default)({}, _assignedPoolWhenPoolsDeactivated.ASSIGNED_POOL_FROM_NORM_SETTING_KEY, true));
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.isPoolsDeactivated) {
	      this.isDeactivatePoolsActive = true;
	    }
	    if (this.$store.getters.isAssignedPoolFromNormWhenPoolsDeactivated) {
	      this.isAssignedPoolFromNormActive = true;
	    }
	  }
	};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(14);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ChangeSchoolYear: _ChangeSchoolYear2.default, DatePickerRange: _DatePickerRange2.default },
	  props: {
	    schoolId: {},
	    users: {
	      type: Array,
	      default: []
	    }
	  },
	  data: function data() {
	    return {
	      hoursPerWeek: 37,
	      userData: null,
	      isLoadingUpdatedNumbers: false,
	      theSelectedUserId: null,
	      numberOfVacationDays: 0,
	      startDate: (0, _moment2.default)().startOf('year').format('YYYY-MM-DD'),
	      endDate: (0, _moment2.default)().endOf('year').format('YYYY-MM-DD') };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    holidaysWithinActiveSchoolYear: 'holidaysWithinActiveSchoolYear'
	  }), {
	    hoursPerDay: function hoursPerDay() {
	      return this.hoursPerWeek / 5;
	    },
	    userActualHours: function userActualHours() {
	      return this.userData && this.userData[0].actual_total_hours ? (this.userData[0].actual_total_hours * 1).toFixed(1) : 0;
	    },
	    userActualHoursDiff: function userActualHoursDiff() {
	      return (this.userActualHours * 1 - this.numberOfWorkDaysPossibleInHours * 1).toFixed(2);
	    },
	    theSelectedUser: function theSelectedUser() {
	      var _this = this;
	
	      return this.theSelectedUserId ? this.users.find(function (user) {
	        return user.id === _this.theSelectedUserId;
	      }) : null;
	    },
	    numberOfWorkDaysPossible: function numberOfWorkDaysPossible() {
	      return this.numberOfDaysWithoutWeekendsAndHolidays - this.numberOfVacationDays;
	    },
	    numberOfWorkDaysPossibleInHours: function numberOfWorkDaysPossibleInHours() {
	      return (this.numberOfWorkDaysPossible * this.hoursPerDay).toFixed(1);
	    },
	    numberOfVacationDaysInHours: function numberOfVacationDaysInHours() {
	      return (this.numberOfVacationDays * this.hoursPerDay).toFixed(1);
	    },
	    filteredHolidays: function filteredHolidays() {
	      return this.holidaysWithinActiveSchoolYear(this.startDate, this.endDate);
	    },
	    hasAnyHolidays: function hasAnyHolidays() {
	      return this.filteredHolidays.length > 0;
	    },
	    holidaysAsLabels: function holidaysAsLabels() {
	      return this.filteredHolidays.join(', ');
	    },
	    filteredHolidaysInHours: function filteredHolidaysInHours() {
	      return (this.filteredHolidays.length * this.hoursPerDay).toFixed(1);
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isDatesPristine: function isDatesPristine() {
	      return this.compareDates(this.activeSchoolYear.employee_time_start, this.startDate) && this.compareDates(this.activeSchoolYear.employee_time_end, this.endDate);
	    },
	    numberOfDays: function numberOfDays() {
	      var start = (0, _moment2.default)(this.startDate).startOf('day');
	      var end = (0, _moment2.default)(this.endDate).endOf('day');
	      var diff = end.diff(start, 'day');
	      return diff + 1;
	    },
	    numberOfDaysWithoutWeekendsInHours: function numberOfDaysWithoutWeekendsInHours() {
	      return (this.numberOfDaysWithoutWeekends * this.hoursPerDay).toFixed(1);
	    },
	    numberOfDaysWithoutWeekends: function numberOfDaysWithoutWeekends() {
	      var diff = this.numberOfDays;
	      var newDate = (0, _moment2.default)(this.startDate);
	      var weekdaysCount = 0;
	      for (var i = 0; i < diff; i++) {
	        if (newDate.isoWeekday() !== 6 && newDate.isoWeekday() !== 7) {
	          weekdaysCount++;
	        }
	        newDate = (0, _moment2.default)(newDate).add(1, 'days');
	      }
	      return weekdaysCount;
	    },
	    numberOfDaysWithoutWeekendsAndHolidays: function numberOfDaysWithoutWeekendsAndHolidays() {
	      return this.numberOfDaysWithoutWeekends - this.filteredHolidays.length;
	    },
	    numberOfDaysWithoutWeekendsAndHolidaysInHours: function numberOfDaysWithoutWeekendsAndHolidaysInHours() {
	      return (this.numberOfDaysWithoutWeekendsAndHolidays * this.hoursPerDay).toFixed(1);
	    },
	    summary: function summary() {
	      return {
	        userId: this.theSelectedUserId,
	        startDate: this.startDate,
	        endDate: this.endDate,
	        hoursPerWeek: this.hoursPerWeek * 1,
	        grossHours: this.numberOfDaysWithoutWeekendsInHours * 1,
	        holidayHours: this.filteredHolidaysInHours * 1,
	        vacationHours: this.numberOfVacationDaysInHours * 1,
	        workHours: this.numberOfWorkDaysPossibleInHours * 1
	      };
	    }
	  }),
	  watch: {
	    summary: {
	      handler: function handler(summary) {
	        this.$emit('changed', summary);
	      },
	
	      immediate: true
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      this.setEndDate(this.activeSchoolYear.employee_time_end);
	      this.setStartDate(this.activeSchoolYear.employee_time_start);
	    }
	  },
	  methods: {
	    onUserIsSelected: function onUserIsSelected() {
	      this.getUsersHours();
	    },
	    getUsersHours: function getUsersHours() {
	      var _this2 = this;
	
	      if (!this.theSelectedUserId) {
	        return;
	      }
	      this.isLoadingUpdatedNumbers = true;
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD') + ' 00:00';
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD') + ' 23:59';
	      _docendo2.default.schoolActualHours(this.schoolId, startDate, endDate, [this.theSelectedUserId], function (data) {
	        _this2.userData = data;
	        _this2.isLoadingUpdatedNumbers = false;
	      });
	    },
	    resetDates: function resetDates() {
	      this.setEndDate(this.activeSchoolYear.employee_time_end, false);
	      this.setStartDate(this.activeSchoolYear.employee_time_start);
	    },
	    compareDates: function compareDates(firstDate, secondDate) {
	      return (0, _moment2.default)(firstDate).format('YYYY-MM-DD') === (0, _moment2.default)(secondDate).format('YYYY-MM-DD');
	    },
	    setStartDate: function setStartDate(date) {
	      this.startDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      if ((0, _moment2.default)(date).isValid()) {
	        this.getUsersHours();
	      }
	    },
	    setEndDate: function setEndDate(date, isCallServer) {
	      this.endDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      if (!isCallServer) {
	        return;
	      }
	      if ((0, _moment2.default)(date).isValid()) {
	        this.getUsersHours();
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.activeSchoolYear) {
	      this.setEndDate(this.activeSchoolYear.employee_time_end, false);
	      this.setStartDate(this.activeSchoolYear.employee_time_start);
	    }
	  }
	};

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(14);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var XLSX = null;
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  data: function data() {
	    return {
	      userYearsByUserId: {},
	      isLoading: false,
	      isDownloading: false,
	      sort: { key: 'name', dir: 'asc' }
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usersSortedOnName']), {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    schoolYearName: function schoolYearName() {
	      return this.activeSchoolYear && this.activeSchoolYear.name ? this.activeSchoolYear.name : '';
	    },
	    coreColumns: function coreColumns() {
	      return ['Ansættelsesgrad', 'Timeansættelse pr. uge'];
	    },
	    columns: function columns() {
	      var cols = {};
	      this.coreColumns.forEach(function (c) {
	        cols[c] = true;
	      });
	      var users = this.usersSortedOnName || [];
	      for (var i = 0; i < users.length; i++) {
	        var year = this.userYearsByUserId[users[i].id] || {};
	        var norm = year && Array.isArray(year.norm) ? year.norm : [];
	        for (var j = 0; j < norm.length; j++) {
	          var entry = norm[j];
	          if (!entry || !entry.title) continue;
	          if (entry.title.indexOf('hidden_') === 0) continue;
	          cols[entry.title] = true;
	        }
	      }
	      var ordered = (0, _keys2.default)(cols);
	
	      var periodeIdx = ordered.indexOf('Periode');
	      var bruttoIdx = ordered.indexOf('Bruttotid');
	      if (periodeIdx > -1 && bruttoIdx > -1) {
	        ordered.splice(periodeIdx, 1);
	        ordered.splice(ordered.indexOf('Bruttotid') + 1, 0, 'Periode');
	      }
	      return ordered;
	    },
	    rows: function rows() {
	      var _this = this;
	
	      var users = this.usersSortedOnName || [];
	      return users.map(function (u) {
	        var year = _this.userYearsByUserId[u.id] || {};
	        var norm = year && Array.isArray(year.norm) ? year.norm : [];
	        var values = {};
	        for (var i = 0; i < _this.columns.length; i++) {
	          values[_this.columns[i]] = '';
	        }for (var k = 0; k < norm.length; k++) {
	          var e = norm[k];
	          if (!e || !e.title) continue;
	          if (e.title.indexOf('hidden_') === 0) continue;
	          values[e.title] = e.value;
	        }
	        return {
	          id: u.id,
	          name: u && u.name ? u.name : '',
	          values: values
	        };
	      });
	    },
	    displayedRows: function displayedRows() {
	      var list = this.rows.slice();
	      var key = this.sort.key;
	      var dir = this.sort.dir;
	
	      if (key === 'name') {
	        list.sort(function (a, b) {
	          var cmp = String(a.name || '').localeCompare(String(b.name || ''), 'da-DK');
	          return dir === 'asc' ? cmp : -cmp;
	        });
	        return list;
	      }
	
	      function toNum(val) {
	        var s = String(val === undefined || val === null ? '' : val).replace('%', '').replace(',', '.');
	        var n = parseFloat(s);
	        return isNaN(n) ? null : n;
	      }
	
	      list.sort(function (a, b) {
	        var avRaw = a.values[key];
	        var bvRaw = b.values[key];
	        var avNum = toNum(avRaw);
	        var bvNum = toNum(bvRaw);
	        if (avNum !== null && bvNum !== null) {
	          return dir === 'asc' ? avNum - bvNum : bvNum - avNum;
	        }
	        var at = String(avRaw === undefined || avRaw === null ? '' : avRaw);
	        var bt = String(bvRaw === undefined || bvRaw === null ? '' : bvRaw);
	        var cmp = at.localeCompare(bt, 'da-DK');
	        return dir === 'asc' ? cmp : -cmp;
	      });
	      return list;
	    }
	  }),
	  methods: {
	    columnLabel: function columnLabel(col) {
	      if (col === 'Periode') return 'Ansættelsesperiode';
	      if (col === 'Arbejdstid') return 'Nettotid';
	      return col;
	    },
	    parseNumericValue: function parseNumericValue(val) {
	      if (val === null || val === undefined) return null;
	      var s = String(val).trim();
	
	      if (!/^-?\d+(?:[.,]\d+)?$/.test(s)) return null;
	      var n = parseFloat(s.replace(',', '.'));
	      return isNaN(n) ? null : n;
	    },
	    setSort: function setSort(key) {
	      if (this.sort.key === key) {
	        this.sort.dir = this.sort.dir === 'asc' ? 'desc' : 'asc';
	        return;
	      }
	      this.sort.key = key;
	      this.sort.dir = key === 'name' ? 'asc' : 'desc';
	    },
	    loadUserYears: function loadUserYears() {
	      var _this2 = this;
	
	      if (!this.activeSchoolYear || !this.activeSchoolYear.id) {
	        this.userYearsByUserId = {};
	        return;
	      }
	      this.isLoading = true;
	      _docendo2.default.schoolUserYearsList(this.schoolId, this.activeSchoolYear.id, null, function (success) {
	        var list = Array.isArray(success) ? success : [];
	        var byUserId = {};
	        for (var i = 0; i < list.length; i++) {
	          var userYear = list[i];
	          if (userYear && userYear.user_id) {
	            byUserId[userYear.user_id] = userYear;
	          }
	        }
	        _this2.userYearsByUserId = byUserId;
	        _this2.isLoading = false;
	      }, function (failure) {
	        _this2.userYearsByUserId = {};
	        _this2.isLoading = false;
	        console.log('schoolUserYearsList failed', failure);
	      });
	    },
	    asyncLoadXLSXAndDownload: function asyncLoadXLSXAndDownload() {
	      var _this3 = this;
	
	      this.isDownloading = true;
	      if (window.XLSX && XLSX) {
	        this.download();
	      } else {
	        var cdnXLSX = document.createElement('script');
	        cdnXLSX.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.mini.min.js');
	        document.head.appendChild(cdnXLSX);
	        var intervalTimer = setInterval(function (_) {
	          if (window.XLSX) {
	            clearInterval(intervalTimer);
	            XLSX = window.XLSX;
	            _this3.download();
	          }
	        }, 500);
	      }
	    },
	    download: function download() {
	      var _this4 = this;
	
	      var rows = this.displayedRows.map(function (row) {
	        var obj = { 'Navn': row.name };
	        _this4.columns.forEach(function (col) {
	          var num = _this4.parseNumericValue(row.values[col]);
	
	          obj[_this4.columnLabel(col)] = num !== null ? num : row.values[col] || '';
	        });
	        return obj;
	      });
	      var headers = ['Navn'].concat(this.columns.map(function (col) {
	        return _this4.columnLabel(col);
	      }));
	      var data = XLSX.utils.json_to_sheet(rows, { header: headers });
	      var wb = XLSX.utils.book_new();
	      XLSX.utils.book_append_sheet(wb, data, 'Ansættelsesgrader');
	      XLSX.writeFile(wb, 'docendo_ansaettelsesgrader.xlsx');
	      this.isDownloading = false;
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('getUsersFromSchoolId', this.schoolId);
	    this.loadUserYears();
	  }
	};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _vuex = __webpack_require__(14);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _AppEIPWYZIWYG = __webpack_require__(55);
	
	var _AppEIPWYZIWYG2 = _interopRequireDefault(_AppEIPWYZIWYG);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _AssignHoursNormList = __webpack_require__(338);
	
	var _AssignHoursNormList2 = _interopRequireDefault(_AssignHoursNormList);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _AssignHoursNormEditIUserModal = __webpack_require__(1451);
	
	var _AssignHoursNormEditIUserModal2 = _interopRequireDefault(_AssignHoursNormEditIUserModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    AssignHoursNormEditIUserModal: _AssignHoursNormEditIUserModal2.default,
	    DoFiltersFilter: _DoFiltersFilter2.default, ModalConfirmation: _ModalConfirmation2.default, AppToggle: _AppToggle2.default, DModal: _DModal2.default, AppEIPWYZIWYG: _AppEIPWYZIWYG2.default, AssignHoursNormList: _AssignHoursNormList2.default
	  },
	  props: {
	    tags: {
	      default: function _default() {
	        return [];
	      }
	    },
	    isKindergarten: {
	      type: Boolean,
	      default: false
	    },
	    isLocalPoolActivated: {
	      type: Boolean,
	      default: false
	    },
	    prepFactor: {
	      default: null
	    },
	    isPoolsDeactivated: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      theEditUser: null,
	      showAllFields: false,
	      sort: {
	        key: 'vAssignedTotalHours',
	        dir: 'desc'
	      },
	      normSort: { key: 'name', dir: 'asc' },
	      theEmploymentRate: 1,
	      theNewNettoValue: null,
	      isShowHolidaysSettingsModal: false,
	      holidaysSettingsValue: 0,
	      holidaysSettingsList: [],
	      holidaysSettingsStandardCount: 0,
	      holidaysSettingsCalculatedValue: 0,
	      holidaysSettingsReadOnly: false,
	      originalHolidayHours: 0,
	      isShowLocalAgreementSettingsModal: false,
	      localAgreementSettingsValue: 0,
	      originalLocalAgreementHours: 0,
	      isWarningActive: false,
	      isActive: false,
	      isSaving: false,
	      selectedUsers: [],
	      appliedFilters: [],
	      nettoItems: [],
	      items: [{ id: 'assigned_teaching_hours', name: 'Undervisning', hours: 800, isChecked: false }, { id: 'assigned_additional_task_hours', name: 'Øvrige opgaver', hours: 400, isChecked: false }, { id: 'assigned_preparation_hours', name: 'Forberedelse', hours: 400, isChecked: false }, { id: 'assigned_pool_hours', name: 'Lokalpulje', hours: 80, isChecked: false }, { id: 'substitute_pool_hours', name: 'Vikartimer', hours: 0, isChecked: false }, { id: 'assigned_club_hours', name: 'SFO-timer', hours: 0, isChecked: false }],
	      originalItems: [],
	      agreements: '',
	      isShowAgreement: false,
	      activeTab: 0,
	      itemsToSave: [],
	      nettoTime: 1686.1,
	      originalNettoTime: 1686.1,
	      theEditUserNorm: null,
	      theNewStandardHoursForPool: null,
	      isAutoCalculateHoursFromEmploymentRate: false,
	      isModalAutoCalculateOpen: false,
	      isEditWorkHours: true,
	      updatesHasHappened: false,
	      userYearsByUserId: {},
	      isLoadingUserYears: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usersSortedOnName', 'isAssignedPoolFromNormWhenPoolsDeactivated']), {
	    displayedNormPoolItems: function displayedNormPoolItems() {
	      if (this.isPoolsDeactivated && this.isAssignedPoolFromNormWhenPoolsDeactivated) {
	        return this.items.filter(function (item) {
	          return item.id === 'assigned_pool_hours';
	        });
	      }
	      return this.items;
	    },
	    isLoadingAllUsers: function isLoadingAllUsers() {
	      return this.$store.state.isLoadingAllUsers;
	    },
	    localPoolTitle: function localPoolTitle() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || this.$t('vue2.task_overview.pool');
	    },
	    coreColumns: function coreColumns() {
	      return ['Ansættelsesgrad', 'Timeansættelse pr. uge'];
	    },
	    normColumns: function normColumns() {
	      var cols = {};
	      var users = this.filteredUsers || [];
	      for (var i = 0; i < users.length; i++) {
	        var u = users[i];
	        var year = u && u.vYear ? u.vYear : {};
	        var norm = year && Array.isArray(year.norm) ? year.norm : [];
	        for (var j = 0; j < norm.length; j++) {
	          var entry = norm[j];
	          if (!entry || !entry.title) continue;
	          if (entry.title.indexOf('hidden_') === 0) continue;
	          if (entry.title === 'Periode') continue;
	          cols[entry.title] = true;
	        }
	      }
	
	      this.coreColumns.forEach(function (c) {
	        cols[c] = true;
	      });
	      return (0, _keys2.default)(cols);
	    },
	    extraColumns: function extraColumns() {
	      var _this = this;
	
	      return this.normColumns.filter(function (c) {
	        return _this.coreColumns.indexOf(c) === -1;
	      });
	    },
	    isAllDisplayedSelected: function isAllDisplayedSelected() {
	      var rows = this.normDisplayedRows;
	      if (!rows.length) return false;
	      for (var i = 0; i < rows.length; i++) {
	        var r = rows[i];
	        if (!this.getIsUserSelected(r)) return false;
	      }
	      return true;
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    activeSchoolYearName: function activeSchoolYearName() {
	      return this.activeSchoolYear && this.activeSchoolYear.name ? this.activeSchoolYear.name : '';
	    },
	    restCalculation: function restCalculation() {
	      var sum = this.items.filter(function (item) {
	        return item.isChecked;
	      }).reduce(function (sum, item) {
	        return sum + Number(item.hours);
	      }, 0);
	      return (this.nettoTime - sum).toFixed(2);
	    },
	    checkedItemsToUpdate: function checkedItemsToUpdate() {
	      var _this2 = this;
	
	      return this.items.filter(function (item) {
	        return !_this2.prepFactor || item.id !== 'assigned_preparation_hours';
	      }).filter(function (item) {
	        return item.isChecked;
	      });
	    },
	    isEmploymentRateChanged: function isEmploymentRateChanged() {
	      return this.isPoolsDeactivated ? false : Number(this.theEmploymentRate) !== 1;
	    },
	    usersSortedOnNameWithTags: function usersSortedOnNameWithTags() {
	      return this.usersSortedOnName.map(function (user) {
	        user.tags = user.user_tags;
	        return user;
	      });
	    },
	    filteredUsers: function filteredUsers() {
	      var _this3 = this;
	
	      var enriched = this.usersSortedOnNameWithTags.map(function (user) {
	        var cy = _this3.getYearForActiveSchoolYear(user) || {};
	        var hasHours = typeof cy.assigned_total_hours !== 'undefined' && cy.assigned_total_hours !== null;
	        var hours = hasHours ? Number(cy.assigned_total_hours) : 0;
	
	        return (0, _extends3.default)({}, user, {
	          vYear: cy,
	          vTags: user && user.user_tags ? user.user_tags : [],
	          vName: user && user.name ? user.name : '',
	          vAssignedTotalHours: isNaN(hours) ? 0 : hours,
	          vHasAssignedTotalHours: !!hasHours
	        });
	      });
	
	      var filtered = !this.appliedFilters.length ? enriched : enriched.filter(function (user) {
	        return user.vTags && _this3.appliedFilters.some(function (tag) {
	          return user.vTags.indexOf(tag) > -1;
	        });
	      });
	
	      return filtered.slice().sort(function (a, b) {
	        if (b.vAssignedTotalHours !== a.vAssignedTotalHours) {
	          return b.vAssignedTotalHours - a.vAssignedTotalHours;
	        }
	        return String(a.vName).localeCompare(String(b.vName), 'da-DK');
	      });
	    },
	    displayedUsers: function displayedUsers() {
	      var _this4 = this;
	
	      var list = this.filteredUsers.slice();
	
	      if (this.sort.key === 'vAssignedTotalHours') {
	        list.sort(function (a, b) {
	          var av = Number(a.vAssignedTotalHours || 0);
	          var bv = Number(b.vAssignedTotalHours || 0);
	          return _this4.sort.dir === 'asc' ? av - bv : bv - av;
	        });
	      } else if (this.sort.key === 'name') {
	        list.sort(function (a, b) {
	          var an = String(a.name || '');
	          var bn = String(b.name || '');
	          var cmp = an.localeCompare(bn, 'da-DK');
	          return _this4.sort.dir === 'asc' ? cmp : -cmp;
	        });
	      }
	
	      return list;
	    },
	    hoursForTeaching: function hoursForTeaching() {
	      var idx = this.items.findIndex(function (item) {
	        return item.id === 'assigned_teaching_hours';
	      });
	      return this.items[idx].hours;
	    },
	    isPrepFactorForSubstitutePools: function isPrepFactorForSubstitutePools() {
	      return !!(this.schoolSettings && this.schoolSettings['prepFactorForSubstitutePools']);
	    },
	    substitutePoolHoursForPrep: function substitutePoolHoursForPrep() {
	      if (!this.isPrepFactorForSubstitutePools) {
	        return null;
	      }
	      var item = this.items.find(function (item) {
	        return item.id === 'substitute_pool_hours';
	      });
	      if (!item || !item.isChecked) {
	        return null;
	      }
	      var hours = Number(item.hours);
	      return isNaN(hours) ? 0 : hours;
	    },
	    normRows: function normRows() {
	      var _this5 = this;
	
	      var users = this.filteredUsers || [];
	      return users.map(function (u) {
	        var year = u && u.vYear ? u.vYear : {};
	        var norm = year && Array.isArray(year.norm) ? year.norm : [];
	
	        var values = {};
	        for (var i = 0; i < _this5.coreColumns.length; i++) {
	          values[_this5.coreColumns[i]] = '';
	        }
	        for (var k = 0; k < norm.length; k++) {
	          var e = norm[k];
	          if (!e || !e.title) continue;
	          if (e.title.indexOf('hidden_') === 0) continue;
	          if (e.title === 'Periode') continue;
	          values[e.title] = e.value;
	        }
	
	        if (_this5.showAllFields) {
	          for (var _i = 0; _i < _this5.extraColumns.length; _i++) {
	            var col = _this5.extraColumns[_i];
	            if (values[col] === undefined) values[col] = '';
	          }
	        }
	
	        var hasHours = year && typeof year.assigned_total_hours !== 'undefined' && year.assigned_total_hours !== null;
	        var hours = hasHours ? Number(year.assigned_total_hours) : 0;
	
	        return {
	          id: u.id,
	          name: u && u.name ? u.name : '',
	          vAssignedTotalHours: isNaN(hours) ? 0 : hours,
	          values: values,
	          _rawUser: u
	        };
	      });
	    },
	    normDisplayedRows: function normDisplayedRows() {
	      var list = this.normRows.slice();
	      var key = this.normSort.key;
	      var dir = this.normSort.dir;
	
	      var canSortCoreWhenCollapsed = this.coreColumns.indexOf(key) > -1;
	
	      if (!this.showAllFields && key !== 'name' && !canSortCoreWhenCollapsed) {
	        return list.sort(function (a, b) {
	          var an = String(a.name || '');
	          var bn = String(b.name || '');
	          var cmp = an.localeCompare(bn, 'da-DK');
	          return cmp;
	        });
	      }
	
	      if (key === 'name') {
	        list.sort(function (a, b) {
	          var an = String(a.name || '');
	          var bn = String(b.name || '');
	          var cmp = an.localeCompare(bn, 'da-DK');
	          return dir === 'asc' ? cmp : -cmp;
	        });
	        return list;
	      }
	
	      if (key === 'vAssignedTotalHours') {
	        list.sort(function (a, b) {
	          var av = Number(a.vAssignedTotalHours || 0);
	          var bv = Number(b.vAssignedTotalHours || 0);
	          return dir === 'asc' ? av - bv : bv - av;
	        });
	        return list;
	      }
	
	      function toNum(val) {
	        var s = String(val === undefined || val === null ? '' : val).replace('%', '').replace(',', '.');
	        var n = parseFloat(s);
	        return isNaN(n) ? null : n;
	      }
	
	      list.sort(function (a, b) {
	        var avRaw = a.values[key];
	        var bvRaw = b.values[key];
	        var avNum = toNum(avRaw);
	        var bvNum = toNum(bvRaw);
	
	        if (avNum !== null && bvNum !== null) {
	          return dir === 'asc' ? avNum - bvNum : bvNum - avNum;
	        }
	
	        var at = String(avRaw === undefined || avRaw === null ? '' : avRaw);
	        var bt = String(bvRaw === undefined || bvRaw === null ? '' : bvRaw);
	        var cmp = at.localeCompare(bt, 'da-DK');
	        return dir === 'asc' ? cmp : -cmp;
	      });
	      return list;
	    }
	  }),
	  methods: {
	    getItemName: function getItemName(item) {
	      if (item && item.id === 'assigned_pool_hours') {
	        return this.localPoolTitle;
	      }
	      return item && item.name ? item.name : '';
	    },
	    onUpdatedUserNorm: function onUpdatedUserNorm() {
	      this.updatesHasHappened = true;
	      this.setTheEditUser(null);
	      this.loadUserYearsForActiveSchoolYear();
	    },
	    loadUserYearsForActiveSchoolYear: function loadUserYearsForActiveSchoolYear() {
	      var _this6 = this;
	
	      if (!this.activeSchoolYear || !this.activeSchoolYear.id) {
	        this.userYearsByUserId = {};
	        return;
	      }
	      this.isLoadingUserYears = true;
	      _docendo2.default.schoolUserYearsList(this.schoolId, this.activeSchoolYear.id, null, function (success) {
	        var list = Array.isArray(success) ? success : [];
	        var byUserId = {};
	        for (var i = 0; i < list.length; i++) {
	          var userYear = list[i];
	          if (userYear && userYear.user_id) {
	            byUserId[userYear.user_id] = userYear;
	          }
	        }
	        _this6.userYearsByUserId = byUserId;
	        _this6.isLoadingUserYears = false;
	      }, function (failure) {
	        _this6.userYearsByUserId = {};
	        _this6.isLoadingUserYears = false;
	        console.log('schoolUserYearsList failed', failure);
	      });
	    },
	    getYearForActiveSchoolYear: function getYearForActiveSchoolYear(user) {
	      if (!user || !user.id) return null;
	      return this.userYearsByUserId[user.id] || null;
	    },
	    setTheEditUser: function setTheEditUser(user) {
	      if (user) {
	        this.selectedUsers = [user.id];
	      } else {
	        this.selectedUsers = [];
	      }
	      this.theEditUser = user;
	    },
	    toggleAllDisplayed: function toggleAllDisplayed() {
	      if (this.isAllDisplayedSelected) {
	        var ids = this.normDisplayedRows.map(function (r) {
	          return r.id;
	        });
	        this.selectedUsers = this.selectedUsers.filter(function (id) {
	          return ids.indexOf(id) === -1;
	        });
	        return;
	      }
	
	      var add = this.normDisplayedRows.map(function (r) {
	        return r.id;
	      });
	      var set = {};
	      for (var i = 0; i < this.selectedUsers.length; i++) {
	        set[this.selectedUsers[i]] = true;
	      }for (var j = 0; j < add.length; j++) {
	        set[add[j]] = true;
	      }this.selectedUsers = (0, _keys2.default)(set).map(function (k) {
	        return k * 1;
	      });
	    },
	    shortNormTitle: function shortNormTitle(title) {
	      var map = {
	        'Ansættelsesgrad': 'Ans.grad',
	        'Timeansættelse pr. uge': 'Timer/uge',
	        'Søgnehelligdage': 'Søgnehel.',
	        '6. Ferieuge': '6. ferieuge',
	        'Bruttotid': 'Brutto',
	        'Arbejdstid': 'Netto'
	      };
	      if (map[title]) return map[title];
	
	      var t = String(title);
	      t = t.replace(' pr. ', '/');
	      t = t.replace(' pr ', '/');
	
	      var max = 16;
	      if (t.length > max) t = t.slice(0, max - 1) + '…';
	
	      return t;
	    },
	    setNormSort: function setNormSort(key) {
	      if (this.normSort.key === key) {
	        this.normSort.dir = this.normSort.dir === 'asc' ? 'desc' : 'asc';
	        return;
	      }
	      this.normSort.key = key;
	      this.normSort.dir = key === 'name' ? 'asc' : 'desc';
	    },
	    setIsWarningActive: function setIsWarningActive(bool) {
	      if (bool && this.isEditWorkHours) {
	        this.isWarningActive = true;
	        return;
	      }
	      this.save();
	    },
	    setHoursFromEmploymentRate: function setHoursFromEmploymentRate(itemToUpdate) {
	      var idx = this.items.findIndex(function (item) {
	        return item.id === itemToUpdate.id;
	      });
	      if (idx === -1) return;
	
	      var item = this.items[idx];
	      var originalItem = this.findOriginalItem(item);
	      var newHours = parseFloat((originalItem.hours * this.theEmploymentRate).toFixed(2));
	
	      this.$set(this.items, idx, (0, _extends3.default)({}, item, { hours: newHours }));
	    },
	    updateActivePoolsFromEmploymentRate: function updateActivePoolsFromEmploymentRate() {
	      var _this7 = this;
	
	      this.checkedItemsToUpdate.forEach(function (checkedItem) {
	        _this7.setHoursFromEmploymentRate(checkedItem);
	      });
	      this.isModalAutoCalculateOpen = false;
	      this.updatePrepHoursFromTeaching();
	    },
	    formatEmploymentRateText: function formatEmploymentRateText(item) {
	      var showResult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var originalHours = this.findOriginalItem(item).hours;
	      var employmentRatePercentage = (this.theEmploymentRate * 100).toFixed(0) + '%';
	      var result = (originalHours * this.theEmploymentRate).toFixed(2);
	
	      return showResult ? originalHours + ' timer * ' + employmentRatePercentage + ' = ' + result + ' timer' : originalHours + 't * ' + employmentRatePercentage;
	    },
	    onChangedEmploymentRate: function onChangedEmploymentRate(rate) {
	      if (this.isPoolsDeactivated) {
	        return;
	      }
	      this.theEmploymentRate = rate;
	      this.isModalAutoCalculateOpen = this.items.some(function (item) {
	        return item.isChecked;
	      });
	    },
	    isShowPrepFactorTooltip: function isShowPrepFactorTooltip(item) {
	      return item.id === 'assigned_preparation_hours' && this.prepFactor !== null;
	    },
	    saveNewNettoTime: function saveNewNettoTime() {
	      var _this8 = this;
	
	      var val = this.theNewNettoValue * 1;
	      this.$store.dispatch('updateSchoolSettings', { 'nettoTime': val });
	      this.originalNettoTime = val;
	      setTimeout(function (_) {
	        _this8.setIsShowNewNettoModal(null);
	      }, 0);
	    },
	    setIsShowNewNettoModal: function setIsShowNewNettoModal(val) {
	      this.theNewNettoValue = val;
	    },
	    openHolidaysSettingsModal: function openHolidaysSettingsModal(payload) {
	      this.holidaysSettingsValue = payload.fullTimeValue;
	      this.holidaysSettingsList = payload.holidays || [];
	      this.holidaysSettingsStandardCount = payload.standardDayCount || 0;
	      this.holidaysSettingsCalculatedValue = payload.calculatedFullTimeValue || 0;
	      this.holidaysSettingsReadOnly = !!payload.isReadOnly;
	      this.isShowHolidaysSettingsModal = true;
	    },
	    closeHolidaysSettingsModal: function closeHolidaysSettingsModal() {
	      this.isShowHolidaysSettingsModal = false;
	    },
	    saveHolidaysSettings: function saveHolidaysSettings() {
	      var _this9 = this;
	
	      var val = this.holidaysSettingsValue * 1;
	      if (!val || val <= 0) {
	        return;
	      }
	      this.$store.dispatch('updateSchoolSettingsForSchoolYear', { 'holidays': val });
	      this.originalHolidayHours = val;
	      setTimeout(function (_) {
	        _this9.closeHolidaysSettingsModal();
	      }, 0);
	    },
	    deleteHolidaysSettings: function deleteHolidaysSettings() {
	      var _this10 = this;
	
	      this.$store.dispatch('deleteSchoolSettingForSchoolYear', 'holidays');
	      this.originalHolidayHours = 0;
	      setTimeout(function (_) {
	        _this10.closeHolidaysSettingsModal();
	      }, 0);
	    },
	    openLocalAgreementSettingsModal: function openLocalAgreementSettingsModal(payload) {
	      this.localAgreementSettingsValue = payload.fullTimeValue;
	      this.isShowLocalAgreementSettingsModal = true;
	    },
	    closeLocalAgreementSettingsModal: function closeLocalAgreementSettingsModal() {
	      this.isShowLocalAgreementSettingsModal = false;
	    },
	    saveLocalAgreementSettings: function saveLocalAgreementSettings() {
	      var _this11 = this;
	
	      var val = this.localAgreementSettingsValue * 1;
	      if (!val || val <= 0) {
	        return;
	      }
	      this.$store.dispatch('updateSchoolSettings', { 'local_agreement_adjustment': val });
	      this.originalLocalAgreementHours = val;
	      setTimeout(function (_) {
	        _this11.closeLocalAgreementSettingsModal();
	      }, 0);
	    },
	    deleteLocalAgreementSettings: function deleteLocalAgreementSettings() {
	      var _this12 = this;
	
	      this.$store.dispatch('updateSchoolSettings', { 'local_agreement_adjustment': null });
	      this.originalLocalAgreementHours = 0;
	      setTimeout(function (_) {
	        _this12.closeLocalAgreementSettingsModal();
	      }, 0);
	    },
	    setTheNewStandardHoursForPool: function setTheNewStandardHoursForPool() {
	      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      this.theNewStandardHoursForPool = obj;
	    },
	    saveNewStandardHours: function saveNewStandardHours() {
	      var _this13 = this;
	
	      var hours = Number(this.theNewStandardHoursForPool.hours);
	      var key = this.theNewStandardHoursForPool.id;
	
	      this.$store.dispatch('updateSchoolSettings', (0, _defineProperty3.default)({}, key, hours));
	
	      var originalItem = this.originalItems.find(function (item) {
	        return item.id === _this13.theNewStandardHoursForPool.id;
	      });
	      if (originalItem) {
	        originalItem.hours = hours;
	      }
	      setTimeout(function () {
	        _this13.setTheNewStandardHoursForPool(null);
	      }, 0);
	    },
	    setIsNormModal: function setIsNormModal() {
	      this.$store.dispatch('getUsersFromSchoolId', this.schoolId);
	      this.loadUserYearsForActiveSchoolYear();
	      this.theEmploymentRate = 1;
	      this.updateItemsWithSchoolSettings();
	      if (this.schoolSettings && (this.schoolSettings['netto_time'] || this.schoolSettings['nettoTime'])) {
	        var nettTime = this.schoolSettings['netto_time'] || this.schoolSettings['nettoTime'];
	        this.nettoTime = nettTime;
	        this.originalNettoTime = nettTime;
	      }
	      this.originalHolidayHours = this.getHolidayHoursFromSchoolYearSettings();
	      this.originalLocalAgreementHours = this.getLocalAgreementHoursFromSchoolSettings();
	      this.isActive = true;
	      this.updatePrepHoursFromTeaching();
	    },
	    getLocalAgreementHoursFromSchoolSettings: function getLocalAgreementHoursFromSchoolSettings() {
	      if (this.schoolSettings && this.schoolSettings['local_agreement_adjustment']) {
	        return this.schoolSettings['local_agreement_adjustment'] * 1;
	      }
	      return 0;
	    },
	    getHolidayHoursFromSchoolYearSettings: function getHolidayHoursFromSchoolYearSettings() {
	      if (!this.schoolSettings || !this.activeSchoolYear || !this.activeSchoolYear.id) {
	        return 0;
	      }
	      var propSchoolYear = 'school_year_' + this.activeSchoolYear.id;
	      var settingsForYear = this.schoolSettings[propSchoolYear];
	      if (settingsForYear && settingsForYear['holidays']) {
	        return settingsForYear['holidays'] * 1;
	      }
	      return 0;
	    },
	    updatePrepHoursFromTeaching: function updatePrepHoursFromTeaching() {
	      if (!this.prepFactor) {
	        return;
	      }
	      var teachingHours = Number(this.hoursForTeaching) || 0;
	      var substituteHours = this.substitutePoolHoursForPrep !== null ? this.substitutePoolHoursForPrep : 0;
	      var thePrep = (teachingHours + substituteHours) * this.prepFactor;
	      var roundedPrep = parseFloat(thePrep.toFixed(2));
	      var idx = this.items.findIndex(function (hoursItem) {
	        return hoursItem.id === 'assigned_preparation_hours';
	      });
	      this.items[idx].hours = roundedPrep;
	    },
	    onUpdatingHours: function onUpdatingHours(item, val) {
	      var originalItem = this.originalItems.find(function (item) {
	        return item.id === item.id;
	      });
	      var originalVal = originalItem.hours;
	      var newVal = val * 1;
	      if (!this.isEmploymentRateChanged && originalVal !== newVal) {
	        this.setTheNewStandardHoursForPool(item);
	      }
	      this.updatePrepHoursFromTeaching();
	    },
	    findOriginalItem: function findOriginalItem(item) {
	      return this.originalItems.find(function (originalItem) {
	        return originalItem.id === item.id;
	      });
	    },
	    toggleItem: function toggleItem(idx) {
	      var item = this.items[idx];
	      this.items[idx].isChecked = !this.items[idx].isChecked;
	      if (this.prepFactor && item.id === 'assigned_preparation_hours') {
	        return;
	      }
	      if (this.isEmploymentRateChanged) {
	        this.setHoursFromEmploymentRate(item);
	        this.updatePrepHoursFromTeaching();
	      } else if (item.id === 'substitute_pool_hours') {
	        this.updatePrepHoursFromTeaching();
	      }
	    },
	    toggleItemById: function toggleItemById(itemId) {
	      var idx = this.items.findIndex(function (item) {
	        return item.id === itemId;
	      });
	      if (idx > -1) {
	        this.toggleItem(idx);
	      }
	    },
	    isItemToggled: function isItemToggled(idx) {
	      return this.items[idx].isChecked;
	    },
	    isItemToggledById: function isItemToggledById(itemId) {
	      var idx = this.items.findIndex(function (item) {
	        return item.id === itemId;
	      });
	      return idx > -1 ? this.isItemToggled(idx) : false;
	    },
	    setNettoTime: function setNettoTime(time) {
	      this.nettoTime = time;
	    },
	    setItemsToSave: function setItemsToSave(arr) {
	      this.itemsToSave = arr;
	    },
	    setActiveTab: function setActiveTab(num) {
	      this.activeTab = num;
	      if (num === 1) {
	        this.nettoTime = this.originalNettoTime;
	      }
	    },
	    getIsActiveTab: function getIsActiveTab(num) {
	      return this.activeTab === num;
	    },
	    setIsShowAgreement: function setIsShowAgreement() {
	      this.isShowAgreement = !this.isShowAgreement;
	    },
	    toggleAll: function toggleAll() {
	      var _this14 = this;
	
	      if (this.selectedUsers.length > 0) {
	        this.selectedUsers = [];
	      } else {
	        this.selectedUsers = [];
	        this.filteredUsers.forEach(function (user) {
	          return _this14.selectedUsers.push(user.id);
	        });
	      }
	    },
	    getIsUserSelected: function getIsUserSelected(user) {
	      var idx = this.selectedUsers.findIndex(function (selectedUser) {
	        return selectedUser === user.id;
	      });
	      return idx > -1;
	    },
	    toggleUser: function toggleUser(user) {
	      var idx = this.selectedUsers.findIndex(function (selectedUser) {
	        return selectedUser === user.id;
	      });
	      if (idx > -1) {
	        this.selectedUsers.splice(idx, 1);
	      } else {
	        this.selectedUsers.push(user.id);
	      }
	    },
	    toggleFilter: function toggleFilter(tag) {
	      this.selectedUsers = [];
	      var idx = this.appliedFilters.findIndex(function (filter) {
	        return filter === tag;
	      });
	
	      if (idx < 0) {
	        this.appliedFilters.push(tag);
	      } else {
	        this.appliedFilters.splice(idx, 1);
	      }
	    },
	    close: function close() {
	      this.userYearsByUserId = {};
	      this.isActive = false;
	      this.selectedUsers = [];
	      if (this.updatesHasHappened) {
	        this.$emit('updateUsersHours');
	      }
	    },
	    save: function save() {
	      var _this15 = this;
	
	      if (this.selectedUsers.length < 1) return;
	      if (!this.activeSchoolYear || !this.activeSchoolYear.name) {
	        _eventbus2.default.toast = { text: 'Skoleår er ikke indlæst endnu', success: false };
	        return;
	      }
	
	      function validateNumber(item) {
	        var itemsNotToValidate = ['hidden_ansættelsesgrad', 'Periode', 'hidden_periode_start', 'hidden_periode_end', 'Ansættelsesgrad'];
	
	        if (itemsNotToValidate.indexOf(item.title) > -1) {
	          return item.value;
	        }
	
	        var val = item.hours * 1;
	        return val.toFixed(2);
	      }
	
	      var data = {};
	
	      if (this.isEditWorkHours) {
	        this.isSaving = true;
	
	        var itemsToSave = this.itemsToSave.map(function (item) {
	          return {
	            title: item.title,
	            value: validateNumber(item)
	          };
	        });
	
	        itemsToSave.push({
	          title: 'Arbejdstid',
	          value: this.nettoTime
	        });
	
	        data.norm = itemsToSave;
	        data.assigned_total_hours = this.nettoTime;
	      }
	
	      if (this.isShowAgreement) {
	        data.agreements = this.agreements;
	      }
	
	      var activatedItems = this.items.filter(function (item) {
	        return item.isChecked;
	      });
	      activatedItems.forEach(function (item) {
	        data[item.id] = item.hours;
	      });
	
	      var dataToSave = this.selectedUsers.map(function (userId) {
	        return {
	          user_id: userId,
	          data: data
	        };
	      });
	
	      _docendo2.default.bulkSchoolUserYearUpdate(this.schoolId, this.activeSchoolYear.name, dataToSave, function (success) {
	        _this15.reset();
	        _this15.$emit('updateUsersHours');
	        _this15.close();
	        _eventbus2.default.toast = { text: 'Gemt', success: true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Noget gik galt', success: false };
	      });
	    },
	    reset: function reset() {
	      this.isSaving = false;
	      this.isEditWorkHours = true;
	      this.selectedUsers = [];
	      this.isShowAgreement = false;
	      this.agreements = '';
	      this.items = JSON.parse((0, _stringify2.default)(this.originalItems));
	      this.isWarningActive = false;
	    },
	    updateAgreements: function updateAgreements(val) {
	      this.agreements = val;
	    },
	    readUserNorm: function readUserNorm(user) {
	      var _this16 = this;
	
	      if (!this.activeSchoolYear || !this.activeSchoolYear.name) return;
	      _docendo2.default.schoolUserYearRead(this.schoolId, user.id, this.activeSchoolYear.name, function (success) {
	        _this16.theEditUserNorm = success.norm ? success.norm : [];
	        _this16.userAgreements = success.agreements ? success.agreements : '';
	      }, function (failure) {
	        console.log('failed!');
	      });
	    },
	    editUserNorm: function editUserNorm(user) {
	      this.setTheEditUser(user);
	    },
	    updateItemsWithSchoolSettings: function updateItemsWithSchoolSettings() {
	      var _this17 = this;
	
	      this.items.forEach(function (item) {
	        var setting = _this17.schoolSettings && _this17.schoolSettings[item.id];
	        if (setting) {
	          _this17.$set(item, 'hours', setting);
	        }
	      });
	      this.originalItems.forEach(function (item) {
	        var setting = _this17.schoolSettings && _this17.schoolSettings[item.id];
	        if (setting) {
	          _this17.$set(item, 'hours', setting);
	        }
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (!this.isLocalPoolActivated) {
	      var idx = this.items.findIndex(function (item) {
	        return item.id === 'assigned_pool_hours';
	      });
	      this.items.splice(idx, 1);
	    }
	  },
	  mounted: function mounted() {
	    this.originalItems = JSON.parse((0, _stringify2.default)(this.items));
	  }
	};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _AssignHoursNormList = __webpack_require__(338);
	
	var _AssignHoursNormList2 = _interopRequireDefault(_AssignHoursNormList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AssignHoursNormList: _AssignHoursNormList2.default, DModal: _DModal2.default },
	  props: {
	    user: {
	      type: Object,
	      default: null
	    },
	    schoolId: {
	      default: null
	    },
	    schoolYear: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isUpdating: false,
	      theEditUserNorm: null,
	      userAgreements: null,
	      isLoading: false,
	      itemsToSave: [],
	      nettoTime: null
	    };
	  },
	
	  methods: {
	    setItemsToSave: function setItemsToSave(arr) {
	      this.itemsToSave = arr;
	    },
	    setNettoTime: function setNettoTime(val) {
	      this.nettoTime = val;
	    },
	    validateNumber: function validateNumber(item) {
	      var itemsNotToValidate = ['hidden_ansættelsesgrad', 'Periode', 'hidden_periode_start', 'hidden_periode_end', 'Ansættelsesgrad'];
	      if (itemsNotToValidate.indexOf(item.title) > -1) {
	        return item.value;
	      }
	      var val = item.hours * 1;
	      return val.toFixed(2);
	    },
	    findArbejdstidFromItems: function findArbejdstidFromItems() {
	      var keys = ['Arbejdstid i perioden', 'Nettotid', 'Bruttotid', 'Arbejdstid'];
	      for (var i = 0; i < this.itemsToSave.length; i++) {
	        var it = this.itemsToSave[i];
	        if (!it || !it.title) continue;
	        if (keys.indexOf(it.title) > -1) {
	          return (it.value * 1).toFixed(2);
	        }
	        if (it.id === 'working_hours') {
	          return (it.hours * 1).toFixed(2);
	        }
	      }
	      return null;
	    },
	    onUpdate: function onUpdate() {
	      var _this = this;
	
	      if (!this.schoolYear || !this.schoolYear.name) {
	        console.error('Skoleår er ikke indlæst endnu');
	        return;
	      }
	      if (!this.user || !this.user.id) {
	        console.error('Bruger mangler');
	        return;
	      }
	
	      this.isUpdating = true;
	
	      var mapped = this.itemsToSave.map(function (item) {
	        return {
	          title: item.title,
	          value: _this.validateNumber(item)
	        };
	      });
	
	      var arbejdstid = this.nettoTime;
	      if (!arbejdstid) {
	        arbejdstid = this.findArbejdstidFromItems();
	      }
	      if (arbejdstid) {
	        mapped.push({
	          title: 'Arbejdstid',
	          value: arbejdstid
	        });
	      }
	
	      var payload = {
	        norm: mapped
	      };
	
	      if (arbejdstid) {
	        payload.assigned_total_hours = arbejdstid;
	      }
	
	
	      var dataToSave = [{
	        user_id: this.user.id,
	        data: payload
	      }];
	
	      _docendo2.default.bulkSchoolUserYearUpdate(this.schoolId, this.schoolYear.name, dataToSave, function (success) {
	        _docendo2.default.schoolUsers(_this.schoolId, [_this.user.id], function (success) {
	          var updatedUser = success[0];
	          _this.$store.commit('updateSchoolUser', updatedUser);
	          _this.$emit('updated');
	        }, function (failure) {
	          console.log('failure');
	        });
	      }, function (failure) {
	        _this.isUpdating = false;
	        console.error('Noget gik galt ved opdatering');
	      });
	    },
	    close: function close() {
	      this.$emit('close');
	    },
	    readUserNorm: function readUserNorm() {
	      var _this2 = this;
	
	      this.isLoading = true;
	      _docendo2.default.schoolUserYearRead(this.schoolId, this.user.id, this.schoolYear.name, function (success) {
	        _this2.theEditUserNorm = success.norm ? success.norm : [];
	        _this2.userAgreements = success.agreements ? success.agreements : '';
	        _this2.isLoading = false;
	      }, function (failure) {
	        console.log('failed!');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readUserNorm();
	  }
	};

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default, DateSelector: _DateSelector2.default },
	  props: {
	    schoolYear: {},
	    isKindergarten: {
	      type: Boolean,
	      default: false
	    },
	    theEditUserNorm: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isNetto: {
	      default: false,
	      type: Boolean
	    },
	    standardNettoHours: {
	      default: 1686.1
	    },
	    standardHolidayHours: {
	      default: 0
	    },
	    standardLocalAgreementHours: {
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      isEditPeriod: false,
	      initStartDate: null,
	      initEndDate: null,
	      startDate: null,
	      endDate: null,
	      isBruttoTid: true,
	      theSelectedWayToCalculate: 'day',
	      waysToCalculate: [{
	        title: '7.4 timer pr. dag: <span>Dvs. 7,4 timer pr. mulig arbejdsdag. Mulige arbejdsdage er dage i delperioden der ikke er weekenddage.</span>',
	        desc: '',
	        value: 'day'
	      }, {
	        title: '160.3 timer pr. måned: <span>Dvs. 1924 timer / 12 måneder. Så hvis man f.eks ansætter en ny pr. 1/9 2023, så er regnestykket: 1924 / 12 * 4 = årsnorm resten af året i de fire måneder.</span>',
	        desc: '',
	        value: 'month'
	      }],
	      hoursPerWeek: {
	        id: 'hours_per_week',
	        title: 'Timeansættelse pr. uge',
	        hours: 37,
	        standardHours: 37,
	        isFixed: false
	      },
	      employmentPercentage: {
	        id: 'employment_percentage',
	        title: 'Ansættelsesgrad',
	        hours: 100,
	        standardHours: 100,
	        unit: 'percentage',
	        isFixed: false
	      },
	      workingHours: {
	        id: 'working_hours',
	        title: 'Arbejdstid i perioden',
	        hours: this.standardNettoHours,
	        standardHours: this.standardNettoHours,
	        isFixed: true
	      },
	      standardItems: [{
	        id: 'holidays',
	        title: 'Søgnehelligdage',
	        hours: 0,
	        standardHours: 0,
	        userStandardHours: 0,
	        desc: 'Søgnehelligdage er helligdage, som ikke falder på en lørdag eller søndag',
	        isFixed: true,
	        isSelected: false
	      }, {
	        id: 'vacation',
	        title: 'Ferie',
	        inputType: 'number',
	        hours: 185.00,
	        standardHours: 185.00,
	        userStandardHours: 185.00,
	        unit: 'timer',
	        isFixed: true,
	        isSelected: false
	      }, {
	        id: 'vacation_6_week',
	        title: '6. Ferieuge',
	        inputType: 'number',
	        hours: 37.00,
	        standardHours: 37.00,
	        userStandardHours: 37.00,
	        unit: 'timer',
	        isFixed: true,
	        isSelected: false
	      }, { id: 'care_days', title: 'Omsorgsdage', hours: 0, standardHours: 0, isFixed: false, isSelected: false }, { id: 'senior_days', title: 'Seniordage', hours: 0, standardHours: 0, isFixed: false, isSelected: false }, {
	        id: 'age_reduction',
	        title: 'Aldersreduktion',
	        hours: 175,
	        standardHours: 175.00,
	        userStandardHours: 175.00,
	        isFixed: true,
	        isSelected: false,
	
	        isDeprecated: true
	      }, {
	        id: 'local_agreement_adjustment',
	        title: 'Tilpasning til lokalaftale',
	        hours: 0,
	        standardHours: 0,
	        userStandardHours: 0,
	        scalesWithEmploymentRate: true,
	        isFixed: false,
	        isSelected: false
	      }],
	      isEdit: false,
	      isAddNew: false,
	      newItemTitle: ''
	    };
	  },
	
	  computed: {
	    danishHolidays: function danishHolidays() {
	      return this.$store.state.danishHolidays.danishHolidays;
	    },
	    isErrorInStartDate: function isErrorInStartDate() {
	      if (this.theSelectedWayToCalculate === 'day') {
	        return false;
	      }
	      var date = (0, _moment2.default)(this.startDate);
	      var isFirstDay = date.date() === 1;
	      var isLastDay = date.clone().add(1, 'days').date() === 1;
	      return !isFirstDay && !isLastDay;
	    },
	    isErrorInEndDate: function isErrorInEndDate() {
	      if (this.theSelectedWayToCalculate === 'day') {
	        return false;
	      }
	      var date = (0, _moment2.default)(this.endDate);
	      var isFirstDay = date.date() === 1;
	      var isLastDay = date.clone().add(1, 'days').date() === 1;
	      return !isFirstDay && !isLastDay;
	    },
	    dateRangeFormatted: function dateRangeFormatted() {
	      return (0, _moment2.default)(this.startDate).format('ll') + ' - ' + (0, _moment2.default)(this.endDate).format('ll');
	    },
	    subtractedItems: function subtractedItems() {
	      return this.standardItems.filter(function (item) {
	        return item.isSelected;
	      });
	    },
	    possibleStandardItems: function possibleStandardItems() {
	      var _this = this;
	
	      var itemsOnlyForBrutto = ['holidays', 'vacation'];
	      return this.standardItems.filter(function (item) {
	        if (item.isDeprecated) return false;
	        return _this.isNetto ? !itemsOnlyForBrutto.includes(item.id) && !item.isSelected : !item.isSelected;
	      });
	    },
	    nettoTime: function nettoTime() {
	      var sums = this.subtractedItems.map(function (item) {
	        return item.hours * 1;
	      });
	      var subtract = this.subtractedItems.length < 1 ? 0 : sums.reduce(function (sum, val) {
	        return sum + val;
	      });
	      return parseFloat(this.workingHours.hours - subtract * 1).toFixed(2);
	    },
	    itemsToSave: function itemsToSave() {
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var periodStart = {
	        id: 'period_start',
	        title: 'hidden_periode_start',
	        isChecked: true,
	        value: startDate,
	        hours: startDate
	      };
	      var periodEnd = { id: 'period_end', title: 'hidden_periode_end', isChecked: true, value: endDate, hours: endDate };
	      var periodDates = { title: 'Periode', value: this.dateRangeFormatted };
	      var arr = [periodStart, periodEnd, periodDates];
	      if (this.isBruttoTid) {
	        var workPercentageHidden = { title: 'hidden_ansættelsesgrad', value: this.employmentPercentage.hours };
	        var workPercentage = { title: 'Ansættelsesgrad', value: this.employmentPercentage.hours + '%' };
	        arr.push(workPercentageHidden, workPercentage);
	      }
	      arr.push(this.hoursPerWeek);
	      arr.push(this.workingHours);
	      arr = arr.concat(this.subtractedItems);
	      return arr;
	    },
	    numberOfSchoolDays: function numberOfSchoolDays() {
	      function isNotWeekend(m) {
	        return (0, _moment2.default)(m).isoWeekday() !== 6 && (0, _moment2.default)(m).isoWeekday() !== 7;
	      }
	
	      var startDate = this.startDate;
	      var endDate = this.endDate;
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        if (isNotWeekend(m)) {
	          dateArray.push(m);
	        }
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray.length;
	    },
	    isOnlyPartOfSchoolYear: function isOnlyPartOfSchoolYear() {
	      var initStartDateFormatted = (0, _moment2.default)(this.initStartDate).format('YYYY-MM-DD');
	      var startDateFormatted = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var initEndDateFormatted = (0, _moment2.default)(this.initEndDate).format('YYYY-MM-DD');
	      var endDateFormatted = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      return initStartDateFormatted !== startDateFormatted || initEndDateFormatted !== endDateFormatted;
	    }
	  },
	  watch: {
	    itemsToSave: function itemsToSave() {
	      this.$emit('updated', this.itemsToSave);
	    },
	    nettoTime: function nettoTime() {
	      this.$emit('changedSum', this.nettoTime);
	    },
	    theEditUserNorm: function theEditUserNorm() {
	      var _this2 = this;
	
	      this.isEdit = true;
	      this.standardItems.forEach(function (standardItem, idx) {
	        _this2.standardItems[idx].isSelected = false;
	      });
	      this.initStartAndEndDate();
	      this.theEditUserNorm.forEach(function (normItem) {
	        var normItemHours = normItem.value * 1;
	        switch (normItem.title) {
	          case 'Timeansættelse pr. uge':
	            _this2.hoursPerWeek.hours = normItemHours;
	            break;
	          case 'Periode start':
	          case 'hidden_periode_start':
	            _this2.setStartDate(normItem.value);
	            break;
	          case 'Periode slut':
	          case 'hidden_periode_end':
	            _this2.setEndDate(normItem.value);
	            break;
	          case 'Bruttotid':
	          case 'Arbejdstid i perioden':
	            _this2.$emit('onEditBrutto');
	            _this2.workingHours.title = normItem.title;
	            _this2.workingHours.hours = normItemHours;
	            break;
	          case 'Nettotid':
	            _this2.workingHours.title = normItem.title;
	            _this2.$emit('onEditNetto');
	            _this2.workingHours.hours = normItemHours;
	            break;
	          case 'hidden_ansættelsesgrad':
	            _this2.employmentPercentage.hours = normItemHours;
	            break;
	          case 'Periode':
	          case 'Ansættelsesgrad':
	          case 'Arbejdstid':
	            break;
	          default:
	            var idx = _this2.standardItems.findIndex(function (item) {
	              return item.title === normItem.title;
	            });
	            if (idx > -1) {
	              _this2.standardItems[idx].hours = normItemHours;
	              if (_this2.standardItems[idx].scalesWithEmploymentRate) {
	                _this2.standardItems[idx].userStandardHours = normItemHours;
	              }
	              _this2.standardItems[idx].isSelected = true;
	            } else {
	              _this2.addOwn(normItem);
	            }
	            break;
	        }
	      });
	    },
	    numberOfSchoolDays: function numberOfSchoolDays() {
	      this.initData();
	    },
	    isNetto: function isNetto() {
	      if (!this.isEdit) {
	        this.initStartAndEndDate();
	      }
	      this.initData();
	    },
	    standardHolidayHours: function standardHolidayHours() {
	      if (this.isKindergarten || this.isBruttoTid) {
	        this.getHolidayHours();
	      }
	    },
	    standardLocalAgreementHours: function standardLocalAgreementHours() {
	      var idx = this.standardItems.findIndex(function (item) {
	        return item.id === 'local_agreement_adjustment';
	      });
	      if (idx === -1) return;
	      var savedStandard = this.standardLocalAgreementHours * 1;
	      if (!savedStandard || savedStandard <= 0) {
	        this.standardItems[idx].standardHours = 0;
	        this.standardItems[idx].userStandardHours = 0;
	        this.standardItems[idx].hours = 0;
	        return;
	      }
	      this.applyLocalAgreementStandard();
	    }
	  },
	  methods: {
	    onClickEditPeriod: function onClickEditPeriod() {
	      this.isEditPeriod = true;
	
	      this.initData(true);
	    },
	    setTheSelectedWayToCalculate: function setTheSelectedWayToCalculate(wayValue) {
	      this.theSelectedWayToCalculate = wayValue;
	
	      this.initData(this.isEditPeriod);
	    },
	    initData: function initData(force) {
	      var _this3 = this;
	
	      var weekly = this.hoursPerWeek && this.hoursPerWeek.hours ? this.hoursPerWeek.hours * 1 : null;
	      var percent = this.employmentPercentage && this.employmentPercentage.hours ? this.employmentPercentage.hours * 1 : null;
	      var employmentRate = weekly ? weekly / 37 : percent ? percent / 100 : 1;
	      if (!employmentRate || employmentRate <= 0) employmentRate = 1;
	
	      if (this.isEdit && !force) {
	        return;
	      }
	
	      this.workingHours.title = this.isNetto ? 'Nettotid' : 'Bruttotid';
	
	      var fullYearHours = this.isNetto ? this.standardNettoHours : 1924;
	
	      var fullTimeHoursInPeriod = fullYearHours;
	      if (this.isOnlyPartOfSchoolYear) {
	        if (this.theSelectedWayToCalculate === 'day') {
	          fullTimeHoursInPeriod = parseFloat(this.numberOfSchoolDays * 7.4).toFixed(2);
	        } else {
	          var startDate = (0, _moment2.default)(this.startDate);
	          var endDate = (0, _moment2.default)(this.endDate);
	          var isLastDayOfMonth = endDate.date() === endDate.clone().endOf('month').date();
	          var numberOfMonths = endDate.diff(startDate, 'months') + (isLastDayOfMonth ? 1 : 0);
	          var hoursOfWork = fullYearHours / 12 * numberOfMonths;
	          fullTimeHoursInPeriod = parseFloat(hoursOfWork).toFixed(2);
	        }
	      }
	
	      var hoursInPeriod = parseFloat(fullTimeHoursInPeriod * employmentRate).toFixed(2);
	
	      this.workingHours.hours = hoursInPeriod;
	      this.workingHours.standardHours = hoursInPeriod;
	
	      this.standardItems.forEach(function (item, key) {
	        var itemsToAdd = _this3.isNetto ? [] : ['vacation', 'holidays'];
	        var itemsToHide = _this3.isNetto ? ['vacation', 'holidays'] : [];
	        if (itemsToAdd.indexOf(item.id) > -1) _this3.standardItems[key].isSelected = true;
	        if (itemsToHide.indexOf(item.id) > -1) _this3.standardItems[key].isSelected = false;
	      });
	
	      this.getHolidayHours(employmentRate);
	
	      this.standardItems.forEach(function (item) {
	        var base = item.userStandardHours ? item.userStandardHours : item.standardHours;
	        if (typeof base === 'number') {
	          item.hours = parseFloat(base * employmentRate).toFixed(2);
	        }
	      });
	    },
	    setStartDate: function setStartDate(date) {
	      var _this4 = this;
	
	      this.startDate = date;
	      setTimeout(function (_) {
	        _this4.isEdit = false;
	      });
	    },
	    setEndDate: function setEndDate(date) {
	      var _this5 = this;
	
	      this.endDate = date;
	      setTimeout(function (_) {
	        _this5.isEdit = false;
	      });
	    },
	    employmentPercentageChanged: function employmentPercentageChanged(val) {
	      var inHours = val / 100 * 37;
	      this.hoursPerWeek.hours = parseFloat(inHours.toFixed(2));
	      this.hoursPerWeekChanged(inHours, false);
	    },
	    hoursPerWeekChanged: function hoursPerWeekChanged(val, changePercentage) {
	      var employmentRate = val / 37;
	      if (changePercentage) {
	        var percentage = employmentRate * 100;
	        percentage = percentage.toFixed(0);
	        this.employmentPercentage.hours = percentage;
	      }
	      this.$emit('changedEmploymentRate', employmentRate);
	      this.workingHours.hours = parseFloat(this.workingHours.standardHours * employmentRate).toFixed(2);
	      this.standardItems.forEach(function (item) {
	        if (item.userStandardHours) {
	          item.hours = parseFloat(item.userStandardHours * employmentRate).toFixed(2);
	        } else {
	          if (item.standardHours) {
	            item.hours = parseFloat(item.standardHours * employmentRate).toFixed(2);
	          }
	        }
	      });
	    },
	    onEditWorkingHours: function onEditWorkingHours(value) {
	      this.workingHours.standardHours = value;
	      this.workingHours.isFixed = false;
	      if (this.isNetto) {
	        this.$emit('onEditedStandardWorkingHours', value);
	      }
	    },
	    setSubtractedItemValue: function setSubtractedItemValue(item, value) {
	      var idx = this.standardItems.findIndex(function (standardItem) {
	        return standardItem.id === item.id;
	      });
	      if (item.userStandardHours || item.scalesWithEmploymentRate) {
	        this.standardItems[idx].userStandardHours = value * 1;
	      }
	      if (!item.standardHours || item.standardHours * 1 !== value * 1) {
	        this.standardItems[idx].isFixed = false;
	      } else {
	        this.standardItems[idx].isFixed = true;
	      }
	    },
	    onClickEditHolidaysStandard: function onClickEditHolidaysStandard() {
	      var holidaysInPeriod = this.getHolidaysInPeriodWithMeta();
	      var standardDayCount = holidaysInPeriod.filter(function (h) {
	        return h.isStandard;
	      }).length;
	      var calculatedFullTimeValue = parseFloat(standardDayCount * 7.4).toFixed(2);
	
	      var savedStandard = this.standardHolidayHours * 1;
	      var fullTimeValue = savedStandard > 0 ? savedStandard : calculatedFullTimeValue;
	
	      this.$emit('onOpenHolidaysSettings', {
	        fullTimeValue: fullTimeValue,
	        holidays: holidaysInPeriod,
	        standardDayCount: standardDayCount,
	        calculatedFullTimeValue: calculatedFullTimeValue,
	        isReadOnly: this.isOnlyPartOfSchoolYear
	      });
	    },
	    onClickEditLocalAgreementStandard: function onClickEditLocalAgreementStandard() {
	      var savedStandard = this.standardLocalAgreementHours * 1;
	      this.$emit('onOpenLocalAgreementSettings', {
	        fullTimeValue: savedStandard > 0 ? savedStandard : 0
	      });
	    },
	    currentEmploymentRate: function currentEmploymentRate() {
	      var weekly = this.hoursPerWeek && this.hoursPerWeek.hours ? this.hoursPerWeek.hours * 1 : null;
	      var percent = this.employmentPercentage && this.employmentPercentage.hours ? this.employmentPercentage.hours * 1 : null;
	      var rate = weekly ? weekly / 37 : percent ? percent / 100 : 1;
	      if (!rate || rate <= 0) rate = 1;
	      return rate;
	    },
	    applyLocalAgreementStandard: function applyLocalAgreementStandard() {
	      var idx = this.standardItems.findIndex(function (item) {
	        return item.id === 'local_agreement_adjustment';
	      });
	      if (idx === -1) return;
	      var savedStandard = this.standardLocalAgreementHours * 1;
	      if (!savedStandard || savedStandard <= 0) return;
	      var rate = this.currentEmploymentRate();
	      this.standardItems[idx].standardHours = savedStandard;
	      this.standardItems[idx].userStandardHours = savedStandard;
	      this.standardItems[idx].hours = parseFloat(savedStandard * rate).toFixed(2);
	
	      this.standardItems[idx].isSelected = true;
	    },
	    getHolidaysInPeriodWithMeta: function getHolidaysInPeriodWithMeta() {
	      var _this6 = this;
	
	      if (!this.startDate || !this.endDate) return [];
	      var start = (0, _moment2.default)(this.startDate);
	      var end = (0, _moment2.default)(this.endDate);
	      var seen = {};
	      var list = [];
	      this.danishHolidays.forEach(function (dateStr) {
	        if (seen[dateStr]) return;
	        seen[dateStr] = true;
	        var mDate = (0, _moment2.default)(dateStr, 'DD-MM-YYYY');
	        if (!mDate.isValid()) return;
	        if (mDate.isBefore(start, 'day') || mDate.isAfter(end, 'day')) return;
	        list.push({
	          date: dateStr,
	          sortKey: mDate.valueOf(),
	          formatted: mDate.format('dddd [d.] D. MMMM YYYY'),
	          name: _this6.getDanishHolidayName(mDate),
	          isStandard: mDate.isoWeekday() < 6
	        });
	      });
	      list.sort(function (a, b) {
	        return a.sortKey - b.sortKey;
	      });
	      var standardCounter = 0;
	      list.forEach(function (item) {
	        if (item.isStandard) {
	          standardCounter++;
	          item.standardIndex = standardCounter;
	        }
	      });
	      return list;
	    },
	    getDanishHolidayName: function getDanishHolidayName(mDate) {
	      var month = mDate.month() + 1;
	      var day = mDate.date();
	      var year = mDate.year();
	
	      var fixedDates = {
	        '1-1': 'Nytårsdag',
	        '5-6': 'Grundlovsdag',
	        '24-12': 'Juleaftensdag',
	        '25-12': 'Juledag',
	        '26-12': '2. juledag',
	        '31-12': 'Nytårsaftensdag'
	      };
	      var fixedKey = day + '-' + month;
	      if (fixedDates[fixedKey]) {
	        return fixedDates[fixedKey];
	      }
	
	      var easter = this.getEasterSunday(year);
	      var diff = mDate.clone().startOf('day').diff(easter.clone().startOf('day'), 'days');
	      var easterRelative = {
	        '-3': 'Skærtorsdag',
	        '-2': 'Langfredag',
	        '0': 'Påskedag',
	        '1': '2. påskedag',
	        '26': 'Store bededag',
	        '39': 'Kristi Himmelfartsdag',
	        '49': 'Pinsedag',
	        '50': '2. pinsedag'
	      };
	      if (easterRelative[diff]) {
	        return easterRelative[diff];
	      }
	
	      return '';
	    },
	    getEasterSunday: function getEasterSunday(year) {
	      var a = year % 19;
	      var b = Math.floor(year / 100);
	      var c = year % 100;
	      var d = Math.floor(b / 4);
	      var e = b % 4;
	      var f = Math.floor((b + 8) / 25);
	      var g = Math.floor((b - f + 1) / 3);
	      var h = (19 * a + b - d - g + 15) % 30;
	      var i = Math.floor(c / 4);
	      var k = c % 4;
	      var l = (32 + 2 * e + 2 * i - h - k) % 7;
	      var m = Math.floor((a + 11 * h + 22 * l) / 451);
	      var monthOneBased = Math.floor((h + l - 7 * m + 114) / 31);
	      var dayOfMonth = (h + l - 7 * m + 114) % 31 + 1;
	      return (0, _moment2.default)({ year: year, month: monthOneBased - 1, day: dayOfMonth });
	    },
	    setItemValue: function setItemValue(item, idx, value) {
	      if (!this.items[idx].standardHours || this.items[idx].standardHours * 1 !== value * 1) {
	        this.items[idx].isFixed = false;
	      } else {
	        this.items[idx].isFixed = true;
	      }
	    },
	    setIsAddNew: function setIsAddNew(bool) {
	      var _this7 = this;
	
	      if (bool) {
	        this.isAddNew = true;
	        this.$nextTick(function (_) {
	          _this7.$refs.add_new_input.focus();
	        });
	      } else {
	        this.isAddNew = false;
	      }
	    },
	    addFromStandard: function addFromStandard(item) {
	      var idx = this.standardItems.findIndex(function (standardItem) {
	        return standardItem.id === item.id;
	      });
	      this.standardItems[idx].isSelected = true;
	    },
	    addOwn: function addOwn(item) {
	      var newItem = {
	        id: new Date().getTime(),
	        title: this.newItemTitle,
	        hours: 0,
	        isFixed: false,
	        isSelected: true,
	        isOwn: true
	      };
	      if (item && item.title) {
	        newItem.id = item.title;
	        newItem.title = item.title;
	        newItem.hours = item.value * 1;
	      }
	      this.standardItems.push(newItem);
	      this.reset();
	    },
	    deleteItem: function deleteItem(item) {
	      var idx = this.standardItems.findIndex(function (standardItem) {
	        return standardItem.id === item.id;
	      });
	      if (item.isOwn) {
	        this.standardItems.splice(idx, 1);
	        return;
	      }
	      this.standardItems[idx].hours = this.standardItems[idx].standardHours;
	      this.standardItems[idx].isFixed = true;
	      this.standardItems[idx].isSelected = false;
	    },
	    reset: function reset() {
	      this.newItemTitle = '';
	      this.isAddNew = false;
	    },
	    getHolidaysWithinSchoolYearRange: function getHolidaysWithinSchoolYearRange() {
	      var start = this.startDate;
	      var end = this.endDate;
	      return this.danishHolidays.filter(function (date) {
	        var mDate = (0, _moment2.default)(date, 'DD-MM-YYYY');
	        if (!mDate.isValid()) return false;
	
	        var isAfterStart = mDate.isSameOrAfter(start, 'day');
	        var isBeforeEnd = mDate.isSameOrBefore(end, 'day');
	        var isNotWeekend = mDate.isoWeekday() < 6;
	        return isAfterStart && isBeforeEnd && isNotWeekend;
	      });
	    },
	    getHolidayHours: function getHolidayHours(employmentRate) {
	      var rate = employmentRate;
	      if (!rate) {
	        var weekly = this.hoursPerWeek && this.hoursPerWeek.hours ? this.hoursPerWeek.hours * 1 : null;
	        var percent = this.employmentPercentage && this.employmentPercentage.hours ? this.employmentPercentage.hours * 1 : null;
	        rate = weekly ? weekly / 37 : percent ? percent / 100 : 1;
	        if (!rate || rate <= 0) rate = 1;
	      }
	
	      var savedStandard = this.standardHolidayHours * 1;
	      var holidayHoursFullTime = void 0;
	      if (savedStandard > 0 && !this.isOnlyPartOfSchoolYear) {
	        holidayHoursFullTime = savedStandard;
	      } else {
	        var holidays = this.getHolidaysWithinSchoolYearRange();
	        holidayHoursFullTime = holidays.length * 7.4;
	      }
	      var holidayHours = parseFloat(holidayHoursFullTime * rate).toFixed(2);
	
	      var holidayIdx = this.standardItems.findIndex(function (item) {
	        return item.id === 'holidays';
	      });
	      if (holidayIdx > -1) {
	        this.standardItems[holidayIdx].standardHours = holidayHours;
	        this.standardItems[holidayIdx].hours = holidayHours;
	        this.standardItems[holidayIdx].userStandardHours = holidayHours;
	      }
	    },
	    initStartAndEndDate: function initStartAndEndDate() {
	      if (this.isKindergarten) {
	        this.startDate = (0, _moment2.default)(this.schoolYear.employee_time_start).set({
	          month: 0,
	          date: 1
	        });
	        this.endDate = (0, _moment2.default)(this.schoolYear.employee_time_end).set({
	          month: 11,
	          date: 31
	        });
	      } else {
	        this.startDate = (0, _moment2.default)(this.schoolYear.employee_time_start).set({
	          month: 7,
	          date: 1
	        });
	        this.endDate = (0, _moment2.default)(this.schoolYear.employee_time_end).set({
	          month: 6,
	          date: 31
	        });
	      }
	      this.initStartDate = this.startDate.clone();
	      this.initEndDate = this.endDate.clone();
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.initStartAndEndDate();
	    this.applyLocalAgreementStandard();
	    if (this.isNetto) {
	      this.workingHours.title = 'Nettotid';
	      return;
	    }
	    if (this.isKindergarten || this.isBruttoTid) {
	      this.getHolidayHours();
	    }
	    if (this.isBruttoTid) {
	      this.workingHours.title = 'Bruttotid';
	    }
	  }
	};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(51);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _ColorPicker = __webpack_require__(68);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _preparationFactor = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default, ColorPicker: _ColorPicker2.default },
	  props: {
	    users: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    schoolId: {
	      default: null
	    },
	    schoolYearId: {
	      default: null
	    },
	    isLocalPoolActivated: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      selectedUserIds: [],
	      mode: 'new',
	      selectedBrikKey: null,
	      isSaving: false,
	      newBrik: {
	        name: '',
	        subject_type: 'additional_tasks',
	        color: '#999999'
	      }
	    };
	  },
	
	  computed: {
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash || {};
	    },
	    allowedTypes: function allowedTypes() {
	      var types = [{ value: 'additional_tasks', name: 'Øvrige opgaver' }, { value: 'club', name: 'SFO' }];
	      if (this.isLocalPoolActivated) {
	        types.push({ value: 'pool', name: this.$store.getters.localPoolTitle || 'Lokalpulje' });
	      }
	      return types;
	    },
	    selectedUsers: function selectedUsers() {
	      var _this = this;
	
	      return this.users.filter(function (user) {
	        return _this.selectedUserIds.indexOf(user.id) > -1;
	      });
	    },
	    isAllSelected: function isAllSelected() {
	      return this.users.length > 0 && this.selectedUsers.length === this.users.length;
	    },
	    selectedRestSum: function selectedRestSum() {
	      return this.selectedUsers.reduce(function (sum, user) {
	        return sum + user.rest;
	      }, 0);
	    },
	    existingBriks: function existingBriks() {
	      var allowed = this.allowedTypes.map(function (t) {
	        return t.value;
	      });
	      var groups = {};(this.$store.state.subjects.subjects || []).forEach(function (subject) {
	        if (allowed.indexOf(subject.subject_type) === -1 || subject.task_overview === false) {
	          return;
	        }
	        var key = subject.subject_type + ';' + subject.name;
	        if (!groups[key]) {
	          groups[key] = {
	            key: key,
	            name: subject.name,
	            subject_type: subject.subject_type,
	            subjects: []
	          };
	        }
	        groups[key].subjects.push(subject);
	      });
	      return (0, _keys2.default)(groups).map(function (key) {
	        return groups[key];
	      }).sort(function (a, b) {
	        return a.name.localeCompare(b.name, 'da-DK');
	      });
	    },
	    selectedBrik: function selectedBrik() {
	      var _this2 = this;
	
	      return this.existingBriks.find(function (brik) {
	        return brik.key === _this2.selectedBrikKey;
	      }) || null;
	    },
	    canSubmit: function canSubmit() {
	      if (this.isSaving || this.selectedUsers.length === 0) {
	        return false;
	      }
	      if (this.mode === 'new') {
	        return this.newBrik.name.trim().length > 0 && !!this.newBrik.subject_type;
	      }
	      return !!this.selectedBrik;
	    }
	  },
	  methods: {
	    close: function close() {
	      if (this.isSaving) {
	        return;
	      }
	      this.$emit('close');
	    },
	    formatHours: function formatHours(value) {
	      var num = parseFloat(value);
	      return isNaN(num) ? '' : num.toFixed(1);
	    },
	    roundHours: function roundHours(value) {
	      return Math.round(value * 100) / 100;
	    },
	    typeName: function typeName(subjectType) {
	      var type = this.allowedTypes.find(function (t) {
	        return t.value === subjectType;
	      });
	      return type ? type.name : subjectType;
	    },
	    isSelected: function isSelected(userId) {
	      return this.selectedUserIds.indexOf(userId) > -1;
	    },
	    toggleUser: function toggleUser(userId) {
	      var idx = this.selectedUserIds.indexOf(userId);
	      if (idx > -1) {
	        this.selectedUserIds.splice(idx, 1);
	      } else {
	        this.selectedUserIds.push(userId);
	      }
	    },
	    toggleAll: function toggleAll() {
	      this.selectedUserIds = this.isAllSelected ? [] : this.users.map(function (user) {
	        return user.id;
	      });
	    },
	    isUserCalendar: function isUserCalendar(calId) {
	      var cal = this.allCalendarsInHash[calId];
	      return !!(cal && cal.type === 'user');
	    },
	    subjectHasUser: function subjectHasUser(subject, calId) {
	      if ((0, _preparationFactor.sameCalendarId)(subject.calendar_id, calId)) {
	        return true;
	      }
	      return (subject.cals || []).some(function (cal) {
	        return cal.calendar_type === 'user' && (0, _preparationFactor.sameCalendarId)(cal.id, calId);
	      });
	    },
	    apiCall: function apiCall(fn) {
	      return new _promise2.default(function (resolve, reject) {
	        fn(function (data) {
	          if (data && data.status === 'error') {
	            reject(data);
	            return;
	          }
	          resolve(typeof data === 'string' ? JSON.parse(data) : data);
	        }, reject);
	      });
	    },
	    subjectPayload: function subjectPayload(template, calId, hours) {
	      return {
	        name: template.name,
	        color: template.color,
	        subject_type: template.subject_type,
	        default_duration: template.default_duration != null ? template.default_duration : 60,
	        preparation: template.preparation != null ? template.preparation : null,
	        can_schedule: !!template.can_schedule,
	        from_date: template.from_date || null,
	        to_date: template.to_date || null,
	        calendar_id: calId,
	        calendar_ids: [],
	        hours: hours
	      };
	    },
	    createSubjects: function createSubjects(payloads) {
	      var _this3 = this;
	
	      if (payloads.length === 0) {
	        return _promise2.default.resolve();
	      }
	      return this.apiCall(function (ok, fail) {
	        return _docendo2.default.bulkCreateSubjects(_this3.schoolId, _this3.schoolYearId, payloads, ok, fail);
	      });
	    },
	    setUserHours: function setUserHours(subject, calId, hours) {
	      return this.apiCall(function (ok, fail) {
	        return _docendo2.default.setHoursForTeacherOnSubject(subject.id, subject.school_id, subject.school_year_id, calId, hours, ok, fail);
	      });
	    },
	    addRestToSubject: function addRestToSubject(subject, calId, rest) {
	      var hours = this.roundHours((0, _preparationFactor.getVHoursForSubject)(subject, calId) + rest);
	      var hasCalendarHours = (subject.subject_calendars || []).some(function (sc) {
	        return sc.hours != null;
	      });
	      if ((0, _preparationFactor.sameCalendarId)(subject.calendar_id, calId) && !hasCalendarHours) {
	        return this.apiCall(function (ok, fail) {
	          return _docendo2.default.bulkUpdateSubjects(subject.school_id, [subject.id], { hours: hours }, ok, fail);
	        });
	      }
	      return this.setUserHours(subject, calId, hours);
	    },
	    addUserToSharedSubject: function addUserToSharedSubject(subject, calId, rest) {
	      var _this4 = this;
	
	      return this.apiCall(function (ok, fail) {
	        return _docendo2.default.bulkUpdateSubjects(subject.school_id, [subject.id], { add_calendar_id: calId }, ok, fail);
	      }).then(function () {
	        return _this4.setUserHours(subject, calId, _this4.roundHours(rest));
	      });
	    },
	    transferToNewBrik: function transferToNewBrik() {
	      var _this5 = this;
	
	      var template = {
	        name: this.newBrik.name.trim(),
	        color: this.newBrik.color,
	        subject_type: this.newBrik.subject_type,
	        can_schedule: false
	      };
	      var payloads = this.selectedUsers.map(function (user) {
	        return _this5.subjectPayload(template, user.user_calendar_id, _this5.roundHours(user.rest));
	      });
	      return this.createSubjects(payloads).then(function () {
	        return { failed: 0 };
	      });
	    },
	    transferToExistingBrik: function transferToExistingBrik() {
	      var _this6 = this;
	
	      var subjects = this.selectedBrik.subjects;
	      var template = subjects.find(function (s) {
	        return _this6.isUserCalendar(s.calendar_id);
	      }) || subjects[0];
	      var sharedSubject = subjects.find(function (s) {
	        return s.calendar_id && !_this6.isUserCalendar(s.calendar_id);
	      });
	      var toCreate = [];
	      var operations = [];
	      this.selectedUsers.forEach(function (user) {
	        var calId = user.user_calendar_id;
	        var subject = subjects.find(function (s) {
	          return _this6.subjectHasUser(s, calId);
	        });
	        if (subject) {
	          operations.push(_this6.addRestToSubject(subject, calId, user.rest));
	        } else if (sharedSubject) {
	          operations.push(_this6.addUserToSharedSubject(sharedSubject, calId, user.rest));
	        } else {
	          toCreate.push(_this6.subjectPayload(template, calId, _this6.roundHours(user.rest)));
	        }
	      });
	      operations.push(this.createSubjects(toCreate));
	      return _promise2.default.all(operations.map(function (op) {
	        return op.then(function () {
	          return true;
	        }, function () {
	          return false;
	        });
	      })).then(function (results) {
	        return { failed: results.filter(function (ok) {
	            return !ok;
	          }).length };
	      });
	    },
	    submit: function submit() {
	      var _this7 = this;
	
	      if (!this.canSubmit) {
	        return;
	      }
	      this.isSaving = true;
	      var transfer = this.mode === 'new' ? this.transferToNewBrik() : this.transferToExistingBrik();
	      transfer.then(function (result) {
	        _this7.isSaving = false;
	        if (result.failed > 0) {
	          _eventbus2.default.toast = { text: 'Resten kunne ikke overføres for alle personer - tjek tallene', success: false };
	        } else {
	          _eventbus2.default.toast = { text: 'Resten er overført til brikken', success: true };
	        }
	        _this7.$emit('transferred');
	        _this7.$emit('close');
	      }, function () {
	        _this7.isSaving = false;
	        _eventbus2.default.toast = { text: 'Kunne ikke overføre resten - prøv igen', success: false };
	      });
	    }
	  }
	};

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _isInteger = __webpack_require__(73);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _extends4 = __webpack_require__(6);
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	var _values = __webpack_require__(33);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _slicedToArray2 = __webpack_require__(35);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _set = __webpack_require__(27);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _preparationFactor = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS = [{ id: 'scheduled', title: 'Skemalagt', api: 'skemadage', description: 'Timerne, der er skemalagt i perioden.' }, { id: 'school_days', title: 'Elevdage', api: 'skoledage', description: 'Tildelte timer fordelt efter antal elevdage i perioden.' }, { id: 'actual_days', title: 'Faktiske dage', api: 'faktiskedage', description: 'Tildelte timer fordelt på opgavens dage i perioden.' }, { id: 'assessment', title: 'Egen vurdering', api: 'vurdering', description: 'Du angiver selv timerne for perioden.', isManual: true }];
	var NUMBER_FIELDS = {
	  vacation_days_taken: {
	    invalid: 'Feriedage skal være et tal, f.eks. 2 eller 2,5.',
	    failed: 'Feriedagene kunne ikke gemmes. Prøv igen.'
	  }
	};
	var HOURS_PER_FULL_TIME_WEEK = 37;
	var MASTER_TYPE_ORDER = ['teaching', 'preparation', 'other', 'pool', 'club', 'with_kids', 'without_kids', 'flextime', 'absence', 'unknown'];
	var API_TO_METHOD = METHODS.reduce(function (map, method) {
	  map[method.api] = method.id;
	  return map;
	}, {});
	function toNumber(value) {
	  var num = parseFloat(value);
	  return isNaN(num) ? 0 : num;
	}
	
	function toNullableNumber(value) {
	  if (value === '' || value === null || value === undefined) return null;
	  var num = parseFloat(String(value).replace(',', '.'));
	  return isNaN(num) ? null : num;
	}
	
	function escapeHtml(value) {
	  return String(value).replace(/[&<>"']/g, function (char) {
	    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
	  });
	}
	
	function countWeekdays(from, to, excludedDays) {
	  var count = 0;
	  var day = (0, _moment2.default)(from);
	  var end = (0, _moment2.default)(to);
	  while (day.isSameOrBefore(end, 'day')) {
	    var isWeekend = day.isoWeekday() === 6 || day.isoWeekday() === 7;
	    if (!isWeekend && !(excludedDays && excludedDays[day.format('YYYY-MM-DD')])) {
	      count++;
	    }
	    day = day.add(1, 'days');
	  }
	  return count;
	}
	
	exports.default = {
	  components: { DatePickerRange: _DatePickerRange2.default },
	  props: {
	    schoolId: {},
	    users: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    savedStatement: {
	      type: Object,
	      default: null
	    }
	  },
	  data: function data() {
	    var schoolYear = this.$store.state.localActivatedSchoolYear;
	    var saved = this.savedStatement;
	    return {
	      methods: METHODS,
	      userId: saved ? saved.user_id : null,
	      startDate: saved ? saved.from_date : schoolYear ? (0, _moment2.default)(schoolYear.employee_time_start).format('YYYY-MM-DD') : null,
	      endDate: saved ? saved.to_date : (0, _moment2.default)().endOf('month').format('YYYY-MM-DD'),
	      statement: null,
	      isLoadingStatement: false,
	      isTogglingClosed: false,
	      numberDrafts: { vacation_days_taken: null },
	      errorMessage: null,
	      rows: {},
	      userYear: null,
	      yearTasks: [],
	      isLoadingOriginal: false
	    };
	  },
	
	  computed: {
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    schoolYearName: function schoolYearName() {
	      return this.activeSchoolYear ? this.activeSchoolYear.name : '';
	    },
	    period: function period() {
	      return { userId: this.userId, startDate: this.startDate, endDate: this.endDate };
	    },
	    isPeriodValid: function isPeriodValid() {
	      return Boolean(this.userId) && (0, _moment2.default)(this.startDate).isValid() && (0, _moment2.default)(this.endDate).isValid() && !(0, _moment2.default)(this.endDate).isBefore(this.startDate);
	    },
	    periodKey: function periodKey() {
	      return this.isPeriodValid ? [this.userId, this.startDate, this.endDate].join('|') : null;
	    },
	    originalNorm: function originalNorm() {
	      var norm = this.userYear && Array.isArray(this.userYear.norm) ? this.userYear.norm : [];
	      return norm.filter(function (item) {
	        return item && item.title && item.title.indexOf('hidden_') !== 0;
	      });
	    },
	    originalNormBody: function originalNormBody() {
	      return this.originalNorm.slice(0, -1);
	    },
	    originalNormFooter: function originalNormFooter() {
	      return this.originalNorm[this.originalNorm.length - 1];
	    },
	    originalWorkHours: function originalWorkHours() {
	      return toNumber(this.userYear && this.userYear.assigned_total_hours);
	    },
	    originalTypes: function originalTypes() {
	      var types = {};
	      this.yearTasks.forEach(function (task) {
	        if (!types[task.master_type]) {
	          types[task.master_type] = { assigned: 0, scheduled: 0 };
	        }
	        types[task.master_type].assigned += toNumber(task.hours);
	        types[task.master_type].scheduled += toNumber(task.actual);
	      });
	      return types;
	    },
	    originalScheduledTotal: function originalScheduledTotal() {
	      var _this = this;
	
	      return this.summaryTypes.reduce(function (sum, type) {
	        return sum + _this.originalByType(type).scheduled;
	      }, 0);
	    },
	    originalRest: function originalRest() {
	      var _this2 = this;
	
	      return this.summaryTypes.reduce(function (sum, type) {
	        return sum - _this2.originalByType(type).assigned;
	      }, this.originalWorkHours);
	    },
	    summaryTypes: function summaryTypes() {
	      var _this3 = this;
	
	      var types = new _set2.default(this.groups.map(function (group) {
	        return group.type;
	      }));
	      (0, _keys2.default)(this.originalTypes).forEach(function (type) {
	        var values = _this3.originalTypes[type];
	        if (values.assigned !== 0 || values.scheduled !== 0) types.add(type);
	      });
	      if (this.originalPreparation !== 0 || this.periodPreparation !== 0) types.add('preparation');
	      types.delete('absence');
	      return this.sortMasterTypes([].concat((0, _toConsumableArray3.default)(types)));
	    },
	    hoursPerWeek: function hoursPerWeek() {
	      return HOURS_PER_FULL_TIME_WEEK * toNumber(this.statement && this.statement.employment_percent);
	    },
	    selectedUserName: function selectedUserName() {
	      var _this4 = this;
	
	      var user = this.users.find(function (user) {
	        return user.id === _this4.period.userId;
	      });
	      return user ? user.name : '';
	    },
	    statementTitle: function statementTitle() {
	      if (!this.selectedUserName || !(0, _moment2.default)(this.period.startDate).isValid() || !(0, _moment2.default)(this.period.endDate).isValid()) {
	        return 'Opgørelse af ansættelse';
	      }
	      return 'Opgørelse af ansættelse for ' + this.selectedUserName + ', ' + this.periodFormatted;
	    },
	    isClosed: function isClosed() {
	      return Boolean(this.statement && this.statement.closed_at);
	    },
	    closedLabel: function closedLabel() {
	      var _this5 = this;
	
	      if (!this.isClosed) return '';
	      var closedBy = this.users.find(function (user) {
	        return Number(user.id) === Number(_this5.statement.closed_by_id);
	      }) || this.$store.getters.allUsersInHash[this.statement.closed_by_id];
	      var label = 'd. ' + (0, _moment2.default)(this.statement.closed_at).format('LLL');
	      return closedBy ? label + ' af ' + closedBy.name : label;
	    },
	    periodFormatted: function periodFormatted() {
	      return (0, _moment2.default)(this.period.startDate).format('LL') + ' - ' + (0, _moment2.default)(this.period.endDate).format('LL');
	    },
	    schoolDaysInPeriod: function schoolDaysInPeriod() {
	      return Math.round(toNumber(this.statement && this.statement.skoledage));
	    },
	    holidays: function holidays() {
	      return this.statement && this.statement.helligdage || [];
	    },
	    holidaysTooltip: function holidaysTooltip() {
	      return this.holidays.map(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            date = _ref2[0],
	            name = _ref2[1];
	
	        return (0, _moment2.default)(date).format('D. MMM YYYY') + ' ' + name;
	      }).join(', ');
	    },
	    prepFactor: function prepFactor() {
	      var settings = this.$store.state.schoolSettings || {};
	      var isDanish = this.$store.getters.locale === 'da' && String(this.$store.getters.schoolCountry).toLowerCase() === 'dk';
	      if (!isDanish || !this.isPoolsDeactivated) return null;
	      return (0, _preparationFactor.parseNumericPreparationFactor)(settings.prepFactor);
	    },
	    isPoolsDeactivated: function isPoolsDeactivated() {
	      return Boolean((this.$store.state.schoolSettings || {}).deactivatePools);
	    },
	    isUserInGroupWithoutPrepFactor: function isUserInGroupWithoutPrepFactor() {
	      var tagsWithout = this.$store.getters.userTagsWithoutPrepFactor || [];
	      var user = this.$store.getters.allUsersInHash && this.$store.getters.allUsersInHash[this.userId];
	      var userTags = user && Array.isArray(user.user_tags) ? user.user_tags : [];
	      return userTags.some(function (tag) {
	        return tagsWithout.includes(tag);
	      });
	    },
	    originalPreparation: function originalPreparation() {
	      var _this6 = this;
	
	      if (this.prepFactor === null) {
	        if (this.isPoolsDeactivated) return 0;
	        return toNumber(this.userYear && this.userYear.assigned_preparation_hours);
	      }
	      if (this.isUserInGroupWithoutPrepFactor) return 0;
	      return this.yearTasks.reduce(function (sum, task) {
	        if (task.substitute || task.master_type !== 'teaching' || task.subject_type === 'preparation') return sum;
	        return sum + toNumber(task.hours) * (0, _preparationFactor.effectivePreparationFactor)(task.preparation, _this6.prepFactor);
	      }, 0);
	    },
	    periodPreparation: function periodPreparation() {
	      var _this7 = this;
	
	      if (this.isClosed) return toNumber(this.statement.preparation_hours);
	      if (this.prepFactor === null) {
	        return this.originalWorkHours > 0 ? this.originalPreparation * this.periodWorkHours / this.originalWorkHours : 0;
	      }
	      if (this.isUserInGroupWithoutPrepFactor) return 0;
	      var teaching = this.groups.find(function (group) {
	        return group.type === 'teaching';
	      });
	      if (!teaching) return 0;
	      return teaching.rows.reduce(function (sum, row) {
	        if (row.task.substitute || row.task.subject_type === 'preparation') return sum;
	        return sum + _this7.rowHours(row) * (0, _preparationFactor.effectivePreparationFactor)(row.task.preparation, _this7.prepFactor);
	      }, 0);
	    },
	    explanationTippy: function explanationTippy() {
	      return {
	        arrow: true,
	        allowHTML: true,
	        placement: 'left',
	        maxWidth: 420,
	        zIndex: 999999992,
	        onShow: function onShow(instance) {
	          return instance.setContent(instance.reference.getAttribute('content'));
	        }
	      };
	    },
	    workHoursExplanation: function workHoursExplanation() {
	      var statement = this.statement || {};
	      var percent = Math.round(toNumber(statement.employment_percent) * 100) + ' %';
	      return '<b>Arbejdstid i perioden</b><br>' + 'Hverdage i perioden minus søgnehelligdage og feriedage, ganget med 7,4 timer og ansættelsesgraden.<br><br>' + '<b>Regneeksempel</b><br>' + this.formatDays(statement.brutto_dage) + ' − ' + this.formatDays(statement.helligdage_dage) + ' − ' + this.formatDays(statement.feriedage) + ' = ' + this.formatDays(statement.arbejdsdage) + ' arbejdsdage<br>' + this.formatDays(statement.arbejdsdage) + ' × 7.4 × ' + percent + ' = ' + this.format(this.periodWorkHours);
	    },
	    restExplanation: function restExplanation() {
	      var _this8 = this;
	
	      var parts = this.summaryTypes.map(function (type) {
	        return _this8.format(_this8.groupHoursByType(type));
	      });
	
	      var absence = this.groupHoursByType('absence');
	      if (absence !== 0) parts.push(this.format(absence) + ' (fravær)');
	      return '<b>Rest</b><br>' + 'Arbejdstiden minus alle opgaver og forberedelse i perioden.<br><br>' + '<b>Regneeksempel</b><br>' + [this.format(this.periodWorkHours)].concat((0, _toConsumableArray3.default)(parts)).join(' − ') + ' = ' + this.format(this.rest);
	    },
	    preparationToSave: function preparationToSave() {
	      if (!this.statement || this.isClosed || this.isLoadingStatement) return null;
	      if (this.prepFactor === null && !this.isPoolsDeactivated && (this.isLoadingOriginal || !this.userYear)) return null;
	      return Math.round(this.periodPreparation * 100) / 100;
	    },
	    preparationSyncKey: function preparationSyncKey() {
	      if (this.preparationToSave === null) return null;
	      return this.preparationToSave + '|' + this.statement.preparation_hours;
	    },
	    schoolDaysInYear: function schoolDaysInYear() {
	      return Math.round(toNumber(this.statement && this.statement.school_year_work_days));
	    },
	    schoolDaysRatio: function schoolDaysRatio() {
	      return this.schoolDaysInYear > 0 ? this.schoolDaysInPeriod / this.schoolDaysInYear : 0;
	    },
	    calculatedValues: function calculatedValues() {
	      return this.statement && this.statement.calculated_values || [];
	    },
	    savedMethods: function savedMethods() {
	      return (this.statement && this.statement.calculation_method || []).reduce(function (map, item) {
	        map[item.id] = API_TO_METHOD[item.method];
	        return map;
	      }, {});
	    },
	    employmentPercentLabel: function employmentPercentLabel() {
	      return Math.round(toNumber(this.statement && this.statement.employment_percent) * 100) + ' %';
	    },
	    periodWorkHours: function periodWorkHours() {
	      return toNumber(this.statement && this.statement.arbejds_tid_i_timer);
	    },
	    localPoolTitle: function localPoolTitle() {
	      return this.$store.getters.localPoolTitle || this.$t('vue2.task_overview.pool');
	    },
	    groups: function groups() {
	      var _this9 = this;
	
	      if (!this.statement) {
	        return [];
	      }
	      var groups = {};
	      this.statement.tasks.forEach(function (task, index) {
	        if (toNumber(task.hours) === 0 && toNumber(task.actual) === 0) return;
	        var type = task.master_type;
	        if (!groups[type]) {
	          var order = MASTER_TYPE_ORDER.indexOf(type);
	          groups[type] = {
	            type: type,
	            title: _this9.getMasterTypeTitle(type),
	            order: order === -1 ? MASTER_TYPE_ORDER.length : order,
	            rows: [],
	            assigned: 0,
	            scheduled: 0
	          };
	        }
	        var row = {
	          key: task.id + (task.substitute ? '-substitute' : ''),
	          index: index,
	          task: task,
	          assigned: toNumber(task.hours),
	          scheduled: toNumber(task.actual)
	        };
	        groups[type].rows.push(row);
	        groups[type].assigned += row.assigned;
	        groups[type].scheduled += row.scheduled;
	      });
	      return (0, _values2.default)(groups).map(function (group) {
	        return (0, _extends5.default)({}, group, { rows: group.rows.sort(function (a, b) {
	            return a.task.name.localeCompare(b.task.name);
	          }) });
	      }).sort(function (a, b) {
	        return a.order - b.order;
	      });
	    },
	    rest: function rest() {
	      return toNumber(this.statement && this.statement.rest_i_timer);
	    }
	  },
	  watch: {
	    statementTitle: {
	      handler: function handler(title) {
	        this.$emit('title', title);
	      },
	
	      immediate: true
	    },
	    periodKey: function periodKey(key) {
	      var _this10 = this;
	
	      clearTimeout(this._loadTimer);
	      if (!key) return;
	      this._loadTimer = setTimeout(function () {
	        return _this10.loadStatement();
	      }, 400);
	    },
	    userId: function userId() {
	      this.loadOriginal();
	    },
	    preparationSyncKey: function preparationSyncKey(key) {
	      if (key !== null) this.schedulePreparationSync();
	    }
	  },
	  methods: {
	    setStartDate: function setStartDate(date) {
	      this.startDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	    },
	    setEndDate: function setEndDate(date) {
	      this.endDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	    },
	    loadOriginal: function loadOriginal() {
	      var _this11 = this;
	
	      var userId = this.userId;
	      var schoolYear = this.activeSchoolYear;
	      this.userYear = null;
	      this.yearTasks = [];
	      if (!userId || !schoolYear) return;
	      this.isLoadingOriginal = true;
	      var pending = 2;
	      var done = function done() {
	        pending--;
	        if (pending === 0) _this11.isLoadingOriginal = false;
	      };
	      var toDateExclusive = (0, _moment2.default)(schoolYear.employee_time_end).add(1, 'days').format('YYYY-MM-DD');
	      _docendo2.default.userTasks(userId, schoolYear.employee_time_start, toDateExclusive, null, function (data) {
	        if (_this11.userId === userId && Array.isArray(data)) {
	          _this11.yearTasks = data;
	        }
	        done();
	      }, done);
	      _docendo2.default.schoolUserYearRead(this.schoolId, userId, schoolYear.name, function (data) {
	        if (_this11.userId === userId && data && data.status !== 'error') {
	          _this11.userYear = data;
	        }
	        done();
	      }, done);
	    },
	    originalByType: function originalByType(type) {
	      var values = this.originalTypes[type] || { assigned: 0, scheduled: 0 };
	      if (type !== 'preparation') return values;
	      return (0, _extends5.default)({}, values, { assigned: values.assigned + this.originalPreparation });
	    },
	    groupHoursByType: function groupHoursByType(type) {
	      var group = this.groups.find(function (item) {
	        return item.type === type;
	      });
	      var hours = group ? this.groupHours(group) : 0;
	      return type === 'preparation' ? hours + this.periodPreparation : hours;
	    },
	    typeExplanation: function typeExplanation(type) {
	      var title = '<b>' + escapeHtml(this.getMasterTypeTitle(type)) + ' i perioden</b><br>';
	      var group = this.groups.find(function (item) {
	        return item.type === type;
	      });
	      if (type === 'preparation') {
	        return title + this.preparationExplanation(group);
	      }
	      if (!group) {
	        return title + 'Der er ingen opgaver af denne type i perioden.';
	      }
	      return title + 'Summen af opgavernes timer i perioden. Hver opgave er opgjort med den metode, der er valgt for den i tabellen nedenfor.<br><br>' + this.tasksExplanation(group);
	    },
	    tasksExplanation: function tasksExplanation(group) {
	      var _this12 = this;
	
	      var byMethod = this.methods.map(function (method) {
	        var rows = group.rows.filter(function (row) {
	          return _this12.rowState(row).method === method.id;
	        });
	        return { method: method, rows: rows, hours: rows.reduce(function (sum, row) {
	            return sum + _this12.rowHours(row);
	          }, 0) };
	      }).filter(function (item) {
	        return item.rows.length;
	      });
	      var lines = byMethod.map(function (item) {
	        return item.method.title + ' (' + item.rows.length + ' ' + (item.rows.length === 1 ? 'opgave' : 'opgaver') + '): ' + _this12.format(item.hours);
	      });
	      var examples = byMethod.map(function (item) {
	        return item.rows.find(function (row) {
	          return _this12.rowHours(row) !== 0;
	        });
	      }).filter(Boolean).map(function (row) {
	        return _this12.rowExplanation(row);
	      });
	      var total = byMethod.length > 1 ? '<br>I alt: ' + byMethod.map(function (item) {
	        return _this12.format(item.hours);
	      }).join(' + ') + ' = ' + this.format(this.groupHours(group)) : '';
	      return lines.join('<br>') + total + (examples.length ? '<br><br><b>Regneeksempel</b><br>' + examples.join('<br>') : '');
	    },
	    rowExplanation: function rowExplanation(row) {
	      var name = escapeHtml(row.task.name);
	      var hours = this.rowHours(row);
	      switch (this.rowState(row).method) {
	        case 'scheduled':
	          return name + ': skemalagt i perioden = ' + this.format(hours);
	        case 'school_days':
	          return name + ': ' + this.format(row.assigned) + ' tildelt × ' + this.schoolDaysInPeriod + ' / ' + this.schoolDaysInYear + ' elevdage = ' + this.format(hours);
	        case 'actual_days':
	          {
	            var share = row.assigned ? Math.round(hours / row.assigned * 100) : 0;
	            return name + ': ' + this.format(row.assigned) + ' tildelt × ' + share + ' % af opgavens dage ligger i perioden = ' + this.format(hours);
	          }
	        default:
	          return name + ': egen vurdering = ' + this.format(hours);
	      }
	    },
	    preparationExplanation: function preparationExplanation(group) {
	      var _this13 = this;
	
	      var taskHours = group ? this.groupHours(group) : 0;
	      var taskLine = group ? '<br>+ forberedelsesopgaver: ' + this.format(taskHours) + ' = ' + this.format(this.periodPreparation + taskHours) : '';
	      if (this.isClosed) {
	        return 'Gemt da opgørelsen blev lukket: ' + this.format(this.periodPreparation) + taskLine;
	      }
	      if (this.prepFactor === null && this.isPoolsDeactivated) {
	        return 'Skolen har slået puljerne fra og har ingen forberedelsesfaktor, så forberedelsen kommer kun fra forberedelsesopgaverne.' + (group ? '<br><br>Forberedelsesopgaver: ' + this.format(taskHours) : '');
	      }
	      if (this.prepFactor === null) {
	        return 'Årets tildelte forberedelse fra årsnormen, fordelt efter periodens andel af årets arbejdstid.<br><br>' + '<b>Regneeksempel</b><br>' + this.format(this.originalPreparation) + ' × ' + this.format(this.periodWorkHours) + ' / ' + this.format(this.originalWorkHours) + ' = ' + this.format(this.periodPreparation) + taskLine;
	      }
	      if (this.isUserInGroupWithoutPrepFactor) {
	        return 'Personen er i en gruppe uden forberedelsesfaktor, så undervisningen giver ingen forberedelse.' + taskLine;
	      }
	      var teaching = this.groups.find(function (item) {
	        return item.type === 'teaching';
	      });
	      var byFactor = {};(teaching ? teaching.rows : []).forEach(function (row) {
	        if (row.task.substitute || row.task.subject_type === 'preparation') return;
	        var factor = (0, _preparationFactor.effectivePreparationFactor)(row.task.preparation, _this13.prepFactor);
	        byFactor[factor] = (byFactor[factor] || 0) + _this13.rowHours(row);
	      });
	      var parts = (0, _keys2.default)(byFactor).map(function (factor) {
	        return _this13.format(byFactor[factor]) + ' × ' + _this13.format(factor);
	      });
	      return 'Undervisningens timer i perioden ganget med forberedelsesfaktoren. Fag med egen faktor bruger den, ellers bruges skolens faktor (' + this.format(this.prepFactor) + ').<br><br>' + '<b>Regneeksempel</b><br>' + (parts.length ? parts.join(' + ') : '0.00') + ' = ' + this.format(this.periodPreparation) + taskLine;
	    },
	    updateStatement: function updateStatement(attributes, onSaved, onFailed) {
	      var _this14 = this;
	
	      var statementId = this.statement.id;
	      var preparation = this.preparationToSave;
	      this._updatesInFlight = (this._updatesInFlight || 0) + 1;
	      var done = function done() {
	        _this14._updatesInFlight--;
	        _this14.schedulePreparationSync();
	      };
	      _docendo2.default.updateWorkedHoursStatement(this.schoolId, statementId, (0, _extends5.default)({}, attributes, preparation === null ? {} : { preparation_hours: preparation }, {
	        calculation_method: this.calculationMethodPayload()
	      }), function (data) {
	        if (!data || data.status === 'error') {
	          onFailed();
	        } else if (_this14.statement && _this14.statement.id === statementId) {
	          onSaved(data);
	          _this14.statement = (0, _extends5.default)({}, _this14.statement, data);
	        }
	        done();
	      }, function () {
	        onFailed();
	        done();
	      });
	    },
	    schedulePreparationSync: function schedulePreparationSync() {
	      var _this15 = this;
	
	      clearTimeout(this._preparationSaveTimer);
	      this._preparationSaveTimer = setTimeout(function () {
	        return _this15.syncPreparation();
	      }, 400);
	    },
	    syncPreparation: function syncPreparation() {
	      var value = this.preparationToSave;
	      if (value === null || value === toNumber(this.statement.preparation_hours)) return;
	      if (this._updatesInFlight || this._calculationSaveTimer) return;
	      this.updateStatement({}, function () {}, function () {});
	    },
	    restBadgeClass: function restBadgeClass(rest) {
	      var rounded = Math.round(rest * 100) / 100;
	      if (rounded > 0) return 'd-bagde d-badge--green';
	      if (rounded < 0) return 'd-bagde d-badge--warning';
	      return '';
	    },
	    restLabel: function restLabel(rest) {
	      var rounded = Math.round(rest * 100) / 100;
	      if (rounded > 0) return 'Timer til overs';
	      if (rounded < 0) return 'Over arbejdstiden – for mange timer';
	      return '';
	    },
	    formatSigned: function formatSigned(value) {
	      var rounded = Math.round(toNumber(value) * 100) / 100;
	      return Math.abs(rounded).toFixed(2);
	    },
	    formatShare: function formatShare(hours) {
	      if (!this.originalWorkHours) return '';
	      return Math.round(toNumber(hours) / this.originalWorkHours * 100) + ' %';
	    },
	    getMasterTypeTitle: function getMasterTypeTitle(type) {
	      switch (type) {
	        case 'teaching':
	          return this.$t('vue2.task_overview.teaching');
	        case 'other':
	          return this.$t('vue2.task_overview.tasks');
	        case 'preparation':
	          return this.$t('vue2.task_overview.preparation');
	        case 'club':
	          return this.$t('vue2.task_overview.club');
	        case 'pool':
	          return this.localPoolTitle;
	        case 'absence':
	          return this.$t('vue2.task_overview.absence');
	        case 'unknown':
	          return this.$t('vue2.task_overview.unknown');
	        case 'with_kids':
	          return 'Tid med børn';
	        case 'without_kids':
	          return 'Tid uden børn';
	        case 'flextime':
	          return 'Flekstid';
	        default:
	          return type;
	      }
	    },
	    loadStatement: function loadStatement() {
	      var _this16 = this;
	
	      if (!this.isPeriodValid) {
	        return;
	      }
	      clearTimeout(this._calculationSaveTimer);
	      this._calculationSaveTimer = null;
	      this.clearNumberDrafts();
	      var _period = this.period,
	          userId = _period.userId,
	          startDate = _period.startDate,
	          endDate = _period.endDate;
	
	      var statement = this.statement;
	      var sameUser = statement && Number(statement.user_id) === Number(userId);
	      if (sameUser && (this.isClosed || statement.from_date === startDate && statement.to_date === endDate)) {
	        return;
	      }
	      if (!sameUser) {
	        this.statement = null;
	        this.rows = {};
	      }
	      this.errorMessage = null;
	      this.isLoadingStatement = true;
	      var requestKey = this.periodKey;
	      var onFailure = function onFailure() {
	        if (requestKey !== _this16.periodKey) return;
	        _this16.isLoadingStatement = false;
	        _this16.errorMessage = 'Timeopgørelsen kunne ikke hentes. Prøv igen.';
	      };
	      var onSuccess = function onSuccess(data) {
	        if (!data || data.status === 'error') return onFailure();
	        if (requestKey !== _this16.periodKey) return;
	        _this16.applyStatement(data);
	        _this16.isLoadingStatement = false;
	      };
	      if (sameUser) {
	        _docendo2.default.updateWorkedHoursStatement(this.schoolId, statement.id, {
	          from_date: startDate,
	          to_date: endDate,
	          calculation_method: this.calculationMethodPayload()
	        }, onSuccess, onFailure);
	      } else {
	        if (statement && !statement.closed_at) {
	          _docendo2.default.deleteWorkedHoursStatement(this.schoolId, statement.id, function () {}, function () {});
	        }
	        _docendo2.default.createWorkedHoursStatement(this.schoolId, userId, startDate, endDate, onSuccess, onFailure);
	      }
	    },
	    applyStatement: function applyStatement(data) {
	      this.clearNumberDrafts();
	      this.statement = data;
	      this.rows = this.hydrateRows(data.calculation_method);
	    },
	    setClosed: function setClosed(closed) {
	      var _this17 = this;
	
	      if (!this.statement || this.isTogglingClosed) return;
	      clearTimeout(this._calculationSaveTimer);
	      this._calculationSaveTimer = null;
	      clearTimeout(this._loadTimer);
	      var statementId = this.statement.id;
	      var attributes = closed ? { closed: true, calculation_method: this.calculationMethodPayload() } : { closed: false };
	      if (closed && this.preparationToSave !== null) attributes.preparation_hours = this.preparationToSave;
	      this.errorMessage = null;
	      this.isTogglingClosed = true;
	      _docendo2.default.updateWorkedHoursStatement(this.schoolId, statementId, attributes, function (data) {
	        _this17.isTogglingClosed = false;
	        if (!_this17.statement || _this17.statement.id !== statementId) return;
	        _this17.statement = data;
	        _this17.startDate = data.from_date;
	        _this17.endDate = data.to_date;
	      }, function () {
	        _this17.isTogglingClosed = false;
	        _this17.errorMessage = closed ? 'Opgørelsen kunne ikke lukkes. Prøv igen.' : 'Opgørelsen kunne ikke genåbnes. Prøv igen.';
	      });
	    },
	    hydrateRows: function hydrateRows(calculationMethod) {
	      var _this18 = this;
	
	      var buckets = {};(calculationMethod || []).forEach(function (item) {
	        var method = API_TO_METHOD[item.method];
	        var id = Number(item.id);
	        if (!method || !(0, _isInteger2.default)(id)) return;
	        if (!buckets[id]) buckets[id] = [];
	        buckets[id].push({ method: method, value: item.value });
	      });
	      var rows = {};
	      this.groups.forEach(function (group) {
	        group.rows.forEach(function (row) {
	          var id = Number(row.task.id);
	          var bucket = buckets[id];
	          if (!bucket || !bucket.length) return;
	          var siblings = _this18.groups.reduce(function (count, item) {
	            return count + item.rows.filter(function (other) {
	              return Number(other.task.id) === id;
	            }).length;
	          }, 0);
	          if (bucket.length < siblings && row.task.substitute) return;
	          var saved = bucket.shift();
	          if (!saved) return;
	          rows[row.key] = {
	            method: saved.method,
	            manual: {
	              assessment: saved.method === 'assessment' && saved.value != null ? saved.value : 0
	            }
	          };
	        });
	      });
	      return rows;
	    },
	    calculationMethodPayload: function calculationMethodPayload() {
	      var _this19 = this;
	
	      var entries = (this.statement && this.statement.calculation_method || []).map(function (item) {
	        return (0, _extends5.default)({}, item);
	      });
	      var indexById = entries.reduce(function (map, item, index) {
	        map[item.id] = index;
	        return map;
	      }, {});
	      this.groups.forEach(function (group) {
	        group.rows.forEach(function (row) {
	          var id = Number(row.task.id);
	          if (!(0, _isInteger2.default)(id)) return;
	          var state = _this19.rowState(row);
	          var method = _this19.methods.find(function (item) {
	            return item.id === state.method;
	          });
	          if (!method) return;
	          var entry = {
	            id: id,
	            method: method.api,
	            value: method.isManual ? toNullableNumber(state.manual[state.method]) : null
	          };
	          if (id in indexById) {
	            entries[indexById[id]] = entry;
	          } else {
	            indexById[id] = entries.push(entry) - 1;
	          }
	        });
	      });
	      return entries;
	    },
	    scheduleCalculationSave: function scheduleCalculationSave() {
	      var _this20 = this;
	
	      clearTimeout(this._calculationSaveTimer);
	      this._calculationSaveTimer = setTimeout(function () {
	        _this20._calculationSaveTimer = null;
	        _this20.saveCalculationMethod();
	      }, 400);
	    },
	    flushCalculationSave: function flushCalculationSave() {
	      if (!this._calculationSaveTimer) return;
	      clearTimeout(this._calculationSaveTimer);
	      this._calculationSaveTimer = null;
	      this.saveCalculationMethod();
	    },
	    saveCalculationMethod: function saveCalculationMethod() {
	      var _this21 = this;
	
	      if (!this.statement || this.isClosed) return;
	      if (this._updatesInFlight) {
	        this.scheduleCalculationSave();
	        return;
	      }
	      this.updateStatement({}, function () {}, function () {
	        _this21.errorMessage = 'Opgørelsesmetoden kunne ikke gemmes. Prøv igen.';
	      });
	    },
	    sortMasterTypes: function sortMasterTypes(types) {
	      return types.sort(function (a, b) {
	        var orderA = MASTER_TYPE_ORDER.indexOf(a);
	        var orderB = MASTER_TYPE_ORDER.indexOf(b);
	        return (orderA === -1 ? MASTER_TYPE_ORDER.length : orderA) - (orderB === -1 ? MASTER_TYPE_ORDER.length : orderB);
	      });
	    },
	    numberInput: function numberInput(field) {
	      if (this.numberDrafts[field] !== null) return this.numberDrafts[field];
	      var value = toNumber(this.statement && this.statement[field]);
	      return String(Math.round(value * 100) / 100).replace('.', ',');
	    },
	    clearNumberDrafts: function clearNumberDrafts() {
	      var _this22 = this;
	
	      (0, _keys2.default)(this.numberDrafts).forEach(function (field) {
	        clearTimeout(_this22._numberSaveTimers[field]);
	        _this22.numberDrafts[field] = null;
	      });
	      this._numberSaveTimers = {};
	    },
	    setNumber: function setNumber(field, value) {
	      var _this23 = this;
	
	      if (this.isClosed) return;
	      this.numberDrafts[field] = value;
	      clearTimeout(this._numberSaveTimers[field]);
	      this._numberSaveTimers[field] = setTimeout(function () {
	        return _this23.flushNumberSave(field);
	      }, 600);
	    },
	    flushNumberSave: function flushNumberSave(field) {
	      var _this24 = this;
	
	      clearTimeout(this._numberSaveTimers[field]);
	      this._numberSaveTimers[field] = null;
	      var draft = this.numberDrafts[field];
	      if (draft === null || !this.statement || this.isClosed) return;
	      var value = String(draft).trim() === '' ? 0 : toNullableNumber(draft);
	      if (value === null || value < 0) {
	        this.errorMessage = NUMBER_FIELDS[field].invalid;
	        return;
	      }
	      if (value === toNumber(this.statement[field])) {
	        this.numberDrafts[field] = null;
	        return;
	      }
	      if (this._updatesInFlight) {
	        this._numberSaveTimers[field] = setTimeout(function () {
	          return _this24.flushNumberSave(field);
	        }, 400);
	        return;
	      }
	      this.errorMessage = null;
	      this.updateStatement((0, _defineProperty3.default)({}, field, value), function () {
	        _this24.numberDrafts[field] = null;
	      }, function () {
	        _this24.errorMessage = NUMBER_FIELDS[field].failed;
	      });
	    },
	    defaultMethod: function defaultMethod(row) {
	      if (row.task.master_type === 'teaching') {
	        return 'scheduled';
	      }
	      if (row.task.from_date && row.task.to_date) {
	        return 'actual_days';
	      }
	      return 'school_days';
	    },
	    actualDaysHours: function actualDaysHours(row) {
	      var _row$task = row.task,
	          from = _row$task.from_date,
	          to = _row$task.to_date;
	
	      if (!from || !to) {
	        return 0;
	      }
	      var overlapStart = _moment2.default.max((0, _moment2.default)(from), (0, _moment2.default)(this.period.startDate));
	      var overlapEnd = _moment2.default.min((0, _moment2.default)(to), (0, _moment2.default)(this.period.endDate));
	      var taskDays = countWeekdays(from, to);
	      if (overlapEnd.isBefore(overlapStart) || taskDays === 0) {
	        return 0;
	      }
	      return row.assigned * countWeekdays(overlapStart, overlapEnd) / taskDays;
	    },
	    rowState: function rowState(row) {
	      return this.rows[row.key] || {
	        method: this.defaultMethod(row),
	        manual: { assessment: 0 }
	      };
	    },
	    updateRow: function updateRow(row, changes) {
	      this.rows = (0, _extends5.default)({}, this.rows, (0, _defineProperty3.default)({}, row.key, (0, _extends5.default)({}, this.rowState(row), changes)));
	    },
	    setMethod: function setMethod(row, method) {
	      var _this25 = this;
	
	      if (this.isClosed) return;
	      this.updateRow(row, { method: method });
	      this.scheduleCalculationSave();
	      if (method !== 'assessment') return;
	      this.$nextTick(function () {
	        var ref = _this25.$refs['period-' + row.key];
	        var input = Array.isArray(ref) ? ref[0] : ref;
	        if (!input) return;
	        input.focus();
	        input.select();
	      });
	    },
	    setManual: function setManual(row, method, value) {
	      if (this.isClosed) return;
	      this.updateRow(row, { manual: (0, _extends5.default)({}, this.rowState(row).manual, (0, _defineProperty3.default)({}, method, value)) });
	      this.scheduleCalculationSave();
	    },
	    isManualMethod: function isManualMethod(method) {
	      var found = this.methods.find(function (item) {
	        return item.id === method;
	      });
	      return Boolean(found && found.isManual);
	    },
	    methodHours: function methodHours(row, method) {
	      switch (method) {
	        case 'scheduled':
	          return row.scheduled;
	        case 'school_days':
	          return row.assigned * this.schoolDaysRatio;
	        case 'actual_days':
	          return this.actualDaysHours(row);
	        default:
	          {
	            var value = toNullableNumber(this.rowState(row).manual[method]);
	            return value === null ? 0 : value;
	          }
	      }
	    },
	    rowHours: function rowHours(row) {
	      var method = this.rowState(row).method;
	      var calculated = this.calculatedValues[row.index];
	      var isSaved = this.savedMethods[row.task.id] === method;
	      if (!this.isManualMethod(method) && isSaved && calculated && calculated.value !== null && calculated.value !== undefined) {
	        return toNumber(calculated.value);
	      }
	      return this.methodHours(row, method);
	    },
	    groupHours: function groupHours(group) {
	      var _this26 = this;
	
	      return group.rows.reduce(function (sum, row) {
	        return sum + _this26.rowHours(row);
	      }, 0);
	    },
	    format: function format(value) {
	      return toNumber(value).toFixed(2);
	    },
	    formatDays: function formatDays(value) {
	      return String(Math.round(toNumber(value) * 100) / 100).replace('.', ',');
	    },
	    formatDateRange: function formatDateRange(fromDate, toDate) {
	      if (!fromDate && !toDate) return '';
	      var from = fromDate ? (0, _moment2.default)(fromDate) : null;
	      var to = toDate ? (0, _moment2.default)(toDate) : null;
	      if (from && !to) return from.format('DD-MM-YYYY');
	      if (!from && to) return to.format('DD-MM-YYYY');
	      if (from.isSame(to, 'day')) return from.format('DD-MM-YYYY');
	      return from.format('DD-MM-YYYY') + ' - ' + to.format('DD-MM-YYYY');
	    }
	  },
	  created: function created() {
	    this._numberSaveTimers = {};
	    if (this.savedStatement) {
	      this.applyStatement(this.savedStatement);
	      this.loadOriginal();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearTimeout(this._preparationSaveTimer);
	    clearTimeout(this._calculationSaveTimer);
	    clearTimeout(this._loadTimer);
	    this.clearNumberDrafts();
	  }
	};

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var XLSX = null;
	
	exports.default = {
	  components: { DModal: _DModal2.default, Loader: _Loader2.default, DoFiltersFilter: _DoFiltersFilter2.default },
	  props: {
	    schoolId: {
	      default: function _default() {
	        return null;
	      }
	    },
	    schoolYearId: {
	      default: function _default() {
	        return null;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isLoadingUserYears: false,
	      userYears: [],
	      teachingHoursMap: {},
	      isLoadingTeachingHours: false,
	      selectedGroups: [],
	      closeFiltersCount: 0
	    };
	  },
	
	  computed: {
	    poolsDeactivated: function poolsDeactivated() {
	      var settings = this.$store.state.schoolSettings;
	      return !!(settings && settings.deactivatePools);
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    userYearMap: function userYearMap() {
	      var map = {};
	      this.userYears.forEach(function (userYear) {
	        map[userYear.user_id] = userYear;
	      });
	      return map;
	    },
	    rows: function rows() {
	      var _this = this;
	
	      return this.users.map(function (user) {
	        var employmentPercentage = _this.employmentPercentage(user.id);
	        var teachingHours = _this.assignedTeachingHours(user.id);
	        return {
	          userId: user.id,
	          name: user.name,
	          userTags: user.user_tags || [],
	          employmentPercentage: employmentPercentage,
	          weeklyHours: _this.weeklyHours(employmentPercentage),
	          teachingHours: teachingHours,
	          normalizedToFullTime: _this.normalizedToFullTime(teachingHours, employmentPercentage)
	        };
	      });
	    },
	    filteredRows: function filteredRows() {
	      var _this2 = this;
	
	      return this.rows.filter(function (row) {
	        return _this2.matchesGroups(row);
	      });
	    },
	    uniqueGroups: function uniqueGroups() {
	      var groups = [];
	      this.rows.forEach(function (row) {
	        if (row.userTags && row.userTags.length > 0) {
	          groups = groups.concat(row.userTags);
	        }
	      });
	      return this.uniqueSorted(groups);
	    },
	    summary: function summary() {
	      var normalizedRows = this.filteredRows.filter(function (row) {
	        return row.normalizedToFullTime !== null;
	      });
	      var count = normalizedRows.length;
	      if (count === 0) {
	        return { count: 0, average: null };
	      }
	      var total = normalizedRows.reduce(function (sum, row) {
	        return sum + row.normalizedToFullTime;
	      }, 0);
	      return { count: count, average: total / count };
	    },
	    isLoading: function isLoading() {
	      return this.isLoadingUserYears || this.poolsDeactivated && this.isLoadingTeachingHours;
	    }
	  },
	  methods: {
	    uniqueSorted: function uniqueSorted(items) {
	      var seen = {};
	      var unique = [];
	      items.forEach(function (item) {
	        if (!seen[item]) {
	          seen[item] = true;
	          unique.push(item);
	        }
	      });
	      return unique.sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    matchesGroups: function matchesGroups(row) {
	      var _this3 = this;
	
	      if (this.selectedGroups.length < 1) return true;
	      if (!row.userTags || row.userTags.length < 1) return false;
	      return row.userTags.some(function (tag) {
	        return _this3.selectedGroups.indexOf(tag) > -1;
	      });
	    },
	    toggleGroup: function toggleGroup(group) {
	      var idx = this.selectedGroups.indexOf(group);
	      if (idx > -1) {
	        this.selectedGroups.splice(idx, 1);
	      } else {
	        this.selectedGroups.push(group);
	      }
	    },
	    clearGroups: function clearGroups() {
	      this.selectedGroups = [];
	    },
	    closeFilters: function closeFilters() {
	      this.closeFiltersCount++;
	    },
	    assignedTeachingHours: function assignedTeachingHours(userId) {
	      if (this.poolsDeactivated) {
	        var hours = this.teachingHoursMap[userId];
	        return hours != null ? hours : 0;
	      }
	      var userYear = this.userYearMap[userId];
	      return userYear && userYear.assigned_teaching_hours ? userYear.assigned_teaching_hours : 0;
	    },
	    normValue: function normValue(userId, title) {
	      var userYear = this.userYearMap[userId];
	      var norm = userYear && userYear.norm ? userYear.norm : [];
	      var found = norm.find(function (item) {
	        return item.title === title;
	      });
	      return found ? found.value : null;
	    },
	    employmentPercentage: function employmentPercentage(userId) {
	      var value = this.normValue(userId, 'hidden_ansættelsesgrad');
	      return value !== null ? parseFloat(value) : null;
	    },
	    weeklyHours: function weeklyHours(employmentPercentage) {
	      if (employmentPercentage === null || isNaN(employmentPercentage) || employmentPercentage === 0) {
	        return null;
	      }
	      return employmentPercentage / 100 * 37;
	    },
	    normalizedToFullTime: function normalizedToFullTime(teachingHours, employmentPercentage) {
	      if (employmentPercentage === null || isNaN(employmentPercentage) || employmentPercentage === 0) {
	        return null;
	      }
	      var hours = parseFloat(teachingHours);
	      if (isNaN(hours)) return null;
	      return hours / employmentPercentage * 100;
	    },
	    formatDecimal: function formatDecimal(value) {
	      var num = parseFloat(value);
	      return isNaN(num) ? '' : num.toFixed(2).replace('.', ',');
	    },
	    formatPercentage: function formatPercentage(value) {
	      if (value === null || value === undefined || isNaN(value) || value === 0) return '';
	      return this.formatDecimal(value) + ' %';
	    },
	    readUserYears: function readUserYears() {
	      var _this4 = this;
	
	      if (!this.schoolId || !this.schoolYearId) return;
	      this.isLoadingUserYears = true;
	      _docendo2.default.schoolUserYearsList(this.schoolId, this.schoolYearId, null, function (success) {
	        _this4.userYears = success || [];
	        _this4.isLoadingUserYears = false;
	      }, function (failure) {
	        console.log(failure);
	        _this4.isLoadingUserYears = false;
	      });
	    },
	    readTeachingHours: function readTeachingHours() {
	      var _this5 = this;
	
	      if (!this.schoolId || !this.schoolYearId) return;
	      this.isLoadingTeachingHours = true;
	      _docendo2.default.readUserHoursForSchoolYear(this.schoolId, this.schoolYearId, null, function (success) {
	        var map = {};
	        var rows = success && success.teaching_hours || [];
	        rows.forEach(function (row) {
	          if (row.user_id == null) return;
	          map[row.user_id] = (map[row.user_id] || 0) + (parseFloat(row.hours) || 0);
	        });
	        _this5.teachingHoursMap = map;
	        _this5.isLoadingTeachingHours = false;
	      }, function (failure) {
	        console.log(failure);
	        _this5.isLoadingTeachingHours = false;
	      }, true);
	    },
	    asyncLoadXLSXAndDownload: function asyncLoadXLSXAndDownload() {
	      var _this6 = this;
	
	      if (window.XLSX && XLSX) {
	        this.download();
	      } else {
	        var cdnXLSX = document.createElement('script');
	        cdnXLSX.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.mini.min.js');
	        document.head.appendChild(cdnXLSX);
	        var intervalTimer = setInterval(function (_) {
	          if (window.XLSX) {
	            clearInterval(intervalTimer);
	            XLSX = window.XLSX;
	            _this6.download();
	          }
	        }, 500);
	      }
	    },
	    download: function download() {
	      var rows = [['Navn', 'Ansættelsesgrad', 'Timeansættelse pr. uge', 'Uv-timer', 'Normeret til fuldtid']];
	      this.filteredRows.forEach(function (row) {
	        rows.push([row.name, row.employmentPercentage === null || isNaN(row.employmentPercentage) ? '' : row.employmentPercentage, row.weeklyHours === null ? '' : row.weeklyHours, isNaN(parseFloat(row.teachingHours)) ? '' : parseFloat(row.teachingHours), row.normalizedToFullTime === null ? '' : row.normalizedToFullTime]);
	      });
	      rows.push(['Gennemsnit (normeret) — ' + this.summary.count + ' medarbejdere', '', '', '', this.summary.average === null ? '' : this.summary.average]);
	      var data = XLSX.utils.aoa_to_sheet(rows);
	      var wb = XLSX.utils.book_new();
	      XLSX.utils.book_append_sheet(wb, data, 'data');
	      XLSX.writeFile(wb, 'docendo_gennemsnits_undervisningstal.xlsx');
	    }
	  },
	  mounted: function mounted() {
	    this.readUserYears();
	    if (this.poolsDeactivated) {
	      this.readTeachingHours();
	    }
	  }
	};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DoFiltersFilter: _DoFiltersFilter2.default, DModal: _DModal2.default },
	  props: {
	    schoolId: {},
	    tags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    preSelectedTags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    preSelectedTagsSumWorkHours: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isSaving: false,
	      selectedTags: [],
	      selectedTagsSumWorkHours: []
	    };
	  },
	
	  methods: {
	    save: function save() {
	      var _$store$dispatch,
	          _this = this;
	
	      var noPrepKey = 'pedagogicalGroups';
	      var sumWorkHoursKey = 'workHoursSumGroups';
	      this.isSaving = true;
	
	      var noPrepValue = Array.isArray(this.selectedTags) && this.selectedTags.length > 0 ? this.selectedTags.slice() : null;
	      var sumWorkHoursValue = Array.isArray(this.selectedTagsSumWorkHours) && this.selectedTagsSumWorkHours.length > 0 ? this.selectedTagsSumWorkHours.slice() : null;
	
	      this.$store.dispatch('updateSchoolSettings', (_$store$dispatch = {}, (0, _defineProperty3.default)(_$store$dispatch, noPrepKey, noPrepValue), (0, _defineProperty3.default)(_$store$dispatch, sumWorkHoursKey, sumWorkHoursValue), _$store$dispatch));
	
	      setTimeout(function (_) {
	        _this.$store.dispatch('trackEvent', 'assignHours_pedagogicalGroups_saved');
	        _this.$emit('saved');
	        _this.$emit('close');
	      }, 500);
	    },
	    toggleTag: function toggleTag(tag) {
	      var idx = this.selectedTags.indexOf(tag);
	      if (idx > -1) {
	        this.selectedTags.splice(idx, 1);
	      } else {
	        this.selectedTags.push(tag);
	      }
	    },
	    clearTags: function clearTags() {
	      this.selectedTags = [];
	    },
	    toggleTagSumWorkHours: function toggleTagSumWorkHours(tag) {
	      var idx = this.selectedTagsSumWorkHours.indexOf(tag);
	      if (idx > -1) {
	        this.selectedTagsSumWorkHours.splice(idx, 1);
	      } else {
	        this.selectedTagsSumWorkHours.push(tag);
	      }
	    },
	    clearTagsSumWorkHours: function clearTagsSumWorkHours() {
	      this.selectedTagsSumWorkHours = [];
	    }
	  },
	  mounted: function mounted() {
	    this.selectedTags = Array.isArray(this.preSelectedTags) ? this.preSelectedTags.slice() : [];
	    this.selectedTagsSumWorkHours = Array.isArray(this.preSelectedTagsSumWorkHours) ? this.preSelectedTagsSumWorkHours.slice() : [];
	  }
	};

/***/ }),
/* 483 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'aula-setup',
	  description: 'Initial setup of Aula for a school.',
	  data: function data() {
	    return {
	      institutionNumberConfirmed: false,
	      dataAgreementConfirmed: false,
	      locationsConfirmed: false,
	      usersImported: false,
	      groupsImported: false
	    };
	  },
	
	  methods: {
	    institutionNumberConfirmedClick: function institutionNumberConfirmedClick() {
	      this.institutionNumberConfirmed = true;
	    },
	    locationsConfirmedClick: function locationsConfirmedClick() {
	      this.locationsConfirmed = true;
	    },
	    usersImportedClick: function usersImportedClick() {
	      this.usersImported = true;
	    },
	    groupsImportedClick: function groupsImportedClick() {
	      this.groupsImported = true;
	    }
	  }
	};

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var XLSX = null;
	
	exports.default = {
	  components: { Tabs: _Tabs2.default, DatePickerRange: _DatePickerRange2.default },
	  mixins: [_vueClickaway.mixin],
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        el.focus();
	        el.select();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      theSelectedTab: 'hours',
	      isDownloading: false,
	      theEditNumberUser: null,
	      theEditNumberType: '',
	      theEditNumberNumber: 0,
	      isDropdownPopperDone: false,
	      isUpdatingNumber: false,
	      startDate: (0, _moment2.default)().startOf('isoWeek'),
	      endDate: (0, _moment2.default)().endOf('isoWeek'),
	      col1: [{ name: 'Employee id', rowspan: 2 }, { name: 'Name', rowspan: 2 }, { name: 'Working hours', color: '#f7f9fe' }, { name: 'Teaching', colspan: 2, color: '#f2f2ff' }, { name: 'Tasks', color: '#fffbf1' }, { name: 'Preparation', color: '#fef7f5' }, { name: 'Substitute', colspan: 2, color: '#f2fafb' }, { name: 'Hours left', color: '#fff' }, { name: 'Absent', color: '#f1f1f1' }],
	      col2: [{ name: 'Working hours', color: '#f7f9fe' }, { name: 'Subject', color: '#f2f2ff' }, { name: 'Breaks', color: '#f2f2ff' }, { name: 'Not teaching', color: '#fffbf1' }, { name: 'Preparation', color: '#fef7f5' }, { name: 'Teaching', color: '#f2fafb' }, { name: 'Breaks/not teaching', color: '#f2fafb' }, { name: 'Hours left', color: '#fff' }, { name: 'Absent', color: '#f1f1f1' }],
	      events: [],
	      isLoading: false,
	      eventsInUserCalendarIdHash: {},
	      debounceTimer: null,
	      clickCount: 0,
	      clickCountTimer: null
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    usersWithEmployeeId: function usersWithEmployeeId() {
	      return this.users.filter(function (user) {
	        return user.employee_id;
	      });
	    },
	    filteredCalendars: function filteredCalendars() {
	      return this.users && this.users.length > 0 ? this.users.map(function (user) {
	        return user.user_calendar_id;
	      }) : [];
	    },
	    isThisWeek: function isThisWeek() {
	      var start = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD') === (0, _moment2.default)().startOf('isoWeek').format('YYYY-MM-DD');
	      var end = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD') === (0, _moment2.default)().endOf('isoWeek').format('YYYY-MM-DD');
	      return start && end;
	    },
	    usersWithVEvents: function usersWithVEvents() {
	      var _this = this;
	
	      var multiple = this.theSelectedTab === 'minutes' ? 1 : 60;
	      var formatTime = function formatTime(num) {
	        return (num / multiple).toFixed(2);
	      };
	
	      var getWeeklyHours = function getWeeklyHours(user) {
	        return user.custom_data && user.custom_data.schools && user.custom_data.schools[_this.schoolId] && user.custom_data.schools[_this.schoolId]['weeklyHours'] || 0;
	      };
	
	      return this.users.map(function (user) {
	        var calUser = _this.eventsInUserCalendarIdHash && _this.eventsInUserCalendarIdHash[user.user_calendar_id];
	        var getCount = function getCount(key) {
	          return calUser && calUser[key] || 0;
	        };
	
	        var vPresence = getWeeklyHours(user);
	        var vSubject = getCount('subject_count');
	        var vBreak = getCount('break_count');
	        var vTasks = getCount('additional_tasks_count');
	        var vPreparation = getCount('preparation_count');
	        var vAbsence = getCount('absence_count');
	        var vSubstituteTeaching = getCount('substitute_teaching_count');
	        var vSubstituteNotTeaching = getCount('substitute_not_teaching_count');
	
	        var usedTime = vSubject + vBreak + vTasks + vPreparation + vSubstituteTeaching + vSubstituteNotTeaching;
	        var vTotal = vPresence - usedTime;
	
	        return (0, _extends3.default)({}, user, {
	          v_presence: formatTime(vPresence),
	          v_subject: formatTime(vSubject),
	          v_break: formatTime(vBreak),
	          v_tasks: formatTime(vTasks),
	          v_preparation: formatTime(vPreparation),
	          v_substitute_teaching: formatTime(vSubstituteTeaching),
	          v_substitute_not_teaching: formatTime(vSubstituteNotTeaching),
	          v_hours_left: formatTime(vTotal),
	          v_absence: formatTime(vAbsence)
	        });
	      });
	    }
	  },
	  watch: {
	    users: function users() {
	      this.readEvents();
	    }
	  },
	  methods: {
	    computeOverlapMinutes: function computeOverlapMinutes(startA, endA, startB, endB) {
	      var sA = (0, _moment2.default)(startA);
	      var eA = (0, _moment2.default)(endA);
	      var sB = (0, _moment2.default)(startB);
	      var eB = (0, _moment2.default)(endB);
	      var latestStart = _moment2.default.max(sA, sB);
	      var earliestEnd = _moment2.default.min(eA, eB);
	      var diff = earliestEnd.diff(latestStart, 'minutes');
	      return diff > 0 ? diff : 0;
	    },
	    dataToExcel: function dataToExcel() {
	      var _this2 = this;
	
	      var users = this.usersWithVEvents.map(function (user) {
	        return {
	          'employee_id': user.employee_id || null,
	          'name': user.name,
	          'work_time': parseFloat(_this2.humanizeNumber(user.v_presence)),
	          'subject': parseFloat(user.v_subject),
	          'breaks': parseFloat(user.v_break),
	          'tasks': parseFloat(user.v_tasks),
	          'preparation': parseFloat(user.v_preparation),
	          'substitute_teaching': parseFloat(user.v_substitute_teaching),
	          'substitute_not_teaching': parseFloat(user.v_substitute_not_teaching),
	          'hours_left': parseFloat(user.v_hours_left),
	          'absence': parseFloat(user.v_absence)
	        };
	      });
	
	      var baseHeaders = {
	        'employee_id': 'Employee ID',
	        'name': 'Name',
	        'work_time': 'Work Time',
	        'subject': 'Subject',
	        'breaks': 'Breaks',
	        'tasks': 'Tasks',
	        'preparation': 'Preparation',
	        'substitute_teaching': 'Substitute Teaching',
	        'substitute_not_teaching': 'Substitute Not Teaching',
	        'hours_left': 'Hours Left',
	        'absence': 'Absence'
	      };
	
	      var headersRow1 = (0, _keys2.default)(baseHeaders).reduce(function (accumulator, key) {
	        accumulator[key] = '';
	        return accumulator;
	      }, {});
	
	      var headersRow2 = (0, _extends3.default)({}, baseHeaders);
	
	      users.unshift(headersRow2, headersRow1);
	
	      return users;
	    },
	    asyncLoadXLSXAndDownload: function asyncLoadXLSXAndDownload() {
	      var _this3 = this;
	
	      this.isDownloading = true;
	      if (window.XLSX && XLSX) {
	        this.download();
	      } else {
	        var cdnXLSX = document.createElement('script');
	        cdnXLSX.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.mini.min.js');
	        document.head.appendChild(cdnXLSX);
	        var intervalTimer = setInterval(function (_) {
	          if (window.XLSX) {
	            clearInterval(intervalTimer);
	            XLSX = window.XLSX;
	            _this3.download();
	          }
	        }, 500);
	      }
	    },
	    download: function download() {
	      var data = XLSX.utils.json_to_sheet(this.dataToExcel(), { skipHeader: true });
	
	      data.A1 = { t: 's', v: 'Employee id' };
	      data.B1 = { t: 's', v: 'Navn' };
	      data.C1 = { t: 's', v: 'Working hours' };
	
	      data.D1 = { t: 's', v: 'Teaching' };
	      data.D2 = { t: 's', v: 'Subject' };
	      data.E2 = { t: 's', v: 'Breaks' };
	      data.F1 = { t: 's', v: 'Tasks' };
	      data.G1 = { t: 's', v: 'Preparation' };
	
	      data.H1 = { t: 's', v: 'Substitute' };
	      data.H2 = { t: 's', v: 'Teaching' };
	      data.I2 = { t: 's', v: 'Not Teaching' };
	      data.J1 = { t: 's', v: 'Hours Left' };
	      data.K1 = { t: 's', v: 'Absence' };
	
	      var merge = [{ s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }, { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } }, { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } }, { s: { r: 0, c: 7 }, e: { r: 0, c: 8 } }];
	
	      data['!merges'] = merge;
	
	      var wb = XLSX.utils.book_new();
	      XLSX.utils.book_append_sheet(wb, data, 'data');
	
	      XLSX.writeFile(wb, 'docendo_tildel_timer.xlsx');
	
	      this.isDownloading = false;
	    },
	    humanizeNumber: function humanizeNumber(num) {
	      return parseFloat(num).toFixed(1);
	    },
	    closeEditing: function closeEditing() {
	      this.isDropdownPopperDone = false;
	      this.theEditNumberUser = null;
	      this.theEditNumberType = '';
	      this.theEditNumberNumber = 0;
	    },
	    doneEditing: function doneEditing() {
	      console.log('doneEditing');
	      this.updateUser(this.theEditNumberUser, this.theEditNumberNumber);
	    },
	    createPopper: function createPopper(parentPopper, childPopper) {
	      parentPopper.appendChild(childPopper);
	    },
	    setOpenEdit: function setOpenEdit(obj) {
	      var _this4 = this;
	
	      this.isDropdownPopperDone = false;
	      this.theEditNumberUser = obj.user;
	      this.theEditNumberType = obj.type;
	      this.theEditNumberNumber = obj.number;
	      this.$nextTick(function (_) {
	        _this4.createPopper(obj.evt.target, _this4.$refs.popper_child);
	        _this4.isDropdownPopperDone = true;
	      });
	    },
	    openEdit: function openEdit(user, num, type, evt) {
	      var numberInfo = {
	        user: user,
	        number: num,
	        type: type,
	        evt: evt
	      };
	      this.setOpenEdit(numberInfo);
	    },
	    updateUser: function updateUser(user, val) {
	      var _this5 = this;
	
	      this.isUpdatingNumber = true;
	      var change = 'weeklyHours';
	      var customData = user.custom_data;
	      var changes = {};
	      if (!customData['schools']) {
	        customData.schools = (0, _defineProperty3.default)({}, this.schoolId, (0, _defineProperty3.default)({}, change, val));
	      }
	      if (customData['schools'] && !customData['schools'][this.schoolId]) {
	        customData['schools'][this.schoolId] = (0, _defineProperty3.default)({}, change, val);
	      }
	      if (customData['schools'] && customData['schools'][this.schoolId]) {
	        if (!val || val.length < 1) {
	          delete customData['schools'][this.schoolId][[change]];
	        } else {
	          customData['schools'][this.schoolId][[change]] = val;
	        }
	      }
	      changes['custom_data'] = customData;
	      _docendo2.default.updateUsers(this.schoolId, user.id, changes, function (data) {
	        _this5.isUpdatingNumber = false;
	        _this5.closeEditing();
	        _this5.$store.commit('updateSchoolUser', data);
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    debounce: function debounce(func, delay) {
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(func, delay);
	    },
	    setPrevWeek: function setPrevWeek() {
	      var date = (0, _moment2.default)(this.startDate).subtract(1, 'week');
	      this.startDate = (0, _moment2.default)(date).startOf('isoWeek');
	      this.endDate = (0, _moment2.default)(date).endOf('isoWeek');
	      this.readEvents();
	    },
	    setNextWeek: function setNextWeek() {
	      var date = (0, _moment2.default)(this.startDate).add(1, 'week');
	      this.startDate = (0, _moment2.default)(date).startOf('isoWeek');
	      this.endDate = (0, _moment2.default)(date).endOf('isoWeek');
	      this.readEvents();
	    },
	    setThisWeek: function setThisWeek() {
	      this.startDate = (0, _moment2.default)().startOf('isoWeek');
	      this.endDate = (0, _moment2.default)().endOf('isoWeek');
	      this.readEvents();
	    },
	    setStartDate: function setStartDate(date) {
	      this.setDates(date, null);
	    },
	    setEndDate: function setEndDate(date) {
	      this.setDates(null, date);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.startDate = start;
	      }
	      if (end) {
	        this.endDate = end;
	      }
	      this.readEvents();
	    },
	    placeEventsOnUsers: function placeEventsOnUsers() {
	      var _this6 = this;
	
	      this.eventsInUserCalendarIdHash = {};
	
	      var eventsSorted = this.events.slice().sort(function (a, b) {
	        if (a.event_type === 'available' && b.event_type !== 'available') return -1;
	        if (b.event_type === 'available' && a.event_type !== 'available') return 1;
	        return 0;
	      });
	
	      eventsSorted.forEach(function (event) {
	        if (event.event_type === 'presence') {
	          var calcMinutes = (0, _moment2.default)(event.end).diff(event.start, 'minutes');
	          if (!_this6.eventsInUserCalendarIdHash[event.calendar_id]) {
	            _this6.eventsInUserCalendarIdHash[event.calendar_id] = {};
	          }
	          if (_this6.eventsInUserCalendarIdHash[event.calendar_id]['presence']) {
	            _this6.eventsInUserCalendarIdHash[event.calendar_id]['presence'] += calcMinutes;
	          } else {
	            _this6.eventsInUserCalendarIdHash[event.calendar_id]['presence'] = calcMinutes;
	          }
	          return;
	        }
	
	        if (event.school_id !== _this6.schoolId) {
	          return;
	        }
	
	        event.calendars.forEach(function (calendarEvent) {
	          if (calendarEvent.calendar_type !== 'user') {
	            return;
	          }
	
	          var calendarId = calendarEvent.calendar_id;
	          if (!_this6.eventsInUserCalendarIdHash[calendarId]) {
	            _this6.eventsInUserCalendarIdHash[calendarId] = {};
	          }
	
	          if (!calendarEvent.substitute && event.event_type === 'available') {
	            if (!_this6.eventsInUserCalendarIdHash[calendarId]['available']) {
	              _this6.eventsInUserCalendarIdHash[calendarId]['available'] = [event];
	              _this6.eventsInUserCalendarIdHash[calendarId]['available_count'] = calendarEvent.minutes;
	            } else {
	              var idxAvail = _this6.eventsInUserCalendarIdHash[calendarId]['available'].findIndex(function (e) {
	                return e.event_id === event.event_id;
	              });
	              if (idxAvail < 0) {
	                _this6.eventsInUserCalendarIdHash[calendarId]['available'].push(event);
	                _this6.eventsInUserCalendarIdHash[calendarId]['available_count'] += calendarEvent.minutes;
	              }
	            }
	            return;
	          }
	
	          if (!calendarEvent.substitute) {
	            var propName = event.event_type + '_count';
	            if (!_this6.eventsInUserCalendarIdHash[calendarId][event.event_type]) {
	              _this6.eventsInUserCalendarIdHash[calendarId][event.event_type] = [event];
	              _this6.eventsInUserCalendarIdHash[calendarId][propName] = calendarEvent.minutes;
	            } else {
	              var idx = _this6.eventsInUserCalendarIdHash[calendarId][event.event_type].findIndex(function (userEvent) {
	                return userEvent.event_id === event.event_id;
	              });
	              if (idx < 0) {
	                _this6.eventsInUserCalendarIdHash[calendarId][event.event_type].push(event);
	                _this6.eventsInUserCalendarIdHash[calendarId][propName] += calendarEvent.minutes;
	              }
	            }
	            return;
	          }
	
	          var teachingTypes = ['subject', 'person_resource', 'person_resource_visible', 'optional'];
	          var isTeaching = teachingTypes.indexOf(event.event_type) > -1;
	          var availableList = _this6.eventsInUserCalendarIdHash[calendarId] && _this6.eventsInUserCalendarIdHash[calendarId]['available'] ? _this6.eventsInUserCalendarIdHash[calendarId]['available'] : [];
	
	          var overlap = 0;
	          availableList.forEach(function (av) {
	            overlap += _this6.computeOverlapMinutes(event.start, event.end, av.start, av.end);
	          });
	
	          var effectiveMinutes = Math.max(0, calendarEvent.minutes - overlap);
	
	          if (isTeaching) {
	            if (effectiveMinutes > 0) {
	              if (!_this6.eventsInUserCalendarIdHash[calendarId]['substitute_teaching']) {
	                _this6.eventsInUserCalendarIdHash[calendarId]['substitute_teaching'] = [event];
	                _this6.eventsInUserCalendarIdHash[calendarId]['substitute_teaching_count'] = effectiveMinutes;
	              } else {
	                var idxST = _this6.eventsInUserCalendarIdHash[calendarId]['substitute_teaching'].findIndex(function (userEvent) {
	                  return userEvent.event_id === event.event_id;
	                });
	                if (idxST < 0) {
	                  _this6.eventsInUserCalendarIdHash[calendarId]['substitute_teaching'].push(event);
	                  _this6.eventsInUserCalendarIdHash[calendarId]['substitute_teaching_count'] += effectiveMinutes;
	                }
	              }
	            }
	          } else {
	            if (effectiveMinutes > 0) {
	              if (!_this6.eventsInUserCalendarIdHash[calendarId]['substitute_not_teaching']) {
	                _this6.eventsInUserCalendarIdHash[calendarId]['substitute_not_teaching'] = [event];
	                _this6.eventsInUserCalendarIdHash[calendarId]['substitute_not_teaching_count'] = effectiveMinutes;
	              } else {
	                var idxSNT = _this6.eventsInUserCalendarIdHash[calendarId]['substitute_not_teaching'].findIndex(function (userEvent) {
	                  return userEvent.event_id === event.event_id;
	                });
	                if (idxSNT < 0) {
	                  _this6.eventsInUserCalendarIdHash[calendarId]['substitute_not_teaching'].push(event);
	                  _this6.eventsInUserCalendarIdHash[calendarId]['substitute_not_teaching_count'] += effectiveMinutes;
	                }
	              }
	            }
	          }
	        });
	      });
	    },
	    readEvents: function readEvents() {
	      var _this7 = this;
	
	      if (this.filteredCalendars.length < 1) {
	        return;
	      }
	      this.clickCount++;
	      var start = this.startDate;
	      var end = this.endDate;
	      var calendarIds = this.filteredCalendars;
	      if (this.clickCount === 2) {
	        clearTimeout(this.clickCountTimer);
	      }
	      if (this.clickCount === 1) {
	        this.isLoading = true;
	        _docendo2.default.calendarEvents2(calendarIds, start, end, null, function (success) {
	          _this7.events = success && success.length > 0 ? JSON.parse(success) : [];
	          _this7.placeEventsOnUsers();
	          _this7.isLoading = false;
	        }, function (failure) {
	          console.log('failure', failure);
	        });
	        this.clickCountTimer = setTimeout(function () {
	          _this7.clickCount = 0;
	        }, 300);
	      } else {
	        this.debounce(function () {
	          _this7.isLoading = true;
	          _docendo2.default.calendarEvents2(calendarIds, start, end, null, function (success) {
	            _this7.events = success && success.length > 0 ? JSON.parse(success) : [];
	            _this7.placeEventsOnUsers();
	            _this7.isLoading = false;
	          }, function (failure) {
	            console.log('failure', failure);
	          });
	          _this7.clickCount = 0;
	        }, 300);
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.readEvents();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$refs.popper_child) {
	      this.$refs.popper_child.remove();
	    }
	  }
	};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Modal = __webpack_require__(363);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Pricing = __webpack_require__(1458);
	
	var _Pricing2 = _interopRequireDefault(_Pricing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { modal: _Modal2.default, Pricing: _Pricing2.default },
	  data: function data() {
	    return {
	      interval: 1,
	
	      selectedModel: null,
	      users: '',
	      pupils: '',
	
	      name: '',
	      email: '',
	      phone: '',
	      schoolName: '',
	      schoolEAN: '',
	      showModal: false,
	      modalHeader: '',
	      modalBody: ''
	    };
	  },
	
	  props: ['school'],
	  exampleData: {
	    school: 3
	  },
	  computed: {
	    isChatActive: function isChatActive() {
	      return window.$crisp;
	    },
	    country: function country() {
	      return window.SCHOOL.country.toLowerCase();
	    },
	    isCountryDK: function isCountryDK() {
	      return this.country === 'dk';
	    },
	    countryIsDkOrNo: function countryIsDkOrNo() {
	      return this.country === 'dk' || this.country === 'no';
	    },
	    currency: function currency() {
	      if (this.country === 'dk') {
	        return 'kr';
	      } else if (this.country === 'no') {
	        return 'kr';
	      } else {
	        return '€';
	      }
	    },
	    monthlyInstitutionPrice: function monthlyInstitutionPrice() {
	      if (this.country === 'dk') {
	        return 499;
	      } else if (this.country === 'no') {
	        return 499;
	      } else {
	        return 50;
	      }
	    },
	    userPrice: function userPrice() {
	      if (this.country === 'dk') {
	        return 45;
	      } else if (this.country === 'no') {
	        return 59;
	      } else {
	        return 5;
	      }
	    },
	    pupilsPrice: function pupilsPrice() {
	      return this.country === 'dk' ? 5 : 6.5;
	    },
	    buyButtonEnabled: function buyButtonEnabled() {
	      return this.name.length > 0 && this.email.length > 0 && this.phone.length > 0 && this.schoolName.length > 0;
	    },
	    userAmount: function userAmount() {
	      return this.users < 0 ? 0 : this.users * this.userPrice;
	    },
	    pupilAmount: function pupilAmount() {
	      return this.pupils < 0 ? 0 : this.pupils * this.pupilsPrice;
	    },
	    yearlyPayment: function yearlyPayment() {
	      return this.interval * 1 === 2;
	    },
	    yearlySavings: function yearlySavings() {
	      var total = this.totalAmount * 1.02 * 0.02;
	      return total.toFixed(0);
	    },
	    totalAmount: function totalAmount() {
	      var total = 0;
	
	      if (this.selectedModel === 1) {
	        if (this.yearlyPayment) {
	          total = (this.userAmount + this.monthlyInstitutionPrice) * 0.98 * 12;
	        } else {
	          total = this.userAmount + this.monthlyInstitutionPrice;
	        }
	      } else if (this.selectedModel === 2) {
	        if (this.yearlyPayment) {
	          total = (this.pupilAmount + this.monthlyInstitutionPrice) * 0.98 * 12;
	        } else {
	          total = this.pupilAmount + this.monthlyInstitutionPrice;
	        }
	      } else {
	        total = this.monthlyInstitutionPrice;
	      }
	      return total.toFixed(0);
	    }
	  },
	  methods: {
	    selectModel: function selectModel(num) {
	      this.selectedModel = num;
	    },
	    isSelectedModel: function isSelectedModel(num) {
	      return this.selectedModel === num;
	    },
	    buyClick: function buyClick() {
	      this.showModal = true;
	      this.modalHeader = this.$i18n.t('repitition.processing');
	      this.modalBody = '<h1>' + this.$i18n.t('repitition.one_moment') + '</h1>';
	      _docendo2.default.schoolSubscribe(this.school, {
	        name: this.name,
	        user_count: this.selectedModel === 1 ? parseInt(this.users) : 0,
	        pupil_count: this.selectedModel === 2 ? parseInt(this.pupils) : 0,
	        pay_monthly: this.interval === 1,
	        email: this.email,
	        phone: this.phone,
	        school_name: this.schoolName,
	        ean: this.schoolEAN
	      }, this.buyCallbackSuccess, this.buyCallbackFailure);
	    },
	    buyCallbackSuccess: function buyCallbackSuccess(data) {
	      this.showModal = true;
	      this.modalHeader = this.$i18n.t('vue.buy.thanks_for_buying');
	      this.modalBody = '<a class="font-xlarge" href="/home">' + this.$i18n.t('vue.buy.go_to_home') + '</a>';
	      this.$store.dispatch('analyticsOnSubscribe');
	    },
	    buyCallbackFailure: function buyCallbackFailure(data) {
	      console.log('buyCallbackFailure', data);
	      console.log(data.full_messages);
	      this.modalHeader = this.$i18n.t('vue.buy.error');
	      this.modalBody = this.$i18n.t('vue.buy.missing_inputs');
	      this.showModal = true;
	    },
	    closedModal: function closedModal() {
	      this.showModal = false;
	    },
	    openCrispChat: function openCrispChat() {
	      if (window.$crisp) {
	        window.$crisp.push(['do', 'chat:open']);
	      } else {
	        console.error('Crisp is not loaded on this page.');
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('analyticsOnVisitedBuy');
	  },
	  updated: function updated() {
	    if (!this.countryIsDkOrNo) {
	      this.selectModel(1);
	    }
	  }
	};

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      features: ['Automatisk skemalægning', 'Fleksibel skemalægning', 'Vikardækning', 'Arbejdstidsregistering', 'Årsnorm/Tjenestetid', 'Fagfordeling', 'Opgave- og aktivitetsoversigt', 'Ugeplan', 'Integration med Uni-C (Uni-Login), Aula, Google, Outlook m.m', 'Aula widgets: Dagens Vikarer & Ugeplan', 'Import af fag fra Undervisningsministeriet', 'Grundskole- og kompetenceindberetning', 'Support', 'Evt. Import af jeres nuværende skemaer']
	    };
	  }
	};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DoDatePickerRange = __webpack_require__(44);
	
	var _DoDatePickerRange2 = _interopRequireDefault(_DoDatePickerRange);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    flextime: 'Flextid',
	    flexin: 'Flex ind',
	    flexout: 'Flex ud',
	    teaching: 'Undervisning',
	    preparation: 'Forberedelse',
	    additional_tasks: 'Øvrige Opgaver',
	    available: 'Rådighedstimer',
	    club: 'SFO tid',
	    pool: 'Lokalpulje',
	    absence: 'Fravær',
	    other: 'Opgaver',
	    subject: 'Fag',
	    person_resource: 'Ressource',
	    person_resource_visible: 'Synlig ressource',
	    with_kids: 'Med børn',
	    without_kids: 'Uden børn',
	    unknown: 'Rådighedstime',
	    break: 'Pause',
	    period_hours: 'Timer i perioden',
	    no_schedule: 'Intet skemalagt i perioden',
	    hour: 'time',
	    hours: 'timer',
	    min: 'min',
	    optional: 'Valgfag',
	    resource: 'Ressource',
	    show_lessons: 'Vis i lektioner'
	  },
	  en: {
	    teaching: 'Teaching',
	    preparation: 'Preparation',
	    additional_tasks: 'Additional Tasks',
	    available: 'Available Hours',
	    club: 'Club Time',
	    pool: 'Local Pool',
	    absence: 'Absence',
	    period_hours: 'Hours in the Period',
	    no_schedule: 'No Schedule in the Period',
	    other: 'Tasks',
	    subject: 'Course',
	    person_resource: 'Resource',
	    person_resource_visible: 'Visible resource',
	    with_kids: 'With children',
	    without_kids: 'Without children',
	    unknown: 'Free period',
	    break: 'Break',
	    hour: 'hour',
	    hours: 'hours',
	    min: 'min',
	    optional: 'Optional',
	    resource: 'Resource',
	    show_lessons: 'Show lessons'
	  },
	  nb: {
	    teaching: 'Undervisning',
	    preparation: 'Forberedelse',
	    additional_tasks: 'Ekstra oppgaver',
	    available: 'Tilgjengelige timer',
	    club: 'SFO tid',
	    pool: 'Lokalpulje',
	    absence: 'Fravær',
	    period_hours: 'Timer i perioden',
	    no_schedule: 'Ingen timeplan i perioden',
	    other: 'Oppgaver',
	    subject: 'Fag',
	    person_resource: 'Ressurs',
	    person_resource_visible: 'Synlig ressurs',
	    with_kids: 'Med barn',
	    without_kids: 'Uten barn',
	    unknown: 'Ledig time',
	    break: 'Pause',
	    hour: 'time',
	    hours: 'timer',
	    min: 'min',
	    optional: 'Valgfag',
	    resource: 'Ressurs',
	    show_lessons: 'Vis leksjoner'
	  }
	};
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default, Loader: _Loader2.default, DoDatePickerRange: _DoDatePickerRange2.default },
	  props: {
	    schoolId: { default: 7272 },
	    calendarId: { default: 7 },
	    isShowOptions: { type: Boolean, default: true },
	    date: { default: (0, _moment2.default)() }
	  },
	  data: function data() {
	    return {
	      startDate: (0, _moment2.default)(this.date).startOf('isoWeek'),
	      endDate: (0, _moment2.default)(this.date).endOf('isoWeek'),
	      hours: [],
	      isLoading: false,
	      maxHeight: '50vh',
	      showLessons: false
	    };
	  },
	
	  computed: {
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    localPoolTitle: function localPoolTitle() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || this.$t('vue2.task_overview.pool');
	    },
	    isDKSchool: function isDKSchool() {
	      return this.school && this.school.country && this.school.country === 'DK';
	    },
	    subjectDefaultDuration: function subjectDefaultDuration() {
	      return this.school && this.school.subject_default_duration ? this.school.subject_default_duration : 45;
	    },
	    hoursGrouped: function hoursGrouped() {
	      var _this = this;
	
	      var categories = [];
	      this.hours.forEach(function (subarray) {
	        var masterType = subarray[0] ? subarray[0] : null;
	        var subjectType = subarray[1] ? subarray[1] : null;
	        var subjectTitle = subarray[2] ? subarray[2] : null;
	        var minutes = subarray[3] ? subarray[3] : 0;
	        var vHours = _this.getMinutesToHours(minutes);
	        var vLessons = _this.getLessonsNumber(minutes);
	
	        if (masterType) {
	          var masterTypeIdx = categories.findIndex(function (cat) {
	            return cat.masterType === masterType;
	          });
	          if (masterTypeIdx < 0) {
	            categories.push({
	              masterType: masterType,
	              vTitle: _this.getTitle(masterType),
	              vOrder: _this.getOrder(masterType),
	              vHours: vHours,
	              vLessons: vLessons,
	              subCategories: []
	            });
	          } else {
	            if (subjectType && !subjectTitle) {
	              var subjectTypeIdx = categories[masterTypeIdx]['subCategories'].findIndex(function (subCat) {
	                return subCat.subjectType === subjectType;
	              });
	              var subjectTypeObj = {
	                masterType: masterType,
	                subjectType: subjectType,
	                vTitle: _this.getTitle(subjectType),
	                vHours: vHours,
	                vLessons: vLessons,
	                vOrder: _this.getOrder(subjectType),
	                subjects: []
	              };
	              if (subjectTypeIdx < 0) {
	                categories[masterTypeIdx]['subCategories'].push(subjectTypeObj);
	              } else {
	                categories[masterTypeIdx]['subCategories'][subjectTypeIdx].push(subjectTypeObj);
	              }
	            }
	            if (subjectType && subjectTitle) {
	              var _subjectTypeIdx = categories[masterTypeIdx]['subCategories'].findIndex(function (subCat) {
	                return subCat.subjectType === subjectType;
	              });
	              var subjectObj = {
	                masterType: masterType,
	                subjectType: subjectType,
	                subjectTitle: subjectTitle,
	                vTitle: subjectTitle,
	                vHours: vHours,
	                vLessons: vLessons
	              };
	              categories[masterTypeIdx]['subCategories'][_subjectTypeIdx]['subjects'].push(subjectObj);
	            }
	          }
	        }
	      });
	      return categories;
	    },
	    hoursGroupedSorted: function hoursGroupedSorted() {
	      var sorted = [].concat((0, _toConsumableArray3.default)(this.hoursGrouped));
	      sorted.sort(function (a, b) {
	        return a.vOrder - b.vOrder;
	      });
	      sorted.forEach(function (item) {
	        if (item.subCategories) item.subCategories.sort(function (a, b) {
	          return a.vOrder - b.vOrder;
	        });
	      });
	      return sorted;
	    }
	  },
	  methods: {
	    getTitle: function getTitle(label) {
	      if (label === 'pool') {
	        return this.localPoolTitle;
	      }
	      return this.i18n[label] ? this.i18n[label] : label;
	    },
	    getOrder: function getOrder(label) {
	      var orders = {
	        flextime: 1,
	        teaching: 1,
	        subject: 1,
	        person_resource: 3,
	        person_resource_visible: 2,
	        with_kids: 1,
	        without_kids: 2,
	        additional_tasks: 2,
	        other: 3,
	        preparation: 4,
	        available: 7,
	        club: 6,
	        pool: 5,
	        unknown: 7,
	        break: 2,
	        absence: 12
	      };
	      return orders[label] ? orders[label] : 20;
	    },
	    setDates: function setDates(startAndEnd) {
	      var start = startAndEnd.start;
	      var end = startAndEnd.end;
	      if (start) this.startDate = start;
	      if (end) this.endDate = end;
	      this.readHours();
	    },
	    readHours: function readHours() {
	      var _this2 = this;
	
	      this.isLoading = true;
	      this.hours = [];
	      var start = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var end = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      _docendo2.default.hoursCountForCalendar(this.schoolId, this.calendarId, start, end, function (success) {
	        _this2.hours = JSON.parse(success);
	        _this2.isLoading = false;
	      }, function (failure) {
	        return console.log({ failure: failure });
	      });
	    },
	    getMinutesToHours: function getMinutesToHours(minutes) {
	      var total = Math.abs(minutes).toFixed(0);
	      var h = Math.floor(total / 60);
	      var m = total % 60;
	      var hLabel = h !== 1 ? this.i18n['hours'] : this.i18n['hour'];
	      var sign = minutes < 0 ? '-' : '';
	      var hoursStr = h > 0 ? h + ' ' + hLabel + ' ' : '';
	      return sign + hoursStr + m + ' ' + this.i18n['min'];
	    },
	    getLessonsNumber: function getLessonsNumber(minutes) {
	      if (!minutes) return '0.0';
	      var total = Math.abs(minutes);
	      var raw = total / this.subjectDefaultDuration;
	      var rounded = Math.round(raw * 10) / 10;
	      var sign = minutes < 0 ? '-' : '';
	      return sign + rounded.toFixed(1);
	    },
	    calculateMaxHeight: function calculateMaxHeight() {
	      var pxFromTop = this.$refs.dropdown.getBoundingClientRect().top;
	      var maxHeight = window.innerHeight - (pxFromTop + 30);
	      this.maxHeight = maxHeight + 'px';
	    },
	    setShowLessons: function setShowLessons(bool) {
	      this.showLessons = bool;
	      var key = 'do_calculate_hours_as_lessons';
	      if (bool) {
	        this.$helpers.setLocalStorage(key, true);
	        this.$store.dispatch('trackEvent', 'calendar_calculateHours_showAsLessons');
	      } else {
	        this.$helpers.removeLocalStorage(key);
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    var key = 'do_calculate_hours_as_lessons';
	    var isActivated = this.$helpers.getLocalStorage(key);
	    if (isActivated && this.isDKSchool) {
	      this.showLessons = true;
	    }
	  },
	  mounted: function mounted() {
	    this.calculateMaxHeight();
	    window.addEventListener('resize', this.calculateMaxHeight);
	    this.readHours();
	    this.$store.dispatch('trackEvent', 'calendar_calculateHours_view');
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.calculateMaxHeight);
	  }
	};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _CopyEvent = __webpack_require__(135);
	
	var _CopyEvent2 = _interopRequireDefault(_CopyEvent);
	
	var _Modal = __webpack_require__(69);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    bulk_actions: 'Massehandling',
	    delete_events_onward: 'Slet lektioner fremadrettet',
	    delete_in_week: 'Slet alle valgte',
	    copy_events: 'Kopier lektioner',
	    cancel_selection: 'Annuller',
	    are_you_sure: 'Er du sikker?',
	    delete_question_onward: 'Vil du slette de valgte lektioner, og alle der ligger på samme ugedag og i samme tidsrum fremadrettet?',
	    delete_question_week: 'Vil du slette de valgte lektioner i denne uge?',
	    cancel_events: 'Aflys valgte lektioner',
	    uncancel_events: 'Fortryd aflysning',
	    cancel_question: 'Vil du aflyse de valgte lektioner? De bliver ikke slettet, men markeret som aflyst.',
	    uncancel_question: 'Vil du fortryde aflysningen af de valgte lektioner?',
	    away_events: 'Markér som ude af huset',
	    unaway_events: 'Fortryd ude af huset',
	    away_question: 'Vil du markere de valgte lektioner som ude af huset? Personale på lektionerne vil fremgå i vikardækningen som fraværende.',
	    unaway_question: 'Vil du fortryde markeringen som ude af huset for de valgte lektioner?',
	    cancel: 'Annuller'
	  },
	  en: {
	    bulk_actions: 'Bulk action',
	    delete_events_onward: 'Delete lessons forward',
	    delete_in_week: 'Delete all selected',
	    copy_events: 'Copy lessons',
	    cancel_selection: 'Cancel',
	    are_you_sure: 'Are you sure?',
	    delete_question_onward: 'Would you like to delete the selected lessons and all that lie on the same day of the week and in the same time period going forward?',
	    delete_question_week: 'Would you like to delete the selected lessons in this week?',
	    cancel_events: 'Cancel selected lessons',
	    uncancel_events: 'Undo cancellation',
	    cancel_question: 'Would you like to cancel the selected lessons? They will not be deleted but marked as canceled.',
	    uncancel_question: 'Would you like to undo the cancellation of the selected lessons?',
	    away_events: 'Mark as out of school',
	    unaway_events: 'Undo out of school',
	    away_question: 'Would you like to mark the selected lessons as out of school? Staff in the lessons will appear in the substitute management as absent.',
	    unaway_question: 'Would you like to undo the out of school marking for the selected lessons?',
	    cancel: 'Cancel'
	  },
	  nb: {
	    bulk_actions: 'Massehandling',
	    delete_events_onward: 'Slett timer fremover',
	    delete_in_week: 'Slett alle valgte',
	    copy_events: 'Kopier timer',
	    cancel_selection: 'Avbryt',
	    are_you_sure: 'Er du sikker?',
	    delete_question_onward: 'Vil du slette de valgte timene og alle tilsvarende planlagte timer i samme tidsrom fremover i tid?',
	    delete_question_week: 'Vil du slette de valgte timene i denne uken?',
	    cancel_events: 'Avlys valgte timer',
	    uncancel_events: 'Angre avlysning',
	    cancel_question: 'Vil du avlyse de valgte timene? De blir ikke slettet, men markert som avlyst.',
	    uncancel_question: 'Vil du angre avlysningen av de valgte timene?',
	    away_events: 'Marker som utenfor skolen',
	    unaway_events: 'Angre utenfor skolen',
	    away_question: 'Vil du markere de valgte timene som utenfor skolen? Personalet på timene vil vises i vikarhåndteringen som fraværende.',
	    unaway_question: 'Vil du angre markeringen som utenfor skolen for de valgte timene?',
	    cancel: 'Avbryt'
	  }
	};
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default, CopyEvent: _CopyEvent2.default, Modal: _Modal2.default },
	  data: function data() {
	    return {
	      isDeleteModal: false,
	      isDeleting: false,
	      deleteMode: 'onward'
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store && this.$store.getters ? this.$store.getters.locale : 'da';
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    isMultiSelectActive: function isMultiSelectActive() {
	      return this.$store.getters.isMultiSelectActive;
	    },
	    selectedEventIds: function selectedEventIds() {
	      return this.$store.state.calendar.selectedEventIds;
	    },
	    selectedCalendarEvents: function selectedCalendarEvents() {
	      return this.$store.getters.selectedCalendarEvents;
	    },
	    calendarId: function calendarId() {
	      return this.$store.state.calendar.calendarId;
	    },
	    activeCalendarDate: function activeCalendarDate() {
	      return this.$store.state.calendar.date;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    isVisible: function isVisible() {
	      return this.selectedEventIds.length > 0;
	    },
	    deleteQuestion: function deleteQuestion() {
	      var keys = {
	        week: 'delete_question_week',
	        onward: 'delete_question_onward',
	        cancel: 'cancel_question',
	        uncancel: 'uncancel_question',
	        away: 'away_question',
	        unaway: 'unaway_question'
	      };
	      return this.i18n[this.locale][keys[this.deleteMode]];
	    },
	    confirmButtonLabel: function confirmButtonLabel() {
	      var keys = {
	        week: 'delete_in_week',
	        onward: 'delete_events_onward',
	        cancel: 'cancel_events',
	        uncancel: 'uncancel_events',
	        away: 'away_events',
	        unaway: 'unaway_events'
	      };
	      return this.i18n[this.locale][keys[this.deleteMode]];
	    }
	  },
	  methods: {
	    clearSelection: function clearSelection() {
	      this.$store.commit('clearSelectedEventIds');
	    },
	    startBulkCopy: function startBulkCopy() {
	      var events = this.selectedCalendarEvents;
	      if (events.length < 1) {
	        return;
	      }
	      var first = events[0];
	
	      var earliestStart = first.start;
	      var earliestMs = first.start ? new Date(first.start).getTime() : null;
	      events.forEach(function (event) {
	        if (!event.start) {
	          return;
	        }
	        var ms = new Date(event.start).getTime();
	        if (earliestMs === null || ms < earliestMs) {
	          earliestMs = ms;
	          earliestStart = event.start;
	        }
	      });
	      _eventbus2.default.copyEventsBulk = {
	        event_ids: this.selectedEventIds.slice(),
	        calendar_id: first.calendar_id ? first.calendar_id : this.calendarId * 1,
	        school_id: first.school_id ? first.school_id : this.schoolId,
	        start: earliestStart || this.activeCalendarDate,
	        title: '',
	        color: first.color ? first.color : '#468ad7',
	        v_popper_anchor: '#vue-popper__massehandling_button'
	      };
	    },
	    openDeleteModal: function openDeleteModal(mode) {
	      this.deleteMode = ['week', 'cancel', 'uncancel', 'away', 'unaway'].indexOf(mode) > -1 ? mode : 'onward';
	      this.isDeleteModal = true;
	    },
	    closeDeleteModal: function closeDeleteModal() {
	      if (this.isDeleting) {
	        return;
	      }
	      this.isDeleteModal = false;
	    },
	    confirmDelete: function confirmDelete() {
	      if (this.deleteMode === 'week') {
	        this.deleteSelectedEventsInWeek();
	      } else if (this.deleteMode === 'cancel' || this.deleteMode === 'uncancel') {
	        this.setSelectedEventsFlag('canceled', this.deleteMode === 'cancel');
	      } else if (this.deleteMode === 'away' || this.deleteMode === 'unaway') {
	        this.setSelectedEventsFlag('away', this.deleteMode === 'away');
	      } else {
	        this.deleteSelectedEventsOnward();
	      }
	    },
	    setSelectedEventsFlag: function setSelectedEventsFlag(prop, value) {
	      var _this = this;
	
	      var updatesBySchool = {};
	      this.selectedCalendarEvents.forEach(function (event) {
	        if (!!event[prop] === value) {
	          return;
	        }
	        var schoolId = event.school_id ? event.school_id : _this.schoolId;
	        updatesBySchool[schoolId] = updatesBySchool[schoolId] || [];
	        updatesBySchool[schoolId].push((0, _defineProperty3.default)({ event_id: event.event_id }, prop, value));
	      });
	      var schoolIds = (0, _keys2.default)(updatesBySchool);
	      if (schoolIds.length < 1) {
	        this.isDeleteModal = false;
	        this.$store.commit('clearSelectedEventIds');
	        return;
	      }
	      this.isDeleting = true;
	      var remaining = schoolIds.length;
	      var done = function done() {
	        remaining -= 1;
	        if (remaining === 0) {
	          _this.onAllDeleted();
	        }
	      };
	      schoolIds.forEach(function (schoolId) {
	        _docendo2.default.updateEvents(schoolId * 1, updatesBySchool[schoolId], done, function (failure) {
	          console.log('bulk update ' + prop + ' failure', failure);
	          done();
	        });
	      });
	    },
	    deleteSelectedEventsOnward: function deleteSelectedEventsOnward() {
	      var _this2 = this;
	
	      var events = this.selectedCalendarEvents.slice();
	      if (events.length < 1) {
	        this.closeDeleteModal();
	        return;
	      }
	      this.isDeleting = true;
	      var remaining = events.length;
	      var done = function done() {
	        remaining -= 1;
	        if (remaining === 0) {
	          _this2.onAllDeleted();
	        }
	      };
	      events.forEach(function (event) {
	        var schoolId = event.school_id ? event.school_id : _this2.schoolId;
	        _docendo2.default.eventsDeleteThisAndFollowing(schoolId, event.event_id, function () {
	          _this2.$store.commit('deleteActiveCalendarEvent', event);
	          done();
	        }, function (failure) {
	          console.log('bulk delete (onward) failure', failure);
	          done();
	        });
	      });
	    },
	    deleteSelectedEventsInWeek: function deleteSelectedEventsInWeek() {
	      var _this3 = this;
	
	      var events = this.selectedCalendarEvents.slice();
	      if (events.length < 1) {
	        this.closeDeleteModal();
	        return;
	      }
	      this.isDeleting = true;
	      var remaining = events.length;
	      var done = function done() {
	        remaining -= 1;
	        if (remaining === 0) {
	          _this3.onAllDeleted();
	        }
	      };
	      events.forEach(function (event) {
	        var schoolId = event.school_id ? event.school_id : _this3.schoolId;
	        _docendo2.default.deleteEvent(schoolId, event.event_id, function () {
	          _this3.$store.commit('deleteActiveCalendarEvent', event);
	          done();
	        }, function (failure) {
	          console.log('bulk delete (week) failure', failure);
	          done();
	        });
	      });
	    },
	    onAllDeleted: function onAllDeleted() {
	      this.isDeleting = false;
	      this.isDeleteModal = false;
	      this.$store.commit('clearSelectedEventIds');
	      this.$store.dispatch('readCalendarSubjects');
	    }
	  }
	};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default, Loader: _Loader2.default },
	  props: {
	    schoolId: {
	      default: null
	    },
	    calendarId: {
	      default: null
	    },
	    calendarType: {
	      default: null
	    },
	    calendar: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isLoadingMerges: false,
	      merges: [],
	      theLoaderId: null
	    };
	  },
	
	  computed: {
	    isMergeCalendar: function isMergeCalendar() {
	      var calType = this.calendar && this.calendar.type ? this.calendar.type : null;
	      return calType === 'merge';
	    },
	    schoolYear: function schoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    mergesFilteredForCalendar: function mergesFilteredForCalendar() {
	      var _this = this;
	
	      return this.merges.filter(function (merge) {
	        return merge.mergee_id === _this.calendarId;
	      });
	    },
	    activeMergeCalendars: function activeMergeCalendars() {
	      return this.$store.getters.mergeCalendars;
	    },
	    mergeCalendarsInclArchived: function mergeCalendarsInclArchived() {
	      return this.$store.getters.mergeCalendarsInclArchived;
	    },
	    mergeCalsMerged: function mergeCalsMerged() {
	      var _this2 = this;
	
	      return this.mergeCalendarsInclArchived.filter(function (mergeCalendar) {
	        return _this2.mergesFilteredForCalendar.findIndex(function (mergesCal) {
	          return mergesCal.merger_id === mergeCalendar.id;
	        }) > -1;
	      });
	    },
	    possibleMergeCals: function possibleMergeCals() {
	      var _this3 = this;
	
	      return this.activeMergeCalendars.filter(function (mergeCalender) {
	        return mergeCalender.school_year_id && mergeCalender.school_year_id === _this3.schoolYear.id && _this3.mergeCalsMerged.findIndex(function (cal) {
	          return cal.id === mergeCalender.id;
	        }) < 0;
	      });
	    },
	    allMergeCalendars: function allMergeCalendars() {
	      var mergedCals = this.mergeCalsMerged.map(function (cal) {
	        return (0, _extends3.default)({}, cal, {
	          vIsMerged: true
	        });
	      });
	      var cals = mergedCals.concat(this.possibleMergeCals);
	      return this.$helpers.sortArrOnName(cals);
	    },
	    allCalendars: function allCalendars() {
	      return this.$store.state.calendars;
	    },
	    mergesFilteredForMergeCalendar: function mergesFilteredForMergeCalendar() {
	      var _this4 = this;
	
	      return this.merges.filter(function (merge) {
	        return merge.merger_id === _this4.calendarId;
	      });
	    },
	    calendarsMerged: function calendarsMerged() {
	      var _this5 = this;
	
	      var cals = this.allCalendars.filter(function (calendar) {
	        return _this5.mergesFilteredForMergeCalendar.findIndex(function (mergesCal) {
	          return mergesCal.mergee_id === calendar.id;
	        }) > -1;
	      });
	      return this.$helpers.sortArrOnName(cals);
	    },
	    possibleToMerge: function possibleToMerge() {
	      var _this6 = this;
	
	      var typesToMerge = ['klass', 'club', 'other'];
	      var isCorrectTypes = this.allCalendars.filter(function (cal) {
	        return typesToMerge.indexOf(cal.type) > -1;
	      });
	      var isCorrectYear = isCorrectTypes.filter(function (cal) {
	        return cal.school_year_id === _this6.schoolYear.id;
	      });
	      var cals = isCorrectYear.filter(function (cal) {
	        return _this6.calendarsMerged.findIndex(function (calMerged) {
	          return calMerged.id === cal.id;
	        }) < 0;
	      });
	      return this.$helpers.sortArrOnName(cals);
	    }
	  },
	  methods: {
	    toggleMergeCalendar: function toggleMergeCalendar(calendar) {
	      this.theLoaderId = calendar.id;
	      if (calendar.vIsMerged) {
	        this.unMergeCalendar(calendar);
	      } else {
	        this.mergeCalendar(calendar);
	      }
	    },
	    mergeCalendar: function mergeCalendar(calendar) {
	      var _this7 = this;
	
	      _docendo2.default.mergeCalendar(this.schoolId, this.calendarId, calendar.id, function (success) {
	        _this7.readCalendarsMerges();
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    unMergeCalendar: function unMergeCalendar(calendar) {
	      var _this8 = this;
	
	      _docendo2.default.unmergeCalendar(this.schoolId, this.calendarId, calendar.id, function (success) {
	        _this8.readCalendarsMerges();
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    unMergeCalendarFromMergeCalendar: function unMergeCalendarFromMergeCalendar(calendar) {
	      var _this9 = this;
	
	      this.theLoaderId = calendar.id;
	      _docendo2.default.unmergeCalendar(this.schoolId, calendar.id, this.calendarId, function (success) {
	        _this9.readCalendarsMerges();
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    mergeCalendarFromMergeCalendar: function mergeCalendarFromMergeCalendar(calendar) {
	      var _this10 = this;
	
	      this.theLoaderId = calendar.id;
	      _docendo2.default.mergeCalendar(this.schoolId, calendar.id, this.calendarId, function (success) {
	        _this10.readCalendarsMerges();
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    readCalendarsMerges: function readCalendarsMerges(withSpinner) {
	      var _this11 = this;
	
	      if (withSpinner) {
	        this.isLoadingMerges = true;
	      }
	      _docendo2.default.listCalendarMerges(this.schoolId, function (success) {
	        _this11.isLoadingMerges = false;
	        _this11.theLoaderId = null;
	        _this11.merges = success;
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readCalendarsMerges(true);
	  }
	};

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _PresenceUser = __webpack_require__(82);
	
	var _PresenceUser2 = _interopRequireDefault(_PresenceUser);
	
	var _Spinner = __webpack_require__(26);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _ExportCalendar = __webpack_require__(97);
	
	var _ExportCalendar2 = _interopRequireDefault(_ExportCalendar);
	
	var _DWeekplan = __webpack_require__(406);
	
	var _DWeekplan2 = _interopRequireDefault(_DWeekplan);
	
	var _WeekSelecter = __webpack_require__(106);
	
	var _WeekSelecter2 = _interopRequireDefault(_WeekSelecter);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DCalendarShowEvent = __webpack_require__(81);
	
	var _DCalendarShowEvent2 = _interopRequireDefault(_DCalendarShowEvent);
	
	var _DCalendar = __webpack_require__(53);
	
	var _DCalendar2 = _interopRequireDefault(_DCalendar);
	
	var _TaskOverviewPage = __webpack_require__(147);
	
	var _TaskOverviewPage2 = _interopRequireDefault(_TaskOverviewPage);
	
	var _UserTasks = __webpack_require__(54);
	
	var _UserTasks2 = _interopRequireDefault(_UserTasks);
	
	var _SelectCalendar = __webpack_require__(415);
	
	var _SelectCalendar2 = _interopRequireDefault(_SelectCalendar);
	
	var _UserRequest = __webpack_require__(150);
	
	var _UserRequest2 = _interopRequireDefault(_UserRequest);
	
	var _Print = __webpack_require__(98);
	
	var _Print2 = _interopRequireDefault(_Print);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    UserRequest: _UserRequest2.default,
	    DCalendarShowEvent: _DCalendarShowEvent2.default,
	    SelectCalendar: _SelectCalendar2.default,
	    TaskOverviewPage: _TaskOverviewPage2.default,
	    UserTasks: _UserTasks2.default,
	    DWeekplan: _DWeekplan2.default,
	    DCalendar: _DCalendar2.default,
	    Loader: _Loader2.default,
	    Spinner: _Spinner2.default,
	    UserPresence: _PresenceUser2.default,
	    ExportCalendar: _ExportCalendar2.default,
	    weekSelector: _WeekSelecter2.default,
	    Print: _Print2.default
	  },
	  data: function data() {
	    return {
	      isShowWeekends: false,
	      startTime: '06:00:00',
	      endTime: '16:00:00',
	      isInPrintMode: false,
	      isCalendarInPrintMode: false,
	      theView: 'calendar',
	      isShowAbsenceRequest: false
	    };
	  },
	
	  computed: {
	    isEditable: function isEditable() {
	      return this.$store.getters.isUserCanEditCalendar;
	    },
	    isSubHeader: function isSubHeader() {
	      return this.canSeeTaskOverview || this.canSeeHourOverview;
	    },
	    canSeeTaskOverview: function canSeeTaskOverview() {
	      if (!this.user || !this.calendar) {
	        return false;
	      }
	      if (this.userHasPermission('can_see_own_task_overview') && this.isUsersCalendar) {
	        return true;
	      }
	      return this.userHasPermission('can_see_others_task_overviews') && this.calendar.type === 'user';
	    },
	    canSeeHourOverview: function canSeeHourOverview() {
	      if (!this.user || !this.calendar) {
	        return false;
	      }
	      if (this.userHasPermission('can_see_own_hour_overview') && this.isUsersCalendar) {
	        return true;
	      }
	      return this.userHasPermission('can_see_others_hour_overviews') && this.calendar.type === 'user';
	    },
	    theSelectedUser: function theSelectedUser() {
	      if (!this.calendar) {
	        var _userObj = {
	          userId: this.user.id,
	          name: this.user.name,
	          calendarId: this.user.user_calendar_id
	        };
	        return _userObj;
	      }
	      var userObj = {
	        userId: this.allUsersInCalIdHash[this.calendar.id] ? this.allUsersInCalIdHash[this.calendar.id].id : this.user.id,
	        name: this.calendar.name,
	        calendarId: this.calendar.id
	      };
	      return userObj;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    theActiveCalendarId: function theActiveCalendarId() {
	      return this.$store.state.calendar.calendarId;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isUsersCalendar: function isUsersCalendar() {
	      return this.$store.state.calendar.calendarId ? this.theActiveCalendarId === this.user.user_calendar_id : true;
	    },
	    schoolFeatures: function schoolFeatures() {
	      return this.$store.getters.schoolFeatures;
	    },
	    absenceRequestIsActivated: function absenceRequestIsActivated() {
	      return this.schoolFeatures.indexOf('absence_requests') > -1;
	    },
	    userCanRequestAbsence: function userCanRequestAbsence() {
	      return this.isUsersCalendar && this.absenceRequestIsActivated && this.userHasPermission('can_request_absence');
	    },
	    isShowWeekPlan: function isShowWeekPlan() {
	      return this.calendar && this.calendar.type === 'klass' || this.calendar && this.calendar.type === 'user' || this.calendar && this.calendar.type === 'other';
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    calendar: function calendar() {
	      return this.$store.getters.activeCalendar;
	    },
	    events: function events() {
	      return this.$store.state.calendar.events;
	    },
	    availabilityEvents: function availabilityEvents() {
	      return this.$store.state.calendar.availabilityEvents;
	    },
	    dCalendarEvents: function dCalendarEvents() {
	      return this.events.concat(this.availabilityEvents);
	    },
	    isEventsLoading: function isEventsLoading() {
	      return this.$store.state.calendar.isEventsLoading;
	    },
	    activeCalendarDate: function activeCalendarDate() {
	      return (0, _moment2.default)(this.$store.state.calendar.date).format('YYYY-MM-DD');
	    },
	    activeEvent: function activeEvent() {
	      return this.$store.getters.activeCalendarEvent;
	    },
	    iCalUrl: function iCalUrl() {
	      if (this.calendar && this.calendar.ical_url) {
	        return window.location.origin + this.calendar.ical_url;
	      } else if (this.calendar && this.calendar.ical_link) {
	        return window.location.origin + this.calendar.ical_link;
	      } else {
	        return 'loading';
	      }
	    },
	    isNotThisWeek: function isNotThisWeek() {
	      return (0, _moment2.default)(this.$store.state.calendar.date).isoWeek() === (0, _moment2.default)().isoWeek();
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    weekSelectorStartDate: function weekSelectorStartDate() {
	      var startDate = this.calendar && this.calendar.start_date ? this.calendar && this.calendar.start_date : (0, _moment2.default)().startOf('isoweek');
	      var calType = this.calendar ? this.calendar.type : 'klass';
	      if (this.activeSchoolYear) {
	        if (calType === 'klass') {
	          startDate = (0, _moment2.default)(this.activeSchoolYear.student_time_start).startOf('isoweek');
	        } else {
	          startDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_start).startOf('isoweek');
	        }
	      }
	      return startDate;
	    },
	    weekSelectorEndDate: function weekSelectorEndDate() {
	      var endDate = this.calendar && this.calendar.end_date ? this.calendar && this.calendar.end_date : (0, _moment2.default)().startOf('isoweek');
	      var calType = this.calendar ? this.calendar.type : 'klass';
	      if (this.activeSchoolYear) {
	        if (calType === 'klass') {
	          endDate = (0, _moment2.default)(this.activeSchoolYear.student_time_end).startOf('isoweek');
	        } else {
	          endDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_end).startOf('isoweek');
	        }
	      }
	      return endDate;
	    },
	    maxCalendarDate: function maxCalendarDate() {
	      var years = this.$store.state.activeSchoolYears;
	      if (!years || years.length === 0) {
	        return null;
	      }
	      return years.reduce(function (max, year) {
	        return year.employee_time_end > max ? year.employee_time_end : max;
	      }, years[0].employee_time_end);
	    },
	    isAtMaxWeek: function isAtMaxWeek() {
	      if (!this.maxCalendarDate) {
	        return false;
	      }
	      return (0, _moment2.default)(this.activeCalendarDate).isoWeekday(7).format('YYYY-MM-DD') >= this.maxCalendarDate;
	    }
	  },
	  watch: {
	    calendar: function calendar() {
	      if (this.calendar && this.calendar.view_state > -1) {
	        var state = this.calendar.view_state * 1;
	        if (state === 0) {
	          this.startTime = '06:00:00';
	          this.endTime = '18:00:00';
	          this.isShowWeekends = false;
	        } else if (state === 1) {
	          this.startTime = '06:00:00';
	          this.endTime = '18:00:00';
	          this.isShowWeekends = true;
	        } else {
	          this.startTime = '00:00:00';
	          this.endTime = '23:00:00';
	          this.isShowWeekends = true;
	        }
	      }
	    },
	    user: function user(val) {
	      if (val) {
	        this.readEvents();
	        this.readCalendar();
	      }
	    },
	    activeCalendarDate: function activeCalendarDate() {
	      this.readEvents();
	    },
	    theActiveCalendarId: function theActiveCalendarId(val) {
	      if (!val) {
	        return;
	      }
	      this.readEvents();
	      this.readCalendar();
	    }
	  },
	  methods: {
	    setTheView: function setTheView(view) {
	      var stripViewFromUrl = function stripViewFromUrl(url) {
	        var suffixes = ['?tasks', '?hours'];
	        var theUrl = url;
	        suffixes.forEach(function (suffix) {
	          var idx = theUrl.indexOf(suffix);
	          if (idx > 0) {
	            theUrl = theUrl.substr(0, idx);
	          }
	        });
	        return theUrl;
	      };
	      var baseUrl = stripViewFromUrl(window.location.href);
	      var theUrl = baseUrl;
	      if (view === 'tasks') {
	        theUrl = baseUrl + '?tasks';
	      } else if (view === 'hours') {
	        theUrl = baseUrl + '?hours';
	      }
	      if (theUrl !== window.location.href) {
	        window.location.href = theUrl;
	      }
	      this.theView = view;
	    },
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    readCalendar: function readCalendar() {
	      if (!this.user) {
	        return;
	      }
	      if (!this.theActiveCalendarId) {
	        this.$store.commit('setActiveCalendarId', this.user.user_calendar_id);
	      }
	      this.$store.dispatch('readCalendar', this.theActiveCalendarId);
	    },
	    presenceCall: function presenceCall(arrOfPresenceInWeek) {
	      var _this = this;
	
	      setTimeout(function (_) {
	        _this.readEvents();
	      }, 0);
	    },
	    readEvents: function readEvents() {
	      if (!this.user) {
	        return;
	      }
	      var calendarId = this.theActiveCalendarId ? this.theActiveCalendarId : this.user.user_calendar_id;
	      var obj = {
	        calIds: [calendarId],
	        start: (0, _moment2.default)(this.activeCalendarDate).isoWeekday(1).format('YYYY-MM-DD 00:00'),
	        end: (0, _moment2.default)(this.activeCalendarDate).isoWeekday(7).endOf('day')
	      };
	      this.$store.dispatch('readCalendarEvents', obj);
	    },
	    prevWeek: function prevWeek() {
	      var newDate = (0, _moment2.default)(this.activeCalendarDate).subtract(7, 'days');
	      this.setDate(newDate);
	    },
	    nextWeek: function nextWeek() {
	      if (this.isAtMaxWeek) return;
	      var newDate = (0, _moment2.default)(this.activeCalendarDate).add(7, 'days');
	      this.setDate(newDate);
	    },
	    today: function today() {
	      this.setDate((0, _moment2.default)());
	    },
	    setDate: function setDate(date) {
	      this.$store.commit('setActiveCalendarDate', date);
	      this.$helpers.setCookie('calendar_current_date', (0, _moment2.default)(date).format('YYYY-MM-DD'));
	    },
	    setActiveEvent: function setActiveEvent(event) {
	      this.$store.commit('setActiveCalendarEventId', event.obj.event_id);
	    },
	    closeShowEvent: function closeShowEvent() {
	      this.$store.commit('setActiveCalendarEventId', null);
	    },
	    findRoute: function findRoute() {
	      var queryString = window.location.href;
	      var calUrlIndex = window.location.href.indexOf('?cal=');
	      if (calUrlIndex > -1) {
	        var hashEnd = window.location.href.indexOf('#');
	        var calId = queryString.substr(calUrlIndex + 5, hashEnd);
	        this.$store.commit('setActiveCalendarId', calId);
	      }
	    },
	    readUsers: function readUsers() {
	      this.$store.dispatch('getUsers');
	    }
	  },
	  beforeMount: function beforeMount() {
	    var cookieDate = this.$helpers.getCookie('calendar_current_date');
	    if (cookieDate && (0, _moment2.default)(cookieDate).isValid()) {
	      this.$store.commit('setActiveCalendarDate', cookieDate);
	    }
	    var theDevice = this.$helpers.checkUserDevice();
	    if (theDevice === 'Mobile') {
	      this.$store.commit('setIsDeviceMobile', true);
	      document.querySelector('body').classList.add('device--is-mobile');
	    }
	  },
	  mounted: function mounted() {
	    this.readEvents();
	    this.readCalendar();
	    this.findRoute();
	    this.readUsers();
	    window.addEventListener('vueTeamCalendarChanged', this.readEvents);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('vueTeamCalendarChanged', this.readEvents);
	  }
	};

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DCalendar = __webpack_require__(53);
	
	var _DCalendar2 = _interopRequireDefault(_DCalendar);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _CalendarViewDayRemoveOrReplace = __webpack_require__(342);
	
	var _CalendarViewDayRemoveOrReplace2 = _interopRequireDefault(_CalendarViewDayRemoveOrReplace);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { CalendarViewDayRemoveOrReplace: _CalendarViewDayRemoveOrReplace2.default, DCalendar: _DCalendar2.default, DModal: _DModal2.default },
	  props: {
	    calendar: {
	      default: {
	        id: 7,
	        name: 'Henrik R.'
	      }
	    },
	    date: {
	      default: '2022-02-21'
	    },
	    event: {
	      default: null,
	      type: Object
	    },
	    calendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      events: [],
	      isEventsLoading: false
	    };
	  },
	
	  computed: {
	    isShowActions: function isShowActions() {
	      var calendarTypes = ['user', 'room', 'klass', 'student'];
	      return this.event && this.calendar && calendarTypes.indexOf(this.calendar.type) > -1;
	    },
	    eventStartFormatted: function eventStartFormatted() {
	      return (0, _moment2.default)(this.event.start).format('LL LT');
	    }
	  },
	  methods: {
	    readEvents: function readEvents() {
	      var _this = this;
	
	      this.isEventsLoading = true;
	      var obj = {
	        calIds: [this.calendar.id],
	        start: (0, _moment2.default)(this.date).startOf('day'),
	        end: (0, _moment2.default)(this.date).endOf('day')
	      };
	      _docendo2.default.calendarEvents2(obj.calIds, obj.start, obj.end, null, function (data) {
	        _this.isEventsLoading = false;
	        _this.events = data.length > 0 ? JSON.parse(data) : [];
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readEvents();
	  }
	};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    choose_end_date: 'Vælg slutdato',
	    cancel: 'Annuller',
	    apply_remove: 'Fjernes fra alle skemalagte brikker fremadrettet',
	    apply_add: 'Sættes på alle skemalagte brikker fremadrettet',
	    apply_replace: 'Erstattes på alle skemalagte brikker fremadrettet',
	    apply_remove_until: 'Fjernes fra alle skemalagte brikker frem til og med d. %{date}',
	    apply_add_until: 'Sættes på alle skemalagte brikker frem til og med d. %{date}',
	    apply_replace_until: 'Erstattes på alle skemalagte brikker frem til og med d. %{date}',
	    title_remove: 'Fjern fremadrettet',
	    title_add: 'Tilføj fremadrettet',
	    title_replace: 'Erstat fremadrettet',
	    confirm_remove: 'Fjern',
	    confirm_add: 'Tilføj',
	    confirm_replace: 'Erstat'
	  },
	  en: {
	    choose_end_date: 'Choose end date',
	    cancel: 'Cancel',
	    apply_remove: 'Removed from all scheduled lessons going forward',
	    apply_add: 'Added to all scheduled lessons going forward',
	    apply_replace: 'Replaced on all scheduled lessons going forward',
	    apply_remove_until: 'Removed from all scheduled lessons until and including %{date}',
	    apply_add_until: 'Added to all scheduled lessons until and including %{date}',
	    apply_replace_until: 'Replaced on all scheduled lessons until and including %{date}',
	    title_remove: 'Remove onwards',
	    title_add: 'Add onwards',
	    title_replace: 'Replace onwards',
	    confirm_remove: 'Remove',
	    confirm_add: 'Add',
	    confirm_replace: 'Replace'
	  },
	  nb: {
	    choose_end_date: 'Velg sluttdato',
	    cancel: 'Avbryt',
	    apply_remove: 'Fjernes fra alle timeplanlagte brikker fremover',
	    apply_add: 'Settes på alle timeplanlagte brikker fremover',
	    apply_replace: 'Erstattes på alle timeplanlagte brikker fremover',
	    apply_remove_until: 'Fjernes fra alle timeplanlagte brikker frem til og med %{date}',
	    apply_add_until: 'Settes på alle timeplanlagte brikker frem til og med %{date}',
	    apply_replace_until: 'Erstattes på alle timeplanlagte brikker frem til og med %{date}',
	    title_remove: 'Fjern fremover',
	    title_add: 'Legg til fremover',
	    title_replace: 'Erstatt fremover',
	    confirm_remove: 'Fjern',
	    confirm_add: 'Legg til',
	    confirm_replace: 'Erstatt'
	  }
	};
	
	exports.default = {
	  components: { ModalConfirmation: _ModalConfirmation2.default, AppToggle: _AppToggle2.default, DateSelector: _DateSelector2.default },
	  props: {
	    mode: {
	      type: String,
	      default: 'remove'
	    },
	    calendarName: {
	      type: String,
	      default: ''
	    },
	    minDate: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      hasEndDate: false,
	      enddate: null
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale] || I18N.da;
	    },
	    title: function title() {
	      return this.i18n['title_' + this.mode] || this.i18n.title_remove;
	    },
	    formattedEndDate: function formattedEndDate() {
	      if (!this.enddate) return '';
	      return (0, _moment2.default)(this.enddate).locale(this.locale).format('D. MMMM');
	    },
	    applyOnwardsText: function applyOnwardsText() {
	      if (this.hasEndDate && this.enddate) {
	        var template = this.i18n['apply_' + this.mode + '_until'] || this.i18n.apply_remove_until;
	        return template.replace('%{date}', this.formattedEndDate);
	      }
	      return this.i18n['apply_' + this.mode] || this.i18n.apply_remove;
	    },
	    confirmLabel: function confirmLabel() {
	      var action = this.i18n['confirm_' + this.mode] || this.i18n.confirm_remove;
	      return this.calendarName ? action + ' ' + this.calendarName : action;
	    }
	  },
	  methods: {
	    defaultEnddate: function defaultEnddate() {
	      return (0, _moment2.default)(this.minDate || undefined).format('YYYY-MM-DD');
	    },
	    toggleEndDate: function toggleEndDate() {
	      this.hasEndDate = !this.hasEndDate;
	      this.enddate = this.hasEndDate ? this.defaultEnddate() : null;
	    },
	    setEndDate: function setEndDate(date) {
	      this.enddate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	    },
	    onConfirm: function onConfirm() {
	      this.$emit('confirm', this.hasEndDate ? this.enddate : null);
	    }
	  }
	};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _CalendarViewDayOnwardConfirm = __webpack_require__(1462);
	
	var _CalendarViewDayOnwardConfirm2 = _interopRequireDefault(_CalendarViewDayOnwardConfirm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { CalendarViewDayOnwardConfirm: _CalendarViewDayOnwardConfirm2.default },
	  props: {
	    event: {
	      default: null
	    },
	    calendar: {
	      default: {
	        id: 7,
	        name: 'Henrik R.'
	      }
	    },
	    calendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isPossibleToAdd: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      theShowAction: null,
	      theReplaceWithCalendarId: null,
	      onwardConfirmMode: null
	    };
	  },
	
	  computed: {
	    selectableCalendars: function selectableCalendars() {
	      var _this = this;
	
	      return this.calendars.filter(function (cal) {
	        return cal.id !== _this.calendar.id;
	      });
	    },
	    eventStartDate: function eventStartDate() {
	      if (!this.event || !this.event.start) return (0, _moment2.default)().format('YYYY-MM-DD');
	      return (0, _moment2.default)(this.event.start).format('YYYY-MM-DD');
	    },
	    eventStartFormatted: function eventStartFormatted() {
	      if (!this.event || !this.event.start) return '';
	      return (0, _moment2.default)(this.event.start).format('LL LT');
	    }
	  },
	  methods: {
	    start: function start(el) {
	      el.style.height = el.scrollHeight + 'px';
	    },
	    end: function end(el) {
	      el.style.height = '';
	    },
	    setTheShowAction: function setTheShowAction(action) {
	      if (this.theShowAction === action) {
	        this.theShowAction = null;
	      } else {
	        this.theShowAction = action;
	      }
	    },
	    getTheShowAction: function getTheShowAction(action) {
	      return this.theShowAction === action;
	    },
	    openOnwardConfirm: function openOnwardConfirm(mode) {
	      this.onwardConfirmMode = mode;
	    },
	    onOnwardConfirm: function onOnwardConfirm(enddate) {
	      var mode = this.onwardConfirmMode;
	      this.onwardConfirmMode = null;
	      if (mode === 'remove') this.removeOnward(enddate);
	      if (mode === 'add') this.addOnward(enddate);
	      if (mode === 'replace') this.replaceOnward(enddate);
	    },
	    removeOnward: function removeOnward(enddate) {
	      var _this2 = this;
	
	      _docendo2.default.eventRemoveCalendar(this.event.school_id, this.event.event_id, this.calendar.id, enddate || null, function (success) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.substitution.lessons_updated'), 'success': true };
	        _this2.$emit('updateAndClose');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Sorry, that failed', 'success': false };
	        console.log('failure', failure);
	      });
	    },
	    addOnward: function addOnward(enddate) {
	      var _this3 = this;
	
	      _docendo2.default.eventAddCalendar(this.event.school_id, this.event.event_id, this.calendar.id, enddate || null, function (success) {
	        _eventbus2.default.toast = { text: _this3.$t('vue2.substitution.lessons_updated'), 'success': true };
	        _this3.$emit('updateAndClose');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Sorry, that failed', 'success': false };
	        console.log('failure', failure);
	      });
	    },
	    replaceOnward: function replaceOnward(enddate) {
	      var _this4 = this;
	
	      _docendo2.default.eventReplaceCalendar(this.event.school_id, this.event.event_id, this.calendar.id, this.theReplaceWithCalendarId, enddate || null, function (success) {
	        _eventbus2.default.toast = { text: _this4.$t('vue2.substitution.lessons_updated'), 'success': true };
	        _this4.$emit('updateAndClose');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Sorry, that failed', 'success': false };
	        console.log('failure', failure);
	      });
	    }
	  }
	};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CopyMultipleCalendars = __webpack_require__(1469);
	
	var _CopyMultipleCalendars2 = _interopRequireDefault(_CopyMultipleCalendars);
	
	var _CalendarsBulkArchiveCalendar = __webpack_require__(1464);
	
	var _CalendarsBulkArchiveCalendar2 = _interopRequireDefault(_CalendarsBulkArchiveCalendar);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Print = __webpack_require__(98);
	
	var _Print2 = _interopRequireDefault(_Print);
	
	var _PresenceForUsers = __webpack_require__(1526);
	
	var _PresenceForUsers2 = _interopRequireDefault(_PresenceForUsers);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _CalendarsDeleteEventsInDays = __webpack_require__(1465);
	
	var _CalendarsDeleteEventsInDays2 = _interopRequireDefault(_CalendarsDeleteEventsInDays);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CalendarsDeleteEventsInDays: _CalendarsDeleteEventsInDays2.default,
	    Datepickerrange: _DatePickerRange2.default,
	    PresenceForUsers: _PresenceForUsers2.default, Print: _Print2.default, CopyMultipleCalendars: _CopyMultipleCalendars2.default, CalendarsBulkArchiveCalendar: _CalendarsBulkArchiveCalendar2.default, ChangeSchoolYear: _ChangeSchoolYear2.default
	  },
	  data: function data() {
	    return {
	      selectedView: 'crudCalendars',
	      fromDate: (0, _moment2.default)(),
	      toDate: (0, _moment2.default)()
	    };
	  },
	
	  computed: {
	    klassCalendars: function klassCalendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    kindergartenCalendars: function kindergartenCalendars() {
	      return this.$store.getters.kindergartenCalendars;
	    },
	    userCalendars: function userCalendars() {
	      return this.$store.getters.userCalendars;
	    },
	    roomCalendarsInclArchived: function roomCalendarsInclArchived() {
	      return this.$store.getters.roomCalendarsInclArchived;
	    },
	    mergeCalendarsInclArchived: function mergeCalendarsInclArchived() {
	      return this.$store.getters.mergeCalendarsInclArchived;
	    },
	    otherCalendars: function otherCalendars() {
	      return this.$store.getters.otherCalendars;
	    },
	    isSchoolDanish: function isSchoolDanish() {
	      return window.SCHOOL.country.toLowerCase() === 'dk';
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    userHasPermissionToEditOthersPresence: function userHasPermissionToEditOthersPresence() {
	      return this.userHasPermission('can_edit_others_presence');
	    }
	  },
	  methods: {
	    setFromDate: function setFromDate(date) {
	      this.setDates(date, null);
	    },
	    setToDate: function setToDate(date) {
	      this.setDates(null, date);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.fromDate = start;
	      }
	      if (end) {
	        this.toDate = end;
	      }
	    },
	    userHasPermission: function userHasPermission(val) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(val) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    setSelectedView: function setSelectedView(val) {
	      var _this = this;
	
	      if (val === 'printCalendars') {
	        this.selectedView = 'printCalendars';
	        setTimeout(function (_) {
	          _this.setIsPrintCalendarsModal();
	        }, 0);
	      }
	    },
	    setIsPrintCalendarsModal: function setIsPrintCalendarsModal() {
	      _eventbus2.default.isPrintCalendarsModal = true;
	    }
	  }
	};

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    isOpen: {
	      type: Boolean,
	      default: false
	    },
	    calType: {
	      type: String,
	      default: 'klass'
	    },
	    calendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isAccOpen: false,
	      isArchivedAccOpen: false,
	      theActiveCalId: null,
	      theUpdateCalName: '',
	      theDeleteCalId: null,
	      theDeleteCalName: ''
	    };
	  },
	
	  computed: {
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    calendarsExclArchived: function calendarsExclArchived() {
	      return this.calendars.filter(function (calendar) {
	        return !calendar.archived_at;
	      });
	    },
	    archivedCalendars: function archivedCalendars() {
	      return this.calendars.filter(function (calendar) {
	        return calendar.archived_at;
	      });
	    },
	    deleteCalName: function deleteCalName() {
	      return this.theDeleteCalId ? this.allCalendarsInHash[this.theDeleteCalId].name : '';
	    },
	    isDeleteCalValidated: function isDeleteCalValidated() {
	      return this.theDeleteCalName.length > 0 && this.theDeleteCalName === this.deleteCalName;
	    },
	    title: function title() {
	      switch (this.calType) {
	        case 'klass':
	          return this.$t('vue2.common.classes');
	        case 'user':
	          return this.$t('vue2.common.users');
	        case 'room':
	          return this.$t('vue2.common.rooms');
	        case 'merge':
	          return this.$t('vue2.common.merge_calendars');
	        case 'other':
	          return this.$t('vue2.common.other_calendars');
	      }
	    }
	  },
	  methods: {
	    getIsInselectedCalIds: function getIsInselectedCalIds(calId) {
	      return this.selectedCalIds.indexOf(calId) > -1;
	    },
	    toogleCal: function toogleCal(calId) {
	      var idx = this.selectedCalIds.indexOf(calId);
	      if (idx < 0) {
	        this.selectedCalIds.push(calId);
	      } else {
	        this.selectedCalIds.splice(idx, 1);
	      }
	    },
	    toggleAllKlasses: function toggleAllKlasses() {
	      var _this = this;
	
	      if (this.selectedCalIds.length > 0) {
	        this.selectedCalIds = [];
	      } else {
	        this.selectedCalIds = [];
	        this.calendars.forEach(function (calendar) {
	          return _this.selectedCalIds.push(calendar.id);
	        });
	      }
	    },
	    toggleIsAccOpen: function toggleIsAccOpen() {
	      if (!this.isAccOpen) {
	        this.isAccOpen = true;
	      } else {
	        this.isAccOpen = false;
	        this.selectedCalIds = [];
	      }
	    },
	    archiveCal: function archiveCal(calId) {
	      var calObj = {
	        calendarId: calId,
	        changes: { name: this.allCalendarsInHash[calId].name, archived: true }
	      };
	      this.$store.dispatch('updateCalendar', calObj);
	    },
	    deArchiveCal: function deArchiveCal(calId) {
	      var calObj = {
	        calendarId: calId,
	        changes: { name: this.allCalendarsInHash[calId].name, archived: false }
	      };
	      this.$store.dispatch('updateCalendar', calObj);
	    },
	    setEditCal: function setEditCal(calId) {
	      var _this2 = this;
	
	      this.theUpdateCalName = this.allCalendarsInHash[calId].name;
	      this.theActiveCalId = calId;
	      setTimeout(function (_) {
	        _this2.$refs.edit_name_input.focus();
	      }, 500);
	    },
	    closeUpdateCalName: function closeUpdateCalName() {
	      this.theUpdateCalName = '';
	      this.theActiveCalId = null;
	    },
	    updateCalName: function updateCalName() {
	      var archived = this.allCalendarsInHash[this.theActiveCalId].archived_at;
	      var calObj = {
	        calendarId: this.theActiveCalId,
	        changes: { name: this.theUpdateCalName, archived: archived }
	      };
	      this.$store.dispatch('updateCalendar', calObj);
	      this.closeUpdateCalName();
	    },
	    setDeleteCal: function setDeleteCal(calId) {
	      var _this3 = this;
	
	      this.theDeleteCalId = calId;
	      setTimeout(function (_) {
	        _this3.$refs.delete_name_input.focus();
	      }, 500);
	    },
	    closeDeleteCalModal: function closeDeleteCalModal() {
	      this.theDeleteCalId = null;
	      this.theDeleteCalName = '';
	    },
	    deleteCal: function deleteCal() {
	      this.$store.dispatch('deleteCalendar', this.theDeleteCalId);
	      this.closeDeleteCalModal();
	    }
	  },
	  mounted: function mounted() {
	    if (this.isOpen) {
	      this.isAccOpen = true;
	    }
	  }
	};

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, Datepickerrange: _DatePickerRange2.default },
	  props: {
	    isOpen: {
	      type: Boolean,
	      default: false
	    },
	    calType: {
	      type: String,
	      default: 'klass'
	    },
	    calendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    toDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    fromDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      copyCalType: null,
	      selectedCalIds: [],
	      isDeleteEvents: true,
	      isAccOpen: false,
	      isArchivedAccOpen: false,
	      isDeleting: false
	    };
	  },
	
	  computed: {
	    fromDateAndToDate: function fromDateAndToDate() {
	      return (0, _moment2.default)(this.fromDate).format('L') + ' to ' + (0, _moment2.default)(this.toDate).format('L');
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    calendarsExclArchived: function calendarsExclArchived() {
	      return this.calendars.filter(function (calendar) {
	        return !calendar.archived_at;
	      });
	    },
	    archivedCalendars: function archivedCalendars() {
	      return this.calendars.filter(function (calendar) {
	        return calendar.archived_at;
	      });
	    },
	    title: function title() {
	      switch (this.calType) {
	        case 'klass':
	          return this.$t('vue2.common.classes');
	        case 'user':
	          return this.$t('vue2.common.users');
	        case 'room':
	          return this.$t('vue2.common.rooms');
	        case 'merge':
	          return this.$t('vue2.common.merge_calendars');
	        case 'other':
	          return this.$t('vue2.common.other_calendars');
	        default:
	          return this.calType;
	      }
	    }
	  },
	  methods: {
	    getIsInSelectedCalIds: function getIsInSelectedCalIds(calId) {
	      return this.selectedCalIds.indexOf(calId) > -1;
	    },
	    toogleCal: function toogleCal(calId) {
	      var idx = this.selectedCalIds.indexOf(calId);
	      if (idx < 0) {
	        this.selectedCalIds.push(calId);
	      } else {
	        this.selectedCalIds.splice(idx, 1);
	      }
	    },
	    toggleAllKlasses: function toggleAllKlasses() {
	      var _this = this;
	
	      if (this.selectedCalIds.length > 0) {
	        this.selectedCalIds = [];
	      } else {
	        this.selectedCalIds = [];
	        this.calendars.forEach(function (calendar) {
	          return _this.selectedCalIds.push(calendar.id);
	        });
	      }
	    },
	    deleteDays: function deleteDays() {
	      var _this2 = this;
	
	      this.isDeleting = true;
	      var from = (0, _moment2.default)(this.fromDate).startOf('day');
	      var to = (0, _moment2.default)(this.toDate).endOf('day');
	      var index = 0;
	      var cals = JSON.parse((0, _stringify2.default)(this.selectedCalIds));
	      var dInterval = setInterval(function (_) {
	        var calId = cals[index];
	        if (!calId) {
	          clearInterval(dInterval);
	          _this2.isDeleting = false;
	        }
	        var idx = _this2.selectedCalIds.indexOf(calId);
	        _this2.selectedCalIds.splice(idx, 1);
	        index++;
	        if (calId) {
	          var calName = _this2.allCalendarsInHash[calId] ? _this2.allCalendarsInHash[calId].name : '';
	          _docendo2.default.deleteEventsRange(calId, from, to, function (success) {
	            _eventbus2.default.toast = { text: 'Deleted days in ' + calName, success: true };
	          }, function (failure) {
	            _eventbus2.default.toast = { text: 'Something went wrong!', success: false };
	            console.log('failed', failure);
	          });
	        }
	      }, 1000);
	    },
	    toggleIsAccOpen: function toggleIsAccOpen() {
	      if (!this.isAccOpen) {
	        this.isAccOpen = true;
	      } else {
	        this.isAccOpen = false;
	        this.selectedCalIds = [];
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.isOpen) {
	      this.isAccOpen = true;
	    }
	  }
	};

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _PresenceUser = __webpack_require__(82);
	
	var _PresenceUser2 = _interopRequireDefault(_PresenceUser);
	
	var _Spinner = __webpack_require__(26);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _ExportCalendar = __webpack_require__(97);
	
	var _ExportCalendar2 = _interopRequireDefault(_ExportCalendar);
	
	var _DWeekplan = __webpack_require__(406);
	
	var _DWeekplan2 = _interopRequireDefault(_DWeekplan);
	
	var _WeekSelecter = __webpack_require__(106);
	
	var _WeekSelecter2 = _interopRequireDefault(_WeekSelecter);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DCalendarShowEvent = __webpack_require__(81);
	
	var _DCalendarShowEvent2 = _interopRequireDefault(_DCalendarShowEvent);
	
	var _DCalendar = __webpack_require__(53);
	
	var _DCalendar2 = _interopRequireDefault(_DCalendar);
	
	var _UserTasks = __webpack_require__(54);
	
	var _UserTasks2 = _interopRequireDefault(_UserTasks);
	
	var _SelectCalendar = __webpack_require__(415);
	
	var _SelectCalendar2 = _interopRequireDefault(_SelectCalendar);
	
	var _CopyCalendarRotate = __webpack_require__(346);
	
	var _CopyCalendarRotate2 = _interopRequireDefault(_CopyCalendarRotate);
	
	var _DCalendarHeader = __webpack_require__(347);
	
	var _DCalendarHeader2 = _interopRequireDefault(_DCalendarHeader);
	
	var _DeleteDayOrWeek = __webpack_require__(352);
	
	var _DeleteDayOrWeek2 = _interopRequireDefault(_DeleteDayOrWeek);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DeleteDayOrWeek: _DeleteDayOrWeek2.default,
	    DCalendarHeader: _DCalendarHeader2.default,
	    CopyCalendarRotate: _CopyCalendarRotate2.default,
	    DCalendarShowEvent: _DCalendarShowEvent2.default,
	    SelectCalendar: _SelectCalendar2.default,
	    UserTasks: _UserTasks2.default,
	    DWeekplan: _DWeekplan2.default,
	    DCalendar: _DCalendar2.default,
	    Loader: _Loader2.default,
	    Spinner: _Spinner2.default,
	    UserPresence: _PresenceUser2.default,
	    ExportCalendar: _ExportCalendar2.default,
	    weekSelector: _WeekSelecter2.default
	  },
	  props: {
	    calendarId: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isShowWeekends: false,
	      presetStartTime: '06:00:00',
	      presetEndTime: '16:00:00',
	      isInPrintMode: false,
	      isCalendarInPrintMode: false,
	      calendarDates: [],
	      isDragging: false,
	      debounceTimer: null,
	      clickCount: 0,
	      clickCountTimer: null,
	      isLockedFromFrontend: false,
	      isCopyCalendarModalOpen: false,
	      showGrid: false
	    };
	  },
	
	  computed: {
	    user: function user() {
	      return this.$store.state.user;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    isDeviceMobile: function isDeviceMobile() {
	      return this.$store.state.isDeviceMobile;
	    },
	    theActiveCalendarId: function theActiveCalendarId() {
	      return this.calendarId ? this.calendarId : this.$route.params.calendar_id;
	    },
	    isUsersCalendar: function isUsersCalendar() {
	      return this.theActiveCalendarId === this.user.user_calendar_id;
	    },
	    calendar: function calendar() {
	      return this.$store.getters.activeCalendar;
	    },
	    firstDayOfWeek: function firstDayOfWeek() {
	      return this.$store.getters.firstDayOfWeek;
	    },
	    isLocked: function isLocked() {
	      return this.calendar && this.calendar.locked;
	    },
	    calendarName: function calendarName() {
	      return this.calendar ? this.calendar.name : '';
	    },
	    isEditable: function isEditable() {
	      return !this.isLockedFromFrontend;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    isShowWeekPlan: function isShowWeekPlan() {
	      return this.calendar && this.calendar.type === 'klass' || this.calendar && this.calendar.type === 'user' || this.calendar && this.calendar.type === 'other';
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    events: function events() {
	      return this.$store.state.calendar.events;
	    },
	    availabilityEvents: function availabilityEvents() {
	      return this.$store.state.calendar.availabilityEvents;
	    },
	    dCalendarEvents: function dCalendarEvents() {
	      if (this.isDragging) {
	        return this.events.concat(this.availabilityEvents);
	      } else {
	        return this.events;
	      }
	    },
	    startTime: function startTime() {
	      return this.expandedTimeRange.startTime;
	    },
	    endTime: function endTime() {
	      return this.expandedTimeRange.endTime;
	    },
	    expandedTimeRange: function expandedTimeRange() {
	      return this.$helpers.expandTimeRangeForEvents(this.presetStartTime, this.presetEndTime, this.events);
	    },
	    isEventsLoading: function isEventsLoading() {
	      return this.$store.state.calendar.isEventsLoading;
	    },
	    activeCalendarDate: function activeCalendarDate() {
	      return (0, _moment2.default)(this.$store.state.calendar.date).format('YYYY-MM-DD');
	    },
	    activeEvent: function activeEvent() {
	      return this.$store.getters.activeCalendarEvent;
	    },
	    iCalUrl: function iCalUrl() {
	      if (this.calendar && this.calendar.ical_url) {
	        return window.location.origin + this.calendar.ical_url;
	      } else if (this.calendar && this.calendar.ical_link) {
	        return window.location.origin + this.calendar.ical_link;
	      } else {
	        return 'loading';
	      }
	    },
	    isNotThisWeek: function isNotThisWeek() {
	      return (0, _moment2.default)(this.$store.state.calendar.date).isoWeek() === (0, _moment2.default)().isoWeek();
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    weekSelectorStartDate: function weekSelectorStartDate() {
	      var calType = this.calendar ? this.calendar.type : 'klass';
	      if (this.activeSchoolYear) {
	        if (calType === 'klass') {
	          return (0, _moment2.default)(this.activeSchoolYear.student_time_start).startOf('isoweek');
	        } else {
	          return (0, _moment2.default)(this.activeSchoolYear.employee_time_start).startOf('isoweek');
	        }
	      }
	    },
	    weekSelectorEndDate: function weekSelectorEndDate() {
	      var endDate = this.calendar && this.calendar.end_date ? this.calendar && this.calendar.end_date : (0, _moment2.default)().startOf('isoweek');
	      var calType = this.calendar ? this.calendar.type : 'klass';
	      if (this.activeSchoolYear) {
	        if (calType === 'klass') {
	          endDate = (0, _moment2.default)(this.activeSchoolYear.student_time_end).startOf('isoweek');
	        } else {
	          endDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_end).startOf('isoweek');
	        }
	      }
	      return endDate;
	    },
	    schoolFeatures: function schoolFeatures() {
	      return this.$store.getters.schoolFeatures;
	    },
	    isSalaySystemAbsenceActivated: function isSalaySystemAbsenceActivated() {
	      return this.schoolFeatures.indexOf('kmd_absence') > -1;
	    },
	    getIsAbsenceEditable: function getIsAbsenceEditable() {
	      if (this.isSalaySystemAbsenceActivated) {
	        return false;
	      }
	      var schoolIdsWithoutDeleteFnc = [29045];
	      return schoolIdsWithoutDeleteFnc.includes(this.schoolId) ? this.userHasPermission('can_manage_users') : true;
	    },
	    maxCalendarDate: function maxCalendarDate() {
	      var years = this.$store.state.activeSchoolYears;
	      if (!years || years.length === 0) {
	        return null;
	      }
	      return years.reduce(function (max, year) {
	        return year.employee_time_end > max ? year.employee_time_end : max;
	      }, years[0].employee_time_end);
	    },
	    isAtMaxWeek: function isAtMaxWeek() {
	      if (!this.maxCalendarDate || !this.activeCalendarDate) {
	        return false;
	      }
	      if (this.user && this.user.admin) {
	        return false;
	      }
	      return (0, _moment2.default)(this.activeCalendarDate).isoWeekday(7).format('YYYY-MM-DD') >= this.maxCalendarDate;
	    }
	  },
	  watch: {
	    calendar: function calendar() {
	      if (this.calendar && this.calendar.view_state > -1) {
	        var state = this.calendar.view_state * 1;
	        if (state === 0) {
	          this.presetStartTime = '06:00:00';
	          this.presetEndTime = '18:00:00';
	          this.isShowWeekends = false;
	        } else if (state === 1) {
	          this.presetStartTime = '06:00:00';
	          this.presetEndTime = '18:00:00';
	          this.isShowWeekends = true;
	        } else {
	          this.presetStartTime = '00:00:00';
	          this.presetEndTime = '23:00:00';
	          this.isShowWeekends = true;
	        }
	      }
	    },
	    activeCalendarDate: function activeCalendarDate(val, oldVal) {
	      this.$store.commit('clearSelectedEventIds');
	      this.readEvents(true);
	    },
	    theActiveCalendarId: function theActiveCalendarId() {
	      this.$store.commit('clearSelectedEventIds');
	    }
	  },
	  methods: {
	    setIsCopyCalendarModalOpen: function setIsCopyCalendarModalOpen(bool) {
	      this.isCopyCalendarModalOpen = bool;
	    },
	    setCalendarDates: function setCalendarDates(days) {
	      this.calendarDates = days;
	    },
	    setTheView: function setTheView(view) {
	      var hasTasksInUrl = window.location.href.indexOf('?tasks') > 0;
	      if (view === 'tasks' && !hasTasksInUrl) {
	        window.location.href = window.location.href + '?tasks';
	      }
	      if (view === 'calendar' && hasTasksInUrl) {
	        window.location.href = window.location.href.substr(0, window.location.href.indexOf('?tasks'));
	      }
	      this.theView = view;
	    },
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    readCalendar: function readCalendar() {
	      this.$store.dispatch('readCalendar', this.theActiveCalendarId);
	    },
	    presenceCall: function presenceCall(arrOfPresenceInWeek) {
	      var _this = this;
	
	      setTimeout(function (_) {
	        _this.readEvents();
	      }, 0);
	    },
	    debounce: function debounce(func, delay) {
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(func, delay);
	    },
	    onTeamCalendarChanged: function onTeamCalendarChanged() {
	      this.readEvents(true);
	    },
	    readEvents: function readEvents(andReadSubjects) {
	      var _this2 = this;
	
	      var firstDay = this.firstDayOfWeek;
	      var lastDay = this.firstDayOfWeek + 6;
	      this.clickCount++;
	      var obj = {
	        calIds: [this.calendarId],
	        start: (0, _moment2.default)(this.activeCalendarDate).isoWeekday(firstDay).format('YYYY-MM-DD 00:00'),
	        end: (0, _moment2.default)(this.activeCalendarDate).isoWeekday(lastDay).endOf('day')
	      };
	      if (andReadSubjects) {
	        obj['andReadSubjects'] = true;
	      }
	      if (this.clickCount === 2) {
	        clearTimeout(this.clickCountTimer);
	      }
	      if (this.clickCount === 1) {
	        this.$store.dispatch('readCalendarEvents', obj);
	        this.clickCountTimer = setTimeout(function () {
	          _this2.clickCount = 0;
	        }, 300);
	      } else {
	        this.debounce(function () {
	          _this2.$store.dispatch('readCalendarEvents', obj);
	          _this2.clickCount = 0;
	        }, 300);
	      }
	    },
	    prevWeek: function prevWeek() {
	      var newDate = (0, _moment2.default)(this.activeCalendarDate).subtract(7, 'days');
	      this.setDate(newDate);
	    },
	    nextWeek: function nextWeek() {
	      if (this.isAtMaxWeek) return;
	      var newDate = (0, _moment2.default)(this.activeCalendarDate).add(7, 'days');
	      this.setDate(newDate);
	    },
	    today: function today() {
	      this.setDate((0, _moment2.default)());
	    },
	    setDate: function setDate(date) {
	      this.$store.commit('setActiveCalendarDate', date);
	      this.$helpers.setCookie('do_calendar_current_date', (0, _moment2.default)(date).format('YYYY-MM-DD'));
	    },
	    print: function print() {
	      var _this3 = this;
	
	      this.isCalendarInPrintMode = true;
	      setTimeout(function (_) {
	        _this3.isInPrintMode = true;
	        _this3.$nextTick(function (_) {
	          var prtHtml = document.getElementById('printCalendar').innerHTML;
	
	          var stylesHtml = '';
	
	          var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')));
	
	          for (var _i = 0; _i < _arr.length; _i++) {
	            var node = _arr[_i];
	            stylesHtml += node.outerHTML;
	          }
	
	          var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	
	          WinPrint.document.write('<!DOCTYPE html><html><head>' + stylesHtml + '</head><body>' + prtHtml + '</body></html>');
	          var afterPrint = function afterPrint() {
	            WinPrint.close();
	            _this3.isInPrintMode = false;
	            _this3.isCalendarInPrintMode = false;
	          };
	          WinPrint.onafterprint = afterPrint;
	          setTimeout(function (_) {
	            WinPrint.document.close();
	            WinPrint.focus();
	            WinPrint.print();
	          }, 1000);
	        }, 500);
	      });
	    },
	    setActiveEvent: function setActiveEvent(event) {
	      this.$store.commit('setActiveCalendarEventId', event.obj.event_id);
	    },
	    closeShowEvent: function closeShowEvent() {
	      this.$store.commit('setActiveCalendarEventId', null);
	    },
	    handleKeyDown: function handleKeyDown(evt) {
	      if (evt.key === 'Meta' || evt.key === 'Control') {
	        if (!evt.shiftKey && !evt.altKey) {
	          this.$store.commit('setCmdKeyDown', true);
	        }
	      } else if (this.$store.state.calendar.isCmdKeyDown) {
	        this.$store.commit('setCmdKeyDown', false);
	      }
	      var target = evt.target;
	      if (target && (target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName))) {
	        return;
	      }
	      if (evt.key === 'ArrowLeft' && (evt.ctrlKey || evt.metaKey)) {
	        evt.preventDefault();
	        this.prevWeek();
	        return;
	      }
	      if (evt.key === 'ArrowRight' && (evt.ctrlKey || evt.metaKey)) {
	        evt.preventDefault();
	        this.nextWeek();
	        return;
	      }
	    },
	    handleKeyUp: function handleKeyUp(evt) {
	      if (evt.key === 'Meta' || evt.key === 'Control') {
	        this.$store.commit('setCmdKeyDown', false);
	      }
	    },
	    handleWindowBlur: function handleWindowBlur() {
	      this.$store.commit('setCmdKeyDown', false);
	    },
	    setIsDragging: function setIsDragging(bool) {
	      this.isDragging = bool;
	    },
	    setIsLockedFromFrontend: function setIsLockedFromFrontend() {
	      this.isLockedFromFrontend = !this.isLockedFromFrontend;
	      this.readEvents();
	    },
	    toggleGrid: function toggleGrid() {
	      this.showGrid = !this.showGrid;
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.commit('setActiveCalendarId', this.calendarId);
	    this.readCalendar();
	    var cookieDate = this.$helpers.getCookie('do_calendar_current_date');
	    if (cookieDate && (0, _moment2.default)(cookieDate).isValid()) {
	      this.$store.commit('setActiveCalendarDate', cookieDate);
	      if ((0, _moment2.default)(cookieDate).format('YYYY-MM-DD') === (0, _moment2.default)(this.date).format('YYYY-MM-DD')) {
	        this.readEvents();
	      }
	    } else {
	      this.$store.commit('setActiveCalendarDate', (0, _moment2.default)().format('YYYY-MM-DD'));
	      this.readEvents();
	    }
	    var theDevice = this.$helpers.checkUserDevice();
	    if (theDevice === 'Mobile') {
	      this.isLockedFromFrontend = true;
	      this.$store.commit('setIsDeviceMobile', true);
	      document.querySelector('body').classList.add('device--is-mobile');
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('analyticsOnVisitedCalendar');
	  },
	  created: function created() {
	    document.removeEventListener('keydown', this.handleKeyDown);
	    document.addEventListener('keydown', this.handleKeyDown);
	    document.addEventListener('keyup', this.handleKeyUp);
	    window.addEventListener('blur', this.handleWindowBlur);
	    window.addEventListener('vueTeamCalendarChanged', this.onTeamCalendarChanged);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this.handleKeyDown);
	    document.removeEventListener('keyup', this.handleKeyUp);
	    window.removeEventListener('blur', this.handleWindowBlur);
	    window.removeEventListener('vueTeamCalendarChanged', this.onTeamCalendarChanged);
	    this.$store.commit('setCmdKeyDown', false);
	    this.$store.commit('clearSelectedEventIds');
	  }
	};

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _CalendarOnMobileGuides = __webpack_require__(1516);
	
	var _CalendarOnMobileGuides2 = _interopRequireDefault(_CalendarOnMobileGuides);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    external_view: 'Ekstern visning',
	    calendars: 'Kalendere',
	    absent_today: 'Dagens fraværende',
	    show_absent_today: 'Vis dagens fraværende på infoskærm',
	    show_absent_today_desc: 'Ønsker I at vise information om dagens fraværende på infoskærm, kan nedenstående link bruges til opsætningen.',
	    activate_view: 'Aktiver visningen',
	    show_selected_schedules: 'Vis udvalgte skemaer',
	    show_selected_schedules_desc: 'For at vise skemaer til elever og forældre kan I linke til skemaerne direkte fra jeres hjemmeside med dette link',
	    show_selected_schedules_desc_with_students: 'For at vise skemaer til klasser, elever og forældre kan du dele nedenstående link på skolens hjemmeside eller lignende. Individuelle elevskemaer vil ikke blive delt via dette fælles link, men kan deles via sit eget unikke link, som kan findes ved at klikke på klassen i listen nedenfor.',
	    selected_the_schedules: 'Vælg hvilke kalendere som skal være synlige på hjemmesiden og via direkte link',
	    selected_the_schedules_with_students: 'Vælg hvilke skemaer for klasser og lokaler, der skal være synlige via linket ovenfor, og hvilke skemaer for elever der kan deles via et unikt direkte link.',
	    visible_via_link: 'Synlig via link',
	    visible_via_link_tooltip: 'Et unikt link til kalenderen, som f.eks. elever og forældre kan tilgå uden at skulle logge ind i Docendo. Klik for at se guide for mobil.',
	    schedules_on_desktop_mobile: 'Skema på desktop, iPad, Mobil',
	    schedules_on_desktop_mobile_tooltip: 'Lektioner i kalenderen vil kun være synlige til og med denne dato. Hvis der ikke er sat en dato, vil alle lektioner blive vist.',
	    show_schedules_until: 'Vis skemaer til og med',
	    integrations_with_google: 'Integration med Apple Calendar, Google mfl. Klik for at se guide',
	    grades: 'Klasser',
	    grade: 'Klasse',
	    unselect: 'Fravælg',
	    select: 'Vælg',
	    all: 'Alle',
	    no_grades_created: 'Der er ikke oprettet nogen klasser',
	    copy_calendar_link: 'Kopier kalenderlink',
	    copied: 'Kopieret',
	    no_end_date: 'Ingen slutdato. Alt vises.',
	    set_a_date: 'Sæt en slutdato',
	    remove_end_date: 'Fjern slutdato',
	    copy_ical_link: 'Kopier iCal-link',
	    room: 'Lokale',
	    rooms: 'Lokaler',
	    no_rooms_created: 'Der er ikke oprettet nogen lokaler',
	    access_schedule_without_login: 'Skal kalenderen kunne tilgås via et unikt link uden login?',
	    student: 'elev',
	    students: 'elever',
	    user: 'bruger',
	    users: 'brugere',
	    no_users_created: 'Der er ikke oprettet nogen brugere',
	    other: 'Andre kalendere',
	    no_other_created: 'Der er ikke oprettet nogen andre kalendere',
	    club: 'SFO',
	    no_club_created: 'Der er ikke oprettet nogen SFO kalendere',
	    merge_calendars: 'Fletteskemaer',
	    merge_calendar: 'Fletteskema',
	    no_merge_created: 'Der er ikke oprettet nogen flettekalendere',
	    use_update_in_url: 'Hvis du ønsker, at de offentlige skemaer automatisk skal hente lektioner hvert 5. minut, skal du tilføje ?update i slutningen af den offentlige URL-adresse.'
	  },
	  en: {
	    external_view: 'External view',
	    calendars: 'Calendars',
	    absent_today: 'Todays absent teachers',
	    show_absent_today: 'Show todays absent teachers',
	    show_absent_today_desc: 'Use link below to display information about absent teachers on info screen.',
	    activate_view: 'Activate the view',
	    show_selected_schedules: 'Display selected calendars',
	    show_selected_schedules_desc: 'To show calendars to students and parents, you can link to the calendars directly from your website with this link',
	    show_selected_schedules_desc_with_students: 'To show schedules to students and parents, you can share the link below on the school\'s website or similar. Individual student schedules will not be shared via this common link, but can be shared via their own unique link, which can be found by clicking on the grade/group in the list below.',
	    selected_the_schedules: 'Choose which calendars should be visible on the website and via direct public link',
	    selected_the_schedules_with_students: 'Choose which schedules for grades/groups and rooms are to be visible via the link above, and which student schedules can be shared via a unique direct link.',
	    visible_via_link: 'Visible via link',
	    visible_via_link_tooltip: 'A unique link to the calendar, such as students and parents can access without having to log in to Docendo. Click to view mobile guide.',
	    schedules_on_desktop_mobile: 'Schedules on desktop, iPad, mobile',
	    schedules_on_desktop_mobile_tooltip: 'Lessons in the calendar will only be visible up to and including this date. If no date is set, all lessons will be displayed.',
	    show_schedules_until: 'Show schedules until',
	    integrations_with_google: 'Integration with Apple Calendar, Google, etc. Click to view guide',
	    grades: 'Grades/groups',
	    grade: 'Grade/group',
	    unselect: 'Deselect',
	    select: 'Select',
	    all: 'All',
	    no_grades_created: 'No grades/groups created',
	    copy_calendar_link: 'Copy calendar link',
	    copied: 'Copied',
	    no_end_date: 'No end date. All lesson will be shown.',
	    set_a_date: 'Set an end date',
	    remove_end_date: 'Remove end date',
	    copy_ical_link: 'Copy iCal-link',
	    room: 'Room',
	    rooms: 'Rooms',
	    no_rooms_created: 'No rooms created',
	    access_schedule_without_login: 'Make the calendar accessible via a unique link without login?',
	    student: 'student',
	    students: 'students',
	    user: 'user',
	    users: 'users',
	    no_users_created: 'No users created',
	    other: 'Other calendars',
	    no_other_created: 'No other calendars are created',
	    club: 'Club',
	    no_club_created: 'No club calendars are created',
	    merge_calendars: 'Merge Calendars',
	    merge_calendar: 'Merge Calendar',
	    no_merge_created: 'No merge calendars have been created',
	    use_update_in_url: 'If you want the public schedules to automatically fetch lessons every 5 minutes, you need to add ?update at the end of the public URL address.'
	  },
	  nb: {
	    external_view: 'Ekstern visning',
	    calendars: 'Kalendere',
	    absent_today: 'Dagens fraværende',
	    show_absent_today: 'Vis dagens fraværende',
	    show_absent_today_desc: 'Informasjon om dagens fraværende undervisere kan vises på f.eks infoskjerm. Bruk linken under til oppsetting.',
	    activate_view: 'Aktiver visningen',
	    show_selected_schedules: 'Vis valgte timeplaner',
	    show_selected_schedules_desc: 'For å vise timeplaner til klasser, elever og foresatte, kan man dele linken under på skolens hjemmeside eller lignende. Individuelle elevtimeplaner vil ikke deles via denne felles linken, men kan deles via egen unik link, som man finner ved å trykke på klassen i listen under.',
	    show_selected_schedules_desc_with_students: 'For å vise timeplaner til klasser, elever og foresatte, kan man dele linken under på skolens hjemmeside eller lignende. Individuelle elevtimeplaner vil ikke deles via denne felles linken, men kan deles via egen unik link, som man finner ved å trykke på klassen i listen under.',
	    selected_the_schedules: 'Velg hvilke timeplaner for klasser og rom som skal være synlige via linken over, og hvilke timeplaner til elever som kan deles via unik direktelink.',
	    selected_the_schedules_with_students: 'Velg hvilke timeplaner for klasser og rom som skal være synlige via linken over, og hvilke timeplaner til elever som kan deles via unik direktelink.',
	    visible_via_link: 'Synlig via link',
	    visible_via_link_tooltip: 'En unik lenke til kalenderen, som f.eks elever og foreldre kan få tilgang uten å måtte logge på Docendo. Klikk for å se mobilguide.',
	    schedules_on_desktop_mobile: 'Timeplan på desktop, iPad, Mobil',
	    schedules_on_desktop_mobile_tooltip: 'Leksjoner i kalenderen vil kun være synlige til og med denne datoen. Hvis ingen dato er satt, vil alle leksjoner vises.',
	    show_schedules_until: 'Vis timeplaner til og med',
	    integrations_with_google: 'Integrasjon med Apple Calendar, Google, etc. Klikk for å se veiledningen',
	    grades: 'Klasser',
	    grade: 'Klasse',
	    unselect: 'Opphev',
	    select: 'Velg',
	    all: 'alle',
	    no_grades_created: 'Der er ikke opprettet noen klasser',
	    copy_calendar_link: 'Kopier kalenderlenken',
	    copied: 'Kopiert',
	    no_end_date: 'Ingen sluttdato. Alt vises.',
	    set_a_date: 'Angi en sluttdato',
	    remove_end_date: 'Fjern sluttdatoen',
	    copy_ical_link: 'Kopier iCal-lenken',
	    room: 'Rom',
	    rooms: 'Rom',
	    no_rooms_created: 'Der er ikke opprettet noen rom',
	    access_schedule_without_login: 'Kalenderen skal være tilgjengelig via en unik lenke uten pålogging?',
	    student: 'elev',
	    students: 'elever',
	    user: 'bruker',
	    users: 'brukere',
	    no_users_created: 'Der er ikke opprettet noen brukere',
	    other: 'Andre kalendere',
	    no_other_created: 'Der er ikke opprettet noen andre kalendere',
	    club: 'SFO',
	    no_club_created: 'Der er ikke opprettet noen SFO kalendere',
	    merge_calendars: 'Fellestimeplaner',
	    merge_calendar: 'Fellestimeplan',
	    no_merge_created: 'Der er ikke opprettet noen fellestimeplaner',
	    use_update_in_url: 'Hvis du vil at offentlige timeplaner automatisk skal hente leksjoner hvert 5. minutt, må du legge til ?update på slutten av den offentlige URL-adressen.'
	  }
	};
	exports.default = {
	  components: { CalendarOnMobileGuides: _CalendarOnMobileGuides2.default, Loader: _Loader2.default, AppToggle: _AppToggle2.default, DateSelector: _DateSelector2.default },
	  props: {
	    absence: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      theActiveKlassCalendar: null,
	      isShowICalGuide: false,
	      isShowMobileGuide: false,
	      theActiveDatePickerId: null,
	      theActiveDatepickerDate: null,
	      isToggleLoading: '',
	      theActiveTab: 0,
	      isShowKlass: true,
	      isShowRooms: false,
	      isShowUsers: false,
	      isShowOtherCalendars: false,
	      isShowClubCalendars: false,
	      isShowMergeCalendars: false,
	      isAbsentTodayEnabled: false,
	      isAbsentTodaySaving: false
	    };
	  },
	  created: function created() {
	    this.loadAbsentTodayView();
	  },
	
	  watch: {
	    isUpdatingCalendars: function isUpdatingCalendars(val) {
	      if (!val) {
	        this.isToggleLoading = '';
	      }
	    }
	  },
	  computed: {
	    i18n: function i18n() {
	      return I18N;
	    },
	    locale: function locale() {
	      return window.USER && window.USER.language ? window.USER.language : 'da';
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    isUpdatingCalendars: function isUpdatingCalendars() {
	      return this.$store.state.isUpdatingCalendars;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isLoadingCalendars: function isLoadingCalendars() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    roomCalendars: function roomCalendars() {
	      return this.$store.getters.roomCalendars;
	    },
	    roomCalendarsWithProps: function roomCalendarsWithProps() {
	      var _this = this;
	
	      return this.roomCalendars.map(function (calendar) {
	        _this.$set(calendar, 'v_public_link', _this.generatePublicLink(calendar));
	        _this.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link);
	        _this.$set(calendar, 'v_formatted_date', calendar.published_until ? (0, _moment2.default)(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null);
	        return calendar;
	      });
	    },
	    otherCalendars: function otherCalendars() {
	      return this.$store.getters.otherCalendars;
	    },
	    otherCalendarsWithProps: function otherCalendarsWithProps() {
	      var _this2 = this;
	
	      return this.otherCalendars.map(function (calendar) {
	        _this2.$set(calendar, 'v_public_link', _this2.generatePublicLink(calendar));
	        _this2.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link);
	        _this2.$set(calendar, 'v_formatted_date', calendar.published_until ? (0, _moment2.default)(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null);
	        return calendar;
	      });
	    },
	    clubCalendars: function clubCalendars() {
	      return this.$store.getters.clubCalendars;
	    },
	    clubCalendarsWithProps: function clubCalendarsWithProps() {
	      var _this3 = this;
	
	      return this.clubCalendars.map(function (calendar) {
	        _this3.$set(calendar, 'v_public_link', _this3.generatePublicLink(calendar));
	        _this3.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link);
	        _this3.$set(calendar, 'v_formatted_date', calendar.published_until ? (0, _moment2.default)(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null);
	        return calendar;
	      });
	    },
	    mergeCalendars: function mergeCalendars() {
	      return this.$store.getters.mergeCalendars;
	    },
	    mergeCalendarsWithProps: function mergeCalendarsWithProps() {
	      var _this4 = this;
	
	      return this.mergeCalendars.map(function (calendar) {
	        _this4.$set(calendar, 'v_public_link', _this4.generatePublicLink(calendar));
	        _this4.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link);
	        _this4.$set(calendar, 'v_formatted_date', calendar.published_until ? (0, _moment2.default)(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null);
	        return calendar;
	      });
	    },
	    userCalendars: function userCalendars() {
	      return this.$store.getters.userCalendars;
	    },
	    userCalendarsWithProps: function userCalendarsWithProps() {
	      var _this5 = this;
	
	      return this.userCalendars.map(function (calendar) {
	        _this5.$set(calendar, 'v_public_link', _this5.generatePublicLink(calendar));
	        _this5.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link);
	        _this5.$set(calendar, 'v_formatted_date', calendar.published_until ? (0, _moment2.default)(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null);
	        return calendar;
	      });
	    },
	    studentCalendars: function studentCalendars() {
	      return this.$store.getters.studentCalendars;
	    },
	    studentCalendarsWithProps: function studentCalendarsWithProps() {
	      var _this6 = this;
	
	      return this.studentCalendars.map(function (calendar) {
	        _this6.$set(calendar, 'v_public_link', _this6.generatePublicLink(calendar));
	        _this6.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link);
	        _this6.$set(calendar, 'v_formatted_date', calendar.published_until ? (0, _moment2.default)(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null);
	        return calendar;
	      });
	    },
	    activeStudentCalenders: function activeStudentCalenders() {
	      var _this7 = this;
	
	      return this.studentCalendarsWithProps.filter(function (student) {
	        return student.klasses && student.klasses.indexOf(_this7.theActiveKlassCalendar) > -1;
	      });
	    },
	    calendars: function calendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    klassCalendarsWithAnonymousAccess: function klassCalendarsWithAnonymousAccess() {
	      return this.calendars.filter(function (calendar) {
	        return calendar.anonymous_access;
	      });
	    },
	    isAnyKlassCalendarsWithAnonymousAccess: function isAnyKlassCalendarsWithAnonymousAccess() {
	      return this.klassCalendarsWithAnonymousAccess.length > 0;
	    },
	    roomCalendarsWithAnonymousAccess: function roomCalendarsWithAnonymousAccess() {
	      return this.roomCalendars.filter(function (calendar) {
	        return calendar.anonymous_access;
	      });
	    },
	    isAnyRoomCalendarsWithAnonymousAccess: function isAnyRoomCalendarsWithAnonymousAccess() {
	      return this.roomCalendarsWithAnonymousAccess.length > 0;
	    },
	    otherCalendarsWithAnonymousAccess: function otherCalendarsWithAnonymousAccess() {
	      return this.otherCalendars.filter(function (calendar) {
	        return calendar.anonymous_access;
	      });
	    },
	    isAnyOtherCalendarsWithAnonymousAccess: function isAnyOtherCalendarsWithAnonymousAccess() {
	      return this.otherCalendarsWithAnonymousAccess.length > 0;
	    },
	    clubCalendarsWithAnonymousAccess: function clubCalendarsWithAnonymousAccess() {
	      return this.clubCalendars.filter(function (calendar) {
	        return calendar.anonymous_access;
	      });
	    },
	    isAnyClubCalendarsWithAnonymousAccess: function isAnyClubCalendarsWithAnonymousAccess() {
	      return this.clubCalendarsWithAnonymousAccess.length > 0;
	    },
	    mergeCalendarsWithAnonymousAccess: function mergeCalendarsWithAnonymousAccess() {
	      return this.mergeCalendars.filter(function (calendar) {
	        return calendar.anonymous_access;
	      });
	    },
	    isAnyMergeCalendarsWithAnonymousAccess: function isAnyMergeCalendarsWithAnonymousAccess() {
	      return this.mergeCalendarsWithAnonymousAccess.length > 0;
	    },
	    userCalendarsWithAnonymousAccess: function userCalendarsWithAnonymousAccess() {
	      return this.userCalendars.filter(function (calendar) {
	        return calendar.anonymous_access;
	      });
	    },
	    isAnyUserCalendarsWithAnonymousAccess: function isAnyUserCalendarsWithAnonymousAccess() {
	      return this.userCalendarsWithAnonymousAccess.length > 0;
	    },
	    activeStudentCalendersWithAnonymousAccess: function activeStudentCalendersWithAnonymousAccess() {
	      return this.activeStudentCalenders.filter(function (calendar) {
	        return calendar.anonymous_access;
	      });
	    },
	    isAnyActiveStudentCalendersWithAnonymousAccess: function isAnyActiveStudentCalendersWithAnonymousAccess() {
	      return this.activeStudentCalendersWithAnonymousAccess.length > 0;
	    },
	    calendarsWithProps: function calendarsWithProps() {
	      var _this8 = this;
	
	      return this.calendars.map(function (calendar) {
	        _this8.$set(calendar, 'v_is_open', _this8.theActiveKlassCalendar === calendar.id);
	        _this8.$set(calendar, 'v_public_link', _this8.generatePublicLink(calendar));
	        _this8.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link);
	        _this8.$set(calendar, 'v_formatted_date', calendar.published_until ? (0, _moment2.default)(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null);
	        return calendar;
	      });
	    },
	    publicLink: function publicLink() {
	      return window.location.origin + '/schools/' + window.SCHOOL.id + '/public_calendars';
	    }
	  },
	  methods: {
	    generatePublicLink: function generatePublicLink(calendar) {
	      return window.location.origin + '/calendar/' + calendar.public_id;
	    },
	    setActiveKlassCalendar: function setActiveKlassCalendar(calendar) {
	      if (calendar.students && calendar.students.length < 1) {
	        return;
	      }
	      if (this.theActiveKlassCalendar === calendar.id) {
	        this.theActiveKlassCalendar = null;
	      } else {
	        this.theActiveKlassCalendar = calendar.id;
	      }
	    },
	    setTheActiveTab: function setTheActiveTab(num) {
	      this.theActiveTab = num;
	    },
	    setActiveDatePicker: function setActiveDatePicker(calendar) {
	      if (calendar.published_until) {
	        this.theActiveDatePickerDate = (0, _moment2.default)(calendar.published_until).format('YYYY-MM-DD');
	      } else {
	        this.theActiveDatePickerDate = (0, _moment2.default)(this.activeSchoolYear.student_time_end).format('YYYY-MM-DD');
	      }
	      this.theActiveDatePickerId = calendar.id;
	    },
	    closeDatepicker: function closeDatepicker(calendar) {
	      this.theActiveDatePickerDate = null;
	      this.theActiveDatePickerId = null;
	    },
	    updatePublishUntilDate: function updatePublishUntilDate(calendar, theDate) {
	      var calendars = [{
	        calendar_id: calendar.id,
	        published_until: theDate,
	        anonymous_access: calendar.anonymous_access
	      }];
	      this.$store.dispatch('updateSchoolCalendars', calendars);
	      this.closeDatepicker();
	    },
	    deleteActiveDatePicker: function deleteActiveDatePicker(calendar) {
	      this.updatePublishUntilDate(calendar, null);
	      this.closeDatepicker();
	    },
	    toggleAllKlassCalendars: function toggleAllKlassCalendars() {
	      var _this9 = this;
	
	      this.isToggleLoading = 'klass';
	      var calendars = this.calendars;
	      if (this.isAnyKlassCalendarsWithAnonymousAccess) {
	        calendars = this.klassCalendarsWithAnonymousAccess;
	      }
	      var cals = calendars.map(function (calendar) {
	        var cal = {
	          calendar_id: calendar.id,
	          published_until: calendar.published_until,
	          anonymous_access: !_this9.isAnyKlassCalendarsWithAnonymousAccess
	        };
	        return cal;
	      });
	      this.$store.dispatch('updateSchoolCalendars', cals);
	    },
	    toggleAllUsersCalendars: function toggleAllUsersCalendars() {
	      var _this10 = this;
	
	      this.isToggleLoading = 'users';
	      var calendars = this.userCalendars;
	      if (this.isAnyUserCalendarsWithAnonymousAccess) {
	        calendars = this.userCalendarsWithAnonymousAccess;
	      }
	      var cals = calendars.map(function (calendar) {
	        var cal = {
	          calendar_id: calendar.id,
	          published_until: calendar.published_until,
	          anonymous_access: !_this10.isAnyUserCalendarsWithAnonymousAccess
	        };
	        return cal;
	      });
	      this.$store.dispatch('updateSchoolCalendars', cals);
	    },
	    toggleAllRoomCalendars: function toggleAllRoomCalendars() {
	      var _this11 = this;
	
	      this.isToggleLoading = 'rooms';
	      var calendars = this.roomCalendars;
	      if (this.isAnyRoomCalendarsWithAnonymousAccess) {
	        calendars = this.roomCalendarsWithAnonymousAccess;
	      }
	      var cals = calendars.map(function (calendar) {
	        var cal = {
	          calendar_id: calendar.id,
	          published_until: calendar.published_until,
	          anonymous_access: !_this11.isAnyRoomCalendarsWithAnonymousAccess
	        };
	        return cal;
	      });
	      this.$store.dispatch('updateSchoolCalendars', cals);
	    },
	    toggleAllOtherCalendars: function toggleAllOtherCalendars() {
	      var _this12 = this;
	
	      this.isToggleLoading = 'other';
	      var calendars = this.otherCalendars;
	      if (this.isAnyOtherCalendarsWithAnonymousAccess) {
	        calendars = this.otherCalendarsWithAnonymousAccess;
	      }
	      var cals = calendars.map(function (calendar) {
	        var cal = {
	          calendar_id: calendar.id,
	          published_until: calendar.published_until,
	          anonymous_access: !_this12.isAnyOtherCalendarsWithAnonymousAccess
	        };
	        return cal;
	      });
	      this.$store.dispatch('updateSchoolCalendars', cals);
	    },
	    toggleAllClubCalendars: function toggleAllClubCalendars() {
	      var _this13 = this;
	
	      this.isToggleLoading = 'club';
	      var calendars = this.clubCalendars;
	      if (this.isAnyClubCalendarsWithAnonymousAccess) {
	        calendars = this.clubCalendarsWithAnonymousAccess;
	      }
	      var cals = calendars.map(function (calendar) {
	        var cal = {
	          calendar_id: calendar.id,
	          published_until: calendar.published_until,
	          anonymous_access: !_this13.isAnyClubCalendarsWithAnonymousAccess
	        };
	        return cal;
	      });
	      this.$store.dispatch('updateSchoolCalendars', cals);
	    },
	    toggleAllMergeCalendars: function toggleAllMergeCalendars() {
	      var _this14 = this;
	
	      this.isToggleLoading = 'merge';
	      var calendars = this.mergeCalendars;
	      if (this.isAnyMergeCalendarsWithAnonymousAccess) {
	        calendars = this.mergeCalendarsWithAnonymousAccess;
	      }
	      var cals = calendars.map(function (calendar) {
	        var cal = {
	          calendar_id: calendar.id,
	          published_until: calendar.published_until,
	          anonymous_access: !_this14.isAnyMergeCalendarsWithAnonymousAccess
	        };
	        return cal;
	      });
	      this.$store.dispatch('updateSchoolCalendars', cals);
	    },
	    toggleAllStudentCalendars: function toggleAllStudentCalendars() {
	      var _this15 = this;
	
	      this.isToggleLoading = 'students';
	      var calendars = this.activeStudentCalenders;
	      if (this.isAnyActiveStudentCalendersWithAnonymousAccess) {
	        calendars = this.activeStudentCalendersWithAnonymousAccess;
	      }
	      var cals = calendars.map(function (calendar) {
	        var cal = {
	          calendar_id: calendar.id,
	          published_until: calendar.published_until,
	          anonymous_access: !_this15.isAnyActiveStudentCalendersWithAnonymousAccess
	        };
	        return cal;
	      });
	      this.$store.dispatch('updateSchoolCalendars', cals);
	    },
	    toggleAnonymousAccess: function toggleAnonymousAccess(calendar) {
	      var calendars = [{
	        calendar_id: calendar.id,
	        published_until: calendar.published_until,
	        anonymous_access: !calendar.anonymous_access
	      }];
	      this.$store.dispatch('updateSchoolCalendars', calendars);
	    },
	    loadAbsentTodayView: function loadAbsentTodayView() {
	      var _this16 = this;
	
	      if (!this.schoolId) {
	        return;
	      }
	      _docendo2.default.showSchool(this.schoolId, function (data) {
	        _this16.isAbsentTodayEnabled = !!data.anonymous_access;
	      });
	    },
	    toggleAbsentTodayView: function toggleAbsentTodayView() {
	      var _this17 = this;
	
	      if (this.isAbsentTodaySaving || !this.schoolId) {
	        return;
	      }
	      var next = !this.isAbsentTodayEnabled;
	      this.isAbsentTodayEnabled = next;
	      this.isAbsentTodaySaving = true;
	      _docendo2.default.updateSchool(this.schoolId, { anonymous_access: next }, function (success) {
	        _this17.isAbsentTodayEnabled = !!success.anonymous_access;
	        _this17.isAbsentTodaySaving = false;
	      }, function (failure) {
	        console.log('failure', failure);
	        _this17.isAbsentTodayEnabled = !next;
	        _this17.isAbsentTodaySaving = false;
	      });
	    },
	    setIsShowICalGuide: function setIsShowICalGuide(boolean) {
	      this.isShowICalGuide = boolean;
	    },
	    setIsShowMobileGuide: function setIsShowMobileGuide(boolean) {
	      this.isShowMobileGuide = boolean;
	    },
	    hideTippy: function hideTippy(tippyEl) {
	      setTimeout(function (_) {
	        tippyEl.hide();
	      }, 1000);
	    },
	    copyToClipboard: function copyToClipboard(link, evt) {
	      navigator.clipboard.writeText(link).then(function (_) {
	        evt.target._tippy.show();
	      }, function (_) {
	        console.log('that totally failed');
	      });
	    }
	  }
	};

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DateSelector: _DateSelector2.default },
	  props: {
	    enddate: {
	      default: null
	    },
	    minDate: {
	      default: null
	    },
	    label: {
	      type: String,
	      required: true
	    }
	  },
	  methods: {
	    defaultEnddate: function defaultEnddate() {
	      return (0, _moment2.default)(this.minDate || undefined).format('YYYY-MM-DD');
	    },
	    onToggle: function onToggle(event) {
	      this.$emit('update:enddate', event.target.checked ? this.defaultEnddate() : null);
	    },
	    onDateChanged: function onDateChanged(date) {
	      this.$emit('update:enddate', (0, _moment2.default)(date).format('YYYY-MM-DD'));
	    }
	  }
	};

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vuex = __webpack_require__(14);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(39);
	
	var _CalendarViewDay = __webpack_require__(341);
	
	var _CalendarViewDay2 = _interopRequireDefault(_CalendarViewDay);
	
	var _DCalendarShowEvent = __webpack_require__(81);
	
	var _DCalendarShowEvent2 = _interopRequireDefault(_DCalendarShowEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	
	var I18N = {
	  da: {
	    double_booking: 'Dobbeltbooking',
	    double_bookings: 'Dobbeltbookinger',
	    no_double_bookings: 'Ingen dobbeltbookinger denne dato',
	    more: 'mere'
	  },
	  en: {
	    double_booking: 'Doublebooking',
	    double_bookings: 'Doublebookings',
	    no_double_bookings: 'There is no double bookings this date',
	    more: 'more'
	  },
	  nb: {
	    double_booking: 'Dobbeltbooking',
	    double_bookings: 'Dobbeltbookinger',
	    no_double_bookings: 'Ingen dobbeltbookinger denne datoen',
	    more: 'til'
	  }
	};
	
	exports.default = {
	  components: { CalendarViewDay: _CalendarViewDay2.default, Loader: _Loader2.default, DCalendarShowEvent: _DCalendarShowEvent2.default },
	  props: {
	    date: {
	      default: function _default() {
	        return moment().startOf('day');
	      }
	    },
	    show: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      activeTab: 'teachers',
	      collisions: [],
	      eventsWithOverlappingEvents: [],
	      startDate: moment().startOf('day'),
	      endDate: moment().endOf('day'),
	      isLoading: true,
	      activeCalendar: null,
	      locale: window.USER.language ? window.USER.language : 'en',
	      activeEvent: null
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['allCalendarsInHash', 'userCalendars', 'roomCalendars']), {
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    allCalendars: function allCalendars() {
	      return this.$store.state.calendars;
	    },
	    calendarIds: function calendarIds() {
	      return this.allCalendars.map(function (calendar) {
	        return calendar.id;
	      });
	    },
	    formattedDate: function formattedDate() {
	      return moment(this.date).format('LL');
	    },
	    i18n: function i18n() {
	      return I18N;
	    }
	  }),
	  watch: {
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders(val) {
	      if (!val) {
	        this.readCollisions();
	      }
	    },
	    date: function date(val) {
	      this.startDate = moment(val).startOf('day');
	      this.endDate = moment(val).endOf('day');
	      this.readCollisions();
	    },
	    show: function show(val) {
	      if (val) {
	        console.log('collisions:update');
	        this.readCollisions();
	      }
	    }
	  },
	  methods: {
	    closeShowEvent: function closeShowEvent() {
	      this.activeEvent = null;
	    },
	    onEventUpdated: function onEventUpdated() {
	      this.readCollisions();
	      this.$emit('updated');
	    },
	    setActiveTab: function setActiveTab(tab) {
	      this.activeTab = tab;
	      this.readCollisions();
	    },
	    readCollisions: function readCollisions() {
	      var _this = this;
	
	      this.isLoading = true;
	      if (this.calendarIds.length < 1) {
	        return;
	      }
	      _docendo2.default.eventsFromCalendars(this.calendarIds, this.startDate, this.endDate, true, function (success) {
	        var data = success && success.length > 0 ? JSON.parse(success) : [];
	        data = data.filter(function (event) {
	          return event.event_type !== 'presence';
	        });
	        _this.collisions = data.sort(function (a, b) {
	          return moment(a.start).unix() - moment(b.start).unix();
	        });
	        _this.isLoading = false;
	        _this.setCollisionsInGroups(_this.collisions);
	      }, function (failure) {
	        console.log('failure', failure);
	        _this.isLoading = false;
	      });
	    },
	    setCollisionsInGroups: function setCollisionsInGroups(eventsArr) {
	      var _this2 = this;
	
	      this.eventsWithOverlappingEvents = [];
	
	      eventsArr.forEach(function (event) {
	        event.v_start = moment(event.start).format('LT');
	        event.v_end = moment(event.end).format('LT');
	        event.v_overlapping_calendars = [];
	        event.v_overlapping_cals_with_events = {};
	        event.v_calendarIds = event.calendars.map(function (cal) {
	          return cal.calendar_id;
	        });
	        event.v_owner_calendar_name = '';
	        event.v_number_of_overlapping_events = 0;
	        if (_this2.allCalendarsInHash[event.calendar_id]) {
	          event.v_owner_calendar_name = _this2.allCalendarsInHash[event.calendar_id].name;
	        }
	        var range1 = moment.range(event.start, event.end);
	        eventsArr.forEach(function (lesson) {
	          if (lesson.event_id !== event.event_id) {
	            var range2 = moment.range(lesson.start, lesson.end);
	
	            if (range1.overlaps(range2)) {
	              var calIds = lesson.calendars.map(function (cal) {
	                return cal.calendar_id;
	              });
	              event.calendars.forEach(function (eventCal) {
	                var overLapCalId = eventCal.calendar_id;
	
	                if (calIds.indexOf(overLapCalId) > -1) {
	                  if (_this2.allCalendarsInHash[overLapCalId]) {
	                    if (!event.v_overlapping_cals_with_events[overLapCalId]) {
	                      event.v_overlapping_cals_with_events[overLapCalId] = {
	                        idx: (0, _keys2.default)(event.v_overlapping_cals_with_events).length,
	                        calendar: _this2.allCalendarsInHash[overLapCalId],
	                        lessons: [{ v_event_id: lesson.event_id, v_event_title: lesson.title }]
	                      };
	                    } else {
	                      event.v_overlapping_cals_with_events[overLapCalId].lessons.push({
	                        v_event_id: lesson.event_id,
	                        v_event_title: lesson.title
	                      });
	                    }
	                  }
	                  event.v_overlapping_calendars.push(eventCal.calendar_id);
	                }
	              });
	            }
	          }
	          event.v_number_of_overlapping_events = (0, _keys2.default)(event.v_overlapping_cals_with_events).length;
	        });
	        _this2.eventsWithOverlappingEvents.push(event);
	      });
	    }
	  },
	  mounted: function mounted() {
	    if (this.isLoadingSchoolCalenders) {
	      return;
	    }
	    this.readCollisions();
	  }
	};

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _Feedback = __webpack_require__(1470);
	
	var _Feedback2 = _interopRequireDefault(_Feedback);
	
	var _SpinnerButton = __webpack_require__(154);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _CopyCalendarRotate = __webpack_require__(346);
	
	var _CopyCalendarRotate2 = _interopRequireDefault(_CopyCalendarRotate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    calid: {
	      default: 71980
	    },
	    initCalendar: {
	      default: null
	    },
	    activeCalendarDate: {
	      default: null
	    }
	  },
	  mixins: [_vueClickaway.mixin],
	  components: { CopyCalendarRotate: _CopyCalendarRotate2.default, leftPanel: _Feedback2.default, spinner: _SpinnerButton2.default },
	  data: function data() {
	    return {
	      cal: null,
	      calType: '',
	      calCurrentDate: (0, _moment2.default)(),
	      modal: false,
	      copyDate: '',
	      isJustCopied: false,
	      selectedWeeks: [],
	      startPasteWeek: _eventbus2.default.now,
	      feedback: false,
	      notSubmit: false,
	      deleteEvents: true,
	      weeks: [],
	      isLoading: false,
	      calStartDate: (0, _moment2.default)().format('YYYY-MM-DD'),
	      calEndDate: (0, _moment2.default)().format('YYYY-MM-DD')
	    };
	  },
	
	  computed: {
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    schoolIsFromDenmark: function schoolIsFromDenmark() {
	      return this.activeSchool && this.activeSchool.country === 'DK';
	    },
	    schoolFeatures: function schoolFeatures() {
	      return this.activeSchool && this.activeSchool.features ? this.activeSchool.features : [];
	    },
	    isShowCopyCalendarRotate: function isShowCopyCalendarRotate() {
	      return this.schoolFeatures.indexOf('rotating_schedules') > -1;
	    },
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    schoolYear: function schoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isBetweenActiveSchoolYear: function isBetweenActiveSchoolYear() {
	      var _this = this;
	
	      var calDateIsWithinThisSchoolYear = null;
	      this.activeSchoolYears.forEach(function (year) {
	        var startDate = void 0;
	        var endDate = void 0;
	        if (_this.calType === 'klass') {
	          startDate = (0, _moment2.default)(year.student_time_start).startOf('isoweek');
	          endDate = (0, _moment2.default)(year.student_time_end).endOf('isoweek');
	        } else {
	          startDate = (0, _moment2.default)(year.employee_time_start).startOf('isoweek');
	          endDate = (0, _moment2.default)(year.employee_time_end).endOf('isoweek');
	        }
	        if ((0, _moment2.default)(_this.calCurrentDate).isSame(startDate) || (0, _moment2.default)(_this.calCurrentDate).isBetween(startDate, endDate)) {
	          calDateIsWithinThisSchoolYear = year;
	        }
	      });
	      return calDateIsWithinThisSchoolYear;
	    },
	    currentDateIsNotWithinCalendarRange: function currentDateIsNotWithinCalendarRange() {
	      return !this.isBetweenActiveSchoolYear && this.activeSchoolYears.length > 0;
	    },
	    showStartPasteWeek: function showStartPasteWeek() {
	      return (0, _moment2.default)(this.startPasteWeek).isSame(this.calStartDate);
	    },
	    noneSelected: function noneSelected() {
	      return this.selectedWeeks.length === 0;
	    },
	    tooptipCopyWeek: function tooptipCopyWeek() {
	      return this.$t('vue2.copycalendar.copiedFrom') + ' ' + (0, _moment2.default)(this.copyDate).isoWeek();
	    },
	    firstDayOfTheWeek: function firstDayOfTheWeek() {
	      return this.$store.getters.firstDayOfWeek;
	    }
	  },
	  watch: {
	    activeCalendarDate: function activeCalendarDate() {
	      this.calCurrentDate = this.activeCalendarDate;
	    }
	  },
	  filters: {
	    tooltipDate: function tooltipDate(date) {
	      var start = (0, _moment2.default)(date);
	      var start2 = (0, _moment2.default)(date).format('DD. MMM');
	      var startFormat = start.format('DD');
	      var end = (0, _moment2.default)(date).add(6, 'days');
	      var endFormat = (0, _moment2.default)(date).add(6, 'days').format('DD. MMM YYYY');
	
	      if ((0, _moment2.default)(start).format('MM') === (0, _moment2.default)(end).format('MM')) {
	        return startFormat + ' - ' + endFormat;
	      } else {
	        return start2 + ' - ' + endFormat;
	      }
	    },
	    week: function week(date) {
	      return (0, _moment2.default)(date).isoWeek();
	    }
	  },
	  methods: {
	    getCalType: function getCalType() {
	      var _this2 = this;
	
	      if (this.initCalendar) {
	        this.cal = this.initCalendar;
	        this.calType = this.initCalendar.type;
	      } else {
	        _docendo2.default.calendar(this.calid, function (data) {
	          _this2.cal = data;
	          _this2.calType = data.type;
	        });
	      }
	    },
	    getCopyDate: function getCopyDate() {
	      var _this3 = this;
	
	      var year = this.schoolYear;
	      if (this.isBetweenActiveSchoolYear) {
	        year = this.isBetweenActiveSchoolYear;
	      }
	      if (this.calType === 'klass') {
	        this.calStartDate = year.student_time_start;
	        this.calEndDate = year.student_time_end;
	      } else {
	        this.calStartDate = year.employee_time_start;
	        this.calEndDate = year.employee_time_end;
	      }
	
	      this.removeAllSelectedWeeks();
	      this.cleanCopyDate();
	      if (this.activeCalendarDate) {
	        this.isJustCopied = true;
	        setTimeout(function () {
	          _this3.isJustCopied = false;
	        }, 3500);
	        this.copyDate = (0, _moment2.default)(this.activeCalendarDate).isoWeekday(this.firstDayOfTheWeek);
	      } else {
	        var calendar = document.querySelectorAll('#calendar_' + this.calid);
	        if (calendar.length === 1) {
	          this.isJustCopied = true;
	          setTimeout(function () {
	            _this3.isJustCopied = false;
	          }, 3500);
	          this.copyDate = calendar[0].dataset.current_date;
	        }
	      }
	      this.openModal();
	    },
	    openModal: function openModal() {
	      this.isLoading = true;
	      this.createWeeks();
	      this.getPasteDate();
	      this.modal = true;
	      this.$emit('copyCalendarModalOpen', true);
	    },
	    createWeeks: function createWeeks() {
	      var start = (0, _moment2.default)(this.calStartDate).day(this.firstDayOfTheWeek);
	      var end = (0, _moment2.default)(this.calEndDate).endOf('isoweek');
	      var startWeek = (0, _moment2.default)(start).isoWeek();
	      var diff = (0, _moment2.default)(end).diff(start, 'week');
	      var max = startWeek + diff;
	      var weeks = [];
	      for (var i = startWeek; i <= max; i++) {
	        var date = (0, _moment2.default)(start).isoWeek(i).day(this.firstDayOfTheWeek);
	        weeks.push({
	          date: date,
	          isSelected: false,
	          serverDate: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	          weekNum: date.isoWeek(),
	          isNow: (0, _moment2.default)(date).format('GGGG-WW') === (0, _moment2.default)().format('GGGG-WW'),
	          isCopyWeek: date.isoWeek() === (0, _moment2.default)(this.copyDate).isoWeek()
	        });
	      }
	      this.weeks = weeks;
	      this.isLoading = false;
	    },
	    setSubmit: function setSubmit(val) {
	      this.notSubmit = val;
	    },
	    getPasteDate: function getPasteDate() {
	      if (this.activeCalendarDate) {
	        var week = (0, _moment2.default)(this.activeCalendarDate).isoWeek();
	        this.startPasteWeek = this.activeCalendarDate;
	        this.selectWeek(this.findWeek(week));
	      } else {
	        var calendar = document.querySelectorAll('#calendar_' + this.calid);
	        if (calendar.length === 1 && this.selectedWeeks.length === 0) {
	          var _week = (0, _moment2.default)(calendar[0].dataset.current_date).isoWeek();
	          this.startPasteWeek = calendar[0].dataset.current_date;
	          this.selectWeek(this.findWeek(_week));
	        }
	      }
	    },
	    selectWeek: function selectWeek(i) {
	      if (i > -1) {
	        if (!this.weeks[i].isSelected && !this.weeks[i].isCopyWeek) {
	          this.selectedWeeks.push(this.weeks[i].serverDate);
	          this.weeks[i].isSelected = true;
	        }
	      }
	    },
	    removeWeek: function removeWeek(i) {
	      this.weeks[i].isSelected = false;
	      var selectedIndex = this.selectedWeeks.indexOf(this.weeks[i].serverDate);
	      this.selectedWeeks.splice(selectedIndex, 1);
	    },
	    toggleWeek: function toggleWeek(index) {
	      if (this.selectedWeeks.length < 1 || this.showStartPasteWeek) {
	        this.startPasteWeek = this.weeks[index].date;
	      }
	      if (!this.weeks[index].isSelected) {
	        this.selectWeek(index);
	      } else {
	        this.removeWeek(index);
	      }
	    },
	    findWeek: function findWeek(weekNum) {
	      for (var i = 0; i < this.weeks.length; i++) {
	        if (this.weeks[i].weekNum === weekNum) {
	          return i;
	        }
	      }
	    },
	    selectAll: function selectAll() {
	      for (var i = 0; i < this.weeks.length; i++) {
	        if ((0, _moment2.default)(this.weeks[i].date).isSameOrAfter(this.startPasteWeek)) {
	          this.selectWeek(i);
	        }
	      }
	    },
	    selectEvenWeeks: function selectEvenWeeks() {
	      for (var i = 0; i < this.weeks.length; i++) {
	        if ((0, _moment2.default)(this.weeks[i].date).isSameOrAfter(this.startPasteWeek)) {
	          if (this.isEven(this.weeks[i].date.isoWeek())) {
	            this.selectWeek(i);
	          }
	        }
	      }
	    },
	    selectOddWeeks: function selectOddWeeks() {
	      for (var i = 0; i < this.weeks.length; i++) {
	        if ((0, _moment2.default)(this.weeks[i].date).isSameOrAfter(this.startPasteWeek)) {
	          if (this.isOdd(this.weeks[i].date.isoWeek())) {
	            this.selectWeek(i);
	          }
	        }
	      }
	    },
	    isEven: function isEven(n) {
	      return (/^-?\d*[02468]$/.test(n)
	      );
	    },
	    isOdd: function isOdd(n) {
	      return (/^-?\d*[13579]$/.test(n)
	      );
	    },
	    removeAllSelectedWeeks: function removeAllSelectedWeeks() {
	      this.selectedWeeks = [];
	      for (var i = 0; i < this.weeks.length; i++) {
	        this.weeks[i].isSelected = false;
	      }
	    },
	    submitWeeks: function submitWeeks() {
	      var _this4 = this;
	
	      this.$store.dispatch('analyticsCopyCalender');
	      if (this.selectedWeeks.length > 0 && !this.notSubmit) {
	        this.close();
	        _eventbus2.default.toast = { text: this.$i18n.t('vue2.copycalendar.noticationMessage'), success: false };
	        _docendo2.default.calendarCopyWeeks(this.calid, this.copyDate, this.selectedWeeks, this.deleteEvents, [], ['absence', 'presence', 'activity'], function (data) {
	          _this4.removeAllSelectedWeeks();
	        });
	      }
	    },
	    submitThisWeek: function submitThisWeek() {
	      var _this5 = this;
	
	      this.$store.dispatch('analyticsCopyCalender');
	      this.close();
	      _eventbus2.default.toast = { text: this.$i18n.t('vue2.copycalendar.noticationMessage'), success: false };
	      var serverDate = (0, _moment2.default)(this.calCurrentDate).format('YYYY-WW');
	      this.selectedWeeks.push(serverDate);
	      _docendo2.default.calendarCopyWeeks(this.calid, this.copyDate, this.selectedWeeks, false, [], ['absence', 'presence', 'activity'], function (data) {
	        _this5.removeAllSelectedWeeks();
	      });
	    },
	    close: function close() {
	      this.modal = false;
	      this.feedback = false;
	      this.$emit('copyCalendarModalOpen', false);
	    },
	    eraseStartDate: function eraseStartDate() {
	      this.startPasteWeek = this.calStartDate;
	    },
	    cleanCopyDate: function cleanCopyDate() {
	      this.copyDate = '';
	      for (var i = 0; i < this.weeks.length; i++) {
	        this.weeks[i].isCopyWeek = false;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.getCalType();
	  },
	  mounted: function mounted() {
	    var _this6 = this;
	
	    if (this.activeCalendarDate) {
	      this.calCurrentDate = this.activeCalendarDate;
	    } else {
	      window.addEventListener('fullcal_view_or_date_changed', function (e) {
	        _this6.calCurrentDate = e.detail;
	      }, false);
	    }
	  }
	};

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CopyMultipleCalendarsCopy = __webpack_require__(345);
	
	var _CopyMultipleCalendarsCopy2 = _interopRequireDefault(_CopyMultipleCalendarsCopy);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _TaggingFilter = __webpack_require__(43);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { TaggingFilter: _TaggingFilter2.default, CopyButton: _CopyMultipleCalendarsCopy2.default },
	  props: {
	    isOpen: {
	      type: Boolean,
	      default: false
	    },
	    calType: {
	      type: String,
	      default: 'klass'
	    },
	    calendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      copyCalType: null,
	      selectedCalIds: [],
	      selectedWeeks: ['2021-26'],
	      copyDate: '2021-02-08',
	      isDeleteEvents: true,
	      isAccOpen: false,
	      isArchivedAccOpen: false,
	      isCopyOpen: false,
	      appliedFilters: [],
	      tags: []
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    filteredCalendars: function filteredCalendars() {
	      var _this = this;
	
	      if (this.appliedFilters.length < 1) {
	        return this.calendars;
	      }
	      return this.calendars.filter(function (calendar) {
	        return calendar.user_tags.some(function (tag) {
	          return _this.appliedFilters.includes(tag);
	        });
	      });
	    },
	    calendarsExclArchived: function calendarsExclArchived() {
	      return this.filteredCalendars.filter(function (calendar) {
	        return !calendar.archived_at;
	      });
	    },
	    calendarsExclArchivedWithoutFilters: function calendarsExclArchivedWithoutFilters() {
	      return this.calendars.filter(function (calendar) {
	        return !calendar.archived_at;
	      });
	    },
	    archivedCalendars: function archivedCalendars() {
	      return this.filteredCalendars.filter(function (calendar) {
	        return calendar.archived_at;
	      });
	    },
	    title: function title() {
	      switch (this.calType) {
	        case 'klass':
	          return this.$t('vue2.common.classes');
	        case 'user':
	          return this.$t('vue2.common.users');
	        case 'room':
	          return this.$t('vue2.common.rooms');
	        case 'merge':
	          return this.$t('vue2.common.merge_calendars');
	        case 'other':
	          return this.$t('vue2.common.other_calendars');
	      }
	    }
	  },
	  methods: {
	    setTagFromFilter: function setTagFromFilter(tag) {
	      this.selectedCalIds = [];
	      this.appliedFilters.push(tag);
	    },
	    removeTagFromFilter: function removeTagFromFilter(tag) {
	      this.appliedFilters.splice(this.appliedFilters.indexOf(tag), 1);
	    },
	    getIsInSelectedCalIds: function getIsInSelectedCalIds(calId) {
	      return this.selectedCalIds.indexOf(calId) > -1;
	    },
	    toogleCal: function toogleCal(calId) {
	      var idx = this.selectedCalIds.indexOf(calId);
	      if (idx < 0) {
	        this.selectedCalIds.push(calId);
	      } else {
	        this.selectedCalIds.splice(idx, 1);
	      }
	    },
	    toggleAllKlasses: function toggleAllKlasses() {
	      var _this2 = this;
	
	      if (this.selectedCalIds.length > 0) {
	        this.selectedCalIds = [];
	      } else {
	        this.selectedCalIds = [];
	        this.filteredCalendars.forEach(function (calendar) {
	          return _this2.selectedCalIds.push(calendar.id);
	        });
	      }
	    },
	    copyCals: function copyCals(objWeeks) {
	      this.copyDate = objWeeks.copyDate;
	      this.selectedWeeks = objWeeks.selectedWeeks;
	      this.isDeleteEvents = objWeeks.isDeleteEvents;
	      this.copyWeeks();
	    },
	    copyWeeks: function copyWeeks(calId) {
	      var _this3 = this;
	
	      if (this.selectedCalIds.length < 1) {
	        return;
	      }
	      _docendo2.default.calendarCopyWeeks(this.selectedCalIds, this.copyDate, this.selectedWeeks, this.isDeleteEvents, [], ['absence', 'presence', 'activity'], function (data) {
	        _eventbus2.default.toast = { text: 'Kopierer kalendere', success: true };
	        _this3.selectedCalIds = [];
	      });
	    },
	    toggleIsAccOpen: function toggleIsAccOpen() {
	      if (this.isCopyOpen) {
	        return;
	      }
	      if (!this.isAccOpen) {
	        this.isAccOpen = true;
	      } else {
	        this.isAccOpen = false;
	        this.selectedCalIds = [];
	      }
	    },
	    getTags: function getTags() {
	      var _this4 = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this4.tags = data;
	      });
	    }
	  },
	  mounted: function mounted() {
	    if (this.isOpen) {
	      this.isAccOpen = true;
	    }
	    if (this.calType === 'user') {
	      this.getTags();
	    }
	  }
	};

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(28);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _core = __webpack_require__(25);
	
	var _Spinner = __webpack_require__(26);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Spinner: _Spinner2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    calType: {
	      type: String,
	      default: 'klass'
	    },
	    initCopyDate: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      copyDate: null,
	      calStartDate: null,
	      calEndDate: null,
	      selectedWeeks: [],
	      isDropdown: false,
	      isDropdownPopperDone: false,
	      isDeleteEvents: true
	    };
	  },
	
	  computed: {
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    localActivatedSchoolYear: function localActivatedSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    firstDayOfTheWeek: function firstDayOfTheWeek() {
	      var start = 1;
	      if ((0, _typeof3.default)(window.SCHOOL) && window.SCHOOL.first_day_of_week_num !== 'undefined') {
	        start = window.SCHOOL.first_day_of_week_num;
	      }
	      return start;
	    },
	    weeks: function weeks() {
	      var activeSchoolYear = this.localActivatedSchoolYear;
	      if (this.calType === 'klass') {
	        this.calStartDate = activeSchoolYear.student_time_start;
	        this.calEndDate = activeSchoolYear.student_time_end;
	      } else {
	        this.calStartDate = activeSchoolYear.employee_time_start;
	        this.calEndDate = activeSchoolYear.employee_time_end;
	      }
	      var start = (0, _moment2.default)(this.calStartDate).day(this.firstDayOfTheWeek);
	      var end = (0, _moment2.default)(this.calEndDate).endOf('isoweek');
	      var startWeek = (0, _moment2.default)(start).isoWeek();
	      var diff = (0, _moment2.default)(end).diff(start, 'week');
	      var max = startWeek + diff;
	      var weeks = [];
	      for (var i = startWeek; i <= max; i++) {
	        var date = (0, _moment2.default)(start).isoWeek(i).day(this.firstDayOfTheWeek);
	        weeks.push({
	          date: date,
	          serverDate: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	          weekNum: date.isoWeek()
	        });
	      }
	      return weeks;
	    }
	  },
	  methods: {
	    createPopper: function createPopper() {
	      var el = this.$refs.copy_calendars_button;
	
	      (0, _core.createPopper)(el, this.$refs.copy_calendars_panel, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: function offset(_ref) {
	              var placement = _ref.placement,
	                  reference = _ref.reference,
	                  popper = _ref.popper;
	
	              return [0, 5];
	            }
	          }
	        }]
	      });
	    },
	    openDropdown: function openDropdown() {
	      var _this = this;
	
	      if (this.initCopyDate) {
	        this.copyDate = this.initCopyDate;
	      }
	      this.isDropdown = true;
	      this.$emit('open');
	      setTimeout(function (_) {
	        _this.createPopper();
	        _this.isDropdownPopperDone = true;
	      }, 0);
	    },
	    closeDropdown: function closeDropdown() {
	      if (!this.isDropdown) {
	        return;
	      }
	      this.isDropdown = false;
	      this.$emit('close');
	      this.isDropdownPopperDone = false;
	      this.selectedWeeks = [];
	      this.calStartDate = null;
	      this.copyDate = null;
	    },
	    tooltipDate: function tooltipDate(date) {
	      var start = (0, _moment2.default)(date);
	      var start2 = (0, _moment2.default)(date).format('DD. MMM');
	      var startFormat = start.format('DD');
	      var end = (0, _moment2.default)(date).add(6, 'days');
	      var endFormat = (0, _moment2.default)(date).add(6, 'days').format('DD. MMM YYYY');
	
	      if ((0, _moment2.default)(start).format('MM') === (0, _moment2.default)(end).format('MM')) {
	        return startFormat + ' - ' + endFormat;
	      } else {
	        return start2 + ' - ' + endFormat;
	      }
	    },
	    isWeekSelected: function isWeekSelected(week) {
	      var idx = this.selectedWeeks.indexOf(week.serverDate);
	      return idx > -1;
	    },
	    isCopyWeek: function isCopyWeek(week) {
	      return this.copyDate ? (0, _moment2.default)(week.date).format('GGGG-WW') === (0, _moment2.default)(this.copyDate).format('GGGG-WW') : false;
	    },
	    isNow: function isNow(week) {
	      return (0, _moment2.default)(week.date).format('GGGG-WW') === (0, _moment2.default)().format('GGGG-WW');
	    },
	    setSelectedWeek: function setSelectedWeek(week) {
	      if (!this.copyDate) {
	        this.copyDate = week.date;
	        return;
	      }
	      if (this.isCopyWeek(week)) {
	        this.removeSelectedDate();
	        return;
	      }
	      var idx = this.selectedWeeks.indexOf(week.serverDate);
	      if (idx < 0) {
	        this.selectedWeeks.push(week.serverDate);
	      } else {
	        this.selectedWeeks.splice(idx, 1);
	      }
	    },
	    removeSelectedDate: function removeSelectedDate() {
	      this.copyDate = null;
	      this.selectedWeeks = [];
	    },
	    showWeek: function showWeek(date) {
	      return (0, _moment2.default)(date).isoWeek();
	    },
	    selectWeek: function selectWeek(week) {
	      if (this.isCopyWeek(week)) {
	        return;
	      }
	      var idx = this.selectedWeeks.indexOf(week.serverDate);
	      if (idx < 0) {
	        this.selectedWeeks.push(week.serverDate);
	      }
	    },
	    addAllWeeksOnward: function addAllWeeksOnward() {
	      var _this2 = this;
	
	      if (!this.copyDate) {
	        return [];
	      }
	      this.weeks.forEach(function (week) {
	        if ((0, _moment2.default)(week.date).isSameOrAfter(_this2.copyDate)) {
	          _this2.selectWeek(week);
	        }
	      });
	    },
	    removeAllSelectedWeeks: function removeAllSelectedWeeks() {
	      this.selectedWeeks = [];
	    },
	    selectEvenWeeks: function selectEvenWeeks() {
	      var _this3 = this;
	
	      this.weeks.forEach(function (week) {
	        if ((0, _moment2.default)(week.date).isSameOrAfter(_this3.copyDate)) {
	          if (_this3.isEven(week.date.isoWeek())) {
	            _this3.selectWeek(week);
	          }
	        }
	      });
	    },
	    selectOddWeeks: function selectOddWeeks() {
	      var _this4 = this;
	
	      this.weeks.forEach(function (week) {
	        if ((0, _moment2.default)(week.date).isSameOrAfter(_this4.copyDate)) {
	          if (_this4.isOdd(week.date.isoWeek())) {
	            _this4.selectWeek(week);
	          }
	        }
	      });
	    },
	    isEven: function isEven(n) {
	      return (/^-?\d*[02468]$/.test(n)
	      );
	    },
	    isOdd: function isOdd(n) {
	      return (/^-?\d*[13579]$/.test(n)
	      );
	    },
	    submit: function submit() {
	      var obj = {
	        copyDate: this.copyDate,
	        selectedWeeks: this.selectedWeeks,
	        isDeleteEvents: this.isDeleteEvents
	      };
	      this.$emit('submit', obj);
	      this.closeDropdown();
	    }
	  }
	};

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Spinner = __webpack_require__(26);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { spinner: _Spinner2.default },
	  props: ['selectedWeeks', 'calId', 'deleteEvents'],
	  watch: {
	    selectedWeeks: function selectedWeeks(val, oldVal) {
	      this.checkForNotesAndSubstitutes(val);
	    },
	    isLoading: function isLoading(val, oldVal) {
	      this.$emit('load', val);
	    },
	    deleteEvents: function deleteEvents(val, oldVal) {
	      if (val) {
	        this.checkForNotesAndSubstitutes(this.selectedWeeks);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      lessons: []
	    };
	  },
	
	  computed: {
	    sortedLesson: function sortedLesson() {
	      return this.lessons.sort(function compare(a, b) {
	        var dateA = new Date(a.event_time_start);
	        var dateB = new Date(b.event_time_start);
	        return dateA - dateB;
	      });
	    }
	  },
	  filters: {
	    showDateAndTime: function showDateAndTime(val) {
	      return (0, _moment2.default)(val).format('lll');
	    },
	    showWeek: function showWeek(date) {
	      return (0, _moment2.default)(date).isoWeek();
	    }
	  },
	  methods: {
	    checkForNotesAndSubstitutes: function checkForNotesAndSubstitutes(weekNums) {
	      var _this = this;
	
	      if (!this.deleteEvents) {
	        return;
	      }
	      var spinnerTimer = setTimeout(function () {
	        _this.isLoading = true;
	      }, 100);
	      this.lesson = [];
	      _docendo2.default.calendarCopyCheck(this.calId, this.selectedWeeks, function (data) {
	        clearTimeout(spinnerTimer);
	        _this.isLoading = false;
	        _this.lessons = data;
	      });
	    },
	    isSameDate: function isSameDate(index) {
	      if (index > 0) {
	        var l1 = this.sortedLesson[index].event_time_start;
	        var l2 = this.sortedLesson[index - 1].event_time_start;
	        return (0, _moment2.default)(l1).isoWeek() === (0, _moment2.default)(l2).isoWeek();
	      } else {
	        return false;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.selectedWeeks.length > 0) {
	      this.checkForNotesAndSubstitutes(this.selectedWeeks);
	    }
	  }
	};

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _CopyCalendarRotateDates = __webpack_require__(1471);
	
	var _CopyCalendarRotateDates2 = _interopRequireDefault(_CopyCalendarRotateDates);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, DModal: _DModal2.default, DateSelector: _DateSelector2.default, CopyCalendarRotateDates: _CopyCalendarRotateDates2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    calendarId: {
	      type: Number,
	      default: null
	    },
	    activeCalendarDate: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isDropdown: false,
	      numberOfDays: 5,
	      daysToCopy: [],
	      isSeeDates: false,
	      pasteDates: [],
	      sourceStartDate: (0, _moment2.default)(),
	      isLoading: false
	    };
	  },
	
	  computed: {
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    localActivatedSchoolYear: function localActivatedSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.localActivatedSchoolYear.id;
	    },
	    schoolId: function schoolId() {
	      return this.$store ? this.$store.getters.schoolId : window.SCHOOL.id;
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    isLoadingSchoolSettings: function isLoadingSchoolSettings() {
	      return this.$store.state.isLoadingSchoolSettings;
	    },
	    initStartPasteDate: function initStartPasteDate() {
	      var lastIdx = this.daysToCopy.length - 1;
	      var lastDate = this.daysToCopy[lastIdx]['date'];
	
	      if ((0, _moment2.default)(lastDate).isoWeekday() === 5) {
	        return (0, _moment2.default)(lastDate).add(3, 'days');
	      } else if ((0, _moment2.default)(lastDate).isoWeekday() === 6) {
	        return (0, _moment2.default)(lastDate).add(2, 'days');
	      } else {
	        return (0, _moment2.default)(lastDate).add(1, 'days');
	      }
	    }
	  },
	  watch: {
	    numberOfDays: function numberOfDays(newValue) {
	      var parsedValue = parseInt(newValue, 10);
	      if (isNaN(parsedValue)) {
	        this.numberOfDays = 1;
	      } else if (parsedValue > 12) {
	        this.numberOfDays = 12;
	      } else if (parsedValue < 1) {
	        this.numberOfDays = 1;
	      } else {
	        this.numberOfDays = parsedValue;
	      }
	    },
	    isLoadingSchoolSettings: function isLoadingSchoolSettings() {
	      this.readSavedSourceDates();
	    }
	  },
	  methods: {
	    setPasteDates: function setPasteDates(arr) {
	      this.pasteDates = arr;
	    },
	    addDay: function addDay() {
	      if (this.numberOfDays < 12) {
	        var lastDate = this.daysToCopy[this.daysToCopy.length - 1]['date'];
	        var nextDate = (0, _moment2.default)(lastDate).add(1, 'days').format('YYYY-MM-DD');
	        var day = { label: 'Day ' + (this.daysToCopy.length * 1 + 1), date: nextDate };
	        this.daysToCopy.push(day);
	        this.numberOfDays = this.daysToCopy.length;
	      }
	    },
	    subtractDay: function subtractDay() {
	      if (this.numberOfDays > 1) {
	        this.daysToCopy.pop();
	        this.numberOfDays = this.daysToCopy.length;
	      }
	    },
	    updateDaysToCopy: function updateDaysToCopy() {
	      var currentDate = this.sourceStartDate;
	      var newDaysToCopy = [];
	
	      for (var i = 0; i < this.numberOfDays; i++) {
	        var day = this.daysToCopy[i] || {};
	        var label = 'Day ' + (i + 1);
	        var date = day.date || (0, _moment2.default)(currentDate).add(i, 'days').format('YYYY-MM-DD');
	        newDaysToCopy.push({ label: label, date: date });
	      }
	      this.daysToCopy = newDaysToCopy;
	    },
	    toggleDropdown: function toggleDropdown() {
	      if (!this.isDropdown) {
	        this.openDropdown();
	      } else {
	        this.closeDropdown();
	      }
	    },
	    openDropdown: function openDropdown() {
	      this.$store.dispatch('readSchoolSettings');
	      this.isDropdown = true;
	    },
	    closeDropdown: function closeDropdown() {
	      if (!this.isDropdown) {
	        return;
	      }
	      this.isSeeDates = false;
	      this.isDropdown = false;
	    },
	    setDayToCopyDate: function setDayToCopyDate(date, index) {
	      this.daysToCopy[index].date = (0, _moment2.default)(date).format('YYYY-MM-DD');
	    },
	    saveSourceDates: function saveSourceDates() {
	      var sourceDates = this.daysToCopy.map(function (day) {
	        return day.date;
	      });
	      var saveObj = { rotating_schedules_source_dates: (0, _stringify2.default)(sourceDates) };
	      this.saveSchoolYearSetting(saveObj);
	    },
	    saveSchoolYearSetting: function saveSchoolYearSetting(obj) {
	      this.$store.dispatch('updateSchoolSettingsForSchoolYear', obj);
	    },
	    readSavedSourceDates: function readSavedSourceDates() {
	      var _this = this;
	
	      var settings = this.schoolSettings;
	      var schoolYearId = this.schoolYearId;
	      var propSchoolYear = 'school_year_' + schoolYearId;
	      var propName = 'rotating_schedules_source_dates';
	      if (settings && settings[propSchoolYear] && settings[propSchoolYear][propName]) {
	        var dates = JSON.parse(settings[propSchoolYear][propName]);
	        var arr = dates.map(function (date, i) {
	          return { label: 'Day ' + (i + 1), date: date };
	        });
	        this.numberOfDays = dates.length;
	        setTimeout(function (_) {
	          _this.daysToCopy = arr;
	        }, 0);
	      }
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      var sourceDates = this.daysToCopy.map(function (day) {
	        return day.date;
	      });
	      this.saveSourceDates();
	      var destinationDates = this.pasteDates.filter(function (day) {
	        return day.isIncluded;
	      }).map(function (day) {
	        return day.date;
	      });
	      _docendo2.default.calendarCopyDays(this.schoolId, this.calendarId, sourceDates, destinationDates, function (success) {
	        _eventbus2.default.toast = { text: 'Inserting days', 'success': true };
	        _this2.closeDropdown();
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    }
	  },
	  created: function created() {
	    this.updateDaysToCopy();
	  }
	};

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, Datepickerrange: _DatePickerRange2.default },
	  props: {
	    daysToCopy: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    schoolId: {},
	    initStartDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      startDate: (0, _moment2.default)(),
	      endDate: (0, _moment2.default)().add(1, 'days'),
	      vacationsDays: [],
	      datesBetween: [],
	      excludedDates: [],
	      isLoading: true
	    };
	  },
	
	  computed: {
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.activeSchoolYear.id;
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    groupedDatesByMonth: function groupedDatesByMonth() {
	      var groupedDates = {};
	
	      this.datesWithMeta.forEach(function (dateObj) {
	        var month = (0, _moment2.default)(dateObj.date).format('MMMM YYYY');
	        if (!groupedDates[month]) {
	          groupedDates[month] = {
	            dates: [],
	            emptyDays: 0
	          };
	          if (groupedDates[month].emptyDays < 0) {
	            groupedDates[month].emptyDays = 6;
	          }
	          var date = (0, _moment2.default)(dateObj.date);
	          var startOfWeek = date.clone().startOf('isoWeek');
	          var days = date.diff(startOfWeek, 'days');
	          groupedDates[month].emptyDays = days;
	        }
	        groupedDates[month].dates.push(dateObj);
	      });
	
	      return groupedDates;
	    },
	    datesWithMeta: function datesWithMeta() {
	      var _this = this;
	
	      var daysToCopyIndex = 0;
	
	      return this.datesBetween.map(function (dateObj) {
	        var dateMoment = (0, _moment2.default)(dateObj.date);
	        var isWeekend = dateMoment.day() === 6 || dateMoment.day() === 0;
	        var isVacationDay = _this.vacationsDays.includes(dateObj.date);
	        var isExcluded = _this.excludedDates.includes(dateObj.date);
	        var isIncluded = !isWeekend && !isVacationDay && !isExcluded;
	
	        var dayToInsert = null;
	        if (isIncluded) {
	          dayToInsert = _this.daysToCopy[daysToCopyIndex];
	          daysToCopyIndex = (daysToCopyIndex + 1) % _this.daysToCopy.length;
	        }
	
	        return (0, _extends3.default)({}, dateObj, {
	          isWeekend: isWeekend,
	          isVacationDay: isVacationDay,
	          isIncluded: isIncluded,
	          dayToInsert: dayToInsert
	        });
	      });
	    }
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear() {
	      this.onSchoolYearChanged();
	    },
	    datesWithMeta: function datesWithMeta() {
	      this.$emit('pasteDates', this.datesWithMeta);
	    }
	  },
	  methods: {
	    toggleDate: function toggleDate(dateObj) {
	      var idx = this.excludedDates.indexOf(dateObj.date);
	      if (idx < 0) {
	        this.excludedDates.push(dateObj.date);
	      } else {
	        this.excludedDates.splice(idx, 1);
	      }
	      this.saveExcludedDates(this.excludedDates);
	    },
	    saveExcludedDates: function saveExcludedDates(val) {
	      var propName = 'rotating_schedules_excluded_dates';
	      var saveObj = (0, _defineProperty3.default)({}, propName, (0, _stringify2.default)(val));
	      this.$store.dispatch('updateSchoolSettingsForSchoolYear', saveObj);
	    },
	    getExcludedDates: function getExcludedDates() {
	      var settings = this.schoolSettings;
	      var schoolYearId = this.schoolYearId;
	      var propSchoolYear = 'school_year_' + schoolYearId;
	      var propName = 'rotating_schedules_excluded_dates';
	      if (settings && settings[propSchoolYear] && settings[propSchoolYear][propName]) {
	        var arr = JSON.parse(settings[propSchoolYear][propName]);
	        this.excludedDates = arr;
	      }
	    },
	    createDatesBetween: function createDatesBetween() {
	      var start = (0, _moment2.default)(this.startDate);
	      var end = (0, _moment2.default)(this.endDate);
	      var dates = [];
	
	      while (start.isSameOrBefore(end)) {
	        dates.push({
	          date: start.format('YYYY-MM-DD'),
	          formattedDate: start.format('D')
	        });
	        start.add(1, 'days');
	      }
	      this.datesBetween = dates;
	    },
	    setStartDate: function setStartDate(date) {
	      this.setDates(date, null);
	    },
	    setEndDate: function setEndDate(date) {
	      this.setDates(null, date);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.startDate = start;
	      }
	      if (end) {
	        this.endDate = end;
	      }
	      this.createDatesBetween();
	    },
	    readVacationDays: function readVacationDays() {
	      var _this2 = this;
	
	      _docendo2.default.schoolVacationDaysRead(this.schoolId, function (success) {
	        _this2.vacationsDays = success.map(function (day) {
	          return day.day;
	        });
	        _this2.isLoading = false;
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    onSchoolYearChanged: function onSchoolYearChanged() {
	      if (this.activeSchoolYear) {
	        this.setDates(this.activeSchoolYear.student_time_start, this.activeSchoolYear.student_time_end);
	      }
	    },
	    initStartAndEndDate: function initStartAndEndDate() {
	      if (this.initStartDate && this.activeSchoolYear) {
	        this.setDates(this.initStartDate, this.activeSchoolYear.student_time_end);
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.initStartAndEndDate();
	  },
	  created: function created() {
	    this.readVacationDays();
	    this.getExcludedDates();
	  }
	};

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(80);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ChangeSchoolYear: _ChangeSchoolYear2.default, Modal: _Modal2.default },
	  data: function data() {
	    return {
	      showModal: false,
	      calendars: [],
	      calendarsWithText: [],
	      someWithSameName: false,
	      openedFromRoRSelect2: false
	    };
	  },
	
	  computed: {
	    isKindergarten: function isKindergarten() {
	      return this.$store.getters.isKindergarten;
	    },
	    calendarTypeIsWithSchoolYear: function calendarTypeIsWithSchoolYear() {
	      var typeHasSchoolYear = ['merge', 'other', 'kindergarten', 'club'];
	      return typeHasSchoolYear.indexOf(this.theCreateCalendarsType) > -1;
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    placeholderText: function placeholderText() {
	      switch (this.theCreateCalendarsType) {
	        case 'room':
	          return this.$t('vue2.createrooms.placeholder');
	        case 'other':
	          return this.$t('vue2.create_calendars.other_calendar_placeholder');
	        case 'merge':
	          return this.$t('vue2.createmerge.placeholder');
	        case 'club':
	          return 'Eks. SFO Mosehuset';
	      }
	    },
	    showInactiveButton: function showInactiveButton() {
	      if (this.calendarsWithText.length < 1) {
	        return true;
	      }
	    },
	    theCreateCalendarsType: function theCreateCalendarsType() {
	      return _eventbus2.default.createCalendarsType;
	    },
	    buttonText: function buttonText() {
	      if (this.calendarsWithText.length < 1) {
	        return this.$t('vue2.createusers.create');
	      } else {
	        var calendarsPluralized = this.calendarsWithText.length === 1 ? this.$t('vue2.createmerge.calendar') : this.$t('vue2.createmerge.calendars');
	        if (this.theCreateCalendarsType === 'room') {
	          calendarsPluralized = this.calendarsWithText.length === 1 ? this.$t('vue2.createrooms.room') : this.$t('vue2.createrooms.rooms');
	        }
	        return this.$t('vue2.createusers.create') + ' ' + this.calendarsWithText.length + ' ' + calendarsPluralized;
	      }
	    }
	  },
	  watch: {
	    theCreateCalendarsType: function theCreateCalendarsType() {
	      if (this.theCreateCalendarsType) {
	        this.setShowModal();
	      }
	    }
	  },
	  methods: {
	    setShowModal: function setShowModal() {
	      this.showModal = true;
	      this.pushNewCalendar();
	      this.pushNewCalendar();
	      this.pushNewCalendar();
	      setTimeout(function () {
	        document.querySelector('.namefield').focus();
	      }, 100);
	    },
	    setIsSameInputToFalse: function setIsSameInputToFalse() {
	      if (!this.someWithSameName) {
	        return;
	      } else {
	        this.someWithSameName = false;
	        this.calendars.forEach(function (obj) {
	          obj.isSameName = false;
	        });
	      }
	    },
	    setSameInput: function setSameInput(klassName) {
	      for (var i = 0; i < this.calendars.length; i++) {
	        if (this.calendars[i].name !== '') {
	          if (this.calendars[i].name === klassName) {
	            this.calendars[i].isSameName = true;
	          }
	        }
	      }
	    },
	    checkForSameNameInCalendars: function checkForSameNameInCalendars() {
	      var nbr = 0;
	      for (var i = 0; i < this.calendarsWithText.length; i++) {
	        for (var j = 0; j < this.calendarsWithText.length; j++) {
	          if (j !== i) {
	            if (this.calendarsWithText[i].name === this.calendarsWithText[j].name) {
	              this.setSameInput(this.calendarsWithText[i].name);
	              nbr++;
	            }
	          }
	        }
	      }
	      if (nbr > 0) {
	        this.someWithSameName = true;
	      } else {
	        this.someWithSameName = false;
	      }
	    },
	    setCloseModal: function setCloseModal() {
	      this.showModal = false;
	      _eventbus2.default.createCalendarsType = null;
	      this.calendars = [];
	      this.calendarsWithText = [];
	      this.someWithSameName = false;
	      this.openedFromRoRSelect2 = false;
	    },
	    pushNewCalendar: function pushNewCalendar() {
	      var _this = this;
	
	      this.calendars.push({
	        name: '',
	        type: this.theCreateCalendarsType,
	        isSameName: false
	      });
	      if (this.calendars.length > 4) {
	        setTimeout(function () {
	          _this.scrollInDiv();
	        }, 0);
	      }
	    },
	    removeCalendar: function removeCalendar(cal) {
	      this.calendars.splice(this.calendars.indexOf(cal), 1);
	      this.setIsSameInputToFalse();
	      this.checkForSameNameInCalendars();
	      this.checkAllForText();
	    },
	    scrollInDiv: function scrollInDiv() {
	      var objDiv = document.querySelector('.modal-body');
	      objDiv.scrollTop = objDiv.scrollHeight;
	    },
	    checkAllForText: function checkAllForText($event) {
	      if ($event && $event.key === 'Escape') {
	        this.setCloseModal();
	      }
	      this.setIsSameInputToFalse();
	      this.calendarsWithText = [];
	      for (var i = 0; i < this.calendars.length; i++) {
	        if (this.calendars[i].name.length > 0) {
	          this.calendarsWithText.push(this.calendars[i]);
	        }
	      }
	      if (this.calendarsWithText.length === this.calendars.length) {
	        this.pushNewCalendar();
	      }
	      this.checkForSameNameInCalendars();
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      var isOpenedFromRoRSelect2 = false;
	
	      if (this.openedFromRoRSelect2) {
	        isOpenedFromRoRSelect2 = true;
	      }
	      this.checkForSameNameInCalendars();
	      if (!this.someWithSameName) {
	        _eventbus2.default.toast = { text: this.$t('vue2.createrooms.creating'), 'success': false };
	        var calendarType = this.theCreateCalendarsType;
	        _docendo2.default.schoolBulkCreateCalendars(this.activeSchool.id, this.activeSchoolYear.id, this.calendarsWithText, function (success) {
	          _eventbus2.default.toast = { text: _this2.$t('vue2.createmerge.succes_text'), 'success': true };
	          _this2.$store.dispatch('getSchoolCalendars', _this2.activeSchool.id);
	
	          if (calendarType === 'merge') {
	            _this2.$store.dispatch('updateUserSettings', { 'setup_widget_progress_merge': true });
	            setTimeout(function () {
	              _this2.$store.commit('setOnboardingStep', 0);
	            }, 2500);
	          }
	
	          if (calendarType === 'room') {
	            _this2.$store.dispatch('updateUserSettings', { 'setup_widget_progress_rooms': true });
	            setTimeout(function () {
	              _this2.$store.commit('setOnboardingStep', 0);
	            }, 2500);
	            if (isOpenedFromRoRSelect2) {
	              _this2.$helpers.sendCustomEvt('vue_created_room', success[0].calendarable_id);
	            }
	          }
	          if (window.Intercom) {
	            window.Intercom('trackEvent', 'Created calendars: ' + _this2.theCreateCalendarsType);
	          }
	        }, function (errors) {
	          _eventbus2.default.toast = { text: _this2.$t('vue2.toast.something_went_wrong'), 'success': false };
	        });
	        this.setCloseModal();
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    window.addEventListener('vueCreateRoom', function (e) {
	      _this3.openedFromRoRSelect2 = true;
	      _this3.calendars.push({
	        name: e.detail,
	        type: 'room',
	        isSameName: false
	      });
	      _eventbus2.default.createRoomModal = true;
	      _this3.checkAllForText();
	    }, false);
	  }
	};

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(80);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _CreateKlassesSubjectList = __webpack_require__(1474);
	
	var _CreateKlassesSubjectList2 = _interopRequireDefault(_CreateKlassesSubjectList);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _StandardDurationSetting = __webpack_require__(382);
	
	var _StandardDurationSetting2 = _interopRequireDefault(_StandardDurationSetting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { StandardDurationSetting: _StandardDurationSetting2.default, Modal: _Modal2.default, ShowSubjects: _CreateKlassesSubjectList2.default, ChangeSchoolYear: _ChangeSchoolYear2.default },
	  data: function data() {
	    return {
	      showModal: false,
	      klasses: [],
	      showSubjects: false,
	      subjectsArrowPosition: 100,
	      activeKlassStep: 1,
	      klassStepIsSelected: false,
	      someWithSameName: false,
	      schoolCountry: 'dk',
	      isOpenDurationModal: false,
	      isAwaitingServerResponse: false,
	      debounceTimer: null,
	      klassIdCounter: 0
	    };
	  },
	
	  computed: {
	    showImportSubjects: function showImportSubjects() {
	      return this.schoolCountry === 'dk' || this.schoolCountry === 'no';
	    },
	    showInactiveButton: function showInactiveButton() {
	      if (this.alreadyCreatedKlassesToImportSubjectTo.length < 1) {
	        if (this.klassesToSubmit.length < 1) {
	          return true;
	        }
	      } else {
	        if (this.subjectsToCreateWhenAlreadyCreatedKlasses.length < 1) {
	          return true;
	        }
	      }
	    },
	    openFromOtherComponent: function openFromOtherComponent() {
	      return _eventbus2.default.createKlassModal;
	    },
	    alreadyCreatedKlassesToImportSubjectTo: function alreadyCreatedKlassesToImportSubjectTo() {
	      return _eventbus2.default.theKlassesToImportSubjectTo;
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    activeSchoolYears: function activeSchoolYears() {
	      return this.schoolYears.filter(function (year) {
	        return year.active;
	      });
	    },
	    selectedSchoolYear: function selectedSchoolYear() {
	      return this.activeSchoolYear.name;
	    },
	    country: function country() {
	      return window.SCHOOL.country;
	    },
	    stepNumbers: function stepNumbers() {
	      return this.country === 'NO' ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] : [1, 2, 3, 4, 5, 6, 7, 8, 9];
	    },
	    subjectsToCreateWhenAlreadyCreatedKlasses: function subjectsToCreateWhenAlreadyCreatedKlasses() {
	      return this.klasses.filter(function (klass) {
	        return klass.template;
	      }).map(function (cal) {
	        var klassObj = {
	          calendar_id: cal.calendarId,
	          step: cal.template
	        };
	        return klassObj;
	      });
	    },
	    klassesToSubmit: function klassesToSubmit() {
	      var klassesToSubmit = [];
	      for (var i = 0; i < this.klasses.length; i++) {
	        if (this.klasses[i].name.length > 0) {
	          klassesToSubmit.push({
	            'name': this.klasses[i].name,
	            'type': 'class',
	            'year': this.selectedSchoolYear,
	            'template': this.klasses[i].template.toString()
	          });
	        }
	      }
	      return klassesToSubmit;
	    },
	    buttonText: function buttonText() {
	      if (this.alreadyCreatedKlassesToImportSubjectTo.length < 1) {
	        if (this.klassesToSubmit.length < 1) {
	          return this.$t('vue2.createusers.create');
	        } else {
	          var klassesPluralized = this.klassesToSubmit.length === 1 ? this.$t('vue2.createklass.klass') : this.$t('vue2.createklass.klasses');
	          return this.$t('vue2.createusers.create') + ' ' + this.klassesToSubmit.length + ' ' + klassesPluralized;
	        }
	      } else {
	        return this.subjectsToCreateWhenAlreadyCreatedKlasses.length === 1 ? this.$t('vue2.createusers.create') : this.$t('vue2.createusers.create') + ' ' + this.$t('vue2.common.in') + ' ' + this.subjectsToCreateWhenAlreadyCreatedKlasses.length + ' ' + this.$t('vue2.createklass.klasses');
	      }
	    },
	    schoolYears: function schoolYears() {
	      return this.$store.state.schoolYears;
	    },
	    copySubjectsSchoolYearUrl: function copySubjectsSchoolYearUrl() {
	      if (this.activeSchoolYears.length < 2) {
	        return '#';
	      }
	      var sortedSchoolYears = this.activeSchoolYears.sort(function (a, b) {
	        return new Date(b.student_time_start) - new Date(a.student_time_start);
	      });
	      return '/schools/' + this.activeSchool.id + '/year_transfer/new?from_school_year_id=' + sortedSchoolYears[1].id + '&to_school_year_id=' + sortedSchoolYears[0].id;
	    },
	    isCourseImportSelected: function isCourseImportSelected() {
	      var isSelected = false;
	      this.klasses.forEach(function (klass) {
	        if (klass.template) {
	          isSelected = true;
	        }
	      });
	      return isSelected;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    isUserCanEditSchool: function isUserCanEditSchool() {
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf('can_manage_school') > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    }
	  },
	  watch: {
	    openFromOtherComponent: function openFromOtherComponent() {
	      if (this.openFromOtherComponent) {
	        this.setShowModal();
	      }
	    }
	  },
	  methods: {
	    submitOrSetDuration: function submitOrSetDuration() {
	      if (this.isCourseImportSelected && this.isUserCanEditSchool) {
	        this.isOpenDurationModal = true;
	      } else {
	        this.submitKlasses();
	      }
	    },
	    saveDuration: function saveDuration() {
	      this.submitKlasses();
	    },
	    setIsSameInputToFalse: function setIsSameInputToFalse() {
	      if (!this.someWithSameName) {
	        return;
	      } else {
	        this.someWithSameName = false;
	        this.klasses.forEach(function (obj) {
	          obj.isSameName = false;
	        });
	      }
	    },
	    setSameInputOnKlass: function setSameInputOnKlass(klassName) {
	      for (var i = 0; i < this.klasses.length; i++) {
	        if (this.klasses[i].name !== '') {
	          if (this.klasses[i].name === klassName) {
	            this.klasses[i].isSameName = true;
	          }
	        }
	      }
	    },
	    checkForSameNameInKlasses: function checkForSameNameInKlasses() {
	      var nbr = 0;
	      for (var i = 0; i < this.klassesToSubmit.length; i++) {
	        for (var j = 0; j < this.klassesToSubmit.length; j++) {
	          if (j !== i) {
	            if (this.klassesToSubmit[i].name === this.klassesToSubmit[j].name) {
	              this.setSameInputOnKlass(this.klassesToSubmit[i].name);
	              nbr++;
	            }
	          }
	        }
	      }
	      if (nbr > 0) {
	        this.someWithSameName = true;
	      } else {
	        this.someWithSameName = false;
	      }
	    },
	    mouseOverStep: function mouseOverStep(klassStep, event, klass) {
	      if (klass.template !== '') {
	        this.activeKlassStep = klass.template;
	        this.klassStepIsSelected = true;
	      } else {
	        this.activeKlassStep = klassStep;
	        this.klassStepIsSelected = false;
	      }
	      this.showSubjects = true;
	      var modalPxFromTop = document.querySelector('.modal-container').getBoundingClientRect().top;
	      var targetPxFromTop = event.target.getBoundingClientRect().top;
	      this.subjectsArrowPosition = targetPxFromTop - modalPxFromTop;
	    },
	    checkAllForText: function checkAllForText(klass, idx, text) {
	      var _this = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        _this.klasses[idx]['name'] = text;
	        _this.setIsSameInputToFalse();
	        _this.isTemplateButNotName(klass);
	        var klassesWithName = [];
	        for (var i = 0; i < _this.klasses.length; i++) {
	          if (_this.klasses[i].name.length > 0) {
	            klassesWithName.push(_this.klasses[i]);
	          }
	        }
	        if (klassesWithName.length === _this.klasses.length) {
	          _this.pushNewKlass();
	        }
	        _this.checkForSameNameInKlasses(klass);
	      }, 250);
	    },
	    addDeleteClass: function addDeleteClass(klass) {
	      var idx = this.klasses.findIndex(function (k) {
	        return k.id === klass.id;
	      });
	      if (idx > -1) {
	        this.klasses[idx].deleteClass = true;
	      }
	    },
	    removeDeleteClass: function removeDeleteClass(klass) {
	      var idx = this.klasses.findIndex(function (k) {
	        return k.id === klass.id;
	      });
	      if (idx > -1) {
	        this.klasses[idx].deleteClass = false;
	      }
	    },
	    setShowModal: function setShowModal() {
	      var _this2 = this;
	
	      this.klassStepIsSelected = false;
	      if (this.alreadyCreatedKlassesToImportSubjectTo.length < 1) {
	        this.pushNewKlass();
	        this.pushNewKlass();
	        this.pushNewKlass();
	        setTimeout(function () {
	          document.querySelector('.namefield').focus();
	        }, 100);
	      } else {
	        this.alreadyCreatedKlassesToImportSubjectTo.forEach(function (klass) {
	          _this2.pushExistingKlass(klass);
	        });
	      }
	      this.showModal = true;
	      window.setTimeout(function (_) {
	        if (document.querySelector('.import-klass') && document.querySelector('.modal-container')) {
	          var modalPxFromTop = document.querySelector('.modal-container').getBoundingClientRect().top;
	          var targetPxFromTop = document.querySelector('.import-klass').getBoundingClientRect().top;
	          _this2.subjectsArrowPosition = targetPxFromTop - modalPxFromTop;
	        }
	      }, 300);
	    },
	    pushNewKlass: function pushNewKlass() {
	      var _this3 = this;
	
	      this.klasses.push({
	        id: ++this.klassIdCounter,
	        name: '',
	        schoolYear: '',
	        template: '',
	        deleteClass: false,
	        isValid: true,
	        isSameName: false
	      });
	      if (this.klasses.length > 4) {
	        setTimeout(function () {
	          _this3.scrollInDiv();
	        }, 0);
	      }
	    },
	    pushExistingKlass: function pushExistingKlass(klass) {
	      this.klasses.push({
	        id: ++this.klassIdCounter,
	        calendarId: klass.id,
	        schoolId: klass.school_id,
	        name: klass.name,
	        template: '',
	        deleteClass: false,
	        isValid: true,
	        isSameName: false
	      });
	    },
	    isTemplateButNotName: function isTemplateButNotName(klass) {
	      var idx = this.klasses.findIndex(function (k) {
	        return k.id === klass.id;
	      });
	      if (idx < 0) return;
	      if (this.klasses[idx].template.length < 1) {
	        this.klasses[idx].isValid = true;
	      } else {
	        this.klasses[idx].isValid = this.klasses[idx].name.length > 0;
	      }
	    },
	    removeKlass: function removeKlass(klass) {
	      var idx = this.klasses.findIndex(function (k) {
	        return k.id === klass.id;
	      });
	      if (idx > -1) {
	        this.klasses.splice(idx, 1);
	      }
	      this.setIsSameInputToFalse();
	      this.checkForSameNameInKlasses();
	    },
	    setKlassImport: function setKlassImport(klass, value, event) {
	      var idx = this.klasses.findIndex(function (k) {
	        return k.id === klass.id;
	      });
	      if (idx < 0) return;
	      if (this.klasses[idx].template === value) {
	        this.klasses[idx].template = '';
	        this.klassStepIsSelected = false;
	        this.isTemplateButNotName(klass);
	      } else {
	        this.klasses[idx].template = value;
	        this.klassStepIsSelected = true;
	        this.activeKlassStep = klass.template;
	
	        if (this.klasses[idx].name.length < 1) {
	          document.querySelectorAll('.namefield')[idx].focus();
	        }
	        this.isTemplateButNotName(klass);
	      }
	    },
	    setCloseModal: function setCloseModal() {
	      this.showModal = false;
	      _eventbus2.default.createKlassModal = false;
	      this.klasses = [];
	      _eventbus2.default.theKlassesToImportSubjectTo = [];
	      this.isAwaitingServerResponse = false;
	    },
	    scrollInDiv: function scrollInDiv() {
	      var objDiv = document.querySelector('.modal-body');
	      objDiv.scrollTop = objDiv.scrollHeight;
	    },
	    submitKlasses: function submitKlasses() {
	      var _this4 = this;
	
	      if (this.alreadyCreatedKlassesToImportSubjectTo.length === 0) {
	        this.checkForSameNameInKlasses();
	        if (!this.someWithSameName) {
	          _docendo2.default.schoolBulkCreateCalendars(this.activeSchool.id, this.activeSchoolYear.id, this.klassesToSubmit, function (success) {
	            _eventbus2.default.toast = { text: _this4.$t('vue2.createklass.succes_text'), 'success': true };
	            _this4.$store.dispatch('getSchoolCalendars', _this4.activeSchool.id);
	            _this4.$store.dispatch('updateUserSettings', { 'setup_widget_progress_klass': true });
	            if (window.Intercom) {
	              window.Intercom('trackEvent', 'Created Classes');
	            }
	            var newSubjectsCreated = new window.CustomEvent('new_subjects_created', {
	              bubbles: true,
	              cancelable: true
	            });
	            window.document.dispatchEvent(newSubjectsCreated);
	
	            setTimeout(function () {
	              _this4.$store.commit('setOnboardingStep', 0);
	            }, 2500);
	          }, function (errors) {
	            _eventbus2.default.toast = { text: _this4.$t('vue2.toast.something_went_wrong'), 'success': false };
	          });
	          this.setCloseModal();
	        }
	      } else {
	        this.isAwaitingServerResponse = true;
	        _docendo2.default.calendarCreateNormSubjects(this.klasses[0].schoolId, this.subjectsToCreateWhenAlreadyCreatedKlasses, function (success) {
	          _eventbus2.default.toast = { text: _this4.$t('vue2.createklass.subjects_created_successfully'), 'success': true };
	          _this4.$store.dispatch('readSubjects', _this4.activeSchoolYear.id);
	          _this4.updateSubjectsIfInRORCalendar();
	          _this4.setCloseModal();
	        }, function (failure) {
	          _eventbus2.default.toast = { text: _this4.$t('vue2.toast.something_went_wrong'), 'success': false };
	          _this4.setCloseModal();
	        });
	      }
	    },
	    updateSubjectsIfInRORCalendar: function updateSubjectsIfInRORCalendar() {
	      var updateSidebarInROR = new window.CustomEvent('vueUpdateSidebarSubjects', { bubbles: true, cancelable: true });
	      window.document.dispatchEvent(updateSidebarInROR);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.schoolCountry = window.SCHOOL.country.toLowerCase();
	  }
	};

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Spinner = __webpack_require__(26);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Spinner: _Spinner2.default },
	  props: {
	    arrowPosition: {},
	    activeKlassStep: {
	      default: 1
	    },
	    klassStepIsSelected: {
	      default: false
	    },
	    country: {
	      default: 'dk'
	    }
	  },
	  filters: {
	    removeDecimal: function removeDecimal(number) {
	      return Math.round(number * 1);
	    }
	  },
	  computed: {
	    activeSubjects: function activeSubjects() {
	      var _this = this;
	
	      return this.subjects.filter(function (obj) {
	        return obj.step === _this.activeKlassStep.toString();
	      });
	    },
	    locale: function locale() {
	      return _moment2.default.locale();
	    },
	    classesNumberized: function classesNumberized() {
	      switch (this.activeKlassStep) {
	        case 1:
	          return 'st';
	        case 2:
	          return 'nd';
	        case 3:
	          return 'rd';
	        default:
	          return 'th';
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: true,
	      subjects: []
	    };
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    _docendo2.default.subjectNormsSchool(window.SCHOOL.id, function (data) {
	      _this2.subjects = data;
	      _this2.isLoading = false;
	    });
	  }
	};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  methods: {
	    open: function open() {
	      _eventbus2.default.createCalendarsType = 'room';
	    }
	  }
	};

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _SearchForCalendar = __webpack_require__(383);
	
	var _SearchForCalendar2 = _interopRequireDefault(_SearchForCalendar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Modal: _DModal2.default, SearchForCalendar: _SearchForCalendar2.default },
	  data: function data() {
	    return {
	      students: [],
	      isShowModal: false,
	      theCreateCalendarsType: 'student',
	      debounceTimer: null,
	      isCreateMultipleStudents: false,
	      theBulkStudentsStr: ''
	    };
	  },
	
	  computed: {
	    isShowTextAreaPlaceholder: function isShowTextAreaPlaceholder() {
	      return this.theBulkStudentsStr.length < 1;
	    },
	    theBulkStudentsArr: function theBulkStudentsArr() {
	      var arr = this.theBulkStudentsStr.length > 0 ? this.theBulkStudentsStr.split('\n') : [];
	      return arr.filter(function (studentName) {
	        return studentName.trim().length > 0;
	      });
	    },
	    isFeideActive: function isFeideActive() {
	      return false;
	    },
	    allStudents: function allStudents() {
	      return this.$store.getters.studentCalendars;
	    },
	    allFeideIds: function allFeideIds() {
	      var feideids = [];
	      this.allStudents.forEach(function (student) {
	        var feideId = student.custom_data['feide'];
	        if (feideId) {
	          var idx = feideids.indexOf(feideId);
	          if (idx < 0) {
	            feideids.push(feideId);
	          }
	        }
	      });
	      return feideids;
	    },
	    isFeideAlreadyCreated: function isFeideAlreadyCreated() {
	      var isCreated = false;
	      if (this.students[0] && this.students[0].feide && this.students[0].feide.length > 0) {
	        var idx = this.allFeideIds.indexOf(this.students[0].feide);
	        if (idx > -1) {
	          isCreated = true;
	        }
	      }
	      return isCreated;
	    },
	    studentsWithSameName: function studentsWithSameName() {
	      return this.students[0].name.length > 0;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    showInactiveButton: function showInactiveButton() {
	      if (this.studentsToSubmit.length < 1) {
	        return true;
	      }
	    },
	    studentsToSubmit: function studentsToSubmit() {
	      var studentsToSubmit = [];
	      if (this.isCreateMultipleStudents) {
	        this.theBulkStudentsArr.forEach(function (studentName) {
	          var studentObj = {
	            name: studentName,
	            type: 'student'
	          };
	          studentsToSubmit.push(studentObj);
	        });
	      } else {
	        for (var i = 0; i < this.students.length; i++) {
	          if (this.students[i].name.length > 0) {
	            var userobj = {
	              name: this.students[i].name,
	              type: 'student'
	            };
	            if (this.students[i].unilogin.length > 0) {
	              userobj.unilogin = this.students[i].unilogin;
	            }
	            if (this.students[i].feide.length > 0) {
	              userobj.feide = this.students[i].feide;
	            }
	            if (this.students[i].email.length > 0) {
	              userobj.email = this.students[i].email;
	            }
	            studentsToSubmit.push(userobj);
	          }
	        }
	      }
	      return studentsToSubmit;
	    }
	  },
	  methods: {
	    setIsShowModal: function setIsShowModal() {
	      this.isShowModal = true;
	      this.pushNewStudent();
	      window.setTimeout(function (_) {
	        var el = document.getElementById('studentname_0');
	        if (el) {
	          el.focus();
	        }
	      }, 400);
	    },
	    setCloseModal: function setCloseModal() {
	      this.isShowModal = false;
	      this.cleanForm();
	    },
	    cleanForm: function cleanForm() {
	      this.students = [];
	      this.theBulkStudentsStr = '';
	    },
	    pushNewStudent: function pushNewStudent() {
	      var _this = this;
	
	      this.students.push({
	        name: '',
	        type: this.theCreateCalendarsType,
	        isSameName: false,
	        unilogin: '',
	        feide: '',
	        email: ''
	      });
	      if (this.students.length > 4) {
	        setTimeout(function () {
	          _this.scrollInDiv();
	        }, 0);
	      }
	    },
	    scrollInDiv: function scrollInDiv() {
	      var objDiv = document.querySelector('.modal-body');
	      objDiv.scrollTop = objDiv.scrollHeight;
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      if (this.showInactiveButton) {
	        return;
	      }
	      var successText = this.studentsToSubmit.length > 1 ? this.$t('vue2.students.created_student') : this.$t('vue2.students.created_student');
	      _docendo2.default.schoolBulkCreateCalendars(window.SCHOOL.id, this.activeSchoolYear.id, this.studentsToSubmit, function (success) {
	        _eventbus2.default.toast = { text: successText, 'success': true };
	        _this2.cleanForm();
	        _this2.pushNewStudent();
	        _this2.$store.dispatch('getSchoolCalendars', window.SCHOOL.id);
	      }, function (errors) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    checkAllForText: function checkAllForText() {
	      this.usersWithText = [];
	      for (var i = 0; i < this.users.length; i++) {
	        if (this.users[i].name.length > 0) {
	          this.usersWithText.push(this.users[i]);
	        }
	      }
	      this.$emit('editedUsers', this.usersWithText);
	      if (this.usersWithText.length === this.users.length) {
	        this.pushNewUser();
	      }
	    },
	    validate: function validate(user, key) {
	      if (user.name.length >= 0) {
	        this.students[key].nameIsValid = true;
	      }
	      if (user.feide.length > 0 && user.name.length < 1) {
	        this.students[key].nameIsValid = false;
	      }
	    },
	    unValidate: function unValidate(user, key) {
	      this.users[key].nameIsValid = true;
	    }
	  }
	};

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(80);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _CreateUsersForm = __webpack_require__(1480);
	
	var _CreateUsersForm2 = _interopRequireDefault(_CreateUsersForm);
	
	var _SearchForCalendar = __webpack_require__(383);
	
	var _SearchForCalendar2 = _interopRequireDefault(_SearchForCalendar);
	
	var _randomNames = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Modal: _Modal2.default, createUserForm: _CreateUsersForm2.default, SearchForCalendar: _SearchForCalendar2.default },
	  computed: {
	    showInactiveButton: function showInactiveButton() {
	      if (this.usersToSubmit.length < 1) {
	        return true;
	      }
	    },
	    openFromOtherComponent: function openFromOtherComponent() {
	      return _eventbus2.default.createUserModal;
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    isTestSchool: function isTestSchool() {
	      return window.SCHOOL.id === 7272 || window.SCHOOL.id === 9111 || window.SCHOOL.id === 3;
	    },
	    isSchoolSystem: function isSchoolSystem() {
	      return this.$store.getters.isSchoolSystem;
	    },
	    country: function country() {
	      return this.$store.state.activeSchool.country;
	    },
	    usersToSubmit: function usersToSubmit() {
	      var usersToSubmit = [];
	      for (var i = 0; i < this.users.length; i++) {
	        if (this.users[i].name.length > 0) {
	          var userobj = {
	            name: this.users[i].name
	          };
	          if (this.users[i].unilogin.length > 0) {
	            userobj.unilogin = this.users[i].unilogin;
	          }
	          if (this.users[i].feide.length > 0) {
	            userobj.feide = this.users[i].feide;
	          }
	          if (this.users[i].email.length > 0) {
	            userobj.email = this.users[i].email;
	          }
	          usersToSubmit.push(userobj);
	        }
	      }
	      return usersToSubmit;
	    },
	    buttonText: function buttonText() {
	      if (this.usersToSubmit.length < 1) {
	        return this.$t('vue2.createusers.create');
	      }
	      var users = this.usersToSubmit.length === 1 ? this.$t('vue2.createusers.user') : this.$t('vue2.createusers.users');
	      return this.$t('vue2.createusers.create') + ' ' + this.usersToSubmit.length + ' ' + users;
	    }
	  },
	  data: function data() {
	    return {
	      showModal: false,
	      users: [],
	      pushNameFromSelect2: '',
	      openedFromRoRSelect2: false,
	      activeInputName: '',
	      showAutoUsersInput: false,
	      autoUsersCount: 20,
	      maxAutoUsers: 200
	    };
	  },
	
	  watch: {
	    openFromOtherComponent: function openFromOtherComponent() {
	      if (this.openFromOtherComponent) {
	        this.setShowModal();
	      }
	    }
	  },
	  methods: {
	    checkForDoubleNames: function checkForDoubleNames(name) {
	      this.activeInputName = name;
	    },
	    setUsers: function setUsers(users) {
	      this.users = users;
	    },
	    validateEmail: function validateEmail(user, email) {
	      if (email.length < 1) {
	        this.users[this.users.indexOf(user)].validEmail = true;
	      } else {
	        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	        this.users[this.users.indexOf(user)].validEmail = re.test(String(email).toLowerCase());
	      }
	    },
	    openAutoUsersInput: function openAutoUsersInput() {
	      var _this = this;
	
	      this.showAutoUsersInput = true;
	      this.$nextTick(function () {
	        _this.$refs.autoUsersCount.focus();
	      });
	    },
	    createAutoUsers: function createAutoUsers() {
	      var count = Math.min(Math.max(parseInt(this.autoUsersCount, 10) || 0, 0), this.maxAutoUsers);
	      if (count < 1) {
	        return;
	      }
	      var existingNames = (this.$store.state.allUsers || []).map(function (user) {
	        return user.name;
	      }).filter(Boolean);
	      this.createUsers((0, _randomNames.generateRandomNames)(count, existingNames).map(function (name) {
	        return { name: name };
	      }));
	    },
	    setShowModal: function setShowModal() {
	      this.showModal = true;
	    },
	    setCloseModal: function setCloseModal() {
	      this.showModal = false;
	      this.showAutoUsersInput = false;
	      _eventbus2.default.createUserModal = false;
	      this.users = [];
	      this.openedFromRoRSelect2 = false;
	    },
	    submitUsers: function submitUsers() {
	      this.createUsers(this.usersToSubmit);
	    },
	    createUsers: function createUsers(usersToSubmit) {
	      var _this2 = this;
	
	      var isOpenedFromRoRSelect2 = false;
	
	      if (this.openedFromRoRSelect2) {
	        isOpenedFromRoRSelect2 = true;
	      }
	      var successText = usersToSubmit.length > 1 ? this.$t('vue2.createusers.users_created') : this.$t('vue2.createusers.user_created');
	      _docendo2.default.schoolUsersCreate(this.activeSchool.id, usersToSubmit, function (success) {
	        _eventbus2.default.toast = { text: successText, 'success': true };
	        _this2.$store.dispatch('getSchoolCalendars', _this2.activeSchool.id);
	        _this2.$store.dispatch('updateUserSettings', { 'setup_widget_progress_users': true });
	        _this2.$store.dispatch('getUsers', _this2.activeSchool.id);
	        if (window.Intercom) {
	          window.Intercom('trackEvent', 'Created Users');
	        }
	        _eventbus2.default.createdId = success[0].id;
	        if (isOpenedFromRoRSelect2) {
	          _this2.$helpers.sendCustomEvt('vue_created_user', success[0].id);
	        }
	        if (_eventbus2.default.createUserModalROR) {
	          window.location.reload();
	        }
	
	        setTimeout(function () {
	          _this2.$store.commit('setOnboardingStep', 0);
	        }, 2500);
	      }, function (errors) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	      this.setCloseModal();
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    window.addEventListener('vueCreateUser', function (e) {
	      _this3.openedFromRoRSelect2 = true;
	      _this3.pushNameFromSelect2 = e.detail === null ? '' : e.detail;
	      _eventbus2.default.createUserModal = true;
	    }, false);
	  }
	};

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  methods: {
	    open: function open() {
	      _eventbus2.default.createUserModal = true;
	    }
	  }
	};

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  methods: {
	    open: function open() {
	      _eventbus2.default.createUserModal = true;
	      _eventbus2.default.createUserModalROR = true;
	    }
	  }
	};

/***/ }),
/* 515 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    country: {
	      default: 'dk'
	    },
	    pushname: {
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      users: [],
	      usersWithText: [],
	      userWithSameFeide: null,
	      debounceTimer: null
	    };
	  },
	
	  computed: {
	    allUsers: function allUsers() {
	      return this.$store.state.allUsers;
	    }
	  },
	  methods: {
	    getIsUserWithSameFeide: function getIsUserWithSameFeide(user) {
	      return this.userWithSameFeide && this.userWithSameFeide.email === user.feide;
	    },
	    pushNewUser: function pushNewUser() {
	      var _this = this;
	
	      this.users.push({
	        name: '',
	        nameIsValid: true,
	        unilogin: '',
	        feide: '',
	        email: '',
	        validEmail: true,
	        userHoverDanger: false
	      });
	      if (this.users.length > 4) {
	        setTimeout(function () {
	          _this.scrollInDiv();
	        }, 0);
	      }
	    },
	    setHoverDanger: function setHoverDanger(idx) {
	      this.users[idx].userHoverDanger = true;
	    },
	    removeHoverDanger: function removeHoverDanger(idx) {
	      this.users[idx].userHoverDanger = false;
	    },
	    removeUser: function removeUser(user) {
	      this.users.splice(this.users.indexOf(user), 1);
	      this.checkAllForText();
	    },
	    scrollInDiv: function scrollInDiv() {
	      var objDiv = document.querySelector('.modal-body');
	      objDiv.scrollTop = objDiv.scrollHeight;
	    },
	    validateEmail: function validateEmail(user, email, key) {
	      if (email.length < 1) {
	        this.users[key].validEmail = true;
	      } else {
	        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	        this.users[key].validEmail = re.test(String(email).toLowerCase());
	        if (re.test(String(email).toLowerCase())) {
	          this.validate(user, key);
	        }
	      }
	    },
	    checkEmailAndAllForText: function checkEmailAndAllForText(user, email, userIdx) {
	      var _this2 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        _this2.users[userIdx].email = email;
	        _this2.checkAllForText();
	        if (email.length < 1) {
	          _this2.users[_this2.users.indexOf(user)].validEmail = true;
	        }
	      }, 250);
	    },
	    checkAllForText: function checkAllForText(text, theType, userIdx) {
	      var _this3 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        if (theType === 'username') {
	          _this3.users[userIdx].name = text;
	          _this3.$emit('onNameInput', text);
	        }
	        if (theType === 'unilogin') {
	          _this3.users[userIdx].unilogin = text;
	        }
	        if (theType === 'feide') {
	          _this3.users[userIdx].feide = text;
	          _this3.checkIfAlreadyUsed(text, 'feide', userIdx);
	        }
	        _this3.usersWithText = [];
	        for (var i = 0; i < _this3.users.length; i++) {
	          if (_this3.users[i].name.length > 0) {
	            _this3.usersWithText.push(_this3.users[i]);
	          }
	        }
	        _this3.$emit('editedUsers', _this3.usersWithText);
	        if (_this3.usersWithText.length === _this3.users.length) {
	          _this3.pushNewUser();
	        }
	      }, 300);
	    },
	    checkIfAlreadyUsed: function checkIfAlreadyUsed(loginId, theType) {
	      if (theType === 'feide') {
	        var user = this.allUsers.filter(function (user) {
	          return user.email === loginId;
	        });
	        if (user.length > 0) {
	          this.userWithSameFeide = user[0];
	        } else {
	          this.userWithSameFeide = null;
	        }
	      }
	    },
	    validate: function validate(user, key) {
	      if (user.name.length >= 0) {
	        this.users[key].nameIsValid = true;
	      }
	      if (user.email.length > 0 && user.name.length < 1) {
	        this.users[key].nameIsValid = false;
	      }
	      if (this.country.toLowerCase() === 'dk') {
	        if (user.unilogin.length > 0 && user.name.length < 1) {
	          this.users[key].nameIsValid = false;
	        }
	      } else if (this.country.toLowerCase() === 'no') {
	        if (user.feide.length > 0 && user.name.length < 1) {
	          this.users[key].nameIsValid = false;
	        }
	      }
	    },
	    unValidate: function unValidate(user, key) {
	      this.users[key].nameIsValid = true;
	    }
	  },
	  mounted: function mounted() {
	    var i = 0;
	    if (this.pushname.length > 1) {
	      this.users.push({
	        name: this.pushname,
	        nameIsValid: true,
	        unilogin: '',
	        feide: '',
	        email: '',
	        validEmail: true,
	        userHoverDanger: false
	      });
	      this.checkAllForText();
	      i = 2;
	    }
	    for (i; i < 3; i++) {
	      this.pushNewUser();
	      this.$emit('editedUsers', this.usersWithText);
	      setTimeout(function () {
	        document.querySelector('.namefield').focus();
	      }, 100);
	    }
	  }
	};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(9);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    show: {
	      type: Boolean,
	      default: false
	    },
	
	    close_on_click_away: {
	      type: Boolean,
	      default: false
	    },
	    show_modal_mask: {
	      type: Boolean,
	      default: true
	    },
	    show_modal_sidebar: {
	      type: Boolean,
	      default: false
	    }
	  },
	  watch: {
	    show: function show() {
	      var body = document.querySelector('body');
	      if (this.show) {
	        _eventbus2.default.createModalOpen = true;
	        body.classList.add('no-scroll');
	      } else {
	        this.removeModal();
	      }
	    }
	  },
	  methods: {
	    setShowModal: function setShowModal() {
	      this.show = true;
	    },
	    removeModal: function removeModal() {
	      var body = document.querySelector('body');
	      this.$emit('close');
	      body.classList.remove('no-scroll');
	      _eventbus2.default.createModalOpen = false;
	    },
	    clickAway: function clickAway() {
	      this.close_on_click_away ? this.removeModal() : null;
	    }
	  },
	  mounted: function mounted() {
	    this._keyListener = function (e) {
	      if (e.key === 'Escape') {
	        if (e.target.tagName.toUpperCase() === 'BODY') {
	          this.removeModal();
	        }
	      }
	    };
	    document.addEventListener('keydown', this._keyListener.bind(this));
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this._keyListener);
	  }
	};

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CreateTaskForm = __webpack_require__(1482);
	
	var _CreateTaskForm2 = _interopRequireDefault(_CreateTaskForm);
	
	var _CreateTaskNewSubject = __webpack_require__(1483);
	
	var _CreateTaskNewSubject2 = _interopRequireDefault(_CreateTaskNewSubject);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { CreateTaskNewSubject: _CreateTaskNewSubject2.default, CreateTaskForm: _CreateTaskForm2.default },
	  props: {
	    user: {
	      type: Object,
	      default: null
	    },
	    initDate: {
	      type: Object,
	      default: (0, _moment2.default)()
	    },
	    emitEvent: {
	      type: Boolean,
	      default: false
	    },
	    showSubstituteOption: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      date: (0, _moment2.default)(),
	      theCreateNewSubjectName: null,
	      theNewlyCreatedSubject: null
	    };
	  },
	
	  methods: {
	    onCreatedEvent: function onCreatedEvent(lesson) {
	      var initDate = this.initDate;
	
	      var eventStart = lesson.start;
	      var eventEnd = lesson.end;
	
	      var initDateMoment = (0, _moment2.default)(initDate);
	      var eventStartMoment = (0, _moment2.default)(eventStart);
	      var eventEndMoment = (0, _moment2.default)(eventEnd);
	
	      var isStartDateSame = eventStartMoment.isSame(initDateMoment, 'day');
	      var isEndDateSame = eventEndMoment.isSame(initDateMoment, 'day');
	      if (this.emitEvent) {
	        this.$emit('addANewEvent', lesson);
	        return;
	      }
	      if (isStartDateSame && isEndDateSame) {
	        this.$store.commit('addANewEvent', lesson);
	      }
	    },
	    setDate: function setDate(mom) {
	      this.date = mom;
	    },
	    setCreateNewSubject: function setCreateNewSubject(str) {
	      this.theCreateNewSubjectName = str;
	    },
	    onNewSubject: function onNewSubject(subject) {
	      this.theNewlyCreatedSubject = subject;
	      this.setCreateNewSubject(null);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.date = this.initDate;
	  }
	};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _TimeChanger = __webpack_require__(31);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { dSelect: _DSelect2.default, DModal: _DModal2.default, TimeChanger: _TimeChanger2.default, DateSelector: _DateSelector2.default, AppToggle: _AppToggle2.default },
	  props: {
	    user: {
	      type: Object,
	      default: function _default() {
	        return {
	          name: 'Henrik',
	          user_calendar_id: 7
	        };
	      }
	    },
	    date: {
	      type: Object,
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    theNewlyCreatedSubject: {
	      type: Object,
	      default: null
	    },
	    showSubstituteOption: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isLoadingSubject: false,
	      subjects: [],
	      startTime: (0, _moment2.default)().set({ 'hour': 8, 'minutes': 0 }),
	      endTime: (0, _moment2.default)().set({ 'hour': 8, 'minutes': 45 }),
	      selectedSubject: null,
	      isSubmitting: false,
	      theSearchText: '',
	      theNewSubject: null,
	      isShowCreateSubjectButton: false,
	      isSetAsSubstitute: this.showSubstituteOption
	    };
	  },
	
	  computed: {
	    isValidated: function isValidated() {
	      return this.selectedSubject;
	    },
	    filteredSubjects: function filteredSubjects() {
	      return this.subjects.filter(function (subject) {
	        return subject.subject_type !== 'absence';
	      });
	    },
	    sortedSubjects: function sortedSubjects() {
	      var _this = this;
	
	      return this.filteredSubjects.map(function (subject) {
	        var translatedSubjectType = _this.$t('vue2.eventTypes.' + subject.subject_type);
	
	        var vSubjectType = translatedSubjectType === 'vue2.eventTypes.' + subject.subject_type ? subject.subject_type : translatedSubjectType;
	
	        return (0, _extends3.default)({}, subject, {
	          vSubjectType: vSubjectType
	        });
	      }).sort(function (a, b) {
	        if (a.name < b.name) return -1;
	        if (a.name > b.name) return 1;
	        return 0;
	      });
	    },
	    dbEventStart: function dbEventStart() {
	      var date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      var time = this.startTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    dbEventEnd: function dbEventEnd() {
	      var date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      var time = this.endTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    }
	  },
	  watch: {
	    theNewlyCreatedSubject: function theNewlyCreatedSubject(val) {
	      this.readSubjects();
	    }
	  },
	  methods: {
	    setDate: function setDate(date) {
	      this.$emit('setDate', date);
	    },
	    onCloseDSelect: function onCloseDSelect() {
	      this.isShowCreateSubjectButton = false;
	    },
	    setIsShowCreateSubjectButton: function setIsShowCreateSubjectButton() {
	      var _this2 = this;
	
	      var idx = this.filteredSubjects.findIndex(function (subject) {
	        return subject.name === _this2.theSearchText;
	      });
	      this.isShowCreateSubjectButton = this.theSearchText.length > 0 && idx < 0;
	    },
	    onSearchTextDebounced: function onSearchTextDebounced() {
	      this.setIsShowCreateSubjectButton();
	    },
	    onCreateNewSubject: function onCreateNewSubject() {
	      this.$emit('createNewSubject', this.theSearchText);
	      this.theSearchText = '';
	    },
	    setTheSearchText: function setTheSearchText(str) {
	      this.theSearchText = str;
	    },
	    setSubject: function setSubject(arr) {
	      this.selectedSubject = arr[0];
	    },
	    setStartTime: function setStartTime(payload) {
	      this.startTime = payload;
	    },
	    setEndTime: function setEndTime(payload) {
	      this.endTime = payload;
	    },
	    readSubjects: function readSubjects() {
	      var _this3 = this;
	
	      this.isLoadingSubject = true;
	      _docendo2.default.sidebar(this.user.user_calendar_id, this.date, function (success) {
	        _this3.isLoadingSubject = false;
	        _this3.subjects = success;
	        _this3.$nextTick(function (_) {
	          if (_this3.theNewlyCreatedSubject) {
	            _this3.theNewSubject = _this3.theNewlyCreatedSubject;
	          }
	        });
	      }, function (failure) {
	        console.log('something went wrong');
	      });
	    },
	    submit: function submit() {
	      var _this4 = this;
	
	      var schoolId = this.selectedSubject.school_id;
	      var calendarId = this.selectedSubject.calendar_id;
	      var calendarIds = [calendarId];
	      var subjectId = this.selectedSubject.id;
	      var internalNote = '';
	      this.isSubmitting = true;
	      var options = {};
	      if (this.isSetAsSubstitute) {
	        options.substituteCalendarIds = [this.user.user_calendar_id];
	      }
	      _docendo2.default.createEvent(schoolId, calendarId, calendarIds, subjectId, this.dbEventStart, this.dbEventEnd, '', '', '', internalNote, options, function (data) {
	        if (data && data.status === 'error') {
	          _eventbus2.default.toast = { text: data.message, 'success': false };
	          _this4.$emit('close');
	          return;
	        }
	        var lesson = JSON.parse(data);
	        _this4.$emit('onCreatedEvent', lesson);
	        if (_this4.isSetAsSubstitute) {
	          _this4.$store.dispatch('getUserSubPools');
	        }
	        _this4.$emit('close');
	        _eventbus2.default.toast = { text: _this4.$t('vue2.create_activity.created'), 'success': true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readSubjects();
	    setTimeout(function (_) {
	      var el = document.querySelector('#d-create-task-for-user .d-select__input-look > input[type="search"]');
	      if (el) {
	        el.focus();
	      }
	    }, 400);
	  }
	};

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SubjectFormSubjectType = __webpack_require__(61);
	
	var _SubjectFormSubjectType2 = _interopRequireDefault(_SubjectFormSubjectType);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { SubjectFormSubjectType: _SubjectFormSubjectType2.default, dSelect: _DSelect2.default, DModal: _DModal2.default },
	  props: {
	    title: {
	      type: String
	    },
	    user: {
	      type: Object,
	      default: function _default() {
	        return {
	          name: 'Henrik',
	          user_calendar_id: 7
	        };
	      }
	    },
	    date: {
	      type: Object,
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      subjectName: '',
	      subjectType: '',
	      isSubmitting: false,
	      theActiveSchoolId: null,
	      userSchools: [],
	      isLoadingUserSchools: false
	    };
	  },
	
	  computed: {
	    isValidated: function isValidated() {
	      return this.subjectName.length > 0;
	    },
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    isUserHasMultipleSchools: function isUserHasMultipleSchools() {
	      return (0, _keys2.default)(this.userSchools).length > 1;
	    }
	  },
	  methods: {
	    setSubjectType: function setSubjectType(str) {
	      this.subjectType = str;
	    },
	    findSchoolYearId: function findSchoolYearId() {
	      if (this.activeSchoolYears.length === 1) {
	        return this.activeSchoolYears[0].id;
	      }
	      var givenDate = (0, _moment2.default)(this.date);
	
	      var overlappingSchoolYears = this.activeSchoolYears.filter(function (year) {
	        var start = (0, _moment2.default)(year.employee_time_start);
	        var end = (0, _moment2.default)(year.employee_time_end);
	        return givenDate.isBetween(start, end, undefined, '[]');
	      });
	
	      if (overlappingSchoolYears.length > 0) {
	        var latestSchoolYear = overlappingSchoolYears.reduce(function (latest, current) {
	          var latestEnd = (0, _moment2.default)(latest.employee_time_end);
	          var currentEnd = (0, _moment2.default)(current.employee_time_end);
	          return currentEnd.isAfter(latestEnd) ? current : latest;
	        }, overlappingSchoolYears[0]);
	
	        return latestSchoolYear.id;
	      } else {
	        _eventbus2.default.toast = { text: this.$t('vue2.create_activity.the_selected_date_is_outside_schoolyears'), 'success': false };
	        return null;
	      }
	    },
	    submit: function submit() {
	      var _this = this;
	
	      var calendarId = this.user.user_calendar_id;
	      var schoolYearId = this.findSchoolYearId();
	      if (!schoolYearId) {
	        return;
	      }
	      var schoolId = this.theActiveSchoolId;
	      var color = '#999999';
	      var duration = 45;
	      var preparation = null;
	      var calendarIds = [];
	      var subjectCode = null;
	      this.isSubmitting = true;
	      _docendo2.default.createSubject(this.subjectName, color, calendarId, duration, preparation, 0, this.subjectType, schoolId, schoolYearId, calendarIds, subjectCode, false, null, null, null, function (data) {
	        if (data && data.status === 'error') {
	          _eventbus2.default.toast = { text: data.message, 'success': false };
	          return;
	        }
	        _this.$emit('newSubject', data);
	      }, function (failure) {
	        console.log('failed');
	      });
	    },
	    readUser: function readUser() {
	      var _this2 = this;
	
	      _docendo2.default.showUser(this.user.id, function (data) {
	        _this2.userSchools = data && data.schools ? data.schools.sort(function (a, b) {
	          return a.name.localeCompare(b.name);
	        }) : [];
	      }, function (failure) {});
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.readUser();
	    this.subjectName = this.title;
	    this.theActiveSchoolId = this.activeSchool.id;
	    this.$nextTick(function (_) {
	      var el = _this3.$refs.d_title_input;
	      if (el) {
	        _this3.$refs.d_title_input.click();
	        _this3.$refs.d_title_input.focus();
	      }
	    });
	  }
	};

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DCalendarDay = __webpack_require__(1485);
	
	var _DCalendarDay2 = _interopRequireDefault(_DCalendarDay);
	
	var _DCalendarDayDraggable = __webpack_require__(1486);
	
	var _DCalendarDayDraggable2 = _interopRequireDefault(_DCalendarDayDraggable);
	
	var _DCalendarSubjects = __webpack_require__(1494);
	
	var _DCalendarSubjects2 = _interopRequireDefault(_DCalendarSubjects);
	
	var _DCalendarDraggedSubject = __webpack_require__(1487);
	
	var _DCalendarDraggedSubject2 = _interopRequireDefault(_DCalendarDraggedSubject);
	
	var _DCalendarList = __webpack_require__(1489);
	
	var _DCalendarList2 = _interopRequireDefault(_DCalendarList);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DCalendarList: _DCalendarList2.default,
	    DCalendarDraggedSubject: _DCalendarDraggedSubject2.default,
	    DCalendarSubjects: _DCalendarSubjects2.default,
	    DCalendarDay: _DCalendarDay2.default,
	    Loader: _Loader2.default,
	    DCalendarDayDraggable: _DCalendarDayDraggable2.default,
	    ModalConfirmation: _ModalConfirmation2.default
	  },
	  props: {
	    calendar: {
	      type: Object,
	      default: null
	    },
	    calendarId: {
	      default: 7
	    },
	    calendarName: {
	      default: ''
	    },
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    isMultiCalendar: {
	      type: Boolean,
	      default: false
	    },
	    showSidebar: {
	      type: Boolean,
	      default: true
	    },
	    isShowWeek: {
	      type: Boolean,
	      default: true
	    },
	    isShowWeekends: {
	      type: Boolean,
	      default: false
	    },
	    firstDayOfWeek: {
	      type: Number,
	      default: 1
	    },
	    startTime: {
	      default: '06:00:00'
	    },
	    endTime: {
	      default: '16:00:00'
	    },
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isLoadingEvents: {
	      type: Boolean,
	      default: false
	    },
	    isEventsClickable: {
	      type: Boolean,
	      default: false
	    },
	    isEditable: {
	      type: Boolean,
	      default: false
	    },
	    isLocked: {
	      type: Boolean,
	      default: false
	    },
	    isCalendarInPrintMode: {
	      type: Boolean,
	      default: false
	    },
	    isShowStudents: {
	      type: Boolean,
	      default: false
	    },
	    isShowAsList: {
	      type: Boolean,
	      default: false
	    },
	    isHideHeader: {
	      type: Boolean,
	      default: false
	    },
	    initNumberOfDays: {
	      default: null
	    },
	    isCalNoBgColors: {
	      type: Boolean,
	      default: false
	    },
	    eventFontSize: {
	      default: 10
	    },
	    isAbsenceEditable: {
	      type: Boolean,
	      default: true
	    },
	    isHideCalendars: {
	      type: Boolean,
	      default: false
	    },
	    isHideDates: {
	      type: Boolean,
	      default: false
	    },
	    isCopyCalendarModalOpen: {
	      type: Boolean,
	      default: false
	    },
	    showGrid: {
	      type: Boolean,
	      default: false
	    },
	    ringingSet: {
	      type: Object,
	      default: function _default() {
	        return null;
	      }
	    },
	    localeOverride: {
	      type: String,
	      default: null
	    },
	
	    isMoveOnly: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      slotHeight: 40,
	      slotWidth: 50,
	
	      defaultRingingSet: {
	        id: 'default',
	        name: 'Default ringetider',
	        dayStart: '08:00',
	        dayEnd: '16:00',
	        slots: [{ start: '08:00', end: '08:45' }, { start: '08:45', end: '09:30' }, { start: '09:30', end: '10:00' }, { start: '10:00', end: '10:45' }, { start: '10:45', end: '11:30' }, { start: '11:30', end: '12:00' }, { start: '12:00', end: '12:45' }, { start: '12:45', end: '13:30' }, { start: '13:30', end: '14:15' }, { start: '14:15', end: '15:00' }, { start: '15:00', end: '15:45' }]
	      },
	      hoveredSlotIndex: null,
	      i18n: {
	        da: {
	          week: 'Uge',
	          lesson: 'lektion',
	          lessons: 'lektioner'
	        },
	        nb: {
	          week: 'Uke',
	          lesson: 'time',
	          lessons: 'timer'
	        },
	        en: {
	          week: 'W ',
	          lesson: 'lesson',
	          lessons: 'lessons'
	        }
	      },
	      activeEvent: null,
	      theDragLesson: null,
	      movedX: 0,
	      movedY: 0,
	      dragEventY: 0,
	      dragEventHeight: 0,
	      dragActiveDate: null,
	      dragActiveDates: [],
	      dragEventStart: (0, _moment2.default)(),
	      dragEventEnd: (0, _moment2.default)(),
	      isResizingEvent: false,
	      isSideResizingEvent: false,
	      isDraggingEvent: false,
	      isDraggingExternalEvent: false,
	      theExternalEvent: null,
	      theExternalEventBCR: null,
	      isWindowResizingTimer: null,
	      deleteSubject: null,
	      theDeleteEvent: null,
	      isDeleteSubjectOverSubjects: false,
	      isConfirmDeleteModal: false,
	      isSelectionDeleteDrag: false,
	      calendarDOMUuid: this.generateUUID()
	    };
	  },
	
	  computed: {
	    school: function school() {
	      return this.$store && this.$store.state ? this.$store.state.activeSchool : null;
	    },
	    locale: function locale() {
	      if (this.localeOverride) {
	        return this.localeOverride;
	      }
	      return this.$store && this.$store.getters ? this.$store.getters.locale : 'da';
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store && this.$store.getters ? this.$store.getters.allCalendarsInHash : {};
	    },
	    userSchools: function userSchools() {
	      return this.$store && this.$store.getters ? this.$store.getters.userSchools : {};
	    },
	    eventsWithMetaData: function eventsWithMetaData() {
	      var _this = this;
	
	      return this.events.map(function (lesson) {
	        var dLesson = (0, _extends3.default)({}, lesson);
	
	        if (lesson.rendering) {
	          return (0, _extends3.default)({}, lesson, {
	            event_starttime: '',
	            event_endtime: '',
	            event_key: _this.generateUUID(),
	            has_notes: false,
	            has_substitute: false,
	            group: '',
	            teacher: '',
	            v_teachers_arr: [],
	            room: '',
	            substitutes: '',
	            eventDuration: 0,
	            v_other_school: false,
	            v_is_editable: false,
	            v_sort_key: ''
	          });
	        }
	
	        var getHighestMinutesClassName = function getHighestMinutesClassName(calendars) {
	          var highestMinutesCalendar = calendars.reduce(function (highest, calendar) {
	            if (calendar.calendar_type === 'klass' && (!highest || calendar.minutes > highest.minutes)) {
	              return calendar;
	            }
	            return highest;
	          }, null);
	
	          return highestMinutesCalendar ? highestMinutesCalendar.name : '';
	        };
	
	        var cleanText = function cleanText(content) {
	          return content ? content.replace(/<(?:.|\n)*?>/gm, '') : '';
	        };
	
	        var teacherNotes = cleanText(dLesson.teacher_notes);
	        var hasNotes = teacherNotes || cleanText(dLesson.description) || cleanText(dLesson.notes_for_students) || cleanText(dLesson.learning_goal);
	
	        var groups = [];
	        var rooms = [];
	        var teachers = [];
	        var students = [];
	        var substitutes = [];
	        var hasSubstitutes = false;
	        var eventActiveCalendarDuration = 0;
	
	        eventActiveCalendarDuration = 0;(dLesson.calendars || []).forEach(function (calendar) {
	          if (calendar.calendar_id === _this.calendarId) {
	            eventActiveCalendarDuration = calendar.minutes;
	          }
	
	          var name = calendar.name;
	          switch (calendar.calendar_type) {
	            case 'klass':
	              if (calendar.calendar_id !== _this.calendarId) groups.push(name);
	              break;
	            case 'room':
	              if (calendar.calendar_id !== _this.calendarId) rooms.push(name);
	              break;
	            case 'user':
	              if (calendar.substitute || calendar.is_substitute) {
	                hasSubstitutes = true;
	                substitutes.push(name);
	              } else if (calendar.calendar_id !== _this.calendarId) {
	                teachers.push(name);
	              }
	              break;
	            case 'student':
	              if (calendar.calendar_id !== _this.calendarId) students.push(name);
	              break;
	          }
	        });
	
	        var className = getHighestMinutesClassName(dLesson.calendars || []);
	
	        var updatedLesson = (0, _extends3.default)({}, lesson, {
	          event_starttime: (0, _moment2.default)(dLesson.start).locale(_this.locale).format('LT'),
	          event_endtime: (0, _moment2.default)(dLesson.end).locale(_this.locale).format('LT'),
	          event_key: dLesson.v_overlay_key ? dLesson.v_overlay_key : _this.calendarId + '_' + dLesson.event_id,
	          has_notes: !!hasNotes,
	          has_substitute: hasSubstitutes,
	          group: groups.join(', '),
	          teacher: teachers.join(', '),
	          room: rooms.join(', '),
	          substitutes: substitutes.join(', '),
	          eventDuration: eventActiveCalendarDuration,
	          v_other_school: _this.getIsEventOtherSchool(lesson),
	          v_is_editable: _this.getIsEventEditable(lesson),
	          v_sort_key: className,
	          v_other_calendar: _this.calendarId * 1 !== lesson.calendar_id && (_this.allCalendarsInHash[lesson.calendar_id] || true)
	        });
	
	        if (_this.isShowStudents) {
	          updatedLesson.students = students.join(', ');
	        }
	
	        return updatedLesson;
	      });
	    },
	    isLocaleEn: function isLocaleEn() {
	      return this.locale === 'en';
	    },
	    calStartHour: function calStartHour() {
	      return this.startTime.slice(0, 2) !== '00' ? this.startTime.slice(0, 2) : '01';
	    },
	    calEndHour: function calEndHour() {
	      return this.endTime.slice(0, 2);
	    },
	    calStartTime: function calStartTime() {
	      return (0, _moment2.default)().set({ hour: this.calStartHour, minutes: 0, seconds: 0 });
	    },
	    calEndTime: function calEndTime() {
	      return (0, _moment2.default)().set({ hour: this.calEndHour, minutes: 0, seconds: 0 });
	    },
	    theWeekNumber: function theWeekNumber() {
	      return (0, _moment2.default)(this.date).isoWeek();
	    },
	    numberOfDays: function numberOfDays() {
	      if (this.initNumberOfDays) {
	        return this.initNumberOfDays;
	      }
	      if (this.isShowWeek) {
	        if (this.isShowWeekends) {
	          return this.firstDayOfWeek + 6;
	        } else {
	          return this.firstDayOfWeek + 4;
	        }
	      } else {
	        return 1;
	      }
	    },
	    days: function days() {
	      var currentLocale = this.locale;
	      var correctDates = [];
	      var days = [];
	      if (this.isShowWeek) {
	        for (var i = this.firstDayOfWeek; i <= this.numberOfDays; i++) {
	          var date = (0, _moment2.default)(this.date).isoWeekday(i);
	          var dateObj = {
	            day: date,
	            date: this.getShowDate(date),
	            isToday: (0, _moment2.default)().format('YYYY-MM-DD') === (0, _moment2.default)(date).format('YYYY-MM-DD'),
	            dayName: (0, _moment2.default)(date).locale(currentLocale).format('dddd')
	          };
	          correctDates.push(dateObj);
	          days.push(date);
	        }
	      } else {
	        var _date = (0, _moment2.default)(this.date);
	        var _dateObj = {
	          day: _date,
	          date: this.getShowDate(_date),
	          isToday: (0, _moment2.default)().format('YYYY-MM-DD') === (0, _moment2.default)(_date).format('YYYY-MM-DD')
	        };
	        correctDates.push(_dateObj);
	        days.push(_date);
	      }
	      this.$emit('dates', days);
	      return correctDates;
	    },
	    hours: function hours() {
	      var hours = [];
	      var diffInHours = this.calEndHour * 1 - this.calStartHour * 1;
	      for (var i = 0; i <= diffInHours; i++) {
	        hours.push((0, _moment2.default)(this.calStartTime).add(i, 'hours'));
	      }
	      return hours;
	    },
	    hoursInLocale: function hoursInLocale() {
	      var _this2 = this;
	
	      var localeHours = [];
	      this.hours.forEach(function (h) {
	        localeHours.push((0, _moment2.default)(h).locale(_this2.locale).format('LT'));
	      });
	      return localeHours;
	    },
	    isMobile: function isMobile() {
	      return this.$store && this.$store.state ? this.$store.state.isDeviceMobile : false;
	    },
	    activeRingingSet: function activeRingingSet() {
	      return this.ringingSet || this.defaultRingingSet;
	    },
	    gridSlots: function gridSlots() {
	      var _this3 = this;
	
	      if (!this.showGrid || !this.activeRingingSet) {
	        return [];
	      }
	      var slots = this.activeRingingSet.slots;
	      var calStartMinutes = this.parseTimeToMinutes(this.calStartHour + ':00');
	      var calEndMinutes = this.parseTimeToMinutes(this.calEndHour + ':00');
	
	      return slots.map(function (slot, index) {
	        var startMinutes = _this3.parseTimeToMinutes(slot.start);
	        var endMinutes = _this3.parseTimeToMinutes(slot.end);
	
	        if (endMinutes <= calStartMinutes || startMinutes >= calEndMinutes) {
	          return null;
	        }
	
	        var visibleStart = Math.max(startMinutes, calStartMinutes);
	        var visibleEnd = Math.min(endMinutes, calEndMinutes);
	
	        var topPx = _this3.minutesToPx(visibleStart - calStartMinutes);
	        var heightPx = _this3.minutesToPx(visibleEnd - visibleStart);
	
	        return {
	          index: index,
	          start: slot.start,
	          end: slot.end,
	          startMinutes: startMinutes,
	          endMinutes: endMinutes,
	          topPx: topPx,
	          heightPx: heightPx,
	          label: slot.start + ' - ' + slot.end
	        };
	      }).filter(function (slot) {
	        return slot !== null;
	      });
	    }
	  },
	  watch: {
	    isCalendarInPrintMode: function isCalendarInPrintMode() {
	      return this.getSlotHeight();
	    },
	    startTime: function startTime() {
	      this.getSlotHeight();
	    },
	    endTime: function endTime() {
	      this.getSlotHeight();
	    }
	  },
	  methods: {
	    onMouseUpFromDragging: function onMouseUpFromDragging() {
	      var _this4 = this;
	
	      if (this.deleteSubject && this.isDeleteSubjectOverSubjects) {
	        this.theDeleteEvent = this.deleteSubject;
	        var isDontAskDeleteEvent = this.$helpers.getLocalStorage('do_dont_ask_delete_event');
	        if (isDontAskDeleteEvent) {
	          this.deleteEvent();
	        } else {
	          setTimeout(function (_) {
	            _this4.isConfirmDeleteModal = true;
	          }, 0);
	        }
	      }
	    },
	    closeIsConfirmDelete: function closeIsConfirmDelete() {
	      this.isConfirmDeleteModal = false;
	      this.theDeleteEvent = null;
	    },
	    onConfirmDeleteEvent: function onConfirmDeleteEvent(evt) {
	      this.isConfirmDeleteModal = false;
	      if (evt) {
	        this.$helpers.setLocalStorage('do_dont_ask_delete_event', true);
	      }
	      this.deleteEvent();
	    },
	    deleteEvent: function deleteEvent() {
	      var _this5 = this;
	
	      if (this.theDeleteEvent && this.theDeleteEvent.v_is_selection) {
	        var events = this.$store.getters.selectedCalendarEvents.slice();
	        events.forEach(function (event) {
	          return _this5.$store.dispatch('deleteEvent', event);
	        });
	        this.$store.commit('clearSelectedEventIds');
	        this.$store.dispatch('readCalendarSubjects');
	      } else {
	        this.$store.dispatch('deleteEvent', this.theDeleteEvent);
	      }
	      this.theDeleteEvent = null;
	    },
	    startSelectionDeleteDrag: function startSelectionDeleteDrag(count) {
	      var label = count === 1 ? this.i18n[this.locale].lesson : this.i18n[this.locale].lessons;
	      this.isSelectionDeleteDrag = true;
	      this.deleteSubject = {
	        v_is_selection: true,
	        title: count + ' ' + label,
	        color: '#e74c3c'
	      };
	      this.$emit('onDragging', true);
	    },
	    moveSelectionDeleteDrag: function moveSelectionDeleteDrag(pos) {
	      this.setMovedXY(pos.x, pos.y);
	    },
	    endSelectionDeleteDrag: function endSelectionDeleteDrag() {
	      var _this6 = this;
	
	      var wasOverSubjects = this.isDeleteSubjectOverSubjects;
	      var marker = this.deleteSubject;
	
	      this.isSelectionDeleteDrag = false;
	      this.isDeleteSubjectOverSubjects = false;
	      this.deleteSubject = null;
	      this.setMovedXY(null, null);
	      this.$emit('onDragging', false);
	      if (wasOverSubjects && marker && marker.v_is_selection) {
	        this.theDeleteEvent = marker;
	        var isDontAskDeleteEvent = this.$helpers.getLocalStorage('do_dont_ask_delete_event');
	        if (isDontAskDeleteEvent) {
	          this.deleteEvent();
	        } else {
	          setTimeout(function (_) {
	            _this6.isConfirmDeleteModal = true;
	          }, 0);
	        }
	      }
	    },
	    onMouseEnterSubjects: function onMouseEnterSubjects() {
	      if (this.deleteSubject) {
	        this.isDeleteSubjectOverSubjects = true;
	      }
	    },
	    onMouseLeaveSubjects: function onMouseLeaveSubjects() {
	      this.isDeleteSubjectOverSubjects = false;
	    },
	    generateUUID: function generateUUID() {
	      var d = new Date().getTime();
	      var d2 = window.performance && window.performance.now && window.performance.now() * 1000 || 0;
	      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        var r = Math.random() * 16;
	        if (d > 0) {
	          r = (d + r) % 16 | 0;
	          d = Math.floor(d / 16);
	        } else {
	          r = (d2 + r) % 16 | 0;
	          d2 = Math.floor(d2 / 16);
	        }
	        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
	      });
	    },
	    getIsEventEditable: function getIsEventEditable(event) {
	      if (this.isMoveOnly) {
	        return event.event_type !== 'absence' && event.event_type !== 'presence' && !this.getIsEventOtherSchool(event);
	      }
	      if (event.event_type === 'absence') {
	        return this.isAbsenceEditable;
	      }
	      return this.calendarId * 1 === event.calendar_id && event.event_type !== 'presence';
	    },
	    getIsEventOtherSchool: function getIsEventOtherSchool(event) {
	      return event.event_type !== 'presence' && !this.userSchools[event.school_id];
	    },
	    setTheExternalEventBCR: function setTheExternalEventBCR(BCR) {
	      this.theExternalEventBCR = BCR;
	    },
	    setMovedXY: function setMovedXY(x, y) {
	      this.movedX = x;
	      this.movedY = y;
	    },
	    subjectsMouseUp: function subjectsMouseUp() {
	      this.theExternalEvent = null;
	    },
	    setIsDraggingExternalEvent: function setIsDraggingExternalEvent(boolean) {
	      this.isDraggingExternalEvent = boolean;
	      this.$emit('onDragging', boolean);
	    },
	    setTheExternalEvent: function setTheExternalEvent(subject) {
	      if (subject) {
	        this.$emit('onDragging', true);
	        this.theExternalEvent = subject;
	        this.isDraggingExternalEvent = true;
	        this.setDragActiveDate(null);
	      } else {
	        this.$emit('onDragging', false);
	        this.theDragLesson = null;
	        this.setIsDraggingEvent(false);
	      }
	    },
	    setIsDraggingEvent: function setIsDraggingEvent(boolean) {
	      this.$emit('onDragging', boolean);
	      this.isDraggingEvent = boolean;
	
	      if (this.isMoveOnly) {
	        return;
	      }
	      if (!boolean) {
	        this.$store.dispatch('clearAvailability');
	        this.deleteSubject = null;
	        this.isDeleteSubjectOverSubjects = false;
	        this.setMovedXY(null, null);
	        return;
	      }
	      if (this.theDragLesson && !this.theExternalEvent) {
	        var lessonObj = {
	          calendarId: this.theDragLesson.obj.calendar_id,
	          eventId: this.theDragLesson.obj.event_id
	        };
	        this.$store.dispatch('readEventAvailability', lessonObj);
	        if (!this.isResizingEvent && !this.isSideResizingEvent) {
	          this.deleteSubject = this.theDragLesson.obj;
	        }
	      }
	    },
	    setTheDeleteSubjectCursorPlacement: function setTheDeleteSubjectCursorPlacement(obj) {
	      if (this.deleteSubject) {
	        this.setMovedXY(obj.x, obj.y);
	      }
	    },
	    setDragEventStart: function setDragEventStart(mom) {
	      this.dragEventStart = mom;
	    },
	    setDragEventEnd: function setDragEventEnd(mom) {
	      this.dragEventEnd = mom;
	    },
	    setDragActiveDate: function setDragActiveDate(mom) {
	      this.dragActiveDate = mom;
	      if (!this.isSideResizingEvent) {
	        return;
	      }
	      if (mom === null) {
	        this.dragActiveDates = [];
	        return;
	      }
	      var theDragLessonStartDate = (0, _moment2.default)(this.theDragLesson.obj.start).format('YYYY-MM-DD');
	      var date = (0, _moment2.default)(mom).format('YYYY-MM-DD');
	      var idx = this.dragActiveDates.indexOf(date);
	      if (theDragLessonStartDate !== date && idx < 0) {
	        this.dragActiveDates.push(date);
	      } else {
	        this.dragActiveDates.splice(idx + 1, this.dragActiveDates.length);
	      }
	    },
	    setDragEventY: function setDragEventY(px) {
	      this.dragEventY = px;
	    },
	    setDragEventHeight: function setDragEventHeight(px) {
	      this.dragEventHeight = px;
	    },
	    setIsResizingEvent: function setIsResizingEvent(boolean) {
	      this.isResizingEvent = boolean;
	    },
	    setIsSideResizingEvent: function setIsSideResizingEvent(boolean) {
	      this.isSideResizingEvent = boolean;
	    },
	    setTheDragLesson: function setTheDragLesson(lesson) {
	      this.theDragLesson = lesson;
	    },
	    onEventClick: function onEventClick(event) {
	      this.$emit('onEventClick', event);
	    },
	    onPresenceClick: function onPresenceClick(event) {
	      this.$emit('onPresenceClick', event);
	    },
	    getShowDate: function getShowDate(date) {
	      return this.locale !== 'en' ? (0, _moment2.default)(date).locale(this.locale).format('ddd[.] DD/MM') : (0, _moment2.default)(date).locale(this.locale).format('ddd MM/DD');
	    },
	    getSlotHeight: function getSlotHeight() {
	      var _this7 = this;
	
	      if (this.isShowAsList) {
	        return;
	      }
	      this.$nextTick(function (_) {
	        _this7.slotHeight = document.querySelector('#calendar_dom_id_' + _this7.calendarDOMUuid + ' .time-slot').getBoundingClientRect().height;
	        _this7.slotWidth = document.querySelector('#calendar_dom_id_' + _this7.calendarDOMUuid + ' .day-cal__event-container').getBoundingClientRect().width;
	      });
	    },
	    handleWindowResize: function handleWindowResize() {
	      var _this8 = this;
	
	      clearTimeout(this.isWindowResizingTimer);
	      this.isWindowResizingTimer = setTimeout(function (_) {
	        _this8.getSlotHeight();
	      }, 0);
	    },
	    parseTimeToMinutes: function parseTimeToMinutes(timeStr) {
	      var parts = timeStr.split(':');
	      return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
	    },
	    minutesToPx: function minutesToPx(minutes) {
	      return minutes / 30 * this.slotHeight;
	    },
	    pxToMinutes: function pxToMinutes(px) {
	      return px / this.slotHeight * 30;
	    },
	    findSlotAtMinutes: function findSlotAtMinutes(minutes) {
	      var _this9 = this;
	
	      if (!this.activeRingingSet) return null;
	      return this.activeRingingSet.slots.find(function (slot) {
	        var startMinutes = _this9.parseTimeToMinutes(slot.start);
	        var endMinutes = _this9.parseTimeToMinutes(slot.end);
	        return minutes >= startMinutes && minutes < endMinutes;
	      });
	    },
	    setHoveredSlotIndex: function setHoveredSlotIndex(index) {
	      this.hoveredSlotIndex = index;
	    }
	  },
	  mounted: function mounted() {
	    var _this10 = this;
	
	    this.$nextTick(function (_) {
	      _this10.getSlotHeight();
	      window.addEventListener('resize', _this10.handleWindowResize);
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.handleWindowResize);
	  }
	};

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventTypeOrder = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    out_of_school: 'Ude af huset',
	    canceled: 'Aflyst'
	  },
	  en: {
	    out_of_school: 'Out of school',
	    canceled: 'Canceled'
	  },
	  nb: {
	    out_of_school: 'Utenfor skolen',
	    canceled: 'Avlyst'
	  }
	};
	
	exports.default = {
	  props: {
	    localeOverride: {
	      type: String,
	      default: null
	    },
	    calendarId: {
	      default: 7
	    },
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    date: {},
	    slotHeight: {
	      default: 40
	    },
	    calStartTime: {
	      default: '08:00:00'
	    },
	    calEndTime: {
	      default: '17:00:00'
	    },
	    isEventsClickable: {
	      type: Boolean,
	      default: false
	    },
	    isCalendarInPrintMode: {
	      type: Boolean,
	      default: false
	    },
	    isMobile: {
	      type: Boolean,
	      default: false
	    },
	    isCalNoBgColors: {
	      type: Boolean,
	      default: false
	    },
	    eventFontSize: {
	      default: 10
	    },
	    isHideCalendars: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      correctEvents: [],
	      firstEvent: true,
	      isWindowResizing: false
	    };
	  },
	
	  computed: {
	    dayLessons: function dayLessons() {
	      var _this = this;
	
	      return this.events.filter(function (lesson) {
	        return (0, _moment2.default)(lesson.start).format('YYYY-MM-DD') === (0, _moment2.default)(_this.date).format('YYYY-MM-DD');
	      });
	    },
	    locale: function locale() {
	      if (this.localeOverride) {
	        return this.localeOverride;
	      }
	      if (this.$store && this.$store.getters && this.$store.getters.locale) {
	        return this.$store.getters.locale;
	      }
	      return 'da';
	    },
	    i18n: function i18n() {
	      return I18N[this.locale] || I18N.en;
	    }
	  },
	  watch: {
	    dayLessons: function dayLessons() {
	      this.updateEventsPositions();
	    },
	    slotHeight: function slotHeight() {
	      this.updateEventsPositions();
	    },
	    calStartTime: function calStartTime() {
	      this.updateEventsPositions();
	    },
	    calEndTime: function calEndTime() {
	      this.updateEventsPositions();
	    }
	  },
	  methods: {
	    getEventWarningLabel: function getEventWarningLabel(eventObj) {
	      if (eventObj.canceled) {
	        return this.i18n.canceled;
	      }
	      if (eventObj.away) {
	        return this.i18n.out_of_school;
	      }
	    },
	    updateEventsPositions: function updateEventsPositions() {
	      var _this2 = this;
	
	      this.$nextTick(function (_) {
	        _this2.correctEvents = [];
	        _this2.formatEvents();
	        _this2.firstEvent = true;
	      });
	    },
	    onEventClick: function onEventClick(event, evt) {
	      if (event.obj.event_type === 'presence') {
	        this.$emit('onPresenceClick', event);
	      } else {
	        evt.stopPropagation();
	        this.$emit('onEventClick', event);
	      }
	    },
	    eventTop: function eventTop(event) {
	      var calStartTime = (0, _moment2.default)(event.start).set({
	        'hours': (0, _moment2.default)(this.calStartTime).hours(),
	        'minutes': (0, _moment2.default)(this.calStartTime).minutes()
	      });
	      var eventStartTime = (0, _moment2.default)(event.start);
	      var duration = (0, _moment2.default)(eventStartTime).diff(calStartTime);
	      var eventTop = this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	      return eventTop;
	    },
	    eventHeight: function eventHeight(event) {
	      var duration = (0, _moment2.default)(event.end).diff(event.start);
	      return this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    },
	    eventBottom: function eventBottom(event) {
	      var calStartTime = (0, _moment2.default)(event.start).set({
	        'hours': (0, _moment2.default)(this.calStartTime).hours(),
	        'minutes': (0, _moment2.default)(this.calStartTime).minutes()
	      });
	      var eventEndTime = (0, _moment2.default)(event.end);
	      var duration = (0, _moment2.default)(eventEndTime).diff(calStartTime);
	      return this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    },
	    formatEvents: function formatEvents() {
	      var dayEventsPresence = this.dayLessons.filter(function (event) {
	        return event.event_type === 'presence';
	      });
	      this.setWidthAndLeft(dayEventsPresence);
	      var dayEvents = this.dayLessons.filter(function (event) {
	        return event.event_type !== 'presence';
	      });
	      this.setWidthAndLeft(dayEvents);
	    },
	    setWidthAndLeft: function setWidthAndLeft(dayLessons) {
	      var _this3 = this;
	
	      var cluster = [];
	      var lastEventEnding = null;
	      var events = dayLessons.map(function (elem) {
	        var top = _this3.eventTop(elem);
	        var height = _this3.eventHeight(elem);
	        var bottom = _this3.eventBottom(elem);
	        return {
	          'obj': elem,
	          'top': top,
	          'height': height,
	          'bottom': bottom
	        };
	      });
	
	      events = events.sort(function (e1, e2) {
	        return e1.top - e2.top || e2.bottom - e1.bottom;
	      });
	      for (var i = 0; i < events.length; i++) {
	        var e = events[i];
	        if (lastEventEnding !== null && e.top >= lastEventEnding) {
	          this.packCluster(cluster);
	          cluster = [];
	          lastEventEnding = null;
	        }
	        cluster.push(e);
	        if (lastEventEnding === null || e.bottom > lastEventEnding) {
	          lastEventEnding = e.bottom;
	        }
	      }
	      if (cluster.length > 0) {
	        this.packCluster(cluster);
	      }
	    },
	    packCluster: function packCluster(cluster) {
	      var _this4 = this;
	
	      var columns = [];
	      cluster.sort(_eventTypeOrder.compareEventsByType).forEach(function (e) {
	        var col = columns.find(function (col) {
	          return col.every(function (ev) {
	            return !_this4.collidesWith(ev, e);
	          });
	        });
	        if (col) {
	          col.push(e);
	        } else {
	          columns.push([e]);
	        }
	      });
	      columns.forEach(function (col) {
	        return col.sort(function (a, b) {
	          return a.top - b.top;
	        });
	      });
	      this.packEvents(columns);
	    },
	    packEvents: function packEvents(columns) {
	      var n = columns.length;
	      for (var i = 0; i < n; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev = col[j];
	          var colSpan = this.expandEvent(ev, i, columns);
	          col[j].left = i / n * 100;
	          col[j].width = 100 * colSpan / n;
	          col[j].cols = n;
	
	          if (n > 1 && j === 0) {
	            var aTop = col[j].top;
	            var bTop = columns[j + 1][0].top;
	
	            if (bTop - aTop > 20) {
	              col[j].width = 90;
	            }
	          }
	          this.correctEvents.push(col[j]);
	
	          if (this.firstEvent) {
	            this.$emit('lessonsUpdate', this.correctEvents[0]);
	          }
	          this.firstEvent = false;
	        }
	      }
	    },
	    expandEvent: function expandEvent(ev, iColumn, columns) {
	      var colSpan = 1;
	      for (var i = iColumn + 1; i < columns.length; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev1 = col[j];
	          if (this.collidesWith(ev, ev1)) {
	            return colSpan;
	          }
	        }
	        colSpan++;
	      }
	      return colSpan;
	    },
	    collidesWith: function collidesWith(a, b) {
	      return a.bottom > b.top && a.top < b.bottom;
	    }
	  },
	  mounted: function mounted() {
	    this.updateEventsPositions();
	  }
	};

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _eventTypeOrder = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    other_school: 'Anden skole',
	    this_event_can_only_be_edited_in: 'Denne brik kan kun redigeres i',
	    where_it_initially_was_scheduled: 'hvor den er skemalagt',
	    the_calendar: 'den kalender',
	    go_to: 'Gå til',
	    out_of_school: 'Ude af huset',
	    canceled: 'Aflyst'
	  },
	  en: {
	    other_school: 'Other school',
	    this_event_can_only_be_edited_in: 'This event can only be edited in',
	    where_it_initially_was_scheduled: 'where it is scheduled',
	    the_calendar: 'the calendar',
	    go_to: 'Go to',
	    out_of_school: 'Out of school',
	    canceled: 'Canceled'
	  },
	  nb: {
	    other_school: 'Annen skole',
	    this_event_can_only_be_edited_in: 'Denne timen kan kun redigeres i',
	    the_calendar: 'den kalenderen',
	    where_it_initially_was_scheduled: 'hvor den opprinnelig er planlagt',
	    go_to: 'Gå til',
	    out_of_school: 'Utenfor skolen',
	    canceled: 'Avlyst'
	  }
	};
	
	exports.default = {
	  props: {
	    calendar: {
	      type: Object,
	      default: null
	    },
	    calendarId: {
	      default: 7
	    },
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    date: {},
	    slotHeight: {
	      default: 40
	    },
	    calStartTime: {
	      default: '08:00:00'
	    },
	    calEndTime: {
	      default: '17:00:00'
	    },
	    isEventsClickable: {
	      type: Boolean,
	      default: false
	    },
	    dragLesson: {
	      type: Object,
	      default: function _default() {
	        return null;
	      }
	    },
	    dragEventY: {
	      type: Number,
	      default: 0
	    },
	    dragEventHeight: {
	      type: Number,
	      default: 0
	    },
	    dragActiveDate: {
	      type: Object,
	      default: function _default() {
	        return null;
	      }
	    },
	    isResizingEvent: {
	      type: Boolean,
	      default: false
	    },
	    isDraggingEvent: {
	      type: Boolean,
	      default: false
	    },
	    isDraggingExternalEvent: {
	      type: Boolean,
	      default: false
	    },
	    theExternalEvent: {
	      type: Object,
	      default: null
	    },
	    dragEventStart: {},
	    dragEventEnd: {},
	    isLocked: {
	      type: Boolean,
	      default: false
	    },
	    dragActiveDates: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isSideResizingEvent: {
	      type: Boolean,
	      default: false
	    },
	    isCopyCalendarModalOpen: {
	      type: Boolean,
	      default: false
	    },
	    showGrid: {
	      type: Boolean,
	      default: false
	    },
	    gridSlots: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    hoveredSlotIndex: {
	      type: Number,
	      default: null
	    },
	
	    isMoveOnly: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      correctEvents: [],
	      firstEvent: true,
	      isWindowResizing: false,
	      dragLessonId: null,
	      startY: 0,
	      startX: 0,
	      delta: 2,
	      distanceMovedY: null,
	      distanceMovedX: null,
	      raf: null,
	      multiSelect: null
	    };
	  },
	
	  computed: {
	    isCalendarTypeRoom: function isCalendarTypeRoom() {
	      return this.calendar && this.calendar.type ? this.calendar.type === 'room' : false;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    dragEventStartTime: function dragEventStartTime() {
	      return (0, _moment2.default)(this.dragEventStart).format('LT');
	    },
	    dragEventEndTime: function dragEventEndTime() {
	      return (0, _moment2.default)(this.dragEventEnd).format('LT');
	    },
	    dayLessons: function dayLessons() {
	      var _this = this;
	
	      return this.events.filter(function (lesson) {
	        return (0, _moment2.default)(lesson.start).format('YYYY-MM-DD') === (0, _moment2.default)(_this.date).format('YYYY-MM-DD');
	      });
	    },
	    isMultiSelectActive: function isMultiSelectActive() {
	      return !this.isMoveOnly && this.$store.getters.isMultiSelectActive;
	    },
	    selectedEventIds: function selectedEventIds() {
	      return this.$store.state.calendar.selectedEventIds;
	    },
	    isActiveDay: function isActiveDay() {
	      if (!this.isSideResizingEvent) {
	        if (!this.dragActiveDate) {
	          return false;
	        }
	        return (0, _moment2.default)(this.date).isSame(this.dragActiveDate);
	      } else {
	        if (this.dragActiveDates.length < 1) {
	          return false;
	        }
	        var date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	        return this.dragActiveDates.includes(date);
	      }
	    }
	  },
	  watch: {
	    dayLessons: function dayLessons() {
	      this.updateEventsPositions();
	    },
	    slotHeight: function slotHeight() {
	      this.updateEventsPositions();
	    },
	    calStartTime: function calStartTime() {
	      this.updateEventsPositions();
	    },
	    calEndTime: function calEndTime() {
	      this.updateEventsPositions();
	    }
	  },
	  methods: {
	    isEventSelectable: function isEventSelectable(obj) {
	      return !!obj.v_is_editable && !obj.v_other_calendar && !obj.v_other_school && !obj.rendering && !obj.v_is_loading && obj.event_type !== 'presence' && obj.event_type !== 'absence';
	    },
	    isEventSelected: function isEventSelected(obj) {
	      return this.selectedEventIds.indexOf(obj.event_id) > -1;
	    },
	    toggleEventSelection: function toggleEventSelection(obj) {
	      if (!this.isEventSelectable(obj)) {
	        return;
	      }
	      this.$store.commit('toggleSelectedEventId', obj.event_id);
	    },
	    onMultiSelectMove: function onMultiSelectMove(evt) {
	      if (!this.multiSelect) {
	        return;
	      }
	      var distX = evt.pageX - this.multiSelect.startX;
	      var distY = evt.pageY - this.multiSelect.startY;
	      if (!this.multiSelect.started && (Math.abs(distX) > this.delta || Math.abs(distY) > this.delta)) {
	        this.multiSelect.started = true;
	
	        if (!this.isEventSelected(this.multiSelect.lesson.obj)) {
	          this.$store.commit('toggleSelectedEventId', this.multiSelect.lesson.obj.event_id);
	        }
	        this.$emit('startSelectionDeleteDrag', this.selectedEventIds.length);
	      }
	      if (this.multiSelect.started) {
	        this.$emit('moveSelectionDeleteDrag', { x: evt.pageX, y: evt.pageY });
	      }
	    },
	    onMultiSelectUp: function onMultiSelectUp() {
	      document.removeEventListener('pointermove', this.onMultiSelectMove);
	      document.removeEventListener('pointerup', this.onMultiSelectUp);
	      document.removeEventListener('pointercancel', this.onMultiSelectUp);
	      if (!this.multiSelect) {
	        return;
	      }
	      if (this.multiSelect.started) {
	        this.$emit('endSelectionDeleteDrag');
	      } else {
	        this.toggleEventSelection(this.multiSelect.lesson.obj);
	      }
	      this.multiSelect = null;
	    },
	    getEventWarningLabel: function getEventWarningLabel(eventObj) {
	      if (eventObj.canceled) {
	        return this.i18n.canceled;
	      }
	      if (eventObj.away) {
	        return this.i18n.out_of_school;
	      }
	    },
	    onNativeEventClick: function onNativeEventClick(event, evt) {
	      if (event && event.obj && event.obj.event_type === 'presence') {} else {
	        evt.stopPropagation();
	      }
	    },
	    onMouseEnterDay: function onMouseEnterDay(evt) {
	      var _this2 = this;
	
	      if (!this.dragLesson && !this.theExternalEvent) {
	        return;
	      }
	      if (this.dragLesson || !this.isResizingEvent || this.theExternalEvent) {
	        this.$emit('setDragActiveDate', this.date);
	        if (this.isDraggingExternalEvent) {
	          this.startY = evt.pageY;
	          this.startX = evt.pageX;
	          var elTop = document.querySelector('.day-cal__event-container').getBoundingClientRect().top - 1;
	          var mouseEnterDayPxFromTop = evt.clientY;
	          var PxFromTopOfCal = mouseEnterDayPxFromTop - elTop;
	
	          var startTime = void 0,
	              endTime = void 0,
	              closestFiveMinutesInPx = void 0,
	              eventHeight = void 0;
	
	          if (this.showGrid && this.gridSlots.length > 0) {
	            var slot = this.findSlotAtPx(PxFromTopOfCal);
	            if (slot) {
	              var calStartMinutes = this.parseTimeToMinutes((0, _moment2.default)(this.calStartTime).locale('en').format('HH:mm'));
	              var slotStartMinutes = slot.startMinutes;
	              var slotEndMinutes = slot.endMinutes;
	
	              closestFiveMinutesInPx = this.minutesToPx(slotStartMinutes - calStartMinutes);
	              eventHeight = this.minutesToPx(slotEndMinutes - slotStartMinutes);
	
	              startTime = (0, _moment2.default)(this.calStartTime).set({
	                hour: Math.floor(slotStartMinutes / 60),
	                minute: slotStartMinutes % 60,
	                second: 0,
	                millisecond: 0
	              });
	              endTime = (0, _moment2.default)(this.calStartTime).set({
	                hour: Math.floor(slotEndMinutes / 60),
	                minute: slotEndMinutes % 60,
	                second: 0,
	                millisecond: 0
	              });
	
	              this.$emit('setHoveredSlotIndex', slot.index);
	            } else {
	              var fiveMinutesInPx = this.slotHeight / 6;
	              closestFiveMinutesInPx = Math.floor(PxFromTopOfCal / fiveMinutesInPx) * fiveMinutesInPx;
	              var numberOfMinutesToMultiply = Math.floor(PxFromTopOfCal / fiveMinutesInPx);
	              var minutes = 5 * Math.abs(numberOfMinutesToMultiply);
	              startTime = (0, _moment2.default)(this.calStartTime).add(minutes, 'minutes');
	              endTime = (0, _moment2.default)(startTime).add(this.theExternalEvent.default_duration, 'minutes');
	              eventHeight = null;
	              this.$emit('setHoveredSlotIndex', null);
	            }
	          } else {
	            var _fiveMinutesInPx = this.slotHeight / 6;
	            closestFiveMinutesInPx = Math.floor(PxFromTopOfCal / _fiveMinutesInPx) * _fiveMinutesInPx;
	            var _numberOfMinutesToMultiply = Math.floor(PxFromTopOfCal / _fiveMinutesInPx);
	            var _minutes = 5 * Math.abs(_numberOfMinutesToMultiply);
	            startTime = (0, _moment2.default)(this.calStartTime).add(_minutes, 'minutes');
	            endTime = (0, _moment2.default)(startTime).add(this.theExternalEvent.default_duration, 'minutes');
	            eventHeight = null;
	          }
	
	          var eventCals = this.theExternalEvent.cals;
	          var isNotThisCalendar = this.theExternalEvent.calendar_id !== this.calendarId;
	          var isNotInCalsArrAlready = eventCals.findIndex(function (cal) {
	            return cal.id === _this2.theExternalEvent.calendar_id;
	          }) < 0;
	          if (isNotThisCalendar && isNotInCalsArrAlready) {
	            var otherCal = { id: this.theExternalEvent.calendar_id };
	            eventCals.push(otherCal);
	          }
	          var event = {
	            school_id: this.theExternalEvent.school_id,
	            subject_id: this.theExternalEvent.id,
	            calendarIds: [],
	            title: this.theExternalEvent.title,
	            end: endTime,
	            start: startTime,
	            color: this.theExternalEvent.color,
	            event_id: null,
	            calendars: eventCals,
	            event_type: this.theExternalEvent.subjectType,
	            calendar_id: this.calendarId,
	            description: '',
	            learning_goal: '',
	            teacher_notes: '',
	            notes_for_students: '',
	            has_notes: false,
	            group: '',
	            teacher: '',
	            room: '',
	            substitutes: null,
	            eventDuration: this.theExternalEvent.default_duration,
	            v_other_school: false,
	            v_is_editable: true
	          };
	          var lesson = {
	            top: closestFiveMinutesInPx,
	            height: eventHeight !== null ? eventHeight : this.eventHeight(event),
	            bottom: 0,
	            left: 0,
	            width: 100,
	            obj: event
	          };
	          this.onMouseDown(lesson, evt);
	          this.$emit('setIsDraggingExternalEvent', false);
	        }
	      }
	    },
	    onMouseLeaveDay: function onMouseLeaveDay(evt) {
	      if (!this.dragLesson || this.isResizingEvent || this.isSideResizingEvent) {
	        return;
	      }
	      this.$emit('setDragActiveDate', null);
	    },
	    getIsMouseDownAllowed: function getIsMouseDownAllowed(lesson) {
	      return this.isEventsClickable && !lesson.obj.v_other_school && lesson.obj.event_type !== 'presence' && !lesson.obj.v_is_loading;
	    },
	    onMouseDown: function onMouseDown(lesson, evt) {
	      if (this.isMultiSelectActive && this.isEventSelectable(lesson.obj)) {
	        evt.stopPropagation();
	        if (evt.button === 2 || evt.button === 1) {
	          return;
	        }
	        if (evt.target.releasePointerCapture) {
	          try {
	            evt.target.releasePointerCapture(evt.pointerId);
	          } catch (e) {}
	        }
	        this.multiSelect = { lesson: lesson, startX: evt.pageX, startY: evt.pageY, started: false };
	        document.addEventListener('pointermove', this.onMultiSelectMove, { passive: true });
	        document.addEventListener('pointerup', this.onMultiSelectUp, { passive: true });
	        document.addEventListener('pointercancel', this.onMultiSelectUp, { passive: true });
	        return;
	      }
	
	      if (!this.getIsMouseDownAllowed(lesson) || evt.button === 2 || evt.button === 1 || evt.target.classList.contains('js-no-click')) {
	        return;
	      }
	      evt.target.releasePointerCapture(evt.pointerId);
	      if (evt.target.classList.contains('d-event__resizer')) {
	        this.$emit('setIsResizingEvent', true);
	      }
	      if (evt.target.classList.contains('d-event__side__resizer')) {
	        this.$emit('setIsSideResizingEvent', true);
	      }
	      this.startY = evt.pageY;
	      this.startX = evt.pageX;
	      this.$emit('setDragEventY', lesson.top);
	      this.$emit('setDragEventHeight', lesson.height);
	      this.$emit('setDragLesson', lesson);
	      this.$emit('setDragEventStart', lesson.obj.start);
	      this.$emit('setDragEventEnd', lesson.obj.end);
	      this.$emit('setDragActiveDate', this.date);
	      if (lesson.obj.v_is_editable && !this.isLocked) {
	        document.addEventListener('pointermove', this.onMouseMove, { passive: true });
	      }
	      document.addEventListener('pointerup', this.onMouseUp, { passive: true });
	      document.addEventListener('pointercancel', this.onMouseUp, { passive: true });
	    },
	    onMouseUp: function onMouseUp(evt) {
	      if (this.dragActiveDate) {
	        this.getIsDragOrClick(evt);
	      }
	      this.$emit('onMouseUp');
	      this.$emit('setHoveredSlotIndex', null);
	      this.cleanUp();
	      document.removeEventListener('pointermove', this.onMouseMove);
	      document.removeEventListener('pointerup', this.onMouseUp);
	      document.addEventListener('pointercancel', this.onMouseUp);
	      this.distanceMovedY = null;
	      this.distanceMovedX = null;
	      if (this.raf) {
	        window.cancelAnimationFrame(this.raf);
	        this.raf = null;
	      }
	    },
	    getIsDragOrClick: function getIsDragOrClick(evt) {
	      if (!this.dragLesson.obj.v_is_editable && !this.dragLesson.obj.v_other_calendar || this.isLocked && !this.dragLesson.obj.v_other_calendar) {
	        this.onEventClick(evt);
	        return;
	      }
	      if (!this.isDraggingEvent) {
	        this.onEventClick(evt);
	      } else {
	        if (this.dragLesson.obj.v_other_calendar && !this.isMoveOnly) {
	          var parentCalendarName = this.dragLesson.obj.v_other_calendar && this.dragLesson.obj.v_other_calendar.name ? this.dragLesson.obj.v_other_calendar.name : this.i18n['the_calendar'];
	          var txt = this.i18n['this_event_can_only_be_edited_in'] + ' ' + parentCalendarName + ', ' + this.i18n['where_it_initially_was_scheduled'];
	          _eventbus2.default.toast = { text: txt, 'success': false };
	          return;
	        }
	        this.updateEventTimes();
	      }
	    },
	    updateEventTimes: function updateEventTimes() {
	      var _this3 = this;
	
	      if (this.isSideResizingEvent) {
	        if (this.dragActiveDates.length < 1) {
	          return;
	        }
	        var eventsToCreate = [];
	        this.dragActiveDates.forEach(function (dragDate, key) {
	          var newEvent = (0, _assign2.default)({}, _this3.dragLesson.obj);
	          var year = (0, _moment2.default)(dragDate).year();
	          var month = (0, _moment2.default)(dragDate).month();
	          var day = (0, _moment2.default)(dragDate).date();
	          var newStartTime = (0, _moment2.default)(newEvent.start).set({
	            year: year,
	            month: month,
	            date: day,
	            millisecond: 0
	          });
	          var newEndTime = (0, _moment2.default)(newEvent.end).set({
	            year: year,
	            month: month,
	            date: day,
	            millisecond: 0
	          });
	          newEvent.event_id = 'new_temp_id_' + key;
	          newEvent.start = newStartTime;
	          newEvent.end = newEndTime;
	          newEvent.v_is_loading = true;
	          eventsToCreate.push(newEvent);
	        });
	        this.$store.dispatch('createCalendarEvents', eventsToCreate);
	        return;
	      }
	      var year = (0, _moment2.default)(this.dragActiveDate).year();
	      var month = (0, _moment2.default)(this.dragActiveDate).month();
	      var date = (0, _moment2.default)(this.dragActiveDate).date();
	      var newStartTime = (0, _moment2.default)(this.dragEventStart).set({
	        'year': year,
	        'month': month,
	        'date': date,
	        'millisecond': 0
	      });
	      var newEndTime = (0, _moment2.default)(this.dragEventEnd).set({ 'year': year, 'month': month, 'date': date, 'millisecond': 0 });
	      if (this.isMoveOnly) {
	        var obj = this.dragLesson.obj;
	        if (obj.event_id && (!newStartTime.isSame(obj.start) || !newEndTime.isSame(obj.end))) {
	          this.$emit('moveEvent', { event: obj, start: newStartTime, end: newEndTime });
	        }
	        return;
	      }
	      if (this.dragLesson.obj.event_id) {
	        var updatedArr = {
	          school_id: this.dragLesson.obj.school_id,
	          updates: [{
	            event_id: this.dragLesson.obj.event_id,
	            calendar_id: this.dragLesson.obj.calendar_id,
	            start_time: newStartTime,
	            end_time: newEndTime
	          }]
	        };
	        this.$store.dispatch('updateCalendarEvent', updatedArr);
	      } else {
	        this.dragLesson.obj.event_id = 'new_temp_id';
	        this.dragLesson.obj.start = newStartTime;
	        this.dragLesson.obj.end = newEndTime;
	        this.dragLesson.obj.calendar_id = this.calendarId;
	        this.dragLesson.obj.v_is_loading = true;
	        this.$store.dispatch('createCalendarEvent', this.dragLesson.obj);
	      }
	    },
	    onMouseMove: function onMouseMove(evt) {
	      if (!this.raf) {
	        this.distanceMovedY = evt.pageY - this.startY;
	        this.distanceMovedX = evt.pageX - this.startX;
	        this.raf = window.requestAnimationFrame(this.moveEvent);
	        var cursorPlacement = {
	          x: evt.pageX,
	          y: evt.pageY
	        };
	        this.$emit('setTheDeleteSubjectCursorPlacement', cursorPlacement);
	      }
	    },
	    moveEvent: function moveEvent() {
	      var distanceMovedY = this.distanceMovedY;
	      var distanceMovedX = this.distanceMovedX;
	      if (Math.abs(distanceMovedY) > this.delta || Math.abs(distanceMovedX) > this.delta) {
	        if (!this.isDraggingEvent) {
	          this.$emit('setIsDraggingEvent', true);
	        }
	      }
	
	      if (this.showGrid && this.gridSlots && this.gridSlots.length > 0) {
	        if (this.isResizingEvent) {
	          this.resizeEventWithGridSnapping(distanceMovedY);
	        } else if (!this.isSideResizingEvent) {
	          this.moveEventWithGridSnapping(distanceMovedY);
	        } else {
	          this.moveEventDefault(distanceMovedY);
	        }
	      } else {
	        this.moveEventDefault(distanceMovedY);
	      }
	
	      this.raf = null;
	    },
	    moveEventDefault: function moveEventDefault(distanceMovedY) {
	      var fiveMinutesInPx = this.slotHeight / 6;
	      var numberOfMinutesToMultiply = Math.floor(distanceMovedY / fiveMinutesInPx);
	      var minutes = 5 * Math.abs(numberOfMinutesToMultiply);
	
	      if (!this.isResizingEvent && !this.isSideResizingEvent) {
	        var dragEventStart = void 0,
	            dragEventEnd = void 0;
	        if (numberOfMinutesToMultiply > 0) {
	          dragEventStart = (0, _moment2.default)(this.dragLesson.obj.start).add(minutes, 'minutes');
	          dragEventEnd = (0, _moment2.default)(this.dragLesson.obj.end).add(minutes, 'minutes');
	        } else {
	          dragEventStart = (0, _moment2.default)(this.dragLesson.obj.start).subtract(minutes, 'minutes');
	          dragEventEnd = (0, _moment2.default)(this.dragLesson.obj.end).subtract(minutes, 'minutes');
	        }
	        this.$emit('setDragEventStart', dragEventStart);
	        this.$emit('setDragEventEnd', dragEventEnd);
	        this.$emit('setDragEventY', this.dragLesson.top + fiveMinutesInPx * numberOfMinutesToMultiply);
	        this.$emit('setHoveredSlotIndex', null);
	      } else if (this.isResizingEvent) {
	        var _dragEventEnd = void 0;
	        if (numberOfMinutesToMultiply > 0) {
	          _dragEventEnd = (0, _moment2.default)(this.dragLesson.obj.end).add(minutes, 'minutes');
	        } else {
	          _dragEventEnd = (0, _moment2.default)(this.dragLesson.obj.end).subtract(minutes, 'minutes');
	
	          if ((0, _moment2.default)(_dragEventEnd).isSameOrBefore(this.dragLesson.obj.start)) {
	            _dragEventEnd = (0, _moment2.default)(this.dragLesson.obj.start).add(5, 'minutes');
	          }
	        }
	        var dragEventHeight = this.dragLesson.height + fiveMinutesInPx * numberOfMinutesToMultiply > 0 ? this.dragLesson.height + fiveMinutesInPx * numberOfMinutesToMultiply : fiveMinutesInPx;
	        this.$emit('setDragEventEnd', _dragEventEnd);
	        this.$emit('setDragEventHeight', dragEventHeight);
	        this.$emit('setHoveredSlotIndex', null);
	      }
	    },
	    moveEventWithGridSnapping: function moveEventWithGridSnapping(distanceMovedY) {
	      var newTopPx = this.dragLesson.top + distanceMovedY;
	
	      var slot = this.findSlotAtPx(newTopPx);
	
	      if (slot) {
	        var calStartMinutes = this.parseTimeToMinutes((0, _moment2.default)(this.calStartTime).locale('en').format('HH:mm'));
	        var slotStartMinutes = this.parseTimeToMinutes(slot.start);
	        var slotEndMinutes = this.parseTimeToMinutes(slot.end);
	        var slotDuration = slotEndMinutes - slotStartMinutes;
	
	        var slotTopPx = this.minutesToPx(slotStartMinutes - calStartMinutes);
	        var slotHeightPx = this.minutesToPx(slotDuration);
	
	        var dragEventStart = (0, _moment2.default)(this.dragLesson.obj.start).set({
	          hour: Math.floor(slotStartMinutes / 60),
	          minute: slotStartMinutes % 60,
	          second: 0,
	          millisecond: 0
	        });
	        var dragEventEnd = (0, _moment2.default)(this.dragLesson.obj.end).set({
	          hour: Math.floor(slotEndMinutes / 60),
	          minute: slotEndMinutes % 60,
	          second: 0,
	          millisecond: 0
	        });
	
	        this.$emit('setDragEventStart', dragEventStart);
	        this.$emit('setDragEventEnd', dragEventEnd);
	        this.$emit('setDragEventY', slotTopPx);
	        this.$emit('setDragEventHeight', slotHeightPx);
	        this.$emit('setHoveredSlotIndex', slot.index);
	      } else {
	        this.moveEventDefault(distanceMovedY);
	      }
	    },
	    resizeEventWithGridSnapping: function resizeEventWithGridSnapping(distanceMovedY) {
	      var currentBottomPx = this.dragLesson.top + this.dragLesson.height;
	      var newBottomPx = currentBottomPx + distanceMovedY;
	
	      var slot = this.findSlotAtPx(newBottomPx);
	
	      if (slot) {
	        var slotEndMinutes = this.parseTimeToMinutes(slot.end);
	        var eventStartMinutes = this.parseTimeToMinutes((0, _moment2.default)(this.dragLesson.obj.start).locale('en').format('HH:mm'));
	
	        if (slotEndMinutes <= eventStartMinutes) {
	          var minEndSlot = this.findSlotAfterMinutes(eventStartMinutes);
	          if (minEndSlot) {
	            var minEndMinutes = this.parseTimeToMinutes(minEndSlot.end);
	            var _newHeightPx = this.minutesToPx(minEndMinutes - eventStartMinutes);
	            var _dragEventEnd2 = (0, _moment2.default)(this.dragLesson.obj.end).set({
	              hour: Math.floor(minEndMinutes / 60),
	              minute: minEndMinutes % 60,
	              second: 0,
	              millisecond: 0
	            });
	            this.$emit('setDragEventEnd', _dragEventEnd2);
	            this.$emit('setDragEventHeight', _newHeightPx);
	            this.$emit('setHoveredSlotIndex', minEndSlot.index);
	          }
	          return;
	        }
	
	        var newHeightPx = this.minutesToPx(slotEndMinutes - eventStartMinutes);
	
	        var dragEventEnd = (0, _moment2.default)(this.dragLesson.obj.end).set({
	          hour: Math.floor(slotEndMinutes / 60),
	          minute: slotEndMinutes % 60,
	          second: 0,
	          millisecond: 0
	        });
	
	        this.$emit('setDragEventEnd', dragEventEnd);
	        this.$emit('setDragEventHeight', newHeightPx);
	        this.$emit('setHoveredSlotIndex', slot.index);
	      } else {
	        var fiveMinutesInPx = this.slotHeight / 6;
	        var numberOfMinutesToMultiply = Math.floor(distanceMovedY / fiveMinutesInPx);
	        var minutes = 5 * Math.abs(numberOfMinutesToMultiply);
	        var _dragEventEnd3 = void 0;
	
	        if (numberOfMinutesToMultiply > 0) {
	          _dragEventEnd3 = (0, _moment2.default)(this.dragLesson.obj.end).add(minutes, 'minutes');
	        } else {
	          _dragEventEnd3 = (0, _moment2.default)(this.dragLesson.obj.end).subtract(minutes, 'minutes');
	          if ((0, _moment2.default)(_dragEventEnd3).isSameOrBefore(this.dragLesson.obj.start)) {
	            _dragEventEnd3 = (0, _moment2.default)(this.dragLesson.obj.start).add(5, 'minutes');
	          }
	        }
	
	        var dragEventHeight = this.dragLesson.height + fiveMinutesInPx * numberOfMinutesToMultiply > 0 ? this.dragLesson.height + fiveMinutesInPx * numberOfMinutesToMultiply : fiveMinutesInPx;
	
	        this.$emit('setDragEventEnd', _dragEventEnd3);
	        this.$emit('setDragEventHeight', dragEventHeight);
	        this.$emit('setHoveredSlotIndex', null);
	      }
	    },
	    findSlotAfterMinutes: function findSlotAfterMinutes(minutes) {
	      if (!this.gridSlots || this.gridSlots.length === 0) return null;
	
	      for (var i = 0; i < this.gridSlots.length; i++) {
	        var slot = this.gridSlots[i];
	        if (slot.endMinutes > minutes) {
	          return slot;
	        }
	      }
	      return null;
	    },
	    parseTimeToMinutes: function parseTimeToMinutes(timeStr) {
	      var parts = timeStr.split(':');
	      return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
	    },
	    minutesToPx: function minutesToPx(minutes) {
	      return minutes / 30 * this.slotHeight;
	    },
	    pxToMinutes: function pxToMinutes(px) {
	      return px / this.slotHeight * 30;
	    },
	    findSlotAtPx: function findSlotAtPx(px) {
	      if (!this.gridSlots || this.gridSlots.length === 0) return null;
	
	      var minutes = this.pxToMinutes(px);
	      var calStartMinutes = this.parseTimeToMinutes((0, _moment2.default)(this.calStartTime).locale('en').format('HH:mm'));
	      var absoluteMinutes = calStartMinutes + minutes;
	
	      for (var i = 0; i < this.gridSlots.length; i++) {
	        var slot = this.gridSlots[i];
	        if (absoluteMinutes >= slot.startMinutes && absoluteMinutes < slot.endMinutes) {
	          return slot;
	        }
	      }
	      return null;
	    },
	    cleanUp: function cleanUp() {
	      this.$emit('setDragActiveDate', null);
	      this.$emit('setDragLesson', null);
	      this.$emit('setIsResizingEvent', false);
	      this.$emit('setIsSideResizingEvent', false);
	      this.$emit('setIsDraggingEvent', false);
	    },
	    updateEventsPositions: function updateEventsPositions() {
	      var _this4 = this;
	
	      this.$nextTick(function (_) {
	        _this4.correctEvents = [];
	        _this4.formatEvents();
	        _this4.firstEvent = true;
	      });
	    },
	    onEventClick: function onEventClick(evt) {
	      this.$emit('onEventClick', this.dragLesson);
	    },
	    eventTop: function eventTop(event) {
	      var calStartTime = (0, _moment2.default)(event.start).set({
	        'hours': (0, _moment2.default)(this.calStartTime).hours(),
	        'minutes': (0, _moment2.default)(this.calStartTime).minutes()
	      });
	      var eventStartTime = (0, _moment2.default)(event.start);
	      var duration = (0, _moment2.default)(eventStartTime).diff(calStartTime);
	      var eventTop = this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	      return eventTop;
	    },
	    eventHeight: function eventHeight(event) {
	      var duration = (0, _moment2.default)(event.end).diff(event.start);
	      return this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    },
	    eventBottom: function eventBottom(event) {
	      var calStartTime = (0, _moment2.default)(event.start).set({
	        'hours': (0, _moment2.default)(this.calStartTime).hours(),
	        'minutes': (0, _moment2.default)(this.calStartTime).minutes()
	      });
	      var eventEndTime = (0, _moment2.default)(event.end);
	      var duration = (0, _moment2.default)(eventEndTime).diff(calStartTime);
	      return this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    },
	    formatEvents: function formatEvents() {
	      var dayEventsPresence = this.dayLessons.filter(function (event) {
	        return event.event_type === 'presence';
	      });
	      this.setWidthAndLeft(dayEventsPresence);
	      var backgroundEvent = this.dayLessons.filter(function (event) {
	        return event.rendering && event.event_type !== 'presence';
	      });
	      this.setWidthAndLeft(backgroundEvent);
	      var dayEvents = this.dayLessons.filter(function (event) {
	        return event.event_type !== 'presence' && !event.rendering;
	      });
	      this.setWidthAndLeft(dayEvents);
	    },
	    setWidthAndLeft: function setWidthAndLeft(dayLessons) {
	      var _this5 = this;
	
	      var cluster = [];
	      var lastEventEnding = null;
	
	      var events = dayLessons.map(function (elem) {
	        var top = _this5.eventTop(elem);
	        var height = _this5.eventHeight(elem);
	        var bottom = _this5.eventBottom(elem);
	
	        return {
	          'obj': elem,
	          'top': top,
	          'height': height,
	          'bottom': bottom
	        };
	      });
	
	      events = events.sort(function (e1, e2) {
	        return e1.top - e2.top || e2.bottom - e1.bottom;
	      });
	
	      for (var i = 0; i < events.length; i++) {
	        var e = events[i];
	        if (lastEventEnding !== null && e.top >= lastEventEnding) {
	          this.packCluster(cluster);
	          cluster = [];
	          lastEventEnding = null;
	        }
	        cluster.push(e);
	        if (lastEventEnding === null || e.bottom > lastEventEnding) {
	          lastEventEnding = e.bottom;
	        }
	      }
	      if (cluster.length > 0) {
	        this.packCluster(cluster);
	      }
	    },
	    packCluster: function packCluster(cluster) {
	      var _this6 = this;
	
	      var columns = [];
	      cluster.sort(_eventTypeOrder.compareEventsByType).forEach(function (e) {
	        var col = columns.find(function (col) {
	          return col.every(function (ev) {
	            return !_this6.collidesWith(ev, e);
	          });
	        });
	        if (col) {
	          col.push(e);
	        } else {
	          columns.push([e]);
	        }
	      });
	      columns.forEach(function (col) {
	        return col.sort(function (a, b) {
	          return a.top - b.top;
	        });
	      });
	      this.packEvents(columns);
	    },
	    packEvents: function packEvents(columns) {
	      var n = columns.length;
	      for (var i = 0; i < n; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev = col[j];
	          var colSpan = this.expandEvent(ev, i, columns);
	          col[j].left = i / n * 100;
	          col[j].width = 100 * colSpan / n;
	          col[j].cols = n;
	
	          if (n > 1 && j === 0) {
	            var aTop = col[j].top;
	            var bTop = columns[j + 1][0].top;
	
	            if (bTop - aTop > 20) {
	              col[j].width = 90;
	            }
	          }
	          this.correctEvents.push(col[j]);
	
	          if (this.firstEvent) {
	            this.$emit('lessonsUpdate', this.correctEvents[0]);
	          }
	          this.firstEvent = false;
	        }
	      }
	    },
	    expandEvent: function expandEvent(ev, iColumn, columns) {
	      var colSpan = 1;
	      for (var i = iColumn + 1; i < columns.length; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev1 = col[j];
	          if (this.collidesWith(ev, ev1)) {
	            return colSpan;
	          }
	        }
	        colSpan++;
	      }
	      return colSpan;
	    },
	    collidesWith: function collidesWith(a, b) {
	      return a.bottom > b.top && a.top < b.bottom;
	    },
	    goToCalendar: function goToCalendar(calendarId, evt) {
	      window.location.href = '/calendars/' + calendarId;
	    },
	    customTooltip: function customTooltip(obj) {
	      var parentCalendarName = obj.v_other_calendar && obj.v_other_calendar.name ? obj.v_other_calendar.name : this.i18n['the_calendar'];
	      return this.i18n['go_to'] + ' ' + parentCalendarName;
	    }
	  },
	  mounted: function mounted() {
	    if (this.isMoveOnly) {
	      this.updateEventsPositions();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('pointermove', this.onMultiSelectMove);
	    document.removeEventListener('pointerup', this.onMultiSelectUp);
	    document.removeEventListener('pointercancel', this.onMultiSelectUp);
	  }
	};

/***/ }),
/* 523 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    deleteSubject: {
	      type: Object,
	      default: null
	    },
	    activeSubject: {
	      type: Object,
	      default: null
	    },
	    activeSubjectBCR: {
	      default: null
	    },
	    movedX: {
	      type: Number,
	      default: 0
	    },
	    movedY: {
	      type: Number,
	      default: 0
	    }
	  },
	  computed: {
	    subjectTitle: function subjectTitle() {
	      return this.activeSubject ? this.activeSubject.title : this.deleteSubject ? this.deleteSubject.title : '';
	    },
	    styleObj: function styleObj() {
	      return {
	        'top': this.movedY + 'px',
	        'left': this.movedX + 'px',
	        'background': this.activeSubject ? this.activeSubject.color : this.deleteSubject ? this.deleteSubject.color : 'transparent',
	        'width': this.activeSubjectBCR ? this.activeSubjectBCR.width + 'px' : '165px',
	        'height': this.activeSubjectBCR ? this.activeSubjectBCR.height + 'px' : '40px',
	        'borderColor': this.activeSubject ? this.activeSubject.color : this.deleteSubject ? this.deleteSubject.color : 'transparent'
	      };
	    }
	  },
	  mounted: function mounted() {
	    var el = this.$refs.d_cal_dragged;
	
	    document.getElementById('djs-content-container').appendChild(el);
	  }
	};

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DCalendarSelect = __webpack_require__(1491);
	
	var _DCalendarSelect2 = _interopRequireDefault(_DCalendarSelect);
	
	var _CopyCalendar = __webpack_require__(344);
	
	var _CopyCalendar2 = _interopRequireDefault(_CopyCalendar);
	
	var _Print = __webpack_require__(98);
	
	var _Print2 = _interopRequireDefault(_Print);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _EditCalendarEditName = __webpack_require__(1512);
	
	var _EditCalendarEditName2 = _interopRequireDefault(_EditCalendarEditName);
	
	var _EditCalendarDelete = __webpack_require__(1511);
	
	var _EditCalendarDelete2 = _interopRequireDefault(_EditCalendarDelete);
	
	var _PresenceUser = __webpack_require__(82);
	
	var _PresenceUser2 = _interopRequireDefault(_PresenceUser);
	
	var _ExportCalendar = __webpack_require__(97);
	
	var _ExportCalendar2 = _interopRequireDefault(_ExportCalendar);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _CalendarMergeModal = __webpack_require__(1460);
	
	var _CalendarMergeModal2 = _interopRequireDefault(_CalendarMergeModal);
	
	var _CalculateHours = __webpack_require__(340);
	
	var _CalculateHours2 = _interopRequireDefault(_CalculateHours);
	
	var _DCalendarHeaderDelete = __webpack_require__(1488);
	
	var _DCalendarHeaderDelete2 = _interopRequireDefault(_DCalendarHeaderDelete);
	
	var _UserRequest = __webpack_require__(150);
	
	var _UserRequest2 = _interopRequireDefault(_UserRequest);
	
	var _CalendarBulkActions = __webpack_require__(1459);
	
	var _CalendarBulkActions2 = _interopRequireDefault(_CalendarBulkActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    calculate_hours: 'Beregn timer'
	  },
	  en: {
	    calculate_hours: 'Calculate Hours'
	  },
	  nb: {
	    calculate_hours: 'Beregn timer'
	  }
	};
	
	exports.default = {
	  components: {
	    CalendarBulkActions: _CalendarBulkActions2.default,
	    UserRequest: _UserRequest2.default,
	    DCalendarHeaderDelete: _DCalendarHeaderDelete2.default,
	    CalculateHours: _CalculateHours2.default,
	    CalendarMergeModal: _CalendarMergeModal2.default,
	    EditCalendarDelete: _EditCalendarDelete2.default,
	    ExportCalendar: _ExportCalendar2.default,
	    EditCalendarEditName: _EditCalendarEditName2.default, DDropdown: _DDropdown2.default, Print: _Print2.default, DCalendarSelect: _DCalendarSelect2.default, CopyCalendar: _CopyCalendar2.default, UserPresence: _PresenceUser2.default
	  },
	  props: {
	    calendarId: {
	      required: true
	    },
	    initCalendar: {
	      default: null
	    },
	    activeCalendarDate: {
	      default: null
	    },
	    dates: {
	      default: null
	    },
	    hasHotKeys: {
	      default: false
	    },
	    isLoadingEvents: {
	      type: Boolean,
	      default: false
	    },
	    showGrid: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      calendar: null,
	      isShowExportCalendarModal: false,
	      isShowMergeCalendars: false,
	      isShowCalculateHours: false,
	      isShowAbsenceRequest: false
	    };
	  },
	
	  computed: {
	    user: function user() {
	      return this.$store.state.user;
	    },
	    hasBulkSelection: function hasBulkSelection() {
	      return this.$store.state.calendar.selectedEventIds.length > 0;
	    },
	    userCanToggleViewState: function userCanToggleViewState() {
	      var schoolids = [7272, 64019];
	      return schoolids.indexOf(this.schoolId) > -1;
	    },
	    schoolFeatures: function schoolFeatures() {
	      return this.$store.getters.schoolFeatures;
	    },
	    isOwnCalendar: function isOwnCalendar() {
	      return this.user && this.user.user_calendar_id === this.calendarId;
	    },
	    absenceRequestIsActivated: function absenceRequestIsActivated() {
	      return this.schoolFeatures.indexOf('absence_requests') > -1;
	    },
	    userCanRequestAbsence: function userCanRequestAbsence() {
	      return this.isOwnCalendar && this.absenceRequestIsActivated && this.userHasPermission('can_request_absence');
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    calendarType: function calendarType() {
	      return this.calendar && this.calendar.type ? this.calendar.type : null;
	    },
	    isMergeCalendar: function isMergeCalendar() {
	      return this.calendarType === 'merge';
	    },
	    calendarName: function calendarName() {
	      return this.calendar && this.calendar.name ? this.calendar.name : '';
	    },
	    iCalUrl: function iCalUrl() {
	      return this.calendar && this.calendar.ical_url ? window.location.origin + this.calendar.ical_url : this.calendar && this.calendar.ical_link ? window.location.origin + this.calendar.ical_link : 'loading';
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    schoolId: function schoolId() {
	      return this.calendar && this.calendar.school_id ? this.calendar.school_id : this.activeSchool.id;
	    },
	    firstDayOfTheWeek: function firstDayOfTheWeek() {
	      return this.$store.getters.firstDayOfTheWeek;
	    },
	    isLocked: function isLocked() {
	      return this.calendar && this.calendar.locked ? this.calendar.locked : false;
	    },
	    canBeLocked: function canBeLocked() {
	      var typesThatCantBeLocked = ['user', 'room'];
	      return typesThatCantBeLocked.indexOf(this.calendarType) < 0 && this.userHasPermission('can_do_most_stuff');
	    },
	    canToggleViewState: function canToggleViewState() {
	      return this.userHasPermission('can_do_most_stuff');
	    },
	    canBeDeleted: function canBeDeleted() {
	      var typesThatCantBeDeleted = ['merge', 'room', 'user'];
	      return typesThatCantBeDeleted.indexOf(this.calendarType) < 0 && this.userHasPermission('can_manage_calendars');
	    },
	    canEditName: function canEditName() {
	      var typesThatCantEditName = ['user'];
	      return typesThatCantEditName.indexOf(this.calendarType) < 0 && this.userHasPermission('can_manage_calendars');
	    },
	    canBeArchived: function canBeArchived() {
	      var typesThatCantBeDeleted = ['merge', 'room'];
	      return typesThatCantBeDeleted.indexOf(this.calendarType) > -1 && this.userHasPermission('can_manage_calendars');
	    },
	    deleteCalendarText: function deleteCalendarText() {
	      var keys = {
	        klass: 'delete_klass',
	        club: 'delete_club',
	        kindergarten: 'delete_kindergarten'
	      };
	      return this.$t('vue2.editCalendarMenu.' + (keys[this.calendarType] || 'delete_calendar'));
	    },
	    removeCalendarText: function removeCalendarText() {
	      var keys = {
	        room: 'remove_room',
	        merge: 'remove_merge'
	      };
	      return this.$t('vue2.editCalendarMenu.' + (keys[this.calendarType] || 'remove_calendar'));
	    },
	    canEditPresence: function canEditPresence() {
	      var typesThatCanEditPresence = ['user'];
	      return typesThatCanEditPresence.indexOf(this.calendarType) > -1;
	    },
	    canSeeExportCalendar: function canSeeExportCalendar() {
	      var typesThatCanExportCalendar = ['user'];
	      return typesThatCanExportCalendar.indexOf(this.calendarType) > -1;
	    },
	    canSeeMergeWithMergeCalendars: function canSeeMergeWithMergeCalendars() {
	      var typesThatCanExportCalendar = ['klass', 'club'];
	      return typesThatCanExportCalendar.indexOf(this.calendarType) > -1;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    isToday: function isToday() {
	      return this.activeCalendarDate ? (0, _moment2.default)(this.activeCalendarDate).isoWeek() === (0, _moment2.default)().isoWeek() : false;
	    },
	    calendarDateInterval: function calendarDateInterval() {
	      if (this.dates.length === 0) {
	        return '';
	      }
	      var startDate = (0, _moment2.default)(this.dates[0]);
	      var endDate = (0, _moment2.default)(this.dates[this.dates.length - 1]);
	      var startFormat = startDate.format('D.');
	      if (!(0, _moment2.default)(startDate).isSame(endDate, 'month')) {
	        startFormat = startDate.format('D. MMM');
	      }
	      if (!(0, _moment2.default)(startDate).isSame(endDate, 'year')) {
	        startFormat = startDate.format('D. MMM, YYYY');
	      }
	      var endFormat = endDate.format('D. MMM, YYYY');
	      return startFormat + ' - ' + endFormat;
	    },
	    tooltipArrowLeft: function tooltipArrowLeft() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span><span>←</span></p>';
	    },
	    tooltipArrowRight: function tooltipArrowRight() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span><span>→</span></p>';
	    },
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    },
	    isAnonymousAccessActivated: function isAnonymousAccessActivated() {
	      return this.calendar && this.calendar.anonymous_access;
	    },
	    canSeePublicCalendar: function canSeePublicCalendar() {
	      var typesThatCanExportCalendar = ['klass', 'kindergarten'];
	      return typesThatCanExportCalendar.indexOf(this.calendarType) > -1;
	    },
	    maxCalendarDate: function maxCalendarDate() {
	      var years = this.$store.state.activeSchoolYears;
	      if (!years || years.length === 0) {
	        return null;
	      }
	      return years.reduce(function (max, year) {
	        return year.employee_time_end > max ? year.employee_time_end : max;
	      }, years[0].employee_time_end);
	    },
	    isAtMaxWeek: function isAtMaxWeek() {
	      if (!this.maxCalendarDate || !this.activeCalendarDate) {
	        return false;
	      }
	      return (0, _moment2.default)(this.activeCalendarDate).isoWeekday(7).format('YYYY-MM-DD') >= this.maxCalendarDate;
	    }
	  },
	  methods: {
	    setIsShowMergeCalendars: function setIsShowMergeCalendars(bool) {
	      this.isShowMergeCalendars = bool;
	      if (!bool) {
	        if (this.activeCalendarDate) {
	          this.$emit('updateEvents');
	        } else {
	          window.location.reload();
	        }
	      }
	    },
	    setIsShowExportCalendarModal: function setIsShowExportCalendarModal(bool) {
	      this.isShowExportCalendarModal = bool;
	    },
	    userHasPermission: function userHasPermission(permission) {
	      var notAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        if (notAdmin) {
	          return this.userPermissions.indexOf(permission) > -1;
	        }
	        return this.userPermissions.indexOf(permission) > -1 || this.user.admin;
	      }
	      return true;
	    },
	    openEditNameModal: function openEditNameModal() {
	      _eventbus2.default.editCalendarNameModal = true;
	    },
	    openDeleteModal: function openDeleteModal() {
	      _eventbus2.default.editCalendarDeleteModal = true;
	    },
	    toggleCalendarLock: function toggleCalendarLock() {
	      var bool = this.isLocked ? 'false' : 'true';
	      this.updateCalendar({ locked: bool });
	    },
	    toggleCalendarView: function toggleCalendarView(state) {
	      this.updateCalendar({ view_state: state });
	    },
	    updateCalendar: function updateCalendar(changesObj) {
	      _docendo2.default.schoolCalendarsUpdate(this.schoolId, this.calendarId, changesObj, function (success) {
	        _eventbus2.default.toast = { text: 'Calendar updated', 'success': true };
	        window.location.reload();
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    archiveCalendar: function archiveCalendar() {
	      var _this = this;
	
	      _docendo2.default.schoolCalendarsUpdate(this.schoolId, this.calendarId, { archived: true }, function (success) {
	        var updateObj = {
	          id: success.id,
	          name: success.name,
	          archived_at: success.archived_at
	        };
	        _this.$store.commit('updateSchoolCalendar', updateObj);
	        _eventbus2.default.toast = { text: 'Calendar updated', 'success': true };
	        window.location.href = '/calendar';
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    openPublicCalendar: function openPublicCalendar() {
	      if (this.calendar.anonymous_access) {
	        var url = this.generatePublicLink(this.calendar);
	        window.open(url, '_blank').focus();
	      } else {
	        var schoolId = this.calendar.school_id ? this.calendar.school_id : this.schoolId;
	        var _url = window.location.origin + '/schools/' + schoolId + '/calendars_setup#/';
	        window.open(_url, '_blank').focus();
	      }
	    },
	    generatePublicLink: function generatePublicLink(calendar) {
	      return window.location.origin + '/calendar/' + calendar.public_id;
	    },
	    toggleCalendarGrid: function toggleCalendarGrid() {
	      this.$emit('toggleGrid');
	    }
	  },
	  beforeMount: function beforeMount() {
	    var _this2 = this;
	
	    if (this.initCalendar) {
	      this.calendar = this.initCalendar;
	    } else {
	      _docendo2.default.calendar(this.calendarId, function (success) {
	        _this2.calendar = success;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      });
	    }
	  }
	};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default, ModalConfirmation: _ModalConfirmation2.default },
	  props: {
	    calendarId: {
	      default: null
	    },
	    firstDayOfTheWeek: {
	      default: 1
	    },
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isConfirmDeletion: false,
	      isDeleteWeek: false,
	      theDeleteDayDate: null,
	      theDeleteText: false,
	      isDeleting: false
	    };
	  },
	
	  computed: {
	    weekDays: function weekDays() {
	      var arr = [];
	      for (var i = this.firstDayOfTheWeek; i < 8; i++) {
	        var weekDayDate = (0, _moment2.default)(this.date).isoWeekday(i);
	        var obj = {
	          date: weekDayDate,
	          name: (0, _moment2.default)(weekDayDate).format('dddd')
	        };
	        arr.push(obj);
	      }
	      return arr;
	    }
	  },
	  methods: {
	    setIsConfirmDeletion: function setIsConfirmDeletion(day) {
	      if (day === 'week') {
	        this.theDeleteText = this.$t('vue2.common.delete') + ' ' + this.$t('vue.deleteday.whole_week');
	        this.isDeleteWeek = true;
	      } else {
	        this.isDeleteWeek = false;
	        this.theDeleteText = this.$t('vue2.common.delete') + ' ' + day.name;
	        this.theDeleteDayDate = day.date;
	      }
	      this.isConfirmDeletion = true;
	    },
	    closeIsConfirmDelete: function closeIsConfirmDelete() {
	      this.isConfirmDeletion = false;
	      this.isDeleteWeek = false;
	      this.theDeleteDayDate = null;
	    },
	    onConfirmDelete: function onConfirmDelete() {
	      if (this.isDeleteWeek) {
	        this.deleteWeek();
	      } else {
	        this.deleteDay();
	      }
	    },
	    deleteDay: function deleteDay() {
	      var _this = this;
	
	      this.isDeleting = true;
	      var from = (0, _moment2.default)(this.theDeleteDayDate).startOf('day').toISOString();
	      var to = (0, _moment2.default)(this.theDeleteDayDate).endOf('day').toISOString();
	      _docendo2.default.deleteEventsRange(this.calendarId, from, to, function (success) {
	        _this.isDeleting = false;
	        _this.closeIsConfirmDelete();
	        _this.$emit('update');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.delete_day_or_week.cant_delete'), success: false };
	      });
	    },
	    deleteWeek: function deleteWeek() {
	      var _this2 = this;
	
	      this.isDeleting = true;
	      var fromDate = this.firstDayOfTheWeek === 1 ? (0, _moment2.default)(this.date).startOf('isoWeek') : (0, _moment2.default)(this.date).startOf('week');
	      var toDate = this.firstDayOfTheWeek === 1 ? (0, _moment2.default)(this.date).endOf('isoWeek') : (0, _moment2.default)(this.date).endOf('week');
	      var from = (0, _moment2.default)(fromDate).toISOString();
	      var to = (0, _moment2.default)(toDate).toISOString();
	      _docendo2.default.deleteEventsRange(this.calendarId, from, to, function (success) {
	        _this2.isDeleting = false;
	        _this2.closeIsConfirmDelete();
	        _this2.$emit('update');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.delete_day_or_week.cant_delete'), success: false };
	      });
	    }
	  }
	};

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    no_lessons: 'Der er ingen lektioner i denne uge'
	  },
	  en: {
	    no_lessons: 'No lessons this week'
	  },
	  nb: {
	    no_lessons: 'Ingen leksjoner denne uken'
	  }
	};
	
	exports.default = {
	  props: {
	    calendarName: {
	      default: 'DCalendarList'
	    },
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    isShowWeekends: {
	      type: Boolean,
	      default: false
	    },
	    firstDayOfWeek: {
	      type: Number,
	      default: 1
	    },
	    isCalendarInPrintMode: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    startDate: function startDate() {
	      return (0, _moment2.default)(this.date).isoWeekday(this.firstDayOfWeek);
	    },
	    endDate: function endDate() {
	      var endDayNum = this.isShowWeekends ? this.firstDayOfWeek + 6 : this.firstDayOfWeek + 4;
	      return (0, _moment2.default)(this.date).isoWeekday(endDayNum);
	    },
	    dateRangeFormatted: function dateRangeFormatted() {
	      var isSameYear = (0, _moment2.default)(this.startDate).format('YYYY') === (0, _moment2.default)(this.endDate).format('YYYY');
	      var start = isSameYear ? (0, _moment2.default)(this.startDate).format('DD MMM') : (0, _moment2.default)(this.startDate).format('ll');
	      var end = (0, _moment2.default)(this.endDate).format('ll');
	      return start + ' - ' + end;
	    },
	    filteredEvents: function filteredEvents() {
	      return this.events;
	    },
	    sortedEvents: function sortedEvents() {
	      return this.filteredEvents.sort(function (a, b) {
	        return (0, _moment2.default)(a.start).unix() - (0, _moment2.default)(b.start).unix();
	      });
	    },
	    eventsSortedInDays: function eventsSortedInDays() {
	      var _this = this;
	
	      var eventsAndDays = [];
	      this.sortedEvents.forEach(function (event, idx) {
	        event.v_start = (0, _moment2.default)(event.start).format('LT');
	        event.v_end = (0, _moment2.default)(event.end).format('LT');
	        if (event.event_type === 'presence') {
	          event.title = _this.$t('vue2.task_overview.work_hours');
	          event.color = '#d9e9fb';
	        }
	        var startTime = event.start;
	        var dateObj = {
	          id: startTime,
	          type: 'dayDate',
	          start: (0, _moment2.default)(startTime).format('YYYY-MM-DD'),
	          showDay: (0, _moment2.default)(startTime).format('dddd'),
	          showDate: (0, _moment2.default)(startTime).format('LL')
	        };
	        if (idx === 0) {
	          eventsAndDays.push(dateObj);
	        }
	        if (idx > 0 && (0, _moment2.default)(event.start).format('YYYY-MM-DD') !== (0, _moment2.default)(_this.sortedEvents[idx - 1].start).format('YYYY-MM-DD')) {
	          eventsAndDays.push(dateObj);
	        }
	        eventsAndDays.push(event);
	      });
	      return eventsAndDays;
	    }
	  }
	};

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    no_lessons: 'Der er ingen lektioner i denne uge'
	  },
	  en: {
	    no_lessons: 'No lessons this week'
	  },
	  nb: {
	    no_lessons: 'Ingen leksjoner denne uken'
	  }
	};
	
	exports.default = {
	  props: {
	    calendarId: {
	      default: 7
	    },
	    calendarName: {
	      default: 'DCalendarList'
	    },
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    isShowWeekends: {
	      type: Boolean,
	      default: false
	    },
	    firstDayOfWeek: {
	      type: Number,
	      default: 1
	    },
	    isCalendarInPrintMode: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    startDate: function startDate() {
	      return (0, _moment2.default)(this.date).isoWeekday(this.firstDayOfWeek);
	    },
	    endDate: function endDate() {
	      var endDayNum = this.isShowWeekends ? this.firstDayOfWeek + 6 : this.firstDayOfWeek + 4;
	      return (0, _moment2.default)(this.date).isoWeekday(endDayNum);
	    },
	    weekDays: function weekDays() {
	      var _this = this;
	
	      var days = [];
	
	      var _loop = function _loop(i) {
	        var day = (0, _moment2.default)(_this.date).isoWeekday(i);
	        var events = _this.eventsWithMetaData.filter(function (event) {
	          return (0, _moment2.default)(event.start).format('YYYY-MM-DD') === day.format('YYYY-MM-DD');
	        });
	        days.push({
	          date: day.format('YYYY-MM-DD'),
	          formatted: _this.getShowDate(day),
	          events: _this.sortEvents(events)
	        });
	      };
	
	      for (var i = this.firstDayOfWeek; i <= this.numberOfDays; i++) {
	        _loop(i);
	      }
	      return days;
	    },
	    numberOfDays: function numberOfDays() {
	      if (this.isShowWeekends) {
	        return this.firstDayOfWeek + 6;
	      } else {
	        return this.firstDayOfWeek + 4;
	      }
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    userSchools: function userSchools() {
	      return this.$store.getters.userSchools;
	    },
	    eventsWithMetaData: function eventsWithMetaData() {
	      var _this2 = this;
	
	      return this.events.map(function (originalLesson) {
	        var lesson = (0, _extends3.default)({}, originalLesson);
	
	        if (lesson.rendering) {
	          (0, _assign2.default)(lesson, {
	            event_starttime: '',
	            event_endtime: '',
	            has_notes: false,
	            has_substitute: false,
	            group: '',
	            teacher: '',
	            v_teachers_arr: [],
	            room: '',
	            substitutes: '',
	            eventDuration: 0,
	            v_other_school: false,
	            v_is_editable: false
	          });
	          return lesson;
	        }
	
	        var stripHtml = function stripHtml(str) {
	          return (str || '').replace(/<(?:.|\n)*?>/gm, '');
	        };
	        var hasNotes = stripHtml(lesson.description) || stripHtml(lesson.notes_for_students) || stripHtml(lesson.teacher_notes) || stripHtml(lesson.learning_goal);
	
	        var groups = [];
	        var allGroups = [];
	        var rooms = [];
	        var allRooms = [];
	        var teachers = [];
	        var allTeachers = [];
	        var students = [];
	        var allStudents = [];
	        var substitutes = [];
	
	        var hasSubstitutes = false;
	        var eventActiveCalendarDuration = 0;
	
	        lesson.calendars.forEach(function (calendar) {
	          var calMeta = _this2.allCalendarsInHash[calendar.calendar_id];
	          if (!calMeta) return;
	
	          var name = calMeta.name;
	          var isCurrent = calendar.calendar_id === _this2.calendarId;
	
	          if (isCurrent) {
	            eventActiveCalendarDuration = calendar.minutes;
	            return;
	          }
	
	          switch (calMeta.type) {
	            case 'klass':
	              allGroups.push(name);
	              if (groups.length < 3) groups.push(name);
	              break;
	            case 'room':
	              allRooms.push(name);
	              if (rooms.length < 3) rooms.push(name);
	              break;
	            case 'user':
	              if (calendar.substitute) {
	                hasSubstitutes = true;
	                substitutes.push(name);
	              } else {
	                allTeachers.push(name);
	                if (teachers.length < 3) teachers.push(name);
	              }
	              break;
	            case 'student':
	              allStudents.push(name);
	              if (students.length < 3) students.push(name);
	              break;
	          }
	        });
	
	        var overflowLabel = function overflowLabel(arr, allArr) {
	          var overflow = allArr.length - 3;
	          if (overflow > 0) arr.push('+' + overflow);
	          return arr.join(', ');
	        };
	
	        (0, _assign2.default)(lesson, {
	          event_starttime: (0, _moment2.default)(lesson.start).locale(_this2.locale).format('LT'),
	          event_endtime: (0, _moment2.default)(lesson.end).locale(_this2.locale).format('LT'),
	          event_key: _this2.calendarId + '_' + lesson.event_id,
	          has_notes: !!hasNotes,
	          has_substitute: hasSubstitutes,
	          group: overflowLabel(groups, allGroups),
	          teacher: overflowLabel(teachers, allTeachers),
	          room: overflowLabel(rooms, allRooms),
	          substitutes: substitutes.join(', '),
	          eventDuration: eventActiveCalendarDuration,
	          v_other_school: _this2.getIsEventOtherSchool(lesson),
	          v_is_editable: _this2.getIsEventEditable(lesson),
	          v_teachers_arr: allTeachers
	        });
	
	        if (_this2.isShowStudents) {
	          lesson.students = overflowLabel(students, allStudents);
	        }
	
	        if (lesson.event_type === 'presence') {
	          lesson.title = _this2.$t('vue2.task_overview.work_hours');
	          lesson.color = '#d9e9fb';
	          lesson.teacher = '';
	        }
	
	        return lesson;
	      });
	    }
	  },
	  methods: {
	    getIsEventEditable: function getIsEventEditable(event) {
	      return this.calendarId * 1 === event.calendar_id && event.event_type !== 'presence';
	    },
	    getIsEventOtherSchool: function getIsEventOtherSchool(event) {
	      return event.event_type !== 'presence' && !this.userSchools[event.school_id];
	    },
	    sortEvents: function sortEvents(events) {
	      return events.sort(function (a, b) {
	        return (0, _moment2.default)(a.start).unix() - (0, _moment2.default)(b.start).unix();
	      });
	    },
	    getShowDate: function getShowDate(date) {
	      return this.locale !== 'en' ? (0, _moment2.default)(date).locale(this.locale).format('ddd[.] DD/MM') : (0, _moment2.default)(date).locale(this.locale).format('ddd MM/DD');
	    }
	  }
	};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _core = __webpack_require__(25);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    calendar: {
	      required: true,
	      default: function _default() {
	        return null;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      selectedCalendarId: null,
	      isDropDown: false,
	      isPopperDone: false,
	      isPopperReady: false,
	      search: '',
	      isKeyboardShortcutsActivated: false,
	      keyboardSelected: null,
	      isMouseMoved: false,
	      isSelectLoading: false
	    };
	  },
	
	  computed: {
	    isSchoolCalendarsLoading: function isSchoolCalendarsLoading() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    calendarName: function calendarName() {
	      return this.calendar ? this.calendar.name : '';
	    },
	    klassCalendars: function klassCalendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    userCalendars: function userCalendars() {
	      return this.$store.getters.userCalendars;
	    },
	    roomCalendars: function roomCalendars() {
	      return this.$store.getters.roomCalendars;
	    },
	    mergeCalendars: function mergeCalendars() {
	      return this.$store.getters.mergeCalendars;
	    },
	    otherCalendars: function otherCalendars() {
	      return this.$store.getters.otherCalendars;
	    },
	    clubCalendars: function clubCalendars() {
	      return this.$store.getters.clubCalendars;
	    },
	    studentCalendars: function studentCalendars() {
	      return this.$store.getters.studentCalendars;
	    },
	    kindergartenCalendars: function kindergartenCalendars() {
	      return this.$store.getters.kindergartenCalendars;
	    },
	    sortedCalendars: function sortedCalendars() {
	      if (this.calendar) {
	        switch (this.calendar.type) {
	          case 'klass':
	            return this.klassCalendars;
	          case 'user':
	            return this.userCalendars;
	          case 'room':
	            return this.roomCalendars;
	          case 'merge':
	            return this.mergeCalendars;
	          case 'other':
	            return this.otherCalendars;
	          case 'club':
	            return this.clubCalendars;
	          case 'student':
	            return this.studentCalendars;
	          case 'kindergarten':
	            return this.kindergartenCalendars;
	          default:
	            return [];
	        }
	      } else {
	        return [];
	      }
	    },
	    sortedCalendarsWithVProps: function sortedCalendarsWithVProps() {
	      var _this = this;
	
	      return this.sortedCalendars.map(function (calendar) {
	        return (0, _extends3.default)({}, calendar, {
	          v_selected: _this.selectedCalendarId === calendar.id
	        });
	      });
	    },
	    calendarQuery: function calendarQuery() {
	      var _this2 = this;
	
	      return this.sortedCalendarsWithVProps.filter(function (item) {
	        return item.name !== null ? item.name.match(new RegExp(_this2.search, 'i')) : '';
	      });
	    }
	  },
	  watch: {
	    calendarQuery: function calendarQuery() {
	      this.keyboardSelected = this.calendarQuery[0] ? this.calendarQuery[0] : null;
	    }
	  },
	  methods: {
	    onMouseMove: function onMouseMove() {
	      this.isMouseMoved = true;
	    },
	    setTheKeyboardSelected: function setTheKeyboardSelected(calendar) {
	      if (!this.isMouseMoved) {
	        return;
	      }
	      this.keyboardSelected = calendar;
	    },
	    getIsTheKeyboardSelected: function getIsTheKeyboardSelected(calendar) {
	      if (!this.keyboardSelected) {
	        return false;
	      } else {
	        return this.keyboardSelected.id === calendar.id;
	      }
	    },
	    nativeSelect: function nativeSelect() {
	      window.location = '/calendars/' + this.selectedCalendarId;
	    },
	    selectCalendar: function selectCalendar(calendarId) {
	      this.isSelectLoading = true;
	      this.selectedCalendarId = calendarId;
	      window.location = '/calendars/' + calendarId;
	      this.setDropdown();
	    },
	    createPopper: function createPopper() {
	      var _this3 = this;
	
	      this.isPopperReady = false;
	      this.isPopperDone = false;
	      var dChild = this.$refs.d_child;
	      var dParent = this.$refs.d_parent;
	      if (this.appendToBody) {
	        document.getElementById('djs-body-click').appendChild(dChild);
	      }
	      (0, _core.createPopper)(dParent, dChild, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, 0]
	          }
	        }]
	      });
	      setTimeout(function (_) {
	        _this3.isPopperReady = true;
	        _this3.isPopperDone = true;
	      }, 0);
	      setTimeout(function (_) {
	        _this3.$refs.inputsearch.focus();
	      }, 200);
	    },
	    setDropdown: function setDropdown() {
	      var _this4 = this;
	
	      this.isDropDown = !this.isDropDown;
	      if (this.isDropDown) {
	        setTimeout(function (_) {
	          _this4.createPopper();
	          _this4.addKeyboardEvents();
	          _this4.keyboardSelected = _this4.calendarQuery.length > 0 ? _this4.calendarQuery[0] : null;
	        }, 0);
	      } else {
	        this.isPopperReady = false;
	        this.isPopperDone = false;
	        this.search = '';
	        this.destroyKeyboardEvents();
	      }
	    },
	    setDropdownFromClick: function setDropdownFromClick() {
	      if (!this.isDropDown) {
	        return;
	      }
	      this.setDropdown();
	    },
	    handleKeyboardNavigation: function handleKeyboardNavigation(event) {
	      var _this5 = this;
	
	      var key = event.key;
	
	      if (this.isDropDown) {
	        if (key === 'Escape') {
	          this.setDropdownFromClick();
	          return;
	        }
	        if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'Enter') {
	          if (this.calendarQuery.length === 0) {
	            return;
	          }
	          var idx = this.keyboardSelected ? this.calendarQuery.findIndex(function (cal) {
	            return cal.id === _this5.keyboardSelected.id;
	          }) : 0;
	          if (key === 'Enter') {
	            if (!this.keyboardSelected) {
	              return;
	            }
	            this.selectCalendar(this.keyboardSelected.id);
	          }
	          if (key === 'ArrowDown') {
	            if (this.calendarQuery.length === idx + 1) {
	              return;
	            }
	            this.keyboardSelected = this.calendarQuery[idx + 1];
	            this.scrollToKeyboardSelected();
	          }
	          if (key === 'ArrowUp') {
	            if (idx === 0) {
	              return;
	            }
	            this.keyboardSelected = this.calendarQuery[idx - 1];
	            this.scrollToKeyboardSelected();
	          }
	        }
	      }
	    },
	    scrollToKeyboardSelected: function scrollToKeyboardSelected() {
	      var _this6 = this;
	
	      setTimeout(function () {
	        var searchFieldHeight = _this6.$refs.ref_d_select_input_container.getBoundingClientRect().height;
	
	        var highlightedCalendar = document.querySelector('.d-list-item.d-list-item--highlighted');
	        var highlightedOffsetTop = highlightedCalendar.offsetTop;
	        var highlightedHeight = highlightedCalendar.getBoundingClientRect().height;
	        var totalHeight = highlightedOffsetTop + highlightedHeight - searchFieldHeight;
	
	        var dropdownScrollTop = _this6.$refs.ref_d_select_calendar_dropdown.scrollTop;
	        var dropdownHeight = _this6.$refs.ref_d_select_calendar_dropdown.getBoundingClientRect().height;
	        var dropdownBottom = dropdownScrollTop + dropdownHeight;
	        if (totalHeight > dropdownBottom) {
	          _this6.isMouseMoved = false;
	          _this6.$refs.ref_d_select_calendar_dropdown.scrollTop = _this6.$refs.ref_d_select_calendar_dropdown.scrollTop + highlightedHeight;
	        }
	
	        if (highlightedOffsetTop - searchFieldHeight < dropdownScrollTop) {
	          _this6.isMouseMoved = false;
	          _this6.$refs.ref_d_select_calendar_dropdown.scrollTop = _this6.$refs.ref_d_select_calendar_dropdown.scrollTop - highlightedHeight;
	        }
	      }, 0);
	    },
	    addKeyboardEvents: function addKeyboardEvents() {
	      if (!this.isKeyboardShortcutsActivated) {
	        window.addEventListener('keydown', this.handleKeyboardNavigation);
	        this.isKeyboardShortcutsActivated = true;
	      }
	    },
	    destroyKeyboardEvents: function destroyKeyboardEvents() {
	      window.addEventListener('keydown', this.handleKeyboardNavigation);
	      this.isKeyboardShortcutsActivated = false;
	    }
	  },
	  mounted: function mounted() {
	    if (this.calendar) {
	      this.selectedCalendarId = this.calendar.id;
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    var dChild = this.$refs.d_child;
	    if (dChild) {
	      dChild.remove();
	    }
	    this.destroyKeyboardEvents();
	  }
	};

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _CopyEvent = __webpack_require__(135);
	
	var _CopyEvent2 = _interopRequireDefault(_CopyEvent);
	
	var _DeleteEventOnward = __webpack_require__(359);
	
	var _DeleteEventOnward2 = _interopRequireDefault(_DeleteEventOnward);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DSelectCalendars = __webpack_require__(348);
	
	var _DSelectCalendars2 = _interopRequireDefault(_DSelectCalendars);
	
	var _AppEIPWYZIWYG = __webpack_require__(55);
	
	var _AppEIPWYZIWYG2 = _interopRequireDefault(_AppEIPWYZIWYG);
	
	var _EventChanges = __webpack_require__(136);
	
	var _EventChanges2 = _interopRequireDefault(_EventChanges);
	
	var _TimeChanger = __webpack_require__(31);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _DSelectSubs = __webpack_require__(351);
	
	var _DSelectSubs2 = _interopRequireDefault(_DSelectSubs);
	
	var _DCalendarShowEventSubFor = __webpack_require__(1492);
	
	var _DCalendarShowEventSubFor2 = _interopRequireDefault(_DCalendarShowEventSubFor);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _EventSwapOrReplace = __webpack_require__(1515);
	
	var _EventSwapOrReplace2 = _interopRequireDefault(_EventSwapOrReplace);
	
	var _DCalendarShowEventUsersNotOnSchool = __webpack_require__(1493);
	
	var _DCalendarShowEventUsersNotOnSchool2 = _interopRequireDefault(_DCalendarShowEventUsersNotOnSchool);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _DModalCancelLesson = __webpack_require__(356);
	
	var _DModalCancelLesson2 = _interopRequireDefault(_DModalCancelLesson);
	
	var _DModalOutOfSchoolLesson = __webpack_require__(358);
	
	var _DModalOutOfSchoolLesson2 = _interopRequireDefault(_DModalOutOfSchoolLesson);
	
	var _DModalDeleteAwayEvent = __webpack_require__(357);
	
	var _DModalDeleteAwayEvent2 = _interopRequireDefault(_DModalDeleteAwayEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    out_of_school: 'Ude af huset',
	    hour: 'time',
	    hours: 'timer',
	    minute: 'minut',
	    minutes: 'minutter',
	    delete_events_onward: 'Slet lektionen fremadrettet',
	    only_one_substitute_per_teacher: 'Det kan kun vælges én vikar per fraværende',
	    go_to_calendar: 'Gå til kalender for denne lektion',
	    copy_event_onward: 'Kopier lektionen',
	    delete_event: 'Slet lektion',
	    settings: 'Indstillinger',
	    activity: 'Historik',
	    learning_goal: 'Læringsmål',
	    meeting_purpose: 'Formål med mødet',
	    content: 'Indhold',
	    agenda: 'Agenda',
	    pupil_preparation: 'Elevforberedelse',
	    decisions_and_resume: 'Beslutninger og resumé',
	    teacher_notes: 'Vikarnoter / Interne noter',
	    internal_notes: 'Noter',
	    unsaved_changes_will_be_lost: 'Du har lavet ændringer, der er ikke er gemt. Vil du gemme ændringer før du lukker?',
	    add_grade: 'Tilføj klasse',
	    swap_lesson: 'Byt lektion',
	    replace_lesson: 'Erstat lektion',
	    only_delete_this: 'Slet kun i denne kalender',
	    this_lesson_counts_as: 'Denne lektion tæller som',
	    you_are_about_to_delete_substitutes: 'Du er ved at slette en lektion med vikar på. Vikaren vil få fjernet sin lektion. Er det meningen?',
	    remove_owner_as_substitute: 'Brugeren sættes i stedet på som underviser på aktiviteten. Skal aktiviteten fjernes helt, så slet den i stedet.',
	    ok: 'OK',
	    edit_date: 'Rediger dato',
	    cancel_event: 'Aflys timen',
	    uncancel_event: 'Fortryd aflysning',
	    canceled: 'Aflyst'
	  },
	  en: {
	    out_of_school: 'Out of school',
	    canceled: 'Canceled',
	    cancel_event: 'Cancel lesson',
	    uncancel_event: 'Undo cancellation',
	    hour: 'hour',
	    hours: 'hours',
	    minute: 'minute',
	    minutes: 'minutes',
	    delete_events_onward: 'Delete this and on same timeslot forward',
	    only_one_substitute_per_teacher: 'Only one substitute can be chosen per teacher',
	    go_to_calendar: 'Go to calendar for the lesson',
	    copy_event_onward: 'Copy lesson onward',
	    delete_event: 'Delete lesson',
	    settings: 'Settings',
	    activity: 'History',
	    learning_goal: 'Learning goal',
	    meeting_purpose: 'Purpose of the meeting',
	    content: 'Content',
	    agenda: 'Agenda',
	    pupil_preparation: 'Homework',
	    decisions_and_resume: 'Decisions and summary',
	    internal_notes: 'Notes',
	    teacher_notes: 'Teachers notes',
	    unsaved_changes_will_be_lost: 'Your unsaved changes will be lost. Save changes before close?',
	    add_grade: 'Add grade/group',
	    swap_lesson: 'Swap Lesson',
	    replace_lesson: 'Replace Lesson',
	    only_delete_this: 'Only delete in this calendar',
	    this_lesson_counts_as: 'This lesson counts as',
	    you_are_about_to_delete_substitutes: 'Du er i ferd med å slette en leksjon med vikar. Vikaren vil få fjernet leksjonen sin. Er det meningen?',
	    remove_owner_as_substitute: 'The user will instead be put on the activity as a teacher. If the activity should be removed entirely, delete it instead.',
	    ok: 'OK',
	    edit_date: 'Edit date'
	  },
	  nb: {
	    out_of_school: 'Utenfor skolen',
	    canceled: 'Avlyst',
	    cancel_event: 'Avlys timen',
	    uncancel_event: 'Angre avlysning',
	    hour: 'time',
	    hours: 'timer',
	    minute: 'minutt',
	    minutes: 'minutter',
	    delete_events_onward: 'Slett denne timen fra nå og fremover',
	    only_one_substitute_per_teacher: 'Det kan kun velges én vikar per lærer',
	    go_to_calendar: 'Gå til denne timens kalender',
	    copy_event_onward: 'Kopier faget',
	    delete_event: 'Slett time',
	    settings: 'Innstillinger',
	    activity: 'Logg',
	    learning_goal: 'Læringsmål',
	    meeting_purpose: 'Formål med møtet',
	    content: 'Innhold',
	    agenda: 'Agenda',
	    pupil_preparation: 'Lekser',
	    decisions_and_resume: 'Beslutninger og sammendrag',
	    teacher_notes: 'Vikarnotater',
	    internal_notes: 'Notater',
	    unsaved_changes_will_be_lost: 'Du har gjort endringer uten å lagre. Vil du lagre før du lukker?',
	    add_grade: 'Legg til klasse',
	    swap_lesson: 'Bytt time',
	    replace_lesson: 'Erstatt time',
	    only_delete_this: 'Slett kun i denne kalender',
	    this_lesson_counts_as: 'Denne leksjonen teller som',
	    you_are_about_to_delete_substitutes: 'You are about to delete a lesson with a substitute. The substitute will have their lesson removed. Is this the intention?',
	    remove_owner_as_substitute: 'Brukeren settes i stedet på som underviser på aktiviteten. Skal aktiviteten fjernes helt, så slett den i stedet.',
	    ok: 'OK',
	    edit_date: 'Rediger dato'
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: {
	    DModalOutOfSchoolLesson: _DModalOutOfSchoolLesson2.default,
	    DModalDeleteAwayEvent: _DModalDeleteAwayEvent2.default,
	    DModalCancelLesson: _DModalCancelLesson2.default,
	    DateSelector: _DateSelector2.default,
	    DCalendarShowEventUsersNotOnSchool: _DCalendarShowEventUsersNotOnSchool2.default,
	    DCalendarsShowEventSubFor: _DCalendarShowEventSubFor2.default,
	    DSelectSubs: _DSelectSubs2.default,
	    ModalConfirmation: _ModalConfirmation2.default,
	    DModal: _DModal2.default,
	    DDropdown: _DDropdown2.default,
	    Loader: _Loader2.default,
	    CopyEvent: _CopyEvent2.default,
	    DSelectCalendars: _DSelectCalendars2.default,
	    weip: _AppEIPWYZIWYG2.default,
	    EventChanges: _EventChanges2.default,
	    TimeChanger: _TimeChanger2.default,
	    DeleteEventOnward: _DeleteEventOnward2.default,
	    EventSwapOrReplace: _EventSwapOrReplace2.default
	  },
	  props: {
	    event: {
	      type: Object,
	      default: function _default() {}
	    },
	    initCalendarId: {},
	    calendar: {
	      type: Object,
	      default: null
	    },
	    isInDCalendar: {
	      type: Boolean,
	      default: false
	    },
	    showSettings: {
	      type: Boolean,
	      default: true
	    },
	    canEditEvent: {
	      type: Boolean,
	      default: true
	    },
	    canEditNotes: {
	      type: Boolean,
	      default: true
	    },
	    isInitEventLoading: {
	      type: Boolean,
	      default: false
	    },
	    isDCalendarInROR: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isEventLoading: false,
	      eventSchoolCalendars: [],
	      isLoadingEventSchoolCalendars: false,
	      eventSchoolUsers: [],
	      isLoadingEventSchoolUsers: false,
	      eventSchoolYears: [],
	      isLoadingEventSchoolYears: false,
	      calendars: [],
	      ownerCalendarId: null,
	      userCalendarIds: [],
	      roomCalendarIds: [],
	      klassCalendarIds: [],
	      studentCalendarIds: [],
	      otherCalendarsIds: [],
	      kindergartenCalendarsIds: [],
	      clubCalendarsIds: [],
	      substituteCalendarIds: [],
	      originalSubstituteCalendarIds: [],
	      substitutionsToSubmit: [],
	      isSubsInputFieldActive: false,
	      theActiveTab: 0,
	      isEditTime: false,
	      isChangesMade: false,
	      updatedStartTime: null,
	      updatedEndTime: null,
	      isConfirmDelete: false,
	      isDeleteOnWard: false,
	      theSubstitutesUserId: null,
	      theSubstituteForUserId: null,
	      noteChanges: {},
	      subToSelectWhoToSubFor: null,
	      isClosingWithoutSaving: false,
	      isUpdating: false,
	      keyboardShortcutAdded: false,
	      isShowKlass: false,
	      isOnlyOwnCalendarTextWarning: false,
	      headerHeight: 192,
	      theRemoveCalendarModal: false,
	      isShowKlassAnimate: false,
	      theChangesMade: {},
	      startDate: (0, _moment2.default)(),
	      isEditDate: false,
	      isCancelLesson: false,
	      isOutOfSchoolLesson: false,
	      isConfirmRemoveOwnerAsSubstitute: false
	    };
	  },
	
	  computed: {
	    isCanceled: function isCanceled() {
	      return this.event.canceled;
	    },
	    isAway: function isAway() {
	      return this.event.away;
	    },
	    isCanEditEvent: function isCanEditEvent() {
	      var eventTypeIsAbsence = this.event.event_type === 'absence';
	      if (!eventTypeIsAbsence) {
	        return this.canEditEvent;
	      }
	
	      if (this.isSalaySystemAbsenceActivated) {
	        return false;
	      }
	      var schoolIdsWithoutDeleteFnc = [29045];
	      return schoolIdsWithoutDeleteFnc.indexOf(this.schoolId) < 0 ? true : this.userHasPermission('can_manage_users');
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    activeSchoolName: function activeSchoolName() {
	      return this.activeSchool ? this.activeSchool.name : '';
	    },
	    dShowEventBodyMaxHeight: function dShowEventBodyMaxHeight() {
	      return this.isChangesMade ? this.headerHeight * 1 + 41 : this.headerHeight;
	    },
	    calendarId: function calendarId() {
	      return this.initCalendarId * 1;
	    },
	    schoolFeatures: function schoolFeatures() {
	      return this.$store.getters.schoolFeatures;
	    },
	    isSalaySystemAbsenceActivated: function isSalaySystemAbsenceActivated() {
	      return this.schoolFeatures.indexOf('kmd_absence') > -1;
	    },
	    isPossibleToDelete: function isPossibleToDelete() {
	      var eventTypeIsAbsence = this.event.event_type === 'absence';
	
	      if (eventTypeIsAbsence && this.isSalaySystemAbsenceActivated) {
	        return false;
	      }
	      var schoolIdsWithoutDeleteFnc = [29045];
	      var isActivatedForUsers = schoolIdsWithoutDeleteFnc.indexOf(this.schoolId) < 0 ? true : this.userHasPermission('can_manage_users');
	      var isOwnerOtherCalendar = this.ownerCalendarType === 'other' ? this.event.calendar_id === this.calendarId : true;
	
	      return (!eventTypeIsAbsence || eventTypeIsAbsence && isActivatedForUsers) && isOwnerOtherCalendar;
	    },
	    eventTypeTranslated: function eventTypeTranslated() {
	      return this.$t('vue2.eventTypes.' + this.event.event_type);
	    },
	    eventDurationForCalendar: function eventDurationForCalendar() {
	      var _this = this;
	
	      var calendar = this.event.calendars.find(function (cal) {
	        return cal.calendar_id === _this.calendarId;
	      });
	      if (!calendar) {
	        return '';
	      }
	      var minutes = calendar.minutes;
	
	      if (minutes >= 60) {
	        var hours = Math.floor(minutes / 60);
	        var remainingMinutes = parseFloat((minutes % 60).toFixed(2));
	        var hourLabel = hours === 1 ? this.i18n[this.locale]['hour'] : this.i18n[this.locale]['hours'];
	        var _minuteLabel = remainingMinutes === 1 ? this.i18n[this.locale]['minute'] : this.i18n[this.locale]['minutes'];
	        return hours + ' ' + hourLabel + ' ' + remainingMinutes + ' ' + _minuteLabel;
	      }
	
	      var rounded = parseFloat(minutes.toFixed(2));
	      var minuteLabel = rounded === 1 ? this.i18n[this.locale]['minute'] : this.i18n[this.locale]['minutes'];
	      return rounded + ' ' + minuteLabel;
	    },
	    eventMainCalendarType: function eventMainCalendarType() {
	      var mainCalendar = this.allCalendarsInHash[this.event.calendar_id];
	      if (mainCalendar) {
	        return mainCalendar.type;
	      } else {
	        return null;
	      }
	    },
	    isShowLearningGoal: function isShowLearningGoal() {
	      return !this.isShowOnlyNotes && !this.isKindergarten;
	    },
	    isShowNotesForStudent: function isShowNotesForStudent() {
	      return !this.isShowOnlyNotes && !this.isKindergarten;
	    },
	    isShowTeacherNotes: function isShowTeacherNotes() {
	      return !this.isKindergarten;
	    },
	    isKindergarten: function isKindergarten() {
	      return this.$store.getters.isKindergarten;
	    },
	    isShowReplaceAndSwap: function isShowReplaceAndSwap() {
	      return this.isCanEditEvent && this.event.event_type !== 'absence' && !this.isKindergarten;
	    },
	    activeEventTypeToSelect: function activeEventTypeToSelect() {
	      var calType = 'klass';
	
	      var eventType = this.event && this.event.event_type ? this.event.event_type : 'v_unknown';
	
	      var schoolIdsWhereAvailableInShowEvent = [60598];
	
	      var calendarType = this.calendar && this.calendar.type ? this.calendar.type : '';
	      if (calendarType === 'klass' && eventType === 'additional_tasks') {
	        return 'klass';
	      }
	      var otherArr = ['other_tasks', 'other_stuff', 'available', 'additional_tasks', 'preparation'];
	      var kindergartenArr = ['with_kids', 'without_kids'];
	
	      if (this.event && this.event.school_id && schoolIdsWhereAvailableInShowEvent.includes(this.event.school_id) && eventType === 'available') {
	        return 'klass';
	      }
	      if (otherArr.includes(eventType)) {
	        return 'other';
	      }
	
	      if (eventType === 'club') {
	        return 'club';
	      }
	
	      if (kindergartenArr.includes(eventType)) {
	        return 'kindergarten';
	      }
	
	      return calType;
	    },
	    isStudentsActivated: function isStudentsActivated() {
	      var schoolFeatures = window.SCHOOL && window.SCHOOL.features ? window.SCHOOL.features : [];
	      return schoolFeatures.indexOf('calendar_student') > -1;
	    },
	    isLoadingEventSchoolCalendarsOrUsers: function isLoadingEventSchoolCalendarsOrUsers() {
	      return this.isLoadingEventSchoolCalendars || this.isLoadingEventSchoolUsers || this.isLoadingEventSchoolYears;
	    },
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    },
	    saveKeyTooltip: function saveKeyTooltip() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span>' + '<span>Enter</span></p>';
	    },
	    escTooltip: function escTooltip() {
	      return '<p class="tooltip-shortcut">' + this.$t('vue2.common.close') + '<span>Esc</span></p>';
	    },
	    ownerCalendarType: function ownerCalendarType() {
	      if (this.allCalendarsInHash && this.allCalendarsInHash[this.event.calendar_id]) {
	        return this.allCalendarsInHash[this.event.calendar_id].type;
	      }
	
	      return null;
	    },
	    isShowOnlyNotes: function isShowOnlyNotes() {
	      var eventTypes = ['reservation'];
	      return this.event ? eventTypes.indexOf(this.event.event_type) > -1 : false;
	    },
	    isCalendarOfTypeOther: function isCalendarOfTypeOther() {
	      var eventTypes = ['other_tasks', 'reservation', 'available', 'additional_tasks', 'preparation', 'pool'];
	      return this.event ? eventTypes.indexOf(this.event.event_type) > -1 : false;
	    },
	    possibleTeachersToSub: function possibleTeachersToSub() {
	      var _this2 = this;
	
	      var possibleTeachersToSub = [];
	      var teachersWithSub = this.calendars.filter(function (cal) {
	        return cal.substitute;
	      }).map(function (calendar) {
	        return calendar.substitute;
	      });
	
	      var users = this.userCalendarIds.slice();
	      if (this.ownerCalendarType === 'user' && this.ownerCalendarId) {
	        users.push(this.ownerCalendarId);
	      }
	      users.forEach(function (userCalId) {
	        var user = _this2.allUsersInCalendarHash[userCalId];
	        if (!user) {
	          console.log('teachersWithSub::user_not_found', userCalId, _this2.allUsersInCalendarHash);
	        } else {
	          if (teachersWithSub.indexOf(user.id) < 0) {
	            possibleTeachersToSub.push(user);
	          }
	        }
	      });
	      return possibleTeachersToSub;
	    },
	    i18n: function i18n() {
	      if (this.isKindergarten) {
	        I18N['da']['go_to_calendar'] = 'Gå til kalender for denne aktivitet';
	        I18N['da']['delete_events_onward'] = 'Slet aktiviteten fremadrettet';
	        I18N['da']['copy_event_onward'] = 'Kopier aktiviteten';
	        I18N['da']['delete_event'] = 'Slet aktivitet';
	      }
	      return I18N;
	    },
	    copyEventEvent: function copyEventEvent() {
	      return _eventbus2.default.copyEventEvent;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      var cals = this.isEventSchoolIdTheSameAsActiveSchoolId ? this.$store.state.calendars : this.eventSchoolCalendars;
	      return cals.reduce(function (obj, item) {
	        obj[item.id] = item;
	        return obj;
	      }, {});
	    },
	    allUsersInHash: function allUsersInHash() {
	      var users = this.isEventSchoolIdTheSameAsActiveSchoolId ? this.$store.state.allUsers : this.eventSchoolUsers;
	      return users.reduce(function (obj, item) {
	        obj[item.id] = item;
	        return obj;
	      }, {});
	    },
	    allUsersInCalendarHash: function allUsersInCalendarHash() {
	      var users = this.isEventSchoolIdTheSameAsActiveSchoolId ? this.$store.state.allUsers : this.eventSchoolUsers;
	      return users.reduce(function (obj, item) {
	        obj[item.user_calendar_id] = item;
	        return obj;
	      }, {});
	    },
	    isEventSchoolIdTheSameAsActiveSchoolId: function isEventSchoolIdTheSameAsActiveSchoolId() {
	      if (!this.event) {
	        return false;
	      }
	      var eventSchoolId = this.event.school_id * 1;
	      var activeSchoolId = this.schoolId * 1;
	      if (eventSchoolId === activeSchoolId) {
	        return true;
	      }
	
	      var schoolIdsFromHornslet = [64478, 62460];
	      return schoolIdsFromHornslet.indexOf(eventSchoolId) > -1 && schoolIdsFromHornslet.indexOf(activeSchoolId) > -1;
	    },
	    getCalendarName: function getCalendarName() {
	      return this.allCalendarsInHash[this.event.calendar_id] ? this.allCalendarsInHash[this.event.calendar_id].name : '';
	    },
	    calendarIds: function calendarIds() {
	      return this.klassCalendarIds.concat(this.roomCalendarIds, this.userCalendarIds, this.substituteCalendarIds, this.studentCalendarIds, this.otherCalendarsIds, this.kindergartenCalendarsIds, this.clubCalendarsIds, [this.ownerCalendarId]);
	    },
	    dayAndDate: function dayAndDate() {
	      if (this.locale === 'nn' || this.locale === 'nb') {
	        return (0, _moment2.default)(this.event.start).format('dddd DD. MMMM YYYY');
	      }
	      try {
	        return (0, _moment2.default)(this.event.start)._d.toLocaleDateString(this.locale, {
	          weekday: 'long',
	          month: 'long',
	          day: '2-digit',
	          year: 'numeric'
	        });
	      } catch (e) {
	        return (0, _moment2.default)(this.event.start).format('LL');
	      }
	    },
	    usersWithSubstitute: function usersWithSubstitute() {
	      var _this3 = this;
	
	      var usersWithSub = [];
	      this.calendars.forEach(function (calendar) {
	        var theCalendar = _this3.allCalendarsInHash[calendar.calendar_id];
	        if (calendar.substitute && theCalendar && theCalendar.type === 'user') {
	          var userWithSub = _this3.allUsersInHash[calendar.substitute];
	          if (userWithSub) {
	            usersWithSub.push(userWithSub.user_calendar_id);
	          }
	        }
	      });
	      return usersWithSub;
	    },
	    formattedEventStart: function formattedEventStart() {
	      return (0, _moment2.default)(this.event.start).format('LT');
	    },
	    formattedEventEnd: function formattedEventEnd() {
	      return (0, _moment2.default)(this.event.end).format('LT');
	    },
	    eventDuration: function eventDuration() {
	      var end = this.event.end;
	      var start = this.event.start;
	      return _moment2.default.duration((0, _moment2.default)(end).diff((0, _moment2.default)(start))).asMinutes();
	    },
	    eventMinutes: function eventMinutes() {
	      var hours = Math.floor(this.eventDuration / 60);
	      var minutes = this.eventDuration - hours * 60;
	      return minutes;
	    },
	    eventHours: function eventHours() {
	      return Math.floor(this.eventDuration / 60);
	    },
	    formattedDuration: function formattedDuration() {
	      var hours = this.eventHours < 1 ? '' : this.eventHours + ' ' + (this.eventHours === 1 ? this.i18n[this.locale]['hour'] : this.i18n[this.locale]['hours']);
	      var minutes = this.eventMinutes >= 1 ? this.eventMinutes + ' min' : '';
	      return hours + ' ' + minutes;
	    },
	    eventUsers: function eventUsers() {
	      var _this4 = this;
	
	      return this.calendars.filter(function (calEvent) {
	        return calEvent.calendar_type === 'user' && !calEvent.substitute && !calEvent.is_substitute;
	      }).map(function (user) {
	        return (0, _extends3.default)({}, user, {
	          v_sub: _this4.findSubstitute(user)
	        });
	      });
	    },
	    eventSubstitutes: function eventSubstitutes() {
	      return this.calendars.filter(function (calEvent) {
	        return calEvent.substitute || calEvent.is_substitute;
	      });
	    },
	    eventRooms: function eventRooms() {
	      return this.calendars.filter(function (calEvent) {
	        return calEvent.calendar_type === 'room';
	      });
	    },
	    eventKlasses: function eventKlasses() {
	      return this.calendars.filter(function (calEvent) {
	        return calEvent.calendar_type === 'klass';
	      });
	    },
	    eventStudents: function eventStudents() {
	      return this.calendars.filter(function (calEvent) {
	        return calEvent.calendar_type === 'student';
	      });
	    },
	    isEveryThingReady: function isEveryThingReady() {
	      return !this.isInitEventLoading && this.locale && !this.isLoadingEventSchoolCalendarsOrUsers;
	    },
	    calsNotOnSchool: function calsNotOnSchool() {
	      var _this5 = this;
	
	      return this.calendars.filter(function (cal) {
	        return !_this5.allCalendarsInHash[cal.calendar_id];
	      });
	    },
	    usersNotOnSchool: function usersNotOnSchool() {
	      return this.calsNotOnSchool.filter(function (cal) {
	        return cal.calendar_type === 'user';
	      });
	    }
	  },
	  watch: {
	    event: function event(val) {
	      this.setTheActiveTab(0);
	      this.checkIfEventSchoolIdIsActiveSchoolId();
	    },
	    isEveryThingReady: function isEveryThingReady(val) {
	      var _this6 = this;
	
	      if (val) {
	        this.$nextTick(function () {
	          if (_this6.$refs.d_show_event_header) {
	            _this6.headerHeight = _this6.$refs.d_show_event_header.getBoundingClientRect().height;
	          }
	        });
	      }
	    }
	  },
	  methods: {
	    setIsOutOfSchoolLesson: function setIsOutOfSchoolLesson(bool) {
	      this.isOutOfSchoolLesson = bool;
	    },
	    onEventUpdated: function onEventUpdated() {
	      this.setIsCancelLesson(false);
	      this.setIsOutOfSchoolLesson(false);
	      this.$emit('updated');
	      this.close();
	    },
	    setIsCancelLesson: function setIsCancelLesson(bool) {
	      this.isCancelLesson = bool;
	    },
	    findSubstitute: function findSubstitute(calEvent) {
	      var _this7 = this;
	
	      var user = this.allUsersInCalendarHash[calEvent.calendar_id];
	      if (!user) {
	        return null;
	      }
	      var userId = user.id;
	      var calEventSubsForUser = this.calendars.filter(function (calendar) {
	        return calendar.substitute === userId;
	      });
	      var names = calEventSubsForUser.filter(function (calEvent) {
	        return _this7.allUsersInCalendarHash[calEvent.calendar_id];
	      }).map(function (user) {
	        return user.name;
	      });
	      return names.join(', ');
	    },
	    setStartDate: function setStartDate(date) {
	      this.startDate = date;
	      this.setChangesMade('date');
	    },
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    setIsShowKlass: function setIsShowKlass(bool) {
	      this.isShowKlassAnimate = true;
	      this.isShowKlass = bool;
	    },
	    onKlassDSelectTransitionDone: function onKlassDSelectTransitionDone() {
	      if (!this.isShowKlassAnimate) {
	        return;
	      }
	      var el = document.querySelector('.input-group__grades .d-select__input-look');
	      el.click();
	    },
	    setIsConfirmDeleteMerge: function setIsConfirmDeleteMerge() {
	      this.isOnlyOwnCalendarTextWarning = true;
	      this.isConfirmDelete = true;
	    },
	    getCalendarNames: function getCalendarNames(calIds) {
	      var _this8 = this;
	
	      var names = calIds.map(function (calId) {
	        var idx = _this8.calendars.findIndex(function (cal) {
	          return cal.calendar_id === calId;
	        });
	        if (idx > -1) {
	          return _this8.calendars[idx].name;
	        }
	      });
	
	      return names.join(', ').toString();
	    },
	    closeClick: function closeClick(evt) {
	      function isTargetCalendarEvent(evt) {
	        var target = evt.target;
	        while (target != null) {
	          if (target.classList.contains('fc-event') || target.classList.contains('day-cal__event')) {
	            return true;
	          }
	          if (target.classList.contains('js-no-close')) {
	            return true;
	          }
	          target = target.parentElement;
	        }
	        return false;
	      }
	
	      if (isTargetCalendarEvent(evt)) {
	        return;
	      }
	      if (this.copyEventEvent || this.isDeleteOnWard) {
	        return;
	      }
	      if (this.isChangesMade) {
	        this.isClosingWithoutSaving = true;
	        return;
	      }
	      this.close();
	    },
	    setTeacherToSub: function setTeacherToSub(teacher) {
	      var obj = {
	        calendar_id: this.subToSelectWhoToSubFor.calendarId,
	        substitute: teacher.id,
	        substitute_for_cal_id: teacher.user_calendar_id
	      };
	      this.calendars.push(obj);
	      this.substitutionsToSubmit.push(obj);
	      this.subToSelectWhoToSubFor = null;
	    },
	    cancelSubToSelectWhoToSubFor: function cancelSubToSelectWhoToSubFor() {
	      this.subToSelectWhoToSubFor.calendarId;
	      this.subToSelectWhoToSubFor = null;
	    },
	    setNoteChanges: function setNoteChanges(note, noteType) {
	      this.$set(this.noteChanges, noteType, note);
	      this.setChangesMade('notes');
	    },
	    setChangesMade: function setChangesMade(changeType) {
	      this.$set(this.theChangesMade, changeType, true);
	      this.isChangesMade = true;
	    },
	    setIsDeleteOnWard: function setIsDeleteOnWard() {
	      this.$refs.d_show_event.click();
	      this.isDeleteOnWard = true;
	    },
	    openCopyEventDropdown: function openCopyEventDropdown() {
	      _eventbus2.default.copyEventEvent = this.event;
	    },
	    goToCalendarForLesson: function goToCalendarForLesson() {
	      if (this.isInDCalendar && !this.isDCalendarInROR) {
	        this.$store.commit('setActiveCalendarId', this.event.calendar_id);
	        this.close();
	      } else {
	        window.location.href = window.location.href = '/calendars/' + this.event.calendar_id;
	        this.close();
	      }
	    },
	    updateStartTime: function updateStartTime(time) {
	      var newStartTime = (0, _moment2.default)(this.event.start).hours((0, _moment2.default)(time).hours()).minutes((0, _moment2.default)(time).minutes());
	      this.updatedStartTime = newStartTime;
	      this.setChangesMade('time');
	    },
	    updateEndTime: function updateEndTime(time) {
	      var newEndTime = (0, _moment2.default)(this.event.end).hours((0, _moment2.default)(time).hours()).minutes((0, _moment2.default)(time).minutes());
	      this.updatedEndTime = newEndTime;
	      this.setChangesMade('time');
	    },
	    save: function save() {
	      var _this9 = this;
	
	      if (this.isUpdating) return;
	      this.isClosingWithoutSaving = false;
	      var updates = [{
	        event_id: this.event.event_id
	      }];
	      var isOwnerSubRemoved = this.originalSubstituteCalendarIds.includes(this.ownerCalendarId) && !this.substituteCalendarIds.includes(this.ownerCalendarId);
	      var allCalendarIds = this.calendarIds.concat(this.calsNotOnSchool.map(function (cal) {
	        return cal.calendar_id;
	      }).filter(function (calendarId) {
	        return !_this9.calendarIds.includes(calendarId);
	      })).filter(function (calendarId, idx, arr) {
	        return arr.indexOf(calendarId) === idx;
	      });
	      if (this.theChangesMade['calendars']) {
	        updates[0]['calendar_ids'] = allCalendarIds;
	      }
	      if (this.theChangesMade['time']) {
	        updates[0]['start_time'] = this.updatedStartTime;
	        updates[0]['end_time'] = this.updatedEndTime;
	      }
	      if (this.theChangesMade['date']) {
	        var newStartDate = (0, _moment2.default)(this.updatedStartTime).year((0, _moment2.default)(this.startDate).year()).month((0, _moment2.default)(this.startDate).month()).date((0, _moment2.default)(this.startDate).date());
	
	        var diffInDays = (0, _moment2.default)(this.updatedEndTime).diff((0, _moment2.default)(this.updatedStartTime), 'days');
	
	        var newEndDate = (0, _moment2.default)(newStartDate).add(diffInDays, 'days');
	
	        newEndDate = newEndDate.hour((0, _moment2.default)(this.updatedEndTime).hour()).minute((0, _moment2.default)(this.updatedEndTime).minute()).second((0, _moment2.default)(this.updatedEndTime).second());
	
	        updates[0]['start_time'] = newStartDate;
	        updates[0]['end_time'] = newEndDate;
	      }
	
	      var noteKeys = (0, _keys2.default)(this.noteChanges);
	      if (noteKeys.length > 0) {
	        var noteChanges = {
	          event_id: this.event.event_id
	        };
	        noteKeys.forEach(function (key) {
	          noteChanges[key] = _this9.noteChanges[key];
	        });
	        updates.push(noteChanges);
	      }
	
	      var subCalIdsToRemove = this.originalSubstituteCalendarIds.filter(function (x) {
	        return !_this9.substituteCalendarIds.includes(x);
	      }).filter(function (x) {
	        return x !== _this9.ownerCalendarId;
	      });
	      if (subCalIdsToRemove.length > 0) {
	        updates['remove_substitute_calendar_id'] = subCalIdsToRemove[0];
	      }
	      subCalIdsToRemove.forEach(function (subCalId) {
	        var removeSub = {
	          event_id: _this9.event.event_id,
	          remove_substitute_calendar_id: subCalId
	        };
	        updates.push(removeSub);
	      });
	
	      if (isOwnerSubRemoved) {
	        updates.push({
	          event_id: this.event.event_id,
	          remove_substitute_calendar_id: this.ownerCalendarId
	        });
	        updates.push({
	          event_id: this.event.event_id,
	          calendar_ids: allCalendarIds
	        });
	      }
	
	      var subsWithoutSubFor = this.substitutionsToSubmit.filter(function (subObj) {
	        return !subObj.substitute_for_cal_id;
	      });
	      this.substitutionsToSubmit.filter(function (subObj) {
	        return subObj.substitute_for_cal_id;
	      }).forEach(function (subObj) {
	        var subUpdate = {
	          event_id: _this9.event.event_id,
	          calendar_id: subObj.substitute_for_cal_id,
	          add_substitute_calendar_id: subObj.calendar_id
	        };
	        updates.push(subUpdate);
	      });
	      var addSubsWithoutSubForThenPersist = function addSubsWithoutSubForThenPersist() {
	        if (subsWithoutSubFor.length < 1) {
	          persist();
	          return;
	        }
	        var doneCount = 0;
	        var onDone = function onDone() {
	          doneCount++;
	          if (doneCount === subsWithoutSubFor.length) {
	            persist();
	          }
	        };
	        subsWithoutSubFor.forEach(function (subObj) {
	          var user = _this9.allUsersInCalendarHash[subObj.calendar_id];
	          if (!user) {
	            onDone();
	            return;
	          }
	          _docendo2.default.eventAddSubstitute(_this9.event.event_id, user.id, null, onDone, onDone);
	        });
	      };
	      var persist = function persist() {
	        var updatedLesson = {
	          school_id: _this9.event.school_id,
	          updates: updates
	        };
	        if (_this9.isInDCalendar) {
	          if (_this9.isCanEditEvent) {
	            _this9.$store.dispatch('updateCalendarEvent', updatedLesson);
	          } else {
	            var updateEvent = {
	              schoolId: _this9.event.school_id,
	              eventId: _this9.event.event_id,
	              updates: _this9.noteChanges
	            };
	            _this9.$store.dispatch('updateCalendarEventNotes', updateEvent);
	          }
	          _this9.close();
	        } else {
	          _this9.isEventLoading = true;
	          _docendo2.default.updateEvents(updatedLesson.school_id, updatedLesson.updates, function (success) {
	            _this9.$emit('updated');
	            _this9.close();
	          });
	        }
	      };
	      var periodChanged = this.theChangesMade['date'] || this.theChangesMade['time'];
	      var newStart = updates[0]['start_time'] || this.event.start;
	      var newEnd = updates[0]['end_time'] || this.event.end;
	      var samePeriod = (0, _moment2.default)(newStart).format('YYYY-MM-DD HH:mm') === (0, _moment2.default)(this.event.start).format('YYYY-MM-DD HH:mm') && (0, _moment2.default)(newEnd).format('YYYY-MM-DD HH:mm') === (0, _moment2.default)(this.event.end).format('YYYY-MM-DD HH:mm');
	      if (this.isAway && periodChanged && !samePeriod) {
	        this.isUpdating = true;
	        this.applyAwayPeriodLessonUpdates(newStart, newEnd, function (overlapUpdates) {
	          _this9.isUpdating = false;
	          updates = updates.concat(overlapUpdates);
	          addSubsWithoutSubForThenPersist();
	        });
	        return;
	      }
	      addSubsWithoutSubForThenPersist();
	    },
	    eventHasOtherKlasses: function eventHasOtherKlasses(ev, tripKlassIds) {
	      var calendars = ev && (ev.calendars || ev.calendar_events) || [];
	      var klassIds = calendars.filter(function (c) {
	        return c && c.calendar_type === 'klass';
	      }).map(function (c) {
	        return c.calendar_id;
	      });
	      if (klassIds.length === 0) return false;
	      return klassIds.some(function (id) {
	        return tripKlassIds.indexOf(id) === -1;
	      });
	    },
	    fetchKlassEventsForPeriod: function fetchKlassEventsForPeriod(calendarIds, start, end, callback) {
	      if (!calendarIds || calendarIds.length === 0) {
	        callback([]);
	        return;
	      }
	      _docendo2.default.calendarEvents2(calendarIds, (0, _moment2.default)(start).format('YYYY-MM-DD HH:mm'), (0, _moment2.default)(end).format('YYYY-MM-DD HH:mm'), null, function (success) {
	        callback(success && success.length > 0 ? JSON.parse(success) : []);
	      }, function () {
	        callback([]);
	      });
	    },
	    applyAwayPeriodLessonUpdates: function applyAwayPeriodLessonUpdates(newStart, newEnd, callback) {
	      var _this10 = this;
	
	      var selfId = this.event.event_id;
	      var oldKlassIds = (this.event.calendars || []).filter(function (c) {
	        return c && c.calendar_type === 'klass';
	      }).map(function (c) {
	        return c.calendar_id;
	      });
	      var newKlassIds = (this.klassCalendarIds || []).slice();
	      var ownerCal = (this.event.calendars || []).find(function (c) {
	        return c && c.calendar_id === _this10.event.calendar_id;
	      });
	      if (ownerCal && ownerCal.calendar_type === 'klass' && newKlassIds.indexOf(ownerCal.calendar_id) === -1) {
	        newKlassIds.push(ownerCal.calendar_id);
	      }
	      if (newKlassIds.length === 0) {
	        newKlassIds = oldKlassIds;
	      }
	
	      var pending = 2;
	      var oldEvents = [];
	      var newEvents = [];
	      var done = function done() {
	        pending -= 1;
	        if (pending > 0) return;
	        var cancelCandidates = newEvents.filter(function (ev) {
	          var notAlreadyCanceled = ev && ev.canceled !== true;
	          var notAlreadyAway = ev && ev.away !== true;
	          var notSelf = !selfId || ev.event_id !== selfId && ev.id !== selfId;
	          var hasOtherKlasses = _this10.eventHasOtherKlasses(ev, newKlassIds);
	          return notAlreadyCanceled && notAlreadyAway && notSelf && !hasOtherKlasses;
	        });
	        var cancelIds = {};
	        cancelCandidates.forEach(function (ev) {
	          cancelIds[ev.event_id || ev.id] = true;
	        });
	        var restoreCandidates = oldEvents.filter(function (ev) {
	          var isCanceled = ev && ev.canceled === true;
	          var notAway = ev && ev.away !== true;
	          var notSelf = !selfId || ev.event_id !== selfId && ev.id !== selfId;
	          var eventId = ev.event_id || ev.id;
	          return isCanceled && notAway && notSelf && !cancelIds[eventId];
	        });
	        var overlapUpdates = restoreCandidates.map(function (ev) {
	          return { event_id: ev.event_id || ev.id, canceled: false };
	        }).concat(cancelCandidates.map(function (ev) {
	          return { event_id: ev.event_id || ev.id, canceled: true };
	        }));
	        callback(overlapUpdates);
	      };
	      this.fetchKlassEventsForPeriod(oldKlassIds, this.event.start, this.event.end, function (events) {
	        oldEvents = events;
	        done();
	      });
	      this.fetchKlassEventsForPeriod(newKlassIds, newStart, newEnd, function (events) {
	        newEvents = events;
	        done();
	      });
	    },
	    closeIsConfirmDelete: function closeIsConfirmDelete() {
	      this.isOnlyOwnCalendarTextWarning = false;
	      this.isConfirmDelete = false;
	    },
	    onAwayEventDeleted: function onAwayEventDeleted() {
	      this.isConfirmDelete = false;
	      if (this.isInDCalendar) {
	        this.$store.commit('setActiveCalendarEventId', null);
	        this.$store.commit('deleteActiveCalendarEvent', this.event);
	        this.$store.dispatch('readCalendarSubjects');
	      }
	      this.$emit('updated');
	      this.close();
	    },
	    deleteEvent: function deleteEvent() {
	      var _this11 = this;
	
	      this.isConfirmDelete = true;
	      if (this.isOnlyOwnCalendarTextWarning) {
	        _docendo2.default.deleteEventCalendar(this.event.event_id, this.calendarId, function (success) {
	          _this11.$emit('updated');
	          _this11.isOnlyOwnCalendarTextWarning = false;
	          _this11.close();
	        });
	      } else {
	        if (this.isInDCalendar) {
	          this.$store.dispatch('deleteEvent', this.event);
	          this.close();
	        } else {
	          this.isEventLoading = true;
	          _docendo2.default.deleteEvent(this.event.school_id, this.event.event_id, function (success) {
	            _this11.$emit('updated');
	            _this11.close();
	          });
	        }
	      }
	    },
	    updateAndClose: function updateAndClose() {
	      this.$emit('updated');
	      this.close();
	    },
	    setIsEditTime: function setIsEditTime() {
	      this.setChangesMade('time');
	    },
	    isTheActiveTab: function isTheActiveTab(tab) {
	      return this.theActiveTab === tab;
	    },
	    setTheActiveTab: function setTheActiveTab(tab) {
	      this.theActiveTab = tab;
	    },
	    submitDeleteEventOnward: function submitDeleteEventOnward() {
	      this.$emit('submitDeleteEventOnward');
	      this.close();
	    },
	    close: function close() {
	      var _this12 = this;
	
	      this.isClosingWithoutSaving = false;
	      this.resetChangesMade();
	      this.$nextTick(function (_) {
	        _this12.$emit('close');
	      });
	    },
	    setSelectedUsers: function setSelectedUsers(users) {
	      this.userCalendarIds = users.map(function (user) {
	        return user.id;
	      });
	      this.setChangesMade('calendars');
	    },
	    setSelectedSubstitutes: function setSelectedSubstitutes(users) {
	      var _this13 = this;
	
	      this.setChangesMade('substitutes');
	      var before = this.substituteCalendarIds;
	      var after = users.map(function (user) {
	        return user.id;
	      });
	      var subCalIdsToAdd = after.filter(function (x) {
	        return !before.includes(x);
	      });
	      var subCalIdsToRemove = before.filter(function (x) {
	        return !after.includes(x);
	      });
	
	      if (subCalIdsToRemove.indexOf(this.ownerCalendarId) > -1 && this.originalSubstituteCalendarIds.indexOf(this.ownerCalendarId) > -1) {
	        this.isConfirmRemoveOwnerAsSubstitute = true;
	
	        this.substituteCalendarIds = this.substituteCalendarIds.slice();
	        return;
	      }
	      this.substituteCalendarIds = users.map(function (user) {
	        return user.id;
	      });
	      if (subCalIdsToRemove.length > 0) {
	        subCalIdsToRemove.forEach(function (calId) {
	          var idx = _this13.calendars.findIndex(function (cal) {
	            return cal.calendar_id === calId && (cal.substitute || cal.is_substitute);
	          });
	          if (idx > -1) {
	            _this13.calendars.splice(idx, 1);
	          }
	          var idx2 = _this13.substitutionsToSubmit.findIndex(function (cal) {
	            return cal.calendar_id === calId;
	          });
	          if (idx2 > -1) {
	            _this13.substitutionsToSubmit.splice(idx2, 1);
	          }
	        });
	      }
	
	      if (subCalIdsToAdd.length > 0) {
	        var selfSubCalIds = subCalIdsToAdd.filter(function (calId) {
	          return calId === _this13.ownerCalendarId || _this13.userCalendarIds.indexOf(calId) > -1;
	        });
	        selfSubCalIds.forEach(function (calId) {
	          var obj = {
	            calendar_id: calId,
	            substitute: true,
	            substitute_for_cal_id: null
	          };
	          _this13.calendars.push(obj);
	          _this13.substitutionsToSubmit.push(obj);
	        });
	        var subCalIdsNeedingSubFor = subCalIdsToAdd.filter(function (calId) {
	          return selfSubCalIds.indexOf(calId) < 0;
	        });
	        if (subCalIdsNeedingSubFor.length < 1) {
	          return;
	        }
	
	        if (this.possibleTeachersToSub.length === 1) {
	          subCalIdsNeedingSubFor.forEach(function (calId) {
	            var user = _this13.possibleTeachersToSub[0];
	            if (user) {
	              var obj = {
	                calendar_id: calId,
	                substitute: user.id,
	                substitute_for_cal_id: user.user_calendar_id
	              };
	              _this13.calendars.push(obj);
	              _this13.substitutionsToSubmit.push(obj);
	            }
	          });
	        }
	
	        if (this.possibleTeachersToSub.length > 1) {
	          this.subToSelectWhoToSubFor = {
	            calendarId: subCalIdsNeedingSubFor[0],
	            name: this.allUsersInCalendarHash[subCalIdsNeedingSubFor[0]].name
	          };
	          return;
	        }
	      }
	    },
	    confirmRemoveOwnerAsSubstitute: function confirmRemoveOwnerAsSubstitute() {
	      var _this14 = this;
	
	      this.isConfirmRemoveOwnerAsSubstitute = false;
	      this.setChangesMade('substitutes');
	
	      this.substituteCalendarIds = this.substituteCalendarIds.filter(function (calId) {
	        return calId !== _this14.ownerCalendarId;
	      });
	      var idx = this.substitutionsToSubmit.findIndex(function (subObj) {
	        return subObj.calendar_id === _this14.ownerCalendarId;
	      });
	      if (idx > -1) {
	        this.substitutionsToSubmit.splice(idx, 1);
	      }
	    },
	    setSelectedRooms: function setSelectedRooms(rooms) {
	      this.roomCalendarIds = rooms.map(function (cal) {
	        return cal.id;
	      });
	      this.setChangesMade('calendars');
	    },
	    setSelectedKlasses: function setSelectedKlasses(klasses) {
	      this.klassCalendarIds = klasses.map(function (cal) {
	        return cal.id;
	      });
	      this.setChangesMade('calendars');
	    },
	    setSelectedStudents: function setSelectedStudents(cals) {
	      this.studentCalendarIds = cals.map(function (cal) {
	        return cal.id;
	      });
	      this.setChangesMade('calendars');
	    },
	    setSelectedOtherCalendar: function setSelectedOtherCalendar(cals) {
	      this.otherCalendarsIds = cals.map(function (cal) {
	        return cal.id;
	      });
	      this.setChangesMade('calendars');
	    },
	    setSelectedKindergartenCalendar: function setSelectedKindergartenCalendar(cals) {
	      this.kindergartenCalendarsIds = cals.map(function (cal) {
	        return cal.id;
	      });
	      this.setChangesMade('calendars');
	    },
	    setSelectedClubCalendar: function setSelectedClubCalendar(cals) {
	      this.clubCalendarsIds = cals.map(function (cal) {
	        return cal.id;
	      });
	      this.setChangesMade('calendars');
	    },
	    resetChangesMade: function resetChangesMade() {
	      this.theChangesMade = {};
	      this.isChangesMade = false;
	    },
	    reset: function reset() {
	      this.ownerCalendarId = null;
	      this.userCalendarIds = [];
	      this.roomCalendarIds = [];
	      this.klassCalendarIds = [];
	      this.otherCalendarsIds = [];
	      this.kindergartenCalendarsIds = [];
	      this.clubCalendarsIds = [];
	      this.substituteCalendarIds = [];
	      this.originalSubstituteCalendarIds = [];
	      this.studentCalendarIds = [];
	      this.isShowKlass = false;
	      this.isOnlyOwnCalendarTextWarning = false;
	      this.resetChangesMade();
	    },
	    setInitialEventData: function setInitialEventData() {
	      var _this15 = this;
	
	      this.reset();
	      this.updatedStartTime = this.event.start;
	      this.updatedEndTime = this.event.end;
	      this.startDate = this.event.start;
	      this.event.calendars.forEach(function (calendar) {
	        if (calendar.calendar_id === _this15.event.calendar_id) {
	          _this15.ownerCalendarId = calendar.calendar_id;
	
	          if (calendar.calendar_type === 'user' && (calendar.substitute || calendar.is_substitute)) {
	            _this15.substituteCalendarIds.push(calendar.calendar_id);
	            _this15.originalSubstituteCalendarIds.push(calendar.calendar_id);
	          }
	        } else {
	          var theCalendar = calendar;
	          if (theCalendar) {
	            switch (theCalendar.calendar_type) {
	              case 'klass':
	                if (_this15.ownerCalendarId !== calendar.calendar_id) {
	                  _this15.isShowKlass = true;
	                }
	                _this15.klassCalendarIds.push(calendar.calendar_id);
	                break;
	              case 'room':
	                _this15.roomCalendarIds.push(calendar.calendar_id);
	                break;
	              case 'other':
	                _this15.otherCalendarsIds.push(calendar.calendar_id);
	                break;
	              case 'club':
	                _this15.clubCalendarsIds.push(calendar.calendar_id);
	                break;
	              case 'kindergarten':
	                _this15.kindergartenCalendarsIds.push(calendar.calendar_id);
	                break;
	              case 'student':
	                _this15.studentCalendarIds.push(calendar.calendar_id);
	                break;
	              case 'user':
	                if (calendar.substitute || calendar.is_substitute) {
	                  _this15.substituteCalendarIds.push(calendar.calendar_id);
	                  _this15.originalSubstituteCalendarIds.push(calendar.calendar_id);
	                } else {
	                  _this15.userCalendarIds.push(calendar.calendar_id);
	                }
	                break;
	            }
	          }
	        }
	      });
	
	      this.calendars = JSON.parse((0, _stringify2.default)(this.event.calendars));
	    },
	    setConfirmationMessage: function setConfirmationMessage(e) {
	      var confirmMessage = 'Continue without saving?';
	      if (this.isChangesMade) {
	        (e || window.event).returnValue = confirmMessage;
	        return confirmMessage;
	      }
	    },
	    handleKeyboardShortcut1: function handleKeyboardShortcut1(e) {
	      if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
	        if (e.target.closest && e.target.closest('.d-select')) {
	          return;
	        }
	        e.preventDefault();
	        this.save();
	      }
	    },
	    handleKeyboardShortcut2: function handleKeyboardShortcut2(e) {
	      if (e.key === 'Escape') {
	        e.preventDefault();
	        if (this.isChangesMade) {
	          this.isClosingWithoutSaving = true;
	          return;
	        }
	        this.close();
	      }
	    },
	    checkIfEventSchoolIdIsActiveSchoolId: function checkIfEventSchoolIdIsActiveSchoolId() {
	      var _this16 = this;
	
	      this.eventSchoolCalendars = [];
	      this.eventSchoolUsers = [];
	      var isUsersLoaded = false;
	      var isCalendarsLoaded = false;
	      var isSchoolYearsLoaded = false;
	      if (!this.event) {
	        return;
	      }
	      if (this.isEventSchoolIdTheSameAsActiveSchoolId) {
	        this.setInitialEventData();
	      } else {
	        this.isLoadingEventSchoolCalendars = true;
	        _docendo2.default.calendarsForSchool(this.event.school_id, function (data) {
	          _this16.eventSchoolCalendars = data;
	          _this16.isLoadingEventSchoolCalendars = false;
	          isCalendarsLoaded = true;
	          if (isUsersLoaded && isSchoolYearsLoaded) {
	            _this16.setInitialEventData();
	          }
	        });
	        this.isLoadingEventSchoolUsers = true;
	        _docendo2.default.schoolUsers2(this.event.school_id, function (data) {
	          _this16.eventSchoolUsers = data;
	          _this16.isLoadingEventSchoolUsers = false;
	          isUsersLoaded = true;
	          if (isCalendarsLoaded && isSchoolYearsLoaded) {
	            _this16.setInitialEventData();
	          }
	        });
	        this.isLoadingEventSchoolYears = true;
	        _docendo2.default.schoolYearsRead(this.event.school_id, '', 'id', function (data) {
	          _this16.eventSchoolYears = data.filter(function (year) {
	            return year.active;
	          });
	          _this16.isLoadingEventSchoolYears = false;
	          isSchoolYearsLoaded = true;
	          if (isCalendarsLoaded && isUsersLoaded) {
	            _this16.setInitialEventData();
	          }
	        });
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.checkIfEventSchoolIdIsActiveSchoolId();
	    window.addEventListener('beforeunload', this.setConfirmationMessage);
	
	    if (!this.keyboardShortcutAdded) {
	      window.addEventListener('keydown', this.handleKeyboardShortcut1);
	      window.addEventListener('keydown', this.handleKeyboardShortcut2);
	      this.keyboardShortcutAdded = true;
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('beforeunload', this.setConfirmationMessage);
	
	    window.removeEventListener('keydown', this.handleKeyboardShortcut1);
	    window.removeEventListener('keydown', this.handleKeyboardShortcut2);
	    this.keyboardShortcutAdded = false;
	  }
	};

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    which_teacher_will: 'Hvilken person skal',
	    be_substitute_for: 'være vikar for'
	  },
	  en: {
	    which_teacher_will: 'Which teacher will',
	    be_substitute_for: 'be a substitute for'
	  },
	  nb: {
	    which_teacher_will: 'Hvilken lærer bør',
	    be_substitute_for: 'være vikar for'
	  }
	};
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    substitute: {},
	    teachers: {
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N;
	    }
	  }
	};

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _CalendarViewDayRemoveOrReplace = __webpack_require__(342);
	
	var _CalendarViewDayRemoveOrReplace2 = _interopRequireDefault(_CalendarViewDayRemoveOrReplace);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    following_persons_are_on_the_lesson_but_not_on_school: 'Følgende personer er på lektionen, men er ikke tilknyttet ',
	    sub: 'Vikar',
	    remove: 'Fjern',
	    from_this_lesson: 'fra denne lektion',
	    remove_or_replace: 'Eller vil du gerne fjerne eller erstatte',
	    on: 'på',
	    onwards: 'fremadrettet'
	  },
	  nb: {
	    following_persons_are_on_the_lesson_but_not_on_school: 'Følgende personer er lagt til timen, men er ikke tilknyttet ',
	    sub: 'Vikar',
	    remove: 'Fjern',
	    from_this_lesson: 'fra denne timen',
	    remove_or_replace: 'Eller vil du fjerne eller erstatte',
	    on: 'på',
	    onwards: 'fremover'
	  },
	  en: {
	    following_persons_are_on_the_lesson_but_not_on_school: 'The following staff are in the lesson but are not staff on ',
	    sub: 'Sub',
	    remove: 'Remove',
	    from_this_lesson: 'from this lesson',
	    remove_or_replace: 'Or would you like to remove or replace',
	    on: 'on',
	    onwards: 'onwards'
	  }
	};
	
	exports.default = {
	  components: { DModal: _DModal2.default, CalendarViewDayRemoveOrReplace: _CalendarViewDayRemoveOrReplace2.default },
	  props: {
	    usersNotOnSchool: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    activeSchoolName: {
	      default: ''
	    },
	    event: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      theRemoveCalendar: null,
	      isRemoving: false
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    userCalendars: function userCalendars() {
	      var _this = this;
	
	      if (this.theRemoveCalendar === null) {
	        return this.$store.getters.userCalendars;
	      } else {
	        return this.$store.getters.userCalendars.filter(function (calendar) {
	          return !_this.sameCalendarId(calendar.id, _this.theRemoveCalendar.id);
	        });
	      }
	    }
	  },
	  methods: {
	    sameCalendarId: function sameCalendarId(a, b) {
	      return a != null && b != null && String(a) === String(b);
	    },
	    isEventOwner: function isEventOwner(calendar) {
	      return this.event && this.sameCalendarId(this.event.calendar_id, calendar.calendar_id);
	    },
	    removeCalendar: function removeCalendar(calendar) {
	      var _this2 = this;
	
	      if (this.isRemoving || !this.event || !calendar || !calendar.id) {
	        return;
	      }
	      this.isRemoving = true;
	      _docendo2.default.eventRemoveCalendar(this.event.school_id, this.event.event_id, calendar.id, function (success) {
	        _this2.isRemoving = false;
	        _eventbus2.default.toast = { text: _this2.$t('vue2.substitution.lessons_updated'), 'success': true };
	        _this2.setTheRemoveCalendar(null);
	        _this2.$emit('updateAndClose');
	      }, function (failure) {
	        _this2.isRemoving = false;
	        _eventbus2.default.toast = { text: 'Sorry, that failed', 'success': false };
	        console.log('failure', failure);
	      });
	    },
	    updateAndClose: function updateAndClose() {
	      this.setTheRemoveCalendar(null);
	      this.$emit('updateAndClose');
	    },
	    setTheRemoveCalendar: function setTheRemoveCalendar(calendar) {
	      if (calendar === null) {
	        this.theRemoveCalendar = null;
	        this.isRemoving = false;
	        return;
	      }
	      var calObj = {
	        name: calendar.name,
	        id: calendar.calendar_id
	      };
	      this.theRemoveCalendar = calObj;
	    }
	  }
	};

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CreateSubject = __webpack_require__(384);
	
	var _CreateSubject2 = _interopRequireDefault(_CreateSubject);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ImportSubjectsToKlass = __webpack_require__(385);
	
	var _ImportSubjectsToKlass2 = _interopRequireDefault(_ImportSubjectsToKlass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SUBJETS_ALL_TYPES = {
	  subject: {
	    da: {
	      name: 'Fag',
	      order: 1
	    },
	    en: {
	      name: 'Subject',
	      order: 1
	    },
	    nb: {
	      name: 'Fag',
	      order: 1
	    }
	  },
	  optional: {
	    da: {
	      name: 'Valgfag/Hold',
	      order: 2
	    },
	    en: {
	      name: 'Optional grades/groups',
	      order: 2
	    },
	    nb: {
	      name: 'Valgfag/gruppe',
	      order: 2
	    }
	  },
	  supplemental: {
	    da: {
	      name: 'UUV',
	      order: 6
	    },
	    en: {
	      name: 'UUV',
	      order: 6
	    },
	    nb: {
	      name: 'UUV',
	      order: 6
	    }
	  },
	  frame: {
	    da: {
	      name: 'Temavisning',
	      order: 3
	    },
	    en: {
	      name: 'Theme',
	      order: 3
	    },
	    nb: {
	      name: 'Temavisning',
	      order: 3
	    }
	  },
	  break: {
	    da: {
	      name: 'Pause',
	      order: 7
	    },
	    en: { name: 'Break', order: 7 },
	    nb: {
	      name: 'Pause',
	      order: 7
	    }
	  },
	  resource: {
	    da: {
	      name: 'Ressource (skjult)',
	      order: 4
	    },
	    en: {
	      name: 'Resource (hidden)',
	      order: 4
	    },
	    nb: {
	      name: 'Ressurs (skjult)',
	      order: 4
	    }
	  },
	  person_resource: {
	    da: {
	      name: 'Ressource (skjult)',
	      order: 4
	    },
	    en: {
	      name: 'Resource (hidden)',
	      order: 4
	    },
	    nb: {
	      name: 'Ressurs (skjult)',
	      order: 4
	    }
	  },
	  other_tasks: {
	    da: {
	      name: 'Anden tid <span class="pill pill--grey hint--top-right hint--medium" aria-label="Udfases fra skoleåret 21/22 pga. den nye arbejdstidsaftale (A20)">udfases</span>',
	      order: 13
	    },
	    en: { name: 'Other tasks', order: 13 },
	    nb: { name: 'Annen tid', order: 13 }
	  },
	  other_stuff: {
	    da: {
	      name: 'Øvrig tid <span class="pill pill--grey hint--top-right hint--medium" aria-label="Udfases fra skoleåret 21/22 pga. den nye arbejdstidsaftale (A20)">udfases</span>',
	      order: 12
	    },
	    en: {
	      name: 'Additional tasks',
	      order: 12
	    },
	    nb: {
	      name: 'Øvrig tid',
	      order: 12
	    }
	  },
	  available: {
	    da: {
	      name: 'Rådighedstime',
	      order: 11
	    },
	    en: {
	      name: 'On-Call',
	      order: 11
	    }
	  },
	  person_resource_visible: {
	    da: {
	      name: 'Ressource (synlig)',
	      order: 5
	    },
	    en: {
	      name: 'Resource (Visible)',
	      order: 5
	    },
	    nb: {
	      name: 'Ressurs (Vises for elever)',
	      order: 5
	    }
	  },
	  club: {
	    da: {
	      name: 'SFO tid',
	      order: 8
	    },
	    en: { name: 'SFO time', order: 8 },
	    nb: { name: 'SFO tid', order: 8 }
	  },
	  additional_tasks: {
	    da: {
	      name: 'Øvrige opgaver',
	      order: 9
	    },
	    en: { name: 'Not teaching', order: 9 },
	    nb: { name: 'Øvrige oppgaver', order: 9 }
	  },
	  pool: {
	    da: {
	      name: 'Lokalpulje',
	      order: 9
	    }
	  },
	  preparation: {
	    da: {
	      name: 'Forberedelse',
	      order: 10
	    },
	    en: {
	      name: 'Preparation',
	      order: 10
	    },
	    nb: {
	      name: 'Forberedelse',
	      order: 10
	    }
	  },
	  reservation: {
	    da: {
	      name: 'Reservation',
	      order: 11
	    },
	    en: {
	      name: 'Reservation',
	      order: 11
	    },
	    nb: {
	      name: 'Reservasjon',
	      order: 11
	    }
	  },
	  activity: {
	    da: {
	      name: 'Aktiviteter',
	      order: 11
	    },
	    en: {
	      name: 'Activities',
	      order: 11
	    },
	    nb: {
	      name: 'Aktiviteter',
	      order: 11
	    }
	  },
	  absence: {
	    da: {
	      name: 'Fravær',
	      order: 12
	    },
	    en: {
	      name: 'Absence',
	      order: 12
	    },
	    nb: {
	      name: 'Fravær',
	      order: 12
	    }
	  },
	  exercise: {
	    da: {
	      name: 'Bevægelse',
	      order: 21
	    }
	  },
	  flextime: {
	    da: {
	      name: 'Flextid',
	      order: 22
	    }
	  },
	  pay_supplement: {
	    da: {
	      name: 'Tillæg',
	      order: 13
	    }
	  },
	  without_kids: {
	    da: {
	      name: 'Uden børn',
	      order: 2
	    }
	  },
	  with_kids: {
	    da: {
	      name: 'Med børn',
	      order: 1
	    }
	  }
	};
	var SUBJECTS_TYPE_WITH_REMEMBER_TEACHER = {
	  subject: true,
	  resource: true,
	  optional: true,
	  exercise: true,
	  club: true,
	  supplemental: true
	};
	
	var SCHOOL_YEAR_WITH_REDUCED_HOURS = '2026-2027';
	var I18N = {
	  da: {
	    cant_edit: 'Kan ikke redigeres fra kalenderen',
	    hours_per_year: 't/år',
	    add: 'Tilføj'
	  },
	  en: {
	    cant_edit: 'Can not edit from the calendar',
	    hours_per_year: 'h/year',
	    add: 'Add'
	  },
	  nb: {
	    cant_edit: 'Kan ikke redigeres fra kalenderen',
	    hours_per_year: 't/år',
	    add: 'Legg til'
	  }
	};
	exports.default = {
	  components: { ImportSubjectsToKlass: _ImportSubjectsToKlass2.default, Loader: _Loader2.default, CreateSubject: _CreateSubject2.default },
	  props: {
	    calendarId: {
	      default: 7
	    },
	    dragActiveDate: {
	      type: Object,
	      default: function _default() {
	        return null;
	      }
	    },
	    locale: {
	      default: 'en'
	    },
	    school: {
	      default: null
	    },
	    deleteSubject: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      startX: 0,
	      startY: 0,
	      startClientY: 0,
	      startClientX: 0,
	      delta: 5,
	      activeSubject: null,
	      movedY: 0,
	      movedX: 0,
	      activeSubjectBCR: null,
	      theActiveAcc: null,
	      accTransition: null,
	      isDraggingSubject: false,
	      isDCalATrashcan: false
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    isReducedHoursSchoolYear: function isReducedHoursSchoolYear() {
	      var year = this.$store.state.localActivatedSchoolYear;
	      return !!year && year.name === SCHOOL_YEAR_WITH_REDUCED_HOURS;
	    },
	    theUser: function theUser() {
	      return this.$store.state.user;
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    localPoolTitle: function localPoolTitle() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || this.$t('vue2.task_overview.pool');
	    },
	    isShowImportSubjectsOption: function isShowImportSubjectsOption() {
	      var schoolCountry = this.school && this.school.country ? this.school && this.school.country.toLowerCase() : 'da';
	      return this.subjects.length < 1 && this.allKlassCalendarsInAHash[this.calendarId] && (schoolCountry === 'no' || schoolCountry === 'dk');
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    calendarType: function calendarType() {
	      return this.allCalendarsInHash[this.calendarId] ? this.allCalendarsInHash[this.calendarId].type : '';
	    },
	    allKlassCalendarsInAHash: function allKlassCalendarsInAHash() {
	      return this.$store.getters.allKlassCalendarsInHash;
	    },
	    subjects: function subjects() {
	      return this.$store.state.calendar.subjects;
	    },
	    isSubjectsLoading: function isSubjectsLoading() {
	      return this.$store.state.calendar.isSubjectsLoading;
	    },
	    theActiveAccSubjects: function theActiveAccSubjects() {
	      var _this = this;
	
	      return this.allSubjects.filter(function (subject) {
	        return subject.subject_type === _this.theActiveAcc;
	      });
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    theUserIsAdmin: function theUserIsAdmin() {
	      return this.userHasPermission('can_manage_school');
	    },
	    isPermissionToSeeAbsence: function isPermissionToSeeAbsence() {
	      if (this.schoolId !== 29045) {
	        return true;
	      } else {
	        return this.theUserIsAdmin;
	      }
	    },
	    filteredSubjects: function filteredSubjects() {
	      var _this2 = this;
	
	      return this.subjects.filter(function (subject) {
	        if (_this2.isPermissionToSeeAbsence) {
	          return subject;
	        } else {
	          return subject.subject_type !== 'absence';
	        }
	      });
	    },
	    allSubjects: function allSubjects() {
	      var _this3 = this;
	
	      var sortedSubjects = this.filteredSubjects.sort(function (a, b) {
	        if (a.name && b.name) {
	          return a.name.localeCompare(b.name, undefined, {
	            numeric: true,
	            sensitivity: 'base'
	          });
	        }
	      });
	      return sortedSubjects.map(function (subject) {
	        var title = subject.calendar_id === _this3.calendarId * 1 ? subject.name : subject.name + ', ' + subject.calendar_name;
	        _this3.$set(subject, 'title', title);
	        if (subject.subject_type === 'absence' || subject.subject_type === 'flexin' || subject.subject_type === 'flexout') {
	          _this3.$set(subject, 'v_is_editable', false);
	          _this3.$set(subject, 'v_hours', '');
	          _this3.$set(subject, 'v_other_school', false);
	          _this3.$set(subject, 'v_cal_types', _this3.getCalUsers(subject));
	        } else {
	          var plannedHours = _this3.calendarSubjectHours(subject);
	          var hours = subject.actual_hours ? plannedHours - Math.floor(subject.actual_hours) : plannedHours * 1;
	          _this3.$set(subject, 'v_hours', hours.toFixed(0));
	          _this3.$set(subject, 'v_other_school', false);
	          _this3.$set(subject, 'v_is_editable', true);
	          _this3.$set(subject, 'v_cal_types', _this3.getCalUsers(subject));
	        }
	        if (SUBJECTS_TYPE_WITH_REMEMBER_TEACHER[subject.subject_type] && _this3.calendarType !== 'user') {
	          subject.v_must_have_teacher = true;
	        }
	        return subject;
	      });
	    },
	    subjectsInCategories: function subjectsInCategories() {
	      var subjectsAcc = [];
	      this.allSubjects.forEach(function (subject) {
	        var idx = subjectsAcc.findIndex(function (subjectAcc) {
	          return subjectAcc.type === subject.subject_type;
	        });
	        if (idx < 0) {
	          subjectsAcc.push({ type: subject.subject_type, subjects: [subject] });
	        } else {
	          subjectsAcc[idx].subjects.push(subject);
	        }
	      });
	      return subjectsAcc;
	    },
	    subjectsInCategoriesSorted: function subjectsInCategoriesSorted() {
	      var _this4 = this;
	
	      return this.subjectsInCategories.map(function (subCat) {
	        var name = subCat.type;
	        var order = 100;
	        if (SUBJETS_ALL_TYPES[subCat.type]) {
	          var localized = SUBJETS_ALL_TYPES[subCat.type][_this4.locale] ? SUBJETS_ALL_TYPES[subCat.type][_this4.locale] : SUBJETS_ALL_TYPES[subCat.type]['da'];
	          name = localized.name;
	          order = localized.order;
	        }
	        if (subCat.type === 'pool') {
	          name = _this4.localPoolTitle;
	        }
	        subCat.v_order = order;
	        subCat.v_title = name;
	        return subCat;
	      }).sort(function (a, b) {
	        return a.v_order > b.v_order ? 1 : -1;
	      });
	    },
	    activeSubjects: function activeSubjects() {
	      var _this5 = this;
	
	      var activeSubjects = this.subjectsInCategoriesSorted.filter(function (subjectsGroup) {
	        return subjectsGroup.type === _this5.theActiveAcc;
	      });
	      return activeSubjects && activeSubjects[0] && activeSubjects[0].subjects ? activeSubjects[0].subjects : [];
	    }
	  },
	  watch: {
	    calendarId: function calendarId(val) {
	      if (val) {
	        var isNewCalendar = true;
	        this.$store.dispatch('readCalendarSubjects', isNewCalendar);
	      }
	    },
	    deleteSubject: function deleteSubject(val) {
	      if (!val) {
	        this.isDCalATrashcan = false;
	      }
	    }
	  },
	  methods: {
	    calendarSubjectHours: function calendarSubjectHours(subject) {
	      var _this6 = this;
	
	      if (this.isReducedHoursSchoolYear && Array.isArray(subject.subject_calendars)) {
	        var match = subject.subject_calendars.find(function (sc) {
	          return sc.calendar_id === _this6.calendarId * 1;
	        });
	        if (match && match.hours !== null && match.hours !== undefined && match.hours !== '') {
	          var parsed = parseFloat(match.hours);
	          if (!isNaN(parsed)) {
	            return parsed;
	          }
	        }
	      }
	
	      return subject.hours;
	    },
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.theUser) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.theUser.admin;
	      } else {
	        return true;
	      }
	    },
	    onMouseEnter: function onMouseEnter(evt) {
	      if (!this.deleteSubject) {
	        return;
	      }
	      this.isDCalATrashcan = true;
	      this.$emit('onMouseEnter');
	    },
	    onMouseLeave: function onMouseLeave(evt) {
	      this.isDCalATrashcan = false;
	      if (!this.deleteSubject) {
	        return;
	      }
	      this.$emit('onMouseLeave');
	    },
	    startTrans: function startTrans(el) {
	      el.style.height = el.scrollHeight + 'px';
	    },
	    endTrans: function endTrans(el) {
	      el.style.height = '';
	    },
	    tippyContent: function tippyContent(subject) {
	      if (!subject.v_is_editable) {
	        return this.i18n[this.locale]['cant_edit'];
	      } else {
	        return subject.v_cal_types.toolTipText;
	      }
	    },
	    tippySettings: function tippySettings(subject) {
	      if (!subject.v_is_editable) {
	        return {
	          trigger: 'click',
	          arrow: true,
	          onShow: this.hideTippy,
	          zIndex: '999999992',
	          boundary: 'window'
	        };
	      } else {
	        return {
	          arrow: true,
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function onShow() {
	            return subject.v_cal_types.toolTipText.length > 0;
	          }
	        };
	      }
	    },
	    getCalUsers: function getCalUsers(subject) {
	      var users = [];
	      var rooms = [];
	      if (subject.cals) {
	        subject.cals.forEach(function (cal) {
	          switch (cal.calendar_type) {
	            case 'user':
	              users.push(cal.name);
	              break;
	            case 'room':
	              rooms.push(cal.name);
	              break;
	          }
	        });
	      }
	      return { users: users, rooms: rooms, toolTipText: users.concat(rooms).join(', ') };
	    },
	    setTheActiveAcc: function setTheActiveAcc(subjectType) {
	      var key = 'd_subject_acc_' + this.calendarId;
	      if (this.theActiveAcc === subjectType) {
	        this.theActiveAcc = null;
	        if (this.$helpers.getCookie(key)) {
	          this.$helpers.deleteCookie(key);
	        }
	      } else {
	        this.theActiveAcc = subjectType;
	        if (subjectType !== 'absence') {
	          this.$helpers.setCookie(key, subjectType);
	        }
	      }
	    },
	    onMouseDown: function onMouseDown(subject, evt) {
	      if (evt.button !== 0) {
	        return;
	      }
	      var el = evt.target.closest('li');
	      this.activeSubjectBCR = el.getBoundingClientRect();
	      this.$emit('setDragLesson', subject);
	      this.$emit('setActiveSubjectBCR', el.getBoundingClientRect());
	
	      this.activeSubject = subject;
	      this.startX = evt.pageX;
	      this.startY = evt.pageY;
	      this.startClientY = evt.clientY;
	      this.startClientX = evt.clientX;
	      evt.target.releasePointerCapture(evt.pointerId);
	      document.addEventListener('pointermove', this.onMouseMove);
	      document.addEventListener('pointerup', this.onMouseUp);
	    },
	    onMouseUp: function onMouseUp(evt) {
	      this.getIsDragOrClick(evt);
	      document.removeEventListener('pointermove', this.onMouseMove);
	      document.removeEventListener('pointerup', this.onMouseUp);
	      this.cleanUp();
	      this.$emit('doMouseUp');
	    },
	    getIsDragOrClick: function getIsDragOrClick(event) {
	      if (!this.isDraggingSubject) {
	        if (this.activeSubject.v_is_editable) {
	          this.$store.commit('setEditSubject', this.activeSubject);
	        }
	      }
	    },
	    onMouseMove: function onMouseMove(evt) {
	      this.movedY = evt.pageY - (this.startClientY - this.activeSubjectBCR.top);
	      this.movedX = evt.pageX - (this.startClientX - this.activeSubjectBCR.left);
	      this.$emit('movedXY', this.movedX, this.movedY);
	      if (!this.isDraggingSubject) {
	        this.setIsDraggingSubject(true);
	      }
	      this.$emit('movedXY', this.movedX, this.movedY);
	    },
	    setIsDraggingSubject: function setIsDraggingSubject(boolean) {
	      if (boolean) {
	        this.isDraggingSubject = true;
	        var subjectObj = {
	          calendarId: this.activeSubject.calendar_id,
	          subjectId: this.activeSubject.id
	        };
	        this.$store.dispatch('readSubjectAvailability', subjectObj);
	      } else {
	        this.isDraggingSubject = false;
	      }
	    },
	    cleanUp: function cleanUp() {
	      this.setIsDraggingSubject(false);
	      this.activeSubject = null;
	      this.$emit('movedXY', null, null);
	      this.$emit('setIsDraggingExternalEvent', false);
	      this.$store.dispatch('clearAvailability');
	      var el = this.$refs.d_cal_dragged;
	      if (el) {
	        el.remove();
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    var key = 'd_subject_acc_' + this.calendarId;
	    if (this.$helpers.getCookie(key)) {
	      this.setTheActiveAcc(this.$helpers.getCookie(key));
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('readCalendarSubjects');
	  }
	};

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _DSchedulerItem = __webpack_require__(1496);
	
	var _DSchedulerItem2 = _interopRequireDefault(_DSchedulerItem);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SchedulerItem: _DSchedulerItem2.default,
	    Spinner: _Loader2.default
	  },
	  directives: {
	    scroll: {
	      inserted: function inserted(el, binding) {
	        var f = function f(evt) {
	          if (binding.value(evt, el)) {
	            el.removeEventListener('scroll', f);
	          }
	        };
	        el.addEventListener('scroll', f);
	      }
	    }
	  },
	  props: {
	    calendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    title: {
	      type: String,
	      default: 'Teachers'
	    },
	    isLoading: {
	      type: Boolean,
	      default: false
	    },
	    sortBy: {
	      type: String,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isSyncingLeftScroll: false,
	      isSyncingRightScroll: false,
	      isSyncingTopScroll: false,
	      tags: [],
	      rows: {}
	    };
	  },
	
	  watch: {
	    rows: function rows() {
	      this.$refs.rightDiv.scrollLeft = 480;
	      this.$refs.topDiv.scrollLeft = 480;
	    }
	  },
	  filters: {
	    round: function round(num) {
	      return Math.round(num);
	    }
	  },
	  computed: {
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    items: function items() {
	      var _this = this;
	
	      var calendars = JSON.parse((0, _stringify2.default)(this.calendars));
	      var evts = JSON.parse((0, _stringify2.default)(this.events));
	      var cals = calendars.map(function (cal) {
	        var icon = '';
	        switch (cal.type) {
	          case 'user':
	            icon = 'icon-user';
	            break;
	          case 'room':
	            icon = 'icon-location';
	            break;
	          case 'klass':
	            icon = 'icon-calendar4';
	            break;
	          case 'other':
	            icon = 'icon-clipboard2';
	            break;
	          case 'merge':
	            icon = 'icon-calendar-week';
	            break;
	          case 'club':
	            icon = 'icon-users5';
	            break;
	        }
	        _this.$set(cal, 'dCalIcon', icon);
	        _this.$set(cal, 'userLessons', []);
	        _this.$set(cal, 'dayEvents', []);
	        _this.$set(cal, 'dayPresence', []);
	        _this.$set(cal, 'firstEvent', null);
	        _this.$set(cal, 'lastEvent', null);
	        return cal;
	      });
	      evts.forEach(function (event) {
	        _this.$set(event, 'v_calIds', []);
	        _this.$set(event, 'v_groups', []);
	        _this.$set(event, 'v_group_names', '');
	        _this.$set(event, 'v_users', []);
	        _this.$set(event, 'v_subs_for_user_ids', []);
	        _this.$set(event, 'v_room_ids', []);
	        _this.$set(event, 'v_has_teachers', false);
	        _this.$set(event, 'v_user_names_obj', {});
	        _this.$set(event, 'v_user_names', '');
	        if (event.calendars) {
	          event.calendars.forEach(function (calendar) {
	            var cal = _this.allCalendarsInHash[calendar.calendar_id];
	            if (cal) {
	              if (event.v_calIds.indexOf(cal.id) < 0) {
	                event.v_calIds.push(cal.id);
	              }
	              if (cal.type === 'klass') {
	                event.v_groups.push(cal);
	                event.v_group_names += event.v_group_names.length === 0 ? ' ' + cal.name : ', ' + cal.name;
	              }
	              if (cal.type === 'user') {
	                if (calendar.substitute) {
	                  event.v_subs_for_user_ids.push(calendar.substitute);
	                }
	                event.v_has_teachers = true;
	                event.v_users.push(cal);
	                var userId = _this.allUsersInCalIdHash[calendar.calendar_id] ? _this.allUsersInCalIdHash[calendar.calendar_id].id : null;
	                var userObj = {
	                  userId: userId,
	                  name: cal.name ? cal.name : '',
	                  isSubstituted: false
	                };
	                event.v_user_names_obj[userId] = userObj;
	              }
	              if (cal.type === 'room') {
	                event.v_room_ids.push(cal.id);
	              }
	            }
	          });
	        }
	        if (event.event_type === 'presence') {
	          var addPresenceCalId = function addPresenceCalId(calId) {
	            if (calId && event.v_calIds.indexOf(calId) < 0) {
	              event.v_calIds.push(calId);
	            }
	          };
	          addPresenceCalId(event.calendar_id);
	          if (event.calendar_events) {
	            event.calendar_events.forEach(function (calendarEvent) {
	              addPresenceCalId(calendarEvent.calendar_id);
	            });
	          }
	        }
	
	        event.v_subs_for_user_ids.forEach(function (userId) {
	          if (event.v_user_names_obj[userId]) {
	            event.v_user_names_obj[userId].isSubstituted = true;
	          }
	        });
	        (0, _keys2.default)(event.v_user_names_obj).forEach(function (key) {
	          var user = event.v_user_names_obj[key];
	          if (user.isSubstituted) {
	            event.v_user_names += '<p class="striketrough">' + user.name + '</p>';
	          } else {
	            event.v_user_names += '<p>' + user.name + '</p>';
	          }
	        });
	        event.v_calIds.forEach(function (calId) {
	          var idx = cals.findIndex(function (cal) {
	            return cal.id === calId;
	          });
	          if (idx > -1) {
	            if (event.event_type === 'presence') {
	              cals[idx].dayPresence.push(event);
	            } else {
	              cals[idx].dayEvents.push(event);
	              if (!cals[idx]['firstEvent'] || (0, _moment2.default)(event.start).isBefore(cals[idx]['firstEvent'])) {
	                cals[idx]['firstEvent'] = new Date(event.start).getTime();
	              }
	              if (!cals[idx]['lastEvent'] || (0, _moment2.default)(event.end).isAfter(cals[idx]['lastEvent'])) {
	                cals[idx]['lastEvent'] = new Date(event.end).getTime();
	              }
	            }
	          }
	        });
	      });
	      return cals;
	    },
	    itemsSorted: function itemsSorted() {
	      if (!this.sortBy) {
	        var userLocale = 'en';
	        return this.items.sort(function (a, b) {
	          return a.name.localeCompare(b.name, userLocale, {
	            numeric: true,
	            sensitivity: 'base'
	          });
	        });
	      }
	      if (this.sortBy === 'firstEvent') {
	        return this.items.sort(function (itemA, itemB) {
	          var a = itemA['firstEvent'];
	          var b = itemB['firstEvent'];
	          return (a === null) - (b === null) || +(a > b) || -(a < b);
	        });
	      }
	      if (this.sortBy === 'lastEvent') {
	        return this.items.sort(function (itemA, itemB) {
	          var a = itemA['lastEvent'];
	          var b = itemB['lastEvent'];
	          return (a === null) - (b === null) || -(a > b) || +(a < b);
	        });
	      }
	      return this.items;
	    },
	    hoursInLocale: function hoursInLocale() {
	      var hours = [];
	      for (var i = 0; i < 24; i++) {
	        hours.push((0, _moment2.default)().set({ hour: i, minutes: 0, seconds: 0 }));
	      }
	      return hours;
	    }
	  },
	  methods: {
	    setRows: function setRows(obj, userid) {
	      this.$set(this.rows, userid, obj.rows);
	    },
	    handleScrollRight: function handleScrollRight(evt, el) {
	      if (!this.isSyncingRightScroll) {
	        this.isSyncingLeftScroll = true;
	        this.isSyncingTopScroll = true;
	        this.$refs.leftDiv.scrollTop = el.scrollTop;
	        this.$refs.topDiv.scrollLeft = el.scrollLeft;
	      }
	      this.isSyncingRightScroll = false;
	    },
	    handleScrollLeft: function handleScrollLeft(evt, el) {
	      if (!this.isSyncingLeftScroll) {
	        this.isSyncingRightScroll = true;
	        this.$refs.rightDiv.scrollTop = el.scrollTop;
	      }
	      this.isSyncingLeftScroll = false;
	    },
	    handleScrollTop: function handleScrollTop(evt, el) {
	      if (!this.isSyncingTopScroll) {
	        this.isSyncingRightScroll = true;
	        this.$refs.rightDiv.scrollLeft = el.scrollLeft;
	      }
	      this.isSyncingTopScroll = false;
	    }
	  }
	};

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	
	exports.default = {
	  props: {
	    user: {}
	  },
	  data: function data() {
	    return {
	      slotWidth: 40,
	      slotHeight: 40,
	      rows: 1,
	      firstEvent: true,
	      correctEvents: [],
	      subScoreMeta: [],
	      oldSubScoreMeta: []
	    };
	  },
	
	  computed: {
	    userLessons: function userLessons() {
	      return this.user.dayEvents;
	    },
	    userPresence: function userPresence() {
	      return this.user.dayPresence;
	    },
	    userPresenceForPlacing: function userPresenceForPlacing() {
	      var _this = this;
	
	      return this.userPresence.map(function (event) {
	        return {
	          'left': _this.eventTop(event),
	          'right': _this.eventRight(event),
	          'obj': event
	        };
	      });
	    },
	    sortedEvents: function sortedEvents() {
	      var arr = this.userLessons;
	      return arr.sort(function (a, b) {
	        return moment(a.start).unix() - moment(b.start).unix();
	      });
	    }
	  },
	  watch: {
	    sortedEvents: function sortedEvents() {
	      this.rows = 1;
	      this.$emit('rows', { 'rows': this.rows });
	      this.correctEvents.splice(0, this.correctEvents.length);
	      this.setWidthAndLeft();
	    }
	  },
	  methods: {
	    isActiveEvent: function isActiveEvent(event) {
	      return this.activeEvent && event.obj.id === this.activeEvent.obj.id && this.activeUser && this.user.id === this.activeUser.id;
	    },
	    eventRight: function eventRight(event) {
	      var time = moment.duration({
	        minutes: moment(event.end).format('mm'),
	        hours: moment(event.end).format('HH')
	      }).asMinutes();
	      var endOfDay = moment.duration({
	        hours: 24,
	        minutes: 0
	      }).asMinutes();
	      return this.slotWidth * 2 / 60 * (endOfDay - time);
	    },
	    eventTop: function eventTop(event) {
	      var calStartTime = moment(event.start).set({
	        'hour': 0,
	        'minutes': 0
	      });
	      var eventStartTime = moment(event.start);
	      var duration = moment(eventStartTime).diff(calStartTime);
	      return this.slotHeight * 2 / 60 * moment.duration(duration).asMinutes();
	    },
	    eventHeight: function eventHeight(event) {
	      var duration = moment(event.end).diff(event.start);
	      return this.slotHeight * 2 / 60 * moment.duration(duration).asMinutes();
	    },
	    eventBottom: function eventBottom(event) {
	      var calStartTime = moment(event.end).set({
	        'hour': 0,
	        'minutes': 0
	      });
	      var eventEndTime = moment(event.end);
	      var duration = moment(eventEndTime).diff(calStartTime);
	      return this.slotHeight * 2 / 60 * moment.duration(duration).asMinutes();
	    },
	    collidesWith: function collidesWith(a, b) {
	      return a.bottom > b.top && a.top < b.bottom;
	    },
	    packEvents: function packEvents(columns) {
	      var n = columns.length;
	      for (var i = 0; i < n; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev = col[j];
	          var colSpan = this.expandEvent(ev, i, columns);
	          col[j].row = i;
	          if (i + 1 > this.rows) {
	            this.rows = i + 1;
	          }
	          this.$emit('rows', { 'rows': this.rows });
	          col[j].colspan = colSpan / n;
	          this.correctEvents.push(col[j]);
	
	          if (this.firstEvent) {
	            this.$emit('lessonsUpdate', this.correctEvents[0]);
	          }
	          this.firstEvent = false;
	        }
	      }
	    },
	    expandEvent: function expandEvent(ev, iColumn, columns) {
	      var colSpan = 1;
	      for (var i = iColumn + 1; i < columns.length; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev1 = col[j];
	          if (this.collidesWith(ev, ev1)) {
	            return colSpan;
	          }
	        }
	        colSpan++;
	      }
	      return colSpan;
	    },
	    setWidthAndLeft: function setWidthAndLeft() {
	      var _this2 = this;
	
	      var columns = [];
	      var lastEventEnding = null;
	      var events = this.sortedEvents.map(function (elem) {
	        var top = _this2.eventTop(elem);
	        var height = _this2.eventHeight(elem);
	        var bottom = _this2.eventBottom(elem);
	        var right = _this2.eventRight(elem);
	        return {
	          'obj': elem,
	          'top': top,
	          'left': top,
	          'right': right,
	          'height': height,
	          'bottom': bottom,
	          'subs': [],
	          'othersOnLesson': elem.teacher,
	          'klassesOnLesson': elem.group
	        };
	      });
	      events.sort(function (e1, e2) {
	        if (e1.top < e2.top) return -1;
	        if (e1.top > e2.top) return 1;
	        if (e1.bottom < e2.bottom) return -1;
	        if (e1.bottom > e2.bottom) return 1;
	        return 0;
	      });
	      for (var i = 0; i < events.length; i++) {
	        var e = events[i];
	        if (lastEventEnding !== null && e.top >= lastEventEnding) {
	          this.packEvents(columns);
	          columns = [];
	          lastEventEnding = null;
	        }
	        var placed = false;
	        for (var j = 0; j < columns.length; j++) {
	          var col = columns[j];
	          if (!this.collidesWith(col[col.length - 1], e)) {
	            col.push(e);
	            placed = true;
	            break;
	          }
	        }
	        if (!placed) {
	          columns.push([e]);
	        }
	        if (lastEventEnding === null || e.bottom > lastEventEnding) {
	          lastEventEnding = e.bottom;
	        }
	      }
	      if (columns.length > 0) {
	        this.packEvents(columns);
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.rows = 1;
	    this.$emit('rows', { 'rows': this.rows });
	    this.setWidthAndLeft();
	  }
	};

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Spinner = __webpack_require__(26);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _core = __webpack_require__(25);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    also_assigned: 'Også tilknyttet',
	    working_hours: 'Arbejdstid'
	  },
	  nb: {
	    also_assigned: 'Også tilordnet',
	    working_hours: 'Arbeidstid'
	  },
	  en: {
	    also_assigned: 'Also assigned',
	    working_hours: 'Working Hours'
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { Loader: _Loader2.default, spinner: _Spinner2.default },
	  props: {
	    items: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    itemsSelected: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    isLoading: {
	      default: false,
	      type: Boolean
	    },
	    allDataLoaded: {
	      default: false,
	      type: Boolean
	    },
	    show: {
	      default: false,
	      type: Boolean
	    },
	    multiple: {
	      default: true,
	      type: Boolean
	    },
	    placeholder: {
	      type: String,
	      default: ''
	    },
	    eventId: {
	      type: Number,
	      required: false
	    },
	    receiveData: {},
	    showSelectedUsers: {
	      default: true,
	      type: Boolean
	    },
	    addClass: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    itemSpaceBetween: {
	      type: Boolean,
	      default: false
	    },
	    resetCounter: {
	      default: 0
	    },
	    selectedSubject: {
	      default: null
	    },
	    isShowRemoveButton: {
	      default: true,
	      type: Boolean
	    }
	  },
	  computed: {
	    withoutSelectedItems: function withoutSelectedItems() {
	      var _this = this;
	
	      return this.items.filter(function (el) {
	        return _this.selectedUsers.filter(function (secEl) {
	          return secEl.id === el.id;
	        }).length === 0;
	      });
	    },
	    searchedUsers: function searchedUsers() {
	      var _this2 = this;
	
	      return this.withoutSelectedItems.filter(function (user) {
	        var nameMatch = user.name !== '' ? user.name.match(new RegExp(_this2.searchText, 'i')) : '';
	        var initialsMatch = user.initials && user.initials !== '' ? user.initials.match(new RegExp(_this2.searchText, 'i')) : '';
	        return nameMatch || initialsMatch;
	      });
	    },
	    placeholderText: function placeholderText() {
	      var placeholder = this.placeholder.length > 0 ? this.placeholder : this.$i18n.t('vue2.dselect.placeholder');
	      return this.selectedUsers.length > 0 ? '' : placeholder;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    }
	  },
	  data: function data() {
	    return {
	      showDropdown: false,
	      searchText: '',
	      searchTextDebounced: '',
	      selectedUsers: [],
	      keyboardSelected: null,
	      keyboardSelectedIndex: 0,
	      readyToDelete: null,
	      openFromBottom: false,
	      maxLimit: 400,
	      addLimit: 400,
	      debounceTimer: null
	    };
	  },
	
	  watch: {
	    selectedSubject: {
	      immediate: true,
	      handler: function handler(val) {
	        if (!val || !val.id || !Array.isArray(this.items)) {
	          return;
	        }
	        var found = this.items.find(function (item) {
	          return item.id === val.id;
	        });
	        if (found) {
	          this.toggleUser(found);
	        }
	      }
	    },
	    receiveData: function receiveData(val) {
	      for (var i = 0; i < this.items.length; i++) {
	        if (this.receiveData.id === this.items[i].id) {
	          this.toggleUser(this.items[i]);
	        }
	      }
	      this.searchText = '';
	    },
	    resetCounter: function resetCounter(val) {
	      this.searchText = '';
	      this.selectedUsers = [];
	    },
	    show: function show() {
	      if (!this.show) {
	        this.close();
	      }
	    },
	    searchedUsers: function searchedUsers(newVal) {
	      if (this._preserveKeyboardIndex) {
	        this._preserveKeyboardIndex = false;
	        if (this.keyboardSelectedIndex >= newVal.length) {
	          this.keyboardSelectedIndex = Math.max(0, newVal.length - 1);
	        }
	        this.keyboardSelected = newVal[this.keyboardSelectedIndex] || null;
	      } else {
	        this.keyboardSelectedIndex = 0;
	        this.keyboardSelected = newVal[0];
	      }
	    },
	    searchText: function searchText() {
	      this.$emit('searchText', this.searchText);
	    },
	    allDataLoaded: function allDataLoaded() {
	      this.sortSelectedUsers();
	    }
	  },
	  filters: {
	    localeTime: function localeTime(eventTime) {
	      return (0, _moment2.default)(eventTime).format('LT');
	    }
	  },
	  methods: {
	    onTabKeyDown: function onTabKeyDown() {
	      this.close();
	    },
	    debounceSearch: function debounceSearch(event) {
	      var _this3 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        _this3.searchTextDebounced = event.target.value;
	        _this3.$emit('onSearchTextDebounced', _this3.searchTextDebounced);
	      }, 400);
	    },
	    createPopper: function createPopper() {
	      var source = this.$refs.d_select__items;
	      var el = this.$refs.d_select;
	      document.getElementById('djs-content-container').appendChild(source);
	      var elWidth = el.getBoundingClientRect().width;
	      source.style.width = elWidth + 'px';
	      (0, _core.createPopper)(el, source, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, 0]
	          }
	        }]
	      });
	    },
	    userOccEvents: function userOccEvents(selectedUser) {
	      var _this4 = this;
	
	      if (selectedUser.occupied && selectedUser.occupied.events.length > 0) {
	        var occEventsWithoutPresenceAndCurrentEvent = selectedUser.occupied.events.filter(function (lesson) {
	          return lesson.event_id !== _this4.eventId && lesson.event_type !== 'presence';
	        });
	        return occEventsWithoutPresenceAndCurrentEvent;
	      } else {
	        return false;
	      }
	    },
	    checkHeight: function checkHeight() {
	      var bcr = this.$el.getBoundingClientRect();
	      var pxFromTop = bcr.top;
	      var pxFromBottom = window.innerHeight - (bcr.top + bcr.height);
	      if (pxFromBottom < 330 && pxFromTop > 330) {
	        this.openFromBottom = true;
	      }
	    },
	    isReadyToDelete: function isReadyToDelete(user) {
	      if (!this.readyToDelete) {
	        return;
	      }
	      return this.readyToDelete.id === user.id;
	    },
	    scrollTokeyboardSelected: function scrollTokeyboardSelected() {
	      var _this5 = this;
	
	      setTimeout(function () {
	        var user = document.querySelector('.isReadyForSelection');
	        var selectedOffsetTop = user.offsetTop;
	        var selectedHeight = user.getBoundingClientRect().height;
	        var totalHeight = selectedOffsetTop + selectedHeight;
	
	        var top = _this5.$refs.dropdown.scrollTop;
	        var height = _this5.$refs.dropdown.getBoundingClientRect().height;
	        var bottom = top + height;
	
	        if (totalHeight > bottom) {
	          _this5.$refs.dropdown.scrollTop = _this5.$refs.dropdown.scrollTop + selectedHeight;
	        }
	
	        if (selectedOffsetTop < top) {
	          _this5.$refs.dropdown.scrollTop = _this5.$refs.dropdown.scrollTop - selectedHeight;
	        }
	      }, 0);
	    },
	    setIsReadyForSelection: function setIsReadyForSelection(user, idx) {
	      this.keyboardSelected = null;
	      this.keyboardSelected = user;
	      this.keyboardSelectedIndex = idx;
	    },
	    selectWithKeyboard: function selectWithKeyboard(stroke, e) {
	      if (!this.showDropdown) {
	        this.open();
	      }
	      if (stroke === 'down') {
	        if (this.keyboardSelectedIndex + 1 >= this.searchedUsers.length) {
	          return;
	        }
	        this.keyboardSelectedIndex = this.keyboardSelectedIndex + 1;
	        this.keyboardSelected = this.searchedUsers[this.keyboardSelectedIndex];
	        this.scrollTokeyboardSelected();
	      }
	      if (stroke === 'up') {
	        if (this.keyboardSelectedIndex - 1 < 0) {
	          return;
	        }
	        this.keyboardSelectedIndex = this.keyboardSelectedIndex - 1;
	        this.keyboardSelected = this.searchedUsers[this.keyboardSelectedIndex];
	        this.scrollTokeyboardSelected();
	      }
	      if (stroke === 'enter') {
	        if (this.keyboardSelected === null) {
	          return;
	        }
	        if (this.searchedUsers.length < 1) {
	          this.$emit('enter');
	          return;
	        }
	        var keepOpen = e && (e.metaKey || e.ctrlKey);
	        this._preserveKeyboardIndex = true;
	        this.toggleUser(this.keyboardSelected, keepOpen);
	      }
	    },
	    isSelectedWithKeyboard: function isSelectedWithKeyboard(user) {
	      return this.keyboardSelected && this.keyboardSelected.id === user.id;
	    },
	    deleteUserWithKeyboard: function deleteUserWithKeyboard() {
	      if (this.searchText.length > 0 || this.selectedUsers.length < 1) {
	        return;
	      }
	      if (this.readyToDelete === null) {
	        this.readyToDelete = this.selectedUsers[this.selectedUsers.length - 1];
	      } else {
	        this.removeUser(this.selectedUsers[this.selectedUsers.length - 1]);
	        this.readyToDelete = null;
	      }
	    },
	    onClickAway: function onClickAway() {
	      this.close();
	      this.$emit('close');
	    },
	    close: function close() {
	      if (!this.showDropdown) {
	        return;
	      }
	      this.showDropdown = false;
	      this.keyboardSelected = null;
	      this.keyboardSelectedIndex = 0;
	      this.readyToDelete = null;
	      this.searchText = '';
	      this.$emit('show', false);
	      this.$emit('close');
	      this.openFromBottom = false;
	      this.maxLimit = this.addLimit;
	    },
	    open: function open() {
	      var _this6 = this;
	
	      this.checkHeight();
	      this.showDropdown = true;
	      this.$emit('show', true);
	      this.setFocus();
	      this.keyboardSelectedIndex = 0;
	      this.$nextTick(function (_) {
	        _this6.createPopper();
	      });
	    },
	    toggleUser: function toggleUser(item, keepOpen) {
	      if (item.tag) {
	        this.selectAllWithTag(item.name);
	        return;
	      }
	      if (this.isSelected(item)) {
	        this.selectedUsers.splice(this.selectedUsers.indexOf(item), 1);
	        this.$emit('remove', item);
	        this.$emit('update', this.selectedUsers);
	      } else {
	        if (item.isOnLesson) {
	          this.$emit('addIsOnLesson', item);
	          if (!keepOpen) this.close();
	          return;
	        }
	        if (this.multiple) {
	          this.selectedUsers.push(item);
	          this.$emit('add', item);
	        } else {
	          this.selectedUsers = [];
	          this.selectedUsers.push(item);
	          this.$emit('add', item);
	        }
	        this.$emit('update', this.selectedUsers);
	      }
	      if (!this.showSelectedUsers) {
	        this.selectedUsers = [];
	      }
	      if (!keepOpen) {
	        this.close();
	      }
	    },
	    selectAllWithTag: function selectAllWithTag(tag) {
	      var _this7 = this;
	
	      var usersWithTag = this.items.filter(function (item) {
	        return item.user_tags && item.user_tags.indexOf(tag) > -1;
	      });
	      usersWithTag.forEach(function (user) {
	        var idx = _this7.items.findIndex(function (x) {
	          return x.id === user.id;
	        });
	        if (!_this7.isSelected(_this7.items[idx])) {
	          _this7.selectedUsers.push(_this7.items[idx]);
	        }
	      });
	      this.close();
	      this.$emit('update', this.selectedUsers);
	    },
	    removeUser: function removeUser(item) {
	      this.selectedUsers.splice(this.selectedUsers.indexOf(item), 1);
	      this.$emit('remove', item);
	      this.$emit('update', this.selectedUsers);
	      this.close();
	    },
	    isSelected: function isSelected(user) {
	      return this.selectedUsers.indexOf(user) > -1;
	    },
	    setFocus: function setFocus() {
	      this.$refs.inputfield.focus();
	    },
	    sortSelectedUsers: function sortSelectedUsers() {
	      this.selectedUsers = this.selectedUsers.sort(function (a, b) {
	        var x = a.name.toLowerCase();
	        var y = b.name.toLowerCase();
	        return x < y ? -1 : x > y ? 1 : 0;
	      });
	    },
	    loadMoreCalendars: function loadMoreCalendars() {
	      if (this.searchedUsers.length > this.maxLimit) {
	        this.maxLimit = this.maxLimit + this.addLimit;
	      }
	    },
	    handleScroll: function handleScroll(evt) {
	      var element = evt.target;
	
	      if (element.scrollHeight - element.scrollTop === element.clientHeight) {
	        this.loadMoreCalendars();
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this8 = this;
	
	    this.$nextTick(function (_) {
	      if (_this8.show) {
	        _this8.open();
	      }
	    });
	    this.selectedUsers = this.itemsSelected;
	  },
	  beforeDestroy: function beforeDestroy() {
	    var source = this.$refs.d_select__items;
	    if (source) {
	      source.remove();
	    }
	  }
	};

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _CalendarViewDay = __webpack_require__(341);
	
	var _CalendarViewDay2 = _interopRequireDefault(_CalendarViewDay);
	
	var _DSelectCals = __webpack_require__(48);
	
	var _DSelectCals2 = _interopRequireDefault(_DSelectCals);
	
	var _core = __webpack_require__(25);
	
	var _vuex = __webpack_require__(14);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _hiddenAbsenceTitle = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelectCals2.default, CalendarViewDay: _CalendarViewDay2.default },
	  props: {
	    itemType: {
	      default: 'user'
	    },
	    preSelectedItems: {
	      default: function _default() {
	        return [];
	      }
	    },
	    itemsThatCantBeDeleted: {
	      default: function _default() {
	        return [];
	      }
	    },
	    itemsUnselectable: {
	      default: function _default() {
	        return [];
	      }
	    },
	    includeEventCalendar: {
	      type: Boolean,
	      default: false
	    },
	    showTags: {
	      type: Boolean,
	      default: false
	    },
	    isMultiple: {
	      type: Boolean,
	      default: true
	    },
	    showCreateButton: {
	      type: Boolean,
	      default: false
	    },
	    appendToBody: {
	      type: Boolean,
	      default: true
	    },
	    show: {
	      default: false,
	      type: Boolean
	    },
	    eventId: {
	      default: null
	    },
	    event: {
	      default: null
	    },
	    disableAddMore: {
	      type: Boolean,
	      default: false
	    },
	    disableAddMoreMessage: {
	      type: String
	    },
	    isDeleteAllAnOption: {
	      type: Boolean,
	      default: true
	    },
	    isLoadingProp: {
	      type: Boolean,
	      default: false
	    },
	    eventSchoolCalendars: {
	      required: false,
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    eventSchoolUsers: {
	      required: false,
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    eventSchoolYears: {
	      required: false,
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isEventSchoolIdTheSameAsActiveSchoolId: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      activeCalendar: null,
	      isLoaded: false,
	      tags: [],
	      selectedItems: [],
	      occupiedItems: {},
	      presentItems: {},
	      searchText: '',
	      placement: 'bottom',
	      i18n: {
	        da: {
	          search: 'Søg og vælg'
	        },
	        en: {
	          search: 'Search and choose'
	        },
	        nb: {
	          search: 'Søk og velg'
	        }
	      },
	      newUserCalendarId: null,
	      isLoading: false,
	      theShowCalendar: null
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['locale']), {
	    calendars: function calendars() {
	      return this.isEventSchoolIdTheSameAsActiveSchoolId ? this.$store.state.calendars : this.eventSchoolCalendars;
	    },
	    users: function users() {
	      return this.isEventSchoolIdTheSameAsActiveSchoolId ? this.$store.state.allUsers : this.eventSchoolUsers;
	    },
	    activeSchoolYears: function activeSchoolYears() {
	      return this.isEventSchoolIdTheSameAsActiveSchoolId ? this.$store.state.activeSchoolYears : this.eventSchoolYears;
	    },
	    eventSchoolYearId: function eventSchoolYearId() {
	      if (!this.event || !this.event.start || !this.activeSchoolYears || !Array.isArray(this.activeSchoolYears) || this.activeSchoolYears.length === 0) {
	        return null;
	      }
	      var eventDate = new Date(this.event.start);
	      if (isNaN(eventDate.getTime())) {
	        return null;
	      }
	      var toDate = function toDate(dateString) {
	        if (!dateString) {
	          return null;
	        }
	        var d = new Date(dateString);
	        return isNaN(d.getTime()) ? null : d;
	      };
	      var isInRange = function isInRange(startString, endString) {
	        var start = toDate(startString);
	        var end = toDate(endString);
	        if (!start || !end) {
	          return false;
	        }
	        return eventDate >= start && eventDate <= end;
	      };
	      var found = this.activeSchoolYears.find(function (schoolYear) {
	        return isInRange(schoolYear.student_time_start, schoolYear.student_time_end);
	      });
	      if (!found) {
	        found = this.activeSchoolYears.find(function (schoolYear) {
	          return isInRange(schoolYear.employee_time_start, schoolYear.employee_time_end);
	        });
	      }
	      return found ? found.id : null;
	    },
	    eventSchoolId: function eventSchoolId() {
	      return this.event ? this.event.school_id : null;
	    },
	    klassCalendars: function klassCalendars() {
	      return this.returnCorrectCalendars('klass');
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.users.reduce(function (obj, item) {
	        obj[item.user_calendar_id] = item;
	        return obj;
	      }, {});
	    },
	    userCalendars: function userCalendars() {
	      var cals = this.calendars.filter(function (cal) {
	        return cal.type === 'user' && cal.name !== null && cal.name !== '';
	      });
	      return this.$helpers.sortArrOnName(cals);
	    },
	    roomCalendars: function roomCalendars() {
	      var cals = this.calendars.filter(function (cal) {
	        return cal.type === 'room' && !cal.archived_at && cal.name !== null && cal.name !== '';
	      });
	      return this.$helpers.sortArrOnName(cals);
	    },
	    otherCalendars: function otherCalendars() {
	      return this.returnCorrectCalendars('other');
	    },
	    kindergartenCalendars: function kindergartenCalendars() {
	      return this.returnCorrectCalendars('kindergarten');
	    },
	    clubCalendars: function clubCalendars() {
	      return this.returnCorrectCalendars('club');
	    },
	    studentCalendars: function studentCalendars() {
	      var cals = this.calendars.filter(function (cal) {
	        return cal.type === 'student' && !cal.archived_at && cal.name !== null && cal.name !== '';
	      });
	      return this.$helpers.sortArrOnName(cals);
	    },
	    calendarId: function calendarId() {
	      return this.event ? this.event.calendar_id : null;
	    },
	    items: function items() {
	      var _this = this;
	
	      var cals = [];
	      if (this.itemType === 'user') {
	        if (!this.showTags) {
	          cals = this.userCalendars;
	        }
	        var userCalsWithTags = this.userCalendars.map(function (cal) {
	          var tags = _this.allUsersInCalIdHash[cal.id] && _this.allUsersInCalIdHash[cal.id].user_tags ? _this.allUsersInCalIdHash[cal.id].user_tags : [];
	          _this.$set(cal, 'user_tags', tags);
	          return cal;
	        });
	        this.tags.forEach(function (tag) {
	          userCalsWithTags.push(tag);
	        });
	        cals = userCalsWithTags;
	      }
	      if (this.itemType.toLowerCase() === 'room') {
	        cals = this.roomCalendars;
	      }
	      if (this.itemType.toLowerCase() === 'klass') {
	        cals = this.filterCalendarsByEventSchoolYear(this.klassCalendars);
	      }
	      if (this.itemType.toLowerCase() === 'student') {
	        cals = this.studentCalendars;
	      }
	      if (this.itemType.toLowerCase() === 'other') {
	        cals = this.filterCalendarsByEventSchoolYear(this.otherCalendars);
	      }
	      if (this.itemType.toLowerCase() === 'club') {
	        cals = this.clubCalendars;
	      }
	      if (this.itemType.toLowerCase() === 'kindergarten') {
	        cals = this.kindergartenCalendars;
	      }
	      return this.calendarId && !this.includeEventCalendar ? cals.filter(function (calendar) {
	        return calendar.id !== _this.calendarId;
	      }) : cals;
	    },
	    itemsWithOccupation: function itemsWithOccupation() {
	      var _this2 = this;
	
	      return this.items.map(function (calendar) {
	        _this2.$set(calendar, 'v_occupation', []);
	        _this2.$set(calendar, 'v_presence', []);
	        if (_this2.occupiedItems[calendar.id]) {
	          _this2.$set(calendar, 'v_occupation', _this2.occupiedItems[calendar.id]);
	        }
	        if (_this2.presentItems[calendar.id]) {
	          _this2.$set(calendar, 'v_presence', _this2.presentItems[calendar.id]);
	        }
	        return calendar;
	      });
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    date: function date() {
	      return this.event.start;
	    }
	  }),
	  watch: {
	    items: function items(val) {
	      if (val.length > 0) {
	        this.setPreSelectedItems();
	      }
	    },
	    eventId: function eventId(val) {
	      if (this.event) {
	        this.getDoubleBookedCalendars();
	      }
	    },
	    preSelectedItems: function preSelectedItems() {
	      this.setPreSelectedItems();
	    }
	  },
	  methods: {
	    updateAndClose: function updateAndClose() {
	      this.activeCalendar = null;
	      this.$emit('updateAndClose');
	    },
	    filterCalendarsByEventSchoolYear: function filterCalendarsByEventSchoolYear(cals) {
	      var schoolYearId = this.eventSchoolYearId;
	      if (!schoolYearId) {
	        return cals;
	      }
	      var schoolYearName = '';
	      var idx = this.activeSchoolYears ? this.activeSchoolYears.findIndex(function (schoolYear) {
	        return schoolYear.id === schoolYearId;
	      }) : -1;
	      if (idx > -1) {
	        schoolYearName = this.activeSchoolYears[idx].name;
	      }
	      return cals.filter(function (calendar) {
	        if (calendar.school_year_id && calendar.school_year_id === schoolYearId) {
	          return true;
	        }
	        if (schoolYearName && calendar.year && calendar.year === schoolYearName) {
	          return true;
	        }
	        if (!calendar.school_year_id && !calendar.year) {
	          return true;
	        }
	        return false;
	      });
	    },
	    returnCorrectCalendars: function returnCorrectCalendars(calType) {
	      var _this3 = this;
	
	      var schoolYearIds = this.activeSchoolYears.map(function (schoolYear) {
	        return schoolYear.id;
	      });
	      var schoolYearYears = this.activeSchoolYears.map(function (schoolYear) {
	        return schoolYear.name;
	      });
	      var calendars = this.calendars.filter(function (cal) {
	        return cal.type === calType && cal.name !== null && cal.name !== '';
	      });
	      var calendarsInActiveYear = calendars.filter(function (cal) {
	        return cal.school_year_id ? schoolYearIds.indexOf(cal.school_year_id) > -1 : schoolYearYears.indexOf(cal.year) > -1;
	      });
	      var calendarInActiveYearMapped = calendarsInActiveYear.map(function (calendar) {
	        return (0, _extends3.default)({}, calendar, {
	          name: schoolYearIds.length < 2 ? calendar.name : _this3.getSchoolYearName(calendar) + ' - ' + calendar.name
	        });
	      });
	      return this.$helpers.sortArrOnName(calendarInActiveYearMapped);
	    },
	    getSchoolYearName: function getSchoolYearName(cal) {
	      var idx = this.activeSchoolYears ? this.activeSchoolYears.findIndex(function (schoolYear) {
	        return schoolYear.id === cal.school_year_id;
	      }) : -1;
	      if (idx > -1) {
	        return this.activeSchoolYears[idx]['name'];
	      }
	      return '';
	    },
	    withPopper: function withPopper(dropdownList, component, _ref) {
	      var width = _ref.width;
	
	      dropdownList.style.width = width;
	      (0, _core.createPopper)(component.$refs.toggle, dropdownList, {
	        placement: this.placement,
	        modifiers: [{
	          name: 'offset', options: {
	            offset: [0, 0]
	          }
	        }, {
	          name: 'toggleClass',
	          enabled: true,
	          phase: 'write',
	          fn: function fn(_ref2) {
	            var state = _ref2.state;
	
	            component.$el.classList.toggle('openFromBottom', state.placement === 'top');
	          }
	        }]
	      });
	    },
	    showCalendar: function showCalendar(calendar) {
	      var el = document.querySelector('.d-show-event');
	      if (el) {
	        el.click();
	      }
	      this.activeCalendar = calendar;
	    },
	    setSelectedItems: function setSelectedItems(val) {
	      this.selectedItems = [];
	      this.selectedItems = val;
	      this.$emit('update', this.selectedItems);
	    },
	    isInSelectedItems: function isInSelectedItems(calid) {
	      return this.selectedItems.findIndex(function (item) {
	        return item.id === calid;
	      }) >= 0;
	    },
	    setPreSelectedItems: function setPreSelectedItems() {
	      var _this4 = this;
	
	      if (this.calendars.length < 1) {
	        return;
	      }
	      this.selectedItems = [];
	      this.preSelectedItems.forEach(function (calendarId) {
	        if (calendarId) {
	          if (!_this4.isInSelectedItems(calendarId)) {
	            var idx = _this4.items.findIndex(function (item) {
	              return item.id === calendarId;
	            });
	            if (idx > -1) {
	              _this4.selectedItems.push(_this4.items[idx]);
	            }
	          }
	        }
	      });
	      if (!this.showTags) {
	        this.isLoaded = true;
	      }
	    },
	    getTags: function getTags() {
	      var _this5 = this;
	
	      _docendo2.default.schoolTags(this.event.school_id, function (data) {
	        var tags = [];
	        var i = 0;
	        data.forEach(function (tag) {
	          i++;
	          var oneTag = {
	            tag: true,
	            id: 999999999999 + i,
	            name: tag,
	            icon: 'icon-price-tag2'
	          };
	          tags.push(oneTag);
	        });
	        _this5.tags = tags;
	      });
	    },
	    createNew: function createNew(evt) {
	      var _this6 = this;
	
	      if (this.itemType === 'room') {
	        var calendars = [{ name: evt, type: this.itemType }];
	        _docendo2.default.schoolBulkCreateCalendars(this.eventSchoolId, this.activeSchoolYear.id, calendars, function (success) {
	          console.log('success', success);
	        }, function (failure) {
	          console.log('failure', failure);
	        });
	        return;
	      }
	      if (this.itemType === 'user') {
	        var users = [{ name: evt }];
	        _docendo2.default.schoolUsersCreate(this.eventSchoolId, users, function (success) {
	          _this6.$store.dispatch('getSchoolCalendars', window.SCHOOL.id);
	          _this6.newUserCalendarId = success[0].user_calendar_id;
	        }, function (failure) {
	          console.log('failure', failure);
	        });
	      }
	    },
	    getDoubleBookedCalendars: function getDoubleBookedCalendars() {
	      var _this7 = this;
	
	      this.isLoading = true;
	      this.occupiedItems = {};
	      this.presentItems = {};
	      _docendo2.default.schoolAvailabilities(this.eventSchoolId, this.itemType, this.event.start, this.event.end, function (data) {
	        _this7.isLoading = false;
	        var dbAnswer = (0, _hiddenAbsenceTitle.maskHiddenAbsenceTitlesInAvailability)(data && data.length > 0 ? JSON.parse(data) : [], _this7.$store, _this7.eventSchoolId);
	        dbAnswer.forEach(function (cal) {
	          var occEvents = [];
	          var occPresence = [];
	          cal.events.forEach(function (event) {
	            if (event.event_id !== _this7.eventId) {
	              if (event.event_type === 'presence') {
	                occPresence.push(event);
	              } else {
	                occEvents.push(event);
	              }
	            }
	          });
	          if (occEvents.length > 0) {
	            _this7.$set(_this7.occupiedItems, cal.calendar_id, occEvents);
	          }
	          if (occPresence.length > 0) {
	            _this7.$set(_this7.presentItems, cal.calendar_id, occPresence);
	          }
	        });
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this8 = this;
	
	    this.setPreSelectedItems();
	    if (this.showTags) {
	      this.getTags();
	    }
	    if (this.event) {
	      this.$nextTick(function (_) {
	        _this8.getDoubleBookedCalendars();
	      });
	    }
	  }
	};

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Spinner = __webpack_require__(26);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _appendToBody = __webpack_require__(429);
	
	var _appendToBody2 = _interopRequireDefault(_appendToBody);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _core = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    delete_all: 'Slet alle valgte',
	    hold_down: 'Hold',
	    to_select_multiple: 'nede for at vælge flere',
	    see_calendar: 'Se kalender'
	  },
	  en: {
	    delete_all: 'Remove all',
	    hold_down: 'Hold down',
	    to_select_multiple: 'to select multiple',
	    see_calendar: 'See calender'
	  },
	  nb: {
	    delete_all: 'Slett alle valgte',
	    hold_down: 'Hold nede',
	    to_select_multiple: 'for å velge flere',
	    see_calendar: 'Se kalender'
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  directives: { appendToBody: _appendToBody2.default },
	  components: { Loader: _Loader2.default, spinner: _Spinner2.default },
	  props: {
	    items: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    itemsSelected: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    itemsUnselectable: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    itemsThatCantBeDeleted: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    isLoading: {
	      default: false,
	      type: Boolean
	    },
	    isLoadingAvailability: {
	      default: false,
	      type: Boolean
	    },
	    allDataLoaded: {
	      default: false,
	      type: Boolean
	    },
	    show: {
	      default: false,
	      type: Boolean
	    },
	    multiple: {
	      default: true,
	      type: Boolean
	    },
	    placeholder: {
	      type: String,
	      default: ''
	    },
	    eventId: {
	      type: Number,
	      required: false
	    },
	    event: {
	      type: Object,
	      default: function _default() {
	        return null;
	      },
	      required: false
	    },
	    appendToBody: {
	      default: false
	    },
	    calculatePosition: {
	      type: Function,
	      default: function _default(dropdownList, component, _ref) {
	        var top = _ref.top,
	            left = _ref.left;
	
	        dropdownList.style.top = top;
	        dropdownList.style.left = left;
	      }
	    },
	    showCreateButton: {
	      default: false,
	      type: Boolean
	    },
	    newUserCalendarId: {
	      default: null
	    },
	    disableAddMore: {
	      type: Boolean,
	      default: false
	    },
	    isDeleteAllAnOption: {
	      type: Boolean,
	      default: true
	    },
	    isShowCollisions: {
	      type: Boolean,
	      default: false
	    },
	    showCalendarYear: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return window.USER && window.USER.language ? window.USER.language : 'en';
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    isInEvent: function isInEvent() {
	      return this.event !== null;
	    },
	    withoutSelectedItems: function withoutSelectedItems() {
	      var _this = this;
	
	      var itemsFiltered = this.items.filter(function (item) {
	        return !_this.itemsUnselectable.includes(item.id);
	      });
	      return itemsFiltered.filter(function (el) {
	        return _this.selectedItems.filter(function (secEl) {
	          return secEl.id === el.id;
	        }).length === 0;
	      });
	    },
	    searchedUsers: function searchedUsers() {
	      var _this2 = this;
	
	      if (this.disableAddMore) {
	        return [];
	      }
	      return this.withoutSelectedItems.filter(function (user) {
	        return user.name !== '' ? user.name.match(new RegExp(_this2.searchText, 'i')) : '';
	      });
	    },
	    placeholderText: function placeholderText() {
	      var placeholder = this.placeholder.length > 0 ? this.placeholder : this.$i18n.t('vue2.dselect.placeholder');
	      return this.selectedItems.length > 0 ? '' : placeholder;
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    },
	    metaKeyTooltip: function metaKeyTooltip() {
	      return '<p class="tooltip-shortcut">' + this.i18n['hold_down'] + '<span>' + this.metaKey + '</span>' + this.i18n['to_select_multiple'] + '</p>';
	    }
	  },
	  data: function data() {
	    return {
	      showDropdown: false,
	      searchText: '',
	      selectedItems: [],
	      keyboardSelected: null,
	      keyboardSelectedIndex: 0,
	      readyToDelete: null,
	      openFromBottom: false,
	      readyToReceive: false,
	      maxLimit: 400,
	      addLimit: 400,
	      isKeepOpen: false,
	      _keyListenerOne: null,
	      _keyListenerTwo: null,
	      isMouseMoved: false
	    };
	  },
	
	  watch: {
	    show: function show() {
	      if (!this.show) {
	        this.close();
	      }
	    },
	    searchedUsers: function searchedUsers(newVal) {
	      if (this._preserveKeyboardIndex) {
	        this._preserveKeyboardIndex = false;
	        if (this.keyboardSelectedIndex >= newVal.length) {
	          this.keyboardSelectedIndex = Math.max(0, newVal.length - 1);
	        }
	        this.keyboardSelected = newVal[this.keyboardSelectedIndex] || null;
	      } else {
	        this.keyboardSelectedIndex = 0;
	        this.keyboardSelected = newVal[0];
	      }
	    },
	    searchText: function searchText() {
	      this.$emit('searchText', this.searchText);
	    },
	    selectedItems: function selectedItems() {
	      this.$nextTick(this.updatePopper);
	    },
	    allDataLoaded: function allDataLoaded() {
	      this.sortselectedItems();
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders(val) {
	      if (!val && this.newUserCalendarId) {
	        console.log('this.newUserCalendarId', this.newUserCalendarId);
	      }
	    },
	    itemsSelected: function itemsSelected(val) {
	      var preSelectedIds = val.map(function (calendar) {
	        return calendar.id;
	      });
	      var selectedItems = this.selectedItems.map(function (cal) {
	        return cal.id;
	      });
	      if (preSelectedIds.sort().join(',') === selectedItems.sort().join(',')) {} else {
	        this.selectedItems = this.itemsSelected;
	      }
	    }
	  },
	  filters: {
	    localeTime: function localeTime(eventTime) {
	      return (0, _moment2.default)(eventTime).format('LT');
	    }
	  },
	  methods: {
	    onClickAway: function onClickAway() {
	      this.close();
	      this.$emit('close');
	    },
	    isInItemsThatCantBeDeleted: function isInItemsThatCantBeDeleted(selectedItem) {
	      return this.itemsThatCantBeDeleted.indexOf(selectedItem.id) > -1;
	    },
	    isReadyToDelete: function isReadyToDelete(user) {
	      if (!this.readyToDelete) {
	        return;
	      }
	      return this.readyToDelete.id === user.id;
	    },
	    scrollTokeyboardSelected: function scrollTokeyboardSelected() {
	      var _this3 = this;
	
	      setTimeout(function () {
	        var user = document.querySelector('.isReadyForSelection');
	        var selectedOffsetTop = user.offsetTop;
	        var selectedHeight = user.getBoundingClientRect().height;
	        var totalHeight = selectedOffsetTop + selectedHeight;
	
	        var top = _this3.$refs.dropdown.scrollTop;
	        var height = _this3.$refs.dropdown.getBoundingClientRect().height;
	        var bottom = top + height;
	
	        if (totalHeight > bottom) {
	          _this3.isMouseMoved = false;
	          _this3.$refs.dropdown.scrollTop = _this3.$refs.dropdown.scrollTop + selectedHeight;
	        }
	
	        if (selectedOffsetTop < top) {
	          _this3.isMouseMoved = false;
	          _this3.$refs.dropdown.scrollTop = _this3.$refs.dropdown.scrollTop - selectedHeight;
	        }
	      }, 0);
	    },
	    setIsReadyForSelection: function setIsReadyForSelection(user, idx) {
	      if (!this.isMouseMoved) {
	        return;
	      }
	      this.keyboardSelected = null;
	      this.keyboardSelected = user;
	      this.keyboardSelectedIndex = idx;
	    },
	    selectWithKeyboard: function selectWithKeyboard(stroke, e) {
	      if (!this.showDropdown) {
	        this.open();
	      }
	      if (stroke === 'tab') {
	        if (this.searchText.length > 0 && this.searchedUsers.length < 1) {
	          this.createNew();
	          this.close();
	          return;
	        }
	        this.close();
	      }
	      if (stroke === 'down') {
	        if (this.keyboardSelectedIndex + 1 >= this.searchedUsers.length) {
	          return;
	        }
	        this.keyboardSelectedIndex = this.keyboardSelectedIndex + 1;
	        this.keyboardSelected = this.searchedUsers[this.keyboardSelectedIndex];
	        this.scrollTokeyboardSelected();
	      }
	      if (stroke === 'up') {
	        if (this.keyboardSelectedIndex - 1 < 0) {
	          return;
	        }
	        this.keyboardSelectedIndex = this.keyboardSelectedIndex - 1;
	        this.keyboardSelected = this.searchedUsers[this.keyboardSelectedIndex];
	        this.scrollTokeyboardSelected();
	      }
	      if (stroke === 'enter') {
	        if (this.keyboardSelected === null) {
	          return;
	        }
	        if (this.searchedUsers.length < 1) {
	          this.$emit('enter');
	          return;
	        }
	        this._preserveKeyboardIndex = true;
	        this.toggleUser(this.keyboardSelected);
	      }
	    },
	    isSelectedWithKeyboard: function isSelectedWithKeyboard(user) {
	      return this.keyboardSelected && this.keyboardSelected.id === user.id;
	    },
	    handlePaste: function handlePaste(event) {
	      if (!this.$listeners || !this.$listeners.multiPaste) {
	        return;
	      }
	      var clipboard = event.clipboardData || window.clipboardData;
	      if (!clipboard) {
	        return;
	      }
	      var text = clipboard.getData('text');
	      if (!text || text.length < 1) {
	        return;
	      }
	      var looksMulti = text.indexOf(',') > -1 || text.indexOf(';') > -1 || text.indexOf('\n') > -1 || text.indexOf('\t') > -1;
	      if (!looksMulti) {
	        return;
	      }
	      event.preventDefault();
	      this.$emit('multiPaste', text);
	      this.searchText = '';
	    },
	    deleteUserWithKeyboard: function deleteUserWithKeyboard() {
	      if (this.searchText.length > 0 || this.selectedItems.length < 1) {
	        return;
	      }
	      if (this.itemsThatCantBeDeleted.length > 0) {
	        return;
	      }
	      if (this.readyToDelete === null) {
	        this.readyToDelete = this.selectedItems[this.selectedItems.length - 1];
	      } else {
	        this.removeUser(this.selectedItems[this.selectedItems.length - 1]);
	        this.readyToDelete = null;
	      }
	    },
	    close: function close() {
	      if (!this.showDropdown) {
	        return;
	      }
	      this.showDropdown = false;
	      this.destroyPopper();
	      this.keyboardSelected = null;
	      this.keyboardSelectedIndex = 0;
	      this.readyToDelete = null;
	      this.searchText = '';
	      this.$emit('show', false);
	      this.openFromBottom = false;
	      this.maxLimit = 400;
	      this.removeKeyboardShortCuts();
	      this.isKeepOpen = false;
	    },
	    open: function open() {
	      var _this4 = this;
	
	      if (this.showDropdown) {
	        return;
	      }
	      this.showDropdown = true;
	      this.$emit('show', true);
	      this.setFocus();
	      this.keyboardSelectedIndex = 0;
	      this.keyboardShortcut();
	      this.$nextTick(function (_) {
	        _this4.createPopper();
	      });
	    },
	    toggleUser: function toggleUser(item) {
	      if (item.tag) {
	        this.selectAllWithTag(item.name);
	        return;
	      }
	      if (this.isSelected(item)) {
	        this.removeUser(item);
	      } else {
	        if (item.isOnLesson) {
	          this.$emit('addIsOnLesson', item);
	          this.close();
	          return;
	        }
	        if (this.multiple) {
	          this.selectedItems.push(item);
	          this.$emit('add', item);
	          this.readyToDelete = null;
	          this.searchText = '';
	          this.setFocus();
	        } else {
	          this.selectedItems = [];
	          this.selectedItems.push(item);
	          this.$emit('add', item);
	        }
	        this.$emit('update', this.selectedItems);
	      }
	      if (!this.isKeepOpen) {
	        this.close();
	      }
	    },
	    createPopper: function createPopper() {
	      var source = this.$refs.d_select__items;
	      var el = this.$refs.d_select;
	      if (!source || !el) {
	        return;
	      }
	      this.destroyPopper();
	      document.getElementById('djs-content-container').appendChild(source);
	      var elRect = el.getBoundingClientRect();
	      source.style.width = elRect.width + 'px';
	
	      var spaceBelow = window.innerHeight - elRect.bottom;
	      var spaceAbove = elRect.top;
	      var fitsBelow = source.offsetHeight <= spaceBelow || spaceBelow >= spaceAbove;
	      this.popperInstance = (0, _core.createPopper)(el, source, {
	        placement: fitsBelow ? 'bottom-start' : 'top-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, 0]
	          }
	        }, {
	          name: 'flip',
	          enabled: false
	        }]
	      });
	    },
	    updatePopper: function updatePopper() {
	      if (this.popperInstance) {
	        this.popperInstance.update();
	      }
	    },
	    destroyPopper: function destroyPopper() {
	      if (this.popperInstance) {
	        this.popperInstance.destroy();
	        this.popperInstance = null;
	      }
	    },
	    selectAllWithTag: function selectAllWithTag(tag) {
	      var _this5 = this;
	
	      var usersWithTag = this.items.filter(function (item) {
	        return item.user_tags && item.user_tags.indexOf(tag) > -1;
	      });
	      usersWithTag.forEach(function (user) {
	        var idx = _this5.items.findIndex(function (x) {
	          return x.id === user.id;
	        });
	        if (!_this5.isSelected(_this5.items[idx])) {
	          _this5.selectedItems.push(_this5.items[idx]);
	        }
	      });
	      this.close();
	      this.$emit('update', this.selectedItems);
	      this.$emit('add', this.selectedItems);
	    },
	    removeUser: function removeUser(item) {
	      this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
	      this.$emit('remove', item);
	      this.$emit('update', this.selectedItems);
	      this.close();
	    },
	    removeAllUsers: function removeAllUsers() {
	      var _this6 = this;
	
	      this.selectedItems.forEach(function (item) {
	        _this6.$emit('remove', item);
	      });
	      this.selectedItems.splice(0, this.selectedItems.length);
	      this.$emit('update', this.selectedItems);
	      this.close();
	    },
	    isSelected: function isSelected(user) {
	      return this.selectedItems.indexOf(user) > -1;
	    },
	    setFocus: function setFocus() {
	      this.$refs.inputfield.focus();
	    },
	    sortselectedItems: function sortselectedItems() {
	      this.selectedItems = this.selectedItems.sort(function (a, b) {
	        var x = a.name.toLowerCase();
	        var y = b.name.toLowerCase();
	        return x < y ? -1 : x > y ? 1 : 0;
	      });
	    },
	    createNew: function createNew() {
	      this.$emit('createNew', this.searchText);
	      this.readyToReceive = true;
	      this.close();
	    },
	    loadMoreCalendars: function loadMoreCalendars() {
	      if (this.searchedUsers.length < this.maxLimit) {
	        this.maxLimit = this.maxLimit + this.addLimit;
	      }
	    },
	    handleScroll: function handleScroll(evt) {
	      var element = evt.target;
	
	      if (element.scrollHeight - element.scrollTop === element.clientHeight) {
	        this.loadMoreCalendars();
	      }
	    },
	    getCollisionText: function getCollisionText(selectedItem) {
	      return selectedItem.v_occupation.map(function (event) {
	        return event.title;
	      });
	    },
	    showCalendar: function showCalendar(item) {
	      this.$emit('showCalendar', item);
	    },
	    keyboardShortcut: function keyboardShortcut() {
	      if (this._keyListenerOne) {
	        return;
	      }
	      var self = this;
	      this._keyListenerOne = function (e) {
	        if (e.key === 'Meta' || e.key === 'Control') {
	          e.preventDefault();
	          if (!self.isKeepOpen) {
	            self.isKeepOpen = true;
	          }
	        }
	      };
	      this._keyListenerTwo = function (e) {
	        if (e.key === 'Meta' || e.key === 'Control') {
	          e.preventDefault();
	          self.isKeepOpen = false;
	        }
	      };
	      document.addEventListener('keydown', this._keyListenerOne);
	      document.addEventListener('keyup', this._keyListenerTwo);
	    },
	    removeKeyboardShortCuts: function removeKeyboardShortCuts() {
	      document.removeEventListener('keydown', this._keyListenerOne);
	      document.removeEventListener('keyup', this._keyListenerTwo);
	      this._keyListenerOne = null;
	      this._keyListenerTwo = null;
	    }
	  },
	  mounted: function mounted() {
	    if (this.show) {
	      this.open();
	    }
	    this.selectedItems = this.itemsSelected;
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.removeKeyboardShortCuts();
	    this.destroyPopper();
	
	    var source = this.$refs.d_select__items;
	    if (source) {
	      source.remove();
	    }
	  }
	};

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DSelectCals = __webpack_require__(48);
	
	var _DSelectCals2 = _interopRequireDefault(_DSelectCals);
	
	var _vuex = __webpack_require__(14);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelectCals2.default },
	  props: {
	    itemsSelected: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      allDataLoaded: false,
	      tags: []
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['allCalendarsInHash', 'userCalendars', 'klassCalendars', 'allUsersInCalIdHash', 'roomCalendars', 'mergeCalendars', 'otherCalendars', 'studentCalendars', 'kindergartenCalendars', 'clubCalendars']), {
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.isLoadingAllUsers;
	    },
	    allCals: function allCals() {
	      return this.usersForSelect.concat(this.kindergartenCalendarsForSelect, this.KlassForSelect, this.roomCalsForDSelect, this.mergeCalendarsForDSelect, this.otherCalendarsForDSelect, this.clubCalendarsForDSelect, this.tagsForSelect, this.studentCalendarsForSelect);
	    },
	    studentCalendarsForSelect: function studentCalendarsForSelect() {
	      return this.studentCalendars.map(function (cal, key) {
	        cal.icon = 'icon-user';
	        return cal;
	      });
	    },
	    kindergartenCalendarsForSelect: function kindergartenCalendarsForSelect() {
	      return this.kindergartenCalendars.map(function (cal, key) {
	        cal.icon = 'icon-users5';
	        return cal;
	      });
	    },
	    usersForSelect: function usersForSelect() {
	      var _this = this;
	
	      var users = this.userCalendars.map(function (cal, key) {
	        if (_this.allUsersInCalIdHash[cal.id]) {
	          _this.$set(cal, 'user_tags', _this.allUsersInCalIdHash[cal.id].user_tags);
	          _this.$set(cal, 'default_thumb_url', _this.allUsersInCalIdHash[cal.id].default_thumb_url);
	        }
	        return cal;
	      });
	      return users;
	    },
	    KlassForSelect: function KlassForSelect() {
	      var klasses = this.klassCalendars.map(function (cal, key) {
	        cal.icon = 'icon-calendar4';
	        return cal;
	      });
	      return klasses;
	    },
	    roomCalsForDSelect: function roomCalsForDSelect() {
	      var rooms = this.roomCalendars.map(function (cal, key) {
	        cal.icon = 'icon-location';
	        return cal;
	      });
	      return rooms;
	    },
	    mergeCalendarsForDSelect: function mergeCalendarsForDSelect() {
	      var mergeCals = this.mergeCalendars.map(function (cal, key) {
	        cal.icon = 'icon-calendar-week';
	        return cal;
	      });
	      return mergeCals;
	    },
	    otherCalendarsForDSelect: function otherCalendarsForDSelect() {
	      var otherCalendars = this.otherCalendars.map(function (cal, key) {
	        cal.icon = 'icon-clipboard2';
	        return cal;
	      });
	      return otherCalendars;
	    },
	    tagsForSelect: function tagsForSelect() {
	      var tags = [];
	      var i = 0;
	      this.tags.forEach(function (tag) {
	        i++;
	        var oneTag = {
	          tag: true,
	          id: 999999999999 + i,
	          name: tag,
	          icon: 'icon-price-tag2'
	        };
	        tags.push(oneTag);
	      });
	      return tags;
	    },
	    clubCalendarsForDSelect: function clubCalendarsForDSelect() {
	      var clubCalendars = this.clubCalendars.map(function (cal, key) {
	        cal.icon = 'icon-users5';
	        return cal;
	      });
	      return clubCalendars;
	    }
	  }),
	  methods: {
	    getTags: function getTags() {
	      var _this2 = this;
	
	      _docendo2.default.schoolTags(this.school.id, function (data) {
	        _this2.tags = data;
	        _this2.allDataLoaded = true;
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUsersFromSchoolId', this.school.id);
	    this.getTags();
	  }
	};

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DSelectCals = __webpack_require__(48);
	
	var _DSelectCals2 = _interopRequireDefault(_DSelectCals);
	
	var _core = __webpack_require__(25);
	
	var _vuex = __webpack_require__(14);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelectCals2.default },
	  props: {
	    calendarId: {
	      default: null
	    },
	    itemType: {
	      default: 'user'
	    },
	    preSelectedItems: {
	      default: function _default() {
	        return [];
	      }
	    },
	    itemsThatCantBeDeleted: {
	      default: function _default() {
	        return [];
	      }
	    },
	    showTags: {
	      type: Boolean,
	      default: false
	    },
	    isMultiple: {
	      type: Boolean,
	      default: true
	    },
	    showCreateButton: {
	      type: Boolean,
	      default: false
	    },
	    appendToBody: {
	      type: Boolean,
	      default: true
	    },
	    show: {
	      default: false,
	      type: Boolean
	    },
	    calendarIdsToHide: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    sortSelectedByName: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['klassCalendars', 'userCalendars', 'roomCalendars', 'clubCalendars', 'allUsersInCalIdHash', 'locale']), {
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    items: function items() {
	      var _this = this;
	
	      if (this.itemType.toLowerCase() === 'user') {
	        if (!this.showTags) {
	          return this.userCalendars.filter(function (calendar) {
	            if (!_this.calendarIdsToHide || _this.calendarIdsToHide.length === 0) {
	              return true;
	            }
	            return !_this.calendarIdsToHide.some(function (calId) {
	              return calId === calendar.id;
	            });
	          });
	        }
	        var userCalsWithTags = this.userCalendars.map(function (cal) {
	          var tags = _this.allUsersInCalIdHash[cal.id] && _this.allUsersInCalIdHash[cal.id].user_tags ? _this.allUsersInCalIdHash[cal.id].user_tags : [];
	          _this.$set(cal, 'user_tags', tags);
	          return cal;
	        });
	        this.tags.forEach(function (tag) {
	          userCalsWithTags.push(tag);
	        });
	        return userCalsWithTags;
	      }
	      if (this.itemType.toLowerCase() === 'room') {
	        return this.roomCalendars;
	      }
	      if (this.itemType.toLowerCase() === 'club') {
	        return this.calendarId ? this.clubCalendars.filter(function (calendar) {
	          return calendar.id !== _this.calendarId;
	        }) : this.clubCalendars;
	      }
	      if (this.itemType.toLowerCase() === 'klass') {
	        return this.calendarId ? this.klassCalendars.filter(function (calendar) {
	          return calendar.id !== _this.calendarId;
	        }) : this.klassCalendars;
	      }
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    }
	  }),
	  data: function data() {
	    return {
	      isLoaded: false,
	      tags: [],
	      selectedItems: [],
	      searchText: '',
	      placement: 'bottom',
	      i18n: {
	        da: {
	          search: 'Søg og vælg'
	        },
	        en: {
	          search: 'Search and choose'
	        },
	        nb: {
	          search: 'Søk og velg'
	        }
	      },
	      newUserCalendarId: null
	    };
	  },
	
	  watch: {
	    items: function items(val, oldVal) {
	      if (val.length > 0) {
	        this.setPreSelectedItems();
	      }
	    }
	  },
	  methods: {
	    withPopper: function withPopper(dropdownList, component, _ref) {
	      var width = _ref.width;
	
	      dropdownList.style.width = width;
	      (0, _core.createPopper)(component.$refs.toggle, dropdownList, {
	        placement: this.placement,
	        modifiers: [{
	          name: 'offset', options: {
	            offset: [0, 0]
	          }
	        }, {
	          name: 'toggleClass',
	          enabled: true,
	          phase: 'write',
	          fn: function fn(_ref2) {
	            var state = _ref2.state;
	
	            component.$el.classList.toggle('openFromBottom', state.placement === 'top');
	          }
	        }]
	      });
	    },
	    add: function add(item) {},
	    remove: function remove(item) {},
	    setSelectedItems: function setSelectedItems(val) {
	      this.selectedItems = [];
	      this.selectedItems = val;
	      this.sortSelectedItems();
	      this.$emit('update', this.selectedItems);
	    },
	    sortSelectedItems: function sortSelectedItems() {
	      if (!this.sortSelectedByName) return;
	      this.selectedItems.sort(function (a, b) {
	        return (a.name || '').localeCompare(b.name || '', 'da');
	      });
	    },
	    isInSelectedItems: function isInSelectedItems(calid) {
	      return this.selectedItems.findIndex(function (item) {
	        return item && item.id === calid;
	      }) >= 0;
	    },
	    setPreSelectedItems: function setPreSelectedItems() {
	      var _this2 = this;
	
	      this.preSelectedItems.forEach(function (userCalendarId) {
	        if (userCalendarId) {
	          if (!_this2.isInSelectedItems(userCalendarId)) {
	            var idx = _this2.items.findIndex(function (item) {
	              return item.id === userCalendarId;
	            });
	            if (idx > -1) {
	              _this2.selectedItems.push(_this2.items[idx]);
	            } else {
	              console.log('cant find', userCalendarId);
	            }
	          }
	        }
	      });
	      this.sortSelectedItems();
	      if (!this.showTags) {
	        this.isLoaded = true;
	      }
	    },
	    getTags: function getTags() {
	      var _this3 = this;
	
	      _docendo2.default.schoolTags(this.school.id, function (data) {
	        var tags = [];
	        var i = 0;
	        data.forEach(function (tag) {
	          i++;
	          var oneTag = {
	            tag: true,
	            id: 999999999999 + i,
	            name: tag,
	            icon: 'icon-price-tag2'
	          };
	          tags.push(oneTag);
	        });
	        _this3.tags = tags;
	      });
	    },
	    createNew: function createNew(evt) {
	      var _this4 = this;
	
	      if (this.itemType === 'room') {
	        var calendars = [{ name: evt, type: this.itemType }];
	        _docendo2.default.schoolBulkCreateCalendars(window.SCHOOL.id, this.activeSchoolYear.id, calendars, function (success) {
	          console.log('success', success);
	        }, function (failure) {
	          console.log('failure', failure);
	        });
	        return;
	      }
	      if (this.itemType === 'user') {
	        var users = [{ name: evt }];
	        _docendo2.default.schoolUsersCreate(this.school.id, users, function (success) {
	          _this4.$store.dispatch('getSchoolCalendars', _this4.school.id);
	          _this4.newUserCalendarId = success[0].user_calendar_id;
	          console.log('newUserCalendarId', _this4.newUserCalendarId);
	        }, function (failure) {
	          console.log('failure', failure);
	        });
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.showTags) {
	      this.getTags();
	    }
	    this.setPreSelectedItems();
	  }
	};

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _vuex = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelect2.default },
	  props: {
	    showTags: {
	      type: Boolean,
	      default: false
	    },
	    multiple: {
	      type: Boolean,
	      default: true
	    },
	    showCreateButton: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['klassCalendars'])),
	  data: function data() {
	    return {
	      selectedKlasses: [],
	      searchText: '',
	      locale: 'da',
	      i18n: {
	        da: {
	          search: 'Søg og vælg klasse'
	        },
	        en: {
	          search: 'Search and choose class'
	        },
	        nb: {
	          search: 'Søk og velg klasse'
	        }
	      }
	    };
	  },
	
	  watch: {
	    selectedUsers: function selectedUsers() {
	      this.$emit('updated', this.selectedKlasses);
	    }
	  },
	  methods: {
	    add: function add(item) {
	      this.$emit('add', item);
	    },
	    remove: function remove(item) {
	      this.$emit('remove', item);
	    },
	    setSelectedKasses: function setSelectedKasses(val) {
	      this.selectedKlasses = val;
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.locale = window.USER.language ? window.USER.language : 'da';
	  }
	};

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _hiddenAbsenceTitle = __webpack_require__(110);
	
	var _vuex = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    user_not_found: 'Brugeren er fjernet fra skolen',
	    would_you_like_to_set: 'Vil du sætte',
	    as_a_substitute_instead_of_teacher: 'på som vikar i stedet for underviser',
	    yes: 'Ja',
	    no: 'Nej'
	  },
	  nb: {
	    user_not_found: 'Brukeren er fjernet fra skolen',
	    would_you_like_to_set: 'Vil du sette',
	    as_a_substitute_instead_of_teacher: 'som vikar istedenfor lærer',
	    yes: 'Ja',
	    no: 'Nej'
	  },
	  en: {
	    user_not_found: 'User is removed from school',
	    would_you_like_to_set: 'Would you like to set',
	    as_a_substitute_instead_of_teacher: 'as a substitute instead of a teacher',
	    yes: 'Yes',
	    no: 'No'
	  }
	};
	
	exports.default = {
	  components: { dSelect: _DSelect2.default },
	  props: {
	    eventId: {
	      type: Number
	    },
	    startTime: {
	      type: String,
	      default: '2018-06-19 07:00'
	    },
	    endTime: {
	      type: String,
	      default: '2018-06-19 14:00'
	    },
	    subs: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    user: {
	      type: Object,
	      default: function _default() {}
	    },
	    othersOnLesson: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    show: {
	      default: false,
	      type: Boolean
	    },
	    addClass: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  watch: {
	    eventId: function eventId() {
	      this.selectedForehand = this.subs;
	      this.getUsersSelectedForehand();
	      this.getOccupiedUsers();
	    },
	    user: function user() {
	      this.selectedForehand = this.subs;
	      this.getUsersSelectedForehand();
	      this.getOccupiedUsers();
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['allUsersSortedOnName', 'locale']), {
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    userNotFoundPlaceholder: function userNotFoundPlaceholder() {
	      return {
	        id: 0,
	        name: this.i18n['user_not_found'],
	        type: 'user',
	        url: '/calendar',
	        calendar_id: 0,
	        dayAbsence: [],
	        dayEvents: [],
	        dayAllEvents: [],
	        default_thumb_url: '',
	        user_tags: [],
	        occupied: false,
	        isOnLesson: false,
	        currentEventId: 0,
	        user_calendar_id: 0,
	        isErrorUser: true
	      };
	    },
	    filterAbsentUser: function filterAbsentUser() {
	      var filterUserIds = [this.user.id];
	      return this.allUsersSortedOnName.filter(function (user) {
	        return filterUserIds.indexOf(user.id) === -1;
	      });
	    },
	    usersForList: function usersForList() {
	      var _this = this;
	
	      var users = this.filterAbsentUser.map(function (obj) {
	        var occ = false;
	        var isOnLesson = false;
	        var isWithAvailability = false;
	        if (_this.occupiedUsers[obj.user_calendar_id]) {
	          occ = _this.occupiedUsers[obj.user_calendar_id];
	          isOnLesson = _this.othersOnLesson.filter(function (user) {
	            return user.user_calendar_id === obj.user_calendar_id;
	          }).length > 0;
	          isWithAvailability = occ.events.filter(function (event) {
	            return event.event_type === 'available';
	          }).length > 0;
	        }
	        var user = {
	          id: obj.id,
	          default_thumb_url: obj.default_thumb_url,
	          name: obj.name,
	          user_tags: obj.user_tags,
	          occupied: occ,
	          currentEventId: _this.eventId,
	          isOnLesson: isOnLesson,
	          isWithAvailability: isWithAvailability,
	          user_calendar_id: obj.user_calendar_id
	        };
	        return user;
	      });
	      users.push(this.userNotFoundPlaceholder);
	      return users;
	    }
	  }),
	  data: function data() {
	    return {
	      selectedUsers: [],
	      occupiedUsers: [],
	      allDataLoaded: false,
	      selfIsLoading: false,
	      subFromIsOnLesson: null
	    };
	  },
	
	  methods: {
	    getUsers: function getUsers(val) {
	      if (val) {
	        this.getOccupiedUsers();
	      }
	    },
	    addUser: function addUser(user) {
	      this.$emit('add', user);
	    },
	    removeUser: function removeUser(user) {
	      this.$emit('remove', user);
	    },
	    setSelectedUsers: function setSelectedUsers(val) {
	      this.selectedUsers = val;
	      this.$emit('updated', this.selectedUsers);
	    },
	    getUsersSelectedForehand: function getUsersSelectedForehand() {
	      var _this2 = this;
	
	      this.selectedUsers.splice(0, this.selectedUsers.length);
	
	      var _loop = function _loop(i) {
	        for (var j = 0; j < _this2.usersForList.length; j++) {
	          if (_this2.usersForList[j].id === _this2.selectedForehand[i].id) {
	            if (_this2.selectedUsers.filter(function (obj) {
	              return obj.id === _this2.selectedForehand[i].id;
	            }).length === 0) {
	              _this2.selectedUsers.push(_this2.usersForList[j]);
	            }
	          }
	        }
	      };
	
	      for (var i = 0; i < this.selectedForehand.length; i++) {
	        _loop(i);
	      }
	    },
	    getOccupiedUsers: function getOccupiedUsers() {
	      var _this3 = this;
	
	      _docendo2.default.schoolAvailabilities(window.SCHOOL.id, 'user', this.startTime, this.endTime, function (data) {
	        var toArr = (0, _hiddenAbsenceTitle.maskHiddenAbsenceTitlesInAvailability)(JSON.parse(data), _this3.$store, window.SCHOOL.id);
	        var newUsers = {};
	        for (var i = 0; i < toArr.length; i++) {
	          newUsers[toArr[i].calendar_id] = toArr[i];
	        }
	        _this3.occupiedUsers = newUsers;
	        if (!_this3.allDataLoaded) {
	          _this3.getUsersSelectedForehand();
	        }
	        _this3.allDataLoaded = true;
	        _this3.selfIsLoading = false;
	      });
	    },
	    addedIsOnLesson: function addedIsOnLesson(sub) {
	      this.subFromIsOnLesson = sub;
	    },
	    setSubFromIsOnLesson: function setSubFromIsOnLesson() {
	      var _this4 = this;
	
	      for (var j = 0; j < this.usersForList.length; j++) {
	        if (this.usersForList[j].id === this.subFromIsOnLesson.id) {
	          this.selectedUsers.push(this.usersForList[j]);
	        }
	      }
	      _docendo2.default.eventAddSubstitute(this.eventId, this.subFromIsOnLesson.id, this.user.id, function (data) {
	        _this4.subFromIsOnLesson = null;
	        _this4.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data));
	        _this4.$emit('addedSubFromTeachers');
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.selectedForehand = this.subs;
	    if (this.selectedForehand.length > 0) {
	      this.getOccupiedUsers();
	    }
	  }
	};

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	
	var NON_OCCUPYING_TYPES = {
	  presence: true,
	  available: true
	};
	
	exports.default = {
	  components: { dSelect: _DSelect2.default },
	  props: {
	    possibleSubs: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    activeEvents: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isLoading: {
	      type: Boolean,
	      default: false
	    },
	    addClass: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    placeholder: {
	      type: String,
	      default: ''
	    }
	  },
	  computed: {
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    selectedLessonRanges: function selectedLessonRanges() {
	      var selectedEventIds = {};
	      var ranges = [];
	      this.activeEvents.forEach(function (activeEvent, idx) {
	        if (!activeEvent.lesson || !activeEvent.lesson.start || !activeEvent.lesson.end) {
	          return;
	        }
	        selectedEventIds[activeEvent.event_id] = true;
	        ranges.push({
	          idx: idx,
	          range: moment.range(activeEvent.lesson.start, activeEvent.lesson.end),
	          timeLabel: activeEvent.lessonLTTime
	        });
	      });
	      return { selectedEventIds: selectedEventIds, ranges: ranges };
	    },
	    subsForSelect: function subsForSelect() {
	      var _this = this;
	
	      return this.possibleSubs.filter(function (user) {
	        return user && !user.headline && (!user.dayAbsence || user.dayAbsence.length < 1);
	      }).map(function (user) {
	        var occupiedSlots = _this.occupiedSlotsForUser(user);
	        var occupiedLabel = _this.occupiedLabelForSlots(occupiedSlots);
	        var occupiedTitles = occupiedSlots.map(function (slot) {
	          return slot.event && slot.event.title;
	        }).filter(Boolean).join(', ');
	        return {
	          id: user.id,
	          name: user.name,
	          default_thumb_url: user.default_thumb_url,
	          user_calendar_id: user.user_calendar_id,
	          user_tags: user.user_tags,
	          occupiedLabel: occupiedLabel,
	          occupiedTitles: occupiedTitles,
	          occupied: occupiedSlots.length > 0 ? {
	            events: [{
	              event_id: -1,
	              event_type: 'lesson',
	              title: occupiedLabel
	            }]
	          } : false
	        };
	      });
	    }
	  },
	  methods: {
	    occupiedSlotsForUser: function occupiedSlotsForUser(user) {
	      var _selectedLessonRanges = this.selectedLessonRanges,
	          selectedEventIds = _selectedLessonRanges.selectedEventIds,
	          ranges = _selectedLessonRanges.ranges;
	
	      if (ranges.length < 1) {
	        return [];
	      }
	      var dayEvents = user.dayEvents || [];
	      var occupiedByIdx = {};
	      for (var i = 0; i < dayEvents.length; i++) {
	        var event = this.allEventsInAHash[dayEvents[i]];
	        if (!this.eventCountsAsOccupied(event, selectedEventIds)) {
	          continue;
	        }
	        var eventRange = moment.range(event.start, event.end);
	        for (var j = 0; j < ranges.length; j++) {
	          var slot = ranges[j];
	          if (!occupiedByIdx[slot.idx] && slot.range.overlaps(eventRange)) {
	            occupiedByIdx[slot.idx] = {
	              idx: slot.idx,
	              timeLabel: slot.timeLabel,
	              event: event
	            };
	          }
	        }
	      }
	      return ranges.map(function (slot) {
	        return occupiedByIdx[slot.idx];
	      }).filter(Boolean);
	    },
	    eventCountsAsOccupied: function eventCountsAsOccupied(event, selectedEventIds) {
	      if (!event || event.canceled) {
	        return false;
	      }
	      if (selectedEventIds[event.id]) {
	        return false;
	      }
	      return !NON_OCCUPYING_TYPES[event.event_type];
	    },
	    occupiedLabelForSlots: function occupiedLabelForSlots(occupiedSlots) {
	      var total = this.selectedLessonRanges.ranges.length;
	      if (occupiedSlots.length < 1 || total < 1) {
	        return '';
	      }
	      var times = occupiedSlots.map(function (slot) {
	        return slot.timeLabel;
	      }).filter(Boolean).join(', ');
	      if (total === 1) {
	        var occupied = this.$t('vue2.sub_scheduler.occupied');
	        return times ? occupied + ' ' + times : occupied;
	      }
	      var countLabel = this.$t('vue2.sub_scheduler.occupied_in_selected', {
	        occupied: occupiedSlots.length,
	        total: total
	      }).replace('{occupied}', occupiedSlots.length).replace('{total}', total);
	      return times ? countLabel + ' · ' + times : countLabel;
	    },
	    onAdd: function onAdd(user) {
	      this.$emit('add', user);
	    }
	  }
	};

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Spinner = __webpack_require__(26);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    user_not_found: 'Brugeren er fjernet fra skolen',
	    would_you_like_to_set: 'Vil du sætte',
	    as_a_substitute_instead_of_teacher: 'på som vikar i stedet for underviser',
	    yes: 'Ja',
	    no: 'Nej',
	    working_hours: 'Arbejdstid',
	    also_assigned: 'Også tilknyttet'
	  },
	  nb: {
	    user_not_found: 'Brukeren er fjernet fra skolen',
	    would_you_like_to_set: 'Vil du sette',
	    as_a_substitute_instead_of_teacher: 'som vikar istedenfor lærer',
	    yes: 'Ja',
	    no: 'Nej',
	    working_hours: 'Arbeidstid',
	    also_assigned: 'Også tilknyttet'
	  },
	  en: {
	    user_not_found: 'User is removed from school',
	    would_you_like_to_set: 'Would you like to set',
	    as_a_substitute_instead_of_teacher: 'as a substitute instead of a teacher',
	    yes: 'Yes',
	    no: 'No',
	    working_hours: 'Working hours',
	    also_assigned: 'Also assigned'
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { spinner: _Spinner2.default },
	  props: {
	    items: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    itemsSelected: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    isLoading: {
	      default: false,
	      type: Boolean
	    },
	    show: {
	      default: false,
	      type: Boolean
	    },
	    multiple: {
	      default: true,
	      type: Boolean
	    },
	    placeholder: {
	      type: String,
	      default: ''
	    },
	    eventId: {
	      type: Number,
	      required: false
	    },
	    user: {},
	    isUpdatingUsers: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    usersThatAreSelected: function usersThatAreSelected() {
	      var _this = this;
	
	      var subIds = this.selectedUsers.map(function (user) {
	        return user.id;
	      });
	      return subIds.map(function (subID) {
	        return _this.items.find(function (user) {
	          return user.id === subID;
	        });
	      });
	    },
	    withoutSelectedItems: function withoutSelectedItems() {
	      var _this2 = this;
	
	      return this.items.filter(function (el) {
	        return _this2.selectedUsers.filter(function (secEl) {
	          return secEl.id === el.id;
	        }).length === 0;
	      });
	    },
	    searchedUsers: function searchedUsers() {
	      var _this3 = this;
	
	      return this.withoutSelectedItems.filter(function (user) {
	        return user.name !== '' ? user.name.match(new RegExp(_this3.searchText, 'i')) : '';
	      });
	    },
	    placeholderText: function placeholderText() {
	      var placeholder = this.placeholder.length > 0 ? this.placeholder : this.$i18n.t('vue2.dselect.placeholder');
	      return this.selectedUsers.length > 0 ? '' : placeholder;
	    }
	  },
	  data: function data() {
	    return {
	      showDropdown: false,
	      searchText: '',
	      selectedUsers: [],
	      keyboardSelected: null,
	      keyboardSelectedIndex: 0,
	      readyToDelete: null,
	      openFromBottom: false,
	      subFromIsOnLesson: null
	    };
	  },
	
	  watch: {
	    show: function show() {
	      if (!this.show) {
	        this.close();
	      }
	    },
	    searchedUsers: function searchedUsers() {
	      this.keyboardSelectedIndex = 0;
	      this.keyboardSelected = this.searchedUsers[0];
	    },
	    searchText: function searchText() {
	      this.$emit('searchText', this.searchText);
	    }
	  },
	  filters: {
	    localeTime: function localeTime(eventTime) {
	      return (0, _moment2.default)(eventTime).format('LT');
	    }
	  },
	  methods: {
	    addedIsOnLesson: function addedIsOnLesson(sub) {
	      this.subFromIsOnLesson = sub;
	    },
	    setSubFromIsOnLesson: function setSubFromIsOnLesson() {
	      var _this4 = this;
	
	      this.selectedUsers.push(this.items[this.items.indexOf(this.subFromIsOnLesson)]);
	      _docendo2.default.eventAddSubstitute(this.eventId, this.subFromIsOnLesson.id, this.user.id, function (data) {
	        _this4.subFromIsOnLesson = null;
	        _this4.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data));
	      });
	    },
	    userOccEvents: function userOccEvents(selectedUser) {
	      var _this5 = this;
	
	      if (selectedUser.occupied && selectedUser.occupied.events.length > 0) {
	        var occEventsWithoutPresenceAndCurrentEvent = selectedUser.occupied.events.filter(function (lesson) {
	          return lesson.event_id !== _this5.eventId && lesson.event_type !== 'presence';
	        });
	        return occEventsWithoutPresenceAndCurrentEvent;
	      } else {
	        return false;
	      }
	    },
	    checkHeight: function checkHeight() {
	      var bcr = this.$el.getBoundingClientRect();
	      var pxFromTop = bcr.top;
	      var pxFromBottom = window.innerHeight - (bcr.top + bcr.height);
	      if (pxFromBottom < 330 && pxFromTop > 330) {
	        this.openFromBottom = true;
	      }
	    },
	    isReadyToDelete: function isReadyToDelete(user) {
	      if (!this.readyToDelete) {
	        return;
	      }
	      return this.readyToDelete.id === user.id;
	    },
	    scrollTokeyboardSelected: function scrollTokeyboardSelected() {
	      var _this6 = this;
	
	      setTimeout(function () {
	        var user = document.querySelector('.isReadyForSelection');
	        var selectedOffsetTop = user.offsetTop;
	        var selectedHeight = user.getBoundingClientRect().height;
	        var totalHeight = selectedOffsetTop + selectedHeight;
	
	        var top = _this6.$refs.dropdown.scrollTop;
	        var height = _this6.$refs.dropdown.getBoundingClientRect().height;
	        var bottom = top + height;
	
	        if (totalHeight > bottom) {
	          _this6.$refs.dropdown.scrollTop = _this6.$refs.dropdown.scrollTop + selectedHeight;
	        }
	
	        if (selectedOffsetTop < top) {
	          _this6.$refs.dropdown.scrollTop = _this6.$refs.dropdown.scrollTop - selectedHeight;
	        }
	      }, 0);
	    },
	    setIsReadyForSelection: function setIsReadyForSelection(user, idx) {
	      this.keyboardSelected = null;
	      this.keyboardSelected = user;
	      this.keyboardSelectedIndex = idx;
	    },
	    selectWithKeyboard: function selectWithKeyboard(stroke, e) {
	      if (!this.showDropdown) {
	        this.open();
	      }
	      if (stroke === 'down') {
	        if (this.keyboardSelectedIndex + 1 >= this.searchedUsers.length) {
	          return;
	        }
	        this.keyboardSelectedIndex = this.keyboardSelectedIndex + 1;
	        this.keyboardSelected = this.searchedUsers[this.keyboardSelectedIndex];
	        this.scrollTokeyboardSelected();
	      }
	      if (stroke === 'up') {
	        if (this.keyboardSelectedIndex - 1 < 0) {
	          return;
	        }
	        this.keyboardSelectedIndex = this.keyboardSelectedIndex - 1;
	        this.keyboardSelected = this.searchedUsers[this.keyboardSelectedIndex];
	        this.scrollTokeyboardSelected();
	      }
	      if (stroke === 'enter') {
	        if (this.keyboardSelected === null) {
	          return;
	        }
	        if (this.searchedUsers.length < 1) {
	          this.$emit('enter');
	          return;
	        }
	        this.toggleUser(this.keyboardSelected);
	      }
	    },
	    isSelectedWithKeyboard: function isSelectedWithKeyboard(user) {
	      return this.keyboardSelected && this.keyboardSelected.id === user.id;
	    },
	    deleteUserWithKeyboard: function deleteUserWithKeyboard() {
	      if (this.searchText.length > 0 || this.selectedUsers.length < 1) {
	        return;
	      }
	      if (this.readyToDelete === null) {
	        this.readyToDelete = this.selectedUsers[this.selectedUsers.length - 1];
	      } else {
	        this.removeUser(this.selectedUsers[this.selectedUsers.length - 1]);
	        this.readyToDelete = null;
	      }
	    },
	    close: function close() {
	      this.$emit('close');
	      if (!this.showDropdown) {
	        return;
	      }
	      this.showDropdown = false;
	      this.keyboardSelected = null;
	      this.keyboardSelectedIndex = 0;
	      this.readyToDelete = null;
	      this.searchText = '';
	      this.$emit('show', false);
	      this.openFromBottom = false;
	    },
	    open: function open() {
	      this.checkHeight();
	      this.showDropdown = true;
	      this.$emit('show', true);
	      this.setFocus();
	      this.keyboardSelectedIndex = 0;
	    },
	    toggleUser: function toggleUser(item) {
	      if (item.tag) {
	        this.selectAllWithTag(item.name);
	        return;
	      }
	      if (this.isSelected(item)) {
	        this.removeUser(item);
	      } else {
	        if (item.isOnLesson) {
	          this.addedIsOnLesson(item);
	          this.close();
	          return;
	        }
	        if (this.multiple) {
	          this.selectedUsers.push(item);
	          this.$emit('add', item);
	        } else {
	          this.selectedUsers = [];
	          this.selectedUsers.push(item);
	          this.$emit('add', item);
	        }
	        this.$emit('update', this.selectedUsers);
	      }
	      this.close();
	    },
	    selectAllWithTag: function selectAllWithTag(tag) {
	      var _this7 = this;
	
	      var usersWithTag = this.items.filter(function (item) {
	        return item.user_tags && item.user_tags.indexOf(tag) > -1;
	      });
	      usersWithTag.forEach(function (user) {
	        var idx = _this7.items.findIndex(function (x) {
	          return x.id === user.id;
	        });
	        if (!_this7.isSelected(_this7.items[idx])) {
	          _this7.selectedUsers.push(_this7.items[idx]);
	        }
	      });
	      this.close();
	      this.$emit('update', this.selectedUsers);
	    },
	    removeUser: function removeUser(item) {
	      this.selectedUsers.splice(this.selectedUsers.indexOf(item), 1);
	      this.$emit('remove', item);
	      this.$emit('update', this.selectedUsers);
	      this.close();
	    },
	    isSelected: function isSelected(user) {
	      return this.selectedUsers.indexOf(user) > -1;
	    },
	    setFocus: function setFocus() {
	      this.$refs.inputfield.focus();
	    }
	  },
	  mounted: function mounted() {
	    if (this.show) {
	      this.open();
	    }
	    this.selectedUsers = this.itemsSelected;
	  }
	};

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DSelectCals = __webpack_require__(48);
	
	var _DSelectCals2 = _interopRequireDefault(_DSelectCals);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _vuex = __webpack_require__(14);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelectCals2.default },
	  props: {
	    showTags: {
	      type: Boolean,
	      default: false
	    },
	    multiple: {
	      type: Boolean,
	      default: true
	    },
	    showCreateButton: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usersSortedOnName']), {
	    isLoading: function isLoading() {
	      return this.$store.state.isLoadingAllUsers;
	    },
	    schoolId: function schoolId() {
	      return window.SCHOOL.id;
	    },
	    getSelectedUsersIds: function getSelectedUsersIds() {
	      return this.selectedUsers.map(function (user) {
	        return user.id;
	      });
	    },
	    tagsForSelect: function tagsForSelect() {
	      var tags = [];
	      var i = 0;
	      this.tags.forEach(function (tag) {
	        i++;
	        var oneTag = {
	          tag: true,
	          id: 999999999999 + i,
	          name: tag,
	          icon: 'icon-price-tag2'
	        };
	        tags.push(oneTag);
	      });
	      return tags;
	    },
	    usersAndTags: function usersAndTags() {
	      var items = [].concat((0, _toConsumableArray3.default)(this.usersSortedOnName));
	      if (this.showTags) {
	        this.tagsForSelect.forEach(function (obj) {
	          items.push(obj);
	        });
	      }
	      return items;
	    }
	  }),
	  data: function data() {
	    return {
	      selectedUsers: [],
	      searchText: '',
	      tags: [],
	      showDropDown: false,
	      allDataLoaded: false,
	      getOnce: true
	    };
	  },
	
	  watch: {
	    schoolId: function schoolId() {
	      this.$store.dispatch('getUsers', this.schoolId);
	      this.getTags();
	    },
	    isLoading: function isLoading() {
	      if (this.usersSortedOnName.length > 0 && this.getOnce) {
	        this.getUsersFromRORInput();
	      } else {
	        this.setNewlyCreatedUser();
	      }
	    },
	    selectedUsers: function selectedUsers() {
	      this.setUsersOnRORInput();
	      this.$emit('usersUpdated', this.selectedUsers);
	    }
	  },
	  methods: {
	    addUser: function addUser(user) {
	      this.$emit('add', user);
	    },
	    removeUser: function removeUser(user) {
	      this.$emit('remove', user);
	    },
	    setShow: function setShow(val) {
	      this.showDropDown = val;
	    },
	    setSelectedUsers: function setSelectedUsers(val) {
	      this.selectedUsers = val;
	      this.$emit('update', this.selectedUsers);
	    },
	    setCreateUserText: function setCreateUserText(val) {
	      this.searchText = val;
	    },
	    createCalendarOnDSelect: function createCalendarOnDSelect() {
	      this.showDropDown = false;
	
	      window.dispatchEvent(new window.CustomEvent('vueCreateUser', { detail: this.searchText }));
	    },
	    setNewlyCreatedUser: function setNewlyCreatedUser() {
	      for (var j = 0; j < this.usersSortedOnName.length; j++) {
	        if (this.usersSortedOnName[j].id === Number(_eventbus2.default.createdId)) {
	          this.selectedUsers.push(this.usersSortedOnName[j]);
	        }
	      }
	    },
	    getUsersFromRORInput: function getUsersFromRORInput() {
	      if (document.getElementById('subject_stringy_user_ids') === null || document.getElementById('subject_stringy_user_ids').value.length < 1) {
	        return;
	      }
	      var ids = document.getElementById('subject_stringy_user_ids').value;
	      var idsArr = ids.split(',');
	      for (var i = 0; i < idsArr.length; i++) {
	        for (var j = 0; j < this.usersSortedOnName.length; j++) {
	          if (this.usersSortedOnName[j].id === Number(idsArr[i])) {
	            this.selectedUsers.push(this.usersSortedOnName[j]);
	          }
	        }
	      }
	      this.getOnce = false;
	    },
	    setUsersOnRORInput: function setUsersOnRORInput() {
	      if (document.getElementById('subject_stringy_user_ids') === null) {
	        return;
	      }
	      document.getElementById('subject_stringy_user_ids').value = this.getSelectedUsersIds;
	    },
	    getTags: function getTags() {
	      var _this = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this.tags = data;
	        _this.allDataLoaded = true;
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUsers', this.schoolId);
	    if (this.showTags) {
	      this.getTags();
	    }
	  }
	};

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _CustomEvent = __webpack_require__(159);
	
	var _CustomEvent2 = _interopRequireDefault(_CustomEvent);
	
	var _DropUp = __webpack_require__(413);
	
	var _DropUp2 = _interopRequireDefault(_DropUp);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { dropup: _DropUp2.default, ModalConfirmation: _ModalConfirmation2.default },
	  name: 'delete-day-or-week',
	  props: {
	    calendar: {},
	    date: {
	      default: null
	    },
	    internaldate: {
	      type: Object,
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    currentdate: {
	      type: String,
	      default: function _default() {
	        return '';
	      }
	    }
	  },
	  computed: {
	    firstDayOfTheWeek: function firstDayOfTheWeek() {
	      return this.$store.getters.firstDayOfWeek;
	    },
	    weekDaysLocale: function weekDaysLocale() {
	      var arr = [];
	
	      var start = this.firstDayOfTheWeek - 1;
	      for (var i = 0; i < 7; i++) {
	        start++;
	        arr.push(start);
	      }
	      return arr.reverse();
	    }
	  },
	  data: function data() {
	    return {
	      showDropUp: false,
	      isConfirmDeletion: false,
	      _currentDate: this.currentdate,
	      _internalDate: this.internaldate,
	      isDeleteWeek: false,
	      theDeleteText: '',
	      theDeleteFromDate: (0, _moment2.default)(),
	      theDeleteToDate: (0, _moment2.default)()
	    };
	  },
	
	  methods: {
	    setIsConfirmDeletion: function setIsConfirmDeletion(day) {
	      if (day === 'week') {
	        this.theDeleteText = this.$t('vue2.common.delete') + ' ' + this.$t('vue.deleteday.whole_week');
	        this.isDeleteWeek = true;
	      } else {
	        this.theDeleteText = this.$t('vue2.common.delete') + ' ' + this.formattedDate(day);
	        this.theDeleteFromDate = (0, _moment2.default)(this._internalDate).clone().day(day).startOf('day');
	        this.theDeleteToDate = (0, _moment2.default)(this._internalDate).clone().day(day).endOf('day');
	      }
	      this.isConfirmDeletion = true;
	      this.showDropUp = false;
	    },
	    closeIsConfirmDelete: function closeIsConfirmDelete() {
	      this.isConfirmDeletion = false;
	      this.isDeleteWeek = false;
	      this.theDeleteFromDate = (0, _moment2.default)(this._internalDate).clone().day(1).startOf('day');
	      this.theDeleteToDate = (0, _moment2.default)(this._internalDate).clone().day(1).endOf('day');
	    },
	    confirmDelete: function confirmDelete() {
	      if (this.isDeleteWeek) {
	        this.deleteWeek();
	      } else {
	        this.deleteDay();
	      }
	      this.closeIsConfirmDelete();
	    },
	    dropUp: function dropUp() {
	      this.showDropUp = true;
	      if (this.date) {
	        this._internalDate = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      } else {
	        this._currentDate = document.querySelector('.calendar').getAttribute('data-current_date');
	        this._internalDate = (0, _moment2.default)(this._currentDate, 'YYYY-MM-DD');
	      }
	    },
	    formattedDate: function formattedDate(day) {
	      return this.internaldate.clone().day(day).format('dddd');
	    },
	    deleteDay: function deleteDay() {
	      var mFrom = (0, _moment2.default)(this.theDeleteFromDate).toDate();
	      var mTo = (0, _moment2.default)(this.theDeleteToDate).toDate();
	      if ((0, _moment2.default)(mFrom).isValid() && (0, _moment2.default)(mTo).isValid()) {
	        _docendo2.default.deleteEventsRange(this.calendar, this.theDeleteFromDate.toISOString(), this.theDeleteToDate.toISOString(), this.deleted);
	      } else {
	        _eventbus2.default.toast = { text: this.$t('vue2.delete_day_or_week.cant_delete'), success: false };
	      }
	      this.showDropUp = false;
	    },
	    deleteWeek: function deleteWeek() {
	      var from = this.theDeleteFromDate = (0, _moment2.default)(this._internalDate).clone().day(this.weekDaysLocale[this.weekDaysLocale.length - 1]);
	      var to = this.theDeleteToDate = (0, _moment2.default)(this._internalDate).clone().day(this.weekDaysLocale[0]).endOf('day');
	      _docendo2.default.deleteEventsRange(this.calendar, from.toISOString(), to.toISOString(), this.deleted);
	      this.showDropUp = false;
	    },
	    deleted: function deleted() {
	      this.$emit('update');
	
	      var event = new window.CustomEvent('UpdateCalendarEvents', { bubbles: true, cancelable: true });
	      window.document.dispatchEvent(event);
	    }
	  }
	};

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _vuedraggable = __webpack_require__(108);
	
	var _vuedraggable2 = _interopRequireDefault(_vuedraggable);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _vueClickaway = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    substitutes: 'Vikarer',
	    select_filters: 'Vælg filtre',
	    selected: 'valgt',
	    clear_all: 'Ryd alle',
	    filter_by_criteria: 'Vis alle der opfylder ét eller flere af følgende kriterier',
	    filter_by_group: 'Eller er med i en eller flere af disse grupper',
	    filter_by_blocks: 'Eller har en eller flere af disse brikker',
	    groups: 'Grupper',
	    blocks: 'Brikker',
	    sub_events_available: 'Har rådighedstimer',
	    sub_events_two_in_some_class: 'Er to eller flere samtidig i en klasse',
	    sub_events_canceled: 'Har aflyste timer',
	    filters: 'Filtre',
	    sorting: 'Sortering',
	    sorting_hint: 'Træk for at ændre rækkefølgen. Vikarer der matcher det øverste vises først.',
	    sorting_empty: 'Slå et eller flere filtre til ovenfor for at sortere efter dem.',
	    sorting_inactive: 'Slå sortering til for at vise vikarerne i rækkefølgen herunder.',
	    sort_by_filters: 'Sortér efter filtre',
	    only_with_work_hours: 'Kun med arbejdstid:',
	    type_quick: 'Kriterie',
	    type_group: 'Gruppe',
	    type_block: 'Brik'
	  },
	  en: {
	    substitutes: 'Substitutes',
	    select_filters: 'Select filters',
	    selected: 'selected',
	    clear_all: 'Clear all',
	    filter_by_criteria: 'Show all that meet one or more of the following criteria',
	    filter_by_group: 'Or belong to one or more of these groups',
	    filter_by_blocks: 'Or has one or more of these blocks',
	    groups: 'Groups',
	    blocks: 'Blocks',
	    sub_events_available: 'Has available hours',
	    sub_events_two_in_some_class: 'Two or more are in a class at the same time',
	    sub_events_canceled: 'Has canceled hours',
	    filters: 'Filters',
	    sorting: 'Sorting',
	    sorting_hint: 'Drag to change the order. Substitutes matching the top item are shown first.',
	    sorting_empty: 'Turn on one or more filters above to sort by them.',
	    sorting_inactive: 'Turn on sorting to show substitutes in the order below.',
	    sort_by_filters: 'Sort by filters',
	    only_with_work_hours: 'Only with work hours:',
	    type_quick: 'Criterion',
	    type_group: 'Group',
	    type_block: 'Block'
	  },
	  nb: {
	    substitutes: 'Vikarer',
	    select_filters: 'Velg filtre',
	    selected: 'valgt',
	    clear_all: 'Fjern alle',
	    filter_by_criteria: 'Vis alle som oppfyller ett eller flere av følgende kriterier',
	    filter_by_group: 'Eller er med i en eller flere av disse gruppene',
	    filter_by_blocks: 'Eller har en eller flere av disse brikkene',
	    groups: 'Grupper',
	    blocks: 'Brikker',
	    sub_events_available: 'Har tilgjengelige timer',
	    sub_events_two_in_some_class: 'To eller flere er samtidig i en klasse',
	    sub_events_canceled: 'Har avlyste timer',
	    filters: 'Filtre',
	    sorting: 'Sortering',
	    sorting_hint: 'Dra for å endre rekkefølgen. Vikarer som matcher det øverste vises først.',
	    sorting_empty: 'Slå på ett eller flere filtre over for å sortere etter dem.',
	    sorting_inactive: 'Slå på sortering for å vise vikarene i rekkefølgen nedenfor.',
	    sort_by_filters: 'Sorter etter filtre',
	    only_with_work_hours: 'Kun med arbeidstid:',
	    type_quick: 'Kriterium',
	    type_group: 'Gruppe',
	    type_block: 'Brikke'
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { DoFiltersFilter: _DoFiltersFilter2.default, DDropdown: _DDropdown2.default, draggable: _vuedraggable2.default, AppToggle: _AppToggle2.default },
	  props: {
	    tags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedTags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      } },
	    selectedQuickFilters: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    eventTitleTags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedEventTitles: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    theSelectedSorting: {
	      type: String,
	      default: 'name'
	    },
	    isSortable: {
	      type: Boolean,
	      default: false
	    },
	    sortItems: {
	      type: Array,
	      default: function _default() {
	        return [];
	      } },
	    isSortActive: {
	      type: Boolean,
	      default: false
	    },
	    isPresenceOption: {
	      type: Boolean,
	      default: false
	    },
	    groupsRequiringPresence: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isShowDropdown: false,
	      quickFilters: [{ value: 'sub_events_canceled', titleKey: 'sub_events_canceled' }, { value: 'sub_events_available', titleKey: 'sub_events_available' }, { value: 'sub_events_two_in_some_class', titleKey: 'sub_events_two_in_some_class' }]
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale] || I18N['en'];
	    },
	    allSelectedFiltersLength: function allSelectedFiltersLength() {
	      var quickFilters = (0, _keys2.default)(this.selectedQuickFilters);
	      return quickFilters.length + this.selectedTags.length + this.selectedEventTitles.length;
	    },
	    sortHint: function sortHint() {
	      if (this.sortItems.length === 0) return this.i18n['sorting_empty'];
	      return this.isSortActive ? this.i18n['sorting_hint'] : this.i18n['sorting_inactive'];
	    }
	  },
	  methods: {
	    getIsQuickFilterSelected: function getIsQuickFilterSelected(quickFilter) {
	      return this.selectedQuickFilters.find(function (selectedQuickFilter) {
	        return selectedQuickFilter === quickFilter.value;
	      });
	    },
	    onClickOutside: function onClickOutside() {
	      this.isShowDropdown = false;
	    },
	    getSortItemTitle: function getSortItemTitle(item) {
	      return item.type === 'quick' ? this.i18n[item.value] : item.value;
	    },
	    onSortInput: function onSortInput(items) {
	      this.$emit('sortItems', items.map(function (item) {
	        return item.key;
	      }));
	    },
	    onToggleSort: function onToggleSort(isOn) {
	      if (isOn !== this.isSortActive) {
	        this.$emit('toggleSort', isOn);
	      }
	    }
	  }
	};

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    select_filters: 'Vælg filtre',
	    selected: 'valgt',
	    select_all: 'Vælg alle',
	    clear_all: 'Ryd alle',
	    search_placeholder: 'Søg',
	    no_results: 'Ingen resultater'
	  },
	  en: {
	    select_filters: 'Select filters',
	    selected: 'selected',
	    select_all: 'Select all',
	    clear_all: 'Clear all',
	    search_placeholder: 'Search',
	    no_results: 'No results'
	  },
	  nb: {
	    select_filters: 'Velg filtre',
	    selected: 'valgt',
	    select_all: 'Velg alle',
	    clear_all: 'Fjern alle',
	    search_placeholder: 'Søk',
	    no_results: 'Ingen resultater'
	  }
	};
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default },
	  props: {
	    title: {
	      type: String,
	      default: null
	    },
	    tags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedTags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      } },
	    numberOfSelectedTagsToShow: {
	      type: Number,
	      default: 3
	    },
	    placeholder: {
	      default: null
	    },
	    closeFromProp: {
	      type: Number,
	      default: 0
	    }
	  },
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        setTimeout(function () {
	          el.focus();
	        }, 0);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      query: ''
	    };
	  },
	
	  computed: {
	    resolvedTitle: function resolvedTitle() {
	      if (this.title === '') {
	        return '';
	      }
	      return this.title || this.$t('vue2.common.groups');
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale] || I18N['en'];
	    },
	    sortedTags: function sortedTags() {
	      var _this = this;
	
	      return [].concat((0, _toConsumableArray3.default)(this.tags)).sort(function (a, b) {
	        return a.localeCompare(b, _this.locale);
	      });
	    },
	    filteredTags: function filteredTags() {
	      var _this2 = this;
	
	      return this.sortedTags.filter(function (tag) {
	        return tag.toLowerCase().includes(_this2.query.toLowerCase());
	      });
	    }
	  },
	  methods: {
	    onCloseDropdown: function onCloseDropdown() {
	      this.query = '';
	      this.$emit('close');
	    },
	    selectAll: function selectAll() {
	      var _this3 = this;
	
	      this.filteredTags.forEach(function (tag) {
	        if (!_this3.selectedTags.includes(tag)) {
	          _this3.$emit('select', tag);
	        }
	      });
	    },
	    clearAll: function clearAll() {
	      this.$emit('clear');
	    },
	    select: function select(tag) {
	      this.$emit('select', tag);
	    },
	    getIsItemSelected: function getIsItemSelected(tag) {
	      return this.selectedTags.includes(tag);
	    }
	  }
	};

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(9);
	
	var I18N = {
	  da: {
	    filters: 'Filtre',
	    select_filters: 'Vælg filtre',
	    selected: 'valgt',
	    clear_all: 'Ryd alle'
	  },
	  en: {
	    filters: 'Filters',
	    select_filters: 'Select filters',
	    selected: 'selected',
	    clear_all: 'Clear all'
	  },
	  nb: {
	    filters: 'Filtre',
	    select_filters: 'Velg filtre',
	    selected: 'valgt',
	    clear_all: 'Fjern alle'
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    title: {
	      type: String,
	      default: null
	    },
	    selectedCount: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      isShowDropdown: false
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale] || I18N['en'];
	    }
	  },
	  methods: {
	    onClickOutside: function onClickOutside() {
	      this.isShowDropdown = false;
	    }
	  }
	};

/***/ }),
/* 549 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    }
	  }
	};

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DocendoConnnectionIndicator',
	  created: function created() {
	    _docendo2.default.subscribeConnected(this.connected);
	    _docendo2.default.subscribeDisconnected(this.disconnected);
	  },
	  methods: {
	    connected: function connected() {
	      this.is_connected = true;
	    },
	    disconnected: function disconnected() {
	      this.is_connected = false;
	    }
	  },
	  data: function data() {
	    return {
	      is_connected: true
	    };
	  }
	};

/***/ }),
/* 551 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    navigate: function navigate(direction) {
	      if (direction === 'previous') {
	        this.$emit('prev');
	      } else if (direction === 'next') {
	        this.$emit('next');
	      }
	    },
	    goToToday: function goToToday() {
	      this.$emit('today');
	    }
	  }
	};

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CreateEventForm = __webpack_require__(1503);
	
	var _CreateEventForm2 = _interopRequireDefault(_CreateEventForm);
	
	var _CreateEventNewSubject = __webpack_require__(1504);
	
	var _CreateEventNewSubject2 = _interopRequireDefault(_CreateEventNewSubject);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ModalConfirmation: _ModalConfirmation2.default, CreateTaskNewSubject: _CreateEventNewSubject2.default, CreateTaskForm: _CreateEventForm2.default },
	  props: {
	    user: {
	      type: Object,
	      default: null
	    },
	    initDate: {
	      type: Object,
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    initSubject: {
	      type: Object,
	      default: null
	    },
	    emitEvent: {
	      type: Boolean,
	      default: false
	    },
	    editEvent: {
	      type: Object,
	      default: null
	    },
	    openingHours: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      date: (0, _moment2.default)(),
	      theCreateNewSubjectName: null,
	      theNewlyCreatedSubject: null,
	      theDeleteEvent: null,
	      isDeleting: false
	    };
	  },
	
	  methods: {
	    deleteEvent: function deleteEvent() {
	      var _this = this;
	
	      this.isDeleting = true;
	      var schoolId = this.theDeleteEvent.school_id;
	      var eventId = this.theDeleteEvent.event_id;
	      _docendo2.default.deleteEvent(schoolId, eventId, function (success) {
	        _this.onCloseConfirmation();
	        _this.$emit('deletedEvent', success);
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    onCloseConfirmation: function onCloseConfirmation() {
	      this.onDeleteEvent(null);
	    },
	    onDeleteEvent: function onDeleteEvent(lesson) {
	      this.theDeleteEvent = lesson;
	    },
	    onCreatedEvent: function onCreatedEvent(lesson) {
	      var initDate = this.initDate;
	
	      var eventStart = lesson.start;
	      var eventEnd = lesson.end;
	
	      var initDateMoment = (0, _moment2.default)(initDate);
	      var eventStartMoment = (0, _moment2.default)(eventStart);
	      var eventEndMoment = (0, _moment2.default)(eventEnd);
	
	      var isStartDateSame = eventStartMoment.isSame(initDateMoment, 'day');
	      var isEndDateSame = eventEndMoment.isSame(initDateMoment, 'day');
	      if (this.emitEvent) {
	        this.$emit('addANewEvent', lesson);
	        return;
	      }
	      if (isStartDateSame && isEndDateSame) {
	        this.$store.commit('addANewEvent', lesson);
	      }
	    },
	    setDate: function setDate(mom) {
	      this.date = mom;
	    },
	    setCreateNewSubject: function setCreateNewSubject(str) {
	      this.theCreateNewSubjectName = str;
	    },
	    onNewSubject: function onNewSubject(subject) {
	      this.theNewlyCreatedSubject = subject;
	      this.setCreateNewSubject(null);
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.editEvent) {
	      this.date = (0, _moment2.default)(this.editEvent.start);
	      return;
	    }
	    this.date = this.initDate;
	  }
	};

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(35);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _TimeChanger = __webpack_require__(31);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Tabs: _Tabs2.default, dSelect: _DSelect2.default, DModal: _DModal2.default, TimeChanger: _TimeChanger2.default, DateSelector: _DateSelector2.default },
	  props: {
	    user: {
	      type: Object,
	      default: function _default() {
	        return {
	          name: 'Henrik',
	          user_calendar_id: 7
	        };
	      }
	    },
	    date: {
	      type: Object,
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    initSubject: {
	      type: Object,
	      default: null
	    },
	    theNewlyCreatedSubject: {
	      type: Object,
	      default: null
	    },
	    editEvent: {
	      type: Object,
	      default: null
	    },
	    openingHours: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isLoadingSubject: false,
	      subjects: [],
	      startTime: (0, _moment2.default)().set({ 'hour': 8, 'minutes': 0 }),
	      endTime: (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0 }),
	      selectedSubject: null,
	      isSubmitting: false,
	      theSearchText: '',
	      theNewSubject: null,
	      isShowCreateSubjectButton: false,
	      tabs: ['Med børn', 'Uden Børn', 'Fravær'],
	      activeTab: 'Med børn'
	    };
	  },
	
	  computed: {
	    isWithKids: function isWithKids() {
	      return this.activeTab === 'Med børn';
	    },
	    isValidated: function isValidated() {
	      return this.selectedSubject;
	    },
	    filteredSubjects: function filteredSubjects() {
	      return this.subjects.filter(function (subject) {
	        return subject.subject_type !== 'absence';
	      });
	    },
	    sortedSubjects: function sortedSubjects() {
	      var _this = this;
	
	      return this.filteredSubjects.map(function (subject) {
	        var translatedSubjectType = _this.$t('vue2.eventTypes.' + subject.subject_type);
	
	        var vSubjectType = translatedSubjectType === 'vue2.eventTypes.' + subject.subject_type ? subject.subject_type : translatedSubjectType;
	
	        return (0, _extends3.default)({}, subject, {
	          vSubjectType: vSubjectType
	        });
	      }).sort(function (a, b) {
	        if (a.name < b.name) return -1;
	        if (a.name > b.name) return 1;
	        return 0;
	      });
	    },
	    dbEventStart: function dbEventStart() {
	      var date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      var time = this.startTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    dbEventEnd: function dbEventEnd() {
	      var date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      var time = this.endTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    }
	  },
	  watch: {
	    theNewlyCreatedSubject: function theNewlyCreatedSubject(val) {
	      this.readSubjects();
	    }
	  },
	  methods: {
	    selectTab: function selectTab(tab) {
	      this.activeTab = tab;
	    },
	    setDate: function setDate(date) {
	      this.$emit('setDate', date);
	    },
	    onCloseDSelect: function onCloseDSelect() {
	      this.isShowCreateSubjectButton = false;
	    },
	    setIsShowCreateSubjectButton: function setIsShowCreateSubjectButton() {
	      var _this2 = this;
	
	      var idx = this.filteredSubjects.findIndex(function (subject) {
	        return subject.name === _this2.theSearchText;
	      });
	      this.isShowCreateSubjectButton = this.theSearchText.length > 0 && idx < 0;
	    },
	    onSearchTextDebounced: function onSearchTextDebounced() {
	      this.setIsShowCreateSubjectButton();
	    },
	    onCreateNewSubject: function onCreateNewSubject() {
	      this.$emit('createNewSubject', this.theSearchText);
	      this.theSearchText = '';
	    },
	    setTheSearchText: function setTheSearchText(str) {
	      this.theSearchText = str;
	    },
	    setSubject: function setSubject(arr) {
	      this.selectedSubject = arr[0];
	    },
	    setStartTime: function setStartTime(payload) {
	      this.startTime = payload;
	    },
	    setEndTime: function setEndTime(payload) {
	      this.endTime = payload;
	    },
	    readSubjects: function readSubjects() {
	      var _this3 = this;
	
	      this.isLoadingSubject = true;
	      _docendo2.default.sidebar(this.user.user_calendar_id, this.date, function (success) {
	        _this3.isLoadingSubject = false;
	        _this3.subjects = success;
	        _this3.$nextTick(function (_) {
	          if (_this3.theNewlyCreatedSubject) {
	            _this3.theNewSubject = _this3.theNewlyCreatedSubject;
	          }
	        });
	      }, function (failure) {
	        console.log('something went wrong');
	      });
	    },
	    onDelete: function onDelete() {
	      this.$emit('deleteEvent', this.editEvent);
	    },
	    onSubmitEditEvent: function onSubmitEditEvent() {
	      var _this4 = this;
	
	      this.isSubmitting = true;
	      var schoolId = this.editEvent.school_id;
	      var updates = [{ event_id: this.editEvent.event_id, start_time: this.dbEventStart, end_time: this.dbEventEnd }];
	      _docendo2.default.updateEvents(schoolId, updates, function (data) {
	        if (data && data.status === 'error') {
	          _eventbus2.default.toast = { text: data.message, 'success': false };
	          _this4.$emit('close');
	          return;
	        }
	        _this4.isSubmitting = false;
	        var deletedEventId = data.id;
	
	        _this4.$emit('updatedEvent', deletedEventId);
	        _eventbus2.default.toast = { text: _this4.$t('vue2.create_activity.created'), 'success': true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      });
	    },
	    submit: function submit() {
	      var _this5 = this;
	
	      var schoolId = this.selectedSubject.school_id;
	      var calendarId = this.selectedSubject.calendar_id;
	      var calendarIds = [calendarId].concat((0, _toConsumableArray3.default)(this.selectedSubject.cals.map(function (calendar) {
	        return calendar.id;
	      })));
	      var subjectId = this.selectedSubject.id;
	      var internalNote = '';
	      this.isSubmitting = true;
	      _docendo2.default.createEvent(schoolId, calendarId, calendarIds, subjectId, this.dbEventStart, this.dbEventEnd, '', '', '', internalNote, function (data) {
	        if (data && data.status === 'error') {
	          _eventbus2.default.toast = { text: data.message, 'success': false };
	          _this5.$emit('close');
	          return;
	        }
	        var lesson = JSON.parse(data);
	        _this5.$emit('onCreatedEvent', lesson);
	        _this5.$emit('close');
	        _eventbus2.default.toast = { text: _this5.$t('vue2.create_activity.created'), 'success': true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      });
	    }
	  },
	  mounted: function mounted() {
	    setTimeout(function (_) {
	      var el = document.querySelector('.time-changer__group > .flex.align-center > div:first-child > .d-time-change-input');
	      if (el) {
	        el.select();
	      }
	    }, 0);
	    if (!this.editEvent && this.openingHours) {
	      var openingHoursObj = this.openingHours;
	      var dateDayNum = (0, _moment2.default)(this.date).isoWeekday();
	      var data = openingHoursObj[dateDayNum];
	      if (data) {
	        var openHoursAndMinute = data['open'];
	        var _openHoursAndMinute$s = openHoursAndMinute.split(':'),
	            _openHoursAndMinute$s2 = (0, _slicedToArray3.default)(_openHoursAndMinute$s, 2),
	            hour = _openHoursAndMinute$s2[0],
	            minute = _openHoursAndMinute$s2[1];
	
	        if (openHoursAndMinute) {
	          this.startTime = (0, _moment2.default)().set({ 'hour': hour, 'minutes': minute });
	        }
	        var closeHoursAndMinute = data['close'];
	        var _closeHoursAndMinute$ = closeHoursAndMinute.split(':'),
	            _closeHoursAndMinute$2 = (0, _slicedToArray3.default)(_closeHoursAndMinute$, 2),
	            closeHour = _closeHoursAndMinute$2[0],
	            closeMinute = _closeHoursAndMinute$2[1];
	
	        if (closeHoursAndMinute) {
	          this.endTime = (0, _moment2.default)().set({ 'hour': closeHour, 'minutes': closeMinute });
	        }
	      }
	    }
	    if (this.editEvent) {
	      var startHour = (0, _moment2.default)(this.editEvent.start).format('HH');
	      var startMinute = (0, _moment2.default)(this.editEvent.start).format('mm');
	      this.startTime = (0, _moment2.default)().set({ 'hour': startHour, 'minutes': startMinute });
	      var endHour = (0, _moment2.default)(this.editEvent.end).format('HH');
	      var endMinute = (0, _moment2.default)(this.editEvent.end).format('mm');
	      this.endTime = (0, _moment2.default)().set({ 'hour': endHour, 'minutes': endMinute });
	      return;
	    }
	    if (this.initSubject) {
	      this.selectedSubject = this.initSubject;
	    }
	    this.readSubjects();
	  }
	};

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SubjectFormSubjectType = __webpack_require__(61);
	
	var _SubjectFormSubjectType2 = _interopRequireDefault(_SubjectFormSubjectType);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { SubjectFormSubjectType: _SubjectFormSubjectType2.default, dSelect: _DSelect2.default, DModal: _DModal2.default },
	  props: {
	    title: {
	      type: String
	    },
	    user: {
	      type: Object,
	      default: function _default() {
	        return {
	          name: 'Henrik',
	          user_calendar_id: 7
	        };
	      }
	    },
	    date: {
	      type: Object,
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      subjectName: '',
	      subjectType: '',
	      isSubmitting: false,
	      theActiveSchoolId: null,
	      userSchools: [],
	      isLoadingUserSchools: false
	    };
	  },
	
	  computed: {
	    isValidated: function isValidated() {
	      return this.subjectName.length > 0;
	    },
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    isUserHasMultipleSchools: function isUserHasMultipleSchools() {
	      return (0, _keys2.default)(this.userSchools).length > 1;
	    }
	  },
	  methods: {
	    setSubjectType: function setSubjectType(str) {
	      this.subjectType = str;
	    },
	    findSchoolYearId: function findSchoolYearId() {
	      if (this.activeSchoolYears.length === 1) {
	        return this.activeSchoolYears[0].id;
	      }
	      var givenDate = (0, _moment2.default)(this.date);
	
	      var overlappingSchoolYears = this.activeSchoolYears.filter(function (year) {
	        var start = (0, _moment2.default)(year.employee_time_start);
	        var end = (0, _moment2.default)(year.employee_time_end);
	        return givenDate.isBetween(start, end, undefined, '[]');
	      });
	
	      if (overlappingSchoolYears.length > 0) {
	        var latestSchoolYear = overlappingSchoolYears.reduce(function (latest, current) {
	          var latestEnd = (0, _moment2.default)(latest.employee_time_end);
	          var currentEnd = (0, _moment2.default)(current.employee_time_end);
	          return currentEnd.isAfter(latestEnd) ? current : latest;
	        }, overlappingSchoolYears[0]);
	
	        return latestSchoolYear.id;
	      } else {
	        _eventbus2.default.toast = { text: this.$t('vue2.create_activity.the_selected_date_is_outside_schoolyears'), 'success': false };
	        return null;
	      }
	    },
	    submit: function submit() {
	      var _this = this;
	
	      var calendarId = this.user.user_calendar_id;
	      var schoolYearId = this.findSchoolYearId();
	      if (!schoolYearId) {
	        return;
	      }
	      var schoolId = this.theActiveSchoolId;
	      var color = '#999999';
	      var duration = 45;
	      var preparation = null;
	      var calendarIds = [];
	      var subjectCode = null;
	      this.isSubmitting = true;
	      _docendo2.default.createSubject(this.subjectName, color, calendarId, duration, preparation, 0, this.subjectType, schoolId, schoolYearId, calendarIds, subjectCode, false, null, null, null, function (data) {
	        if (data && data.status === 'error') {
	          _eventbus2.default.toast = { text: data.message, 'success': false };
	          return;
	        }
	        _this.$emit('newSubject', data);
	      }, function (failure) {
	        console.log('failed');
	      });
	    },
	    readUser: function readUser() {
	      var _this2 = this;
	
	      _docendo2.default.showUser(this.user.id, function (data) {
	        _this2.userSchools = data && data.schools ? data.schools.sort(function (a, b) {
	          return a.name.localeCompare(b.name);
	        }) : [];
	      }, function (failure) {});
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.readUser();
	    this.subjectName = this.title;
	    this.theActiveSchoolId = this.activeSchool.id;
	    this.$nextTick(function (_) {
	      var el = _this3.$refs.d_title_input;
	      if (el) {
	        _this3.$refs.d_title_input.click();
	        _this3.$refs.d_title_input.focus();
	      }
	    });
	  }
	};

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _DSelectCalsIds = __webpack_require__(40);
	
	var _DSelectCalsIds2 = _interopRequireDefault(_DSelectCalsIds);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelectCalendarIds: _DSelectCalsIds2.default, dSelect: _DSelect2.default, DModal: _DModal2.default },
	  props: {
	    calendarAndUsers: {
	      type: Object,
	      default: null
	    },
	    schoolId: {
	      default: null
	    },
	    schoolYearId: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isSubmitting: false,
	      userCalendarIds: []
	    };
	  },
	
	  computed: {
	    calendar: function calendar() {
	      return this.calendarAndUsers['calendar'];
	    },
	    activeUsers: function activeUsers() {
	      return this.calendarAndUsers['users'];
	    },
	    calendarIdsToHide: function calendarIdsToHide() {
	      return this.activeUsers.map(function (user) {
	        return user.user_calendar_id;
	      });
	    },
	    isValidated: function isValidated() {
	      return this.userCalendarIds.length === 1;
	    },
	    userCalendars: function userCalendars() {
	      return this.$store.getters.userCalendars;
	    }
	  },
	  methods: {
	    setSelectedUsers: function setSelectedUsers(users) {
	      this.userCalendarIds = users.map(function (user) {
	        return user.id;
	      });
	    },
	    submit: function submit() {
	      var _this = this;
	
	      this.isSubmitting = true;
	      var calendarId = this.calendar.id;
	      var subjectName = 'Vagt';
	      var color = '#A0A5EF';
	      var defaultDuration = 420;
	      var preparation = null;
	      var hours = 0;
	      var subjectType = 'with_kids';
	      var subjectCode = null;
	      _docendo2.default.createSubject(subjectName, color, calendarId, defaultDuration, preparation, hours, subjectType, this.schoolId, this.schoolYearId, this.userCalendarIds, subjectCode, false, null, null, null, function (success) {
	        console.log('oprette!', success);
	        _this.$emit('created', success);
	      }, function (failure) {
	        console.log('failure!');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.$nextTick(function (_) {
	      var el = document.querySelector('.d-select__input-look');
	      if (el) {
	        el.click();
	      }
	    });
	  }
	};

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _WeekSelecter = __webpack_require__(106);
	
	var _WeekSelecter2 = _interopRequireDefault(_WeekSelecter);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DutySchedulePlan = __webpack_require__(1508);
	
	var _DutySchedulePlan2 = _interopRequireDefault(_DutySchedulePlan);
	
	var _DoSplash = __webpack_require__(412);
	
	var _DoSplash2 = _interopRequireDefault(_DoSplash);
	
	var _DutySchedulePlanCalendar = __webpack_require__(355);
	
	var _DutySchedulePlanCalendar2 = _interopRequireDefault(_DutySchedulePlanCalendar);
	
	var _CreateEvent = __webpack_require__(1502);
	
	var _CreateEvent2 = _interopRequireDefault(_CreateEvent);
	
	var _BottomNav = __webpack_require__(353);
	
	var _BottomNav2 = _interopRequireDefault(_BottomNav);
	
	var _CreateSubject = __webpack_require__(1505);
	
	var _CreateSubject2 = _interopRequireDefault(_CreateSubject);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DutyScheduleOpeningHours = __webpack_require__(1507);
	
	var _DutyScheduleOpeningHours2 = _interopRequireDefault(_DutyScheduleOpeningHours);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DutyScheduleOpeningHours: _DutyScheduleOpeningHours2.default,
	    DModal: _DModal2.default,
	    CreateSubject: _CreateSubject2.default, BottomNav: _BottomNav2.default, CreateEvent: _CreateEvent2.default, DutyScheduleCalendar: _DutySchedulePlanCalendar2.default, DoSplash: _DoSplash2.default, DutySchedulePlan: _DutySchedulePlan2.default, WeekSelecter: _WeekSelecter2.default
	  },
	  data: function data() {
	    return {
	      date: (0, _moment2.default)(),
	      events: [],
	      isEventsLoading: false,
	      theCreateEventObj: null,
	      theEditEventObj: null,
	      userNorms: null,
	      isLoadingUserNorms: false,
	      theCreateSubjectCalendar: null,
	      theNewlyCreatedSubject: null,
	      isCreateOpeningHours: false
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    openingHours: function openingHours() {
	      if (!this.schoolSettings || !this.schoolSettings.openingHours) {
	        return null;
	      } else {
	        return this.schoolSettings.openingHours;
	      }
	    },
	    schoolYear: function schoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.schoolYear && this.schoolYear.id ? this.schoolYear.id : null;
	    },
	    calendars: function calendars() {
	      return this.$store.state.calendars;
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    isLoadingAllUsers: function isLoadingAllUsers() {
	      return this.$store.state.isLoadingAllUsers;
	    },
	    isInitialLoading: function isInitialLoading() {
	      return this.isLoadingSchoolCalenders || this.isLoadingAllUsers || this.isSubjectsLoading;
	    },
	    kindergartenCalendars: function kindergartenCalendars() {
	      return this.$store.getters.kindergartenCalendars;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    eventsInUserCalendarIdHash: function eventsInUserCalendarIdHash() {
	      return this.events.reduce(function (eventsHash, event) {
	        var eventDate = (0, _moment2.default)(event.start).format('YYYY_MM_DD');
	        var eventTimeFormatted = (0, _moment2.default)(event.start).format('HH:mm') + ' - ' + (0, _moment2.default)(event.end).format('HH:mm');
	        var eventObj = (0, _extends3.default)({}, event, {
	          v_time: eventTimeFormatted
	        });
	        event.calendars.forEach(function (calendar) {
	          var lookUpKey = calendar.calendar_id + '_' + eventDate;
	          if (eventsHash[lookUpKey]) {
	            eventsHash[lookUpKey].push(eventObj);
	          } else {
	            eventsHash[lookUpKey] = [eventObj];
	          }
	        });
	        return eventsHash;
	      }, {});
	    }
	  },
	  watch: {
	    users: function users() {
	      this.readEvents();
	    },
	    schoolYear: function schoolYear() {
	      this.readUserNorm();
	    }
	  },
	  methods: {
	    setIsCreateOpeningHours: function setIsCreateOpeningHours(bool) {
	      this.isCreateOpeningHours = bool;
	    },
	    onNewSubjectCreated: function onNewSubjectCreated($event) {
	      this.onCreateSubject(null);
	      this.theNewlyCreatedSubject = $event;
	    },
	    onCreateSubject: function onCreateSubject(calendarAndUsers) {
	      this.theCreateSubjectCalendar = calendarAndUsers;
	    },
	    onUpdatedEvent: function onUpdatedEvent() {
	      this.onCloseCreateEvent();
	      this.readEvents();
	    },
	    onDeletedEvent: function onDeletedEvent() {
	      this.onCloseCreateEvent();
	      this.readEvents();
	    },
	    onCloseCreateEvent: function onCloseCreateEvent() {
	      this.theCreateEventObj = null;
	      this.theEditEventObj = null;
	    },
	    onAddedEvent: function onAddedEvent(event) {
	      this.theCreateEventObj = null;
	      this.readEvents();
	    },
	    onEditEvent: function onEditEvent(theEditEvent) {
	      this.theEditEventObj = theEditEvent;
	    },
	    onCreateEvent: function onCreateEvent(theEventObject) {
	      this.theCreateEventObj = theEventObject;
	    },
	    setDate: function setDate(date) {
	      this.date = date;
	      this.readEvents();
	    },
	    setToday: function setToday() {
	      this.setDate((0, _moment2.default)());
	    },
	    setPrev: function setPrev() {
	      var date = (0, _moment2.default)(this.date).subtract(1, 'week');
	      this.setDate(date);
	    },
	    setNext: function setNext() {
	      var date = (0, _moment2.default)(this.date).add(1, 'week');
	      this.setDate(date);
	    },
	    readEvents: function readEvents() {
	      var _this = this;
	
	      var calendarIds = this.users.map(function (user) {
	        return user.user_calendar_id;
	      });
	      if (calendarIds.length === 0) {
	        return;
	      }
	
	      var start = (0, _moment2.default)(this.date).isoWeekday(1).format('YYYY-MM-DD 00:00');
	      var end = (0, _moment2.default)(this.date).isoWeekday(5).endOf('day');
	      _docendo2.default.calendarEvents2(calendarIds, start, end, null, function (data) {
	        _this.events = data.length > 0 ? JSON.parse(data) : [];
	        _this.isEventsLoading = false;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    readUserNorm: function readUserNorm() {
	      var _this2 = this;
	
	      if (!this.schoolYear || !this.schoolId) {
	        return;
	      }
	      this.isLoadingUserNorms = true;
	      this.userNorms = null;
	      _docendo2.default.schoolUserYearsList(this.schoolId, this.schoolYear.id, null, function (success) {
	        _this2.userNorms = success;
	        _this2.isLoadingUserNorms = false;
	      }, function (failure) {
	        console.log('failed!');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readEvents();
	    this.readUserNorm();
	  }
	};

/***/ }),
/* 557 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    isToday: {
	      default: false
	    }
	  },
	  computed: {
	    tooltipArrowLeft: function tooltipArrowLeft() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span><span>←</span></p>';
	    },
	    tooltipArrowRight: function tooltipArrowRight() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span><span>→</span></p>';
	    },
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    }
	  }
	};

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    propOpeningHours: {
	      default: {
	        1: { open: '08:00', close: '22:00' },
	        2: { open: '08:00', close: '16:00' },
	        3: { open: '08:00', close: '16:00' },
	        4: { open: '08:00', close: '16:00' },
	        5: { open: '08:00', close: '16:00' },
	        6: { open: '', close: '' },
	        7: { open: '', close: '' }
	      }
	    }
	  },
	  data: function data() {
	    return {
	      openingHours: {},
	      isSaving: false
	    };
	  },
	
	  watch: {
	    propOpeningHours: function propOpeningHours(val, oldVal) {
	      this.loadOpeningHours();
	      this.$emit('close');
	    }
	  },
	  methods: {
	    deleteDay: function deleteDay(day) {
	      this.openingHours[day]['open'] = '';
	      this.openingHours[day]['close'] = '';
	    },
	    getDayName: function getDayName(day) {
	      return (0, _moment2.default)().isoWeekday(day * 1).format('dddd');
	    },
	    formatTime: function formatTime(day, type) {
	      var time = this.openingHours[day][type];
	      if (time) {
	        this.openingHours[day][type] = (0, _moment2.default)(time, 'HH:mm').format('HH:mm');
	      }
	    },
	    saveOpeningHours: function saveOpeningHours() {
	      this.isSaving = true;
	      var openingHoursJson = this.openingHours;
	      this.$store.dispatch('updateSchoolSettings', { 'openingHours': openingHoursJson });
	    },
	    loadOpeningHours: function loadOpeningHours() {
	      var storedData = this.propOpeningHours;
	      if (storedData) {
	        this.openingHours = storedData;
	      } else {
	        this.openingHours = {
	          1: { open: '08:00', close: '22:00' },
	          2: { open: '08:00', close: '16:00' },
	          3: { open: '08:00', close: '16:00' },
	          4: { open: '08:00', close: '16:00' },
	          5: { open: '08:00', close: '16:00' },
	          6: { open: '', close: '' },
	          7: { open: '', close: '' }
	        };
	      }
	    }
	  },
	  created: function created() {
	    this.loadOpeningHours();
	  }
	};

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DutySchedulePlanCalendar = __webpack_require__(355);
	
	var _DutySchedulePlanCalendar2 = _interopRequireDefault(_DutySchedulePlanCalendar);
	
	var _CopyMultipleCalendarsCopy = __webpack_require__(345);
	
	var _CopyMultipleCalendarsCopy2 = _interopRequireDefault(_CopyMultipleCalendarsCopy);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DutyScheduleNav = __webpack_require__(1506);
	
	var _DutyScheduleNav2 = _interopRequireDefault(_DutyScheduleNav);
	
	var _BottomNav = __webpack_require__(353);
	
	var _BottomNav2 = _interopRequireDefault(_BottomNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { BottomNav: _BottomNav2.default, DutyScheduleNav: _DutyScheduleNav2.default, DDropdown: _DDropdown2.default, CopyMultipleCalendarsCopy: _CopyMultipleCalendarsCopy2.default, DutyScheduleCalendar: _DutySchedulePlanCalendar2.default },
	  props: {
	    date: {
	      default: new Date()
	    },
	    isEventsLoading: {
	      type: Boolean,
	      default: false
	    },
	    events: {
	      type: Array,
	      default: []
	    },
	    calendars: {
	      type: Array,
	      default: []
	    },
	    usersCalIdsHash: {
	      default: {}
	    },
	    eventsInHash: {
	      default: {}
	    },
	    theCreateEventObj: {
	      type: Object,
	      default: null
	    },
	    userNorms: {
	      type: Array,
	      default: []
	    },
	    theNewlyCreatedSubject: {
	      type: Object,
	      default: null
	    },
	    schoolSettings: {
	      type: Object,
	      default: null
	    },
	    isCreateOpeningHours: {
	      type: Boolean,
	      default: false
	    },
	    openingHours: {
	      default: null
	    }
	  },
	  computed: {
	    currentWeek: function currentWeek() {
	      return (0, _moment2.default)(this.date).isoWeek();
	    },
	    days: function days() {
	      return this.createDates();
	    }
	  },
	  methods: {
	    setIsCreateOpeningHours: function setIsCreateOpeningHours(bool) {
	      this.$emit('setIsCreateOpeningHours', bool);
	    },
	    createCalendars: function createCalendars(calendarType) {
	      _eventbus2.default.createCalendarsType = calendarType;
	    },
	    createDates: function createDates() {
	      _moment2.default.locale('da-DK');
	      var days = [];
	      for (var i = 1; i <= 5; i++) {
	        var date = (0, _moment2.default)(this.date).isoWeekday(i);
	        days.push({
	          dateId: date.format('YYYY-MM-DD'),
	          date: date,
	          dateFormatted: date.format('dddd DD. MMM')
	        });
	      }
	      return days;
	    },
	    copyCals: function copyCals(objWeeks) {
	      var selectedCalIds = this.calendars.map(function (calendar) {
	        return calendar.id;
	      });
	      var copyDate = objWeeks.copyDate;
	      var selectedWeeks = objWeeks.selectedWeeks;
	      var isDeleteEvents = objWeeks.isDeleteEvents;
	      _docendo2.default.calendarCopyWeeks(selectedCalIds, copyDate, selectedWeeks, isDeleteEvents, [], ['absence', 'presence', 'activity'], function (data) {
	        _eventbus2.default.toast = { text: 'Kopierer kalendere', success: true };
	      });
	    }
	  }
	};

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DutySchedulePlanCalendarUserDay = __webpack_require__(1510);
	
	var _DutySchedulePlanCalendarUserDay2 = _interopRequireDefault(_DutySchedulePlanCalendarUserDay);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _DutySchedulePlanCalendarDayStats = __webpack_require__(1509);
	
	var _DutySchedulePlanCalendarDayStats2 = _interopRequireDefault(_DutySchedulePlanCalendarDayStats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DutySchedulePlanCalendarDayStats: _DutySchedulePlanCalendarDayStats2.default, ModalConfirmation: _ModalConfirmation2.default, DDropdown: _DDropdown2.default, DutyScheduleCalendarUserDay: _DutySchedulePlanCalendarUserDay2.default },
	  props: {
	    calendar: {
	      type: Object,
	      default: null
	    },
	    date: {
	      default: function _default() {
	        return new Date();
	      }
	    },
	    usersCalIdsHash: {
	      type: Object
	    },
	    days: {
	      type: Array,
	      required: true
	    },
	    colspan: {
	      type: Number,
	      required: false,
	      default: 6 },
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    eventsInHash: {
	      default: {}
	    },
	    theCreateEventObj: {
	      type: Object,
	      default: null
	    },
	    userNorms: {
	      type: Array,
	      default: []
	    },
	    theNewlyCreatedSubject: {
	      type: Object,
	      default: null
	    },
	    schoolSettings: {
	      type: Object,
	      default: null
	    },
	    openingHours: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      subjects: [],
	      isLoadingSubjects: false,
	      subjectsInUserCalIdHash: {},
	      users: [],
	      isCreateSubject: false,
	      theDeleteUser: null,
	      isDeletingUserSubject: false,
	      isLoadingTheUserSubject: false,
	      theUserSubject: null
	    };
	  },
	
	  computed: {
	    schoolSettingsColor: function schoolSettingsColor() {
	      return this.schoolSettings && this.schoolSettings;
	    },
	    usersSorted: function usersSorted() {
	      return this.users.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    usersWithCalc: function usersWithCalc() {
	      var _this = this;
	
	      var users = this.usersSorted.map(function (user) {
	        return (0, _extends3.default)({}, user, {
	          v_events: _this.getEventsForCalendarId(user.user_calendar_id),
	          v_employment: _this.getEmployment(user)
	        });
	      });
	
	      return users;
	    },
	    eventsInDays: function eventsInDays() {
	      var _this2 = this;
	
	      var days = this.days.map(function (day) {
	        return (0, _extends3.default)({}, day, {
	          v_minutes: 0
	        });
	      });
	
	      this.events.forEach(function (event) {
	        event.calendars.forEach(function (calEvent) {
	          if (calEvent.calendar_id === _this2.calendar.id) {
	            var eventDate = (0, _moment2.default)(event.start).format('YYYY-MM-DD');
	            var idx = days.findIndex(function (day) {
	              return day.dateId === eventDate;
	            });
	            if (idx >= 0) {
	              days[idx].v_minutes += calEvent.minutes;
	            }
	          }
	        });
	      });
	      return days.map(function (day) {
	        return (0, _extends3.default)({}, day, {
	          v_formattedTime: Math.floor(day.v_minutes / 60) + 't ' + day.v_minutes % 60 + 'm'
	        });
	      });
	    }
	  },
	  watch: {
	    theNewlyCreatedSubject: function theNewlyCreatedSubject(newSubject) {
	      if (newSubject.calendar_id === this.calendar.id) {
	        this.subjects.push(newSubject);
	        this.matchSubjects();
	      }
	    }
	  },
	  methods: {
	    setTheDeleteUser: function setTheDeleteUser(user) {
	      this.theDeleteUser = user;
	    },
	    createSubject: function createSubject() {
	      this.isCreateSubject = true;
	    },
	    getEmployment: function getEmployment(user) {
	      var userNorm = this.userNorms.find(function (userNorm) {
	        return userNorm.user_id === user.id;
	      });
	      var employmentPerWeek = userNorm && userNorm.norm ? userNorm.norm.find(function (normObj) {
	        return normObj.title === 'Timeansættelse pr. uge';
	      }) : null;
	      return employmentPerWeek ? employmentPerWeek.value : null;
	    },
	    getEventsForCalendarId: function getEventsForCalendarId(calendarId) {
	      var obj = {
	        v_events: [],
	        v_minutes: 0,
	        v_minutesFormatted: ''
	      };
	
	      this.events.forEach(function (event) {
	        event.calendars.forEach(function (calEvent) {
	          if (calEvent.calendar_id === calendarId) {
	            obj.v_events.push(event);
	            obj.v_minutes += calEvent.minutes;
	          }
	        });
	      });
	
	      var hours = Math.floor(obj.v_minutes / 60);
	      var minutes = obj.v_minutes % 60;
	      obj.v_minutesFormatted = hours + 't ' + minutes + 'm';
	
	      return obj;
	    },
	    readSubjects: function readSubjects() {
	      var _this3 = this;
	
	      this.isLoadingSubjects = true;
	      _docendo2.default.sidebar(this.calendar.id, this.date, function (success) {
	        _this3.isLoadingSubjects = false;
	        _this3.subjects = success;
	        _this3.matchSubjects();
	      }, function (failure) {
	        console.log('something went wrong');
	      });
	    },
	    matchSubjects: function matchSubjects() {
	      var _this4 = this;
	
	      this.users = [];
	      this.subjects.forEach(function (subject) {
	        subject.cals.forEach(function (calEvent) {
	          if (calEvent.calendar_type === 'user') {
	            var userCalendarId = calEvent.id;
	            var user = _this4.usersCalIdsHash[userCalendarId];
	            if (user) {
	              _this4.users.push(user);
	              _this4.$set(_this4.subjectsInUserCalIdHash, userCalendarId, subject);
	            }
	          }
	        });
	      });
	    },
	    resetDeleteUser: function resetDeleteUser() {
	      this.theDeleteUser = null;
	      this.isDeletingUserSubject = false;
	      this.theUserSubject = null;
	      this.isLoadingTheUserSubject = false;
	    },
	    readUserSubject: function readUserSubject(user) {
	      var _this5 = this;
	
	      this.isLoadingTheUserSubject = true;
	      var subject = this.subjectsInUserCalIdHash[user.user_calendar_id];
	      var subjectId = subject.id;
	      _docendo2.default.showSubject(subjectId, function (dbSuccess) {
	        if (dbSuccess.id) {
	          _this5.theUserSubject = dbSuccess;
	        } else {
	          window.alert('Personen kan ikke findes');
	          _this5.resetDeleteUser();
	        }
	        _this5.isLoadingTheUserSubject = false;
	      }, function (failure) {
	        console.error('Error showing subject:', failure);
	      });
	    },
	    deleteUserSubject: function deleteUserSubject() {
	      if (!this.theUserSubject) {
	        console.error('No user selected for deletion');
	        return;
	      }
	      this.isDeletingUserSubject = true;
	      var subject = this.theUserSubject;
	
	      if (!subject) {
	        console.error('Subject not found for user_calendar_id:');
	        this.resetDeleteUser();
	        return;
	      }
	      this.deleteSubject(subject);
	    },
	    deleteSubject: function deleteSubject(_deleteSubject) {
	      var _this6 = this;
	
	      var subjectId = _deleteSubject.id;
	      var schoolId = _deleteSubject.school_id;
	      var schoolYearId = _deleteSubject.school_year_id;
	      if (_deleteSubject.can_delete) {
	        _docendo2.default.deleteSubject(subjectId, schoolId, schoolYearId, function (success) {
	          if (success.id) {
	            var idx = _this6.subjects.findIndex(function (subject) {
	              return subject.id === success.id;
	            });
	            _this6.subjects.splice(idx, idx);
	            _this6.matchSubjects();
	            _this6.resetDeleteUser();
	          }
	        }, function (failure) {
	          console.log('totally failed!');
	        });
	      } else {
	        var userCalendarId = this.theDeleteUser.user_calendar_id;
	        var calendarIds = _deleteSubject.calendar_ids.filter(function (calId) {
	          return calId !== userCalendarId;
	        });
	        _docendo2.default.updateSubject(subjectId, _deleteSubject.name, _deleteSubject.color, _deleteSubject.calendar_id, calendarIds, _deleteSubject.default_duration, _deleteSubject.preparation, _deleteSubject.hours, _deleteSubject.subject_type, _deleteSubject.school_id, schoolYearId, _deleteSubject.subject_code, false, false, null, null, null, function (success) {
	          _this6.readSubjects();
	        }, function (failure) {
	          console.log('FAILED!');
	        });
	        this.resetDeleteUser();
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.readSubjects();
	  }
	};

/***/ }),
/* 561 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    hours: {
	      default: 0
	    },
	    openingHours: {
	      default: null
	    }
	  }
	};

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ButtonSpinner = __webpack_require__(1693);
	
	var _ButtonSpinner2 = _interopRequireDefault(_ButtonSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ButtonSpinner: _ButtonSpinner2.default },
	  props: {
	    user: {
	      type: Object
	    },
	    date: {
	      default: function _default() {
	        return new Date();
	      }
	    },
	    eventsInHash: {
	      default: {}
	    },
	    subjectsInUserCalIdHash: {},
	    theCreateEventObj: {
	      type: Object,
	      default: null
	    }
	  },
	  computed: {
	    filteredEvents: function filteredEvents() {
	      var calendarId = this.user.user_calendar_id;
	      var lookUpKey = calendarId + '_' + (0, _moment2.default)(this.date).format('YYYY_MM_DD');
	      return this.eventsInHash[lookUpKey] ? this.eventsInHash[lookUpKey] : [];
	    },
	    isTheActiveDay: function isTheActiveDay() {
	      if (!this.theCreateEventObj) {
	        return false;
	      }
	      return this.theCreateEventObj.user.id === this.user.id && this.theCreateEventObj.date === this.date;
	    }
	  },
	  methods: {
	    setCreateEventOnUser: function setCreateEventOnUser() {
	      var calendarId = this.user.user_calendar_id;
	      var subject = this.subjectsInUserCalIdHash[calendarId];
	      var newEventObj = {
	        user: this.user,
	        date: this.date,
	        subject: subject
	      };
	      this.$emit('createEvent', newEventObj);
	    },
	    editEvent: function editEvent(event) {
	      var editEventObj = {
	        user: this.user,
	        event: event
	      };
	      this.$emit('editEvent', editEventObj);
	    }
	  }
	};

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Modal = __webpack_require__(80);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppModal: _Modal2.default },
	  props: {
	    calendar: {
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      showModal: false,
	      validatorText: '',
	      validatorTextOriginal: this.$t('vue2.editCalendarDelete.validator_name')
	    };
	  },
	
	  computed: {
	    calName: function calName() {
	      return this.calendar ? this.calendar.name : '';
	    },
	    openFromOtherComponent: function openFromOtherComponent() {
	      return _eventbus2.default.editCalendarDeleteModal;
	    }
	  },
	  methods: {
	    validateInput: function validateInput() {
	      return this.validatorText === this.validatorTextOriginal;
	    },
	    setCloseModal: function setCloseModal() {
	      this.validatorText = '';
	      _eventbus2.default.editCalendarDeleteModal = false;
	    },
	    submitDelete: function submitDelete() {
	      var _this = this;
	
	      _docendo2.default.schoolCalendarsDelete(this.calendar.school_id, this.calendar.id, function (success) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.editCalendarDelete.success_text'), 'success': true };
	      }, function (errors) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	      this.setCloseModal();
	      window.location.href = '/calendar';
	    }
	  }
	};

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Modal = __webpack_require__(80);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppModal: _Modal2.default },
	  props: {
	    calendar: {
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      calName: ''
	    };
	  },
	
	  computed: {
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    openFromOtherComponent: function openFromOtherComponent() {
	      return _eventbus2.default.editCalendarNameModal;
	    }
	  },
	  methods: {
	    validateInput: function validateInput() {
	      return this.calName && this.calName.length > 0;
	    },
	    setCloseModal: function setCloseModal() {
	      _eventbus2.default.editCalendarNameModal = false;
	    },
	    submitNewName: function submitNewName() {
	      var _this = this;
	
	      _docendo2.default.schoolCalendarsUpdate(this.calendar.school_id, this.calendar.id, { name: this.calName }, function (succes) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.editCalendarEditName.success_text'), 'success': true };
	        window.location.reload();
	      }, function (errors) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	      this.setCloseModal();
	    }
	  },
	  mounted: function mounted() {
	    this.calName = this.calendar ? this.calendar.name : '';
	  }
	};

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Spinner = __webpack_require__(26);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _core = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Spinner: _Spinner2.default },
	  filters: {
	    showWeek: function showWeek(date) {
	      return (0, _moment2.default)(date).isoWeek();
	    }
	  },
	  props: {
	    bulk: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      cal: null,
	      calType: null,
	      calStartDate: null,
	      calEndDate: null,
	      selectedWeeks: [],
	      isDropdown: false,
	      isDropdownPopperDone: false,
	      componentActiveSchoolYearId: null,
	      event: {
	        'id': 24035310,
	        'calendar_id': 133752,
	        'title': 'Billedkunst',
	        'color': '#ff7f50',
	        'event_time_start': '2020-10-20T06:00:00Z',
	        'event_time_end': '2020-10-20T07:00:00Z'
	      }
	    };
	  },
	
	  computed: {
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    copyEventEvent: function copyEventEvent() {
	      return _eventbus2.default.copyEventEvent;
	    },
	    copyEventsBulk: function copyEventsBulk() {
	      return _eventbus2.default.copyEventsBulk;
	    },
	    theTriggerEvent: function theTriggerEvent() {
	      return this.bulk ? _eventbus2.default.copyEventsBulk : _eventbus2.default.copyEventEvent;
	    },
	    isBulk: function isBulk() {
	      return this.bulk && this.event && Array.isArray(this.event.event_ids);
	    },
	    bulkEventIds: function bulkEventIds() {
	      return this.event && Array.isArray(this.event.event_ids) ? this.event.event_ids : [];
	    },
	    bulkLessonsLabel: function bulkLessonsLabel() {
	      var labels = {
	        da: 'lektioner',
	        nb: 'timer',
	        nn: 'timer',
	        en: 'lessons'
	      };
	      var locale = this.$store && this.$store.getters ? this.$store.getters.locale : 'da';
	      return labels[locale] || labels['da'];
	    },
	    popperAnchorSelector: function popperAnchorSelector() {
	      if (this.event && this.event.v_popper_anchor) {
	        return this.event.v_popper_anchor;
	      }
	      return this.bulk ? '#vue-popper__massehandling_button' : '#vue-popper__copy_event_button';
	    },
	    copyDate: function copyDate() {
	      var startDate = this.event.start ? this.event.start : this.event.event_time_start;
	      return (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	    },
	    sourceWeek: function sourceWeek() {
	      return (0, _moment2.default)(this.copyDate).format('GGGG-WW');
	    },
	    showStartPasteWeek: function showStartPasteWeek() {
	      return (0, _moment2.default)(this.startPasteWeek).isSame(this.calStartDate);
	    },
	    showDateAndTime: function showDateAndTime() {
	      var startDate = this.event.start ? this.event.start : this.event.event_time_start;
	      var endDate = this.event.end ? this.event.end : this.event.event_time_end;
	      return (0, _moment2.default)(startDate).format('dddd, LT') + ' - ' + (0, _moment2.default)(endDate).format('LT');
	    },
	    weeks: function weeks() {
	      var _this = this;
	
	      if (!this.componentActiveSchoolYearId || !this.calType) {
	        return [];
	      }
	      var activeSchoolYear = this.activeSchoolYears[this.activeSchoolYears.findIndex(function (year) {
	        return year.id === _this.componentActiveSchoolYearId;
	      })];
	      if (this.calType === 'klass') {
	        this.calStartDate = activeSchoolYear.student_time_start;
	        this.calEndDate = activeSchoolYear.student_time_end;
	      } else {
	        this.calStartDate = activeSchoolYear.employee_time_start;
	        this.calEndDate = activeSchoolYear.employee_time_end;
	      }
	      var start = (0, _moment2.default)(this.calStartDate).day(this.firstDayOfTheWeek);
	      var end = (0, _moment2.default)(this.calEndDate).endOf('isoweek');
	      var startWeek = (0, _moment2.default)(start).isoWeek();
	      var diff = (0, _moment2.default)(end).diff(start, 'week');
	      var max = startWeek + diff;
	      var weeks = [];
	      for (var i = startWeek; i <= max; i++) {
	        var date = (0, _moment2.default)(start).isoWeek(i).day(this.firstDayOfTheWeek);
	        weeks.push({
	          date: date,
	          serverDate: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	          weekNum: date.isoWeek()
	        });
	      }
	      return weeks;
	    },
	    firstDayOfTheWeek: function firstDayOfTheWeek() {
	      return this.$store.getters.firstDayOfWeek;
	    }
	  },
	  watch: {
	    theTriggerEvent: function theTriggerEvent(val) {
	      if (val) {
	        this.event = val;
	        this.openDropdown();
	      }
	    }
	  },
	  methods: {
	    setInitialActivatedSchoolYear: function setInitialActivatedSchoolYear() {
	      if (this.activeSchoolYear && this.activeSchoolYear.id) {
	        this.componentActiveSchoolYearId = this.activeSchoolYear.id;
	      }
	    },
	    createPopper: function createPopper() {
	      var parentPopper = document.querySelector(this.popperAnchorSelector);
	      var childPopper = this.$refs.copy_event_panel;
	      document.getElementById('djs-content-container').appendChild(childPopper);
	      (0, _core.createPopper)(parentPopper, childPopper, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, 5]
	          }
	        }]
	      });
	    },
	    tooltipDate: function tooltipDate(date) {
	      var start = (0, _moment2.default)(date);
	      var start2 = (0, _moment2.default)(date).format('DD. MMM');
	      var startFormat = start.format('DD');
	      var end = (0, _moment2.default)(date).add(6, 'days');
	      var endFormat = (0, _moment2.default)(date).add(6, 'days').format('DD. MMM YYYY');
	
	      if ((0, _moment2.default)(start).format('MM') === (0, _moment2.default)(end).format('MM')) {
	        return startFormat + ' - ' + endFormat;
	      } else {
	        return start2 + ' - ' + endFormat;
	      }
	    },
	    setSelectedWeek: function setSelectedWeek(week) {
	      if (this.isCopyWeek(week)) {
	        return;
	      }
	      var idx = this.selectedWeeks.indexOf(week.serverDate);
	      if (idx < 0) {
	        this.selectedWeeks.push(week.serverDate);
	      } else {
	        this.selectedWeeks.splice(idx, 1);
	      }
	    },
	    isWeekSelected: function isWeekSelected(week) {
	      var idx = this.selectedWeeks.indexOf(week.serverDate);
	      return idx > -1;
	    },
	    isCopyWeek: function isCopyWeek(week) {
	      return (0, _moment2.default)(week.date).format('GGGG-WW') === (0, _moment2.default)(this.copyDate).format('GGGG-WW');
	    },
	    isNow: function isNow(week) {
	      return (0, _moment2.default)(week.date).format('GGGG-WW') === (0, _moment2.default)().format('GGGG-WW');
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      var schoolId = this.event.school_id ? this.event.school_id : window.SCHOOL.id;
	      var eventIds = this.bulkEventIds.length > 0 ? this.bulkEventIds : [this.event.event_id ? this.event.event_id : this.event.id];
	      _docendo2.default.subjectEventsCreate(schoolId, this.event.calendar_id, this.copyDate, this.selectedWeeks, false, null, null, [], eventIds, function (success) {
	        var wasBulk = _this2.bulk;
	
	        _this2.closeDropdown();
	        if (wasBulk) {
	          _this2.$store.commit('clearSelectedEventIds');
	        }
	        setTimeout(function (_) {
	          var elCal = document.querySelector('.calendar');
	          if (elCal) {
	            elCal.click();
	          }
	        }, 0);
	        _eventbus2.default.toast = { text: _this2.$i18n.t('vue2.copycalendar.noticationMessage'), success: false };
	      }, function (failure) {
	        _this2.closeDropdown();
	        console.log('failure', failure);
	      });
	    },
	    openDropdown: function openDropdown() {
	      var _this3 = this;
	
	      this.setInitialActivatedSchoolYear();
	      this.isDropdown = true;
	      this.getCalendar();
	      this.$nextTick(function (_) {
	        _this3.createPopper();
	        _this3.isDropdownPopperDone = true;
	        document.getElementById('djs-content-container').appendChild(_this3.$refs.d_copy_event_overlay);
	      });
	    },
	    closeDropdown: function closeDropdown() {
	      if (!this.isDropdown) {
	        return;
	      }
	      this.isDropdown = false;
	      this.isDropdownPopperDone = false;
	      if (this.bulk) {
	        _eventbus2.default.copyEventsBulk = null;
	      } else {
	        _eventbus2.default.copyEventEvent = null;
	      }
	      this.removeAllSelectedWeeks();
	      this.calType = null;
	      this.calStartDate = null;
	      if (this.$refs.d_copy_event_overlay) {
	        this.$refs.d_copy_event_overlay.remove();
	      }
	
	      if (this.$refs.copy_event_panel) {
	        this.$refs.copy_event_panel.remove();
	      }
	    },
	    selectWeek: function selectWeek(week) {
	      if (this.isCopyWeek(week)) {
	        return;
	      }
	      var idx = this.selectedWeeks.indexOf(week.serverDate);
	      if (idx < 0) {
	        this.selectedWeeks.push(week.serverDate);
	      }
	    },
	    selectEvenWeeks: function selectEvenWeeks() {
	      var _this4 = this;
	
	      this.weeks.forEach(function (week) {
	        if ((0, _moment2.default)(week.date).isSameOrAfter(_this4.copyDate)) {
	          if (_this4.isEven(week.weekNum)) {
	            _this4.selectWeek(week);
	          }
	        }
	      });
	    },
	    selectOddWeeks: function selectOddWeeks() {
	      var _this5 = this;
	
	      this.weeks.forEach(function (week) {
	        if ((0, _moment2.default)(week.date).isSameOrAfter(_this5.copyDate)) {
	          if (_this5.isOdd(week.weekNum)) {
	            _this5.selectWeek(week);
	          }
	        }
	      });
	    },
	    isEven: function isEven(n) {
	      return (/^-?\d*[02468]$/.test(n)
	      );
	    },
	    isOdd: function isOdd(n) {
	      return (/^-?\d*[13579]$/.test(n)
	      );
	    },
	    addAllWeeksOnward: function addAllWeeksOnward() {
	      var _this6 = this;
	
	      this.weeks.forEach(function (week) {
	        if ((0, _moment2.default)(week.date).isSameOrAfter(_this6.copyDate)) {
	          _this6.selectWeek(week);
	        }
	      });
	    },
	    removeAllSelectedWeeks: function removeAllSelectedWeeks() {
	      this.selectedWeeks = [];
	    },
	    getCalendar: function getCalendar() {
	      var _this7 = this;
	
	      _docendo2.default.calendar(this.event.calendar_id, function (data) {
	        _this7.cal = data;
	        _this7.calType = data.type;
	        _this7.setCalStartAndEndDate();
	      }, function (failure) {
	        console.log('failed to get calendar', failure);
	      });
	    },
	    setCalStartAndEndDate: function setCalStartAndEndDate() {
	      var _this8 = this;
	
	      var highestIdx = 0;
	      this.activeSchoolYears.forEach(function (year, idx) {
	        if (idx > highestIdx) {
	          highestIdx = idx;
	        }
	        var startDate = void 0;
	        var endDate = void 0;
	        if (_this8.calType === 'klass') {
	          startDate = (0, _moment2.default)(year.student_time_start).startOf('isoweek');
	          endDate = (0, _moment2.default)(year.student_time_end).endOf('isoweek');
	        } else {
	          startDate = (0, _moment2.default)(year.employee_time_start).startOf('isoweek');
	          endDate = (0, _moment2.default)(year.employee_time_end).endOf('isoweek');
	        }
	        if ((0, _moment2.default)(_this8.copyDate).isSame(startDate) || (0, _moment2.default)(_this8.copyDate).isBetween(startDate, endDate)) {
	          _this8.componentActiveSchoolYearId = _this8.activeSchoolYears[idx].id;
	        }
	      });
	      if (!this.componentActiveSchoolYearId) {
	        this.componentActiveSchoolYearId = this.activeSchoolYears[highestIdx].id;
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.bulk) {
	      _eventbus2.default.copyEventsBulk = null;
	    } else {
	      _eventbus2.default.copyEventEvent = null;
	    }
	    if (this.$refs.copy_event_panel) {
	      this.$refs.copy_event_panel.remove();
	    }
	    if (this.$refs.d_copy_event_overlay) {
	      this.$refs.d_copy_event_overlay.remove();
	    }
	  }
	};

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    event: {
	      type: Object,
	      default: function _default() {
	        return {
	          'id': 24035310,
	          'calendar_id': 133752,
	          'title': 'Billedkunst',
	          'color': '#ff7f50',
	          'event_time_start': '2020-10-20T06:00:00Z',
	          'event_time_end': '2020-10-20T07:00:00Z'
	        };
	      }
	    }
	  },
	  methods: {
	    openCopyEventDropdown: function openCopyEventDropdown() {
	      _eventbus2.default.copyEventEvent = this.event;
	    }
	  }
	};

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    cancel_event: 'Aflys timen',
	    uncancel_event: 'Fortryd aflysning',
	    confirm_cancel_title: 'Er du sikker på, at du vil aflyse timen?',
	    confirm_cancel_text: 'Timen bliver ikke slettet, men vil blive markeret som aflyst med overstregede tekster.',
	    confirm_uncancel_title: 'Er du sikker på, at du vil fortryde aflysningen?',
	    confirm_uncancel_text: 'Timen vil blive gendannet, og de overstregede tekster fjernes.'
	  },
	  nb: {
	    cancel_event: 'Avlys timen',
	    uncancel_event: 'Angre avlysning',
	    confirm_cancel_title: 'Er du sikker på at du vil avlyse timen?',
	    confirm_cancel_text: 'Timen blir ikke slettet, men vil bli markert som avlyst med gjennomstreket tekst.',
	    confirm_uncancel_title: 'Er du sikker på at du vil angre avlysningen?',
	    confirm_uncancel_text: 'Timen vil bli gjenopprettet, og den gjennomstrekede teksten fjernes.'
	  },
	  en: {
	    cancel_event: 'Cancel lesson',
	    uncancel_event: 'Undo cancellation',
	    confirm_cancel_title: 'Are you sure you want to cancel the lesson?',
	    confirm_cancel_text: 'The lesson will not be deleted but will be marked as canceled with strikethrough text.',
	    confirm_uncancel_title: 'Are you sure you want to undo the cancellation?',
	    confirm_uncancel_text: 'The lesson will be restored, and the strikethrough text will be removed.'
	  }
	};
	
	exports.default = {
	  components: { ModalConfirmation: _ModalConfirmation2.default },
	  props: {
	    event: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    eventIdProp: {
	      default: 'event_id'
	    }
	  },
	  data: function data() {
	    return {
	      isCancellingLesson: false
	    };
	  },
	
	  computed: {
	    isCanceled: function isCanceled() {
	      return this.event.canceled;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      var locale = this.locale === 'nn' || this.locale === 'no' ? 'nb' : this.locale;
	      return I18N[locale] || I18N.en;
	    }
	  },
	  methods: {
	    onConfirmCancelLesson: function onConfirmCancelLesson() {
	      this.handleConfirmCancelLesson();
	    },
	    handleConfirmCancelLesson: function handleConfirmCancelLesson() {
	      var _this = this;
	
	      this.isCancellingLesson = true;
	      var updatedLesson = {
	        school_id: this.event.school_id,
	        updates: [{ event_id: this.event[this.eventIdProp], canceled: !this.isCanceled }]
	      };
	      _docendo2.default.updateEvents(updatedLesson.school_id, updatedLesson.updates, function (success) {
	        _this.isCancellingLesson = false;
	        _this.$emit('updated');
	      }, function (failure) {
	        console.log('failed');
	      });
	    }
	  }
	};

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    delete: 'Slet',
	    confirm_delete_title: 'Er du sikker på, at du vil slette denne lektion?',
	    confirm_delete_text: 'Lektionen slettes. Aflyste lektioner i perioden vil blive gendannet.',
	    lessons_will_be_restored: 'Følgende lektioner vil blive gendannet',
	    no_lessons_to_restore: 'Der er ingen lektioner at gendanne i perioden'
	  },
	  nb: {
	    delete: 'Slett',
	    confirm_delete_title: 'Er du sikker på at du vil slette denne leksjonen?',
	    confirm_delete_text: 'Leksjonen slettes. Avlyste leksjoner i perioden vil bli gjenopprettet.',
	    lessons_will_be_restored: 'Følgende leksjoner vil bli gjenopprettet',
	    no_lessons_to_restore: 'Det er ingen leksjoner å gjenopprette i perioden'
	  },
	  en: {
	    delete: 'Delete',
	    confirm_delete_title: 'Are you sure you want to delete this lesson?',
	    confirm_delete_text: 'The lesson will be deleted. Canceled lessons in the period will be restored.',
	    lessons_will_be_restored: 'The following lessons will be restored',
	    no_lessons_to_restore: 'There are no lessons to restore in the period'
	  }
	};
	
	exports.default = {
	  components: { ModalConfirmation: _ModalConfirmation2.default },
	  props: {
	    event: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    eventIdProp: {
	      default: 'event_id'
	    },
	    appendToBody: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isSubmitting: false,
	      klassEvents: []
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      var locale = this.locale === 'nn' || this.locale === 'no' ? 'nb' : this.locale;
	      return I18N[locale] || I18N.en;
	    },
	    selfEventId: function selfEventId() {
	      if (!this.event) return null;
	      if (this.event[this.eventIdProp] != null) return this.event[this.eventIdProp];
	      return this.event.event_id != null ? this.event.event_id : this.event.id;
	    },
	    eventCalendars: function eventCalendars() {
	      if (!this.event) return [];
	      if (Array.isArray(this.event.calendars) && this.event.calendars.length > 0) {
	        return this.event.calendars;
	      }
	      if (Array.isArray(this.event.calendar_events)) {
	        return this.event.calendar_events;
	      }
	      return [];
	    },
	    uncancelCandidates: function uncancelCandidates() {
	      if (!Array.isArray(this.klassEvents)) return [];
	      var selfId = this.selfEventId;
	      return this.klassEvents.filter(function (ev) {
	        var isCanceled = ev && ev.canceled === true;
	        var notAway = ev && ev.away !== true;
	        var notSelf = !selfId || ev.event_id !== selfId && ev.id !== selfId;
	        return isCanceled && notAway && notSelf;
	      });
	    },
	    uncancelGroups: function uncancelGroups() {
	      return this.groupByClass(this.uncancelCandidates);
	    }
	  },
	  methods: {
	    groupByClass: function groupByClass(events) {
	      if (!Array.isArray(events)) return [];
	      var bucket = {};
	      events.forEach(function (ev) {
	        var calendars = (ev.calendars || []).filter(function (c) {
	          return c && c.calendar_type === 'klass';
	        });
	        if (calendars.length === 0) {
	          var key = 'Uden klasse';
	          if (!bucket[key]) bucket[key] = [];
	          bucket[key].push(ev);
	        } else {
	          calendars.forEach(function (c) {
	            var key = c && c.name ? c.name : 'Uden klasse';
	            if (!bucket[key]) bucket[key] = [];
	            bucket[key].push(ev);
	          });
	        }
	      });
	      return (0, _keys2.default)(bucket).sort(function (a, b) {
	        return a.localeCompare(b);
	      }).map(function (name) {
	        var list = bucket[name].slice().sort(function (a, b) {
	          return (0, _moment2.default)(a.start).valueOf() - (0, _moment2.default)(b.start).valueOf();
	        });
	        return { name: name, events: list };
	      });
	    },
	    humanTime: function humanTime(startIso, endIso) {
	      var s = (0, _moment2.default)(startIso);
	      var e = (0, _moment2.default)(endIso);
	      return s.format('LT') + ' - ' + e.format('LT');
	    },
	    onConfirmDelete: function onConfirmDelete() {
	      var _this = this;
	
	      this.isSubmitting = true;
	      this.restoreCanceledEvents(function () {
	        _this.deleteEvent(function (success) {
	          _this.isSubmitting = false;
	          _this.$emit('deleted', success);
	          _this.$emit('close');
	        });
	      });
	    },
	    restoreCanceledEvents: function restoreCanceledEvents(callback) {
	      if (this.uncancelCandidates.length === 0) {
	        callback();
	        return;
	      }
	      var schoolId = this.event.school_id;
	      var updates = this.uncancelCandidates.map(function (ev) {
	        return { event_id: ev.event_id || ev.id, canceled: false };
	      });
	      _docendo2.default.updateEvents(schoolId, updates, function () {
	        callback();
	      }, function () {
	        console.log('failed to restore canceled events');
	        callback();
	      });
	    },
	    deleteEvent: function deleteEvent(callback) {
	      var _this2 = this;
	
	      var schoolId = this.event.school_id;
	      var eventId = this.selfEventId;
	      _docendo2.default.deleteEvent(schoolId, eventId, function (success) {
	        callback(success);
	      }, function (failure) {
	        _this2.isSubmitting = false;
	        console.log('failed to delete event', failure);
	      });
	    },
	    readKlassEvents: function readKlassEvents() {
	      var _this3 = this;
	
	      var dbEventStart = (0, _moment2.default)(this.event.start).format('YYYY-MM-DD HH:mm');
	      var dbEventEnd = (0, _moment2.default)(this.event.end).format('YYYY-MM-DD HH:mm');
	
	      var calendarIds = this.eventCalendars.filter(function (calendar) {
	        return calendar.calendar_type === 'klass';
	      }).map(function (calendar) {
	        return calendar.calendar_id;
	      });
	
	      if (calendarIds.length === 0) {
	        this.klassEvents = [];
	        return;
	      }
	
	      _docendo2.default.calendarEvents2(calendarIds, dbEventStart, dbEventEnd, null, function (success) {
	        _this3.klassEvents = success && success.length > 0 ? JSON.parse(success) : [];
	      }, function (failure) {
	        console.log('Error fetching class events', failure);
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readKlassEvents();
	  }
	};

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function eventKlassIds(ev) {
	  var calendars = ev && (ev.calendars || ev.calendar_events) || [];
	  return calendars.filter(function (c) {
	    return c && c.calendar_type === 'klass';
	  }).map(function (c) {
	    return c.calendar_id;
	  });
	}
	
	function eventHasOtherKlasses(ev, tripKlassIds) {
	  var klassIds = eventKlassIds(ev);
	  if (klassIds.length === 0) return false;
	  var tripSet = tripKlassIds || [];
	  return klassIds.some(function (id) {
	    return tripSet.indexOf(id) === -1;
	  });
	}
	
	var I18N = {
	  da: {
	    mark_as_away: 'Markér som ude af huset',
	    unmark_as_away: 'Fortryd markering som ude af huset',
	    confirm_away_title: 'Er du sikker på, at du vil markere lektionen som ude af huset?',
	    confirm_away_text: 'Lektionen vil blive markeret som værende uden for skolens område. Og personale på lektionen vil fremgå i vikardækningen som fraværende.',
	    confirm_unaway_text: 'Lektionen vil ikke længere fremgå som ude af huset. Og personale vil ikke længere fremgå i vikardækningen som fraværende.',
	    confirm_unaway_title: 'Er du sikker på, at du vil fortryde markeringen som ude af huset?',
	    lessons_will_be_cancelled: 'Følgende lektioner vil blive aflyst',
	    lessons_will_be_restored: 'Følgende lektioner vil blive gendannet',
	    no_lessons_to_cancel: 'Der er ingen lektioner at aflyse i perioden',
	    no_lessons_to_restore: 'Der er ingen lektioner at gendanne i perioden',
	    class_header: 'Klasse',
	    lesson_header: 'Lektion',
	    time_header: 'Tid'
	  },
	  nb: {
	    mark_as_away: 'Marker som utenfor skolen',
	    unmark_as_away: 'Angre markering som utenfor skolen',
	    confirm_away_title: 'Er du sikker på at du vil markere timen som utenfor skolen?',
	    confirm_away_text: 'Timen vil bli markert som utenfor skolens område. Personalet på timen vil vises i vikarhåndteringen som fraværende.',
	    confirm_unaway_title: 'Er du sikker på at du vil angre markeringen som utenfor skolen?',
	    confirm_unaway_text: 'Timen vil ikke lenger vises som utenfor skolen. Personalet vil ikke lenger vises i vikarhåndteringen som fraværende.',
	    lessons_will_be_cancelled: 'Følgende timer vil bli avlyst',
	    lessons_will_be_restored: 'Følgende timer vil bli gjenopprettet',
	    no_lessons_to_cancel: 'Det er ingen timer å avlyse i perioden',
	    no_lessons_to_restore: 'Det er ingen timer å gjenopprette i perioden',
	    class_header: 'Klasse',
	    lesson_header: 'Time',
	    time_header: 'Tid'
	  },
	  en: {
	    mark_as_away: 'Mark as out of school',
	    unmark_as_away: 'Undo out of school marking',
	    confirm_away_title: 'Are you sure you want to mark the event as out of school?',
	    confirm_away_text: 'The event will be marked as taking place outside the school premises. And staff in the event will appear in the substitute management as absent.',
	    confirm_unaway_text: 'The event will no longer be shown as taking place outside the school. And staff will no longer appear in the substitute management as absent.',
	    confirm_unaway_title: 'Are you sure you want to undo the out of school marking?',
	    lessons_will_be_cancelled: 'The following lessons will be canceled',
	    lessons_will_be_restored: 'The following lessons will be restored',
	    no_lessons_to_cancel: 'There are no lessons to cancel in the period',
	    no_lessons_to_restore: 'There are no lessons to restore in the period',
	    class_header: 'Class',
	    lesson_header: 'Lesson',
	    time_header: 'Time'
	  }
	};
	
	exports.default = {
	  components: { ModalConfirmation: _ModalConfirmation2.default },
	  props: {
	    event: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    eventIdProp: {
	      default: 'event_id'
	    }
	  },
	  data: function data() {
	    return {
	      isSubmitting: false,
	      klassEvents: [],
	      isLoadingKlassLesson: false,
	      selectedCancelIds: []
	    };
	  },
	
	  watch: {
	    canceledCandidates: {
	      immediate: true,
	      handler: function handler(candidates) {
	        var tripKlassIds = this.tripKlassIds;
	
	        this.selectedCancelIds = candidates.filter(function (ev) {
	          return !eventHasOtherKlasses(ev, tripKlassIds);
	        }).map(function (ev) {
	          return ev.event_id;
	        });
	      }
	    }
	  },
	  computed: {
	    isAway: function isAway() {
	      return this.event && this.event.away === true;
	    },
	    selfEventId: function selfEventId() {
	      if (!this.event) return null;
	      if (this.event[this.eventIdProp] != null) return this.event[this.eventIdProp];
	      return this.event.event_id != null ? this.event.event_id : this.event.id;
	    },
	    eventCalendars: function eventCalendars() {
	      if (!this.event) return [];
	      if (Array.isArray(this.event.calendars) && this.event.calendars.length > 0) {
	        return this.event.calendars;
	      }
	      if (Array.isArray(this.event.calendar_events)) {
	        return this.event.calendar_events;
	      }
	      return [];
	    },
	    tripKlassIds: function tripKlassIds() {
	      return this.eventCalendars.filter(function (calendar) {
	        return calendar && calendar.calendar_type === 'klass';
	      }).map(function (calendar) {
	        return calendar.calendar_id;
	      });
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      var locale = this.locale === 'nn' || this.locale === 'no' ? 'nb' : this.locale;
	      return I18N[locale] || I18N.en;
	    },
	    canceledCandidates: function canceledCandidates() {
	      if (!Array.isArray(this.klassEvents)) return [];
	      var selfId = this.selfEventId;
	      return this.klassEvents.filter(function (ev) {
	        var notAlreadyCanceled = ev && ev.canceled !== true;
	        var notAlreadyAway = ev && ev.away !== true;
	        var notSelf = !selfId || ev.event_id !== selfId && ev.id !== selfId;
	        return notAlreadyCanceled && notAlreadyAway && notSelf;
	      });
	    },
	    uncancelCandidates: function uncancelCandidates() {
	      if (!Array.isArray(this.klassEvents)) return [];
	      var selfId = this.selfEventId;
	      return this.klassEvents.filter(function (ev) {
	        var isCanceled = ev && ev.canceled === true;
	
	        var notAway = ev && ev.away !== true;
	        var notSelf = !selfId || ev.event_id !== selfId && ev.id !== selfId;
	        return isCanceled && notAway && notSelf;
	      });
	    },
	    canceledRows: function canceledRows() {
	      var seen = {};
	      var rows = [];
	      this.canceledCandidates.forEach(function (ev) {
	        if (seen[ev.event_id]) return;
	        seen[ev.event_id] = true;
	        var klassNames = (ev.calendars || []).filter(function (c) {
	          return c && c.calendar_type === 'klass';
	        }).map(function (c) {
	          return c.name;
	        }).sort(function (a, b) {
	          return a.localeCompare(b);
	        });
	        rows.push({
	          event_id: ev.event_id,
	          title: ev.title,
	          start: ev.start,
	          end: ev.end,
	          klassNames: klassNames.length > 0 ? klassNames.join(', ') : 'Uden klasse'
	        });
	      });
	      rows.sort(function (a, b) {
	        return (0, _moment2.default)(a.start).valueOf() - (0, _moment2.default)(b.start).valueOf();
	      });
	      return rows;
	    },
	    uncancelGroups: function uncancelGroups() {
	      return this.groupByClass(this.uncancelCandidates);
	    },
	    allCancelSelected: function allCancelSelected() {
	      return this.canceledCandidates.length > 0 && this.selectedCancelIds.length === this.canceledCandidates.length;
	    }
	  },
	  methods: {
	    toggleAllCancel: function toggleAllCancel() {
	      if (this.allCancelSelected) {
	        this.selectedCancelIds = [];
	      } else {
	        this.selectedCancelIds = this.canceledCandidates.map(function (ev) {
	          return ev.event_id;
	        });
	      }
	    },
	    groupByClass: function groupByClass(events) {
	      if (!Array.isArray(events)) return [];
	      var bucket = {};
	      events.forEach(function (ev) {
	        var calendars = (ev.calendars || []).filter(function (c) {
	          return c && c.calendar_type === 'klass';
	        });
	        if (calendars.length === 0) {
	          var key = 'Uden klasse';
	          if (!bucket[key]) bucket[key] = [];
	          bucket[key].push(ev);
	        } else {
	          calendars.forEach(function (c) {
	            var key = c && c.name ? c.name : 'Uden klasse';
	            if (!bucket[key]) bucket[key] = [];
	            bucket[key].push(ev);
	          });
	        }
	      });
	
	      return (0, _keys2.default)(bucket).sort(function (a, b) {
	        return a.localeCompare(b);
	      }).map(function (name) {
	        var list = bucket[name].slice().sort(function (a, b) {
	          return (0, _moment2.default)(a.start).valueOf() - (0, _moment2.default)(b.start).valueOf();
	        });
	        return { name: name, events: list };
	      });
	    },
	    humanTime: function humanTime(startIso, endIso) {
	      var s = (0, _moment2.default)(startIso);
	      var e = (0, _moment2.default)(endIso);
	      return s.format('LT') + ' - ' + e.format('LT');
	    },
	    onConfirmAwayStatus: function onConfirmAwayStatus() {
	      this.handleConfirmAwayStatus();
	    },
	    handleConfirmAwayStatus: function handleConfirmAwayStatus() {
	      var _this = this;
	
	      this.isSubmitting = true;
	
	      var willSetAwayTo = !this.isAway;
	      var updatedAway = {
	        school_id: this.event.school_id,
	        updates: [{ event_id: this.event[this.eventIdProp], away: willSetAwayTo }]
	      };
	
	      _docendo2.default.updateEvents(updatedAway.school_id, updatedAway.updates, function (success) {
	        if (willSetAwayTo) {
	          var self = _this;
	          var selected = _this.canceledCandidates.filter(function (ev) {
	            return self.selectedCancelIds.indexOf(ev.event_id) !== -1;
	          });
	          if (selected.length > 0) {
	            var updates = selected.map(function (ev) {
	              return { event_id: ev.event_id, canceled: true };
	            });
	            _docendo2.default.updateEvents(_this.event.school_id, updates, function (s2) {
	              _this.isSubmitting = false;
	              _this.$emit('updated');
	            }, function (f2) {
	              _this.isSubmitting = false;
	              console.log('failed to bulk cancel');
	              _this.$emit('updated');
	            });
	          } else {
	            _this.isSubmitting = false;
	            _this.$emit('updated');
	            _this.$store.dispatch('trackEvent', 'calendar_event_away');
	          }
	        } else {
	          if (_this.uncancelCandidates.length > 0) {
	            var _updates = _this.uncancelCandidates.map(function (ev) {
	              return { event_id: ev.event_id, canceled: false };
	            });
	            _docendo2.default.updateEvents(_this.event.school_id, _updates, function (s3) {
	              _this.isSubmitting = false;
	              _this.$emit('updated');
	            }, function (f3) {
	              _this.isSubmitting = false;
	              console.log('failed to bulk uncancel');
	              _this.$emit('updated');
	            });
	          } else {
	            _this.isSubmitting = false;
	            _this.$emit('updated');
	            _this.$store.dispatch('trackEvent', 'calendar_event_awayFalse');
	          }
	        }
	      }, function (failure) {
	        _this.isSubmitting = false;
	        console.log('failed to toggle away');
	      });
	    },
	    readKlassEvents: function readKlassEvents() {
	      var _this2 = this;
	
	      this.isLoadingKlassLesson = true;
	      var dbEventStart = (0, _moment2.default)(this.event.start).format('YYYY-MM-DD HH:mm');
	      var dbEventEnd = (0, _moment2.default)(this.event.end).format('YYYY-MM-DD HH:mm');
	
	      var calendarIds = this.eventCalendars.filter(function (calendar) {
	        return calendar.calendar_type === 'klass';
	      }).map(function (calendar) {
	        return calendar.calendar_id;
	      });
	
	      if (calendarIds.length === 0) {
	        this.klassEvents = [];
	        this.isLoadingKlassLesson = false;
	        return;
	      }
	
	      _docendo2.default.calendarEvents2(calendarIds, dbEventStart, dbEventEnd, null, function (success) {
	        _this2.klassEvents = success && success.length > 0 ? JSON.parse(success) : [];
	        _this2.isLoadingKlassLesson = false;
	      }, function (failure) {
	        _this2.showToast('Error fetching class events', false);
	        _this2.isLoadingKlassLesson = false;
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readKlassEvents();
	  }
	};

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DCalendarShowEvent = __webpack_require__(81);
	
	var _DCalendarShowEvent2 = _interopRequireDefault(_DCalendarShowEvent);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, DCalendarShowEvent: _DCalendarShowEvent2.default },
	  data: function data() {
	    return {
	      calendarId: null,
	      eventId: null,
	      events: [],
	      isEventsLoading: false
	    };
	  },
	
	  computed: {
	    event: function event() {
	      var _this = this;
	
	      var idx = this.events.findIndex(function (event) {
	        return event.event_id === _this.eventId;
	      });
	      return idx > -1 ? this.events[idx] : null;
	    }
	  },
	  methods: {
	    onEventUpdated: function onEventUpdated() {
	      var customEvent = new window.CustomEvent('UpdateCalendarEvents', { bubbles: true, cancelable: true });
	      window.document.dispatchEvent(customEvent);
	    },
	    onClose: function onClose() {
	      this.eventId = null;
	    },
	    readEvents: function readEvents(event) {
	      var _this2 = this;
	
	      this.calendarId = event.calendar_id;
	      this.eventId = event.event_id;
	      var obj = {
	        calIds: [this.calendarId],
	        start: (0, _moment2.default)(event.start).format('YYYY-MM-DD 00:00'),
	        end: (0, _moment2.default)(event.end).endOf('day')
	      };
	      this.isEventsLoading = true;
	      _docendo2.default.calendarEvents2(obj.calIds, obj.start, obj.end, null, function (data) {
	        console.log({ data: data });
	        _this2.isEventsLoading = false;
	        _this2.events = data.length > 0 ? JSON.parse(data) : [];
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    eventHandler: function eventHandler(e) {
	      var event = e.detail['calEvent'];
	      this.readEvents(event);
	    }
	  },
	  mounted: function mounted() {
	    window.removeEventListener('fullcal_event_click_for_vue', this.eventHandler);
	    window.addEventListener('fullcal_event_click_for_vue', this.eventHandler);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('fullcal_event_click_for_vue', this.eventHandler);
	  }
	};

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(69);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _i18n = {
	  da: {
	    delete_events_onward: 'Slet lektionen fremadrettet',
	    are_you_sure: 'Er du sikker?',
	    do_you_want_to_delete_this_and_all_in_same_timeslot: 'Vil du gerne slette denne lektion, og alle der ligger på samme ugedag og i samme tidsrum fremadrettet?',
	    cancel: 'Annuller'
	  },
	  en: {
	    delete_events_onward: 'Delete this and on same timeslot forward',
	    are_you_sure: 'Are you sure?',
	    do_you_want_to_delete_this_and_all_in_same_timeslot: 'Would you like to delete this lesson and all that lie on the same day of the week and in the same time period going forward?',
	    cancel: 'Cancel'
	  },
	  nb: {
	    delete_events_onward: 'Slett denne timen nå og fremover',
	    are_you_sure: 'Er du sikker?',
	    do_you_want_to_delete_this_and_all_in_same_timeslot: 'Vil du slette denne timen og alle tilsvarende planlagte timer i dette faget og tidsrommet fremover i tid?',
	    cancel: 'Avbryt'
	  }
	};
	exports.default = {
	  components: { Modal: _Modal2.default, DDropdown: _DDropdown2.default },
	  props: {
	    subjectId: {
	      default: '262937'
	    },
	    eventId: {
	      default: '24035264'
	    },
	    isInDCalendar: {
	      type: Boolean,
	      default: false
	    },
	    event: {
	      type: Object,
	      default: function _default() {
	        return null;
	      }
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store ? this.$store.getters.locale : window.USER.language;
	    },
	    schoolId: function schoolId() {
	      return this.$store ? this.$store.getters.schoolId : window.SCHOOL.id;
	    },
	    i18n: function i18n() {
	      return _i18n;
	    },
	    bgColor: function bgColor() {
	      return this.event && this.event.color ? this.event.color : '#989898';
	    }
	  },
	  data: function data() {
	    return {
	      isReadyForModal: false,
	      isModal: false
	    };
	  },
	
	  methods: {
	    closeModal: function closeModal() {
	      this.isReadyForModal = true;
	      this.isModal = false;
	      this.$emit('close');
	    },
	    setDelete: function setDelete() {
	      var _this = this;
	
	      this.isReadyForModal = true;
	      this.$nextTick(function (_) {
	        document.getElementById('djs-content-container').appendChild(_this.$refs.d_modal_delete_event);
	        _this.isModal = true;
	      });
	    },
	    deleteEvents: function deleteEvents() {
	      var _this2 = this;
	
	      var schoolId = this.schoolId;
	      var eventId = this.eventId;
	      if (this.event) {
	        schoolId = this.event.school_id;
	        eventId = this.event.event_id;
	      }
	      _docendo2.default.eventsDeleteThisAndFollowing(schoolId, eventId, function (success) {
	        document.querySelector('body').classList.remove('no-scroll');
	        var elCal = document.querySelector('.calendar');
	        if (elCal) {
	          elCal.click();
	        }
	        _this2.$emit('submit');
	        _this2.closeModal();
	      }, function (failure) {
	        console.log('something went wront');
	      });
	    }
	  },
	  mounted: function mounted() {
	    if (this.isInDCalendar) {
	      this.setDelete();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$refs.d_modal_delete_event) {
	      this.$refs.d_modal_delete_event.remove();
	    }
	  }
	};

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    prevWeek: 'Ugen før',
	    currentWeek: 'Samme uge',
	    nextWeek: 'En uge frem',
	    nextNextWeek: 'To uger frem'
	  },
	  nb: {
	    prevWeek: 'Uken før',
	    currentWeek: 'Samme uke',
	    nextWeek: 'Neste uke',
	    nextNextWeek: 'Om to uker'
	  },
	  en: {
	    prevWeek: 'Previous week',
	    currentWeek: 'Same week',
	    nextWeek: 'Next week',
	    nextNextWeek: 'In two weeks'
	  }
	};
	exports.default = {
	  components: { Tabs: _Tabs2.default, Loader: _Loader2.default },
	  props: {
	    type: {
	      default: 'swap'
	    },
	    propEvent: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      isSubmittingSubjectId: null,
	      isSubmittingEventId: null,
	      events: [],
	      subjects: [],
	      selectedTab: 'currentWeek'
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    tabs: function tabs() {
	      return [{ id: 'prevWeek', title: this.i18n.prevWeek }, { id: 'currentWeek', title: this.i18n.currentWeek }, { id: 'nextWeek', title: this.i18n.nextWeek }, { id: 'nextNextWeek', title: this.i18n.nextNextWeek }];
	    },
	    sortedEvents: function sortedEvents() {
	      return this.events.slice().sort(function (a, b) {
	        return (0, _moment2.default)(a.event_time_start).unix() - (0, _moment2.default)(b.event_time_start).unix();
	      });
	    },
	    weekRange: function weekRange() {
	      var base = (0, _moment2.default)(this.propEvent.start);
	      switch (this.selectedTab) {
	        case 'prevWeek':
	          return {
	            start: base.clone().startOf('isoWeek').subtract(1, 'week'),
	            end: base.clone().endOf('isoWeek').subtract(1, 'week')
	          };
	        case 'nextWeek':
	          return {
	            start: base.clone().startOf('isoWeek').add(1, 'week'),
	            end: base.clone().endOf('isoWeek').add(1, 'week')
	          };
	        case 'nextNextWeek':
	          return {
	            start: base.clone().startOf('isoWeek').add(2, 'weeks'),
	            end: base.clone().endOf('isoWeek').add(2, 'weeks')
	          };
	        case 'currentWeek':
	        default:
	          return {
	            start: base.clone().startOf('isoWeek'),
	            end: base.clone().endOf('isoWeek')
	          };
	      }
	    },
	    filteredEvents: function filteredEvents() {
	      var _weekRange = this.weekRange,
	          start = _weekRange.start,
	          end = _weekRange.end;
	
	      return this.sortedEvents.filter(function (ev) {
	        var s = (0, _moment2.default)(ev.event_time_start);
	        return s.isBetween(start, end, undefined, '[]');
	      });
	    },
	    filteredEventsVProps: function filteredEventsVProps() {
	      var _this = this;
	
	      return this.filteredEvents.map(function (event) {
	        return (0, _extends3.default)({}, event, {
	          vTitle: event.title,
	          vTeachers: _this.getTeachers(event),
	          vDateAndTime: _this.getDateAndTime(event)
	        });
	      });
	    },
	    subjectsVProps: function subjectsVProps() {
	      return this.subjects.filter(function (subject) {
	        return subject.master_type !== 'unknown';
	      }).map(function (subject) {
	        return (0, _extends3.default)({}, subject, {
	          vTitle: subject.name
	        });
	      });
	    },
	    schoolId: function schoolId() {
	      return this.propEvent.school_id;
	    },
	    eventId: function eventId() {
	      return this.propEvent.event_id;
	    }
	  },
	  watch: {
	    type: function type() {
	      this.readPossibilities();
	    }
	  },
	  methods: {
	    getTeachers: function getTeachers(event) {
	      return 'test';
	    },
	    selectTab: function selectTab(tabId) {
	      this.selectedTab = tabId;
	    },
	    replaceEvent: function replaceEvent(subject) {
	      var _this2 = this;
	
	      this.isSubmittingSubjectId = subject.id;
	      _docendo2.default.eventReplace(this.schoolId, this.eventId, subject.id, function (success) {
	        if (success.status && success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, success: false };
	          _this2.isSubmittingSubjectId = null;
	          return;
	        }
	        _eventbus2.default.toast = { text: _this2.$t('vue2.edit_event.lesson_updated'), success: true };
	        _this2.isSubmittingSubjectId = null;
	        _this2.$emit('update');
	      }, function (failure) {
	        console.log({ failure: failure });
	        _this2.isSubmittingSubjectId = null;
	      });
	    },
	    eventSwap: function eventSwap(event) {
	      var _this3 = this;
	
	      this.isSubmittingEventId = event.id;
	      _docendo2.default.eventSwap(this.schoolId, this.eventId, event.id, function (success) {
	        if (success.status && success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, success: false };
	          _this3.isSubmittingEventId = null;
	          return;
	        }
	        _eventbus2.default.toast = { text: _this3.$t('vue2.edit_event.lesson_updated'), success: true };
	        _this3.isSubmittingEventId = null;
	        _this3.$emit('update');
	        _this3.$store.dispatch('trackEvent', 'calendar_event_swaps_swapped');
	      }, function (failure) {
	        console.log({ failure: failure });
	        _this3.isSubmittingEventId = null;
	      });
	    },
	    getDateAndTime: function getDateAndTime(event) {
	      if (!event.event_time_start) return '';
	      var start = (0, _moment2.default)(event.event_time_start);
	      var end = (0, _moment2.default)(event.event_time_end);
	      if (this.locale === 'en') {
	        return start.format('dddd, D MMM [at] HH:mm') + ' - ' + end.format('HH:mm');
	      } else {
	        return start.format('dddd, D. MMM [kl.] HH:mm') + ' - ' + end.format('HH:mm');
	      }
	    },
	    readReplaceSubjects: function readReplaceSubjects() {
	      var _this4 = this;
	
	      this.isLoading = true;
	      this.subjects = [];
	      _docendo2.default.eventListReplaceable(this.schoolId, this.eventId, function (success) {
	        if (success.status && success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, success: false };
	          _this4.subjects = [];
	          _this4.isLoading = false;
	          return;
	        }
	        _this4.subjects = success;
	        _this4.isLoading = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', success: false };
	        console.log('failure', failure);
	        _this4.isLoading = false;
	      });
	    },
	    readSwapEvents: function readSwapEvents() {
	      var _this5 = this;
	
	      this.isLoading = true;
	      this.events = [];
	      _docendo2.default.eventListSwapable(this.schoolId, this.eventId, function (success) {
	        if (success.status && success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, success: false };
	          _this5.events = [];
	          _this5.isLoading = false;
	          return;
	        }
	        _this5.events = success;
	        _this5.isLoading = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', success: false };
	        console.log({ failure: failure });
	        _this5.isLoading = false;
	      });
	    },
	    readPossibilities: function readPossibilities() {
	      if (this.type === 'swap') this.readSwapEvents();
	      if (this.type === 'replace') this.readReplaceSubjects();
	    }
	  },
	  mounted: function mounted() {
	    this.readPossibilities();
	  }
	};

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _Spinner = __webpack_require__(26);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default, Spinner: _Spinner2.default },
	  props: {
	    isShowFromProp: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isModal: false,
	      theActiveIntegration: 0,
	      integrations: [{
	        id: 0,
	        title: 'Apple iPhone',
	        youTubeLink: 'https://www.youtube.com/watch?v=Vkw-bVsvkq4'
	      }, {
	        id: 1,
	        title: 'Android',
	        youTubeLink: 'https://www.youtube.com/watch?v=Idpmc8dcFV0'
	      }]
	    };
	  },
	
	  watch: {
	    isShowFromProp: function isShowFromProp(val) {
	      this.setIsModal(val);
	    }
	  },
	  methods: {
	    setIsModal: function setIsModal(boolean) {
	      this.isModal = boolean;
	      if (!boolean) {
	        this.$emit('close');
	      }
	    }
	  }
	};

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _Spinner = __webpack_require__(26);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _icalIcon = __webpack_require__(1425);
	
	var _icalIcon2 = _interopRequireDefault(_icalIcon);
	
	var _ical_ = __webpack_require__(1426);
	
	var _ical_2 = _interopRequireDefault(_ical_);
	
	var _googleCalendarIcon = __webpack_require__(1421);
	
	var _googleCalendarIcon2 = _interopRequireDefault(_googleCalendarIcon);
	
	var _googlecalendar = __webpack_require__(1422);
	
	var _googlecalendar2 = _interopRequireDefault(_googlecalendar);
	
	var _googlecalendar3 = __webpack_require__(1423);
	
	var _googlecalendar4 = _interopRequireDefault(_googlecalendar3);
	
	var _googlecalendar5 = __webpack_require__(1424);
	
	var _googlecalendar6 = _interopRequireDefault(_googlecalendar5);
	
	var _outlookIcon = __webpack_require__(1427);
	
	var _outlookIcon2 = _interopRequireDefault(_outlookIcon);
	
	var _outlook = __webpack_require__(1428);
	
	var _outlook2 = _interopRequireDefault(_outlook);
	
	var _outlook3 = __webpack_require__(1429);
	
	var _outlook4 = _interopRequireDefault(_outlook3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default, Spinner: _Spinner2.default },
	  props: {
	    calLink: {
	      default: ''
	    },
	    isShowButton: {
	      type: Boolean,
	      default: true
	    },
	    isShowFromProp: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isModal: false,
	      theActiveIntegration: 0,
	      integrations: [{
	        id: 0,
	        title: 'Google Calendar',
	        icon: _googleCalendarIcon2.default,
	        imgs: [_googlecalendar2.default, _googlecalendar4.default, _googlecalendar6.default]
	      }, {
	        id: 1,
	        title: 'Apple Calendar',
	        icon: _icalIcon2.default,
	        imgs: [_ical_2.default]
	      }, {
	        id: 2,
	        title: 'Outlook Calendar',
	        icon: _outlookIcon2.default,
	        imgs: [_outlook2.default, _outlook4.default]
	      }]
	    };
	  },
	
	  watch: {
	    isShowFromProp: function isShowFromProp(val) {
	      this.setIsModal(val);
	    }
	  },
	  methods: {
	    setIsModal: function setIsModal(boolean) {
	      this.isModal = boolean;
	      if (!boolean) {
	        this.$emit('close');
	      }
	    }
	  }
	};

/***/ }),
/* 575 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'hello',
	  props: {
	    message: {
	      type: String,
	      default: function _default() {
	        return 'hello';
	      }
	    }
	  },
	  exampleData: {
	    message: 'Example message'
	  },
	  methods: {
	    emitClick: function emitClick() {
	      this.$emit('message', this.message);
	    }
	  }
	};

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _anne = __webpack_require__(1430);
	
	var _anne2 = _interopRequireDefault(_anne);
	
	var _henrik = __webpack_require__(1431);
	
	var _henrik2 = _interopRequireDefault(_henrik);
	
	var _jeppe = __webpack_require__(1432);
	
	var _jeppe2 = _interopRequireDefault(_jeppe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      isShowChat: false,
	      anne: _anne2.default,
	      henrik: _henrik2.default,
	      jeppe: _jeppe2.default
	    };
	  },
	
	  methods: {
	    setOpenChat: function setOpenChat() {
	      this.isShowChat = !this.isShowChat;
	    }
	  }
	};

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DoLogo = __webpack_require__(411);
	
	var _DoLogo2 = _interopRequireDefault(_DoLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HELPDESK_LOCALES = [{ code: 'da', flag: 'https://zen.docendo.co/flags/dk.svg', label: 'Dansk', dateLocale: 'da-DK' }, { code: 'nb', flag: 'https://zen.docendo.co/flags/no.svg', label: 'Norsk', dateLocale: 'nb-NO' }, { code: 'en', flag: 'https://zen.docendo.co/flags/us.svg', label: 'English', dateLocale: 'en-GB' }];
	
	var HELPDESK_LOCALE_CODES = HELPDESK_LOCALES.map(function (opt) {
	  return opt.code;
	});
	
	function defaultHelpdeskLocale(vm) {
	  var host = typeof window !== 'undefined' && window.location && window.location.host || '';
	  if (host.indexOf('.dk') > -1) return 'da';
	  if (host.indexOf('.no') > -1) return 'nb';
	  if (vm && vm.$store && vm.$store.getters && vm.$store.getters.locale) {
	    return vm.$store.getters.locale;
	  }
	  if (vm && vm.$i18n && vm.$i18n.locale) return vm.$i18n.locale;
	  return 'en';
	}
	
	function normalizeHelpdeskLocale(code) {
	  if (code === 'no' || code === 'nn') return 'nb';
	  if (HELPDESK_LOCALE_CODES.indexOf(code) > -1) return code;
	  return null;
	}
	
	exports.default = {
	  name: 'Helpdesk',
	  components: { DoLogo: _DoLogo2.default },
	  data: function data() {
	    return {
	      rawCategories: [],
	      mostVisited: [],
	      latestNews: [],
	      isLoading: false,
	      searchQuery: '',
	      searchResults: [],
	      isSearching: false,
	      activeCategory: null,
	      activeArticle: null,
	      searchDebounce: null,
	      shareCopied: false,
	      shareTimer: null,
	
	      articleLocale: null,
	      localeOptions: HELPDESK_LOCALES
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.articleLocale || defaultHelpdeskLocale(this);
	    },
	    homeUrl: function homeUrl() {
	      var host = typeof window !== 'undefined' && window.location && window.location.host || '';
	      if (host.indexOf('.dk') > -1) return 'https://app.docendo.dk/calendar';
	      if (host.indexOf('.no') > -1) return 'https://app.docendo.no/calendar';
	      if (host.indexOf('.co') > -1) return 'https://app.docendo.co/calendar';
	      return '/calendar';
	    },
	    categories: function categories() {
	      var uncategorized = this.$t('vue2.helpdesk.uncategorized');
	      return this.rawCategories.filter(function (cat) {
	        return cat.articles && cat.articles.length;
	      }).map(function (cat) {
	        var name = cat.name || uncategorized;
	        return {
	          id: cat.id,
	          name: name,
	          description: cat.description || '',
	          icon: cat.icon || null,
	          count: cat.articles.length,
	          articles: cat.articles.map(function (article) {
	            return (0, _assign2.default)({}, article, { category: name });
	          })
	        };
	      });
	    },
	    articles: function articles() {
	      return this.categories.reduce(function (all, cat) {
	        return all.concat(cat.articles);
	      }, []);
	    },
	    newsCategoryName: function newsCategoryName() {
	      var first = this.latestNews[0];
	      return first ? first.category : null;
	    },
	    topicCategories: function topicCategories() {
	      var _this = this;
	
	      return this.categories.filter(function (cat) {
	        return cat.name !== _this.newsCategoryName;
	      });
	    },
	    featuredNews: function featuredNews() {
	      return this.latestNews[0] || null;
	    },
	    olderNews: function olderNews() {
	      return this.latestNews.slice(1, 4);
	    },
	    featuredNewsDate: function featuredNewsDate() {
	      var _this2 = this;
	
	      if (!this.featuredNews || !this.featuredNews.published_at) return '';
	      var opt = HELPDESK_LOCALES.find(function (o) {
	        return o.code === _this2.locale;
	      });
	      try {
	        return new Date(this.featuredNews.published_at).toLocaleDateString(opt ? opt.dateLocale : undefined, { month: 'long', year: 'numeric' });
	      } catch (e) {
	        return '';
	      }
	    },
	    articlesInActiveCategory: function articlesInActiveCategory() {
	      var _this3 = this;
	
	      if (!this.activeCategory) return [];
	      return this.articles.filter(function (article) {
	        return article.category === _this3.activeCategory;
	      });
	    },
	    articleCategory: function articleCategory() {
	      if (this.activeArticle && this.activeArticle.category) {
	        return this.activeArticle.category;
	      }
	      return this.activeCategory;
	    },
	    relatedArticles: function relatedArticles() {
	      var _this4 = this;
	
	      if (!this.articleCategory) return [];
	      var currentId = this.activeArticle ? this.activeArticle.id : null;
	      return this.articles.filter(function (article) {
	        return article.category === _this4.articleCategory && article.id !== currentId;
	      });
	    },
	    showSubheader: function showSubheader() {
	      return !this.isLoading && !this.searchQuery && !this.isSearching && (!!this.activeArticle || !!this.activeCategory);
	    },
	    articleHtml: function articleHtml() {
	      if (!this.activeArticle) return '';
	      var html = this.activeArticle.as_html || this.activeArticle.body || '';
	      return this.processArticleHtml(html);
	    }
	  },
	  created: function created() {
	    this._previousUiLocale = this.$i18n ? this.$i18n.locale : null;
	    var queryLang = this.$route && this.$route.query ? normalizeHelpdeskLocale(this.$route.query.lang) : null;
	    this.articleLocale = queryLang || defaultHelpdeskLocale(this);
	    this.syncUiLocale(this.articleLocale);
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUser');
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$i18n && this._previousUiLocale) {
	      this.$i18n.locale = this._previousUiLocale;
	    }
	  },
	  mounted: function mounted() {
	    this.fetchArticles();
	
	    if (this.$route) {
	      this.applyState(this.$route.query || {});
	    }
	  },
	
	  watch: {
	    '$route.query': function $routeQuery(query) {
	      this.applyState(query || {});
	    }
	  },
	  methods: {
	    syncUiLocale: function syncUiLocale(code) {
	      if (this.$i18n && code) {
	        this.$i18n.locale = code;
	      }
	    },
	    setLocale: function setLocale(code) {
	      var next = normalizeHelpdeskLocale(code);
	      if (!next || next === this.locale) return;
	      this.articleLocale = next;
	      this.syncUiLocale(next);
	
	      this.activeArticle = null;
	      this.activeCategory = null;
	      this.searchQuery = '';
	      this.searchResults = [];
	      this.isSearching = false;
	      this.fetchArticles();
	      this.navigate({}, true);
	    },
	    fetchArticles: function fetchArticles() {
	      var _this5 = this;
	
	      this.isLoading = true;
	      _docendo2.default.articlesIndexNew(this.locale, function (data) {
	        data = data || {};
	        _this5.rawCategories = Array.isArray(data.categories) ? data.categories : [];
	        _this5.mostVisited = Array.isArray(data.most_visited) ? data.most_visited : [];
	        _this5.latestNews = Array.isArray(data.latest_news) ? data.latest_news : [];
	        _this5.isLoading = false;
	      }, function () {
	        _this5.rawCategories = [];
	        _this5.mostVisited = [];
	        _this5.latestNews = [];
	        _this5.isLoading = false;
	      });
	    },
	    categoryDescription: function categoryDescription(name) {
	      var cat = this.categories.find(function (c) {
	        return c.name === name;
	      });
	      return cat ? cat.description : '';
	    },
	    processArticleHtml: function processArticleHtml(html) {
	      if (!html) return '';
	      if (typeof window === 'undefined' || !window.DOMParser) return html;
	
	      var doc = new window.DOMParser().parseFromString(html, 'text/html');
	      var each = function each(nodeList, fn) {
	        Array.prototype.forEach.call(nodeList, fn);
	      };
	
	      each(doc.querySelectorAll('.legacy-anchor'), function (el) {
	        el.parentNode && el.parentNode.removeChild(el);
	      });
	
	      each(doc.querySelectorAll('img'), function (img) {
	        img.removeAttribute('width');
	        img.removeAttribute('height');
	        img.style.maxWidth = '100%';
	        img.style.height = 'auto';
	      });
	
	      each(doc.querySelectorAll('a'), function (a) {
	        var href = a.getAttribute('href') || '';
	        if (!/^\d+$/.test(href)) return;
	        var wrap = doc.createElement('div');
	        wrap.className = 'helpdesk__video';
	        var iframe = doc.createElement('iframe');
	        iframe.setAttribute('src', 'https://player.vimeo.com/video/' + href);
	        iframe.setAttribute('frameborder', '0');
	        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
	        iframe.setAttribute('allowfullscreen', 'true');
	        wrap.appendChild(iframe);
	        var target = a.closest ? a.closest('p') || a : a;
	        target.parentNode && target.parentNode.replaceChild(wrap, target);
	      });
	
	      each(doc.querySelectorAll('a[href^="#"]'), function (a) {
	        var text = doc.createTextNode(a.textContent || '');
	        a.parentNode && a.parentNode.replaceChild(text, a);
	      });
	
	      each(doc.querySelectorAll('a[href^="http"]'), function (a) {
	        a.setAttribute('target', '_blank');
	        a.setAttribute('rel', 'noopener noreferrer');
	      });
	
	      var result = doc.body ? doc.body.innerHTML : html;
	
	      return result.replace(/\$\{vimeo\}/g, '');
	    },
	    articleExcerpt: function articleExcerpt(article) {
	      var raw = article && (article.excerpt || article.body);
	      if (!raw) return '';
	      var text = String(raw).replace(/<[^>]*>/g, ' ').replace(/!\[[^\]]*\]\([^)]*\)/g, ' ').replace(/\[([^\]]*)\]\([^)]*\)/g, '$1').replace(/\$\{vimeo\}/g, ' ').replace(/[#*_`>]/g, ' ').replace(/\s+/g, ' ').trim();
	      if (text.length > 160) {
	        text = text.slice(0, 160).trim() + '…';
	      }
	      return text;
	    },
	    navigate: function navigate(query, replace) {
	      var clean = { lang: this.locale };
	      (0, _keys2.default)(query || {}).forEach(function (key) {
	        var value = query[key];
	        if (value !== null && value !== undefined && value !== '') {
	          clean[key] = String(value);
	        }
	      });
	      if (this.$router && this.$route) {
	        if ((0, _stringify2.default)(this.$route.query) === (0, _stringify2.default)(clean)) {
	          return;
	        }
	        var method = replace ? 'replace' : 'push';
	        this.$router[method]({ query: clean }).catch(function () {});
	      } else {
	        this.applyState(clean);
	      }
	    },
	    applyState: function applyState(query) {
	      query = query || {};
	
	      var lang = normalizeHelpdeskLocale(query.lang);
	      if (lang && lang !== this.articleLocale) {
	        this.articleLocale = lang;
	        this.syncUiLocale(lang);
	        this.activeArticle = null;
	        this.fetchArticles();
	      }
	
	      this.searchQuery = query.q || '';
	      this.activeCategory = query.category || null;
	
	      var articleId = query.article || null;
	      if (articleId) {
	        if (!this.activeArticle || String(this.activeArticle.id) !== String(articleId)) {
	          this.fetchArticle(articleId);
	        }
	      } else {
	        this.activeArticle = null;
	      }
	
	      if (this.searchQuery) {
	        this.isSearching = true;
	        this.runSearch(this.searchQuery);
	      } else {
	        this.searchResults = [];
	        this.isSearching = false;
	      }
	      this.scrollToTop();
	    },
	    fetchArticle: function fetchArticle(id) {
	      var _this6 = this;
	
	      this.isLoading = true;
	      _docendo2.default.articlesGet(id, this.locale, function (data) {
	        _this6.activeArticle = data && !data.status ? data : null;
	        _this6.isLoading = false;
	        _this6.scrollToTop();
	        if (_this6.activeArticle && _this6.activeArticle.title) {
	          _this6.$store.dispatch('trackEvent', 'helpdesk_article_' + _this6.activeArticle.title);
	        }
	      }, function () {
	        _this6.isLoading = false;
	      });
	    },
	    goHome: function goHome() {
	      this.navigate({});
	    },
	    openCategory: function openCategory(name) {
	      this.navigate({ category: name });
	    },
	    closeCategory: function closeCategory() {
	      this.navigate({});
	    },
	    openArticle: function openArticle(id) {
	      this.navigate({ article: id });
	    },
	    closeArticle: function closeArticle() {
	      this.navigate({});
	    },
	    onSearchInput: function onSearchInput() {
	      var _this7 = this;
	
	      if (this.searchDebounce) {
	        clearTimeout(this.searchDebounce);
	      }
	      var query = this.searchQuery;
	      if (!query || !query.trim()) {
	        this.navigate({}, true);
	        return;
	      }
	      this.isSearching = true;
	      this.searchDebounce = setTimeout(function () {
	        _this7.navigate({ q: query }, true);
	      }, 350);
	    },
	    runSearch: function runSearch(query) {
	      var _this8 = this;
	
	      _docendo2.default.articlesSearch(query, this.locale, function (data) {
	        if (_this8.searchQuery !== query) return;
	        _this8.searchResults = Array.isArray(data) ? data : [];
	        _this8.isSearching = false;
	      }, function () {
	        _this8.searchResults = [];
	        _this8.isSearching = false;
	      });
	    },
	    clearSearch: function clearSearch() {
	      if (this.searchDebounce) {
	        clearTimeout(this.searchDebounce);
	      }
	      this.navigate({});
	    },
	    scrollToTop: function scrollToTop() {
	      if (typeof window !== 'undefined' && window.scrollTo) {
	        window.scrollTo({ top: 0, behavior: 'smooth' });
	      }
	    },
	    articleShareUrl: function articleShareUrl() {
	      if (typeof window === 'undefined' || !this.activeArticle) return '';
	
	      if (this.$router && this.$route) {
	        var resolved = this.$router.resolve({
	          query: (0, _assign2.default)({}, this.$route.query, { article: String(this.activeArticle.id) })
	        });
	        var href = resolved.href || '';
	        if (href.charAt(0) === '#') {
	          return window.location.origin + window.location.pathname + href;
	        }
	        if (href.charAt(0) === '/') {
	          return window.location.origin + href;
	        }
	      }
	      return window.location.href;
	    },
	    shareArticle: function shareArticle() {
	      var url = this.articleShareUrl();
	      if (!url) return;
	      this.copyToClipboard(url);
	    },
	    copyToClipboard: function copyToClipboard(text) {
	      var self = this;
	      var done = function done() {
	        self.shareCopied = true;
	        if (self.shareTimer) {
	          clearTimeout(self.shareTimer);
	        }
	        self.shareTimer = setTimeout(function () {
	          self.shareCopied = false;
	        }, 2000);
	      };
	      if (navigator.clipboard && navigator.clipboard.writeText) {
	        navigator.clipboard.writeText(text).then(done).catch(function () {
	          self.fallbackCopy(text, done);
	        });
	      } else {
	        this.fallbackCopy(text, done);
	      }
	    },
	    fallbackCopy: function fallbackCopy(text, done) {
	      try {
	        var el = document.createElement('textarea');
	        el.value = text;
	        el.setAttribute('readonly', '');
	        el.style.position = 'absolute';
	        el.style.left = '-9999px';
	        document.body.appendChild(el);
	        el.select();
	        document.execCommand('copy');
	        document.body.removeChild(el);
	        done();
	      } catch (e) {}
	    }
	  }
	};

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(33);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _DSelectUsers = __webpack_require__(67);
	
	var _DSelectUsers2 = _interopRequireDefault(_DSelectUsers);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Spinner = __webpack_require__(26);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _IEAndEdgeWarning = __webpack_require__(414);
	
	var _IEAndEdgeWarning2 = _interopRequireDefault(_IEAndEdgeWarning);
	
	var _HoursShowShortcuts = __webpack_require__(1519);
	
	var _HoursShowShortcuts2 = _interopRequireDefault(_HoursShowShortcuts);
	
	var _userEventsFilter = __webpack_require__(112);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'HoursShow',
	  components: { DatePickerRange: _DatePickerRange2.default, dSelectUsers: _DSelectUsers2.default, Spinner: _Spinner2.default, IEwarning: _IEAndEdgeWarning2.default, HoursShowShortcuts: _HoursShowShortcuts2.default },
	  data: function data() {
	    return {
	      startDate: (0, _moment2.default)().isoWeekday(1),
	      endDate: (0, _moment2.default)().isoWeekday(7),
	      selectedUsers: [],
	      usersAndEvents: [],
	      eventsFilter: null,
	      isLoading: false
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.state.activeSchool.id;
	    },
	    start: function start() {
	      return (0, _moment2.default)(this.startDate).startOf('day');
	    },
	    end: function end() {
	      return (0, _moment2.default)(this.endDate).endOf('day');
	    },
	    selectedUsersIds: function selectedUsersIds() {
	      return this.selectedUsers.map(function (user) {
	        return user.id;
	      });
	    },
	    usersAndEventsSortedOnName: function usersAndEventsSortedOnName() {
	      return this.usersAndEvents.sort(function (a, b) {
	        var x = a.name.toLowerCase();
	        var y = b.name.toLowerCase();
	        if (x < y) {
	          return -1;
	        }
	        if (x > y) {
	          return 1;
	        }
	        return 0;
	      });
	    },
	    usersAndEventsWithProps: function usersAndEventsWithProps() {
	      var _this = this;
	
	      return this.usersAndEventsSortedOnName.map(function (user) {
	        user.v_events_filtered = _this.filteredEvents(user.events, user.user_id);
	        user.v_filter_events = _this.filterEvents(user.events, user.user_id);
	        user.v_day_durations = _this.getUserDayDurations(user.v_events_filtered);
	        user.v_all_days_duration = _this.getAllUserDaysDurations(user.v_day_durations);
	        return user;
	      });
	    }
	  },
	  watch: {
	    selectedUsersIds: function selectedUsersIds() {
	      if (this.selectedUsersIds.length < 1) {
	        this.usersAndEvents = [];
	      }
	      this.getEvents();
	    }
	  },
	  filters: {
	    klassList: function klassList(string) {
	      return string.replace(/{|}/g, '');
	    }
	  },
	  methods: {
	    filterEvents: function filterEvents(events, userId) {
	      return (0, _userEventsFilter.filterUserEvents)(events, this.eventsFilter, userId);
	    },
	    eventHasAnyKlass: function eventHasAnyKlass(event) {
	      var str = event.replace(/{|}/g, '');
	      return str.length > 0;
	    },
	    eventsToArr: function eventsToArr(events) {
	      events = this.eventsSortedInDays(events);
	      return (0, _keys2.default)(events).map(function (e) {
	        return { date: e, events: events[e] };
	      });
	    },
	    filteredEvents: function filteredEvents(events, userId) {
	      return this.sortedEvents(this.filterEvents(events, userId));
	    },
	    sortedEvents: function sortedEvents(events) {
	      var sortedEvent = events.sort(function (a, b) {
	        return (0, _moment2.default)(a.start_time).unix() - (0, _moment2.default)(b.start_time).unix();
	      });
	      return this.eventsSortedInDays(sortedEvent);
	    },
	    eventsSortedInDays: function eventsSortedInDays(events) {
	      return events.reduce(function (acc, curr, index) {
	        var val = (0, _moment2.default)(curr['start_time']).format('YYYY-MM-DD');
	        acc[val] = acc[val] || [];
	        acc[val].push(curr);
	        return acc;
	      }, {});
	    },
	    syncUsers: function syncUsers(data) {
	      this.selectedUsers = data;
	    },
	    startDateChanged: function startDateChanged(date) {
	      this.startDate = date;
	      this.getEvents();
	    },
	    endDateChanged: function endDateChanged(date) {
	      this.endDate = date;
	      this.getEvents();
	    },
	    setEventsFilter: function setEventsFilter(type) {
	      this.eventsFilter = type;
	    },
	    filterIsActive: function filterIsActive(type) {
	      return this.eventsFilter === type;
	    },
	    getEvents: function getEvents() {
	      var _this2 = this;
	
	      if (this.selectedUsersIds.length < 1) {
	        return;
	      }
	      this.isLoading = true;
	      _docendo2.default.schoolEvents(window.SCHOOL.id, this.start, this.end, this.selectedUsersIds, '', function (data) {
	        _this2.usersAndEvents = data;
	        _this2.isLoading = false;
	      });
	    },
	    print: function print() {
	      window.print();
	    },
	    getSumDuration: function getSumDuration(eventsArr) {
	      var filterAbsence = eventsArr;
	      if (this.eventsFilter !== 'absence') {
	        filterAbsence = eventsArr.filter(function (lesson) {
	          return lesson.event_type !== 'absence';
	        });
	      }
	      var durations = [];
	      filterAbsence.forEach(function (lesson) {
	        durations.push(lesson.calendar_event_duration);
	      });
	      var data = durations.reduce(function (a, b) {
	        return a + b;
	      }, 0);
	      return this.humanizeMinutes(data);
	    },
	    getDayDuration: function getDayDuration(eventsArr) {
	      var start = (0, _moment2.default)(eventsArr[0].start_time);
	      var end = (0, _moment2.default)(eventsArr[eventsArr.length - 1].end_time);
	      var duration = end.diff(start, 'minutes');
	      return this.humanizeMinutes(duration);
	    },
	    getDayDurationInMinutes: function getDayDurationInMinutes(eventsArr) {
	      var start = (0, _moment2.default)(eventsArr[0].start_time);
	      var end = (0, _moment2.default)(eventsArr[eventsArr.length - 1].end_time);
	      return end.diff(start, 'minutes');
	    },
	    humanizeMinutes: function humanizeMinutes(data) {
	      var minutes = data % 60;
	      var hours = (data - minutes) / 60;
	      var multiple = hours === 1 ? this.$i18n.t('vue2.substitute_hours.hour') : this.$i18n.t('vue2.substitute_hours.hours');
	      return hours + ' ' + multiple + ' ' + minutes + ' ' + this.$t('vue2.substitute_hours.min');
	    },
	    getEventDuration: function getEventDuration(event) {
	      if (this.activeFilter !== 'absence' && event.event_type === 'absence') {
	        return '';
	      }
	      return event.calendar_event_duration + ' min.';
	    },
	    getUserDayDurations: function getUserDayDurations(eventsInDays) {
	      var durations = {};
	      for (var key in eventsInDays) {
	        if (!durations[key]) {
	          durations[key] = this.getDayDurationInMinutes(eventsInDays[key]);
	        }
	      }
	      return durations;
	    },
	    getAllUserDaysDurations: function getAllUserDaysDurations(dayDurations) {
	      var durationsArr = (0, _values2.default)(dayDurations);
	      var allDaysDuration = durationsArr && durationsArr.length > 0 ? durationsArr.reduce(function (currentValue, sum) {
	        return currentValue + sum;
	      }) : 0;
	      return this.humanizeMinutes(allDaysDuration);
	    }
	  },
	  mounted: function mounted() {
	    if (window.Intercom) {
	      window.Intercom('trackEvent', 'Visited Get User Events');
	    }
	  }
	};

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _freeze = __webpack_require__(86);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _map = __webpack_require__(894);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _values = __webpack_require__(33);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    filter_reasons: 'Årsager',
	    period: 'Periode',
	    ongoing: 'løbende'
	  },
	  en: {
	    filter_reasons: 'Reasons',
	    period: 'Period',
	    ongoing: 'ongoing'
	  },
	  nb: {
	    filter_reasons: 'Årsaker',
	    period: 'Periode',
	    ongoing: 'løpende'
	  }
	};
	
	var USERS_PAGE_SIZE = 15;
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default, DoFiltersFilter: _DoFiltersFilter2.default, Loader: _Loader2.default },
	  props: {
	    start: {
	      type: Object,
	      default: (0, _moment2.default)()
	    },
	    end: {
	      type: Object,
	      default: (0, _moment2.default)()
	    }
	  },
	  data: function data() {
	    return {
	      isShowAbsentUsers: false,
	      absenceEvents: [],
	      eventSerialsInHash: {},
	      isLoading: false,
	      selectedReasonsToFilter: [],
	      visibleUsersCount: USERS_PAGE_SIZE,
	      requestId: 0
	    };
	  },
	
	  watch: {
	    isLoading: function isLoading(_isLoading) {
	      if (!_isLoading) {
	        this.observeLoadMoreSentinel();
	      }
	    },
	    selectedReasonsToFilter: function selectedReasonsToFilter() {
	      this.visibleUsersCount = USERS_PAGE_SIZE;
	      this.observeLoadMoreSentinel();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.disconnectLoadMoreObserver();
	    document.querySelector('body').classList.remove('no-scroll');
	  },
	
	  computed: {
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    userIsSchoolAdmin: function userIsSchoolAdmin() {
	      return this.userHasPermission('can_manage_school');
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolCountry: function schoolCountry() {
	      return this.$store.getters.schoolCountry;
	    },
	    isShowExternalShortCuts: function isShowExternalShortCuts() {
	      return this.schoolCountry.toLowerCase() === 'dk' && this.userIsSchoolAdmin;
	    },
	    schoolLinks: function schoolLinks() {
	      return [{
	        link: window.location.origin + '/app#/dashboard/' + this.schoolId,
	        title: 'Antal vikartimer pr. klasse for skoleåret'
	      }, {
	        link: window.location.origin + '/app#/dashboard/absence/' + this.schoolId,
	        title: 'Personalets fraværstyper fordelt over måneder'
	      }, {
	        link: window.location.origin + '/app#/dashboard/absence/subs/' + this.schoolId,
	        title: 'Vikartimer ift. Fraværstyper'
	      }, {
	        link: window.location.origin + '/app#/dashboard/coverage/' + this.schoolId,
	        title: 'Vikardækning pr. skole, årgang, klasse og fag'
	      }, {
	        link: window.location.origin + '/app#/dashboard/continuity/' + this.schoolId,
	        title: 'Vikarkontinuitet pr. klasse og fag'
	      }, {
	        link: window.location.origin + '/app#/dashboard/absence/duration/' + this.schoolId,
	        title: 'Fraværets varighed'
	      }];
	    },
	    startDateFormatted: function startDateFormatted() {
	      return (0, _moment2.default)(this.start).locale(this.locale).format('DD. MMMM YYYY');
	    },
	    endDateFormatted: function endDateFormatted() {
	      return (0, _moment2.default)(this.end).locale(this.locale).format('DD. MMMM YYYY');
	    },
	    absenceEventsTypes: function absenceEventsTypes() {
	      var types = [];
	      this.absenceEvents.forEach(function (event) {
	        var idx = types.findIndex(function (type) {
	          return type === event.title;
	        });
	        if (idx < 0) {
	          types.push(event.title);
	        }
	      });
	      return types;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    durationLabels: function durationLabels() {
	      return {
	        hour: this.$t('vue2.substitute_hours.hour'),
	        hours: this.$t('vue2.substitute_hours.hours'),
	        min: this.$t('vue2.substitute_hours.min')
	      };
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    schoolUsers: function schoolUsers() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    schoolUsersIds: function schoolUsersIds() {
	      return this.schoolUsers.map(function (user) {
	        return user.id;
	      });
	    },
	    schoolUserCalIds: function schoolUserCalIds() {
	      return this.schoolUsers.map(function (user) {
	        return user.user_calendar_id;
	      });
	    },
	    absenceEventsFiltered: function absenceEventsFiltered() {
	      var _this = this;
	
	      if (!this.selectedReasonsToFilter.length) {
	        return this.absenceEvents;
	      }
	      return this.absenceEvents.filter(function (event) {
	        return _this.selectedReasonsToFilter.includes(event.title);
	      });
	    },
	    serialsByCalendarId: function serialsByCalendarId() {
	      var index = {};
	      (0, _values2.default)(this.eventSerialsInHash).forEach(function (serial) {
	        index[serial.calendar_id] = index[serial.calendar_id] || [];
	        index[serial.calendar_id].push({
	          serial: serial,
	          fromDate: (0, _moment2.default)(serial.from_date).format('YYYY-MM-DD'),
	          toDate: serial.to_date ? (0, _moment2.default)(serial.to_date).format('YYYY-MM-DD') : null
	        });
	      });
	      return index;
	    },
	    absentUsers: function absentUsers() {
	      var _this2 = this;
	
	      var eventsByCalId = new _map2.default();
	      this.absenceEventsFiltered.forEach(function (event) {
	        if (!eventsByCalId.has(event.calendar_id)) {
	          eventsByCalId.set(event.calendar_id, []);
	        }
	        eventsByCalId.get(event.calendar_id).push(event);
	      });
	      var users = [];
	      eventsByCalId.forEach(function (events, calId) {
	        users.push({
	          userCalendarId: calId,
	          name: _this2.getUserNameFromCalId(calId),
	          days: _this2.groupEventsInDays(events)
	        });
	      });
	      var collator = new Intl.Collator(this.locale);
	      return users.sort(function (a, b) {
	        return collator.compare(a.name, b.name);
	      });
	    },
	    visibleAbsentUsers: function visibleAbsentUsers() {
	      return this.absentUsers.slice(0, this.visibleUsersCount);
	    },
	    hasMoreAbsentUsers: function hasMoreAbsentUsers() {
	      return this.visibleUsersCount < this.absentUsers.length;
	    }
	  },
	  methods: {
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    toggleFilter: function toggleFilter(filter) {
	      var idx = this.selectedReasonsToFilter.indexOf(filter);
	      if (idx < 0) {
	        this.selectedReasonsToFilter.push(filter);
	      } else {
	        this.selectedReasonsToFilter.splice(idx, 1);
	      }
	    },
	    print: function print() {
	      this.visibleUsersCount = Infinity;
	      this.$nextTick(this.printList);
	    },
	    printList: function printList() {
	      var prtHtml = document.getElementById('printList').innerHTML;
	
	      var stylesHtml = '';
	
	      var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"], style')));
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var node = _arr[_i];
	        stylesHtml += node.outerHTML;
	      }
	
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	
	      WinPrint.document.write('<!DOCTYPE html><html><head>' + stylesHtml + '</head><body>' + prtHtml + '</body></html>');
	      setTimeout(function (_) {
	        WinPrint.document.close();
	        WinPrint.focus();
	        WinPrint.print();
	        WinPrint.close();
	      }, 1000);
	    },
	    hasNoteWithoutHTML: function hasNoteWithoutHTML(myString) {
	      return myString.replace(/<[^>]*>?/gm, '');
	    },
	    open: function open() {
	      var el = document.querySelector('body');
	      if (!el.classList.contains('no-scroll')) {
	        el.classList.add('no-scroll');
	      }
	    },
	    close: function close() {
	      this.isShowAbsentUsers = false;
	      this.disconnectLoadMoreObserver();
	      document.querySelector('body').classList.remove('no-scroll');
	    },
	    observeLoadMoreSentinel: function observeLoadMoreSentinel() {
	      var _this3 = this;
	
	      this.$nextTick(function () {
	        _this3.disconnectLoadMoreObserver();
	        var root = _this3.$refs.overlay;
	        var sentinel = _this3.$refs.loadMoreSentinel;
	        if (!window.IntersectionObserver) {
	          _this3.visibleUsersCount = Infinity;
	          return;
	        }
	        if (!root || !sentinel) {
	          return;
	        }
	        _this3.loadMoreObserver = new window.IntersectionObserver(function (entries) {
	          if (entries.some(function (entry) {
	            return entry.isIntersecting;
	          }) && _this3.hasMoreAbsentUsers) {
	            _this3.visibleUsersCount += USERS_PAGE_SIZE;
	
	            _this3.observeLoadMoreSentinel();
	          }
	        }, { root: root, rootMargin: '600px 0px' });
	        _this3.loadMoreObserver.observe(sentinel);
	      });
	    },
	    disconnectLoadMoreObserver: function disconnectLoadMoreObserver() {
	      if (this.loadMoreObserver) {
	        this.loadMoreObserver.disconnect();
	        this.loadMoreObserver = null;
	      }
	    },
	    getAbsentUsers: function getAbsentUsers() {
	      var _this4 = this;
	
	      this.open();
	      this.isShowAbsentUsers = true;
	      this.absenceEvents = [];
	      this.visibleUsersCount = USERS_PAGE_SIZE;
	      this.isLoading = true;
	      var requestId = ++this.requestId;
	      _docendo2.default.calendarEvents2(this.schoolUserCalIds, this.start, this.end, ['absence'], function (data) {
	        if (requestId !== _this4.requestId) {
	          return;
	        }
	        _this4.absenceEvents = (0, _freeze2.default)(data.length > 0 ? JSON.parse(data) : []);
	        _this4.isLoading = false;
	      }, function (failure) {
	        if (requestId === _this4.requestId) {
	          _this4.isLoading = false;
	        }
	      });
	      this.getEventSerials(requestId);
	    },
	    getEventSerials: function getEventSerials(requestId) {
	      var _this5 = this;
	
	      this.eventSerialsInHash = {};
	      var collected = {};
	      var day = (0, _moment2.default)(this.start).startOf('day');
	      var lastDay = (0, _moment2.default)(this.end).startOf('day');
	      var pending = 0;
	      var flushTimer = null;
	      var flush = function flush() {
	        clearTimeout(flushTimer);
	        flushTimer = null;
	        if (requestId === _this5.requestId) {
	          _this5.eventSerialsInHash = (0, _freeze2.default)((0, _extends3.default)({}, collected));
	        }
	      };
	
	      var done = function done() {
	        pending--;
	        if (pending === 0) {
	          flush();
	        } else if (!flushTimer) {
	          flushTimer = setTimeout(flush, 500);
	        }
	      };
	      while (day.isSameOrBefore(lastDay)) {
	        pending++;
	        _docendo2.default.schoolEventSerialsList(this.schoolId, day.format('YYYY-MM-DD'), function (data) {
	          var serials = Array.isArray(data) ? data : data && Array.isArray(data.data) ? data.data : [];
	          serials.forEach(function (serial) {
	            collected[serial.id] = serial;
	          });
	          done();
	        }, function (failure) {
	          console.log('schoolEventSerialsList failure', failure);
	          done();
	        });
	        day.add(1, 'day');
	      }
	    },
	    getEventSerial: function getEventSerial(event, eventDate) {
	      var candidates = this.serialsByCalendarId[event.calendar_id] || [];
	      var match = candidates.find(function (_ref) {
	        var serial = _ref.serial,
	            fromDate = _ref.fromDate,
	            toDate = _ref.toDate;
	
	        var isSameReason = serial.subject_id ? serial.subject_id === event.subject_id : serial.subject_name === event.title;
	        return isSameReason && fromDate <= eventDate && (!toDate || toDate >= eventDate);
	      });
	      return match ? match.serial : false;
	    },
	    groupEventsInDays: function groupEventsInDays(events) {
	      var _this6 = this;
	
	      var items = events.map(function (event, index) {
	        var start = (0, _moment2.default)(event.start);
	        var date = start.format('YYYY-MM-DD');
	        return {
	          key: event.id || event.start + '-' + index,
	          event: event,
	          date: date,
	          startMs: start.valueOf(),
	          isMultiDay: !_this6.isSameDay(event.start, event.end),
	          serial: _this6.getEventSerial(event, date),
	          hasNote: !!event.teacher_notes && _this6.hasNoteWithoutHTML(event.teacher_notes).length > 0,
	          duration: _this6.getDuration(event)
	        };
	      }).sort(function (a, b) {
	        return a.startMs - b.startMs;
	      });
	      var days = [];
	      items.forEach(function (item) {
	        var lastDay = days[days.length - 1];
	        if (lastDay && lastDay.date === item.date) {
	          lastDay.items.push(item);
	        } else {
	          days.push({ date: item.date, items: [item] });
	        }
	      });
	      return days;
	    },
	    getUserNameFromCalId: function getUserNameFromCalId(calId) {
	      return this.allUsersInCalIdHash[calId] && this.allUsersInCalIdHash[calId].name ? this.allUsersInCalIdHash[calId].name : 'User can not be found';
	    },
	    isSameDay: function isSameDay(start, end) {
	      return (0, _moment2.default)(start).isSame((0, _moment2.default)(end), 'day');
	    },
	    getDuration: function getDuration(event) {
	      return this.humanizeMinutes(event.duration);
	    },
	    humanizeMinutes: function humanizeMinutes(data) {
	      var labels = this.durationLabels;
	      var minutes = data % 60;
	      var hours = (data - minutes) / 60;
	      var multiple = hours === 1 ? labels.hour : labels.hours;
	      return hours + ' ' + multiple + ' ' + minutes + ' ' + labels.min;
	    }
	  }
	};

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userEventsFilter = __webpack_require__(112);
	
	exports.default = {
	  props: {
	    event: {
	      type: Object
	    },
	    activeFilter: {
	      type: String,
	      default: ''
	    },
	
	    userId: {
	      type: Number,
	      default: null
	    }
	  },
	  computed: {
	    eventDuration: function eventDuration() {
	      if (this.activeFilter !== 'absence' && this.event.event_type === 'absence') {
	        return '';
	      }
	      return this.event.calendar_event_duration + ' min.';
	    },
	    showType: function showType() {
	      var isSubstituteHour = this.userId !== null ? (0, _userEventsFilter.isSubstitute)(this.event, this.userId) : this.event.substitute_for !== null;
	      if (isSubstituteHour) {
	        return this.$i18n.t('vue2.substitute_hours.substitute_hour');
	      } else if (this.event.event_type === 'absence') {
	        return this.$i18n.t('vue2.substitute_hours.absence');
	      } else if (this.event.event_type === 'other_tasks') {
	        return this.$i18n.t('vue2.substitute_hours.other_tasks');
	      } else if (this.event.event_type === 'other_stuff') {
	        return this.$i18n.t('vue2.substitute_hours.other_stuff');
	      } else {
	        return '';
	      }
	    }
	  },
	  filters: {
	    klassList: function klassList(string) {
	      return string.replace(/{|}/g, '');
	    }
	  },
	  methods: {
	    eventHasAnyKlass: function eventHasAnyKlass(event) {
	      var str = event.replace(/{|}/g, '');
	      return str.length > 0;
	    }
	  }
	};

/***/ }),
/* 581 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'list-with-search',
	  props: {
	    options: {
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      search: ''
	    };
	  },
	
	  computed: {
	    searchList: function searchList() {
	      var _this = this;
	
	      return this.options.filter(function (obj) {
	        return obj.name !== null ? obj.name.match(new RegExp(_this.search, 'i')) : '';
	      });
	    }
	  },
	  methods: {
	    chooseItem: function chooseItem(obj) {
	      this.$emit('choose', obj);
	    },
	    focusOption: function focusOption(index) {
	      if (index < 0) {
	        this.$refs.search_input.focus();
	        return;
	      }
	      var links = this.$el.querySelectorAll('.js-list-search-option');
	      if (links[index]) {
	        links[index].focus();
	      }
	    },
	    chooseFirst: function chooseFirst() {
	      var firstLink = this.$el.querySelector('.js-list-search-option');
	      if (firstLink) {
	        firstLink.click();
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.$nextTick(function (_) {
	      var searchInput = _this2.$refs.search_input;
	      if (searchInput) {
	        searchInput.focus();
	      }
	    });
	  }
	};

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _momentlangs = __webpack_require__(425);
	
	var _momentlangs2 = _interopRequireDefault(_momentlangs);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      locale: window.USER.locale,
	      languages: _momentlangs2.default
	    };
	  },
	
	  computed: {
	    langSorted: function langSorted() {
	      return this.languages.sort(function (a, b) {
	        return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
	      });
	    }
	  },
	  methods: {
	    saveInLocalStorage: function saveInLocalStorage() {
	      try {
	        if (typeof Storage !== 'undefined') {
	          window.localStorage.setItem('locale', this.locale);
	        }
	      } catch (e) {}
	    },
	    setLocale: function setLocale(userLocale) {
	      var lowerCaseLocale = userLocale.toLowerCase();
	      var fullCallLongLocales = ['ar-dz', 'ar-kw', 'ar-ly', 'ar-ma', 'ar-sa', 'ar-tn', 'de-at', 'de-ch', 'en-au', 'en-ca', 'en-gb', 'en-ie', 'en-nz', 'es-do', 'es-us', 'fr-ca', 'fr-ch', 'ms-my', 'nl-be', 'pt-br', 'sr-cyrl', 'zh-vn', 'zh-tw'];
	      if (fullCallLongLocales.indexOf(lowerCaseLocale) < 0) {
	        this.locale = lowerCaseLocale.substring(0, 2);
	      } else {
	        this.locale = lowerCaseLocale;
	      }
	      this.$emit('locale', lowerCaseLocale);
	    }
	  },
	  watch: {
	    locale: function locale(val) {
	      this.$emit('locale', val);
	      this.$i18n.locale = val;
	      _moment2.default.locale(val);
	    }
	  },
	  beforeMount: function beforeMount() {
	    try {
	      if (typeof Storage !== 'undefined') {
	        if (window.localStorage.getItem('locale') !== null) {
	          this.setLocale(window.localStorage.getItem('locale'));
	        } else {
	          try {
	            var browserLocale = navigator.language || navigator.userLanguage;
	            this.setLocale(browserLocale);
	          } catch (e) {
	            this.setLocale('en');
	          }
	        }
	      }
	    } catch (e) {
	      this.setLocale('en');
	    }
	  }
	};

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'eventChanges',
	  components: { Loader: _Loader2.default },
	  props: {
	    eventId: {
	      type: Number,
	      default: 11794195
	    },
	    event: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      i18n: {
	        da: {
	          latest_activity: 'Seneste aktivitet',
	          no_changes: 'Ingen ændringer foretaget',
	          created: 'Oprettede',
	          added_room: 'Tilføjede lokale',
	          removed_room: 'Fjernede lokale',
	          added_user: 'Tilføjede person',
	          removed_user: 'Fjernede person',
	          changed_time: 'Ændrede tidspunkt',
	          ago: 'siden',
	          added_grade: 'Tilføjede klasse',
	          removed_grade: 'Fjernede klasse',
	          added_sub: 'Tilføjede vikar',
	          removed_sub: 'Fjernede vikar',
	          learning_goal_changed: 'Læringsmål ændrede',
	          content_changed: 'Indhold ændrede',
	          teacher_notes_changed: 'Vikarnoter ændrede',
	          notes_for_students_changed: 'Noter til elever ændrede'
	        },
	        en: {
	          latest_activity: 'Recent activity',
	          no_changes: 'No changes made',
	          created: 'Created',
	          added_user: 'Added teacher',
	          added_room: 'Added room',
	          removed_user: 'Removed the teacher',
	          changed_time: 'Changed time',
	          ago: 'ago',
	          added_grade: 'Added grade/group',
	          removed_grade: 'Removed grade/group',
	          added_sub: 'Added substitute',
	          removed_sub: 'Removed substitute',
	          learning_goal_changed: 'Learning goal changed',
	          content_changed: 'Content changed',
	          teacher_notes_changed: 'Teacher notes changed',
	          notes_for_students_changed: 'Notes for students changed'
	        },
	        nb: {
	          latest_activity: 'Historikk',
	          no_changes: 'Ingen endringer er blitt gjort',
	          created: 'Opprettet',
	          added_room: 'La til lokalet',
	          removed_room: 'Fjernet lokalet',
	          added_user: 'La til underviser',
	          removed_user: 'Fjernet underviseren',
	          changed_time: 'Endret tiden',
	          ago: 'siden',
	          added_grade: 'La til klasse',
	          removed_grade: 'Fjernet klasse',
	          added_sub: 'La til vikar',
	          removed_sub: 'Fjernet vikar',
	          learning_goal_changed: 'Læringsmål endret',
	          content_changed: 'Innhold endret',
	          teacher_notes_changed: 'Vikarnotater endret',
	          notes_for_students_changed: 'Notater for elever endret'
	        }
	      },
	      isLoading: true,
	      changes: []
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    changesFiltered: function changesFiltered() {
	      return this.changes.filter(function (change) {
	        return change;
	      });
	    },
	    sortedLogs: function sortedLogs() {
	      return this.changesFiltered.sort(function (a, b) {
	        if (b && b.at && a && a.at) {
	          return new Date(b.at) - new Date(a.at);
	        }
	      });
	    },
	    logsFormatted: function logsFormatted() {
	      var _this = this;
	
	      return this.sortedLogs.map(function (activity) {
	        return (0, _extends3.default)({}, activity, {
	          vFormattedDate: _this.formatDate(activity.at),
	          vDuration: _this.getDuration(activity.at),
	          vHumanizedChanges: _this.humanizeChanges(activity.changes)
	        });
	      });
	    }
	  },
	  methods: {
	    formatDate: function formatDate(datetime) {
	      return datetime ? (0, _moment2.default)(datetime).format('LLL') : datetime;
	    },
	    getDuration: function getDuration(datetime) {
	      var diff = (0, _moment2.default)().diff((0, _moment2.default)(datetime));
	      return _moment2.default.duration(diff).humanize();
	    },
	    changeCalendars: function changeCalendars(change) {
	      var text = '';
	
	      var addedArr = change.calendars.addded;
	      var removedArr = change.calendars.removed;
	
	      var users = { added: [], removed: [] };
	      var rooms = { added: [], removed: [] };
	      var subs = { added: [], removed: [] };
	      var klasses = { added: [], removed: [] };
	
	      addedArr.forEach(function (obj) {
	        if (obj.type === 'room') {
	          rooms.added.push(obj);
	        }
	        if (obj.type === 'user' && obj.substitute === null) {
	          users.added.push(obj);
	        }
	        if (obj.type === 'user' && obj.substitute !== null) {
	          subs.added.push(obj);
	        }
	        if (obj.type === 'klass') {
	          klasses.added.push(obj);
	        }
	      });
	      removedArr.forEach(function (obj) {
	        if (obj.type === 'room') {
	          rooms.removed.push(obj);
	        }
	        if (obj.type === 'klass') {
	          klasses.removed.push(obj);
	        }
	        if (obj.type === 'user' && obj.substitute === null) {
	          users.removed.push(obj);
	        }
	        if (obj.type === 'user' && obj.substitute !== null) {
	          subs.removed.push(obj);
	        }
	      });
	      if (rooms.added.length > 0) {
	        var i18nRoomChanges = '<b><span class="icon-location"></span> ' + this.i18n[this.locale]['added_room'] + '</b>';
	        var roomNames = rooms.added.map(function (obj) {
	          return obj.name;
	        }).join(', ');
	        text = i18nRoomChanges + ' ' + roomNames + '<br>';
	      }
	      if (rooms.removed.length > 0) {
	        var i18n = '<b><span class="icon-location"></span> ' + this.i18n[this.locale]['removed_room'] + '</b>';
	        var names = rooms.removed.map(function (obj) {
	          return obj.name;
	        }).join(', ');
	        text = text + i18n + ' ' + names + '<br>';
	      }
	      if (users.added.length > 0) {
	        var _i18n = '<b><span class="icon-user"></span> ' + this.i18n[this.locale]['added_user'] + '</b>';
	        var userNames = users.added.map(function (obj) {
	          return obj.name;
	        }).join(', ');
	        text = text + _i18n + ' ' + userNames + '<br>';
	      }
	      if (users.removed.length > 0) {
	        var _i18n2 = '<b><span class="icon-user"></span> ' + this.i18n[this.locale]['removed_user'] + '</b>';
	        var _userNames = users.removed.map(function (obj) {
	          return obj.name;
	        }).join(', ');
	        text = text + _i18n2 + ' ' + _userNames;
	      }
	      if (klasses.added.length > 0) {
	        var _i18n3 = '<b><span class="icon-calendar4"></span> ' + this.i18n[this.locale]['added_grade'] + '</b>';
	        var _names = klasses.added.map(function (obj) {
	          return obj.name;
	        }).join(', ');
	        text = _i18n3 + ' ' + _names + '<br>';
	      }
	      if (klasses.removed.length > 0) {
	        var _i18n4 = '<b><span class="icon-calendar4"></span> ' + this.i18n[this.locale]['removed_grade'] + '</b>';
	        var _names2 = klasses.removed.map(function (obj) {
	          return obj.name;
	        }).join(', ');
	        text = text + _i18n4 + ' ' + _names2 + '<br>';
	      }
	      if (subs.added.length > 0) {
	        var _i18n5 = '<b><span class="icon-users"></span> ' + this.i18n[this.locale]['added_sub'] + '</b>';
	        var _userNames2 = subs.added.map(function (obj) {
	          return obj.name;
	        }).join(', ');
	        text = text + _i18n5 + ' ' + _userNames2 + '<br>';
	      }
	      if (subs.removed.length > 0) {
	        var _i18n6 = '<b><span class="icon-users"></span> ' + this.i18n[this.locale]['removed_sub'] + '</b>';
	        var _userNames3 = subs.removed.map(function (obj) {
	          return obj.name;
	        }).join(', ');
	        text = text + _i18n6 + ' ' + _userNames3;
	      }
	      return text;
	    },
	    changeLearningGoalNotes: function changeLearningGoalNotes(changes) {
	      var txt = '<b><span class="icon-pencil"></span>' + this.i18n[this.locale]['learning_goal_changed'] + '</b>';
	      var from = changes.learning_goal.from.length < 1 ? '' : changes.learning_goal.from;
	      var to = changes.learning_goal.to;
	      return '<b>' + txt + '</b><div>' + from + ' <span><b>&#8594;</b></span> ' + to + '</div>';
	    },
	    changeDescNotes: function changeDescNotes(changes) {
	      var txt = '<b><span class="icon-pencil"></span>' + this.i18n[this.locale]['content_changed'] + '</b>';
	      var from = changes.description.from.length < 1 ? '' : changes.description.from;
	      var to = changes.description.to;
	      return '<b>' + txt + '</b><div>' + from + ' <span><b>&#8594;</b></span> ' + to + '</div>';
	    },
	    changeTeacherNotes: function changeTeacherNotes(changes) {
	      var txt = '<b><span class="icon-pencil"></span>' + this.i18n[this.locale]['teacher_notes_changed'] + '</b>';
	      var from = changes.teacher_notes.from.length < 1 ? '' : changes.teacher_notes.from;
	      var to = changes.teacher_notes.to;
	      return '<b>' + txt + '</b><div>' + from + ' <span><b>&#8594;</b></span> ' + to + '</div>';
	    },
	    changeNotesForStudents: function changeNotesForStudents(changes) {
	      var txt = '<b><span class="icon-pencil"></span> ' + this.i18n[this.locale]['notes_for_students_changed'] + '</b>';
	      var from = changes.notes_for_students.from.length < 1 ? '' : changes.notes_for_students.from;
	      var to = changes.notes_for_students.to;
	      return '<b>' + txt + '</b><div>' + from + ' <span><b>&#8594;</b></span> ' + to + '</div>';
	    },
	    changeTime: function changeTime(changes) {
	      var txt = '<b><span class="icon-clock"></span> ' + this.i18n[this.locale]['changed_time'] + '</b>';
	      var oldStartTime = (0, _moment2.default)(changes.start.start.from).format('dddd LT');
	      var newStartTime = (0, _moment2.default)(changes.start.start.to).format('dddd LT');
	      var oldEndTime = (0, _moment2.default)(changes.end.end.from).format('LT');
	      var newEndTime = (0, _moment2.default)(changes.end.end.to).format('LT');
	      return '<b>' + txt + '</b><br>' + oldStartTime + ' - ' + oldEndTime + ' <span><b>&#8594;</b></span>  ' + newStartTime + ' - ' + newEndTime;
	    },
	    changeStart: function changeStart(changes) {
	      var txt = '<b><span class="icon-clock"></span> Ændrede start</b>';
	      var oldStartTime = (0, _moment2.default)(changes.start.from).format('dddd LT');
	      var newStartTime = (0, _moment2.default)(changes.start.to).format('dddd LT');
	      return '<b>' + txt + '</b> Fra ' + oldStartTime + ' til ' + newStartTime;
	    },
	    changeEnd: function changeEnd(changes) {
	      var txt = '<b><span class="icon-clock"></span> Ændrede slut</b>';
	      var oldEndTime = (0, _moment2.default)(changes.end.from).format('dddd LT');
	      var newEndTime = (0, _moment2.default)(changes.end.to).format('dddd LT');
	      return '<b>' + txt + '</b> Fra ' + oldEndTime + ' til ' + newEndTime;
	    },
	    humanizeChanges: function humanizeChanges(lessonChanges) {
	      var txt = [];
	      if (lessonChanges) {
	        for (var i = 0; i < lessonChanges.length; i++) {
	          switch ((0, _keys2.default)(lessonChanges[i])[0]) {
	            case 'learning_goal':
	              txt.push(this.changeLearningGoalNotes(lessonChanges[i]));
	              break;
	            case 'description':
	              txt.push(this.changeDescNotes(lessonChanges[i]));
	              break;
	            case 'teacher_notes':
	              txt.push(this.changeTeacherNotes(lessonChanges[i]));
	              break;
	            case 'notes_for_students':
	              txt.push(this.changeNotesForStudents(lessonChanges[i]));
	              break;
	            case 'calendars':
	              txt.push(this.changeCalendars(lessonChanges[i]));
	              break;
	            case 'start':
	              if (lessonChanges[i + 1] && lessonChanges[i + 1].end) {
	                txt.push(this.changeTime({ start: lessonChanges[i], end: lessonChanges[i + 1] }));
	              } else {
	                txt.push(this.changeStart(lessonChanges[i]));
	              }
	              break;
	            case 'end':
	              if (lessonChanges[i - 1] && lessonChanges[i - 1].start) {
	                break;
	              } else {
	                txt.push(this.changeEnd(lessonChanges[i]));
	              }
	              break;
	            default:
	              txt.push('Changed something');
	          }
	        }
	      }
	      return txt;
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    var schoolId = window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id : this.event.school_id;
	    _docendo2.default.eventChanges(schoolId, this.eventId, function (data) {
	      _this2.isLoading = false;
	      _this2.changes = data && data.length > 0 ? JSON.parse(data) : [];
	    });
	  }
	};

/***/ }),
/* 584 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'login',
	  created: function created() {
	    this.$on('docendo_state', function (data) {
	      if (data === 'connected') {
	        this.connected();
	      } else if (data === 'disconnected') {
	        this.disconnected();
	      }
	    });
	  },
	  methods: {
	    connected: function connected() {},
	    disconnected: function disconnected() {},
	    login: function login() {
	      var location = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	      console.log(location);
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(32);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _vueClickaway = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    show: {
	      type: Boolean,
	      default: false
	    },
	
	    close_on_click_away: {
	      type: Boolean,
	      default: false
	    },
	    modal_from_bottom: {
	      type: Boolean,
	      default: false
	    },
	    show_modal_mask: {
	      type: Boolean,
	      default: true
	    },
	
	    ariaLabel: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {};
	  },
	
	  watch: {
	    show: function show() {
	      var body = document.querySelector('body');
	      if (this.show === true) {
	        body.classList.add('no-scroll');
	        this.activateA11y();
	      } else {
	        this.deactivateA11y();
	        this.removeModal();
	      }
	    }
	  },
	  methods: {
	    setShowModal: function setShowModal() {
	      this.show = true;
	    },
	    removeModal: function removeModal() {
	      var body = document.querySelector('body');
	      this.show = false;
	      this.$emit('close');
	      body.classList.remove('no-scroll');
	    },
	    clickAway: function clickAway() {
	      this.close_on_click_away ? this.removeModal() : null;
	    },
	    getFocusable: function getFocusable() {
	      var root = this.$refs.modalContent;
	      if (!root) return [];
	      var selector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
	      return (0, _from2.default)(root.querySelectorAll(selector)).filter(function (el) {
	        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
	      });
	    },
	    focusInitial: function focusInitial() {
	      var root = this.$refs.modalContent;
	      if (!root) return;
	      if (root.contains(document.activeElement) && document.activeElement !== root) {
	        return;
	      }
	      var focusable = this.getFocusable();
	      var field = focusable.find(function (el) {
	        return (/^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName)
	        );
	      });
	      var target = field || focusable[0] || root;
	      target.focus();
	    },
	    handleKeydown: function handleKeydown(event) {
	      if (event.key === 'Escape') {
	        this.removeModal();
	        return;
	      }
	
	      if (event.key === 'Tab') {
	        var root = this.$refs.modalContent;
	        if (!root) return;
	        var focusable = this.getFocusable();
	        if (focusable.length === 0) {
	          event.preventDefault();
	          root.focus();
	          return;
	        }
	        var first = focusable[0];
	        var last = focusable[focusable.length - 1];
	        if (!root.contains(document.activeElement)) {
	          event.preventDefault();
	          first.focus();
	        } else if (event.shiftKey && document.activeElement === first) {
	          event.preventDefault();
	          last.focus();
	        } else if (!event.shiftKey && document.activeElement === last) {
	          event.preventDefault();
	          first.focus();
	        }
	      }
	    },
	    activateA11y: function activateA11y() {
	      var _this = this;
	
	      window.addEventListener('keydown', this.handleKeydown);
	      this.$nextTick(function () {
	        _this.focusInitial();
	      });
	    },
	    deactivateA11y: function deactivateA11y() {
	      window.removeEventListener('keydown', this.handleKeydown);
	    }
	  },
	  mounted: function mounted() {
	    if (this.show) {
	      this.activateA11y();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('keydown', this.handleKeydown);
	  }
	};

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(32);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    are_you_sure: 'Er du sikker på, at du vil slette denne?',
	    are_you_sure_own_calendar: 'Er du sikker på, at du vil slette denne brik? Det vil kun gælde for denne kalender og kan ikke fortrydes. Venligst bekræft, hvis du ønsker at fortsætte.',
	    delete: 'Slet',
	    cancel: 'Annuller',
	    dont_ask_me_again: 'Spørg mig ikke igen'
	  },
	  nb: {
	    are_you_sure: 'Er du sikker på at du vil slette dette?',
	    are_you_sure_own_calendar: 'Er du sikker på at du vil slette dette? Dette vil kun gjelde for denne kalenderen og kan ikke reverseres. Vennligst bekreft at du ønsker å fortsette.',
	    delete: 'Slett',
	    cancel: 'Avbryt',
	    dont_ask_me_again: 'Ikke spør meg igjen'
	  },
	  en: {
	    are_you_sure: 'Are you sure that you want to delete this?',
	    are_you_sure_own_calendar: 'Are you sure you want to delete this? This will only apply to this calendar and cannot be undone. Please confirm if you wish to proceed.',
	    delete: 'Delete',
	    cancel: 'Cancel',
	    dont_ask_me_again: 'Don\'t ask me again'
	  }
	};
	
	var confirmModalStack = [];
	
	exports.default = {
	  props: {
	    showClose: {
	      type: Boolean,
	      default: true
	    },
	    appendToBody: {
	      type: Boolean,
	      default: false
	    },
	    ariaLabel: {
	      type: String,
	      default: ''
	    },
	    isOnlyOwnCalendarText: {
	      type: Boolean,
	      default: false
	    },
	    isSubmitButtonLoading: {
	      type: Boolean,
	      default: false
	    },
	    isShowDontAskAgain: {
	      type: Boolean,
	      default: false
	    },
	    propLocale: {
	      default: null
	    },
	    isShowConfirmDeleteMessage: {
	      type: Boolean,
	      default: true
	    },
	    customWidth: {
	      default: '350px'
	    },
	    noMarginOnButton: {
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isDontAskAgain: false
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return !this.propLocale ? I18N[this.locale] : I18N[this.propLocale];
	    }
	  },
	  methods: {
	    onConfirm: function onConfirm() {
	      this.$emit('confirm', this.isDontAskAgain);
	    },
	    getFocusable: function getFocusable() {
	      var root = this.$refs.modalContent;
	      if (!root) return [];
	      var selector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
	      return (0, _from2.default)(root.querySelectorAll(selector)).filter(function (el) {
	        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
	      });
	    },
	    handleKeydown: function handleKeydown(event) {
	      if (confirmModalStack[confirmModalStack.length - 1] !== this) return;
	      if (event.key === 'Escape') {
	        this.$emit('close');
	        return;
	      }
	
	      if (event.key === 'Tab') {
	        var root = this.$refs.modalContent;
	        if (!root) return;
	        var focusable = this.getFocusable();
	        if (focusable.length === 0) {
	          event.preventDefault();
	          root.focus();
	          return;
	        }
	        var first = focusable[0];
	        var last = focusable[focusable.length - 1];
	        if (!root.contains(document.activeElement)) {
	          event.preventDefault();
	          first.focus();
	        } else if (event.shiftKey && document.activeElement === first) {
	          event.preventDefault();
	          last.focus();
	        } else if (!event.shiftKey && document.activeElement === last) {
	          event.preventDefault();
	          first.focus();
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    confirmModalStack.push(this);
	    window.addEventListener('keydown', this.handleKeydown);
	
	    this.$nextTick(function (_) {
	      var el = _this.$refs.submit_bttn;
	      if (el) {
	        _this.$refs.submit_bttn.focus();
	      } else {
	        var focusable = _this.getFocusable();
	        if (focusable.length > 0) {
	          focusable[0].focus();
	        } else if (_this.$refs.modalContent) {
	          _this.$refs.modalContent.focus();
	        }
	      }
	    });
	    if (this.appendToBody) {
	      var el = this.$refs.d_modal;
	      var bod = document.getElementById('djs-content-container');
	      if (bod) {
	        bod.appendChild(el);
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    var idx = confirmModalStack.indexOf(this);
	    if (idx > -1) {
	      confirmModalStack.splice(idx, 1);
	    }
	    window.removeEventListener('keydown', this.handleKeydown);
	    var el = this.$refs.d_modal;
	    if (el) {
	      el.remove();
	    }
	  }
	};

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default },
	  mixins: [_vueClickaway.mixin],
	  data: function data() {
	    return {
	      onlyUnreadMessagesActive: false,
	      show: false,
	      messages: [],
	      unReadCounter: '',
	      lastId: '',
	      isAllLoaded: false,
	      isInitialLoad: true
	    };
	  },
	
	  methods: {
	    handleScrolledToBottom: function handleScrolledToBottom(isVisible) {
	      if (!isVisible) {
	        return;
	      }
	      this.getMessagesBefore(this.lastId);
	    },
	    close: function close() {
	      this.show = false;
	      this.messages = [];
	    },
	    open: function open() {
	      this.show = true;
	      this.getMessages();
	    },
	    toggle: function toggle(e) {
	      if (e.target.classList.contains('js-toggle-notifications')) {
	        if (!this.show) {
	          this.open();
	        } else {
	          this.close();
	        }
	      }
	    },
	    getMessages: function getMessages() {
	      this.isInitialLoad = true;
	      this.onlyUnreadMessagesActive = false;
	      _docendo2.default.getNotificationsList(5, this.receiveMessages);
	    },
	    getMessagesUnread: function getMessagesUnread() {
	      this.onlyUnreadMessagesActive = true;
	      _docendo2.default.getNotificationsListUnread(5, true, this.receiveMessages);
	    },
	    getMessagesBefore: function getMessagesBefore(id) {
	      if (!this.onlyUnreadMessagesActive) {
	        _docendo2.default.getNotificationsBefore(5, id, this.pushMessages);
	      } else {
	        _docendo2.default.getNotificationsUnreadBeforeId(5, true, id, this.pushMessages);
	      }
	    },
	    receiveMessages: function receiveMessages(messages) {
	      this.messages = messages;
	      this.isAllLoaded = false;
	      this.isInitialLoad = false;
	
	      if (messages < 1) {
	        this.isAllLoaded = true;
	        return;
	      }
	      this.lastId = messages[messages.length - 1].id;
	    },
	    pushMessages: function pushMessages(messages) {
	      if (messages < 1) {
	        this.isAllLoaded = true;
	        return;
	      }
	      this.lastId = messages[messages.length - 1].id;
	      this.messages = this.messages.concat(messages);
	    },
	    readStatusRead: function readStatusRead(e, index, id, read) {
	      if (this.messages[index].read === false) {
	        this.unReadCounter === 0 ? this.unReadCounter = '' : this.unReadCounter = this.unReadCounter - 1;
	      }
	      this.messages[index].read = true;
	      _docendo2.default.updateNotification(id, { read: read }, this.updateMessage);
	    },
	    changeReadStatus: function changeReadStatus(e, index, id, read) {
	      var _this = this;
	
	      e.preventDefault();
	      read === true ? this.unReadCounter = this.unReadCounter - 1 : this.unReadCounter++;
	
	      this.messages[index].read = !this.messages[index].read;
	      _docendo2.default.updateNotification(id, { read: read }, function (data) {
	        _this.updateMessage(data);
	      });
	    },
	    updateMessage: function updateMessage(data) {
	      console.log('updateMessage', data);
	    },
	    markAllAsRead: function markAllAsRead() {
	      for (var i = 0; i < this.messages.length; i++) {
	        this.messages[i].read = true;
	      }
	      this.unReadCounter = 0;
	      _docendo2.default.markAllNotificationsAsRead();
	    },
	    unreadCount: function unreadCount() {
	      _docendo2.default.notificationsUnreadCount(this.updateUnreadCount);
	    },
	    updateUnreadCount: function updateUnreadCount(count) {
	      count >= 1 ? this.unReadCounter = count : this.unReadCounter = '';
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.unreadCount();
	    _docendo2.default.bind('new_notification', function (data) {
	      _this2.unreadCount();
	    });
	  }
	};

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _PermissionsUserChange = __webpack_require__(364);
	
	var _PermissionsUserChange2 = _interopRequireDefault(_PermissionsUserChange);
	
	var _PermissionsUser = __webpack_require__(1525);
	
	var _PermissionsUser2 = _interopRequireDefault(_PermissionsUser);
	
	var _vueVirtualScrollList = __webpack_require__(423);
	
	var _vueVirtualScrollList2 = _interopRequireDefault(_vueVirtualScrollList);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  en: {
	    administrator: 'Administrator',
	    read_only_user: 'Read only user',
	    regular_user: 'Regular user',
	    selected: 'selected',
	    unselect_all: 'Unselect all',
	    select_all: 'Select all'
	  },
	  da: {
	    administrator: 'Administrator',
	    read_only_user: 'Skrivebeskyttet bruger',
	    regular_user: 'Normal bruger',
	    selected: 'valgt',
	    unselect_all: 'Fravælg alle',
	    select_all: 'Vælg alle'
	  },
	  nb: {
	    administrator: 'Administrator',
	    read_only_user: 'Lesetilgang',
	    regular_user: 'Vanlig bruker',
	    selected: 'valgt',
	    unselect_all: 'Fravælg alle',
	    select_all: 'Vælg alle'
	  }
	};
	exports.default = {
	  components: {
	    Loader: _Loader2.default,
	    DModal: _DModal2.default, DDropdown: _DDropdown2.default, AppToggle: _AppToggle2.default, DSelect: _DSelect2.default, PermissionsUserChange: _PermissionsUserChange2.default, PermissionsUser: _PermissionsUser2.default, virtualList: _vueVirtualScrollList2.default
	  },
	  data: function data() {
	    return {
	      itemComponent: _PermissionsUser2.default,
	      permissions: [],
	      roles: [],
	      isLoadingRoles: true,
	      users: [],
	      activeRoleId: null,
	      isRoleModal: false,
	      createNewRoleName: '',
	      theEditRole: null,
	      theDeleteRole: null,
	      existingRoleToCopyId: null,
	      isSavingWithoutInput: false,
	      debounceTimer: null,
	      selectedUsers: []
	    };
	  },
	
	  computed: {
	    isInputFieldLength: function isInputFieldLength() {
	      return this.createNewRoleName.length > 0;
	    },
	    schoolId: function schoolId() {
	      if (this.$route && this.$route.params && this.$route.params.school_id) {
	        return this.$route.params.school_id;
	      }
	      return this.$store.getters.schoolId;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    isKindergarten: function isKindergarten() {
	      return this.$store.getters.isKindergarten;
	    },
	    rolesWithMeta: function rolesWithMeta() {
	      var rolesMap = {
	        'Read only user': { v_title: I18N[this.locale].read_only_user, v_sort: 3 },
	        'Regular user': { v_title: I18N[this.locale].regular_user, v_sort: 2 },
	        'Administrator': { v_title: I18N[this.locale].administrator, v_sort: 1 }
	      };
	
	      var roles = this.roles.map(function (role) {
	        var vRoleType = role.permissions.includes('can_manage_users') ? 'admin' : role.permissions.includes('can_do_most_stuff') ? 'normalUser' : 'readOnly';
	
	        return (0, _extends3.default)({}, role, rolesMap[role.name] || { v_title: role.name }, {
	          vRoleType: vRoleType
	        });
	      });
	
	      var sortedRoles = roles.sort(function (a, b) {
	        if (a.v_sort && b.v_sort) {
	          return a.v_sort - b.v_sort;
	        } else if (a.v_sort) {
	          return -1;
	        } else if (b.v_sort) {
	          return 1;
	        } else {
	          return a.v_title.localeCompare(b.v_title);
	        }
	      });
	
	      return sortedRoles;
	    },
	    rolesToCopy: function rolesToCopy() {
	      return this.rolesWithMeta.filter(function (role) {
	        return role.vRoleType !== 'admin';
	      });
	    },
	    activeRole: function activeRole() {
	      var _this = this;
	
	      var idx = this.roles.findIndex(function (role) {
	        return role.id === _this.activeRoleId;
	      });
	      return this.roles[idx];
	    },
	    usersWithActiveRole: function usersWithActiveRole() {
	      var _this2 = this;
	
	      if (!this.activeRole) {
	        return [];
	      }
	      var users = this.activeRole.user_ids.map(function (userId) {
	        return _this2.allUsersInHash[userId];
	      });
	      users = users.filter(function (user) {
	        return user.name;
	      });
	      return this.$helpers.sortArrOnName(users);
	    },
	    allUsersSortedByName: function allUsersSortedByName() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    usersForDSelect: function usersForDSelect() {
	      var _this3 = this;
	
	      return this.activeRole ? this.allUsersSortedByName.filter(function (user) {
	        return _this3.activeRole.user_ids.indexOf(user.id) < 0;
	      }) : this.allUsersSortedByName;
	    },
	    selectableRoles: function selectableRoles() {
	      var _this4 = this;
	
	      return this.rolesWithMeta.filter(function (role) {
	        return role.id !== _this4.activeRole.id;
	      });
	    },
	    activeChangeRoleUserId: function activeChangeRoleUserId() {
	      return _eventbus2.default.activeChangeRoleId;
	    },
	    activePermissions: function activePermissions() {
	      var _this5 = this;
	
	      var normalUserPermissions = ['can_see_other_subject_requests', 'can_edit_subject_requests', 'can_edit_user_year_notes', 'can_change_substitution', 'can_send_substitute_sms', 'can_edit_own_presence', 'can_edit_others_presence', 'can_see_subjects_distribution_page', 'can_manage_assigned_hours', 'can_see_assigned_hours', 'can_manage_calendars', 'can_manage_absence_reasons', 'can_see_own_task_overview', 'can_see_others_task_overviews', 'can_change_task_overview', 'can_see_own_hour_overview', 'can_see_others_hour_overviews', 'can_manage_tasks', 'can_request_absence', 'can_handle_absence_requests'].filter(function (permission) {
	        return !(_this5.isKindergarten && permission === 'can_see_subjects_distribution_page') && !(_this5.locale === 'en' && permission === 'can_send_substitute_sms');
	      });
	
	      var readOnlyUserPermissions = ['can_see_other_subject_requests', 'can_edit_subject_requests', 'can_edit_own_notes', 'can_see_other_calendars', 'can_see_own_task_overview', 'can_see_others_task_overviews', 'can_change_task_overview', 'can_see_own_hour_overview', 'can_see_others_hour_overviews', 'can_edit_own_presence', 'can_request_absence'];
	
	      if (!this.activeRole) {
	        return [];
	      }
	
	      var filteredPermissions = [];
	      var isNormalUser = this.activeRole.permissions.includes('can_do_most_stuff');
	
	      switch (this.activeRole.name) {
	        case 'Read only user':
	          filteredPermissions = this.permissions.filter(function (permission) {
	            return readOnlyUserPermissions.includes(permission);
	          });
	          break;
	        case 'Regular user':
	          filteredPermissions = this.permissions.filter(function (permission) {
	            return normalUserPermissions.includes(permission);
	          });
	          break;
	        case 'Administrator':
	          filteredPermissions = [];
	          break;
	        default:
	          if (isNormalUser) {
	            filteredPermissions = this.permissions.filter(function (permission) {
	              return normalUserPermissions.includes(permission);
	            });
	          } else {
	            filteredPermissions = this.permissions.filter(function (permission) {
	              return readOnlyUserPermissions.includes(permission);
	            });
	          }
	      }
	
	      return filteredPermissions.map(function (permission) {
	        return {
	          permission: permission,
	          vTitle: _this5.$t('vue2.permissions.' + permission) || permission
	        };
	      }).sort(function (a, b) {
	        return a.vTitle.localeCompare(b.vTitle);
	      });
	    },
	    getRoleDesc: function getRoleDesc() {
	      if (!this.activeRole) {
	        return '';
	      }
	      switch (this.activeRole.name) {
	        case 'Administrator':
	          return this.$t('vue2.permissions.role_desc_administrator');
	        case 'Read only user':
	          return this.$t('vue2.permissions.role_desc_read_only_user');
	        case 'Regular user':
	          return this.$t('vue2.permissions.role_desc_regular_user');
	        default:
	          return '';
	      }
	    },
	    areAllUsersSelected: function areAllUsersSelected() {
	      var _this6 = this;
	
	      if (this.usersWithActiveRole.length === 0) {
	        return false;
	      }
	      return this.usersWithActiveRole.every(function (user) {
	        return _this6.selectedUsers.some(function (selectedUser) {
	          return selectedUser.id === user.id;
	        });
	      });
	    }
	  },
	  methods: {
	    onInput: function onInput(evt) {
	      var _this7 = this;
	
	      var val = evt.target.value;
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        _this7.createNewRoleName = val;
	      }, 0);
	    },
	    getIsPermissioni18n: function getIsPermissioni18n(permission) {
	      if (!this.isKindergarten) {
	        return false;
	      }
	      var kindergartenI18N = {
	        can_see_others_task_overviews: 'Kan se andres årsnormsoversigt',
	        can_see_own_task_overview: 'Kan se egen årsnormsoversigt'
	      };
	      return kindergartenI18N[permission];
	    },
	    readPermissions: function readPermissions() {
	      var _this8 = this;
	
	      _docendo2.default.permissionSetsPermissions(this.schoolId, function (data) {
	        _this8.permissions = data;
	      }, function (failure) {
	        console.log('something went wrong', failure);
	      });
	    },
	    readPermissionSets: function readPermissionSets() {
	      var _this9 = this;
	
	      this.isLoadingRoles = true;
	      _docendo2.default.permissionSetsRead(this.schoolId, function (data) {
	        _this9.roles = data.sort(function (a, b) {
	          return a.name.localeCompare(b.name);
	        });
	        _this9.isLoadingRoles = false;
	        if (_this9.roles[0]) {
	          _this9.setActiveRole(_this9.roles[0]);
	        }
	      }, function (failure) {
	        console.log('something went wrong', failure);
	        _this9.isLoadingRoles = false;
	      });
	    },
	    createNewRole: function createNewRole() {
	      var _this10 = this;
	
	      var existingRole = this.rolesToCopy.find(function (role) {
	        return Number(role.id) === Number(_this10.existingRoleToCopyId);
	      });
	      var permissions = [];
	      if (existingRole) {
	        console.log('existingRole', existingRole);
	        permissions = existingRole.permissions;
	      }
	      this.isLoadingRoles = true;
	      _docendo2.default.permissionSetsCreate(this.schoolId, this.createNewRoleName, permissions, function (data) {
	        _eventbus2.default.toast = { text: _this10.$t('vue2.permissions.role_created'), 'success': true };
	        _this10.roles.push(data);
	        _this10.isLoadingRoles = false;
	        _this10.setActiveRole(data);
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this10.$t('vue2.toast.something_went_wrong'), 'success': false };
	        _this10.isLoadingRoles = false;
	      });
	      this.isRoleModal = false;
	      this.resetCreateRoleForm();
	    },
	    updateRoleName: function updateRoleName() {
	      var _this11 = this;
	
	      var idx = this.roles.findIndex(function (role) {
	        return role.id === _this11.theEditRole.id;
	      });
	      _docendo2.default.permissionSetsUpdate(this.schoolId, this.theEditRole.id, this.createNewRoleName, this.theEditRole.permissions, function (data) {
	        _eventbus2.default.toast = { text: _this11.$t('vue2.permissions.role_updated'), 'success': true };
	        _this11.$set(_this11.roles, idx, data);
	        _this11.setActiveRole(data);
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this11.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	      this.resetCreateRoleForm();
	      this.isRoleModal = false;
	    },
	    resetCreateRoleForm: function resetCreateRoleForm() {
	      this.isSavingWithoutInput = false;
	      this.theEditRole = null;
	      this.createNewRoleName = '';
	      var defaultRole = this.rolesToCopy.find(function (role) {
	        return role.name === 'Read only user';
	      });
	      this.existingRoleToCopyId = defaultRole ? defaultRole.id : null;
	    },
	    setTheDeleteRole: function setTheDeleteRole(role) {
	      this.theDeleteRole = role;
	      this.setIsRoleModal(true);
	    },
	    deleteRole: function deleteRole() {
	      var _this12 = this;
	
	      _docendo2.default.permissionSetsDelete(this.schoolId, this.theDeleteRole.id, function (success) {
	        _eventbus2.default.toast = { text: _this12.$t('vue2.permissions.role_deleted'), 'success': true };
	        var idx = _this12.roles.findIndex(function (role) {
	          return role.id === _this12.theDeleteRole.id;
	        });
	        _this12.roles.splice(idx, 1);
	        _this12.theDeleteRole = null;
	        _this12.setIsRoleModal(false);
	        _this12.setActiveRole(_this12.roles[0]);
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this12.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    togglePermissionToRole: function togglePermissionToRole(permission) {
	      var _this13 = this;
	
	      var rolePermissions = this.activeRole.permissions;
	      var rolePermissionIdx = rolePermissions.indexOf(permission);
	      if (rolePermissionIdx < 0) {
	        rolePermissions.push(permission);
	      } else {
	        rolePermissions.splice(rolePermissionIdx, 1);
	      }
	      _docendo2.default.permissionSetsUpdate(this.schoolId, this.activeRole.id, this.activeRole.name, rolePermissions, function (data) {
	        _eventbus2.default.toast = { text: _this13.$t('vue2.permissions.role_updated'), 'success': true };
	        var roleIdx = _this13.roles.findIndex(function (role) {
	          return role.id === data.id;
	        });
	        _this13.$set(_this13.roles, roleIdx, data);
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this13.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    isPermissionInActiveRole: function isPermissionInActiveRole(permission) {
	      return this.activeRole ? this.activeRole.permissions.indexOf(permission) > -1 : false;
	    },
	    setActiveRole: function setActiveRole(role) {
	      this.activeRoleId = role.id;
	
	      this.selectedUsers = [];
	    },
	    isActiveRole: function isActiveRole(role) {
	      if (!this.activeRole) {
	        return false;
	      }
	      return this.activeRole && this.activeRole.name === role.name;
	    },
	    onNoInput: function onNoInput() {
	      var _this14 = this;
	
	      this.isSavingWithoutInput = true;
	      setTimeout(function (_) {
	        _this14.isSavingWithoutInput = false;
	      }, 1500);
	      this.$refs.roleCreateInputField.focus();
	    },
	    setIsRoleModal: function setIsRoleModal(boolean) {
	      var _this15 = this;
	
	      if (boolean) {
	        this.isRoleModal = true;
	        setTimeout(function (_) {
	          if (_this15.$refs.roleCreateInputField) {
	            _this15.$refs.roleCreateInputField.focus();
	          }
	        }, 500);
	        var defaultRole = this.rolesToCopy.find(function (role) {
	          return role.name === 'Read only user';
	        });
	        this.existingRoleToCopyId = defaultRole ? defaultRole.id : null;
	      } else {
	        this.isRoleModal = false;
	        this.createNewRoleName = '';
	        this.theEditRole = null;
	        this.theDeleteRole = null;
	      }
	    },
	    setTheEditRole: function setTheEditRole(role) {
	      this.theEditRole = role;
	      this.createNewRoleName = role.name;
	      this.setIsRoleModal(true);
	    },
	    addUserToRole: function addUserToRole(user) {
	      var _this16 = this;
	
	      var userIds = [user.id];
	      var roleIdx = this.roles.findIndex(function (role) {
	        return role.id === _this16.activeRole.id;
	      });
	      _docendo2.default.schoolUsersAssignPermissionSet(window.SCHOOL.id, userIds, this.activeRole.id, function (success) {
	        _this16.removeFromAllRoles(user);
	        _this16.roles[roleIdx].user_ids.push(user.id);
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this16.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    setRole: function setRole(roleFromDropdown) {
	      var _this17 = this;
	
	      var user = {
	        name: '',
	        id: this.activeChangeRoleUserId
	      };
	      var userIds = [this.activeChangeRoleUserId];
	      var roleIdx = this.roles.findIndex(function (role) {
	        return role.id === roleFromDropdown.id;
	      });
	      _docendo2.default.schoolUsersAssignPermissionSet(window.SCHOOL.id, userIds, roleFromDropdown.id, function (success) {
	        _this17.roles[roleIdx].user_ids.push(_this17.activeChangeRoleUserId);
	        _this17.removeFromActiveRole(user);
	        _eventbus2.default.activeChangeRoleId = null;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this17.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    removeFromAllRoles: function removeFromAllRoles(user) {
	      var _this18 = this;
	
	      this.roles.forEach(function (role, idx) {
	        var userIdx = role.user_ids.indexOf(user.id);
	        if (userIdx > -1) {
	          _this18.roles[idx].user_ids.splice(userIdx, 1);
	        }
	      });
	    },
	    removeFromActiveRole: function removeFromActiveRole(user) {
	      var _this19 = this;
	
	      var roleIdx = this.roles.findIndex(function (role) {
	        return role.id === _this19.activeRoleId;
	      });
	      var userIdx = this.roles[roleIdx].user_ids.indexOf(user.id);
	      if (userIdx > -1) {
	        this.roles[roleIdx].user_ids.splice(userIdx, 1);
	      }
	    },
	    handleUserSelectionChanged: function handleUserSelectionChanged(event) {
	      var user = event.user,
	          selected = event.selected;
	
	      if (selected) {
	        var exists = this.selectedUsers.some(function (u) {
	          return u.id === user.id;
	        });
	        if (!exists) {
	          this.selectedUsers.push(user);
	        }
	      } else {
	        var index = this.selectedUsers.findIndex(function (u) {
	          return u.id === user.id;
	        });
	        if (index > -1) {
	          this.selectedUsers.splice(index, 1);
	        }
	      }
	    },
	    toggleSelectAll: function toggleSelectAll(event) {
	      var _this20 = this;
	
	      var shouldSelectAll = event.target.checked;
	      if (shouldSelectAll) {
	        this.usersWithActiveRole.forEach(function (user) {
	          var exists = _this20.selectedUsers.some(function (u) {
	            return u.id === user.id;
	          });
	          if (!exists) {
	            _this20.selectedUsers.push(user);
	          }
	        });
	      } else {
	        this.selectedUsers = this.selectedUsers.filter(function (user) {
	          return !_this20.usersWithActiveRole.some(function (roleUser) {
	            return roleUser.id === user.id;
	          });
	        });
	      }
	    },
	    addUserToRoleForMultipleUsers: function addUserToRoleForMultipleUsers(roleId) {
	      var _this21 = this;
	
	      if (!roleId) {
	        return;
	      }
	      var userIds = this.selectedUsers.map(function (user) {
	        return user.id;
	      });
	      _docendo2.default.schoolUsersAssignPermissionSet(window.SCHOOL.id, userIds, roleId, function (success) {
	        _this21.selectedUsers = [];
	        _this21.readAll();
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this21.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    readAll: function readAll() {
	      this.$store.dispatch('getUsers');
	      this.readPermissions();
	      this.readPermissionSets();
	    }
	  },
	  mounted: function mounted() {
	    this.readAll();
	  }
	};

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _PermissionsUserChange = __webpack_require__(364);
	
	var _PermissionsUserChange2 = _interopRequireDefault(_PermissionsUserChange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'item-component',
	  components: { PermissionsUserChange: _PermissionsUserChange2.default },
	  props: {
	    selectableRoles: {},
	    index: {
	      type: Number
	    },
	    source: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    selectedUsers: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    onUserSelectionChanged: {
	      type: Function,
	      default: null
	    }
	  },
	  computed: {
	    activeChangeId: function activeChangeId() {
	      return _eventbus2.default.activeChangeRoleId;
	    },
	    isSelected: function isSelected() {
	      var _this = this;
	
	      return this.selectedUsers.some(function (user) {
	        return user.id === _this.source.id;
	      });
	    }
	  },
	  methods: {
	    setChangeRole: function setChangeRole() {
	      if (_eventbus2.default.activeChangeRoleId === this.source.id) {
	        _eventbus2.default.activeChangeRoleId = null;
	      } else {
	        _eventbus2.default.activeChangeRoleId = this.source.id;
	      }
	    },
	    handleCheckboxChange: function handleCheckboxChange(event) {
	      if (this.onUserSelectionChanged) {
	        this.onUserSelectionChanged({
	          user: this.source,
	          selected: event.target.checked
	        });
	      }
	    },
	    toggleUserSelection: function toggleUserSelection() {
	      if (this.onUserSelectionChanged) {
	        this.onUserSelectionChanged({
	          user: this.source,
	          selected: !this.isSelected
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _core = __webpack_require__(25);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    roles: {
	      type: Array
	    }
	  },
	  data: function data() {
	    return {
	      isDropDown: false,
	      isDropdownPopperDone: false,
	      activeDiv: null
	    };
	  },
	
	  computed: {
	    activeChangeRoleId: function activeChangeRoleId() {
	      return _eventbus2.default.activeChangeRoleId;
	    }
	  },
	  watch: {
	    activeChangeRoleId: function activeChangeRoleId(val) {
	      var _this = this;
	
	      if (val) {
	        this.isDropdownPopperDone = false;
	        this.activeDiv = document.querySelector('.role-change__selector__placeholder[data-user-id="' + val + '"]');
	        this.isDropDown = true;
	        setTimeout(function (_) {
	          _this.createPopper();
	          _this.isDropdownPopperDone = true;
	        }, 0);
	      } else {
	        _eventbus2.default.activeChangeRoleId = null;
	        this.isDropDown = false;
	        this.isDropdownPopperDone = false;
	      }
	    }
	  },
	  methods: {
	    createPopper: function createPopper() {
	      (0, _core.createPopper)(this.activeDiv, this.$refs.role_child, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, 5]
	          }
	        }]
	      });
	    },
	    setRole: function setRole(role) {
	      this.$emit('set', role);
	      this.isDropDown = false;
	    },
	    setDropdown: function setDropdown() {
	      var _this2 = this;
	
	      if (this.isDropDown) {
	        _eventbus2.default.activeChangeRoleId = null;
	        this.isDropDown = false;
	        this.isDropdownPopperDone = false;
	      } else {
	        this.isDropDown = true;
	        setTimeout(function (_) {
	          _this2.createPopper();
	          _this2.isDropdownPopperDone = true;
	        }, 0);
	      }
	    },
	    setDropdownFromClick: function setDropdownFromClick(el) {
	      if (!this.isDropDown) {
	        return;
	      }
	      this.setDropdown();
	    }
	  }
	};

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _PresenceUser = __webpack_require__(82);
	
	var _PresenceUser2 = _interopRequireDefault(_PresenceUser);
	
	var _TaggingFilter = __webpack_require__(43);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DModal: _DModal2.default,
	    Loader: _Loader2.default,
	    TaggingFilter: _TaggingFilter2.default,
	    PresenceUser: _PresenceUser2.default
	  },
	  data: function data() {
	    return {
	      selectedIds: {},
	      selectedTags: [],
	      tags: [],
	      i18n: {
	        da: {
	          add_presence_to_many_user: 'Tildel arbejdstider til flere brugere',
	          of: 'af',
	          no_users_created: 'Ingen brugere oprettet'
	        },
	        en: {
	          add_presence_to_many_user: 'Add working hours to multiple users',
	          of: 'of',
	          no_users_created: 'No users created'
	        },
	        nb: {
	          add_presence_to_many_user: 'Legg inn arbeidstider for flere brukere',
	          of: 'av',
	          no_users_created: 'Ingen brukere opprettet'
	        }
	      }
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    firstDayOfWeek: function firstDayOfWeek() {
	      return this.$store.getters.firstDayOfWeek;
	    },
	    selectedIdsLength: function selectedIdsLength() {
	      return (0, _keys2.default)(this.selectedIds).length;
	    },
	    users: function users() {
	      return this.$store.getters.userCalendars;
	    },
	    usersFiltered: function usersFiltered() {
	      var _this = this;
	
	      if (this.selectedTags.length === 0) {
	        return this.users;
	      }
	      return this.users.filter(function (user) {
	        return _this.selectedTags.some(function (tag) {
	          return user.user_tags.includes(tag);
	        });
	      });
	    },
	    usersWithProps: function usersWithProps() {
	      var _this2 = this;
	
	      return this.usersFiltered.map(function (user) {
	        _this2.$set(user, 'v_isSelected', _this2.isUserSelected(user.id));
	        return user;
	      });
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    }
	  },
	  methods: {
	    isUserSelected: function isUserSelected(userId) {
	      return this.selectedIds[userId];
	    },
	    toggleUser: function toggleUser(userId) {
	      if (this.isUserSelected(userId)) {
	        this.$delete(this.selectedIds, userId);
	      } else {
	        this.$set(this.selectedIds, userId, true);
	      }
	    },
	    selectAll: function selectAll() {
	      var _this3 = this;
	
	      this.usersWithProps.forEach(function (user) {
	        _this3.$set(_this3.selectedIds, user.id, true);
	      });
	    },
	    unSelectAll: function unSelectAll() {
	      var _this4 = this;
	
	      this.usersWithProps.forEach(function (user) {
	        _this4.$delete(_this4.selectedIds, user.id);
	      });
	    },
	    getTags: function getTags() {
	      var _this5 = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this5.tags = data;
	      });
	    },
	    setTag: function setTag(tag) {
	      this.unSelectAll();
	      this.selectedTags.push(tag);
	    },
	    removeTag: function removeTag(tag) {
	      this.unSelectAll();
	      this.selectedTags.splice(this.selectedTags.indexOf(tag), 1);
	    },
	    savePresence: function savePresence(emitData) {
	      _eventbus2.default.toast = { text: this.$i18n.t('vue2.copycalendar.noticationMessage'), success: false };
	      emitData.calendarIds = (0, _keys2.default)(this.selectedIds);
	      console.log('emitData.eventsToCreate', emitData.eventsToCreate);
	      _docendo2.default.createPresenceForMany(this.schoolId, emitData.calendarIds, emitData.pasteInWeeks, emitData.eventsToCreate, function (success) {
	        console.log('success', success);
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	      this.unSelectAll();
	    },
	    close: function close() {
	      this.$emit('close');
	    }
	  },
	  mounted: function mounted() {
	    this.getTags();
	  }
	};

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(28);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _PresenceUserEditEvent = __webpack_require__(1527);
	
	var _PresenceUserEditEvent2 = _interopRequireDefault(_PresenceUserEditEvent);
	
	var _WeekPicker = __webpack_require__(1528);
	
	var _WeekPicker2 = _interopRequireDefault(_WeekPicker);
	
	var _Spinner = __webpack_require__(26);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _TimeChanger = __webpack_require__(31);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _CustomEvent = __webpack_require__(159);
	
	var _CustomEvent2 = _interopRequireDefault(_CustomEvent);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	
	var DEFAULT_START_HOUR = 8;
	var DEFAULT_START_MINUTES = 0;
	var DEFAULT_END_HOUR = 16;
	var DEFAULT_END_MINUTES = 0;
	
	exports.default = {
	  components: { EditEvent: _PresenceUserEditEvent2.default, WeekPicker: _WeekPicker2.default, Spinner: _Spinner2.default, DModal: _DModal2.default, TimeChanger: _TimeChanger2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    calid: {
	      type: Number
	    },
	    firstDayOfWeek: {
	      default: 1
	    },
	    activeCalendarDate: {
	      default: function _default() {
	        return moment().format('YYYY-MM-DD');
	      }
	    },
	    isModalLeft: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: true,
	      modal: false,
	      durations: [],
	      intersections: [],
	      events: [],
	      deletedEventIds: [],
	      pasteInWeeks: [],
	      showWeekSelector: false,
	      currentDateIsNotWithinCalendarRange: false,
	      isShowSettings: false,
	      ignoreClickaway: false,
	      standardStartTime: moment().set({ 'hour': DEFAULT_START_HOUR, 'minutes': DEFAULT_START_MINUTES }),
	      standardEndTime: moment().set({ 'hour': DEFAULT_END_HOUR, 'minutes': DEFAULT_END_MINUTES })
	    };
	  },
	
	  computed: {
	    user: function user() {
	      return this.$store.state.user;
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    isOwnCalendar: function isOwnCalendar() {
	      return this.user && this.user.user_calendar_id === this.calid;
	    },
	    userHasPermissionToEdit: function userHasPermissionToEdit() {
	      if (this.isOwnCalendar) {
	        return this.userHasPermission('can_edit_own_presence');
	      } else {
	        return this.userHasPermission('can_edit_others_presence');
	      }
	    },
	    weekDays: function weekDays() {
	      var days = [];
	
	      var start = this.firstDayOfWeek;
	      for (var i = 0; i < 7; i++) {
	        days.push(moment(this.activeCalendarDate).day(start));
	        start++;
	      }
	      return days;
	    },
	    totalDurationWeek: function totalDurationWeek() {
	      var arr = [];
	      this.events.forEach(function (event) {
	        arr.push(event.tempDuration);
	      });
	      return arr.reduce(function (a, b) {
	        return a + b;
	      }, 0);
	    },
	    eventsToCreate: function eventsToCreate() {
	      var arr = this.events.filter(function (event) {
	        return event.tempNew === true;
	      });
	      var newArr = [];
	      arr.forEach(function (obj) {
	        newArr.push({
	          calendar_id: obj.calendar_id,
	          start: obj.start,
	          end: obj.end
	        });
	      });
	      return newArr;
	    },
	    eventsToUpdate: function eventsToUpdate() {
	      var arr = this.events.filter(function (event) {
	        return event.toUpdate === true;
	      });
	      var newArr = [];
	      arr.forEach(function (obj) {
	        newArr.push({
	          id: obj.event_id,
	          calendar_id: obj.calendar_id,
	          start: obj.start,
	          end: obj.end
	        });
	      });
	      return newArr;
	    },
	    hasWeekendEvents: function hasWeekendEvents() {
	      return this.events.some(function (event) {
	        var startDate = moment(event.start);
	        var dayOfWeek = startDate.day();
	        return dayOfWeek === 0 || dayOfWeek === 6;
	      });
	    }
	  },
	  watch: {
	    events: function events() {
	      this.$emit('events', this.events);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.clearTimeout(this.ignoreClickawayTimeout);
	  },
	
	  methods: {
	    userHasPermission: function userHasPermission(val) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(val) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    setCurrentDateIsNotWithinCalendarRange: function setCurrentDateIsNotWithinCalendarRange(val) {
	      this.currentDateIsNotWithinCalendarRange = val;
	    },
	    durationAsHoursAndMin: function durationAsHoursAndMin(inMinutes) {
	      var hours = Math.floor(inMinutes / 60);
	      var minutes = inMinutes - hours * 60;
	      return hours + ' ' + this.$t('vue2.presence.hours') + ' ' + minutes + ' ' + this.$t('vue2.presence.minutes');
	    },
	    readCurrentEvents: function readCurrentEvents() {
	      this.getAllEvents();
	      this.cleanAllIntersections();
	      this.checkAllWithAllForIntersection();
	    },
	    open: function open() {
	      if (this.calid) {
	        this.readCurrentEvents();
	      } else {
	        this.isLoading = false;
	        this.events = [];
	      }
	      this.modal = true;
	      this.pasteInWeeks = [];
	    },
	    onPresenceClickaway: function onPresenceClickaway(ev) {
	      if (this.shouldIgnoreClickaway(ev)) {
	        return;
	      }
	      this.close();
	    },
	    shouldIgnoreClickaway: function shouldIgnoreClickaway(ev) {
	      if (this.isShowSettings || this.ignoreClickaway) {
	        return true;
	      }
	      var path = ev && (ev.path || ev.composedPath && ev.composedPath()) || [];
	      return path.some(function (el) {
	        return el.classList && (el.classList.contains('d-modal') || el.classList.contains('modal-wrapper') || el.classList.contains('bg-overlay'));
	      });
	    },
	    close: function close() {
	      if (this.shouldIgnoreClickaway()) {
	        return;
	      }
	      if (!this.modal) {
	        return;
	      }
	      this.$emit('close');
	      this.deletedEventIds = [];
	      this.modal = false;
	      this.showWeekSelector = false;
	      this.cleanAllIntersections();
	      if (this.calid) {
	        this.getAllEvents();
	      }
	    },
	    compareDates: function compareDates(firstDate, secondDate) {
	      return moment(firstDate).format('YYYY-MM-DD') === moment(secondDate).format('YYYY-MM-DD');
	    },
	    lastEventOfDayIsCloseToMidnight: function lastEventOfDayIsCloseToMidnight(weekDay) {
	      var _this = this;
	
	      var dayEvents = this.events.filter(function (event) {
	        return _this.compareDates(event.start, weekDay);
	      });
	      if (dayEvents.length > 1) {
	        var lastEventEnd = moment(dayEvents[dayEvents.length - 1].end).utc();
	        if (moment(lastEventEnd).local().format('HH') * 1 === 23 && moment(lastEventEnd).local().format('mm') * 1 > 49) {
	          return true;
	        }
	      }
	      return false;
	    },
	    addEvent: function addEvent(weekDay) {
	      var _this2 = this;
	
	      var start = void 0;
	      var end = void 0;
	      var dayEvents = this.events.filter(function (event) {
	        return _this2.compareDates(event.start, weekDay);
	      });
	      if (dayEvents.length < 1) {
	        var times = this.getDefaultTimes();
	        start = moment(weekDay).set({
	          'hour': times.startHour,
	          'minutes': times.startMinutes,
	          'seconds': 0,
	          'milliseconds': 0
	        });
	        end = moment(weekDay).set({
	          'hour': times.endHour,
	          'minutes': times.endMinutes,
	          'seconds': 0,
	          'milliseconds': 0
	        });
	      } else {
	        if (this.lastEventOfDayIsCloseToMidnight(weekDay)) {
	          return;
	        }
	        var lastEventEnd = moment(dayEvents[dayEvents.length - 1].end);
	        var add5Min = lastEventEnd.add(5, 'minutes');
	        start = moment(weekDay).set({
	          'hour': add5Min.format('HH'),
	          'minutes': add5Min.format('mm'),
	          'seconds': 0,
	          'milliseconds': 0
	        });
	        var add10Min = lastEventEnd.add(10, 'minutes');
	        end = moment(weekDay).set({
	          'hour': add10Min.format('HH'),
	          'minutes': add10Min.format('mm'),
	          'seconds': 0,
	          'milliseconds': 0
	        });
	      }
	      var event = {
	        calendar_id: this.calid,
	        start_time: start.utc().toISOString(),
	        end_time: end.utc().toISOString(),
	        start: start.utc().toISOString(),
	        end: end.utc().toISOString(),
	        rendering: 'background',
	        className: 'fc-bgevent__presence',
	        deleted: false,
	        tempId: Date.now(),
	        tempDuration: 0,
	        tempIntersect: false,
	        tempNew: true
	      };
	      this.events.push(event);
	      this.cleanAllIntersections();
	      this.checkAllWithAllForIntersection();
	    },
	    deleteEvent: function deleteEvent(presenceEvent) {
	      if (presenceEvent.event_id) {
	        this.deletedEventIds.push(presenceEvent.event_id);
	      }
	      var idx = this.events.findIndex(function (event) {
	        return event.tempId === presenceEvent.tempId;
	      });
	      this.events.splice(idx, 1);
	      this.cleanAllIntersections();
	      this.checkAllWithAllForIntersection();
	    },
	    updateStart: function updateStart(tempIdAndStarTime) {
	      var idx = this.events.findIndex(function (event) {
	        return event.tempId === tempIdAndStarTime.tempId;
	      });
	      this.events[idx].start = tempIdAndStarTime.startTime;
	      this.cleanAllIntersections();
	      this.checkAllWithAllForIntersection();
	    },
	    updateEnd: function updateEnd(tempIdAndEndTime) {
	      var idx = this.events.findIndex(function (event) {
	        return event.tempId === tempIdAndEndTime.tempId;
	      });
	      this.events[idx].end = tempIdAndEndTime.endTime;
	      this.cleanAllIntersections();
	      this.checkAllWithAllForIntersection();
	    },
	    setEventDurations: function setEventDurations(idAndDurationInMinutes) {
	      var idx = this.events.findIndex(function (event) {
	        return event.tempId === idAndDurationInMinutes.tempId;
	      });
	      this.events[idx].tempDuration = idAndDurationInMinutes.asMinutes;
	    },
	    cleanAllIntersections: function cleanAllIntersections() {
	      this.intersections = [];
	      for (var i = 0; i < this.events.length; i++) {
	        this.events[i].tempIntersect = false;
	      }
	    },
	    checkTwoDatesForIntersection: function checkTwoDatesForIntersection(idx1, idx2) {
	      var range1 = moment.range(this.events[idx1].start, this.events[idx1].end);
	      var range2 = moment.range(this.events[idx2].start, this.events[idx2].end);
	      if (range1.intersect(range2)) {
	        return true;
	      }
	    },
	    checkAllWithAllForIntersection: function checkAllWithAllForIntersection() {
	      for (var i = 0; i < this.events.length; i++) {
	        for (var j = 0; j < this.events.length; j++) {
	          if (i !== j) {
	            if (this.checkTwoDatesForIntersection(i, j)) {
	              this.events[i].tempIntersect = true;
	              this.intersections.push(this.events[j]);
	            }
	          }
	        }
	      }
	    },
	    setPastedWeeks: function setPastedWeeks(weekArray) {
	      this.pasteInWeeks = weekArray;
	    },
	    getAllEvents: function getAllEvents() {
	      var _this3 = this;
	
	      var start = moment(this.activeCalendarDate).day(this.firstDayOfWeek).startOf('day');
	
	      var end = moment(this.activeCalendarDate).day(this.firstDayOfWeek + 6).endOf('day');
	
	      this.isLoading = true;
	
	      _docendo2.default.calendarEvents2([this.calid], start, end, ['presence'], function (data) {
	        _this3.isLoading = false;
	        var events = data.length > 0 ? JSON.parse(data) : [];
	
	        var sortedEvents = events.filter(function (event) {
	          return event.event_type === 'presence';
	        }).sort(function (a, b) {
	          return new Date(a.start) - new Date(b.start);
	        });
	
	        var tempIdCounter = 0;
	
	        _this3.events = sortedEvents.map(function (event) {
	          return (0, _extends3.default)({}, event, {
	            rendering: 'background',
	            className: 'fc-bgevent__presence',
	            tempDuration: 0,
	            tempId: tempIdCounter++,
	            tempIntersect: false,
	            toUpdate: true
	          });
	        });
	      }, function (error) {
	        console.log(error);
	      });
	    },
	    savePresence: function savePresence() {
	      var _this4 = this;
	
	      if (this.calid) {
	        console.log('this.activeCalendarDate', this.activeCalendarDate);
	
	        var dbDate = moment(this.activeCalendarDate).day(this.firstDayOfWeek).format('YYYY-MM-DD');
	        console.log({ dbDate: dbDate });
	        _docendo2.default.bulkPresenceEvent(this.calid, this.eventsToCreate, this.eventsToUpdate, this.deletedEventIds, function (data) {
	          _this4.$emit('saved', data);
	
	          if (_this4.pasteInWeeks.length > 0) {
	            _eventbus2.default.toast = { text: _this4.$i18n.t('vue2.copycalendar.noticationMessage'), success: false };
	            _docendo2.default.calendarCopyWeeks(_this4.calid, dbDate, _this4.pasteInWeeks, true, 'presence', function (success) {});
	          }
	        });
	      } else {
	        var emitObj = {
	          eventsToCreate: this.eventsToCreate,
	          pasteInWeeks: this.pasteInWeeks
	        };
	        this.$emit('save', emitObj);
	      }
	      this.close(this.eventsToCreate);
	    },
	    getSavedTimesForCalendar: function getSavedTimesForCalendar(calid) {
	      if (!calid) {
	        return null;
	      }
	      var saved = this.userSettings && this.userSettings.presenceWorkHoursDefaultTimes;
	      if (!saved || (typeof saved === 'undefined' ? 'undefined' : (0, _typeof3.default)(saved)) !== 'object') {
	        return null;
	      }
	      var entry = saved[calid] || saved[String(calid)];
	      if (!entry || !entry.start || !entry.end) {
	        return null;
	      }
	      return entry;
	    },
	    getCalendarTimesMap: function getCalendarTimesMap() {
	      var saved = this.userSettings && this.userSettings.presenceWorkHoursDefaultTimes || {};
	      var map = {};
	      (0, _keys2.default)(saved).forEach(function (key) {
	        if (saved[key] && saved[key].start && saved[key].end) {
	          map[key] = saved[key];
	        }
	      });
	      return map;
	    },
	    getDefaultTimes: function getDefaultTimes() {
	      var fallback = {
	        startHour: DEFAULT_START_HOUR,
	        startMinutes: DEFAULT_START_MINUTES,
	        endHour: DEFAULT_END_HOUR,
	        endMinutes: DEFAULT_END_MINUTES
	      };
	      var saved = this.getSavedTimesForCalendar(this.calid);
	      if (!saved) {
	        return fallback;
	      }
	      var start = moment(saved.start);
	      var end = moment(saved.end);
	      if (!start.isValid() || !end.isValid()) {
	        return fallback;
	      }
	      return {
	        startHour: start.hour(),
	        startMinutes: start.minute(),
	        endHour: end.hour(),
	        endMinutes: end.minute()
	      };
	    },
	    openDefaultTimesSettings: function openDefaultTimesSettings() {
	      var times = this.getDefaultTimes();
	      this.standardStartTime = moment().set({ 'hour': times.startHour, 'minutes': times.startMinutes });
	      this.standardEndTime = moment().set({ 'hour': times.endHour, 'minutes': times.endMinutes });
	      this.isShowSettings = true;
	    },
	    closeDefaultTimesSettings: function closeDefaultTimesSettings() {
	      var _this5 = this;
	
	      this.ignoreClickaway = true;
	      this.isShowSettings = false;
	      window.clearTimeout(this.ignoreClickawayTimeout);
	      this.ignoreClickawayTimeout = window.setTimeout(function () {
	        _this5.ignoreClickaway = false;
	      }, 300);
	    },
	    setStandardStartTime: function setStandardStartTime(payload) {
	      this.standardStartTime = payload;
	    },
	    setStandardEndTime: function setStandardEndTime(payload) {
	      this.standardEndTime = payload;
	    },
	    submitStandardSettings: function submitStandardSettings() {
	      if (!this.calid) {
	        return;
	      }
	      var next = this.getCalendarTimesMap();
	      next[this.calid] = {
	        start: this.standardStartTime,
	        end: this.standardEndTime
	      };
	      this.$store.dispatch('updateUserSettings', {
	        presenceWorkHoursDefaultTimes: next
	      });
	      this.closeDefaultTimesSettings();
	    }
	  }
	};

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TimeChanger = __webpack_require__(31);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { timechanger: _TimeChanger2.default },
	  props: {
	    event: {
	      type: Object
	    }
	  },
	  data: function data() {
	    return {
	      isOn: true
	    };
	  },
	
	  computed: {
	    durationAsMinutes: function durationAsMinutes() {
	      var diff = (0, _moment2.default)(this.event.end).diff(this.event.start);
	      var asMinutes = _moment2.default.duration(diff).asMinutes();
	      this.$emit('duration', { tempId: this.event.tempId, asMinutes: asMinutes });
	      return asMinutes;
	    },
	    duration: function duration() {
	      var hours = Math.floor(this.durationAsMinutes / 60);
	      var minutes = this.durationAsMinutes - hours * 60;
	      return hours + this.$t('vue2.presence.h') + ' ' + minutes + this.$t('vue2.presence.m');
	    }
	  },
	  methods: {
	    updateStart: function updateStart(startTime) {
	      this.$emit('updateStart', { tempId: this.event.tempId, startTime: startTime });
	    },
	    updateEnd: function updateEnd(endTime) {
	      this.$emit('updateEnd', { tempId: this.event.tempId, endTime: endTime });
	    },
	    deleteEvent: function deleteEvent() {
	      this.$emit('delete', this.event);
	    },
	    setEventPresence: function setEventPresence(val) {
	      this.isOn = val;
	    }
	  }
	};

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SpinnerButton = __webpack_require__(154);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    calid: {
	      type: Number
	    },
	    date: {}
	  },
	  components: { spinner: _SpinnerButton2.default },
	  directives: {
	    tooltip: {
	      inserted: function inserted(el) {
	        var headerBottom = document.querySelector('.up-modal__header').getBoundingClientRect().bottom;
	        var elBottom = el.getBoundingClientRect().bottom;
	        var calc = elBottom - headerBottom;
	        if (calc < 100) {
	          el.classList.remove('hint--top');
	          el.classList.add('hint--bottom');
	        }
	      },
	      update: function update(el) {
	        var headerBottom = document.querySelector('.up-modal__header').getBoundingClientRect().bottom;
	        var elBottom = el.getBoundingClientRect().bottom;
	        var calc = elBottom - headerBottom;
	        if (calc < 100) {
	          el.classList.remove('hint--top');
	          el.classList.add('hint--bottom');
	        }
	      }
	    }
	  },
	  data: function data() {
	    return {
	      modal: false,
	      today: _eventbus2.default.now,
	      copyDate: _eventbus2.default.now,
	      selectedWeeks: [],
	      calStartDate: _eventbus2.default.now,
	      calEndDate: _eventbus2.default.now,
	      calCurrentDate: _eventbus2.default.now,
	      calType: '',
	      startPasteWeek: _eventbus2.default.now,
	      weeks: [],
	      deleteEvents: true
	    };
	  },
	
	  watch: {
	    selectedWeeks: function selectedWeeks() {
	      this.$emit('weeks', this.selectedWeeks);
	    }
	  },
	  computed: {
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    showStartPasteWeek: function showStartPasteWeek() {
	      return (0, _moment2.default)(this.startPasteWeek).isSame(this.calStartDate);
	    },
	    noneSelected: function noneSelected() {
	      return this.selectedWeeks.length === 0;
	    },
	    firstDayOfTheWeek: function firstDayOfTheWeek() {
	      var start = 1;
	      if (typeof window.SCHOOL.first_day_of_week_num !== 'undefined') {
	        start = window.SCHOOL.first_day_of_week_num;
	      }
	      return start;
	    }
	  },
	  filters: {
	    tooltipDate: function tooltipDate(date) {
	      var start = (0, _moment2.default)(date);
	      var start2 = (0, _moment2.default)(date).format('DD. MMM');
	      var startFormat = start.format('DD');
	      var end = (0, _moment2.default)(date).add(6, 'days');
	      var endFormat = (0, _moment2.default)(date).add(6, 'days').format('DD. MMM YYYY');
	
	      if ((0, _moment2.default)(start).format('MM') === (0, _moment2.default)(end).format('MM')) {
	        return startFormat + ' - ' + endFormat;
	      } else {
	        return start2 + ' - ' + endFormat;
	      }
	    },
	    week: function week(date) {
	      return (0, _moment2.default)(date).isoWeek();
	    }
	  },
	  methods: {
	    setActiveSchoolYear: function setActiveSchoolYear(evt) {
	      this.$store.commit('setlocalActivatedSchoolYear', evt.target.value);
	      this.setStartAndEndDateBasedOnSchoolYear();
	    },
	    setStartAndEndDate: function setStartAndEndDate() {
	      var _this = this;
	
	      var isCalDateNotWithinASchoolYear = true;
	      var startDate = void 0;
	      var endDate = void 0;
	      this.activeSchoolYears.forEach(function (year) {
	        startDate = (0, _moment2.default)(year.employee_time_start).startOf('isoweek');
	        endDate = (0, _moment2.default)(year.employee_time_end).endOf('isoweek');
	        if (_this.isCalDateWithinRange(startDate, endDate)) {
	          _this.calStartDate = startDate;
	          _this.calEndDate = endDate;
	          isCalDateNotWithinASchoolYear = false;
	        }
	      });
	      this.createWeeks();
	      this.$emit('isWithinCalRange', isCalDateNotWithinASchoolYear);
	    },
	    setStartAndEndDateBasedOnSchoolYear: function setStartAndEndDateBasedOnSchoolYear() {
	      this.calStartDate = this.activeSchoolYear.employee_time_start;
	      this.calEndDate = this.activeSchoolYear.employee_time_end;
	      this.createWeeks();
	    },
	    isCalDateWithinRange: function isCalDateWithinRange(start, end) {
	      var lockupdate = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      return (0, _moment2.default)(lockupdate).isBetween(start, end) || (0, _moment2.default)(lockupdate).isSame(start) || (0, _moment2.default)(lockupdate).isSame(end);
	    },
	    createWeeks: function createWeeks() {
	      var start = (0, _moment2.default)(this.calStartDate).day(this.firstDayOfTheWeek);
	      var end = this.calEndDate;
	      var startWeek = (0, _moment2.default)(start).isoWeek();
	      var diff = (0, _moment2.default)(end).diff(start, 'week');
	      var max = startWeek + diff;
	      var weeks = [];
	      for (var i = startWeek; i <= max; i++) {
	        var date = (0, _moment2.default)(start).isoWeek(i).day(this.firstDayOfTheWeek);
	        weeks.push({
	          date: date,
	          isSelected: false,
	          serverDate: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	          weekNum: date.isoWeek(),
	          isNow: (0, _moment2.default)(date).format('GGGG-WW') === (0, _moment2.default)().format('GGGG-WW'),
	          isCopyWeek: false
	        });
	      }
	      this.weeks = weeks;
	    },
	    getCalDatesAndCreateWeeks: function getCalDatesAndCreateWeeks() {
	      var _this2 = this;
	
	      _docendo2.default.calendar(this.calid, function (data) {
	        _this2.calType = data.type;
	        _this2.calStartDate = data.start_date;
	        _this2.calEndDate = data.end_date;
	        _this2.setStartAndEndDate();
	        _this2.setStartWeek();
	      });
	    },
	    setStartWeek: function setStartWeek() {
	      var weekNum = (0, _moment2.default)(this.date).isoWeek();
	      var index = this.findWeek(weekNum);
	      if (this.weeks[index] !== undefined) {
	        this.weeks[index].isCopyWeek = true;
	        this.startPasteWeek = this.date;
	      }
	    },
	    selectWeek: function selectWeek(i) {
	      if (!this.weeks[i].isSelected && !this.weeks[i].isCopyWeek) {
	        this.selectedWeeks.push(this.weeks[i].serverDate);
	        this.weeks[i].isSelected = true;
	      }
	    },
	    removeWeek: function removeWeek(i) {
	      this.weeks[i].isSelected = false;
	      var selectedIndex = this.selectedWeeks.indexOf(this.weeks[i].serverDate);
	      this.selectedWeeks.splice(selectedIndex, 1);
	    },
	    toggleWeek: function toggleWeek(index) {
	      if (this.selectedWeeks.length < 1 || this.showStartPasteWeek) {
	        this.startPasteWeek = this.weeks[index].date;
	      }
	      if (this.weeks[index].isCopyWeek) {
	        return;
	      }
	      if (!this.weeks[index].isSelected) {
	        this.selectWeek(index);
	      } else {
	        this.removeWeek(index);
	      }
	    },
	    findWeek: function findWeek(weekNum) {
	      for (var i = 0; i < this.weeks.length; i++) {
	        if (this.weeks[i].weekNum === weekNum) {
	          return i;
	        }
	      }
	    },
	    selectAll: function selectAll() {
	      for (var i = 0; i < this.weeks.length; i++) {
	        if ((0, _moment2.default)(this.weeks[i].date).isSameOrAfter(this.startPasteWeek)) {
	          this.selectWeek(i);
	        }
	      }
	    },
	    selectEvenWeeks: function selectEvenWeeks() {
	      for (var i = 0; i < this.weeks.length; i++) {
	        if ((0, _moment2.default)(this.weeks[i].date).isSameOrAfter(this.startPasteWeek)) {
	          if (this.isEven(this.weeks[i].date.isoWeek())) {
	            this.selectWeek(i);
	          }
	        }
	      }
	    },
	    selectOddWeeks: function selectOddWeeks() {
	      for (var i = 0; i < this.weeks.length; i++) {
	        if ((0, _moment2.default)(this.weeks[i].date).isSameOrAfter(this.startPasteWeek)) {
	          if (this.isOdd(this.weeks[i].date.isoWeek())) {
	            this.selectWeek(i);
	          }
	        }
	      }
	    },
	    isEven: function isEven(n) {
	      return (/^-?\d*[02468]$/.test(n)
	      );
	    },
	    isOdd: function isOdd(n) {
	      return (/^-?\d*[13579]$/.test(n)
	      );
	    },
	    removeAllSelectedWeeks: function removeAllSelectedWeeks() {
	      this.selectedWeeks = [];
	      for (var i = 0; i < this.weeks.length; i++) {
	        this.weeks[i].isSelected = false;
	      }
	    },
	    close: function close() {
	      this.modal = false;
	      this.feedback = false;
	    },
	    eraseStartDate: function eraseStartDate() {
	      this.startPasteWeek = this.calStartDate;
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.calid) {
	      this.getCalDatesAndCreateWeeks();
	    } else {
	      this.setStartAndEndDateBasedOnSchoolYear();
	    }
	  }
	};

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _TaskOverviewUser = __webpack_require__(103);
	
	var _TaskOverviewUser2 = _interopRequireDefault(_TaskOverviewUser);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _TaggingFilter = __webpack_require__(43);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default, Loader: _Loader2.default, DModal: _DModal2.default, TaskOverviewUser: _TaskOverviewUser2.default, filterTags: _TaggingFilter2.default },
	  props: {
	    schoolThresholdToHideTaskHours: {
	      default: null
	    },
	    theUserCanManageAssignedHours: {
	      default: false
	    },
	    tags: {
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      versions: [],
	      isLoading: false,
	      isHideTaskHoursUnderThreshold: true,
	      isShowUserSelectModal: true,
	      selectedUserIds: [],
	      isLoadingPrint: false,
	      appliedFilters: [] };
	  },
	
	  computed: {
	    usersSortedOnName: function usersSortedOnName() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.$store.getters.schoolYearId;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    usersSortedOnNameWithTags: function usersSortedOnNameWithTags() {
	      return this.usersSortedOnName.map(function (user) {
	        user.tags = user.user_tags;
	        return user;
	      });
	    },
	    filteredUsersOnTags: function filteredUsersOnTags() {
	      var _this = this;
	
	      if (this.appliedFilters.length < 1) {
	        return this.usersSortedOnNameWithTags;
	      }
	      return this.usersSortedOnNameWithTags.filter(function (user) {
	        if (!user.tags) return false;
	        return user.tags.some(function (tag) {
	          return _this.appliedFilters.includes(tag);
	        });
	      });
	    },
	    sortedUsers: function sortedUsers() {
	      var _this2 = this;
	
	      var versions = this.versions.filter(function (version) {
	        return _this2.allUsersInHash[version.user_id];
	      }).map(function (version) {
	        return {
	          name: _this2.allUsersInHash[version.user_id]['name'],
	          user: _this2.allUsersInHash[version.user_id],
	          version: version
	        };
	      });
	      return this.$helpers.sortArrOnName(versions);
	    },
	    filteredUsers: function filteredUsers() {
	      var _this3 = this;
	
	      if (this.selectedUserIds.length < 1) {
	        return this.sortedUsers;
	      }
	      return this.sortedUsers.filter(function (user) {
	        return _this3.selectedUserIds.includes(user.user.id);
	      });
	    }
	  },
	  methods: {
	    toggleUser: function toggleUser(user) {
	      var userId = user.id;
	      var index = this.selectedUserIds.indexOf(userId);
	      if (index === -1) {
	        this.selectedUserIds.push(userId);
	      } else {
	        this.selectedUserIds.splice(index, 1);
	      }
	    },
	    getIsUserSelected: function getIsUserSelected(user) {
	      return this.selectedUserIds.includes(user.id);
	    },
	    toggleAll: function toggleAll() {
	      if (this.selectedUserIds.length < 1) {
	        this.selectedUserIds = this.filteredUsersOnTags.map(function (user) {
	          return user.id;
	        });
	      } else {
	        this.selectedUserIds = [];
	      }
	    },
	    setTagFromFilter: function setTagFromFilter(tag) {
	      if (!this.appliedFilters.includes(tag)) {
	        this.appliedFilters.push(tag);
	      }
	    },
	    removeTagFromFilter: function removeTagFromFilter(tag) {
	      var index = this.appliedFilters.indexOf(tag);
	      if (index !== -1) {
	        this.appliedFilters.splice(index, 1);
	      }
	    },
	    startPrint: function startPrint() {
	      var _this4 = this;
	
	      this.isLoadingPrint = true;
	      this.$nextTick(function (_) {
	        _this4.isShowUserSelectModal = false;
	        _this4.$nextTick(function (_) {
	          _this4.isLoadingPrint = false;
	          _this4.print();
	        });
	      });
	    },
	    setIsHideTaskHoursUnderThreshold: function setIsHideTaskHoursUnderThreshold() {
	      this.isHideTaskHoursUnderThreshold = !this.isHideTaskHoursUnderThreshold;
	    },
	    closeModal: function closeModal() {
	      this.$emit('close');
	    },
	    readAllOverviews: function readAllOverviews() {
	      var _this5 = this;
	
	      this.isLoading = true;
	      _docendo2.default.readAllTaskOverview(this.schoolId, this.schoolYearId, function (success) {
	        _this5.versions = success;
	        _this5.isLoading = false;
	        _this5.$nextTick(function (_) {
	          _this5.isShowUserSelectModal = true;
	        });
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    print: function print() {
	      var _this6 = this;
	
	      var i18nTaskOverview = this.$t('vue2.task_versions.task_overview');
	
	      var prtHtml = document.getElementById('printTaskOverviews').innerHTML;
	
	      var stylesHtml = '';
	
	      var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')));
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var node = _arr[_i];
	        stylesHtml += node.outerHTML;
	      }
	
	      var pageBreakStyles = '<style>@media print {\n        #printTaskOverviews .to-user { page-break-after: always; break-after: page; }\n        #printTaskOverviews .to-user:last-child { page-break-after: auto; break-after: auto; }\n      }</style>';
	
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	
	      WinPrint.document.write('<!DOCTYPE html><html id="html-bg-white"><head><title>' + i18nTaskOverview + '</title>' + stylesHtml + pageBreakStyles + '</head><body><div id="printTaskOverviews">' + prtHtml + '</div></body></html>');
	      var afterPrint = function afterPrint() {
	        WinPrint.close();
	        _this6.closeModal();
	      };
	      WinPrint.onafterprint = afterPrint;
	      setTimeout(function (_) {
	        WinPrint.document.close();
	        WinPrint.focus();
	        WinPrint.print();
	      }, 1000);
	    }
	  },
	  mounted: function mounted() {
	    this.readAllOverviews();
	  }
	};

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _PrintCalendarsWeekSelector = __webpack_require__(1531);
	
	var _PrintCalendarsWeekSelector2 = _interopRequireDefault(_PrintCalendarsWeekSelector);
	
	var _PrintCalendars = __webpack_require__(1530);
	
	var _PrintCalendars2 = _interopRequireDefault(_PrintCalendars);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _vueClickaway = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { DDropdown: _DDropdown2.default, PrintCalendars: _PrintCalendars2.default, PrintCalendarsWeekSelector: _PrintCalendarsWeekSelector2.default, DModal: _DModal2.default },
	  props: {
	    calendarId: {
	      default: 7
	    },
	    activeCalendarDate: {
	      default: null
	    },
	    onlyPrintThisCalendar: {
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      theStep: 1,
	      calendarTypes: [{ title: this.$t('vue2.print_all_calendars.all_classes'), type: 'klass' }, { title: this.$t('vue2.print_all_calendars.all_teachers'), type: 'user' }, { title: this.$t('vue2.print_all_calendars.all_rooms'), type: 'room' }],
	      date: (0, _moment2.default)().format('YYYY-MM-DD 00:00'),
	      startDate: (0, _moment2.default)().isoWeek(1).startOf('day'),
	      endDate: (0, _moment2.default)().isoWeek(7).endOf('day'),
	      isDropdown: false,
	      selectedCalendars: []
	    };
	  },
	
	  computed: {
	    firstDayOfWeek: function firstDayOfWeek() {
	      return this.$store.getters.firstDayOfWeek;
	    },
	    allSchoolCalendars: function allSchoolCalendars() {
	      return this.$store.state.calendars;
	    },
	    isShowModal: function isShowModal() {
	      return _eventbus2.default.isPrintCalendarsModal;
	    },
	    printCalendarType: function printCalendarType() {
	      return _eventbus2.default.printCalendarType;
	    },
	    calendarIds: function calendarIds() {
	      var _this = this;
	
	      var filteredCals = [];
	      if (this.printCalendarType === 'single_calendar') {
	        filteredCals = this.allSchoolCalendars.filter(function (calendar) {
	          return calendar.id === _this.calendarId;
	        });
	      } else if (this.printCalendarType === 'multiple_calendars') {
	        filteredCals = this.selectedCalendars;
	      } else {
	        filteredCals = this.allSchoolCalendars.filter(function (calendar) {
	          return calendar.type === _this.printCalendarType;
	        });
	      }
	      var sortedFilteredCals = filteredCals.sort(function (a, b) {
	        if (a.name && b.name) {
	          return a.name.localeCompare(b.name, undefined, {
	            numeric: true,
	            sensitivity: 'base'
	          });
	        }
	      });
	      return this.printCalendarType ? sortedFilteredCals.filter(function (cal) {
	        return cal.id;
	      }).map(function (cal) {
	        return cal.id;
	      }) : [];
	    }
	  },
	  watch: {
	    isShowModal: function isShowModal(val) {
	      if (!val) {
	        this.resetForm();
	      }
	    }
	  },
	  methods: {
	    clearSelectedCalendars: function clearSelectedCalendars() {
	      this.selectedCalendars = [];
	    },
	    updateSelectedCalendar: function updateSelectedCalendar(cals) {
	      this.selectedCalendars = cals;
	    },
	    getPrintingDate: function getPrintingDate() {
	      if (this.activeCalendarDate) {
	        this.setDate(this.activeCalendarDate);
	      } else {
	        var calendar = document.querySelectorAll('#calendar_' + this.calendarId);
	        if (calendar.length > 0) {
	          this.setDate(calendar[0].dataset.current_date);
	        }
	      }
	    },
	    setDropdownFromClick: function setDropdownFromClick() {
	      if (!this.isDropdown) {
	        return;
	      }
	      this.isDropdown = false;
	    },
	    setIsDropdown: function setIsDropdown() {
	      if (!this.isDropdown) {
	        this.getPrintingDate();
	      }
	      this.isDropdown = !this.isDropdown;
	    },
	    setDate: function setDate(date) {
	      var selectedDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      if (this.firstDayOfWeek === 0) {
	        selectedDate = (0, _moment2.default)(selectedDate).add(1, 'days');
	      }
	      this.date = selectedDate;
	      var endDayOfWeek = this.firstDayOfWeek + 6;
	      this.startDate = (0, _moment2.default)(selectedDate).isoWeekday(this.firstDayOfWeek).startOf('day');
	      this.endDate = (0, _moment2.default)(selectedDate).isoWeekday(endDayOfWeek).endOf('day');
	      this.theStep = 2;
	    },
	    setIsShowModalFalse: function setIsShowModalFalse() {
	      _eventbus2.default.isPrintCalendarsModal = false;
	      this.resetForm();
	    },
	    resetForm: function resetForm() {
	      _eventbus2.default.printCalendarType = null;
	      this.theStep = 1;
	    },
	    selectType: function selectType(type) {
	      this.isDropdown = false;
	      _eventbus2.default.printCalendarType = type.type;
	      this.theStep = 1;
	      _eventbus2.default.isPrintCalendarsModal = true;
	    },
	    printThis: function printThis() {
	      this.isDropdown = false;
	      this.getPrintingDate();
	      _eventbus2.default.printCalendarType = 'single_calendar';
	      this.theStep = 1;
	      _eventbus2.default.isPrintCalendarsModal = true;
	    },
	    printOld: function printOld() {
	      window.noTextNoPrint();
	      window.printCalendar(this.calendarId);
	    }
	  }
	};

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DSelectCalsAll = __webpack_require__(349);
	
	var _DSelectCalsAll2 = _interopRequireDefault(_DSelectCalsAll);
	
	var _DCalendar = __webpack_require__(53);
	
	var _DCalendar2 = _interopRequireDefault(_DCalendar);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _TimeChanger = __webpack_require__(31);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _DCalendarPrint = __webpack_require__(1490);
	
	var _DCalendarPrint2 = _interopRequireDefault(_DCalendarPrint);
	
	var _CalculateHours = __webpack_require__(340);
	
	var _CalculateHours2 = _interopRequireDefault(_CalculateHours);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelectCals: _DSelectCalsAll2.default, CalculateHours: _CalculateHours2.default, DCalendarPrint: _DCalendarPrint2.default, AppToggle: _AppToggle2.default, DModal: _DModal2.default, Loader: _Loader2.default, DCalendar: _DCalendar2.default, TimeChanger: _TimeChanger2.default },
	  props: {
	    calendarIds: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)().format('YYYY-MM-DD');
	      }
	    },
	    startDate: {
	      default: function _default() {
	        return (0, _moment2.default)().isoWeekday(1).format('YYYY-MM-DD 00:00');
	      }
	    },
	    endDate: {
	      default: function _default() {
	        return (0, _moment2.default)().isoWeekday(7).format('YYYY-MM-DD 00:00');
	      }
	    },
	    firstDayOfWeek: {
	      type: Number,
	      default: 1
	    },
	    showDSelect: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      events: [],
	      isLoading: true,
	      theViewSetting: 'calendar',
	      isShowPrintButton: false,
	      isShowWeekends: false,
	      isPrintHours: false,
	      startTimeDate: (0, _moment2.default)().set({ 'hour': 6, 'minutes': 0, 'second': 0, 'millisecond': 0 }),
	      endTimeDate: (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0, 'second': 0, 'millisecond': 0 }),
	      isCalNoBgColors: false,
	      eventFontSize: 10,
	      isCalendarsSelected: false,
	      isHideCalendars: false,
	      isHideDates: false
	    };
	  },
	
	  watch: {
	    isLoading: function isLoading(val) {
	      var _this = this;
	
	      if (!this.isLoading) {
	        setTimeout(function (_) {
	          _this.isShowPrintButton = true;
	        }, 500);
	      }
	    },
	    calendarIds: function calendarIds(val) {
	      if (this.isCalendarsSelected) {
	        this.getEvents();
	      }
	    }
	  },
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    startTime: function startTime() {
	      return (0, _moment2.default)(this.startTimeDate).format('HH:mm:ss');
	    },
	    endTime: function endTime() {
	      return (0, _moment2.default)(this.endTimeDate).format('HH:mm:ss');
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    eventsInHash: function eventsInHash() {
	      var _this2 = this;
	
	      var objOfEvents = {};
	      if (this.events.length < 1) {
	        objOfEvents = {};
	      } else {
	        this.events.forEach(function (event) {
	          event.calendars.forEach(function (calendar) {
	            var calendarId = calendar.calendar_id;
	            if (!objOfEvents[calendarId]) {
	              _this2.$set(objOfEvents, calendarId, [event]);
	            } else {
	              objOfEvents[calendarId].push(event);
	            }
	          });
	        });
	      }
	      return objOfEvents;
	    },
	    calendars: function calendars() {
	      var _this3 = this;
	
	      var cals = [];
	      cals = this.calendarIds.map(function (calId) {
	        return {
	          id: calId,
	          name: _this3.allCalendarsInHash[calId] ? _this3.allCalendarsInHash[calId].name : 'No title',
	          view_state: 0,
	          events: _this3.eventsInHash[calId] ? _this3.eventsInHash[calId] : [],
	          isHasEvents: _this3.eventsInHash[calId]
	        };
	      });
	      return cals.filter(function (cal) {
	        return cal.isHasEvents;
	      });
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    userPrintSettings: function userPrintSettings() {
	      return this.userSettings['print_settings_calendar'] ? this.userSettings['print_settings_calendar'] : {};
	    },
	    hasUserPrintSettings: function hasUserPrintSettings() {
	      return (0, _keys2.default)(this.userPrintSettings).length > 0;
	    }
	  },
	  methods: {
	    setIsCalendarsSelected: function setIsCalendarsSelected() {
	      var _this4 = this;
	
	      this.isCalendarsSelected = true;
	      this.$nextTick(function (_) {
	        _this4.getEvents();
	      });
	    },
	    dSelectCalsUpdated: function dSelectCalsUpdated(type, cals) {
	      this.$emit('updateCalendars', cals);
	    },
	    updatePrintSettingsFromComputed: function updatePrintSettingsFromComputed() {
	      var _this5 = this;
	
	      (0, _keys2.default)(this.userPrintSettings).forEach(function (setting) {
	        var val = _this5.userPrintSettings[setting];
	        if (_this5.hasOwnProperty(setting)) {
	          _this5[setting] = val;
	        }
	      });
	    },
	    changeSetting: function changeSetting(setting, val) {
	      if (this.hasOwnProperty(setting)) {
	        this[setting] = val;
	        this.savePrintSettings(setting, val);
	      }
	    },
	    savePrintSettings: function savePrintSettings(setting, val) {
	      var initPrintSettings = {
	        theViewSetting: 'calendar',
	        isShowWeekends: false,
	        isPrintHours: false,
	        startTimeDate: (0, _moment2.default)().set({ 'hour': 6, 'minutes': 0, 'second': 0, 'millisecond': 0 }),
	        endTimeDate: (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0, 'second': 0, 'millisecond': 0 }),
	        isCalNoBgColors: false,
	        eventFontSize: 10
	      };
	      var newPrintSettings = JSON.parse((0, _stringify2.default)(this.userPrintSettings));
	      if (initPrintSettings[setting] === val && this.userPrintSettings[setting]) {
	        delete newPrintSettings[setting];
	        if ((0, _keys2.default)(newPrintSettings).length === 0) {
	          this.$store.dispatch('deleteUserSetting', 'print_settings_calendar');
	        } else {
	          this.$store.dispatch('updateUserSettings', { 'print_settings_calendar': newPrintSettings });
	        }
	        return;
	      }
	      if (initPrintSettings[setting] !== val) {
	        newPrintSettings[setting] = val;
	        this.$store.dispatch('updateUserSettings', { 'print_settings_calendar': newPrintSettings });
	      }
	    },
	    resetPrintSettings: function resetPrintSettings() {
	      this.theViewSetting = 'calendar';
	      this.isShowWeekends = false;
	      this.isPrintHours = false;
	      this.startTimeDate = (0, _moment2.default)().set({ 'hour': 6, 'minutes': 0, 'second': 0, 'millisecond': 0 }).format();
	      this.endTimeDate = (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0, 'second': 0, 'millisecond': 0 }).format();
	      this.isCalNoBgColors = false;
	      this.eventFontSize = 10;
	      this.$store.dispatch('deleteUserSetting', 'print_settings_calendar');
	    },
	    setViewSetting: function setViewSetting(type) {
	      if (this.theViewSetting === type) {
	        this.theViewSetting = 'calendar';
	        this.changeSetting('theViewSetting', 'calendar');
	      } else {
	        this.theViewSetting = type;
	        this.changeSetting('theViewSetting', type);
	      }
	    },
	    setStartTime: function setStartTime(payload) {
	      this.startTimeDate = payload;
	      this.changeSetting('startTimeDate', payload);
	    },
	    setEndTime: function setEndTime(payload) {
	      this.endTimeDate = payload;
	      this.changeSetting('endTimeDate', payload);
	    },
	    getEvents: function getEvents() {
	      var _this6 = this;
	
	      this.isLoading = true;
	      _docendo2.default.eventsFromCalendars(this.calendarIds, this.startDate, this.endDate, null, function (data) {
	        _this6.events = data.length > 0 ? JSON.parse(data) : [];
	        _this6.isLoading = false;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    print: function print() {
	      var _this7 = this;
	
	      this.isShowPrintButton = false;
	      this.$nextTick(function (_) {
	        var prtHtml = document.getElementById('printCalendars').innerHTML;
	
	        var stylesHtml = '';
	
	        var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')));
	
	        for (var _i = 0; _i < _arr.length; _i++) {
	          var node = _arr[_i];
	          stylesHtml += node.outerHTML;
	        }
	
	        var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	
	        WinPrint.document.write('<!DOCTYPE html><html><head>' + stylesHtml + '</head><body>' + prtHtml + '</body></html>');
	        var afterPrint = function afterPrint() {
	          WinPrint.close();
	          _this7.close();
	        };
	        WinPrint.onafterprint = afterPrint;
	        setTimeout(function (_) {
	          WinPrint.document.close();
	          WinPrint.focus();
	          WinPrint.print();
	        }, 1000);
	      });
	    },
	    close: function close() {
	      this.isShowPrintButton = false;
	      _eventbus2.default.isPrintCalendarsModal = false;
	    }
	  },
	  mounted: function mounted() {
	    var _this8 = this;
	
	    this.updatePrintSettingsFromComputed();
	    setTimeout(function (_) {
	      _this8.getEvents();
	    }, 500);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.$emit('clear');
	  }
	};

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ChangeSchoolYear: _ChangeSchoolYear2.default },
	  computed: {
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    localActivatedSchoolYear: function localActivatedSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    weeks: function weeks() {
	      var activeSchoolYear = this.localActivatedSchoolYear;
	      if (this.calType === 'klass') {
	        this.calStartDate = activeSchoolYear.student_time_start;
	        this.calEndDate = activeSchoolYear.student_time_end;
	      } else {
	        this.calStartDate = activeSchoolYear.employee_time_start;
	        this.calEndDate = activeSchoolYear.employee_time_end;
	      }
	      var start = (0, _moment2.default)(this.calStartDate).startOf('isoweek');
	      var end = (0, _moment2.default)(this.calEndDate).endOf('isoweek');
	      var startWeek = (0, _moment2.default)(start).isoWeek();
	      var diff = (0, _moment2.default)(end).diff(start, 'week');
	      var max = startWeek + diff;
	      var weeks = [];
	      for (var i = startWeek; i <= max; i++) {
	        var date = (0, _moment2.default)(start).isoWeek(i);
	        weeks.push({
	          date: date,
	          serverDate: (0, _moment2.default)(date).format('GGGG-WW'),
	          weekNum: date.isoWeek()
	        });
	      }
	      return weeks;
	    }
	  },
	  methods: {
	    tooltipDate: function tooltipDate(date) {
	      var start = (0, _moment2.default)(date).startOf('isoweek');
	      var start2 = (0, _moment2.default)(date).startOf('isoweek').format('DD. MMM');
	      var startFormat = start.format('DD');
	      var end = (0, _moment2.default)(date).endOf('isoweek');
	      var endFormat = (0, _moment2.default)(date).endOf('isoweek').format('DD. MMM YYYY');
	
	      if ((0, _moment2.default)(start).format('MM') === (0, _moment2.default)(end).format('MM')) {
	        return startFormat + ' - ' + endFormat;
	      } else {
	        return start2 + ' - ' + endFormat;
	      }
	    },
	    isNow: function isNow(week) {
	      return (0, _moment2.default)(week.date).format('GGGG-WW') === (0, _moment2.default)().format('GGGG-WW');
	    },
	    setSelectedWeek: function setSelectedWeek(week) {
	      this.$emit('setWeek', week);
	    },
	    showWeek: function showWeek(date) {
	      return (0, _moment2.default)(date).isoWeek();
	    }
	  }
	};

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ProfileSubjects = __webpack_require__(1534);
	
	var _ProfileSubjects2 = _interopRequireDefault(_ProfileSubjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ProfileSubjects: _ProfileSubjects2.default, Loader: _Loader2.default },
	  props: {
	    userId: {
	      default: null
	    }
	  },
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolIsFromDenmark: function schoolIsFromDenmark() {
	      var school = this.$store.state.activeSchool;
	      return school && school.country === 'DK';
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    theUser: function theUser() {
	      if (!this.user) {
	        return null;
	      }
	      if (this.userId * 1 === this.user.id * 1) {
	        return this.user;
	      }
	      return this.allUsersInHash && this.allUsersInHash[this.userId] ? this.allUsersInHash[this.userId] : null;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    isUserCanEdit: function isUserCanEdit() {
	      if (this.userId * 1 === this.user.id * 1) {
	        return true;
	      }
	      return this.userHasPermission('can_manage_users');
	    },
	    users: function users() {
	      return this.$store.state.allUsers;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    }
	  },
	  methods: {
	    userHasPermission: function userHasPermission(val) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(val) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    }
	  }
	};

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default },
	  props: {
	    user: {
	      default: null
	    },
	    users: {
	      default: function _default() {
	        return [];
	      }
	    },
	    canEdit: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isEditable: false,
	      formErrors: {},
	      ssn: '',
	      isSaving: false
	    };
	  },
	
	  computed: {
	    ssnTrimmed: function ssnTrimmed() {
	      var cpr = this.ssn.replace(/[^0-9]/ig, '');
	      return cpr.toString();
	    },
	    isSaveButtonDisabled: function isSaveButtonDisabled() {
	      return this.ssn.replace(/[^0-9]/ig, '').length !== 10;
	    },
	    ssnHidden: function ssnHidden() {
	      var ssnText = 'Ikke udfyldt';
	      if (this.ssn.length > 0) {
	        ssnText = this.ssn;
	        if (this.ssn.length > 5) {
	          var replacement = 'xxxx';
	          ssnText = ssnText.slice(0, -4) + replacement;
	        }
	      }
	      return ssnText;
	    }
	  },
	  methods: {
	    removeErrors: function removeErrors(title) {
	      this.$delete(this.formErrors, title);
	    },
	    formValidation: function formValidation() {
	      this.formErrors = {};
	      if (!this.validateCPR()) {
	        this.$set(this.formErrors, 'ssn', 'Er ikke et gyldigt CPR nummer');
	      }
	    },
	    validateCPR: function validateCPR() {
	      var ssn = this.ssn.replace(/[^0-9]/ig, '');
	      return ssn.length === 10;
	    },
	    resetForm: function resetForm() {
	      this.ssn = this.user.ssn;
	      this.formErrors = {};
	    },
	    cancel: function cancel() {
	      this.resetForm();
	      this.isEditable = false;
	    },
	    submit: function submit() {
	      var _this = this;
	
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      this.isSaving = true;
	      var changes = { ssn: this.ssnTrimmed };
	      _docendo2.default.updateUser(changes, function (success) {
	        _eventbus2.default.toast = { text: 'Gemt', 'success': true };
	        var obj = {
	          prop: 'ssn',
	          ssn: success.ssn
	        };
	        _this.$store.commit('updateUserProp', obj);
	        _this.isSaving = false;
	        _this.cancel();
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'CPR nummer er allerede brugt', 'success': false };
	        _this.isSaving = false;
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.ssn = this.user.ssn;
	  }
	};

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(45);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _KompetenceIndberetningDSelect = __webpack_require__(367);
	
	var _KompetenceIndberetningDSelect2 = _interopRequireDefault(_KompetenceIndberetningDSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, DSelect: _KompetenceIndberetningDSelect2.default },
	  props: {
	    user: {
	      default: null
	    },
	    schoolId: {
	      default: null
	    },
	    canEdit: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      isEditable: false,
	      formErrors: {},
	      isSaving: false,
	      competencies: [],
	      theNewSubject: null,
	      theNewSubjectLevel: 'L',
	      standardSubjects: [{ subject_code: 110, name: 'Dansk' }, { subject_code: 120, name: 'Engelsk' }, { subject_code: 130, name: 'Tysk (tilbudsfag)' }, { subject_code: 134, name: 'Tysk (valgfag)' }, { subject_code: 140, name: 'Fransk (tilbudsfag)' }, { subject_code: 144, name: 'Fransk (valgfag)' }, { subject_code: 170, name: 'Kristendomskundskab' }, { subject_code: 171, name: 'Kristendomskundskab/religion' }, { subject_code: 181, name: 'Historie' }, { subject_code: 182, name: 'Samfundsfag' }, { subject_code: 210, name: 'Idræt' }, { subject_code: 220, name: 'Musik' }, { subject_code: 230, name: 'Billedkunst' }, { subject_code: 240, name: 'Håndarbejde' }, { subject_code: 245, name: 'Håndværk og design' }, { subject_code: 250, name: 'Sløjd' }, { subject_code: 260, name: 'Madkundskab' }, { subject_code: 310, name: 'Matematik' }, { subject_code: 320, name: 'Fysik/kemi' }, { subject_code: 330, name: 'Geografi' }, { subject_code: 340, name: 'Biologi' }, { subject_code: 350, name: 'Natur/teknik' }, { subject_code: 511, name: 'Praktisk/Musisk valgfag: Håndværk/design' }, { subject_code: 520, name: 'Praktisk/Musisk valgfag: Musik' }, { subject_code: 531, name: 'Praktisk/Musisk valgfag: Billedkunst' }, { subject_code: 540, name: 'Praktisk/Musisk valgfag: Madkundskab' }, { subject_code: 600, name: 'Børnehaveklasse' }],
	      levelMap: {
	        L: 'Linjefag',
	        K: 'Tilsvarende kompetencer'
	      }
	    };
	  },
	
	  computed: {
	    isSaveButtonDisabled: function isSaveButtonDisabled() {
	      return false;
	    },
	    standardSubjectsWithVProps: function standardSubjectsWithVProps() {
	      var _this = this;
	
	      var subjects = [];
	      var sortedSubjects = this.standardSubjects.sort(function (a, b) {
	        if (a.name < b.name) return -1;
	        if (a.name > b.name) return 1;
	        return 0;
	      });
	      sortedSubjects.forEach(function (subject) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(_this.levelMap)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var key = _step.value;
	
	            var obj = {};
	            obj.level = key;
	            obj.name = subject.name + ' (' + key + ')';
	            obj.id = subject.subject_code + '_' + key;
	            obj.user_id = subject.subject_code + '_' + key;
	            obj.subject_code = subject.subject_code;
	            subjects.push(obj);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      });
	      return subjects;
	    },
	    userCompetencies: function userCompetencies() {
	      var _this2 = this;
	
	      var competencies = [];
	      this.competencies.forEach(function (subject) {
	        var id = subject.subject_code + '_' + subject.level;
	        var idx = _this2.standardSubjectsWithVProps.findIndex(function (subjectWithVProps) {
	          return subjectWithVProps.id === id;
	        });
	        var obj = {
	          id: subject.subject_code + '_' + subject.level,
	          subject_code: subject.subject_code,
	          level: subject.level,
	          name: idx > -1 ? _this2.standardSubjectsWithVProps[idx].name : ''
	        };
	        competencies.push(obj);
	      });
	      return competencies;
	    }
	  },
	  methods: {
	    removeErrors: function removeErrors(title) {
	      this.$delete(this.formErrors, title);
	    },
	    cancel: function cancel() {
	      this.resetForm();
	      this.isEditable = false;
	    },
	    updateSubjectOnUser: function updateSubjectOnUser(subjects) {
	      var _this3 = this;
	
	      var user = this.user;
	      var subjectForServer = [];
	      subjects.forEach(function (subject) {
	        var obj = {
	          subject_code: subject.subject_code,
	          level: subject.level
	        };
	        subjectForServer.push(obj);
	      });
	      _docendo2.default.updateUserCompetencies(this.schoolId, user.id, subjectForServer, function (success) {
	        var userCompetencies = success.filter(function (subject) {
	          return subject.user_id === _this3.user.id;
	        });
	        _this3.competencies = userCompetencies;
	        _eventbus2.default.toast = { text: 'Linjefag er opdateret', success: true };
	      }, function (failure) {
	        console.log('failed');
	      });
	    },
	    readCompetencies: function readCompetencies() {
	      var _this4 = this;
	
	      this.isLoading = true;
	      _docendo2.default.listUserCompetencies(this.schoolId, this.user.id, function (success) {
	        var userCompetencies = success.filter(function (subject) {
	          return subject.user_id === _this4.user.id;
	        });
	        _this4.competencies = userCompetencies;
	        _this4.isLoading = false;
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readCompetencies();
	  }
	};

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppEIPWYZIWYG = __webpack_require__(55);
	
	var _AppEIPWYZIWYG2 = _interopRequireDefault(_AppEIPWYZIWYG);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    text: {
	      type: String
	    },
	    noteType: {
	      type: String,
	      default: ''
	    }
	  },
	  components: {
	    weip: _AppEIPWYZIWYG2.default
	  },
	  data: function data() {
	    return {
	      serverText: ''
	    };
	  },
	
	  methods: {
	    changed: function changed(text) {
	      this.serverText = text;
	      var el = this.$refs.quillelement.closest('.djs-slidein-form');
	      if (el) {
	        el.setAttribute('data-form-changes', 'true');
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.serverText = this.text;
	  }
	};

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'recent-users',
	  data: function data() {
	    return {
	      users: []
	    };
	  },
	  props: ['school'],
	  methods: {
	    tooltiptitle: function tooltiptitle(user) {
	      return user.name + ' ' + this.timeFromNow(user.last_seen);
	    },
	    timeFromNow: function timeFromNow(m) {
	      if (m !== null) {
	        return this.$i18n.t('vue.recent_users.last_seen') + ' ' + (0, _moment2.default)(m).fromNow();
	      } else {
	        return this.$i18n.t('vue.recent_users.never_logged_in');
	      }
	    },
	    update: function update() {
	      _docendo2.default.getRecentUsers(this.school, 25, this.updated);
	    },
	    updated: function updated(data) {
	      this.users = data;
	    },
	    startRefreshing: function startRefreshing() {
	      this.timer = setInterval(this.update, 60000);
	    },
	    stopRefreshing: function stopRefreshing() {
	      clearInterval(this.timer);
	    }
	  },
	  mounted: function mounted() {
	    this.update();
	    this.startRefreshing();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.stopRefreshing();
	  },
	  created: function created() {
	    this.$on('docendo_state', function (data) {
	      if (data === 'connected') {
	        this.startRefreshing();
	      } else if (data === 'disconnected') {
	        this.stopRefreshing();
	      }
	    });
	  }
	};

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _set = __webpack_require__(27);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _BulkCreateSubjects = __webpack_require__(391);
	
	var _BulkCreateSubjects2 = _interopRequireDefault(_BulkCreateSubjects);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _SubjectForm = __webpack_require__(70);
	
	var _SubjectForm2 = _interopRequireDefault(_SubjectForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { SubjectForm: _SubjectForm2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, BulkCreateSubjects: _BulkCreateSubjects2.default, DModal: _DModal2.default, Tabs: _Tabs2.default, DoFiltersFilter: _DoFiltersFilter2.default, Loader: _Loader2.default },
	  data: function data() {
	    return {
	      selectedTab: 'Aktiviteter',
	      selectedKlassFilters: [],
	      statusFilters: [],
	      selectedStatusFilters: [],
	      loadingSubjects: {},
	      subjectSearchQuery: '',
	      debounceTimer: null,
	      isCreateActivityModal: false,
	      editSubject: null,
	      isRefreshing: false
	    };
	  },
	
	  computed: {
	    tabsList: function tabsList() {
	      return [{ id: 'Aktiviteter', title: 'Aktiviteter' }, { id: 'Fag', title: 'Fag' }];
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.$store.getters.schoolYearId;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    userCalendarId: function userCalendarId() {
	      return this.user && this.user.user_calendar_id ? this.user.user_calendar_id : null;
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.subjects.isLoading;
	    },
	    isLoadingSubjects: function isLoadingSubjects() {
	      return this.$store.state.subjects.isLoadingSubjects;
	    },
	    isRefreshingOrLoadingSubjects: function isRefreshingOrLoadingSubjects() {
	      return this.isRefreshing || this.isLoadingSubjects;
	    },
	    subjects: function subjects() {
	      return this.$store.state.subjects.subjects;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    subjectsInKlassHash: function subjectsInKlassHash() {
	      return this.$store.getters.subjectsInKlassHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    subjectsInUserHash: function subjectsInUserHash() {
	      return this.$store.getters.subjectsInUserHash;
	    },
	    klassCalendars: function klassCalendars() {
	      var cals = [];
	      var seenIds = new _set2.default();
	      this.subjects.forEach(function (subject) {
	        subject.cals.forEach(function (cal) {
	          if (cal.calendar_type === 'klass' && !seenIds.has(cal.id)) {
	            seenIds.add(cal.id);
	            cals.push(cal);
	          }
	        });
	      });
	      return cals.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    klassTags: function klassTags() {
	      return this.klassCalendars.map(function (klassCalendar) {
	        return klassCalendar.name;
	      });
	    },
	    calsWithProps: function calsWithProps() {
	      var _this = this;
	
	      var klasses = this.klassCalendars;
	
	      return klasses.map(function (klass) {
	        var vSubjects = (_this.subjectsInKlassHash[klass.id] || []).map(function (subjectId) {
	          var subject = _this.subjectsInHash[subjectId] || {};
	
	          var calendarHours = null;
	
	          if (subject.subject_calendars) {
	            var match = subject.subject_calendars.find(function (sc) {
	              return sc.calendar_id === klass.id;
	            });
	            if (match) {
	              calendarHours = parseFloat(match.hours);
	            }
	          }
	
	          var fallbackHours = parseFloat(subject.hours);
	          var vHours = isNaN(calendarHours) ? fallbackHours : calendarHours;
	
	          return (0, _extends3.default)({}, subject, {
	            vHours: vHours
	          });
	        });
	
	        var sumHours = vSubjects.reduce(function (sum, subject) {
	          var raw = parseFloat(subject.hours);
	          return sum + (isNaN(raw) ? 0 : raw);
	        }, 0);
	
	        var sumVHours = vSubjects.reduce(function (sum, subject) {
	          return sum + (isNaN(subject.vHours) ? 0 : subject.vHours);
	        }, 0);
	
	        return (0, _extends3.default)({}, klass, {
	          vSubjects: vSubjects,
	          sumHours: parseFloat(sumHours.toFixed(2)),
	          sumVHours: parseFloat(sumVHours.toFixed(2))
	        });
	      });
	    },
	    filteredKlassCals: function filteredKlassCals() {
	      var _this2 = this;
	
	      var klasses = this.calsWithProps;
	
	      if (this.selectedKlassFilters.length > 0) {
	        klasses = klasses.filter(function (klass) {
	          return _this2.selectedKlassFilters.includes(klass.name);
	        });
	      }
	
	      return klasses.map(function (klass) {
	        var vSubjects = klass.vSubjects.filter(function (subject) {
	          var matchesStatusFilter = _this2.selectedTab === 'Fag' ? subject.subject_type === 'subject' || subject.subject_type === 'optional' || subject.subject_type === 'activity' : subject.subject_type === 'frame';
	
	          var matchesSearch = !_this2.subjectSearchQuery || subject.name.toLowerCase().includes(_this2.subjectSearchQuery.toLowerCase());
	
	          return matchesStatusFilter && matchesSearch;
	        });
	
	        var rawSumVHours = vSubjects.reduce(function (sum, subject) {
	          return sum + (isNaN(subject.vHours) ? 0 : subject.vHours);
	        }, 0);
	
	        var rawSumHours = vSubjects.reduce(function (sum, subject) {
	          if (subject.subject_type === 'activity') return sum;
	          var raw = parseFloat(subject.hours);
	          return sum + (isNaN(raw) ? 0 : raw);
	        }, 0);
	
	        return (0, _extends3.default)({}, klass, {
	          vSubjects: vSubjects,
	          vSubjectsSum: parseFloat(rawSumVHours.toFixed(2)),
	          vSubjectsSumRaw: parseFloat(rawSumHours.toFixed(2))
	        });
	      });
	    }
	  },
	  methods: {
	    updateSubject: function updateSubject(updatedSubject) {
	      updatedSubject['schoolId'] = this.schoolId;
	      updatedSubject['schoolYearId'] = this.activeSchoolYear.id;
	      this.$store.dispatch('updateSubject', updatedSubject);
	      this.closeEditSubjectModal();
	    },
	    closeEditSubjectModal: function closeEditSubjectModal() {
	      this.editSubject = null;
	    },
	    setEditSubject: function setEditSubject(editSubject) {
	      this.editSubject = (0, _assign2.default)({}, editSubject);
	    },
	    deleteSubject: function deleteSubject(editSubject) {
	      var deletedSubject = {
	        id: editSubject.id,
	        school_id: editSubject.school_id,
	        school_year_id: this.activeSchoolYear.id
	      };
	      deletedSubject['schoolYearId'] = this.activeSchoolYear.id;
	      this.$store.dispatch('deleteSubject', deletedSubject);
	      this.closeEditSubjectModal();
	    },
	    refreshReductions: function refreshReductions() {
	      var _this3 = this;
	
	      this.isRefreshing = true;
	      _docendo2.default.refreshSubjectReductions(this.schoolId, this.schoolYearId, function (success) {
	        _this3.isRefreshing = false;
	        _this3.$store.dispatch('readSubjects', _this3.schoolYearId);
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    setIsCreateActivityModal: function setIsCreateActivityModal(bool) {
	      this.isCreateActivityModal = bool;
	    },
	    onSelectTab: function onSelectTab(tab) {
	      this.selectedTab = tab;
	      this.subjectSearchQuery = '';
	    },
	    debounceSearch: function debounceSearch(event) {
	      var _this4 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        _this4.subjectSearchQuery = event.target.value;
	      }, 400);
	    },
	    toggleSelectedStatusFilters: function toggleSelectedStatusFilters(filter) {
	      var idx = this.selectedStatusFilters.indexOf(filter);
	      if (idx < 0) {
	        this.selectedStatusFilters.push(filter);
	      } else {
	        this.selectedStatusFilters.splice(idx, 1);
	      }
	    },
	    toggleKlassTag: function toggleKlassTag(filter) {
	      var idx = this.selectedKlassFilters.indexOf(filter);
	      if (idx < 0) {
	        this.selectedKlassFilters.push(filter);
	      } else {
	        this.selectedKlassFilters.splice(idx, 1);
	      }
	    },
	    getUserNames: function getUserNames(subjectId) {
	      var _this5 = this;
	
	      var calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : [];
	      if (!calIds || calIds.length < 1 || !calIds[0]) {
	        return '';
	      }
	      return calIds.filter(function (calId) {
	        return _this5.allCalendarsInHash[calId] && _this5.allCalendarsInHash[calId].type === 'user';
	      }).map(function (userCalId) {
	        return _this5.allCalendarsInHash[userCalId].name ? _this5.allCalendarsInHash[userCalId].name : '';
	      });
	    },
	    subjectHasTeachers: function subjectHasTeachers(subjectId) {
	      var _this6 = this;
	
	      var calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : [];
	      var hasTeachers = false;
	      calIds.forEach(function (calId) {
	        if (_this6.allCalendarsInHash[calId] && _this6.allCalendarsInHash[calId].type === 'user') {
	          hasTeachers = true;
	        }
	      });
	      return hasTeachers;
	    },
	    readSubjects: function readSubjects() {
	      if (this.schoolYearId) {
	        this.$store.dispatch('readSubjects', this.schoolYearId);
	        this.$store.dispatch('readReductions');
	      }
	    }
	  },
	  watch: {
	    schoolYearId: function schoolYearId(val) {
	      this.readSubjects();
	    }
	  },
	  mounted: function mounted() {
	    this.readSubjects();
	    var filters = ['Aktiviteter'];
	    this.$store.commit('SET_SUBJECT_TYPE_FILTER', filters);
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.debounceTimer) {
	      clearTimeout(this.debounceTimer);
	    }
	  }
	};

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _GrundskoleIndberetningUsers = __webpack_require__(1543);
	
	var _GrundskoleIndberetningUsers2 = _interopRequireDefault(_GrundskoleIndberetningUsers);
	
	var _GrundskoleIndberetningTimetal = __webpack_require__(137);
	
	var _GrundskoleIndberetningTimetal2 = _interopRequireDefault(_GrundskoleIndberetningTimetal);
	
	var _GrundskoleIndberetningRessource = __webpack_require__(1539);
	
	var _GrundskoleIndberetningRessource2 = _interopRequireDefault(_GrundskoleIndberetningRessource);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _GrundskoleIndberetningResume = __webpack_require__(366);
	
	var _GrundskoleIndberetningResume2 = _interopRequireDefault(_GrundskoleIndberetningResume);
	
	var _StilGuides = __webpack_require__(49);
	
	var _StilGuides2 = _interopRequireDefault(_StilGuides);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    StilGuides: _StilGuides2.default,
	    GrundskoleIndberetningResume: _GrundskoleIndberetningResume2.default,
	    ChangeSchoolYear: _ChangeSchoolYear2.default,
	    Loader: _Loader2.default, GrundskoleIndberetningUsers: _GrundskoleIndberetningUsers2.default, GrundskoleIndberetningTimetal: _GrundskoleIndberetningTimetal2.default, GrundskoleIndberetningRessource: _GrundskoleIndberetningRessource2.default
	  },
	  data: function data() {
	    return {
	      theActiveTab: 0,
	      stilData: [],
	      isLoadingStilData: false,
	      userEmailInput: '',
	      userEmailFormErrors: {},
	      isSavingUserEmail: false
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isUserLoaded: function isUserLoaded() {
	      return this.$store.state.isUserLoaded;
	    },
	    userHasNoEmail: function userHasNoEmail() {
	      return this.user && this.user.email === null;
	    },
	    isSaveButtonForUserEmailDisabled: function isSaveButtonForUserEmailDisabled() {
	      return this.userEmailInput.length < 3;
	    }
	  },
	  watch: {
	    user: function user() {
	      var _this = this;
	
	      if (this.userHasNoEmail) {
	        setTimeout(function () {
	          var el = _this.$refs.user_email_input;
	          if (el) {
	            _this.$refs.user_email_input.focus();
	          }
	        }, 0);
	        return;
	      }
	      this.isLoadingStilData = true;
	      _docendo2.default.showStilReport(this.schoolId, function (success) {
	        _this.isLoadingStilData = false;
	        _this.stilData = success;
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  },
	  methods: {
	    updateRessource: function updateRessource(ressourceSkema) {
	      var _this2 = this;
	
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      stilData['ressourceskema'] = ressourceSkema;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this2.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    setTolaerer: function setTolaerer(obj) {
	      var _this3 = this;
	
	      var setting = obj.godkendelseskode === 'J' ? 'N' : 'J';
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj._type && stilTing.klassetype === obj.klassetype && stilTing.godkendelsestype === obj.godkendelsestype && stilTing.klassetrin === obj.klassetrin;
	      });
	      stilData['undervisningskema'][idx]['godkendelseskode'] = setting;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this3.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    setForanstaltning: function setForanstaltning(obj) {
	      var _this4 = this;
	
	      var setting = obj.godkendelseskode === 'J' ? 'N' : 'J';
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj._type && stilTing.klassetype === obj.klassetype && stilTing.godkendelsestype === obj.godkendelsestype && stilTing.klassetrin === obj.klassetrin;
	      });
	      stilData['undervisningskema'][idx]['godkendelseskode'] = setting;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this4.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    updatePraktik: function updatePraktik(obj) {
	      var _this5 = this;
	
	      var setting = obj.praktikkode === 'J' ? 'N' : 'J';
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj.v_fag._type;
	      });
	      stilData['undervisningskema'][idx]['praktikkode'] = setting;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this5.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    updateKonfirmation: function updateKonfirmation(obj) {
	      var _this6 = this;
	
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj.v_fag._type;
	      });
	
	      stilData['undervisningskema'][idx]['klassetrin'] = obj.value;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this6.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    updateSubject: function updateSubject(obj) {
	      var _this7 = this;
	
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj.originalObject._type && stilTing.klassetype === obj.originalObject.klassetype && stilTing.fagkode === obj.originalObject.fagkode && stilTing.klassetrin === obj.originalObject.klassetrin;
	      });
	      stilData['undervisningskema'][idx][obj.toUpdate] = obj.value * 1;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this7.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    nulstilKlasse: function nulstilKlasse(grade) {
	      var _this8 = this;
	
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var subjects = stilData['undervisningskema'].filter(function (subject) {
	        return subject._type === 'undervisningstid' && subject.klassetrin === grade.value * 1;
	      });
	      subjects.forEach(function (subject) {
	        var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	          return stilTing._type === subject._type && stilTing.klassetype === subject.klassetype && stilTing.fagkode === subject.fagkode && stilTing.klassetrin === subject.klassetrin;
	        });
	        stilData['undervisningskema'][idx]['klokketimer'] = 0;
	        _docendo2.default.updateStilReport(_this8.schoolId, stilData, function (success) {
	          _this8.stilData = success;
	        }, function (failure) {
	          console.log('failure', failure);
	        });
	      });
	    },
	    update: function update(obj) {
	      var _this9 = this;
	
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData[obj.type].findIndex(function (elevtal) {
	        return elevtal._type === obj.cell._type && elevtal.elevtaltype === obj.cell.elevtaltype && elevtal.klassetrin === obj.cell.klassetrin;
	      });
	      stilData[obj.type][idx]['antal'] = obj.num * 1;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this9.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    submitUserEmail: function submitUserEmail() {
	      var _this10 = this;
	
	      this.formValidation();
	      if ((0, _keys2.default)(this.userEmailFormErrors).length > 0) {
	        return;
	      }
	      this.isSavingUserEmail = true;
	      var changes = { email: this.userEmailInput };
	      _docendo2.default.updateUser(changes, function (success) {
	        _eventbus2.default.toast = { text: 'Emailen er gemt', 'success': true };
	        var obj = {
	          prop: 'email',
	          email: success.email
	        };
	        _this10.$store.commit('updateUserProp', obj);
	        _this10.isSavingUserEmail = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Email er allerede brugt', 'success': false };
	        _this10.isSavingUserEmail = false;
	      });
	    },
	    formValidation: function formValidation() {
	      this.userEmailFormErrors = {};
	      if (!this.validateEmail(this.userEmailInput)) {
	        this.$set(this.userEmailFormErrors, 'email', 'Er ikke en gyldig email');
	      }
	    },
	    validateEmail: function validateEmail(email) {
	      var emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
	      return email.trim() !== '' && emailRegex.test(email);
	    },
	    removeErrors: function removeErrors(title) {
	      this.$delete(this.userEmailFormErrors, title);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUser');
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('getUsersFromSchoolId', this.schoolId);
	    this.$store.dispatch('readSchoolYears', this.schoolId);
	  }
	};

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _GrundskoleIndberetningRessourceInsertModal = __webpack_require__(1540);
	
	var _GrundskoleIndberetningRessourceInsertModal2 = _interopRequireDefault(_GrundskoleIndberetningRessourceInsertModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _GrundskoleIndberetningRessourceOverview = __webpack_require__(365);
	
	var _GrundskoleIndberetningRessourceOverview2 = _interopRequireDefault(_GrundskoleIndberetningRessourceOverview);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _UserTasks = __webpack_require__(54);
	
	var _UserTasks2 = _interopRequireDefault(_UserTasks);
	
	var _StilRessourceTasks = __webpack_require__(1556);
	
	var _StilRessourceTasks2 = _interopRequireDefault(_StilRessourceTasks);
	
	var _StilGuides = __webpack_require__(49);
	
	var _StilGuides2 = _interopRequireDefault(_StilGuides);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var klasseType = {
	  stil_hours_40_B: {
	    klassetype: '40',
	    tidstype: 'B'
	  },
	  stil_hours_50_B: {
	    klassetype: '50',
	    tidstype: 'B'
	  },
	  stil_hours_40_A1: {
	    klassetype: '40',
	    tidstype: 'A1'
	  },
	  stil_hours_50_A1: {
	    klassetype: '50',
	    tidstype: 'A1'
	  },
	  stil_hours_40_A22: {
	    klassetype: '40',
	    tidstype: 'A22'
	  },
	  stil_hours_50_A22: {
	    klassetype: '50',
	    tidstype: 'A22'
	  },
	  stil_hours_40_A33: {
	    klassetype: '40',
	    tidstype: 'A33'
	  },
	  stil_hours_50_A33: {
	    klassetype: '50',
	    tidstype: 'A33'
	  }
	};
	
	exports.default = {
	  components: {
	    StilGuides: _StilGuides2.default,
	    StilRessourceTasks: _StilRessourceTasks2.default,
	    DModal: _DModal2.default, UserTasks: _UserTasks2.default, GrundskoleIndberetningRessourceOverview: _GrundskoleIndberetningRessourceOverview2.default, GrundskoleIndberetningRessourceInsertModal: _GrundskoleIndberetningRessourceInsertModal2.default
	  },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    stilData: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      activeUserFilter: '',
	      isInsertOnMore: false,
	      theActiveUserId: null,
	      selectedUsers: []
	    };
	  },
	
	  computed: {
	    selectedUserObjects: function selectedUserObjects() {
	      var _this = this;
	
	      return this.selectedUsers.map(function (userId) {
	        var idx = _this.usersWithVProps.findIndex(function (user) {
	          return user.id === userId;
	        });
	        return _this.usersWithVProps[idx];
	      });
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    stilStillinger: function stilStillinger() {
	      return [{ value: '', title: 'Alle' }, { value: 'LA', title: 'Lærer' }, { value: 'BH', title: 'Børnehaveklasseleder' }, { value: 'PA', title: 'Pædagog' }, { value: 'LE', title: 'Leder' }, { value: 'AN', title: 'Andre med undervisningsopgaver', shortTitle: 'Andre med UV' }, { value: 'undtaget', title: 'Ingen undervisningsopgaver', shortTitle: 'Ingen UV' }];
	    },
	    stilStillingerWithCount: function stilStillingerWithCount() {
	      var _this2 = this;
	
	      return this.stilStillinger.map(function (stilling) {
	        if (!stilling.value) {
	          _this2.$set(stilling, 'count', _this2.usersWithVProps.length);
	        } else {
	          _this2.$set(stilling, 'count', _this2.usersWithVProps.filter(function (user) {
	            return user.v_stil_stilling && user.v_stil_stilling === stilling.value;
	          }).length);
	        }
	        return stilling;
	      });
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    usersWithVProps: function usersWithVProps() {
	      var _this3 = this;
	
	      return this.users.map(function (user) {
	        var birthday = null;
	        if (user.dob && user.dob.length > 6) {
	          birthday = user.dob;
	        }
	        _this3.$set(user, 'v_birthday', birthday);
	        var stilStilling = null;
	        if (user.custom_data && user.custom_data['schools'] && user.custom_data['schools'][_this3.schoolId] && user.custom_data['schools'][_this3.schoolId]['stilling']) {
	          stilStilling = user.custom_data['schools'][_this3.schoolId]['stilling'];
	        }
	        _this3.$set(user, 'v_stil_stilling', stilStilling);
	        _this3.$set(user, 'v_stil_stilling_title', _this3.getStilStillingTitle(stilStilling));
	        _this3.$set(user, 'v_stil_hours_total_normal', _this3.getUserSetting(user, 'stil_hours_40_B'));
	        _this3.$set(user, 'v_stil_hours_total_special', _this3.getUserSetting(user, 'stil_hours_50_B'));
	        _this3.$set(user, 'v_stil_hours_fag_normal', _this3.getUserSetting(user, 'stil_hours_40_A1'));
	        _this3.$set(user, 'v_stil_hours_fag_special', _this3.getUserSetting(user, 'stil_hours_50_A1'));
	        _this3.$set(user, 'v_stil_hours_uuv_normal', _this3.getUserSetting(user, 'stil_hours_40_A22'));
	        _this3.$set(user, 'v_stil_hours_uuv_special', _this3.getUserSetting(user, 'stil_hours_50_A22'));
	        _this3.$set(user, 'v_stil_hours_other_normal', _this3.getUserSetting(user, 'stil_hours_40_A33'));
	        _this3.$set(user, 'v_stil_hours_other_special', _this3.getUserSetting(user, 'stil_hours_50_A33'));
	        return user;
	      });
	    },
	    unfilledUsers: function unfilledUsers() {
	      return this.usersWithVProps.filter(function (user) {
	        return !user.gender || !user.v_birthday || !user.v_stil_stilling;
	      });
	    },
	    filteredUsersWithVProps: function filteredUsersWithVProps() {
	      var _this4 = this;
	
	      if (!this.activeUserFilter || this.activeUserFilter.length < 1) {
	        return this.usersWithVProps;
	      }
	      return this.usersWithVProps.filter(function (user) {
	        return user.v_stil_stilling && user.v_stil_stilling === _this4.activeUserFilter;
	      });
	    }
	  },
	  methods: {
	    updateRessourceFromModal: function updateRessourceFromModal(obj) {
	      var _this5 = this;
	
	      var changes = obj.change;
	      var user = obj.user;
	      var skemaer = this.stilData['ressourceskema'];
	
	      var _loop = function _loop(updateProp) {
	        user['v_' + updateProp] = changes[updateProp];
	        var idx = skemaer.findIndex(function (skema) {
	          return skema._type === 'ressource' && skema.tidstype === klasseType[updateProp]['tidstype'] && skema.personaletype === user.v_stil_stilling && skema.klassetype === klasseType[updateProp]['klassetype'];
	        });
	        skemaer[idx]['timer'] = _this5.getHoursPerPerson(user, user.v_stil_stilling, updateProp);
	      };
	
	      for (var updateProp in changes) {
	        _loop(updateProp);
	      }
	      this.$emit('updateStil', skemaer);
	    },
	    updateRessource: function updateRessource(user, updateProp) {
	      var skemaer = this.stilData['ressourceskema'];
	      var idx = skemaer.findIndex(function (skema) {
	        return skema._type === 'ressource' && skema.tidstype === klasseType[updateProp]['tidstype'] && skema.personaletype === user.v_stil_stilling && skema.klassetype === klasseType[updateProp]['klassetype'];
	      });
	      skemaer[idx]['timer'] = this.getHoursPerPerson(user, user.v_stil_stilling, updateProp);
	      this.$emit('updateStil', skemaer);
	    },
	    getHoursPerPerson: function getHoursPerPerson(user, stilStilling, roleType) {
	      var userSetting = 'v_' + roleType;
	      var users = this.users.filter(function (uUser) {
	        return uUser.v_stil_stilling === stilStilling && uUser.id !== user.id;
	      });
	      users.push(user);
	      var arrOfAmounts = users.map(function (user) {
	        return user[userSetting];
	      }).filter(function (val) {
	        return val && val * 1 > 0;
	      });
	      return arrOfAmounts.length > 0 ? arrOfAmounts.reduce(function (num, sum) {
	        return sum * 1 + num * 1;
	      }) : 0;
	    },
	    closeInsertOnMore: function closeInsertOnMore() {
	      this.selectedUsers = [];
	      this.isInsertOnMore = false;
	    },
	    toggleAll: function toggleAll() {
	      var _this6 = this;
	
	      if (this.selectedUsers.length > 0) {
	        this.selectedUsers = [];
	      } else {
	        this.selectedUsers = [];
	        this.filteredUsersWithVProps.forEach(function (user) {
	          return _this6.selectedUsers.push(user.id);
	        });
	      }
	    },
	    selectUser: function selectUser(userId) {
	      var idx = this.selectedUsers.indexOf(userId);
	      if (idx < 0) {
	        this.selectedUsers.push(userId);
	      } else {
	        this.selectedUsers.splice(idx, 1);
	      }
	    },
	    getIsUserSelected: function getIsUserSelected(userId) {
	      return this.selectedUsers.indexOf(userId) > -1;
	    },
	    setTheActiveUserId: function setTheActiveUserId(userId) {
	      if (this.theActiveUserId === userId) {
	        this.theActiveUserId = null;
	      } else {
	        this.theActiveUserId = userId;
	      }
	    },
	    getStilStillingTitle: function getStilStillingTitle(val) {
	      var title = '';
	      if (!val || val.length === 0) {
	        return title;
	      }
	      var idx = this.stilStillinger.findIndex(function (stilling) {
	        return stilling.value === val;
	      });
	      if (idx > -1) {
	        return this.stilStillinger[idx].shortTitle ? this.stilStillinger[idx].shortTitle : this.stilStillinger[idx].title;
	      } else {
	        return title;
	      }
	    },
	    getUserSetting: function getUserSetting(user, setting) {
	      var customData = user.custom_data;
	      if (customData['schools'] && customData['schools'][this.schoolId] && customData['schools'][this.schoolId][[setting]]) {
	        return customData['schools'][this.schoolId][[setting]];
	      } else {
	        return '';
	      }
	    },
	    updateUser: function updateUser(user, change, val) {
	      var _this7 = this;
	
	      var text = val.replace(',', '.');
	      var numberInput = text * 1;
	      if (isNaN(numberInput)) {
	        _eventbus2.default.toast = { text: 'Skal være et tal', success: false };
	        return;
	      }
	      var customData = user.custom_data;
	      var changes = {};
	      if (!customData['schools']) {
	        customData.schools = (0, _defineProperty3.default)({}, this.schoolId, (0, _defineProperty3.default)({}, change, numberInput));
	      }
	      if (customData['schools'] && !customData['schools'][this.schoolId]) {
	        customData['schools'][this.schoolId] = (0, _defineProperty3.default)({}, change, numberInput);
	      }
	      if (customData['schools'] && customData['schools'][this.schoolId]) {
	        if (val.length < 1) {
	          delete customData['schools'][this.schoolId][[change]];
	        } else {
	          customData['schools'][this.schoolId][[change]] = numberInput;
	        }
	      }
	      changes['custom_data'] = customData;
	      _docendo2.default.updateUsers(this.schoolId, user.id, changes, function (data) {
	        _this7.$store.commit('updateSchoolUser', data);
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  }
	};

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    selectedUsers: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    schoolId: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isSaving: false,
	      numberOfUsersSaved: 0,
	      items: [{ id: 'B', title: 'Antal arbejdstimer i alt', nHours: 1924, sHours: null }, { id: 'A1', title: 'Fagopdelt undervisning', nHours: null, sHours: null }, { id: 'A22', title: 'Understøttende undervisning', nHours: null, sHours: null }, { id: 'A33', title: 'Øvrig tid med eleverne', nHours: null, sHours: null }]
	    };
	  },
	
	  computed: {
	    itemsToSave: function itemsToSave() {
	      var changes = {};
	      this.items.forEach(function (item) {
	        if (item.id === 'B') {
	          changes['stil_hours_40_B'] = item.nHours;
	          changes['stil_hours_50_B'] = item.sHours;
	        }
	        if (item.id === 'A1') {
	          changes['stil_hours_40_A1'] = item.nHours;
	          changes['stil_hours_50_A1'] = item.sHours;
	        }
	        if (item.id === 'A22') {
	          changes['stil_hours_40_A22'] = item.nHours;
	          changes['stil_hours_50_A22'] = item.sHours;
	        }
	        if (item.id === 'A33') {
	          changes['stil_hours_40_A33'] = item.nHours;
	          changes['stil_hours_50_A33'] = item.sHours;
	        }
	      });
	      return changes;
	    }
	  },
	  methods: {
	    close: function close() {
	      this.$emit('close');
	    },
	    save: function save() {
	      this.updateUsers();
	      this.$emit('save', this.items);
	    },
	    updateUsers: function updateUsers() {
	      var _this = this;
	
	      this.isSaving = true;
	      this.selectedUsers.forEach(function (user) {
	        _this.updateUser(user);
	      });
	    },
	    updateUser: function updateUser(user) {
	      var _this2 = this;
	
	      var customData = user.custom_data;
	      var changes = {};
	      for (var change in this.itemsToSave) {
	        var val = this.itemsToSave[change];
	        if (!customData['schools']) {
	          customData.schools = (0, _defineProperty3.default)({}, this.schoolId, (0, _defineProperty3.default)({}, change, val));
	        }
	        if (customData['schools'] && !customData['schools'][this.schoolId]) {
	          customData['schools'][this.schoolId] = (0, _defineProperty3.default)({}, change, val);
	        }
	        if (customData['schools'] && customData['schools'][this.schoolId]) {
	          if (!val || val.length < 1) {
	            delete customData['schools'][this.schoolId][[change]];
	          } else {
	            customData['schools'][this.schoolId][[change]] = val;
	          }
	        }
	      }
	      changes['custom_data'] = customData;
	      _docendo2.default.updateUsers(this.schoolId, user.id, changes, function (data) {
	        _this2.$store.commit('updateSchoolUser', data);
	        _this2.numberOfUsersSaved++;
	        if (_this2.numberOfUsersSaved === _this2.selectedUsers.length) {
	          _this2.close();
	        }
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  }
	};

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    stilData: {
	      type: Object,
	      default: function _default() {}
	    },
	    users: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  computed: {
	    stilDataRessourceSkema: function stilDataRessourceSkema() {
	      return this.stilData && this.stilData.ressourceskema ? this.stilData.ressourceskema : [];
	    },
	    userTypes: function userTypes() {
	      return [{ id: 'LE', title: 'Ledere' }, { id: 'LA', title: 'Lærere' }, { id: 'BH', title: 'BH klasseledere' }, { id: 'PA', title: 'Pædagoger' }, { id: 'AN', title: 'Andre med undervisningsopgaver' }];
	    },
	    stilDataRess: function stilDataRess() {
	      var _this = this;
	
	      return this.userTypes.map(function (userType) {
	        var userTypeObj = {
	          id: userType.id,
	          title: userType.title,
	          number_of_usertype: _this.getNumberOfUsertype(userType.id),
	          years_of_work: _this.getYearsOfWork(userType.id),
	          stil_hours_40_B: _this.getHoursPerUserType(userType.id, '40', 'B'),
	          stil_hours_50_B: _this.getHoursPerUserType(userType.id, '50', 'B'),
	          stil_hours_40_A1: _this.getHoursPerUserType(userType.id, '40', 'A1'),
	          stil_hours_50_A1: _this.getHoursPerUserType(userType.id, '50', 'A1'),
	          stil_hours_40_A22: _this.getHoursPerUserType(userType.id, '40', 'A22'),
	          stil_hours_50_A22: _this.getHoursPerUserType(userType.id, '50', 'A22'),
	          stil_hours_40_A33: _this.getHoursPerUserType(userType.id, '40', 'A33'),
	          stil_hours_50_A33: _this.getHoursPerUserType(userType.id, '50', 'A33')
	        };
	        return userTypeObj;
	      });
	    }
	  },
	  methods: {
	    getNumberOfUsertype: function getNumberOfUsertype(personaletype) {
	      return this.users.filter(function (user) {
	        return user.v_stil_stilling === personaletype;
	      }).length;
	    },
	    getHoursPerUserType: function getHoursPerUserType(personaletype, klassetype, tidstype) {
	      var idx = this.stilDataRessourceSkema.findIndex(function (skema) {
	        return skema.personaletype === personaletype && skema.klassetype === klassetype && personaletype && skema.tidstype === tidstype;
	      });
	      return idx > -1 ? this.stilDataRessourceSkema[idx]['timer'] : 0;
	    },
	    getYearsOfWork: function getYearsOfWork(personaletype) {
	      var normalKlasse = this.getHoursPerUserType(personaletype, '40', 'B') * 1;
	      var specialKlasse = this.getHoursPerUserType(personaletype, '50', 'B') * 1;
	      var sum = normalKlasse + specialKlasse;
	      return (sum / 1924).toFixed(2);
	    }
	  }
	};

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ResumePersonaleSkema = __webpack_require__(1555);
	
	var _ResumePersonaleSkema2 = _interopRequireDefault(_ResumePersonaleSkema);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _GrundskoleIndberetningTimetal = __webpack_require__(137);
	
	var _GrundskoleIndberetningTimetal2 = _interopRequireDefault(_GrundskoleIndberetningTimetal);
	
	var _GrundskoleIndberetningRessourceOverview = __webpack_require__(365);
	
	var _GrundskoleIndberetningRessourceOverview2 = _interopRequireDefault(_GrundskoleIndberetningRessourceOverview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { GrundskoleIndberetningRessourceOverview: _GrundskoleIndberetningRessourceOverview2.default, GrundskoleIndberetningTimetal: _GrundskoleIndberetningTimetal2.default, ResumePersonaleSkema: _ResumePersonaleSkema2.default, Loader: _Loader2.default },
	  data: function data() {
	    return {
	      isSendingToStil: false,
	      stilData: {},
	      isLoadingStilData: true
	    };
	  },
	
	  computed: {
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    ressourceskema: function ressourceskema() {
	      return this.stilData['ressourceskema'] ? this.stilData['ressourceskema'] : [];
	    },
	    undervisningskema: function undervisningskema() {
	      return this.stilData['undervisningskema'] ? this.stilData['undervisningskema'] : [];
	    }
	  },
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      this.isSendingToStil = true;
	      _docendo2.default.submitStilReport(this.schoolId, function (success) {
	        _this.isSendingToStil = false;
	        _eventbus2.default.toast = { text: 'Grundskoleindberetning er sendt til STIL', 'success': true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Noget gik galt', 'success': false };
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.isLoadingStilData = true;
	    _docendo2.default.showStilReport(this.schoolId, function (success) {
	      _this2.isLoadingStilData = false;
	      _this2.stilData = success;
	      console.log('success', success);
	    }, function (failure) {
	      console.log('failure');
	    });
	  }
	};

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GrundskoleIndberetningTimetalFag = __webpack_require__(1541);
	
	var _GrundskoleIndberetningTimetalFag2 = _interopRequireDefault(_GrundskoleIndberetningTimetalFag);
	
	var _GrundskoleIndberetningTimetalFagSpecial = __webpack_require__(1542);
	
	var _GrundskoleIndberetningTimetalFagSpecial2 = _interopRequireDefault(_GrundskoleIndberetningTimetalFagSpecial);
	
	var _StilGuides = __webpack_require__(49);
	
	var _StilGuides2 = _interopRequireDefault(_StilGuides);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { StilGuides: _StilGuides2.default, GrundskoleIndberetningTimetalFagSpecial: _GrundskoleIndberetningTimetalFagSpecial2.default, GrundskoleIndberetningTimetalFag: _GrundskoleIndberetningTimetalFag2.default },
	  props: {
	    stilData: {
	      type: Object,
	      default: function _default() {}
	    },
	    isReadOnly: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      klasstype: {
	        40: 'Normalklasse',
	        50: 'Specialklasse'
	      },
	      grades: [{ value: 1, title: '1.' }, { value: 2, title: '2.' }, { value: 3, title: '3.' }, { value: 4, title: '4.' }, { value: 5, title: '5.' }, { value: 6, title: '6.' }, { value: 7, title: '7.' }, { value: 8, title: '8.' }, { value: 9, title: '9.' }],
	      fag: {
	        110: 'Dansk',
	        120: 'Engelsk',
	        130: 'Tysk',
	        140: 'Fransk',
	        170: 'Kristendomskundskab',
	        171: 'Kristendomskundskab/religion (10. klasse)',
	        181: 'Historie',
	        182: 'Samfundsfag',
	        210: 'Idræt',
	        220: 'Musik',
	        230: 'Billedkunst',
	        902: 'Håndværk og design samt madkundskab',
	        310: 'Matematik',
	        320: 'Fysik/Kemi',
	        330: 'Geografi',
	        340: 'Biologi',
	        350: 'Natur/teknologi',
	        511: 'Praktisk/Musisk valgfag: Håndværk/design',
	        520: 'Praktisk/Musisk valgfag: Musik',
	        531: 'Praktisk/Musisk valgfag: Billedkunst',
	        540: 'Praktisk/Musisk valgfag: Madkundskab',
	        589: 'Andre tilbudsfag / valgfag',
	        600: 'Børnehaveklasse',
	        799: 'Øvrige fag',
	        800: 'Understøttende undervisning'
	      }
	    };
	  },
	
	  computed: {
	    undervisningskema: function undervisningskema() {
	      return this.stilData && this.stilData['undervisningskema'] ? this.stilData['undervisningskema'] : [];
	    },
	    fagFraStil: function fagFraStil() {
	      var filteredKlassetrin = [0, '0', 10, '10'];
	      return this.stilData.undervisningskema.filter(function (type) {
	        return type._type === 'undervisningstid' && type.klassetype === '40' && !filteredKlassetrin.includes(type.klassetrin);
	      });
	    }
	  },
	  methods: {
	    updateCell: function updateCell(type, cell, num) {
	      var obj = { type: type, cell: cell, num: num };
	      this.$emit('update', obj);
	    },
	    updateSubject: function updateSubject(obj) {
	      this.$emit('updateSubject', obj);
	    },
	    updateKonfirmation: function updateKonfirmation(obj) {
	      this.$emit('updateKonfirmation', obj);
	    },
	    updatePraktik: function updatePraktik(fag) {
	      this.$emit('updatePraktik', fag);
	    },
	    setTolaerer: function setTolaerer(fag) {
	      this.$emit('setTolaerer', fag);
	    },
	    setForanstaltning: function setForanstaltning(foranstaltning) {
	      this.$emit('setForanstaltning', foranstaltning);
	    },
	    nulstilKlasse: function nulstilKlasse(grade) {
	      this.$emit('nulstilKlasse', grade);
	    }
	  }
	};

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(35);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(50);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    fagFraStil: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    undervisningskema: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isReadOnly: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      fag: [{
	        _type: 'undervisningstid', fagkode: '600', title: 'Børnehaveklasse', klasser: [],
	        obligatorisk: { 0: true }
	      }, {
	        _type: 'undervisningstid',
	        fagkode: '110',
	        title: 'Dansk',
	        klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '120', title: 'Engelsk', klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '130', title: 'Tysk', klasser: [],
	        obligatorisk: { 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '140', title: 'Fransk', klasser: [],
	        obligatorisk: { 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '181', title: 'Historie', klasser: [],
	        obligatorisk: { 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '170', title: 'Kristendomskundskab', klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, { _type: 'konfirmation', title: 'Hvor finder konfirmationsforberedelsen sted?', klassetrin: 7, klasser: [] }, {
	        _type: 'undervisningstid',
	        fagkode: '182',
	        title: 'Samfundsfag',
	        klasser: [],
	        obligatorisk: { 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '310', title: 'Matematik', klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '350', title: 'Natur/teknologi', klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '330', title: 'Geografi', klasser: [],
	        obligatorisk: { 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '340', title: 'Biologi', klasser: [],
	        obligatorisk: { 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '320', title: 'Fysik/Kemi', klasser: [],
	        obligatorisk: { 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '210', title: 'Idræt', klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '220', title: 'Musik', klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '230', title: 'Billedkunst', klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '902', title: 'Håndværk og design samt madkundskab', klasser: [],
	        obligatorisk: { 3: true, 4: true, 5: true, 6: true, 7: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '589', title: 'Valgfag', klasser: [],
	        obligatorisk: { 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '511', title: 'Praktisk/Musisk valgfag: Håndværk/ design', klasser: [],
	        obligatorisk: { 7: true, 8: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '520', title: 'Praktisk/Musisk valgfag: Musik', klasser: [],
	        obligatorisk: { 7: true, 8: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '531', title: 'Praktisk/Musisk valgfag: Billedkunst', klasser: [],
	        obligatorisk: { 7: true, 8: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '540', title: 'Praktisk/Musisk valgfag: Madkundskab', klasser: [],
	        obligatorisk: { 7: true, 8: true }
	      }],
	      klasstype: {
	        40: 'Normalklasse',
	        50: 'Specialklasse'
	      },
	      grades: [{ value: '1', title: '1.' }, { value: '2', title: '2.' }, { value: '3', title: '3.' }, { value: '4', title: '4.' }, { value: '5', title: '5.' }, { value: '6', title: '6.' }, { value: '7', title: '7.' }, { value: '8', title: '8.' }, { value: '9', title: '9.' }],
	      minimumFagopdelt: {
	        1: 750,
	        2: 780,
	        3: 810,
	        4: 870,
	        5: 930,
	        6: 930,
	        7: 960,
	        8: 990,
	        9: 990
	      },
	      totalMinimum: {
	        1: 1110,
	        2: 1110,
	        3: 1110,
	        4: 1320,
	        5: 1320,
	        6: 1320,
	        7: 1400,
	        8: 1400,
	        9: 1400
	      },
	      understottende: [{
	        _type: 'undervisningstid',
	        fagkode: '800',
	        title: 'Understøttende undervisning i alt inkl. alle pauser',
	        klasser: []
	      }],
	      tolaererOrdning: [{
	        _type: 'tolaerer',
	        godkendelsestype: 'b',
	        title: 'Har kommunalbestyrelsen godkendt, at en del af den understøttende undervisning konverteres til ekstra personale i normalklasser jf. §16b?',
	        klasser: []
	      }, {
	        _type: 'tolaerer',
	        godkendelsestype: 'd',
	        title: 'Har kommunalbestyrelsen godkendt, at en del af den understøttende undervisning konverteres til ekstra personale i normalklasser jf. §16d?',
	        klasser: []
	      }],
	      foranstaltninger: [{
	        _type: 'foranstaltninger',
	        title: 'Har kommunalbestyrelsen godkendt, at en del af den understøttende undervisning konverteres til ekstra personale i normalklasser jf. §16e?',
	        klasser: []
	      }],
	      valgfagsFagKoder: [511, 520, 531, 540],
	      tyskOgFranskKoder: [130, 140]
	    };
	  },
	
	  computed: {
	    foranstaltningerFraStil: function foranstaltningerFraStil() {
	      return this.undervisningskema.filter(function (skema) {
	        return skema._type === 'foranstaltninger' && skema.klassetype === '40';
	      });
	    },
	    foranstaltningerMedProps: function foranstaltningerMedProps() {
	      var _this = this;
	
	      return this.foranstaltninger.map(function (foranstaltning) {
	        foranstaltning.klasser = [];
	        _this.grades.forEach(function (grade) {
	          var idx = _this.foranstaltningerFraStil.findIndex(function (faget) {
	            return faget.klassetrin * 1 === grade.value * 1;
	          });
	          foranstaltning.klasser.push(_this.foranstaltningerFraStil[idx]);
	        });
	        return foranstaltning;
	      });
	    },
	    tolaerer: function tolaerer() {
	      return this.undervisningskema.filter(function (skema) {
	        return skema._type === 'tolaerer' && skema.klassetype === '40';
	      });
	    },
	    tolaererArr: function tolaererArr() {
	      var _this2 = this;
	
	      return this.tolaererOrdning.map(function (toLaerer) {
	        var arr = _this2.tolaerer.filter(function (obj) {
	          return obj.godkendelsestype === toLaerer.godkendelsestype;
	        });
	        toLaerer.klasser = [];
	        _this2.grades.forEach(function (grade) {
	          var idx = arr.findIndex(function (faget) {
	            return faget.klassetrin * 1 === grade.value * 1;
	          });
	          toLaerer.klasser.push(arr[idx]);
	        });
	        return toLaerer;
	      });
	    },
	    hojesteValgfag: function hojesteValgfag() {
	      var _this3 = this;
	
	      var valgfagene = this.fagMedVProps.filter(function (fag) {
	        var fagKode = fag.fagkode * 1;
	        return fag._type === 'undervisningstid' && _this3.valgfagsFagKoder.includes(fagKode);
	      });
	      var hoursInGrades = {
	        1: 0,
	        2: 0,
	        3: 0,
	        4: 0,
	        5: 0,
	        6: 0,
	        7: 0,
	        8: 0,
	        9: 0
	      };
	      valgfagene.forEach(function (valgfag) {
	        valgfag.klasser.forEach(function (klasse) {
	          if (klasse && klasse.num) {
	            var klassetrin = klasse.v_originalObject.klassetrin;
	            var hoursInKlasse = parseFloat(klasse.num);
	
	            if (klassetrin in hoursInGrades && hoursInKlasse > hoursInGrades[klassetrin]) {
	              hoursInGrades[klassetrin] = hoursInKlasse;
	            }
	          }
	        });
	      });
	      return hoursInGrades;
	    },
	    highestTyskFransk: function highestTyskFransk() {
	      var subjectCodesForGermanAndFrenchToCheckForHighestNumber = this.tyskOgFranskKoder;
	      var tyskFranskFag = this.fagMedVProps.filter(function (fag) {
	        var fagKode = parseInt(fag.fagkode, 10);
	        return fag._type === 'undervisningstid' && subjectCodesForGermanAndFrenchToCheckForHighestNumber.includes(fagKode);
	      });
	      var hoursInGrades = {
	        1: 0,
	        2: 0,
	        3: 0,
	        4: 0,
	        5: 0,
	        6: 0,
	        7: 0,
	        8: 0,
	        9: 0
	      };
	
	      tyskFranskFag.forEach(function (fag) {
	        fag.klasser.forEach(function (klasse) {
	          if (klasse && klasse.num && klasse.v_originalObject && klasse.v_originalObject.klassetrin) {
	            var klassetrin = parseInt(klasse.v_originalObject.klassetrin, 10);
	            var hoursInKlasse = parseFloat(klasse.num);
	            if (klassetrin in hoursInGrades && hoursInKlasse > hoursInGrades[klassetrin]) {
	              hoursInGrades[klassetrin] = hoursInKlasse;
	            }
	          }
	        });
	      });
	
	      return Object.fromEntries((0, _entries2.default)(hoursInGrades).filter(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            klassetrin = _ref2[0],
	            hours = _ref2[1];
	
	        return hours > 0;
	      }));
	    },
	    obligatoriskFagopdelt: function obligatoriskFagopdelt() {
	      var _this4 = this;
	
	      var fagUdenValgfag = this.fagMedVProps.filter(function (fag) {
	        var fagKode = fag.fagkode * 1;
	        return fag._type === 'undervisningstid' && !_this4.valgfagsFagKoder.includes(fagKode) && !_this4.tyskOgFranskKoder.includes(fagKode);
	      });
	      var hoursInGrades = {
	        1: 0,
	        2: 0,
	        3: 0,
	        4: 0,
	        5: 0,
	        6: 0,
	        7: 0,
	        8: 0,
	        9: 0
	      };
	      fagUdenValgfag.forEach(function (hvertFag) {
	        hvertFag.klasser.forEach(function (klasse, key) {
	          if (klasse && klasse.num && (klasse.v_obligatorisk || key === 10)) {
	            var klassetrin = klasse.v_originalObject.klassetrin;
	            hoursInGrades[klassetrin] += klasse.num;
	          }
	        });
	      });
	
	      var highestTyskFransk = this.highestTyskFransk;
	      (0, _keys2.default)(hoursInGrades).forEach(function (klassetrin) {
	        if (highestTyskFransk[klassetrin]) {
	          hoursInGrades[klassetrin] += highestTyskFransk[klassetrin];
	        }
	      });
	
	      var highestValgfag = this.hojesteValgfag;
	      (0, _keys2.default)(hoursInGrades).forEach(function (klassetrin) {
	        if (highestValgfag[klassetrin]) {
	          hoursInGrades[klassetrin] += highestValgfag[klassetrin];
	        }
	      });
	      return hoursInGrades;
	    },
	    sammentaelling: function sammentaelling() {
	      var _this5 = this;
	
	      var fagUdenValgfag = this.fagMedVProps.filter(function (fag) {
	        var fagKode = fag.fagkode * 1;
	        return fag._type === 'undervisningstid' && !_this5.valgfagsFagKoder.includes(fagKode) && !_this5.tyskOgFranskKoder.includes(fagKode);
	      });
	      var hoursInGrades = {
	        1: 0,
	        2: 0,
	        3: 0,
	        4: 0,
	        5: 0,
	        6: 0,
	        7: 0,
	        8: 0,
	        9: 0
	      };
	      fagUdenValgfag.forEach(function (hvertFag) {
	        hvertFag.klasser.forEach(function (klasse) {
	          if (klasse && klasse.num) {
	            var klassetrin = klasse.v_originalObject.klassetrin;
	            hoursInGrades[klassetrin] += parseFloat(klasse.num);
	          }
	        });
	      });
	
	      this.uuv.forEach(function (uuv) {
	        uuv.klasser.forEach(function (uuvKlasse, key) {
	          if (uuvKlasse && uuvKlasse.num) {
	            var prop = uuvKlasse.v_originalObject.klassetrin;
	            hoursInGrades[prop] += uuvKlasse.num;
	          }
	        });
	      });
	
	      var highestTyskFransk = this.highestTyskFransk;
	      (0, _keys2.default)(hoursInGrades).forEach(function (klassetrin) {
	        if (highestTyskFransk[klassetrin]) {
	          hoursInGrades[klassetrin] += highestTyskFransk[klassetrin];
	        }
	      });
	
	      var highestValgfag = this.hojesteValgfag;
	      (0, _keys2.default)(hoursInGrades).forEach(function (klassetrin) {
	        if (highestValgfag[klassetrin]) {
	          hoursInGrades[klassetrin] += highestValgfag[klassetrin];
	        }
	      });
	      return hoursInGrades;
	    },
	    uuv: function uuv() {
	      var _this6 = this;
	
	      return this.understottende.map(function (fag) {
	        fag.v_originalObject = _this6.fagFraStil[_this6.fagFraStil.findIndex(function (faget) {
	          return faget.fagkode === fag.fagkode;
	        })];
	        fag.klasser = [];
	        _this6.grades.forEach(function (grade) {
	          fag.klasser.push(_this6.findGradeAndHours(fag, grade.value, '40'));
	        });
	        return fag;
	      });
	    },
	    ovrigFagopdelt: function ovrigFagopdelt() {
	      var fag = this.fagMedVProps.filter(function (fag) {
	        return fag._type === 'undervisningstid';
	      });
	      var hoursInGrades = {
	        1: 0,
	        2: 0,
	        3: 0,
	        4: 0,
	        5: 0,
	        6: 0,
	        7: 0,
	        8: 0,
	        9: 0
	      };
	      fag.forEach(function (hvertFag) {
	        hvertFag.klasser.forEach(function (klasse, key) {
	          if (klasse && klasse.num && !klasse.v_obligatorisk && key !== 10) {
	            var klassetrin = klasse.v_originalObject.klassetrin;
	            hoursInGrades[klassetrin] += klasse.num;
	          }
	        });
	      });
	      return hoursInGrades;
	    },
	    kristendom: function kristendom() {
	      return this.undervisningskema[this.undervisningskema.findIndex(function (skema) {
	        return skema._type === 'konfirmation';
	      })];
	    },
	    fagMedVProps: function fagMedVProps() {
	      var _this7 = this;
	
	      return this.fag.map(function (fag) {
	        if (fag._type === 'undervisningstid') {
	          fag.v_fag = _this7.fagFraStil[_this7.fagFraStil.findIndex(function (faget) {
	            return faget.fagkode === fag.fagkode;
	          })];
	          fag.klasser = [];
	          _this7.grades.forEach(function (grade) {
	            fag.klasser.push(_this7.findGradeAndHours(fag, grade.value, '40'));
	          });
	        }
	        if (fag._type === 'konfirmation') {
	          fag.klasser = [];
	          fag.v_fag = _this7.undervisningskema[_this7.undervisningskema.findIndex(function (skema) {
	            return skema._type === 'konfirmation';
	          })];
	          _this7.grades.forEach(function (grade) {
	            if (grade.value === '7' || grade.value === '8') {
	              fag.klasser.push({ checkbox: true, value: grade.value });
	            } else {
	              fag.klasser.push(false);
	            }
	          });
	        }
	        if (fag._type === 'praktik') {
	          fag.v_fag = _this7.undervisningskema[_this7.undervisningskema.findIndex(function (skema) {
	            return skema._type === 'praktik';
	          })];
	          fag.klasser = [];
	          fag.praktikkode = fag.v_fag.praktikkode;
	          _this7.grades.forEach(function (grade) {
	            if (grade.value === '10') {
	              fag.klasser.push({ checkbox: true, value: fag.v_fag.praktikkode });
	            } else {
	              fag.klasser.push(false);
	            }
	          });
	        }
	        return fag;
	      });
	    }
	  },
	  methods: {
	    setForanstaltning: function setForanstaltning(foranstaltning) {
	      this.$emit('setForanstaltning', foranstaltning);
	    },
	    findToLaererAndHours: function findToLaererAndHours(arr, klassetrin) {
	      var idx = arr.findIndex(function (faget) {
	        return faget.klassetrin * 1 === klassetrin * 1;
	      });
	      if (idx > -1) {
	        return { num: arr[idx]['godkendelseskode'], v_originalObject: arr[idx] };
	      } else {
	        return false;
	      }
	    },
	    setPraktik: function setPraktik(fag) {
	      this.$emit('updatePraktik', fag);
	    },
	    setTolaerer: function setTolaerer(fag) {
	      this.$emit('setTolaerer', fag);
	    },
	    updateCell: function updateCell(originalObject, value) {
	      var obj = { originalObject: originalObject, value: value, toUpdate: 'klokketimer' };
	      this.$emit('update', obj);
	    },
	    setKonfirmation: function setKonfirmation(fag, klasse) {
	      var obj = { v_fag: fag, value: klasse };
	      this.$emit('updateKonfirmation', obj);
	    },
	    findGradeAndHours: function findGradeAndHours(fag, klassetrin, klassetype) {
	      var idx = this.fagFraStil.findIndex(function (faget) {
	        return faget.klassetype === klassetype && faget.fagkode === fag.fagkode && faget.klassetrin * 1 === klassetrin * 1;
	      });
	      var self = this;
	
	      function getIsObligatorisk() {
	        if (fag.fagkode === '170') {
	          return fag.obligatorisk && fag.obligatorisk[klassetrin] && self.kristendom && self.kristendom['klassetrin'] * 1 !== klassetrin * 1;
	        }
	        return fag.obligatorisk && fag.obligatorisk[klassetrin];
	      }
	
	      if (idx > -1) {
	        return {
	          num: this.fagFraStil[idx]['klokketimer'],
	          v_originalObject: this.fagFraStil[idx],
	          v_obligatorisk: getIsObligatorisk()
	        };
	      } else {
	        return false;
	      }
	    },
	    nulstilKlasse: function nulstilKlasse(grade) {
	      this.$emit('nulstilKlasse', grade);
	    }
	  }
	};

/***/ }),
/* 612 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    undervisningskema: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isReadOnly: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      fag: [{
	        _type: 'undervisningstid', fagkode: '600', title: 'Børnehaveklasse', klasser: [],
	        obligatorisk: { 0: true }
	      }, {
	        _type: 'undervisningstid',
	        fagkode: '110',
	        title: 'Dansk',
	        klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '181', title: 'Historie', klasser: [],
	        obligatorisk: { 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '310', title: 'Matematik', klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '799', title: 'Øvrige fag', klasser: [],
	        obligatorisk: {}
	      }],
	      klasstype: {
	        40: 'Normalklasse',
	        50: 'Specialklasse'
	      },
	      grades: [{ value: '1', title: '1.' }, { value: '2', title: '2.' }, { value: '3', title: '3.' }, { value: '4', title: '4.' }, { value: '5', title: '5.' }, { value: '6', title: '6.' }, { value: '7', title: '7.' }, { value: '8', title: '8.' }, { value: '9', title: '9.' }],
	      minimumFagopdelt: {
	        1: 750,
	        2: 780,
	        3: 810,
	        4: 870,
	        5: 930,
	        6: 930,
	        7: 960,
	        8: 990,
	        9: 990
	      },
	      totalMinimum: {
	        1: 1110,
	        2: 1110,
	        3: 1110,
	        4: 1320,
	        5: 1320,
	        6: 1320,
	        7: 1400,
	        8: 1400,
	        9: 1400
	      },
	      understottende: [{
	        _type: 'undervisningstid',
	        fagkode: '800',
	        title: 'Understøttende undervisning i alt inkl. alle pauser',
	        klasser: []
	      }],
	      tolaererOrdning: [{
	        _type: 'tolaerer',
	        godkendelsestype: 'b',
	        title: 'Har kommunalbestyrelsen godkendt, at en del af den understøttende undervisning konverteres til ekstra personale i specialklasser jf. §16b?',
	        klasser: []
	      }, {
	        _type: 'tolaerer',
	        godkendelsestype: 'd',
	        title: 'Har kommunalbestyrelsen godkendt, at en del af den understøttende undervisning konverteres til ekstra personale i specialklasser jf. §16d?',
	        klasser: []
	      }],
	      foranstaltninger: [{
	        _type: 'foranstaltninger',
	        title: 'Har kommunalbestyrelsen godkendt, at en del af den understøttende undervisning konverteres til ekstra personale i specialklasser jf. §16e?',
	        klasser: []
	      }]
	    };
	  },
	
	  computed: {
	    fagFraStil: function fagFraStil() {
	      return this.undervisningskema.filter(function (skema) {
	        return skema._type === 'undervisningstid' && skema.klassetype === '50';
	      });
	    },
	    foranstaltningerFraStil: function foranstaltningerFraStil() {
	      return this.undervisningskema.filter(function (skema) {
	        return skema._type === 'foranstaltninger' && skema.klassetype === '50';
	      });
	    },
	    foranstaltningerMedProps: function foranstaltningerMedProps() {
	      var _this = this;
	
	      return this.foranstaltninger.map(function (foranstaltning) {
	        foranstaltning.klasser = [];
	        _this.grades.forEach(function (grade) {
	          var idx = _this.foranstaltningerFraStil.findIndex(function (faget) {
	            return faget.klassetrin * 1 === grade.value * 1;
	          });
	          foranstaltning.klasser.push(_this.foranstaltningerFraStil[idx]);
	        });
	        return foranstaltning;
	      });
	    },
	    tolaerer: function tolaerer() {
	      return this.undervisningskema.filter(function (skema) {
	        return skema._type === 'tolaerer' && skema.klassetype === '50';
	      });
	    },
	    tolaererArr: function tolaererArr() {
	      var _this2 = this;
	
	      return this.tolaererOrdning.map(function (toLaerer) {
	        var arr = _this2.tolaerer.filter(function (obj) {
	          return obj.godkendelsestype === toLaerer.godkendelsestype;
	        });
	        toLaerer.klasser = [];
	        _this2.grades.forEach(function (grade) {
	          var idx = arr.findIndex(function (faget) {
	            return faget.klassetrin * 1 === grade.value * 1;
	          });
	          toLaerer.klasser.push(arr[idx]);
	        });
	        return toLaerer;
	      });
	    },
	    sammentaelling: function sammentaelling() {
	      var fag = this.fagMedVProps.filter(function (fag) {
	        return fag._type === 'undervisningstid';
	      });
	      var hoursInGrades = {
	        1: 0,
	        2: 0,
	        3: 0,
	        4: 0,
	        5: 0,
	        6: 0,
	        7: 0,
	        8: 0,
	        9: 0
	      };
	      fag.forEach(function (hvertFag) {
	        hvertFag.klasser.forEach(function (klasse, key) {
	          if (klasse && klasse.num) {
	            var prop = klasse.v_originalObject.klassetrin;
	            hoursInGrades[prop] += klasse.num;
	          }
	        });
	      });
	      this.uuv.forEach(function (uuv) {
	        uuv.klasser.forEach(function (uuvKlasse, key) {
	          if (uuvKlasse && uuvKlasse.num) {
	            var prop = uuvKlasse.v_originalObject.klassetrin;
	            hoursInGrades[prop] += uuvKlasse.num;
	          }
	        });
	      });
	      return hoursInGrades;
	    },
	    uuv: function uuv() {
	      var _this3 = this;
	
	      return this.understottende.map(function (fag) {
	        fag.v_originalObject = _this3.fagFraStil[_this3.fagFraStil.findIndex(function (faget) {
	          return faget.fagkode === fag.fagkode;
	        })];
	        fag.klasser = [];
	        _this3.grades.forEach(function (grade) {
	          fag.klasser.push(_this3.findGradeAndHours(fag, grade.value, '50'));
	        });
	        return fag;
	      });
	    },
	    obligatoriskFagopdelt: function obligatoriskFagopdelt() {
	      var fag = this.fagMedVProps.filter(function (fag) {
	        return fag._type === 'undervisningstid';
	      });
	      var hoursInGrades = {
	        1: 0,
	        2: 0,
	        3: 0,
	        4: 0,
	        5: 0,
	        6: 0,
	        7: 0,
	        8: 0,
	        9: 0
	      };
	      fag.forEach(function (hvertFag) {
	        hvertFag.klasser.forEach(function (klasse, key) {
	          if (klasse && klasse.num && (klasse.v_obligatorisk || key === 10)) {
	            var klassetrin = klasse.v_originalObject.klassetrin;
	            hoursInGrades[klassetrin] += klasse.num;
	          }
	        });
	      });
	      return hoursInGrades;
	    },
	    ovrigFagopdelt: function ovrigFagopdelt() {
	      var fag = this.fagMedVProps.filter(function (fag) {
	        return fag._type === 'undervisningstid';
	      });
	      var hoursInGrades = {
	        1: 0,
	        2: 0,
	        3: 0,
	        4: 0,
	        5: 0,
	        6: 0,
	        7: 0,
	        8: 0,
	        9: 0
	      };
	      fag.forEach(function (hvertFag) {
	        hvertFag.klasser.forEach(function (klasse, key) {
	          if (klasse && klasse.num && !klasse.v_obligatorisk && key !== 10) {
	            var klassetrin = klasse.v_originalObject.klassetrin;
	            hoursInGrades[klassetrin] += klasse.num;
	          }
	        });
	      });
	      return hoursInGrades;
	    },
	    kristendom: function kristendom() {
	      return this.undervisningskema[this.undervisningskema.findIndex(function (skema) {
	        return skema._type === 'konfirmation';
	      })];
	    },
	    fagMedVProps: function fagMedVProps() {
	      var _this4 = this;
	
	      return this.fag.map(function (fag) {
	        if (fag._type === 'undervisningstid') {
	          fag.v_fag = _this4.fagFraStil[_this4.fagFraStil.findIndex(function (faget) {
	            return faget.fagkode === fag.fagkode;
	          })];
	          fag.klasser = [];
	          _this4.grades.forEach(function (grade) {
	            fag.klasser.push(_this4.findGradeAndHours(fag, grade.value, '50'));
	          });
	        }
	        if (fag._type === 'konfirmation') {
	          fag.klasser = [];
	          fag.v_fag = _this4.undervisningskema[_this4.undervisningskema.findIndex(function (skema) {
	            return skema._type === 'konfirmation';
	          })];
	          _this4.grades.forEach(function (grade) {
	            if (grade.value === '7' || grade.value === '8') {
	              fag.klasser.push({ checkbox: true, value: grade.value });
	            } else {
	              fag.klasser.push(false);
	            }
	          });
	        }
	        if (fag._type === 'praktik') {
	          fag.v_fag = _this4.undervisningskema[_this4.undervisningskema.findIndex(function (skema) {
	            return skema._type === 'praktik';
	          })];
	          fag.klasser = [];
	          fag.praktikkode = fag.v_fag.praktikkode;
	          _this4.grades.forEach(function (grade) {
	            if (grade.value === '10') {
	              fag.klasser.push({ checkbox: true, value: fag.v_fag.praktikkode });
	            } else {
	              fag.klasser.push(false);
	            }
	          });
	        }
	        return fag;
	      });
	    }
	  },
	  methods: {
	    findToLaererAndHours: function findToLaererAndHours(arr, klassetrin) {
	      var idx = arr.findIndex(function (faget) {
	        return faget.klassetrin * 1 === klassetrin * 1;
	      });
	      if (idx > -1) {
	        return { num: arr[idx]['godkendelseskode'], v_originalObject: arr[idx] };
	      } else {
	        return false;
	      }
	    },
	    setPraktik: function setPraktik(fag) {
	      this.$emit('updatePraktik', fag);
	    },
	    setTolaerer: function setTolaerer(fag) {
	      this.$emit('setTolaerer', fag);
	    },
	    setForanstaltning: function setForanstaltning(foranstaltning) {
	      this.$emit('setForanstaltning', foranstaltning);
	    },
	    updateCell: function updateCell(originalObject, value) {
	      var obj = { originalObject: originalObject, value: value, toUpdate: 'klokketimer' };
	      this.$emit('update', obj);
	    },
	    setKonfirmation: function setKonfirmation(fag, klasse) {
	      var obj = { v_fag: fag, value: klasse };
	      this.$emit('updateKonfirmation', obj);
	    },
	    findGradeAndHours: function findGradeAndHours(fag, klassetrin, klassetype) {
	      var idx = this.fagFraStil.findIndex(function (faget) {
	        return faget.klassetype === klassetype && faget.fagkode === fag.fagkode && faget.klassetrin * 1 === klassetrin * 1;
	      });
	      var self = this;
	
	      function getIsObligatorisk() {
	        if (fag.fagkode === '170') {
	          return fag.obligatorisk && fag.obligatorisk[klassetrin] && self.kristendom && self.kristendom['klassetrin'] * 1 !== klassetrin * 1;
	        }
	        return fag.obligatorisk && fag.obligatorisk[klassetrin];
	      }
	
	      if (idx > -1) {
	        return {
	          num: this.fagFraStil[idx]['klokketimer'],
	          v_originalObject: this.fagFraStil[idx],
	          v_obligatorisk: getIsObligatorisk()
	        };
	      } else {
	        return false;
	      }
	    }
	  }
	};

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _StilGuides = __webpack_require__(49);
	
	var _StilGuides2 = _interopRequireDefault(_StilGuides);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { StilGuides: _StilGuides2.default },
	  mixins: [_vueClickaway.mixin],
	  data: function data() {
	    return {
	      theSelectMonth: null,
	      activeFilter: 0
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    usersWithVProps: function usersWithVProps() {
	      var _this = this;
	
	      return this.users.map(function (user) {
	        var birthday = null;
	        if (user.dob && user.dob.length > 6) {
	          birthday = user.dob;
	        }
	        _this.$set(user, 'v_birthday', birthday);
	        var stilStilling = null;
	        if (user.custom_data && user.custom_data['schools'] && user.custom_data['schools'][_this.schoolId] && user.custom_data['schools'][_this.schoolId]['stilling']) {
	          stilStilling = user.custom_data['schools'][_this.schoolId]['stilling'];
	        }
	        _this.$set(user, 'v_stil_stilling', stilStilling);
	        return user;
	      });
	    },
	    unfilledUsers: function unfilledUsers() {
	      return this.usersWithVProps.filter(function (user) {
	        return !user.gender || !user.v_birthday || !user.v_stil_stilling;
	      });
	    },
	    filteredUsersWithVProps: function filteredUsersWithVProps() {
	      if (this.activeFilter === 0) {
	        return this.usersWithVProps;
	      } else {
	        return this.unfilledUsers;
	      }
	    }
	  },
	  methods: {
	    updateUser: function updateUser(user, change, val) {
	      var _this2 = this;
	
	      var customData = user.custom_data;
	      var errors = false;
	      var changes = {};
	      changes[change] = val;
	      if (change === 'stil_stilling') {
	        if (!customData['schools']) {
	          customData.schools = (0, _defineProperty3.default)({}, this.schoolId, { 'stilling': val });
	        }
	        if (customData['schools'] && !customData['schools'][this.schoolId]) {
	          customData['schools'][this.schoolId] = { 'stilling': val };
	        }
	        if (customData['schools'] && customData['schools'][this.schoolId]) {
	          customData['schools'][this.schoolId]['stilling'] = val;
	        }
	        changes['custom_data'] = customData;
	      }
	      if (change === 'dob') {
	        if (!(0, _moment2.default)(val).isValid() || (0, _moment2.default)(val).isAfter((0, _moment2.default)())) {
	          _eventbus2.default.toast = { text: 'Ugyldig fødselsdato', success: false };
	          errors = true;
	          var originalDob = JSON.parse((0, _stringify2.default)(user.dob));
	          user.dob = null;
	          user.dob = originalDob;
	        }
	        changes[change] = val;
	      }
	      if (errors) {
	        return;
	      }
	      _docendo2.default.updateUsers(this.schoolId, user.id, changes, function (success) {
	        _this2.$store.commit('updateSchoolUser', success);
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Noget gik galt', success: false };
	      });
	    }
	  }
	};

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _StilGuides = __webpack_require__(49);
	
	var _StilGuides2 = _interopRequireDefault(_StilGuides);
	
	var _KompetenceIndberetningLinjeFag = __webpack_require__(1552);
	
	var _KompetenceIndberetningLinjeFag2 = _interopRequireDefault(_KompetenceIndberetningLinjeFag);
	
	var _KompetenceIndberetningKlasser = __webpack_require__(1549);
	
	var _KompetenceIndberetningKlasser2 = _interopRequireDefault(_KompetenceIndberetningKlasser);
	
	var _KompetenceIndberetningDaekning = __webpack_require__(1546);
	
	var _KompetenceIndberetningDaekning2 = _interopRequireDefault(_KompetenceIndberetningDaekning);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _KompetenceIndberetningIndberet = __webpack_require__(1548);
	
	var _KompetenceIndberetningIndberet2 = _interopRequireDefault(_KompetenceIndberetningIndberet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    KompetenceIndberetningIndberet: _KompetenceIndberetningIndberet2.default,
	    StilGuides: _StilGuides2.default,
	    ChangeSchoolYear: _ChangeSchoolYear2.default,
	    Loader: _Loader2.default,
	    KompetenceIndberetningLinjeFag: _KompetenceIndberetningLinjeFag2.default,
	    KompetenceIndberetningKlasser: _KompetenceIndberetningKlasser2.default,
	    KompetenceIndberetningDaekning: _KompetenceIndberetningDaekning2.default
	  },
	  data: function data() {
	    return {
	      dbStilData: null,
	      stilData: null,
	      isLoadingStilData: false,
	      theActiveTab: 1,
	      theTabs: {
	        1: {
	          title: 'Undervisningskompetencer',
	          component: _KompetenceIndberetningLinjeFag2.default
	        },
	        2: {
	          title: 'Klasser',
	          component: _KompetenceIndberetningKlasser2.default
	        },
	        3: {
	          title: 'Fag',
	          component: _KompetenceIndberetningKlasser2.default,
	          isShowSubjects: true
	        },
	        4: {
	          title: 'Kompetencedækning',
	          component: _KompetenceIndberetningDaekning2.default
	        },
	        5: {
	          title: 'Resumé og indberet',
	          component: _KompetenceIndberetningIndberet2.default
	        }
	      },
	      theActiveComponent: _KompetenceIndberetningLinjeFag2.default,
	      isShowSubjects: false,
	      klokketimetyper: {
	        1: 'Almindelig undervisning',
	        10: 'Tolærerordning',
	        20: 'Undervisningsassistenter og pædagoger',
	        30: 'Supplerende undervisning af enkelte elever',
	        91: 'Andet',
	        92: 'Ej specificeret på nuværende tidspunkt'
	      }
	    };
	  },
	
	  computed: {
	    standardSubjects: function standardSubjects() {
	      return this.$store.getters.standardSubjectCodes;
	    },
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    usersSSNHash: function usersSSNHash() {
	      var _this = this;
	
	      var users = this.users.filter(function (user) {
	        return _this.getUserStilling(user);
	      });
	      return this.$helpers.hashMap(users, 'ssn');
	    },
	    userIdsKlasseFagMap: function userIdsKlasseFagMap() {
	      var fagOnUserMap = {};
	      this.stilData.klasser.forEach(function (klasse) {
	        klasse.fag.forEach(function (fag) {
	          fag.laerere.forEach(function (learer) {
	            var vUid = klasse.klasse_id + '_' + fag.fag_id;
	            var vFag = {
	              vUid: vUid,
	              user_id: learer.user_id,
	              cpr: learer.cpr,
	              klassebetegnelse: klasse.klassebetegnelse,
	              klasse_id: klasse.klasse_id,
	              klasse_type: klasse.klasse_type,
	              klasse_klokketimer: fag.klokketimer,
	              fag_id: fag.fag_id,
	              fag_navn: fag.fag_navn,
	              fagkode: fag.fagkode,
	              learer_klokketimer: learer.klokketimer,
	              klokketimer_type: learer.klokketimer_type
	            };
	            if (learer.user_id) {
	              if (!fagOnUserMap[learer.user_id]) {
	                fagOnUserMap[learer.user_id] = [vFag];
	              } else {
	                fagOnUserMap[learer.user_id].push(vFag);
	              }
	            }
	          });
	        });
	      });
	      return fagOnUserMap;
	    }
	  },
	  methods: {
	    getUserStilling: function getUserStilling(user) {
	      return user.custom_data && user.custom_data.schools && user.custom_data.schools[this.schoolId] && user.custom_data.schools[this.schoolId]['stilling'] && user.custom_data.schools[this.schoolId]['stilling'] !== 'undtaget';
	    },
	    getIsTheActiveTab: function getIsTheActiveTab(prop) {
	      return this.theActiveTab * 1 === prop * 1;
	    },
	    setTheActiveTab: function setTheActiveTab(tab, prop) {
	      this.theActiveComponent = tab.component;
	      this.theActiveTab = prop;
	      this.isShowSubjects = tab['isShowSubjects'];
	      if (prop === '5') {
	        this.removeTeachersWithoutStilling();
	      } else {
	        this.readStilCompetencyReport();
	      }
	    },
	    readStilCompetencyReport: function readStilCompetencyReport() {
	      var _this2 = this;
	
	      this.isLoadingStilData = true;
	      _docendo2.default.showStilCompetencyReport(this.schoolId, function (success) {
	        _this2.isLoadingStilData = false;
	        _this2.stilData = success;
	        _this2.dbStilData = success;
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    updateStil: function updateStil(report) {
	      var _this3 = this;
	
	      _docendo2.default.updateStilCompetencyReport(this.schoolId, report, function (success) {
	        _eventbus2.default.toast = { text: 'Opdateret', success: true };
	        _this3.stilData = success;
	        _this3.dbStilData = success;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Noget gik galt', success: false };
	      });
	    },
	    removeTeachersWithoutStilling: function removeTeachersWithoutStilling() {
	      var _this4 = this;
	
	      this.isLoadingStilData = true;
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	      report['laerere'] = this.stilData['laerere'].filter(function (laerer) {
	        return laerer.stilling !== 'undtaget';
	      });
	
	      _docendo2.default.updateStilCompetencyReport(this.schoolId, report, function (success) {
	        _this4.readStilCompetencyReport();
	      });
	    },
	    updateStilReportUser: function updateStilReportUser(user) {
	      var userId = user.id;
	      var SSN = user.ssn;
	      var userSubjects = this.userIdsKlasseFagMap[userId] || [];
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	
	      userSubjects.forEach(function (itemFag) {
	        var klasse = report.klasser.find(function (klasse) {
	          return klasse.klasse_id === itemFag.klasse_id;
	        });
	        if (!klasse) return;
	
	        var fag = klasse.fag.find(function (fag) {
	          return fag.fag_id === itemFag.fag_id;
	        });
	        if (!fag) return;
	
	        var teacher = fag.laerere.find(function (teacher) {
	          return teacher.user_id === userId;
	        });
	        if (teacher) {
	          teacher.cpr = SSN;
	        }
	      });
	
	      this.updateStil(report);
	    }
	  },
	  mounted: function mounted() {
	    this.readStilCompetencyReport();
	    this.$store.dispatch('getUsersFromSchoolId', this.schoolId);
	    this.$store.dispatch('readSchoolYears', this.schoolId);
	  }
	};

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(9);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  mixins: [_vueClickaway.mixin],
	  data: function data() {
	    return {
	      klassebetegnelse: ''
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    isFormValid: function isFormValid() {
	      return this.klassebetegnelse.length > 0;
	    }
	  },
	  methods: {
	    close: function close() {
	      this.$emit('close');
	    },
	    submit: function submit() {
	      if (!this.isFormValid) {
	        return;
	      }
	      var uniqueId = 'id_' + new Date().getTime() + '_' + Math.random().toString(36).substr(2, 9);
	      var klasse = {
	        klassebetegnelse: this.klassebetegnelse,
	        fag: [],
	        hold: '',
	        klasse_id: uniqueId,
	        klasse_type: '',
	        klassetrin: '',
	        spor: ''
	
	      };
	      this.$emit('save', klasse);
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function (_) {
	      _this.$refs.inputTitle.focus();
	    });
	  }
	};

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DSelectCals = __webpack_require__(48);
	
	var _DSelectCals2 = _interopRequireDefault(_DSelectCals);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _pasteTableMatcher = __webpack_require__(426);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelectCals2.default },
	  props: {
	    items: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    itemsSelected: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    placeholder: {
	      type: String,
	      default: 'Søg og vælg kompetence'
	    },
	    show: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: {
	    itemsFiltered: function itemsFiltered() {
	      var _this = this;
	
	      if (this.itemsSelected.length > 5) {
	        return [];
	      }
	      return this.items.filter(function (item) {
	        return _this.itemsSelected.findIndex(function (itemSelected) {
	          return itemSelected.subject_code === item.subject_code;
	        }) < 0;
	      });
	    }
	  },
	  methods: {
	    update: function update(val) {
	      this.$emit('update', val);
	    },
	    onMultiPaste: function onMultiPaste(text) {
	      var result = (0, _pasteTableMatcher.parseSubjectListPaste)(text, 'L', this.items);
	      var existingCodes = this.itemsSelected.map(function (item) {
	        return item.subject_code;
	      });
	      var additions = [];
	      var duplicates = [];
	      result.matched.forEach(function (_ref) {
	        var raw = _ref.raw,
	            item = _ref.item;
	
	        if (existingCodes.indexOf(item.subject_code) > -1) {
	          duplicates.push(raw);
	          return;
	        }
	        if (additions.findIndex(function (a) {
	          return a.subject_code === item.subject_code;
	        }) > -1) {
	          duplicates.push(raw);
	          return;
	        }
	        additions.push(item);
	      });
	      var totalAfter = this.itemsSelected.length + additions.length;
	      var overflow = [];
	      var toAdd = additions;
	      if (totalAfter > _pasteTableMatcher.constants.MAX_COMPETENCIES) {
	        var room = Math.max(0, _pasteTableMatcher.constants.MAX_COMPETENCIES - this.itemsSelected.length);
	        toAdd = additions.slice(0, room);
	        overflow = additions.slice(room);
	      }
	
	      if (toAdd.length > 0) {
	        var next = this.itemsSelected.concat(toAdd);
	        this.$emit('update', next);
	      }
	
	      this.reportPasteFeedback({
	        added: toAdd,
	        duplicates: duplicates,
	        overflow: overflow,
	        notFound: result.notFound,
	        ambiguous: result.ambiguous
	      });
	    },
	    reportPasteFeedback: function reportPasteFeedback(info) {
	      var issues = [];
	      if (info.notFound.length > 0) {
	        issues.push('ukendte: ' + info.notFound.map(function (n) {
	          return n.raw;
	        }).join(', '));
	      }
	      if (info.ambiguous.length > 0) {
	        issues.push('flere mulige matches: ' + info.ambiguous.map(function (a) {
	          return a.raw;
	        }).join(', '));
	      }
	      if (info.overflow.length > 0) {
	        issues.push('over 6-grænsen: ' + info.overflow.map(function (o) {
	          return o.name;
	        }).join(', '));
	      }
	      if (info.duplicates.length > 0) {
	        issues.push('allerede valgt: ' + info.duplicates.join(', '));
	      }
	
	      if (issues.length < 1) {
	        return;
	      }
	      if (info.added.length > 0) {
	        _eventbus2.default.toast = {
	          text: 'Tilføjede ' + info.added.length + ' kompetencer. Ikke tilføjet: ' + issues.join('; '),
	          success: false
	        };
	        return;
	      }
	      _eventbus2.default.toast = { text: 'Intet tilføjet. ' + issues.join('; '), success: false };
	    }
	  }
	};

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _KompetenceIndberetningDaekningUser = __webpack_require__(1547);
	
	var _KompetenceIndberetningDaekningUser2 = _interopRequireDefault(_KompetenceIndberetningDaekningUser);
	
	var _StilGuides = __webpack_require__(49);
	
	var _StilGuides2 = _interopRequireDefault(_StilGuides);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { KompetenceIndberetningDaekningUser: _KompetenceIndberetningDaekningUser2.default, StilGuides: _StilGuides2.default },
	  props: {
	    standardSubjects: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    dbStilData: {
	      type: Object,
	      default: function _default() {}
	    },
	    stilData: {
	      type: Object,
	      default: function _default() {}
	    },
	    isShowSubjects: {
	      type: Boolean,
	      default: false
	    },
	    usersSSNHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    klokketimetyper: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  computed: {
	    users: function users() {
	      var _this = this;
	
	      return this.stilData.laerere.filter(function (user) {
	        return _this.usersSSNHash[user.cpr];
	      }).map(function (user) {
	        var vName = _this.usersSSNHash[user.cpr].name;
	        var vFag = _this.usersWithSubjectIdsMap[user.cpr] ? _this.usersWithSubjectIdsMap[user.cpr] : [];
	        vFag = vFag.sort(function (a, b) {
	          return a.fag_navn.localeCompare(b.fag_navn, 'da', {
	            numeric: true,
	            sensitivity: 'base'
	          });
	        });
	        return (0, _extends3.default)({}, user, { vName: vName, vFag: vFag });
	      });
	    },
	    usersSorted: function usersSorted() {
	      return this.users.sort(function (a, b) {
	        return a.vName.localeCompare(b.vName, 'da', {
	          numeric: true,
	          sensitivity: 'base'
	        });
	      });
	    },
	    usersWithSubjectIdsMap: function usersWithSubjectIdsMap() {
	      var fagOnUserMap = {};
	      this.stilData.klasser.forEach(function (klasse) {
	        klasse.fag.forEach(function (fag) {
	          fag.laerere.forEach(function (learer) {
	            var vUid = klasse.klasse_id + '_' + fag.fag_id;
	            var vFag = {
	              vUid: vUid,
	              cpr: learer.cpr,
	              klassebetegnelse: klasse.klassebetegnelse,
	              klasse_id: klasse.klasse_id,
	              klasse_type: klasse.klasse_type,
	              klasse_klokketimer: fag.klokketimer,
	              fag_id: fag.fag_id,
	              fag_navn: fag.fag_navn,
	              fagkode: fag.fagkode,
	              learer_klokketimer: learer.klokketimer,
	              klokketimer_type: learer.klokketimer_type
	            };
	            if (learer.cpr) {
	              if (!fagOnUserMap[learer.cpr]) {
	                fagOnUserMap[learer.cpr] = [vFag];
	              } else {
	                fagOnUserMap[learer.cpr].push(vFag);
	              }
	            }
	          });
	        });
	      });
	      return fagOnUserMap;
	    }
	  },
	  methods: {
	    isValidNumber: function isValidNumber(input) {
	      if (isNaN(input)) {
	        return false;
	      }
	      if (input < 0) {
	        return false;
	      }
	      return true;
	    },
	    updateStilKlasseFagLaerer: function updateStilKlasseFagLaerer(user, itemFag, prop, val, target) {
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	      var klasseIdx = report.klasser.findIndex(function (klasse) {
	        return klasse.klasse_id === itemFag.klasse_id;
	      });
	      var fagIdx = report.klasser[klasseIdx].fag.findIndex(function (fag) {
	        return fag.fag_id === itemFag.fag_id;
	      });
	      var teacherIdx = report.klasser[klasseIdx].fag[fagIdx]['laerere'].findIndex(function (teacher) {
	        return teacher.cpr === itemFag.cpr;
	      });
	      var oldValue = report.klasser[klasseIdx].fag[fagIdx]['laerere'][teacherIdx][prop];
	      if (oldValue === val) {
	        return;
	      }
	      report.klasser[klasseIdx].fag[fagIdx]['laerere'][teacherIdx][prop] = val;
	      if (prop === 'klokketimer' && !this.isValidNumber(val)) {
	        _eventbus2.default.toast = { text: 'Skal være et tal, 0 eller højere', success: false };
	        target.value = oldValue;
	        return;
	      }
	      this.$emit('updateStil', report);
	    }
	  }
	};

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _isInteger = __webpack_require__(73);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    user: {
	      type: Object,
	      default: function _default() {
	        return null;
	      }
	    },
	    dbStilData: {
	      type: Object,
	      default: function _default() {}
	    },
	    klokketimetyper: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  methods: {
	    isValidNumber: function isValidNumber(input) {
	      if (isNaN(input)) {
	        return false;
	      }
	      if (input < 0) {
	        return false;
	      }
	      return true;
	    },
	    updateStilKlasseFagLaerer: function updateStilKlasseFagLaerer(user, itemFag, prop, val, target) {
	      if (prop === 'klokketimer') {
	        if (target) {
	          target.classList.remove('d-input__small--warning');
	        }
	        if (!(0, _isInteger2.default)(Number(val))) {
	          window.alert('Klokketimer skal være et helt tal');
	          target.classList.add('d-input__small--warning');
	          return;
	        }
	      }
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	      var klasseIdx = report.klasser.findIndex(function (klasse) {
	        return klasse.klasse_id === itemFag.klasse_id;
	      });
	      var fagIdx = report.klasser[klasseIdx].fag.findIndex(function (fag) {
	        return fag.fag_id === itemFag.fag_id;
	      });
	      var teacherIdx = report.klasser[klasseIdx].fag[fagIdx]['laerere'].findIndex(function (teacher) {
	        return teacher.cpr === itemFag.cpr;
	      });
	      var oldValue = report.klasser[klasseIdx].fag[fagIdx]['laerere'][teacherIdx][prop];
	      if (oldValue === val) {
	        return;
	      }
	      report.klasser[klasseIdx].fag[fagIdx]['laerere'][teacherIdx][prop] = val;
	      if (prop === 'klokketimer' && !this.isValidNumber(val)) {
	        _eventbus2.default.toast = { text: 'Skal være et tal, 0 eller højere', success: false };
	        target.value = oldValue;
	        return;
	      }
	      this.$emit('updateStil', report);
	    }
	  }
	};

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _IndberetPersonale = __webpack_require__(1554);
	
	var _IndberetPersonale2 = _interopRequireDefault(_IndberetPersonale);
	
	var _IndberetFag = __webpack_require__(1553);
	
	var _IndberetFag2 = _interopRequireDefault(_IndberetFag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { IndberetFag: _IndberetFag2.default, IndberetetPersonale: _IndberetPersonale2.default, DModal: _DModal2.default },
	  props: {
	    stilData: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      isSendingToStil: false,
	      messageFromStil: ''
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    error: function error() {
	      return this.stilData['error'] ? this.stilData['error'] : false;
	    },
	    klasser: function klasser() {
	      return this.stilData['klasser'] ? this.stilData['klasser'] : [];
	    },
	    klasserUdenFag: function klasserUdenFag() {
	      return this.klasser.filter(function (klasse) {
	        return klasse.fag.length === 0;
	      });
	    }
	  },
	  methods: {
	    confirmDeleteGrade: function confirmDeleteGrade(grade) {
	      var klasseId = grade.klasse_id;
	      var report = JSON.parse((0, _stringify2.default)(this.stilData));
	      var klasseIdx = report.klasser.findIndex(function (klasse) {
	        return klasse.klasse_id === klasseId;
	      });
	      if (klasseIdx < 0) {
	        return;
	      }
	      report.klasser.splice(klasseIdx, 1);
	      this.$emit('updateStil', report);
	    },
	    submit: function submit() {
	      var _this = this;
	
	      this.isSendingToStil = true;
	      this.messageFromStil = '';
	      _docendo2.default.submitStilCompetencyReport(this.schoolId, function (success) {
	        _this.messageFromStil = success;
	        _this.isSendingToStil = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Noget gik galt', success: false };
	        _this.isSendingToStil = false;
	      });
	    }
	  }
	};

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isInteger = __webpack_require__(73);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _KompetenceIndberetningKlasserDSelect = __webpack_require__(1550);
	
	var _KompetenceIndberetningKlasserDSelect2 = _interopRequireDefault(_KompetenceIndberetningKlasserDSelect);
	
	var _KompetenceIndberetningKlasserFagForm = __webpack_require__(1551);
	
	var _KompetenceIndberetningKlasserFagForm2 = _interopRequireDefault(_KompetenceIndberetningKlasserFagForm);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _StilGuides = __webpack_require__(49);
	
	var _StilGuides2 = _interopRequireDefault(_StilGuides);
	
	var _KompetenceIndberetningCreateKlasseModal = __webpack_require__(1545);
	
	var _KompetenceIndberetningCreateKlasseModal2 = _interopRequireDefault(_KompetenceIndberetningCreateKlasseModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    KompetenceIndberetningCreateKlasseModal: _KompetenceIndberetningCreateKlasseModal2.default,
	    ModalConfirmation: _ModalConfirmation2.default, KompetenceIndberetningKlasserFagForm: _KompetenceIndberetningKlasserFagForm2.default, DSelect: _KompetenceIndberetningKlasserDSelect2.default, DModal: _DModal2.default, StilGuides: _StilGuides2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    standardSubjects: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    dbStilData: {
	      type: Object,
	      default: function _default() {}
	    },
	    stilData: {
	      type: Object,
	      default: function _default() {}
	    },
	    isShowSubjects: {
	      type: Boolean,
	      default: false
	    },
	    usersSSNHash: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      isModalCreateGrade: false,
	      theEditTeacher: null,
	      klassetrin: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
	      theCreateSubject: null,
	      theDeleteSubject: null,
	      klasseTyper: {
	        40: 'Normalklasser - fuldt årgangsdelte',
	        41: 'Normalklasser - Ikke fuldt årgangsdelte',
	        45: 'EUD10',
	        46: '20/20',
	        50: 'Specialklasser',
	        55: 'Klasser for ældre tosprogede elever'
	      },
	      formErrors: {},
	      theDeleteGrade: null
	    };
	  },
	
	  computed: {
	    videoGuideId: function videoGuideId() {
	      return !this.isShowSubjects ? '5Id4TeuHMvI?start=122' : '5Id4TeuHMvI?start=139';
	    },
	    videoGuideText: function videoGuideText() {
	      return !this.isShowSubjects ? 'Guide: Se videoguide til udfyldning af klasser' : 'Guide: Se videoguide til udfyldning af fag';
	    },
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    klasser: function klasser() {
	      if (!this.stilData['klasser']) {
	        return [];
	      }
	      return this.stilData['klasser'];
	    },
	    klasserMedProps: function klasserMedProps() {
	      var _this = this;
	
	      var klasser = this.klasser.map(function (klasse) {
	        klasse.fag.forEach(function (fag) {
	          _this.$set(fag, 'v_klasse_name', klasse.klassebetegnelse);
	          var isTheEditTeacher = _this.theEditTeacher === fag.fag_id;
	          _this.$set(fag, 'v_is_the_edit_teacher', isTheEditTeacher);
	          fag.laerere.forEach(function (laerer) {
	            var teacherName = laerer.user_name + ' (Mangler CPR)';
	            var user = _this.usersSSNHash[laerer.cpr];
	            if (user) {
	              teacherName = _this.usersSSNHash[laerer.cpr].name;
	              _this.$delete(laerer, 'v_no_cpr');
	            } else {
	              _this.$set(laerer, 'v_no_cpr', true);
	            }
	            _this.$set(laerer, 'v_name', teacherName);
	          });
	        });
	        klasse.fag = klasse.fag.sort(function (a, b) {
	          return a.fag_navn.localeCompare(b.fag_navn, 'da', {
	            numeric: true,
	            sensitivity: 'base'
	          });
	        });
	        return klasse;
	      });
	      return klasser.sort(function (a, b) {
	        return a.klassebetegnelse.localeCompare(b.klassebetegnelse, 'da', {
	          numeric: true,
	          sensitivity: 'base'
	        });
	      });
	    },
	    standardSubjectsHash: function standardSubjectsHash() {
	      return this.$helpers.hashMap(this.standardSubjects, 'fagkode');
	    }
	  },
	  methods: {
	    checkSporMaxLength: function checkSporMaxLength(event) {
	      if (event.target.value.length >= 10) {
	        _eventbus2.default.toast = { text: 'Spor kan maks være 10 tegn', success: false };
	      }
	    },
	    saveNewGrade: function saveNewGrade(newKlasse) {
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	      report.klasser.push(newKlasse);
	      this.$emit('updateStil', report);
	      this.setIsModalCreateGrade(false);
	    },
	    setIsModalCreateGrade: function setIsModalCreateGrade(bool) {
	      if (bool) {
	        this.isModalCreateGrade = bool;
	        return;
	      }
	      if (this.isModalCreateGrade) {
	        this.isModalCreateGrade = false;
	      } else {
	        this.isModalCreateGrade = true;
	      }
	    },
	    closeModalConfirm: function closeModalConfirm() {
	      this.theDeleteSubject = null;
	      this.theDeleteGrade = null;
	    },
	    setTheDeleteGrade: function setTheDeleteGrade(klasse) {
	      this.theDeleteGrade = klasse;
	    },
	    setTheDeleteSubject: function setTheDeleteSubject(klasse, fag) {
	      this.theDeleteSubject = { klasse: klasse, fag: fag };
	    },
	    confirmDeleteGrade: function confirmDeleteGrade() {
	      var klasseId = this.theDeleteGrade.klasse_id;
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	      var klasseIdx = report.klasser.findIndex(function (klasse) {
	        return klasse.klasse_id === klasseId;
	      });
	      if (klasseIdx < 0) {
	        return;
	      }
	      report.klasser.splice(klasseIdx, 1);
	      this.$emit('updateStil', report);
	      this.theDeleteGrade = null;
	    },
	    confirmDelete: function confirmDelete() {
	      if (this.theDeleteGrade) {
	        this.confirmDeleteGrade();
	        return;
	      }
	      var klasseId = this.theDeleteSubject.klasse.klasse_id;
	      var fagId = this.theDeleteSubject.fag.fag_id;
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	      var klasseIdx = report.klasser.findIndex(function (klasse) {
	        return klasse.klasse_id === klasseId;
	      });
	      var fagIdx = report.klasser[klasseIdx].fag.findIndex(function (fag) {
	        return fag.fag_id === fagId;
	      });
	      if (klasseIdx < 0 || fagIdx < 0) {
	        return;
	      }
	      report.klasser[klasseIdx].fag.splice(fagIdx, 1);
	      this.$emit('updateStil', report);
	      this.theDeleteSubject = null;
	    },
	    updateStilKlasse: function updateStilKlasse(itemKlasse, prop, val) {
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	      var idx = report.klasser.findIndex(function (klasse) {
	        return klasse.klasse_id === itemKlasse.klasse_id;
	      });
	      if (idx > -1) {
	        if (report.klasser[idx][prop] === val) {
	          return;
	        }
	        report.klasser[idx][prop] = val;
	      }
	      this.$emit('updateStil', report);
	    },
	    isValidNumber: function isValidNumber(input) {
	      if (isNaN(input)) {
	        return false;
	      }
	      if (input < 0) {
	        return false;
	      }
	      return true;
	    },
	    updateStilKlasseFag: function updateStilKlasseFag(itemKlasse, itemFag, prop, val, target) {
	      if (prop === 'klokketimer') {
	        if (target) {
	          target.classList.remove('d-input__small--warning');
	        }
	        if (!(0, _isInteger2.default)(Number(val))) {
	          window.alert('Klassetimer skal være et helt tal');
	          target.classList.add('d-input__small--warning');
	          return;
	        }
	      }
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	      var klasseIdx = report.klasser.findIndex(function (klasse) {
	        return klasse.klasse_id === itemKlasse.klasse_id;
	      });
	      var fagIdx = report.klasser[klasseIdx].fag.findIndex(function (fag) {
	        return fag.fag_id === itemFag.fag_id;
	      });
	
	      if (prop === 'laerere') {
	        var currentUsers = report.klasser[klasseIdx]['fag'][fagIdx][prop];
	        var hours = report.klasser[klasseIdx]['fag'][fagIdx]['klokketimer'];
	        val = val.map(function (user) {
	          var userIdx = currentUsers.findIndex(function (currentUser) {
	            return currentUser.cpr === user.ssn;
	          });
	          if (userIdx > -1 && currentUsers[userIdx]['klokketimer']) {
	            hours = currentUsers[userIdx]['klokketimer'];
	          }
	          return {
	            cpr: user.ssn,
	            klokketimer: hours,
	            klokketimer_type: '1',
	            user_id: user.id,
	            user_name: user.name
	          };
	        });
	      }
	
	      if (prop === 'klokketimer' && !this.isValidNumber(val)) {
	        target.value = report.klasser[klasseIdx]['fag'][fagIdx][prop];
	        _eventbus2.default.toast = { text: 'Skal være 0 eller større', success: false };
	        return;
	      }
	      if (fagIdx > -1 || klasseIdx > -1) {
	        if (report.klasser[klasseIdx]['fag'][fagIdx][prop] === val) {
	          return;
	        }
	        report.klasser[klasseIdx]['fag'][fagIdx][prop] = val;
	      }
	      this.$emit('updateStil', report);
	    },
	    saveNewSubject: function saveNewSubject(newSubject) {
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	      var klasseIdx = report.klasser.findIndex(function (klasse) {
	        return klasse.klasse_id === newSubject.klasse_id;
	      });
	      report.klasser[klasseIdx].fag.push(newSubject);
	      this.$emit('updateStil', report);
	    },
	    setTheEditSubject: function setTheEditSubject(subject) {
	      this.theEditSubject = subject;
	    },
	    close: function close() {
	      this.theEditSubject = null;
	    }
	  }
	};

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DSelectCals = __webpack_require__(48);
	
	var _DSelectCals2 = _interopRequireDefault(_DSelectCals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelectCals2.default },
	  props: {
	    items: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    itemsSelected: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    usersSSNHash: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  computed: {
	    itemsFiltered: function itemsFiltered() {
	      var _this = this;
	
	      return this.items.filter(function (user) {
	        return _this.usersSSNHash[user.ssn];
	      });
	    },
	    itemsSelectedFormatted: function itemsSelectedFormatted() {
	      var _this2 = this;
	
	      var usersNotOnSchool = this.itemsSelected.filter(function (user) {
	        return !_this2.usersSSNHash[user.cpr];
	      }).map(function (user) {
	        return {
	          id: user.user_id,
	          name: user.user_name
	        };
	      });
	      var users = this.itemsSelected.filter(function (user) {
	        return _this2.usersSSNHash[user.cpr];
	      }).map(function (user) {
	        return _this2.usersSSNHash[user.cpr];
	      });
	      return usersNotOnSchool.concat(users);
	    }
	  },
	  methods: {
	    update: function update(val) {
	      this.$emit('update', val);
	    }
	  }
	};

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(9);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelect2.default, DModal: _DModal2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    standardSubjects: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    theCreateSubject: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      title: '',
	      fagkode: 110,
	      klokketimer: 220
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    isFormValid: function isFormValid() {
	      return this.title.length > 0 && this.isValidNumber(this.klokketimer);
	    }
	  },
	  methods: {
	    isValidNumber: function isValidNumber(input) {
	      if (input.length < 1) {
	        return false;
	      }
	      if (isNaN(input)) {
	        return false;
	      }
	      if (input < 0) {
	        return false;
	      }
	      return true;
	    },
	    close: function close() {
	      this.$emit('close');
	    },
	    submit: function submit() {
	      var fag = {
	        klasse_id: this.theCreateSubject.klasse_id,
	        fag_id: new Date().valueOf(),
	        fag_navn: this.title,
	        fagkode: this.fagkode,
	        klokketimer: this.klokketimer,
	        laerere: []
	      };
	      this.$emit('save', fag);
	      this.$emit('close');
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function (_) {
	      _this.$refs.inputTitle.focus();
	    });
	  }
	};

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(45);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _StilGuides = __webpack_require__(49);
	
	var _StilGuides2 = _interopRequireDefault(_StilGuides);
	
	var _KompetenceIndberetningDSelect = __webpack_require__(367);
	
	var _KompetenceIndberetningDSelect2 = _interopRequireDefault(_KompetenceIndberetningDSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _KompetenceIndberetningDSelect2.default, StilGuides: _StilGuides2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    standardSubjects: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      theSelectMonth: null,
	      activeUserFilter: 0,
	      standardSubjectsWithVProps: [],
	      levelMap: {
	        L: 'Linjefag',
	        K: 'Tilsvarende kompetencer'
	      },
	      theEditUserId: null,
	      sortProperty: 'name',
	      sortOrder: 'asc' };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    usersWithVProps: function usersWithVProps() {
	      var _this = this;
	
	      return this.users.map(function (user) {
	        var competencies = [];
	        if (!user.competencies) {
	          console.log('user', user, user.competencies);
	        }
	        user.competencies.forEach(function (subject) {
	          var id = subject.subject_code + '_' + subject.level;
	          var idx = _this.standardSubjectsWithVProps.findIndex(function (subjectWithVProps) {
	            return subjectWithVProps.id === id;
	          });
	          var obj = {
	            id: subject.subject_code + '_' + subject.level,
	            subject_code: subject.subject_code,
	            level: subject.level,
	            name: _this.standardSubjectsWithVProps[idx].name
	          };
	          competencies.push(obj);
	        });
	        var vSsn = user.ssn && user.ssn.length > 6 ? user.ssn : '';
	        var isTheEditUser = _this.theEditUserId === user.id;
	        var stilStilling = null;
	        if (user.custom_data && user.custom_data['schools'] && user.custom_data['schools'][_this.schoolId] && user.custom_data['schools'][_this.schoolId]['stilling']) {
	          stilStilling = user.custom_data['schools'][_this.schoolId]['stilling'];
	        }
	        _this.$set(user, 'v_stil_stilling', stilStilling);
	        _this.$set(user, 'v_ssn', vSsn);
	        _this.$set(user, 'v_competencies', competencies);
	        _this.$set(user, 'v_isTheEditUser', isTheEditUser);
	        return user;
	      });
	    },
	    unfilledUsers: function unfilledUsers() {
	      return this.usersWithVProps.filter(function (user) {
	        return user.v_stil_stilling === 'undtaget';
	      });
	    },
	    filledUsers: function filledUsers() {
	      return this.usersWithVProps.filter(function (user) {
	        return user.v_stil_stilling !== 'undtaget';
	      });
	    },
	    filteredUsersWithVProps: function filteredUsersWithVProps() {
	      if (this.activeUserFilter === 0) {
	        return this.filledUsers;
	      } else {
	        return this.unfilledUsers;
	      }
	    },
	    sortedUsers: function sortedUsers() {
	      var _this2 = this;
	
	      var arrCopy = [].concat((0, _toConsumableArray3.default)(this.filteredUsersWithVProps));
	      var sortOrder = this.sortOrder === 'asc' ? 1 : -1;
	      return arrCopy.sort(function (a, b) {
	        var propA = a[_this2.sortProperty];
	        var propB = b[_this2.sortProperty];
	        if (propA === null || propA === undefined) {
	          return 1 * sortOrder;
	        }
	        if (propB === null || propB === undefined) {
	          return -1 * sortOrder;
	        }
	        var propAUppercase = propA.toUpperCase();
	        var propBUppercase = propB.toUpperCase();
	        if (propAUppercase < propBUppercase) {
	          return -1 * sortOrder;
	        }
	        if (propAUppercase > propBUppercase) {
	          return 1 * sortOrder;
	        }
	        return 0;
	      }).concat(arrCopy.filter(function (item) {
	        return item[_this2.sortProperty] === null || item[_this2.sortProperty] === undefined;
	      }));
	    }
	  },
	  methods: {
	    setSortProperty: function setSortProperty(property) {
	      if (this.sortProperty === property) {
	        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
	      } else {
	        this.sortOrder = 'asc';
	      }
	      this.sortProperty = property;
	    },
	    validateCPR: function validateCPR(vSsn) {
	      var ssn = vSsn.replace(/[^0-9]/ig, '');
	      return ssn.length === 10;
	    },
	    updateSubjectOnUser: function updateSubjectOnUser(subjects, user) {
	      var _this3 = this;
	
	      var subjectForServer = [];
	      subjects.forEach(function (subject) {
	        var obj = {
	          subject_code: subject.subject_code,
	          level: subject.level
	        };
	        subjectForServer.push(obj);
	      });
	      _docendo2.default.updateUserCompetencies(this.schoolId, user.id, subjectForServer, function (success) {
	        var userCompetencies = success.filter(function (subject) {
	          return subject.user_id === user.id;
	        });
	        var data = {
	          prop: 'competencies',
	          userId: user.id,
	          competencies: userCompetencies
	        };
	        _eventbus2.default.toast = { text: 'Linjefag er opdateret', success: true };
	        _this3.$store.commit('updatePropOnSchoolUser', data);
	      }, function (failure) {
	        console.log('failed');
	      });
	    },
	    updateUser: function updateUser(user, change, val, forceUpdate) {
	      var _this4 = this;
	
	      var customData = user.custom_data;
	      var errors = false;
	      var changes = {};
	      changes[change] = val;
	      if (change === 'stil_stilling') {
	        if (!customData['schools']) {
	          customData.schools = (0, _defineProperty3.default)({}, this.schoolId, { 'stilling': val });
	        }
	        if (customData['schools'] && !customData['schools'][this.schoolId]) {
	          customData['schools'][this.schoolId] = { 'stilling': val };
	        }
	        if (customData['schools'] && customData['schools'][this.schoolId]) {
	          customData['schools'][this.schoolId]['stilling'] = val;
	        }
	        changes['custom_data'] = customData;
	      }
	      if (change === 'ssn') {
	        val = val.replace(/[^0-9]/ig, '');
	        if (!forceUpdate && (val === user.ssn || val.length === 0)) {
	          var originalSSN = JSON.parse((0, _stringify2.default)(user.ssn));
	          user.ssn = null;
	          user.ssn = originalSSN;
	          return;
	        }
	        if (!this.validateCPR(val)) {
	          _eventbus2.default.toast = { text: 'Ugyldigt cpr nummer', success: false };
	          errors = true;
	          var _originalSSN = JSON.parse((0, _stringify2.default)(user.ssn));
	          user.ssn = null;
	          user.ssn = _originalSSN;
	        }
	        changes[change] = val;
	      }
	      if (errors) {
	        return;
	      }
	      _docendo2.default.updateUsers(this.schoolId, user.id, changes, function (success) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(changes)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var key = _step.value;
	
	            var data = (0, _defineProperty3.default)({
	              prop: key,
	              userId: user.id
	            }, key, success[key]);
	            _this4.$store.commit('updatePropOnSchoolUser', data);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        if (change === 'ssn') {
	          _this4.updateStilReportUser(user);
	        } else {
	          _eventbus2.default.toast = { text: 'Opdateret', success: true };
	        }
	      }, function (failure) {
	        if (change === 'ssn') {
	          var _originalSSN2 = JSON.parse((0, _stringify2.default)(user.ssn));
	          user.ssn = null;
	          user.ssn = _originalSSN2;
	          _eventbus2.default.toast = { text: 'CPR er allerede brugt', success: false };
	        }
	      });
	    },
	    updateStilReportUser: function updateStilReportUser(user) {
	      this.$emit('updateStilReportUser', user);
	    },
	    createStandardSubjectsWithVProps: function createStandardSubjectsWithVProps() {
	      var _this5 = this;
	
	      var sortedSubjects = this.standardSubjects.sort(function (a, b) {
	        if (a.name < b.name) return -1;
	        if (a.name > b.name) return 1;
	        return 0;
	      });
	      sortedSubjects.forEach(function (subject) {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)((0, _keys2.default)(_this5.levelMap)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var key = _step2.value;
	
	            var obj = {};
	            obj.level = key;
	            obj.name = subject.name + ' (' + key + ')';
	            obj.id = subject.subject_code + '_' + key;
	            obj.user_id = subject.subject_code + '_' + key;
	            obj.subject_code = subject.subject_code;
	            _this5.standardSubjectsWithVProps.push(obj);
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.createStandardSubjectsWithVProps();
	  }
	};

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isInteger = __webpack_require__(73);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    stilData: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      stillinger: {
	        LA: 'Lærere',
	        BH: 'Børnehaveklasseledere',
	        PA: 'Pædagoger',
	        LE: 'Ledere',
	        AN: 'Andre med undervisningsopgaver',
	        KO: 'Konsulenter'
	      }
	    };
	  },
	
	  computed: {
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    klasser: function klasser() {
	      var klasser = this.stilData['klasser'] ? this.stilData['klasser'] : [];
	      return klasser.sort(function (a, b) {
	        return a.klassebetegnelse.localeCompare(b.klassebetegnelse, 'da', {
	          numeric: true,
	          sensitivity: 'base'
	        });
	      });
	    },
	    fag: function fag() {
	      var fagArr = [];
	      this.klasser.forEach(function (klasse) {
	        klasse.fag.forEach(function (fag) {
	          var obj = (0, _extends3.default)({
	            klasse: klasse.klassebetegnelse,
	            klassetrin: klasse.klassetrin
	          }, fag);
	          fagArr.push(obj);
	        });
	      });
	      return fagArr;
	    },
	    fagUdenKorrekteOplysninger: function fagUdenKorrekteOplysninger() {
	      var fagMedManglendeOplysninger = [];
	
	      this.fag.forEach(function (fag) {
	        var klassename = fag.klasse ? fag.klasse : 'Klassen';
	        var errors = [];
	
	        if (!fag.klasse) {
	          errors.push(klassename + ' mangler klassebetegnelse');
	        }
	        if (!fag.klassetrin) {
	          errors.push(klassename + ' mangler klassetrin');
	        }
	        if (!fag.fagkode || String(fag.fagkode).trim() === '') {
	          errors.push('Fag mangler fagkode');
	        }
	        if (!fag.klokketimer) {
	          errors.push('Fag mangler klokketimer');
	        } else {
	          var klokketimerNum = Number(fag.klokketimer);
	          if (isNaN(klokketimerNum)) {
	            errors.push('Klokketimer skal være et tal');
	          } else if (!(0, _isInteger2.default)(klokketimerNum)) {
	            errors.push('Klokketimer skal være et helt tal');
	          }
	        }
	
	        if (!Array.isArray(fag.laerere) || fag.laerere.length === 0) {
	          errors.push('Fag mangler lærer');
	        } else {
	          fag.laerere.forEach(function (laerer) {
	            var username = laerer.user_name ? laerer.user_name : 'En lærer';
	
	            if (!laerer.cpr) {
	              errors.push(username + ' mangler cpr');
	            }
	
	            if (!laerer.klokketimer) {
	              errors.push(username + ' mangler klokketimer');
	            } else {
	              var laererKlokketimerNum = Number(laerer.klokketimer);
	              if (isNaN(laererKlokketimerNum)) {
	                errors.push(username + 's klokketimer skal være et tal');
	              } else if (!(0, _isInteger2.default)(laererKlokketimerNum)) {
	                errors.push(username + 's klokketimer skal være et helt tal');
	              }
	            }
	          });
	        }
	
	        if (errors.length > 0) {
	          var newFag = (0, _extends3.default)({}, fag, {
	            errors: errors
	          });
	          fagMedManglendeOplysninger.push(newFag);
	        }
	      });
	
	      return fagMedManglendeOplysninger;
	    },
	    laerere: function laerere() {
	      return this.stilData['laerere'] ? this.stilData['laerere'] : [];
	    },
	    personaleUdenKorrekteOplysninger: function personaleUdenKorrekteOplysninger() {
	      var _this = this;
	
	      var users = this.laerere.filter(function (laerer) {
	        return laerer.stilling !== 'undtaget' && (!laerer.cpr || !laerer.stilling);
	      });
	      var usersWithProps = users.map(function (user) {
	        var name = _this.allUsersInHash[user.user_id] ? _this.allUsersInHash[user.user_id].name : user.user_id;
	        return (0, _extends3.default)({}, user, {
	          name: name
	        });
	      });
	      return this.$helpers.sortArrOnName(usersWithProps);
	    }
	  }
	};

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    stilData: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      stillinger: {
	        LA: 'Lærere',
	        BH: 'Børnehaveklasseledere',
	        PA: 'Pædagoger',
	        LE: 'Ledere',
	        AN: 'Andre med undervisningsopgaver',
	        KO: 'Konsulenter'
	      }
	    };
	  },
	
	  computed: {
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    laerere: function laerere() {
	      return this.stilData['laerere'] ? this.stilData['laerere'] : [];
	    },
	    personaleUdenKorrekteOplysninger: function personaleUdenKorrekteOplysninger() {
	      var _this = this;
	
	      var users = this.laerere.filter(function (laerer) {
	        return laerer.stilling !== 'undtaget' && (!laerer.cpr || !laerer.stilling);
	      });
	      var usersWithProps = users.map(function (user) {
	        var name = _this.allUsersInHash[user.user_id] ? _this.allUsersInHash[user.user_id].name : user.user_id;
	        return (0, _extends3.default)({}, user, {
	          name: name
	        });
	      });
	      return this.$helpers.sortArrOnName(usersWithProps);
	    },
	    groupedLaerere: function groupedLaerere() {
	      var _this2 = this;
	
	      var result = {};
	
	      var _loop = function _loop(stilling) {
	        var jobTitle = _this2.stillinger[stilling];
	        var learereWithJobTitle = _this2.laerere.filter(function (lærer) {
	          return lærer.stilling === stilling;
	        });
	        result[jobTitle] = learereWithJobTitle;
	      };
	
	      for (var stilling in this.stillinger) {
	        _loop(stilling);
	      }
	      return result;
	    },
	    groupedLaerereProps: function groupedLaerereProps() {
	      var result = {};
	      for (var jobTitle in this.groupedLaerere) {
	        var laerere = this.groupedLaerere[jobTitle];
	        var laerereWithFag = laerere.filter(function (laerer) {
	          return laerer.fag.length > 0;
	        });
	        var laerereWithoutFag = laerere.filter(function (laerer) {
	          return laerer.fag.length === 0;
	        });
	        result[jobTitle] = [laerereWithFag, laerereWithoutFag];
	      }
	      return result;
	    }
	  }
	};

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    personaleskema: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      userTypesInHash: {
	        'LA': 'Lærere',
	        'BH': 'Børnehaveklasseledere',
	        'PA': 'Pædagoger',
	        'LE': 'Ledere',
	        'AN': 'Andre med undervisningsopgaver'
	      },
	      userTypes: [{ value: 'LA', title: 'Lærere' }, { value: 'BH', title: 'Børnehaveklasseledere' }, { value: 'PA', title: 'Pædagoger' }, { value: 'LE', title: 'Ledere' }, { value: 'AN', title: 'Andre med undervisningsopgaver' }]
	    };
	  },
	
	  computed: {
	    personale: function personale() {
	      var _this = this;
	
	      return this.userTypes.map(function (usertype) {
	        var obj = {
	          title: usertype.title,
	          male: _this.getMalesFromTitle(usertype.title)
	        };
	        return obj;
	      });
	    }
	  },
	  methods: {
	    getMalesFromTitle: function getMalesFromTitle(title) {
	      this.userTypes;
	    }
	  }
	};

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    textForLink: {
	      default: 'Guide: Se videoguide Her'
	    },
	    videoId: {
	      default: 'etaeiteazYM'
	    },
	    isButton: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isShowGuide: false,
	      playerVars: {
	        autoplay: 1,
	        resize: true,
	        fitParent: true
	      }
	    };
	  },
	
	  computed: {
	    videoLink: function videoLink() {
	      return 'https://www.youtube.com/embed/' + this.videoId;
	    }
	  },
	  methods: {
	    playing: function playing() {
	      console.log('playing');
	    }
	  }
	};

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default },
	  props: {
	    userId: {
	      default: null
	    },
	    schoolYear: {},
	    startDate: {},
	    endDate: {}
	  },
	  data: function data() {
	    return {
	      tasks: [],
	      isLoading: true,
	      tildeltArbejdstid: 0,
	      tildeltUndervisning: 0
	    };
	  },
	
	  computed: {
	    tildeltUndervisningUdenUUV: function tildeltUndervisningUdenUUV() {
	      return (this.tildeltUndervisning * 1 - this.tasksInTypes[1].sum * 1).toFixed(1);
	    },
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    tasksInTypes: function tasksInTypes() {
	      var tasks = [{ id: 'teaching', title: 'Fag', events: [], sum: 0 }, { id: 'supplemental', title: 'UUV', events: [], sum: 0 }];
	      this.tasks.forEach(function (task) {
	        if (task.master_type === 'teaching' && task.subject_type !== 'supplemental') {
	          tasks[0].events.push(task);
	          tasks[0].sum += task.hours * 1;
	        }
	        if (task.subject_type === 'supplemental') {
	          tasks[1].events.push(task);
	          tasks[1].sum += task.hours * 1;
	        }
	      });
	      tasks[0].sum = tasks[0].sum.toFixed(1);
	      tasks[1].sum = tasks[1].sum.toFixed(1);
	      return tasks;
	    }
	  },
	  methods: {
	    readUserTasks: function readUserTasks() {
	      var _this = this;
	
	      this.isLoading = true;
	      _docendo2.default.userTasks(this.userId, this.startDate, this.endDate, null, function (success) {
	        _this.isLoading = false;
	        _this.tasks = success;
	      }, function (failure) {
	        console.log(failure);
	      });
	      _docendo2.default.schoolAssignedHours(this.schoolId, this.schoolYear.name, [this.userId], function (data) {
	        if (data && data.length === 1 && data[0]['assigned_total_hours']) {
	          _this.tildeltArbejdstid = data[0]['assigned_total_hours'];
	          _this.tildeltUndervisning = data[0]['assigned_teaching_hours'] ? data[0]['assigned_teaching_hours'] : 0;
	        }
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readUserTasks();
	  }
	};

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _GrundskoleIndberetningTimetal = __webpack_require__(137);
	
	var _GrundskoleIndberetningTimetal2 = _interopRequireDefault(_GrundskoleIndberetningTimetal);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _StilGuides = __webpack_require__(49);
	
	var _StilGuides2 = _interopRequireDefault(_StilGuides);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _GrundskoleIndberetningResume = __webpack_require__(366);
	
	var _GrundskoleIndberetningResume2 = _interopRequireDefault(_GrundskoleIndberetningResume);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    GrundskoleIndberetningResume: _GrundskoleIndberetningResume2.default,
	    StilGuides: _StilGuides2.default,
	    ChangeSchoolYear: _ChangeSchoolYear2.default,
	    Loader: _Loader2.default,
	    GrundskoleIndberetningTimetal: _GrundskoleIndberetningTimetal2.default
	  },
	  data: function data() {
	    return {
	      isSendingToStil: false,
	      stilData: [],
	      isLoadingStilData: false,
	      userEmailInput: '',
	      userEmailFormErrors: {},
	      isSavingUserEmail: false
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isUserLoaded: function isUserLoaded() {
	      return this.$store.state.isUserLoaded;
	    },
	    userHasNoEmail: function userHasNoEmail() {
	      return this.user && this.user.email === null;
	    },
	    isSaveButtonForUserEmailDisabled: function isSaveButtonForUserEmailDisabled() {
	      return this.userEmailInput.length < 3;
	    }
	  },
	  watch: {
	    user: function user() {
	      var _this = this;
	
	      if (this.userHasNoEmail) {
	        setTimeout(function () {
	          var el = _this.$refs.user_email_input;
	          if (el) {
	            _this.$refs.user_email_input.focus();
	          }
	        }, 0);
	        return;
	      }
	      this.isLoadingStilData = true;
	      _docendo2.default.showStilReport(this.schoolId, function (success) {
	        _this.isLoadingStilData = false;
	        _this.stilData = success;
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  },
	  methods: {
	    submit: function submit() {
	      var _this2 = this;
	
	      this.isSendingToStil = true;
	      _docendo2.default.submitStilReport(this.schoolId, function (success) {
	        _this2.isSendingToStil = false;
	        _eventbus2.default.toast = { text: 'Grundskoleindberetning er sendt til STIL', 'success': true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Noget gik galt', 'success': false };
	      });
	    },
	    setTolaerer: function setTolaerer(obj) {
	      var _this3 = this;
	
	      var setting = obj.godkendelseskode === 'J' ? 'N' : 'J';
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj._type && stilTing.klassetype === obj.klassetype && stilTing.godkendelsestype === obj.godkendelsestype && stilTing.klassetrin === obj.klassetrin;
	      });
	      stilData['undervisningskema'][idx]['godkendelseskode'] = setting;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this3.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    setForanstaltning: function setForanstaltning(obj) {
	      var _this4 = this;
	
	      var setting = obj.godkendelseskode === 'J' ? 'N' : 'J';
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj._type && stilTing.klassetype === obj.klassetype && stilTing.godkendelsestype === obj.godkendelsestype && stilTing.klassetrin === obj.klassetrin;
	      });
	      stilData['undervisningskema'][idx]['godkendelseskode'] = setting;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this4.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    updatePraktik: function updatePraktik(obj) {
	      var _this5 = this;
	
	      var setting = obj.praktikkode === 'J' ? 'N' : 'J';
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj.v_fag._type;
	      });
	      stilData['undervisningskema'][idx]['praktikkode'] = setting;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this5.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    updateKonfirmation: function updateKonfirmation(obj) {
	      var _this6 = this;
	
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj.v_fag._type;
	      });
	      if (stilData['undervisningskema'][idx]['klassetrin'] === obj.value) {
	        stilData['undervisningskema'][idx]['klassetrin'] = null;
	      } else {
	        stilData['undervisningskema'][idx]['klassetrin'] = obj.value;
	      }
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this6.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    updateSubject: function updateSubject(obj) {
	      var _this7 = this;
	
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj.originalObject._type && stilTing.klassetype === obj.originalObject.klassetype && stilTing.fagkode === obj.originalObject.fagkode && stilTing.klassetrin === obj.originalObject.klassetrin;
	      });
	      stilData['undervisningskema'][idx][obj.toUpdate] = obj.value * 1;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this7.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    nulstilKlasse: function nulstilKlasse(grade) {
	      var _this8 = this;
	
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var subjects = stilData['undervisningskema'].filter(function (subject) {
	        return subject._type === 'undervisningstid' && subject.klassetrin === grade.value * 1;
	      });
	      subjects.forEach(function (subject) {
	        var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	          return stilTing._type === subject._type && stilTing.klassetype === subject.klassetype && stilTing.fagkode === subject.fagkode && stilTing.klassetrin === subject.klassetrin;
	        });
	        stilData['undervisningskema'][idx]['klokketimer'] = 0;
	        _docendo2.default.updateStilReport(_this8.schoolId, stilData, function (success) {
	          _this8.stilData = success;
	        }, function (failure) {
	          console.log('failure', failure);
	        });
	      });
	    },
	    update: function update(obj) {
	      var _this9 = this;
	
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData[obj.type].findIndex(function (elevtal) {
	        return elevtal._type === obj.cell._type && elevtal.elevtaltype === obj.cell.elevtaltype && elevtal.klassetrin === obj.cell.klassetrin;
	      });
	      stilData[obj.type][idx]['antal'] = obj.num * 1;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this9.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    submitUserEmail: function submitUserEmail() {
	      var _this10 = this;
	
	      this.formValidation();
	      if ((0, _keys2.default)(this.userEmailFormErrors).length > 0) {
	        return;
	      }
	      this.isSavingUserEmail = true;
	      var changes = { email: this.userEmailInput };
	      _docendo2.default.updateUser(changes, function (success) {
	        _eventbus2.default.toast = { text: 'Emailen er gemt', 'success': true };
	        var obj = {
	          prop: 'email',
	          email: success.email
	        };
	        _this10.$store.commit('updateUserProp', obj);
	        _this10.isSavingUserEmail = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Email er allerede brugt', 'success': false };
	        _this10.isSavingUserEmail = false;
	      });
	    },
	    formValidation: function formValidation() {
	      this.userEmailFormErrors = {};
	      if (!this.validateEmail(this.userEmailInput)) {
	        this.$set(this.userEmailFormErrors, 'email', 'Er ikke en gyldig email');
	      }
	    },
	    validateEmail: function validateEmail(email) {
	      var emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
	      return email.trim() !== '' && emailRegex.test(email);
	    },
	    removeErrors: function removeErrors(title) {
	      this.$delete(this.userEmailFormErrors, title);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUser');
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('getUsersFromSchoolId', this.schoolId);
	    this.$store.dispatch('readSchoolYears', this.schoolId);
	  }
	};

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    editsms: {
	      type: Object
	    },
	    messageType: {
	      default: 'sms'
	    }
	  },
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      _docendo2.default.deleteMessageTemplate(window.SCHOOL.id, this.editsms.id, function (success) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.sms.template_sms_deleted'), success: true };
	        _this.$emit('updated');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.sms.an_error_occured'), success: false };
	        _this.$emit('close');
	      });
	    }
	  }
	};

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _autosize = __webpack_require__(424);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    editsms: {
	      type: Object
	    },
	    messageType: {
	      default: 'sms'
	    }
	  },
	  data: function data() {
	    return {
	      title: '',
	      body: '',
	      errors: {}
	    };
	  },
	
	  computed: {
	    today: function today() {
	      _moment2.default.locale(window.USER.language);
	      return (0, _moment2.default)().format('dddd');
	    }
	  },
	  methods: {
	    insertToday: function insertToday() {
	      this.body = this.body + '[today]';
	      this.$refs.smsbodyinput.focus();
	    },
	    validation: function validation() {
	      if (this.title.length < 1) {
	        this.$set(this.errors, 'title', this.$t('vue2.common.must_be_filled'));
	      }
	      if (this.body.length < 1) {
	        this.$set(this.errors, 'body', this.$t('vue2.common.must_be_filled'));
	      }
	    },
	    resetValidation: function resetValidation(type) {
	      this.$delete(this.errors, type);
	    },
	    updateTemplate: function updateTemplate() {
	      var _this = this;
	
	      this.validation();
	      if (this.errors.length > 0) {
	        return;
	      }
	      _docendo2.default.updateMessageTemplate(window.SCHOOL.id, this.editsms.id, this.title, this.body, this.editsms.message_type, function (success) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.sms.updated_sms_template'), success: true };
	        _this.$emit('updated');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.sms.an_error_occured'), success: false };
	      });
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      this.validation();
	      if (this.errors.length > 0) {
	        return;
	      }
	      var messageType = this.messageType === 'sms' ? 'sms' : 'email';
	      _docendo2.default.createMessageTemplate(window.SCHOOL.id, this.title, this.body, messageType, function (success) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.sms.created_sms_template'), success: true };
	        _this2.$emit('updated');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.sms.an_error_occured'), success: false };
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.editsms) {
	      this.title = this.editsms.title;
	      this.body = this.editsms.body;
	    }
	  },
	  mounted: function mounted() {
	    (0, _autosize2.default)(document.querySelectorAll('textarea'));
	    this.$refs.titleInput.focus();
	  }
	};

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _SmsAddNumber = __webpack_require__(138);
	
	var _SmsAddNumber2 = _interopRequireDefault(_SmsAddNumber);
	
	var _MessageTemplate = __webpack_require__(369);
	
	var _MessageTemplate2 = _interopRequireDefault(_MessageTemplate);
	
	var _MedssageTemplateDelete = __webpack_require__(368);
	
	var _MedssageTemplateDelete2 = _interopRequireDefault(_MedssageTemplateDelete);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SendMessagesUserSetting = __webpack_require__(372);
	
	var _SendMessagesUserSetting2 = _interopRequireDefault(_SendMessagesUserSetting);
	
	var _Loader3 = __webpack_require__(5);
	
	var _Loader4 = _interopRequireDefault(_Loader3);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _TaggingFilter = __webpack_require__(43);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	var _DoFilters = __webpack_require__(134);
	
	var _DoFilters2 = _interopRequireDefault(_DoFilters);
	
	var _SendMessagesPastSmses = __webpack_require__(371);
	
	var _SendMessagesPastSmses2 = _interopRequireDefault(_SendMessagesPastSmses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    send_message: 'Send besked',
	    recipient: 'Modtager',
	    a_recipient: 'Vælg en modtager',
	    subject: 'Emnefelt',
	    message: 'Besked',
	    message_must_be_filled: 'Besked skal udfyldes',
	    sending_message: 'Sender besked',
	    message_sent: 'Besked sendt',
	    no_users_matches: 'Ingen brugere matcher din søgning',
	    todays_substitutes: 'Vælg dagens vikarer',
	    send_message_to: 'Send besked til',
	    select_a_standard_template: 'Vælg en besked',
	    create_a_standard_template: 'Opret ny standard besked',
	    recipients: 'Modtagere',
	    select_recipients: 'Vælg modtagere fra listen til venstre',
	    deactivate_sms: 'Slå SMS fra',
	    activate_sms: 'Slå SMS til',
	    deactivate_email: 'Slå email fra',
	    activate_email: 'Slå email til',
	    add_number: 'Tilføj nummer',
	    add_email: 'Tilføj email',
	    awaiting_approval: 'Afventer bekræftelse',
	    sms: 'SMS',
	    email: 'email',
	    settings: 'Indstillinger',
	    email_sent: 'Emails afsendt',
	    sms_sent: 'SMSer afsendt',
	    welcome_to_sms: 'Velkommen til SMS',
	    add_your_number_to_send_sms: 'Indtast dit mobilnummer for at begynde at sende smser til skolens personale. Modtagere kan besvare til dette nummer.',
	    add_your_number: 'Tilføj dit mobilnummer',
	    last_sms: 'Sidst sendt til',
	    see_message: 'Se besked'
	  },
	  nb: {
	    send_message: 'Send melding',
	    recipient: 'Velg mottaker',
	    a_recipient: 'Velg en mottaker',
	    subject: 'Emnefelt',
	    message: 'Melding',
	    message_must_be_filled: 'Meldingsfelt må utfylles',
	    sending_message: 'Sender melding',
	    message_sent: 'Melding sendt',
	    no_users_matches: 'Ingen brukere passer til søket',
	    todays_substitutes: 'Dagens vikarer',
	    send_message_to: 'Send melding til',
	    select_a_standard_template: 'Velg en melding',
	    create_a_standard_sms: 'Opprett ny standardmelding',
	    recipients: 'Mottakere',
	    select_recipients: 'Velg mottakere fra listen til venstre',
	    deactivate_sms: 'Deaktivere SMS',
	    activate_sms: 'Aktivere SMS',
	    deactivate_email: 'Deaktivere e-post',
	    activate_email: 'Aktivere e-post',
	    add_number: 'Legg til nummer',
	    add_email: 'Legg til e-post',
	    awaiting_approval: 'Venter på bekreftelse',
	    sms: 'SMS',
	    email: 'e-post',
	    settings: 'Innstillinger',
	    email_sent: 'E-poster sendt',
	    sms_sent: 'SMS sendt',
	    last_sms: 'Sist sendt til',
	    see_message: 'Se melding'
	  },
	  en: {
	    send_message: 'Send message',
	    recipient: 'Recipient',
	    a_recipient: 'Choose a recipient',
	    subject: 'Subject',
	    message: 'Message',
	    message_must_be_filled: 'Message can not be empty',
	    sending_message: 'Sending message',
	    message_sent: 'Message sent',
	    no_users_matches: 'No matching users',
	    todays_substitutes: 'Substitutes today',
	    send_message_to: 'Send message to',
	    select_a_standard_template: 'Choose a template',
	    create_a_standard_template: 'Create new template',
	    recipients: 'Recipients',
	    select_recipients: 'Choose users to receive the message',
	    deactivate_sms: 'Deactivate SMS',
	    activate_sms: 'Activate SMS',
	    deactivate_email: 'Deactivate email',
	    activate_email: 'Activate email',
	    add_number: 'Add number',
	    add_email: 'Add email',
	    awaiting_approval: 'Awaiting approval',
	    sms: 'SMS',
	    email: 'email',
	    settings: 'Settings',
	    email_sent: 'Emails sent',
	    sms_sent: 'SMS sent',
	    last_sms: 'Last sent to',
	    see_message: 'See message'
	  }
	};
	
	exports.default = {
	  components: {
	    SendMessagesPastSmses: _SendMessagesPastSmses2.default,
	    DoFilters: _DoFilters2.default,
	    TaggingFilter: _TaggingFilter2.default,
	    DoFiltersFilter: _DoFiltersFilter2.default,
	    Loader: _Loader4.default, SendMessagesUserSetting: _SendMessagesUserSetting2.default, DDropdown: _DDropdown2.default, SmsAddNumber: _SmsAddNumber2.default, TemplateModal: _MessageTemplate2.default, TemplateDelete: _MedssageTemplateDelete2.default, Spinner: _Loader2.default
	  },
	  data: function data() {
	    return {
	      pastSmsModalUser: null,
	      pastSmsModalData: null,
	      sortMode: 'name',
	      pastSmsesMap: {},
	      isEmailActive: true,
	      isSMSActive: false,
	      isOpen: false,
	      selectedWithoutContactForm: [],
	      selectedUser: '',
	      messageSubject: '',
	      messageBody: '',
	      giveFeedback: false,
	      selectedUsers: [],
	      searchText: '',
	      appliedFilters: [],
	      tags: [],
	      isCreateTemplate: false,
	      theEditTemplate: null,
	      theDeleteTemplate: null,
	      isLoadingTemplates: true,
	      templates: [],
	      theActiveEditUser: null,
	      isEmailSent: true,
	      isSMSSent: true,
	      isLoading: true,
	      isInitialLoad: true,
	      isShowPastSMSes: false
	    };
	  },
	
	  computed: {
	    user: function user() {
	      return this.$store.state.user;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    activeDate: function activeDate() {
	      return this.$store.state.subs.date;
	    },
	    noNumberForUser: function noNumberForUser() {
	      return this.user && !this.user.phone;
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    usersToReceiveEmail: function usersToReceiveEmail() {
	      var users = this.userSetSelected.filter(function (user) {
	        return user.v_email_setting === 'active';
	      });
	      return users.map(function (user) {
	        return user.id;
	      });
	    },
	    usersToReceiveSMS: function usersToReceiveSMS() {
	      var users = this.userSetSelected.filter(function (user) {
	        return user.v_phone_setting === 'active';
	      });
	      return users.map(function (user) {
	        return user.id;
	      });
	    },
	    userSetSelected: function userSetSelected() {
	      var usersMap = this.usersWithCustomProps.reduce(function (acc, user) {
	        acc[user.id] = user;
	        return acc;
	      }, {});
	
	      return this.selectedUsers.filter(function (id) {
	        return usersMap[id];
	      }).map(function (id) {
	        return usersMap[id];
	      });
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    usersSortedOnName: function usersSortedOnName() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    noText: function noText() {
	      return this.messageBody.length < 1 || this.messageSubject.length < 1;
	    },
	    noReceiver: function noReceiver() {
	      return this.selectedUsers.length < 1;
	    },
	    usersUrl: function usersUrl() {
	      return '/schools/' + this.schoolId + '/users';
	    },
	    usersWithCustomProps: function usersWithCustomProps() {
	      var _this = this;
	
	      return this.usersSortedOnName.map(function (user) {
	        var vPhoneSetting = _this.getContactOption(user, 'phone');
	        var vEmailSetting = _this.getContactOption(user, 'email');
	
	        var lastRow = _this.pastSmsesMap[user.id];
	        var lastTs = lastRow ? lastRow.created_at : null;
	        var lastHuman = lastTs ? _this.formatLastSmsHuman(lastTs) : null;
	        var lastRelative = lastTs ? _this.formatLastSmsRelative(lastTs) : null;
	
	        return (0, _extends3.default)({}, user, {
	          v_phone_setting: vPhoneSetting,
	          v_phone_tooltip: _this.getTooltipText('sms', vPhoneSetting),
	          v_email_setting: vEmailSetting,
	          v_email_tooltip: _this.getTooltipText('email', vEmailSetting),
	          v_last_sms_row: lastRow,
	          v_last_sms_at: lastTs,
	          v_last_sms_at_human: lastHuman,
	          v_last_sms_relative: lastRelative
	        });
	      });
	    },
	    searchedUsers: function searchedUsers() {
	      var _this2 = this;
	
	      return this.usersWithCustomProps.filter(function (user) {
	        return user.name !== '' ? user.name.match(new RegExp(_this2.searchText, 'i')) : '';
	      });
	    },
	    filteredUsers: function filteredUsers() {
	      var _this3 = this;
	
	      var passedUsers = this.searchedUsers;
	      if (this.appliedFilters.length > 0) {
	        passedUsers = passedUsers.filter(function (user) {
	          return user.user_tags.some(function (tag) {
	            return _this3.appliedFilters.includes(tag);
	          });
	        });
	      }
	
	      var collator = new Intl.Collator(this.locale || 'da-DK', { sensitivity: 'base', numeric: true });
	
	      return passedUsers.slice().sort(function (a, b) {
	        if (_this3.sortMode === 'last') {
	          var aTs = a.v_last_sms_at || null;
	          var bTs = b.v_last_sms_at || null;
	
	          if (aTs && !bTs) return -1;
	          if (!aTs && bTs) return 1;
	
	          if (aTs && bTs) {
	            var _aTime = (0, _moment2.default)(aTs).valueOf();
	            var _bTime = (0, _moment2.default)(bTs).valueOf();
	            if (_aTime !== _bTime) return _bTime - _aTime;
	          }
	
	          return collator.compare(a.name || '', b.name || '');
	        }
	
	        var nameCmp = collator.compare(a.name || '', b.name || '');
	        if (nameCmp !== 0) return nameCmp;
	
	        var aTime = a.v_last_sms_at ? (0, _moment2.default)(a.v_last_sms_at).valueOf() : 0;
	        var bTime = b.v_last_sms_at ? (0, _moment2.default)(b.v_last_sms_at).valueOf() : 0;
	        return bTime - aTime;
	      });
	    },
	    absentUsersFromUserSet: function absentUsersFromUserSet() {
	      return this.$store.getters.absentUsersFromUserSet;
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    }
	  },
	  watch: {
	    activeDate: function activeDate() {
	      this.removeAllSelectedUsers();
	    }
	  },
	  methods: {
	    showSent: function showSent(user) {
	      var row = user && user.v_last_sms_row ? user.v_last_sms_row : null;
	      this.pastSmsModalUser = user;
	      this.pastSmsModalData = row;
	      this.isShowPastSMSes = true;
	      this.$store.dispatch('trackEvent', 'substitution_SMS_showLastSentMessage');
	    },
	    toggleSortByLast: function toggleSortByLast() {
	      this.sortMode = this.sortMode === 'last' ? 'name' : 'last';
	      this.$store.dispatch('trackEvent', 'substitution_SMS_sortedBySent');
	    },
	    readPastSMSes: function readPastSMSes() {
	      var _this4 = this;
	
	      _docendo2.default.pastSmses(this.schoolId, function (success) {
	        var rows = success && success.data ? success.data : [];
	        var byUser = {};
	
	        for (var i = 0; i < rows.length; i++) {
	          var row = rows[i];
	          var uid = row.user_id;
	          if (!byUser[uid]) {
	            byUser[uid] = row;
	          } else {
	            var newer = (0, _moment2.default)(row.created_at).isAfter((0, _moment2.default)(byUser[uid].created_at));
	            if (newer) byUser[uid] = row;
	          }
	        }
	
	        _this4.pastSmsesMap = byUser;
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    formatLastSmsHuman: function formatLastSmsHuman(ts) {
	      if (!ts) return '';
	
	      return (0, _moment2.default)(ts).format('lll');
	    },
	    formatLastSmsRelative: function formatLastSmsRelative(ts) {
	      if (!ts) return '';
	      return (0, _moment2.default)(ts).fromNow();
	    },
	    toggleTag: function toggleTag(tag) {
	      var idx = this.appliedFilters.indexOf(tag);
	      if (idx > -1) {
	        this.appliedFilters.splice(idx, 1);
	      } else {
	        this.appliedFilters.push(tag);
	      }
	    },
	    clearAllTags: function clearAllTags() {
	      this.appliedFilters = [];
	      this.removeAllSelectedUsers();
	    },
	    setOpen: function setOpen(bool) {
	      if (bool) {
	        this.isLoading = true;
	        this.isOpen = true;
	        if (this.isInitialLoad) {
	          this.readTags();
	          this.$store.dispatch('getUsers');
	          this.readPastSMSes();
	          this.readMessageTemplates();
	        }
	        this.isInitialLoad = false;
	      } else {
	        this.isOpen = false;
	      }
	    },
	    onEnterComplete: function onEnterComplete() {
	      this.isLoading = false;
	    },
	    getTooltipText: function getTooltipText(contactType, setting) {
	      var tooltips = {
	        active: this.i18n[this.locale]['deactivate_' + contactType],
	        no_number: this.i18n[this.locale]['add_number'],
	        no_email: this.i18n[this.locale]['add_email'],
	        awaiting_approval: this.i18n[this.locale]['awaiting_approval'],
	        deactivated: this.i18n[this.locale]['activate_' + contactType]
	      };
	      return tooltips[setting];
	    },
	    setOption: function setOption(user, contactType) {
	      var currentSetting = this.getContactOption(user, contactType);
	      var needsEdit = contactType === 'phone' && currentSetting === 'no_number' || contactType === 'email' && currentSetting === 'no_email' || currentSetting === 'awaiting_approval';
	
	      if (needsEdit) {
	        this.theActiveEditUser = user;
	        return;
	      }
	
	      if (['active', 'deactivated'].includes(currentSetting)) {
	        this.updateUserSettings(user, contactType);
	      }
	    },
	    getContactOption: function getContactOption(user, contactType) {
	      if (contactType === 'phone' && !this.isSMSActive) return 'no_number';
	      if (contactType === 'email' && !this.isEmailActive) return 'no_email';
	
	      var hasContact = user[contactType];
	      if (!hasContact) return contactType === 'phone' ? 'no_number' : 'no_email';
	
	      if (contactType === 'phone' && user.unconfirmed_phone) return 'awaiting_approval';
	
	      var userSettings = JSON.parse(user.settings);
	      if (userSettings['dont_receive_' + contactType]) return 'deactivated';
	
	      return 'active';
	    },
	    closeUserSetting: function closeUserSetting() {
	      var user = this.allUsersInHash[this.theActiveEditUser.id];
	      var emailSetting = this.getContactOption(user, 'email');
	      var phoneSetting = this.getContactOption(user, 'phone');
	      if (emailSetting === 'active' || phoneSetting === 'active') {
	        var idx2 = this.selectedWithoutContactForm.indexOf(user.id);
	        if (idx2 > -1) {
	          this.selectedWithoutContactForm.splice(idx2, 1);
	        }
	      } else {
	        var idx = this.selectedUsers.indexOf(user.id);
	        if (idx > -1) {
	          this.selectedUsers.splice(idx, 1);
	        }
	      }
	      this.theActiveEditUser = null;
	    },
	    updateUserSettings: function updateUserSettings(user, contactType) {
	      var _this5 = this;
	
	      var idx = this.selectedWithoutContactForm.indexOf(user.id);
	      if (idx > -1) {
	        this.selectedWithoutContactForm.splice(idx, 1);
	      }
	      var idx2 = this.selectedUsers.indexOf(user.id);
	      if (idx2 > -1) {
	        this.selectedUsers.splice(idx2, 1);
	      }
	      var userSettings = JSON.parse(user.settings);
	      var varOption = 'dont_receive_' + contactType;
	      var settingsObj = {};
	      settingsObj[varOption] = true;
	      var prop = (0, _keys2.default)(settingsObj)[0];
	      if (this.getContactOption(user, contactType) === 'deactivated') {
	        delete userSettings[prop];
	      } else {
	        var val = settingsObj[prop];
	        userSettings[prop] = val;
	      }
	      var changes = { settings: (0, _stringify2.default)(userSettings) };
	      _docendo2.default.updateUsers(this.schoolId, user.id, changes, function (data) {
	        _this5.$store.commit('updateSchoolUser', data);
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    setTheEditTemplate: function setTheEditTemplate(template) {
	      this.theEditTemplate = template;
	      this.isCreateTemplate = true;
	    },
	    createNewTemplate: function createNewTemplate() {
	      this.isCreateTemplate = true;
	    },
	    closeTemplate: function closeTemplate() {
	      this.theEditTemplate = null;
	      this.theDeleteTemplate = null;
	      this.isCreateTemplate = false;
	    },
	    selectTemplate: function selectTemplate(template) {
	      var today = (0, _moment2.default)().format('dddd');
	      this.messageSubject = template.title.replace('[today]', today);
	      this.messageBody = template.body.replace('[today]', today);
	    },
	    getSubsOfTheDay: function getSubsOfTheDay() {
	      var _this6 = this;
	
	      var userMap = this.usersWithCustomProps.reduce(function (acc, user) {
	        acc[user.user_calendar_id] = user;
	        return acc;
	      }, {});
	
	      var today = (0, _moment2.default)(this.activeDate).format('YYYY-MM-DD');
	
	      var eventsHash = this.allEventsInAHash || {};
	      var events = (0, _keys2.default)(eventsHash).map(function (id) {
	        return eventsHash[id];
	      });
	
	      events.forEach(function (lesson) {
	        if (!lesson) return;
	        if (lesson.v_is_event_from_other_school) return;
	
	        var lessonDay = (0, _moment2.default)(lesson.start).format('YYYY-MM-DD');
	        if (lessonDay !== today) return;
	
	        var calEvents = lesson.calendar_events || [];
	        var subEvents = calEvents.filter(function (e) {
	          return e.substitute || e.is_substitute;
	        });
	
	        subEvents.forEach(function (subEvent) {
	          var subUser = userMap[subEvent.calendar_id];
	          if (subUser) _this6.setSub(subUser);
	        });
	      });
	    },
	    getUserLessons: function getUserLessons(user) {
	      var _this7 = this;
	
	      var lessons = user.dayEvents.map(function (eventId) {
	        return _this7.allEventsInAHash[eventId];
	      });
	      lessons.filter(function (lesson) {
	        return !lesson.v_is_event_from_other_school;
	      }).forEach(function (lesson) {
	        _this7.getSubsFromLessons(lesson);
	      });
	    },
	    getSubsFromLessons: function getSubsFromLessons(lesson) {
	      var _this8 = this;
	
	      var subEvents = lesson.calendar_events.filter(function (event) {
	        return event.substitute || event.is_substitute;
	      });
	
	      var userMap = this.usersWithCustomProps.reduce(function (acc, user) {
	        acc[user.user_calendar_id] = user;
	        return acc;
	      }, {});
	
	      subEvents.forEach(function (subEvent) {
	        var sub = userMap[subEvent.calendar_id];
	        if (sub) {
	          _this8.setSub(sub);
	        }
	      });
	    },
	    setSub: function setSub(user, $event) {
	      if (user.v_phone_setting === 'active' || user.v_email_setting === 'active') {
	        if (this.selectedUsers.indexOf(user.id) < 0) {
	          this.selectedUsers.push(user.id);
	        }
	      } else {
	        if (this.selectedWithoutContactForm.indexOf(user.id) < 0) {
	          this.selectedWithoutContactForm.push(user.id);
	        }
	      }
	    },
	    checkIfInListWithoutContactForm: function checkIfInListWithoutContactForm(userid) {
	      return this.selectedWithoutContactForm.indexOf(userid) > -1;
	    },
	    resetData: function resetData() {
	      this.selectedUsers = [];
	      this.selectedUser = '';
	      this.messageSubject = '';
	      this.messageBody = '';
	    },
	    sendMessage: function sendMessage() {
	      var usersToReceiveEmail = this.usersToReceiveEmail;
	      var usersToReceiveSMS = this.usersToReceiveSMS;
	      if (usersToReceiveEmail.length > 0) {
	        this.isEmailSent = false;
	      }
	      if (usersToReceiveSMS.length > 0) {
	        this.isSMSSent = false;
	      }
	      if (usersToReceiveEmail.length > 0) {
	        this.sendEmails(usersToReceiveEmail);
	      }
	      if (usersToReceiveSMS.length > 0) {
	        this.sendSMS(usersToReceiveSMS);
	      }
	    },
	    sendEmails: function sendEmails(userIds) {
	      var _this9 = this;
	
	      _eventbus2.default.toast = { text: this.i18n[this.locale]['sending_message'], 'success': false };
	      this.isOpen = false;
	      _docendo2.default.sendEmails(this.schoolId, userIds, this.messageSubject, this.messageBody, function (success) {
	        _this9.isEmailSent = true;
	        _eventbus2.default.toast = { text: _this9.i18n[_this9.locale]['email_sent'], 'success': true };
	        if (_this9.isSMSSent) {
	          _this9.resetData();
	        }
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      });
	    },
	    sendSMS: function sendSMS(userIds) {
	      var _this10 = this;
	
	      _docendo2.default.sendSmses(this.schoolId, userIds, this.messageBody, function (data) {
	        _this10.isSMSSent = true;
	        _eventbus2.default.toast = { text: _this10.i18n[_this10.locale]['sms_sent'], 'success': true };
	        if (_this10.isEmailSent) {
	          _this10.resetData();
	        }
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      });
	    },
	    removeAllSelectedUsers: function removeAllSelectedUsers() {
	      this.selectedUsers = [];
	      this.selectedWithoutContactForm = [];
	    },
	    setUser: function setUser(user, idx, $event) {
	      if (user.v_phone_setting === 'active' || user.v_email_setting === 'active') {
	        if (this.selectedUsers.indexOf(user.id) > -1) {
	          this.selectedUsers.splice(this.selectedUsers.indexOf(user.id), 1);
	        } else {
	          this.selectedUsers.push(user.id);
	        }
	      } else {
	        if (this.selectedWithoutContactForm.indexOf(user.id) < 0) {
	          this.selectedWithoutContactForm.push(user.id);
	        }
	      }
	    },
	    setAllUsersSelected: function setAllUsersSelected() {
	      this.selectedUsers = [];
	      this.selectedWithoutContactForm = [];
	      for (var i = 0; i < this.filteredUsers.length; i++) {
	        var user = this.filteredUsers[i];
	        if (user.v_phone_setting === 'active' || user.v_email_setting === 'active') {
	          this.selectedUsers.push(user.id);
	        }
	      }
	    },
	    checkIfInList: function checkIfInList(userid) {
	      return this.selectedUsers.indexOf(userid) > -1;
	    },
	    readMessageTemplates: function readMessageTemplates() {
	      var _this11 = this;
	
	      this.closeTemplate();
	      this.isLoadingTemplates = true;
	      this.templates = [];
	      _docendo2.default.readMessageTemplates(this.schoolId, function (messages) {
	        _this11.templates = messages.filter(function (message) {
	          return message.message_type === 'email';
	        });
	        _this11.isLoadingTemplates = false;
	      }, function (failure) {
	        console.log('failed');
	      });
	    },
	    readTags: function readTags() {
	      var _this12 = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this12.tags = data;
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    var country = window.SCHOOL.country && window.SCHOOL.country.toLowerCase();
	    if (country === 'dk' || country === 'no') {
	      this.isSMSActive = true;
	    }
	  }
	};

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    modal_title: 'Senest sendte besked',
	    user: 'Bruger',
	    sent: 'Sendt',
	    phone: 'Telefon',
	    content: 'Indhold',
	    no_previous: 'Der er ingen tidligere besked til denne bruger',
	    close: 'Luk'
	  },
	  nb: {
	    modal_title: 'Sist sendte melding',
	    user: 'Bruker',
	    sent: 'Sendt',
	    phone: 'Telefon',
	    content: 'Innhold',
	    no_previous: 'Det finnes ingen tidligere melding til denne brukeren',
	    close: 'Lukk'
	  },
	  en: {
	    modal_title: 'Most recent message',
	    user: 'User',
	    sent: 'Sent',
	    phone: 'Phone',
	    content: 'Content',
	    no_previous: 'There is no previous message to this user',
	    close: 'Close'
	  }
	};
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    activeUser: { type: Object, default: null },
	    sms: { type: Object, default: null }
	  },
	  computed: {
	    i18n: function i18n() {
	      return I18N;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    humanTime: function humanTime() {
	      if (!this.sms || !this.sms.created_at) return '';
	      return (0, _moment2.default)(this.sms.created_at).format('lll');
	    }
	  }
	};

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _isInteger = __webpack_require__(73);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _SmsAddNumber = __webpack_require__(138);
	
	var _SmsAddNumber2 = _interopRequireDefault(_SmsAddNumber);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    awaiting_approval: 'Afventer bekræftelse',
	    user_settings: 'Brugerindstillinger',
	    mobile_number: 'Mobilnummer',
	    number_must_be_8_digits: 'Telefonummer skal være 8 cifre',
	    receive_sms: 'Modtag SMS',
	    email: 'Email',
	    use_a_valid_email: 'Skriv en gyldig email',
	    receive_email: 'Modtag email',
	    user_updated: 'Opdateret'
	  },
	  nb: {
	    awaiting_approval: 'Venter på bekreftelse',
	    user_settings: 'brukerinstillinger',
	    mobile_number: 'Telefonnummer',
	    number_must_be_8_digits: 'Telefonnummer må være 8 sifre',
	    receive_sms: 'Motta SMS',
	    email: 'E-post',
	    use_a_valid_email: 'Bruk en gyldig e-post',
	    receive_email: 'Motta epost',
	    user_updated: 'Oppdatert'
	  },
	  en: {
	    awaiting_approval: 'Awaiting approval',
	    user_settings: 'User settings',
	    mobile_number: 'Mobile number',
	    number_must_be_8_digits: 'Mobile number must be 8 digits',
	    receive_sms: 'Receive sms',
	    email: 'Email',
	    use_a_valid_email: 'Use a valid email',
	    receive_email: 'Receive email',
	    user_updated: 'User updated'
	  }
	};
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default, DModal: _DModal2.default, DDropdown: _DDropdown2.default, SmsAddNumber: _SmsAddNumber2.default },
	  props: {
	    user: {},
	    isEmailActive: {
	      type: Boolean,
	      default: true
	    },
	    isSMSActive: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      phone: '',
	      initialPhone: '',
	      isPhoneValid: true,
	      isAnimatePhoneUnconfirmed: false,
	      isAnimatePhone: false,
	      email: '',
	      initialEmail: '',
	      initialReceiveSMS: true,
	      receiveSMS: true,
	      hideSMSToggle: false,
	      receiveEmails: true,
	      initialReceiveEmails: true,
	      isEmailValid: true,
	      hideEmailToggle: false,
	      activeCountry: null,
	      countries: [{ name: 'Danmark', countryCode: '45', code: 'dk', flag: 'https://zen.docendo.co/flags/dk.svg' }, { name: 'Norge', countryCode: '47', code: 'no', flag: 'https://zen.docendo.co/flags/no.svg' }, { name: 'United States', countryCode: '1', code: 'us', flag: 'https://zen.docendo.co/flags/us.svg' }],
	      isSubmitting: false,
	      initialUserSettings: null,
	      userSettings: null,
	      errors: {}
	    };
	  },
	
	  computed: {
	    i18n: function i18n() {
	      return I18N;
	    },
	    locale: function locale() {
	      return window.USER.language ? window.USER.language : 'en';
	    },
	    isUSA: function isUSA() {
	      return this.activeCountry.code === 'us';
	    },
	    isNumberBeingDeleted: function isNumberBeingDeleted() {
	      return this.phone.length === 0 && this.phone !== this.initialPhone;
	    }
	  },
	  methods: {
	    toggleSetting: function toggleSetting(contactType) {
	      var _this = this;
	
	      if (contactType === 'phone') {
	        if (this.user.v_phone_setting === 'no_number' || this.phone.length < 1) {
	          this.isPhoneValid = false;
	          this.isAnimatePhone = true;
	          clearTimeout(dTimer);
	          this.$refs.input_phone.focus();
	          var dTimer = setTimeout(function (_) {
	            _this.isAnimatePhone = false;
	          }, 1000);
	          return;
	        }
	        if (this.user.v_phone_setting === 'awaiting_approval') {
	          var _dTimer = null;
	          clearTimeout(_dTimer);
	          this.isAnimatePhoneUnconfirmed = true;
	          _dTimer = setTimeout(function (_) {
	            _this.isAnimatePhoneUnconfirmed = false;
	          }, 1000);
	          return;
	        }
	        this.receiveSMS = !this.receiveSMS;
	      }
	    },
	    validateEmail: function validateEmail(email) {
	      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      this.isEmailValid = email.length < 1 ? true : re.test(String(email).toLowerCase());
	    },
	    setActiveCountry: function setActiveCountry(country) {
	      this.activeCountry = country;
	    },
	    onPhoneKeyup: function onPhoneKeyup(number) {
	      if (number.length === 0 || number.length > 8) {
	        this.hideSMSToggle = true;
	      }
	      if (number.length === 8) {
	        this.hideSMSToggle = false;
	      }
	      this.isPhoneValid = true;
	    },
	    isValidNumber: function isValidNumber(number) {
	      if (this.isUSA) {
	        return true;
	      }
	      var num = number * 1;
	      this.isPhoneValid = number.length < 1 ? true : (0, _isInteger2.default)(num) && number.length === 8;
	    },
	    setNumber: function setNumber() {
	      var num = '';
	
	      if (this.user.phone) {
	        num = !this.isUSA && this.user.phone.substr(0, 2) === this.activeCountry.countryCode ? this.user.phone.replace(this.activeCountry.countryCode, '') : this.user.phone;
	      }
	      this.initialPhone = num;
	      this.phone = num;
	    },
	    updateUserSettings: function updateUserSettings(contactType) {
	      var userSettings = JSON.parse(this.userSettings);
	      var varOption = 'dont_receive_' + contactType;
	      var settingsObj = {};
	      settingsObj[varOption] = true;
	      var prop = (0, _keys2.default)(settingsObj)[0];
	      if (this.getContactOption(this.user, contactType) === 'deactivated') {
	        delete userSettings[prop];
	      } else {
	        var val = settingsObj[prop];
	        userSettings[prop] = val;
	      }
	      this.userSettings = (0, _stringify2.default)(userSettings);
	    },
	    getContactOption: function getContactOption(user, contactType) {
	      var userSettings = JSON.parse(user.settings);
	      var varOption = 'dont_receive_' + contactType;
	      if (userSettings[varOption]) {
	        return 'deactivated';
	      }
	      if (contactType === 'phone' && !user.phone) {
	        return 'no_number';
	      }
	      if (contactType === 'phone' && user.phone && user.unconfirmed_phone) {
	        return 'awaiting_approval';
	      }
	      if (contactType === 'phone' && user.phone) {
	        return 'active';
	      }
	      if (contactType === 'email' && !user.email) {
	        return 'no_email';
	      }
	      if (contactType === 'email' && user.email) {
	        return 'active';
	      }
	    },
	    onEmailKeyup: function onEmailKeyup(val) {
	      if (val.length === 0) {
	        this.hideEmailToggle = true;
	      } else {
	        this.hideEmailToggle = false;
	      }
	      this.isEmailValid = true;
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      var changes = {};
	      if (this.isSMSActive) {
	        this.isValidNumber(this.phone);
	      }
	      if (this.isEmailActive) {
	        this.validateEmail(this.email);
	      }
	      if (!this.isEmailValid || !this.isPhoneValid) {
	        return;
	      }
	      if (this.isEmailActive && this.email !== this.initialEmail) {
	        changes['email'] = this.email;
	      }
	      if (this.isSMSActive && this.phone !== this.initialPhone) {
	        if (this.phone.length > 0) {
	          changes['phone'] = this.activeCountry.countryCode + this.phone;
	        } else {
	          changes['phone'] = this.phone;
	        }
	      }
	      if (this.initialReceiveSMS !== this.receiveSMS) {
	        this.updateUserSettings('phone');
	        changes['settings'] = this.userSettings;
	      }
	      if (this.initialReceiveEmails !== this.receiveEmails) {
	        this.updateUserSettings('email');
	        changes['settings'] = this.userSettings;
	      }
	      _docendo2.default.updateUsers(window.SCHOOL.id, this.user.id, changes, function (success) {
	        _this2.$store.commit('updateSchoolUser', success);
	        _eventbus2.default.toast = { text: _this2.i18n[_this2.locale]['user_updated'], success: true };
	        _this2.$emit('close');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.sms.an_error_occured'), success: false };
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (window.SCHOOL.country) {
	      var idxOfCountry = this.countries.findIndex(function (country) {
	        return country.code === window.SCHOOL.country.toLowerCase();
	      });
	      this.activeCountry = idxOfCountry > -1 ? this.countries[idxOfCountry] : this.countries[0];
	    }
	    this.userSettings = this.user.settings;
	    this.initialUserSettings = this.user.settings;
	    if (this.isSMSActive) {
	      this.setNumber();
	      var phoneSetting = this.getContactOption(this.user, 'phone');
	      if (phoneSetting === 'no_number') {
	        this.initialReceiveSMS = false;
	        this.receiveSMS = false;
	      } else {
	        if (phoneSetting === 'deactivated' || phoneSetting === 'awaiting_approval') {
	          this.initialReceiveSMS = false;
	          this.receiveSMS = false;
	        }
	      }
	    }
	    if (this.isEmailActive) {
	      this.email = this.user.email ? this.user.email : '';
	      this.initialEmail = this.user.email ? this.user.email : '';
	      if (!this.user.email) {
	        this.receiveEmails = false;
	        this.initialReceiveEmails = false;
	      } else {
	        if (this.getContactOption(this.user, 'email') === 'deactivated') {
	          this.receiveEmails = false;
	          this.initialReceiveEmails = false;
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SmsAddNumber',
	  components: { DDropdown: _DDropdown2.default },
	  props: {
	    userid: {
	      type: Number,
	      required: true
	    },
	    hint: {
	      type: String,
	      default: 'hint--top'
	    },
	    isEditFromStart: {
	      type: Boolean,
	      default: false
	    },
	    updateThisUser: {
	      type: Boolean,
	      default: false
	    }
	  },
	  mixins: [_vueClickaway.mixin],
	  data: function data() {
	    return {
	      originalNumber: null,
	      number: null,
	      isEdit: false,
	      showWarning: false,
	      timeout: null,
	      user: null,
	      activeCountry: null,
	      countries: [{ name: 'Danmark', countryCode: '45', code: 'dk', flag: 'https://zen.docendo.co/flags/dk.svg' }, { name: 'Norge', countryCode: '47', code: 'no', flag: 'https://zen.docendo.co/flags/no.svg' }, { name: 'United States', countryCode: '1', code: 'us', flag: 'https://zen.docendo.co/flags/us.svg' }]
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    loggedInUser: function loggedInUser() {
	      return this.$store.state.user;
	    },
	    isLoggedInUser: function isLoggedInUser() {
	      return this.loggedInUser.id === this.user.id;
	    },
	    hintClass: function hintClass() {
	      return this.showWarning ? this.hint + ' hint--always' : '';
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    isValidNumber: function isValidNumber() {
	      if (this.isUSA) {
	        return true;
	      }
	      if (this.number && this.number.length === 8) {
	        this.showWarning = false;
	      }
	      return this.number.length === 8 || this.isNumberBeingDeleted && this.number.length === 0;
	    },
	    isNumberChanged: function isNumberChanged() {
	      return this.number !== this.originalNumber;
	    },
	    isNumberBeingDeleted: function isNumberBeingDeleted() {
	      return this.number.length === 0 && this.number !== this.originalNumber;
	    },
	    isPendingConfirmation: function isPendingConfirmation() {
	      return this.allUsersInHash[this.userid].unconfirmed_phone;
	    },
	    isUSA: function isUSA() {
	      return this.activeCountry.code === 'us';
	    }
	  },
	  methods: {
	    setActiveCountry: function setActiveCountry(country) {
	      this.activeCountry = country;
	    },
	    onMouseOver: function onMouseOver() {
	      if (!this.isValidNumber) {
	        this.showWarning = true;
	      }
	    },
	    onMouseLeave: function onMouseLeave() {
	      this.showWarning = false;
	    },
	    keyPressEnter: function keyPressEnter() {
	      this.submitNumber();
	    },
	    setEdit: function setEdit() {
	      var _this = this;
	
	      this.isEdit = true;
	      setTimeout(function (_) {
	        if (_this.$refs.inputfield) {
	          _this.$refs.inputfield.focus();
	        }
	      }, 400);
	    },
	    closeEdit: function closeEdit() {
	      this.isEdit = false;
	    },
	    inputKeypress: function inputKeypress(evt) {
	      this.isNumber(evt);
	    },
	    isNumber: function isNumber(evt) {
	      var charCode = evt.which ? evt.which : evt.keyCode;
	      if (charCode === 13) {
	        this.keyPressEnter();
	      }
	      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 9 || !this.isUSA && this.number.length === 8) {
	        evt.preventDefault();
	      } else {
	        return true;
	      }
	    },
	    setNumber: function setNumber() {
	      this.user = this.allUsersInHash[this.userid];
	      var num = '';
	
	      if (this.user.phone) {
	        num = !this.isUSA && this.user.phone.substr(0, 2) === this.activeCountry.countryCode ? this.user.phone.replace(this.activeCountry.countryCode, '') : this.user.phone;
	      }
	      this.originalNumber = num;
	      this.number = this.originalNumber;
	    },
	    inputKeyup: function inputKeyup() {
	      this.showWarning = false;
	    },
	    closeWithoutSubmit: function closeWithoutSubmit(val) {
	      if (this.isEditFromStart) {
	        if (val === 'button') {
	          this.$emit('close');
	        }
	        return;
	      }
	      this.number = this.originalNumber;
	      this.closeEdit();
	    },
	    submitNumber: function submitNumber() {
	      var _this2 = this;
	
	      if (!this.isValidNumber) {
	        setTimeout(function (_) {
	          _this2.showWarning = true;
	        }, 300);
	        return;
	      }
	      if (this.isNumberBeingDeleted) {
	        this.closeEdit();
	        _docendo2.default.deleteUserPhone(window.SCHOOL.id, this.userid, function (payload) {
	          _eventbus2.default.toast = { text: _this2.$t('vue2.sms.number_deleted'), success: true };
	          _this2.$store.commit('updateSchoolUser', payload);
	          _this2.setNumber();
	          _this2.$emit('close');
	        }, function (failure) {
	          _eventbus2.default.toast = { text: _this2.$t('vue2.sms.an_error_occured'), success: false };
	        });
	        return;
	      }
	      if (this.isValidNumber && !this.isNumberBeingDeleted) {
	        var num = this.activeCountry.countryCode + this.number;
	        var changes = {};
	        changes['phone'] = num;
	        _docendo2.default.updateUsers(this.schoolId, this.userid, changes, function (success) {
	          _this2.$store.commit('updateSchoolUser', success);
	          if (_this2.updateThisUser) {
	            var updateObj = {
	              prop: 'phone',
	              phone: success.phone
	            };
	            _this2.$store.commit('updateUserProp', updateObj);
	          }
	          _eventbus2.default.toast = { text: 'Updated', success: true };
	          _this2.$emit('close');
	        }, function (failure) {
	          _eventbus2.default.toast = { text: _this2.$t('vue2.sms.an_error_occured'), success: false };
	        });
	        if (this.isEditFromStart) {
	          this.$emit('added');
	        }
	        this.closeEdit();
	        this.$emit('close');
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (window.SCHOOL.country) {
	      var idxOfCountry = this.countries.findIndex(function (country) {
	        return country.code === window.SCHOOL.country.toLowerCase();
	      });
	      this.activeCountry = idxOfCountry > -1 ? this.countries[idxOfCountry] : this.countries[0];
	    }
	    this.setNumber();
	  },
	  mounted: function mounted() {
	    if (this.isEditFromStart) {
	      this.setEdit();
	    }
	  }
	};

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _SmsAddNumber = __webpack_require__(138);
	
	var _SmsAddNumber2 = _interopRequireDefault(_SmsAddNumber);
	
	var _MessageTemplate = __webpack_require__(369);
	
	var _MessageTemplate2 = _interopRequireDefault(_MessageTemplate);
	
	var _MedssageTemplateDelete = __webpack_require__(368);
	
	var _MedssageTemplateDelete2 = _interopRequireDefault(_MedssageTemplateDelete);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SendMessagesUserSetting = __webpack_require__(372);
	
	var _SendMessagesUserSetting2 = _interopRequireDefault(_SendMessagesUserSetting);
	
	var _Loader3 = __webpack_require__(5);
	
	var _Loader4 = _interopRequireDefault(_Loader3);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _TaggingFilter = __webpack_require__(43);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	var _DoFilters = __webpack_require__(134);
	
	var _DoFilters2 = _interopRequireDefault(_DoFilters);
	
	var _SendMessagesPastSmses = __webpack_require__(371);
	
	var _SendMessagesPastSmses2 = _interopRequireDefault(_SendMessagesPastSmses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    send_message: 'Send besked',
	    recipient: 'Modtager',
	    a_recipient: 'Vælg en modtager',
	    subject: 'Emnefelt',
	    message: 'Besked',
	    message_must_be_filled: 'Besked skal udfyldes',
	    sending_message: 'Sender besked',
	    message_sent: 'Besked sendt',
	    no_users_matches: 'Ingen brugere matcher din søgning',
	    todays_substitutes: 'Vælg dagens vikarer',
	    send_message_to: 'Send besked til',
	    select_a_standard_template: 'Vælg en besked',
	    create_a_standard_template: 'Opret ny standard besked',
	    recipients: 'Modtagere',
	    select_recipients: 'Vælg modtagere fra listen til venstre',
	    deactivate_sms: 'Slå SMS fra',
	    activate_sms: 'Slå SMS til',
	    deactivate_email: 'Slå email fra',
	    activate_email: 'Slå email til',
	    add_number: 'Tilføj nummer',
	    add_email: 'Tilføj email',
	    awaiting_approval: 'Afventer bekræftelse',
	    sms: 'SMS',
	    email: 'email',
	    settings: 'Indstillinger',
	    email_sent: 'Emails afsendt',
	    sms_sent: 'SMSer afsendt',
	    welcome_to_sms: 'Velkommen til SMS',
	    add_your_number_to_send_sms: 'Indtast dit mobilnummer for at begynde at sende smser til skolens personale. Modtagere kan besvare til dette nummer.',
	    add_your_number: 'Tilføj dit mobilnummer',
	    last_sms: 'Sidst sendt til',
	    see_message: 'Se besked'
	  },
	  nb: {
	    send_message: 'Send melding',
	    recipient: 'Velg mottaker',
	    a_recipient: 'Velg en mottaker',
	    subject: 'Emnefelt',
	    message: 'Melding',
	    message_must_be_filled: 'Meldingsfelt må utfylles',
	    sending_message: 'Sender melding',
	    message_sent: 'Melding sendt',
	    no_users_matches: 'Ingen brukere passer til søket',
	    todays_substitutes: 'Dagens vikarer',
	    send_message_to: 'Send melding til',
	    select_a_standard_template: 'Velg en melding',
	    create_a_standard_sms: 'Opprett ny standardmelding',
	    recipients: 'Mottakere',
	    select_recipients: 'Velg mottakere fra listen til venstre',
	    deactivate_sms: 'Deaktivere SMS',
	    activate_sms: 'Aktivere SMS',
	    deactivate_email: 'Deaktivere e-post',
	    activate_email: 'Aktivere e-post',
	    add_number: 'Legg til nummer',
	    add_email: 'Legg til e-post',
	    awaiting_approval: 'Venter på bekreftelse',
	    sms: 'SMS',
	    email: 'e-post',
	    settings: 'Innstillinger',
	    email_sent: 'E-poster sendt',
	    sms_sent: 'SMS sendt',
	    last_sms: 'Sist sendt til',
	    see_message: 'Se melding'
	  },
	  en: {
	    send_message: 'Send message',
	    recipient: 'Recipient',
	    a_recipient: 'Choose a recipient',
	    subject: 'Subject',
	    message: 'Message',
	    message_must_be_filled: 'Message can not be empty',
	    sending_message: 'Sending message',
	    message_sent: 'Message sent',
	    no_users_matches: 'No matching users',
	    todays_substitutes: 'Substitutes today',
	    send_message_to: 'Send message to',
	    select_a_standard_template: 'Choose a template',
	    create_a_standard_template: 'Create new template',
	    recipients: 'Recipients',
	    select_recipients: 'Choose users to receive the message',
	    deactivate_sms: 'Deactivate SMS',
	    activate_sms: 'Activate SMS',
	    deactivate_email: 'Deactivate email',
	    activate_email: 'Activate email',
	    add_number: 'Add number',
	    add_email: 'Add email',
	    awaiting_approval: 'Awaiting approval',
	    sms: 'SMS',
	    email: 'email',
	    settings: 'Settings',
	    email_sent: 'Emails sent',
	    sms_sent: 'SMS sent',
	    last_sms: 'Last sent to',
	    see_message: 'See message'
	  }
	};
	
	exports.default = {
	  components: {
	    SendMessagesPastSmses: _SendMessagesPastSmses2.default,
	    DoFilters: _DoFilters2.default,
	    TaggingFilter: _TaggingFilter2.default,
	    DoFiltersFilter: _DoFiltersFilter2.default,
	    Loader: _Loader4.default, SendMessagesUserSetting: _SendMessagesUserSetting2.default, DDropdown: _DDropdown2.default, SmsAddNumber: _SmsAddNumber2.default, TemplateModal: _MessageTemplate2.default, TemplateDelete: _MedssageTemplateDelete2.default, Spinner: _Loader2.default
	  },
	  data: function data() {
	    return {
	      pastSmsModalUser: null,
	      pastSmsModalData: null,
	      sortMode: 'name',
	      pastSmsesMap: {},
	      isEmailActive: true,
	      isSMSActive: false,
	      isOpen: false,
	      selectedWithoutContactForm: [],
	      selectedUser: '',
	      messageSubject: '',
	      messageBody: '',
	      giveFeedback: false,
	      selectedUsers: [],
	      searchText: '',
	      appliedFilters: [],
	      tags: [],
	      isCreateTemplate: false,
	      theEditTemplate: null,
	      theDeleteTemplate: null,
	      isLoadingTemplates: true,
	      templates: [],
	      theActiveEditUser: null,
	      isEmailSent: true,
	      isSMSSent: true,
	      isLoading: true,
	      isInitialLoad: true,
	      isShowPastSMSes: false
	    };
	  },
	
	  computed: {
	    user: function user() {
	      return this.$store.state.user;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    activeDate: function activeDate() {
	      return this.$store.state.subs.date;
	    },
	    noNumberForUser: function noNumberForUser() {
	      return this.user && !this.user.phone;
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    usersToReceiveEmail: function usersToReceiveEmail() {
	      var users = this.userSetSelected.filter(function (user) {
	        return user.v_email_setting === 'active';
	      });
	      return users.map(function (user) {
	        return user.id;
	      });
	    },
	    usersToReceiveSMS: function usersToReceiveSMS() {
	      var users = this.userSetSelected.filter(function (user) {
	        return user.v_phone_setting === 'active';
	      });
	      return users.map(function (user) {
	        return user.id;
	      });
	    },
	    userSetSelected: function userSetSelected() {
	      var usersMap = this.usersWithCustomProps.reduce(function (acc, user) {
	        acc[user.id] = user;
	        return acc;
	      }, {});
	
	      return this.selectedUsers.filter(function (id) {
	        return usersMap[id];
	      }).map(function (id) {
	        return usersMap[id];
	      });
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    usersSortedOnName: function usersSortedOnName() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    noText: function noText() {
	      return this.messageBody.length < 1 || this.messageSubject.length < 1;
	    },
	    noReceiver: function noReceiver() {
	      return this.selectedUsers.length < 1;
	    },
	    usersUrl: function usersUrl() {
	      return '/schools/' + this.schoolId + '/users';
	    },
	    usersWithCustomProps: function usersWithCustomProps() {
	      var _this = this;
	
	      return this.usersSortedOnName.map(function (user) {
	        var vPhoneSetting = _this.getContactOption(user, 'phone');
	        var vEmailSetting = _this.getContactOption(user, 'email');
	
	        var lastRow = _this.pastSmsesMap[user.id];
	        var lastTs = lastRow ? lastRow.created_at : null;
	        var lastHuman = lastTs ? _this.formatLastSmsHuman(lastTs) : null;
	        var lastRelative = lastTs ? _this.formatLastSmsRelative(lastTs) : null;
	
	        return (0, _extends3.default)({}, user, {
	          v_phone_setting: vPhoneSetting,
	          v_phone_tooltip: _this.getTooltipText('sms', vPhoneSetting),
	          v_email_setting: vEmailSetting,
	          v_email_tooltip: _this.getTooltipText('email', vEmailSetting),
	          v_last_sms_row: lastRow,
	          v_last_sms_at: lastTs,
	          v_last_sms_at_human: lastHuman,
	          v_last_sms_relative: lastRelative
	        });
	      });
	    },
	    searchedUsers: function searchedUsers() {
	      var _this2 = this;
	
	      return this.usersWithCustomProps.filter(function (user) {
	        return user.name !== '' ? user.name.match(new RegExp(_this2.searchText, 'i')) : '';
	      });
	    },
	    filteredUsers: function filteredUsers() {
	      var _this3 = this;
	
	      var passedUsers = this.searchedUsers;
	      if (this.appliedFilters.length > 0) {
	        passedUsers = passedUsers.filter(function (user) {
	          return user.user_tags.some(function (tag) {
	            return _this3.appliedFilters.includes(tag);
	          });
	        });
	      }
	
	      var collator = new Intl.Collator(this.locale || 'da-DK', { sensitivity: 'base', numeric: true });
	
	      return passedUsers.slice().sort(function (a, b) {
	        if (_this3.sortMode === 'last') {
	          var aTs = a.v_last_sms_at || null;
	          var bTs = b.v_last_sms_at || null;
	
	          if (aTs && !bTs) return -1;
	          if (!aTs && bTs) return 1;
	
	          if (aTs && bTs) {
	            var _aTime = (0, _moment2.default)(aTs).valueOf();
	            var _bTime = (0, _moment2.default)(bTs).valueOf();
	            if (_aTime !== _bTime) return _bTime - _aTime;
	          }
	
	          return collator.compare(a.name || '', b.name || '');
	        }
	
	        var nameCmp = collator.compare(a.name || '', b.name || '');
	        if (nameCmp !== 0) return nameCmp;
	
	        var aTime = a.v_last_sms_at ? (0, _moment2.default)(a.v_last_sms_at).valueOf() : 0;
	        var bTime = b.v_last_sms_at ? (0, _moment2.default)(b.v_last_sms_at).valueOf() : 0;
	        return bTime - aTime;
	      });
	    },
	    absentUsersFromUserSet: function absentUsersFromUserSet() {
	      return this.$store.getters.absentUsersFromUserSet;
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    }
	  },
	  watch: {
	    activeDate: function activeDate() {
	      this.removeAllSelectedUsers();
	    }
	  },
	  methods: {
	    showSent: function showSent(user) {
	      var row = user && user.v_last_sms_row ? user.v_last_sms_row : null;
	      this.pastSmsModalUser = user;
	      this.pastSmsModalData = row;
	      this.isShowPastSMSes = true;
	      this.$store.dispatch('trackEvent', 'substitution_SMS_showLastSentMessage');
	    },
	    toggleSortByLast: function toggleSortByLast() {
	      this.sortMode = this.sortMode === 'last' ? 'name' : 'last';
	      this.$store.dispatch('trackEvent', 'substitution_SMS_sortedBySent');
	    },
	    readPastSMSes: function readPastSMSes() {
	      var _this4 = this;
	
	      _docendo2.default.pastSmses(this.schoolId, function (success) {
	        var rows = success && success.data ? success.data : [];
	        var byUser = {};
	
	        for (var i = 0; i < rows.length; i++) {
	          var row = rows[i];
	          var uid = row.user_id;
	          if (!byUser[uid]) {
	            byUser[uid] = row;
	          } else {
	            var newer = (0, _moment2.default)(row.created_at).isAfter((0, _moment2.default)(byUser[uid].created_at));
	            if (newer) byUser[uid] = row;
	          }
	        }
	
	        _this4.pastSmsesMap = byUser;
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    formatLastSmsHuman: function formatLastSmsHuman(ts) {
	      if (!ts) return '';
	
	      return (0, _moment2.default)(ts).format('lll');
	    },
	    formatLastSmsRelative: function formatLastSmsRelative(ts) {
	      if (!ts) return '';
	      return (0, _moment2.default)(ts).fromNow();
	    },
	    toggleTag: function toggleTag(tag) {
	      var idx = this.appliedFilters.indexOf(tag);
	      if (idx > -1) {
	        this.appliedFilters.splice(idx, 1);
	      } else {
	        this.appliedFilters.push(tag);
	      }
	    },
	    clearAllTags: function clearAllTags() {
	      this.appliedFilters = [];
	      this.removeAllSelectedUsers();
	    },
	    setOpen: function setOpen(bool) {
	      if (bool) {
	        this.isLoading = true;
	        this.isOpen = true;
	        if (this.isInitialLoad) {
	          this.readTags();
	          this.$store.dispatch('getUsers');
	          this.readPastSMSes();
	          this.readMessageTemplates();
	        }
	        this.isInitialLoad = false;
	      } else {
	        this.isOpen = false;
	      }
	    },
	    onEnterComplete: function onEnterComplete() {
	      this.isLoading = false;
	    },
	    getTooltipText: function getTooltipText(contactType, setting) {
	      var tooltips = {
	        active: this.i18n[this.locale]['deactivate_' + contactType],
	        no_number: this.i18n[this.locale]['add_number'],
	        no_email: this.i18n[this.locale]['add_email'],
	        awaiting_approval: this.i18n[this.locale]['awaiting_approval'],
	        deactivated: this.i18n[this.locale]['activate_' + contactType]
	      };
	      return tooltips[setting];
	    },
	    setOption: function setOption(user, contactType) {
	      var currentSetting = this.getContactOption(user, contactType);
	      var needsEdit = contactType === 'phone' && currentSetting === 'no_number' || contactType === 'email' && currentSetting === 'no_email' || currentSetting === 'awaiting_approval';
	
	      if (needsEdit) {
	        this.theActiveEditUser = user;
	        return;
	      }
	
	      if (['active', 'deactivated'].includes(currentSetting)) {
	        this.updateUserSettings(user, contactType);
	      }
	    },
	    getContactOption: function getContactOption(user, contactType) {
	      if (contactType === 'phone' && !this.isSMSActive) return 'no_number';
	      if (contactType === 'email' && !this.isEmailActive) return 'no_email';
	
	      var hasContact = user[contactType];
	      if (!hasContact) return contactType === 'phone' ? 'no_number' : 'no_email';
	
	      if (contactType === 'phone' && user.unconfirmed_phone) return 'awaiting_approval';
	
	      var userSettings = JSON.parse(user.settings);
	      if (userSettings['dont_receive_' + contactType]) return 'deactivated';
	
	      return 'active';
	    },
	    closeUserSetting: function closeUserSetting() {
	      var user = this.allUsersInHash[this.theActiveEditUser.id];
	      var emailSetting = this.getContactOption(user, 'email');
	      var phoneSetting = this.getContactOption(user, 'phone');
	      if (emailSetting === 'active' || phoneSetting === 'active') {
	        var idx2 = this.selectedWithoutContactForm.indexOf(user.id);
	        if (idx2 > -1) {
	          this.selectedWithoutContactForm.splice(idx2, 1);
	        }
	      } else {
	        var idx = this.selectedUsers.indexOf(user.id);
	        if (idx > -1) {
	          this.selectedUsers.splice(idx, 1);
	        }
	      }
	      this.theActiveEditUser = null;
	    },
	    updateUserSettings: function updateUserSettings(user, contactType) {
	      var _this5 = this;
	
	      var idx = this.selectedWithoutContactForm.indexOf(user.id);
	      if (idx > -1) {
	        this.selectedWithoutContactForm.splice(idx, 1);
	      }
	      var idx2 = this.selectedUsers.indexOf(user.id);
	      if (idx2 > -1) {
	        this.selectedUsers.splice(idx2, 1);
	      }
	      var userSettings = JSON.parse(user.settings);
	      var varOption = 'dont_receive_' + contactType;
	      var settingsObj = {};
	      settingsObj[varOption] = true;
	      var prop = (0, _keys2.default)(settingsObj)[0];
	      if (this.getContactOption(user, contactType) === 'deactivated') {
	        delete userSettings[prop];
	      } else {
	        var val = settingsObj[prop];
	        userSettings[prop] = val;
	      }
	      var changes = { settings: (0, _stringify2.default)(userSettings) };
	      _docendo2.default.updateUsers(this.schoolId, user.id, changes, function (data) {
	        _this5.$store.commit('updateSchoolUser', data);
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    setTheEditTemplate: function setTheEditTemplate(template) {
	      this.theEditTemplate = template;
	      this.isCreateTemplate = true;
	    },
	    createNewTemplate: function createNewTemplate() {
	      this.isCreateTemplate = true;
	    },
	    closeTemplate: function closeTemplate() {
	      this.theEditTemplate = null;
	      this.theDeleteTemplate = null;
	      this.isCreateTemplate = false;
	    },
	    selectTemplate: function selectTemplate(template) {
	      var today = (0, _moment2.default)().format('dddd');
	      this.messageSubject = template.title.replace('[today]', today);
	      this.messageBody = template.body.replace('[today]', today);
	    },
	    getSubsOfTheDay: function getSubsOfTheDay() {
	      var _this6 = this;
	
	      var userMap = this.usersWithCustomProps.reduce(function (acc, user) {
	        acc[user.user_calendar_id] = user;
	        return acc;
	      }, {});
	
	      var today = (0, _moment2.default)(this.activeDate).format('YYYY-MM-DD');
	
	      var eventsHash = this.allEventsInAHash || {};
	      var events = (0, _keys2.default)(eventsHash).map(function (id) {
	        return eventsHash[id];
	      });
	
	      events.forEach(function (lesson) {
	        if (!lesson) return;
	        if (lesson.v_is_event_from_other_school) return;
	
	        var lessonDay = (0, _moment2.default)(lesson.start).format('YYYY-MM-DD');
	        if (lessonDay !== today) return;
	
	        var calEvents = lesson.calendar_events || [];
	        var subEvents = calEvents.filter(function (e) {
	          return e.substitute || e.is_substitute;
	        });
	
	        subEvents.forEach(function (subEvent) {
	          var subUser = userMap[subEvent.calendar_id];
	          if (subUser) _this6.setSub(subUser);
	        });
	      });
	    },
	    getUserLessons: function getUserLessons(user) {
	      var _this7 = this;
	
	      var lessons = user.dayEvents.map(function (eventId) {
	        return _this7.allEventsInAHash[eventId];
	      });
	      lessons.filter(function (lesson) {
	        return !lesson.v_is_event_from_other_school;
	      }).forEach(function (lesson) {
	        _this7.getSubsFromLessons(lesson);
	      });
	    },
	    getSubsFromLessons: function getSubsFromLessons(lesson) {
	      var _this8 = this;
	
	      var subEvents = lesson.calendar_events.filter(function (event) {
	        return event.substitute || event.is_substitute;
	      });
	
	      var userMap = this.usersWithCustomProps.reduce(function (acc, user) {
	        acc[user.user_calendar_id] = user;
	        return acc;
	      }, {});
	
	      subEvents.forEach(function (subEvent) {
	        var sub = userMap[subEvent.calendar_id];
	        if (sub) {
	          _this8.setSub(sub);
	        }
	      });
	    },
	    setSub: function setSub(user, $event) {
	      if (user.v_phone_setting === 'active' || user.v_email_setting === 'active') {
	        if (this.selectedUsers.indexOf(user.id) < 0) {
	          this.selectedUsers.push(user.id);
	        }
	      } else {
	        if (this.selectedWithoutContactForm.indexOf(user.id) < 0) {
	          this.selectedWithoutContactForm.push(user.id);
	        }
	      }
	    },
	    checkIfInListWithoutContactForm: function checkIfInListWithoutContactForm(userid) {
	      return this.selectedWithoutContactForm.indexOf(userid) > -1;
	    },
	    resetData: function resetData() {
	      this.selectedUsers = [];
	      this.selectedUser = '';
	      this.messageSubject = '';
	      this.messageBody = '';
	    },
	    sendMessage: function sendMessage() {
	      var usersToReceiveEmail = this.usersToReceiveEmail;
	      var usersToReceiveSMS = this.usersToReceiveSMS;
	      if (usersToReceiveEmail.length > 0) {
	        this.isEmailSent = false;
	      }
	      if (usersToReceiveSMS.length > 0) {
	        this.isSMSSent = false;
	      }
	      if (usersToReceiveEmail.length > 0) {
	        this.sendEmails(usersToReceiveEmail);
	      }
	      if (usersToReceiveSMS.length > 0) {
	        this.sendSMS(usersToReceiveSMS);
	      }
	    },
	    sendEmails: function sendEmails(userIds) {
	      var _this9 = this;
	
	      _eventbus2.default.toast = { text: this.i18n[this.locale]['sending_message'], 'success': false };
	      this.isOpen = false;
	      _docendo2.default.sendEmails(this.schoolId, userIds, this.messageSubject, this.messageBody, function (success) {
	        _this9.isEmailSent = true;
	        _eventbus2.default.toast = { text: _this9.i18n[_this9.locale]['email_sent'], 'success': true };
	        if (_this9.isSMSSent) {
	          _this9.resetData();
	        }
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      });
	    },
	    sendSMS: function sendSMS(userIds) {
	      var _this10 = this;
	
	      _docendo2.default.sendSmses(this.schoolId, userIds, this.messageBody, function (data) {
	        _this10.isSMSSent = true;
	        _eventbus2.default.toast = { text: _this10.i18n[_this10.locale]['sms_sent'], 'success': true };
	        if (_this10.isEmailSent) {
	          _this10.resetData();
	        }
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      });
	    },
	    removeAllSelectedUsers: function removeAllSelectedUsers() {
	      this.selectedUsers = [];
	      this.selectedWithoutContactForm = [];
	    },
	    setUser: function setUser(user, idx, $event) {
	      if (user.v_phone_setting === 'active' || user.v_email_setting === 'active') {
	        if (this.selectedUsers.indexOf(user.id) > -1) {
	          this.selectedUsers.splice(this.selectedUsers.indexOf(user.id), 1);
	        } else {
	          this.selectedUsers.push(user.id);
	        }
	      } else {
	        if (this.selectedWithoutContactForm.indexOf(user.id) < 0) {
	          this.selectedWithoutContactForm.push(user.id);
	        }
	      }
	    },
	    setAllUsersSelected: function setAllUsersSelected() {
	      this.selectedUsers = [];
	      this.selectedWithoutContactForm = [];
	      for (var i = 0; i < this.filteredUsers.length; i++) {
	        var user = this.filteredUsers[i];
	        if (user.v_phone_setting === 'active' || user.v_email_setting === 'active') {
	          this.selectedUsers.push(user.id);
	        }
	      }
	    },
	    checkIfInList: function checkIfInList(userid) {
	      return this.selectedUsers.indexOf(userid) > -1;
	    },
	    readMessageTemplates: function readMessageTemplates() {
	      var _this11 = this;
	
	      this.closeTemplate();
	      this.isLoadingTemplates = true;
	      this.templates = [];
	      _docendo2.default.readMessageTemplates(this.schoolId, function (messages) {
	        _this11.templates = messages.filter(function (message) {
	          return message.message_type === 'email';
	        });
	        _this11.isLoadingTemplates = false;
	      }, function (failure) {
	        console.log('failed');
	      });
	    },
	    readTags: function readTags() {
	      var _this12 = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this12.tags = data;
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    var country = window.SCHOOL.country && window.SCHOOL.country.toLowerCase();
	    if (country === 'dk' || country === 'no') {
	      this.isSMSActive = true;
	    }
	  }
	};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, DModal: _DModal2.default },
	  props: {
	    userId: {
	      default: 13
	    },
	    userName: {
	      default: 'Henrik'
	    }
	  },
	  data: function data() {
	    return {
	      isModal: false,
	      isLoading: true,
	      isCreateForm: false,
	      createFormCPR: '',
	      createFormExtraCiffer: '',
	      createFormEmploymentTypeId: null,
	      employments: [],
	      schoolEmployments: [],
	      theDeleteEmployment: null,
	      formErrors: {},
	      isShowArchived: false
	    };
	  },
	
	  computed: {
	    createFormEmploymentNumber: function createFormEmploymentNumber() {
	      var cpr = this.createFormCPR.replace(/[^0-9]/ig, '');
	      return cpr.toString() + this.createFormExtraCiffer.toString();
	    },
	    isEmploymentTypesLoading: function isEmploymentTypesLoading() {
	      return this.$store.getters.isLoadingEmploymentsTypesForSchool;
	    },
	    isAllDoneLoading: function isAllDoneLoading() {
	      return !this.isLoading && !this.isEmploymentTypesLoading;
	    },
	    employmentTypes: function employmentTypes() {
	      return this.$store.state.employments.employmentsTypes;
	    },
	    employmentTypesActive: function employmentTypesActive() {
	      return this.employmentTypes.filter(function (type) {
	        return !type.deleted;
	      });
	    },
	    userEmployments: function userEmployments() {
	      return this.employments.filter(function (employment) {
	        return !employment.deleted;
	      });
	    },
	    userDeletedEmployments: function userDeletedEmployments() {
	      return this.employments.filter(function (employment) {
	        return employment.deleted;
	      });
	    },
	    userEmploymentsWithTitle: function userEmploymentsWithTitle() {
	      var _this = this;
	
	      var arr = [];
	      this.userEmployments.forEach(function (employment) {
	        var title = _this.getEmploymentTypeTitle(employment.employment_type_id);
	        _this.$set(employment, 'title', title);
	        arr.push(employment);
	      });
	      return arr;
	    },
	    deletedUserEmploymentsWithTitle: function deletedUserEmploymentsWithTitle() {
	      var _this2 = this;
	
	      var arr = [];
	      this.userDeletedEmployments.forEach(function (employment) {
	        var title = _this2.getEmploymentTypeTitle(employment.employment_type_id);
	        _this2.$set(employment, 'title', title);
	        arr.push(employment);
	      });
	      return arr;
	    }
	  },
	  methods: {
	    removeErrors: function removeErrors(title) {
	      this.$delete(this.formErrors, title);
	    },
	    formValidation: function formValidation() {
	      this.formErrors = {};
	      if (!this.createFormEmploymentTypeId) {
	        this.$set(this.formErrors, 'type', 'Vælg en type');
	      }
	      if (!this.validateCPR()) {
	        this.$set(this.formErrors, 'cpr', 'Er ikke et gyldigt CPR nummer');
	      }
	      if (this.createFormExtraCiffer.length < 1) {
	        this.$set(this.formErrors, 'ciffer', 'Skal sættes');
	      }
	      if (this.validateCPRAndCifferIsAlreadyUsed()) {
	        this.$set(this.formErrors, 'cpr', 'CPR nummer + ekstra ciffer er allerede brugt');
	        this.$set(this.formErrors, 'ciffer', ' ');
	      }
	    },
	    validateCPRAndCifferIsAlreadyUsed: function validateCPRAndCifferIsAlreadyUsed() {
	      var _this3 = this;
	
	      var idx = this.userEmployments.findIndex(function (employment) {
	        return employment.employment_number.toString() === _this3.createFormEmploymentNumber.toString();
	      });
	      return idx > -1;
	    },
	    validateCPR: function validateCPR() {
	      var cpr = this.createFormCPR;
	      var res = cpr.replace(/[^0-9]/ig, '');
	      if (res.length !== 10) {
	        return false;
	      } else {
	        return true;
	      }
	    },
	    closeIsModal: function closeIsModal() {
	      this.closeIsCreateForm();
	      this.isModal = false;
	    },
	    setIsCreateForm: function setIsCreateForm(boolean) {
	      if (boolean) {
	        this.isCreateForm = true;
	      }
	    },
	    resetForm: function resetForm() {
	      this.createFormCPR = '';
	      this.createFormExtraCiffer = '';
	      this.createFormEmploymentTypeId = null;
	      this.formErrors = {};
	    },
	    closeIsCreateForm: function closeIsCreateForm() {
	      this.resetForm();
	      if (this.userEmployments.length < 1) {
	        this.isModal = false;
	      }
	      this.isCreateForm = false;
	    },
	    openIsModal: function openIsModal() {
	      this.getUserEmployments();
	      this.isModal = true;
	    },
	    createEmployment: function createEmployment() {
	      var _this4 = this;
	
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      _docendo2.default.createEmployment(window.SCHOOL.id, this.userId, this.createFormEmploymentNumber, this.createFormEmploymentTypeId, function (success) {
	        _this4.employments.push(success);
	        _this4.closeIsCreateForm();
	        _eventbus2.default.toast = { text: 'Ansættelsen er oprettet', success: true };
	        _this4.$store.dispatch('readEmployments');
	      }, function (failure) {
	        console.log('FAILED', failure);
	        _this4.$store.dispatch('readEmployments');
	      });
	    },
	    getUserEmployments: function getUserEmployments() {
	      var _this5 = this;
	
	      this.isLoading = true;
	      _docendo2.default.employmentsForSchoolForUser(window.SCHOOL.id, this.userId, function (success) {
	        _this5.employments = success;
	        _this5.isLoading = false;
	        if (_this5.employments.length < 1) {
	          _this5.isCreateForm = true;
	        }
	      }, function (failure) {
	        console.log('failed', failure);
	      });
	    },
	    setDeleteEmployment: function setDeleteEmployment(employment) {
	      this.theDeleteEmployment = employment;
	    },
	    deleteEmployment: function deleteEmployment() {
	      var _this6 = this;
	
	      _docendo2.default.deleteEmployment(window.SCHOOL.id, this.userId, this.theDeleteEmployment.id, function (success) {
	        _eventbus2.default.toast = { text: 'Ansættelsen er slettet', success: true };
	        _this6.getUserEmployments();
	        _this6.theDeleteEmployment = null;
	        _this6.$store.dispatch('readEmployments');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Noget gik galt', success: false };
	        _this6.getUserEmployments();
	        _this6.theDeleteEmployment = null;
	        _this6.$store.dispatch('readEmployments');
	      });
	    },
	    getAllEmployments: function getAllEmployments() {
	      var _this7 = this;
	
	      _docendo2.default.employmentsForSchool(window.SCHOOL.id, function (success) {
	        _this7.schoolEmployments = success;
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    getEmploymentTypeTitle: function getEmploymentTypeTitle(employmentTypeId) {
	      var employmentIdStr = employmentTypeId * 1;
	      var idx = this.employmentTypes.findIndex(function (employment) {
	        return employment.id === employmentIdStr;
	      });
	      return idx > -1 ? this.employmentTypes[idx].title : '?';
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('readEmploymentTypes');
	    this.$store.dispatch('readEmployments');
	  }
	};

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(32);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _set = __webpack_require__(27);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SalarySettingsUsersOpus = __webpack_require__(141);
	
	var _SalarySettingsUsersOpus2 = _interopRequireDefault(_SalarySettingsUsersOpus);
	
	var _EmploymentImportModal = __webpack_require__(376);
	
	var _EmploymentImportModal2 = _interopRequireDefault(_EmploymentImportModal);
	
	var _SalaryOrganisationsModal = __webpack_require__(377);
	
	var _SalaryOrganisationsModal2 = _interopRequireDefault(_SalaryOrganisationsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SalarySettingsUsersOpus: _SalarySettingsUsersOpus2.default,
	    EmploymentImportModal: _EmploymentImportModal2.default,
	    SalaryOrganisationsModal: _SalaryOrganisationsModal2.default
	  },
	  data: function data() {
	    return {
	      theImportUser: null,
	      isOrganisationsModal: false
	    };
	  },
	
	  methods: {
	    openImport: function openImport(user) {
	      if (user) {
	        this.theImportUser = user;
	      }
	    }
	  },
	  computed: {
	    isOrganisationsEnabled: function isOrganisationsEnabled() {
	      var user = this.$store.state.user;
	      if (!user || !user.admin) {
	        return false;
	      }
	      return true;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    employments: function employments() {
	      var all = this.$store.state.employments && this.$store.state.employments.employments ? this.$store.state.employments.employments : [];
	      return all.filter(function (employment) {
	        return !employment.deleted;
	      });
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash;
	    },
	    usersWithEmployments: function usersWithEmployments() {
	      var _this = this;
	
	      return this.users.map(function (user) {
	        var userEmployments = _this.employmentsInUserIdHash[user.id] ? _this.employmentsInUserIdHash[user.id] : [];
	        var employmentsSorted = userEmployments.filter(function (employment) {
	          return !employment.deleted;
	        }).sort(function (a, b) {
	          var aTitle = a && (a.source_title || a.title) ? a.source_title || a.title : '';
	          var bTitle = b && (b.source_title || b.title) ? b.source_title || b.title : '';
	          return aTitle.localeCompare(bTitle, 'da-DK');
	        });
	        return (0, _extends3.default)({}, user, {
	          v_employments: employmentsSorted
	        });
	      });
	    },
	    tags: function tags() {
	      var tagSet = new _set2.default();
	      this.users.forEach(function (user) {
	        if (user.user_tags && Array.isArray(user.user_tags)) {
	          user.user_tags.forEach(function (tag) {
	            return tagSet.add(tag);
	          });
	        }
	      });
	      return (0, _from2.default)(tagSet).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('getUsers');
	    this.$store.dispatch('readEmployments');
	  }
	};

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelect2.default, DModal: _DModal2.default, DateSelector: _DateSelector2.default },
	  props: {
	    schoolId: {
	      type: Number,
	      required: true
	    },
	    employmentIds: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    subtitle: {
	      type: String,
	      default: ''
	    },
	
	    prefill: {
	      type: Object,
	      default: null
	    }
	  },
	  data: function data() {
	    var prefill = this.prefill || {};
	    return {
	      dato: prefill.dato ? (0, _moment2.default)(prefill.dato) : (0, _moment2.default)(),
	      salaryCodeId: prefill.salaryCodeId != null ? prefill.salaryCodeId : null,
	      salaryCostCenterId: null,
	      antal: prefill.antal != null ? String(prefill.antal) : '',
	      beloeb: prefill.beloeb != null ? String(prefill.beloeb) : '',
	      isSubmitting: false,
	      validationMessage: ''
	    };
	  },
	
	  computed: {
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    },
	    saveKeyTooltip: function saveKeyTooltip() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span>' + '<span>Enter</span></p>';
	    },
	    subtitleText: function subtitleText() {
	      if (this.subtitle) return this.subtitle;
	      return 'På ' + this.employmentIds.length + ' ' + (this.employmentIds.length === 1 ? 'ansættelse' : 'ansættelser');
	    },
	    submitButtonLabel: function submitButtonLabel() {
	      if (this.employmentIds.length <= 1) {
	        return 'Opret engangsydelse';
	      }
	      return 'Opret ' + this.employmentIds.length + ' engangsydelser';
	    },
	    isValid: function isValid() {
	      var hasEmployments = this.employmentIds.length > 0;
	      var hasDato = !!this.dato && (0, _moment2.default)(this.dato).isValid();
	      var hasLoenart = this.salaryCodeId != null;
	      var hasAntal = this.antal !== '' && this.antal != null;
	      var hasBeloeb = this.beloeb !== '' && this.beloeb != null;
	
	      var beloebRule = this.beloebAllowed ? hasBeloeb : hasAntal;
	      return hasEmployments && hasDato && hasLoenart && beloebRule && this.antalValid && this.beloebValid;
	    },
	    antalValid: function antalValid() {
	      if (this.antal === '' || this.antal == null) return true;
	      var antal = parseFloat(String(this.antal).replace(',', '.'));
	      return !isNaN(antal) && antal >= -999.99 && antal <= 9999.99;
	    },
	    beloebValid: function beloebValid() {
	      if (this.beloeb === '' || this.beloeb == null) return true;
	      var beloeb = parseFloat(String(this.beloeb).replace(',', '.'));
	      return !isNaN(beloeb) && Math.abs(beloeb) <= 99999.99;
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted || [];
	    },
	    salaryCodesForDSelect: function salaryCodesForDSelect() {
	      if (!this.salaryCodes || !Array.isArray(this.salaryCodes)) {
	        return [];
	      }
	      return this.salaryCodes.filter(function (sc) {
	        return sc.loenart;
	      }).map(function (sc) {
	        var value = sc.loenart != null ? sc.loenart : sc.code;
	        var displayValue = value != null ? String(value) : '';
	        var name = sc.name || '';
	        return {
	          id: sc.id,
	          name: displayValue + (name ? ' - ' + name : ''),
	          value: value,
	          original: sc
	        };
	      });
	    },
	    selectedSalaryCodeForDSelect: function selectedSalaryCodeForDSelect() {
	      var _this = this;
	
	      if (this.salaryCodeId == null) {
	        return [];
	      }
	      var found = this.salaryCodesForDSelect.find(function (item) {
	        return item.id === _this.salaryCodeId;
	      });
	      return found ? [found] : [];
	    },
	    selectedSalaryCode: function selectedSalaryCode() {
	      var _this2 = this;
	
	      var found = this.salaryCodesForDSelect.find(function (item) {
	        return item.id === _this2.salaryCodeId;
	      });
	      return found ? found.original : null;
	    },
	    beloebAllowed: function beloebAllowed() {
	      return !!this.selectedSalaryCode && String(this.selectedSalaryCode.loenart).slice(-1) === '0';
	    },
	    beloebHint: function beloebHint() {
	      if (this.beloebAllowed) {
	        return 'Lønkoden har løbenummer 0, så Beløb skal udfyldes. Antal er valgfrit og ganges på beløbet.';
	      }
	      if (this.selectedSalaryCode) {
	        return 'Angiv Antal – taksten for lønkoden anvendes. Beløb kan kun angives for lønkoder med løbenummer 0 (sidste ciffer).';
	      }
	      return 'Beløb kan kun angives for lønkoder med løbenummer 0 (sidste ciffer); ellers angives Antal.';
	    },
	    costCenters: function costCenters() {
	      return this.$store.getters.costCenters || [];
	    },
	    costCentersForDSelect: function costCentersForDSelect() {
	      return this.costCenters.map(function (cc) {
	        var code = cc.code != null ? String(cc.code) : '';
	        var title = cc.title || cc.name || '';
	        return {
	          id: cc.id,
	          name: code + (title ? ' - ' + title : ''),
	          value: code,
	          original: cc
	        };
	      });
	    },
	    selectedCostCenterForDSelect: function selectedCostCenterForDSelect() {
	      var _this3 = this;
	
	      if (this.salaryCostCenterId == null) {
	        return [];
	      }
	      var found = this.costCentersForDSelect.find(function (item) {
	        return item.id === _this3.salaryCostCenterId;
	      });
	      return found ? [found] : [];
	    }
	  },
	  watch: {
	    beloebAllowed: function beloebAllowed(allowed) {
	      if (!allowed) {
	        this.beloeb = '';
	      }
	    }
	  },
	  methods: {
	    onSelectLoenart: function onSelectLoenart(item) {
	      this.salaryCodeId = item ? item.id : null;
	    },
	    onSelectCostCenter: function onSelectCostCenter(item) {
	      this.salaryCostCenterId = item ? item.id : null;
	    },
	    setDato: function setDato(date) {
	      this.dato = date;
	    },
	    onGlobalKeydown: function onGlobalKeydown(evt) {
	      var isSubmitCombo = (evt.metaKey || evt.ctrlKey) && (evt.key === 'Enter' || evt.keyCode === 13);
	      if (!isSubmitCombo) return;
	
	      if (this.isSubmitting || !this.isValid) return;
	
	      evt.preventDefault();
	      this.submit();
	    },
	    submit: function submit() {
	      var _this4 = this;
	
	      this.validationMessage = '';
	      if (!this.isValid) {
	        this.validationMessage = 'Udfyld alle obligatoriske felter';
	        return;
	      }
	      if (!this.schoolId) {
	        this.validationMessage = 'Mangler schoolId';
	        return;
	      }
	
	      var engangsydelse = {
	        dato: (0, _moment2.default)(this.dato).format('YYYY-MM-DD'),
	        salary_code_id: this.salaryCodeId
	      };
	      if (this.antal !== '' && this.antal != null) {
	        engangsydelse.antal = parseFloat(String(this.antal).replace(',', '.'));
	      }
	      if (this.beloeb !== '' && this.beloeb != null) {
	        engangsydelse.beloeb = parseFloat(String(this.beloeb).replace(',', '.'));
	      }
	      if (this.salaryCostCenterId != null) {
	        engangsydelse.salary_cost_center_id = this.salaryCostCenterId;
	      }
	
	      this.isSubmitting = true;
	      _docendo2.default.createKmdEngangsydelseForEmployees(this.schoolId, this.employmentIds, engangsydelse, function (success) {
	        _this4.isSubmitting = false;
	        if (success && success.status === 'error') {
	          _this4.validationMessage = success.message || 'Kunne ikke oprette engangsydelser';
	          _eventbus2.default.toast = { text: 'Kunne ikke oprette engangsydelser', success: false, position: 'bottomLeft' };
	          return;
	        }
	        var count = Array.isArray(success) ? success.length : _this4.employmentIds.length;
	        _eventbus2.default.toast = {
	          text: (count === 1 ? 'Engangsydelse' : count + ' engangsydelser') + ' sendt til behandling. Følg status i listen.',
	          success: true,
	          position: 'bottomLeft'
	        };
	        _this4.$emit('created', success);
	        _this4.$emit('close');
	      }, function (failure) {
	        console.log('failure', failure);
	        _this4.isSubmitting = false;
	        _eventbus2.default.toast = { text: 'Kunne ikke oprette engangsydelser', success: false, position: 'bottomLeft' };
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this5 = this;
	
	    this.$store.dispatch('readSalaryCodes');
	    this.$store.dispatch('readCostCenters');
	    window.addEventListener('keydown', this.onGlobalKeydown);
	
	    this.didAddNoScroll = !document.body.classList.contains('no-scroll');
	    if (this.didAddNoScroll) {
	      document.body.classList.add('no-scroll');
	    }
	
	    this.$nextTick(function () {
	      setTimeout(function () {
	        if (_this5.$refs.loenartSelect) _this5.$refs.loenartSelect.setFocus();
	      }, 300);
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('keydown', this.onGlobalKeydown);
	    if (this.didAddNoScroll) {
	      document.body.classList.remove('no-scroll');
	    }
	  }
	};

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelect2.default, DModal: _DModal2.default, DateSelector: _DateSelector2.default },
	  props: {
	    schoolId: {
	      type: Number,
	      required: true
	    },
	    employmentIds: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    subtitle: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      salaryCodeId: null,
	      antal: '',
	      beloeb: '',
	      salaryCostCenterId: null,
	      startDato: null,
	      endDato: null,
	      noEndDate: false,
	      isSubmitting: false,
	      validationMessage: ''
	    };
	  },
	
	  computed: {
	    subtitleText: function subtitleText() {
	      if (this.subtitle) return this.subtitle;
	      return 'På ' + this.employmentIds.length + ' ' + (this.employmentIds.length === 1 ? 'ansættelse' : 'ansættelser');
	    },
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    },
	    saveKeyTooltip: function saveKeyTooltip() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span>' + '<span>Enter</span></p>';
	    },
	    submitButtonLabel: function submitButtonLabel() {
	      if (this.employmentIds.length <= 1) {
	        return 'Send til OPUS';
	      }
	      return 'Send ' + this.employmentIds.length + ' faste tillæg til OPUS';
	    },
	    openEndedDateLabel: function openEndedDateLabel() {
	      return (0, _moment2.default)('9999-12-31').format('DD-MM-YYYY');
	    },
	    schoolYearStartDate: function schoolYearStartDate() {
	      var year = this.$store.state.localActivatedSchoolYear;
	      var firstOfNextMonth = (0, _moment2.default)().add(1, 'month').startOf('month');
	      if (year && year.employee_time_start) {
	        var start = (0, _moment2.default)(year.employee_time_start);
	
	        return start.isBefore((0, _moment2.default)(), 'day') ? firstOfNextMonth : start;
	      }
	      return firstOfNextMonth;
	    },
	    schoolYearEndDate: function schoolYearEndDate() {
	      var year = this.$store.state.localActivatedSchoolYear;
	      if (year && year.employee_time_end) {
	        return (0, _moment2.default)(year.employee_time_end);
	      }
	      return (0, _moment2.default)().add(1, 'year');
	    },
	    isValid: function isValid() {
	      var hasSelections = this.employmentIds.length > 0;
	      var hasStart = !!this.startDato && (0, _moment2.default)(this.startDato).isValid();
	      var hasEnd = !!this.endDato && (0, _moment2.default)(this.endDato).isValid();
	      var hasLoenkode = this.salaryCodeId != null;
	      var antal = parseFloat(String(this.antal).replace(',', '.'));
	      var hasAntal = !isNaN(antal) && antal > 0 && antal <= 9999;
	      var isEndAfterStart = hasEnd && (0, _moment2.default)(this.endDato).isSameOrAfter((0, _moment2.default)(this.startDato));
	
	      var hasBeloeb = this.beloeb !== '' && this.beloeb != null;
	      var beloebRule = !this.beloebAllowed || hasBeloeb;
	      return hasSelections && hasStart && hasEnd && hasLoenkode && hasAntal && beloebRule && this.beloebValid && isEndAfterStart;
	    },
	    beloebValid: function beloebValid() {
	      if (this.beloeb === '' || this.beloeb == null) return true;
	      var beloeb = parseFloat(String(this.beloeb).replace(',', '.'));
	      return !isNaN(beloeb) && Math.abs(beloeb) <= 99999.99;
	    },
	    missingFields: function missingFields() {
	      var missing = [];
	      if (this.employmentIds.length === 0) missing.push('mindst én ansættelse');
	      if (this.salaryCodeId == null) missing.push('lønkode');
	      var antal = parseFloat(String(this.antal).replace(',', '.'));
	      if (isNaN(antal) || antal <= 0) missing.push('antal');else if (antal > 9999) missing.push('et gyldigt antal (maks. 9.999)');
	      if (this.beloebAllowed && (this.beloeb === '' || this.beloeb == null)) missing.push('beløb (lønkoden har løbenummer 0)');
	      if (!this.beloebValid) missing.push('et gyldigt beløb (maks. 99.999,99)');
	      var hasStart = !!this.startDato && (0, _moment2.default)(this.startDato).isValid();
	      var hasEnd = !!this.endDato && (0, _moment2.default)(this.endDato).isValid();
	      if (!hasStart) missing.push('startdato');
	      if (!hasEnd) missing.push('slutdato');else if (hasStart && (0, _moment2.default)(this.endDato).isBefore((0, _moment2.default)(this.startDato))) {
	        missing.push('en slutdato efter startdato');
	      }
	      return missing;
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted || [];
	    },
	    salaryCodesForDSelect: function salaryCodesForDSelect() {
	      if (!this.salaryCodes || !Array.isArray(this.salaryCodes)) {
	        return [];
	      }
	      return this.salaryCodes.filter(function (sc) {
	        return sc.loenart;
	      }).map(function (sc) {
	        var value = sc.loenart != null ? sc.loenart : sc.code;
	        var displayValue = value != null ? String(value) : '';
	        var name = sc.name || '';
	        return {
	          id: sc.id,
	          name: displayValue + (name ? ' - ' + name : ''),
	          value: value,
	          original: sc
	        };
	      });
	    },
	    selectedSalaryCodeForDSelect: function selectedSalaryCodeForDSelect() {
	      var _this = this;
	
	      if (this.salaryCodeId == null) {
	        return [];
	      }
	      var found = this.salaryCodesForDSelect.find(function (item) {
	        return item.id === _this.salaryCodeId;
	      });
	      return found ? [found] : [];
	    },
	    selectedSalaryCode: function selectedSalaryCode() {
	      var _this2 = this;
	
	      var found = this.salaryCodesForDSelect.find(function (item) {
	        return item.id === _this2.salaryCodeId;
	      });
	      return found ? found.original : null;
	    },
	    beloebAllowed: function beloebAllowed() {
	      return !!this.selectedSalaryCode && String(this.selectedSalaryCode.loenart).slice(-1) === '0';
	    },
	    beloebHint: function beloebHint() {
	      if (this.beloebAllowed) {
	        return 'Lønkoden har løbenummer 0, så Beløb skal udfyldes. Antal ganges på beløbet.';
	      }
	      if (this.selectedSalaryCode) {
	        return 'Angiv Antal – taksten for lønkoden anvendes. Beløb kan kun angives for lønkoder med løbenummer 0 (sidste ciffer).';
	      }
	      return 'Beløb kan kun angives for lønkoder med løbenummer 0 (sidste ciffer); ellers angives Antal.';
	    },
	    costCenters: function costCenters() {
	      return this.$store.getters.costCenters || [];
	    },
	    costCentersForDSelect: function costCentersForDSelect() {
	      return this.costCenters.map(function (cc) {
	        var code = cc.code != null ? String(cc.code) : '';
	        var title = cc.title || cc.name || '';
	        return {
	          id: cc.id,
	          name: code + (title ? ' - ' + title : ''),
	          value: code,
	          original: cc
	        };
	      });
	    },
	    selectedCostCenterForDSelect: function selectedCostCenterForDSelect() {
	      var _this3 = this;
	
	      if (this.salaryCostCenterId == null) {
	        return [];
	      }
	      var found = this.costCentersForDSelect.find(function (item) {
	        return item.id === _this3.salaryCostCenterId;
	      });
	      return found ? [found] : [];
	    }
	  },
	  watch: {
	    beloebAllowed: function beloebAllowed(allowed) {
	      if (!allowed) {
	        this.beloeb = '';
	      }
	    }
	  },
	  methods: {
	    onSelectLoenkode: function onSelectLoenkode(item) {
	      this.salaryCodeId = item ? item.id : null;
	    },
	    onSelectCostCenter: function onSelectCostCenter(item) {
	      this.salaryCostCenterId = item ? item.id : null;
	    },
	    onToggleNoEndDate: function onToggleNoEndDate() {
	      if (this.noEndDate) {
	        this.endDato = (0, _moment2.default)('9999-12-31');
	      } else {
	        this.endDato = this.schoolYearEndDate;
	      }
	    },
	    onGlobalKeydown: function onGlobalKeydown(evt) {
	      var isSubmitCombo = (evt.metaKey || evt.ctrlKey) && (evt.key === 'Enter' || evt.keyCode === 13);
	      if (!isSubmitCombo) return;
	      if (this.isSubmitting || !this.isValid) return;
	      evt.preventDefault();
	      this.submit();
	    },
	    submit: function submit() {
	      var _this4 = this;
	
	      this.validationMessage = '';
	      if (!this.isValid) {
	        var missing = this.missingFields;
	        if (missing.length) {
	          var text = missing.length === 1 ? 'Udfyld ' + missing[0] : 'Mangler: ' + missing.join(', ');
	          _eventbus2.default.toast = { text: text, success: false, position: 'bottomLeft' };
	        }
	        return;
	      }
	      if (!this.schoolId) {
	        this.validationMessage = 'Mangler schoolId';
	        return;
	      }
	
	      var recurringPayment = {
	        startdato: (0, _moment2.default)(this.startDato).format('YYYY-MM-DD'),
	        stopdato: (0, _moment2.default)(this.endDato).format('YYYY-MM-DD'),
	        salary_code_id: this.salaryCodeId,
	        antal: parseFloat(String(this.antal).replace(',', '.'))
	      };
	      if (this.beloeb !== '' && this.beloeb != null) {
	        recurringPayment.beloeb = parseFloat(String(this.beloeb).replace(',', '.'));
	      }
	      if (this.salaryCostCenterId != null) {
	        recurringPayment.salary_cost_center_id = this.salaryCostCenterId;
	      }
	
	      this.isSubmitting = true;
	      _docendo2.default.createRecurringPaymentForEmployees(this.schoolId, this.employmentIds, recurringPayment, function (success) {
	        _this4.isSubmitting = false;
	        if (success && success.status === 'error') {
	          _this4.validationMessage = success.message || 'Kunne ikke oprette faste tillæg';
	          _eventbus2.default.toast = { text: 'Kunne ikke oprette faste tillæg', success: false, position: 'bottomLeft' };
	          return;
	        }
	        var count = Array.isArray(success) ? success.length : _this4.employmentIds.length;
	        _eventbus2.default.toast = {
	          text: (count === 1 ? 'Fast tillæg' : count + ' faste tillæg') + ' sendt til behandling. Følg status i Udbakke.',
	          success: true,
	          position: 'bottomLeft'
	        };
	        _this4.$emit('created', success);
	        _this4.$emit('close');
	      }, function (failure) {
	        console.log('failure', failure);
	        _this4.isSubmitting = false;
	        _eventbus2.default.toast = { text: 'Kunne ikke oprette faste tillæg', success: false, position: 'bottomLeft' };
	      });
	    }
	  },
	  created: function created() {
	    this.startDato = this.schoolYearStartDate;
	    this.endDato = this.schoolYearEndDate;
	  },
	  mounted: function mounted() {
	    var _this5 = this;
	
	    this.$store.dispatch('readSalaryCodes');
	    this.$store.dispatch('readCostCenters');
	    window.addEventListener('keydown', this.onGlobalKeydown);
	
	    this.$nextTick(function () {
	      setTimeout(function () {
	        if (_this5.$refs.loenkodeSelect) _this5.$refs.loenkodeSelect.setFocus();
	      }, 300);
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('keydown', this.onGlobalKeydown);
	  }
	};

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelect2.default, DModal: _DModal2.default, DateSelector: _DateSelector2.default },
	  props: {
	    schoolId: {
	      type: Number,
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      userId: '',
	      employmentId: null,
	      startDate: (0, _moment2.default)(),
	      endDate: (0, _moment2.default)().add(1, 'day'),
	      absenceType: 'SY',
	      isSubmitting: false,
	      validationMessage: ''
	    };
	  },
	
	  computed: {
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    },
	    saveKeyTooltip: function saveKeyTooltip() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span>' + '<span>Enter</span></p>';
	    },
	    isValid: function isValid() {
	      var hasUser = !!this.userId;
	      var hasEmployment = !!this.employmentId;
	      var hasAbsenceType = !!this.absenceType && String(this.absenceType).trim() !== '';
	      var hasStartDate = !!this.startDate && (0, _moment2.default)(this.startDate).isValid();
	      var emp = this.selectedEmployment;
	      var hasEmploymentNumbers = emp && emp.employment_number;
	
	      return hasUser && hasEmployment && hasAbsenceType && hasStartDate && hasEmploymentNumbers;
	    },
	    usersSortedOnName: function usersSortedOnName() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    filteredUsers: function filteredUsers() {
	      var _this = this;
	
	      return this.usersSortedOnName.filter(function (user) {
	        return _this.employmentsInUserIdHash[user.id];
	      });
	    },
	    itemsSelectedForDSelect: function itemsSelectedForDSelect() {
	      return this.selectedUser ? [this.selectedUser] : [];
	    },
	    selectedUser: function selectedUser() {
	      var _this2 = this;
	
	      return this.usersSortedOnName.find(function (u) {
	        return u.id === _this2.userId;
	      });
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash;
	    },
	    employmentsRaw: function employmentsRaw() {
	      var has = this.userId && this.employmentsInUserIdHash[this.userId];
	      return has ? this.employmentsInUserIdHash[this.userId] : [];
	    },
	    employments: function employments() {
	      var src = this.employmentsRaw;
	      var out = [];
	      for (var i = 0; i < src.length; i++) {
	        var e = src[i];
	        var num = e && e.employment_number ? String(e.employment_number) : '';
	        if (num.trim() !== '') out.push(e);
	      }
	      return out;
	    },
	    hasEmploymentsWithNumber: function hasEmploymentsWithNumber() {
	      return this.userId && this.employments.length > 0;
	    },
	    selectedEmployment: function selectedEmployment() {
	      var list = this.employments;
	      for (var i = 0; i < list.length; i++) {
	        if (list[i].id === this.employmentId) return list[i];
	      }
	      return null;
	    },
	    absenceTypes: function absenceTypes() {
	      return [{ value: 'SY', label: 'SY - Sygdom' }, { value: 'FE', label: 'FE - Ferie' }, { value: 'BE', label: 'BE - Barsel' }, { value: 'OR', label: 'OR - Orlov' }, { value: 'FR', label: 'FR - Fritagelse' }, { value: 'ST', label: 'ST - Sygdom med løn' }, { value: 'SU', label: 'SU - Sygdom uden løn' }, { value: 'FU', label: 'FU - Fritagelse uden løn' }, { value: 'BU', label: 'BU - Barsel uden løn' }];
	    }
	  },
	  watch: {
	    userId: function userId() {
	      this.onUserChange();
	    }
	  },
	  methods: {
	    onSelectUser: function onSelectUser(item) {
	      var _this3 = this;
	
	      if (!item) {
	        this.userId = '';
	      } else {
	        this.userId = item.id;
	      }
	
	      if (item && item.id) {
	        this.$nextTick(function () {
	          if (_this3.employments && _this3.employments.length === 1) {
	            _this3.employmentId = _this3.employments[0].id;
	          }
	        });
	      }
	    },
	    focusUserSelect: function focusUserSelect() {
	      var el = this.$refs && this.$refs.userSelect ? this.$refs.userSelect : null;
	      if (!el) return;
	      el.open();
	    },
	    setStartDate: function setStartDate(date) {
	      this.startDate = date;
	    },
	    setEndDate: function setEndDate(date) {
	      this.endDate = date;
	    },
	    onGlobalKeydown: function onGlobalKeydown(evt) {
	      var isSubmitCombo = (evt.metaKey || evt.ctrlKey) && (evt.key === 'Enter' || evt.keyCode === 13);
	      if (!isSubmitCombo) return;
	
	      if (this.isSubmitting || !this.isValid) return;
	
	      evt.preventDefault();
	      this.submit();
	    },
	    onUserChange: function onUserChange() {
	      this.employmentId = null;
	    },
	    submit: function submit() {
	      var _this4 = this;
	
	      this.validationMessage = '';
	      if (!this.isValid) {
	        this.validationMessage = 'Udfyld alle obligatoriske felter';
	        return;
	      }
	      if (!this.schoolId) {
	        this.validationMessage = 'Mangler schoolId';
	        return;
	      }
	
	      var startDateStr = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDateStr = this.endDate && (0, _moment2.default)(this.endDate).isValid() ? (0, _moment2.default)(this.endDate).format('YYYY-MM-DD') : '9999-12-31';
	
	      var success = function success(res) {
	        _this4.isSubmitting = false;
	        _eventbus2.default.toast = { text: 'Fraværsindberetning oprettet', success: true, position: 'bottomLeft' };
	        _this4.$emit('created', res && res ? res : null);
	        _this4.$emit('close');
	      };
	      var failure = function failure(err) {
	        console.log('failure', err);
	        _this4.isSubmitting = false;
	        _eventbus2.default.toast = { text: 'Kunne ikke oprette fraværsindberetning', success: false, position: 'bottomLeft' };
	      };
	
	      this.isSubmitting = true;
	      _docendo2.default.createKmdOpusAbsence(this.schoolId, this.employmentId, startDateStr, endDateStr, this.absenceType, success, failure);
	    }
	  },
	  mounted: function mounted() {
	    var _this5 = this;
	
	    this.$store.dispatch('readEmployments');
	    window.addEventListener('keydown', this.onGlobalKeydown);
	
	    this.$nextTick(function () {
	      setTimeout(function () {
	        _this5.focusUserSelect();
	      }, 500);
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('keydown', this.onGlobalKeydown);
	  }
	};

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFinite = __webpack_require__(85);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _CreateEngangsydelse = __webpack_require__(373);
	
	var _CreateEngangsydelse2 = _interopRequireDefault(_CreateEngangsydelse);
	
	var _EngangsydelserModal = __webpack_require__(1564);
	
	var _EngangsydelserModal2 = _interopRequireDefault(_EngangsydelserModal);
	
	var _DoDatePickerRange = __webpack_require__(44);
	
	var _DoDatePickerRange2 = _interopRequireDefault(_DoDatePickerRange);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var XLSX = null;
	exports.default = {
	  name: 'Engangsydelser',
	  components: { Loader: _Loader2.default, DoFiltersFilter: _DoFiltersFilter2.default, CreateEngangsydelse: _CreateEngangsydelse2.default, EngangsydelserModal: _EngangsydelserModal2.default, DoDatePickerRange: _DoDatePickerRange2.default, Tabs: _Tabs2.default },
	  data: function data() {
	    return {
	      isNoConfiguration: false,
	      isLoading: false,
	      engangsydelser: [],
	      sortBy: 'vCreatedAt',
	      sortDir: 'desc',
	      isSortPristine: true,
	      selectedNames: [],
	      selectedLoenart: [],
	
	      startDate: (0, _moment2.default)().subtract(1, 'month').startOf('month').startOf('day'),
	      endDate: (0, _moment2.default)().add(1, 'month').endOf('month').endOf('day'),
	      viewTab: 'opus',
	
	      selectedPersonNames: [],
	      selectedUserTags: [],
	      selectedEmploymentTitles: [],
	      selectedOrganisations: [],
	      selectedEmploymentIds: [],
	      isBatchMode: false,
	      activeRow: null,
	      createEmploymentIds: [],
	      createSubtitle: '',
	      createPrefill: null,
	      isDownloadingExcel: false
	    };
	  },
	
	  computed: {
	    viewTabs: function viewTabs() {
	      return [{ id: 'opus', title: 'Oprettelse' }, { id: 'sent', title: 'Sendt til l\xF8nsystem (' + this.sentToSalarySystemCount + ')' }, { id: 'failed', title: 'Fejlede (' + this.failedCount + ')' }];
	    },
	    dateFilteredRows: function dateFilteredRows() {
	      if (!this.startDate || !this.endDate) return this.engangsydelserSorted;
	      var from = (0, _moment2.default)(this.startDate).startOf('day');
	      var to = (0, _moment2.default)(this.endDate).endOf('day');
	      return this.engangsydelserSorted.filter(function (x) {
	        if (!x.vDato) return true;
	        var dato = (0, _moment2.default)(x.vDato, 'DD-MM-YYYY');
	        return dato.isSameOrAfter(from) && dato.isSameOrBefore(to);
	      });
	    },
	    sentToSalarySystemCount: function sentToSalarySystemCount() {
	      return this.dateFilteredRows.filter(function (x) {
	        return x.status !== 'error';
	      }).length;
	    },
	    failedCount: function failedCount() {
	      return this.dateFilteredRows.filter(function (x) {
	        return x.status === 'error';
	      }).length;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    storageKey: function storageKey() {
	      return 'engangsydelserFilters:' + (this.schoolId || 'default');
	    },
	    filtersSnapshot: function filtersSnapshot() {
	      return (0, _stringify2.default)({
	        viewTab: this.viewTab,
	        selectedNames: this.selectedNames,
	        selectedLoenart: this.selectedLoenart,
	        selectedPersonNames: this.selectedPersonNames,
	        selectedUserTags: this.selectedUserTags,
	        selectedEmploymentTitles: this.selectedEmploymentTitles,
	        selectedOrganisations: this.selectedOrganisations
	      });
	    },
	    isLoadingEmployments: function isLoadingEmployments() {
	      return this.$store.state.employments && this.$store.state.employments.isLoadingEmploymentsTypesForSchool;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName || [];
	    },
	    usersById: function usersById() {
	      var map = {};
	      var list = this.users;
	      for (var i = 0; i < list.length; i++) {
	        var u = list[i];
	        map[u.id] = u.name;
	      }
	      return map;
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash || {};
	    },
	    allRows: function allRows() {
	      var out = [];
	      for (var i = 0; i < this.users.length; i++) {
	        var user = this.users[i];
	        var emps = this.employmentsInUserIdHash[user.id] || [];
	        for (var j = 0; j < emps.length; j++) {
	          var emp = emps[j];
	          var empNumber = emp && emp.employment_number ? String(emp.employment_number) : '';
	          if (empNumber.trim() === '') continue;
	          if (emp.source && emp.source !== 'opus') continue;
	
	          if (emp.employment_template_id == null) continue;
	          var title = emp.source_title || emp.title || 'Ansættelse';
	          out.push({
	            id: user.id + '_' + emp.id,
	            userId: user.id,
	            userName: user.name,
	            userTags: Array.isArray(user.user_tags) ? user.user_tags : [],
	            employmentId: emp.id,
	            employmentTitle: title,
	            employmentNumber: empNumber,
	            organisation: emp.organisation || '',
	            employment: emp
	          });
	        }
	      }
	      return out.sort(function (a, b) {
	        return a.userName.localeCompare(b.userName, 'da-DK', { sensitivity: 'base' });
	      });
	    },
	    personNames: function personNames() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        if (this.allRows[i].userName) set[this.allRows[i].userName] = true;
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    userTags: function userTags() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        var t = this.allRows[i].userTags || [];
	        for (var j = 0; j < t.length; j++) {
	          if (t[j]) set[t[j]] = true;
	        }
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    employmentTitles: function employmentTitles() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        if (this.allRows[i].employmentTitle) set[this.allRows[i].employmentTitle] = true;
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    organisations: function organisations() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        if (this.allRows[i].organisation) set[this.allRows[i].organisation] = true;
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    filteredRows: function filteredRows() {
	      var _this = this;
	
	      return this.allRows.filter(function (row) {
	        if (_this.selectedPersonNames.length > 0 && _this.selectedPersonNames.indexOf(row.userName) === -1) {
	          return false;
	        }
	        if (_this.selectedUserTags.length > 0) {
	          var match = row.userTags && _this.selectedUserTags.some(function (t) {
	            return row.userTags.indexOf(t) > -1;
	          });
	          if (!match) return false;
	        }
	        if (_this.selectedEmploymentTitles.length > 0 && _this.selectedEmploymentTitles.indexOf(row.employmentTitle) === -1) {
	          return false;
	        }
	        if (_this.selectedOrganisations.length > 0 && _this.selectedOrganisations.indexOf(row.organisation) === -1) {
	          return false;
	        }
	        return true;
	      });
	    },
	    isAllFilteredSelected: function isAllFilteredSelected() {
	      var _this2 = this;
	
	      if (this.filteredRows.length === 0) return false;
	      return this.filteredRows.every(function (row) {
	        return _this2.selectedEmploymentIds.indexOf(row.employmentId) > -1;
	      });
	    },
	    groupedRows: function groupedRows() {
	      var groups = [];
	      var indexByUser = {};
	      for (var i = 0; i < this.filteredRows.length; i++) {
	        var row = this.filteredRows[i];
	        if (indexByUser[row.userId] === undefined) {
	          indexByUser[row.userId] = groups.length;
	          groups.push({ userId: row.userId, rows: [] });
	        }
	        groups[indexByUser[row.userId]].rows.push(row);
	      }
	      return groups;
	    },
	    employmentsAll: function employmentsAll() {
	      return this.$store.state.employments && this.$store.state.employments.employments ? this.$store.state.employments.employments : [];
	    },
	    employmentsById: function employmentsById() {
	      var map = {};
	      var list = this.employmentsAll || [];
	      for (var i = 0; i < list.length; i++) {
	        var e = list[i];
	        map[e.id] = e;
	      }
	      return map;
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted || [];
	    },
	    salaryCodesByLoenart: function salaryCodesByLoenart() {
	      var map = {};
	      var codes = this.salaryCodes || [];
	      for (var i = 0; i < codes.length; i++) {
	        var code = codes[i];
	        if (code.loenart) {
	          map[String(code.loenart)] = code;
	        }
	      }
	      return map;
	    },
	    salaryCodesById: function salaryCodesById() {
	      var map = {};
	      var codes = this.salaryCodes || [];
	      for (var i = 0; i < codes.length; i++) {
	        map[codes[i].id] = codes[i];
	      }
	      return map;
	    },
	    engangsydelserSorted: function engangsydelserSorted() {
	      var result = [];
	      for (var i = 0; i < this.engangsydelser.length; i++) {
	        var item = this.engangsydelser[i];
	        var employeeId = item.employee_id || item.user_id;
	        var employeeUser = this.usersById[employeeId] || null;
	        var vUserName = employeeUser || (item.medarbejdernummer ? String(item.medarbejdernummer) : 'Ukendt');
	
	        var employment = item.employment_id ? this.employmentsById[item.employment_id] : null;
	        var vEmploymentNumber = employment && employment.employment_number ? employment.employment_number + (employment.title ? ' - ' + employment.title : '') : item.medarbejdernummer ? String(item.medarbejdernummer) : 'Ukendt';
	
	        var createdByUser = item.user_id ? this.usersById[item.user_id] : null;
	        var vCreatedBy = createdByUser || '';
	
	        var vCreatedAt = item.created_at ? (0, _moment2.default)(item.created_at).format('lll') : '';
	        var vStatus = item.status || 'new';
	        var vMessage = item.message || null;
	        var vMessageText = this.formatMessage(vMessage);
	
	        if (item.engangsydelser && Array.isArray(item.engangsydelser) && item.engangsydelser.length > 0) {
	          for (var j = 0; j < item.engangsydelser.length; j++) {
	            var engangsydelse = item.engangsydelser[j];
	            var vDato = engangsydelse.Startdato ? (0, _moment2.default)(engangsydelse.Startdato).format('DD-MM-YYYY') : '';
	
	            var loenartCode = engangsydelse.Loenart || '';
	            var loebenummerCode = engangsydelse.Loebenummer != null ? String(engangsydelse.Loebenummer) : '';
	            var loenkode = loenartCode ? String(parseInt(loenartCode, 10)).padStart(3, '0') + loebenummerCode : '';
	            var salaryCode = item.salary_code_id && this.salaryCodesById[item.salary_code_id] || (loenkode ? this.salaryCodesByLoenart[loenkode] : null);
	            var vLoenart = salaryCode && salaryCode.name ? (salaryCode.loenart || loenkode) + ' - ' + salaryCode.name : loenkode;
	            result.push({
	              id: item.id + '-' + j,
	              parentId: item.id,
	              engangsydelseIndex: j,
	              vUserName: vUserName,
	              vEmploymentNumber: vEmploymentNumber,
	              vCreatedAt: vCreatedAt,
	              vCreatedBy: vCreatedBy,
	              vDato: vDato,
	              loenart: loenkode,
	              vLoenart: vLoenart,
	              salaryCodeId: salaryCode ? salaryCode.id : null,
	              loebenummer: engangsydelse.Loebenummer || '',
	              antal: engangsydelse.Antal != null ? engangsydelse.Antal : null,
	              beloeb: engangsydelse.Beloeb != null ? engangsydelse.Beloeb : null,
	              status: vStatus,
	              message: vMessage,
	              vMessageText: vMessageText,
	              user_id: item.user_id,
	              employee_id: item.employee_id,
	              employment_id: item.employment_id,
	              medarbejdernummer: item.medarbejdernummer,
	              created_at: item.created_at,
	              originalItem: item,
	              originalEngangsydelse: engangsydelse
	            });
	          }
	        } else {
	          result.push({
	            id: item.id + '-empty',
	            parentId: item.id,
	            engangsydelseIndex: -1,
	            vUserName: vUserName,
	            vEmploymentNumber: vEmploymentNumber,
	            vCreatedAt: vCreatedAt,
	            vCreatedBy: vCreatedBy,
	            vDato: '',
	            loenart: '',
	            vLoenart: '',
	            salaryCodeId: null,
	            loebenummer: '',
	            antal: null,
	            beloeb: null,
	            status: vStatus,
	            message: vMessage,
	            vMessageText: vMessageText,
	            user_id: item.user_id,
	            employee_id: item.employee_id,
	            employment_id: item.employment_id,
	            medarbejdernummer: item.medarbejdernummer,
	            created_at: item.created_at,
	            originalItem: item,
	            originalEngangsydelse: null
	          });
	        }
	      }
	      return result;
	    },
	    uniqueNames: function uniqueNames() {
	      var set = {};
	      for (var i = 0; i < this.engangsydelserSorted.length; i++) {
	        var s = this.engangsydelserSorted[i];
	        var name = s.vUserName || '';
	        if (name) set[name] = true;
	      }
	      var arr = (0, _keys2.default)(set);
	      return arr.sort(function (a, b) {
	        return a.localeCompare(b, 'da', { sensitivity: 'base' });
	      });
	    },
	    uniqueLoenart: function uniqueLoenart() {
	      var set = {};
	      for (var i = 0; i < this.engangsydelserSorted.length; i++) {
	        var s = this.engangsydelserSorted[i];
	        var loenart = s.loenart || '';
	        if (loenart) set[loenart] = true;
	      }
	      var arr = (0, _keys2.default)(set);
	      return arr.sort(function (a, b) {
	        return a.localeCompare(b, 'da', { sensitivity: 'base' });
	      });
	    },
	    displayedEngangsydelser: function displayedEngangsydelser() {
	      var _this3 = this;
	
	      var rows = this.dateFilteredRows.slice();
	
	      if (this.viewTab === 'failed') {
	        rows = rows.filter(function (x) {
	          return x.status === 'error';
	        });
	      } else {
	        rows = rows.filter(function (x) {
	          return x.status !== 'error';
	        });
	      }
	
	      if (this.selectedNames && this.selectedNames.length > 0) {
	        var chosen = {};
	        for (var i = 0; i < this.selectedNames.length; i++) {
	          chosen[this.selectedNames[i]] = true;
	        }rows = rows.filter(function (x) {
	          return chosen[x.vUserName || ''];
	        });
	      }
	
	      if (this.selectedLoenart && this.selectedLoenart.length > 0) {
	        var _chosen = {};
	        for (var _i = 0; _i < this.selectedLoenart.length; _i++) {
	          _chosen[this.selectedLoenart[_i]] = true;
	        }rows = rows.filter(function (x) {
	          return _chosen[x.loenart || ''];
	        });
	      }
	
	      var get = function get(item, key) {
	        switch (key) {
	          case 'name':
	            return item.vUserName || '';
	          case 'employment_number':
	            return String(item.vEmploymentNumber || '');
	          case 'loenart':
	            return String(item.loenart || '');
	          case 'loebenummer':
	            return String(item.loebenummer || '');
	          case 'dato':
	            return item.vDato ? (0, _moment2.default)(item.vDato, 'DD-MM-YYYY').toDate() : new Date(0);
	          case 'antal':
	            return _this3._num(item.antal);
	          case 'beloeb':
	            return _this3._num(item.beloeb);
	          case 'vCreatedAt':
	            return item.created_at ? _this3._momentOrNull(item.created_at).valueOf() : 0;
	          default:
	            return item[key] || '';
	        }
	      };
	
	      var dir = this.sortDir === 'asc' ? 1 : -1;
	      var key = this.sortBy;
	
	      return rows.slice().sort(function (a, b) {
	        var va = get(a, key);
	        var vb = get(b, key);
	        if (va === vb) return 0;
	        if (typeof va === 'number' && typeof vb === 'number') return (va - vb) * dir;
	        if (va instanceof Date && vb instanceof Date) return (va - vb) * dir;
	        if (typeof va === 'number' && typeof vb !== 'number') return -1 * dir;
	        if (typeof vb === 'number' && typeof va !== 'number') return 1 * dir;
	        return String(va).localeCompare(String(vb), 'da', { sensitivity: 'base' }) * dir;
	      });
	    }
	  },
	  methods: {
	    onSelectViewTab: function onSelectViewTab(tab) {
	      this.viewTab = tab;
	
	      if (tab !== 'opus' && !this.isLoading) {
	        this.readEngangsydelser();
	      }
	    },
	    togglePersonName: function togglePersonName(name) {
	      var idx = this.selectedPersonNames.indexOf(name);
	      if (idx > -1) this.selectedPersonNames.splice(idx, 1);else this.selectedPersonNames.push(name);
	    },
	    toggleUserTag: function toggleUserTag(tag) {
	      var idx = this.selectedUserTags.indexOf(tag);
	      if (idx > -1) this.selectedUserTags.splice(idx, 1);else this.selectedUserTags.push(tag);
	    },
	    toggleEmploymentTitle: function toggleEmploymentTitle(title) {
	      var idx = this.selectedEmploymentTitles.indexOf(title);
	      if (idx > -1) this.selectedEmploymentTitles.splice(idx, 1);else this.selectedEmploymentTitles.push(title);
	    },
	    toggleOrganisation: function toggleOrganisation(organisation) {
	      var idx = this.selectedOrganisations.indexOf(organisation);
	      if (idx > -1) this.selectedOrganisations.splice(idx, 1);else this.selectedOrganisations.push(organisation);
	    },
	    isRowSelected: function isRowSelected(row) {
	      return this.selectedEmploymentIds.indexOf(row.employmentId) > -1;
	    },
	    toggleSelection: function toggleSelection(row) {
	      var idx = this.selectedEmploymentIds.indexOf(row.employmentId);
	      if (idx > -1) this.selectedEmploymentIds.splice(idx, 1);else this.selectedEmploymentIds.push(row.employmentId);
	    },
	    toggleAllSelected: function toggleAllSelected() {
	      this.isBatchMode = true;
	      var visibleIds = this.filteredRows.map(function (row) {
	        return row.employmentId;
	      });
	      if (this.isAllFilteredSelected) {
	        this.selectedEmploymentIds = this.selectedEmploymentIds.filter(function (id) {
	          return visibleIds.indexOf(id) === -1;
	        });
	      } else {
	        var set = {};
	        for (var i = 0; i < this.selectedEmploymentIds.length; i++) {
	          set[this.selectedEmploymentIds[i]] = true;
	        }for (var _i2 = 0; _i2 < visibleIds.length; _i2++) {
	          set[visibleIds[_i2]] = true;
	        }this.selectedEmploymentIds = (0, _keys2.default)(set).map(function (id) {
	          return parseInt(id, 10);
	        });
	      }
	    },
	    cancelBatchMode: function cancelBatchMode() {
	      this.isBatchMode = false;
	      this.selectedEmploymentIds = [];
	    },
	    onRowClick: function onRowClick(row) {
	      if (this.isBatchMode) {
	        this.toggleSelection(row);
	      } else {
	        this.openViewModal(row);
	      }
	    },
	    openViewModal: function openViewModal(row) {
	      this.activeRow = row;
	    },
	    onViewModalCreated: function onViewModalCreated() {
	      this.readEngangsydelser();
	    },
	    onCheckboxClick: function onCheckboxClick(row) {
	      if (!this.isBatchMode) this.isBatchMode = true;
	      this.toggleSelection(row);
	    },
	    openBulkCreate: function openBulkCreate() {
	      if (this.selectedEmploymentIds.length === 0) return;
	      this.createEmploymentIds = this.selectedEmploymentIds.slice();
	      this.createSubtitle = '';
	    },
	    closeCreate: function closeCreate() {
	      this.createEmploymentIds = [];
	      this.createSubtitle = '';
	      this.createPrefill = null;
	    },
	    openModpostering: function openModpostering(item) {
	      if (!item.employment_id) return;
	      this.createSubtitle = 'Modregn – ' + item.vUserName + ' – ' + item.vEmploymentNumber;
	      this.createPrefill = {
	        salaryCodeId: item.salaryCodeId || null,
	        antal: item.antal != null ? -item.antal : null,
	        beloeb: item.beloeb != null ? -item.beloeb : null,
	        dato: item.vDato ? (0, _moment2.default)(item.vDato, 'DD-MM-YYYY') : null
	      };
	      this.createEmploymentIds = [item.employment_id];
	    },
	    onCreated: function onCreated() {
	      this.closeCreate();
	      this.cancelBatchMode();
	      this.readEngangsydelser();
	    },
	    toggleName: function toggleName(name) {
	      var idx = this.selectedNames.indexOf(name);
	      if (idx >= 0) {
	        this.selectedNames.splice(idx, 1);
	      } else {
	        this.selectedNames.push(name);
	      }
	    },
	    clearNames: function clearNames() {
	      this.selectedNames = [];
	    },
	    toggleLoenart: function toggleLoenart(loenart) {
	      var idx = this.selectedLoenart.indexOf(loenart);
	      if (idx >= 0) {
	        this.selectedLoenart.splice(idx, 1);
	      } else {
	        this.selectedLoenart.push(loenart);
	      }
	    },
	    clearLoenart: function clearLoenart() {
	      this.selectedLoenart = [];
	    },
	    setSort: function setSort(key) {
	      this.isSortPristine = false;
	      if (this.sortBy === key) {
	        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
	      } else {
	        this.sortBy = key;
	        this.sortDir = 'asc';
	      }
	    },
	    _num: function _num(v) {
	      if (v == null || v === '') return 0;
	      var n = typeof v === 'number' ? v : parseFloat(String(v).replace(',', '.'));
	      return (0, _isFinite2.default)(n) ? n : 0;
	    },
	    _momentOrNull: function _momentOrNull(iso) {
	      return iso ? (0, _moment2.default)(iso) : null;
	    },
	    formatDecimal: function formatDecimal(value) {
	      if (value == null || value === '') return '';
	      return String(value).replace('.', ',');
	    },
	    readEngangsydelser: function readEngangsydelser() {
	      var _this4 = this;
	
	      this.isLoading = true;
	      _docendo2.default.listKmdEngangsydelser(this.schoolId, function (success) {
	        if (success && success.status && success.status === 'error') {
	          _this4.isNoConfiguration = true;
	        }
	        if (Array.isArray(success)) {
	          _this4.engangsydelser = success;
	        } else if (success && Array.isArray(success.data)) {
	          _this4.engangsydelser = success.data;
	        } else {
	          _this4.engangsydelser = [];
	        }
	        _this4.isLoading = false;
	      }, function (failure) {
	        console.log(failure);
	        _this4.isLoading = false;
	        _this4.engangsydelser = [];
	        if (failure && failure.status && failure.status === 'error') {
	          _this4.isNoConfiguration = true;
	        }
	      });
	    },
	    startDateChanged: function startDateChanged(date) {
	      this.startDate = date;
	      this.readEngangsydelser();
	    },
	    endDateChanged: function endDateChanged(date) {
	      this.endDate = date;
	      this.readEngangsydelser();
	    },
	    statusLabel: function statusLabel(status) {
	      switch (status) {
	        case 'new':
	          return 'Afventer';
	        case 'success':
	          return 'Sendt';
	        case 'error':
	          return 'Fejlet';
	        default:
	          return status || '';
	      }
	    },
	    dataToExcel: function dataToExcel() {
	      var _this5 = this;
	
	      return this.displayedEngangsydelser.map(function (row) {
	        return {
	          created_at: row.vCreatedAt || '',
	          user: row.vUserName || '',
	          employment: row.vEmploymentNumber || '',
	          loenkode: row.vLoenart || '',
	          antal: row.antal != null ? row.antal : '',
	          beloeb: row.beloeb != null ? row.beloeb : '',
	          dato: row.vDato || '',
	          created_by: row.vCreatedBy || '',
	          status: _this5.statusLabel(row.status),
	          message: row.vMessageText || ''
	        };
	      });
	    },
	    downloadExcel: function downloadExcel() {
	      var _this6 = this;
	
	      if (this.isDownloadingExcel || this.displayedEngangsydelser.length === 0) return;
	      this.isDownloadingExcel = true;
	      if (window.XLSX && XLSX) {
	        this.writeExcel();
	      } else {
	        var cdnXLSX = document.createElement('script');
	        cdnXLSX.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.mini.min.js');
	        document.head.appendChild(cdnXLSX);
	        var intervalTimer = setInterval(function (_) {
	          if (window.XLSX) {
	            clearInterval(intervalTimer);
	            XLSX = window.XLSX;
	            _this6.writeExcel();
	          }
	        }, 500);
	      }
	    },
	    writeExcel: function writeExcel() {
	      var headers = {
	        created_at: 'Oprettet',
	        user: 'Navn',
	        employment: 'Ansættelse',
	        loenkode: 'Lønkode',
	        antal: 'Enheder',
	        beloeb: 'Beløb',
	        dato: 'Dato',
	        created_by: 'Oprettet af',
	        status: 'Status',
	        message: 'Besked'
	      };
	      var rows = this.dataToExcel();
	      rows.unshift(headers);
	      var sheet = XLSX.utils.json_to_sheet(rows, { skipHeader: true });
	      var wb = XLSX.utils.book_new();
	      XLSX.utils.book_append_sheet(wb, sheet, 'data');
	      var label = this.viewTab === 'failed' ? 'fejlede' : 'sendt';
	      var timestamp = (0, _moment2.default)().format('YYYY-MM-DD_HH-mm');
	      XLSX.writeFile(wb, 'engangsydelser_' + label + '_' + timestamp + '.xlsx');
	      this.isDownloadingExcel = false;
	    },
	    formatMessage: function formatMessage(message) {
	      if (!message) return '';
	      var list = Array.isArray(message) ? message : [message];
	      return list.map(function (m) {
	        if (!m) return '';
	        if (typeof m === 'string') return m;
	        var tekst = m.Tekst || m.tekst || m.message || '';
	        return m.Kode != null && tekst ? m.Kode + ': ' + tekst : tekst;
	      }).filter(function (t) {
	        return t;
	      }).join(' · ');
	    },
	    persistFilters: function persistFilters(val) {
	      try {
	        window.localStorage.setItem(this.storageKey, val);
	      } catch (e) {}
	    },
	    restoreFilters: function restoreFilters() {
	      try {
	        var raw = window.localStorage.getItem(this.storageKey);
	        if (!raw) return;
	        var saved = JSON.parse(raw);
	        if (!saved) return;
	        if (saved.viewTab) this.viewTab = saved.viewTab;
	        if (Array.isArray(saved.selectedNames)) this.selectedNames = saved.selectedNames;
	        if (Array.isArray(saved.selectedLoenart)) this.selectedLoenart = saved.selectedLoenart;
	        if (Array.isArray(saved.selectedPersonNames)) this.selectedPersonNames = saved.selectedPersonNames;
	        if (Array.isArray(saved.selectedUserTags)) this.selectedUserTags = saved.selectedUserTags;
	        if (Array.isArray(saved.selectedEmploymentTitles)) this.selectedEmploymentTitles = saved.selectedEmploymentTitles;
	        if (Array.isArray(saved.selectedOrganisations)) this.selectedOrganisations = saved.selectedOrganisations;
	      } catch (e) {}
	    }
	  },
	  watch: {
	    filtersSnapshot: function filtersSnapshot(val) {
	      this.persistFilters(val);
	    },
	    selectedEmploymentIds: function selectedEmploymentIds(ids) {
	      if (!ids || ids.length === 0) {
	        this.isBatchMode = false;
	      }
	    }
	  },
	  created: function created() {
	    this.restoreFilters();
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('readEmployments');
	    this.$store.dispatch('readSalaryCodes');
	    this.readEngangsydelser();
	  }
	};

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DoDatePickerRange = __webpack_require__(44);
	
	var _DoDatePickerRange2 = _interopRequireDefault(_DoDatePickerRange);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _CreateEngangsydelse = __webpack_require__(373);
	
	var _CreateEngangsydelse2 = _interopRequireDefault(_CreateEngangsydelse);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'EngangsydelserModal',
	  components: { DModal: _DModal2.default, DoDatePickerRange: _DoDatePickerRange2.default, Loader: _Loader2.default, CreateEngangsydelse: _CreateEngangsydelse2.default },
	  props: {
	    schoolId: {
	      type: Number,
	      required: true
	    },
	    employmentId: {
	      required: true
	    },
	    employment: {
	      default: null
	    },
	    userId: {
	      required: true
	    },
	    userName: {
	      type: String,
	      default: ''
	    },
	    employmentNumber: {
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      startDate: (0, _moment2.default)().subtract(1, 'month'),
	      endDate: (0, _moment2.default)(),
	      isLoading: false,
	      payments: [],
	      isShowCreate: false,
	      createPrefill: null,
	      createModalSubtitle: '',
	
	      pendingPayments: []
	    };
	  },
	
	  computed: {
	    employmentLabel: function employmentLabel() {
	      var e = this.employment;
	      if (!e) return this.employmentNumber ? String(this.employmentNumber) : '';
	      var title = e.source_title || e.title || 'Ansættelse';
	      return e.employment_number ? e.employment_number + ' - ' + title : title;
	    },
	    createSubtitle: function createSubtitle() {
	      return this.userName + (this.employmentLabel ? ' – ' + this.employmentLabel : '');
	    },
	    effectiveCreateSubtitle: function effectiveCreateSubtitle() {
	      return this.createModalSubtitle || this.createSubtitle;
	    },
	    dateShortCuts: function dateShortCuts() {
	      var now = (0, _moment2.default)();
	      return [{ title: 'Denne uge', startDate: now.clone().startOf('isoWeek'), endDate: now.clone().endOf('isoWeek') }, { title: 'Denne måned', startDate: now.clone().startOf('month'), endDate: now.clone().endOf('month') }, { title: 'Sidste måned', startDate: now.clone().subtract(1, 'month').startOf('month'), endDate: now.clone().subtract(1, 'month').endOf('month') }];
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted || [];
	    },
	    salaryCodesByLoenkode: function salaryCodesByLoenkode() {
	      var map = {};
	      for (var i = 0; i < this.salaryCodes.length; i++) {
	        var code = this.salaryCodes[i];
	        if (code.loenart) map[String(code.loenart)] = code;
	      }
	      return map;
	    },
	    displayedPayments: function displayedPayments() {
	      var _this = this;
	
	      var opusRows = this.payments.slice().sort(function (a, b) {
	        return new Date(a.startdato) - new Date(b.startdato);
	      }).map(function (item) {
	        var loenkode = _this.loenkodeForRow(item);
	        return (0, _assign2.default)({}, item, {
	          vLoenart: _this.loenartLabel(loenkode),
	          vDato: item.startdato ? (0, _moment2.default)(item.startdato).format('DD-MM-YYYY') : '',
	          vStatus: 'I OPUS',
	          statusClass: 'do-pill--green'
	        });
	      });
	
	      return this.pendingPayments.concat(opusRows);
	    }
	  },
	  methods: {
	    formatDecimal: function formatDecimal(value) {
	      if (value == null || value === '') return '';
	      return String(value).replace('.', ',');
	    },
	    loenkodeForRow: function loenkodeForRow(item) {
	      if (item.loenart == null) return '';
	      var loenart = String(item.loenart).padStart(3, '0');
	      var loebenummer = item.loebenummer != null ? String(item.loebenummer) : '0';
	      return loenart + loebenummer;
	    },
	    loenartLabel: function loenartLabel(loenkode) {
	      var salaryCode = loenkode ? this.salaryCodesByLoenkode[loenkode] : null;
	      var codeName = salaryCode && salaryCode.name || '';
	      return codeName ? loenkode ? loenkode + ' - ' + codeName : codeName : loenkode || '—';
	    },
	    statusLabel: function statusLabel(status) {
	      switch (status) {
	        case 'success':
	          return 'Sendt';
	        case 'error':
	          return 'Fejlet';
	        default:
	          return 'I kø';
	      }
	    },
	    statusPillClass: function statusPillClass(status) {
	      switch (status) {
	        case 'success':
	          return 'do-pill--green';
	        case 'error':
	          return 'do-pill--red';
	        default:
	          return 'do-pill--yellow';
	      }
	    },
	    normAmount: function normAmount(v) {
	      if (v == null || v === '') return '';
	      var n = parseFloat(String(v).replace(',', '.'));
	      return isNaN(n) ? '' : n.toFixed(2);
	    },
	    matchKey: function matchKey(loenkode, startdato, antal, beloeb) {
	      var date = startdato ? (0, _moment2.default)(startdato).format('YYYY-MM-DD') : '';
	      return [loenkode || '', date, this.normAmount(antal), this.normAmount(beloeb)].join('|');
	    },
	    startDateChanged: function startDateChanged(date) {
	      this.startDate = date;
	      this.scheduleRead();
	    },
	    endDateChanged: function endDateChanged(date) {
	      this.endDate = date;
	      this.scheduleRead();
	    },
	    scheduleRead: function scheduleRead() {
	      var _this2 = this;
	
	      if (this._readTimer) clearTimeout(this._readTimer);
	      this._readTimer = setTimeout(function () {
	        _this2._readTimer = null;
	        _this2.read();
	      }, 0);
	    },
	    read: function read() {
	      var _this3 = this;
	
	      this.isLoading = true;
	      var fromDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var toDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      _docendo2.default.salaryOpusRead(this.schoolId, [this.schoolId], fromDate, toDate, this.userId, function (success) {
	        var list = success && Array.isArray(success.one_time_payments) ? success.one_time_payments : [];
	
	        var empNumber = parseInt(_this3.employmentNumber, 10);
	        _this3.payments = isNaN(empNumber) ? list : list.filter(function (p) {
	          return parseInt(p.medarbejdernummer, 10) === empNumber;
	        });
	
	        var opusKeys = {};
	        _this3.payments.forEach(function (p) {
	          opusKeys[_this3.matchKey(_this3.loenkodeForRow(p), p.startdato, p.antal, p.beloeb)] = true;
	        });
	        _this3.pendingPayments = _this3.pendingPayments.filter(function (row) {
	          return !opusKeys[row._key];
	        });
	        _this3.isLoading = false;
	      }, function (failure) {
	        console.log('Kunne ikke hente engangsydelser fra OPUS', failure);
	        _this3.payments = [];
	        _this3.isLoading = false;
	        _eventbus2.default.toast = { text: 'Kunne ikke hente engangsydelser fra OPUS', success: false, position: 'bottomLeft' };
	      });
	    },
	    openCreate: function openCreate() {
	      this.createPrefill = null;
	      this.createModalSubtitle = '';
	      this.isShowCreate = true;
	    },
	    closeCreate: function closeCreate() {
	      this.isShowCreate = false;
	      this.createPrefill = null;
	      this.createModalSubtitle = '';
	    },
	    openModregn: function openModregn(row) {
	      var loenkode = this.loenkodeForRow(row);
	      var salaryCode = loenkode ? this.salaryCodesByLoenkode[loenkode] : null;
	      var antal = row.antal != null && row.antal !== '' ? parseFloat(String(row.antal).replace(',', '.')) : null;
	      var beloeb = row.beloeb != null && row.beloeb !== '' ? parseFloat(String(row.beloeb).replace(',', '.')) : null;
	      this.createModalSubtitle = 'Modregn – ' + this.userName + ' – ' + this.employmentLabel;
	      this.createPrefill = {
	        salaryCodeId: salaryCode ? salaryCode.id : null,
	        antal: antal != null && !isNaN(antal) ? -antal : null,
	        beloeb: beloeb != null && !isNaN(beloeb) ? -beloeb : null,
	        dato: row.vDato ? (0, _moment2.default)(row.vDato, 'DD-MM-YYYY') : row.startdato ? (0, _moment2.default)(row.startdato) : null
	      };
	      this.isShowCreate = true;
	    },
	    onCreated: function onCreated(created) {
	      var _this4 = this;
	
	      this.closeCreate();
	      this.$emit('created');
	
	      var list = Array.isArray(created) ? created : created ? [created] : [];
	      var rows = [];
	      list.forEach(function (item) {
	        var ydelser = Array.isArray(item.engangsydelser) ? item.engangsydelser : [];
	        ydelser.forEach(function (e, idx) {
	          var loenkode = e.Loenart ? String(parseInt(e.Loenart, 10)).padStart(3, '0') + (e.Loebenummer != null ? String(e.Loebenummer) : '0') : '';
	          rows.push({
	            id: 'pending-' + item.id + '-' + idx,
	
	            _key: _this4.matchKey(loenkode, e.Startdato, e.Antal, e.Beloeb),
	            vDato: e.Startdato ? (0, _moment2.default)(e.Startdato).format('DD-MM-YYYY') : '',
	            vLoenart: _this4.loenartLabel(loenkode),
	            antal: e.Antal != null ? e.Antal : null,
	            beloeb: e.Beloeb != null ? e.Beloeb : null,
	            afv_omkostningssted: e.Afv_Omkostningssted || '',
	            vStatus: _this4.statusLabel(item.status),
	            statusClass: _this4.statusPillClass(item.status)
	          });
	        });
	      });
	      this.pendingPayments = rows.concat(this.pendingPayments);
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('readSalaryCodes');
	    this.read();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this._readTimer) clearTimeout(this._readTimer);
	  }
	};

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(28);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _FasteTillaegModal = __webpack_require__(1566);
	
	var _FasteTillaegModal2 = _interopRequireDefault(_FasteTillaegModal);
	
	var _CreateFastTillaeg = __webpack_require__(1561);
	
	var _CreateFastTillaeg2 = _interopRequireDefault(_CreateFastTillaeg);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _Supplements = __webpack_require__(102);
	
	var _Supplements2 = _interopRequireDefault(_Supplements);
	
	var _TidsbegraensetUvModal = __webpack_require__(399);
	
	var _TidsbegraensetUvModal2 = _interopRequireDefault(_TidsbegraensetUvModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var XLSX = null;
	exports.default = {
	  name: 'FasteTillaeg',
	  components: { Loader: _Loader2.default, DoFiltersFilter: _DoFiltersFilter2.default, Tabs: _Tabs2.default, FasteTillaegModal: _FasteTillaegModal2.default, CreateFastTillaeg: _CreateFastTillaeg2.default, DModal: _DModal2.default, DDropdown: _DDropdown2.default, Supplements: _Supplements2.default, TidsbegraensetUvModal: _TidsbegraensetUvModal2.default },
	  data: function data() {
	    return {
	      selectedNames: [],
	      selectedTags: [],
	      selectedEmploymentTitles: [],
	      selectedOrganisations: [],
	      selectedEmploymentIds: [],
	      isBatchMode: false,
	      activeRow: null,
	      createEmploymentIds: [],
	      createSubtitle: '',
	      isShowTidsbegraenset: false,
	      isShowBeregnModal: false,
	      beregnType: null,
	      sendToOpusTrigger: 0,
	      opusApproveState: { count: 0, isApproving: false, canApprove: false, missingEmployment: false },
	      beregnOptions: [{ id: 'uv_over_graense', label: 'Undervisningstillæg – timer over grænse (§5 stk. 2)' }, { id: 'spec_skole_uv', label: 'Specialundervisning (§ 5, stk. 4)' }, { id: 'dsa_tale_hoere', label: 'DSA og tale/høre-undervisning (§5 stk. 9 og 10)' }, { id: 'paedagog_eneansvar', label: 'Pædagog med eneansvar' }],
	      viewTab: 'opus',
	      outboxRows: [],
	      isLoadingOutbox: false,
	      outboxSortKey: 'created_at',
	      outboxSortDir: 'desc',
	      hasLoadedOutbox: false,
	      deletingIds: [],
	      rowToDelete: null,
	      isDownloadingOutbox: false
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    storageKey: function storageKey() {
	      return 'fasteTillaegFilters:' + (this.schoolId || 'default');
	    },
	    filtersSnapshot: function filtersSnapshot() {
	      return (0, _stringify2.default)({
	        viewTab: this.viewTab,
	        selectedNames: this.selectedNames,
	        selectedTags: this.selectedTags,
	        selectedEmploymentTitles: this.selectedEmploymentTitles,
	        selectedOrganisations: this.selectedOrganisations
	      });
	    },
	    beregnModalTitle: function beregnModalTitle() {
	      var _this = this;
	
	      var option = this.beregnOptions.find(function (o) {
	        return o.id === _this.beregnType;
	      });
	      return option ? option.label : 'Beregn tillæg automatisk';
	    },
	    sendToOpusTooltip: function sendToOpusTooltip() {
	      if (this.opusApproveState.count === 0) return 'Opret lønlinjer først';
	      if (this.opusApproveState.missingEmployment) return 'Vælg ansættelse på alle linjer';
	      return '';
	    },
	    isLoadingEmployments: function isLoadingEmployments() {
	      return this.$store.state.employments && this.$store.state.employments.isLoadingEmploymentsTypesForSchool;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName || [];
	    },
	    userById: function userById() {
	      var map = {};
	      for (var i = 0; i < this.users.length; i++) {
	        map[this.users[i].id] = this.users[i];
	      }return map;
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash || {};
	    },
	    allRows: function allRows() {
	      var out = [];
	      for (var i = 0; i < this.users.length; i++) {
	        var user = this.users[i];
	        var emps = this.employmentsInUserIdHash[user.id] || [];
	        for (var j = 0; j < emps.length; j++) {
	          var emp = emps[j];
	          var empNumber = emp && emp.employment_number ? String(emp.employment_number) : '';
	          if (empNumber.trim() === '') continue;
	          if (emp.source && emp.source !== 'opus') continue;
	
	          if (emp.employment_template_id == null) continue;
	          var title = emp.source_title || emp.title || 'Ansættelse';
	          out.push({
	            id: user.id + '_' + emp.id,
	            userId: user.id,
	            userName: user.name,
	            userTags: Array.isArray(user.user_tags) ? user.user_tags : [],
	            employmentId: emp.id,
	            employmentTitle: title,
	            employmentNumber: empNumber,
	            organisation: emp.organisation || '',
	            employment: emp
	          });
	        }
	      }
	      return out.sort(function (a, b) {
	        return a.userName.localeCompare(b.userName, 'da-DK', { sensitivity: 'base' });
	      });
	    },
	    personNames: function personNames() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        if (this.allRows[i].userName) set[this.allRows[i].userName] = true;
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    tags: function tags() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        var t = this.allRows[i].userTags || [];
	        for (var j = 0; j < t.length; j++) {
	          if (t[j]) set[t[j]] = true;
	        }
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    employmentTitles: function employmentTitles() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        if (this.allRows[i].employmentTitle) set[this.allRows[i].employmentTitle] = true;
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    organisations: function organisations() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        if (this.allRows[i].organisation) set[this.allRows[i].organisation] = true;
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    filteredRows: function filteredRows() {
	      var _this2 = this;
	
	      return this.allRows.filter(function (row) {
	        if (_this2.selectedNames.length > 0 && _this2.selectedNames.indexOf(row.userName) === -1) {
	          return false;
	        }
	        if (_this2.selectedTags.length > 0) {
	          var match = row.userTags && _this2.selectedTags.some(function (t) {
	            return row.userTags.indexOf(t) > -1;
	          });
	          if (!match) return false;
	        }
	        if (_this2.selectedEmploymentTitles.length > 0 && _this2.selectedEmploymentTitles.indexOf(row.employmentTitle) === -1) {
	          return false;
	        }
	        if (_this2.selectedOrganisations.length > 0 && _this2.selectedOrganisations.indexOf(row.organisation) === -1) {
	          return false;
	        }
	        return true;
	      });
	    },
	    isAllFilteredSelected: function isAllFilteredSelected() {
	      var _this3 = this;
	
	      if (this.filteredRows.length === 0) return false;
	      return this.filteredRows.every(function (row) {
	        return _this3.selectedEmploymentIds.indexOf(row.employmentId) > -1;
	      });
	    },
	    groupedRows: function groupedRows() {
	      var groups = [];
	      var indexByUser = {};
	      for (var i = 0; i < this.filteredRows.length; i++) {
	        var row = this.filteredRows[i];
	        if (indexByUser[row.userId] === undefined) {
	          indexByUser[row.userId] = groups.length;
	          groups.push({ userId: row.userId, rows: [] });
	        }
	        groups[indexByUser[row.userId]].rows.push(row);
	      }
	      return groups;
	    },
	    viewTabs: function viewTabs() {
	      return [{ id: 'opus', title: 'Oprettelse' }, { id: 'outbox', title: 'Udbakke' }, { id: 'sent', title: 'Afsendte' }];
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted || [];
	    },
	    hasSpecialSalaryCode: function hasSpecialSalaryCode() {
	      return this.salaryCodes.some(function (salaryCode) {
	        return String(salaryCode.loenart) === '8411' || String(salaryCode.code) === '8411';
	      });
	    },
	    visibleBeregnOptions: function visibleBeregnOptions() {
	      var _this4 = this;
	
	      return this.beregnOptions.filter(function (option) {
	        return option.id !== 'spec_skole_uv' || _this4.hasSpecialSalaryCode;
	      });
	    },
	    salaryCodesByLoenkode: function salaryCodesByLoenkode() {
	      var map = {};
	      for (var i = 0; i < this.salaryCodes.length; i++) {
	        var code = this.salaryCodes[i];
	        if (code.loenart) map[String(code.loenart)] = code;
	      }
	      return map;
	    },
	    employmentRowByNumber: function employmentRowByNumber() {
	      var map = {};
	      var rows = this.allRows;
	      for (var i = 0; i < rows.length; i++) {
	        var num = parseInt(rows[i].employmentNumber, 10);
	        if (!isNaN(num)) map[String(num)] = rows[i];
	      }
	      return map;
	    },
	    enrichedOutboxRows: function enrichedOutboxRows() {
	      var _this5 = this;
	
	      var rowByNumber = this.employmentRowByNumber;
	      var userById = this.userById;
	      var rows = this.outboxRows.filter(function (rec) {
	        return rec.state !== 'deleted';
	      }).map(function (rec) {
	        var match = rowByNumber[String(rec.medarbejder_nummer)] || null;
	        var creator = rec.user_id != null ? userById[rec.user_id] || null : null;
	        return (0, _assign2.default)({}, rec, {
	          vUserName: match ? match.userName : 'Medarbejder ' + rec.medarbejder_nummer,
	          vUserId: match ? match.userId : null,
	          vUserTags: match ? match.userTags : [],
	          vEmploymentId: match ? match.employmentId : null,
	          vEmployment: match ? match.employment : null,
	          vEmploymentLabel: match ? match.employmentNumber + ' - ' + match.employmentTitle : String(rec.medarbejder_nummer),
	          vEmploymentTitle: match ? match.employmentTitle : '',
	          vOrganisation: match ? match.organisation : '',
	          vCreatedById: rec.user_id != null ? rec.user_id : null,
	          vCreatedByName: creator ? creator.name : null
	        });
	      });
	      rows = rows.filter(function (row) {
	        if (_this5.selectedNames.length > 0 && _this5.selectedNames.indexOf(row.vUserName) === -1) {
	          return false;
	        }
	        if (_this5.selectedTags.length > 0) {
	          var match = row.vUserTags && _this5.selectedTags.some(function (t) {
	            return row.vUserTags.indexOf(t) > -1;
	          });
	          if (!match) return false;
	        }
	        if (_this5.selectedEmploymentTitles.length > 0 && _this5.selectedEmploymentTitles.indexOf(row.vEmploymentTitle) === -1) {
	          return false;
	        }
	        if (_this5.selectedOrganisations.length > 0 && _this5.selectedOrganisations.indexOf(row.vOrganisation) === -1) {
	          return false;
	        }
	        return true;
	      });
	      rows = rows.map(function (item) {
	        var loenkode = _this5.loenkodeForRow(item);
	        var salaryCode = loenkode ? _this5.salaryCodesByLoenkode[loenkode] : null;
	        var title = salaryCode && salaryCode.name || '';
	        var vLoenart = loenkode ? title ? title + ' (' + loenkode + ')' : loenkode : '—';
	        return (0, _assign2.default)({}, item, {
	          vLoenart: vLoenart,
	          vCreatedAt: item.created_at ? (0, _moment2.default)(item.created_at).format('DD-MM-YYYY HH:mm') : '',
	          vFraDato: item.startdato ? (0, _moment2.default)(item.startdato).format('DD-MM-YYYY') : '',
	          vTilDato: item.stopdato ? (0, _moment2.default)(item.stopdato).format('DD-MM-YYYY') : ''
	        });
	      });
	      var dir = this.outboxSortDir === 'asc' ? 1 : -1;
	      var key = this.outboxSortKey;
	      return rows.sort(function (a, b) {
	        var av = _this5.outboxSortValue(a, key);
	        var bv = _this5.outboxSortValue(b, key);
	        var cmp = void 0;
	        if (typeof av === 'number' && typeof bv === 'number') {
	          cmp = av - bv;
	        } else {
	          cmp = String(av).localeCompare(String(bv), 'da-DK', { sensitivity: 'base' });
	        }
	        return cmp * dir;
	      });
	    },
	    displayedOutboxRows: function displayedOutboxRows() {
	      return this.enrichedOutboxRows.filter(function (row) {
	        return row.state !== 'sent';
	      });
	    },
	    displayedSentRows: function displayedSentRows() {
	      return this.enrichedOutboxRows.filter(function (row) {
	        return row.state === 'sent';
	      });
	    },
	    currentOutboxRows: function currentOutboxRows() {
	      return this.viewTab === 'sent' ? this.displayedSentRows : this.displayedOutboxRows;
	    }
	  },
	  methods: {
	    sortOutbox: function sortOutbox(key) {
	      if (this.outboxSortKey === key) {
	        this.outboxSortDir = this.outboxSortDir === 'asc' ? 'desc' : 'asc';
	      } else {
	        this.outboxSortKey = key;
	        this.outboxSortDir = 'asc';
	      }
	    },
	    outboxSortValue: function outboxSortValue(row, key) {
	      switch (key) {
	        case 'created_at':
	          return row.created_at ? (0, _moment2.default)(row.created_at).valueOf() : 0;
	        case 'user':
	          return (row.vUserName || '').toLowerCase();
	        case 'employment':
	          return (row.vEmploymentLabel || '').toLowerCase();
	        case 'loenkode':
	          return (row.vLoenart || '').toLowerCase();
	        case 'antal':
	          return row.antal != null && row.antal !== '' ? parseFloat(String(row.antal).replace(',', '.')) : 0;
	        case 'beloeb':
	          return row.beloeb != null && row.beloeb !== '' ? parseFloat(String(row.beloeb).replace(',', '.')) : 0;
	        case 'fra':
	          return row.startdato ? (0, _moment2.default)(row.startdato).valueOf() : 0;
	        case 'til':
	          return row.stopdato ? (0, _moment2.default)(row.stopdato).valueOf() : 0;
	        case 'operation':
	          return this.operationLabel(row.operation) || '';
	        case 'created_by':
	          return (row.vCreatedByName || (row.vCreatedById != null ? 'tidligere ansat' : '')).toLowerCase();
	        case 'state':
	          return this.stateLabel(row) || '';
	        default:
	          return '';
	      }
	    },
	    loenkodeForRow: function loenkodeForRow(item) {
	      if (item.loenart == null) return '';
	      var loenart = String(item.loenart).padStart(3, '0');
	      var loebenummer = item.loebenummer != null ? String(item.loebenummer) : '0';
	      return loenart + loebenummer;
	    },
	    toggleName: function toggleName(name) {
	      var idx = this.selectedNames.indexOf(name);
	      if (idx > -1) this.selectedNames.splice(idx, 1);else this.selectedNames.push(name);
	    },
	    toggleTag: function toggleTag(tag) {
	      var idx = this.selectedTags.indexOf(tag);
	      if (idx > -1) this.selectedTags.splice(idx, 1);else this.selectedTags.push(tag);
	    },
	    toggleEmploymentTitle: function toggleEmploymentTitle(title) {
	      var idx = this.selectedEmploymentTitles.indexOf(title);
	      if (idx > -1) this.selectedEmploymentTitles.splice(idx, 1);else this.selectedEmploymentTitles.push(title);
	    },
	    toggleOrganisation: function toggleOrganisation(organisation) {
	      var idx = this.selectedOrganisations.indexOf(organisation);
	      if (idx > -1) this.selectedOrganisations.splice(idx, 1);else this.selectedOrganisations.push(organisation);
	    },
	    isRowSelected: function isRowSelected(row) {
	      return this.selectedEmploymentIds.indexOf(row.employmentId) > -1;
	    },
	    toggleSelection: function toggleSelection(row) {
	      var idx = this.selectedEmploymentIds.indexOf(row.employmentId);
	      if (idx > -1) this.selectedEmploymentIds.splice(idx, 1);else this.selectedEmploymentIds.push(row.employmentId);
	    },
	    toggleAllSelected: function toggleAllSelected() {
	      this.isBatchMode = true;
	      var visibleIds = this.filteredRows.map(function (row) {
	        return row.employmentId;
	      });
	      if (this.isAllFilteredSelected) {
	        this.selectedEmploymentIds = this.selectedEmploymentIds.filter(function (id) {
	          return visibleIds.indexOf(id) === -1;
	        });
	      } else {
	        var set = {};
	        for (var i = 0; i < this.selectedEmploymentIds.length; i++) {
	          set[this.selectedEmploymentIds[i]] = true;
	        }for (var _i = 0; _i < visibleIds.length; _i++) {
	          set[visibleIds[_i]] = true;
	        }this.selectedEmploymentIds = (0, _keys2.default)(set).map(function (id) {
	          return parseInt(id, 10);
	        });
	      }
	    },
	    cancelBatchMode: function cancelBatchMode() {
	      this.isBatchMode = false;
	      this.selectedEmploymentIds = [];
	    },
	    openBulkCreate: function openBulkCreate() {
	      if (this.selectedEmploymentIds.length === 0) return;
	      this.createEmploymentIds = this.selectedEmploymentIds.slice();
	      this.createSubtitle = '';
	    },
	    openSingleCreate: function openSingleCreate(row) {
	      this.createEmploymentIds = [row.employmentId];
	      this.createSubtitle = row.userName + ' – ' + row.employmentNumber + ' - ' + row.employmentTitle;
	    },
	    closeCreate: function closeCreate() {
	      this.createEmploymentIds = [];
	      this.createSubtitle = '';
	    },
	    onBulkCreated: function onBulkCreated() {
	      this.createEmploymentIds = [];
	      this.createSubtitle = '';
	      this.selectedEmploymentIds = [];
	      this.isBatchMode = false;
	
	      this.loadOutbox();
	    },
	    onRowClick: function onRowClick(row) {
	      if (this.isBatchMode) {
	        this.toggleSelection(row);
	      } else {
	        this.openSingleCreate(row);
	      }
	    },
	    onCheckboxClick: function onCheckboxClick(row) {
	      if (!this.isBatchMode) this.isBatchMode = true;
	      this.toggleSelection(row);
	    },
	    openModal: function openModal(row) {
	      this.activeRow = row;
	    },
	    selectBeregnOption: function selectBeregnOption(option) {
	      if (option.id === 'tidsbegraenset_uv') {
	        this.isShowTidsbegraenset = true;
	        return;
	      }
	      this.beregnType = option.id;
	      this.opusApproveState = { count: 0, isApproving: false, canApprove: false, missingEmployment: false };
	      this.isShowBeregnModal = true;
	    },
	    triggerSendToOpus: function triggerSendToOpus() {
	      this.sendToOpusTrigger++;
	    },
	    closeBeregnModal: function closeBeregnModal() {
	      this.isShowBeregnModal = false;
	      this.beregnType = null;
	
	      this.loadOutbox();
	    },
	    deleteFailedRow: function deleteFailedRow(row) {
	      if (row.id == null) return;
	      this.rowToDelete = row;
	    },
	    confirmDeleteFailedRow: function confirmDeleteFailedRow() {
	      var _this6 = this;
	
	      var row = this.rowToDelete;
	      if (!row || row.id == null || this.deletingIds.includes(row.id)) return;
	      this.deletingIds.push(row.id);
	      _docendo2.default.deleteFailedRecurringPayments(this.schoolId, [row.id], function () {
	        _this6.deletingIds = _this6.deletingIds.filter(function (id) {
	          return id !== row.id;
	        });
	
	        _this6.outboxRows = _this6.outboxRows.filter(function (r) {
	          return r.id !== row.id;
	        });
	        _this6.rowToDelete = null;
	        _eventbus2.default.toast = { text: 'Linjen blev slettet', success: true, position: 'bottomLeft' };
	      }, function (failure) {
	        console.log('Kunne ikke slette udbakke-linje', failure);
	        _this6.deletingIds = _this6.deletingIds.filter(function (id) {
	          return id !== row.id;
	        });
	        _eventbus2.default.toast = { text: 'Kunne ikke slette linjen', success: false, position: 'bottomLeft' };
	      });
	    },
	    onSelectViewTab: function onSelectViewTab(tab) {
	      this.viewTab = tab;
	
	      if ((tab === 'outbox' || tab === 'sent') && !this.isLoadingOutbox) {
	        this.loadOutbox();
	      }
	    },
	    loadOutbox: function loadOutbox() {
	      var _this7 = this;
	
	      if (this.isLoadingOutbox) return;
	      this.isLoadingOutbox = true;
	      this.hasLoadedOutbox = true;
	
	      _docendo2.default.listRecurringPaymentsOutbox(this.schoolId, null, function (success) {
	        var list = Array.isArray(success) ? success : success && Array.isArray(success.data) ? success.data : [];
	        _this7.outboxRows = list.map(function (rec, i) {
	          return (0, _assign2.default)({}, rec, {
	            vRowKey: rec.id != null ? 'id_' + rec.id : 'idx_' + i
	          });
	        });
	        _this7.isLoadingOutbox = false;
	      }, function (failure) {
	        console.log('Kunne ikke hente udbakke', failure);
	        _this7.outboxRows = [];
	        _this7.isLoadingOutbox = false;
	        _eventbus2.default.toast = { text: 'Kunne ikke hente udbakken', success: false, position: 'bottomLeft' };
	      });
	    },
	    dataToOutboxExcel: function dataToOutboxExcel() {
	      var _this8 = this;
	
	      return this.currentOutboxRows.map(function (row) {
	        var createdBy = '—';
	        if (row.vCreatedByName) {
	          createdBy = row.vCreatedByName;
	        } else if (row.vCreatedById != null) {
	          createdBy = 'Tidligere ansat';
	        }
	        return {
	          created_at: row.vCreatedAt || '',
	          user: row.vUserName || '',
	          employment: row.vEmploymentLabel || '',
	          loenkode: row.vLoenart || '',
	          antal: _this8.formatDecimal(row.antal),
	          beloeb: _this8.formatDecimal(row.beloeb),
	          fra: row.vFraDato || '',
	          til: row.vTilDato || '',
	          operation: _this8.operationLabel(row.operation) || '',
	          created_by: createdBy,
	          state: _this8.stateLabel(row) || ''
	        };
	      });
	    },
	    downloadOutboxExcel: function downloadOutboxExcel() {
	      var _this9 = this;
	
	      if (this.isDownloadingOutbox || this.currentOutboxRows.length === 0) return;
	      this.isDownloadingOutbox = true;
	      if (window.XLSX && XLSX) {
	        this.writeOutboxExcel();
	      } else {
	        var cdnXLSX = document.createElement('script');
	        cdnXLSX.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.mini.min.js');
	        document.head.appendChild(cdnXLSX);
	        var intervalTimer = setInterval(function (_) {
	          if (window.XLSX) {
	            clearInterval(intervalTimer);
	            XLSX = window.XLSX;
	            _this9.writeOutboxExcel();
	          }
	        }, 500);
	      }
	    },
	    writeOutboxExcel: function writeOutboxExcel() {
	      var headers = {
	        created_at: 'Oprettet',
	        user: 'Navn',
	        employment: 'Ansættelse',
	        loenkode: 'Lønkode',
	        antal: 'Enheder',
	        beloeb: 'Beløb',
	        fra: 'Fra',
	        til: 'Til',
	        operation: 'Handling',
	        created_by: 'Oprettet af',
	        state: 'Status'
	      };
	      var rows = this.dataToOutboxExcel();
	      rows.unshift(headers);
	      var sheet = XLSX.utils.json_to_sheet(rows, { skipHeader: true });
	      var wb = XLSX.utils.book_new();
	      XLSX.utils.book_append_sheet(wb, sheet, 'data');
	      var label = this.viewTab === 'sent' ? 'afsendte' : 'udbakke';
	      var timestamp = (0, _moment2.default)().format('YYYY-MM-DD_HH-mm');
	      XLSX.writeFile(wb, 'faste_tillaeg_' + label + '_' + timestamp + '.xlsx');
	      this.isDownloadingOutbox = false;
	    },
	    formatDecimal: function formatDecimal(value) {
	      if (value == null || value === '') return '';
	      var num = Number(value);
	      if (isNaN(num)) return String(value).replace('.', ',');
	      return num.toFixed(2).replace('.', ',');
	    },
	    operationLabel: function operationLabel(operation) {
	      var map = { create: 'Opret', delimit: 'Afgræns', delete: 'Slet' };
	      return map[operation] || operation || '';
	    },
	    stateLabel: function stateLabel(row) {
	      var map = { new: 'Afventer', sent: 'Sendt', failed: 'Fejlet', read: 'Læst' };
	      return map[row.state] || row.state || '';
	    },
	    statePillClass: function statePillClass(row) {
	      if (row.state === 'failed') return 'do-pill--red';
	      if (row.state === 'sent') return 'do-pill--green';
	      return 'do-pill--yellow';
	    },
	    resultMessages: function resultMessages(row) {
	      var result = row.result;
	      if (!result || (typeof result === 'undefined' ? 'undefined' : (0, _typeof3.default)(result)) !== 'object') return [];
	      var list = Array.isArray(result.Meddelelser) ? result.Meddelelser : [];
	      return list.map(function (m) {
	        return { code: m.Kode, type: m.Type, text: m.Tekst || '' };
	      }).filter(function (m) {
	        return m.text;
	      });
	    },
	    persistFilters: function persistFilters(val) {
	      try {
	        window.localStorage.setItem(this.storageKey, val);
	      } catch (e) {}
	    },
	    restoreFilters: function restoreFilters() {
	      try {
	        var raw = window.localStorage.getItem(this.storageKey);
	        if (!raw) return;
	        var saved = JSON.parse(raw);
	        if (!saved) return;
	        if (saved.viewTab) this.viewTab = saved.viewTab;
	        if (Array.isArray(saved.selectedNames)) this.selectedNames = saved.selectedNames;
	        if (Array.isArray(saved.selectedTags)) this.selectedTags = saved.selectedTags;
	        if (Array.isArray(saved.selectedEmploymentTitles)) this.selectedEmploymentTitles = saved.selectedEmploymentTitles;
	        if (Array.isArray(saved.selectedOrganisations)) this.selectedOrganisations = saved.selectedOrganisations;
	      } catch (e) {}
	    }
	  },
	  watch: {
	    filtersSnapshot: function filtersSnapshot(val) {
	      this.persistFilters(val);
	    },
	    selectedEmploymentIds: function selectedEmploymentIds(ids) {
	      if (!ids || ids.length === 0) {
	        this.isBatchMode = false;
	      }
	    }
	  },
	  created: function created() {
	    this.restoreFilters();
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('readEmployments');
	    this.$store.dispatch('readSalaryCodes');
	
	    this.loadOutbox();
	  }
	};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'FasteTillaegModal',
	  components: { DModal: _DModal2.default, DateSelector: _DateSelector2.default, DSelect: _DSelect2.default, DDropdown: _DDropdown2.default, Loader: _Loader2.default },
	  props: {
	    schoolId: {
	      type: Number,
	      required: true
	    },
	    employmentId: {
	      required: true
	    },
	    employment: {
	      default: null
	    },
	    userName: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      payments: [],
	      kmdPayments: [],
	      rowToStop: null,
	      stopDate: null,
	      rowToExtend: null,
	      extendDate: null,
	      rowToDelete: null,
	      actionError: '',
	      isSubmittingAction: false,
	      isShowCreate: false,
	      isCreating: false,
	      createValidationMessage: '',
	      createForm: {
	        salaryCodeId: null,
	        antal: '',
	        beloeb: '',
	        salaryCostCenterId: null,
	        startdato: null,
	        stopdato: null,
	        noEndDate: false
	      }
	    };
	  },
	
	  computed: {
	    employmentLabel: function employmentLabel() {
	      var e = this.employment;
	      if (!e) return '';
	      var title = e.source_title || e.title || 'Ansættelse';
	      return e.employment_number ? e.employment_number + ' - ' + title : title;
	    },
	    schoolYearStartDate: function schoolYearStartDate() {
	      var year = this.$store.state.localActivatedSchoolYear;
	      var firstOfNextMonth = (0, _moment2.default)().add(1, 'month').startOf('month');
	      if (year && year.employee_time_start) {
	        var start = (0, _moment2.default)(year.employee_time_start);
	
	        return start.isBefore((0, _moment2.default)(), 'day') ? firstOfNextMonth : start;
	      }
	      return firstOfNextMonth;
	    },
	    schoolYearEndDate: function schoolYearEndDate() {
	      var year = this.$store.state.localActivatedSchoolYear;
	      if (year && year.employee_time_end) {
	        return (0, _moment2.default)(year.employee_time_end);
	      }
	      return (0, _moment2.default)().add(1, 'year');
	    },
	    stopMaxDate: function stopMaxDate() {
	      return this.rowToStop && this.rowToStop.stopdato ? (0, _moment2.default)(this.rowToStop.stopdato).subtract(1, 'day') : null;
	    },
	    extendMinDate: function extendMinDate() {
	      return this.rowToExtend && this.rowToExtend.stopdato ? (0, _moment2.default)(this.rowToExtend.stopdato).add(1, 'day') : null;
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted || [];
	    },
	    salaryCodesByLoenkode: function salaryCodesByLoenkode() {
	      var map = {};
	      for (var i = 0; i < this.salaryCodes.length; i++) {
	        var code = this.salaryCodes[i];
	        if (code.loenart) map[String(code.loenart)] = code;
	      }
	      return map;
	    },
	    salaryCodesForDSelect: function salaryCodesForDSelect() {
	      return this.salaryCodes.filter(function (sc) {
	        return sc.loenart;
	      }).map(function (sc) {
	        var value = String(sc.loenart);
	        var name = sc.name || '';
	        return {
	          id: sc.id,
	          name: value + (name ? ' - ' + name : ''),
	          value: value,
	          original: sc
	        };
	      });
	    },
	    selectedSalaryCodeForDSelect: function selectedSalaryCodeForDSelect() {
	      var _this = this;
	
	      if (this.createForm.salaryCodeId == null) return [];
	      var found = this.salaryCodesForDSelect.find(function (item) {
	        return item.id === _this.createForm.salaryCodeId;
	      });
	      return found ? [found] : [];
	    },
	    costCenters: function costCenters() {
	      return this.$store.getters.costCenters || [];
	    },
	    costCentersForDSelect: function costCentersForDSelect() {
	      return this.costCenters.map(function (cc) {
	        var code = cc.code != null ? String(cc.code) : '';
	        var title = cc.title || cc.name || '';
	        return {
	          id: cc.id,
	          name: code + (title ? ' - ' + title : ''),
	          value: code,
	          original: cc
	        };
	      });
	    },
	    selectedCostCenterForDSelect: function selectedCostCenterForDSelect() {
	      var _this2 = this;
	
	      if (this.createForm.salaryCostCenterId == null) return [];
	      var found = this.costCentersForDSelect.find(function (item) {
	        return item.id === _this2.createForm.salaryCostCenterId;
	      });
	      return found ? [found] : [];
	    },
	    displayedPayments: function displayedPayments() {
	      var _this3 = this;
	
	      return this.payments.map(function (item) {
	        var loenkode = _this3.loenkodeForRow(item);
	        var salaryCode = loenkode ? _this3.salaryCodesByLoenkode[loenkode] : null;
	        var codeName = salaryCode && salaryCode.name || item.loenart_tekst || '';
	        var vLoenart = codeName ? loenkode ? loenkode + ' - ' + codeName : codeName : loenkode || '—';
	        return (0, _extends3.default)({}, item, {
	          vLoenart: vLoenart,
	          vFraDato: item.startdato ? (0, _moment2.default)(item.startdato).format('DD-MM-YYYY') : '',
	          vTilDato: item.stopdato ? (0, _moment2.default)(item.stopdato).format('DD-MM-YYYY') : ''
	        });
	      });
	    },
	    isCreateValid: function isCreateValid() {
	      var hasLoenkode = this.createForm.salaryCodeId != null;
	      var antal = parseFloat(String(this.createForm.antal).replace(',', '.'));
	      var hasAntal = !isNaN(antal) && antal > 0 && antal <= 9999;
	      var hasStart = !!this.createForm.startdato && (0, _moment2.default)(this.createForm.startdato).isValid();
	      var hasStop = !!this.createForm.stopdato && (0, _moment2.default)(this.createForm.stopdato).isValid();
	      var stopAfterStart = hasStart && hasStop && (0, _moment2.default)(this.createForm.stopdato).isSameOrAfter((0, _moment2.default)(this.createForm.startdato));
	      return hasLoenkode && hasAntal && hasStart && hasStop && stopAfterStart && this.beloebValid;
	    },
	    beloebValid: function beloebValid() {
	      if (this.createForm.beloeb === '' || this.createForm.beloeb == null) return true;
	      var beloeb = parseFloat(String(this.createForm.beloeb).replace(',', '.'));
	      return !isNaN(beloeb) && Math.abs(beloeb) <= 99999.99;
	    },
	    openEndedDateLabel: function openEndedDateLabel() {
	      return (0, _moment2.default)('9999-12-31').format('DD-MM-YYYY');
	    },
	    selectedLoenkode: function selectedLoenkode() {
	      var sel = this.selectedSalaryCodeForDSelect;
	      return sel.length ? String(sel[0].value) : '';
	    },
	    createOverlapWarning: function createOverlapWarning() {
	      var _this4 = this;
	
	      var loenkode = this.selectedLoenkode;
	      if (!loenkode || !this.createForm.startdato || !this.createForm.stopdato) return '';
	      var newStart = (0, _moment2.default)(this.createForm.startdato);
	      var newStop = (0, _moment2.default)(this.createForm.stopdato);
	      var conflict = this.kmdPayments.find(function (p) {
	        if (_this4.loenkodeForRow(p) !== loenkode) return false;
	        if (!p.startdato || !p.stopdato) return false;
	        return newStart.isSameOrBefore((0, _moment2.default)(p.stopdato)) && newStop.isSameOrAfter((0, _moment2.default)(p.startdato));
	      });
	      if (!conflict) return '';
	      var fra = conflict.startdato ? (0, _moment2.default)(conflict.startdato).format('DD-MM-YYYY') : '';
	      var til = conflict.stopdato ? (0, _moment2.default)(conflict.stopdato).format('DD-MM-YYYY') : '';
	      return 'Der findes allerede et tillæg med lønkode ' + loenkode + ' i perioden ' + fra + ' – ' + til + '. KMD tillader kun ét tillæg pr. lønart/løbenummer i en overlappende periode, så dette vil sandsynligvis blive afvist.';
	    }
	  },
	  methods: {
	    formatDecimal: function formatDecimal(value) {
	      if (value == null || value === '') return '';
	      return String(value).replace('.', ',');
	    },
	    onSelectLoenkode: function onSelectLoenkode(item) {
	      this.createForm.salaryCodeId = item ? item.id : null;
	    },
	    onSelectCostCenter: function onSelectCostCenter(item) {
	      this.createForm.salaryCostCenterId = item ? item.id : null;
	    },
	    onToggleNoEndDate: function onToggleNoEndDate() {
	      if (this.createForm.noEndDate) {
	        this.createForm.stopdato = (0, _moment2.default)('9999-12-31');
	      } else {
	        this.createForm.stopdato = this.schoolYearEndDate;
	      }
	    },
	    loenkodeForRow: function loenkodeForRow(item) {
	      if (item.loenart == null) return '';
	      var loenart = String(item.loenart).padStart(3, '0');
	      var loebenummer = item.loebenummer != null ? String(item.loebenummer) : '0';
	      return loenart + loebenummer;
	    },
	    openCreate: function openCreate() {
	      var _this5 = this;
	
	      this.createForm.startdato = this.schoolYearStartDate;
	      this.createForm.stopdato = this.schoolYearEndDate;
	      this.createForm.noEndDate = false;
	      this.isShowCreate = true;
	
	      _docendo2.default.listRecurringPayments(this.schoolId, this.employmentId, function (success) {
	        _this5.kmdPayments = Array.isArray(success) ? success : success && Array.isArray(success.data) ? success.data : [];
	      }, function () {});
	      this.$nextTick(function () {
	        setTimeout(function () {
	          if (_this5.$refs.loenkodeSelect) _this5.$refs.loenkodeSelect.setFocus();
	        }, 100);
	      });
	    },
	    closeCreate: function closeCreate() {
	      this.isShowCreate = false;
	      this.createValidationMessage = '';
	      this.createForm.salaryCodeId = null;
	      this.createForm.antal = '';
	      this.createForm.beloeb = '';
	      this.createForm.salaryCostCenterId = null;
	      this.createForm.noEndDate = false;
	    },
	    read: function read() {
	      var _this6 = this;
	
	      this.isLoading = true;
	      _docendo2.default.listRecurringPayments(this.schoolId, this.employmentId, function (success) {
	        var list = Array.isArray(success) ? success : success && Array.isArray(success.data) ? success.data : [];
	        _this6.payments = list;
	        _this6.kmdPayments = list;
	        _this6.isLoading = false;
	      }, function (failure) {
	        console.log('Kunne ikke hente faste tillæg', failure);
	        _this6.payments = [];
	        _this6.isLoading = false;
	        _eventbus2.default.toast = { text: 'Kunne ikke hente faste tillæg', success: false, position: 'bottomLeft' };
	      });
	    },
	    closeAction: function closeAction() {
	      this.rowToStop = null;
	      this.rowToExtend = null;
	      this.rowToDelete = null;
	      this.actionError = '';
	    },
	    errorFromResponse: function errorFromResponse(resp) {
	      if (!resp) return null;
	      var isError = resp.status === 'error' || resp.error === true || resp.success === false || !!resp.error_code;
	      if (!isError) return null;
	      var code = resp.code || resp.error_code || resp.status_code;
	      var message = typeof resp.error === 'string' ? resp.error : resp.message || '';
	      if (String(code) === '138' || /\b138\b/.test(String(message)) || /låst/i.test(String(message))) {
	        return 'Læreren er låst i lønsystemet. Vent ca. 15 minutter og prøv igen.';
	      }
	      return message || 'Noget gik galt. Prøv igen eller kontakt support.';
	    },
	    openStop: function openStop(row) {
	      this.closeAction();
	      this.rowToStop = row;
	      var isOpenEnded = !row.stopdato || row.stopdato === '9999-12-31';
	      var maxDate = isOpenEnded ? null : (0, _moment2.default)(row.stopdato).subtract(1, 'day');
	      var dflt = this.schoolYearEndDate;
	      if (maxDate && dflt.isAfter(maxDate)) dflt = maxDate;
	      this.stopDate = dflt;
	    },
	    submitStop: function submitStop() {
	      var _this7 = this;
	
	      if (!this.rowToStop || this.isSubmittingAction || !this.stopDate) return;
	      this.actionError = '';
	      this.isSubmittingAction = true;
	      var stopDate = (0, _moment2.default)(this.stopDate).format('YYYY-MM-DD');
	      var row = this.rowToStop;
	      var startDate = row.startdato ? (0, _moment2.default)(row.startdato).format('YYYY-MM-DD') : stopDate;
	      _docendo2.default.delimitRecurringPayment(this.schoolId, this.employmentId, row.objekt_id, startDate, stopDate, function (success) {
	        var errorMessage = _this7.errorFromResponse(success);
	        if (errorMessage) {
	          _this7.isSubmittingAction = false;
	          _this7.actionError = errorMessage;
	          return;
	        }
	        _this7.queuedAction('Stop sendt til behandling. Følg status under "Udbakke".');
	      }, function (failure) {
	        console.log('failure', failure);
	        _this7.isSubmittingAction = false;
	        _this7.actionError = 'Noget gik galt. Prøv igen eller kontakt support.';
	      });
	    },
	    openExtend: function openExtend(row) {
	      this.closeAction();
	      this.rowToExtend = row;
	      var minDate = (0, _moment2.default)(row.stopdato).add(1, 'day');
	      this.extendDate = this.schoolYearEndDate.isAfter(minDate) ? this.schoolYearEndDate : minDate.clone().add(1, 'year');
	    },
	    submitExtend: function submitExtend() {
	      var _this8 = this;
	
	      if (!this.rowToExtend || this.isSubmittingAction || !this.extendDate) return;
	      this.actionError = '';
	      var row = this.rowToExtend;
	      var startdato = (0, _moment2.default)(row.stopdato).add(1, 'day').format('YYYY-MM-DD');
	      var stopdato = (0, _moment2.default)(this.extendDate).format('YYYY-MM-DD');
	      var recurringPayment = {
	        startdato: startdato,
	        stopdato: stopdato,
	        loenart: String(row.loenart != null ? row.loenart : '').trim(),
	        loebenummer: row.loebenummer != null ? parseInt(row.loebenummer, 10) : 1
	      };
	      if (row.antal != null && row.antal !== '') {
	        recurringPayment.antal = parseFloat(String(row.antal).replace(',', '.'));
	      }
	      if (row.beloeb != null && row.beloeb !== '') {
	        recurringPayment.beloeb = parseFloat(String(row.beloeb).replace(',', '.'));
	      }
	      this.isSubmittingAction = true;
	      _docendo2.default.createRecurringPaymentForEmployees(this.schoolId, [this.employmentId], recurringPayment, function (success) {
	        var errorMessage = _this8.errorFromResponse(success);
	        if (errorMessage) {
	          _this8.isSubmittingAction = false;
	          _this8.actionError = errorMessage;
	          return;
	        }
	        _this8.queuedAction('Forlængelse sendt til behandling. Følg status under "Udbakke".');
	      }, function (failure) {
	        console.log('failure', failure);
	        _this8.isSubmittingAction = false;
	        _this8.actionError = 'Noget gik galt. Prøv igen eller kontakt support.';
	      });
	    },
	    openDelete: function openDelete(row) {
	      this.closeAction();
	      this.rowToDelete = row;
	    },
	    submitDelete: function submitDelete() {
	      var _this9 = this;
	
	      if (!this.rowToDelete || this.isSubmittingAction) return;
	      this.actionError = '';
	      this.isSubmittingAction = true;
	      var row = this.rowToDelete;
	      var startDate = row.startdato ? (0, _moment2.default)(row.startdato).format('YYYY-MM-DD') : null;
	      var stopDate = row.stopdato ? (0, _moment2.default)(row.stopdato).format('YYYY-MM-DD') : null;
	      _docendo2.default.deleteRecurringPayment(this.schoolId, this.employmentId, row.objekt_id, startDate, stopDate, function (success) {
	        var errorMessage = _this9.errorFromResponse(success);
	        if (errorMessage) {
	          _this9.isSubmittingAction = false;
	          _this9.actionError = errorMessage;
	          return;
	        }
	        _this9.queuedAction('Sletning sendt til behandling. Følg status under "Udbakke".');
	      }, function (failure) {
	        console.log('failure', failure);
	        _this9.isSubmittingAction = false;
	        _this9.actionError = 'Noget gik galt. Prøv igen eller kontakt support.';
	      });
	    },
	    queuedAction: function queuedAction(message) {
	      this.isSubmittingAction = false;
	      this.closeAction();
	      _eventbus2.default.toast = { text: message, success: true, position: 'bottomLeft' };
	      this.$emit('changed');
	      this.read();
	    },
	    submitCreate: function submitCreate() {
	      var _this10 = this;
	
	      this.createValidationMessage = '';
	      var antalValue = parseFloat(String(this.createForm.antal).replace(',', '.'));
	      if (!isNaN(antalValue) && antalValue > 9999) {
	        this.createValidationMessage = 'Antal må højst være 9.999';
	        return;
	      }
	      if (!this.beloebValid) {
	        this.createValidationMessage = 'Beløb må højst være 99.999,99';
	        return;
	      }
	      if (!this.isCreateValid) {
	        this.createValidationMessage = 'Udfyld lønkode, antal og gyldige datoer';
	        return;
	      }
	
	      this.isCreating = true;
	      var recurringPayment = {
	        startdato: (0, _moment2.default)(this.createForm.startdato).format('YYYY-MM-DD'),
	        stopdato: (0, _moment2.default)(this.createForm.stopdato).format('YYYY-MM-DD'),
	        salary_code_id: this.createForm.salaryCodeId,
	        antal: parseFloat(String(this.createForm.antal).replace(',', '.'))
	      };
	      if (this.createForm.beloeb !== '' && this.createForm.beloeb != null) {
	        recurringPayment.beloeb = parseFloat(String(this.createForm.beloeb).replace(',', '.'));
	      }
	      if (this.createForm.salaryCostCenterId != null) {
	        recurringPayment.salary_cost_center_id = this.createForm.salaryCostCenterId;
	      }
	
	      _docendo2.default.createRecurringPaymentForEmployees(this.schoolId, [this.employmentId], recurringPayment, function (success) {
	        var errorMessage = _this10.errorFromResponse(success);
	        if (errorMessage) {
	          _this10.isCreating = false;
	          _this10.createValidationMessage = errorMessage;
	          return;
	        }
	        _this10.isCreating = false;
	        _this10.closeCreate();
	        _eventbus2.default.toast = { text: 'Sendt til behandling. Følg status under "Udbakke".', success: true, position: 'bottomLeft' };
	        _this10.$emit('changed');
	        _this10.read();
	      }, function (failure) {
	        console.log('failure', failure);
	        _this10.isCreating = false;
	        _this10.createValidationMessage = 'Noget gik galt. Prøv igen eller kontakt support.';
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('readSalaryCodes');
	    this.$store.dispatch('readCostCenters');
	    this.read();
	  }
	};

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DoDatePickerRange = __webpack_require__(44);
	
	var _DoDatePickerRange2 = _interopRequireDefault(_DoDatePickerRange);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GENERIC_ERROR = 'Kunne ikke hente fravær fra KMD Opus. Prøv igen eller kontakt support.';
	var NOT_FOUND_ERROR = 'Ansættelsen findes ikke som aktiv Opus-ansættelse, så fraværet kan ikke hentes fra KMD Opus.';
	var MAX_RANGE_DAYS = 731;
	
	function normalizeCode(value) {
	  return value == null ? '' : String(value).trim().toLowerCase();
	}
	
	function periodsOverlap(aStart, aEnd, bStart, bEnd) {
	  var startsBeforeEnd = aStart === '' || bEnd === '' || aStart <= bEnd;
	  var endsAfterStart = aEnd === '' || bStart === '' || aEnd >= bStart;
	  return startsBeforeEnd && endsAfterStart;
	}
	
	function isOpenEndedTransfer(transfer) {
	  return !!transfer.ongoing || !transfer.to_date || String(transfer.to_date).indexOf('9999') === 0;
	}
	
	function defaultPeriod(transfer) {
	  var start = (0, _moment2.default)().subtract(1, 'month').startOf('day');
	  var end = (0, _moment2.default)().add(1, 'year').endOf('day');
	  if (transfer && transfer.from_date && (0, _moment2.default)(transfer.from_date).isValid()) {
	    var transferStart = (0, _moment2.default)(transfer.from_date).startOf('day');
	    if (transferStart.isBefore(start)) start = transferStart;
	    if (!isOpenEndedTransfer(transfer) && (0, _moment2.default)(transfer.to_date).isValid()) {
	      var transferEnd = (0, _moment2.default)(transfer.to_date).endOf('day');
	      if (transferEnd.isAfter(end)) end = transferEnd;
	    }
	  }
	  if (end.diff(start, 'days') >= MAX_RANGE_DAYS) {
	    end = (0, _moment2.default)(start).add(MAX_RANGE_DAYS - 1, 'days').endOf('day');
	  }
	  return { start: start, end: end };
	}
	
	exports.default = {
	  name: 'KmdOpusAbsenceModal',
	  components: { DModal: _DModal2.default, DoDatePickerRange: _DoDatePickerRange2.default, Loader: _Loader2.default },
	  props: {
	    employmentId: {
	      type: [Number, String],
	      required: true
	    },
	    userName: {
	      type: String,
	      default: ''
	    },
	    employmentLabel: {
	      type: String,
	      default: ''
	    },
	
	    transfer: {
	      type: Object,
	      default: null
	    },
	
	    absenceTypeCode: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    var period = defaultPeriod(this.transfer);
	    return {
	      startDate: period.start,
	      endDate: period.end,
	      maximumDateRange: MAX_RANGE_DAYS,
	      kmdAbsence: [],
	      isLoading: false,
	      hasLoaded: false,
	      errorMessage: '',
	      loadedFromDate: '',
	      loadedToDate: '',
	      requestId: 0
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    fromDate: function fromDate() {
	      return (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	    },
	    toDate: function toDate() {
	      return (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	    },
	    isPeriodChanged: function isPeriodChanged() {
	      return this.fromDate !== this.loadedFromDate || this.toDate !== this.loadedToDate;
	    },
	    loadedPeriodLabel: function loadedPeriodLabel() {
	      if (!this.loadedFromDate || !this.loadedToDate) return '';
	      return this.formatDate(this.loadedFromDate) + ' - ' + this.formatDate(this.loadedToDate);
	    },
	    dateShortCuts: function dateShortCuts() {
	      var today = (0, _moment2.default)();
	      return [{ title: 'Standard (1 md. tilbage - 1 år frem)', startDate: (0, _moment2.default)(today).subtract(1, 'month').startOf('day'), endDate: (0, _moment2.default)(today).add(1, 'year').endOf('day') }, { title: 'Denne måned', startDate: (0, _moment2.default)(today).startOf('month'), endDate: (0, _moment2.default)(today).endOf('month') }, { title: 'Seneste 3 måneder', startDate: (0, _moment2.default)(today).subtract(3, 'months').startOf('day'), endDate: (0, _moment2.default)(today).endOf('day') }, { title: 'Dette år', startDate: (0, _moment2.default)(today).startOf('year'), endDate: (0, _moment2.default)(today).endOf('year') }];
	    },
	    rows: function rows() {
	      var _this = this;
	
	      var rows = this.kmdAbsence.map(function (item, idx) {
	        var start = _this.parseDate(item.kmd_start_date);
	
	        var endRaw = item.kmd_end_date || '';
	        var isOpenEnded = endRaw.indexOf('9999') === 0;
	        var end = isOpenEnded ? null : _this.parseDate(endRaw);
	        var startTime = _this.formatTime(item.kmd_start_time);
	        var isOverlap = _this.isTransferOverlap(start ? start.format('YYYY-MM-DD') : '', end ? end.format('YYYY-MM-DD') : '');
	        var isMatch = isOverlap && _this.isSameTypeAsTransfer(item.kmd_absence_attendance_type);
	        return {
	          key: [item.kmd_object_id, item.kmd_record_number, item.kmd_external_id, idx].join('-'),
	          typeText: item.kmd_absence_attendance_type_text || '',
	          typeCode: item.kmd_absence_attendance_type || '',
	          vStartDate: start ? start.format('DD-MM-YYYY') : item.kmd_start_date || '',
	          vEndDate: isOpenEnded ? 'Løbende' : end ? end.format('DD-MM-YYYY') : endRaw,
	          vTime: _this.formatTimeRange(item.kmd_start_time, item.kmd_end_time),
	          days: item.kmd_absence_attendance_days,
	          hours: item.kmd_absence_attendance_hours,
	          calendarDays: item.kmd_absence_attendance_calendar_days,
	
	          isFromDocendo: !!item.event_serial_id,
	
	          isMatch: isMatch,
	          isOtherTypeOverlap: isOverlap && !isMatch,
	          sortKey: (start ? start.format('YYYY-MM-DD') : '0000-00-00') + ' ' + (startTime || '00:00')
	        };
	      });
	      return rows.sort(function (a, b) {
	        if (a.sortKey === b.sortKey) return 0;
	        return a.sortKey < b.sortKey ? -1 : 1;
	      });
	    },
	    transferStartKey: function transferStartKey() {
	      return this.transfer ? this.toDateKey(this.transfer.from_date) : '';
	    },
	    transferIsOpenEnded: function transferIsOpenEnded() {
	      return this.transfer ? isOpenEndedTransfer(this.transfer) : false;
	    },
	    transferEndKey: function transferEndKey() {
	      return this.transfer && !this.transferIsOpenEnded ? this.toDateKey(this.transfer.to_date) : '';
	    },
	    transferTypeCode: function transferTypeCode() {
	      return normalizeCode(this.absenceTypeCode);
	    },
	    transferTypeText: function transferTypeText() {
	      return this.transfer ? this.transfer.vAbsenceTypeText || '' : '';
	    },
	    transferStartLabel: function transferStartLabel() {
	      return this.transfer ? this.transfer.vStartDate || '' : '';
	    },
	    transferEndLabel: function transferEndLabel() {
	      if (!this.transfer) return '';
	      return this.transfer.ongoing ? 'Åbenstående' : this.transfer.vEndDate || '';
	    },
	    transferMessages: function transferMessages() {
	      var errors = this.transfer && this.transfer.error;
	      return Array.isArray(errors) ? errors.filter(function (msg) {
	        return msg && msg.MessageText;
	      }) : [];
	    },
	    matchCount: function matchCount() {
	      return this.rows.filter(function (row) {
	        return row.isMatch;
	      }).length;
	    },
	    isLoadedPeriodCoveringTransfer: function isLoadedPeriodCoveringTransfer() {
	      if (!this.transferStartKey || !this.loadedFromDate || !this.loadedToDate) return true;
	      if (this.loadedFromDate > this.transferStartKey) return false;
	      if (this.transferIsOpenEnded || !this.transferEndKey) return this.loadedToDate >= this.transferStartKey;
	      return this.loadedToDate >= this.transferEndKey;
	    },
	    otherTypeOverlapRows: function otherTypeOverlapRows() {
	      return this.rows.filter(function (row) {
	        return row.isOtherTypeOverlap;
	      });
	    },
	    otherTypeOverlapCount: function otherTypeOverlapCount() {
	      return this.otherTypeOverlapRows.length;
	    },
	    otherTypeOverlapCodes: function otherTypeOverlapCodes() {
	      var seen = {};
	      var codes = [];
	      this.otherTypeOverlapRows.forEach(function (row) {
	        var code = row.typeCode ? String(row.typeCode).trim() : '';
	        var key = normalizeCode(code);
	        if (seen[key]) return;
	        seen[key] = true;
	        codes.push(code || 'ukendt kode');
	      });
	      return codes.join(', ');
	    },
	    matchStatus: function matchStatus() {
	      if (!this.transfer || this.isLoading || !this.hasLoaded || this.errorMessage) return '';
	      if (!this.transferTypeCode) return 'unknown_type';
	      if (this.matchCount > 0) return 'match';
	      if (this.otherTypeOverlapCount > 0) return 'other_type';
	      if (!this.isLoadedPeriodCoveringTransfer) return 'not_covered';
	      return 'no_match';
	    },
	    hasTimes: function hasTimes() {
	      return this.rows.some(function (row) {
	        return !!row.vTime;
	      });
	    }
	  },
	  methods: {
	    readKmdAbsence: function readKmdAbsence() {
	      var _this2 = this;
	
	      if (this.isLoading) return;
	      this.requestId += 1;
	      var requestId = this.requestId;
	      var fromDate = this.fromDate;
	      var toDate = this.toDate;
	      this.isLoading = true;
	      this.errorMessage = '';
	
	      _docendo2.default.listKmdOpusAbsenceForEmployment(this.schoolId, this.employmentId, fromDate, toDate, function (list) {
	        if (requestId !== _this2.requestId) return;
	        _this2.loadedFromDate = fromDate;
	        _this2.loadedToDate = toDate;
	        if (Array.isArray(list)) {
	          _this2.kmdAbsence = list;
	          _this2.errorMessage = '';
	        } else {
	          console.error('api.kmd_absence.index: uventet svar', list);
	          _this2.kmdAbsence = [];
	          _this2.errorMessage = GENERIC_ERROR;
	        }
	        _this2.isLoading = false;
	        _this2.hasLoaded = true;
	      }, function (failure) {
	        if (requestId !== _this2.requestId) return;
	        var rawError = failure && failure.error ? String(failure.error) : '';
	
	        console.error('api.kmd_absence.index fejlede:', rawError || failure);
	        _this2.loadedFromDate = fromDate;
	        _this2.loadedToDate = toDate;
	        _this2.kmdAbsence = [];
	        _this2.errorMessage = /RecordNotFound|Couldn't find/i.test(rawError) ? NOT_FOUND_ERROR : GENERIC_ERROR;
	        _this2.isLoading = false;
	        _this2.hasLoaded = true;
	      });
	    },
	    isTransferOverlap: function isTransferOverlap(startKey, endKey) {
	      if (!this.transfer) return false;
	      return periodsOverlap(startKey, endKey, this.transferStartKey, this.transferEndKey);
	    },
	    isSameTypeAsTransfer: function isSameTypeAsTransfer(kmdTypeCode) {
	      if (!this.transferTypeCode) return false;
	      return normalizeCode(kmdTypeCode) === this.transferTypeCode;
	    },
	    toDateKey: function toDateKey(value) {
	      if (!value) return '';
	      var date = (0, _moment2.default)(value);
	      return date.isValid() ? date.format('YYYY-MM-DD') : '';
	    },
	    parseDate: function parseDate(value) {
	      var str = value == null ? '' : String(value).trim();
	      if (str === '') return null;
	      var date = (0, _moment2.default)(str, ['YYYY-MM-DD', 'YYYYMMDD', _moment2.default.ISO_8601], true);
	      return date.isValid() ? date : null;
	    },
	    formatDate: function formatDate(value) {
	      var date = this.parseDate(value);
	      return date ? date.format('DD-MM-YYYY') : value || '';
	    },
	    formatTime: function formatTime(value) {
	      var str = value == null ? '' : String(value).trim();
	      if (str === '') return '';
	      var time = (0, _moment2.default)(str, ['HH:mm:ss', 'HH:mm', 'HHmmss'], true);
	      return time.isValid() ? time.format('HH:mm') : str;
	    },
	    formatTimeRange: function formatTimeRange(startTime, endTime) {
	      var start = this.formatTime(startTime);
	      var end = this.formatTime(endTime);
	      if ((!start || start === '00:00') && (!end || end === '00:00')) return '';
	      if (start && end) return start + ' - ' + end;
	      return start || end;
	    },
	    formatDecimal: function formatDecimal(value) {
	      var str = value == null ? '' : String(value).trim();
	      if (str === '') return '';
	      var num = Number(str.replace(',', '.'));
	      if (isNaN(num)) return str;
	      var formatted = num % 1 === 0 ? String(num) : num.toFixed(2);
	      return formatted.replace('.', ',');
	    }
	  },
	  mounted: function mounted() {
	    this.readKmdAbsence();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.requestId += 1;
	  }
	};

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(28);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _promise = __webpack_require__(51);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _isFinite = __webpack_require__(85);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _DSelectUsers = __webpack_require__(67);
	
	var _DSelectUsers2 = _interopRequireDefault(_DSelectUsers);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CHUNK_SIZE = 10;
	var XLSX = null;
	
	exports.default = {
	  name: 'KmdQuotasModal',
	  components: { DModal: _DModal2.default, DoFiltersFilter: _DoFiltersFilter2.default, DSelectUsers: _DSelectUsers2.default, DateSelector: _DateSelector2.default, Loader: _Loader2.default },
	  data: function data() {
	    return {
	      allRows: [],
	      isLoading: false,
	      hasLoaded: false,
	      fetchGeneration: 0,
	      errorMessage: '',
	      warningMessage: '',
	      loadedCount: 0,
	      totalCount: 0,
	      selectedUserIds: [],
	      selectAll: false,
	      selectedDate: (0, _moment2.default)(),
	      selectedQuotaTypes: [],
	      sortBy: 'userName',
	      sortDir: 'asc',
	      isDownloadingExcel: false,
	      fetchTimer: null
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    storageKey: function storageKey() {
	      return 'kmd-quotas-filters-' + this.schoolId;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale || 'da';
	    },
	    effectiveDate: function effectiveDate() {
	      return (0, _moment2.default)(this.selectedDate).format('YYYY-MM-DD');
	    },
	    quotaDateLabel: function quotaDateLabel() {
	      var date = (0, _moment2.default)(this.effectiveDate, 'YYYY-MM-DD');
	      return date.format('DD-MM-YYYY') + ' (uge ' + date.isoWeek() + ')';
	    },
	    hasSelection: function hasSelection() {
	      return this.selectAll || this.selectedUserIds.length > 0;
	    },
	    selectedUserCount: function selectedUserCount() {
	      if (!this.selectAll) return this.selectedUserIds.length;
	      var ids = {};
	      for (var i = 0; i < this.opusEmployments.length; i++) {
	        ids[this.opusEmployments[i].user.id] = true;
	      }
	      return (0, _keys2.default)(ids).length;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName || [];
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash || {};
	    },
	    opusEmployments: function opusEmployments() {
	      var out = [];
	      for (var i = 0; i < this.users.length; i++) {
	        var user = this.users[i];
	        var emps = this.employmentsInUserIdHash[user.id] || [];
	        for (var j = 0; j < emps.length; j++) {
	          var emp = emps[j];
	          var empNumber = emp && emp.employment_number ? String(emp.employment_number) : '';
	          if (empNumber.trim() === '') continue;
	          if (emp.source && emp.source !== 'opus') continue;
	          if (emp.deleted) continue;
	          if (emp.end_date && emp.end_date < this.effectiveDate) continue;
	          out.push({
	            user: user,
	            employment: emp
	          });
	        }
	      }
	      return out;
	    },
	    selectedOpusEmployments: function selectedOpusEmployments() {
	      if (this.selectAll) return this.opusEmployments;
	      if (this.selectedUserIds.length === 0) return [];
	      var ids = {};
	      for (var i = 0; i < this.selectedUserIds.length; i++) {
	        ids[this.selectedUserIds[i]] = true;
	      }
	      return this.opusEmployments.filter(function (pairing) {
	        return ids[pairing.user.id];
	      });
	    },
	    hasGroupLabels: function hasGroupLabels() {
	      for (var i = 0; i < this.allRows.length; i++) {
	        if (this.allRows[i].userTagsLabel) return true;
	      }
	      return false;
	    },
	    quotaTypes: function quotaTypes() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        if (this.allRows[i].quotaType) set[this.allRows[i].quotaType] = true;
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da');
	      });
	    },
	    filteredRows: function filteredRows() {
	      var _this = this;
	
	      var rows = this.allRows.filter(function (row) {
	        if (_this.selectedQuotaTypes.length > 0 && _this.selectedQuotaTypes.indexOf(row.quotaType) === -1) {
	          return false;
	        }
	        return true;
	      });
	      var key = this.sortBy;
	      var dir = this.sortDir === 'desc' ? -1 : 1;
	      var numericKeys = { balance: true, used: true, difference: true };
	      rows = rows.slice().sort(function (a, b) {
	        if (numericKeys[key]) {
	          var _av = _this.toNumber(a[key]);
	          var _bv = _this.toNumber(b[key]);
	          if (_av === _bv) return a.userName.localeCompare(b.userName, 'da');
	          return _av < _bv ? -dir : dir;
	        }
	        var av = a[key] == null ? '' : String(a[key]);
	        var bv = b[key] == null ? '' : String(b[key]);
	        var cmp = av.localeCompare(bv, 'da', { sensitivity: 'base' });
	        if (cmp !== 0) return cmp * dir;
	        return a.userName.localeCompare(b.userName, 'da');
	      });
	      return rows;
	    }
	  },
	  watch: {
	    selectedQuotaTypes: function selectedQuotaTypes() {
	      this.persistFilters();
	    },
	    opusEmployments: function opusEmployments() {
	      if (this.selectAll) this.scheduleFetch();
	    }
	  },
	  methods: {
	    onUsersUpdated: function onUsersUpdated(users) {
	      var ids = [];
	      var list = users || [];
	      for (var i = 0; i < list.length; i++) {
	        if (!list[i] || list[i].tag || !list[i].id) continue;
	        ids.push(list[i].id);
	      }
	      this.selectedUserIds = ids;
	      this.scheduleFetch();
	    },
	    onDateChanged: function onDateChanged(date) {
	      this.selectedDate = date;
	      this.persistFilters();
	      this.scheduleFetch();
	    },
	    selectAllUsers: function selectAllUsers() {
	      this.selectAll = true;
	      this.selectedUserIds = [];
	      this.scheduleFetch();
	    },
	    clearSelectAll: function clearSelectAll() {
	      this.selectAll = false;
	      this.selectedUserIds = [];
	      this.resetResults();
	    },
	    scheduleFetch: function scheduleFetch() {
	      if (this.fetchTimer) {
	        clearTimeout(this.fetchTimer);
	        this.fetchTimer = null;
	      }
	      if (!this.hasSelection) {
	        this.resetResults();
	        return;
	      }
	      var self = this;
	      this.fetchTimer = setTimeout(function () {
	        self.fetchTimer = null;
	        self.fetchAllQuotas();
	      }, 400);
	    },
	    toggleQuotaType: function toggleQuotaType(type) {
	      var idx = this.selectedQuotaTypes.indexOf(type);
	      if (idx > -1) this.selectedQuotaTypes.splice(idx, 1);else this.selectedQuotaTypes.push(type);
	    },
	    setSort: function setSort(key) {
	      if (this.sortBy === key) {
	        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
	      } else {
	        this.sortBy = key;
	        this.sortDir = 'asc';
	      }
	    },
	    persistFilters: function persistFilters() {
	      try {
	        window.localStorage.setItem(this.storageKey, (0, _stringify2.default)({
	          selectedQuotaTypes: this.selectedQuotaTypes,
	          selectedDate: this.effectiveDate
	        }));
	      } catch (e) {}
	    },
	    restoreFilters: function restoreFilters() {
	      try {
	        var raw = window.localStorage.getItem(this.storageKey);
	        if (!raw) return;
	        var parsed = JSON.parse(raw);
	        if (parsed && Array.isArray(parsed.selectedQuotaTypes)) this.selectedQuotaTypes = parsed.selectedQuotaTypes;
	        if (parsed && parsed.selectedDate && (0, _moment2.default)(parsed.selectedDate, 'YYYY-MM-DD', true).isValid()) {
	          this.selectedDate = (0, _moment2.default)(parsed.selectedDate, 'YYYY-MM-DD');
	        }
	      } catch (e) {}
	    },
	    resetResults: function resetResults() {
	      this.fetchGeneration += 1;
	      this.allRows = [];
	      this.isLoading = false;
	      this.hasLoaded = false;
	      this.errorMessage = '';
	      this.warningMessage = '';
	      this.loadedCount = 0;
	      this.totalCount = 0;
	    },
	    toNumber: function toNumber(value) {
	      var n = typeof value === 'number' ? value : parseFloat(String(value).replace(',', '.'));
	      return (0, _isFinite2.default)(n) ? n : 0;
	    },
	    normalizeEmploymentNumber: function normalizeEmploymentNumber(value) {
	      if (value == null || value === '') return '';
	      var asInt = parseInt(String(value).trim(), 10);
	      if (!isNaN(asInt)) return String(asInt);
	      return String(value).trim();
	    },
	    quotaEmployeeNumber: function quotaEmployeeNumber(quota) {
	      if (!quota) return '';
	      return quota.EmployeeNumber || quota.PersonnelNumber || quota.EmployeeNo || quota.Medarbejdernummer || quota.EmploymentNumber || quota.EmployeeID || '';
	    },
	    formatDate: function formatDate(date) {
	      if (!date) return '';
	      return (0, _moment2.default)(date, 'YYYY-MM-DD').isValid() ? (0, _moment2.default)(date, 'YYYY-MM-DD').format('DD-MM-YYYY') : date;
	    },
	    formatDateRange: function formatDateRange(startDate, endDate) {
	      return this.formatDate(startDate) + ' - ' + this.formatDate(endDate);
	    },
	    formatDecimal: function formatDecimal(value) {
	      if (value === null || typeof value === 'undefined' || value === '') {
	        return '0';
	      }
	      var parsedValue = Number(value);
	      if (isNaN(parsedValue)) {
	        return String(value);
	      }
	      return parsedValue.toLocaleString(this.locale === 'en' ? 'en-US' : 'da-DK', {
	        minimumFractionDigits: 0,
	        maximumFractionDigits: 2
	      });
	    },
	    listQuotas: function listQuotas(employmentIds) {
	      var self = this;
	      return new _promise2.default(function (resolve, reject) {
	        _docendo2.default.listQuotas(self.schoolId, employmentIds, self.effectiveDate, function (response) {
	          if (response && response.success === false) {
	            reject(response.data && response.data.error || response.error || 'Kunne ikke hente kvoter fra KMD.');
	            return;
	          }
	          if (response && response.error) {
	            reject(response.error);
	            return;
	          }
	          if (response && response.data && response.data.error) {
	            reject(response.data.error);
	            return;
	          }
	          resolve(self.parseQuotaItems(response));
	        }, function (error) {
	          reject(error && error.data && error.data.error || error && error.error || 'Kunne ikke hente kvoter fra KMD.');
	        });
	      });
	    },
	    parseQuotaItems: function parseQuotaItems(response) {
	      var parsedData = response;
	      if (response && response.data && response.data.response && typeof response.data.response === 'string') {
	        try {
	          parsedData = JSON.parse(response.data.response);
	        } catch (e) {
	          return [];
	        }
	      } else if (response && response.response && typeof response.response === 'string') {
	        try {
	          parsedData = JSON.parse(response.response);
	        } catch (e) {
	          return [];
	        }
	      }
	
	      var quotaItems = null;
	      if (parsedData && parsedData.Body && parsedData.Body.FetchQuotaListResponse_MT) {
	        var quotaList = parsedData.Body.FetchQuotaListResponse_MT.OT_QUOTA_LIST;
	        if (quotaList) {
	          quotaItems = typeof quotaList.item !== 'undefined' ? quotaList.item : quotaList.Item;
	        }
	      }
	
	      if (Array.isArray(quotaItems)) return quotaItems;
	      if (quotaItems && (typeof quotaItems === 'undefined' ? 'undefined' : (0, _typeof3.default)(quotaItems)) === 'object') return [quotaItems];
	      return [];
	    },
	    rowFromQuota: function rowFromQuota(quota, pairing, index) {
	      var user = pairing.user;
	      var emp = pairing.employment;
	      var title = emp.source_title || emp.title || '';
	      var empNumber = emp.employment_number ? String(emp.employment_number) : '';
	      var userTags = Array.isArray(user.user_tags) ? user.user_tags : [];
	      return {
	        id: user.id + '_' + emp.id + '_' + (quota.QuotaNumber || quota.QuotaType || index || '0'),
	        userId: user.id,
	        userName: user.name,
	        userTags: userTags,
	        userTagsLabel: userTags.join(', '),
	        employmentId: emp.id,
	        employmentNumber: empNumber,
	        employmentLabel: empNumber + (title ? ' - ' + title : ''),
	        quotaType: quota.QuotaTypaText || quota.QuotaType || '',
	        balance: quota.QuotaAccrued,
	        used: quota.QuotaUsed,
	        difference: quota.QuotaValue,
	        periodLabel: this.formatDateRange(quota.DeductionStartDate, quota.DeductionEndDate)
	      };
	    },
	    rowsFromQuotas: function rowsFromQuotas(quotas, pairing) {
	      var out = [];
	      for (var i = 0; i < quotas.length; i++) {
	        out.push(this.rowFromQuota(quotas[i], pairing, i));
	      }
	      return out;
	    },
	    attributeQuotas: function attributeQuotas(quotas, pairings) {
	      if (quotas.length === 0) return [];
	      if (pairings.length === 1) {
	        return this.rowsFromQuotas(quotas, pairings[0]);
	      }
	      var byNumber = {};
	      for (var i = 0; i < pairings.length; i++) {
	        var key = this.normalizeEmploymentNumber(pairings[i].employment.employment_number);
	        if (key) byNumber[key] = pairings[i];
	      }
	      var rows = [];
	      for (var _i = 0; _i < quotas.length; _i++) {
	        var _key = this.normalizeEmploymentNumber(this.quotaEmployeeNumber(quotas[_i]));
	        var pairing = _key ? byNumber[_key] : null;
	        if (!pairing) return null;
	        rows.push(this.rowFromQuota(quotas[_i], pairing, _i));
	      }
	      return rows;
	    },
	    chunkArray: function chunkArray(items, size) {
	      var chunks = [];
	      for (var i = 0; i < items.length; i += size) {
	        chunks.push(items.slice(i, i + size));
	      }
	      return chunks;
	    },
	    fetchChunk: function fetchChunk(pairings) {
	      var self = this;
	      var ids = pairings.map(function (pairing) {
	        return pairing.employment.id;
	      });
	      return this.listQuotas(ids).then(function (quotas) {
	        var attributed = self.attributeQuotas(quotas, pairings);
	        if (attributed) return attributed;
	        return self.fetchPairingsIndividually(pairings);
	      }).catch(function () {
	        return self.fetchPairingsIndividually(pairings);
	      });
	    },
	    fetchPairingsIndividually: function fetchPairingsIndividually(pairings) {
	      var self = this;
	      var tasks = pairings.map(function (pairing) {
	        return self.listQuotas([pairing.employment.id]).then(function (quotas) {
	          return self.rowsFromQuotas(quotas, pairing);
	        }).catch(function () {
	          return null;
	        });
	      });
	      return _promise2.default.all(tasks).then(function (groups) {
	        var out = [];
	        var failed = 0;
	        for (var i = 0; i < groups.length; i++) {
	          if (groups[i] == null) {
	            failed += 1;
	          } else {
	            out.push.apply(out, groups[i]);
	          }
	        }
	        if (failed > 0) {
	          self.warningMessage = failed + ' ansættelser kunne ikke hentes fra KMD.';
	        }
	        return out;
	      });
	    },
	    fetchAllQuotas: function fetchAllQuotas() {
	      if (!this.hasSelection) return;
	      this.fetchGeneration += 1;
	      var generation = this.fetchGeneration;
	      var pairings = this.selectedOpusEmployments;
	      this.isLoading = true;
	      this.hasLoaded = false;
	      this.errorMessage = '';
	      this.warningMessage = '';
	      this.loadedCount = 0;
	      this.totalCount = pairings.length;
	
	      if (pairings.length === 0) {
	        this.allRows = [];
	        this.isLoading = false;
	        this.hasLoaded = true;
	        return;
	      }
	
	      var self = this;
	      var chunks = this.chunkArray(pairings, CHUNK_SIZE);
	      var chain = _promise2.default.resolve([]);
	      chunks.forEach(function (chunk) {
	        chain = chain.then(function (rows) {
	          if (generation !== self.fetchGeneration) return rows;
	          return self.fetchChunk(chunk).then(function (chunkRows) {
	            if (generation !== self.fetchGeneration) return rows;
	            self.loadedCount += chunk.length;
	            return rows.concat(chunkRows);
	          });
	        });
	      });
	      chain.then(function (rows) {
	        if (generation !== self.fetchGeneration) return;
	        self.allRows = rows;
	        self.isLoading = false;
	        self.hasLoaded = true;
	      }).catch(function (error) {
	        if (generation !== self.fetchGeneration) return;
	        self.allRows = [];
	        self.errorMessage = typeof error === 'string' ? error : 'Kunne ikke hente kvoter fra KMD.';
	        self.isLoading = false;
	        self.hasLoaded = true;
	      });
	    },
	    dataToExcel: function dataToExcel() {
	      var _this2 = this;
	
	      return this.filteredRows.map(function (row) {
	        return {
	          user: row.userName || '',
	          groups: row.userTagsLabel || '',
	          employment: row.employmentLabel || '',
	          quotaType: row.quotaType || '',
	          balance: row.balance != null ? row.balance : '',
	          used: row.used != null ? row.used : '',
	          difference: row.difference != null ? row.difference : '',
	          period: row.periodLabel || '',
	          date: _this2.quotaDateLabel
	        };
	      });
	    },
	    downloadExcel: function downloadExcel() {
	      var _this3 = this;
	
	      if (this.isDownloadingExcel || this.filteredRows.length === 0) return;
	      this.isDownloadingExcel = true;
	      if (window.XLSX && XLSX) {
	        this.writeExcel();
	      } else {
	        var cdnXLSX = document.createElement('script');
	        cdnXLSX.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.mini.min.js');
	        document.head.appendChild(cdnXLSX);
	        var intervalTimer = setInterval(function (_) {
	          if (window.XLSX) {
	            clearInterval(intervalTimer);
	            XLSX = window.XLSX;
	            _this3.writeExcel();
	          }
	        }, 500);
	      }
	    },
	    writeExcel: function writeExcel() {
	      var headers = {
	        user: 'Navn',
	        groups: 'Grupper',
	        employment: 'Ansættelse',
	        quotaType: 'Kontotype',
	        balance: 'Saldo',
	        used: 'Brugt',
	        difference: 'Forskel',
	        period: 'Afholdelsesperiode',
	        date: 'Restkvote pr.'
	      };
	      var rows = this.dataToExcel();
	      rows.unshift(headers);
	      var sheet = XLSX.utils.json_to_sheet(rows, { skipHeader: true });
	      var wb = XLSX.utils.book_new();
	      XLSX.utils.book_append_sheet(wb, sheet, 'kvoter');
	      var timestamp = (0, _moment2.default)().format('YYYY-MM-DD_HH-mm');
	      XLSX.writeFile(wb, 'kmd_kvoter_' + timestamp + '.xlsx');
	      this.isDownloadingExcel = false;
	    }
	  },
	  mounted: function mounted() {
	    this.restoreFilters();
	    this.$store.dispatch('readEmployments');
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.fetchTimer) {
	      clearTimeout(this.fetchTimer);
	      this.fetchTimer = null;
	    }
	  }
	};

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFinite = __webpack_require__(85);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _CreateOpusAbsence = __webpack_require__(1562);
	
	var _CreateOpusAbsence2 = _interopRequireDefault(_CreateOpusAbsence);
	
	var _KmdQuotasModal = __webpack_require__(1568);
	
	var _KmdQuotasModal2 = _interopRequireDefault(_KmdQuotasModal);
	
	var _KmdOpusAbsenceModal = __webpack_require__(1567);
	
	var _KmdOpusAbsenceModal2 = _interopRequireDefault(_KmdOpusAbsenceModal);
	
	var _DoDatePickerRange = __webpack_require__(44);
	
	var _DoDatePickerRange2 = _interopRequireDefault(_DoDatePickerRange);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'OpusAbsence',
	  components: { Loader: _Loader2.default, DoFiltersFilter: _DoFiltersFilter2.default, CreateOpusAbsence: _CreateOpusAbsence2.default, KmdQuotasModal: _KmdQuotasModal2.default, KmdOpusAbsenceModal: _KmdOpusAbsenceModal2.default, DoDatePickerRange: _DoDatePickerRange2.default, Tabs: _Tabs2.default },
	  data: function data() {
	    return {
	      isNoConfiguration: false,
	      isLoading: false,
	      opusAbsence: [],
	
	      sortBy: 'vCreatedAt',
	      sortDir: 'desc',
	      isSortPristine: true,
	      selectedNames: [],
	      selectedAbsenceTypes: [],
	      isShowCreateOpusAbsence: false,
	      isShowQuotasModal: false,
	      startDate: (0, _moment2.default)().startOf('month').startOf('day'),
	      endDate: (0, _moment2.default)().endOf('month').endOf('day'),
	      absenceCodes: [],
	      selectedTab: 'all',
	      kmdAbsenceItem: null
	    };
	  },
	
	  computed: {
	    tabsList: function tabsList() {
	      var allCount = this.opusAbsenceSorted.length;
	      var failedCount = this.failedCount;
	      var queuedCount = this.queuedCount;
	      var successCount = this.successCount;
	      return [{
	        id: 'all',
	        title: 'Alle (' + allCount + ')'
	      }, {
	        id: 'failed',
	        title: 'Fejlede (' + failedCount + ')'
	      }, {
	        id: 'queued',
	        title: 'Afventer (' + queuedCount + ')'
	      }, {
	        id: 'success',
	        title: 'Gennemf\xF8rte (' + successCount + ')'
	      }];
	    },
	    successCount: function successCount() {
	      return this.opusAbsenceSorted.filter(function (x) {
	        return x.state === 'ok';
	      }).length;
	    },
	    failedCount: function failedCount() {
	      return this.opusAbsenceSorted.filter(function (x) {
	        return x.state === 'error';
	      }).length;
	    },
	    queuedCount: function queuedCount() {
	      return this.opusAbsenceSorted.filter(function (x) {
	        return x.state === 'queued' || !x.state || x.state === '';
	      }).length;
	    },
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    },
	    saveKeyTooltip: function saveKeyTooltip() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span>' + '<span>Enter</span></p>';
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    isOpusAbsenceActivated: function isOpusAbsenceActivated() {
	      return this.$store.getters.schoolFeatures && this.$store.getters.schoolFeatures.indexOf('kmd_absence') > -1;
	    },
	    usersById: function usersById() {
	      var map = {};
	      var list = this.$store.getters.usersSortedOnName || [];
	      for (var i = 0; i < list.length; i++) {
	        var u = list[i];
	        map[u.id] = u.name;
	      }
	      return map;
	    },
	    employmentsAll: function employmentsAll() {
	      return this.$store.state.employments && this.$store.state.employments.employments ? this.$store.state.employments.employments : [];
	    },
	    employmentsById: function employmentsById() {
	      var map = {};
	      var list = this.employmentsAll || [];
	      for (var i = 0; i < list.length; i++) {
	        var e = list[i];
	        map[e.id] = e;
	      }
	      return map;
	    },
	    opusAbsenceSorted: function opusAbsenceSorted() {
	      var _this = this;
	
	      return this.opusAbsence.map(function (item) {
	        var employment = _this.employmentsById[item.employment_id] || null;
	        var vUserName = employment && employment.user_id ? _this.getUserName(employment.user_id) : item.employment_number || 'Ukendt';
	        var vEmploymentNumber = employment && employment.employment_number ? employment.employment_number + (employment.title ? ' - ' + employment.title : '') : item.employment_number || 'Ukendt';
	        var vAbsenceTypeText = _this.getAbsenceCodeName(item.kmd_absence_code_id);
	        var vCreatedAt = item.created_at ? (0, _moment2.default)(item.created_at).format('lll') : '';
	        var vStartDate = item.from_date ? (0, _moment2.default)(item.from_date).format('DD-MM-YYYY') : '';
	        var vEndDate = item.to_date && item.to_date !== '9999-12-31' ? (0, _moment2.default)(item.to_date).format('DD-MM-YYYY') : 'Løbende';
	
	        var vAbsenceDays = item.absence_days || 0;
	        var vAbsenceCalendarDays = item.absence_calendar_days || 0;
	        var vAbsenceHours = item.absence_hours || 0;
	        if (item.from_date) {
	          var startDate = (0, _moment2.default)(item.from_date);
	          var endDate = item.to_date && item.to_date !== '9999-12-31' ? (0, _moment2.default)(item.to_date) : (0, _moment2.default)();
	          vAbsenceCalendarDays = endDate.diff(startDate, 'days') + 1;
	
	          if (!item.absence_days) {
	            vAbsenceDays = vAbsenceCalendarDays;
	          }
	        }
	
	        if (item.from_time && item.to_time && !item.absence_hours) {
	          var startTime = (0, _moment2.default)(item.from_time);
	          var endTime = (0, _moment2.default)(item.to_time);
	
	          vAbsenceHours = endTime.diff(startTime, 'hours', true);
	        }
	        return (0, _assign2.default)({}, item, {
	          vUserName: vUserName,
	          vEmploymentNumber: vEmploymentNumber,
	          vAbsenceTypeText: vAbsenceTypeText,
	          vCreatedAt: vCreatedAt,
	          vStartDate: vStartDate,
	          vEndDate: vEndDate,
	          vAbsenceDays: vAbsenceDays,
	          vAbsenceCalendarDays: vAbsenceCalendarDays,
	          vAbsenceHours: vAbsenceHours,
	          absence_days: vAbsenceDays,
	          absence_calendar_days: vAbsenceCalendarDays,
	          absence_hours: vAbsenceHours,
	          employment: employment
	        });
	      });
	    },
	    uniqueNames: function uniqueNames() {
	      var set = {};
	      for (var i = 0; i < this.opusAbsenceSorted.length; i++) {
	        var s = this.opusAbsenceSorted[i];
	        var name = s.vUserName || '';
	        if (name) set[name] = true;
	      }
	      var arr = (0, _keys2.default)(set);
	      return arr.sort(function (a, b) {
	        return a.localeCompare(b, 'da', { sensitivity: 'base' });
	      });
	    },
	    uniqueAbsenceTypes: function uniqueAbsenceTypes() {
	      var set = {};
	      for (var i = 0; i < this.opusAbsenceSorted.length; i++) {
	        var s = this.opusAbsenceSorted[i];
	        var type = s.vAbsenceTypeText || '';
	        if (type) set[type] = true;
	      }
	      var arr = (0, _keys2.default)(set);
	      return arr.sort(function (a, b) {
	        return a.localeCompare(b, 'da', { sensitivity: 'base' });
	      });
	    },
	    displayedAbsences: function displayedAbsences() {
	      var _this2 = this;
	
	      var rows = this.opusAbsenceSorted.slice();
	
	      if (this.selectedTab === 'failed') {
	        rows = rows.filter(function (x) {
	          return x.state === 'error';
	        });
	      } else if (this.selectedTab === 'success') {
	        rows = rows.filter(function (x) {
	          return x.state === 'ok';
	        });
	      } else if (this.selectedTab === 'queued') {
	        rows = rows.filter(function (x) {
	          return x.state === 'queued' || !x.state || x.state === '';
	        });
	      }
	
	      if (this.selectedNames && this.selectedNames.length > 0) {
	        var chosen = {};
	        for (var i = 0; i < this.selectedNames.length; i++) {
	          chosen[this.selectedNames[i]] = true;
	        }rows = rows.filter(function (x) {
	          return chosen[x.vUserName || ''];
	        });
	      }
	
	      if (this.selectedAbsenceTypes && this.selectedAbsenceTypes.length > 0) {
	        var _chosen = {};
	        for (var _i = 0; _i < this.selectedAbsenceTypes.length; _i++) {
	          _chosen[this.selectedAbsenceTypes[_i]] = true;
	        }rows = rows.filter(function (x) {
	          return _chosen[x.vAbsenceTypeText || ''];
	        });
	      }
	
	      var get = function get(item, key) {
	        switch (key) {
	          case 'state':
	            if (item.state === 'error') return 0;
	            if (item.state === 'queued' || !item.state || item.state === '') return 1;
	            if (item.state === 'ok') {
	              if (item.error && item.error.some(function (x) {
	                return x && x.StatusType === 'W';
	              })) return 2;
	              return 3;
	            }
	            return 4;
	          case 'name':
	            return item.vUserName || '';
	          case 'employment_number':
	            return String(item.vEmploymentNumber || '');
	          case 'absence_type_text':
	            return String(item.vAbsenceTypeText || '');
	          case 'start_date':
	            return item.from_date ? (0, _moment2.default)(item.from_date).toDate() : new Date(0);
	          case 'end_date':
	            if (!item.to_date || item.to_date === '9999-12-31') {
	              return new Date('9999-12-31');
	            }
	            return (0, _moment2.default)(item.to_date).toDate();
	          case 'absence_days':
	            return _this2._num(item.absence_days);
	          case 'absence_hours':
	            return _this2._num(item.absence_hours);
	          case 'absence_calendar_days':
	            return _this2._num(item.absence_calendar_days);
	          case 'vCreatedAt':
	            return _this2._momentOrNull(item.created_at).valueOf() || 0;
	          default:
	            return item[key] || '';
	        }
	      };
	
	      var dir = this.sortDir === 'asc' ? 1 : -1;
	      var key = this.sortBy;
	
	      return rows.slice().sort(function (a, b) {
	        var va = get(a, key);
	        var vb = get(b, key);
	        if (va === vb) return 0;
	        if (typeof va === 'number' && typeof vb === 'number') return (va - vb) * dir;
	        if (va instanceof Date && vb instanceof Date) return (va - vb) * dir;
	        if (typeof va === 'number' && typeof vb !== 'number') return -1 * dir;
	        if (typeof vb === 'number' && typeof va !== 'number') return 1 * dir;
	        return String(va).localeCompare(String(vb), 'da', { sensitivity: 'base' }) * dir;
	      });
	    }
	  },
	  methods: {
	    retrySend: function retrySend(item) {
	      var _this3 = this;
	
	      this.$set(item, 'isRetrying', true);
	      _docendo2.default.schoolEventSerialsRetrySend(this.schoolId, item.id, function (response) {
	        _this3.$set(item, 'isRetrying', false);
	        _this3.$set(item, 'state', 'queued');
	        _this3.$set(item, 'error', []);
	        _eventbus2.default.toast = { text: 'Forsøgt sendt igen', success: false };
	        _this3.readOpusAbsence(false);
	      }, function () {
	        _this3.$set(item, 'isRetrying', false);
	        _eventbus2.default.toast = { text: 'Kunne ikke sende igen', success: false };
	      });
	    },
	    openKmdAbsence: function openKmdAbsence(item) {
	      this.kmdAbsenceItem = item;
	    },
	    isOpusEmployment: function isOpusEmployment(employment) {
	      return !employment || !employment.source || employment.source === 'opus';
	    },
	    getUserName: function getUserName(userId) {
	      if (!userId) {
	        return '';
	      }
	      var user = this.usersById[userId];
	      if (user) {
	        return user;
	      }
	      return userId;
	    },
	    toggleName: function toggleName(name) {
	      var idx = this.selectedNames.indexOf(name);
	      if (idx >= 0) {
	        this.selectedNames.splice(idx, 1);
	      } else {
	        this.selectedNames.push(name);
	      }
	    },
	    clearNames: function clearNames() {
	      this.selectedNames = [];
	    },
	    toggleAbsenceType: function toggleAbsenceType(type) {
	      var idx = this.selectedAbsenceTypes.indexOf(type);
	      if (idx >= 0) {
	        this.selectedAbsenceTypes.splice(idx, 1);
	      } else {
	        this.selectedAbsenceTypes.push(type);
	      }
	    },
	    clearAbsenceTypes: function clearAbsenceTypes() {
	      this.selectedAbsenceTypes = [];
	    },
	    setSort: function setSort(key) {
	      this.isSortPristine = false;
	      if (this.sortBy === key) {
	        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
	      } else {
	        this.sortBy = key;
	        this.sortDir = 'asc';
	      }
	    },
	    _num: function _num(v) {
	      var n = typeof v === 'number' ? v : parseFloat(String(v).replace(',', '.'));
	      return (0, _isFinite2.default)(n) ? n : 0;
	    },
	    _momentOrNull: function _momentOrNull(iso) {
	      return iso ? (0, _moment2.default)(iso) : null;
	    },
	    formatDecimal: function formatDecimal(value) {
	      if (value == null || value === '') return '';
	      var num = Number(value);
	      if (isNaN(num)) return String(value).replace('.', ',');
	      var formatted = num % 1 === 0 ? String(num) : num.toFixed(2);
	      return formatted.replace('.', ',');
	    },
	    setIsShowCreateOpusAbsence: function setIsShowCreateOpusAbsence(bool) {
	      this.isShowCreateOpusAbsence = bool;
	    },
	    onCreated: function onCreated(data) {
	      if (!data || !data.id) return;
	      var idx = this.opusAbsence.findIndex(function (item) {
	        return item.id === data.id;
	      });
	      if (idx < 0) {
	        this.opusAbsence.push(data);
	      } else {
	        this.$set(this.opusAbsence, idx, (0, _assign2.default)({}, this.opusAbsence[idx], data));
	      }
	      this.readOpusAbsence();
	    },
	    readOpusAbsence: function readOpusAbsence() {
	      var _this4 = this;
	
	      var isShowSpinner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (isShowSpinner) {
	        this.isLoading = true;
	      }
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      _docendo2.default.schoolEventSerialsListKmd(this.schoolId, startDate, endDate, function (success) {
	        if (success && success.status && success.status === 'error') {
	          _this4.isNoConfiguration = true;
	        }
	        if (Array.isArray(success)) {
	          _this4.opusAbsence = success;
	        } else if (success && Array.isArray(success.data)) {
	          _this4.opusAbsence = success.data;
	        } else {
	          _this4.opusAbsence = [];
	        }
	        _this4.isLoading = false;
	      }, function (failure) {
	        console.log(failure);
	        _this4.isLoading = false;
	        _this4.opusAbsence = [];
	      });
	    },
	    startDateChanged: function startDateChanged(date) {
	      this.startDate = date;
	      this.readOpusAbsence();
	    },
	    endDateChanged: function endDateChanged(date) {
	      this.endDate = date;
	      this.readOpusAbsence();
	    },
	    getAbsenceTypeCode: function getAbsenceTypeCode(codeId) {
	      if (!codeId || !Array.isArray(this.absenceCodes)) return '';
	      var code = this.absenceCodes.find(function (c) {
	        return c.id === codeId;
	      });
	      return code && code.absence_type ? String(code.absence_type) : '';
	    },
	    getAbsenceCodeName: function getAbsenceCodeName(codeId) {
	      if (!codeId || !this.absenceCodes || !Array.isArray(this.absenceCodes)) {
	        return '';
	      }
	      var code = this.absenceCodes.find(function (c) {
	        return c.id === codeId;
	      });
	      if (!code) {
	        return '';
	      }
	      return code.absence_type + (code.absence_type_text ? ' - ' + code.absence_type_text : '');
	    },
	    readAbsenceCodes: function readAbsenceCodes() {
	      var _this5 = this;
	
	      _docendo2.default.listKmdOpusAbsenceCodes(this.schoolId, function (success) {
	        _this5.absenceCodes = success;
	      }, function (failure) {
	        _this5.absenceCodes = [];
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('readEmployments');
	    this.readAbsenceCodes();
	    this.readOpusAbsence();
	  }
	};

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(28);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    userQuota: 'Kvoter',
	    showingForDate: 'Viser saldo pr.',
	    employment: 'Ansættelse',
	    quotaType: 'Kontotype',
	    balance: 'Saldo',
	    used: 'Brugt',
	    difference: 'Forskel',
	    deductionPeriod: 'Afholdelsesperiode',
	    noQuotas: 'Der blev ikke fundet nogen kvoter for den valgte ansættelse.',
	    loadError: 'Kunne ikke hente kvoter fra KMD.'
	  },
	  nb: {
	    userQuota: 'KMD-kvoter',
	    showingForDate: 'Viser saldo per',
	    employment: 'Ansettelse',
	    quotaType: 'Kontotype',
	    balance: 'Saldo',
	    used: 'Brukt',
	    difference: 'Forskjell',
	    deductionPeriod: 'Uttaksperiode',
	    noQuotas: 'Fant ingen kvoter for valgt ansettelse.',
	    loadError: 'Kunne ikke hente kvoter fra KMD.'
	  },
	  en: {
	    userQuota: 'KMD quotas',
	    showingForDate: 'Showing balance for',
	    employment: 'Employment',
	    quotaType: 'Quota type',
	    balance: 'Balance',
	    used: 'Used',
	    difference: 'Difference',
	    deductionPeriod: 'Deduction period',
	    noQuotas: 'No quotas were found for the selected employment.',
	    loadError: 'Could not fetch quotas from KMD.'
	  }
	};
	
	exports.default = {
	  props: {
	    userId: {
	      type: Number,
	      default: null
	    },
	    date: {
	      default: null
	    },
	    isSidebar: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      selectedEmploymentId: null,
	      quotas: [],
	      isLoadingQuotas: false,
	      hasLoadedQuotas: false,
	      errorMessage: '',
	      userEmploymentsRaw: [],
	      isLoadingEmployments: false,
	      hasRequestedEmployments: false
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale || 'da';
	    },
	    i18n: function i18n() {
	      return I18N[this.locale] || I18N.da;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    employments: function employments() {
	      var out = [];
	      for (var i = 0; i < this.userEmploymentsRaw.length; i++) {
	        var employment = this.userEmploymentsRaw[i];
	        var employmentNumber = employment && employment.employment_number ? String(employment.employment_number) : '';
	        if (employmentNumber.trim() !== '') {
	          out.push(employment);
	        }
	      }
	      return out;
	    },
	    shouldRenderComponent: function shouldRenderComponent() {
	      if (!this.hasRequestedEmployments || this.isLoadingEmployments) {
	        return true;
	      }
	      return this.employments.length > 0;
	    },
	    effectiveDate: function effectiveDate() {
	      return (0, _moment2.default)().format('YYYY-MM-DD');
	    },
	    quotaDateLabel: function quotaDateLabel() {
	      return this.effectiveDate ? (0, _moment2.default)(this.effectiveDate, 'YYYY-MM-DD').format('DD-MM-YYYY') : '';
	    },
	    sortedQuotas: function sortedQuotas() {
	      var MAX_END_DATE = '9999-12-31';
	      return this.quotas.slice().sort(function (a, b) {
	        var aEnd = a && a.DeductionEndDate ? a.DeductionEndDate : '';
	        var bEnd = b && b.DeductionEndDate ? b.DeductionEndDate : '';
	
	        var aIsMax = aEnd === MAX_END_DATE;
	        var bIsMax = bEnd === MAX_END_DATE;
	
	        if (aIsMax && !bIsMax) {
	          return 1;
	        }
	        if (!aIsMax && bIsMax) {
	          return -1;
	        }
	
	        if (aEnd && bEnd && aEnd !== bEnd) {
	          return aEnd.localeCompare(bEnd);
	        }
	
	        var aName = a && (a.QuotaTypaText || a.QuotaType) ? a.QuotaTypaText || a.QuotaType : '';
	        var bName = b && (b.QuotaTypaText || b.QuotaType) ? b.QuotaTypaText || b.QuotaType : '';
	        return aName.localeCompare(bName);
	      });
	    }
	  },
	  watch: {
	    shouldRenderComponent: {
	      immediate: true,
	      handler: function handler(value) {
	        this.$emit('visibility', value);
	      }
	    },
	    employments: function employments() {
	      this.selectDefaultEmployment();
	    },
	    selectedEmploymentId: function selectedEmploymentId() {
	      this.fetchQuotas();
	    },
	    date: function date() {
	      this.fetchQuotas();
	    },
	    userId: function userId() {
	      this.readUserEmployments();
	    }
	  },
	  methods: {
	    readUserEmployments: function readUserEmployments() {
	      var _this = this;
	
	      this.hasRequestedEmployments = true;
	      this.userEmploymentsRaw = [];
	      if (!this.userId || !this.schoolId) {
	        return;
	      }
	      var userId = this.userId;
	      this.isLoadingEmployments = true;
	      this.errorMessage = '';
	      _docendo2.default.employmentsForUser(this.schoolId, userId, function (data) {
	        if (userId !== _this.userId) {
	          return;
	        }
	        _this.userEmploymentsRaw = Array.isArray(data) ? data.filter(function (employment) {
	          return employment.user_id * 1 === userId * 1;
	        }) : [];
	        _this.isLoadingEmployments = false;
	      }, function (error) {
	        if (userId !== _this.userId) {
	          return;
	        }
	        _this.isLoadingEmployments = false;
	        _this.handleQuotaError(error && error.error || _this.i18n.loadError);
	      });
	    },
	    selectDefaultEmployment: function selectDefaultEmployment() {
	      var _this2 = this;
	
	      if (this.employments.length < 1) {
	        this.selectedEmploymentId = null;
	        return;
	      }
	      var selectedExists = this.employments.some(function (employment) {
	        return String(employment.id) === String(_this2.selectedEmploymentId);
	      });
	      if (!selectedExists) {
	        this.selectedEmploymentId = this.employments[0].id;
	      }
	    },
	    fetchQuotas: function fetchQuotas() {
	      var _this3 = this;
	
	      if (!this.selectedEmploymentId || !this.schoolId) {
	        this.quotas = [];
	        this.hasLoadedQuotas = false;
	        this.errorMessage = '';
	        return;
	      }
	
	      this.isLoadingQuotas = true;
	      this.hasLoadedQuotas = false;
	      this.errorMessage = '';
	
	      _docendo2.default.listQuotas(this.schoolId, [this.selectedEmploymentId], this.effectiveDate, function (response) {
	        if (response && response.success === false) {
	          _this3.handleQuotaError(response.data && response.data.error || response.error || _this3.i18n.loadError);
	          return;
	        }
	        if (response && response.error) {
	          _this3.handleQuotaError(response.error);
	          return;
	        }
	        if (response && response.data && response.data.error) {
	          _this3.handleQuotaError(response.data.error);
	          return;
	        }
	
	        var parsedData = response;
	        if (response && response.data && response.data.response && typeof response.data.response === 'string') {
	          try {
	            parsedData = JSON.parse(response.data.response);
	          } catch (e) {
	            _this3.handleQuotaError(_this3.i18n.loadError);
	            return;
	          }
	        } else if (response && response.response && typeof response.response === 'string') {
	          try {
	            parsedData = JSON.parse(response.response);
	          } catch (e) {
	            _this3.handleQuotaError(_this3.i18n.loadError);
	            return;
	          }
	        }
	
	        var quotaItems = null;
	        if (parsedData && parsedData.Body && parsedData.Body.FetchQuotaListResponse_MT) {
	          var quotaList = parsedData.Body.FetchQuotaListResponse_MT.OT_QUOTA_LIST;
	          if (quotaList) {
	            quotaItems = typeof quotaList.item !== 'undefined' ? quotaList.item : quotaList.Item;
	          }
	        }
	
	        if (Array.isArray(quotaItems)) {
	          _this3.quotas = quotaItems;
	        } else if (quotaItems && (typeof quotaItems === 'undefined' ? 'undefined' : (0, _typeof3.default)(quotaItems)) === 'object') {
	          _this3.quotas = [quotaItems];
	        } else {
	          _this3.quotas = [];
	        }
	
	        _this3.isLoadingQuotas = false;
	        _this3.hasLoadedQuotas = true;
	      }, function (error) {
	        var errorMessage = error && error.data && error.data.error || error && error.error || _this3.i18n.loadError;
	        _this3.handleQuotaError(errorMessage);
	      });
	    },
	    handleQuotaError: function handleQuotaError(message) {
	      this.quotas = [];
	      this.errorMessage = message;
	      this.isLoadingQuotas = false;
	      this.hasLoadedQuotas = true;
	    },
	    formatDate: function formatDate(date) {
	      if (!date) {
	        return '';
	      }
	      return (0, _moment2.default)(date, 'YYYY-MM-DD').isValid() ? (0, _moment2.default)(date, 'YYYY-MM-DD').format('DD-MM-YYYY') : date;
	    },
	    formatDateRange: function formatDateRange(startDate, endDate) {
	      return this.formatDate(startDate) + ' - ' + this.formatDate(endDate);
	    },
	    formatDecimal: function formatDecimal(value) {
	      if (value === null || typeof value === 'undefined' || value === '') {
	        return '0';
	      }
	      var parsedValue = Number(value);
	      if (isNaN(parsedValue)) {
	        return String(value);
	      }
	      return parsedValue.toLocaleString(this.locale === 'en' ? 'en-US' : 'da-DK', {
	        minimumFractionDigits: 0,
	        maximumFractionDigits: 2
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readUserEmployments();
	  }
	};

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EmploymentTemplates = __webpack_require__(1585);
	
	var _EmploymentTemplates2 = _interopRequireDefault(_EmploymentTemplates);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ChooseSalarySystem = __webpack_require__(398);
	
	var _ChooseSalarySystem2 = _interopRequireDefault(_ChooseSalarySystem);
	
	var _Tjenestenumre = __webpack_require__(1594);
	
	var _Tjenestenumre2 = _interopRequireDefault(_Tjenestenumre);
	
	var _CostCenters = __webpack_require__(143);
	
	var _CostCenters2 = _interopRequireDefault(_CostCenters);
	
	var _SalaryCodes = __webpack_require__(144);
	
	var _SalaryCodes2 = _interopRequireDefault(_SalaryCodes);
	
	var _Loenbroek = __webpack_require__(1586);
	
	var _Loenbroek2 = _interopRequireDefault(_Loenbroek);
	
	var _OpusAbsence = __webpack_require__(1569);
	
	var _OpusAbsence2 = _interopRequireDefault(_OpusAbsence);
	
	var _Ansaettelsesnumre = __webpack_require__(1560);
	
	var _Ansaettelsesnumre2 = _interopRequireDefault(_Ansaettelsesnumre);
	
	var _Engangsydelser = __webpack_require__(1563);
	
	var _Engangsydelser2 = _interopRequireDefault(_Engangsydelser);
	
	var _FasteTillaeg = __webpack_require__(1565);
	
	var _FasteTillaeg2 = _interopRequireDefault(_FasteTillaeg);
	
	var _SdEngangsydelser = __webpack_require__(1591);
	
	var _SdEngangsydelser2 = _interopRequireDefault(_SdEngangsydelser);
	
	var _SdFasteTillaeg = __webpack_require__(1592);
	
	var _SdFasteTillaeg2 = _interopRequireDefault(_SdFasteTillaeg);
	
	var _SdFravaer = __webpack_require__(1593);
	
	var _SdFravaer2 = _interopRequireDefault(_SdFravaer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CostCenters: _CostCenters2.default,
	    Tjenestenumre: _Tjenestenumre2.default,
	    ChooseSalarySystem: _ChooseSalarySystem2.default,
	    SalaryCodes: _SalaryCodes2.default,
	    EmploymentTemplatesTable: _EmploymentTemplates2.default,
	    Loader: _Loader2.default,
	    Loenbroek: _Loenbroek2.default,
	    OpusAbsence: _OpusAbsence2.default,
	    Ansaettelsesnumre: _Ansaettelsesnumre2.default,
	    Engangsydelser: _Engangsydelser2.default,
	    FasteTillaeg: _FasteTillaeg2.default,
	    SdEngangsydelser: _SdEngangsydelser2.default,
	    SdFasteTillaeg: _SdFasteTillaeg2.default,
	    SdFravaer: _SdFravaer2.default
	  },
	  data: function data() {
	    return {
	      activePage: 'fravaer',
	      loadedSchoolId: null
	    };
	  },
	
	  computed: {
	    routeSchoolId: function routeSchoolId() {
	      var param = this.$route && this.$route.params ? this.$route.params.school_id : null;
	      return param ? parseInt(param, 10) : null;
	    },
	    menu: function menu() {
	      if (this.salarySystem === 'SD') {
	        return [{ key: 'fravaer', label: 'Fraværsindberetninger', component: 'SdFravaer' }, { key: 'ydelse', label: 'Engangsydelser', component: 'SdEngangsydelser' }, { key: 'tillaeg', label: 'Faste tillæg', component: 'SdFasteTillaeg' }, { key: 'tjenestenumre', label: 'Ansættelser', component: 'Tjenestenumre' }, { key: 'stillingskategorier', label: 'Stillingskategorier', component: 'EmploymentTemplatesTable' }, { key: 'lønkoder', label: 'Lønkoder', component: 'SalaryCodes' }, { key: 'costcenters', label: 'Omkostningssteder', component: 'CostCenters' }];
	      } else {
	        return [{ key: 'fravaer', label: 'Fraværsindberetninger', component: 'OpusAbsence' }, { key: 'engangsydelser', label: 'Engangsydelser', component: 'Engangsydelser' }, { key: 'faste-tillaeg', label: 'Faste tillæg', component: 'FasteTillaeg' }, { key: 'ansættelsesnumre', label: 'Ansættelser', component: 'Ansaettelsesnumre' }, { key: 'stillingskategorier', label: 'Stillingskategorier', component: 'EmploymentTemplatesTable' }, { key: 'lønkoder', label: 'Lønkoder', component: 'SalaryCodes' }, { key: 'costcenters', label: 'Omkostningssteder', component: 'CostCenters' }];
	      }
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    salarySystem: function salarySystem() {
	      return this.$store.getters.salarySystem;
	    },
	    isSDIntegrationActive: function isSDIntegrationActive() {
	      return this.activeSchool && this.activeSchool.features && this.activeSchool.features.includes('silkeborg_data_integration');
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolYear: function schoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.$store.getters.schoolYearId;
	    },
	    isAllLoaded: function isAllLoaded() {
	      return this.schoolId && this.schoolYearId && this.schoolYear;
	    },
	    selectedEmploymentIds: function selectedEmploymentIds() {
	      if (this.$store && this.$store.getters && this.$store.getters.selectedEmploymentIds) {
	        return this.$store.getters.selectedEmploymentIds;
	      }
	      return [];
	    },
	    activeTab: function activeTab() {
	      var _this = this;
	
	      var match = this.menu.filter(function (m) {
	        return m.key === _this.activePage;
	      });
	      return match.length > 0 ? match[0] : null;
	    }
	  },
	  methods: {
	    ensureActiveSchoolFromRoute: function ensureActiveSchoolFromRoute() {
	      var id = this.routeSchoolId;
	      if (!id) return;
	      if (this.activeSchool && this.activeSchool.id === id) return;
	      this.$store.dispatch('readActiveSchool', { id: id });
	    },
	    loadSalaryData: function loadSalaryData() {
	      if (!this.schoolId || this.loadedSchoolId === this.schoolId) return;
	      this.loadedSchoolId = this.schoolId;
	      this.$store.dispatch('readSalaryCodes');
	      this.$store.dispatch('readCostCenters');
	    },
	    setActivePage: function setActivePage(page) {
	      this.activePage = page;
	    },
	    getPropsFor: function getPropsFor(key) {
	      if (key === 'lønkoder') {
	        return {};
	      }
	      if (key === 'stillingskategorier') {
	        return {
	          selectedEmploymentIds: this.selectedEmploymentIds
	        };
	      }
	      return {
	        theType: key
	      };
	    },
	    onTemplateSelected: function onTemplateSelected(tpl) {
	      this.$emit('template-selected', tpl);
	    },
	    onTemplateCreated: function onTemplateCreated() {
	      this.$emit('template-created');
	    },
	    onTemplateUpdated: function onTemplateUpdated() {
	      this.$emit('template-updated');
	    },
	    onTemplateDeleted: function onTemplateDeleted() {
	      this.$emit('template-deleted');
	    }
	  },
	  watch: {
	    routeSchoolId: function routeSchoolId() {
	      this.ensureActiveSchoolFromRoute();
	    },
	    schoolId: function schoolId(val) {
	      if (val) this.loadSalaryData();
	    }
	  },
	  created: function created() {
	    this.ensureActiveSchoolFromRoute();
	  },
	  mounted: function mounted() {
	    this.loadSalaryData();
	  }
	};

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Tabs: _Tabs2.default },
	  props: {
	    activeFilter: {
	      type: String,
	      default: 'draft'
	    },
	    userDaysSorted: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isSalaryIntegrationActive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    userDaysDrafts: function userDaysDrafts() {
	      return this.userDaysSorted.filter(function (userDay) {
	        return userDay.state === 'draft';
	      });
	    },
	    userDaysApproved: function userDaysApproved() {
	      return this.userDaysSorted.filter(function (userDay) {
	        return userDay.state === 'approved';
	      });
	    },
	    userDaysSent: function userDaysSent() {
	      return this.userDaysSorted.filter(function (userDay) {
	        return userDay.state === 'sent';
	      });
	    },
	    tabsList: function tabsList() {
	      var sentLabel = this.isSalaryIntegrationActive ? 'Sendt til lønsystem' : 'Er indberettet';
	
	      return [{ id: 'draft', title: 'Efterbehandling (' + this.userDaysDrafts.length + ')' }, { id: 'approved', title: 'Godkendt (' + this.userDaysApproved.length + ')' }, { id: 'sent', title: sentLabel + ' (' + this.userDaysSent.length + ')' }];
	    }
	  },
	  methods: {
	    setFilter: function setFilter(filter) {
	      this.$emit('change', filter);
	    }
	  }
	};

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(9);
	
	var _DoEmploymentTemplate = __webpack_require__(140);
	
	var _DoEmploymentTemplate2 = _interopRequireDefault(_DoEmploymentTemplate);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DoEmploymentDropdown',
	  components: { DoEmploymentTemplate: _DoEmploymentTemplate2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    selectedEmploymentIds: {
	      default: function _default() {
	        return [];
	      }
	    },
	    employmentTypes: {
	      type: Array,
	      required: true
	    },
	    value: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    canSave: {
	      type: Boolean,
	      default: false
	    },
	    isSubmitting: {
	      type: Boolean,
	      default: false
	    },
	    createNewTitleText: {
	      type: String,
	      default: 'Opret ny stillingskategori'
	    },
	    initiallyOpen: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isOpen: this.initiallyOpen,
	      isTemplateModalOpen: false,
	      editTemplate: null
	    };
	  },
	
	  computed: {
	    isDisabled: function isDisabled() {
	      return !this.selectedEmploymentIds || this.selectedEmploymentIds.length === 0;
	    }
	  },
	  methods: {
	    toggleOpen: function toggleOpen() {
	      if (this.isDisabled) return;
	      if (!this.isOpen) this.$emit('input', []);
	      this.isOpen = !this.isOpen;
	      this.$emit('open-change', this.isOpen);
	    },
	    onClickAway: function onClickAway() {
	      if (!this.isOpen) return;
	      this.$emit('input', []);
	      this.isOpen = false;
	      this.$emit('open-change', this.isOpen);
	    },
	    isSelected: function isSelected(title) {
	      return this.value.findIndex(function (t) {
	        return t === title;
	      }) > -1;
	    },
	    selectEmploymentType: function selectEmploymentType(employmentType) {
	      if (this.selectedEmploymentIds.length === 0) {
	        _eventbus2.default.toast = { text: 'Vælg personale først', 'success': false };
	        return;
	      }
	      this.$emit('select', employmentType);
	      this.isOpen = false;
	    },
	    setTemplateModalOpen: function setTemplateModalOpen(bool) {
	      this.isTemplateModalOpen = bool;
	    },
	    openEdit: function openEdit(employmentType) {
	      this.editTemplate = employmentType;
	      this.setTemplateModalOpen(true);
	    },
	    closeTemplateModal: function closeTemplateModal() {
	      this.editTemplate = null;
	      this.setTemplateModalOpen(false);
	    }
	  }
	};

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default, DModal: _DModal2.default },
	  props: {
	    theEditEmploymentTemplate: {
	      type: Object,
	      default: null
	    },
	    forceHourLimitMode: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      title: '',
	      localManualSalary: false,
	      salaryCodeId: null,
	      omkostningssted: null,
	      hasHourLimit: false,
	      hourLimit: null,
	      hourLimitSalaryCodeId: null,
	      hasSpecialHourLimit: false,
	      specialHourLimitSalaryCodeId: null,
	      enableEmploymentDecimal: false,
	      isSubmitting: false,
	      isDeleting: false,
	      confirmingDelete: false
	    };
	  },
	
	  computed: {
	    isEditing: function isEditing() {
	      return !!this.theEditEmploymentTemplate;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    templateId: function templateId() {
	      return this.isEditing ? this.theEditEmploymentTemplate.id : null;
	    },
	    isValid: function isValid() {
	      return this.title.trim().length > 0;
	    },
	    costCenters: function costCenters() {
	      return this.$store.getters.costCenters;
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted;
	    },
	    isSalarySystemSD: function isSalarySystemSD() {
	      return this.$store.getters.salarySystem === 'SD';
	    },
	    hasSpecialSalaryCode: function hasSpecialSalaryCode() {
	      if (this.$store.getters.salarySystem === 'SD') {
	        return (this.salaryCodes || []).some(function (salaryCode) {
	          return String(salaryCode.tillaegsnummer) === '160099' || String(salaryCode.tillaegsnummer) === '160100' || String(salaryCode.loenart) === '836';
	        });
	      }
	      return (this.salaryCodes || []).some(function (salaryCode) {
	        return String(salaryCode.loenart) === '8411' || String(salaryCode.code) === '8411';
	      });
	    },
	    isLoadingUsage: function isLoadingUsage() {
	      return this.$store.state.employments.isLoadingEmploymentsTypesForSchool;
	    },
	    templateUsageCount: function templateUsageCount() {
	      if (!this.isEditing) return 0;
	      var employments = this.$store.state.employments.employments || [];
	      var count = 0;
	      for (var i = 0; i < employments.length; i++) {
	        var emp = employments[i];
	        if (emp.deleted) continue;
	        if (emp.employment_template_id == null) continue;
	        if (Number(emp.employment_template_id) === Number(this.templateId)) count++;
	      }
	      return count;
	    },
	    isTemplateInUse: function isTemplateInUse() {
	      return this.templateUsageCount > 0;
	    },
	    deleteButtonTitle: function deleteButtonTitle() {
	      if (this.isLoadingUsage) return 'Undersøger om kategorien er i brug…';
	      if (this.isTemplateInUse) {
	        return 'Bruges af ' + this.templateUsageCount + (this.templateUsageCount === 1 ? ' ansættelse' : ' ansættelser') + ' og kan ikke slettes';
	      }
	      if (this.confirmingDelete) return 'Klik for at bekræfte sletning';
	      return 'Slet stillingskategori';
	    }
	  },
	  methods: {
	    salaryCodeLabel: function salaryCodeLabel(salaryCode) {
	      if (this.isSalarySystemSD) {
	        return salaryCode.vSupplementTitle || salaryCode.name + ' (' + salaryCode.code + ')';
	      }
	      return salaryCode.name + ' (' + salaryCode.code + ')';
	    },
	    setIsManualSalary: function setIsManualSalary(bool) {
	      this.localManualSalary = bool;
	      if (bool) {
	        this.resetHourLimitFields();
	      } else {
	        this.resetManualFields();
	      }
	    },
	    resetManualFields: function resetManualFields() {
	      this.salaryCodeId = null;
	      this.omkostningssted = null;
	    },
	    toggleHasHourLimit: function toggleHasHourLimit() {
	      if (this.forceHourLimitMode) return;
	      this.setHasHourLimit(!this.hasHourLimit);
	    },
	    setHasHourLimit: function setHasHourLimit(bool) {
	      var _this = this;
	
	      this.hasHourLimit = bool;
	      if (!bool) {
	        this.resetHourLimitFields();
	      } else {
	        this.$nextTick(function () {
	          var el = _this.$refs.input_hour_limit;
	          if (el) el.focus();
	        });
	      }
	    },
	    toggleHasSpecialHourLimit: function toggleHasSpecialHourLimit() {
	      this.setHasSpecialHourLimit(!this.hasSpecialHourLimit);
	    },
	    setHasSpecialHourLimit: function setHasSpecialHourLimit(bool) {
	      this.hasSpecialHourLimit = bool;
	      if (!bool) {
	        this.specialHourLimitSalaryCodeId = null;
	      }
	    },
	    resetHourLimitFields: function resetHourLimitFields() {
	      this.hasHourLimit = false;
	      this.hourLimit = null;
	      this.hourLimitSalaryCodeId = null;
	      this.hasSpecialHourLimit = false;
	      this.specialHourLimitSalaryCodeId = null;
	    },
	    onSubmit: function onSubmit() {
	      var _this2 = this;
	
	      if (!this.isValid || this.isSubmitting) return;
	
	      this.isSubmitting = true;
	
	      var onSuccess = function onSuccess(response) {
	        _this2.isSubmitting = false;
	        if (response.status === 'error') {
	          _eventbus2.default.toast = { text: response.message, 'success': false };
	          return;
	        }
	        if (_this2.isEditing) {
	          console.log('child-emit');
	          _this2.$emit('updated', response);
	        } else {
	          _this2.$emit('created', response);
	        }
	        _this2.$emit('close');
	      };
	
	      var onFailure = function onFailure() {
	        _this2.isSubmitting = false;
	      };
	
	      var salaryCodeValue = this.salaryCodeId ? Number(this.salaryCodeId) : null;
	      var omkostningsstedValue = this.omkostningssted ? String(this.omkostningssted) : null;
	      var hourLimitValue = !this.localManualSalary && this.hasHourLimit && this.hourLimit ? Number(this.hourLimit) : null;
	      var hourLimitSalaryCodeValue = !this.localManualSalary && this.hasHourLimit && this.hourLimitSalaryCodeId ? Number(this.hourLimitSalaryCodeId) : null;
	      var specialHourLimitSalaryCodeValue = !this.localManualSalary && this.hasSpecialHourLimit && this.specialHourLimitSalaryCodeId ? Number(this.specialHourLimitSalaryCodeId) : null;
	      var enableEmploymentDecimalValue = this.isSalarySystemSD ? this.enableEmploymentDecimal : false;
	
	      if (this.isEditing) {
	        _docendo2.default.updateEmploymentTemplate(this.schoolId, this.templateId, this.title.trim(), this.localManualSalary, salaryCodeValue, omkostningsstedValue, hourLimitValue, hourLimitSalaryCodeValue, specialHourLimitSalaryCodeValue, enableEmploymentDecimalValue, onSuccess, onFailure);
	      } else {
	        _docendo2.default.createEmploymentTemplate(this.schoolId, this.title.trim(), this.localManualSalary, salaryCodeValue, omkostningsstedValue, hourLimitValue, hourLimitSalaryCodeValue, specialHourLimitSalaryCodeValue, enableEmploymentDecimalValue, onSuccess, onFailure);
	      }
	    },
	    onDeleteClick: function onDeleteClick() {
	      if (this.isDeleting || this.isTemplateInUse || this.isLoadingUsage) return;
	      if (!this.confirmingDelete) {
	        this.confirmingDelete = true;
	        return;
	      }
	      this.deleteEmploymentTemplate();
	    },
	    deleteEmploymentTemplate: function deleteEmploymentTemplate() {
	      var _this3 = this;
	
	      if (!this.isEditing || this.isDeleting) return;
	      this.isDeleting = true;
	
	      var onSuccess = function onSuccess(response) {
	        if (response.status === 'error') {
	          _eventbus2.default.toast = { text: response.message, 'success': false };
	        }
	        _this3.isDeleting = false;
	        _this3.$emit('deleted', response);
	        _this3.$emit('close');
	      };
	
	      var onFailure = function onFailure(error) {
	        _this3.isDeleting = false;
	        console.log('deleteEmploymentTemplate failed', error);
	      };
	
	      _docendo2.default.deleteEmploymentTemplate(this.schoolId, this.templateId, onSuccess, onFailure);
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.theEditEmploymentTemplate) {
	      var t = this.theEditEmploymentTemplate;
	      this.title = t.title || '';
	      this.salaryCodeId = typeof t.salary_code_id !== 'undefined' && t.salary_code_id !== null ? String(t.salary_code_id) : '';
	      this.omkostningssted = typeof t.omkostningssted !== 'undefined' && t.omkostningssted !== null ? String(t.omkostningssted) : '';
	      this.hourLimit = typeof t.hour_limit !== 'undefined' && t.hour_limit !== null ? String(t.hour_limit) : '';
	      this.hourLimitSalaryCodeId = typeof t.hour_limit_salary_code_id !== 'undefined' && t.hour_limit_salary_code_id !== null ? String(t.hour_limit_salary_code_id) : '';
	      this.specialHourLimitSalaryCodeId = typeof t.special_hour_limit_salary_code_id !== 'undefined' && t.special_hour_limit_salary_code_id !== null ? String(t.special_hour_limit_salary_code_id) : '';
	      this.hasSpecialHourLimit = !!this.specialHourLimitSalaryCodeId;
	      this.hasHourLimit = !!(this.hourLimit || this.hourLimitSalaryCodeId || this.specialHourLimitSalaryCodeId);
	      this.localManualSalary = !!t.manual_salary;
	      this.enableEmploymentDecimal = !!t.enable_employment_decimal;
	    }
	    if (this.forceHourLimitMode) {
	      this.localManualSalary = false;
	      this.resetManualFields();
	      this.hasHourLimit = true;
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    if (this.isEditing) {
	      this.$store.dispatch('readEmployments');
	    }
	    this.$nextTick(function (_) {
	      var el = _this4.$refs.input_title;
	      if (el) el.focus();
	    });
	  }
	};

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'EmploymentImportModal',
	  components: { DModal: _DModal2.default },
	  props: {
	    user: {
	      type: Object,
	      required: true
	    },
	
	    numberLabel: {
	      type: String,
	      default: 'Ansættelsesnummer'
	    },
	    maxLength: {
	      type: Number,
	      default: null
	    },
	
	    padLength: {
	      type: Number,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      step: 1,
	      code: '',
	      cpr: '',
	      cprSaved: false,
	      importedSchoolEmployments: [],
	      employmentTemplateId: null,
	      isSubmitting: false,
	      errorMessage: ''
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    employmentTemplates: function employmentTemplates() {
	      return this.$store.getters.employmentTemplatesSorted;
	    },
	    needsCpr: function needsCpr() {
	      return !this.user.ssn && !this.cprSaved;
	    },
	    cprDigits: function cprDigits() {
	      return String(this.cpr).replace(/\D+/g, '');
	    },
	    cprError: function cprError() {
	      if (this.cprDigits.length === 0) return '';
	      if (this.cprDigits.length !== 10) return 'CPR-nummer skal være 10 cifre';
	      return '';
	    },
	    numberToSend: function numberToSend() {
	      var val = String(this.code).trim();
	      return this.padLength ? val.padStart(this.padLength, '0') : val;
	    },
	    codeError: function codeError() {
	      var val = String(this.code).trim();
	      if (val.length === 0) return '';
	      if (!/^\d+$/.test(val)) return 'Kun cifre er tilladt';
	      if (this.maxLength && val.length > this.maxLength) return 'Maks ' + this.maxLength + ' cifre';
	      return '';
	    },
	    isValid: function isValid() {
	      var val = String(this.code).trim();
	      var codeOk = val.length > 0 && !this.codeError;
	      if (this.needsCpr) {
	        return codeOk && this.cprDigits.length === 10;
	      }
	      return codeOk;
	    }
	  },
	  methods: {
	    onCodeInput: function onCodeInput(e) {
	      var max = this.maxLength || 20;
	      this.code = String(e.target.value).replace(/\D+/g, '').slice(0, max);
	      this.errorMessage = '';
	    },
	    formatDate: function formatDate(date) {
	      if (!date) return '';
	      var parts = String(date).split('-');
	      if (parts.length !== 3) return date;
	      return parts[2] + '-' + parts[1] + '-' + parts[0];
	    },
	    formatPercent: function formatPercent(percent) {
	      var number = parseFloat(percent);
	      if (isNaN(number)) return percent;
	      return number % 1 === 0 ? String(Math.round(number)) : String(number);
	    },
	    onFetch: function onFetch() {
	      if (!this.isValid || this.isSubmitting) return;
	      this.isSubmitting = true;
	      this.errorMessage = '';
	      if (this.needsCpr) {
	        this.saveCprThenImport();
	      } else {
	        this.importEmployment();
	      }
	    },
	    resultError: function resultError(result) {
	      return result && result.status === 'error' ? result.message || 'Der skete en fejl' : null;
	    },
	    friendlyError: function friendlyError(message) {
	      if (/knows no employment/.test(message)) {
	        return 'Lønsystemet kender ikke nummeret ' + this.numberToSend + ' på denne medarbejders CPR-nummer';
	      }
	      return message;
	    },
	    saveCprThenImport: function saveCprThenImport() {
	      var _this = this;
	
	      _docendo2.default.updateUsers(this.schoolId, this.user.id, { ssn: this.cprDigits }, function (result) {
	        if (_this.resultError(result)) {
	          _this.isSubmitting = false;
	          _this.errorMessage = 'CPR-nummeret kunne ikke gemmes - det er muligvis allerede brugt';
	          return;
	        }
	        _this.cprSaved = true;
	
	        _this.$store.dispatch('getUsers');
	        _this.importEmployment();
	      }, function (failure) {
	        _this.isSubmitting = false;
	        _this.errorMessage = 'CPR-nummeret kunne ikke gemmes - det er muligvis allerede brugt';
	      });
	    },
	    importEmployment: function importEmployment() {
	      var _this2 = this;
	
	      _docendo2.default.importEmployment(this.schoolId, this.user.id, this.numberToSend, function (result) {
	        _this2.isSubmitting = false;
	        var error = _this2.resultError(result);
	        if (error) {
	          _this2.errorMessage = _this2.friendlyError(error);
	          return;
	        }
	        _this2.importedSchoolEmployments = Array.isArray(result) ? result : [];
	
	        _this2.$store.dispatch('readEmployments');
	        _this2.$emit('imported');
	        _this2.errorMessage = '';
	        _this2.step = 2;
	      }, function (failure) {
	        _this2.isSubmitting = false;
	        _this2.errorMessage = failure && failure.error ? failure.error : 'Kunne ikke hente ansættelsen fra lønsystemet';
	      });
	    },
	    onAssignTemplate: function onAssignTemplate() {
	      var _this3 = this;
	
	      if (!this.employmentTemplateId || this.isSubmitting) return;
	      var ids = this.importedSchoolEmployments.map(function (employment) {
	        return employment.id;
	      }).filter(function (id) {
	        return id != null;
	      });
	      if (ids.length === 0) {
	        this.finish();
	        return;
	      }
	      this.isSubmitting = true;
	      this.errorMessage = '';
	      _docendo2.default.assignEmploymentTemplateToEmployment(this.schoolId, this.employmentTemplateId, ids, function (result) {
	        _this3.isSubmitting = false;
	        if (_this3.resultError(result)) {
	          _this3.errorMessage = 'Stillingskategorien kunne ikke tildeles - prøv igen';
	          return;
	        }
	        _this3.finish();
	      }, function (failure) {
	        _this3.isSubmitting = false;
	        _this3.errorMessage = 'Stillingskategorien kunne ikke tildeles - prøv igen';
	      });
	    },
	    onSkipTemplate: function onSkipTemplate() {
	      this.finish();
	    },
	    finish: function finish() {
	      this.$store.dispatch('readEmployments');
	      _eventbus2.default.toast = { text: 'Ansættelsen er hentet fra lønsystemet', success: true, position: 'bottomLeft' };
	      this.$emit('close');
	    },
	    onClose: function onClose() {
	      this.$emit('close');
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    this.$nextTick(function (_) {
	      var el = _this4.needsCpr ? _this4.$refs.cpr_input : _this4.$refs.number_input;
	      if (el) el.focus();
	    });
	  }
	};

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DModal: _DModal2.default,
	    Loader: _Loader2.default,
	    Tabs: _Tabs2.default
	  },
	  data: function data() {
	    return {
	      activeTab: 'select',
	      isLoading: false,
	      isSaving: false,
	      organisations: [],
	      selectedOrganisations: [],
	      isLoadingOutside: false,
	      outsideData: null,
	      isShowAllOutside: false,
	      isLoadingUnused: false,
	      unusedEmployments: [],
	      isUnusedLoaded: false,
	      isConfirmingUnusedDelete: false,
	      isDeletingUnused: false,
	      theTabs: [{ id: 'select', title: '1. Vælg organisationer' }, { id: 'outside', title: '2. Overførsler uden for organisationer' }, { id: 'unused', title: '3. Ubrugte ansættelser' }]
	    };
	  },
	
	  computed: {
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    isFullSize: function isFullSize() {
	      return this.activeTab !== 'select';
	    },
	    usersInHash: function usersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    countsByOrganisation: function countsByOrganisation() {
	      var hash = {};
	      this.$store.state.employments.employments.forEach(function (employment) {
	        if (employment.deleted) {
	          return;
	        }
	        var key = employment.organisation || '';
	        if (!hash[key]) {
	          hash[key] = { total: 0, withTemplate: 0 };
	        }
	        hash[key].total++;
	        if (employment.employment_template_id != null && employment.employment_template_id !== '') {
	          hash[key].withTemplate++;
	        }
	      });
	      return hash;
	    },
	    outsideEmployments: function outsideEmployments() {
	      if (!this.outsideData) {
	        return [];
	      }
	      return this.outsideData.employments.map(function (employment) {
	        var safe = function safe(key) {
	          return Array.isArray(employment[key]) ? employment[key] : [];
	        };
	        var positionIds = safe('positions').map(function (position) {
	          return position.school_employment_id;
	        });
	
	        var kmdRows = safe('kmd_engangsydelser').reduce(function (rows, record) {
	          var payload = Array.isArray(record.engangsydelser) ? record.engangsydelser : [];
	          payload.forEach(function (row) {
	            rows.push((0, _extends3.default)({}, row, { v_status: record.status, v_created_at: record.created_at }));
	          });
	          return rows;
	        }, []);
	
	        var salaryDays = safe('salary_days').map(function (day) {
	          var sums = Array.isArray(day.sums) ? day.sums : [];
	          var minutes = sums.filter(function (sum) {
	            return sum && positionIds.indexOf(sum.employment_id * 1) > -1;
	          }).reduce(function (total, sum) {
	            return total + (sum.minutes * 1 || 0);
	          }, 0);
	          return (0, _extends3.default)({}, day, { v_minutes: minutes });
	        });
	
	        return (0, _extends3.default)({}, employment, {
	          salary_supplements: safe('salary_supplements'),
	          absences: safe('absences'),
	          sd_engangsydelser: safe('sd_engangsydelser'),
	          sd_fravaer: safe('sd_fravaer'),
	          sd_loenaendringer: safe('sd_loenaendringer'),
	          sd_tillaeg: safe('sd_tillaeg'),
	          v_kmd_rows: kmdRows,
	          v_salary_days: salaryDays
	        });
	      });
	    },
	    employmentsWithTransfers: function employmentsWithTransfers() {
	      var _this = this;
	
	      return this.outsideEmployments.filter(function (employment) {
	        return _this.transfersCount(employment) > 0;
	      });
	    },
	    shownEmployments: function shownEmployments() {
	      return this.isShowAllOutside ? this.outsideEmployments : this.employmentsWithTransfers;
	    }
	  },
	  methods: {
	    transfersCount: function transfersCount(employment) {
	      return employment.salary_supplements.length + employment.absences.length + employment.sd_engangsydelser.length + employment.sd_fravaer.length + employment.sd_loenaendringer.length + employment.sd_tillaeg.length + employment.v_kmd_rows.length + employment.v_salary_days.length;
	    },
	    setActiveTab: function setActiveTab(tabId) {
	      this.activeTab = tabId;
	      if (tabId === 'outside') {
	        this.readOutside();
	      }
	      if (tabId === 'unused') {
	        this.readUnused();
	      }
	    },
	    userName: function userName(userId) {
	      var user = this.usersInHash[userId];
	      return user && user.name ? user.name : 'Bruger ' + userId;
	    },
	    readUnused: function readUnused() {
	      var _this2 = this;
	
	      this.isLoadingUnused = true;
	      this.isConfirmingUnusedDelete = false;
	      _docendo2.default.unusedEmployments(this.schoolId, function (data) {
	        _this2.unusedEmployments = Array.isArray(data) ? data : [];
	        _this2.isUnusedLoaded = true;
	        _this2.isLoadingUnused = false;
	      }, function (failure) {
	        console.log(failure);
	        _this2.isLoadingUnused = false;
	        _eventbus2.default.toast = { text: 'Kunne ikke hente ubrugte ansættelser', success: false, position: 'bottomLeft' };
	      });
	    },
	    deleteUnused: function deleteUnused() {
	      var _this3 = this;
	
	      if (this.isDeletingUnused) {
	        return;
	      }
	      this.isDeletingUnused = true;
	      _docendo2.default.deleteUnusedEmployments(this.schoolId, function (data) {
	        var count = Array.isArray(data) ? data.length : 0;
	        _this3.isDeletingUnused = false;
	        _this3.isConfirmingUnusedDelete = false;
	        _this3.unusedEmployments = [];
	        _eventbus2.default.toast = {
	          text: count + ' ' + (count === 1 ? 'ansættelse' : 'ansættelser') + ' slettet',
	          success: true,
	          position: 'bottomLeft'
	        };
	
	        _this3.$store.dispatch('readEmployments');
	      }, function (failure) {
	        console.log(failure);
	        _this3.isDeletingUnused = false;
	        _this3.isConfirmingUnusedDelete = false;
	        _eventbus2.default.toast = { text: 'Kunne ikke slette ansættelserne', success: false, position: 'bottomLeft' };
	      });
	    },
	    formatDate: function formatDate(date) {
	      return date ? (0, _moment2.default)(date).format('DD-MM-YYYY') : '';
	    },
	    formatPeriod: function formatPeriod(from, to) {
	      if (!from && !to) {
	        return '';
	      }
	      return this.formatDate(from) + ' - ' + this.formatDate(to);
	    },
	    formatSdDate: function formatSdDate(ydelse) {
	      if (!ydelse.aar) {
	        return '';
	      }
	      var pad = function pad(value) {
	        return (value * 1 < 10 ? '0' : '') + value;
	      };
	      return pad(ydelse.dag) + '-' + pad(ydelse.maaned) + '-' + ydelse.aar;
	    },
	    formatMinutes: function formatMinutes(minutes) {
	      if (!minutes) {
	        return '';
	      }
	      var hours = Math.floor(minutes / 60);
	      var rest = Math.round(minutes % 60);
	      return hours + 't ' + (rest < 10 ? '0' : '') + rest + 'm';
	    },
	    organisationCounts: function organisationCounts(organisation) {
	      return this.countsByOrganisation[organisation || ''] || { total: 0, withTemplate: 0 };
	    },
	    isSelected: function isSelected(organisation) {
	      return this.selectedOrganisations.indexOf(organisation) > -1;
	    },
	    toggleOrganisation: function toggleOrganisation(organisation) {
	      var idx = this.selectedOrganisations.indexOf(organisation);
	      if (idx > -1) {
	        this.selectedOrganisations.splice(idx, 1);
	      } else {
	        this.selectedOrganisations.push(organisation);
	      }
	    },
	    readOrganisations: function readOrganisations() {
	      var _this4 = this;
	
	      this.isLoading = true;
	      _docendo2.default.listSalaryOrganisations(this.schoolId, function (data) {
	        _this4.organisations = data;
	        _this4.isLoading = false;
	      }, function (failure) {
	        console.log(failure);
	        _this4.isLoading = false;
	        _eventbus2.default.toast = { text: 'Kunne ikke hente organisationer', success: false, position: 'bottomLeft' };
	      });
	    },
	    readOutside: function readOutside() {
	      var _this5 = this;
	
	      this.isLoadingOutside = true;
	
	      setTimeout(function () {
	        _docendo2.default.employmentsOutsideSalaryOrganisations(_this5.schoolId, function (data) {
	          _this5.outsideData = data;
	          _this5.isLoadingOutside = false;
	        }, function (failure) {
	          console.log(failure);
	          _this5.isLoadingOutside = false;
	          _eventbus2.default.toast = { text: 'Kunne ikke hente overførsler', success: false, position: 'bottomLeft' };
	        });
	      }, 0);
	    },
	    save: function save() {
	      var _this6 = this;
	
	      if (this.isLoading || this.isSaving) {
	        return;
	      }
	      this.isSaving = true;
	      _docendo2.default.updateSchool(this.schoolId, { salary_organisations: this.selectedOrganisations }, function (success) {
	        _this6.isSaving = false;
	        _this6.$store.commit('setActiveSchool', (0, _extends3.default)({}, _this6.school, { salary_organisations: success.salary_organisations }));
	        _eventbus2.default.toast = { text: 'Gemt', success: true, position: 'bottomLeft' };
	
	        _this6.setActiveTab('outside');
	      }, function (failure) {
	        console.log(failure);
	        _this6.isSaving = false;
	        _eventbus2.default.toast = { text: 'Kunne ikke gemme organisationer', success: false, position: 'bottomLeft' };
	      });
	    }
	  },
	  mounted: function mounted() {
	    var saved = this.school && this.school.salary_organisations;
	    this.selectedOrganisations = Array.isArray(saved) ? saved.slice() : [];
	    this.readOrganisations();
	  }
	};

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _SalarySettingsUsers = __webpack_require__(1573);
	
	var _SalarySettingsUsers2 = _interopRequireDefault(_SalarySettingsUsers);
	
	var _SalaryRule = __webpack_require__(1576);
	
	var _SalaryRule2 = _interopRequireDefault(_SalaryRule);
	
	var _SalaryRule3 = __webpack_require__(1577);
	
	var _SalaryRule4 = _interopRequireDefault(_SalaryRule3);
	
	var _SalaryRule5 = __webpack_require__(1578);
	
	var _SalaryRule6 = _interopRequireDefault(_SalaryRule5);
	
	var _SalaryRule7 = __webpack_require__(1579);
	
	var _SalaryRule8 = _interopRequireDefault(_SalaryRule7);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _CostCenters = __webpack_require__(143);
	
	var _CostCenters2 = _interopRequireDefault(_CostCenters);
	
	var _SalaryCodes = __webpack_require__(144);
	
	var _SalaryCodes2 = _interopRequireDefault(_SalaryCodes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SalaryCodes: _SalaryCodes2.default,
	    CostCenters: _CostCenters2.default,
	    Loader: _Loader2.default, SalaryRule1: _SalaryRule2.default, SalaryRule2: _SalaryRule4.default, SalaryRule3: _SalaryRule6.default, SalaryRule4: _SalaryRule8.default, SalarySettingsUsers: _SalarySettingsUsers2.default, DModal: _DModal2.default
	  },
	  props: {
	    isSalaryIntegrationActive: {
	      type: Boolean,
	      default: false
	    },
	    isSDIntegrationActive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isSubmitting: false,
	      isValidated: false,
	      theActiveTab: 1,
	      isChangesMade: true,
	      theEditUser: null,
	      isInitLoading: true
	    };
	  },
	
	  computed: {
	    tabs: function tabs() {
	      if (this.isSalaryIntegrationActive && !this.isSDIntegrationActive) {
	        return [{ id: 7, title: '1. Lønkoder' }, { id: 6, title: '2. Omkostningssteder' }, { id: 1, title: '3. Tilføj stillingskategorier til ansættelser' }, { id: 2, title: '4. Hvornår skal hvilken ansættelse bruges' }, { id: 5, title: '5. Skal der gives tid før første lektion' }, { id: 3, title: '6. Hvordan tæller mellemtimer' }, { id: 4, title: '7. Er der et minimum antal timer' }];
	      } else if (this.isSalaryIntegrationActive && this.isSDIntegrationActive) {
	        return [{ id: 7, title: '1. Lønkoder' }, { id: 6, title: '2. Omkostningssteder' }, { id: 1, title: '4. Tilføj stillingskategorier til ansættelser' }, { id: 2, title: '5. Hvornår skal hvilken ansættelse bruges' }, { id: 5, title: '6. Skal der gives tid før første lektion' }, { id: 3, title: '7. Hvordan tæller mellemtimer' }, { id: 4, title: '8. Er der et minimum antal timer' }];
	      } else {
	        return [{ id: 1, title: '1. Opret ansættelser' }, { id: 2, title: '2. Hvornår skal hvilken ansættelse bruges' }, { id: 5, title: '3. Skal der gives tid før første lektion' }, { id: 3, title: '4. Hvordan tæller mellemtimer' }, { id: 4, title: '5. Er der et minimum antal timer' }, { id: 6, title: '6. Omkostningssteder' }];
	      }
	    },
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolSubstituteRules: function schoolSubstituteRules() {
	      if (this.school && this.school.substitute_rules) {
	        return this.school.substitute_rules;
	      }
	    },
	    rules: function rules() {
	      return this.schoolSubstituteRules && this.schoolSubstituteRules.rules ? this.schoolSubstituteRules.rules : [];
	    },
	    config: function config() {
	      return this.schoolSubstituteRules && this.schoolSubstituteRules.configuration ? this.schoolSubstituteRules.configuration : {};
	    },
	    costCenterRules: function costCenterRules() {
	      return this.schoolSubstituteRules && this.schoolSubstituteRules.cost_center_rules ? this.schoolSubstituteRules.cost_center_rules : [];
	    }
	  },
	  methods: {
	    setEditUser: function setEditUser(user) {
	      this.theEditUser = user;
	    },
	    onClose: function onClose() {
	      if (this.isChangesMade) {
	        this.$emit('update');
	      }
	      this.$emit('close');
	      this.isChangesMade = false;
	    },
	    setTheActiveTab: function setTheActiveTab(tabId) {
	      this.theActiveTab = tabId;
	    },
	    updateSchoolConfiguration: function updateSchoolConfiguration(dbConfig, employmentRules) {
	      var _this = this;
	
	      var dbRules = JSON.parse((0, _stringify2.default)(this.schoolSubstituteRules));
	      if (!dbConfig || (0, _keys2.default)(dbConfig).length === 0) {
	        delete dbRules.configuration;
	      } else {
	        dbRules['configuration'] = dbConfig;
	      }
	      if (employmentRules && employmentRules.length === 0) {
	        delete dbRules.rules;
	      }
	      if (employmentRules) {
	        dbRules['rules'] = employmentRules;
	      }
	      this.isSaving = true;
	      this.isChangesMade = true;
	      _docendo2.default.updateSchool(this.schoolId, { substitute_rules: dbRules }, function (success) {
	        _eventbus2.default.toast = { text: 'Gemt', 'success': true };
	        _this.isSaving = false;
	        _this.$store.commit('setActiveSchool', success);
	        _this.$store.commit('setSchoolSettings', success.custom_data);
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    updateCostCenterRules: function updateCostCenterRules(incomingRules) {
	      var _this2 = this;
	
	      var dbRules = JSON.parse((0, _stringify2.default)(this.schoolSubstituteRules || {}));
	
	      var existing = Array.isArray(this.costCenterRules) ? this.costCenterRules : [];
	      var updates = Array.isArray(incomingRules) ? incomingRules : [];
	
	      var byCostCenterId = {};
	      for (var i = 0; i < existing.length; i++) {
	        var r = existing[i];
	        if (r && r.selected_cost_center_id != null) {
	          byCostCenterId[r.selected_cost_center_id] = r;
	        }
	      }
	
	      for (var _i = 0; _i < updates.length; _i++) {
	        var u = updates[_i];
	        if (!u || u.selected_cost_center_id == null) continue;
	
	        if (Array.isArray(u.calendar_ids) && u.calendar_ids.length === 0) {
	          delete byCostCenterId[u.selected_cost_center_id];
	          continue;
	        }
	
	        var prev = byCostCenterId[u.selected_cost_center_id];
	        var next = {
	          type: 'calendars',
	          calendar_ids: Array.isArray(u.calendar_ids) ? u.calendar_ids.slice() : [],
	          selected_cost_center_id: u.selected_cost_center_id
	        };
	
	        next.id = u.id ? u.id : prev && prev.id ? prev.id : this.generateUUID();
	
	        byCostCenterId[u.selected_cost_center_id] = next;
	      }
	
	      var merged = [];
	      for (var k in byCostCenterId) {
	        if (byCostCenterId.hasOwnProperty(k)) {
	          merged.push(byCostCenterId[k]);
	        }
	      }
	
	      if (merged.length === 0) {
	        delete dbRules.cost_center_rules;
	      } else {
	        dbRules.cost_center_rules = merged;
	      }
	
	      this.isSaving = true;
	      this.isChangesMade = true;
	
	      _docendo2.default.updateSchool(this.schoolId, { substitute_rules: dbRules }, function (success) {
	        _eventbus2.default.toast = { text: 'Gemt', success: true };
	        _this2.isSaving = false;
	        _this2.$store.commit('setActiveSchool', success);
	        _this2.$store.commit('setSchoolSettings', success.custom_data);
	      }, function (failure) {
	        console.log({ failure: failure });
	        _this2.isSaving = false;
	      });
	    },
	    generateUUID: function generateUUID() {
	      var d = new Date().getTime();
	      var d2 = window.performance && window.performance.now && window.performance.now() * 1000 || 0;
	      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        var r = Math.random() * 16;
	        if (d > 0) {
	          r = (d + r) % 16 | 0;
	          d = Math.floor(d / 16);
	        } else {
	          r = (d2 + r) % 16 | 0;
	          d2 = Math.floor(d2 / 16);
	        }
	        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.isInitLoading = true;
	    setTimeout(function (_) {
	      _this3.isInitLoading = false;
	    }, 500);
	  }
	};

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ModalConfirmation: _ModalConfirmation2.default, AppToggle: _AppToggle2.default, DModal: _DModal2.default },
	  props: {
	    isCreateNewEmploymentTitle: {
	      type: Boolean,
	      default: false
	    },
	    isManualSalary: {
	      type: Boolean,
	      default: false
	    },
	    selectedUsers: {
	      type: Array,
	      default: []
	    }
	  },
	  data: function data() {
	    return {
	      title: '',
	      isDeleteConfirm: false,
	      isDeleting: false
	    };
	  },
	
	  computed: {
	    isValid: function isValid() {
	      return this.isCreateNewEmploymentTitle ? this.title.length > 0 : true;
	    }
	  },
	  methods: {
	    onSubmit: function onSubmit() {
	      if (this.isCreateNewEmploymentTitle) {
	        this.$emit('save', this.title);
	      } else {
	        this.$emit('save');
	      }
	      this.$emit('close');
	    }
	  },
	  mounted: function mounted() {
	    if (this.isCreateNewEmploymentTitle) {
	      this.$refs.title_input.focus();
	    }
	  }
	};

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _SalarySettingsUsersUser = __webpack_require__(1574);
	
	var _SalarySettingsUsersUser2 = _interopRequireDefault(_SalarySettingsUsersUser);
	
	var _SalarySettingsCreateEmploymentType = __webpack_require__(1572);
	
	var _SalarySettingsCreateEmploymentType2 = _interopRequireDefault(_SalarySettingsCreateEmploymentType);
	
	var _SalarySettingsUsersOpus = __webpack_require__(141);
	
	var _SalarySettingsUsersOpus2 = _interopRequireDefault(_SalarySettingsUsersOpus);
	
	var _SalarySettingsUsersOpusTable = __webpack_require__(378);
	
	var _SalarySettingsUsersOpusTable2 = _interopRequireDefault(_SalarySettingsUsersOpusTable);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: {
	    AppToggle: _AppToggle2.default,
	    SalarySettingsUsersTable: _SalarySettingsUsersOpusTable2.default,
	    SalarySettingsUsersOpus: _SalarySettingsUsersOpus2.default,
	    SalarySettingsCreateEmploymentType: _SalarySettingsCreateEmploymentType2.default,
	    Tabs: _Tabs2.default,
	    DoFiltersFilter: _DoFiltersFilter2.default,
	    SalarySettingsUsersUser: _SalarySettingsUsersUser2.default
	  },
	  props: {
	    isSalaryIntegrationActive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      tags: [],
	      appliedFilters: [],
	      selectedUsers: [],
	      selectedEmployments: [],
	      isDropdown: false,
	      theEditUser: null,
	      theEditUserEmployment: null,
	      isAddEmploymentModal: false,
	      isCreateNewEmploymentTitle: false,
	      isManualSalary: false,
	      selectedOrganisations: [],
	      theTabs: [{ id: 'all', title: 'Alle' }, { id: 'without', title: 'Uden ansættelse' }],
	      theSelectedTab: 'all'
	    };
	  },
	
	  computed: {
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    isSubmittingUsers: function isSubmittingUsers() {
	      return this.$store.state.employments.isSubmittingUser;
	    },
	    employments: function employments() {
	      return this.$store.state.employments.employments;
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash;
	    },
	    employmentsTypes: function employmentsTypes() {
	      return this.$store.state.employments.employmentsTypes;
	    },
	    employmentTypesSorted: function employmentTypesSorted() {
	      return this.$store.getters.employmentTypesActive;
	    },
	    employmentsTypesForDropdown: function employmentsTypesForDropdown() {
	      var _this = this;
	
	      return this.employmentTypesSorted.map(function (employmentType) {
	        return {
	          v_title: employmentType,
	          v_isSelected: _this.selectedEmployments.findIndex(function (selectedEmployment) {
	            return selectedEmployment === employmentType;
	          }) > -1
	        };
	      });
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    usersWithEmployments: function usersWithEmployments() {
	      var _this2 = this;
	
	      return this.users.map(function (user) {
	        var employments = _this2.employmentsInUserIdHash[user.id] ? _this2.employmentsInUserIdHash[user.id] : [];
	        var employmentsSorted = employments.sort(function (a, b) {
	          return a.title.localeCompare(b.title);
	        });
	        return (0, _extends3.default)({}, user, {
	          v_employments: employmentsSorted.filter(function (employment) {
	            return !employment.deleted;
	          }),
	          v_oldEmployments: employmentsSorted.filter(function (employment) {
	            return employment.deleted;
	          })
	        });
	      });
	    },
	    usersWithSelection: function usersWithSelection() {
	      var _this3 = this;
	
	      return this.usersWithEmployments.map(function (user) {
	        return (0, _extends3.default)({}, user, {
	          v_isSelected: _this3.selectedUsers.findIndex(function (selectedUser) {
	            return selectedUser.id === user.id;
	          }) > -1
	        });
	      });
	    },
	    filteredUsers: function filteredUsers() {
	      var _this4 = this;
	
	      var list = this.usersWithSelection;
	      if (this.appliedFilters.length > 0) {
	        list = list.filter(function (user) {
	          return user.user_tags && user.user_tags.some(function (tag) {
	            return _this4.appliedFilters.includes(tag);
	          });
	        });
	      }
	      if (this.theSelectedTab === 'without') {
	        list = list.filter(function (user) {
	          return !user.v_employments || user.v_employments.length === 0;
	        });
	      }
	      return list;
	    }
	  },
	  methods: {
	    setIsManualSalary: function setIsManualSalary(bool) {
	      this.isManualSalary = bool;
	    },
	    setIsCreateNewEmploymentTitle: function setIsCreateNewEmploymentTitle(bool) {
	      this.isCreateNewEmploymentTitle = bool;
	      if (bool) {
	        this.setIsAddExistingEmploymentsToUsers(true);
	      }
	    },
	    setIsAddExistingEmploymentsToUsers: function setIsAddExistingEmploymentsToUsers(bool) {
	      this.isAddEmploymentModal = bool;
	      if (this.isCreateNewEmploymentTitle) {
	        this.selectedEmployments = [];
	      }
	      if (!bool) {
	        this.isManualSalary = false;
	        this.setIsCreateNewEmploymentTitle(false);
	      }
	    },
	    updateEmployment: function updateEmployment(employment) {
	      var _this5 = this;
	
	      var dbObj = {
	        schoolId: employment.school_id,
	        userId: employment.user_id,
	        employmentId: employment.id,
	        manualSalary: !employment.manual_salary,
	        defaultLoenart: employment.default_loenart ? employment.default_loenart * 1 : null,
	        defaultLoebenummer: employment.default_loebenummer ? employment.default_loebenummer * 1 : null
	      };
	      _docendo2.default.updateEmployment(dbObj.schoolId, dbObj.userId, dbObj.employmentId, dbObj.manualSalary, dbObj.defaultLoenart, dbObj.defaultLoebenummer, function (success) {
	        _this5.$store.dispatch('readEmployments');
	      }, function (failure) {
	        console.log('failure!');
	      });
	    },
	    setTheEditUserEmployment: function setTheEditUserEmployment(userAndEmployment) {
	      if (userAndEmployment.context === 'manual_salary') {
	        this.updateEmployment(userAndEmployment.employment);
	        return;
	      }
	      this.theEditUserEmployment = userAndEmployment.employment;
	      this.theEditUser = userAndEmployment.user;
	    },
	    setTheEditUser: function setTheEditUser(user) {
	      if (!user) {
	        this.theEditUserEmployment = null;
	      }
	      this.theEditUser = user;
	      this.$emit('setEditUser', user);
	    },
	    setIsDropdown: function setIsDropdown() {
	      if (!this.isDropdown) {
	        this.selectedEmployments = [];
	      }
	      this.isDropdown = !this.isDropdown;
	    },
	    saveForUsers: function saveForUsers(newEmploymentTitle) {
	      var _this6 = this;
	
	      if (this.selectedUsers.length < 1) {
	        return;
	      }
	      if (newEmploymentTitle) {
	        this.selectedEmployments.push(newEmploymentTitle);
	      }
	      if (this.selectedEmployments.length < 1) {
	        return;
	      }
	
	      var dbObj = {
	        schoolId: this.schoolId,
	        userIds: [],
	        employmentTypeIds: [],
	        isManualSalary: this.isManualSalary
	      };
	
	      var selectedEmploymentTypeIds = this.selectedEmployments.map(function (employment) {
	        return employment;
	      });
	      var usersWithEmployments = {};
	
	      this.selectedUsers.forEach(function (user) {
	        var userEmployments = user.v_employments.map(function (employment) {
	          return employment.title;
	        });
	
	        selectedEmploymentTypeIds.forEach(function (employmentTypeId) {
	          if (userEmployments.includes(employmentTypeId)) {
	            if (usersWithEmployments[employmentTypeId]) {
	              usersWithEmployments[employmentTypeId].push(user.id);
	            } else {
	              usersWithEmployments[employmentTypeId] = [user.id];
	            }
	          }
	        });
	      });
	
	      if ((0, _keys2.default)(usersWithEmployments).length === 0) {
	        dbObj.userIds = this.selectedUsers.map(function (user) {
	          return user.id;
	        });
	        dbObj.employmentTypeIds = selectedEmploymentTypeIds;
	        this.$emit('changedMade');
	        this.$store.dispatch('createEmployments', dbObj);
	        this.reset();
	      } else {
	        var numberOfUpdatesToCompleted = this.selectedEmployments.length;
	        var numberOfUpdates = 0;
	        this.selectedEmployments.forEach(function (selectedEmployment, key) {
	          var userIdsArr = usersWithEmployments[selectedEmployment] ? usersWithEmployments[selectedEmployment] : [];
	          var newUserIds = _this6.selectedUsers.filter(function (user) {
	            return !userIdsArr.includes(user.id);
	          }).map(function (user) {
	            return user.id;
	          });
	          if (newUserIds.length > 0) {
	            var newObj = {
	              schoolId: _this6.schoolId,
	              userIds: newUserIds,
	              employmentTypeIds: [selectedEmployment],
	              isManualSalary: _this6.isManualSalary
	            };
	            _this6.$emit('changedMade');
	            _this6.$store.dispatch('createEmployments', newObj);
	            numberOfUpdates++;
	            if (numberOfUpdates === numberOfUpdatesToCompleted) {
	              _this6.reset();
	            }
	          }
	        });
	      }
	    },
	    reset: function reset() {
	      this.selectedUsers = [];
	      this.selectedEmployments = [];
	      this.isDropdown = false;
	    },
	    selectedEmploymentsType: function selectedEmploymentsType(employmentsType) {
	      var idx = this.selectedEmployments.findIndex(function (selectedEmployment) {
	        return selectedEmployment === employmentsType;
	      });
	      if (idx < 0) {
	        this.selectedEmployments.push(employmentsType);
	      } else {
	        this.selectedEmployments.splice(idx, 1);
	      }
	    },
	    onClickAway: function onClickAway() {
	      if (!this.isDropdown) {
	        return;
	      }
	      this.selectedEmployments = [];
	      this.isDropdown = false;
	    },
	    toggleUser: function toggleUser(user) {
	      var idx = this.selectedUsers.findIndex(function (selectedUser) {
	        return selectedUser.id === user.id;
	      });
	      if (idx < 0) {
	        this.selectedUsers.push(user);
	      } else {
	        this.selectedUsers.splice(idx, 1);
	      }
	    },
	    toggleAll: function toggleAll() {
	      var _this7 = this;
	
	      if (this.selectedUsers.length > 0) {
	        this.selectedUsers = [];
	      } else {
	        this.selectedUsers = [];
	        this.filteredUsers.forEach(function (user) {
	          return _this7.selectedUsers.push(user);
	        });
	      }
	    },
	    setTagFromFilter: function setTagFromFilter(tag) {
	      this.selectedUsers = [];
	      this.appliedFilters.push(tag);
	    },
	    removeTagFromFilter: function removeTagFromFilter(tag) {
	      this.selectedUsers = [];
	      this.appliedFilters.splice(this.appliedFilters.indexOf(tag), 1);
	    },
	    clearAllTags: function clearAllTags() {
	      this.selectedUsers = [];
	      this.appliedFilters = [];
	    },
	    readAllEmployments: function readAllEmployments() {
	      this.$store.dispatch('readEmploymentTypes');
	      this.$store.dispatch('readEmployments');
	    },
	    readTags: function readTags() {
	      var _this8 = this;
	
	      this.isLoadingTags = true;
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this8.tags = data;
	        _this8.isLoadingTags = false;
	      });
	    },
	    setTbodyMaxHeight: function setTbodyMaxHeight() {
	      var tbody = this.$refs['d-b'];
	      if (!tbody) {
	        return;
	      }
	      var tbodyTop = tbody.getBoundingClientRect().top;
	      var windowHeight = window.innerHeight;
	      var maxHeight = windowHeight - tbodyTop - 20;
	
	      tbody.style.maxHeight = maxHeight + 'px';
	    }
	  },
	  mounted: function mounted() {
	    this.readTags();
	    this.readAllEmployments();
	    this.setTbodyMaxHeight();
	    window.addEventListener('resize', this.setTbodyMaxHeight);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.setTbodyMaxHeight);
	  }
	};

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _from = __webpack_require__(32);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _set = __webpack_require__(27);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SalarySettingsUsersOpusTable = __webpack_require__(378);
	
	var _SalarySettingsUsersOpusTable2 = _interopRequireDefault(_SalarySettingsUsersOpusTable);
	
	var _SalarySsnModal = __webpack_require__(1575);
	
	var _SalarySsnModal2 = _interopRequireDefault(_SalarySsnModal);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _TaggingFilter = __webpack_require__(43);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	var _DoEmploymentDropdown = __webpack_require__(1570);
	
	var _DoEmploymentDropdown2 = _interopRequireDefault(_DoEmploymentDropdown);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Tabs: _Tabs2.default, DoEmploymentDropdown: _DoEmploymentDropdown2.default, TaggingFilter: _TaggingFilter2.default, DoFiltersFilter: _DoFiltersFilter2.default, SalarySettingsUsersTable: _SalarySettingsUsersOpusTable2.default, SalarySsnModal: _SalarySsnModal2.default, Loader: _Loader2.default, DModal: _DModal2.default },
	  props: {
	    users: {
	      default: function _default() {
	        return [];
	      }
	    },
	    employments: {
	      default: function _default() {
	        return [];
	      }
	    },
	    tags: {
	      default: function _default() {
	        return [];
	      }
	    },
	    isSalaryIntegrationActive: {
	      type: Boolean,
	      default: false
	    },
	    isShowEmploymentNumber: {
	      type: Boolean,
	      default: false
	    },
	    filtersStorageKey: {
	      type: String,
	      default: 'salaryUsersOpusFilters'
	    },
	    rowActionLabel: {
	      type: String,
	      default: ''
	    },
	
	    confirmRemoveTemplateOnTagClick: {
	      type: Boolean,
	      default: false
	    },
	
	    emitEditSsn: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      selectedTags: [],
	      selectedEmploymentTitles: [],
	      selectedOrganisations: [],
	      selectedEmploymentIds: [],
	      isSubmitting: false,
	      selectedNames: [],
	      selectedTemplateTab: 'all',
	      theSsnUser: null,
	      templateRemovalTarget: null,
	      isRemovingTemplate: false,
	      employmentRemovalTarget: null,
	      isRemovingEmployment: false
	    };
	  },
	
	  computed: {
	    employmentTemplates: function employmentTemplates() {
	      return this.$store.getters.employmentTemplatesSorted;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    storageKey: function storageKey() {
	      return this.filtersStorageKey + ':' + (this.schoolId || 'default');
	    },
	    filtersSnapshot: function filtersSnapshot() {
	      return (0, _stringify2.default)({
	        selectedTags: this.selectedTags,
	        selectedEmploymentTitles: this.selectedEmploymentTitles,
	        selectedOrganisations: this.selectedOrganisations,
	        selectedNames: this.selectedNames,
	        selectedTemplateTab: this.selectedTemplateTab
	      });
	    },
	    personNames: function personNames() {
	      var names = new _set2.default();
	      this.users.forEach(function (u) {
	        if (u && u.name) names.add(u.name);
	      });
	      return (0, _from2.default)(names).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    organisations: function organisations() {
	      var organisations = new _set2.default();
	      this.employments.forEach(function (employment) {
	        if (employment.organisation) {
	          organisations.add(employment.organisation);
	        }
	      });
	      return (0, _from2.default)(organisations).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    employmentTitles: function employmentTitles() {
	      var titles = new _set2.default();
	      this.employments.forEach(function (e) {
	        if (e.title) titles.add(e.title);
	      });
	      return (0, _from2.default)(titles).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    hasEmploymentFilter: function hasEmploymentFilter() {
	      return this.selectedOrganisations.length > 0 || this.selectedEmploymentTitles.length > 0;
	    },
	    filteredEmployments: function filteredEmployments() {
	      var _this = this;
	
	      var hasOrgFilter = this.selectedOrganisations.length > 0;
	      var hasTitleFilter = this.selectedEmploymentTitles.length > 0;
	
	      return this.employments.filter(function (e) {
	        var orgOk = hasOrgFilter ? _this.selectedOrganisations.indexOf(e.organisation) > -1 : true;
	        var titleOk = hasTitleFilter ? _this.selectedEmploymentTitles.indexOf(e.title) > -1 : true;
	        return orgOk && titleOk;
	      });
	    },
	    filteredUsers: function filteredUsers() {
	      var _this2 = this;
	
	      var allEmploymentsForUser = function allEmploymentsForUser(userId) {
	        return _this2.employments.filter(function (e) {
	          return e.user_id === userId;
	        });
	      };
	
	      var matchedEmploymentsForUser = function matchedEmploymentsForUser(userId) {
	        return _this2.filteredEmployments.filter(function (e) {
	          return e.user_id === userId;
	        });
	      };
	
	      return this.users.filter(function (user) {
	        if (_this2.selectedNames.length > 0) {
	          return _this2.selectedNames.indexOf(user.name) > -1;
	        } else {
	          return true;
	        }
	      }).filter(function (user) {
	        if (_this2.selectedTags.length > 0) {
	          return user.user_tags && user.user_tags.some(function (tag) {
	            return _this2.selectedTags.indexOf(tag) > -1;
	          });
	        } else {
	          return true;
	        }
	      }).filter(function (user) {
	        if (!_this2.hasEmploymentFilter) return true;
	
	        if (_this2.selectedOrganisations.length > 0 && _this2.selectedEmploymentTitles.length === 0 && allEmploymentsForUser(user.id).length === 0) return true;
	        var emps = matchedEmploymentsForUser(user.id);
	        return emps.length > 0;
	      }).filter(function (user) {
	        if (_this2.selectedTemplateTab === 'all') return true;
	        var emps = _this2.hasEmploymentFilter ? matchedEmploymentsForUser(user.id) : allEmploymentsForUser(user.id);
	        return emps.some(function (e) {
	          return _this2.hasStillingskategori(e);
	        });
	      }).map(function (user) {
	        var emps = _this2.hasEmploymentFilter ? matchedEmploymentsForUser(user.id) : allEmploymentsForUser(user.id);
	
	        return (0, _extends3.default)({}, user, {
	          v_employments: emps.sort(function (a, b) {
	            var aTitle = a && (a.source_title || a.title) ? a.source_title || a.title : '';
	            var bTitle = b && (b.source_title || b.title) ? b.source_title || b.title : '';
	            return aTitle.localeCompare(bTitle, 'da-DK');
	          })
	        });
	      });
	    },
	    usersWithTemplateCount: function usersWithTemplateCount() {
	      var _this3 = this;
	
	      var allEmploymentsForUser = function allEmploymentsForUser(userId) {
	        return _this3.employments.filter(function (e) {
	          return e.user_id === userId;
	        });
	      };
	      var count = 0;
	      this.users.forEach(function (u) {
	        var emps = allEmploymentsForUser(u.id);
	        var hasTemplate = emps.some(function (e) {
	          return _this3.hasStillingskategori(e);
	        });
	        if (hasTemplate) count = count + 1;
	      });
	      return count;
	    },
	    templateTabs: function templateTabs() {
	      var allCount = this.users.length;
	      var withTpl = this.usersWithTemplateCount;
	      return [{ id: 'all', title: 'Alle (' + allCount + ')' }, { id: 'with_template', title: 'Med stillingskategori (' + withTpl + ')' }];
	    }
	  },
	  watch: {
	    filtersSnapshot: function filtersSnapshot(val) {
	      this.persistFilters(val);
	    },
	    selectedNames: function selectedNames() {
	      this.selectedEmploymentIds = [];
	    },
	    selectedTags: function selectedTags() {
	      this.selectedEmploymentIds = [];
	    },
	    selectedEmploymentTitles: function selectedEmploymentTitles() {
	      this.selectedEmploymentIds = [];
	    },
	    selectedOrganisations: function selectedOrganisations() {
	      this.selectedEmploymentIds = [];
	    }
	  },
	  methods: {
	    hasStillingskategori: function hasStillingskategori(employment) {
	      return !!employment && employment.employment_template_id != null && employment.employment_template_id !== undefined;
	    },
	    onEditSsn: function onEditSsn(user) {
	      if (this.emitEditSsn) {
	        this.$emit('editSsn', user);
	      } else {
	        this.theSsnUser = user;
	      }
	    },
	    onEditEmployment: function onEditEmployment(payload) {
	      if (this.confirmRemoveTemplateOnTagClick) {
	        this.templateRemovalTarget = payload;
	      } else {
	        this.$emit('editEmployment', payload);
	      }
	    },
	    cancelRemoveTemplate: function cancelRemoveTemplate() {
	      if (this.isRemovingTemplate) return;
	      this.templateRemovalTarget = null;
	    },
	    confirmRemoveTemplate: function confirmRemoveTemplate() {
	      var _this4 = this;
	
	      if (this.isRemovingTemplate || !this.templateRemovalTarget) return;
	      var employment = this.templateRemovalTarget.employment;
	      this.isRemovingTemplate = true;
	
	      _docendo2.default.updateEmployment(this.schoolId, employment.user_id, employment.id, false, null, null, null, null, null, function (success) {
	        _this4.isRemovingTemplate = false;
	        _this4.templateRemovalTarget = null;
	        _this4.$store.dispatch('readEmployments');
	        _eventbus2.default.toast = { text: 'Stillingskategori er fjernet', success: true, position: 'bottomLeft' };
	      }, function (failure) {
	        console.log(failure);
	        _this4.isRemovingTemplate = false;
	        _eventbus2.default.toast = { text: 'Kunne ikke fjerne stillingskategori', success: false, position: 'bottomLeft' };
	      });
	    },
	    cancelRemoveEmployment: function cancelRemoveEmployment() {
	      if (this.isRemovingEmployment) return;
	      this.employmentRemovalTarget = null;
	    },
	    confirmRemoveEmployment: function confirmRemoveEmployment() {
	      var _this5 = this;
	
	      if (this.isRemovingEmployment || !this.employmentRemovalTarget) return;
	      var employment = this.employmentRemovalTarget.employment;
	      this.isRemovingEmployment = true;
	
	      _docendo2.default.deleteEmployment(this.schoolId, employment.user_id, employment.id, function (data) {
	        _this5.isRemovingEmployment = false;
	        if (data && data.status === 'error') {
	          _eventbus2.default.toast = { text: data.message || 'Kunne ikke fjerne ansættelsen', success: false, position: 'bottomLeft' };
	          return;
	        }
	        _this5.employmentRemovalTarget = null;
	        _this5.selectedEmploymentIds = _this5.selectedEmploymentIds.filter(function (id) {
	          return id !== employment.id;
	        });
	        _this5.$store.dispatch('readEmployments');
	        _eventbus2.default.toast = { text: 'Ansættelsen er fjernet', success: true, position: 'bottomLeft' };
	      }, function (failure) {
	        console.log(failure);
	        _this5.isRemovingEmployment = false;
	        _eventbus2.default.toast = { text: 'Kunne ikke fjerne ansættelsen', success: false, position: 'bottomLeft' };
	      });
	    },
	    toggleName: function toggleName(name) {
	      var idx = this.selectedNames.indexOf(name);
	      if (idx > -1) {
	        this.selectedNames.splice(idx, 1);
	      } else {
	        this.selectedNames.push(name);
	      }
	    },
	    onTemplateSelected: function onTemplateSelected(employmentType) {
	      var _this6 = this;
	
	      this.isSubmitting = true;
	      var employmentTemplateId = employmentType.id;
	      var employmentIds = this.selectedEmploymentIds;
	      this.selectedEmploymentIds = [];
	      _docendo2.default.assignEmploymentTemplateToEmployment(this.schoolId, employmentTemplateId, employmentIds, function (success) {
	        _this6.isSubmitting = false;
	        _this6.$store.dispatch('readEmployments');
	      }, function (failure) {
	        _this6.isSubmitting = false;
	      });
	    },
	    toggleEmployment: function toggleEmployment(employment) {
	      var id = employment.id;
	      var idx = this.selectedEmploymentIds.indexOf(id);
	      if (idx > -1) {
	        this.selectedEmploymentIds.splice(idx, 1);
	      } else {
	        this.selectedEmploymentIds.push(id);
	      }
	    },
	    toggleAllEmployments: function toggleAllEmployments() {
	      var visibleEmploymentIds = [];
	      this.filteredUsers.forEach(function (user) {
	        user.v_employments.forEach(function (e) {
	          return visibleEmploymentIds.push(e.id);
	        });
	      });
	
	      if (this.selectedEmploymentIds.length > 0) {
	        this.selectedEmploymentIds = this.selectedEmploymentIds.filter(function (id) {
	          return visibleEmploymentIds.indexOf(id) === -1;
	        });
	      } else {
	        this.selectedEmploymentIds = visibleEmploymentIds.slice();
	      }
	    },
	    onTemplateCreated: function onTemplateCreated() {
	      this.readEmploymentTemplates();
	    },
	    onTemplateUpdated: function onTemplateUpdated() {
	      this.readEmploymentTemplates();
	    },
	    onTemplateDeleted: function onTemplateDeleted() {
	      this.readEmploymentTemplates();
	    },
	    toggleTag: function toggleTag(tag) {
	      var idx = this.selectedTags.indexOf(tag);
	      if (idx > -1) {
	        this.selectedTags.splice(idx, 1);
	      } else {
	        this.selectedTags.push(tag);
	      }
	    },
	    selectedOrganisation: function selectedOrganisation(organisation) {
	      var idx = this.selectedOrganisations.indexOf(organisation);
	      if (idx > -1) {
	        this.selectedOrganisations.splice(idx, 1);
	      } else {
	        this.selectedOrganisations.push(organisation);
	      }
	    },
	    toggleEmploymentTitle: function toggleEmploymentTitle(title) {
	      var idx = this.selectedEmploymentTitles.indexOf(title);
	      if (idx > -1) {
	        this.selectedEmploymentTitles.splice(idx, 1);
	      } else {
	        this.selectedEmploymentTitles.push(title);
	      }
	    },
	    onClose: function onClose() {
	      this.$emit('close');
	    },
	    readEmploymentTemplates: function readEmploymentTemplates() {
	      this.$store.dispatch('readEmploymentTemplates');
	    },
	    persistFilters: function persistFilters(val) {
	      try {
	        window.localStorage.setItem(this.storageKey, val);
	      } catch (e) {}
	    },
	    restoreFilters: function restoreFilters() {
	      try {
	        var raw = window.localStorage.getItem(this.storageKey);
	        if (!raw) return;
	        var saved = JSON.parse(raw);
	        if (!saved) return;
	        if (Array.isArray(saved.selectedTags)) this.selectedTags = saved.selectedTags;
	        if (Array.isArray(saved.selectedEmploymentTitles)) this.selectedEmploymentTitles = saved.selectedEmploymentTitles;
	        if (Array.isArray(saved.selectedOrganisations)) this.selectedOrganisations = saved.selectedOrganisations;
	        if (Array.isArray(saved.selectedNames)) this.selectedNames = saved.selectedNames;
	        if (saved.selectedTemplateTab) this.selectedTemplateTab = saved.selectedTemplateTab;
	      } catch (e) {}
	    }
	  },
	  created: function created() {
	    this.restoreFilters();
	  },
	  mounted: function mounted() {
	    this.readEmploymentTemplates();
	  }
	};

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default },
	  props: {
	    filteredUsers: {
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedEmploymentIds: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isShowNoEmploymentsText: {
	      type: Boolean,
	      default: false
	    },
	    isSalaryIntegrationActive: {
	      type: Boolean,
	      default: false
	    },
	    employmentTemplates: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isShowEmploymentNumber: {
	      type: Boolean,
	      default: false
	    },
	    rowActionLabel: {
	      type: String,
	      default: 'Opret engangsydelse'
	    }
	  },
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    costCenters: function costCenters() {
	      return this.$store.getters.costCentersAll;
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted;
	    },
	    visibleEmploymentIds: function visibleEmploymentIds() {
	      var ids = [];
	      this.filteredUsers.forEach(function (user) {
	        (user.v_employments || []).forEach(function (e) {
	          return ids.push(e.id);
	        });
	      });
	      return ids;
	    },
	    selectedVisibleCount: function selectedVisibleCount() {
	      var _this = this;
	
	      return this.visibleEmploymentIds.filter(function (id) {
	        return _this.selectedEmploymentIds.indexOf(id) > -1;
	      }).length;
	    },
	    isAllVisibleSelected: function isAllVisibleSelected() {
	      return this.visibleEmploymentIds.length > 0 && this.selectedVisibleCount === this.visibleEmploymentIds.length;
	    },
	    isIndeterminateVisible: function isIndeterminateVisible() {
	      return this.selectedVisibleCount > 0 && this.selectedVisibleCount < this.visibleEmploymentIds.length;
	    }
	  },
	  methods: {
	    formatEmploymentPeriod: function formatEmploymentPeriod(employment) {
	      var start = employment.start_date ? (0, _moment2.default)(employment.start_date).format('DD-MM-YYYY') : '';
	      var end = employment.end_date ? (0, _moment2.default)(employment.end_date).format('DD-MM-YYYY') : '';
	      if (!start && !end) return '';
	      return start + ' \u2013 ' + end;
	    },
	    formatEmploymentPercent: function formatEmploymentPercent(percent) {
	      if (percent == null || percent === '') return '';
	      var number = parseFloat(percent);
	      if (isNaN(number)) return percent;
	      return (number % 1 === 0 ? String(Math.round(number)) : String(number).replace('.', ',')) + '%';
	    },
	    formatSsn: function formatSsn(ssn) {
	      if (!ssn) return '';
	      var digits = String(ssn).replace(/\D+/g, '');
	      if (digits.length === 10) {
	        return digits.slice(0, 6) + '-' + digits.slice(6);
	      }
	      return ssn;
	    },
	    getCostCenterName: function getCostCenterName(defaultOmkostningssted) {
	      var costCenter = this.costCenters.find(function (costCenter) {
	        return costCenter.code * 1 === defaultOmkostningssted;
	      });
	      return costCenter ? costCenter.title : defaultOmkostningssted;
	    },
	    getDefaultSalaryCodeName: function getDefaultSalaryCodeName(salaryCodeId) {
	      var salaryCode = this.salaryCodes.find(function (costCenter) {
	        return costCenter.id === salaryCodeId;
	      });
	      return salaryCode ? salaryCode.vTitle : salaryCodeId;
	    },
	    setTheEditUser: function setTheEditUser(user) {
	      this.$emit('setTheEditUser', user);
	    },
	    isEmploymentSelected: function isEmploymentSelected(employmentId) {
	      return this.selectedEmploymentIds.indexOf(employmentId) > -1;
	    },
	    hasStillingskategori: function hasStillingskategori(employment) {
	      return !!employment && employment.employment_template_id != null && employment.employment_template_id !== undefined;
	    },
	    isLocalEmployment: function isLocalEmployment(employment) {
	      return !!employment && Number(employment.school_id) === Number(this.schoolId);
	    },
	    hasLocalStillingskategori: function hasLocalStillingskategori(employment) {
	      if (!this.hasStillingskategori(employment)) return false;
	      return this.employmentTemplates.some(function (template) {
	        return Number(template.id) === Number(employment.employment_template_id);
	      });
	    },
	    isStillingskategoriFromOtherSchool: function isStillingskategoriFromOtherSchool(employment) {
	      if (!this.hasStillingskategori(employment)) return false;
	      if (this.employmentTemplates.length > 0) {
	        return !this.hasLocalStillingskategori(employment);
	      }
	      return !this.isLocalEmployment(employment);
	    },
	    showEmploymentSalaryFields: function showEmploymentSalaryFields(employment) {
	      return !!employment && employment.manual_salary && this.hasLocalStillingskategori(employment);
	    },
	    onStillingskategoriClick: function onStillingskategoriClick(user, employment) {
	      if (this.isStillingskategoriFromOtherSchool(employment)) return;
	      this.$emit('editEmployment', { user: user, employment: employment });
	    },
	    setTbodyMaxHeight: function setTbodyMaxHeight() {
	      var tbody = this.$refs['d-b'];
	      if (!tbody) return;
	      var tbodyTop = tbody.getBoundingClientRect().top;
	      var windowHeight = window.innerHeight;
	      var maxHeight = windowHeight - tbodyTop - 20;
	      tbody.style.maxHeight = maxHeight + 'px';
	    }
	  },
	  mounted: function mounted() {
	    this.setTbodyMaxHeight();
	    window.addEventListener('resize', this.setTbodyMaxHeight);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.setTbodyMaxHeight);
	  }
	};

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default, DModal: _DModal2.default },
	  props: {
	    user: {
	      type: Object
	    },
	    theEditEmployment: {
	      type: Object,
	      default: null
	    },
	    school: {
	      type: Object,
	      default: null
	    },
	    isSalaryIntegrationActive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      theDeleteEmployment: null,
	      isShowOldEmployment: false,
	      theUpdatingEmployment: null,
	      employments: [],
	      isSaving: false,
	      isSavingTemplate: false
	    };
	  },
	
	  computed: {
	    costCenters: function costCenters() {
	      return this.$store.getters.costCenters;
	    },
	    filteredEmployment: function filteredEmployment() {
	      var _this = this;
	
	      return this.theEditEmployment ? this.employments.filter(function (employment) {
	        return employment.id === _this.theEditEmployment.id;
	      }) : this.employments;
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted;
	    },
	    employmentTemplates: function employmentTemplates() {
	      return this.$store.getters.employmentTemplatesSorted;
	    },
	    salarySystem: function salarySystem() {
	      return this.$store.getters.salarySystem;
	    },
	    isSalarySystemSD: function isSalarySystemSD() {
	      return this.salarySystem === 'SD';
	    }
	  },
	  methods: {
	    onChanged: function onChanged(employment) {
	      var idx = this.employments.findIndex(function (emp) {
	        return emp.id === employment.id;
	      });
	      if (idx > -1 && this.employments[idx].hasOwnProperty('v_has_error')) {
	        this.$delete(this.employments[idx], 'v_has_error');
	      }
	    },
	    resetManualFields: function resetManualFields(employment) {
	      employment.salary_code_id = null;
	      employment.default_omkostningssted = null;
	    },
	    setIsManualSalary: function setIsManualSalary(employment, bool) {
	      var idx = this.employments.findIndex(function (emp) {
	        return emp.id === employment.id;
	      });
	      if (idx > -1) {
	        this.employments[idx].manual_salary = bool;
	        if (!bool) {
	          this.resetManualFields(this.employments[idx]);
	        }
	        this.onChanged(this.employments[idx]);
	      }
	    },
	    setIsShowOldEmployment: function setIsShowOldEmployment() {
	      this.isShowOldEmployment = !this.isShowOldEmployment;
	    },
	    setDeleteEmployment: function setDeleteEmployment(employment) {
	      this.theDeleteEmployment = employment;
	    },
	    deleteEmployment: function deleteEmployment(employment) {
	      var dbObj = {
	        schoolId: employment.school_id,
	        userId: employment.user_id,
	        employmentId: employment.id
	      };
	      this.$store.dispatch('deleteEmployment', dbObj);
	      this.$emit('close');
	    },
	    archiveEmployment: function archiveEmployment(employment) {
	      var dbObj = {
	        schoolId: employment.school_id,
	        userId: employment.user_id,
	        employmentId: employment.id
	      };
	      this.$store.dispatch('deleteEmployment', dbObj);
	      this.$emit('close');
	    },
	    validate: function validate() {
	      var _this2 = this;
	
	      var isValidated = true;
	      var errors = [];
	
	      if (this.isSalaryIntegrationActive) {
	        this.employments.forEach(function (employment) {
	          if (employment.manual_salary) {
	            var missingFields = [];
	
	            if (missingFields.length > 0) {
	              errors.push('Manglende ' + missingFields.join(' og ') + ' for ' + (employment.name || 'ansat'));
	              isValidated = false;
	              _this2.$set(employment, 'v_has_error', true);
	            }
	          }
	        });
	      }
	
	      if (!isValidated) {
	        _eventbus2.default.toast = {
	          text: errors.length > 1 ? 'Flere fejl:\n' + errors.join('\n') : errors[0],
	          success: false
	        };
	      }
	
	      return isValidated;
	    },
	    saveChanges: function saveChanges() {
	      var _this3 = this;
	
	      if (!this.validate()) {
	        return;
	      }
	      this.isSaving = true;
	      var numberOfSaves = this.employments.length;
	      var saves = 0;
	      this.employments.forEach(function (employment, key) {
	        var dbObj = {
	          schoolId: employment.school_id,
	          userId: employment.user_id,
	          employmentId: employment.id,
	          manualSalary: employment.manual_salary,
	          defaultLoenart: employment.default_loenart ? employment.default_loenart * 1 : null,
	          defaultLoebenummer: employment.default_loebenummer ? employment.default_loebenummer * 1 : null,
	          defaultOmkostningssted: employment.default_omkostningssted,
	          employmentTemplateId: employment.employment_template_id,
	          salaryCodeId: employment.salary_code_id
	        };
	        _docendo2.default.updateEmployment(dbObj.schoolId, dbObj.userId, dbObj.employmentId, dbObj.manualSalary, dbObj.defaultLoenart, dbObj.defaultLoebenummer, dbObj.defaultOmkostningssted, dbObj.employmentTemplateId, dbObj.salaryCodeId, function (success) {
	          saves++;
	          if (numberOfSaves === saves) {
	            _this3.$store.dispatch('readEmployments');
	            _this3.$emit('close');
	          }
	        }, function (failure) {
	          console.log('failure!');
	        });
	      });
	    },
	    setEmploymentTemplate: function setEmploymentTemplate(employment, employmentTemplateId) {
	      var _this4 = this;
	
	      this.isSavingTemplate = true;
	      var employmentIds = [employment.id];
	      this.selectedEmploymentIds = [];
	
	      _docendo2.default.assignEmploymentTemplateToEmployment(employment.school_id, employmentTemplateId, employmentIds, function (success) {
	        _this4.isSavingTemplate = false;
	        _this4.$store.dispatch('readEmployments');
	
	        var idx = _this4.employments.findIndex(function (e) {
	          return e.id === employment.id;
	        });
	        if (idx >= 0) {
	          _this4.$set(_this4.employments, idx, success[0]);
	        }
	      }, function (failure) {
	        _this4.isSubmitting = false;
	      });
	    }
	  },
	  mounted: function mounted() {
	    var employments = JSON.parse((0, _stringify2.default)(this.user.v_employments));
	    this.employments = employments.sort(function (a, b) {
	      return a.title.localeCompare(b.title);
	    });
	  }
	};

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SalarySsnModal',
	  components: { DModal: _DModal2.default },
	  props: {
	    user: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      ssn: '',
	      isSubmitting: false
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    ssnDigits: function ssnDigits() {
	      return String(this.ssn).replace(/\D+/g, '');
	    },
	    isValid: function isValid() {
	      return this.ssnDigits.length === 10;
	    },
	    error: function error() {
	      if (this.ssnDigits.length === 0) return '';
	      if (this.ssnDigits.length !== 10) return 'CPR-nummer skal være 10 cifre';
	      return '';
	    }
	  },
	  methods: {
	    onSubmit: function onSubmit() {
	      var _this = this;
	
	      if (!this.isValid || this.isSubmitting) {
	        return;
	      }
	      this.isSubmitting = true;
	      var changes = { ssn: this.ssnDigits };
	      _docendo2.default.updateUsers(this.schoolId, this.user.id, changes, function (success) {
	        _this.$store.dispatch('getUsers');
	        _eventbus2.default.toast = { text: 'CPR-nummer gemt', success: true, position: 'bottomLeft' };
	        _this.isSubmitting = false;
	        _this.$emit('close');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'CPR-nummer er allerede brugt', success: false };
	        _this.isSubmitting = false;
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.user && this.user.ssn) {
	      this.ssn = this.user.ssn;
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.$nextTick(function (_) {
	      var el = _this2.$refs.ssn_input;
	      if (el) el.focus();
	    });
	  }
	};

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(28);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getIterator2 = __webpack_require__(45);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _vuedraggable = __webpack_require__(108);
	
	var _vuedraggable2 = _interopRequireDefault(_vuedraggable);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SUBJECTTYPES = ['subject', 'supplemental', 'additional_tasks', 'optional', 'frame', 'break', 'person_resource_visible', 'resource', 'person_resource', 'preparation', 'club'];
	
	exports.default = {
	  name: 'SalaryRules',
	  components: { draggable: _vuedraggable2.default },
	  props: {
	    propRules: {
	      type: Array,
	      default: null
	    },
	    schoolSubstituteRules: {
	      type: Object,
	      default: null
	    },
	    schoolIds: {
	      type: Array,
	      default: []
	    }
	  },
	  data: function data() {
	    return {
	      isSaving: false,
	      isConfirmDeletion: false,
	      isChangeHasBeenMade: false,
	      rules: [],
	      ruleTypes: [{
	        id: 1,
	        value: 'employment_type',
	        title: 'man er vikar for',
	        prop: 'substituted_employment_title'
	      }, {
	        id: 2,
	        value: 'subject_type',
	        title: 'briktypen er',
	        prop: 'subject_type'
	      }, {
	        id: 3,
	        value: 'subject_title',
	        title: 'brikken hedder',
	        prop: 'subject_title'
	      }, {
	        id: 4,
	        value: 'calendar_id',
	        title: 'kalenderen er',
	        prop: 'calendar_id'
	      }]
	    };
	  },
	
	  computed: {
	    calendars: function calendars() {
	      return [].concat(this.klassCalendars).concat(this.otherCalendars).concat(this.clubCalendars);
	    },
	    klassCalendars: function klassCalendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    clubCalendars: function clubCalendars() {
	      return this.$store.getters.clubCalendars;
	    },
	    otherCalendars: function otherCalendars() {
	      return this.$store.getters.otherCalendars;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    employmentTypesActive: function employmentTypesActive() {
	      return this.$store.getters.employmentTypesActive;
	    },
	    employmentToSelectForRules: function employmentToSelectForRules() {
	      return this.$store.getters.employmentToSelectForRules;
	    },
	    employmentsTypesForFullTime: function employmentsTypesForFullTime() {
	      return this.employmentTypesActive.filter(function (employmentType) {
	        return employmentType;
	      });
	    },
	    subjectTypes: function subjectTypes() {
	      var _this = this;
	
	      return SUBJECTTYPES.map(function (subjectType) {
	        return {
	          value: subjectType,
	          name: _this.$t('vue2.eventTypes.' + subjectType) !== 'vue2.eventTypes.' + subjectType ? _this.$t('vue2.eventTypes.' + subjectType) : subjectType
	        };
	      });
	    }
	  },
	  methods: {
	    onChange: function onChange() {
	      this.isChangeHasBeenMade = true;
	    },
	    validateArray: function validateArray(arr) {
	      if (!Array.isArray(arr)) {
	        return false;
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var obj = _step.value;
	
	          if (obj && (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object' && !Array.isArray(obj)) {
	            for (var key in obj) {
	              if (obj[key] === null || obj[key] === '') {
	                return false;
	              }
	            }
	          } else {
	              return false;
	            }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return true;
	    },
	    onChangeRuleType: function onChangeRuleType(rule, val) {
	      var _this2 = this;
	
	      var ruleTypeProp = this.ruleTypes.find(function (ruleType) {
	        return ruleType.value === val;
	      })['prop'];
	      var idxOfRule = this.rules.findIndex(function (rulesRule) {
	        return rulesRule.id === rule.id;
	      });
	      delete this.rules[idxOfRule]['subject_type'];
	      delete this.rules[idxOfRule]['substituted_employment_title'];
	      delete this.rules[idxOfRule]['calendar_id'];
	      delete this.rules[idxOfRule]['subject_title'];
	      this.rules[idxOfRule][ruleTypeProp] = null;
	      this.onChange();
	
	      this.$nextTick(function () {
	        if (val === 'subject_title') {
	          var inputRef = _this2.$refs['subjectTitleInput' + rule.id];
	          if (inputRef) {
	            inputRef[0].focus();
	          }
	        }
	      });
	    },
	    setRoleToDelete: function setRoleToDelete(rule) {
	      var idx = this.rules.findIndex(function (item) {
	        return item.id === rule.id;
	      });
	      if (idx > -1) {
	        this.rules.splice(idx, 1);
	      }
	      this.onChange();
	    },
	    onChangeOrder: function onChangeOrder() {
	      this.onChange();
	    },
	    addNewRule: function addNewRule() {
	      var newRuleObj = {
	        id: this.generateUUID(),
	        type: 'employment_type',
	        substituted_employment_title: null,
	        selected_employment_title: null
	      };
	      this.rules.push(newRuleObj);
	      this.onChange();
	    },
	    submit: function submit() {
	      var _this3 = this;
	
	      if (!this.validateArray(this.rules)) {
	        _eventbus2.default.toast = { text: 'En regel må ikke indeholde tomme værdier', success: false };
	        return;
	      }
	
	      this.isSaving = true;
	
	      var activeSchool = this.$store.state.activeSchool || {};
	      var fromProp = this.schoolSubstituteRules || {};
	      var fromStore = activeSchool.substitute_rules || {};
	      var base = (0, _keys2.default)(fromProp).length > 0 ? fromProp : fromStore;
	
	      var dbRules = JSON.parse((0, _stringify2.default)(base || {}));
	
	      var extraTimeRules = this.propRules ? this.propRules.filter(function (item) {
	        return item.id && item.id.indexOf('_extra_time') === 0;
	      }) : [];
	      var combinedRules = [].concat(extraTimeRules).concat(this.rules);
	
	      if (!combinedRules || combinedRules.length === 0) {
	        delete dbRules.rules;
	      } else {
	        dbRules.rules = combinedRules;
	      }
	
	      var hasExistingCostCenterRules = base && Object.prototype.hasOwnProperty.call(base, 'cost_center_rules') && Array.isArray(base.cost_center_rules);
	
	      if (hasExistingCostCenterRules) {
	        dbRules.cost_center_rules = JSON.parse((0, _stringify2.default)(base.cost_center_rules));
	      } else {
	        delete dbRules.cost_center_rules;
	      }
	
	      this.$emit('changedMade');
	
	      _docendo2.default.updateSchool(this.schoolId, { substitute_rules: dbRules }, function (success) {
	        _eventbus2.default.toast = { text: 'Gemt', success: true };
	        _this3.isSaving = false;
	        _this3.isChangeHasBeenMade = false;
	        _this3.$store.commit('setActiveSchool', success);
	        _this3.$store.commit('setSchoolSettings', success.custom_data);
	      }, function (failure) {
	        console.log({ failure: failure });
	        _this3.isSaving = false;
	      });
	    },
	    cancel: function cancel() {
	      this.$emit('close');
	    },
	    generateUUID: function generateUUID() {
	      var d = new Date().getTime();
	      var d2 = window.performance && window.performance.now && window.performance.now() * 1000 || 0;
	      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        var r = Math.random() * 16;
	        if (d > 0) {
	          r = (d + r) % 16 | 0;
	          d = Math.floor(d / 16);
	        } else {
	          r = (d2 + r) % 16 | 0;
	          d2 = Math.floor(d2 / 16);
	        }
	        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
	      });
	    }
	  },
	  mounted: function mounted() {
	    if (this.propRules) {
	      this.rules = this.propRules.filter(function (item) {
	        return !item.id.startsWith('_extra_time');
	      });
	    }
	  }
	};

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _SalaryRulesRule = __webpack_require__(142);
	
	var _SalaryRulesRule2 = _interopRequireDefault(_SalaryRulesRule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { SalaryRulesRule: _SalaryRulesRule2.default, AppToggle: _AppToggle2.default },
	  props: {
	    config: {
	      type: Object,
	      default: null
	    },
	    propRules: {
	      type: Array,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isOn: false,
	      minutes: 45,
	      subjectType: '_extra_time_between_events_',
	      selectedEmploymentTypeId: ''
	    };
	  },
	
	  computed: {
	    initMinutes: function initMinutes() {
	      return this.config && this.config.between_events && this.config.between_events.minutes;
	    },
	    initSelectedEmploymentTypeId: function initSelectedEmploymentTypeId() {
	      var _this = this;
	
	      if (!this.propRules) {
	        return '';
	      }
	      var idx = this.propRules.findIndex(function (item) {
	        return item.id === _this.subjectType;
	      });
	      if (idx < 0) {
	        return '';
	      }
	      return this.propRules[idx]['selected_employment_title'];
	    },
	    isChangesMade: function isChangesMade() {
	      if (this.isOn) {
	        return this.initMinutes !== this.minutes * 1 || this.initSelectedEmploymentTypeId !== this.selectedEmploymentTypeId;
	      } else {
	        return this.config && this.config.between_events;
	      }
	    }
	  },
	  methods: {
	    setRuleEmployment: function setRuleEmployment(selectedEmploymentTypeId) {
	      this.selectedEmploymentTypeId = selectedEmploymentTypeId;
	    },
	    newRulesArr: function newRulesArr() {
	      var _this2 = this;
	
	      if (!this.isOn || this.selectedEmploymentTypeId === '') {
	        return this.propRules.filter(function (item) {
	          return item.id !== _this2.subjectType;
	        });
	      }
	      var dbRules = JSON.parse((0, _stringify2.default)(this.propRules));
	      var idx = dbRules.findIndex(function (item) {
	        return item.id === _this2.subjectType;
	      });
	      if (idx < 0) {
	        var newRuleObj = {
	          id: this.subjectType,
	          type: 'subject_type',
	          subject_type: this.subjectType,
	          selected_employment_title: this.selectedEmploymentTypeId
	        };
	        dbRules.unshift(newRuleObj);
	      } else {
	        dbRules[idx].selected_employment_title = this.selectedEmploymentTypeId;
	      }
	      return dbRules;
	    },
	    setIsOn: function setIsOn() {
	      var _this3 = this;
	
	      this.isOn = !this.isOn;
	      if (this.isOn) {
	        this.$nextTick(function (_) {
	          _this3.$refs.input_number.focus();
	        });
	      }
	    },
	    onSubmit: function onSubmit() {
	      var dbConfig = JSON.parse((0, _stringify2.default)(this.config));
	      if (!this.isOn) {
	        delete dbConfig.between_events;
	      } else {
	        dbConfig.between_events = { minutes: this.minutes * 1 };
	      }
	      this.$emit('onSubmit', dbConfig, this.newRulesArr());
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    if (this.propRules) {
	      var idx = this.propRules.findIndex(function (item) {
	        return item.id === _this4.subjectType;
	      });
	      if (idx > -1) {
	        var employmentId = JSON.parse((0, _stringify2.default)(this.propRules[idx]['selected_employment_title']));
	        this.selectedEmploymentTypeId = employmentId;
	      }
	    }
	    if (this.config && this.config.between_events && this.config.between_events.minutes) {
	      var minutes = JSON.parse((0, _stringify2.default)(this.config.between_events.minutes * 1));
	      this.isOn = true;
	      this.minutes = minutes;
	    }
	  }
	};

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _TimeInput = __webpack_require__(107);
	
	var _TimeInput2 = _interopRequireDefault(_TimeInput);
	
	var _SalaryRulesRule = __webpack_require__(142);
	
	var _SalaryRulesRule2 = _interopRequireDefault(_SalaryRulesRule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { SalaryRulesRule: _SalaryRulesRule2.default, TimeInput: _TimeInput2.default, AppToggle: _AppToggle2.default },
	  props: {
	    config: {
	      type: Object,
	      default: null
	    },
	    propRules: {
	      type: Array,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isOn: false,
	      minutes: 120,
	      subjectType: '_extra_time_if_shorter_than_',
	      selectedEmploymentTypeId: ''
	    };
	  },
	
	  computed: {
	    initMinutes: function initMinutes() {
	      return this.config && this.config.if_shorter_than && this.config.if_shorter_than.minutes;
	    },
	    initSelectedEmploymentTypeId: function initSelectedEmploymentTypeId() {
	      var _this = this;
	
	      if (!this.propRules) {
	        return '';
	      }
	      var idx = this.propRules.findIndex(function (item) {
	        return item.id === _this.subjectType;
	      });
	      if (idx < 0) {
	        return '';
	      }
	      return this.propRules[idx]['selected_employment_title'];
	    },
	    isChangesMade: function isChangesMade() {
	      if (this.isOn) {
	        return this.initMinutes !== this.minutes * 1 || this.initSelectedEmploymentTypeId !== this.selectedEmploymentTypeId;
	      } else {
	        return this.config && this.config.if_shorter_than;
	      }
	    }
	  },
	  methods: {
	    setRuleEmployment: function setRuleEmployment(selectedEmploymentTypeId) {
	      this.selectedEmploymentTypeId = selectedEmploymentTypeId;
	    },
	    newRulesArr: function newRulesArr() {
	      var _this2 = this;
	
	      if (!this.isOn || this.selectedEmploymentTypeId === '') {
	        return this.propRules.filter(function (item) {
	          return item.id !== _this2.subjectType;
	        });
	      }
	      var dbRules = JSON.parse((0, _stringify2.default)(this.propRules));
	      var idx = dbRules.findIndex(function (item) {
	        return item.id === _this2.subjectType;
	      });
	      if (idx < 0) {
	        var newRuleObj = {
	          id: this.subjectType,
	          type: 'subject_type',
	          subject_type: this.subjectType,
	          selected_employment_title: this.selectedEmploymentTypeId
	        };
	        dbRules.unshift(newRuleObj);
	      } else {
	        dbRules[idx].selected_employment_title = this.selectedEmploymentTypeId;
	      }
	      return dbRules;
	    },
	    setIsOn: function setIsOn() {
	      var _this3 = this;
	
	      this.isOn = !this.isOn;
	      if (this.isOn) {
	        this.$nextTick(function (_) {
	          _this3.$refs.input_number.focus();
	        });
	      }
	    },
	    onSubmit: function onSubmit() {
	      var dbConfig = JSON.parse((0, _stringify2.default)(this.config));
	      if (!this.isOn) {
	        delete dbConfig.if_shorter_than;
	      } else {
	        dbConfig.if_shorter_than = { minutes: this.minutes * 1 };
	      }
	      this.$emit('onSubmit', dbConfig, this.newRulesArr());
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    if (this.propRules) {
	      var idx = this.propRules.findIndex(function (item) {
	        return item.id === _this4.subjectType;
	      });
	      if (idx > -1) {
	        var employmentId = JSON.parse((0, _stringify2.default)(this.propRules[idx]['selected_employment_title']));
	        this.selectedEmploymentTypeId = employmentId;
	      }
	    }
	    if (this.config && this.config.if_shorter_than && this.config.if_shorter_than.minutes) {
	      this.isOn = true;
	      this.minutes = JSON.parse((0, _stringify2.default)(this.config.if_shorter_than.minutes * 1));
	    }
	  }
	};

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _SalaryRulesRule = __webpack_require__(142);
	
	var _SalaryRulesRule2 = _interopRequireDefault(_SalaryRulesRule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { SalaryRulesRule: _SalaryRulesRule2.default, AppToggle: _AppToggle2.default },
	  props: {
	    config: {
	      type: Object,
	      default: null
	    },
	    propRules: {
	      type: Array,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isOn: false,
	      atStartOfDay: [],
	      subjectType: '_extra_time_at_start_of_day_',
	      selectedEmploymentTitle: '',
	      isChangesMade: false
	    };
	  },
	
	  methods: {
	    updateTime: function updateTime(event, index) {
	      this.atStartOfDay[index].time = event.target.value;
	      this.isChangesMade = true;
	    },
	    updateMinutes: function updateMinutes(event, index) {
	      this.atStartOfDay[index].minutes = parseInt(event.target.value, 10) || 0;
	      this.isChangesMade = true;
	    },
	    setRuleEmployment: function setRuleEmployment(selectedEmploymentTitle) {
	      this.selectedEmploymentTitle = selectedEmploymentTitle;
	      this.isChangesMade = true;
	    },
	    newRulesArr: function newRulesArr() {
	      var _this = this;
	
	      if (!this.isOn || this.selectedEmploymentTitle === '') {
	        return this.propRules.filter(function (item) {
	          return item.id !== _this.subjectType;
	        });
	      }
	      var dbRules = JSON.parse((0, _stringify2.default)(this.propRules));
	      var idx = dbRules.findIndex(function (item) {
	        return item.id === _this.subjectType;
	      });
	      if (idx < 0) {
	        var newRuleObj = {
	          id: this.subjectType,
	          type: 'subject_type',
	          subject_type: this.subjectType,
	          selected_employment_title: this.selectedEmploymentTitle
	        };
	        dbRules.unshift(newRuleObj);
	      } else {
	        dbRules[idx].selected_employment_title = this.selectedEmploymentTitle;
	      }
	      return dbRules;
	    },
	    setIsOn: function setIsOn() {
	      this.isOn = !this.isOn;
	      this.isChangesMade = true;
	      if (this.atStartOfDay.length === 0) {
	        this.atStartOfDay.push({ time: '08:00', minutes: 10 });
	      }
	    },
	    addTime: function addTime() {
	      this.atStartOfDay.push({ time: '08:00', minutes: 10 });
	      this.isChangesMade = true;
	    },
	    deleteItem: function deleteItem(idx) {
	      this.atStartOfDay.splice(idx, 1);
	      this.isChangesMade = true;
	      if (this.atStartOfDay.length === 0) {
	        this.isOn = false;
	      }
	    },
	    onSubmit: function onSubmit() {
	      var dbConfig = JSON.parse((0, _stringify2.default)(this.config));
	
	      if (!this.isOn) {
	        delete dbConfig.at_start_of_day;
	      } else {
	        dbConfig.at_start_of_day = this.atStartOfDay;
	      }
	      this.$emit('onSubmit', dbConfig, this.newRulesArr());
	      this.isChangesMade = false;
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    if (this.propRules) {
	      var idx = this.propRules.findIndex(function (item) {
	        return item.id === _this2.subjectType;
	      });
	      if (idx > -1) {
	        this.selectedEmploymentTitle = JSON.parse((0, _stringify2.default)(this.propRules[idx]['selected_employment_title']));
	      }
	    }
	    if (this.config && this.config.at_start_of_day) {
	      this.isOn = true;
	      this.atStartOfDay = JSON.parse((0, _stringify2.default)(Array.isArray(this.config.at_start_of_day) ? this.config.at_start_of_day : [this.config.at_start_of_day]));
	    } else {
	      this.atStartOfDay = [{ time: '08:00', minutes: 10 }];
	    }
	  }
	};

/***/ }),
/* 667 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    subjectType: {
	      default: '_extra_time_if_shorter_than_'
	    },
	    propSelectedEmploymentTypeId: {
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      selectedEmploymentTitle: this.propSelectedEmploymentTypeId
	    };
	  },
	
	  computed: {
	    employmentToSelectForRules: function employmentToSelectForRules() {
	      if (this.subjectType === '_extra_time_at_start_of_day_') {
	        return this.$store.getters.employmentToSelectForRules.filter(function (title) {
	          return title !== '*Stillingen fra lektionen før*';
	        });
	      }
	      if (this.subjectType === '_extra_time_if_shorter_than_') {
	        return this.$store.getters.employmentToSelectForRules.filter(function (title) {
	          return title !== '*Stillingen fra lektionen efter*';
	        });
	      }
	      return this.$store.getters.employmentToSelectForRules;
	    }
	  },
	  watch: {
	    propSelectedEmploymentTypeId: function propSelectedEmploymentTypeId(newVal) {
	      this.selectedEmploymentTitle = newVal;
	    }
	  },
	  methods: {
	    onChange: function onChange(val) {
	      this.selectedEmploymentTitle = val;
	      this.$emit('change', val);
	    }
	  },
	  mounted: function mounted() {
	    this.selectedEmploymentTitle = this.propSelectedEmploymentTypeId;
	  }
	};

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(28);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _SalarySettings = __webpack_require__(1571);
	
	var _SalarySettings2 = _interopRequireDefault(_SalarySettings);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DoDatePickerRange = __webpack_require__(44);
	
	var _DoDatePickerRange2 = _interopRequireDefault(_DoDatePickerRange);
	
	var _SalarySubsPerfUserDay = __webpack_require__(379);
	
	var _SalarySubsPerfUserDay2 = _interopRequireDefault(_SalarySubsPerfUserDay);
	
	var _SchoolsSelector = __webpack_require__(1697);
	
	var _SchoolsSelector2 = _interopRequireDefault(_SchoolsSelector);
	
	var _SalarySubsPerfUser = __webpack_require__(1581);
	
	var _SalarySubsPerfUser2 = _interopRequireDefault(_SalarySubsPerfUser);
	
	var _SalaryFilters = __webpack_require__(375);
	
	var _SalaryFilters2 = _interopRequireDefault(_SalaryFilters);
	
	var _SalarySubsPerfUserTable = __webpack_require__(380);
	
	var _SalarySubsPerfUserTable2 = _interopRequireDefault(_SalarySubsPerfUserTable);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SalarySubsPerfUserTable: _SalarySubsPerfUserTable2.default,
	    SalaryFilters: _SalaryFilters2.default,
	    SalarySubsPerfUser: _SalarySubsPerfUser2.default,
	    SchoolsSelector: _SchoolsSelector2.default,
	    SalarySubsPerfUserDay: _SalarySubsPerfUserDay2.default, DoDatePickerRange: _DoDatePickerRange2.default, Loader: _Loader2.default, SalarySettings: _SalarySettings2.default, Datepickerrange: _DatePickerRange2.default, DModal: _DModal2.default
	  },
	  data: function data() {
	    return {
	      permission: 'can_manage_salary',
	      startDate: null,
	      endDate: null,
	      isLoading: false,
	      usersAndEvents: [],
	      isShowSalarySettings: false,
	      activeFilter: 'draft',
	      theActiveUserDay: null,
	      isInitialLoad: true,
	      theUserDaySubmitting: null,
	      schoolIdsWithSchoolSelector: [7272, 60494],
	      selectedSchoolIds: [],
	      isSchoolSelectorOn: false,
	      activeUserId: null,
	      isConfirmBulkSend: false,
	      isBulkSending: false,
	      pendingBulkSendDays: []
	    };
	  },
	
	  computed: {
	    date: function date() {
	      return (0, _moment2.default)();
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    validationTxt: function validationTxt() {
	      return this.isSalaryIntegrationActive ? 'Vælg ansættelse og lønkode på hver lektion' : 'Vælg ansættelse på hver lektion';
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted;
	    },
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    isSalaryIntegrationActive: function isSalaryIntegrationActive() {
	      return this.isOpusIntegrationActive || this.isSDIntegrationActive;
	    },
	    isOpusIntegrationActive: function isOpusIntegrationActive() {
	      return this.school && this.school.features && this.school.features.includes('kmd_opus_integration');
	    },
	    isSDIntegrationActive: function isSDIntegrationActive() {
	      return this.school && this.school.features && this.school.features.includes('silkeborg_data_integration');
	    },
	    costCenters: function costCenters() {
	      return this.$store.getters.costCenters;
	    },
	    costCentersAll: function costCentersAll() {
	      return this.$store.getters.costCentersAll;
	    },
	    isUserLoaded: function isUserLoaded() {
	      return this.$store.state.isUserLoaded;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    userSchools: function userSchools() {
	      return this.user && this.user.schools ? this.user.schools : [];
	    },
	    usersInHash: function usersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    userMemberships: function userMemberships() {
	      return this.$store.getters.userSchools;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash;
	    },
	    dateShortCuts: function dateShortCuts() {
	      var now = (0, _moment2.default)(this.date);
	      return [{
	        id: 'this_month',
	        title: 'Denne måned',
	        startDate: now.clone().startOf('month'),
	        endDate: now.clone().endOf('month')
	      }, {
	        id: 'last_month',
	        title: 'Sidste måned',
	        startDate: now.clone().subtract(1, 'month').startOf('month'),
	        endDate: now.clone().subtract(1, 'month').endOf('month')
	      }, {
	        id: 'last_month_to_today',
	        title: 'Dags dato og en måned tilbage',
	        startDate: now.clone().subtract(1, 'month').startOf('day'),
	        endDate: now.clone().startOf('day')
	      }];
	    },
	    dbStartDate: function dbStartDate() {
	      return (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	    },
	    dbEndDate: function dbEndDate() {
	      return (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	    },
	    usersAndEventsWithOnlyNewestEvent: function usersAndEventsWithOnlyNewestEvent() {
	      var filteredDays = [];
	      this.usersAndEvents.forEach(function (userDay) {
	        var idx = filteredDays.findIndex(function (day) {
	          return day.user_id === userDay.user_id && day.day === userDay.day;
	        });
	        if (idx < 0) {
	          filteredDays.push(userDay);
	        } else {
	          if (filteredDays[idx].id < userDay.id) {
	            filteredDays.splice(idx, 1);
	            filteredDays.push(userDay);
	          }
	        }
	      });
	      return filteredDays;
	    },
	    userDaysSorted: function userDaysSorted() {
	      return this.usersAndEventsWithOnlyNewestEvent.sort(function (a, b) {
	        return (0, _moment2.default)(a.day).unix() - (0, _moment2.default)(b.day).unix();
	      });
	    },
	    userDaysDrafts: function userDaysDrafts() {
	      return this.userDaysSorted.filter(function (userDay) {
	        return userDay.state === 'draft';
	      });
	    },
	    userDaysApproved: function userDaysApproved() {
	      return this.userDaysSorted.filter(function (userDay) {
	        return userDay.state === 'approved';
	      });
	    },
	    userDaysSent: function userDaysSent() {
	      return this.userDaysSorted.filter(function (userDay) {
	        return userDay.state === 'sent';
	      });
	    },
	    usersAndEventsFiltered: function usersAndEventsFiltered() {
	      if (this.activeFilter === 'draft') {
	        return this.userDaysDrafts;
	      } else if (this.activeFilter === 'approved') {
	        return this.userDaysApproved;
	      } else if (this.activeFilter === 'sent') {
	        return this.userDaysSent;
	      }
	    },
	    usersPackedInDays: function usersPackedInDays() {
	      var _this = this;
	
	      var subs = [];
	
	      this.usersAndEventsFiltered.forEach(function (userAndDay) {
	        var userEmployments = _this.getUserEmployments(userAndDay.user_id);
	
	        var startEvent = userAndDay.events[0];
	        var endEvent = userAndDay.events[userAndDay.events.length - 1];
	        var userDayDateFormatted = (0, _moment2.default)(startEvent.start).format('ddd') + ', ' + (0, _moment2.default)(startEvent.start).format('LL') + ', kl. ' + (0, _moment2.default)(startEvent.start).format('LT') + ' - ' + (0, _moment2.default)(endEvent.end).format('LT');
	        userAndDay.v_date_formatted = userDayDateFormatted;
	        userAndDay.v_unfilled = Array.isArray(userAndDay.sums) ? userAndDay.sums.some(function (sum) {
	          return sum && (sum.employment_id == null || sum.employment_id === '');
	        }) : false;
	
	        var approvedBy = userAndDay.approved_by ? _this.usersInHash[userAndDay.approved_by] ? _this.usersInHash[userAndDay.approved_by]['name'] : userAndDay.approved_by : '';
	        var approvedAt = userAndDay.approved_at ? (0, _moment2.default)(userAndDay.approved_at).format('LLL') : '';
	        userAndDay.v_approved = 'Beregnet d.' + approvedAt + ' af ' + approvedBy;
	        var sums = userAndDay.sums;
	        if (sums && sums.length > 0) {
	          userAndDay.v_sums = sums.map(function (sumObj) {
	            var key = sumObj.employment_id;
	            var minutes = sumObj.minutes * 1;
	
	            var employment = userEmployments.find(function (e) {
	              return e.id === key * 1;
	            });
	            var employmentTitle = employment && employment.title ? employment.title : 'Ikke sat';
	
	            var ccCode = sumObj.afv_omkostningssted != null && sumObj.afv_omkostningssted !== '' ? String(sumObj.afv_omkostningssted) : null;
	
	            var ccName = null;
	            if (ccCode != null) {
	              var ccObj = _this.costCentersAll.find(function (c) {
	                return String(c.code) === ccCode;
	              });
	              ccName = ccObj && ccObj.name ? ccObj.name : null;
	            }
	
	            var minutesHuman = _this.getHumanizeMinutes(minutes);
	
	            return {
	              employment_not_set: !employment,
	              employment_id: key,
	              employment_title: employmentTitle,
	              minutes: minutes,
	              minutes_humanized: minutesHuman,
	              minutes_to_copy: _this.getSumTopCopy(minutes),
	              costCenter_code: ccCode,
	              costCenter: ccName,
	              vId: key + '_' + (ccCode != null ? ccCode : 'noCC')
	            };
	          });
	        } else {
	          userAndDay.v_sums = [];
	        }
	
	        var updateUserSums = function updateUserSums(currentSumArr, newSumArr) {
	          var arr = currentSumArr;
	          newSumArr.forEach(function (item) {
	            var idx = arr.findIndex(function (currentItem) {
	              return currentItem.employment_id === item.employment_id && (currentItem.costCenter_code == null ? item.costCenter_code == null : currentItem.costCenter_code === item.costCenter_code);
	            });
	
	            if (idx < 0) {
	              arr.push((0, _extends3.default)({}, item));
	            } else {
	              arr[idx].minutes += item.minutes * 1;
	              arr[idx].minutes_humanized = _this.getHumanizeMinutes(arr[idx].minutes);
	              arr[idx].minutes_to_copy = _this.getSumTopCopy(arr[idx].minutes);
	            }
	          });
	          return arr;
	        };
	
	        var idx = subs.findIndex(function (sub) {
	          return sub.user_id === userAndDay.user_id;
	        });
	        if (idx < 0) {
	          subs.push({
	            user_id: userAndDay.user_id,
	            days: [userAndDay],
	            v_user_name: userAndDay.name,
	            v_user_employments: userEmployments,
	            v_user_active_employments: userEmployments.filter(function (e) {
	              return !e.deleted && e.manual_salary;
	            }),
	            v_user_sums: JSON.parse((0, _stringify2.default)(userAndDay.v_sums))
	          });
	        } else {
	          subs[idx].days.push(userAndDay);
	          subs[idx].v_user_sums = updateUserSums(subs[idx].v_user_sums, userAndDay.v_sums);
	        }
	      });
	
	      return subs;
	    },
	    usersPackedInDaysWithProps: function usersPackedInDaysWithProps() {
	      var _this2 = this;
	
	      return this.usersPackedInDays.map(function (user) {
	        return (0, _extends3.default)({}, user, {
	          days: user.days.map(function (userAndDay) {
	            return (0, _extends3.default)({}, userAndDay, {
	              v_is_open: _this2.getIsTheActiveUserDay(userAndDay)
	            });
	          })
	        });
	      }).sort(function (a, b) {
	        return a.v_user_name.localeCompare(b.v_user_name);
	      });
	    },
	    localStorageKey: function localStorageKey() {
	      return 'do_salary_subs_schools_' + this.schoolId;
	    },
	    dateShortcutStorageKey: function dateShortcutStorageKey() {
	      return 'do_salary_subs_date_shortcut';
	    },
	    bulkSendButtonLabel: function bulkSendButtonLabel() {
	      return this.isSalaryIntegrationActive ? 'Send alle til lønsystem' : 'Marker alle som indberettet';
	    },
	    bulkSendConfirmText: function bulkSendConfirmText() {
	      var count = this.pendingBulkSendDays.length;
	      var daysLabel = count === 1 ? '1 godkendt dag' : count + ' godkendte dage';
	      if (this.isSalaryIntegrationActive) {
	        return 'Er du sikker på, at du vil sende ' + daysLabel + ' til lønsystemet?';
	      }
	      return 'Er du sikker på, at du vil markere ' + daysLabel + ' som indberettet?';
	    }
	  },
	  watch: {
	    user: function user(newVal, oldVal) {
	      if (newVal !== oldVal) {
	        this.getSavedSchoolIdsAndCheckForPermission();
	      }
	    },
	    date: function date() {
	      this.applySavedOrDefaultDateRange();
	    }
	  },
	  methods: {
	    calculateDateRange: function calculateDateRange() {
	      if (!this.date) {
	        return;
	      }
	      var referenceDate = (0, _moment2.default)(this.date);
	
	      this.startDate = referenceDate.clone().subtract(1, 'month').date(16).startOf('day');
	      this.endDate = referenceDate.clone().date(15).startOf('day');
	    },
	    applySavedOrDefaultDateRange: function applySavedOrDefaultDateRange() {
	      var savedShortcutId = this.$helpers.getLocalStorage(this.dateShortcutStorageKey);
	      var shortcut = this.dateShortCuts.find(function (shortCut) {
	        return shortCut.id === savedShortcutId;
	      });
	      if (shortcut) {
	        this.startDate = shortcut.startDate.clone();
	        this.endDate = shortcut.endDate.clone();
	        return;
	      }
	      this.calculateDateRange();
	    },
	    persistDateShortcut: function persistDateShortcut(startDate, endDate) {
	      var shortcut = this.dateShortCuts.find(function (shortCut) {
	        return (0, _moment2.default)(shortCut.startDate).isSame(startDate, 'day') && (0, _moment2.default)(shortCut.endDate).isSame(endDate, 'day');
	      });
	      if (shortcut) {
	        this.$helpers.setLocalStorage(this.dateShortcutStorageKey, shortcut.id);
	      } else {
	        this.$helpers.removeLocalStorage(this.dateShortcutStorageKey);
	      }
	    },
	    parseUserErrors: function parseUserErrors(errors) {
	      if (!errors || (typeof errors === 'undefined' ? 'undefined' : (0, _typeof3.default)(errors)) !== 'object') return [];
	
	      var errorMessages = [];
	
	      (0, _keys2.default)(errors).forEach(function (key) {
	        var errorList = errors[key];
	        if (Array.isArray(errorList)) {
	          errorList.forEach(function (error) {
	            var message = key + ': "' + error.Tekst + '" (Kode: ' + error.Kode + ', Type: ' + error.Type + ')';
	            errorMessages.push(message);
	          });
	        }
	      });
	
	      return errorMessages;
	    },
	    hideTippy: function hideTippy(tippyEl) {
	      setTimeout(function (_) {
	        tippyEl.hide();
	      }, 1000);
	    },
	    copyToClipboard: function copyToClipboard(val, evt) {
	      navigator.clipboard.writeText(val.toString()).then(function (_) {
	        evt.target._tippy.show();
	      }, function (_) {
	        console.log('that totally failed');
	      });
	    },
	    setActiveUserId: function setActiveUserId(userId) {
	      this.activeUserId = userId;
	      var body = document.querySelector('body');
	      if (userId) {
	        body.classList.add('no-scroll');
	      } else {
	        body.classList.remove('no-scroll');
	      }
	    },
	    getHasPermission: function getHasPermission(schoolId) {
	      var schoolMember = this.userMemberships[schoolId];
	      if (!schoolMember) {
	        return false;
	      }
	      return schoolMember['permissions'].indexOf(this.permission) > -1;
	    },
	    toggleSchool: function toggleSchool(school) {
	      var _this3 = this;
	
	      this.usersAndEvents = [];
	      var idx = this.selectedSchoolIds.indexOf(school.id);
	      if (idx < 0) {
	        this.selectedSchoolIds.push(school.id);
	      } else {
	        this.selectedSchoolIds.splice(idx, 1);
	      }
	      var selectedSchoolIdsWithoutActiveSchoolId = this.selectedSchoolIds.filter(function (schoolId) {
	        return schoolId !== _this3.schoolId;
	      });
	      if (selectedSchoolIdsWithoutActiveSchoolId.length > 0) {
	        this.$helpers.setLocalStorage(this.localStorageKey, (0, _stringify2.default)(this.selectedSchoolIds));
	      } else {
	        this.$helpers.removeLocalStorage(this.localStorageKey);
	      }
	      if (this.selectedSchoolIds.length > 0) {
	        this.readSalary();
	      }
	    },
	    setIsSubmitting: function setIsSubmitting(userDay) {
	      if (!userDay) {
	        this.theUserDaySubmitting = null;
	      } else {
	        this.theUserDaySubmitting = userDay.day_id;
	      }
	    },
	    getIsSubmitting: function getIsSubmitting(userDay) {
	      return this.theUserDaySubmitting === userDay.day_id;
	    },
	    updatePropOnLesson: function updatePropOnLesson(obj) {
	      var idx = this.usersAndEvents.findIndex(function (userDay) {
	        return userDay.day_id === obj.userDay.day_id;
	      });
	
	      if (idx < 0) {
	        return;
	      }
	      var eventIdx = this.usersAndEvents[idx]['events'].findIndex(function (event) {
	        return event.event_id === obj.event.event_id;
	      });
	
	      if (eventIdx < 0) {
	        return;
	      }
	      var value = void 0;
	      if (obj.propToUpdate === 'afv_omkostningssted') {
	        value = obj.val === null ? null : String(obj.val);
	      } else if (obj.propToUpdate === 'zero') {
	        value = !!obj.val;
	        if (value) {
	          this.$store.dispatch('trackEvent', 'subSalary_zero_event_toggled');
	        }
	      } else {
	        value = obj.val * 1;
	      }
	      this.usersAndEvents[idx].events[eventIdx][obj.propToUpdate] = value;
	      if (this.isSalaryIntegrationActive && obj.propToUpdate === 'employment_id') {
	        var userEmployment = obj.user.v_user_employments.find(function (employment) {
	          return employment.id === Number(obj.val);
	        });
	        if (userEmployment) {
	          if (userEmployment.salary_code_id) {
	            this.usersAndEvents[idx].events[eventIdx].salary_code_id = Number(userEmployment.salary_code_id);
	          }
	          if (userEmployment.default_omkostningssted) {
	            this.usersAndEvents[idx].events[eventIdx].afv_omkostningssted = userEmployment.default_omkostningssted;
	          }
	        }
	      }
	      this.saveDay(this.usersAndEvents[idx]);
	    },
	    saveDay: function saveDay(userDay, onSuccess) {
	      var _this4 = this;
	
	      _docendo2.default.salaryDayUpdate(this.schoolId, this.selectedSchoolIds, userDay, function (success) {
	        _this4.setIsSubmitting(null);
	        if (success && success.status === 'error') {
	          _eventbus2.default.toast = {
	            text: success.message || 'Kunne ikke gemme dagen',
	            success: false,
	            position: 'bottomLeft'
	          };
	          return;
	        }
	        if (onSuccess) onSuccess(success);
	        _this4.applyDaysFromResponse(success && success.days ? success.days : []);
	      }, function (failure) {
	        _this4.setIsSubmitting(null);
	        _eventbus2.default.toast = {
	          text: failure && failure.message || failure || 'Kunne ikke gemme dagen',
	          success: false,
	          position: 'bottomLeft'
	        };
	      });
	    },
	    changeStateIsSent: function changeStateIsSent(userDay) {
	      var _this5 = this;
	
	      this.setIsSubmitting(userDay);
	      var updatedUserDay = JSON.parse((0, _stringify2.default)(userDay));
	      updatedUserDay['state'] = 'sent';
	      this.saveDay(updatedUserDay, function () {
	        var text = 'Dagen er markeret som indberettet';
	        if (_this5.isSDIntegrationActive) {
	          text = 'Vikartimerne overføres til SD som engangsydelser. Du kan følge dem under Løn → Engangsydelser.';
	        } else if (_this5.isSalaryIntegrationActive) {
	          text = 'Dagen er sendt til lønsystemet';
	        }
	        _eventbus2.default.toast = {
	          text: text,
	          success: true,
	          position: 'bottomLeft'
	        };
	      });
	    },
	    applyDaysFromResponse: function applyDaysFromResponse(days) {
	      var _this6 = this;
	
	      days.forEach(function (userDaySuccess) {
	        var idx = _this6.usersAndEvents.findIndex(function (userDay) {
	          return userDay.day_id === userDaySuccess.day_id;
	        });
	        if (idx > -1) {
	          var localEvents = _this6.usersAndEvents[idx].events;
	          userDaySuccess.events = userDaySuccess.events.map(function (event) {
	            var localEvent = localEvents.find(function (e) {
	              return e.event_id === event.event_id;
	            });
	            if (localEvent && localEvent.zero) {
	              event.zero = true;
	            }
	            return event;
	          });
	          _this6.$set(_this6.usersAndEvents, idx, userDaySuccess);
	        }
	      });
	    },
	    openBulkSendConfirm: function openBulkSendConfirm(userDays) {
	      var days = userDays && userDays.length ? userDays : this.userDaysApproved;
	      if (days.length < 1 || this.isBulkSending) {
	        return;
	      }
	      this.pendingBulkSendDays = days;
	      this.isConfirmBulkSend = true;
	    },
	    cancelBulkSend: function cancelBulkSend() {
	      if (!this.isBulkSending) {
	        this.isConfirmBulkSend = false;
	        this.pendingBulkSendDays = [];
	      }
	    },
	    bulkSendApprovedDays: function bulkSendApprovedDays() {
	      var _this7 = this;
	
	      if (this.isBulkSending || this.pendingBulkSendDays.length < 1) {
	        return;
	      }
	      var days = this.pendingBulkSendDays.map(function (userDay) {
	        return {
	          school_id: Number(userDay.school_id) || _this7.schoolId,
	          user_id: userDay.user_id,
	          day: (0, _moment2.default)(userDay.day).format('YYYY-MM-DD')
	        };
	      });
	      this.isBulkSending = true;
	      _docendo2.default.salaryDaysBulkSend(this.schoolId, this.selectedSchoolIds, days, function (success) {
	        _this7.isBulkSending = false;
	        _this7.isConfirmBulkSend = false;
	        _this7.pendingBulkSendDays = [];
	        if (success && success.status === 'error') {
	          _eventbus2.default.toast = {
	            text: success.message || 'Kunne ikke sende dagene',
	            success: false,
	            position: 'bottomLeft'
	          };
	          return;
	        }
	        _this7.applyDaysFromResponse(success && success.days ? success.days : []);
	        var text = days.length + ' dage er markeret som indberettet';
	        if (_this7.isSDIntegrationActive) {
	          text = 'Vikartimerne overføres til SD som engangsydelser. Du kan følge dem under Løn → Engangsydelser.';
	        } else if (_this7.isSalaryIntegrationActive) {
	          text = days.length === 1 ? '1 dag er sendt til lønsystemet' : days.length + ' dage er sendt til lønsystemet';
	        }
	        _eventbus2.default.toast = {
	          text: text,
	          success: true,
	          position: 'bottomLeft'
	        };
	      }, function (failure) {
	        _this7.isBulkSending = false;
	        _eventbus2.default.toast = {
	          text: failure && failure.message || failure || 'Kunne ikke sende dagene',
	          success: false,
	          position: 'bottomLeft'
	        };
	      });
	    },
	    unApproveDay: function unApproveDay(userDay) {
	      this.setIsSubmitting(userDay);
	      var updatedUserDay = JSON.parse((0, _stringify2.default)(userDay));
	      updatedUserDay['state'] = 'draft';
	      this.saveDay(updatedUserDay);
	    },
	    approveDay: function approveDay(userDay) {
	      this.setIsSubmitting(userDay);
	      var updatedUserDay = JSON.parse((0, _stringify2.default)(userDay));
	      updatedUserDay['state'] = 'approved';
	      this.saveDay(updatedUserDay);
	    },
	    getHumanizeMinutes: function getHumanizeMinutes(data) {
	      var totalMinutes = data;
	      var roundedMinutes = Math.round(totalMinutes);
	      var hours = Math.floor(roundedMinutes / 60);
	      var minutes = roundedMinutes % 60;
	      var hoursTitle = hours === 1 ? 'time' : 'timer';
	      return '(' + hours + ' ' + hoursTitle + ' ' + minutes + ' ' + 'min)' + ' - ' + (totalMinutes / 60).toFixed(2) + ' timer';
	    },
	    getSumTopCopy: function getSumTopCopy(totalMinutes) {
	      return (totalMinutes / 60).toFixed(2);
	    },
	    getIsDayValidated: function getIsDayValidated(userAndDay) {
	      return this.isSalaryIntegrationActive ? !userAndDay.events.every(function (event) {
	        return event.zero || event.employment_id && event.salary_code_id;
	      }) : !userAndDay.events.every(function (event) {
	        return event.zero || event.employment_id;
	      });
	    },
	    getUserEmployments: function getUserEmployments(userId) {
	      return this.employmentsInUserIdHash[userId] ? this.employmentsInUserIdHash[userId] : [];
	    },
	    getIsTheActiveUserDay: function getIsTheActiveUserDay(userDay) {
	      return this.theActiveUserDay === userDay.day_id;
	    },
	    setTheActiveUserDay: function setTheActiveUserDay(userDay) {
	      this.theActiveUserDay = this.theActiveUserDay === userDay.day_id ? null : userDay.day_id;
	    },
	    setFilter: function setFilter(filter) {
	      this.activeFilter = filter;
	    },
	    setIsShowSalarySettings: function setIsShowSalarySettings(bool) {
	      this.isShowSalarySettings = bool;
	    },
	    startDateChanged: function startDateChanged(date) {
	      this.startDate = date;
	      if (!this.isInitialLoad) {
	        this.readSalary();
	      }
	    },
	    endDateChanged: function endDateChanged(date) {
	      this.endDate = date;
	      if (!this.isInitialLoad) {
	        this.readSalary();
	      }
	    },
	    datesChanged: function datesChanged(_ref) {
	      var start = _ref.start,
	          end = _ref.end;
	
	      this.persistDateShortcut(start, end);
	    },
	    onUpdate: function onUpdate() {
	      this.readSalary();
	    },
	    readSalary: function readSalary() {
	      var _this8 = this;
	
	      if (this.selectedSchoolIds.length < 1) {
	        this.usersAndEvents = [];
	        return;
	      }
	      this.isLoading = true;
	      _docendo2.default.salaryDays(this.schoolId, this.selectedSchoolIds, this.dbStartDate, this.dbEndDate, function (success) {
	        if (success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, success: false };
	          _this8.isLoading = false;
	          return;
	        }
	        _this8.usersAndEvents = success.days;
	        _this8.isLoading = false;
	        if (_this8.isInitialLoad) {
	          _this8.isInitialLoad = false;
	        }
	      }, function (failure) {
	        _eventbus2.default.toast = { text: failure, success: false };
	        _this8.isLoading = false;
	      });
	    },
	    getSavedSchoolIdsAndCheckForPermission: function getSavedSchoolIdsAndCheckForPermission() {
	      var _this9 = this;
	
	      if (!this.isUserLoaded) {
	        return;
	      }
	
	      var localStorageSelectedSchoolIds = this.$helpers.getLocalStorage(this.localStorageKey);
	      var selectedSchoolIds = [];
	      if (localStorageSelectedSchoolIds) {
	        try {
	          var parsedSchoolIds = JSON.parse(localStorageSelectedSchoolIds);
	          parsedSchoolIds.forEach(function (schoolId) {
	            if (_this9.getHasPermission(schoolId) && !selectedSchoolIds.includes(schoolId)) {
	              selectedSchoolIds.push(schoolId);
	            }
	          });
	          var selectedSchoolIdsWithoutActiveSchoolId = selectedSchoolIds.filter(function (schoolId) {
	            return schoolId !== _this9.schoolId;
	          });
	
	          if (selectedSchoolIdsWithoutActiveSchoolId.length > 0) {
	            this.$helpers.setLocalStorage(this.localStorageKey, (0, _stringify2.default)(selectedSchoolIds));
	          } else {
	            this.$helpers.removeLocalStorage(this.localStorageKey);
	          }
	
	          if (selectedSchoolIdsWithoutActiveSchoolId.length === 0) {
	            this.selectedSchoolIds = [this.schoolId];
	          } else {
	            this.selectedSchoolIds = selectedSchoolIds;
	          }
	
	          this.readSalary();
	        } catch (e) {
	          console.error('Error parsing localStorage data', e);
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.applySavedOrDefaultDateRange();
	    this.$store.dispatch('readSalaryCodes');
	    this.$store.dispatch('readEmployments');
	    this.$store.dispatch('readCostCenters');
	    if (this.schoolIdsWithSchoolSelector.includes(this.schoolId)) {
	      this.isSchoolSelectorOn = true;
	    } else {
	      this.$helpers.removeLocalStorage(this.localStorageKey);
	    }
	
	    var localStorageSelectedSchoolIds = this.$helpers.getLocalStorage(this.localStorageKey);
	
	    if (!localStorageSelectedSchoolIds) {
	      this.selectedSchoolIds = [this.schoolId];
	      this.readSalary();
	    } else {
	      this.getSavedSchoolIdsAndCheckForPermission();
	    }
	  }
	};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _SalarySubsPerfUserDay = __webpack_require__(379);
	
	var _SalarySubsPerfUserDay2 = _interopRequireDefault(_SalarySubsPerfUserDay);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SalaryFilters = __webpack_require__(375);
	
	var _SalaryFilters2 = _interopRequireDefault(_SalaryFilters);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SalarySubsPerfUserTable = __webpack_require__(380);
	
	var _SalarySubsPerfUserTable2 = _interopRequireDefault(_SalarySubsPerfUserTable);
	
	var _SalarySubsPerfUserOpusModal = __webpack_require__(1582);
	
	var _SalarySubsPerfUserOpusModal2 = _interopRequireDefault(_SalarySubsPerfUserOpusModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SalarySubsPerfUserOpusModal: _SalarySubsPerfUserOpusModal2.default,
	    SalarySubsPerfUserTable: _SalarySubsPerfUserTable2.default, Loader: _Loader2.default, SalaryFilters: _SalaryFilters2.default, SalarySubsPerfUserDay: _SalarySubsPerfUserDay2.default, DModal: _DModal2.default
	  },
	  props: {
	    usersPackedInDaysWithProps: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    activeUserId: {
	      default: null
	    },
	    startDate: {
	      default: function _default() {
	        return (0, _moment2.default)().startOf('month');
	      }
	    },
	    endDate: {
	      default: function _default() {
	        return (0, _moment2.default)().endOf('month');
	      }
	    },
	    schoolId: {
	      default: null
	    },
	    activeFilter: {
	      default: 'draft'
	    },
	    theUserDaySubmitting: {},
	    isSalaryIntegrationActive: {
	      type: Boolean,
	      default: false
	    },
	    isOpusIntegrationActive: {
	      type: Boolean,
	      default: false
	    },
	    salaryCodes: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    loebenummer: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    costCenters: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isBulkSending: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      isShowUserTable: false,
	      activeOpusUser: null
	    };
	  },
	
	  computed: {
	    user: function user() {
	      var _this = this;
	
	      return this.usersPackedInDaysWithProps.find(function (user) {
	        return user.user_id === _this.activeUserId;
	      }) ? this.usersPackedInDaysWithProps.find(function (user) {
	        return user.user_id === _this.activeUserId;
	      }) : null;
	    },
	    validationTxt: function validationTxt() {
	      return this.isSalaryIntegrationActive ? 'Vælg ansættelse og lønkode på hver lektion' : 'Vælg ansættelse på hver lektion';
	    },
	    userName: function userName() {
	      return this.user && this.user.v_user_name ? this.user.v_user_name : '';
	    },
	    titleOfPeriod: function titleOfPeriod() {
	      return (0, _moment2.default)(this.startDate).format('LL') + ' - ' + (0, _moment2.default)(this.endDate).format('LL');
	    },
	    title: function title() {
	      switch (this.activeFilter) {
	        case 'draft':
	          return 'Efterbehandling';
	        case 'approved':
	          return 'Godkendt';
	        case 'sent':
	          return this.isSalaryIntegrationActive ? 'Sendt til lønsystem' : 'Er indberettet';
	      }
	    },
	    canBulkSendUserDays: function canBulkSendUserDays() {
	      return this.activeFilter === 'approved' && this.user && this.user.days && this.user.days.length > 0;
	    },
	    bulkSendButtonLabel: function bulkSendButtonLabel() {
	      return this.isSalaryIntegrationActive ? 'Send alle til lønsystem' : 'Marker alle som indberettet';
	    }
	  },
	  methods: {
	    setActiveOpusUser: function setActiveOpusUser(user) {
	      this.activeOpusUser = user;
	    },
	    getIsSubmitting: function getIsSubmitting(userDay) {
	      return this.theUserDaySubmitting === userDay.day_id;
	    },
	    getIsDayValidated: function getIsDayValidated(userAndDay) {
	      return this.isSalaryIntegrationActive ? !userAndDay.events.every(function (event) {
	        return event.zero || event.employment_id && event.salary_code_id;
	      }) : !userAndDay.events.every(function (event) {
	        return event.zero || event.employment_id;
	      });
	    },
	    print: function print() {
	      var fileTitle = 'Vikarløn Efterbehandling ' + this.userName + ' - ' + (0, _moment2.default)(this.startDate).format('DD-MM-YYYY') + '_' + (0, _moment2.default)(this.endDate).format('DD-MM-YYYY') + ' • docendo.dk';
	
	      var prtHtml = document.getElementById('printUserSalary').innerHTML;
	
	      var stylesHtml = '';
	
	      var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')));
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var node = _arr[_i];
	        stylesHtml += node.outerHTML;
	      }
	
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	
	      WinPrint.document.write('<!DOCTYPE html><html id="html-bg-white"><head><title>' + fileTitle + '</title>' + stylesHtml + '</head><body>' + prtHtml + '</body></html>');
	      var afterPrint = function afterPrint() {
	        WinPrint.close();
	      };
	      WinPrint.onafterprint = afterPrint;
	      setTimeout(function (_) {
	        WinPrint.document.close();
	        WinPrint.focus();
	        WinPrint.print();
	      }, 1000);
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.isLoading = true;
	    setTimeout(function (_) {
	      _this2.isLoading = false;
	    }, 500);
	  }
	};

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(28);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    user: {
	      type: Object
	    },
	    userDay: {
	      type: Object
	    },
	    isSalaryIntegrationActive: {
	      type: Boolean,
	      default: false
	    },
	    salaryCodes: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    costCenters: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  computed: {
	    events: function events() {
	      var _this = this;
	
	      return this.userDay.events.map(function (event) {
	        var userEmployments = _this.user.v_user_employments;
	        return (0, _extends3.default)({}, event, {
	          v_is_special: event.event_type.startsWith('_extra_time_'),
	          v_start_and_endtime: (0, _moment2.default)(event.start).format('LT') + ' - ' + (0, _moment2.default)(event.end).format('LT'),
	          v_calendar_name: event.calendars ? _this.getCalendarName(event) : '',
	          v_substitute_for_employments: event.substitute_for_user_id ? _this.getSubstituteForEmployments(event.substitute_for_user_id) : [],
	          v_substitute_for_name: event.substitute_for_user_id && _this.allUsersInHash[event.substitute_for_user_id] ? _this.allUsersInHash[event.substitute_for_user_id]['name'] : '',
	          v_event_type_name: _this.getExtraEventTitle(event.event_type) || (_this.$t('vue2.eventTypes.' + event.event_type) !== 'vue2.eventTypes.' + event.event_type ? _this.$t('vue2.eventTypes.' + event.event_type) : event.event_type),
	          v_employment_id_title: event.employment_id ? userEmployments.find(function (userEmployment) {
	            return userEmployment.id === event.employment_id;
	          }) ? userEmployments.find(function (userEmployment) {
	            return userEmployment.id === event.employment_id;
	          })['title'] : event.employment_id : 'Ingen valgt',
	          v_employment_details_tip: _this.employmentDetailsTip(event.employment)
	        }, _this.employmentSourceProps(event));
	      });
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    schoolSubstituteRules: function schoolSubstituteRules() {
	      var school = this.$store.state.activeSchool;
	      return school && school.substitute_rules ? school.substitute_rules : {};
	    }
	  },
	  methods: {
	    employmentDetailsTip: function employmentDetailsTip(employment) {
	      if (!employment || (typeof employment === 'undefined' ? 'undefined' : (0, _typeof3.default)(employment)) !== 'object') return '';
	      var formatDate = function formatDate(date) {
	        return date ? (0, _moment2.default)(date).format('DD-MM-YYYY') : '';
	      };
	      var lines = [];
	      var heading = [employment.employment_number, employment.source_title].filter(Boolean).join(' - ');
	      if (heading) lines.push('<b>' + heading + '</b>');
	      if (employment.organisation) lines.push(employment.organisation);
	      if (employment.employment_percent != null && employment.employment_percent !== '') {
	        lines.push(parseFloat(employment.employment_percent) + '%');
	      }
	      if (employment.start_date) {
	        var hasEndDate = employment.end_date && employment.end_date !== '2099-12-31';
	        lines.push(hasEndDate ? formatDate(employment.start_date) + ' – ' + formatDate(employment.end_date) : 'Fra ' + formatDate(employment.start_date));
	      }
	      return lines.join('<br>');
	    },
	    employmentSourceProps: function employmentSourceProps(event) {
	      if (this.userDay.state !== 'draft' || !event.employment_id) {
	        return {
	          v_employment_source: null,
	          v_employment_source_tip: ''
	        };
	      }
	      if (event.rule_id) {
	        return {
	          v_employment_source: 'rule',
	          v_employment_source_tip: this.ruleTooltip(event.rule_id)
	        };
	      }
	      if (this.eventHasSavedEmployment(event)) {
	        return {
	          v_employment_source: 'saved',
	          v_employment_source_tip: 'Ansættelsen er gemt på dagen og opdateres ikke automatisk, når regler ændres.'
	        };
	      }
	      return {
	        v_employment_source: null,
	        v_employment_source_tip: ''
	      };
	    },
	    eventHasSavedEmployment: function eventHasSavedEmployment(event) {
	      var saved = this.userDay && this.userDay.employments;
	      if (!saved || (typeof saved === 'undefined' ? 'undefined' : (0, _typeof3.default)(saved)) !== 'object') return false;
	      var eventId = String(event.event_id);
	      var val = saved[eventId];
	      return val != null && val !== 0 && val !== '0' && val !== '';
	    },
	    ruleTooltip: function ruleTooltip(ruleId) {
	      var rules = this.schoolSubstituteRules.rules || [];
	      var rule = rules.find(function (item) {
	        return String(item.id) === String(ruleId);
	      });
	      if (!rule) return 'Sat af en regel';
	      return this.describeRule(rule);
	    },
	    describeRule: function describeRule(rule) {
	      var selected = this.employmentTitleName(rule.selected_employment_title);
	      if (rule.type === 'employment_type') {
	        return 'Hvis man er vikar for ' + (rule.substituted_employment_title || '') + ', tæller det som ' + selected + '.';
	      }
	      if (rule.type === 'subject_type') {
	        return 'Hvis briktypen er ' + this.subjectTypeName(rule.subject_type) + ', tæller det som ' + selected + '.';
	      }
	      if (rule.type === 'subject_title') {
	        return 'Hvis brikken hedder “' + (rule.subject_title || '') + '”, tæller det som ' + selected + '.';
	      }
	      if (rule.type === 'calendar_id') {
	        return 'Hvis kalenderen er ' + this.calendarNameById(rule.calendar_id) + ', tæller det som ' + selected + '.';
	      }
	      return selected || 'Sat af en regel';
	    },
	    employmentTitleName: function employmentTitleName(title) {
	      if (title === '*Stillingen fra lektionen efter*') return 'stillingen fra lektionen efter';
	      if (title === '*Stillingen fra lektionen før*') return 'stillingen fra lektionen før';
	      return title || '';
	    },
	    subjectTypeName: function subjectTypeName(subjectType) {
	      var extraTimeNames = {
	        _extra_time_at_start_of_day_: 'ekstra tid før første lektion',
	        _extra_time_between_events_: 'ekstra tid mellem timer',
	        _extra_time_if_shorter_than_: 'ekstra tid, når dagen er for kort'
	      };
	      if (extraTimeNames[subjectType]) return extraTimeNames[subjectType];
	      var key = 'vue2.eventTypes.' + subjectType;
	      var translated = this.$t(key);
	      return translated !== key ? translated.toLowerCase() : subjectType || '';
	    },
	    calendarNameById: function calendarNameById(calendarId) {
	      var calendars = [].concat(this.$store.getters.klassCalendars || []).concat(this.$store.getters.clubCalendars || []).concat(this.$store.getters.otherCalendars || []);
	      var calendar = calendars.find(function (item) {
	        return String(item.id) === String(calendarId);
	      });
	      return calendar && calendar.name ? calendar.name : calendarId || '';
	    },
	    updatePropOnLesson: function updatePropOnLesson(propToUpdate, user, userDay, event, val) {
	      var obj = { propToUpdate: propToUpdate, user: user, userDay: userDay, event: event, val: val };
	      console.log(propToUpdate, val);
	      this.$emit('updatePropOnLesson', obj);
	    },
	    getCalendarName: function getCalendarName(event) {
	      var calendar = event.calendars ? event.calendars.find(function (calEvent) {
	        return calEvent.calendar_id === event.calendar_id;
	      }) : null;
	      return calendar ? calendar.name : '';
	    },
	    getSubstituteForEmployments: function getSubstituteForEmployments(substituteForUserId) {
	      return this.getUserEmployments(substituteForUserId).map(function (employment) {
	        return employment.title;
	      });
	    },
	    getUserEmployments: function getUserEmployments(userId) {
	      return this.employmentsInUserIdHash[userId] ? this.employmentsInUserIdHash[userId] : [];
	    },
	    getExtraEventTitle: function getExtraEventTitle(eventTitle) {
	      var obj = {
	        _extra_time_at_start_of_day_: 'Ekstra tid',
	        _extra_time_if_shorter_than_: 'Ekstra tid',
	        _extra_time_between_events_: 'Ekstra tid'
	      };
	      return obj[eventTitle];
	    }
	  }
	};

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, DModal: _DModal2.default },
	  props: {
	    user: {
	      type: Object
	    },
	    startDate: {
	      default: function _default() {
	        return (0, _moment2.default)().startOf('month');
	      }
	    },
	    endDate: {
	      default: function _default() {
	        return (0, _moment2.default)().endOf('month');
	      }
	    },
	    schoolId: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      fromDate: (0, _moment2.default)().format('YYYY-MM-DD'),
	      toDate: (0, _moment2.default)().add(1, 'days').format('YYYY-MM-DD'),
	      opusData: [],
	      isLoading: false
	    };
	  },
	
	  computed: {
	    titleOfPeriod: function titleOfPeriod() {
	      if (!this.startDate || !this.endDate) return 'Ingen periode valgt';
	      return (0, _moment2.default)(this.startDate).format('LL') + ' - ' + (0, _moment2.default)(this.endDate).format('LL');
	    },
	    oneTimePayments: function oneTimePayments() {
	      if (!this.opusData || !this.opusData.one_time_payments) {
	        return [];
	      } else {
	        return this.opusData.one_time_payments.sort(function (a, b) {
	          return new Date(a.startdato) - new Date(b.startdato);
	        });
	      }
	    }
	  },
	  methods: {
	    readOpus: function readOpus() {
	      var _this = this;
	
	      this.isLoading = true;
	      var schoolIds = [this.schoolId];
	      _docendo2.default.salaryOpusRead(this.schoolId, schoolIds, this.fromDate, this.toDate, this.user.user_id, function (success) {
	        _this.opusData = success;
	        _this.isLoading = false;
	        console.log('opus', success);
	      }, function (failure) {
	        console.log(failure);
	        _eventbus2.default.toast = { text: failure.error, success: false };
	        _this.isLoading = false;
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.fromDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	    this.toDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	    this.readOpus();
	  }
	};

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    startDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    endDate: {
	      default: function _default() {
	        return (0, _moment2.default)().add(3, 'days');
	      }
	    },
	    user: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      tables: []
	    };
	  },
	
	  computed: {
	    userName: function userName() {
	      return this.user && this.user.v_user_name ? this.user.v_user_name : '';
	    },
	    tablesSorted: function tablesSorted() {
	      return this.tables.slice().sort(function (a, b) {
	        return a.title.localeCompare(b.title, 'da-DK');
	      });
	    }
	  },
	  methods: {
	    createTables: function createTables() {
	      var _this = this;
	
	      this.tables = [];
	
	      this.user.v_user_sums.forEach(function (sumType) {
	        var rowKey = sumType.employment_id + '__' + (sumType.costCenter_code != null ? sumType.costCenter_code : 'noCC');
	        var titlePrefix = sumType.costCenter ? '[' + sumType.costCenter + '] ' : '';
	        var obj = {
	          rowKey: rowKey,
	          employmentId: sumType.employment_id,
	          costCenterCode: sumType.costCenter_code || null,
	          title: titlePrefix + sumType.employment_title,
	          minutes: sumType.minutes_to_copy,
	          dates: _this.datesForTable(sumType.employment_id, sumType.costCenter_code || null)
	        };
	        _this.tables.push(obj);
	      });
	    },
	    datesForTable: function datesForTable(employmentId, costCenterCodeOrNull) {
	      var _this2 = this;
	
	      function switchDotsAndCommas(s) {
	        return s.replaceAll(/\.|,/g, function (match) {
	          return match === ',' ? '.' : ',';
	        });
	      }
	
	      var dates = [];
	      var startDate = (0, _moment2.default)(this.startDate).startOf('day');
	      var endDate = (0, _moment2.default)(this.endDate).endOf('day');
	      var daysDiff = endDate.diff(startDate, 'days');
	
	      var _loop = function _loop(i) {
	        var currentDate = startDate.clone().add(i, 'days');
	        var formattedDate = currentDate.format('DD-MM-YYYY');
	        var rawDate = currentDate.format('YYYY-MM-DD');
	
	        var subDay = _this2.user.days.find(function (day) {
	          return day.day === rawDate;
	        });
	        var dayCount = null;
	
	        if (subDay) {
	          var theEmployment = subDay.v_sums.find(function (vSum) {
	            if (vSum.employment_id !== employmentId) return false;
	            var a = vSum.costCenter_code;
	            var b = costCenterCodeOrNull;
	
	            return a == null ? b == null : a === b;
	          });
	
	          if (theEmployment) {
	            dayCount = switchDotsAndCommas(JSON.parse((0, _stringify2.default)(theEmployment.minutes_to_copy)));
	          }
	        }
	
	        dates.push({ date: formattedDate, dayCount: dayCount });
	      };
	
	      for (var i = 0; i <= daysDiff; i++) {
	        _loop(i);
	      }
	
	      return dates;
	    },
	    copyTableDayCounts: function copyTableDayCounts(table, evt) {
	      var dayCounts = table.dates.map(function (date) {
	        return date.dayCount !== null && date.dayCount !== undefined ? date.dayCount : '';
	      }).join('\n');
	
	      navigator.clipboard.writeText(dayCounts).then(function () {
	        evt.target._tippy.show();
	      }).catch(function (err) {
	        console.error('Failed to copy day counts for ' + table.title + ': ', err);
	      });
	    },
	    hideTippy: function hideTippy(tippyEl) {
	      setTimeout(function (_) {
	        tippyEl.hide();
	      }, 1000);
	    },
	    print: function print() {
	      var fileTitle = 'Vikarløn tabel ' + this.userName + ' - ' + (0, _moment2.default)(this.startDate).format('DD-MM-YYYY') + '_' + (0, _moment2.default)(this.endDate).format('DD-MM-YYYY') + ' • docendo.dk';
	      var prtHtml = document.getElementById('printUserSalaryTable').innerHTML;
	      var stylesHtml = '';
	
	      var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')));
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var node = _arr[_i];
	        stylesHtml += node.outerHTML;
	      }
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	      WinPrint.document.write('<!DOCTYPE html><html id="html-bg-white"><head><title>' + fileTitle + '</title>' + stylesHtml + '</head><body>' + prtHtml + '</body></html>');
	      var afterPrint = function afterPrint() {
	        WinPrint.close();
	      };
	      WinPrint.onafterprint = afterPrint;
	      setTimeout(function (_) {
	        WinPrint.document.close();
	        WinPrint.focus();
	        WinPrint.print();
	      }, 1000);
	    }
	  },
	  mounted: function mounted() {
	    this.createTables();
	  }
	};

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _TableCreateModal = __webpack_require__(381);
	
	var _TableCreateModal2 = _interopRequireDefault(_TableCreateModal);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _CostCentersCenter = __webpack_require__(1583);
	
	var _CostCentersCenter2 = _interopRequireDefault(_CostCentersCenter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { CostCentersCenter: _CostCentersCenter2.default, DoFiltersFilter: _DoFiltersFilter2.default, Loader: _Loader2.default, TableCreateModal: _TableCreateModal2.default },
	  props: {
	    costCenterRules: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isInSchoolSalarySettings: {
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      isCreateItemModal: false,
	      theEditItem: null,
	      isDeleting: false,
	      isAwaitingCloseModal: false,
	      costCenterRulesBuffer: [],
	      isShowArchived: false,
	      updatingCostCenterId: null
	    };
	  },
	
	  computed: {
	    activeSchool: function activeSchool() {
	      return this.$store.getters.schoolId;
	    },
	    costCenters: function costCenters() {
	      return this.$store.getters.costCenters;
	    },
	    archivedCostCenters: function archivedCostCenters() {
	      return this.$store.getters.costCentersArchived;
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.employments.isLoadingCostCenters;
	    },
	    isSubmitting: function isSubmitting() {
	      return this.$store.state.employments.isUpdatingCostCenters;
	    },
	    klassCalendars: function klassCalendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    otherCalendars: function otherCalendars() {
	      return this.$store.getters.otherCalendars;
	    },
	    clubCalendars: function clubCalendars() {
	      return this.$store.getters.clubCalendars;
	    },
	    calendars: function calendars() {
	      return [].concat(this.klassCalendars || []).concat(this.otherCalendars || []).concat(this.clubCalendars || []);
	    },
	    calendarNames: function calendarNames() {
	      return this.calendars.map(function (calendar) {
	        return calendar.name;
	      });
	    },
	    ruleMap: function ruleMap() {
	      var map = {};
	      var rules = Array.isArray(this.costCenterRules) ? this.costCenterRules : [];
	      rules.forEach(function (r) {
	        map[r.selected_cost_center_id] = Array.isArray(r.calendar_ids) ? r.calendar_ids : [];
	      });
	      return map;
	    }
	  },
	  watch: {
	    isSubmitting: function isSubmitting(val, oldVal) {
	      if (this.isAwaitingCloseModal && !val) {
	        this.isAwaitingCloseModal = false;
	        this.setIsCreateItemModal(false);
	      }
	    },
	
	    watch: {
	      costCenterRules: {
	        handler: function handler(val) {
	          var arr = Array.isArray(val) ? val : [];
	
	          this.costCenterRulesBuffer = JSON.parse((0, _stringify2.default)(arr));
	        },
	
	        immediate: true,
	        deep: true
	      }
	    }
	  },
	  methods: {
	    onSaveRule: function onSaveRule(rule) {
	      var idx = this.costCenterRulesBuffer.findIndex(function (r) {
	        return r.selected_cost_center_id === rule.selected_cost_center_id;
	      });
	      if (idx > -1) {
	        this.costCenterRulesBuffer.splice(idx, 1, rule);
	      } else {
	        this.costCenterRulesBuffer.push(rule);
	      }
	      this.$emit('updateCostCenterRules', this.costCenterRulesBuffer);
	    },
	    getInitialIdsFor: function getInitialIdsFor(costCenterId) {
	      return this.ruleMap[costCenterId] || [];
	    },
	    prefilledIdsFor: function prefilledIdsFor(costCenterId) {
	      return this.getInitialIdsFor(costCenterId);
	    },
	    setIsCreateItemModal: function setIsCreateItemModal(bool) {
	      this.isCreateItemModal = bool;
	      if (!bool) {
	        this.theEditItem = null;
	      }
	    },
	    setEditItem: function setEditItem(item) {
	      this.theEditItem = item;
	      this.isCreateItemModal = true;
	    },
	    onCreate: function onCreate(costCenter) {
	      this.isAwaitingCloseModal = true;
	      this.$store.dispatch('createCostCenter', costCenter);
	    },
	    archiveCostCenter: function archiveCostCenter(costCenter) {
	      var _this = this;
	
	      this.updatingCostCenterId = costCenter.id;
	      this.$store.dispatch('archiveCostCenter', costCenter).finally(function () {
	        _this.updatingCostCenterId = null;
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('readSalaryCodes');
	    this.$store.dispatch('readCostCenters');
	  }
	};

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _CostCentersCenterCalendarsModal = __webpack_require__(1584);
	
	var _CostCentersCenterCalendarsModal2 = _interopRequireDefault(_CostCentersCenterCalendarsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { CostCentersCenterCalendarsModal: _CostCentersCenterCalendarsModal2.default, DoFiltersFilter: _DoFiltersFilter2.default },
	  props: {
	    item: {
	      type: Object,
	      required: true
	    },
	    calendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      } },
	    calendarNames: {
	      type: Array,
	      default: function _default() {
	        return [];
	      } },
	    initialSelectedCalendarIds: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isInSchoolSalarySettings: {
	      type: Boolean,
	      default: true
	    },
	    isUpdating: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isShowModal: false,
	      selectedIds: [],
	      lastEmittedIds: []
	    };
	  },
	
	  computed: {
	    isArchived: function isArchived() {
	      return !!(this.item && (this.item.archived === true || this.item.archived_at));
	    },
	    selectedNames: function selectedNames() {
	      var _this = this;
	
	      var ids = this.selectedIds;
	      return ids.map(function (id) {
	        var cal = _this.calendars.find(function (c) {
	          return c.id === id;
	        });
	        return cal ? cal.name : null;
	      }).filter(function (n) {
	        return n !== null;
	      });
	    }
	  },
	  methods: {
	    arraysEqual: function arraysEqual(a, b) {
	      var aa = (a || []).slice().sort();
	      var bb = (b || []).slice().sort();
	      if (aa.length !== bb.length) return false;
	      for (var i = 0; i < aa.length; i++) {
	        if (aa[i] !== bb[i]) return false;
	      }
	      return true;
	    },
	    onModalSubmit: function onModalSubmit(ids) {
	      this.isShowModal = false;
	
	      if (this.arraysEqual(ids, this.lastEmittedIds)) return;
	
	      this.selectedIds = ids.slice();
	      this.lastEmittedIds = ids.slice();
	
	      var payload = {
	        type: 'calendars',
	        calendar_ids: ids,
	        selected_cost_center_id: this.item.id
	      };
	      this.$emit('save', payload);
	    },
	    noop: function noop() {
	      return;
	    }
	  },
	  mounted: function mounted() {
	    this.selectedIds = Array.isArray(this.initialSelectedCalendarIds) ? this.initialSelectedCalendarIds.slice() : [];
	    this.lastEmittedIds = this.selectedIds.slice();
	  }
	};

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default, Tabs: _Tabs2.default },
	  props: {
	    calendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      } },
	    selectedIds: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isSubmitting: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      localSelectedIds: [],
	      activeTab: 'all'
	    };
	  },
	
	  computed: {
	    tabs: function tabs() {
	      var hasType = this.calendars.some(function (c) {
	        return c && c.type;
	      });
	      if (!hasType) {
	        return [{ id: 'all', title: 'Alle' }];
	      }
	      return [{ id: 'all', title: 'Alle' }, { id: 'klass', title: 'Klasser' }, { id: 'club', title: 'SFO' }, { id: 'other', title: 'Andre' }];
	    },
	    filteredCalendars: function filteredCalendars() {
	      var _this = this;
	
	      if (this.activeTab === 'all') return this.calendars;
	      return this.calendars.filter(function (c) {
	        return c.type === _this.activeTab;
	      });
	    },
	    isAllChecked: function isAllChecked() {
	      var _this2 = this;
	
	      var idsInTab = this.filteredCalendars.map(function (c) {
	        return c.id;
	      });
	      if (idsInTab.length === 0) return false;
	
	      return idsInTab.every(function (id) {
	        return _this2.localSelectedIds.indexOf(id) > -1;
	      });
	    }
	  },
	  methods: {
	    toggleOne: function toggleOne(id) {
	      var idx = this.localSelectedIds.indexOf(id);
	      if (idx > -1) {
	        this.localSelectedIds.splice(idx, 1);
	      } else {
	        this.localSelectedIds.push(id);
	      }
	    },
	    toggleSelectAll: function toggleSelectAll() {
	      var _this3 = this;
	
	      var idsInTab = this.filteredCalendars.map(function (c) {
	        return c.id;
	      });
	      var allSelected = idsInTab.every(function (id) {
	        return _this3.localSelectedIds.indexOf(id) > -1;
	      });
	      if (allSelected) {
	        this.localSelectedIds = this.localSelectedIds.filter(function (id) {
	          return idsInTab.indexOf(id) === -1;
	        });
	      } else {
	        var set = {};
	        this.localSelectedIds.forEach(function (id) {
	          set[id] = true;
	        });
	        idsInTab.forEach(function (id) {
	          set[id] = true;
	        });
	        this.localSelectedIds = (0, _keys2.default)(set).map(function (x) {
	          return Number(x);
	        });
	      }
	    },
	    onSubmit: function onSubmit() {
	      this.$emit('submit', this.localSelectedIds.slice());
	      this.$store.dispatch('trackEvent', 'subSalary_CostCenterRules_saved');
	    }
	  },
	  mounted: function mounted() {
	    this.localSelectedIds = Array.isArray(this.selectedIds) ? this.selectedIds.slice() : [];
	  }
	};

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(51);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DoEmploymentTemplate = __webpack_require__(140);
	
	var _DoEmploymentTemplate2 = _interopRequireDefault(_DoEmploymentTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'EmploymentTemplatesTable',
	  components: { DoEmploymentTemplate: _DoEmploymentTemplate2.default, Loader: _Loader2.default },
	  props: {
	    selectedEmploymentIds: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    initiallyLoading: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: this.initiallyLoading,
	      isTemplateModalOpen: false,
	      editTemplate: null,
	      isSubmitting: false
	    };
	  },
	
	  computed: {
	    templates: function templates() {
	      return this.$store.getters.employmentTemplatesSorted;
	    },
	    showSpecialSkoleSalaryCodeColumn: function showSpecialSkoleSalaryCodeColumn() {
	      if (this.$store.getters.salarySystem === 'SD') return false;
	      return this.templates.some(function (template) {
	        return template.special_hour_limit_salary_code_id != null && template.special_hour_limit_salary_code_id !== '';
	      });
	    },
	    emptyColspan: function emptyColspan() {
	      return this.showSpecialSkoleSalaryCodeColumn ? 8 : 7;
	    },
	    salaryCodesSorted: function salaryCodesSorted() {
	      return this.$store.getters.salaryCodesSorted || [];
	    },
	    salaryCodeMap: function salaryCodeMap() {
	      var map = {};
	      for (var i = 0; i < this.salaryCodesSorted.length; i++) {
	        var sc = this.salaryCodesSorted[i];
	        map[sc.id] = sc.vTitle;
	      }
	      return map;
	    },
	    costCenters: function costCenters() {
	      return this.$store.getters.costCentersAll || [];
	    },
	    costCenterMap: function costCenterMap() {
	      var m = {};
	      for (var i = 0; i < this.costCenters.length; i++) {
	        var c = this.costCenters[i];
	
	        var key = typeof c.code === 'number' ? String(c.code) : c.code;
	        m[key] = c.title;
	      }
	      return m;
	    }
	  },
	  methods: {
	    salaryCodeTitle: function salaryCodeTitle(id) {
	      if (id === null || typeof id === 'undefined' || id === '') return '';
	      return this.salaryCodeMap[id] || '';
	    },
	    costCenterTitle: function costCenterTitle(code) {
	      if (code === null || typeof code === 'undefined' || code === '') return '';
	      var key = typeof code === 'number' ? String(code) : code;
	      if (this.costCenterMap[key]) {
	        return this.costCenterMap[key];
	      }
	
	      var formatted = String(code).toUpperCase().substring(0, 4);
	      return formatted;
	    },
	    readAllEmployments: function readAllEmployments() {
	      var _this = this;
	
	      this.isLoading = true;
	
	      _promise2.default.resolve().then(function () {
	        return _this.$store.dispatch('readEmploymentTemplates');
	      }).then(function () {
	        return _this.$store.dispatch('readSalaryCodes');
	      }).then(function () {
	        _this.isLoading = false;
	      }).catch(function () {
	        _this.isLoading = false;
	      });
	    },
	    openCreate: function openCreate() {
	      this.editTemplate = null;
	      this.isTemplateModalOpen = true;
	    },
	    openEdit: function openEdit(tpl) {
	      this.editTemplate = tpl;
	      this.isTemplateModalOpen = true;
	    },
	    closeTemplateModal: function closeTemplateModal() {
	      this.editTemplate = null;
	      this.isTemplateModalOpen = false;
	    },
	    onSelect: function onSelect(tpl) {
	      if (!this.selectedEmploymentIds || this.selectedEmploymentIds.length === 0) {
	        _eventbus2.default.toast = { text: 'Vælg personale først', success: false };
	        return;
	      }
	      this.$emit('select', tpl);
	    },
	    onTemplateCreated: function onTemplateCreated() {
	      this.closeTemplateModal();
	      this.readAllEmployments();
	    },
	    onTemplateUpdated: function onTemplateUpdated() {
	      this.closeTemplateModal();
	      this.readAllEmployments();
	    },
	    onTemplateDeleted: function onTemplateDeleted() {
	      this.closeTemplateModal();
	      this.readAllEmployments();
	    }
	  },
	  mounted: function mounted() {
	    this.readAllEmployments();
	  }
	};

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TableCreateModal = __webpack_require__(381);
	
	var _TableCreateModal2 = _interopRequireDefault(_TableCreateModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, TableCreateModal: _TableCreateModal2.default },
	  props: {
	    isInSchoolSalarySettings: {
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      isCreateItemModal: false,
	      theEditItem: null,
	      isSubmitting: false,
	      isDeleting: false,
	      tillaegsnummer: '',
	      submitError: ''
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    salarySystem: function salarySystem() {
	      return this.$store.getters.salarySystem;
	    },
	    items: function items() {
	      return this.salaryCodes;
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted;
	    },
	    isLoadingSalaryCodes: function isLoadingSalaryCodes() {
	      return this.$store.state.employments.isLoadingSalaryCodes;
	    }
	  },
	  methods: {
	    setIsCreateItemModal: function setIsCreateItemModal(bool) {
	      this.isCreateItemModal = bool;
	      this.submitError = '';
	      if (!bool) {
	        this.theEditItem = null;
	      }
	    },
	    setEditItem: function setEditItem(item) {
	      this.theEditItem = item;
	      this.isCreateItemModal = true;
	    },
	    onCreate: function onCreate(obj) {
	      var _this = this;
	
	      var schoolId = this.schoolId;
	      var name = obj.name;
	      var loenart = obj.code;
	      var tillaegsnummer = obj.tillaegsnummer ? obj.tillaegsnummer : '';
	      this.isSubmitting = true;
	      this.submitError = '';
	      _docendo2.default.createSalaryCode(schoolId, name, loenart, tillaegsnummer, function (success) {
	        _this.isCreateItemModal = false;
	        _this.isSubmitting = false;
	        _this.$store.dispatch('readSalaryCodes');
	      }, function (failure) {
	        _this.isSubmitting = false;
	        _this.submitError = _this.translateSalaryCodeError(failure);
	      });
	    },
	    translateSalaryCodeError: function translateSalaryCodeError(failure) {
	      var raw = failure && failure.error ? String(failure.error) : typeof failure === 'string' ? failure : '';
	      var known = [{ match: 'must be three digits', text: 'Lønart skal være præcis 3 cifre.' }, { match: 'must be six digits', text: 'Tillægsnummer skal være 6 cifre eller tomt.' }, { match: 'must be one digit', text: 'Tillægsnummer skal være 1 ciffer eller tomt.' }];
	      var messages = known.filter(function (k) {
	        return raw.indexOf(k.match) > -1;
	      }).map(function (k) {
	        return k.text;
	      });
	      if (messages.length > 0) {
	        return messages.join(' ');
	      }
	      console.error('Kunne ikke oprette lønkode', failure);
	      return 'Lønkoden kunne ikke oprettes. Prøv igen, eller kontakt support hvis fejlen fortsætter.';
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('readSalaryCodes');
	  }
	};

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SalaryRuleCostCentersCreateModal',
	  components: { DModal: _DModal2.default },
	  props: {
	    theType: {
	      type: String,
	      default: 'lønkoder' },
	    placeholder1: {
	      type: String,
	      default: ''
	    },
	    placeholder2: {
	      type: String,
	      default: ''
	    },
	    theEditItem: {
	      type: Object,
	      default: null },
	    isSubmitting: {
	      type: Boolean,
	      default: false
	    },
	    isDeleting: {
	      type: Boolean,
	      default: false
	    },
	
	    salarySystem: {
	      type: String,
	      default: null
	    },
	
	    submitError: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      name: '',
	      code: '',
	      tillaegsnummer: '',
	      touched: { code: false, tillaegsnummer: false },
	      isSubmitAttempted: false
	    };
	  },
	
	  computed: {
	    isEditing: function isEditing() {
	      return !!this.theEditItem;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    isSalaryCode: function isSalaryCode() {
	      return this.theType === 'lønkoder';
	    },
	    trimmedCode: function trimmedCode() {
	      return String(this.code).trim();
	    },
	    trimmedTillaegsnummer: function trimmedTillaegsnummer() {
	      return String(this.tillaegsnummer).trim();
	    },
	    codeError: function codeError() {
	      if (!this.isSalaryCode) {
	        return '';
	      }
	      return (/^\d{3}$/.test(this.trimmedCode) ? '' : 'Lønart skal være præcis 3 cifre'
	      );
	    },
	    tillaegsnummerError: function tillaegsnummerError() {
	      if (!this.isSalaryCode || this.trimmedTillaegsnummer === '') {
	        return '';
	      }
	      if (this.salarySystem === 'SD' && !/^\d{6}$/.test(this.trimmedTillaegsnummer)) {
	        return 'Tillægsnummer skal være 6 cifre eller tomt';
	      }
	      if (this.salarySystem === 'KMD' && !/^\d$/.test(this.trimmedTillaegsnummer)) {
	        return 'Tillægsnummer skal være 1 ciffer eller tomt';
	      }
	      return '';
	    },
	    tillaegsnummerHelp: function tillaegsnummerHelp() {
	      if (this.salarySystem === 'SD') {
	        return 'Kun til faste månedlige tillæg. 6 cifre, fx 111122. Lad feltet stå tomt for timebaserede lønarter.';
	      }
	      if (this.salarySystem === 'KMD') {
	        return 'Kun til faste månedlige tillæg. 1 ciffer (løbenummer), fx 1. Lad feltet stå tomt for timebaserede lønarter.';
	      }
	      return '';
	    },
	    showCodeError: function showCodeError() {
	      return !!this.codeError && (this.touched.code || this.isSubmitAttempted);
	    },
	    showTillaegsnummerError: function showTillaegsnummerError() {
	      return !!this.tillaegsnummerError && (this.touched.tillaegsnummer || this.isSubmitAttempted);
	    },
	    isValid: function isValid() {
	      var hasNameAndCode = this.name.trim().length > 0 && this.trimmedCode.length > 0;
	      if (this.isSalaryCode) {
	        return hasNameAndCode && !this.codeError && !this.tillaegsnummerError;
	      }
	      return hasNameAndCode;
	    }
	  },
	  methods: {
	    onSubmit: function onSubmit() {
	      this.isSubmitAttempted = true;
	      if (!this.isValid || this.isSubmitting) {
	        return;
	      }
	      var obj = {
	        name: this.isSalaryCode ? this.name.trim() : this.name,
	        code: this.isSalaryCode ? this.trimmedCode : this.code
	      };
	      if (this.isSalaryCode && this.trimmedTillaegsnummer.length > 0) {
	        obj.tillaegsnummer = this.trimmedTillaegsnummer;
	      }
	      this.$emit('onSubmit', obj);
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.theEditItem) {
	      var t = this.theEditItem;
	      this.name = t.name ? String(t.name) : '';
	      this.code = t.code !== undefined && t.code !== null ? String(t.code) : '';
	      this.tillaegsnummer = t.tillaegsnummer !== undefined && t.tillaegsnummer !== null ? String(t.tillaegsnummer) : '';
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function (_) {
	      var el = _this.$refs.input_title;
	      if (el) el.focus();
	    });
	  }
	};

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _LoenbroekModal = __webpack_require__(1587);
	
	var _LoenbroekModal2 = _interopRequireDefault(_LoenbroekModal);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Loenbroek',
	  components: { LoenbroekModal: _LoenbroekModal2.default, Loader: _Loader2.default, Tabs: _Tabs2.default, DoFiltersFilter: _DoFiltersFilter2.default },
	  data: function data() {
	    return {
	      isNoSDConfiguration: false,
	      isShowLoenbroekModal: false,
	      loenbroeker: [],
	      isLoading: false,
	      activeFilter: 'draft',
	      sortBy: 'vCreatedAt',
	      sortDir: 'desc',
	      theEditItem: null,
	      isSortPristine: true,
	      selectedNames: []
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    usersById: function usersById() {
	      var map = {};
	      var list = this.$store.getters.usersSortedOnName || [];
	      for (var i = 0; i < list.length; i++) {
	        var u = list[i];
	        map[u.id] = u.name;
	      }
	      return map;
	    },
	    activeStatesForFilter: function activeStatesForFilter() {
	      if (this.activeFilter === 'sent') return ['sent', 'sending'];
	      return [this.activeFilter];
	    },
	    uniqueNames: function uniqueNames() {
	      var set = {};
	      var states = this.activeStatesForFilter;
	      for (var i = 0; i < this.loenbroekerSorted.length; i++) {
	        var s = this.loenbroekerSorted[i];
	        if (states.indexOf(s.state) < 0) continue;
	        var name = s.vUserName || '';
	        if (name) set[name] = true;
	      }
	      var arr = (0, _keys2.default)(set);
	      return arr.sort(function (a, b) {
	        return a.localeCompare(b, 'da', { sensitivity: 'base' });
	      });
	    },
	    loenbroekerSorted: function loenbroekerSorted() {
	      var _this = this;
	
	      return this.loenbroeker.map(function (l) {
	        var vUserName = _this.getUserName(l.user_id);
	        var vCreatedAt = l.created_at ? (0, _moment2.default)(l.created_at).format('lll') : '';
	        var vApprovedAt = l.approved_at ? (0, _moment2.default)(l.approved_at).format('lll') : '';
	        var vApprovedBy = _this.getUserName(l.approved_by);
	        var vDate = l.dato ? (0, _moment2.default)(l.dato).format('DD-MM-YYYY') : '';
	        return (0, _assign2.default)({}, l, {
	          vUserName: vUserName, vCreatedAt: vCreatedAt, vApprovedAt: vApprovedAt, vApprovedBy: vApprovedBy, vDate: vDate
	        });
	      });
	    },
	    displayedLoenbroeker: function displayedLoenbroeker() {
	      var _this2 = this;
	
	      var states = this.activeStatesForFilter;
	      var rows = this.loenbroekerSorted.filter(function (x) {
	        return states.indexOf(x.state) >= 0;
	      });
	
	      if (this.selectedNames && this.selectedNames.length > 0) {
	        var chosen = {};
	        for (var i = 0; i < this.selectedNames.length; i++) {
	          chosen[this.selectedNames[i]] = true;
	        }rows = rows.filter(function (x) {
	          return chosen[x.vUserName || ''];
	        });
	      }
	
	      var get = function get(item, key) {
	        switch (key) {
	          case 'name':
	            return item.vUserName || '';
	          case 'date':
	            return _this2._dateForSort(item.dato);
	          case 'tjenestenummer':
	            return item.tjenestenummer || 0;
	          case 'aarstimetal':
	            return item.aarstimetal || 0;
	          case 'loendecimal':
	            return item.loendecimal || 0;
	          case 'beskaeftigelsesdecimal':
	            return item.beskaeftigelsesdecimal || 0;
	          case 'vCreatedAt':
	            return _this2._momentOrNull(item.created_at).valueOf() || 0;
	          case 'vApprovedAt':
	            return _this2._momentOrNull(item.approved_at).valueOf() || 0;
	          case 'vApprovedBy':
	            return String(item.vApprovedBy || '');
	          default:
	            return item[key] || '';
	        }
	      };
	
	      var dir = this.sortDir === 'asc' ? 1 : -1;
	      var key = this.sortBy;
	
	      return rows.slice().sort(function (a, b) {
	        var va = get(a, key);
	        var vb = get(b, key);
	        if (va === vb) return 0;
	        if (typeof va === 'number' && typeof vb === 'number') return (va - vb) * dir;
	        if (va instanceof Date && vb instanceof Date) return (va - vb) * dir;
	        if (typeof va === 'number' && typeof vb !== 'number') return -1 * dir;
	        if (typeof vb === 'number' && typeof va !== 'number') return 1 * dir;
	        return String(va).localeCompare(String(vb), 'da', { sensitivity: 'base' }) * dir;
	      });
	    },
	    statesPresent: function statesPresent() {
	      var set = {};
	      for (var i = 0; i < this.loenbroekerSorted.length; i++) {
	        var s = this.loenbroekerSorted[i];
	        var st = s && s.state ? String(s.state) : 'unknown';
	        set[st] = true;
	      }
	      return (0, _keys2.default)(set);
	    },
	    countsByState: function countsByState() {
	      var counts = {};
	      for (var i = 0; i < this.loenbroekerSorted.length; i++) {
	        var st = this.loenbroekerSorted[i] && this.loenbroekerSorted[i].state ? String(this.loenbroekerSorted[i].state) : 'unknown';
	        counts[st] = (counts[st] || 0) + 1;
	      }
	      return counts;
	    },
	    tabsList: function tabsList() {
	      var labels = {
	        draft: 'Udbakke',
	        sent: 'Sendt til lønsystem',
	        error: 'Fejl',
	        unknown: 'Ukendt'
	      };
	
	      var counts = (0, _assign2.default)({}, this.countsByState);
	      if (counts.sending && counts.sending > 0) {
	        counts.sent = (counts.sent || 0) + counts.sending;
	        delete counts.sending;
	      }
	
	      var all = this.statesPresent;
	      var extras = [];
	      for (var i = 0; i < all.length; i++) {
	        var st = all[i];
	        if (st !== 'draft' && st !== 'sent' && st !== 'sending') extras.push(st);
	      }
	
	      var pref = ['error', 'unknown'];
	      var extrasKnown = [];
	      for (var _i = 0; _i < pref.length; _i++) {
	        var _st = pref[_i];
	        if (extras.indexOf(_st) >= 0) extrasKnown.push(_st);
	      }
	      var extrasOther = [];
	      for (var j = 0; j < extras.length; j++) {
	        var _st2 = extras[j];
	        if (pref.indexOf(_st2) < 0) extrasOther.push(_st2);
	      }
	      extrasOther.sort(function (a, b) {
	        return a.localeCompare(b, 'da', { sensitivity: 'base' });
	      });
	
	      var out = [];
	
	      out.push({
	        id: 'draft',
	        title: (labels['draft'] || this._capitalize('draft')) + ' (' + String(counts['draft'] || 0) + ')'
	      });
	
	      var orderedExtras = extrasKnown.concat(extrasOther);
	      for (var k = 0; k < orderedExtras.length; k++) {
	        var _st3 = orderedExtras[k];
	        var title = (labels[_st3] || this._capitalize(_st3)) + ' (' + String(counts[_st3] || 0) + ')';
	        out.push({ id: _st3, title: title });
	      }
	
	      out.push({
	        id: 'sent',
	        title: (labels['sent'] || this._capitalize('sent')) + ' (' + String(counts['sent'] || 0) + ')'
	      });
	
	      return out;
	    }
	  },
	  methods: {
	    createLoenbroek: function createLoenbroek() {
	      this.theEditItem = null;
	      this.isShowLoenbroekModal = true;
	    },
	    readLoenbroeker: function readLoenbroeker() {
	      var _this3 = this;
	
	      this.isLoading = true;
	      var success = function success(res) {
	        if (res.status && res.status === 'error') {
	          _this3.isNoSDConfiguration = true;
	        }
	        if (Array.isArray(res)) {
	          _this3.loenbroeker = res;
	        } else if (res && Array.isArray(res.data)) {
	          _this3.loenbroeker = res.data;
	        } else {
	          _this3.loenbroeker = [];
	        }
	        _this3.isLoading = false;
	      };
	      var failure = function failure() {
	        _this3.isLoading = false;
	        _this3.loenbroeker = [];
	      };
	      _docendo2.default.listSilkeborgDataLoenaendringer(this.schoolId, success, failure);
	    },
	    onCreated: function onCreated(data) {
	      if (!data || !data.id) return;
	      var idx = this.loenbroeker.findIndex(function (loenbroek) {
	        return loenbroek.id === data.id;
	      });
	      if (idx < 0) {
	        this.loenbroeker.push(data);
	      } else {
	        this.$set(this.loenbroeker, idx, (0, _assign2.default)({}, this.loenbroeker[idx], data));
	      }
	      this.isShowLoenbroekModal = false;
	      this.theEditItem = null;
	    },
	    onDeleted: function onDeleted(data) {
	      if (!data || !data.id) return;
	      var idx = this.loenbroeker.findIndex(function (loenbroek) {
	        return loenbroek.id === data.id;
	      });
	      if (idx >= 0) {
	        this.loenbroeker.splice(idx, 1);
	      }
	      this.isShowLoenbroekModal = false;
	      this.theEditItem = null;
	    },
	    setFilter: function setFilter(id) {
	      this.activeFilter = id;
	      this.readLoenbroeker();
	    },
	    toggleName: function toggleName(name) {
	      var idx = this.selectedNames.indexOf(name);
	      if (idx >= 0) {
	        this.selectedNames.splice(idx, 1);
	      } else {
	        this.selectedNames.push(name);
	      }
	    },
	    clearNames: function clearNames() {
	      this.selectedNames = [];
	    },
	    setEditItem: function setEditItem(item) {
	      if (this.activeFilter !== 'draft') {
	        return;
	      }
	      this.theEditItem = item;
	      if (item) {
	        this.isShowLoenbroekModal = true;
	      }
	    },
	    setSort: function setSort(key) {
	      this.isSortPristine = false;
	      if (this.sortBy === key) {
	        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
	      } else {
	        this.sortBy = key;
	        this.sortDir = 'asc';
	      }
	    },
	    _momentOrNull: function _momentOrNull(iso) {
	      return iso ? (0, _moment2.default)(iso) : null;
	    },
	    _dateForSort: function _dateForSort(dato) {
	      if (!dato) return new Date(0);
	      var m = (0, _moment2.default)(dato, 'YYYY-MM-DD');
	      return m.isValid() ? m.toDate() : new Date(0);
	    },
	    _capitalize: function _capitalize(str) {
	      return str.charAt(0).toUpperCase() + str.slice(1);
	    },
	    getUserName: function getUserName(userId) {
	      if (!userId) {
	        return '';
	      }
	      var user = this.usersById[userId];
	      if (user) {
	        return user;
	      }
	      return userId;
	    },
	    formatDecimal: function formatDecimal(value) {
	      if (value == null || value === '') return '';
	      return String(value).replace('.', ',');
	    }
	  },
	  mounted: function mounted() {
	    this.readLoenbroeker();
	  }
	};

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'LoenbroekModal',
	  components: { DModal: _DModal2.default, DSelect: _DSelect2.default, DateSelector: _DateSelector2.default, Tabs: _Tabs2.default, ModalConfirmation: _ModalConfirmation2.default },
	  props: {
	    theEditItem: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      userId: '',
	      employmentId: null,
	      startDate: (0, _moment2.default)(),
	      aarstimetal: 1924,
	      tabs: [{
	        title: 'Årsnorm',
	        id: 'timer'
	      }, {
	        title: 'Lønbrøk',
	        id: 'loenbroek'
	      }],
	      activeTab: 'timer',
	      loendecimal: 1,
	      beskaefftigelsesdecimal: 1,
	      isSubmitting: false,
	      isDeleting: false,
	      isDeleteModal: false,
	      hoursError: false,
	      loendecimalError: false,
	      beskaefftigelsesdecimalError: false
	    };
	  },
	
	  computed: {
	    itemsSelectedForDSelect: function itemsSelectedForDSelect() {
	      return this.selectedUser ? [this.selectedUser] : [];
	    },
	    usersSortedOnName: function usersSortedOnName() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    filteredUsers: function filteredUsers() {
	      var _this = this;
	
	      return this.usersSortedOnName.filter(function (user) {
	        return _this.employmentsInUserIdHash[user.id];
	      });
	    },
	    selectedUser: function selectedUser() {
	      var _this2 = this;
	
	      return this.usersSortedOnName.find(function (u) {
	        return u.id === _this2.userId;
	      });
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash;
	    },
	    employmentsRaw: function employmentsRaw() {
	      var has = this.userId && this.employmentsInUserIdHash[this.userId];
	      return has ? this.employmentsInUserIdHash[this.userId] : [];
	    },
	    employments: function employments() {
	      var src = this.employmentsRaw;
	      var out = [];
	      for (var i = 0; i < src.length; i++) {
	        var e = src[i];
	        var num = e && e.employment_number ? String(e.employment_number) : '';
	        if (num.trim() !== '') out.push(e);
	      }
	      return out;
	    },
	    hasEmploymentsWithNumber: function hasEmploymentsWithNumber() {
	      return this.userId && this.employments.length > 0;
	    },
	    selectedEmployment: function selectedEmployment() {
	      var list = this.employments;
	      for (var i = 0; i < list.length; i++) {
	        if (list[i].id === this.employmentId) return list[i];
	      }
	      return null;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    isValid: function isValid() {
	      var emp = this.selectedEmployment;
	      var hasEmploymentNumbers = emp && emp.employment_number;
	      var hasUser = !!this.userId;
	      var hasEmployment = !!this.employmentId;
	
	      var hasValidHours = true;
	      if (this.activeTab === 'timer') {
	        var hoursValue = parseFloat(String(this.aarstimetal).replace(',', '.'));
	        hasValidHours = !isNaN(hoursValue) && hoursValue > 0 && hoursValue <= 1924;
	      }
	      var hasValidLoendecimal = true;
	      var hasValidBeskaefftigelsesdecimal = true;
	      if (this.activeTab === 'loenbroek') {
	        var loendecimalValue = parseFloat(String(this.loendecimal).replace(',', '.'));
	        var beskaefftigelsesdecimalValue = parseFloat(String(this.beskaefftigelsesdecimal).replace(',', '.'));
	        hasValidLoendecimal = !isNaN(loendecimalValue) && loendecimalValue > 0 && loendecimalValue <= 1;
	        hasValidBeskaefftigelsesdecimal = !isNaN(beskaefftigelsesdecimalValue) && beskaefftigelsesdecimalValue > 0 && beskaefftigelsesdecimalValue <= 1;
	      }
	      return hasUser && hasEmployment && hasEmploymentNumbers && hasValidHours && hasValidLoendecimal && hasValidBeskaefftigelsesdecimal;
	    }
	  },
	  watch: {
	    theEditItem: {
	      handler: function handler() {
	        this.applyEditItem();
	      },
	
	      immediate: true
	    },
	
	    employmentsInUserIdHash: {
	      handler: function handler() {
	        if (this.theEditItem && !this.employmentId) {
	          this.applyEditItem();
	        }
	      },
	
	      deep: true
	    }
	  },
	  methods: {
	    changeTab: function changeTab(tab) {
	      this.activeTab = tab;
	    },
	    onSelectUser: function onSelectUser(item) {
	      var _this3 = this;
	
	      if (!item) {
	        this.userId = '';
	      } else {
	        this.userId = item.id;
	      }
	      this.onUserChange();
	
	      if (item && item.id) {
	        this.$nextTick(function () {
	          if (_this3.employments && _this3.employments.length === 1) {
	            _this3.employmentId = _this3.employments[0].id;
	          }
	        });
	      }
	    },
	    onUserChange: function onUserChange() {
	      this.employmentId = null;
	    },
	    focusUserSelect: function focusUserSelect() {
	      var el = this.$refs && this.$refs.userSelect ? this.$refs.userSelect : null;
	      if (!el) return;
	      el.focus();
	    },
	    setDate: function setDate(date) {
	      this.startDate = date;
	    },
	    onHoursInput: function onHoursInput(event) {
	      var value = event.target.value;
	      var numValue = parseFloat(value.replace(',', '.'));
	      if (!isNaN(numValue) && numValue > 1924) {
	        this.hoursError = true;
	        this.aarstimetal = 1924;
	      } else {
	        this.hoursError = false;
	        this.aarstimetal = numValue;
	      }
	    },
	    onLoendecimalInput: function onLoendecimalInput(event) {
	      var value = event.target.value;
	      var numValue = parseFloat(value.replace(',', '.'));
	      if (!isNaN(numValue) && numValue > 1) {
	        this.loendecimalError = true;
	        this.loendecimal = 1;
	      } else {
	        this.loendecimalError = false;
	        this.loendecimal = value;
	      }
	    },
	    onBeskaaefftigelsesdecimalInput: function onBeskaaefftigelsesdecimalInput(event) {
	      var value = event.target.value;
	      var numValue = parseFloat(value.replace(',', '.'));
	      if (!isNaN(numValue) && numValue > 1) {
	        this.beskaefftigelsesdecimalError = true;
	        this.beskaefftigelsesdecimal = 1;
	      } else {
	        this.beskaefftigelsesdecimalError = false;
	        this.beskaefftigelsesdecimal = value;
	      }
	    },
	    applyEditItem: function applyEditItem() {
	      var it = this.theEditItem;
	      if (!it) {
	        this.userId = '';
	        this.employmentId = null;
	        this.startDate = (0, _moment2.default)();
	        this.aarstimetal = 1924;
	        this.loendecimal = 1;
	        this.beskaefftigelsesdecimal = 1;
	        this.activeTab = 'timer';
	        return;
	      }
	
	      this.userId = it.user_id || '';
	      this.startDate = it.dato ? (0, _moment2.default)(it.dato) : (0, _moment2.default)();
	
	      if (it.aarstimetal != null) {
	        this.activeTab = 'timer';
	        this.aarstimetal = it.aarstimetal;
	      } else if (it.loendecimal != null || it.beskaeftigelsesdecimal != null) {
	        this.activeTab = 'loenbroek';
	        this.loendecimal = it.loendecimal != null ? it.loendecimal : 1;
	        this.beskaefftigelsesdecimal = it.beskaeftigelsesdecimal != null ? it.beskaeftigelsesdecimal : 1;
	      }
	
	      var employmentId = null;
	      if (it.tjenestenummer) {
	        var list = this.employmentsInUserIdHash && this.employmentsInUserIdHash[it.user_id] ? this.employmentsInUserIdHash[it.user_id] : [];
	        var match = list.find(function (e) {
	          return String(e.employment_number) === String(it.tjenestenummer);
	        });
	        if (match) employmentId = match.id;
	      }
	      this.employmentId = employmentId;
	    },
	    deleteEditItem: function deleteEditItem() {
	      var _this4 = this;
	
	      if (!this.theEditItem || !this.theEditItem.id) {
	        _eventbus2.default.toast = { text: 'Mangler id på lønbrøk', success: false, position: 'bottomLeft' };
	        return;
	      }
	      if (!this.schoolId) {
	        _eventbus2.default.toast = { text: 'Mangler schoolId', success: false, position: 'bottomLeft' };
	        return;
	      }
	
	      this.isDeleting = true;
	      var success = function success(_res) {
	        _this4.isDeleting = false;
	        _this4.isDeleteModal = false;
	        _eventbus2.default.toast = { text: 'Lønbrøk slettet', success: true, position: 'bottomLeft' };
	        _this4.$emit('deleted', { id: _this4.theEditItem.id });
	        _this4.$emit('close');
	      };
	
	      var failure = function failure(err) {
	        _this4.isDeleting = false;
	        var msg = err && err.error ? err.error : 'Kunne ikke slette lønbrøken';
	        _eventbus2.default.toast = { text: msg, success: false, position: 'bottomLeft' };
	      };
	
	      _docendo2.default.deleteSilkeborgDataLoenaendring(this.schoolId, this.theEditItem.id, success, failure);
	    },
	    onSubmit: function onSubmit() {
	      var _this5 = this;
	
	      if (!this.isValid) {
	        return;
	      }
	      if (!this.schoolId) {
	        _eventbus2.default.toast = { text: 'Mangler schoolId', success: false };
	        return;
	      }
	      this.isSubmitting = true;
	      var emp = this.selectedEmployment;
	      var dato = (0, _moment2.default)(this.startDate);
	
	      var loenaendring = {
	        user_id: this.userId,
	        employment_id: emp ? emp.id : null,
	        tjenestenummer: emp && emp.employment_number ? String(emp.employment_number) : '',
	        dato: dato.format('YYYY-MM-DD')
	      };
	
	      if (this.activeTab === 'timer') {
	        var aarstimetalValue = parseFloat(String(this.aarstimetal).replace(',', '.'));
	        loenaendring.aarstimetal = aarstimetalValue;
	
	        loenaendring.deltidskode = aarstimetalValue < 1924 ? 1 : 0;
	      }
	
	      if (this.activeTab === 'loenbroek') {
	        var loendecimalValue = parseFloat(String(this.loendecimal).replace(',', '.'));
	        var beskaefftigelsesdecimalValue = parseFloat(String(this.beskaefftigelsesdecimal).replace(',', '.'));
	        loenaendring.loendecimal = loendecimalValue;
	        loenaendring.beskaeftigelsesdecimal = beskaefftigelsesdecimalValue;
	
	        loenaendring.deltidskode = loendecimalValue < 1 ? 1 : 0;
	      }
	
	      var success = function success(res) {
	        _this5.isSubmitting = false;
	        var msg = _this5.theEditItem ? 'Lønbrøk opdateret' : 'Lønbrøk oprettet';
	        _eventbus2.default.toast = { text: msg, success: true, position: 'bottomLeft' };
	        _this5.$emit('created', res);
	        _this5.$emit('close');
	      };
	      var failure = function failure(err) {
	        _this5.isSubmitting = false;
	        var msg = err && err.error ? err.error : _this5.theEditItem ? 'Kunne ikke opdatere lønbrøken' : 'Kunne ikke oprette lønbrøken';
	        _eventbus2.default.toast = { text: msg, success: false, position: 'bottomLeft' };
	      };
	
	      if (this.theEditItem && this.theEditItem.id) {
	        if (_docendo2.default.updateSilkeborgDataLoenaendring) {
	          _docendo2.default.updateSilkeborgDataLoenaendring(this.schoolId, this.theEditItem.id, loenaendring, success, failure);
	        } else {
	          _docendo2.default.createSilkeborgDataLoenaendring(this.schoolId, loenaendring, success, failure);
	        }
	      } else {
	        _docendo2.default.createSilkeborgDataLoenaendring(this.schoolId, loenaendring, success, failure);
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this6 = this;
	
	    this.$store.dispatch('readEmployments');
	    if (this.theEditItem) {
	      this.applyEditItem();
	    } else {
	      this.$nextTick(function () {
	        setTimeout(function () {
	          if (_this6.$refs.userSelect) {
	            _this6.$refs.userSelect.open();
	          }
	        }, 500);
	      });
	    }
	  }
	};

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DoDatePickerRange = __webpack_require__(44);
	
	var _DoDatePickerRange2 = _interopRequireDefault(_DoDatePickerRange);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SdAutoFravaer',
	  components: { DModal: _DModal2.default, DoDatePickerRange: _DoDatePickerRange2.default },
	  props: {
	    schoolId: {
	      type: Number,
	      required: true
	    },
	    absenceCodes: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    startDate: {
	      required: true
	    },
	    endDate: {
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      isSubmitting: false,
	      errorMessage: '',
	      createdFravaer: null
	    };
	  },
	
	  computed: {
	    isValid: function isValid() {
	      return !!this.startDate && !!this.endDate && (0, _moment2.default)(this.startDate).isValid() && (0, _moment2.default)(this.endDate).isValid() && !(0, _moment2.default)(this.endDate).isBefore((0, _moment2.default)(this.startDate), 'day');
	    },
	    usersById: function usersById() {
	      var map = {};
	      var list = this.$store.getters.usersSortedOnName || [];
	      for (var i = 0; i < list.length; i++) {
	        map[list[i].id] = list[i].name;
	      }return map;
	    },
	    absenceCodesByLoenart: function absenceCodesByLoenart() {
	      var map = {};
	      for (var i = 0; i < this.absenceCodes.length; i++) {
	        var code = this.absenceCodes[i];
	        if (code.loenart != null) map[String(parseInt(code.loenart, 10))] = code;
	      }
	      return map;
	    },
	    createdRows: function createdRows() {
	      var _this = this;
	
	      var list = this.createdFravaer || [];
	      return list.map(function (item) {
	        var code = item.loenart != null ? _this.absenceCodesByLoenart[String(parseInt(item.loenart, 10))] : null;
	        return (0, _assign2.default)({}, item, {
	          vUserName: item.user_id && _this.usersById[item.user_id] || String(item.tjenestenummer || ''),
	          vAbsenceType: code ? code.loenart + ' - ' + code.title : item.loenart != null ? String(item.loenart) : '',
	          vStartdato: item.startdato ? (0, _moment2.default)(item.startdato).format('DD-MM-YYYY') : '',
	          vSlutdato: _this.formatSlutdato(item.slutdato)
	        });
	      });
	    }
	  },
	  methods: {
	    formatSlutdato: function formatSlutdato(slutdato) {
	      if (!slutdato) return '';
	      var date = (0, _moment2.default)(slutdato);
	      if (date.year() >= 9999) return 'Åbenstående';
	      return date.format('DD-MM-YYYY');
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      if (!this.isValid || this.isSubmitting) return;
	      this.errorMessage = '';
	      this.isSubmitting = true;
	      _docendo2.default.generateSilkeborgDataFravaer(this.schoolId, (0, _moment2.default)(this.startDate).format('YYYY-MM-DD'), (0, _moment2.default)(this.endDate).format('YYYY-MM-DD'), function (success) {
	        _this2.isSubmitting = false;
	        if (success && success.status === 'error') {
	          _this2.errorMessage = 'Kunne ikke oprette fraværsindberetningerne';
	          return;
	        }
	        _this2.createdFravaer = Array.isArray(success) ? success : success && Array.isArray(success.data) ? success.data : [];
	      }, function (failure) {
	        console.log('generate fravaer failure', failure);
	        _this2.isSubmitting = false;
	        _this2.errorMessage = 'Kunne ikke oprette fraværsindberetningerne';
	      });
	    },
	    finish: function finish() {
	      this.$emit('created', this.createdFravaer || []);
	      this.$emit('close');
	    }
	  },
	  mounted: function mounted() {
	    this.didAddNoScroll = !document.body.classList.contains('no-scroll');
	    if (this.didAddNoScroll) {
	      document.body.classList.add('no-scroll');
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.didAddNoScroll) {
	      document.body.classList.remove('no-scroll');
	    }
	  }
	};

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelect2.default, DModal: _DModal2.default, DateSelector: _DateSelector2.default },
	  props: {
	    schoolId: {
	      type: Number,
	      required: true
	    },
	    employmentIds: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    subtitle: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      dato: (0, _moment2.default)(),
	      salaryCodeId: null,
	      salaryCostCenterId: null,
	      antal: '',
	      sats: '',
	      description: '',
	      isSubmitting: false,
	      validationMessage: ''
	    };
	  },
	
	  computed: {
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    },
	    saveKeyTooltip: function saveKeyTooltip() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span>' + '<span>Enter</span></p>';
	    },
	    subtitleText: function subtitleText() {
	      if (this.subtitle) return this.subtitle;
	      return 'På ' + this.employmentIds.length + ' ' + (this.employmentIds.length === 1 ? 'ansættelse' : 'ansættelser');
	    },
	    submitButtonLabel: function submitButtonLabel() {
	      if (this.employmentIds.length <= 1) {
	        return 'Opret engangsydelse';
	      }
	      return 'Opret ' + this.employmentIds.length + ' engangsydelser';
	    },
	    antalHasValue: function antalHasValue() {
	      return this.antal !== '' && this.antal != null;
	    },
	    satsHasValue: function satsHasValue() {
	      return this.sats !== '' && this.sats != null;
	    },
	    isValid: function isValid() {
	      var hasEmployments = this.employmentIds.length > 0;
	      var hasDato = !!this.dato && (0, _moment2.default)(this.dato).isValid();
	      var hasLoenart = this.salaryCodeId != null;
	
	      var exactlyOneAmount = (this.antalHasValue || this.satsHasValue) && !(this.antalHasValue && this.satsHasValue);
	      return hasEmployments && hasDato && hasLoenart && exactlyOneAmount && this.antalValid && this.satsValid;
	    },
	    antalValid: function antalValid() {
	      if (!this.antalHasValue) return true;
	      var antal = parseFloat(String(this.antal).replace(',', '.'));
	      return !isNaN(antal) && antal >= -999.99 && antal <= 999.99;
	    },
	    satsValid: function satsValid() {
	      if (!this.satsHasValue) return true;
	      var sats = parseFloat(String(this.sats).replace(',', '.'));
	      return !isNaN(sats) && Math.abs(sats) <= 99999.99;
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted || [];
	    },
	    salaryCodesForDSelect: function salaryCodesForDSelect() {
	      if (!this.salaryCodes || !Array.isArray(this.salaryCodes)) {
	        return [];
	      }
	      return this.salaryCodes.filter(function (sc) {
	        return sc.loenart;
	      }).map(function (sc) {
	        return {
	          id: sc.id,
	          name: sc.vSupplementTitle,
	          value: sc.loenart,
	          original: sc
	        };
	      });
	    },
	    selectedSalaryCodeForDSelect: function selectedSalaryCodeForDSelect() {
	      var _this = this;
	
	      if (this.salaryCodeId == null) {
	        return [];
	      }
	      var found = this.salaryCodesForDSelect.find(function (item) {
	        return item.id === _this.salaryCodeId;
	      });
	      return found ? [found] : [];
	    },
	    costCenters: function costCenters() {
	      return this.$store.getters.costCenters || [];
	    },
	    costCentersForDSelect: function costCentersForDSelect() {
	      return this.costCenters.map(function (cc) {
	        var code = cc.code != null ? String(cc.code) : '';
	        var title = cc.title || cc.name || '';
	        return {
	          id: cc.id,
	          name: code + (title ? ' - ' + title : ''),
	          value: code,
	          original: cc
	        };
	      });
	    },
	    selectedCostCenterForDSelect: function selectedCostCenterForDSelect() {
	      var _this2 = this;
	
	      if (this.salaryCostCenterId == null) {
	        return [];
	      }
	      var found = this.costCentersForDSelect.find(function (item) {
	        return item.id === _this2.salaryCostCenterId;
	      });
	      return found ? [found] : [];
	    },
	    employmentsById: function employmentsById() {
	      var map = {};
	      var list = this.$store.state.employments && this.$store.state.employments.employments || [];
	      for (var i = 0; i < list.length; i++) {
	        map[list[i].id] = list[i];
	      }
	      return map;
	    },
	    employmentsGroupedByUser: function employmentsGroupedByUser() {
	      var groups = {};
	      var byId = this.employmentsById;
	      for (var i = 0; i < this.employmentIds.length; i++) {
	        var id = this.employmentIds[i];
	        var emp = byId[id];
	        var userId = emp ? emp.user_id : null;
	        var key = userId != null ? String(userId) : 'unknown';
	        if (!groups[key]) groups[key] = { userId: userId, employmentIds: [] };
	        groups[key].employmentIds.push(id);
	      }
	      return (0, _keys2.default)(groups).map(function (k) {
	        return groups[k];
	      });
	    }
	  },
	  methods: {
	    onSelectLoenart: function onSelectLoenart(item) {
	      this.salaryCodeId = item ? item.id : null;
	    },
	    onSelectCostCenter: function onSelectCostCenter(item) {
	      this.salaryCostCenterId = item ? item.id : null;
	    },
	    setDato: function setDato(date) {
	      this.dato = date;
	    },
	    onGlobalKeydown: function onGlobalKeydown(evt) {
	      var isSubmitCombo = (evt.metaKey || evt.ctrlKey) && (evt.key === 'Enter' || evt.keyCode === 13);
	      if (!isSubmitCombo) return;
	      if (this.isSubmitting || !this.isValid) return;
	      evt.preventDefault();
	      this.submit();
	    },
	    submit: function submit() {
	      var _this3 = this;
	
	      this.validationMessage = '';
	      if (!this.isValid) {
	        this.validationMessage = 'Udfyld lønart, aktivitetsdato og enten antal eller beløb';
	        return;
	      }
	      if (!this.schoolId) {
	        this.validationMessage = 'Mangler schoolId';
	        return;
	      }
	
	      var date = (0, _moment2.default)(this.dato);
	      var baseEngangsydelse = {
	        salary_code_id: this.salaryCodeId,
	        aar: parseInt(date.format('YY'), 10),
	        maaned: date.month() + 1,
	        dag: date.date()
	      };
	      if (this.antalHasValue) {
	        baseEngangsydelse.enheder = parseFloat(String(this.antal).replace(',', '.'));
	      }
	      if (this.satsHasValue) {
	        baseEngangsydelse.sats = parseFloat(String(this.sats).replace(',', '.'));
	      }
	      if (this.salaryCostCenterId != null) {
	        baseEngangsydelse.salary_cost_center_id = this.salaryCostCenterId;
	      }
	      if (this.description.trim() !== '') {
	        baseEngangsydelse.description = this.description.trim();
	      }
	
	      var groups = this.employmentsGroupedByUser;
	      this.isSubmitting = true;
	      var pending = groups.length;
	      var createdCount = 0;
	      var hadError = false;
	
	      var finish = function finish() {
	        if (pending > 0) return;
	        _this3.isSubmitting = false;
	        if (hadError) {
	          _this3.validationMessage = 'Kunne ikke oprette alle engangsydelser';
	          _eventbus2.default.toast = { text: 'Kunne ikke oprette alle engangsydelser', success: false, position: 'bottomLeft' };
	          return;
	        }
	        _eventbus2.default.toast = {
	          text: (createdCount === 1 ? 'Engangsydelse' : createdCount + ' engangsydelser') + ' lagt i udbakken. De sendes automatisk til SD.',
	          success: true,
	          position: 'bottomLeft'
	        };
	        _this3.$emit('created');
	        _this3.$emit('close');
	      };
	
	      groups.forEach(function (group) {
	        var engangsydelse = (0, _assign2.default)({}, baseEngangsydelse);
	        if (group.userId != null) engangsydelse.user_id = group.userId;
	        _docendo2.default.bulkCreateSilkeborgDataEngangsydelser(_this3.schoolId, group.employmentIds, engangsydelse, 'ydelse', function (success) {
	          pending--;
	          if (success && success.status === 'error') {
	            hadError = true;
	          } else {
	            createdCount += Array.isArray(success) ? success.length : group.employmentIds.length;
	          }
	          finish();
	        }, function (failure) {
	          console.log('failure', failure);
	          pending--;
	          hadError = true;
	          finish();
	        });
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    if (!this.salaryCodes.length) this.$store.dispatch('readSalaryCodes');
	    if (!this.costCenters.length) this.$store.dispatch('readCostCenters');
	    window.addEventListener('keydown', this.onGlobalKeydown);
	    this.didAddNoScroll = !document.body.classList.contains('no-scroll');
	    if (this.didAddNoScroll) {
	      document.body.classList.add('no-scroll');
	    }
	    this.$nextTick(function () {
	      setTimeout(function () {
	        if (_this4.$refs.loenartSelect) _this4.$refs.loenartSelect.setFocus();
	      }, 300);
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('keydown', this.onGlobalKeydown);
	    if (this.didAddNoScroll) {
	      document.body.classList.remove('no-scroll');
	    }
	  }
	};

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelect2.default, DModal: _DModal2.default, DateSelector: _DateSelector2.default },
	  props: {
	    schoolId: {
	      type: Number,
	      required: true
	    },
	    employmentIds: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    subtitle: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      salaryCodeId: null,
	      antal: '',
	      startDato: null,
	      endDato: null,
	      isSubmitting: false,
	      validationMessage: ''
	    };
	  },
	
	  computed: {
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    },
	    saveKeyTooltip: function saveKeyTooltip() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span>' + '<span>Enter</span></p>';
	    },
	    subtitleText: function subtitleText() {
	      if (this.subtitle) return this.subtitle;
	      return 'På ' + this.employmentIds.length + ' ' + (this.employmentIds.length === 1 ? 'ansættelse' : 'ansættelser');
	    },
	    submitButtonLabel: function submitButtonLabel() {
	      if (this.employmentIds.length <= 1) return 'Opret fast tillæg';
	      return 'Opret ' + this.employmentIds.length + ' faste tillæg';
	    },
	    isValid: function isValid() {
	      var hasSelections = this.employmentIds.length > 0;
	      var hasStart = !!this.startDato && (0, _moment2.default)(this.startDato).isValid();
	      var hasEnd = !!this.endDato && (0, _moment2.default)(this.endDato).isValid();
	      var hasTillaeg = this.salaryCodeId != null;
	      var antal = parseFloat(String(this.antal).replace(',', '.'));
	      var hasAntal = !isNaN(antal) && antal >= 0.0001 && antal <= 999.9999;
	      var isEndAfterStart = hasEnd && hasStart && (0, _moment2.default)(this.endDato).isSameOrAfter((0, _moment2.default)(this.startDato));
	      return hasSelections && hasStart && hasEnd && hasTillaeg && hasAntal && isEndAfterStart;
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted || [];
	    },
	    salaryCodesForDSelect: function salaryCodesForDSelect() {
	      if (!this.salaryCodes || !Array.isArray(this.salaryCodes)) return [];
	      return this.salaryCodes.filter(function (sc) {
	        return sc.tillaegsnummer;
	      }).map(function (sc) {
	        return {
	          id: sc.id,
	          name: sc.vSupplementTitle,
	          value: sc.tillaegsnummer,
	          original: sc
	        };
	      });
	    },
	    selectedSalaryCodeForDSelect: function selectedSalaryCodeForDSelect() {
	      var _this = this;
	
	      if (this.salaryCodeId == null) return [];
	      var found = this.salaryCodesForDSelect.find(function (item) {
	        return item.id === _this.salaryCodeId;
	      });
	      return found ? [found] : [];
	    },
	    employmentsById: function employmentsById() {
	      var map = {};
	      var list = this.$store.state.employments && this.$store.state.employments.employments || [];
	      for (var i = 0; i < list.length; i++) {
	        map[list[i].id] = list[i];
	      }return map;
	    },
	    employmentsGroupedByUser: function employmentsGroupedByUser() {
	      var groups = {};
	      var byId = this.employmentsById;
	      for (var i = 0; i < this.employmentIds.length; i++) {
	        var id = this.employmentIds[i];
	        var emp = byId[id];
	        var userId = emp ? emp.user_id : null;
	        var key = userId != null ? String(userId) : 'unknown';
	        if (!groups[key]) groups[key] = { userId: userId, employmentIds: [] };
	        groups[key].employmentIds.push(id);
	      }
	      return (0, _keys2.default)(groups).map(function (k) {
	        return groups[k];
	      });
	    },
	    schoolYearStartDate: function schoolYearStartDate() {
	      var year = this.$store.state.localActivatedSchoolYear;
	      var firstOfNextMonth = (0, _moment2.default)().add(1, 'month').startOf('month');
	      if (year && year.employee_time_start) {
	        var start = (0, _moment2.default)(year.employee_time_start);
	
	        return start.isBefore((0, _moment2.default)(), 'day') ? firstOfNextMonth : start;
	      }
	      return firstOfNextMonth;
	    },
	    schoolYearEndDate: function schoolYearEndDate() {
	      var year = this.$store.state.localActivatedSchoolYear;
	      if (year && year.employee_time_end) {
	        return (0, _moment2.default)(year.employee_time_end);
	      }
	      return (0, _moment2.default)().add(1, 'year').endOf('month');
	    }
	  },
	  methods: {
	    onSelectTillaeg: function onSelectTillaeg(item) {
	      this.salaryCodeId = item ? item.id : null;
	    },
	    onGlobalKeydown: function onGlobalKeydown(evt) {
	      var isSubmitCombo = (evt.metaKey || evt.ctrlKey) && (evt.key === 'Enter' || evt.keyCode === 13);
	      if (!isSubmitCombo) return;
	      if (this.isSubmitting || !this.isValid) return;
	      evt.preventDefault();
	      this.submit();
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      this.validationMessage = '';
	      if (!this.isValid) {
	        this.validationMessage = 'Udfyld tillæg, antal, startdato og slutdato';
	        return;
	      }
	      if (!this.schoolId) {
	        this.validationMessage = 'Mangler schoolId';
	        return;
	      }
	
	      var baseTillaeg = {
	        salary_code_id: this.salaryCodeId,
	        startdato: (0, _moment2.default)(this.startDato).format('YYYY-MM-DD'),
	        slutdato: (0, _moment2.default)(this.endDato).format('YYYY-MM-DD'),
	        enheder: parseFloat(String(this.antal).replace(',', '.'))
	      };
	
	      var groups = this.employmentsGroupedByUser;
	      this.isSubmitting = true;
	      var pending = groups.length;
	      var createdCount = 0;
	      var hadError = false;
	
	      var finish = function finish() {
	        if (pending > 0) return;
	        _this2.isSubmitting = false;
	        if (hadError) {
	          _this2.validationMessage = 'Kunne ikke oprette alle faste tillæg';
	          _eventbus2.default.toast = { text: 'Kunne ikke oprette alle faste tillæg', success: false, position: 'bottomLeft' };
	          return;
	        }
	        _eventbus2.default.toast = {
	          text: (createdCount === 1 ? 'Fast tillæg' : createdCount + ' faste tillæg') + ' lagt i udbakken. De sendes automatisk til SD.',
	          success: true,
	          position: 'bottomLeft'
	        };
	        _this2.$emit('created');
	        _this2.$emit('close');
	      };
	
	      groups.forEach(function (group) {
	        var tillaeg = (0, _assign2.default)({}, baseTillaeg);
	        if (group.userId != null) tillaeg.user_id = group.userId;
	        _docendo2.default.bulkCreateSilkeborgDataTillaeg(_this2.schoolId, group.employmentIds, tillaeg, function (success) {
	          pending--;
	          if (success && success.status === 'error') {
	            hadError = true;
	          } else {
	            createdCount += group.employmentIds.length;
	          }
	          finish();
	        }, function (failure) {
	          console.log('failure', failure);
	          pending--;
	          hadError = true;
	          finish();
	        });
	      });
	    }
	  },
	  created: function created() {
	    this.startDato = this.schoolYearStartDate;
	    this.endDato = this.schoolYearEndDate;
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    if (!this.salaryCodes.length) this.$store.dispatch('readSalaryCodes');
	    window.addEventListener('keydown', this.onGlobalKeydown);
	    this.didAddNoScroll = !document.body.classList.contains('no-scroll');
	    if (this.didAddNoScroll) {
	      document.body.classList.add('no-scroll');
	    }
	    this.$nextTick(function () {
	      setTimeout(function () {
	        if (_this3.$refs.tillaegSelect) _this3.$refs.tillaegSelect.setFocus();
	      }, 300);
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('keydown', this.onGlobalKeydown);
	    if (this.didAddNoScroll) {
	      document.body.classList.remove('no-scroll');
	    }
	  }
	};

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFinite = __webpack_require__(85);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _DoDatePickerRange = __webpack_require__(44);
	
	var _DoDatePickerRange2 = _interopRequireDefault(_DoDatePickerRange);
	
	var _SdCreateEngangsydelse = __webpack_require__(1589);
	
	var _SdCreateEngangsydelse2 = _interopRequireDefault(_SdCreateEngangsydelse);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SdEngangsydelser',
	  components: { Loader: _Loader2.default, DoFiltersFilter: _DoFiltersFilter2.default, DoDatePickerRange: _DoDatePickerRange2.default, SdCreateEngangsydelse: _SdCreateEngangsydelse2.default, Tabs: _Tabs2.default },
	  data: function data() {
	    return {
	      isNoConfiguration: false,
	      isLoading: false,
	      engangsydelser: [],
	      sortBy: 'vCreatedAt',
	      sortDir: 'desc',
	      isSortPristine: true,
	      selectedNames: [],
	      selectedLoenart: [],
	
	      startDate: (0, _moment2.default)().subtract(1, 'month').startOf('month').startOf('day'),
	      endDate: (0, _moment2.default)().add(1, 'month').endOf('month').endOf('day'),
	      dateFilterTouched: false,
	      viewTab: 'employments',
	      selectedPersonNames: [],
	      selectedUserTags: [],
	      selectedEmploymentTitles: [],
	      selectedOrganisations: [],
	      selectedEmploymentIds: [],
	      isBatchMode: false,
	      createEmploymentIds: [],
	      createSubtitle: '',
	      deletingIds: []
	    };
	  },
	
	  computed: {
	    viewTabs: function viewTabs() {
	      return [{ id: 'employments', title: 'Oprettelse' }, { id: 'outbox', title: 'Udbakke (' + this.outboxCount + ')' }, { id: 'sent', title: 'Sendt til l\xF8nsystem (' + this.sentCount + ')' }];
	    },
	    outboxCount: function outboxCount() {
	      return this.engangsydelserSorted.filter(function (x) {
	        return x.state !== 'sent';
	      }).length;
	    },
	    sentCount: function sentCount() {
	      return this.engangsydelserSorted.filter(function (x) {
	        return x.state === 'sent';
	      }).length;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    isLoadingEmployments: function isLoadingEmployments() {
	      return this.$store.state.employments && this.$store.state.employments.isLoadingEmploymentsTypesForSchool;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName || [];
	    },
	    usersById: function usersById() {
	      var map = {};
	      var list = this.users;
	      for (var i = 0; i < list.length; i++) {
	        map[list[i].id] = list[i].name;
	      }
	      return map;
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash || {};
	    },
	    allRows: function allRows() {
	      var out = [];
	      for (var i = 0; i < this.users.length; i++) {
	        var user = this.users[i];
	        var emps = this.employmentsInUserIdHash[user.id] || [];
	        for (var j = 0; j < emps.length; j++) {
	          var emp = emps[j];
	          var empNumber = emp && emp.employment_number ? String(emp.employment_number) : '';
	          if (empNumber.trim() === '') continue;
	          if (emp.source === 'opus') continue;
	
	          if (emp.employment_template_id == null) continue;
	          var title = emp.source_title || emp.title || 'Ansættelse';
	          out.push({
	            id: user.id + '_' + emp.id,
	            userId: user.id,
	            userName: user.name,
	            userTags: Array.isArray(user.user_tags) ? user.user_tags : [],
	            employmentId: emp.id,
	            employmentTitle: title,
	            employmentNumber: empNumber,
	            organisation: emp.organisation || '',
	            employment: emp
	          });
	        }
	      }
	      return out.sort(function (a, b) {
	        return a.userName.localeCompare(b.userName, 'da-DK', { sensitivity: 'base' });
	      });
	    },
	    personNames: function personNames() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        if (this.allRows[i].userName) set[this.allRows[i].userName] = true;
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    userTags: function userTags() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        var t = this.allRows[i].userTags || [];
	        for (var j = 0; j < t.length; j++) {
	          if (t[j]) set[t[j]] = true;
	        }
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    employmentTitles: function employmentTitles() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        if (this.allRows[i].employmentTitle) set[this.allRows[i].employmentTitle] = true;
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    organisations: function organisations() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        if (this.allRows[i].organisation) set[this.allRows[i].organisation] = true;
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    filteredRows: function filteredRows() {
	      var _this = this;
	
	      return this.allRows.filter(function (row) {
	        if (_this.selectedPersonNames.length > 0 && _this.selectedPersonNames.indexOf(row.userName) === -1) return false;
	        if (_this.selectedUserTags.length > 0) {
	          var match = row.userTags && _this.selectedUserTags.some(function (t) {
	            return row.userTags.indexOf(t) > -1;
	          });
	          if (!match) return false;
	        }
	        if (_this.selectedEmploymentTitles.length > 0 && _this.selectedEmploymentTitles.indexOf(row.employmentTitle) === -1) return false;
	        if (_this.selectedOrganisations.length > 0 && _this.selectedOrganisations.indexOf(row.organisation) === -1) return false;
	        return true;
	      });
	    },
	    isAllFilteredSelected: function isAllFilteredSelected() {
	      var _this2 = this;
	
	      if (this.filteredRows.length === 0) return false;
	      return this.filteredRows.every(function (row) {
	        return _this2.selectedEmploymentIds.indexOf(row.employmentId) > -1;
	      });
	    },
	    groupedRows: function groupedRows() {
	      var groups = [];
	      var indexByUser = {};
	      for (var i = 0; i < this.filteredRows.length; i++) {
	        var row = this.filteredRows[i];
	        if (indexByUser[row.userId] === undefined) {
	          indexByUser[row.userId] = groups.length;
	          groups.push({ userId: row.userId, rows: [] });
	        }
	        groups[indexByUser[row.userId]].rows.push(row);
	      }
	      return groups;
	    },
	    employmentsAll: function employmentsAll() {
	      return this.$store.state.employments && this.$store.state.employments.employments ? this.$store.state.employments.employments : [];
	    },
	    employmentsById: function employmentsById() {
	      var map = {};
	      var list = this.employmentsAll || [];
	      for (var i = 0; i < list.length; i++) {
	        map[list[i].id] = list[i];
	      }
	      return map;
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted || [];
	    },
	    salaryCodesById: function salaryCodesById() {
	      var map = {};
	      var codes = this.salaryCodes || [];
	      for (var i = 0; i < codes.length; i++) {
	        map[codes[i].id] = codes[i];
	      }
	      return map;
	    },
	    salaryCodesByLoenart: function salaryCodesByLoenart() {
	      var map = {};
	      var codes = this.salaryCodes || [];
	      for (var i = 0; i < codes.length; i++) {
	        if (codes[i].loenart != null) map[String(parseInt(codes[i].loenart, 10))] = codes[i];
	      }
	      return map;
	    },
	    engangsydelserSorted: function engangsydelserSorted() {
	      var result = [];
	      for (var i = 0; i < this.engangsydelser.length; i++) {
	        var item = this.engangsydelser[i];
	        var employment = item.employment_id ? this.employmentsById[item.employment_id] : null;
	        var userId = employment && employment.user_id || item.user_id;
	        var vUserName = userId && this.usersById[userId] || (item.tjenestenummer ? String(item.tjenestenummer) : 'Ukendt');
	        var vEmploymentNumber = employment && employment.employment_number ? employment.employment_number + (employment.title ? ' - ' + employment.title : '') : item.tjenestenummer ? String(item.tjenestenummer) : 'Ukendt';
	        var salaryCode = item.salary_code_id && this.salaryCodesById[item.salary_code_id] || (item.loenart != null ? this.salaryCodesByLoenart[String(parseInt(item.loenart, 10))] : null);
	        var loenartLabel = item.loenart != null ? String(item.loenart) : '';
	        var vLoenart = salaryCode && salaryCode.name ? (salaryCode.loenart || loenartLabel) + ' - ' + salaryCode.name : loenartLabel;
	        result.push((0, _assign2.default)({}, item, {
	          vUserName: vUserName,
	          vEmploymentNumber: vEmploymentNumber,
	          vLoenart: vLoenart,
	          loenartLabel: loenartLabel,
	          vCreatedAt: item.created_at ? (0, _moment2.default)(item.created_at).format('lll') : '',
	          vCreatedBy: this.createdByName(item.approved_by),
	          vDato: this.formatActivityDate(item),
	          can_delete: item.can_delete != null ? item.can_delete : item.state === 'draft'
	        }));
	      }
	      return result.sort(function (a, b) {
	        var av = a.created_at ? (0, _moment2.default)(a.created_at).valueOf() : 0;
	        var bv = b.created_at ? (0, _moment2.default)(b.created_at).valueOf() : 0;
	        return bv - av;
	      });
	    },
	    uniqueNames: function uniqueNames() {
	      var set = {};
	      for (var i = 0; i < this.engangsydelserSorted.length; i++) {
	        var name = this.engangsydelserSorted[i].vUserName || '';
	        if (name) set[name] = true;
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da', { sensitivity: 'base' });
	      });
	    },
	    uniqueLoenart: function uniqueLoenart() {
	      var set = {};
	      for (var i = 0; i < this.engangsydelserSorted.length; i++) {
	        var l = this.engangsydelserSorted[i].loenartLabel || '';
	        if (l) set[l] = true;
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da', { sensitivity: 'base' });
	      });
	    },
	    dateFilteredRows: function dateFilteredRows() {
	      if (!this.startDate || !this.endDate) return this.engangsydelserSorted;
	      var from = (0, _moment2.default)(this.startDate).startOf('day');
	      var to = (0, _moment2.default)(this.endDate).endOf('day');
	      return this.engangsydelserSorted.filter(function (x) {
	        if (!x.vDato) return true;
	        var dato = (0, _moment2.default)(x.vDato, 'DD-MM-YYYY');
	        return dato.isSameOrAfter(from) && dato.isSameOrBefore(to);
	      });
	    },
	    emptyTableText: function emptyTableText() {
	      if (this.hasActiveListFilters) return 'Ingen engangsydelser matcher filtrene';
	      return this.viewTab === 'outbox' ? 'Udbakken er tom' : 'Ingen afsendte engangsydelser';
	    },
	    hasActiveListFilters: function hasActiveListFilters() {
	      return this.selectedNames.length > 0 || this.selectedLoenart.length > 0;
	    },
	    displayedRows: function displayedRows() {
	      var _this3 = this;
	
	      var rows = this.dateFilteredRows.slice();
	      rows = rows.filter(function (x) {
	        return _this3.viewTab === 'sent' ? x.state === 'sent' : x.state !== 'sent';
	      });
	      if (this.selectedNames.length > 0) {
	        var chosen = {};
	        for (var i = 0; i < this.selectedNames.length; i++) {
	          chosen[this.selectedNames[i]] = true;
	        }rows = rows.filter(function (x) {
	          return chosen[x.vUserName || ''];
	        });
	      }
	      if (this.selectedLoenart.length > 0) {
	        var _chosen = {};
	        for (var _i = 0; _i < this.selectedLoenart.length; _i++) {
	          _chosen[this.selectedLoenart[_i]] = true;
	        }rows = rows.filter(function (x) {
	          return _chosen[x.loenartLabel || ''];
	        });
	      }
	
	      var get = function get(item, key) {
	        switch (key) {
	          case 'name':
	            return item.vUserName || '';
	          case 'employment_number':
	            return String(item.vEmploymentNumber || '');
	          case 'loenart':
	            return String(item.loenartLabel || item.vLoenart || '');
	          case 'dato':
	            return item.vDato ? (0, _moment2.default)(item.vDato, 'DD-MM-YYYY').toDate() : new Date(0);
	          case 'antal':
	            return _this3._num(item.enheder);
	          case 'beloeb':
	            return _this3._num(item.sats);
	          case 'vCreatedAt':
	            return item.created_at ? (0, _moment2.default)(item.created_at).valueOf() : 0;
	          default:
	            return item[key] || '';
	        }
	      };
	
	      var dir = this.sortDir === 'asc' ? 1 : -1;
	      var key = this.sortBy;
	
	      return rows.slice().sort(function (a, b) {
	        var va = get(a, key);
	        var vb = get(b, key);
	        if (va === vb) return 0;
	        if (typeof va === 'number' && typeof vb === 'number') return (va - vb) * dir;
	        if (va instanceof Date && vb instanceof Date) return (va - vb) * dir;
	        if (typeof va === 'number' && typeof vb !== 'number') return -1 * dir;
	        if (typeof vb === 'number' && typeof va !== 'number') return 1 * dir;
	        return String(va).localeCompare(String(vb), 'da', { sensitivity: 'base' }) * dir;
	      });
	    }
	  },
	  methods: {
	    createdByName: function createdByName(approvedBy) {
	      if (approvedBy == null) return '';
	      return this.usersById[approvedBy] || String(approvedBy);
	    },
	    onSelectViewTab: function onSelectViewTab(tab) {
	      this.viewTab = tab;
	      if (tab !== 'employments' && !this.isLoading) {
	        this.readEngangsydelser();
	      }
	    },
	    togglePersonName: function togglePersonName(name) {
	      var idx = this.selectedPersonNames.indexOf(name);
	      if (idx > -1) this.selectedPersonNames.splice(idx, 1);else this.selectedPersonNames.push(name);
	    },
	    toggleUserTag: function toggleUserTag(tag) {
	      var idx = this.selectedUserTags.indexOf(tag);
	      if (idx > -1) this.selectedUserTags.splice(idx, 1);else this.selectedUserTags.push(tag);
	    },
	    toggleEmploymentTitle: function toggleEmploymentTitle(title) {
	      var idx = this.selectedEmploymentTitles.indexOf(title);
	      if (idx > -1) this.selectedEmploymentTitles.splice(idx, 1);else this.selectedEmploymentTitles.push(title);
	    },
	    toggleOrganisation: function toggleOrganisation(organisation) {
	      var idx = this.selectedOrganisations.indexOf(organisation);
	      if (idx > -1) this.selectedOrganisations.splice(idx, 1);else this.selectedOrganisations.push(organisation);
	    },
	    toggleName: function toggleName(name) {
	      var idx = this.selectedNames.indexOf(name);
	      if (idx > -1) this.selectedNames.splice(idx, 1);else this.selectedNames.push(name);
	    },
	    toggleLoenart: function toggleLoenart(loenart) {
	      var idx = this.selectedLoenart.indexOf(loenart);
	      if (idx > -1) this.selectedLoenart.splice(idx, 1);else this.selectedLoenart.push(loenart);
	    },
	    setSort: function setSort(key) {
	      this.isSortPristine = false;
	      if (this.sortBy === key) {
	        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
	      } else {
	        this.sortBy = key;
	        this.sortDir = 'asc';
	      }
	    },
	    startDateChanged: function startDateChanged(date) {
	      this.dateFilterTouched = true;
	      this.startDate = date;
	    },
	    endDateChanged: function endDateChanged(date) {
	      this.dateFilterTouched = true;
	      this.endDate = date;
	    },
	    syncDateRangeFromData: function syncDateRangeFromData() {
	      if (this.dateFilterTouched) return;
	      var min = null;
	      var max = null;
	      for (var i = 0; i < this.engangsydelser.length; i++) {
	        var item = this.engangsydelser[i];
	        if (item.aar == null || item.maaned == null || item.dag == null) continue;
	        var year = 2000 + parseInt(item.aar, 10);
	        var d = (0, _moment2.default)({
	          year: year,
	          month: parseInt(item.maaned, 10) - 1,
	          day: parseInt(item.dag, 10)
	        });
	        if (!d.isValid()) continue;
	        if (!min || d.isBefore(min)) min = d.clone();
	        if (!max || d.isAfter(max)) max = d.clone();
	      }
	      if (min && max) {
	        this.startDate = min.startOf('day');
	        this.endDate = max.endOf('day');
	      }
	    },
	    _num: function _num(v) {
	      if (v == null || v === '') return 0;
	      var n = typeof v === 'number' ? v : parseFloat(String(v).replace(',', '.'));
	      return (0, _isFinite2.default)(n) ? n : 0;
	    },
	    isRowSelected: function isRowSelected(row) {
	      return this.selectedEmploymentIds.indexOf(row.employmentId) > -1;
	    },
	    toggleSelection: function toggleSelection(row) {
	      var idx = this.selectedEmploymentIds.indexOf(row.employmentId);
	      if (idx > -1) this.selectedEmploymentIds.splice(idx, 1);else this.selectedEmploymentIds.push(row.employmentId);
	    },
	    toggleAllSelected: function toggleAllSelected() {
	      this.isBatchMode = true;
	      var visibleIds = this.filteredRows.map(function (row) {
	        return row.employmentId;
	      });
	      if (this.isAllFilteredSelected) {
	        this.selectedEmploymentIds = this.selectedEmploymentIds.filter(function (id) {
	          return visibleIds.indexOf(id) === -1;
	        });
	      } else {
	        var set = {};
	        for (var i = 0; i < this.selectedEmploymentIds.length; i++) {
	          set[this.selectedEmploymentIds[i]] = true;
	        }for (var _i2 = 0; _i2 < visibleIds.length; _i2++) {
	          set[visibleIds[_i2]] = true;
	        }this.selectedEmploymentIds = (0, _keys2.default)(set).map(function (id) {
	          return parseInt(id, 10);
	        });
	      }
	    },
	    cancelBatchMode: function cancelBatchMode() {
	      this.isBatchMode = false;
	      this.selectedEmploymentIds = [];
	    },
	    onRowClick: function onRowClick(row) {
	      if (this.isBatchMode) this.toggleSelection(row);else this.openSingleCreate(row);
	    },
	    onCheckboxClick: function onCheckboxClick(row) {
	      if (!this.isBatchMode) this.isBatchMode = true;
	      this.toggleSelection(row);
	    },
	    openSingleCreate: function openSingleCreate(row) {
	      this.createEmploymentIds = [row.employmentId];
	      this.createSubtitle = row.userName + ' – ' + row.employmentNumber + ' - ' + row.employmentTitle;
	    },
	    openBulkCreate: function openBulkCreate() {
	      if (this.selectedEmploymentIds.length === 0) return;
	      this.createEmploymentIds = this.selectedEmploymentIds.slice();
	      this.createSubtitle = '';
	    },
	    closeCreate: function closeCreate() {
	      this.createEmploymentIds = [];
	      this.createSubtitle = '';
	    },
	    onCreated: function onCreated() {
	      this.closeCreate();
	      this.cancelBatchMode();
	      this.viewTab = 'outbox';
	      this.readEngangsydelser();
	    },
	    deleteRow: function deleteRow(item) {
	      var _this4 = this;
	
	      if (item.id == null || this.deletingIds.includes(item.id)) return;
	      this.deletingIds.push(item.id);
	      _docendo2.default.deleteSilkeborgDataEngangsydelse(this.schoolId, item.id, 'ydelse', function () {
	        _this4.deletingIds = _this4.deletingIds.filter(function (id) {
	          return id !== item.id;
	        });
	        _this4.engangsydelser = _this4.engangsydelser.filter(function (r) {
	          return r.id !== item.id;
	        });
	        _eventbus2.default.toast = { text: 'Engangsydelsen blev slettet fra udbakken', success: true, position: 'bottomLeft' };
	      }, function (failure) {
	        console.log('delete failure', failure);
	        _this4.deletingIds = _this4.deletingIds.filter(function (id) {
	          return id !== item.id;
	        });
	        _eventbus2.default.toast = { text: 'Kunne ikke slette engangsydelsen', success: false, position: 'bottomLeft' };
	      });
	    },
	    formatActivityDate: function formatActivityDate(item) {
	      if (item.aar == null || item.maaned == null || item.dag == null) return '';
	      var year = 2000 + parseInt(item.aar, 10);
	      return (0, _moment2.default)({ year: year, month: parseInt(item.maaned, 10) - 1, day: parseInt(item.dag, 10) }).format('DD-MM-YYYY');
	    },
	    formatDecimal: function formatDecimal(value) {
	      if (value == null || value === '') return '';
	      var num = Number(value);
	      if (isNaN(num)) return String(value).replace('.', ',');
	      var rounded = Math.round(num * 100) / 100;
	      return String(rounded).replace('.', ',');
	    },
	    stateLabel: function stateLabel(state) {
	      switch (state) {
	        case 'draft':
	          return 'I udbakke';
	        case 'sending':
	          return 'Sender';
	        case 'sent':
	          return 'Sendt';
	        default:
	          return state || '';
	      }
	    },
	    readEngangsydelser: function readEngangsydelser() {
	      var _this5 = this;
	
	      this.isLoading = true;
	      _docendo2.default.listSilkeborgDataEngangsydelser(this.schoolId, 'ydelse', function (success) {
	        if (success && success.status && success.status === 'error') {
	          _this5.isNoConfiguration = true;
	        }
	        if (Array.isArray(success)) {
	          _this5.engangsydelser = success;
	        } else if (success && Array.isArray(success.data)) {
	          _this5.engangsydelser = success.data;
	        } else {
	          _this5.engangsydelser = [];
	        }
	        _this5.syncDateRangeFromData();
	        _this5.isLoading = false;
	      }, function (failure) {
	        console.log(failure);
	        _this5.isLoading = false;
	        _this5.engangsydelser = [];
	        if (failure && failure.status && failure.status === 'error') {
	          _this5.isNoConfiguration = true;
	        }
	      });
	    }
	  },
	  watch: {
	    selectedEmploymentIds: function selectedEmploymentIds(ids) {
	      if (!ids || ids.length === 0) this.isBatchMode = false;
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('getUsersFromSchoolId', this.schoolId);
	    this.$store.dispatch('readEmployments');
	    this.$store.dispatch('readSalaryCodes');
	    this.readEngangsydelser();
	  }
	};

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _SdCreateFastTillaeg = __webpack_require__(1590);
	
	var _SdCreateFastTillaeg2 = _interopRequireDefault(_SdCreateFastTillaeg);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _Supplements = __webpack_require__(102);
	
	var _Supplements2 = _interopRequireDefault(_Supplements);
	
	var _TidsbegraensetUvModal = __webpack_require__(399);
	
	var _TidsbegraensetUvModal2 = _interopRequireDefault(_TidsbegraensetUvModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SdFasteTillaeg',
	  components: { Loader: _Loader2.default, DoFiltersFilter: _DoFiltersFilter2.default, SdCreateFastTillaeg: _SdCreateFastTillaeg2.default, Tabs: _Tabs2.default, DModal: _DModal2.default, DDropdown: _DDropdown2.default, Supplements: _Supplements2.default, TidsbegraensetUvModal: _TidsbegraensetUvModal2.default },
	  data: function data() {
	    return {
	      isNoConfiguration: false,
	      isLoading: false,
	      tillaeger: [],
	      loenaendringer: [],
	      selectedNames: [],
	      selectedTillaeg: [],
	      viewTab: 'employments',
	      selectedPersonNames: [],
	      selectedUserTags: [],
	      selectedEmploymentTitles: [],
	      selectedOrganisations: [],
	      selectedEmploymentIds: [],
	      isBatchMode: false,
	      createEmploymentIds: [],
	      createSubtitle: '',
	      deletingKeys: [],
	      entriesSortKey: 'created_at',
	      entriesSortDir: 'desc',
	      isShowBeregnModal: false,
	      isShowTidsbegraenset: false,
	      beregnType: null,
	      sendToSdTrigger: 0,
	      sdApproveState: { count: 0, isApproving: false, canApprove: false, missingEmployment: false },
	      beregnOptions: [{ id: 'loenbroek', label: 'Lønbrøk' }, { id: 'uv_over_graense', label: 'Undervisningstillæg – timer over grænse (§5 stk. 2)' }, { id: 'spec_skole_uv', label: 'Specialundervisning (§ 5, stk. 4)' }, { id: 'dsa_tale_hoere', label: 'DSA og tale/høre-undervisning (§5 stk. 9 og 10)' }, { id: 'paedagog_eneansvar', label: 'Pædagog med eneansvar' }]
	    };
	  },
	
	  computed: {
	    viewTabs: function viewTabs() {
	      return [{ id: 'employments', title: 'Oprettelse' }, { id: 'outbox', title: 'Udbakke (' + this.outboxCount + ')' }, { id: 'sent', title: 'Sendt til l\xF8nsystem (' + this.sentCount + ')' }];
	    },
	    outboxCount: function outboxCount() {
	      return this.allEntries.filter(function (p) {
	        return p.state !== 'sent';
	      }).length;
	    },
	    sentCount: function sentCount() {
	      return this.allEntries.filter(function (p) {
	        return p.state === 'sent';
	      }).length;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    isLoadingEmployments: function isLoadingEmployments() {
	      return this.$store.state.employments && this.$store.state.employments.isLoadingEmploymentsTypesForSchool;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName || [];
	    },
	    usersById: function usersById() {
	      var map = {};
	      var list = this.users;
	      for (var i = 0; i < list.length; i++) {
	        map[list[i].id] = list[i].name;
	      }return map;
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash || {};
	    },
	    allRows: function allRows() {
	      var out = [];
	      for (var i = 0; i < this.users.length; i++) {
	        var user = this.users[i];
	        var emps = this.employmentsInUserIdHash[user.id] || [];
	        for (var j = 0; j < emps.length; j++) {
	          var emp = emps[j];
	          var empNumber = emp && emp.employment_number ? String(emp.employment_number) : '';
	          if (empNumber.trim() === '') continue;
	          if (emp.source === 'opus') continue;
	
	          if (emp.employment_template_id == null) continue;
	          var title = emp.source_title || emp.title || 'Ansættelse';
	          out.push({
	            id: user.id + '_' + emp.id,
	            userId: user.id,
	            userName: user.name,
	            userTags: Array.isArray(user.user_tags) ? user.user_tags : [],
	            employmentId: emp.id,
	            employmentTitle: title,
	            employmentNumber: empNumber,
	            organisation: emp.organisation || '',
	            employment: emp
	          });
	        }
	      }
	      return out.sort(function (a, b) {
	        return a.userName.localeCompare(b.userName, 'da-DK', { sensitivity: 'base' });
	      });
	    },
	    personNames: function personNames() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        if (this.allRows[i].userName) set[this.allRows[i].userName] = true;
	      }return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    userTags: function userTags() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        var t = this.allRows[i].userTags || [];
	        for (var j = 0; j < t.length; j++) {
	          if (t[j]) set[t[j]] = true;
	        }
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    employmentTitles: function employmentTitles() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        if (this.allRows[i].employmentTitle) set[this.allRows[i].employmentTitle] = true;
	      }return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    organisations: function organisations() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        if (this.allRows[i].organisation) set[this.allRows[i].organisation] = true;
	      }return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    filteredRows: function filteredRows() {
	      var _this = this;
	
	      return this.allRows.filter(function (row) {
	        if (_this.selectedPersonNames.length > 0 && _this.selectedPersonNames.indexOf(row.userName) === -1) return false;
	        if (_this.selectedUserTags.length > 0) {
	          var match = row.userTags && _this.selectedUserTags.some(function (t) {
	            return row.userTags.indexOf(t) > -1;
	          });
	          if (!match) return false;
	        }
	        if (_this.selectedEmploymentTitles.length > 0 && _this.selectedEmploymentTitles.indexOf(row.employmentTitle) === -1) return false;
	        if (_this.selectedOrganisations.length > 0 && _this.selectedOrganisations.indexOf(row.organisation) === -1) return false;
	        return true;
	      });
	    },
	    isAllFilteredSelected: function isAllFilteredSelected() {
	      var _this2 = this;
	
	      if (this.filteredRows.length === 0) return false;
	      return this.filteredRows.every(function (row) {
	        return _this2.selectedEmploymentIds.indexOf(row.employmentId) > -1;
	      });
	    },
	    groupedRows: function groupedRows() {
	      var groups = [];
	      var indexByUser = {};
	      for (var i = 0; i < this.filteredRows.length; i++) {
	        var row = this.filteredRows[i];
	        if (indexByUser[row.userId] === undefined) {
	          indexByUser[row.userId] = groups.length;
	          groups.push({ userId: row.userId, rows: [] });
	        }
	        groups[indexByUser[row.userId]].rows.push(row);
	      }
	      return groups;
	    },
	    employmentsById: function employmentsById() {
	      var map = {};
	      var list = this.$store.state.employments && this.$store.state.employments.employments || [];
	      for (var i = 0; i < list.length; i++) {
	        map[list[i].id] = list[i];
	      }return map;
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted || [];
	    },
	    hasSpecialSalaryCode: function hasSpecialSalaryCode() {
	      return this.salaryCodes.some(function (salaryCode) {
	        return String(salaryCode.tillaegsnummer) === '160099' || String(salaryCode.tillaegsnummer) === '160100' || String(salaryCode.loenart) === '836';
	      });
	    },
	    visibleBeregnOptions: function visibleBeregnOptions() {
	      return this.beregnOptions.filter(function (option) {
	        return option.id !== 'spec_skole_uv';
	      });
	    },
	    beregnModalTitle: function beregnModalTitle() {
	      var _this3 = this;
	
	      var option = this.beregnOptions.find(function (o) {
	        return o.id === _this3.beregnType;
	      });
	      return option ? option.label : 'Beregn tillæg automatisk';
	    },
	    sendToSdTooltip: function sendToSdTooltip() {
	      if (this.sdApproveState.count === 0) return 'Opret lønlinjer først';
	      if (this.sdApproveState.missingEmployment) return 'Vælg ansættelse på alle linjer';
	      return '';
	    },
	    salaryCodesById: function salaryCodesById() {
	      var map = {};
	      var codes = this.salaryCodes || [];
	      for (var i = 0; i < codes.length; i++) {
	        map[codes[i].id] = codes[i];
	      }return map;
	    },
	    salaryCodesByTillaegsnummer: function salaryCodesByTillaegsnummer() {
	      var map = {};
	      var codes = this.salaryCodes || [];
	      for (var i = 0; i < codes.length; i++) {
	        if (codes[i].tillaegsnummer != null) map[String(codes[i].tillaegsnummer)] = codes[i];
	      }
	      return map;
	    },
	    allPairs: function allPairs() {
	      var _this4 = this;
	
	      var groups = {};
	      for (var i = 0; i < this.tillaeger.length; i++) {
	        var t = this.tillaeger[i];
	        var empKey = t.employment_id != null ? 'e' + t.employment_id : 'n' + t.tjenestenummer;
	        var key = empKey + '|' + (t.tillaegsnummer != null ? t.tillaegsnummer : '') + '|' + (t.salary_code_id != null ? t.salary_code_id : '');
	        if (!groups[key]) groups[key] = { o: [], s: [] };
	        if (t.aendringskode === 'S') groups[key].s.push(t);else groups[key].o.push(t);
	      }
	      var pairs = [];
	      (0, _keys2.default)(groups).forEach(function (key) {
	        var g = groups[key];
	        g.o.sort(function (a, b) {
	          return a.id - b.id;
	        });
	        g.s.sort(function (a, b) {
	          return a.id - b.id;
	        });
	        var count = Math.max(g.o.length, g.s.length);
	        for (var _i = 0; _i < count; _i++) {
	          pairs.push(_this4.buildPair(g.o[_i] || null, g.s[_i] || null));
	        }
	      });
	      return pairs.sort(function (a, b) {
	        var av = a.created_at ? (0, _moment2.default)(a.created_at).valueOf() : 0;
	        var bv = b.created_at ? (0, _moment2.default)(b.created_at).valueOf() : 0;
	        return bv - av;
	      });
	    },
	    loenaendringRows: function loenaendringRows() {
	      var _this5 = this;
	
	      return this.loenaendringer.map(function (loenaendring) {
	        return _this5.buildLoenaendringRow(loenaendring);
	      });
	    },
	    allEntries: function allEntries() {
	      return this.allPairs.concat(this.loenaendringRows).sort(function (a, b) {
	        var av = a.created_at ? (0, _moment2.default)(a.created_at).valueOf() : 0;
	        var bv = b.created_at ? (0, _moment2.default)(b.created_at).valueOf() : 0;
	        return bv - av;
	      });
	    },
	    uniqueNames: function uniqueNames() {
	      var set = {};
	      for (var i = 0; i < this.allEntries.length; i++) {
	        var name = this.allEntries[i].vUserName || '';
	        if (name) set[name] = true;
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da', { sensitivity: 'base' });
	      });
	    },
	    uniqueTillaeg: function uniqueTillaeg() {
	      var set = {};
	      for (var i = 0; i < this.allEntries.length; i++) {
	        var tillaeg = this.allEntries[i].vTillaeg || '';
	        if (tillaeg) set[tillaeg] = true;
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da', { sensitivity: 'base', numeric: true });
	      });
	    },
	    displayedPairs: function displayedPairs() {
	      var _this6 = this;
	
	      var rows = this.allEntries.slice();
	      rows = rows.filter(function (p) {
	        return _this6.viewTab === 'sent' ? p.state === 'sent' : p.state !== 'sent';
	      });
	      if (this.selectedNames.length > 0) {
	        var chosen = {};
	        for (var i = 0; i < this.selectedNames.length; i++) {
	          chosen[this.selectedNames[i]] = true;
	        }rows = rows.filter(function (p) {
	          return chosen[p.vUserName || ''];
	        });
	      }
	      if (this.selectedTillaeg.length > 0) {
	        var _chosen = {};
	        for (var _i2 = 0; _i2 < this.selectedTillaeg.length; _i2++) {
	          _chosen[this.selectedTillaeg[_i2]] = true;
	        }rows = rows.filter(function (p) {
	          return _chosen[p.vTillaeg || ''];
	        });
	      }
	      var dir = this.entriesSortDir === 'asc' ? 1 : -1;
	      var key = this.entriesSortKey;
	      return rows.sort(function (a, b) {
	        var av = _this6.entrySortValue(a, key);
	        var bv = _this6.entrySortValue(b, key);
	        var cmp = void 0;
	        if (typeof av === 'number' && typeof bv === 'number') {
	          cmp = av - bv;
	        } else {
	          cmp = String(av).localeCompare(String(bv), 'da-DK', { sensitivity: 'base' });
	        }
	        return cmp * dir;
	      });
	    }
	  },
	  methods: {
	    sortEntries: function sortEntries(key) {
	      if (this.entriesSortKey === key) {
	        this.entriesSortDir = this.entriesSortDir === 'asc' ? 'desc' : 'asc';
	      } else {
	        this.entriesSortKey = key;
	        this.entriesSortDir = 'asc';
	      }
	    },
	    entrySortValue: function entrySortValue(row, key) {
	      switch (key) {
	        case 'created_at':
	          return row.created_at ? (0, _moment2.default)(row.created_at).valueOf() : 0;
	        case 'user':
	          return (row.vUserName || '').toLowerCase();
	        case 'employment':
	          return (row.vEmploymentNumber || '').toLowerCase();
	        case 'tillaeg':
	          return (row.vTillaeg || '').toLowerCase();
	        case 'antal':
	          return row.vEnheder !== '' ? parseFloat(String(row.vEnheder).replace(',', '.')) || 0 : 0;
	        case 'fra':
	          return row.fraDato ? (0, _moment2.default)(row.fraDato).valueOf() : 0;
	        case 'til':
	          return row.tilDato ? (0, _moment2.default)(row.tilDato).valueOf() : 0;
	        case 'created_by':
	          return (row.vCreatedBy || '').toLowerCase();
	        case 'state':
	          return this.stateLabel(row.state);
	        default:
	          return '';
	      }
	    },
	    createdByName: function createdByName(approvedBy) {
	      if (approvedBy == null) return '';
	      return this.usersById[approvedBy] || String(approvedBy);
	    },
	    buildPair: function buildPair(oLine, sLine) {
	      var base = oLine || sLine;
	      var employment = base.employment_id ? this.employmentsById[base.employment_id] : null;
	      var userId = employment && employment.user_id || base.user_id;
	      var vUserName = userId && this.usersById[userId] || (base.tjenestenummer ? String(base.tjenestenummer) : 'Ukendt');
	      var vEmploymentNumber = employment && employment.employment_number ? employment.employment_number + (employment.title ? ' - ' + employment.title : '') : base.tjenestenummer ? String(base.tjenestenummer) : 'Ukendt';
	      var salaryCode = base.salary_code_id && this.salaryCodesById[base.salary_code_id] || (base.tillaegsnummer != null ? this.salaryCodesByTillaegsnummer[String(base.tillaegsnummer)] : null);
	      var tillaegLabel = base.tillaegsnummer != null ? String(base.tillaegsnummer) : '';
	      var vTillaeg = salaryCode && salaryCode.name ? tillaegLabel + ' - ' + salaryCode.name : tillaegLabel;
	      var ids = [];
	      if (oLine) ids.push(oLine.id);
	      if (sLine) ids.push(sLine.id);
	      var state = base.state || 'draft';
	      var canDelete = base.can_delete != null ? base.can_delete : state === 'draft';
	      return {
	        vRowKey: 'p_' + (oLine ? oLine.id : 'x') + '_' + (sLine ? sLine.id : 'x'),
	        kind: 'tillaeg',
	        ids: ids,
	        state: state,
	        can_delete: canDelete,
	        created_at: base.created_at,
	        vCreatedAt: base.created_at ? (0, _moment2.default)(base.created_at).format('lll') : '',
	        vCreatedBy: this.createdByName(base.approved_by),
	        vUserName: vUserName,
	        vEmploymentNumber: vEmploymentNumber,
	        vTillaeg: vTillaeg,
	        vEnheder: this.formatDecimal(oLine ? oLine.enheder : sLine ? sLine.enheder : null),
	        fraDato: oLine ? oLine.dato : null,
	        tilDato: sLine ? sLine.dato : null,
	        vFraDato: oLine && oLine.dato ? (0, _moment2.default)(oLine.dato).format('DD-MM-YYYY') : '',
	        vTilDato: sLine && sLine.dato ? (0, _moment2.default)(sLine.dato).format('DD-MM-YYYY') : ''
	      };
	    },
	    buildLoenaendringRow: function buildLoenaendringRow(loenaendring) {
	      var employment = loenaendring.employment_id ? this.employmentsById[loenaendring.employment_id] : null;
	      var userId = employment && employment.user_id || loenaendring.user_id;
	      var vUserName = userId && this.usersById[userId] || (loenaendring.tjenestenummer ? String(loenaendring.tjenestenummer) : 'Ukendt');
	      var vEmploymentNumber = employment && employment.employment_number ? employment.employment_number + (employment.title ? ' - ' + employment.title : '') : loenaendring.tjenestenummer ? String(loenaendring.tjenestenummer) : 'Ukendt';
	      var state = loenaendring.state || 'draft';
	      var vEnheder = '';
	      if (loenaendring.beskaeftigelsesdecimal != null) vEnheder = this.formatDecimal(loenaendring.beskaeftigelsesdecimal);else if (loenaendring.loendecimal != null) vEnheder = this.formatDecimal(loenaendring.loendecimal);else if (loenaendring.aarstimetal != null) vEnheder = this.formatDecimal(loenaendring.aarstimetal);else if (Number(loenaendring.deltidskode) === 0) vEnheder = '1';
	      return {
	        vRowKey: 'l_' + loenaendring.id,
	        kind: 'loenaendring',
	        ids: [loenaendring.id],
	        state: state,
	        can_delete: state === 'draft',
	        created_at: loenaendring.created_at,
	        vCreatedAt: loenaendring.created_at ? (0, _moment2.default)(loenaendring.created_at).format('lll') : '',
	        vCreatedBy: this.createdByName(loenaendring.approved_by),
	        vUserName: vUserName,
	        vEmploymentNumber: vEmploymentNumber,
	        vTillaeg: 'Lønbrøk',
	        vEnheder: vEnheder,
	        fraDato: loenaendring.dato,
	        tilDato: null,
	        vFraDato: loenaendring.dato ? (0, _moment2.default)(loenaendring.dato).format('DD-MM-YYYY') : '',
	        vTilDato: ''
	      };
	    },
	    onSelectViewTab: function onSelectViewTab(tab) {
	      this.viewTab = tab;
	      if (tab !== 'employments' && !this.isLoading) this.readTillaeger();
	    },
	    togglePersonName: function togglePersonName(name) {
	      var idx = this.selectedPersonNames.indexOf(name);
	      if (idx > -1) this.selectedPersonNames.splice(idx, 1);else this.selectedPersonNames.push(name);
	    },
	    toggleUserTag: function toggleUserTag(tag) {
	      var idx = this.selectedUserTags.indexOf(tag);
	      if (idx > -1) this.selectedUserTags.splice(idx, 1);else this.selectedUserTags.push(tag);
	    },
	    toggleEmploymentTitle: function toggleEmploymentTitle(title) {
	      var idx = this.selectedEmploymentTitles.indexOf(title);
	      if (idx > -1) this.selectedEmploymentTitles.splice(idx, 1);else this.selectedEmploymentTitles.push(title);
	    },
	    toggleOrganisation: function toggleOrganisation(organisation) {
	      var idx = this.selectedOrganisations.indexOf(organisation);
	      if (idx > -1) this.selectedOrganisations.splice(idx, 1);else this.selectedOrganisations.push(organisation);
	    },
	    toggleName: function toggleName(name) {
	      var idx = this.selectedNames.indexOf(name);
	      if (idx > -1) this.selectedNames.splice(idx, 1);else this.selectedNames.push(name);
	    },
	    toggleTillaeg: function toggleTillaeg(tillaeg) {
	      var idx = this.selectedTillaeg.indexOf(tillaeg);
	      if (idx > -1) this.selectedTillaeg.splice(idx, 1);else this.selectedTillaeg.push(tillaeg);
	    },
	    isRowSelected: function isRowSelected(row) {
	      return this.selectedEmploymentIds.indexOf(row.employmentId) > -1;
	    },
	    toggleSelection: function toggleSelection(row) {
	      var idx = this.selectedEmploymentIds.indexOf(row.employmentId);
	      if (idx > -1) this.selectedEmploymentIds.splice(idx, 1);else this.selectedEmploymentIds.push(row.employmentId);
	    },
	    toggleAllSelected: function toggleAllSelected() {
	      this.isBatchMode = true;
	      var visibleIds = this.filteredRows.map(function (row) {
	        return row.employmentId;
	      });
	      if (this.isAllFilteredSelected) {
	        this.selectedEmploymentIds = this.selectedEmploymentIds.filter(function (id) {
	          return visibleIds.indexOf(id) === -1;
	        });
	      } else {
	        var set = {};
	        for (var i = 0; i < this.selectedEmploymentIds.length; i++) {
	          set[this.selectedEmploymentIds[i]] = true;
	        }for (var _i3 = 0; _i3 < visibleIds.length; _i3++) {
	          set[visibleIds[_i3]] = true;
	        }this.selectedEmploymentIds = (0, _keys2.default)(set).map(function (id) {
	          return parseInt(id, 10);
	        });
	      }
	    },
	    cancelBatchMode: function cancelBatchMode() {
	      this.isBatchMode = false;
	      this.selectedEmploymentIds = [];
	    },
	    onRowClick: function onRowClick(row) {
	      if (this.isBatchMode) this.toggleSelection(row);else this.openSingleCreate(row);
	    },
	    onCheckboxClick: function onCheckboxClick(row) {
	      if (!this.isBatchMode) this.isBatchMode = true;
	      this.toggleSelection(row);
	    },
	    openSingleCreate: function openSingleCreate(row) {
	      this.createEmploymentIds = [row.employmentId];
	      this.createSubtitle = row.userName + ' – ' + row.employmentNumber + ' - ' + row.employmentTitle;
	    },
	    openBulkCreate: function openBulkCreate() {
	      if (this.selectedEmploymentIds.length === 0) return;
	      this.createEmploymentIds = this.selectedEmploymentIds.slice();
	      this.createSubtitle = '';
	    },
	    closeCreate: function closeCreate() {
	      this.createEmploymentIds = [];
	      this.createSubtitle = '';
	    },
	    onCreated: function onCreated() {
	      this.closeCreate();
	      this.cancelBatchMode();
	      this.viewTab = 'outbox';
	      this.readTillaeger();
	    },
	    isDeleting: function isDeleting(pair) {
	      return this.deletingKeys.includes(pair.vRowKey);
	    },
	    deletePair: function deletePair(pair) {
	      var _this7 = this;
	
	      if (pair.ids.length === 0 || this.isDeleting(pair)) return;
	      var isLoenaendring = pair.kind === 'loenaendring';
	      var label = isLoenaendring ? 'lønbrøk' : 'faste tillæg';
	      this.deletingKeys.push(pair.vRowKey);
	      var pending = pair.ids.length;
	      var hadError = false;
	      var done = function done() {
	        if (pending > 0) return;
	        _this7.deletingKeys = _this7.deletingKeys.filter(function (k) {
	          return k !== pair.vRowKey;
	        });
	        if (hadError) {
	          _eventbus2.default.toast = { text: 'Kunne ikke slette ' + (isLoenaendring ? 'lønbrøken' : 'det faste tillæg'), success: false, position: 'bottomLeft' };
	          _this7.readTillaeger();
	          return;
	        }
	        if (isLoenaendring) {
	          _this7.loenaendringer = _this7.loenaendringer.filter(function (r) {
	            return pair.ids.indexOf(r.id) === -1;
	          });
	        } else {
	          _this7.tillaeger = _this7.tillaeger.filter(function (r) {
	            return pair.ids.indexOf(r.id) === -1;
	          });
	        }
	        _eventbus2.default.toast = { text: (isLoenaendring ? 'Lønbrøken' : 'Det faste tillæg') + ' blev slettet fra udbakken', success: true, position: 'bottomLeft' };
	      };
	      var deleteFn = isLoenaendring ? _docendo2.default.deleteSilkeborgDataLoenaendring : _docendo2.default.deleteSilkeborgDataTillaeg;
	      pair.ids.forEach(function (id) {
	        deleteFn.call(_docendo2.default, _this7.schoolId, id, function () {
	          pending--;
	          done();
	        }, function (failure) {
	          console.log('delete ' + label + ' failure', failure);
	          pending--;
	          hadError = true;
	          done();
	        });
	      });
	    },
	    formatDecimal: function formatDecimal(value) {
	      if (value == null || value === '') return '';
	      var num = Number(value);
	      if (isNaN(num)) return String(value).replace('.', ',');
	
	      var rounded = Math.round(num * 1000) / 1000;
	      return String(rounded).replace('.', ',');
	    },
	    stateLabel: function stateLabel(state) {
	      switch (state) {
	        case 'draft':
	          return 'I udbakke';
	        case 'sending':
	          return 'Sender';
	        case 'sent':
	          return 'Sendt';
	        default:
	          return state || '';
	      }
	    },
	    readTillaeger: function readTillaeger() {
	      var _this8 = this;
	
	      this.isLoading = true;
	      var pending = 2;
	      var done = function done() {
	        pending--;
	        if (pending <= 0) _this8.isLoading = false;
	      };
	      _docendo2.default.listSilkeborgDataTillaeg(this.schoolId, function (success) {
	        if (success && success.status && success.status === 'error') {
	          _this8.isNoConfiguration = true;
	        }
	        if (Array.isArray(success)) {
	          _this8.tillaeger = success;
	        } else if (success && Array.isArray(success.data)) {
	          _this8.tillaeger = success.data;
	        } else {
	          _this8.tillaeger = [];
	        }
	        done();
	      }, function (failure) {
	        console.log(failure);
	        _this8.tillaeger = [];
	        if (failure && failure.status && failure.status === 'error') {
	          _this8.isNoConfiguration = true;
	        }
	        done();
	      });
	      _docendo2.default.listSilkeborgDataLoenaendringer(this.schoolId, function (success) {
	        if (success && success.status && success.status === 'error') {
	          _this8.isNoConfiguration = true;
	        }
	        if (Array.isArray(success)) {
	          _this8.loenaendringer = success;
	        } else if (success && Array.isArray(success.data)) {
	          _this8.loenaendringer = success.data;
	        } else {
	          _this8.loenaendringer = [];
	        }
	        done();
	      }, function (failure) {
	        console.log(failure);
	        _this8.loenaendringer = [];
	        done();
	      });
	    },
	    selectBeregnOption: function selectBeregnOption(option) {
	      if (option.id === 'tidsbegraenset_uv') {
	        this.isShowTidsbegraenset = true;
	        return;
	      }
	      this.beregnType = option.id;
	      this.sdApproveState = { count: 0, isApproving: false, canApprove: false, missingEmployment: false };
	      this.isShowBeregnModal = true;
	    },
	    triggerSendToSd: function triggerSendToSd() {
	      this.sendToSdTrigger++;
	    },
	    closeBeregnModal: function closeBeregnModal() {
	      this.isShowBeregnModal = false;
	      this.beregnType = null;
	
	      this.readTillaeger();
	    }
	  },
	  watch: {
	    selectedEmploymentIds: function selectedEmploymentIds(ids) {
	      if (!ids || ids.length === 0) this.isBatchMode = false;
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('getUsersFromSchoolId', this.schoolId);
	    this.$store.dispatch('readEmployments');
	    this.$store.dispatch('readSalaryCodes');
	    this.readTillaeger();
	  }
	};

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _SdAutoFravaer = __webpack_require__(1588);
	
	var _SdAutoFravaer2 = _interopRequireDefault(_SdAutoFravaer);
	
	var _DoDatePickerRange = __webpack_require__(44);
	
	var _DoDatePickerRange2 = _interopRequireDefault(_DoDatePickerRange);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SdFravaer',
	  components: { Loader: _Loader2.default, DoFiltersFilter: _DoFiltersFilter2.default, SdAutoFravaer: _SdAutoFravaer2.default, DoDatePickerRange: _DoDatePickerRange2.default, Tabs: _Tabs2.default, ModalConfirmation: _ModalConfirmation2.default },
	  data: function data() {
	    return {
	      isNoConfiguration: false,
	      isLoading: false,
	      fravaer: [],
	      sdFravaer: [],
	      absenceCodes: [],
	      selectedNames: [],
	      selectedAbsenceTypes: [],
	      viewTab: 'employments',
	      selectedPersonNames: [],
	      selectedUserTags: [],
	      selectedEmploymentTitles: [],
	      selectedOrganisations: [],
	      selectedEmploymentIds: [],
	      isBatchMode: false,
	      createEmploymentIds: [],
	      createSubtitle: '',
	      isAutoFravaerOpen: false,
	      autoStartDate: (0, _moment2.default)().startOf('month'),
	      autoEndDate: (0, _moment2.default)().endOf('month'),
	      deletingIds: [],
	      deleteCandidate: null
	    };
	  },
	
	  computed: {
	    viewTabs: function viewTabs() {
	      return [{ id: 'employments', title: 'Oprettelse' }, { id: 'outbox', title: 'Udbakke (' + this.outboxCount + ')' }, { id: 'sent', title: 'Sendt til l\xF8nsystem (' + this.sentCount + ')' }];
	    },
	    outboxCount: function outboxCount() {
	      return this.fravaerSorted.filter(function (x) {
	        return x.state !== 'sent';
	      }).length;
	    },
	    sentCount: function sentCount() {
	      return this.fravaerSorted.filter(function (x) {
	        return x.state === 'sent';
	      }).length;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    isLoadingEmployments: function isLoadingEmployments() {
	      return this.$store.state.employments && this.$store.state.employments.isLoadingEmploymentsTypesForSchool;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName || [];
	    },
	    usersById: function usersById() {
	      var map = {};
	      var list = this.users;
	      for (var i = 0; i < list.length; i++) {
	        map[list[i].id] = list[i].name;
	      }return map;
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash || {};
	    },
	    allRows: function allRows() {
	      var out = [];
	      for (var i = 0; i < this.users.length; i++) {
	        var user = this.users[i];
	        var emps = this.employmentsInUserIdHash[user.id] || [];
	        for (var j = 0; j < emps.length; j++) {
	          var emp = emps[j];
	          var empNumber = emp && emp.employment_number ? String(emp.employment_number) : '';
	          if (empNumber.trim() === '') continue;
	          if (emp.source === 'opus') continue;
	
	          if (emp.employment_template_id == null) continue;
	          var title = emp.source_title || emp.title || 'Ansættelse';
	          out.push({
	            id: user.id + '_' + emp.id,
	            userId: user.id,
	            userName: user.name,
	            userTags: Array.isArray(user.user_tags) ? user.user_tags : [],
	            employmentId: emp.id,
	            employmentTitle: title,
	            employmentNumber: empNumber,
	            organisation: emp.organisation || '',
	            employment: emp
	          });
	        }
	      }
	      return out.sort(function (a, b) {
	        return a.userName.localeCompare(b.userName, 'da-DK', { sensitivity: 'base' });
	      });
	    },
	    personNames: function personNames() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        if (this.allRows[i].userName) set[this.allRows[i].userName] = true;
	      }return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    userTags: function userTags() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        var t = this.allRows[i].userTags || [];
	        for (var j = 0; j < t.length; j++) {
	          if (t[j]) set[t[j]] = true;
	        }
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    employmentTitles: function employmentTitles() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        if (this.allRows[i].employmentTitle) set[this.allRows[i].employmentTitle] = true;
	      }return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    organisations: function organisations() {
	      var set = {};
	      for (var i = 0; i < this.allRows.length; i++) {
	        if (this.allRows[i].organisation) set[this.allRows[i].organisation] = true;
	      }return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    filteredRows: function filteredRows() {
	      var _this = this;
	
	      return this.allRows.filter(function (row) {
	        if (_this.selectedPersonNames.length > 0 && _this.selectedPersonNames.indexOf(row.userName) === -1) return false;
	        if (_this.selectedUserTags.length > 0) {
	          var match = row.userTags && _this.selectedUserTags.some(function (t) {
	            return row.userTags.indexOf(t) > -1;
	          });
	          if (!match) return false;
	        }
	        if (_this.selectedEmploymentTitles.length > 0 && _this.selectedEmploymentTitles.indexOf(row.employmentTitle) === -1) return false;
	        if (_this.selectedOrganisations.length > 0 && _this.selectedOrganisations.indexOf(row.organisation) === -1) return false;
	        return true;
	      });
	    },
	    isAllFilteredSelected: function isAllFilteredSelected() {
	      var _this2 = this;
	
	      if (this.filteredRows.length === 0) return false;
	      return this.filteredRows.every(function (row) {
	        return _this2.selectedEmploymentIds.indexOf(row.employmentId) > -1;
	      });
	    },
	    groupedRows: function groupedRows() {
	      var groups = [];
	      var indexByUser = {};
	      for (var i = 0; i < this.filteredRows.length; i++) {
	        var row = this.filteredRows[i];
	        if (indexByUser[row.userId] === undefined) {
	          indexByUser[row.userId] = groups.length;
	          groups.push({ userId: row.userId, rows: [] });
	        }
	        groups[indexByUser[row.userId]].rows.push(row);
	      }
	      return groups;
	    },
	    employmentsById: function employmentsById() {
	      var map = {};
	      var list = this.$store.state.employments && this.$store.state.employments.employments || [];
	      for (var i = 0; i < list.length; i++) {
	        map[list[i].id] = list[i];
	      }return map;
	    },
	    absenceCodesByLoenart: function absenceCodesByLoenart() {
	      var map = {};
	      for (var i = 0; i < this.absenceCodes.length; i++) {
	        var code = this.absenceCodes[i];
	        if (code.loenart != null) map[String(parseInt(code.loenart, 10))] = code;
	      }
	      return map;
	    },
	    fravaerSorted: function fravaerSorted() {
	      var result = [];
	      for (var i = 0; i < this.fravaer.length; i++) {
	        var item = this.fravaer[i];
	        result.push((0, _assign2.default)({}, item, this.decorateFravaer(item), {
	          vKey: 'ey_' + item.id,
	          vDato: this.formatActivityDate(item),
	          can_delete: item.can_delete != null ? item.can_delete : item.state === 'draft'
	        }));
	      }
	
	      for (var _i = 0; _i < this.sdFravaer.length; _i++) {
	        var _item = this.sdFravaer[_i];
	        result.push((0, _assign2.default)({}, _item, this.decorateFravaer(_item), {
	          vKey: 'fv_' + _item.id,
	          isPeriod: true,
	          vDato: this.formatPeriod(_item),
	
	          dage: _item.dagdecimal != null ? Math.round(parseFloat(_item.dagdecimal) * 100) / 100 : null,
	          timer: null,
	          can_delete: _item['can_delete?'] != null ? _item['can_delete?'] : _item.state === 'draft'
	        }));
	      }
	      return result.sort(function (a, b) {
	        var av = a.created_at ? (0, _moment2.default)(a.created_at).valueOf() : 0;
	        var bv = b.created_at ? (0, _moment2.default)(b.created_at).valueOf() : 0;
	        return bv - av;
	      });
	    },
	    uniqueNames: function uniqueNames() {
	      var set = {};
	      for (var i = 0; i < this.fravaerSorted.length; i++) {
	        var name = this.fravaerSorted[i].vUserName || '';
	        if (name) set[name] = true;
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da', { sensitivity: 'base' });
	      });
	    },
	    uniqueAbsenceTypes: function uniqueAbsenceTypes() {
	      var set = {};
	      for (var i = 0; i < this.fravaerSorted.length; i++) {
	        var t = this.fravaerSorted[i].vAbsenceType || '';
	        if (t) set[t] = true;
	      }
	      return (0, _keys2.default)(set).sort(function (a, b) {
	        return a.localeCompare(b, 'da', { sensitivity: 'base' });
	      });
	    },
	    displayedRows: function displayedRows() {
	      var _this3 = this;
	
	      var rows = this.fravaerSorted.slice();
	      rows = rows.filter(function (x) {
	        return _this3.viewTab === 'sent' ? x.state === 'sent' : x.state !== 'sent';
	      });
	      if (this.selectedNames.length > 0) {
	        var chosen = {};
	        for (var i = 0; i < this.selectedNames.length; i++) {
	          chosen[this.selectedNames[i]] = true;
	        }rows = rows.filter(function (x) {
	          return chosen[x.vUserName || ''];
	        });
	      }
	      if (this.selectedAbsenceTypes.length > 0) {
	        var _chosen = {};
	        for (var _i2 = 0; _i2 < this.selectedAbsenceTypes.length; _i2++) {
	          _chosen[this.selectedAbsenceTypes[_i2]] = true;
	        }rows = rows.filter(function (x) {
	          return _chosen[x.vAbsenceType || ''];
	        });
	      }
	      return rows;
	    }
	  },
	  methods: {
	    createdByName: function createdByName(approvedBy) {
	      if (approvedBy == null) return '';
	      return this.usersById[approvedBy] || String(approvedBy);
	    },
	    decorateFravaer: function decorateFravaer(item) {
	      var employment = item.employment_id ? this.employmentsById[item.employment_id] : null;
	      var userId = employment && employment.user_id || item.user_id;
	      var vUserName = userId && this.usersById[userId] || (item.tjenestenummer ? String(item.tjenestenummer) : 'Ukendt');
	      var vEmploymentNumber = employment && employment.employment_number ? employment.employment_number + (employment.title ? ' - ' + employment.title : '') : item.tjenestenummer ? String(item.tjenestenummer) : 'Ukendt';
	      var code = item.loenart != null ? this.absenceCodesByLoenart[String(parseInt(item.loenart, 10))] : null;
	      var vAbsenceType = code ? code.loenart + ' - ' + code.title : item.loenart != null ? String(item.loenart) : '';
	      return {
	        vUserName: vUserName,
	        vEmploymentNumber: vEmploymentNumber,
	        vAbsenceType: vAbsenceType,
	        vCreatedAt: item.created_at ? (0, _moment2.default)(item.created_at).format('lll') : '',
	        vCreatedBy: this.createdByName(item.approved_by)
	      };
	    },
	    formatPeriod: function formatPeriod(item) {
	      if (!item.startdato) return '';
	      var start = (0, _moment2.default)(item.startdato).format('DD-MM-YYYY');
	      if (!item.slutdato) return start;
	      var slut = (0, _moment2.default)(item.slutdato);
	      if (slut.year() >= 9999) return start + ' - Åbenstående';
	      if (item.startdato === item.slutdato) return start;
	      return start + ' - ' + slut.format('DD-MM-YYYY');
	    },
	    onSelectViewTab: function onSelectViewTab(tab) {
	      this.viewTab = tab;
	      if (tab !== 'employments' && !this.isLoading) this.readFravaer();
	    },
	    togglePersonName: function togglePersonName(name) {
	      var idx = this.selectedPersonNames.indexOf(name);
	      if (idx > -1) this.selectedPersonNames.splice(idx, 1);else this.selectedPersonNames.push(name);
	    },
	    toggleUserTag: function toggleUserTag(tag) {
	      var idx = this.selectedUserTags.indexOf(tag);
	      if (idx > -1) this.selectedUserTags.splice(idx, 1);else this.selectedUserTags.push(tag);
	    },
	    toggleEmploymentTitle: function toggleEmploymentTitle(title) {
	      var idx = this.selectedEmploymentTitles.indexOf(title);
	      if (idx > -1) this.selectedEmploymentTitles.splice(idx, 1);else this.selectedEmploymentTitles.push(title);
	    },
	    toggleOrganisation: function toggleOrganisation(organisation) {
	      var idx = this.selectedOrganisations.indexOf(organisation);
	      if (idx > -1) this.selectedOrganisations.splice(idx, 1);else this.selectedOrganisations.push(organisation);
	    },
	    toggleName: function toggleName(name) {
	      var idx = this.selectedNames.indexOf(name);
	      if (idx > -1) this.selectedNames.splice(idx, 1);else this.selectedNames.push(name);
	    },
	    toggleAbsenceType: function toggleAbsenceType(type) {
	      var idx = this.selectedAbsenceTypes.indexOf(type);
	      if (idx > -1) this.selectedAbsenceTypes.splice(idx, 1);else this.selectedAbsenceTypes.push(type);
	    },
	    isRowSelected: function isRowSelected(row) {
	      return this.selectedEmploymentIds.indexOf(row.employmentId) > -1;
	    },
	    toggleSelection: function toggleSelection(row) {
	      var idx = this.selectedEmploymentIds.indexOf(row.employmentId);
	      if (idx > -1) this.selectedEmploymentIds.splice(idx, 1);else this.selectedEmploymentIds.push(row.employmentId);
	    },
	    toggleAllSelected: function toggleAllSelected() {
	      this.isBatchMode = true;
	      var visibleIds = this.filteredRows.map(function (row) {
	        return row.employmentId;
	      });
	      if (this.isAllFilteredSelected) {
	        this.selectedEmploymentIds = this.selectedEmploymentIds.filter(function (id) {
	          return visibleIds.indexOf(id) === -1;
	        });
	      } else {
	        var set = {};
	        for (var i = 0; i < this.selectedEmploymentIds.length; i++) {
	          set[this.selectedEmploymentIds[i]] = true;
	        }for (var _i3 = 0; _i3 < visibleIds.length; _i3++) {
	          set[visibleIds[_i3]] = true;
	        }this.selectedEmploymentIds = (0, _keys2.default)(set).map(function (id) {
	          return parseInt(id, 10);
	        });
	      }
	    },
	    cancelBatchMode: function cancelBatchMode() {
	      this.isBatchMode = false;
	      this.selectedEmploymentIds = [];
	    },
	    onRowClick: function onRowClick(row) {
	      if (this.isBatchMode) this.toggleSelection(row);else this.openSingleCreate(row);
	    },
	    onCheckboxClick: function onCheckboxClick(row) {
	      if (!this.isBatchMode) this.isBatchMode = true;
	      this.toggleSelection(row);
	    },
	    openSingleCreate: function openSingleCreate(row) {
	      this.createEmploymentIds = [row.employmentId];
	      this.createSubtitle = row.userName + ' – ' + row.employmentNumber + ' - ' + row.employmentTitle;
	    },
	    openAutomaticIndberetning: function openAutomaticIndberetning() {
	      this.isAutoFravaerOpen = true;
	    },
	    onAutoFravaerCreated: function onAutoFravaerCreated(createdFravaer) {
	      this.isAutoFravaerOpen = false;
	      if (createdFravaer && createdFravaer.length > 0) {
	        this.viewTab = 'outbox';
	        this.readFravaer();
	      }
	    },
	    openBulkCreate: function openBulkCreate() {
	      if (this.selectedEmploymentIds.length === 0) return;
	      this.createEmploymentIds = this.selectedEmploymentIds.slice();
	      this.createSubtitle = '';
	    },
	    closeCreate: function closeCreate() {
	      this.createEmploymentIds = [];
	      this.createSubtitle = '';
	    },
	    onCreated: function onCreated() {
	      this.closeCreate();
	      this.cancelBatchMode();
	      this.viewTab = 'outbox';
	      this.readFravaer();
	    },
	    deleteRow: function deleteRow(item) {
	      if (item.id == null || this.deletingIds.includes(item.vKey)) return;
	      this.deleteCandidate = item;
	    },
	    confirmDeleteRow: function confirmDeleteRow() {
	      var _this4 = this;
	
	      var item = this.deleteCandidate;
	      if (!item || this.deletingIds.includes(item.vKey)) return;
	      this.deletingIds.push(item.vKey);
	      var success = function success() {
	        _this4.deletingIds = _this4.deletingIds.filter(function (key) {
	          return key !== item.vKey;
	        });
	        if (item.isPeriod) {
	          _this4.sdFravaer = _this4.sdFravaer.filter(function (r) {
	            return r.id !== item.id;
	          });
	        } else {
	          _this4.fravaer = _this4.fravaer.filter(function (r) {
	            return r.id !== item.id;
	          });
	        }
	        _this4.deleteCandidate = null;
	        _eventbus2.default.toast = { text: 'Fraværsindberetningen blev slettet fra udbakken', success: true, position: 'bottomLeft' };
	      };
	      var failure = function failure(error) {
	        console.log('delete failure', error);
	        _this4.deletingIds = _this4.deletingIds.filter(function (key) {
	          return key !== item.vKey;
	        });
	        _this4.deleteCandidate = null;
	        _eventbus2.default.toast = { text: 'Kunne ikke slette fraværsindberetningen', success: false, position: 'bottomLeft' };
	      };
	      if (item.isPeriod) {
	        _docendo2.default.deleteSilkeborgDataFravaer(this.schoolId, item.id, success, failure);
	      } else {
	        _docendo2.default.deleteSilkeborgDataEngangsydelse(this.schoolId, item.id, 'fravaer', success, failure);
	      }
	    },
	    formatActivityDate: function formatActivityDate(item) {
	      if (item.aar == null || item.maaned == null || item.dag == null) return '';
	      var year = 2000 + parseInt(item.aar, 10);
	      return (0, _moment2.default)({ year: year, month: parseInt(item.maaned, 10) - 1, day: parseInt(item.dag, 10) }).format('DD-MM-YYYY');
	    },
	    formatDecimal: function formatDecimal(value) {
	      if (value == null || value === '') return '';
	      return String(value).replace('.', ',');
	    },
	    stateLabel: function stateLabel(state) {
	      switch (state) {
	        case 'draft':
	          return 'I udbakke';
	        case 'sending':
	          return 'Sender';
	        case 'sent':
	          return 'Sendt';
	        default:
	          return state || '';
	      }
	    },
	    readFravaer: function readFravaer() {
	      var _this5 = this;
	
	      this.isLoading = true;
	      var pending = 2;
	      var done = function done() {
	        pending--;
	        if (pending === 0) _this5.isLoading = false;
	      };
	      _docendo2.default.listSilkeborgDataEngangsydelser(this.schoolId, 'fravaer', function (success) {
	        if (success && success.status && success.status === 'error') {
	          _this5.isNoConfiguration = true;
	        }
	        if (Array.isArray(success)) {
	          _this5.fravaer = success;
	        } else if (success && Array.isArray(success.data)) {
	          _this5.fravaer = success.data;
	        } else {
	          _this5.fravaer = [];
	        }
	        done();
	      }, function (failure) {
	        console.log(failure);
	        _this5.fravaer = [];
	        if (failure && failure.status && failure.status === 'error') {
	          _this5.isNoConfiguration = true;
	        }
	        done();
	      });
	
	      _docendo2.default.listSilkeborgDataFravaer(this.schoolId, (0, _moment2.default)().subtract(1, 'year').format('YYYY-MM-DD'), (0, _moment2.default)().add(1, 'year').format('YYYY-MM-DD'), function (success) {
	        _this5.sdFravaer = Array.isArray(success) ? success : success && Array.isArray(success.data) ? success.data : [];
	        done();
	      }, function (failure) {
	        console.log(failure);
	        _this5.sdFravaer = [];
	        done();
	      });
	    },
	    readAbsenceCodes: function readAbsenceCodes() {
	      var _this6 = this;
	
	      _docendo2.default.listSilkeborgDataAbsenceCodes(this.schoolId, function (success) {
	        _this6.absenceCodes = Array.isArray(success) ? success : success && Array.isArray(success.data) ? success.data : [];
	      }, function (failure) {
	        console.log(failure);
	        _this6.absenceCodes = [];
	      });
	    }
	  },
	  watch: {
	    selectedEmploymentIds: function selectedEmploymentIds(ids) {
	      if (!ids || ids.length === 0) this.isBatchMode = false;
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('getUsersFromSchoolId', this.schoolId);
	    this.$store.dispatch('readEmployments');
	    this.readAbsenceCodes();
	    this.readFravaer();
	  }
	};

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(32);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _set = __webpack_require__(27);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SalarySettingsUsersOpus = __webpack_require__(141);
	
	var _SalarySettingsUsersOpus2 = _interopRequireDefault(_SalarySettingsUsersOpus);
	
	var _EmploymentImportModal = __webpack_require__(376);
	
	var _EmploymentImportModal2 = _interopRequireDefault(_EmploymentImportModal);
	
	var _SalaryOrganisationsModal = __webpack_require__(377);
	
	var _SalaryOrganisationsModal2 = _interopRequireDefault(_SalaryOrganisationsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SalarySettingsUsersOpus: _SalarySettingsUsersOpus2.default,
	    EmploymentImportModal: _EmploymentImportModal2.default,
	    SalaryOrganisationsModal: _SalaryOrganisationsModal2.default
	  },
	  data: function data() {
	    return {
	      theImportUser: null,
	      isOrganisationsModal: false
	    };
	  },
	
	  methods: {
	    openImport: function openImport(user) {
	      if (user) {
	        this.theImportUser = user;
	      }
	    }
	  },
	  computed: {
	    isOrganisationsEnabled: function isOrganisationsEnabled() {
	      var user = this.$store.state.user;
	      if (!user || !user.admin) {
	        return false;
	      }
	      return true;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    employments: function employments() {
	      var all = this.$store.state.employments && this.$store.state.employments.employments ? this.$store.state.employments.employments : [];
	      return all.filter(function (employment) {
	        return !employment.deleted;
	      });
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash;
	    },
	    usersWithEmployments: function usersWithEmployments() {
	      var _this = this;
	
	      return this.users.map(function (user) {
	        var userEmployments = _this.employmentsInUserIdHash[user.id] ? _this.employmentsInUserIdHash[user.id] : [];
	        var employmentsSorted = userEmployments.filter(function (employment) {
	          return !employment.deleted;
	        }).sort(function (a, b) {
	          var aTitle = a && (a.source_title || a.title) ? a.source_title || a.title : '';
	          var bTitle = b && (b.source_title || b.title) ? b.source_title || b.title : '';
	          return aTitle.localeCompare(bTitle, 'da-DK');
	        });
	        return (0, _extends3.default)({}, user, {
	          v_employments: employmentsSorted
	        });
	      });
	    },
	    tags: function tags() {
	      var tagSet = new _set2.default();
	      this.users.forEach(function (user) {
	        if (user.user_tags && Array.isArray(user.user_tags)) {
	          user.user_tags.forEach(function (tag) {
	            return tagSet.add(tag);
	          });
	        }
	      });
	      return (0, _from2.default)(tagSet).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('getUsersFromSchoolId', this.$store.getters.schoolId);
	    this.$store.dispatch('readEmployments');
	  }
	};

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    whiteTheme: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    schoolYears: function schoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    }
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear(val) {
	      this.$emit('yearChange', val);
	    }
	  },
	  methods: {
	    setActiveSchoolYear: function setActiveSchoolYear(schoolYearId) {
	      this.$store.commit('setlocalActivatedSchoolYear', schoolYearId);
	    }
	  }
	};

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _StepDoughnut = __webpack_require__(334);
	
	var _StepDoughnut2 = _interopRequireDefault(_StepDoughnut);
	
	var _DashboardBox = __webpack_require__(1596);
	
	var _DashboardBox2 = _interopRequireDefault(_DashboardBox);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _VacationDaysSelector = __webpack_require__(153);
	
	var _VacationDaysSelector2 = _interopRequireDefault(_VacationDaysSelector);
	
	var _IEAndEdgeWarning = __webpack_require__(414);
	
	var _IEAndEdgeWarning2 = _interopRequireDefault(_IEAndEdgeWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { doughnut: _StepDoughnut2.default, dashboardBox: _DashboardBox2.default, vacationDaySelector: _VacationDaysSelector2.default, isIEOrEdge: _IEAndEdgeWarning2.default },
	  computed: {
	    showSetupWidget: function showSetupWidget() {
	      return _eventbus2.default.showSetupWidget;
	    },
	    schoolYear: function schoolYear() {
	      return this.$store.state.selectedSchoolYear;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    klassCals: function klassCals() {
	      return this.$store.getters.klassCalendars;
	    },
	    userCals: function userCals() {
	      return this.$store.getters.userCalendars;
	    },
	    roomCals: function roomCals() {
	      return this.$store.getters.roomCalendars;
	    },
	    mergeCals: function mergeCals() {
	      return this.$store.getters.mergeCalendars;
	    },
	    steps: function steps() {
	      if (this.country === 'dk') {
	        return this.stepsDK;
	      } else if (this.country === 'no') {
	        return this.stepsNO;
	      } else {
	        return this.stepsEN;
	      }
	    },
	    howManyDone: function howManyDone() {
	      var doneSteps = this.steps.filter(function (obj) {
	        return obj.done === true;
	      });
	      return doneSteps.length;
	    }
	  },
	  watch: {
	    userSettings: function userSettings() {
	      var obj = this.userSettings;
	      this.progressed = (0, _keys2.default)(obj).filter(function (key) {
	        return key.startsWith('setup_widget_progress');
	      });
	      this.checkProgress();
	    },
	    klassCals: function klassCals(val) {
	      this.setNumberOfCals('setup_widget_progress_klass', val.length);
	    },
	    userCals: function userCals(val) {
	      this.setNumberOfCals('setup_widget_progress_users', val.length);
	    },
	    roomCals: function roomCals(val) {
	      this.setNumberOfCals('setup_widget_progress_rooms', val.length);
	    },
	    mergeCals: function mergeCals(val) {
	      this.setNumberOfCals('setup_widget_progress_merge', val.length);
	    }
	  },
	  data: function data() {
	    var _this = this;
	
	    return {
	      schoolId: 0,
	      userName: '',
	      schoolName: '',
	      isOnboarding: false,
	      progressed: [],
	      showSlideUp: false,
	      country: 'EN',
	      showTutorial: false,
	      videoId: '5gjODdkqRDI',
	      videoVars: {
	        autoplay: 0,
	        modestbranding: 1,
	        rel: 0 },
	      stepsDK: [{
	        title: 'Klasser',
	        icon: 'icon-calendar4',
	        buttonText: '+ Opret klasser',
	        guide: 'https://www.youtube.com/watch?v=5gjODdkqRDI&feature=youtu.be',
	        videoid: '5gjODdkqRDI',
	        guideDuration: '1:01',
	        dbName: 'setup_widget_progress_klass',
	        done: false,
	        stepNum: 1,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createKlassModal = true;
	        }
	      }, {
	        title: 'Undervisere',
	        icon: 'icon-users',
	        buttonText: '+ Opret undervisere',
	        guide: 'https://www.youtube.com/watch?v=YtujiFzH50A&feature=youtu.be',
	        videoid: 'YtujiFzH50A',
	        guideDuration: '0:41',
	        dbName: 'setup_widget_progress_users',
	        done: false,
	        stepNum: 2,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createUserModal = true;
	        }
	      }, {
	        title: 'Lokaler',
	        icon: 'icon-location',
	        buttonText: '+ Opret lokaler',
	        guide: 'https://www.youtube.com/watch?v=2XQjHWLvyrM&feature=youtu.be',
	        videoid: '2XQjHWLvyrM',
	        guideDuration: '0:39',
	        dbName: 'setup_widget_progress_rooms',
	        done: false,
	        stepNum: 3,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createCalendarsType = 'merge';
	        }
	      }, {
	        title: 'Skoledage',
	        icon: 'icon-calendar2',
	        guide: 'https://www.youtube.com/watch?v=0XB5A0xr-N0&feature=youtu.be',
	        videoid: '0XB5A0xr-N0',
	        guideDuration: '0:39',
	        buttonText: 'Vælg feriedage',
	        dbName: 'setup_widget_progress_vacation',
	        done: false,
	        stepNum: 4,
	        number: 0,
	        action: function action() {
	          _this.$store.dispatch('updateUserSettings', { 'setup_widget_progress_vacation': true });
	          if (window.Intercom) {
	            window.Intercom('trackEvent', 'Visited Holiday Calendar');
	          }
	          _this.setShowSlideUp('true');
	        }
	      }, {
	        title: 'Fletteskemaer',
	        icon: '',
	        guide: 'https://www.youtube.com/watch?time_continue=2&v=VNt1m80YEsI',
	        videoid: 'VNt1m80YEsI',
	        guideDuration: '0:39',
	        buttonText: '+ Opret fletteskemaer',
	        dbName: 'setup_widget_progress_merge',
	        done: false,
	        stepNum: 5,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createCalendarsType = 'merge';
	        }
	      }, {
	        title: 'Skemalægning i klasser',
	        icon: '',
	        guide: 'https://www.youtube.com/watch?v=7NR8_EygcoM&feature=youtu.be',
	        videoid: '7NR8_EygcoM',
	        guideDuration: '2:25',
	        dbName: 'setup_widget_progress_scheduling',
	        done: false,
	        stepNum: 6,
	        desc: 'Når du har oprettet klasser, undervisere og fag, så er du klar til at lægge skemaer for klasserne.',
	        uniClass: 'text-left'
	      }],
	      stepsNO: [{
	        title: 'Klasser',
	        icon: 'icon-calendar4',
	        buttonText: '+ Opprett klasser',
	        guide: 'https://www.youtube.com/watch?v=P9lc_0-64kc&feature=youtu.be',
	        videoid: 'P9lc_0-64kc',
	        guideDuration: '0:36',
	        dbName: 'setup_widget_progress_klass',
	        done: false,
	        stepNum: 1,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createKlassModal = true;
	        }
	      }, {
	        title: 'Lærere',
	        icon: 'icon-users',
	        buttonText: '+ Opprett lærere',
	        guide: 'https://www.youtube.com/watch?v=X-w0i3MFeL4&feature=youtu.be',
	        videoid: 'X-w0i3MFeL4',
	        guideDuration: '0:44',
	        dbName: 'setup_widget_progress_users',
	        done: false,
	        stepNum: 2,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createUserModal = true;
	        }
	      }, {
	        title: 'Lokaler',
	        icon: 'icon-location',
	        buttonText: '+ Opprett lokaler',
	        guide: 'https://www.youtube.com/watch?v=8FoyUOiwdPk&feature=youtu.be',
	        videoid: '8FoyUOiwdPk',
	        guideDuration: '0:37',
	        dbName: 'setup_widget_progress_rooms',
	        done: false,
	        stepNum: 3,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createCalendarsType = 'merge';
	        }
	      }, {
	        title: 'Skoledager',
	        icon: 'icon-calendar2',
	        guide: 'https://www.youtube.com/watch?v=KmLDUVlzhXA&feature=youtu.be',
	        videoid: 'KmLDUVlzhXA',
	        guideDuration: '0:39',
	        buttonText: 'Legg inn fridager',
	        dbName: 'setup_widget_progress_vacation',
	        done: false,
	        stepNum: 4,
	        number: 0,
	        action: function action() {
	          _this.$store.dispatch('updateUserSettings', { 'setup_widget_progress_vacation': true });
	          _this.setShowSlideUp('true');
	        }
	      }, {
	        title: 'Fellestimeplaner',
	        icon: '',
	        guide: 'https://www.youtube.com/watch?v=39daX1u0238&feature=youtu.be',
	        videoid: '39daX1u0238',
	        guideDuration: '2:09',
	        buttonText: '+ Opprett fellestimeplaner',
	        dbName: 'setup_widget_progress_merge',
	        done: false,
	        stepNum: 5,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createCalendarsType = 'merge';
	        }
	      }, {
	        title: 'Timeplanlegging i klasser',
	        icon: '',
	        guide: 'https://www.youtube.com/watch?v=s6b7b07ZHl0&feature=youtu.be',
	        videoid: 's6b7b07ZHl0',
	        guideDuration: '2:25',
	        dbName: 'setup_widget_progress_scheduling',
	        done: false,
	        stepNum: 6,
	        desc: 'Du må opprette klasser, lærere og fag før du kan lage timeplaner.',
	        uniClass: 'text-left'
	      }],
	      stepsEN: [{
	        title: 'Classes',
	        icon: 'icon-calendar4',
	        buttonText: '+ Create Classes',
	        guide: 'https://youtu.be/WdXydJxGFpI',
	        videoid: 'WdXydJxGFpI',
	        guideDuration: '0:52',
	        dbName: 'setup_widget_progress_klass',
	        done: false,
	        stepNum: 1,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createKlassModal = true;
	        }
	      }, {
	        title: 'Teachers',
	        icon: 'icon-users',
	        buttonText: '+ Create teachers',
	        guide: 'https://youtu.be/D83kXuPIZzE',
	        videoid: 'D83kXuPIZzE',
	        guideDuration: '0:43',
	        dbName: 'setup_widget_progress_users',
	        done: false,
	        stepNum: 2,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createUserModal = true;
	        }
	      }, {
	        title: 'Classrooms',
	        icon: 'icon-location',
	        buttonText: '+ Create classrooms',
	        guide: 'https://youtu.be/UBI-WnWOtdQ',
	        videoid: 'UBI-WnWOtdQ',
	        guideDuration: '1:01',
	        dbName: 'setup_widget_progress_rooms',
	        done: false,
	        stepNum: 3,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createCalendarsType = 'merge';
	        }
	      }, {
	        title: 'School days',
	        icon: 'icon-calendar2',
	        guide: 'https://youtu.be/CkUvNQQgMoQ',
	        videoid: 'CkUvNQQgMoQ',
	        guideDuration: '0:36',
	        buttonText: 'Choose holidays',
	        dbName: 'setup_widget_progress_vacation',
	        done: false,
	        stepNum: 4,
	        number: 0,
	        action: function action() {
	          _this.$store.dispatch('updateUserSettings', { 'setup_widget_progress_vacation': true });
	          if (window.Intercom) {
	            window.Intercom('trackEvent', 'Visited Holiday Calendar');
	          }
	          _this.setShowSlideUp('true');
	        }
	      }, {
	        title: 'Shared calendar',
	        icon: '',
	        guide: 'https://youtu.be/aIvpXbHwYeA',
	        videoid: 'aIvpXbHwYeA',
	        guideDuration: '2:56',
	        buttonText: '+ Create breaks',
	        dbName: 'setup_widget_progress_merge',
	        done: false,
	        stepNum: 5,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createCalendarsType = 'merge';
	        }
	      }, {
	        title: 'Subjects',
	        icon: '',
	        guide: 'https://youtu.be/EpEfabVl7yw',
	        videoid: 'EpEfabVl7yw',
	        guideDuration: '2:31',
	        buttonText: '',
	        dbName: 'setup_widget_progress_subjects',
	        done: false,
	        desc: 'Go to classes to create subjects for that specific class',
	        stepNum: 6,
	        uniClass: 'text-left'
	      }, {
	        title: 'Start scheduling',
	        icon: '',
	        guide: 'https://youtu.be/UXZpf-wAh-U',
	        videoid: 'UXZpf-wAh-U',
	        guideDuration: '3:31',
	        dbName: 'setup_widget_progress_scheduling',
	        done: false,
	        stepNum: 7,
	        desc: 'You have to create classes, teachers and subjects before you can schedule a class',
	        uniClass: 'text-left'
	      }]
	    };
	  },
	
	  methods: {
	    openSetupWidget: function openSetupWidget() {
	      _eventbus2.default.showSetupWidget = true;
	    },
	    checkProgress: function checkProgress() {
	      for (var i = 0; i < this.progressed.length; i++) {
	        for (var j = 0; j < this.steps.length; j++) {
	          if (this.steps[j].dbName === this.progressed[i]) {
	            this.steps[j].done = true;
	          }
	        }
	      }
	    },
	    findStepIndex: function findStepIndex(dbName) {
	      return this.steps.map(function (step) {
	        return step.dbName;
	      }).indexOf(dbName);
	    },
	    setNumberOfCals: function setNumberOfCals(dbName, number) {
	      this.steps[this.findStepIndex(dbName)].number = number;
	    },
	    setSchoolDays: function setSchoolDays(days) {
	      this.setNumberOfCals('setup_widget_progress_vacation', days);
	    },
	    setShowSlideUp: function setShowSlideUp(boolean) {
	      if (boolean) {
	        this.showSlideUp = true;
	      } else {
	        this.showSlideUp = false;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.userName = window.USER.name;
	    this.schoolName = window.SCHOOL.name;
	    this.schoolId = window.SCHOOL.id;
	    this.country = window.SCHOOL.country.toLowerCase();
	    if (window.SCHOOL.state && window.SCHOOL.state === 'demo') {
	      this.isOnboarding = true;
	    }
	  }
	};

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Spinner = __webpack_require__(26);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { spinner: _Spinner2.default },
	  props: {
	    isOnboarding: {
	      type: Boolean,
	      default: false
	    },
	    step: {
	      default: {
	        title: 'Classes',
	        icon: 'icon-calendar4',
	        buttonText: '+ Create Classes',
	        guide: 'https://youtu.be/WdXydJxGFpI',
	        videoid: 'UXZpf-wAh-U',
	        guideDuration: '0:52',
	        dbName: 'setup_widget_progress_klass',
	        done: false,
	        stepNum: 1
	      }
	    }
	  },
	  computed: {
	    isSchoolFromNorway: function isSchoolFromNorway() {
	      return window.SCHOOL.country.toLowerCase() === 'no';
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    }
	  },
	  methods: {
	    seeTutorial: function seeTutorial(step) {
	      _eventbus2.default.youTubeVideoId = step.videoid;
	      _eventbus2.default.isOpenYouTubePopup = true;
	      this.$emit('tutorial', step);
	      if (window.Intercom) {
	        window.Intercom('trackEvent', 'Watched tutorial Video planning: ' + step.title);
	      }
	    }
	  }
	};

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    isOpenModal: {
	      type: Boolean,
	      default: false
	    },
	    isForImportInZEN: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      inputDuration: 0,
	      isButtonLoading: false
	    };
	  },
	
	  computed: {
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    originalDuration: function originalDuration() {
	      if (this.activeSchool && this.activeSchool.subject_default_duration) {
	        return this.activeSchool.subject_default_duration;
	      }
	    },
	    isAValidDuration: function isAValidDuration() {
	      return (/^-?[\d.]+(?:e-?\d+)?$/.test(this.inputDuration) && this.inputDuration > 0 && this.inputDuration < 1440 && this.inputDuration % 5 === 0
	      );
	    }
	  },
	  watch: {
	    isOpenModal: function isOpenModal(val) {
	      if (val) {
	        this.openModal();
	      } else {
	        this.closeModal();
	      }
	    }
	  },
	  methods: {
	    selectAllOnFocus: function selectAllOnFocus(evt) {
	      setTimeout(function (_) {
	        evt.target.select();
	      }, 0);
	    },
	    openModal: function openModal() {
	      var _this = this;
	
	      this.inputDuration = this.originalDuration;
	      this.$nextTick(function (_) {
	        _this.$refs.duration_input.focus();
	      });
	    },
	    closeModal: function closeModal() {
	      this.$emit('close');
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      this.isButtonLoading = true;
	      var updates = { subject_default_duration: this.inputDuration };
	      _docendo2.default.updateSchool(window.SCHOOL.id, updates, function (success) {
	        _this2.$store.commit('updateActiveSchoolDuration', success.subject_default_duration);
	        _this2.$emit('close');
	        _this2.$emit('submit');
	        _this2.isButtonLoading = false;
	      }, function (failure) {
	        console.log('failed');
	      });
	    }
	  }
	};

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _SchoolDataGrade = __webpack_require__(1602);
	
	var _SchoolDataGrade2 = _interopRequireDefault(_SchoolDataGrade);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _schoolDataMixin = __webpack_require__(71);
	
	var _schoolDataMixin2 = _interopRequireDefault(_schoolDataMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Datepickerrange: _DatePickerRange2.default, Loader: _Loader2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, SchoolDataGrade: _SchoolDataGrade2.default },
	  mixins: [_schoolDataMixin2.default],
	  computed: {
	    calendars: function calendars() {
	      return this.$store.state.calendars;
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    clubCalendars: function clubCalendars() {
	      return this.$store.getters.clubCalendars;
	    },
	    klassCalendars: function klassCalendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    filteredCalendars: function filteredCalendars() {
	      var klassCalendars = this.klassCalendars || [];
	      var clubCalendars = this.clubCalendars || [];
	      return klassCalendars.concat(clubCalendars);
	    },
	    reportCalendars: function reportCalendars() {
	      return this.filteredCalendars;
	    },
	    eventsInHash: function eventsInHash() {
	      var eventsInHash = {};
	      this.eventsInRange.forEach(function (event, idx) {
	        event.calendars.forEach(function (calendarEvent) {
	          var calId = calendarEvent.calendar_id;
	          var durationInMinutes = (0, _moment2.default)(event.end).diff((0, _moment2.default)(event.start), 'minutes');
	          event.v_duration = durationInMinutes;
	          if (calendarEvent.substitute) {
	            event.v_has_substitute = true;
	          }
	          if (!eventsInHash[calId]) {
	            eventsInHash[calId] = [event];
	          } else {
	            eventsInHash[calId].push(event);
	          }
	        });
	      });
	      return eventsInHash;
	    }
	  }
	};

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _freeze = __webpack_require__(86);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _LineChart = __webpack_require__(427);
	
	var _LineChart2 = _interopRequireDefault(_LineChart);
	
	var _schoolDataMixin = __webpack_require__(71);
	
	var _schoolDataMixin2 = _interopRequireDefault(_schoolDataMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Datepickerrange: _DatePickerRange2.default, Loader: _Loader2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, LineChart: _LineChart2.default },
	  mixins: [_schoolDataMixin2.default],
	  data: function data() {
	    return {
	      reportEventTypeFilter: ['absence'],
	      showHidden: false,
	      hiddenAbsence: [],
	      isComparing: false,
	      isLoadingPreviousYear: false,
	      previousYearEvents: [],
	      previousYearLoadedFor: null,
	      chartOptions: {
	        responsive: true,
	        maintainAspectRatio: false,
	        scales: {
	          yAxes: [{ ticks: { beginAtZero: true } }]
	        }
	      }
	    };
	  },
	
	  computed: {
	    absenceEvents: function absenceEvents() {
	      return this.events.filter(function (event) {
	        return event.event_type === 'absence';
	      });
	    },
	    previousYearStart: function previousYearStart() {
	      return (0, _moment2.default)(this.startDate).subtract(1, 'year').format('YYYY-MM-DD');
	    },
	    previousYearEnd: function previousYearEnd() {
	      return (0, _moment2.default)(this.endDate).subtract(1, 'year').format('YYYY-MM-DD');
	    },
	    comparisonChartData: function comparisonChartData() {
	      var current = this.countVisibleAbsencePerMonth(this.absenceEvents, this.startDate);
	      var previous = this.countVisibleAbsencePerMonth(this.previousYearEvents, this.previousYearStart);
	      return {
	        labels: current.map(function (month) {
	          return month.label;
	        }),
	        datasets: [{
	          label: 'Valgte periode',
	          data: current.map(function (month) {
	            return month.count;
	          }),
	          borderColor: '#3b82f6',
	          backgroundColor: 'rgba(59, 130, 246, 0.1)',
	          fill: false
	        }, {
	          label: 'Året før',
	          data: previous.map(function (month) {
	            return month.count;
	          }),
	          borderColor: '#9ca3af',
	          backgroundColor: 'rgba(156, 163, 175, 0.1)',
	          borderDash: [5, 5],
	          fill: false
	        }]
	      };
	    },
	    absenceTypes: function absenceTypes() {
	      var obj = this.restructuredAbsenceData.length > 0 ? this.restructuredAbsenceData[0] : {};
	      var arr = (0, _keys2.default)(obj).filter(function (key) {
	        return key !== 'month';
	      }).sort(function (a, b) {
	        return a.localeCompare(b);
	      });
	      return arr;
	    },
	    visibleAbsenceTypes: function visibleAbsenceTypes() {
	      var _this = this;
	
	      return this.absenceTypes.filter(function (type) {
	        return _this.hiddenAbsence.indexOf(type) < 0;
	      });
	    },
	    hiddenAbsenceTypes: function hiddenAbsenceTypes() {
	      var _this2 = this;
	
	      return this.absenceTypes.filter(function (type) {
	        return _this2.hiddenAbsence.indexOf(type) > -1;
	      });
	    },
	    restructuredAbsenceData: function restructuredAbsenceData() {
	      var start = (0, _moment2.default)(this.startDate);
	      var end = (0, _moment2.default)(this.endDate);
	
	      var restructuredData = [];
	
	      var absenceTypes = {};
	
	      while (start.isSameOrBefore(end)) {
	        restructuredData.push({
	          month: start.format('MMM YYYY')
	        });
	        start.add(1, 'month');
	      }
	
	      this.absenceEvents.forEach(function (event) {
	        var eventDate = (0, _moment2.default)(event.start);
	        var monthIndex = restructuredData.findIndex(function (data) {
	          return data.month === eventDate.format('MMM YYYY');
	        });
	
	        if (monthIndex !== -1) {
	          var absenceType = event.title;
	
	          if (!absenceTypes[absenceType]) {
	            absenceTypes[absenceType] = true;
	            restructuredData.forEach(function (data) {
	              data[absenceType] = 0;
	            });
	          }
	
	          restructuredData[monthIndex][absenceType]++;
	        }
	      });
	
	      return restructuredData;
	    }
	  },
	  methods: {
	    toggleHiddenAbsence: function toggleHiddenAbsence(type) {
	      var idx = this.hiddenAbsence.indexOf(type);
	      if (idx < 0) {
	        this.hiddenAbsence.push(type);
	      } else {
	        this.hiddenAbsence.splice(idx, 1);
	      }
	      this.$helpers.setLocalStorage('d_hidden_absence', (0, _stringify2.default)(this.hiddenAbsence));
	    },
	    readPreviousYearEvents: function readPreviousYearEvents() {
	      var _this3 = this;
	
	      var period = this.previousYearStart + '|' + this.previousYearEnd;
	      if (!this.isComparing || this.previousYearLoadedFor === period) {
	        return;
	      }
	      var calendarIds = this.reportCalendars.map(function (calendar) {
	        return calendar.id;
	      });
	      if (calendarIds.length < 1) {
	        return;
	      }
	      this.previousYearLoadedFor = period;
	      this.isLoadingPreviousYear = true;
	      this.fetchEvents(calendarIds, this.previousYearStart, this.previousYearEnd, ['absence'], function (events) {
	        if (_this3.previousYearLoadedFor !== period) {
	          return;
	        }
	        _this3.previousYearEvents = (0, _freeze2.default)(events);
	        _this3.isLoadingPreviousYear = false;
	      });
	    },
	    countVisibleAbsencePerMonth: function countVisibleAbsencePerMonth(events, startDate) {
	      var _this4 = this;
	
	      var months = [];
	      var month = (0, _moment2.default)(startDate).startOf('month');
	      var monthCount = (0, _moment2.default)(this.endDate).startOf('month').diff((0, _moment2.default)(this.startDate).startOf('month'), 'months');
	      var lastMonth = (0, _moment2.default)(startDate).startOf('month').add(monthCount, 'months');
	      while (month.isSameOrBefore(lastMonth, 'month')) {
	        months.push({ key: month.format('YYYY-MM'), label: month.format('MMM'), count: 0 });
	        month.add(1, 'month');
	      }
	      events.forEach(function (event) {
	        if (_this4.hiddenAbsence.indexOf(event.title) > -1) {
	          return;
	        }
	        var item = months.find(function (month) {
	          return month.key === (0, _moment2.default)(event.start).format('YYYY-MM');
	        });
	        if (item) {
	          item.count += 1;
	        }
	      });
	      return months;
	    }
	  },
	  watch: {
	    startDate: function startDate() {
	      this.readPreviousYearEvents();
	    },
	    endDate: function endDate() {
	      this.readPreviousYearEvents();
	    }
	  },
	  mounted: function mounted() {
	    var localVal = this.$helpers.getLocalStorage('d_hidden_absence');
	    if (localVal) {
	      this.hiddenAbsence = JSON.parse(localVal);
	    }
	  }
	};

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _values = __webpack_require__(33);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _schoolDataMixin = __webpack_require__(71);
	
	var _schoolDataMixin2 = _interopRequireDefault(_schoolDataMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BUCKETS = [{ id: '1', title: '1 dag', max: 1 }, { id: '2', title: '2 dage', max: 2 }, { id: '3-5', title: '3-5 dage', max: 5 }, { id: '6-10', title: '6-10 dage', max: 10 }, { id: '11-20', title: '11-20 dage', max: 20 }, { id: '21+', title: 'Over 20 dage', max: Infinity }];
	
	exports.default = {
	  components: { Datepickerrange: _DatePickerRange2.default, Loader: _Loader2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, DoFiltersFilter: _DoFiltersFilter2.default },
	  mixins: [_schoolDataMixin2.default],
	  data: function data() {
	    return {
	      reportEventTypeFilter: ['absence'],
	      selectedReasons: [],
	      buckets: BUCKETS
	    };
	  },
	
	  computed: {
	    absenceReasons: function absenceReasons() {
	      return this.absenceEventsInRange.map(function (event) {
	        return event.title;
	      }).filter(function (title, idx, arr) {
	        return arr.indexOf(title) === idx;
	      });
	    },
	    periods: function periods() {
	      var _this = this;
	
	      var datesByKey = {};
	      this.absenceEventsInRange.forEach(function (event) {
	        if (_this.selectedReasons.length > 0 && _this.selectedReasons.indexOf(event.title) < 0) {
	          return;
	        }
	        var key = event.calendar_id + '|' + event.title;
	        if (!datesByKey[key]) {
	          datesByKey[key] = { calendarId: event.calendar_id, reason: event.title, dates: {} };
	        }
	        _this.getWeekdays(event).forEach(function (date) {
	          datesByKey[key].dates[date] = true;
	        });
	      });
	      var periods = [];
	      (0, _values2.default)(datesByKey).forEach(function (group) {
	        var current = null;
	        (0, _keys2.default)(group.dates).sort().forEach(function (date) {
	          if (current && _this.nextWeekday(current.lastDate) === date) {
	            current.days += 1;
	            current.lastDate = date;
	          } else {
	            current = { calendarId: group.calendarId, reason: group.reason, days: 1, lastDate: date };
	            periods.push(current);
	          }
	        });
	      });
	      return periods;
	    },
	    rows: function rows() {
	      var _this2 = this;
	
	      var rowsByName = {};
	      var total = this.newRow('I alt', true);
	      this.periods.forEach(function (period) {
	        if (!rowsByName[period.reason]) {
	          rowsByName[period.reason] = _this2.newRow(period.reason, false);
	        }
	        _this2.addPeriod(rowsByName[period.reason], period);
	        _this2.addPeriod(total, period);
	      });
	      var rows = (0, _values2.default)(rowsByName).sort(function (a, b) {
	        return a.name.localeCompare(b.name, 'da');
	      }).concat([total]);
	      rows.forEach(function (row) {
	        row.persons = (0, _keys2.default)(row.persons).length;
	      });
	      return rows;
	    }
	  },
	  methods: {
	    newRow: function newRow(name, isTotal) {
	      var buckets = {};
	      BUCKETS.forEach(function (bucket) {
	        buckets[bucket.id] = 0;
	      });
	      return { name: name, isTotal: isTotal, buckets: buckets, periods: 0, days: 0, persons: {} };
	    },
	    addPeriod: function addPeriod(row, period) {
	      var bucket = BUCKETS.find(function (bucket) {
	        return period.days <= bucket.max;
	      });
	      row.buckets[bucket.id] += 1;
	      row.periods += 1;
	      row.days += period.days;
	      row.persons[period.calendarId] = true;
	    },
	    getWeekdays: function getWeekdays(event) {
	      var dates = [];
	      var day = (0, _moment2.default)(event.start).startOf('day');
	      var lastDay = (0, _moment2.default)(event.end).subtract(1, 'millisecond').startOf('day');
	      var rangeStart = (0, _moment2.default)(this.startDate).startOf('day');
	      var rangeEnd = (0, _moment2.default)(this.endDate).startOf('day');
	      while (day.isSameOrBefore(lastDay)) {
	        if (day.isoWeekday() < 6 && day.isSameOrAfter(rangeStart) && day.isSameOrBefore(rangeEnd)) {
	          dates.push(day.format('YYYY-MM-DD'));
	        }
	        day.add(1, 'day');
	      }
	      return dates;
	    },
	    nextWeekday: function nextWeekday(date) {
	      var day = (0, _moment2.default)(date).add(1, 'day');
	      while (day.isoWeekday() > 5) {
	        day.add(1, 'day');
	      }
	      return day.format('YYYY-MM-DD');
	    },
	    toggleReason: function toggleReason(reason) {
	      var idx = this.selectedReasons.indexOf(reason);
	      if (idx < 0) {
	        this.selectedReasons.push(reason);
	      } else {
	        this.selectedReasons.splice(idx, 1);
	      }
	    }
	  }
	};

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(33);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _SchoolDataCoverageTable = __webpack_require__(1601);
	
	var _SchoolDataCoverageTable2 = _interopRequireDefault(_SchoolDataCoverageTable);
	
	var _schoolDataMixin = __webpack_require__(71);
	
	var _schoolDataMixin2 = _interopRequireDefault(_schoolDataMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SCHOOL_TOTAL = 'Hele skolen';
	
	exports.default = {
	  components: { Datepickerrange: _DatePickerRange2.default, Loader: _Loader2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, Tabs: _Tabs2.default, SchoolDataCoverageTable: _SchoolDataCoverageTable2.default },
	  mixins: [_schoolDataMixin2.default],
	  data: function data() {
	    return {
	      viewMode: 'grades',
	      sortMode: 'name',
	      viewTabs: [{ id: 'grades', title: 'Skole og årgange' }, { id: 'klasses', title: 'Klasser' }, { id: 'subjects', title: 'Fag' }],
	      sortTabs: [{ id: 'name', title: 'Navn' }, { id: 'substitute', title: 'Flest vikartimer' }, { id: 'share', title: 'Højest andel vikar' }, { id: 'uncovered', title: 'Flest ikke dækkede' }]
	    };
	  },
	
	  computed: {
	    reportCalendars: function reportCalendars() {
	      var userCalendars = this.$store.getters.userCalendars || [];
	      var klassCalendars = this.$store.getters.klassCalendars || [];
	      var clubCalendars = this.$store.getters.clubCalendars || [];
	      return userCalendars.concat(klassCalendars, clubCalendars);
	    },
	    affectedByLessonId: function affectedByLessonId() {
	      var hash = {};
	      this.affectedLessons.forEach(function (item) {
	        hash[item.lesson.event_id] = item;
	      });
	      return hash;
	    },
	    gradeRows: function gradeRows() {
	      var _this = this;
	
	      var rows = this.aggregate(function (lesson) {
	        var grades = _this.getLessonKlasses(lesson).map(function (klass) {
	          return _this.getGradeName(klass.name);
	        });
	        return [SCHOOL_TOTAL].concat(grades);
	      });
	      return this.sortRows(rows, function (a, b) {
	        return _this.gradeNumber(a.name) - _this.gradeNumber(b.name);
	      });
	    },
	    klassRows: function klassRows() {
	      var _this2 = this;
	
	      var rows = this.aggregate(function (lesson) {
	        return _this2.getLessonKlasses(lesson).map(function (klass) {
	          return klass.name;
	        });
	      });
	      return this.sortRows(rows, function (a, b) {
	        return a.name.localeCompare(b.name, 'da', { numeric: true });
	      });
	    },
	    subjectRows: function subjectRows() {
	      var rows = this.aggregate(function (lesson) {
	        return [lesson.title || 'Uden titel'];
	      });
	      return this.sortRows(rows, function (a, b) {
	        return a.name.localeCompare(b.name, 'da');
	      });
	    }
	  },
	  methods: {
	    aggregate: function aggregate(getKeys) {
	      var _this3 = this;
	
	      var rowsByName = {};
	      this.lessonsInRange.forEach(function (lesson) {
	        var minutes = _this3.getLessonMinutes(lesson);
	        var affected = _this3.affectedByLessonId[lesson.event_id];
	        var keys = getKeys(lesson).filter(function (key, idx, arr) {
	          return arr.indexOf(key) === idx;
	        });
	        keys.forEach(function (key) {
	          if (!rowsByName[key]) {
	            rowsByName[key] = {
	              name: key,
	              isTotal: key === SCHOOL_TOTAL,
	              totalMinutes: 0,
	              affectedMinutes: 0,
	              substitute: 0,
	              coTeacher: 0,
	              canceled: 0,
	              away: 0,
	              uncovered: 0,
	              lessonsWithAbsence: 0,
	              lessonsWithNotes: 0
	            };
	          }
	          var row = rowsByName[key];
	          row.totalMinutes += minutes;
	          if (affected) {
	            row.affectedMinutes += minutes;
	            row[affected.coverage] += minutes;
	            if (affected.absentTeachers.length > 0) {
	              row.lessonsWithAbsence += 1;
	              if (affected.hasTeacherNotes) {
	                row.lessonsWithNotes += 1;
	              }
	            }
	          }
	        });
	      });
	      return (0, _values2.default)(rowsByName);
	    },
	    sortRows: function sortRows(rows, nameCompare) {
	      var _this4 = this;
	
	      var compare = {
	        name: nameCompare,
	        substitute: function substitute(a, b) {
	          return b.substitute - a.substitute;
	        },
	        share: function share(a, b) {
	          return _this4.share(b.substitute, b.totalMinutes) - _this4.share(a.substitute, a.totalMinutes);
	        },
	        uncovered: function uncovered(a, b) {
	          return b.uncovered - a.uncovered;
	        }
	      }[this.sortMode];
	      return rows.slice().sort(function (a, b) {
	        if (a.isTotal !== b.isTotal) {
	          return a.isTotal ? -1 : 1;
	        }
	        return compare(a, b);
	      });
	    },
	    share: function share(part, total) {
	      return total ? part / total : 0;
	    },
	    gradeNumber: function gradeNumber(name) {
	      var match = name.match(/^(\d+)/);
	      return match ? match[1] * 1 : 999;
	    }
	  }
	};

/***/ }),
/* 696 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    title: {
	      type: String,
	      default: ''
	    },
	    rows: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  methods: {
	    formatHours: function formatHours(minutes) {
	      return (minutes / 60).toFixed(1).replace('.', ',');
	    },
	    formatPercent: function formatPercent(part, total) {
	      if (!total) {
	        return '-';
	      }
	      return Math.round(part / total * 100) + ' %';
	    }
	  }
	};

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(33);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Tabs: _Tabs2.default
	  },
	  props: {
	    calendar: {
	      type: Object,
	      default: null
	    },
	    eventsInHash: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      isShowMore: false,
	      viewMode: 'timer',
	      tabs: [{
	        title: 'Vikartimer',
	        id: 'timer'
	      }, {
	        title: 'Vikarer pr. klasse',
	        id: 'subs'
	      }]
	    };
	  },
	
	  computed: {
	    events: function events() {
	      return this.eventsInHash[this.calendar.id] ? this.eventsInHash[this.calendar.id] : [];
	    },
	    calendarName: function calendarName() {
	      return this.calendar ? this.calendar.name : '';
	    },
	    eventsInPools: function eventsInPools() {
	      var events = {};
	      this.events.forEach(function (event) {
	        if (!events[event.title]) {
	          events[event.title] = {
	            events: 0,
	            eventsWithSubs: 0,
	            durations: [0],
	            durationsWithSubs: [0]
	          };
	        }
	        events[event.title]['events'] += 1;
	        events[event.title]['durations'].push(event.v_duration);
	        if (event.v_has_substitute) {
	          events[event.title]['eventsWithSubs'] += 1;
	          events[event.title]['durationsWithSubs'].push(event.v_duration);
	        }
	      });
	      for (var key in events) {
	        var sumInHours = events[key]['durations'].reduce(function (a, b) {
	          return a + b;
	        }) / 60;
	        events[key]['durationInHours'] = parseFloat(sumInHours).toFixed(2);
	        var sumOfDurationsWithSubs = events[key]['durationsWithSubs'].reduce(function (a, b) {
	          return a + b;
	        }) / 60;
	        events[key]['durationWithSubsInHours'] = parseFloat(sumOfDurationsWithSubs).toFixed(2);
	      }
	      return events;
	    },
	    eventsInHours: function eventsInHours() {
	      return this.getEventsInHours(this.events);
	    },
	    eventsWithSubInHours: function eventsWithSubInHours() {
	      return this.getEventsInHours(this.eventsWithSub);
	    },
	    eventsWithSub: function eventsWithSub() {
	      return this.events.filter(function (event) {
	        var hasSub = false;
	        event.calendars.forEach(function (calendar) {
	          if (calendar.substitute) {
	            hasSub = true;
	          }
	        });
	        return hasSub;
	      });
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    substitutesByKlass: function substitutesByKlass() {
	      var _this = this;
	
	      var klassMap = {};
	      var allUsersInCalIdHash = this.$store.getters.allUsersInCalIdHash || {};
	      var currentCalendarId = this.calendar ? this.calendar.id : null;
	
	      if (!currentCalendarId) {
	        return [];
	      }
	
	      this.events.forEach(function (event) {
	        var klassCalendars = [];
	        if (_this.calendar.type === 'klass' || _this.calendar.type === 'club') {
	          var calendarType = _this.calendar.type;
	          klassCalendars = event.calendars.filter(function (cal) {
	            return cal.calendar_type === calendarType && cal.calendar_id === currentCalendarId;
	          });
	        }
	
	        klassCalendars.forEach(function (klassCal) {
	          var klassName = klassCal.name || klassCal.calendar_id;
	          if (!klassMap[klassName]) {
	            klassMap[klassName] = {
	              name: klassName,
	              substitutes: {},
	              totalMinutes: 0
	            };
	          }
	
	          event.calendars.forEach(function (cal) {
	            if (cal.calendar_type === 'user' && cal.substitute) {
	              var substituteCalId = cal.calendar_id;
	              var substituteUserId = allUsersInCalIdHash[substituteCalId] ? allUsersInCalIdHash[substituteCalId].id : null;
	              var substituteName = cal.name || (substituteUserId && _this.allUsersInHash[substituteUserId] ? _this.allUsersInHash[substituteUserId].name : 'Vikar ' + substituteCalId);
	
	              var key = substituteCalId;
	              if (!klassMap[klassName].substitutes[key]) {
	                klassMap[klassName].substitutes[key] = {
	                  userId: substituteUserId,
	                  calendarId: substituteCalId,
	                  name: substituteName,
	                  minutes: 0
	                };
	              }
	
	              var minutes = cal.minutes || event.v_duration || 0;
	              klassMap[klassName].substitutes[key].minutes += minutes;
	              klassMap[klassName].totalMinutes += minutes;
	            }
	          });
	        });
	      });
	
	      return (0, _keys2.default)(klassMap).map(function (klassName) {
	        var klass = klassMap[klassName];
	        var substitutesArray = (0, _values2.default)(klass.substitutes).sort(function (a, b) {
	          return b.minutes - a.minutes;
	        });
	        var totalHours = (klass.totalMinutes / 60).toFixed(2);
	        return {
	          name: klassName,
	          substitutes: substitutesArray,
	          substituteCount: substitutesArray.length,
	          totalHours: totalHours
	        };
	      }).sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    }
	  },
	  methods: {
	    getEventsInHours: function getEventsInHours(events) {
	      var eventsDurations = [0];
	      events.forEach(function (event) {
	        eventsDurations.push(event.v_duration);
	      });
	      var sum = eventsDurations.reduce(function (a, b) {
	        return a + b;
	      });
	      var inHours = sum / 60;
	      return parseFloat(inHours).toFixed(2);
	    },
	    formatMinutesToHours: function formatMinutesToHours(minutes) {
	      var hours = (minutes / 60).toFixed(2);
	      return hours.replace('.', ',');
	    }
	  }
	};

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _values = __webpack_require__(33);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _schoolDataMixin = __webpack_require__(71);
	
	var _schoolDataMixin2 = _interopRequireDefault(_schoolDataMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Datepickerrange: _DatePickerRange2.default, Loader: _Loader2.default, ChangeSchoolYear: _ChangeSchoolYear2.default },
	  mixins: [_schoolDataMixin2.default],
	  data: function data() {
	    return {
	      openKlasses: []
	    };
	  },
	
	  computed: {
	    reportCalendars: function reportCalendars() {
	      var klassCalendars = this.$store.getters.klassCalendars || [];
	      var clubCalendars = this.$store.getters.clubCalendars || [];
	      return klassCalendars.concat(clubCalendars);
	    },
	    klassRows: function klassRows() {
	      var _this = this;
	
	      var klasses = {};
	      this.lessonsInRange.forEach(function (lesson) {
	        var substitutes = _this.getLessonSubstitutes(lesson);
	        if (substitutes.length < 1) {
	          return;
	        }
	        var subjectName = lesson.title || 'Uden titel';
	        var klassNames = _this.getLessonKlasses(lesson).map(function (klass) {
	          return klass.name;
	        }).filter(function (name, idx, arr) {
	          return arr.indexOf(name) === idx;
	        });
	        klassNames.forEach(function (klassName) {
	          if (!klasses[klassName]) {
	            klasses[klassName] = { name: klassName, substitutes: {}, subjects: {} };
	          }
	          var klass = klasses[klassName];
	          if (!klass.subjects[subjectName]) {
	            klass.subjects[subjectName] = { name: subjectName, substitutes: {} };
	          }
	          substitutes.forEach(function (sub) {
	            var minutes = sub.minutes || _this.getLessonMinutes(lesson);
	            _this.addSubstituteMinutes(klass.substitutes, sub, minutes);
	            _this.addSubstituteMinutes(klass.subjects[subjectName].substitutes, sub, minutes);
	          });
	        });
	      });
	      return (0, _values2.default)(klasses).map(function (klass) {
	        return (0, _extends3.default)({}, _this.summarize(klass), {
	          subjects: (0, _values2.default)(klass.subjects).map(function (subject) {
	            return _this.summarize(subject);
	          }).sort(function (a, b) {
	            return b.minutes - a.minutes;
	          })
	        });
	      }).sort(function (a, b) {
	        return a.name.localeCompare(b.name, 'da', { numeric: true });
	      });
	    }
	  },
	  methods: {
	    addSubstituteMinutes: function addSubstituteMinutes(hash, sub, minutes) {
	      if (!hash[sub.calendar_id]) {
	        hash[sub.calendar_id] = { name: sub.name || 'Vikar ' + sub.calendar_id, minutes: 0 };
	      }
	      hash[sub.calendar_id].minutes += minutes;
	    },
	    summarize: function summarize(group) {
	      var substitutes = (0, _values2.default)(group.substitutes).sort(function (a, b) {
	        return b.minutes - a.minutes;
	      });
	      return {
	        name: group.name,
	        substitutes: substitutes,
	        minutes: substitutes.reduce(function (sum, sub) {
	          return sum + sub.minutes;
	        }, 0),
	        topSubstitute: substitutes[0] || { name: '-', minutes: 0 }
	      };
	    },
	    toggleKlass: function toggleKlass(name) {
	      var idx = this.openKlasses.indexOf(name);
	      if (idx < 0) {
	        this.openKlasses.push(name);
	      } else {
	        this.openKlasses.splice(idx, 1);
	      }
	    }
	  }
	};

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	exports.default = {
	  components: { Datepickerrange: _DatePickerRange2.default, Loader: _Loader2.default, ChangeSchoolYear: _ChangeSchoolYear2.default },
	  data: function data() {
	    return {
	      events: [],
	      subEventsWithAbsenceType: [],
	      absenceTypesWithLessons: {},
	      absenceEventsInHash: {},
	      sortedAbsenceTypesWithLessons: {},
	      isLoading: false,
	      startDate: moment(),
	      endDate: moment().add(7, 'days'),
	      absenceEvents: [],
	      theActiveAcc: '',
	      isReadEventsClick: false,
	      sortKey: 'start',
	      sortOrder: 1,
	      sortColumns: [{ key: 'start', label: 'Dato' }, { key: 'substitute', label: 'Vikar' }, { key: 'substituteFor', label: 'Vikar for' }]
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    schoolId: function schoolId() {
	      return this.$route.params.school_id * 1;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    calendars: function calendars() {
	      return this.$store.state.calendars;
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    filteredCalendars: function filteredCalendars() {
	      return this.$store.getters.userCalendars;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    }
	  },
	  watch: {
	    user: function user() {
	      this.$store.dispatch('getSchoolCalendars', this.schoolId);
	    }
	  },
	  methods: {
	    setAbsenceEventsInHash: function setAbsenceEventsInHash() {
	      var _this = this;
	
	      this.absenceEventsInHash = {};
	      this.absenceEvents.forEach(function (event, idx) {
	        var calId = _this.allUsersInCalIdHash[event.calendar_id] ? _this.allUsersInCalIdHash[event.calendar_id].id : event.calendar_id;
	        if (!_this.absenceEventsInHash[calId]) {
	          _this.absenceEventsInHash[calId] = [event];
	        } else {
	          _this.absenceEventsInHash[calId].push(event);
	        }
	      });
	    },
	    setSubEventsWithAbsenceType: function setSubEventsWithAbsenceType() {
	      var _this2 = this;
	
	      this.subEventsWithAbsenceType = [];
	      moment.locale(this.locale);
	      this.events.forEach(function (lesson) {
	        lesson.calendars.forEach(function (cal) {
	          if (cal.substitute) {
	            var subLesson = {
	              id: lesson.event_id + '_' + cal.calendar_id,
	              title: lesson.title,
	              start: lesson.start,
	              vTimestamp: moment(lesson.start).format('lll') + ' - ' + moment(lesson.end).format('LT'),
	              vKlasses: lesson.calendars.filter(function (cal) {
	                return cal.calendar_type === 'klass';
	              }).map(function (cal) {
	                return cal.name;
	              }).join(' ,'),
	              end: lesson.end,
	              substitute: _this2.allUsersInCalIdHash[cal.calendar_id] ? _this2.allUsersInCalIdHash[cal.calendar_id].name : cal.calendar_id,
	              substituteCalId: cal.calendar_id,
	              minutes: cal.minutes,
	              substituteFor: _this2.allUsersInHash[cal.substitute] ? _this2.allUsersInHash[cal.substitute].name : cal.substitute,
	              absenceOverlapping: [],
	              absenceTitle: 'Ukendt fraværsårsag'
	            };
	            if (_this2.absenceEventsInHash[cal.substitute]) {
	              subLesson.absenceOverlapping = _this2.getEventsWithinDateTimes(_this2.absenceEventsInHash[cal.substitute], lesson.start, lesson.end);
	            }
	            if (subLesson.absenceOverlapping.length === 1) {
	              subLesson.absenceTitle = subLesson.absenceOverlapping[0].title;
	            }
	            if (subLesson.absenceOverlapping.length > 1) {
	              subLesson.absenceTitle = 'Multiple';
	            }
	            _this2.subEventsWithAbsenceType.push(subLesson);
	          }
	        });
	      });
	      this.setAbsenceTypesWithLessons();
	    },
	    setAbsenceTypesWithLessons: function setAbsenceTypesWithLessons() {
	      var _this3 = this;
	
	      this.absenceTypesWithLessons = {};
	      this.subEventsWithAbsenceType.forEach(function (lesson) {
	        if (_this3.absenceTypesWithLessons[lesson.absenceTitle]) {
	          _this3.absenceTypesWithLessons[lesson.absenceTitle]['minutes'] = _this3.absenceTypesWithLessons[lesson.absenceTitle]['minutes'] + lesson.minutes * 1;
	          _this3.absenceTypesWithLessons[lesson.absenceTitle]['lessons'].push(lesson);
	        } else {
	          _this3.absenceTypesWithLessons[lesson.absenceTitle] = { minutes: lesson.minutes * 1, lessons: [lesson], type: lesson.absenceTitle, isOpen: false };
	        }
	      });
	      this.setSortedAbsenceTypesWithLessons();
	    },
	    setSortedAbsenceTypesWithLessons: function setSortedAbsenceTypesWithLessons() {
	      var _this4 = this;
	
	      this.sortedAbsenceTypesWithLessons = {};
	
	      var sortedKeys = (0, _keys2.default)(this.absenceTypesWithLessons).sort(function (a, b) {
	        var minutesA = _this4.absenceTypesWithLessons[a].minutes;
	        var minutesB = _this4.absenceTypesWithLessons[b].minutes;
	        return minutesB - minutesA;
	      });
	
	      sortedKeys.forEach(function (key) {
	        _this4.sortedAbsenceTypesWithLessons[key] = (0, _extends3.default)({}, _this4.absenceTypesWithLessons[key], {
	          formattedDuration: _this4.formatDuration(_this4.absenceTypesWithLessons[key].minutes)
	        });
	      });
	    },
	    formatDuration: function formatDuration(minutes) {
	      var hours = Math.floor(minutes / 60);
	      var remainingMinutes = (minutes % 60).toFixed(0);
	      return hours + ' timer ' + remainingMinutes + ' min';
	    },
	    setSortKey: function setSortKey(key) {
	      if (this.sortKey === key) {
	        this.sortOrder = this.sortOrder * -1;
	      } else {
	        this.sortKey = key;
	        this.sortOrder = 1;
	      }
	    },
	    sortLessons: function sortLessons(lessons) {
	      var _this5 = this;
	
	      var key = this.sortKey;
	      var order = this.sortOrder;
	      return [].concat((0, _toConsumableArray3.default)(lessons)).sort(function (a, b) {
	        var result = void 0;
	        if (key === 'start') {
	          result = moment(a.start).valueOf() - moment(b.start).valueOf();
	        } else {
	          result = String(a[key] || '').localeCompare(String(b[key] || ''), _this5.locale);
	        }
	        if (result === 0 && key !== 'start') {
	          result = moment(a.start).valueOf() - moment(b.start).valueOf();
	        }
	        return result * order;
	      });
	    },
	    setActiveAcc: function setActiveAcc(prop) {
	      if (this.theActiveAcc === prop) {
	        this.theActiveAcc = '';
	      } else {
	        this.theActiveAcc = prop;
	      }
	    },
	    getEventsWithinDateTimes: function getEventsWithinDateTimes(events, start, end) {
	      return events.filter(function (event) {
	        var eventStart = moment(start).startOf('day');
	        var eventEnd = moment(end).endOf('day');
	        var absenceStart = moment(event.start);
	        var absenceEnd = moment(event.end);
	
	        var range1 = moment.range(eventStart, eventEnd);
	        var range2 = moment.range(absenceStart, absenceEnd);
	        return range1.intersect(range2);
	      });
	    },
	    resetDates: function resetDates() {
	      this.setDates(this.schoolYearStartDate, this.schoolYearEndDate);
	    },
	    setStartDate: function setStartDate(date) {
	      this.setDates(date, null);
	    },
	    setEndDate: function setEndDate(date) {
	      this.setDates(null, date);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.startDate = start;
	      }
	      if (end) {
	        this.endDate = end;
	      }
	    },
	    readEvents: function readEvents() {
	      var _this6 = this;
	
	      this.theActiveAcc = '';
	      this.isReadEventsClick = true;
	      this.isLoading = true;
	      var start = moment(this.startDate).format('YYYY-MM-DD');
	      var end = moment(this.endDate).endOf('day');
	      var calendarIds = this.filteredCalendars.map(function (calendar) {
	        return calendar.id;
	      });
	      _docendo2.default.calendarEvents2(calendarIds, start, end, null, function (success) {
	        _this6.events = JSON.parse(success).filter(function (event) {
	          return event.school_id === _this6.schoolId;
	        });
	        _this6.absenceEvents = _this6.events.filter(function (event) {
	          return event.event_type === 'absence' && event.school_id === _this6.schoolId;
	        });
	        _this6.isLoading = false;
	        _this6.setAbsenceEventsInHash();
	        _this6.setSubEventsWithAbsenceType();
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    compareDates: function compareDates(firstDate, secondDate) {
	      return moment(firstDate).format('YYYY-MM-DD') === moment(secondDate).format('YYYY-MM-DD');
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUsersFromSchoolId', this.schoolId);
	    this.$store.dispatch('getUser');
	  }
	};

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _phone = __webpack_require__(156);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_EDITABLE = ['name', 'initials', 'email', 'phone', 'ssn'];
	
	exports.default = {
	  name: 'school-user-modal',
	  components: { DModal: _DModal2.default },
	  props: {
	    schoolId: {
	      default: null
	    },
	    user: {
	      type: Object,
	      required: true
	    }
	  },
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        setTimeout(function () {
	          return el.focus();
	        }, 150);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isSaving: false,
	      isUploadingImage: false,
	      thumbUrl: this.user.default_thumb_url,
	      form: this.buildForm()
	    };
	  },
	
	  computed: {
	    country: function country() {
	      return (this.$store.getters.schoolCountry || '').toUpperCase();
	    },
	    showSsn: function showSsn() {
	      return this.$store.getters.schoolFeatures.indexOf('salary') > -1 && 'ssn' in this.user;
	    },
	    loginField: function loginField() {
	      if (this.country === 'DK') {
	        return { key: 'unilogin', label: this.$t('vue2.school_users.unilogin'), hint: this.$t('vue2.school_users.unilogin_hint') };
	      }
	      if (this.country === 'NO') {
	        return { key: 'feide', label: this.$t('vue2.school_users.feide') };
	      }
	      return null;
	    },
	    lastSeen: function lastSeen() {
	      if (!this.user.last_seen) {
	        return this.$t('vue2.school_users.never_logged_in');
	      }
	      return this.$t('vue2.school_users.last_seen') + ' ' + (0, _moment2.default)(this.user.last_seen).fromNow();
	    },
	    tasksUrl: function tasksUrl() {
	      return '/schools/' + this.schoolId + '/users/' + this.user.id + '/tasks';
	    },
	    changes: function changes() {
	      var _this = this;
	
	      var original = this.buildForm();
	      var changes = {};
	      API_EDITABLE.forEach(function (key) {
	        if ((_this.form[key] || '').trim() !== (original[key] || '').trim()) {
	          changes[key] = (_this.form[key] || '').trim();
	        }
	      });
	      if ('phone' in changes) {
	        changes.phone = (0, _phone.normalizePhone)(changes.phone, this.country);
	      }
	      return changes;
	    },
	    isValid: function isValid() {
	      return this.form.name.trim().length > 0;
	    }
	  },
	  methods: {
	    buildForm: function buildForm() {
	      return {
	        name: this.user.name || '',
	        initials: this.user.initials || '',
	        email: this.user.email || '',
	        phone: (0, _phone.formatPhone)(this.user.phone),
	        ssn: this.user.ssn || '',
	        unilogin: this.user.unilogin || '',
	        feide: this.user.feide || '',
	        employee_id: this.user.employee_id || ''
	      };
	    },
	    isEditable: function isEditable(key) {
	      return API_EDITABLE.indexOf(key) > -1;
	    },
	    onImageSelected: function onImageSelected(event) {
	      var _this2 = this;
	
	      var file = event.target.files && event.target.files[0];
	      if (!file) {
	        return;
	      }
	      var reader = new window.FileReader();
	      reader.onload = function (e) {
	        _this2.isUploadingImage = true;
	        _docendo2.default.updateUserProfileImage(_this2.user.id, e.target.result, function (data) {
	          _this2.isUploadingImage = false;
	          if (data && data.url) {
	            _this2.thumbUrl = data.url;
	          }
	          _this2.$emit('imageChanged');
	        }, _this2.onError);
	      };
	      reader.readAsDataURL(file);
	    },
	    save: function save() {
	      var _this3 = this;
	
	      if (!this.isValid || this.isSaving) {
	        return;
	      }
	      if ((0, _keys2.default)(this.changes).length === 0) {
	        this.$emit('close');
	        return;
	      }
	      this.isSaving = true;
	      _docendo2.default.updateUsers(this.schoolId, this.user.id, this.changes, function (data) {
	        if (data && data.status === 'error') {
	          _this3.onError();
	          return;
	        }
	        _this3.isSaving = false;
	        _eventbus2.default.toast = { text: _this3.$t('vue2.school_users.saved'), success: true };
	        _this3.$emit('saved');
	      }, this.onError);
	    },
	    onError: function onError() {
	      this.isSaving = false;
	      this.isUploadingImage = false;
	      _eventbus2.default.toast = { text: this.$t('vue2.school_users.error_toast'), success: false };
	    }
	  }
	};

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _SchoolUserModal = __webpack_require__(1605);
	
	var _SchoolUserModal2 = _interopRequireDefault(_SchoolUserModal);
	
	var _phone = __webpack_require__(156);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LOGIN_TYPES = ['email', 'unilogin', 'wayf', 'feide'];
	
	exports.default = {
	  name: 'school-users',
	  components: { Loader: _Loader2.default, DDropdown: _DDropdown2.default, SchoolUserModal: _SchoolUserModal2.default },
	  data: function data() {
	    return {
	      isLoading: true,
	      users: [],
	      search: '',
	      sortKey: 'name',
	      sortAsc: true,
	      editingUser: null,
	      closeActionsMenu: 0
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    isDK: function isDK() {
	      return (this.$store.getters.schoolCountry || '').toUpperCase() === 'DK';
	    },
	    stilImportUrl: function stilImportUrl() {
	      return '/schools/' + this.schoolId + '/stil_users_import/edit';
	    },
	    mergeUsersUrl: function mergeUsersUrl() {
	      return '/schools/' + this.schoolId + '/user_merges/new';
	    },
	    transferCalendarUrl: function transferCalendarUrl() {
	      return '/schools/' + this.schoolId + '/calendar_transfers/new';
	    },
	    createdId: function createdId() {
	      return _eventbus2.default.createdId;
	    },
	    actions: function actions() {
	      return [{ key: 'edit', icon: 'icon-pencil', label: this.$t('vue2.school_users.edit_action'), run: this.openEdit }];
	    },
	    filteredUsers: function filteredUsers() {
	      var query = this.search.trim().toLowerCase();
	      if (!query) {
	        return this.users;
	      }
	      return this.users.filter(function (user) {
	        return ['name', 'initials', 'email', 'unilogin', 'feide', 'wayf', 'phone', 'employee_id'].some(function (key) {
	          return user[key] && String(user[key]).toLowerCase().indexOf(query) > -1;
	        });
	      });
	    },
	    visibleUsers: function visibleUsers() {
	      var key = this.sortKey;
	      var direction = this.sortAsc ? 1 : -1;
	      return this.filteredUsers.slice().sort(function (a, b) {
	        var valueA = a[key] || '';
	        var valueB = b[key] || '';
	        if (key === 'last_seen') {
	          return ((0, _moment2.default)(valueA || 0).valueOf() - (0, _moment2.default)(valueB || 0).valueOf()) * direction;
	        }
	        return String(valueA).localeCompare(String(valueB), 'da', { numeric: true, sensitivity: 'base' }) * direction;
	      });
	    },
	    countLabel: function countLabel() {
	      if (this.filteredUsers.length === this.users.length) {
	        return this.users.length + ' ' + this.$t('vue2.school_users.users');
	      }
	      return this.filteredUsers.length + ' / ' + this.users.length + ' ' + this.$t('vue2.school_users.users');
	    }
	  },
	  watch: {
	    createdId: function createdId() {
	      this.readList();
	    }
	  },
	  mounted: function mounted() {
	    this.readList();
	  },
	
	  methods: {
	    readList: function readList() {
	      var _this = this;
	
	      if (!this.schoolId) {
	        return;
	      }
	      _docendo2.default.schoolUsers2(this.schoolId, function (data) {
	        _this.users = Array.isArray(data) ? data : [];
	        _this.isLoading = false;
	      }, function () {
	        _this.isLoading = false;
	        _eventbus2.default.toast = { text: _this.$t('vue2.school_users.error_toast'), success: false };
	      });
	    },
	    setSort: function setSort(key) {
	      if (this.sortKey === key) {
	        this.sortAsc = !this.sortAsc;
	      } else {
	        this.sortKey = key;
	        this.sortAsc = key !== 'last_seen';
	      }
	    },
	    sortIndicator: function sortIndicator(key) {
	      if (this.sortKey !== key) {
	        return '';
	      }
	      return this.sortAsc ? '▲' : '▼';
	    },
	    logins: function logins(user) {
	      return LOGIN_TYPES.filter(function (type) {
	        return user[type];
	      }).map(function (type) {
	        return { type: type, value: user[type] };
	      });
	    },
	    formatPhone: function formatPhone(phone) {
	      return (0, _phone.formatPhone)(phone);
	    },
	    lastSeen: function lastSeen(user) {
	      if (!user.last_seen) {
	        return this.$t('vue2.school_users.never_logged_in');
	      }
	      return (0, _moment2.default)(user.last_seen).fromNow();
	    },
	    runAction: function runAction(action, user) {
	      this.closeActionsMenu++;
	      action.run(user);
	    },
	    openCreate: function openCreate() {
	      _eventbus2.default.createUserModal = true;
	    },
	    openEdit: function openEdit(user) {
	      this.editingUser = user;
	    },
	    onSaved: function onSaved() {
	      this.editingUser = null;
	      this.readList();
	    }
	  }
	};

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SideNav = __webpack_require__(99);
	
	var _SideNav2 = _interopRequireDefault(_SideNav);
	
	var _Salary = __webpack_require__(139);
	
	var _Salary2 = _interopRequireDefault(_Salary);
	
	var _Supplements = __webpack_require__(102);
	
	var _Supplements2 = _interopRequireDefault(_Supplements);
	
	var _AssignHours = __webpack_require__(335);
	
	var _AssignHours2 = _interopRequireDefault(_AssignHours);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Salary: _Salary2.default,
	    Supplements: _Supplements2.default,
	    SideNav: _SideNav2.default,
	    AssignHours: _AssignHours2.default
	  }
	};

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(32);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _ToggleYear = __webpack_require__(1698);
	
	var _ToggleYear2 = _interopRequireDefault(_ToggleYear);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _OnboardArrow = __webpack_require__(417);
	
	var _OnboardArrow2 = _interopRequireDefault(_OnboardArrow);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _TeamCalendar = __webpack_require__(402);
	
	var _TeamCalendar2 = _interopRequireDefault(_TeamCalendar);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, yearToggle: _ToggleYear2.default, onboardArrow: _OnboardArrow2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, TeamCalendar: _TeamCalendar2.default },
	  mixins: [_vueClickaway.mixin],
	  data: function data() {
	    return {
	      open: false,
	      search: '',
	      type: '',
	      active: '',
	      changeSchoolDropdown: false,
	      searchName: '',
	      hover: false,
	      theStudentsActiveForCal: null,
	      snowflakes: []
	    };
	  },
	
	  watch: {
	    schoolId: function schoolId(val, oldVal) {
	      this.getSchoolCalendars();
	    },
	    user: function user() {
	      this.setActiveSchool();
	      this.$i18n.locale = this.locale;
	      _moment2.default.locale(this.locale);
	      this.getSchoolCalendars();
	    },
	    activeOnboardingStep: function activeOnboardingStep() {
	      if (this.activeOnboardingStep > 0 && this.activeOnboardingStep < 5) {
	        this.openSideNav();
	        this.chooseCals(this.activeOnboardingStep);
	      } else if (this.activeOnboardingStep === 6) {
	        this.openSideNav();
	        this.chooseCals(1);
	      }
	    }
	  },
	  computed: {
	    isUserLoaded: function isUserLoaded() {
	      return this.$store.state.isUserLoaded;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    schoolId: function schoolId() {
	      if (this.$route && this.$route.params && this.$route.params.school_id) {
	        return this.$route.params.school_id;
	      }
	      if (this.activeSchool && this.activeSchool.id) {
	        return this.activeSchool.id;
	      }
	      if (window.SCHOOL && window.SCHOOL.id) {
	        return window.SCHOOL.id;
	      }
	    },
	    isKindergarten: function isKindergarten() {
	      return this.$store.getters.isKindergarten;
	    },
	    isSchoolTestingStudents: function isSchoolTestingStudents() {
	      return this.$store.getters.isSchoolTestingStudents;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    userHasMultipleSchools: function userHasMultipleSchools() {
	      return this.user && this.user.schools ? this.user.schools.length > 1 : false;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    year: function year() {
	      return this.activeSchoolYear.name;
	    },
	    schoolYearStartDate: function schoolYearStartDate() {
	      return this.activeSchoolYear ? this.activeSchoolYear.student_time_start : null;
	    },
	    notCreatedAnyTextString: function notCreatedAnyTextString() {
	      switch (this.activeType.type) {
	        case 'klass':
	          return this.$t('vue2.sidenav.not_created_klass');
	        case 'user':
	          return this.$t('vue2.sidenav.not_created_users');
	        case 'room':
	          return this.$t('vue2.sidenav.not_created_rooms');
	        case 'merge':
	          return this.$t('vue2.sidenav.not_created_merge');
	        case 'other':
	          return this.$t('vue2.sidenav.not_created_other');
	        case 'club':
	          return this.$t('vue2.club.not_created_club');
	        case 'kindergarten':
	          return 'stue';
	      }
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    cals: function cals() {
	      return this.$store.state.calendars;
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    activeOnboardingStep: function activeOnboardingStep() {
	      return this.$store.state.onboardingStep;
	    },
	    showOnboardingArrow: function showOnboardingArrow() {
	      return _eventbus2.default.showOnboardingArrow;
	    },
	    calendarData: function calendarData() {
	      return {
	        1: {
	          type: 'klass',
	          title: this.$i18n.t('vue2.common.class'),
	          searchName: this.$i18n.t('vue2.common.classes'),
	          icon: 'icon-calendar4',
	          hasSchoolYear: true
	        },
	        2: {
	          type: 'user',
	          title: this.$i18n.t('vue2.common.user'),
	          searchName: this.$i18n.t('vue2.common.users'),
	          icon: 'icon-users',
	          hasSchoolYear: false
	        },
	        3: {
	          type: 'room',
	          title: this.$i18n.t('vue2.common.room'),
	          searchName: this.$i18n.t('vue2.common.rooms'),
	          icon: 'icon-location',
	          hasSchoolYear: false
	        },
	        4: {
	          type: 'merge',
	          title: this.$i18n.t('vue2.common.merge_calendar'),
	          searchName: this.$i18n.t('vue2.common.merge_calendars'),
	          icon: 'icon-calendar-week',
	          hasSchoolYear: true
	        },
	        5: {
	          type: 'other',
	          title: this.$i18n.t('vue2.common.other_calendar'),
	          searchName: this.$i18n.t('vue2.common.other_calendars'),
	          icon: 'icon-clipboard2',
	          hasSchoolYear: true
	        },
	        6: {
	          type: 'club',
	          title: this.$i18n.t('vue2.club.club_calendar'),
	          searchName: this.$i18n.t('vue2.club.club'),
	          icon: 'icon-users5',
	          hasSchoolYear: true
	        },
	        7: {
	          type: 'kindergarten',
	          title: 'Stue',
	          searchName: 'Stue',
	          icon: 'icon-users5',
	          hasSchoolYear: true
	        }
	      };
	    },
	    activeType: function activeType() {
	      if (this.active !== '') {
	        return this.calendarData[this.active];
	      } else {
	        return '';
	      }
	    },
	    allSchools: function allSchools() {
	      return this.user.schools;
	    },
	    activeCals: function activeCals() {
	      var _this = this;
	
	      return this.cals.filter(function (cal) {
	        return cal.type === _this.type && !cal.archived_at;
	      });
	    },
	    yearCals: function yearCals() {
	      var _this2 = this;
	
	      var cals = this.activeCals.filter(function (cal) {
	        return cal.school_year_id ? cal.school_year_id === _this2.activeSchoolYear.id : cal.year === '' || cal.year.match(_this2.year);
	      });
	      return this.$helpers.sortArrOnName(cals);
	    },
	    searchCals: function searchCals() {
	      var _this3 = this;
	
	      return this.yearCals.filter(function (cal) {
	        return cal.name !== null ? cal.name.match(new RegExp(_this3.search, 'i')) : '';
	      });
	    },
	    isSchoolSFOActive: function isSchoolSFOActive() {
	      return this.$store.getters.isSchoolSFOActive;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    }
	  },
	  methods: {
	    goToDutySchedule: function goToDutySchedule() {
	      window.location.href = '/schools/' + this.schoolId + '/duty_schedule';
	    },
	    getSchoolCalendars: function getSchoolCalendars() {
	      if (!this.schoolId) {
	        return;
	      }
	      if (this.isSchoolTestingStudents) {
	        this.$store.dispatch('readCalendarRelations');
	      }
	      this.$store.dispatch('getSchoolCalendars', this.schoolId);
	      this.$store.dispatch('readSchoolYears', this.schoolId);
	    },
	    getCalStudents: function getCalStudents(calStudents) {
	      var _this4 = this;
	
	      var students = calStudents.filter(function (studentId) {
	        return _this4.allCalendarsInHash[studentId] && !_this4.allCalendarsInHash[studentId].archived_at;
	      }).map(function (studentId) {
	        return _this4.allCalendarsInHash[studentId];
	      });
	      return this.$helpers.sortArrOnName(students);
	    },
	    setActiveCalendarId: function setActiveCalendarId(calId) {
	      if (window.location.href.indexOf('calendar') < 0 || window.location.href.indexOf('?tasks') > 0) {
	        window.location.href = '/calendar/?cal=' + calId;
	      }
	      this.$store.commit('setActiveCalendarId', calId);
	      this.closeSideNav();
	    },
	    setTheStudentsActiveForCal: function setTheStudentsActiveForCal(calId) {
	      if (this.isStudentsActiveForCal(calId)) {
	        this.theStudentsActiveForCal = null;
	      } else {
	        this.theStudentsActiveForCal = calId;
	      }
	    },
	    isStudentsActiveForCal: function isStudentsActiveForCal(calId) {
	      return this.theStudentsActiveForCal === calId;
	    },
	    userHasPermission: function userHasPermission(val) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(val) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    createKlasses: function createKlasses() {
	      _eventbus2.default.createKlassModal = true;
	      _eventbus2.default.showOnboardingArrow = false;
	    },
	    createUsers: function createUsers() {
	      _eventbus2.default.createUserModal = true;
	      _eventbus2.default.showOnboardingArrow = false;
	    },
	    createCalendars: function createCalendars(calendarType) {
	      _eventbus2.default.createCalendarsType = calendarType;
	      _eventbus2.default.showOnboardingArrow = false;
	    },
	    toggleChangeSchoolDropdown: function toggleChangeSchoolDropdown() {
	      this.changeSchoolDropdown = !this.changeSchoolDropdown;
	    },
	    closeChangeSchoolDropdown: function closeChangeSchoolDropdown() {
	      this.changeSchoolDropdown = false;
	      this.$refs.changeSchoolToggle.focus();
	    },
	    openSideNav: function openSideNav(cals) {
	      var _this5 = this;
	
	      if (this.open) {
	        return;
	      }
	      this.open = true;
	      var pagewidth = document.getElementById('djs-content-container');
	      if (!pagewidth.classList.contains('djs_menu_out')) {
	        pagewidth.className += ' djs_menu_out';
	      }
	      if (cals === 0) {
	        this.isKindergarten ? this.chooseCals(7) : this.chooseCals(1);
	      }
	      setTimeout(function (_) {
	        _this5.$refs.searchfield.focus();
	      }, 200);
	    },
	    clickaway: function clickaway(e) {
	      if (e !== undefined) {
	        if (e.target.classList.toString().startsWith('lity') || e.target.classList.contains('js-setupWidgetEvent') || e.target.classList.contains('js-modalCloseEvent') || e.target.classList.contains('js-dontCloseSidenav')) {
	          return;
	        }
	      }
	      if (_eventbus2.default.createModalOpen) {
	        return;
	      }
	      this.closeSideNav();
	      if (this.activeOnboardingStep > 0 && this.activeOnboardingStep < 5) {
	        this.$store.commit('setOnboardingStep', 0);
	      }
	      if (this.activeOnboardingStep === 6) {
	        this.$store.commit('setOnboardingStep', 0);
	      }
	    },
	    closeSideNav: function closeSideNav() {
	      this.open = false;
	      var pagewidth = document.getElementById('djs-content-container');
	      if (this.hasClass(pagewidth, 'djs_menu_out')) {
	        pagewidth.className = 'content_container';
	        this.active = '';
	      }
	    },
	    clearSearch: function clearSearch() {
	      this.search = '';
	    },
	    calLinks: function calLinks() {
	      return this.$refs.calList ? (0, _from2.default)(this.$refs.calList.querySelectorAll('a')) : [];
	    },
	    focusCalLink: function focusCalLink(index) {
	      if (index < 0) {
	        this.$refs.searchfield.focus();
	        return;
	      }
	      var links = this.calLinks();
	      if (links[index]) {
	        links[index].focus();
	      }
	    },
	    chooseFirstCalLink: function chooseFirstCalLink() {
	      var links = this.calLinks();
	      if (links[0]) {
	        links[0].click();
	      }
	    },
	    onCalListKeydown: function onCalListKeydown(e) {
	      var links = this.calLinks();
	      var index = links.indexOf(e.target);
	      if (index === -1) {
	        return;
	      }
	      var targets = {
	        ArrowDown: Math.min(index + 1, links.length - 1),
	        ArrowUp: index - 1,
	        Home: 0,
	        End: links.length - 1
	      };
	      if (e.key in targets) {
	        e.preventDefault();
	        this.focusCalLink(targets[e.key]);
	      }
	    },
	    activateNav: function activateNav(num) {
	      this.openSideNav();
	      this.chooseCals(num);
	    },
	    chooseCals: function chooseCals(num) {
	      var searchfield = document.getElementById('searchfield');
	      if (searchfield !== null) {
	        searchfield.focus();
	      }
	      var calendar = this.calendarData[num];
	      this.type = calendar.type;
	      this.active = num;
	      this.searchName = calendar.searchName.toLowerCase();
	    },
	    isActive: function isActive(num) {
	      return this.active === num;
	    },
	    hasClass: function hasClass(elem, cls) {
	      return (' ' + elem.className + ' ').indexOf(' ' + cls + ' ') > -1;
	    },
	    setActiveSchool: function setActiveSchool() {
	      var activeSchool = '';
	
	      if (this.user.current_school) {
	        activeSchool = this.user.current_school;
	      } else if (this.user.primary_school) {
	        activeSchool = this.user.primary_school;
	      } else {
	        activeSchool = this.user.schools[0];
	      }
	
	      this.$store.dispatch('readActiveSchool', activeSchool);
	    },
	    manipulateSchoolStuffForKindergarten: function manipulateSchoolStuffForKindergarten() {
	      var elSupportLink = document.querySelector('.js-intro-support__nav > a');
	      if (elSupportLink) {
	        elSupportLink.setAttribute('href', 'https://app.docendo.dk/features/daycare/');
	      }
	      this.changeLinksTextString('Opgaveoversigt', 'Årsnormsoversigt');
	      this.changeLinksTextString('Feriekalender', 'Lukkedage');
	      this.changeLinksTextString('Skoleår', 'Perioder');
	      this.changeDivTextString('Undervisere', 'Personale');
	      this.changePlanningLink();
	    },
	    changePlanningLink: function changePlanningLink() {
	      var planningLink = document.querySelector('.js-onboarding-arrow-planning > a');
	      var subPlanningLink = document.querySelector('.js-onboarding-arrow-planning > .header-nav__item__dropdown > a:first-child');
	      if (!planningLink || !subPlanningLink) {
	        return;
	      }
	      planningLink.setAttribute('href', '/schools/' + this.schoolId + '/annual_norm');
	      planningLink.innerHTML = '<span class="icon-calendar2"></span> Årsnorm';
	      subPlanningLink.remove();
	    },
	    changeDivTextString: function changeDivTextString(initialText, newText) {
	      var aElements = document.querySelectorAll('div');
	      for (var i = 0; i < aElements.length; i++) {
	        var a = aElements[i];
	        if (a.textContent.indexOf(initialText) !== -1) {
	          a.innerText = newText;
	        }
	      }
	    },
	    changeLinksTextString: function changeLinksTextString(initialText, newText) {
	      var aElements = document.querySelectorAll('a');
	      for (var i = 0; i < aElements.length; i++) {
	        var a = aElements[i];
	        if (a.textContent.indexOf(initialText) !== -1) {
	          a.innerText = newText;
	        }
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUser');
	  },
	  mounted: function mounted() {
	    if (this.isKindergarten) {
	      this.manipulateSchoolStuffForKindergarten();
	    }
	  }
	};

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['school'],
	  data: function data() {
	    return {
	      html: ''
	    };
	  },
	
	  methods: {
	    getAllData: function getAllData() {
	      _docendo2.default.getSchoolLeftSideMenu(this.school, this.sidebarUpdated);
	    },
	    sidebarUpdated: function sidebarUpdated(data) {
	      this.html = data.data;
	    }
	  },
	  mounted: function mounted() {
	    this.getAllData();
	  }
	};

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DSelectCals = __webpack_require__(48);
	
	var _DSelectCals2 = _interopRequireDefault(_DSelectCals);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'special-day-calendar-modal',
	  components: { DModal: _DModal2.default, Loader: _Loader2.default, DSelectCals: _DSelectCals2.default, AppToggle: _AppToggle2.default },
	  props: {
	    schoolId: {
	      default: null
	    },
	    schoolYearId: {
	      default: null
	    },
	    specialDayId: {
	      default: null
	    },
	    klassCalendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    schoolYearStart: {
	      default: null
	    },
	    schoolYearEnd: {
	      default: null
	    }
	  },
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        setTimeout(function () {
	          return el.focus();
	        }, 150);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isSaving: false,
	      isLoadingExisting: false,
	      hasTriedSave: false,
	      form: {
	        title: '',
	        reduct: true
	      },
	      rangeStart: null,
	      rangeEnd: null,
	      selectedClasses: []
	    };
	  },
	
	  computed: {
	    calStart: function calStart() {
	      return this.schoolYearStart ? (0, _moment2.default)(this.schoolYearStart) : (0, _moment2.default)().startOf('month');
	    },
	    calEnd: function calEnd() {
	      return this.schoolYearEnd ? (0, _moment2.default)(this.schoolYearEnd) : (0, _moment2.default)().add(11, 'month').endOf('month');
	    },
	    months: function months() {
	      var months = [];
	      var cursor = this.calStart.clone().startOf('month');
	      var last = this.calEnd.clone().endOf('month');
	      while (cursor.isSameOrBefore(last)) {
	        months.push(this.buildMonth(cursor.clone()));
	        cursor.add(1, 'month');
	      }
	      return months;
	    },
	    effectiveEnd: function effectiveEnd() {
	      return this.rangeEnd || this.rangeStart;
	    },
	    allClassesSelected: function allClassesSelected() {
	      return this.klassCalendars.length > 0 && this.selectedClasses.length === this.klassCalendars.length;
	    },
	    rangeLabel: function rangeLabel() {
	      if (!this.rangeStart) {
	        return '';
	      }
	      var start = (0, _moment2.default)(this.rangeStart);
	      var end = (0, _moment2.default)(this.effectiveEnd);
	      if (start.isSame(end, 'day')) {
	        return start.format('dddd D. MMMM YYYY');
	      }
	      return start.format('D. MMM') + ' – ' + end.format('D. MMM YYYY');
	    },
	    isValid: function isValid() {
	      return this.form.title.trim().length > 0 && !!this.rangeStart && this.selectedClasses.length > 0;
	    }
	  },
	  mounted: function mounted() {
	    if (this.specialDayId) {
	      this.loadExisting();
	    }
	  },
	
	  methods: {
	    buildMonth: function buildMonth(monthStart) {
	      var monthEnd = monthStart.clone().endOf('month');
	      var days = [];
	      var day = monthStart.clone();
	      while (day.isSameOrBefore(monthEnd, 'day')) {
	        days.push({
	          date: day.format('YYYY-MM-DD'),
	          label: day.date(),
	          isWeekend: day.isoWeekday() >= 6,
	          selectable: day.isSameOrAfter(this.calStart, 'day') && day.isSameOrBefore(this.calEnd, 'day')
	        });
	        day.add(1, 'day');
	      }
	      return { key: monthStart.format('YYYY-MM'), label: monthStart.format('MMMM'), days: days };
	    },
	    isInRange: function isInRange(day) {
	      if (!this.rangeStart || !this.effectiveEnd) {
	        return false;
	      }
	      return day.date > this.rangeStart && day.date < this.effectiveEnd;
	    },
	    selectDay: function selectDay(day) {
	      if (!day.selectable) {
	        return;
	      }
	      var d = day.date;
	      if (!this.rangeStart || this.rangeEnd) {
	        this.rangeStart = d;
	        this.rangeEnd = null;
	      } else if (d < this.rangeStart) {
	        this.rangeEnd = this.rangeStart;
	        this.rangeStart = d;
	      } else {
	        this.rangeEnd = d;
	      }
	    },
	    clearRange: function clearRange() {
	      this.rangeStart = null;
	      this.rangeEnd = null;
	    },
	    onClassesUpdate: function onClassesUpdate(classes) {
	      this.selectedClasses = classes.slice();
	    },
	    toggleAllClasses: function toggleAllClasses() {
	      this.selectedClasses = this.allClassesSelected ? [] : this.klassCalendars.slice();
	    },
	    loadExisting: function loadExisting() {
	      var _this = this;
	
	      this.isLoadingExisting = true;
	      _docendo2.default.specialDaysShow(this.schoolId, this.schoolYearId, this.specialDayId, function (data) {
	        _this.form = {
	          title: data.title || '',
	          reduct: data.reduct !== false
	        };
	        _this.rangeStart = data.start_date || null;
	        _this.rangeEnd = data.end_date || null;
	        var ids = data.calendar_ids || [];
	        _this.selectedClasses = _this.klassCalendars.filter(function (cal) {
	          return ids.indexOf(cal.id) > -1;
	        });
	        _this.isLoadingExisting = false;
	      }, function () {
	        _this.isLoadingExisting = false;
	        _eventbus2.default.toast = { text: 'Noget gik galt. Prøv igen.', success: false };
	      });
	    },
	    buildAttrs: function buildAttrs() {
	      return {
	        title: this.form.title.trim(),
	        start_date: this.rangeStart,
	        end_date: this.effectiveEnd,
	        reduct: this.form.reduct,
	        calendar_ids: this.selectedClasses.map(function (cal) {
	          return cal.id;
	        })
	      };
	    },
	    save: function save() {
	      var _this2 = this;
	
	      this.hasTriedSave = true;
	      if (!this.isValid || this.isSaving) {
	        return;
	      }
	      this.isSaving = true;
	      var attrs = this.buildAttrs();
	      var onSaved = function onSaved(data) {
	        if (data && data.status === 'error') {
	          _this2.onError();
	          return;
	        }
	        _this2.isSaving = false;
	        _eventbus2.default.toast = { text: 'Gemt', success: true };
	        _this2.$emit('saved');
	      };
	      if (this.specialDayId) {
	        _docendo2.default.specialDaysUpdate(this.schoolId, this.schoolYearId, this.specialDayId, attrs, onSaved, this.onError);
	      } else {
	        _docendo2.default.specialDaysCreate(this.schoolId, this.schoolYearId, attrs, onSaved, this.onError);
	      }
	    },
	    onError: function onError() {
	      this.isSaving = false;
	      _eventbus2.default.toast = { text: 'Noget gik galt. Prøv igen.', success: false };
	    }
	  }
	};

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DSelectCals = __webpack_require__(48);
	
	var _DSelectCals2 = _interopRequireDefault(_DSelectCals);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'special-day-modal',
	  components: { DModal: _DModal2.default, Loader: _Loader2.default, DSelectCals: _DSelectCals2.default, DateSelector: _DateSelector2.default, AppToggle: _AppToggle2.default, ModalConfirmation: _ModalConfirmation2.default },
	  props: {
	    schoolId: {
	      default: null
	    },
	    schoolYearId: {
	      default: null
	    },
	    specialDayId: {
	      default: null
	    },
	    klassCalendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    defaultDate: {
	      default: null
	    }
	  },
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        setTimeout(function () {
	          return el.focus();
	        }, 150);
	      }
	    }
	  },
	  data: function data() {
	    var defaultDay = this.defaultDate ? (0, _moment2.default)(this.defaultDate).format('YYYY-MM-DD') : null;
	    return {
	      isSaving: false,
	      isLoadingExisting: false,
	      hasTriedSave: false,
	      form: {
	        title: '',
	        startDate: defaultDay,
	        endDate: defaultDay,
	        reduct: true
	      },
	      selectedClasses: [],
	      originalClassIds: [],
	      specialDaySubjectIds: [],
	      showRemovalWarning: false,
	      removalConfirmed: false
	    };
	  },
	
	  computed: {
	    title: function title() {
	      return this.specialDayId ? this.$t('vue2.special_days.edit') : this.$t('vue2.special_days.create');
	    },
	    startDateMoment: function startDateMoment() {
	      if (this.form.startDate) {
	        return (0, _moment2.default)(this.form.startDate);
	      }
	      return this.defaultDate ? (0, _moment2.default)(this.defaultDate) : (0, _moment2.default)();
	    },
	    endDateMoment: function endDateMoment() {
	      if (this.form.endDate) {
	        return (0, _moment2.default)(this.form.endDate);
	      }
	      return this.startDateMoment;
	    },
	    allClassesSelected: function allClassesSelected() {
	      return this.klassCalendars.length > 0 && this.selectedClasses.length === this.klassCalendars.length;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    affectedRemovedClassNames: function affectedRemovedClassNames() {
	      var _this = this;
	
	      var selectedIds = this.selectedClasses.map(function (cal) {
	        return cal.id;
	      });
	      var removedIds = this.originalClassIds.filter(function (id) {
	        return selectedIds.indexOf(id) === -1;
	      });
	      if (removedIds.length === 0) {
	        return [];
	      }
	      return removedIds.filter(function (classId) {
	        return _this.specialDaySubjectIds.some(function (subjectId) {
	          var subject = _this.subjectsInHash[subjectId];
	          if (!subject) {
	            return false;
	          }
	          if (subject.calendar_id === classId) {
	            return true;
	          }
	          return Array.isArray(subject.calendar_ids) && subject.calendar_ids.indexOf(classId) > -1;
	        });
	      }).map(function (classId) {
	        return _this.className(classId);
	      }).filter(function (name) {
	        return !!name;
	      });
	    },
	    isValid: function isValid() {
	      return this.form.title.trim().length > 0 && !!this.form.startDate && !!this.form.endDate && this.form.endDate >= this.form.startDate && this.selectedClasses.length > 0;
	    }
	  },
	  mounted: function mounted() {
	    if (this.specialDayId) {
	      this.loadExisting();
	    }
	  },
	
	  methods: {
	    onStartChanged: function onStartChanged(date) {
	      this.form.startDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      if (!this.form.endDate || this.form.endDate < this.form.startDate) {
	        this.form.endDate = this.form.startDate;
	      }
	    },
	    onEndChanged: function onEndChanged(date) {
	      this.form.endDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	    },
	    onClassesUpdate: function onClassesUpdate(classes) {
	      this.selectedClasses = classes.slice();
	
	      this.showRemovalWarning = false;
	      this.removalConfirmed = false;
	    },
	    className: function className(id) {
	      var cal = this.klassCalendars.find(function (k) {
	        return k.id === id;
	      });
	      return cal && cal.name ? cal.name : '';
	    },
	    toggleAllClasses: function toggleAllClasses() {
	      this.selectedClasses = this.allClassesSelected ? [] : this.klassCalendars.slice();
	    },
	    loadExisting: function loadExisting() {
	      var _this2 = this;
	
	      this.isLoadingExisting = true;
	      _docendo2.default.specialDaysShow(this.schoolId, this.schoolYearId, this.specialDayId, function (data) {
	        _this2.form = {
	          title: data.title || '',
	          startDate: data.start_date || null,
	          endDate: data.end_date || null,
	          reduct: data.reduct !== false
	        };
	        var ids = data.calendar_ids || [];
	        _this2.selectedClasses = _this2.klassCalendars.filter(function (cal) {
	          return ids.indexOf(cal.id) > -1;
	        });
	        _this2.originalClassIds = ids.slice();
	        _this2.specialDaySubjectIds = Array.isArray(data.subject_ids) ? data.subject_ids.slice() : [];
	        _this2.isLoadingExisting = false;
	      }, function () {
	        _this2.isLoadingExisting = false;
	        _eventbus2.default.toast = { text: _this2.$t('vue2.special_days.error_toast'), success: false };
	      });
	    },
	    buildAttrs: function buildAttrs() {
	      return {
	        title: this.form.title.trim(),
	        start_date: this.form.startDate,
	        end_date: this.form.endDate,
	        reduct: this.form.reduct,
	        calendar_ids: this.selectedClasses.map(function (cal) {
	          return cal.id;
	        })
	      };
	    },
	    save: function save() {
	      this.hasTriedSave = true;
	      if (!this.isValid || this.isSaving) {
	        return;
	      }
	
	      if (this.specialDayId && !this.removalConfirmed && this.affectedRemovedClassNames.length > 0) {
	        this.showRemovalWarning = true;
	        return;
	      }
	      this.doSave();
	    },
	    confirmRemovalAndSave: function confirmRemovalAndSave() {
	      this.removalConfirmed = true;
	      this.showRemovalWarning = false;
	      this.save();
	    },
	    doSave: function doSave() {
	      var _this3 = this;
	
	      this.isSaving = true;
	      var attrs = this.buildAttrs();
	      var onSaved = function onSaved(data) {
	        if (data && data.status === 'error') {
	          _this3.onError();
	          return;
	        }
	        _this3.isSaving = false;
	        _eventbus2.default.toast = { text: _this3.$t('vue2.special_days.saved'), success: true };
	        _this3.$emit('saved');
	      };
	      if (this.specialDayId) {
	        _docendo2.default.specialDaysUpdate(this.schoolId, this.schoolYearId, this.specialDayId, attrs, onSaved, this.onError);
	      } else {
	        _docendo2.default.specialDaysCreate(this.schoolId, this.schoolYearId, attrs, function (data) {
	          if (!(data && data.status === 'error')) {
	            _this3.$store.dispatch('trackEvent', 'specialDays_omlagtDag_created');
	          }
	          onSaved(data);
	        }, this.onError);
	      }
	    },
	    onError: function onError() {
	      this.isSaving = false;
	      _eventbus2.default.toast = { text: this.$t('vue2.special_days.error_toast'), success: false };
	    }
	  }
	};

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'special-day-schedule-modal',
	  components: { DModal: _DModal2.default },
	  props: {
	    schoolId: {
	      default: null
	    },
	    specialDay: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    subjects: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    klassCalendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isScheduling: false,
	      timeError: false,
	      commonStart: '08:00',
	      commonEnd: '12:00',
	      rows: this.subjects.map(function (subject) {
	        return {
	          subject: subject,
	          start: '08:00',
	          end: '12:00',
	          error: false
	        };
	      })
	    };
	  },
	
	  computed: {
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    klassHash: function klassHash() {
	      return this.klassCalendars.reduce(function (obj, klass) {
	        obj[klass.id] = klass;
	        return obj;
	      }, {});
	    },
	    dates: function dates() {
	      var dates = [];
	      if (!this.specialDay || !this.specialDay.start_date) {
	        return dates;
	      }
	      var end = (0, _moment2.default)(this.specialDay.end_date || this.specialDay.start_date);
	      var cur = (0, _moment2.default)(this.specialDay.start_date);
	      while (cur.isSameOrBefore(end, 'day')) {
	        dates.push(cur.format('YYYY-MM-DD'));
	        cur = cur.add(1, 'day');
	      }
	      return dates;
	    },
	    periodLabel: function periodLabel() {
	      if (this.dates.length === 0) {
	        return '';
	      }
	      var start = (0, _moment2.default)(this.dates[0]);
	      var end = (0, _moment2.default)(this.dates[this.dates.length - 1]);
	      if (start.isSame(end, 'day')) {
	        return 'Brikkerne skemalægges ' + start.format('ddd D. MMM YYYY');
	      }
	      return 'Brikkerne skemalægges hver dag ' + start.format('D. MMM') + ' – ' + end.format('D. MMM YYYY') + ' (' + this.dates.length + ' dage)';
	    }
	  },
	  watch: {
	    commonStart: function commonStart(val) {
	      this.rows.forEach(function (row) {
	        row.start = val;
	        row.error = false;
	      });
	      this.timeError = false;
	    },
	    commonEnd: function commonEnd(val) {
	      this.rows.forEach(function (row) {
	        row.end = val;
	        row.error = false;
	      });
	      this.timeError = false;
	    }
	  },
	  mounted: function mounted() {
	    document.body.classList.add('no-scroll');
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.body.classList.remove('no-scroll');
	  },
	
	  methods: {
	    classNames: function classNames(subject) {
	      var _this = this;
	
	      var ids = [];
	      if (subject.calendar_id) {
	        ids.push(subject.calendar_id);
	      }
	      if (Array.isArray(subject.calendar_ids)) {
	        subject.calendar_ids.forEach(function (id) {
	          return ids.push(id);
	        });
	      }
	      var seen = {};
	      var names = [];
	      ids.forEach(function (id) {
	        if (seen[id] || !_this.klassHash[id]) {
	          return;
	        }
	        seen[id] = true;
	        names.push(_this.klassHash[id].name);
	      });
	      return names.join(', ');
	    },
	    buildCalendarIds: function buildCalendarIds(subject) {
	      var _this2 = this;
	
	      var ids = [];
	      var add = function add(id) {
	        if (id && ids.indexOf(id) === -1) {
	          ids.push(id);
	        }
	      };
	      add(subject.calendar_id);
	      var list = Array.isArray(subject.calendar_ids) ? subject.calendar_ids : [];
	      list.forEach(function (id) {
	        var cal = _this2.allCalendarsInHash[id];
	        if (!cal || cal.type !== 'school') {
	          add(id);
	        }
	      });
	      return ids;
	    },
	    runSchedule: function runSchedule() {
	      var _this3 = this;
	
	      if (this.isScheduling || this.rows.length === 0) {
	        return;
	      }
	
	      this.timeError = false;
	      var hasError = false;
	      this.rows.forEach(function (row) {
	        var invalid = !row.start || !row.end || row.end <= row.start;
	        row.error = invalid;
	        if (invalid) {
	          hasError = true;
	        }
	      });
	      if (hasError) {
	        this.timeError = true;
	        return;
	      }
	
	      var tasks = [];
	      this.rows.forEach(function (row) {
	        var subject = row.subject;
	        var calendarIds = _this3.buildCalendarIds(subject);
	        _this3.dates.forEach(function (date) {
	          var start = (0, _moment2.default)(date + ' ' + row.start, 'YYYY-MM-DD HH:mm').format();
	          var end = (0, _moment2.default)(date + ' ' + row.end, 'YYYY-MM-DD HH:mm').format();
	          tasks.push({ subject: subject, calendarIds: calendarIds, start: start, end: end });
	        });
	      });
	
	      if (tasks.length === 0) {
	        this.$emit('close');
	        return;
	      }
	
	      this.isScheduling = true;
	      var completed = 0;
	      var failed = 0;
	      var total = tasks.length;
	      var onDone = function onDone() {
	        completed++;
	        if (completed === total) {
	          _this3.isScheduling = false;
	          if (failed > 0) {
	            _eventbus2.default.toast = { text: 'Nogle brikker kunne ikke skemalægges (' + failed + ' af ' + total + ')', success: false };
	          } else {
	            _eventbus2.default.toast = { text: 'Brikkerne blev skemalagt', success: true };
	          }
	          _this3.$emit('scheduled');
	          _this3.$emit('close');
	        }
	      };
	      tasks.forEach(function (task) {
	        _docendo2.default.createEvent(_this3.schoolId, task.subject.calendar_id, task.calendarIds, task.subject.id, task.start, task.end, '', '', '', '', function () {
	          return onDone();
	        }, function () {
	          failed++;
	          onDone();
	        });
	      });
	    }
	  }
	};

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _SubjectForm = __webpack_require__(70);
	
	var _SubjectForm2 = _interopRequireDefault(_SubjectForm);
	
	var _SpecialDayScheduleModal = __webpack_require__(1611);
	
	var _SpecialDayScheduleModal2 = _interopRequireDefault(_SpecialDayScheduleModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'special-day-subjects-list-modal',
	  components: { DModal: _DModal2.default, SubjectForm: _SubjectForm2.default, SpecialDayScheduleModal: _SpecialDayScheduleModal2.default },
	  props: {
	    schoolId: {
	      default: null
	    },
	    schoolYearId: {
	      default: null
	    },
	    specialDay: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    klassCalendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      editSubject: null,
	      isSubjectModal: false,
	      isSubjectLoading: false,
	      isScheduleModal: false,
	      confirmingDeleteId: null,
	      isDeleting: false
	    };
	  },
	
	  computed: {
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    klassHash: function klassHash() {
	      return this.klassCalendars.reduce(function (obj, klass) {
	        obj[klass.id] = klass;
	        return obj;
	      }, {});
	    },
	    dayTitle: function dayTitle() {
	      return this.specialDay && this.specialDay.title ? this.specialDay.title : 'omlagt dag';
	    },
	    subjects: function subjects() {
	      var _this = this;
	
	      var ids = this.specialDay && this.specialDay.subject_ids || [];
	      return ids.map(function (id) {
	        return _this.subjectsInHash[id];
	      }).filter(function (subject) {
	        return !!subject;
	      });
	    }
	  },
	  mounted: function mounted() {
	    document.body.classList.add('no-scroll');
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.body.classList.remove('no-scroll');
	  },
	
	  methods: {
	    canDeleteSubject: function canDeleteSubject(subject) {
	      return subject.can_delete !== false;
	    },
	    formatHours: function formatHours(hours) {
	      var num = parseFloat(hours);
	      return isNaN(num) ? '0' : String(num);
	    },
	    classNames: function classNames(subject) {
	      var _this2 = this;
	
	      var ids = [];
	      if (subject.calendar_id) {
	        ids.push(subject.calendar_id);
	      }
	      if (Array.isArray(subject.calendar_ids)) {
	        subject.calendar_ids.forEach(function (id) {
	          return ids.push(id);
	        });
	      }
	      var seen = {};
	      var names = [];
	      ids.forEach(function (id) {
	        if (seen[id] || !_this2.klassHash[id]) {
	          return;
	        }
	        seen[id] = true;
	        names.push(_this2.klassHash[id].name);
	      });
	      return names.join(', ');
	    },
	    teacherNames: function teacherNames(subject) {
	      var _this3 = this;
	
	      var ids = Array.isArray(subject.calendar_ids) ? subject.calendar_ids : [];
	      var seen = {};
	      var names = [];
	      ids.forEach(function (id) {
	        var cal = _this3.allCalendarsInHash[id];
	        if (seen[id] || !cal || cal.type !== 'user' || !cal.name) {
	          return;
	        }
	        seen[id] = true;
	        names.push(cal.name);
	      });
	      return names.join(', ');
	    },
	    openSchedule: function openSchedule() {
	      if (this.subjects.length === 0) {
	        return;
	      }
	      this.isScheduleModal = true;
	    },
	    onScheduled: function onScheduled() {
	      this.isScheduleModal = false;
	      this.$emit('changed');
	    },
	    startEdit: function startEdit(subject) {
	      this.openSubjectForm(subject.id);
	    },
	    openSubjectForm: function openSubjectForm(subjectId, tab) {
	      var _this4 = this;
	
	      this.confirmingDeleteId = null;
	      this.isSubjectLoading = true;
	      this.isSubjectModal = true;
	      _docendo2.default.showSubject(subjectId, function (success) {
	        _this4.editSubject = tab ? (0, _assign2.default)({}, success, { _openTab: tab }) : (0, _assign2.default)({}, success);
	        _this4.isSubjectLoading = false;
	      }, function () {
	        _this4.isSubjectLoading = false;
	        _this4.isSubjectModal = false;
	        _this4.editSubject = null;
	        _eventbus2.default.toast = { text: 'Kunne ikke hente brikken', success: false };
	      });
	    },
	    closeSubjectModal: function closeSubjectModal() {
	      this.isSubjectModal = false;
	      this.editSubject = null;
	    },
	    updateSubject: function updateSubject(updatedSubject) {
	      if (!updatedSubject.schoolId) {
	        updatedSubject.schoolId = this.schoolId;
	      }
	      if (!updatedSubject.schoolYearId) {
	        updatedSubject.schoolYearId = this.schoolYearId;
	      }
	      this.$store.dispatch('updateSubject', updatedSubject);
	      this.closeSubjectModal();
	      this.$emit('changed');
	    },
	    saveAndShowTab: function saveAndShowTab(updatedSubject, tab) {
	      var _this5 = this;
	
	      var subjectId = updatedSubject.id;
	      this.updateSubject(updatedSubject);
	      setTimeout(function () {
	        _this5.openSubjectForm(subjectId, tab);
	      }, 500);
	    },
	    handleDeleteSubject: function handleDeleteSubject(subject) {
	      var deletedSubject = {
	        id: subject.id,
	        school_id: subject.school_id || this.schoolId,
	        school_year_id: this.schoolYearId,
	        schoolYearId: this.schoolYearId
	      };
	      this.$store.dispatch('deleteSubject', deletedSubject);
	      this.closeSubjectModal();
	      this.$emit('changed');
	    },
	    runDelete: function runDelete(subject) {
	      var _this6 = this;
	
	      if (this.isDeleting) {
	        return;
	      }
	      if (!this.canDeleteSubject(subject)) {
	        this.confirmingDeleteId = null;
	        _eventbus2.default.toast = { text: 'Brikken kan ikke slettes, da den er skemalagt', success: false };
	        return;
	      }
	      this.isDeleting = true;
	      _docendo2.default.deleteSubject(subject.id, this.schoolId, this.schoolYearId, function (data) {
	        var deleted = typeof data === 'string' ? JSON.parse(data) : data;
	        _this6.isDeleting = false;
	        _this6.confirmingDeleteId = null;
	        if (!deleted || !deleted.id) {
	          _eventbus2.default.toast = { text: 'Brikken kan ikke slettes, da den er skemalagt', success: false };
	          _this6.$emit('changed');
	          return;
	        }
	        _this6.$store.commit('deleteSubject', deleted);
	        _eventbus2.default.toast = { text: 'Brikken blev slettet', success: true };
	        _this6.$emit('changed');
	      }, function () {
	        _this6.isDeleting = false;
	        _eventbus2.default.toast = { text: 'Brikken kunne ikke slettes', success: false };
	      });
	    }
	  }
	};

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _ColorPicker = __webpack_require__(68);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	var _SubjectFormSubjectType = __webpack_require__(61);
	
	var _SubjectFormSubjectType2 = _interopRequireDefault(_SubjectFormSubjectType);
	
	var _DSelectCalsIds = __webpack_require__(40);
	
	var _DSelectCalsIds2 = _interopRequireDefault(_DSelectCalsIds);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'special-day-subjects-modal',
	  components: { DModal: _DModal2.default, ColorPicker: _ColorPicker2.default, SubjectTypePicker: _SubjectFormSubjectType2.default, DSelectCalendarIds: _DSelectCalsIds2.default, Tabs: _Tabs2.default },
	  props: {
	    schoolId: {
	      default: null
	    },
	    schoolYearId: {
	      default: null
	    },
	
	    specialDay: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    klassCalendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    existingSubjects: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isSaving: false,
	      name: this.specialDay && this.specialDay.title ? this.specialDay.title : '',
	      hours: 0,
	      color: '#A0A5EF',
	      subjectType: 'subject',
	      mode: 'per_class',
	      rows: [],
	
	      savedRowsByMode: { per_class: null, combined: null },
	      rowUid: 0,
	      originalKlassIds: [],
	      nameError: false,
	      rowsError: false
	    };
	  },
	
	  computed: {
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    existingKlassIds: function existingKlassIds() {
	      var _this = this;
	
	      var ids = [];
	      this.existingSubjects.forEach(function (subject) {
	        var subjectIds = [];
	        if (subject.calendar_id) {
	          subjectIds.push(subject.calendar_id);
	        }
	        if (Array.isArray(subject.calendar_ids)) {
	          subject.calendar_ids.forEach(function (id) {
	            return subjectIds.push(id);
	          });
	        }
	        subjectIds.forEach(function (id) {
	          if (_this.klassCalendars.some(function (k) {
	            return k.id === id;
	          }) && ids.indexOf(id) === -1) {
	            ids.push(id);
	          }
	        });
	      });
	      return ids;
	    },
	    headerTitle: function headerTitle() {
	      return this.name && this.name.length > 0 ? this.name : 'Opret brikker';
	    },
	    modeTabs: function modeTabs() {
	      return [{ id: 'per_class', title: 'En brik pr. klasse' }, { id: 'combined', title: 'En samlet brik' }];
	    },
	    subjectCount: function subjectCount() {
	      return this.rows.filter(function (r) {
	        return r.klassIds.length > 0;
	      }).length;
	    },
	    brikLabel: function brikLabel() {
	      return this.subjectCount === 1 ? '1 brik' : this.subjectCount + ' brikker';
	    },
	    duplicateKlassNames: function duplicateKlassNames() {
	      var _this2 = this;
	
	      var counts = {};
	      this.rows.forEach(function (row) {
	        row.klassIds.forEach(function (id) {
	          counts[id] = (counts[id] || 0) + 1;
	        });
	      });
	      return (0, _keys2.default)(counts).filter(function (id) {
	        return counts[id] > 1;
	      }).map(function (id) {
	        return _this2.klassName(Number(id));
	      });
	    },
	    missingKlassNames: function missingKlassNames() {
	      var _this3 = this;
	
	      var used = this.existingKlassIds.slice();
	      this.rows.forEach(function (row) {
	        row.klassIds.forEach(function (id) {
	          if (used.indexOf(id) === -1) {
	            used.push(id);
	          }
	        });
	      });
	      return this.originalKlassIds.filter(function (id) {
	        return used.indexOf(id) === -1;
	      }).map(function (id) {
	        return _this3.klassName(id);
	      });
	    }
	  },
	  watch: {
	    hours: function hours(val) {
	      this.rows.forEach(function (row) {
	        row.hours = val;
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    var ids = this.specialDay && this.specialDay.calendar_ids || [];
	    var klassIds = ids.filter(function (id) {
	      return _this4.klassCalendars.some(function (k) {
	        return k.id === id;
	      });
	    }).sort(function (a, b) {
	      return _this4.klassName(a).localeCompare(_this4.klassName(b), 'da');
	    });
	    this.originalKlassIds = klassIds.slice();
	    if (this.existingSubjects.length > 0) {
	      this.addRow();
	    } else if (klassIds.length > 0) {
	      klassIds.forEach(function (id) {
	        return _this4.rows.push({ uid: _this4.rowUid++, klassIds: [id], teacherIds: [], hours: _this4.hours });
	      });
	    } else {
	      this.addRow();
	    }
	    this.$nextTick(function () {
	      if (_this4.$refs.input_name) {
	        _this4.$refs.input_name.focus();
	      }
	    });
	    document.body.classList.add('no-scroll');
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.body.classList.remove('no-scroll');
	  },
	
	  methods: {
	    klassName: function klassName(id) {
	      var klass = this.klassCalendars.find(function (k) {
	        return k.id === id;
	      });
	      return klass && klass.name ? klass.name : '';
	    },
	    formatHours: function formatHours(hours) {
	      var num = parseFloat(hours);
	      return isNaN(num) ? '0' : String(num);
	    },
	    existingKlasseNames: function existingKlasseNames(subject) {
	      var _this5 = this;
	
	      var ids = [];
	      if (subject.calendar_id) {
	        ids.push(subject.calendar_id);
	      }
	      if (Array.isArray(subject.calendar_ids)) {
	        subject.calendar_ids.forEach(function (id) {
	          return ids.push(id);
	        });
	      }
	      var seen = {};
	      var names = [];
	      ids.forEach(function (id) {
	        if (seen[id]) {
	          return;
	        }
	        seen[id] = true;
	        var name = _this5.klassName(id);
	        if (name) {
	          names.push(name);
	        }
	      });
	      return names.join(', ');
	    },
	    existingTeacherNames: function existingTeacherNames(subject) {
	      var _this6 = this;
	
	      var ids = Array.isArray(subject.calendar_ids) ? subject.calendar_ids : [];
	      var seen = {};
	      var names = [];
	      ids.forEach(function (id) {
	        var cal = _this6.allCalendarsInHash[id];
	        if (seen[id] || !cal || cal.type !== 'user' || !cal.name) {
	          return;
	        }
	        seen[id] = true;
	        names.push(cal.name);
	      });
	      return names.join(', ');
	    },
	    setMode: function setMode(mode) {
	      var _this7 = this;
	
	      if (mode === this.mode) {
	        return;
	      }
	
	      this.savedRowsByMode[this.mode] = this.rows.map(function (r) {
	        return {
	          klassIds: r.klassIds.slice(),
	          teacherIds: r.teacherIds.slice()
	        };
	      });
	
	      var klassIds = [];
	      this.rows.forEach(function (r) {
	        r.klassIds.forEach(function (id) {
	          if (klassIds.indexOf(id) === -1) {
	            klassIds.push(id);
	          }
	        });
	      });
	      klassIds.sort(function (a, b) {
	        return _this7.klassName(a).localeCompare(_this7.klassName(b), 'da');
	      });
	
	      var saved = this.savedRowsByMode[mode];
	      if (mode === 'combined') {
	        var teacherIds = saved && saved.length > 0 ? saved[0].teacherIds.slice() : [];
	        this.rows = [{ uid: this.rowUid++, klassIds: klassIds, teacherIds: teacherIds, hours: this.hours }];
	      } else {
	        if (klassIds.length > 0) {
	          this.rows = klassIds.map(function (id) {
	            var savedRow = saved ? saved.find(function (r) {
	              return r.klassIds.indexOf(id) > -1;
	            }) : null;
	            var teacherIds = savedRow ? savedRow.teacherIds.slice() : [];
	            return { uid: _this7.rowUid++, klassIds: [id], teacherIds: teacherIds, hours: _this7.hours };
	          });
	        } else {
	          this.rows = [{ uid: this.rowUid++, klassIds: [], teacherIds: [], hours: this.hours }];
	        }
	      }
	      this.mode = mode;
	    },
	    selectAllOnFocus: function selectAllOnFocus(evt) {
	      setTimeout(function () {
	        return evt.target.select();
	      }, 0);
	    },
	    addRow: function addRow() {
	      this.rows.unshift({ uid: this.rowUid++, klassIds: [], teacherIds: [], hours: this.hours });
	    },
	    removeRow: function removeRow(row) {
	      var idx = this.rows.indexOf(row);
	      if (idx > -1) {
	        this.rows.splice(idx, 1);
	      }
	    },
	    setKlasses: function setKlasses(row, klasses) {
	      row.klassIds = klasses.map(function (k) {
	        return k.id;
	      });
	      if (row.klassIds.length > 0) {
	        this.$set(row, 'klassError', false);
	      }
	      this.rowsError = false;
	    },
	    setTeachers: function setTeachers(row, teachers) {
	      row.teacherIds = teachers.map(function (t) {
	        return t.id;
	      });
	      if (row.teacherIds.length === 0) {
	        this.$set(row, 'klassError', false);
	      }
	    },
	    validate: function validate() {
	      var _this8 = this;
	
	      this.nameError = !this.name || this.name.trim().length === 0;
	
	      var hasRowError = false;
	      this.rows.forEach(function (row) {
	        var isError = row.klassIds.length === 0 && row.teacherIds.length > 0;
	        _this8.$set(row, 'klassError', isError);
	        if (isError) {
	          hasRowError = true;
	        }
	      });
	      var validRows = this.rows.filter(function (r) {
	        return r.klassIds.length > 0;
	      });
	      this.rowsError = validRows.length === 0;
	      return !this.nameError && !this.rowsError && !hasRowError;
	    },
	    subjectBase: function subjectBase() {
	      return {
	        name: this.name.trim(),
	        color: this.color,
	        default_duration: 60,
	        subject_type: this.subjectType,
	        special_day_id: this.specialDay ? this.specialDay.id : null,
	        from_date: this.specialDay ? this.specialDay.start_date : null,
	        to_date: this.specialDay ? this.specialDay.end_date : null
	      };
	    },
	    buildSubjects: function buildSubjects() {
	      var _this9 = this;
	
	      return this.rows.filter(function (r) {
	        return r.klassIds.length > 0;
	      }).map(function (r) {
	        return (0, _assign2.default)({}, _this9.subjectBase(), {
	          calendar_id: r.klassIds[0],
	          calendar_ids: r.klassIds.slice(1).concat(r.teacherIds),
	          hours: Number(r.hours) || 0
	        });
	      });
	    },
	    create: function create() {
	      var _this10 = this;
	
	      if (this.isSaving || !this.validate()) {
	        return;
	      }
	      this.isSaving = true;
	      var subjects = this.buildSubjects();
	      _docendo2.default.bulkCreateSubjects(this.schoolId, this.schoolYearId, subjects, function (data) {
	        if (data && data.status === 'error') {
	          _this10.onError();
	          return;
	        }
	        _this10.isSaving = false;
	        var errors = data && data.errors ? data.errors : [];
	        if (errors.length > 0) {
	          _eventbus2.default.toast = { text: 'Nogle brikker kunne ikke oprettes', success: false };
	        } else {
	          _eventbus2.default.toast = { text: 'Brikkerne blev oprettet', success: true };
	        }
	        _this10.$emit('created');
	      }, this.onError);
	    },
	    onError: function onError() {
	      this.isSaving = false;
	      _eventbus2.default.toast = { text: 'Noget gik galt. Prøv igen.', success: false };
	    }
	  }
	};

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SpecialDayModal = __webpack_require__(1610);
	
	var _SpecialDayModal2 = _interopRequireDefault(_SpecialDayModal);
	
	var _SpecialDayCalendarModal = __webpack_require__(1609);
	
	var _SpecialDayCalendarModal2 = _interopRequireDefault(_SpecialDayCalendarModal);
	
	var _SpecialDaySubjectsModal = __webpack_require__(1613);
	
	var _SpecialDaySubjectsModal2 = _interopRequireDefault(_SpecialDaySubjectsModal);
	
	var _SpecialDaySubjectsListModal = __webpack_require__(1612);
	
	var _SpecialDaySubjectsListModal2 = _interopRequireDefault(_SpecialDaySubjectsListModal);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'special-days',
	  components: { Loader: _Loader2.default, SpecialDayModal: _SpecialDayModal2.default, SpecialDayCalendarModal: _SpecialDayCalendarModal2.default, SpecialDaySubjectsModal: _SpecialDaySubjectsModal2.default, SpecialDaySubjectsListModal: _SpecialDaySubjectsListModal2.default, ModalConfirmation: _ModalConfirmation2.default, ChangeSchoolYear: _ChangeSchoolYear2.default },
	  data: function data() {
	    return {
	      isLoading: true,
	      specialDays: [],
	      isModalOpen: false,
	      isCalModalOpen: false,
	      subjectsForDay: null,
	      subjectsListForDay: null,
	      editingId: null,
	      deleting: null,
	      subjectsToDelete: [],
	      isDeleting: false,
	      isRefreshingReductions: false
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.$store.getters.schoolYearId;
	    },
	    klassCalendars: function klassCalendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    klassCalendarsInHash: function klassCalendarsInHash() {
	      return this.$store.getters.allKlassCalendarsInHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    schoolYearStartDate: function schoolYearStartDate() {
	      var year = this.$store.state.localActivatedSchoolYear;
	      return year && year.student_time_start ? year.student_time_start : null;
	    },
	    schoolYearEndDate: function schoolYearEndDate() {
	      var year = this.$store.state.localActivatedSchoolYear;
	      return year && year.student_time_end ? year.student_time_end : null;
	    },
	    canCreate: function canCreate() {
	      return !!this.schoolId && !!this.schoolYearId;
	    },
	    shortcutTooltip: function shortcutTooltip() {
	      return '<p class="tooltip-shortcut">' + this.$t('vue2.special_days.create') + '<span>N</span></p>';
	    }
	  },
	  watch: {
	    schoolYearId: function schoolYearId() {
	      this.readList();
	      this.loadSubjects();
	    }
	  },
	  mounted: function mounted() {
	    if (this.schoolYearId) {
	      this.readList();
	      this.loadSubjects();
	    }
	    document.addEventListener('keydown', this.handleKeydown);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this.handleKeydown);
	  },
	
	  methods: {
	    handleKeydown: function handleKeydown(event) {
	      if (event.key !== 'n' && event.key !== 'N') {
	        return;
	      }
	      if (event.metaKey || event.ctrlKey || event.altKey) {
	        return;
	      }
	      if (this.isModalOpen || this.deleting) {
	        return;
	      }
	      var el = event.target;
	      var tag = el && el.tagName ? el.tagName.toUpperCase() : '';
	      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el && el.isContentEditable) {
	        return;
	      }
	      if (!this.canCreate) {
	        return;
	      }
	      event.preventDefault();
	      this.openCreate();
	    },
	    readList: function readList() {
	      var _this = this;
	
	      if (!this.schoolId || !this.schoolYearId) {
	        return;
	      }
	      this.isLoading = true;
	      _docendo2.default.specialDaysIndex(this.schoolId, this.schoolYearId, function (data) {
	        _this.specialDays = Array.isArray(data) ? data : [];
	        _this.isLoading = false;
	      }, function () {
	        _this.specialDays = [];
	        _this.isLoading = false;
	        _eventbus2.default.toast = { text: _this.$t('vue2.special_days.error_toast'), success: false };
	      });
	    },
	    formatPeriod: function formatPeriod(item) {
	      var start = item.start_date ? (0, _moment2.default)(item.start_date) : null;
	      var end = item.end_date ? (0, _moment2.default)(item.end_date) : null;
	      if (!start) {
	        return '';
	      }
	      if (!end || start.isSame(end, 'day')) {
	        return start.format('ddd D. MMM YYYY');
	      }
	      return start.format('D. MMM') + ' – ' + end.format('D. MMM YYYY');
	    },
	    reductDays: function reductDays(item) {
	      var start = item.start_date ? (0, _moment2.default)(item.start_date) : null;
	      if (!start) {
	        return 0;
	      }
	      var end = item.end_date ? (0, _moment2.default)(item.end_date) : start;
	      return Math.max(1, end.diff(start, 'days') + 1);
	    },
	    reductDaysLabel: function reductDaysLabel(item) {
	      var days = this.reductDays(item);
	      return days + ' ' + (days === 1 ? this.$t('vue2.special_days.day') : this.$t('vue2.special_days.days'));
	    },
	    loadSubjects: function loadSubjects() {
	      if (this.schoolYearId) {
	        this.$store.dispatch('readSubjects', this.schoolYearId);
	      }
	    },
	    linkedSubjects: function linkedSubjects(item) {
	      var _this2 = this;
	
	      var ids = item && item.subject_ids || [];
	      return ids.map(function (id) {
	        return _this2.subjectsInHash[id];
	      }).filter(function (subject) {
	        return !!subject;
	      });
	    },
	    classNames: function classNames(item) {
	      var _this3 = this;
	
	      var ids = item.calendar_ids || [];
	      if (ids.length === 0) {
	        return '–';
	      }
	      var names = ids.map(function (id) {
	        return _this3.klassCalendarsInHash[id] ? _this3.klassCalendarsInHash[id].name : null;
	      }).filter(function (name) {
	        return !!name;
	      }).sort(function (a, b) {
	        return a.localeCompare(b, 'da', { numeric: true, sensitivity: 'base' });
	      });
	      return names.length > 0 ? names.join(', ') : ids.length;
	    },
	    openCreate: function openCreate() {
	      this.editingId = null;
	      this.isModalOpen = true;
	    },
	    openSubjects: function openSubjects(item) {
	      this.subjectsForDay = item;
	    },
	    onSubjectsCreated: function onSubjectsCreated() {
	      this.subjectsForDay = null;
	      this.readList();
	      this.loadSubjects();
	    },
	    brikkerLabel: function brikkerLabel(item) {
	      var count = this.linkedSubjects(item).length;
	      return count + ' ' + (count === 1 ? 'brik' : 'brikker');
	    },
	    openSubjectsList: function openSubjectsList(item, event) {
	      if (event && event.currentTarget && event.currentTarget.blur) {
	        event.currentTarget.blur();
	      }
	      this.subjectsListForDay = item;
	    },
	    openSubjectsFromList: function openSubjectsFromList() {
	      var item = this.subjectsListForDay;
	      this.subjectsListForDay = null;
	      this.subjectsForDay = item;
	    },
	    onSubjectsChanged: function onSubjectsChanged() {
	      var _this4 = this;
	
	      _docendo2.default.specialDaysIndex(this.schoolId, this.schoolYearId, function (data) {
	        _this4.specialDays = Array.isArray(data) ? data : [];
	        if (_this4.subjectsListForDay) {
	          var refreshed = _this4.specialDays.find(function (day) {
	            return day.id === _this4.subjectsListForDay.id;
	          });
	          _this4.subjectsListForDay = refreshed || null;
	        }
	      }, function () {});
	    },
	    openCalCreate: function openCalCreate() {
	      this.editingId = null;
	      this.isCalModalOpen = true;
	    },
	    closeCalModal: function closeCalModal() {
	      this.isCalModalOpen = false;
	      this.editingId = null;
	    },
	    onCalSaved: function onCalSaved() {
	      this.closeCalModal();
	      this.readList();
	      this.updateReductions();
	    },
	    openEdit: function openEdit(item) {
	      this.editingId = item.id;
	      this.isModalOpen = true;
	    },
	    closeModal: function closeModal() {
	      this.isModalOpen = false;
	      this.editingId = null;
	    },
	    onSaved: function onSaved() {
	      this.closeModal();
	      this.readList();
	      this.updateReductions();
	    },
	    updateReductions: function updateReductions() {
	      if (!this.canCreate) {
	        return;
	      }
	      _docendo2.default.specialDaysUpdateReductions(this.schoolId, this.schoolYearId, function () {}, function () {});
	    },
	    refreshReductions: function refreshReductions() {
	      var _this5 = this;
	
	      if (!this.canCreate || this.isRefreshingReductions) {
	        return;
	      }
	      this.isRefreshingReductions = true;
	      _docendo2.default.specialDaysUpdateReductions(this.schoolId, this.schoolYearId, function () {
	        _this5.isRefreshingReductions = false;
	        _eventbus2.default.toast = { text: _this5.$t('vue2.special_days.reductions_updated'), success: true };
	      }, function () {
	        _this5.isRefreshingReductions = false;
	        _eventbus2.default.toast = { text: _this5.$t('vue2.special_days.error_toast'), success: false };
	      });
	    },
	    canDeleteSubject: function canDeleteSubject(subject) {
	      return subject.can_delete !== false;
	    },
	    toggleSubjectToDelete: function toggleSubjectToDelete(subject) {
	      if (!this.canDeleteSubject(subject)) {
	        return;
	      }
	      var idx = this.subjectsToDelete.indexOf(subject.id);
	      if (idx > -1) {
	        this.subjectsToDelete.splice(idx, 1);
	      } else {
	        this.subjectsToDelete.push(subject.id);
	      }
	    },
	    confirmDelete: function confirmDelete(item) {
	      var _this6 = this;
	
	      this.deleting = item;
	      this.subjectsToDelete = this.linkedSubjects(item).filter(function (subject) {
	        return _this6.canDeleteSubject(subject);
	      }).map(function (subject) {
	        return subject.id;
	      });
	    },
	    runDelete: function runDelete() {
	      var _this7 = this;
	
	      if (!this.deleting || this.isDeleting) {
	        return;
	      }
	      this.isDeleting = true;
	      var id = this.deleting.id;
	      var subjectIds = this.subjectsToDelete.slice();
	      if (subjectIds.length === 0) {
	        this.destroySpecialDay(id);
	        return;
	      }
	      _docendo2.default.bulkDeleteSubjects(this.schoolId, subjectIds, function (data) {
	        var result = typeof data === 'string' ? JSON.parse(data) : data;
	        var deleted = result && result.deleted || [];
	        deleted.forEach(function (subject) {
	          return _this7.$store.commit('deleteSubject', subject);
	        });
	        _this7.destroySpecialDay(id);
	      }, function () {
	        _this7.resetDeleteState();
	        _eventbus2.default.toast = { text: _this7.$t('vue2.special_days.error_toast'), success: false };
	      });
	    },
	    destroySpecialDay: function destroySpecialDay(id) {
	      var _this8 = this;
	
	      _docendo2.default.specialDaysDestroy(this.schoolId, this.schoolYearId, id, function () {
	        _this8.resetDeleteState();
	        _eventbus2.default.toast = { text: _this8.$t('vue2.special_days.deleted_toast'), success: true };
	        _this8.readList();
	        _this8.updateReductions();
	      }, function () {
	        _this8.resetDeleteState();
	        _eventbus2.default.toast = { text: _this8.$t('vue2.special_days.error_toast'), success: false };
	      });
	    },
	    resetDeleteState: function resetDeleteState() {
	      this.isDeleting = false;
	      this.deleting = null;
	      this.subjectsToDelete = [];
	    }
	  }
	};

/***/ }),
/* 711 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    query: {
	      type: String,
	      default: ''
	    },
	    calendarType: {
	      type: String,
	      default: 'students'
	    }
	  },
	  data: function data() {
	    return {
	      searchQuery: '',
	      search_timeout: null
	    };
	  },
	
	  computed: {
	    searchedCalendars: function searchedCalendars() {
	      var _this = this;
	
	      return this.searchQuery.length > 0 ? this.activeCalendars.filter(function (cal) {
	        return cal.name !== null ? cal.name.match(new RegExp(_this.searchQuery, 'i')) : '';
	      }) : [];
	    },
	    activeCalendars: function activeCalendars() {
	      return this.calendarType === 'students' ? this.students : this.users;
	    },
	    calendars: function calendars() {
	      return this.$store.state.calendars;
	    },
	    students: function students() {
	      return this.$store.getters.allStudentCalendars;
	    },
	    users: function users() {
	      return this.$store.getters.userCalendars;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    }
	  },
	  watch: {
	    query: function query(val, oldVal) {
	      this.debounceSearch(val);
	    }
	  },
	  methods: {
	    debounceSearch: function debounceSearch(val) {
	      var _this2 = this;
	
	      if (this.search_timeout) {
	        clearTimeout(this.search_timeout);
	      }
	      this.search_timeout = setTimeout(function (_) {
	        _this2.searchQuery = val;
	      }, 400);
	    },
	    getStudentKlasses: function getStudentKlasses(student) {
	      var _this3 = this;
	
	      if (student.klasses) {
	        return student.klasses.map(function (calId) {
	          if (_this3.allCalendarsInHash[calId]) {
	            return _this3.allCalendarsInHash[calId];
	          }
	        });
	      } else {
	        return [];
	      }
	    }
	  }
	};

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _feide = __webpack_require__(1420);
	
	var _feide2 = _interopRequireDefault(_feide);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _CreateStudents = __webpack_require__(1476);
	
	var _CreateStudents2 = _interopRequireDefault(_CreateStudents);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Spinner = __webpack_require__(26);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ChangeSchoolYear: _ChangeSchoolYear2.default, Spinner: _Spinner2.default, ModalConfirmation: _ModalConfirmation2.default, Loader: _Loader2.default, DModal: _DModal2.default, CreateStudents: _CreateStudents2.default },
	  data: function data() {
	    return {
	      theActiveFilter: 'filter__activatedStudents',
	      feideLogo: _feide2.default,
	      dragStudents: [],
	      dragEvt: null,
	      theActiveStudent: null,
	      isHoverOnKlass: false,
	      editName: '',
	      editFeide: '',
	      isEditStudentChanges: false,
	      isEditStudentConfirmation: false,
	      theLatestFeideImport: null,
	      isImporting: false,
	      offsetTop: 0
	    };
	  },
	
	  computed: {
	    bodyStyleObj: function bodyStyleObj() {
	      var offsetHeight = this.offsetTop + 20;
	      return {
	        overflow: 'auto',
	        maxHeight: 'calc(100vh - ' + offsetHeight + 'px)'
	      };
	    },
	    localActivatedSchoolYear: function localActivatedSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isFeideActive: function isFeideActive() {
	      return false;
	    },
	    isFeideImportActive: function isFeideImportActive() {
	      return false;
	    },
	    lastUpdateFromFeide: function lastUpdateFromFeide() {
	      var ddate = (0, _moment2.default)().subtract(2, 'hour');
	      return this.theLatestFeideImport ? (0, _moment2.default)(this.theLatestFeideImport).format('LLL') : (0, _moment2.default)(ddate).format('LLL');
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    isLoadingCalendarRelations: function isLoadingCalendarRelations() {
	      return this.$store.state.isLoadingCalendarRelations;
	    },
	    isLoading: function isLoading() {
	      return this.isLoadingSchoolCalenders || this.isLoadingCalendarRelations;
	    },
	    students: function students() {
	      return this.$store.getters.allStudentCalendars;
	    },
	    studentsWithoutKlasses: function studentsWithoutKlasses() {
	      return this.students.filter(function (student) {
	        return student.klasses.length === 0;
	      });
	    },
	    studentsActivated: function studentsActivated() {
	      return this.students.filter(function (student) {
	        return !student.archived_at;
	      });
	    },
	    filteredStudents: function filteredStudents() {
	      var _this = this;
	
	      var students = [];
	      if (this.theActiveFilter === '') {
	        students = this.students;
	      } else if (this.theActiveFilter === 'filter__students_without_groups') {
	        students = this.studentsWithoutKlasses;
	      } else if (this.theActiveFilter === 'filter__activatedStudents') {
	        students = this.studentsActivated;
	      } else {
	        students = this.students.filter(function (student) {
	          var idx = student.klasses.indexOf(_this.theActiveFilter);
	          if (idx > -1) {
	            return student;
	          }
	        });
	      }
	      return students.map(function (stud) {
	        var iSSelectedForDrag = _this.dragStudents.findIndex(function (dragStudent) {
	          return dragStudent.id === stud.id;
	        }) > -1;
	        _this.$set(stud, 'v_klasses', _this.getStudentKlasses(stud));
	        _this.$set(stud, 'v_isSelectedForDrag', iSSelectedForDrag);
	        return stud;
	      });
	    },
	    klassCalendars: function klassCalendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    relations: function relations() {
	      return this.$store.state.calendarRelations;
	    },
	    schoolYears: function schoolYears() {
	      return this.$store.state.schoolYears;
	    },
	    schoolYearsInHash: function schoolYearsInHash() {
	      return this.schoolYears.reduce(function (obj, item) {
	        obj[item.id] = item;
	        return obj;
	      }, {});
	    }
	  },
	  methods: {
	    updateOffsetTop: function updateOffsetTop() {
	      if (this.$refs.students_col1_body) {
	        this.offsetTop = this.$refs.students_col1_body.getBoundingClientRect().top;
	      }
	    },
	    setStudentsSelectedForDrag: function setStudentsSelectedForDrag(student) {
	      var idx = this.dragStudents.findIndex(function (dragStudent) {
	        return dragStudent.id === student.id;
	      });
	      if (idx < 0) {
	        this.dragStudents.push(student);
	      } else {
	        this.dragStudents.splice(idx, 1);
	      }
	    },
	    getSchoolYearName: function getSchoolYearName(klass) {
	      var schoolYearId = this.allCalendarsInHash[klass.id] && this.allCalendarsInHash[klass.id].school_year_id ? this.allCalendarsInHash[klass.id].school_year_id : null;
	      return this.schoolYearsInHash[schoolYearId] ? '(' + this.schoolYearsInHash[schoolYearId].name + ')' : '';
	    },
	    getLatestFeideUpdate: function getLatestFeideUpdate() {
	      var latestDate = this.$helpers.getLocalStorage('feideUpdate');
	      if (latestDate) {
	        this.theLatestFeideImport = latestDate;
	      }
	    },
	    updateFromFeide: function updateFromFeide() {
	      var _this2 = this;
	
	      this.isImporting = true;
	      this.$helpers.setLocalStorage('feideUpdate', (0, _moment2.default)().format('YYYY-MM-DD HH:mm'));
	      setTimeout(function (_) {
	        _this2.getLatestFeideUpdate();
	        _this2.isImporting = false;
	      }, 2500);
	    },
	    setTheActiveStudent: function setTheActiveStudent(student) {
	      this.theActiveStudent = student;
	      this.editName = student.name;
	      this.editFeide = student.custom_data['feide'] ? student.custom_data['feide'] : '';
	    },
	    closeModal: function closeModal() {
	      this.theActiveStudent = null;
	      this.isEditStudentChanges = false;
	      this.isEditStudentConfirmation = false;
	    },
	    getStudentKlasses: function getStudentKlasses(student) {
	      var _this3 = this;
	
	      if (student.klasses) {
	        return student.klasses.filter(function (klassCalId) {
	          return _this3.allCalendarsInHash[klassCalId] && _this3.allCalendarsInHash[klassCalId].school_year_id && _this3.allCalendarsInHash[klassCalId].school_year_id === _this3.localActivatedSchoolYear.id;
	        }).map(function (calId) {
	          return _this3.allCalendarsInHash[calId];
	        });
	      } else {
	        return [];
	      }
	    },
	    getStudentRelations: function getStudentRelations(student) {
	      var _this4 = this;
	
	      if (student.calRelations) {
	        return student.calRelations.filter(function (calRel) {
	          return _this4.allCalendarsInHash[calRel.other_calendar_id];
	        }).map(function (relation) {
	          if (_this4.allCalendarsInHash[relation.other_calendar_id].name) {
	            var objRelation = {
	              id: relation.id,
	              name: _this4.allCalendarsInHash[relation.other_calendar_id].name
	            };
	            return objRelation;
	          }
	        });
	      } else {
	        return [];
	      }
	    },
	    setTheActiveFilter: function setTheActiveFilter(filter) {
	      this.theActiveFilter = filter;
	    },
	    isTheActiveFilter: function isTheActiveFilter(filter) {
	      return this.theActiveFilter === filter;
	    },
	    toggleAll: function toggleAll() {
	      var _this5 = this;
	
	      if (this.dragStudents.length > 0) {
	        this.dragStudents = [];
	      } else {
	        this.dragStudents = [];
	        this.filteredStudents.forEach(function (student) {
	          _this5.dragStudents.push(student);
	        });
	      }
	    },
	    dragStart: function dragStart(student, evt) {
	      var idx = this.dragStudents.findIndex(function (dragStudent) {
	        return dragStudent.id === student.id;
	      });
	      if (idx < 0) {
	        this.dragStudents.push(student);
	      }
	      this.dragEvt = evt;
	      this.dragEvt.target.classList.add('isDragging');
	      var el = this.$refs.customdrag;
	      el.style.display = 'flex';
	      evt.dataTransfer.setDragImage(el, 0, 0);
	    },
	    dragEnd: function dragEnd() {
	      if (this.dragStudents.length === 0) {
	        return;
	      }
	      this.dragEvt.target.classList.remove('isDragging');
	      this.dragEvt.target.style.display = '';
	      this.dragStudents = [];
	      this.dragEvt = null;
	      this.$refs.customdrag.style.display = 'none';
	    },
	    dragEnter: function dragEnter(klass, evt) {
	      if (this.dragStudents.length === 0) {
	        return;
	      }
	      evt.target.classList.add('isDragEnter');
	    },
	    dragLeave: function dragLeave(evt) {
	      if (this.dragStudents.length === 0) {
	        return;
	      }
	      evt.target.classList.remove('isDragEnter');
	    },
	    drop: function drop(klass) {
	      if (this.dragStudents.length === 0) {
	        return;
	      }
	      this.addStudentsToKlass(this.dragStudents, klass);
	      this.dragEnd();
	      var elements = this.$refs.droppable_elements;
	      for (var i = 0; i < elements.length; i++) {
	        elements[i].classList.remove('isDragEnter');
	      }
	    },
	    addStudentsToKlass: function addStudentsToKlass(students, klass) {
	      var _this6 = this;
	
	      students.forEach(function (student) {
	        var idx = student.calRelations.findIndex(function (relation) {
	          return relation.other_calendar_id === klass.id;
	        });
	        if (idx > -1) {
	          _eventbus2.default.toast = { text: _this6.$t('vue2.students.is_already_in_the_klass'), success: false };
	        } else {
	          var obj = {
	            calendarId: student.id,
	            otherCalendarId: klass.id,
	            relation: 'student_of'
	          };
	          _this6.$store.dispatch('createRelation', obj);
	        }
	      });
	    },
	    removeFromKlass: function removeFromKlass(relation) {
	      this.$store.dispatch('deleteRelation', relation.id);
	    },
	    deleteStudent: function deleteStudent() {
	      this.$store.dispatch('deleteCalendar', this.theActiveStudent.id);
	      this.closeModal();
	    },
	    submitModal: function submitModal() {
	      var calObj = {
	        calendarId: this.theActiveStudent.id,
	        changes: {
	          name: this.editName,
	          feide: this.editFeide
	        }
	      };
	      this.$store.dispatch('updateCalendar', calObj);
	      this.closeModal();
	    },
	    toggleStudentArchived: function toggleStudentArchived(student) {
	      var _this7 = this;
	
	      var calId = student.id;
	      var archive = false;
	      if (!student.archived_at) {
	        archive = true;
	      }
	      var calObj = {
	        calendarId: calId,
	        changes: { archived: archive }
	      };
	      _docendo2.default.schoolCalendarsUpdate(student.school_id, calObj.calendarId, calObj.changes, function (success) {
	        var updateObj = {
	          id: success.id,
	          name: success.name,
	          archived_at: success.archived_at
	        };
	        _this7.$store.commit('updateSchoolCalendar', updateObj);
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.getLatestFeideUpdate();
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('readCalendarRelations');
	    this.updateOffsetTop();
	    window.addEventListener('resize', this.updateOffsetTop);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.updateOffsetTop);
	  }
	};

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelect2.default, DModal: _DModal2.default },
	  props: {
	    calendarId: {
	      default: '141457'
	    },
	    studentCalendarIds: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isNotEditSubject: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isShowModal: false,
	      studentsForSubject: [],
	      studentsSelected: [],
	      isAddStudentFromAnotherGroup: false
	    };
	  },
	
	  computed: {
	    studentsInArr: function studentsInArr() {
	      var _this = this;
	
	      return this.studentsForSubject.filter(function (id) {
	        return _this.allCalendarsInHash[id];
	      }).map(function (id) {
	        return _this.allCalendarsInHash[id];
	      });
	    },
	    studentsSorted: function studentsSorted() {
	      return this.studentsInArr.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    studentsFromOtherGroups: function studentsFromOtherGroups() {
	      var _this2 = this;
	
	      return this.students.filter(function (student) {
	        var idx = student.klasses.indexOf(_this2.calendarId);
	
	        return idx < 0 && _this2.studentsForSubject.indexOf(student.id) < 0;
	      });
	    },
	    students: function students() {
	      return this.$store.getters.studentCalendars;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    klassStudents: function klassStudents() {
	      var _this3 = this;
	
	      var students = this.allCalendarsInHash[this.calendarId] && this.allCalendarsInHash[this.calendarId].students ? this.allCalendarsInHash[this.calendarId].students : [];
	      return students.filter(function (studentId) {
	        return _this3.allCalendarsInHash[studentId] && !_this3.allCalendarsInHash[studentId].archived_at;
	      });
	    },
	    getCalendarName: function getCalendarName() {
	      return this.allCalendarsInHash[this.calendarId] ? this.allCalendarsInHash[this.calendarId].name : this.$t('vue2.students.the_group');
	    }
	  },
	  methods: {
	    getStudentKlasses: function getStudentKlasses(student) {
	      var _this4 = this;
	
	      return student.klasses.filter(function (klassCalId) {
	        return _this4.allCalendarsInHash[klassCalId];
	      }).map(function (klassCalId) {
	        return _this4.allCalendarsInHash[klassCalId];
	      });
	    },
	    setStudentsForSubject: function setStudentsForSubject() {
	      var _this5 = this;
	
	      this.klassStudents.forEach(function (studentId) {
	        _this5.studentsForSubject.push(studentId);
	        if (_this5.isNotEditSubject) {
	          _this5.studentsSelected.push(studentId);
	        }
	      });
	      if (this.isNotEditSubject) {
	        this.$emit('changed', this.studentsSelected);
	      }
	    },
	    selectAll: function selectAll() {
	      var _this6 = this;
	
	      if (this.studentsSelected.length === this.studentsSorted.length) {
	        this.studentsSelected = [];
	      } else {
	        this.studentsSorted.forEach(function (student) {
	          var idx = _this6.studentsSelected.indexOf(student.id);
	          if (idx < 0) {
	            _this6.studentsSelected.push(student.id);
	          }
	        });
	      }
	    },
	    addStudentToSubject: function addStudentToSubject(item) {
	      this.studentsForSubject.push(item.id);
	      this.studentsSelected.push(item.id);
	    },
	    isInStudentsSelected: function isInStudentsSelected(itemId) {
	      return this.studentsSelected.indexOf(itemId) > -1;
	    },
	    toggleInStudentsSelected: function toggleInStudentsSelected(itemId) {
	      var idx = this.studentsSelected.indexOf(itemId);
	      if (idx < 0) {
	        this.studentsSelected.push(itemId);
	      } else {
	        this.studentsSelected.splice(idx, 1);
	      }
	    },
	    closeStudentModal: function closeStudentModal() {
	      this.isAddStudentFromAnotherGroup = false;
	      this.isShowModal = false;
	    },
	    submit: function submit() {
	      this.$emit('changed', this.studentsSelected);
	      this.closeStudentModal();
	    }
	  },
	  beforeMount: function beforeMount() {
	    var _this7 = this;
	
	    this.setStudentsForSubject();
	
	    this.studentCalendarIds.forEach(function (studentCalId) {
	      if (_this7.klassStudents.indexOf(studentCalId) < 0) {
	        _this7.studentsForSubject.push(studentCalId);
	        _this7.studentsSelected.push(studentCalId);
	      } else {
	        _this7.studentsSelected.push(studentCalId);
	      }
	    });
	  }
	};

/***/ }),
/* 714 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    initialColor: {
	      type: String,
	      default: '#e74c3c'
	    }
	  },
	  watch: {
	    initialColor: function initialColor(val) {
	      var idxOfColor = this.findColorIndex(this.initialColor);
	      this.setColor(idxOfColor);
	    },
	    selectedColor: function selectedColor(val) {
	      this.$emit('changedColor', val);
	    }
	  },
	  data: function data() {
	    return {
	      selectedColor: '',
	      colors: [{
	        value: '#e74c3c',
	        title: this.$t('vue2.subject.red'),
	        active: false
	      }, {
	        value: '#cd8c95',
	        title: this.$t('vue2.subject.lightred'),
	        active: false
	      }, {
	        value: '#f08080',
	        title: this.$t('vue2.subject.red2'),
	        active: false
	      }, {
	        value: '#A0A5EF',
	        title: this.$t('vue2.subject.lightpurple'),
	        active: false
	      }, {
	        value: '#6e84c4',
	        title: this.$t('vue2.subject.lightblue'),
	        active: false
	      }, {
	        value: '#9B63E0',
	        title: this.$t('vue2.subject.purple'),
	        active: false
	      }, {
	        value: '#9b59b6',
	        title: this.$t('vue2.subject.darkpurple'),
	        active: false
	      }, {
	        value: '#34495e',
	        title: this.$t('vue2.subject.darkblue'),
	        active: false
	      }, {
	        value: '#0066cc',
	        title: this.$t('vue2.subject.blue'),
	        active: false
	      }, {
	        value: '#578ACC',
	        title: this.$t('vue2.subject.azure'),
	        active: false
	      }, {
	        value: '#87B0BE',
	        title: this.$t('vue2.subject.lightblue2'),
	        active: false
	      }, {
	        value: '#85DD74',
	        title: this.$t('vue2.subject.lightgreen'),
	        active: false
	      }, {
	        value: '#20b2aa',
	        title: this.$t('vue2.subject.marinoblue'),
	        active: false
	      }, {
	        value: '#1abc9c',
	        title: this.$t('vue2.subject.turkis'),
	        active: false
	      }, {
	        value: '#2baf63',
	        title: this.$t('vue2.subject.green'),
	        active: false
	      }, {
	        value: '#93A36C',
	        title: this.$t('vue2.subject.darkgreen'),
	        active: false
	      }, {
	        value: '#cdbe70',
	        title: this.$t('vue2.subject.lightyellow'),
	        active: false
	      }, {
	        value: '#f1c40f',
	        title: this.$t('vue2.subject.darkyellow'),
	        active: false
	      }, {
	        value: '#fcbb2f',
	        title: this.$t('vue2.subject.lightyellow2'),
	        active: false
	      }, {
	        value: '#ff6600',
	        title: this.$t('vue2.subject.orange'),
	        active: false
	      }, {
	        value: '#ff7f50',
	        title: this.$t('vue2.subject.coral'),
	        active: false
	      }, {
	        value: '#EF8430',
	        title: this.$t('vue2.subject.darkorange'),
	        active: false
	      }, {
	        value: '#cd661d',
	        title: this.$t('vue2.subject.darkorange2'),
	        active: false
	      }, {
	        value: '#E1A370',
	        title: this.$t('vue2.subject.bronze'),
	        active: false
	      }, {
	        value: '#97957F',
	        title: this.$t('vue2.subject.lightbrown'),
	        active: false
	      }, {
	        value: '#999999',
	        title: this.$t('vue2.subject.grey'),
	        active: false
	      }, {
	        value: '#564437',
	        title: this.$t('vue2.subject.brown'),
	        active: false
	      }]
	    };
	  },
	
	  methods: {
	    findColorIndex: function findColorIndex(color) {
	      if (!color) {
	        return -1;
	      }
	      var normalized = color.toLowerCase();
	      return this.colors.map(function (obj) {
	        return obj.value.toLowerCase();
	      }).indexOf(normalized);
	    },
	    setColor: function setColor(idx) {
	      this.selectedColor = this.colors[idx].value;
	      if (this.$refs.inputradio[idx]) {
	        this.$refs.inputradio[idx].focus();
	      }
	      var el = document.querySelector('#subject_color');
	      if (el) {
	        el.value = this.colors[idx].value;
	      }
	    },
	    isSelectedColor: function isSelectedColor(val) {
	      return this.selectedColor === val;
	    }
	  },
	  mounted: function mounted() {
	    var el = document.querySelector('#subject_color');
	    if (el) {
	      this.initialColor = el.value;
	    }
	    var idxOfColor = this.findColorIndex(this.initialColor);
	    this.setColor(idxOfColor);
	  }
	};

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _CreateSubjectForm = __webpack_require__(145);
	
	var _CreateSubjectForm2 = _interopRequireDefault(_CreateSubjectForm);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { CreateSubjectForm: _CreateSubjectForm2.default },
	  props: {
	    calendarId: {
	      default: null
	    },
	    isHideCreateButton: {
	      type: Boolean,
	      default: false
	    },
	    isInDCalendar: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isSubjectModal: false,
	      editSubject: null,
	      editSubjectId: null,
	      calCurrentDate: (0, _moment2.default)()
	    };
	  },
	
	  computed: {
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    activeCalendar: function activeCalendar() {
	      return this.allCalendarsInHash[this.calendarId];
	    },
	    schoolYearIdToCreateSubject: function schoolYearIdToCreateSubject() {
	      return this.activeCalendar && this.activeCalendar.school_year_id ? this.activeCalendar.school_year_id : this.activeSchoolYear.id;
	    },
	    theEditSubject: function theEditSubject() {
	      return this.$store.state.calendar.editSubject;
	    }
	  },
	  watch: {
	    theEditSubject: function theEditSubject() {
	      if (this.theEditSubject) {
	        this.setEditSubject(this.theEditSubject);
	      }
	    }
	  },
	  methods: {
	    createNewSubject: function createNewSubject(newSubject) {
	      newSubject['schoolYearId'] = this.schoolYearIdToCreateSubject;
	      newSubject['calCurrentdate'] = this.calCurrentDate;
	      if (this.isInDCalendar) {
	        this.$store.dispatch('createCalendarSubject', newSubject);
	      } else {
	        this.$store.dispatch('createSubject', newSubject);
	      }
	      this.closeModal();
	    },
	    setEditSubject: function setEditSubject(editSubject) {
	      this.editSubject = (0, _assign2.default)({}, editSubject);
	      if (this.isInDCalendar && this.editSubject.cals) {
	        this.editSubject.calendar_ids = this.editSubject.cals.map(function (cal) {
	          return cal.id;
	        });
	      }
	      this.isSubjectModal = true;
	    },
	    updateSubject: function updateSubject(updatedSubject) {
	      if (this.isInDCalendar) {
	        this.$store.dispatch('updateCalendarSubject', updatedSubject);
	      } else {
	        this.$store.dispatch('updateSubject', updatedSubject);
	      }
	      this.closeModal();
	    },
	    deleteSubject: function deleteSubject(editSubject) {
	      if (this.isInDCalendar) {
	        this.$store.dispatch('deleteCalendarSubject', editSubject);
	      } else {
	        var deletedSubject = {
	          id: editSubject.id,
	          school_id: editSubject.school_id,
	          school_year_id: this.activeSchoolYear.id
	        };
	        deletedSubject['schoolYearId'] = this.activeSchoolYear.id;
	        this.$store.dispatch('deleteSubject', deletedSubject);
	      }
	      this.closeModal();
	    },
	    closeModal: function closeModal() {
	      this.editSubject = null;
	      this.editSubjectId = null;
	      this.$store.commit('setEditSubject', null);
	      this.isSubjectModal = false;
	    },
	    setTheEditSubject: function setTheEditSubject(theEditSubject) {
	      this.editSubject = theEditSubject;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.addEventListener('fullcal_view_or_date_changed', function (e) {
	      _this.calCurrentDate = e.detail;
	    }, false);
	
	    window.addEventListener('vue::editSubject', function (e) {
	      _this.editSubjectId = e.detail;
	      _this.isSubjectModal = true;
	    }, false);
	  }
	};

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Modal = __webpack_require__(69);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _DSelectUsers = __webpack_require__(67);
	
	var _DSelectUsers2 = _interopRequireDefault(_DSelectUsers);
	
	var _DSelectKlass = __webpack_require__(350);
	
	var _DSelectKlass2 = _interopRequireDefault(_DSelectKlass);
	
	var _ColorPicker = __webpack_require__(68);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	var _SubjectFormSubjectType = __webpack_require__(61);
	
	var _SubjectFormSubjectType2 = _interopRequireDefault(_SubjectFormSubjectType);
	
	var _DSelectCalsIds = __webpack_require__(40);
	
	var _DSelectCalsIds2 = _interopRequireDefault(_DSelectCalsIds);
	
	var _SubjectFormLog = __webpack_require__(389);
	
	var _SubjectFormLog2 = _interopRequireDefault(_SubjectFormLog);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _StudentsOnSubject = __webpack_require__(1616);
	
	var _StudentsOnSubject2 = _interopRequireDefault(_StudentsOnSubject);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _SubjectFormDeleteSubjects = __webpack_require__(388);
	
	var _SubjectFormDeleteSubjects2 = _interopRequireDefault(_SubjectFormDeleteSubjects);
	
	var _SubjectFormLogDeletedEvents = __webpack_require__(1617);
	
	var _SubjectFormLogDeletedEvents2 = _interopRequireDefault(_SubjectFormLogDeletedEvents);
	
	var _SubjectFormScheduledEvents = __webpack_require__(1619);
	
	var _SubjectFormScheduledEvents2 = _interopRequireDefault(_SubjectFormScheduledEvents);
	
	var _SubjectFormCalendarHours = __webpack_require__(387);
	
	var _SubjectFormCalendarHours2 = _interopRequireDefault(_SubjectFormCalendarHours);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _DkPreparationFactorControl = __webpack_require__(100);
	
	var _DkPreparationFactorControl2 = _interopRequireDefault(_DkPreparationFactorControl);
	
	var _SubjectPoolsUpdateConfirm = __webpack_require__(390);
	
	var _SubjectPoolsUpdateConfirm2 = _interopRequireDefault(_SubjectPoolsUpdateConfirm);
	
	var _SubjectAssignTeacherToEventsConfirm = __webpack_require__(386);
	
	var _SubjectAssignTeacherToEventsConfirm2 = _interopRequireDefault(_SubjectAssignTeacherToEventsConfirm);
	
	var _assignTeacherToScheduledEvents = __webpack_require__(158);
	
	var _assignTeacherToScheduledEvents2 = _interopRequireDefault(_assignTeacherToScheduledEvents);
	
	var _subjectPools = __webpack_require__(111);
	
	var _dkPreparationFactorUi = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    create_subject: 'Opret brik',
	    hours_in_school_year: 'Klokketimer i skoleåret',
	    add_teacher: 'Tilføj underviser',
	    add_room: 'Tilføj lokale',
	    add_klass: 'Tilføj klasse',
	    add_club: 'Tilføj SFO',
	    more_settings: 'Yderligere indstillinger',
	    subject_title: 'Brikkens navn',
	    standard_duration: 'Normal varighed (i minutter)',
	    choose_class: 'Vælg klasse',
	    choose_color: 'Vælg farve',
	    choose_subject_type: 'Vælg briktype',
	    ex_subject: 'Eks. Dansk',
	    cancel: 'Annullér',
	    update_subject: 'Opdatér brik',
	    delete_subject: 'Slet brikken',
	    edit_subject: 'Redigér brik',
	    activity: 'Historik for brik',
	    latest_activity: 'Seneste aktivitet',
	    cannot_delete: 'Ikke muligt at slette, da brikken er skemalagt',
	    choose_school_year: 'Vælg skoleår',
	    can_not_find_subject: 'Kan desværre ikke vise brikken',
	    deleted_lessons: 'Slettede lektioner',
	    scheduled_events: 'Skemalagte brikker',
	    out_of_school_desc: 'Personalet vil fremgå som fraværende i vikardækningen, når denne er aktiveret.',
	    out_of_school: 'Ude af huset',
	    subject_code: 'Fagkode',
	    forb_faktor: 'Forb. faktor',
	    forb_faktor_range_hint: 'Mellem 0 og -1',
	    prep_task_extra_toggle: 'Medregnes ud over forberedelse fra forberedelesfaktor',
	    prep_task_extra_toggle_hint: 'Fra: opgaven følger skolens forberedelsesfaktor som øvrige brikker. Til: opgavens timer medregnes med faktor 1 oven i forberedelsen fra undervisningsfag.',
	    show_on_task_overview: 'Vis på opgaveoversigt',
	    show_on_task_overview_desc: 'Når denne er slået fra, vises brikken ikke på opgaveoversigten.',
	    hours_disabled_desc: 'Klokketimer kan kun angives, når "Vis på opgaveoversigt" er slået til, da timerne bruges på opgaveoversigten.'
	  },
	  en: {
	    create_subject: 'Create course',
	    hours_in_school_year: 'Hours in school year',
	    add_teacher: 'Add teacher',
	    add_room: 'Add room',
	    add_klass: 'Add grade/group',
	    add_club: 'Add club',
	    more_settings: 'Advanced settings',
	    subject_title: 'Subject title',
	    standard_duration: 'Standard duration (in minutes)',
	    choose_class: 'Choose grade/group',
	    choose_color: 'Choose color',
	    choose_subject_type: 'Choose course category',
	    ex_subject: 'E.g. Math',
	    cancel: 'Cancel',
	    update_subject: 'Update course',
	    delete_subject: 'Delete course',
	    edit_subject: 'Edit course',
	    activity: 'History',
	    latest_activity: 'Activity',
	    cannot_delete: 'Not possible to delete because the subject has lessons in a calendar',
	    choose_school_year: 'Choose school year',
	    can_not_find_subject: 'Unfortunately can not show the subject',
	    deleted_lessons: 'Deleted lessons',
	    scheduled_events: 'Scheduled lessons',
	    out_of_school_desc: 'The staff will appear as absent in the substitute coverage when this is activated.',
	    out_of_school: 'Out of school',
	    subject_code: 'Subject code',
	    forb_faktor: 'Prep factor',
	    forb_faktor_range_hint: 'Between 0 and -1',
	    prep_task_extra_toggle: 'Counted in addition to preparation from teaching',
	    prep_task_extra_toggle_hint: 'Off: this task uses the school preparation factor like other tiles. On: hours are counted with factor 1 on top of preparation from teaching subjects.',
	    show_on_task_overview: 'Show on task overview',
	    show_on_task_overview_desc: 'When turned off, the subject is not shown on the task overview.',
	    hours_disabled_desc: 'Hours can only be entered when "Show on task overview" is turned on, since the hours are used on the task overview.'
	  },
	  nb: {
	    create_subject: 'Opprett fag',
	    hours_in_school_year: 'Årstimetall',
	    add_teacher: 'Legg til lærer',
	    add_room: 'Legg til lokale',
	    add_klass: 'Legg til klasse',
	    add_club: 'Legg til SFO',
	    more_settings: 'Flere innstillinger',
	    subject_title: 'Navn på fag',
	    standard_duration: 'Normal varighet (i minutter)',
	    choose_class: 'Velg klasse',
	    choose_color: 'Velg farge',
	    choose_subject_type: 'Velg type',
	    ex_subject: 'F.eks. Norsk',
	    cancel: 'Angre',
	    update_subject: 'Oppdater fag',
	    delete_subject: 'Slett fag',
	    edit_subject: 'Rediger fag',
	    activity: 'Historikk',
	    latest_activity: 'Aktivitet',
	    cannot_delete: 'Ikke mulig å slette fordi faget har leksjoner i en kalender',
	    choose_school_year: 'Velg skoleår',
	    can_not_find_subject: 'Kan dessverre ikke vise faget',
	    deleted_lessons: 'Slettede leksjoner',
	    scheduled_events: 'Timeplanlagte brikker',
	    out_of_school_desc: 'Personalet vil vises som fraværende i vikaroversikten når denne er aktivert.',
	    out_of_school: 'Utenfor skolen',
	    subject_code: 'Fagkode',
	    forb_faktor: 'Forb. faktor',
	    forb_faktor_range_hint: 'Mellom 0 og -1',
	    prep_task_extra_toggle: 'Tas med i tillegg til forberedelse fra undervisning',
	    prep_task_extra_toggle_hint: 'Av: oppgaven følger skolens forberedelsesfaktor som andre brikker. På: oppgavens timer tas med med faktor 1 i tillegg til forberedelse fra undervisningsfag.',
	    show_on_task_overview: 'Vis på oppgaveoversikt',
	    show_on_task_overview_desc: 'Når denne er slått av, vises faget ikke på oppgaveoversikten.',
	    hours_disabled_desc: 'Årstimetall kan kun angis når "Vis på oppgaveoversikt" er slått på, da timene brukes på oppgaveoversikten.'
	  }
	};
	
	exports.default = {
	  mixins: [_assignTeacherToScheduledEvents2.default],
	  components: {
	    SubjectAssignTeacherToEventsConfirm: _SubjectAssignTeacherToEventsConfirm2.default,
	    SubjectPoolsUpdateConfirm: _SubjectPoolsUpdateConfirm2.default,
	    AppToggle: _AppToggle2.default,
	    StudentsOnSubject: _StudentsOnSubject2.default,
	    ChangeSchoolYear: _ChangeSchoolYear2.default,
	    Loader: _Loader2.default,
	    modal: _Modal2.default,
	    ColorPicker: _ColorPicker2.default,
	    DSelectCalendarIds: _DSelectCalsIds2.default,
	    DSelectUser: _DSelectUsers2.default,
	    DSelectKlass: _DSelectKlass2.default,
	    SubjectTypePicker: _SubjectFormSubjectType2.default,
	    SubjectFormLog: _SubjectFormLog2.default,
	    SubjectFormDeleteSubjects: _SubjectFormDeleteSubjects2.default,
	    SubjectFormLogDeletedEvents: _SubjectFormLogDeletedEvents2.default,
	    SubjectFormScheduledEvents: _SubjectFormScheduledEvents2.default,
	    SubjectFormCalendarHours: _SubjectFormCalendarHours2.default,
	    DkPreparationFactorControl: _DkPreparationFactorControl2.default
	  },
	  props: {
	    initCalendarId: {
	      default: null
	    },
	    showModal: {
	      default: false
	    },
	    editSubject: {
	      default: null
	    },
	    editSubjectId: {
	      default: null
	    },
	    isInDCalendar: {
	      type: Boolean,
	      default: false
	    },
	    allowDanishPreparationFactorUi: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      preparationOptionsForNorway: [741, 711, 664, 635, 606],
	      preparation: null,
	      theActiveTab: 0,
	      calendarId: null,
	      name: '',
	      color: '#A0A5EF',
	      defaultDuration: 45,
	      hours: 0,
	      subjectType: null,
	      klassCalendarIds: [],
	      userCalendarIds: [],
	      roomCalendarIds: [],
	      studentCalendarIds: [],
	      clubCalendarIds: [],
	      formErrors: [],
	      isLoadingTheEditSubject: false,
	      showDbErrorText: false,
	      subjectCode: '',
	      isPossibleToAddKlasses: false,
	      subjectsWithSameName: [],
	      updatedSubject: null,
	      newSubject: null,
	      isPossibleToAddClub: false,
	      isAway: false,
	      taskOverview: false,
	      isTaskOverviewTouched: false,
	      showPoolsConfirm: false,
	      poolsSubject: null,
	      savedSubjectHours: null
	    };
	  },
	
	  computed: {
	    isShowSubjectsPools: function isShowSubjectsPools() {
	      return this.isSchoolFromDenmark && (0, _subjectPools.hasDifferentiatedPool)(this.editSubject);
	    },
	    isCalendarKlass: function isCalendarKlass() {
	      return this.calendarType === 'klass';
	    },
	    isArbeidstidsplanActivated: function isArbeidstidsplanActivated() {
	      return this.$store.getters.isArbeidstidsplanActivated;
	    },
	    schoolCountry: function schoolCountry() {
	      return this.$store.getters.schoolCountry;
	    },
	    isSchoolFromDenmark: function isSchoolFromDenmark() {
	      return this.schoolCountry.toLowerCase() === 'dk';
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings || {};
	    },
	    isShowNorwegianPreparationDropdown: function isShowNorwegianPreparationDropdown() {
	      return this.isArbeidstidsplanActivated && !this.isSchoolFromDenmark;
	    },
	    isShowDanishPreparationFactorField: function isShowDanishPreparationFactorField() {
	      if (!this.allowDanishPreparationFactorUi || !this.isSchoolFromDenmark) {
	        return false;
	      }
	      if (!this.schoolSettings || !this.schoolSettings.deactivatePools) {
	        return false;
	      }
	      if (!(0, _dkPreparationFactorUi.schoolHasDanishPreparationFactorConfigured)(this.schoolSettings)) {
	        return false;
	      }
	      return (0, _dkPreparationFactorUi.isSubjectTypeWithDanishPreparationFactor)(this.subjectType);
	    },
	    showDanishPreparationFactorBesideHours: function showDanishPreparationFactorBesideHours() {
	      return this.isShowDanishPreparationFactorField;
	    },
	    isDanishPrepBinaryOnOwnRow: function isDanishPrepBinaryOnOwnRow() {
	      return (0, _dkPreparationFactorUi.isDanishPreparationBinaryPrepTaskSubjectType)(this.subjectType);
	    },
	    danishPreparationControlLabels: function danishPreparationControlLabels() {
	      var L = this.i18n[this.locale];
	      return {
	        forb_faktor: L.forb_faktor,
	        forb_faktor_range_hint: L.forb_faktor_range_hint,
	        prep_task_extra_toggle: L.prep_task_extra_toggle,
	        prep_task_extra_toggle_hint: L.prep_task_extra_toggle_hint
	      };
	    },
	    isSchoolFromNorway: function isSchoolFromNorway() {
	      return this.schoolCountry.toLowerCase() === 'no';
	    },
	    standardSubjectCodes: function standardSubjectCodes() {
	      return this.$store.getters.standardSubjectCodes || [];
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      var I18N_2 = I18N;
	      if (this.isKindergarten) {
	        I18N_2['da']['add_teacher'] = 'Tilføj pædagog';
	        I18N_2['da']['ex_subject'] = 'Eks. Carina';
	        I18N_2['da']['hours_in_school_year'] = 'Timer i perioden';
	        I18N_2['da']['choose_school_year'] = 'Vælg periode';
	        I18N_2['da']['add_klass'] = 'Tilføj stue';
	      }
	      return I18N_2;
	    },
	    schoolId: function schoolId() {
	      return window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id : this.$route.params.school_id ? this.$route.params.school_id : null;
	    },
	    isKindergarten: function isKindergarten() {
	      return this.$store.getters.isKindergarten;
	    },
	    isAllowedToAddKlasses: function isAllowedToAddKlasses() {
	      return this.calendarType === 'klass' || this.calendarType === 'user' && this.subjectType !== 'club';
	    },
	    isAllowedToAddClub: function isAllowedToAddClub() {
	      return this.calendarType === 'club' || this.calendarType === 'user' && this.subjectType === 'club';
	    },
	    editSubjectCanBeDeleted: function editSubjectCanBeDeleted() {
	      return this.editSubject && this.editSubject.can_delete || this.editSubject && this.editSubject.actual_hours === null;
	    },
	    isEditSubject: function isEditSubject() {
	      return !this.editSubject;
	    },
	    klassStudents: function klassStudents() {
	      var _this = this;
	
	      var students = this.allCalendarsInHash[this.calendarId] && this.allCalendarsInHash[this.calendarId].students ? this.allCalendarsInHash[this.calendarId].students : [];
	      return students.filter(function (studentId) {
	        return _this.allCalendarsInHash[studentId] && !_this.allCalendarsInHash[studentId].archived_at;
	      });
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    canChangeTaskOverview: function canChangeTaskOverview() {
	      return this.userHasPermission('can_change_task_overview');
	    },
	    canSeeTaskOverviewToggle: function canSeeTaskOverviewToggle() {
	      return this.canChangeTaskOverview;
	    },
	    isHoursDisabled: function isHoursDisabled() {
	      return !this.taskOverview;
	    },
	    schoolYears: function schoolYears() {
	      return this.$store.state.schoolYears;
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    theSchoolForTheSubject: function theSchoolForTheSubject() {
	      var _this2 = this;
	
	      var school = null;
	      if (this.editSubject && this.editSubject.school_id) {
	        var schoolIdx = this.user.schools.findIndex(function (school) {
	          return school.id === _this2.editSubject.school_id;
	        });
	        if (schoolIdx > -1) {
	          school = this.user.schools[schoolIdx];
	        }
	      }
	      return school;
	    },
	    theActiveSchoolYearForTheSubject: function theActiveSchoolYearForTheSubject() {
	      var _this3 = this;
	
	      var schoolYear = null;
	      if (this.editSubject && this.editSubject.school_year_id) {
	        var schoolYearIdx = this.schoolYears.findIndex(function (schoolYear) {
	          return schoolYear.id === _this3.editSubject.school_year_id;
	        });
	        if (schoolYearIdx > -1) {
	          schoolYear = this.schoolYears[schoolYearIdx];
	        }
	      }
	      return schoolYear;
	    },
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    localActivatedSchoolYear: function localActivatedSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    calendarType: function calendarType() {
	      var calType = this.allCalendarsInHash[this.calendarId] ? this.allCalendarsInHash[this.calendarId].type : 'user';
	      return this.calendarId ? calType : 'klass';
	    },
	    isUserCalendar: function isUserCalendar() {
	      return this.calendarType === 'user';
	    },
	    lockedTeacherCalendarIds: function lockedTeacherCalendarIds() {
	      return this.isUserCalendar && this.calendarId ? [this.calendarId] : [];
	    },
	    preSelectedTeacherCalendarIds: function preSelectedTeacherCalendarIds() {
	      if (this.isUserCalendar && this.calendarId && this.userCalendarIds.indexOf(this.calendarId) === -1) {
	        return [this.calendarId].concat(this.userCalendarIds);
	      }
	      return this.userCalendarIds;
	    },
	    isShowSchool: function isShowSchool() {
	      var userHasMultipleSchools = this.user.schools.length > 1;
	      return this.calendarType === 'user' && userHasMultipleSchools;
	    },
	    isShowSchoolYearSelector: function isShowSchoolYearSelector() {
	      var noActiveYearForSubject = !this.theActiveSchoolYearForTheSubject;
	      var hasMultipleActiveSchoolYears = this.activeSchoolYears.length > 1;
	      var isUserOrRoomCalendar = this.calendarType === 'user' || this.calendarType === 'room';
	
	      return noActiveYearForSubject && hasMultipleActiveSchoolYears && isUserOrRoomCalendar;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    klassCalendarInHash: function klassCalendarInHash() {
	      return this.$store.getters.allKlassCalendarsInHash;
	    },
	    showMasterCalendarName: function showMasterCalendarName() {
	      return this.editSubject && this.allCalendarsInHash[this.editSubject.calendar_id] && this.allCalendarsInHash[this.editSubject.calendar_id].name ? this.allCalendarsInHash[this.editSubject.calendar_id].name : '';
	    },
	    activeSchoolYearId: function activeSchoolYearId() {
	      return this.editSubject && this.editSubject.school_year_id ? this.editSubject.school_year_id : this.localActivatedSchoolYear.id;
	    },
	    arrOfAllSubjectCalendars: function arrOfAllSubjectCalendars() {
	      var calIds = [];
	      this.userCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      this.roomCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      this.klassCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      this.studentCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      this.clubCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      return calIds;
	    },
	    subjectsInKlassHash: function subjectsInKlassHash() {
	      return this.$store.getters.subjectsInKlassHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    }
	  },
	  watch: {
	    defaultDuration: function defaultDuration(val) {
	      this.removeErrors('defaultDuration');
	    }
	  },
	  methods: {
	    setIsPossibleToAddKlasses: function setIsPossibleToAddKlasses() {
	      this.isPossibleToAddKlasses = true;
	      this.$store.dispatch('readSubjects', this.activeSchoolYearId);
	    },
	    setIsPossibleToAddClub: function setIsPossibleToAddClub() {
	      this.isPossibleToAddClub = true;
	      this.$store.dispatch('readSubjects', this.activeSchoolYearId);
	    },
	    setSelectedUsers: function setSelectedUsers(users) {
	      this.onTeacherSelectionUpdated(users);
	    },
	    setSelectedRooms: function setSelectedRooms(rooms) {
	      this.onRoomSelectionUpdated(rooms);
	    },
	    setSelectedKlass: function setSelectedKlass(klasses) {
	      this.onKlassSelectionUpdated(klasses);
	    },
	    setSelectedClub: function setSelectedClub(clubs) {
	      this.clubCalendarIds = clubs.map(function (cal) {
	        return cal.id;
	      });
	    },
	    addKlass: function addKlass(klass) {
	      this.calendarId = klass.id;
	      this.removeErrors('calendarId');
	    },
	    removeKlass: function removeKlass() {
	      this.calendarId = null;
	    },
	    setSubjectColor: function setSubjectColor(val) {
	      this.color = val;
	    },
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.user.admin;
	      }
	      return true;
	    },
	    toggleTaskOverview: function toggleTaskOverview() {
	      if (!this.canChangeTaskOverview) {
	        return;
	      }
	      this.taskOverview = !this.taskOverview;
	      this.isTaskOverviewTouched = true;
	    },
	    taskOverviewForCreate: function taskOverviewForCreate() {
	      return this.canChangeTaskOverview ? this.taskOverview : false;
	    },
	    taskOverviewForUpdate: function taskOverviewForUpdate() {
	      if (this.canChangeTaskOverview) {
	        return this.isTaskOverviewTouched || this.editSubject && typeof this.editSubject.task_overview !== 'undefined' ? this.taskOverview : null;
	      }
	      return null;
	    },
	    formValidation: function formValidation() {
	      if (this.name.length < 1) {
	        this.$set(this.formErrors, 'name', {
	          da: 'Fag skal have et navn',
	          en: 'Subjects must have a name',
	          nb: 'Fag må ha et navn'
	        });
	      }
	      if (this.hours < 0) {
	        this.$set(this.formErrors, 'hours', {
	          da: 'Skal være 0 eller højere',
	          en: 'Must be zero or greater',
	          nb: 'Må være 0 eller høyere'
	        });
	      }
	      if (!this.isAValidDuration(this.defaultDuration)) {
	        this.$set(this.formErrors, 'defaultDuration', {
	          da: 'Skal være mellem 5 og 1440 minutter',
	          en: 'Must be between 5 to 1440 minutes',
	          nb: 'Må være mellom 5 og 1440 minutter'
	        });
	      }
	      if (!this.calendarId) {
	        this.$set(this.formErrors, 'calendarId', {
	          da: 'Skal vælges. Du kan bagefter kopiere til andre',
	          en: 'Must choose a class. It can later be copied',
	          nb: 'Må velges. Du kan deretter kopiere til andres'
	        });
	      }
	    },
	    removeErrors: function removeErrors(title) {
	      this.$delete(this.formErrors, title);
	    },
	    createSubject: function createSubject() {
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      this.newSubject = {
	        name: this.name,
	        color: this.color,
	        calendarId: this.calendarId,
	        defaultDuration: this.defaultDuration,
	        preparation: this.preparationPayloadForSave(),
	        hours: this.hours,
	        subjectType: this.subjectType,
	        calendarIds: this.arrOfAllSubjectCalendars,
	        subjectCode: this.subjectCode,
	        away: this.isAway,
	        taskOverview: this.taskOverviewForCreate()
	      };
	      if (this.klassCalendarIds.length === 0) {
	        this.$emit('createSubject', this.newSubject);
	      } else {
	        this.checkIfAddedKlassAlreadyHasSubjectWithSameName();
	      }
	    },
	    updateSubject: function updateSubject() {
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      var savedSubject = this.savedSubjectHours !== null ? (0, _assign2.default)({}, this.editSubject, { hours: this.savedSubjectHours }) : this.editSubject;
	      if ((0, _subjectPools.shouldConfirmPoolsUpdate)(savedSubject, this.hours)) {
	        this.showPoolsConfirm = true;
	        return;
	      }
	      if (this.shouldWaitForTeacherAssignBeforeUpdate()) {
	        return;
	      }
	      this.doUpdateSubject();
	    },
	    doUpdateSubject: function doUpdateSubject() {
	      this.updatedSubject = {
	        id: this.editSubject.id,
	        name: this.name,
	        color: this.color,
	        calendarId: this.calendarId,
	        defaultDuration: this.defaultDuration,
	        preparation: this.preparationPayloadForSave(),
	        hours: this.hours,
	        subjectType: this.subjectType,
	        calendarIds: this.arrOfAllSubjectCalendars,
	        schoolId: this.theSchoolForTheSubject ? this.theSchoolForTheSubject.id : window.SCHOOL.id,
	        schoolYearId: this.editSubject && this.editSubject.school_year_id ? this.editSubject.school_year_id : this.activeSchoolYear.id,
	        subjectCode: this.subjectCode,
	        away: this.isAway,
	        taskOverview: this.taskOverviewForUpdate()
	      };
	      if (this.klassCalendarIds.length === 0) {
	        this.$emit('updateSubject', this.updatedSubject);
	      } else {
	        this.checkIfAddedKlassAlreadyHasSubjectWithSameName();
	      }
	    },
	    onPoolsConfirmUpdateAll: function onPoolsConfirmUpdateAll(calendarIds) {
	      var _this4 = this;
	
	      this.showPoolsConfirm = false;
	      this.applyHoursToCalendars(calendarIds, this.hours, function () {
	        return _this4.proceedAfterPoolsConfirm();
	      });
	    },
	    onPoolsConfirmSubjectOnly: function onPoolsConfirmSubjectOnly() {
	      this.showPoolsConfirm = false;
	      this.proceedAfterPoolsConfirm();
	    },
	    proceedAfterPoolsConfirm: function proceedAfterPoolsConfirm() {
	      if (this.shouldWaitForTeacherAssignBeforeUpdate()) {
	        return;
	      }
	      this.doUpdateSubject();
	    },
	    onPoolsConfirmClose: function onPoolsConfirmClose() {
	      this.showPoolsConfirm = false;
	    },
	    onSubjectHoursSaved: function onSubjectHoursSaved(hours) {
	      this.savedSubjectHours = hours;
	      this.hours = hours;
	    },
	    applyHoursToCalendars: function applyHoursToCalendars(calendarIds, hours, done) {
	      var _this5 = this;
	
	      var subj = this.editSubject;
	      var finish = function finish() {
	        if (done) done();
	      };
	      if (!subj || !Array.isArray(calendarIds)) return finish();
	      var id = subj.id;
	      var schoolId = subj.school_id || (this.theSchoolForTheSubject ? this.theSchoolForTheSubject.id : window.SCHOOL.id);
	      var schoolYearId = subj.school_year_id || this.activeSchoolYearId;
	      var queue = calendarIds.slice();
	      var next = function next() {
	        if (queue.length === 0) return finish();
	        _docendo2.default.setHoursForTeacherOnSubject(id, schoolId, schoolYearId, queue.shift(), hours, function (success) {
	          if (success) {
	            _this5.$store.commit('updateTeacherHoursOnSubject', success);
	          }
	          next();
	        }, function (failure) {
	          console.log('failed to update pool hours', failure);
	          next();
	        });
	      };
	      next();
	    },
	    deleteExistingSubjects: function deleteExistingSubjects() {
	      var _this6 = this;
	
	      this.subjectsWithSameName.forEach(function (subject) {
	        _this6.$emit('deleteSubject', subject);
	      });
	      this.createOrUpdate();
	    },
	    keepExistingSubjects: function keepExistingSubjects() {
	      this.subjectsWithSameName = [];
	      this.createOrUpdate();
	    },
	    createOrUpdate: function createOrUpdate() {
	      if (this.editSubject) {
	        this.$emit('updateSubject', this.updatedSubject);
	      } else {
	        this.$emit('createSubject', this.newSubject);
	      }
	    },
	    closeModalSubjectsWithSameName: function closeModalSubjectsWithSameName() {
	      this.subjectsWithSameName = [];
	    },
	    checkIfAddedKlassAlreadyHasSubjectWithSameName: function checkIfAddedKlassAlreadyHasSubjectWithSameName() {
	      var _this7 = this;
	
	      var newKlassesAddedOnSubject = [];
	      this.klassCalendarIds.forEach(function (calId) {
	        if (_this7.editSubject) {
	          if (_this7.editSubject.calendar_ids.indexOf(calId) < 0) {
	            newKlassesAddedOnSubject.push(calId);
	          }
	        } else {
	          newKlassesAddedOnSubject.push(calId);
	        }
	      });
	      if (newKlassesAddedOnSubject.length > 0) {
	        newKlassesAddedOnSubject.forEach(function (calId) {
	          var subjectIdsForKlass = _this7.subjectsInKlassHash[calId] ? _this7.subjectsInKlassHash[calId] : [];
	          var klassSubjects = subjectIdsForKlass.map(function (subjectId) {
	            if (_this7.subjectsInHash[subjectId]) {
	              return _this7.subjectsInHash[subjectId];
	            }
	          });
	          klassSubjects.forEach(function (subject) {
	            if (subject.name === _this7.name) {
	              _this7.subjectsWithSameName.push(subject);
	            }
	          });
	        });
	        if (this.subjectsWithSameName.length === 0) {
	          this.createOrUpdate();
	        }
	      } else {
	        this.createOrUpdate();
	      }
	    },
	    deleteEditSubject: function deleteEditSubject() {
	      this.$emit('deleteSubject', this.editSubject);
	    },
	    onClickPoolsTab: function onClickPoolsTab() {
	      var _this8 = this;
	
	      this.theActiveTab = 4;
	      this.poolsSubject = null;
	      _docendo2.default.showSubject(this.editSubject.id, function (success) {
	        _this8.poolsSubject = success;
	      }, function (failure) {
	        console.log('failed to read subject pools', failure);
	      });
	    },
	    clearForm: function clearForm() {
	      this.theActiveTab = 0;
	      this.poolsSubject = null;
	      this.formErrors = [];
	      this.name = '';
	      this.calendarIds = [];
	      this.hours = 0;
	      this.color = '#A0A5EF';
	      this.setDefaultDuration();
	      this.isLoadingTheEditSubject = false;
	      this.subjectCode = '';
	      this.subjectsWithSameName = [];
	      this.updatedSubject = null;
	      this.newSubject = null;
	      this.preparation = '';
	      this.taskOverview = false;
	      this.isTaskOverviewTouched = false;
	    },
	    preparationPayloadForSave: function preparationPayloadForSave() {
	      return (0, _dkPreparationFactorUi.preparationPayloadForSave)(this.preparation, this.isShowDanishPreparationFactorField, this.subjectType);
	    },
	    preparationFromApiForForm: function preparationFromApiForForm(prep) {
	      return (0, _dkPreparationFactorUi.preparationFromApiForForm)(prep, this.isShowDanishPreparationFactorField, this.subjectType);
	    },
	    isAValidDuration: function isAValidDuration(duration) {
	      return (/^-?[\d.]+(?:e-?\d+)?$/.test(duration) && duration > 4 && duration < 1441
	      );
	    },
	    close: function close() {
	      this.clearForm();
	      this.$emit('close');
	    },
	    selectSubjectType: function selectSubjectType(subjectType) {
	      this.subjectType = subjectType;
	
	      if (this.subjectType === 'other_tasks' || this.subjectType === 'other_stuff' || this.subjectType === 'club') {
	        this.klassCalendarIds = [];
	        this.isPossibleToAddKlasses = false;
	      }
	      if (this.subjectType !== 'club') {
	        this.clubCalendarIds = [];
	        this.isPossibleToAddClub = false;
	      }
	    },
	    readTheEditSubject: function readTheEditSubject(editSubjectId) {
	      var _this9 = this;
	
	      _docendo2.default.showSubject(editSubjectId, function (success) {
	        _this9.$emit('setTheEditSubject', success);
	        if (success.status === 'error') {
	          _this9.setErrorMessage();
	          return;
	        }
	        setTimeout(function (_) {
	          _this9.setTheEditSubject();
	        }, 0);
	      }, function (failure) {
	        console.log('failed');
	      });
	    },
	    setErrorMessage: function setErrorMessage() {
	      this.showDbErrorText = true;
	      this.isLoadingTheEditSubject = false;
	    },
	    selectAllOnFocus: function selectAllOnFocus(evt) {
	      setTimeout(function (_) {
	        evt.target.select();
	      }, 0);
	    },
	    setTheEditSubject: function setTheEditSubject() {
	      var _this10 = this;
	
	      this.savedSubjectHours = null;
	      console.log('this.editSubject.away', this.editSubject);
	      this.name = this.editSubject.name;
	      this.color = this.editSubject.color;
	      this.hours = this.editSubject.hours;
	      this.defaultDuration = this.editSubject.default_duration;
	      this.subjectType = this.editSubject.subject_type;
	      this.calendarId = this.editSubject.calendar_id;
	      this.subjectCode = this.editSubject.subject_code;
	      if (typeof this.editSubject.away !== 'undefined') {
	        this.isAway = this.editSubject.away;
	      }
	      this.taskOverview = typeof this.editSubject.task_overview !== 'undefined' ? this.editSubject.task_overview : false;
	      if (this.editSubject.preparation != null) {
	        this.preparation = this.preparationFromApiForForm(this.editSubject.preparation);
	      }
	      if (this.editSubject.calendar_ids) {
	        var klassCounter = 0;
	        this.editSubject.calendar_ids.forEach(function (calid) {
	          if (_this10.allCalendarsInHash[calid] && _this10.allCalendarsInHash[calid].type === 'user') {
	            _this10.userCalendarIds.push(calid);
	          }
	          if (_this10.allCalendarsInHash[calid] && _this10.allCalendarsInHash[calid].type === 'room') {
	            _this10.roomCalendarIds.push(calid);
	          }
	          if (_this10.allCalendarsInHash[calid] && _this10.allCalendarsInHash[calid].type === 'club' && calid !== _this10.calendarId) {
	            _this10.isPossibleToAddClub = true;
	            _this10.clubCalendarIds.push(calid);
	          }
	          if (_this10.allCalendarsInHash[calid] && _this10.allCalendarsInHash[calid].type === 'klass' && calid !== _this10.calendarId) {
	            if (klassCounter === 0) {
	              _this10.setIsPossibleToAddKlasses();
	            }
	            _this10.klassCalendarIds.push(calid);
	            klassCounter++;
	          }
	          if (_this10.allCalendarsInHash[calid] && _this10.allCalendarsInHash[calid].type === 'student') {
	            _this10.studentCalendarIds.push(calid);
	          }
	        });
	      }
	      this.isLoadingTheEditSubject = false;
	    },
	    setStudentCalendarIds: function setStudentCalendarIds(arr) {
	      this.studentCalendarIds = arr;
	    },
	    setDefaultDuration: function setDefaultDuration() {
	      if (this.activeSchool && this.activeSchool.subject_default_duration) {
	        this.defaultDuration = this.activeSchool.subject_default_duration;
	      } else {
	        this.defaultDuration = 45;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.initCalendarId) {
	      this.calendarId = this.initCalendarId;
	    }
	    if (this.editSubjectId) {
	      this.isLoadingTheEditSubject = true;
	      this.readTheEditSubject(this.editSubjectId);
	    }
	    if (this.editSubject) {
	      this.setTheEditSubject();
	    }
	    if (!this.editSubject && !this.editSubjectId) {
	      this.setDefaultDuration();
	    }
	  },
	  mounted: function mounted() {
	    var _this11 = this;
	
	    if (!this.isInDCalendar && this.editSubject) {
	      if (this.theActiveTab === 0) {
	        setTimeout(function (_) {
	          _this11.$refs.inputLessonCount.focus();
	        }, 500);
	      }
	      return;
	    }
	    this.$nextTick(function (_) {
	      _this11.$refs.name.focus();
	    });
	  }
	};

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _dkPreparationFactorUi = __webpack_require__(72);
	
	var _preparationFactor = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DkPreparationFactorControl',
	  components: { AppToggle: _AppToggle2.default },
	  model: {
	    prop: 'value',
	    event: 'input'
	  },
	  props: {
	    value: {
	      default: null
	    },
	    subjectType: {
	      type: String,
	      required: true
	    },
	    schoolPrepFactor: {
	      default: null
	    },
	    labels: {
	      type: Object,
	      required: true
	    },
	    inputClass: {
	      type: String,
	      default: 'do-input'
	    },
	    wrapClass: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      isDanishPreparationFactorEditing: false,
	      numericEditDraft: ''
	    };
	  },
	
	  computed: {
	    isBinaryPrepTask: function isBinaryPrepTask() {
	      return (0, _dkPreparationFactorUi.isDanishPreparationBinaryPrepTaskSubjectType)(this.subjectType);
	    },
	    schoolPrepFactorNumeric: function schoolPrepFactorNumeric() {
	      return (0, _preparationFactor.parseNumericPreparationFactor)(this.schoolPrepFactor);
	    },
	    isPrepExtraOn: function isPrepExtraOn() {
	      return (0, _preparationFactor.parseNumericPreparationFactor)(this.value) === 1;
	    },
	    effectiveDanishPreparationFactorNumeric: function effectiveDanishPreparationFactorNumeric() {
	      var eff = (0, _preparationFactor.effectivePreparationFactor)(this.value, this.schoolPrepFactorNumeric);
	      if (eff === null || isNaN(eff)) {
	        return 0;
	      }
	      return eff;
	    },
	    formattedDanishPreparationFactor: function formattedDanishPreparationFactor() {
	      var n = this.effectiveDanishPreparationFactorNumeric;
	      if (typeof n !== 'number' || isNaN(n)) {
	        return '0';
	      }
	      return String(Number(n.toFixed(4)));
	    },
	    numericTippyOptions: function numericTippyOptions() {
	      return {
	        content: this.labels.forb_faktor_range_hint,
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	        trigger: 'mouseenter focus',
	        maxWidth: 280
	      };
	    },
	    toggleTippyOptions: function toggleTippyOptions() {
	      return {
	        content: this.labels.prep_task_extra_toggle_hint,
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	        trigger: 'mouseenter focus',
	        maxWidth: 320
	      };
	    }
	  },
	  watch: {
	    subjectType: function subjectType() {
	      this.isDanishPreparationFactorEditing = false;
	      this.numericEditDraft = '';
	    },
	    isBinaryPrepTask: function isBinaryPrepTask(isBinary) {
	      if (isBinary) {
	        this.isDanishPreparationFactorEditing = false;
	        this.numericEditDraft = '';
	      }
	    }
	  },
	  methods: {
	    valueToDraft: function valueToDraft(v) {
	      if (v === null || v === undefined || v === '') {
	        return '';
	      }
	      var n = typeof v === 'number' ? v : parseFloat(String(v).replace(',', '.'));
	      if (isNaN(n)) {
	        return '';
	      }
	      return String(n);
	    },
	    onPrepToggle: function onPrepToggle(isOn) {
	      this.$emit('input', isOn ? 1 : null);
	    },
	    openDanishPreparationFactorEdit: function openDanishPreparationFactorEdit() {
	      var _this = this;
	
	      this.isDanishPreparationFactorEditing = true;
	      this.numericEditDraft = this.valueToDraft(this.value);
	      this.$nextTick(function (_) {
	        var el = _this.$refs.inputDanishPreparationFactor;
	        if (el) {
	          el.focus();
	        }
	      });
	    },
	    onDanishPreparationFactorInput: function onDanishPreparationFactorInput(e) {
	      var raw = e.target.value;
	      this.numericEditDraft = raw;
	      if (raw === '' || raw === '-' || raw === '.' || raw === ',' || raw === '-.') {
	        return;
	      }
	      var n = parseFloat(String(raw).replace(',', '.'));
	      if (isNaN(n)) {
	        return;
	      }
	      var c = n < -1 ? -1 : n > 1 ? 1 : n;
	      if (c !== n) {
	        this.$emit('input', c);
	        this.numericEditDraft = String(c);
	      } else {
	        this.$emit('input', n);
	      }
	    },
	    onDanishPreparationFactorBlur: function onDanishPreparationFactorBlur() {
	      var n = parseFloat(String(this.numericEditDraft).replace(',', '.'));
	      var parsed = this.numericEditDraft === '' || isNaN(n) ? null : n;
	      var clamped = (0, _preparationFactor.clampDanishPreparationFactor)(parsed);
	      this.$emit('input', clamped);
	      this.numericEditDraft = this.valueToDraft(clamped);
	      this.isDanishPreparationFactorEditing = false;
	    },
	    selectAllOnFocus: function selectAllOnFocus(evt) {
	      setTimeout(function (_) {
	        evt.target.select();
	      }, 0);
	    }
	  }
	};

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    calendarId: {},
	    noSubjects: {
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      klassHasNoSubjects: false,
	      i18n: {
	        da: {
	          no_subjects_created: 'Ingen fag er oprettet. Du kan enten',
	          import_subjects: 'importere standardfag',
	          or_click_on_create_subject: 'eller klikke på "Opret brik"'
	        },
	        nb: {
	          no_subjects_created: 'Det er ikke opprettet fag. Du kan enten',
	          import_subjects: 'importere standardfag',
	          or_click_on_create_subject: 'eller trykke på "Opprett fag"'
	        }
	      },
	      en: {
	        no_subjects_created: 'No courses have been created. You can choose to either',
	        import_subjects: 'import courses',
	        or_click_on_create_subject: 'or create them yourself by clicking on "Create course”'
	      }
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    allKlassCalendarsInHash: function allKlassCalendarsInHash() {
	      return this.$store.getters.allKlassCalendarsInHash;
	    },
	    theCalendar: function theCalendar() {
	      return this.allKlassCalendarsInHash[this.calendarId] ? this.allKlassCalendarsInHash[this.calendarId] : null;
	    }
	  },
	  methods: {
	    setImportSubjects: function setImportSubjects() {
	      _eventbus2.default.theKlassesToImportSubjectTo = [this.theCalendar];
	      _eventbus2.default.createKlassModal = true;
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.klassHasNoSubjects = this.noSubjects;
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.addEventListener('vueUpdateSidebarSubjects', function (evt) {
	      _this.klassHasNoSubjects = false;
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _this2 = this;
	
	    window.removeEventListener('vueUpdateSidebarSubjects', function (evt) {
	      _this2.klassHasNoSubjects = false;
	    });
	  }
	};

/***/ }),
/* 719 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    closeCrossColor: {
	      default: '#ffffff'
	    },
	    isCloseOnEsc: {
	      type: Boolean,
	      default: true
	    },
	    maxWidth: {
	      type: String,
	      default: null
	    },
	    top: {
	      type: String,
	      default: null
	    }
	  },
	  computed: {
	    modalStyle: function modalStyle() {
	      var style = {};
	      if (this.maxWidth) style.maxWidth = this.maxWidth;
	      if (this.top) style.top = this.top;
	      return style;
	    }
	  },
	  methods: {
	    handleKeydown: function handleKeydown(event) {
	      if (event.key === 'Escape' && this.isCloseOnEsc) {
	        this.$emit('close');
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (!document.querySelector('body').classList.contains('no-scroll')) {
	      document.querySelector('body').classList.add('no-scroll');
	    }
	  },
	  mounted: function mounted() {
	    window.addEventListener('keydown', this.handleKeydown);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.querySelector('body').classList.remove('no-scroll');
	    window.removeEventListener('keydown', this.handleKeydown);
	  }
	};

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _OnwardEndDate = __webpack_require__(1467);
	
	var _OnwardEndDate2 = _interopRequireDefault(_OnwardEndDate);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  user: {
	    add: {
	      da: {
	        title: 'Sæt underviser på skemalagte brikker?',
	        intro: 'Vil du sætte %{name} på alle skemalagte brikker?',
	        subtitle: '%{subject} fra d. %{date}',
	        subtitle_until: '%{subject} fra d. %{date} til d. %{endDate}',
	        from_date: 'Gælder fra',
	        set_end_date: 'Sæt slutdato',
	        skip: 'Kun brikken',
	        confirm: 'Ja, sæt på skemalagte'
	      },
	      en: {
	        title: 'Assign teacher to scheduled lessons?',
	        intro: 'Do you want to assign %{name} to all scheduled lessons?',
	        subtitle: '%{subject} from %{date}',
	        subtitle_until: '%{subject} from %{date} until %{endDate}',
	        from_date: 'Apply from',
	        set_end_date: 'Set end date',
	        skip: 'Subject only',
	        confirm: 'Yes, assign to scheduled'
	      },
	      nb: {
	        title: 'Sett lærer på timeplanlagte brikker?',
	        intro: 'Vil du sette %{name} på alle timeplanlagte brikker?',
	        subtitle: '%{subject} fra %{date}',
	        subtitle_until: '%{subject} fra %{date} til %{endDate}',
	        from_date: 'Gjelder fra',
	        set_end_date: 'Sett sluttdato',
	        skip: 'Kun faget',
	        confirm: 'Ja, sett på timeplanlagte'
	      }
	    },
	    remove: {
	      da: {
	        title: 'Fjern underviser fra skemalagte brikker?',
	        intro: 'Vil du fjerne %{name} fra alle skemalagte brikker?',
	        subtitle: '%{subject} fra d. %{date}',
	        subtitle_until: '%{subject} fra d. %{date} til d. %{endDate}',
	        from_date: 'Gælder fra',
	        set_end_date: 'Sæt slutdato',
	        skip: 'Kun brikken',
	        confirm: 'Ja, fjern fra skemalagte'
	      },
	      en: {
	        title: 'Remove teacher from scheduled lessons?',
	        intro: 'Do you want to remove %{name} from all scheduled lessons?',
	        subtitle: '%{subject} from %{date}',
	        subtitle_until: '%{subject} from %{date} until %{endDate}',
	        from_date: 'Apply from',
	        set_end_date: 'Set end date',
	        skip: 'Subject only',
	        confirm: 'Yes, remove from scheduled'
	      },
	      nb: {
	        title: 'Fjern lærer fra timeplanlagte brikker?',
	        intro: 'Vil du fjerne %{name} fra alle timeplanlagte brikker?',
	        subtitle: '%{subject} fra %{date}',
	        subtitle_until: '%{subject} fra %{date} til %{endDate}',
	        from_date: 'Gjelder fra',
	        set_end_date: 'Sett sluttdato',
	        skip: 'Kun faget',
	        confirm: 'Ja, fjern fra timeplanlagte'
	      }
	    }
	  },
	  klass: {
	    add: {
	      da: {
	        title: 'Sæt klasse på skemalagte brikker?',
	        intro: 'Vil du sætte %{name} på alle skemalagte brikker?',
	        subtitle: '%{subject} fra d. %{date}',
	        subtitle_until: '%{subject} fra d. %{date} til d. %{endDate}',
	        from_date: 'Gælder fra',
	        set_end_date: 'Sæt slutdato',
	        skip: 'Kun brikken',
	        confirm: 'Ja, sæt på skemalagte'
	      },
	      en: {
	        title: 'Assign class to scheduled lessons?',
	        intro: 'Do you want to assign %{name} to all scheduled lessons?',
	        subtitle: '%{subject} from %{date}',
	        subtitle_until: '%{subject} from %{date} until %{endDate}',
	        from_date: 'Apply from',
	        set_end_date: 'Set end date',
	        skip: 'Subject only',
	        confirm: 'Yes, assign to scheduled'
	      },
	      nb: {
	        title: 'Sett klasse på timeplanlagte brikker?',
	        intro: 'Vil du sette %{name} på alle timeplanlagte brikker?',
	        subtitle: '%{subject} fra %{date}',
	        subtitle_until: '%{subject} fra %{date} til %{endDate}',
	        from_date: 'Gjelder fra',
	        set_end_date: 'Sett sluttdato',
	        skip: 'Kun faget',
	        confirm: 'Ja, sett på timeplanlagte'
	      }
	    },
	    remove: {
	      da: {
	        title: 'Fjern klasse fra skemalagte brikker?',
	        intro: 'Vil du fjerne %{name} fra alle skemalagte brikker?',
	        subtitle: '%{subject} fra d. %{date}',
	        subtitle_until: '%{subject} fra d. %{date} til d. %{endDate}',
	        from_date: 'Gælder fra',
	        set_end_date: 'Sæt slutdato',
	        skip: 'Kun brikken',
	        confirm: 'Ja, fjern fra skemalagte'
	      },
	      en: {
	        title: 'Remove class from scheduled lessons?',
	        intro: 'Do you want to remove %{name} from all scheduled lessons?',
	        subtitle: '%{subject} from %{date}',
	        subtitle_until: '%{subject} from %{date} until %{endDate}',
	        from_date: 'Apply from',
	        set_end_date: 'Set end date',
	        skip: 'Subject only',
	        confirm: 'Yes, remove from scheduled'
	      },
	      nb: {
	        title: 'Fjern klasse fra timeplanlagte brikker?',
	        intro: 'Vil du fjerne %{name} fra alle timeplanlagte brikker?',
	        subtitle: '%{subject} fra %{date}',
	        subtitle_until: '%{subject} fra %{date} til %{endDate}',
	        from_date: 'Gjelder fra',
	        set_end_date: 'Sett sluttdato',
	        skip: 'Kun faget',
	        confirm: 'Ja, fjern fra timeplanlagte'
	      }
	    }
	  },
	  room: {
	    add: {
	      da: {
	        title: 'Sæt lokale på skemalagte brikker?',
	        intro: 'Vil du sætte %{name} på alle skemalagte brikker?',
	        subtitle: '%{subject} fra d. %{date}',
	        subtitle_until: '%{subject} fra d. %{date} til d. %{endDate}',
	        from_date: 'Gælder fra',
	        set_end_date: 'Sæt slutdato',
	        skip: 'Kun brikken',
	        confirm: 'Ja, sæt på skemalagte'
	      },
	      en: {
	        title: 'Assign room to scheduled lessons?',
	        intro: 'Do you want to assign %{name} to all scheduled lessons?',
	        subtitle: '%{subject} from %{date}',
	        subtitle_until: '%{subject} from %{date} until %{endDate}',
	        from_date: 'Apply from',
	        set_end_date: 'Set end date',
	        skip: 'Subject only',
	        confirm: 'Yes, assign to scheduled'
	      },
	      nb: {
	        title: 'Sett lokale på timeplanlagte brikker?',
	        intro: 'Vil du sette %{name} på alle timeplanlagte brikker?',
	        subtitle: '%{subject} fra %{date}',
	        subtitle_until: '%{subject} fra %{date} til %{endDate}',
	        from_date: 'Gjelder fra',
	        set_end_date: 'Sett sluttdato',
	        skip: 'Kun faget',
	        confirm: 'Ja, sett på timeplanlagte'
	      }
	    },
	    remove: {
	      da: {
	        title: 'Fjern lokale fra skemalagte brikker?',
	        intro: 'Vil du fjerne %{name} fra alle skemalagte brikker?',
	        subtitle: '%{subject} fra d. %{date}',
	        subtitle_until: '%{subject} fra d. %{date} til d. %{endDate}',
	        from_date: 'Gælder fra',
	        set_end_date: 'Sæt slutdato',
	        skip: 'Kun brikken',
	        confirm: 'Ja, fjern fra skemalagte'
	      },
	      en: {
	        title: 'Remove room from scheduled lessons?',
	        intro: 'Do you want to remove %{name} from all scheduled lessons?',
	        subtitle: '%{subject} from %{date}',
	        subtitle_until: '%{subject} from %{date} until %{endDate}',
	        from_date: 'Apply from',
	        set_end_date: 'Set end date',
	        skip: 'Subject only',
	        confirm: 'Yes, remove from scheduled'
	      },
	      nb: {
	        title: 'Fjern lokale fra timeplanlagte brikker?',
	        intro: 'Vil du fjerne %{name} fra alle timeplanlagte brikker?',
	        subtitle: '%{subject} fra %{date}',
	        subtitle_until: '%{subject} fra %{date} til %{endDate}',
	        from_date: 'Gjelder fra',
	        set_end_date: 'Sett sluttdato',
	        skip: 'Kun faget',
	        confirm: 'Ja, fjern fra timeplanlagte'
	      }
	    }
	  }
	};
	
	exports.default = {
	  components: { DateSelector: _DateSelector2.default, OnwardEndDate: _OnwardEndDate2.default },
	  props: {
	    teacherNames: {
	      type: String,
	      default: ''
	    },
	    initialDate: {
	      default: null
	    },
	    mode: {
	      type: String,
	      default: 'add'
	    },
	    calendarKind: {
	      type: String,
	      default: 'user'
	    },
	    color: {
	      type: String,
	      default: ''
	    },
	    subjectName: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      fromDate: this.initialDate || (0, _moment2.default)().format('YYYY-MM-DD'),
	      enddate: null
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      var kindTexts = I18N[this.calendarKind] || I18N.user;
	      var modeTexts = kindTexts[this.mode] || kindTexts.add;
	      return modeTexts[this.locale] || modeTexts.da;
	    },
	    introText: function introText() {
	      return this.i18n.intro.replace('%{name}', this.teacherNames || '');
	    },
	    headerColor: function headerColor() {
	      return this.color || '#A0A5EF';
	    },
	    formattedFromDate: function formattedFromDate() {
	      return (0, _moment2.default)(this.fromDate).locale(this.locale).format('D. MMMM YYYY');
	    },
	    formattedEndDate: function formattedEndDate() {
	      if (!this.enddate) return '';
	      return (0, _moment2.default)(this.enddate).locale(this.locale).format('D. MMMM YYYY');
	    },
	    headerSubtitle: function headerSubtitle() {
	      if (!this.subjectName) return '';
	      var template = this.enddate && this.i18n.subtitle_until ? this.i18n.subtitle_until : this.i18n.subtitle;
	      return template.replace('%{subject}', this.subjectName).replace('%{date}', this.formattedFromDate).replace('%{endDate}', this.formattedEndDate);
	    }
	  },
	  methods: {
	    setFromDate: function setFromDate(date) {
	      this.fromDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      if (this.enddate && this.enddate < this.fromDate) {
	        this.enddate = this.fromDate;
	      }
	    },
	    onConfirm: function onConfirm() {
	      this.$emit('confirm', {
	        fromDate: this.fromDate,
	        enddate: this.enddate || null
	      });
	    },
	    handleKeydown: function handleKeydown(event) {
	      if (event.key === 'Escape') {
	        this.$emit('skip');
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.addEventListener('keydown', this.handleKeydown);
	    this.$nextTick(function () {
	      if (_this.$refs.satc) _this.$refs.satc.focus();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('keydown', this.handleKeydown);
	  }
	};

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Modal = __webpack_require__(69);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _DSelectUsers = __webpack_require__(67);
	
	var _DSelectUsers2 = _interopRequireDefault(_DSelectUsers);
	
	var _DSelectKlass = __webpack_require__(350);
	
	var _DSelectKlass2 = _interopRequireDefault(_DSelectKlass);
	
	var _ColorPicker = __webpack_require__(68);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	var _SubjectFormSubjectType = __webpack_require__(61);
	
	var _SubjectFormSubjectType2 = _interopRequireDefault(_SubjectFormSubjectType);
	
	var _DSelectCalsIds = __webpack_require__(40);
	
	var _DSelectCalsIds2 = _interopRequireDefault(_DSelectCalsIds);
	
	var _SubjectFormLog = __webpack_require__(389);
	
	var _SubjectFormLog2 = _interopRequireDefault(_SubjectFormLog);
	
	var _StandardDurationSetting = __webpack_require__(382);
	
	var _StandardDurationSetting2 = _interopRequireDefault(_StandardDurationSetting);
	
	var _SubjectFormDeleteSubjects = __webpack_require__(388);
	
	var _SubjectFormDeleteSubjects2 = _interopRequireDefault(_SubjectFormDeleteSubjects);
	
	var _SubjectFormReductions = __webpack_require__(1618);
	
	var _SubjectFormReductions2 = _interopRequireDefault(_SubjectFormReductions);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SubjectFormCalendarHours = __webpack_require__(387);
	
	var _SubjectFormCalendarHours2 = _interopRequireDefault(_SubjectFormCalendarHours);
	
	var _DkPreparationFactorControl = __webpack_require__(100);
	
	var _DkPreparationFactorControl2 = _interopRequireDefault(_DkPreparationFactorControl);
	
	var _SubjectPoolsUpdateConfirm = __webpack_require__(390);
	
	var _SubjectPoolsUpdateConfirm2 = _interopRequireDefault(_SubjectPoolsUpdateConfirm);
	
	var _SubjectAssignTeacherToEventsConfirm = __webpack_require__(386);
	
	var _SubjectAssignTeacherToEventsConfirm2 = _interopRequireDefault(_SubjectAssignTeacherToEventsConfirm);
	
	var _assignTeacherToScheduledEvents = __webpack_require__(158);
	
	var _assignTeacherToScheduledEvents2 = _interopRequireDefault(_assignTeacherToScheduledEvents);
	
	var _subjectPools = __webpack_require__(111);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _dkPreparationFactorUi = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    create_subject: 'Opret fag',
	    hours_in_school_year: 'Klokketimer i skoleåret',
	    add_teacher: 'Tilføj underviser',
	    add_room: 'Tilføj lokale',
	    add_klass: 'Tilføj klasse',
	    more_settings: 'Yderligere indstillinger',
	    subject_title: 'Fagets navn',
	    standard_duration: 'Normal varighed (i minutter)',
	    choose_class: 'Vælg klasse',
	    choose_color: 'Vælg farve',
	    choose_subject_type: 'Vælg briktype',
	    ex_subject: 'Eks. Dansk',
	    cancel: 'Annullér',
	    update_subject: 'Opdatér',
	    delete_subject: 'Slet faget i klassen',
	    edit_subject: 'Redigér',
	    activity: 'Historik',
	    latest_activity: 'Seneste aktivitet',
	    cannot_delete: 'Ikke muligt at slette, da brikken er skemalagt',
	    requested_by: 'Ønsket af',
	    subject_code: 'Fagkode',
	    forb_faktor: 'Forb. faktor',
	    forb_faktor_range_hint: 'Mellem 0 og -1',
	    prep_task_extra_toggle: 'Medregnes ud over forberedelse fra forberedelesfaktor',
	    prep_task_extra_toggle_hint: 'Fra: opgaven følger skolens forberedelsesfaktor som øvrige brikker. Til: opgavens timer medregnes med faktor 1 oven i forberedelsen fra undervisningsfag.',
	    from_date: 'Startdato',
	    to_date: 'Slutdato',
	    show_dates_on_overview: 'Vis datoer på opgaveoversigten',
	    show_on_task_overview: 'Vis på opgaveoversigt',
	    show_on_task_overview_desc: 'Når denne er slået fra, vises faget ikke på opgaveoversigten.',
	    hours_disabled_desc: 'Klokketimer kan kun angives, når "Vis på opgaveoversigt" er slået til, da timerne bruges på opgaveoversigten.',
	    pool_for: 'pulje for',
	    pool_save_failed: 'Kunne ikke opdatere puljen'
	  },
	  en: {
	    create_subject: 'Create subject',
	    hours_in_school_year: 'Hours in school year',
	    add_teacher: 'Add teacher',
	    add_klass: 'Add grade/group',
	    add_room: 'Add room',
	    more_settings: 'Advanced settings',
	    subject_title: 'Subject title',
	    standard_duration: 'Standard duration (in minutes)',
	    choose_class: 'Choose class',
	    choose_color: 'Choose color',
	    choose_subject_type: 'Choose subject category',
	    ex_subject: 'E.g. Math',
	    cancel: 'Cancel',
	    update_subject: 'Update subject',
	    delete_subject: 'Delete subject in class',
	    edit_subject: 'Edit subject',
	    activity: 'History',
	    latest_activity: 'Activity',
	    cannot_delete: 'Not possible to delete because the subject has lessons in a calendar',
	    requested_by: 'Requested by',
	    subject_code: 'Subject code',
	    forb_faktor: 'Prep factor',
	    forb_faktor_range_hint: 'Between 0 and -1',
	    prep_task_extra_toggle: 'Counted in addition to preparation from teaching',
	    prep_task_extra_toggle_hint: 'Off: this task uses the school preparation factor like other tiles. On: hours are counted with factor 1 on top of preparation from teaching subjects.',
	    from_date: 'Start date',
	    to_date: 'End date',
	    show_dates_on_overview: 'Show dates on task overview',
	    show_on_task_overview: 'Show on task overview',
	    show_on_task_overview_desc: 'When turned off, the subject is not shown on the task overview.',
	    hours_disabled_desc: 'Hours can only be entered when "Show on task overview" is turned on, since the hours are used on the task overview.',
	    pool_for: 'pool for',
	    pool_save_failed: 'Could not update the pool'
	  },
	  nb: {
	    create_subject: 'Opprett fag',
	    hours_in_school_year: 'Årstimetall',
	    add_teacher: 'Legg til lærer',
	    add_room: 'Legg til lokale',
	    add_klass: 'Legg til klasse',
	    more_settings: 'Flere innstillinger',
	    subject_title: 'Navn på fag',
	    standard_duration: 'Normal varighet (i minutter)',
	    choose_class: 'Velg klasse',
	    choose_color: 'Velg farge',
	    choose_subject_type: 'Velg type',
	    ex_subject: 'F.eks. Norsk',
	    cancel: 'Angre',
	    update_subject: 'Oppdater fag',
	    delete_subject: 'Slett fag',
	    edit_subject: 'Rediger fag',
	    activity: 'Historikk',
	    latest_activity: 'Aktivitet',
	    cannot_delete: 'Ikke mulig å slette fordi faget har leksjoner i en kalender',
	    requested_by: 'Ønsket av',
	    subject_code: 'Fagkode',
	    forb_faktor: 'Forb. faktor',
	    forb_faktor_range_hint: 'Mellom 0 og -1',
	    prep_task_extra_toggle: 'Tas med i tillegg til forberedelse fra undervisning',
	    prep_task_extra_toggle_hint: 'Av: oppgaven følger skolens forberedelsesfaktor som andre brikker. På: oppgavens timer tas med med faktor 1 i tillegg til forberedelse fra undervisningsfag.',
	    from_date: 'Startdato',
	    to_date: 'Sluttdato',
	    show_dates_on_overview: 'Vis dato på oppgaveoversikt',
	    show_on_task_overview: 'Vis på oppgaveoversikt',
	    show_on_task_overview_desc: 'Når denne er slått av, vises faget ikke på oppgaveoversikten.',
	    hours_disabled_desc: 'Årstimetall kan kun angis når "Vis på oppgaveoversikt" er slått på, da timene brukes på oppgaveoversikten.',
	    pool_for: 'pulje for',
	    pool_save_failed: 'Kunne ikke oppdatere puljen'
	  }
	};
	
	exports.default = {
	  mixins: [_assignTeacherToScheduledEvents2.default],
	  components: {
	    SubjectAssignTeacherToEventsConfirm: _SubjectAssignTeacherToEventsConfirm2.default,
	    SubjectPoolsUpdateConfirm: _SubjectPoolsUpdateConfirm2.default,
	    SubjectFormCalendarHours: _SubjectFormCalendarHours2.default,
	    Loader: _Loader2.default,
	    SubjectFormReductions: _SubjectFormReductions2.default,
	    StandardDurationSetting: _StandardDurationSetting2.default,
	    modal: _Modal2.default,
	    ColorPicker: _ColorPicker2.default,
	    DSelectCalendarIds: _DSelectCalsIds2.default,
	    DSelectUser: _DSelectUsers2.default,
	    DSelectKlass: _DSelectKlass2.default,
	    SubjectTypePicker: _SubjectFormSubjectType2.default,
	    SubjectFormLog: _SubjectFormLog2.default,
	    SubjectFormDeleteSubjects: _SubjectFormDeleteSubjects2.default,
	    DkPreparationFactorControl: _DkPreparationFactorControl2.default,
	    DateSelector: _DateSelector2.default,
	    AppToggle: _AppToggle2.default
	  },
	  props: {
	    showModal: {
	      default: false
	    },
	    editSubject: {
	      default: null
	    },
	    isShowSubjectsRequest: {
	      type: Boolean,
	      default: false
	    },
	    subjectsRequestsInHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    isActivities: {
	      type: Boolean,
	      default: false
	    },
	    propCalendarId: {
	      default: null
	    },
	    poolCalendarId: {
	      default: null
	    },
	    propTab: {
	      default: null
	    },
	    isShowReductions: {
	      default: false
	    },
	    propIsLoading: {
	      default: false
	    },
	    allowDanishPreparationFactorUi: {
	      type: Boolean,
	      default: false
	    },
	    showActivities: {
	      type: Boolean,
	      default: false
	    },
	    isInDCalendar: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      preparationOptionsForNorway: [741, 711, 664, 635, 606],
	      preparation: null,
	      name: '',
	      color: '#A0A5EF',
	      calendarId: null,
	      defaultDuration: 45,
	      hours: 0,
	      subjectType: null,
	      klassCalendarIds: [],
	      userCalendarIds: [],
	      roomCalendarIds: [],
	      formErrors: [],
	      isEditSubjectAdvanced: false,
	      activeTab: 'edit',
	      subjectCode: '',
	      isOpenDurationModal: false,
	      isPossibleToAddKlasses: false,
	      subjectsWithSameName: [],
	      updatedSubject: null,
	      fromDate: null,
	      toDate: null,
	      isShowDateFields: false,
	      taskOverview: false,
	      showPoolsConfirm: false,
	      savedSubjectHours: null
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    subjectHasDifferentiatedPools: function subjectHasDifferentiatedPools() {
	      if (!this.editSubject) return false;
	      var subj = this.editSubject;
	      if (!subj) return false;
	
	      var rows = [];
	      if (subj.subject_calendars && subj.subject_calendars.length) {
	        rows = subj.subject_calendars;
	      } else if (subj.calendars_subjects && subj.calendars_subjects.length) {
	        rows = subj.calendars_subjects;
	      } else {
	        return false;
	      }
	
	      for (var i = 0; i < rows.length; i++) {
	        var sc = rows[i];
	        if (!sc) continue;
	
	        var v = sc.hours !== undefined ? sc.hours : sc.value;
	        if (v !== null && v !== undefined) return true;
	      }
	      return false;
	    },
	    subjectRequestedBy: function subjectRequestedBy() {
	      var _this = this;
	
	      if (!this.isShowSubjectsRequest || !this.editSubject) {
	        return [];
	      }
	      var calendarIds = this.subjectsRequestsInHash[this.editSubject.id] || [];
	      return calendarIds.filter(function (calId) {
	        return _this.allCalendarsInHash[calId];
	      }).map(function (calId) {
	        return _this.allCalendarsInHash[calId]['name'];
	      }).join(' ,');
	    },
	    isArbeidstidsplanActivated: function isArbeidstidsplanActivated() {
	      return this.$store.getters.isArbeidstidsplanActivated;
	    },
	    schoolCountry: function schoolCountry() {
	      return this.$store.getters.schoolCountry;
	    },
	    isSchoolFromDenmark: function isSchoolFromDenmark() {
	      return this.schoolCountry.toLowerCase() === 'dk';
	    },
	    standardSubjectCodes: function standardSubjectCodes() {
	      return this.$store.getters.standardSubjectCodes || [];
	    },
	    isReductionsActive: function isReductionsActive() {
	      return this.$store.getters.isReductionsActive;
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    isAllowedToAddKlasses: function isAllowedToAddKlasses() {
	      return this.calendarType === 'klass' || this.calendarType === 'user';
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    userCanManageSchool: function userCanManageSchool() {
	      return this.userHasPermission('can_manage_school');
	    },
	    canChangeTaskOverview: function canChangeTaskOverview() {
	      return this.userHasPermission('can_change_task_overview');
	    },
	    canSeeTaskOverviewToggle: function canSeeTaskOverviewToggle() {
	      return this.canChangeTaskOverview;
	    },
	    isHoursDisabled: function isHoursDisabled() {
	      return !this.isActivities && !this.taskOverview;
	    },
	    hoursDisabledTippy: function hoursDisabledTippy() {
	      var _this2 = this;
	
	      return {
	        arrow: false,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	        onShow: function onShow() {
	          return _this2.isHoursDisabled;
	        }
	      };
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    editSubjectCanBeDeleted: function editSubjectCanBeDeleted() {
	      return this.editSubject && this.editSubject.can_delete;
	    },
	    calendarType: function calendarType() {
	      var _this3 = this;
	
	      if (!this.calendarId) {
	        return 'klass';
	      }
	      var cal = this.allCalendarsInHash[this.calendarId];
	      if (cal) {
	        return cal.type;
	      }
	
	      var subjectCal = this.editSubject && Array.isArray(this.editSubject.cals) ? this.editSubject.cals.find(function (c) {
	        return c && c.id * 1 === _this3.calendarId * 1;
	      }) : null;
	      return subjectCal && subjectCal.calendar_type ? subjectCal.calendar_type : 'klass';
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    klassCalendarInHash: function klassCalendarInHash() {
	      return this.$store.getters.allKlassCalendarsInHash;
	    },
	    subjectsInKlassHash: function subjectsInKlassHash() {
	      return this.$store.getters.subjectsInKlassHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    poolEntry: function poolEntry() {
	      var _this4 = this;
	
	      if (!this.poolCalendarId || !this.editSubject || !Array.isArray(this.editSubject.subject_calendars)) {
	        return null;
	      }
	      return this.editSubject.subject_calendars.find(function (sc) {
	        return sc && sc.calendar_id * 1 === _this4.poolCalendarId * 1 && sc.hours !== null && sc.hours !== undefined;
	      }) || null;
	    },
	    isEditingPool: function isEditingPool() {
	      return !!this.poolEntry;
	    },
	    poolCalendarName: function poolCalendarName() {
	      var cal = this.allCalendarsInHash[this.poolCalendarId];
	      return cal && cal.name ? cal.name : '';
	    },
	    hoursLabel: function hoursLabel() {
	      var label = this.i18n[this.locale]['hours_in_school_year'];
	      if (!this.isEditingPool) {
	        return label;
	      }
	      return label + ' (' + this.i18n[this.locale]['pool_for'] + ' ' + this.poolCalendarName + ')';
	    },
	    subjectHours: function subjectHours() {
	      if (this.savedSubjectHours !== null) return this.savedSubjectHours;
	      return this.editSubject ? this.editSubject.hours : null;
	    },
	    isPoolHoursChanged: function isPoolHoursChanged() {
	      return this.isEditingPool && parseFloat(this.poolEntry.hours) !== parseFloat(this.hours);
	    },
	    showMasterCalendarName: function showMasterCalendarName() {
	      return this.editSubject && this.allCalendarsInHash[this.editSubject.calendar_id] && this.allCalendarsInHash[this.editSubject.calendar_id].name ? this.allCalendarsInHash[this.editSubject.calendar_id].name : '';
	    },
	    isShowSubjectsPools: function isShowSubjectsPools() {
	      return this.isSchoolFromDenmark;
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings || {};
	    },
	    isShowNorwegianPreparationDropdown: function isShowNorwegianPreparationDropdown() {
	      return this.isArbeidstidsplanActivated && !this.isSchoolFromDenmark;
	    },
	    isShowDanishPreparationFactorField: function isShowDanishPreparationFactorField() {
	      return this.allowDanishPreparationFactorUi && this.isSchoolFromDenmark && this.schoolSettings && this.schoolSettings.deactivatePools && (0, _dkPreparationFactorUi.schoolHasDanishPreparationFactorConfigured)(this.schoolSettings) && (0, _dkPreparationFactorUi.isSubjectTypeWithDanishPreparationFactor)(this.subjectType);
	    },
	    showDanishPreparationFactorBesideHours: function showDanishPreparationFactorBesideHours() {
	      if (!this.isShowDanishPreparationFactorField) {
	        return false;
	      }
	      return !!this.editSubject || !this.editSubject && !this.isEditSubjectAdvanced;
	    },
	    showDanishPreparationFactorInTitleRow: function showDanishPreparationFactorInTitleRow() {
	      return this.isShowDanishPreparationFactorField && !this.showDanishPreparationFactorBesideHours;
	    },
	    isDanishPrepBinaryOnOwnRow: function isDanishPrepBinaryOnOwnRow() {
	      return (0, _dkPreparationFactorUi.isDanishPreparationBinaryPrepTaskSubjectType)(this.subjectType);
	    },
	    danishPreparationControlLabels: function danishPreparationControlLabels() {
	      var L = this.i18n[this.locale];
	      return {
	        forb_faktor: L.forb_faktor,
	        forb_faktor_range_hint: L.forb_faktor_range_hint,
	        prep_task_extra_toggle: L.prep_task_extra_toggle,
	        prep_task_extra_toggle_hint: L.prep_task_extra_toggle_hint
	      };
	    },
	    today: function today() {
	      return (0, _moment2.default)().format('YYYY-MM-DD');
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    }
	  },
	  watch: {
	    defaultDuration: function defaultDuration(val) {
	      this.removeErrors('defaultDuration');
	    },
	
	    editSubject: {
	      handler: function handler(val) {
	        this.handleEditSubject();
	        if (val && val._openTab) {
	          this.activeTab = val._openTab;
	        }
	      },
	
	      immediate: true
	    }
	  },
	  methods: {
	    toggleDateFields: function toggleDateFields() {
	      this.isShowDateFields = !this.isShowDateFields;
	      if (this.isShowDateFields) {
	        if (!this.fromDate && this.activeSchoolYear) {
	          this.fromDate = this.activeSchoolYear.employee_time_start || null;
	        }
	        if (!this.toDate && this.activeSchoolYear) {
	          this.toDate = this.activeSchoolYear.employee_time_end || null;
	        }
	      } else {
	        this.fromDate = null;
	        this.toDate = null;
	      }
	    },
	    setFromDate: function setFromDate(date) {
	      var formatted = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      this.fromDate = formatted;
	      if (this.toDate && formatted > this.toDate) {
	        this.toDate = formatted;
	      }
	    },
	    setToDate: function setToDate(date) {
	      var formatted = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      this.toDate = formatted;
	      if (this.fromDate && formatted < this.fromDate) {
	        this.fromDate = formatted;
	      }
	    },
	    hasDifferentiatedPools: function hasDifferentiatedPools(subj) {
	      if (!subj) return false;
	
	      var rows = [];
	      if (subj.subject_calendars && subj.subject_calendars.length) {
	        rows = subj.subject_calendars;
	      } else if (subj.calendars_subjects && subj.calendars_subjects.length) {
	        rows = subj.calendars_subjects;
	      } else {
	        return false;
	      }
	
	      for (var i = 0; i < rows.length; i++) {
	        var sc = rows[i];
	        if (!sc) continue;
	        var v = sc.hours !== undefined ? sc.hours : sc.value;
	        if (v !== null && v !== undefined) return true;
	      }
	      return false;
	    },
	    applyHoursToCalendars: function applyHoursToCalendars(calendarIds, hours, done) {
	      var _this5 = this;
	
	      var subj = this.editSubject;
	      var finish = function finish() {
	        if (done) done();
	      };
	      if (!subj || !Array.isArray(calendarIds)) return finish();
	      var id = subj.id;
	      var schoolId = subj.school_id;
	      var schoolYearId = subj.school_year_id;
	      var queue = calendarIds.slice();
	      var next = function next() {
	        if (queue.length === 0) return finish();
	        _docendo2.default.setHoursForTeacherOnSubject(id, schoolId, schoolYearId, queue.shift(), hours, function (success) {
	          if (success) {
	            _this5.$store.commit('updateTeacherHoursOnSubject', success);
	          }
	          next();
	        }, function (failure) {
	          console.log('failed to update pool hours', failure);
	          next();
	        });
	      };
	      next();
	    },
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.user.admin;
	      }
	      return true;
	    },
	    toggleTaskOverview: function toggleTaskOverview() {
	      if (!this.canChangeTaskOverview) {
	        return;
	      }
	      this.taskOverview = !this.taskOverview;
	    },
	    taskOverviewForCreate: function taskOverviewForCreate() {
	      return this.canChangeTaskOverview ? this.taskOverview : false;
	    },
	    taskOverviewForUpdate: function taskOverviewForUpdate() {
	      if (this.canChangeTaskOverview) {
	        return this.taskOverview;
	      }
	      return this.editSubject && typeof this.editSubject.task_overview !== 'undefined' ? this.editSubject.task_overview : null;
	    },
	    selectAllOnFocus: function selectAllOnFocus(evt) {
	      setTimeout(function (_) {
	        evt.target.select();
	      }, 0);
	    },
	    hasUnsavedChanges: function hasUnsavedChanges() {
	      var _this6 = this;
	
	      if (!this.editSubject) return false;
	      var cals = this.editSubject.calendar_ids || this.editSubject.cals || [];
	      var originalUsers = cals.filter(function (id) {
	        return _this6.allCalendarsInHash[id] && _this6.allCalendarsInHash[id].type === 'user';
	      }).slice().sort();
	      var currentUsers = this.userCalendarIds.slice().sort();
	      if (originalUsers.length !== currentUsers.length) return true;
	      for (var i = 0; i < originalUsers.length; i++) {
	        if (originalUsers[i] !== currentUsers[i]) return true;
	      }
	      return false;
	    },
	    onClickCalendarHoursTab: function onClickCalendarHoursTab() {
	      if (this.hasUnsavedChanges()) {
	        if (window.confirm('Du har ugemte ændringer. Vil du gemme først?')) {
	          this.$emit('saveAndShowTab', this.buildUpdatedSubject(), 'calendarHours');
	          return;
	        }
	      }
	      this.activeTab = 'calendarHours';
	    },
	    buildUpdatedSubject: function buildUpdatedSubject() {
	      var calIds = [];
	      this.userCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      this.roomCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      this.klassCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      return {
	        id: this.editSubject.id,
	        name: this.name,
	        color: this.color,
	        calendarId: this.calendarId,
	        defaultDuration: this.defaultDuration,
	        preparation: this.preparationPayloadForSave(),
	        hours: this.isEditingPool ? this.subjectHours : this.hours,
	        subjectType: this.subjectType,
	        calendarIds: calIds,
	        subjectCode: this.subjectCode,
	        fromDate: this.fromDate || null,
	        toDate: this.toDate || null,
	        taskOverview: this.taskOverviewForUpdate()
	      };
	    },
	    setSelectedUsers: function setSelectedUsers(users) {
	      this.onTeacherSelectionUpdated(users);
	    },
	    setSelectedRooms: function setSelectedRooms(rooms) {
	      this.onRoomSelectionUpdated(rooms);
	    },
	    setSelectedKlass: function setSelectedKlass(klasses) {
	      this.onKlassSelectionUpdated(klasses);
	    },
	    addKlass: function addKlass(klass) {
	      this.calendarId = klass.id;
	      this.removeErrors('calendarId');
	    },
	    removeKlass: function removeKlass() {
	      this.calendarId = null;
	    },
	    setSubjectColor: function setSubjectColor(val) {
	      this.color = val;
	    },
	    formValidation: function formValidation() {
	      if (this.name.length < 1) {
	        this.$set(this.formErrors, 'name', {
	          da: 'Fag skal have et navn',
	          en: 'Subjects must have a name',
	          nb: 'Fag må ha et navn'
	        });
	      }
	      if (this.hours < 0) {
	        this.$set(this.formErrors, 'hours', {
	          da: 'Skal være 0 eller højere',
	          en: 'Must be zero or greater',
	          nb: 'Må være 0 eller høyere'
	        });
	      }
	      if (!this.isAValidDuration(this.defaultDuration)) {
	        this.$set(this.formErrors, 'defaultDuration', {
	          da: 'Må ikke være højere end 1440 minutter',
	          en: 'Can not be greater than 1440 minutes',
	          nb: 'Kan ikke være lengre enn 1440 minutter'
	        });
	      }
	      if (!this.calendarId) {
	        this.$set(this.formErrors, 'calendarId', {
	          da: 'Skal vælges. Du kan bagefter kopiere til andre',
	          en: 'Must choose a class. It can later be copied',
	          nb: 'Må velges. Du kan deretter kopiere til andres'
	        });
	      }
	    },
	    removeErrors: function removeErrors(title) {
	      this.$delete(this.formErrors, title);
	    },
	    createSubject: function createSubject() {
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      var newSubject = {
	        name: this.name,
	        color: this.color,
	        calendarId: this.calendarId,
	        defaultDuration: this.defaultDuration,
	        hours: this.hours,
	        subjectType: this.subjectType,
	        calendarIds: [],
	        subjectCode: this.subjectCode,
	        preparation: this.preparationPayloadForSave(),
	        fromDate: this.fromDate || null,
	        toDate: this.toDate || null,
	        taskOverview: this.taskOverviewForCreate()
	      };
	      this.$emit('createSubject', newSubject);
	    },
	    updateSubject: function updateSubject() {
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      var savedSubject = (0, _assign2.default)({}, this.editSubject, { hours: this.subjectHours });
	      if (!this.isEditingPool && (0, _subjectPools.shouldConfirmPoolsUpdate)(savedSubject, this.hours)) {
	        this.showPoolsConfirm = true;
	        return;
	      }
	      if (this.shouldWaitForTeacherAssignBeforeUpdate()) {
	        return;
	      }
	      this.doUpdateSubject();
	    },
	    doUpdateSubject: function doUpdateSubject() {
	      var _this7 = this;
	
	      if (!this.isPoolHoursChanged) {
	        this.emitUpdatedSubject();
	        return;
	      }
	      var subj = this.editSubject;
	      _docendo2.default.setHoursForTeacherOnSubject(subj.id, subj.school_id, subj.school_year_id, this.poolCalendarId, this.hours, function (success) {
	        if (success) {
	          _this7.$store.commit('updateTeacherHoursOnSubject', success);
	        }
	        _this7.emitUpdatedSubject();
	      }, function (failure) {
	        console.log('failed to update pool hours', failure);
	        _eventbus2.default.toast = { text: _this7.i18n[_this7.locale]['pool_save_failed'], success: false };
	      });
	    },
	    emitUpdatedSubject: function emitUpdatedSubject() {
	      var calIds = [];
	      this.userCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      this.roomCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      this.klassCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      this.updatedSubject = {
	        id: this.editSubject.id,
	        name: this.name,
	        color: this.color,
	        calendarId: this.calendarId,
	        defaultDuration: this.defaultDuration,
	        preparation: this.preparationPayloadForSave(),
	        hours: this.isEditingPool ? this.subjectHours : this.hours,
	        subjectType: this.subjectType,
	        calendarIds: calIds,
	        subjectCode: this.subjectCode,
	        fromDate: this.fromDate || null,
	        toDate: this.toDate || null,
	        taskOverview: this.taskOverviewForUpdate()
	      };
	      if (this.klassCalendarIds.length === 0) {
	        this.$emit('updateSubject', this.updatedSubject);
	      } else {
	        this.checkIfAddedKlassAlreadyHasSubjectWithSameName();
	      }
	    },
	    onPoolsConfirmUpdateAll: function onPoolsConfirmUpdateAll(calendarIds) {
	      var _this8 = this;
	
	      this.showPoolsConfirm = false;
	      this.applyHoursToCalendars(calendarIds, this.hours, function () {
	        return _this8.proceedAfterPoolsConfirm();
	      });
	    },
	    onPoolsConfirmSubjectOnly: function onPoolsConfirmSubjectOnly() {
	      this.showPoolsConfirm = false;
	      this.proceedAfterPoolsConfirm();
	    },
	    proceedAfterPoolsConfirm: function proceedAfterPoolsConfirm() {
	      if (this.shouldWaitForTeacherAssignBeforeUpdate()) {
	        return;
	      }
	      this.doUpdateSubject();
	    },
	    onPoolsConfirmClose: function onPoolsConfirmClose() {
	      this.showPoolsConfirm = false;
	    },
	    onSubjectHoursSaved: function onSubjectHoursSaved(hours) {
	      this.savedSubjectHours = hours;
	      if (!this.isEditingPool) {
	        this.hours = hours;
	      }
	    },
	    checkIfAddedKlassAlreadyHasSubjectWithSameName: function checkIfAddedKlassAlreadyHasSubjectWithSameName() {
	      var _this9 = this;
	
	      var newKlassesAddedOnSubject = [];
	      this.klassCalendarIds.forEach(function (calId) {
	        if (_this9.editSubject.calendar_ids.indexOf(calId) < 0) {
	          newKlassesAddedOnSubject.push(calId);
	        }
	      });
	      if (newKlassesAddedOnSubject.length > 0) {
	        newKlassesAddedOnSubject.forEach(function (calId) {
	          var subjectIdsForKlass = _this9.subjectsInKlassHash[calId];
	          var klassSubjects = subjectIdsForKlass.map(function (subjectId) {
	            if (_this9.subjectsInHash[subjectId]) {
	              return _this9.subjectsInHash[subjectId];
	            }
	          });
	          klassSubjects.forEach(function (subject) {
	            if (subject.name === _this9.name) {
	              _this9.subjectsWithSameName.push(subject);
	            }
	          });
	        });
	        if (this.subjectsWithSameName.length === 0) {
	          this.$emit('updateSubject', this.updatedSubject);
	        }
	      } else {
	        this.$emit('updateSubject', this.updatedSubject);
	      }
	    },
	    deleteExistingSubjects: function deleteExistingSubjects() {
	      var _this10 = this;
	
	      this.subjectsWithSameName.forEach(function (subject) {
	        _this10.$emit('deleteSubject', subject);
	      });
	      this.$emit('updateSubject', this.updatedSubject);
	    },
	    keepExistingSubjects: function keepExistingSubjects() {
	      this.subjectsWithSameName = [];
	      this.$emit('updateSubject', this.updatedSubject);
	    },
	    closeModalSubjectsWithSameName: function closeModalSubjectsWithSameName() {
	      this.subjectsWithSameName = [];
	    },
	    deleteEditSubject: function deleteEditSubject() {
	      this.$emit('deleteSubject', this.editSubject);
	    },
	    clearForm: function clearForm() {
	      this.formErrors = [];
	      this.name = '';
	      this.calendarIds = [];
	      this.hours = 0;
	      this.color = '#A0A5EF';
	      this.setDefaultDuration();
	      this.subjectCode = '';
	      this.subjectsWithSameName = [];
	      this.updatedSubject = null;
	      this.preparation = '';
	      this.fromDate = null;
	      this.toDate = null;
	      this.isShowDateFields = false;
	      this.taskOverview = false;
	    },
	    preparationPayloadForSave: function preparationPayloadForSave() {
	      return (0, _dkPreparationFactorUi.preparationPayloadForSave)(this.preparation, this.isShowDanishPreparationFactorField, this.subjectType);
	    },
	    preparationFromApiForForm: function preparationFromApiForForm(prep) {
	      return (0, _dkPreparationFactorUi.preparationFromApiForForm)(prep, this.isShowDanishPreparationFactorField, this.subjectType);
	    },
	    close: function close() {
	      this.clearForm();
	      this.$emit('close');
	    },
	    selectSubjectType: function selectSubjectType(subjectType) {
	      this.subjectType = subjectType;
	    },
	    saveUpdatedDuration: function saveUpdatedDuration() {
	      this.setDefaultDuration();
	      this.$refs.input_default_duration.focus();
	      this.$refs.input_default_duration.select();
	    },
	    setDefaultDuration: function setDefaultDuration() {
	      if (this.activeSchool && this.activeSchool.subject_default_duration) {
	        this.defaultDuration = this.activeSchool.subject_default_duration;
	      } else {
	        this.defaultDuration = 45;
	      }
	    },
	    isAValidDuration: function isAValidDuration(duration) {
	      return (/^-?[\d.]+(?:e-?\d+)?$/.test(duration) && duration > 0 && duration < 1440
	      );
	    },
	    handleEditSubject: function handleEditSubject() {
	      var _this11 = this;
	
	      this.savedSubjectHours = null;
	      if (this.editSubject) {
	        this.name = this.editSubject.name;
	        this.color = this.editSubject.color;
	        this.hours = this.isEditingPool ? parseFloat(this.poolEntry.hours) : this.editSubject.hours;
	        this.defaultDuration = this.editSubject.default_duration;
	        this.subjectType = this.editSubject.subject_type;
	        this.calendarId = this.editSubject.calendar_id;
	        this.subjectCode = this.editSubject.subject_code;
	
	        if (this.editSubject.preparation != null) {
	          this.preparation = this.preparationFromApiForForm(this.editSubject.preparation);
	        } else {
	          this.preparation = null;
	        }
	        this.fromDate = this.editSubject.from_date || null;
	        this.toDate = this.editSubject.to_date || null;
	        this.isShowDateFields = !!(this.fromDate || this.toDate);
	        this.taskOverview = typeof this.editSubject.task_overview !== 'undefined' ? this.editSubject.task_overview : false;
	
	        var cals = this.editSubject.calendar_ids ? this.editSubject.calendar_ids : this.editSubject.cals;
	        if (cals) {
	          cals.forEach(function (calid) {
	            if (_this11.allCalendarsInHash[calid] && _this11.allCalendarsInHash[calid].type === 'user') {
	              _this11.userCalendarIds.push(calid);
	            }
	            if (_this11.allCalendarsInHash[calid] && _this11.allCalendarsInHash[calid].type === 'room') {
	              _this11.roomCalendarIds.push(calid);
	            }
	            if (_this11.allCalendarsInHash[calid] && _this11.allCalendarsInHash[calid].type === 'klass' && calid !== _this11.calendarId) {
	              _this11.isPossibleToAddKlasses = true;
	              _this11.klassCalendarIds.push(calid);
	            }
	          });
	        }
	      } else {
	        this.setDefaultDuration();
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.propTab) {
	      this.activeTab = this.propTab;
	    }
	    if (this.isActivities) {
	      this.subjectType = 'activity';
	    }
	  },
	  mounted: function mounted() {
	    var _this12 = this;
	
	    if (this.propCalendarId) {
	      this.calendarId = this.propCalendarId;
	    }
	    if (this.editSubject) {
	      if (this.activeTab === 'edit') {
	        setTimeout(function (_) {
	          if (_this12.$refs.inputLessonCount) _this12.$refs.inputLessonCount.focus();
	        }, 500);
	      }
	      return;
	    }
	    setTimeout(function (_) {
	      if (_this12.$refs.name) _this12.$refs.name.focus();
	    }, 150);
	  }
	};

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    subject: {
	      type: Object,
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      localRows: this.subject && this.subject.subject_calendars ? this.subject.subject_calendars.map(function (sc) {
	        return { calendar_id: sc.calendar_id, hours: sc.hours };
	      }) : [],
	      originalByCalId: this.subject && this.subject.subject_calendars ? this.subject.subject_calendars.reduce(function (acc, sc) {
	        acc[sc.calendar_id] = sc.hours;
	        return acc;
	      }, {}) : {},
	      calsById: this.subject && this.subject.cals ? this.subject.cals.reduce(function (acc, c) {
	        acc[c.id] = { name: c.name, calendar_type: c.calendar_type };
	        return acc;
	      }, {}) : {},
	      savingRows: {},
	      savedSubjectHours: this.subject ? this.subject.hours : null,
	      subjectHoursInput: this.subject && this.subject.hours != null ? String(this.subject.hours) : '',
	      isSavingSubjectHours: false
	    };
	  },
	
	  computed: {
	    isSubjectHoursChanged: function isSubjectHoursChanged() {
	      if (this.subjectHoursInput === '' || this.subjectHoursInput == null) return false;
	      return parseFloat(this.subjectHoursInput) !== parseFloat(this.savedSubjectHours);
	    },
	    sortedRows: function sortedRows() {
	      var self = this;
	      var rows = this.localRows.filter(function (r) {
	        return !self.isRoomCalendar(r.calendar_id);
	      });
	
	      return rows.slice().sort(function (a, b) {
	        var ma = self.calsById[a.calendar_id] || {};
	        var mb = self.calsById[b.calendar_id] || {};
	
	        var priA = ma.calendar_type === 'klass' ? 0 : 1;
	        var priB = mb.calendar_type === 'klass' ? 0 : 1;
	        if (priA !== priB) return priA - priB;
	
	        var na = ma.name ? ma.name.toLowerCase() : '';
	        var nb = mb.name ? mb.name.toLowerCase() : '';
	        if (na < nb) return -1;
	        if (na > nb) return 1;
	
	        return String(a.calendar_id).localeCompare(String(b.calendar_id));
	      });
	    }
	  },
	  methods: {
	    isRoomCalendar: function isRoomCalendar(calendarId) {
	      var meta = this.calsById[calendarId];
	      if (!meta || !meta.calendar_type) return false;
	      var t = String(meta.calendar_type).toLowerCase();
	
	      if (t === 'room') {
	        return true;
	      }
	      return false;
	    },
	    displayHoursSource: function displayHoursSource(row) {
	      if (row.hours != null) return 'sat på denne kalender';
	
	      var type = this.calendarType(row.calendar_id);
	
	      if (type === 'user') {
	        var ch = this.classSetHours();
	        if (ch != null) return 'fra klassens pulje';
	        return 'fra brikken';
	      }
	
	      if (type === 'klass') return 'fra brikken';
	
	      return 'fra brikken';
	    },
	    selectAll: function selectAll(event) {
	      setTimeout(function () {
	        event.target.select();
	      }, 0);
	    },
	    calendarMeta: function calendarMeta(calendarId) {
	      return this.calsById[calendarId] || {};
	    },
	    calendarType: function calendarType(calendarId) {
	      var meta = this.calendarMeta(calendarId);
	      return meta.calendar_type || '';
	    },
	    isEditable: function isEditable(calendarId) {
	      var type = this.calendarType(calendarId);
	      return type === 'user' || type === 'klass';
	    },
	    differsFromSubject: function differsFromSubject(row) {
	      if (this.calendarType(row.calendar_id) !== 'klass') return false;
	      if (this.originalByCalId[row.calendar_id] == null) return false;
	      var saved = parseFloat(this.originalByCalId[row.calendar_id]);
	      var subjectHours = parseFloat(this.subjectDefaultHours());
	      if (isNaN(saved) || isNaN(subjectHours)) return false;
	      return saved !== subjectHours;
	    },
	    calendarName: function calendarName(calendarId) {
	      var meta = this.calendarMeta(calendarId);
	      if (meta && meta.name) return meta.name;
	      if (!this.subject || !this.subject.cals) return '' + calendarId;
	      for (var i = 0; i < this.subject.cals.length; i++) {
	        var c = this.subject.cals[i];
	        if (c && c.id === calendarId) return c.name;
	      }
	      return '' + calendarId;
	    },
	    firstClassCalendarId: function firstClassCalendarId() {
	      if (!this.subject || !Array.isArray(this.subject.cals)) return null;
	      for (var i = 0; i < this.subject.cals.length; i++) {
	        var c = this.subject.cals[i];
	        if (c && c.calendar_type === 'klass') return c.id;
	      }
	      return null;
	    },
	    classSetHours: function classSetHours() {
	      var classId = this.firstClassCalendarId();
	      if (classId == null) return null;
	      for (var i = 0; i < this.localRows.length; i++) {
	        var r = this.localRows[i];
	        if (r && r.calendar_id === classId) {
	          return r.hours != null ? r.hours : null;
	        }
	      }
	      return null;
	    },
	    subjectDefaultHours: function subjectDefaultHours() {
	      if (this.savedSubjectHours == null) return '';
	      return this.savedSubjectHours;
	    },
	    submitSubjectHours: function submitSubjectHours() {
	      var _this = this;
	
	      if (!this.isSubjectHoursChanged) return;
	      var hours = parseFloat(this.subjectHoursInput);
	      this.isSavingSubjectHours = true;
	      _docendo2.default.bulkUpdateSubjects(this.subject.school_id, [this.subject.id], { hours: hours }, function (data) {
	        var subjects = typeof data === 'string' ? JSON.parse(data) : data;
	        if (Array.isArray(subjects)) {
	          subjects.forEach(function (subj) {
	            subj.calendar_ids = subj.cals ? subj.cals.map(function (c) {
	              return c.id;
	            }) : subj.calendar_ids || [];
	            _this.$store.commit('updateSubject', subj);
	          });
	        }
	        _this.savedSubjectHours = hours;
	        _this.subjectHoursInput = String(hours);
	        _this.isSavingSubjectHours = false;
	        _this.$emit('subjectHoursSaved', hours);
	      }, function () {
	        _this.isSavingSubjectHours = false;
	      });
	    },
	    displayHours: function displayHours(row) {
	      if (row.hours != null) return row.hours;
	      var type = this.calendarType(row.calendar_id);
	      if (type === 'user') {
	        var ch = this.classSetHours();
	        if (ch != null) return ch;
	        return this.subjectDefaultHours();
	      }
	      if (type === 'klass') return this.subjectDefaultHours();
	      return this.subjectDefaultHours();
	    },
	    fallbackPlaceholder: function fallbackPlaceholder(row) {
	      var val = this.displayHours(row);
	      var source = this.displayHoursSource(row);
	      if (val === '' || val == null) return '';
	      return val + ' (' + source + ')';
	    },
	    onInput: function onInput(calendarId, value) {
	      var idx = this.localRows.findIndex(function (r) {
	        return r && r.calendar_id === calendarId;
	      });
	      if (idx < 0) return;
	
	      var val = value === '' ? null : String(value);
	      this.$set(this.localRows, idx, {
	        calendar_id: this.localRows[idx].calendar_id,
	        hours: val
	      });
	    },
	    desiredHoursToSave: function desiredHoursToSave(row) {
	      if (row.hours != null) return String(row.hours);
	      return null;
	    },
	    isChanged: function isChanged(row) {
	      var prev = this.originalByCalId[row.calendar_id] == null ? null : String(this.originalByCalId[row.calendar_id]);
	      var desired = this.desiredHoursToSave(row);
	      return desired !== prev;
	    },
	    submitRow: function submitRow(calendarId) {
	      var _this2 = this;
	
	      var idx = this.localRows.findIndex(function (r) {
	        return r && r.calendar_id === calendarId;
	      });
	      if (idx < 0) return;
	
	      var row = this.localRows[idx];
	      var desired = this.desiredHoursToSave(row);
	
	      if (desired == null && this.originalByCalId[calendarId] == null) return;
	
	      var id = this.subject.id;
	      var schoolId = this.subject.school_id;
	      var schoolYearId = this.subject.school_year_id;
	      var hours = desired;
	
	      this.$set(this.savingRows, calendarId, true);
	
	      _docendo2.default.setHoursForTeacherOnSubject(id, schoolId, schoolYearId, calendarId, hours, function (success) {
	        _this2.originalByCalId[calendarId] = hours;
	
	        var newVal = hours;
	        _this2.$set(_this2.localRows, idx, {
	          calendar_id: calendarId,
	          hours: newVal
	        });
	        _this2.$store.commit('updateTeacherHoursOnSubject', success);
	        _this2.$set(_this2.savingRows, calendarId, false);
	      }, function (failure) {
	        _this2.$set(_this2.savingRows, calendarId, false);
	      });
	    }
	  },
	  watch: {
	    subject: {
	      handler: function handler(val, oldVal) {
	        if (val && (!oldVal || val.id !== oldVal.id)) {
	          this.savedSubjectHours = val.hours;
	          this.subjectHoursInput = val.hours != null ? String(val.hours) : '';
	        }
	        var rows = val && val.subject_calendars ? val.subject_calendars : [];
	        this.localRows = rows.map(function (sc) {
	          return { calendar_id: sc.calendar_id, hours: sc.hours };
	        });
	        this.originalByCalId = rows.reduce(function (acc, sc) {
	          acc[sc.calendar_id] = sc.hours;
	          return acc;
	        }, {});
	        this.calsById = val && val.cals ? val.cals.reduce(function (acc, c) {
	          acc[c.id] = { name: c.name, calendar_type: c.calendar_type };
	          return acc;
	        }, {}) : {};
	      },
	
	      deep: true
	    }
	  }
	};

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    subjectsWithSameName: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      locale: 'da',
	      i18n: {
	        da: {
	          exists: 'findes allerede',
	          the_subject: 'Faget',
	          already_exists: 'findes allerede i klassen/klasserne, du er ved at tilføje på faget.',
	          do_you_want_to_delete: 'Vil du slette eksisterende fag',
	          create_new_anyway: 'Behold eksisterende',
	          delete: 'Slet eksisterende fag',
	          subject_cannot_be_deleted: 'Disse fag kan ikke slettes, da de er skemalagt'
	        },
	        en: {
	          exists: 'already exists',
	          delete_existing_subjects: 'Delete already existing course',
	          the_subject: 'The course',
	          already_exists: 'already exists in the grades/groups.',
	          do_you_want_to_delete: 'Would you like to delete the already existing course?',
	          create_new_anyway: 'Keep existing',
	          delete: 'Delete already existing course',
	          subject_cannot_be_deleted: 'These courses cannot be deleted, as they contain scheduled activities.'
	        },
	        nb: {
	          exists: 'er allerede opprettet',
	          delete_existing_subjects: 'Slett eksisterende fag',
	          the_subject: 'Faget',
	          already_exists: 'finnes allerede i klassen/klassene du ønsker å legge til.',
	          do_you_want_to_delete: 'Vil du slette allerede eksisterende fag',
	          create_new_anyway: 'Legg til fag til i klassen allikevel',
	          delete: 'Slett eksisterende fag',
	          subject_cannot_be_deleted: 'Disse fagene kan ikke slettes, ettersom de inngår i planlagte timer i timeplanene.'
	        }
	      }
	    };
	  },
	
	  computed: {
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    subjectsCanBeDeleted: function subjectsCanBeDeleted() {
	      return this.subjectsWithSameName.filter(function (subject) {
	        return subject.can_delete;
	      });
	    },
	    subjectsCanBeDeletedWithVProps: function subjectsCanBeDeletedWithVProps() {
	      var _this = this;
	
	      return this.subjectsCanBeDeleted.map(function (subject) {
	        subject.v_calendar_name = _this.allCalendarsInHash[subject.calendar_id] ? _this.allCalendarsInHash[subject.calendar_id].name : subject.calendar_id;
	        return subject;
	      });
	    },
	    subjectsCannotDelete: function subjectsCannotDelete() {
	      return this.subjectsWithSameName.filter(function (subject) {
	        return !subject.can_delete;
	      });
	    },
	    subjectsCannotDeleteWithVProps: function subjectsCannotDeleteWithVProps() {
	      var _this2 = this;
	
	      return this.subjectsCannotDelete.map(function (subject) {
	        subject.v_calendar_name = _this2.allCalendarsInHash[subject.calendar_id] ? _this2.allCalendarsInHash[subject.calendar_id].name : subject.calendar_id;
	        return subject;
	      });
	    },
	    firstInSubjectsWithSameName: function firstInSubjectsWithSameName() {
	      return this.subjectsWithSameName[0] ? this.subjectsWithSameName[0] : { name: '', color: '' };
	    }
	  },
	  methods: {
	    close: function close() {
	      this.$emit('close');
	    },
	    keepExistingSubjects: function keepExistingSubjects() {
	      this.$emit('keep');
	    },
	    deleteExistingSubjects: function deleteExistingSubjects() {
	      this.$emit('delete');
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.locale = window.language ? window.language : 'da';
	  }
	};

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Spinner = __webpack_require__(26);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Spinner: _Spinner2.default },
	  props: {
	    subject: {
	      type: Object
	    }
	  },
	  data: function data() {
	    return {
	      i18n: {
	        da: {
	          there_is_no_logged_activity: 'Der er ingen historik',
	          no_changes: 'Ingen ændringer foretaget',
	          created_subject: 'Oprettede faget',
	          from: 'fra',
	          to: 'til',
	          added: 'Tilføjede',
	          added_user: 'Tilføjede underviser',
	          added_room: 'Tilføjede lokalet',
	          removed: 'Fjernede',
	          removed_room: 'Fjernede lokalet',
	          removed_user: 'Fjernede underviseren',
	          changed: 'Ændrede',
	          changed_hours_in_school_year_from: 'Ændrede timer i skoleåret fra',
	          changed_subject_name_from: 'Ændrede fagets navn fra',
	          changed_subject_default_duration_from: 'Ændrede fagets normale varighed fra',
	          changed_subject_color: 'Ændrede fagets farve',
	          changed_subject_type_from: 'Ændrede fagets type fra',
	          subject: 'Fag',
	          supplemental: 'UUV',
	          frame: 'Temavisning',
	          break: 'break',
	          resource: 'Ressource',
	          optional: 'Valgfag/Hold',
	          ago: 'siden'
	        },
	        en: {
	          there_is_no_logged_activity: 'No history',
	          no_changes: 'No changes made',
	          created_subject: 'created the subject',
	          from: 'from',
	          to: 'to',
	          added: 'Added',
	          added_user: 'Added teacher',
	          added_room: 'Added room',
	          removed: 'Removed',
	          removed_room: 'Removed room',
	          removed_user: 'Removed the teacher',
	          changed: 'Changed',
	          changed_hours_in_school_year_from: 'Changed annual isntruction time from',
	          changed_subject_name_from: 'Changed the subject title from',
	          changed_subject_default_duration_from: 'Changed the subject standard duration from',
	          changed_subject_color: 'Changed the subject color',
	          changed_subject_type_from: 'Changed the subject category from',
	          subject: 'subject',
	          supplemental: 'UUV',
	          frame: 'Theme/focus',
	          break: 'break',
	          resource: 'Resource',
	          optional: 'Elective',
	          ago: 'ago'
	        },
	        nb: {
	          there_is_no_logged_activity: 'Ingen historikk',
	          no_changes: 'Ingen endringer er blitt gjort',
	          created_subject: 'Opprettet faget',
	          from: 'fra',
	          to: 'til',
	          added: 'La til',
	          added_user: 'La til underviser',
	          added_room: 'La til lokalet',
	          removed: 'Fjernet',
	          removed_room: 'Fjernet lokalet',
	          removed_user: 'Fjernet underviseren',
	          changed: 'Endret',
	          changed_hours_in_school_year_from: 'Endret timer i skoleåret fra',
	          changed_subject_name_from: 'Endret fagets navn fra',
	          changed_subject_default_duration_from: 'Endret fagets normale varighet fra',
	          changed_subject_color: 'Endret fagets farge',
	          changed_subject_type_from: 'Endret fagets type fra',
	          subject: 'Fag',
	          supplemental: 'UUV',
	          frame: 'Temavisning',
	          break: 'Pause',
	          resource: 'Ressurs',
	          optional: 'Valgfag',
	          ago: 'siden'
	        }
	      },
	      isLoading: true,
	      activities: null
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    usersHash: function usersHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    sortedActivities: function sortedActivities() {
	      var withoutNull = this.activities.filter(function (activity) {
	        return activity;
	      });
	      return withoutNull.sort(function (a, b) {
	        return new Date(b.at) - new Date(a.at);
	      });
	    },
	    packedActivities: function packedActivities() {
	      var sortedOnTimestamp = [];
	      for (var i = 0; i < this.sortedActivities.length; i++) {
	        var lastSortedTimestamp = sortedOnTimestamp[sortedOnTimestamp.length - 1];
	
	        var isWithinFiveMinutes = lastSortedTimestamp && (0, _moment2.default)(lastSortedTimestamp.at).format('YYYYMMDDh:mm') === (0, _moment2.default)(this.sortedActivities[i].at).format('YYYYMMDDh:mm');
	        if (isWithinFiveMinutes && lastSortedTimestamp.by && lastSortedTimestamp.by.id === this.sortedActivities[i].by.id) {
	          sortedOnTimestamp[sortedOnTimestamp.length - 1].changes.push(this.sortedActivities[i]);
	        } else {
	          this.$set(this.sortedActivities[i], 'changes', [this.sortedActivities[i]]);
	          sortedOnTimestamp.push(this.sortedActivities[i]);
	        }
	      }
	      return sortedOnTimestamp;
	    }
	  },
	  methods: {
	    humanizeChange: function humanizeChange(change) {
	      var text = '';
	      if (change.ta === 'subject_calendars') {
	        if (change.ac === 'I') {
	          text += '<p><span class="icon-calendar4"></span> ' + this.i18n[this.locale]['added'] + ' ' + change.refs.calendar.name + '</p>';
	        }
	        if (change.ac === 'D') {
	          text += '<p><span class="icon-calendar4"></span> ' + this.i18n[this.locale]['removed'] + ' ' + change.refs.calendar.name + '</p>';
	        }
	      } else if (change.ta === 'subjects' && !change.new) {
	        text += '<p>' + this.i18n[this.locale]['created_subject'] + '</p>';
	      } else if (change.ta === 'subjects' && change.new) {
	        for (var prop in change.new) {
	          if (prop === 'hours') {
	            text += '<p>' + this.i18n[this.locale].changed_hours_in_school_year_from + ' ' + change.old.hours + ' ' + this.i18n[this.locale].to + '  ' + change.new.hours + '</p>';
	          }
	          if (prop === 'default_duration') {
	            text += '<p>' + this.i18n[this.locale].changed_subject_default_duration_from + ' ' + change.old.default_duration + ' ' + this.i18n[this.locale].to + '  ' + change.new.default_duration + '</p>';
	          }
	          if (prop === 'name') {
	            text += '<p>' + this.i18n[this.locale].changed_subject_name_from + ' ' + change.old.name + ' ' + this.i18n[this.locale].to + '  ' + change.new.name + '</p>';
	          }
	          if (prop === 'color') {
	            text += '<p>' + this.i18n[this.locale].changed_subject_color + '</p>';
	          }
	          if (prop === 'subject_type') {
	            text += '<p>' + this.i18n[this.locale].changed_subject_type_from + ' ' + this.i18n[this.locale][change.old.subject_type] + ' ' + this.i18n[this.locale].to + ' ' + this.i18n[this.locale][change.new.subject_type] + '</p>';
	          }
	        }
	      }
	      return text;
	    },
	    formatDate: function formatDate(datetime) {
	      _moment2.default.locale(this.locale);
	      return (0, _moment2.default)(datetime).format('LLL');
	    },
	    getDuration: function getDuration(datetime) {
	      _moment2.default.locale(this.locale);
	      var diff = (0, _moment2.default)().diff((0, _moment2.default)(datetime));
	      return _moment2.default.duration(diff).humanize();
	    },
	    getSubjectLog: function getSubjectLog() {
	      var _this = this;
	
	      var schoolId = this.subject.school_id;
	      _docendo2.default.auditSubject(schoolId, this.subject.id, function (data) {
	        _this.activities = data.hasOwnProperty('data') ? [] : JSON.parse(data);
	        _this.isLoading = false;
	      }, function (failure) {
	        console.log('failed', failure);
	      });
	    },
	    getUserImg: function getUserImg(activity) {
	      var userId = activity.by.id;
	      return this.usersHash[userId].default_thumb_url;
	    },
	    getUserName: function getUserName(activity) {
	      return activity.by ? activity.by.name : '';
	    }
	  },
	  mounted: function mounted() {
	    this.getSubjectLog();
	  }
	};

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default },
	  props: {
	    subject: {
	      required: true,
	      type: Object,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      log: [],
	      isLoading: false
	    };
	  },
	
	  computed: {
	    sortedLog: function sortedLog() {
	      var _this = this;
	
	      return this.log.slice().sort(function (a, b) {
	        return (0, _moment2.default)(b.ts).valueOf() - (0, _moment2.default)(a.ts).valueOf();
	      }).map(function (item) {
	        return (0, _extends3.default)({}, item, {
	          v_formattedDate: _this.formatDate(item.ts),
	          v_humanizedDate: _this.getDuration(item.ts),
	          v_eventDate: _this.getEventDate(item)
	        });
	      });
	    }
	  },
	  methods: {
	    getEventDate: function getEventDate(item) {
	      var start = item.start_time ? (0, _moment2.default)(item.start_time).format('llll') : '';
	      var end = item.end_time ? (0, _moment2.default)(item.end_time).format('LT') : '';
	      return start + ' - ' + end;
	    },
	    formatDate: function formatDate(datetime) {
	      return datetime ? (0, _moment2.default)(datetime).format('LLL') : datetime;
	    },
	    getDuration: function getDuration(datetime) {
	      var diff = (0, _moment2.default)().diff((0, _moment2.default)(datetime));
	      return _moment2.default.duration(diff).humanize();
	    },
	    readDeletedEventsLog: function readDeletedEventsLog() {
	      var _this2 = this;
	
	      this.isLoading = true;
	      var schoolId = this.subject.school_id;
	      var subjectId = this.subject.id;
	      _docendo2.default.auditDeletedEventsBySubject(schoolId, subjectId, function (success) {
	        if (success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, success: false };
	          _this2.isLoading = false;
	          return;
	        }
	        _this2.log = success;
	        _this2.isLoading = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.sms.an_error_occured'), success: false };
	        _this2.isLoading = false;
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readDeletedEventsLog();
	    if (window.Intercom) {
	      window.Intercom('trackEvent', 'Docendo Feature: Log Of Deleted Events');
	    }
	  }
	};

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default },
	  props: {
	    subject: {
	      type: Object
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    isLoadingReductions: function isLoadingReductions() {
	      return this.$store.state.subjects.isLoadingReductions;
	    },
	    reductionsInSubjectIdHash: function reductionsInSubjectIdHash() {
	      return this.$store.getters.reductionsInSubjectIdHash;
	    },
	    subjectReductions: function subjectReductions() {
	      return (this.reductionsInSubjectIdHash[this.subject.id] || []).map(function (reduction) {
	        return (0, _extends3.default)({}, reduction, {
	          vFormattedHours: Number(reduction.hours).toFixed(2)
	        });
	      });
	    },
	    subjectReductionsSorted: function subjectReductionsSorted() {
	      var _this = this;
	
	      return this.subjectReductions.sort(function (a, b) {
	        return a.vActivityTitle.localeCompare(b.vActivityTitle, _this.locale);
	      });
	    },
	    totalReductionHours: function totalReductionHours() {
	      var total = this.subjectReductions.reduce(function (sum, reduction) {
	        return sum + Number(reduction.hours);
	      }, 0);
	
	      return total.toFixed(2);
	    }
	  },
	  mounted: function mounted() {
	    var schoolId = this.subject.school_id;
	    var schoolYearId = this.subject.school_year_id;
	    this.$store.dispatch('readReductions', { schoolId: schoolId, schoolYearId: schoolYearId });
	  }
	};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    scheduled_events: 'Skemalagte brikker for',
	    no_scheduled_events: 'Der er ingen skemalagte brikker',
	    date: 'Dato',
	    weekday: 'Ugedag',
	    time: 'Tid',
	    calendars: 'Kalendere',
	    events_total: 'skemalagte brikker i alt'
	  },
	  en: {
	    scheduled_events: 'Scheduled lessons for',
	    no_scheduled_events: 'There are no scheduled lessons',
	    date: 'Date',
	    weekday: 'Weekday',
	    time: 'Time',
	    calendars: 'Calendars',
	    events_total: 'scheduled lessons in total'
	  },
	  nb: {
	    scheduled_events: 'Timeplanlagte brikker for',
	    no_scheduled_events: 'Det er ingen timeplanlagte brikker',
	    date: 'Dato',
	    weekday: 'Ukedag',
	    time: 'Tid',
	    calendars: 'Kalendere',
	    events_total: 'timeplanlagte brikker totalt'
	  }
	};
	
	exports.default = {
	  components: { Loader: _Loader2.default },
	  props: {
	    subject: {
	      required: true,
	      type: Object,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      i18n: I18N,
	      events: [],
	      isLoading: false
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    sortedEvents: function sortedEvents() {
	      var _this = this;
	
	      return this.events.slice().sort(function (a, b) {
	        return (0, _moment2.default)(a.start).valueOf() - (0, _moment2.default)(b.start).valueOf();
	      }).map(function (event) {
	        return (0, _extends3.default)({}, event, {
	          v_date: _this.formatDate(event.start),
	          v_weekday: _this.formatWeekday(event.start),
	          v_time: _this.formatTime(event.start, event.end),
	          v_calendars: _this.formatCalendars(event.calendars)
	        });
	      });
	    }
	  },
	  methods: {
	    formatDate: function formatDate(datetime) {
	      if (!datetime) return '';
	      _moment2.default.locale(this.locale);
	      return (0, _moment2.default)(datetime).format('L');
	    },
	    formatWeekday: function formatWeekday(datetime) {
	      if (!datetime) return '';
	      _moment2.default.locale(this.locale);
	      return (0, _moment2.default)(datetime).format('dddd');
	    },
	    formatTime: function formatTime(start, end) {
	      _moment2.default.locale(this.locale);
	      var from = start ? (0, _moment2.default)(start).format('LT') : '';
	      var to = end ? (0, _moment2.default)(end).format('LT') : '';
	      return to ? from + ' - ' + to : from;
	    },
	    formatCalendars: function formatCalendars(calendars) {
	      if (!Array.isArray(calendars)) return '';
	      var names = calendars.map(function (calendar) {
	        return calendar && calendar.name;
	      }).filter(function (name) {
	        return name;
	      });
	      return names.filter(function (name, index) {
	        return names.indexOf(name) === index;
	      }).join(', ');
	    },
	    parseEvents: function parseEvents(success) {
	      if (Array.isArray(success)) return success;
	      if (typeof success === 'string' && success.length > 0) {
	        try {
	          var parsed = JSON.parse(success);
	          return Array.isArray(parsed) ? parsed : [];
	        } catch (e) {
	          return [];
	        }
	      }
	      return [];
	    },
	    readScheduledEvents: function readScheduledEvents() {
	      var _this2 = this;
	
	      this.isLoading = true;
	      _docendo2.default.eventsBySubjects([this.subject.id], null, null, function (success) {
	        _this2.events = _this2.parseEvents(success);
	        _this2.isLoading = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.sms.an_error_occured'), success: false };
	        _this2.isLoading = false;
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readScheduledEvents();
	  }
	};

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _core = __webpack_require__(25);
	
	var _subjectTypes = __webpack_require__(157);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    calendarType: {
	      default: 'klass'
	    },
	    subjectType: {
	      default: ''
	    },
	    isInTasks: {
	      type: Boolean,
	      default: false
	    },
	    showActivities: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      calSubjectTypes: [],
	      allTypes: _subjectTypes.allTypes,
	      kindergartenTypes: _subjectTypes.kindergartenTypes,
	      selectedtype: null,
	      isTooltip: false,
	      isTooltipPopperDone: false,
	      activeSubjectTypeDesc: ''
	    };
	  },
	
	  computed: {
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    schoolId: function schoolId() {
	      return window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id : this.$route.params.school_id ? this.$route.params.school_id : this.school.id;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    isKindergarten: function isKindergarten() {
	      return this.$store.getters.isKindergarten;
	    },
	    isReductionsActive: function isReductionsActive() {
	      return this.$store.getters.isReductionsActive;
	    },
	    localPoolTitle: function localPoolTitle() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || this.$t('vue2.task_overview.pool');
	    },
	    activeSubjectTypes: function activeSubjectTypes() {
	      var _this = this;
	
	      var arr = [];
	      var dbSubjectTypes = !this.isInTasks ? this.calSubjectTypes : this.calSubjectTypes.filter(function (type) {
	        return !(type === 'other_stuff' || type === 'other_tasks');
	      });
	      var allTypes = this.isKindergarten ? this.kindergartenTypes : this.allTypes;
	      dbSubjectTypes.forEach(function (activeType) {
	        if (allTypes[activeType] && allTypes[activeType].filter(function (subjectType) {
	          return subjectType.lang === _this.locale;
	        })[0]) {
	          arr.push(allTypes[activeType].filter(function (subjectType) {
	            return subjectType.lang === _this.locale;
	          })[0]);
	        }
	      });
	      if (this.localPoolTitle) {
	        arr = arr.map(function (subjectType) {
	          if (subjectType.value === 'pool') {
	            return (0, _extends3.default)({}, subjectType, { name: _this.localPoolTitle });
	          }
	          return subjectType;
	        });
	      }
	      if (!this.isSchoolFeatureLocalePool) {
	        arr = arr.filter(function (subjectType) {
	          return subjectType.value !== 'pool';
	        });
	      }
	      if (this.calendarType === 'room') {
	        arr = arr.filter(function (subjectType) {
	          return subjectType.value !== 'subject';
	        });
	      }
	      if (this.calendarType === 'klass') {
	        var idx = arr.findIndex(function (subjectType) {
	          return subjectType.value === 'additional_tasks' && subjectType.lang === 'da';
	        });
	        if (idx > -1) {
	          arr[idx]['name'] = 'Tilsyn / Øvrige opgaver';
	        }
	      }
	      return arr.filter(function (item) {
	        if (item.value === 'activity' && !_this.showActivities && _this.subjectType !== 'activity') return false;
	        return true;
	      }).sort(function (a, b) {
	        return a.order > b.order ? 1 : -1;
	      });
	    },
	    isSchoolFeatureLocalePool: function isSchoolFeatureLocalePool() {
	      return this.$store.getters.isSchoolFeatureLocalePool;
	    }
	  },
	  watch: {
	    calendarType: function calendarType() {
	      this.readSubjectTypes(this.calendarType);
	    },
	    selectedtype: function selectedtype(val) {
	      this.$emit('change', val);
	    },
	    activeSubjectTypes: function activeSubjectTypes() {
	      var _this2 = this;
	
	      var idx = this.activeSubjectTypes.findIndex(function (subjectType) {
	        return subjectType.value === _this2.subjectType;
	      });
	      if (idx > 0 && this.subjectType) {
	        this.selectedtype = this.subjectType;
	      } else {
	        this.selectedtype = this.activeSubjectTypes[0].value;
	      }
	    }
	  },
	  methods: {
	    createPopper: function createPopper(evt) {
	      var childPopper = this.$refs.child_popper;
	      document.getElementById('djs-content-container').appendChild(childPopper);
	      (0, _core.createPopper)(evt.target, childPopper, {
	        placement: 'right',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: function offset(_ref) {
	              var placement = _ref.placement,
	                  reference = _ref.reference,
	                  popper = _ref.popper;
	
	              return [0, 5];
	            }
	          }
	        }]
	      });
	    },
	    showTooltip: function showTooltip(desc, evt) {
	      var _this3 = this;
	
	      this.activeSubjectTypeDesc = desc;
	      this.isTooltip = true;
	      this.$nextTick(function (_) {
	        _this3.createPopper(evt);
	        _this3.isTooltipPopperDone = true;
	      });
	    },
	    hideTooltip: function hideTooltip() {
	      this.activeSubjectTypeDesc = '';
	      this.isTooltip = false;
	      this.isTooltipPopperDone = false;
	    },
	    readSubjectTypes: function readSubjectTypes(calType) {
	      var _this4 = this;
	
	      var schoolCountry = this.school.country;
	      _docendo2.default.subjectsForCalendarType(calType, schoolCountry, function (success) {
	        _this4.calSubjectTypes = success;
	      }, function (failure) {
	        console.log('failed');
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.activeSubjectTypes && this.activeSubjectTypes[0]) {
	      this.subjectType ? this.selectedtype = this.subjectType : this.selectedtype = this.activeSubjectTypes[0].value;
	    }
	  },
	  mounted: function mounted() {
	    this.readSubjectTypes(this.calendarType);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var childPopper = this.$refs.child_popper;
	    if (childPopper) {
	      childPopper.remove();
	    }
	  }
	};

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _subjectPools = __webpack_require__(111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    title: 'Opdatér puljer?',
	    intro: 'Faget har puljer, der ikke følger brikken. Vil du opdatere dem alle til %{hours} klokketimer?',
	    calendar: 'Kalender',
	    current: 'Nuværende',
	    new: 'Ny',
	    only_subject: 'Kun brikken',
	    update_all: 'Opdatér alle puljer'
	  },
	  nb: {
	    title: 'Oppdatere puljer?',
	    intro: 'Faget har puljer som ikke følger brikken. Vil du oppdatere dem alle til %{hours} timer?',
	    calendar: 'Kalender',
	    current: 'Nåværende',
	    new: 'Ny',
	    only_subject: 'Kun faget',
	    update_all: 'Oppdater alle puljer'
	  },
	  en: {
	    title: 'Update pools?',
	    intro: 'The subject has pools that do not follow the subject. Do you want to update them all to %{hours} hours?',
	    calendar: 'Calendar',
	    current: 'Current',
	    new: 'New',
	    only_subject: 'Subject only',
	    update_all: 'Update all pools'
	  }
	};
	
	exports.default = {
	  components: { ModalConfirmation: _ModalConfirmation2.default },
	  props: {
	    subject: {
	      type: Object,
	      required: true
	    },
	    newHours: {
	      default: null
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale] || I18N.da;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash || {};
	    },
	    formattedNewHours: function formattedNewHours() {
	      return this.newHours === null || this.newHours === undefined ? '' : this.newHours;
	    },
	    introText: function introText() {
	      return this.i18n.intro.replace('%{hours}', this.formattedNewHours);
	    },
	    poolRows: function poolRows() {
	      var _this = this;
	
	      return (0, _subjectPools.getDifferentiatedPools)(this.subject, this.newHours).map(function (pool) {
	        return {
	          calendarId: pool.calendarId,
	          hours: pool.hours,
	          name: _this.calendarName(pool.calendarId)
	        };
	      });
	    }
	  },
	  methods: {
	    calendarName: function calendarName(calendarId) {
	      var cals = this.subject && this.subject.cals;
	      if (Array.isArray(cals)) {
	        for (var i = 0; i < cals.length; i++) {
	          if (cals[i] && cals[i].id === calendarId) {
	            return cals[i].name;
	          }
	        }
	      }
	      var fromStore = this.allCalendarsInHash[calendarId];
	      if (fromStore && fromStore.name) {
	        return fromStore.name;
	      }
	      return '' + calendarId;
	    },
	    onUpdateAll: function onUpdateAll() {
	      this.$emit('updateAll', this.poolRows.map(function (row) {
	        return row.calendarId;
	      }));
	    }
	  }
	};

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(28);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _slicedToArray2 = __webpack_require__(35);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _create = __webpack_require__(161);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _SubjectForm = __webpack_require__(70);
	
	var _SubjectForm2 = _interopRequireDefault(_SubjectForm);
	
	var _BulkCreateSubjectsSubject = __webpack_require__(1620);
	
	var _BulkCreateSubjectsSubject2 = _interopRequireDefault(_BulkCreateSubjectsSubject);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _Banner = __webpack_require__(409);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _Modal = __webpack_require__(69);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ColorPicker = __webpack_require__(68);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	var _DSelectCalsIds = __webpack_require__(40);
	
	var _DSelectCalsIds2 = _interopRequireDefault(_DSelectCalsIds);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    headline: 'Fagoprettelse',
	    create_subject: 'Opret fag',
	    create_classes_first: 'Opret klasser i sidemenuen først',
	    import_subjects: 'Importer fag',
	    subjects: 'Fag',
	    grades: 'Klasser',
	    no_subjects: 'Ingen fag',
	    create: 'Opret',
	    in: 'i',
	    change_title: 'Skift titel',
	    change_hours: 'Opdater klokketimer i skoleåret',
	    change_subject_type: 'Skift briktype',
	    change_preparation: 'Sæt forberedelsesfaktor',
	    change_color: 'Skift farve',
	    change_room: 'Tilføj lokale',
	    cancel: 'Annullér',
	    update: 'Opdatér',
	    add_room_to_klass: 'Tilføj lokale',
	    select_subjects: 'Vælg fag',
	    edit: 'Stamlokale',
	    tooltip_teachers: 'Undervisere',
	    tooltip_rooms: 'Lokaler',
	    tooltip_klasses: 'Klasser'
	  },
	  en: {
	    headline: 'Create course',
	    create_subject: 'Create course',
	    create_classes_first: 'Start by creating grades/groups',
	    import_subjects: 'Import courses',
	    subjects: 'Courses',
	    grades: 'Grades/groups',
	    no_subjects: 'No courses',
	    create: 'Create',
	    in: 'in',
	    change_title: 'Change title',
	    change_hours: 'Update clock hours for the school year',
	    change_subject_type: 'Change tile type',
	    change_preparation: 'Set preparation factor',
	    change_color: 'Change color',
	    change_room: 'Add room',
	    cancel: 'Cancel',
	    update: 'Update',
	    add_room_to_klass: 'Add room',
	    select_subjects: 'Select subjects',
	    edit: 'Room',
	    tooltip_teachers: 'Teachers',
	    tooltip_rooms: 'Rooms',
	    tooltip_klasses: 'Grades/groups'
	  },
	  nb: {
	    headline: 'Fag- og timefordeling',
	    create_subject: 'Opprett fag',
	    create_classes_first: 'Opprett klasser i sidemenyen',
	    import_subjects: 'Importer fag',
	    grades: 'Klasser',
	    no_subjects: 'Ingen fag',
	    create: 'Opprett',
	    in: 'i',
	    change_title: 'Endre tittel',
	    change_hours: 'Oppdater klokketimer i skoleåret',
	    change_subject_type: 'Endre brikketype',
	    change_preparation: 'Sett forberedelsesfaktor',
	    change_color: 'Endre farge',
	    change_room: 'Legg til lokale',
	    cancel: 'Angre',
	    update: 'Oppdater',
	    add_room_to_klass: 'Legg til lokale',
	    select_subjects: 'Velg fag',
	    edit: 'Lokale',
	    tooltip_teachers: 'Lærere',
	    tooltip_rooms: 'Lokaler',
	    tooltip_klasses: 'Klasser'
	  }
	};
	
	exports.default = {
	  components: { DoFiltersFilter: _DoFiltersFilter2.default, Loader: _Loader2.default, AddSubject: _BulkCreateSubjectsSubject2.default, SubjectForm: _SubjectForm2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, Banner: _Banner2.default, modal: _Modal2.default, ColorPicker: _ColorPicker2.default, DSelectCalendarIds: _DSelectCalsIds2.default, AppToggle: _AppToggle2.default },
	  props: {
	    isActivities: {
	      default: false
	    },
	    propIsSubjectModal: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      tableWidth: '100%',
	      editSubject: null,
	      isSubjectModal: false,
	      isTheCreateCalenderSubjectActive: null,
	      isSubjectImportModal: false,
	      createInCalendarId: null,
	      _tableWidthRaf: null,
	      isBulkColorModalOpen: false,
	      bulkColorRow: null,
	      bulkColor: '',
	      bulkColorLoading: false,
	      bulkColorEnabled: false,
	      bulkName: '',
	      bulkNameEnabled: false,
	      bulkHours: null,
	      bulkHoursEnabled: false,
	      bulkSubjectType: '',
	      bulkSubjectTypeEnabled: false,
	      bulkCalSubjectTypes: [],
	      bulkPreparation: null,
	      bulkPreparationEnabled: false,
	      bulkRoom: [],
	      bulkRoomSelected: [],
	      bulkRoomEnabled: false,
	      isKlassRoomModalOpen: false,
	      klassRoomCalId: null,
	      klassRoomName: '',
	      klassRoomSelected: [],
	      klassRoomLoading: false,
	      klassRoomExcluded: {},
	      selectedKlassFilters: [],
	      lastCreatedHoursBySubjectId: {}
	    };
	  },
	
	  computed: {
	    schoolIsFromDK: function schoolIsFromDK() {
	      return this.$store.getters.schoolCountry.toLowerCase() === 'dk';
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    noActiveSchoolYears: function noActiveSchoolYears() {
	      return this.$store.state.noActiveSchoolYears;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.subjects.isLoading;
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    subjectTypes: function subjectTypes() {
	      return this.$store.state.subjects.subjectTypes[this.locale];
	    },
	    bulkSubjectTypeOptions: function bulkSubjectTypeOptions() {
	      var _this = this;
	
	      var types = this.subjectTypes || [];
	      var allowed = this.bulkCalSubjectTypes;
	      var filtered = allowed && allowed.length > 0 ? types.filter(function (t) {
	        return allowed.indexOf(t.value) > -1;
	      }) : types;
	      var current = this.bulkColorRow && this.bulkColorRow.rawSubject ? this.bulkColorRow.rawSubject.subject_type : null;
	      if (current && !filtered.find(function (t) {
	        return t.value === current;
	      })) {
	        var fallback = types.find(function (t) {
	          return t.value === current;
	        });
	        if (fallback) {
	          filtered = filtered.concat([fallback]);
	        }
	      }
	      return filtered.slice().sort(function (a, b) {
	        return a.name.localeCompare(b.name, _this.locale);
	      });
	    },
	    subjectTypeFilters: function subjectTypeFilters() {
	      var excluded = ['activity', 'other_tasks', 'other_stuff', 'club'];
	
	      return this.subjectTypes.filter(function (type) {
	        return !excluded.includes(type.value);
	      }).map(function (type) {
	        return type.name;
	      });
	    },
	    selectedSubjectTypeFilters: function selectedSubjectTypeFilters() {
	      return this.$store.state.subjects.selectedSubjectTypeFilters;
	    },
	    subjectsInKlasses: function subjectsInKlasses() {
	      return this.$store.getters.uniqueSubjects ? this.$store.getters.uniqueSubjects : [];
	    },
	    subjectsInKlassHash: function subjectsInKlassHash() {
	      return this.$store.getters.subjectsInKlassHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    klassCalendarsSorted: function klassCalendarsSorted() {
	      return this.$store.getters.klassCalendars;
	    },
	    klassCalendarInHash: function klassCalendarInHash() {
	      return this.$store.getters.allKlassCalendarsInHash;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    klassIds: function klassIds() {
	      return this.$store.getters.klassCalIdsHashSortedOnName || [];
	    },
	    klassTags: function klassTags() {
	      return (this.klassCalendarsSorted || []).map(function (calendar) {
	        return calendar.name;
	      });
	    },
	    klassFilterStorageKey: function klassFilterStorageKey() {
	      return this.isActivities ? 'doBulkCreateActivitiesKlassFilters' : 'doBulkCreateSubjectsKlassFilters';
	    },
	    filteredKlassIds: function filteredKlassIds() {
	      var _this2 = this;
	
	      if (!this.selectedKlassFilters || this.selectedKlassFilters.length === 0) {
	        return this.klassIds;
	      }
	      var hash = this.klassCalendarInHash || {};
	      return this.klassIds.filter(function (calId) {
	        var cal = hash[calId];
	        return cal && _this2.selectedKlassFilters.indexOf(cal.name) > -1;
	      });
	    },
	    klassesWithoutSubjects: function klassesWithoutSubjects() {
	      var _this3 = this;
	
	      return this.klassCalendarsSorted.filter(function (klass) {
	        return !_this3.subjectsInKlassHash[klass.id];
	      });
	    },
	    translations: function translations() {
	      var loc = this.locale || 'en';
	      return this.i18n && this.i18n[loc] ? this.i18n[loc] : {};
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    klassHeaderColumns: function klassHeaderColumns() {
	      var _this4 = this;
	
	      var ids = this.filteredKlassIds;
	      var totalHoursByCalId = this.totalHoursByCalIdFromRowCells;
	
	      return ids.map(function (calId) {
	        var base = _this4.klassCalendarInHash && _this4.klassCalendarInHash[calId] ? _this4.klassCalendarInHash[calId] : { id: calId };
	
	        return (0, _extends3.default)({}, base, {
	          vName: _this4.getCalendarName(calId),
	          vTotalHours: totalHoursByCalId[calId] || '0'
	        });
	      });
	    },
	    totalHoursByCalIdFromRowCells: function totalHoursByCalIdFromRowCells() {
	      var _this5 = this;
	
	      var ids = this.filteredKlassIds;
	      var rows = this.subjectsTable || [];
	
	      var totals = {};
	
	      ids.forEach(function (calId) {
	        totals[calId] = 0;
	      });
	
	      rows.forEach(function (row) {
	        var cells = row.cells || [];
	        cells.forEach(function (cell) {
	          if (!cell || !cell.hasSubject) {
	            return;
	          }
	          var hours = cell.vHours * 1;
	          if (!hours) {
	            return;
	          }
	          var key = cell.calId;
	          if (totals[key] === undefined) {
	            totals[key] = 0;
	          }
	          totals[key] += hours;
	        });
	      });
	
	      var out = {};
	      ids.forEach(function (calId) {
	        out[calId] = _this5.formatHours(totals[calId] || 0);
	      });
	
	      return out;
	    },
	    totalHoursByCalId: function totalHoursByCalId() {
	      var _this6 = this;
	
	      var ids = this.klassIds;
	      var subjectsInKlassHash = this.subjectsInKlassHash || {};
	      var subjectsInHash = this.subjectsInHash || {};
	
	      var hoursMap = {};
	
	      ids.forEach(function (calId) {
	        var subjectIds = subjectsInKlassHash[calId] || [];
	        var total = 0;
	        subjectIds.forEach(function (subjectId) {
	          var subject = subjectsInHash[subjectId];
	          if (!subject) {
	            return;
	          }
	          total += _this6.getKlassHours(subject, calId) * 1;
	        });
	
	        hoursMap[calId] = total;
	      });
	
	      return hoursMap;
	    },
	    subjectsTable: function subjectsTable() {
	      var _this7 = this;
	
	      var klassIds = this.filteredKlassIds;
	      var translations = this.translations;
	      var createText = translations['create'] || 'Create';
	      var inText = translations['in'] || 'in';
	
	      var allCalendarsInHash = this.allCalendarsInHash || {};
	      var klassCalendarInHash = this.klassCalendarInHash || {};
	
	      var memo = {
	        byKey: (0, _create2.default)(null)
	      };
	
	      var getCalIdsKey = function getCalIdsKey(calIds) {
	        if (!calIds || calIds.length < 1 || !calIds[0]) {
	          return '';
	        }
	        return calIds.join(',');
	      };
	
	      var computeFlags = function computeFlags(subjectKlass, calIds) {
	        var key = getCalIdsKey(calIds);
	        if (!key) {
	          return {
	            v_subjectHasTeachers: false,
	            v_subjectHasRooms: false,
	            v_subjectOtherKlasses: '',
	            v_userNames: '',
	            v_tooltip: ''
	          };
	        }
	
	        if (memo.byKey[key]) {
	          return memo.byKey[key];
	        }
	
	        var hasTeachers = false;
	        var hasRooms = false;
	        var otherKlasses = [];
	        var userNames = [];
	        var roomNames = [];
	
	        calIds.forEach(function (id) {
	          var cal = allCalendarsInHash[id];
	          if (!cal) {
	            return;
	          }
	          if (cal.type === 'user') {
	            hasTeachers = true;
	            if (cal.name) {
	              userNames.push(cal.name);
	            }
	          }
	          if (cal.type === 'room') {
	            hasRooms = true;
	            if (cal.name) {
	              roomNames.push(cal.name);
	            }
	          }
	          if (cal.type === 'klass' && id !== subjectKlass.calendar_id) {
	            if (cal.name) {
	              otherKlasses.push(cal.name);
	            } else {
	              otherKlasses.push('');
	            }
	          }
	        });
	
	        var tooltipLines = [[translations['tooltip_teachers'], userNames], [translations['tooltip_rooms'], roomNames], [translations['tooltip_klasses'], otherKlasses.filter(Boolean)]].filter(function (line) {
	          return line[1].length > 0;
	        }).map(function (_ref) {
	          var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	              label = _ref2[0],
	              names = _ref2[1];
	
	          return '<b>' + label + ':</b> ' + names.map(_this7.escapeHtml).join(', ');
	        });
	
	        var res = {
	          v_subjectHasTeachers: hasTeachers,
	          v_subjectHasRooms: hasRooms,
	          v_subjectOtherKlasses: otherKlasses,
	          v_userNames: userNames,
	          v_tooltip: tooltipLines.join('<br>')
	        };
	
	        memo.byKey[key] = res;
	        return res;
	      };
	
	      return this.subjectsInKlasses.map(function (subject) {
	        var klasses = subject.klasses || {};
	
	        var cells = klassIds.map(function (calId) {
	          var klass = klasses[calId] ? klasses[calId] : { calendar_id: parseInt(calId) };
	          var hasSubject = !!(klasses[calId] && klasses[calId].hours > -1);
	
	          if (hasSubject) {
	            var calIds = klass.calendar_ids;
	            var flags = computeFlags(klass, calIds);
	
	            return {
	              calId: calId,
	              klass: klass,
	              hasSubject: true,
	              vHours: _this7.getKlassHours(subject, calId),
	              v_subjectHasTeachers: flags.v_subjectHasTeachers,
	              v_subjectHasRooms: flags.v_subjectHasRooms,
	              v_subjectOtherKlasses: flags.v_subjectOtherKlasses,
	              v_userNames: flags.v_userNames,
	              v_tooltip: flags.v_tooltip
	            };
	          }
	
	          var subjectName = subject && subject.name ? subject.name : '';
	          var calName = klassCalendarInHash[calId] && klassCalendarInHash[calId].name ? klassCalendarInHash[calId].name : 'id: ' + calId;
	
	          return {
	            calId: calId,
	            klass: klass,
	            hasSubject: false,
	            createTooltip: createText + ' ' + subjectName + ' ' + inText + ' ' + calName
	          };
	        });
	
	        var resolvedColor = subject.color;
	        for (var calId in klasses) {
	          if (klasses[calId] && klasses[calId].color) {
	            resolvedColor = klasses[calId].color;
	            break;
	          }
	        }
	
	        var resolvedSubject = resolvedColor !== subject.color ? (0, _assign2.default)({}, subject, { color: resolvedColor }) : subject;
	
	        return {
	          id: subject.id,
	          name: subject.name,
	          rawSubject: resolvedSubject,
	          cells: cells
	        };
	      });
	    },
	    visibleSubjectsTable: function visibleSubjectsTable() {
	      var _this8 = this;
	
	      return (this.subjectsTable || []).filter(function (row) {
	        var t = row.rawSubject && row.rawSubject.subject_type;
	        if (_this8.isActivities) {
	          return t === 'activity';
	        }
	        return !row.rawSubject || t !== 'activity';
	      });
	    },
	    klassRoomSubjects: function klassRoomSubjects() {
	      var _this9 = this;
	
	      if (!this.klassRoomCalId) return [];
	      return (this.subjectsTable || []).map(function (row) {
	        var cell = row.cells.find(function (c) {
	          return c.calId === _this9.klassRoomCalId;
	        });
	        if (!cell || !cell.hasSubject) return null;
	        return { id: cell.klass.id, name: row.name, cell: cell };
	      }).filter(Boolean);
	    }
	  },
	
	  watch: {
	    activeSchoolYear: function activeSchoolYear() {
	      this.$store.dispatch('readSubjects', this.activeSchoolYear.id);
	    },
	    propIsSubjectModal: function propIsSubjectModal(bool) {
	      this.isSubjectModal = bool;
	    },
	    klassIds: function klassIds() {
	      this.scheduleSetTableWidth();
	    },
	    subjectsInKlasses: function subjectsInKlasses() {
	      this.scheduleSetTableWidth();
	    },
	    selectedKlassFilters: function selectedKlassFilters() {
	      this.scheduleSetTableWidth();
	    }
	  },
	
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        el.focus();
	      }
	    }
	  },
	
	  methods: {
	    escapeHtml: function escapeHtml(str) {
	      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	    },
	    formatHours: function formatHours(value) {
	      var num = value * 1;
	      if (Math.floor(num) === num) {
	        return '' + num;
	      }
	      return num.toFixed(2).replace(/\.?0+$/, '');
	    },
	    onNewSubjectsCreated: function onNewSubjectsCreated() {
	      this.readSubject();
	    },
	    scheduleSetTableWidth: function scheduleSetTableWidth() {
	      var _this10 = this;
	
	      if (this._tableWidthRaf) {
	        window.cancelAnimationFrame(this._tableWidthRaf);
	      }
	      this._tableWidthRaf = window.requestAnimationFrame(function () {
	        _this10._tableWidthRaf = null;
	        _this10.setTableWidth();
	      });
	    },
	    getKlassHours: function getKlassHours(subject, calId) {
	      if (!subject.klasses || !subject.klasses[calId]) {
	        return subject.hours || 0;
	      }
	
	      var klassSubject = subject.klasses[calId];
	      var calendars = klassSubject.subject_calendars || [];
	      var targetId = parseInt(calId);
	
	      for (var i = 0; i < calendars.length; i++) {
	        var sc = calendars[i];
	        if (sc && sc.calendar_id === targetId) {
	          if (sc.hours) {
	            return sc.hours;
	          }
	          break;
	        }
	      }
	
	      return klassSubject.hours || 0;
	    },
	    getCalendarName: function getCalendarName(calId) {
	      return this.klassCalendarInHash && this.klassCalendarInHash[calId] ? this.klassCalendarInHash[calId].name : 'id: ' + calId;
	    },
	    setCreateInCalendarId: function setCreateInCalendarId(calId) {
	      this.createInCalendarId = calId;
	      if (calId) {
	        this.isSubjectModal = true;
	      } else {
	        this.isSubjectModal = false;
	      }
	    },
	    toggleSelectedSubjectTypeFilters: function toggleSelectedSubjectTypeFilters(filter) {
	      this.$store.commit('TOGGLE_SUBJECT_TYPE_FILTER', filter);
	    },
	    clearSelectedSubjectTypeFilters: function clearSelectedSubjectTypeFilters() {
	      this.$store.commit('CLEAR_SUBJECT_TYPE_FILTERS');
	    },
	    toggleKlassTag: function toggleKlassTag(tag) {
	      var next = this.selectedKlassFilters.slice();
	      var idx = next.indexOf(tag);
	      if (idx > -1) {
	        next.splice(idx, 1);
	      } else {
	        next.push(tag);
	      }
	      this.selectedKlassFilters = next;
	      this.$helpers.setLocalStorage(this.klassFilterStorageKey, (0, _stringify2.default)(next));
	    },
	    clearSelectedKlassFilters: function clearSelectedKlassFilters() {
	      this.selectedKlassFilters = [];
	      this.$helpers.setLocalStorage(this.klassFilterStorageKey, (0, _stringify2.default)([]));
	    },
	    loadSelectedKlassFiltersFromLocalStorage: function loadSelectedKlassFiltersFromLocalStorage() {
	      var stored = this.$helpers.getLocalStorage(this.klassFilterStorageKey);
	      if (!stored) {
	        return;
	      }
	      var parsed = [];
	      try {
	        parsed = JSON.parse(stored);
	      } catch (e) {
	        parsed = [];
	      }
	      if (!Array.isArray(parsed)) {
	        return;
	      }
	      this.selectedKlassFilters = parsed;
	    },
	    setImportSubjects: function setImportSubjects() {
	      _eventbus2.default.theKlassesToImportSubjectTo = [].concat((0, _toConsumableArray3.default)(this.klassesWithoutSubjects));
	      _eventbus2.default.createKlassModal = true;
	    },
	    setIsCreateSubject: function setIsCreateSubject(subject, calendarSubject) {
	      var _this11 = this;
	
	      setTimeout(function (_) {
	        _this11.isTheCreateCalenderSubjectActive = subject.id + '_' + calendarSubject.calendar_id;
	      }, 0);
	    },
	    isCreateSubject: function isCreateSubject(subject, calendarSubject) {
	      return this.isTheCreateCalenderSubjectActive === subject.id + '_' + calendarSubject.calendar_id;
	    },
	    closeIsCreateSubject: function closeIsCreateSubject() {
	      this.isTheCreateCalenderSubjectActive = null;
	    },
	    closeModal: function closeModal() {
	      this.editSubject = null;
	      this.isSubjectModal = false;
	      this.createInCalendarId = null;
	      this.$emit('closeSubjectModal');
	    },
	    setEditSubject: function setEditSubject(editSubject) {
	      var _this12 = this;
	
	      this.editSubject = (0, _assign2.default)({}, editSubject);
	      this.isSubjectModal = true;
	      setTimeout(function (_) {
	        _this12.isTheCreateCalenderSubjectActive = null;
	      }, 1);
	    },
	    createNewSubject: function createNewSubject(newSubject) {
	      newSubject['schoolYearId'] = this.activeSchoolYear.id;
	      this.$store.dispatch('createSubject', newSubject);
	      this.closeModal();
	    },
	    createExistingSubjectInCal: function createExistingSubjectInCal(brik) {
	      var numericHours = brik.hours * 1;
	      if (brik.subject && brik.subject.id != null && !isNaN(numericHours) && numericHours > 0) {
	        this.$set(this.lastCreatedHoursBySubjectId, brik.subject.id, numericHours);
	      }
	      var newSubject = {
	        calendarId: brik.calendar.calendar_id,
	        name: brik.subject.name,
	        color: brik.subject.color,
	        defaultDuration: brik.subject.default_duration,
	        preparation: brik.subject.preparation != null && brik.subject.preparation !== '' ? brik.subject.preparation : null,
	        hours: brik.hours,
	        subjectType: brik.subject.subject_type,
	        calendarIds: [],
	        subjectCode: brik.subject.subject_code
	      };
	      newSubject['schoolYearId'] = this.activeSchoolYear.id;
	      this.$store.dispatch('createSubject', newSubject);
	    },
	    updateSubject: function updateSubject(updatedSubject) {
	      updatedSubject['schoolId'] = updatedSubject.schoolId ? updatedSubject.schoolId : window.SCHOOL.id;
	      updatedSubject['schoolYearId'] = updatedSubject.schoolYearId ? updatedSubject.schoolYearId : this.activeSchoolYear.id;
	      this.$store.dispatch('updateSubject', updatedSubject);
	      this.closeModal();
	    },
	    saveAndShowTab: function saveAndShowTab(updatedSubject, tab) {
	      var _this13 = this;
	
	      updatedSubject['schoolId'] = updatedSubject.schoolId ? updatedSubject.schoolId : window.SCHOOL.id;
	      updatedSubject['schoolYearId'] = updatedSubject.schoolYearId ? updatedSubject.schoolYearId : this.activeSchoolYear.id;
	      this.updateSubject(updatedSubject);
	      this._pendingTab = tab;
	      this._pendingSubjectId = updatedSubject.id;
	      setTimeout(function () {
	        _this13.isSubjectModal = true;
	        _docendo2.default.showSubject(_this13._pendingSubjectId, function (success) {
	          var pendingTab = _this13._pendingTab;
	          _this13._pendingTab = null;
	          _this13._pendingSubjectId = null;
	          _this13.editSubject = (0, _assign2.default)({}, success, { _openTab: pendingTab });
	        });
	      }, 500);
	    },
	    deleteSubject: function deleteSubject(editSubject) {
	      var deletedSubject = {
	        id: editSubject.id,
	        school_id: editSubject.school_id,
	        school_year_id: this.activeSchoolYear.id
	      };
	      deletedSubject['schoolYearId'] = this.activeSchoolYear.id;
	      this.$store.dispatch('deleteSubject', deletedSubject);
	      this.closeModal();
	    },
	    setTableWidth: function setTableWidth() {
	      var el = this.$refs.tableHead;
	      if (!el) {
	        return;
	      }
	      var tableBCR = el.getBoundingClientRect();
	      this.tableWidth = tableBCR.width + 15 + 'px';
	    },
	    readSubject: function readSubject() {
	      this.$store.dispatch('readSubjects', this.activeSchoolYear.id);
	    },
	    loadBulkCalSubjectTypes: function loadBulkCalSubjectTypes() {
	      var _this14 = this;
	
	      var country = this.$store.getters.schoolCountry;
	      _docendo2.default.subjectsForCalendarType('klass', country, function (data) {
	        var list = typeof data === 'string' ? JSON.parse(data) : data;
	        _this14.bulkCalSubjectTypes = Array.isArray(list) ? list : [];
	      }, function () {
	        _this14.bulkCalSubjectTypes = [];
	      });
	    },
	    openBulkColorModal: function openBulkColorModal(row) {
	      this.bulkColorRow = row;
	      this.bulkColor = row.rawSubject.color || '#A0A5EF';
	      this.bulkName = row.name || '';
	      this.bulkHours = row.rawSubject && row.rawSubject.hours != null ? row.rawSubject.hours : null;
	      this.bulkSubjectType = row.rawSubject && row.rawSubject.subject_type ? row.rawSubject.subject_type : '';
	      this.bulkPreparation = row.rawSubject && row.rawSubject.preparation != null ? row.rawSubject.preparation * 1 : null;
	      var roomIds = this.getRoomIdsFromRow(row);
	      this.bulkRoom = roomIds;
	      this.bulkRoomSelected = [].concat(roomIds);
	      this.bulkColorEnabled = false;
	      this.bulkNameEnabled = false;
	      this.bulkHoursEnabled = false;
	      this.bulkSubjectTypeEnabled = false;
	      this.bulkPreparationEnabled = false;
	      this.bulkRoomEnabled = false;
	      this.isBulkColorModalOpen = true;
	    },
	    getRoomIdsFromRow: function getRoomIdsFromRow(row) {
	      var allCals = this.allCalendarsInHash || {};
	      var cells = row.cells || [];
	      for (var i = 0; i < cells.length; i++) {
	        var cell = cells[i];
	        if (!cell.hasSubject) {
	          continue;
	        }
	        var calIds = cell.klass.calendar_ids || [];
	        var roomIds = calIds.filter(function (id) {
	          return allCals[id] && allCals[id].type === 'room';
	        });
	        if (roomIds.length > 0) {
	          return roomIds;
	        }
	      }
	      return [];
	    },
	    setBulkColor: function setBulkColor(color) {
	      this.bulkColor = color;
	    },
	    setBulkRoom: function setBulkRoom(rooms) {
	      this.bulkRoomSelected = rooms.map(function (r) {
	        return r.id;
	      });
	    },
	    closeBulkColorModal: function closeBulkColorModal() {
	      if (this.bulkColorLoading) {
	        return;
	      }
	      this.isBulkColorModalOpen = false;
	      this.bulkColorRow = null;
	      this.bulkColor = '';
	      this.bulkName = '';
	      this.bulkHours = null;
	      this.bulkSubjectType = '';
	      this.bulkPreparation = null;
	      this.bulkRoom = [];
	      this.bulkRoomSelected = [];
	      this.bulkColorEnabled = false;
	      this.bulkNameEnabled = false;
	      this.bulkHoursEnabled = false;
	      this.bulkSubjectTypeEnabled = false;
	      this.bulkPreparationEnabled = false;
	      this.bulkRoomEnabled = false;
	    },
	    saveBulkColor: function saveBulkColor() {
	      var _this15 = this;
	
	      if (!this.bulkColorRow || this.bulkColorLoading) {
	        return;
	      }
	      if (!this.bulkColorEnabled && !this.bulkRoomEnabled && !this.bulkNameEnabled && !this.bulkHoursEnabled && !this.bulkSubjectTypeEnabled && !this.bulkPreparationEnabled) {
	        return;
	      }
	      var cellsToUpdate = (this.bulkColorRow.cells || []).filter(function (cell) {
	        return cell.hasSubject;
	      });
	      if (cellsToUpdate.length === 0) {
	        this.closeBulkColorModal();
	        return;
	      }
	      var ids = cellsToUpdate.map(function (cell) {
	        return cell.klass.id;
	      });
	      var changes = {};
	      if (this.bulkNameEnabled && this.bulkName.trim().length > 0) {
	        changes.name = this.bulkName.trim();
	      }
	      if (this.bulkHoursEnabled && typeof this.bulkHours === 'number' && !isNaN(this.bulkHours) && this.bulkHours >= 0) {
	        changes.hours = this.bulkHours;
	      }
	      if (this.bulkSubjectTypeEnabled && this.bulkSubjectType) {
	        changes.subject_type = this.bulkSubjectType;
	      }
	      if (this.bulkPreparationEnabled && typeof this.bulkPreparation === 'number' && !isNaN(this.bulkPreparation) && this.bulkPreparation >= -1) {
	        changes.preparation = this.bulkPreparation;
	      }
	      if (this.bulkColorEnabled) {
	        changes.color = this.bulkColor;
	      }
	      if (this.bulkRoomEnabled && this.bulkRoomSelected.length > 0) {
	        changes.add_calendar_id = this.bulkRoomSelected[0];
	      }
	      this.bulkColorLoading = true;
	      _docendo2.default.bulkUpdateSubjects(this.schoolId, ids, changes, function (data) {
	        var subjects = typeof data === 'string' ? JSON.parse(data) : data;
	        subjects.forEach(function (subj) {
	          subj.calendar_ids = subj.cals ? subj.cals.map(function (c) {
	            return c.id;
	          }) : [];
	          _this15.$store.commit('updateSubject', subj);
	        });
	        _this15.bulkColorLoading = false;
	        _this15.closeBulkColorModal();
	      }, function () {
	        _this15.bulkColorLoading = false;
	        _this15.closeBulkColorModal();
	      });
	    },
	    openKlassRoomModal: function openKlassRoomModal(calId) {
	      this.klassRoomCalId = calId;
	      var cal = this.klassHeaderColumns.find(function (c) {
	        return c.id === calId;
	      });
	      this.klassRoomName = cal ? cal.vName : '';
	      this.klassRoomSelected = [];
	      this.klassRoomExcluded = {};
	      this.klassRoomLoading = false;
	      this.isKlassRoomModalOpen = true;
	    },
	    setKlassRoom: function setKlassRoom(rooms) {
	      this.klassRoomSelected = rooms;
	    },
	    toggleKlassRoomSubject: function toggleKlassRoomSubject(subjectId) {
	      var copy = (0, _assign2.default)({}, this.klassRoomExcluded);
	      if (copy[subjectId]) {
	        delete copy[subjectId];
	      } else {
	        copy[subjectId] = true;
	      }
	      this.klassRoomExcluded = copy;
	    },
	    closeKlassRoomModal: function closeKlassRoomModal() {
	      if (this.klassRoomLoading) return;
	      this.isKlassRoomModalOpen = false;
	      this.klassRoomCalId = null;
	      this.klassRoomName = '';
	      this.klassRoomSelected = [];
	      this.klassRoomExcluded = {};
	      this.klassRoomLoading = false;
	    },
	    saveKlassRoom: function saveKlassRoom() {
	      var _this16 = this;
	
	      if (this.klassRoomSelected.length === 0) return;
	      var subjects = this.klassRoomSubjects.filter(function (s) {
	        return !_this16.klassRoomExcluded[s.id];
	      });
	      if (subjects.length === 0) {
	        this.closeKlassRoomModal();
	        return;
	      }
	      var ids = subjects.map(function (s) {
	        return s.id;
	      });
	      var firstSelected = this.klassRoomSelected[0];
	      var calendarId = firstSelected && (typeof firstSelected === 'undefined' ? 'undefined' : (0, _typeof3.default)(firstSelected)) === 'object' ? firstSelected.id : firstSelected;
	      if (!calendarId) return;
	      var changes = { add_calendar_id: calendarId };
	      this.klassRoomLoading = true;
	      _docendo2.default.bulkUpdateSubjects(this.schoolId, ids, changes, function (data) {
	        var updated = typeof data === 'string' ? JSON.parse(data) : data;
	        updated.forEach(function (subj) {
	          subj.calendar_ids = subj.cals ? subj.cals.map(function (c) {
	            return c.id;
	          }) : [];
	          _this16.$store.commit('updateSubject', subj);
	        });
	        _this16.klassRoomLoading = false;
	        _this16.closeKlassRoomModal();
	      }, function () {
	        _this16.klassRoomLoading = false;
	        _this16.closeKlassRoomModal();
	      });
	    }
	  },
	
	  mounted: function mounted() {
	    window.addEventListener('new_subjects_created', this.onNewSubjectsCreated);
	    this.scheduleSetTableWidth();
	    this.loadBulkCalSubjectTypes();
	    this.loadSelectedKlassFiltersFromLocalStorage();
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('new_subjects_created', this.onNewSubjectsCreated);
	    if (this._tableWidthRaf) {
	      window.cancelAnimationFrame(this._tableWidthRaf);
	      this._tableWidthRaf = null;
	    }
	  }
	};

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(9);
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    subject: {
	      default: null
	    },
	    calendar: {
	      default: null
	    },
	    propHours: {
	      default: null
	    }
	  },
	  data: function data() {
	    var initial = this.propHours != null ? this.propHours * 1 : NaN;
	    return {
	      hours: !isNaN(initial) && initial > 0 ? initial : 0
	    };
	  },
	
	  methods: {
	    close: function close() {
	      this.$emit('close');
	      this.hours = 0;
	    },
	    selectAll: function selectAll(event) {
	      setTimeout(function () {
	        event.target.select();
	      }, 0);
	    },
	    addSubject: function addSubject() {
	      if (this.hours < 0 || isNaN(this.hours)) {
	        this.isCreateSubject = false;
	        this.hours = 0;
	        return;
	      }
	      var newSubject = {
	        subject: this.subject,
	        calendar: this.calendar,
	        hours: this.hours
	      };
	      this.$emit('createSubject', newSubject);
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    setTimeout(function (_) {
	      _this.$refs.count.focus();
	    }, 0);
	  }
	};

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _set = __webpack_require__(27);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _RequestSubjectsUser = __webpack_require__(1622);
	
	var _RequestSubjectsUser2 = _interopRequireDefault(_RequestSubjectsUser);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Tabs: _Tabs2.default, RequestSubjectsUser: _RequestSubjectsUser2.default, DoFiltersFilter: _DoFiltersFilter2.default, Loader: _Loader2.default, AppToggle: _AppToggle2.default },
	  data: function data() {
	    return {
	      selectedTab: 'Fag',
	      selectedKlassFilters: [],
	      selectedStatusFilters: ['Fag uden tildelt underviser'],
	      loadingSubjects: {},
	      subjectSearchQuery: '',
	      debounceTimer: null,
	      schoolYearId: null,
	      userAssignedTeachingTasks: [],
	      userAssignedOtherTasks: [],
	      userPoolData: null,
	      showLessonsPerWeek: false
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    isSchoolDanish: function isSchoolDanish() {
	      return this.school && this.school.country ? this.school.country.toLowerCase() === 'dk' : false;
	    },
	    subjectDefaultDuration: function subjectDefaultDuration() {
	      return this.school && this.school.subject_default_duration ? this.school.subject_default_duration : 45;
	    },
	    isLessonsPerWeekActive: function isLessonsPerWeekActive() {
	      return this.isSchoolDanish && this.showLessonsPerWeek;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    userCalendarId: function userCalendarId() {
	      return this.user && this.user.user_calendar_id ? this.user.user_calendar_id : null;
	    },
	    schoolYears: function schoolYears() {
	      return this.$store.state.schoolYears;
	    },
	    requestedSchoolYear: function requestedSchoolYear() {
	      var _this = this;
	
	      if (!this.schoolYearId) {
	        return null;
	      }
	      return this.schoolYears.find(function (year) {
	        return year.id === _this.schoolYearId * 1;
	      }) || null;
	    },
	    canShowAssignedSubjects: function canShowAssignedSubjects() {
	      return !!(this.user && this.user.id && this.requestedSchoolYear && this.requestedSchoolYear.employee_time_start && this.requestedSchoolYear.employee_time_end);
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.subjects.isLoading;
	    },
	    subjects: function subjects() {
	      return this.$store.state.subjects.subjects;
	    },
	    hasOtherSubjects: function hasOtherSubjects() {
	      return this.subjects.some(function (subject) {
	        return subject.master_type === 'other';
	      });
	    },
	    requestedSubjects: function requestedSubjects() {
	      return this.$store.getters.subjectsRequestsInHash;
	    },
	    isShowSubjectsWithoutTeachers: function isShowSubjectsWithoutTeachers() {
	      return this.selectedStatusFilters.includes('Fag uden tildelt underviser');
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    subjectsInKlassHash: function subjectsInKlassHash() {
	      return this.$store.getters.subjectsInKlassHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    subjectsInUserHash: function subjectsInUserHash() {
	      return this.$store.getters.subjectsInUserHash;
	    },
	    klassCalendars: function klassCalendars() {
	      var cals = [];
	      var seenIds = new _set2.default();
	      this.subjects.forEach(function (subject) {
	        subject.cals.forEach(function (cal) {
	          if (cal.calendar_type === 'klass' && !seenIds.has(cal.id)) {
	            seenIds.add(cal.id);
	            cals.push(cal);
	          }
	        });
	      });
	      return cals.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    klassTags: function klassTags() {
	      return this.klassCalendars.map(function (klassCalendar) {
	        return klassCalendar.name;
	      });
	    },
	    calsWithProps: function calsWithProps() {
	      var _this2 = this;
	
	      var klasses = this.klassCalendars;
	
	      return klasses.map(function (klass) {
	        return (0, _extends3.default)({}, klass, {
	          vSubjects: (_this2.subjectsInKlassHash[klass.id] || []).filter(function (subjectId) {
	            var subject = _this2.subjectsInHash[subjectId] || {};
	            return subject.subject_type !== 'frame' && subject.subject_type !== 'activity';
	          }).map(function (subjectId) {
	            var subject = _this2.subjectsInHash[subjectId] || {};
	
	            var vHours = _this2.getSubjectHoursForKlass(subject, klass.id);
	            return (0, _extends3.default)({}, subject, {
	              vHours: vHours,
	              vLessonsPerWeek: _this2.calcLessonsPerWeek(_this2.getSubjectHoursForLessons(subject)),
	              vRequestedBy: _this2.getSubjectedRequestedBy(subjectId),
	              vTotalRequestCount: (_this2.requestedSubjects[subjectId] || []).length,
	              vHasTeachers: _this2.subjectHasTeachers(subjectId),
	              vUserNames: _this2.getUserNames(subjectId),
	              vIsRequestedByUser: _this2.getIsSubjectRequestedByUser(subjectId),
	              vIsLoading: _this2.getIsSubjectLoading(subjectId)
	            });
	          })
	        });
	      });
	    },
	    filteredKlassCals: function filteredKlassCals() {
	      var _this3 = this;
	
	      var klasses = this.calsWithProps;
	
	      if (this.selectedKlassFilters.length > 0) {
	        klasses = klasses.filter(function (klass) {
	          return _this3.selectedKlassFilters.includes(klass.name);
	        });
	      }
	
	      var hasStatusFilters = this.selectedStatusFilters.length > 0;
	
	      return klasses.map(function (klass) {
	        return (0, _extends3.default)({}, klass, {
	          vSubjects: klass.vSubjects.filter(function (subject) {
	            var matchesStatusFilter = !hasStatusFilters || _this3.selectedStatusFilters.includes('Fag uden tildelt underviser') && !subject.vHasTeachers || _this3.selectedStatusFilters.includes('Fag med tildelt underviser') && subject.vHasTeachers || _this3.selectedStatusFilters.includes('Fag jeg har ønsket') && subject.vIsRequestedByUser || _this3.selectedStatusFilters.includes('Fag ønsket af flere') && subject.vTotalRequestCount >= 2 || _this3.selectedStatusFilters.includes('Fag ingen har ønsket') && subject.vTotalRequestCount === 0;
	
	            var matchesSearch = !_this3.subjectSearchQuery || subject.name.toLowerCase().includes(_this3.subjectSearchQuery.toLowerCase());
	
	            return matchesStatusFilter && matchesSearch;
	          })
	        });
	      });
	    },
	    subjectsRequests: function subjectsRequests() {
	      return this.$store.state.subjects.subjectsRequests;
	    },
	    isLoadingSubjectsRequests: function isLoadingSubjectsRequests() {
	      return this.$store.state.subjects.isLoadingSubjectsRequests;
	    },
	    userRequestedSubjects: function userRequestedSubjects() {
	      var _this4 = this;
	
	      if (!this.user) {
	        return [];
	      }
	      return this.subjects.filter(function (subject) {
	        return _this4.getIsSubjectRequestedByUser(subject.id);
	      });
	    },
	    userRequestedSubjectsWithProps: function userRequestedSubjectsWithProps() {
	      var _this5 = this;
	
	      return this.userRequestedSubjects.map(function (subject) {
	        var vHours = _this5.getSubjectHoursForKlass(subject, subject.calendar_id);
	        return (0, _extends3.default)({}, subject, {
	          vHours: vHours,
	          vLessonsPerWeek: _this5.calcLessonsPerWeek(_this5.getSubjectHoursForLessons(subject)),
	          vKlass: _this5.getKlassesOnSubjects(subject),
	          vRequestedBy: _this5.getSubjectedRequestedBy(subject.id)
	        });
	      }).sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    userRequestedTeachingSubjects: function userRequestedTeachingSubjects() {
	      return this.userRequestedSubjectsWithProps.filter(function (subject) {
	        return subject.master_type !== 'other';
	      });
	    },
	    userRequestedOtherSubjects: function userRequestedOtherSubjects() {
	      return this.userRequestedSubjectsWithProps.filter(function (subject) {
	        return subject.master_type === 'other';
	      });
	    },
	    assignedSubjectsTeaching: function assignedSubjectsTeaching() {
	      if (!this.canShowAssignedSubjects) {
	        return [];
	      }
	      return this.userAssignedTeachingTasks.slice().sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    assignedSubjectsOther: function assignedSubjectsOther() {
	      if (!this.canShowAssignedSubjects) {
	        return [];
	      }
	      return this.userAssignedOtherTasks.slice().sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    isPoolsDeactivated: function isPoolsDeactivated() {
	      return this.schoolSettings && this.schoolSettings['deactivatePools'] ? this.schoolSettings['deactivatePools'] : false;
	    },
	    poolTeachingHours: function poolTeachingHours() {
	      if (!this.userPoolData) {
	        return 0;
	      }
	      var val = parseFloat(this.userPoolData.assigned_teaching_hours);
	      return isNaN(val) ? 0 : val;
	    },
	    poolOtherHours: function poolOtherHours() {
	      if (!this.userPoolData) {
	        return 0;
	      }
	      var val = parseFloat(this.userPoolData.assigned_additional_task_hours);
	      return isNaN(val) ? 0 : val;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    canSeeOtherSubjectRequests: function canSeeOtherSubjectRequests() {
	      if (!this.user) return false;
	      if (!this.isPermissionsActivatedForSchool) return true;
	      return this.userPermissions && this.userPermissions.indexOf('can_see_other_subject_requests') > -1 || this.user.admin;
	    },
	    statusFilters: function statusFilters() {
	      var filters = ['Fag uden tildelt underviser', 'Fag med tildelt underviser', 'Fag jeg har ønsket'];
	      if (this.canSeeOtherSubjectRequests) {
	        filters.push('Fag ønsket af flere', 'Fag ingen har ønsket');
	      }
	      return filters;
	    }
	  },
	  methods: {
	    calcLessonsPerWeek: function calcLessonsPerWeek(hours) {
	      return this.$helpers.calcLessonsPerWeek(hours, this.subjectDefaultDuration);
	    },
	    getSubjectHoursForKlass: function getSubjectHoursForKlass(subject, klassCalId) {
	      if (subject.subject_calendars) {
	        var entry = subject.subject_calendars.find(function (sc) {
	          return sc.calendar_id === klassCalId;
	        });
	        if (entry && entry.hours != null) {
	          return entry.hours;
	        }
	      }
	      return subject.hours;
	    },
	    getSubjectHoursForLessons: function getSubjectHoursForLessons(subject) {
	      if (subject.subject_calendars && this.userCalendarId) {
	        var entry = subject.subject_calendars.find(function (sc) {
	          return sc.calendar_id === this.userCalendarId;
	        }.bind(this));
	        if (entry && entry.hours != null) {
	          return entry.hours;
	        }
	      }
	      return subject.hours;
	    },
	    getKlassesOnSubjects: function getKlassesOnSubjects(subject) {
	      var cal = this.allCalendarsInHash[subject.calendar_id];
	      return cal ? cal.name : '';
	    },
	    readUserTeachingTasks: function readUserTeachingTasks() {
	      var _this6 = this;
	
	      if (!this.canShowAssignedSubjects) {
	        this.userAssignedTeachingTasks = [];
	        this.userAssignedOtherTasks = [];
	        return;
	      }
	      _docendo2.default.userTasks(this.user.id, this.requestedSchoolYear.employee_time_start, this.requestedSchoolYear.employee_time_end, function (success) {
	        var rows = Array.isArray(success) ? success : success && Array.isArray(success.data) ? success.data : [];
	        var mapped = rows.filter(function (row) {
	          return row;
	        }).map(function (row) {
	          var hoursUser = parseFloat(row.hours_user);
	          var hoursSubject = parseFloat(row.hours_subject);
	          var hours = parseFloat(row.hours);
	          var vHours = 0;
	          if (!isNaN(hoursUser)) {
	            vHours = hoursUser;
	          } else if (!isNaN(hoursSubject)) {
	            vHours = hoursSubject;
	          } else if (!isNaN(hours)) {
	            vHours = hours;
	          }
	          var isOtherKind = row.master_type === 'other' || row.subject_type === 'additional_tasks' && row.master_type !== 'teaching';
	          var vType = row.subject_type === 'subject' ? 'Fag' : isOtherKind ? 'Øvrig opgave' : 'Undervisningsopgave';
	          return (0, _extends3.default)({}, row, {
	            rowId: 'user_task_' + row.id,
	            vKlass: row.calendar || '',
	            vHours: vHours,
	            vType: vType
	          });
	        });
	        var isTeachingAssigned = function isTeachingAssigned(row) {
	          if (row.master_type === 'other') {
	            return false;
	          }
	          return row.subject_type === 'subject' || row.subject_type === 'person_resource' || row.subject_type === 'person_resource_visible' || row.master_type === 'teaching';
	        };
	        var isOtherAssigned = function isOtherAssigned(row) {
	          if (row.master_type === 'other') {
	            return true;
	          }
	          return row.subject_type === 'additional_tasks' && row.master_type !== 'teaching';
	        };
	        _this6.userAssignedTeachingTasks = mapped.filter(isTeachingAssigned);
	        _this6.userAssignedOtherTasks = mapped.filter(isOtherAssigned);
	      }, function (failure) {
	        _this6.userAssignedTeachingTasks = [];
	        _this6.userAssignedOtherTasks = [];
	        console.log('failed read user tasks', failure);
	      });
	    },
	    onSelectTab: function onSelectTab(tab) {
	      this.selectedTab = tab;
	    },
	    debounceSearch: function debounceSearch(event) {
	      var _this7 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        _this7.subjectSearchQuery = event.target.value;
	      }, 400);
	    },
	    getSubjectedRequestedBy: function getSubjectedRequestedBy(subjectId) {
	      var _this8 = this;
	
	      var currentCalendarIds = this.requestedSubjects[subjectId] || [];
	      return currentCalendarIds.filter(function (calId) {
	        return calId !== _this8.userCalendarId && _this8.allCalendarsInHash[calId];
	      }).map(function (calId) {
	        return _this8.allCalendarsInHash[calId] ? _this8.allCalendarsInHash[calId]['name'] : [];
	      });
	    },
	    getIsSubjectRequestedByUser: function getIsSubjectRequestedByUser(subjectId) {
	      var userCalendarId = this.userCalendarId;
	      var currentUserIds = this.requestedSubjects[subjectId];
	      return currentUserIds && currentUserIds.includes(userCalendarId);
	    },
	    onSetSubjectRequest: function onSetSubjectRequest(subjectId) {
	      var _this9 = this;
	
	      this.$set(this.loadingSubjects, subjectId, true);
	
	      if (this.getIsSubjectRequestedByUser(subjectId)) {
	        var idx = this.subjectsRequests.findIndex(function (subjectsReq) {
	          return subjectsReq.subject_id === subjectId && subjectsReq.calendar_id === _this9.userCalendarId;
	        });
	        if (idx > -1) {
	          var reqId = this.subjectsRequests[idx]['id'];
	
	          _docendo2.default.deleteSubjectRequest(this.schoolId, this.schoolYearId, reqId, function (success) {
	            _this9.$store.commit('removeSubjectRequest', success);
	            _this9.$delete(_this9.loadingSubjects, subjectId);
	          }, function (failure) {
	            _this9.$delete(_this9.loadingSubjects, subjectId);
	          });
	        }
	      } else {
	        _docendo2.default.createSubjectRequest(this.schoolId, this.schoolYearId, subjectId, function (success) {
	          console.log(success);
	          if (success && success.status && success.status === 'error') {
	            _eventbus2.default.toast = { text: 'Fagønsker er ikke åbne for dette skoleår', success: false };
	            _this9.$delete(_this9.loadingSubjects, subjectId);
	            return;
	          }
	          _this9.$store.commit('addSubjectRequest', success);
	          _this9.$delete(_this9.loadingSubjects, subjectId);
	        }, function (failure) {
	          _eventbus2.default.toast = { text: 'Fagønsker er ikke åbne for dette skoleår', success: false };
	          _this9.$delete(_this9.loadingSubjects, subjectId);
	        });
	      }
	    },
	    getIsSubjectLoading: function getIsSubjectLoading(subjectId) {
	      return this.loadingSubjects[subjectId];
	    },
	    toggleSelectedStatusFilters: function toggleSelectedStatusFilters(filter) {
	      var idx = this.selectedStatusFilters.indexOf(filter);
	      if (idx < 0) {
	        this.selectedStatusFilters.push(filter);
	      } else {
	        this.selectedStatusFilters.splice(idx, 1);
	      }
	    },
	    toggleKlassTag: function toggleKlassTag(filter) {
	      var idx = this.selectedKlassFilters.indexOf(filter);
	      if (idx < 0) {
	        this.selectedKlassFilters.push(filter);
	      } else {
	        this.selectedKlassFilters.splice(idx, 1);
	      }
	    },
	    setEditSubject: function setEditSubject(editSubject) {
	      console.log('setEditSubject', editSubject);
	    },
	    getUserNames: function getUserNames(subjectId) {
	      var _this10 = this;
	
	      var calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : [];
	      if (!calIds || calIds.length < 1 || !calIds[0]) {
	        return '';
	      }
	      return calIds.filter(function (calId) {
	        return _this10.allCalendarsInHash[calId] && _this10.allCalendarsInHash[calId].type === 'user';
	      }).map(function (userCalId) {
	        return _this10.allCalendarsInHash[userCalId].name ? _this10.allCalendarsInHash[userCalId].name : '';
	      });
	    },
	    isShowWithoutTeacher: function isShowWithoutTeacher(subjectid) {
	      if (!this.isShowSubjectsWithoutTeachers) {
	        return true;
	      } else {
	        return !this.subjectHasTeachers(subjectid);
	      }
	    },
	    subjectHasTeachers: function subjectHasTeachers(subjectId) {
	      var _this11 = this;
	
	      var calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : [];
	      var hasTeachers = false;
	      calIds.forEach(function (calId) {
	        if (_this11.allCalendarsInHash[calId] && _this11.allCalendarsInHash[calId].type === 'user') {
	          hasTeachers = true;
	        }
	      });
	      return hasTeachers;
	    },
	    readUserPoolData: function readUserPoolData() {
	      var _this12 = this;
	
	      if (!this.schoolId || !this.schoolYearId || !this.user || !this.user.id) {
	        this.userPoolData = null;
	        return;
	      }
	      _docendo2.default.schoolUserYearsList(this.schoolId, this.schoolYearId, this.user.id, function (data) {
	        var rows = Array.isArray(data) ? data : [];
	        var match = rows.find(function (row) {
	          return row && row.user_id === _this12.user.id;
	        });
	        _this12.userPoolData = match || null;
	      }, function (failure) {
	        _this12.userPoolData = null;
	      });
	    },
	    readSubjectRequests: function readSubjectRequests() {
	      if (this.schoolYearId) {
	        this.$store.dispatch('readSubjects', this.schoolYearId);
	        this.$store.dispatch('readSubjectRequests', this.schoolYearId);
	      }
	      this.readUserTeachingTasks();
	      this.readUserPoolData();
	    }
	  },
	  watch: {
	    showLessonsPerWeek: function showLessonsPerWeek(val) {
	      this.$helpers.setLocalStorage('doRequestSubjectsShowLessonsPerWeek', val);
	    },
	    canShowAssignedSubjects: function canShowAssignedSubjects(value) {
	      if (value) {
	        this.readUserTeachingTasks();
	      } else {
	        this.userAssignedTeachingTasks = [];
	        this.userAssignedOtherTasks = [];
	      }
	    },
	    requestedSchoolYear: function requestedSchoolYear(value, oldValue) {
	      var nextId = value && value.id ? value.id : null;
	      var prevId = oldValue && oldValue.id ? oldValue.id : null;
	      if (nextId !== prevId && this.canShowAssignedSubjects) {
	        this.readUserTeachingTasks();
	        this.readUserPoolData();
	      }
	    }
	  },
	  mounted: function mounted() {
	    var urlParams = new window.URLSearchParams(window.location.search);
	    this.schoolYearId = urlParams.get('school_year_id') || 19983;
	    if (!this.schoolYearId) {
	      window.alert('Der mangler et skoleårs ID i URL’en');
	    }
	    var storedLessons = this.$helpers.getLocalStorage('doRequestSubjectsShowLessonsPerWeek');
	    if (storedLessons === 'true') {
	      this.showLessonsPerWeek = true;
	    }
	    this.readSubjectRequests();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.debounceTimer) {
	      clearTimeout(this.debounceTimer);
	    }
	  }
	};

/***/ }),
/* 733 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      isAssignedTeachingOpen: false,
	      isAssignedOtherOpen: false
	    };
	  },
	
	  props: {
	    user: {
	      type: Object,
	      default: {
	        name: ''
	      }
	    },
	    assignedTeaching: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    assignedOther: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    showAssignedSubjects: {
	      type: Boolean,
	      default: true
	    },
	    userSubjectsTeaching: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    userSubjectsOther: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    allCalendarsInHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    loadingSubjects: {
	      default: {}
	    },
	    isPoolsDeactivated: {
	      type: Boolean,
	      default: true
	    },
	    poolTeachingHours: {
	      type: Number,
	      default: 0
	    },
	    poolOtherHours: {
	      type: Number,
	      default: 0
	    },
	    hasOtherSubjects: {
	      type: Boolean,
	      default: false
	    },
	    showLessonsPerWeek: {
	      type: Boolean,
	      default: false
	    },
	    subjectDefaultDuration: {
	      type: Number,
	      default: 45
	    }
	  },
	  computed: {
	    assignedSumTeaching: function assignedSumTeaching() {
	      return this.sumHoursForRows(this.assignedTeaching);
	    },
	    assignedSumOther: function assignedSumOther() {
	      return this.sumHoursForRows(this.assignedOther);
	    },
	    assignedSumTotal: function assignedSumTotal() {
	      return (parseFloat(this.assignedSumTeaching) + parseFloat(this.assignedSumOther)).toFixed(1);
	    },
	    sumOfHoursTeaching: function sumOfHoursTeaching() {
	      return this.sumHoursForSubjects(this.userSubjectsTeaching);
	    },
	    sumOfHoursOther: function sumOfHoursOther() {
	      return this.sumHoursForSubjects(this.userSubjectsOther);
	    },
	    totalTeachingCombined: function totalTeachingCombined() {
	      return (parseFloat(this.sumOfHoursTeaching) + parseFloat(this.assignedSumTeaching)).toFixed(1);
	    },
	    totalOtherCombined: function totalOtherCombined() {
	      return (parseFloat(this.sumOfHoursOther) + parseFloat(this.assignedSumOther)).toFixed(1);
	    },
	    totalSumOfHours: function totalSumOfHours() {
	      return (parseFloat(this.totalTeachingCombined) + parseFloat(this.totalOtherCombined)).toFixed(1);
	    },
	    showOtherTasks: function showOtherTasks() {
	      return this.hasOtherSubjects && this.assignedOther.length > 0;
	    },
	    showPoolInfo: function showPoolInfo() {
	      return !this.isPoolsDeactivated && this.showAssignedSubjects;
	    },
	    teachingDiff: function teachingDiff() {
	      return (this.poolTeachingHours - parseFloat(this.totalTeachingCombined)).toFixed(1);
	    },
	    showOtherPoolInfo: function showOtherPoolInfo() {
	      return this.showPoolInfo && this.hasOtherSubjects;
	    },
	    otherDiff: function otherDiff() {
	      return (this.poolOtherHours - parseFloat(this.totalOtherCombined)).toFixed(1);
	    },
	    displaySumTeaching: function displaySumTeaching() {
	      if (this.showLessonsPerWeek) {
	        return this.userSubjectsTeaching.reduce(function (sum, s) {
	          return sum + parseFloat(s.vLessonsPerWeek || 0);
	        }, 0).toFixed(1);
	      }
	      return this.sumOfHoursTeaching;
	    },
	    displayAssignedSumTeaching: function displayAssignedSumTeaching() {
	      return this.showLessonsPerWeek ? this.calcLessonsPerWeek(parseFloat(this.assignedSumTeaching)) : this.assignedSumTeaching;
	    },
	    displayTotalTeachingCombined: function displayTotalTeachingCombined() {
	      if (this.showLessonsPerWeek) {
	        return (parseFloat(this.displaySumTeaching) + parseFloat(this.displayAssignedSumTeaching)).toFixed(1);
	      }
	      return this.totalTeachingCombined;
	    },
	    displayPoolTeachingHours: function displayPoolTeachingHours() {
	      return this.showLessonsPerWeek ? this.calcLessonsPerWeek(this.poolTeachingHours) : this.poolTeachingHours;
	    },
	    displayTeachingDiff: function displayTeachingDiff() {
	      if (this.showLessonsPerWeek) {
	        return (parseFloat(this.displayPoolTeachingHours) - parseFloat(this.displayTotalTeachingCombined)).toFixed(1);
	      }
	      return this.teachingDiff;
	    }
	  },
	  methods: {
	    calcLessonsPerWeek: function calcLessonsPerWeek(hours) {
	      return this.$helpers.calcLessonsPerWeek(hours, this.subjectDefaultDuration);
	    },
	    displayHours: function displayHours(hours) {
	      if (this.showLessonsPerWeek) {
	        return this.calcLessonsPerWeek(this.getNumericHours(hours));
	      }
	      return this.formatHours(hours);
	    },
	    sumHoursForSubjects: function sumHoursForSubjects(subjects) {
	      var _this = this;
	
	      return subjects.reduce(function (sum, subject) {
	        return sum + _this.getNumericHours(subject.vHours);
	      }, 0).toFixed(1);
	    },
	    sumHoursForRows: function sumHoursForRows(rows) {
	      var _this2 = this;
	
	      return rows.reduce(function (sum, subject) {
	        return sum + _this2.getNumericHours(subject.vHours);
	      }, 0).toFixed(1);
	    },
	    getNumericHours: function getNumericHours(hours) {
	      var value = parseFloat(hours);
	      return isNaN(value) ? 0 : value;
	    },
	    formatHours: function formatHours(hours) {
	      return this.getNumericHours(hours).toFixed(1);
	    }
	  }
	};

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DSelectCalsIds = __webpack_require__(40);
	
	var _DSelectCalsIds2 = _interopRequireDefault(_DSelectCalsIds);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _TimeInput = __webpack_require__(107);
	
	var _TimeInput2 = _interopRequireDefault(_TimeInput);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    title: 'Lejrskoler',
	    guide: 'Guide til lejrskole udregning',
	    create: 'Opret lejrskole',
	    edit: 'Rediger lejrskole',
	    camp_title: 'Titel',
	    title_placeholder: 'F.eks. Lejrskole 5. klasse',
	    from_date: 'Afrejse',
	    to_date: 'Hjemkomst',
	    time: 'Tid',
	    period: 'Periode',
	    classes: 'Klasser',
	    add_classes: 'Tilføj klasser',
	    add_users: 'Tilføj personer',
	    users: 'Personer',
	    existing_hours: 'Angiv UV-reduktion',
	    existing_hours_desc: 'Angiv det antal UV-timer som hver person allerede har i skema i lejrskoleperioden. Disse timer trækkes fra, da de vil blive aflyst eller vikardækket. Hvis skemaet endnu ikke er lagt, kan et forventet tal skrives ind, og evt. opdateres senere.',
	    hours_label: 'Reduktion',
	    person: 'Person',
	    in_schedule: 'I skema',
	    available_time: 'Hvordan skal rådighedstjenesten håndteres?',
	    pay_out: 'Rådighedstjenesten skal I selv oprette som engangsydelse',
	    add_to_tasks: 'Rådighedstjenesten oprettes automatisk som øvrig opgave med 1/3 af tiden',
	    teaching_hours: 'UV-timer',
	    remaining_hours: 'Øvrig tid',
	    no_camps: 'Ingen lejrskoler oprettet',
	    cancel: 'Annuller',
	    save: 'Gem',
	    created: 'Lejrskole oprettet',
	    updated: 'Lejrskole opdateret',
	    deleted: 'Lejrskole slettet',
	    something_went_wrong: 'Noget gik galt'
	  },
	  en: {
	    title: 'School camps',
	    guide: 'Guide to camp hour calculation',
	    create: 'Create school camp',
	    edit: 'Edit school camp',
	    camp_title: 'Title',
	    title_placeholder: 'E.g. School camp 5th grade',
	    from_date: 'From date',
	    to_date: 'To date',
	    time: 'Time',
	    period: 'Period',
	    classes: 'Classes',
	    add_classes: 'Add classes',
	    add_users: 'Add people',
	    users: 'People',
	    existing_hours: 'Reduction',
	    existing_hours_desc: 'Enter the number of hours each person already has scheduled during the camp period. These hours will be deducted as they will be cancelled or covered by a substitute. If the schedule has not been finalised yet, the number can be updated later.',
	    hours_label: 'Hours',
	    person: 'Person',
	    in_schedule: 'Scheduled',
	    available_time: 'How should standby duty be handled?',
	    pay_out: 'Paid out as a one-time payment',
	    add_to_tasks: 'Included in working hours (1/3) as additional task',
	    teaching_hours: 'Teaching hours',
	    remaining_hours: 'Remaining hours',
	    no_camps: 'No school camps created',
	    cancel: 'Cancel',
	    save: 'Save',
	    created: 'School camp created',
	    updated: 'School camp updated',
	    deleted: 'School camp deleted',
	    something_went_wrong: 'Something went wrong'
	  },
	  nb: {
	    title: 'Leirskoler',
	    guide: 'Guide til leirskole beregning',
	    create: 'Opprett leirskole',
	    edit: 'Rediger leirskole',
	    camp_title: 'Tittel',
	    title_placeholder: 'F.eks. Leirskole 5. klasse',
	    from_date: 'Fra dato',
	    to_date: 'Til dato',
	    time: 'Tid',
	    period: 'Periode',
	    classes: 'Klasser',
	    add_classes: 'Legg til klasser',
	    add_users: 'Legg til personer',
	    users: 'Personer',
	    existing_hours: 'Reduksjon',
	    existing_hours_desc: 'Angi antall timer hver person allerede har i timeplanen i leirskoleperioden. Disse timene trekkes fra, da de vil bli avlyst eller vikardekket. Hvis timeplanen ikke er lagt ennå, kan tallet oppdateres senere.',
	    hours_label: 'Timer',
	    person: 'Person',
	    in_schedule: 'I timeplan',
	    available_time: 'Hvordan skal beredskapstjenesten håndteres?',
	    pay_out: 'Utbetales som engangsytelse',
	    add_to_tasks: 'Innregnes i arbeidstiden (1/3) som øvrig oppgave',
	    teaching_hours: 'UV-timer',
	    remaining_hours: 'Øvrig tid',
	    no_camps: 'Ingen leirskoler opprettet',
	    cancel: 'Avbryt',
	    save: 'Lagre',
	    created: 'Leirskole opprettet',
	    updated: 'Leirskole oppdatert',
	    deleted: 'Leirskole slettet',
	    something_went_wrong: 'Noe gikk galt'
	  }
	};
	
	exports.default = {
	  components: {
	    DModal: _DModal2.default,
	    DSelectCalendarIds: _DSelectCalsIds2.default,
	    ModalConfirmation: _ModalConfirmation2.default,
	    Loader: _Loader2.default,
	    DateSelector: _DateSelector2.default,
	    TimeInput: _TimeInput2.default
	  },
	  data: function data() {
	    return {
	      camps: [],
	      isLoading: false,
	      isModal: false,
	      isSaving: false,
	      isDeleting: false,
	      theEditCamp: null,
	      theDeleteCamp: null,
	      form: {
	        title: 'Lejrskole',
	        fromTime: (0, _moment2.default)().startOf('isoWeek').add(1, 'week').set({ hour: 6, minute: 0 }),
	        toTime: (0, _moment2.default)().startOf('isoWeek').add(1, 'week').add(4, 'days').set({ hour: 16, minute: 0 }),
	        klassCalendarIds: [],
	        userCalendarIds: [],
	        existingHours: {},
	        useAdditionalTasks: true
	      },
	      scheduledHours: {}
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    schoolYearMinDate: function schoolYearMinDate() {
	      if (this.activeSchoolYear && this.activeSchoolYear.employee_time_start) {
	        return (0, _moment2.default)(this.activeSchoolYear.employee_time_start);
	      }
	      return null;
	    },
	    schoolYearMaxDate: function schoolYearMaxDate() {
	      if (this.activeSchoolYear && this.activeSchoolYear.employee_time_end) {
	        return (0, _moment2.default)(this.activeSchoolYear.employee_time_end);
	      }
	      return null;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    isFormValid: function isFormValid() {
	      return this.form.title.trim().length > 0;
	    },
	    selectedUsers: function selectedUsers() {
	      var _this = this;
	
	      return this.form.userCalendarIds.map(function (id) {
	        return _this.allCalendarsInHash[id];
	      }).filter(function (cal) {
	        return cal;
	      });
	    }
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear() {
	      this.readCamps();
	    }
	  },
	  methods: {
	    readCamps: function readCamps() {
	      var _this2 = this;
	
	      if (!this.activeSchoolYear || !this.activeSchoolYear.id) return;
	      this.isLoading = true;
	      _docendo2.default.schoolCampsList(this.schoolId, this.activeSchoolYear.id, function (data) {
	        _this2.camps = data;
	        _this2.isLoading = false;
	      }, function () {
	        _eventbus2.default.toast = { text: _this2.i18n[_this2.locale].something_went_wrong, success: false };
	        _this2.isLoading = false;
	      });
	    },
	    formatDate: function formatDate(dateStr) {
	      if (!dateStr) return '';
	      return (0, _moment2.default)(dateStr).format('D. MMM YYYY');
	    },
	    formatDateTime: function formatDateTime(dateStr) {
	      if (!dateStr) return '';
	      return (0, _moment2.default)(dateStr).format('D. MMM YYYY [kl.] HH:mm');
	    },
	    formatTime: function formatTime(dateStr) {
	      if (!dateStr) return '';
	      return (0, _moment2.default)(dateStr).format('HH:mm');
	    },
	    getCalendarNamesByType: function getCalendarNamesByType(calendarIds, type) {
	      var _this3 = this;
	
	      if (!calendarIds || calendarIds.length < 1) return '';
	      return calendarIds.filter(function (id) {
	        var cal = _this3.allCalendarsInHash[id];
	        return cal && cal.type === type;
	      }).map(function (id) {
	        return _this3.allCalendarsInHash[id].name;
	      }).filter(function (name) {
	        return name && name.length > 0;
	      }).join(', ');
	    },
	    clampDateToSchoolYear: function clampDateToSchoolYear(date) {
	      if (this.schoolYearMinDate && date.isBefore(this.schoolYearMinDate)) {
	        return (0, _moment2.default)(this.schoolYearMinDate).set({ hour: date.hours(), minute: date.minutes() });
	      }
	      if (this.schoolYearMaxDate && date.isAfter(this.schoolYearMaxDate)) {
	        return (0, _moment2.default)(this.schoolYearMaxDate).set({ hour: date.hours(), minute: date.minutes() });
	      }
	      return date;
	    },
	    openCreateModal: function openCreateModal() {
	      var _this4 = this;
	
	      this.theEditCamp = null;
	      this.scheduledHours = {};
	      var firstMonday = this.schoolYearMinDate ? (0, _moment2.default)(this.schoolYearMinDate).isoWeekday() <= 1 ? (0, _moment2.default)(this.schoolYearMinDate).isoWeekday(1) : (0, _moment2.default)(this.schoolYearMinDate).add(1, 'week').isoWeekday(1) : (0, _moment2.default)().startOf('isoWeek').add(1, 'week');
	      var fromTime = firstMonday.set({ hour: 6, minute: 0 });
	      var toTime = (0, _moment2.default)(firstMonday).isoWeekday(5).set({ hour: 16, minute: 0 });
	      this.form = {
	        title: 'Lejrskole',
	        fromTime: fromTime,
	        toTime: toTime,
	        klassCalendarIds: [],
	        userCalendarIds: [],
	        existingHours: {},
	        useAdditionalTasks: true
	      };
	      this.isModal = true;
	      this.$nextTick(function () {
	        if (_this4.$refs.titleInput) _this4.$refs.titleInput.focus();
	      });
	    },
	    openEditModal: function openEditModal(camp) {
	      var _this5 = this;
	
	      this.theEditCamp = camp;
	      var ids = camp.calendar_ids || [];
	      var klassIds = [];
	      var userIds = [];
	      ids.forEach(function (id) {
	        var cal = _this5.allCalendarsInHash[id];
	        if (cal && cal.type === 'user') {
	          userIds.push(id);
	        } else {
	          klassIds.push(id);
	        }
	      });
	      var existingHoursMap = {};
	      if (camp.existing_hours) {
	        camp.existing_hours.forEach(function (entry) {
	          if (entry.calendar_id != null && entry.hours != null) {
	            existingHoursMap[entry.calendar_id] = entry.hours;
	          }
	        });
	      }
	      this.form = {
	        title: camp.title,
	        fromTime: camp.from_time ? (0, _moment2.default)(camp.from_time) : (0, _moment2.default)(),
	        toTime: camp.to_time ? (0, _moment2.default)(camp.to_time) : (0, _moment2.default)(),
	        klassCalendarIds: klassIds,
	        userCalendarIds: userIds,
	        existingHours: existingHoursMap,
	        useAdditionalTasks: !!camp.use_additional_tasks
	      };
	      this.scheduledHours = {};
	      this.isModal = true;
	      this.fetchScheduledHours();
	    },
	    closeModal: function closeModal() {
	      this.isModal = false;
	      this.theEditCamp = null;
	    },
	    onFromDateChanged: function onFromDateChanged(date) {
	      var hours = (0, _moment2.default)(this.form.fromTime).hours();
	      var minutes = (0, _moment2.default)(this.form.fromTime).minutes();
	      var newFrom = (0, _moment2.default)(date).set({ hour: hours, minute: minutes });
	      this.form.fromTime = newFrom;
	      if ((0, _moment2.default)(newFrom).startOf('day').isAfter((0, _moment2.default)(this.form.toTime).startOf('day'))) {
	        this.form.toTime = (0, _moment2.default)(newFrom).set({ hour: (0, _moment2.default)(this.form.toTime).hours(), minute: (0, _moment2.default)(this.form.toTime).minutes() });
	      }
	      this.fetchScheduledHoursIfNeeded();
	    },
	    onToDateChanged: function onToDateChanged(date) {
	      var hours = (0, _moment2.default)(this.form.toTime).hours();
	      var minutes = (0, _moment2.default)(this.form.toTime).minutes();
	      var newTo = (0, _moment2.default)(date).set({ hour: hours, minute: minutes });
	      this.form.toTime = newTo;
	      if ((0, _moment2.default)(newTo).startOf('day').isBefore((0, _moment2.default)(this.form.fromTime).startOf('day'))) {
	        this.form.fromTime = (0, _moment2.default)(newTo).subtract(1, 'day').set({ hour: (0, _moment2.default)(this.form.fromTime).hours(), minute: (0, _moment2.default)(this.form.fromTime).minutes() });
	      }
	      this.fetchScheduledHoursIfNeeded();
	    },
	    fetchScheduledHoursIfNeeded: function fetchScheduledHoursIfNeeded() {
	      if (this.form.userCalendarIds.length > 0) {
	        this.fetchScheduledHours();
	      }
	    },
	    onStartTimeInput: function onStartTimeInput(val) {
	      var parsed = (0, _moment2.default)(val, 'LT');
	      if (!parsed.isValid()) return;
	      var hours = parsed.hours();
	      var minutes = parsed.minutes();
	      this.form.fromTime = (0, _moment2.default)(this.form.fromTime).set({ hour: hours, minute: minutes });
	    },
	    onEndTimeInput: function onEndTimeInput(val) {
	      var parsed = (0, _moment2.default)(val, 'LT');
	      if (!parsed.isValid()) return;
	      var hours = parsed.hours();
	      var minutes = parsed.minutes();
	      this.form.toTime = (0, _moment2.default)(this.form.toTime).set({ hour: hours, minute: minutes });
	    },
	    setSelectedKlasses: function setSelectedKlasses(klasses) {
	      this.form.klassCalendarIds = klasses.map(function (k) {
	        return k.id;
	      });
	    },
	    setSelectedUsers: function setSelectedUsers(users) {
	      var _this6 = this;
	
	      var newIds = users.map(function (u) {
	        return u.id;
	      });
	      var newExistingHours = {};
	      newIds.forEach(function (id) {
	        newExistingHours[id] = _this6.form.existingHours[id] || 0;
	      });
	      this.form.userCalendarIds = newIds;
	      this.form.existingHours = newExistingHours;
	      this.fetchScheduledHours();
	    },
	    fetchScheduledHours: function fetchScheduledHours() {
	      var _this7 = this;
	
	      var start = (0, _moment2.default)(this.form.fromTime).format('YYYY-MM-DD');
	      var end = (0, _moment2.default)(this.form.toTime).format('YYYY-MM-DD');
	      this.form.userCalendarIds.forEach(function (calendarId) {
	        _docendo2.default.hoursCountForCalendar(_this7.schoolId, calendarId, start, end, function (response) {
	          var rows = JSON.parse(response);
	          var totalRow = rows.find(function (row) {
	            return row[0] === null && row[1] === null && row[2] === null;
	          });
	          var totalMinutes = totalRow && totalRow[3] ? totalRow[3] : 0;
	
	          var campTitle = _this7.form.title;
	          var campRow = campTitle ? rows.find(function (row) {
	            return row[0] === 'teaching' && row[1] === 'activity' && row[2] === campTitle;
	          }) : null;
	          var campMinutes = campRow && campRow[3] ? campRow[3] : 0;
	
	          _this7.$set(_this7.scheduledHours, calendarId, totalMinutes - campMinutes);
	        }, function () {
	          _this7.$set(_this7.scheduledHours, calendarId, 0);
	        });
	      });
	    },
	    formatMinutesToHours: function formatMinutesToHours(minutes) {
	      if (!minutes) return '0';
	      var hours = Math.round(minutes / 60 * 100) / 100;
	      return hours;
	    },
	    saveCamp: function saveCamp() {
	      var _this8 = this;
	
	      if (this.isSaving) return;
	      this.isSaving = true;
	
	      var fromTime = (0, _moment2.default)(this.form.fromTime).format('YYYY-MM-DD HH:mm');
	      var toTime = (0, _moment2.default)(this.form.toTime).format('YYYY-MM-DD HH:mm');
	      var calendarIds = this.form.klassCalendarIds.concat(this.form.userCalendarIds);
	      var existingHours = (0, _keys2.default)(this.form.existingHours).map(function (id) {
	        return { calendar_id: parseInt(id), hours: _this8.form.existingHours[id] || 0 };
	      });
	
	      if (this.theEditCamp) {
	        _docendo2.default.schoolCampsUpdate(this.schoolId, this.theEditCamp.id, this.activeSchoolYear.id, fromTime, toTime, this.form.title, calendarIds, existingHours, this.form.useAdditionalTasks, function () {
	          _eventbus2.default.toast = { text: _this8.i18n[_this8.locale].updated, success: true };
	          _this8.isSaving = false;
	          _this8.closeModal();
	          _this8.readCamps();
	          _this8.$store.dispatch('readSubjects', _this8.activeSchoolYear.id);
	        }, function () {
	          _eventbus2.default.toast = { text: _this8.i18n[_this8.locale].something_went_wrong, success: false };
	          _this8.isSaving = false;
	        });
	      } else {
	        _docendo2.default.schoolCampsCreate(this.schoolId, this.activeSchoolYear.id, fromTime, toTime, this.form.title, calendarIds, existingHours, this.form.useAdditionalTasks, function () {
	          _eventbus2.default.toast = { text: _this8.i18n[_this8.locale].created, success: true };
	          _this8.isSaving = false;
	          _this8.closeModal();
	          _this8.readCamps();
	          _this8.$store.dispatch('readSubjects', _this8.activeSchoolYear.id);
	          _this8.$store.dispatch('trackEvent', 'subjectsDistribution_camp_created');
	        }, function () {
	          _eventbus2.default.toast = { text: _this8.i18n[_this8.locale].something_went_wrong, success: false };
	          _this8.isSaving = false;
	        });
	      }
	    },
	    deleteCamp: function deleteCamp() {
	      var _this9 = this;
	
	      if (this.isDeleting || !this.theDeleteCamp) return;
	      this.isDeleting = true;
	      var campToDelete = this.theDeleteCamp;
	      _docendo2.default.schoolCampsDelete(this.schoolId, this.activeSchoolYear.id, campToDelete.id, function () {
	        _eventbus2.default.toast = { text: _this9.i18n[_this9.locale].deleted, success: true };
	        _this9.isDeleting = false;
	        _this9.theDeleteCamp = null;
	        if (_this9.theEditCamp && _this9.theEditCamp.id === campToDelete.id) {
	          _this9.closeModal();
	        }
	        _this9.readCamps();
	        _this9.$store.dispatch('readSubjects', _this9.activeSchoolYear.id);
	      }, function () {
	        _eventbus2.default.toast = { text: _this9.i18n[_this9.locale].something_went_wrong, success: false };
	        _this9.isDeleting = false;
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readCamps();
	  }
	};

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(35);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(50);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _getIterator2 = __webpack_require__(45);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _set = __webpack_require__(27);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _SubjectForm = __webpack_require__(70);
	
	var _SubjectForm2 = _interopRequireDefault(_SubjectForm);
	
	var _TaggingFilter = __webpack_require__(43);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	var _Spinner = __webpack_require__(26);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _SubjectsDistributionTasks = __webpack_require__(392);
	
	var _SubjectsDistributionTasks2 = _interopRequireDefault(_SubjectsDistributionTasks);
	
	var _SubjectsDistributionTasksFromSubjects = __webpack_require__(1627);
	
	var _SubjectsDistributionTasksFromSubjects2 = _interopRequireDefault(_SubjectsDistributionTasksFromSubjects);
	
	var _SubjectsDistributionUser = __webpack_require__(394);
	
	var _SubjectsDistributionUser2 = _interopRequireDefault(_SubjectsDistributionUser);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _SubjectsDistributionPrint = __webpack_require__(1625);
	
	var _SubjectsDistributionPrint2 = _interopRequireDefault(_SubjectsDistributionPrint);
	
	var _SubjectsDistributionTasksCreate = __webpack_require__(146);
	
	var _SubjectsDistributionTasksCreate2 = _interopRequireDefault(_SubjectsDistributionTasksCreate);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _DoFiltersPopover = __webpack_require__(1499);
	
	var _DoFiltersPopover2 = _interopRequireDefault(_DoFiltersPopover);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DoButtonAndDate = __webpack_require__(1695);
	
	var _DoButtonAndDate2 = _interopRequireDefault(_DoButtonAndDate);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _Banner = __webpack_require__(409);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _SubjectsDistributionTable = __webpack_require__(1626);
	
	var _SubjectsDistributionTable2 = _interopRequireDefault(_SubjectsDistributionTable);
	
	var _SchoolCamps = __webpack_require__(1623);
	
	var _SchoolCamps2 = _interopRequireDefault(_SchoolCamps);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _ZenExport = __webpack_require__(1689);
	
	var _ZenExport2 = _interopRequireDefault(_ZenExport);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _UserOverviewTabs = __webpack_require__(403);
	
	var _UserOverviewTabs2 = _interopRequireDefault(_UserOverviewTabs);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    name: 'Navn',
	    subjects_for_teachers: 'Fagfordeling',
	    filter_users: 'Grupper',
	    teaching_hours_from_subjects: 'UV-TID FRA FAG',
	    created_subject: 'Oprettede faget',
	    klass: 'Klasse',
	    subjects: 'Fag',
	    teaching_hours: 'UV tid',
	    no_subjects_assigned: 'Ingen fag tildelt',
	    assigned: 'Tildelt',
	    from_subjects: 'Fra fag',
	    difference: 'Diff',
	    only_subjects_without_teachers: 'Vis fag uden underviser',
	    only_subjects_with_teachers: 'Vis fag med underviser',
	    only_subjects_with_teacher_pool: 'Vis fag med lærerpuljer',
	    hours_in_school_year: 'Timer i skoleåret',
	    export_to_zen: 'Overfør til automatisk skemalægning',
	    go_to_zen: 'Gå til automatisk skemalægning',
	    automatic_scheduling: 'Automatisk skemalægning',
	    transfer_subjects_to_zen: 'Overfør brikker til automatisk skemalægning',
	    exported_to_zen: 'Data overført til Docendo ZEN',
	    something_went_wrong: 'Noget gik galt',
	    choose_grades: 'Vælg klasser',
	    grades: 'Klasser',
	    only_show_users_with_uv_time: 'Vis kun brugere med tildelt UV tid',
	    tasks: 'Opgaver',
	    no_users_matches: 'Ingen brugere matcher dine filtre',
	    print: 'Print opgaveoversigter',
	    only_subjects_with_requests: 'Vis kun fag med ønsker',
	    subjects_status: 'Status',
	    camps: 'Lejrskole',
	    persons: 'Personer',
	    no_klasses_matches: 'Ingen klasser matcher dine filtre',
	    filter_by_status: 'Vis brikker der opfylder ét eller flere af følgende kriterier',
	    filter_by_grades: 'Vis kun disse klasser',
	    filter_by_subjects: 'Vis kun disse fag',
	    filter_by_type: 'Vis kun brikker af disse typer',
	    filter_by_persons: 'Vis kun brikker hvor disse personer står på',
	    tooltip_teachers: 'Undervisere',
	    tooltip_rooms: 'Lokaler',
	    tooltip_klasses: 'Klasser'
	  },
	  en: {
	    subjects_status: 'Status',
	    name: 'name',
	    subjects_for_teachers: 'Teacher-subject allocation',
	    filter_users: ' Filter users by groups',
	    teaching_hours_from_subjects: 'Annual instruction time from subjects',
	    created_subject: 'Created subject',
	    klass: 'Class',
	    subjects: 'Subjects',
	    teaching_hours: 'Instruction time',
	    no_subjects_assigned: 'No subjects allocated',
	    assigned: 'Allocated',
	    from_subjects: 'From subjects',
	    difference: 'Diff',
	    only_subjects_without_teachers: 'Show only subjects without teachers',
	    only_subjects_with_teachers: 'Show subjects without teachers',
	    only_subjects_with_teacher_pool: 'Show subjects with teacher pools',
	    hours_in_school_year: 'Annual Instruction Time',
	    export_to_zen: 'Export to automatic scheduling',
	    go_to_zen: 'Go to automatic scheduling',
	    automatic_scheduling: 'Automatic scheduling',
	    transfer_subjects_to_zen: 'Transfer subjects to automatic scheduling',
	    exported_to_zen: 'Data is ready in Docendo ZEN',
	    something_went_wrong: 'Something went wrong',
	    choose_grades: 'Choose grades/groups',
	    grades: 'Grades/groups',
	    only_show_users_with_uv_time: 'Only show user with assigned teaching hours',
	    tasks: 'Tasks',
	    no_users_matches: 'No users matches',
	    print: 'Print',
	    only_subjects_with_requests: 'Show only subjects with requests',
	    camps: 'School camps',
	    persons: 'People',
	    no_klasses_matches: 'No grades/groups match your filters',
	    filter_by_status: 'Show subjects that meet one or more of the following criteria',
	    filter_by_grades: 'Only show these grades/groups',
	    filter_by_subjects: 'Only show these subjects',
	    filter_by_type: 'Only show subjects of these types',
	    filter_by_persons: 'Only show subjects assigned to these people',
	    tooltip_teachers: 'Teachers',
	    tooltip_rooms: 'Rooms',
	    tooltip_klasses: 'Grades/groups'
	  },
	  nb: {
	    subjects_status: 'Status',
	    name: 'Navn',
	    subjects_for_teachers: 'Fag- og lærerfordeling',
	    filter_users: ' Filtrer etter gruppe',
	    teaching_hours_from_subjects: 'Årstimetall',
	    created_subject: 'Opprettet faget',
	    klass: 'Klasse',
	    subjects: 'Fag',
	    teaching_hours: 'Timetall',
	    no_subjects_assigned: 'Ingen fag tildelt',
	    assigned: 'Tildelt',
	    from_subjects: 'Fra fag',
	    difference: 'Diff',
	    only_subjects_without_teachers: 'Vis kun fag uten underviser',
	    only_subjects_with_teachers: 'Vis fag uten underviser',
	    only_subjects_with_teacher_pool: 'Vis fag med lærerpuljer',
	    hours_in_school_year: 'Timer i skoleåret',
	    export_to_zen: 'Overfør for automatisk timeplanlegging',
	    go_to_zen: 'Gå til automatisk timeplanlegging',
	    automatic_scheduling: 'Automatisk timeplanlegging',
	    transfer_subjects_to_zen: 'Overfør brikker til automatisk timeplanlegging',
	    exported_to_zen: 'Data is ready in Docendo ZEN',
	    something_went_wrong: 'Something went wrong',
	    choose_grades: 'Velg klasser',
	    grades: 'Klasser',
	    only_show_users_with_uv_time: 'Vis kun brukere med tildelt undervisning',
	    tasks: 'Oppgaver',
	    no_users_matches: 'Ingen brukere passer til søket',
	    print: 'Skriv ut',
	    only_subjects_with_requests: 'Vis kun fag med ønsker',
	    camps: 'Leirskole',
	    persons: 'Personer',
	    no_klasses_matches: 'Ingen klasser passer til filtrene',
	    filter_by_status: 'Vis brikker som oppfyller ett eller flere av følgende kriterier',
	    filter_by_grades: 'Vis kun disse klassene',
	    filter_by_subjects: 'Vis kun disse fagene',
	    filter_by_type: 'Vis kun brikker av disse typene',
	    filter_by_persons: 'Vis kun brikker hvor disse personene står på',
	    tooltip_teachers: 'Lærere',
	    tooltip_rooms: 'Lokaler',
	    tooltip_klasses: 'Klasser'
	  }
	};
	
	exports.default = {
	  components: {
	    Tabs: _Tabs2.default,
	    DoButtonAndDate: _DoButtonAndDate2.default,
	    DateSelector: _DateSelector2.default,
	    DoFiltersFilter: _DoFiltersFilter2.default,
	    DoFiltersPopover: _DoFiltersPopover2.default,
	    Loader: _Loader2.default,
	    AppToggle: _AppToggle2.default,
	    ModalConfirmation: _ModalConfirmation2.default,
	    ChangeSchoolYear: _ChangeSchoolYear2.default,
	    SubjectForm: _SubjectForm2.default,
	    TaggingFilter: _TaggingFilter2.default,
	    Spinner: _Spinner2.default,
	    SubjectsDistributionTasks: _SubjectsDistributionTasks2.default,
	    SubjectsDistributionTasksFromSubjects: _SubjectsDistributionTasksFromSubjects2.default,
	    SubjectsDistributionUser: _SubjectsDistributionUser2.default,
	    SubjectDistributionPrint: _SubjectsDistributionPrint2.default,
	    SubjectsDistributionTasksCreate: _SubjectsDistributionTasksCreate2.default,
	    DModal: _DModal2.default,
	    Banner: _Banner2.default,
	    SubjectsDistributionTable: _SubjectsDistributionTable2.default,
	    SchoolCamps: _SchoolCamps2.default,
	    DDropdown: _DDropdown2.default,
	    ZenExport: _ZenExport2.default,
	    DatePickerRange: _DatePickerRange2.default,
	    UserOverviewTabs: _UserOverviewTabs2.default
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear(val) {
	      this.readAssignedHours();
	      this.$store.dispatch('readSubjects', this.activeSchoolYear.id);
	      this.setSubjectsRequestEndDate(this.activeSchoolYear);
	      this.readSubjectRequests();
	    },
	    onlyShowSubjectsWithoutTeacherI18n: function onlyShowSubjectsWithoutTeacherI18n() {
	      if (!this.isShowSubjectsWithoutTeachers) {
	        this.selectedSubjectStatusFilters.push(this.onlyShowSubjectsWithoutTeacherI18n);
	      }
	    },
	    viewMode: function viewMode(val) {
	      this.$helpers.setLocalStorage('doSubjectsDistributionViewMode', val);
	    },
	    showLessonsPerWeek: function showLessonsPerWeek(val) {
	      this.$helpers.setLocalStorage('doSubjectsDistributionShowLessonsPerWeek', val);
	    },
	    showActivities: function showActivities(val) {
	      this.$helpers.setLocalStorage('doSubjectsDistributionShowActivities', val);
	    },
	    showSubjectsRequestInTable: function showSubjectsRequestInTable(val) {
	      this.$helpers.setLocalStorage('doSubjectsDistributionShowSubjectsRequest', val);
	    },
	    showDatesInTable: function showDatesInTable(val) {
	      this.$helpers.setLocalStorage('doSubjectsDistributionShowDatesInTable', val);
	    }
	  },
	  data: function data() {
	    return {
	      subjectSearchQuery: '',
	      selectedSubjectStatusFilters: [],
	      sortBy: 'name',
	      sortOrder: -1,
	      isShowOnlyTeacherWithTeachingTime: false,
	      isPrintUsers: false,
	      editSubject: null,
	      editSubjectPoolCalendarId: null,
	      theEditTask: null,
	      theUserToShowTasks: null,
	      isSubjectModal: false,
	      activeUserId: null,
	      selectedKlassFilters: [],
	      activeView: 'subjects',
	      theZENToken: '',
	      subjectsRequestEndDate: null,
	      isUpdatingSchoolYear: false,
	      isSubjectLoading: false,
	      selectedSubjectFilters: [],
	      selectedTypeFilters: [],
	      selectedPersonFilters: [],
	      groupTags: [],
	      showLessonsPerWeek: false,
	      showActivities: false,
	      showSubjectsRequestInTable: false,
	      showDatesInTable: false,
	      viewMode: 'tiles',
	      isDownloadingExcel: false,
	      isPrintingTable: false,
	      isZenExportModal: false,
	      isEditingDates: false,
	      selectedSubjectIds: [],
	      bulkFromDate: null,
	      bulkToDate: null,
	      isSavingBulkDates: false
	    };
	  },
	
	  computed: {
	    isLessonsPerWeekActive: function isLessonsPerWeekActive() {
	      return this.isSchoolDanish && this.showLessonsPerWeek;
	    },
	    subjectDefaultDuration: function subjectDefaultDuration() {
	      return this.school && this.school.subject_default_duration ? this.school.subject_default_duration : 45;
	    },
	    noActiveSchoolYears: function noActiveSchoolYears() {
	      return this.$store.state.noActiveSchoolYears;
	    },
	    viewTabs: function viewTabs() {
	      var tabs = [{ id: 'subjects', title: this.i18n[this.locale].subjects }];
	      if (this.useTasksFromSubjects) {
	        tabs.push({ id: 'tasks_new', title: this.i18n[this.locale].tasks });
	      } else {
	        tabs.push({ id: 'tasks', title: this.i18n[this.locale].tasks });
	      }
	      if (this.isSchoolDanish) {
	        tabs.push({ id: 'camps', title: this.i18n[this.locale].camps });
	      }
	      return tabs;
	    },
	    selectedViewTabId: function selectedViewTabId() {
	      return this.activeView;
	    },
	    isTasksView: function isTasksView() {
	      return this.activeView === 'tasks';
	    },
	    isTasksNewView: function isTasksNewView() {
	      return this.activeView === 'tasks_new';
	    },
	    useTasksFromSubjects: function useTasksFromSubjects() {
	      return true;
	    },
	    isTableView: function isTableView() {
	      return this.viewMode === 'table';
	    },
	    isCampsView: function isCampsView() {
	      return this.activeView === 'camps';
	    },
	    subjectStatusFilters: function subjectStatusFilters() {
	      return [this.onlyShowSubjectsWithoutTeacherI18n, this.onlyShowSubjectsWithRequestsI18n, this.onlyShowSubjectsWithTeacherI18n, this.onlyShowSubjectsWithTeacherPoolI18n];
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolCountry: function schoolCountry() {
	      return this.school && this.school.country ? this.school.country : 'NO';
	    },
	    isSchoolDanish: function isSchoolDanish() {
	      return this.schoolCountry.toUpperCase() === 'DK';
	    },
	    poolSubjectTypeLabel: function poolSubjectTypeLabel() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || 'Lokalpulje';
	    },
	    isShowSubjectsRequest: function isShowSubjectsRequest() {
	      return this.isSchoolDanish && this.userHasPermission('can_see_other_subject_requests');
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    userCanManageSchool: function userCanManageSchool() {
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions && this.userPermissions.indexOf('can_manage_school') > -1 || this.user && this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    zenUrl: function zenUrl() {
	      var startURL = 'https://zen.docendo.co/jwt_signin/?jwt=';
	      if (this.locale === 'da') {
	        startURL = 'https://zen.docendo.co/da/jwt_signin/?jwt=';
	      }
	      if (this.locale === 'nb') {
	        startURL = 'https://zen.docendo.co/nb/jwt_signin/?jwt=';
	      }
	
	      var schoolUuid = this.school && this.school.uuid ? this.school.uuid : null;
	      var url = startURL + this.theZENToken;
	      url += '&domain=' + encodeURIComponent(window.location.hostname);
	      if (schoolUuid) {
	        url += '&school_uuid=' + schoolUuid;
	      }
	
	      return url;
	    },
	    isConfirmDeletion: function isConfirmDeletion() {
	      return this.$store.state.subjects.isConfirmDeletion;
	    },
	    itemToDelete: function itemToDelete() {
	      return this.$store.state.subjects.itemToDelete;
	    },
	    klassTags: function klassTags() {
	      return this.klassCalendars.map(function (calendar) {
	        return calendar.name;
	      });
	    },
	    uniqueSubjects: function uniqueSubjects() {
	      var names = new _set2.default();
	      var cals = this.calsWithProps;
	      for (var i = 0; i < cals.length; i++) {
	        var subjects = cals[i].vSubjects;
	        for (var j = 0; j < subjects.length; j++) {
	          if (subjects[j].name) names.add(subjects[j].name);
	        }
	      }
	      return [].concat((0, _toConsumableArray3.default)(names));
	    },
	    uniquePersons: function uniquePersons() {
	      var names = new _set2.default();
	      var cals = this.calsWithProps;
	      for (var i = 0; i < cals.length; i++) {
	        var subjects = cals[i].vSubjects;
	        for (var j = 0; j < subjects.length; j++) {
	          subjects[j].vUserNames.forEach(function (name) {
	            return names.add(name);
	          });
	        }
	      }
	      return [].concat((0, _toConsumableArray3.default)(names));
	    },
	    allSelectedFiltersCount: function allSelectedFiltersCount() {
	      return this.selectedKlassFilters.length + this.selectedSubjectStatusFilters.length + this.selectedSubjectFilters.length + this.selectedTypeFilters.length + this.selectedPersonFilters.length;
	    },
	    uniqueSubjectTypeLabels: function uniqueSubjectTypeLabels() {
	      var typeLabels = {
	        subject: 'Fag',
	        activity: 'Aktivitet',
	        available: 'Rådighedstime',
	        person_resource: 'Ressource',
	        person_resource_visible: 'Ressource (synlig)',
	        resource: 'Ressource',
	        additional_tasks: 'Øvrige opgaver',
	        preparation: 'Forberedelse',
	        pool: this.poolSubjectTypeLabel,
	        club: 'SFO',
	        without_kids: 'Uden børn',
	        frame: 'Temavisning',
	        optional: 'Valgfag/Hold',
	        supplemental: 'UUV',
	        break: 'Pause'
	      };
	      var labels = new _set2.default();
	      var cals = this.calsWithProps;
	      for (var i = 0; i < cals.length; i++) {
	        var subjects = cals[i].vSubjects;
	        for (var j = 0; j < subjects.length; j++) {
	          var type = subjects[j].subject_type;
	          if (type && type !== 'frame') {
	            if (type === 'activity' && !this.showActivities) continue;
	            var label = typeLabels[type] || type;
	            labels.add(label);
	          }
	        }
	      }
	      return [].concat((0, _toConsumableArray3.default)(labels)).sort(function (a, b) {
	        return a.localeCompare(b, 'da');
	      });
	    },
	    showTeacherPoolHours: function showTeacherPoolHours() {
	      return this.selectedSubjectStatusFilters.indexOf(this.onlyShowSubjectsWithTeacherPoolI18n) > -1;
	    },
	    klassSubjects: function klassSubjects() {
	      var _this = this;
	
	      var map = {};
	      var calendarsHash = this.allCalendarsInHash;
	      var subjectsHash = this.subjectsInHash;
	      var requestsHash = this.subjectsRequestsInHash;
	      var usersInCalHash = this.$store.getters.allUsersInCalIdHash;
	      var shouldExcludeTypes = !this.doesRessCountInKlassTotalHours;
	      var excludedTypes = ['resource', 'person_resource_visible'];
	      var translations = I18N[this.locale] || I18N.en;
	
	      var getExplicitTeacherPoolHours = function getExplicitTeacherPoolHours(subject, calId) {
	        if (Array.isArray(subject.subject_calendars)) {
	          var match = subject.subject_calendars.find(function (sc) {
	            return sc && sc.calendar_id === calId && sc.hours != null;
	          });
	          if (match) {
	            var parsed = parseFloat(match.hours);
	            return isNaN(parsed) ? null : parsed;
	          }
	        }
	        var userId = usersInCalHash[calId] && usersInCalHash[calId].id;
	        if (userId && Array.isArray(subject.teachers)) {
	          var teacher = subject.teachers.find(function (t) {
	            return t && t.user_id === userId && t.hours != null;
	          });
	          if (teacher) {
	            var _parsed = parseFloat(teacher.hours);
	            return isNaN(_parsed) ? null : _parsed;
	          }
	        }
	        return null;
	      };
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        var _loop = function _loop() {
	          var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
	              klassId = _step$value[0],
	              subjectIds = _step$value[1];
	
	          var klassIdInt = parseInt(klassId);
	          var subjects = [];
	          var totalHours = 0;
	          var hasReductions = false;
	
	          var _loop2 = function _loop2(i) {
	            var subjectId = subjectIds[i];
	            var subject = subjectsHash[subjectId];
	            if (!subject) return 'continue';
	
	            var calendarHours = null;
	            if (subject.subject_calendars) {
	              var match = subject.subject_calendars.find(function (sc) {
	                return sc.calendar_id === klassIdInt;
	              });
	              if (match) {
	                calendarHours = parseFloat(match.hours);
	              }
	            }
	
	            var fallbackHours = parseFloat(subject.hours);
	            var vHours = isNaN(calendarHours) ? fallbackHours : calendarHours;
	
	            if (!isNaN(calendarHours) && calendarHours !== fallbackHours) {
	              hasReductions = true;
	            }
	
	            if (subject.subject_type === 'frame') return 'continue';
	
	            if (!shouldExcludeTypes || excludedTypes.indexOf(subject.subject_type) < 0) {
	              totalHours += isNaN(vHours) ? 0 : vHours;
	            }
	
	            var calIds = subject.calendar_ids || [];
	            var hasTeachers = false;
	            var hasRooms = false;
	            var userNames = [];
	            var roomNames = [];
	            var teachersWithPool = [];
	            var otherKlasses = [];
	
	            for (var j = 0; j < calIds.length; j++) {
	              var cal = calendarsHash[calIds[j]];
	              if (!cal) continue;
	              if (cal.type === 'user') {
	                hasTeachers = true;
	                if (cal.name) {
	                  userNames.push(cal.name);
	                  teachersWithPool.push({
	                    name: cal.name,
	                    hours: getExplicitTeacherPoolHours(subject, calIds[j])
	                  });
	                }
	              }
	              if (cal.type === 'room') {
	                hasRooms = true;
	                if (cal.name) roomNames.push(cal.name);
	              }
	              if (cal.type === 'klass' && parseInt(calIds[j]) !== klassIdInt) {
	                otherKlasses.push(cal.name || '');
	              }
	            }
	
	            var tooltip = [[translations.tooltip_teachers, userNames], [translations.tooltip_rooms, roomNames], [translations.tooltip_klasses, otherKlasses.filter(Boolean)]].filter(function (line) {
	              return line[1].length > 0;
	            }).map(function (line) {
	              return '<b>' + line[0] + ':</b> ' + line[1].map(_this.escapeHtml).join(', ');
	            }).join('<br>');
	
	            var remainingHours = null;
	            if (Array.isArray(subject.subject_calendars) && subject.cals) {
	              var distributedSum = 0;
	              var userCalCount = 0;
	              var allUsersHaveExplicitHours = true;
	              subject.subject_calendars.forEach(function (sc) {
	                var cal = subject.cals.find(function (c) {
	                  return c.id === sc.calendar_id;
	                });
	                if (cal && cal.calendar_type === 'user') {
	                  userCalCount++;
	                  if (sc.hours != null) {
	                    distributedSum += parseFloat(sc.hours) || 0;
	                  } else {
	                    allUsersHaveExplicitHours = false;
	                  }
	                }
	              });
	              if (userCalCount > 0 && allUsersHaveExplicitHours) {
	                var total = parseFloat(subject.hours) || 0;
	                var diff = total - distributedSum;
	                if (diff > 0) {
	                  remainingHours = diff;
	                }
	              }
	            }
	
	            var requestedCalIds = requestsHash[subjectId] || [];
	            var vRequestedBy = requestedCalIds.filter(function (calId) {
	              return calId !== _this.userCalendarId && calendarsHash[calId];
	            }).map(function (calId) {
	              return calendarsHash[calId] ? calendarsHash[calId].name : '';
	            });
	
	            var hasTeacherPool = false;
	            if (Array.isArray(subject.teachers) && subject.teachers.some(function (teacher) {
	              return teacher && teacher.hours != null;
	            })) {
	              hasTeacherPool = true;
	            } else if (Array.isArray(subject.subject_calendars) && Array.isArray(subject.cals)) {
	              hasTeacherPool = subject.subject_calendars.some(function (sc) {
	                if (!sc || sc.hours == null) return false;
	                var cal = subject.cals.find(function (c) {
	                  return c && c.id === sc.calendar_id;
	                });
	                return cal && cal.calendar_type === 'user';
	              });
	            }
	
	            subjects.push((0, _extends3.default)({}, subject, {
	              vRequestedBy: vRequestedBy,
	              vHasTeachers: hasTeachers,
	              vHasRooms: hasRooms,
	              vUserNames: userNames,
	              vTooltip: tooltip,
	              vTeachersWithPool: teachersWithPool,
	              v_subjectOtherKlasses: otherKlasses,
	              vHours: vHours,
	              vLessonsPerWeek: _this.calcLessonsPerWeek(subject.hours),
	              vRemainingHours: remainingHours,
	              vRemainingLessonsPerWeek: remainingHours != null ? _this.calcLessonsPerWeek(remainingHours) : '0.0',
	              vIsPartiallyDistributed: remainingHours != null && remainingHours > 0,
	              vHasTeacherPool: hasTeacherPool
	            }));
	          };
	
	          for (var i = 0; i < subjectIds.length; i++) {
	            var _ret2 = _loop2(i);
	
	            if (_ret2 === 'continue') continue;
	          }
	
	          map[klassId] = { subjects: subjects, totalHours: totalHours, hasReductions: hasReductions };
	        };
	
	        for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(this.subjectsInKlassHash)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          _loop();
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return map;
	    },
	    calsWithProps: function calsWithProps() {
	      var _this2 = this;
	
	      return this.klassCalendars.map(function (klass) {
	        var data = _this2.klassSubjects[klass.id];
	        return (0, _extends3.default)({}, klass, {
	          vTotalHours: data ? data.totalHours.toFixed(2) : '0.00',
	          vHasReductions: data ? data.hasReductions : false,
	          vSubjects: data ? data.subjects : []
	        });
	      });
	    },
	    filteredKlassCals: function filteredKlassCals() {
	      var _this3 = this;
	
	      var klasses = this.calsWithProps;
	
	      if (this.selectedKlassFilters.length > 0) {
	        klasses = klasses.filter(function (klass) {
	          return _this3.selectedKlassFilters.includes(klass.name);
	        });
	      }
	
	      var hasStatusFilters = this.selectedSubjectStatusFilters.length > 0;
	      var hasSubjectFilters = this.selectedSubjectFilters.length > 0;
	      var hasTypeFilters = this.selectedTypeFilters.length > 0;
	      var hasPersonFilters = this.selectedPersonFilters.length > 0;
	      var hasSubjectLevelFilters = hasStatusFilters || hasSubjectFilters || hasTypeFilters || hasPersonFilters || !!this.subjectSearchQuery;
	      var typeLabelsMap = {
	        subject: 'Fag',
	        activity: 'Aktivitet',
	        available: 'Rådighedstime',
	        person_resource: 'Ressource',
	        person_resource_visible: 'Ressource (synlig)',
	        resource: 'Ressource',
	        additional_tasks: 'Øvrige opgaver',
	        preparation: 'Forberedelse',
	        pool: this.poolSubjectTypeLabel,
	        club: 'SFO',
	        without_kids: 'Uden børn',
	        frame: 'Temavisning',
	        optional: 'Valgfag/Hold',
	        supplemental: 'UUV',
	        break: 'Pause'
	      };
	
	      return klasses.map(function (klass) {
	        return (0, _extends3.default)({}, klass, {
	          vSubjects: klass.vSubjects.filter(function (subject) {
	            if (subject.subject_type === 'activity' && !_this3.showActivities) return false;
	
	            var hasFilterWithoutTeacher = _this3.selectedSubjectStatusFilters.includes(_this3.onlyShowSubjectsWithoutTeacherI18n);
	            var hasFilterWithTeacher = _this3.selectedSubjectStatusFilters.includes(_this3.onlyShowSubjectsWithTeacherI18n);
	            var hasFilterWithRequests = _this3.selectedSubjectStatusFilters.includes(_this3.onlyShowSubjectsWithRequestsI18n);
	            var hasFilterWithTeacherPool = _this3.selectedSubjectStatusFilters.includes(_this3.onlyShowSubjectsWithTeacherPoolI18n);
	
	            var matchesStatusFilter = !hasStatusFilters || hasFilterWithoutTeacher && (!subject.vHasTeachers || subject.vIsPartiallyDistributed) || hasFilterWithTeacher && subject.vHasTeachers || hasFilterWithRequests && subject.vRequestedBy.length > 0 || hasFilterWithTeacherPool && subject.vHasTeacherPool;
	
	            var subjectName = subject.name ? subject.name.toLowerCase() : '';
	            var matchesSearch = !_this3.subjectSearchQuery || subjectName.includes(_this3.subjectSearchQuery.toLowerCase());
	
	            var matchesSubjectFilter = !hasSubjectFilters || _this3.selectedSubjectFilters.includes(subject.name);
	
	            var typeLabel = typeLabelsMap[subject.subject_type] || subject.subject_type || '';
	            var matchesTypeFilter = !hasTypeFilters || _this3.selectedTypeFilters.includes(typeLabel);
	
	            var matchesPersonFilter = !hasPersonFilters || subject.vUserNames.some(function (name) {
	              return _this3.selectedPersonFilters.includes(name);
	            });
	
	            return matchesStatusFilter && matchesSearch && matchesSubjectFilter && matchesTypeFilter && matchesPersonFilter;
	          }).sort(function (a, b) {
	            var nameA = (a.name || '').toLowerCase();
	            var nameB = (b.name || '').toLowerCase();
	            return nameA.localeCompare(nameB, 'da');
	          })
	        });
	      }).filter(function (klass) {
	        return !hasSubjectLevelFilters || klass.vSubjects.length > 0;
	      });
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.subjects.isLoading;
	    },
	    klassCalendars: function klassCalendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    usersAssignedHoursHash: function usersAssignedHoursHash() {
	      return this.$store.getters.usersAssignedHoursHash;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    allUsersInCalendarHash: function allUsersInCalendarHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    subjectsInKlassHash: function subjectsInKlassHash() {
	      return this.$store.getters.subjectsInKlassHash;
	    },
	    subjectsInUserHash: function subjectsInUserHash() {
	      return this.$store.getters.subjectsInUserHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    tasksInUserHash: function tasksInUserHash() {
	      return this.$store.getters.tasksInUserHash;
	    },
	    tasksInHash: function tasksInHash() {
	      return this.$store.getters.tasksInHash;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    usersFilteredWithTags: function usersFilteredWithTags() {
	      var _this4 = this;
	
	      var users = this.$store.getters.usersFilteredWithTags;
	      if (!this.isPoolsDeactivated && this.isShowOnlyTeacherWithTeachingTime) {
	        return users.filter(function (user) {
	          var userHours = _this4.usersAssignedHoursHash[user.id];
	          return userHours && userHours.assigned_teaching_hours;
	        });
	      }
	      return users;
	    },
	    userTeachingDiffMap: function userTeachingDiffMap() {
	      var map = {};
	      var usersHash = this.allUsersInHash;
	      var subjectsUserHash = this.subjectsInUserHash;
	      var subjectsHash = this.subjectsInHash;
	      var poolsDeactivated = this.isPoolsDeactivated;
	      var assignedHash = this.usersAssignedHoursHash;
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.usersFilteredWithTags), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var user = _step2.value;
	
	          var userCalId = usersHash[user.id] ? usersHash[user.id].user_calendar_id : null;
	          if (!userCalId) {
	            map[user.id] = '0.0';continue;
	          }
	
	          var total = 0;
	          var sIds = subjectsUserHash[userCalId];
	          if (sIds) {
	            for (var i = 0; i < sIds.length; i++) {
	              var s = subjectsHash[sIds[i]];
	              if (!s) continue;
	              total += this.getSubjectHours(s.id, userCalId);
	            }
	          }
	
	          var assigned = assignedHash[user.id] ? assignedHash[user.id].assigned_teaching_hours : 0;
	          var diff = !poolsDeactivated ? assigned - total : total;
	          map[user.id] = diff.toFixed(1);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return map;
	    },
	    userLessonsPerWeekMap: function userLessonsPerWeekMap() {
	      var map = {};
	      var usersHash = this.allUsersInHash;
	      var subjectsUserHash = this.subjectsInUserHash;
	      var subjectsHash = this.subjectsInHash;
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = (0, _getIterator3.default)(this.usersFilteredWithTags), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var user = _step3.value;
	
	          var userCalId = usersHash[user.id] ? usersHash[user.id].user_calendar_id : null;
	          if (!userCalId) {
	            map[user.id] = '0.0';continue;
	          }
	
	          var total = 0;
	          var sIds = subjectsUserHash[userCalId] || [];
	          for (var i = 0; i < sIds.length; i++) {
	            var s = subjectsHash[sIds[i]];
	            if (!s) continue;
	            var hours = this.getSubjectHoursForUser(s, userCalId);
	            total += parseFloat(this.calcLessonsPerWeek(hours));
	          }
	
	          map[user.id] = total.toFixed(1);
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      return map;
	    },
	    sortedUsersFilteredWithTags: function sortedUsersFilteredWithTags() {
	      var _this5 = this;
	
	      if (this.sortBy === 'name') {
	        return this.$helpers.sortArrOnName(this.usersFilteredWithTags);
	      }
	      var diffMap = this.userTeachingDiffMap;
	      return [].concat((0, _toConsumableArray3.default)(this.usersFilteredWithTags)).sort(function (a, b) {
	        return _this5.sortOrder < 0 ? diffMap[a.id] - diffMap[b.id] : diffMap[b.id] - diffMap[a.id];
	      });
	    },
	    selectedGroupTags: function selectedGroupTags() {
	      return this.$store.state.selectedTags || [];
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    isPoolsDeactivated: function isPoolsDeactivated() {
	      return this.schoolSettings && this.schoolSettings['deactivatePools'] ? this.schoolSettings['deactivatePools'] : false;
	    },
	    doesRessCountInKlassTotalHours: function doesRessCountInKlassTotalHours() {
	      return !this.schoolSettings.hasOwnProperty('hide_ressource_hours_count_in_total_hours_for_klasse');
	    },
	    subjectsRequestsInHash: function subjectsRequestsInHash() {
	      return this.$store.getters.subjectsRequestsInHash;
	    },
	    isShowSubjectsWithoutTeachers: function isShowSubjectsWithoutTeachers() {
	      return this.selectedSubjectStatusFilters.indexOf(this.onlyShowSubjectsWithoutTeacherI18n) > -1;
	    },
	    isShowSubjectsWithTeachers: function isShowSubjectsWithTeachers() {
	      return this.selectedSubjectStatusFilters.indexOf(this.onlyShowSubjectsWithTeacherI18n) > -1;
	    },
	    onlyShowSubjectsWithoutTeacherI18n: function onlyShowSubjectsWithoutTeacherI18n() {
	      return this.i18n[this.locale].only_subjects_without_teachers;
	    },
	    onlyShowSubjectsWithRequestsI18n: function onlyShowSubjectsWithRequestsI18n() {
	      return this.i18n[this.locale].only_subjects_with_requests;
	    },
	    onlyShowSubjectsWithTeacherI18n: function onlyShowSubjectsWithTeacherI18n() {
	      return this.i18n[this.locale].only_subjects_with_teachers;
	    },
	    onlyShowSubjectsWithTeacherPoolI18n: function onlyShowSubjectsWithTeacherPoolI18n() {
	      return this.i18n[this.locale].only_subjects_with_teacher_pool;
	    },
	    visibleSubjectIdsForBulk: function visibleSubjectIdsForBulk() {
	      var ids = new _set2.default();
	      this.filteredKlassCals.forEach(function (kc) {
	        kc.vSubjects.forEach(function (s) {
	          return ids.add(s.id);
	        });
	      });
	      return [].concat((0, _toConsumableArray3.default)(ids));
	    },
	    allVisibleSelected: function allVisibleSelected() {
	      var _this6 = this;
	
	      var visible = this.visibleSubjectIdsForBulk;
	      return visible.length > 0 && visible.every(function (id) {
	        return _this6.selectedSubjectIds.indexOf(id) >= 0;
	      });
	    },
	    bulkDateMin: function bulkDateMin() {
	      if (this.activeSchoolYear && this.activeSchoolYear.employee_time_start) {
	        return (0, _moment2.default)(this.activeSchoolYear.employee_time_start);
	      }
	      return null;
	    },
	    bulkDateMax: function bulkDateMax() {
	      if (this.activeSchoolYear && this.activeSchoolYear.employee_time_end) {
	        return (0, _moment2.default)(this.activeSchoolYear.employee_time_end);
	      }
	      return null;
	    }
	  },
	  methods: {
	    escapeHtml: function escapeHtml(str) {
	      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	    },
	    onSelectView: function onSelectView(tabId) {
	      this.activeView = tabId;
	    },
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions && this.userPermissions.indexOf(permission) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    getSubjectedRequestedBy: function getSubjectedRequestedBy(subjectId) {
	      var _this7 = this;
	
	      var currentCalendarIds = this.subjectsRequestsInHash[subjectId] || [];
	      return currentCalendarIds.filter(function (calId) {
	        return calId !== _this7.userCalendarId && _this7.allCalendarsInHash[calId];
	      }).map(function (calId) {
	        return _this7.allCalendarsInHash[calId] ? _this7.allCalendarsInHash[calId]['name'] : [];
	      });
	    },
	    setSubjectsRequestEndDate: function setSubjectsRequestEndDate(schoolYear) {
	      if (schoolYear && Object.prototype.hasOwnProperty.call(schoolYear, 'subject_request_end')) {
	        this.subjectsRequestEndDate = schoolYear.subject_request_end;
	      }
	    },
	    onSetSubjectsRequestEndDate: function onSetSubjectsRequestEndDate(date) {
	      var _this8 = this;
	
	      this.isUpdatingSchoolYear = true;
	      var dbDate = null;
	      if (date) {
	        dbDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      }
	      _docendo2.default.schoolYearsUpdate(this.schoolId, this.activeSchoolYear.id, { subject_request_end: dbDate }, function (success) {
	        _this8.isUpdatingSchoolYear = false;
	        _this8.setSubjectsRequestEndDate(success);
	        _this8.updateRORDOMAnnouncementBadge(dbDate);
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    updateRORDOMAnnouncementBadge: function updateRORDOMAnnouncementBadge(dbDate) {
	      var announcementEl = document.querySelector('.do-top-menu-announcement');
	      var navStart = document.querySelector('#nav-start');
	      var navEnd = document.querySelector('#nav-end');
	
	      if (!navStart || !navEnd) {
	        console.warn('Kunne ikke finde navigationselementerne i headeren.');
	        return;
	      }
	
	      if (dbDate && (0, _moment2.default)(dbDate).isBefore((0, _moment2.default)(), 'day')) {
	        if (announcementEl) {
	          announcementEl.remove();
	        }
	        return;
	      }
	
	      if (!dbDate) {
	        if (announcementEl) {
	          announcementEl.remove();
	        }
	        return;
	      }
	
	      if (!announcementEl) {
	        var newEl = document.createElement('div');
	        newEl.classList.add('do-top-menu-announcement');
	
	        var anchor = document.createElement('a');
	        anchor.href = '/schools/' + this.schoolId + '/subject_requests?school_year_id=' + this.activeSchoolYear.id;
	        anchor.innerHTML = 'Fag\xF8nsker er \xE5ben indtil <span data-date="' + dbDate + '">' + (0, _moment2.default)(dbDate).format('D. MMMM YYYY') + '</span>';
	
	        newEl.appendChild(anchor);
	
	        navStart.parentNode.insertBefore(newEl, navEnd);
	      } else {
	        var spanEl = announcementEl.querySelector('span[data-date]');
	        if (spanEl) {
	          spanEl.setAttribute('data-date', dbDate);
	          spanEl.textContent = (0, _moment2.default)(dbDate).format('D. MMMM YYYY');
	        }
	      }
	    },
	    readSubjectRequests: function readSubjectRequests() {
	      if (this.isShowSubjectsRequest && this.activeSchoolYear && this.activeSchoolYear.id) {
	        this.$store.dispatch('readSubjectRequests', this.activeSchoolYear.id);
	      }
	    },
	    calcLessonsPerWeek: function calcLessonsPerWeek(hours) {
	      return this.$helpers.calcLessonsPerWeek(hours, this.subjectDefaultDuration);
	    },
	    toggleDoesRessCount: function toggleDoesRessCount() {
	      if (!this.doesRessCountInKlassTotalHours) {
	        this.$store.dispatch('deleteSchoolSetting', 'hide_ressource_hours_count_in_total_hours_for_klasse');
	      } else {
	        this.$store.dispatch('updateSchoolSettings', { 'hide_ressource_hours_count_in_total_hours_for_klasse': true });
	      }
	    },
	    closeIsPrintUsers: function closeIsPrintUsers() {
	      this.isPrintUsers = false;
	      window.scrollTo(0, 0);
	    },
	    deleteSubject: function deleteSubject(editSubject) {
	      var deletedSubject = {
	        id: editSubject.id,
	        school_id: editSubject.school_id,
	        school_year_id: this.activeSchoolYear.id
	      };
	      deletedSubject['schoolYearId'] = this.activeSchoolYear.id;
	      this.$store.dispatch('deleteSubject', deletedSubject);
	      this.closeModal();
	    },
	    onZenExported: function onZenExported() {
	      this.isZenExportModal = false;
	    },
	    userHasAgreements: function userHasAgreements(userId) {
	      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].agreements;
	    },
	    setSortBy: function setSortBy(key) {
	      this.sortBy = key;
	      this.sortOrder = this.sortOrder * -1;
	    },
	    confirmDelete: function confirmDelete() {
	      if (this.itemToDelete && this.itemToDelete.itemType === 'task') {
	        this.$store.dispatch('deleteTask', this.itemToDelete);
	        this.$store.commit('setTheDeletedItemId', this.itemToDelete.id);
	      }
	      this.$store.commit('setConfirmDeletion', false);
	      this.$store.commit('setItemToDelete', null);
	    },
	    subjectHasTeachers: function subjectHasTeachers(subjectId) {
	      var _this9 = this;
	
	      var calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : [];
	      var hasTeachers = false;
	      calIds.forEach(function (calId) {
	        if (_this9.allCalendarsInHash[calId] && _this9.allCalendarsInHash[calId].type === 'user') {
	          hasTeachers = true;
	        }
	      });
	      return hasTeachers;
	    },
	    subjectHasRooms: function subjectHasRooms(subjectId) {
	      var _this10 = this;
	
	      var calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : [];
	      var hasRooms = false;
	      calIds.forEach(function (calId) {
	        if (_this10.allCalendarsInHash[calId] && _this10.allCalendarsInHash[calId].type === 'room') {
	          hasRooms = true;
	        }
	      });
	      return hasRooms;
	    },
	    getUserNames: function getUserNames(subjectId) {
	      var _this11 = this;
	
	      var calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : [];
	      if (!calIds || calIds.length < 1 || !calIds[0]) {
	        return '';
	      }
	      return calIds.filter(function (calId) {
	        return _this11.allCalendarsInHash[calId] && _this11.allCalendarsInHash[calId].type === 'user';
	      }).map(function (userCalId) {
	        return _this11.allCalendarsInHash[userCalId].name ? _this11.allCalendarsInHash[userCalId].name : '';
	      });
	    },
	    subjectHasOtherKlasses: function subjectHasOtherKlasses(subjectId, currentKlassId) {
	      var _this12 = this;
	
	      var calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : [];
	      var otherKlasses = [];
	      calIds.forEach(function (calId) {
	        if (_this12.allCalendarsInHash[calId] && _this12.allCalendarsInHash[calId].type === 'klass' && parseInt(calId) !== parseInt(currentKlassId)) {
	          if (_this12.allCalendarsInHash[calId].name) {
	            otherKlasses.push(_this12.allCalendarsInHash[calId].name);
	          } else {
	            otherKlasses.push('');
	          }
	        }
	      });
	      return otherKlasses;
	    },
	    subjectHasRoom: function subjectHasRoom(subjectId) {
	      var subject = this.subjectsInHash[subjectId];
	      return subject.rooms_calendar_ids && subject.rooms_calendar_ids.length > 0 && subject.rooms_calendar_ids[0];
	    },
	    updateLocalStorage: function updateLocalStorage(key, filters) {
	      var val = (0, _stringify2.default)(filters);
	      this.$helpers.setLocalStorage(key, val);
	    },
	    toggleFilter: function toggleFilter(filter, filterArray) {
	      var storageKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      if (filterArray.includes(filter)) {
	        filterArray.splice(filterArray.indexOf(filter), 1);
	      } else {
	        filterArray.push(filter);
	      }
	
	      if (storageKey) {
	        this.updateLocalStorage(storageKey, filterArray);
	      }
	    },
	    toggleKlassTag: function toggleKlassTag(tag) {
	      this.toggleFilter(tag, this.selectedKlassFilters, 'doSubjectsDistributionSubjectKlassFilters');
	    },
	    clearSelectedKlassFilters: function clearSelectedKlassFilters() {
	      this.selectedKlassFilters = [];
	      var storageKey = 'doSubjectsDistributionSubjectKlassFilters';
	      this.updateLocalStorage(storageKey, []);
	    },
	    toggleSelectedSubjectStatusFilters: function toggleSelectedSubjectStatusFilters(filter) {
	      this.toggleFilter(filter, this.selectedSubjectStatusFilters, 'doSubjectsDistributionSubjectStatusFilters');
	    },
	    toggleSelectedSubjectFilters: function toggleSelectedSubjectFilters(filter) {
	      this.toggleFilter(filter, this.selectedSubjectFilters, 'doSubjectsDistributionSubjectFilters');
	    },
	    clearSelectedSubjectFilters: function clearSelectedSubjectFilters() {
	      this.selectedSubjectFilters = [];
	      var storageKey = 'doSubjectsDistributionSubjectFilters';
	      this.updateLocalStorage(storageKey, []);
	    },
	    clearSelectedSubjectStatusFilters: function clearSelectedSubjectStatusFilters() {
	      this.selectedSubjectStatusFilters = [];
	      var storageKey = 'doSubjectsDistributionSubjectStatusFilters';
	      this.updateLocalStorage(storageKey, []);
	    },
	    toggleSelectedTypeFilters: function toggleSelectedTypeFilters(filter) {
	      this.toggleFilter(filter, this.selectedTypeFilters, 'doSubjectsDistributionSubjectTypeFilters');
	    },
	    clearSelectedTypeFilters: function clearSelectedTypeFilters() {
	      this.selectedTypeFilters = [];
	      this.updateLocalStorage('doSubjectsDistributionSubjectTypeFilters', []);
	    },
	    toggleSelectedPersonFilters: function toggleSelectedPersonFilters(filter) {
	      this.toggleFilter(filter, this.selectedPersonFilters, 'doSubjectsDistributionSubjectPersonFilters');
	    },
	    clearSelectedPersonFilters: function clearSelectedPersonFilters() {
	      this.selectedPersonFilters = [];
	      this.updateLocalStorage('doSubjectsDistributionSubjectPersonFilters', []);
	    },
	    clearAllFilters: function clearAllFilters() {
	      this.clearSelectedKlassFilters();
	      this.clearSelectedSubjectStatusFilters();
	      this.clearSelectedSubjectFilters();
	      this.clearSelectedTypeFilters();
	      this.clearSelectedPersonFilters();
	    },
	    toggleGroupTag: function toggleGroupTag(tag) {
	      this.$store.commit('setSelectedTags', tag);
	      this.updateLocalStorage('doSubjectsDistributionSelectedGroupTags', this.$store.state.selectedTags);
	    },
	    clearSelectedGroupTags: function clearSelectedGroupTags() {
	      var _this13 = this;
	
	      var tagsToRemove = [].concat((0, _toConsumableArray3.default)(this.$store.state.selectedTags));
	      tagsToRemove.forEach(function (tag) {
	        _this13.$store.commit('setSelectedTags', tag);
	      });
	      this.updateLocalStorage('doSubjectsDistributionSelectedGroupTags', []);
	    },
	    loadSelectedGroupTagsFromLocalStorage: function loadSelectedGroupTagsFromLocalStorage() {
	      var _this14 = this;
	
	      var stored = this.$helpers.getLocalStorage('doSubjectsDistributionSelectedGroupTags');
	      if (!stored) return;
	      var parsed = [];
	      try {
	        parsed = JSON.parse(stored);
	      } catch (e) {
	        parsed = [];
	      }
	      if (!Array.isArray(parsed)) return;
	
	      var current = [].concat((0, _toConsumableArray3.default)(this.$store.state.selectedTags));
	      current.forEach(function (tag) {
	        if (parsed.indexOf(tag) < 0) {
	          _this14.$store.commit('setSelectedTags', tag);
	        }
	      });
	      parsed.forEach(function (tag) {
	        if (_this14.$store.state.selectedTags.indexOf(tag) < 0) {
	          _this14.$store.commit('setSelectedTags', tag);
	        }
	      });
	    },
	    getUserAssignedTeachingHours: function getUserAssignedTeachingHours(userId) {
	      return this.usersAssignedHoursHash[userId] ? this.usersAssignedHoursHash[userId].assigned_teaching_hours : 0;
	    },
	    getSubjectHours: function getSubjectHours(subjectId, userCalId) {
	      var subject = this.subjectsInHash[subjectId];
	      if (!subject) return 0;
	
	      if (Array.isArray(subject.subject_calendars)) {
	        var userMatch = subject.subject_calendars.find(function (sc) {
	          return sc.calendar_id === userCalId && sc.hours != null;
	        });
	        if (userMatch) {
	          var parsed = parseFloat(userMatch.hours);
	          return isNaN(parsed) ? 0 : parsed;
	        }
	      }
	
	      if (Array.isArray(subject.cals)) {
	        var klass = subject.cals.find(function (c) {
	          return c.calendar_type === 'klass';
	        });
	        if (klass && Array.isArray(subject.subject_calendars)) {
	          var klassMatch = subject.subject_calendars.find(function (sc) {
	            return sc.calendar_id === klass.id && sc.hours != null;
	          });
	          if (klassMatch) {
	            var _parsed2 = parseFloat(klassMatch.hours);
	            return isNaN(_parsed2) ? 0 : _parsed2;
	          }
	        }
	      }
	
	      var fallback = parseFloat(subject.hours);
	      return isNaN(fallback) ? 0 : fallback;
	    },
	    getSubjectHoursForUser: function getSubjectHoursForUser(subject, userCalId) {
	      if (Array.isArray(subject.subject_calendars)) {
	        var userMatch = subject.subject_calendars.find(function (sc) {
	          return sc.calendar_id === userCalId && sc.hours != null;
	        });
	        if (userMatch) {
	          var parsed = parseFloat(userMatch.hours);
	          if (!isNaN(parsed)) return parsed;
	        }
	      }
	      var fallback = parseFloat(subject.hours);
	      return isNaN(fallback) ? 0 : fallback;
	    },
	    getTotalSubjectTeachingHours: function getTotalSubjectTeachingHours(userCalId) {
	      var _this15 = this;
	
	      var ids = this.subjectsInUserHash[userCalId] || [];
	      return ids.reduce(function (acc, id) {
	        return acc + (_this15.getSubjectHours(id, userCalId) * 1 || 0);
	      }, 0);
	    },
	    getTotalUserHoursTeachingCount: function getTotalUserHoursTeachingCount(userCalId) {
	      return this.getTotalSubjectTeachingHours(userCalId);
	    },
	    getUserTeachingHoursDiff: function getUserTeachingHoursDiff(userId) {
	      var diff = !this.isPoolsDeactivated ? this.getUserAssignedTeachingHours(userId) - this.getTotalUserHoursTeachingCount(this.allUsersInHash[userId].user_calendar_id) : this.getTotalUserHoursTeachingCount(this.allUsersInHash[userId].user_calendar_id);
	      return diff.toFixed(1);
	    },
	    getUserLessonsPerWeek: function getUserLessonsPerWeek(userId) {
	      var user = this.allUsersInHash[userId];
	      if (!user || !user.user_calendar_id) {
	        return '0.0';
	      }
	      var userCalId = user.user_calendar_id;
	      var subjectsUserHash = this.subjectsInUserHash;
	      var subjectsHash = this.subjectsInHash;
	
	      var total = 0;
	      var sIds = subjectsUserHash[userCalId] || [];
	      for (var i = 0; i < sIds.length; i++) {
	        var s = subjectsHash[sIds[i]];
	        if (!s) continue;
	        var hours = this.getSubjectHoursForUser(s, userCalId);
	        total += parseFloat(this.calcLessonsPerWeek(hours));
	      }
	
	      return total.toFixed(1);
	    },
	    setActiveUserId: function setActiveUserId(userId) {
	      if (this.activeUserId === userId) {
	        return;
	      }
	      this.activeUserId = userId;
	    },
	    resetActiveUserId: function resetActiveUserId() {
	      var _this16 = this;
	
	      setTimeout(function (_) {
	        _this16.activeUserId = null;
	      }, 0);
	    },
	    setTheUserToShowTasks: function setTheUserToShowTasks(user) {
	      this.theUserToShowTasks = user;
	    },
	    closeTheUserToShowTasks: function closeTheUserToShowTasks() {
	      this.theUserToShowTasks = null;
	    },
	    getAllUserSubjects: function getAllUserSubjects(calid) {
	      return this.subjectsInUserHash[calid];
	    },
	    readAssignedHours: function readAssignedHours() {
	      var schoolObj = {
	        schoolId: this.schoolId,
	        schoolYearId: this.activeSchoolYear.id
	      };
	      this.$store.dispatch('getUsers', this.schoolId, null);
	      this.$store.dispatch('readUsersAssignedHours', schoolObj);
	    },
	    totalHoursCount: function totalHoursCount(klassCalId) {
	      var _this17 = this;
	
	      var subjectsHours = [0];
	      var shouldExcludeTypes = !this.doesRessCountInKlassTotalHours;
	      var excludedTypes = ['resource', 'person_resource_visible'];
	
	      if (this.subjectsInKlassHash[klassCalId]) {
	        var _subjects = this.subjectsInKlassHash[klassCalId].map(function (subjectId) {
	          return _this17.subjectsInHash[subjectId];
	        }).filter(function (subject) {
	          return subject.subject_type !== 'frame' && (!shouldExcludeTypes || excludedTypes.indexOf(subject.subject_type) < 0);
	        });
	
	        subjectsHours = _subjects.map(function (subject) {
	          var calendarHours = null;
	          if (subject.subject_calendars) {
	            var match = subject.subject_calendars.find(function (sc) {
	              return sc.calendar_id === klassCalId;
	            });
	            if (match) {
	              calendarHours = parseFloat(match.hours);
	            }
	          }
	
	          var fallbackHours = parseFloat(subject.hours);
	          var vHours = isNaN(calendarHours) ? fallbackHours : calendarHours;
	          return isNaN(vHours) ? 0 : vHours;
	        });
	      }
	
	      var sum = subjectsHours.reduce(function (acc, item) {
	        return acc + item;
	      }, 0);
	      return sum.toFixed(2);
	    },
	    isShowWithoutTeacher: function isShowWithoutTeacher(subjectid) {
	      if (!this.isShowSubjectsWithoutTeachers) {
	        return true;
	      } else {
	        return !this.subjectHasTeachers(subjectid);
	      }
	    },
	    closeModal: function closeModal() {
	      this.editSubject = null;
	      this.editSubjectPoolCalendarId = null;
	      this.isSubjectModal = false;
	    },
	    setEditSubject: function setEditSubject(editSubject, klassCalId) {
	      var _this18 = this;
	
	      this.editSubjectPoolCalendarId = klassCalId || null;
	      this.isSubjectLoading = true;
	      this.isSubjectModal = true;
	      _docendo2.default.showSubject(editSubject.id, function (success) {
	        var pendingTab = _this18._pendingTab;
	        _this18._pendingTab = null;
	        _this18._pendingSubjectId = null;
	        _this18.editSubject = pendingTab ? (0, _assign2.default)({}, success, { _openTab: pendingTab }) : (0, _assign2.default)({}, success);
	        _this18.isSubjectLoading = false;
	        setTimeout(function (_) {
	          _this18.$store.commit('updateSubject', success);
	        }, 1500);
	        setTimeout(function (_) {
	          _this18.isTheCreateCalenderSubjectActive = null;
	        }, 1);
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    setEditTask: function setEditTask(editTask) {
	      this.theEditTask = this.tasksInHash[editTask.id];
	    },
	    updateSubject: function updateSubject(updatedSubject) {
	      if (!updatedSubject['schoolId']) {
	        updatedSubject['schoolId'] = this.schoolId;
	      }
	      if (!updatedSubject['schoolYearId']) {
	        updatedSubject['schoolYearId'] = this.activeSchoolYear.id;
	      }
	      this.$store.dispatch('updateSubject', updatedSubject);
	      this.closeModal();
	    },
	    saveAndShowTab: function saveAndShowTab(updatedSubject, tab) {
	      var _this19 = this;
	
	      var poolCalendarId = this.editSubjectPoolCalendarId;
	      this.updateSubject(updatedSubject);
	      this.closeModal();
	      this._pendingTab = tab;
	      this._pendingSubjectId = updatedSubject.id;
	      setTimeout(function () {
	        _this19.setEditSubject({ id: _this19._pendingSubjectId }, poolCalendarId);
	      }, 500);
	    },
	    toggleEditDates: function toggleEditDates() {
	      if (this.isEditingDates) {
	        this.cancelEditDates();
	      } else {
	        this.isEditingDates = true;
	        this.selectedSubjectIds = [];
	        this.bulkFromDate = this.bulkDateMin ? this.bulkDateMin.clone() : (0, _moment2.default)();
	        this.bulkToDate = this.bulkDateMax ? this.bulkDateMax.clone() : (0, _moment2.default)();
	      }
	    },
	    cancelEditDates: function cancelEditDates() {
	      this.isEditingDates = false;
	      this.selectedSubjectIds = [];
	      this.isSavingBulkDates = false;
	    },
	    toggleSubjectSelection: function toggleSubjectSelection(subjectId) {
	      var idx = this.selectedSubjectIds.indexOf(subjectId);
	      if (idx >= 0) {
	        this.selectedSubjectIds.splice(idx, 1);
	      } else {
	        this.selectedSubjectIds.push(subjectId);
	      }
	    },
	    toggleSelectAllVisible: function toggleSelectAllVisible() {
	      if (this.allVisibleSelected) {
	        this.selectedSubjectIds = [];
	      } else {
	        this.selectedSubjectIds = this.visibleSubjectIdsForBulk.slice();
	      }
	    },
	    setBulkFromDate: function setBulkFromDate(date) {
	      this.bulkFromDate = date;
	    },
	    setBulkToDate: function setBulkToDate(date) {
	      this.bulkToDate = date;
	    },
	    saveBulkDates: function saveBulkDates() {
	      var _this20 = this;
	
	      if (this.selectedSubjectIds.length === 0 || this.isSavingBulkDates) return;
	      var fromMoment = (0, _moment2.default)(this.bulkFromDate);
	      var toMoment = (0, _moment2.default)(this.bulkToDate);
	      if (this.bulkDateMin && fromMoment.isBefore(this.bulkDateMin, 'day')) {
	        _eventbus2.default.toast = { text: 'Startdato skal være inden for skoleåret', success: false };
	        return;
	      }
	      if (this.bulkDateMax && toMoment.isAfter(this.bulkDateMax, 'day')) {
	        _eventbus2.default.toast = { text: 'Slutdato skal være inden for skoleåret', success: false };
	        return;
	      }
	      var changes = {
	        from_date: fromMoment.format('YYYY-MM-DD'),
	        to_date: toMoment.format('YYYY-MM-DD')
	      };
	      this.isSavingBulkDates = true;
	      _docendo2.default.bulkUpdateSubjects(this.schoolId, this.selectedSubjectIds.slice(), changes, function (data) {
	        var subjects = typeof data === 'string' ? JSON.parse(data) : data;
	        subjects.forEach(function (subj) {
	          subj.calendar_ids = subj.cals ? subj.cals.map(function (c) {
	            return c.id;
	          }) : [];
	          _this20.$store.commit('updateSubject', subj);
	        });
	        _this20.isSavingBulkDates = false;
	        _eventbus2.default.toast = { text: 'Datoer opdateret', success: true };
	        _this20.cancelEditDates();
	      }, function (err) {
	        _this20.isSavingBulkDates = false;
	        var msg = err && err.data && err.data.error ? err.data.error : err && err.error ? err.error : 'Kunne ikke opdatere datoer';
	        _eventbus2.default.toast = { text: msg, success: false };
	      });
	    },
	    setPrint: function setPrint() {
	      this.isPrintUsers = true;
	    },
	    getZENJWT: function getZENJWT() {
	      var _this21 = this;
	
	      _docendo2.default.getJwt(function (data) {
	        _this21.theZENToken = data && data.token ? data.token : '';
	      });
	    },
	    readSubject: function readSubject() {
	      this.$store.dispatch('readSubjects', this.activeSchoolYear.id);
	    },
	    loadFiltersFromLocalStorage: function loadFiltersFromLocalStorage(key, filterArray) {
	      var deprecatedFilters = ['Vis kun fag uden underviser'];
	      var storedFilters = this.$helpers.getLocalStorage(key);
	
	      if (storedFilters) {
	        var parsedFilters = JSON.parse(storedFilters);
	
	        parsedFilters = parsedFilters.filter(function (filter) {
	          return !deprecatedFilters.includes(filter);
	        });
	
	        this[filterArray] = parsedFilters;
	
	        if (parsedFilters.length !== JSON.parse(storedFilters).length) {
	          this.$helpers.setLocalStorage(key, (0, _stringify2.default)(parsedFilters));
	        }
	      }
	    },
	    printTable: function printTable() {
	      var _this22 = this;
	
	      this.isPrintingTable = true;
	      this.$nextTick(function () {
	        window.print();
	        _this22.isPrintingTable = false;
	      });
	    },
	    asyncLoadXLSXAndDownloadTable: function asyncLoadXLSXAndDownloadTable() {
	      var _this23 = this;
	
	      this.isDownloadingExcel = true;
	      if (window.XLSX) {
	        this.downloadTableToExcel();
	      } else {
	        var cdnXLSX = document.createElement('script');
	        cdnXLSX.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.mini.min.js');
	        document.head.appendChild(cdnXLSX);
	        var intervalTimer = setInterval(function () {
	          if (window.XLSX) {
	            clearInterval(intervalTimer);
	            _this23.downloadTableToExcel();
	          }
	        }, 500);
	      }
	    },
	    downloadTableToExcel: function downloadTableToExcel() {
	      var XLSX = window.XLSX;
	      var typeLabels = {
	        subject: 'Fag',
	        activity: 'Aktivitet',
	        available: 'Rådighedstime',
	        person_resource: 'Ressource',
	        person_resource_visible: 'Ressource (synlig)',
	        resource: 'Ressource',
	        additional_tasks: 'Øvrige opgaver',
	        preparation: 'Forberedelse',
	        pool: this.poolSubjectTypeLabel,
	        club: 'SFO',
	        without_kids: 'Uden børn',
	        frame: 'Temavisning',
	        optional: 'Valgfag/Hold',
	        supplemental: 'UUV',
	        break: 'Pause'
	      };
	
	      var rows = [];
	      var klasses = this.filteredKlassCals;
	      var showRequested = this.showSubjectsRequestInTable && this.isShowSubjectsRequest && (0, _keys2.default)(this.subjectsRequestsInHash).length > 0;
	      var showDates = this.showDatesInTable;
	
	      var header = ['Klasse', 'Fag', 'Type', 'Personale'];
	      if (showDates) header.push('Startdato', 'Slutdato');
	      if (showRequested) header.push('Ønsket af');
	      header.push('Lokaler', 'Klasser', 'Lek. pr. uge', 'Timer');
	      rows.push(header);
	
	      var _loop3 = function _loop3(k) {
	        var klass = klasses[k];
	        var subjects = [].concat((0, _toConsumableArray3.default)(klass.vSubjects)).sort(function (a, b) {
	          return (a.name || '').localeCompare(b.name || '', 'da');
	        });
	
	        for (var s = 0; s < subjects.length; s++) {
	          var subj = subjects[s];
	
	          var teachers = subj.vUserNames && subj.vUserNames.length ? subj.vUserNames.join(', ') : '';
	
	          var requestedBy = subj.vRequestedBy && subj.vRequestedBy.length ? subj.vRequestedBy.join(', ') : '';
	
	          var rooms = '';
	          if (subj.cals && subj.cals.length) {
	            rooms = subj.cals.filter(function (cal) {
	              return cal.calendar_type === 'room';
	            }).map(function (cal) {
	              return cal.name;
	            }).join(', ');
	          }
	
	          var _otherKlasses = subj.v_subjectOtherKlasses && subj.v_subjectOtherKlasses.length ? subj.v_subjectOtherKlasses.join(', ') : '';
	
	          var hours = subj.vHours;
	          if (subj.subject_calendars && subj.subject_calendars.length) {
	            var match = subj.subject_calendars.find(function (sc) {
	              return sc.calendar_id === klass.id;
	            });
	            if (match && match.hours != null) {
	              hours = parseFloat(match.hours);
	            }
	          }
	
	          var row = [klass.name || '', subj.name || '', typeLabels[subj.subject_type] || subj.subject_type || '', teachers];
	          if (showDates) {
	            row.push(subj.from_date ? (0, _moment2.default)(subj.from_date).format('D. MMM YYYY') : '', subj.to_date ? (0, _moment2.default)(subj.to_date).format('D. MMM YYYY') : '');
	          }
	          if (showRequested) row.push(requestedBy);
	          row.push(rooms, _otherKlasses, parseFloat(subj.vLessonsPerWeek) || 0, isNaN(hours) ? 0 : parseFloat(hours));
	          rows.push(row);
	        }
	      };
	
	      for (var k = 0; k < klasses.length; k++) {
	        _loop3(k);
	      }
	
	      var ws = XLSX.utils.aoa_to_sheet(rows);
	      var wb = XLSX.utils.book_new();
	      XLSX.utils.book_append_sheet(wb, ws, 'Fagfordeling');
	      XLSX.writeFile(wb, 'docendo_fagfordeling.xlsx');
	      this.isDownloadingExcel = false;
	    }
	  },
	  beforeMount: function beforeMount() {
	    var _this24 = this;
	
	    if (this.schoolId) {
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this24.groupTags = Array.isArray(data) ? data : [];
	      }, function (failure) {
	        _this24.groupTags = [];
	      });
	    }
	
	    this.loadFiltersFromLocalStorage('doSubjectsDistributionSubjectStatusFilters', 'selectedSubjectStatusFilters');
	    this.loadFiltersFromLocalStorage('doSubjectsDistributionSubjectKlassFilters', 'selectedKlassFilters');
	    this.loadFiltersFromLocalStorage('doSubjectsDistributionSubjectFilters', 'selectedSubjectFilters');
	    this.loadFiltersFromLocalStorage('doSubjectsDistributionSubjectTypeFilters', 'selectedTypeFilters');
	    this.loadFiltersFromLocalStorage('doSubjectsDistributionSubjectPersonFilters', 'selectedPersonFilters');
	    this.loadSelectedGroupTagsFromLocalStorage();
	
	    var storedViewMode = this.$helpers.getLocalStorage('doSubjectsDistributionViewMode');
	    if (storedViewMode === 'tiles' || storedViewMode === 'table') {
	      this.viewMode = storedViewMode;
	    }
	    var storedLessons = this.$helpers.getLocalStorage('doSubjectsDistributionShowLessonsPerWeek');
	    if (storedLessons === 'true') {
	      this.showLessonsPerWeek = true;
	    }
	    var storedActivities = this.$helpers.getLocalStorage('doSubjectsDistributionShowActivities');
	    if (storedActivities === 'true') {
	      this.showActivities = true;
	    }
	    var storedSubjectsRequest = this.$helpers.getLocalStorage('doSubjectsDistributionShowSubjectsRequest');
	    if (storedSubjectsRequest === 'true') {
	      this.showSubjectsRequestInTable = true;
	    }
	    var storedDates = this.$helpers.getLocalStorage('doSubjectsDistributionShowDatesInTable');
	    if (storedDates === 'true') {
	      this.showDatesInTable = true;
	    }
	  },
	  mounted: function mounted() {
	    var _this25 = this;
	
	    this.readAssignedHours();
	    this.getZENJWT();
	    this.readSubjectRequests();
	    window.addEventListener('new_subjects_created', function () {
	      return _this25.readSubject();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _this26 = this;
	
	    window.removeEventListener('new_subjects_created', function () {
	      return _this26.readSubject();
	    });
	  }
	};

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SubjectsDistributionUser = __webpack_require__(394);
	
	var _SubjectsDistributionUser2 = _interopRequireDefault(_SubjectsDistributionUser);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { SubjectsDistributionUser: _SubjectsDistributionUser2.default, DModal: _DModal2.default },
	  data: function data() {
	    return {
	      isPrintSettingsModal: false,
	      filteredUsers: []
	    };
	  },
	
	  computed: {
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    usersFilteredWithTags: function usersFilteredWithTags() {
	      return this.$store.getters.usersFilteredWithTags;
	    },
	    usersFilteredWithTagsFiltered: function usersFilteredWithTagsFiltered() {
	      return this.usersFilteredWithTags.filter(function (user) {
	        return user;
	      });
	    }
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear() {
	      this.readAssignedHours();
	      this.$store.dispatch('readSubjects', this.activeSchoolYear.id);
	    }
	  },
	  methods: {
	    isUserFiltered: function isUserFiltered(user) {
	      return this.filteredUsers.indexOf(user.id) > -1;
	    },
	    toggleFilteredUser: function toggleFilteredUser(user) {
	      var idx = this.filteredUsers.indexOf(user.id);
	      if (idx < 0) {
	        this.filteredUsers.push(user.id);
	      } else {
	        this.filteredUsers.splice(idx, 1);
	      }
	    },
	    readAssignedHours: function readAssignedHours() {
	      var schoolObj = {
	        schoolId: window.SCHOOL.id,
	        schoolYearId: this.activeSchoolYear.id
	      };
	      this.$store.dispatch('getUsers', window.SCHOOL.id, null);
	      this.$store.dispatch('readUsersAssignedHours', schoolObj);
	    },
	    print: function print() {
	      setTimeout(function (_) {
	        try {
	          document.execCommand('print', false, null);
	        } catch (err) {
	          window.print();
	        }
	        setTimeout(function (_) {
	          window.close();
	        }, 1000);
	      }, 0);
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.readAssignedHours();
	    setTimeout(function (_) {
	      _this.isPrintSettingsModal = true;
	    }, 500);
	  }
	};

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SubjectsDistributionTable',
	  props: {
	    subjectDefaultDuration: {
	      type: Number,
	      default: 45
	    },
	    filteredKlassCals: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    doesRessCountInKlassTotalHours: {
	      type: Boolean,
	      default: true
	    },
	    showLessonsPerWeek: {
	      type: Boolean,
	      default: false
	    },
	    showSubjectsRequest: {
	      type: Boolean,
	      default: false
	    },
	    showDates: {
	      type: Boolean,
	      default: false
	    },
	    showTeacherPoolHours: {
	      type: Boolean,
	      default: false
	    },
	    isEditingDates: {
	      type: Boolean,
	      default: false
	    },
	    selectedSubjectIds: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  computed: {
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    poolSubjectTypeLabel: function poolSubjectTypeLabel() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || 'Lokalpulje';
	    }
	  },
	  methods: {
	    isExcludedType: function isExcludedType(subject) {
	      if (this.doesRessCountInKlassTotalHours) return false;
	      var excludedTypes = ['resource', 'person_resource_visible'];
	      return excludedTypes.indexOf(subject.subject_type) >= 0;
	    },
	    isExcludedFromLessons: function isExcludedFromLessons(subject) {
	      if (this.doesRessCountInKlassTotalHours) return false;
	      var teachingTypes = ['subject'];
	      return teachingTypes.indexOf(subject.subject_type) < 0;
	    },
	    totalLessons: function totalLessons(subjects) {
	      var _this = this;
	
	      return subjects.reduce(function (sum, s) {
	        if (_this.isExcludedFromLessons(s)) return sum;
	        return sum + parseFloat(s.vLessonsPerWeek || 0);
	      }, 0).toFixed(1);
	    },
	    totalHours: function totalHours(subjects, klassCalId) {
	      var _this2 = this;
	
	      return subjects.reduce(function (sum, s) {
	        if (_this2.isExcludedFromLessons(s)) return sum;
	        var hours = _this2.getHoursForKlass(s, klassCalId);
	        return sum + (isNaN(hours) ? 0 : parseFloat(hours));
	      }, 0).toFixed(1);
	    },
	    getHoursForKlass: function getHoursForKlass(subject, klassCalId) {
	      if (subject.subject_calendars && subject.subject_calendars.length) {
	        var match = subject.subject_calendars.find(function (sc) {
	          return sc.calendar_id === klassCalId;
	        });
	        if (match && match.hours != null) return parseFloat(match.hours);
	      }
	      return subject.vHours;
	    },
	    sortedSubjects: function sortedSubjects(subjects) {
	      return [].concat((0, _toConsumableArray3.default)(subjects)).sort(function (a, b) {
	        return (a.name || '').localeCompare(b.name || '', 'da');
	      });
	    },
	    subjectTypeLabel: function subjectTypeLabel(type) {
	      var labels = {
	        subject: 'Fag',
	        activity: 'Aktivitet',
	        available: 'Rådighedstime',
	        person_resource: 'Ressource',
	        person_resource_visible: 'Ressource (synlig)',
	        resource: 'Ressource',
	        additional_tasks: 'Øvrige opgaver',
	        preparation: 'Forberedelse',
	        pool: this.poolSubjectTypeLabel,
	        club: 'SFO',
	        without_kids: 'Uden børn',
	        frame: 'Temavisning',
	        optional: 'Valgfag/Hold',
	        supplemental: 'UUV',
	        break: 'Pause'
	      };
	      return labels[type] || type || '';
	    },
	    getRoomNames: function getRoomNames(subject) {
	      if (!subject.cals || !subject.cals.length) return '';
	      return subject.cals.filter(function (cal) {
	        return cal.calendar_type === 'room';
	      }).map(function (cal) {
	        return cal.name;
	      }).join(', ');
	    },
	    formatDate: function formatDate(dateStr) {
	      if (!dateStr) return '';
	      return (0, _moment2.default)(dateStr).format('D. MMM YYYY');
	    },
	    formatTeacherPoolHours: function formatTeacherPoolHours(hours, subject) {
	      var parsed = parseFloat(hours);
	      if (isNaN(parsed)) return '';
	      if (this.showLessonsPerWeek) {
	        var duration = subject && subject.default_duration || this.subjectDefaultDuration;
	        return this.$helpers.calcLessonsPerWeek(parsed, duration);
	      }
	      return Math.round(parsed * 10) / 10;
	    },
	    onRowClick: function onRowClick(subject, klassCalId) {
	      if (this.isEditingDates) {
	        this.$emit('toggleSubjectSelection', subject.id);
	      } else {
	        this.$emit('editSubject', subject, klassCalId);
	      }
	    }
	  }
	};

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(33);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _set = __webpack_require__(27);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _from = __webpack_require__(32);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _SubjectsDistributionTasksCreate = __webpack_require__(146);
	
	var _SubjectsDistributionTasksCreate2 = _interopRequireDefault(_SubjectsDistributionTasksCreate);
	
	var _DSelectCalsIds = __webpack_require__(40);
	
	var _DSelectCalsIds2 = _interopRequireDefault(_DSelectCalsIds);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vueClickaway = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var XLSX = null;
	
	var I18N = {
	  da: {
	    create_tasks: 'Opret opgave',
	    teaching: 'Undervisning',
	    additional_tasks: 'Øvrige opgaver',
	    preparation: 'Forberedelse',
	    pool: 'Lokalpulje',
	    club: 'SFO',
	    task_names: 'Opgavens titel',
	    brick_type: 'Briktype',
	    tasks_label: 'Opgaver',
	    of: 'af',
	    all: 'Alle',
	    hours_short: 't',
	    no_tasks: 'Ingen opgaver',
	    hours: 'Timer',
	    type: 'Type',
	    users: 'Brugere',
	    total: 'Total',
	    new_task: '+ Ny opgave',
	    create_copy: 'Opret kopi',
	    select_task: 'Vælg en opgave i listen',
	    task: 'Opgave',
	    tasks_sheet: 'Opgaver',
	    tasks_status: 'Status',
	    only_tasks_with_users: 'Vis opgaver med personale',
	    only_tasks_without_users: 'Vis opgaver uden personale'
	  },
	  nb: {
	    create_tasks: 'Opprett oppgaver',
	    teaching: 'Undervisning',
	    additional_tasks: 'Øvrige oppgaver',
	    preparation: 'Forberedelse',
	    pool: 'Planleggingsdager',
	    club: 'SFO',
	    task_names: 'Oppgave',
	    brick_type: 'Brikketype',
	    tasks_label: 'Oppgaver',
	    of: 'av',
	    all: 'Alle',
	    hours_short: 't',
	    no_tasks: 'Ingen oppgaver',
	    hours: 'Timer',
	    type: 'Type',
	    users: 'Brukere',
	    total: 'Totalt',
	    new_task: '+ Ny oppgave',
	    create_copy: 'Opprett kopi',
	    select_task: 'Velg en oppgave i listen',
	    task: 'Oppgave',
	    tasks_sheet: 'Oppgaver',
	    tasks_status: 'Status',
	    only_tasks_with_users: 'Vis oppgaver med personale',
	    only_tasks_without_users: 'Vis oppgaver uten personale'
	  },
	  en: {
	    create_tasks: 'Create task',
	    teaching: 'Teaching',
	    additional_tasks: 'Additional tasks',
	    preparation: 'Preparation',
	    pool: 'Custom pool',
	    club: 'Club',
	    task_names: 'Task',
	    brick_type: 'Task type',
	    tasks_label: 'Tasks',
	    of: 'of',
	    all: 'All',
	    hours_short: 'h',
	    no_tasks: 'No tasks',
	    hours: 'Hours',
	    type: 'Type',
	    users: 'Users',
	    total: 'Total',
	    new_task: '+ New task',
	    create_copy: 'Create copy',
	    select_task: 'Select a task from the list',
	    task: 'Task',
	    tasks_sheet: 'Tasks',
	    tasks_status: 'Status',
	    only_tasks_with_users: 'Show tasks with personnel',
	    only_tasks_without_users: 'Show tasks without personnel'
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { CreateTask: _SubjectsDistributionTasksCreate2.default, DSelectCalendarIds: _DSelectCalsIds2.default, DoFiltersFilter: _DoFiltersFilter2.default },
	  data: function data() {
	    return {
	      locale: window.USER && window.USER.language ? window.USER.language : 'da',
	      activeGroup: null,
	      isTaskModal: false,
	      editTask: null,
	      isLoadingFreshTask: false,
	      prefillTask: null,
	      isQuickCreate: false,
	      activeDSelect: null,
	      activeDSelectShow: false,
	      selectedFilterSubjectTypes: [],
	      selectedFilterTaskNames: [],
	      selectedFilterTaskStatus: [],
	      isDownloading: false,
	      sidebarCollapsed: false
	    };
	  },
	
	  computed: {
	    i18n: function i18n() {
	      return I18N;
	    },
	    isSubmittingTask: function isSubmittingTask() {
	      return this.$store.state.subjects.isSubmittingTask;
	    },
	    isSchoolFeatureLocalePool: function isSchoolFeatureLocalePool() {
	      return this.$store.getters.isSchoolFeatureLocalePool;
	    },
	    localPoolTitle: function localPoolTitle() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || this.i18n[this.locale]['pool'];
	    },
	    tasks: function tasks() {
	      return this.$store.state.subjects.tasks;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    visibleTasks: function visibleTasks() {
	      var calendarsHash = this.allCalendarsInHash;
	      return this.tasks.filter(function (task) {
	        var subjects = task.subjects || [];
	        if (subjects.length === 0) return true;
	        return !subjects.every(function (s) {
	          var ownerCal = calendarsHash[s.calendar_id];
	          return ownerCal && ownerCal.type === 'klass';
	        });
	      });
	    },
	    tasksTeaching: function tasksTeaching() {
	      return this.visibleTasks.filter(function (t) {
	        return t.subject_type === 'person_resource_visible' || t.subject_type === 'person_resource' || t.subject_type === 'subject';
	      });
	    },
	    tasksTasks: function tasksTasks() {
	      return this.visibleTasks.filter(function (t) {
	        return t.subject_type === 'additional_tasks';
	      });
	    },
	    tasksPrep: function tasksPrep() {
	      return this.visibleTasks.filter(function (t) {
	        return t.subject_type === 'preparation';
	      });
	    },
	    tasksPool: function tasksPool() {
	      return this.visibleTasks.filter(function (t) {
	        return t.subject_type === 'pool';
	      });
	    },
	    tasksClub: function tasksClub() {
	      return this.visibleTasks.filter(function (t) {
	        return t.subject_type === 'club';
	      });
	    },
	    filters: function filters() {
	      var filters = [{ label: this.i18n[this.locale]['teaching'], value: 'teaching', length: this.tasksTeaching.length }, { label: this.i18n[this.locale]['additional_tasks'], value: 'additional_tasks', length: this.tasksTasks.length }, { label: this.i18n[this.locale]['preparation'], value: 'preparation', length: this.tasksPrep.length }, { label: this.localPoolTitle, value: 'pool', length: this.tasksPool.length }, { label: this.i18n[this.locale]['club'], value: 'club', length: this.tasksClub.length }];
	      return this.isSchoolFeatureLocalePool ? filters : filters.filter(function (f) {
	        return f.value !== 'pool';
	      });
	    },
	    filterLabels: function filterLabels() {
	      return this.filters.map(function (f) {
	        return f.label;
	      });
	    },
	    selectedFilterSubjectTypesValue: function selectedFilterSubjectTypesValue() {
	      var _this = this;
	
	      return this.filters.filter(function (f) {
	        return _this.selectedFilterSubjectTypes.includes(f.label);
	      }).map(function (f) {
	        return f.value;
	      });
	    },
	    taskNameLabels: function taskNameLabels() {
	      var names = this.visibleTasks.map(function (t) {
	        return t && t.name ? String(t.name).trim() : '';
	      }).filter(function (n) {
	        return n.length > 0;
	      });
	      return (0, _from2.default)(new _set2.default(names)).sort(function (a, b) {
	        return a.localeCompare(b);
	      });
	    },
	    onlyTasksWithUsersI18n: function onlyTasksWithUsersI18n() {
	      return this.i18n[this.locale].only_tasks_with_users;
	    },
	    onlyTasksWithoutUsersI18n: function onlyTasksWithoutUsersI18n() {
	      return this.i18n[this.locale].only_tasks_without_users;
	    },
	    taskStatusFilters: function taskStatusFilters() {
	      return [this.onlyTasksWithUsersI18n, this.onlyTasksWithoutUsersI18n];
	    },
	    filteredTasks: function filteredTasks() {
	      var calendarsHash = this.allCalendarsInHash;
	      var sanitize = function sanitize(task) {
	        var all = task.user_calendar_ids || [];
	        var users = [];
	        var nonUsers = [];
	        all.forEach(function (calId) {
	          var cal = calendarsHash[calId];
	          if (cal && cal.type === 'user') {
	            users.push(calId);
	          } else if (calId != null) {
	            nonUsers.push(calId);
	          }
	        });
	        users.sort(function (a, b) {
	          return (calendarsHash[a].name || '').localeCompare(calendarsHash[b].name || '', 'da');
	        });
	        return (0, _assign2.default)({}, task, {
	          user_calendar_ids: users,
	          _nonUserCalendarIds: nonUsers
	        });
	      };
	
	      var selectedValues = this.selectedFilterSubjectTypesValue;
	      var base = [];
	      if (!selectedValues.length || selectedValues.includes('')) {
	        base = this.visibleTasks.map(sanitize);
	      } else {
	        if (selectedValues.includes('teaching')) base = base.concat(this.tasksTeaching.map(sanitize));
	        if (selectedValues.includes('additional_tasks')) base = base.concat(this.tasksTasks.map(sanitize));
	        if (selectedValues.includes('preparation')) base = base.concat(this.tasksPrep.map(sanitize));
	        if (selectedValues.includes('pool')) base = base.concat(this.tasksPool.map(sanitize));
	        if (selectedValues.includes('club')) base = base.concat(this.tasksClub.map(sanitize));
	      }
	      if (this.selectedFilterTaskNames && this.selectedFilterTaskNames.length > 0) {
	        var selectedNames = this.selectedFilterTaskNames;
	        base = base.filter(function (t) {
	          var n = t && t.name ? String(t.name).trim() : '';
	          return n.length > 0 && selectedNames.indexOf(n) > -1;
	        });
	      }
	      if (this.selectedFilterTaskStatus && this.selectedFilterTaskStatus.length > 0) {
	        var hasFilterWithUsers = this.selectedFilterTaskStatus.indexOf(this.onlyTasksWithUsersI18n) > -1;
	        var hasFilterWithoutUsers = this.selectedFilterTaskStatus.indexOf(this.onlyTasksWithoutUsersI18n) > -1;
	        base = base.filter(function (task) {
	          var hasUsers = (task.user_calendar_ids || []).length > 0;
	          return hasFilterWithUsers && hasUsers || hasFilterWithoutUsers && !hasUsers;
	        });
	      }
	      return base;
	    },
	    groupedTasks: function groupedTasks() {
	      var _this2 = this;
	
	      var map = {};
	      this.filteredTasks.forEach(function (task) {
	        var name = (task.name || '').trim();
	        if (!name) return;
	        if (!map[name]) {
	          map[name] = {
	            name: name,
	            color: task.color || '#ccc',
	            tasks: [],
	            totalHours: 0,
	            weightedHours: 0
	          };
	        }
	        map[name].tasks.push(task);
	        var h = parseFloat(task.hours) || 0;
	        map[name].totalHours += h;
	        map[name].weightedHours += _this2.getTaskWeightedTotal(task);
	      });
	      return (0, _values2.default)(map).sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    filteredGroupedTasks: function filteredGroupedTasks() {
	      return this.groupedTasks;
	    },
	    totalGroupCount: function totalGroupCount() {
	      var names = new _set2.default();
	      this.visibleTasks.forEach(function (t) {
	        var n = (t.name || '').trim();
	        if (n) names.add(n);
	      });
	      return names.size;
	    },
	    allFilteredWeightedHours: function allFilteredWeightedHours() {
	      var sum = 0;
	      this.filteredGroupedTasks.forEach(function (g) {
	        sum += g.weightedHours;
	      });
	      return sum;
	    },
	    allGroupData: function allGroupData() {
	      var allTasks = [];
	      var totalHours = 0;
	      var weightedHours = 0;
	      this.filteredGroupedTasks.forEach(function (g) {
	        g.tasks.forEach(function (t) {
	          return allTasks.push(t);
	        });
	        totalHours += g.totalHours;
	        weightedHours += g.weightedHours;
	      });
	      var sorted = allTasks.slice().sort(function (a, b) {
	        var nameCmp = (a.name || '').localeCompare(b.name || '');
	        if (nameCmp !== 0) return nameCmp;
	        return (parseFloat(b.hours) || 0) - (parseFloat(a.hours) || 0);
	      });
	      return { name: this.i18n[this.locale]['all'], color: '#8898aa', tasks: sorted, totalHours: totalHours, weightedHours: weightedHours };
	    },
	    activeGroupName: function activeGroupName() {
	      var _this3 = this;
	
	      if (this.activeGroup === '__all__') return '__all__';
	      if (this.activeGroup) {
	        var exists = this.filteredGroupedTasks.find(function (g) {
	          return g.name === _this3.activeGroup;
	        });
	        if (exists) return this.activeGroup;
	      }
	      return '__all__';
	    },
	    activeGroupData: function activeGroupData() {
	      var _this4 = this;
	
	      if (this.activeGroupName === '__all__') return this.allGroupData;
	      var group = this.filteredGroupedTasks.find(function (g) {
	        return g.name === _this4.activeGroupName;
	      });
	      if (!group) return null;
	      var sorted = group.tasks.slice().sort(function (a, b) {
	        var nameCmp = (a.name || '').localeCompare(b.name || '');
	        if (nameCmp !== 0) return nameCmp;
	        return (parseFloat(b.hours) || 0) - (parseFloat(a.hours) || 0);
	      });
	      return (0, _assign2.default)({}, group, { tasks: sorted });
	    }
	  },
	  watch: {
	    activeSchoolYear: {
	      immediate: true,
	      handler: function handler(val) {
	        var _this5 = this;
	
	        if (!val || !val.id) return;
	        var schoolId = this.$store.getters.schoolId;
	        if (!schoolId) return;
	        _docendo2.default.readTasks(schoolId, val.id, null, function (data) {
	          _this5.$store.commit('setTasks', data);
	          window.dispatchEvent(new window.CustomEvent('vueDoneLoadingTasks', { detail: data }));
	        }, function () {});
	      }
	    }
	  },
	  methods: {
	    getTaskWeightedTotal: function getTaskWeightedTotal(task) {
	      var baseHours = parseFloat(task.hours) || 0;
	      var userCalIds = task.user_calendar_ids || [];
	      if (!userCalIds.length) return 0;
	
	      var subjectId = task.subjects && task.subjects.length ? task.subjects[0].id : task.subject_ids && task.subject_ids.length ? task.subject_ids[0] : null;
	      var subj = subjectId ? this.subjectsInHash[subjectId] : null;
	      var scList = subj && subj.subject_calendars ? subj.subject_calendars : [];
	
	      var total = 0;
	
	      var _loop = function _loop(i) {
	        var sc = scList.find(function (s) {
	          return s.calendar_id === userCalIds[i] && s.hours != null;
	        });
	        total += sc ? parseFloat(sc.hours) : baseHours;
	      };
	
	      for (var i = 0; i < userCalIds.length; i++) {
	        _loop(i);
	      }
	      return parseFloat(total.toFixed(2));
	    },
	    toggleFilter: function toggleFilter(filter, filterArray) {
	      if (filterArray.includes(filter)) {
	        filterArray.splice(filterArray.indexOf(filter), 1);
	      } else {
	        filterArray.push(filter);
	      }
	    },
	    toggleFilterTaskNames: function toggleFilterTaskNames(tag) {
	      this.toggleFilter(tag, this.selectedFilterTaskNames);
	    },
	    toggleFilterSubjectTypes: function toggleFilterSubjectTypes(tag) {
	      this.toggleFilter(tag, this.selectedFilterSubjectTypes);
	    },
	    toggleFilterTaskStatus: function toggleFilterTaskStatus(tag) {
	      this.toggleFilter(tag, this.selectedFilterTaskStatus);
	    },
	    getTaskTypeLabel: function getTaskTypeLabel(task) {
	      var t = task.subject_type;
	      if (t === 'person_resource_visible' || t === 'person_resource' || t === 'subject') return this.i18n[this.locale]['teaching'];
	      if (t === 'additional_tasks') return this.i18n[this.locale]['additional_tasks'];
	      if (t === 'preparation') return this.i18n[this.locale]['preparation'];
	      if (t === 'pool') return this.localPoolTitle;
	      if (t === 'club') return this.i18n[this.locale]['club'];
	      return '';
	    },
	    setActiveGroup: function setActiveGroup(name) {
	      this.activeGroup = name;
	    },
	    getUserNames: function getUserNames(calIds) {
	      var _this6 = this;
	
	      return calIds.map(function (calId) {
	        return _this6.allCalendarsInHash[calId] ? _this6.allCalendarsInHash[calId].name : '';
	      }).filter(function (n) {
	        return n.length > 0;
	      });
	    },
	    getCalendarName: function getCalendarName(calId) {
	      var cal = this.allCalendarsInHash[calId];
	      return cal ? cal.name : '';
	    },
	    setEditTask: function setEditTask(task) {
	      var _this7 = this;
	
	      this.isTaskModal = false;
	      this.isQuickCreate = false;
	      this.editTask = task;
	      this.isLoadingFreshTask = true;
	      setTimeout(function () {
	        _this7.isTaskModal = true;
	      }, 0);
	      this.$store.dispatch('reloadTasks', this.activeSchoolYear.id).then(function () {
	        var fresh = _this7.tasks.find(function (t) {
	          return t.id === task.id;
	        });
	        if (!fresh && task.subject_ids && task.subject_ids.length) {
	          var cachedSubjectIds = new _set2.default(task.subject_ids);
	          fresh = _this7.tasks.find(function (t) {
	            return (t.subject_ids || []).some(function (sid) {
	              return cachedSubjectIds.has(sid);
	            });
	          });
	        }
	        if (fresh) {
	          _this7.editTask = fresh;
	        }
	        _this7.isLoadingFreshTask = false;
	      });
	    },
	    openCreateTask: function openCreateTask() {
	      this.editTask = null;
	      this.prefillTask = null;
	      this.isQuickCreate = false;
	      this.isTaskModal = true;
	    },
	    closeCreateTask: function closeCreateTask() {
	      this.isTaskModal = false;
	      this.editTask = null;
	      this.prefillTask = null;
	      this.isQuickCreate = false;
	    },
	    duplicateFromGroup: function duplicateFromGroup() {
	      var _this8 = this;
	
	      if (!this.activeGroupData) return;
	      var ref = this.activeGroupData.tasks[0];
	      this.editTask = null;
	      this.isQuickCreate = true;
	      this.prefillTask = {
	        name: this.activeGroupData.name,
	        color: this.activeGroupData.color,
	        subject_type: ref ? ref.subject_type : 'additional_tasks',
	        can_schedule: ref ? ref.can_schedule : true,
	        default_duration: ref ? ref.default_duration : 60,
	        preparation: ref ? ref.preparation : null,
	        in_user_calendar: ref ? ref.in_user_calendar : true,
	        belongs_to_calendars: ref ? ref.belongs_to_calendars : []
	      };
	      this.isTaskModal = false;
	      setTimeout(function () {
	        _this8.isTaskModal = true;
	      }, 0);
	    },
	    duplicateTask: function duplicateTask(task) {
	      var _this9 = this;
	
	      this.editTask = null;
	      this.isQuickCreate = true;
	      this.prefillTask = {
	        name: task.name,
	        color: task.color,
	        subject_type: task.subject_type,
	        can_schedule: task.can_schedule,
	        default_duration: task.default_duration,
	        preparation: task.preparation,
	        in_user_calendar: task.in_user_calendar,
	        belongs_to_calendars: task.belongs_to_calendars || []
	      };
	      this.isTaskModal = false;
	      setTimeout(function () {
	        _this9.isTaskModal = true;
	      }, 0);
	    },
	    createTask: function createTask(task) {
	      var _this10 = this;
	
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          _ref$keepOpen = _ref.keepOpen,
	          keepOpen = _ref$keepOpen === undefined ? false : _ref$keepOpen;
	
	      task['schoolYearId'] = this.activeSchoolYear.id;
	      this.$store.dispatch('createTask', task);
	      if (!keepOpen) {
	        this.closeCreateTask();
	        return;
	      }
	      this.isTaskModal = false;
	      setTimeout(function () {
	        _this10.isTaskModal = true;
	      }, 0);
	    },
	    updateTask: function updateTask(updatesForTask) {
	      this.$store.dispatch('updateTask', updatesForTask);
	      this.closeCreateTask();
	    },
	    setActiveDSelect: function setActiveDSelect(task) {
	      if ((task.user_calendar_ids || []).length < 1) {
	        this.activeDSelectShow = true;
	      } else {
	        this.activeDSelectShow = false;
	      }
	      this.activeDSelect = task.id;
	    },
	    closeDSelect: function closeDSelect() {
	      if (!this.activeDSelect) return;
	      this.activeDSelect = null;
	    },
	    setTableSelectedUsers: function setTableSelectedUsers(users, task) {
	      var nonUserCalIds = task._nonUserCalendarIds || [];
	      var userCalendars = users.map(function (u) {
	        return u.id;
	      }).concat(nonUserCalIds);
	      var belongsToCalendars = [];
	      if (!task.in_user_calendar) {
	        belongsToCalendars = task.belongs_to_calendars[0];
	      } else {
	        belongsToCalendars = userCalendars;
	      }
	      var updatedTask = {
	        schoolId: task.school_id,
	        schoolYearId: task.school_year_id,
	        id: task.id,
	        name: task.name,
	        color: task.color,
	        hours: task.hours,
	        defaultDuration: task.default_duration,
	        preparation: task.preparation != null ? Number(task.preparation) : null,
	        belongsToCalendars: belongsToCalendars,
	        userCalendars: userCalendars,
	        inUserCalendar: task.in_user_calendar
	      };
	      this.$store.dispatch('updateTask', updatedTask);
	    },
	    dataToExcel: function dataToExcel() {
	      var _this11 = this;
	
	      if (!this.activeGroupData) return [];
	      return this.activeGroupData.tasks.map(function (task) {
	        return {
	          name: task.name || '',
	          hours: parseFloat(task.hours) || 0,
	          type: _this11.getTaskTypeLabel(task),
	          users: _this11.getUserNames(task.user_calendar_ids || []).join(', '),
	          total: _this11.getTaskWeightedTotal(task)
	        };
	      });
	    },
	    asyncLoadXLSXAndDownload: function asyncLoadXLSXAndDownload() {
	      var _this12 = this;
	
	      this.isDownloading = true;
	      if (window.XLSX && XLSX) {
	        this.downloadExcel();
	      } else {
	        var cdnXLSX = document.createElement('script');
	        cdnXLSX.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.mini.min.js');
	        document.head.appendChild(cdnXLSX);
	        var intervalTimer = setInterval(function () {
	          if (window.XLSX) {
	            clearInterval(intervalTimer);
	            XLSX = window.XLSX;
	            _this12.downloadExcel();
	          }
	        }, 500);
	      }
	    },
	    downloadExcel: function downloadExcel() {
	      var t = this.i18n[this.locale];
	      var headers = {
	        name: t['task'],
	        hours: t['hours'],
	        type: t['type'],
	        users: t['users'],
	        total: t['total']
	      };
	      var rows = this.dataToExcel();
	      rows.unshift(headers);
	
	      var sheet = XLSX.utils.json_to_sheet(rows, { skipHeader: true });
	      var wb = XLSX.utils.book_new();
	      var groupName = this.activeGroupName === '__all__' ? t['all'] : this.activeGroupName;
	      XLSX.utils.book_append_sheet(wb, sheet, t['tasks_sheet']);
	      XLSX.writeFile(wb, t['tasks_sheet'].toLowerCase() + '_' + groupName.replace(/[^a-zA-Z0-9æøåÆØÅ]/g, '_') + '.xlsx');
	
	      this.isDownloading = false;
	    }
	  }
	};

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _set = __webpack_require__(27);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _from = __webpack_require__(32);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DSelectCalsIds = __webpack_require__(40);
	
	var _DSelectCalsIds2 = _interopRequireDefault(_DSelectCalsIds);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _SubjectFormSubjectType = __webpack_require__(61);
	
	var _SubjectFormSubjectType2 = _interopRequireDefault(_SubjectFormSubjectType);
	
	var _DkPreparationFactorControl = __webpack_require__(100);
	
	var _DkPreparationFactorControl2 = _interopRequireDefault(_DkPreparationFactorControl);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _SubjectsDistributionTasksCreateDropdown = __webpack_require__(393);
	
	var _SubjectsDistributionTasksCreateDropdown2 = _interopRequireDefault(_SubjectsDistributionTasksCreateDropdown);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dkPreparationFactorUi = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    create_task: 'Opret opgave',
	    save_and_close: 'Gem og afslut',
	    save_and_new: 'Gem og opret ny opgave',
	    update_task: 'Opdatér',
	    task_title: 'Opgavens titel',
	    ex_task: 'Eks. Tilsyn',
	    choose_type: 'Vælg type',
	    hours_as: 'Timer som',
	    hours: 'Timer',
	    add_user: 'Tilføj personale',
	    hours_in_school_year_per_person: 'Øvrig tid',
	    teaching_hours: 'UV tid',
	    cancel: 'Annullér',
	    cannot_be_deleted: 'Kan ikke slettes, da der er skemalagte brikker',
	    can_be_scheduled: 'Kan skemalægges',
	    duration: 'NORMAL VARIGHED (I MINUTTER)',
	    create_in_calendar: 'Opret i kalender',
	    created_in_calendar: 'Oprettet i kalenderen',
	    choose_color: 'Vælg farve',
	    teaching: 'Undervisning',
	    preparation: 'Forberedelse',
	    additional_tasks: 'Øvrige Opgaver',
	    available: 'Rådighedstimer',
	    club: 'SFO tid',
	    locale_pool: 'Lokalpulje',
	    forb_faktor: 'Forb. faktor',
	    forb_faktor_range_hint: 'Mellem 0 og -1',
	    prep_task_extra_toggle: 'Medregnes ud over forberedelse fra forberedelesfaktor',
	    prep_task_extra_toggle_hint: 'Fra: opgaven følger skolens forberedelsesfaktor som øvrige brikker. Til: opgavens timer medregnes med faktor 1 oven i forberedelsen fra undervisningsfag.',
	    from_date: 'Startdato',
	    to_date: 'Slutdato',
	    show_dates_on_overview: 'Vis datoer på opgaveoversigten',
	    copy_to_shared_calendar: 'Kopiér opgaven til fælles kalender',
	    copied_to_shared_calendar: 'Opgaven er kopieret til fælles kalender'
	  },
	  nb: {
	    create_task: 'Opprett oppgave',
	    save_and_close: 'Lagre og avslutt',
	    save_and_new: 'Lagre og opprett ny oppgave',
	    update_task: 'Oppdater',
	    task_title: 'Navn på oppgave',
	    ex_task: 'F.eks. Tilsyn',
	    choose_type: 'Velg type',
	    hours_as: 'Timer som',
	    hours: 'Timer',
	    add_user: 'Legg til underviser(e)',
	    hours_in_school_year_per_person: 'Øvrig tid',
	    teaching_hours: 'Undervisningstid',
	    cancel: 'Annuller',
	    cannot_be_deleted: 'Kan ikke slettes, ettersom faget er timeplanlagt.',
	    can_be_scheduled: 'Kan timeplanlegges',
	    duration: 'STANDARDLENGDE (I MINUTTER)',
	    create_in_calendar: 'Opprett i kalender',
	    created_in_calendar: 'Opprettet i kalenderen',
	    choose_color: 'Velg farge',
	    teaching: 'Undervisning',
	    preparation: 'Forberedelse',
	    additional_tasks: 'Øvrige oppgaver',
	    available: 'Rådighetstimer',
	    club: 'SFO tid',
	    locale_pool: 'Planleggingsdager',
	    forb_faktor: 'Forb. faktor',
	    forb_faktor_range_hint: 'Mellom 0 og -1',
	    prep_task_extra_toggle: 'Tas med i tillegg til forberedelse fra undervisning',
	    prep_task_extra_toggle_hint: 'Av: oppgaven følger skolens forberedelsesfaktor som andre brikker. På: oppgavens timer tas med med faktor 1 i tillegg til forberedelse fra undervisningsfag.',
	    from_date: 'Startdato',
	    to_date: 'Sluttdato',
	    show_dates_on_overview: 'Vis dato på oppgaveoversikt',
	    copy_to_shared_calendar: 'Kopier oppgaven til felles kalender',
	    copied_to_shared_calendar: 'Oppgaven er kopiert til felles kalender'
	  },
	  en: {
	    create_task: 'Add task',
	    save_and_close: 'Save and close',
	    save_and_new: 'Save and add new task',
	    update_task: 'Update',
	    task_title: 'Title',
	    ex_task: 'eg. non teaching task',
	    choose_type: 'Choose type',
	    hours_as: 'Hours as',
	    hours: 'Hours',
	    add_user: 'Add teacher(s)',
	    hours_in_school_year_per_person: 'Additional time',
	    teaching_hours: 'Teaching hours',
	    cancel: 'Cancel',
	    cannot_be_deleted: 'Cannot be deleted due to scheduled tasks.',
	    can_be_scheduled: 'Can be scheduled',
	    duration: 'STANDARD DURATION (IN MINUTES)',
	    create_in_calendar: 'Create in calendar',
	    created_in_calendar: 'Created in calendar',
	    choose_color: 'Choose color',
	    teaching: 'Teaching',
	    preparation: 'Preparation',
	    additional_tasks: 'Additional tasks',
	    available: 'Available hours',
	    club: 'Club hours',
	    locale_pool: 'Custom pool',
	    forb_faktor: 'Prep factor',
	    forb_faktor_range_hint: 'Between 0 and -1',
	    prep_task_extra_toggle: 'Counted in addition to preparation from teaching',
	    prep_task_extra_toggle_hint: 'Off: this task uses the school preparation factor like other tiles. On: hours are counted with factor 1 on top of preparation from teaching subjects.',
	    from_date: 'Start date',
	    to_date: 'End date',
	    show_dates_on_overview: 'Show dates on task overview',
	    copy_to_shared_calendar: 'Copy task to shared calendar',
	    copied_to_shared_calendar: 'Task copied to shared calendar'
	  }
	};
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default, DModal: _DModal2.default, DSelectCalendarIds: _DSelectCalsIds2.default, SubjectFormSubjectType: _SubjectFormSubjectType2.default, DkPreparationFactorControl: _DkPreparationFactorControl2.default, SelectOtherCal: _SubjectsDistributionTasksCreateDropdown2.default, DSelect: _DSelect2.default, DateSelector: _DateSelector2.default, DDropdown: _DDropdown2.default },
	  props: {
	    editTask: {
	      default: null
	    },
	    activeFilter: {
	      default: null
	    },
	    prefill: {
	      default: null
	    },
	    quickCreate: {
	      type: Boolean,
	      default: false
	    },
	    isLoadingFreshData: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      name: '',
	      hours: 0,
	      calendars: [],
	      subjectType: 'additional_tasks',
	      canSchedule: true,
	      duration: 60,
	      color: '#999999',
	      selectedOtherCalendarId: null,
	      formErrors: [],
	      preparation: null,
	      fromDate: null,
	      toDate: null,
	      isShowDateFields: false
	    };
	  },
	
	  computed: {
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    },
	    saveKeyTooltip: function saveKeyTooltip() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span>' + '<span>Enter</span></p>';
	    },
	    isArbeidstidsplanActivated: function isArbeidstidsplanActivated() {
	      return this.$store.getters.isArbeidstidsplanActivated;
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings || {};
	    },
	    isSchoolFromDenmark: function isSchoolFromDenmark() {
	      return this.schoolCountry.toLowerCase() === 'dk';
	    },
	    isShowNorwegianPreparationDropdown: function isShowNorwegianPreparationDropdown() {
	      return this.isArbeidstidsplanActivated && !this.isSchoolFromDenmark;
	    },
	    isShowDanishPreparationFactorField: function isShowDanishPreparationFactorField() {
	      if (!this.isSchoolFromDenmark || !this.schoolSettings.deactivatePools) {
	        return false;
	      }
	      if (!(0, _dkPreparationFactorUi.schoolHasDanishPreparationFactorConfigured)(this.schoolSettings)) {
	        return false;
	      }
	      return (0, _dkPreparationFactorUi.isSubjectTypeWithDanishPreparationFactor)(this.subjectType);
	    },
	    danishPreparationControlLabels: function danishPreparationControlLabels() {
	      var L = this.i18n[this.locale];
	      return {
	        forb_faktor: L.forb_faktor,
	        forb_faktor_range_hint: L.forb_faktor_range_hint,
	        prep_task_extra_toggle: L.prep_task_extra_toggle,
	        prep_task_extra_toggle_hint: L.prep_task_extra_toggle_hint
	      };
	    },
	    isDanishPrepBinaryOnOwnRow: function isDanishPrepBinaryOnOwnRow() {
	      return this.isShowDanishPreparationFactorField && (0, _dkPreparationFactorUi.isDanishPreparationBinaryPrepTaskSubjectType)(this.subjectType);
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    schoolCountry: function schoolCountry() {
	      return this.$store.getters.schoolCountry;
	    },
	    isSchoolFromNorway: function isSchoolFromNorway() {
	      return this.schoolCountry.toLowerCase() === 'no';
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    otherCalendars: function otherCalendars() {
	      return this.$store.getters.otherCalendars;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    localPoolTitle: function localPoolTitle() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || this.i18n[this.locale]['locale_pool'];
	    },
	    hoursType: function hoursType() {
	      switch (this.subjectType) {
	        case 'person_resource_visible':
	        case 'person_resource':
	        case 'subject':
	          return this.i18n[this.locale]['teaching'];
	        case 'preparation':
	          return this.i18n[this.locale]['preparation'];
	        case 'additional_tasks':
	          return this.i18n[this.locale]['additional_tasks'];
	        case 'available':
	          return this.i18n[this.locale]['available'];
	        case 'club':
	          return this.i18n[this.locale]['club'];
	        case 'pool':
	          return this.localPoolTitle;
	        case 'with_kids':
	          return 'Med børn';
	        case 'without_kids':
	          return 'Uden børn';
	        default:
	          return this.subjectType;
	      }
	    },
	    isCreateInOtherCalendarAnOption: function isCreateInOtherCalendarAnOption() {
	      return this.subjectType === 'without_kids' || this.subjectType === 'preparation' || this.subjectType === 'additional_tasks' || this.subjectType === 'pool' || this.subjectType === 'club';
	    },
	    taskCalendarType: function taskCalendarType() {
	      return this.subjectType === 'club' ? 'club' : 'other';
	    },
	    copyCalendarOptions: function copyCalendarOptions() {
	      return this.taskCalendarType === 'club' ? this.$store.getters.clubCalendars : this.otherCalendars;
	    },
	    canCopyToSharedCalendar: function canCopyToSharedCalendar() {
	      return !!(this.editTask && this.editTask.in_user_calendar && this.canSchedule && this.isCreateInOtherCalendarAnOption && this.copyCalendarOptions && this.copyCalendarOptions.length > 0);
	    },
	    usersWithEvents: function usersWithEvents() {
	      if (!this.editTask) {
	        return [];
	      }
	      var usersWithEvents = [];
	      var usersWithEventsHash = {};
	      this.editTask.subjects.forEach(function (subject) {
	        if (subject.has_events) {
	          if (subject.user_calendars.length > 0) {
	            subject.user_calendars.forEach(function (calId) {
	              if (!usersWithEventsHash[calId]) {
	                usersWithEventsHash[calId] = true;
	                usersWithEvents.push(calId);
	              }
	            });
	          } else {
	            if (!usersWithEventsHash[subject.calendar_id]) {
	              usersWithEventsHash[subject.calendar_id] = true;
	              usersWithEvents.push(subject.calendar_id);
	            }
	          }
	        }
	      });
	      return usersWithEvents;
	    },
	    theDeletedItemId: function theDeletedItemId() {
	      return this.$store.state.subjects.theDeletedItemId;
	    },
	    isSubmittingTask: function isSubmittingTask() {
	      return this.$store.state.subjects.isSubmittingTask;
	    },
	    today: function today() {
	      return (0, _moment2.default)().format('YYYY-MM-DD');
	    }
	  },
	  watch: {
	    editTask: function editTask() {
	      if (this.editTask) {
	        this.populateFromEditTask();
	        if (this.$refs.name) this.$refs.name.focus();
	      }
	    },
	    defaultDuration: function defaultDuration(val) {
	      this.removeErrors('defaultDuration');
	    },
	    theDeletedItemId: function theDeletedItemId() {
	      if (this.theDeletedItemId === this.editTask.id) {
	        this.close();
	      }
	    }
	  },
	  methods: {
	    toggleDateFields: function toggleDateFields() {
	      this.isShowDateFields = !this.isShowDateFields;
	      if (this.isShowDateFields) {
	        if (!this.fromDate && this.activeSchoolYear) {
	          this.fromDate = this.activeSchoolYear.employee_time_start || null;
	        }
	        if (!this.toDate && this.activeSchoolYear) {
	          this.toDate = this.activeSchoolYear.employee_time_end || null;
	        }
	      } else {
	        this.fromDate = null;
	        this.toDate = null;
	      }
	    },
	    setFromDate: function setFromDate(date) {
	      var formatted = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      this.fromDate = formatted;
	      if (this.toDate && formatted > this.toDate) {
	        this.toDate = formatted;
	      }
	    },
	    setToDate: function setToDate(date) {
	      var formatted = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      this.toDate = formatted;
	      if (this.fromDate && formatted < this.fromDate) {
	        this.fromDate = formatted;
	      }
	    },
	    selectAllOnFocus: function selectAllOnFocus(evt) {
	      setTimeout(function (_) {
	        evt.target.select();
	      }, 0);
	    },
	    getOtherCalendarName: function getOtherCalendarName(calId) {
	      var cal = this.allCalendarsInHash[calId];
	      return cal && (cal.type === 'other' || cal.type === 'club') ? cal.name : '';
	    },
	    setSelectedOtherCalendarId: function setSelectedOtherCalendarId(calendarId) {
	      this.selectedOtherCalendarId = calendarId;
	    },
	    setSubjectType: function setSubjectType(type) {
	      this.subjectType = type;
	      if (this.selectedOtherCalendarId) {
	        var cal = this.allCalendarsInHash[this.selectedOtherCalendarId];
	        if (!this.isCreateInOtherCalendarAnOption || !cal || cal.type !== this.taskCalendarType) {
	          this.selectedOtherCalendarId = null;
	        }
	      }
	    },
	    setColor: function setColor(color) {
	      this.color = color;
	    },
	    setSelectedUsers: function setSelectedUsers(users) {
	      this.calendars = users.map(function (user) {
	        return user.id;
	      });
	    },
	    setIsCreateAsSubject: function setIsCreateAsSubject(boolean) {
	      var _this = this;
	
	      this.canSchedule = boolean;
	      if (!boolean) {
	        this.setColor('#999999');
	      } else {
	        this.$nextTick(function (_) {
	          if (_this.$refs.inputLessonCount) {
	            _this.$refs.inputLessonCount.focus();
	          }
	        });
	      }
	    },
	    formValidation: function formValidation() {
	      if (this.name.length < 1) {
	        this.$set(this.formErrors, 'name', {
	          da: 'Opgaven skal have et navn',
	          en: 'Task must have a name',
	          nb: 'Opgave må ha et navn'
	        });
	      }
	      if (this.duration < 0) {
	        this.$set(this.formErrors, 'duration', {
	          da: 'Skal være 0 eller højere',
	          en: 'Must be zero or greater',
	          nb: 'Må være 0 eller høyere'
	        });
	      }
	    },
	    removeErrors: function removeErrors(title) {
	      this.$delete(this.formErrors, title);
	    },
	    createTask: function createTask() {
	      var keepOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      var belongsToCalendars = [];
	      var userCalendars = [];
	      var inUserCalendar = true;
	      if (this.selectedOtherCalendarId) {
	        inUserCalendar = false;
	        belongsToCalendars = [this.selectedOtherCalendarId];
	        userCalendars = this.calendars;
	      } else {
	        belongsToCalendars = this.calendars;
	      }
	      var newTask = {
	        schoolYearId: this.activeSchoolYear.id,
	        subjectType: this.subjectType,
	        hours: this.hours,
	        name: this.name,
	        color: this.color,
	        defaultDuration: this.duration,
	        preparation: this.preparationPayloadForSave(),
	        belongsToCalendars: belongsToCalendars,
	        userCalendars: userCalendars,
	        canSchedule: this.canSchedule,
	        inUserCalendar: inUserCalendar,
	        fromDate: this.fromDate || null,
	        toDate: this.toDate || null
	      };
	      this.$emit('create', newTask, { keepOpen: keepOpen });
	      this.clearForm();
	      if (this.$refs.name) this.$refs.name.focus();
	    },
	    copyTaskToSharedCalendar: function copyTaskToSharedCalendar(calendarId) {
	      if (!calendarId || this.isSubmittingTask) {
	        return;
	      }
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      var schoolYearId = this.editTask.school_year_id || this.activeSchoolYear && this.activeSchoolYear.id;
	      var newTask = {
	        schoolYearId: schoolYearId,
	        subjectType: this.subjectType,
	        hours: this.hours,
	        name: this.name,
	        color: this.color,
	        defaultDuration: this.duration,
	        preparation: this.preparationPayloadForSave(),
	        belongsToCalendars: [calendarId],
	        userCalendars: this.calendars.slice(),
	        canSchedule: this.canSchedule,
	        inUserCalendar: false,
	        fromDate: this.fromDate || null,
	        toDate: this.toDate || null
	      };
	      this.$store.dispatch('createTask', newTask);
	      _eventbus2.default.toast = { text: this.i18n[this.locale]['copied_to_shared_calendar'], success: true };
	      this.$emit('close', newTask);
	    },
	    updateTask: function updateTask() {
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      var task = this.editTask;
	      var userCalIdsCannotDelete = this.usersWithEvents || [];
	      var userCalendars = (0, _from2.default)(new _set2.default(this.calendars.concat(userCalIdsCannotDelete)));
	      var belongsToCalendars = [];
	      if (!task.in_user_calendar) {
	        belongsToCalendars = task.belongs_to_calendars[0];
	      } else {
	        belongsToCalendars = userCalendars;
	      }
	      var updatedTask = {
	        schoolId: this.editTask['school_id'],
	        schoolYearId: this.editTask['school_year_id'],
	        id: this.editTask['id'],
	        name: this.name,
	        color: this.color,
	        hours: this.hours,
	        defaultDuration: this.duration,
	        preparation: this.preparationPayloadForSave(),
	        belongsToCalendars: belongsToCalendars,
	        userCalendars: userCalendars,
	        inUserCalendar: this.editTask['in_user_calendar'],
	        fromDate: this.fromDate || null,
	        toDate: this.toDate || null
	      };
	      this.$store.dispatch('updateTask', updatedTask);
	      this.$emit('close', updatedTask);
	    },
	    clearForm: function clearForm() {
	      this.formErrors = [];
	      this.name = '';
	      this.hours = 0;
	      this.duration = 45;
	      this.preparation = null;
	      this.color = '#999999';
	      this.calendars = [];
	      this.selectedOtherCalendarId = null;
	      this.fromDate = null;
	      this.toDate = null;
	      this.isShowDateFields = false;
	    },
	    preparationPayloadForSave: function preparationPayloadForSave() {
	      return (0, _dkPreparationFactorUi.preparationPayloadForSave)(this.preparation, this.isShowDanishPreparationFactorField, this.subjectType);
	    },
	    preparationFromApiForForm: function preparationFromApiForForm(prep) {
	      return (0, _dkPreparationFactorUi.preparationFromApiForForm)(prep, this.isShowDanishPreparationFactorField, this.subjectType);
	    },
	    populateFromEditTask: function populateFromEditTask() {
	      var _this2 = this;
	
	      if (!this.editTask) return;
	      this.name = this.editTask.name;
	      this.hours = this.editTask.hours;
	      if (this.editTask.subject_type) {
	        this.subjectType = this.editTask.subject_type;
	      }
	      this.color = this.editTask.color;
	      this.canSchedule = this.editTask.can_schedule;
	      this.duration = this.editTask.default_duration;
	      if (this.editTask.preparation != null) {
	        this.preparation = this.preparationFromApiForForm(this.editTask.preparation);
	      } else {
	        this.preparation = null;
	      }
	      this.fromDate = this.editTask.from_date || null;
	      this.toDate = this.editTask.to_date || null;
	      this.isShowDateFields = !!(this.fromDate || this.toDate);
	      this.calendars = [];
	      if (this.editTask.user_calendar_ids) {
	        this.editTask.user_calendar_ids.forEach(function (calid) {
	          _this2.calendars.push(calid);
	        });
	      }
	      if (!this.editTask.in_user_calendar && this.editTask.belongs_to_calendars) {
	        this.selectedOtherCalendarId = this.editTask.belongs_to_calendars[0];
	      }
	    },
	    close: function close() {
	      this.clearForm();
	      this.canSchedule = true;
	      this.$emit('close');
	    },
	    deleteTask: function deleteTask() {
	      this.editTask['itemType'] = 'task';
	      this.$store.commit('setItemToDelete', this.editTask);
	      this.$store.commit('setConfirmDeletion', true);
	    },
	    onHandleKeyboardShortcutSubmit: function onHandleKeyboardShortcutSubmit(evt) {
	      if (this.isSubmittingTask) {
	        return;
	      }
	      if ((evt.ctrlKey || evt.metaKey) && (evt.key === 'Enter' || evt.keyCode === 13)) {
	        evt.preventDefault();
	        if (this.editTask) {
	          this.updateTask();
	        } else {
	          this.createTask();
	        }
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.locale = window.USER.language ? window.USER.language : 'da';
	    if (this.activeFilter) {
	      this.subjectType = this.activeFilter;
	    }
	    if (!this.editTask && this.prefill) {
	      if (this.prefill.name) this.name = this.prefill.name;
	      if (this.prefill.color) this.color = this.prefill.color;
	      if (this.prefill.subject_type) this.subjectType = this.prefill.subject_type;
	      if (this.prefill.can_schedule != null) this.canSchedule = this.prefill.can_schedule;
	      if (this.prefill.default_duration) this.duration = this.prefill.default_duration;
	      if (this.prefill.preparation != null) {
	        this.preparation = this.preparationFromApiForForm(this.prefill.preparation);
	      }
	      if (this.prefill.in_user_calendar === false && this.prefill.belongs_to_calendars && this.prefill.belongs_to_calendars[0]) {
	        this.selectedOtherCalendarId = this.prefill.belongs_to_calendars[0];
	      }
	      if (this.prefill.from_date) this.fromDate = this.prefill.from_date;
	      if (this.prefill.to_date) this.toDate = this.prefill.to_date;
	      if (this.prefill.from_date || this.prefill.to_date) this.isShowDateFields = true;
	    }
	    if (this.editTask) {
	      this.populateFromEditTask();
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    setTimeout(function (_) {
	      if (_this3.$refs.name) _this3.$refs.name.focus();
	    }, 500);
	    window.addEventListener('keydown', this.onHandleKeyboardShortcutSubmit);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('keydown', this.onHandleKeyboardShortcutSubmit);
	  }
	};

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _core = __webpack_require__(25);
	
	var _vueClickaway = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    own_calendars: 'I hver persons kalender'
	  },
	  nb: {
	    own_calendars: 'I hver lærers kalender'
	  },
	  en: {
	    own_calendars: 'Each teachers calendar'
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { DDropdown: _DDropdown2.default },
	  props: {
	    selectedCalendarId: {
	      default: null
	    },
	    calendarType: {
	      type: String,
	      default: 'other' }
	  },
	  data: function data() {
	    return {
	      isDropDown: false,
	      isPopperReady: false,
	      isPopperDone: false,
	      locale: window.USER.language ? window.USER.language : 'da'
	    };
	  },
	
	  computed: {
	    i18n: function i18n() {
	      return I18N;
	    },
	    selectedCalendar: function selectedCalendar() {
	      var _this = this;
	
	      if (!this.selectedCalendarId) {
	        return this.i18n[this.locale]['own_calendars'];
	      }
	      var cal = this.otherCalendars.filter(function (cal) {
	        return cal.id === _this.selectedCalendarId;
	      })[0];
	      return cal ? cal.name : this.i18n[this.locale]['own_calendars'];
	    },
	    otherCalendars: function otherCalendars() {
	      return this.calendarType === 'club' ? this.$store.getters.clubCalendars : this.$store.getters.otherCalendars;
	    }
	  },
	  methods: {
	    selectCalendar: function selectCalendar(calendar) {
	      this.$emit('changed', calendar);
	    },
	    createPopper: function createPopper() {
	      var _this2 = this;
	
	      this.isPopperReady = false;
	      this.isPopperDone = false;
	      var dChild = this.$refs.d_child;
	      var dParent = this.$refs.d_parent;
	      if (this.appendToBody) {
	        document.getElementById('djs-body-click').appendChild(dChild);
	      }
	      (0, _core.createPopper)(dParent, dChild, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, -1]
	          }
	        }]
	      });
	      setTimeout(function (_) {
	        _this2.isPopperReady = true;
	        _this2.isPopperDone = true;
	      }, 0);
	    },
	    setDropdown: function setDropdown() {
	      var _this3 = this;
	
	      this.isDropDown = !this.isDropDown;
	      if (this.isDropDown) {
	        setTimeout(function (_) {
	          _this3.createPopper();
	        }, 0);
	      } else {
	        this.isPopperReady = false;
	        this.isPopperDone = false;
	      }
	    },
	    setDropdownFromClick: function setDropdownFromClick() {
	      if (!this.isDropDown) {
	        return;
	      }
	      this.setDropdown();
	    }
	  }
	};

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(51);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _set = __webpack_require__(27);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _from = __webpack_require__(32);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _values = __webpack_require__(33);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _SubjectsDistributionTasksFromSubjectsCreate = __webpack_require__(1628);
	
	var _SubjectsDistributionTasksFromSubjectsCreate2 = _interopRequireDefault(_SubjectsDistributionTasksFromSubjectsCreate);
	
	var _DSelectCalsIds = __webpack_require__(40);
	
	var _DSelectCalsIds2 = _interopRequireDefault(_DSelectCalsIds);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _subjectTypes = __webpack_require__(157);
	
	var _vueClickaway = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var XLSX = null;
	
	var I18N = {
	  da: {
	    create_tasks: 'Opret opgave',
	    teaching: 'Undervisning',
	    additional_tasks: 'Øvrige opgaver',
	    preparation: 'Forberedelse',
	    pool: 'Lokalpulje',
	    club: 'SFO',
	    available: 'Rådighedstimer',
	    task_names: 'Opgavens titel',
	    brick_type: 'Type',
	    tasks_label: 'Opgaver',
	    of: 'af',
	    all: 'Alle',
	    hours_short: 't',
	    no_tasks: 'Ingen opgaver',
	    hours: 'Timer',
	    type: 'Type',
	    users: 'Brugere',
	    total: 'Total',
	    calendar: 'Kalender',
	    own_calendar: 'Egen',
	    new_task: '+ Ny opgave',
	    create_copy: 'Opret kopi',
	    select_task: 'Vælg en opgave i listen',
	    task: 'Opgave',
	    tasks_sheet: 'Opgaver',
	    tasks_status: 'Status',
	    only_tasks_with_users: 'Vis opgaver med personale',
	    only_tasks_without_users: 'Vis opgaver uden personale',
	    view: 'Visning',
	    show_users_in_table: 'Vis brugere i tabellen',
	    show_calendar_in_table: 'Vis kalender i tabellen',
	    show_total_in_table: 'Vis total i tabellen',
	    show_dates_in_table: 'Vis datoer i tabellen',
	    unmerge_tasks: 'Vis én linje pr. brik',
	    dates: 'Datoer',
	    bulk_actions: 'Massehandling',
	    select_all_visible: 'Vælg alle synlige',
	    deselect_all: 'Fravælg alle',
	    selected: 'valgt',
	    cancel: 'Annullér',
	    apply: 'Anvend',
	    change_type: 'Skift briktype',
	    change_hours: 'Skift timetal',
	    change_dates: 'Skift datoer',
	    delete_subjects: 'Slet brikker',
	    delete: 'Slet',
	    choose_type_placeholder: 'Vælg ny type …',
	    hours_placeholder: 'Nyt timetal',
	    bulk_subject_type_updated: 'Briktype opdateret',
	    bulk_subject_type_failed: 'Kunne ikke opdatere briktype',
	    bulk_hours_updated: 'Timetal opdateret',
	    bulk_hours_failed: 'Kunne ikke opdatere timetal',
	    bulk_dates_updated: 'Datoer opdateret',
	    bulk_dates_failed: 'Kunne ikke opdatere datoer',
	    bulk_delete_success: 'Brikker slettet',
	    bulk_delete_failed: 'Kunne ikke slette brikker',
	    bulk_delete_skipped: 'brikker kunne ikke slettes pga. skemalagte begivenheder',
	    bulk_delete_all_skipped: 'Alle valgte brikker har skemalagte begivenheder og kan ikke slettes',
	    bulk_delete_confirm: 'Er du sikker på, at du vil slette de valgte brikker?',
	    bulk_dates_out_of_range: 'Datoer skal være inden for skoleåret'
	  },
	  nb: {
	    create_tasks: 'Opprett oppgaver',
	    teaching: 'Undervisning',
	    additional_tasks: 'Øvrige oppgaver',
	    preparation: 'Forberedelse',
	    pool: 'Planleggingsdager',
	    club: 'SFO',
	    available: 'Rådighetstimer',
	    task_names: 'Oppgave',
	    brick_type: 'Type',
	    tasks_label: 'Oppgaver',
	    of: 'av',
	    all: 'Alle',
	    hours_short: 't',
	    no_tasks: 'Ingen oppgaver',
	    hours: 'Timer',
	    type: 'Type',
	    users: 'Brukere',
	    total: 'Totalt',
	    calendar: 'Kalender',
	    own_calendar: 'Egen',
	    new_task: '+ Ny oppgave',
	    create_copy: 'Opprett kopi',
	    select_task: 'Velg en oppgave i listen',
	    task: 'Oppgave',
	    tasks_sheet: 'Oppgaver',
	    tasks_status: 'Status',
	    only_tasks_with_users: 'Vis oppgaver med personale',
	    only_tasks_without_users: 'Vis oppgaver uten personale',
	    view: 'Visning',
	    show_users_in_table: 'Vis brukere i tabellen',
	    show_calendar_in_table: 'Vis kalender i tabellen',
	    show_total_in_table: 'Vis totalt i tabellen',
	    show_dates_in_table: 'Vis datoer i tabellen',
	    unmerge_tasks: 'Vis én linje per brikk',
	    dates: 'Datoer',
	    bulk_actions: 'Massehandling',
	    select_all_visible: 'Velg alle synlige',
	    deselect_all: 'Fravelg alle',
	    selected: 'valgt',
	    cancel: 'Avbryt',
	    apply: 'Bruk',
	    change_type: 'Endre brikktype',
	    change_hours: 'Endre timetall',
	    change_dates: 'Endre datoer',
	    delete_subjects: 'Slett brikker',
	    delete: 'Slett',
	    choose_type_placeholder: 'Velg ny type …',
	    hours_placeholder: 'Nytt timetall',
	    bulk_subject_type_updated: 'Brikktype oppdatert',
	    bulk_subject_type_failed: 'Kunne ikke oppdatere brikktype',
	    bulk_hours_updated: 'Timetall oppdatert',
	    bulk_hours_failed: 'Kunne ikke oppdatere timetall',
	    bulk_dates_updated: 'Datoer oppdatert',
	    bulk_dates_failed: 'Kunne ikke oppdatere datoer',
	    bulk_delete_success: 'Brikker slettet',
	    bulk_delete_failed: 'Kunne ikke slette brikker',
	    bulk_delete_skipped: 'brikker kunne ikke slettes pga. skemalagte hendelser',
	    bulk_delete_all_skipped: 'Alle valgte brikker har skemalagte hendelser og kan ikke slettes',
	    bulk_delete_confirm: 'Er du sikker på at du vil slette de valgte brikkene?',
	    bulk_dates_out_of_range: 'Datoer må være innenfor skoleåret'
	  },
	  en: {
	    create_tasks: 'Create task',
	    teaching: 'Teaching',
	    additional_tasks: 'Additional tasks',
	    preparation: 'Preparation',
	    pool: 'Custom pool',
	    club: 'Club',
	    available: 'Available hours',
	    task_names: 'Task',
	    brick_type: 'Type',
	    tasks_label: 'Tasks',
	    of: 'of',
	    all: 'All',
	    hours_short: 'h',
	    no_tasks: 'No tasks',
	    hours: 'Hours',
	    type: 'Type',
	    users: 'Users',
	    total: 'Total',
	    calendar: 'Calendar',
	    own_calendar: 'Own',
	    new_task: '+ New task',
	    create_copy: 'Create copy',
	    select_task: 'Select a task from the list',
	    task: 'Task',
	    tasks_sheet: 'Tasks',
	    tasks_status: 'Status',
	    only_tasks_with_users: 'Show tasks with personnel',
	    only_tasks_without_users: 'Show tasks without personnel',
	    view: 'View',
	    show_users_in_table: 'Show users in table',
	    show_calendar_in_table: 'Show calendar in table',
	    show_total_in_table: 'Show total in table',
	    show_dates_in_table: 'Show dates in table',
	    unmerge_tasks: 'Show one row per tile',
	    dates: 'Dates',
	    bulk_actions: 'Bulk actions',
	    select_all_visible: 'Select all visible',
	    deselect_all: 'Deselect all',
	    selected: 'selected',
	    cancel: 'Cancel',
	    apply: 'Apply',
	    change_type: 'Change tile type',
	    change_hours: 'Change hours',
	    change_dates: 'Change dates',
	    delete_subjects: 'Delete tiles',
	    delete: 'Delete',
	    choose_type_placeholder: 'Choose new type …',
	    hours_placeholder: 'New hours',
	    bulk_subject_type_updated: 'Tile type updated',
	    bulk_subject_type_failed: 'Failed to update tile type',
	    bulk_hours_updated: 'Hours updated',
	    bulk_hours_failed: 'Failed to update hours',
	    bulk_dates_updated: 'Dates updated',
	    bulk_dates_failed: 'Failed to update dates',
	    bulk_delete_success: 'Tiles deleted',
	    bulk_delete_failed: 'Failed to delete tiles',
	    bulk_delete_skipped: 'tiles could not be deleted due to scheduled events',
	    bulk_delete_all_skipped: 'All selected tiles have scheduled events and cannot be deleted',
	    bulk_delete_confirm: 'Are you sure you want to delete the selected tiles?',
	    bulk_dates_out_of_range: 'Dates must be within the school year'
	  }
	};
	
	var TASK_ALWAYS_TYPES = ['club', 'pool', 'person_resource', 'preparation', 'additional_tasks', 'with_kids', 'without_kids'];
	var TASK_TEACHING_TYPES = ['subject', 'person_resource_visible', 'with_kids', 'without_kids', 'available'];
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { CreateTask: _SubjectsDistributionTasksFromSubjectsCreate2.default, DSelectCalendarIds: _DSelectCalsIds2.default, DoFiltersFilter: _DoFiltersFilter2.default, DDropdown: _DDropdown2.default, DatePickerRange: _DatePickerRange2.default },
	  data: function data() {
	    return {
	      locale: window.USER && window.USER.language ? window.USER.language : 'da',
	      activeGroup: null,
	      isTaskModal: false,
	      editTask: null,
	      isLoadingFreshTask: false,
	      prefillTask: null,
	      isQuickCreate: false,
	      activeDSelect: null,
	      activeDSelectShow: false,
	      selectedFilterSubjectTypes: [],
	      selectedFilterTaskNames: [],
	      selectedFilterTaskStatus: [],
	      isDownloading: false,
	      sidebarCollapsed: false,
	      showUsersInTable: true,
	      showCalendarInTable: true,
	      showTotalInTable: true,
	      showDatesInTable: false,
	      unmergeTasks: false,
	      bulkActionMode: false,
	      bulkActionType: '',
	      selectedRowIds: [],
	      bulkSubjectType: '',
	      bulkHours: null,
	      bulkFromDate: null,
	      bulkToDate: null,
	      isApplyingBulk: false,
	      calSubjectTypes: []
	    };
	  },
	
	  computed: {
	    i18n: function i18n() {
	      return I18N;
	    },
	    isSubmittingTask: function isSubmittingTask() {
	      return this.$store.state.subjects.isSubmittingTask;
	    },
	    isSchoolFeatureLocalePool: function isSchoolFeatureLocalePool() {
	      return this.$store.getters.isSchoolFeatureLocalePool;
	    },
	    isKindergarten: function isKindergarten() {
	      return this.$store.getters.isKindergarten;
	    },
	    schoolCountry: function schoolCountry() {
	      var school = this.$store.state.activeSchool || window.SCHOOL;
	      return school && school.country ? school.country : null;
	    },
	    localPoolTitle: function localPoolTitle() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || this.i18n[this.locale]['pool'];
	    },
	    subjects: function subjects() {
	      return this.$store.state.subjects.subjects || [];
	    },
	    backendTasks: function backendTasks() {
	      return this.$store.state.subjects.tasks || [];
	    },
	    tasks: function tasks() {
	      var _this = this;
	
	      var cals = this.allCalendarsInHash;
	      var backendTaskBySubjectId = {};
	      this.backendTasks.forEach(function (bt) {
	        (bt.subject_ids || []).forEach(function (sid) {
	          backendTaskBySubjectId[sid] = bt;
	        });
	      });
	      var map = {};
	      this.subjects.forEach(function (s) {
	        var owner = cals[s.calendar_id];
	        var isAlways = TASK_ALWAYS_TYPES.indexOf(s.subject_type) > -1;
	        var isTeaching = TASK_TEACHING_TYPES.indexOf(s.subject_type) > -1;
	        var ownerIsUser = owner && owner.type === 'user';
	        var ownerIsNull = !s.calendar_id || !owner;
	        var included = isAlways || isTeaching && (ownerIsUser || ownerIsNull);
	        if (!included) return;
	
	        var inUserCalendar = !owner || owner.type === 'user';
	        var userCalendarsOfSubject = [];
	        var seenUserCals = {};
	        var addUserCal = function addUserCal(id) {
	          if (id == null || seenUserCals[id]) return;
	          var cal = cals[id];
	          if (cal && cal.type === 'user') {
	            seenUserCals[id] = true;
	            userCalendarsOfSubject.push(id);
	          }
	        };(s.calendar_ids || []).forEach(addUserCal);
	        if (Array.isArray(s.cals)) {
	          s.cals.forEach(function (cal) {
	            if (cal && cal.calendar_type === 'user') addUserCal(cal.id);
	          });
	        }
	        var hasEvents = s.can_delete === false;
	
	        var hoursKey = s.hours == null ? '' : s.hours;
	        var prepKey = s.preparation == null ? '' : s.preparation;
	        var subjectKey = _this.unmergeTasks ? s.id : '';
	        var ownerKey = inUserCalendar ? '' : s.calendar_id || '';
	        var key = [s.school_id, s.school_year_id, s.subject_type, hoursKey, inUserCalendar, s.can_schedule, s.name, prepKey, subjectKey, ownerKey].join(';');
	
	        if (!map[key]) {
	          map[key] = {
	            id: [s.school_id, s.school_year_id, s.subject_type, hoursKey, inUserCalendar, s.can_schedule, s.name, prepKey, subjectKey, ownerKey].join(';'),
	            school_id: s.school_id,
	            school_year_id: s.school_year_id,
	            name: s.name,
	            subject_type: s.subject_type,
	            hours: parseFloat(s.hours) || 0,
	            preparation: s.preparation,
	            can_schedule: s.can_schedule,
	            in_user_calendar: inUserCalendar,
	            color: s.color,
	            default_duration: s.default_duration,
	            from_date: s.from_date || null,
	            to_date: s.to_date || null,
	            belongs_to_calendars: [],
	            user_calendars: [],
	            subject_ids: [],
	            subjects: []
	          };
	        }
	        var group = map[key];
	
	        if (s.color != null && (group.color == null || String(s.color) < String(group.color))) {
	          group.color = s.color;
	        }
	        if (s.default_duration != null && (group.default_duration == null || s.default_duration < group.default_duration)) {
	          group.default_duration = s.default_duration;
	        }
	        if (s.from_date != null && (group.from_date == null || s.from_date > group.from_date)) {
	          group.from_date = s.from_date;
	        }
	        if (s.to_date != null && (group.to_date == null || s.to_date > group.to_date)) {
	          group.to_date = s.to_date;
	        }
	
	        group.belongs_to_calendars.push(s.calendar_id);
	        userCalendarsOfSubject.forEach(function (id) {
	          return group.user_calendars.push(id);
	        });
	        group.subject_ids.push(s.id);
	        group.subjects.push({
	          id: s.id,
	          calendar_id: s.calendar_id,
	          has_events: hasEvents,
	          user_calendars: userCalendarsOfSubject.slice()
	        });
	      });
	
	      var tasks = (0, _values2.default)(map);
	      tasks.forEach(function (t) {
	        t.user_calendar_ids = t.in_user_calendar ? t.belongs_to_calendars.slice() : t.user_calendars.slice();
	
	        if (t.subject_ids && t.subject_ids.length) {
	          var bt = backendTaskBySubjectId[t.subject_ids[0]];
	          if (bt && bt.id) {
	            t._generatedId = t.id;
	            t.id = bt.id;
	          }
	        }
	      });
	      return tasks;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    visibleTasks: function visibleTasks() {
	      var calendarsHash = this.allCalendarsInHash;
	      return this.tasks.filter(function (task) {
	        var subjects = task.subjects || [];
	        if (subjects.length === 0) return true;
	        return !subjects.every(function (s) {
	          var ownerCal = calendarsHash[s.calendar_id];
	          return ownerCal && ownerCal.type === 'klass';
	        });
	      });
	    },
	    tasksTeaching: function tasksTeaching() {
	      return this.visibleTasks.filter(function (t) {
	        return t.subject_type === 'person_resource_visible' || t.subject_type === 'person_resource' || t.subject_type === 'subject';
	      });
	    },
	    tasksTasks: function tasksTasks() {
	      return this.visibleTasks.filter(function (t) {
	        return t.subject_type === 'additional_tasks';
	      });
	    },
	    tasksPrep: function tasksPrep() {
	      return this.visibleTasks.filter(function (t) {
	        return t.subject_type === 'preparation';
	      });
	    },
	    tasksPool: function tasksPool() {
	      return this.visibleTasks.filter(function (t) {
	        return t.subject_type === 'pool';
	      });
	    },
	    tasksClub: function tasksClub() {
	      return this.visibleTasks.filter(function (t) {
	        return t.subject_type === 'club';
	      });
	    },
	    tasksAvailable: function tasksAvailable() {
	      return this.visibleTasks.filter(function (t) {
	        return t.subject_type === 'available';
	      });
	    },
	    filters: function filters() {
	      var filters = [{ label: this.i18n[this.locale]['teaching'], value: 'teaching', length: this.tasksTeaching.length }, { label: this.i18n[this.locale]['additional_tasks'], value: 'additional_tasks', length: this.tasksTasks.length }, { label: this.i18n[this.locale]['preparation'], value: 'preparation', length: this.tasksPrep.length }, { label: this.localPoolTitle, value: 'pool', length: this.tasksPool.length }, { label: this.i18n[this.locale]['club'], value: 'club', length: this.tasksClub.length }, { label: this.i18n[this.locale]['available'], value: 'available', length: this.tasksAvailable.length }];
	      return this.isSchoolFeatureLocalePool ? filters : filters.filter(function (f) {
	        return f.value !== 'pool';
	      });
	    },
	    filterLabels: function filterLabels() {
	      return this.filters.map(function (f) {
	        return f.label;
	      });
	    },
	    selectedFilterSubjectTypesValue: function selectedFilterSubjectTypesValue() {
	      var _this2 = this;
	
	      return this.filters.filter(function (f) {
	        return _this2.selectedFilterSubjectTypes.includes(f.label);
	      }).map(function (f) {
	        return f.value;
	      });
	    },
	    taskNameLabels: function taskNameLabels() {
	      var names = this.visibleTasks.map(function (t) {
	        return t && t.name ? String(t.name).trim() : '';
	      }).filter(function (n) {
	        return n.length > 0;
	      });
	      return (0, _from2.default)(new _set2.default(names)).sort(function (a, b) {
	        return a.localeCompare(b);
	      });
	    },
	    onlyTasksWithUsersI18n: function onlyTasksWithUsersI18n() {
	      return this.i18n[this.locale].only_tasks_with_users;
	    },
	    onlyTasksWithoutUsersI18n: function onlyTasksWithoutUsersI18n() {
	      return this.i18n[this.locale].only_tasks_without_users;
	    },
	    taskStatusFilters: function taskStatusFilters() {
	      return [this.onlyTasksWithUsersI18n, this.onlyTasksWithoutUsersI18n];
	    },
	    filteredTasks: function filteredTasks() {
	      var calendarsHash = this.allCalendarsInHash;
	      var sanitize = function sanitize(task) {
	        var all = task.user_calendar_ids || [];
	        var users = [];
	        var nonUsers = [];
	        all.forEach(function (calId) {
	          var cal = calendarsHash[calId];
	          if (cal && cal.type === 'user') {
	            users.push(calId);
	          } else if (calId != null) {
	            nonUsers.push(calId);
	          }
	        });
	        users.sort(function (a, b) {
	          return (calendarsHash[a].name || '').localeCompare(calendarsHash[b].name || '', 'da');
	        });
	        return (0, _assign2.default)({}, task, {
	          user_calendar_ids: users,
	          _nonUserCalendarIds: nonUsers
	        });
	      };
	
	      var selectedValues = this.selectedFilterSubjectTypesValue;
	      var base = [];
	      if (!selectedValues.length || selectedValues.includes('')) {
	        base = this.visibleTasks.map(sanitize);
	      } else {
	        if (selectedValues.includes('teaching')) base = base.concat(this.tasksTeaching.map(sanitize));
	        if (selectedValues.includes('additional_tasks')) base = base.concat(this.tasksTasks.map(sanitize));
	        if (selectedValues.includes('preparation')) base = base.concat(this.tasksPrep.map(sanitize));
	        if (selectedValues.includes('pool')) base = base.concat(this.tasksPool.map(sanitize));
	        if (selectedValues.includes('club')) base = base.concat(this.tasksClub.map(sanitize));
	        if (selectedValues.includes('available')) base = base.concat(this.tasksAvailable.map(sanitize));
	      }
	      if (this.selectedFilterTaskNames && this.selectedFilterTaskNames.length > 0) {
	        var selectedNames = this.selectedFilterTaskNames;
	        base = base.filter(function (t) {
	          var n = t && t.name ? String(t.name).trim() : '';
	          return n.length > 0 && selectedNames.indexOf(n) > -1;
	        });
	      }
	      if (this.selectedFilterTaskStatus && this.selectedFilterTaskStatus.length > 0) {
	        var hasFilterWithUsers = this.selectedFilterTaskStatus.indexOf(this.onlyTasksWithUsersI18n) > -1;
	        var hasFilterWithoutUsers = this.selectedFilterTaskStatus.indexOf(this.onlyTasksWithoutUsersI18n) > -1;
	        base = base.filter(function (task) {
	          var hasUsers = (task.user_calendar_ids || []).length > 0;
	          return hasFilterWithUsers && hasUsers || hasFilterWithoutUsers && !hasUsers;
	        });
	      }
	      return base;
	    },
	    groupedTasks: function groupedTasks() {
	      var _this3 = this;
	
	      var map = {};
	      this.filteredTasks.forEach(function (task) {
	        var name = (task.name || '').trim();
	        if (!name) return;
	        if (!map[name]) {
	          map[name] = {
	            name: name,
	            color: task.color || '#ccc',
	            tasks: [],
	            totalHours: 0,
	            weightedHours: 0
	          };
	        }
	        map[name].tasks.push(task);
	        var h = parseFloat(task.hours) || 0;
	        map[name].totalHours += h;
	        map[name].weightedHours += _this3.getTaskWeightedTotal(task);
	      });
	      return (0, _values2.default)(map).sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    filteredGroupedTasks: function filteredGroupedTasks() {
	      return this.groupedTasks;
	    },
	    totalGroupCount: function totalGroupCount() {
	      var names = new _set2.default();
	      this.visibleTasks.forEach(function (t) {
	        var n = (t.name || '').trim();
	        if (n) names.add(n);
	      });
	      return names.size;
	    },
	    allFilteredWeightedHours: function allFilteredWeightedHours() {
	      var sum = 0;
	      this.filteredGroupedTasks.forEach(function (g) {
	        sum += g.weightedHours;
	      });
	      return sum;
	    },
	    allGroupData: function allGroupData() {
	      var allTasks = [];
	      var totalHours = 0;
	      var weightedHours = 0;
	      this.filteredGroupedTasks.forEach(function (g) {
	        g.tasks.forEach(function (t) {
	          return allTasks.push(t);
	        });
	        totalHours += g.totalHours;
	        weightedHours += g.weightedHours;
	      });
	      var sorted = allTasks.slice().sort(function (a, b) {
	        var nameCmp = (a.name || '').localeCompare(b.name || '');
	        if (nameCmp !== 0) return nameCmp;
	        return (parseFloat(b.hours) || 0) - (parseFloat(a.hours) || 0);
	      });
	      return { name: this.i18n[this.locale]['all'], color: '#8898aa', tasks: sorted, totalHours: totalHours, weightedHours: weightedHours };
	    },
	    activeGroupName: function activeGroupName() {
	      var _this4 = this;
	
	      if (this.activeGroup === '__all__') return '__all__';
	      if (this.activeGroup) {
	        var exists = this.filteredGroupedTasks.find(function (g) {
	          return g.name === _this4.activeGroup;
	        });
	        if (exists) return this.activeGroup;
	      }
	      return '__all__';
	    },
	    activeGroupData: function activeGroupData() {
	      var _this5 = this;
	
	      if (this.activeGroupName === '__all__') return this.allGroupData;
	      var group = this.filteredGroupedTasks.find(function (g) {
	        return g.name === _this5.activeGroupName;
	      });
	      if (!group) return null;
	      var sorted = group.tasks.slice().sort(function (a, b) {
	        var nameCmp = (a.name || '').localeCompare(b.name || '');
	        if (nameCmp !== 0) return nameCmp;
	        return (parseFloat(b.hours) || 0) - (parseFloat(a.hours) || 0);
	      });
	      return (0, _assign2.default)({}, group, { tasks: sorted });
	    },
	    visibleColumnCount: function visibleColumnCount() {
	      var count = 4;
	      if (this.showCalendarInTable) count++;
	      if (this.showDatesInTable) count++;
	      if (this.showUsersInTable) count++;
	      if (this.showTotalInTable) count++;
	      if (this.bulkActionMode) count++;
	      return count;
	    },
	    taskByRowId: function taskByRowId() {
	      var map = {};
	      this.tasks.forEach(function (task) {
	        var rowId = task._generatedId || task.id;
	        map[rowId] = task;
	      });
	      return map;
	    },
	    visibleRowIds: function visibleRowIds() {
	      if (!this.activeGroupData) return [];
	      return this.activeGroupData.tasks.map(function (task) {
	        return task._generatedId || task.id;
	      });
	    },
	    allVisibleSelected: function allVisibleSelected() {
	      var _this6 = this;
	
	      if (this.visibleRowIds.length === 0) return false;
	      return this.visibleRowIds.every(function (rowId) {
	        return _this6.selectedRowIds.indexOf(rowId) !== -1;
	      });
	    },
	    bulkSubjectTypeOptions: function bulkSubjectTypeOptions() {
	      var _this7 = this;
	
	      var stripHtml = function stripHtml(html) {
	        if (!html) return '';
	        var tmp = document.createElement('div');
	        tmp.innerHTML = html;
	        return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
	      };
	      var dbSubjectTypes = this.calSubjectTypes.filter(function (type) {
	        return !(type === 'other_stuff' || type === 'other_tasks');
	      });
	      var typesMap = this.isKindergarten ? _subjectTypes.kindergartenTypes : _subjectTypes.allTypes;
	      var arr = [];
	      dbSubjectTypes.forEach(function (activeType) {
	        if (!typesMap[activeType]) return;
	        var localeEntry = typesMap[activeType].filter(function (t) {
	          return t.lang === _this7.locale;
	        })[0];
	        if (localeEntry) arr.push(localeEntry);
	      });
	      if (this.localPoolTitle) {
	        arr = arr.map(function (t) {
	          return t.value === 'pool' ? (0, _assign2.default)({}, t, { name: _this7.localPoolTitle }) : t;
	        });
	      }
	      if (!this.isSchoolFeatureLocalePool) {
	        arr = arr.filter(function (t) {
	          return t.value !== 'pool';
	        });
	      }
	      arr.sort(function (a, b) {
	        return a.order > b.order ? 1 : -1;
	      });
	      return arr.map(function (t) {
	        return { value: t.value, label: stripHtml(t.name) };
	      });
	    },
	    bulkDateMin: function bulkDateMin() {
	      if (this.activeSchoolYear && this.activeSchoolYear.employee_time_start) {
	        return (0, _moment2.default)(this.activeSchoolYear.employee_time_start);
	      }
	      return null;
	    },
	    bulkDateMax: function bulkDateMax() {
	      if (this.activeSchoolYear && this.activeSchoolYear.employee_time_end) {
	        return (0, _moment2.default)(this.activeSchoolYear.employee_time_end);
	      }
	      return null;
	    },
	    selectedSubjectIds: function selectedSubjectIds() {
	      var _this8 = this;
	
	      var ids = [];
	      var seen = {};
	      this.selectedRowIds.forEach(function (rowId) {
	        var task = _this8.taskByRowId[rowId];
	        if (!task) return;
	        var subjectIds = task.subject_ids || [];
	        subjectIds.forEach(function (sid) {
	          if (!seen[sid]) {
	            seen[sid] = true;
	            ids.push(sid);
	          }
	        });
	      });
	      return ids;
	    },
	    deletableSubjectIds: function deletableSubjectIds() {
	      var _this9 = this;
	
	      var ids = [];
	      var seen = {};
	      this.selectedRowIds.forEach(function (rowId) {
	        var task = _this9.taskByRowId[rowId];
	        if (!task) return;
	        var subjects = task.subjects || [];
	        subjects.forEach(function (subj) {
	          if (subj.has_events) return;
	          if (!seen[subj.id]) {
	            seen[subj.id] = true;
	            ids.push(subj.id);
	          }
	        });
	      });
	      return ids;
	    },
	    skippedSubjectCount: function skippedSubjectCount() {
	      return this.selectedSubjectIds.length - this.deletableSubjectIds.length;
	    }
	  },
	  watch: {
	    showUsersInTable: function showUsersInTable(val) {
	      this.$helpers.setLocalStorage('doSubjectsDistributionTasksFromSubjectsShowUsers', val);
	    },
	    showCalendarInTable: function showCalendarInTable(val) {
	      this.$helpers.setLocalStorage('doSubjectsDistributionTasksFromSubjectsShowCalendar', val);
	    },
	    showTotalInTable: function showTotalInTable(val) {
	      this.$helpers.setLocalStorage('doSubjectsDistributionTasksFromSubjectsShowTotal', val);
	    },
	    showDatesInTable: function showDatesInTable(val) {
	      this.$helpers.setLocalStorage('doSubjectsDistributionTasksFromSubjectsShowDates', val);
	    },
	    sidebarCollapsed: function sidebarCollapsed(val) {
	      this.$helpers.setLocalStorage('doSubjectsDistributionTasksFromSubjectsSidebarCollapsed', val);
	    },
	    unmergeTasks: function unmergeTasks(val) {
	      this.$helpers.setLocalStorage('doSubjectsDistributionTasksFromSubjectsUnmergeTasks', val);
	    }
	  },
	  created: function created() {
	    var _this10 = this;
	
	    var storedShowUsers = this.$helpers.getLocalStorage('doSubjectsDistributionTasksFromSubjectsShowUsers');
	    if (storedShowUsers === 'false') {
	      this.showUsersInTable = false;
	    }
	    var storedShowCalendar = this.$helpers.getLocalStorage('doSubjectsDistributionTasksFromSubjectsShowCalendar');
	    if (storedShowCalendar === 'false') {
	      this.showCalendarInTable = false;
	    }
	    var storedShowTotal = this.$helpers.getLocalStorage('doSubjectsDistributionTasksFromSubjectsShowTotal');
	    if (storedShowTotal === 'false') {
	      this.showTotalInTable = false;
	    }
	    var storedShowDates = this.$helpers.getLocalStorage('doSubjectsDistributionTasksFromSubjectsShowDates');
	    if (storedShowDates === 'true') {
	      this.showDatesInTable = true;
	    }
	    var storedSidebarCollapsed = this.$helpers.getLocalStorage('doSubjectsDistributionTasksFromSubjectsSidebarCollapsed');
	    if (storedSidebarCollapsed === 'true') {
	      this.sidebarCollapsed = true;
	    }
	    var storedUnmergeTasks = this.$helpers.getLocalStorage('doSubjectsDistributionTasksFromSubjectsUnmergeTasks');
	    if (storedUnmergeTasks === 'true') {
	      this.unmergeTasks = true;
	    }
	    _docendo2.default.subjectsForCalendarType('user', this.schoolCountry, function (data) {
	      _this10.calSubjectTypes = data || [];
	    });
	  },
	
	  methods: {
	    getTaskWeightedTotal: function getTaskWeightedTotal(task) {
	      var baseHours = parseFloat(task.hours) || 0;
	      var userCalIds = task.user_calendar_ids || [];
	      if (!userCalIds.length) return 0;
	
	      var subjectId = task.subjects && task.subjects.length ? task.subjects[0].id : task.subject_ids && task.subject_ids.length ? task.subject_ids[0] : null;
	      var subj = subjectId ? this.subjectsInHash[subjectId] : null;
	      var scList = subj && subj.subject_calendars ? subj.subject_calendars : [];
	
	      var total = 0;
	
	      var _loop = function _loop(i) {
	        var sc = scList.find(function (s) {
	          return s.calendar_id === userCalIds[i] && s.hours != null;
	        });
	        total += sc ? parseFloat(sc.hours) : baseHours;
	      };
	
	      for (var i = 0; i < userCalIds.length; i++) {
	        _loop(i);
	      }
	      return parseFloat(total.toFixed(2));
	    },
	    toggleFilter: function toggleFilter(filter, filterArray) {
	      if (filterArray.includes(filter)) {
	        filterArray.splice(filterArray.indexOf(filter), 1);
	      } else {
	        filterArray.push(filter);
	      }
	    },
	    toggleFilterTaskNames: function toggleFilterTaskNames(tag) {
	      this.toggleFilter(tag, this.selectedFilterTaskNames);
	    },
	    toggleFilterSubjectTypes: function toggleFilterSubjectTypes(tag) {
	      this.toggleFilter(tag, this.selectedFilterSubjectTypes);
	    },
	    toggleFilterTaskStatus: function toggleFilterTaskStatus(tag) {
	      this.toggleFilter(tag, this.selectedFilterTaskStatus);
	    },
	    getTaskTypeLabel: function getTaskTypeLabel(task) {
	      var t = task.subject_type;
	      if (t === 'person_resource_visible' || t === 'person_resource' || t === 'subject') return this.i18n[this.locale]['teaching'];
	      if (t === 'additional_tasks') return this.i18n[this.locale]['additional_tasks'];
	      if (t === 'preparation') return this.i18n[this.locale]['preparation'];
	      if (t === 'pool') return this.localPoolTitle;
	      if (t === 'club') return this.i18n[this.locale]['club'];
	      if (t === 'available') return this.i18n[this.locale]['available'];
	      return '';
	    },
	    setActiveGroup: function setActiveGroup(name) {
	      this.activeGroup = name;
	    },
	    getUserNames: function getUserNames(calIds) {
	      var _this11 = this;
	
	      return calIds.map(function (calId) {
	        return _this11.allCalendarsInHash[calId] ? _this11.allCalendarsInHash[calId].name : '';
	      }).filter(function (n) {
	        return n.length > 0;
	      });
	    },
	    getUsersWithEvents: function getUsersWithEvents(task) {
	      var usersWithEvents = [];
	      var seen = {};
	      var subjects = task.subjects || [];
	      subjects.forEach(function (subject) {
	        if (!subject.has_events) return;
	        if (subject.user_calendars && subject.user_calendars.length > 0) {
	          subject.user_calendars.forEach(function (calId) {
	            if (!seen[calId]) {
	              seen[calId] = true;
	              usersWithEvents.push(calId);
	            }
	          });
	        } else if (subject.calendar_id != null) {
	          if (!seen[subject.calendar_id]) {
	            seen[subject.calendar_id] = true;
	            usersWithEvents.push(subject.calendar_id);
	          }
	        }
	      });
	      return usersWithEvents;
	    },
	    startBulkAction: function startBulkAction(actionType) {
	      this.bulkActionMode = true;
	      this.bulkActionType = actionType;
	      this.bulkSubjectType = '';
	      this.bulkHours = null;
	      this.isApplyingBulk = false;
	      if (actionType === 'dates') {
	        this.bulkFromDate = this.bulkDateMin ? this.bulkDateMin.clone() : (0, _moment2.default)();
	        this.bulkToDate = this.bulkDateMax ? this.bulkDateMax.clone() : (0, _moment2.default)();
	      } else {
	        this.bulkFromDate = null;
	        this.bulkToDate = null;
	      }
	    },
	    cancelBulkAction: function cancelBulkAction() {
	      this.bulkActionMode = false;
	      this.bulkActionType = '';
	      this.selectedRowIds = [];
	      this.bulkSubjectType = '';
	      this.bulkHours = null;
	      this.bulkFromDate = null;
	      this.bulkToDate = null;
	      this.isApplyingBulk = false;
	    },
	    isRowSelected: function isRowSelected(task) {
	      var rowId = task._generatedId || task.id;
	      return this.selectedRowIds.indexOf(rowId) !== -1;
	    },
	    toggleRowSelection: function toggleRowSelection(task) {
	      var rowId = task._generatedId || task.id;
	      var idx = this.selectedRowIds.indexOf(rowId);
	      if (idx === -1) {
	        this.selectedRowIds.push(rowId);
	      } else {
	        this.selectedRowIds.splice(idx, 1);
	      }
	    },
	    toggleSelectAllVisible: function toggleSelectAllVisible() {
	      var _this12 = this;
	
	      if (this.allVisibleSelected) {
	        this.selectedRowIds = this.selectedRowIds.filter(function (rowId) {
	          return _this12.visibleRowIds.indexOf(rowId) === -1;
	        });
	      } else {
	        var next = this.selectedRowIds.slice();
	        this.visibleRowIds.forEach(function (rowId) {
	          if (next.indexOf(rowId) === -1) next.push(rowId);
	        });
	        this.selectedRowIds = next;
	      }
	    },
	    setBulkFromDate: function setBulkFromDate(date) {
	      this.bulkFromDate = date;
	    },
	    setBulkToDate: function setBulkToDate(date) {
	      this.bulkToDate = date;
	    },
	    reloadSubjects: function reloadSubjects() {
	      var _this13 = this;
	
	      if (!this.activeSchoolYear || !this.activeSchoolYear.id) {
	        this.$store.state.subjects.isSubmittingTask = false;
	        return;
	      }
	      var schoolId = this.$store.getters.schoolId;
	      this.$store.state.subjects.isSubmittingTask = true;
	      _docendo2.default.readSubjects(schoolId, this.activeSchoolYear.id, null, function (data) {
	        _this13.$store.commit('setSubjects', data);
	        _this13.$store.state.subjects.isSubmittingTask = false;
	      }, function () {
	        _this13.$store.state.subjects.isSubmittingTask = false;
	      });
	    },
	    runBulkUpdate: function runBulkUpdate(changes, successKey, failureKey) {
	      var _this14 = this;
	
	      var subjectIds = this.selectedSubjectIds;
	      if (subjectIds.length === 0) return;
	      var schoolId = this.$store.getters.schoolId;
	      this.isApplyingBulk = true;
	      _docendo2.default.bulkUpdateSubjects(schoolId, subjectIds, changes, function (data) {
	        var subjects = typeof data === 'string' ? JSON.parse(data) : data;
	        if (Array.isArray(subjects)) {
	          subjects.forEach(function (subj) {
	            subj.calendar_ids = subj.cals ? subj.cals.map(function (c) {
	              return c.id;
	            }) : subj.calendar_ids || [];
	            _this14.$store.commit('updateSubject', subj);
	          });
	        }
	        _this14.reloadSubjects();
	        _eventbus2.default.toast = { text: _this14.i18n[_this14.locale][successKey], success: true };
	        _this14.cancelBulkAction();
	      }, function (err) {
	        _this14.isApplyingBulk = false;
	        var fallback = _this14.i18n[_this14.locale][failureKey];
	        var msg = err && err.data && err.data.error ? err.data.error : err && err.error ? err.error : fallback;
	        _eventbus2.default.toast = { text: msg, success: false };
	      });
	    },
	    applyBulkSubjectType: function applyBulkSubjectType() {
	      if (!this.bulkSubjectType || this.isApplyingBulk) return;
	      this.runBulkUpdate({ subject_type: this.bulkSubjectType }, 'bulk_subject_type_updated', 'bulk_subject_type_failed');
	    },
	    applyBulkHours: function applyBulkHours() {
	      if (this.bulkHours == null || this.bulkHours === '' || this.isApplyingBulk) return;
	      var hours = parseFloat(this.bulkHours);
	      if (isNaN(hours) || hours < 0) return;
	      this.runBulkUpdate({ hours: hours }, 'bulk_hours_updated', 'bulk_hours_failed');
	    },
	    applyBulkDates: function applyBulkDates() {
	      if (!this.bulkFromDate || !this.bulkToDate || this.isApplyingBulk) return;
	      var fromMoment = (0, _moment2.default)(this.bulkFromDate);
	      var toMoment = (0, _moment2.default)(this.bulkToDate);
	      if (this.bulkDateMin && fromMoment.isBefore(this.bulkDateMin, 'day')) {
	        _eventbus2.default.toast = { text: this.i18n[this.locale]['bulk_dates_out_of_range'], success: false };
	        return;
	      }
	      if (this.bulkDateMax && toMoment.isAfter(this.bulkDateMax, 'day')) {
	        _eventbus2.default.toast = { text: this.i18n[this.locale]['bulk_dates_out_of_range'], success: false };
	        return;
	      }
	      this.runBulkUpdate({
	        from_date: fromMoment.format('YYYY-MM-DD'),
	        to_date: toMoment.format('YYYY-MM-DD')
	      }, 'bulk_dates_updated', 'bulk_dates_failed');
	    },
	    applyBulkDelete: function applyBulkDelete() {
	      var _this15 = this;
	
	      if (this.isApplyingBulk) return;
	      var deletable = this.deletableSubjectIds;
	      if (deletable.length === 0) {
	        _eventbus2.default.toast = { text: this.i18n[this.locale]['bulk_delete_all_skipped'], success: false };
	        return;
	      }
	      if (!window.confirm(this.i18n[this.locale]['bulk_delete_confirm'])) return;
	      var schoolId = this.$store.getters.schoolId;
	      this.isApplyingBulk = true;
	      _docendo2.default.bulkDeleteSubjects(schoolId, deletable, function (data) {
	        var result = typeof data === 'string' ? JSON.parse(data) : data;
	        if (result && Array.isArray(result.deleted)) {
	          result.deleted.forEach(function (subj) {
	            _this15.$store.commit('deleteSubject', subj);
	            window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: subj }));
	          });
	        }
	        _this15.reloadSubjects();
	        var errors = result && Array.isArray(result.errors) ? result.errors : [];
	        if (errors.length > 0) {
	          _eventbus2.default.toast = { text: errors.length + ' ' + _this15.i18n[_this15.locale]['bulk_delete_skipped'], success: false };
	        } else {
	          _eventbus2.default.toast = { text: _this15.i18n[_this15.locale]['bulk_delete_success'], success: true };
	        }
	        _this15.cancelBulkAction();
	      }, function (err) {
	        _this15.isApplyingBulk = false;
	        var fallback = _this15.i18n[_this15.locale]['bulk_delete_failed'];
	        var msg = err && err.data && err.data.error ? err.data.error : err && err.error ? err.error : fallback;
	        _eventbus2.default.toast = { text: msg, success: false };
	      });
	    },
	    getCalendarName: function getCalendarName(calId) {
	      var cal = this.allCalendarsInHash[calId];
	      return cal ? cal.name : '';
	    },
	    getTaskCalendarLabel: function getTaskCalendarLabel(task) {
	      if (task.in_user_calendar) return this.i18n[this.locale]['own_calendar'];
	      var calIds = task.belongs_to_calendars || [];
	      for (var i = 0; i < calIds.length; i++) {
	        var cal = this.allCalendarsInHash[calIds[i]];
	        if (cal && cal.type !== 'user') return cal.name;
	      }
	      return '';
	    },
	    getTaskDatesLabel: function getTaskDatesLabel(task) {
	      var fmt = function fmt(d) {
	        return d ? (0, _moment2.default)(d).format('D. MMM YYYY') : '';
	      };
	      var from = fmt(task.from_date);
	      var to = fmt(task.to_date);
	      if (from && to) return from + ' – ' + to;
	      return from || to;
	    },
	    setEditTask: function setEditTask(task) {
	      var _this16 = this;
	
	      this.isTaskModal = false;
	      this.isQuickCreate = false;
	      this.editTask = task;
	      this.isLoadingFreshTask = true;
	      setTimeout(function () {
	        _this16.isTaskModal = true;
	      }, 0);
	      var schoolId = this.$store.getters.schoolId;
	      var onLoaded = function onLoaded() {
	        var rowId = task._generatedId || task.id;
	        var fresh = _this16.tasks.find(function (t) {
	          return (t._generatedId || t.id) === rowId;
	        });
	        if (!fresh && task.subject_ids && task.subject_ids.length) {
	          var cachedSubjectIds = new _set2.default(task.subject_ids);
	          fresh = _this16.tasks.find(function (t) {
	            return (t.subject_ids || []).some(function (sid) {
	              return cachedSubjectIds.has(sid);
	            });
	          });
	        }
	        if (fresh) {
	          _this16.editTask = fresh;
	        }
	        _this16.isLoadingFreshTask = false;
	      };
	      _docendo2.default.readSubjects(schoolId, this.activeSchoolYear.id, null, function (data) {
	        _this16.$store.commit('setSubjects', data);
	        onLoaded();
	      }, function () {
	        onLoaded();
	      });
	    },
	    openCreateTask: function openCreateTask() {
	      this.editTask = null;
	      this.prefillTask = null;
	      this.isQuickCreate = false;
	      this.isTaskModal = true;
	    },
	    closeCreateTask: function closeCreateTask() {
	      this.isTaskModal = false;
	      this.editTask = null;
	      this.prefillTask = null;
	      this.isQuickCreate = false;
	    },
	    duplicateFromGroup: function duplicateFromGroup() {
	      var _this17 = this;
	
	      if (!this.activeGroupData) return;
	      var ref = this.activeGroupData.tasks[0];
	      this.editTask = null;
	      this.isQuickCreate = true;
	      this.prefillTask = {
	        name: this.activeGroupData.name,
	        color: this.activeGroupData.color,
	        subject_type: ref ? ref.subject_type : 'additional_tasks',
	        can_schedule: ref ? ref.can_schedule : true,
	        default_duration: ref ? ref.default_duration : 60,
	        preparation: ref ? ref.preparation : null,
	        in_user_calendar: ref ? ref.in_user_calendar : true,
	        belongs_to_calendars: ref ? ref.belongs_to_calendars : []
	      };
	      this.isTaskModal = false;
	      setTimeout(function () {
	        _this17.isTaskModal = true;
	      }, 0);
	    },
	    duplicateTask: function duplicateTask(task) {
	      var _this18 = this;
	
	      this.editTask = null;
	      this.isQuickCreate = true;
	      this.prefillTask = {
	        name: task.name,
	        color: task.color,
	        subject_type: task.subject_type,
	        can_schedule: task.can_schedule,
	        default_duration: task.default_duration,
	        preparation: task.preparation,
	        in_user_calendar: task.in_user_calendar,
	        belongs_to_calendars: task.belongs_to_calendars || []
	      };
	      this.isTaskModal = false;
	      setTimeout(function () {
	        _this18.isTaskModal = true;
	      }, 0);
	    },
	    createTask: function createTask() {
	      var _this19 = this;
	
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$keepOpen = _ref.keepOpen,
	          keepOpen = _ref$keepOpen === undefined ? false : _ref$keepOpen;
	
	      if (!keepOpen) {
	        this.closeCreateTask();
	        return;
	      }
	      this.isTaskModal = false;
	      setTimeout(function () {
	        _this19.isTaskModal = true;
	      }, 0);
	    },
	    setActiveDSelect: function setActiveDSelect(task) {
	      if ((task.user_calendar_ids || []).length < 1) {
	        this.activeDSelectShow = true;
	      } else {
	        this.activeDSelectShow = false;
	      }
	      this.activeDSelect = task._generatedId || task.id;
	    },
	    closeDSelect: function closeDSelect() {
	      if (!this.activeDSelect) return;
	      this.activeDSelect = null;
	    },
	    setTableSelectedUsers: function setTableSelectedUsers(users, task) {
	      var _this20 = this;
	
	      var newCalIds = users.map(function (u) {
	        return u.id;
	      });
	      var oldCalIds = (task.user_calendar_ids || []).filter(function (id) {
	        return id != null;
	      });
	      var addedCalIds = newCalIds.filter(function (id) {
	        return oldCalIds.indexOf(id) === -1;
	      });
	      var removedCalIds = oldCalIds.filter(function (id) {
	        return newCalIds.indexOf(id) === -1;
	      });
	      if (addedCalIds.length === 0 && removedCalIds.length === 0) return;
	
	      var schoolId = task.school_id;
	      var schoolYearId = task.school_year_id;
	      var subjectIds = (task.subject_ids || []).slice();
	
	      var baseSubjectPayload = function baseSubjectPayload() {
	        return {
	          name: task.name,
	          color: task.color,
	          hours: task.hours,
	          subject_type: task.subject_type,
	          default_duration: task.default_duration,
	          preparation: task.preparation,
	          can_schedule: task.can_schedule,
	          from_date: task.from_date || null,
	          to_date: task.to_date || null
	        };
	      };
	
	      var operations = [];
	
	      if (task.in_user_calendar) {
	        var existingPlaceholder = (task.subjects || []).find(function (s) {
	          return !s.calendar_id;
	        });
	        var subjectsToDelete = (task.subjects || []).filter(function (s) {
	          return s.calendar_id && removedCalIds.indexOf(s.calendar_id) !== -1;
	        }).map(function (s) {
	          return s.id;
	        });
	        if (newCalIds.length > 0 && existingPlaceholder) {
	          subjectsToDelete.push(existingPlaceholder.id);
	        }
	        if (subjectsToDelete.length > 0) {
	          operations.push(new _promise2.default(function (resolve, reject) {
	            _docendo2.default.bulkDeleteSubjects(schoolId, subjectsToDelete, function (data) {
	              var result = typeof data === 'string' ? JSON.parse(data) : data;
	              if (result && Array.isArray(result.deleted)) {
	                result.deleted.forEach(function (subj) {
	                  _this20.$store.commit('deleteSubject', subj);
	                  window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: subj }));
	                });
	              }
	              if (result && Array.isArray(result.errors) && result.errors.length > 0) {
	                _eventbus2.default.toast = { text: 'Nogle brugere kunne ikke fjernes, da de har skemalagte brikker', success: false };
	              }
	              resolve();
	            }, function (err) {
	              return reject(err);
	            });
	          }));
	        }
	
	        var subjectsToCreate = addedCalIds.map(function (calId) {
	          return (0, _assign2.default)({}, baseSubjectPayload(), {
	            calendar_id: calId,
	            calendar_ids: []
	          });
	        });
	        if (newCalIds.length === 0 && !existingPlaceholder) {
	          subjectsToCreate.push((0, _assign2.default)({}, baseSubjectPayload(), {
	            calendar_ids: []
	          }));
	        }
	        if (subjectsToCreate.length > 0) {
	          operations.push(new _promise2.default(function (resolve, reject) {
	            _docendo2.default.bulkCreateSubjects(schoolId, schoolYearId, subjectsToCreate, function (data) {
	              var created = typeof data === 'string' ? JSON.parse(data) : data;
	              if (Array.isArray(created)) {
	                created.forEach(function (subj) {
	                  subj.calendar_ids = subj.cals ? subj.cals.map(function (c) {
	                    return c.id;
	                  }) : subj.calendar_ids || [];
	                  _this20.$store.commit('createSubject', subj);
	                  window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: subj }));
	                });
	              }
	              resolve();
	            }, function (err) {
	              return reject(err);
	            });
	          }));
	        }
	      } else {
	        if (subjectIds.length === 0) return;
	        var targetSubjectId = subjectIds[0];
	        addedCalIds.forEach(function (calId) {
	          operations.push(new _promise2.default(function (resolve, reject) {
	            _docendo2.default.bulkUpdateSubjects(schoolId, [targetSubjectId], { add_calendar_id: calId }, function (data) {
	              var subjects = typeof data === 'string' ? JSON.parse(data) : data;
	              if (Array.isArray(subjects)) {
	                subjects.forEach(function (subj) {
	                  subj.calendar_ids = subj.cals ? subj.cals.map(function (c) {
	                    return c.id;
	                  }) : subj.calendar_ids || [];
	                  _this20.$store.commit('updateSubject', subj);
	                  window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: subj }));
	                });
	              }
	              resolve();
	            }, function (err) {
	              return reject(err);
	            });
	          }));
	        });
	        removedCalIds.forEach(function (calId) {
	          operations.push(new _promise2.default(function (resolve, reject) {
	            _docendo2.default.bulkUpdateSubjects(schoolId, [targetSubjectId], { remove_calendar_id: calId }, function (data) {
	              var subjects = typeof data === 'string' ? JSON.parse(data) : data;
	              if (Array.isArray(subjects)) {
	                subjects.forEach(function (subj) {
	                  subj.calendar_ids = subj.cals ? subj.cals.map(function (c) {
	                    return c.id;
	                  }) : subj.calendar_ids || [];
	                  _this20.$store.commit('updateSubject', subj);
	                  window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: subj }));
	                });
	              }
	              resolve();
	            }, function (err) {
	              return reject(err);
	            });
	          }));
	        });
	      }
	
	      if (operations.length === 0) {
	        this.reloadSubjects();
	        return;
	      }
	
	      this.$store.state.subjects.isSubmittingTask = true;
	      _promise2.default.all(operations).then(function () {
	        _this20.reloadSubjects();
	      }).catch(function (err) {
	        console.warn('setTableSelectedUsers failed', err);
	        var fallback = 'Kunne ikke opdatere brugere på opgaven';
	        var msg = err && err.data && err.data.error ? err.data.error : err && err.error ? err.error : fallback;
	        _eventbus2.default.toast = { text: msg, success: false };
	        _this20.reloadSubjects();
	      });
	    },
	    dataToExcel: function dataToExcel() {
	      var _this21 = this;
	
	      if (!this.activeGroupData) return [];
	      return this.activeGroupData.tasks.map(function (task) {
	        var row = {
	          name: task.name || '',
	          hours: parseFloat(task.hours) || 0,
	          type: _this21.getTaskTypeLabel(task)
	        };
	        if (_this21.showCalendarInTable) row.calendar = _this21.getTaskCalendarLabel(task);
	        if (_this21.showDatesInTable) row.dates = _this21.getTaskDatesLabel(task);
	        if (_this21.showUsersInTable) row.users = _this21.getUserNames(task.user_calendar_ids || []).join(', ');
	        if (_this21.showTotalInTable) row.total = _this21.getTaskWeightedTotal(task);
	        return row;
	      });
	    },
	    asyncLoadXLSXAndDownload: function asyncLoadXLSXAndDownload() {
	      var _this22 = this;
	
	      this.isDownloading = true;
	      if (window.XLSX && XLSX) {
	        this.downloadExcel();
	      } else {
	        var cdnXLSX = document.createElement('script');
	        cdnXLSX.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.mini.min.js');
	        document.head.appendChild(cdnXLSX);
	        var intervalTimer = setInterval(function () {
	          if (window.XLSX) {
	            clearInterval(intervalTimer);
	            XLSX = window.XLSX;
	            _this22.downloadExcel();
	          }
	        }, 500);
	      }
	    },
	    downloadExcel: function downloadExcel() {
	      var t = this.i18n[this.locale];
	      var headers = {
	        name: t['task'],
	        hours: t['hours'],
	        type: t['type']
	      };
	      if (this.showCalendarInTable) headers.calendar = t['calendar'];
	      if (this.showDatesInTable) headers.dates = t['dates'];
	      if (this.showUsersInTable) headers.users = t['users'];
	      if (this.showTotalInTable) headers.total = t['total'];
	      var rows = this.dataToExcel();
	      rows.unshift(headers);
	
	      var sheet = XLSX.utils.json_to_sheet(rows, { skipHeader: true });
	      var wb = XLSX.utils.book_new();
	      var groupName = this.activeGroupName === '__all__' ? t['all'] : this.activeGroupName;
	      XLSX.utils.book_append_sheet(wb, sheet, t['tasks_sheet']);
	      XLSX.writeFile(wb, t['tasks_sheet'].toLowerCase() + '_' + groupName.replace(/[^a-zA-Z0-9æøåÆØÅ]/g, '_') + '.xlsx');
	
	      this.isDownloading = false;
	    }
	  }
	};

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(51);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DSelectCalsIds = __webpack_require__(40);
	
	var _DSelectCalsIds2 = _interopRequireDefault(_DSelectCalsIds);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _SubjectFormSubjectType = __webpack_require__(61);
	
	var _SubjectFormSubjectType2 = _interopRequireDefault(_SubjectFormSubjectType);
	
	var _DkPreparationFactorControl = __webpack_require__(100);
	
	var _DkPreparationFactorControl2 = _interopRequireDefault(_DkPreparationFactorControl);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _SubjectsDistributionTasksCreateDropdown = __webpack_require__(393);
	
	var _SubjectsDistributionTasksCreateDropdown2 = _interopRequireDefault(_SubjectsDistributionTasksCreateDropdown);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _dkPreparationFactorUi = __webpack_require__(72);
	
	var _preparationFactor = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    create_task: 'Opret opgave',
	    save_and_close: 'Gem og afslut',
	    save_and_new: 'Gem og opret ny opgave',
	    update_task: 'Opdatér',
	    task_title: 'Opgavens titel',
	    ex_task: 'Eks. Tilsyn',
	    choose_type: 'Vælg type',
	    hours_as: 'Timer som',
	    hours: 'Timer',
	    add_user: 'Tilføj personale',
	    hours_in_school_year_per_person: 'Øvrig tid',
	    teaching_hours: 'UV tid',
	    cancel: 'Annullér',
	    cannot_be_deleted: 'Kan ikke slettes, da der er skemalagte brikker',
	    cannot_change_can_schedule: 'Kan ikke ændres, fordi {names} har skemalagte brikker',
	    can_be_scheduled: 'Kan skemalægges',
	    duration: 'NORMAL VARIGHED (I MINUTTER)',
	    create_in_calendar: 'Opret i kalender',
	    created_in_calendar: 'Oprettet i kalenderen',
	    choose_color: 'Vælg farve',
	    teaching: 'Undervisning',
	    preparation: 'Forberedelse',
	    additional_tasks: 'Øvrige Opgaver',
	    available: 'Rådighedstimer',
	    club: 'SFO tid',
	    locale_pool: 'Lokalpulje',
	    forb_faktor: 'Forb. faktor',
	    forb_faktor_range_hint: 'Mellem 0 og -1',
	    total_time: 'Samlet tid',
	    hours_unit: 't',
	    prep_task_extra_toggle: 'Medregnes ud over forberedelse fra forberedelesfaktor',
	    prep_task_extra_toggle_hint: 'Fra: opgaven følger skolens forberedelsesfaktor som øvrige brikker. Til: opgavens timer medregnes med faktor 1 oven i forberedelsen fra undervisningsfag.',
	    from_date: 'Startdato',
	    to_date: 'Slutdato',
	    show_dates_on_overview: 'Vis datoer på opgaveoversigten',
	    copy_to_shared_calendar: 'Kopiér opgaven til fælles kalender',
	    copied_to_shared_calendar: 'Opgaven er kopieret til fælles kalender'
	  },
	  nb: {
	    create_task: 'Opprett oppgave',
	    save_and_close: 'Lagre og avslutt',
	    save_and_new: 'Lagre og opprett ny oppgave',
	    update_task: 'Oppdater',
	    task_title: 'Navn på oppgave',
	    ex_task: 'F.eks. Tilsyn',
	    choose_type: 'Velg type',
	    hours_as: 'Timer som',
	    hours: 'Timer',
	    add_user: 'Legg til underviser(e)',
	    hours_in_school_year_per_person: 'Øvrig tid',
	    teaching_hours: 'Undervisningstid',
	    cancel: 'Annuller',
	    cannot_be_deleted: 'Kan ikke slettes, ettersom faget er timeplanlagt.',
	    cannot_change_can_schedule: 'Kan ikke endres, fordi {names} har timeplanlagte brikker',
	    can_be_scheduled: 'Kan timeplanlegges',
	    duration: 'STANDARDLENGDE (I MINUTTER)',
	    create_in_calendar: 'Opprett i kalender',
	    created_in_calendar: 'Opprettet i kalenderen',
	    choose_color: 'Velg farge',
	    teaching: 'Undervisning',
	    preparation: 'Forberedelse',
	    additional_tasks: 'Øvrige oppgaver',
	    available: 'Rådighetstimer',
	    club: 'SFO tid',
	    locale_pool: 'Planleggingsdager',
	    forb_faktor: 'Forb. faktor',
	    forb_faktor_range_hint: 'Mellom 0 og -1',
	    total_time: 'Samlet tid',
	    hours_unit: 't',
	    prep_task_extra_toggle: 'Tas med i tillegg til forberedelse fra undervisning',
	    prep_task_extra_toggle_hint: 'Av: oppgaven følger skolens forberedelsesfaktor som andre brikker. På: oppgavens timer tas med med faktor 1 i tillegg til forberedelse fra undervisningsfag.',
	    from_date: 'Startdato',
	    to_date: 'Sluttdato',
	    show_dates_on_overview: 'Vis dato på oppgaveoversikt',
	    copy_to_shared_calendar: 'Kopier oppgaven til felles kalender',
	    copied_to_shared_calendar: 'Oppgaven er kopiert til felles kalender'
	  },
	  en: {
	    create_task: 'Add task',
	    save_and_close: 'Save and close',
	    save_and_new: 'Save and add new task',
	    update_task: 'Update',
	    task_title: 'Title',
	    ex_task: 'eg. non teaching task',
	    choose_type: 'Choose type',
	    hours_as: 'Hours as',
	    hours: 'Hours',
	    add_user: 'Add teacher(s)',
	    hours_in_school_year_per_person: 'Additional time',
	    teaching_hours: 'Teaching hours',
	    cancel: 'Cancel',
	    cannot_be_deleted: 'Cannot be deleted due to scheduled tasks.',
	    cannot_change_can_schedule: 'Cannot be changed because {names} have scheduled tasks',
	    can_be_scheduled: 'Can be scheduled',
	    duration: 'STANDARD DURATION (IN MINUTES)',
	    create_in_calendar: 'Create in calendar',
	    created_in_calendar: 'Created in calendar',
	    choose_color: 'Choose color',
	    teaching: 'Teaching',
	    preparation: 'Preparation',
	    additional_tasks: 'Additional tasks',
	    available: 'Available hours',
	    club: 'Club hours',
	    locale_pool: 'Custom pool',
	    forb_faktor: 'Prep factor',
	    forb_faktor_range_hint: 'Between 0 and -1',
	    total_time: 'Total time',
	    hours_unit: 'h',
	    prep_task_extra_toggle: 'Counted in addition to preparation from teaching',
	    prep_task_extra_toggle_hint: 'Off: this task uses the school preparation factor like other tiles. On: hours are counted with factor 1 on top of preparation from teaching subjects.',
	    from_date: 'Start date',
	    to_date: 'End date',
	    show_dates_on_overview: 'Show dates on task overview',
	    copy_to_shared_calendar: 'Copy task to shared calendar',
	    copied_to_shared_calendar: 'Task copied to shared calendar'
	  }
	};
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default, DModal: _DModal2.default, DSelectCalendarIds: _DSelectCalsIds2.default, SubjectFormSubjectType: _SubjectFormSubjectType2.default, DkPreparationFactorControl: _DkPreparationFactorControl2.default, SelectOtherCal: _SubjectsDistributionTasksCreateDropdown2.default, DSelect: _DSelect2.default, DateSelector: _DateSelector2.default, DDropdown: _DDropdown2.default },
	  props: {
	    editTask: {
	      default: null
	    },
	    activeFilter: {
	      default: null
	    },
	    prefill: {
	      default: null
	    },
	    quickCreate: {
	      type: Boolean,
	      default: false
	    },
	    isLoadingFreshData: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      name: '',
	      hours: 0,
	      calendars: [],
	      subjectType: 'additional_tasks',
	      canSchedule: true,
	      duration: 60,
	      color: '#999999',
	      selectedOtherCalendarId: null,
	      formErrors: [],
	      preparation: null,
	      fromDate: null,
	      toDate: null,
	      isShowDateFields: false
	    };
	  },
	
	  computed: {
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    },
	    saveKeyTooltip: function saveKeyTooltip() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span>' + '<span>Enter</span></p>';
	    },
	    isArbeidstidsplanActivated: function isArbeidstidsplanActivated() {
	      return this.$store.getters.isArbeidstidsplanActivated;
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings || {};
	    },
	    isSchoolFromDenmark: function isSchoolFromDenmark() {
	      return this.schoolCountry.toLowerCase() === 'dk';
	    },
	    isShowNorwegianPreparationDropdown: function isShowNorwegianPreparationDropdown() {
	      return this.isArbeidstidsplanActivated && !this.isSchoolFromDenmark;
	    },
	    isShowDanishPreparationFactorField: function isShowDanishPreparationFactorField() {
	      if (!this.isSchoolFromDenmark || !this.schoolSettings.deactivatePools) {
	        return false;
	      }
	      if (!(0, _dkPreparationFactorUi.schoolHasDanishPreparationFactorConfigured)(this.schoolSettings)) {
	        return false;
	      }
	      return (0, _dkPreparationFactorUi.isSubjectTypeWithDanishPreparationFactor)(this.subjectType);
	    },
	    danishPreparationControlLabels: function danishPreparationControlLabels() {
	      var L = this.i18n[this.locale];
	      return {
	        forb_faktor: L.forb_faktor,
	        forb_faktor_range_hint: L.forb_faktor_range_hint,
	        prep_task_extra_toggle: L.prep_task_extra_toggle,
	        prep_task_extra_toggle_hint: L.prep_task_extra_toggle_hint
	      };
	    },
	    isDanishPrepBinaryOnOwnRow: function isDanishPrepBinaryOnOwnRow() {
	      return this.isShowDanishPreparationFactorField && (0, _dkPreparationFactorUi.isDanishPreparationBinaryPrepTaskSubjectType)(this.subjectType);
	    },
	    isTeachingTypeForTotal: function isTeachingTypeForTotal() {
	      return this.subjectType === 'subject' || this.subjectType === 'person_resource' || this.subjectType === 'person_resource_visible';
	    },
	    isShowSamletTid: function isShowSamletTid() {
	      return this.isShowDanishPreparationFactorField && this.isTeachingTypeForTotal;
	    },
	    samletTid: function samletTid() {
	      var teaching = parseFloat(this.hours) || 0;
	      var schoolPrepFactorNumeric = (0, _preparationFactor.parseNumericPreparationFactor)(this.schoolSettings.prepFactor);
	      var factor = (0, _preparationFactor.effectivePreparationFactor)(this.preparation, schoolPrepFactorNumeric);
	      var safeFactor = factor === null || isNaN(factor) ? 0 : factor;
	      var prep = teaching * safeFactor;
	      var round = function round(n) {
	        return Math.round(n * 100) / 100;
	      };
	      return {
	        teaching: round(teaching),
	        prep: round(prep),
	        total: round(teaching + prep)
	      };
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    schoolCountry: function schoolCountry() {
	      return this.$store.getters.schoolCountry;
	    },
	    isSchoolFromNorway: function isSchoolFromNorway() {
	      return this.schoolCountry.toLowerCase() === 'no';
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    otherCalendars: function otherCalendars() {
	      return this.$store.getters.otherCalendars;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    localPoolTitle: function localPoolTitle() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || this.i18n[this.locale]['locale_pool'];
	    },
	    hoursType: function hoursType() {
	      switch (this.subjectType) {
	        case 'person_resource_visible':
	        case 'person_resource':
	        case 'subject':
	          return this.i18n[this.locale]['teaching'];
	        case 'preparation':
	          return this.i18n[this.locale]['preparation'];
	        case 'additional_tasks':
	          return this.i18n[this.locale]['additional_tasks'];
	        case 'available':
	          return this.i18n[this.locale]['available'];
	        case 'club':
	          return this.i18n[this.locale]['club'];
	        case 'pool':
	          return this.localPoolTitle;
	        case 'with_kids':
	          return 'Med børn';
	        case 'without_kids':
	          return 'Uden børn';
	        default:
	          return this.subjectType;
	      }
	    },
	    isCreateInOtherCalendarAnOption: function isCreateInOtherCalendarAnOption() {
	      return this.subjectType === 'without_kids' || this.subjectType === 'preparation' || this.subjectType === 'additional_tasks' || this.subjectType === 'pool' || this.subjectType === 'club';
	    },
	    taskCalendarType: function taskCalendarType() {
	      return this.subjectType === 'club' ? 'club' : 'other';
	    },
	    copyCalendarOptions: function copyCalendarOptions() {
	      return this.taskCalendarType === 'club' ? this.$store.getters.clubCalendars : this.otherCalendars;
	    },
	    canCopyToSharedCalendar: function canCopyToSharedCalendar() {
	      return !!(this.editTask && this.editTask.in_user_calendar && this.canSchedule && this.isCreateInOtherCalendarAnOption && this.copyCalendarOptions && this.copyCalendarOptions.length > 0);
	    },
	    usersWithEvents: function usersWithEvents() {
	      if (!this.editTask) {
	        return [];
	      }
	      var usersWithEvents = [];
	      var usersWithEventsHash = {};
	      this.editTask.subjects.forEach(function (subject) {
	        if (subject.has_events) {
	          if (subject.user_calendars.length > 0) {
	            subject.user_calendars.forEach(function (calId) {
	              if (!usersWithEventsHash[calId]) {
	                usersWithEventsHash[calId] = true;
	                usersWithEvents.push(calId);
	              }
	            });
	          } else {
	            if (!usersWithEventsHash[subject.calendar_id]) {
	              usersWithEventsHash[subject.calendar_id] = true;
	              usersWithEvents.push(subject.calendar_id);
	            }
	          }
	        }
	      });
	      return usersWithEvents;
	    },
	    usersWithEventsNames: function usersWithEventsNames() {
	      var cals = this.allCalendarsInHash;
	      return this.usersWithEvents.map(function (calId) {
	        return cals[calId] && cals[calId].name || '';
	      }).filter(function (name) {
	        return name;
	      }).join(', ');
	    },
	    cannotChangeCanSchedule: function cannotChangeCanSchedule() {
	      return this.usersWithEvents.length > 0;
	    },
	    cannotChangeCanScheduleTooltip: function cannotChangeCanScheduleTooltip() {
	      return this.i18n[this.locale]['cannot_change_can_schedule'].replace('{names}', this.usersWithEventsNames);
	    },
	    theDeletedItemId: function theDeletedItemId() {
	      return this.$store.state.subjects.theDeletedItemId;
	    },
	    isSubmittingTask: function isSubmittingTask() {
	      return this.$store.state.subjects.isSubmittingTask;
	    },
	    today: function today() {
	      return (0, _moment2.default)().format('YYYY-MM-DD');
	    }
	  },
	  watch: {
	    editTask: function editTask() {
	      if (this.editTask) {
	        this.populateFromEditTask();
	        if (this.$refs.name) this.$refs.name.focus();
	      }
	    },
	    defaultDuration: function defaultDuration(val) {
	      this.removeErrors('defaultDuration');
	    },
	    theDeletedItemId: function theDeletedItemId() {
	      if (this.theDeletedItemId === this.editTask.id) {
	        this.close();
	      }
	    }
	  },
	  methods: {
	    toggleDateFields: function toggleDateFields() {
	      this.isShowDateFields = !this.isShowDateFields;
	      if (this.isShowDateFields) {
	        if (!this.fromDate && this.activeSchoolYear) {
	          this.fromDate = this.activeSchoolYear.employee_time_start || null;
	        }
	        if (!this.toDate && this.activeSchoolYear) {
	          this.toDate = this.activeSchoolYear.employee_time_end || null;
	        }
	      } else {
	        this.fromDate = null;
	        this.toDate = null;
	      }
	    },
	    setFromDate: function setFromDate(date) {
	      var formatted = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      this.fromDate = formatted;
	      if (this.toDate && formatted > this.toDate) {
	        this.toDate = formatted;
	      }
	    },
	    setToDate: function setToDate(date) {
	      var formatted = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      this.toDate = formatted;
	      if (this.fromDate && formatted < this.fromDate) {
	        this.fromDate = formatted;
	      }
	    },
	    selectAllOnFocus: function selectAllOnFocus(evt) {
	      setTimeout(function (_) {
	        evt.target.select();
	      }, 0);
	    },
	    getOtherCalendarName: function getOtherCalendarName(calId) {
	      var cal = this.allCalendarsInHash[calId];
	      return cal && cal.type !== 'user' ? cal.name : '';
	    },
	    setSelectedOtherCalendarId: function setSelectedOtherCalendarId(calendarId) {
	      this.selectedOtherCalendarId = calendarId;
	    },
	    setSubjectType: function setSubjectType(type) {
	      this.subjectType = type;
	      if (this.selectedOtherCalendarId) {
	        var cal = this.allCalendarsInHash[this.selectedOtherCalendarId];
	        if (!this.isCreateInOtherCalendarAnOption || !cal || cal.type !== this.taskCalendarType) {
	          this.selectedOtherCalendarId = null;
	        }
	      }
	    },
	    setColor: function setColor(color) {
	      this.color = color;
	    },
	    setSelectedUsers: function setSelectedUsers(users) {
	      this.calendars = users.map(function (user) {
	        return user.id;
	      });
	    },
	    setIsCreateAsSubject: function setIsCreateAsSubject(boolean) {
	      var _this = this;
	
	      this.canSchedule = boolean;
	      if (boolean) {
	        this.$nextTick(function (_) {
	          if (_this.$refs.inputLessonCount) {
	            _this.$refs.inputLessonCount.focus();
	          }
	        });
	      }
	    },
	    toggleCanSchedule: function toggleCanSchedule() {
	      if (this.cannotChangeCanSchedule) return;
	      this.canSchedule = !this.canSchedule;
	    },
	    formValidation: function formValidation() {
	      if (this.name.length < 1) {
	        this.$set(this.formErrors, 'name', {
	          da: 'Opgaven skal have et navn',
	          en: 'Task must have a name',
	          nb: 'Opgave må ha et navn'
	        });
	      }
	      if (this.duration < 0) {
	        this.$set(this.formErrors, 'duration', {
	          da: 'Skal være 0 eller højere',
	          en: 'Must be zero or greater',
	          nb: 'Må være 0 eller høyere'
	        });
	      }
	    },
	    removeErrors: function removeErrors(title) {
	      this.$delete(this.formErrors, title);
	    },
	    createTask: function createTask() {
	      var _this2 = this;
	
	      var keepOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      var schoolId = this.$store.getters.schoolId;
	      var schoolYearId = this.activeSchoolYear.id;
	      var baseSubject = {
	        name: this.name,
	        color: this.color,
	        hours: this.hours,
	        subject_type: this.subjectType,
	        default_duration: this.duration,
	        preparation: this.preparationPayloadForSave(),
	        can_schedule: this.canSchedule,
	        from_date: this.fromDate || null,
	        to_date: this.toDate || null
	      };
	      var subjectsPayload = [];
	      if (this.selectedOtherCalendarId) {
	        subjectsPayload.push((0, _assign2.default)({}, baseSubject, {
	          calendar_id: this.selectedOtherCalendarId,
	          calendar_ids: this.calendars
	        }));
	      } else if (this.calendars.length > 0) {
	        this.calendars.forEach(function (calId) {
	          subjectsPayload.push((0, _assign2.default)({}, baseSubject, {
	            calendar_id: calId,
	            calendar_ids: []
	          }));
	        });
	      } else {
	        subjectsPayload.push((0, _assign2.default)({}, baseSubject, {
	          calendar_ids: []
	        }));
	      }
	      this.$store.state.subjects.isSubmittingTask = true;
	      _docendo2.default.bulkCreateSubjects(schoolId, schoolYearId, subjectsPayload, function (data) {
	        var created = typeof data === 'string' ? JSON.parse(data) : data;
	        if (Array.isArray(created)) {
	          created.forEach(function (subj) {
	            subj.calendar_ids = subj.cals ? subj.cals.map(function (c) {
	              return c.id;
	            }) : subj.calendar_ids || [];
	            _this2.$store.commit('createSubject', subj);
	            window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: subj }));
	          });
	        }
	        _this2.$store.state.subjects.isSubmittingTask = false;
	        _docendo2.default.readSubjects(schoolId, schoolYearId, null, function (subjects) {
	          _this2.$store.commit('setSubjects', subjects);
	        }, function () {});
	        _this2.$emit('create', { keepOpen: keepOpen });
	      }, function (err) {
	        _this2.$store.state.subjects.isSubmittingTask = false;
	        var msg = err && err.data && err.data.error ? err.data.error : 'Kunne ikke oprette opgaven - prøv igen';
	        _eventbus2.default.toast = { text: msg, success: false };
	      });
	    },
	    copyTaskToSharedCalendar: function copyTaskToSharedCalendar(calendarId) {
	      var _this3 = this;
	
	      if (!calendarId || this.isSubmittingTask) {
	        return;
	      }
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      var schoolId = this.$store.getters.schoolId;
	      var schoolYearId = this.editTask && this.editTask.school_year_id || this.activeSchoolYear.id;
	      var subjectsPayload = [{
	        name: this.name,
	        color: this.color,
	        hours: this.hours,
	        subject_type: this.subjectType,
	        default_duration: this.duration,
	        preparation: this.preparationPayloadForSave(),
	        can_schedule: this.canSchedule,
	        from_date: this.fromDate || null,
	        to_date: this.toDate || null,
	        calendar_id: calendarId,
	        calendar_ids: this.calendars.slice()
	      }];
	      this.$store.state.subjects.isSubmittingTask = true;
	      _docendo2.default.bulkCreateSubjects(schoolId, schoolYearId, subjectsPayload, function (data) {
	        var created = typeof data === 'string' ? JSON.parse(data) : data;
	        if (Array.isArray(created)) {
	          created.forEach(function (subj) {
	            subj.calendar_ids = subj.cals ? subj.cals.map(function (c) {
	              return c.id;
	            }) : subj.calendar_ids || [];
	            _this3.$store.commit('createSubject', subj);
	            window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: subj }));
	          });
	        }
	        _this3.$store.state.subjects.isSubmittingTask = false;
	        _docendo2.default.readSubjects(schoolId, schoolYearId, null, function (subjects) {
	          _this3.$store.commit('setSubjects', subjects);
	        }, function () {});
	        _eventbus2.default.toast = { text: _this3.i18n[_this3.locale]['copied_to_shared_calendar'], success: true };
	        _this3.$emit('close');
	      }, function (err) {
	        _this3.$store.state.subjects.isSubmittingTask = false;
	        var msg = err && err.data && err.data.error ? err.data.error : 'Kunne ikke oprette opgaven - prøv igen';
	        _eventbus2.default.toast = { text: msg, success: false };
	      });
	    },
	    updateTask: function updateTask() {
	      var _this4 = this;
	
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      var task = this.editTask;
	      var subjectIds = (task.subject_ids || []).slice();
	      if (subjectIds.length === 0) {
	        this.$emit('close');
	        return;
	      }
	      var schoolId = task.school_id;
	      var schoolYearId = task.school_year_id;
	      var oldCalIds = (task.user_calendar_ids || []).filter(function (id) {
	        return id != null;
	      });
	      var newCalIds = this.calendars;
	      var addedCalIds = newCalIds.filter(function (id) {
	        return oldCalIds.indexOf(id) === -1;
	      });
	      var removedCalIds = oldCalIds.filter(function (id) {
	        return newCalIds.indexOf(id) === -1;
	      });
	      var fieldChanges = {
	        name: this.name,
	        hours: this.hours,
	        preparation: this.preparationPayloadForSave(),
	        default_duration: this.duration,
	        subject_type: this.subjectType,
	        can_schedule: this.canSchedule,
	        color: this.color,
	        from_date: this.fromDate,
	        to_date: this.toDate
	      };
	      var operations = [];
	      operations.push(new _promise2.default(function (resolve, reject) {
	        _docendo2.default.bulkUpdateSubjects(schoolId, subjectIds, fieldChanges, function (data) {
	          var subjects = typeof data === 'string' ? JSON.parse(data) : data;
	          if (Array.isArray(subjects)) {
	            subjects.forEach(function (subj) {
	              subj.calendar_ids = subj.cals ? subj.cals.map(function (c) {
	                return c.id;
	              }) : subj.calendar_ids || [];
	              _this4.$store.commit('updateSubject', subj);
	              window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: subj }));
	            });
	          }
	          resolve();
	        }, function (err) {
	          return reject(err);
	        });
	      }));
	      if (task.in_user_calendar) {
	        var existingPlaceholder = (task.subjects || []).find(function (s) {
	          return !s.calendar_id;
	        });
	        var subjectsToDelete = (task.subjects || []).filter(function (s) {
	          return s.calendar_id && removedCalIds.indexOf(s.calendar_id) !== -1;
	        }).map(function (s) {
	          return s.id;
	        });
	        if (newCalIds.length > 0 && existingPlaceholder) {
	          subjectsToDelete.push(existingPlaceholder.id);
	        }
	        if (subjectsToDelete.length > 0) {
	          operations.push(new _promise2.default(function (resolve, reject) {
	            _docendo2.default.bulkDeleteSubjects(schoolId, subjectsToDelete, function (data) {
	              var result = typeof data === 'string' ? JSON.parse(data) : data;
	              if (result && Array.isArray(result.deleted)) {
	                result.deleted.forEach(function (subj) {
	                  _this4.$store.commit('deleteSubject', subj);
	                  window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: subj }));
	                });
	              }
	              if (result && Array.isArray(result.errors) && result.errors.length > 0) {
	                _eventbus2.default.toast = { text: 'Nogle brugere kunne ikke fjernes, da de har skemalagte brikker', success: false };
	              }
	              resolve();
	            }, function (err) {
	              return reject(err);
	            });
	          }));
	        }
	        var subjectsToCreate = addedCalIds.map(function (calId) {
	          return {
	            name: _this4.name,
	            color: _this4.color,
	            hours: _this4.hours,
	            subject_type: _this4.subjectType,
	            default_duration: _this4.duration,
	            preparation: _this4.preparationPayloadForSave(),
	            can_schedule: _this4.canSchedule,
	            from_date: _this4.fromDate || null,
	            to_date: _this4.toDate || null,
	            calendar_id: calId,
	            calendar_ids: []
	          };
	        });
	        if (newCalIds.length === 0 && !existingPlaceholder) {
	          subjectsToCreate.push({
	            name: this.name,
	            color: this.color,
	            hours: this.hours,
	            subject_type: this.subjectType,
	            default_duration: this.duration,
	            preparation: this.preparationPayloadForSave(),
	            can_schedule: this.canSchedule,
	            from_date: this.fromDate || null,
	            to_date: this.toDate || null,
	            calendar_ids: []
	          });
	        }
	        if (subjectsToCreate.length > 0) {
	          operations.push(new _promise2.default(function (resolve, reject) {
	            _docendo2.default.bulkCreateSubjects(schoolId, schoolYearId, subjectsToCreate, function (data) {
	              var created = typeof data === 'string' ? JSON.parse(data) : data;
	              if (Array.isArray(created)) {
	                created.forEach(function (subj) {
	                  subj.calendar_ids = subj.cals ? subj.cals.map(function (c) {
	                    return c.id;
	                  }) : subj.calendar_ids || [];
	                  _this4.$store.commit('createSubject', subj);
	                  window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: subj }));
	                });
	              }
	              resolve();
	            }, function (err) {
	              return reject(err);
	            });
	          }));
	        }
	      } else {
	        var targetSubjectId = subjectIds[0];
	        addedCalIds.forEach(function (calId) {
	          operations.push(new _promise2.default(function (resolve, reject) {
	            _docendo2.default.bulkUpdateSubjects(schoolId, [targetSubjectId], { add_calendar_id: calId }, function (data) {
	              var subjects = typeof data === 'string' ? JSON.parse(data) : data;
	              if (Array.isArray(subjects)) {
	                subjects.forEach(function (subj) {
	                  subj.calendar_ids = subj.cals ? subj.cals.map(function (c) {
	                    return c.id;
	                  }) : subj.calendar_ids || [];
	                  _this4.$store.commit('updateSubject', subj);
	                  window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: subj }));
	                });
	              }
	              resolve();
	            }, function (err) {
	              return reject(err);
	            });
	          }));
	        });
	        removedCalIds.forEach(function (calId) {
	          operations.push(new _promise2.default(function (resolve, reject) {
	            _docendo2.default.bulkUpdateSubjects(schoolId, [targetSubjectId], { remove_calendar_id: calId }, function (data) {
	              var subjects = typeof data === 'string' ? JSON.parse(data) : data;
	              if (Array.isArray(subjects)) {
	                subjects.forEach(function (subj) {
	                  subj.calendar_ids = subj.cals ? subj.cals.map(function (c) {
	                    return c.id;
	                  }) : subj.calendar_ids || [];
	                  _this4.$store.commit('updateSubject', subj);
	                  window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: subj }));
	                });
	              }
	              resolve();
	            }, function (err) {
	              return reject(err);
	            });
	          }));
	        });
	      }
	      this.$store.state.subjects.isSubmittingTask = true;
	      _promise2.default.all(operations).then(function () {
	        _this4.$store.state.subjects.isSubmittingTask = false;
	        _docendo2.default.readSubjects(schoolId, schoolYearId, null, function (subjects) {
	          _this4.$store.commit('setSubjects', subjects);
	        }, function () {});
	        _this4.$emit('close', task);
	      }).catch(function (err) {
	        _this4.$store.state.subjects.isSubmittingTask = false;
	        var msg = err && err.data && err.data.error ? err.data.error : 'Kunne ikke opdatere opgaven';
	        _eventbus2.default.toast = { text: msg, success: false };
	      });
	    },
	    clearForm: function clearForm() {
	      this.formErrors = [];
	      this.name = '';
	      this.hours = 0;
	      this.duration = 45;
	      this.preparation = null;
	      this.color = '#999999';
	      this.calendars = [];
	      this.selectedOtherCalendarId = null;
	      this.fromDate = null;
	      this.toDate = null;
	      this.isShowDateFields = false;
	    },
	    preparationPayloadForSave: function preparationPayloadForSave() {
	      return (0, _dkPreparationFactorUi.preparationPayloadForSave)(this.preparation, this.isShowDanishPreparationFactorField, this.subjectType);
	    },
	    preparationFromApiForForm: function preparationFromApiForForm(prep) {
	      return (0, _dkPreparationFactorUi.preparationFromApiForForm)(prep, this.isShowDanishPreparationFactorField, this.subjectType);
	    },
	    populateFromEditTask: function populateFromEditTask() {
	      var _this5 = this;
	
	      if (!this.editTask) return;
	      this.name = this.editTask.name;
	      this.hours = this.editTask.hours;
	      if (this.editTask.subject_type) {
	        this.subjectType = this.editTask.subject_type;
	      }
	      this.color = this.editTask.color;
	      this.canSchedule = this.editTask.can_schedule;
	      this.duration = this.editTask.default_duration;
	      if (this.editTask.preparation != null) {
	        this.preparation = this.preparationFromApiForForm(this.editTask.preparation);
	      } else {
	        this.preparation = null;
	      }
	      this.fromDate = this.editTask.from_date || null;
	      this.toDate = this.editTask.to_date || null;
	      this.isShowDateFields = !!(this.fromDate || this.toDate);
	      this.calendars = [];
	      if (this.editTask.user_calendar_ids) {
	        this.editTask.user_calendar_ids.forEach(function (calid) {
	          _this5.calendars.push(calid);
	        });
	      }
	      if (!this.editTask.in_user_calendar && this.editTask.belongs_to_calendars) {
	        this.selectedOtherCalendarId = this.editTask.belongs_to_calendars[0];
	      }
	    },
	    close: function close() {
	      this.clearForm();
	      this.canSchedule = true;
	      this.$emit('close');
	    },
	    deleteTask: function deleteTask() {
	      this.editTask['itemType'] = 'task';
	      this.$store.commit('setItemToDelete', this.editTask);
	      this.$store.commit('setConfirmDeletion', true);
	    },
	    onHandleKeyboardShortcutSubmit: function onHandleKeyboardShortcutSubmit(evt) {
	      if (this.isSubmittingTask) {
	        return;
	      }
	      if ((evt.ctrlKey || evt.metaKey) && (evt.key === 'Enter' || evt.keyCode === 13)) {
	        evt.preventDefault();
	        if (this.editTask) {
	          this.updateTask();
	        } else {
	          this.createTask();
	        }
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.locale = window.USER.language ? window.USER.language : 'da';
	    if (this.activeFilter) {
	      this.subjectType = this.activeFilter;
	    }
	    if (!this.editTask && this.prefill) {
	      if (this.prefill.name) this.name = this.prefill.name;
	      if (this.prefill.color) this.color = this.prefill.color;
	      if (this.prefill.subject_type) this.subjectType = this.prefill.subject_type;
	      if (this.prefill.can_schedule != null) this.canSchedule = this.prefill.can_schedule;
	      if (this.prefill.default_duration) this.duration = this.prefill.default_duration;
	      if (this.prefill.preparation != null) {
	        this.preparation = this.preparationFromApiForForm(this.prefill.preparation);
	      }
	      if (this.prefill.in_user_calendar === false && this.prefill.belongs_to_calendars && this.prefill.belongs_to_calendars[0]) {
	        this.selectedOtherCalendarId = this.prefill.belongs_to_calendars[0];
	      }
	      if (this.prefill.from_date) this.fromDate = this.prefill.from_date;
	      if (this.prefill.to_date) this.toDate = this.prefill.to_date;
	      if (this.prefill.from_date || this.prefill.to_date) this.isShowDateFields = true;
	    }
	    if (this.editTask) {
	      this.populateFromEditTask();
	    }
	  },
	  mounted: function mounted() {
	    var _this6 = this;
	
	    setTimeout(function (_) {
	      if (_this6.$refs.name) _this6.$refs.name.focus();
	    }, 500);
	    window.addEventListener('keydown', this.onHandleKeyboardShortcutSubmit);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('keydown', this.onHandleKeyboardShortcutSubmit);
	  }
	};

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SubjectsDistributionUserAgreements = __webpack_require__(83);
	
	var _SubjectsDistributionUserAgreements2 = _interopRequireDefault(_SubjectsDistributionUserAgreements);
	
	var _SubjectsDistributionUserEditHours = __webpack_require__(395);
	
	var _SubjectsDistributionUserEditHours2 = _interopRequireDefault(_SubjectsDistributionUserEditHours);
	
	var _SubjectsDistributionUserTable = __webpack_require__(1629);
	
	var _SubjectsDistributionUserTable2 = _interopRequireDefault(_SubjectsDistributionUserTable);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    subjects_for_teachers: 'Fagfordeling',
	    filter_users: ' Filtrer på teams',
	    teaching_hours_from_subjects: 'UV-TID FRA FAG',
	    created_subject: 'Oprettede faget',
	    klass: 'Tilhører',
	    subjects: 'Undervisning',
	    teaching_hours: 'UV tid',
	    no_subjects_assigned: 'Ingen fag tildelt',
	    assigned: 'Tildelt',
	    from_subjects: 'Fra fag',
	    difference: 'Diff',
	    only_subjects_without_teachers: 'Vis kun fag uden underviser',
	    hours_in_school_year: 'Timer i skoleåret',
	    time: 'Timer',
	    additional_tasks: 'Øvrige opgaver',
	    preparation: 'Forberedelse',
	    club: 'SFO',
	    pool: 'Lokalpulje',
	    available: 'Rådighedstimer'
	  },
	  en: {
	    subjects_for_teachers: 'Teacher-subject allocation',
	    filter_users: ' Filter users by groups',
	    teaching_hours_from_subjects: 'Annual instruction time from subjects',
	    created_subject: 'Created subject',
	    klass: 'Class',
	    subjects: 'Subjects',
	    teaching_hours: 'Instruction time',
	    no_subjects_assigned: 'No subjects allocated',
	    assigned: 'Allocated',
	    from_subjects: 'From subjects',
	    difference: 'Diff',
	    only_subjects_without_teachers: 'Show only subjects without teachers',
	    hours_in_school_year: 'Annual Instruction Time',
	    time: 'Hours',
	    additional_tasks: 'Not teaching',
	    preparation: 'Preparation',
	    club: 'club',
	    pool: 'Custom pool',
	    available: 'Available hours'
	  },
	  nb: {
	    subjects_for_teachers: 'Fag- og lærerfordeling',
	    filter_users: ' Filtrer etter gruppe',
	    teaching_hours_from_subjects: 'Årstimetall',
	    created_subject: 'Opprettet faget',
	    klass: 'Klasse',
	    subjects: 'Fag',
	    teaching_hours: 'Timetall',
	    no_subjects_assigned: 'Ingen fag tildelt',
	    assigned: 'Tildelt',
	    from_subjects: 'Fra fag',
	    difference: 'Diff',
	    only_subjects_without_teachers: 'Vis kun fag uten underviser',
	    hours_in_school_year: 'Timer i skoleåret',
	    time: 'Timer',
	    additional_tasks: 'Øvrige oppgaver',
	    preparation: 'Forberedelse',
	    club: 'SFO',
	    pool: 'Planleggingsdager',
	    available: 'Rådighetstimer'
	  }
	};
	
	exports.default = {
	  components: { SubjectsDistributionUserAgreements: _SubjectsDistributionUserAgreements2.default, DDropdown: _DDropdown2.default, DModal: _DModal2.default, SubjectsDistributionUserEditHours: _SubjectsDistributionUserEditHours2.default, TasksTable: _SubjectsDistributionUserTable2.default },
	  props: {
	    activeUserId: {
	      default: null
	    },
	    showCloseCross: {
	      default: true
	    },
	    isPoolsDeactivated: {
	      type: Boolean,
	      default: false
	    },
	    showLessonsPerWeek: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isPrint: false,
	      theActiveSubject: null,
	      theActiveTask: null,
	      userTasksTasks: [],
	      showSubjectRequests: false
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    getTheActiveSubject: function getTheActiveSubject() {
	      if (!this.theActiveSubject) return null;
	      return this.subjectsInHash[this.theActiveSubject] || this.tasksInHash[this.theActiveSubject] || null;
	    },
	    getTheActiveUser: function getTheActiveUser() {
	      return this.activeUserId ? this.allUsersInHash[this.activeUserId] : null;
	    },
	    isTestSchool: function isTestSchool() {
	      return window.SCHOOL.country === 'DK';
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    subjectsInUserHash: function subjectsInUserHash() {
	      return this.$store.getters.subjectsInUserHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    usersAssignedHoursHash: function usersAssignedHoursHash() {
	      return this.$store.getters.usersAssignedHoursHash;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    tasksInUserHash: function tasksInUserHash() {
	      return this.$store.getters.tasksInUserHash;
	    },
	    tasksInHash: function tasksInHash() {
	      return this.$store.getters.tasksInHash;
	    },
	    userCalId: function userCalId() {
	      return this.allUsersInHash[this.activeUserId].user_calendar_id;
	    },
	    subjects: function subjects() {
	      return this.$store.state.subjects.subjects;
	    },
	    allUserTasks: function allUserTasks() {
	      var _this = this;
	
	      return this.subjects.filter(function (subject) {
	        if (subject.calendar_id === _this.userCalId) return true;
	        return Array.isArray(subject.cals) && subject.cals.some(function (cal) {
	          return cal.calendar_type === 'user' && cal.id === _this.userCalId;
	        });
	      });
	    },
	    getAllUserTasksTask: function getAllUserTasksTask() {
	      return this.allUserTasks.filter(function (task) {
	        return task.subject_type === 'additional_tasks';
	      });
	    },
	    getAllUserTasksPrep: function getAllUserTasksPrep() {
	      return this.allUserTasks.filter(function (task) {
	        return task.subject_type === 'preparation';
	      });
	    },
	    getAllUserTasksClub: function getAllUserTasksClub() {
	      return this.allUserTasks.filter(function (task) {
	        return task.subject_type === 'club';
	      });
	    },
	    getAllUserTasksPool: function getAllUserTasksPool() {
	      return this.allUserTasks.filter(function (task) {
	        return task.subject_type === 'pool';
	      });
	    },
	    getAllUserTasksAvailable: function getAllUserTasksAvailable() {
	      return this.allUserTasks.filter(function (task) {
	        return task.subject_type === 'available';
	      });
	    },
	    isSchoolFeatureLocalePool: function isSchoolFeatureLocalePool() {
	      return this.$store.getters.isSchoolFeatureLocalePool;
	    },
	    localPoolTitle: function localPoolTitle() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || this.i18n[this.locale]['pool'];
	    },
	    getAllUserTasksTeaching: function getAllUserTasksTeaching() {
	      var _this2 = this;
	
	      return this.allUserTasks.filter(function (task) {
	        if (task.subject_type !== 'subject' && task.subject_type !== 'person_resource' && task.subject_type !== 'person_resource_visible') return false;
	        var ownerCal = _this2.allCalendarsInHash[task.calendar_id];
	        return ownerCal && ownerCal.type === 'user';
	      });
	    },
	    currentUser: function currentUser() {
	      return this.$store.state.user;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    canSeeSubjectRequests: function canSeeSubjectRequests() {
	      if (!this.currentUser) return false;
	      if (!this.isPermissionsActivatedForSchool) return true;
	      return this.userPermissions && this.userPermissions.indexOf('can_see_other_subject_requests') > -1 || this.currentUser.admin;
	    },
	    activeSchoolYearId: function activeSchoolYearId() {
	      return this.$store.getters.schoolYearId;
	    },
	    isLoadingSubjectRequests: function isLoadingSubjectRequests() {
	      return this.$store.state.subjects.isLoadingSubjectsRequests;
	    },
	    subjectsRequests: function subjectsRequests() {
	      return this.$store.state.subjects.subjectsRequests;
	    },
	    userSubjectRequests: function userSubjectRequests() {
	      var _this3 = this;
	
	      var userCalId = this.userCalId;
	      var requestedSubjectIds = this.subjectsRequests.filter(function (req) {
	        return req.calendar_id === userCalId;
	      }).map(function (req) {
	        return req.subject_id;
	      });
	
	      return requestedSubjectIds.map(function (subjectId) {
	        var subject = _this3.subjectsInHash[subjectId];
	        if (!subject) return null;
	        var cal = _this3.allCalendarsInHash[subject.calendar_id];
	        return (0, _extends3.default)({}, subject, {
	          vKlass: cal ? cal.name : '',
	          vHours: _this3.getSubjectHoursForKlass(subject)
	        });
	      }).filter(function (s) {
	        return s !== null;
	      }).sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    getAllUserSubjectsAndTeachingTasks: function getAllUserSubjectsAndTeachingTasks() {
	      var _this4 = this;
	
	      var calId = this.userCalId;
	      var subjects = this.subjectsInUserHash[calId] ? this.subjectsInUserHash[calId].map(function (subjectId) {
	        return _this4.subjectsInHash[subjectId];
	      }) : [];
	      subjects = subjects.filter(function (subject) {
	        if (_this4.allCalendarsInHash[subject.calendar_id]) {
	          var calendarType = _this4.allCalendarsInHash[subject.calendar_id].type;
	          return calendarType === 'klass' || calendarType === 'merge';
	        } else {
	          console.log('error::calendar not found', subject.calendar_id);
	        }
	      });
	      return subjects.concat(this.getAllUserTasksTeaching);
	    }
	  },
	  methods: {
	    openSubjectRequests: function openSubjectRequests() {
	      this.showSubjectRequests = true;
	      if (this.activeSchoolYearId) {
	        this.$store.dispatch('readSubjectRequests', this.activeSchoolYearId);
	      }
	    },
	    emitShowUserTasks: function emitShowUserTasks() {
	      this.$emit('showUserTasks', this.allUsersInHash[this.activeUserId]);
	    },
	    getSubjectHoursForKlass: function getSubjectHoursForKlass(subject) {
	      if (subject.subject_calendars) {
	        var entry = subject.subject_calendars.find(function (sc) {
	          return sc.calendar_id === subject.calendar_id;
	        });
	        if (entry && entry.hours != null) {
	          return entry.hours;
	        }
	      }
	      return subject.hours;
	    },
	    getUserAssignedTaskHours: function getUserAssignedTaskHours(userId) {
	      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].assigned_additional_task_hours ? this.usersAssignedHoursHash[userId].assigned_additional_task_hours : 0;
	    },
	    getUserAssignedPreparationHours: function getUserAssignedPreparationHours(userId) {
	      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].assigned_preparation_hours ? this.usersAssignedHoursHash[userId].assigned_preparation_hours : 0;
	    },
	    getUserAssignedClubHours: function getUserAssignedClubHours(userId) {
	      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].assigned_club_hours ? this.usersAssignedHoursHash[userId].assigned_club_hours : 0;
	    },
	    getUserAssignedPoolHours: function getUserAssignedPoolHours(userId) {
	      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].assigned_pool_hours ? this.usersAssignedHoursHash[userId].assigned_pool_hours : 0;
	    },
	    getAllUserSubjects: function getAllUserSubjects(calid) {
	      var _this5 = this;
	
	      var subjects = this.subjectsInUserHash[calid] ? this.subjectsInUserHash[calid] : [];
	      return subjects.sort(function (subjectA, subjectB) {
	        var subjectFromSubjectA = _this5.allCalendarsInHash[_this5.subjectsInHash[subjectB].calendar_id];
	        var subjectFromSubjectB = _this5.allCalendarsInHash[_this5.subjectsInHash[subjectA].calendar_id];
	        if (subjectFromSubjectA && subjectFromSubjectA.name && subjectFromSubjectB && subjectFromSubjectB.name) {
	          return subjectFromSubjectA.name.localeCompare(subjectFromSubjectB.name, undefined, {
	            numeric: true,
	            sensitivity: 'base'
	          });
	        }
	      });
	    },
	    setEditSubject: function setEditSubject(editSubject) {
	      this.$emit('editSubject', editSubject);
	    },
	    setDeleteTask: function setDeleteTask(taskId) {
	      var task = this.tasksInHash[taskId];
	      task['itemType'] = 'task';
	      this.$store.commit('setItemToDelete', task);
	      this.$store.commit('setConfirmDeletion', true);
	    },
	    getUserAssignedTeachingHours: function getUserAssignedTeachingHours(userId) {
	      return this.usersAssignedHoursHash[userId] ? this.usersAssignedHoursHash[userId].assigned_teaching_hours : 0;
	    },
	    setActiveSubject: function setActiveSubject(subject) {
	      this.theActiveTask = null;
	      this.theActiveSubject = subject;
	    },
	    setActiveTaskSubject: function setActiveTaskSubject(task) {
	      var _this6 = this;
	
	      var subjectId = null;
	      if (task.subjects && task.subjects.length) {
	        var match = task.subjects.find(function (s) {
	          return s.user_calendars && s.user_calendars.includes(_this6.userCalId);
	        });
	        subjectId = match ? match.id : task.subjects[0] ? task.subjects[0].id : null;
	      }
	      if (!subjectId) subjectId = task.id;
	      this.theActiveTask = task;
	      this.theActiveSubject = subjectId;
	    },
	    closeActiveSubject: function closeActiveSubject() {
	      this.theActiveSubject = null;
	      this.theActiveTask = null;
	    }
	  }
	};

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppEIPWYZIWYG = __webpack_require__(55);
	
	var _AppEIPWYZIWYG2 = _interopRequireDefault(_AppEIPWYZIWYG);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppEIPWYZIWYG: _AppEIPWYZIWYG2.default },
	  props: {
	    userId: {
	      type: Number,
	      required: true
	    },
	    userAgreements: {
	      default: '',
	      required: false
	    },
	    isReadAgreements: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      agreements: '',
	      locale: 'da',
	      i18n: {
	        da: {
	          notes_for: 'Noter til'
	        },
	        nb: {
	          notes_for: 'Noter til'
	        },
	        en: {
	          notes_for: 'Notes for'
	        }
	      }
	    };
	  },
	
	  computed: {
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    userCanEditAgreementNote: function userCanEditAgreementNote() {
	      return this.userHasPermission('can_edit_user_year_notes');
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    }
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear() {
	      this.readAgreements();
	    },
	    userAgreements: function userAgreements(val) {
	      this.agreements = val;
	    }
	  },
	  methods: {
	    userHasPermission: function userHasPermission(val) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(val) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    readAgreements: function readAgreements() {
	      var _this = this;
	
	      if (!this.isReadAgreements) {
	        return;
	      }
	      _docendo2.default.schoolUserYearRead(window.SCHOOL.id, this.userId, this.activeSchoolYear.name, function (success) {
	        _this.agreements = success.agreements;
	      }, function (failure) {
	        console.log('failed!');
	      });
	    },
	    updateAgreements: function updateAgreements(updatedText) {
	      var _this2 = this;
	
	      _docendo2.default.schoolUserYearUpdate(window.SCHOOL.id, this.userId, this.activeSchoolYear.name, { 'agreements': updatedText.text }, function (success) {
	        _this2.agreements = success.agreements;
	      }, function (failure) {
	        console.log('failed!');
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.locale = window.USER.language;
	  },
	  mounted: function mounted() {
	    this.agreements = this.userAgreements;
	    this.readAgreements();
	  }
	};

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    subject: {},
	    teacher: {},
	    task: { default: null }
	  },
	  data: function data() {
	    return {
	      hours: '',
	      i18n: {
	        da: {
	          add_new_hours_for: 'Indtast nyt timetal for',
	          has: 'har',
	          hours_in_school_year: 'Klokketimer i skoleåret',
	          cancel: 'Annullér',
	          update: 'Opdatér'
	        },
	        en: {
	          add_new_hours_for: 'Enter new number of hours for',
	          has: 'has',
	          hours_in_school_year: 'hours in schoolyear',
	          cancel: 'Cancel',
	          update: 'Update'
	        },
	        nb: {
	          add_new_hours_for: 'Angi nytt antall timer for',
	          has: 'har',
	          hours_in_school_year: 'timer i skoleåret',
	          cancel: 'Avbryt',
	          update: 'Oppdater'
	        }
	      }
	    };
	  },
	
	  computed: {
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    tasksInHash: function tasksInHash() {
	      return this.$store.getters.tasksInHash;
	    },
	    isInUserCalendar: function isInUserCalendar() {
	      if (this.task && this.task.in_user_calendar) return true;
	      if (this.subject && this.teacher && this.subject.calendar_id === this.teacher.user_calendar_id) return true;
	      return false;
	    },
	    getAllKlasses: function getAllKlasses() {
	      if (this.subject && this.subject.calendar_id && this.allCalendarsInHash[this.subject.calendar_id]) {
	        return this.allCalendarsInHash[this.subject.calendar_id].name;
	      }
	      if (this.task) return this.task.name;
	      return this.subject ? this.subject.name : '';
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    taskId: function taskId() {
	      return this.task ? this.task.id : null;
	    }
	  },
	  methods: {
	    selectAll: function selectAll(event) {
	      setTimeout(function () {
	        event.target.select();
	      }, 0);
	    },
	    submit: function submit() {
	      var _this = this;
	
	      var store = this.$store;
	      var schoolYearId = this.activeSchoolYear ? this.activeSchoolYear.id : this.subject ? this.subject.school_year_id : null;
	      var schoolId = this.subject ? this.subject.school_id : null;
	      var refreshSubjects = function refreshSubjects() {
	        if (!schoolYearId || !schoolId) return;
	        _docendo2.default.readSubjects(schoolId, schoolYearId, null, function (subjects) {
	          store.commit('setSubjects', subjects);
	        }, function () {});
	      };
	
	      if (this.isInUserCalendar) {
	        if (this.tasksInHash[this.subject.id]) {
	          _docendo2.default.updateTask(this.subject.school_id, this.subject.school_year_id, this.subject.id, this.subject.name, this.subject.color, this.hours, this.subject.default_duration, this.subject.preparation != null ? Number(this.subject.preparation) : null, this.subject.belongs_to_calendars || [], this.subject.user_calendars || [this.teacher.user_calendar_id], true, function () {
	            refreshSubjects();
	          }, function (failure) {
	            console.log('Something went wrong');
	          });
	        } else {
	          _docendo2.default.updateSubject(this.subject.id, this.subject.name, this.subject.color, this.subject.calendar_id, this.subject.calendar_ids, this.subject.default_duration, this.subject.preparation, this.hours, this.subject.subject_type, this.subject.school_id, this.subject.school_year_id, this.subject.subject_code, this.subject.away || false, false, null, null, null, function () {
	            refreshSubjects();
	          }, function (failure) {
	            console.log('Something went wrong');
	          });
	        }
	      } else {
	        _docendo2.default.setHoursForTeacherOnSubject(this.subject.id, this.subject.school_id, this.subject.school_year_id, this.teacher.user_calendar_id, this.hours, function (success) {
	          var succesObj = success;
	          succesObj['user_id'] = _this.teacher.id;
	          store.commit('updateTeacherHoursOnSubject', success);
	          refreshSubjects();
	        }, function (failure) {
	          console.log('Something went wrong');
	        });
	      }
	      this.$emit('close');
	    },
	    getSubjectHours: function getSubjectHours() {
	      if (this.isInUserCalendar) {
	        this.hours = this.subject && this.subject.hours != null ? this.subject.hours : '';
	        return;
	      }
	
	      var defaultHours = this.subject && this.subject.hours != null ? this.subject.hours : '';
	
	      var calId = null;
	      if (this.teacher && this.teacher.user_calendar_id) {
	        calId = this.teacher.user_calendar_id;
	      } else if (this.teacher && this.teacher.calendar_id) {
	        calId = this.teacher.calendar_id;
	      }
	
	      if (!calId || !this.subject || !this.subject.subject_calendars) {
	        this.hours = defaultHours;
	        return;
	      }
	
	      var found = false;
	      for (var i = 0; i < this.subject.subject_calendars.length; i++) {
	        var sc = this.subject.subject_calendars[i];
	        if (sc && sc.calendar_id === calId) {
	          this.hours = sc.hours;
	          found = true;
	          break;
	        }
	      }
	
	      if (!found) this.hours = defaultHours;
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    setTimeout(function (_) {
	      _this2.$refs.input_hours.focus();
	    }, 500);
	  }
	};

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default },
	  props: {
	    id: {
	      type: String,
	      default: 'teaching'
	    },
	    user: {
	      type: Object
	    },
	    userCalendarId: {
	      default: 13
	    },
	    title: {
	      type: String,
	      default: 'Øvrige opgaver'
	    },
	    hoursTitle: {
	      type: String,
	      default: 'Timer'
	    },
	    tasks: {
	      default: function _default() {
	        return [];
	      }
	    },
	    assignedHours: {
	      default: '0.0'
	    },
	    isTeaching: {
	      type: Boolean,
	      default: false
	    },
	    isPoolsDeactivated: {
	      type: Boolean,
	      default: false
	    },
	    showLessonsPerWeek: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      i18n: {
	        da: {
	          no_subjects_assigned: 'Ingen opgaver tildelt',
	          assigned: 'Tildelt',
	          difference: 'Diff',
	          time: 'Timer'
	        },
	        en: {
	          no_subjects_assigned: 'No subjects allocated',
	          assigned: 'Allocated',
	          from_subjects: 'From subjects',
	          difference: 'Diff',
	          time: 'Hours'
	        },
	        nb: {
	          no_subjects_assigned: 'Ingen fag tildelt',
	          assigned: 'Tildelt',
	          from_subjects: 'Fra fag',
	          difference: 'Diff',
	          time: 'Timer'
	        }
	      }
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    subjectDefaultDuration: function subjectDefaultDuration() {
	      return this.school && this.school.subject_default_duration ? this.school.subject_default_duration : 45;
	    },
	    sortedTasks: function sortedTasks() {
	      var _this = this;
	
	      return this.tasks.map(function (task) {
	        var vHours = null;
	        var userSpecificHours = null;
	
	        var subjectCalendars = task.subject_calendars;
	        if (task.hasOwnProperty('can_schedule') && task.subjects && task.subjects.length) {
	          var subjectMatch = task.subjects.find(function (s) {
	            return s.user_calendars && s.user_calendars.includes(_this.userCalendarId);
	          });
	          var sid = subjectMatch ? subjectMatch.id : task.subjects[0] ? task.subjects[0].id : null;
	          var subj = sid ? _this.subjectsInHash[sid] : null;
	          if (subj && subj.subject_calendars) {
	            subjectCalendars = subj.subject_calendars;
	          }
	        }
	
	        if (Array.isArray(subjectCalendars)) {
	          var match = subjectCalendars.find(function (sc) {
	            return sc.calendar_id === _this.userCalendarId && sc.hours != null;
	          });
	          if (match) {
	            vHours = parseFloat(match.hours);
	            userSpecificHours = vHours;
	          }
	        }
	
	        if (vHours == null && Array.isArray(task.cals)) {
	          var klassCal = task.cals.find(function (c) {
	            return c.calendar_type === 'klass';
	          });
	          if (klassCal && Array.isArray(subjectCalendars)) {
	            var klassMatch = subjectCalendars.find(function (sc) {
	              return sc.calendar_id === klassCal.id && sc.hours != null;
	            });
	            if (klassMatch) {
	              vHours = parseFloat(klassMatch.hours);
	            }
	          }
	        }
	
	        if (vHours == null) {
	          var fallback = parseFloat(task.hours);
	          vHours = isNaN(fallback) ? 0 : fallback;
	        }
	
	        return (0, _extends3.default)({}, task, {
	          vHours: vHours,
	          vLessonsPerWeek: _this.calcLessonsPerWeek(userSpecificHours != null ? userSpecificHours : task.hours)
	        });
	      }).sort(function (a, b) {
	        return a.name.localeCompare(b.name, undefined, {
	          numeric: true,
	          sensitivity: 'base'
	        });
	      });
	    },
	    sumOfHours: function sumOfHours() {
	      var sum = this.sortedTasks.reduce(function (acc, task) {
	        var val = parseFloat(task.vHours);
	        return acc + (isNaN(val) ? 0 : val);
	      }, 0);
	      return sum.toFixed(1);
	    },
	    sumOfLessonsPerWeek: function sumOfLessonsPerWeek() {
	      var sum = this.sortedTasks.reduce(function (acc, task) {
	        return acc + parseFloat(task.vLessonsPerWeek);
	      }, 0);
	      return sum.toFixed(1);
	    },
	    sumOfHoursWithSubject: function sumOfHoursWithSubject() {
	      var _this2 = this;
	
	      var sum = this.sortedTasks.reduce(function (acc, task) {
	        var hasSubject = _this2.subjectsInHash[task.id];
	        if (hasSubject || task.can_schedule) {
	          var v = parseFloat(task.vHours);
	          return acc + (isNaN(v) ? 0 : v);
	        }
	        return acc;
	      }, 0);
	      return sum.toFixed(1);
	    },
	    sumOfHoursWithoutSubject: function sumOfHoursWithoutSubject() {
	      var _this3 = this;
	
	      var sum = this.sortedTasks.reduce(function (acc, task) {
	        var hasSubject = _this3.subjectsInHash[task.id];
	        if (!hasSubject && !task.can_schedule) {
	          var v = parseFloat(task.vHours);
	          return acc + (isNaN(v) ? 0 : v);
	        }
	        return acc;
	      }, 0);
	      return sum.toFixed(1);
	    },
	    sumOfLessonsWithSubject: function sumOfLessonsWithSubject() {
	      var _this4 = this;
	
	      var sum = this.sortedTasks.reduce(function (acc, task) {
	        var hasSubject = _this4.subjectsInHash[task.id];
	        if (hasSubject || task.can_schedule) {
	          return acc + parseFloat(task.vLessonsPerWeek);
	        }
	        return acc;
	      }, 0);
	      return sum.toFixed(1);
	    },
	    sumOfLessonsWithoutSubject: function sumOfLessonsWithoutSubject() {
	      var _this5 = this;
	
	      var sum = this.sortedTasks.reduce(function (acc, task) {
	        var hasSubject = _this5.subjectsInHash[task.id];
	        if (!hasSubject && !task.can_schedule) {
	          return acc + parseFloat(task.vLessonsPerWeek);
	        }
	        return acc;
	      }, 0);
	      return sum.toFixed(1);
	    },
	    getDiff: function getDiff() {
	      return (this.assignedHours - this.sumOfHours).toFixed(1);
	    },
	    assignedLessonsPerWeek: function assignedLessonsPerWeek() {
	      return this.calcLessonsPerWeek(this.assignedHours);
	    },
	    getDiffLessons: function getDiffLessons() {
	      return (parseFloat(this.assignedLessonsPerWeek) - parseFloat(this.sumOfLessonsPerWeek)).toFixed(1);
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    tasksWithoutSubject: function tasksWithoutSubject() {
	      return this.tasks.filter(function (task) {
	        return task.hasOwnProperty('can_schedule') && !task.can_schedule;
	      });
	    },
	    userTableAcc: function userTableAcc() {
	      return this.$store.state.subjects.userTableAcc;
	    },
	    isOpen: function isOpen() {
	      return this.userTableAcc[this.id];
	    }
	  },
	  methods: {
	    calcLessonsPerWeek: function calcLessonsPerWeek(hours) {
	      return this.$helpers.calcLessonsPerWeek(hours, this.subjectDefaultDuration);
	    },
	    setIsOpen: function setIsOpen() {
	      var current = this.userTableAcc[this.id];
	      var obj = {
	        title: this.id,
	        boolean: current ? !current : true
	      };
	      return this.$store.commit('setUserTableAcc', obj);
	    },
	    setEditTask: function setEditTask(task) {
	      this.$emit('edit', task);
	    },
	    setDeleteTask: function setDeleteTask(task) {
	      this.$emit('delete', task);
	    },
	    calsToString: function calsToString(cals) {
	      if (!cals || !cals.length) return '';
	      var names = cals.slice(0, 2).map(function (cal) {
	        return cal.name;
	      });
	      return cals.length > 2 ? names.join(', ') + ' ...' : names.join(', ');
	    },
	    getShowCalendarIfNotOwn: function getShowCalendarIfNotOwn(task) {
	      var _this6 = this;
	
	      var isInOwnCalendar = task.belongs_to_calendars ? task.belongs_to_calendars.indexOf(this.userCalendarId) > -1 : task.calendar_id === this.userCalendarId;
	      if (isInOwnCalendar) {
	        return null;
	      }
	      if (task.cals) {
	        var klasses = task.cals.filter(function (cal) {
	          return cal.calendar_type === 'klass';
	        });
	        if (klasses && klasses.length > 0) {
	          return this.calsToString(klasses);
	        }
	      }
	      if (task.belongs_to_calendars) {
	        return task.belongs_to_calendars.filter(function (calId) {
	          return _this6.allCalendarsInHash[calId];
	        }).map(function (calId) {
	          return _this6.allCalendarsInHash[calId]['name'];
	        }).join(',');
	      }
	      return this.allCalendarsInHash[task.calendar_id] ? this.allCalendarsInHash[task.calendar_id]['name'] : [];
	    },
	    getUserCalendarId: function getUserCalendarId() {
	      if (this.user && this.user.user_calendar_id) return this.user.user_calendar_id;
	      if (this.user && this.user.calendar_id) return this.user.calendar_id;
	      return null;
	    },
	    isSubjectHoursModified: function isSubjectHoursModified(subjectId) {
	      var subj = this.subjectsInHash && this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId] : null;
	      if (!subj) return false;
	
	      var calId = this.getUserCalendarId();
	      if (!calId || !subj.subject_calendars || subj.subject_calendars.length === 0) return false;
	
	      for (var i = 0; i < subj.subject_calendars.length; i++) {
	        var sc = subj.subject_calendars[i];
	        if (sc && sc.calendar_id === calId) {
	          return sc.hours !== null && sc.hours !== undefined;
	        }
	      }
	      return false;
	    },
	    getTaskSubjectId: function getTaskSubjectId(task) {
	      var _this7 = this;
	
	      if (!task.subjects || !task.subjects.length) return null;
	      var match = task.subjects.find(function (s) {
	        return s.user_calendars && s.user_calendars.includes(_this7.userCalendarId);
	      });
	      return match ? match.id : task.subjects[0] ? task.subjects[0].id : null;
	    },
	    setActiveSubject: function setActiveSubject(subjectId) {
	      this.$emit('setActiveSubject', subjectId);
	    },
	    setActiveTaskSubject: function setActiveTaskSubject(task) {
	      this.$emit('setActiveTaskSubject', task);
	    }
	  }
	};

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DSelectCals = __webpack_require__(48);
	
	var _DSelectCals2 = _interopRequireDefault(_DSelectCals);
	
	var _vuex = __webpack_require__(14);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _TimeChanger = __webpack_require__(31);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _ClassOnTripSubject = __webpack_require__(1631);
	
	var _ClassOnTripSubject2 = _interopRequireDefault(_ClassOnTripSubject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ClassOnTripSubject: _ClassOnTripSubject2.default, DateSelector: _DateSelector2.default, TimeChanger: _TimeChanger2.default, DSelectCals: _DSelectCals2.default, DModal: _DModal2.default },
	  props: {
	    initDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      date: (0, _moment2.default)(),
	      startTime: (0, _moment2.default)().set({ 'hour': 8, 'minutes': 0 }),
	      endTime: (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0 }),
	      selectedKlasses: [],
	      selectedSubject: null,
	      selectedUsers: [],
	      klassEvents: [],
	      isSubmitting: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['klassCalendars', 'userCalendars', 'schoolId']), {
	    isValidated: function isValidated() {
	      return this.selectedKlasses.length > 0 && this.selectedSubject && this.date && this.startTime && this.endTime;
	    },
	    dbEventStart: function dbEventStart() {
	      var date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      var time = this.startTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    dbEventEnd: function dbEventEnd() {
	      var date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      var time = this.endTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    }
	  }),
	  methods: {
	    setSelectedSubject: function setSelectedSubject(subject) {
	      this.selectedSubject = subject;
	    },
	    setDate: function setDate(payload) {
	      this.date = payload;
	    },
	    setStartTime: function setStartTime(payload) {
	      this.startTime = payload;
	    },
	    setEndTime: function setEndTime(payload) {
	      this.endTime = payload;
	    },
	    setSelectedKlasses: function setSelectedKlasses(val) {
	      this.selectedKlasses = val;
	      if (this.selectedSubject) {
	        var subjectCalendarId = this.selectedSubject.calendar_id;
	        var stillHasSubjectCalendar = val.some(function (klass) {
	          return klass.id === subjectCalendarId;
	        });
	        if (!stillHasSubjectCalendar) {
	          this.setSelectedSubject(null);
	        }
	      } else if (val.length === 0) {
	        this.setSelectedSubject(null);
	      }
	    },
	    setSelectedUsers: function setSelectedUsers(val) {
	      this.selectedUsers = val;
	    },
	    submit: function submit() {
	      var _this = this;
	
	      this.isSubmitting = true;
	      this.readKlassEvents(function () {
	        _this.createMainEvent(function (createdEvent) {
	          _this.cancelOverlappingEvents(createdEvent, function () {
	            _this.isSubmitting = false;
	            _this.showToast(_this.$t('vue2.create_activity.created'), true);
	            _this.$emit('onCreatedEvents');
	            _this.$emit('close');
	            _this.$store.dispatch('trackEvent', 'substitution_classOnTrip_submit');
	          });
	        });
	      });
	    },
	    readKlassEvents: function readKlassEvents(callback) {
	      var _this2 = this;
	
	      var calendarIds = this.selectedKlasses.map(function (calendar) {
	        return calendar.id;
	      });
	      _docendo2.default.calendarEvents2(calendarIds, this.dbEventStart, this.dbEventEnd, null, function (success) {
	        _this2.klassEvents = success && success.length > 0 ? JSON.parse(success) : [];
	        callback();
	      }, function (failure) {
	        _this2.showToast('Error fetching class events', false);
	        _this2.isSubmitting = false;
	      });
	    },
	    createMainEvent: function createMainEvent(callback) {
	      var _this3 = this;
	
	      var schoolId = this.selectedSubject.school_id || this.schoolId;
	      var calendarId = this.selectedSubject.calendar_id;
	      var selectedKlassIds = this.selectedKlasses.map(function (calendar) {
	        return calendar.id;
	      });
	      var selectedUserIds = this.selectedUsers.map(function (calendar) {
	        return calendar.id;
	      });
	      var calendarIds = [this.selectedSubject.calendar_id].concat((0, _toConsumableArray3.default)(selectedKlassIds), (0, _toConsumableArray3.default)(selectedUserIds)).filter(function (id, index, ids) {
	        return id && ids.indexOf(id) === index;
	      });
	      var subjectId = this.selectedSubject.id;
	      var internalNote = '';
	
	      _docendo2.default.createEvent(schoolId, calendarId, calendarIds, subjectId, this.dbEventStart, this.dbEventEnd, '', '', '', internalNote, true, function (data) {
	        if (data && data.status === 'error') {
	          _this3.showToast(data.message, false);
	          _this3.isSubmitting = false;
	          return;
	        }
	        var createdEvent = data;
	        if (typeof data === 'string') {
	          createdEvent = JSON.parse(data);
	        }
	        callback(createdEvent);
	      }, function (failure) {
	        _this3.showToast('Something went wrong', false);
	        _this3.isSubmitting = false;
	      });
	    },
	    cancelOverlappingEvents: function cancelOverlappingEvents(createdEvent, callback) {
	      var _this4 = this;
	
	      var createdEventId = createdEvent && (createdEvent.id || createdEvent.event_id);
	      var tripKlassIds = this.selectedKlasses.map(function (calendar) {
	        return calendar.id;
	      });
	      var candidates = this.klassEvents.filter(function (ev) {
	        var notAlreadyCanceled = ev && ev.canceled !== true;
	        var notAlreadyAway = ev && ev.away !== true;
	        var notSelf = !createdEventId || ev.event_id !== createdEventId && ev.id !== createdEventId;
	
	        var hasOtherKlasses = _this4.eventHasOtherKlasses(ev, tripKlassIds);
	        return notAlreadyCanceled && notAlreadyAway && notSelf && !hasOtherKlasses;
	      });
	
	      if (candidates.length === 0) {
	        callback();
	        return;
	      }
	
	      var schoolId = this.selectedSubject.school_id || this.schoolId;
	      var updates = candidates.map(function (ev) {
	        return { event_id: ev.event_id || ev.id, canceled: true };
	      });
	
	      _docendo2.default.updateEvents(schoolId, updates, function () {
	        callback();
	      }, function () {
	        _this4.showToast('Error canceling overlapping events', false);
	        _this4.isSubmitting = false;
	      });
	    },
	    eventHasOtherKlasses: function eventHasOtherKlasses(ev, tripKlassIds) {
	      var calendars = ev && (ev.calendars || ev.calendar_events) || [];
	      var klassIds = calendars.filter(function (c) {
	        return c && c.calendar_type === 'klass';
	      }).map(function (c) {
	        return c.calendar_id;
	      });
	      if (klassIds.length === 0) return false;
	      return klassIds.some(function (id) {
	        return tripKlassIds.indexOf(id) === -1;
	      });
	    },
	    showToast: function showToast(message, success) {
	      _eventbus2.default.toast = { text: message, success: success };
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.date = this.initDate;
	  }
	};

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { dSelect: _DSelect2.default },
	  props: {
	    calendarId: {
	      default: function _default() {
	        return null;
	      }
	    },
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    selectedSubject: {
	      default: null
	    },
	    schoolId: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isLoadingSubjects: false,
	      subjects: [],
	      theSearchText: '',
	      theNewSubject: null,
	      isShowCreateSubjectButton: false,
	      isCreatingNewSubject: false,
	      subjectType: 'frame',
	      theNewlyCreatedSubject: null
	    };
	  },
	
	  computed: {
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    filteredSubjects: function filteredSubjects() {
	      var _this = this;
	
	      return this.subjects.filter(function (subject) {
	        return subject.subject_type === _this.subjectType;
	      });
	    },
	    sortedSubjects: function sortedSubjects() {
	      var _this2 = this;
	
	      return this.filteredSubjects.map(function (subject) {
	        var translatedSubjectType = _this2.$t('vue2.eventTypes.' + subject.subject_type);
	        var vSubjectType = translatedSubjectType === 'vue2.eventTypes.' + subject.subject_type ? subject.subject_type : translatedSubjectType;
	        return (0, _extends3.default)({}, subject, {
	          vSubjectType: vSubjectType
	        });
	      }).sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    }
	  },
	  watch: {
	    calendarId: function calendarId() {
	      this.readSubjects();
	    }
	  },
	  methods: {
	    onCloseDSelect: function onCloseDSelect() {
	      this.isShowCreateSubjectButton = false;
	    },
	    setIsShowCreateSubjectButton: function setIsShowCreateSubjectButton() {
	      var _this3 = this;
	
	      var idx = this.filteredSubjects.findIndex(function (subject) {
	        return subject.name === _this3.theSearchText;
	      });
	      this.isShowCreateSubjectButton = this.theSearchText.length > 0 && idx < 0;
	    },
	    onSearchTextDebounced: function onSearchTextDebounced() {
	      this.setIsShowCreateSubjectButton();
	    },
	    findSchoolYearId: function findSchoolYearId() {
	      if (this.activeSchoolYears.length === 1) {
	        return this.activeSchoolYears[0].id;
	      }
	      var givenDate = (0, _moment2.default)(this.date);
	      var overlappingSchoolYears = this.activeSchoolYears.filter(function (year) {
	        var start = (0, _moment2.default)(year.employee_time_start);
	        var end = (0, _moment2.default)(year.employee_time_end);
	        return givenDate.isBetween(start, end, undefined, '[]');
	      });
	
	      if (overlappingSchoolYears.length > 0) {
	        var latestSchoolYear = overlappingSchoolYears.reduce(function (latest, current) {
	          var latestEnd = (0, _moment2.default)(latest.employee_time_end);
	          var currentEnd = (0, _moment2.default)(current.employee_time_end);
	          return currentEnd.isAfter(latestEnd) ? current : latest;
	        }, overlappingSchoolYears[0]);
	
	        return latestSchoolYear.id;
	      } else {
	        _eventbus2.default.toast = {
	          text: this.$t('vue2.create_activity.the_selected_date_is_outside_schoolyears'),
	          'success': false
	        };
	        return null;
	      }
	    },
	    onCreateNewSubject: function onCreateNewSubject() {
	      var _this4 = this;
	
	      var calendarId = this.calendarId;
	      var schoolYearId = this.findSchoolYearId();
	      if (!schoolYearId || !calendarId) {
	        return;
	      }
	      var schoolId = this.schoolId;
	      var color = '#999999';
	      var duration = 300;
	      var preparation = null;
	      var calendarIds = [];
	      var subjectCode = null;
	      this.isCreatingNewSubject = true;
	      _docendo2.default.createSubject(this.theSearchText, color, calendarId, duration, preparation, 0, this.subjectType, schoolId, schoolYearId, calendarIds, subjectCode, true, null, null, null, function (data) {
	        if (data && data.status === 'error') {
	          _eventbus2.default.toast = { text: data.message, 'success': false };
	          return;
	        }
	        _this4.isCreatingNewSubject = false;
	        _this4.theNewlyCreatedSubject = data;
	        _this4.theSearchText = '';
	        _this4.readSubjects();
	      }, function (failure) {
	        console.log('failed');
	      });
	    },
	    setTheSearchText: function setTheSearchText(str) {
	      this.theSearchText = str;
	    },
	    setSubject: function setSubject(arr) {
	      this.$emit('setSubject', arr[0]);
	    },
	    readSubjects: function readSubjects() {
	      var _this5 = this;
	
	      if (!this.calendarId) {
	        return;
	      }
	      this.isLoadingSubjects = true;
	      _docendo2.default.sidebar(this.calendarId, this.date, function (success) {
	        _this5.isLoadingSubjects = false;
	        _this5.subjects = success;
	        _this5.$nextTick(function (_) {
	          if (_this5.theNewlyCreatedSubject) {
	            _this5.theNewSubject = _this5.theNewlyCreatedSubject;
	          }
	        });
	      }, function (failure) {
	        console.log('something went wrong');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readSubjects();
	  }
	};

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	exports.default = {
	  props: {
	    lesson: {
	      type: Object
	    }
	  },
	  data: function data() {
	    return {
	      numberOfTeachersToShow: 3,
	      isShowAllTeachers: false
	    };
	  },
	
	  computed: {
	    numberOfTeachersHidden: function numberOfTeachersHidden() {
	      return this.teachersInKlassSameTime.length - this.numberOfTeachersToShow;
	    },
	    calsAndEventIds: function calsAndEventIds() {
	      return this.$store.state.subs.allCalsWithEventIdsInHash;
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    allUsersAndEvents: function allUsersAndEvents() {
	      return this.$store.state.subs.allUsersAndEvents;
	    },
	    lessonThatOverLap: function lessonThatOverLap() {
	      return this.otherLessonsInKlassThatOverlap(this.lesson);
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    lessons: function lessons() {
	      return this.lessonThatOverLap.map(function (lesson) {
	        return (0, _extends3.default)({}, lesson, {
	          v_title: lesson.title + ', ' + moment(lesson.start).format('LT') + '-' + moment(lesson.end).format('LT')
	        });
	      });
	    },
	    teachersInKlassSameTime: function teachersInKlassSameTime() {
	      var _this = this;
	
	      var users = [];
	      this.lessons.forEach(function (lesson) {
	        var usersOnLesson = lesson.calendar_events.filter(function (cal) {
	          return cal.calendar_type === 'user';
	        });
	        usersOnLesson.forEach(function (userCalEvent) {
	          var user = _this.allUsersAndEvents[userCalEvent.calendar_id];
	          user['v_overlapping_absence'] = user.dayAbsence.length > 0 ? _this.absenceOverlapLesson(lesson.id, user.dayAbsence) : [];
	          user['v_is_substitute'] = userCalEvent['substitute'];
	          var obj = {
	            lesson: lesson,
	            user: user
	          };
	          users.push(obj);
	        });
	      });
	      return users;
	    }
	  },
	  methods: {
	    otherLessonsInKlassThatOverlap: function otherLessonsInKlassThatOverlap(lesson) {
	      var _this2 = this;
	
	      var klassCals = lesson.calendar_events.filter(function (cal) {
	        return cal.calendar_type === 'klass';
	      });
	
	      var klassCalEventsIDs = klassCals.map(function (cal) {
	        return _this2.calsAndEventIds[cal.calendar_id];
	      });
	      var allEventsInKlass = klassCalEventsIDs.map(function (obj) {
	        return obj.lessons;
	      });
	      var lessonsInKlass = allEventsInKlass[0] ? allEventsInKlass[0].map(function (id) {
	        return _this2.allEventsInAHash[id];
	      }) : [];
	
	      var overlappingEvents = [];
	      lessonsInKlass.forEach(function (event) {
	        var range1 = moment.range(lesson.start, lesson.end);
	        var range2 = moment.range(event.start, event.end);
	
	        if (event.id !== lesson.id && range1.overlaps(range2)) {
	          overlappingEvents.push(event);
	        }
	      });
	      return overlappingEvents;
	    },
	    absenceOverlapLesson: function absenceOverlapLesson(lessonId, absenceIds) {
	      var _this3 = this;
	
	      var absenceOverlapping = [];
	      var absenceEvents = absenceIds.map(function (eventId) {
	        return _this3.allEventsInAHash[eventId];
	      });
	      var lessonEvent = this.allEventsInAHash[lessonId];
	      absenceEvents.forEach(function (absenceEvent) {
	        var range1 = moment.range(absenceEvent.start, absenceEvent.end);
	        var range2 = moment.range(lessonEvent.start, lessonEvent.end);
	        if (range1.intersect(range2)) {
	          var absentLessonReadable = absenceEvent.title + ' ' + moment(absenceEvent.start).format('LT') + '-' + moment(absenceEvent.end).format('LT');
	          absenceOverlapping.push(absentLessonReadable);
	        }
	      });
	      return absenceOverlapping;
	    }
	  }
	};

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(39);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	var XLSX = null;
	var SLIDER_DURATION_MS = 20000;
	
	var I18N = {
	  en: {
	    subs_today: 'Substitutes today',
	    today: 'Today',
	    download: 'Download to Excel',
	    no_subs_today: 'No substitutes today',
	    course: 'COURSE',
	    grade: 'GROUP',
	    room: 'ROOM',
	    sub_for: 'SUBSTITUTE FOR',
	    not_on_school: 'Not on school',
	    subs: 'substitutes',
	    sub: 'substitute',
	    absent: 'absent',
	    no_one_absent_today: 'No one absent',
	    no_lessons_effected: 'No lessons are affected by the absence',
	    absence: 'Absence',
	    canceled: 'Canceled'
	  },
	  da: {
	    subs_today: 'Dagens vikarer',
	    today: 'I dag',
	    no_subs_today: 'Ingen vikarer denne dag',
	    download: 'Download til Excel',
	    course: 'FAG',
	    grade: 'KLASSE',
	    room: 'LOKALE',
	    sub_for: 'VIKAR FOR',
	    not_on_school: 'Ikke på skolen',
	    subs: 'vikarer',
	    sub: 'vikar',
	    absent: 'fraværende',
	    no_one_absent_today: 'Ingen fraværende',
	    no_lessons_effected: 'Ingen lektioner påvirkes af fravær',
	    absence: 'Fravær',
	    canceled: 'Aflyst'
	  },
	  nb: {
	    subs_today: 'Dagens vikarer',
	    today: 'I dag',
	    no_subs_today: 'Ingen vikarer i dag',
	    download: 'Last ned som Excel-fil',
	    course: 'FAG',
	    grade: 'KLASSE',
	    room: 'ROM',
	    sub_for: 'VIKAR FOR',
	    not_on_school: 'Ikke på skolen',
	    subs: 'vikarer',
	    sub: 'vikar',
	    absent: 'fraværende',
	    no_one_absent_today: 'Ingen fraværende',
	    no_lessons_effected: 'Ingen leksjoner påvirkes av fraværet',
	    absence: 'Fravær',
	    canceled: 'Avlyst'
	  }
	};
	exports.default = {
	  components: { Loader: _Loader2.default, DatePicker: _DateSelector2.default },
	  props: {
	    isSubsToday: {
	      type: Boolean,
	      default: true
	    },
	    isPublic: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isDownloading: false,
	      absentToday: [],
	      isLoadingAbsence: false,
	      isSlider: false,
	      theSliderIndex: 0,
	      theSliderInterval: null,
	      theAnimateProgress: 0,
	      theAnimateProgressInterval: null
	    };
	  },
	
	  computed: {
	    schoolUuid: function schoolUuid() {
	      return window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id : this.$route.params.school_uuid;
	    },
	    urlLocale: function urlLocale() {
	      var url = window.location.host;
	      var locale = 'en';
	      if (url.indexOf('.dk') > -1) {
	        locale = 'da';
	      }
	      if (url.indexOf('.no') > -1) {
	        locale = 'nb';
	      }
	      return locale;
	    },
	    locale: function locale() {
	      return window.USER && window.USER.language ? window.USER.language : this.urlLocale;
	    },
	    isShowRooms: function isShowRooms() {
	      return this.locale === 'en';
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    isLoadingSubs: function isLoadingSubs() {
	      return this.$store.state.subs.dataIsLoading;
	    },
	    isLoading: function isLoading() {
	      return this.isLoadingSubs || this.isLoadingAbsence;
	    },
	    getIsToday: function getIsToday() {
	      moment.locale(this.locale);
	      return moment(this.date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD');
	    },
	    date: function date() {
	      return moment(this.$store.state.subs.date).format('YYYY-MM-DD');
	    },
	    formattedDayDate: function formattedDayDate() {
	      moment.locale(this.locale);
	      return moment(this.date).format('dddd') + ' ' + moment(this.date).format('LL');
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    allKlassCalendarsInAHash: function allKlassCalendarsInAHash() {
	      return this.$store.getters.allKlassCalendarsInHash;
	    },
	    allEventsInHash: function allEventsInHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    allUsersAndEvents: function allUsersAndEvents() {
	      return this.$store.state.subs.allUsersAndEvents;
	    },
	    substitutesToday: function substitutesToday() {
	      return this.$store.getters.substitutesToday;
	    },
	    absentFormatted: function absentFormatted() {
	      return this.absentToday.map(function (user) {
	        var userObj = {
	          id: user.user_id,
	          user_calendar_id: user.calendar_id,
	          name: user.name,
	          dayEvents: [],
	          dayAbsence: []
	        };
	        user.events.forEach(function (event) {
	          if (event.event_type === 'absence') {
	            userObj.dayAbsence.push(event);
	          }
	          if (event.event_type !== 'absence' && event.event_type !== 'presence') {
	            userObj.dayEvents.push(event);
	          }
	        });
	        return userObj;
	      });
	    },
	    usersFormatted: function usersFormatted() {
	      var _this = this;
	
	      var usersSelected = this.isSubsToday ? this.substitutesToday : this.absentFormatted;
	      var users = usersSelected.map(function (user) {
	        var eventsArr = _this.isSubsToday ? user.dayEvents.filter(function (event) {
	          return _this.allEventsInHash[event];
	        }).map(function (eventId) {
	          return _this.allEventsInHash[eventId];
	        }) : user.dayEvents;
	        var events = _this.isSubsToday ? eventsArr.filter(function (event) {
	          return _this.isEventAsASubstitute(event, user);
	        }) : eventsArr.filter(function (event) {
	          return _this.doesEventOverLapAbsence(event, user);
	        });
	        var absence = _this.isSubsToday ? user.dayAbsence.filter(function (event) {
	          return _this.allEventsInHash[event];
	        }).map(function (eventId) {
	          return _this.allEventsInHash[eventId];
	        }) : user.dayAbsence;
	        var absenceFormatted = absence.map(function (event) {
	          var eventStart = moment(event.start).format('LT');
	          var eventEnd = moment(event.end).format('LT');
	          var eventFormat = {
	            title: _this.isPublic ? _this.i18n[_this.locale]['absence'] : event.title,
	            startTime: event.start,
	            start: eventStart,
	            end: eventEnd,
	            timeFormatted: eventStart + '-' + eventEnd
	          };
	          return eventFormat;
	        });
	        var eventsFormatted = events.map(function (event) {
	          var eventStart = moment(event.start).format('LT');
	          var eventEnd = moment(event.end).format('LT');
	          var eventFormat = {
	            title: event.title,
	            startTime: event.start,
	            start: eventStart,
	            end: eventEnd,
	            timeFormatted: eventStart + '-' + eventEnd,
	            canceled: event.canceled === true,
	            grades: [],
	            substitute_for: [],
	            substitute: [],
	            rooms: []
	          };
	          event.calendar_events.forEach(function (calEvent) {
	            if (calEvent.calendar_type === 'klass' && calEvent.name) {
	              eventFormat.grades.push(calEvent.name);
	            }
	
	            if (calEvent.calendar_id === user.user_calendar_id && calEvent.substitute_for_user_id) {
	              var subForUserName = _this.allUsersInHash[calEvent.substitute_for_user_id] ? _this.allUsersInHash[calEvent.substitute_for_user_id].name : _this.i18n[_this.locale]['not_on_school'];
	              eventFormat.substitute_for.push(subForUserName);
	            }
	
	            if (calEvent.substitute_for_user_id === user.id) {
	              eventFormat.substitute.push(calEvent.name);
	            }
	
	            if (calEvent.calendar_type === 'room' && calEvent.name) {
	              eventFormat.rooms.push(calEvent.name);
	            }
	          });
	          eventFormat.grades = eventFormat.grades.sort(function (a, b) {
	            if (a && b) {
	              return a.localeCompare(b, undefined, {
	                numeric: true,
	                sensitivity: 'base'
	              });
	            }
	          });
	          if (eventFormat.grades.length < 3) {
	            eventFormat.grades = eventFormat.grades.join(', ');
	          } else {
	            var gradesAsString = eventFormat.grades.filter(function (grade, idx) {
	              return idx < 3;
	            }).join(', ');
	            eventFormat.grades = gradesAsString + '...';
	          }
	          eventFormat.substitute_for = eventFormat.substitute_for.sort(function (a, b) {
	            if (a && b) {
	              return a.localeCompare(b, undefined, {
	                numeric: true,
	                sensitivity: 'base'
	              });
	            }
	          }).join(', ');
	          eventFormat.substitute = eventFormat.substitute.sort(function (a, b) {
	            if (a && b) {
	              return a.localeCompare(b, undefined, {
	                numeric: true,
	                sensitivity: 'base'
	              });
	            }
	          }).join(', ');
	          eventFormat.rooms = eventFormat.rooms.sort(function (a, b) {
	            if (a && b) {
	              return a.localeCompare(b, undefined, {
	                numeric: true,
	                sensitivity: 'base'
	              });
	            }
	          }).join(', ');
	          return eventFormat;
	        });
	        var userObj = {
	          name: user.name ? user.name : _this.allUsersInCalIdHash[user.user_calendar_id] ? _this.allUsersInCalIdHash[user.user_calendar_id].name : '(' + _this.i18n[_this.locale]['not_on_school'] + ')',
	          events: eventsFormatted.sort(function (a, b) {
	            return moment(a.startTime).unix() - moment(b.startTime).unix();
	          }),
	          absence: absenceFormatted.sort(function (a, b) {
	            return moment(a.startTime).unix() - moment(b.startTime).unix();
	          })
	        };
	        return userObj;
	      });
	      return this.$helpers.sortArrOnName(users);
	    },
	    userInRows: function userInRows() {
	      var newArr = [];
	      var arr = JSON.parse((0, _stringify2.default)(this.usersFormatted));
	      while (arr.length) {
	        newArr.push(arr.splice(0, 8));
	      }return newArr;
	    },
	    usersInArraysSlider: function usersInArraysSlider() {
	      return this.userInRows;
	    },
	    dataToExcel: function dataToExcel() {
	      var _this2 = this;
	
	      var dataArr = [{ name: this.i18n[this.locale]['subs_today'] + ', ' + this.formattedDayDate }, { name: '' }];
	      this.usersFormatted.forEach(function (user) {
	        dataArr.push({ name: user.name });
	        dataArr.push({
	          name: _this2.i18n[_this2.locale]['course'],
	          class: _this2.i18n[_this2.locale]['grade'],
	          sub_for: _this2.i18n[_this2.locale]['sub_for'],
	          room: _this2.i18n[_this2.locale]['room']
	        });
	        user.events.forEach(function (event) {
	          dataArr.push({
	            name: event.title + ', ' + event.timeFormatted,
	            class: event.grades,
	            sub_for: event.substitute_for,
	            room: event.rooms
	          });
	        });
	        dataArr.push({ name: '' });
	      });
	      return dataArr;
	    },
	    animatePercentage: function animatePercentage() {
	      return this.theAnimateProgress / (SLIDER_DURATION_MS / 10) * 100 + '%';
	    }
	  },
	  methods: {
	    animateProgress: function animateProgress() {
	      var _this3 = this;
	
	      this.theAnimateProgressInterval = window.setInterval(function (_) {
	        _this3.theAnimateProgress += 1;
	      }, 10);
	    },
	    startSlider: function startSlider() {
	      var _this4 = this;
	
	      this.isSlider = !this.isSlider;
	      clearInterval(this.theSliderInterval);
	      clearInterval(this.theAnimateProgressInterval);
	      if (this.isSlider) {
	        this.animateProgress();
	        this.theSliderInterval = window.setInterval(function (_) {
	          if (_this4.theSliderIndex < _this4.userInRows.length - 1) {
	            _this4.theSliderIndex++;
	          } else {
	            _this4.theSliderIndex = 0;
	          }
	          _this4.theAnimateProgress = 0;
	        }, SLIDER_DURATION_MS);
	      } else {
	        this.theSliderIndex = 0;
	      }
	    },
	    isEventAsASubstitute: function isEventAsASubstitute(event, user) {
	      var isSub = false;
	      event.calendar_events.forEach(function (calEvent) {
	        if (calEvent.calendar_id === user.user_calendar_id && (calEvent.substitute || calEvent.is_substitute)) {
	          isSub = true;
	        }
	      });
	      return isSub;
	    },
	    doesEventOverLapAbsence: function doesEventOverLapAbsence(event, user) {
	      var overlaps = false;
	      for (var i = 0; i < user.dayAbsence.length; i++) {
	        var absence = user.dayAbsence[i];
	        var range1 = moment.range(absence.start, absence.end);
	        var range2 = moment.range(event.start, event.end);
	        if (range1.overlaps(range2)) {
	          overlaps = true;
	        }
	      }
	      return overlaps;
	    },
	    asyncLoadXLSXAndDownload: function asyncLoadXLSXAndDownload() {
	      var _this5 = this;
	
	      this.isDownloading = true;
	      if (window.XLSX && XLSX) {
	        this.download();
	      } else {
	        var cdnXLSX = document.createElement('script');
	        cdnXLSX.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.mini.min.js');
	        document.head.appendChild(cdnXLSX);
	        var intervalTimer = setInterval(function (_) {
	          if (window.XLSX) {
	            clearInterval(intervalTimer);
	            XLSX = window.XLSX;
	            _this5.download();
	          }
	        }, 500);
	      }
	    },
	    download: function download() {
	      var data = XLSX.utils.json_to_sheet(this.dataToExcel, { skipHeader: true });
	      var wb = XLSX.utils.book_new();
	      XLSX.utils.book_append_sheet(wb, data, 'data');
	      XLSX.writeFile(wb, 'docendo_subs_today.xlsx');
	      this.isDownloading = false;
	    },
	    setDate: function setDate(date) {
	      this.$store.commit('setSubDate', date);
	      this.getData(date);
	    },
	    prevDay: function prevDay() {
	      var date = moment(this.date).subtract(1, 'days').format('YYYY-MM-DD');
	      this.setDate(date);
	    },
	    nextDay: function nextDay() {
	      var date = moment(this.date).add(1, 'days').format('YYYY-MM-DD');
	      this.setDate(date);
	    },
	    setToday: function setToday() {
	      var date = moment().format('YYYY-MM-DD');
	      this.setDate(date);
	    },
	    print: function print() {
	      window.print();
	    },
	    getData: function getData(date) {
	      if (this.isSubsToday) {
	        this.$store.dispatch('getAllDayEvents');
	      } else {
	        this.getAbsence(date);
	      }
	    },
	    getAbsence: function getAbsence(date) {
	      var _this6 = this;
	
	      this.isLoadingAbsence = true;
	      _docendo2.default.absenceForDate(this.schoolUuid, date, function (success) {
	        _this6.isLoadingAbsence = false;
	        _this6.absentToday = success && success.length > 1 ? JSON.parse(success) : [];
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (window.location.href.indexOf('?kiosk') > -1) {
	      this.startSlider();
	    }
	  },
	  mounted: function mounted() {
	    if (this.isSubsToday) {
	      this.$store.dispatch('getAllUsers');
	      this.$store.dispatch('getAllDayEvents');
	    } else {
	      this.getAbsence(moment());
	    }
	  }
	};

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _OverviewToday = __webpack_require__(396);
	
	var _OverviewToday2 = _interopRequireDefault(_OverviewToday);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AbsentToday: _OverviewToday2.default },
	  computed: {
	    schoolUuid: function schoolUuid() {
	      return this.$route.params.school_uuid;
	    }
	  },
	  mounted: function mounted() {
	    console.log('this.$route', this.$route);
	  }
	};

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(35);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(50);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _SchedulerItem = __webpack_require__(1635);
	
	var _SchedulerItem2 = _interopRequireDefault(_SchedulerItem);
	
	var _SchedulerRulers = __webpack_require__(1638);
	
	var _SchedulerRulers2 = _interopRequireDefault(_SchedulerRulers);
	
	var _SchedulerSubSubstituteHours = __webpack_require__(1640);
	
	var _SchedulerSubSubstituteHours2 = _interopRequireDefault(_SchedulerSubSubstituteHours);
	
	var _SchedulerItemPopover = __webpack_require__(397);
	
	var _SchedulerItemPopover2 = _interopRequireDefault(_SchedulerItemPopover);
	
	var _core = __webpack_require__(25);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DModalDeleteAwayEvent = __webpack_require__(357);
	
	var _DModalDeleteAwayEvent2 = _interopRequireDefault(_DModalDeleteAwayEvent);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    go_to_calendar: 'Se kalender',
	    add_sub_to_multiple_lessons: 'Vikardæk flere lektioner',
	    auto_created: 'Oprettet automatisk',
	    should: 'Skal',
	    be_appointed: 'sætttes på som vikar eller lærer',
	    as_a_substitute: 'Som en vikar',
	    as_a_teacher: 'Som en lærer',
	    create_activity: 'Opret aktivitet'
	  },
	  nb: {
	    go_to_calendar: 'Se kalender',
	    add_sub_to_multiple_lessons: 'Legg til vikar for flere leksjoner',
	    auto_created: 'Løpende lengre fravær',
	    should: 'Bør',
	    be_appointed: 'settes inn som lærer eller vikar',
	    as_a_substitute: 'Som en vikar',
	    as_a_teacher: 'Som en lærer',
	    create_activity: 'Opprett aktivitet'
	  },
	  en: {
	    go_to_calendar: 'Go to calendar',
	    add_sub_to_multiple_lessons: 'Add substitute to multiple lessons',
	    auto_created: 'Autogenerated',
	    should: 'Should',
	    be_appointed: 'be appointed as a substitute teacher or teacher',
	    as_a_substitute: 'As a subtitute teacher',
	    as_a_teacher: 'As a teacher',
	    create_activity: 'Create event'
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: {
	    ModalConfirmation: _ModalConfirmation2.default,
	    DModalDeleteAwayEvent: _DModalDeleteAwayEvent2.default,
	    DModal: _DModal2.default,
	    DDropdown: _DDropdown2.default,
	    SchedulerItem: _SchedulerItem2.default,
	    SchedulerRulers: _SchedulerRulers2.default,
	    SchedulerSubsSubstituteHours: _SchedulerSubSubstituteHours2.default,
	    SchedulerPopover: _SchedulerItemPopover2.default,
	    Loader: _Loader2.default
	  },
	  directives: {
	    scroll: {
	      inserted: function inserted(el, binding) {
	        var f = function f(evt) {
	          if (binding.value(evt, el)) {
	            el.removeEventListener('scroll', f);
	          }
	        };
	        el.addEventListener('scroll', f);
	      }
	    }
	  },
	  props: {
	    date: {
	      required: false
	    },
	    items: {},
	    title: {
	      type: String,
	      default: 'Teachers'
	    },
	    subsTitle: {
	      type: String,
	      default: 'Potential Substitutes'
	    },
	    isSortOnName: {
	      type: Boolean,
	      default: true
	    },
	    isSubStatusPendingActive: {
	      type: Boolean,
	      default: false
	    },
	    allCalendarsInHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    longAbsentListInHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    isHideEventsNotOverlappingAbsence: {
	      type: Boolean,
	      default: false
	    },
	    selectedEventTitleFilters: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedQuickFilters: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedClassFilters: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedGroupFilters: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isLoadingEvent: false,
	      theTeacherOrSubObj: null,
	      isSyncingLeftScroll: false,
	      isSyncingRightScroll: false,
	      isSyncingTopScroll: false,
	      tags: [],
	      rows: {},
	      activeUser: null,
	      activeUserBCR: null,
	      subStatusDropdown: null,
	      theAbsentUserHandledDropdown: null,
	      theUserHandlerLoading: null,
	      theDeleteEvent: null,
	      schedulerMaxHeight: '100vh',
	      isVerticalScrollbar: false
	    };
	  },
	
	  watch: {
	    rows: function rows() {
	      this.$refs.rightDiv.scrollLeft = 480;
	      this.$refs.topDiv.scrollLeft = 480;
	    },
	    date: function date() {
	      this.closePopover();
	    }
	  },
	  filters: {
	    round: function round(num) {
	      return Math.round(num);
	    }
	  },
	  computed: {
	    activeEvents: function activeEvents() {
	      return this.$store.state.subs.activeEvents;
	    },
	    isActiveEventsLoading: function isActiveEventsLoading() {
	      return this.$store.state.subs.isActiveEventsLoading;
	    },
	    theActiveEventsLoadingOnCalendarId: function theActiveEventsLoadingOnCalendarId() {
	      return this.$store.state.subs.theActiveEventsLoadingOnCalendarId;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    theSubName: function theSubName() {
	      return this.theTeacherOrSubObj && this.theTeacherOrSubObj.userAsSub && this.theTeacherOrSubObj.userAsSub.name ? this.theTeacherOrSubObj.userAsSub.name : 'the teacher';
	    },
	    dataIsLoading: function dataIsLoading() {
	      return this.$store.state.subs.dataIsLoading;
	    },
	    hoursInLocale: function hoursInLocale() {
	      var hours = [];
	      for (var i = 0; i < 24; i++) {
	        hours.push((0, _moment2.default)().set({ hour: i, minutes: 0, seconds: 0 }));
	      }
	      return hours;
	    },
	    isSubScoreActive: function isSubScoreActive() {
	      return this.$store.state.subs.isSortSubActive;
	    },
	    activeEvent: function activeEvent() {
	      return this.$store.state.subs.schedulerActiveEvent;
	    },
	    schedulerUser: function schedulerUser() {
	      return this.$store.state.subs.activeUser;
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    getDate: function getDate() {
	      return this.$store.getters.absentUsersGetDate;
	    },
	    absentUsersHandledHash: function absentUsersHandledHash() {
	      return this.$store.getters.absentUsersHandledHash;
	    },
	    allEvents: function allEvents() {
	      return this.$store.state.subs.allEvents;
	    }
	  },
	  methods: {
	    getUserRowHeight: function getUserRowHeight(item) {
	      var rowCount = this.rows && this.rows[item.id] ? this.rows[item.id] : 1;
	      var hasMultipleAbsences = item.dayAbsence && item.dayAbsence.length > 1;
	      var initialHeight = hasMultipleAbsences ? 25 : 0;
	      return initialHeight + 40 * rowCount + 'px';
	    },
	    calculateMaxHeight: function calculateMaxHeight() {
	      if (this.$refs.rightDiv) {
	        var topOffset = this.$refs.rightDiv.getBoundingClientRect().top;
	        this.schedulerMaxHeight = window.innerHeight - topOffset;
	      }
	    },
	    getIsUsersAbsentHandled: function getIsUsersAbsentHandled(user) {
	      return this.absentUsersHandledHash[user.id] ? this.absentUsersHandledHash[user.id] : false;
	    },
	    schedulerUserHandledCls: function schedulerUserHandledCls(item) {
	      if (!this.isSubStatusPendingActive) {
	        return this.getIsUsersAbsentHandled(item) ? 'scheduler__users__user__handled__handler--handled' : null;
	      } else {
	        if (!this.getIsUsersAbsentHandled(item)) {
	          return null;
	        }
	        return this.getIsUsersAbsentHandled(item) && this.getIsUsersAbsentHandled(item) === 2 ? 'scheduler__users__user__handled__handler--pending' : 'scheduler__users__user__handled__handler--handled';
	      }
	    },
	    setDeleteEvent: function setDeleteEvent(lesson) {
	      this.theDeleteEvent = lesson;
	    },
	    onAwayEventDeleted: function onAwayEventDeleted(success) {
	      var _this = this;
	
	      var event = success ? typeof success === 'string' ? JSON.parse(success) : success : this.theDeleteEvent;
	      if (event && event.calendar_events) {
	        event.calendar_events.forEach(function (calEvent) {
	          if (calEvent.calendar_type === 'user') {
	            _this.$store.commit('removeAbsenceOnAllUsersWithEvents', {
	              cal_id: calEvent.calendar_id,
	              event_id: event.id || _this.theDeleteEvent.id
	            });
	            _this.$store.commit('removeEventOnAllUsersWithEvents', {
	              cal_id: calEvent.calendar_id,
	              event_id: event.id || _this.theDeleteEvent.id
	            });
	          }
	        });
	      }
	      this.$store.dispatch('getAllDayEvents');
	      document.querySelector('body').click();
	      this.theDeleteEvent = null;
	    },
	    deleteTheDeleteEvent: function deleteTheDeleteEvent() {
	      var _this2 = this;
	
	      _docendo2.default.deleteEvent(this.theDeleteEvent.school_id, this.theDeleteEvent.id, function (success) {
	        var event = JSON.parse(success);
	        event.calendar_events.forEach(function (calEvent) {
	          if (calEvent.calendar_type === 'user') {
	            if (event.away) {
	              _this2.$store.commit('removeAbsenceOnAllUsersWithEvents', {
	                cal_id: calEvent.calendar_id,
	                event_id: event.id
	              });
	              _this2.$store.commit('removeEventOnAllUsersWithEvents', {
	                cal_id: calEvent.calendar_id,
	                event_id: event.id
	              });
	            } else {
	              _this2.$store.commit('removeEventOnAllUsersWithEvents', {
	                cal_id: calEvent.calendar_id,
	                event_id: event.id
	              });
	            }
	          }
	        });
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	      document.querySelector('body').click();
	      this.theDeleteEvent = null;
	    },
	    setSubStatus: function setSubStatus(lesson, num, teacherToSub) {
	      var _this3 = this;
	
	      var statusData = this.getSubstitutionStatus(lesson);
	      statusData[teacherToSub.user_calendar_id] = { 'status': num };
	      _docendo2.default.updateEvent(lesson.school_id, lesson.id, { substitution_status: (0, _stringify2.default)(statusData) }, function (success) {
	        _this3.$store.commit('updateSubStatusOnEvent', {
	          'eventId': lesson.id,
	          'status': (0, _stringify2.default)(statusData)
	        });
	      });
	    },
	    getSubstitutionStatus: function getSubstitutionStatus(lesson) {
	      return lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	    },
	    setAsSub: function setAsSub() {
	      var _this4 = this;
	
	      this.isLoadingEvent = true;
	      var activeEvent = this.theTeacherOrSubObj.eventToSub;
	      var teacherToAdd = this.theTeacherOrSubObj.userAsSub;
	      var teacherToSub = this.theTeacherOrSubObj.userToSub;
	      if (this.isSubStatusPendingActive) {
	        this.setSubStatus(activeEvent, 2, teacherToSub);
	      }
	      var userEventObj = { cal_id: teacherToAdd.user_calendar_id, event_id: activeEvent.id };
	      _docendo2.default.eventAddSubstitute(activeEvent.id, teacherToAdd.id, teacherToSub.id, function (data) {
	        _this4.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data));
	        _this4.$store.commit('addEventOnAllUsersWithEvents', userEventObj);
	        _this4.isLoadingEvent = false;
	        _this4.theTeacherOrSubObj = null;
	      });
	    },
	    setAsTeacher: function setAsTeacher() {
	      var _this5 = this;
	
	      this.isLoadingEvent = true;
	      var activeEvent = this.theTeacherOrSubObj.eventToSub;
	      var teacherToAdd = this.theTeacherOrSubObj.userAsSub;
	      var teacherToSub = this.theTeacherOrSubObj.userToSub;
	      this.setSubStatus(activeEvent, 1, teacherToSub);
	      var userCalIds = activeEvent.calendar_events.map(function (cal) {
	        return cal.calendar_id;
	      });
	      var allCals = userCalIds.concat([teacherToAdd.user_calendar_id]);
	      var updates = [{ event_id: activeEvent.id, calendar_ids: allCals }];
	      _docendo2.default.updateEvents(activeEvent.school_id, updates, function (success) {
	        _this5.isLoadingEvent = false;
	        _this5.$store.dispatch('getAllDayEvents');
	        _this5.theTeacherOrSubObj = null;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    onChooseSubType: function onChooseSubType(obj) {
	      this.theTeacherOrSubObj = obj;
	      this.setIsModal(true);
	    },
	    setIsModal: function setIsModal(bool) {
	      if (!bool) {
	        this.theTeacherOrSubObj = null;
	      }
	    },
	    showLog: function showLog(event) {
	      this.$emit('showLog', event);
	    },
	    removeSubs: function removeSubs(data) {
	      this.$emit('removeSubs', data);
	    },
	    setActiveUser: function setActiveUser(item, e) {
	      this.activeUser = item;
	      this.activeUserBCR = e.target.getBoundingClientRect();
	    },
	    setRows: function setRows(obj, userid) {
	      this.$set(this.rows, userid, obj.rows);
	    },
	    handleScrollRight: function handleScrollRight(evt, el) {
	      if (!this.isSyncingRightScroll) {
	        this.isSyncingLeftScroll = true;
	        this.isSyncingTopScroll = true;
	        this.$refs.leftDiv.scrollTop = el.scrollTop;
	        this.$refs.topDiv.scrollLeft = el.scrollLeft;
	      }
	      this.isSyncingRightScroll = false;
	    },
	    handleScrollLeft: function handleScrollLeft(evt, el) {
	      if (!this.isSyncingLeftScroll) {
	        this.isSyncingRightScroll = true;
	        this.$refs.rightDiv.scrollTop = el.scrollTop;
	      }
	      this.isSyncingLeftScroll = false;
	    },
	    handleScrollTop: function handleScrollTop(evt, el) {
	      if (!this.isSyncingTopScroll) {
	        this.isSyncingRightScroll = true;
	        this.$refs.rightDiv.scrollLeft = el.scrollLeft;
	      }
	      this.isSyncingTopScroll = false;
	    },
	    closePopover: function closePopover(e) {
	      if (!this.setActiveUser) {
	        return;
	      }
	      this.$store.commit('setActiveUser', null);
	      this.$store.commit('setActiveEvent', null);
	      this.$store.dispatch('setActiveSchedulerEvent', {
	        'left': -10,
	        'right': -10,
	        'color': '',
	        'oldSubScoreMeta': this.subScoreMeta,
	        'obj': null
	      });
	    },
	    createPopperForAbsentStatusDropdown: function createPopperForAbsentStatusDropdown(itemId) {
	      (0, _core.createPopper)(this.$refs['absence_status_dropdown__parent___' + itemId][0], this.$refs['absence_status_dropdown'], {
	        placement: 'right-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, -10]
	          }
	        }]
	      });
	    },
	    setIsUserHandlerLoading: function setIsUserHandlerLoading(itemId) {
	      this.theUserHandlerLoading = itemId;
	    },
	    getIsUserHandlerLoading: function getIsUserHandlerLoading(itemId) {
	      return this.theUserHandlerLoading === itemId;
	    },
	    setTheAbsentUserHandledDropdown: function setTheAbsentUserHandledDropdown(user) {
	      var _this6 = this;
	
	      this.theAbsentUserHandledDropdown = user;
	      if (!user) {
	        return;
	      }
	      setTimeout(function (_) {
	        _this6.createPopperForAbsentStatusDropdown(user.id);
	      }, 0);
	    },
	    getIsUserSubstituted: function getIsUserSubstituted(user, lesson) {
	      var isUserSubstituted = lesson.calendar_events.some(function (calEvent) {
	        return calEvent.substitute_for_user_id === user.id;
	      });
	      if (isUserSubstituted) {
	        return true;
	      }
	    },
	    setAbsenceStatus: function setAbsenceStatus(user, num) {
	      var _this7 = this;
	
	      var groupBySchoolId = function groupBySchoolId(lessons) {
	        return lessons.reduce(function (groups, lesson) {
	          var schoolId = lesson.school_id;
	          if (!groups[schoolId]) {
	            groups[schoolId] = [];
	          }
	          groups[schoolId].push(lesson);
	          return groups;
	        }, {});
	      };
	
	      if (user.dayEvents.length < 1) {
	        user.dayAbsence.forEach(function (lessonId) {
	          var lesson = _this7.allEventsInAHash[lessonId];
	          var statusData = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	          statusData[user.user_calendar_id] = { status: num };
	
	          _docendo2.default.updateEvent(lesson.school_id, lesson.id, { substitution_status: (0, _stringify2.default)(statusData) }, function (success) {
	            _this7.$store.commit('updateSubStatusOnEvent', {
	              eventId: lesson.id,
	              status: (0, _stringify2.default)(statusData)
	            });
	          });
	        });
	      }
	
	      var lessonsToUpdate = user.dayEvents.filter(function (lessonId) {
	        var lesson = _this7.allEventsInAHash[lessonId];
	        return !_this7.isSubStatusPendingActive ? !_this7.getIsUserSubstituted(user, lesson) : true;
	      }).map(function (lessonId) {
	        var lesson = _this7.allEventsInAHash[lessonId];
	        var statusData = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	        statusData[user.user_calendar_id] = { status: num };
	
	        return (0, _extends3.default)({}, lesson, {
	          substitution_status: (0, _stringify2.default)(statusData)
	        });
	      });
	
	      var groupedLessons = groupBySchoolId(lessonsToUpdate);
	
	      this.setIsUserHandlerLoading(user.id);
	
	      (0, _entries2.default)(groupedLessons).forEach(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            schoolId = _ref2[0],
	            lessons = _ref2[1];
	
	        var eventsToUpdate = lessons.map(function (lesson) {
	          return {
	            event_id: lesson.id,
	            substitution_status: lesson.substitution_status
	          };
	        });
	
	        _docendo2.default.updateEvents(schoolId, eventsToUpdate, function (success) {
	          if (success) {
	            eventsToUpdate.forEach(function (event) {
	              _this7.$store.commit('updateSubStatusOnEvent', {
	                eventId: event.event_id,
	                status: event.substitution_status
	              });
	            });
	          } else {
	            console.error('Failed to update events for school_id: ' + schoolId);
	          }
	
	          _this7.setIsUserHandlerLoading(null);
	        });
	      });
	
	      setTimeout(function () {
	        _this7.setTheAbsentUserHandledDropdown(null);
	      }, 0);
	    },
	    getAbsenceTitle: function getAbsenceTitle(absenceId) {
	      return this.allEventsInAHash[absenceId] && this.allEventsInAHash[absenceId].title ? this.allEventsInAHash[absenceId].title : 'No title';
	    },
	    closeSubStatusDropdown: function closeSubStatusDropdown(evt) {
	      var theClassList = evt.target.classList;
	      if (theClassList.contains('scheduler__users__user__handled__handler') || theClassList.contains('scheduler__users__user__handled')) {
	        return;
	      }
	      this.setTheAbsentUserHandledDropdown(null);
	    },
	    isAbsenceAutoGenerated: function isAbsenceAutoGenerated(item) {
	      var _this8 = this;
	
	      if (item.dayAbsence.length < 1) {
	        return false;
	      }
	      var autoGeneratedToday = false;
	      item.dayAbsence.forEach(function (absenceId) {
	        var absence = _this8.allEventsInAHash[absenceId] && _this8.allEventsInAHash[absenceId] ? _this8.allEventsInAHash[absenceId] : {};
	        var statusObj = absence.substitution_status ? JSON.parse(absence.substitution_status) : {};
	        var todayDate = (0, _moment2.default)(_this8.date).format('YYYY-MM-DD');
	        if (statusObj['extended_at'] && (0, _moment2.default)(statusObj['extended_at']).isSame(todayDate)) {
	          autoGeneratedToday = true;
	        }
	      });
	      return autoGeneratedToday;
	    },
	    setActiveAbsentUser: function setActiveAbsentUser(item) {
	      this.$store.commit('setActiveAbsentUser', item);
	    },
	    setCreateEventOnUser: function setCreateEventOnUser(item) {
	      var user = item;
	      var date = (0, _moment2.default)(this.date);
	      this.$emit('setCreateEventOnUser', { user: user, date: date });
	    },
	    setCreateEventOnUserOnNotAbsentUser: function setCreateEventOnUserOnNotAbsentUser(item) {
	      if (item.dayAbsence.length > 0) {
	        return;
	      }
	      this.setCreateEventOnUser(item);
	    },
	    hasVerticalScrollbar: function hasVerticalScrollbar(el) {
	      return el.offsetWidth > el.clientWidth;
	    }
	  },
	  mounted: function mounted() {
	    this.calculateMaxHeight();
	    window.addEventListener('resize', this.calculateMaxHeight);
	    var rightDiv = this.$refs.rightDiv;
	    this.isVerticalScrollbar = this.hasVerticalScrollbar(rightDiv);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.calculateMaxHeight);
	  }
	};

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SchedulerItemPopover = __webpack_require__(397);
	
	var _SchedulerItemPopover2 = _interopRequireDefault(_SchedulerItemPopover);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(39);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	
	
	var I18N = {
	  da: {
	    multiple_days: 'Flere dage',
	    ongoing: 'Løbende fravær',
	    auto_created: 'Oprettet automatisk',
	    from_another_school: 'Fra anden skole'
	  },
	  nb: {
	    multiple_days: 'Flere dager',
	    ongoing: 'Automatisk',
	    auto_created: 'Løpende lengre fravær',
	    from_another_school: 'Fra annen skole'
	  },
	  en: {
	    multiple_days: 'Multiple days',
	    ongoing: 'Automatic',
	    auto_created: 'Autogenerated',
	    from_another_school: 'From another school'
	  }
	};
	
	exports.default = {
	  components: { doPopover: _SchedulerItemPopover2.default },
	  props: {
	    user: {
	      type: Object
	    },
	    locale: {
	      default: 'da'
	    },
	    allEvents: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isSubStatusPendingActive: {
	      type: Boolean,
	      default: false
	    },
	    allCalendarsInHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    longAbsentListInHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    isActiveEventsLoading: {
	      default: false
	    },
	    theActiveEventsLoadingOnCalendarId: {
	      default: null
	    },
	    activeEvents: {
	      default: function _default() {
	        return [];
	      }
	    },
	    isHideEventsNotOverlappingAbsence: {
	      type: Boolean,
	      default: false
	    },
	    selectedEventTitleFilters: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedQuickFilters: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedClassFilters: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedGroupFilters: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isShowSelectButton: false,
	      selectButtonStyleObjForLoader: { color: '' },
	      selectButtonLoading: false,
	      slotWidth: 40,
	      slotHeight: 40,
	      absenceStackOffset: 13,
	      rows: 1,
	      firstEvent: true,
	      correctEvents: [],
	      subScoreMeta: [],
	      oldSubScoreMeta: [],
	      isEventsHasSortedOnce: false
	    };
	  },
	
	  computed: {
	    correctEventsFiltered: function correctEventsFiltered() {
	      var _this = this;
	
	      var events = this.correctEvents;
	      if (this.isHideEventsNotOverlappingAbsence && this.user.dayAbsence.length > 0) {
	        events = events.filter(function (event) {
	          return event.overlapsAbsent;
	        });
	      }
	      var isAbsentUser = this.user.dayAbsence && this.user.dayAbsence.length > 0;
	      var hasOtherSubFilters = this.selectedQuickFilters && this.selectedQuickFilters.length > 0 || this.selectedClassFilters && this.selectedClassFilters.length > 0 || this.selectedGroupFilters && this.selectedGroupFilters.length > 0;
	      if (!isAbsentUser && !hasOtherSubFilters && this.selectedEventTitleFilters && this.selectedEventTitleFilters.length > 0) {
	        events = events.filter(function (event) {
	          return event.obj && _this.selectedEventTitleFilters.indexOf(event.obj.title) > -1;
	        });
	      }
	      return events;
	    },
	    activeEventsFiltered: function activeEventsFiltered() {
	      var hasActiveEventsAndLoading = this.activeEvents.length > 0 && this.isActiveEventsLoading && this.theActiveEventsLoadingOnCalendarId === this.user.user_calendar_id;
	
	      var shouldShowBecauseOfSelectButton = this.isShowSelectButton && this.user.dayAbsence && this.user.dayAbsence.length < 1 && !this.user.headline;
	
	      if (hasActiveEventsAndLoading || shouldShowBecauseOfSelectButton) {
	        return this.activeEvents;
	      }
	
	      return [];
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    isOnActiveEvent: function isOnActiveEvent() {
	      var arr = this.allEventsInAHash[this.activeEvent.obj.id].calendar_events ? this.allEventsInAHash[this.activeEvent.obj.id].calendar_events.map(function (cal) {
	        return cal.calendar_id;
	      }) : [];
	
	      return arr.indexOf(this.user.user_calendar_id) > -1;
	    },
	    isShowSetAsSubButton: function isShowSetAsSubButton() {
	      return this.selectButtonLoading || this.isShowSelectButton && this.styleObj.color !== '' && this.user.dayAbsence.length < 1 && !this.user.headline && this.activeEvent && this.activeEvent.obj.event_type !== 'absence' && !this.isOnActiveEvent;
	    },
	    schedulerActiveEvent: function schedulerActiveEvent() {
	      return this.$store.state.subs.schedulerActiveEvent;
	    },
	    styleObj: function styleObj() {
	      return this.schedulerActiveEvent.obj ? this.schedulerActiveEvent : this.selectButtonStyleObjForLoader;
	    },
	    activeEvent: function activeEvent() {
	      return this.$store.state.subs.activeEvent;
	    },
	    activeUser: function activeUser() {
	      return this.$store.state.subs.activeUser;
	    },
	    isSortSubActive: function isSortSubActive() {
	      return this.$store.state.subs.isSortSubActive;
	    },
	    users: function users() {
	      return this.$store.state.subs.allUsersAndEvents;
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    calsAndEventIds: function calsAndEventIds() {
	      return this.$store.state.subs.allCalsWithEventIdsInHash;
	    },
	    userLessons: function userLessons() {
	      var _this2 = this;
	
	      return this.user.dayEvents.map(function (eventId) {
	        return _this2.allEventsInAHash[eventId];
	      });
	    },
	    userPresence: function userPresence() {
	      var _this3 = this;
	
	      return this.user.dayPresence.map(function (eventId) {
	        return _this3.allEventsInAHash[eventId];
	      });
	    },
	    userAbsence: function userAbsence() {
	      var _this4 = this;
	
	      return this.user.dayAbsence.map(function (eventId) {
	        return _this4.allEventsInAHash[eventId];
	      });
	    },
	    hasAbsence: function hasAbsence() {
	      return this.userAbsence.length > 1 ? 25 : this.userAbsence.length === 1 ? 12 : 0;
	    },
	    userAbsenceForPlacing: function userAbsenceForPlacing() {
	      var _this5 = this;
	
	      return this.userAbsence.map(function (event, index) {
	        var stackTop = _this5.absenceStackOffset * index;
	        return {
	          'left': _this5.eventTop(event),
	          'right': _this5.eventRight(event),
	          'row': 0,
	          'bottom': _this5.eventBottom(event),
	          'obj': event,
	          'stackTop': stackTop,
	          'stackHeight': 'calc(100% - 1px - ' + stackTop + 'px)',
	          'zIndex': stackTop > 0 ? 1000 : 100
	        };
	      });
	    },
	    userPresenceForPlacing: function userPresenceForPlacing() {
	      var _this6 = this;
	
	      return this.userPresence.map(function (event) {
	        return {
	          'left': _this6.eventTop(event),
	          'right': _this6.eventRight(event),
	          'obj': event
	        };
	      });
	    },
	    sortedEvents: function sortedEvents() {
	      var _this7 = this;
	
	      var arr = this.userLessons.map(function (lesson) {
	        return (0, _extends3.default)({}, lesson, {
	          v_status: _this7.getSubstitutionStatusForUserCalId(lesson)
	        });
	      });
	      return arr.sort(function (a, b) {
	        return moment(a.start).unix() - moment(b.start).unix();
	      });
	    },
	    activeDate: function activeDate() {
	      return this.$store.state.subs.date;
	    },
	    isSchoolCalendarsLoading: function isSchoolCalendarsLoading() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    userMinHeight: function userMinHeight() {
	      var initialHeight = this.userAbsence.length > 1 ? 25 : 0;
	      return initialHeight + 40 * this.rows + 'px';
	    },
	    showOverlappingClassBadge: function showOverlappingClassBadge() {
	      var settings = this.$store.state.schoolSettings || {};
	      return settings.showOverlappingClassBadgeInSubstitution !== false;
	    }
	  },
	  watch: {
	    sortedEvents: function sortedEvents() {
	      this.rows = 1;
	      this.$emit('rows', { 'rows': this.rows });
	      this.correctEvents.splice(0, this.correctEvents.length);
	      this.setWidthAndLeft();
	    },
	    isSchoolCalendarsLoading: function isSchoolCalendarsLoading() {
	      this.setWidthAndLeft();
	    },
	    showOverlappingClassBadge: function showOverlappingClassBadge() {
	      this.setWidthAndLeft();
	    }
	  },
	  methods: {
	    addSubToActiveEvents: function addSubToActiveEvents() {
	      if (this.user.dayAbsence.length > 0 || this.activeEvents.length === 0) {
	        return;
	      }
	      this.$store.dispatch('addSubToActiveEvents', this.user.user_calendar_id);
	    },
	    getSerialListItem: function getSerialListItem(reason) {
	      return this.longAbsentListInHash[reason.event_serial_id] || false;
	    },
	    getIsAbsenceOngoing: function getIsAbsenceOngoing(reason) {
	      return this.getSerialListItem(reason) && this.getSerialListItem(reason).ongoing;
	    },
	    getIsAbsenceAutoGenerated: function getIsAbsenceAutoGenerated(reason) {
	      var statusObj = reason.substitution_status ? JSON.parse(reason.substitution_status) : {};
	      return statusObj['extended_at'] && moment(statusObj['extended_at']).isSame(moment(this.activeDate).format('YYYY-MM-DD'));
	    },
	    getIsAbsenceMultipleDays: function getIsAbsenceMultipleDays(reason) {
	      var serialItem = this.getSerialListItem(reason);
	      return serialItem && moment(serialItem.from_date).format('YYYY-MM-DD') !== moment(serialItem.to_date).format('YYYY-MM-DD');
	    },
	    getAbsenceTitle: function getAbsenceTitle(reason) {
	      var baseTitle = reason && reason.title ? reason.title : '';
	      var title = baseTitle;
	
	      if (reason && reason.away === true && reason.calendar_events && reason.calendar_events.length) {
	        var klassList = '';
	        for (var i = 0; i < reason.calendar_events.length; i++) {
	          var ev = reason.calendar_events[i];
	          if (ev && ev.calendar_type === 'klass' && ev.name) {
	            if (klassList.length) klassList += ', ';
	            klassList += ev.name;
	          }
	        }
	        if (klassList.length) title += ' - ' + klassList;
	      }
	
	      var isOngoing = this.getIsAbsenceOngoing(reason);
	      var isMultiple = this.getIsAbsenceMultipleDays(reason);
	      var str = '';
	
	      if (this.getIsAbsenceAutoGenerated(reason)) {
	        str = '(' + this.i18n['ongoing'] + ')' + '<span class="marg-5-left badge badge--small badge--orange-warning">' + this.i18n['auto_created'] + '</span>';
	      } else if (isOngoing || isMultiple) {
	        str = isOngoing ? '(' + this.i18n['ongoing'] + ')' : '(' + this.i18n['multiple_days'] + ')';
	      }
	
	      if (str) title += ' - ' + str;
	
	      return title;
	    },
	    allOnLessonHumanized: function allOnLessonHumanized(lesson) {
	      if (!lesson) return [];
	
	      if (lesson.subs && lesson.subs.length > 0) {
	        return lesson.subs.map(function (obj) {
	          return obj && obj.name ? obj.name : '';
	        });
	      } else if (lesson.othersOnLessonForBadge) {
	        return lesson.othersOnLessonForBadge.map(function (obj, idx) {
	          return obj && obj.name && idx < 3 ? obj.name : '';
	        });
	      }
	
	      return [];
	    },
	    usersOverlappingInClass: function usersOverlappingInClass(lesson) {
	      var _this8 = this;
	
	      var klassCals = lesson.calendar_events.filter(function (cal) {
	        return cal.calendar_type === 'klass';
	      });
	      var firstKlassCal = klassCals[0];
	      if (!firstKlassCal) return [];
	
	      var calData = this.calsAndEventIds[firstKlassCal.calendar_id];
	      if (!calData || !calData.lessons) return [];
	
	      var lessonRange = moment.range(lesson.start, lesson.end);
	      var seen = {};
	      var users = [];
	
	      calData.lessons.forEach(function (eventId) {
	        var event = _this8.allEventsInAHash[eventId];
	        if (!event || !event.calendar_events || event.id === lesson.id) return;
	        if (!lessonRange.overlaps(moment.range(event.start, event.end))) return;
	
	        event.calendar_events.forEach(function (cal) {
	          if (cal.calendar_type !== 'user') return;
	          if (cal.calendar_id === _this8.user.user_calendar_id) return;
	          if (seen[cal.calendar_id]) return;
	          var user = _this8.users[cal.calendar_id];
	          if (!user) return;
	          seen[cal.calendar_id] = true;
	          users.push(user);
	        });
	      });
	      return users;
	    },
	    mergeUsersForBadge: function mergeUsersForBadge(othersOnLesson, usersOverlappingInClass) {
	      var seen = {};
	      var users = [];
	      othersOnLesson.concat(usersOverlappingInClass).forEach(function (user) {
	        if (!user || seen[user.user_calendar_id]) return;
	        seen[user.user_calendar_id] = true;
	        users.push(user);
	      });
	      return users;
	    },
	    getSubstitutionStatusForUserCalId: function getSubstitutionStatusForUserCalId(lesson) {
	      var _this9 = this;
	
	      if (lesson.canceled === true) {
	        return 1;
	      }
	
	      var statusObj = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	      var userStatus = statusObj[this.user.user_calendar_id] ? statusObj[this.user.user_calendar_id].status : 0;
	
	      if (this.isSubStatusPendingActive) {
	        return userStatus;
	      } else {
	        var isUserSubstituted = lesson.calendar_events.some(function (calEvent) {
	          return calEvent.substitute_for_user_id === _this9.user.id;
	        });
	        if (isUserSubstituted || userStatus === 1) {
	          return 1;
	        } else {
	          return 0;
	        }
	      }
	    },
	    getLocaleTime: function getLocaleTime(lesson) {
	      var start = moment(lesson.start).format('LT');
	      var end = moment(lesson.end).format('LT');
	      return start + ' - ' + end;
	    },
	    getSubs: function getSubs(activeEvent, userId) {
	      var calendars = activeEvent.calendar_events;
	      return calendars.filter(function (calEvent) {
	        return calEvent.substitute_for_user_id === userId;
	      });
	    },
	    setPopover: function setPopover(lesson, evt) {
	      var _this10 = this;
	
	      if (lesson.obj.v_is_event_from_other_school) {
	        return;
	      }
	      var activeEventIntoDbEvent = null;
	
	      var isAltTrigger = evt && (evt.metaKey || evt.ctrlKey);
	      if (isAltTrigger && this.user.dayAbsence.length > 0 && lesson.obj.event_type !== 'absence') {
	        var dbEvent = {
	          school_id: lesson.obj.school_id,
	          event_id: lesson.obj.id,
	          calendar_id: this.user.user_calendar_id,
	          user_to_substitute: this.user.name,
	          left: lesson.left,
	          right: lesson.right,
	          color: lesson.obj.color,
	          lesson: lesson.obj,
	          lessonLTTime: this.getLocaleTime(lesson.obj),
	          selectedSubs: this.getSubs(lesson.obj, this.user.id)
	        };
	        if (this.activeEvent && this.activeEvent.obj.event_type !== 'absence') {
	          activeEventIntoDbEvent = {
	            school_id: this.activeEvent.obj.school_id,
	            event_id: this.activeEvent.obj.id,
	            calendar_id: this.activeUser.user_calendar_id,
	            user_to_substitute: this.activeUser.name,
	            left: this.activeEvent.left,
	            right: this.activeEvent.right,
	            color: this.activeEvent.obj.color,
	            lesson: this.activeEvent.obj,
	            lessonLTTime: this.getLocaleTime(lesson.obj),
	            selectedSubs: this.getSubs(lesson.obj, this.activeUser.id)
	          };
	        }
	        setTimeout(function (_) {
	          if (activeEventIntoDbEvent) {
	            _this10.$store.commit('setActiveEvents', activeEventIntoDbEvent);
	          }
	          _this10.$store.commit('setActiveEvents', dbEvent);
	        }, 100);
	        this.$store.dispatch('trackEvent', 'substitution_altTrigger_used');
	        return;
	      }
	      this.$store.commit('clearActiveEvents');
	      setTimeout(function () {
	        var overlappingEvents = [];
	        if (_this10.isSortSubActive && _this10.user.dayAbsence.length > 0 && lesson.obj.event_type !== 'absence') {
	          _this10.oldSubScoreMeta = _this10.subScoreMeta;
	          _this10.subScoreMeta = lesson.othersOnLesson;
	          _this10.allEvents.forEach(function (event) {
	            var range1 = moment.range(lesson.obj.start, lesson.obj.end);
	            var range2 = moment.range(event.start, event.end);
	            if (range1.overlaps(range2)) {
	              overlappingEvents.push(event);
	            }
	          });
	        }
	        _this10.$store.commit('setActiveUser', _this10.user);
	        _this10.$store.commit('setActiveEvent', lesson);
	        _this10.$store.dispatch('setActiveSchedulerEvent', {
	          'obj': lesson.obj,
	          'left': lesson.left,
	          'right': lesson.right,
	          'color': lesson.obj.color,
	          'user': _this10.user,
	          'userIsAbsent': _this10.user.dayAbsence.length > 0,
	          'oldSubScoreMeta': _this10.oldSubScoreMeta,
	          'othersOnLesson': lesson.othersOnLesson,
	          'overlappingEvents': overlappingEvents
	        });
	      }, 100);
	    },
	    eventOverLapsAbsence: function eventOverLapsAbsence(event) {
	      var overlaps = false;
	      for (var i = 0; i < this.user.dayAbsence.length; i++) {
	        var lesson = this.allEventsInAHash[this.user.dayAbsence[i]];
	        var range1 = moment.range(lesson.start, lesson.end);
	        var range2 = moment.range(event.start, event.end);
	        if (range1.overlaps(range2)) {
	          overlaps = true;
	        }
	      }
	      return overlaps;
	    },
	    eventRight: function eventRight(event) {
	      var time = moment.duration({
	        minutes: moment(event.end).format('mm'),
	        hours: moment(event.end).format('HH')
	      }).asMinutes();
	      var endOfDay = moment.duration({
	        hours: 24,
	        minutes: 0
	      }).asMinutes();
	      return this.slotWidth * 2 / 60 * (endOfDay - time);
	    },
	    eventTop: function eventTop(event) {
	      var calStartTime = moment(event.start).set({
	        'hour': 0,
	        'minutes': 0
	      });
	      var eventStartTime = moment(event.start);
	      var duration = moment(eventStartTime).diff(calStartTime);
	      return this.slotHeight * 2 / 60 * moment.duration(duration).asMinutes();
	    },
	    eventHeight: function eventHeight(event) {
	      var duration = moment(event.end).diff(event.start);
	      return this.slotHeight * 2 / 60 * moment.duration(duration).asMinutes();
	    },
	    eventBottom: function eventBottom(event) {
	      var calStartTime = moment(event.end).set({
	        'hour': 0,
	        'minutes': 0
	      });
	      var eventEndTime = moment(event.end);
	      var duration = moment(eventEndTime).diff(calStartTime);
	      return this.slotHeight * 2 / 60 * moment.duration(duration).asMinutes();
	    },
	    collidesWith: function collidesWith(a, b) {
	      return a.bottom > b.top && a.top < b.bottom;
	    },
	    packEvents: function packEvents(columns) {
	      var _this11 = this;
	
	      var n = columns.length;
	
	      var _loop = function _loop(i) {
	        var col = columns[i];
	
	        var _loop2 = function _loop2(j) {
	          var ev = col[j];
	          var colSpan = _this11.expandEvent(ev, i, columns);
	          col[j].row = i;
	          if (i + 1 > _this11.rows) {
	            _this11.rows = i + 1;
	          }
	          _this11.$emit('rows', { 'rows': _this11.rows });
	          col[j].colspan = colSpan / n;
	          var idx = _this11.correctEvents.findIndex(function (lesson) {
	            return lesson.obj.id === col[j].obj.id;
	          });
	          if (idx < 0) {
	            _this11.correctEvents.push(col[j]);
	          } else {
	            _this11.$set(_this11.correctEvents, idx, col[j]);
	          }
	
	          if (_this11.firstEvent) {
	            _this11.$emit('lessonsUpdate', _this11.correctEvents[0]);
	          }
	          _this11.firstEvent = false;
	        };
	
	        for (var j = 0; j < col.length; j++) {
	          _loop2(j);
	        }
	      };
	
	      for (var i = 0; i < n; i++) {
	        _loop(i);
	      }
	    },
	    expandEvent: function expandEvent(ev, iColumn, columns) {
	      var colSpan = 1;
	      for (var i = iColumn + 1; i < columns.length; i++) {
	        var _col = columns[i];
	        for (var j = 0; j < _col.length; j++) {
	          var ev1 = _col[j];
	          if (this.collidesWith(ev, ev1)) {
	            return colSpan;
	          }
	        }
	        colSpan++;
	      }
	      return colSpan;
	    },
	    setWidthAndLeft: function setWidthAndLeft() {
	      var _this12 = this;
	
	      this.isEventsHasSortedOnce = true;
	      var columns = [];
	      var lastEventEnding = null;
	      var events = this.sortedEvents.map(function (elem) {
	        var subs = [];
	        var othersOnLesson = [];
	        var klassesOnLesson = [];
	
	        elem.calendar_events.forEach(function (calEvent) {
	          if (calEvent.calendar_id !== _this12.user.user_calendar_id && calEvent.substitute && calEvent.substitute_for_user_id === _this12.user.id) {
	            subs.push(_this12.users[calEvent.calendar_id]);
	          } else if (calEvent.calendar_type === 'user' && !calEvent.substitute && calEvent.calendar_id !== _this12.user.user_calendar_id) {
	            othersOnLesson.push(_this12.users[calEvent.calendar_id]);
	          } else if (calEvent.calendar_type === 'klass' || calEvent.calendar_type === 'club') {
	            klassesOnLesson.push(calEvent);
	          }
	        });
	        var top = _this12.eventTop(elem);
	        var height = _this12.eventHeight(elem);
	        var bottom = _this12.eventBottom(elem);
	        var right = _this12.eventRight(elem);
	        var overlapsAbsent = _this12.eventOverLapsAbsence(elem);
	        var usersOverlappingInClass = _this12.showOverlappingClassBadge ? _this12.usersOverlappingInClass(elem) : [];
	        return {
	          'obj': elem,
	          'top': top,
	          'left': top,
	          'right': right,
	          'height': height,
	          'bottom': bottom,
	          'overlapsAbsent': overlapsAbsent,
	          'subs': subs,
	          'othersOnLesson': othersOnLesson,
	          'othersOnLessonForBadge': _this12.mergeUsersForBadge(othersOnLesson, usersOverlappingInClass),
	          'klassesOnLesson': klassesOnLesson,
	          'klassesAsString': klassesOnLesson.filter(function (klass) {
	            return klass && klass.name;
	          }).map(function (klass) {
	            return klass.name;
	          }).join(', ')
	        };
	      });
	      events.sort(function (e1, e2) {
	        if (e1.top < e2.top) return -1;
	        if (e1.top > e2.top) return 1;
	        if (e1.bottom < e2.bottom) return -1;
	        if (e1.bottom > e2.bottom) return 1;
	        return 0;
	      });
	      for (var i = 0; i < events.length; i++) {
	        var e = events[i];
	        if (lastEventEnding !== null && e.top >= lastEventEnding) {
	          this.packEvents(columns);
	          columns = [];
	          lastEventEnding = null;
	        }
	        var placed = false;
	        for (var j = 0; j < columns.length; j++) {
	          var _col2 = columns[j];
	          if (!this.collidesWith(_col2[_col2.length - 1], e)) {
	            _col2.push(e);
	            placed = true;
	            break;
	          }
	        }
	        if (!placed) {
	          columns.push([e]);
	        }
	        if (lastEventEnding === null || e.bottom > lastEventEnding) {
	          lastEventEnding = e.bottom;
	        }
	      }
	      if (columns.length > 0) {
	        this.packEvents(columns);
	      }
	    },
	    setAddSubstitute: function setAddSubstitute() {
	      var _this13 = this;
	
	      if (this.selectButtonLoading) {
	        return;
	      }
	
	      if (this.checkIfAvailableEventOverlaps(this.activeEvent, this.sortedEvents)) {
	        var _userEventObj = { userAsSub: this.user, eventToSub: this.activeEvent.obj, userToSub: this.activeUser };
	        this.$emit('onChooseSubType', _userEventObj);
	        return;
	      }
	      this.selectButtonStyleObjForLoader = this.schedulerActiveEvent;
	      this.selectButtonLoading = true;
	      if (this.isSubStatusPendingActive) {
	        this.setSubStatus(this.activeEvent.obj, 2);
	      }
	      var userEventObj = { cal_id: this.user.user_calendar_id, event_id: this.activeEvent.obj.id };
	      _docendo2.default.eventAddSubstitute(this.activeEvent.obj.id, this.user.id, this.activeUser.id, function (data) {
	        _this13.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data));
	        _this13.$store.commit('addEventOnAllUsersWithEvents', userEventObj);
	        _this13.selectButtonLoading = false;
	        _this13.selectButtonStyleObjForLoader = { color: '' };
	      });
	    },
	    checkIfAvailableEventOverlaps: function checkIfAvailableEventOverlaps(eventToSubstitute, userEvents) {
	      var startTime = moment(eventToSubstitute.obj.start);
	      var endTime = moment(eventToSubstitute.obj.end);
	
	      var overlappingAvailableEvents = userEvents.filter(function (event) {
	        var eventStart = moment(event.start);
	        var eventEnd = moment(event.end);
	        return eventStart.isBefore(endTime) && eventEnd.isAfter(startTime) && event.event_type === 'available';
	      });
	
	      return overlappingAvailableEvents.length > 0;
	    },
	    setSubStatus: function setSubStatus(lesson, num) {
	      var _this14 = this;
	
	      var statusData = this.getSubstitutionStatus(lesson);
	      statusData[this.activeUser.user_calendar_id] = { 'status': num };
	      _docendo2.default.updateEvent(lesson.school_id, lesson.id, { substitution_status: (0, _stringify2.default)(statusData) }, function (success) {
	        _this14.$store.commit('updateSubStatusOnEvent', {
	          'eventId': lesson.id,
	          'status': (0, _stringify2.default)(statusData)
	        });
	      });
	    },
	    getSubstitutionStatus: function getSubstitutionStatus(lesson) {
	      return lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	    }
	  },
	  mounted: function mounted() {
	    this.rows = 1;
	    this.$emit('rows', { 'rows': this.rows });
	    this.setWidthAndLeft();
	  }
	};

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DSelectSubs = __webpack_require__(351);
	
	var _DSelectSubs2 = _interopRequireDefault(_DSelectSubs);
	
	var _DSelectSubsActiveEvents = __webpack_require__(1497);
	
	var _DSelectSubsActiveEvents2 = _interopRequireDefault(_DSelectSubsActiveEvents);
	
	var _SchedulerItemPopoverStatus = __webpack_require__(1636);
	
	var _SchedulerItemPopoverStatus2 = _interopRequireDefault(_SchedulerItemPopoverStatus);
	
	var _SubsUserAbsenceReason = __webpack_require__(101);
	
	var _SubsUserAbsenceReason2 = _interopRequireDefault(_SubsUserAbsenceReason);
	
	var _vuex = __webpack_require__(14);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _AppEIPWYZIWYG = __webpack_require__(55);
	
	var _AppEIPWYZIWYG2 = _interopRequireDefault(_AppEIPWYZIWYG);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DSelectCalendars = __webpack_require__(348);
	
	var _DSelectCalendars2 = _interopRequireDefault(_DSelectCalendars);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _LessonOverlapInKlass = __webpack_require__(1632);
	
	var _LessonOverlapInKlass2 = _interopRequireDefault(_LessonOverlapInKlass);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    absent: 'Fraværende',
	    user_not_found: 'Brugeren er fjernet fra skolen',
	    edit_teachers: 'Redigér underviser(e)',
	    delete_lesson: 'Slet lektion',
	    split_lesson: 'Opdel lektion',
	    edit_times: 'Rediger tider',
	    out_of_school: 'Ude af huset',
	    cancel_event: 'Aflys timen',
	    uncancel_event: 'Fortryd aflysning',
	    canceled: 'Aflyst',
	    choose_status: 'Vælg status',
	    set_handled: 'Sæt som håndteret',
	    set_not_handled: 'Sæt som ikke håndteret',
	    lesson: 'Lektion',
	    lessons: 'Lektioner',
	    selected: 'valgt',
	    remove_substitutes: 'Fjern vikarer',
	    confirm_remove_substitutes_text: 'Dette vil fjerne alle vikarer på de valgte lektioner.'
	  },
	  nb: {
	    absent: 'Fraværende',
	    user_not_found: 'Brukeren er fjernet fra skolen',
	    edit_teachers: 'Rediger lærer(e)',
	    delete_lesson: 'Slett time',
	    split_lesson: 'Del opp timen',
	    edit_times: 'Rediger tider',
	    out_of_school: 'Utenfor skolen',
	    canceled: 'Avlyst',
	    cancel_event: 'Avlys timen',
	    uncancel_event: 'Angre avlysning',
	    choose_status: 'Velg status',
	    set_handled: 'Sett som håndtert',
	    set_not_handled: 'Sett som ikke håndtert',
	    lesson: 'Time',
	    lessons: 'Timer',
	    selected: 'valgt',
	    remove_substitutes: 'Fjern vikarer',
	    confirm_remove_substitutes_text: 'Dette vil fjerne alle vikarer på de valgte timene.'
	  },
	  en: {
	    absent: 'Absent',
	    user_not_found: 'User is removed from school',
	    edit_teachers: 'Edit teacher(s)',
	    delete_lesson: 'Delete lesson',
	    split_lesson: 'Split lesson in two',
	    edit_times: 'Edit times',
	    out_of_school: 'Out of school',
	    canceled: 'Canceled',
	    cancel_event: 'Cancel lesson',
	    uncancel_event: 'Undo cancellation',
	    choose_status: 'Choose status',
	    set_handled: 'Mark as handled',
	    set_not_handled: 'Mark as not handled',
	    lesson: 'Lesson',
	    lessons: 'Lessons',
	    selected: 'selected',
	    remove_substitutes: 'Remove substitutes',
	    confirm_remove_substitutes_text: 'This will remove all substitutes on the selected lessons.'
	  }
	};
	
	exports.default = {
	  components: {
	    LessonOverlapInKlass: _LessonOverlapInKlass2.default,
	    DDropdown: _DDropdown2.default, Loader: _Loader2.default, DSelectCalendars: _DSelectCalendars2.default, dSelectSub: _DSelectSubs2.default, DSelectSubsActiveEvents: _DSelectSubsActiveEvents2.default, lessonsSubstitutionStatus: _SchedulerItemPopoverStatus2.default, AbsenceReason: _SubsUserAbsenceReason2.default, weip: _AppEIPWYZIWYG2.default, ModalConfirmation: _ModalConfirmation2.default
	  },
	  props: {
	    activeEventId: {
	      type: Object
	    },
	    user: {
	      type: Object,
	      default: function _default() {}
	    },
	    locale: {
	      default: 'da'
	    },
	    activeEvents: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    possibleSubs: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  mixins: [_vueClickaway.mixin],
	  data: function data() {
	    return {
	      isUpdatingSubstitutes: false,
	      isEditTeacher: false,
	      isUpdatingTeachers: false,
	      showAllOnLesson: 3,
	      propStatus: 3,
	      isActiveEIP: false,
	      hasSubstituteNoteChanged: false,
	      propToCloseDropdown: 0,
	      activeEventsStatus: '',
	      isConfirmRemoveSubs: false
	    };
	  },
	
	  filters: {
	    time: function time(date) {
	      return (0, _moment2.default)(date).format('LT');
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['allCalendarsInHash', 'userSet', 'allUsersInHash', 'isSubStatusPendingActive']), {
	    i18n: function i18n() {
	      return I18N;
	    },
	    isActiveEvents: function isActiveEvents() {
	      return this.activeEvents.length > 0;
	    },
	    hasActiveEventsWithSubs: function hasActiveEventsWithSubs() {
	      return this.activeEvents.some(function (ev) {
	        var hasSelected = ev.selectedSubs && ev.selectedSubs.length > 0;
	        var hasLessonSubs = ev.lesson && ev.lesson.calendar_events && ev.lesson.calendar_events.some(function (ce) {
	          return ce.substitute === true;
	        });
	        return hasSelected || hasLessonSubs;
	      });
	    },
	    subsRemovalList: function subsRemovalList() {
	      var _this = this;
	
	      var pairs = [];
	      this.activeEvents.forEach(function (ev) {
	        var selected = Array.isArray(ev.selectedSubs) && ev.selectedSubs.length > 0 ? ev.selectedSubs : ev.lesson && Array.isArray(ev.lesson.calendar_events) ? ev.lesson.calendar_events.filter(function (ce) {
	          return ce.substitute === true;
	        }) : [];
	        selected.forEach(function (ce) {
	          var subName = ce.name;
	
	          var forName = ev.user_to_substitute;
	          if ((!forName || forName === '') && ce.substitute_for_user_id) {
	            var u = _this.allUsersInHash[ce.substitute_for_user_id];
	            if (u && u.name) forName = u.name;
	          }
	          pairs.push({ subName: subName, forName: forName || '' });
	        });
	      });
	
	      var seen = {};
	      var out = [];
	      for (var i = 0; i < pairs.length; i++) {
	        var key = pairs[i].subName + '->' + pairs[i].forName;
	        if (!seen[key]) {
	          seen[key] = true;
	          out.push(pairs[i]);
	        }
	      }
	      return out;
	    },
	    isActiveEventsLoading: function isActiveEventsLoading() {
	      return this.$store.state.subs.isActiveEventsLoading;
	    },
	    lesson: function lesson() {
	      return this.allEventsInAHash[this.activeEventId.obj.id];
	    },
	    isCanceled: function isCanceled() {
	      return this.lesson.canceled;
	    },
	    isAway: function isAway() {
	      return this.lesson.away;
	    },
	    allUsersAndEvents: function allUsersAndEvents() {
	      return this.$store.state.subs.allUsersAndEvents;
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    calsOnLesson: function calsOnLesson() {
	      var _this2 = this;
	
	      return this.lesson.calendar_events.map(function (event) {
	        return _this2.allCalendarsInHash[event.calendar_id];
	      });
	    },
	    klassesOnLesson: function klassesOnLesson() {
	      return this.calsOnLesson.filter(function (cal) {
	        return cal && cal.type === 'klass' || cal && cal.type === 'other';
	      });
	    },
	    usersOnLesson: function usersOnLesson() {
	      var _this3 = this;
	
	      var userIds = [];
	      this.lesson.calendar_events.forEach(function (cal) {
	        if (cal.calendar_type === 'user' && !cal.substitute && cal.calendar_type === 'user' && cal.calendar_id !== _this3.lesson.calendar_id) {
	          userIds.push(cal.calendar_id);
	        }
	      });
	      return userIds;
	    },
	    userCalIdsSubstituted: function userCalIdsSubstituted() {
	      var _this4 = this;
	
	      var userIdsSubstituted = this.lesson.calendar_events.map(function (cal) {
	        return cal.substitute_for_user_id;
	      });
	      return userIdsSubstituted.filter(function (userId) {
	        return _this4.allUsersInHash[userId];
	      }).map(function (userId) {
	        return _this4.allUsersInHash[userId].user_calendar_id;
	      });
	    },
	    othersOnLesson: function othersOnLesson() {
	      var users = [];
	      for (var i = 0; i < this.lesson.calendar_events.length; i++) {
	        if (this.allUsersAndEvents[this.lesson.calendar_events[i].calendar_id] && !this.lesson.calendar_events[i].substitute && this.lesson.calendar_events[i].calendar_id !== this.user.user_calendar_id) {
	          var user = this.allUsersAndEvents[this.lesson.calendar_events[i].calendar_id];
	          user['v_isUserAbsentFromLesson'] = this.absenceOverlapLesson(this.lesson.id, user.dayAbsence);
	          users.push(user);
	        }
	      }
	      return users;
	    },
	    userNotFoundPlaceholder: function userNotFoundPlaceholder() {
	      return {
	        id: 0,
	        name: this.i18n[this.locale]['user_not_found'],
	        type: 'user',
	        url: '/calendar',
	        calendar_id: 0,
	        dayAbsence: [],
	        dayEvents: [],
	        dayAllEvents: [],
	        default_thumb_url: '',
	        user_tags: [],
	        occupied: false,
	        isOnLesson: false,
	        currentEventId: 0,
	        user_calendar_id: 0,
	        isErrorUser: true
	      };
	    },
	    substitutesOnLesson: function substitutesOnLesson() {
	      var _this5 = this;
	
	      var subs = [];
	      this.lesson.calendar_events.map(function (event) {
	        if (event.substitute && event.substitute_for_user_id === _this5.user.id) {
	          var sub = _this5.allUsersAndEvents[event.calendar_id] ? _this5.allUsersAndEvents[event.calendar_id] : _this5.userNotFoundPlaceholder;
	          subs.push(sub);
	        }
	      });
	      return subs;
	    }
	  }),
	  methods: {
	    addSubToActiveEvents: function addSubToActiveEvents(user) {
	      this.$store.dispatch('addSubToActiveEvents', user.user_calendar_id);
	    },
	    setActiveSplitLesson: function setActiveSplitLesson(lesson) {
	      this.propToCloseDropdown++;
	      this.$emit('splitLesson', lesson);
	    },
	    setActiveEditTimes: function setActiveEditTimes(lesson) {
	      this.propToCloseDropdown++;
	      this.$emit('editTimes', lesson);
	    },
	    onDeletedLesson: function onDeletedLesson(lesson) {
	      this.propToCloseDropdown++;
	      this.$emit('deleteEvent', lesson);
	    },
	    setUsers: function setUsers(userCals) {
	      var _this6 = this;
	
	      this.isUpdatingTeachers = true;
	      var userCalIds = userCals.map(function (cal) {
	        return cal.id;
	      });
	      var calIdsNotInUserCalIds = this.lesson.calendar_events.filter(function (cal) {
	        return !(cal.calendar_type === 'user' && cal.substitute === false && cal.calendar_id !== _this6.lesson.calendar_id);
	      }).map(function (cal) {
	        return cal.calendar_id;
	      });
	      var allCals = calIdsNotInUserCalIds.concat(userCalIds);
	      var updates = [{ event_id: this.lesson.id, calendar_ids: allCals }];
	      _docendo2.default.updateEvents(this.lesson.school_id, updates, function (success) {
	        _this6.$store.dispatch('getAllDayEvents');
	        _this6.isUpdatingTeachers = false;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    showLog: function showLog(event) {
	      this.$emit('showLog', event);
	    },
	    absenceOverlapLesson: function absenceOverlapLesson(lessonId, absenceIds) {
	      var _this7 = this;
	
	      var absenceOverlapping = [];
	      var absenceEvents = absenceIds.map(function (eventId) {
	        return _this7.allEventsInAHash[eventId];
	      });
	      var lessonEvent = this.allEventsInAHash[lessonId];
	      absenceEvents.forEach(function (absenceEvent) {
	        var range1 = _moment2.default.range(absenceEvent.start, absenceEvent.end);
	        var range2 = _moment2.default.range(lessonEvent.start, lessonEvent.end);
	        if (range1.intersect(range2)) {
	          var absentLessonReadable = absenceEvent.title + ' ' + (0, _moment2.default)(absenceEvent.start).format('LT') + '-' + (0, _moment2.default)(absenceEvent.end).format('LT');
	          absenceOverlapping.push(absentLessonReadable);
	        }
	      });
	      return absenceOverlapping;
	    },
	    getUser: function getUser(calId) {
	      return this.allCalendarsInHash[calId] && this.allCalendarsInHash[calId].name ? this.allCalendarsInHash[calId].name : 'Not found';
	    },
	    updateTeacherNote: function updateTeacherNote(obj) {
	      var _this8 = this;
	
	      if (this.lesson.teacher_notes === obj.text || !obj) {
	        return;
	      }
	      var eventIdAndTeacherNote = {
	        eventId: this.lesson.id,
	        note: obj.text
	      };
	      _docendo2.default.updateEvent(window.SCHOOL.id, obj.lesson.id, (0, _defineProperty3.default)({}, obj.noteType, obj.text), function (success) {
	        _this8.$store.commit('updateTeacherNoteOnEvent', eventIdAndTeacherNote);
	      });
	    },
	    addSubstitute: function addSubstitute(userObj) {
	      var _this9 = this;
	
	      if (userObj.isWithAvailability) {
	        var updateObj = {
	          eventToSub: this.lesson,
	          userAsSub: userObj,
	          userToSub: this.user
	        };
	        this.$emit('chooseSubType', updateObj);
	        this.emitClose();
	        return;
	      }
	      this.isUpdatingSubstitutes = true;
	      if (this.isSubStatusPendingActive) {
	        this.propStatus = 2;
	      }
	
	      var userEventObj = { cal_id: userObj.user_calendar_id, event_id: this.lesson.id };
	      _docendo2.default.eventAddSubstitute(this.lesson.id, userObj.id, this.user.id, function (data) {
	        _this9.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data));
	        _this9.$store.commit('addEventOnAllUsersWithEvents', userEventObj);
	        _this9.isUpdatingSubstitutes = false;
	      });
	    },
	    setStatusOnActiveEvents: function setStatusOnActiveEvents(val) {
	      console.log('Valgt status:', val);
	      this.$store.dispatch('updateStatusOnActiveEvents', val);
	    },
	    confirmRemoveSubs: function confirmRemoveSubs() {
	      this.$store.dispatch('removeSubsOnActiveEvents');
	      this.isConfirmRemoveSubs = false;
	    },
	    removeSubstitute: function removeSubstitute(userObj) {
	      var _this10 = this;
	
	      this.isUpdatingSubstitutes = true;
	
	      var subsForTheSub = [];
	      this.lesson.calendar_events.forEach(function (calEvent) {
	        if (calEvent.substitute && calEvent.substitute_for_user_id === userObj.id) {
	          subsForTheSub.indexOf(calEvent.calendar_id) < 0 ? subsForTheSub.push(calEvent.calendar_id) : null;
	        }
	      });
	      var userAndSubsForUser = {
	        user: this.user,
	        lesson: this.lesson,
	        subToBeRemoved: userObj,
	        subsForTheSubToBeRemoved: subsForTheSub
	      };
	      if (subsForTheSub.length > 0) {
	        this.$emit('removeSubs', userAndSubsForUser);
	        return;
	      }
	
	      this.propStatus = 0;
	      _docendo2.default.eventRemoveSubstitute(this.lesson.id, userObj.id, this.user.id, function (data) {
	        _this10.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data));
	        _this10.$store.commit('removeEventOnAllUsersWithEvents', {
	          cal_id: userObj.user_calendar_id,
	          event_id: _this10.lesson.id
	        });
	        _this10.isUpdatingSubstitutes = false;
	      });
	    },
	    emitClose: function emitClose(e) {
	      this.$emit('close');
	    },
	    emitClickAway: function emitClickAway(evt) {
	      if (this.isActiveEvents) {
	        var target = evt.target;
	        var classesNotToTarget = ['day-cal__event__subs__img', 'day-cal__event__subs', 'select-user__button', 'day-cal__event__other', 'icon-user'];
	        if (target && classesNotToTarget.some(function (cls) {
	          return target.classList.contains(cls);
	        })) {
	          return;
	        }
	      }
	      var targ = evt.target.closest('ul');
	
	      if (targ && targ.classList.contains('d-select__items__container') || _eventbus2.default.isLessonNoteChangedWithoutSaving) {
	        return;
	      }
	      this.$emit('clickaway');
	    }
	  }
	};

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    user: {
	      type: Object,
	      default: null
	    },
	
	    userCalendarId: {
	      type: Number
	    },
	    lesson: {
	      type: Object,
	      default: function _default() {}
	    },
	    statusProp: {
	      type: Number,
	      default: 0
	    },
	    dropdownPlacement: {
	      type: String,
	      default: 'bottom-end'
	    },
	    othersOnLesson: {
	      type: Array,
	      default: []
	    },
	    isSubStatusPendingActive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    statusDotClass: function statusDotClass() {
	      if (this.status === 2) {
	        return 'dot-yellow';
	      }
	      if (!this.status || this.status === 0) {
	        return 'dot-white';
	      }
	    },
	    substitution_status: function substitution_status() {
	      return this.lesson.substitution_status ? JSON.parse(this.lesson.substitution_status) : {};
	    },
	    status: function status() {
	      return this.substitution_status[this.userCalendarId] ? this.substitution_status[this.userCalendarId].status : null;
	    },
	    othersOnLessonAbsence: function othersOnLessonAbsence() {
	      return this.othersOnLesson.filter(function (user) {
	        return user.v_isUserAbsentFromLesson && user.v_isUserAbsentFromLesson.length > 0;
	      }).map(function (user) {
	        return user.user_calendar_id;
	      });
	    },
	    getIsUserSubstituted: function getIsUserSubstituted() {
	      var _this = this;
	
	      var isUserSubstituted = this.lesson.calendar_events.some(function (calEvent) {
	        return calEvent.substitute_for_user_id === _this.user.id;
	      });
	      return isUserSubstituted;
	    }
	  },
	  data: function data() {
	    return {
	      showDropdown: false,
	      isSubmitting: false
	    };
	  },
	
	  watch: {
	    statusProp: function statusProp(val, oldVal) {
	      this.setStatus(this.statusProp);
	    }
	  },
	  methods: {
	    setStatusForAll: function setStatusForAll() {
	      var _this2 = this;
	
	      this.isSubmitting = true;
	      var calendarIds = [this.userCalendarId];
	      var otherAbsentUsers = JSON.parse((0, _stringify2.default)(this.othersOnLessonAbsence));
	      var allCalendarIds = calendarIds.concat(otherAbsentUsers);
	      var statusData = (0, _extends3.default)({}, this.substitution_status);
	      allCalendarIds.forEach(function (id) {
	        statusData[id] = { 'status': 1 };
	      });
	      _docendo2.default.updateEvent(this.lesson.school_id, this.lesson.id, { substitution_status: (0, _stringify2.default)(statusData) }, function (success) {
	        _this2.$store.commit('updateSubStatusOnEvent', {
	          'eventId': _this2.lesson.id,
	          'status': (0, _stringify2.default)(statusData)
	        });
	        _this2.isSubmitting = false;
	        _this2.closeDropDown();
	      });
	    },
	    setStatus: function setStatus(num) {
	      var _this3 = this;
	
	      this.isSubmitting = true;
	      var statusData = (0, _extends3.default)({}, this.substitution_status);
	
	      if (num === 0) {
	        if (!statusData[this.userCalendarId]) {
	          this.isSubmitting = false;
	          this.closeDropDown();
	          return;
	        }
	        delete statusData[this.userCalendarId];
	      } else {
	        statusData[this.userCalendarId] = { status: num };
	      }
	      var payload = {
	        substitution_status: (0, _stringify2.default)(statusData)
	      };
	      _docendo2.default.updateEvent(this.lesson.school_id, this.lesson.id, payload, function (success) {
	        if (success) {
	          _this3.$store.commit('updateSubStatusOnEvent', {
	            eventId: _this3.lesson.id,
	            status: payload.substitution_status
	          });
	        } else {
	          console.error('Failed to update substitution status');
	        }
	
	        _this3.isSubmitting = false;
	        _this3.closeDropDown();
	      });
	    },
	    closeDropDown: function closeDropDown() {
	      if (!this.showDropdown) {
	        return;
	      }
	      this.showDropdown = false;
	    }
	  }
	};

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _entries = __webpack_require__(50);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _vuedraggable = __webpack_require__(108);
	
	var _vuedraggable2 = _interopRequireDefault(_vuedraggable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    draggable: _vuedraggable2.default
	  },
	  props: {
	    propsIsPrioritizerActive: {
	      default: false
	    }
	  },
	  watch: {
	    propsIsPrioritizerActive: function propsIsPrioritizerActive(val) {
	      this.setIsPrioritizerActive(val);
	    }
	  },
	  data: function data() {
	    return {
	      isPrioritizerActive: false,
	      isEditable: true,
	      isChangeHasBeenMade: false,
	      list: [],
	      translations: {
	        canceledHours: this.$t('vue2.sub_scheduler.has_canceled_hours'),
	        othersOnLesson: this.$t('vue2.sub_scheduler.already_on_lesson'),
	        isInSameClassAtTheSameTime: this.$t('vue2.sub_scheduler.is_in_same_class_at_the_same_time'),
	        hasHoursInClassOnDay: this.$t('vue2.sub_scheduler.has_hours_in_class_on_day'),
	        multipleLessonsInSameClasses: this.$t('vue2.sub_scheduler.multiple_lessons_in_same_classes'),
	        availableHour: this.$t('vue2.sub_scheduler.not_occupied_with_available_lesson'),
	        presence: this.$t('vue2.sub_scheduler.not_occupied_with_work_hours'),
	        notOccupiedWithLessonsOnDay: this.$t('vue2.sub_scheduler.not_occupied_without_work_hours'),
	        severalOnALesson: this.$t('vue2.sub_scheduler.multiple_on_a_lesson'),
	        notOccupiedWithoutLessonsOnDay: this.$t('vue2.sub_scheduler.not_occupied_without_lessons_on_the_day'),
	        occupied: this.$t('vue2.sub_scheduler.occupied'),
	        absence: this.$t('vue2.sub_scheduler.absent_people')
	      }
	    };
	  },
	
	  computed: {
	    dragOptions: function dragOptions() {
	      return {
	        animation: 0,
	        group: 'description',
	        disabled: false,
	        ghostClass: 'ghost'
	      };
	    },
	    storeSorting: function storeSorting() {
	      return this.$store.state.subs.sortingHierarchy;
	    },
	    sortingHierarchy: function sortingHierarchy() {
	      return (0, _entries2.default)(this.storeSorting).sort(function (a, b) {
	        return a[1] - b[1];
	      });
	    },
	    updatedList: function updatedList() {
	      return this.list.map(function (item, idx) {
	        return {
	          name: item[0], value: idx * 3
	        };
	      });
	    },
	    unAvailableItems: function unAvailableItems() {
	      return [['notOccupiedWithoutLessonsOnDay', this.storeSorting.notOccupiedWithoutLessonsOnDay], ['occupied', this.storeSorting.occupied]];
	    }
	  },
	  methods: {
	    setIsPrioritizerActive: function setIsPrioritizerActive(boolean) {
	      if (boolean) {
	        this.list = this.sortingHierarchy.filter(function (item) {
	          return item[0] !== 'absence' && item[0] !== 'occupied' && item[0] !== 'notOccupiedWithoutLessonsOnDay';
	        });
	        this.isPrioritizerActive = true;
	        this.isChangeHasBeenMade = false;
	      } else {
	        this.isPrioritizerActive = false;
	      }
	      this.$emit('setIsPrioritizerActive', this.isPrioritizerActive);
	    },
	    getItemTitle: function getItemTitle(item) {
	      return this.translations[item] ? this.translations[item] : 'No title';
	    },
	    removeActiveEvent: function removeActiveEvent() {
	      this.$store.commit('setActiveUser', null);
	      this.$store.commit('setActiveEvent', null);
	      this.$store.dispatch('setActiveSchedulerEvent', {
	        'left': -10,
	        'right': -10,
	        'color': '',
	        'oldSubScoreMeta': [],
	        'obj': null
	      });
	    },
	    onChange: function onChange() {
	      this.isChangeHasBeenMade = true;
	    },
	    onSave: function onSave() {
	      if (!this.isChangeHasBeenMade) {
	        return;
	      }
	      var updatedObj = this.updatedList.reduce(function (obj, item) {
	        return (0, _assign2.default)(obj, (0, _defineProperty3.default)({}, item.name, item.value));
	      }, {});
	      this.$store.dispatch('updateSortingHierarchy', updatedObj);
	      this.removeActiveEvent();
	      this.setIsPrioritizerActive(false);
	    }
	  }
	};

/***/ }),
/* 757 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    lesson: {
	      type: Object,
	      default: null
	    }
	  },
	  computed: {
	    styleObj: function styleObj() {
	      return this.lesson ? this.lesson : this.$store.state.subs.schedulerActiveEvent;
	    }
	  }
	};

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    name: 'Navn',
	    pools: 'Vikarpulje (høj til lav)',
	    poolsAsc: 'Vikarpulje (lav til høj)',
	    workHours: 'Arbejdstid',
	    proposals: 'Forslag',
	    sort_by: 'Sortering af vikarer',
	    group_at_top: 'Vælg en gruppe øverst',
	    group_placeholder: 'Vælg gruppe'
	  },
	  nb: {
	    name: 'Navn',
	    pools: 'Vikarpulje (høy til lav)',
	    poolsAsc: 'Vikarpulje (lav til høy)',
	    workHours: 'Arbeidstid',
	    proposals: 'Suggestions',
	    sort_by: 'Sorter vikarer',
	    group_at_top: 'Velg en gruppe øverst',
	    group_placeholder: 'Velg gruppe'
	  },
	  en: {
	    name: 'Name',
	    pools: 'Substitute pool (high to low)',
	    poolsAsc: 'Substitute pool (low to high)',
	    workHours: 'Work hours',
	    proposals: 'Forslag',
	    sort_by: 'Sort substitutes by',
	    group_at_top: 'Select a group at top',
	    group_placeholder: 'Select group'
	  }
	};
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default, DoFiltersFilter: _DoFiltersFilter2.default },
	  props: {
	    selected: {
	      default: 'name'
	    },
	    locale: {
	      default: 'da'
	    },
	    groupTags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedGroupTags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  computed: {
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    selectedI18n: function selectedI18n() {
	      var _this = this;
	
	      var selectedOptions = this.options.find(function (option) {
	        return option.value === _this.selected;
	      });
	      return selectedOptions.name || '';
	    },
	    options: function options() {
	      return [{ value: 'subzen', name: this.i18n['proposals'], selected: this.selected === 'subzen' }, { value: 'name', name: this.i18n['name'], selected: this.selected === 'name' }, { value: 'pools', name: this.i18n['pools'], selected: this.selected === 'pools' }, { value: 'poolsAsc', name: this.i18n['poolsAsc'], selected: this.selected === 'poolsAsc' }, { value: 'workHours', name: this.i18n['workHours'], selected: this.selected === 'workHours' }];
	    }
	  },
	  methods: {
	    select: function select(selected) {
	      this.$emit('onSortBy', selected);
	    },
	    toggleGroupTag: function toggleGroupTag(tag) {
	      this.$emit('toggleGroupTag', tag);
	    },
	    clearAllGroupTags: function clearAllGroupTags() {
	      this.$emit('clearAllGroupTags');
	    }
	  }
	};

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    item: {},
	    itemBCR: {}
	  },
	  computed: {
	    posTop: function posTop() {
	      return this.itemBCR.top - 15;
	    },
	    itemSubPool: function itemSubPool() {
	      return this.item.current_user_year && this.item.current_user_year.substitute_pool_hours || 0;
	    },
	    itemSubPoolDiff: function itemSubPoolDiff() {
	      return (this.itemSubPool - this.item.substituteHours).toFixed(1);
	    }
	  }
	};

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _SubsCreate = __webpack_require__(1643);
	
	var _SubsCreate2 = _interopRequireDefault(_SubsCreate);
	
	var _SubsUser = __webpack_require__(1651);
	
	var _SubsUser2 = _interopRequireDefault(_SubsUser);
	
	var _AppFlipperButtons = __webpack_require__(1692);
	
	var _AppFlipperButtons2 = _interopRequireDefault(_AppFlipperButtons);
	
	var _TaggingFilter = __webpack_require__(43);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	var _DoFilters = __webpack_require__(134);
	
	var _DoFilters2 = _interopRequireDefault(_DoFilters);
	
	var _Scheduler = __webpack_require__(1634);
	
	var _Scheduler2 = _interopRequireDefault(_Scheduler);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SubsEventSplit = __webpack_require__(1649);
	
	var _SubsEventSplit2 = _interopRequireDefault(_SubsEventSplit);
	
	var _SubsEventEditTimes = __webpack_require__(1648);
	
	var _SubsEventEditTimes2 = _interopRequireDefault(_SubsEventEditTimes);
	
	var _SubsNote = __webpack_require__(1650);
	
	var _SubsNote2 = _interopRequireDefault(_SubsNote);
	
	var _EventChanges = __webpack_require__(136);
	
	var _EventChanges2 = _interopRequireDefault(_EventChanges);
	
	var _AppModal = __webpack_require__(104);
	
	var _AppModal2 = _interopRequireDefault(_AppModal);
	
	var _vuex = __webpack_require__(14);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SchedulerPrioritizer = __webpack_require__(1637);
	
	var _SchedulerPrioritizer2 = _interopRequireDefault(_SchedulerPrioritizer);
	
	var _SubsAbsentWithoutEnd = __webpack_require__(1642);
	
	var _SubsAbsentWithoutEnd2 = _interopRequireDefault(_SubsAbsentWithoutEnd);
	
	var _SubsEditAbsence = __webpack_require__(1647);
	
	var _SubsEditAbsence2 = _interopRequireDefault(_SubsEditAbsence);
	
	var _SubsUserPanel = __webpack_require__(1652);
	
	var _SubsUserPanel2 = _interopRequireDefault(_SubsUserPanel);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _CreateTask = __webpack_require__(1481);
	
	var _CreateTask2 = _interopRequireDefault(_CreateTask);
	
	var _ClassOnTrip = __webpack_require__(1630);
	
	var _ClassOnTrip2 = _interopRequireDefault(_ClassOnTrip);
	
	var _DFilters = __webpack_require__(1694);
	
	var _DFilters2 = _interopRequireDefault(_DFilters);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _DModalOutOfSchoolLesson = __webpack_require__(358);
	
	var _DModalOutOfSchoolLesson2 = _interopRequireDefault(_DModalOutOfSchoolLesson);
	
	var _SchedulerSort = __webpack_require__(1639);
	
	var _SchedulerSort2 = _interopRequireDefault(_SchedulerSort);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _DModalCancelLesson = __webpack_require__(356);
	
	var _DModalCancelLesson2 = _interopRequireDefault(_DModalCancelLesson);
	
	var _SendMessages = __webpack_require__(370);
	
	var _SendMessages2 = _interopRequireDefault(_SendMessages);
	
	var _vueClickaway = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: {
	    Tabs: _Tabs2.default,
	    SchedulerSort: _SchedulerSort2.default,
	    DModalOutOfSchoolLesson: _DModalOutOfSchoolLesson2.default,
	    DModalCancelLesson: _DModalCancelLesson2.default,
	    DoFiltersFilter: _DoFiltersFilter2.default,
	    DFilters: _DFilters2.default,
	    ClassOnTrip: _ClassOnTrip2.default,
	    CreateTask: _CreateTask2.default,
	    SubsUserPanel: _SubsUserPanel2.default,
	    SchedulerPrioritizer: _SchedulerPrioritizer2.default,
	    scheduler: _Scheduler2.default,
	    SubsUser: _SubsUser2.default,
	    filterTags: _TaggingFilter2.default,
	    DatePicker: _DateSelector2.default,
	    SubstitutionCreate: _SubsCreate2.default,
	    appFlipperButton: _AppFlipperButtons2.default,
	    appToggleButton: _AppToggle2.default,
	    spinner: _Loader2.default,
	    splitLesson: _SubsEventSplit2.default,
	    SubsEventEditTimes: _SubsEventEditTimes2.default,
	    AppModal: _AppModal2.default,
	    SubsNote: _SubsNote2.default,
	    EventChanges: _EventChanges2.default,
	    SubsAbsentWithoutEnd: _SubsAbsentWithoutEnd2.default,
	    SubsEditAbsence: _SubsEditAbsence2.default,
	    DoFilters: _DoFilters2.default,
	    SendMessages: _SendMessages2.default
	  },
	  data: function data() {
	    return {
	      isHideEventsNotOverlappingAbsence: false,
	      selectedSort: 'name',
	      localSchedulerView: true,
	      selectedQuickFilters: [],
	      appliedFilters: [],
	      appliedFiltersAbsentUsers: [],
	      selectedClassFilters: [],
	      selectedEventTitleFilters: [],
	      selectedUser: null,
	      sortOnName: true,
	      isSortOnSubPools: false,
	      sortOnSubPoolsAsc: true,
	      sortOnDayPresence: false,
	      activeSplitLesson: null,
	      theEditTimesLesson: null,
	      activeDSelect: null,
	      isModal: false,
	      userAndLessonAndSubsToBeDeleted: {
	        user: {},
	        lesson: {},
	        subToBeRemoved: {},
	        subsForTheSubToBeRemoved: []
	      },
	      eventChangesEvent: null,
	      isFilterAbsentUsersWithHandledLessons: false,
	      absentFilter: '',
	      createEventOnUser: null,
	      isModalClassOnTrip: false,
	      theOutOfSchoolLesson: null,
	      isPrioritizerActive: false,
	      theCancelLesson: null,
	      priorityGroupTags: [],
	      filterSortOrder: [],
	      isFilterSortActive: false,
	      groupsRequiringPresence: [],
	      isSubstitutionSettingsOpen: false
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings || {};
	    },
	    includeReservationsInSubstitution: function includeReservationsInSubstitution() {
	      return !!this.schoolSettings.includeReservationsInSubstitution;
	    },
	    showOverlappingClassBadgeInSubstitution: function showOverlappingClassBadgeInSubstitution() {
	      return this.schoolSettings.showOverlappingClassBadgeInSubstitution !== false;
	    },
	    schoolFeatures: function schoolFeatures() {
	      return this.$store.getters.schoolFeatures;
	    },
	    schoolHasFeatureSMS: function schoolHasFeatureSMS() {
	      var _this = this;
	
	      var features = ['substitute_sms', 'substitute_email'];
	      var hasFeatures = features.some(function (feature) {
	        return _this.schoolFeatures.includes(feature);
	      });
	      var permissions = ['can_manage_school', 'can_send_substitute_email', 'can_send_substitute_sms'];
	      return hasFeatures && permissions.some(function (permission) {
	        return _this.userHasPermission(permission);
	      });
	    },
	    hasAbsentUsers: function hasAbsentUsers() {
	      return this.absentUsersFromUserSet.length > 0;
	    },
	    lessonViewTabs: function lessonViewTabs() {
	      return [{ id: 'all', title: this.i18n[this.locale]['show_all_lessons'] }, { id: 'hideNonOverlapping', title: this.i18n[this.locale]['hide_lessons_not_overlapping_absence'] }];
	    },
	    selectedLessonViewTabId: function selectedLessonViewTabId() {
	      return this.isHideEventsNotOverlappingAbsence ? 'hideNonOverlapping' : 'all';
	    },
	    absentTabs: function absentTabs() {
	      return [{ id: '', title: this.i18n[this.locale]['absent_today'] + ' (' + this.absentUsersFromUserSet.length + ')' }, { id: 'handled', title: this.i18n[this.locale]['absent_handled'] + ' (' + this.absentUsersHandled.length + ')' }, { id: 'unhandled', title: this.i18n[this.locale]['absent_unhandled'] + ' (' + this.absentUsersUnhandled.length + ')' }];
	    },
	    currentAbsentTabId: function currentAbsentTabId() {
	      if (this.isAbsentUserFilter('handled')) return 'handled';
	      if (this.isAbsentUserFilter('unhandled')) return 'unhandled';
	      return '';
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    isClassOnTripSchool: function isClassOnTripSchool() {
	      var country = this.$store.getters.schoolCountry;
	      return country && String(country).toUpperCase() === 'DK';
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    allEvents: function allEvents() {
	      return this.$store.state.subs.allEvents;
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    allUsersAndEvents: function allUsersAndEvents() {
	      return this.$store.state.subs.allUsersAndEvents;
	    },
	    allCalendarsInAHash: function allCalendarsInAHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    longAbsentListInHash: function longAbsentListInHash() {
	      return this.$store.getters.longAbsentListInHash;
	    },
	    calsAndEventIds: function calsAndEventIds() {
	      return this.$store.state.subs.allCalsWithEventIdsInHash;
	    },
	    absentUsersHandledHash: function absentUsersHandledHash() {
	      return this.$store.getters.absentUsersHandledHash;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    }
	  }, (0, _vuex.mapGetters)(['allUsersSortedOnName', 'userSet', 'absentUsersFromUserSet', 'notAbsentUsersFromUserSet', 'allUsersInCalIdHash', 'absentUsersUnhandled', 'absentUsersHandled', 'isSubStatusPendingActive', 'usersWithOngoingAbsenceInHash']), {
	    i18n: function i18n() {
	      return {
	        da: {
	          filters_saved_locally: 'Filtre gemt lokalt på din enhed',
	          remove_subs: 'Fjern følgende vikarer',
	          substitutes_for: 'Fjern følgende vikarer for ' + this.userAndLessonAndSubsToBeDeleted.subToBeRemoved.name + ' på ' + this.userAndLessonAndSubsToBeDeleted.lesson.title,
	          has_to_remove_subs: 'Du er ved at fjerne en vikar, som har fået vikardækket lektionen af en anden vikar. Før du kan fortsætte, skal vikarer for ' + this.userAndLessonAndSubsToBeDeleted.subToBeRemoved.name + ' fjernes.',
	          click_on_remove_all: 'Klik \'fjern alle\' for at gøre dette.',
	          button_text: 'Fjern alle',
	          absent_today: 'Fraværende i dag',
	          absent_handled: 'Håndterede',
	          absent_unhandled: 'Ikke-håndterede',
	          absent: 'Fraværende',
	          show_all_lessons: 'Vis alle lektioner',
	          hide_lessons_not_overlapping_absence: 'Skjul lektioner uden fravær',
	          in_the_class_this_day: 'I klassen denne dag'
	        },
	        en: {
	          filters_saved_locally: 'Filters saved locally on your device',
	          remove_subs: 'Remove substitute teachers',
	          substitutes_for: 'Remove substitutes for ' + this.userAndLessonAndSubsToBeDeleted.subToBeRemoved.name + ' in ' + this.userAndLessonAndSubsToBeDeleted.lesson.title,
	          has_to_remove_subs: 'You are about to delete a substitute teacher that has been substituted by another substitute teacher. To continue, the substitute teacher for ' + this.userAndLessonAndSubsToBeDeleted.subToBeRemoved.name + ' has to be removed',
	          click_on_remove_all: 'Press \'remove all\' to continue.',
	          button_text: 'Remove all',
	          absent_today: 'Absent today',
	          absent_handled: 'Handled',
	          absent_unhandled: 'Unhandled',
	          absent: 'Absent',
	          show_all_lessons: 'Show all lessons',
	          hide_lessons_not_overlapping_absence: 'Hide lessons without absence overlap',
	          in_the_class_this_day: 'In the class this day'
	        },
	        nb: {
	          filters_saved_locally: 'Filtre lagret lokalt på enheten din',
	          remove_subs: 'Fjern vikar',
	          substitutes_for: 'Fjern vikarer for ' + this.userAndLessonAndSubsToBeDeleted.subToBeRemoved.name + ' i ' + this.userAndLessonAndSubsToBeDeleted.lesson.title,
	          has_to_remove_subs: 'Du kommer nå til å fjerne en vikar som har blitt erstattet av en annen vikar. For å fortsette skal vikarer for  ' + this.userAndLessonAndSubsToBeDeleted.subToBeRemoved.name + ' fjernes',
	          click_on_remove_all: 'Klikk på \'fjern alle\' for å gjennomføre dette.',
	          button_text: 'Fjern alle',
	          absent_today: 'Fraværende i dag',
	          absent_handled: 'Håndtert',
	          absent_unhandled: 'Ikke håndtert',
	          absent: 'Fraværende',
	          show_all_lessons: 'Vis alle leksjoner',
	          hide_lessons_not_overlapping_absence: 'Skjul leksjoner uten fravær',
	          in_the_class_this_day: 'I klassen denne dag'
	        }
	      };
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    userCanSeeInternalNote: function userCanSeeInternalNote() {
	      var lang = this.locale;
	      if (!lang || lang.toLowerCase() === 'en') {
	        return false;
	      }
	      return this.userHasPermission('can_manage_school');
	    },
	    dataIsLoading: function dataIsLoading() {
	      return this.$store.state.subs.dataIsLoading;
	    },
	    sortSubs: function sortSubs() {
	      return this.$store.state.subs.sortSubs;
	    },
	    activeTab: function activeTab() {
	      return this.localSchedulerView ? 1 : 0;
	    },
	    allUsers: function allUsers() {
	      return this.$store.state.subs.allUsers;
	    },
	    getDate: function getDate() {
	      return this.$store.state.subs.date;
	    },
	    isSubScoreActive: function isSubScoreActive() {
	      return this.$store.state.subs.isSortSubActive;
	    },
	    text: function text() {
	      return this.$t('vue2.sub_scheduler.absent_people') + ': ' + this.filteredAbsentUsers.length + ' ' + this.$t('vue2.sub_scheduler.out_of') + ' ' + this.absentUsersFromUserSet.length;
	    },
	    subsHeadline: function subsHeadline() {
	      return this.$t('vue2.sub_scheduler.potential_substitutes') + ': ' + this.filteredNotAbsentUsers.filter(function (user) {
	        return !user.headline;
	      }).length;
	    },
	    isToday: function isToday() {
	      return _moment2.default.utc().format('YYYY-MM-DD') === (0, _moment2.default)(this.getDate).format('YYYY-MM-DD');
	    },
	    absentUsers: function absentUsers() {
	      if (this.absentFilter === 'unhandled') {
	        return this.absentUsersUnhandled;
	      } else if (this.absentFilter === 'handled') {
	        return this.absentUsersHandled;
	      } else {
	        return this.absentUsersFromUserSet;
	      }
	    },
	    classTags: function classTags() {
	      var names = [];
	      var seen = {};
	      var eventsHash = this.allEventsInAHash || {};
	      var ids = (0, _keys2.default)(eventsHash);
	      for (var i = 0; i < ids.length; i++) {
	        var ev = eventsHash[ids[i]];
	        if (!ev || !ev.calendar_events || !Array.isArray(ev.calendar_events)) continue;
	        for (var j = 0; j < ev.calendar_events.length; j++) {
	          var ce = ev.calendar_events[j];
	          if (ce && ce.calendar_type === 'klass' && ce.name && !seen[ce.name]) {
	            seen[ce.name] = true;
	            names.push(ce.name);
	          }
	        }
	      }
	      names.sort(function (a, b) {
	        if (a < b) return -1;
	        if (a > b) return 1;
	        return 0;
	      });
	      return names;
	    },
	    eventTitleTags: function eventTitleTags() {
	      var _this2 = this;
	
	      var titles = [];
	      var seen = {};
	      var skipTypes = { absence: true, available: true, presence: true, reservation: true };
	      var eventsHash = this.allEventsInAHash || {};
	      var ids = (0, _keys2.default)(eventsHash);
	      for (var i = 0; i < ids.length; i++) {
	        var ev = eventsHash[ids[i]];
	        if (!ev || !ev.title || skipTypes[ev.event_type] || seen[ev.title]) continue;
	        seen[ev.title] = true;
	        titles.push(ev.title);
	      }
	      titles.sort(function (a, b) {
	        return a.localeCompare(b, _this2.locale);
	      });
	      return titles;
	    },
	    filteredAbsentUsers: function filteredAbsentUsers() {
	      var _this3 = this;
	
	      var passedUsers = this.absentUsers;
	      var hasTagFilters = this.appliedFiltersAbsentUsers.length > 0;
	      var hasClassFilters = this.selectedClassFilters.length > 0;
	
	      if (!hasTagFilters && !hasClassFilters) {
	        return passedUsers;
	      }
	
	      var selectedClasses = this.selectedClassFilters;
	      var eventsHash = this.allEventsInAHash || {};
	
	      return passedUsers.filter(function (user) {
	        if (user.headline) return true;
	
	        var tagMatch = false;
	        var classMatch = false;
	
	        if (hasTagFilters && user.user_tags && user.user_tags.length > 0) {
	          tagMatch = user.user_tags.some(function (tag) {
	            return _this3.appliedFiltersAbsentUsers.includes(tag);
	          });
	        }
	
	        if (hasClassFilters) {
	          var dayAllEvents = user.dayAllEvents || [];
	          if (dayAllEvents.length > 0) {
	            for (var i = 0; i < dayAllEvents.length; i++) {
	              var ev = eventsHash[dayAllEvents[i]];
	              if (!ev || !ev.calendar_events || !Array.isArray(ev.calendar_events)) continue;
	              for (var j = 0; j < ev.calendar_events.length; j++) {
	                var ce = ev.calendar_events[j];
	                if (ce && ce.calendar_type === 'klass' && ce.name && selectedClasses.indexOf(ce.name) > -1) {
	                  classMatch = true;
	                  break;
	                }
	              }
	              if (classMatch) break;
	            }
	          }
	        }
	
	        return hasTagFilters && tagMatch || hasClassFilters && classMatch;
	      });
	    },
	    filteredNotAbsentUsers: function filteredNotAbsentUsers() {
	      var _this4 = this;
	
	      var passedUsers = this.notAbsentUsersFromUserSet;
	
	      var hasTagFilters = this.appliedFilters.length > 0;
	      var hasQuickFilters = this.selectedQuickFilters.length > 0;
	      var hasClassFilters = this.selectedClassFilters.length > 0;
	      var hasTitleFilters = this.selectedEventTitleFilters.length > 0;
	      if (!hasTagFilters && !hasQuickFilters && !hasClassFilters && !hasTitleFilters) {
	        return passedUsers;
	      }
	
	      var selectedClasses = this.selectedClassFilters;
	      var eventsHash = this.allEventsInAHash || {};
	
	      var isAvailableActive = this.selectedQuickFilters.includes('sub_events_available');
	      var isCanceledActive = this.selectedQuickFilters.includes('sub_events_canceled');
	      var isTwoInClassActive = this.selectedQuickFilters.includes('sub_events_two_in_some_class');
	
	      return passedUsers.filter(function (user) {
	        if (user.headline) return true;
	
	        var quickOrTagMatch = false;
	        var classMatch = false;
	
	        if (hasQuickFilters || hasTagFilters) {
	          if (isAvailableActive && user.dayAvailability && user.dayAvailability.length > 0) {
	            quickOrTagMatch = true;
	          }
	          if (!quickOrTagMatch && isCanceledActive && user.canceledEvents && user.canceledEvents.length > 0) {
	            quickOrTagMatch = true;
	          }
	          if (!quickOrTagMatch && isTwoInClassActive && (user.v_two_in_class_events && user.v_two_in_class_events.length > 0 || user.v_two_events_in_class_events && user.v_two_events_in_class_events.length > 0)) {
	            quickOrTagMatch = true;
	          }
	          if (!quickOrTagMatch && hasTagFilters) {
	            quickOrTagMatch = _this4.appliedFilters.some(function (tag) {
	              return _this4.userMatchesGroup(user, tag);
	            });
	          }
	        }
	
	        if (hasClassFilters) {
	          var dayAllEvents = user.dayAllEvents || [];
	          if (dayAllEvents.length > 0) {
	            for (var i = 0; i < dayAllEvents.length; i++) {
	              var ev = eventsHash[dayAllEvents[i]];
	              if (!ev || !ev.calendar_events || !Array.isArray(ev.calendar_events)) continue;
	              for (var j = 0; j < ev.calendar_events.length; j++) {
	                var ce = ev.calendar_events[j];
	                if (ce && ce.calendar_type === 'klass' && ce.name && selectedClasses.indexOf(ce.name) > -1) {
	                  classMatch = true;
	                  break;
	                }
	              }
	              if (classMatch) break;
	            }
	          }
	        }
	
	        var matchesOtherFilters = (hasQuickFilters || hasTagFilters ? quickOrTagMatch : false) || (hasClassFilters ? classMatch : false);
	        var matchesTitle = hasTitleFilters && _this4.userMatchesEventTitleFilters(user, eventsHash);
	
	        if (!hasQuickFilters && !hasTagFilters && !hasClassFilters) return matchesTitle;
	        if (!hasTitleFilters) return matchesOtherFilters;
	        return matchesOtherFilters || matchesTitle;
	      });
	    },
	    filterSortItems: function filterSortItems() {
	      var _this5 = this;
	
	      var activeItems = [].concat((0, _toConsumableArray3.default)(this.selectedQuickFilters.map(function (value) {
	        return { key: 'quick:' + value, type: 'quick', value: value };
	      })), (0, _toConsumableArray3.default)(this.appliedFilters.map(function (value) {
	        return { key: 'group:' + value, type: 'group', value: value };
	      })), (0, _toConsumableArray3.default)(this.selectedEventTitleFilters.map(function (value) {
	        return { key: 'block:' + value, type: 'block', value: value };
	      })));
	      var getOrderIdx = function getOrderIdx(item) {
	        var idx = _this5.filterSortOrder.indexOf(item.key);
	        return idx > -1 ? idx : _this5.filterSortOrder.length;
	      };
	      return activeItems.map(function (item, idx) {
	        return { item: item, idx: idx };
	      }).sort(function (a, b) {
	        return getOrderIdx(a.item) - getOrderIdx(b.item) || a.idx - b.idx;
	      }).map(function (_ref) {
	        var item = _ref.item;
	        return item;
	      });
	    },
	    absentAndSubs: function absentAndSubs() {
	      var _this6 = this;
	
	      if (!this.localSchedulerView) return [];
	
	      var headline = {
	        name: this.$t('vue2.sub_scheduler.potential_subs'),
	        id: 12312312312312313123123123,
	        dayAbsence: [],
	        dayPresence: [],
	        dayEvents: [],
	        headline: true
	      };
	
	      var subs = [].concat((0, _toConsumableArray3.default)(this.filteredNotAbsentUsers));
	
	      var sortFunctions = {
	        subScore: function subScore(a, b) {
	          return b.subScore - a.subScore;
	        },
	        subPools: function subPools(a, b) {
	          return _this6.sortOnSubPoolsAsc ? a.subPoolsDiff - b.subPoolsDiff : b.subPoolsDiff - a.subPoolsDiff;
	        },
	        dayPresence: function dayPresence(a, b) {
	          return b.dayPresence.length - a.dayPresence.length;
	        },
	        name: function name() {
	          return _this6.$helpers.sortArrOnName(subs);
	        }
	      };
	
	      var hasPriorityGroups = this.priorityGroupTags && this.priorityGroupTags.length > 0;
	      var hasFilterSort = this.isFilterSortActive && this.filterSortItems.length > 0;
	      var shouldSort = this.isSubScoreActive && this.sortSubs !== 0 || !this.isSubScoreActive && this.isSortOnSubPools && this.sortSubs !== 0 || this.sortOnDayPresence || this.sortOnName || hasPriorityGroups || hasFilterSort;
	
	      if (shouldSort) {
	        subs = subs.filter(function (user) {
	          return !user.headline;
	        });
	
	        if (this.isSubScoreActive && this.sortSubs !== 0) {
	          subs.sort(sortFunctions.subScore);
	        } else if (this.isSortOnSubPools && this.sortSubs !== 0) {
	          subs.sort(sortFunctions.subPools);
	        } else if (this.sortOnDayPresence) {
	          subs.sort(sortFunctions.dayPresence);
	        } else if (this.sortOnName) {
	          sortFunctions.name();
	        }
	
	        if (hasPriorityGroups) {
	          var priorityUsers = [];
	          var otherUsers = [];
	          for (var i = 0; i < subs.length; i++) {
	            var user = subs[i];
	            var userTags = user.user_tags || [];
	            var hasPriorityTag = userTags.some(function (tag) {
	              return _this6.priorityGroupTags.includes(tag);
	            });
	            if (hasPriorityTag) {
	              priorityUsers.push(user);
	            } else {
	              otherUsers.push(user);
	            }
	          }
	          subs = [].concat(priorityUsers, otherUsers);
	        }
	
	        if (hasFilterSort) {
	          var eventsHash = this.allEventsInAHash || {};
	          var items = this.filterSortItems;
	          var getRank = function getRank(user) {
	            var idx = items.findIndex(function (item) {
	              return _this6.userMatchesFilterSortItem(user, item, eventsHash);
	            });
	            return idx > -1 ? idx : items.length;
	          };
	          subs = subs.map(function (user, idx) {
	            return { user: user, idx: idx, rank: getRank(user) };
	          }).sort(function (a, b) {
	            return a.rank - b.rank || a.idx - b.idx;
	          }).map(function (_ref2) {
	            var user = _ref2.user;
	            return user;
	          });
	        }
	
	        subs.unshift(headline);
	      } else if (subs.length === 0 || !subs[0].headline) {
	        subs.unshift(headline);
	      }
	
	      return [].concat((0, _toConsumableArray3.default)(this.filteredAbsentUsers), (0, _toConsumableArray3.default)(subs));
	    },
	    activeAbsenceReason: function activeAbsenceReason() {
	      return this.$store.state.subs.activeAbsenceReason;
	    },
	    activeAbsentUser: function activeAbsentUser() {
	      return this.$store.state.subs.activeAbsentUser;
	    }
	  }),
	  watch: {
	    userSettings: function userSettings(val) {
	      this.applyUserSettings(val);
	    },
	    isSubScoreActive: function isSubScoreActive(val) {
	      this.sortOnName = !val;
	    },
	    includeReservationsInSubstitution: function includeReservationsInSubstitution() {
	      this.applyReservationSettingToLoadedEvents();
	    }
	  },
	  methods: {
	    onLessonViewTabSelect: function onLessonViewTabSelect(tabId) {
	      this.isHideEventsNotOverlappingAbsence = tabId === 'hideNonOverlapping';
	      this.persistHideLessonsWithoutAbsence();
	      if (tabId === 'hideNonOverlapping') {
	        this.$store.dispatch('trackEvent', 'substitution_eventFilter_' + tabId);
	      }
	    },
	    persistHideLessonsWithoutAbsence: function persistHideLessonsWithoutAbsence() {
	      var key = 'd_hide_lessons_without_absence_' + this.schoolId;
	      if (this.isHideEventsNotOverlappingAbsence) {
	        this.$helpers.setLocalStorage(key, '1');
	      } else {
	        this.$helpers.removeLocalStorage(key);
	      }
	    },
	    onAbsentTabSelect: function onAbsentTabSelect(tabId) {
	      this.setAbsentFilter(tabId);
	    },
	    setTheOutOfSchoolLesson: function setTheOutOfSchoolLesson() {
	      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      this.theOutOfSchoolLesson = obj;
	    },
	    setIsCancelLesson: function setIsCancelLesson() {
	      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      this.theCancelLesson = obj;
	    },
	    onCancelLessonUpdated: function onCancelLessonUpdated() {
	      this.setIsCancelLesson(null);
	      this.readEvents();
	      this.$nextTick(function (_) {
	        var el = document.getElementById('djs-body-click');
	        if (el) {
	          el.click();
	        }
	      });
	    },
	    onOutOfSchoolLessonUpdated: function onOutOfSchoolLessonUpdated() {
	      this.setTheOutOfSchoolLesson(null);
	      this.readEvents();
	      this.$nextTick(function (_) {
	        var el = document.getElementById('djs-body-click');
	        if (el) {
	          el.click();
	        }
	      });
	    },
	    setIsModalClassOnTrip: function setIsModalClassOnTrip(bool) {
	      this.isModalClassOnTrip = bool;
	    },
	    setCreateEventOnUser: function setCreateEventOnUser(userAndDateObj) {
	      this.createEventOnUser = userAndDateObj;
	    },
	    userHasPermission: function userHasPermission(val) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(val) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    setActiveAbsentUser: function setActiveAbsentUser(user) {
	      this.$store.commit('setActiveAbsentUser', user);
	    },
	    setAbsentFilter: function setAbsentFilter(filter) {
	      this.absentFilter = filter;
	    },
	    isAbsentUserFilter: function isAbsentUserFilter(filter) {
	      return this.absentFilter === filter;
	    },
	    showEventLog: function showEventLog(event) {
	      this.eventChangesEvent = event;
	    },
	    setActiveDSelect: function setActiveDSelect(userAndLessonId) {
	      this.activeDSelect = userAndLessonId;
	    },
	    setRemoveSubsFromEvent: function setRemoveSubsFromEvent(userAndLessonAndSubsForUser) {
	      this.userAndLessonAndSubsToBeDeleted = userAndLessonAndSubsForUser;
	      this.isModal = true;
	    },
	    removeSubs: function removeSubs() {
	      var _this7 = this;
	
	      var lesson = this.userAndLessonAndSubsToBeDeleted.lesson;
	      this.userAndLessonAndSubsToBeDeleted.subsForTheSubToBeRemoved.forEach(function (sub) {
	        _this7.removeSub(_this7.allUsersInCalIdHash[sub], _this7.userAndLessonAndSubsToBeDeleted.subToBeRemoved, lesson);
	      });
	
	      this.removeSub(this.userAndLessonAndSubsToBeDeleted.subToBeRemoved, this.userAndLessonAndSubsToBeDeleted.user, lesson);
	      this.setSubStatusOnLesson(this.userAndLessonAndSubsToBeDeleted.user, this.userAndLessonAndSubsToBeDeleted.subToBeRemoved, lesson);
	      this.isModal = false;
	    },
	    removeSub: function removeSub(sub, subFor, lesson) {
	      var _this8 = this;
	
	      _docendo2.default.eventRemoveSubstitute(lesson.id, sub.id, subFor.id, function (data) {
	        _this8.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data));
	        _this8.$store.commit('removeEventOnAllUsersWithEvents', {
	          cal_id: sub.user_calendar_id,
	          event_id: lesson.id
	        });
	      });
	    },
	    setSubStatusOnLesson: function setSubStatusOnLesson(user, sub, lesson) {
	      var _this9 = this;
	
	      var statusData = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	      statusData[user.user_calendar_id] = { 'status': 0 };
	      statusData[sub.user_calendar_id] = { 'status': 0 };
	      _docendo2.default.updateEvent(lesson.school_id, lesson.id, { substitution_status: (0, _stringify2.default)(statusData) }, function (success) {
	        _this9.$store.commit('updateSubStatusOnEvent', {
	          'eventId': lesson.id,
	          'status': (0, _stringify2.default)(statusData)
	        });
	      });
	    },
	    onSortBy: function onSortBy(selected) {
	      var saveInLocalStorage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      this.resetSort();
	      this.selectedSort = selected;
	      if (selected === 'subzen') {
	        this.$store.commit('setIsSubScoreActive', true);
	      }
	      if (selected === 'pools') {
	        this.isSortOnSubPools = true;
	      }
	      if (selected === 'poolsAsc') {
	        this.isSortOnSubPools = true;
	        this.sortOnSubPoolsAsc = true;
	      }
	      if (selected === 'name') {
	        this.sortOnName = true;
	      }
	      if (selected === 'workHours') {
	        this.sortOnDayPresence = true;
	      }
	      this.$store.commit('setSortSubsAgain');
	      var saveSortSetting = { 'selectedSubSchedulerSorting': selected };
	      if (saveInLocalStorage) {
	        this.$store.dispatch('updateUserSettings', saveSortSetting);
	      }
	    },
	    resetSort: function resetSort() {
	      this.sortOnName = false;
	      this.isSortOnSubPools = false;
	      this.sortOnSubPoolsAsc = false;
	      this.sortOnDayPresence = false;
	      this.$store.commit('setIsSubScoreActive', false);
	    },
	    setIsSubScoreActive: function setIsSubScoreActive(boolean) {
	      this.$store.dispatch('updateIsSubZenActive', boolean);
	    },
	    setSchedulerView: function setSchedulerView(num) {
	      if (num === 1) {
	        this.localSchedulerView = true;
	        this.$helpers.removeLocalStorage('subListView');
	      } else {
	        this.localSchedulerView = false;
	        this.$helpers.setLocalStorage('subListView', true);
	      }
	      this.setActiveDSelect(null);
	    },
	    prevDay: function prevDay() {
	      this.$store.commit('setSubDate', (0, _moment2.default)(this.getDate).subtract(1, 'days'));
	      this.readEvents();
	      this.$store.dispatch('subsGetLongAbsenceList');
	      this.setActiveDSelect(null);
	    },
	    nextDay: function nextDay() {
	      this.$store.commit('setSubDate', (0, _moment2.default)(this.getDate).add(1, 'days'));
	      this.readEvents();
	      this.$store.dispatch('subsGetLongAbsenceList');
	      this.setActiveDSelect(null);
	    },
	    setToday: function setToday() {
	      this.$store.commit('setSubDate', _moment2.default.utc().format('YYYY-MM-DD'));
	      this.readEvents();
	      this.$store.dispatch('subsGetLongAbsenceList');
	      this.setActiveDSelect(null);
	    },
	    setDate: function setDate(date) {
	      this.$store.commit('setSubDate', date);
	      this.readEvents();
	      this.$store.dispatch('subsGetLongAbsenceList');
	      this.setActiveDSelect(null);
	    },
	    print: function print() {
	      window.print();
	    },
	    updateLocalStorage: function updateLocalStorage(keyStr, items) {
	      var key = keyStr + '_' + this.schoolId;
	      if (items.length > 0) {
	        this.$helpers.setLocalStorage(key, (0, _stringify2.default)(items));
	      } else {
	        this.$helpers.removeLocalStorage(key);
	      }
	    },
	    toggleQuickFilter: function toggleQuickFilter(quickFilter) {
	      var val = quickFilter.value;
	      var idx = this.selectedQuickFilters.indexOf(val);
	      if (idx > -1) {
	        this.selectedQuickFilters.splice(idx, 1);
	      } else {
	        this.selectedQuickFilters.push(val);
	      }
	      this.updateLocalStorage('d_applied_event_filters_subs', this.selectedQuickFilters);
	    },
	    setTagFromFilter: function setTagFromFilter(tag) {
	      this.appliedFilters.push(tag);
	      this.updateLocalStorage('d_applied_filters_subs', this.appliedFilters);
	      _eventbus2.default.toast = { text: this.i18n[this.locale]['filters_saved_locally'], 'success': true, position: 'bottomLeft' };
	    },
	    removeTagFromFilter: function removeTagFromFilter(tag) {
	      this.appliedFilters.splice(this.appliedFilters.indexOf(tag), 1);
	      this.updateLocalStorage('d_applied_filters_subs', this.appliedFilters);
	    },
	    toggleTag: function toggleTag(tag) {
	      var idx = this.appliedFilters.indexOf(tag);
	      if (idx > -1) {
	        this.removeTagFromFilter(tag);
	      } else {
	        this.setTagFromFilter(tag);
	      }
	    },
	    clearAllTags: function clearAllTags() {
	      this.appliedFilters = [];
	      this.updateLocalStorage('d_applied_filters_subs', this.appliedFilters);
	      this.selectedQuickFilters = [];
	      this.updateLocalStorage('d_applied_event_filters_subs', this.selectedQuickFilters);
	    },
	    clearAllFiltersForSubs: function clearAllFiltersForSubs() {
	      this.clearAllTags();
	      this.clearAllEventTitleFilters();
	    },
	    userMatchesEventTitleFilters: function userMatchesEventTitleFilters(user, eventsHash) {
	      var selectedTitles = this.selectedEventTitleFilters;
	      if (!selectedTitles.length) return true;
	      var skipTypes = { absence: true, available: true, presence: true, reservation: true };
	      var dayAllEvents = user.dayAllEvents || [];
	      for (var i = 0; i < dayAllEvents.length; i++) {
	        var ev = eventsHash[dayAllEvents[i]];
	        if (ev && ev.title && !skipTypes[ev.event_type] && selectedTitles.indexOf(ev.title) > -1) {
	          return true;
	        }
	      }
	      return false;
	    },
	    userMatchesFilterSortItem: function userMatchesFilterSortItem(user, item, eventsHash) {
	      if (item.type === 'group') {
	        return this.userMatchesGroup(user, item.value);
	      }
	      if (item.type === 'block') {
	        var skipTypes = { absence: true, available: true, presence: true, reservation: true };
	        return (user.dayAllEvents || []).some(function (eventId) {
	          var ev = eventsHash[eventId];
	          return ev && ev.title === item.value && !skipTypes[ev.event_type];
	        });
	      }
	      switch (item.value) {
	        case 'sub_events_canceled':
	          return !!user.canceledEvents && user.canceledEvents.length > 0;
	        case 'sub_events_available':
	          return !!user.dayAvailability && user.dayAvailability.length > 0;
	        case 'sub_events_two_in_some_class':
	          return !!user.v_two_in_class_events && user.v_two_in_class_events.length > 0 || !!user.v_two_events_in_class_events && user.v_two_events_in_class_events.length > 0;
	        default:
	          return false;
	      }
	    },
	    userMatchesGroup: function userMatchesGroup(user, tag) {
	      if (!user.user_tags || !user.user_tags.includes(tag)) return false;
	      if (!this.groupsRequiringPresence.includes(tag)) return true;
	      return !!user.dayPresence && user.dayPresence.length > 0;
	    },
	    togglePresenceGroup: function togglePresenceGroup(tag) {
	      var idx = this.groupsRequiringPresence.indexOf(tag);
	      if (idx > -1) {
	        this.groupsRequiringPresence.splice(idx, 1);
	      } else {
	        this.groupsRequiringPresence.push(tag);
	      }
	      this.updateLocalStorage('d_groups_requiring_presence_subs', this.groupsRequiringPresence);
	      this.$store.dispatch('trackEvent', idx > -1 ? 'substitution_group_presence_toggled_off' : 'substitution_group_presence_toggled_on');
	    },
	    setFilterSortOrder: function setFilterSortOrder(keys) {
	      this.filterSortOrder = keys;
	      this.updateLocalStorage('d_filter_sort_order_subs', this.filterSortOrder);
	      this.$store.dispatch('trackEvent', 'substitution_filter_sort_changed');
	    },
	    setIsFilterSortActive: function setIsFilterSortActive(isActive) {
	      this.isFilterSortActive = isActive;
	      this.$helpers.setLocalStorage('d_filter_sort_active_subs_' + this.schoolId, isActive ? '1' : '0');
	      this.$store.dispatch('trackEvent', isActive ? 'substitution_filter_sort_toggled_on' : 'substitution_filter_sort_toggled_off');
	    },
	    toggleEventTitleFilter: function toggleEventTitleFilter(title) {
	      var idx = this.selectedEventTitleFilters.indexOf(title);
	      if (idx > -1) {
	        this.selectedEventTitleFilters.splice(idx, 1);
	      } else {
	        this.selectedEventTitleFilters.push(title);
	        _eventbus2.default.toast = { text: this.i18n[this.locale]['filters_saved_locally'], 'success': true, position: 'bottomLeft' };
	      }
	      this.updateLocalStorage('d_applied_event_title_filters_subs', this.selectedEventTitleFilters);
	      this.$store.dispatch('trackEvent', 'substitution_event_title_filter_toggled');
	    },
	    clearAllEventTitleFilters: function clearAllEventTitleFilters() {
	      this.selectedEventTitleFilters = [];
	      this.updateLocalStorage('d_applied_event_title_filters_subs', this.selectedEventTitleFilters);
	    },
	    setTagFromFilterOnAbsentUsers: function setTagFromFilterOnAbsentUsers(tag) {
	      this.appliedFiltersAbsentUsers.push(tag);
	      this.updateLocalStorage('d_applied_filters_absent', this.appliedFiltersAbsentUsers);
	      _eventbus2.default.toast = { text: this.i18n[this.locale]['filters_saved_locally'], 'success': true, position: 'bottomLeft' };
	    },
	    removeTagFromFilterOnAbsentUsers: function removeTagFromFilterOnAbsentUsers(tag) {
	      this.appliedFiltersAbsentUsers.splice(this.appliedFiltersAbsentUsers.indexOf(tag), 1);
	      this.updateLocalStorage('d_applied_filters_absent', this.appliedFiltersAbsentUsers);
	    },
	    toggleAbsentFilter: function toggleAbsentFilter(tag) {
	      var idx = this.appliedFiltersAbsentUsers.indexOf(tag);
	      if (idx > -1) {
	        this.removeTagFromFilterOnAbsentUsers(tag);
	      } else {
	        this.setTagFromFilterOnAbsentUsers(tag);
	      }
	    },
	    clearAllAbsentFilters: function clearAllAbsentFilters() {
	      this.appliedFiltersAbsentUsers = [];
	      this.updateLocalStorage('d_applied_filters_absent', this.appliedFiltersAbsentUsers);
	    },
	    toggleClassFilter: function toggleClassFilter(tag) {
	      var idx = this.selectedClassFilters.indexOf(tag);
	      if (idx > -1) {
	        this.selectedClassFilters.splice(idx, 1);
	      } else {
	        this.selectedClassFilters.push(tag);
	      }
	      this.$store.dispatch('trackEvent', 'substitution_class_filter_toggled');
	    },
	    clearAllClassFilters: function clearAllClassFilters() {
	      this.selectedClassFilters = [];
	    },
	    togglePriorityGroupTag: function togglePriorityGroupTag(tag) {
	      var idx = this.priorityGroupTags.indexOf(tag);
	      if (idx > -1) {
	        this.priorityGroupTags.splice(idx, 1);
	      } else {
	        this.priorityGroupTags.push(tag);
	      }
	      this.updateLocalStorage('d_priority_group_tags', this.priorityGroupTags);
	      this.$store.commit('setSortSubsAgain');
	    },
	    clearAllPriorityGroupTags: function clearAllPriorityGroupTags() {
	      this.priorityGroupTags = [];
	      this.updateLocalStorage('d_priority_group_tags', this.priorityGroupTags);
	      this.$store.commit('setSortSubsAgain');
	    },
	    getTags: function getTags() {
	      var _this10 = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this10.tags = data;
	      });
	    },
	    setSplitLesson: function setSplitLesson(lesson) {
	      this.activeSplitLesson = lesson;
	    },
	    closeSplitLesson: function closeSplitLesson() {
	      this.activeSplitLesson = null;
	    },
	    onSubmittedSplitEvent: function onSubmittedSplitEvent() {
	      this.activeSplitLesson = null;
	      this.closeSchedulerPopover();
	    },
	    setEditTimesLesson: function setEditTimesLesson() {
	      var lesson = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      this.theEditTimesLesson = lesson;
	    },
	    onEditTimesUpdated: function onEditTimesUpdated() {
	      this.setEditTimesLesson(null);
	      this.readEvents();
	      this.$nextTick(function (_) {
	        var el = document.getElementById('djs-body-click');
	        if (el) {
	          el.click();
	        }
	      });
	    },
	    closeSchedulerPopover: function closeSchedulerPopover() {
	      this.$store.commit('setActiveUser', null);
	      this.$store.commit('setActiveEvent', null);
	      this.$store.dispatch('setActiveSchedulerEvent', {
	        'left': -10,
	        'right': -10,
	        'color': '',
	        'oldSubScoreMeta': this.subScoreMeta,
	        'obj': null
	      });
	    },
	    closeSubstitutionSettings: function closeSubstitutionSettings() {
	      this.isSubstitutionSettingsOpen = false;
	    },
	    toggleIncludeReservations: function toggleIncludeReservations() {
	      var nextValue = !this.includeReservationsInSubstitution;
	      var nextSettings = (0, _extends3.default)({}, this.schoolSettings, {
	        includeReservationsInSubstitution: nextValue
	      });
	      this.$store.commit('setSchoolSettings', nextSettings);
	      this.$store.dispatch('updateSchoolSettings', {
	        includeReservationsInSubstitution: nextValue
	      });
	    },
	    toggleShowOverlappingClassBadge: function toggleShowOverlappingClassBadge() {
	      var nextValue = !this.showOverlappingClassBadgeInSubstitution;
	      var nextSettings = (0, _extends3.default)({}, this.schoolSettings, {
	        showOverlappingClassBadgeInSubstitution: nextValue
	      });
	      this.$store.commit('setSchoolSettings', nextSettings);
	      this.$store.dispatch('updateSchoolSettings', {
	        showOverlappingClassBadgeInSubstitution: nextValue
	      });
	    },
	    applyReservationSettingToLoadedEvents: function applyReservationSettingToLoadedEvents() {
	      var rawEvents = this.$store.state.subs.allDayEventsRaw;
	      if (!rawEvents || !this.$store.state.subs.allUsersAndEvents) {
	        return;
	      }
	      this.$store.commit('setAllEventsOnUsers', rawEvents);
	    },
	    readEvents: function readEvents() {
	      var _this11 = this;
	
	      var checkIfUserIsMemberOfAllSchools = function checkIfUserIsMemberOfAllSchools(schoolIdsToCall) {
	        var userSchools = _this11.user && _this11.user.schools ? _this11.user.schools : null;
	        if (!userSchools) {
	          return true;
	        }
	        var userSchoolIds = userSchools.map(function (school) {
	          return school.id;
	        });
	
	        return schoolIdsToCall.every(function (id) {
	          return userSchoolIds.includes(id);
	        });
	      };
	      var activeSchoolId = this.schoolId * 1;
	
	      var isSchoolSorenKanneFaelles = activeSchoolId === 60494;
	      if (isSchoolSorenKanneFaelles) {
	        var schoolIdsFromSorenKanne = [60489, 60490, 60491, 60492, 60494];
	        var storeObj = {
	          schoolIds: schoolIdsFromSorenKanne,
	          isShowEventsFromOtherThanActiveSchool: true
	        };
	        this.$store.dispatch('readAllEvents', storeObj);
	        return;
	      }
	      var schoolIdsFromLillevang = [59488, 59489];
	      var schoolIdsFromHerlevBySkole = [57481, 17269];
	      var schoolIdsFromHornslet = [64478, 62460];
	      var schoolIdsFromKildegaard = [23481, 57727];
	      var schoolsIdsFromBorneby = [60458, 60459, 60460, 60495];
	      var schoolIdsFromSolsort = [7272, 62084];
	      var schoolIdsFrom64272 = [64272, 64273, 64274, 64275];
	      var isIdxInHerlevArr = schoolIdsFromHerlevBySkole.indexOf(activeSchoolId);
	      var isIdxInHornsletArr = schoolIdsFromHornslet.indexOf(activeSchoolId);
	      var isIdxInKildeArr = schoolIdsFromKildegaard.indexOf(activeSchoolId);
	      var isIdxInLillevangArr = schoolIdsFromLillevang.indexOf(activeSchoolId);
	      var isIdxInBornebyArr = schoolsIdsFromBorneby.indexOf(activeSchoolId);
	      var isIdsInSolsort = schoolIdsFromSolsort.indexOf(activeSchoolId);
	      var isIdxIn64272Arr = schoolIdsFrom64272.indexOf(activeSchoolId);
	      if (isIdxIn64272Arr > -1) {
	        var _storeObj = {
	          schoolIds: schoolIdsFrom64272,
	          isShowEventsFromOtherThanActiveSchool: false
	        };
	        this.$store.dispatch('readAllEvents', _storeObj);
	        return;
	      }
	      if (isIdxInBornebyArr > -1) {
	        var _storeObj2 = {
	          schoolIds: schoolsIdsFromBorneby,
	          isShowEventsFromOtherThanActiveSchool: false
	        };
	        this.$store.dispatch('readAllEvents', _storeObj2);
	        return;
	      }
	      if (isIdsInSolsort > -1) {
	        var _storeObj3 = {
	          schoolIds: schoolIdsFromSolsort,
	          isShowEventsFromOtherThanActiveSchool: false
	        };
	        this.$store.dispatch('readAllEvents', _storeObj3);
	        return;
	      }
	      if (isIdxInLillevangArr > -1) {
	        var _storeObj4 = {
	          schoolIds: schoolIdsFromLillevang,
	          isShowEventsFromOtherThanActiveSchool: false
	        };
	        if (checkIfUserIsMemberOfAllSchools(schoolIdsFromLillevang)) {
	          this.$store.dispatch('readAllEvents', _storeObj4);
	        } else {
	          this.$store.dispatch('getAllDayEvents');
	        }
	        return;
	      }
	      if (isIdxInHerlevArr > -1) {
	        var _storeObj5 = {
	          schoolIds: schoolIdsFromHerlevBySkole,
	          isShowEventsFromOtherThanActiveSchool: false
	        };
	        this.$store.dispatch('readAllEvents', _storeObj5);
	        return;
	      }
	      if (isIdxInHornsletArr > -1) {
	        var _storeObj6 = {
	          schoolIds: schoolIdsFromHornslet,
	          isShowEventsFromOtherThanActiveSchool: true
	        };
	        this.$store.dispatch('readAllEvents', _storeObj6);
	        return;
	      }
	      if (isIdxInKildeArr > -1) {
	        var _storeObj7 = {
	          schoolIds: schoolIdsFromKildegaard,
	          isShowEventsFromOtherThanActiveSchool: false
	        };
	        this.$store.dispatch('readAllEvents', _storeObj7);
	        return;
	      }
	      this.$store.dispatch('getAllDayEvents');
	    },
	    applyUserSettings: function applyUserSettings(val) {
	      if (!val) return;
	
	      var selectedSubSchedulerSorting = val.selectedSubSchedulerSorting,
	          isSubZenActive = val.isSubZenActive,
	          subZenOrder = val.subZenOrder;
	
	
	      if (selectedSubSchedulerSorting) {
	        this.onSortBy(selectedSubSchedulerSorting, false);
	      } else if (isSubZenActive) {
	        this.onSortBy('subzen', true);
	      }
	
	      if (subZenOrder) {
	        this.$store.commit('setSortingHierarchy', subZenOrder);
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUserSubPools');
	    this.$store.dispatch('subsGetLongAbsenceList');
	    var localStorageAppliedFiltersForSubs = this.$helpers.getLocalStorage('d_applied_filters_subs_' + this.schoolId);
	    var localStorageAppliedFiltersForAbsent = this.$helpers.getLocalStorage('d_applied_filters_absent_' + this.schoolId);
	    this.appliedFilters = localStorageAppliedFiltersForSubs ? JSON.parse(localStorageAppliedFiltersForSubs) : [];
	    this.appliedFiltersAbsentUsers = localStorageAppliedFiltersForAbsent ? JSON.parse(localStorageAppliedFiltersForAbsent) : [];
	    var localStorageAppliedEventFiltersForSubs = this.$helpers.getLocalStorage('d_applied_event_filters_subs_' + this.schoolId);
	    this.selectedQuickFilters = localStorageAppliedEventFiltersForSubs ? JSON.parse(localStorageAppliedEventFiltersForSubs) : [];
	    var localStorageAppliedEventTitleFilters = this.$helpers.getLocalStorage('d_applied_event_title_filters_subs_' + this.schoolId);
	    this.selectedEventTitleFilters = localStorageAppliedEventTitleFilters ? JSON.parse(localStorageAppliedEventTitleFilters) : [];
	    var localStoragePriorityGroupTags = this.$helpers.getLocalStorage('d_priority_group_tags_' + this.schoolId);
	    this.priorityGroupTags = localStoragePriorityGroupTags ? JSON.parse(localStoragePriorityGroupTags) : [];
	    var localStorageFilterSortOrder = this.$helpers.getLocalStorage('d_filter_sort_order_subs_' + this.schoolId);
	    this.filterSortOrder = localStorageFilterSortOrder ? JSON.parse(localStorageFilterSortOrder) : [];
	    this.isFilterSortActive = this.$helpers.getLocalStorage('d_filter_sort_active_subs_' + this.schoolId) === '1';
	    var localStorageGroupsRequiringPresence = this.$helpers.getLocalStorage('d_groups_requiring_presence_subs_' + this.schoolId);
	    this.groupsRequiringPresence = localStorageGroupsRequiringPresence ? JSON.parse(localStorageGroupsRequiringPresence) : [];
	    var hideLessonsWithoutAbsence = this.$helpers.getLocalStorage('d_hide_lessons_without_absence_' + this.schoolId);
	    this.isHideEventsNotOverlappingAbsence = hideLessonsWithoutAbsence === '1';
	    if (this.$helpers.getLocalStorage('subListView')) {
	      this.localSchedulerView = false;
	    }
	    this.applyUserSettings(this.userSettings);
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('getAllUsers');
	    this.$store.dispatch('getUsers');
	    this.readEvents();
	    this.getTags();
	    this.$store.dispatch('trackEvent', 'substitution_view_opened');
	    window.addEventListener('vueTeamCalendarChanged', this.readEvents);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('vueTeamCalendarChanged', this.readEvents);
	  }
	};

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(14);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  data: function data() {
	    return {
	      isOpen: false
	    };
	  },
	
	  filters: {
	    showDate: function showDate(date) {
	      return (0, _moment2.default)(date).format('dddd, D. MMM');
	    },
	    showTime: function showTime(date) {
	      return (0, _moment2.default)(date).format('LT');
	    },
	    date: function date(_date) {
	      return (0, _moment2.default)(_date).format('ll');
	    },
	    absenceDate: function absenceDate(date) {
	      return (0, _moment2.default)(date).format('DD. MMM, [kl]. LT');
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['longAbsentListInHash', 'usersWithOngoingAbsenceInHash', 'allUsersInCalIdHash']), {
	    absentUsers: function absentUsers() {
	      var _this = this;
	
	      if ((0, _keys2.default)(this.allUsersInCalIdHash).length < 1) {
	        return [];
	      }
	      var userArr = (0, _keys2.default)(this.usersWithOngoingAbsenceInHash);
	      var filteredNotExisting = userArr.filter(function (userCalId) {
	        return !_this.allUsersInCalIdHash[userCalId];
	      });
	      if (filteredNotExisting.length > 0) {
	        console.log('filteredNotExisting', filteredNotExisting);
	      }
	      var filteredUser = userArr.filter(function (userCalId) {
	        return _this.allUsersInCalIdHash[userCalId];
	      });
	      return filteredUser.map(function (userCalId) {
	        var user = {
	          name: _this.allUsersInCalIdHash[userCalId].name,
	          default_thumb_url: _this.allUsersInCalIdHash[userCalId].default_thumb_url,
	          reasons: _this.usersWithOngoingAbsenceInHash[userCalId].absenceArr.map(function (absenceId) {
	            return _this.longAbsentListInHash[absenceId];
	          })
	        };
	        return user;
	      });
	    },
	    absentUsersSorted: function absentUsersSorted() {
	      return this.absentUsers.sort(function (a, b) {
	        return (a.name || '').localeCompare(b.name || '', 'da');
	      });
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    absenceReasons: function absenceReasons() {
	      return this.$store.state.subs.absenceReasons;
	    },
	    absenceAutogeneratedToday: function absenceAutogeneratedToday() {
	      var _this2 = this;
	
	      var num = 0;
	      this.absentUsers.forEach(function (user) {
	        if (_this2.getIsUserAbsenceAutogeneratedToday(user)) {
	          num++;
	        }
	      });
	      return num;
	    },
	    textAbsenceCreatedAuto: function textAbsenceCreatedAuto() {
	      return this.$t('vue2.subs_ongoing_absence.auto_created');
	    },
	    allAbsenceEventInEventSerialIdsHash: function allAbsenceEventInEventSerialIdsHash() {
	      return this.$store.state.subs.allAbsenceEventInEventSerialIdsHash;
	    },
	    activeDate: function activeDate() {
	      return this.$store.state.subs.date;
	    }
	  }),
	  methods: {
	    formatDate: function formatDate(date) {
	      return (0, _moment2.default)(date).format('ll');
	    },
	    getIsUserAbsenceAutogeneratedToday: function getIsUserAbsenceAutogeneratedToday(user) {
	      var _this3 = this;
	
	      var autoGeneratedToday = false;
	      user.reasons.forEach(function (reason) {
	        var absence = _this3.allAbsenceEventInEventSerialIdsHash[reason.event_serial_id];
	        if (!absence) {
	          return autoGeneratedToday;
	        }
	        var statusObj = absence.substitution_status ? JSON.parse(absence.substitution_status) : {};
	        var todayDate = (0, _moment2.default)(_this3.activeDate).format('YYYY-MM-DD');
	        var extendedDate = (0, _moment2.default)(statusObj['extended_at']).format('YYYY-MM-DD');
	        if (statusObj['extended_at'] && (0, _moment2.default)(extendedDate).isSame(todayDate)) {
	          autoGeneratedToday = true;
	        }
	      });
	      return autoGeneratedToday;
	    },
	    getReasonTitle: function getReasonTitle(reason) {
	      var idx = this.absenceReasons.findIndex(function (absenceSubject) {
	        return absenceSubject.id === reason.subject_id;
	      });
	      return idx > -1 ? this.absenceReasons[idx].name : '';
	    },
	    getSerialListItem: function getSerialListItem(reason) {
	      return this.longAbsentListInHash[reason.event_serial_id] || false;
	    },
	    getAbsenceIsRunningOut: function getAbsenceIsRunningOut(user) {
	      var end = null;
	      user.reasons.forEach(function (reason) {
	        if (!end || (0, _moment2.default)(reason.to_date).isBefore(end)) {
	          end = reason.to_date;
	        }
	      });
	      return end;
	    },
	    setTheEditAbsenceReason: function setTheEditAbsenceReason(reason) {
	      this.$store.commit('setActiveAbsenceReason', reason);
	    },
	    humanizeEndDate: function humanizeEndDate(user) {
	      _moment2.default.locale(window.USER.language);
	      var endDate = this.getAbsenceIsRunningOut(user);
	      var diff = (0, _moment2.default)().diff((0, _moment2.default)(endDate).endOf('day'));
	      return _moment2.default.duration(diff).humanize();
	    }
	  }
	};

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(28);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _AppModal = __webpack_require__(104);
	
	var _AppModal2 = _interopRequireDefault(_AppModal);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _TimeChanger = __webpack_require__(31);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _SubsCreateDayPicker = __webpack_require__(1645);
	
	var _SubsCreateDayPicker2 = _interopRequireDefault(_SubsCreateDayPicker);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _vuex = __webpack_require__(14);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _DQuestionMark = __webpack_require__(410);
	
	var _DQuestionMark2 = _interopRequireDefault(_DQuestionMark);
	
	var _SubsCreateDSelect = __webpack_require__(1644);
	
	var _SubsCreateDSelect2 = _interopRequireDefault(_SubsCreateDSelect);
	
	var _AbsenceReasonsCreate = __webpack_require__(332);
	
	var _AbsenceReasonsCreate2 = _interopRequireDefault(_AbsenceReasonsCreate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    AbsenceReasonsCreate: _AbsenceReasonsCreate2.default,
	    SubsCreateDSelect: _SubsCreateDSelect2.default,
	    AppToggle: _AppToggle2.default, AppModal: _AppModal2.default, DModal: _DModal2.default, dSelect: _DSelect2.default, DatepickerRange: _DatePickerRange2.default, TimeChanger: _TimeChanger2.default, DaySelector: _SubsCreateDayPicker2.default, DQuestionMark: _DQuestionMark2.default
	  },
	  props: {
	    users: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    usersWithOngoingAbsenceInHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    allUsersInCalIdHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    schoolId: {
	      default: null
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['subsAbsenceReasonsSorted', 'locale', 'employmentsInUserIdHash']), {
	    getOPUSAbsence: function getOPUSAbsence() {
	      if (!this.reason || !this.reason.kmd_absence_code_id) {
	        return null;
	      }
	      var opusAbsenceId = this.reason.kmd_absence_code_id;
	      var absenceCodes = this.opusAbsenceCodes || [];
	      if (!Array.isArray(absenceCodes) || absenceCodes.length < 1) {
	        return null;
	      }
	      var match = absenceCodes.find(function (code) {
	        return String(code.id) === String(opusAbsenceId);
	      });
	      return match || null;
	    },
	    getSDAbsence: function getSDAbsence() {
	      if (!this.reason || !this.reason.sd_absence_code_id) {
	        return null;
	      }
	      var sdAbsenceId = this.reason.sd_absence_code_id;
	      var absenceCodes = this.sdAbsenceCodes || [];
	      if (!Array.isArray(absenceCodes) || absenceCodes.length < 1) {
	        return null;
	      }
	      var match = absenceCodes.find(function (code) {
	        return String(code.id) === String(sdAbsenceId);
	      });
	      return match || null;
	    },
	    timeRangeHours: function timeRangeHours() {
	      if (!this.startTime || !this.endTime) {
	        return 0;
	      }
	      var diffMinutes = this.endTime.diff(this.startTime, 'minutes');
	      var hours = diffMinutes / 60;
	      return Math.round(hours * 100) / 100;
	    },
	    timeRangeHoursFormatted: function timeRangeHoursFormatted() {
	      var hours = this.timeRangeHours;
	      if (hours === 1) {
	        return '1 time';
	      }
	
	      return String(hours).replace('.', ',') + ' timer';
	    },
	    dateRangeDays: function dateRangeDays() {
	      if (!this.startDate || !this.endDate) {
	        return 1;
	      }
	      var start = (0, _moment2.default)(this.startDate).startOf('day');
	      var end = (0, _moment2.default)(this.endDate).startOf('day');
	      return end.diff(start, 'days') + 1;
	    },
	    dateRangeDaysFormatted: function dateRangeDaysFormatted() {
	      var days = this.dateRangeDays;
	      if (days === 1) {
	        return '1 dag';
	      }
	      return days + ' dage';
	    },
	    dateRangeFormatted: function dateRangeFormatted() {
	      var start = (0, _moment2.default)(this.startDate).format('DD-MM-YYYY');
	      var end = (0, _moment2.default)(this.endDate).format('DD-MM-YYYY');
	      if (start === end) {
	        return start;
	      }
	      return start + ' - ' + end;
	    },
	    startDateFormatted: function startDateFormatted() {
	      return (0, _moment2.default)(this.startDate).format('DD-MM-YYYY');
	    },
	    isOpusAllowOpen: function isOpusAllowOpen() {
	      if (!this.isOpusAbsenceActivated || !this.reason || !this.reason.kmd_absence_code_id) {
	        return true;
	      }
	      var opusAbsence = this.getOPUSAbsence;
	      if (!opusAbsence || typeof opusAbsence.allow_open === 'undefined') {
	        return true;
	      }
	      return opusAbsence.allow_open === true;
	    },
	    isOpusAbsenceActivated: function isOpusAbsenceActivated() {
	      return this.$store.getters.schoolFeatures && this.$store.getters.schoolFeatures.indexOf('kmd_absence') > -1;
	    },
	    isSDIntegrationActive: function isSDIntegrationActive() {
	      return this.$store.getters.schoolFeatures && this.$store.getters.schoolFeatures.indexOf('silkeborg_data_integration') > -1;
	    },
	    isAbsenceIntegrationActive: function isAbsenceIntegrationActive() {
	      return this.isOpusAbsenceActivated || this.isSDIntegrationActive;
	    },
	    isShowOpusInfoBox: function isShowOpusInfoBox() {
	      return this.isOpusAbsenceActivated && this.reason && this.reason.kmd_absence_code_id && this.usersAbsent.length > 0;
	    },
	    isShowSdInfoBox: function isShowSdInfoBox() {
	      return this.isSDIntegrationActive && this.reason && this.reason.sd_absence_code_id && this.usersAbsent.length > 0;
	    },
	    isShowSalaryInfoBox: function isShowSalaryInfoBox() {
	      return this.isShowOpusInfoBox || this.isShowSdInfoBox;
	    },
	    isShowExtraInformation: function isShowExtraInformation() {
	      var opusAbsence = this.getOPUSAbsence;
	      if (!opusAbsence || !opusAbsence.additional_data) {
	        return false;
	      }
	
	      var firstUserCalendarId = this.usersAbsent[0];
	      return firstUserCalendarId && this.selectedEmploymentIds[firstUserCalendarId];
	    },
	    shouldShowEmploymentSelection: function shouldShowEmploymentSelection() {
	      return this.isAbsenceIntegrationActive && this.reason && (this.reason.kmd_absence_code_id && this.isOpusAbsenceActivated || this.reason.sd_absence_code_id && this.isSDIntegrationActive) && this.usersAbsent.length > 0;
	    },
	    isEmploymentSelected: function isEmploymentSelected() {
	      var _this = this;
	
	      if (!this.shouldShowEmploymentSelection) {
	        return true;
	      }
	      return this.usersAbsent.every(function (userCalendarId) {
	        return _this.selectedEmploymentIds[userCalendarId] && _this.selectedEmploymentIds[userCalendarId] !== '';
	      });
	    },
	    absentUsersWithOngoingAbsenceAlready: function absentUsersWithOngoingAbsenceAlready() {
	      var _this2 = this;
	
	      if (!this.isAbsenceOngoing) {
	        return [];
	      }
	
	      return this.usersAbsent.filter(function (absentUserCalId) {
	        return _this2.usersWithOngoingAbsenceInHash[absentUserCalId];
	      }).map(function (absentUserCalId) {
	        var user = _this2.allUsersInCalIdHash[absentUserCalId];
	        return user ? user.name : absentUserCalId;
	      });
	    },
	    text: function text() {
	      return '';
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isUserLoaded: function isUserLoaded() {
	      return this.$store.state.isUserLoaded;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    isAdditionalDataRequired: function isAdditionalDataRequired() {
	      return this.getOPUSAbsence && this.getOPUSAbsence.additional_data_required;
	    },
	    isAdditionalDataSelected: function isAdditionalDataSelected() {
	      if (!this.isAdditionalDataRequired) {
	        return true;
	      }
	      return this.selectedAdditionalData !== '';
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    dbEventStart: function dbEventStart() {
	      var date = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var time = this.startTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    dbEventEnd: function dbEventEnd() {
	      var date = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var time = this.endTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    isUserSelected: function isUserSelected() {
	      return this.usersAbsent.length > 0;
	    },
	    isReasonSelected: function isReasonSelected() {
	      return this.reason !== '';
	    },
	    getDate: function getDate() {
	      return this.$store.state.subs.date;
	    },
	    isOngoingAbsenceDateAllowed: function isOngoingAbsenceDateAllowed() {
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var now = (0, _moment2.default)().format('YYYY-MM-DD');
	      return (0, _moment2.default)(endDate).isSameOrAfter(now);
	    },
	    isAbsenceOnlyOnWeekend: function isAbsenceOnlyOnWeekend() {
	      if (this.isAbsenceOngoing || !this.startDate || !this.endDate) {
	        return false;
	      }
	      var start = (0, _moment2.default)(this.startDate).startOf('day');
	      var end = (0, _moment2.default)(this.endDate).startOf('day');
	      for (var date = start.clone(); date.isSameOrBefore(end); date.add(1, 'day')) {
	        if (date.isoWeekday() < 6) {
	          return false;
	        }
	      }
	      return true;
	    },
	    isOngoingAbsenceAllowed: function isOngoingAbsenceAllowed() {
	      return this.isOngoingAbsenceDateAllowed && this.isOpusAllowOpen;
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    },
	    saveKeyTooltip: function saveKeyTooltip() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span>' + '<span>Enter</span></p>';
	    }
	  }),
	  data: function data() {
	    return {
	      isLoadedSalarySystemInfo: false,
	      useTime: false,
	      useTimeBeforeTimeEdit: false,
	      wholeDayToastTimer: null,
	      isCreateAbsenceReason: false,
	      i18n: {
	        da: {
	          note_to_absence: 'Eventuel note til fraværet',
	          set_default_start_and_endtime: 'Sæt standard start- og sluttid',
	          standard_setting: 'Standard indstilling',
	          as_a_new_reason: 'som ny årsag',
	          already_has_ongoing_absence: 'har allerede åbenstående fravær',
	          absence_only_on_weekend: 'Fravær kan ikke oprettes i weekenden. Vælg en periode, der indeholder mindst én hverdag.'
	        },
	        en: {
	          note_to_absence: 'Note to absence',
	          set_default_start_and_endtime: 'Set default start and end time',
	          standard_setting: 'Standard setting',
	          as_a_new_reason: 'as a new absence',
	          already_has_ongoing_absence: 'already has ongoing absence',
	          absence_only_on_weekend: 'Absence cannot be created on weekends. Choose a period that includes at least one weekday.'
	        },
	        nb: {
	          note_to_absence: 'Merknad til fravær',
	          set_default_start_and_endtime: 'Angi standard start- og sluttid',
	          standard_setting: 'Standardinnstilling',
	          as_a_new_reason: 'som en ny årsak',
	          already_has_ongoing_absence: 'har allerede pågående fravær',
	          absence_only_on_weekend: 'Fravær kan ikke opprettes i helgen. Velg en periode som inneholder minst én ukedag.'
	        }
	      },
	      noteForAbsentReason: '',
	      showModal: false,
	      showErrorMessages: false,
	      usersAbsent: [],
	      startDate: (0, _moment2.default)(),
	      endDate: (0, _moment2.default)(),
	      reason: '',
	      reasonCreated: '',
	      startTime: (0, _moment2.default)().set({ 'hour': 8, 'minutes': 0 }),
	      endTime: (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0 }),
	      standardStartTime: (0, _moment2.default)().set({ 'hour': 8, 'minutes': 0 }),
	      standardEndTime: (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0 }),
	      isAbsenceOngoing: false,
	      isShowSettings: false,
	      reasonSearchText: '',
	      isShowCreateAbsenceReasonButton: false,
	      isEventListenerForSubmitAdded: false,
	      isEndDateManipulatedFromDev: false,
	      originalEndDate: null,
	      selectedEmploymentIds: {},
	      opusAbsenceCodes: [],
	      sdAbsenceCodes: [],
	      additionalDataOptions: [],
	      selectedAdditionalData: null,
	      isLoadingAdditionalData: false,
	      hasLoadedAdditionalData: false,
	      additionalDataError: null
	    };
	  },
	
	  methods: {
	    setIsAbsenceOngoing: function setIsAbsenceOngoing(bool) {
	      if (!this.isOpusAllowOpen && bool) {
	        this.isAbsenceOngoing = false;
	        return;
	      }
	      this.isAbsenceOngoing = bool;
	      if (bool) {
	        var start = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	        var end = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	        this.originalEndDate = end;
	
	        var endWasFriday = (0, _moment2.default)(end).isoWeekday() === 5;
	        var newEnd = end;
	
	        if (start === end) {
	          newEnd = (0, _moment2.default)(end).add(1, 'day');
	          this.isEndDateManipulatedFromDev = true;
	        }
	
	        if (endWasFriday) {
	          newEnd = (0, _moment2.default)(end).add(3, 'days');
	          this.isEndDateManipulatedFromDev = true;
	        }
	        this.endDate = newEnd;
	      } else {
	        if (this.isEndDateManipulatedFromDev) {
	          this.endDate = (0, _moment2.default)(this.originalEndDate).format('YYYY-MM-DD');
	          this.isEndDateManipulatedFromDev = false;
	        }
	      }
	    },
	    onCloseDSelectAbsenceReasons: function onCloseDSelectAbsenceReasons() {
	      this.isShowCreateAbsenceReasonButton = false;
	    },
	    setIsShowCreateAbsenceReasonButton: function setIsShowCreateAbsenceReasonButton() {
	      var _this3 = this;
	
	      var idx = this.subsAbsenceReasonsSorted.findIndex(function (absenceReason) {
	        return absenceReason.name === _this3.reasonSearchText;
	      });
	      this.isShowCreateAbsenceReasonButton = this.reasonSearchText.length > 0 && idx < 0;
	    },
	    onSearchTextDebounced: function onSearchTextDebounced() {
	      this.setIsShowCreateAbsenceReasonButton();
	    },
	    setIsAbsenceRunning: function setIsAbsenceRunning(val) {
	      if (this.isAbsenceOngoing !== val) {
	        this.isAbsenceOngoing = !this.isAbsenceOngoing;
	      }
	    },
	    userHasPermission: function userHasPermission(val) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(val) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    setShowModal: function setShowModal() {
	      this.showModal = true;
	      this.startDate = (0, _moment2.default)(this.getDate);
	      this.endDate = (0, _moment2.default)(this.getDate);
	      this.addEventListenerSubmit();
	      if (this.userSettings) {
	        if (this.userSettings.subSettingsCreateTime) {
	          var start = (0, _moment2.default)(this.userSettings.subSettingsCreateTime.start);
	          var end = (0, _moment2.default)(this.userSettings.subSettingsCreateTime.end);
	          this.startTime = (0, _moment2.default)().set({ 'hour': (0, _moment2.default)(start).hour(), 'minutes': (0, _moment2.default)(start).minute() });
	          this.endTime = (0, _moment2.default)().set({ 'hour': (0, _moment2.default)(end).hour(), 'minutes': (0, _moment2.default)(end).minute() });
	          this.standardStartTime = this.startTime;
	          this.standardEndTime = this.endTime;
	        }
	      }
	      setTimeout(function (_) {
	        document.querySelector('#create_absence_user .d-select__input-look > input[type="search"]').focus();
	      }, 500);
	    },
	    addEventListenerSubmit: function addEventListenerSubmit() {
	      if (!this.isEventListenerForSubmitAdded) {
	        window.addEventListener('keydown', this.onHandleKeyboardShortcutSubmit);
	        window.addEventListener('keydown', this.onHandleKeyboardShortcutEsc);
	        this.isEventListenerForSubmitAdded = true;
	      }
	    },
	    removeEventListenerForSubmit: function removeEventListenerForSubmit() {
	      window.removeEventListener('keydown', this.onHandleKeyboardShortcutSubmit);
	      window.removeEventListener('keydown', this.onHandleKeyboardShortcutEsc);
	      this.isEventListenerForSubmitAdded = false;
	    },
	    closeModal: function closeModal() {
	      this.showModal = false;
	      this.showErrorMessages = false;
	      this.isAbsenceOngoing = false;
	      this.useTime = false;
	      this.reason = '';
	      this.reasonSearchText = '';
	      this.isShowCreateAbsenceReasonButton = false;
	      this.selectedEmploymentIds = {};
	      this.usersAbsent = [];
	      if (this.isEndDateManipulatedFromDev) {
	        this.endDate = (0, _moment2.default)(this.originalEndDate);
	      }
	      this.isEndDateManipulatedFromDev = false;
	      this.originalEndDate = null;
	      this.removeEventListenerForSubmit();
	    },
	    createAbsenceReason: function createAbsenceReason(titleAndDefaultPrivate) {
	      var _this4 = this;
	
	      var title = titleAndDefaultPrivate.title;
	      var defaultPrivate = titleAndDefaultPrivate.defaultPrivate;
	      var canRequest = true;
	      var defaultOngoing = false;
	      var kmdAbsenceCodeId = null;
	      var sdAbsenceCodeId = null;
	      var plannedAbsence = false;
	      _docendo2.default.schoolAbsenceSubjectsCreate(this.schoolId, title, '#564437', defaultPrivate, defaultOngoing, plannedAbsence, kmdAbsenceCodeId, sdAbsenceCodeId, canRequest, function (data) {
	        _this4.$store.commit('subsAddNewAbsenceReason', data);
	        _this4.reasonCreated = data;
	        _this4.isCreateAbsenceReason = false;
	      }, function (failure) {
	        console.log('Failed', failure);
	      });
	    },
	    setReasonSearchText: function setReasonSearchText(text) {
	      this.reasonSearchText = text;
	    },
	    setUsers: function setUsers(users) {
	      var _this5 = this;
	
	      var newUsersAbsent = users.map(function (user) {
	        return user.user_calendar_id;
	      });
	
	      var preservedEmploymentIds = {};
	      newUsersAbsent.forEach(function (userCalendarId) {
	        if (_this5.selectedEmploymentIds[userCalendarId]) {
	          preservedEmploymentIds[userCalendarId] = _this5.selectedEmploymentIds[userCalendarId];
	        }
	      });
	      this.usersAbsent = newUsersAbsent;
	      this.selectedEmploymentIds = preservedEmploymentIds;
	
	      if (this.reason && (this.reason.kmd_absence_code_id || this.reason.sd_absence_code_id)) {
	        this.autoSelectSingleEmployments();
	      }
	    },
	    setReason: function setReason(reason) {
	      this.reason = reason[0];
	      var shouldBeOngoing = !!(reason[0] && reason[0].default_ongoing && this.isOpusAllowOpen);
	      if (shouldBeOngoing !== this.isAbsenceOngoing) {
	        this.setIsAbsenceOngoing(shouldBeOngoing);
	      }
	
	      if (!reason[0] || !reason[0].kmd_absence_code_id && !reason[0].sd_absence_code_id) {
	        this.selectedEmploymentIds = {};
	      } else {
	        this.autoSelectSingleEmployments();
	      }
	    },
	    getUserName: function getUserName(userCalendarId) {
	      var user = this.allUsersInCalIdHash[userCalendarId];
	      return user ? user.name : userCalendarId;
	    },
	    getUserEmployments: function getUserEmployments(userCalendarId) {
	      var user = this.allUsersInCalIdHash[userCalendarId];
	      if (!user || !user.id) {
	        return [];
	      }
	      var employments = this.employmentsInUserIdHash[user.id] || [];
	
	      return employments.filter(function (emp) {
	        return emp.employment_number && String(emp.employment_number).trim() !== '';
	      });
	    },
	    getEmploymentNumber: function getEmploymentNumber(userCalendarId) {
	      var employmentId = this.selectedEmploymentIds[userCalendarId];
	      if (!employmentId) {
	        return '—';
	      }
	      var employments = this.getUserEmployments(userCalendarId);
	      var match = employments.find(function (emp) {
	        return emp.id === Number(employmentId);
	      });
	      if (!match) {
	        return '—';
	      }
	      return match.employment_number || match.id;
	    },
	    onEmploymentChange: function onEmploymentChange(userCalendarId, employmentId) {
	      this.$set(this.selectedEmploymentIds, userCalendarId, employmentId);
	    },
	    autoSelectSingleEmployments: function autoSelectSingleEmployments() {
	      var _this6 = this;
	
	      if (!this.shouldShowEmploymentSelection) {
	        return;
	      }
	      this.usersAbsent.forEach(function (userCalendarId) {
	        if (_this6.selectedEmploymentIds[userCalendarId]) {
	          return;
	        }
	        var employments = _this6.getUserEmployments(userCalendarId);
	
	        if (employments.length === 1) {
	          _this6.$set(_this6.selectedEmploymentIds, userCalendarId, employments[0].id);
	        }
	      });
	    },
	    setStartDate: function setStartDate(payload) {
	      this.startDate = payload;
	    },
	    setEndDate: function setEndDate(payload) {
	      this.endDate = payload;
	      var endDate = (0, _moment2.default)(payload).format('YYYY-MM-DD');
	      var now = (0, _moment2.default)().format('YYYY-MM-DD');
	      if (this.isAbsenceOngoing && !(0, _moment2.default)(endDate).isAfter(now)) {
	        this.isAbsenceOngoing = false;
	        this.isEndDateManipulatedFromDev = false;
	      }
	    },
	    setStartTime: function setStartTime(payload) {
	      this.startTime = payload;
	      this.syncWholeDayWithStandardTimes();
	    },
	    setEndTime: function setEndTime(payload) {
	      this.endTime = payload;
	      this.syncWholeDayWithStandardTimes();
	    },
	    syncWholeDayWithStandardTimes: function syncWholeDayWithStandardTimes() {
	      var saved = this.userSettings && this.userSettings.subSettingsCreateTime;
	      var standardStart = saved ? (0, _moment2.default)(saved.start).format('HH:mm') : '08:00';
	      var standardEnd = saved ? (0, _moment2.default)(saved.end).format('HH:mm') : '16:00';
	      var isStandardStart = (0, _moment2.default)(this.startTime).format('HH:mm') === standardStart;
	      var isStandardEnd = (0, _moment2.default)(this.endTime).format('HH:mm') === standardEnd;
	      if (this.wholeDayToastTimer === null) {
	        this.useTimeBeforeTimeEdit = this.useTime;
	      }
	      this.useTime = !(isStandardStart && isStandardEnd);
	      this.notifyWholeDayChange();
	    },
	    notifyWholeDayChange: function notifyWholeDayChange() {
	      var _this7 = this;
	
	      clearTimeout(this.wholeDayToastTimer);
	      this.wholeDayToastTimer = setTimeout(function () {
	        _this7.wholeDayToastTimer = null;
	        if (_this7.isShowSalaryInfoBox && _this7.useTime !== _this7.useTimeBeforeTimeEdit) {
	          _eventbus2.default.toast = { text: _this7.useTime ? '"Indberet som hel dag" er slået fra' : '"Indberet som hel dag" er slået til', success: true };
	        }
	      }, 800);
	    },
	    setStandardStartTime: function setStandardStartTime(payload) {
	      this.standardStartTime = payload;
	    },
	    setStandardEndTime: function setStandardEndTime(payload) {
	      this.standardEndTime = payload;
	    },
	    submitUser: function submitUser() {
	      var _this8 = this;
	
	      if (!this.isUserSelected || !this.isReasonSelected) {
	        this.showErrorMessages = true;
	        return;
	      }
	      if (this.shouldShowEmploymentSelection && !this.isEmploymentSelected) {
	        this.showErrorMessages = true;
	        return;
	      }
	      if (!this.isAdditionalDataSelected) {
	        this.showErrorMessages = true;
	        this.additionalDataValidationError = 'Du skal vælge ekstra information';
	        return;
	      }
	      if (this.isAdditionalDataRequired && this.usersAbsent.length > 1) {
	        return;
	      }
	      if (this.isAbsenceOnlyOnWeekend) {
	        return;
	      }
	      if (!this.isOngoingAbsenceAllowed) {
	        this.isAbsenceOngoing = false;
	      }
	      var currDate = (0, _moment2.default)(this.getDate).format('YYYY-MM-DD');
	      var absenceStart = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var absenceEnd = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var absenceOverlapsCurrentDate = (0, _moment2.default)(currDate).isBetween(absenceStart, absenceEnd, null, []);
	      var startTime = this.startTime.second(0).millisecond(0).toISOString();
	      var endTime = this.endTime.second(0).millisecond(0).toISOString();
	      var useTime = this.useTime;
	      this.usersAbsent.forEach(function (userCalendarId) {
	        var employmentId = _this8.shouldShowEmploymentSelection ? _this8.selectedEmploymentIds[userCalendarId] : null;
	        var additionalData = _this8.selectedAdditionalData || null;
	        _docendo2.default.schoolEventSerialsCreate(window.SCHOOL.id, userCalendarId, _this8.reason.id, absenceStart, absenceEnd, startTime, endTime, _this8.isAbsenceOngoing, _this8.noteForAbsentReason, employmentId, useTime, additionalData, function (data) {
	          var parsedEvent = JSON.parse(data);
	
	          var viewedDate = (0, _moment2.default)(_this8.getDate).format('YYYY-MM-DD');
	          if (absenceOverlapsCurrentDate && viewedDate === currDate && parsedEvent && parsedEvent.events) {
	            var todayEvent = parsedEvent.events.find(function (event) {
	              return (0, _moment2.default)(event.start).format('YYYY-MM-DD') === currDate;
	            });
	            if (todayEvent) {
	              _this8.$store.commit('updateEventOnAllEventsInAHash', todayEvent);
	              _this8.$store.commit('addAbsenceToUserInAllUsersWithEvents', {
	                cal_id: parsedEvent.calendar_id,
	                event_id: todayEvent.id
	              });
	            }
	          }
	          _this8.$store.dispatch('subsGetLongAbsenceList');
	        }, function (failure) {
	          console.log('Failed to create absence:', failure);
	        });
	      });
	      this.showModal = false;
	      this.showErrorMessages = false;
	      this.clearForm();
	      this.$emit('created');
	    },
	    clearForm: function clearForm() {
	      this.startDate = (0, _moment2.default)(this.getDate);
	      this.endDate = (0, _moment2.default)(this.getDate);
	      this.startTime = (0, _moment2.default)().set({ 'hour': 8, 'minutes': 0 });
	      this.endTime = (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0 });
	      this.reason = '';
	      this.noteForAbsentReason = '';
	      this.showErrorMessages = false;
	      this.additionalDataValidationError = null;
	      this.selectedEmploymentIds = {};
	      this.isAbsenceOngoing = false;
	      this.useTime = false;
	    },
	    submitStandardSettings: function submitStandardSettings() {
	      var standardSubsCreateTime = { 'subSettingsCreateTime': { start: this.standardStartTime, end: this.standardEndTime } };
	      this.$store.dispatch('updateUserSettings', standardSubsCreateTime);
	      var start = this.standardStartTime;
	      var end = this.standardEndTime;
	      this.startTime = (0, _moment2.default)().set({ 'hour': (0, _moment2.default)(start).hour(), 'minutes': (0, _moment2.default)(start).minute() });
	      this.endTime = (0, _moment2.default)().set({ 'hour': (0, _moment2.default)(end).hour(), 'minutes': (0, _moment2.default)(end).minute() });
	      this.syncWholeDayWithStandardTimes();
	      this.isShowSettings = false;
	    },
	    onHandleKeyboardShortcutSubmit: function onHandleKeyboardShortcutSubmit(e) {
	      if (this.showModal && (e.ctrlKey || e.metaKey) && e.key === 'Enter') {
	        e.preventDefault();
	        this.submitUser();
	      }
	    },
	    onHandleKeyboardShortcutEsc: function onHandleKeyboardShortcutEsc(e) {
	      if (e.key === 'Escape') {
	        e.preventDefault();
	        this.closeModal();
	      }
	    },
	    listKmdOpusAbsenceCodes: function listKmdOpusAbsenceCodes() {
	      var _this9 = this;
	
	      _docendo2.default.listKmdOpusAbsenceCodes(this.schoolId, function (success) {
	        _this9.opusAbsenceCodes = Array.isArray(success) ? success : [];
	      }, function (failure) {
	        _this9.opusAbsenceCodes = [];
	      });
	    },
	    listSdAbsenceCodes: function listSdAbsenceCodes() {
	      var _this10 = this;
	
	      _docendo2.default.listSilkeborgDataAbsenceCodes(this.schoolId, function (success) {
	        _this10.sdAbsenceCodes = Array.isArray(success) ? success : success && Array.isArray(success.data) ? success.data : [];
	      }, function (failure) {
	        _this10.sdAbsenceCodes = [];
	      });
	    },
	    resetOpusFields: function resetOpusFields() {
	      this.useTime = false;
	      this.additionalDataOptions = [];
	      this.selectedAdditionalData = null;
	      this.hasLoadedAdditionalData = false;
	      this.additionalDataError = null;
	      this.additionalDataValidationError = null;
	    },
	    fetchAdditionalDataForAbsence: function fetchAdditionalDataForAbsence() {
	      var _this11 = this;
	
	      console.log('fetchAdditionalDataForAbsence');
	
	      if (!this.isShowExtraInformation) {
	        this.additionalDataOptions = [];
	        this.selectedAdditionalData = null;
	        return;
	      }
	      var opusAbsence = this.getOPUSAbsence;
	      if (!opusAbsence) return;
	
	      var firstUserCalendarId = this.usersAbsent[0];
	      var employmentId = this.selectedEmploymentIds[firstUserCalendarId];
	      if (!employmentId) return;
	
	      this.isLoadingAdditionalData = true;
	      this.hasLoadedAdditionalData = false;
	      this.additionalDataOptions = [];
	      this.selectedAdditionalData = null;
	
	      console.log('Calling listAdditionalDataForAbsence', {
	        schoolId: this.schoolId,
	        employmentId: employmentId,
	        absenceCodeId: opusAbsence.id
	      });
	
	      _docendo2.default.listAdditionalDataForAbsence(this.schoolId, employmentId, opusAbsence.id, (0, _moment2.default)(this.startDate).format('YYYY-MM-DD'), (0, _moment2.default)(this.endDate).format('YYYY-MM-DD'), function (response) {
	        console.log('fetchAdditionalDataForAbsence response', response);
	
	        if (response && response.success === false) {
	          _this11.additionalDataOptions = [];
	          _this11.additionalDataError = response.data && response.data.error || response.error || 'Der opstod en fejl';
	          _this11.isLoadingAdditionalData = false;
	          _this11.hasLoadedAdditionalData = true;
	          return;
	        }
	        if (response && response.error) {
	          _this11.additionalDataOptions = [];
	          _this11.additionalDataError = response.error;
	          _this11.isLoadingAdditionalData = false;
	          _this11.hasLoadedAdditionalData = true;
	          return;
	        }
	        if (response && response.data && response.data.error) {
	          _this11.additionalDataOptions = [];
	          _this11.additionalDataError = response.data.error;
	          _this11.isLoadingAdditionalData = false;
	          _this11.hasLoadedAdditionalData = true;
	          return;
	        }
	        _this11.additionalDataError = null;
	
	        var parsedData = response;
	        if (response && response.response && typeof response.response === 'string') {
	          try {
	            parsedData = JSON.parse(response.response);
	          } catch (e) {
	            console.error('Failed to parse response.response', e);
	          }
	        }
	
	        var cases = null;
	        if (parsedData && parsedData.Body) {
	          if (_this11.getOPUSAbsence && _this11.getOPUSAbsence.additional_data === 'Maternity') {
	            cases = parsedData.Body.GetMaternityCasesResponse_MT && parsedData.Body.GetMaternityCasesResponse_MT.MaternityCase;
	          } else if (_this11.getOPUSAbsence && _this11.getOPUSAbsence.additional_data === 'Reason') {
	            var reasonsResponse = parsedData.Body.GetReasonsResponse_MT || parsedData.Body.GetReasonsResponse_RT;
	            cases = reasonsResponse && reasonsResponse.Reason;
	          } else if (_this11.getOPUSAbsence && _this11.getOPUSAbsence.additional_data === 'WorkInjury') {
	            cases = parsedData.Body.GetWorkAccidentCasesResponse_MT && parsedData.Body.GetWorkAccidentCasesResponse_MT.AccidentCase;
	          } else if (_this11.getOPUSAbsence && _this11.getOPUSAbsence.additional_data === 'Child') {
	            cases = parsedData.Body.GetChildrenResponse_MT && parsedData.Body.GetChildrenResponse_MT.Child;
	          }
	        }
	
	        if (Array.isArray(cases)) {
	          _this11.additionalDataOptions = cases;
	        } else if (cases && cases.Item) {
	          _this11.additionalDataOptions = Array.isArray(cases.Item) ? cases.Item : [cases.Item];
	        } else if (cases && (typeof cases === 'undefined' ? 'undefined' : (0, _typeof3.default)(cases)) === 'object') {
	          _this11.additionalDataOptions = [cases];
	        } else {
	          _this11.additionalDataOptions = [];
	        }
	
	        if (_this11.additionalDataOptions.length === 1) {
	          var singleOption = _this11.additionalDataOptions[0];
	          var additionalDataType = _this11.getOPUSAbsence && _this11.getOPUSAbsence.additional_data;
	          if (additionalDataType === 'Maternity' && singleOption.MaternityCaseKey) {
	            _this11.selectedAdditionalData = singleOption.MaternityCaseKey;
	          } else if (additionalDataType === 'Reason' && singleOption.ReasonCode) {
	            _this11.selectedAdditionalData = singleOption.ReasonCode;
	          } else if (additionalDataType === 'WorkInjury' && singleOption.AccidentNumber) {
	            _this11.selectedAdditionalData = singleOption.AccidentNumber;
	          } else if (additionalDataType === 'Child' && singleOption.ChildNumber) {
	            _this11.selectedAdditionalData = singleOption.ChildNumber;
	          }
	        }
	        _this11.isLoadingAdditionalData = false;
	        _this11.hasLoadedAdditionalData = true;
	      }, function (error) {
	        console.error('fetchAdditionalDataForAbsence error', error);
	        _this11.additionalDataOptions = [];
	
	        if (error && error.data && error.data.error) {
	          _this11.additionalDataError = error.data.error;
	        } else if (error && error.error) {
	          _this11.additionalDataError = error.error;
	        } else {
	          _this11.additionalDataError = 'Der opstod en fejl ved hentning af data';
	        }
	        _this11.isLoadingAdditionalData = false;
	        _this11.hasLoadedAdditionalData = true;
	      });
	    }
	  },
	  watch: {
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      var _this12 = this;
	
	      if (this.shouldShowEmploymentSelection) {
	        this.$nextTick(function () {
	          _this12.autoSelectSingleEmployments();
	        });
	      }
	    },
	    reason: function reason(newValue, oldValue) {
	      if (newValue !== oldValue) {
	        this.resetOpusFields();
	      }
	    },
	
	    usersAbsent: {
	      handler: function handler(newValue, oldValue) {
	        var _this13 = this;
	
	        if ((0, _stringify2.default)(newValue) !== (0, _stringify2.default)(oldValue)) {
	          this.selectedEmploymentIds = {};
	          this.resetOpusFields();
	
	          if (this.shouldShowEmploymentSelection) {
	            this.$nextTick(function () {
	              _this13.autoSelectSingleEmployments();
	            });
	          }
	        }
	      },
	
	      deep: true
	    },
	    isShowSalaryInfoBox: function isShowSalaryInfoBox(newValue) {
	      var _this14 = this;
	
	      if (newValue) {
	        this.isLoadedSalarySystemInfo = false;
	        setTimeout(function () {
	          _this14.isLoadedSalarySystemInfo = true;
	        }, 350);
	      } else {
	        this.useTime = false;
	        this.isLoadedSalarySystemInfo = false;
	      }
	    },
	    useTime: function useTime(nextValue) {
	      var _this15 = this;
	
	      if (!nextValue) {
	        return;
	      }
	      this.$nextTick(function () {
	        if (document.activeElement && document.activeElement.classList.contains('d-time-change-input')) {
	          return;
	        }
	        var el = _this15.$el.querySelector('.d-time-change-input');
	        if (el) {
	          el.focus();
	        }
	      });
	    },
	    isShowExtraInformation: function isShowExtraInformation(newValue) {
	      if (newValue) {
	        this.fetchAdditionalDataForAbsence();
	      } else {
	        this.additionalDataOptions = [];
	        this.selectedAdditionalData = null;
	        this.hasLoadedAdditionalData = false;
	        this.additionalDataError = null;
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.isAbsenceIntegrationActive) {
	      this.$store.dispatch('readEmployments');
	      if (this.isOpusAbsenceActivated) this.listKmdOpusAbsenceCodes();
	      if (this.isSDIntegrationActive) this.listSdAbsenceCodes();
	    }
	    this.$store.dispatch('subsGetAbsenceReasons');
	    this._keyListener = function (e) {
	      if (e.key === 'n') {
	        if (e.target.tagName.toUpperCase() === 'BODY') {
	          e.preventDefault();
	          this.setShowModal();
	        }
	      }
	    };
	    document.addEventListener('keydown', this._keyListener.bind(this));
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.removeEventListenerForSubmit();
	    document.removeEventListener('keydown', this._keyListener);
	  }
	};

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelect2.default },
	  props: {
	    items: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    itemsSelected: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    }
	  },
	  data: function data() {
	    return {
	      tags: []
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return window.SCHOOL && window.SCHOOL.id;
	    },
	    dSelectItems: function dSelectItems() {
	      return this.items.concat(this.tagsForSelect);
	    },
	    tagsForSelect: function tagsForSelect() {
	      var tags = [];
	      var i = 0;
	      this.tags.forEach(function (tag) {
	        i++;
	        var oneTag = {
	          tag: true,
	          id: 999999999999 + i,
	          name: tag,
	          icon: 'icon-price-tag2'
	        };
	        tags.push(oneTag);
	      });
	      return tags;
	    }
	  },
	  methods: {
	    sendUpdate: function sendUpdate($event) {
	      this.$emit('update', $event);
	    },
	    getTags: function getTags() {
	      var _this = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this.tags = data;
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.getTags();
	  }
	};

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { appToogler: _AppToggle2.default },
	  data: function data() {
	    return {
	      isSelectorActive: false,
	      selectedDays: []
	    };
	  },
	
	  computed: {
	    weekDays: function weekDays() {
	      var weekDaysNumbers = [1, 2, 3, 4, 5, 6, 7];
	      var weekDays = weekDaysNumbers.map(function (num) {
	        return (0, _moment2.default)().isoWeekday(num);
	      });
	      var days = weekDays.map(function (mom) {
	        return {
	          date: mom,
	          isoWeekDay: (0, _moment2.default)(mom).isoWeekday()
	        };
	      });
	      return days;
	    }
	  },
	  filters: {
	    ddd: function ddd(date) {
	      return (0, _moment2.default)(date).format('dddd');
	    }
	  },
	  methods: {
	    setSelectorActive: function setSelectorActive(Boolean) {
	      this.isSelectorActive = Boolean;
	      console.log('true', Boolean);
	    },
	    isInList: function isInList(day) {
	      return this.selectedDays.indexOf(day.isoWeekDay) > -1;
	    },
	    toggleDay: function toggleDay(day, idx) {
	      if (this.selectedDays.indexOf(day.isoWeekDay) < 0) {
	        this.selectedDays.push(day.isoWeekDay);
	      } else {
	        this.selectedDays.splice(this.selectedDays.indexOf(day.isoWeekDay), 1);
	      }
	    }
	  }
	};

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Lesson = __webpack_require__(1520);
	
	var _Lesson2 = _interopRequireDefault(_Lesson);
	
	var _vuex = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, Lesson: _Lesson2.default },
	  props: {
	    calendarId: {},
	    firstRange: {},
	    lastRange: {},
	    dates: {
	      default: function _default() {
	        return [];
	      }
	    },
	    startTime: {},
	    endTime: {}
	  },
	  data: function data() {
	    return {
	      events: [],
	      eventsWithSubstitutes: [],
	      eventsToRemovedSubs: [],
	      isLoading: true
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['allUsersInHash', 'allUsersInCalIdHash', 'allKlassCalendarsInHash', 'allCalendarsInHash']), {
	    sortedEvents: function sortedEvents() {
	      var arr = this.eventsWithSubstitutes;
	      return arr.sort(function (a, b) {
	        return (0, _moment2.default)(a.start).unix() - (0, _moment2.default)(b.start).unix();
	      });
	    },
	    eventsSortedInDays: function eventsSortedInDays() {
	      var sortedEventsInDays = this.sortedEvents.reduce(function (acc, curr, index) {
	        var val = (0, _moment2.default)(curr['start']).format('YYYY-MM-DD');
	        acc[val] = acc[val] || [];
	        acc[val].push(curr);
	        return acc;
	      }, {});
	      return this.eventsToArr(sortedEventsInDays);
	    }
	  }),
	  watch: {
	    dates: function dates() {
	      this.getAllEventsInPeriod();
	    },
	    eventsWithSubstitutes: function eventsWithSubstitutes(val) {
	      this.$emit('lessonsWithSubs', val);
	    }
	  },
	  methods: {
	    setDbDateTime: function setDbDateTime(inputDate, dayTime) {
	      var date = (0, _moment2.default)(inputDate).format('YYYY-MM-DD');
	      var time = (0, _moment2.default)(dayTime).locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    readEvents: function readEvents(start, end) {
	      var _this = this;
	
	      var dbStart = this.setDbDateTime(start, (0, _moment2.default)().startOf('day'));
	      var dbEnd = this.setDbDateTime(end, (0, _moment2.default)().endOf('day'));
	      _docendo2.default.eventsFromCalendars([this.calendarId], dbStart, dbEnd, null, function (success) {
	        _this.isLoading = false;
	        var data = success && success.length > 0 ? JSON.parse(success) : [];
	        data.forEach(function (lesson) {
	          _this.events.push(lesson);
	          lesson.calendars.forEach(function (calendar) {
	            if (calendar.substitute && calendar.substitute === _this.allUsersInCalIdHash[_this.calendarId].id) {
	              _this.eventsWithSubstitutes.push(lesson);
	              _this.toggleEvent(lesson);
	            }
	          });
	        });
	        _this.$emit('gotLessons', true);
	      }, function (failure) {
	        console.log('failed', failure);
	      });
	    },
	    eventsToArr: function eventsToArr(events) {
	      return (0, _keys2.default)(events).map(function (e) {
	        return { date: e, events: events[e] };
	      });
	    },
	    getSubstitute: function getSubstitute(event) {
	      var _this2 = this;
	
	      var subs = event.calendars.filter(function (calendar) {
	        return calendar.substitute === _this2.allUsersInCalIdHash[_this2.calendarId].id;
	      });
	      return subs.map(function (calendar) {
	        return _this2.allUsersInCalIdHash[calendar.calendar_id];
	      });
	    },
	    getClasses: function getClasses(event) {
	      var _this3 = this;
	
	      return event.calendars.filter(function (calendar) {
	        return _this3.allKlassCalendarsInHash[calendar.calendar_id];
	      }).map(function (calendar) {
	        return _this3.allKlassCalendarsInHash[calendar.calendar_id];
	      });
	    },
	    isInEventsToRemovedSubs: function isInEventsToRemovedSubs(lesson) {
	      var idx = this.eventsToRemovedSubs.findIndex(function (currentEvent) {
	        return currentEvent.event_id === lesson.event_id;
	      });
	      return idx > -1;
	    },
	    toggleEvent: function toggleEvent(lesson) {
	      var idx = this.eventsToRemovedSubs.findIndex(function (currentEvent) {
	        return currentEvent.event_id === lesson.event_id;
	      });
	      if (idx < 0) {
	        this.eventsToRemovedSubs.push(lesson);
	      } else {
	        this.eventsToRemovedSubs.splice(idx, 1);
	      }
	      this.$emit('changed', this.eventsToRemovedSubs);
	    },
	    toggleAll: function toggleAll() {
	      var _this4 = this;
	
	      if (this.eventsToRemovedSubs.length > 0) {
	        this.eventsToRemovedSubs = [];
	      } else {
	        this.eventsWithSubstitutes.forEach(function (event) {
	          return _this4.eventsToRemovedSubs.push(event);
	        });
	      }
	      this.$emit('changed', this.eventsToRemovedSubs);
	    },
	    getAllEventsInPeriod: function getAllEventsInPeriod() {
	      this.events = [];
	      if (this.firstRange.length > 0) {
	        this.readEvents(this.firstRange[0], this.firstRange[1]);
	      }
	      if (this.lastRange.length > 0) {
	        this.readEvents(this.lastRange[0], this.lastRange[1]);
	      }
	      if (!this.firstRange && !this.lastRange && this.dates) {
	        var moments = this.dates.map(function (d) {
	          return (0, _moment2.default)(d);
	        });
	        var startDate = _moment2.default.min(moments);
	        var endDate = _moment2.default.max(moments);
	        if (this.dates.length === 1) {
	          this.readEvents((0, _moment2.default)(this.dates[0]).startOf('day'), (0, _moment2.default)(this.dates[0]).endOf('day'));
	        } else {
	          this.readEvents((0, _moment2.default)(startDate).startOf('day'), (0, _moment2.default)(endDate).endOf('day'));
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.getAllEventsInPeriod();
	  }
	};

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(28);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _vue2Datepicker = __webpack_require__(155);
	
	var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);
	
	__webpack_require__(1400);
	
	__webpack_require__(2176);
	
	var _vuex = __webpack_require__(14);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SubsDeleteAbsenceSubs = __webpack_require__(1646);
	
	var _SubsDeleteAbsenceSubs2 = _interopRequireDefault(_SubsDeleteAbsenceSubs);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _SubsUserAbsenceReason = __webpack_require__(101);
	
	var _SubsUserAbsenceReason2 = _interopRequireDefault(_SubsUserAbsenceReason);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _DQuestionMark = __webpack_require__(410);
	
	var _DQuestionMark2 = _interopRequireDefault(_DQuestionMark);
	
	var _TimeChanger = __webpack_require__(31);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DModal: _DModal2.default,
	    DatePicker: _vue2Datepicker2.default,
	    SubsDeleteAbsence: _SubsDeleteAbsenceSubs2.default,
	    DatepickerRange: _DatePickerRange2.default,
	    SubsUserAbsenceReason: _SubsUserAbsenceReason2.default,
	    AppToggle: _AppToggle2.default,
	    DQuestionMark: _DQuestionMark2.default,
	    TimeChanger: _TimeChanger2.default,
	    DSelect: _DSelect2.default
	  },
	  data: function data() {
	    return {
	      originalStartAndEnd: [],
	      eventsToRemovedSubs: [],
	      isLessonsLoaded: false,
	      datePickerStart: null,
	      datePickerEnd: null,
	      startAndEnd: [],
	      isAbsenceOngoing: false,
	      lessonsWithSubs: [],
	      startTime: (0, _moment2.default)().set({ 'hour': 8, 'minutes': 0 }),
	      endTime: (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0 }),
	      reason: [],
	      showErrors: false,
	
	      selectedEmploymentId: '',
	      opusAbsenceCodes: [],
	      isLoadedSalarySystemInfo: false,
	      useTime: false,
	      useTimeBeforeTimeEdit: false,
	      wholeDayToastTimer: null,
	      additionalDataOptions: [],
	      selectedAdditionalData: '',
	      isLoadingAdditionalData: false,
	      hasLoadedAdditionalData: false,
	      additionalDataError: null,
	      additionalDataValidationError: null,
	      hasReasonBeenChanged: false,
	      sdAbsenceCodes: [],
	
	      sdFravaerForSerial: null
	    };
	  },
	
	  filters: {
	    showDate: function showDate(date) {
	      return (0, _moment2.default)(date).format('DD. MMM, LT');
	    },
	    showTime: function showTime(date) {
	      return (0, _moment2.default)(date).format('LT');
	    },
	    date: function date(_date) {
	      return (0, _moment2.default)(_date).format('ll');
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['allUsersInCalIdHash', 'longAbsentListInHash', 'subsAbsenceReasonsSorted', 'employmentsInUserIdHash']), {
	    activeAbsenceReason: function activeAbsenceReason() {
	      return this.$store.state.subs.activeAbsenceReason;
	    },
	    isActiveAbsenceReasonIsReadyToDelete: function isActiveAbsenceReasonIsReadyToDelete() {
	      return this.$store.state.subs.isActiveAbsenceReasonIsReadyToDelete;
	    },
	    showUser: function showUser() {
	      return this.allUsersInCalIdHash[this.activeAbsenceReason.calendar_id] ? this.allUsersInCalIdHash[this.activeAbsenceReason.calendar_id] : {};
	    },
	    absenceReasons: function absenceReasons() {
	      return this.$store.state.subs.absenceReasons;
	    },
	    schoolId: function schoolId() {
	      return window.SCHOOL ? window.SCHOOL.id : null;
	    },
	    selectedReason: function selectedReason() {
	      return this.reason && this.reason[0] ? this.reason[0] : null;
	    },
	    getOPUSAbsence: function getOPUSAbsence() {
	      if (!this.selectedReason || !this.selectedReason.kmd_absence_code_id) {
	        return null;
	      }
	      var opusAbsenceId = this.selectedReason.kmd_absence_code_id;
	      var absenceCodes = this.opusAbsenceCodes || [];
	      if (!Array.isArray(absenceCodes) || absenceCodes.length < 1) {
	        return null;
	      }
	      return absenceCodes.find(function (code) {
	        return String(code.id) === String(opusAbsenceId);
	      }) || null;
	    },
	    getSDAbsence: function getSDAbsence() {
	      if (!this.selectedReason || !this.selectedReason.sd_absence_code_id) {
	        return null;
	      }
	      var sdAbsenceId = this.selectedReason.sd_absence_code_id;
	      var absenceCodes = this.sdAbsenceCodes || [];
	      if (!Array.isArray(absenceCodes) || absenceCodes.length < 1) {
	        return null;
	      }
	      return absenceCodes.find(function (code) {
	        return String(code.id) === String(sdAbsenceId);
	      }) || null;
	    },
	    isOpusAbsenceActivated: function isOpusAbsenceActivated() {
	      return this.$store.getters.schoolFeatures && this.$store.getters.schoolFeatures.indexOf('kmd_absence') > -1;
	    },
	    isSDIntegrationActive: function isSDIntegrationActive() {
	      return this.$store.getters.schoolFeatures && this.$store.getters.schoolFeatures.indexOf('silkeborg_data_integration') > -1;
	    },
	    isAbsenceIntegrationActive: function isAbsenceIntegrationActive() {
	      return this.isOpusAbsenceActivated || this.isSDIntegrationActive;
	    },
	    isShowOpusInfoBox: function isShowOpusInfoBox() {
	      if (!this.activeAbsenceReason || !this.isOpusAbsenceActivated || !this.selectedReason || !this.selectedReason.kmd_absence_code_id) return false;
	
	      if (this.activeAbsenceReason.kmd_absence_code_id === null && !this.hasReasonBeenChanged) return false;
	      return this.selectedReason && this.selectedReason.kmd_absence_code_id != null;
	    },
	    isShowSdInfoBox: function isShowSdInfoBox() {
	      return !!(this.isSDIntegrationActive && this.selectedReason && this.selectedReason.sd_absence_code_id);
	    },
	    isShowSalaryInfoBox: function isShowSalaryInfoBox() {
	      return this.isShowOpusInfoBox || this.isShowSdInfoBox;
	    },
	    isShowExtraInformation: function isShowExtraInformation() {
	      var opusAbsence = this.getOPUSAbsence;
	      if (!opusAbsence || !opusAbsence.additional_data) {
	        return false;
	      }
	      return !!this.selectedEmploymentId;
	    },
	    existingAdditionalData: function existingAdditionalData() {
	      if (this.activeAbsenceReason && this.activeAbsenceReason.additional_data) {
	        return this.activeAbsenceReason.additional_data;
	      }
	      var serialItem = this.getSerialListItem;
	      return serialItem && serialItem.additional_data ? serialItem.additional_data : '';
	    },
	    shouldShowEmploymentSelection: function shouldShowEmploymentSelection() {
	      return this.isAbsenceIntegrationActive && this.selectedReason && (this.selectedReason.kmd_absence_code_id && this.isOpusAbsenceActivated || this.selectedReason.sd_absence_code_id && this.isSDIntegrationActive);
	    },
	    isEmploymentSelected: function isEmploymentSelected() {
	      if (!this.shouldShowEmploymentSelection) {
	        return true;
	      }
	      return this.selectedEmploymentId && this.selectedEmploymentId !== '';
	    },
	    isAdditionalDataRequired: function isAdditionalDataRequired() {
	      return this.getOPUSAbsence && this.getOPUSAbsence.additional_data_required;
	    },
	    isAdditionalDataSelected: function isAdditionalDataSelected() {
	      if (!this.isAdditionalDataRequired) {
	        return true;
	      }
	      return this.selectedAdditionalData !== '';
	    },
	    isOpusAllowOpen: function isOpusAllowOpen() {
	      if (!this.isOpusAbsenceActivated || !this.selectedReason || !this.selectedReason.kmd_absence_code_id) {
	        return true;
	      }
	      var opusAbsence = this.getOPUSAbsence;
	      if (!opusAbsence || typeof opusAbsence.allow_open === 'undefined') {
	        return true;
	      }
	      return opusAbsence.allow_open === true;
	    },
	    startDateFormatted: function startDateFormatted() {
	      return this.datePickerStart ? (0, _moment2.default)(this.datePickerStart).format('DD-MM-YYYY') : '';
	    },
	    dateRangeFormatted: function dateRangeFormatted() {
	      if (!this.datePickerStart || !this.datePickerEnd) return '';
	      return (0, _moment2.default)(this.datePickerStart).format('DD-MM-YYYY') + ' - ' + (0, _moment2.default)(this.datePickerEnd).format('DD-MM-YYYY');
	    },
	    dateRangeDaysFormatted: function dateRangeDaysFormatted() {
	      if (!this.datePickerStart || !this.datePickerEnd) return '';
	      var days = (0, _moment2.default)(this.datePickerEnd).diff((0, _moment2.default)(this.datePickerStart), 'days') + 1;
	      return days + (days === 1 ? ' dag' : ' dage');
	    },
	    timeRangeHoursFormatted: function timeRangeHoursFormatted() {
	      var diff = (0, _moment2.default)(this.endTime).diff((0, _moment2.default)(this.startTime), 'minutes');
	      var hours = (diff / 60).toFixed(1);
	      return hours + ' timer';
	    },
	    userEmployments: function userEmployments() {
	      var user = this.showUser;
	      if (!user || !user.id) {
	        return [];
	      }
	      var employments = this.employmentsInUserIdHash[user.id] || [];
	      return employments.filter(function (emp) {
	        return emp.employment_number && String(emp.employment_number).trim() !== '';
	      });
	    },
	    originalStart: function originalStart() {
	      return (0, _moment2.default)(this.originalStartAndEnd[0]).format('YYYY-MM-DD');
	    },
	    originalEnd: function originalEnd() {
	      return (0, _moment2.default)(this.originalStartAndEnd[1]).format('YYYY-MM-DD');
	    },
	    originalDatesArr: function originalDatesArr() {
	      return this.enumerateDaysBetweenDates(this.originalStart, this.originalEnd);
	    },
	    datePickerDatesArr: function datePickerDatesArr() {
	      var start = (0, _moment2.default)(this.datePickerStart).format('YYYY-MM-DD');
	      var end = (0, _moment2.default)(this.datePickerEnd).format('YYYY-MM-DD');
	      return this.enumerateDaysBetweenDates(start, end);
	    },
	    originalDatesNotInNewRange: function originalDatesNotInNewRange() {
	      var _this = this;
	
	      return this.originalDatesArr.filter(function (e) {
	        return _this.datePickerDatesArr.indexOf(e) === -1;
	      });
	    },
	    originalDatesNotInNewRangeMinimum: function originalDatesNotInNewRangeMinimum() {
	      var moments = this.originalDatesNotInNewRange.map(function (d) {
	        return (0, _moment2.default)(d);
	      });
	      var date = _moment2.default.min(moments);
	      var datepickerStart = (0, _moment2.default)(this.datePickerStart).format('YYYY-MM-DD');
	      if (this.datePickerStart) {
	        return (0, _moment2.default)(date).isBefore(this.datePickerStart) ? [date, (0, _moment2.default)(datepickerStart).subtract(1, 'day')] : false;
	      } else {
	        return false;
	      }
	    },
	    originalDatesNotInNewRangeMaximum: function originalDatesNotInNewRangeMaximum() {
	      var moments = this.originalDatesNotInNewRange.map(function (d) {
	        return (0, _moment2.default)(d);
	      });
	      var date = _moment2.default.max(moments);
	      var datepickerEnd = (0, _moment2.default)(this.datePickerEnd).format('YYYY-MM-DD');
	      return (0, _moment2.default)(date).isAfter(this.datePickerEnd) ? [(0, _moment2.default)(datepickerEnd).add(1, 'day'), date] : false;
	    },
	    deleteAbsenceFollowingDates: function deleteAbsenceFollowingDates() {
	      return this.originalDatesNotInNewRange;
	    },
	    getSerialListItem: function getSerialListItem() {
	      return this.activeAbsenceReason.event_serial_id ? this.longAbsentListInHash[this.activeAbsenceReason.event_serial_id] : false;
	    },
	    sdFravaerRows: function sdFravaerRows() {
	      var serialItem = this.getSerialListItem;
	      if (serialItem && Array.isArray(serialItem.sd_fravaer)) return serialItem.sd_fravaer;
	      return this.sdFravaerForSerial || [];
	    },
	    hasSdFravaer: function hasSdFravaer() {
	      return this.sdFravaerRows.length > 0;
	    },
	    hasSentSdFravaer: function hasSentSdFravaer() {
	      return this.sdFravaerRows.some(function (row) {
	        return row.state !== 'draft';
	      });
	    },
	    hasDraftSdFravaer: function hasDraftSdFravaer() {
	      return this.sdFravaerRows.some(function (row) {
	        return row.state === 'draft';
	      });
	    },
	    isReasonChangedAwayFromSd: function isReasonChangedAwayFromSd() {
	      if (!this.hasReasonBeenChanged || !this.hasDraftSdFravaer) return false;
	      return !(this.selectedReason && this.selectedReason.sd_absence_code_id);
	    },
	    isOngoing: function isOngoing() {
	      return this.getSerialListItem && this.getSerialListItem.ongoing;
	    },
	    isOngoingAbsenceAllowed: function isOngoingAbsenceAllowed() {
	      var endDate = (0, _moment2.default)(this.startAndEnd[1]).format('YYYY-MM-DD');
	      var now = (0, _moment2.default)().format('YYYY-MM-DD');
	      return (0, _moment2.default)(endDate).isSameOrAfter(now);
	    }
	  }),
	  watch: {
	    isActiveAbsenceReasonIsReadyToDelete: function isActiveAbsenceReasonIsReadyToDelete() {
	      if (this.isActiveAbsenceReasonIsReadyToDelete) {
	        this.datePickerStart = null;
	        this.datePickerEnd = null;
	      }
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      var _this2 = this;
	
	      if (this.shouldShowEmploymentSelection) {
	        this.$nextTick(function () {
	          _this2.autoSelectSingleEmployment();
	        });
	      }
	    },
	    isShowSalaryInfoBox: function isShowSalaryInfoBox(newValue) {
	      var _this3 = this;
	
	      if (newValue) {
	        this.isLoadedSalarySystemInfo = false;
	        setTimeout(function () {
	          _this3.isLoadedSalarySystemInfo = true;
	        }, 350);
	      } else {
	        this.isLoadedSalarySystemInfo = false;
	      }
	    },
	    isShowExtraInformation: function isShowExtraInformation(newValue) {
	      if (newValue) {
	        this.fetchAdditionalDataForAbsence();
	      } else {
	        this.additionalDataOptions = [];
	        this.selectedAdditionalData = '';
	        this.hasLoadedAdditionalData = false;
	        this.additionalDataError = null;
	      }
	    }
	  },
	  methods: {
	    formatDate: function formatDate(date) {
	      return (0, _moment2.default)(date).format('ll');
	    },
	    getIsAbsenceMultipleDays: function getIsAbsenceMultipleDays() {
	      var serialItem = this.getSerialListItem;
	      return serialItem && (0, _moment2.default)(serialItem.from_date).format('YYYY-MM-DD') !== (0, _moment2.default)(serialItem.to_date).format('YYYY-MM-DD');
	    },
	    setDeleteSubs: function setDeleteSubs(val) {
	      this.eventsToRemovedSubs = val;
	    },
	    enumerateDaysBetweenDates: function enumerateDaysBetweenDates(startDate, endDate) {
	      var date = [];
	      while ((0, _moment2.default)(startDate) <= (0, _moment2.default)(endDate)) {
	        date.push(startDate);
	        startDate = (0, _moment2.default)(startDate).add(1, 'days').format('YYYY-MM-DD');
	      }
	      return date;
	    },
	    getReasonTitle: function getReasonTitle(reason) {
	      var idx = this.absenceReasons.findIndex(function (absenceSubject) {
	        return absenceSubject.id === reason.subject_id;
	      });
	      return idx > -1 ? this.absenceReasons[idx].name : '';
	    },
	    removeSubsAndUpdateAbsence: function removeSubsAndUpdateAbsence() {
	      var vuexObj = {
	        events: this.eventsToRemovedSubs,
	        userId: this.showUser.id,
	        user_calendar_id: this.activeAbsenceReason.calendar_id
	      };
	      this.$store.dispatch('removeSubsFromEvents', vuexObj);
	      this.updateDates();
	    },
	    updateDates: function updateDates() {
	      var selectedReason = this.reason && this.reason[0];
	
	      if (this.isShowSalaryInfoBox) {
	        if (this.shouldShowEmploymentSelection && !this.isEmploymentSelected) {
	          this.showErrors = true;
	          return;
	        }
	        if (this.isShowOpusInfoBox && !this.isAdditionalDataSelected) {
	          this.showErrors = true;
	          this.additionalDataValidationError = 'Du skal vælge ekstra information';
	          return;
	        }
	      }
	      var obj = JSON.parse((0, _stringify2.default)(this.activeAbsenceReason));
	      obj['from_date'] = this.datePickerStart;
	      obj['to_date'] = this.datePickerEnd;
	      obj['ongoing'] = this.isAbsenceOngoing;
	      obj['to_time'] = this.endTime;
	      obj['from_time'] = this.startTime;
	      obj['use_time'] = this.useTime;
	      obj['subject_id'] = selectedReason ? selectedReason.id : this.activeAbsenceReason.subject_id;
	      obj['internal_note'] = this.activeAbsenceReason.internal_note || '';
	
	      if (this.isShowSalaryInfoBox && this.selectedEmploymentId) {
	        obj['employment_id'] = this.selectedEmploymentId;
	      } else {
	        obj['employment_id'] = this.activeAbsenceReason.employment_id || null;
	      }
	      obj['additional_data'] = this.isShowExtraInformation ? this.selectedAdditionalData || null : null;
	      console.log('updateEventsSerial', obj);
	      this.$store.dispatch('updateEventsSerial', obj);
	      this.close();
	    },
	    close: function close() {
	      this.$store.commit('setActiveAbsenceReason', null);
	      this.$store.commit('setIsActiveAbsenceReasonIsReadyToDelete', false);
	    },
	    removeSubsAndDeleteAbsence: function removeSubsAndDeleteAbsence() {
	      var obj = {
	        events: this.eventsToRemovedSubs,
	        userId: this.showUser.id,
	        user_calendar_id: this.activeAbsenceReason.calendar_id
	      };
	      this.$store.dispatch('removeSubsFromEvents', obj);
	      var reasonObj = {
	        event_serial_id: this.activeAbsenceReason.event_serial_id,
	        user_calendar_id: this.activeAbsenceReason.calendar_id,
	        id: this.activeAbsenceReason.id
	      };
	      this.$store.dispatch('deleteAbsence', reasonObj);
	      this.closeSchedulerPopover();
	      this.close();
	    },
	    setStartDate: function setStartDate(payload) {
	      this.datePickerStart = (0, _moment2.default)(payload).format('YYYY-MM-DD');
	      this.setStartAndEnd();
	    },
	    setEndDate: function setEndDate(payload) {
	      var newEnd = (0, _moment2.default)(payload).format('YYYY-MM-DD');
	      var previousEnd = this.datePickerEnd;
	      this.datePickerEnd = newEnd;
	      this.setStartAndEnd();
	
	      var now = (0, _moment2.default)().format('YYYY-MM-DD');
	      if (previousEnd && newEnd !== previousEnd && !(0, _moment2.default)(newEnd).isAfter(now)) {
	        this.isAbsenceOngoing = false;
	      }
	    },
	    setStartTime: function setStartTime(payload) {
	      this.startTime = payload;
	      this.syncWholeDayWithStandardTimes();
	    },
	    setEndTime: function setEndTime(payload) {
	      this.endTime = payload;
	      this.syncWholeDayWithStandardTimes();
	    },
	    syncWholeDayWithStandardTimes: function syncWholeDayWithStandardTimes() {
	      var userSettings = this.$store.state.userSettings;
	      var saved = userSettings && userSettings.subSettingsCreateTime;
	      var standardStart = saved ? (0, _moment2.default)(saved.start).format('HH:mm') : '08:00';
	      var standardEnd = saved ? (0, _moment2.default)(saved.end).format('HH:mm') : '16:00';
	      var isStandardStart = (0, _moment2.default)(this.startTime).format('HH:mm') === standardStart;
	      var isStandardEnd = (0, _moment2.default)(this.endTime).format('HH:mm') === standardEnd;
	      if (this.wholeDayToastTimer === null) {
	        this.useTimeBeforeTimeEdit = this.useTime;
	      }
	      this.useTime = !(isStandardStart && isStandardEnd);
	      this.notifyWholeDayChange();
	    },
	    notifyWholeDayChange: function notifyWholeDayChange() {
	      var _this4 = this;
	
	      clearTimeout(this.wholeDayToastTimer);
	      this.wholeDayToastTimer = setTimeout(function () {
	        _this4.wholeDayToastTimer = null;
	        if (_this4.isShowSalaryInfoBox && _this4.useTime !== _this4.useTimeBeforeTimeEdit) {
	          _eventbus2.default.toast = { text: _this4.useTime ? '"Indberet som hel dag" er slået fra' : '"Indberet som hel dag" er slået til', success: true };
	        }
	      }, 800);
	    },
	    setStartAndEnd: function setStartAndEnd() {
	      this.startAndEnd = [(0, _moment2.default)(this.datePickerStart).format('YYYY-MM-DD'), (0, _moment2.default)(this.datePickerEnd).format('YYYY-MM-DD')];
	    },
	    setLessonsWithSubs: function setLessonsWithSubs(arr) {
	      this.lessonsWithSubs = arr;
	    },
	    setReason: function setReason(reason) {
	      var _this5 = this;
	
	      this.reason = reason;
	      this.showErrors = false;
	      this.hasReasonBeenChanged = true;
	      this.selectedEmploymentId = '';
	      this.resetOpusFields();
	      var selected = reason && reason[0];
	      var shouldBeOngoing = !!(selected && selected.default_ongoing && this.isOpusAllowOpen && this.isOngoingAbsenceAllowed);
	      if (shouldBeOngoing !== this.isAbsenceOngoing) {
	        this.setIsAbsenceOngoing(shouldBeOngoing);
	      }
	      if (this.shouldShowEmploymentSelection) {
	        this.$nextTick(function () {
	          _this5.autoSelectSingleEmployment();
	        });
	      }
	    },
	    onEmploymentChange: function onEmploymentChange(value) {
	      this.selectedEmploymentId = value;
	    },
	    autoSelectSingleEmployment: function autoSelectSingleEmployment() {
	      if (!this.shouldShowEmploymentSelection) {
	        return;
	      }
	      if (this.selectedEmploymentId) {
	        return;
	      }
	      if (this.userEmployments.length === 1) {
	        this.selectedEmploymentId = this.userEmployments[0].id;
	      }
	    },
	    listKmdOpusAbsenceCodes: function listKmdOpusAbsenceCodes() {
	      var _this6 = this;
	
	      _docendo2.default.listKmdOpusAbsenceCodes(this.schoolId, function (success) {
	        _this6.opusAbsenceCodes = Array.isArray(success) ? success : [];
	      }, function (failure) {
	        _this6.opusAbsenceCodes = [];
	      });
	    },
	    listSdAbsenceCodes: function listSdAbsenceCodes() {
	      var _this7 = this;
	
	      _docendo2.default.listSilkeborgDataAbsenceCodes(this.schoolId, function (success) {
	        _this7.sdAbsenceCodes = Array.isArray(success) ? success : success && Array.isArray(success.data) ? success.data : [];
	      }, function (failure) {
	        _this7.sdAbsenceCodes = [];
	      });
	    },
	    resetOpusFields: function resetOpusFields() {
	      this.useTime = false;
	      this.additionalDataOptions = [];
	      this.selectedAdditionalData = '';
	      this.hasLoadedAdditionalData = false;
	      this.additionalDataError = null;
	      this.additionalDataValidationError = null;
	    },
	    setIsAbsenceOngoing: function setIsAbsenceOngoing(bool) {
	      if (!this.isOpusAllowOpen && bool) {
	        this.isAbsenceOngoing = false;
	        return;
	      }
	      this.isAbsenceOngoing = bool;
	    },
	    fetchAdditionalDataForAbsence: function fetchAdditionalDataForAbsence() {
	      var _this8 = this;
	
	      if (!this.isShowExtraInformation) {
	        this.additionalDataOptions = [];
	        this.selectedAdditionalData = '';
	        return;
	      }
	      var opusAbsence = this.getOPUSAbsence;
	      if (!opusAbsence) return;
	
	      var employmentId = this.selectedEmploymentId;
	      if (!employmentId) return;
	
	      this.isLoadingAdditionalData = true;
	      this.hasLoadedAdditionalData = false;
	      this.additionalDataOptions = [];
	      this.selectedAdditionalData = '';
	
	      _docendo2.default.listAdditionalDataForAbsence(this.schoolId, employmentId, opusAbsence.id, (0, _moment2.default)(this.datePickerStart).format('YYYY-MM-DD'), (0, _moment2.default)(this.datePickerEnd).format('YYYY-MM-DD'), function (response) {
	        if (response && response.success === false) {
	          _this8.additionalDataOptions = [];
	          _this8.additionalDataError = response.data && response.data.error || response.error || 'Der opstod en fejl';
	          _this8.isLoadingAdditionalData = false;
	          _this8.hasLoadedAdditionalData = true;
	          return;
	        }
	        if (response && response.error) {
	          _this8.additionalDataOptions = [];
	          _this8.additionalDataError = response.error;
	          _this8.isLoadingAdditionalData = false;
	          _this8.hasLoadedAdditionalData = true;
	          return;
	        }
	        if (response && response.data && response.data.error) {
	          _this8.additionalDataOptions = [];
	          _this8.additionalDataError = response.data.error;
	          _this8.isLoadingAdditionalData = false;
	          _this8.hasLoadedAdditionalData = true;
	          return;
	        }
	        _this8.additionalDataError = null;
	        var parsedData = response;
	        if (response && response.response && typeof response.response === 'string') {
	          try {
	            parsedData = JSON.parse(response.response);
	          } catch (e) {
	            console.error('Failed to parse response.response', e);
	          }
	        }
	        var cases = null;
	        if (parsedData && parsedData.Body) {
	          if (_this8.getOPUSAbsence && _this8.getOPUSAbsence.additional_data === 'Maternity') {
	            cases = parsedData.Body.GetMaternityCasesResponse_MT && parsedData.Body.GetMaternityCasesResponse_MT.MaternityCase;
	          } else if (_this8.getOPUSAbsence && _this8.getOPUSAbsence.additional_data === 'Reason') {
	            var reasonsResponse = parsedData.Body.GetReasonsResponse_MT || parsedData.Body.GetReasonsResponse_RT;
	            cases = reasonsResponse && reasonsResponse.Reason;
	          } else if (_this8.getOPUSAbsence && _this8.getOPUSAbsence.additional_data === 'WorkInjury') {
	            cases = parsedData.Body.GetWorkAccidentCasesResponse_MT && parsedData.Body.GetWorkAccidentCasesResponse_MT.AccidentCase;
	          } else if (_this8.getOPUSAbsence && _this8.getOPUSAbsence.additional_data === 'Child') {
	            cases = parsedData.Body.GetChildrenResponse_MT && parsedData.Body.GetChildrenResponse_MT.Child;
	          }
	        }
	        if (Array.isArray(cases)) {
	          _this8.additionalDataOptions = cases;
	        } else if (cases && cases.Item) {
	          _this8.additionalDataOptions = Array.isArray(cases.Item) ? cases.Item : [cases.Item];
	        } else if (cases && (typeof cases === 'undefined' ? 'undefined' : (0, _typeof3.default)(cases)) === 'object') {
	          _this8.additionalDataOptions = [cases];
	        } else {
	          _this8.additionalDataOptions = [];
	        }
	        _this8.selectAdditionalDataAfterFetch();
	        _this8.isLoadingAdditionalData = false;
	        _this8.hasLoadedAdditionalData = true;
	      }, function (error) {
	        console.error('fetchAdditionalDataForAbsence error', error);
	        _this8.additionalDataOptions = [];
	        if (error && error.data && error.data.error) {
	          _this8.additionalDataError = error.data.error;
	        } else if (error && error.error) {
	          _this8.additionalDataError = error.error;
	        } else {
	          _this8.additionalDataError = 'Der opstod en fejl ved hentning af data';
	        }
	        _this8.isLoadingAdditionalData = false;
	        _this8.hasLoadedAdditionalData = true;
	      });
	    },
	    selectAdditionalDataAfterFetch: function selectAdditionalDataAfterFetch() {
	      var existing = this.existingAdditionalData;
	      if (existing) {
	        this.selectedAdditionalData = existing;
	        return;
	      }
	      if (this.additionalDataOptions.length !== 1) return;
	      var singleOption = this.additionalDataOptions[0];
	      var additionalDataType = this.getOPUSAbsence && this.getOPUSAbsence.additional_data;
	      if (additionalDataType === 'Maternity' && singleOption.MaternityCaseKey) {
	        this.selectedAdditionalData = singleOption.MaternityCaseKey;
	      } else if (additionalDataType === 'Reason' && singleOption.ReasonCode) {
	        this.selectedAdditionalData = singleOption.ReasonCode;
	      } else if (additionalDataType === 'WorkInjury' && singleOption.AccidentNumber) {
	        this.selectedAdditionalData = singleOption.AccidentNumber;
	      } else if (additionalDataType === 'Child' && singleOption.ChildNumber) {
	        this.selectedAdditionalData = singleOption.ChildNumber;
	      }
	    },
	    closeSchedulerPopover: function closeSchedulerPopover() {
	      this.$store.commit('setActiveUser', null);
	      this.$store.commit('setActiveEvent', null);
	      this.$store.dispatch('setActiveSchedulerEvent', {
	        'left': -10,
	        'right': -10,
	        'color': '',
	        'oldSubScoreMeta': [],
	        'obj': null
	      });
	    },
	    initFromAbsenceReason: function initFromAbsenceReason() {
	      var _this9 = this;
	
	      if (!this.activeAbsenceReason) return;
	      var startTime = this.getSerialListItem ? this.getSerialListItem.from_time : this.activeAbsenceReason.start;
	      this.startTime = (0, _moment2.default)(startTime).locale('LT');
	      var endTime = this.getSerialListItem ? this.getSerialListItem.to_time : this.activeAbsenceReason.end;
	      this.endTime = (0, _moment2.default)(endTime).locale('LT');
	      var idx = this.absenceReasons.findIndex(function (absenceSubject) {
	        return absenceSubject.id === _this9.activeAbsenceReason.subject_id;
	      });
	      if (idx > -1) {
	        this.reason = [this.absenceReasons[idx]];
	      }
	      if (this.activeAbsenceReason.event_serial_id) {
	        var reason = this.longAbsentListInHash[this.activeAbsenceReason.event_serial_id];
	        if (reason) {
	          this.originalStartAndEnd = [reason.from_date, reason.to_date];
	          this.isAbsenceOngoing = reason.ongoing;
	        }
	      } else if (this.activeAbsenceReason.from_date) {
	        this.originalStartAndEnd = [new Date(this.activeAbsenceReason.from_date), new Date(this.activeAbsenceReason.to_date)];
	      } else {
	        this.originalStartAndEnd = [this.activeAbsenceReason.start, this.activeAbsenceReason.end];
	      }
	
	      var employmentId = this.activeAbsenceReason.employment_id || this.getSerialListItem && this.getSerialListItem.employment_id;
	      if (employmentId) {
	        this.selectedEmploymentId = employmentId;
	      }
	      var serialItem = this.getSerialListItem;
	      this.useTime = !!(serialItem && serialItem.use_time);
	      if (this.isAbsenceIntegrationActive) {
	        this.$store.dispatch('readEmployments');
	        this.listKmdOpusAbsenceCodes();
	      }
	      if (this.isSDIntegrationActive) {
	        this.listSdAbsenceCodes();
	        this.readSdFravaerForSerial();
	      }
	    },
	    readSdFravaerForSerial: function readSdFravaerForSerial() {
	      var _this10 = this;
	
	      var serialId = this.activeAbsenceReason && this.activeAbsenceReason.event_serial_id;
	      if (!serialId || !this.schoolId) return;
	      var serialItem = this.getSerialListItem;
	      if (serialItem && Array.isArray(serialItem.sd_fravaer)) return;
	
	      var start = (0, _moment2.default)(serialItem && serialItem.from_date ? serialItem.from_date : undefined).subtract(1, 'year').format('YYYY-MM-DD');
	      var end = (0, _moment2.default)(serialItem && serialItem.to_date ? serialItem.to_date : undefined).add(1, 'year').format('YYYY-MM-DD');
	      _docendo2.default.listSilkeborgDataFravaer(this.schoolId, start, end, function (success) {
	        var rows = Array.isArray(success) ? success : success && Array.isArray(success.data) ? success.data : [];
	        _this10.sdFravaerForSerial = rows.filter(function (row) {
	          return row.event_serial_id === serialId;
	        });
	      }, function (failure) {
	        console.log('listSilkeborgDataFravaer failure', failure);
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.initFromAbsenceReason();
	  }
	};

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TimeChanger = __webpack_require__(31);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _AppModal = __webpack_require__(104);
	
	var _AppModal2 = _interopRequireDefault(_AppModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppModal: _AppModal2.default, TimeChanger: _TimeChanger2.default },
	  props: {
	    lesson: {
	      type: Object
	    }
	  },
	  filters: {
	    showDate: function showDate(dateTime) {
	      return (0, _moment2.default)(dateTime).format('dddd, D. MMM');
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    oldDuration: function oldDuration() {
	      var duration = _moment2.default.duration((0, _moment2.default)(this.lesson.end).diff(this.lesson.start));
	      return duration.asMinutes();
	    },
	    newDuration: function newDuration() {
	      var duration = _moment2.default.duration((0, _moment2.default)(this.updatedEndTime).diff(this.updatedStartTime));
	      return duration.asMinutes();
	    }
	  },
	  data: function data() {
	    return {
	      i18n: {
	        da: {
	          edit_times: 'Rediger tider på',
	          current_times: 'Nuværende tider',
	          new_times: 'Nye tider',
	          duration: 'Varighed',
	          minutes: 'minutter',
	          btn: 'Gem tider'
	        },
	        nb: {
	          edit_times: 'Rediger tider på',
	          current_times: 'Nåværende tider',
	          new_times: 'Nye tider',
	          duration: 'Lengde',
	          minutes: 'minutter',
	          btn: 'Lagre tider'
	        },
	        en: {
	          edit_times: 'Edit times on',
	          current_times: 'Current times',
	          new_times: 'New times',
	          duration: 'Duration',
	          minutes: 'minutes',
	          btn: 'Save times'
	        }
	      },
	      showModal: true,
	      updatedStartTime: this.lesson.start,
	      updatedEndTime: this.lesson.end,
	      isSubmitting: false
	    };
	  },
	
	  methods: {
	    updateStartTime: function updateStartTime(time) {
	      this.updatedStartTime = (0, _moment2.default)(this.lesson.start).hours((0, _moment2.default)(time).hours()).minutes((0, _moment2.default)(time).minutes());
	    },
	    updateEndTime: function updateEndTime(time) {
	      this.updatedEndTime = (0, _moment2.default)(this.lesson.end).hours((0, _moment2.default)(time).hours()).minutes((0, _moment2.default)(time).minutes());
	    },
	    submit: function submit() {
	      var _this = this;
	
	      if (this.isSubmitting) return;
	      this.isSubmitting = true;
	      var updates = [{
	        event_id: this.lesson.id,
	        start_time: (0, _moment2.default)(this.updatedStartTime).toISOString(),
	        end_time: (0, _moment2.default)(this.updatedEndTime).toISOString()
	      }];
	      _docendo2.default.updateEvents(this.lesson.school_id, updates, function (success) {
	        _this.isSubmitting = false;
	        _this.$emit('updated');
	        _this.showModal = false;
	      }, function (failure) {
	        console.log('failure', failure);
	        _this.isSubmitting = false;
	      });
	    },
	    closeModal: function closeModal() {
	      this.$emit('close');
	      this.showModal = false;
	    }
	  }
	};

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TimeInput = __webpack_require__(107);
	
	var _TimeInput2 = _interopRequireDefault(_TimeInput);
	
	var _AppModal = __webpack_require__(104);
	
	var _AppModal2 = _interopRequireDefault(_AppModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	
	exports.default = {
	  components: { AppModal: _AppModal2.default, timeInput: _TimeInput2.default },
	  props: {
	    user: {
	      type: Object
	    },
	    lesson: {
	      type: Object
	    }
	  },
	  filters: {
	    LT: function LT(dateTime) {
	      return moment(dateTime).format('LT');
	    },
	    showDate: function showDate(dateTime) {
	      return moment(dateTime).format('dddd, D. MMM');
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    newCurrentLessonEnd: function newCurrentLessonEnd() {
	      return moment(this.newLessonStart);
	    },
	    oldDuration: function oldDuration() {
	      var duration = moment.duration(moment(this.lesson.end).diff(this.lesson.start));
	      return duration.asMinutes();
	    },
	    newLessonDuration: function newLessonDuration() {
	      var duration = moment.duration(moment(this.lesson.end).diff(this.newLessonStart));
	      return duration.asMinutes();
	    },
	    lessonDuration: function lessonDuration() {
	      var duration = moment.duration(this.newCurrentLessonEnd.diff(this.lesson.start));
	      return duration.asMinutes();
	    }
	  },
	  data: function data() {
	    return {
	      i18n: {
	        da: {
	          split: 'Opdel',
	          original_lesson: 'Nuværende lektion',
	          duration: 'Varighed',
	          minutes: 'minutter',
	          when_is_the_split: 'På hvilket tidspunkt vil du dele lektion i to?',
	          everything_will_be_cloned: 'Alt ved den oprindelige brik bliver kopieret dvs. undervisere, vikarer, noter osv.',
	          split_lessons: 'Lektionen vil så blive delt til flg. lektioner: ',
	          btn: 'Opdel lektion'
	        },
	        nb: {
	          split: 'Del opp',
	          original_lesson: 'Nåværende time',
	          duration: 'Lengde',
	          minutes: 'minutter',
	          when_is_the_split: 'På hvilket tidspunkt skal timen deles i to?',
	          everything_will_be_cloned: 'Alt i den opprinnelige timen blir kopiert dvs. undervisere, vikarer, notater osv.',
	          split_lessons: 'Timen vil så bli delt opp til følgende timer: ',
	          btn: 'Del opp timen'
	        },
	        en: {
	          split: 'Split',
	          original_lesson: 'Original lesson',
	          duration: 'Duration',
	          minutes: 'minutes',
	          when_is_the_split: 'At what time should the lesson be split in two?',
	          everything_will_be_cloned: 'All information from the original lesson will be copied i.e. teachers, substitutes, notes etc.',
	          split_lessons: 'The lesson will be divided into the following lessons:',
	          btn: 'Split lesson'
	        }
	      },
	      showModal: true,
	      newLessonStart: 8,
	      newLessonEnd: this.lesson.end,
	      isSubmitting: false
	    };
	  },
	
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      this.isSubmitting = true;
	      _docendo2.default.splitEvent(this.lesson.id, moment(this.newLessonStart).toISOString(), function (data) {
	        JSON.parse(data).forEach(function (lesson) {
	          _this.allEventsInAHash[lesson.id] ? _this.$store.commit('updateEventOnAllEventsInAHash', lesson) : _this.$store.commit('addANewEvent', lesson);
	        });
	        _this.isSubmitting = false;
	        _this.$emit('submitted');
	        _this.showModal = false;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    closeModal: function closeModal() {
	      this.$emit('closeSplitEvent');
	      this.showModal = false;
	    },
	    setStartTime: function setStartTime(val) {
	      var number = moment(val, 'LT');
	      if (isNaN(number)) {
	        this.newLessonStart = this.newLessonStart;
	        return;
	      } else {
	        var hours = moment(number).format('HH');
	        var minutes = Math.round(moment(number).format('mm') / 5) * 5;
	        var _newDate = moment(this.newLessonStart).set({ 'hour': hours, 'minute': minutes });
	        if (hours * 1 === 23 && minutes * 1 === 55) {
	          _newDate = moment(this.newLessonStart).set({ 'hour': hours, 'minute': 50 });
	        }
	
	        if (moment(_newDate).isSameOrBefore(this.lesson.start)) {
	          this.newLessonStart = this.newLessonStart;
	          return;
	        }
	        if (moment(_newDate).isSameOrAfter(this.lesson.end)) {
	          this.newLessonStart = this.newLessonStart;
	          return;
	        }
	        this.newLessonStart = _newDate;
	      }
	    },
	    createInitialSplit: function createInitialSplit() {
	      var start = this.lesson.start;
	      var end = this.lesson.end;
	      var diffInMinutes = moment(end).diff(moment(start), 'minutes');
	
	      var minutes = Math.round(diffInMinutes / 2 / 5) * 5;
	      this.newLessonStart = moment(this.lesson.end).subtract(minutes, 'minutes');
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.createInitialSplit();
	  },
	  created: function created() {
	    this.$nextTick(function () {
	      document.getElementById('focus').focus();
	    });
	  }
	};

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppEIPWYZIWYG = __webpack_require__(55);
	
	var _AppEIPWYZIWYG2 = _interopRequireDefault(_AppEIPWYZIWYG);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppEIPWYZIWYG: _AppEIPWYZIWYG2.default },
	  props: {
	    date: {}
	  },
	  data: function data() {
	    return {
	      isOpen: false,
	      noteText: ''
	    };
	  },
	
	  watch: {
	    date: function date(val) {
	      this.readNoteText();
	    }
	  },
	  computed: {
	    showDate: function showDate() {
	      return (0, _moment2.default)(this.date).locale(window.USER.locale).format('dddd DD. MMMM YYYY');
	    },
	    serverDate: function serverDate() {
	      return (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	    }
	  },
	  methods: {
	    readNoteText: function readNoteText() {
	      var _this = this;
	
	      _docendo2.default.schoolSubstituteDayNoteRead(window.SCHOOL.id, this.serverDate, function (data) {
	        _this.noteText = data.note ? data.note : '';
	      });
	    },
	    updateNoteText: function updateNoteText(updatedText) {
	      var _this2 = this;
	
	      _docendo2.default.schoolSubstituteDayNoteUpdate(window.SCHOOL.id, this.serverDate, updatedText.text, function (success) {
	        _this2.noteText = success.note;
	      }, function (failure) {
	        console.log('failed!');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readNoteText();
	  }
	};

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(35);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(50);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SubsUserAbsenceReason = __webpack_require__(101);
	
	var _SubsUserAbsenceReason2 = _interopRequireDefault(_SubsUserAbsenceReason);
	
	var _DSelectSubsSub = __webpack_require__(1498);
	
	var _DSelectSubsSub2 = _interopRequireDefault(_DSelectSubsSub);
	
	var _AppEIPWYZIWYG = __webpack_require__(55);
	
	var _AppEIPWYZIWYG2 = _interopRequireDefault(_AppEIPWYZIWYG);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _hiddenAbsenceTitle = __webpack_require__(110);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(39);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	var I18N = {
	  da: {
	    subject: 'Fag',
	    class: 'Klasse',
	    other_users: 'I samme tidsrum',
	    substitute: 'Vikar',
	    substitute_notes: 'Vikarnoter',
	    todays_lessons: 'Dagens lektioner',
	    see_all: 'Se alle',
	    see_less: 'Se færre',
	    search: 'Søg på person',
	    multiple_days: 'Flere dage',
	    lessons_on_day: 'Lektioner på dagen',
	    lessons_affected_by_absence: 'Lektioner påvirket af fravær',
	    absent: 'Fraværende',
	    reason: 'Årsag',
	    absent_period: 'Fraværsperiode',
	    note: 'Note',
	    split_lesson: 'Opdel lektion',
	    same_time: 'I samme tidsrum',
	    on_the_lesson: 'Underviser',
	    same_time_in_class: 'Samtidig i klassen',
	    view_all: 'Se alle',
	    view_less: 'Se færre',
	    view_all_lessons: 'Se alle lektioner',
	    view_less_lessons: 'Se færre lektioner',
	    log: 'Historik',
	    user_not_found: 'Brugeren er fjernet fra skolen',
	    absent_handled: 'Håndteret',
	    ongoing_absence: 'Løbende fravær',
	    auto_created: 'Oprettet Automatisk',
	    see_calendar: 'Se kalender',
	    add_sub_to_multiple_lessons: 'Vikardæk flere lektioner'
	  },
	  en: {
	    subject: 'Subject',
	    class: 'Class',
	    other_users: 'Other users',
	    substitute: 'Substitute',
	    substitute_notes: 'Substitute notes',
	    todays_lessons: 'Todays lessons',
	    see_all: 'View all',
	    see_less: 'View less',
	    search: 'Search',
	    multiple_days: 'Multiple days',
	    lessons_on_day: 'Lessons this day',
	    lessons_affected_by_absence: 'Lessons affected by absence',
	    absent: 'Absent',
	    reason: 'Reason',
	    absent_period: 'Period of absence',
	    note: 'Note',
	    note_for_absent: 'Note for absent',
	    split_lesson: 'Split lesson in two',
	    same_time: 'At the same time',
	    on_the_lesson: 'Teachers',
	    same_time_in_class: 'In the same class',
	    view_all: 'View all',
	    view_less: 'View less',
	    view_all_lessons: 'View all lessons',
	    view_less_lessons: 'View fewer lessons',
	    log: 'Activity log',
	    user_not_found: 'User is removed from school',
	    absent_handled: 'Covered',
	    ongoing_absence: 'Ongoing absence',
	    auto_created: 'Autogenerated',
	    see_calendar: 'See calendar',
	    add_sub_to_multiple_lessons: 'Add substitute to multiple lessons'
	  },
	  nb: {
	    subject: 'Fag',
	    class: 'Klasse',
	    other_users: 'Også tilknyttet',
	    substitute: 'Vikar',
	    substitute_notes: 'Vikarnotater',
	    todays_lessons: 'Dagens timer',
	    see_all: 'Se alle',
	    see_less: 'Se mindre',
	    search: 'Søk etter person',
	    multiple_days: 'Flere dager',
	    lessons_on_day: 'Undervisningstimer denne dag',
	    lessons_affected_by_absence: 'Timer påvirket av fravær',
	    absent: 'Fraværende',
	    reason: 'Årsak',
	    absent_period: 'Fraværsperiode',
	    note: 'Notat',
	    note_for_absent: 'Eventuell notat til fraværet',
	    split_lesson: 'Del opp timen',
	    same_time: 'I samme tidsrom',
	    on_the_lesson: 'Undervisere',
	    same_time_in_class: 'Samtidig i klassen',
	    view_all: 'Se alle',
	    view_less: 'Se færre',
	    view_all_lessons: 'Se alle timer',
	    view_less_lessons: 'Se færre timer',
	    log: 'Historikk',
	    user_not_found: 'Brukeren er fjernet fra skolen',
	    absent_handled: 'Håndtert',
	    ongoing_absence: 'Løpende lengre fravær',
	    auto_created: 'Opprettet automatisk',
	    see_calendar: 'Se kalender',
	    add_sub_to_multiple_lessons: 'Legg til vikar for flere leksjoner'
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { DDropdown: _DDropdown2.default, DSelectSub: _DSelectSubsSub2.default, weip: _AppEIPWYZIWYG2.default, AbsenceReason: _SubsUserAbsenceReason2.default },
	  props: {
	    user: {},
	    activeDSelect: {
	      type: String,
	      default: null
	    },
	    allEvents: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    allEventsInAHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    allUsersAndEvents: {
	      type: Object,
	      default: function _default() {}
	    },
	    allCalendarsInAHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    allUsersSortedOnName: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    longAbsentListInHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    date: {
	      type: [Object, String],
	      default: function _default() {
	        return moment();
	      }
	    },
	    calsAndEventIds: {
	      type: Object,
	      default: function _default() {}
	    },
	    absentUsersHandledHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    isSubStatusPendingActive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isSubmittingAbsenceStatus: false,
	      activeEIP: [],
	      showOtherOnLesson: -1,
	      showDSub: -1,
	      searchText: '',
	      occupiedUsers: [],
	      usersForDSelect: [],
	      subStatusDropdown: null,
	      isUpdatingPotentialSubs: false,
	      theActiveShowAllOtherOnLessonId: null,
	      theActiveShowOtherLessonsInKlassThatOverlap: null,
	      theActiveOtherLessonShowAllUsers: null,
	      theLoadingLessons: []
	    };
	  },
	
	  watch: {
	    date: function date() {
	      this.resetAllFormData();
	    }
	  },
	  computed: {
	    i18n: function i18n() {
	      return I18N;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    userLessons: function userLessons() {
	      var _this = this;
	
	      return this.user.dayEvents.map(function (eventId) {
	        return _this.allEventsInAHash[eventId];
	      });
	    },
	    countryIsDK: function countryIsDK() {
	      return window.SCHOOL.country === 'DK';
	    },
	    filterAbsentUser: function filterAbsentUser() {
	      var _this2 = this;
	
	      return this.allUsersSortedOnName.filter(function (user) {
	        return user.id !== _this2.user.id;
	      });
	    },
	    sortedEvents: function sortedEvents() {
	      var _this3 = this;
	
	      var absenceRanges = this.absenceReasons.map(function (absence) {
	        return {
	          id: absence.id,
	          range: moment.range(absence.start, absence.end)
	        };
	      });
	
	      return this.userLessons.map(function (lesson) {
	        var lessonRange = moment.range(lesson.start, lesson.end);
	
	        var isOverlapping = absenceRanges.some(function (absence) {
	          return lessonRange.intersect(absence.range);
	        });
	
	        var klassesAndOther = [];
	        var calEvents = lesson.calendar_events;
	        for (var i = 0; i < calEvents.length; i++) {
	          var cal = calEvents[i];
	          if (cal && (cal.calendar_type === 'klass' || cal.calendar_type === 'other')) {
	            klassesAndOther.push((0, _extends3.default)({}, cal, {
	              url: window.location.origin + '/calendars/' + cal.calendar_id
	            }));
	          }
	        }
	
	        var others = [];
	        for (var _i = 0; _i < calEvents.length; _i++) {
	          var calEvent = calEvents[_i];
	          if (_this3.allUsersAndEvents[calEvent.calendar_id] && !calEvent.substitute && calEvent.calendar_id !== _this3.user.user_calendar_id) {
	            var user = _this3.allUsersAndEvents[calEvent.calendar_id];
	            others.push((0, _extends3.default)({}, user, {
	              v_isUserAbsentFromLesson: _this3.doesAbsenceOverlapLesson(lesson.id, user.dayAbsence)
	            }));
	          }
	        }
	
	        var subs = [];
	        for (var _i2 = 0; _i2 < calEvents.length; _i2++) {
	          var event = calEvents[_i2];
	          if (event.substitute && event.substitute_for_user_id === _this3.user.id) {
	            var subUser = _this3.allUsersAndEvents[event.calendar_id];
	            subs.push(subUser || _this3.userNotFoundPlaceholder);
	          }
	        }
	
	        return (0, _extends3.default)({}, lesson, {
	          v_substituted: _this3.getIsUserSubstituted(lesson),
	          v_status: _this3.getSubstitutionStatusForUserCalId(lesson),
	          v_isLoading: _this3.theLoadingLessons.indexOf(lesson.id) > -1,
	          v_isOverlapping: isOverlapping,
	          v_others: others,
	          v_subs: subs,
	          showAllOtherOnLesson: lesson.id === _this3.theActiveShowAllOtherOnLessonId,
	          klassesAndOther: klassesAndOther,
	          otherLessonsInKlassThatOverlap: _this3.otherLessonsInKlassThatOverlap(lesson),
	          showOtherLessonsInKlassThatOverlap: lesson.id === _this3.theActiveShowOtherLessonsInKlassThatOverlap
	        });
	      }).sort(function (a, b) {
	        return moment(a.start).unix() - moment(b.start).unix();
	      });
	    },
	    overlappingArr: function overlappingArr() {
	      return this.sortedEvents.filter(function (lesson) {
	        return lesson.v_isOverlapping;
	      }).map(function (lesson) {
	        return lesson.id;
	      });
	    },
	    absenceReasons: function absenceReasons() {
	      var _this4 = this;
	
	      return this.user.dayAbsence.map(function (eventId) {
	        return _this4.allEventsInAHash[eventId];
	      });
	    },
	    userNotFoundPlaceholder: function userNotFoundPlaceholder() {
	      return {
	        id: 0,
	        name: this.i18n[this.locale]['user_not_found'],
	        type: 'user',
	        url: '/calendar',
	        calendar_id: 0,
	        dayAbsence: [],
	        dayEvents: [],
	        dayAllEvents: [],
	        isErrorUser: true,
	        default_thumb_url: '',
	        user_tags: [],
	        occupied: false,
	        isOnLesson: false,
	        currentEventId: 0,
	        user_calendar_id: 0
	      };
	    }
	  },
	  methods: {
	    showDate: function showDate(date) {
	      return moment(date).format('dddd, D. MMM');
	    },
	    showTime: function showTime(date) {
	      return moment(date).format('LT');
	    },
	    formatDate: function formatDate(date) {
	      return moment(date).format('ll');
	    },
	    absenceDate: function absenceDate(date) {
	      return moment(date).format('DD. MMM, [kl]. LT');
	    },
	    schedulerUserHandledCls: function schedulerUserHandledCls(item) {
	      var userStatus = this.getIsUserAbsentHandled(item);
	      if (userStatus === 0) {
	        return 'dot-white';
	      }
	      if (userStatus === 2) {
	        return 'dot-yellow';
	      }
	    },
	    statusDotClass: function statusDotClass(lesson) {
	      if (lesson.v_status === 2) {
	        return 'dot-yellow';
	      }
	      if (lesson.v_status === 0) {
	        return 'dot-white';
	      }
	    },
	    setOtherLessonShowAllUsers: function setOtherLessonShowAllUsers(lessonId) {
	      this.theActiveOtherLessonShowAllUsers = lessonId;
	    },
	    setShowOtherLessonsInKlassThatOverlap: function setShowOtherLessonsInKlassThatOverlap(lessonId) {
	      this.theActiveShowOtherLessonsInKlassThatOverlap = lessonId;
	    },
	    getIsAbsenceMultipleDays: function getIsAbsenceMultipleDays(reason) {
	      var serialItem = this.getSerialListItem(reason);
	      return serialItem && moment(serialItem.from_date).format('YYYY-MM-DD') !== moment(serialItem.to_date).format('YYYY-MM-DD');
	    },
	    getIsAbsenceAutoGenerated: function getIsAbsenceAutoGenerated(reason) {
	      var statusObj = reason.substitution_status ? JSON.parse(reason.substitution_status) : {};
	      return statusObj['extended_at'] && moment(statusObj['extended_at']).isSame(moment(this.date).format('YYYY-MM-DD'));
	    },
	    setActiveAbsentUser: function setActiveAbsentUser() {
	      this.$store.commit('setActiveAbsentUser', this.user);
	    },
	    setReadyToDelete: function setReadyToDelete(reason) {
	      this.$store.commit('setIsActiveAbsenceReasonIsReadyToDelete', true);
	      this.$store.commit('setActiveAbsenceReason', reason);
	    },
	    showLog: function showLog(event) {
	      this.$emit('showLog', event);
	    },
	    getSubs: function getSubs(lesson) {
	      var _this5 = this;
	
	      var subCalIds = lesson.calendar_events.filter(function (event) {
	        return event.substitute && event.substitute_for_user_id === _this5.user.id;
	      });
	      return subCalIds.map(function (sub) {
	        return _this5.allUsersAndEvents[sub.calendar_id] ? _this5.allUsersAndEvents[sub.calendar_id] : _this5.userNotFoundPlaceholder;
	      });
	    },
	    setSubStatusDropdown: function setSubStatusDropdown(lessonId) {
	      this.subStatusDropdown = lessonId;
	    },
	    isSubStatusDropdown: function isSubStatusDropdown(lessonId) {
	      return this.subStatusDropdown === lessonId;
	    },
	    getIsUserSubstituted: function getIsUserSubstituted(lesson) {
	      var _this6 = this;
	
	      var isUserSubstituted = lesson.calendar_events.some(function (calEvent) {
	        return calEvent.substitute_for_user_id === _this6.user.id;
	      });
	      if (isUserSubstituted) {
	        return true;
	      }
	    },
	    getSubstitutionStatusForUserCalId: function getSubstitutionStatusForUserCalId(lesson) {
	      var _this7 = this;
	
	      var statusObj = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	      var userStatus = statusObj[this.user.user_calendar_id] ? statusObj[this.user.user_calendar_id].status : 0;
	      if (this.isSubStatusPendingActive) {
	        return userStatus;
	      } else {
	        var isUserSubstituted = lesson.calendar_events.some(function (calEvent) {
	          return calEvent.substitute_for_user_id === _this7.user.id;
	        });
	        if (isUserSubstituted || userStatus === 1 || lesson && lesson.canceled === true) {
	          return 1;
	        } else {
	          return 0;
	        }
	      }
	    },
	    setSubStatus: function setSubStatus(lesson, num) {
	      var _this8 = this;
	
	      this.pushLoadingLesson(lesson.id);
	      var statusData = (0, _extends3.default)({}, this.substitution_status);
	      if (num === 0) {
	        delete statusData[this.user.user_calendar_id];
	      } else {
	        statusData[this.user.user_calendar_id] = { status: num };
	      }
	      _docendo2.default.updateEvent(lesson.school_id, lesson.id, { substitution_status: (0, _stringify2.default)(statusData) }, function (success) {
	        _this8.$store.commit('updateSubStatusOnEvent', {
	          'eventId': lesson.id,
	          'status': (0, _stringify2.default)(statusData)
	        });
	        _this8.spliceLoadingLesson(lesson.id);
	      });
	      this.closeSubStatusDropdown();
	    },
	    getIsUserAbsentHandled: function getIsUserAbsentHandled() {
	      return this.absentUsersHandledHash[this.user.id] ? this.absentUsersHandledHash[this.user.id] : 0;
	    },
	    setAbsenceStatus: function setAbsenceStatus(num) {
	      var _this9 = this;
	
	      this.isSubmittingAbsenceStatus = true;
	      if (this.user.dayEvents.length < 1) {
	        this.user.dayAbsence.forEach(function (lessonId) {
	          var lesson = _this9.allEventsInAHash[lessonId];
	          var statusData = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	          statusData[_this9.user.user_calendar_id] = { 'status': num };
	          _docendo2.default.updateEvent(lesson.school_id, lesson.id, { substitution_status: (0, _stringify2.default)(statusData) }, function (success) {
	            _this9.$store.commit('updateSubStatusOnEvent', {
	              'eventId': lesson.id,
	              'status': (0, _stringify2.default)(statusData)
	            });
	          });
	        });
	      } else {
	        var groupBySchoolId = function groupBySchoolId(lessons) {
	          return lessons.reduce(function (groups, lesson) {
	            var schoolId = lesson.school_id;
	            if (!groups[schoolId]) {
	              groups[schoolId] = [];
	            }
	            groups[schoolId].push(lesson);
	            return groups;
	          }, {});
	        };
	
	        var lessonsToUpdate = this.user.dayEvents.filter(function (lessonId) {
	          var lesson = _this9.allEventsInAHash[lessonId];
	          return !_this9.isSubStatusPendingActive ? !_this9.getIsUserSubstituted(lesson) : true;
	        }).map(function (lessonId) {
	          var lesson = _this9.allEventsInAHash[lessonId];
	          var statusData = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	          statusData[_this9.user.user_calendar_id] = { status: num };
	
	          return (0, _extends3.default)({}, lesson, {
	            substitution_status: (0, _stringify2.default)(statusData)
	          });
	        });
	
	        var groupedLessons = groupBySchoolId(lessonsToUpdate);
	
	        (0, _entries2.default)(groupedLessons).forEach(function (_ref) {
	          var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	              schoolId = _ref2[0],
	              lessons = _ref2[1];
	
	          var eventsToUpdate = lessons.map(function (lesson) {
	            return {
	              event_id: lesson.id,
	              substitution_status: lesson.substitution_status
	            };
	          });
	
	          _docendo2.default.updateEvents(schoolId, eventsToUpdate, function (success) {
	            if (success) {
	              eventsToUpdate.forEach(function (event) {
	                _this9.$store.commit('updateSubStatusOnEvent', {
	                  eventId: event.event_id,
	                  status: event.substitution_status
	                });
	              });
	            } else {
	              console.error('Failed to update events for school_id: ' + schoolId);
	            }
	            setTimeout(function (_) {
	              _this9.isSubmittingAbsenceStatus = false;
	              _this9.closeSubStatusDropdown();
	            }, 0);
	          });
	        });
	      }
	    },
	    closeSubStatusDropdown: function closeSubStatusDropdown() {
	      this.subStatusDropdown = null;
	    },
	    isActiveEIP: function isActiveEIP(idx) {
	      return this.activeEIP.indexOf(idx) > -1;
	    },
	    setActiveEIP: function setActiveEIP(idx) {
	      if (this.activeEIP.indexOf(idx) < 0) {
	        this.activeEIP.push(idx);
	      }
	    },
	    isShowOtherOnLesson: function isShowOtherOnLesson(idx) {
	      return this.showOtherOnLesson === idx;
	    },
	    setShowOtherOnLesson: function setShowOtherOnLesson(lessonId) {
	      this.theActiveShowAllOtherOnLessonId = lessonId;
	    },
	    subLessonsThatOverlap: function subLessonsThatOverlap(lesson, lessonsArr) {
	      var _this10 = this;
	
	      var filterCurrLesson = lessonsArr.filter(function (eventid) {
	        return eventid !== lesson.id;
	      });
	      var arr = filterCurrLesson.map(function (eventId) {
	        return _this10.allEventsInAHash[eventId];
	      });
	      var arrWithOutPresence = arr.filter(function (event) {
	        return event.event_type !== null;
	      });
	      return arrWithOutPresence.filter(function (dayLesson) {
	        var range1 = moment.range(dayLesson.start, dayLesson.end);
	        var range2 = moment.range(lesson.start, lesson.end);
	        return range1.intersect(range2);
	      });
	    },
	    textFromSubLessonsThatOverlap: function textFromSubLessonsThatOverlap(lesson, lessonsArr) {
	      var _this11 = this;
	
	      var filterCurrLesson = lessonsArr.filter(function (eventid) {
	        return eventid !== lesson.id;
	      });
	      var arr = filterCurrLesson.map(function (eventId) {
	        return _this11.allEventsInAHash[eventId];
	      });
	      var arrWithOutPResence = arr.filter(function (event) {
	        return event.event_type !== null;
	      });
	      var lessonsArrToTitles = arrWithOutPResence.filter(function (dayLesson) {
	        var range1 = moment.range(dayLesson.start, dayLesson.end);
	        var range2 = moment.range(lesson.start, lesson.end);
	        return range1.intersect(range2);
	      });
	      return lessonsArrToTitles.map(function (lesson) {
	        return lesson.title;
	      });
	    },
	    otherLessonsInKlassThatOverlap: function otherLessonsInKlassThatOverlap(lesson) {
	      var _this12 = this;
	
	      var cals = this.calsOnLesson(lesson);
	      var klassCals = cals.filter(function (cal) {
	        return cal && cal.type === 'klass';
	      });
	      var klassCalEventsIDs = klassCals.map(function (cal) {
	        return _this12.calsAndEventIds[cal.id];
	      });
	      var allEventsInKlass = klassCalEventsIDs.map(function (obj) {
	        return obj.lessons;
	      });
	      var lessonsInKlass = allEventsInKlass[0] ? allEventsInKlass[0].map(function (id) {
	        return _this12.allEventsInAHash[id];
	      }) : [];
	
	      var lessonRange = moment.range(lesson.start, lesson.end);
	
	      return lessonsInKlass.filter(function (event) {
	        var range2 = moment.range(event.start, event.end);
	        return event.id !== lesson.id && lessonRange.overlaps(range2);
	      }).map(function (event) {
	        var usersOnEvent = event.calendar_events.filter(function (cal) {
	          return _this12.allUsersAndEvents[cal.calendar_id];
	        }).map(function (cal) {
	          var user = _this12.allUsersAndEvents[cal.calendar_id];
	          var absenceOverlap = _this12.doesAbsenceOverlapLesson(lesson.id, user.dayAbsence || []);
	          return (0, _extends3.default)({}, user, {
	            v_isUserAbsent: absenceOverlap.length > 0,
	            v_absenceInfo: absenceOverlap.join(', ')
	          });
	        });
	
	        return (0, _extends3.default)({}, event, {
	          showAllUsers: event.id === _this12.theActiveOtherLessonShowAllUsers,
	          users: usersOnEvent
	        });
	      });
	    },
	    setUsersForDSelect: function setUsersForDSelect() {
	      var _this13 = this;
	
	      this.filterAbsentUser.map(function (obj) {
	        var occ = false;
	        var isOnLesson = true;
	        var user = {
	          id: obj.id,
	          default_thumb_url: obj.default_thumb_url,
	          name: obj.name,
	          user_tags: obj.user_tags,
	          occupied: occ,
	          isOnLesson: isOnLesson,
	          currentEventId: 1,
	          user_calendar_id: obj.user_calendar_id
	        };
	        _this13.usersForDSelect.push(user);
	      });
	      this.usersForDSelect.push(this.userNotFoundPlaceholder);
	    },
	    updateUsersForList: function updateUsersForList(lesson) {
	      var _this14 = this;
	
	      this.usersForDSelect.forEach(function (obj, idx) {
	        _this14.usersForDSelect[idx].currentEventId = lesson.id;
	        _this14.usersForDSelect[idx].isOnLesson = _this14.othersOnLesson(lesson).filter(function (user) {
	          return user.id === obj.id;
	        }).length > 0;
	        if (_this14.occupiedUsers[obj.user_calendar_id]) {
	          _this14.usersForDSelect[idx].occupied = _this14.occupiedUsers[obj.user_calendar_id];
	        } else {
	          _this14.usersForDSelect[idx].occupied = false;
	        }
	        _this14.isUpdatingPotentialSubs = false;
	      });
	    },
	    getOccupiedUsers: function getOccupiedUsers(lesson) {
	      var _this15 = this;
	
	      this.isUpdatingPotentialSubs = true;
	      _docendo2.default.schoolAvailabilities(lesson.school_id, 'user', lesson.start, lesson.end, function (data) {
	        var toArr = (0, _hiddenAbsenceTitle.maskHiddenAbsenceTitlesInAvailability)(JSON.parse(data), _this15.$store, lesson.school_id);
	        var newUsers = {};
	        for (var i = 0; i < toArr.length; i++) {
	          newUsers[toArr[i].calendar_id] = toArr[i];
	        }
	        _this15.occupiedUsers = newUsers;
	        _this15.updateUsersForList(lesson);
	      });
	    },
	    setDSelect: function setDSelect(lesson) {
	      this.$emit('setActiveDSelect', this.user.id + '_' + lesson.id);
	      this.getOccupiedUsers(lesson);
	    },
	    openDSelect: function openDSelect(lesson) {
	      return this.activeDSelect === this.user.id + '_' + lesson.id;
	    },
	    calIdsOnLesson: function calIdsOnLesson(lesson) {
	      var _this16 = this;
	
	      var calIds = lesson.calendar_events.map(function (cal) {
	        return cal.calendar_id;
	      });
	      return calIds.filter(function (calIds) {
	        return calIds !== _this16.user.user_calendar_id;
	      });
	    },
	    calsOnLesson: function calsOnLesson(lesson) {
	      var _this17 = this;
	
	      return this.calIdsOnLesson(lesson).filter(function (calId) {
	        return _this17.allCalendarsInAHash[calId];
	      }).map(function (calId) {
	        return _this17.allCalendarsInAHash[calId];
	      });
	    },
	    othersOnLesson: function othersOnLesson(lesson) {
	      var users = [];
	      for (var i = 0; i < lesson.calendar_events.length; i++) {
	        if (this.allUsersAndEvents[lesson.calendar_events[i].calendar_id] && !lesson.calendar_events[i].substitute && lesson.calendar_events[i].calendar_id !== this.user.user_calendar_id) {
	          var user = this.allUsersAndEvents[lesson.calendar_events[i].calendar_id];
	          user['v_isUserAbsentFromLesson'] = this.doesAbsenceOverlapLesson(lesson.id, user.dayAbsence);
	          users.push(user);
	        }
	      }
	      return users;
	    },
	    doesAbsenceOverlapLesson: function doesAbsenceOverlapLesson(lessonId, absenceIds) {
	      var _this18 = this;
	
	      var absenceOverlapping = [];
	      var absenceEvents = absenceIds.map(function (eventId) {
	        return _this18.allEventsInAHash[eventId];
	      });
	      var lessonEvent = this.allEventsInAHash[lessonId];
	      absenceEvents.forEach(function (absenceEvent) {
	        var range1 = moment.range(absenceEvent.start, absenceEvent.end);
	        var range2 = moment.range(lessonEvent.start, lessonEvent.end);
	        if (range1.intersect(range2)) {
	          var absentLessonReadable = absenceEvent.title + ' ' + moment(absenceEvent.start).format('LT') + '-' + moment(absenceEvent.end).format('LT');
	          absenceOverlapping.push(absentLessonReadable);
	        }
	      });
	      return absenceOverlapping;
	    },
	    pushLoadingLesson: function pushLoadingLesson(lessonId) {
	      var idx = this.theLoadingLessons.indexOf(lessonId);
	      if (idx < 0) {
	        this.theLoadingLessons.push(lessonId);
	      }
	    },
	    spliceLoadingLesson: function spliceLoadingLesson(lessonId) {
	      var idx = this.theLoadingLessons.indexOf(lessonId);
	      if (idx > -1) {
	        this.theLoadingLessons.splice(idx, 1);
	      }
	    },
	    addSubstitute: function addSubstitute(userObj, lesson) {
	      var _this19 = this;
	
	      this.pushLoadingLesson(lesson.id);
	      if (this.isSubStatusPendingActive) {
	        this.setSubStatus(lesson, 2);
	      }
	      _docendo2.default.eventAddSubstitute(lesson.id, userObj.id, this.user.id, function (data) {
	        _this19.spliceLoadingLesson(lesson.id);
	        _this19.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data));
	        _this19.$store.commit('addEventOnAllUsersWithEvents', { cal_id: userObj.user_calendar_id, event_id: lesson.id });
	      });
	    },
	    removeSubstitute: function removeSubstitute(userObj, lesson) {
	      var _this20 = this;
	
	      this.pushLoadingLesson(lesson.id);
	
	      var subsForTheSub = [];
	      lesson.calendar_events.forEach(function (calEvent) {
	        if (calEvent.substitute && calEvent.substitute_for_user_id === userObj.id) {
	          subsForTheSub.indexOf(calEvent.calendar_id) < 0 ? subsForTheSub.push(calEvent.calendar_id) : null;
	        }
	      });
	      var userAndSubsForUser = {
	        user: this.user,
	        lesson: lesson,
	        subToBeRemoved: userObj,
	        subsForTheSubToBeRemoved: subsForTheSub
	      };
	      if (subsForTheSub.length > 0) {
	        this.$emit('removeSubs', userAndSubsForUser);
	        this.resetAllFormData();
	        this.spliceLoadingLesson(lesson.id);
	        return;
	      }
	      this.setSubStatus(lesson, 0);
	      _docendo2.default.eventRemoveSubstitute(lesson.id, userObj.id, this.user.id, function (data) {
	        _this20.spliceLoadingLesson(lesson.id);
	        _this20.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data));
	        _this20.$store.commit('removeEventOnAllUsersWithEvents', {
	          cal_id: userObj.user_calendar_id,
	          event_id: lesson.id
	        });
	      });
	    },
	    resetAllFormData: function resetAllFormData() {
	      this.$emit('setActiveDSelect', null);
	      this.activeEIP = [];
	      this.showOtherOnLesson = -1;
	      this.showDSub = -1;
	    },
	    getSerialListItem: function getSerialListItem(reason) {
	      return this.longAbsentListInHash[reason.event_serial_id] || false;
	    },
	    getIsAbsenceOngoing: function getIsAbsenceOngoing(reason) {
	      return this.getSerialListItem(reason) && this.getSerialListItem(reason).ongoing;
	    },
	    selectedUser: function selectedUser() {
	      this.$emit('selectedUser');
	    },
	    setActiveSplitLesson: function setActiveSplitLesson(lesson) {
	      this.$emit('splitLesson', lesson);
	    },
	    updateTeacherNote: function updateTeacherNote(obj) {
	      _docendo2.default.updateEvent(obj.lesson.school_id, obj.lesson.id, (0, _defineProperty3.default)({}, obj.noteType, obj.text), function (success) {
	        console.log('opdateret');
	      });
	    },
	    setTheEditAbsenceReason: function setTheEditAbsenceReason(reason) {
	      var absence = this.getSerialListItem(reason) ? this.getSerialListItem(reason) : reason;
	      this.$store.commit('setActiveAbsenceReason', absence);
	    }
	  },
	  mounted: function mounted() {
	    this.setUsersForDSelect();
	  }
	};

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    user_calendar_id: {},
	    reason: {
	      type: Object
	    },
	    internalNote: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      start: this.reason.start,
	      end: this.reason.end
	    };
	  },
	
	  computed: {
	    longAbsentList: function longAbsentList() {
	      return this.$store.state.subs.longAbsentList;
	    },
	    longAbsentListInHash: function longAbsentListInHash() {
	      return this.$store.getters.longAbsentListInHash;
	    },
	    getSerialListItem: function getSerialListItem() {
	      return this.reason && this.reason.event_serial_id ? this.longAbsentListInHash[this.reason.event_serial_id] : false;
	    },
	    isOngoing: function isOngoing() {
	      return this.getSerialListItem ? this.getSerialListItem.ongoing : false;
	    },
	    getIsAbsenceMultipleDays: function getIsAbsenceMultipleDays() {
	      var serialItem = this.getSerialListItem;
	      return serialItem && (0, _moment2.default)(serialItem.from_date).format('YYYY-MM-DD') !== (0, _moment2.default)(serialItem.to_date).format('YYYY-MM-DD');
	    },
	    absenceReasonSubject: function absenceReasonSubject() {
	      var reasons = this.$store.state.subs.absenceReasons || [];
	      var subjectId = this.reason && this.reason.subject_id;
	      if (!subjectId) return null;
	      return reasons.find(function (r) {
	        return r.id === subjectId;
	      }) || null;
	    },
	    hasSdAbsenceCode: function hasSdAbsenceCode() {
	      var serial = this.getSerialListItem;
	      if (serial && serial.sd_absence_code_id) return true;
	      return !!(this.absenceReasonSubject && this.absenceReasonSubject.sd_absence_code_id);
	    },
	    hasOpusAbsenceCode: function hasOpusAbsenceCode() {
	      var serial = this.getSerialListItem;
	      if (serial && serial.kmd_absence_code_id) return true;
	      return !!(this.absenceReasonSubject && this.absenceReasonSubject.kmd_absence_code_id);
	    }
	  },
	  methods: {
	    showDate: function showDate(date) {
	      return (0, _moment2.default)(date).format('DD. MMM, LT');
	    },
	    showTime: function showTime(date) {
	      return (0, _moment2.default)(date).format('LT');
	    },
	    formatDate: function formatDate(date) {
	      return (0, _moment2.default)(date).format('ll');
	    },
	    showLog: function showLog(event) {
	      this.$emit('showLog', event);
	    },
	    setReadyToDelete: function setReadyToDelete() {
	      this.$store.commit('setIsActiveAbsenceReasonIsReadyToDelete', true);
	      this.$store.commit('setActiveAbsenceReason', this.reason);
	    },
	    isEndDateSameDayAsStart: function isEndDateSameDayAsStart(startDate, endDate) {
	      var start = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	      var end = (0, _moment2.default)(endDate).format('YYYY-MM-DD');
	      return (0, _moment2.default)(start).isSame(end);
	    },
	    setTheEditAbsenceReason: function setTheEditAbsenceReason() {
	      var absence = this.getSerialListItem ? this.getSerialListItem : this.reason;
	      absence.internal_note = this.internalNote;
	      this.$store.commit('setActiveAbsenceReason', absence);
	    },
	    getIsAbsenceOngoing: function getIsAbsenceOngoing(reason) {
	      return this.getSerialListItem && this.getSerialListItem.ongoing;
	    }
	  },
	  mounted: function mounted() {
	    this.$emit('start', this.start);
	    this.$emit('end', this.end);
	    this.$store.dispatch('subsGetLongAbsenceList');
	  }
	};

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(35);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _set = __webpack_require__(27);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SubsUserAbsenceReason = __webpack_require__(101);
	
	var _SubsUserAbsenceReason2 = _interopRequireDefault(_SubsUserAbsenceReason);
	
	var _vuex = __webpack_require__(14);
	
	var _SubsUserPanelLessons = __webpack_require__(1653);
	
	var _SubsUserPanelLessons2 = _interopRequireDefault(_SubsUserPanelLessons);
	
	var _SubsUserPanelSubs = __webpack_require__(1654);
	
	var _SubsUserPanelSubs2 = _interopRequireDefault(_SubsUserPanelSubs);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DoDatePickerRange = __webpack_require__(44);
	
	var _DoDatePickerRange2 = _interopRequireDefault(_DoDatePickerRange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DoDatePickerRange: _DoDatePickerRange2.default, AbsenceReason: _SubsUserAbsenceReason2.default, SubsUserPanelLessons: _SubsUserPanelLessons2.default, SubsUserPanelSubs: _SubsUserPanelSubs2.default, DModal: _DModal2.default },
	  props: {
	    activeDate: {
	      default: (0, _moment2.default)()
	    },
	    isSubStatusPendingActive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      dateShortCuts: [{
	        sortKey: 1,
	        title: this.$t('vue2.substitution.selected_date'),
	        startDate: (0, _moment2.default)(this.activeDate).startOf('day'),
	        endDate: (0, _moment2.default)(this.activeDate).endOf('day')
	      }],
	      startDate: (0, _moment2.default)(this.activeDate).startOf('day'),
	      endDate: (0, _moment2.default)(this.activeDate).endOf('day'),
	      absentDates: [[(0, _moment2.default)(this.activeDate).startOf('day'), (0, _moment2.default)(this.activeDate).endOf('day')]],
	      isClosingWithoutSaving: false,
	      animate: null,
	      selectedEventIds: [],
	      subToAdd: null,
	      dbEventsWithSubs: [] };
	  },
	
	  computed: (0, _extends3.default)({
	    lessonsToSaveCount: function lessonsToSaveCount() {
	      return new _set2.default(this.dbEventsWithSubs.map(function (eventMap) {
	        return eventMap.event_id;
	      })).size;
	    },
	    saveCountSuffix: function saveCountSuffix() {
	      var count = this.lessonsToSaveCount;
	      if (count < 1) {
	        return '';
	      }
	      var words = {
	        da: ['lektion', 'lektioner'],
	        nb: ['leksjon', 'leksjoner'],
	        en: ['lesson', 'lessons']
	      };
	      var locale = String(this.$store.getters.locale || 'da').slice(0, 2);
	
	      var _ref = words[locale] || words.da,
	          _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	          singular = _ref2[0],
	          plural = _ref2[1];
	
	      return ' (' + count + ' ' + (count === 1 ? singular : plural) + ')';
	    }
	  }, (0, _vuex.mapGetters)(['allCalendarsInHash', 'allKlassCalendarsInHash', 'longAbsentListInHash', 'activeAbsentUserEventsInHash']), {
	    selectedEvents: function selectedEvents() {
	      var _this = this;
	
	      return this.selectedEventIds.map(function (eventId) {
	        return _this.activeAbsentUserEventsInHash[eventId];
	      });
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    user: function user() {
	      return this.$store.state.subs.activeAbsentUser;
	    },
	    absenceReasons: function absenceReasons() {
	      var _this2 = this;
	
	      return this.user.dayAbsence.map(function (eventId) {
	        return _this2.allEventsInAHash[eventId];
	      });
	    },
	    dateShortCutsSorted: function dateShortCutsSorted() {
	      return this.dateShortCuts.slice().sort(function (a, b) {
	        if (a.sortKey !== b.sortKey) {
	          return a.sortKey - b.sortKey;
	        }
	
	        return a.title.localeCompare(b.title);
	      });
	    }
	  }),
	  methods: {
	    setDates: function setDates(startAndEnd) {
	      this.startDate = startAndEnd.start;
	      this.endDate = startAndEnd.end;
	      this.absentDates = [[this.startDate, this.endDate]];
	    },
	    setAbsentDates: function setAbsentDates() {
	      var _this3 = this;
	
	      var isFromTodayAndOnwardsPushed = false;
	      if (!this.absenceReasons) {
	        return;
	      }
	
	      var globalStartDate = (0, _moment2.default)(this.activeDate);
	      var globalEndDate = (0, _moment2.default)(this.activeDate);
	
	      this.absenceReasons.forEach(function (absence) {
	        var start = void 0,
	            end = void 0;
	
	        if (absence.event_serial_id) {
	          var reason = _this3.longAbsentListInHash[absence.event_serial_id];
	          start = (0, _moment2.default)(reason.from_date);
	          end = (0, _moment2.default)(reason.to_date);
	        } else {
	          start = (0, _moment2.default)(absence.start);
	          end = (0, _moment2.default)(absence.end);
	        }
	
	        _this3.dateShortCuts.push({
	          sortKey: 3,
	          title: absence.title || '',
	          startDate: start.startOf('day'),
	          endDate: end.startOf('day')
	        });
	
	        if (start.isBefore(globalStartDate)) {
	          globalStartDate = start;
	        }
	        if (end.isAfter(globalEndDate)) {
	          globalEndDate = end;
	        }
	      });
	
	      if (this.absenceReasons.length > 1) {
	        this.dateShortCuts.push({
	          sortKey: 4,
	          title: this.$t('vue2.substitution.entire_period'),
	          startDate: globalStartDate.startOf('day'),
	          endDate: globalEndDate.endOf('day')
	        });
	      }
	
	      if ((0, _moment2.default)(this.activeDate).format('YYYY-MM-DD') !== (0, _moment2.default)(globalStartDate).format('YYYY-MM-DD') && !isFromTodayAndOnwardsPushed) {
	        this.dateShortCuts.push({
	          sortKey: 2,
	          title: this.$t('vue2.substitution.from_selected_date_onwards'),
	          startDate: (0, _moment2.default)(this.activeDate).startOf('day'),
	          endDate: globalEndDate.endOf('day')
	        });
	        isFromTodayAndOnwardsPushed = true;
	      }
	    },
	    close: function close() {
	      var _this4 = this;
	
	      if (this.dbEventsWithSubs.length > 0) {
	        this.isClosingWithoutSaving = true;
	        return;
	      }
	      this.animate = false;
	      setTimeout(function (_) {
	        _this4.$store.commit('setActiveAbsentUser', null);
	      }, 250);
	    },
	    updateSelectedEventIds: function updateSelectedEventIds(arr) {
	      this.selectedEventIds = arr;
	    },
	    addSubToEvents: function addSubToEvents(user) {
	      this.subToAdd = user;
	    },
	    updateDbEventsWithSubs: function updateDbEventsWithSubs(arr) {
	      this.dbEventsWithSubs = arr;
	      this.subToAdd = null;
	    },
	    cancel: function cancel() {
	      this.isClosingWithoutSaving = false;
	      this.dbEventsWithSubs = [];
	      this.close();
	    },
	    submit: function submit() {
	      var _this5 = this;
	
	      var updates = {};
	      this.dbEventsWithSubs.forEach(function (eventMap) {
	        var eventId = eventMap.event_id;
	        var event = _this5.activeAbsentUserEventsInHash[eventId];
	        var schoolId = event && event.school_id ? event.school_id : null;
	        if (!updates[schoolId]) {
	          updates[schoolId] = [eventMap];
	        } else {
	          updates[schoolId].push(eventMap);
	        }
	      });
	      var successTxt = this.$t('vue2.substitution.lessons_updated');
	      var errorTxt = this.$t('vue2.common.something_went_wrong');
	      (0, _keys2.default)(updates).forEach(function (schoolId) {
	        _docendo2.default.updateEvents(schoolId, updates[schoolId], function (success) {
	          _eventbus2.default.toast = { text: successTxt, success: true };
	        }, function (failure) {
	          _eventbus2.default.toast = { text: errorTxt, success: false };
	        });
	      });
	      this.$emit('readEvents');
	      this.dbEventsWithSubs = [];
	      this.close();
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.setAbsentDates();
	  },
	  mounted: function mounted() {
	    this.animate = true;
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.animate = false;
	  }
	};

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _set = __webpack_require__(27);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(14);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Tabs: _Tabs2.default, DModal: _DModal2.default, Loader: _Loader2.default, DoFiltersFilter: _DoFiltersFilter2.default },
	  props: {
	    calendarId: {},
	    dates: {
	      default: function _default() {
	        return [];
	      }
	    },
	    subToAdd: {
	      type: Object,
	      default: null
	    },
	    isSubStatusPendingActive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      events: [],
	      absences: [],
	      selectedEvents: [],
	      eventIdsToAddSub: [],
	      activeFilter: 'lessonsWithoutSub',
	      selectedSubjectTitles: [],
	      dbEventsWithSubs: [],
	      isAskRemoveAll: false,
	      activeLesson: null,
	      activeSub: null
	    };
	  },
	
	  watch: {
	    subToAdd: function subToAdd(val, oldVal) {
	      if (val) {
	        this.addSubstitute(this.subToAdd);
	      }
	    },
	    eventIdsToAddSub: function eventIdsToAddSub() {
	      this.$emit('changed', this.eventIdsToAddSub);
	    },
	    dates: function dates() {
	      this.getAllEventsInRanges();
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['allCalendarsInHash', 'allUsersInCalIdHash', 'allKlassCalendarsInHash', 'longAbsentListInHash', 'activeAbsentUserOriginalEventsInHash']), {
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    subjectTitles: function subjectTitles() {
	      var titles = this.events.map(function (event) {
	        return event.title;
	      }).filter(function (title) {
	        return title;
	      });
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(titles)));
	    },
	    subjectFilteredEvents: function subjectFilteredEvents() {
	      var _this = this;
	
	      if (this.selectedSubjectTitles.length === 0) {
	        return this.events;
	      }
	      return this.events.filter(function (event) {
	        return _this.selectedSubjectTitles.includes(event.title);
	      });
	    },
	    filteredEvents: function filteredEvents() {
	      var _this2 = this;
	
	      if (this.activeFilter === 'lessonsWithoutSub') {
	        return this.subjectFilteredEvents.filter(function (event) {
	          return !_this2.getEventHasSub(event);
	        });
	      } else if (this.activeFilter === 'lessonsWithSub') {
	        return this.subjectFilteredEvents.filter(function (event) {
	          return _this2.getEventHasSub(event);
	        });
	      } else {
	        return this.subjectFilteredEvents;
	      }
	    },
	    sortedEvents: function sortedEvents() {
	      var arr = this.filteredEvents;
	      if (arr.length < 1) {
	        return [];
	      }
	      return arr.sort(function (a, b) {
	        return (0, _moment2.default)(a.start).unix() - (0, _moment2.default)(b.start).unix();
	      });
	    },
	    eventsSortedInDays: function eventsSortedInDays() {
	      if (this.sortedEvents.length < 1) {
	        return [];
	      }
	      var sortedEventsInDays = this.sortedEvents.reduce(function (acc, curr, index) {
	        var val = (0, _moment2.default)(curr['start']).format('YYYY-MM-DD');
	        acc[val] = acc[val] || [];
	        acc[val].push(curr);
	        return acc;
	      }, {});
	      return this.eventsToArr(sortedEventsInDays);
	    },
	    visibleSelectedEventIds: function visibleSelectedEventIds() {
	      var _this3 = this;
	
	      return this.filteredEvents.map(function (event) {
	        return event.event_id;
	      }).filter(function (eventId) {
	        return _this3.eventIdsToAddSub.indexOf(eventId) > -1;
	      });
	    },
	    eventsWithoutSubstitute: function eventsWithoutSubstitute() {
	      var _this4 = this;
	
	      var events = this.subjectFilteredEvents.filter(function (lesson) {
	        return !_this4.getEventHasSub(lesson);
	      });
	      return events.map(function (event) {
	        return event.event_id;
	      });
	    },
	    eventsWithSubstitute: function eventsWithSubstitute() {
	      var _this5 = this;
	
	      var events = this.subjectFilteredEvents.filter(function (lesson) {
	        return _this5.getEventHasSub(lesson);
	      });
	      return events.map(function (event) {
	        return event.event_id;
	      });
	    },
	    tabsList: function tabsList() {
	      return [{
	        id: 'lessonsWithoutSub',
	        title: this.$t('vue2.substitution.lessons_without_sub') + ' (' + this.eventsWithoutSubstitute.length + ')'
	      }, {
	        id: 'lessonsWithSub',
	        title: this.$t('vue2.substitution.lessons_with_sub') + ' (' + this.eventsWithSubstitute.length + ')'
	      }, {
	        id: '',
	        title: this.$t('vue2.substitution.all_lessons') + ' (' + this.subjectFilteredEvents.length + ')'
	      }];
	    }
	  }),
	  methods: {
	    getEventHasSub: function getEventHasSub(event) {
	      var _this6 = this;
	
	      var hasSub = false;
	      event.calendars.forEach(function (calendar) {
	        if (calendar.substitute && calendar.substitute === _this6.allUsersInCalIdHash[_this6.calendarId].id) {
	          hasSub = true;
	        }
	      });
	      return hasSub;
	    },
	    getIsDuringAbsence: function getIsDuringAbsence(event) {
	      var start = (0, _moment2.default)(event.start);
	      var end = (0, _moment2.default)(event.end);
	      return this.absences.some(function (absence) {
	        return start.isBefore(absence.end) && end.isAfter(absence.start);
	      });
	    },
	    getDayAbsenceTimes: function getDayAbsenceTimes(date) {
	      var dayStart = (0, _moment2.default)(date).startOf('day');
	      var dayEnd = (0, _moment2.default)(date).endOf('day');
	      return this.absences.filter(function (absence) {
	        return dayStart.isBefore(absence.end) && dayEnd.isAfter(absence.start);
	      }).sort(function (a, b) {
	        return (0, _moment2.default)(a.start).unix() - (0, _moment2.default)(b.start).unix();
	      }).map(function (absence) {
	        var start = _moment2.default.max((0, _moment2.default)(absence.start), dayStart);
	        var end = _moment2.default.min((0, _moment2.default)(absence.end), dayEnd);
	        return start.format('LT') + ' - ' + end.format('LT');
	      });
	    },
	    setFilter: function setFilter(filter) {
	      this.eventIdsToAddSub = [];
	      this.activeFilter = filter;
	    },
	    toggleSubjectTitle: function toggleSubjectTitle(title) {
	      var idx = this.selectedSubjectTitles.indexOf(title);
	      if (idx < 0) {
	        this.selectedSubjectTitles.push(title);
	      } else {
	        this.selectedSubjectTitles.splice(idx, 1);
	      }
	      this.eventIdsToAddSub = [];
	    },
	    clearSubjectTitles: function clearSubjectTitles() {
	      this.selectedSubjectTitles = [];
	      this.eventIdsToAddSub = [];
	    },
	    setDbDateTime: function setDbDateTime(inputDate, dayTime) {
	      var date = (0, _moment2.default)(inputDate).format('YYYY-MM-DD');
	      var time = (0, _moment2.default)(dayTime);
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    readEvents: function readEvents(start, end) {
	      var _this7 = this;
	
	      this.eventIdsToAddSub = [];
	      this.isLoading = true;
	
	      var dbStart = this.setDbDateTime(start, (0, _moment2.default)().startOf('day'));
	      var dbEnd = this.setDbDateTime(end, (0, _moment2.default)().endOf('day'));
	
	      _docendo2.default.eventsFromCalendars([this.calendarId], dbStart, dbEnd, null, function (success) {
	        var data = [];
	        if (Array.isArray(success)) {
	          data = success;
	        } else if (typeof success === 'string' && success.length > 0) {
	          try {
	            data = JSON.parse(success);
	          } catch (e) {
	            console.log('JSON parse failed', e);
	            data = [];
	          }
	        }
	
	        var includeReservations = !!(_this7.$store.state.schoolSettings && _this7.$store.state.schoolSettings.includeReservationsInSubstitution);
	        data.forEach(function (lesson) {
	          if (lesson.event_type === 'absence' && !_this7.absences.some(function (absence) {
	            return absence.event_id === lesson.event_id;
	          })) {
	            _this7.absences.push(lesson);
	          }
	          var idx = _this7.events.findIndex(function (event) {
	            return event.event_id === lesson.event_id;
	          });
	          if (idx < 0 && lesson.event_type !== 'absence' && lesson.event_type !== 'presence' && (includeReservations || lesson.event_type !== 'reservation') && !lesson.canceled) {
	            _this7.events.push(lesson);
	          }
	        });
	
	        _this7.subjectFilteredEvents.forEach(function (lesson) {
	          if (!_this7.getEventHasSub(lesson) && _this7.getIsDuringAbsence(lesson)) {
	            if (_this7.eventIdsToAddSub.indexOf(lesson.event_id) < 0) {
	              _this7.eventIdsToAddSub.push(lesson.event_id);
	            }
	          }
	        });
	
	        _this7.$emit('gotLessons', true);
	        _this7.$store.commit('setActiveAbsentUserEvents', _this7.events);
	
	        _this7.$store.commit('setActiveAbsentUserOriginalEvents', JSON.parse((0, _stringify2.default)(_this7.events)));
	
	        setTimeout(function (_) {
	          _this7.isLoading = false;
	        }, 500);
	      }, function (failure) {
	        console.log('failed', failure);
	        _this7.$emit('gotLessons', false);
	        setTimeout(function (_) {
	          _this7.isLoading = false;
	        }, 0);
	      });
	    },
	    eventsToArr: function eventsToArr(events) {
	      return (0, _keys2.default)(events).map(function (e) {
	        return { date: e, events: events[e] };
	      });
	    },
	    getSubstitute: function getSubstitute(event) {
	      var _this8 = this;
	
	      var subs = event.calendars.filter(function (calendar) {
	        return calendar.substitute === _this8.allUsersInCalIdHash[_this8.calendarId].id;
	      });
	      return subs.map(function (calendar) {
	        return _this8.allUsersInCalIdHash[calendar.calendar_id];
	      });
	    },
	    getClasses: function getClasses(event) {
	      return event.calendars.filter(function (cal) {
	        return cal.calendar_type === 'klass';
	      });
	    },
	    isInEventIdsToAddSub: function isInEventIdsToAddSub(eventId) {
	      var idx = this.eventIdsToAddSub.indexOf(eventId);
	      return idx > -1;
	    },
	    toggleEvent: function toggleEvent(eventId) {
	      var idx = this.eventIdsToAddSub.indexOf(eventId);
	      if (idx < 0) {
	        this.eventIdsToAddSub.push(eventId);
	      } else {
	        this.eventIdsToAddSub.splice(idx, 1);
	      }
	    },
	    toggleAll: function toggleAll() {
	      var _this9 = this;
	
	      var visibleIds = this.filteredEvents.map(function (event) {
	        return event.event_id;
	      });
	      if (this.visibleSelectedEventIds.length > 0) {
	        this.eventIdsToAddSub = this.eventIdsToAddSub.filter(function (eventId) {
	          return visibleIds.indexOf(eventId) < 0;
	        });
	        this.selectedEvents = this.selectedEvents.filter(function (event) {
	          return visibleIds.indexOf(event.event_id) < 0;
	        });
	      } else {
	        this.filteredEvents.forEach(function (event) {
	          if (_this9.eventIdsToAddSub.indexOf(event.event_id) < 0) {
	            _this9.eventIdsToAddSub.push(event.event_id);
	            _this9.selectedEvents.push(event);
	          }
	        });
	      }
	    },
	    getAllEventsInRanges: function getAllEventsInRanges() {
	      var _this10 = this;
	
	      this.events = [];
	      this.absences = [];
	      this.$store.commit('setActiveAbsentUserEvents', []);
	      this.dates.forEach(function (range) {
	        var moments = range.map(function (d) {
	          return (0, _moment2.default)(d);
	        });
	        var startDate = _moment2.default.min(moments);
	        var endDate = _moment2.default.max(moments);
	        _this10.readEvents((0, _moment2.default)(startDate).startOf('day'), (0, _moment2.default)(endDate).endOf('day'));
	      });
	    },
	    addSubstitute: function addSubstitute(user) {
	      var _this11 = this;
	
	      this.eventIdsToAddSub.forEach(function (eventId) {
	        var idx = _this11.events.findIndex(function (event) {
	          return event.event_id === eventId;
	        });
	        var calendar = {
	          calendar_id: user.user_calendar_id,
	          substitute: _this11.allUsersInCalIdHash[_this11.calendarId].id,
	
	          minutes: 60
	        };
	        var calIdx = _this11.events[idx].calendars.findIndex(function (calendar) {
	          return calendar.calendar_id === user.user_calendar_id;
	        });
	
	        if (calIdx < 0) {
	          _this11.events[idx].calendars.push(calendar);
	
	          var dbArrIdx = _this11.dbEventsWithSubs.findIndex(function (obj) {
	            return obj.event_id === eventId && obj.calendar === _this11.calendarId && obj.remove_substitute_calendar_id === user.user_calendar_id;
	          });
	          if (dbArrIdx < 0) {
	            var updateObj = {
	              event_id: eventId,
	              calendar_id: _this11.calendarId,
	              add_substitute_calendar_id: user.user_calendar_id
	            };
	            if (_this11.isSubStatusPendingActive) {
	              var statusData = {};
	              statusData[_this11.calendarId] = { 'status': 2 };
	              updateObj['substitution_status'] = (0, _stringify2.default)(statusData);
	            }
	            _this11.dbEventsWithSubs.push(updateObj);
	          } else {
	            _this11.dbEventsWithSubs.splice(dbArrIdx, 1);
	          }
	        }
	      });
	      this.$emit('updatedArr', this.dbEventsWithSubs);
	      this.eventIdsToAddSub = [];
	    },
	    setIsAskRemoveAll: function setIsAskRemoveAll(boolean, lesson, sub) {
	      this.isAskRemoveAll = boolean;
	      this.activeLesson = lesson;
	      this.activeSub = sub;
	    },
	    removeSubFromAllLessons: function removeSubFromAllLessons() {
	      var _this12 = this;
	
	      var sub = this.activeSub;
	      this.events.forEach(function (event) {
	        var calIdx = event.calendars.findIndex(function (calendar) {
	          return calendar.calendar_id === sub.user_calendar_id && calendar.substitute === _this12.allUsersInCalIdHash[_this12.calendarId].id;
	        });
	        if (calIdx > -1) {
	          _this12.removeSub(event, sub);
	        }
	      });
	      this.isAskRemoveAll = false;
	      this.activeLesson = null;
	      this.activeSub = null;
	    },
	    removeSubFromActiveLesson: function removeSubFromActiveLesson() {
	      this.removeSub(this.activeLesson, this.activeSub);
	      this.isAskRemoveAll = false;
	      this.activeLesson = null;
	      this.activeSub = null;
	    },
	    removeSub: function removeSub(lesson, sub) {
	      var _this13 = this;
	
	      var eventIdx = this.events.findIndex(function (event) {
	        return event.event_id === lesson.event_id;
	      });
	      var calIdx = this.events[eventIdx].calendars.findIndex(function (calendar) {
	        return calendar.calendar_id === sub.user_calendar_id && calendar.substitute === _this13.allUsersInCalIdHash[_this13.calendarId].id;
	      });
	      this.events[eventIdx].calendars.splice(calIdx, 1);
	
	      var statusData = {};
	      statusData[this.calendarId] = { 'status': 0 };
	      var origCalIdx = this.activeAbsentUserOriginalEventsInHash[lesson.event_id].calendars.findIndex(function (calendar) {
	        return calendar.calendar_id === sub.user_calendar_id && calendar.substitute === _this13.allUsersInCalIdHash[_this13.calendarId].id;
	      });
	      if (origCalIdx > -1) {
	        this.dbEventsWithSubs.push({
	          event_id: lesson.event_id,
	          calendar_id: this.calendarId,
	          remove_substitute_calendar_id: sub.user_calendar_id,
	          substitution_status: (0, _stringify2.default)(statusData)
	        });
	      } else {
	        var dbEventsIdx = this.dbEventsWithSubs.findIndex(function (event) {
	          return event.event_id === lesson.event_id && event.add_substitute_calendar_id === sub.user_calendar_id;
	        });
	        this.dbEventsWithSubs.splice(dbEventsIdx, 1);
	      }
	      this.$emit('updatedArr', this.dbEventsWithSubs);
	    }
	  },
	  mounted: function mounted() {
	    this.getAllEventsInRanges();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.events = [];
	    this.$store.commit('setActiveAbsentUserEvents', []);
	  }
	};

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getIterator2 = __webpack_require__(45);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _vuex = __webpack_require__(14);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NON_BLOCKING_EVENT_TYPES = ['presence', 'available'];
	
	function isCoveredByPresence(start, end, presences) {
	  var cursor = start;
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = (0, _getIterator3.default)(presences), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var presence = _step.value;
	
	      if (presence.start <= cursor && presence.end > cursor) {
	        cursor = presence.end;
	        if (cursor >= end) {
	          return true;
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return false;
	}
	
	exports.default = {
	  components: { DoFiltersFilter: _DoFiltersFilter2.default },
	  props: {
	    selectedEvents: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      users: [],
	      isLoading: true,
	      searchQuery: '',
	      debounceTimer: null,
	      tags: [],
	      eventsByCalendarId: {},
	      isLoadingAvailability: false,
	      availabilityTimer: null,
	      availabilityRequestId: 0
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usersFilteredWithTags', 'allUsersInCalIdHash', 'schoolId']), {
	    activeAbsentUser: function activeAbsentUser() {
	      return this.$store.state.subs.activeAbsentUser;
	    },
	    activeUserEvents: function activeUserEvents() {
	      return this.$store.state.subs.activeAbsentUserEvents;
	    },
	    filteredUsers: function filteredUsers() {
	      var _this = this;
	
	      return this.usersFilteredWithTags.filter(function (user) {
	        return user.user_calendar_id !== _this.activeAbsentUser.user_calendar_id;
	      });
	    },
	    selectedTags: function selectedTags() {
	      return this.$store.state.selectedTags || [];
	    },
	    selectedLessons: function selectedLessons() {
	      return this.selectedEvents.filter(function (event) {
	        return event && event.start && event.end;
	      }).map(function (event) {
	        return {
	          eventId: event.event_id,
	          start: (0, _moment2.default)(event.start).valueOf(),
	          end: (0, _moment2.default)(event.end).valueOf()
	        };
	      });
	    },
	    selectedLessonsKey: function selectedLessonsKey() {
	      return this.selectedLessons.map(function (lesson) {
	        return lesson.eventId + ':' + lesson.start + ':' + lesson.end;
	      }).join(',');
	    },
	    availabilityByCalendarId: function availabilityByCalendarId() {
	      var _this2 = this;
	
	      var lessons = this.selectedLessons;
	      if (lessons.length === 0 || this.isLoadingAvailability) {
	        return {};
	      }
	      var result = {};
	      this.filteredUsers.forEach(function (user) {
	        var events = _this2.eventsByCalendarId[user.user_calendar_id] || [];
	        var presences = events.filter(function (event) {
	          return event.event_type === 'presence';
	        });
	        var blocking = events.filter(function (event) {
	          return NON_BLOCKING_EVENT_TYPES.indexOf(event.event_type) < 0;
	        });
	        var covered = 0;
	        var busy = 0;
	        lessons.forEach(function (lesson) {
	          if (isCoveredByPresence(lesson.start, lesson.end, presences)) {
	            covered++;
	          }
	          if (blocking.some(function (event) {
	            return event.event_id !== lesson.eventId && event.start < lesson.end && event.end > lesson.start;
	          })) {
	            busy++;
	          }
	        });
	        result[user.user_calendar_id] = { covered: covered, busy: busy };
	      });
	      return result;
	    },
	    usersSorted: function usersSorted() {
	      var _this3 = this;
	
	      var users = this.filteredUsers;
	
	      if (this.searchQuery) {
	        var lowercasedQuery = this.searchQuery.toLowerCase();
	        users = users.filter(function (user) {
	          return user.name.toLowerCase().includes(lowercasedQuery) || user.initials && user.initials.toLowerCase().includes(lowercasedQuery);
	        });
	      }
	      var availability = this.availabilityByCalendarId;
	      if ((0, _keys2.default)(availability).length === 0) {
	        return users;
	      }
	      return users.slice().sort(function (a, b) {
	        var statsA = availability[a.user_calendar_id];
	        var statsB = availability[b.user_calendar_id];
	        return Number(_this3.isFullyAvailable(b)) - Number(_this3.isFullyAvailable(a)) || statsB.covered - statsA.covered || statsA.busy - statsB.busy;
	      });
	    }
	  }),
	  watch: {
	    selectedLessonsKey: function selectedLessonsKey() {
	      clearTimeout(this.availabilityTimer);
	      this.availabilityTimer = setTimeout(this.readAvailability, 400);
	    }
	  },
	  methods: {
	    toggleSelectedTags: function toggleSelectedTags(tag) {
	      this.$store.commit('setSelectedTags', tag);
	    },
	    clearSelectedTags: function clearSelectedTags() {
	      var _this4 = this;
	
	      var tagsToRemove = [].concat((0, _toConsumableArray3.default)(this.$store.state.selectedTags));
	      tagsToRemove.forEach(function (tag) {
	        _this4.$store.commit('setSelectedTags', tag);
	      });
	    },
	    addSub: function addSub(user) {
	      if (this.selectedEvents.length < 1) {
	        window.alert(this.$t('vue2.substitution.select_lessons_to_substitute'));
	        return;
	      }
	      this.$emit('addSub', user);
	    },
	    isFullyAvailable: function isFullyAvailable(user) {
	      var stats = this.availabilityByCalendarId[user.user_calendar_id];
	      return !!stats && stats.covered === this.selectedLessons.length && stats.busy === 0;
	    },
	    statusText: function statusText(user) {
	      var stats = this.availabilityByCalendarId[user.user_calendar_id];
	      var busyText = stats.busy > 0 ? this.$t('vue2.substitution.busy') + ' ' + stats.busy : this.$t('vue2.substitution.available');
	      return this.$t('vue2.substitution.working_hours') + ' ' + stats.covered + '/' + this.selectedLessons.length + ' \xB7 ' + busyText;
	    },
	    readAvailability: function readAvailability() {
	      var _this5 = this;
	
	      var lessons = this.selectedLessons;
	      var requestId = ++this.availabilityRequestId;
	      if (lessons.length === 0) {
	        this.eventsByCalendarId = {};
	        this.isLoadingAvailability = false;
	        return;
	      }
	      var start = (0, _moment2.default)(Math.min.apply(Math, (0, _toConsumableArray3.default)(lessons.map(function (lesson) {
	        return lesson.start;
	      })))).format();
	      var end = (0, _moment2.default)(Math.max.apply(Math, (0, _toConsumableArray3.default)(lessons.map(function (lesson) {
	        return lesson.end;
	      })))).format();
	      this.isLoadingAvailability = true;
	      _docendo2.default.schoolAvailabilities(this.schoolId, 'user', start, end, function (data) {
	        if (requestId !== _this5.availabilityRequestId) {
	          return;
	        }
	        var rows = (typeof data === 'string' ? JSON.parse(data) : data) || [];
	        var eventsByCalendarId = {};
	        rows.forEach(function (row) {
	          eventsByCalendarId[row.calendar_id] = row.events.map(function (event) {
	            return {
	              event_id: event.event_id,
	              event_type: event.event_type,
	              start: (0, _moment2.default)(event.event_time_start).valueOf(),
	              end: (0, _moment2.default)(event.event_time_end).valueOf()
	            };
	          }).sort(function (a, b) {
	            return a.start - b.start;
	          });
	        });
	        _this5.eventsByCalendarId = eventsByCalendarId;
	        _this5.isLoadingAvailability = false;
	      }, function () {
	        if (requestId === _this5.availabilityRequestId) {
	          _this5.eventsByCalendarId = {};
	          _this5.isLoadingAvailability = false;
	        }
	      });
	    },
	    debounceSearch: function debounceSearch(event) {
	      var _this6 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        _this6.searchQuery = event.target.value;
	      }, 400);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.debounceTimer) {
	      clearTimeout(this.debounceTimer);
	    }
	    clearTimeout(this.availabilityTimer);
	  },
	  mounted: function mounted() {
	    var _this7 = this;
	
	    _docendo2.default.schoolTags(this.schoolId, function (data) {
	      _this7.tags = data;
	    });
	  }
	};

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getIterator2 = __webpack_require__(45);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    klassCalendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    userCalendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    allCalendarsInHash: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      calendarType: 'user',
	      slotHeight: 35,
	      slotWidth: 50,
	      eventHeightInPx: 28,
	      rows: 1,
	      schedulerMaxHeight: '100vh'
	    };
	  },
	
	  computed: {
	    hoursInLocale: function hoursInLocale() {
	      var hours = [];
	      for (var i = 0; i < 24; i++) {
	        var hour = (0, _moment2.default)().set({ hour: i, minutes: 0, seconds: 0 }).format('LT');
	        hours.push(hour);
	      }
	      return hours;
	    },
	    presenceAndAbsenceEvents: function presenceAndAbsenceEvents() {
	      return this.events.filter(function (event) {
	        return event.event_type === 'presence' || event.event_type === 'absence';
	      });
	    },
	    filteredEvents: function filteredEvents() {
	      return this.events.filter(function (event) {
	        return event.event_type !== 'presence' && event.event_type !== 'absence';
	      });
	    },
	    calendarsWithPresence: function calendarsWithPresence() {
	      var _this = this;
	
	      return this.userCalendars.map(function (calendar) {
	        var presenceAbsenceEvents = _this.presenceAndAbsenceEvents.filter(function (event) {
	          return event.calendar_events.some(function (calEvent) {
	            return calEvent.calendar_id === calendar.id;
	          });
	        });
	
	        var formattedEvents = presenceAbsenceEvents.map(function (event) {
	          var top = _this.eventTop(event);
	          var right = _this.eventRight(event);
	          var left = top;
	          var height = _this.eventHeightInPx;
	          var bottom = _this.eventBottom(event);
	
	          return (0, _extends3.default)({}, event, {
	            top: top,
	            bottom: bottom,
	            left: left,
	            right: right,
	            height: height,
	            vStyle: {
	              backgroundColor: event.color,
	              top: top + 'px',
	              bottom: bottom + 'px',
	              left: left + 'px',
	              right: right + 'px',
	              height: height + 'px'
	            }
	          });
	        });
	
	        return (0, _extends3.default)({}, calendar, {
	          vPresence: formattedEvents.filter(function (event) {
	            return event.event_type === 'presence';
	          }),
	          vAbsence: formattedEvents.filter(function (event) {
	            return event.event_type === 'absence';
	          })
	        });
	      });
	    },
	    calendarsWithEventsHash: function calendarsWithEventsHash() {
	      var _this2 = this;
	
	      var calendarMap = {};
	
	      this.filteredEvents.forEach(function (event) {
	        event.calendar_events.forEach(function (calEvent) {
	          if (!calendarMap[calEvent.calendar_id]) {
	            calendarMap[calEvent.calendar_id] = [];
	          }
	
	          var top = _this2.eventTop(event);
	          var height = _this2.eventHeightInPx;
	          var bottom = _this2.eventBottom(event);
	          var right = _this2.eventRight(event);
	
	          var eventData = (0, _extends3.default)({}, event, {
	            vColumns: 1,
	            top: top,
	            bottom: bottom,
	            left: top,
	            height: height,
	            right: right,
	            vStyle: {
	              backgroundColor: event.color,
	              top: 0,
	              bottom: '5px',
	              left: top + 'px',
	              height: height + 'px',
	              right: right + 'px'
	            }
	          });
	          calendarMap[calEvent.calendar_id].push(eventData);
	        });
	      });
	
	      (0, _keys2.default)(calendarMap).forEach(function (calendarId) {
	        var events = calendarMap[calendarId];
	        events.sort(function (e1, e2) {
	          return e1.top - e2.top || e1.bottom - e2.bottom;
	        });
	
	        var columns = [];
	
	        events.forEach(function (event) {
	          var placed = false;
	
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(columns), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var column = _step.value;
	
	              if (!column.some(function (e) {
	                return _this2.collidesWith(e, event);
	              })) {
	                column.push(event);
	                placed = true;
	                break;
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          if (!placed) {
	            columns.push([event]);
	          }
	        });
	
	        columns.forEach(function (column, colIndex) {
	          var colWidth = _this2.eventHeightInPx * colIndex + 1;
	          if (colIndex > 0) {
	            colWidth = colWidth + 2;
	          }
	          column.forEach(function (event) {
	            event.vStyle.top = colWidth + 'px';
	            event.vColumns = columns.length;
	          });
	        });
	      });
	
	      return calendarMap;
	    },
	    calendarsWithEvents: function calendarsWithEvents() {
	      var _this3 = this;
	
	      return this.userCalendars.map(function (calendar) {
	        var events = _this3.calendarsWithEventsHash[calendar.id] || [];
	        var presenceAbsence = _this3.calendarsWithPresence.find(function (pCal) {
	          return pCal.id === calendar.id;
	        }) || {};
	
	        return (0, _extends3.default)({}, calendar, {
	          vEvents: events.sort(function (a, b) {
	            return (0, _moment2.default)(a.start).valueOf() - (0, _moment2.default)(b.start).valueOf();
	          }),
	          vPresence: presenceAbsence.vPresence || [],
	          vAbsence: presenceAbsence.vAbsence || [],
	          vColumns: _this3.findLargestColumn(events)
	        });
	      });
	    }
	  },
	  methods: {
	    calculateMaxHeight: function calculateMaxHeight() {
	      if (this.$refs.doScheduler) {
	        var topOffset = this.$refs.doScheduler.getBoundingClientRect().top;
	        this.schedulerMaxHeight = window.innerHeight - topOffset - 16;
	      }
	    },
	    getEventStyle: function getEventStyle(event) {
	      return (0, _assign2.default)({}, event.vStyle, { '--event-color': event.color });
	    },
	    findLargestColumn: function findLargestColumn(events) {
	      return events.reduce(function (max, event) {
	        return event.vColumns > max ? event.vColumns : max;
	      }, 1);
	    },
	    eventRight: function eventRight(event) {
	      var time = _moment2.default.duration({
	        minutes: (0, _moment2.default)(event.end).format('mm'),
	        hours: (0, _moment2.default)(event.end).format('HH')
	      }).asMinutes();
	      var endOfDay = _moment2.default.duration({
	        hours: 24,
	        minutes: 0
	      }).asMinutes();
	      return this.slotWidth * 2 / 60 * (endOfDay - time);
	    },
	    eventTop: function eventTop(event) {
	      var calStartTime = (0, _moment2.default)(event.start).set({
	        'hour': 0,
	        'minutes': 0
	      });
	      var eventStartTime = (0, _moment2.default)(event.start);
	      var duration = (0, _moment2.default)(eventStartTime).diff(calStartTime);
	      return this.slotWidth * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    },
	    eventBottom: function eventBottom(event) {
	      var calStartTime = (0, _moment2.default)(event.end).set({
	        'hour': 0,
	        'minutes': 0
	      });
	      var eventEndTime = (0, _moment2.default)(event.end);
	      var duration = (0, _moment2.default)(eventEndTime).diff(calStartTime);
	      return this.slotWidth * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    },
	    collidesWith: function collidesWith(a, b) {
	      return a.bottom > b.top && a.top < b.bottom;
	    },
	    packEvents: function packEvents(columns) {
	      var n = columns.length;
	      for (var i = 0; i < n; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev = col[j];
	          var colSpan = this.expandEvent(ev, i, columns);
	          col[j].row = i;
	          if (i + 1 > this.rows) {
	            this.rows = i + 1;
	          }
	          col[j].colspan = colSpan / n;
	        }
	      }
	    },
	    expandEvent: function expandEvent(ev, iColumn, columns) {
	      var colSpan = 1;
	      for (var i = iColumn + 1; i < columns.length; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev1 = col[j];
	          if (this.collidesWith(ev, ev1)) {
	            return colSpan;
	          }
	        }
	        colSpan++;
	      }
	      return colSpan;
	    },
	    setWidthAndLeft: function setWidthAndLeft() {
	      var _this4 = this;
	
	      this.isEventsHasSortedOnce = true;
	      var columns = [];
	      var lastEventEnding = null;
	      var events = this.sortedEvents.map(function (elem) {
	        var top = _this4.eventTop(elem);
	        var height = _this4.eventHeight(elem);
	        var bottom = _this4.eventBottom(elem);
	        var right = _this4.eventRight(elem);
	        return {
	          'obj': elem,
	          'top': top,
	          'left': top,
	          'right': right,
	          'height': height,
	          'bottom': bottom
	        };
	      });
	      events.sort(function (e1, e2) {
	        if (e1.top < e2.top) return -1;
	        if (e1.top > e2.top) return 1;
	        if (e1.bottom < e2.bottom) return -1;
	        if (e1.bottom > e2.bottom) return 1;
	        return 0;
	      });
	      for (var i = 0; i < events.length; i++) {
	        var e = events[i];
	        if (lastEventEnding !== null && e.top >= lastEventEnding) {
	          this.packEvents(columns);
	          columns = [];
	          lastEventEnding = null;
	        }
	        var placed = false;
	        for (var j = 0; j < columns.length; j++) {
	          var col = columns[j];
	          if (!this.collidesWith(col[col.length - 1], e)) {
	            col.push(e);
	            placed = true;
	            break;
	          }
	        }
	        if (!placed) {
	          columns.push([e]);
	        }
	        if (lastEventEnding === null || e.bottom > lastEventEnding) {
	          lastEventEnding = e.bottom;
	        }
	      }
	      if (columns.length > 0) {
	        this.packEvents(columns);
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.calculateMaxHeight();
	    window.addEventListener('resize', this.calculateMaxHeight);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.calculateMaxHeight);
	  }
	};

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DoChangeDayNav = __webpack_require__(1696);
	
	var _DoChangeDayNav2 = _interopRequireDefault(_DoChangeDayNav);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DoSplash = __webpack_require__(412);
	
	var _DoSplash2 = _interopRequireDefault(_DoSplash);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Scheduler = __webpack_require__(1655);
	
	var _Scheduler2 = _interopRequireDefault(_Scheduler);
	
	var _vuex = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Scheduler: _Scheduler2.default, DoSplash: _DoSplash2.default, DoChangeDayNav: _DoChangeDayNav2.default, Loader: _Loader2.default },
	  data: function data() {
	    return {
	      isLoadingEvents: false,
	      events: [],
	      date: (0, _moment2.default)(),
	      activeUserIds: [],
	      isInitialLoad: true
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['klassCalendars', 'userCalendars', 'allCalendarsInHash']), {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id ? this.$route.params.school_id : this.$store.getters.schoolId;
	    },
	    dateFormatted: function dateFormatted() {
	      return (0, _moment2.default)(this.date).format('DD-MM-YYYY');
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    isLoadingAllUsers: function isLoadingAllUsers() {
	      return this.$store.state.isLoadingAllUsers;
	    },
	    isInitialLoading: function isInitialLoading() {
	      return this.isLoadingSchoolCalenders || this.isLoadingAllUsers;
	    },
	    eventsInHash: function eventsInHash() {
	      var events = this.events;
	      return events.reduce(function (obj, item) {
	        obj[item.id] = item;
	        return obj;
	      }, {});
	    },
	    eventsInCalIdsHash: function eventsInCalIdsHash() {
	      var calIds = {};
	      this.events.forEach(function (event) {
	        event.calendar_events.forEach(function (calEvent) {
	          var cal = calIds[calEvent.calendar_id];
	          if (!cal) {
	            calIds[calEvent.calendar_id] = [event];
	          } else {
	            calIds[calEvent.calendar_id].push(event);
	          }
	        });
	      });
	      return calIds;
	    },
	    usersWithEvents: function usersWithEvents() {
	      if (this.isInitialLoading) {
	        return [];
	      }
	    },
	    absentUsers: function absentUsers() {
	      if (this.isInitialLoading) {
	        return [];
	      }
	      return [];
	    }
	  }),
	  methods: {
	    getIsUserSubstituted: function getIsUserSubstituted(event, user) {
	      return event.calendar_events.some(function (calEvent) {
	        return calEvent.substitute_for_user_id === user.id;
	      });
	    },
	    getStatus: function getStatus(event, user) {
	      var isSubstituted = this.getIsUserSubstituted(event, user);
	      if (isSubstituted) {
	        return 1;
	      }
	      var status = event.substitution_status ? JSON.parse(event.substitution_status) : {};
	      var userStatus = status[user.user_calendar_id] ? status[user.user_calendar_id]['status'] : 0;
	      return userStatus;
	    },
	    setActiveUser: function setActiveUser(user) {
	      this.activeUserIds = [user.id];
	    },
	    onChangeSubstitute: function onChangeSubstitute(updateObj) {
	      this.submit([updateObj]);
	    },
	    onChangeStatus: function onChangeStatus(updateObj) {
	      var _this = this;
	
	      var event = updateObj.event;
	      var user = updateObj.user;
	      var val = updateObj.val * 1;
	      var status = event.substitution_status ? JSON.parse(event.substitution_status) : {};
	      var statusData = (0, _extends3.default)({}, status);
	      if (val === 0) {
	        delete statusData[user.user_calendar_id];
	      } else {
	        statusData[user.user_calendar_id] = { status: val };
	      }
	      _docendo2.default.updateEvent(event.school_id, event.id, { substitution_status: statusData }, function (success) {
	        _this.readEvents();
	      });
	    },
	    submit: function submit(dbEventsWithSubs) {
	      var _this2 = this;
	
	      var updates = {};
	      dbEventsWithSubs.forEach(function (eventMap) {
	        var eventId = eventMap.event_id;
	        var event = _this2.eventsInHash[eventId];
	        var schoolId = event && event.school_id ? event.school_id : null;
	        if (!updates[schoolId]) {
	          updates[schoolId] = [eventMap];
	        } else {
	          updates[schoolId].push(eventMap);
	        }
	      });
	      var successTxt = this.$t('vue2.substitution.lessons_updated');
	      var errorTxt = this.$t('vue2.common.something_went_wrong');
	      (0, _keys2.default)(updates).forEach(function (schoolId) {
	        _docendo2.default.updateEvents(schoolId, updates[schoolId], function (success) {
	          _eventbus2.default.toast = { text: successTxt, success: true };
	          _this2.readEvents();
	        }, function (failure) {
	          _eventbus2.default.toast = { text: errorTxt, success: false };
	        });
	      });
	    },
	    setDate: function setDate(inputDate) {
	      var _this3 = this;
	
	      var date = inputDate;
	      if (date === 'today') {
	        date = (0, _moment2.default)();
	      }
	      if (date === 'prev') {
	        date = (0, _moment2.default)(this.date).subtract(1, 'days');
	      }
	      if (date === 'next') {
	        date = (0, _moment2.default)(this.date).add(1, 'days');
	      }
	      this.date = date;
	      setTimeout(function (_) {
	        _this3.readEvents();
	      }, 100);
	    },
	    readEvents: function readEvents() {
	      var _this4 = this;
	
	      this.isInitialLoad = true;
	      this.events = [];
	      this.isLoadingEvents = true;
	      var schoolIds = [this.schoolId];
	      _docendo2.default.listEventsForSchools(schoolIds, this.date, function (success) {
	        var events = success && success.length > 0 ? JSON.parse(success) : [];
	        _this4.setEventsWithMetaData(events);
	        _this4.isLoadingEvents = false;
	      }, function (failure) {
	        console.log('something went wrong');
	      });
	    },
	    setEventsWithMetaData: function setEventsWithMetaData(events) {
	      this.events = events.map(function (event) {
	        return (0, _extends3.default)({}, event, {
	          vTime: (0, _moment2.default)(event.start).format('LT') + ' - ' + (0, _moment2.default)(event.end).format('LT'),
	          vKlasses: event.calendar_events.filter(function (cal) {
	            return cal && cal.calendar_type === 'klass';
	          }).map(function (cal) {
	            return cal.name;
	          }).join(', '),
	          vSubstitutes: [] });
	      }).sort(function (a, b) {
	        return (0, _moment2.default)(a.start).unix() - (0, _moment2.default)(b.start).unix();
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readEvents();
	  }
	};

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, DModal: _DModal2.default },
	  props: {
	    schoolId: {}
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      selected: 'KMD',
	      systems: [{ value: 'KMD', name: 'KMD OPUS' }, { value: 'SD', name: 'SD LØN' }]
	    };
	  },
	
	  methods: {
	    select: function select(system) {
	      this.selected = system.value;
	    },
	    submit: function submit() {
	      var _this = this;
	
	      this.isLoading = true;
	      var updates = { salary_system: this.selected };
	      _docendo2.default.updateSchool(this.schoolId, updates, function (success) {
	        _this.$store.commit('setActiveSchool', success);
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    }
	  }
	};

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ModalConfirmation: _ModalConfirmation2.default, DModal: _DModal2.default, DateSelector: _DateSelector2.default },
	  props: {
	    isSubmitting: {
	      type: Boolean,
	      default: false
	    },
	    schoolId: {},
	    schoolYearId: {},
	    schoolYear: {},
	    editSupplement: {
	      default: function _default() {
	        return null;
	      }
	    },
	    isInOpusModal: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      userId: '',
	      employmentId: null,
	      yearNormHours: null,
	      startDate: (0, _moment2.default)(),
	      endDate: (0, _moment2.default)(),
	      code: '',
	      salaryCodeId: null,
	      costCenterId: null,
	      units: null,
	      installments: null,
	      unitsPerInstallment: null,
	      isConfirmDelete: false
	    };
	  },
	
	  computed: {
	    isValid: function isValid() {
	      return this.userId && this.yearNormHours && this.code;
	    },
	    usersSortedOnName: function usersSortedOnName() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted || [];
	    },
	    costCenters: function costCenters() {
	      return this.$store.getters.costCenters || [];
	    },
	    isCodeLocked: function isCodeLocked() {
	      if (!this.isInOpusModal || !this.editSupplement) return false;
	      return this.editSupplement.rule === 'undervisningstillæg' || this.editSupplement.rule === 'specialskoletillæg';
	    }
	  },
	  watch: {
	    salaryCodeId: function salaryCodeId(id) {
	      if (id == null) {
	        this.code = '';
	        return;
	      }
	      var salaryCode = this.salaryCodes.find(function (sc) {
	        return sc.id === id;
	      });
	      if (salaryCode) {
	        this.code = salaryCode.code;
	      }
	    }
	  },
	  methods: {
	    costCenterLabel: function costCenterLabel(costCenter) {
	      var code = costCenter.code != null ? String(costCenter.code) : '';
	      var name = costCenter.name || '';
	      if (code && name && code !== name) return code + ' - ' + name;
	      return name || code;
	    },
	    onUserChange: function onUserChange(userId) {
	      this.readUser();
	    },
	    readUser: function readUser() {
	      var _this = this;
	
	      _docendo2.default.schoolUserYearsList(this.schoolId, this.schoolYearId, this.userId, function (success) {
	        var userNorms = success && success[0] && success[0].norm ? success[0].norm : [];
	        if (userNorms.length) {
	          var bruttoTime = userNorms.find(function (userNorm) {
	            return userNorm.title === 'Bruttotid';
	          });
	          if (bruttoTime && bruttoTime.value) {
	            _this.yearNormHours = parseFloat(bruttoTime.value);
	          }
	        } else {
	          _this.yearNormHours = null;
	        }
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    parseDecimal: function parseDecimal(value) {
	      if (value === '' || value == null) return value;
	      var parsed = parseFloat(String(value).replace(',', '.'));
	      return isNaN(parsed) ? value : parsed;
	    },
	    submit: function submit() {
	      var supplement = {
	        userId: this.userId,
	        employmentId: this.employmentId,
	        yearNormHours: this.yearNormHours,
	        startDate: this.startDate,
	        endDate: this.endDate,
	        code: this.code,
	        salaryCodeId: this.salaryCodeId,
	        costCenterId: this.costCenterId,
	        units: this.parseDecimal(this.units),
	        installments: this.installments,
	        unitsPerInstallment: this.parseDecimal(this.unitsPerInstallment)
	      };
	      if (this.editSupplement) {
	        supplement['id'] = this.editSupplement.id;
	        this.$emit('update', supplement);
	        return;
	      }
	      this.$emit('save', supplement);
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.$store.dispatch('readCostCenters');
	    this.$store.dispatch('readSalaryCodes');
	    if (this.schoolYear) {
	      var start = this.schoolYear.employee_time_start;
	      var end = this.schoolYear.employee_time_end;
	      this.startDate = (0, _moment2.default)(start).format('YYYY-MM-DD');
	      this.endDate = (0, _moment2.default)(end).format('YYYY-MM-DD');
	    }
	
	    if (this.editSupplement) {
	      this.userId = this.editSupplement.user_id || '';
	      this.employmentId = this.editSupplement.employment_id || null;
	      this.yearNormHours = this.editSupplement.year_norm_hours ? parseFloat(this.editSupplement.year_norm_hours) : null;
	
	      if (this.editSupplement.valid_period && this.editSupplement.valid_period.includes('...')) {
	        var dates = this.editSupplement.valid_period.split('...');
	        this.startDate = (0, _moment2.default)(dates[0]).format('YYYY-MM-DD');
	        this.endDate = (0, _moment2.default)(dates[1]).format('YYYY-MM-DD');
	      }
	
	      this.code = this.editSupplement.code || '';
	      this.salaryCodeId = this.editSupplement.salary_code_id || (this.salaryCodes.find(function (sc) {
	        return sc.code === _this2.editSupplement.code;
	      }) || {}).id || null;
	      this.costCenterId = this.editSupplement.cost_center_id || null;
	      this.units = this.editSupplement.units ? parseFloat(this.editSupplement.units) : null;
	      this.installments = this.editSupplement.installments || null;
	      this.unitsPerInstallment = this.editSupplement.units_per_installment ? parseFloat(this.editSupplement.units_per_installment) : null;
	    }
	  }
	};

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Tabs: _Tabs2.default, ModalConfirmation: _ModalConfirmation2.default, DModal: _DModal2.default },
	  props: {
	    users: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    schoolId: {},
	    schoolYearId: {},
	    schoolYear: {}
	  },
	  data: function data() {
	    return {
	      selectedTab: 'error'
	    };
	  },
	
	  computed: {
	    usersSorted: function usersSorted() {
	      return this.users.slice().sort(function (a, b) {
	        return a.user_name.localeCompare(b.user_name, 'da', {
	          numeric: true,
	          sensitivity: 'base'
	        });
	      });
	    },
	    errorUsers: function errorUsers() {
	      return this.usersSorted.filter(function (u) {
	        return u.result === 'error';
	      });
	    },
	    okUsers: function okUsers() {
	      return this.usersSorted.filter(function (u) {
	        return u.result === 'ok';
	      });
	    },
	    computedTabs: function computedTabs() {
	      return [{ id: 'error', title: 'Ikke oprettet (' + this.errorUsers.length + ')' }, { id: 'ok', title: 'Oprettet korrekt (' + this.okUsers.length + ')' }];
	    },
	    usersFiltered: function usersFiltered() {
	      var _this = this;
	
	      return this.usersSorted.filter(function (u) {
	        return u.result === _this.selectedTab;
	      });
	    }
	  },
	  methods: {
	    normalizeError: function normalizeError(error) {
	      return String(error == null ? '' : error).trim();
	    },
	    errorDescription: function errorDescription(error) {
	      var err = this.normalizeError(error);
	      if (err === 'No norm' || err === 'No user year') return 'Mangler bruttonorm eller ansættelsesperiode';
	      if (err === 'user has no calendar') return 'Brugeren har ingen kalender';
	      return err || 'Ukendt fejl';
	    },
	    errorHint: function errorHint(error) {
	      var err = this.normalizeError(error);
	      if (err === 'No norm' || err === 'No user year') {
	        return "Udfyld brugerens bruttonorm og ansættelsesperiode i siden 'Årsnorm'.";
	      }
	      if (err === 'user has no calendar') {
	        return 'Kontakt support — brugeren mangler en kalender.';
	      }
	      return 'Tjek brugerens opsætning og prøv igen.';
	    }
	  }
	};

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SupplementsList = __webpack_require__(1659);
	
	var _SupplementsList2 = _interopRequireDefault(_SupplementsList);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ChooseSalarySystem = __webpack_require__(398);
	
	var _ChooseSalarySystem2 = _interopRequireDefault(_ChooseSalarySystem);
	
	var _CostCenters = __webpack_require__(143);
	
	var _CostCenters2 = _interopRequireDefault(_CostCenters);
	
	var _SalaryCodes = __webpack_require__(144);
	
	var _SalaryCodes2 = _interopRequireDefault(_SalaryCodes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CostCenters: _CostCenters2.default,
	    SalaryCodes: _SalaryCodes2.default,
	    ChooseSalarySystem: _ChooseSalarySystem2.default,
	    SupplementsList: _SupplementsList2.default,
	    Loader: _Loader2.default
	  },
	  props: {
	    isInOpusModal: {
	      type: Boolean,
	      default: false
	    },
	    beregningType: {
	      type: String,
	      default: null
	    },
	    sendToOpusTrigger: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      activePage: 'tillæg'
	    };
	  },
	
	  computed: {
	    menu: function menu() {
	      var menu = [{ key: 'tillæg', label: 'Tillæg', component: 'SupplementsList' }, { key: 'lønkoder', label: 'Lønkoder', component: 'SalaryCodes' }, { key: 'omkostningssteder', label: 'Omkostningssteder', component: 'CostCenters' }];
	      return menu;
	    },
	    salarySystem: function salarySystem() {
	      return this.$store.getters.salarySystem;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolYear: function schoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.$store.getters.schoolYearId;
	    },
	    isAllLoaded: function isAllLoaded() {
	      return this.schoolId && this.schoolYearId && this.schoolYear;
	    },
	    selectedEmploymentIds: function selectedEmploymentIds() {
	      if (this.$store && this.$store.getters && this.$store.getters.selectedEmploymentIds) {
	        return this.$store.getters.selectedEmploymentIds;
	      }
	      return [];
	    },
	    activeTab: function activeTab() {
	      var _this = this;
	
	      var match = this.menu.filter(function (m) {
	        return m.key === _this.activePage;
	      });
	      return match.length > 0 ? match[0] : null;
	    }
	  },
	  methods: {
	    setActivePage: function setActivePage(page) {
	      this.activePage = page;
	    },
	    getPropsFor: function getPropsFor(key) {
	      if (key === 'tillæg') {
	        return {
	          schoolId: this.schoolId,
	          schoolYear: this.schoolYear,
	          schoolYearId: this.schoolYearId,
	          isInOpusModal: this.isInOpusModal,
	          beregningType: this.beregningType,
	          sendToOpusTrigger: this.sendToOpusTrigger
	        };
	      }
	      if (key === 'lønkoder') {
	        return {
	          isInSchoolSalarySettings: true
	        };
	      }
	      if (key === 'omkostningssteder') {
	        return {
	          isInSchoolSalarySettings: true
	        };
	      }
	      if (key === 'lønskabeloner') {
	        return {
	          selectedEmploymentIds: this.selectedEmploymentIds
	        };
	      }
	      return {};
	    },
	    onTemplateSelected: function onTemplateSelected(tpl) {
	      this.$emit('template-selected', tpl);
	    },
	    onTemplateCreated: function onTemplateCreated() {
	      this.$emit('template-created');
	    },
	    onTemplateUpdated: function onTemplateUpdated() {
	      this.$emit('template-updated');
	    },
	    onTemplateDeleted: function onTemplateDeleted() {
	      this.$emit('template-deleted');
	    }
	  }
	};

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _CreateSupplement = __webpack_require__(1657);
	
	var _CreateSupplement2 = _interopRequireDefault(_CreateSupplement);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TaskOverviewSettings = __webpack_require__(401);
	
	var _TaskOverviewSettings2 = _interopRequireDefault(_TaskOverviewSettings);
	
	var _ShowResponse = __webpack_require__(1658);
	
	var _ShowResponse2 = _interopRequireDefault(_ShowResponse);
	
	var _UvLimitsModal = __webpack_require__(1661);
	
	var _UvLimitsModal2 = _interopRequireDefault(_UvLimitsModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var XLSX = null;
	exports.default = {
	  components: { ShowResponse: _ShowResponse2.default, TaskOverviewSettings: _TaskOverviewSettings2.default, Tabs: _Tabs2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, CreateSupplement: _CreateSupplement2.default, Loader: _Loader2.default, UvLimitsModal: _UvLimitsModal2.default },
	  props: {
	    schoolId: {
	      default: function _default() {
	        return null;
	      }
	    },
	    schoolYear: {
	      default: function _default() {
	        return null;
	      }
	    },
	    schoolYearId: {
	      default: function _default() {
	        return null;
	      }
	    },
	    isInOpusModal: {
	      type: Boolean,
	      default: false
	    },
	
	    beregningType: {
	      type: String,
	      default: null
	    },
	
	    sendToOpusTrigger: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: true,
	      supplements: [],
	      isCreateModal: false,
	      isSubmitting: false,
	      theEditSupplementType: null,
	      selectedTab: '',
	      isShowTasksModal: false,
	      isDownloading: false,
	      editSupplement: null,
	      response: [],
	      isShowResponseModal: false,
	      isShowUvLimitsModal: false,
	      isGeneratingSupplementType: null,
	      isApproving: false,
	      savingEmploymentIds: [],
	      stateFilter: 'draft'
	    };
	  },
	
	  computed: {
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted || [];
	    },
	    salaryCodesById: function salaryCodesById() {
	      var map = {};
	      this.salaryCodes.forEach(function (salaryCode) {
	        map[salaryCode.id] = salaryCode;
	      });
	      return map;
	    },
	    beregningFilters: function beregningFilters() {
	      var isSd = this.$store.getters.salarySystem === 'SD';
	      return {
	        paedagog_eneansvar: {
	          loenarter: isSd ? ['831', '832'] : ['5061', '5062'],
	          tillaegsnumre: []
	        },
	        dsa_tale_hoere: {
	          loenarter: isSd ? ['878', '879', '835'] : ['6109', '6119', '6111'],
	          tillaegsnumre: isSd ? ['111137', '116229'] : []
	        }
	      };
	    },
	    uvSalaryCodes: function uvSalaryCodes() {
	      var isSd = this.$store.getters.salarySystem === 'SD';
	      return {
	        loenarter: isSd ? ['833', '848', '853', '854'] : ['5652', '5653'],
	        tillaegsnumre: isSd ? ['111122', '111128', '111836', '111841'] : []
	      };
	    },
	    hasSpecialSalaryCode: function hasSpecialSalaryCode() {
	      if (this.$store.getters.salarySystem === 'SD') {
	        return this.salaryCodes.some(function (salaryCode) {
	          return String(salaryCode.tillaegsnummer) === '160099' || String(salaryCode.tillaegsnummer) === '160100' || String(salaryCode.loenart) === '836';
	        });
	      }
	      return this.salaryCodes.some(function (salaryCode) {
	        return String(salaryCode.loenart) === '8411' || String(salaryCode.code) === '8411';
	      });
	    },
	    supplementTabs: function supplementTabs() {
	      var _this = this;
	
	      var isSd = this.$store.getters.salarySystem === 'SD';
	      var tabs = [{ id: '', title: 'Alle' }, { id: '(Lønbrøk)', title: 'Lønbrøk' }, { id: 'undervisningstillæg', title: 'UV-tillæg' }, { id: 'specialskoletillæg', title: 'Spec-skole uv-tillæg' }, { id: 'opgaver', title: 'Opgaver' }].filter(function (tab) {
	        return tab.id !== '(Lønbrøk)' || isSd;
	      }).filter(function (tab) {
	        return tab.id !== 'specialskoletillæg' || _this.hasSpecialSalaryCode && !isSd;
	      });
	      if (this.isInOpusModal) {
	        return tabs.filter(function (tab) {
	          return tab.id !== '' && tab.id !== '(Lønbrøk)';
	        });
	      }
	      return tabs;
	    },
	    tabForBeregningType: function tabForBeregningType() {
	      var map = {
	        loenbroek: '(Lønbrøk)',
	        uv_over_graense: 'undervisningstillæg',
	        spec_skole_uv: 'specialskoletillæg',
	        dsa_tale_hoere: 'opgaver',
	        paedagog_eneansvar: 'opgaver'
	      };
	      return map[this.beregningType] || 'undervisningstillæg';
	    },
	    isOpusIntegrationActive: function isOpusIntegrationActive() {
	      var features = this.$store.getters.schoolFeatures || [];
	      return features.indexOf('kmd_opus_integration') > -1;
	    },
	    isSalaryIntegrationActive: function isSalaryIntegrationActive() {
	      var features = this.$store.getters.schoolFeatures || [];
	      return features.indexOf('kmd_opus_integration') > -1 || features.indexOf('silkeborg_data_integration') > -1;
	    },
	    salaryTargetLabel: function salaryTargetLabel() {
	      return this.$store.getters.salarySystem === 'SD' ? 'SD' : 'OPUS';
	    },
	    uvSupplementsToApprove: function uvSupplementsToApprove() {
	      var _this2 = this;
	
	      return this.supplementsSorted.filter(function (supplement) {
	        return _this2.isUvSupplement(supplement);
	      });
	    },
	    specialSkoleSupplementsToApprove: function specialSkoleSupplementsToApprove() {
	      var _this3 = this;
	
	      return this.supplementsSorted.filter(function (supplement) {
	        return _this3.isSpecialSkoleSupplement(supplement);
	      });
	    },
	    supplementsToApprove: function supplementsToApprove() {
	      var _this4 = this;
	
	      var list = void 0;
	      if (this.selectedTab === '(Lønbrøk)') {
	        list = this.$store.getters.salarySystem === 'SD' ? this.supplementsSorted.filter(function (supplement) {
	          return String(supplement.code) === '(Lønbrøk)';
	        }) : [];
	      } else if (this.selectedTab === 'undervisningstillæg') {
	        list = this.uvSupplementsToApprove;
	      } else if (this.selectedTab === 'specialskoletillæg') {
	        list = this.specialSkoleSupplementsToApprove;
	      } else if (this.selectedTab === 'opgaver') {
	        list = this.supplementsSorted.filter(function (supplement) {
	          return String(supplement.code) !== '(Lønbrøk)' && !_this4.isUvSupplement(supplement) && !_this4.isSpecialSkoleSupplement(supplement) && _this4.supplementMatchesBeregning(supplement);
	        });
	      } else {
	        return [];
	      }
	      return list.filter(function (supplement) {
	        return (supplement.state || 'draft') === 'draft';
	      });
	    },
	    stateTabs: function stateTabs() {
	      var draftCount = this.categoryFiltered.filter(function (s) {
	        return (s.state || 'draft') === 'draft';
	      }).length;
	      var doneCount = this.categoryFiltered.filter(function (s) {
	        return s.state === 'approved';
	      }).length;
	      return [{ id: 'draft', title: 'Klar til afsendelse (' + draftCount + ')' }, { id: 'done', title: 'Godkendte (' + doneCount + ')' }];
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash || {};
	    },
	    costCenters: function costCenters() {
	      return this.$store.getters.costCentersAll || [];
	    },
	    costCenterMap: function costCenterMap() {
	      var map = {};
	      this.costCenters.forEach(function (costCenter) {
	        map[costCenter.id] = costCenter;
	      });
	      return map;
	    },
	    supplementsSorted: function supplementsSorted() {
	      var _this5 = this;
	
	      return this.supplements.map(function (supplement) {
	        var user = _this5.allUsersInHash[supplement.user_id];
	        return (0, _extends3.default)({}, supplement, {
	          vUserName: user ? user.name : 'Ukendt bruger'
	        });
	      }).sort(function (a, b) {
	        var nameA = a.vUserName.toLowerCase();
	        var nameB = b.vUserName.toLowerCase();
	        if (nameA < nameB) return -1;
	        if (nameA > nameB) return 1;
	        return 0;
	      });
	    },
	    categoryFiltered: function categoryFiltered() {
	      var _this6 = this;
	
	      if (this.selectedTab === '(Lønbrøk)') {
	        return this.supplementsSorted.filter(function (supplement) {
	          return String(supplement.code) === '(Lønbrøk)';
	        });
	      }
	      if (this.selectedTab === 'undervisningstillæg') {
	        return this.supplementsSorted.filter(function (supplement) {
	          return _this6.isUvSupplement(supplement);
	        });
	      }
	      if (this.selectedTab === 'specialskoletillæg') {
	        return this.supplementsSorted.filter(function (supplement) {
	          return _this6.isSpecialSkoleSupplement(supplement);
	        });
	      }
	      if (this.selectedTab === 'opgaver') {
	        return this.supplementsSorted.filter(function (supplement) {
	          return String(supplement.code) !== '(Lønbrøk)' && !_this6.isUvSupplement(supplement) && !_this6.isSpecialSkoleSupplement(supplement) && _this6.supplementMatchesBeregning(supplement);
	        });
	      }
	      return this.supplementsSorted;
	    },
	    supplementsFiltered: function supplementsFiltered() {
	      var _this7 = this;
	
	      if (!this.isInOpusModal) {
	        return this.categoryFiltered;
	      }
	
	      return this.categoryFiltered.filter(function (supplement) {
	        return _this7.matchesStateFilter(supplement);
	      });
	    }
	  },
	  watch: {
	    schoolYearId: function schoolYearId(val) {
	      this.readSupplements();
	    },
	    sendToOpusTrigger: function sendToOpusTrigger() {
	      if (this.isInOpusModal) {
	        this.approveSupplements();
	      }
	    },
	    supplementsToApprove: function supplementsToApprove() {
	      this.emitApproveState();
	    },
	    isApproving: function isApproving() {
	      this.emitApproveState();
	    },
	    selectedTab: function selectedTab() {
	      this.emitApproveState();
	    },
	    stateFilter: function stateFilter() {
	      this.emitApproveState();
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      this.emitApproveState();
	    }
	  },
	  methods: {
	    stateLabel: function stateLabel(state) {
	      var map = { draft: 'Kladde', approved: 'Godkendt' };
	      return map[state] || 'Kladde';
	    },
	    isUvSupplement: function isUvSupplement(supplement) {
	      return String(supplement.rule) === 'undervisningstillæg' || this.supplementMatchesCodes(supplement, this.uvSalaryCodes);
	    },
	    isSpecialSkoleSupplement: function isSpecialSkoleSupplement(supplement) {
	      return String(supplement.rule) === 'specialskoletillæg';
	    },
	    supplementMatchesCodes: function supplementMatchesCodes(supplement, filter) {
	      if (!filter) return false;
	      var code = String(supplement.code);
	      if (filter.loenarter.indexOf(code) > -1) return true;
	      var salaryCode = this.salaryCodesById[supplement.salary_code_id];
	      if (salaryCode) {
	        if (filter.loenarter.indexOf(String(salaryCode.loenart)) > -1) return true;
	        if (filter.tillaegsnumre.indexOf(String(salaryCode.tillaegsnummer)) > -1) return true;
	      }
	      return false;
	    },
	    supplementMatchesBeregning: function supplementMatchesBeregning(supplement) {
	      var filter = this.beregningFilters[this.beregningType];
	      if (!filter) return true;
	      return this.supplementMatchesCodes(supplement, filter);
	    },
	    deleteSupplement: function deleteSupplement(supplementId) {
	      var _this8 = this;
	
	      this.isDeleting = true;
	      _docendo2.default.deleteSalarySupplement(this.schoolId, this.schoolYearId, supplementId, function (success) {
	        _this8.setIsCreateModal(false);
	        _this8.isDeleting = false;
	        _this8.readSupplements();
	      }, function (failure) {
	        console.log('failed');
	      });
	    },
	    setEditSupplement: function setEditSupplement(supplement) {
	      if (this.isInOpusModal && this.stateFilter === 'done') return;
	      this.editSupplement = supplement;
	      this.setIsCreateModal(true);
	    },
	    setIsShowTasksModal: function setIsShowTasksModal(bool) {
	      this.isShowTasksModal = bool;
	      if (bool) {
	        document.body.style.overflow = 'hidden';
	      } else {
	        document.body.style.overflow = '';
	      }
	    },
	    formatPeriod: function formatPeriod(periodStr) {
	      if (!periodStr || periodStr.indexOf('...') === -1) return '';
	      var parts = periodStr.split('...');
	      return (0, _moment2.default)(parts[0]).format('DD-MM-YYYY') + ' til ' + (0, _moment2.default)(parts[1]).format('DD-MM-YYYY');
	    },
	    formatDecimal: function formatDecimal(val) {
	      var num = parseFloat(val);
	      return isNaN(num) ? '—' : num.toFixed(4).replace('.', ',');
	    },
	    supplementTypeTitle: function supplementTypeTitle(supplementType) {
	      if (supplementType === 'lønbrøk') return 'Lønbrøk';
	      if (supplementType === 'undervisningstillæg') return 'UV-tillæg';
	      if (supplementType === 'specialskoletillæg') return 'Spec-skole uv-tillæg';
	      if (supplementType === 'opgaver') return 'Opgaver med tillæg';
	      return 'Tillæg';
	    },
	    generateSalarySupplements: function generateSalarySupplements(supplementType) {
	      var _this9 = this;
	
	      if (this.isGeneratingSupplementType) return;
	      if (supplementType === 'undervisningstillæg') {
	        this.$store.dispatch('trackEvent', 'supplements_uvTillaeg_generate');
	      }
	      if (supplementType === 'specialskoletillæg') {
	        this.$store.dispatch('trackEvent', 'supplements_specSkoleUvTillaeg_generate');
	      }
	      this.isGeneratingSupplementType = supplementType;
	      _docendo2.default.generateSalarySupplements(this.schoolId, this.schoolYearId, supplementType, function (success) {
	        _this9.response = Array.isArray(success) ? success : [];
	        _this9.isShowResponseModal = _this9.response.length > 0;
	        _this9.readSupplements();
	        _this9.isGeneratingSupplementType = null;
	        _eventbus2.default.toast = { text: _this9.supplementTypeTitle(supplementType) + ' er hentet', success: true, position: 'bottomLeft' };
	      }, function (failure) {
	        console.log(failure);
	        _this9.isGeneratingSupplementType = null;
	        _eventbus2.default.toast = { text: 'Kunne ikke hente ' + _this9.supplementTypeTitle(supplementType).toLowerCase(), success: false, position: 'bottomLeft' };
	      });
	    },
	    approveSupplements: function approveSupplements() {
	      if (this.isApproving) return;
	      this.doApprove();
	    },
	    doApprove: function doApprove() {
	      var _this10 = this;
	
	      if (this.isApproving) return;
	      var ids = this.supplementsToApprove.map(function (supplement) {
	        return supplement.id;
	      });
	      if (ids.length === 0) return;
	      this.isApproving = true;
	      _docendo2.default.approveSalarySupplements(this.schoolId, this.schoolYearId, ids, function (success) {
	        _this10.isApproving = false;
	        if (success && success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message || 'Kunne ikke godkende og overføre til ' + _this10.salaryTargetLabel, success: false, position: 'bottomLeft' };
	          return;
	        }
	        _this10.readSupplements();
	        _eventbus2.default.toast = { text: 'Sender tillæggene til ' + _this10.salaryTargetLabel + ' – find dem i udbakke eller afsendt', success: true, position: 'bottomLeft' };
	      }, function (failure) {
	        console.log(failure);
	        _this10.isApproving = false;
	        _eventbus2.default.toast = { text: failure && failure.message ? failure.message : 'Kunne ikke godkende og overføre til ' + _this10.salaryTargetLabel, success: false, position: 'bottomLeft' };
	      });
	    },
	    emitApproveState: function emitApproveState() {
	      var _this11 = this;
	
	      if (!this.isInOpusModal) return;
	      var drafts = this.supplementsToApprove;
	
	      var missingEmployment = drafts.length > 0 && drafts.some(function (supplement) {
	        return !_this11.hasSelectableEmployment(supplement);
	      });
	      this.$emit('approveState', {
	        count: drafts.length,
	        isApproving: this.isApproving,
	        missingEmployment: missingEmployment,
	
	        canApprove: this.isSalaryIntegrationActive && (this.selectedTab === 'undervisningstillæg' || this.selectedTab === 'specialskoletillæg' || this.selectedTab === 'opgaver' || this.selectedTab === '(Lønbrøk)' && this.$store.getters.salarySystem === 'SD') && this.stateFilter === 'draft'
	      });
	    },
	    matchesStateFilter: function matchesStateFilter(supplement) {
	      var state = supplement.state || 'draft';
	      if (this.stateFilter === 'draft') {
	        return state === 'draft';
	      }
	      return state === 'approved';
	    },
	    employmentsForUser: function employmentsForUser(userId) {
	      return this.employmentsInUserIdHash[userId] || [];
	    },
	    selectableEmploymentsForUser: function selectableEmploymentsForUser(userId) {
	      return this.employmentsForUser(userId).filter(function (employment) {
	        return !employment.deleted && employment.employment_template_id != null && employment.employment_template_id !== '';
	      });
	    },
	    hasSelectableEmployment: function hasSelectableEmployment(supplement) {
	      if (!supplement.employment_id) return false;
	      return this.selectableEmploymentsForUser(supplement.user_id).some(function (employment) {
	        return employment.id === supplement.employment_id;
	      });
	    },
	    employmentLabel: function employmentLabel(employment) {
	      var number = employment.employment_number ? String(employment.employment_number) : '';
	      var title = employment.source_title || employment.title || 'Ansættelse';
	      return number ? number + ' - ' + title : title;
	    },
	    salaryCodeDisplay: function salaryCodeDisplay(supplement) {
	      if (this.$store.getters.salarySystem === 'SD') {
	        var salaryCode = this.salaryCodesById[supplement.salary_code_id];
	        if (salaryCode && salaryCode.tillaegsnummer != null && salaryCode.tillaegsnummer !== '') {
	          return salaryCode.tillaegsnummer;
	        }
	      }
	      return supplement.code;
	    },
	    costCenterDisplay: function costCenterDisplay(supplement) {
	      var costCenter = this.costCenterMap[supplement.cost_center_id];
	      if (!costCenter) return '—';
	      return this.costCenterLabel(costCenter);
	    },
	    costCenterLabel: function costCenterLabel(costCenter) {
	      var code = costCenter.code != null ? String(costCenter.code) : '';
	      var name = costCenter.name || '';
	      if (code && name && code !== name) return code + ' - ' + name;
	      return name || code || '—';
	    },
	    selectedEmploymentLabel: function selectedEmploymentLabel(supplement) {
	      var employment = this.employmentsForUser(supplement.user_id).find(function (emp) {
	        return emp.id === supplement.employment_id;
	      });
	      return employment ? this.employmentLabel(employment) : 'Ingen ansættelse';
	    },
	    onSelectEmployment: function onSelectEmployment(supplement, event) {
	      var value = event.target.value;
	      var employmentId = value ? parseInt(value, 10) : null;
	      this.persistEmployment(supplement, employmentId);
	    },
	    persistEmployment: function persistEmployment(supplement, employmentId) {
	      var _this12 = this;
	
	      if (this.savingEmploymentIds.includes(supplement.id)) return;
	      this.savingEmploymentIds.push(supplement.id);
	      _docendo2.default.updateSalarySupplement(this.schoolId, this.schoolYearId, supplement.id, supplement.user_id, employmentId, supplement.year_norm_hours, null, null, supplement.code, supplement.salary_code_id, supplement.cost_center_id, supplement.units, supplement.installments, supplement.units_per_installment, function (success) {
	        _this12.savingEmploymentIds = _this12.savingEmploymentIds.filter(function (id) {
	          return id !== supplement.id;
	        });
	        var idx = _this12.supplements.findIndex(function (s) {
	          return s.id === supplement.id;
	        });
	        if (idx > -1) {
	          _this12.$set(_this12.supplements, idx, (0, _assign2.default)({}, _this12.supplements[idx], { employment_id: employmentId }));
	        }
	        _eventbus2.default.toast = { text: 'Ansættelse opdateret', success: true, position: 'bottomLeft' };
	      }, function (failure) {
	        console.log(failure);
	        _this12.savingEmploymentIds = _this12.savingEmploymentIds.filter(function (id) {
	          return id !== supplement.id;
	        });
	        _eventbus2.default.toast = { text: 'Kunne ikke opdatere ansættelsen', success: false, position: 'bottomLeft' };
	      });
	    },
	    setIsCreateModal: function setIsCreateModal(bool) {
	      this.isCreateModal = bool;
	      if (!bool) {
	        this.theEditSupplementType = null;
	        this.editSupplement = null;
	      }
	    },
	    readSupplements: function readSupplements() {
	      var _this13 = this;
	
	      console.log('readSupplements');
	      this.isLoading = true;
	      if (!this.schoolYearId || !this.schoolId) {
	        return;
	      }
	      _docendo2.default.listSalarySupplements(this.schoolId, this.schoolYearId, function (success) {
	        if (success.status && success.status === 'error') {
	          _this13.supplements = [];
	        } else {
	          _this13.supplements = success;
	        }
	        _this13.isLoading = false;
	      });
	    },
	    createSupplement: function createSupplement(supplement) {
	      var _this14 = this;
	
	      this.isSubmitting = true;
	
	      var userId = supplement.userId,
	          employmentId = supplement.employmentId,
	          yearNormHours = supplement.yearNormHours,
	          startDate = supplement.startDate,
	          endDate = supplement.endDate,
	          code = supplement.code,
	          salaryCodeId = supplement.salaryCodeId,
	          costCenterId = supplement.costCenterId,
	          units = supplement.units,
	          installments = supplement.installments,
	          unitsPerInstallment = supplement.unitsPerInstallment;
	
	
	      _docendo2.default.createSalarySupplement(this.schoolId, this.schoolYearId, userId, employmentId, yearNormHours, startDate, endDate, code, salaryCodeId, costCenterId, units, installments, unitsPerInstallment, function (success) {
	        console.log({ success: success });
	        _this14.readSupplements();
	        _this14.isSubmitting = false;
	        _this14.setIsCreateModal(false);
	      }, function (failure) {
	        console.log(failure);
	        _this14.isSubmitting = false;
	      });
	    },
	    updateSupplement: function updateSupplement(supplement) {
	      var _this15 = this;
	
	      this.isSubmitting = true;
	
	      var id = supplement.id,
	          userId = supplement.userId,
	          employmentId = supplement.employmentId,
	          yearNormHours = supplement.yearNormHours,
	          startDate = supplement.startDate,
	          endDate = supplement.endDate,
	          code = supplement.code,
	          salaryCodeId = supplement.salaryCodeId,
	          costCenterId = supplement.costCenterId,
	          units = supplement.units,
	          installments = supplement.installments,
	          unitsPerInstallment = supplement.unitsPerInstallment;
	
	
	      _docendo2.default.updateSalarySupplement(this.schoolId, this.schoolYearId, id, userId, employmentId, yearNormHours, startDate, endDate, code, salaryCodeId, costCenterId, units, installments, unitsPerInstallment, function (success) {
	        console.log({ success: success });
	        _this15.readSupplements();
	        _this15.isSubmitting = false;
	        _this15.setIsCreateModal(false);
	      }, function (failure) {
	        console.log(failure);
	        _this15.isSubmitting = false;
	      });
	    },
	    dataToExcelSimple: function dataToExcelSimple() {
	      var _this16 = this;
	
	      var includeState = this.isInOpusModal && this.isSalaryIntegrationActive;
	      return this.supplementsFiltered.map(function (supplement) {
	        var row = {
	          'name': supplement.vUserName || '',
	          'identity': _this16.isInOpusModal ? _this16.selectedEmploymentLabel(supplement) : '',
	          'year_norm': supplement.year_norm_hours || '',
	          'period': _this16.formatPeriod(supplement.valid_period) || '',
	          'supplement_type': _this16.salaryCodeDisplay(supplement) || '',
	          'account': _this16.costCenterDisplay(supplement),
	          'units_in_period': _this16.formatDecimal(supplement.units) || '',
	          'installments': supplement.installments || '',
	          'units_per_month': _this16.formatDecimal(supplement.units_per_installment) || ''
	        };
	        if (includeState) {
	          row['state'] = _this16.stateLabel(supplement.state);
	        }
	        return row;
	      });
	    },
	    asyncLoadXLSXAndDownloadSimple: function asyncLoadXLSXAndDownloadSimple() {
	      var _this17 = this;
	
	      this.isDownloading = true;
	      if (window.XLSX && XLSX) {
	        this.downloadSimple();
	      } else {
	        var cdnXLSX = document.createElement('script');
	        cdnXLSX.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.mini.min.js');
	        document.head.appendChild(cdnXLSX);
	        var intervalTimer = setInterval(function (_) {
	          if (window.XLSX) {
	            clearInterval(intervalTimer);
	            XLSX = window.XLSX;
	            _this17.downloadSimple();
	          }
	        }, 500);
	      }
	    },
	    downloadSimple: function downloadSimple() {
	      var includeState = this.isInOpusModal && this.isSalaryIntegrationActive;
	      var headers = {
	        'name': 'Navn',
	        'identity': this.isInOpusModal ? 'Ansættelse' : 'Identitet',
	        'year_norm': 'Brutto årsnorm',
	        'period': 'Beregningsperiode',
	        'supplement_type': 'Lønkode',
	        'account': 'Omkostningssted',
	        'units_in_period': 'Enheder i periode',
	        'installments': 'Antal udbetalinger',
	        'units_per_month': 'Enh. pr måned'
	      };
	      if (includeState) {
	        headers['state'] = 'Status';
	      }
	
	      var rows = this.dataToExcelSimple();
	
	      rows.unshift(headers);
	
	      var sheet = XLSX.utils.json_to_sheet(rows, { skipHeader: true });
	      var wb = XLSX.utils.book_new();
	      XLSX.utils.book_append_sheet(wb, sheet, 'data');
	      var timestamp = (0, _moment2.default)().format('YYYY-MM-DD_HH-mm');
	      var filename = 'tillaeg_eksport_' + timestamp + '.xlsx';
	      XLSX.writeFile(wb, filename);
	
	      this.isDownloading = false;
	    }
	  },
	  created: function created() {
	    if (this.isInOpusModal) {
	      this.selectedTab = this.tabForBeregningType;
	
	      this.$store.dispatch('readEmployments');
	      this.emitApproveState();
	    }
	  },
	  mounted: function mounted() {
	    this.readSupplements();
	    this.$store.dispatch('readCostCenters');
	    this.$store.dispatch('readSalaryCodes');
	  }
	};

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TidsbegraensetUvModal',
	  components: { DModal: _DModal2.default, Loader: _Loader2.default },
	  data: function data() {
	    return {
	      userId: '',
	      employmentId: null,
	      salaryCodeId: null,
	      costCenterId: null,
	      schoolDaysInYear: '',
	      schoolDaysInPeriod: '',
	      adjustedHours: '',
	      graense: '750',
	      ansaettelsesgradPercent: null,
	      periodStart: null,
	      periodEnd: null,
	      yearNormHours: null,
	      totalUvHours: null,
	      scheduledInPeriod: null,
	      isLoading: false,
	      isLoadingScheduled: false,
	      isSaving: false
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.$store.getters.schoolYearId;
	    },
	    schoolYear: function schoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    salarySystem: function salarySystem() {
	      return this.$store.getters.salarySystem;
	    },
	    salaryTargetLabel: function salaryTargetLabel() {
	      return this.salarySystem === 'SD' ? 'SD' : 'OPUS';
	    },
	    submitButtonLabel: function submitButtonLabel() {
	      return 'Send til ' + this.salaryTargetLabel;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName || [];
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted || [];
	    },
	    selectableSalaryCodes: function selectableSalaryCodes() {
	      var isSd = this.salarySystem === 'SD';
	      return this.salaryCodes.filter(function (salaryCode) {
	        return isSd ? salaryCode.tillaegsnummer : salaryCode.loenart;
	      });
	    },
	    costCenters: function costCenters() {
	      return this.$store.getters.costCenters || [];
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash || {};
	    },
	    employmentTemplates: function employmentTemplates() {
	      return this.$store.getters.employmentTemplatesSorted || [];
	    },
	    userEmployments: function userEmployments() {
	      if (!this.userId) return [];
	      var isSd = this.salarySystem === 'SD';
	      var emps = this.employmentsInUserIdHash[this.userId] || [];
	      return emps.filter(function (emp) {
	        var sourceOk = isSd ? emp.source !== 'opus' : !emp.source || emp.source === 'opus';
	        return sourceOk && emp.employment_template_id != null && emp.employment_number && String(emp.employment_number).trim() !== '';
	      }).map(function (emp) {
	        return {
	          id: emp.id,
	          employment_template_id: emp.employment_template_id,
	          label: (emp.employment_number ? emp.employment_number + ' - ' : '') + (emp.source_title || emp.title || 'Ansættelse')
	        };
	      });
	    },
	    periodLabel: function periodLabel() {
	      if (!this.periodStart || !this.periodEnd) return '—';
	      return (0, _moment2.default)(this.periodStart).format('DD-MM-YYYY') + ' til ' + (0, _moment2.default)(this.periodEnd).format('DD-MM-YYYY');
	    },
	    g: function g() {
	      return this.ansaettelsesgradPercent != null ? this.ansaettelsesgradPercent / 100 : null;
	    },
	    uvOmregnetFuldtid: function uvOmregnetFuldtid() {
	      var t = this.parseNumber(this.adjustedHours);
	      var n = this.parseNumber(this.schoolDaysInPeriod);
	      var big = this.parseNumber(this.schoolDaysInYear);
	      if (t == null || n == null || big == null || !this.g || n === 0) return null;
	      return t / this.g * (big / n);
	    },
	    surplusFuldtid: function surplusFuldtid() {
	      if (this.uvOmregnetFuldtid == null) return null;
	      var limit = this.parseNumber(this.graense);
	      return this.uvOmregnetFuldtid - (limit != null ? limit : 0);
	    },
	    resultUnits: function resultUnits() {
	      if (this.surplusFuldtid == null) return null;
	      var n = this.parseNumber(this.schoolDaysInPeriod);
	      var big = this.parseNumber(this.schoolDaysInYear);
	      if (n == null || big == null || big === 0) return null;
	      var units = this.surplusFuldtid * this.g * (n / big);
	      return units > 0 ? units : 0;
	    },
	    installments: function installments() {
	      if (!this.periodStart || !this.periodEnd) return 1;
	      var start = (0, _moment2.default)(this.periodStart);
	      var end = (0, _moment2.default)(this.periodEnd);
	      var months = end.month() - start.month() + (end.year() - start.year()) * 12 + 1;
	      return months > 0 ? months : 1;
	    },
	    unitsPerInstallment: function unitsPerInstallment() {
	      if (this.resultUnits == null) return null;
	      var inst = this.installments;
	      return inst > 0 ? this.resultUnits / inst : this.resultUnits;
	    },
	    isCalcValid: function isCalcValid() {
	      var daysYear = this.parseNumber(this.schoolDaysInYear);
	      var daysPeriod = this.parseNumber(this.schoolDaysInPeriod);
	      var hours = this.parseNumber(this.adjustedHours);
	      return daysYear != null && daysYear > 0 && daysPeriod != null && daysPeriod > 0 && hours != null && hours >= 0 && this.g != null && this.g > 0;
	    },
	    isValid: function isValid() {
	      return !!this.userId && !!this.employmentId && !!this.salaryCodeId && this.isCalcValid && this.resultUnits != null && this.resultUnits > 0 && this.yearNormHours != null && !!this.periodStart && !!this.periodEnd;
	    }
	  },
	  methods: {
	    parseNumber: function parseNumber(value) {
	      if (value === '' || value == null) return null;
	      var parsed = parseFloat(String(value).replace(',', '.'));
	      return isNaN(parsed) ? null : parsed;
	    },
	    formatDecimal: function formatDecimal(value) {
	      var num = parseFloat(value);
	      return isNaN(num) ? '—' : num.toFixed(2).replace('.', ',');
	    },
	    formatPercent: function formatPercent(value) {
	      var num = parseFloat(value);
	      return isNaN(num) ? '—' : num.toFixed(2).replace('.', ',') + ' %';
	    },
	    costCenterLabel: function costCenterLabel(costCenter) {
	      var code = costCenter.code != null ? String(costCenter.code) : '';
	      var name = costCenter.name || '';
	      if (code && name && code !== name) return code + ' - ' + name;
	      return name || code;
	    },
	    normValue: function normValue(norm, title) {
	      var found = (norm || []).find(function (item) {
	        return item.title === title;
	      });
	      return found ? found.value : null;
	    },
	    useScheduled: function useScheduled() {
	      if (this.scheduledInPeriod != null) {
	        this.adjustedHours = String(this.scheduledInPeriod);
	      }
	    },
	    onUserChange: function onUserChange() {
	      var _this = this;
	
	      this.resetUserData();
	      this.employmentId = null;
	      if (this.userId) {
	        this.readUserYear();
	        this.$nextTick(function () {
	          if (_this.userEmployments.length === 1) {
	            _this.employmentId = _this.userEmployments[0].id;
	            _this.onEmploymentChange();
	          }
	        });
	      }
	    },
	    onEmploymentChange: function onEmploymentChange() {
	      var _this2 = this;
	
	      var emp = this.userEmployments.find(function (item) {
	        return item.id === _this2.employmentId;
	      });
	      if (!emp || emp.employment_template_id == null) return;
	      var template = this.employmentTemplates.find(function (tmpl) {
	        return tmpl.id === emp.employment_template_id;
	      });
	      if (template && template.hour_limit != null && template.hour_limit !== '') {
	        this.graense = String(parseFloat(template.hour_limit));
	      }
	    },
	    resetUserData: function resetUserData() {
	      this.ansaettelsesgradPercent = null;
	      this.periodStart = null;
	      this.periodEnd = null;
	      this.yearNormHours = null;
	      this.totalUvHours = null;
	      this.scheduledInPeriod = null;
	      this.adjustedHours = '';
	    },
	    readUserYear: function readUserYear() {
	      var _this3 = this;
	
	      this.isLoading = true;
	      _docendo2.default.schoolUserYearsList(this.schoolId, this.schoolYearId, this.userId, function (success) {
	        var userYear = success && success[0] ? success[0] : null;
	        var norm = userYear && userYear.norm ? userYear.norm : [];
	        var grad = _this3.normValue(norm, 'hidden_ansættelsesgrad');
	        _this3.ansaettelsesgradPercent = grad != null ? parseFloat(grad) : null;
	        _this3.periodStart = _this3.normValue(norm, 'hidden_periode_start');
	        _this3.periodEnd = _this3.normValue(norm, 'hidden_periode_end');
	        var brutto = _this3.normValue(norm, 'Bruttotid');
	        _this3.yearNormHours = brutto != null ? parseFloat(brutto) : null;
	        _this3.totalUvHours = userYear && userYear.assigned_teaching_hours != null ? parseFloat(userYear.assigned_teaching_hours) : null;
	        if (_this3.adjustedHours === '' && _this3.totalUvHours != null) {
	          _this3.adjustedHours = String(_this3.totalUvHours);
	        }
	        _this3.isLoading = false;
	        _this3.readScheduledHours();
	      }, function (failure) {
	        console.log(failure);
	        _this3.isLoading = false;
	      });
	    },
	    readScheduledHours: function readScheduledHours() {
	      var _this4 = this;
	
	      if (!this.userId || !this.periodStart || !this.periodEnd) {
	        this.isLoadingScheduled = false;
	        return;
	      }
	      this.isLoadingScheduled = true;
	      var fromDate = (0, _moment2.default)(this.periodStart).format('YYYY-MM-DD');
	      var toDate = (0, _moment2.default)(this.periodEnd).add(1, 'day').format('YYYY-MM-DD');
	      _docendo2.default.subjectActuals(this.schoolId, this.schoolYearId, this.userId, fromDate, toDate, function (success) {
	        var rows = Array.isArray(success) ? success : [];
	        var hours = rows.filter(function (row) {
	          return row.master_type === 'teaching';
	        }).reduce(function (sum, row) {
	          return sum + (parseFloat(row.actual) || 0);
	        }, 0);
	        _this4.scheduledInPeriod = hours;
	        _this4.isLoadingScheduled = false;
	      }, function (failure) {
	        console.log(failure);
	        _this4.scheduledInPeriod = null;
	        _this4.isLoadingScheduled = false;
	      });
	    },
	    create: function create() {
	      if (!this.isValid || this.isSaving) return;
	      var unitsPerInstallment = parseFloat(this.unitsPerInstallment.toFixed(4));
	      var startDate = (0, _moment2.default)(this.periodStart).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.periodEnd).format('YYYY-MM-DD');
	      this.isSaving = true;
	      if (this.salarySystem === 'SD') {
	        var tillaeg = {
	          user_id: this.userId,
	          salary_code_id: this.salaryCodeId,
	          startdato: startDate,
	          slutdato: endDate,
	          enheder: unitsPerInstallment
	        };
	        _docendo2.default.bulkCreateSilkeborgDataTillaeg(this.schoolId, [this.employmentId], tillaeg, this.onCreated, this.onCreateFailed);
	      } else {
	        var recurringPayment = {
	          startdato: startDate,
	          stopdato: endDate,
	          salary_code_id: this.salaryCodeId,
	          antal: unitsPerInstallment
	        };
	        if (this.costCenterId != null) {
	          recurringPayment.salary_cost_center_id = this.costCenterId;
	        }
	        _docendo2.default.createRecurringPaymentForEmployees(this.schoolId, [this.employmentId], recurringPayment, this.onCreated, this.onCreateFailed);
	      }
	    },
	    onCreated: function onCreated(success) {
	      this.isSaving = false;
	      if (success && success.status === 'error') {
	        _eventbus2.default.toast = { text: success.message || 'Kunne ikke sende fast tillæg til ' + this.salaryTargetLabel, success: false, position: 'bottomLeft' };
	        return;
	      }
	      _eventbus2.default.toast = { text: 'Fast tillæg sendt til ' + this.salaryTargetLabel + '. Følg status i Udbakke.', success: true, position: 'bottomLeft' };
	      this.$emit('created', success);
	    },
	    onCreateFailed: function onCreateFailed(failure) {
	      console.log(failure);
	      this.isSaving = false;
	      _eventbus2.default.toast = { text: failure && failure.message ? failure.message : 'Kunne ikke sende fast tillæg til ' + this.salaryTargetLabel, success: false, position: 'bottomLeft' };
	    }
	  }
	};

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'UvLimitTidsbegraensetModal',
	  components: { DModal: _DModal2.default },
	  props: {
	    schoolId: {
	      default: function _default() {
	        return null;
	      }
	    },
	    schoolYearId: {
	      default: function _default() {
	        return null;
	      }
	    },
	    userId: {
	      default: function _default() {
	        return null;
	      }
	    },
	    userName: {
	      type: String,
	      default: ''
	    },
	    employmentId: {
	      default: function _default() {
	        return null;
	      }
	    },
	    ansaettelsesgradPercent: {
	      default: function _default() {
	        return null;
	      }
	    },
	    yearNormHours: {
	      default: function _default() {
	        return null;
	      }
	    },
	    periodStart: {
	      default: function _default() {
	        return null;
	      }
	    },
	    periodEnd: {
	      default: function _default() {
	        return null;
	      }
	    },
	    assignedTeachingHours: {
	      default: function _default() {
	        return null;
	      }
	    },
	    initialGraense: {
	      default: function _default() {
	        return null;
	      }
	    },
	    salaryCodeId: {
	      default: function _default() {
	        return null;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      schoolDaysInYear: '',
	      schoolDaysInPeriod: '',
	      graense: this.initialGraense != null && this.initialGraense !== '' ? String(parseFloat(this.initialGraense)) : '750',
	      adjustedHours: this.assignedTeachingHours != null ? String(this.assignedTeachingHours) : '',
	      isSaving: false
	    };
	  },
	
	  computed: {
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted || [];
	    },
	    salaryCode: function salaryCode() {
	      var _this = this;
	
	      if (this.salaryCodeId == null) return null;
	      return this.salaryCodes.find(function (code) {
	        return String(code.id) === String(_this.salaryCodeId);
	      }) || null;
	    },
	    salaryCodeLabel: function salaryCodeLabel() {
	      if (!this.salaryCode) return '—';
	      return this.salaryCode.vSupplementTitle || this.salaryCode.code || '—';
	    },
	    periodLabel: function periodLabel() {
	      if (!this.periodStart || !this.periodEnd) return '—';
	      return (0, _moment2.default)(this.periodStart).format('DD-MM-YYYY') + ' til ' + (0, _moment2.default)(this.periodEnd).format('DD-MM-YYYY');
	    },
	    g: function g() {
	      return this.ansaettelsesgradPercent != null ? parseFloat(this.ansaettelsesgradPercent) / 100 : null;
	    },
	    uvOmregnetFuldtid: function uvOmregnetFuldtid() {
	      var t = this.parseNumber(this.adjustedHours);
	      var n = this.parseNumber(this.schoolDaysInPeriod);
	      var big = this.parseNumber(this.schoolDaysInYear);
	      if (t == null || n == null || big == null || !this.g || n === 0) return null;
	      return t / this.g * (big / n);
	    },
	    surplusFuldtid: function surplusFuldtid() {
	      if (this.uvOmregnetFuldtid == null) return null;
	      var limit = this.parseNumber(this.graense);
	      return this.uvOmregnetFuldtid - (limit != null ? limit : 0);
	    },
	    resultUnits: function resultUnits() {
	      if (this.surplusFuldtid == null) return null;
	      var n = this.parseNumber(this.schoolDaysInPeriod);
	      var big = this.parseNumber(this.schoolDaysInYear);
	      if (n == null || big == null || big === 0) return null;
	      var units = this.surplusFuldtid * this.g * (n / big);
	      return units > 0 ? units : 0;
	    },
	    installments: function installments() {
	      if (!this.periodStart || !this.periodEnd) return 1;
	      var start = (0, _moment2.default)(this.periodStart);
	      var end = (0, _moment2.default)(this.periodEnd);
	      var months = end.month() - start.month() + (end.year() - start.year()) * 12 + 1;
	      return months > 0 ? months : 1;
	    },
	    unitsPerInstallment: function unitsPerInstallment() {
	      if (this.resultUnits == null) return null;
	      var inst = this.installments;
	      return inst > 0 ? this.resultUnits / inst : this.resultUnits;
	    },
	    isCalcValid: function isCalcValid() {
	      var daysYear = this.parseNumber(this.schoolDaysInYear);
	      var daysPeriod = this.parseNumber(this.schoolDaysInPeriod);
	      var hours = this.parseNumber(this.adjustedHours);
	      return daysYear != null && daysYear > 0 && daysPeriod != null && daysPeriod > 0 && hours != null && hours >= 0 && this.g != null && this.g > 0;
	    },
	    isValid: function isValid() {
	      return !!this.userId && !!this.employmentId && !!this.salaryCodeId && this.isCalcValid && this.resultUnits != null && this.resultUnits > 0 && this.yearNormHours != null && !!this.periodStart && !!this.periodEnd;
	    }
	  },
	  methods: {
	    parseNumber: function parseNumber(value) {
	      if (value === '' || value == null) return null;
	      var parsed = parseFloat(String(value).replace(',', '.'));
	      return isNaN(parsed) ? null : parsed;
	    },
	    formatDecimal: function formatDecimal(value) {
	      var num = parseFloat(value);
	      return isNaN(num) ? '—' : num.toFixed(2).replace('.', ',');
	    },
	    formatPercent: function formatPercent(value) {
	      var num = parseFloat(value);
	      return isNaN(num) ? '—' : num.toFixed(2).replace('.', ',') + ' %';
	    },
	    generate: function generate() {
	      var _this2 = this;
	
	      if (!this.isValid || this.isSaving) return;
	      var units = parseFloat(this.resultUnits.toFixed(4));
	      var installments = this.installments;
	      var unitsPerInstallment = installments > 0 ? parseFloat((units / installments).toFixed(4)) : units;
	      var startDate = (0, _moment2.default)(this.periodStart).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.periodEnd).format('YYYY-MM-DD');
	      this.isSaving = true;
	      _docendo2.default.createSalarySupplement(this.schoolId, this.schoolYearId, this.userId, this.employmentId, this.yearNormHours, startDate, endDate, this.salaryCode ? this.salaryCode.code : '', this.salaryCodeId, null, units, installments, unitsPerInstallment, function (success) {
	        _this2.isSaving = false;
	        if (success && success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message || 'Kunne ikke danne UV-tillæg', success: false, position: 'bottomLeft' };
	          return;
	        }
	        _eventbus2.default.toast = { text: 'UV-tillæg dannet i listen', success: true, position: 'bottomLeft' };
	        _this2.$emit('created', success);
	      }, function (failure) {
	        console.log(failure);
	        _this2.isSaving = false;
	        _eventbus2.default.toast = { text: failure && failure.message ? failure.message : 'Kunne ikke danne UV-tillæg', success: false, position: 'bottomLeft' };
	      });
	    }
	  }
	};

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DoEmploymentTemplate = __webpack_require__(140);
	
	var _DoEmploymentTemplate2 = _interopRequireDefault(_DoEmploymentTemplate);
	
	var _UvLimitTidsbegraensetModal = __webpack_require__(1660);
	
	var _UvLimitTidsbegraensetModal2 = _interopRequireDefault(_UvLimitTidsbegraensetModal);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default, DoEmploymentTemplate: _DoEmploymentTemplate2.default, UvLimitTidsbegraensetModal: _UvLimitTidsbegraensetModal2.default, DoFiltersFilter: _DoFiltersFilter2.default, DDropdown: _DDropdown2.default, Loader: _Loader2.default, Tabs: _Tabs2.default },
	  props: {
	    schoolId: {
	      default: function _default() {
	        return null;
	      }
	    },
	    schoolYearId: {
	      default: function _default() {
	        return null;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isLoadingUserYears: false,
	      userYears: [],
	      isTemplateModalOpen: false,
	      editTemplate: null,
	      isSavingTemplateId: null,
	      selectedNames: [],
	      selectedGroups: [],
	      selectedEmploymentTitles: [],
	      selectedEmploymentIds: [],
	      selectedUserIdsWithoutEmployments: [],
	      isSavingBulkTemplates: false,
	      isSavingNewEmploymentUserId: null,
	      closeFiltersCount: 0,
	      isBulkMode: false,
	      templateTab: 'all',
	      addingForRowKey: null,
	      teachingHoursMap: {},
	      isLoadingTeachingHours: false,
	      employmentsLoadedOnce: false,
	      beregnRow: null,
	      uvHoursSort: null
	    };
	  },
	
	  computed: {
	    isSalaryIntegrationActive: function isSalaryIntegrationActive() {
	      var features = this.$store.getters.schoolFeatures || [];
	      return features.indexOf('kmd_opus_integration') > -1 || features.indexOf('silkeborg_data_integration') > -1;
	    },
	    poolsDeactivated: function poolsDeactivated() {
	      var settings = this.$store.state.schoolSettings;
	      return !!(settings && settings.deactivatePools);
	    },
	    emptyColspan: function emptyColspan() {
	      var count = this.showSpecialSkoleSalaryCodeColumn ? 12 : 11;
	      if (this.isBulkMode) count++;
	      if (this.isSalaryIntegrationActive) count++;
	      return count;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash;
	    },
	    employmentTemplates: function employmentTemplates() {
	      return this.$store.getters.employmentTemplatesSorted;
	    },
	    showSpecialSkoleSalaryCodeColumn: function showSpecialSkoleSalaryCodeColumn() {
	      if (this.$store.getters.salarySystem === 'SD') return false;
	      return this.employmentTemplates.some(function (template) {
	        return template.special_hour_limit_salary_code_id != null && template.special_hour_limit_salary_code_id !== '';
	      });
	    },
	    employmentTemplateMap: function employmentTemplateMap() {
	      var map = {};
	      this.employmentTemplates.forEach(function (template) {
	        map[template.id] = template;
	      });
	      return map;
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted;
	    },
	    salaryCodeMap: function salaryCodeMap() {
	      var map = {};
	      this.salaryCodes.forEach(function (salaryCode) {
	        map[salaryCode.id] = salaryCode.vTitle;
	      });
	      return map;
	    },
	    userYearMap: function userYearMap() {
	      var map = {};
	      this.userYears.forEach(function (userYear) {
	        map[userYear.user_id] = userYear;
	      });
	      return map;
	    },
	    rows: function rows() {
	      var _this = this;
	
	      var rows = [];
	      this.users.forEach(function (user) {
	        var employments = (_this.employmentsInUserIdHash[user.id] || []).filter(function (employment) {
	          return !employment.deleted;
	        }).sort(function (a, b) {
	          return _this.employmentTitle(a).localeCompare(_this.employmentTitle(b), 'da-DK');
	        });
	
	        if (employments.length < 1) {
	          rows.push({
	            key: 'user-' + user.id + '-no-employment',
	            user: user,
	            employment: null,
	            template: null
	          });
	          return;
	        }
	
	        employments.forEach(function (employment, index) {
	          rows.push({
	            key: 'employment-' + employment.id,
	            user: user,
	            employment: employment,
	            template: _this.employmentTemplateMap[employment.employment_template_id] || null,
	            isLastForUser: index === employments.length - 1
	          });
	        });
	      });
	      return rows;
	    },
	    filteredRows: function filteredRows() {
	      var _this2 = this;
	
	      var rows = this.rows.filter(function (row) {
	        return _this2.matchesFilters(row.user) && _this2.matchesEmploymentTitle(row) && _this2.matchesTemplateTab(row);
	      });
	      if (!this.uvHoursSort) return rows;
	      var dir = this.uvHoursSort === 'asc' ? 1 : -1;
	      return rows.slice().sort(function (a, b) {
	        var aHours = parseFloat(_this2.assignedTeachingHours(a.user.id)) || 0;
	        var bHours = parseFloat(_this2.assignedTeachingHours(b.user.id)) || 0;
	        return (aHours - bHours) * dir;
	      });
	    },
	    rowsWithTemplate: function rowsWithTemplate() {
	      var _this3 = this;
	
	      return this.rows.filter(function (row) {
	        return _this3.matchesFilters(row.user) && _this3.matchesEmploymentTitle(row) && _this3.rowHasTemplate(row);
	      }).length;
	    },
	    rowsWithoutTemplate: function rowsWithoutTemplate() {
	      var _this4 = this;
	
	      return this.rows.filter(function (row) {
	        return _this4.matchesFilters(row.user) && _this4.matchesEmploymentTitle(row) && !_this4.rowHasTemplate(row);
	      }).length;
	    },
	    visibleEmploymentRows: function visibleEmploymentRows() {
	      return this.filteredRows.filter(function (row) {
	        return row.employment;
	      });
	    },
	    tidsbegraensetCount: function tidsbegraensetCount() {
	      var _this5 = this;
	
	      return this.rows.filter(function (row) {
	        return _this5.isTidsbegraensetRow(row);
	      }).length;
	    },
	    areAllVisibleEmploymentsSelected: function areAllVisibleEmploymentsSelected() {
	      var _this6 = this;
	
	      var selectableRows = this.filteredRows.filter(function (row) {
	        return _this6.isSelectableRow(row);
	      });
	      return selectableRows.length > 0 && selectableRows.every(function (row) {
	        return row.employment ? _this6.isEmploymentSelected(row.employment.id) : _this6.isUserWithoutEmploymentSelected(row.user.id);
	      });
	    },
	    selectedCount: function selectedCount() {
	      return this.selectedEmploymentIds.length + this.selectedUserIdsWithoutEmployments.length;
	    },
	    uniqueNames: function uniqueNames() {
	      var names = this.rows.map(function (row) {
	        return row.user.name;
	      }).filter(function (name) {
	        return !!name;
	      });
	      return this.uniqueSorted(names);
	    },
	    uniqueGroups: function uniqueGroups() {
	      var groups = [];
	      this.rows.forEach(function (row) {
	        if (row.user.user_tags && row.user.user_tags.length > 0) {
	          groups = groups.concat(row.user.user_tags);
	        }
	      });
	      return this.uniqueSorted(groups);
	    },
	    uniqueEmploymentTitles: function uniqueEmploymentTitles() {
	      var _this7 = this;
	
	      var titles = this.rows.filter(function (row) {
	        return row.employment;
	      }).map(function (row) {
	        return _this7.employmentTitle(row.employment);
	      }).filter(function (title) {
	        return !!title;
	      });
	      return this.uniqueSorted(titles);
	    },
	    employmentsLoading: function employmentsLoading() {
	      return this.$store.state.employments.isLoadingEmploymentsTypesForSchool;
	    },
	    isLoading: function isLoading() {
	      var initialEmploymentsLoading = !this.employmentsLoadedOnce && this.employmentsLoading;
	      return this.isLoadingUserYears || initialEmploymentsLoading || this.poolsDeactivated && this.isLoadingTeachingHours;
	    }
	  },
	  watch: {
	    employmentsLoading: function employmentsLoading(loading) {
	      if (!loading) {
	        this.employmentsLoadedOnce = true;
	      }
	    }
	  },
	  methods: {
	    uniqueSorted: function uniqueSorted(items) {
	      var seen = {};
	      var unique = [];
	      items.forEach(function (item) {
	        if (!seen[item]) {
	          seen[item] = true;
	          unique.push(item);
	        }
	      });
	      return unique.sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    matchesFilters: function matchesFilters(user) {
	      var _this8 = this;
	
	      if (this.selectedNames.length > 0 && this.selectedNames.indexOf(user.name) < 0) {
	        return false;
	      }
	      if (this.selectedGroups.length > 0) {
	        if (!user.user_tags || user.user_tags.length < 1) return false;
	        return user.user_tags.some(function (tag) {
	          return _this8.selectedGroups.indexOf(tag) > -1;
	        });
	      }
	      return true;
	    },
	    matchesEmploymentTitle: function matchesEmploymentTitle(row) {
	      if (this.selectedEmploymentTitles.length < 1) return true;
	      if (!row.employment) return false;
	      return this.selectedEmploymentTitles.indexOf(this.employmentTitle(row.employment)) > -1;
	    },
	    rowHasTemplate: function rowHasTemplate(row) {
	      return !!(row.template && row.template.hour_limit);
	    },
	    matchesTemplateTab: function matchesTemplateTab(row) {
	      if (this.templateTab === 'with') return this.rowHasTemplate(row);
	      if (this.templateTab === 'without') return !this.rowHasTemplate(row);
	      return true;
	    },
	    toggleName: function toggleName(name) {
	      this.toggleInArray(this.selectedNames, name);
	    },
	    clearNames: function clearNames() {
	      this.selectedNames = [];
	    },
	    toggleGroup: function toggleGroup(group) {
	      this.toggleInArray(this.selectedGroups, group);
	    },
	    clearGroups: function clearGroups() {
	      this.selectedGroups = [];
	    },
	    toggleEmploymentTitle: function toggleEmploymentTitle(title) {
	      this.toggleInArray(this.selectedEmploymentTitles, title);
	    },
	    clearEmploymentTitles: function clearEmploymentTitles() {
	      this.selectedEmploymentTitles = [];
	    },
	    closeFilters: function closeFilters() {
	      this.closeFiltersCount++;
	    },
	    toggleUvHoursSort: function toggleUvHoursSort() {
	      if (this.uvHoursSort === 'desc') {
	        this.uvHoursSort = 'asc';
	      } else if (this.uvHoursSort === 'asc') {
	        this.uvHoursSort = null;
	      } else {
	        this.uvHoursSort = 'desc';
	      }
	    },
	    enableBulkMode: function enableBulkMode() {
	      this.isBulkMode = true;
	    },
	    disableBulkMode: function disableBulkMode() {
	      this.isBulkMode = false;
	      this.selectedEmploymentIds = [];
	      this.selectedUserIdsWithoutEmployments = [];
	    },
	    toggleInArray: function toggleInArray(arr, value) {
	      var idx = arr.indexOf(value);
	      if (idx > -1) {
	        arr.splice(idx, 1);
	      } else {
	        arr.push(value);
	      }
	    },
	    isEmploymentSelected: function isEmploymentSelected(employmentId) {
	      return this.selectedEmploymentIds.indexOf(employmentId) > -1;
	    },
	    isUserWithoutEmploymentSelected: function isUserWithoutEmploymentSelected(userId) {
	      return this.selectedUserIdsWithoutEmployments.indexOf(userId) > -1;
	    },
	    isRowSelected: function isRowSelected(row) {
	      return row.employment ? this.isEmploymentSelected(row.employment.id) : this.isUserWithoutEmploymentSelected(row.user.id);
	    },
	    isSelectableRow: function isSelectableRow(row) {
	      if (!row.employment && this.isSalaryIntegrationActive) return false;
	      return !!(row.employment || !row.employment && row.user);
	    },
	    toggleEmployment: function toggleEmployment(employment) {
	      if (!employment) return;
	      this.toggleInArray(this.selectedEmploymentIds, employment.id);
	    },
	    toggleUserWithoutEmployment: function toggleUserWithoutEmployment(user) {
	      if (!user) return;
	      this.toggleInArray(this.selectedUserIdsWithoutEmployments, user.id);
	    },
	    toggleRow: function toggleRow(row) {
	      if (!this.isSelectableRow(row)) return;
	      if (row.employment) {
	        this.toggleEmployment(row.employment);
	      } else {
	        this.toggleUserWithoutEmployment(row.user);
	      }
	    },
	    toggleAllVisibleEmployments: function toggleAllVisibleEmployments() {
	      var _this9 = this;
	
	      var employmentIds = this.visibleEmploymentRows.map(function (row) {
	        return row.employment.id;
	      });
	      var userIds = this.filteredRows.filter(function (row) {
	        return !row.employment && _this9.isSelectableRow(row);
	      }).map(function (row) {
	        return row.user.id;
	      });
	      if (this.areAllVisibleEmploymentsSelected) {
	        this.selectedEmploymentIds = this.selectedEmploymentIds.filter(function (id) {
	          return employmentIds.indexOf(id) < 0;
	        });
	        this.selectedUserIdsWithoutEmployments = this.selectedUserIdsWithoutEmployments.filter(function (id) {
	          return userIds.indexOf(id) < 0;
	        });
	        return;
	      }
	      employmentIds.forEach(function (id) {
	        if (!_this9.isEmploymentSelected(id)) {
	          _this9.selectedEmploymentIds.push(id);
	        }
	      });
	      userIds.forEach(function (id) {
	        if (!_this9.isUserWithoutEmploymentSelected(id)) {
	          _this9.selectedUserIdsWithoutEmployments.push(id);
	        }
	      });
	    },
	    employmentTitle: function employmentTitle(employment) {
	      return employment.source_title ? employment.source_title : employment.title;
	    },
	    templateOptionLabel: function templateOptionLabel(template) {
	      if (!template.hour_limit) return template.title;
	      return template.title + '  ·  UV > ' + template.hour_limit;
	    },
	    assignedTeachingHours: function assignedTeachingHours(userId) {
	      if (this.poolsDeactivated) {
	        var hours = this.teachingHoursMap[userId];
	        return hours != null ? hours : 0;
	      }
	      var userYear = this.userYearMap[userId];
	      return userYear && userYear.assigned_teaching_hours ? userYear.assigned_teaching_hours : 0;
	    },
	    normValue: function normValue(userId, title) {
	      var userYear = this.userYearMap[userId];
	      var norm = userYear && userYear.norm ? userYear.norm : [];
	      var found = norm.find(function (item) {
	        return item.title === title;
	      });
	      return found ? found.value : null;
	    },
	    employmentPercentage: function employmentPercentage(userId) {
	      var value = this.normValue(userId, 'hidden_ansættelsesgrad');
	      return value !== null ? parseFloat(value) : null;
	    },
	    weeklyHours: function weeklyHours(userId) {
	      var percentage = this.employmentPercentage(userId);
	      return percentage !== null ? percentage / 100 * 37 : null;
	    },
	    bruttoTime: function bruttoTime(userId) {
	      var value = this.normValue(userId, 'Bruttotid');
	      return value !== null ? parseFloat(value) : null;
	    },
	    periodStart: function periodStart(userId) {
	      return this.normValue(userId, 'hidden_periode_start');
	    },
	    periodEnd: function periodEnd(userId) {
	      return this.normValue(userId, 'hidden_periode_end');
	    },
	    ansaettelsesgradIssue: function ansaettelsesgradIssue(userId) {
	      var value = this.employmentPercentage(userId);
	      return value === null || value === 0;
	    },
	    bruttotidIssue: function bruttotidIssue(userId) {
	      var value = this.bruttoTime(userId);
	      return value === null || value === 0;
	    },
	    startDateIssue: function startDateIssue(userId) {
	      return !this.periodStart(userId);
	    },
	    endDateIssue: function endDateIssue(userId) {
	      return !this.periodEnd(userId);
	    },
	    isAugustFirst: function isAugustFirst(value) {
	      if (!value) return false;
	      var date = (0, _moment2.default)(value);
	      return date.month() === 7 && date.date() === 1;
	    },
	    isJulyLast: function isJulyLast(value) {
	      if (!value) return false;
	      var date = (0, _moment2.default)(value);
	      return date.month() === 6 && date.date() === 31;
	    },
	    startIsDeviant: function startIsDeviant(row) {
	      var start = this.periodStart(row.user.id);
	      return !!start && !this.isAugustFirst(start);
	    },
	    endIsDeviant: function endIsDeviant(row) {
	      var end = this.periodEnd(row.user.id);
	      return !!end && !this.isJulyLast(end);
	    },
	    isTidsbegraensetRow: function isTidsbegraensetRow(row) {
	      if (!row.employment) return false;
	      if (!this.rowHasTemplate(row)) return false;
	      var start = this.periodStart(row.user.id);
	      var end = this.periodEnd(row.user.id);
	      if (!start || !end) return false;
	      if (!(parseFloat(this.assignedTeachingHours(row.user.id)) > 0)) return false;
	      return this.startIsDeviant(row) || this.endIsDeviant(row);
	    },
	    openBeregn: function openBeregn(row) {
	      if (!row.employment) return;
	      this.beregnRow = row;
	    },
	    onBeregnCreated: function onBeregnCreated() {
	      this.beregnRow = null;
	      this.$emit('supplement-created');
	    },
	    dataIssues: function dataIssues(userId) {
	      var issues = [];
	      if (this.ansaettelsesgradIssue(userId)) issues.push('Ansættelsesgrad');
	      if (this.bruttotidIssue(userId)) issues.push('Bruttotid');
	      if (this.startDateIssue(userId)) issues.push('Startdato');
	      if (this.endDateIssue(userId)) issues.push('Slutdato');
	      return issues;
	    },
	    hasDataIssues: function hasDataIssues(userId) {
	      return this.dataIssues(userId).length > 0;
	    },
	    dataIssuesTitle: function dataIssuesTitle(userId) {
	      var issues = this.dataIssues(userId);
	      if (issues.length === 0) return '';
	      return 'Mangler data for at kunne hentes med: ' + issues.join(', ');
	    },
	    formatDecimal: function formatDecimal(value) {
	      var num = parseFloat(value);
	      return isNaN(num) ? '—' : num.toFixed(2).replace('.', ',');
	    },
	    formatDate: function formatDate(value) {
	      if (!value) return '—';
	      return (0, _moment2.default)(value).format('DD-MM-YYYY');
	    },
	    salaryCodeTitle: function salaryCodeTitle(salaryCodeId) {
	      return this.salaryCodeMap[salaryCodeId] || salaryCodeId || '—';
	    },
	    salaryCodeLoenart: function salaryCodeLoenart(salaryCodeId) {
	      var salaryCode = this.salaryCodes.find(function (sc) {
	        return String(sc.id) === String(salaryCodeId);
	      });
	      if (!salaryCode) return salaryCodeId || '—';
	      return salaryCode.loenart || salaryCode.code || '—';
	    },
	    readUserYears: function readUserYears() {
	      var _this10 = this;
	
	      if (!this.schoolId || !this.schoolYearId) return;
	      this.isLoadingUserYears = true;
	      _docendo2.default.schoolUserYearsList(this.schoolId, this.schoolYearId, null, function (success) {
	        _this10.userYears = success || [];
	        _this10.isLoadingUserYears = false;
	      }, function (failure) {
	        console.log(failure);
	        _this10.isLoadingUserYears = false;
	      });
	    },
	    readTeachingHours: function readTeachingHours() {
	      var _this11 = this;
	
	      if (!this.schoolId || !this.schoolYearId) return;
	      this.isLoadingTeachingHours = true;
	      _docendo2.default.readUserHoursForSchoolYear(this.schoolId, this.schoolYearId, null, function (success) {
	        var map = {};
	        var rows = success && success.teaching_hours || [];
	        rows.forEach(function (row) {
	          if (row.user_id == null) return;
	          map[row.user_id] = (map[row.user_id] || 0) + (parseFloat(row.hours) || 0);
	        });
	        _this11.teachingHoursMap = map;
	        _this11.isLoadingTeachingHours = false;
	      }, function (failure) {
	        console.log(failure);
	        _this11.isLoadingTeachingHours = false;
	      }, true);
	    },
	    setEmploymentTemplate: function setEmploymentTemplate(employment, employmentTemplateId) {
	      var _this12 = this;
	
	      if (!employmentTemplateId) {
	        this.clearEmploymentTemplate(employment);
	        return;
	      }
	      this.isSavingTemplateId = employment.id;
	      _docendo2.default.assignEmploymentTemplateToEmployment(employment.school_id, employmentTemplateId, [employment.id], function (success) {
	        _this12.isSavingTemplateId = null;
	        _this12.$store.dispatch('readEmployments');
	      }, function (failure) {
	        console.log(failure);
	        _this12.isSavingTemplateId = null;
	      });
	    },
	    clearEmploymentTemplate: function clearEmploymentTemplate(employment) {
	      var _this13 = this;
	
	      this.isSavingTemplateId = employment.id;
	
	      _docendo2.default.updateEmployment(employment.school_id, employment.user_id, employment.id, false, null, null, null, null, null, function (success) {
	        _this13.isSavingTemplateId = null;
	        _this13.$store.dispatch('readEmployments');
	        _eventbus2.default.toast = { text: 'Stillingskategori er fjernet', success: true, position: 'bottomLeft' };
	      }, function (failure) {
	        console.log(failure);
	        _this13.isSavingTemplateId = null;
	        _eventbus2.default.toast = { text: 'Kunne ikke fjerne stillingskategori', success: false, position: 'bottomLeft' };
	      });
	    },
	    createEmploymentForUser: function createEmploymentForUser(user, employmentTemplateId) {
	      var _this14 = this;
	
	      var template = this.employmentTemplateMap[employmentTemplateId];
	      if (!template) return;
	      this.isSavingNewEmploymentUserId = user.id;
	      _docendo2.default.createEmployment(this.schoolId, user.id, null, template.title, template.id, !!template.manual_salary, function (data) {
	        _this14.isSavingNewEmploymentUserId = null;
	        if (data && data.status === 'error') {
	          _eventbus2.default.toast = { text: data.message || 'Kunne ikke oprette ansættelse', success: false, position: 'bottomLeft' };
	          return;
	        }
	        _this14.$store.dispatch('readEmployments');
	        _eventbus2.default.toast = { text: 'Ansættelse er oprettet', success: true, position: 'bottomLeft' };
	      }, function (failure) {
	        console.log(failure);
	        _this14.isSavingNewEmploymentUserId = null;
	        _eventbus2.default.toast = { text: failure && failure.message ? failure.message : 'Kunne ikke oprette ansættelse', success: false, position: 'bottomLeft' };
	      });
	    },
	    assignTemplateToSelected: function assignTemplateToSelected(template) {
	      var _this15 = this;
	
	      if (this.selectedCount === 0 || !template) return;
	      this.isSavingBulkTemplates = true;
	      var pending = 0;
	      var failed = false;
	
	      var finish = function finish() {
	        pending--;
	        if (pending > 0) return;
	        _this15.isSavingBulkTemplates = false;
	        if (!failed) {
	          _this15.$store.dispatch('readEmployments');
	          _eventbus2.default.toast = { text: 'Stillingskategori er sat på valgte', success: true, position: 'bottomLeft' };
	          _this15.disableBulkMode();
	        }
	      };
	
	      var handle = function handle(data) {
	        if (data && data.status === 'error') {
	          failed = true;
	          _eventbus2.default.toast = { text: data.message || 'Kunne ikke sætte stillingskategori på valgte', success: false, position: 'bottomLeft' };
	        }
	        finish();
	      };
	
	      var fail = function fail(failure) {
	        console.log(failure);
	        failed = true;
	        _eventbus2.default.toast = { text: failure && failure.message ? failure.message : 'Kunne ikke sætte stillingskategori på valgte', success: false, position: 'bottomLeft' };
	        finish();
	      };
	
	      if (this.selectedEmploymentIds.length > 0) {
	        pending++;
	        _docendo2.default.assignEmploymentTemplateToEmployment(this.schoolId, template.id, this.selectedEmploymentIds, handle, fail);
	      }
	
	      if (this.selectedUserIdsWithoutEmployments.length > 0) {
	        pending++;
	        _docendo2.default.bulkCreateEmployment(this.schoolId, this.selectedUserIdsWithoutEmployments, [template.title], !!template.manual_salary, template.id, handle, fail);
	      }
	    },
	    openCreateTemplate: function openCreateTemplate() {
	      this.editTemplate = null;
	      this.isTemplateModalOpen = true;
	    },
	    openEditTemplate: function openEditTemplate(template) {
	      this.editTemplate = template;
	      this.isTemplateModalOpen = true;
	    },
	    closeTemplateModal: function closeTemplateModal() {
	      this.editTemplate = null;
	      this.isTemplateModalOpen = false;
	    },
	    onTemplateSaved: function onTemplateSaved() {
	      this.closeTemplateModal();
	      this.$store.dispatch('readEmploymentTemplates');
	      this.$store.dispatch('readEmployments');
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('readEmployments');
	    this.$store.dispatch('readEmploymentTemplates');
	    this.$store.dispatch('readSalaryCodes');
	    this.readUserYears();
	    if (this.poolsDeactivated) {
	      this.readTeachingHours();
	    }
	  }
	};

/***/ }),
/* 785 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    tag: {
	      type: String,
	      default: ''
	    }
	  },
	  methods: {
	    remove: function remove() {
	      this.$emit('remove', this.tag);
	    }
	  }
	};

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(14);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _DSelectUsers = __webpack_require__(67);
	
	var _DSelectUsers2 = _interopRequireDefault(_DSelectUsers);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userLocale = window.USER && window.USER.language ? window.USER.language : 'da';
	
	var I18N = {
	  da: {
	    groups: 'Grupper',
	    create_a_new_group: 'Opret ny gruppe',
	    all: 'Alle',
	    in_the_group: 'i gruppen',
	    create_group: 'Opret gruppe',
	    edit_group: 'Redigér gruppe',
	    delete_group: 'Slet gruppe',
	    name_for_group: 'Navn på gruppen',
	    select_a_user: 'Vælg mindst én bruger (tilføj flere senere)',
	    created: 'Oprettet',
	    updated: 'Opdateret',
	    deleted: 'Slettet',
	    add: 'Tilføj',
	    drag_and_drop_explained: 'Drag and drop bruger til gruppe'
	  },
	  nb: {
	    groups: 'Grupper',
	    create_a_new_group: 'Opprett ny gruppe',
	    all: 'Alle',
	    in_the_group: 'i gruppen',
	    create_group: 'Opprett gruppe',
	    edit_group: 'Rediger gruppe',
	    delete_group: 'Slett gruppe',
	    name_for_group: 'Navn på gruppe',
	    select_a_user: 'Velg minst en bruker',
	    created: 'Opprettet',
	    updated: 'Oppdatert',
	    deleted: 'Slettet',
	    add: 'Legg til',
	    drag_and_drop_explained: 'Dra og slipp bruker til gruppe'
	  },
	  en: {
	    groups: 'Groups',
	    create_a_new_group: 'Create new group',
	    all: 'All',
	    in_the_group: 'in the group',
	    create_group: 'Create group',
	    edit_group: 'Edit group',
	    delete_group: 'Delete group',
	    name_for_group: 'Name for group',
	    select_a_user: 'Select minimum one user',
	    created: 'Created',
	    updated: 'Updated',
	    deleted: 'Deleted',
	    add: 'Add',
	    drag_and_drop_explained: 'Drag and drop user to group'
	  }
	};
	
	exports.default = {
	  components: { Loader: _Loader2.default, DSelectUsers: _DSelectUsers2.default, DModal: _DModal2.default, DDropdown: _DDropdown2.default, DSelect: _DSelect2.default },
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        el.focus();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      tags: [],
	      activeTag: null,
	      isModal: false,
	      theEditTag: null,
	      theDeleteTag: null,
	      tagTitle: '',
	      selectedUserIds: [],
	      isButtonLoading: false,
	      dragItem: null,
	      dragEvt: null,
	      usersSelectedForDrag: [],
	      isShowDragExplainer: false,
	      isLoading: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usersSortedOnName', 'allUsersInHash']), {
	    schoolId: function schoolId() {
	      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : window.SCHOOL.id;
	    },
	    locale: function locale() {
	      return window.USER && window.USER.language ? window.USER.language : 'en';
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    sortedTags: function sortedTags() {
	      return this.tags.sort(function (a, b) {
	        return a.localeCompare(b, userLocale, {
	          numeric: true,
	          sensitivity: 'base'
	        });
	      });
	    },
	    tagsWithProps: function tagsWithProps() {
	      var _this = this;
	
	      return this.sortedTags.map(function (tag) {
	        var tagObj = {
	          v_name: tag,
	          v_number_of_persons: _this.getUsersWithTag(tag).length
	        };
	        return tagObj;
	      });
	    },
	    usersWithProps: function usersWithProps() {
	      var _this2 = this;
	
	      return this.usersSortedOnName.map(function (user) {
	        var iSSelectedForDrag = _this2.usersSelectedForDrag.indexOf(user.id) > -1;
	        _this2.$set(user, 'v_isSelectedForDrag', iSSelectedForDrag);
	        return user;
	      });
	    },
	    filteredUsers: function filteredUsers() {
	      return this.getUsersWithTag(this.activeTag);
	    },
	    filteredUserIds: function filteredUserIds() {
	      return this.filteredUsers.map(function (user) {
	        return user.id;
	      });
	    },
	    usersForDSelect: function usersForDSelect() {
	      var _this3 = this;
	
	      return this.usersSortedOnName.filter(function (user) {
	        return _this3.filteredUserIds.indexOf(user.id) < 0;
	      });
	    }
	  }),
	  methods: {
	    setActiveTag: function setActiveTag(tag) {
	      this.activeTag = tag;
	      this.usersSelectedForDrag = [];
	    },
	    setUsersSelectedForDrag: function setUsersSelectedForDrag(user) {
	      var idx = this.usersSelectedForDrag.indexOf(user.id);
	      if (idx < 0) {
	        this.usersSelectedForDrag.push(user.id);
	      } else {
	        this.usersSelectedForDrag.splice(idx, 1);
	      }
	    },
	    setSelectedUsers: function setSelectedUsers(users) {
	      this.selectedUserIds = users.map(function (user) {
	        return user.id;
	      });
	    },
	    setIsModal: function setIsModal(boolean) {
	      this.isModal = boolean;
	      if (!boolean) {
	        this.theDeleteTag = null;
	        this.theEditTag = null;
	        this.tagTitle = '';
	        this.selectedUserIds = [];
	      }
	    },
	    isSubmitted: function isSubmitted(tagTitle) {
	      this.isButtonLoading = false;
	      this.getTags();
	      this.reset();
	      this.setIsModal(false);
	      this.$store.dispatch('getUsers');
	      if (tagTitle) {
	        this.activeTag = tagTitle;
	      }
	    },
	    reset: function reset() {
	      this.activeTag = null;
	      this.theDeleteTag = null;
	      this.theEditTag = null;
	      this.tagTitle = '';
	    },
	    setTheDeleteTag: function setTheDeleteTag(tag) {
	      this.theDeleteTag = tag;
	      this.setIsModal(true);
	    },
	    setTheEditTag: function setTheEditTag(tag) {
	      this.theEditTag = tag;
	      this.tagTitle = tag.v_name;
	      this.setIsModal(true);
	    },
	    getTags: function getTags() {
	      var _this4 = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this4.tags = data;
	      });
	    },
	    getUsersWithTag: function getUsersWithTag(tag) {
	      if (!tag) {
	        return this.usersSortedOnName;
	      }
	      return this.usersWithProps.filter(function (user) {
	        return user.user_tags.indexOf(tag) > -1;
	      });
	    },
	    toggleAll: function toggleAll() {
	      var _this5 = this;
	
	      if (this.usersSelectedForDrag.length > 0) {
	        this.usersSelectedForDrag = [];
	      } else {
	        this.usersSelectedForDrag = [];
	        this.filteredUserIds.forEach(function (userId) {
	          _this5.usersSelectedForDrag.push(userId);
	        });
	      }
	    },
	    createTag: function createTag() {
	      var _this6 = this;
	
	      var successText = this.i18n['created'];
	      if (this.tagTitle.length < 1 || this.selectedUserIds.length === 0) {
	        return;
	      }
	      this.isButtonLoading = true;
	      _docendo2.default.schoolTagsBulkCreate(this.schoolId, [this.tagTitle], this.selectedUserIds, function (success) {
	        _this6.isSubmitted();
	        _eventbus2.default.toast = { text: successText, 'success': true };
	      }, function (failure) {
	        _this6.isButtonLoading = false;
	        _eventbus2.default.toast = { text: _this6.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    deleteTag: function deleteTag() {
	      var _this7 = this;
	
	      var successText = this.i18n['deleted'];
	      this.isButtonLoading = true;
	      _docendo2.default.schoolTagsBulkDelete(this.schoolId, [this.theDeleteTag.v_name], this.filteredUserIds, function (success) {
	        _this7.isSubmitted();
	        _eventbus2.default.toast = { text: successText, 'success': true };
	      }, function (failure) {
	        _this7.isSubmitted();
	        _eventbus2.default.toast = { text: _this7.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    editTag: function editTag() {
	      var _this8 = this;
	
	      if (this.tagTitle.length < 1) {
	        return;
	      }
	      var successText = this.i18n['updated'];
	      this.isButtonLoading = true;
	      _docendo2.default.schoolTagsBulkDelete(this.schoolId, [this.theEditTag.v_name], this.filteredUserIds, function (success) {
	        _docendo2.default.schoolTagsBulkCreate(_this8.schoolId, [_this8.tagTitle], _this8.filteredUserIds, function (success) {
	          _this8.isSubmitted(_this8.tagTitle);
	          _eventbus2.default.toast = { text: successText, 'success': true };
	        }, function (failure) {
	          _this8.isButtonLoading = false;
	          _eventbus2.default.toast = { text: _this8.$t('vue2.toast.something_went_wrong'), 'success': false };
	        });
	      }, function (failure) {
	        _this8.isSubmitted();
	        _eventbus2.default.toast = { text: _this8.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    dragStart: function dragStart(item, evt) {
	      this.isShowDragExplainer = false;
	      this.dragItem = item;
	      var idx = this.usersSelectedForDrag.indexOf(item.id);
	      if (idx < 0) {
	        this.usersSelectedForDrag.push(item.id);
	      }
	      this.dragEvt = evt;
	      this.dragEvt.target.classList.add('isDragging');
	      var el = this.$refs.customdrag;
	      el.style.display = 'flex';
	      evt.dataTransfer.setDragImage(el, 0, 0);
	    },
	    dragEnd: function dragEnd() {
	      if (!this.dragItem) {
	        return;
	      }
	      this.$refs.customdrag.style.display = 'none';
	      this.dragEvt.target.classList.remove('isDragging');
	      this.dragEvt.target.style.display = '';
	      this.usersSelectedForDrag = [];
	      this.dragItem = null;
	      this.dragEvt = null;
	    },
	    dragEnter: function dragEnter(tag, evt) {
	      if (!this.dragItem) {
	        return;
	      }
	      evt.target.classList.add('isDragEnter');
	    },
	    dragLeave: function dragLeave(evt) {
	      if (!this.dragItem) {
	        return;
	      }
	      evt.target.classList.remove('isDragEnter');
	    },
	    drop: function drop(tag) {
	      if (!this.dragItem) {
	        return;
	      }
	      this.addTagToItems(tag);
	      this.dragEnd();
	      var elements = this.$refs.droppable_elements;
	      for (var i = 0; i < elements.length; i++) {
	        elements[i].classList.remove('isDragEnter');
	      }
	    },
	    addTagToItems: function addTagToItems(tag) {
	      var _this9 = this;
	
	      this.isLoading = true;
	      var successText = this.i18n['updated'];
	
	      var users = this.usersSelectedForDrag.map(function (userId) {
	        return _this9.allUsersInHash[userId];
	      });
	      var userIdsToAdd = users.filter(function (user) {
	        return user.user_tags.indexOf(tag.v_name) < 0;
	      }).map(function (user) {
	        return user.id;
	      });
	      _docendo2.default.schoolTagsBulkCreate(this.schoolId, [tag.v_name], userIdsToAdd, function (success) {
	        _eventbus2.default.toast = { text: successText, 'success': true };
	        _this9.isSubmitted(_this9.activeTag);
	        _this9.isLoading = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this9.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    deleteTagFromUser: function deleteTagFromUser(user, tag) {
	      var _this10 = this;
	
	      this.isLoading = true;
	      _docendo2.default.schoolTagsBulkDelete(this.schoolId, [tag], [user.id], function (success) {
	        _this10.isSubmitted(_this10.activeTag);
	        _this10.isLoading = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this10.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    addUserToTag: function addUserToTag(user) {
	      var _this11 = this;
	
	      var tags = [this.activeTag];
	      var userIds = [user.id];
	      this.isLoading = true;
	      _docendo2.default.schoolTagsBulkCreate(this.schoolId, tags, userIds, function (success) {
	        console.log('success', success);
	        _this11.isSubmitted(_this11.activeTag);
	        _this11.isLoading = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this11.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.getTags();
	  }
	};

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tag = __webpack_require__(400);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _vueClickaway = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userLocale = window.USER && window.USER.language ? window.USER.language : 'da';
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { tag: _Tag2.default },
	  props: {
	    tags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    searchText: {
	      default: ''
	    },
	    users: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedTags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    columns: {
	      type: Boolean,
	      default: false
	    },
	    showHowMany: {
	      type: Boolean,
	      default: true
	    },
	    isShowNoTagsText: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      active: false,
	      showDropdown: false,
	      showInput: false,
	      tagText: ''
	    };
	  },
	
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        el.focus();
	      }
	    }
	  },
	  watch: {
	    active: function active() {
	      var _this = this;
	
	      if (this.active) {
	        setTimeout(function () {
	          _this.showDropdown = true;
	        }, 0);
	      } else {
	        this.showDropdown = false;
	      }
	    }
	  },
	  computed: {
	    sortedTags: function sortedTags() {
	      return this.tags.sort(function (a, b) {
	        return a.localeCompare(b, userLocale, {
	          numeric: true,
	          sensitivity: 'base'
	        });
	      });
	    },
	    filteredTags: function filteredTags() {
	      var _this2 = this;
	
	      return this.sortedTags.filter(function (tag) {
	        return tag !== '' ? tag.match(new RegExp(_this2.tagText, 'i')) : '';
	      });
	    },
	    personsWithTags: function personsWithTags() {
	      if (!this.showHowMany) {
	        return 0;
	      }
	      return this.users.filter(function (user) {
	        return user.tags && user.tags.length > 0;
	      });
	    },
	    notSelectedTags: function notSelectedTags() {
	      var _this3 = this;
	
	      return this.filteredTags.filter(function (tag) {
	        return _this3.selectedTags.indexOf(tag) < 0;
	      });
	    },
	    schoolid: function schoolid() {
	      return window.SCHOOL.id;
	    }
	  },
	  methods: {
	    hideActive: function hideActive() {
	      this.tagText = '';
	      this.active = false;
	    },
	    setTag: function setTag(tag) {
	      this.$emit('set', tag);
	      this.hideActive();
	    },
	    howManyWithTag: function howManyWithTag(tag) {
	      var arr = this.personsWithTags.filter(function (user) {
	        return user.tags.indexOf(tag) > -1;
	      });
	      return arr.length;
	    },
	    removeTag: function removeTag(tag) {
	      this.$emit('remove', tag);
	    }
	  }
	};

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _set = __webpack_require__(27);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _from = __webpack_require__(32);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _TaskOverviewUser = __webpack_require__(103);
	
	var _TaskOverviewUser2 = _interopRequireDefault(_TaskOverviewUser);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default, Loader: _Loader2.default, DoFiltersFilter: _DoFiltersFilter2.default, TaskOverviewUser: _TaskOverviewUser2.default, ChangeSchoolYear: _ChangeSchoolYear2.default },
	  props: {
	    tags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      isDeleting: false,
	      isLoadingPrint: false,
	      isPrinting: false,
	      rowsToPrint: [],
	      isDeleteWarningActive: false,
	      versions: [],
	      selectedIds: [],
	      pendingDeleteIds: [],
	      selectedPersons: [],
	      selectedTitles: [],
	      selectedGroups: [],
	      sortKey: 'name',
	      sortDir: 'asc',
	      activeVersion: null,
	      activeUser: null
	    };
	  },
	
	  watch: {
	    schoolYearId: function schoolYearId() {
	      this.selectedIds = [];
	      this.pendingDeleteIds = [];
	      this.selectedPersons = [];
	      this.selectedTitles = [];
	      this.selectedGroups = [];
	      this.activeVersion = null;
	      this.activeUser = null;
	      this.readAllVersions();
	    },
	    filteredRows: function filteredRows(rows) {
	      var visibleIds = {};
	      rows.forEach(function (row) {
	        visibleIds[row.id] = true;
	      });
	      this.selectedIds = this.selectedIds.filter(function (id) {
	        return visibleIds[id];
	      });
	    }
	  },
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.$store.getters.schoolYearId;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    rows: function rows() {
	      var _this = this;
	
	      return this.versions.filter(function (version) {
	        return version.id;
	      }).map(function (version) {
	        var user = _this.allUsersInHash[version.user_id];
	        var title = version.title ? version.title : (0, _moment2.default)(version.created_at).format('LLL');
	        return {
	          id: version.id,
	          userId: version.user_id,
	          isKnownUser: !!user,
	          name: user ? user.name : '#' + version.user_id,
	          tags: user && user.user_tags ? user.user_tags : [],
	          title: title,
	          createdAt: version.created_at,
	          createdAtFormatted: (0, _moment2.default)(version.created_at).format('LLL'),
	          version: (0, _assign2.default)({}, version, { vTitle: title })
	        };
	      }).sort(function (a, b) {
	        var byName = a.name.localeCompare(b.name);
	        if (byName !== 0) {
	          return byName;
	        }
	        return new Date(b.createdAt) - new Date(a.createdAt);
	      });
	    },
	    personOptions: function personOptions() {
	      var names = this.rows.filter(function (row) {
	        return row.isKnownUser;
	      }).map(function (row) {
	        return row.name;
	      });
	      return (0, _from2.default)(new _set2.default(names));
	    },
	    titleOptions: function titleOptions() {
	      var titles = this.rows.map(function (row) {
	        return row.title;
	      });
	      return (0, _from2.default)(new _set2.default(titles));
	    },
	    filteredRows: function filteredRows() {
	      var _this2 = this;
	
	      return this.rows.filter(function (row) {
	        if (_this2.selectedPersons.length > 0 && _this2.selectedPersons.indexOf(row.name) < 0) {
	          return false;
	        }
	        if (_this2.selectedTitles.length > 0 && _this2.selectedTitles.indexOf(row.title) < 0) {
	          return false;
	        }
	        if (_this2.selectedGroups.length > 0 && !_this2.selectedGroups.some(function (group) {
	          return row.tags.indexOf(group) > -1;
	        })) {
	          return false;
	        }
	        return true;
	      });
	    },
	    sortedRows: function sortedRows() {
	      var dir = this.sortDir === 'desc' ? -1 : 1;
	      var key = this.sortKey;
	      return this.filteredRows.slice().sort(function (a, b) {
	        if (key === 'createdAt') {
	          return (new Date(a.createdAt) - new Date(b.createdAt)) * dir;
	        }
	        return String(a[key]).localeCompare(String(b[key])) * dir;
	      });
	    },
	    isAllFilteredSelected: function isAllFilteredSelected() {
	      var _this3 = this;
	
	      return this.filteredRows.length > 0 && this.filteredRows.every(function (row) {
	        return _this3.selectedIds.indexOf(row.id) > -1;
	      });
	    },
	    selectedRows: function selectedRows() {
	      var _this4 = this;
	
	      return this.sortedRows.filter(function (row) {
	        return _this4.selectedIds.indexOf(row.id) > -1;
	      });
	    }
	  },
	  methods: {
	    toggleGroup: function toggleGroup(group) {
	      var idx = this.selectedGroups.indexOf(group);
	      if (idx > -1) {
	        this.selectedGroups.splice(idx, 1);
	      } else {
	        this.selectedGroups.push(group);
	      }
	    },
	    clearGroups: function clearGroups() {
	      this.selectedGroups = [];
	    },
	    togglePerson: function togglePerson(person) {
	      var idx = this.selectedPersons.indexOf(person);
	      if (idx > -1) {
	        this.selectedPersons.splice(idx, 1);
	      } else {
	        this.selectedPersons.push(person);
	      }
	    },
	    clearPersons: function clearPersons() {
	      this.selectedPersons = [];
	    },
	    toggleTitle: function toggleTitle(title) {
	      var idx = this.selectedTitles.indexOf(title);
	      if (idx > -1) {
	        this.selectedTitles.splice(idx, 1);
	      } else {
	        this.selectedTitles.push(title);
	      }
	    },
	    clearTitles: function clearTitles() {
	      this.selectedTitles = [];
	    },
	    setSort: function setSort(key) {
	      if (this.sortKey === key) {
	        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
	      } else {
	        this.sortKey = key;
	        this.sortDir = 'asc';
	      }
	    },
	    isSelected: function isSelected(id) {
	      return this.selectedIds.indexOf(id) > -1;
	    },
	    toggleRow: function toggleRow(id) {
	      var idx = this.selectedIds.indexOf(id);
	      if (idx > -1) {
	        this.selectedIds.splice(idx, 1);
	      } else {
	        this.selectedIds.push(id);
	      }
	    },
	    openRow: function openRow(row) {
	      this.activeUser = this.userForRow(row);
	      this.activeVersion = row.version;
	    },
	    userForRow: function userForRow(row) {
	      return this.allUsersInHash[row.userId] || {
	        id: row.userId,
	        name: row.name,
	        user_tags: row.tags
	      };
	    },
	    printRow: function printRow(row) {
	      this.startPrint([row]);
	    },
	    startPrint: function startPrint(rows) {
	      var _this5 = this;
	
	      var toPrint = Array.isArray(rows) && rows.length ? rows : this.selectedRows;
	      if (toPrint.length < 1 || this.isLoadingPrint) {
	        return;
	      }
	      this.rowsToPrint = toPrint;
	      this.isLoadingPrint = true;
	      this.isPrinting = true;
	      this.$nextTick(function (_) {
	        _this5.$nextTick(function (_) {
	          _this5.isLoadingPrint = false;
	          _this5.print();
	        });
	      });
	    },
	    print: function print() {
	      var _this6 = this;
	
	      var printRoot = document.getElementById('printSelectedTaskOverviews');
	      if (!printRoot) {
	        this.isPrinting = false;
	        this.rowsToPrint = [];
	        return;
	      }
	      var i18nTaskOverview = this.$t('vue2.task_versions.task_overview');
	      var prtHtml = printRoot.innerHTML;
	      var stylesHtml = '';
	
	      var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')));
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var node = _arr[_i];
	        stylesHtml += node.outerHTML;
	      }
	      var pageBreakStyles = '<style>@media print {\n        #printSelectedTaskOverviews .to-user { page-break-after: always; break-after: page; }\n        #printSelectedTaskOverviews .to-user:last-child { page-break-after: auto; break-after: auto; }\n      }</style>';
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	      if (!WinPrint) {
	        this.isPrinting = false;
	        this.rowsToPrint = [];
	        return;
	      }
	      WinPrint.document.write('<!DOCTYPE html><html id="html-bg-white"><head><title>' + i18nTaskOverview + '</title>' + stylesHtml + pageBreakStyles + '</head><body><div id="printSelectedTaskOverviews">' + prtHtml + '</div></body></html>');
	      var afterPrint = function afterPrint() {
	        WinPrint.close();
	        _this6.isPrinting = false;
	        _this6.rowsToPrint = [];
	      };
	      WinPrint.onafterprint = afterPrint;
	      setTimeout(function (_) {
	        WinPrint.document.close();
	        WinPrint.focus();
	        WinPrint.print();
	      }, 1000);
	    },
	    toggleSelectAll: function toggleSelectAll() {
	      var _this7 = this;
	
	      if (this.isAllFilteredSelected) {
	        var filteredIds = this.filteredRows.map(function (row) {
	          return row.id;
	        });
	        this.selectedIds = this.selectedIds.filter(function (id) {
	          return filteredIds.indexOf(id) < 0;
	        });
	      } else {
	        this.filteredRows.forEach(function (row) {
	          if (_this7.selectedIds.indexOf(row.id) < 0) {
	            _this7.selectedIds.push(row.id);
	          }
	        });
	      }
	    },
	    askDelete: function askDelete() {
	      if (this.selectedIds.length < 1) {
	        return;
	      }
	      this.pendingDeleteIds = this.selectedIds.slice();
	      this.isDeleteWarningActive = true;
	    },
	    askDeleteActive: function askDeleteActive() {
	      if (!this.activeVersion) {
	        return;
	      }
	      this.pendingDeleteIds = [this.activeVersion.id];
	      this.isDeleteWarningActive = true;
	    },
	    askDeleteRow: function askDeleteRow(row) {
	      this.pendingDeleteIds = [row.id];
	      this.isDeleteWarningActive = true;
	    },
	    deleteConfirmed: function deleteConfirmed() {
	      var _this8 = this;
	
	      if (this.pendingDeleteIds.length < 1 || this.isDeleting) {
	        return;
	      }
	      this.isDeleting = true;
	      var ids = this.pendingDeleteIds.slice();
	      var firstRow = this.rows.find(function (row) {
	        return row.id === ids[0];
	      });
	      var userId = firstRow ? firstRow.userId : null;
	      _docendo2.default.bulkDeleteTaskOverviews(this.schoolId, this.schoolYearId, userId, ids, function (success) {
	        _this8.isDeleting = false;
	        _this8.isDeleteWarningActive = false;
	        if (success && success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, success: false };
	          return;
	        }
	        _this8.versions = _this8.versions.filter(function (version) {
	          return ids.indexOf(version.id) < 0;
	        });
	        _this8.selectedIds = _this8.selectedIds.filter(function (id) {
	          return ids.indexOf(id) < 0;
	        });
	        _this8.pendingDeleteIds = [];
	        if (_this8.activeVersion && ids.indexOf(_this8.activeVersion.id) > -1) {
	          _this8.activeVersion = null;
	          _this8.activeUser = null;
	        }
	        _eventbus2.default.toast = { text: 'Slettet', success: true };
	      }, function (failure) {
	        _this8.isDeleting = false;
	        _eventbus2.default.toast = { text: 'Noget gik galt', success: false };
	      });
	    },
	    closeModal: function closeModal() {
	      this.$emit('close');
	    },
	    readAllVersions: function readAllVersions() {
	      var _this9 = this;
	
	      this.isLoading = true;
	      _docendo2.default.readAllTaskOverviewVersions(this.schoolId, this.schoolYearId, function (success) {
	        _this9.isLoading = false;
	        if (success && success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, success: false };
	          return;
	        }
	        _this9.versions = Array.isArray(success) ? success : [];
	      }, function (failure) {
	        _this9.isLoading = false;
	        _eventbus2.default.toast = { text: 'Noget gik galt', success: false };
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readAllVersions();
	  }
	};

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _TaggingFilter = __webpack_require__(43);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _vuex = __webpack_require__(14);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default, DModal: _DModal2.default, filterTags: _TaggingFilter2.default },
	  data: function data() {
	    return {
	      isSaving: false,
	      selectedUsers: [],
	      appliedFilters: [],
	      tags: [],
	      isLoadingTags: false,
	      newVersionTitle: '',
	      theTab: 1,
	      theFAQAcc: null
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usersSortedOnName']), {
	    schoolId: function schoolId() {
	      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : this.$store.getters.schoolId ? this.$store.getters.schoolId : window.SCHOOL.id;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    usersSortedOnNameWithTags: function usersSortedOnNameWithTags() {
	      return this.usersSortedOnName.map(function (user) {
	        user.tags = user.user_tags;
	        return user;
	      });
	    },
	    filteredUsers: function filteredUsers() {
	      var _this = this;
	
	      var passedUsers = this.usersSortedOnName;
	
	      var _loop = function _loop(i) {
	        passedUsers = passedUsers.filter(function (user) {
	          return user.user_tags && user.user_tags.indexOf(_this.appliedFilters[i]) > -1;
	        });
	      };
	
	      for (var i = 0; i < this.appliedFilters.length; i++) {
	        _loop(i);
	      }
	      return passedUsers;
	    }
	  }),
	  methods: {
	    start: function start(el) {
	      el.style.height = el.scrollHeight + 'px';
	    },
	    end: function end(el) {
	      el.style.height = '';
	    },
	    setTheFAQAcc: function setTheFAQAcc(num) {
	      if (this.theFAQAcc === num) {
	        this.theFAQAcc = null;
	      } else {
	        this.theFAQAcc = num;
	      }
	    },
	    getTheFAQAcc: function getTheFAQAcc(num) {
	      return this.theFAQAcc === num;
	    },
	    toggleAll: function toggleAll() {
	      var _this2 = this;
	
	      if (this.selectedUsers.length > 0) {
	        this.selectedUsers = [];
	      } else {
	        this.selectedUsers = [];
	        this.filteredUsers.forEach(function (user) {
	          return _this2.selectedUsers.push(user.id);
	        });
	      }
	    },
	    getIsUserSelected: function getIsUserSelected(user) {
	      var idx = this.selectedUsers.findIndex(function (selectedUser) {
	        return selectedUser === user.id;
	      });
	      return idx > -1;
	    },
	    toggleUser: function toggleUser(user) {
	      var idx = this.selectedUsers.findIndex(function (selectedUser) {
	        return selectedUser === user.id;
	      });
	      if (idx > -1) {
	        this.selectedUsers.splice(idx, 1);
	      } else {
	        this.selectedUsers.push(user.id);
	      }
	    },
	    setTagFromFilter: function setTagFromFilter(tag) {
	      this.selectedUsers = [];
	      this.appliedFilters.push(tag);
	    },
	    removeTagFromFilter: function removeTagFromFilter(tag) {
	      this.selectedUsers = [];
	      this.appliedFilters.splice(this.appliedFilters.indexOf(tag), 1);
	    },
	    readTags: function readTags() {
	      var _this3 = this;
	
	      this.isLoadingTags = true;
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this3.tags = data;
	        _this3.isLoadingTags = false;
	      });
	    },
	    close: function close() {
	      this.reset();
	      this.$emit('close');
	    },
	    save: function save() {
	      var _this4 = this;
	
	      if (this.selectedUsers.length < 1) {
	        return;
	      }
	      this.isSaving = true;
	      _docendo2.default.bulkCreateTaskOverview(this.schoolId, this.activeSchoolYear.id, this.selectedUsers, this.newVersionTitle, function (success) {
	        _this4.isSaving = false;
	        _eventbus2.default.toast = { text: 'Gemt', 'success': true };
	        _this4.close();
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Noget gik galt', 'success': false };
	      });
	    },
	    reset: function reset() {
	      this.isSaving = false;
	      this.selectedUsers = [];
	      this.newVersionTitle = '';
	      this.theTab = 1;
	    }
	  },
	  mounted: function mounted() {
	    var _this5 = this;
	
	    this.readTags();
	    this.$nextTick(function (_) {
	      _this5.$refs.version_name_input.focus();
	    });
	  }
	};

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _TaskOverviewSettingsCategoriesTasks = __webpack_require__(1667);
	
	var _TaskOverviewSettingsCategoriesTasks2 = _interopRequireDefault(_TaskOverviewSettingsCategoriesTasks);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _TaskOverviewSettingsCategories = __webpack_require__(1665);
	
	var _TaskOverviewSettingsCategories2 = _interopRequireDefault(_TaskOverviewSettingsCategories);
	
	var _TaskOverviewSettingsCategoriesCreate = __webpack_require__(1666);
	
	var _TaskOverviewSettingsCategoriesCreate2 = _interopRequireDefault(_TaskOverviewSettingsCategoriesCreate);
	
	var _TaskOverviewSettingsUserTasks = __webpack_require__(1671);
	
	var _TaskOverviewSettingsUserTasks2 = _interopRequireDefault(_TaskOverviewSettingsUserTasks);
	
	var _TaskOverviewSettingsGuide = __webpack_require__(1669);
	
	var _TaskOverviewSettingsGuide2 = _interopRequireDefault(_TaskOverviewSettingsGuide);
	
	var _TaskOverviewSettingsSettings = __webpack_require__(1670);
	
	var _TaskOverviewSettingsSettings2 = _interopRequireDefault(_TaskOverviewSettingsSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    TaskOverviewSettingsGuide: _TaskOverviewSettingsGuide2.default,
	    TaskOverviewSettingsUserTasks: _TaskOverviewSettingsUserTasks2.default,
	    TaskOverviewSettingsCategories: _TaskOverviewSettingsCategories2.default,
	    TaskOverviewSettingsCategoryCreate: _TaskOverviewSettingsCategoriesCreate2.default,
	    TaskOverviewSettingsSettings: _TaskOverviewSettingsSettings2.default,
	    Loader: _Loader2.default,
	    DModal: _DModal2.default,
	    TaskOverviewSettingsCategoriesTasks: _TaskOverviewSettingsCategoriesTasks2.default
	  },
	  props: {
	    isSupplements: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isWatchGuide: false,
	      tabs: [{ id: 1, title: '1. Opret og organiser kategorier' }, { id: 2, title: '2. Tilpas kategorier til brikker' }, { id: 3, title: '3. Lav yderligere indstillinger' }, { id: 4, title: '4. Se opgaveoversigter' }],
	      theActiveTab: 1,
	      isLoadingSubjects: true,
	      subjects: [],
	      taskCategories: [],
	      isLoadingTaskCategories: true,
	      isCreateCategory: false,
	      theEditTask: null,
	      theActiveUserIdForExample: null,
	      tags: []
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.$store.getters.schoolYearId;
	    },
	    schoolYear: function schoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    dbSubjectTypes: function dbSubjectTypes() {
	      return this.$store.state.subjects.dbSubjectTypes;
	    },
	    isInitLoading: function isInitLoading() {
	      return this.isLoadingSubjects || this.isLoadingTaskCategories;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    taskCategoriesSorted: function taskCategoriesSorted() {
	      return this.taskCategories.sort(function (a, b) {
	        return a.rank - b.rank;
	      });
	    }
	  },
	  watch: {
	    schoolYearId: function schoolYearId(val) {
	      this.readSubjects();
	      this.readTaskCategories();
	    }
	  },
	  methods: {
	    setTheActiveUserIdForExample: function setTheActiveUserIdForExample(val) {
	      this.theActiveUserIdForExample = val;
	    },
	    onSetEditTask: function onSetEditTask(evt) {
	      this.theEditTask = evt;
	    },
	    updateSubjects: function updateSubjects(updates) {
	      var _this = this;
	
	      updates.forEach(function (subjectUpdate) {
	        var idx = _this.subjects.findIndex(function (subject) {
	          return subject.id === subjectUpdate.id;
	        });
	        if (idx !== -1) {
	          if (_this.isSupplements) {
	            _this.$set(_this.subjects, idx, (0, _extends3.default)({}, _this.subjects[idx], {
	              salary_code_id: subjectUpdate.salary_code_id,
	              salary_cost_center_id: subjectUpdate.salary_cost_center_id
	            }));
	          } else {
	            _this.$set(_this.subjects, idx, (0, _extends3.default)({}, _this.subjects[idx], {
	              selected_task_category_id: subjectUpdate.selected_task_category_id
	            }));
	          }
	        }
	      });
	    },
	    onNewCategory: function onNewCategory(theNewCategory) {
	      this.taskCategories.push(theNewCategory);
	      this.isCreateCategory = false;
	    },
	    onDeleteTaskCategory: function onDeleteTaskCategory(theDeletedCategoryId) {
	      var idx = this.taskCategories.findIndex(function (cat) {
	        return cat.id === theDeletedCategoryId;
	      });
	      this.taskCategories.splice(idx, 1);
	    },
	    onUpdateCategory: function onUpdateCategory(theUpdatedCategory) {
	      var idx = this.taskCategories.findIndex(function (cat) {
	        return cat.id === theUpdatedCategory.id;
	      });
	      this.$set(this.taskCategories, idx, theUpdatedCategory);
	    },
	    setCreateCategory: function setCreateCategory(bool) {
	      this.isCreateCategory = bool;
	    },
	    onClose: function onClose() {
	      this.$emit('close');
	    },
	    setTheActiveTab: function setTheActiveTab(tabId) {
	      this.theActiveTab = tabId;
	    },
	    readSubjects: function readSubjects() {
	      var _this2 = this;
	
	      this.isLoadingSubjects = true;
	      _docendo2.default.readSubjectCalendars(this.schoolId, this.schoolYearId, function (data) {
	        _this2.isLoadingSubjects = false;
	        _this2.subjects = data;
	      }, function (failure) {
	        console.log('failed read subjects');
	      });
	    },
	    readTaskCategories: function readTaskCategories() {
	      var _this3 = this;
	
	      this.isLoadingTaskCategories = true;
	      _docendo2.default.readTaskCategories(this.schoolId, this.schoolYearId, function (data) {
	        _this3.isLoadingTaskCategories = false;
	        _this3.taskCategories = data && data.length > 0 ? data : [];
	      });
	    },
	    readTags: function readTags() {
	      var _this4 = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this4.tags = data;
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.isSupplements) {
	      this.theActiveTab = 2;
	    }
	  },
	  mounted: function mounted() {
	    if (this.schoolYearId && this.schoolId) {
	      this.readSubjects();
	      this.readTaskCategories();
	      this.readTags();
	    }
	  }
	};

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vuedraggable = __webpack_require__(108);
	
	var _vuedraggable2 = _interopRequireDefault(_vuedraggable);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default, draggable: _vuedraggable2.default },
	  props: {
	    schoolId: {},
	    schoolYearId: {},
	    schoolYear: {
	      name: ''
	    },
	    taskCategories: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    dbSubjectTypes: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    locale: {
	      default: 'da'
	    },
	    subjects: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        el.focus();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      taskCategoriesOrder: [],
	      theEditTask: null,
	      theUpdatingTaskId: null,
	      selectedItem: null,
	      theDeleteTaskCategoryId: null,
	      theDeletedCategoryId: null,
	      dragEvt: null,
	      draggedSubjectType: null,
	      draggedFromCategoryId: null,
	      oldCategoryName: ''
	    };
	  },
	
	  computed: {
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings || {};
	    },
	    theDeleteTaskCategory: function theDeleteTaskCategory() {
	      var _this = this;
	
	      return this.theDeleteTaskCategoryId !== null ? this.taskCategoriesOrder.find(function (taskCat) {
	        return taskCat.id === _this.theDeleteTaskCategoryId * 1;
	      }) || null : null;
	    },
	    dbSubjectTypesTranslated: function dbSubjectTypesTranslated() {
	      var _this2 = this;
	
	      return this.dbSubjectTypes.map(function (subjectType) {
	        return {
	          key: subjectType.key,
	          v_title: _this2.getTranslatedSubjectType(subjectType) };
	      }).sort(function (a, b) {
	        return a.v_title.localeCompare(b.v_title);
	      });
	    },
	    getTaskCategoriesOrder: function getTaskCategoriesOrder() {
	      var _this3 = this;
	
	      return this.taskCategoriesOrder.filter(function (taskCat) {
	        return taskCat.id !== _this3.theDeleteTaskCategoryId;
	      });
	    },
	    schoolSettingShownOwnPools: function schoolSettingShownOwnPools() {
	      return this.$store.getters.shownOwnPools;
	    }
	  },
	  watch: {
	    taskCategories: function taskCategories(val) {
	      this.setAllCategories();
	    }
	  },
	  methods: {
	    getIsUsedOnSubjects: function getIsUsedOnSubjects(taskCategory) {
	      return this.subjects.filter(function (subject) {
	        return subject.selected_task_category_id === taskCategory.id;
	      });
	    },
	    resetDrag: function resetDrag() {
	      this.dragEvt.target.classList.remove('isDragging');
	      this.dragEvt.target.style.display = '';
	      this.dragEvt = null;
	      this.draggedSubjectType = null;
	      this.draggedFromCategoryId = null;
	    },
	    dragStart: function dragStart(subjectType, draggedFromCategoryId, evt) {
	      this.draggedSubjectType = subjectType;
	      this.draggedFromCategoryId = draggedFromCategoryId;
	      this.dragEvt = evt;
	      this.dragEvt.target.classList.add('isDragging');
	    },
	    dragEnd: function dragEnd() {
	      if (!this.dragEvt) {
	        return;
	      }
	      this.resetDrag();
	    },
	    dragEnter: function dragEnter(taskCategory, evt) {
	      if (!this.dragEvt) {
	        return;
	      }
	      evt.target.classList.add('isDragEnter');
	    },
	    dragLeave: function dragLeave(evt) {
	      if (!this.dragEvt) {
	        return;
	      }
	      evt.target.classList.remove('isDragEnter');
	    },
	    drop: function drop(taskCategory, evt) {
	      if (!this.dragEvt) {
	        return;
	      }
	      if (this.draggedFromCategoryId !== taskCategory.id) {
	        this.onAddSubjectType(taskCategory, this.draggedSubjectType.key);
	      }
	      this.dragEnd();
	      var elements = this.$refs.droppable_elements;
	      for (var i = 0; i < elements.length; i++) {
	        elements[i].classList.remove('isDragEnter');
	      }
	    },
	    setTheDeleteTaskCategory: function setTheDeleteTaskCategory(taskCategory) {
	      if (!taskCategory) {
	        this.setEditTask(null);
	        this.theDeleteTaskCategoryId = null;
	      }
	      this.theDeleteTaskCategoryId = taskCategory.id;
	    },
	    getFilteredDbSubjectTypes: function getFilteredDbSubjectTypes(taskCategory) {
	      var excludedTypes = ['absence', 'flexin', 'flexout', 'with_kids', 'without_kids', 'exercise', 'reservation', 'frame'];
	      var allExcludedTypes = excludedTypes.concat(taskCategory.subject_types);
	      return this.dbSubjectTypesTranslated.filter(function (subjectType) {
	        return !allExcludedTypes.includes(subjectType.key);
	      });
	    },
	    onChangeCategoryForSubjectType: function onChangeCategoryForSubjectType(taskCategoryId, subjectType) {
	      var newTaskCategory = this.taskCategories.find(function (category) {
	        return category.id === taskCategoryId * 1;
	      });
	      this.onAddSubjectType(newTaskCategory, subjectType);
	    },
	    onAddSubjectType: function onAddSubjectType(taskCategory, val) {
	      var currentTaskCategory = this.taskCategories.find(function (category) {
	        return category.subject_types.includes(val);
	      });
	
	      if (currentTaskCategory) {
	        var currentTaskCategoryTypes = currentTaskCategory.subject_types.filter(function (subjectType) {
	          return subjectType !== val;
	        });
	        this.updateSubjectTypesOnCategory(currentTaskCategory, currentTaskCategoryTypes);
	      }
	
	      if (!taskCategory.subject_types.includes(val)) {
	        var updatedSubjectTypes = [].concat((0, _toConsumableArray3.default)(taskCategory.subject_types), [val]);
	        this.updateSubjectTypesOnCategory(taskCategory, updatedSubjectTypes);
	      }
	    },
	    updateSchoolSettings: function updateSchoolSettings(setting) {
	      var isDelete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!isDelete && this.oldCategoryName === setting) {
	        return;
	      }
	      var saveKey = 'shownOwnPools';
	      var oldSettingName = !isDelete ? this.oldCategoryName : setting;
	      var arr = [].concat((0, _toConsumableArray3.default)(this.schoolSettingShownOwnPools));
	      var index = arr.indexOf(oldSettingName);
	
	      if (index !== -1) {
	        arr.splice(index, 1);
	        if (!isDelete) {
	          arr.push(setting);
	        }
	      }
	      if (arr.length > 0) {
	        this.$store.dispatch('updateSchoolSettings', (0, _defineProperty3.default)({}, saveKey, arr));
	      } else {
	        if (this.schoolSettings[saveKey]) {
	          this.$store.dispatch('deleteSchoolSetting', saveKey);
	        }
	      }
	    },
	    updateSubjectTypesOnCategory: function updateSubjectTypesOnCategory(taskCategory, subjectTypes) {
	      var _this4 = this;
	
	      _docendo2.default.updateTaskCategory(this.schoolId, this.schoolYearId, taskCategory.id, taskCategory.name, taskCategory.rank, subjectTypes, function (success) {
	        _this4.$emit('updateCategory', success);
	        _this4.setEditTask(null);
	        _this4.theUpdatingTaskId = null;
	        _this4.selectedItem = null;
	      }, function (failure) {
	        console.log('Failed to update category');
	        _this4.setEditTask(null);
	        _this4.theUpdatingTaskId = null;
	      });
	    },
	    saveEditTask: function saveEditTask() {
	      var _this5 = this;
	
	      if (this.theEditTask.name.length === 0) {
	        window.alert('må ikke være tom');
	        return;
	      }
	      this.theUpdatingTaskId = this.theEditTask.id;
	      _docendo2.default.updateTaskCategory(this.schoolId, this.schoolYearId, this.theEditTask.id, this.theEditTask.name, this.theEditTask.rank, this.theEditTask.subject_types, function (success) {
	        _this5.updateSchoolSettings(success.name, false);
	        _this5.$emit('updateCategory', success);
	        _this5.setEditTask(null);
	        _this5.theUpdatingTaskId = null;
	      }, function (failure) {
	        console.log('Failed to update category');
	        _this5.setEditTask(null);
	        _this5.theUpdatingTaskId = null;
	      });
	    },
	    getIsTheEditTask: function getIsTheEditTask(taskCategory) {
	      return this.theEditTask && this.theEditTask.id === taskCategory.id;
	    },
	    setEditTask: function setEditTask(taskCategory) {
	      if (taskCategory) {
	        this.oldCategoryName = taskCategory.name;
	      } else {
	        this.oldCategoryName = '';
	      }
	      this.theEditTask = JSON.parse((0, _stringify2.default)(taskCategory));
	      this.$emit('onSetEditTask', taskCategory);
	    },
	    deleteTaskCategory: function deleteTaskCategory(taskCategory) {
	      var _this6 = this;
	
	      this.theDeletedCategoryId = taskCategory.id;
	      _docendo2.default.deleteTaskCategory(this.schoolId, this.schoolYearId, this.theDeletedCategoryId, function (success) {
	        _this6.updateSchoolSettings(taskCategory.name, true);
	        _this6.$emit('onDeleteTaskCategory', _this6.theDeletedCategoryId);
	        _this6.theDeletedCategoryId = null;
	        _this6.setTheDeleteTaskCategory(null);
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    onChangeOrder: function onChangeOrder(evt) {
	      var _this7 = this;
	
	      var movedCategory = evt.moved.element;
	
	      var newIndex = evt.moved.newIndex;
	
	      var prevCategory = this.taskCategoriesOrder[newIndex - 1];
	      var nextCategory = this.taskCategoriesOrder[newIndex + 1];
	
	      var newRank = void 0;
	      if (prevCategory && nextCategory) {
	        newRank = (prevCategory.rank + nextCategory.rank) / 2;
	      } else if (prevCategory) {
	        newRank = prevCategory.rank + 1;
	      } else if (nextCategory) {
	        newRank = nextCategory.rank - 1;
	      } else {
	        newRank = movedCategory.rank;
	      }
	
	      movedCategory.rank = newRank;
	
	      _docendo2.default.updateTaskCategory(this.schoolId, this.schoolYearId, movedCategory.id, movedCategory.name, movedCategory.rank, movedCategory.subject_types, function (success) {
	        _this7.$emit('updateCategory', success);
	      }, function (failure) {
	        console.log('Failed to update category ' + movedCategory.id);
	      });
	    },
	    getTranslatedSubjectType: function getTranslatedSubjectType(subjectType) {
	      return subjectType && (subjectType.i18n && subjectType.i18n[this.locale] || subjectType.key);
	    },
	    setAllCategories: function setAllCategories() {
	      var _this8 = this;
	
	      this.taskCategoriesOrder = this.taskCategories.map(function (taskCategory) {
	        return (0, _extends3.default)({}, taskCategory, {
	          v_is_used_on_subjects: _this8.getIsUsedOnSubjects(taskCategory),
	          v_subject_types: taskCategory.subject_types.map(function (subjectType) {
	            var dbSubjectType = _this8.dbSubjectTypes.find(function (dbSubjectType) {
	              return dbSubjectType.key === subjectType;
	            });
	            return {
	              key: subjectType,
	              v_name: _this8.getTranslatedSubjectType(dbSubjectType) || subjectType
	            };
	          })
	        });
	      }).sort(function (a, b) {
	        return a.rank - b.rank;
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.setAllCategories();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.setEditTask(null);
	  }
	};

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    taskCategories: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    theEditCategory: {},
	    schoolId: {},
	    schoolYearId: {}
	  },
	  data: function data() {
	    return {
	      title: '',
	      isSubmitting: false,
	      isTitleAlreadyCreated: false
	    };
	  },
	
	  methods: {
	    onClose: function onClose() {
	      this.$emit('close');
	    },
	    createCategory: function createCategory() {
	      var _this = this;
	
	      if (this.title.length < 1) {
	        return;
	      }
	      this.isTitleAlreadyCreated = this.taskCategories.filter(function (cat) {
	        return cat.name === _this.title;
	      }).length > 0;
	      if (this.isTitleAlreadyCreated) {
	        return;
	      }
	      this.isSubmitting = true;
	
	      var highestRank = Math.max.apply(null, this.taskCategories.map(function (item) {
	        return item.rank;
	      }));
	
	      if (highestRank === -Infinity) {
	        highestRank = 0;
	      }
	
	      var nextRank = Math.ceil(highestRank + 1);
	      var subjectTypes = [];
	
	      _docendo2.default.createTaskCategory(this.schoolId, this.schoolYearId, this.title, nextRank, subjectTypes, function (success) {
	        _this.$emit('onNewCategory', success);
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.$nextTick(function (_) {
	      var el = _this2.$refs.title_input;
	      if (el) {
	        el.focus();
	      }
	    });
	  }
	};

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _set = __webpack_require__(27);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _vueVirtualScrollList = __webpack_require__(423);
	
	var _vueVirtualScrollList2 = _interopRequireDefault(_vueVirtualScrollList);
	
	var _TaskOverviewSettingsCategoriesTasksTask = __webpack_require__(1668);
	
	var _TaskOverviewSettingsCategoriesTasksTask2 = _interopRequireDefault(_TaskOverviewSettingsCategoriesTasksTask);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  subject: 'Fag',
	  optional: 'Valgfag/Hold',
	  supplemental: 'UUV',
	  frame: 'Temavisning',
	  break: 'Pause',
	  resource: 'Ressource (synlig)',
	  person_resource: 'Ressource (skjult)',
	  other_tasks: 'Anden tid',
	  other_stuff: 'Øvrig tid',
	  available: 'Rådighedstime',
	  person_resource_visible: 'Ressource (synlig)',
	  club: 'SFO tid',
	  additional_tasks: 'Øvrige opgaver',
	  preparation: 'Forberedelse',
	  with_kids: 'Tid med børn',
	  without_kids: 'Tid uden børn',
	  pool: 'Lokalpulje',
	  absence: 'Fravær',
	  _extra_time_at_start_of_day_: 'Ekstra tid for start på dag',
	  reservation: 'Reservation'
	};
	
	exports.default = {
	  components: { Loader: _Loader2.default, DoFiltersFilter: _DoFiltersFilter2.default, virtualList: _vueVirtualScrollList2.default, TaskOverviewSettingsCategoriesTasksTask: _TaskOverviewSettingsCategoriesTasksTask2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    schoolId: {},
	    schoolYearId: {},
	    subjects: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    taskCategories: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    allCalendarsInHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    allUsersInHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    tags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isSupplements: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isInitLoad: true,
	      itemComponent: _TaskOverviewSettingsCategoriesTasksTask2.default,
	      selectedSubjects: [],
	      isDropdown: false,
	      isUpdating: false,
	      selectedTags: [],
	      selectedPersons: [],
	      selectedSubjectsNames: [],
	      selectedTypes: [],
	      sortKey: '',
	      sortDirection: 'asc' };
	  },
	
	  computed: {
	    localPoolTitle: function localPoolTitle() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || this.$t('vue2.task_overview.pool');
	    },
	    salaryCodes: function salaryCodes() {
	      return this.$store.getters.salaryCodesSorted || [];
	    },
	    selectedSubjectIds: function selectedSubjectIds() {
	      return new _set2.default(this.selectedSubjects.map(function (s) {
	        return s.id;
	      }));
	    },
	    sortIcon: function sortIcon() {
	      return this.sortDirection === 'asc' ? '▲' : '▼';
	    },
	    sortedSubjects: function sortedSubjects() {
	      var _this = this;
	
	      return [].concat((0, _toConsumableArray3.default)(this.filteredSubjects)).sort(function (a, b) {
	        if (!_this.sortKey) return 0;
	
	        var valueA = _this.getNestedValue(a, _this.sortKey);
	        var valueB = _this.getNestedValue(b, _this.sortKey);
	
	        if (typeof valueA === 'string' && typeof valueB === 'string') {
	          return _this.sortDirection === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
	        }
	
	        return _this.sortDirection === 'asc' ? valueA - valueB : valueB - valueA;
	      });
	    },
	    persons: function persons() {
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(this.subjects.map(function (subject) {
	        return subject.calendar.name;
	      }))));
	    },
	    subjectNames: function subjectNames() {
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(this.subjects.map(function (subject) {
	        return subject.subject.name;
	      }))));
	    },
	    subjectTypes: function subjectTypes() {
	      var _this2 = this;
	
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(this.subjects.map(function (subject) {
	        return _this2.getSubjectTypeLabel(subject.subject.subject_type);
	      }))));
	    },
	    subjectsWithType: function subjectsWithType() {
	      var _this3 = this;
	
	      return this.subjects.map(function (subject) {
	        return (0, _extends3.default)({}, subject, {
	          v_type: _this3.getSubjectTypeLabel(subject.subject.subject_type),
	          v_DefaultCategory: _this3.getDefaultTaskCategory(subject),
	          v_tags: _this3.getTags(subject)
	        });
	      });
	    },
	    filteredSubjects: function filteredSubjects() {
	      var _this4 = this;
	
	      return this.subjectsWithType.filter(function (subject) {
	        var matchesPerson = _this4.selectedPersons.length === 0 || _this4.selectedPersons.includes(subject.calendar.name);
	        var matchesSubjectName = _this4.selectedSubjectsNames.length === 0 || _this4.selectedSubjectsNames.includes(subject.subject.name);
	        var matchesType = _this4.selectedTypes.length === 0 || _this4.selectedTypes.includes(subject.v_type);
	        var matchesTags = _this4.selectedTags.length === 0 || subject.v_tags.some(function (tag) {
	          return _this4.selectedTags.includes(tag);
	        });
	
	        return matchesPerson && matchesSubjectName && matchesType && matchesTags;
	      });
	    }
	  },
	  methods: {
	    getSubjectTypeLabel: function getSubjectTypeLabel(subjectType) {
	      if (subjectType === 'pool') {
	        return this.localPoolTitle;
	      }
	      var i18n = I18N[subjectType];
	      return i18n || subjectType;
	    },
	    getTags: function getTags(subject) {
	      if (!subject.calendar || !subject.calendar.user_id) {
	        return [];
	      }
	      var user = this.allUsersInHash[subject.calendar.user_id];
	      return user && user.user_tags ? user.user_tags : [];
	    },
	    getDefaultTaskCategory: function getDefaultTaskCategory(subject) {
	      return this.taskCategories.find(function (taskCat) {
	        return taskCat.id === subject.default_task_category_id;
	      });
	    },
	    sortBy: function sortBy(column) {
	      if (this.sortKey === column) {
	        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
	      } else {
	        this.sortKey = column;
	        this.sortDirection = 'asc';
	      }
	    },
	    getNestedValue: function getNestedValue(obj, path) {
	      return path.split('.').reduce(function (acc, part) {
	        return acc && acc[part];
	      }, obj) || '';
	    },
	    onSelectPerson: function onSelectPerson(person) {
	      this.toggleSelection(this.selectedPersons, person);
	    },
	    onSelectTags: function onSelectTags(tag) {
	      this.toggleSelection(this.selectedTags, tag);
	    },
	    onSelectSubject: function onSelectSubject(subjectName) {
	      this.toggleSelection(this.selectedSubjectsNames, subjectName);
	    },
	    onSelectType: function onSelectType(type) {
	      this.toggleSelection(this.selectedTypes, type);
	    },
	    toggleSelection: function toggleSelection(array, value) {
	      var idx = array.indexOf(value);
	      if (idx < 0) {
	        array.push(value);
	      } else {
	        array.splice(idx, 1);
	      }
	    },
	    updateSubjectTaskCategory: function updateSubjectTaskCategory(subject, value) {
	      var _this5 = this;
	
	      this.isUpdating = true;
	      if (!this.isSupplements) {
	        var updates = [{ id: subject.id, selected_task_category_id: value }];
	        _docendo2.default.bulkUpdateSubjectCalendars(this.schoolId, this.schoolYearId, updates, function (success) {
	          _this5.$emit('updateSubjects', updates);
	          _this5.isUpdating = false;
	          _this5.closeDropdown(false);
	        }, function (failure) {
	          console.log('failure');
	          _this5.isUpdating = false;
	          _this5.closeDropdown(false);
	        });
	      } else {
	        var parsedValue = value === '' ? null : value;
	        var _updates = [{
	          id: subject.id,
	          salary_code_id: parsedValue,
	          salary_cost_center_id: subject.salary_cost_center_id || null
	        }];
	        _docendo2.default.bulkUpdateSubjectCalendarsSalary(this.schoolId, this.schoolYearId, _updates, function (success) {
	          _this5.$emit('updateSubjects', _updates);
	          _this5.isUpdating = false;
	          _this5.closeDropdown(false);
	        }, function (failure) {
	          console.log('failure');
	          _this5.isUpdating = false;
	          _this5.closeDropdown(false);
	        });
	      }
	    },
	    setTasksCategory: function setTasksCategory(taskCategory) {
	      var _this6 = this;
	
	      this.isUpdating = true;
	      if (this.isSupplements) {
	        var updates = this.selectedSubjects.map(function (selectedSubject) {
	          return {
	            id: selectedSubject.id,
	            salary_code_id: taskCategory.id,
	            salary_cost_center_id: selectedSubject.salary_cost_center_id || null
	          };
	        });
	        _docendo2.default.bulkUpdateSubjectCalendarsSalary(this.schoolId, this.schoolYearId, updates, function (success) {
	          _this6.$emit('updateSubjects', updates);
	          _this6.isUpdating = false;
	          _this6.closeDropdown(false);
	        }, function (failure) {
	          console.log('failure');
	          _this6.isUpdating = false;
	          _this6.closeDropdown(false);
	        });
	      }
	      if (!this.isSupplements) {
	        var _updates2 = this.selectedSubjects.map(function (selectedSubject) {
	          return {
	            id: selectedSubject.id,
	            selected_task_category_id: taskCategory.id
	          };
	        });
	        _docendo2.default.bulkUpdateSubjectCalendars(this.schoolId, this.schoolYearId, _updates2, function (success) {
	          _this6.$emit('updateSubjects', _updates2);
	          _this6.isUpdating = false;
	          _this6.closeDropdown(false);
	        }, function (failure) {
	          console.log('failure');
	          _this6.isUpdating = false;
	          _this6.closeDropdown(false);
	        });
	      }
	    },
	    onClickAway: function onClickAway() {
	      if (!this.isDropdown) return;
	      this.selectedSubjects = [];
	      this.isDropdown = false;
	    },
	    closeDropdown: function closeDropdown() {
	      this.isDropdown = false;
	      this.selectedSubjects = [];
	    },
	    setIsDropdown: function setIsDropdown() {
	      this.isDropdown = !this.isDropdown;
	    },
	    toggleAll: function toggleAll() {
	      if (this.selectedSubjects.length > 0) {
	        this.selectedSubjects = [];
	      } else {
	        this.selectedSubjects = [].concat((0, _toConsumableArray3.default)(this.filteredSubjects));
	      }
	    },
	    toggleSubject: function toggleSubject(subject) {
	      var idx = this.selectedSubjects.findIndex(function (selectedSubjects) {
	        return selectedSubjects.id === subject.id;
	      });
	      if (idx < 0) {
	        this.selectedSubjects.push(subject);
	      } else {
	        this.selectedSubjects.splice(idx, 1);
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this7 = this;
	
	    if (this.isSupplements) {
	      this.$store.dispatch('readSalaryCodes');
	    }
	    setTimeout(function (_) {
	      _this7.isInitLoad = false;
	    }, 100);
	  }
	};

/***/ }),
/* 794 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    source: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    toggleSubject: {
	      type: Function
	    },
	    updateSubjectTaskCategory: {
	      type: Function
	    },
	    selectedSubjects: {
	      default: function _default() {
	        return function () {
	          return [];
	        };
	      }
	    },
	    taskCategories: {
	      default: function _default() {
	        return function () {
	          return [];
	        };
	      }
	    },
	    selectedSubjectIds: {
	      default: function _default() {
	        return function () {};
	      }
	    },
	    index: {
	      type: Number
	    },
	    isSupplements: {
	      type: Boolean,
	      default: false
	    },
	    salaryCodes: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  computed: {
	    subject: function subject() {
	      return this.source;
	    },
	    isSelected: function isSelected() {
	      return this.selectedSubjectIds.has(this.subject.id);
	    }
	  }
	};

/***/ }),
/* 795 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    videoId: {
	      type: String,
	      required: true,
	      default: 1056171188
	    }
	  },
	  computed: {
	    videoSrc: function videoSrc() {
	      return "https://player.vimeo.com/video/" + this.videoId + "?badge=0&autopause=0&player_id=0&app_id=58479";
	    }
	  }
	};

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default },
	  props: {
	    taskCategories: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isOn: true,
	      schoolSettingsKey: 'hiddenTaskDistributionCategories',
	      schoolSettingsKey2: 'shownOwnPools',
	      isActive: false,
	      thresholdToHideTaskHours: 0,
	      localPoolTitleDraft: ''
	    };
	  },
	
	  computed: {
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    localPoolTitle: function localPoolTitle() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || this.$t('vue2.task_overview.pool');
	    },
	    hiddenTaskDistributionCategories: function hiddenTaskDistributionCategories() {
	      return this.$store.getters.hiddenTaskDistributionCategories;
	    },
	    schoolThresholdToHideTaskHours: function schoolThresholdToHideTaskHours() {
	      return this.schoolSettings && this.schoolSettings['thresholdToHideTaskHours'] ? this.schoolSettings['thresholdToHideTaskHours'] : null;
	    },
	    schoolSettingShownOwnPools: function schoolSettingShownOwnPools() {
	      return this.$store.getters.shownOwnPools;
	    }
	  },
	  methods: {
	    saveLocalPoolTitle: function saveLocalPoolTitle() {
	      var key = 'localPoolTitle';
	      var trimmed = this.localPoolTitleDraft ? this.localPoolTitleDraft.trim() : '';
	      if (!trimmed) {
	        if (this.schoolSettings && this.schoolSettings[key]) {
	          this.$store.dispatch('deleteSchoolSetting', key);
	        }
	        return;
	      }
	      this.$store.dispatch('updateSchoolSettings', (0, _defineProperty3.default)({}, key, trimmed));
	    },
	    setIsActive: function setIsActive() {
	      var _this = this;
	
	      this.isActive = !this.isActive;
	      if (!this.isActive) {
	        this.thresholdToHideTaskHours = 0;
	        this.onSave();
	      } else {
	        this.$nextTick(function (_) {
	          _this.$refs.the_input_field.focus();
	        });
	      }
	    },
	    onSave: function onSave() {
	      var key = 'thresholdToHideTaskHours';
	      if (!this.isActive) {
	        this.$store.dispatch('deleteSchoolSetting', key);
	      } else {
	        var val = this.thresholdToHideTaskHours * 1;
	        if (isNaN(Number(val))) {
	          _eventbus2.default.toast = { text: 'Kan ikke gemme. Skal være et tal', 'success': false };
	          return;
	        }
	        this.$store.dispatch('updateSchoolSettings', { 'thresholdToHideTaskHours': val });
	      }
	    },
	    getIsOn: function getIsOn(setting) {
	      return !this.hiddenTaskDistributionCategories.includes(setting);
	    },
	    getIsOwnPoolOn: function getIsOwnPoolOn(settingId) {
	      return this.schoolSettingShownOwnPools.includes(settingId);
	    },
	    setIsOn: function setIsOn() {
	      this.isOn = !this.isOn;
	    },
	    toggleSettings: function toggleSettings(setting) {
	      var arr = [].concat((0, _toConsumableArray3.default)(this.hiddenTaskDistributionCategories));
	      var index = arr.indexOf(setting);
	
	      if (index !== -1) {
	        arr.splice(index, 1);
	      } else {
	        arr.push(setting);
	      }
	
	      if (arr.length > 0) {
	        this.$store.dispatch('updateSchoolSettings', (0, _defineProperty3.default)({}, this.schoolSettingsKey, arr));
	      } else {
	        if (this.schoolSettings[this.schoolSettingsKey]) {
	          this.$store.dispatch('deleteSchoolSetting', this.schoolSettingsKey);
	        }
	      }
	    },
	    toggleOwnPool: function toggleOwnPool(setting) {
	      var arr = [].concat((0, _toConsumableArray3.default)(this.schoolSettingShownOwnPools));
	      var index = arr.indexOf(setting);
	
	      if (index !== -1) {
	        arr.splice(index, 1);
	      } else {
	        arr.push(setting);
	      }
	
	      if (arr.length > 0) {
	        this.$store.dispatch('updateSchoolSettings', (0, _defineProperty3.default)({}, this.schoolSettingsKey2, arr));
	      } else {
	        if (this.schoolSettings[this.schoolSettingsKey2]) {
	          this.$store.dispatch('deleteSchoolSetting', this.schoolSettingsKey2);
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.schoolThresholdToHideTaskHours) {
	      this.isActive = true;
	      this.thresholdToHideTaskHours = this.schoolThresholdToHideTaskHours;
	    }
	    if (this.schoolSettings && this.schoolSettings.localPoolTitle) {
	      this.localPoolTitleDraft = this.schoolSettings.localPoolTitle;
	    }
	  }
	};

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserTasks = __webpack_require__(54);
	
	var _UserTasks2 = _interopRequireDefault(_UserTasks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { UserTasks: _UserTasks2.default },
	  props: {
	    theActiveUserId: {
	      default: null
	    },
	    users: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    schoolYear: {
	      default: function _default() {
	        return null;
	      }
	    }
	  },
	  computed: {
	    theActiveUser: function theActiveUser() {
	      var _this = this;
	
	      if (!this.theActiveUserId) {
	        if (this.users.length > 0) {
	          return this.users[0];
	        }
	        return null;
	      }
	      return this.users.find(function (user) {
	        return user.id === _this.theActiveUserId * 1;
	      });
	    }
	  }
	};

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _TeamCalendarHeader = __webpack_require__(1672);
	
	var _TeamCalendarHeader2 = _interopRequireDefault(_TeamCalendarHeader);
	
	var _DScheduler = __webpack_require__(1495);
	
	var _DScheduler2 = _interopRequireDefault(_DScheduler);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DCalendar = __webpack_require__(53);
	
	var _DCalendar2 = _interopRequireDefault(_DCalendar);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Collisions = __webpack_require__(1468);
	
	var _Collisions2 = _interopRequireDefault(_Collisions);
	
	var _DCalendarShowEvent = __webpack_require__(81);
	
	var _DCalendarShowEvent2 = _interopRequireDefault(_DCalendarShowEvent);
	
	var _TeamCalendarPresenceTable = __webpack_require__(1674);
	
	var _TeamCalendarPresenceTable2 = _interopRequireDefault(_TeamCalendarPresenceTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { TeamCalendarPresenceTable: _TeamCalendarPresenceTable2.default, DCalendarShowEvent: _DCalendarShowEvent2.default, Collisions: _Collisions2.default, DCalendar: _DCalendar2.default, calHeader: _TeamCalendarHeader2.default, dScheduler: _DScheduler2.default, spinner: _Loader2.default },
	  data: function data() {
	    return {
	      i18n: {
	        da: {
	          button_text: 'Skema-<br>overblik',
	          team_calendar: 'Skemaoverblik',
	          loading_events: 'Henter lektioner..',
	          overlay_week_title: 'Samlet overblik'
	        },
	        en: {
	          button_text: 'Schedule<br>overview',
	          team_calendar: 'Schedule overview',
	          loading_events: 'Loading events..',
	          overlay_week_title: 'Overlay week'
	        },
	        nb: {
	          button_text: 'Timeplan-<br>overblikk',
	          team_calendar: 'Timeplanoverblikk',
	          loading_events: 'Loading events..',
	          overlay_week_title: 'Samlet uke'
	        }
	      },
	      showTeamCalendar: false,
	      calView: 'resourceTimeGridFiveDay',
	      date: (0, _moment2.default)().format('YYYY-MM-DD 00:00'),
	      maxRessLength: 4,
	      selectedRess: [],
	      events: [],
	      prevCounter: 0,
	      nextCounter: 0,
	      todayCounter: 0,
	      theSchedulerCalendars: [],
	      theSchedulerEvents: [],
	      rooms: [],
	      isLoading: false,
	      isLoadingEvents: false,
	      timeout: null,
	      _keyListener: null,
	      theSortOptionForAllSchedules: null,
	      activeEvent: null,
	      activeCalendar: null,
	      activeEventCalendarId: null,
	      selectedScrollOption: '',
	      isDragAndDropOn: false,
	      hasChanges: false
	    };
	  },
	
	  computed: {
	    user: function user() {
	      return this.$store.state.user;
	    },
	    schoolId: function schoolId() {
	      return this.$store ? this.$store.getters.schoolId : window.SCHOOL.id;
	    },
	    locale: function locale() {
	      return this.user && this.user.locale ? this.user.locale : 'en';
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    allCalendars: function allCalendars() {
	      return this.$store.state.calendars;
	    },
	    userCalendars: function userCalendars() {
	      return this.$store.getters.userCalendars;
	    },
	    klassCalendars: function klassCalendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    isListView: function isListView() {
	      return this.calView === 'listView';
	    },
	    isSchedulerView: function isSchedulerView() {
	      return this.calView === 'schedulerView';
	    },
	    isPresenceTableView: function isPresenceTableView() {
	      return this.calView === 'presenceTable';
	    },
	    isOverlayWeekView: function isOverlayWeekView() {
	      return this.calView === 'overlayWeek';
	    },
	    isShowSchedulerShortcut: function isShowSchedulerShortcut() {
	      return this.calView === 'scheduler' || this.calView === 'scheduler__all_cals' || this.calView === 'scheduler__all_users' || this.calView === 'scheduler__all_klass';
	    },
	    isCalendarView: function isCalendarView() {
	      return this.calView === 'resourceTimeGridFiveDay' || this.calView === 'resourceTimeGridDay' || this.calView === 'listView' || this.calView === 'overlayWeek';
	    },
	    isShowWeek: function isShowWeek() {
	      return this.calView !== 'resourceTimeGridDay';
	    },
	    isDragAndDropActive: function isDragAndDropActive() {
	      var isDayOrWeekView = this.calView === 'resourceTimeGridDay' || this.calView === 'resourceTimeGridFiveDay';
	      return this.isDragAndDropOn && this.isUserCanEditCalendar && isDayOrWeekView;
	    },
	    startDate: function startDate() {
	      var startDate = (0, _moment2.default)(this.date).format('YYYY-MM-DD 00:00');
	      if (this.isOverlayWeekView) {
	        startDate = (0, _moment2.default)(this.date).isoWeekday(1).format('YYYY-MM-DD 00:00');
	        return startDate;
	      }
	      if (this.calView === 'resourceTimeGridFiveDay' || this.calView === 'listView' || this.calView === 'presenceTable') {
	        startDate = (0, _moment2.default)(this.date).isoWeekday(1).format('YYYY-MM-DD 00:00');
	      }
	      return startDate;
	    },
	    endDate: function endDate() {
	      var endDate = (0, _moment2.default)(this.date).format('YYYY-MM-DD 23:59');
	      if (this.isOverlayWeekView) {
	        endDate = (0, _moment2.default)(this.date).isoWeekday(7).format('YYYY-MM-DD 23:59');
	        return endDate;
	      }
	      if (this.calView === 'resourceTimeGridFiveDay' || this.calView === 'listView' || this.calView === 'presenceTable') {
	        if (this.isShowWeekends) {
	          endDate = (0, _moment2.default)(this.date).isoWeekday(7).format('YYYY-MM-DD 23:59');
	        } else {
	          endDate = (0, _moment2.default)(this.date).isoWeekday(5).format('YYYY-MM-DD 23:59');
	        }
	        if (this.userCustomNumberOfDays && this.calView !== 'presenceTable') {
	          endDate = (0, _moment2.default)(this.date).isoWeekday(this.userCustomNumberOfDays).format('YYYY-MM-DD 23:59');
	        }
	      }
	      return endDate;
	    },
	    dateRangeFormatted: function dateRangeFormatted() {
	      var isInSameMonth = (0, _moment2.default)(this.startDate).format('MM') === (0, _moment2.default)(this.endDate).format('MM');
	      var start = isInSameMonth ? (0, _moment2.default)(this.startDate).format('DD[.]') : (0, _moment2.default)(this.startDate).format('DD[.] MMM');
	      if (this.locale !== 'en') {
	        if (this.calView !== 'resourceTimeGridDay') {
	          return start + ' - ' + (0, _moment2.default)(this.endDate).format('DD[.] MMM[,] YYYY');
	        } else {
	          return (0, _moment2.default)(this.endDate).format('DD[.] MMM[,] YYYY');
	        }
	      } else {
	        start = (0, _moment2.default)(this.startDate).format('MMM DD');
	        var end = isInSameMonth ? (0, _moment2.default)(this.endDate).format('DD[,] YYYY') : (0, _moment2.default)(this.endDate).format('MMM DD[,] YYYY');
	        if (this.calView !== 'resourceTimeGridDay') {
	          return start + ' - ' + end;
	        } else {
	          return (0, _moment2.default)(this.endDate).format('MMM DD[,] YYYY');
	        }
	      }
	    },
	    startTime: function startTime() {
	      if (this.userSettings && this.userSettings.teamCalendarSettingTimes) {
	        var end = (0, _moment2.default)(this.userSettings.teamCalendarSettingTimes.end);
	        var start = (0, _moment2.default)(this.userSettings.teamCalendarSettingTimes.start);
	        if ((0, _moment2.default)(start).isBefore(end)) {
	          return (0, _moment2.default)(this.userSettings.teamCalendarSettingTimes.start).format('HH:mm:00');
	        } else {
	          this.$store.dispatch('deleteUserSetting', 'teamCalendarSettingTimes');
	        }
	      } else {
	        return '07:00:00';
	      }
	    },
	    endTime: function endTime() {
	      if (this.userSettings && this.userSettings.teamCalendarSettingTimes) {
	        return (0, _moment2.default)(this.userSettings.teamCalendarSettingTimes.end).format('HH:mm:00');
	      } else {
	        return '16:00:00';
	      }
	    },
	    isShowWeekends: function isShowWeekends() {
	      if (this.userSettings && this.userSettings.teamCalendarSettingTimes && this.userSettings.teamCalendarSettingTimes.isShowWeekends) {
	        return this.userSettings.teamCalendarSettingTimes.isShowWeekends;
	      } else {
	        return false;
	      }
	    },
	    userCustomNumberOfDays: function userCustomNumberOfDays() {
	      if (this.userSettings && this.userSettings.teamCalendarSettingTimes && this.userSettings.teamCalendarSettingTimes.numberOfDays) {
	        return this.userSettings.teamCalendarSettingTimes.numberOfDays;
	      } else {
	        return null;
	      }
	    },
	    schedulerDate: function schedulerDate() {
	      return (0, _moment2.default)(this.date).format('dddd') + ', ' + (0, _moment2.default)(this.date).format('ll');
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    roomsGetter: function roomsGetter() {
	      return this.$store.getters.roomCalendars;
	    },
	    eventsInHash: function eventsInHash() {
	      var eventsHash = {};
	      this.events.forEach(function (event) {
	        if (event.event_type === 'presence') {
	          var calId = event.calendar_id;
	          if (!eventsHash[calId]) {
	            eventsHash[calId] = [event];
	          } else {
	            eventsHash[calId].push(event);
	          }
	        } else {
	          event.calendars.forEach(function (calendar) {
	            var calId = calendar.calendar_id;
	            if (!eventsHash[calId]) {
	              eventsHash[calId] = [event];
	            } else {
	              eventsHash[calId].push(event);
	            }
	          });
	        }
	      });
	      return eventsHash;
	    },
	    isUserCanEditCalendar: function isUserCanEditCalendar() {
	      return this.$store.getters.isUserCanEditCalendar;
	    },
	    overlayCalendarId: function overlayCalendarId() {
	      return this.selectedRess[0] ? this.selectedRess[0].id : null;
	    },
	    overlayCalendarColors: function overlayCalendarColors() {
	      var palette = ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'];
	      var colors = {};
	      this.selectedRess.forEach(function (calendar, index) {
	        var color = calendar && calendar.color ? calendar.color : null;
	        if (!color && calendar && calendar.color_hex) {
	          color = calendar.color_hex;
	        }
	        if (!color && calendar && calendar.color_code) {
	          color = calendar.color_code;
	        }
	        if (!color && calendar && calendar.hex_color) {
	          color = calendar.hex_color;
	        }
	        if (!color) {
	          color = palette[index % palette.length];
	        }
	        colors[calendar.id] = color;
	      });
	      return colors;
	    },
	    overlayEvents: function overlayEvents() {
	      var colors = this.overlayCalendarColors;
	      var selectedIds = this.selectedRess.map(function (calendar) {
	        return calendar.id;
	      });
	      var overlay = [];
	      this.events.forEach(function (event) {
	        if (!event) {
	          return;
	        }
	        var calendarIds = [];
	        if (event.calendars && Array.isArray(event.calendars)) {
	          event.calendars.forEach(function (calendar) {
	            if (calendar && calendar.calendar_id && selectedIds.indexOf(calendar.calendar_id) > -1) {
	              calendarIds.push(calendar.calendar_id);
	            }
	          });
	        }
	        if (calendarIds.length < 1 && event.calendar_id && selectedIds.indexOf(event.calendar_id) > -1) {
	          calendarIds = [event.calendar_id];
	        }
	        if (calendarIds.length < 1) {
	          return;
	        }
	        calendarIds.forEach(function (calendarId) {
	          var overlayEvent = (0, _extends3.default)({}, event, {
	            calendar_id: calendarId,
	            v_overlay_key: calendarId + '_' + event.event_id
	          });
	          if (event.event_type !== 'presence' && colors[calendarId]) {
	            overlayEvent.color = colors[calendarId];
	          }
	          overlay.push(overlayEvent);
	        });
	      });
	      return overlay;
	    },
	    overlayCalendarLegend: function overlayCalendarLegend() {
	      var colors = this.overlayCalendarColors;
	      return this.selectedRess.map(function (calendar) {
	        return {
	          id: calendar.id,
	          name: calendar.name,
	          color: colors[calendar.id] || '#999999'
	        };
	      });
	    }
	  },
	  methods: {
	    readInitialScrollOption: function readInitialScrollOption() {
	      var key = 'd_team_calendar_scroll_option';
	      var val = this.$helpers.getLocalStorage(key);
	      if (val) {
	        this.selectedScrollOption = val;
	      }
	    },
	    setSelectedScrollOption: function setSelectedScrollOption(val) {
	      this.selectedScrollOption = val;
	      var key = 'd_team_calendar_scroll_option';
	      if (val === '') {
	        this.$helpers.removeLocalStorage(key);
	      } else {
	        this.$helpers.setLocalStorage(key, val);
	      }
	    },
	    setSortOption: function setSortOption(sortBy) {
	      this.theSortOptionForAllSchedules = sortBy;
	    },
	    getCalendarEvents: function getCalendarEvents(calendarId) {
	      return this.eventsInHash[calendarId] ? this.eventsInHash[calendarId] : [];
	    },
	    setActiveEventForOverlay: function setActiveEventForOverlay(event) {
	      if (!event || !event.obj) {
	        this.setActiveEvent(null);
	        return;
	      }
	      var calendarId = event.obj.calendar_id;
	      if (!calendarId && event.obj.calendars && event.obj.calendars.length > 0) {
	        calendarId = event.obj.calendars[0].calendar_id;
	      }
	      var calendar = calendarId && this.allCalendarsInHash[calendarId] ? this.allCalendarsInHash[calendarId] : null;
	      if (!calendar) {
	        return;
	      }
	      this.setActiveEvent(event, calendar);
	    },
	    setNextDay: function setNextDay() {
	      var newDate = (0, _moment2.default)(this.date).add(1, 'days');
	      this.setDate(newDate);
	    },
	    setPrevDay: function setPrevDay() {
	      var newDate = (0, _moment2.default)(this.date).subtract(1, 'days');
	      this.setDate(newDate);
	    },
	    setDate: function setDate(mom) {
	      var _this = this;
	
	      this.date = mom;
	      if (this.calView === 'doubleBookings') {
	        return;
	      }
	      setTimeout(function (_) {
	        _this.getEvents();
	      }, 0);
	    },
	    setCalView: function setCalView(val) {
	      if (this.calView === val) {
	        return;
	      }
	      if (val === 'scheduler') {
	        this.theSchedulerCalendars = this.roomsGetter;
	      }
	      if (val === 'scheduler__all_cals') {
	        this.theSchedulerCalendars = this.$helpers.sortArrOnName(this.allCalendars);
	      }
	      if (val === 'scheduler__all_users') {
	        this.theSchedulerCalendars = this.userCalendars;
	      }
	      if (val === 'scheduler__all_klass') {
	        this.theSchedulerCalendars = this.klassCalendars;
	      }
	      this.calView = val;
	      this.getEvents();
	    },
	    setCalDate: function setCalDate(calDate) {
	      if ((0, _moment2.default)(this.date).format('YYYY-MM-DD') !== (0, _moment2.default)(calDate).format('YYYY-MM-DD')) {
	        this.date = calDate;
	      }
	    },
	    setToday: function setToday() {
	      this.todayCounter++;
	      this.date = (0, _moment2.default)();
	    },
	    setSelectedRess: function setSelectedRess(calendars) {
	      var _this2 = this;
	
	      this.selectedRess = [];
	      calendars.forEach(function (calendar) {
	        _this2.selectedRess.push(calendar);
	      });
	    },
	    updateEvents: function updateEvents($event) {
	      var _this3 = this;
	
	      setTimeout(function (_) {
	        _this3.getEvents();
	      }, 0);
	    },
	    setView: function setView() {
	      this.getEvents();
	    },
	    getEvents: function getEvents() {
	      var _this4 = this;
	
	      if (this.calView === 'doubleBookings') {
	        return;
	      }
	      if (this.isShowSchedulerShortcut) {
	        var _calendarIds = this.theSchedulerCalendars.map(function (cal) {
	          return cal.id;
	        });
	        this.isLoadingEvents = true;
	        this.theSchedulerEvents = [];
	        _docendo2.default.eventsFromCalendars(_calendarIds, this.startDate, this.endDate, null, function (data) {
	          var events = data.length > 0 ? JSON.parse(data) : [];
	          _this4.theSchedulerEvents = events;
	          _this4.isLoadingEvents = false;
	        });
	        return;
	      }
	      if (this.selectedRess.length === 0) {
	        return;
	      }
	      var calendarIds = this.selectedRess.map(function (user) {
	        return user.id;
	      });
	      this.isLoadingEvents = true;
	      this.events = [];
	      _docendo2.default.eventsFromCalendars(calendarIds, this.startDate, this.endDate, null, function (data) {
	        var events = data.length > 0 ? JSON.parse(data) : [];
	        _this4.events = events;
	        _this4.isLoadingEvents = false;
	      });
	    },
	    setShowTeamCalendar: function setShowTeamCalendar() {
	      var _this5 = this;
	
	      this.showTeamCalendar = true;
	      if (this.selectedRess.length > 0) {
	        this.getEvents();
	      }
	      var body = document.querySelector('body');
	      if (!body.classList.contains('no-scroll')) {
	        body.classList.add('no-scroll');
	      }
	      var onEscape = function onEscape(e) {
	        if (_this5.showTeamCalendar && e.keyCode === 27) {
	          _this5.closeTeamCalendar();
	        }
	      };
	      document.addEventListener('keydown', onEscape);
	      this.$once('hook:destroyed', function () {
	        document.removeEventListener('keydown', onEscape);
	      });
	    },
	    closeTeamCalendar: function closeTeamCalendar() {
	      this.showTeamCalendar = false;
	      var body = document.querySelector('body');
	      body.classList.remove('no-scroll');
	      if (this.hasChanges) {
	        this.hasChanges = false;
	
	        window.dispatchEvent(new window.CustomEvent('vueTeamCalendarChanged'));
	      }
	    },
	    toggleShowTeamCalendar: function toggleShowTeamCalendar() {
	      if (this.showTeamCalendar) {
	        this.closeTeamCalendar();
	      } else {
	        this.setShowTeamCalendar();
	      }
	    },
	    setIsDragAndDropOn: function setIsDragAndDropOn(boolean) {
	      this.isDragAndDropOn = boolean;
	      this.$store.dispatch('updateUserSettings', { 'teamcalendar_drag_and_drop': boolean });
	    },
	    moveEvent: function moveEvent(_ref) {
	      var _this6 = this;
	
	      var event = _ref.event,
	          start = _ref.start,
	          end = _ref.end;
	
	      var original = this.events.find(function (evt) {
	        return evt.event_id === event.event_id;
	      });
	      if (!original) {
	        return;
	      }
	      var oldStart = original.start;
	      var oldEnd = original.end;
	      original.start = (0, _moment2.default)(start).format();
	      original.end = (0, _moment2.default)(end).format();
	      this.$set(original, 'v_is_loading', true);
	      var updates = [{
	        event_id: original.event_id,
	        calendar_id: original.calendar_id,
	        start_time: start,
	        end_time: end
	      }];
	      var revert = function revert() {
	        original.start = oldStart;
	        original.end = oldEnd;
	        original.v_is_loading = false;
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      };
	      _docendo2.default.updateEvents(original.school_id, updates, function (success) {
	        if (success && success.status === 'error') {
	          revert();
	          return;
	        }
	        original.v_is_loading = false;
	        _this6.hasChanges = true;
	      }, revert);
	    },
	    onEventUpdated: function onEventUpdated() {
	      this.hasChanges = true;
	      this.updateEvents();
	    },
	    setActiveEvent: function setActiveEvent(event, calendar) {
	      if (!this.isUserCanEditCalendar) {
	        return;
	      }
	      if (!event) {
	        this.activeEvent = null;
	        this.activeCalendar = null;
	        this.activeEventCalendarId = null;
	      } else {
	        this.activeEvent = event.obj;
	        this.activeCalendar = calendar;
	        this.activeEventCalendarId = calendar.id;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    var _this7 = this;
	
	    window.addEventListener('vue_open_teamcalendar', function (e) {
	      _this7.setShowTeamCalendar();
	    });
	    this.readInitialScrollOption();
	    this.calView = this.userSettings['teamcalendar_view__tab_1'];
	    this.theSortOptionForAllSchedules = this.userSettings['teamcalendar_view__sort_option'];
	    this.isDragAndDropOn = !!this.userSettings['teamcalendar_drag_and_drop'];
	  },
	  mounted: function mounted() {
	    this._keyListener = function (e) {
	      if (e.key === 's') {
	        if (e.target.tagName.toUpperCase() === 'BODY') {
	          this.toggleShowTeamCalendar();
	        }
	      }
	    };
	    document.addEventListener('keydown', this._keyListener.bind(this));
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this._keyListener);
	  }
	};

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _TimeChanger = __webpack_require__(31);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _DSelectCalsAll = __webpack_require__(349);
	
	var _DSelectCalsAll2 = _interopRequireDefault(_DSelectCalsAll);
	
	var _TeamCalendarHeaderSaveView = __webpack_require__(1673);
	
	var _TeamCalendarHeaderSaveView2 = _interopRequireDefault(_TeamCalendarHeaderSaveView);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    views: 'Visning',
	    shortcuts: 'Genveje',
	    room_overview: 'Alle lokaler',
	    close_room_overview: 'Luk lokaleoverblik',
	    show_day: 'Vis en dag',
	    show_week: 'Vis en uge',
	    show_double_bookings: 'Vis dobbeltbookinger',
	    close_double_bookings: 'Luk dobbeltbookinger',
	    show_list: 'Vis som liste',
	    show_scheduler: 'Vis som overblik',
	    show_presence_table: 'Arbejdstid',
	    show_overlay_week: 'Samlet overblik',
	    custom: 'Tilpasset',
	    all_calendars: 'Alle kalendere',
	    all_classes: 'Alle klasser',
	    sort_by: 'Sorter efter',
	    name: 'Navn',
	    first_lesson: 'Første lektion',
	    last_lesson: 'Sidste lektion',
	    all_users: 'Alt personale',
	    scroll_up_and_down: 'Scroll op/ned',
	    scroll_sideways: 'Scroll til siden',
	    edit_schedules: 'Rediger skemaer'
	  },
	  en: {
	    views: 'View',
	    shortcuts: 'Shortcuts',
	    room_overview: 'All rooms',
	    close_room_overview: 'Close rooms overview',
	    show_day: 'Show day',
	    show_week: 'Show week',
	    show_double_bookings: 'Show double bookings',
	    close_double_bookings: 'Close double bookings',
	    show_list: 'Show as list',
	    show_scheduler: 'Show scheduler',
	    show_presence_table: 'Work hours',
	    show_overlay_week: 'Overlay week',
	    custom: 'Custom',
	    all_calendars: 'All calendars',
	    all_classes: 'All classes',
	    sort_by: 'Sort by',
	    name: 'Name',
	    first_lesson: 'First lesson',
	    last_lesson: 'Last lesson',
	    all_users: 'All users',
	    scroll_up_and_down: 'Scroll up/down',
	    scroll_sideways: 'Scroll sideways',
	    edit_schedules: 'Edit schedules'
	  },
	  nb: {
	    views: 'Visning',
	    shortcuts: 'Snarveier',
	    room_overview: 'Alle rom',
	    close_room_overview: 'Lukk dagens romoverblikk',
	    show_day: 'Vis dag',
	    show_week: 'Vis uke',
	    show_double_bookings: 'Vis dobbeltbookinger',
	    close_double_bookings: 'Lukk dobbeltbookinger',
	    show_list: 'Vis som liste',
	    show_scheduler: 'Vis skemaoverblikk',
	    show_presence_table: 'Arbeidstid',
	    show_overlay_week: 'Samlet uke',
	    custom: 'Tilpasset',
	    all_calendars: 'Alle kalendere',
	    all_classes: 'Alle klasser',
	    sort_by: 'Sorter etter',
	    name: 'Navn',
	    first_lesson: 'Første leksjon',
	    last_lesson: 'Siste leksjon',
	    all_users: 'Alle brukere',
	    scroll_up_and_down: 'Scroll opp/ned',
	    scroll_sideways: 'Scroll til siden',
	    edit_schedules: 'Rediger timeplaner'
	  }
	};
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default, dSelectAll: _DSelectCalsAll2.default, AppToggle: _AppToggle2.default, DatePicker: _DateSelector2.default, DModal: _DModal2.default, TimeChanger: _TimeChanger2.default, TeamCalendarHeaderSaveView: _TeamCalendarHeaderSaveView2.default },
	  props: {
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    calview: {
	      type: String,
	      default: 'resourceTimeGridFiveDay'
	    },
	    isNotThisWeek: {
	      type: Boolean,
	      default: true
	    },
	    itemsSelected: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedScrollOption: {
	      default: ''
	    },
	    isDragAndDropOn: {
	      type: Boolean,
	      default: false
	    },
	    isDragAndDropPossible: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      theTab: 1,
	      isShowSettings: false,
	      isShowWeekends: false,
	      showViewOptions: true,
	      standardStartTime: (0, _moment2.default)().set({ 'hour': 7, 'minutes': 0 }),
	      standardEndTime: (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0 }),
	      theSortOptionForAllSchedules: null,
	      isSetCustomNumberOfDays: false,
	      numberOfDays: 5
	    };
	  },
	
	  computed: {
	    scrollOptions: function scrollOptions() {
	      return [{ value: '', title: this.i18n[this.locale]['scroll_up_and_down'] }, { value: 'horizontal', title: this.i18n[this.locale]['scroll_sideways'] }];
	    },
	    theSelectedScrollOption: function theSelectedScrollOption() {
	      var _this = this;
	
	      return this.scrollOptions.find(function (scrollOption) {
	        return scrollOption.value === _this.selectedScrollOption;
	      })['title'];
	    },
	    sortOptionsForAllSchedules: function sortOptionsForAllSchedules() {
	      return [{ value: null, title: this.i18n[this.locale]['name'] }, { value: 'firstEvent', title: this.i18n[this.locale]['first_lesson'] }, { value: 'lastEvent', title: this.i18n[this.locale]['last_lesson'] }];
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    locale: function locale() {
	      return this.user && this.user.locale ? this.user.locale : 'en';
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    isToday: function isToday() {
	      return (0, _moment2.default)(this.date).format('YYYY-MM-DD') === (0, _moment2.default)().format('YYYY-MM-DD');
	    },
	    isSchedulerView: function isSchedulerView() {
	      return this.calview === 'scheduler';
	    },
	    startTime: function startTime() {
	      if (this.userSettings && this.userSettings.teamCalendarSettingTimes) {
	        return (0, _moment2.default)(this.userSettings.teamCalendarSettingTimes.start);
	      } else {
	        return null;
	      }
	    },
	    endTime: function endTime() {
	      if (this.userSettings && this.userSettings.teamCalendarSettingTimes) {
	        return (0, _moment2.default)(this.userSettings.teamCalendarSettingTimes.end);
	      } else {
	        return null;
	      }
	    },
	    calendarsInHash: function calendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    }
	  },
	  methods: {
	    dSelectUsersUpdated: function dSelectUsersUpdated(type, cals) {
	      if (cals) {
	        this.$emit('usersUpdated', cals);
	      }
	      this.$emit('updateEvents');
	    },
	    setChangedSortOption: function setChangedSortOption(val) {
	      this.$emit('changedSortOption', val);
	      var settingsName = 'teamcalendar_view__sort_option';
	      if (!val) {
	        this.$store.dispatch('deleteUserSetting', settingsName);
	      } else {
	        this.$store.dispatch('updateUserSettings', (0, _defineProperty3.default)({}, settingsName, val));
	      }
	    },
	    setTab: function setTab(num) {
	      this.theTab = num;
	      if (num === 1) {
	        var selectedView = this.userSettings['teamcalendar_view__tab_1'];
	        if (selectedView) {
	          this.setView(selectedView);
	        } else {
	          this.setView('resourceTimeGridFiveDay');
	        }
	      } else {
	        var _selectedView = this.userSettings['teamcalendar_view__tab_2'];
	        if (_selectedView) {
	          this.setView(_selectedView);
	        } else {
	          this.setView('scheduler');
	        }
	      }
	    },
	    userHasPermission: function userHasPermission(val) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(val) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    setInitialShowWeekend: function setInitialShowWeekend() {
	      if (this.userSettings && this.userSettings.teamCalendarSettingTimes && this.userSettings.teamCalendarSettingTimes.isShowWeekends) {
	        this.isShowWeekends = this.userSettings.teamCalendarSettingTimes.isShowWeekends;
	      }
	    },
	    setIsShowWeekends: function setIsShowWeekends(boolean) {
	      this.isShowWeekends = boolean;
	    },
	    setCustomNumberOfDays: function setCustomNumberOfDays(bool) {
	      var _this2 = this;
	
	      this.isSetCustomNumberOfDays = bool;
	      if (bool) {
	        this.$nextTick(function (_) {
	          _this2.$refs.input_custom_number_of_days.focus();
	        });
	      }
	    },
	    setStandardStartTime: function setStandardStartTime(payload) {
	      this.standardStartTime = payload;
	    },
	    setStandardEndTime: function setStandardEndTime(payload) {
	      this.standardEndTime = payload;
	    },
	    submitStandardSettings: function submitStandardSettings() {
	      var teamCalendarSettingTimes = {
	        'teamCalendarSettingTimes': {
	          start: this.standardStartTime,
	          end: this.standardEndTime
	        }
	      };
	      if (this.isSetCustomNumberOfDays) {
	        if (this.numberOfDays * 1 > 0 && this.numberOfDays * 1 < 8) {
	          teamCalendarSettingTimes['teamCalendarSettingTimes']['numberOfDays'] = this.numberOfDays;
	        } else {
	          window.alert('Not a valid number');
	          return;
	        }
	      } else {
	        teamCalendarSettingTimes['teamCalendarSettingTimes']['isShowWeekends'] = this.isShowWeekends;
	      }
	      this.$store.dispatch('updateUserSettings', teamCalendarSettingTimes);
	      this.isShowSettings = false;
	      this.$emit('updateEvents');
	    },
	    print: function print() {
	      var prtHtml = document.getElementById('printTeamCalendar').innerHTML;
	
	      var stylesHtml = '';
	
	      var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')));
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var node = _arr[_i];
	        stylesHtml += node.outerHTML;
	      }
	
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	
	      WinPrint.document.write('<!DOCTYPE html><html><head>' + stylesHtml + '</head><body>' + prtHtml + '</body></html>');
	      setTimeout(function (_) {
	        WinPrint.document.close();
	        WinPrint.focus();
	        WinPrint.print();
	        WinPrint.close();
	      }, 1000);
	    },
	    today: function today() {
	      if (this.isToday) {
	        return;
	      }
	      this.$emit('dateChange', (0, _moment2.default)());
	    },
	    setDate: function setDate(date) {
	      this.$emit('dateChange', date);
	    },
	    next: function next() {
	      switch (this.calview) {
	        case 'resourceTimeGridFiveDay':
	          this.$emit('dateChange', (0, _moment2.default)(this.date).add(1, 'weeks'));
	          break;
	        case 'listView':
	        case 'presenceTable':
	          this.$emit('dateChange', (0, _moment2.default)(this.date).add(1, 'weeks'));
	          break;
	        default:
	          this.$emit('dateChange', (0, _moment2.default)(this.date).add(1, 'days'));
	      }
	    },
	    prev: function prev() {
	      switch (this.calview) {
	        case 'resourceTimeGridFiveDay':
	          this.$emit('dateChange', (0, _moment2.default)(this.date).subtract(1, 'weeks'));
	          break;
	        case 'listView':
	        case 'presenceTable':
	          this.$emit('dateChange', (0, _moment2.default)(this.date).subtract(1, 'weeks'));
	          break;
	        default:
	          this.$emit('dateChange', (0, _moment2.default)(this.date).subtract(1, 'days'));
	      }
	    },
	    setView: function setView(doView) {
	      this.$emit('setView', doView);
	      var name = 'teamcalendar_view__tab_' + this.theTab;
	      var val = doView;
	      this.$store.dispatch('updateUserSettings', (0, _defineProperty3.default)({}, name, val));
	    },
	    getIsView: function getIsView(calView) {
	      return this.calview === calView;
	    },
	    setIsShowSettings: function setIsShowSettings() {
	      this.isShowSettings = true;
	      if (this.startTime) {
	        this.standardStartTime = this.startTime;
	      }
	      if (this.endTime) {
	        this.standardEndTime = this.endTime;
	      }
	    },
	    setSelectedScrollOption: function setSelectedScrollOption(view) {
	      this.$emit('setSelectedScrollOption', view.value);
	    },
	    setSavedView: function setSavedView(calenderIds) {
	      var _this3 = this;
	
	      var selectedCalIds = this.itemsSelected.map(function (cal) {
	        return cal.id;
	      }).sort();
	      var calIdsFiltered = calenderIds.filter(function (calId) {
	        return _this3.calendarsInHash[calId];
	      }).sort();
	      var cals = calIdsFiltered.map(function (calId) {
	        return _this3.calendarsInHash[calId];
	      });
	      if ((0, _stringify2.default)(selectedCalIds) !== (0, _stringify2.default)(calIdsFiltered)) {
	        this.$emit('usersUpdated', cals);
	      }
	      this.$emit('updateEvents');
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.theSortOptionForAllSchedules = this.userSettings['teamcalendar_view__sort_option'];
	  },
	  mounted: function mounted() {
	    this.setInitialShowWeekend();
	  }
	};

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _ModalConfirmation = __webpack_require__(20);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    save_view: 'Gem visning',
	    saved_views: 'Mine visninger',
	    create_new_view: 'Opret ny visning',
	    give_the_view_a_title: 'Giv visningen en titel',
	    ex_title: 'Eks. vikarer',
	    or_overwrite_existing: 'Eller overskriv eksisterende',
	    choose_existing: 'Vælg eksisterende..'
	  },
	  nb: {
	    save_view: 'Lagre visning',
	    saved_views: 'Lagrede visninger',
	    create_new_view: 'Opprett ny visning',
	    give_the_view_a_title: 'Gi visning en tittel',
	    ex_title: 'Eks. vikarer',
	    or_overwrite_existing: 'Eller overskriv eksisterende',
	    choose_existing: 'Velg eksisterende..'
	  },
	  en: {
	    save_view: 'Save view',
	    saved_views: 'Saved views',
	    create_new_view: 'Create new view',
	    give_the_view_a_title: 'Give the view a title',
	    ex_title: 'Ex. substitutes',
	    or_overwrite_existing: 'Or overwrite existing',
	    choose_existing: 'Choose existing..'
	  }
	};
	
	exports.default = {
	  components: { DModal: _DModal2.default, ModalConfirmation: _ModalConfirmation2.default, DDropdown: _DDropdown2.default },
	  props: {
	    itemsSelected: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      title: '',
	      isConfirmModal: false,
	      theDeleteItem: '',
	      isSaveModal: false,
	      isInputTitleDisabled: false
	    };
	  },
	
	  computed: {
	    user: function user() {
	      return this.$store.state.user;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    activeSchoolId: function activeSchoolId() {
	      return this.$store.state.activeSchool ? this.$store.state.activeSchool.id : null;
	    },
	    storageName: function storageName() {
	      return 'school_' + this.activeSchoolId + '__team_calendar_views';
	    },
	    savedViews: function savedViews() {
	      if (!this.userSettings || !this.userSettings[this.storageName]) {
	        return {};
	      }
	      return JSON.parse(this.userSettings[this.storageName]);
	    }
	  },
	  methods: {
	    setReplaceExisting: function setReplaceExisting(prop) {
	      if (prop.length > 1) {
	        this.title = prop;
	        this.isInputTitleDisabled = true;
	      } else {
	        this.title = '';
	        this.isInputTitleDisabled = false;
	      }
	    },
	    saveView: function saveView() {
	      if (!this.activeSchoolId || this.itemsSelected.length === 0 || this.title.length < 1) {
	        return;
	      }
	      var saveObj = JSON.parse((0, _stringify2.default)(this.savedViews));
	      if (Array.isArray(this.savedViews)) {
	        saveObj = {};
	      }
	      saveObj[this.title] = this.itemsSelected.map(function (cal) {
	        return cal.id;
	      });
	      this.$store.dispatch('updateUserSettings', (0, _defineProperty3.default)({}, this.storageName, (0, _stringify2.default)(saveObj)));
	      this.closeIsSaveModal();
	    },
	    setDeleteItemConfirm: function setDeleteItemConfirm(prop) {
	      this.theDeleteItem = prop;
	      this.isConfirmModal = true;
	    },
	    deleteItem: function deleteItem() {
	      var saveObj = JSON.parse((0, _stringify2.default)(this.savedViews));
	      delete saveObj[this.theDeleteItem];
	      this.$store.dispatch('updateUserSettings', (0, _defineProperty3.default)({}, this.storageName, (0, _stringify2.default)(saveObj)));
	      this.closeIsSaveModal();
	    },
	    selectView: function selectView(view, prop) {
	      this.$emit('setSavedView', view);
	    },
	    reset: function reset() {
	      this.theDeleteItem = '';
	      this.isConfirmModal = false;
	      this.isInputTitleDisabled = false;
	      this.title = '';
	    },
	    closeIsSaveModal: function closeIsSaveModal() {
	      this.theDeleteItem = '';
	      this.isConfirmModal = false;
	      this.isInputTitleDisabled = false;
	      this.title = '';
	      this.isSaveModal = false;
	    },
	    setIsSaveModal: function setIsSaveModal() {
	      var _this = this;
	
	      this.isSaveModal = true;
	      this.$nextTick(function (_) {
	        _this.$refs.is_save_modal_input.focus();
	      });
	    }
	  }
	};

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    employee: 'Medarbejder',
	    week_total: 'Ugetotal'
	  },
	  en: {
	    employee: 'Employee',
	    week_total: 'Week total'
	  },
	  nb: {
	    employee: 'Ansatt',
	    week_total: 'Uketotal'
	  }
	};
	
	exports.default = {
	  props: {
	    calendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    date: {
	      required: true
	    },
	    locale: {
	      type: String,
	      default: 'da'
	    },
	    isShowWeekends: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      i18n: I18N
	    };
	  },
	
	  computed: {
	    weekStart: function weekStart() {
	      return (0, _moment2.default)(this.date).isoWeekday(1).startOf('day');
	    },
	    weekDays: function weekDays() {
	      var count = this.isShowWeekends ? 7 : 5;
	      var days = [];
	      for (var i = 0; i < count; i++) {
	        days.push((0, _moment2.default)(this.weekStart).add(i, 'days'));
	      }
	      return days;
	    },
	    presenceEvents: function presenceEvents() {
	      var calendarIds = this.calendars.map(function (calendar) {
	        return calendar.id;
	      });
	      return this.events.filter(function (event) {
	        if (!event || event.event_type !== 'presence') {
	          return false;
	        }
	        var calId = event.calendar_id;
	        if (calId && calendarIds.indexOf(calId) > -1) {
	          return true;
	        }
	        if (event.calendars && event.calendars.length > 0) {
	          return event.calendars.some(function (calendar) {
	            return calendarIds.indexOf(calendar.calendar_id) > -1;
	          });
	        }
	        if (event.calendar_events && event.calendar_events.length > 0) {
	          return event.calendar_events.some(function (calendar) {
	            return calendarIds.indexOf(calendar.calendar_id) > -1;
	          });
	        }
	        return false;
	      });
	    },
	    tableRows: function tableRows() {
	      var _this = this;
	
	      return this.calendars.map(function (calendar) {
	        var calendarPresence = _this.presenceEvents.filter(function (event) {
	          return _this.getEventCalendarId(event) === calendar.id;
	        });
	        var weekTotalMinutes = calendarPresence.reduce(function (sum, event) {
	          return sum + (0, _moment2.default)(event.end).diff((0, _moment2.default)(event.start), 'minutes');
	        }, 0);
	        var slotsByDay = {};
	        _this.weekDays.forEach(function (day) {
	          var dayKey = day.format('YYYY-MM-DD');
	          slotsByDay[dayKey] = calendarPresence.filter(function (event) {
	            return (0, _moment2.default)(event.start).format('YYYY-MM-DD') === dayKey;
	          }).sort(function (a, b) {
	            return (0, _moment2.default)(a.start).unix() - (0, _moment2.default)(b.start).unix();
	          }).map(function (event) {
	            return _this.formatTimeRange(event);
	          });
	        });
	        return {
	          calendarId: calendar.id,
	          name: calendar.name,
	          weekTotal: _this.formatMinutesAsHHMM(weekTotalMinutes),
	          slotsByDay: slotsByDay
	        };
	      });
	    }
	  },
	  methods: {
	    getEventCalendarId: function getEventCalendarId(event) {
	      if (event.calendar_id) {
	        return event.calendar_id;
	      }
	      if (event.calendars && event.calendars.length > 0) {
	        return event.calendars[0].calendar_id;
	      }
	      if (event.calendar_events && event.calendar_events.length > 0) {
	        return event.calendar_events[0].calendar_id;
	      }
	      return null;
	    },
	    formatTimeRange: function formatTimeRange(event) {
	      return this.$filters.LT(event.start) + ' - ' + this.$filters.LT(event.end);
	    },
	    formatMinutesAsHHMM: function formatMinutesAsHHMM(minutes) {
	      var total = Math.max(0, Math.round(minutes));
	      var hours = Math.floor(total / 60);
	      var mins = total % 60;
	      return hours + ':' + String(mins).padStart(2, '0');
	    },
	    formatDayName: function formatDayName(day) {
	      return (0, _moment2.default)(day).locale(this.locale).format('dddd');
	    },
	    formatDayDate: function formatDayDate(day) {
	      var m = (0, _moment2.default)(day).locale(this.locale);
	      if (this.locale === 'en') {
	        return m.format('MM/DD');
	      }
	      return m.format('DD[/]MM');
	    }
	  }
	};

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _TimeInput = __webpack_require__(107);
	
	var _TimeInput2 = _interopRequireDefault(_TimeInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { timeInput: _TimeInput2.default },
	  props: {
	    start: {},
	    end: {},
	    lang: {},
	    addClass: {
	      type: String,
	      default: ''
	    },
	    showIcon: {
	      type: Boolean,
	      default: false
	    },
	    isFiveMinutesInterval: {
	      type: Boolean,
	      default: false
	    },
	    inputWidth: {
	      type: [Number, String],
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      diff: 60,
	      startTime: (0, _moment2.default)(this.start),
	      endTime: (0, _moment2.default)(this.end)
	    };
	  },
	
	  watch: {
	    start: function start() {
	      this.startTime = (0, _moment2.default)(this.start);
	    },
	    end: function end() {
	      this.endTime = (0, _moment2.default)(this.end);
	    }
	  },
	  computed: {
	    utcStart: function utcStart() {
	      return _moment2.default.utc(this.startTime).toISOString();
	    },
	    utcEnd: function utcEnd() {
	      return _moment2.default.utc(this.endTime).toISOString();
	    }
	  },
	  methods: {
	    calcDiff: function calcDiff() {
	      var _diff = (0, _moment2.default)(this.endTime).diff(this.startTime);
	      this.diff = _moment2.default.duration(_diff).asMinutes();
	    },
	    setStartTime: function setStartTime(val) {
	      var number = (0, _moment2.default)(val, 'LT');
	      if (isNaN(number)) {
	        this.startTime = this.startTime;
	        return;
	      } else {
	        var hours = (0, _moment2.default)(number).format('HH');
	        var minutes = this.isFiveMinutesInterval ? Math.round((0, _moment2.default)(number).format('mm') / 5) * 5 : (0, _moment2.default)(number).format('mm');
	        var _newDate = (0, _moment2.default)(this.startTime).set({ 'hour': hours, 'minute': minutes });
	        if (hours * 1 === 23 && minutes * 1 === 55) {
	          _newDate = (0, _moment2.default)(this.startTime).set({ 'hour': hours, 'minute': 50 });
	        }
	        this.startTime = _newDate;
	        if ((0, _moment2.default)(this.endTime).isBefore(_newDate) || (0, _moment2.default)(this.endTime).isSame(_newDate)) {
	          var newEndDate = (0, _moment2.default)(this.startTime).add(this.diff, 'minutes');
	          if ((0, _moment2.default)(this.startTime).isSame(newEndDate, 'day')) {
	            this.endTime = newEndDate;
	          } else {
	            this.endTime = (0, _moment2.default)(this.startTime).set({ 'hour': 23, 'minutes': 55 });
	          }
	          this.$emit('updateEnd', this.endTime);
	        }
	        this.$emit('updateStart', this.startTime);
	      }
	    },
	    setEndTime: function setEndTime(val) {
	      var number = (0, _moment2.default)(val, 'LT');
	      if (isNaN(number)) {
	        this.endTime = this.endTime;
	        return;
	      } else {
	        var hours = (0, _moment2.default)(number).format('HH');
	        var minutes = this.isFiveMinutesInterval ? Math.round((0, _moment2.default)(number).format('mm') / 5) * 5 : (0, _moment2.default)(number).format('mm');
	        var _newDate = (0, _moment2.default)(this.endTime).set({ 'hour': hours, 'minute': minutes });
	        if ((0, _moment2.default)(_newDate).isBefore(this.startTime) || (0, _moment2.default)(this.startTime).isSame(_newDate)) {
	          this.endTime = this.endTime;
	        } else {
	          this.endTime = _newDate;
	          this.$emit('updateEnd', this.endTime);
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.calcDiff();
	  }
	};

/***/ }),
/* 803 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      count: 0
	    };
	  },
	  mounted: function mounted() {
	    console.log('Vue tl-test, ready');
	    this.start_update();
	  },
	  beforeDestroy: function beforeDestroy() {
	    console.log('Vue tl-test, beforeDestroy');
	    this.stop_update();
	  },
	
	  methods: {
	    start_update: function start_update() {
	      this.timer = setInterval(this.update, 5000);
	    },
	    stop_update: function stop_update() {
	      clearInterval(this.timer);
	    },
	    update: function update() {
	      this.count++;
	      console.log('still counting');
	    }
	  }
	};

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _TaskOverviewUser = __webpack_require__(103);
	
	var _TaskOverviewUser2 = _interopRequireDefault(_TaskOverviewUser);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _AssignHoursWorkedHoursStatement = __webpack_require__(339);
	
	var _AssignHoursWorkedHoursStatement2 = _interopRequireDefault(_AssignHoursWorkedHoursStatement);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default, DModal: _DModal2.default, Loader: _Loader2.default, TaskOverviewUser: _TaskOverviewUser2.default, AssignHoursWorkedHoursStatement: _AssignHoursWorkedHoursStatement2.default },
	  props: {
	    user: {
	      type: Object,
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      isSaving: false,
	      isLoading: false,
	      versions: [],
	      activeVersion: null,
	      activeVersionId: null,
	      isDeleteWarningActive: false,
	      isDeleting: false,
	      isSaveModalActive: false,
	      newVersionTitle: '',
	      statements: [],
	      activeStatement: null,
	      activeStatementTitle: ''
	    };
	  },
	
	  computed: {
	    userId: function userId() {
	      return this.user ? this.user.id : null;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.$store.getters.schoolYearId;
	    },
	    versionDateFormatted: function versionDateFormatted() {
	      var date = this.activeVersion ? this.activeVersion.created_at : (0, _moment2.default)();
	      return (0, _moment2.default)(date).format('LLL');
	    },
	    sortedVersions: function sortedVersions() {
	      return this.versions.sort(function (a, b) {
	        return new Date(b.created_at) - new Date(a.created_at);
	      }).filter(function (version) {
	        return version.id;
	      }).map(function (version) {
	        return (0, _extends3.default)({}, version, {
	          vTitle: version.title ? version.title : (0, _moment2.default)(version.created_at).format('LLL')
	        });
	      });
	    },
	    theUser: function theUser() {
	      return this.$store.state.user;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    isUserSchoolAdmin: function isUserSchoolAdmin() {
	      return this.userHasPermission('can_manage_school');
	    },
	    showVersionsMenu: function showVersionsMenu() {
	      return this.sortedVersions.length > 0 || this.savedStatements.length > 0 || this.isUserSchoolAdmin;
	    },
	    canSeeStatements: function canSeeStatements() {
	      var country = String(this.$store.getters.schoolCountry).toLowerCase();
	      return this.$store.getters.isSchoolSystem && country === 'dk' && this.isUserSchoolAdmin;
	    },
	    savedStatements: function savedStatements() {
	      var _this = this;
	
	      return this.statements.filter(function (statement) {
	        return statement.closed_at && statement.school_year_id === _this.schoolYearId;
	      }).sort(function (a, b) {
	        return a.from_date < b.from_date ? 1 : a.from_date > b.from_date ? -1 : b.id - a.id;
	      });
	    }
	  },
	  watch: {
	    schoolId: function schoolId() {
	      this.readVersions();
	      this.readStatements();
	    },
	    schoolYearId: function schoolYearId() {
	      this.readVersions();
	    },
	    user: function user() {
	      this.readVersions();
	      this.readStatements();
	    },
	    canSeeStatements: function canSeeStatements() {
	      this.readStatements();
	    }
	  },
	  methods: {
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.theUser) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.theUser.admin;
	      } else {
	        return true;
	      }
	    },
	    readVersions: function readVersions() {
	      var _this2 = this;
	
	      if (!this.schoolYearId || !this.schoolId || !this.userId) {
	        return;
	      }
	      this.isLoading = true;
	      _docendo2.default.readTaskOverviews(this.schoolId, this.schoolYearId, this.userId, function (success) {
	        _this2.isLoading = false;
	        if (success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, success: false };
	          return;
	        }
	        _this2.versions = success;
	      }, function (failure) {
	        _this2.isLoading = false;
	        _eventbus2.default.toast = { text: 'Something went wrong', success: false };
	      });
	    },
	    readStatements: function readStatements() {
	      var _this3 = this;
	
	      if (!this.canSeeStatements || !this.schoolId || !this.userId) {
	        this.statements = [];
	        return;
	      }
	      var userId = this.userId;
	      _docendo2.default.listWorkedHoursStatements(this.schoolId, userId, function (data) {
	        if (_this3.userId === userId && Array.isArray(data)) {
	          _this3.statements = data;
	        }
	      }, function () {});
	    },
	    statementTitle: function statementTitle(statement) {
	      return 'Opgørelse ' + (0, _moment2.default)(statement.from_date).format('D. MMM YYYY') + ' - ' + (0, _moment2.default)(statement.to_date).format('D. MMM YYYY');
	    },
	    closeStatement: function closeStatement() {
	      this.activeStatement = null;
	      this.readStatements();
	    },
	    selectVersion: function selectVersion(version) {
	      this.activeVersion = version;
	      if (version) {
	        this.activeVersionId = version.id;
	      } else {
	        this.activeVersionId = null;
	      }
	    },
	    selectVersionFromId: function selectVersionFromId(id) {
	      var idx = this.sortedVersions.findIndex(function (version) {
	        return version.id === id;
	      });
	      this.selectVersion(this.sortedVersions[idx]);
	    },
	    printVersion: function printVersion() {
	      var source = this.$refs.versionBody ? this.$refs.versionBody.querySelector('.to-user') : null;
	      if (!source) {
	        return;
	      }
	      var title = this.$t('vue2.task_versions.task_overview');
	      var stylesHtml = '';
	
	      var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')));
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var node = _arr[_i];
	        stylesHtml += node.outerHTML;
	      }
	      var printStyles = '<style>\n        html, body { background: #fff; margin: 0; }\n        .to-user { page-break-after: auto !important; break-after: auto !important; }\n        .only-print { display: flex !important; }\n        .no-print { display: none !important; }\n      </style>';
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	      WinPrint.document.write('<!DOCTYPE html><html id="html-bg-white"><head><title>' + title + '</title>' + stylesHtml + printStyles + '</head><body><div id="printTaskOverviews">' + source.outerHTML + '</div></body></html>');
	      WinPrint.onafterprint = function () {
	        WinPrint.close();
	      };
	      setTimeout(function (_) {
	        WinPrint.document.close();
	        WinPrint.focus();
	        WinPrint.print();
	      }, 1000);
	    },
	    setWarningToDelete: function setWarningToDelete() {
	      this.isDeleteWarningActive = true;
	    },
	    openSaveModal: function openSaveModal() {
	      var _this4 = this;
	
	      this.isSaveModalActive = true;
	      this.$nextTick(function () {
	        if (_this4.$refs.version_name_input) {
	          _this4.$refs.version_name_input.focus();
	        }
	      });
	    },
	    closeSaveModal: function closeSaveModal() {
	      if (this.isSaving) {
	        return;
	      }
	      this.isSaveModalActive = false;
	      this.newVersionTitle = '';
	    },
	    deleteVersion: function deleteVersion() {
	      var _this5 = this;
	
	      this.isDeleting = true;
	      _docendo2.default.deleteTaskOverview(this.schoolId, this.schoolYearId, this.userId, this.activeVersion.id, function (success) {
	        _this5.isDeleteWarningActive = false;
	        _this5.isDeleting = false;
	        if (success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, success: false };
	          return;
	        }
	        _eventbus2.default.toast = { text: 'Deleted', success: true };
	        var idx = _this5.versions.findIndex(function (version) {
	          return version.id === success.id;
	        });
	        _this5.versions.splice(idx, 1);
	        _this5.activeVersion = null;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', success: false };
	      });
	    },
	    saveVersion: function saveVersion() {
	      var _this6 = this;
	
	      if (this.isSaving) {
	        return;
	      }
	      this.isSaving = true;
	      _docendo2.default.saveTaskOverview(this.schoolId, this.schoolYearId, this.userId, this.newVersionTitle, function (success) {
	        _this6.isSaving = false;
	        if (success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, success: false };
	          return;
	        }
	        _this6.newVersionTitle = '';
	        _this6.isSaveModalActive = false;
	        _eventbus2.default.toast = { text: _this6.$t('vue2.common.saved'), success: true };
	        _this6.versions.push(success);
	        _this6.$nextTick(function () {
	          var saved = _this6.sortedVersions.find(function (version) {
	            return version.id === success.id;
	          });
	          _this6.selectVersion(saved || success);
	        });
	      }, function (failure) {
	        _this6.isSaving = false;
	        _eventbus2.default.toast = { text: _this6.$t('vue2.common.something_went_wrong'), success: false };
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readVersions();
	    this.readStatements();
	  }
	};

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _values = __webpack_require__(33);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _TaskOverviewUser = __webpack_require__(103);
	
	var _TaskOverviewUser2 = _interopRequireDefault(_TaskOverviewUser);
	
	var _SubjectForm = __webpack_require__(70);
	
	var _SubjectForm2 = _interopRequireDefault(_SubjectForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    no_tasks: 'Ingen opgaver at vise'
	  },
	  en: {
	    no_tasks: 'No tasks to show'
	  },
	  nb: {
	    no_tasks: 'Ingen oppgaver å vise'
	  }
	};
	
	exports.default = {
	  components: { Loader: _Loader2.default, TaskOverviewUser: _TaskOverviewUser2.default, SubjectForm: _SubjectForm2.default },
	  props: {
	    user: {
	      type: Object,
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: true,
	      hasLoaded: false,
	      tasks: [],
	      userYear: null,
	      debounceTimer: null,
	      subjectsChangedListener: null,
	      isSubjectModal: false,
	      isSubjectLoading: false,
	      editSubject: null,
	      pendingSubjectTab: null,
	      pendingSubjectId: null
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.$store.getters.schoolYearId;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    fromDate: function fromDate() {
	      return this.activeSchoolYear ? this.activeSchoolYear.employee_time_start : null;
	    },
	    toDate: function toDate() {
	      return this.activeSchoolYear ? this.activeSchoolYear.employee_time_end : null;
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings || {};
	    },
	    shownOwnPools: function shownOwnPools() {
	      return this.$store.getters.shownOwnPools;
	    },
	    tasksFiltered: function tasksFiltered() {
	      return this.tasks.filter(function (task) {
	        return task.task_overview !== false;
	      });
	    },
	    userNorm: function userNorm() {
	      return this.userYear && this.userYear.norm ? this.userYear.norm : {};
	    },
	    userPools: function userPools() {
	      var uy = this.userYear || {};
	      var toNumberOrNull = function toNumberOrNull(val) {
	        return val === null || val === undefined ? null : parseFloat(val);
	      };
	      return {
	        assigned_total_hours: toNumberOrNull(uy.assigned_total_hours),
	        assigned_teaching_hours: toNumberOrNull(uy.assigned_teaching_hours),
	        assigned_preparation_hours: toNumberOrNull(uy.assigned_preparation_hours),
	        substitute_pool_hours: toNumberOrNull(uy.substitute_pool_hours),
	        assigned_additional_task_hours: toNumberOrNull(uy.assigned_additional_task_hours),
	        assigned_club_hours: toNumberOrNull(uy.assigned_club_hours),
	        assigned_pool_hours: toNumberOrNull(uy.assigned_pool_hours)
	      };
	    },
	    hasContent: function hasContent() {
	      var hasNorm = Array.isArray(this.userNorm) && this.userNorm.length > 0;
	      var hasPools = (0, _values2.default)(this.userPools).some(function (val) {
	        return val !== null && val !== 0;
	      });
	      var hasAgreements = !!(this.userYear && this.userYear.agreements);
	      return this.tasksFiltered.length > 0 || hasNorm || hasPools || hasAgreements || this.canEditNotes;
	    },
	    theUser: function theUser() {
	      return this.$store.state.user;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    canEditTasks: function canEditTasks() {
	      return this.userHasPermission('can_manage_school');
	    },
	    canEditNotes: function canEditNotes() {
	      return this.userHasPermission('can_edit_user_year_notes');
	    },
	    liveVersion: function liveVersion() {
	      return {
	        school_year_id: this.schoolYearId,
	        created_at: null,
	        overview: {
	          norm: this.userNorm,
	          pools: this.userPools,
	          tasks: this.tasksFiltered,
	          agreements: this.userYear && this.userYear.agreements ? this.userYear.agreements : '',
	          school_custom_data: {
	            deactivatePools: this.schoolSettings.deactivatePools,
	            shownOwnPools: this.shownOwnPools,
	            thresholdToHideTaskHours: this.schoolSettings.thresholdToHideTaskHours
	          }
	        }
	      };
	    }
	  },
	  watch: {
	    'user.id': function userId() {
	      this.isLoading = true;
	      this.readData();
	    },
	    schoolYearId: function schoolYearId() {
	      this.isLoading = true;
	      this.readData();
	    },
	    toDate: function toDate(val) {
	      if (val && !this.hasLoaded) {
	        this.readData();
	      }
	    }
	  },
	  methods: {
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.theUser) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.theUser.admin;
	      }
	      return true;
	    },
	    setEditSubject: function setEditSubject(task) {
	      var _this = this;
	
	      if (!task || !task.id) {
	        return;
	      }
	      this.isSubjectLoading = true;
	      this.isSubjectModal = true;
	      this.editSubject = null;
	      _docendo2.default.showSubject(task.id, function (success) {
	        if (success && success.status === 'error') {
	          _this.closeSubjectModal();
	          _eventbus2.default.toast = { text: success.message || _this.$t('vue2.common.something_went_wrong'), success: false };
	          return;
	        }
	        var pendingTab = _this.pendingSubjectTab;
	        _this.pendingSubjectTab = null;
	        _this.pendingSubjectId = null;
	        _this.editSubject = pendingTab ? (0, _assign2.default)({}, success, { _openTab: pendingTab }) : (0, _assign2.default)({}, success);
	        _this.isSubjectLoading = false;
	      }, function (failure) {
	        _this.closeSubjectModal();
	        _eventbus2.default.toast = { text: _this.$t('vue2.common.something_went_wrong'), success: false };
	      });
	    },
	    closeSubjectModal: function closeSubjectModal() {
	      this.editSubject = null;
	      this.isSubjectModal = false;
	      this.isSubjectLoading = false;
	    },
	    updateSubject: function updateSubject(updatedSubject) {
	      if (!updatedSubject.schoolId) {
	        updatedSubject.schoolId = this.schoolId;
	      }
	      if (!updatedSubject.schoolYearId) {
	        updatedSubject.schoolYearId = this.schoolYearId;
	      }
	      this.$store.dispatch('updateSubject', updatedSubject);
	      this.closeSubjectModal();
	    },
	    deleteSubject: function deleteSubject(editSubject) {
	      var deletedSubject = {
	        id: editSubject.id,
	        school_id: editSubject.school_id,
	        school_year_id: this.schoolYearId,
	        schoolYearId: this.schoolYearId
	      };
	      this.$store.dispatch('deleteSubject', deletedSubject);
	      this.closeSubjectModal();
	    },
	    saveAndShowTab: function saveAndShowTab(updatedSubject, tab) {
	      var _this2 = this;
	
	      this.updateSubject(updatedSubject);
	      this.pendingSubjectTab = tab;
	      this.pendingSubjectId = updatedSubject.id;
	      setTimeout(function () {
	        _this2.setEditSubject({ id: _this2.pendingSubjectId });
	      }, 500);
	    },
	    readData: function readData() {
	      var _this3 = this;
	
	      this.isLoading = true;
	      if (!this.schoolId || !this.schoolYearId || !this.user || !this.user.id || !this.toDate) {
	        return;
	      }
	      var pending = 2;
	      var done = function done(_) {
	        pending--;
	        if (pending === 0) {
	          _this3.hasLoaded = true;
	          _this3.isLoading = false;
	        }
	      };
	      var toDateExclusive = (0, _moment2.default)(this.toDate).add(1, 'days').format('YYYY-MM-DD');
	      _docendo2.default.userTasks(this.user.id, this.fromDate, toDateExclusive, true, function (data) {
	        if (data && data.status === 'error') {
	          done();
	          return;
	        }
	        _this3.tasks = data || [];
	        done();
	      }, function (failure) {
	        console.log('failed to read user tasks', failure);
	        done();
	      });
	
	      _docendo2.default.schoolUserYearRead(this.schoolId, this.user.id, this.activeSchoolYear.name, function (data) {
	        if (data && data.status === 'error') {
	          done();
	          return;
	        }
	        _this3.userYear = data || null;
	        done();
	      }, function (failure) {
	        console.log('failed to read user year', failure);
	        done();
	      });
	    },
	    readDataDebounced: function readDataDebounced() {
	      var _this4 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function (_) {
	        _this4.readData();
	      }, 250);
	    }
	  },
	  mounted: function mounted() {
	    var _this5 = this;
	
	    this.readData();
	
	    this.subjectsChangedListener = function (_) {
	      _this5.readDataDebounced();
	    };
	    window.addEventListener('vueCRUDSubject', this.subjectsChangedListener, false);
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearTimeout(this.debounceTimer);
	    window.removeEventListener('vueCRUDSubject', this.subjectsChangedListener, false);
	  }
	};

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _TaskOverviewLive = __webpack_require__(1677);
	
	var _TaskOverviewLive2 = _interopRequireDefault(_TaskOverviewLive);
	
	var _TaskOverview = __webpack_require__(1676);
	
	var _TaskOverview2 = _interopRequireDefault(_TaskOverview);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _SelectUser = __webpack_require__(416);
	
	var _SelectUser2 = _interopRequireDefault(_SelectUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { TaskOverviewLive: _TaskOverviewLive2.default, TaskOverviewVersions: _TaskOverview2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, SelectUser: _SelectUser2.default },
	  props: {
	    user_id: {
	      default: null
	    },
	    user_calendar_id: {
	      default: null
	    },
	    user_name: {
	      default: ''
	    },
	    isCanSeeOtherUsers: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: {
	    loggedInUser: function loggedInUser() {
	      return this.$store.state.user;
	    },
	    viewedUser: function viewedUser() {
	      return {
	        id: this.user_id ? this.user_id * 1 : null,
	        name: this.user_name,
	        user_calendar_id: this.user_calendar_id ? this.user_calendar_id * 1 : null
	      };
	    },
	    canUserSeeVersions: function canUserSeeVersions() {
	      if (!this.loggedInUser || !this.viewedUser || !this.viewedUser.id) {
	        return false;
	      }
	      if (this.userHasPermission('can_manage_school')) {
	        return true;
	      }
	      return this.loggedInUser.id * 1 === this.viewedUser.id * 1 && this.userHasPermission('can_see_own_task_overview');
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    usersSorted: function usersSorted() {
	      return this.$store.getters.usersSortedOnName;
	    }
	  },
	  methods: {
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.loggedInUser) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.loggedInUser.admin;
	      }
	      return true;
	    },
	    print: function print() {
	      var source = this.$el.querySelector('.to-user');
	      if (!source) {
	        return;
	      }
	      var title = this.$t('vue2.task_versions.task_overview');
	      var stylesHtml = '';
	
	      var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')));
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var node = _arr[_i];
	        stylesHtml += node.outerHTML;
	      }
	      var printStyles = '<style>\n        html, body { background: #fff; margin: 0; }\n        .to-user { page-break-after: auto !important; break-after: auto !important; }\n        .only-print { display: flex !important; }\n        .no-print { display: none !important; }\n      </style>';
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	      WinPrint.document.write('<!DOCTYPE html><html id="html-bg-white"><head><title>' + title + '</title>' + stylesHtml + printStyles + '</head><body><div id="printTaskOverviews">' + source.outerHTML + '</div></body></html>');
	      var afterPrint = function afterPrint() {
	        WinPrint.close();
	      };
	      WinPrint.onafterprint = afterPrint;
	      setTimeout(function (_) {
	        WinPrint.document.close();
	        WinPrint.focus();
	        WinPrint.print();
	      }, 1000);
	    },
	    selectUser: function selectUser(id) {
	      window.location = '/users/' + id + '/tasks#';
	    },
	    selectNextUser: function selectNextUser() {
	      var _this = this;
	
	      var idx = this.usersSorted.findIndex(function (user) {
	        return user.id * 1 === _this.user_id * 1;
	      });
	      var nextUserId = this.usersSorted[idx + 1] && this.usersSorted[idx + 1].id ? this.usersSorted[idx + 1].id : null;
	      if (nextUserId) {
	        this.selectUser(nextUserId);
	      }
	    },
	    selectPrevUser: function selectPrevUser() {
	      var _this2 = this;
	
	      var idx = this.usersSorted.findIndex(function (user) {
	        return user.id * 1 === _this2.user_id * 1;
	      });
	      var prevUserId = this.usersSorted[idx - 1] && this.usersSorted[idx - 1].id ? this.usersSorted[idx - 1].id : null;
	      if (prevUserId) {
	        this.selectUser(prevUserId);
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (document.title && this.user_name) {
	      document.title = this.user_name + ' - ' + this.$t('vue2.task_overview.task_overview');
	    }
	    this._keyListener = function (e) {
	      var key = e.which || e.keyCode;
	      var metaKey = e.metaKey || e.ctrlKey;
	      if (metaKey && key === 39) {
	        if (e.target.tagName.toUpperCase() === 'BODY') {
	          this.selectNextUser();
	        }
	      }
	      if (metaKey && e.shiftKey && key === 37) {
	        if (e.target.tagName.toUpperCase() === 'BODY') {
	          this.selectPrevUser();
	        }
	      }
	    };
	    document.addEventListener('keydown', this._keyListener.bind(this));
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this._keyListener);
	  }
	};

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(35);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(50);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _getIterator2 = __webpack_require__(45);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _UserTasksOverviewOwnPools = __webpack_require__(405);
	
	var _UserTasksOverviewOwnPools2 = _interopRequireDefault(_UserTasksOverviewOwnPools);
	
	var _SubjectsDistributionUserAgreements = __webpack_require__(83);
	
	var _SubjectsDistributionUserAgreements2 = _interopRequireDefault(_SubjectsDistributionUserAgreements);
	
	var _TaskOverviewUserTasks = __webpack_require__(1678);
	
	var _TaskOverviewUserTasks2 = _interopRequireDefault(_TaskOverviewUserTasks);
	
	var _preparationFactor = __webpack_require__(42);
	
	var _taskOverviewSnapshot = __webpack_require__(447);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    assigned_total_hours: 'Arbejdstid',
	    assigned_teaching_hours: 'Undervisning',
	    assigned_preparation_hours: 'Forberedelse',
	    assigned_additional_task_hours: 'Øvrige opgaver',
	    assigned_pool_hours: 'Lokalpulje',
	    assigned_club_hours: 'SFO timer',
	    substitute_pool_hours: 'Vikartimer',
	    notes: 'Noter/særlige aftaler',
	    pools: 'Fordeling'
	  },
	  nb: {
	    assigned_total_hours: 'Arbeidstid',
	    assigned_teaching_hours: 'Undervisning',
	    assigned_preparation_hours: 'Forberedelse',
	    assigned_additional_task_hours: 'Oppgaver',
	    substitute_pool_hours: 'Vikartimer',
	    assigned_pool_hours: 'Planegginsdager',
	    assigned_club_hours: 'SFO timer',
	    notes: 'Noter/særlige aftaler',
	    pools: 'Puljer'
	  },
	  en: {
	    assigned_club_hours: 'Club Hours',
	    assigned_pool_hours: 'Local pool',
	    assigned_total_hours: 'Work time',
	    substitute_pool_hours: 'Substitute hours',
	    assigned_teaching_hours: 'Teaching',
	    assigned_preparation_hours: 'Preparation',
	    assigned_additional_task_hours: 'Additional tasks',
	    notes: 'Notes',
	    pools: 'Pools'
	  }
	};
	exports.default = {
	  components: { UserTasksOverviewOwnPools: _UserTasksOverviewOwnPools2.default, TaskOverviewUserTasks: _TaskOverviewUserTasks2.default, SubjectsDistributionUserAgreements: _SubjectsDistributionUserAgreements2.default },
	  props: {
	    user: {},
	    version: {
	      default: function _default() {
	        return null;
	      }
	    },
	    isHideTaskHoursUnderThreshold: {
	      default: false
	    },
	    showHeadline: {
	      type: Boolean,
	      default: true
	    },
	    canEditTasks: {
	      type: Boolean,
	      default: false
	    },
	    canEditNotes: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isShowScheduled: false
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return (0, _assign2.default)({}, I18N[this.locale], {
	        assigned_pool_hours: this.localPoolTitle
	      });
	    },
	    localPoolTitle: function localPoolTitle() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || this.$t('vue2.task_overview.pool');
	    },
	    schoolCustomData: function schoolCustomData() {
	      return this.version && this.version.overview && this.version.overview.school_custom_data;
	    },
	    isPoolsDeactivated: function isPoolsDeactivated() {
	      return (0, _taskOverviewSnapshot.effectiveDeactivatePoolsFromVersion)(this.version, this.schoolSettings);
	    },
	    isAssignedPoolFromNormWhenPoolsDeactivated: function isAssignedPoolFromNormWhenPoolsDeactivated() {
	      return (0, _taskOverviewSnapshot.effectiveAssignedPoolFromNormWhenPoolsDeactivated)(this.version, this.schoolSettings);
	    },
	    schoolThresholdToHideTaskHours: function schoolThresholdToHideTaskHours() {
	      return this.schoolCustomData ? this.schoolCustomData.thresholdToHideTaskHours : null;
	    },
	    schoolSettingShownOwnPools: function schoolSettingShownOwnPools() {
	      return this.schoolCustomData ? this.schoolCustomData.shownOwnPools : [];
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    schoolSettingPrepFactor: function schoolSettingPrepFactor() {
	      return (0, _taskOverviewSnapshot.effectivePrepFactorFromVersion)(this.version, this.schoolSettings);
	    },
	    isPrepFactorForSubstitutePools: function isPrepFactorForSubstitutePools() {
	      return !!(this.schoolSettings && this.schoolSettings.prepFactorForSubstitutePools);
	    },
	    substitutePoolPreparationHours: function substitutePoolPreparationHours() {
	      if (!this.isPrepFactorForSubstitutePools || this.isUserInGroupWithoutPrepFactor) {
	        return 0;
	      }
	      var schoolPrep = (0, _preparationFactor.parseNumericPreparationFactor)(this.schoolSettingPrepFactor);
	      if (schoolPrep === null) {
	        return 0;
	      }
	      var substituteHours = this.userPools ? parseFloat(this.userPools.substitute_pool_hours) : NaN;
	      if (isNaN(substituteHours)) {
	        return 0;
	      }
	      return parseFloat((substituteHours * schoolPrep).toFixed(2));
	    },
	    schoolCountry: function schoolCountry() {
	      return this.$store.getters.schoolCountry;
	    },
	    userTagsWithoutPrepFactor: function userTagsWithoutPrepFactor() {
	      return this.$store.getters.userTagsWithoutPrepFactor || [];
	    },
	    isUserInGroupWithoutPrepFactor: function isUserInGroupWithoutPrepFactor() {
	      var _this = this;
	
	      if (this.userTagsWithoutPrepFactor.length === 0) {
	        return false;
	      }
	      var userTags = this.user && this.user.user_tags;
	      if (!Array.isArray(userTags)) {
	        var storeUser = this.$store.getters.allUsersInHash && this.$store.getters.allUsersInHash[this.user.id];
	        userTags = storeUser && storeUser.user_tags;
	      }
	      if (!Array.isArray(userTags)) {
	        return false;
	      }
	      return userTags.some(function (tag) {
	        return _this.userTagsWithoutPrepFactor.includes(tag);
	      });
	    },
	    weightedPreparationDisplayHours: function weightedPreparationDisplayHours() {
	      if (!this.schoolSettingPrepFactor || !this.isPoolsDeactivated) {
	        return null;
	      }
	      if (this.locale !== 'da' || String(this.schoolCountry).toLowerCase() !== 'dk') {
	        return null;
	      }
	      var schoolPrep = (0, _preparationFactor.parseNumericPreparationFactor)(this.schoolSettingPrepFactor);
	      if (schoolPrep === null) {
	        return null;
	      }
	      var skipTeachingFactor = this.isUserInGroupWithoutPrepFactor;
	      var total = 0;
	      this.tasksFiltered.forEach(function (task) {
	        if (task.substitute) {
	          return;
	        }
	        var isPrepTypeTask = task.subject_type === 'preparation' || task.master_type === 'preparation';
	        var isTeachingOnly = task.master_type === 'teaching' && !isPrepTypeTask;
	        if (!isPrepTypeTask && !isTeachingOnly) {
	          return;
	        }
	        var hours = parseFloat(task.hours);
	        var h = isNaN(hours) ? 0 : hours;
	        if (isPrepTypeTask) {
	          var factor = (0, _preparationFactor.parseNumericPreparationFactor)(task.preparation);
	          if (factor !== null) {
	            total += h * factor;
	          }
	        } else if (!skipTeachingFactor) {
	          var _factor = (0, _preparationFactor.effectivePreparationFactor)(task.preparation, schoolPrep);
	          total += h * _factor;
	        }
	      });
	      return parseFloat(total.toFixed(2));
	    },
	    schoolYears: function schoolYears() {
	      return this.$store.state.schoolYears;
	    },
	    schoolYear: function schoolYear() {
	      var _this2 = this;
	
	      if (!this.version || !this.version.school_year_id) {
	        return '';
	      }
	      var idx = this.schoolYears.findIndex(function (schoolYear) {
	        return schoolYear.id === _this2.version.school_year_id;
	      });
	      return idx > -1 ? this.schoolYears[idx]['name'] : '';
	    },
	    userIdNumber: function userIdNumber() {
	      return this.user && this.user.id ? this.user.id * 1 : null;
	    },
	    userAgreements: function userAgreements() {
	      return this.version.overview && this.version.overview.agreements ? this.version.overview.agreements : '';
	    },
	    userNorm: function userNorm() {
	      return this.version.overview.norm;
	    },
	    userNormFormatted: function userNormFormatted() {
	      if ((0, _keys2.default)(this.userNorm).length < 1) {
	        return [];
	      }
	      var normsFiltered = this.userNorm.filter(function (item) {
	        return item.title.indexOf('hidden_') < 0;
	      });
	      return normsFiltered.map(function (item) {
	        return (0, _extends3.default)({}, item, {
	          value: item.value
	        });
	      });
	    },
	    userPools: function userPools() {
	      return this.version.overview.pools;
	    },
	    taskPools: function taskPools() {
	      var _this3 = this;
	
	      var result = {};
	
	      var formatHours = function formatHours(value) {
	        return value || value === 0 ? value.toFixed(2) : '0.00';
	      };
	
	      var totalWorkHours = this.userPools['assigned_total_hours'];
	      var translatedKey = this.i18n['assigned_total_hours'] || 'assigned_total_hours';
	      var translatedPrep = this.i18n['assigned_preparation_hours'];
	      result[translatedKey] = formatHours(totalWorkHours);
	
	      var taskTypes = this.schoolSettingPrepFactor ? this.tasksByOriginalType.filter(function (taskType) {
	        return taskType.originalType !== 'preparation';
	      }) : this.tasksByOriginalType;
	      var hasPrepRow = false;
	      taskTypes.forEach(function (taskType) {
	        if (_this3.schoolSettingPrepFactor && taskType.originalType === 'teaching') {
	          var prepHours = (_this3.weightedPreparationDisplayHours !== null ? _this3.weightedPreparationDisplayHours : taskType.totalHours * _this3.schoolSettingPrepFactor) + _this3.substitutePoolPreparationHours;
	          result[translatedPrep] = formatHours(prepHours);
	          hasPrepRow = true;
	        }
	        result[taskType.title] = formatHours(taskType.totalHours);
	      });
	
	      if (this.schoolSettingPrepFactor && !hasPrepRow) {
	        var prepWithoutTeaching = (this.weightedPreparationDisplayHours !== null ? this.weightedPreparationDisplayHours : 0) + this.substitutePoolPreparationHours;
	        if (prepWithoutTeaching !== 0) {
	          result[translatedPrep] = formatHours(prepWithoutTeaching);
	        }
	      }
	      return result;
	    },
	    userPoolsFormatted: function userPoolsFormatted() {
	      var _this4 = this;
	
	      if (this.isPoolsDeactivated) {
	        var _result = (0, _assign2.default)({}, this.taskPools);
	        if (this.isAssignedPoolFromNormWhenPoolsDeactivated) {
	          var poolHours = this.userPools && this.userPools.assigned_pool_hours;
	          if (poolHours !== null && poolHours !== undefined && poolHours !== 0) {
	            _result[this.i18n.assigned_pool_hours] = (poolHours || poolHours === 0 ? poolHours : 0).toFixed(2);
	          }
	        }
	
	        if (this.isPrepFactorForSubstitutePools) {
	          var substituteHours = this.userPools && this.userPools.substitute_pool_hours;
	          if (substituteHours !== null && substituteHours !== undefined && substituteHours !== 0) {
	            _result[this.i18n.substitute_pool_hours] = Number(substituteHours).toFixed(2);
	          }
	        }
	        return _result;
	      }
	      var result = {};
	
	      var translatedKeys = [];
	      for (var key in this.userPools) {
	        if (this.userPools[key] !== null && this.userPools[key] !== 0) {
	          var translatedKey = this.i18n[key] || key;
	          translatedKeys.push({ key: translatedKey, originalKey: key });
	        }
	      }
	
	      translatedKeys.sort(function (a, b) {
	        return (0, _keys2.default)(_this4.i18n).indexOf(a.originalKey) - (0, _keys2.default)(_this4.i18n).indexOf(b.originalKey);
	      });
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(translatedKeys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var item = _step.value;
	
	          result[item.key] = this.userPools[item.originalKey].toFixed(2);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return result;
	    },
	    totalUserPools: function totalUserPools() {
	      var poolsObj = this.isPoolsDeactivated ? this.userPoolsFormatted : this.userPools;
	      var sum = 0;
	      for (var key in poolsObj) {
	        if (key !== 'assigned_total_hours' && key !== this.i18n['assigned_total_hours']) {
	          var value = poolsObj[key];
	          var num = Number(value);
	          if (!isNaN(num)) {
	            sum += num;
	          }
	        }
	      }
	      return sum;
	    },
	    rest: function rest() {
	      if (this.userPools.assigned_total_hours && this.userPools.assigned_total_hours > 0) {
	        var remainingHours = this.userPools.assigned_total_hours - this.totalUserPools;
	        return remainingHours.toFixed(2);
	      }
	    },
	    tasks: function tasks() {
	      return this.version.overview.tasks;
	    },
	    tasksFiltered: function tasksFiltered() {
	      return this.tasks.filter(function (item) {
	        return item.master_type !== 'unknown';
	      });
	    },
	    tasksByMasterType: function tasksByMasterType() {
	      var _this5 = this;
	
	      var pools = {};
	
	      function getValidHours(val) {
	        var num = parseFloat(val);
	        return isNaN(num) ? 0 : num;
	      }
	
	      this.tasksFiltered.forEach(function (task) {
	        var hours = getValidHours(task.hours);
	
	        if (!task.actual && hours === 0) {
	          var sameIdTasks = _this5.tasksFiltered.filter(function (t) {
	            return t.id === task.id;
	          });
	          if (sameIdTasks.length > 1) {
	            return;
	          }
	        }
	
	        var activeType = task.task_category_name ? task.task_category_name : task.master_type;
	
	        if (task.substitute) {
	          activeType = 'substitute_hours';
	        }
	
	        var title = _this5.getMasterTypeTitle(activeType);
	
	        if (!pools[title]) {
	          pools[title] = {
	            originalType: activeType,
	            rank: task.substitute ? null : _this5.getTaskCategoryRank(task),
	            tasks: [],
	            totalHours: 0.0
	          };
	        }
	
	        pools[title].tasks.push(task);
	        pools[title].totalHours += hours;
	      });
	
	      for (var pool in pools) {
	        pools[pool].tasks.sort(function (a, b) {
	          return _this5.compareTasksForOverview(a, b);
	        });
	      }
	
	      var poolsArray = (0, _entries2.default)(pools).map(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            title = _ref2[0],
	            _ref2$ = _ref2[1],
	            originalType = _ref2$.originalType,
	            rank = _ref2$.rank,
	            tasks = _ref2$.tasks,
	            totalHours = _ref2$.totalHours;
	
	        return {
	          title: title === 'substitute_hours' ? _this5.getMasterTypeTitle('substitute_hours') : title,
	          originalType: originalType,
	          rank: rank,
	          tasks: tasks,
	          totalHours: totalHours
	        };
	      });
	
	      poolsArray.sort(function (a, b) {
	        return _this5.getPoolSortOrder(a) - _this5.getPoolSortOrder(b);
	      });
	
	      return poolsArray.filter(function (pool) {
	        return pool.originalType !== 'absence';
	      });
	    },
	    tasksByOriginalType: function tasksByOriginalType() {
	      var _this6 = this;
	
	      var pools = {};
	
	      function getValidHours(val) {
	        var num = parseFloat(val);
	        return isNaN(num) ? 0 : num;
	      }
	
	      this.tasksFiltered.forEach(function (task) {
	        var hours = getValidHours(task.hours);
	        var masterTypeTitle = _this6.getMasterTypeTitle(task.master_type);
	
	        if (!pools[masterTypeTitle]) {
	          pools[masterTypeTitle] = {
	            originalType: task.master_type,
	            rank: _this6.getTaskCategoryRank(task),
	            tasks: [],
	            totalHours: 0.0
	          };
	        }
	
	        pools[masterTypeTitle].totalHours += hours;
	
	        if (task.substitute && !pools['substitute_hours']) {
	          pools['substitute_hours'] = {
	            originalType: 'substitute_hours',
	            rank: null,
	            tasks: [task],
	            totalHours: hours
	          };
	        } else if (task.substitute) {
	          pools['substitute_hours'].tasks.push(task);
	          pools['substitute_hours'].totalHours += hours;
	        } else {
	          pools[masterTypeTitle].tasks.push(task);
	        }
	      });
	
	      for (var pool in pools) {
	        pools[pool].tasks.sort(function (a, b) {
	          return _this6.compareTasksForOverview(a, b);
	        });
	      }
	
	      var poolsArray = (0, _entries2.default)(pools).map(function (_ref3) {
	        var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
	            title = _ref4[0],
	            _ref4$ = _ref4[1],
	            originalType = _ref4$.originalType,
	            rank = _ref4$.rank,
	            tasks = _ref4$.tasks,
	            totalHours = _ref4$.totalHours;
	
	        return {
	          title: title === 'substitute_hours' ? _this6.getMasterTypeTitle('substitute_hours') : title,
	          originalType: originalType,
	          rank: rank,
	          tasks: tasks,
	          totalHours: totalHours
	        };
	      });
	
	      poolsArray.sort(function (a, b) {
	        return _this6.getPoolSortOrder(a) - _this6.getPoolSortOrder(b);
	      });
	
	      return poolsArray.filter(function (pool) {
	        return pool.originalType !== 'absence';
	      });
	    },
	    sortOrder: function sortOrder() {
	      return {
	        teaching: 0,
	        substitute_hours: 1,
	        other: 2,
	        preparation: 3,
	        club: 4,
	        absence: 8,
	        unknown: 8,
	        with_kids: 0,
	        without_kids: 2
	      };
	    }
	  },
	  methods: {
	    getTaskCategoryRank: function getTaskCategoryRank(task) {
	      return task && task.task_category_rank !== undefined && task.task_category_rank !== null ? task.task_category_rank : null;
	    },
	    compareTasksForOverview: function compareTasksForOverview(a, b) {
	      var aIsActivity = a.subject_type === 'activity';
	      var bIsActivity = b.subject_type === 'activity';
	      if (aIsActivity !== bIsActivity) return aIsActivity ? 1 : -1;
	      if (a.name < b.name) return -1;
	      if (a.name > b.name) return 1;
	      return 0;
	    },
	    getPoolSortOrder: function getPoolSortOrder(pool) {
	      if (pool.rank !== null && pool.rank !== undefined) {
	        return pool.rank;
	      }
	      return this.sortOrder[pool.originalType] !== undefined ? this.sortOrder[pool.originalType] : 999;
	    },
	    getMasterTypeTitle: function getMasterTypeTitle(title) {
	      switch (title) {
	        case 'teaching':
	          return this.$t('vue2.task_overview.teaching');
	        case 'other':
	          return this.$t('vue2.task_overview.tasks');
	        case 'preparation':
	          return this.$t('vue2.task_overview.preparation');
	        case 'absence':
	          return this.$t('vue2.task_overview.absence');
	        case 'club':
	          return this.$t('vue2.task_overview.club');
	        case 'substitute_hours':
	          return this.$t('vue2.task_overview.substitute_hours');
	        case 'pool':
	          return this.localPoolTitle;
	        case 'with_kids':
	          return 'Tid med børn';
	        case 'without_kids':
	          return 'Tid uden børn';
	        default:
	          return title;
	      }
	    },
	    onEditTask: function onEditTask(task) {
	      this.$emit('editTask', task);
	    }
	  }
	};

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserTasksTable = __webpack_require__(148);
	
	var _UserTasksTable2 = _interopRequireDefault(_UserTasksTable);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { UserTasksTable: _UserTasksTable2.default },
	  props: {
	    user: {
	      type: Object,
	      required: true
	    },
	    tasks: {
	      default: function _default() {
	        return [];
	      }
	    },
	    isHideTaskHoursUnderThreshold: {
	      default: false
	    },
	    schoolThresholdToHideTaskHours: {
	      default: null
	    },
	    sortOrder: {
	      default: null
	    },
	    tasksByMasterType: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    canEditTasks: {
	      type: Boolean,
	      default: false
	    }
	  },
	  methods: {
	    canEditTask: function canEditTask(task) {
	      return this.canEditTasks && task && task.id && !task.substitute;
	    },
	    onTaskClick: function onTaskClick(task) {
	      if (!this.canEditTask(task)) {
	        return;
	      }
	      this.$emit('editTask', task);
	    },
	    formatHours: function formatHours(value) {
	      var num = parseFloat(value);
	      if (isNaN(num)) return value;
	      return Math.round(num * 100) / 100;
	    },
	    getCalendarNames: function getCalendarNames(task) {
	      if (!task.calendars) {
	        return task.calendar || '';
	      }
	      var calendars = task.calendars;
	      if (typeof calendars === 'string') {
	        try {
	          calendars = JSON.parse(calendars);
	        } catch (e) {
	          return task.calendar || '';
	        }
	      }
	      if (!Array.isArray(calendars) || calendars.length < 1) {
	        return task.calendar || '';
	      }
	      var klassNames = [];
	      for (var i = 0; i < calendars.length; i++) {
	        if (calendars[i].calendar_type === 'klass') {
	          klassNames.push(calendars[i].name);
	        }
	      }
	      if (klassNames.length < 1) {
	        return task.calendar || '';
	      }
	      if (klassNames.length <= 4) {
	        return klassNames.join(', ');
	      }
	      return klassNames.slice(0, 4).join(', ') + ' ...';
	    },
	    getIsHideHours: function getIsHideHours(task) {
	      return task.hours * 1 === 0 || this.isHideTaskHoursUnderThreshold && task.subject_type === 'additional_tasks' && task.hours * 1 < this.schoolThresholdToHideTaskHours;
	    },
	    getIsHideTotalHours: function getIsHideTotalHours(tasksType) {
	      return tasksType.totalHours < 1 || this.isHideTaskHoursUnderThreshold && this.schoolThresholdToHideTaskHours && tasksType.originalType === 'other';
	    },
	    hasAnyDatesInGroup: function hasAnyDatesInGroup(tasksType) {
	      return tasksType.tasks.some(function (task) {
	        return task.from_date || task.to_date;
	      });
	    },
	    formatDateRange: function formatDateRange(fromDate, toDate) {
	      if (!fromDate && !toDate) return '';
	      var from = fromDate ? (0, _moment2.default)(fromDate) : null;
	      var to = toDate ? (0, _moment2.default)(toDate) : null;
	      if (from && !to) return from.format('DD-MM-YYYY');
	      if (!from && to) return to.format('DD-MM-YYYY');
	      if (from.isSame(to, 'day')) return from.format('DD-MM-YYYY');
	      return from.format('DD-MM-YYYY') + ' - ' + to.format('DD-MM-YYYY');
	    }
	  }
	};

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(69);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _userEventsFilter = __webpack_require__(112);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, Modal: _Modal2.default },
	  props: {
	    userId: {
	      type: Number
	    },
	    eventsFilter: {
	      type: String,
	      default: 'absence'
	    }
	  },
	  data: function data() {
	    return {
	      showModal: false,
	      events: [],
	      isLoading: false
	    };
	  },
	
	  computed: {
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    start: function start() {
	      return (0, _moment2.default)(this.activeSchoolYears.employee_time_start).startOf('day');
	    },
	    end: function end() {
	      return (0, _moment2.default)(this.activeSchoolYears.employee_time_end).startOf('day');
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    selectedUsersIds: function selectedUsersIds() {
	      return [this.userId];
	    },
	    userName: function userName() {
	      return this.allUsersInHash[this.userId] ? this.allUsersInHash[this.userId].name : '';
	    },
	    filteredEvents: function filteredEvents() {
	      return (0, _userEventsFilter.filterUserEvents)(this.events, this.eventsFilter, this.userId);
	    },
	    sortedEvents: function sortedEvents() {
	      var arr = this.filteredEvents;
	      return arr.sort(function (a, b) {
	        return (0, _moment2.default)(a.start_time).unix() - (0, _moment2.default)(b.start_time).unix();
	      });
	    },
	    totalDuration: function totalDuration() {
	      var durations = [];
	      this.sortedEvents.forEach(function (event) {
	        durations.push(event.calendar_event_duration);
	      });
	      var data = durations.reduce(function (a, b) {
	        return a + b;
	      }, 0);
	      return this.humanizeMinutes(data);
	    }
	  },
	  watch: {
	    userId: function userId() {
	      this.getAllEvents();
	    }
	  },
	  methods: {
	    getAllEvents: function getAllEvents() {
	      var _this = this;
	
	      this.isLoading = true;
	      _docendo2.default.schoolEvents(window.SCHOOL.id, this.start, this.end, this.selectedUsersIds, 'absence', function (data) {
	        _this.events = data[0].events;
	        _this.isLoading = false;
	      });
	    },
	    getDuration: function getDuration(event) {
	      return this.humanizeMinutes(event.calendar_event_duration);
	    },
	    humanizeMinutes: function humanizeMinutes(data) {
	      var minutes = data % 60;
	      var hours = (data - minutes) / 60;
	      var multiple = hours === 1 ? this.$i18n.t('vue2.substitute_hours.hour') : this.$i18n.t('vue2.substitute_hours.hours');
	      return hours + ' ' + multiple + ' ' + minutes + ' ' + this.$t('vue2.substitute_hours.min');
	    },
	    close: function close() {
	      this.$emit('close');
	      this.events = [];
	    }
	  },
	  mounted: function mounted() {
	    this.getAllEvents();
	  }
	};

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TaskOverviewPage = __webpack_require__(147);
	
	var _TaskOverviewPage2 = _interopRequireDefault(_TaskOverviewPage);
	
	var _UserTasks = __webpack_require__(54);
	
	var _UserTasks2 = _interopRequireDefault(_UserTasks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Tabs: _Tabs2.default, TaskOverviewPage: _TaskOverviewPage2.default, UserTasks: _UserTasks2.default },
	  props: {
	    user: {
	      type: Object,
	      required: true
	    },
	    initialView: {
	      type: String,
	      default: 'hours'
	    },
	    initialStartDate: {
	      default: null
	    },
	    initialEndDate: {
	      default: null
	    },
	    initialIsShowScheduled: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      theView: this.initialView
	    };
	  },
	
	  computed: {
	    loggedInUser: function loggedInUser() {
	      return this.$store.state.user;
	    },
	    isOwnUser: function isOwnUser() {
	      return !!this.loggedInUser && this.loggedInUser.id * 1 === this.user.id * 1;
	    },
	    canSeeTaskOverview: function canSeeTaskOverview() {
	      if (this.isOwnUser && this.userHasPermission('can_see_own_task_overview')) {
	        return true;
	      }
	      return this.userHasPermission('can_see_others_task_overviews');
	    },
	    tabs: function tabs() {
	      var tabs = [];
	      if (this.canSeeTaskOverview) {
	        tabs.push({ id: 'tasks', title: this.$t('vue2.task_overview.task_overview') });
	      }
	      tabs.push({ id: 'hours', title: this.$store.getters.isKindergarten ? 'Årsnormsoversigt' : this.$t('vue2.task_overview.hour_overview') });
	      return tabs;
	    },
	    activeView: function activeView() {
	      var _this = this;
	
	      return this.tabs.some(function (tab) {
	        return tab.id === _this.theView;
	      }) ? this.theView : 'hours';
	    }
	  },
	  methods: {
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.loggedInUser) {
	        return false;
	      }
	      if (this.$store.getters.isPermissionsActivatedForSchool) {
	        return this.$store.getters.userPermissions.indexOf(permission) > -1 || this.loggedInUser.admin;
	      }
	      return true;
	    }
	  }
	};

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _UserTasksChart = __webpack_require__(404);
	
	var _UserTasksChart2 = _interopRequireDefault(_UserTasksChart);
	
	var _UserTasksOverview = __webpack_require__(1680);
	
	var _UserTasksOverview2 = _interopRequireDefault(_UserTasksOverview);
	
	var _UserTasksTable = __webpack_require__(148);
	
	var _UserTasksTable2 = _interopRequireDefault(_UserTasksTable);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SelectUser = __webpack_require__(416);
	
	var _SelectUser2 = _interopRequireDefault(_SelectUser);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DatePickerRangeShortcuts = __webpack_require__(105);
	
	var _DatePickerRangeShortcuts2 = _interopRequireDefault(_DatePickerRangeShortcuts);
	
	var _preparationFactor = __webpack_require__(42);
	
	var _SubjectForm = __webpack_require__(70);
	
	var _SubjectForm2 = _interopRequireDefault(_SubjectForm);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DatePickerRangeShortcuts: _DatePickerRangeShortcuts2.default,
	    Loader: _Loader2.default,
	    ChangeSchoolYear: _ChangeSchoolYear2.default,
	    UserTasksOverview: _UserTasksOverview2.default,
	    DatePickerRange: _DatePickerRange2.default,
	    UserTasksChart: _UserTasksChart2.default,
	    UserTasksTable: _UserTasksTable2.default,
	    SelectUser: _SelectUser2.default,
	    SubjectForm: _SubjectForm2.default
	  },
	  props: {
	    user_id: {
	      default: 13
	    },
	    user_calendar_id: {
	      default: 7
	    },
	    user_name: {
	      default: ''
	    },
	    isShowHeader: {
	      type: Boolean,
	      default: true
	    },
	    isShowPrintButton: {
	      type: Boolean,
	      default: true
	    },
	    isCanSeeOtherUsers: {
	      type: Boolean,
	      default: true
	    },
	    initialStartDate: {
	      default: null
	    },
	    initialEndDate: {
	      default: null
	    },
	    initialIsShowScheduled: {
	      default: null
	    },
	    isReactive: {
	      type: Boolean,
	      default: false
	    },
	    isPreviewAsEmployee: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      startDate: null,
	      endDate: null,
	      initialLoad: false,
	      debounceTimer: null,
	      isShowScheduled: true,
	      _keyListener: null,
	      subjectsChangedListener: null,
	      isSubjectModal: false,
	      isSubjectLoading: false,
	      editSubject: null,
	      pendingSubjectTab: null,
	      pendingSubjectId: null
	    };
	  },
	
	  computed: {
	    theUser: function theUser() {
	      return this.$store.state.user;
	    },
	    schoolId: function schoolId() {
	      return window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id : this.$route.params.school_id ? this.$route.params.school_id : null;
	    },
	    isKindergarten: function isKindergarten() {
	      return this.$store.getters.isKindergarten;
	    },
	    user: function user() {
	      return {
	        name: this.user_name,
	        id: this.user_id * 1,
	        user_calendar_id: this.user_calendar_id * 1
	      };
	    },
	    isLoadingTasksForUser: function isLoadingTasksForUser() {
	      return this.$store.state.subjects.isLoadingTasksForUser;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isStartOrEndDateChanged: function isStartOrEndDateChanged() {
	      return this.compareDates(this.activeSchoolYear.employee_time_start, this.startDate) && this.compareDates(this.activeSchoolYear.employee_time_end, this.endDate);
	    },
	    dates: function dates() {
	      return this.startDate ? (0, _moment2.default)(this.startDate).format('LL') + ' - ' + (0, _moment2.default)(this.endDate).format('LL') : '';
	    },
	    usersSorted: function usersSorted() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    isPoolsDeactivated: function isPoolsDeactivated() {
	      return this.schoolSettings && this.schoolSettings['deactivatePools'] ? this.schoolSettings['deactivatePools'] : false;
	    },
	    schoolPrepFactor: function schoolPrepFactor() {
	      return (0, _preparationFactor.parseNumericPreparationFactor)(this.schoolSettings && this.schoolSettings.prepFactor);
	    },
	    canEditTasks: function canEditTasks() {
	      return !this.isPreviewAsEmployee && this.userHasPermission('can_manage_school');
	    },
	    schoolYearId: function schoolYearId() {
	      return this.activeSchoolYear ? this.activeSchoolYear.id : this.$store.getters.schoolYearId;
	    }
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear() {
	      if (!this.initialStartDate) {
	        this.setEndDate(this.activeSchoolYear.employee_time_end);
	        this.setStartDate(this.activeSchoolYear.employee_time_start);
	      }
	    },
	    user_id: function user_id(val) {
	      if (this.isReactive) {
	        this.readAllSubjects();
	      }
	    }
	  },
	  methods: {
	    selectNextUser: function selectNextUser() {
	      var _this = this;
	
	      var idx = this.usersSorted.findIndex(function (user) {
	        return user.id * 1 === _this.user_id * 1;
	      });
	      var nextIdx = idx + 1;
	      var nextUserId = this.usersSorted[nextIdx] && this.usersSorted[nextIdx].id ? this.usersSorted[nextIdx].id : null;
	      if (nextUserId) {
	        this.selectUser(nextUserId);
	      }
	    },
	    selectPrevUser: function selectPrevUser() {
	      var _this2 = this;
	
	      var idx = this.usersSorted.findIndex(function (user) {
	        return user.id * 1 === _this2.user_id * 1;
	      });
	      var nextIdx = idx - 1;
	      var prevUserId = this.usersSorted[nextIdx] && this.usersSorted[nextIdx].id ? this.usersSorted[nextIdx].id : null;
	      if (prevUserId) {
	        this.selectUser(prevUserId);
	      }
	    },
	    selectUser: function selectUser(id) {
	      window.location = '/users/' + id + '/hours#';
	    },
	    setIsShowScheduled: function setIsShowScheduled(boolean) {
	      this.isShowScheduled = boolean;
	    },
	    compareDates: function compareDates(firstDate, secondDate) {
	      return (0, _moment2.default)(firstDate).format('YYYY-MM-DD') === (0, _moment2.default)(secondDate).format('YYYY-MM-DD');
	    },
	    resetDates: function resetDates() {
	      this.setDates(this.activeSchoolYear.employee_time_start, this.activeSchoolYear.employee_time_end);
	    },
	    setDatesFromRange: function setDatesFromRange(dateRange) {
	      this.setDates(dateRange.start, dateRange.end);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.startDate = start;
	      }
	      if (end) {
	        this.endDate = end;
	      }
	      this.readAllSubjects();
	    },
	    setStartDate: function setStartDate(date) {
	      this.startDate = date;
	      if ((0, _moment2.default)(date).isValid()) {
	        this.readAllSubjects();
	      }
	    },
	    setEndDate: function setEndDate(date) {
	      this.endDate = date;
	      if ((0, _moment2.default)(date).isValid()) {
	        this.readAllSubjects();
	      }
	    },
	    readUserTasks: function readUserTasks() {
	      var _this3 = this;
	
	      var isSilent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!this.endDate) {
	        return;
	      }
	      var endDate = (0, _moment2.default)(this.endDate).add(1, 'days');
	
	      setTimeout(function (_) {
	        var readObj = {
	          userId: _this3.user_id,
	          fromDate: _this3.startDate,
	          toDate: endDate,
	          isSilent: isSilent
	        };
	        _this3.$store.dispatch('readUserTasks', readObj);
	      }, 0);
	    },
	    readAllSubjects: function readAllSubjects() {
	      var _this4 = this;
	
	      var isSilent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function (_) {
	        _this4.readAssignedHours();
	        _this4.readUserTasks(isSilent);
	      }, 250);
	    },
	    readAssignedHours: function readAssignedHours() {
	      var _this5 = this;
	
	      setTimeout(function (_) {
	        var schoolObj = {
	          schoolId: window.SCHOOL.id,
	          schoolYearId: _this5.activeSchoolYear.id,
	          userId: _this5.user.id,
	          fromDateTime: (0, _moment2.default)(_this5.startDate).format('YYYY-MM-DD') + ' 00:00',
	          toDateTime: (0, _moment2.default)(_this5.endDate).format('YYYY-MM-DD') + ' 23:59'
	        };
	        _this5.$store.dispatch('readUsersAssignedHoursForUser', schoolObj);
	        _this5.$store.dispatch('readUsersActualHoursForUser', schoolObj);
	      }, 0);
	    },
	    print: function print() {
	      window.print();
	    },
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.theUser) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.theUser.admin;
	      } else {
	        return true;
	      }
	    },
	    setEditSubject: function setEditSubject(task) {
	      var _this6 = this;
	
	      if (!task || !task.id) {
	        return;
	      }
	      this.isSubjectLoading = true;
	      this.isSubjectModal = true;
	      this.editSubject = null;
	      _docendo2.default.showSubject(task.id, function (success) {
	        if (success && success.status === 'error') {
	          _this6.closeSubjectModal();
	          _eventbus2.default.toast = { text: success.message || _this6.$t('vue2.common.something_went_wrong'), success: false };
	          return;
	        }
	        var pendingTab = _this6.pendingSubjectTab;
	        _this6.pendingSubjectTab = null;
	        _this6.pendingSubjectId = null;
	        _this6.editSubject = pendingTab ? (0, _assign2.default)({}, success, { _openTab: pendingTab }) : (0, _assign2.default)({}, success);
	        _this6.isSubjectLoading = false;
	      }, function (failure) {
	        _this6.closeSubjectModal();
	        _eventbus2.default.toast = { text: _this6.$t('vue2.common.something_went_wrong'), success: false };
	      });
	    },
	    closeSubjectModal: function closeSubjectModal() {
	      this.editSubject = null;
	      this.isSubjectModal = false;
	      this.isSubjectLoading = false;
	    },
	    updateSubject: function updateSubject(updatedSubject) {
	      if (!updatedSubject.schoolId) {
	        updatedSubject.schoolId = this.schoolId;
	      }
	      if (!updatedSubject.schoolYearId) {
	        updatedSubject.schoolYearId = this.schoolYearId;
	      }
	      this.$store.dispatch('updateSubject', updatedSubject);
	      this.closeSubjectModal();
	    },
	    deleteSubject: function deleteSubject(editSubject) {
	      var deletedSubject = {
	        id: editSubject.id,
	        school_id: editSubject.school_id,
	        school_year_id: this.schoolYearId,
	        schoolYearId: this.schoolYearId
	      };
	      this.$store.dispatch('deleteSubject', deletedSubject);
	      this.closeSubjectModal();
	    },
	    saveAndShowTab: function saveAndShowTab(updatedSubject, tab) {
	      var _this7 = this;
	
	      this.updateSubject(updatedSubject);
	      this.pendingSubjectTab = tab;
	      this.pendingSubjectId = updatedSubject.id;
	      setTimeout(function () {
	        _this7.setEditSubject({ id: _this7.pendingSubjectId });
	      }, 500);
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.initialIsShowScheduled !== null) {
	      this.isShowScheduled = this.initialIsShowScheduled;
	    }
	  },
	  mounted: function mounted() {
	    var _this8 = this;
	
	    this.subjectsChangedListener = function (e) {
	      var isSilent = !!(e && e.detail && e.detail.isUserTaskHoursUpdatedLocally);
	      _this8.readAllSubjects(isSilent);
	    };
	    window.addEventListener('vueCRUDSubject', this.subjectsChangedListener, false);
	    if (this.initialStartDate) {
	      this.setEndDate(this.initialEndDate);
	      this.setStartDate(this.initialStartDate);
	      return;
	    }
	    if (this.activeSchoolYear) {
	      this.setEndDate(this.activeSchoolYear.employee_time_end);
	      this.setStartDate(this.activeSchoolYear.employee_time_start);
	    }
	    if (document.title) {
	      if (this.user_name) {
	        document.title = this.user_name + ' - ' + this.$t('vue2.task_overview.hour_overview');
	      }
	    }
	    this._keyListener = function (e) {
	      var key = e.which || e.keyCode;
	      var metaKey = e.metaKey || e.ctrlKey;
	      if (metaKey && key === 39) {
	        if (e.target.tagName.toUpperCase() === 'BODY') {
	          this.selectNextUser();
	        }
	      }
	      if (metaKey && e.shiftKey && key === 37) {
	        if (e.target.tagName.toUpperCase() === 'BODY') {
	          this.selectPrevUser();
	        }
	      }
	    };
	    document.addEventListener('keydown', this._keyListener.bind(this));
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this._keyListener);
	    if (this.subjectsChangedListener) {
	      window.removeEventListener('vueCRUDSubject', this.subjectsChangedListener, false);
	    }
	  }
	};

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _BarChart = __webpack_require__(428);
	
	var _BarChart2 = _interopRequireDefault(_BarChart);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LineChart: _BarChart2.default,
	    Loader: _Loader2.default
	  },
	  props: {
	    calendarId: {
	      default: 7
	    },
	    startDate: {
	      default: null
	    },
	    endDate: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: true,
	      debounceTimer: null,
	      options: {
	        indexAxis: 'x',
	        responsive: true,
	        maintainAspectRatio: false,
	        scales: {
	          xAxes: [{
	            gridLines: {
	              color: 'rgba(0, 0, 0, 0)'
	            },
	            stacked: true,
	            ticks: {
	              beginAtZero: true
	            }
	          }, {
	            id: 'x2',
	            display: false,
	            stacked: false,
	            offset: true,
	            padding: 2,
	            ticks: {
	              beginAtZero: true
	            },
	            gridLines: {
	              drawOnChartArea: false }
	          }],
	          yAxes: [{
	            ticks: {
	              suggestedMax: 40,
	              beginAtZero: true
	            }
	          }]
	        }
	      },
	      dbHours: [],
	      datacollection: null,
	      dataPresence: [],
	      dataTeaching: [],
	      dataTasks: [],
	      dataPreparation: [],
	      dataAbsence: [],
	      dataClub: [],
	      dataWithKids: [],
	      dataWithoutKids: [],
	      dataPool: [],
	      weeks: [],
	      weekNumbersLabels: []
	    };
	  },
	
	  computed: {
	    localPoolTitle: function localPoolTitle() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || this.$t('vue2.task_overview.pool');
	    },
	    masterTypes: function masterTypes() {
	      var types = [];
	      this.dbHours.forEach(function (hours) {
	        var idx = types.indexOf(hours.master_type);
	        if (idx < 0) {
	          types.push(hours.master_type);
	        }
	      });
	      return types;
	    }
	  },
	  watch: {
	    startDate: function startDate(val) {
	      if ((0, _moment2.default)(val).isValid()) {
	        this.callAPI();
	      }
	    },
	    endDate: function endDate(val) {
	      if ((0, _moment2.default)(val).isValid()) {
	        this.callAPI();
	      }
	    }
	  },
	  methods: {
	    createWeeks: function createWeeks() {
	      var _this = this;
	
	      this.dataPreparation = [];
	      this.dataTeaching = [];
	      this.dataTasks = [];
	      this.dataPresence = [];
	      this.dataAbsence = [];
	      this.weeks = [];
	      this.weekNumbersLabels = [];
	      this.dataClub = [];
	      this.dataWithKids = [];
	      this.dataWithoutKids = [];
	      this.dataPool = [];
	      this.dbHours.forEach(function (hours) {
	        var idx = _this.weeks.indexOf(hours.week);
	        if (idx < 0) {
	          _this.weeks.push(hours.week);
	          var mom = (0, _moment2.default)(hours.week * 1);
	          var weekNumber = mom.isoWeek();
	          _this.weekNumbersLabels.push(weekNumber);
	        }
	      });
	
	      function twoDigits(val) {
	        return parseFloat(Number(val)).toFixed(2);
	      }
	
	      this.dbHours.forEach(function (hours) {
	        var idxForWeek = _this.weeks.indexOf(hours.week);
	        switch (hours.master_type) {
	          case 'preparation':
	            _this.dataPreparation[idxForWeek] = twoDigits(hours.coalesce);
	            break;
	          case 'teaching':
	            _this.dataTeaching[idxForWeek] = twoDigits(hours.coalesce);
	            break;
	          case 'other':
	            _this.dataTasks[idxForWeek] = twoDigits(hours.coalesce);
	            break;
	          case 'presence':
	            _this.dataPresence[idxForWeek] = twoDigits(hours.coalesce);
	            break;
	          case 'absence':
	            _this.dataAbsence[idxForWeek] = twoDigits(hours.coalesce);
	            break;
	          case 'club':
	            _this.dataClub[idxForWeek] = twoDigits(hours.coalesce);
	            break;
	          case 'with_kids':
	            _this.dataWithKids[idxForWeek] = twoDigits(hours.coalesce);
	            break;
	          case 'without_kids':
	            _this.dataWithoutKids[idxForWeek] = twoDigits(hours.coalesce);
	            break;
	          case 'pool':
	            _this.dataPool[idxForWeek] = twoDigits(hours.coalesce);
	        }
	      });
	      this.fillData();
	    },
	    callAPI: function callAPI() {
	      var _this2 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function (_) {
	        _this2.getData();
	      }, 250);
	    },
	    fillData: function fillData() {
	      var dataset = [];
	      var arrOfTypes = [{ arr: this.dataPresence, value: 'presence' }, { arr: this.dataTeaching, value: 'teaching' }, { arr: this.dataTasks, value: 'tasks' }, { arr: this.dataPreparation, value: 'preparation' }, { arr: this.dataClub, value: 'club' }, { arr: this.dataWithKids, value: 'with_kids' }, { arr: this.dataWithoutKids, value: 'without_kids' }, { arr: this.dataPool, value: 'pool' }];
	      var datasetLabels = [{
	        data: this.dataPresence,
	        type: 'bar',
	        label: this.$t('vue2.task_overview.work_hours'),
	        backgroundColor: 'rgba(153, 197, 244, 0.4)',
	        barPercentage: 1,
	        order: 5,
	        xAxisID: 'x2',
	        v_valueType: 'presence'
	      }, {
	        data: this.dataTeaching,
	        type: 'bar',
	        label: this.$t('vue2.task_overview.teaching'),
	        backgroundColor: 'rgba(122, 115, 255, .4)',
	        barPercentage: 0.5,
	        stack: '1',
	        order: 1,
	        v_valueType: 'teaching'
	      }, {
	        data: this.dataTasks,
	        label: this.$t('vue2.task_overview.tasks'),
	        type: 'bar',
	        backgroundColor: 'rgba(255, 217, 106, 1)',
	        barPercentage: 0.5,
	        stack: '1',
	        order: 2,
	        v_valueType: 'tasks'
	      }, {
	        data: this.dataPreparation,
	        type: 'bar',
	        label: this.$t('vue2.task_overview.preparation'),
	        backgroundColor: '#eee',
	        barPercentage: 0.5,
	        stack: '1',
	        order: 3,
	        v_valueType: 'preparation'
	      }, {
	        data: this.dataClub,
	        type: 'bar',
	        label: this.$t('vue2.task_overview.club'),
	        backgroundColor: '#f3b09b',
	        barPercentage: 0.5,
	        stack: '1',
	        order: 4,
	        v_valueType: 'club'
	      }, {
	        data: this.dataWithKids,
	        type: 'bar',
	        label: 'Med børn',
	        backgroundColor: 'rgba(252, 127, 92,.6)',
	        barPercentage: 0.5,
	        stack: '1',
	        order: 4,
	        v_valueType: 'with_kids'
	      }, {
	        data: this.dataWithoutKids,
	        type: 'bar',
	        label: 'Uden børn',
	        backgroundColor: 'rgba(128, 128, 128,.6)',
	        barPercentage: 0.5,
	        stack: '1',
	        order: 4,
	        v_valueType: 'without_kids'
	      }, {
	        data: this.dataPool,
	        type: 'bar',
	        label: this.localPoolTitle,
	        backgroundColor: 'rgba(238, 174, 101,.6)',
	        barPercentage: 0.5,
	        stack: '1',
	        order: 4,
	        v_valueType: 'pool'
	      }, {
	        data: this.dataAbsence,
	        type: 'bar',
	        label: this.$t('vue2.task_overview.absence'),
	        backgroundColor: 'rgba(86,68,55,.6)',
	        barPercentage: 0.5,
	        stack: '1',
	        order: 4,
	        v_valueType: 'absence'
	      }];
	      arrOfTypes.forEach(function (type) {
	        if (type.arr.length > 0) {
	          var idx = datasetLabels.findIndex(function (label) {
	            return label.v_valueType === type.value;
	          });
	          if (idx > -1) {
	            dataset.push(datasetLabels[idx]);
	          }
	        }
	      });
	      this.datacollection = {
	        labels: this.weekNumbersLabels,
	        datasets: dataset
	      };
	      this.isLoading = false;
	    },
	    getData: function getData() {
	      var _this3 = this;
	
	      this.isLoading = true;
	      if (!this.startDate && !this.endDate || !(0, _moment2.default)(this.startDate).isValid() || !(0, _moment2.default)(this.endDate).isValid()) {
	        return;
	      }
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.endDate).add(1, 'days').format('YYYY-MM-DD');
	      _docendo2.default.calendarActualHoursPerWeek(this.calendarId, startDate, endDate, function (success) {
	        _this3.dbHours = success;
	        _this3.createWeeks();
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.callAPI();
	  }
	};

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SubjectsDistributionUserAgreements = __webpack_require__(83);
	
	var _SubjectsDistributionUserAgreements2 = _interopRequireDefault(_SubjectsDistributionUserAgreements);
	
	var _SubjectsDistributionUserEditHours = __webpack_require__(395);
	
	var _SubjectsDistributionUserEditHours2 = _interopRequireDefault(_SubjectsDistributionUserEditHours);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _UserTasksTable = __webpack_require__(148);
	
	var _UserTasksTable2 = _interopRequireDefault(_UserTasksTable);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _UserTasksChart = __webpack_require__(404);
	
	var _UserTasksChart2 = _interopRequireDefault(_UserTasksChart);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _UserTasksOverviewKindergarten = __webpack_require__(1681);
	
	var _UserTasksOverviewKindergarten2 = _interopRequireDefault(_UserTasksOverviewKindergarten);
	
	var _UserTasksTableSubstituteHours = __webpack_require__(1683);
	
	var _UserTasksTableSubstituteHours2 = _interopRequireDefault(_UserTasksTableSubstituteHours);
	
	var _UserTasksOverviewOwnPools = __webpack_require__(405);
	
	var _UserTasksOverviewOwnPools2 = _interopRequireDefault(_UserTasksOverviewOwnPools);
	
	var _UserQuota = __webpack_require__(374);
	
	var _UserQuota2 = _interopRequireDefault(_UserQuota);
	
	var _preparationFactor = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    work_days: 'arbejdsdage',
	    tooltip: {
	      hours: 'timer',
	      days: 'dage',
	      work_days: 'arbejdsdage',
	      per_day: 'pr. dag',
	      calculation: 'Beregning',
	      forYear: 'For året:',
	      forPeriod: 'For perioden:',
	      explanation: '<p><i>Når du vælger et andet datointerval end hele perioden, kan du her se, hvor mange timer, der i gennemsnit skal planlægges i perioden og per dag. Udregningen er baseret på antal arbejdsdage angivet for personalet, fratrukket weekender, feriedage og helligdage i \'Feriekalender\'</p>'
	    }
	  },
	  nb: {
	    work_days: 'arbeidsdager',
	    tooltip: {
	      hours: 'timer',
	      days: 'dager',
	      per_day: 'per dag',
	      work_days: 'arbeidsdager',
	      calculation: 'Beregning',
	      forYear: 'For året:',
	      forPeriod: 'For perioden:',
	      explanation: '<p><i>Når du velger et annet datointerval enn hele året, kan du her se, hvor mange timer som skal planlegges i perioden og i gjennomsnitt per dag. Beregningen trekker helger og ferie- og helligdager fra.</i></p>'
	    }
	  },
	  en: {
	    work_days: 'work days',
	    tooltip: {
	      hours: 'hours',
	      days: 'days',
	      per_day: 'per day',
	      work_days: 'work days',
	      calculation: 'Calculation',
	      forYear: 'For the year:',
	      forPeriod: 'For the period:',
	      explanation: '<p><i>When you choose a different date range than the whole year, you can see here how many hours need to be planned in the period and on average per day. The calculation subtracts weekends and holidays.</i></p>'
	    }
	  }
	};
	
	exports.default = {
	  components: {
	    UserQuota: _UserQuota2.default,
	    UserTasksOverviewOwnPools: _UserTasksOverviewOwnPools2.default,
	    UserTasksTableSubstituteHours: _UserTasksTableSubstituteHours2.default,
	    UserTasksOverviewKindergarten: _UserTasksOverviewKindergarten2.default,
	    AppToggle: _AppToggle2.default,
	    SubjectsDistributionUserAgreements: _SubjectsDistributionUserAgreements2.default,
	    DDropdown: _DDropdown2.default,
	    DModal: _DModal2.default,
	    SubjectsDistributionUserEditHours: _SubjectsDistributionUserEditHours2.default,
	    UserTasksTable: _UserTasksTable2.default,
	    UserTasksChart: _UserTasksChart2.default
	  },
	  props: {
	    user: {
	      default: function _default() {
	        return {
	          name: 'Henrik Rasch',
	          id: 13,
	          user_calendar_id: 7
	        };
	      }
	    },
	    isKindergarten: {
	      type: Boolean,
	      default: false
	    },
	    activeUserId: {
	      default: null
	    },
	    showCloseCross: {
	      default: true
	    },
	    isInUserCalendar: {
	      default: false
	    },
	    dates: {},
	    startDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    endDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    isShowHeader: {
	      type: Boolean,
	      default: true
	    },
	    isPoolsDeactivated: {
	      type: Boolean,
	      default: false
	    },
	    schoolPrepFactor: {
	      default: null
	    },
	    isPreviewAsEmployee: {
	      type: Boolean,
	      default: false
	    },
	    canEditTasks: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isPrint: false,
	      theActiveSubject: null,
	      assignTeacherTask: null,
	      onTeacherAssigned: null,
	      isAssigningTeacher: false,
	      isShowScheduled: true,
	      userNorm: [],
	      userAgreements: '',
	      allVacationsDays: [],
	      userIdsWithoutCalc: [171563]
	    };
	  },
	
	  computed: {
	    isAssignedPoolFromNormWhenPoolsDeactivated: function isAssignedPoolFromNormWhenPoolsDeactivated() {
	      return this.$store.getters.isAssignedPoolFromNormWhenPoolsDeactivated;
	    },
	    theUser: function theUser() {
	      return this.$store.state.user;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    schoolThresholdToHideTaskHours: function schoolThresholdToHideTaskHours() {
	      return this.schoolSettings && this.schoolSettings['thresholdToHideTaskHours'] ? this.schoolSettings['thresholdToHideTaskHours'] : null;
	    },
	    localPoolTitle: function localPoolTitle() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || this.$t('vue2.task_overview.pool');
	    },
	    hiddenTaskDistributionCategories: function hiddenTaskDistributionCategories() {
	      return this.$store.getters.hiddenTaskDistributionCategories;
	    },
	    schoolSettingShownOwnPools: function schoolSettingShownOwnPools() {
	      return this.$store.getters.shownOwnPools;
	    },
	    isKmdUserQuotaActive: function isKmdUserQuotaActive() {
	      return this.$store.getters.isKmdUserQuotaActive;
	    },
	    canSeeKmdUserQuota: function canSeeKmdUserQuota() {
	      var currentUser = this.theUser;
	      var currentUserId = currentUser && currentUser.id ? currentUser.id * 1 : null;
	      var isAdmin = currentUser && currentUser.admin === true;
	      var viewedUserId = this.user && this.user.id ? this.user.id * 1 : null;
	      var isSelf = currentUserId !== null && viewedUserId !== null && currentUserId === viewedUserId;
	      var isAdministrator = this.userHasPermission('can_manage_school');
	      return isAdmin || isAdministrator || isSelf;
	    },
	    titleForTeachingAndSubstituteHoursTotal: function titleForTeachingAndSubstituteHoursTotal() {
	      var idx = this.userTasksFiltered.findIndex(function (userTasks) {
	        return userTasks.title === 'substitute_hours';
	      });
	      if (idx < 0) {
	        return 'Undervisning + Vikartimer (UV-timer)';
	      }
	      var hasClubTasks = this.userTasksSortedInTypes[idx]['tasks'].some(function (task) {
	        return task.master_type === 'club';
	      });
	      if (hasClubTasks) {
	        return 'Undervisning + Vikartimer (UV-timer & SFO)';
	      } else {
	        return 'Undervisning + Vikartimer (UV-timer)';
	      }
	    },
	    userNormFormatted: function userNormFormatted() {
	      var normsFiltered = this.userNorm.filter(function (item) {
	        return item.title.indexOf('hidden_') < 0;
	      });
	      return normsFiltered.map(function (item) {
	        return (0, _extends3.default)({}, item, {
	          value: item.value
	        });
	      });
	    },
	    tooltipContent: function tooltipContent() {
	      return '<p><i>N\xE5r du v\xE6lger et andet datointerval end hele \xE5ret, kan du her se, hvor mange timer, der skal planl\xE6gges for medarbejderen i perioden og i gennemsnit per dag. Udregningen tager h\xF8jde for institutionens ferie- og helligdage.</i></p><br></p><p><b>Beregning</b></p><p>For \xE5ret: ' + this.getUserHoursOverview.assigned_total_hours + ' timer / ' + this.workDayDates.length + ' dage = ' + this.averageWorkingHoursPerDay + ' timer pr. dag</p><p>For perioden: ' + this.numberOfWorkDaysInPeriod + ' arbejdsdage * ' + this.averageWorkingHoursPerDay + ' timer pr. dag = ' + this.assignedTotalHoursForPeriod + ' timer</p>';
	    },
	    schoolTooltipContent: function schoolTooltipContent() {
	      var sumForYear = this.getUserHoursOverview.assigned_total_hours;
	      var hoursInYear = this.numberOfWorkDays;
	      var hoursPerDay = sumForYear / hoursInYear;
	      var hoursForPeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      var hoursPerDayFixed = this.toFixedIfNecessary(hoursPerDay);
	      var hoursForPeriodFixed = this.toFixedIfNecessary(hoursForPeriod);
	      return this.i18n.tooltip.explanation + '<br></p><p><b>' + this.i18n.tooltip.calculation + '</b></p><p>' + this.i18n.tooltip.forYear + ' ' + sumForYear + ' ' + this.i18n.tooltip.hours + ' / ' + hoursInYear + ' ' + this.i18n.tooltip.days + ' = ' + hoursPerDayFixed + ' ' + this.i18n.tooltip.hours + ' ' + this.i18n.tooltip.per_day + '</p><p>' + this.i18n.tooltip.forPeriod + ' ' + this.numberOfWorkDaysInPeriod + ' ' + this.i18n.tooltip.work_days + ' * ' + hoursPerDayFixed + ' ' + this.i18n.tooltip.hours + ' ' + this.i18n.tooltip.per_day + ' = ' + hoursForPeriodFixed + ' ' + this.i18n.tooltip.hours + '</p>';
	    },
	    urlLocale: function urlLocale() {
	      var url = window.location.host;
	      var locale = 'en';
	      if (url.indexOf('.dk') > -1) {
	        locale = 'da';
	      }
	      if (url.indexOf('.no') > -1) {
	        locale = 'nb';
	      }
	      return locale;
	    },
	    locale: function locale() {
	      return window.USER && window.USER.language ? window.USER.language : this.urlLocale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    isDateIntervalChanged: function isDateIntervalChanged() {
	      var userId = this.user.id * 1;
	      if (this.userIdsWithoutCalc.indexOf(userId) > -1) {
	        return false;
	      }
	      var originalStart = (0, _moment2.default)(this.activeSchoolYear.employee_time_start).format('YYYY-MM-DD');
	      var originalEnd = (0, _moment2.default)(this.activeSchoolYear.employee_time_end).format('YYYY-MM-DD');
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      return startDate !== originalStart || endDate !== originalEnd;
	    },
	    canTransferScheduled: function canTransferScheduled() {
	      return this.canEditTasks && this.userHasPermission('can_do_most_stuff');
	    },
	    isFullPeriodSelected: function isFullPeriodSelected() {
	      if (!this.activeSchoolYear) {
	        return false;
	      }
	      var format = function format(date) {
	        return (0, _moment2.default)(date).format('YYYY-MM-DD');
	      };
	      return format(this.startDate) === format(this.activeSchoolYear.employee_time_start) && format(this.endDate) === format(this.activeSchoolYear.employee_time_end);
	    },
	    schoolId: function schoolId() {
	      if (window.SCHOOL && window.SCHOOL.id) {
	        return window.SCHOOL.id;
	      }
	      if (this.$route && this.$route.params && this.$route.params.school_id) {
	        return this.$route.params.school_id;
	      }
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    workDayDates: function workDayDates() {
	      var self = this;
	
	      function isNotWeekend(m) {
	        return (0, _moment2.default)(m).isoWeekday() !== 6 && (0, _moment2.default)(m).isoWeekday() !== 7;
	      }
	
	      function isNotVacationDay(m) {
	        var idx = self.allVacationsDays.findIndex(function (date) {
	          return (0, _moment2.default)(date.day).format('YYYY-MM-DD') === m;
	        });
	        return idx < 0;
	      }
	
	      var startDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_start).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_end).format('YYYY-MM-DD');
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        if (isNotWeekend(m) && isNotVacationDay(m)) {
	          dateArray.push(m);
	        }
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray;
	    },
	    workDayDatesInPeriod: function workDayDatesInPeriod() {
	      var _this = this;
	
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        dateArray.push(m);
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray.filter(function (date) {
	        var m = (0, _moment2.default)(date).format('YYYY-MM-DD');
	        var idx = _this.workDayDates.indexOf(m);
	        return idx > -1;
	      });
	    },
	    numberOfWorkDays: function numberOfWorkDays() {
	      return this.workDayDates.length;
	    },
	    numberOfWorkDaysInPeriod: function numberOfWorkDaysInPeriod() {
	      return this.workDayDatesInPeriod.length;
	    },
	    averageWorkingHoursPerDay: function averageWorkingHoursPerDay() {
	      var hoursPerDay = this.getUserHoursOverview.assigned_total_hours / this.numberOfWorkDays * 1;
	      return this.toFixedIfNecessary(hoursPerDay);
	    },
	    assignedTotalHoursForPeriod: function assignedTotalHoursForPeriod() {
	      var userId = this.user.id * 1;
	      if (this.userIdsWithoutCalc.includes(userId)) {
	        return this.getUserHoursOverview.assigned_total_hours;
	      }
	      var hoursPerDay = this.getUserHoursOverview.assigned_total_hours / this.numberOfWorkDays * 1;
	      var hoursInThePeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      return this.toFixedIfNecessary(hoursInThePeriod);
	    },
	    diffTotalHoursForPeriod: function diffTotalHoursForPeriod() {
	      var diff = this.assignedTotalHoursForPeriod - this.getUserHoursOverview.actual_total_hours;
	      return this.toFixedIfNecessary(diff);
	    },
	    schoolCountry: function schoolCountry() {
	      return this.$store.getters.schoolCountry;
	    },
	    isShowSubsAndTeachingActive: function isShowSubsAndTeachingActive() {
	      var schoolIds = [7272, 1256, 2987, 2991, 2986, 2989, 2990, 2985, 2992, 4910, 4911, 4912, 1976, 6527, 61476, 60668, 1795, 60800, 62650];
	      return schoolIds.indexOf(this.schoolId) > -1;
	    },
	    isSchoolGlHjortespring: function isSchoolGlHjortespring() {
	      return this.schoolId === 25609;
	    },
	    userTasksSortedInTypes: function userTasksSortedInTypes() {
	      return this.$store.getters.userTasksSortedInTypes;
	    },
	    userTasksFiltered: function userTasksFiltered() {
	      if (this.isShowScheduled) {
	        return this.userTasksSortedInTypes;
	      } else {
	        return this.userTasksSortedInTypes.filter(function (type) {
	          return type.title !== 'absence' && type.title !== 'substitute_hours';
	        });
	      }
	    },
	    getTheActiveSubject: function getTheActiveSubject() {
	      return this.theActiveSubject ? this.subjectsInHash[this.theActiveSubject] : null;
	    },
	    getTheActiveUser: function getTheActiveUser() {
	      return this.activeUserId ? this.allUsersInHash[this.activeUserId] : null;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    subjectsInUserHash: function subjectsInUserHash() {
	      return this.$store.getters.subjectsInUserHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    usersAssignedHoursHash: function usersAssignedHoursHash() {
	      return this.$store.getters.usersAssignedHoursHash;
	    },
	    preparationHoursInUserHash: function preparationHoursInUserHash() {
	      return this.$store.getters.preparationHoursInUserHash;
	    },
	    localPoolHoursInUserHash: function localPoolHoursInUserHash() {
	      return this.$store.getters.localPoolHoursInUserHash;
	    },
	    clubHoursInUserHash: function clubHoursInUserHash() {
	      return this.$store.getters.clubHoursInUserHash;
	    },
	    theUserAssignedHours: function theUserAssignedHours() {
	      var obj = this.usersAssignedHoursHash[this.user.id] ? (0, _extends3.default)({}, this.usersAssignedHoursHash[this.user.id]) : {};
	      if (this.isPoolsDeactivated) {
	        var calId = this.user.user_calendar_id;
	        var assignedTeachingHours = this.getSumOfHoursForMasterType('teaching', calId);
	        obj.assigned_teaching_hours = assignedTeachingHours || 0;
	        obj.assigned_additional_task_hours = this.getSumOfHoursForMasterType('additional_tasks');
	        obj.assigned_preparation_hours = this.getPreparationForUser(assignedTeachingHours) + this.getSubstitutePoolPreparationHours(obj);
	        if (!this.isAssignedPoolFromNormWhenPoolsDeactivated) {
	          obj.assigned_pool_hours = this.getSumOfHoursForMasterType('pool') || 0;
	        }
	        obj.assigned_club_hours = this.getSumOfHoursForMasterType('club') || 0;
	      }
	      return obj;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    tasksInUserHash: function tasksInUserHash() {
	      return this.$store.getters.tasksInUserHash;
	    },
	    tasksInHash: function tasksInHash() {
	      return this.$store.getters.tasksInHash;
	    },
	    allUserTasks: function allUserTasks() {
	      var _this2 = this;
	
	      return this.tasksInUserHash[this.user.user_calendar_id] ? this.tasksInUserHash[this.user.user_calendar_id].map(function (taskId) {
	        return _this2.tasksInHash[taskId];
	      }) : [];
	    },
	    getAllUserTasksTask: function getAllUserTasksTask() {
	      return this.allUserTasks.filter(function (task) {
	        return task.subject_type === 'additional_tasks';
	      });
	    },
	    userActualHours: function userActualHours() {
	      var src = this.$store.state.subjects && this.$store.state.subjects.userActualHours ? this.$store.state.subjects.userActualHours : {};
	
	      var n = function n(v) {
	        var x = v === null || v === undefined || v === '' ? 0 : v;
	        var num = typeof x === 'number' ? x : parseFloat(x);
	        return isNaN(num) ? 0 : num;
	      };
	
	      var useCategorySum = typeof this.getIsUserInGroupForSumWorkHours === 'function' ? this.getIsUserInGroupForSumWorkHours() : false;
	
	      var summed = n(src.actual_substitute_hours) + n(src.actual_teaching_hours) + n(src.actual_additional_task_hours) + n(src.actual_preparation_hours) + n(src.actual_club_hours) + n(src.actual_pool_hours);
	
	      var actualTotalHours = useCategorySum ? summed : n(src.actual_total_hours);
	
	      return (0, _extends3.default)({}, src, {
	        actual_total_hours: actualTotalHours
	      });
	    },
	    userTagsWithoutPrepFactor: function userTagsWithoutPrepFactor() {
	      return this.$store.getters.userTagsWithoutPrepFactor;
	    },
	    userTagsForSumWorkHours: function userTagsForSumWorkHours() {
	      return this.$store.getters.userTagsForSumWorkHours;
	    },
	    isPrepFactorForSubstitutePools: function isPrepFactorForSubstitutePools() {
	      return !!(this.$store.state.schoolSettings && this.$store.state.schoolSettings.prepFactorForSubstitutePools);
	    },
	    getUserHoursOverview: function getUserHoursOverview() {
	      var obj = this.user;
	      var usersWithAssignedHours = this.theUserAssignedHours;
	      var usersWithScheduledHours = this.userActualHours;
	      var user = {
	        id: obj.id,
	        name: obj.name,
	        assigned_total_hours: usersWithAssignedHours && this.toFixedIfNecessary(usersWithAssignedHours.assigned_total_hours) || 0,
	        actual_total_hours: usersWithScheduledHours && this.toFixedIfNecessary(usersWithScheduledHours.actual_total_hours) || 0,
	        diff_total_hours: this.toFixedIfNecessary(parseFloat(usersWithAssignedHours && usersWithAssignedHours.assigned_total_hours || 0) - parseFloat(usersWithScheduledHours && usersWithScheduledHours.actual_total_hours || 0)),
	        assigned_teaching_hours: usersWithAssignedHours && this.toFixedIfNecessary(usersWithAssignedHours.assigned_teaching_hours) || 0,
	        actual_teaching_hours: usersWithScheduledHours && this.toFixedIfNecessary(usersWithScheduledHours.actual_teaching_hours) || 0,
	        diff_teaching_hours: this.toFixedIfNecessary(parseFloat(usersWithAssignedHours && usersWithAssignedHours.assigned_teaching_hours || 0) - parseFloat(usersWithScheduledHours && usersWithScheduledHours.actual_teaching_hours || 0)),
	        substitute_pool_hours: usersWithAssignedHours && this.toFixedIfNecessary(usersWithAssignedHours.substitute_pool_hours) || 0,
	        actual_substitute_hours: usersWithScheduledHours && this.toFixedIfNecessary(usersWithScheduledHours.actual_substitute_hours) || 0,
	        diff_substitute_hours: this.toFixedIfNecessary(parseFloat(usersWithAssignedHours && usersWithAssignedHours.substitute_pool_hours || 0) - parseFloat(usersWithScheduledHours && usersWithScheduledHours.actual_substitute_hours || 0)),
	        actual_absence_hours: usersWithScheduledHours && this.toFixedIfNecessary(usersWithScheduledHours.actual_absence_hours) || 0,
	        assigned_additional_task_hours: usersWithAssignedHours && this.toFixedIfNecessary(usersWithAssignedHours.assigned_additional_task_hours) || 0,
	        actual_additional_task_hours: usersWithScheduledHours && this.toFixedIfNecessary(usersWithScheduledHours.actual_additional_task_hours) || 0,
	        diff_additional_task_hours: this.toFixedIfNecessary(parseFloat(usersWithAssignedHours && usersWithAssignedHours.assigned_additional_task_hours || 0) - parseFloat(usersWithScheduledHours && usersWithScheduledHours.actual_additional_task_hours || 0)),
	        assigned_preparation_hours: usersWithAssignedHours && this.toFixedIfNecessary(usersWithAssignedHours.assigned_preparation_hours) || 0,
	        actual_preparation_hours: usersWithScheduledHours && this.toFixedIfNecessary(usersWithScheduledHours.actual_preparation_hours) || 0,
	        diff_preparation_hours: this.toFixedIfNecessary(parseFloat(usersWithAssignedHours && usersWithAssignedHours.assigned_preparation_hours || 0) - parseFloat(usersWithScheduledHours && usersWithScheduledHours.actual_preparation_hours || 0)),
	        assigned_pool_hours: usersWithAssignedHours && this.toFixedIfNecessary(usersWithAssignedHours.assigned_pool_hours) || 0,
	        actual_pool_hours: usersWithScheduledHours && this.toFixedIfNecessary(usersWithScheduledHours.actual_pool_hours) || 0,
	        diff_pool_hours: this.toFixedIfNecessary(parseFloat(usersWithAssignedHours && usersWithAssignedHours.assigned_pool_hours || 0) - parseFloat(usersWithScheduledHours && usersWithScheduledHours.actual_pool_hours || 0)),
	        assigned_club_hours: usersWithAssignedHours && this.toFixedIfNecessary(usersWithAssignedHours.assigned_club_hours) || 0,
	        actual_club_hours: usersWithScheduledHours && this.toFixedIfNecessary(usersWithScheduledHours.actual_club_hours) || 0,
	        diff_club_hours: this.toFixedIfNecessary(parseFloat(usersWithAssignedHours && usersWithAssignedHours.assigned_club_hours || 0) - parseFloat(usersWithScheduledHours && usersWithScheduledHours.actual_club_hours || 0))
	      };
	      return user;
	    },
	    getUserAssignedTotalHours: function getUserAssignedTotalHours() {
	      return this.theUserAssignedHours.assigned_total_hours || 0;
	    },
	    getUserAssignedTeachingHours: function getUserAssignedTeachingHours() {
	      return this.theUserAssignedHours.assigned_teaching_hours || 0;
	    },
	    getPercentageOfTeaching: function getPercentageOfTeaching() {
	      var total = this.getUserAssignedTotalHours;
	      var teaching = this.getUserAssignedTeachingHours;
	      var percentage = teaching / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    getUserAssignedTaskHours: function getUserAssignedTaskHours() {
	      return this.theUserAssignedHours.assigned_additional_task_hours || 0;
	    },
	    getPercentageOfTasks: function getPercentageOfTasks() {
	      var total = this.getUserAssignedTotalHours;
	      var tasks = this.getUserAssignedTaskHours;
	      var percentage = tasks / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    getUserAssignedPreparationHours: function getUserAssignedPreparationHours() {
	      return this.theUserAssignedHours.assigned_preparation_hours || 0;
	    },
	    getUserAssignedClubHours: function getUserAssignedClubHours() {
	      return this.theUserAssignedHours.assigned_club_hours || 0;
	    },
	    getPercentageOfPrep: function getPercentageOfPrep() {
	      var total = this.getUserAssignedTotalHours;
	      var tasks = this.getUserAssignedPreparationHours;
	      var percentage = tasks / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    getUserAssignedPoolHours: function getUserAssignedPoolHours() {
	      return this.theUserAssignedHours.assigned_pool_hours || 0;
	    },
	    getPercentageOfPool: function getPercentageOfPool() {
	      var total = this.getUserAssignedTotalHours;
	      var tasks = this.getUserAssignedPoolHours;
	      var percentage = tasks / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    getPercentageOfClub: function getPercentageOfClub() {
	      var total = this.getUserAssignedTotalHours;
	      var tasks = this.getUserAssignedClubHours;
	      var percentage = tasks / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    getPercentageOfSubPool: function getPercentageOfSubPool() {
	      var total = this.getUserAssignedTotalHours;
	      var tasks = this.getUserHoursOverview.substitute_pool_hours;
	      var percentage = tasks / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    getTotalAssigned: function getTotalAssigned() {
	      var total = this.getUserHoursOverview.assigned_total_hours;
	      var sumOfAllAssigned = this.getUserHoursOverview.assigned_teaching_hours + this.getUserHoursOverview.assigned_additional_task_hours + this.getUserHoursOverview.assigned_preparation_hours + this.getUserHoursOverview.substitute_pool_hours + this.getUserHoursOverview.assigned_club_hours + this.getUserHoursOverview.assigned_pool_hours;
	      return total - sumOfAllAssigned;
	    },
	    getPercentageOfRest: function getPercentageOfRest() {
	      var total = this.getUserHoursOverview.assigned_total_hours;
	      var percentage = this.getTotalAssigned / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    getDistributionDifference: function getDistributionDifference() {
	      return this.toFixedIfNecessary(this.getTotalAssigned);
	    },
	    getPercentageOfDifference: function getPercentageOfDifference() {
	      var total = this.getUserHoursOverview.assigned_total_hours;
	      if (!total) {
	        return '0%';
	      }
	      var percentage = this.getDistributionDifference / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    getTotalTooMany: function getTotalTooMany() {
	      var total = this.getUserHoursOverview.assigned_total_hours;
	      var sumOfAllAssigned = this.getUserHoursOverview.assigned_teaching_hours + this.getUserHoursOverview.assigned_additional_task_hours + this.getUserHoursOverview.assigned_preparation_hours + this.getUserHoursOverview.substitute_pool_hours + this.getUserHoursOverview.assigned_club_hours + this.getUserHoursOverview.assigned_pool_hours;
	      return sumOfAllAssigned - total;
	    },
	    getPercentageOfTooMany: function getPercentageOfTooMany() {
	      var total = this.getUserHoursOverview.assigned_total_hours;
	      var percentage = this.getTotalTooMany / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    tasksHoursInUserHash: function tasksHoursInUserHash() {
	      return this.$store.getters.tasksHoursInUserHash;
	    },
	    userTasks: function userTasks() {
	      return this.$store.state.subjects.userTasks;
	    }
	  },
	  watch: {
	    userSettings: function userSettings() {
	      if (!this.isShowHeader) {
	        return;
	      }
	      if (this.userSettings && this.userSettings.hasOwnProperty('userTasksIsShowScheduled')) {
	        this.isShowScheduled = this.userSettings.userTasksIsShowScheduled;
	      }
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      this.readUserAgreements();
	    }
	  },
	  methods: {
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.theUser) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.theUser.admin;
	      } else {
	        return true;
	      }
	    },
	    getSumOfHoursForMasterType: function getSumOfHoursForMasterType(subjectType) {
	      var isTeaching = subjectType === 'teaching';
	      var tasksFiltered = this.userTasks.filter(function (task) {
	        return isTeaching ? task.master_type === 'teaching' : task.subject_type === subjectType;
	      });
	      var tasksHours = tasksFiltered.map(function (task) {
	        return task.hours ? parseFloat(task.hours) : 0;
	      });
	      var sum = tasksHours.reduce(function (acc, item) {
	        return acc + item;
	      }, 0);
	      return this.toFixedIfNecessary(sum, 2);
	    },
	    getIsCategoryVisible: function getIsCategoryVisible(category) {
	      return this.hiddenTaskDistributionCategories && this.hiddenTaskDistributionCategories.indexOf(category) < 0;
	    },
	    getSchoolDays: function getSchoolDays() {
	      var _this3 = this;
	
	      _docendo2.default.schoolVacationDaysRead(this.schoolId, function (success) {
	        if (success.status !== 'error') {
	          _this3.allVacationsDays = success;
	        }
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    toFixedIfNecessary: function toFixedIfNecessary(value) {
	      return +parseFloat(value).toFixed(2);
	    },
	    setIsShowScheduled: function setIsShowScheduled(boolean) {
	      this.isShowScheduled = boolean;
	      this.$emit('changedIsShowScheduled', boolean);
	      var obj = {
	        userTasksIsShowScheduled: boolean
	      };
	      this.$store.dispatch('updateUserSettings', obj);
	    },
	    scaleIndicator: function scaleIndicator(diff) {
	      var color = 'rgba(62, 207, 142, 0.4)';
	      var newDiff = parseFloat(diff);
	      var indicatorPercentage = parseFloat(newDiff.toFixed(0));
	      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
	        indicatorPercentage = '0' + indicatorPercentage;
	      }
	      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
	        indicatorPercentage = '0' + indicatorPercentage * -1;
	      }
	      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
	        indicatorPercentage = indicatorPercentage * -1;
	      }
	      if (newDiff === 0) {
	        color = 'transparent';
	      }
	      if (newDiff < 0) {
	        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff < -99) {
	        color = 'rgba(250, 86, 90, 1)';
	      }
	      if (newDiff > 0) {
	        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff > 99) {
	        color = 'rgba(62, 207, 142, 1)';
	      }
	      return { 'backgroundColor': color };
	    },
	    getAllUserTasks: function getAllUserTasks(calid) {
	      return this.tasksInUserHash[calid];
	    },
	    setEditSubject: function setEditSubject(editSubject) {
	      this.$emit('editSubject', editSubject);
	    },
	    transferScheduledToAssigned: function transferScheduledToAssigned(task) {
	      var _this4 = this;
	
	      var userCalendarId = this.user.user_calendar_id * 1;
	      var fromHours = this.toFixedIfNecessary(task.hours || 0);
	      var toHours = this.toFixedIfNecessary(task.actual || 0);
	      var onFailure = function onFailure(data) {
	        return _this4.toastSubjectFailure(data);
	      };
	      var onSuccess = function onSuccess(data) {
	        if (data && data.status === 'error') {
	          onFailure(data);
	          return;
	        }
	        _eventbus2.default.toast = {
	          text: _this4.$t('vue2.task_overview.transfer_scheduled_success', { name: task.name, from: fromHours, to: toHours }),
	          success: true
	        };
	        _this4.$store.commit('updateUserTaskHours', { id: task.id, hours: toHours });
	        window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: { id: task.id, isUserTaskHoursUpdatedLocally: true } }));
	      };
	
	      _docendo2.default.showSubject(task.id, function (subject) {
	        if (!subject || subject.status === 'error') {
	          onFailure(subject);
	          return;
	        }
	        var hasHours = function hasHours(sc) {
	          return sc.hours !== null && sc.hours !== undefined;
	        };
	        var subjectCalendars = subject.subject_calendars || [];
	        var userSubjectCalendar = subjectCalendars.find(function (sc) {
	          return sc.calendar_id * 1 === userCalendarId;
	        });
	        var setUserHours = function setUserHours(_) {
	          _docendo2.default.setHoursForTeacherOnSubject(subject.id, subject.school_id, subject.school_year_id, userCalendarId, toHours, onSuccess, onFailure);
	        };
	        if (subject.calendar_id * 1 !== userCalendarId) {
	          if (userSubjectCalendar) {
	            setUserHours();
	          } else {
	            onFailure();
	          }
	          return;
	        }
	
	        var otherCalendarsWithHours = subjectCalendars.filter(function (sc) {
	          return sc.calendar_id * 1 !== userCalendarId && hasHours(sc);
	        });
	        var blockingCalendars = otherCalendarsWithHours.filter(function (sc) {
	          return !userSubjectCalendar || sc.hours * 1 > toHours;
	        });
	        if (blockingCalendars.length > 0) {
	          var cals = subject.cals || [];
	          var calendarNames = blockingCalendars.map(function (sc) {
	            var cal = cals.find(function (c) {
	              return c.id * 1 === sc.calendar_id * 1;
	            });
	            return cal ? cal.name : sc.calendar_id;
	          });
	          _eventbus2.default.toast = {
	            text: _this4.$t('vue2.task_overview.transfer_scheduled_other_calendar_hours', { name: task.name, calendars: calendarNames.join(', ') }),
	            success: false
	          };
	          return;
	        }
	        if (otherCalendarsWithHours.length > 0 || userSubjectCalendar && hasHours(userSubjectCalendar)) {
	          setUserHours();
	        } else {
	          _docendo2.default.bulkUpdateSubjects(subject.school_id, [subject.id], { hours: toHours }, onSuccess, onFailure);
	        }
	      }, onFailure);
	    },
	    toastSubjectFailure: function toastSubjectFailure(data) {
	      var message = data && data.message ? String(data.message) : '';
	      var key = message.indexOf('permission required') === 0 ? 'vue2.task_overview.transfer_scheduled_no_permission' : 'vue2.common.something_went_wrong';
	      _eventbus2.default.toast = { text: this.$t(key), success: false };
	    },
	    openAssignTeacherDialog: function openAssignTeacherDialog(task, onAssigned) {
	      this.assignTeacherTask = task;
	      this.onTeacherAssigned = onAssigned;
	    },
	    closeAssignTeacherDialog: function closeAssignTeacherDialog() {
	      this.assignTeacherTask = null;
	      this.onTeacherAssigned = null;
	      this.isAssigningTeacher = false;
	    },
	    assignTeacherToTask: function assignTeacherToTask() {
	      var _this5 = this;
	
	      if (this.isAssigningTeacher) {
	        return;
	      }
	      var task = this.assignTeacherTask;
	      var onAssigned = this.onTeacherAssigned;
	      var userCalendarId = this.user.user_calendar_id * 1;
	      this.isAssigningTeacher = true;
	      var onFailure = function onFailure(data) {
	        _this5.isAssigningTeacher = false;
	        _this5.toastSubjectFailure(data);
	      };
	      var isError = function isError(data) {
	        return !data || data.status === 'error';
	      };
	      var onAdded = function onAdded(data) {
	        if (data && data.status === 'error') {
	          onFailure(data);
	          return;
	        }
	        _docendo2.default.showSubject(task.id, function (subject) {
	          if (isError(subject)) {
	            onFailure(subject);
	            return;
	          }
	          var userSubjectCalendar = (subject.subject_calendars || []).find(function (sc) {
	            return sc.calendar_id * 1 === userCalendarId;
	          });
	          if (!userSubjectCalendar) {
	            onFailure();
	            return;
	          }
	          _this5.$store.commit('setUserTaskSubjectCalendarId', { id: task.id, subjectCalendarId: userSubjectCalendar.id });
	          _eventbus2.default.toast = {
	            text: _this5.$t('vue2.task_overview.assign_teacher_to_subject_success', { teacher: _this5.user.name, name: task.name }),
	            success: true
	          };
	          window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: { id: task.id, isUserTaskHoursUpdatedLocally: true } }));
	          _this5.closeAssignTeacherDialog();
	          if (onAssigned) {
	            onAssigned();
	          }
	        }, onFailure);
	      };
	
	      _docendo2.default.showSubject(task.id, function (subject) {
	        if (isError(subject)) {
	          onFailure(subject);
	          return;
	        }
	        _docendo2.default.bulkUpdateSubjects(subject.school_id, [subject.id], { add_calendar_id: userCalendarId }, onAdded, onFailure);
	      }, onFailure);
	    },
	    setDeleteTask: function setDeleteTask(taskId) {
	      var task = this.tasksInHash[taskId];
	      task['itemType'] = 'task';
	      this.$store.commit('setItemToDelete', task);
	      this.$store.commit('setConfirmDeletion', true);
	    },
	    getTotalSubjectTeachingHours: function getTotalSubjectTeachingHours(userCalId) {
	      var _this6 = this;
	
	      var subjectsHours = this.subjectsInUserHash[userCalId] ? this.subjectsInUserHash[userCalId].map(function (subjectId) {
	        return _this6.getSubjectHours(subjectId) * 1;
	      }) : [0];
	      var sum = subjectsHours.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return sum.toFixed(2);
	    },
	    getTotalUserTasksTeachingHours: function getTotalUserTasksTeachingHours(userCalId) {
	      var _this7 = this;
	
	      var tasksHours = this.tasksInUserHash[userCalId] ? this.tasksInUserHash[userCalId].map(function (taskId) {
	        return _this7.tasksInHash[taskId].hours_teaching * 1;
	      }) : [0];
	      return tasksHours.reduce(function (acc, item) {
	        return acc + item;
	      }).toFixed(2);
	    },
	    setActiveSubject: function setActiveSubject(subject) {
	      this.theActiveSubject = subject;
	    },
	    getSubjectHours: function getSubjectHours(subjectId) {
	      var _this8 = this;
	
	      var theSubject = this.subjectsInHash[subjectId];
	      var idx = theSubject.teachers[0] ? theSubject.teachers.findIndex(function (teacher) {
	        return teacher.user_id === _this8.activeUserId;
	      }) : -1;
	      if (idx > -1) {
	        return theSubject.teachers[idx].hours;
	      } else {
	        return theSubject.hours;
	      }
	    },
	    getIsHoursModified: function getIsHoursModified(subjectId) {
	      var _this9 = this;
	
	      var theSubject = this.subjectsInHash[subjectId];
	      var idx = theSubject.teachers[0] ? theSubject.teachers.findIndex(function (teacher) {
	        return teacher.user_id === _this9.activeUserId;
	      }) : -1;
	      return idx > -1;
	    },
	    readUserAgreements: function readUserAgreements() {
	      var _this10 = this;
	
	      _docendo2.default.schoolUserYearRead(this.schoolId, this.user.id, this.activeSchoolYear.name, function (success) {
	        _this10.userNorm = success.norm ? success.norm : [];
	        _this10.userAgreements = success.agreements ? success.agreements : '';
	      }, function (failure) {
	        console.log('failed!');
	      });
	    },
	    getIsUserInGroupWithoutPrepFactor: function getIsUserInGroupWithoutPrepFactor() {
	      var _this11 = this;
	
	      var user = this.getTheActiveUser;
	      if (!user || !user.user_tags) return false;
	      return user.user_tags.some(function (tag) {
	        return _this11.userTagsWithoutPrepFactor.includes(tag);
	      });
	    },
	    getIsUserInGroupForSumWorkHours: function getIsUserInGroupForSumWorkHours() {
	      var _this12 = this;
	
	      var user = this.getTheActiveUser;
	      if (!user || !user.user_tags) return false;
	      if (!Array.isArray(this.userTagsForSumWorkHours) || this.userTagsForSumWorkHours.length === 0) return false;
	      return user.user_tags.some(function (tag) {
	        return _this12.userTagsForSumWorkHours.includes(tag);
	      });
	    },
	    getSubstitutePoolPreparationHours: function getSubstitutePoolPreparationHours(assignedHours) {
	      if (!this.isPrepFactorForSubstitutePools || this.getIsUserInGroupWithoutPrepFactor()) {
	        return 0;
	      }
	      var schoolPrep = (0, _preparationFactor.parseNumericPreparationFactor)(this.schoolPrepFactor !== null && this.schoolPrepFactor !== undefined ? this.schoolPrepFactor : this.$store.state.schoolSettings && this.$store.state.schoolSettings.prepFactor);
	      if (schoolPrep === null) {
	        return 0;
	      }
	      var substituteHours = parseFloat(assignedHours && assignedHours.substitute_pool_hours);
	      if (isNaN(substituteHours)) {
	        return 0;
	      }
	      return parseFloat((substituteHours * schoolPrep).toFixed(2));
	    },
	    getPreparationForUser: function getPreparationForUser() {
	      var schoolPrep = (0, _preparationFactor.parseNumericPreparationFactor)(this.schoolPrepFactor !== null && this.schoolPrepFactor !== undefined ? this.schoolPrepFactor : this.$store.state.schoolSettings && this.$store.state.schoolSettings.prepFactor);
	      var skipTeachingFactor = this.getIsUserInGroupWithoutPrepFactor();
	
	      var fromUserTasks = (0, _preparationFactor.computeWeightedPreparationFromTaskList)(this.userTasks, schoolPrep, {
	        skipTeachingFactor: skipTeachingFactor
	      });
	      if (skipTeachingFactor || schoolPrep !== null || fromUserTasks) {
	        return fromUserTasks;
	      }
	      return this.getSumOfHoursForMasterType('preparation') || 0;
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (!this.isShowHeader) {
	      this.isShowScheduled = false;
	    }
	  },
	  mounted: function mounted() {
	    this.getSchoolDays();
	    this.readUserAgreements();
	    if (!this.isShowHeader) {
	      return;
	    }
	    if (this.userSettings && this.userSettings.hasOwnProperty('userTasksIsShowScheduled')) {
	      this.isShowScheduled = this.userSettings.userTasksIsShowScheduled;
	      this.$emit('changedIsShowScheduled', this.isShowScheduled);
	    }
	  }
	};

/***/ }),
/* 814 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    isShowScheduled: {
	      type: Boolean,
	      default: true
	    },
	    isDateIntervalChanged: {
	      type: Boolean,
	      default: false
	    },
	    workDayDates: {},
	    assignedTotalHoursForYear: {
	      type: Number,
	      default: 0
	    },
	    assignedTotalHoursForPeriod: {
	      type: Number,
	      default: 0
	    },
	    diffTotalHoursForPeriod: {
	      type: Number,
	      default: 0
	    },
	    userActualHours: {
	      type: Object,
	      default: function _default() {}
	    },
	    getUserHoursOverview: {
	      type: Object,
	      default: function _default() {}
	    },
	    tooltipContent: {
	      type: String,
	      default: ''
	    },
	    numberOfWorkDays: {
	      type: Number,
	      default: 0
	    },
	    numberOfWorkDaysInPeriod: {
	      type: Number,
	      default: 0
	    }
	  },
	  computed: {
	    userActualWithKids: function userActualWithKids() {
	      var usersWithScheduledHours = this.userActualHours;
	      if (usersWithScheduledHours && usersWithScheduledHours.actual_with_kids_hours) {
	        return this.toFixedIfNecessary(usersWithScheduledHours.actual_with_kids_hours);
	      } else {
	        return 0;
	      }
	    },
	    userActualWithoutKids: function userActualWithoutKids() {
	      var usersWithScheduledHours = this.userActualHours;
	      if (usersWithScheduledHours && usersWithScheduledHours.actual_without_kids_hours) {
	        return this.toFixedIfNecessary(usersWithScheduledHours.actual_without_kids_hours);
	      } else {
	        return 0;
	      }
	    },
	    userWithKidsAndWithout: function userWithKidsAndWithout() {
	      var sum = this.userActualWithKids * 1 + this.userActualWithoutKids * 1;
	      return this.toFixedIfNecessary(sum);
	    },
	    userDiffWithKidsAndWithout: function userDiffWithKidsAndWithout() {
	      var sum = this.userActualWithKids * 1 + this.userActualWithoutKids * 1;
	      var diff = this.assignedTotalHoursForPeriod - sum;
	      return this.toFixedIfNecessary(diff);
	    },
	    userTasks: function userTasks() {
	      return this.$store.state.subjects.userTasks;
	    },
	    assignedHoursWithoutKids: function assignedHoursWithoutKids() {
	      var tasks = this.userTasks.filter(function (task) {
	        return task.master_type === 'without_kids';
	      });
	      var hours = [0];
	      tasks.forEach(function (task) {
	        hours.push(task.hours * 1);
	      });
	      return hours.reduce(function (acc, n) {
	        return acc + n;
	      });
	    },
	    assignedHoursWithoutKidsInPeriod: function assignedHoursWithoutKidsInPeriod() {
	      return this.assignedHoursForPeriod(this.assignedHoursWithoutKids);
	    },
	    diffHoursWithoutKidsForPeriod: function diffHoursWithoutKidsForPeriod() {
	      var hoursPerDay = this.assignedHoursWithoutKids / this.numberOfWorkDays * 1;
	      var hoursInThePeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      var diff = hoursInThePeriod - this.userActualWithoutKids;
	      return this.toFixedIfNecessary(diff);
	    },
	    assignedHoursWithKids: function assignedHoursWithKids() {
	      return this.assignedTotalHoursForYear - this.assignedHoursWithoutKids;
	    },
	    assignedHoursWithKidsInPeriod: function assignedHoursWithKidsInPeriod() {
	      var hoursPerDay = this.assignedHoursWithoutKids / this.numberOfWorkDays * 1;
	      var assignedHoursWithoutKidsInThePeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      var result = this.assignedTotalHoursForPeriod - assignedHoursWithoutKidsInThePeriod;
	      return this.toFixedIfNecessary(result);
	    },
	    diffHoursWithKidsForPeriod: function diffHoursWithKidsForPeriod() {
	      var hoursPerDay = this.assignedHoursWithKids / this.numberOfWorkDays * 1;
	      var hoursInThePeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      var diff = hoursInThePeriod - this.userActualWithKids;
	      return this.toFixedIfNecessary(diff);
	    }
	  },
	  methods: {
	    createTooltip: function createTooltip(sumForYear) {
	      var hoursPerDay = sumForYear / this.numberOfWorkDays;
	      var hoursForPeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      var hoursPerDayFixed = this.toFixedIfNecessary(hoursPerDay);
	      var hoursForPeriodFixed = this.toFixedIfNecessary(hoursForPeriod);
	      return '<p><i>N\xE5r du v\xE6lger et andet datointerval end hele \xE5ret, kan du her se, hvor mange timer, der skal planl\xE6gges for medarbejderen i perioden og i gennemsnit per dag. Udregningen tager h\xF8jde for institutionens ferie- og helligdage.</i></p><br></p><p><b>Beregning</b></p><p>For \xE5ret: ' + sumForYear + ' timer / ' + this.numberOfWorkDays + ' dage = ' + hoursPerDayFixed + ' timer pr. dag</p><p>For perioden: ' + this.numberOfWorkDaysInPeriod + ' arbejdsdage * ' + hoursPerDayFixed + ' timer pr. dag = ' + hoursForPeriodFixed + ' timer</p>';
	    },
	    assignedHoursForPeriod: function assignedHoursForPeriod(hours) {
	      var hoursPerDay = hours / this.numberOfWorkDays * 1;
	      var hoursInThePeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      return this.toFixedIfNecessary(hoursInThePeriod);
	    },
	    toFixedIfNecessary: function toFixedIfNecessary(value) {
	      var num = value * 1;
	      return parseFloat(num).toFixed(2);
	    },
	    scaleIndicator: function scaleIndicator(diff) {
	      var color = 'rgba(62, 207, 142, 0.4)';
	      var newDiff = parseFloat(diff);
	      var indicatorPercentage = parseFloat(newDiff.toFixed(0));
	      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
	        indicatorPercentage = '0' + indicatorPercentage;
	      }
	      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
	        indicatorPercentage = '0' + indicatorPercentage * -1;
	      }
	      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
	        indicatorPercentage = indicatorPercentage * -1;
	      }
	      if (newDiff === 0) {
	        color = 'transparent';
	      }
	      if (newDiff < 0) {
	        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff < -99) {
	        color = 'rgba(250, 86, 90, 1)';
	      }
	      if (newDiff > 0) {
	        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff > 99) {
	        color = 'rgba(62, 207, 142, 1)';
	      }
	      return { 'backgroundColor': color };
	    }
	  }
	};

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserTasksOverviewOwnPoolsPool = __webpack_require__(1682);
	
	var _UserTasksOverviewOwnPoolsPool2 = _interopRequireDefault(_UserTasksOverviewOwnPoolsPool);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { UserTasksOverviewOwnPoolsPool: _UserTasksOverviewOwnPoolsPool2.default },
	  props: {
	    isShowScheduled: {
	      default: false
	    },
	    isDateIntervalChanged: {
	      default: false
	    },
	    schoolSettingShownOwnPools: {
	      default: function _default() {
	        return [];
	      }
	    },
	    userTasks: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  computed: {
	    visibleCategories: function visibleCategories() {
	      var _this = this;
	
	      return this.userTasks.filter(function (tasks) {
	        return _this.schoolSettingShownOwnPools.includes(tasks.title);
	      });
	    }
	  }
	};

/***/ }),
/* 816 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    taskCategory: {
	      default: function _default() {
	        return [];
	      }
	    },
	    isDateIntervalChanged: {
	      default: false
	    },
	    isShowScheduled: {
	      default: true
	    }
	  },
	  computed: {
	    tasks: function tasks() {
	      return this.taskCategory.tasks;
	    },
	    sumOfHours: function sumOfHours() {
	      var tasksHours = [0];
	      if (this.tasks.length > 0) {
	        tasksHours = this.tasks.map(function (task) {
	          return task.hours ? parseFloat(task.hours) : 0;
	        });
	      }
	      var sum = tasksHours.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return this.toFixedIfNecessary(sum, 2);
	    },
	    sumOfActual: function sumOfActual() {
	      var tasksActual = [0];
	      if (this.tasks.length > 0) {
	        tasksActual = this.tasks.map(function (task) {
	          var actual = task.actual ? task.actual : 0;
	          return parseFloat(actual);
	        });
	      }
	      var sum = tasksActual.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return this.toFixedIfNecessary(sum, 2);
	    },
	    sumOfDiff: function sumOfDiff() {
	      var tasksNumbers = [0];
	      if (this.tasks.length > 0) {
	        tasksNumbers = this.tasks.map(function (task) {
	          return task.diff ? parseFloat(task.diff) : 0;
	        });
	      }
	      var sum = tasksNumbers.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return this.toFixedIfNecessary(sum, 2);
	    }
	  },
	  methods: {
	    toFixedIfNecessary: function toFixedIfNecessary(value, dp) {
	      return +parseFloat(value).toFixed(dp);
	    }
	  }
	};

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vueClickaway = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    userCalendarId: {
	      default: 13
	    },
	    userId: {
	      default: 7
	    },
	    title: {
	      type: String,
	      default: 'Øvrige opgaver'
	    },
	    tasks: {
	      default: function _default() {
	        return [];
	      }
	    },
	    assignedHours: {
	      default: '0.0'
	    },
	    isShowScheduled: {
	      default: false,
	      type: Boolean
	    },
	    isPreviewAsEmployee: {
	      default: false,
	      type: Boolean
	    },
	    schoolThresholdToHideTaskHours: {
	      default: null
	    },
	    canEditTasks: {
	      type: Boolean,
	      default: false
	    },
	    userCalendarIdForTransfer: {
	      default: null
	    },
	    isFullPeriodSelected: {
	      type: Boolean,
	      default: false
	    },
	    canTransferScheduled: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      sortKey: 'name',
	      sortOrder: 1,
	      contextMenu: null
	    };
	  },
	
	  computed: {
	    localPoolTitle: function localPoolTitle() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || this.$t('vue2.task_overview.pool');
	    },
	    isOnlyShowScheduled: function isOnlyShowScheduled() {
	      return this.title === 'absence' || this.title === 'substitute_hours';
	    },
	    sortedTasks: function sortedTasks() {
	      var sortKey = this.sortKey;
	      var order = this.sortOrder;
	      var data = this.tasks;
	      if (sortKey) {
	        data = data.sort(function (a, b) {
	          a = a[sortKey];
	          b = b[sortKey];
	          if (sortKey !== 'name' && sortKey !== 'calendar') {
	            if (order < 0) {
	              return a - b;
	            } else {
	              return b - a;
	            }
	          } else {
	            a = a.toLowerCase();
	            b = b.toLowerCase();
	            return (a === b ? 0 : a > b ? 1 : -1) * order;
	          }
	        });
	      }
	      return data;
	    },
	    sumOfHours: function sumOfHours() {
	      var tasksHours = [0];
	      if (this.tasks.length > 0) {
	        tasksHours = this.tasks.map(function (task) {
	          return task.hours ? parseFloat(task.hours) : 0;
	        });
	      }
	      var sum = tasksHours.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return this.toFixedIfNecessary(sum, 2);
	    },
	    sumOfActual: function sumOfActual() {
	      var tasksActual = [0];
	      if (this.tasks.length > 0) {
	        tasksActual = this.tasks.map(function (task) {
	          var actual = task.actual ? task.actual : 0;
	          return parseFloat(actual);
	        });
	      }
	      var sum = tasksActual.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return this.toFixedIfNecessary(sum, 2);
	    },
	    sumOfDiff: function sumOfDiff() {
	      var tasksNumbers = [0];
	      if (this.tasks.length > 0) {
	        tasksNumbers = this.tasks.map(function (task) {
	          return task.diff ? parseFloat(task.diff) : 0;
	        });
	      }
	      var sum = tasksNumbers.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return this.toFixedIfNecessary(sum, 2);
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    hasAnyDates: function hasAnyDates() {
	      return this.tasks.some(function (task) {
	        return task.from_date || task.to_date;
	      });
	    }
	  },
	  methods: {
	    getI18n: function getI18n(title) {
	      switch (title) {
	        case 'teaching':
	          return this.$t('vue2.task_overview.teaching');
	        case 'other':
	          return this.$t('vue2.task_overview.tasks');
	        case 'preparation':
	          return this.$t('vue2.task_overview.preparation');
	        case 'absence':
	          return this.$t('vue2.task_overview.absence');
	        case 'club':
	          return this.$t('vue2.task_overview.club');
	        case 'substitute_hours':
	          return this.$t('vue2.task_overview.substitute_hours');
	        case 'pool':
	          return this.localPoolTitle;
	        case 'unknown':
	          return this.$t('vue2.task_overview.unknown');
	        case 'with_kids':
	          return 'Tid med børn';
	        case 'without_kids':
	          return 'Tid uden børn';
	        default:
	          return title;
	      }
	    },
	    setSortKey: function setSortKey(prop) {
	      this.sortKey = prop;
	      this.sortOrder === 1 ? this.sortOrder = -1 : this.sortOrder = 1;
	    },
	    toFixedIfNecessary: function toFixedIfNecessary(value, dp) {
	      return +parseFloat(value).toFixed(dp);
	    },
	    getCalendarNames: function getCalendarNames(task) {
	      if (!task.calendars) {
	        return task.calendar || '';
	      }
	      var calendars = task.calendars;
	      if (typeof calendars === 'string') {
	        try {
	          calendars = JSON.parse(calendars);
	        } catch (e) {
	          return task.calendar || '';
	        }
	      }
	      if (!Array.isArray(calendars) || calendars.length < 1) {
	        return task.calendar || '';
	      }
	      var klassNames = [];
	      for (var i = 0; i < calendars.length; i++) {
	        if (calendars[i].calendar_type === 'klass') {
	          klassNames.push(calendars[i].name);
	        }
	      }
	      if (klassNames.length < 1) {
	        return task.calendar || '';
	      }
	      if (klassNames.length <= 4) {
	        return klassNames.join(', ');
	      }
	      return klassNames.slice(0, 4).join(', ') + ' ...';
	    },
	    getTaskActual: function getTaskActual(task) {
	      var actual = task.actual ? task.actual * 1 : 0;
	      return this.toFixedIfNecessary(actual, 2);
	    },
	    getTasksHours: function getTasksHours(task) {
	      return task.hours ? this.toFixedIfNecessary(task.hours, 2) : '';
	    },
	    getIsHideTaskHours: function getIsHideTaskHours(task) {
	      var threshold = this.schoolThresholdToHideTaskHours * 1;
	      if (!this.isPreviewAsEmployee || !threshold) {
	        return false;
	      }
	      var hours = task.hours * 1;
	      return task.subject_type === 'additional_tasks' && hours >= 0 && hours < threshold;
	    },
	    calcDifference: function calcDifference(task) {
	      var actual = task.actual ? task.actual * 1 : 0;
	      var hours = task.hours ? parseFloat(task.hours) : null;
	      return task.hours ? this.toFixedIfNecessary(hours - actual, 2) : '';
	    },
	    canEditTask: function canEditTask(task) {
	      return this.canEditTasks && task && task.id && !task.substitute && this.title !== 'absence';
	    },
	    onTaskClick: function onTaskClick(task) {
	      if (!this.canEditTask(task)) {
	        return;
	      }
	      this.setEditTask(task);
	    },
	    setEditTask: function setEditTask(task) {
	      this.$emit('edit', task);
	    },
	    canShowContextMenu: function canShowContextMenu(task) {
	      if (!this.canTransferScheduled || !this.canEditTask(task) || !this.isShowScheduled || this.isOnlyShowScheduled) {
	        return false;
	      }
	      return task.can_schedule === true || task.can_schedule === 't';
	    },
	    isTeacherOnTask: function isTeacherOnTask(task) {
	      var isInOwnCalendar = task.calendar_id_for_subject * 1 === this.userCalendarIdForTransfer * 1;
	      return isInOwnCalendar || !!task.subject_calendar_id;
	    },
	    getTransferDisabledReason: function getTransferDisabledReason(task) {
	      if (!this.isFullPeriodSelected) {
	        return this.$t('vue2.task_overview.transfer_scheduled_only_full_period');
	      }
	      var hours = task.hours ? this.toFixedIfNecessary(task.hours, 2) : 0;
	      if (hours === this.getTaskActual(task)) {
	        return this.$t('vue2.task_overview.transfer_scheduled_already_equal');
	      }
	      return '';
	    },
	    onTaskContextMenu: function onTaskContextMenu(event, task) {
	      var _this = this;
	
	      if (!this.canShowContextMenu(task)) {
	        return;
	      }
	      event.preventDefault();
	      var x = event.clientX;
	      var y = event.clientY;
	      if (!this.isTeacherOnTask(task)) {
	        this.$emit('assignTeacher', task, function () {
	          return _this.openContextMenu(task, x, y);
	        });
	        return;
	      }
	      this.openContextMenu(task, x, y);
	    },
	    openContextMenu: function openContextMenu(task, x, y) {
	      this.contextMenu = { task: task, x: x, y: y };
	    },
	    closeContextMenu: function closeContextMenu() {
	      this.contextMenu = null;
	    },
	    onTransferScheduled: function onTransferScheduled(task) {
	      if (this.getTransferDisabledReason(task)) {
	        return;
	      }
	      this.closeContextMenu();
	      this.$emit('transferScheduled', task);
	    },
	    onEditFromContextMenu: function onEditFromContextMenu(task) {
	      this.closeContextMenu();
	      this.setEditTask(task);
	    },
	    setDeleteTask: function setDeleteTask(task) {
	      this.$emit('delete', task);
	    },
	    getShowCalendarIfNotOwn: function getShowCalendarIfNotOwn(task) {
	      var _this2 = this;
	
	      var isInOwnCalendar = task.belongs_to_calendars ? task.belongs_to_calendars.indexOf(this.userCalendarId) > -1 : task.calendar_id === this.userCalendarId;
	      if (isInOwnCalendar) {
	        return [];
	      } else {
	        return task.belongs_to_calendars ? task.belongs_to_calendars.map(function (calId) {
	          return _this2.allCalendarsInHash[calId];
	        }) : [this.allCalendarsInHash[task.calendar_id]];
	      }
	    },
	    formatDateRange: function formatDateRange(fromDate, toDate) {
	      if (!fromDate && !toDate) return '';
	      var from = fromDate ? (0, _moment2.default)(fromDate) : null;
	      var to = toDate ? (0, _moment2.default)(toDate) : null;
	      if (from && !to) return from.format('DD-MM-YYYY');
	      if (!from && to) return to.format('DD-MM-YYYY');
	      if (from.isSame(to, 'day')) return from.format('DD-MM-YYYY');
	      return from.format('DD-MM-YYYY') + ' - ' + to.format('DD-MM-YYYY');
	    },
	    scaleIndicator: function scaleIndicator(diff) {
	      var color = 'rgba(62, 207, 142, 0.4)';
	      var newDiff = parseFloat(diff);
	      var indicatorPercentage = parseFloat(newDiff.toFixed(0));
	      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
	        indicatorPercentage = '0' + indicatorPercentage;
	      }
	      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
	        indicatorPercentage = '0' + indicatorPercentage * -1;
	      }
	      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
	        indicatorPercentage = indicatorPercentage * -1;
	      }
	      if (newDiff === 0) {
	        color = 'transparent';
	      }
	      if (newDiff < 0) {
	        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff < -99) {
	        color = 'rgba(250, 86, 90, 1)';
	      }
	      if (newDiff > 0) {
	        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff > 99) {
	        color = 'rgba(62, 207, 142, 1)';
	      }
	      return { 'backgroundColor': color };
	    }
	  },
	  watch: {
	    tasks: {
	      handler: function handler() {
	        var _this3 = this;
	
	        this.tasks.forEach(function (task, i) {
	          return _this3.$set(_this3.tasks[i], 'diff', _this3.calcDifference(task));
	        });
	      },
	
	      immediate: true
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    this._onContextMenuKeydown = function (e) {
	      if (e.key === 'Escape') {
	        _this4.closeContextMenu();
	      }
	    };
	    window.addEventListener('scroll', this.closeContextMenu, true);
	    window.addEventListener('contextmenu', this.closeContextMenu, true);
	    window.addEventListener('keydown', this._onContextMenuKeydown);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('scroll', this.closeContextMenu, true);
	    window.removeEventListener('contextmenu', this.closeContextMenu, true);
	    window.removeEventListener('keydown', this._onContextMenuKeydown);
	  }
	};

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default },
	  props: {
	    userCalendarId: {
	      default: 13
	    },
	    userId: {
	      default: 7
	    },
	    title: {
	      type: String,
	      default: 'Øvrige opgaver'
	    },
	    tasks: {
	      default: function _default() {
	        return [];
	      }
	    },
	    assignedHours: {
	      default: '0.0'
	    },
	    isShowScheduled: {
	      default: false,
	      type: Boolean
	    }
	  },
	  data: function data() {
	    return {
	      sortKey: 'name',
	      sortOrder: 1
	    };
	  },
	
	  computed: {
	    localPoolTitle: function localPoolTitle() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || this.$t('vue2.task_overview.pool');
	    },
	    isOnlyShowScheduled: function isOnlyShowScheduled() {
	      return this.title === 'absence' || this.title === 'substitute_hours';
	    },
	    sortedTasks: function sortedTasks() {
	      var sortKey = this.sortKey;
	      var order = this.sortOrder;
	      var data = this.tasks;
	      if (sortKey) {
	        data = data.sort(function (a, b) {
	          a = a[sortKey];
	          b = b[sortKey];
	          if (sortKey !== 'name' && sortKey !== 'calendar') {
	            if (order < 0) {
	              return a - b;
	            } else {
	              return b - a;
	            }
	          } else {
	            a = a.toLowerCase();
	            b = b.toLowerCase();
	            return (a === b ? 0 : a > b ? 1 : -1) * order;
	          }
	        });
	      }
	      return data;
	    },
	    tasksGrouped: function tasksGrouped() {
	      var types = [];
	      this.sortedTasks.forEach(function (event) {
	        var idx = types.findIndex(function (masterType) {
	          return masterType.masterType === event.master_type;
	        });
	        if (idx < 0) {
	          var obj = { masterType: event.master_type, events: [event], sum: event.actual };
	          types.push(obj);
	        } else {
	          types[idx]['events'].push(event);
	          types[idx]['sum'] += event.actual;
	        }
	      });
	      var masterTypeOrder = ['teaching', 'club', 'other', 'preparation', 'pool', 'unknown'];
	      types.sort(function (a, b) {
	        var aIndex = masterTypeOrder.indexOf(a.masterType);
	        var bIndex = masterTypeOrder.indexOf(b.masterType);
	
	        var aFinalIndex = aIndex === -1 ? 9999 : aIndex;
	        var bFinalIndex = bIndex === -1 ? 9999 : bIndex;
	
	        return aFinalIndex - bFinalIndex;
	      });
	
	      return types;
	    },
	    sumOfHours: function sumOfHours() {
	      var tasksHours = [0];
	      if (this.tasks.length > 0) {
	        tasksHours = this.tasks.map(function (task) {
	          return parseFloat(task.hours);
	        });
	      }
	      var sum = tasksHours.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return this.toFixedIfNecessary(sum, 2);
	    },
	    sumOfActual: function sumOfActual() {
	      var tasksActual = [0];
	      if (this.tasks.length > 0) {
	        tasksActual = this.tasks.map(function (task) {
	          var actual = task.actual ? task.actual : 0;
	          return parseFloat(actual);
	        });
	      }
	      var sum = tasksActual.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return this.toFixedIfNecessary(sum, 2);
	    },
	    sumOfDiff: function sumOfDiff() {
	      var tasksNumbers = [0];
	      if (this.tasks.length > 0) {
	        tasksNumbers = this.tasks.map(function (task) {
	          return parseFloat(task.diff);
	        });
	      }
	      var sum = tasksNumbers.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return this.toFixedIfNecessary(sum, 2);
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    }
	  },
	  methods: {
	    getI18n: function getI18n(title) {
	      switch (title) {
	        case 'teaching':
	          return this.$t('vue2.task_overview.teaching');
	        case 'other':
	          return this.$t('vue2.task_overview.tasks');
	        case 'preparation':
	          return this.$t('vue2.task_overview.preparation');
	        case 'absence':
	          return this.$t('vue2.task_overview.absence');
	        case 'club':
	          return this.$t('vue2.task_overview.club');
	        case 'substitute_hours':
	          return this.$t('vue2.task_overview.substitute_hours');
	        case 'pool':
	          return this.localPoolTitle;
	        case 'unknown':
	          return this.$t('vue2.task_overview.unknown');
	        case 'with_kids':
	          return 'Tid med børn';
	        case 'without_kids':
	          return 'Tid uden børn';
	        default:
	          return title;
	      }
	    },
	    setSortKey: function setSortKey(prop) {
	      this.sortKey = prop;
	      this.sortOrder === 1 ? this.sortOrder = -1 : this.sortOrder = 1;
	    },
	    toFixedIfNecessary: function toFixedIfNecessary(value, dp) {
	      return +parseFloat(value).toFixed(dp);
	    },
	    getTaskActual: function getTaskActual(task) {
	      var actual = task.actual ? task.actual * 1 : 0;
	      return this.toFixedIfNecessary(actual, 2);
	    },
	    getTasksHours: function getTasksHours(task) {
	      return this.toFixedIfNecessary(task.hours, 2);
	    },
	    calcDifference: function calcDifference(task) {
	      var actual = task.actual ? task.actual * 1 : 0;
	      var hours = parseFloat(task.hours);
	      return this.toFixedIfNecessary(hours - actual, 2);
	    },
	    getSubjectHours: function getSubjectHours(task) {
	      var _this = this;
	
	      var theSubject = task;
	      var idx = theSubject.teachers[0] ? theSubject.teachers.findIndex(function (teacher) {
	        return teacher.user_id === _this.userId;
	      }) : -1;
	      var num = 0;
	      if (idx > -1) {
	        num = theSubject.teachers[idx].hours;
	      } else {
	        num = theSubject.hours;
	      }
	      return parseFloat(num).toFixed(1);
	    },
	    setEditTask: function setEditTask(task) {
	      this.$emit('edit', task);
	    },
	    setDeleteTask: function setDeleteTask(task) {
	      this.$emit('delete', task);
	    },
	    getShowCalendarIfNotOwn: function getShowCalendarIfNotOwn(task) {
	      var _this2 = this;
	
	      var isInOwnCalendar = task.belongs_to_calendars ? task.belongs_to_calendars.indexOf(this.userCalendarId) > -1 : task.calendar_id === this.userCalendarId;
	      if (isInOwnCalendar) {
	        return [];
	      } else {
	        return task.belongs_to_calendars ? task.belongs_to_calendars.map(function (calId) {
	          return _this2.allCalendarsInHash[calId];
	        }) : [this.allCalendarsInHash[task.calendar_id]];
	      }
	    },
	    scaleIndicator: function scaleIndicator(diff) {
	      var color = 'rgba(62, 207, 142, 0.4)';
	      var newDiff = parseFloat(diff);
	      var indicatorPercentage = parseFloat(newDiff.toFixed(0));
	      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
	        indicatorPercentage = '0' + indicatorPercentage;
	      }
	      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
	        indicatorPercentage = '0' + indicatorPercentage * -1;
	      }
	      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
	        indicatorPercentage = indicatorPercentage * -1;
	      }
	      if (newDiff === 0) {
	        color = 'transparent';
	      }
	      if (newDiff < 0) {
	        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff < -99) {
	        color = 'rgba(250, 86, 90, 1)';
	      }
	      if (newDiff > 0) {
	        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff > 99) {
	        color = 'rgba(62, 207, 142, 1)';
	      }
	      return { 'backgroundColor': color };
	    }
	  },
	  beforeMount: function beforeMount() {
	    var _this3 = this;
	
	    this.tasks.forEach(function (task, i) {
	      return _this3.$set(_this3.tasks[i], 'diff', _this3.calcDifference(task));
	    });
	  }
	};

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vuex = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    absence_reason: 'Fraværsårsag'
	  },
	  en: {
	    absence_reason: 'Absence reason'
	  },
	  nb: {
	    absence_reason: 'Fraværsårsak'
	  }
	};
	
	exports.default = {
	  components: { dSelect: _DSelect2.default },
	  props: {
	    calendarId: {
	      default: function _default() {
	        return 309496;
	      }
	    },
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    selectedSubject: {
	      default: null
	    },
	    resetCounter: {
	      default: 0
	    },
	    isShowLabel: {
	      default: true,
	      type: Boolean
	    }
	  },
	  data: function data() {
	    return {
	      isLoadingSubjects: false,
	      subjects: [],
	      isSubmitting: false,
	      theSearchText: '',
	      theNewSubject: null,
	      isShowCreateSubjectButton: false,
	      theNewlyCreatedSubject: null,
	      isCreateAbsenceReason: false,
	      startTime: (0, _moment2.default)().set({ hour: 8, minutes: 0 }),
	      endTime: (0, _moment2.default)().set({ hour: 16, minutes: 0 })
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['schoolId', 'locale']), {
	    i18n: function i18n() {
	      return I18N[this.locale] || I18N['da'];
	    },
	    filteredSubjects: function filteredSubjects() {
	      return this.subjects.filter(function (subject) {
	        return subject.can_request;
	      });
	    },
	    selectedSubjectArr: function selectedSubjectArr() {
	      var _this = this;
	
	      if (!this.selectedSubject) {
	        return [];
	      }
	      var filteredSubjects = this.filteredSubjects.filter(function (subject) {
	        return subject.id === _this.selectedSubject.id;
	      });
	      return filteredSubjects.length > 0 ? filteredSubjects : [];
	    },
	    sortedSubjects: function sortedSubjects() {
	      var _this2 = this;
	
	      return this.filteredSubjects.map(function (subject) {
	        var translatedSubjectType = _this2.$t('vue2.eventTypes.' + subject.subject_type);
	        var vSubjectType = translatedSubjectType === 'vue2.eventTypes.' + subject.subject_type ? subject.subject_type : translatedSubjectType;
	
	        return (0, _extends3.default)({}, subject, {
	          vSubjectType: vSubjectType
	        });
	      }).sort(function (a, b) {
	        if (a.name < b.name) return -1;
	        if (a.name > b.name) return 1;
	        return 0;
	      });
	    },
	    dbEventStart: function dbEventStart() {
	      var date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      var time = this.startTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    dbEventEnd: function dbEventEnd() {
	      var date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      var time = this.endTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    }
	  }),
	  watch: {
	    selectedSubject: function selectedSubject() {
	      this.theNewSubject = null;
	    },
	    calendarId: function calendarId() {
	      this.readSubjects();
	    },
	    theNewlyCreatedSubject: function theNewlyCreatedSubject() {
	      this.readSubjects();
	    }
	  },
	  methods: {
	    setDate: function setDate(date) {
	      this.$emit('setDate', date);
	    },
	    onCloseDSelect: function onCloseDSelect() {
	      this.isShowCreateSubjectButton = false;
	    },
	    setIsShowCreateSubjectButton: function setIsShowCreateSubjectButton() {
	      var _this3 = this;
	
	      var idx = this.filteredSubjects.findIndex(function (subject) {
	        return subject.name === _this3.theSearchText;
	      });
	      this.isShowCreateSubjectButton = this.theSearchText.length > 0 && idx < 0;
	    },
	    onSearchTextDebounced: function onSearchTextDebounced() {
	      this.setIsShowCreateSubjectButton();
	    },
	    setTheSearchText: function setTheSearchText(str) {
	      this.theSearchText = str;
	    },
	    setSubject: function setSubject(arr) {
	      var selectedSubject = arr.length > 0 ? arr[0] : null;
	      if (!selectedSubject) {
	        return;
	      }
	      this.$emit('setSubject', selectedSubject);
	    },
	    setStartTime: function setStartTime(payload) {
	      this.startTime = payload;
	    },
	    setEndTime: function setEndTime(payload) {
	      this.endTime = payload;
	    },
	    readSubjects: function readSubjects() {
	      var _this4 = this;
	
	      this.isLoadingSubjects = true;
	      _docendo2.default.schoolAbsenceSubjectsList(this.schoolId, false, function (success) {
	        _this4.isLoadingSubjects = false;
	        _this4.subjects = success;
	      }, function (failure) {
	        console.log('something went wrong');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readSubjects();
	    setTimeout(function (_) {
	      var el = document.querySelector('#d-create-task-for-user .d-select__input-look > input[type="search"]');
	      if (el) {
	        el.focus();
	      }
	    }, 400);
	  }
	};

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _vuex = __webpack_require__(14);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _TimeChanger = __webpack_require__(31);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _UserAbsence = __webpack_require__(149);
	
	var _UserAbsence2 = _interopRequireDefault(_UserAbsence);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _UserRequestList = __webpack_require__(151);
	
	var _UserRequestList2 = _interopRequireDefault(_UserRequestList);
	
	var _UserQuota = __webpack_require__(374);
	
	var _UserQuota2 = _interopRequireDefault(_UserQuota);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    absence_request: 'Fraværsanmodning',
	    tab_request: 'Anmod om fravær',
	    tab_list: 'Dine fraværsanmodninger',
	    select_school: 'Vælg skole',
	    date: 'Dato',
	    time: 'Tid',
	    optional_note: 'Evt. note',
	    toast_created: 'Anmodning oprettet'
	  },
	  en: {
	    absence_request: 'Absence request',
	    tab_request: 'Request absence',
	    tab_list: 'Your absence requests',
	    select_school: 'Select school',
	    date: 'Date',
	    time: 'Time',
	    optional_note: 'Optional note',
	    toast_created: 'Request created'
	  },
	  nb: {
	    absence_request: 'Fraværsforespørsel',
	    tab_request: 'Send forespørsel',
	    tab_list: 'Dine fraværsforespørsler',
	    select_school: 'Velg skole',
	    date: 'Dato',
	    time: 'Tid',
	    optional_note: 'Valgfri merknad',
	    toast_created: 'Forespørsel opprettet'
	  }
	};
	
	exports.default = {
	  components: { UserRequestList: _UserRequestList2.default, UserAbsence: _UserAbsence2.default, UserQuota: _UserQuota2.default, DatepickerRange: _DatePickerRange2.default, TimeChanger: _TimeChanger2.default, DModal: _DModal2.default, Tabs: _Tabs2.default },
	  props: {
	    isShowTabs: {
	      type: Boolean,
	      default: true
	    },
	    editRequest: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      date: (0, _moment2.default)(),
	      startDate: (0, _moment2.default)(),
	      endDate: (0, _moment2.default)(),
	      startTime: (0, _moment2.default)().set({ hour: 8, minutes: 0 }),
	      endTime: (0, _moment2.default)().set({ hour: 16, minutes: 0 }),
	      selectedSubject: null,
	      note: '',
	      isSubmitting: false,
	      activeSchoolId: null,
	      isMultipleSchoolsActive: false,
	      selectedTab: 'request',
	      resetAbsenceCounter: 0,
	      isQuotaVisible: true
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userCalendars', 'schoolId', 'schoolFeatures', 'locale', 'isKmdUserQuotaActive', 'isPermissionsActivatedForSchool', 'userPermissions']), {
	    i18n: function i18n() {
	      return I18N[this.locale] || I18N['da'];
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    userSchools: function userSchools() {
	      return this.user && this.user.schools ? this.user.schools : [];
	    },
	    userSchoolsSorted: function userSchoolsSorted() {
	      return this.userSchools.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    isShowKmdQuotas: function isShowKmdQuotas() {
	      return !!(this.user && this.user.id) && this.isKmdUserQuotaActive && this.userHasPermission('can_see_own_task_overview');
	    },
	    isShowQuotasSidebar: function isShowQuotasSidebar() {
	      return this.isShowKmdQuotas && this.selectedTab === 'request' && !this.activeSchoolId && !this.isMultipleSchoolsActive;
	    },
	    isValidated: function isValidated() {
	      return this.selectedSubject;
	    },
	    dbEventStart: function dbEventStart() {
	      var date = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var time = this.startTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    dbEventEnd: function dbEventEnd() {
	      var date = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var time = this.endTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    }
	  }),
	  methods: {
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.user.admin;
	      }
	      return true;
	    },
	    resetForm: function resetForm() {
	      this.startDate = (0, _moment2.default)();
	      this.endDate = (0, _moment2.default)();
	      this.startTime = (0, _moment2.default)().set({ hour: 8, minutes: 0 });
	      this.endTime = (0, _moment2.default)().set({ hour: 16, minutes: 0 });
	      this.selectedSubject = null;
	      this.note = '';
	      this.resetAbsenceCounter++;
	    },
	    onChangeActiveSchoolId: function onChangeActiveSchoolId() {
	      this.readSchoolYears();
	      this.$nextTick(function (_) {
	        console.log(document.getElementById('app'));
	      });
	    },
	    readSchoolYears: function readSchoolYears() {
	      var _this = this;
	
	      this.isLoadingSchoolYears = true;
	      _docendo2.default.schoolYearsRead(this.activeSchoolId, {}, 'name', function (data) {
	        _this.schoolYears = data;
	        _this.isLoadingSchoolYears = false;
	      });
	    },
	    setSelectedSubject: function setSelectedSubject(subject) {
	      this.selectedSubject = subject;
	    },
	    setStartDate: function setStartDate(payload) {
	      this.startDate = payload;
	    },
	    setEndDate: function setEndDate(payload) {
	      this.endDate = payload;
	    },
	    setStartTime: function setStartTime(payload) {
	      this.startTime = payload;
	    },
	    setEndTime: function setEndTime(payload) {
	      this.endTime = payload;
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      this.isSubmitting = true;
	      var schoolId = this.selectedSubject.school_id;
	      var startTime = this.dbEventStart;
	      var endTime = this.dbEventEnd;
	      var requestNote = this.note;
	      var subjectId = this.selectedSubject.id;
	      _docendo2.default.createRequest(schoolId, subjectId, startTime, endTime, requestNote, function (success) {
	        _this2.showToast(_this2.i18n['toast_created'], true);
	        _this2.isSubmitting = false;
	        _this2.selectedTab = 'list';
	        _this2.resetForm();
	        _this2.$store.dispatch('trackEvent', 'calendar_absence_request');
	      }, function (failure) {
	        _this2.showToast(failure, false);
	        _this2.isSubmitting = false;
	      });
	    },
	    showToast: function showToast(message, success) {
	      _eventbus2.default.toast = { text: message, success: success };
	    }
	  }
	};

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    absent_on_date: 'Fraværende',
	    no_one_absent: 'Ingen fraværende på denne dato'
	  },
	  en: {
	    absent_on_date: 'Absent',
	    no_one_absent: 'No one absent on this date'
	  },
	  nb: {
	    absent_on_date: 'Fraværende',
	    no_one_absent: 'Ingen fraværende på denne datoen'
	  }
	};
	
	exports.default = {
	  components: { DateSelector: _DateSelector2.default },
	  props: {
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    requesterId: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      selectedDate: (0, _moment2.default)(this.date).format('YYYY-MM-DD'),
	      absentToday: [],
	      isLoading: false,
	      requestCounter: 0
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['schoolId', 'locale']), {
	    i18n: function i18n() {
	      return I18N[this.locale] || I18N['da'];
	    },
	    absentUsers: function absentUsers() {
	      var _this = this;
	
	      var users = this.absentToday.map(function (user) {
	        var absence = (user.events || []).filter(function (event) {
	          return event.event_type === 'absence';
	        }).sort(function (a, b) {
	          return (0, _moment2.default)(a.start).unix() - (0, _moment2.default)(b.start).unix();
	        }).map(function (event) {
	          return {
	            title: event.title,
	            dateRange: _this.isSameDay(event.start, event.end) ? null : _this.formatDate(event.start) + ' - ' + _this.formatDate(event.end),
	            timeRange: _this.formatTime(event.start) + ' - ' + _this.formatTime(event.end)
	          };
	        });
	        return {
	          id: user.calendar_id,
	          name: user.name,
	          isRequester: !!_this.requesterId && String(user.user_id) === String(_this.requesterId),
	          absence: absence
	        };
	      });
	      return this.$helpers.sortArrOnName(users);
	    }
	  }),
	  watch: {
	    date: function date(newDate, oldDate) {
	      if ((0, _moment2.default)(newDate).format('YYYY-MM-DD') !== (0, _moment2.default)(oldDate).format('YYYY-MM-DD')) {
	        this.setDate(newDate);
	      }
	    }
	  },
	  methods: {
	    setDate: function setDate(date) {
	      this.selectedDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      this.getAbsence();
	    },
	    prevDay: function prevDay() {
	      this.setDate((0, _moment2.default)(this.selectedDate).subtract(1, 'days'));
	    },
	    nextDay: function nextDay() {
	      this.setDate((0, _moment2.default)(this.selectedDate).add(1, 'days'));
	    },
	    formatDate: function formatDate(date) {
	      return (0, _moment2.default)(date).locale(this.locale).format('D. MMM');
	    },
	    isSameDay: function isSameDay(start, end) {
	      return (0, _moment2.default)(start).format('YYYY-MM-DD') === (0, _moment2.default)(end).format('YYYY-MM-DD');
	    },
	    formatTime: function formatTime(date) {
	      return (0, _moment2.default)(date).locale(this.locale).format('LT');
	    },
	    getAbsence: function getAbsence() {
	      var _this2 = this;
	
	      var counter = ++this.requestCounter;
	      this.isLoading = true;
	      _docendo2.default.absenceForDate(this.schoolId, this.selectedDate, function (success) {
	        if (counter !== _this2.requestCounter) return;
	        _this2.isLoading = false;
	        _this2.absentToday = typeof success === 'string' && success.length > 1 ? JSON.parse(success) : Array.isArray(success) ? success : [];
	      }, function (failure) {
	        if (counter !== _this2.requestCounter) return;
	        _this2.isLoading = false;
	        _this2.absentToday = [];
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.getAbsence();
	  }
	};

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _vuex = __webpack_require__(14);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _TimeChanger = __webpack_require__(31);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _UserAbsence = __webpack_require__(149);
	
	var _UserAbsence2 = _interopRequireDefault(_UserAbsence);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _UserRequestList = __webpack_require__(151);
	
	var _UserRequestList2 = _interopRequireDefault(_UserRequestList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    edit_absence_request: 'Rediger fraværsanmodning',
	    date: 'Dato',
	    time: 'Tid',
	    optional_note: 'Evt. note',
	    delete_request_tooltip: 'Slet anmodning',
	    toast_deleted: 'Anmodning slettet',
	    toast_updated: 'Anmodning opdateret'
	  },
	  en: {
	    edit_absence_request: 'Edit absence request',
	    date: 'Date',
	    time: 'Time',
	    optional_note: 'Optional note',
	    delete_request_tooltip: 'Delete request',
	    toast_deleted: 'Request deleted',
	    toast_updated: 'Request updated'
	  },
	  nb: {
	    edit_absence_request: 'Rediger fraværsforespørsel',
	    date: 'Dato',
	    time: 'Tid',
	    optional_note: 'Valgfri merknad',
	    delete_request_tooltip: 'Slett forespørsel',
	    toast_deleted: 'Forespørsel slettet',
	    toast_updated: 'Forespørsel oppdatert'
	  }
	};
	
	exports.default = {
	  components: { UserRequestList: _UserRequestList2.default, UserAbsence: _UserAbsence2.default, DatepickerRange: _DatePickerRange2.default, TimeChanger: _TimeChanger2.default, DModal: _DModal2.default, Tabs: _Tabs2.default },
	  props: {
	    isShowTabs: {
	      type: Boolean,
	      default: true
	    },
	    editRequest: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      initStartDate: (0, _moment2.default)(),
	      initEndDate: (0, _moment2.default)(),
	      startDate: (0, _moment2.default)(),
	      endDate: (0, _moment2.default)(),
	      startTime: (0, _moment2.default)().set({ hour: 8, minutes: 0 }),
	      endTime: (0, _moment2.default)().set({ hour: 16, minutes: 0 }),
	      selectedSubject: null,
	      note: '',
	      isSubmitting: false,
	      activeSchoolId: null,
	      isMultipleSchoolsActive: false,
	      selectedTab: 'request',
	      resetAbsenceCounter: 0,
	      isDeleting: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userCalendars', 'schoolId', 'locale']), {
	    i18n: function i18n() {
	      return I18N[this.locale] || I18N['da'];
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    userSchools: function userSchools() {
	      return this.user && this.user.schools ? this.user.schools : [];
	    },
	    userSchoolsSorted: function userSchoolsSorted() {
	      return this.userSchools.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    isValidated: function isValidated() {
	      return this.selectedSubject;
	    },
	    dbEventStart: function dbEventStart() {
	      var date = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var time = this.startTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    dbEventEnd: function dbEventEnd() {
	      var date = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var time = this.endTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    }
	  }),
	  watch: {
	    editRequest: {
	      immediate: true,
	      handler: function handler(val) {
	        if (val) {
	          this.startDate = (0, _moment2.default)(val.start_time);
	          this.endDate = (0, _moment2.default)(val.end_time);
	          this.initStartDate = (0, _moment2.default)(val.start_time);
	          this.initEndDate = (0, _moment2.default)(val.end_time);
	          this.startTime = (0, _moment2.default)(val.start_time);
	          this.endTime = (0, _moment2.default)(val.end_time);
	          this.note = val.request_note || '';
	          this.selectedSubject = { id: val.subject_id };
	        } else {
	          this.resetForm();
	        }
	      }
	    }
	  },
	  methods: {
	    deleteRequest: function deleteRequest() {
	      var _this = this;
	
	      this.isDeleting = true;
	      var schoolId = this.editRequest.school_id;
	      var id = this.editRequest.id;
	      _docendo2.default.deleteRequest(schoolId, id, function (success) {
	        _this.showToast(_this.i18n['toast_deleted'], true);
	        _this.$emit('submitted');
	        _this.$emit('close');
	      }, function (failure) {
	        _this.isDeleting = false;
	        _this.showToast(failure, false);
	      });
	    },
	    resetForm: function resetForm() {
	      this.startDate = (0, _moment2.default)();
	      this.endDate = (0, _moment2.default)();
	      this.startTime = (0, _moment2.default)().set({ hour: 8, minutes: 0 });
	      this.endTime = (0, _moment2.default)().set({ hour: 16, minutes: 0 });
	      this.selectedSubject = null;
	      this.note = '';
	      this.resetAbsenceCounter++;
	    },
	    setSelectedSubject: function setSelectedSubject(subject) {
	      this.selectedSubject = subject;
	    },
	    setStartDate: function setStartDate(payload) {
	      this.startDate = payload;
	    },
	    setEndDate: function setEndDate(payload) {
	      this.endDate = payload;
	    },
	    setStartTime: function setStartTime(payload) {
	      this.startTime = payload;
	    },
	    setEndTime: function setEndTime(payload) {
	      this.endTime = payload;
	    },
	    showToast: function showToast(message, success) {
	      _eventbus2.default.toast = { text: message, success: success };
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      this.isSubmitting = true;
	      var schoolId = this.editRequest.school_id;
	      var startTime = this.dbEventStart;
	      var endTime = this.dbEventEnd;
	      var requestNote = this.note;
	      var subjectId = this.selectedSubject.id;
	      var id = this.editRequest.id;
	
	      _docendo2.default.updateRequest(schoolId, id, subjectId, startTime, endTime, requestNote, function (success) {
	        _this2.showToast(_this2.i18n['toast_updated'], true);
	        _this2.$emit('submitted');
	        _this2.$emit('close');
	      }, function (failure) {
	        _this2.showToast(failure, false);
	        _this2.isSubmitting = false;
	      });
	    }
	  }
	};

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _UserRequestListAnswer = __webpack_require__(1686);
	
	var _UserRequestListAnswer2 = _interopRequireDefault(_UserRequestListAnswer);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _UserRequest = __webpack_require__(150);
	
	var _UserRequest2 = _interopRequireDefault(_UserRequest);
	
	var _UserRequestForm = __webpack_require__(1685);
	
	var _UserRequestForm2 = _interopRequireDefault(_UserRequestForm);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _vuex = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SORT_STORAGE_KEY = 'docendo-user-requests-list-sort';
	var SORTABLE_KEYS = ['created_at', 'vUserName', 'start_time', 'end_time', 'vSubjectTitle', 'request_note', 'response_note', 'vResponderName', 'state'];
	var DATE_SORT_KEYS = {
	  created_at: true,
	  start_time: true,
	  end_time: true
	};
	
	var I18N = {
	  da: {
	    absence_requests: 'Fraværsanmodninger',
	    created: 'Oprettet',
	    who: 'Hvem',
	    from: 'Fra',
	    to: 'Til',
	    reason: 'Årsag',
	    note: 'Note',
	    note_back: 'Note tilbage',
	    answered_by: 'Besvaret af',
	    status: 'Status',
	    tab_requested: 'Afventer svar',
	    tab_approved: 'Godkendte',
	    tab_rejected: 'Afviste',
	    empty_requested: 'Ingen nye anmodninger',
	    empty_approved: 'Ingen godkendte anmodninger',
	    empty_rejected: 'Ingen afviste anmodninger',
	    answer: 'Besvar',
	    pending: 'Afventer svar',
	    approved: 'Godkendt',
	    rejected: 'Afvist',
	    at_time_cap: 'Kl.',
	    at_time_lower: 'kl.',
	    ago_suffix: 'siden',
	    school_year: 'Skoleår'
	  },
	  en: {
	    absence_requests: 'Absence requests',
	    created: 'Created',
	    who: 'Who',
	    from: 'From',
	    to: 'To',
	    reason: 'Reason',
	    note: 'Note',
	    note_back: 'Reply note',
	    answered_by: 'Answered by',
	    status: 'Status',
	    tab_requested: 'Pending',
	    tab_approved: 'Approved',
	    tab_rejected: 'Rejected',
	    empty_requested: 'No new requests',
	    empty_approved: 'No approved requests',
	    empty_rejected: 'No rejected requests',
	    answer: 'Answer',
	    pending: 'Pending',
	    approved: 'Approved',
	    rejected: 'Rejected',
	    at_time_cap: 'At',
	    at_time_lower: 'at',
	    ago_suffix: 'ago',
	    school_year: 'School year'
	  },
	  nb: {
	    absence_requests: 'Fraværsforespørsler',
	    created: 'Opprettet',
	    who: 'Hvem',
	    from: 'Fra',
	    to: 'Til',
	    reason: 'Årsak',
	    note: 'Merknad',
	    note_back: 'Svarmerknad',
	    answered_by: 'Besvart av',
	    status: 'Status',
	    tab_requested: 'Venter svar',
	    tab_approved: 'Godkjente',
	    tab_rejected: 'Avviste',
	    empty_requested: 'Ingen nye forespørsler',
	    empty_approved: 'Ingen godkjente forespørsler',
	    empty_rejected: 'Ingen avviste forespørsler',
	    answer: 'Svar',
	    pending: 'Venter svar',
	    approved: 'Godkjent',
	    rejected: 'Avvist',
	    at_time_cap: 'Kl.',
	    at_time_lower: 'kl.',
	    ago_suffix: 'siden',
	    school_year: 'Skoleår'
	  }
	};
	
	exports.default = {
	  components: { UserRequestForm: _UserRequestForm2.default, UserRequest: _UserRequest2.default, Loader: _Loader2.default, Tabs: _Tabs2.default, UserRequestListAnswer: _UserRequestListAnswer2.default, DoFiltersFilter: _DoFiltersFilter2.default },
	  props: {
	    isUserView: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      requests: [],
	      isLoadingSubjects: false,
	      subjects: [],
	      theEditRequest: null,
	      theAnswerRequest: null,
	      selectedTab: 'requested',
	      sortBy: 'created_at',
	      sortDir: 'desc',
	      selectedSchoolYears: []
	    };
	  },
	  created: function created() {
	    this.restoreSort();
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['schoolId', 'allUsersInHash', 'locale']), {
	    activeSchoolYears: function activeSchoolYears() {
	      return (this.$store.state.activeSchoolYears || []).slice().sort(function (a, b) {
	        return (0, _moment2.default)(b.student_time_start || b.employee_time_start).valueOf() - (0, _moment2.default)(a.student_time_start || a.employee_time_start).valueOf();
	      });
	    },
	    schoolYearTags: function schoolYearTags() {
	      return this.activeSchoolYears.map(function (year) {
	        return year.name;
	      });
	    },
	    i18n: function i18n() {
	      return I18N[this.locale] || I18N['da'];
	    },
	    emptyTableTitle: function emptyTableTitle() {
	      if (this.selectedTab === 'requested') {
	        return this.i18n['empty_requested'];
	      }
	      if (this.selectedTab === 'approved') {
	        return this.i18n['empty_approved'];
	      }
	      if (this.selectedTab === 'rejected') {
	        return this.i18n['empty_rejected'];
	      }
	    },
	    tabs: function tabs() {
	      return [{ id: 'requested', title: this.i18n['tab_requested'] }, { id: 'approved', title: this.i18n['tab_approved'] }, { id: 'rejected', title: this.i18n['tab_rejected'] }];
	    },
	    filteredRequests: function filteredRequests() {
	      var _this = this;
	
	      var tabRequests = this.requests.filter(function (r) {
	        return r.state === _this.selectedTab;
	      });
	      if (this.selectedSchoolYears.length === 0) {
	        return tabRequests;
	      }
	      var selectedYears = this.activeSchoolYears.filter(function (year) {
	        return _this.selectedSchoolYears.indexOf(year.name) > -1;
	      });
	      return tabRequests.filter(function (request) {
	        return selectedYears.some(function (year) {
	          return _this.requestInSchoolYear(request, year);
	        });
	      });
	    },
	    formattedRequests: function formattedRequests() {
	      var _this2 = this;
	
	      return this.filteredRequests.map(function (r) {
	        var created = (0, _moment2.default)(r.created_at);
	        var start = (0, _moment2.default)(r.start_time);
	        var end = (0, _moment2.default)(r.end_time);
	
	        return (0, _extends3.default)({}, r, {
	          vCreated: created.format('ll [' + _this2.i18n['at_time_cap'] + '] LT'),
	          vCreatedTimeAgo: _moment2.default.duration((0, _moment2.default)().diff(created)).humanize() + ' ' + _this2.i18n['ago_suffix'],
	          vUserName: _this2.allUsersInHash[r.request_by_id] ? _this2.allUsersInHash[r.request_by_id]['name'] : r.request_by_id,
	          vSubjectTitle: _this2.getSubjectTitle(r.subject_id),
	          vStart: start.format('ll LT'),
	          vEnd: end.format('ll [' + _this2.i18n['at_time_lower'] + '] LT'),
	          vResponderName: _this2.allUsersInHash[r.respond_by_id] ? _this2.allUsersInHash[r.respond_by_id]['name'] : r.respond_by_id
	        });
	      });
	    },
	    sortedRequests: function sortedRequests() {
	      var _this3 = this;
	
	      var dir = this.sortDir === 'asc' ? 1 : -1;
	      var key = this.sortBy;
	      var locale = this.locale || 'da';
	
	      return this.formattedRequests.slice().sort(function (a, b) {
	        var va = _this3.getSortValue(a, key);
	        var vb = _this3.getSortValue(b, key);
	
	        if (DATE_SORT_KEYS[key]) {
	          return (va - vb) * dir;
	        }
	
	        if (typeof va === 'string' || typeof vb === 'string') {
	          return String(va || '').localeCompare(String(vb || ''), locale, { sensitivity: 'base' }) * dir;
	        }
	
	        if (va < vb) return -1 * dir;
	        if (va > vb) return 1 * dir;
	        return 0;
	      });
	    }
	  }),
	  watch: {
	    schoolId: {
	      immediate: true,
	      handler: function handler() {
	        this.readRequests();
	        this.readSubjects();
	      }
	    }
	  },
	  methods: {
	    toggleSchoolYear: function toggleSchoolYear(yearName) {
	      var idx = this.selectedSchoolYears.indexOf(yearName);
	      if (idx < 0) {
	        this.selectedSchoolYears.push(yearName);
	      } else {
	        this.selectedSchoolYears.splice(idx, 1);
	      }
	    },
	    requestInSchoolYear: function requestInSchoolYear(request, year) {
	      var start = year.employee_time_start || year.student_time_start;
	      var end = year.employee_time_end || year.student_time_end;
	      if (!start || !end || !request.start_time) {
	        return true;
	      }
	      var requestStart = (0, _moment2.default)(request.start_time);
	      return requestStart.isSameOrAfter((0, _moment2.default)(start).startOf('day')) && requestStart.isSameOrBefore((0, _moment2.default)(end).endOf('day'));
	    },
	    setTheEditRequest: function setTheEditRequest(request) {
	      if (!this.isUserView || request.state !== 'requested') {
	        return;
	      }
	      this.theEditRequest = request;
	    },
	    getSubjectTitle: function getSubjectTitle(subjectId) {
	      var subject = this.subjects.find(function (subject) {
	        return subject.id * 1 === subjectId * 1;
	      });
	      return subject ? subject.name : subjectId;
	    },
	    getSortValue: function getSortValue(request, key) {
	      if (DATE_SORT_KEYS[key]) {
	        var _value = request[key];
	        return _value ? (0, _moment2.default)(_value).valueOf() : 0;
	      }
	      var value = request[key];
	      return value == null ? '' : value;
	    },
	    setSort: function setSort(key) {
	      if (SORTABLE_KEYS.indexOf(key) === -1) {
	        return;
	      }
	      if (this.sortBy === key) {
	        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
	      } else {
	        this.sortBy = key;
	        this.sortDir = key === 'created_at' ? 'desc' : 'asc';
	      }
	      this.persistSort();
	    },
	    persistSort: function persistSort() {
	      try {
	        window.localStorage.setItem(SORT_STORAGE_KEY, (0, _stringify2.default)({
	          sortBy: this.sortBy,
	          sortDir: this.sortDir
	        }));
	      } catch (e) {}
	    },
	    restoreSort: function restoreSort() {
	      try {
	        var raw = window.localStorage.getItem(SORT_STORAGE_KEY);
	        if (!raw) return;
	        var saved = JSON.parse(raw);
	        if (!saved) return;
	        if (SORTABLE_KEYS.indexOf(saved.sortBy) > -1) {
	          this.sortBy = saved.sortBy;
	        }
	        if (saved.sortDir === 'asc' || saved.sortDir === 'desc') {
	          this.sortDir = saved.sortDir;
	        }
	      } catch (e) {}
	    },
	    readRequests: function readRequests() {
	      var _this4 = this;
	
	      if (!this.schoolId) {
	        return;
	      }
	      this.isLoading = true;
	      _docendo2.default.listRequests(this.schoolId, function (success) {
	        _this4.requests = success;
	        _this4.isLoading = false;
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    readSubjects: function readSubjects() {
	      var _this5 = this;
	
	      this.isLoadingSubjects = true;
	      _docendo2.default.schoolAbsenceSubjectsList(this.schoolId, true, function (success) {
	        _this5.isLoadingSubjects = false;
	        _this5.subjects = success;
	      }, function (failure) {
	        console.log('something went wrong');
	      });
	    },
	    onSubmittedAnswer: function onSubmittedAnswer() {
	      this.readRequests();
	    },
	    onCloseAnswerRequest: function onCloseAnswerRequest() {
	      this.theAnswerRequest = null;
	    }
	  }
	};

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(28);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _vuex = __webpack_require__(14);
	
	var _UserAbsence = __webpack_require__(149);
	
	var _UserAbsence2 = _interopRequireDefault(_UserAbsence);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _TimeChanger = __webpack_require__(31);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _UserRequestAbsenceSidebar = __webpack_require__(1684);
	
	var _UserRequestAbsenceSidebar2 = _interopRequireDefault(_UserRequestAbsenceSidebar);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    answer_absence_request: 'Besvar fraværsanmodning',
	    absence_reason: 'Fraværsårsag',
	    date: 'Dato',
	    time: 'Tid',
	    reply_note: 'Note til besvarelsen',
	    reject: 'Afvis',
	    approve: 'Godkend',
	    show_absent: 'Vis fraværende',
	    toast_updated: 'Fraværsanmodning opdateret'
	  },
	  en: {
	    answer_absence_request: 'Answer absence request',
	    absence_reason: 'Absence reason',
	    date: 'Date',
	    time: 'Time',
	    reply_note: 'Reply note',
	    reject: 'Reject',
	    approve: 'Approve',
	    show_absent: 'Show absent',
	    toast_updated: 'Absence request updated'
	  },
	  nb: {
	    answer_absence_request: 'Svar på fraværsforespørsel',
	    absence_reason: 'Fraværsårsak',
	    date: 'Dato',
	    time: 'Tid',
	    reply_note: 'Svarmerknad',
	    reject: 'Avvis',
	    approve: 'Godkjenn',
	    show_absent: 'Vis fraværende',
	    toast_updated: 'Fraværsforespørsel oppdatert'
	  }
	};
	
	exports.default = {
	  components: { DModal: _DModal2.default, UserAbsence: _UserAbsence2.default, AppToggle: _AppToggle2.default, DatepickerRange: _DatePickerRange2.default, TimeChanger: _TimeChanger2.default, UserRequestAbsenceSidebar: _UserRequestAbsenceSidebar2.default },
	  props: {
	    request: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      note: '',
	      isLoadingApprove: false,
	      isLoadingRejected: false,
	      subjectId: null,
	      useTime: false,
	      useTimeBeforeTimeEdit: false,
	      wholeDayToastTimer: null,
	      initStartDate: (0, _moment2.default)(),
	      initEndDate: (0, _moment2.default)(),
	      startDate: (0, _moment2.default)(),
	      endDate: (0, _moment2.default)(),
	      startTime: (0, _moment2.default)().set({ hour: 8, minutes: 0 }),
	      endTime: (0, _moment2.default)().set({ hour: 16, minutes: 0 }),
	      isOngoing: false,
	      isShowAbsenceSidebar: window.innerWidth > 760,
	      selectedEmploymentId: null,
	      selectedAdditionalData: '',
	      opusAbsenceCodes: [],
	      sdAbsenceCodes: [],
	      additionalDataOptions: [],
	      additionalDataError: null,
	      isLoadingAdditionalData: false,
	      hasLoadedAdditionalData: false,
	      absenceSubjects: [],
	      showValidationErrors: false
	    };
	  },
	
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        el.focus();
	        el.select();
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['schoolId', 'locale', 'employmentsInUserIdHash']), {
	    selectedSubject: function selectedSubject() {
	      var _this = this;
	
	      return this.subjectId ? this.absenceSubjects.find(function (subject) {
	        return subject.id === _this.subjectId;
	      }) || null : null;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale] || I18N['da'];
	    },
	    isOpusAbsenceActivated: function isOpusAbsenceActivated() {
	      return this.$store.getters.schoolFeatures && this.$store.getters.schoolFeatures.indexOf('kmd_absence') > -1;
	    },
	    isSDIntegrationActive: function isSDIntegrationActive() {
	      return this.$store.getters.schoolFeatures && this.$store.getters.schoolFeatures.indexOf('silkeborg_data_integration') > -1;
	    },
	    isShowOpusInfoBox: function isShowOpusInfoBox() {
	      return this.isOpusAbsenceActivated && this.selectedSubject && this.selectedSubject.kmd_absence_code_id;
	    },
	    isShowSdInfoBox: function isShowSdInfoBox() {
	      return !!(this.isSDIntegrationActive && this.selectedSubject && this.selectedSubject.sd_absence_code_id);
	    },
	    isShowSalaryInfoBox: function isShowSalaryInfoBox() {
	      return this.isShowOpusInfoBox || this.isShowSdInfoBox;
	    },
	    getSDAbsence: function getSDAbsence() {
	      if (!this.selectedSubject || !this.selectedSubject.sd_absence_code_id) {
	        return null;
	      }
	      var sdAbsenceId = this.selectedSubject.sd_absence_code_id;
	      var absenceCodes = this.sdAbsenceCodes || [];
	      if (!Array.isArray(absenceCodes) || absenceCodes.length < 1) {
	        return null;
	      }
	      var match = absenceCodes.find(function (code) {
	        return String(code.id) === String(sdAbsenceId);
	      });
	      return match || null;
	    },
	    isSdOngoingAllowed: function isSdOngoingAllowed() {
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var now = (0, _moment2.default)().format('YYYY-MM-DD');
	      return (0, _moment2.default)(endDate).isSameOrAfter(now);
	    },
	    getOPUSAbsence: function getOPUSAbsence() {
	      if (!this.selectedSubject || !this.selectedSubject.kmd_absence_code_id) {
	        return null;
	      }
	      var opusAbsenceId = this.selectedSubject.kmd_absence_code_id;
	      var absenceCodes = this.opusAbsenceCodes || [];
	      if (!Array.isArray(absenceCodes) || absenceCodes.length < 1) {
	        return null;
	      }
	      var match = absenceCodes.find(function (code) {
	        return String(code.id) === String(opusAbsenceId);
	      });
	      return match || null;
	    },
	    isOpusAllowOpen: function isOpusAllowOpen() {
	      if (!this.isOpusAbsenceActivated || !this.selectedSubject || !this.selectedSubject.kmd_absence_code_id) {
	        return false;
	      }
	      var opusAbsence = this.getOPUSAbsence;
	      if (!opusAbsence || typeof opusAbsence.allow_open === 'undefined') {
	        return false;
	      }
	      return opusAbsence.allow_open === true;
	    },
	    userEmployments: function userEmployments() {
	      if (!this.request || !this.request.request_by_id) {
	        return [];
	      }
	      var employments = this.employmentsInUserIdHash[this.request.request_by_id] || [];
	      return employments.filter(function (emp) {
	        return emp.employment_number && String(emp.employment_number).trim() !== '';
	      });
	    },
	    isShowExtraInformation: function isShowExtraInformation() {
	      var opusAbsence = this.getOPUSAbsence;
	      if (!opusAbsence || !opusAbsence.additional_data) {
	        return false;
	      }
	      return this.selectedEmploymentId !== null;
	    },
	    additionalData: function additionalData() {
	      if (!this.isShowExtraInformation || !this.selectedAdditionalData) {
	        return null;
	      }
	      return this.selectedAdditionalData;
	    },
	    isEmploymentValid: function isEmploymentValid() {
	      if (!this.isShowSalaryInfoBox) {
	        return true;
	      }
	
	      if (this.userEmployments.length > 0) {
	        return this.selectedEmploymentId !== null;
	      }
	      return true;
	    },
	    isAdditionalDataValid: function isAdditionalDataValid() {
	      if (!this.isShowExtraInformation) {
	        return true;
	      }
	
	      var opusAbsence = this.getOPUSAbsence;
	      if (opusAbsence && opusAbsence.additional_data_required) {
	        return this.selectedAdditionalData !== '';
	      }
	      return true;
	    },
	    isSalaryFormValid: function isSalaryFormValid() {
	      return this.isEmploymentValid && this.isAdditionalDataValid;
	    },
	    dbEventStart: function dbEventStart() {
	      var date = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var time = this.startTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    dbEventEnd: function dbEventEnd() {
	      var date = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var time = this.endTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    }
	  }),
	  watch: {
	    request: {
	      immediate: true,
	      handler: function handler(val) {
	        if (val) {
	          this.startDate = (0, _moment2.default)(val.start_time);
	          this.endDate = (0, _moment2.default)(val.end_time);
	          this.initStartDate = (0, _moment2.default)(val.start_time);
	          this.initEndDate = (0, _moment2.default)(val.end_time);
	          this.startTime = (0, _moment2.default)(val.start_time);
	          this.endTime = (0, _moment2.default)(val.end_time);
	        }
	      }
	    },
	    selectedSubject: function selectedSubject(newValue, oldValue) {
	      if (newValue !== oldValue) {
	        this.resetOpusFields();
	        this.autoSelectSingleEmployment();
	        if (oldValue) {
	          this.isOngoing = !!(newValue && newValue.default_ongoing && (this.isOpusAllowOpen || this.isShowSdInfoBox && this.isSdOngoingAllowed));
	        }
	      }
	    },
	    isShowExtraInformation: function isShowExtraInformation(newValue) {
	      if (newValue) {
	        this.fetchAdditionalDataForAbsence();
	      } else {
	        this.additionalDataOptions = [];
	        this.selectedAdditionalData = '';
	        this.hasLoadedAdditionalData = false;
	        this.additionalDataError = null;
	      }
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      this.autoSelectSingleEmployment();
	    }
	  },
	  methods: {
	    approveRequest: function approveRequest() {
	      var _this2 = this;
	
	      if (!this.isSalaryFormValid) {
	        this.showValidationErrors = true;
	        return;
	      }
	      this.showValidationErrors = false;
	      this.isLoadingApprove = true;
	      var schoolId = this.request.school_id;
	      var id = this.request.id;
	      var responseNote = this.note;
	      var internalNote = '';
	      var employmentId = this.selectedEmploymentId;
	      var useTime = this.useTime;
	      var additionalData = this.additionalData;
	      var ongoing = (this.isOpusAllowOpen || this.isShowSdInfoBox && this.isSdOngoingAllowed) && this.isOngoing;
	      var startTime = this.dbEventStart;
	      var endTime = this.dbEventEnd;
	      _docendo2.default.approveRequest(schoolId, id, responseNote, this.subjectId, internalNote, employmentId, useTime, additionalData, ongoing, startTime, endTime, function (response) {
	        if (response && response.success === false) {
	          var errorMessage = response.data && response.data.error || response.error || 'Der opstod en fejl ved godkendelse';
	          _this2.showToast(errorMessage, false);
	          _this2.isLoadingApprove = false;
	          return;
	        }
	        _this2.requestDone(response);
	      }, function (error) {
	        var errorMessage = error && error.data && error.data.error || error && error.error || 'Der opstod en fejl ved godkendelse';
	        _this2.showToast(errorMessage, false);
	        _this2.isLoadingApprove = false;
	      });
	    },
	    rejectRequest: function rejectRequest() {
	      var _this3 = this;
	
	      this.isLoadingRejected = true;
	      var schoolId = this.request.school_id;
	      var id = this.request.id;
	      var responseNote = this.note;
	      _docendo2.default.rejectRequest(schoolId, id, responseNote, function (success) {
	        _this3.requestDone(success);
	      }, function (failure) {
	        _this3.requestDone();
	      });
	    },
	    requestDone: function requestDone(resp) {
	      this.isLoadingApprove = false;
	      this.isLoadingRejected = false;
	      if (resp && resp.status === 'error') {
	        this.showToast(resp.message, false);
	      } else {
	        this.$emit('close');
	      }
	      this.$emit('submitted');
	    },
	    showToast: function showToast(message, success) {
	      _eventbus2.default.toast = { text: message, success: success };
	    },
	    formatTime: function formatTime(dateTime) {
	      return (0, _moment2.default)(dateTime).format('HH:mm');
	    },
	    updateRequestSubject: function updateRequestSubject(subject) {
	      this.subjectId = subject.id;
	    },
	    setStartDate: function setStartDate(payload) {
	      this.startDate = payload;
	    },
	    setEndDate: function setEndDate(payload) {
	      var newEnd = (0, _moment2.default)(payload).format('YYYY-MM-DD');
	      var previousEnd = this.endDate ? (0, _moment2.default)(this.endDate).format('YYYY-MM-DD') : null;
	      this.endDate = payload;
	      var now = (0, _moment2.default)().format('YYYY-MM-DD');
	      if (previousEnd && newEnd !== previousEnd && !(0, _moment2.default)(newEnd).isAfter(now)) {
	        this.isOngoing = false;
	      }
	    },
	    setStartTime: function setStartTime(payload) {
	      this.startTime = payload;
	      this.syncWholeDayWithStandardTimes();
	    },
	    setEndTime: function setEndTime(payload) {
	      this.endTime = payload;
	      this.syncWholeDayWithStandardTimes();
	    },
	    syncWholeDayWithStandardTimes: function syncWholeDayWithStandardTimes() {
	      var userSettings = this.$store.state.userSettings;
	      var saved = userSettings && userSettings.subSettingsCreateTime;
	      var standardStart = saved ? (0, _moment2.default)(saved.start).format('HH:mm') : '08:00';
	      var standardEnd = saved ? (0, _moment2.default)(saved.end).format('HH:mm') : '16:00';
	      var isStandardStart = (0, _moment2.default)(this.startTime).format('HH:mm') === standardStart;
	      var isStandardEnd = (0, _moment2.default)(this.endTime).format('HH:mm') === standardEnd;
	      if (this.wholeDayToastTimer === null) {
	        this.useTimeBeforeTimeEdit = this.useTime;
	      }
	      this.useTime = !(isStandardStart && isStandardEnd);
	      this.notifyWholeDayChange();
	    },
	    notifyWholeDayChange: function notifyWholeDayChange() {
	      var _this4 = this;
	
	      clearTimeout(this.wholeDayToastTimer);
	      this.wholeDayToastTimer = setTimeout(function () {
	        _this4.wholeDayToastTimer = null;
	        if (_this4.isShowSalaryInfoBox && _this4.useTime !== _this4.useTimeBeforeTimeEdit) {
	          _eventbus2.default.toast = { text: _this4.useTime ? '"Indberet som hel dag" er slået fra' : '"Indberet som hel dag" er slået til', success: true };
	        }
	      }, 800);
	    },
	    onEmploymentChange: function onEmploymentChange() {
	      var _this5 = this;
	
	      this.selectedAdditionalData = '';
	      this.additionalDataOptions = [];
	      this.hasLoadedAdditionalData = false;
	      this.additionalDataError = null;
	
	      this.$nextTick(function () {
	        if (_this5.isShowExtraInformation) {
	          _this5.fetchAdditionalDataForAbsence();
	        }
	      });
	    },
	    autoSelectSingleEmployment: function autoSelectSingleEmployment() {
	      if (!this.isShowSalaryInfoBox) {
	        return;
	      }
	      var employments = this.userEmployments;
	      if (employments.length === 1 && !this.selectedEmploymentId) {
	        this.selectedEmploymentId = employments[0].id;
	      }
	    },
	    resetOpusFields: function resetOpusFields() {
	      this.useTime = false;
	      this.isOngoing = false;
	      this.selectedEmploymentId = null;
	      this.additionalDataOptions = [];
	      this.selectedAdditionalData = '';
	      this.hasLoadedAdditionalData = false;
	      this.additionalDataError = null;
	    },
	    listKmdOpusAbsenceCodes: function listKmdOpusAbsenceCodes() {
	      var _this6 = this;
	
	      _docendo2.default.listKmdOpusAbsenceCodes(this.schoolId, function (success) {
	        _this6.opusAbsenceCodes = Array.isArray(success) ? success : [];
	      }, function (failure) {
	        _this6.opusAbsenceCodes = [];
	      });
	    },
	    listSdAbsenceCodes: function listSdAbsenceCodes() {
	      var _this7 = this;
	
	      _docendo2.default.listSilkeborgDataAbsenceCodes(this.schoolId, function (success) {
	        _this7.sdAbsenceCodes = Array.isArray(success) ? success : success && Array.isArray(success.data) ? success.data : [];
	      }, function (failure) {
	        _this7.sdAbsenceCodes = [];
	      });
	    },
	    fetchAdditionalDataForAbsence: function fetchAdditionalDataForAbsence() {
	      var _this8 = this;
	
	      if (!this.isShowExtraInformation) {
	        this.additionalDataOptions = [];
	        this.selectedAdditionalData = '';
	        return;
	      }
	      var opusAbsence = this.getOPUSAbsence;
	      if (!opusAbsence) return;
	      if (!this.selectedEmploymentId) return;
	
	      this.isLoadingAdditionalData = true;
	      this.hasLoadedAdditionalData = false;
	      this.additionalDataOptions = [];
	      this.selectedAdditionalData = '';
	
	      _docendo2.default.listAdditionalDataForAbsence(this.schoolId, this.selectedEmploymentId, opusAbsence.id, (0, _moment2.default)(this.startDate).format('YYYY-MM-DD'), (0, _moment2.default)(this.endDate).format('YYYY-MM-DD'), function (response) {
	        if (response && response.success === false) {
	          _this8.additionalDataOptions = [];
	          _this8.additionalDataError = response.data && response.data.error || response.error || 'Der opstod en fejl';
	          _this8.isLoadingAdditionalData = false;
	          _this8.hasLoadedAdditionalData = true;
	          return;
	        }
	        if (response && response.error) {
	          _this8.additionalDataOptions = [];
	          _this8.additionalDataError = response.error;
	          _this8.isLoadingAdditionalData = false;
	          _this8.hasLoadedAdditionalData = true;
	          return;
	        }
	        if (response && response.data && response.data.error) {
	          _this8.additionalDataOptions = [];
	          _this8.additionalDataError = response.data.error;
	          _this8.isLoadingAdditionalData = false;
	          _this8.hasLoadedAdditionalData = true;
	          return;
	        }
	        _this8.additionalDataError = null;
	
	        var parsedData = response;
	        if (response && response.response && typeof response.response === 'string') {
	          try {
	            parsedData = JSON.parse(response.response);
	          } catch (e) {
	            console.error('Failed to parse response.response', e);
	          }
	        }
	        var cases = null;
	        if (parsedData && parsedData.Body) {
	          if (opusAbsence.additional_data === 'Maternity') {
	            cases = parsedData.Body.GetMaternityCasesResponse_MT && parsedData.Body.GetMaternityCasesResponse_MT.MaternityCase;
	          } else if (opusAbsence.additional_data === 'Reason') {
	            var reasonsResponse = parsedData.Body.GetReasonsResponse_MT || parsedData.Body.GetReasonsResponse_RT;
	            cases = reasonsResponse && reasonsResponse.Reason;
	          } else if (opusAbsence.additional_data === 'WorkInjury') {
	            cases = parsedData.Body.GetWorkAccidentCasesResponse_MT && parsedData.Body.GetWorkAccidentCasesResponse_MT.AccidentCase;
	          } else if (opusAbsence.additional_data === 'Child') {
	            cases = parsedData.Body.GetChildrenResponse_MT && parsedData.Body.GetChildrenResponse_MT.Child;
	          }
	        }
	
	        if (Array.isArray(cases)) {
	          _this8.additionalDataOptions = cases;
	        } else if (cases && cases.Item) {
	          _this8.additionalDataOptions = Array.isArray(cases.Item) ? cases.Item : [cases.Item];
	        } else if (cases && (typeof cases === 'undefined' ? 'undefined' : (0, _typeof3.default)(cases)) === 'object') {
	          _this8.additionalDataOptions = [cases];
	        } else {
	          _this8.additionalDataOptions = [];
	        }
	
	        if (_this8.additionalDataOptions.length === 1) {
	          var singleOption = _this8.additionalDataOptions[0];
	          var additionalDataType = opusAbsence.additional_data;
	          if (additionalDataType === 'Maternity' && singleOption.MaternityCaseKey) {
	            _this8.selectedAdditionalData = singleOption.MaternityCaseKey;
	          } else if (additionalDataType === 'Reason' && singleOption.ReasonCode) {
	            _this8.selectedAdditionalData = singleOption.ReasonCode;
	          } else if (additionalDataType === 'WorkInjury' && singleOption.AccidentNumber) {
	            _this8.selectedAdditionalData = singleOption.AccidentNumber;
	          } else if (additionalDataType === 'Child' && singleOption.ChildNumber) {
	            _this8.selectedAdditionalData = singleOption.ChildNumber;
	          }
	        }
	        _this8.isLoadingAdditionalData = false;
	        _this8.hasLoadedAdditionalData = true;
	      }, function (error) {
	        _this8.additionalDataOptions = [];
	        if (error && error.data && error.data.error) {
	          _this8.additionalDataError = error.data.error;
	        } else if (error && error.error) {
	          _this8.additionalDataError = error.error;
	        } else {
	          _this8.additionalDataError = 'Der opstod en fejl ved hentning af data';
	        }
	        _this8.isLoadingAdditionalData = false;
	        _this8.hasLoadedAdditionalData = true;
	      });
	    },
	    readSubjects: function readSubjects() {
	      var _this9 = this;
	
	      _docendo2.default.schoolAbsenceSubjectsList(this.schoolId, false, function (success) {
	        _this9.absenceSubjects = success;
	      }, function (failure) {
	        console.log('something went wrong');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readSubjects();
	    this.subjectId = this.request.subject_id;
	    if (this.isOpusAbsenceActivated || this.isSDIntegrationActive) {
	      this.$store.dispatch('readEmployments');
	    }
	    if (this.isOpusAbsenceActivated) {
	      this.listKmdOpusAbsenceCodes();
	    }
	    if (this.isSDIntegrationActive) {
	      this.listSdAbsenceCodes();
	    }
	  }
	};

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'direct-day-selector',
	  description: 'Can list individual days of a date range in month rows.\n' + 'Each day can be selected, this emits two events:\n' + ' "toggled" : has the date and whether it is selected\n' + ' "updated" : has counts and a list of selected dates\n',
	  props: {
	    fromDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      },
	
	      validator: function validator(value) {
	        return (0, _moment2.default)(value).isValid();
	      }
	    },
	    toDate: {
	      default: function _default() {
	        return (0, _moment2.default)().add(1, 'month');
	      },
	
	      validator: function validator(value) {
	        return (0, _moment2.default)(value).isValid();
	      }
	    },
	    selectedDays: {
	      default: function _default() {
	        return [];
	      },
	
	      type: Array
	    },
	    includeWeekends: {
	      default: function _default() {
	        return false;
	      },
	
	      type: Boolean
	    }
	  },
	  data: function data() {
	    return {
	      dates: [],
	      datesInMonths: [],
	      checked: false
	    };
	  },
	
	  watch: {
	    fromDate: function fromDate(newVal, oldVal) {
	      this.updateDates();
	    },
	    toDate: function toDate(newVal, oldVal) {
	      this.updateDates();
	    },
	    includeWeekends: function includeWeekends(newVal, oldVal) {
	      this.updateDates();
	    },
	    selectedDays: function selectedDays(newVal, oldVal) {
	      this.updateDates();
	    }
	  },
	  computed: {
	    totalDaysCount: function totalDaysCount() {
	      return this.dates.length;
	    },
	    selectableDaysCount: function selectableDaysCount() {
	      return this.dates.filter(function (date) {
	        return date.isSelectable;
	      }).length;
	    },
	    selectedDaysCount: function selectedDaysCount() {
	      var self = this;
	      return this.selectedDays.filter(function (date) {
	        return self.fromDate <= (0, _moment2.default)(date) && (0, _moment2.default)(date) <= self.toDate;
	      }).length;
	    }
	  },
	  methods: {
	    updateDates: function updateDates() {
	      var _this = this;
	
	      this.datesInMonths = [];
	      this.dates = [];
	      if (this.fromDate < this.toDate) {
	        var theDate = this.fromDate.clone().startOf('month');
	
	        var _loop = function _loop() {
	          var thisDate = theDate.clone().endOf('day');
	          if (theDate.format('D') === '1') {
	            var monthObj = { month: (0, _moment2.default)(theDate.format('YYYY-MM')), dates: [] };
	            _this.datesInMonths.push(monthObj);
	          }
	          thisDate.simpleDate = thisDate.format('YYYY-MM-DD');
	          thisDate.isWeekend = _this.isWeekend(thisDate);
	          thisDate.isInRange = _this.isInRange(thisDate);
	          thisDate.isSelectable = _this.includeWeekends ? thisDate.isInRange : !thisDate.isWeekend && thisDate.isInRange;
	
	          thisDate.isSelected = thisDate.isSelectable && _this.selectedDays.indexOf(thisDate.simpleDate) > -1;
	          var idx = _this.datesInMonths.findIndex(function (month) {
	            return (0, _moment2.default)(month.month).format('YYYY-MM') === thisDate.format('YYYY-MM');
	          });
	          _this.datesInMonths[idx].dates.push(thisDate);
	          theDate.add(1, 'days');
	        };
	
	        while (theDate.clone().endOf('day') <= this.toDate.clone().endOf('month')) {
	          _loop();
	        }
	      }
	      this.sendUpdate();
	    },
	    isInRange: function isInRange(date) {
	      return date.isBetween(this.fromDate.clone().startOf('day'), this.toDate.clone().endOf('day'), null, '[]');
	    },
	    isWeekend: function isWeekend(date) {
	      return date.isoWeekday() === 6 || date.isoWeekday() === 7;
	    },
	    isSelected: function isSelected(date) {
	      return date.isSelected;
	    },
	    toggle: function toggle(date) {
	      if (date.isSelectable) {
	        date.isSelected = !date.isSelected;
	        if (!this.isDateSelected(date)) {
	          this.selectedDays.push(date.simpleDate);
	        } else {
	          var index = this.selectedDays.indexOf(date.simpleDate);
	          this.selectedDays.splice(index, 1);
	        }
	        this.sendToggle(date, date.isSelected);
	      }
	    },
	    sendToggle: function sendToggle(date, isSelected) {
	      this.$emit('toggled', date.simpleDate, isSelected);
	    },
	    sendUpdate: function sendUpdate() {
	      this.$emit('updated', {
	        selectedDays: this.selectedDays,
	        totalDaysCount: this.totalDaysCount,
	        selectableDaysCount: this.selectableDaysCount,
	        selectedDaysCount: this.selectedDaysCount
	      });
	    },
	    isDateSelected: function isDateSelected(date) {
	      return this.selectedDays.indexOf((0, _moment2.default)(date).format('YYYY-MM-DD')) > -1;
	    }
	  },
	  mounted: function mounted() {
	    this.updateDates();
	  }
	};

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DirectDaySelector = __webpack_require__(152);
	
	var _DirectDaySelector2 = _interopRequireDefault(_DirectDaySelector);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'vacation-day-selector',
	  components: {
	    DirectDaySelector: _DirectDaySelector2.default, DatePickerRange: _DatePickerRange2.default
	  },
	  props: {
	    initialYear: {
	      type: String,
	      default: '2018-2019'
	    },
	    schoolId: {
	      type: Number,
	      default: 3
	    },
	    emitEventOnLoad: {
	      type: Boolean,
	      default: true
	    },
	    fromDate: {
	      default: function _default() {
	        return (0, _moment2.default)('2016-08-08T12:00');
	      },
	      validator: function validator(value) {
	        return (0, _moment2.default)(value).isValid();
	      }
	    },
	    toDate: {
	      default: function _default() {
	        return (0, _moment2.default)('2017-06-23T12:00');
	      },
	      validator: function validator(value) {
	        return (0, _moment2.default)(value).isValid();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      initialSelectedDates: [],
	      vacationDays: {},
	      schoolYears: [],
	      activeSchoolYears: [],
	      selectedSchoolYearIndex: 0,
	      currFromDate: this.fromDate,
	      currToDate: this.toDate,
	      includeWeekends: false
	    };
	  },
	
	  watch: {
	    schoolDaysCount: function schoolDaysCount(val) {
	      this.$emit('schoolDays', val);
	    }
	  },
	  mounted: function mounted() {
	    _docendo2.default.schoolYearsRead(this.schoolId, {}, 'name', this.schoolYearsCallback);
	    _docendo2.default.schoolVacationDaysRead(this.schoolId, this.initialDaysCallback);
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      if (window.SCHOOL && window.SCHOOL.id) {
	        return window.SCHOOL.id;
	      }
	      if (this.$route && this.$route.params && this.$route.params.school_id) {
	        return this.$route.params.school_id;
	      }
	    },
	    isKindergarten: function isKindergarten() {
	      return this.$store.getters.isKindergarten;
	    },
	    vacationDaysBetweenStartAndEnd: function vacationDaysBetweenStartAndEnd() {
	      var _this = this;
	
	      return this.initialSelectedDates.filter(function (date) {
	        return (0, _moment2.default)(date).isSameOrBefore(_this.currToDate) && (0, _moment2.default)(date).isSameOrAfter(_this.currFromDate);
	      });
	    },
	    vacationDaysWithoutWeekends: function vacationDaysWithoutWeekends() {
	      return this.vacationDaysBetweenStartAndEnd.filter(function (date) {
	        if ((0, _moment2.default)(date).isoWeekday() !== 6 && (0, _moment2.default)(date).isoWeekday() !== 7) {
	          return date;
	        }
	      });
	    },
	    allDates: function allDates() {
	      var startDate = this.currFromDate;
	      var dateArray = [];
	      var currentDate = (0, _moment2.default)(startDate);
	      var stopDate = (0, _moment2.default)(this.currToDate);
	      while (currentDate <= stopDate) {
	        dateArray.push((0, _moment2.default)(currentDate).format('YYYY-MM-DD'));
	        currentDate = (0, _moment2.default)(currentDate).add(1, 'days');
	      }
	      return dateArray;
	    },
	    weekends: function weekends() {
	      return this.allDates.filter(function (date) {
	        if ((0, _moment2.default)(date).isoWeekday() === 6 || (0, _moment2.default)(date).isoWeekday() === 7) {
	          return date;
	        }
	      });
	    },
	    newCount: function newCount() {
	      return this.currToDate.diff(this.currFromDate, 'days') + 1;
	    },
	    schoolDaysCount: function schoolDaysCount() {
	      if (this.includeWeekends) {
	        return this.newCount - this.vacationDaysBetweenStartAndEnd.length;
	      } else {
	        return this.newCount - this.weekends.length - this.vacationDaysWithoutWeekends.length;
	      }
	    },
	    selectedSchoolYear: function selectedSchoolYear() {
	      return this.activeSchoolYears[this.selectedSchoolYearIndex];
	    }
	  },
	  methods: {
	    updateToFromDates: function updateToFromDates() {
	      this.currFromDate = (0, _moment2.default)(this.selectedSchoolYear.student_time_start);
	      this.currToDate = (0, _moment2.default)(this.selectedSchoolYear.student_time_end);
	    },
	    dayToggled: function dayToggled(date, isSelected) {
	      if (isSelected) {
	        _docendo2.default.schoolVacationDaysCreate(this.schoolId, date, this.saved, this.failed);
	      } else {
	        var id = this.vacationDays[date];
	        _docendo2.default.schoolVacationDaysDelete(this.schoolId, id, this.saved, this.failed);
	      }
	    },
	    saved: function saved(vacationDay) {
	      this.vacationDays[vacationDay.day] = vacationDay.id;
	    },
	    failed: function failed(error) {
	      console.log('failed', error);
	    },
	    schoolYearsCallback: function schoolYearsCallback(data) {
	      var _this2 = this;
	
	      this.schoolYears = data;
	      this.activeSchoolYears = this.schoolYears.filter(function (schoolYear) {
	        return schoolYear.active;
	      });
	      this.selectedSchoolYearIndex = this.initialYear ? this.activeSchoolYears.findIndex(function (x) {
	        return x.name === _this2.initialYear;
	      }) : 0;
	      if (this.selectedSchoolYearIndex < 0) {
	        this.selectedSchoolYearIndex = 0;
	      }
	      this.updateToFromDates();
	    },
	    initialDaysCallback: function initialDaysCallback(data) {
	      var _this3 = this;
	
	      this.initialSelectedDates = [];
	      data.forEach(function (vacationDay) {
	        this.vacationDays[vacationDay.day] = vacationDay.id;
	        this.initialSelectedDates.push(vacationDay.day);
	      }, this);
	      if (this.emitEventOnLoad) {
	        this.$store.dispatch('updateUserSettings', { 'setup_widget_progress_vacation': true });
	
	        setTimeout(function () {
	          _this3.$store.commit('setOnboardingStep', 0);
	        }, 2500);
	      }
	    },
	    onSchoolYearChanged: function onSchoolYearChanged() {
	      this.updateToFromDates();
	      _docendo2.default.schoolVacationDaysRead(this.schoolId, this.initialDaysCallback);
	    },
	    onStartDateChanged: function onStartDateChanged(date) {
	      var self = this;
	      if (this.selectedSchoolYear === undefined) {
	        return;
	      }
	      if (date !== this.selectedSchoolYear.student_time_start) {
	        _docendo2.default.schoolYearsUpdate(this.schoolId, this.selectedSchoolYear.id, { student_time_start: date }, function (data) {
	          self.currFromDate = (0, _moment2.default)(date);
	          self.schoolYears[self.selectedSchoolYearIndex].student_time_start = data.student_time_start;
	        });
	      }
	    },
	    onEndDateChanged: function onEndDateChanged(date) {
	      var self = this;
	      if (this.selectedSchoolYear === undefined) {
	        return;
	      }
	      if (date !== this.selectedSchoolYear.student_time_end) {
	        _docendo2.default.schoolYearsUpdate(this.schoolId, this.selectedSchoolYear.id, { student_time_end: date }, function (data) {
	          self.currToDate = (0, _moment2.default)(date);
	          self.schoolYears[self.selectedSchoolYearIndex].student_time_end = data.student_time_end;
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(9);
	
	__webpack_require__(191);
	
	__webpack_require__(192);
	
	__webpack_require__(190);
	
	var _vueQuillEditor = __webpack_require__(422);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DoWeekPlanLog = __webpack_require__(407);
	
	var _DoWeekPlanLog2 = _interopRequireDefault(_DoWeekPlanLog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: {
	    quillEditor: _vueQuillEditor.quillEditor,
	    DModal: _DModal2.default,
	    DoWeekPlanLog: _DoWeekPlanLog2.default
	  },
	  props: {
	    isUploadFile: {
	      type: Boolean,
	      default: false
	    },
	    isUploadImage: {
	      type: Boolean,
	      default: false
	    },
	    textInput: {
	      type: String,
	      default: null
	    },
	    lesson: {
	      type: Object,
	      default: function _default() {
	        return null;
	      }
	    },
	    noteType: {
	      type: String,
	      default: ''
	    },
	    isOpen: {
	      type: Boolean,
	      default: false
	    },
	    isInTestOfSaveButton: {
	      type: Boolean,
	      default: true
	    },
	    isClosingWithoutSaving: {
	      type: Boolean,
	      default: false
	    },
	
	    activeEIP: {},
	    isSaving: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      initialHTML: '',
	      isChanged: false,
	      editor: null,
	      edit: false,
	      text: '',
	      linkText: '',
	      link: '',
	      isMouseDown: false,
	      isLinkModal: false,
	      preserveWhitespace: true,
	      editorOption: {
	        modules: {
	          toolbar: {
	            container: '#toolbar'
	          }
	        },
	        clipboard: {
	          matchVisual: false
	        }
	      },
	      placeholder: '',
	      isShowModalTeleport: false,
	      isShowModalTeleportClosingWithoutSaving: false
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    linkWithHttp: function linkWithHttp() {
	      var withHttp = function withHttp(url) {
	        return !/^https?:\/\//i.test(url) ? 'http://' + url : url;
	      };
	      return withHttp(this.link);
	    },
	    isValidURL: function isValidURL() {
	      return this.checkValidURL(this.linkWithHttp);
	    },
	    isValidated: function isValidated() {
	      return this.isValidURL && this.linkText.length > 0;
	    },
	    textWithoutHTML: function textWithoutHTML() {
	      return this.text ? this.text.replace(/<\/?p[^>]*>/g, '') : '';
	    },
	    i18n: function i18n() {
	      return {
	        da: {
	          bold: 'Fed',
	          italic: 'Kursiv',
	          underline: 'Understreget',
	          list_ordered: 'Liste nummereret',
	          list_bullets: 'Liste i punktform',
	          insert_link: 'Indsæt link',
	          link_text_label: 'Tekst der skal vises',
	          link_text_placeholder: 'eks. Docendo',
	          link_link_label: 'Webadressen',
	          link_link_placeholder: 'eks. www.docendo.dk',
	          cancel: 'Annuller'
	        },
	        en: {
	          bold: 'Bold',
	          italic: 'Italic',
	          underline: 'Underline',
	          list_ordered: 'List Ordered',
	          list_bullets: 'List i punktform',
	          insert_link: 'Insert link',
	          link_text_label: 'Text to be shown',
	          link_text_placeholder: 'e.g. Docendo',
	          link_link_label: 'Web address',
	          link_link_placeholder: 'e.g. www.docendo.co',
	          cancel: 'Cancel'
	        },
	        nb: {
	          bold: 'Fet',
	          italic: 'Kursiv',
	          underline: 'Understreket',
	          list_ordered: 'Punktliste',
	          list_bullets: 'Nummerert liste',
	          insert_link: 'Sett inn link',
	          link_text_label: 'Tekst som skal vises',
	          link_text_placeholder: 'eks. Docendo',
	          link_link_label: 'Nettadressen',
	          link_link_placeholder: 'eks. www.docendo.no',
	          cancel: 'Annuller'
	        }
	      };
	    }
	  },
	  watch: {
	    activeEIP: function activeEIP(val, oldVal) {
	      if (val) {
	        this.reboot();
	      }
	    },
	    textInput: function textInput(val) {
	      if (!this.lesson) {
	        this.text = val;
	      }
	    },
	    isClosingWithoutSaving: function isClosingWithoutSaving(val) {
	      var _this = this;
	
	      if (val) {
	        this.isShowModalTeleportClosingWithoutSaving = true;
	        this.$nextTick(function (_) {
	          var el = _this.$refs.d_modal_teleport_alert;
	          document.getElementById('djs-content-container').appendChild(el);
	        });
	      }
	    }
	  },
	  methods: {
	    reboot: function reboot() {
	      this.text = this.lesson[this.noteType];
	      this.initialHTML = this.text;
	      this.editor.focus();
	    },
	    checkValidURL: function checkValidURL(str) {
	      return true;
	    },
	    setIsLinkModal: function setIsLinkModal(boolean) {
	      var _this2 = this;
	
	      if (boolean) {
	        this.isShowModalTeleport = true;
	        this.isLinkModal = true;
	        this.$nextTick(function (_) {
	          var el = _this2.$refs.d_modal_teleport;
	          document.getElementById('djs-content-container').appendChild(el);
	          _this2.$refs.linkTextInput.focus();
	        });
	      } else {
	        this.$refs.d_modal_teleport.remove();
	        this.linkText = '';
	        this.link = '';
	        this.isLinkModal = false;
	      }
	    },
	    insertLink: function insertLink() {
	      this.editor.focus();
	      var index = (this.editor.getSelection() || {}).index || this.editor.getLength() - 1;
	      this.editor.insertText(index, this.linkText, 'link', this.linkWithHttp);
	      this.setIsLinkModal(false);
	    },
	    onEditorReady: function onEditorReady(quill) {
	      this.editor = quill;
	      quill.focus();
	    },
	    onUploadFile: function onUploadFile(e) {
	      console.log('show some file uploading');
	    },
	    cancelModal: function cancelModal() {
	      this.$refs.d_modal_teleport_alert.remove();
	      this.isShowModalTeleportClosingWithoutSaving = false;
	      this.cancel();
	    },
	    saveModal: function saveModal() {
	      this.$refs.d_modal_teleport_alert.remove();
	      this.isShowModalTeleportClosingWithoutSaving = false;
	      this.save();
	    },
	    cancel: function cancel() {
	      this.edit = false;
	      if (this.lesson) {
	        this.text = this.lesson[this.noteType];
	      } else {
	        this.text = this.textInput;
	      }
	      this.setIsEditorTextChanged(false);
	      this.$emit('close', false);
	    },
	    save: function save() {
	      this.edit = false;
	      if (this.lesson) {
	        this.$emit('close', { lesson: this.lesson, noteType: this.noteType, text: this.text });
	      } else {
	        this.$emit('close', { text: this.text });
	      }
	      this.setIsEditorTextChanged(false);
	    },
	    onEditorChange: function onEditorChange(_ref) {
	      var quill = _ref.quill,
	          html = _ref.html,
	          text = _ref.text;
	
	      var oldVal = this.lesson[this.noteType];
	      var newVal = html;
	      var isDiff = oldVal.trim() !== newVal.trim();
	      this.text = html;
	
	      if (this.textInput && this.textInput === html || this.initialHTML === html) {
	        return;
	      }
	      if (isDiff) {
	        this.setIsEditorTextChanged(true);
	      }
	    },
	    setIsEditorTextChanged: function setIsEditorTextChanged(bool) {
	      this.isChanged = bool;
	      this.$emit('changed', bool);
	      if (this.isInTestOfSaveButton) {
	        _eventbus2.default.isLessonNoteChangedWithoutSaving = bool;
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.textInput) {
	      this.text = this.textInput;
	      this.initialHTML = this.text;
	      return;
	    }
	    if (this.lesson && this.noteType) {
	      this.text = this.lesson[this.noteType];
	      this.initialHTML = this.text;
	    }
	    window.addEventListener('beforeunload', function (e) {
	      var confirmMessage = 'Continue without saving?';
	      if (_eventbus2.default.isLessonNoteChangedWithoutSaving) {
	        (e || window.event).returnValue = confirmMessage;
	        return confirmMessage;
	      }
	    });
	  }
	};

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DEIP = __webpack_require__(1687);
	
	var _DEIP2 = _interopRequireDefault(_DEIP);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    weekplan: 'Ugeplan',
	    no_events_this_week: 'Ingen lektioner eller noter i ugen',
	    learning_goal: 'Læringsmål',
	    meeting_purpose: 'Formål med mødet',
	    content: 'Indhold',
	    agenda: 'Agenda',
	    pupil_preparation: 'Elevforberedelse',
	    decisions_and_resume: 'Beslutninger og resumé',
	    teacher_notes: 'Vikarnoter / Interne noter',
	    internal_notes: 'Noter'
	  },
	  en: {
	    weekplan: 'Weekplan',
	    no_events_this_week: 'No lessons or notes this week',
	    learning_goal: 'Learning goal',
	    meeting_purpose: 'Purpose of the meeting',
	    content: 'Content',
	    agenda: 'Agenda',
	    pupil_preparation: 'Homework',
	    decisions_and_resume: 'Decisions and summary',
	    internal_notes: 'Notes',
	    teacher_notes: 'Teachers notes'
	  },
	  nb: {
	    weekplan: 'Ukeplan',
	    no_events_this_week: 'Ingen leksjoner eller notater denne uken',
	    learning_goal: 'Læringsmål',
	    meeting_purpose: 'Formål med møtet',
	    content: 'Innhold',
	    agenda: 'Agenda',
	    pupil_preparation: 'Lekser',
	    decisions_and_resume: 'Beslutninger og resymé',
	    teacher_notes: 'Vikarnotater',
	    internal_notes: 'Notater'
	  }
	};
	
	exports.default = {
	  props: {
	    isReadOnly: {
	      type: Boolean,
	      default: false
	    },
	    isI18N: {
	      type: Boolean,
	      default: false
	    },
	    isInPrintMode: {
	      type: Boolean,
	      default: false
	    }
	  },
	  components: { Loader: _Loader2.default, EIP: _DEIP2.default },
	  data: function data() {
	    return {
	      isInViewport: false,
	      isWeekplanHasLesson: false,
	      activeEIP: null,
	      activeEvent: null,
	      activeNoteType: '',
	      activeText: '',
	      isEditorChangedWithoutSave: false,
	      isClosingWithoutSaving: false,
	      weekNote: '',
	      weeknoteId: null,
	      weekNoteState: '',
	      isSavingEIP: false
	    };
	  },
	
	  computed: {
	    isCalendarAUser: function isCalendarAUser() {
	      return this.calendar && this.calendar.type && this.calendar.type === 'user';
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    placeholderHeight: function placeholderHeight() {
	      var boxHeight = 27 + 12;
	      var dayHeight = 24 + 12 + 22 + 34;
	      var eventHeight = 68 + 12;
	      var days = 0;
	      var events = 0;
	      this.eventsWithinDays.forEach(function (day) {
	        if (day.lessons.length > 0) {
	          days++;
	          events += day.lessons.length;
	        }
	      });
	      if (days < 1) {
	        return 'height: 61px';
	      }
	      var height = boxHeight + days * dayHeight + events * eventHeight;
	      return 'height:' + height + 'px';
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    isEventsLoading: function isEventsLoading() {
	      return this.$store.state.calendar.isEventsLoading;
	    },
	    calendar: function calendar() {
	      return this.$store.state.calendar.calendar;
	    },
	    date: function date() {
	      return this.$store.state.calendar.date;
	    },
	    events: function events() {
	      return this.$store.getters.activeFullCalendarEvents;
	    },
	    eventsFiltered: function eventsFiltered() {
	      return this.isInPrintMode || this.isReadOnly ? this.events.filter(function (event) {
	        return event.has_notes;
	      }) : this.events;
	    },
	    eventsInHash: function eventsInHash() {
	      return this.$store.getters.activeFullCalendarEventsInHash;
	    },
	    eventsWithinDays: function eventsWithinDays() {
	      this.isWeekplanHasLesson = false;
	      var allDates = [];
	      for (var i = 1; i < 8; i++) {
	        var date = (0, _moment2.default)(this.date).isoWeekday(i).format('YYYY-MM-DD');
	        var arr = this.filterLesson(i).concat();
	        arr.sort(function compare(a, b) {
	          var dateA = new Date(a.start);
	          var dateB = new Date(b.start);
	          return dateA - dateB;
	        });
	        if (arr.length > 0) {
	          this.isWeekplanHasLesson = true;
	        }
	        allDates.push({ date: date, lessons: arr });
	      }
	      return allDates;
	    },
	    activeEventId: function activeEventId() {
	      return !this.activeEvent ? '' : this.activeEvent.event_id + '_' + this.activeNoteType;
	    }
	  },
	  watch: {
	    date: function date() {
	      this.cleanUp();
	
	      this.isInViewport = false;
	      this.getWeekNote();
	    },
	    isInPrintMode: function isInPrintMode(val) {
	      if (val) {
	        this.isInViewport = true;
	      }
	    },
	    calendar: function calendar() {
	      this.getWeekNote();
	    }
	  },
	  methods: {
	    createPopper: function createPopper(divId) {
	      var el = document.getElementById(divId);
	      var source = this.$refs.d_eip;
	      el.appendChild(source);
	    },
	    closeEip: function closeEip(obj) {
	      var _this = this;
	
	      if (!obj) {
	        this.activeEvent = null;
	        return;
	      }
	      if (obj.noteType === 'weeknote') {
	        this.updateWeekNote(obj.text);
	        return;
	      }
	      this.isSavingEIP = true;
	      _docendo2.default.updateEvent(obj.lesson.school_id, obj.lesson.event_id, (0, _defineProperty3.default)({}, obj.noteType, obj.text), function (payload) {
	        var updateObj = {
	          noteType: obj.noteType,
	          payload: payload
	        };
	        _this.$store.commit('updateActiveCalendarEventNote', updateObj);
	        _this.activeEvent = null;
	        _this.isSavingEIP = false;
	        _eventbus2.default.toast = { text: _this.$t('vue2.common.saved'), 'success': true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    setActiveEip: function setActiveEip(event, noteType, divId, evt) {
	      var _this2 = this;
	
	      if (this.isReadOnly) {
	        return;
	      }
	      if (this.activeEvent && divId === this.activeEvent.event_id + '_' + this.activeNoteType) {
	        return;
	      }
	      if (evt.target.tagName.toLowerCase() === 'a' && evt.target.href.length > 0) {
	        evt.stopPropagation();
	        window.open(evt.target.href, '_blank', 'noopener,noreferrer');
	        return;
	      }
	      if (this.isEditorChangedWithoutSave) {
	        this.isClosingWithoutSaving = true;
	        return;
	      }
	      this.isClosingWithoutSaving = false;
	      this.createPopper(divId);
	      this.$nextTick(function (_) {
	        if (noteType === 'weeknote') {
	          var activeEvent = {
	            weeknote: _this2.weekNote,
	            event_id: _this2.calendar.id
	          };
	          _this2.activeEvent = activeEvent;
	          _this2.activeNoteType = noteType;
	          _this2.activeText = _this2.weekNote;
	          _this2.activeEIP = _this2.calendar.id + '_' + 'weeknote';
	        } else {
	          _this2.activeEvent = event;
	          _this2.activeNoteType = noteType;
	          _this2.activeText = _this2.activeEvent[_this2.activeNoteType];
	          _this2.activeEIP = event.event_id + '_' + noteType;
	        }
	      });
	    },
	    setIsEditorChangedWithoutSave: function setIsEditorChangedWithoutSave(boolean) {
	      this.isEditorChangedWithoutSave = boolean;
	    },
	    filterLocaleDate: function filterLocaleDate(mom) {
	      if (this.locale === 'nn') {
	        return (0, _moment2.default)(mom).format('dddd DD. MMMM');
	      }
	      try {
	        return (0, _moment2.default)(mom)._d.toLocaleDateString(this.locale, { weekday: 'long', month: 'long', day: '2-digit' });
	      } catch (e) {
	        return (0, _moment2.default)(mom).format('LL');
	      }
	    },
	    getEvent: function getEvent(eventId) {
	      return this.eventsInHash[eventId];
	    },
	    filterLesson: function filterLesson(dayNum) {
	      var _this3 = this;
	
	      var allowedEventTypes = ['subject', 'supplemental', 'exercise', 'resource', 'frame', 'optional', 'person_resource', 'person_resource_visible', 'other_tasks', 'other_stuff'];
	
	      return this.eventsFiltered.filter(function (lesson) {
	        if (allowedEventTypes.indexOf(lesson.event_type) > -1) {
	          var lessonDate = (0, _moment2.default)(lesson.start).format('YYYY-MM-DD');
	          var day = (0, _moment2.default)(_this3.date).isoWeekday(dayNum).format('YYYY-MM-DD');
	          return (0, _moment2.default)(lessonDate).isSame(day);
	        }
	      }).map(function (lesson) {
	        var klassNames = lesson.calendars ? lesson.calendars.filter(function (c) {
	          return c.calendar_type === 'klass';
	        }).map(function (c) {
	          return c.name;
	        }) : [];
	
	        var vKlasses = '';
	        if (klassNames.length > 0) {
	          var shown = klassNames.slice(0, 2).join(', ');
	          vKlasses = klassNames.length > 2 ? shown + ', …' : shown;
	        }
	
	        return (0, _extends3.default)({}, lesson, {
	          vKlasses: vKlasses
	        });
	      });
	    },
	    cleanUp: function cleanUp() {
	      this.activeEvent = null;
	      this.activeNoteType = '';
	      this.activeText = '';
	      this.activeEIP = null;
	    },
	    toogleWeekplan: function toogleWeekplan(evt) {
	      if (this.activeEIP) {
	        return;
	      }
	      this.isInViewport = evt[0].isIntersecting;
	      if (!this.isInViewport) {
	        this.cleanUp();
	      }
	    },
	    scrollTrigger: function scrollTrigger() {
	      var observer = new window.IntersectionObserver(this.toogleWeekplan);
	      if (!this.isInPrintMode) {
	        observer.observe(this.$refs.d_weekplan);
	      }
	    },
	    getWeekNote: function getWeekNote() {
	      var _this4 = this;
	
	      if (!this.calendar || this.calendar && this.calendar.type !== 'klass') {
	        return;
	      }
	      var isoWeek = (0, _moment2.default)(this.date).isoWeek().toString().length < 2 ? '0' + (0, _moment2.default)(this.date).isoWeek() : (0, _moment2.default)(this.date).isoWeek();
	      var week = (0, _moment2.default)(this.date).format('YYYY') + 'W' + isoWeek;
	      _docendo2.default.weeknote(this.calendar.id, week, function (data) {
	        _this4.weekNote = data.note ? data.note : '';
	
	        _this4.weeknoteId = data.note ? data.id : null;
	      });
	    },
	    updateWeekNote: function updateWeekNote(note) {
	      var _this5 = this;
	
	      this.isSavingEIP = true;
	      var isoWeek = (0, _moment2.default)(this.date).isoWeek().toString().length < 2 ? '0' + (0, _moment2.default)(this.date).isoWeek() : (0, _moment2.default)(this.date).isoWeek();
	      var week = (0, _moment2.default)(this.date).format('YYYY') + 'W' + isoWeek;
	      this.weekNoteState = 'saving';
	      _docendo2.default.weeknoteUpdate(this.calendar.id, week, note, function (success) {
	        _this5.weekNoteState = 'saved';
	        if (success.hasOwnProperty('note')) {
	          _this5.weekNote = success.note;
	          _this5.weeknoteId = success.id;
	        }
	        _this5.activeEvent = null;
	        _this5.isSavingEIP = false;
	        _eventbus2.default.toast = { text: _this5.$t('vue2.common.saved'), 'success': true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this5.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.scrollTrigger();
	    this.getWeekNote();
	  }
	};

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    weeknoteId: {}
	  },
	  data: function data() {
	    return {
	      activeIdxs: [0, 1],
	      log: [],
	      isShowHistory: false
	    };
	  },
	
	  computed: {
	    latestActivity: function latestActivity() {
	      var _this = this;
	
	      return this.log ? this.log.filter(function (log, idx) {
	        return _this.isInActiveIdx(idx);
	      }) : [];
	    },
	    logSorted: function logSorted() {
	      return this.log ? this.log.sort(function (a, b) {
	        return new Date(b.at) - new Date(a.at);
	      }) : [];
	    }
	  },
	  methods: {
	    showHumanizedTime: function showHumanizedTime(dateTime) {
	      var diff = (0, _moment2.default)().diff((0, _moment2.default)(dateTime));
	      return _moment2.default.duration(diff).humanize();
	    },
	    isInActiveIdx: function isInActiveIdx(key) {
	      return this.activeIdxs.indexOf(key) > -1;
	    },
	    setShowHistory: function setShowHistory() {
	      this.isShowHistory = true;
	      this.getWeeknoteLog();
	    },
	    close: function close() {
	      this.isShowHistory = false;
	    },
	    getWeeknoteLog: function getWeeknoteLog() {
	      var _this2 = this;
	
	      if (!this.weeknoteId) {
	        this.log = [];
	      }
	      _docendo2.default.auditWeeknote(window.SCHOOL.id, this.weeknoteId, function (data) {
	        _this2.log = data && data.length > 0 ? JSON.parse(data) : [];
	      }, function (failure) {
	        console.log('something went wrong', failure);
	      });
	    },
	    showDate: function showDate(date) {
	      return (0, _moment2.default)(date).format('L LT');
	    },
	    showUser: function showUser(user) {
	      return user.name;
	    },
	    revertedKey: function revertedKey(version) {
	      var idx = this.logSorted.findIndex(function (log) {
	        return log.at === version.at;
	      });
	      return this.logSorted.length - idx;
	    },
	    setVersion: function setVersion(version) {
	      var idx = this.logSorted.findIndex(function (log) {
	        return log.at === version.at;
	      });
	      this.activeIdxs = [];
	      this.activeIdxs.push(idx, idx + 1);
	    },
	    isNewestVersion: function isNewestVersion(version) {
	      var idx = this.logSorted.findIndex(function (log) {
	        return log.at === version.at;
	      });
	      return idx === 0;
	    }
	  }
	};

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'do-youtube',
	  description: 'Popup that plays youtube-videoes. Tags: Popup, YouTube-API, responsive',
	  computed: {
	    player: function player() {
	      return this.$refs.youtube.player;
	    },
	    showTutorial: function showTutorial() {
	      return _eventbus2.default.isOpenYouTubePopup;
	    },
	    videoId: function videoId() {
	      return _eventbus2.default.youTubeVideoId;
	    }
	  },
	  watch: {
	    showTutorial: function showTutorial(val) {
	      var _this = this;
	
	      if (val) {
	        setTimeout(function () {
	          _this.classListTimeout = true;
	        }, 0);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      videoVars: {
	        autoplay: 1,
	        modestbranding: 1,
	        rel: 0 },
	      classListTimeout: false
	    };
	  },
	
	  methods: {
	    playVideo: function playVideo(youTubeUrl) {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.player.playVideo();
	      });
	    },
	    getVideoId: function getVideoId(youTubeUrl) {
	      this.videoId = this.$youtube.getIdFromUrl(youTubeUrl);
	    },
	    closeYouTubePopup: function closeYouTubePopup() {
	      _eventbus2.default.isOpenYouTubePopup = false;
	      this.player.stopVideo();
	      this.classListTimeout = false;
	    },
	    videoPlaying: function videoPlaying() {
	      console.log('video started');
	    },
	    videoEnded: function videoEnded() {
	      this.closeYouTubePopup();
	      console.log('video ended');
	    },
	    videoReady: function videoReady() {
	      console.log('video ready');
	    },
	    videoCued: function videoCued() {
	      console.log('video cued');
	    }
	  }
	};

/***/ }),
/* 831 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    actionType: {
	      type: String,
	      default: 'delete'
	    },
	    state: {
	      type: String,
	      default: 'idle'
	    }
	  },
	  computed: {
	    isConfirming: function isConfirming() {
	      return this.state === 'confirming';
	    },
	    isLoading: function isLoading() {
	      return this.state === 'loading';
	    },
	    isDone: function isDone() {
	      return this.state === 'deleted' || this.state === 'reverted';
	    },
	    actionLabel: function actionLabel() {
	      return this.actionType === 'delete' ? this.$t('vue2.zen_import.delete') : this.$t('vue2.zen_import.undo_change');
	    },
	    doneLabel: function doneLabel() {
	      return this.state === 'deleted' ? this.$t('vue2.zen_import.done_deleted') : this.$t('vue2.zen_import.done_reverted');
	    }
	  }
	};

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _values = __webpack_require__(33);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _set = __webpack_require__(27);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Tabs = __webpack_require__(15);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _DoFiltersFilter = __webpack_require__(13);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ZEN_EXPORT_SUBJECT_TYPE_ORDER = ['subject', 'optional', 'resource', 'person_resource_visible', 'person_resource', 'supplemental', 'break'];
	
	var I18N = {
	  da: {
	    title: 'Vælg brikker til skemalægning',
	    select_all: 'Vælg alle',
	    deselect_all: 'Fravælg alle',
	    tab_count: '{count} af {total} brikker i {scope} valgt',
	    total_count: '{count} af {total} skoleårets brikker valgt',
	    scope_klass: 'klasserne',
	    scope_user: 'personalekalenderne',
	    scope_other: 'andre kalendere',
	    tab_klass: 'Klasser',
	    tab_user: 'Personale',
	    tab_other: 'Andre kalendere',
	    filter_title: 'Titel',
	    filter_type: 'Type',
	    filter_calendars_klass: 'Klasser',
	    filter_calendars_user: 'Personale',
	    filter_calendars_other: 'Kalendere',
	    filter_no_type: '(uden type)',
	    filter_resource_hidden: 'Ressource (skjult)',
	    filter_resource_personnel: 'Ressource (personale)',
	    th_type: 'Type',
	    th_teachers: 'Personale',
	    th_rooms: 'Lokaler',
	    th_klasses: 'Klasser',
	    th_hours: 'Timer',
	    th_lessons_per_week: 'Lek. pr. uge',
	    th_events: 'Antal lektioner',
	    no_pieces: 'Ingen brikker',
	    no_pieces_in_calendar_type: 'Ingen brikker i denne kalendertype',
	    no_pieces_match_filters: 'Ingen brikker matcher de valgte filtre',
	    cancel: 'Annuller',
	    transferring: 'Overfører...',
	    transfer_to_zen: 'Overfør til automatisk skemalægning',
	    toast_exported_success: 'Data overført til automatisk skemalægning',
	    toast_export_failed: 'Noget gik galt ved overførsel',
	    subject_types: {
	      subject: 'Fag',
	      activity: 'Aktivitet',
	      available: 'Rådighedstime',
	      person_resource: 'Ressource',
	      person_resource_visible: 'Ressource (synlig)',
	      resource: 'Ressource',
	      additional_tasks: 'Øvrige opgaver',
	      preparation: 'Forberedelse',
	      club: 'SFO',
	      without_kids: 'Uden børn',
	      frame: 'Temavisning',
	      optional: 'Valgfag/Hold',
	      supplemental: 'UUV',
	      break: 'Pause'
	    }
	  },
	  nb: {
	    title: 'Velg brikker til timeplanlegging',
	    select_all: 'Velg alle',
	    deselect_all: 'Fjern alle',
	    tab_count: '{count} av {total} brikker valgt i {scope}',
	    total_count: '{count} av {total} brikker i skoleåret valgt',
	    scope_klass: 'klassene',
	    scope_user: 'ansattkalenderne',
	    scope_other: 'andre kalendere',
	    tab_klass: 'Klasser',
	    tab_user: 'Ansatte',
	    tab_other: 'Andre kalendere',
	    filter_title: 'Tittel',
	    filter_type: 'Type',
	    filter_calendars_klass: 'Klasser',
	    filter_calendars_user: 'Ansatte',
	    filter_calendars_other: 'Kalendere',
	    filter_no_type: '(uten type)',
	    filter_resource_hidden: 'Ressurs (skjult)',
	    filter_resource_personnel: 'Ressurs (ansatte)',
	    th_type: 'Type',
	    th_teachers: 'Ansatte',
	    th_rooms: 'Rom',
	    th_klasses: 'Klasser',
	    th_hours: 'Timer',
	    th_lessons_per_week: 'Lek. pr. uke',
	    th_events: 'Antall leksjoner',
	    no_pieces: 'Ingen brikker',
	    no_pieces_in_calendar_type: 'Ingen brikker i denne kalendertypen',
	    no_pieces_match_filters: 'Ingen brikker matcher valgte filtre',
	    cancel: 'Avbryt',
	    transferring: 'Overfører...',
	    transfer_to_zen: 'Overfør til automatisk timeplanlegging',
	    toast_exported_success: 'Data overført til automatisk timeplanlegging',
	    toast_export_failed: 'Noe gikk galt under overføring',
	    subject_types: {
	      subject: 'Fag',
	      activity: 'Aktivitet',
	      available: 'Rådighetstime',
	      person_resource: 'Ressurs',
	      person_resource_visible: 'Ressurs (synlig)',
	      resource: 'Ressurs',
	      additional_tasks: 'Øvrige oppgaver',
	      preparation: 'Forberedelse',
	      club: 'SFO',
	      without_kids: 'Uten barn',
	      frame: 'Temavisning',
	      optional: 'Valgfag/Gruppe',
	      supplemental: 'UUV',
	      break: 'Pause'
	    }
	  },
	  en: {
	    title: 'Select pieces for scheduling',
	    select_all: 'Select all',
	    deselect_all: 'Deselect all',
	    tab_count: '{count} of {total} pieces selected in {scope}',
	    total_count: '{count} of {total} pieces for the school year selected',
	    scope_klass: 'the classes',
	    scope_user: 'the staff calendars',
	    scope_other: 'other calendars',
	    tab_klass: 'Classes',
	    tab_user: 'Staff',
	    tab_other: 'Other calendars',
	    filter_title: 'Title',
	    filter_type: 'Type',
	    filter_calendars_klass: 'Classes',
	    filter_calendars_user: 'Staff',
	    filter_calendars_other: 'Calendars',
	    filter_no_type: '(without type)',
	    filter_resource_hidden: 'Resource (hidden)',
	    filter_resource_personnel: 'Resource (staff)',
	    th_type: 'Type',
	    th_teachers: 'Staff',
	    th_rooms: 'Rooms',
	    th_klasses: 'Classes',
	    th_hours: 'Hours',
	    th_lessons_per_week: 'Les. per week',
	    th_events: 'Number of lessons',
	    no_pieces: 'No pieces',
	    no_pieces_in_calendar_type: 'No pieces in this calendar type',
	    no_pieces_match_filters: 'No pieces match the selected filters',
	    cancel: 'Cancel',
	    transferring: 'Transferring...',
	    transfer_to_zen: 'Transfer to automatic scheduling',
	    toast_exported_success: 'Data transferred to automatic scheduling',
	    toast_export_failed: 'Something went wrong during transfer',
	    subject_types: {
	      subject: 'Subject',
	      activity: 'Activity',
	      available: 'On-call',
	      person_resource: 'Resource',
	      person_resource_visible: 'Resource (visible)',
	      resource: 'Resource',
	      additional_tasks: 'Other tasks',
	      preparation: 'Preparation',
	      club: 'Club',
	      without_kids: 'Without kids',
	      frame: 'Theme',
	      optional: 'Optional/Group',
	      supplemental: 'UUV',
	      break: 'Break'
	    }
	  }
	};
	
	exports.default = {
	  components: { Loader: _Loader2.default, Tabs: _Tabs2.default, DoFiltersFilter: _DoFiltersFilter2.default },
	  props: {
	    schoolId: {
	      type: Number,
	      required: true
	    },
	    schoolYearId: {
	      type: Number,
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      activeTab: 'klass',
	      isExporting: false,
	      localSettings: {},
	      selectedSubjectTitleFilters: [],
	      selectedSubjectTypeFilters: [],
	      selectedCalendarNameFilters: [],
	      durationInputMinutes: 45
	    };
	  },
	
	  watch: {
	    activeTab: function activeTab() {
	      this.selectedSubjectTitleFilters = [];
	      this.selectedSubjectTypeFilters = [];
	      this.selectedCalendarNameFilters = [];
	    },
	    isLoading: function isLoading(val) {
	      if (!val) {
	        this.syncDurationInputFromSchool();
	      }
	    }
	  },
	  computed: {
	    isLoading: function isLoading() {
	      return this.$store.state.subjects.isLoadingSubjects;
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    locale: function locale() {
	      var l = this.$store.getters.locale;
	      return I18N[l] ? l : 'en';
	    },
	    t: function t() {
	      return I18N[this.locale];
	    },
	    tabCountText: function tabCountText() {
	      return this.formatMessage(this.t.tab_count, {
	        count: this.tabCheckedCount,
	        total: this.activeRows.length,
	        scope: this.activeTabBrikkerScope
	      });
	    },
	    totalCountText: function totalCountText() {
	      return this.formatMessage(this.t.total_count, {
	        count: this.totalCheckedCount,
	        total: this.totalCount
	      });
	    },
	    calendarTabs: function calendarTabs() {
	      return [{ id: 'klass', title: this.t.tab_klass }, { id: 'user', title: this.t.tab_user }, { id: 'other', title: this.t.tab_other }];
	    },
	    activeTabBrikkerScope: function activeTabBrikkerScope() {
	      if (this.activeTab === 'klass') return this.t.scope_klass;
	      if (this.activeTab === 'user') return this.t.scope_user;
	      return this.t.scope_other;
	    },
	    calendarFilterTitle: function calendarFilterTitle() {
	      if (this.activeTab === 'klass') return this.t.filter_calendars_klass;
	      if (this.activeTab === 'user') return this.t.filter_calendars_user;
	      return this.t.filter_calendars_other;
	    },
	    subjects: function subjects() {
	      return this.$store.state.subjects.subjects;
	    },
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    subjectDefaultDuration: function subjectDefaultDuration() {
	      return this.school && this.school.subject_default_duration ? this.school.subject_default_duration : 45;
	    },
	    zenLessonsSchoolYearWeeks: function zenLessonsSchoolYearWeeks() {
	      var c = this.school && this.school.country ? String(this.school.country).toUpperCase() : '';
	      return c === 'NO' ? 38 : 40;
	    },
	    poolSubjectTypeLabel: function poolSubjectTypeLabel() {
	      var title = this.$store.getters.localPoolTitle;
	      return title || 'Lokalpulje';
	    },
	    isAValidStandardDuration: function isAValidStandardDuration() {
	      var n = Number(this.durationInputMinutes);
	      return (/^-?[\d.]+(?:e-?\d+)?$/.test(String(this.durationInputMinutes)) && n > 0 && n < 1440 && n % 5 === 0
	      );
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    klassRows: function klassRows() {
	      return this.buildRows('klass');
	    },
	    userRows: function userRows() {
	      return this.buildRows('user');
	    },
	    otherRows: function otherRows() {
	      return this.buildRows('other');
	    },
	    activeRows: function activeRows() {
	      if (this.activeTab === 'klass') return this.klassRows;
	      if (this.activeTab === 'user') return this.userRows;
	      return this.otherRows;
	    },
	    uniqueSubjectTitles: function uniqueSubjectTitles() {
	      var names = this.activeRows.map(function (r) {
	        return r.subjectName;
	      }).filter(function (n) {
	        return n;
	      });
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(names))).sort(function (a, b) {
	        return a.localeCompare(b, 'da');
	      });
	    },
	    uniqueCalendarNames: function uniqueCalendarNames() {
	      var names = this.activeRows.map(function (r) {
	        return r.calendarName;
	      }).filter(function (n) {
	        return n;
	      });
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(names))).sort(function (a, b) {
	        return a.localeCompare(b, 'da');
	      });
	    },
	    uniqueSubjectTypeFilterTags: function uniqueSubjectTypeFilterTags() {
	      var _this = this;
	
	      var types = [].concat((0, _toConsumableArray3.default)(new _set2.default(this.activeRows.map(function (r) {
	        return r.subjectType || '';
	      }))));
	      types.sort(function (a, b) {
	        return _this.compareZenExportRowsByTypeThenName({ subjectType: a, subjectName: '' }, { subjectType: b, subjectName: '' });
	      });
	      return types.map(function (t) {
	        return _this.subjectTypeFilterOptionLabel(t);
	      });
	    },
	    filteredActiveRows: function filteredActiveRows() {
	      var _this2 = this;
	
	      var rows = this.activeRows;
	      if (this.selectedSubjectTitleFilters.length > 0) {
	        var titles = new _set2.default(this.selectedSubjectTitleFilters);
	        rows = rows.filter(function (r) {
	          return titles.has(r.subjectName);
	        });
	      }
	      if (this.selectedSubjectTypeFilters.length > 0) {
	        var typeTags = new _set2.default(this.selectedSubjectTypeFilters);
	        rows = rows.filter(function (r) {
	          return typeTags.has(_this2.subjectTypeFilterOptionLabel(r.subjectType));
	        });
	      }
	      if (this.selectedCalendarNameFilters.length > 0) {
	        var cals = new _set2.default(this.selectedCalendarNameFilters);
	        rows = rows.filter(function (r) {
	          return cals.has(r.calendarName);
	        });
	      }
	      return rows;
	    },
	    groupedRows: function groupedRows() {
	      var groups = {};
	      var rows = this.filteredActiveRows;
	      for (var i = 0; i < rows.length; i++) {
	        var row = rows[i];
	        var g = groups[row.calendarId];
	        if (!g) {
	          g = {
	            calendarId: row.calendarId,
	            calendarName: row.calendarName,
	            subjects: []
	          };
	          groups[row.calendarId] = g;
	        }
	        g.subjects.push(row);
	      }
	      return (0, _values2.default)(groups).sort(function (a, b) {
	        return (a.calendarName || '').localeCompare(b.calendarName || '', 'da');
	      });
	    },
	    tabCheckedCount: function tabCheckedCount() {
	      var rows = this.activeRows;
	      var n = 0;
	      for (var i = 0; i < rows.length; i++) {
	        if (this.isRowChecked(rows[i])) n++;
	      }
	      return n;
	    },
	    filteredCheckedCount: function filteredCheckedCount() {
	      var rows = this.filteredActiveRows;
	      var n = 0;
	      for (var i = 0; i < rows.length; i++) {
	        if (this.isRowChecked(rows[i])) n++;
	      }
	      return n;
	    },
	    allChecked: function allChecked() {
	      return this.filteredActiveRows.length > 0 && this.filteredCheckedCount === this.filteredActiveRows.length;
	    },
	    totalCount: function totalCount() {
	      return this.klassRows.length + this.userRows.length + this.otherRows.length;
	    },
	    totalCheckedCount: function totalCheckedCount() {
	      var n = 0;
	      var all = [this.klassRows, this.userRows, this.otherRows];
	      for (var t = 0; t < all.length; t++) {
	        var rows = all[t];
	        for (var i = 0; i < rows.length; i++) {
	          if (this.isRowChecked(rows[i])) n++;
	        }
	      }
	      return n;
	    }
	  },
	  methods: {
	    syncDurationInputFromSchool: function syncDurationInputFromSchool() {
	      this.durationInputMinutes = this.subjectDefaultDuration;
	    },
	    onStandardDurationFocus: function onStandardDurationFocus(evt) {
	      setTimeout(function () {
	        evt.target.select();
	      }, 0);
	    },
	    onStandardDurationBlur: function onStandardDurationBlur() {
	      var _this3 = this;
	
	      if (!this.isAValidStandardDuration) {
	        this.durationInputMinutes = this.subjectDefaultDuration;
	        return;
	      }
	      if (Number(this.durationInputMinutes) === Number(this.subjectDefaultDuration)) {
	        return;
	      }
	      _docendo2.default.updateSchool(this.schoolId, { subject_default_duration: this.durationInputMinutes }, function (success) {
	        var next = success && success.subject_default_duration != null ? success.subject_default_duration : _this3.durationInputMinutes;
	        _this3.$store.commit('updateActiveSchoolDuration', next);
	        _this3.durationInputMinutes = next;
	        _eventbus2.default.toast = { text: _this3.$t('vue2.common.saved'), success: true };
	      }, function () {
	        _this3.durationInputMinutes = _this3.subjectDefaultDuration;
	        _eventbus2.default.toast = { text: _this3.$t('vue2.common.something_went_wrong'), success: false };
	      });
	    },
	    toggleSelectedSubjectTitleFilters: function toggleSelectedSubjectTitleFilters(tag) {
	      var idx = this.selectedSubjectTitleFilters.indexOf(tag);
	      if (idx < 0) {
	        this.selectedSubjectTitleFilters.push(tag);
	      } else {
	        this.selectedSubjectTitleFilters.splice(idx, 1);
	      }
	    },
	    clearSelectedSubjectTitleFilters: function clearSelectedSubjectTitleFilters() {
	      this.selectedSubjectTitleFilters = [];
	    },
	    toggleSelectedSubjectTypeFilters: function toggleSelectedSubjectTypeFilters(tag) {
	      var idx = this.selectedSubjectTypeFilters.indexOf(tag);
	      if (idx < 0) {
	        this.selectedSubjectTypeFilters.push(tag);
	      } else {
	        this.selectedSubjectTypeFilters.splice(idx, 1);
	      }
	    },
	    clearSelectedSubjectTypeFilters: function clearSelectedSubjectTypeFilters() {
	      this.selectedSubjectTypeFilters = [];
	    },
	    toggleSelectedCalendarNameFilters: function toggleSelectedCalendarNameFilters(tag) {
	      var idx = this.selectedCalendarNameFilters.indexOf(tag);
	      if (idx < 0) {
	        this.selectedCalendarNameFilters.push(tag);
	      } else {
	        this.selectedCalendarNameFilters.splice(idx, 1);
	      }
	    },
	    clearSelectedCalendarNameFilters: function clearSelectedCalendarNameFilters() {
	      this.selectedCalendarNameFilters = [];
	    },
	    defaultEventsForHours: function defaultEventsForHours(hours) {
	      var lpw = parseFloat(this.$helpers.calcLessonsPerWeek(hours, this.subjectDefaultDuration, this.zenLessonsSchoolYearWeeks)) || 0;
	      return Math.ceil(lpw);
	    },
	    defaultCheckedForSubject: function defaultCheckedForSubject(subjectType, calendarType) {
	      if (calendarType !== 'klass') return false;
	      return subjectType !== 'activity' && subjectType !== 'frame' && subjectType !== 'additional_tasks';
	    },
	    isRowChecked: function isRowChecked(row) {
	      var setting = this.localSettings[row.subjectId];
	      if (setting) return !!setting.checked;
	      return this.defaultCheckedForSubject(row.subjectType, row.calendarType);
	    },
	    rowEvents: function rowEvents(row) {
	      var setting = this.localSettings[row.subjectId];
	      if (setting && setting.events != null) return setting.events;
	      return row.defaultEvents;
	    },
	    buildRows: function buildRows(calendarType) {
	      var _this4 = this;
	
	      var rows = [];
	      var calHash = this.allCalendarsInHash;
	      var subjects = this.subjects;
	      var duration = this.subjectDefaultDuration;
	      var weeks = this.zenLessonsSchoolYearWeeks;
	
	      for (var i = 0; i < subjects.length; i++) {
	        var subject = subjects[i];
	        var cal = calHash[subject.calendar_id];
	        if (!cal || cal.type !== calendarType) continue;
	        if (subject.can_schedule === false) continue;
	
	        var subjectType = subject.subject_type || '';
	        var lpw = this.$helpers.calcLessonsPerWeek(subject.hours, duration, weeks);
	
	        rows.push({
	          id: subject.id,
	          subjectId: subject.id,
	          subjectType: subjectType,
	          calendarType: calendarType,
	          calendarId: subject.calendar_id,
	          subjectName: subject.name || '',
	          calendarName: cal.name || '',
	          color: subject.color || '#ccc',
	          typeName: this.subjectTypeLabel(subjectType),
	          teachers: this.getTeacherNames(subject),
	          rooms: this.getRoomNames(subject),
	          otherKlasses: this.getOtherKlasses(subject),
	          hours: subject.hours,
	          lessonsPerWeek: lpw,
	          defaultEvents: Math.ceil(parseFloat(lpw) || 0)
	        });
	      }
	
	      rows.sort(function (a, b) {
	        return _this4.compareZenExportRowsByTypeThenName(a, b);
	      });
	      return rows;
	    },
	    collectAllSettings: function collectAllSettings() {
	      var settings = {};
	      var calHash = this.allCalendarsInHash;
	      var subjects = this.subjects;
	      var duration = this.subjectDefaultDuration;
	      var weeks = this.zenLessonsSchoolYearWeeks;
	
	      for (var i = 0; i < subjects.length; i++) {
	        var subject = subjects[i];
	        var cal = calHash[subject.calendar_id];
	        if (!cal) continue;
	        if (cal.type !== 'klass' && cal.type !== 'user' && cal.type !== 'other') continue;
	        if (subject.can_schedule === false) continue;
	
	        var setting = this.localSettings[subject.id];
	        var subjectType = subject.subject_type || '';
	        var checked = void 0,
	            events = void 0;
	        if (setting) {
	          checked = !!setting.checked;
	          events = setting.events;
	        } else {
	          checked = this.defaultCheckedForSubject(subjectType, cal.type);
	          var lpw = parseFloat(this.$helpers.calcLessonsPerWeek(subject.hours, duration, weeks)) || 0;
	          events = Math.ceil(lpw);
	        }
	        settings[subject.id] = { checked: checked, events: events };
	      }
	      return settings;
	    },
	    compareZenExportRowsByTypeThenName: function compareZenExportRowsByTypeThenName(a, b) {
	      var typeA = a.subjectType || '';
	      var typeB = b.subjectType || '';
	      var idxA = ZEN_EXPORT_SUBJECT_TYPE_ORDER.indexOf(typeA);
	      var idxB = ZEN_EXPORT_SUBJECT_TYPE_ORDER.indexOf(typeB);
	      if (idxA >= 0 && idxB >= 0 && idxA !== idxB) return idxA - idxB;
	      if (idxA >= 0 && idxB < 0) return -1;
	      if (idxA < 0 && idxB >= 0) return 1;
	      if (idxA < 0 && idxB < 0) {
	        var cmpType = typeA.localeCompare(typeB, 'da');
	        if (cmpType !== 0) return cmpType;
	      }
	      var nameA = a.subjectName || '';
	      var nameB = b.subjectName || '';
	      return nameA.localeCompare(nameB, 'da');
	    },
	    formatMessage: function formatMessage(template, params) {
	      var s = template || '';
	      (0, _keys2.default)(params).forEach(function (k) {
	        s = s.split('{' + k + '}').join(params[k]);
	      });
	      return s;
	    },
	    subjectTypeLabel: function subjectTypeLabel(type) {
	      if (!type) return '';
	      if (type === 'pool') return this.poolSubjectTypeLabel;
	      var label = this.t.subject_types[type];
	      return label || type;
	    },
	    subjectTypeFilterOptionLabel: function subjectTypeFilterOptionLabel(type) {
	      if (!type) return this.t.filter_no_type;
	      if (type === 'resource') return this.t.filter_resource_hidden;
	      if (type === 'person_resource') return this.t.filter_resource_personnel;
	      return this.subjectTypeLabel(type);
	    },
	    getTeacherNames: function getTeacherNames(subject) {
	      if (!subject.cals || !subject.cals.length) return '';
	      return subject.cals.filter(function (c) {
	        return c.calendar_type === 'user';
	      }).map(function (c) {
	        return c.name;
	      }).join(', ');
	    },
	    getRoomNames: function getRoomNames(subject) {
	      if (!subject.cals || !subject.cals.length) return '';
	      return subject.cals.filter(function (c) {
	        return c.calendar_type === 'room';
	      }).map(function (c) {
	        return c.name;
	      }).join(', ');
	    },
	    getOtherKlasses: function getOtherKlasses(subject) {
	      if (!subject.calendar_ids || !subject.calendar_ids.length) return '';
	      var calHash = this.allCalendarsInHash;
	      var primaryId = subject.calendar_id;
	      return subject.calendar_ids.filter(function (id) {
	        return id !== primaryId && calHash[id] && calHash[id].type === 'klass';
	      }).map(function (id) {
	        return calHash[id].name;
	      }).join(', ');
	    },
	    toggleRow: function toggleRow(row) {
	      var wasChecked = this.isRowChecked(row);
	      var events = this.rowEvents(row);
	      this.$set(this.localSettings, row.subjectId, {
	        checked: !wasChecked,
	        events: events
	      });
	    },
	    onEventsInput: function onEventsInput(row, event) {
	      var val = parseInt(event.target.value, 10);
	      var current = this.localSettings[row.subjectId];
	      if (current) {
	        this.$set(this.localSettings, row.subjectId, {
	          checked: current.checked,
	          events: isNaN(val) ? 0 : val
	        });
	      } else {
	        this.$set(this.localSettings, row.subjectId, {
	          checked: true,
	          events: isNaN(val) ? 0 : val
	        });
	      }
	    },
	    toggleAll: function toggleAll() {
	      var shouldCheck = !this.allChecked;
	      var rows = this.filteredActiveRows;
	      for (var i = 0; i < rows.length; i++) {
	        var row = rows[i];
	        this.$set(this.localSettings, row.subjectId, {
	          checked: shouldCheck,
	          events: this.rowEvents(row)
	        });
	      }
	    },
	    toggleGroup: function toggleGroup(group) {
	      var allChecked = this.isGroupAllChecked(group);
	      for (var i = 0; i < group.subjects.length; i++) {
	        var row = group.subjects[i];
	        this.$set(this.localSettings, row.subjectId, {
	          checked: !allChecked,
	          events: this.rowEvents(row)
	        });
	      }
	    },
	    isGroupAllChecked: function isGroupAllChecked(group) {
	      if (group.subjects.length === 0) return false;
	      for (var i = 0; i < group.subjects.length; i++) {
	        if (!this.isRowChecked(group.subjects[i])) return false;
	      }
	      return true;
	    },
	    saveAndExport: function saveAndExport() {
	      var _this5 = this;
	
	      this.isExporting = true;
	      this.$store.dispatch('trackEvent', 'zen_export_save');
	      var settings = this.collectAllSettings();
	      _docendo2.default.exportToZen(this.schoolId, this.schoolYearId, settings, function () {
	        _eventbus2.default.toast = { text: _this5.t.toast_exported_success, success: true };
	        _this5.isExporting = false;
	        _this5.$emit('exported');
	      }, function () {
	        _eventbus2.default.toast = { text: _this5.t.toast_export_failed, success: false };
	        _this5.isExporting = false;
	      });
	    },
	    handleKeydown: function handleKeydown(event) {
	      if (event.key === 'Escape') {
	        this.$emit('close');
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('readSubjects', this.schoolYearId);
	    window.addEventListener('keydown', this.handleKeydown);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('keydown', this.handleKeydown);
	  }
	};

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ChangeSchoolYear = __webpack_require__(19);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Spinner = __webpack_require__(26);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _vue2Datepicker = __webpack_require__(155);
	
	var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);
	
	var _ZenImportChanges = __webpack_require__(1691);
	
	var _ZenImportChanges2 = _interopRequireDefault(_ZenImportChanges);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Spinner: _Spinner2.default, Loader: _Loader2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, DatePicker: _vue2Datepicker2.default, ZenImportChanges: _ZenImportChanges2.default },
	  data: function data() {
	    return {
	      isLoading: false,
	      isSendingData: false,
	      schedules: [],
	      theSelected: null,
	      theDate: (0, _moment2.default)().format('YYYY-MM-DD')
	    };
	  },
	
	  computed: {
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    datepickerType: function datepickerType() {
	      return window.SCHOOL.id === 40235 ? 'date' : 'week';
	    },
	    datepickerLang: function datepickerLang() {
	      return {
	        formatLocale: {
	          firstDayOfWeek: window.SCHOOL.id === 40235 ? 0 : 1
	        }
	      };
	    },
	    datepickerFormat: function datepickerFormat() {
	      return window.SCHOOL.id === 40235 ? 'YYYY-MM-DD' : this.$t('vue2.zen_import.week') + ' w, YYYY';
	    }
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear(val) {
	      this.theDate = this.activeSchoolYear.student_time_start;
	    }
	  },
	  methods: {
	    isSelected: function isSelected(id) {
	      return this.theSelected === id;
	    },
	    setActiveSchedule: function setActiveSchedule(id) {
	      this.theSelected = id;
	    },
	    setDate: function setDate(date) {
	      this.theDate = date;
	    },
	    readVersions: function readVersions() {
	      var _this = this;
	
	      this.isLoading = true;
	      _docendo2.default.listImports(window.SCHOOL.id, function (versions) {
	        if (versions.length < 1) {
	          _this.schedules = [];
	        } else {
	          var sortedVersions = versions.sort(function (a, b) {
	            var aModified = a.modifiedAt ? a.modifiedAt : (0, _moment2.default)();
	            var bModified = b.modifiedAt ? b.modifiedAt : (0, _moment2.default)();
	            return new Date(bModified) - new Date(aModified);
	          });
	          _this.schedules = sortedVersions;
	          _this.theSelected = sortedVersions[0].scheduleUuid;
	        }
	        _this.isLoading = false;
	      }, function (failure) {
	        console.log('failure', failure);
	        _this.isLoading = false;
	      });
	    },
	    submitSchudules: function submitSchudules() {
	      var _this2 = this;
	
	      this.$store.dispatch('trackEvent', 'zen_import_submit');
	      this.isSendingData = true;
	      var serverDate = (0, _moment2.default)(this.theDate).isoWeekday(1).format('YYYY-MM-DD');
	      if (window.SCHOOL.id === 40235) {
	        serverDate = (0, _moment2.default)(this.theDate).format('YYYY-MM-DD');
	      }
	      _docendo2.default.enqueueImport(window.SCHOOL.id, this.theSelected, serverDate, this.activeSchoolYear.id, function (success) {
	        _eventbus2.default.toast = {
	          text: _this2.$t('vue2.zen_import.schedules_are_being_inserted') + ' ' + (0, _moment2.default)(_this2.theDate).isoWeek(),
	          success: true
	        };
	        _this2.isSendingData = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.common.something_went_wrong'), success: false };
	        _this2.isSendingData = false;
	      });
	    },
	    showHumanizeDate: function showHumanizeDate(date) {
	      _moment2.default.locale(window.USER.language);
	      var diff = (0, _moment2.default)().diff((0, _moment2.default)(date));
	      return _moment2.default.duration(diff).humanize() + ' ' + this.$t('vue2.common.ago');
	    },
	    showDate: function showDate(modifiedAt) {
	      _moment2.default.locale(window.USER.language);
	      return (0, _moment2.default)(modifiedAt).format('LLLL');
	    }
	  },
	  mounted: function mounted() {
	    this.readVersions();
	  }
	};

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _ZenChangeAction = __webpack_require__(1688);
	
	var _ZenChangeAction2 = _interopRequireDefault(_ZenChangeAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, DModal: _DModal2.default, ZenChangeAction: _ZenChangeAction2.default },
	  data: function data() {
	    return {
	      isLoading: false,
	      imports: [],
	      activeImport: null,
	      itemState: {},
	      schoolCalendars: [],
	      isDownloadingExcel: false
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return window.SCHOOL.id;
	    },
	    summary: function summary() {
	      return this.activeImport && this.activeImport.summary ? this.activeImport.summary : {};
	    },
	    createdCalendars: function createdCalendars() {
	      return this.summary.created_calendars || [];
	    },
	    changedCalendars: function changedCalendars() {
	      return this.summary.changed_calendars || [];
	    },
	    createdSubjects: function createdSubjects() {
	      return this.summary.created_subjects || [];
	    },
	    changedSubjects: function changedSubjects() {
	      return this.summary.changed_subjects || [];
	    },
	    calendarNamesById: function calendarNamesById() {
	      var map = {};
	      this.schoolCalendars.forEach(function (cal) {
	        map[cal.id] = cal.name;
	      });
	      this.createdCalendars.concat(this.changedCalendars).forEach(function (cal) {
	        map[cal.id] = cal.name;
	      });
	      return map;
	    },
	    classGroups: function classGroups() {
	      var _this = this;
	
	      var groups = {};
	      var ensure = function ensure(calendarId, name) {
	        if (!groups[calendarId]) {
	          groups[calendarId] = {
	            calendarId: calendarId,
	            name: name || _this.calendarName(calendarId),
	            createdItems: [],
	            changedItems: []
	          };
	        } else if (name) {
	          groups[calendarId].name = name;
	        }
	        return groups[calendarId];
	      };
	      var calendarType = this.$t('vue2.zen_import.type_calendar');
	      var subjectType = this.$t('vue2.zen_import.type_subject');
	      this.createdCalendars.forEach(function (cal) {
	        ensure(cal.id, cal.name).createdItems.push({
	          key: 'cal-' + cal.id, type: calendarType, id: cal.id, name: cal.name
	        });
	      });
	      this.changedCalendars.forEach(function (cal) {
	        ensure(cal.id, cal.name).changedItems.push({
	          key: 'cal-' + cal.id, type: calendarType, id: cal.id, name: cal.name, changes: cal.changes
	        });
	      });
	      this.createdSubjects.forEach(function (sub) {
	        ensure(sub.calendar_id).createdItems.push({
	          key: 'sub-' + sub.id, type: subjectType, id: sub.id, name: sub.name
	        });
	      });
	      this.changedSubjects.forEach(function (sub) {
	        ensure(sub.calendar_id).changedItems.push({
	          key: 'sub-' + sub.id, type: subjectType, id: sub.id, name: sub.name, changes: sub.changes
	        });
	      });
	      return (0, _keys2.default)(groups).map(function (id) {
	        return groups[id];
	      }).sort(function (a, b) {
	        return String(a.name).localeCompare(String(b.name), undefined, { numeric: true });
	      });
	    },
	    isEmptyImport: function isEmptyImport() {
	      return this.createdCalendars.length < 1 && this.changedCalendars.length < 1 && this.createdSubjects.length < 1 && this.changedSubjects.length < 1;
	    }
	  },
	  methods: {
	    readImports: function readImports() {
	      var _this2 = this;
	
	      this.isLoading = true;
	      _docendo2.default.listZenImports(this.schoolId, function (imports) {
	        _this2.imports = Array.isArray(imports) ? imports : [];
	        _this2.isLoading = false;
	        _this2.openImportFromUrl();
	      }, function (failure) {
	        console.log('failure', failure);
	        _this2.isLoading = false;
	      });
	    },
	    readSchoolCalendars: function readSchoolCalendars() {
	      var _this3 = this;
	
	      _docendo2.default.calendarsForSchool(this.schoolId, function (calendars) {
	        _this3.schoolCalendars = Array.isArray(calendars) ? calendars : [];
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    calendarName: function calendarName(calendarId) {
	      return this.calendarNamesById[calendarId] || '#' + calendarId;
	    },
	    openImportFromUrl: function openImportFromUrl() {
	      var match = window.location.search.match(/[?&]id=(\d+)/);
	      if (!match) {
	        return;
	      }
	      var id = match[1];
	      var imp = this.imports.find(function (item) {
	        return String(item.id) === id;
	      });
	      if (imp) {
	        this.openImport(imp);
	      }
	    },
	    openImport: function openImport(imp) {
	      this.itemState = {};
	      this.activeImport = imp;
	    },
	    closeImport: function closeImport() {
	      this.activeImport = null;
	    },
	    stateKey: function stateKey(type, id) {
	      return type + '-' + id;
	    },
	    setItemState: function setItemState(key, state) {
	      this.$set(this.itemState, key, state);
	    },
	    calendarChangeCount: function calendarChangeCount(imp) {
	      var s = imp.summary || {};
	      return (s.created_calendars || []).length + (s.changed_calendars || []).length;
	    },
	    subjectChangeCount: function subjectChangeCount(imp) {
	      var s = imp.summary || {};
	      return (s.created_subjects || []).length + (s.changed_subjects || []).length;
	    },
	    fieldLabel: function fieldLabel(field) {
	      var key = 'vue2.zen_import.field_' + field;
	      var translated = this.$t(key);
	      return translated === key ? field : translated;
	    },
	    diffList: function diffList(changes) {
	      var _this4 = this;
	
	      if (!changes) {
	        return [];
	      }
	      return (0, _keys2.default)(changes).map(function (field) {
	        return {
	          field: field,
	          label: _this4.fieldLabel(field),
	          from: _this4.formatValue(changes[field][0]),
	          to: _this4.formatValue(changes[field][1])
	        };
	      });
	    },
	    formatValue: function formatValue(value) {
	      if (value === null || value === undefined || value === '') {
	        return '–';
	      }
	      return value;
	    },
	    oldValues: function oldValues(changes) {
	      var result = {};
	      (0, _keys2.default)(changes || {}).forEach(function (field) {
	        result[field] = changes[field][0];
	      });
	      return result;
	    },
	    revertCalendar: function revertCalendar(item) {
	      var _this5 = this;
	
	      var key = this.stateKey('cal', item.id);
	      this.setItemState(key, 'loading');
	      var revertTo = this.revertableChanges(item.changes, ['name']);
	      _docendo2.default.schoolCalendarsUpdate(this.schoolId, item.id, revertTo, function () {
	        _this5.setItemState(key, 'reverted');
	      }, function (failure) {
	        _this5.handleFailure(key, failure);
	      });
	    },
	    revertSubject: function revertSubject(item) {
	      var _this6 = this;
	
	      var key = this.stateKey('sub', item.id);
	      this.setItemState(key, 'loading');
	      var revertTo = this.revertableChanges(item.changes, ['name', 'color']);
	      _docendo2.default.bulkUpdateSubjects(this.schoolId, [item.id], revertTo, function () {
	        _this6.setItemState(key, 'reverted');
	      }, function (failure) {
	        _this6.handleFailure(key, failure);
	      });
	    },
	    revertableChanges: function revertableChanges(changes, allowedFields) {
	      var old = this.oldValues(changes);
	      var result = {};
	      allowedFields.forEach(function (field) {
	        if (Object.prototype.hasOwnProperty.call(old, field)) {
	          result[field] = old[field];
	        }
	      });
	      return result;
	    },
	    asyncLoadXLSXAndDownload: function asyncLoadXLSXAndDownload() {
	      var _this7 = this;
	
	      this.isDownloadingExcel = true;
	      if (window.XLSX) {
	        this.downloadExcel();
	      } else {
	        var cdnXLSX = document.createElement('script');
	        cdnXLSX.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.mini.min.js');
	        document.head.appendChild(cdnXLSX);
	        var intervalTimer = setInterval(function () {
	          if (window.XLSX) {
	            clearInterval(intervalTimer);
	            _this7.downloadExcel();
	          }
	        }, 500);
	      }
	    },
	    downloadExcel: function downloadExcel() {
	      var _this8 = this;
	
	      var XLSX = window.XLSX;
	      var typeHeader = this.$t('vue2.zen_import.type_column');
	      var nameHeader = this.$t('vue2.zen_import.field_name');
	      var idHeader = 'ID';
	      var fieldHeader = this.$t('vue2.zen_import.excel_field');
	      var fromHeader = this.$t('vue2.zen_import.excel_old_value');
	      var toHeader = this.$t('vue2.zen_import.excel_new_value');
	      var rows = [];
	
	      this.classGroups.forEach(function (group) {
	        rows.push([group.name]);
	
	        if (group.createdItems.length) {
	          rows.push([_this8.$t('vue2.zen_import.created_title')]);
	          rows.push([typeHeader, idHeader, nameHeader]);
	          group.createdItems.forEach(function (item) {
	            rows.push([item.type, item.id, item.name]);
	          });
	        }
	
	        if (group.changedItems.length) {
	          rows.push([_this8.$t('vue2.zen_import.changed_title')]);
	          rows.push([typeHeader, idHeader, nameHeader, fieldHeader, fromHeader, toHeader]);
	          group.changedItems.forEach(function (item) {
	            _this8.diffList(item.changes).forEach(function (diff) {
	              rows.push([item.type, item.id, item.name, diff.label, diff.from, diff.to]);
	            });
	          });
	        }
	
	        rows.push([]);
	      });
	
	      var ws = XLSX.utils.aoa_to_sheet(rows);
	      ws['!cols'] = [{ wch: 12 }, { wch: 10 }, { wch: 30 }, { wch: 15 }, { wch: 25 }, { wch: 25 }];
	      var wb = XLSX.utils.book_new();
	      XLSX.utils.book_append_sheet(wb, ws, 'ZEN import');
	      XLSX.writeFile(wb, 'docendo_zen_import_' + this.activeImport.id + '.xlsx');
	      this.isDownloadingExcel = false;
	    },
	    handleFailure: function handleFailure(key, failure) {
	      console.log('failure', failure);
	      this.setItemState(key, 'idle');
	      _eventbus2.default.toast = { text: this.$t('vue2.common.something_went_wrong'), success: false };
	    },
	    showHumanizeDate: function showHumanizeDate(date) {
	      _moment2.default.locale(window.USER.language);
	      var diff = (0, _moment2.default)().diff((0, _moment2.default)(date));
	      return _moment2.default.duration(diff).humanize() + ' ' + this.$t('vue2.common.ago');
	    }
	  },
	  mounted: function mounted() {
	    this.readImports();
	    this.readSchoolCalendars();
	  }
	};

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(9);
	
	__webpack_require__(191);
	
	__webpack_require__(192);
	
	__webpack_require__(190);
	
	var _vueQuillEditor = __webpack_require__(422);
	
	var _DModal = __webpack_require__(4);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DoWeekPlanLog = __webpack_require__(407);
	
	var _DoWeekPlanLog2 = _interopRequireDefault(_DoWeekPlanLog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: {
	    quillEditor: _vueQuillEditor.quillEditor,
	    DModal: _DModal2.default,
	    DoWeekPlanLog: _DoWeekPlanLog2.default
	  },
	  props: {
	    isUploadFile: {
	      type: Boolean,
	      default: false
	    },
	    isUploadImage: {
	      type: Boolean,
	      default: false
	    },
	    textInput: {
	      type: String,
	      default: ''
	    },
	    lesson: {
	      type: Object,
	      default: function _default() {
	        return null;
	      }
	    },
	    noteType: {
	      type: String,
	      default: ''
	    },
	    isOpen: {
	      type: Boolean,
	      default: false
	    },
	    isInTestOfSaveButton: {
	      type: Boolean,
	      default: true
	    },
	    isInDCalendar: {
	      type: Boolean,
	      default: false
	    },
	    isKeepOpen: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      editor: null,
	      uniqueNum: 1,
	      isChanged: false,
	      edit: false,
	      text: '',
	      linkText: '',
	      link: '',
	      isMouseDown: false,
	      isLinkModal: false,
	      editorOption: {},
	      placeholder: '',
	      isClosingWithoutSaving: false
	    };
	  },
	
	  computed: {
	    linkWithHttp: function linkWithHttp() {
	      var withHttp = function withHttp(url) {
	        return !/^https?:\/\//i.test(url) ? 'http://' + url : url;
	      };
	      return withHttp(this.link);
	    },
	    isValidURL: function isValidURL() {
	      return this.checkValidURL(this.linkWithHttp);
	    },
	    isValidated: function isValidated() {
	      return this.isValidURL && this.linkText.length > 0;
	    },
	    textWithoutHTML: function textWithoutHTML() {
	      return this.text ? this.text.replace(/<\/?p[^>]*>/g, '') : '';
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return {
	        da: {
	          bold: 'Fed',
	          italic: 'Kursiv',
	          underline: 'Understreget',
	          list_ordered: 'Liste nummereret',
	          list_bullets: 'Liste i punktform',
	          insert_link: 'Indsæt link',
	          link_text_label: 'Tekst der skal vises',
	          link_text_placeholder: 'eks. Docendo',
	          link_link_label: 'Webadressen',
	          link_link_placeholder: 'eks. www.docendo.dk',
	          cancel: 'Annuller'
	        },
	        en: {
	          bold: 'Bold',
	          italic: 'Italic',
	          underline: 'Underline',
	          list_ordered: 'List Ordered',
	          list_bullets: 'List i punktform',
	          insert_link: 'Insert link',
	          link_text_label: 'Text to be shown',
	          link_text_placeholder: 'e.g. Docendo',
	          link_link_label: 'Web address',
	          link_link_placeholder: 'e.g. www.docendo.co',
	          cancel: 'Cancel'
	        },
	        nb: {
	          bold: 'Fet',
	          italic: 'Kursiv',
	          underline: 'Understreket',
	          list_ordered: 'Punktliste',
	          list_bullets: 'Nummerert liste',
	          insert_link: 'Sett inn link',
	          link_text_label: 'Tekst som skal vises',
	          link_text_placeholder: 'eks. Docendo',
	          link_link_label: 'Nettadressen',
	          link_link_placeholder: 'eks. www.docendo.no',
	          cancel: 'Annuller'
	        }
	      };
	    }
	  },
	  watch: {
	    lesson: {
	      handler: function handler(newValue, oldVal) {
	        this.text = this.lesson[this.noteType];
	      },
	
	      deep: true
	    },
	    textInput: function textInput(val) {
	      if (!this.lesson) {
	        this.text = val;
	      }
	    }
	  },
	  methods: {
	    checkValidURL: function checkValidURL(str) {
	      return true;
	    },
	    setIsLinkModal: function setIsLinkModal(boolean) {
	      var _this = this;
	
	      if (!boolean) {
	        this.linkText = '';
	        this.link = '';
	      } else {
	        setTimeout(function (_) {
	          _this.$refs.linkTextInput.focus();
	        }, 500);
	      }
	      this.isLinkModal = boolean;
	    },
	    insertLink: function insertLink() {
	      this.editor.focus();
	      var index = (this.editor.getSelection() || {}).index || this.editor.getLength() - 1;
	      this.editor.insertText(index, this.linkText, 'link', this.linkWithHttp);
	      this.setIsLinkModal(false);
	    },
	    onEditorReady: function onEditorReady(quill) {
	      this.editor = quill;
	      quill.focus();
	    },
	    onUploadFile: function onUploadFile(e) {
	      console.log('show some file uploading');
	    },
	    setEdit: function setEdit() {
	      var _this2 = this;
	
	      if (_eventbus2.default.isLessonNoteChangedWithoutSaving && !this.isInDCalendar) {
	        return;
	      }
	
	      document.querySelectorAll('.d-quill__toolbar').forEach(function (el) {
	        if (el.dataset.num >= _this2.uniqueNum) {
	          _this2.uniqueNum = el.dataset.num * 1 + 1;
	        }
	      });
	      this.editorOption = {
	        modules: {
	          toolbar: {
	            container: '#toolbar_' + this.uniqueNum
	          }
	        },
	        clipboard: {
	          matchVisual: false
	        }
	      };
	      this.$emit('open');
	      this.edit = true;
	    },
	    closeEdit: function closeEdit(event) {
	      if (this.isKeepOpen) {
	        return;
	      }
	      if (this.isInDCalendar) {
	        this.edit = false;
	        return;
	      }
	      if (this.isChanged && this.isInTestOfSaveButton) {
	        this.isClosingWithoutSaving = true;
	        return;
	      }
	      if (!this.isChanged && this.isInTestOfSaveButton) {
	        this.edit = false;
	        return;
	      }
	      if (event.target.classList.contains('ap')) {
	        return;
	      }
	      if (this.isMouseDown) {
	        this.isMouseDown = false;
	        return;
	      }
	      if (!this.edit) {
	        return;
	      }
	      if (this.lesson) {
	        this.$emit('close', { lesson: this.lesson, noteType: this.noteType, text: this.text });
	      } else {
	        this.$emit('close', { text: this.text });
	      }
	      this.edit = false;
	    },
	    cancel: function cancel() {
	      this.edit = false;
	      if (this.lesson) {
	        this.text = this.lesson[this.noteType];
	      } else {
	        this.text = this.textInput;
	      }
	      this.isClosingWithoutSaving = false;
	      this.isChanged = false;
	      this.$emit('close', false);
	      _eventbus2.default.isLessonNoteChangedWithoutSaving = false;
	    },
	    save: function save() {
	      this.edit = false;
	      if (this.lesson) {
	        this.$emit('close', { lesson: this.lesson, noteType: this.noteType, text: this.text });
	      } else {
	        this.$emit('close', { text: this.text });
	      }
	      this.isClosingWithoutSaving = false;
	      this.isChanged = false;
	      _eventbus2.default.isLessonNoteChangedWithoutSaving = false;
	    },
	    onEditorChange: function onEditorChange(_ref) {
	      var quill = _ref.quill,
	          html = _ref.html,
	          text = _ref.text;
	
	      this.text = html;
	
	      if (this.textInput && this.textInput === html) {
	        return;
	      }
	      this.isChanged = true;
	      this.$emit('changed', this.text);
	      if (this.isInTestOfSaveButton) {
	        _eventbus2.default.isLessonNoteChangedWithoutSaving = true;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.isOpen) {
	      this.setEdit();
	    }
	  },
	  mounted: function mounted() {
	    if (this.textInput) {
	      this.text = this.textInput;
	      return;
	    }
	    if (this.lesson && this.noteType) {
	      this.text = this.lesson[this.noteType];
	    }
	    window.addEventListener('beforeunload', function (e) {
	      var confirmMessage = 'Continue without saving?';
	      if (_eventbus2.default.isLessonNoteChangedWithoutSaving) {
	        (e || window.event).returnValue = confirmMessage;
	        return confirmMessage;
	      }
	    });
	  }
	};

/***/ }),
/* 836 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    preselectedTab: {
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      activeTab: this.preselectedTab
	    };
	  },
	
	  methods: {
	    setTab: function setTab(num) {
	      this.activeTab = num;
	      this.$emit('update', num);
	    },
	    isActiveTab: function isActiveTab(num) {
	      return num === this.activeTab;
	    }
	  }
	};

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(32);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appModalStack = [];
	
	exports.default = {
	  props: {
	    submitTxt: {
	      type: String,
	      default: 'OK'
	    },
	    isShowFooter: {
	      default: true,
	      type: Boolean
	    },
	    modalResponsive: {
	      default: false,
	      type: Boolean
	    },
	    modalFlexContainer: {
	      default: false,
	      type: Boolean
	    },
	
	    ariaLabel: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {};
	  },
	
	  methods: {
	    getFocusable: function getFocusable() {
	      var root = this.$refs.modalContent;
	      if (!root) return [];
	      var selector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
	      return (0, _from2.default)(root.querySelectorAll(selector)).filter(function (el) {
	        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
	      });
	    },
	    focusInitial: function focusInitial() {
	      var root = this.$refs.modalContent;
	      if (!root) return;
	      if (root.contains(document.activeElement) && document.activeElement !== root) {
	        return;
	      }
	      var focusable = this.getFocusable();
	      var field = focusable.find(function (el) {
	        return (/^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName)
	        );
	      });
	      var target = field || focusable[0] || root;
	      target.focus();
	    },
	    handleKeydown: function handleKeydown(event) {
	      if (appModalStack[appModalStack.length - 1] !== this) return;
	      if (event.key === 'Escape') {
	        this.$emit('close');
	        return;
	      }
	
	      if (event.key === 'Tab') {
	        var root = this.$refs.modalContent;
	        if (!root) return;
	        var focusable = this.getFocusable();
	        if (focusable.length === 0) {
	          event.preventDefault();
	          root.focus();
	          return;
	        }
	        var first = focusable[0];
	        var last = focusable[focusable.length - 1];
	        if (!root.contains(document.activeElement)) {
	          event.preventDefault();
	          first.focus();
	        } else if (event.shiftKey && document.activeElement === first) {
	          event.preventDefault();
	          last.focus();
	        } else if (!event.shiftKey && document.activeElement === last) {
	          event.preventDefault();
	          first.focus();
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    appModalStack.push(this);
	    window.addEventListener('keydown', this.handleKeydown);
	    this.$nextTick(function () {
	      _this.focusInitial();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var idx = appModalStack.indexOf(this);
	    if (idx > -1) {
	      appModalStack.splice(idx, 1);
	    }
	    window.removeEventListener('keydown', this.handleKeydown);
	  }
	};

/***/ }),
/* 838 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    propOn: {
	      default: true
	    },
	    allowChanges: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      isOn: this.propOn
	    };
	  },
	
	  watch: {
	    propOn: function propOn(val, oldVal) {
	      if (this.propOn !== this.isOn) {
	        this.isOn = this.propOn;
	      }
	    },
	    isOn: function isOn() {
	      this.$emit('changed', this.isOn);
	    }
	  },
	  methods: {
	    toggleIsOn: function toggleIsOn() {
	      if (!this.allowChanges) {
	        return;
	      }
	      this.isOn = !this.isOn;
	    }
	  }
	};

/***/ }),
/* 839 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Banner',
	  computed: {
	    noActiveSchoolYears: function noActiveSchoolYears() {
	      return this.$store.state.noActiveSchoolYears;
	    }
	  }
	};

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(9);
	
	var _core = __webpack_require__(25);
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    appendToBody: {
	      type: Boolean,
	      default: true
	    },
	    isShowDots: {
	      type: Boolean,
	      default: true
	    },
	    isBottomStart: {
	      type: Boolean,
	      default: true
	    },
	    propOffset: {
	      type: Array,
	      default: function _default() {
	        return null;
	      }
	    },
	    isCloseOnDropdownClick: {
	      type: Boolean,
	      default: true
	    },
	    closeFromProp: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      isDropDown: false,
	      isPopperDone: false,
	      isPopperReady: false
	    };
	  },
	
	  watch: {
	    closeFromProp: function closeFromProp(val, oldVal) {
	      if (this.isDropDown) {
	        this.setDropdown();
	      }
	    }
	  },
	  methods: {
	    createPopper: function createPopper() {
	      var _this = this;
	
	      this.isPopperReady = false;
	      this.isPopperDone = false;
	      var dChild = this.$refs.d_child;
	      var dParent = this.$refs.d_parent;
	      if (this.appendToBody) {
	        document.getElementById('djs-body-click').appendChild(dChild);
	      }
	      var dOffset = this.isShowDots ? [5, 5] : [0, -20];
	      if (this.propOffset) {
	        dOffset = this.propOffset;
	      }
	      var dPlacement = this.isBottomStart ? 'bottom-start' : 'bottom-end';
	      (0, _core.createPopper)(dParent, dChild, {
	        placement: dPlacement,
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: dOffset
	          }
	        }]
	      });
	      setTimeout(function (_) {
	        _this.isPopperReady = true;
	        _this.isPopperDone = true;
	      }, 0);
	    },
	    setDropdown: function setDropdown() {
	      var _this2 = this;
	
	      this.isDropDown = !this.isDropDown;
	      if (this.isDropDown) {
	        this.$emit('open');
	        this.$nextTick(function (_) {
	          _this2.createPopper();
	        });
	      } else {
	        this.$emit('onClose');
	        this.isPopperReady = false;
	        this.isPopperDone = false;
	      }
	    },
	    setDropdownFromClick: function setDropdownFromClick() {
	      if (!this.isDropDown || !this.isCloseOnDropdownClick) {
	        return;
	      }
	      this.setDropdown();
	    },
	    onClickOutside: function onClickOutside() {
	      if (this.isCloseOnDropdownClick) {
	        return;
	      }
	      if (this.isDropDown) {
	        this.setDropdown();
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    var dChild = this.$refs.d_child;
	    if (dChild) {
	      dChild.remove();
	    }
	  }
	};

/***/ }),
/* 841 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DFilters',
	  props: {
	    initialFilter: {
	      default: ''
	    },
	    filters: {
	      type: Array,
	      default: function _default() {
	        return [{ label: 'Alle', value: '', length: 20 }, { label: 'Undervisning', value: 'person_resource', length: 10 }, { label: 'Øvrige opgaver', value: 'additional_tasks', length: 8 }, { label: 'Forberedelse', value: 'preparation', length: 2 }];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      left: 0,
	      width: 0
	    };
	  },
	
	  watch: {
	    initialFilter: function initialFilter() {
	      this.selectorSliderLeft();
	    }
	  },
	  methods: {
	    setFilter: function setFilter(filter) {
	      this.$emit('set', filter.value);
	    },
	    isFilter: function isFilter(filterValue) {
	      return this.initialFilter === filterValue;
	    },
	    selectorSliderLeft: function selectorSliderLeft() {
	      var el = document.querySelector('#filter_' + this.initialFilter);
	      if (!el) {
	        return;
	      }
	      var parentBCR = this.$refs.dfilters.getBoundingClientRect();
	      var BCR = el.getBoundingClientRect();
	      this.width = BCR.width + 'px';
	      this.left = BCR.left * 1 - parentBCR.left * 1 + 'px';
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    setTimeout(function (_) {
	      _this.selectorSliderLeft();
	    }, 500);
	  }
	};

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(32);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalStack = [];
	
	var printableModalCount = 0;
	
	exports.default = {
	  props: {
	    showClose: {
	      type: Boolean,
	      default: true
	    },
	    isBgOverlay: {
	      type: Boolean,
	      default: false
	    },
	    appendToBody: {
	      type: Boolean,
	      default: false
	    },
	    placeInTop: {
	      type: Boolean,
	      default: false
	    },
	    pxFromTop: {
	      type: Number,
	      default: 2
	    },
	    isCloseOnEsc: {
	      type: Boolean,
	      default: true
	    },
	    isCloseOnBgClick: {
	      type: Boolean,
	      default: true
	    },
	
	    ariaLabel: {
	      type: String,
	      default: ''
	    },
	
	    isPrintable: {
	      type: Boolean,
	      default: false
	    },
	
	    autoFocusField: {
	      type: Boolean,
	      default: true
	    },
	
	    zIndex: {
	      type: Number,
	      default: null
	    }
	  },
	  data: function data() {
	    return {};
	  },
	
	  methods: {
	    onBgClick: function onBgClick() {
	      if (this.isCloseOnBgClick) {
	        this.$emit('close');
	      }
	    },
	    getFocusable: function getFocusable() {
	      var root = this.$refs.modalContent;
	      if (!root) return [];
	      var selector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
	      return (0, _from2.default)(root.querySelectorAll(selector)).filter(function (el) {
	        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
	      });
	    },
	    focusInitial: function focusInitial() {
	      var root = this.$refs.modalContent;
	      if (!root) return;
	      if (root.contains(document.activeElement) && document.activeElement !== root) {
	        return;
	      }
	      if (!this.autoFocusField) {
	        root.focus();
	        return;
	      }
	      var focusable = this.getFocusable();
	      var field = focusable.find(function (el) {
	        return (/^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName)
	        );
	      });
	      var target = field || focusable[0] || root;
	      target.focus();
	    },
	    handleKeydown: function handleKeydown(event) {
	      if (modalStack[modalStack.length - 1] !== this) return;
	      if (event.key === 'Escape') {
	        if (this.isCloseOnEsc) {
	          this.$emit('close');
	        }
	        return;
	      }
	
	      if (event.key === 'Tab') {
	        var focusable = this.getFocusable();
	        var root = this.$refs.modalContent;
	        if (!root) return;
	        if (focusable.length === 0) {
	          event.preventDefault();
	          root.focus();
	          return;
	        }
	        var first = focusable[0];
	        var last = focusable[focusable.length - 1];
	        if (!root.contains(document.activeElement)) {
	          event.preventDefault();
	          first.focus();
	        } else if (event.shiftKey && document.activeElement === first) {
	          event.preventDefault();
	          last.focus();
	        } else if (!event.shiftKey && document.activeElement === last) {
	          event.preventDefault();
	          first.focus();
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (this.appendToBody) {
	      var el = this.$refs.d_modal;
	      var container = document.getElementById('djs-content-container');
	
	      if (el && container) {
	        container.appendChild(el);
	      }
	    }
	    modalStack.push(this);
	    if (this.isPrintable) {
	      printableModalCount++;
	      document.body.classList.add('is-printing-modal');
	    }
	    window.addEventListener('keydown', this.handleKeydown);
	
	    this.$nextTick(function () {
	      _this.focusInitial();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var el = this.$refs.d_modal;
	    if (el && el.parentNode) {
	      el.parentNode.removeChild(el);
	    }
	    var idx = modalStack.indexOf(this);
	    if (idx > -1) {
	      modalStack.splice(idx, 1);
	    }
	    if (this.isPrintable) {
	      printableModalCount = Math.max(0, printableModalCount - 1);
	      if (printableModalCount === 0) {
	        document.body.classList.remove('is-printing-modal');
	      }
	    }
	    window.removeEventListener('keydown', this.handleKeydown);
	  }
	};

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _core = __webpack_require__(25);
	
	exports.default = {
	  data: function data() {
	    return {
	      isHovered: false
	    };
	  },
	
	  methods: {
	    createPopper: function createPopper() {
	      var el = this.$refs.d_question;
	      var source = this.$refs.d_popover;
	      document.getElementById('djs-content-container').appendChild(source);
	      (0, _core.createPopper)(el, source, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [5, 5]
	          }
	        }]
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.createPopper();
	  },
	  beforeDestroy: function beforeDestroy() {
	    var source = this.$refs.d_popover;
	    if (source) {
	      source.remove();
	    }
	  }
	};

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DateSelector: _DateSelector2.default },
	  props: {
	    selectedDate: {
	      default: function _default() {
	        return null;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      date: (0, _moment2.default)(),
	      isDatepickerOpen: false
	    };
	  },
	
	  computed: {
	    selectedDateFormatted: function selectedDateFormatted() {
	      return (0, _moment2.default)(this.selectedDate).format('DD/MM-YY');
	    }
	  },
	  methods: {
	    setDate: function setDate(date) {
	      this.$emit('dateChanged', date);
	    }
	  }
	};

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    date: {
	      default: (0, _moment2.default)()
	    }
	  },
	  computed: {
	    isToday: function isToday() {
	      return (0, _moment2.default)(this.date).format('YYYY-MM-DD') === (0, _moment2.default)().format('YYYY-MM-DD');
	    },
	    tooltipArrowLeft: function tooltipArrowLeft() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span><span>←</span></p>';
	    },
	    tooltipArrowRight: function tooltipArrowRight() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span><span>→</span></p>';
	    },
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    }
	  }
	};

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DoLogo = __webpack_require__(411);
	
	var _DoLogo2 = _interopRequireDefault(_DoLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DoLogo: _DoLogo2.default }
	};

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(9);
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    show: {
	      type: Boolean,
	      default: false
	    },
	    buttonText: {
	      type: String,
	      default: 'Drop Up!'
	    }
	  },
	  exampleData: {
	    buttonText: 'Click me!'
	  },
	  methods: {
	    open: function open() {
	      this.$emit('open');
	    },
	    close: function close() {
	      this.$emit('close');
	    }
	  }
	};

/***/ }),
/* 848 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  computed: {
	    isIEorEdge: function isIEorEdge() {
	      var isIE = false || !!document.documentMode;
	
	      var isEdge = !isIE && !!window.StyleMedia;
	
	      return isIE || isEdge;
	    }
	  }
	};

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    bgColor: {
	      default: '#edf0f5'
	    },
	    isSmall: {
	      type: Boolean,
	      default: false
	    },
	    isExtraSmall: {
	      type: Boolean,
	      default: false
	    },
	    isLoaderModal: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    styleObj: function styleObj() {
	      return {
	        '--bgColor': this.bgColor
	      };
	    }
	  }
	};

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default },
	  props: {
	    schools: {
	      type: Array,
	      default: []
	    },
	    selectedSchoolIds: {
	      type: Array,
	      default: []
	    },
	    permission: {
	      default: 'can_manage_salary'
	    }
	  },
	  computed: {
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    selectedTitle: function selectedTitle() {
	      if (this.selectedSchoolIds.length === 0) {
	        return 'Vælg skole';
	      }
	      if (this.selectedSchoolIds.length === 1) {
	        var id = this.selectedSchoolIds[0];
	        var school = this.schools.find(function (school) {
	          return school.id === id;
	        });
	        return school ? school['name'] : 'Unavngiven skole';
	      }
	      if (this.selectedSchoolIds.length > 1) {
	        return this.selectedSchoolIds.length + ' skoler valgt';
	      }
	    },
	    userSchoolsSorted: function userSchoolsSorted() {
	      var _this = this;
	
	      console.log('this.schools', this.schools);
	      return this.schools.filter(function (school) {
	        return _this.getHasPermission(school);
	      }).map(function (school) {
	        return (0, _extends3.default)({}, school, {
	          v_is_selected: _this.getIsSelected(school)
	        });
	      }).sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    userMemberships: function userMemberships() {
	      return this.$store.getters.userSchools;
	    }
	  },
	  methods: {
	    toggleSchool: function toggleSchool(school) {
	      this.$emit('toggleSchool', school);
	    },
	    getIsSelected: function getIsSelected(school) {
	      return this.selectedSchoolIds.includes(school.id);
	    },
	    getHasPermission: function getHasPermission(school) {
	      var schoolMember = this.userMemberships[school.id];
	      if (!schoolMember) {
	        return false;
	      }
	      return schoolMember['permissions'].indexOf(this.permission) > -1;
	    },
	    onSelectionChange: function onSelectionChange() {
	      this.$emit('schools-changed', this.selectedSchoolIds);
	    }
	  }
	};

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(9);
	
	var _core = __webpack_require__(25);
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    isMultiple: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      isDropDown: false,
	      isPopperDone: false,
	      isPopperReady: false,
	      search: ''
	    };
	  },
	
	  computed: {
	    activeCalendar: function activeCalendar() {
	      return this.$store.state.calendar.calendar;
	    },
	    klassCalendars: function klassCalendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    userCalendars: function userCalendars() {
	      return this.$store.getters.userCalendars;
	    },
	    roomCalendars: function roomCalendars() {
	      return this.$store.getters.roomCalendars;
	    },
	    mergeCalendars: function mergeCalendars() {
	      return this.$store.getters.mergeCalendars;
	    },
	    otherCalendars: function otherCalendars() {
	      return this.$store.getters.otherCalendars;
	    },
	    activeCalendarName: function activeCalendarName() {
	      return this.activeCalendar ? this.activeCalendar.name : '';
	    },
	    sortedCalendars: function sortedCalendars() {
	      if (this.activeCalendar) {
	        switch (this.activeCalendar.type) {
	          case 'klass':
	            return this.klassCalendars;
	          case 'user':
	            return this.userCalendars;
	          case 'room':
	            return this.roomCalendars;
	          case 'merge':
	            return this.mergeCalendars;
	          case 'other':
	            return this.otherCalendars;
	          default:
	            return [];
	        }
	      } else {
	        return [];
	      }
	    },
	    calendarQuery: function calendarQuery() {
	      var _this = this;
	
	      return this.sortedCalendars.filter(function (item) {
	        return item.name !== null && item.id !== _this.activeCalendar.id ? item.name.match(new RegExp(_this.search, 'i')) : '';
	      });
	    }
	  },
	  methods: {
	    selectCalendar: function selectCalendar(calendarId) {
	      this.$store.commit('setActiveCalendarId', calendarId);
	      this.setDropdown();
	    },
	    createPopper: function createPopper() {
	      var _this2 = this;
	
	      this.isPopperReady = false;
	      this.isPopperDone = false;
	      var dChild = this.$refs.d_child;
	      var dParent = this.$refs.d_parent;
	      if (this.appendToBody) {
	        document.getElementById('djs-body-click').appendChild(dChild);
	      }
	      (0, _core.createPopper)(dParent, dChild, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, 0]
	          }
	        }]
	      });
	      this.$nextTick(function (_) {
	        _this2.isPopperReady = true;
	        _this2.isPopperDone = true;
	        setTimeout(function (_) {
	          _this2.$refs.inputsearch.focus();
	        }, 200);
	      });
	    },
	    setDropdown: function setDropdown() {
	      var _this3 = this;
	
	      if (!this.isMultiple || this.sortedCalendars.length < 2) {
	        return;
	      }
	      this.isDropDown = !this.isDropDown;
	      if (this.isDropDown) {
	        this.$nextTick(function (_) {
	          _this3.createPopper();
	        });
	      } else {
	        this.isPopperReady = false;
	        this.isPopperDone = false;
	        this.search = '';
	      }
	    },
	    setDropdownFromClick: function setDropdownFromClick() {
	      if (!this.isDropDown) {
	        return;
	      }
	      this.setDropdown();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    var dChild = this.$refs.d_child;
	    if (dChild) {
	      dChild.remove();
	    }
	  }
	};

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(9);
	
	var _core = __webpack_require__(25);
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    preSelectedUserId: {
	      default: 13
	    },
	    userName: {
	      default: ''
	    },
	    path: {
	      type: String,
	      default: 'tasks'
	    }
	  },
	  data: function data() {
	    return {
	      selectedUserId: null,
	      isDropDown: false,
	      isPopperDone: false,
	      isPopperReady: false,
	      search: ''
	    };
	  },
	
	  computed: {
	    selectedUser: function selectedUser() {
	      var _this = this;
	
	      var idx = this.users.findIndex(function (user) {
	        return user.id === _this.selectedUserId * 1;
	      });
	      return this.users[idx];
	    },
	    users: function users() {
	      return this.$store.state.allUsers;
	    },
	    usersSorted: function usersSorted() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    usersQuery: function usersQuery() {
	      var _this2 = this;
	
	      return this.usersSorted.filter(function (item) {
	        return item.name !== null ? item.name.match(new RegExp(_this2.search, 'i')) : '';
	      });
	    }
	  },
	  methods: {
	    selectUser: function selectUser(id) {
	      this.selectedUserId = id;
	      window.location = '/users/' + id + '/' + this.path + '#';
	    },
	    createPopper: function createPopper() {
	      var _this3 = this;
	
	      this.isPopperReady = false;
	      this.isPopperDone = false;
	      var dChild = this.$refs.d_child;
	      var dParent = this.$refs.d_parent;
	      if (this.appendToBody) {
	        document.getElementById('djs-body-click').appendChild(dChild);
	      }
	      (0, _core.createPopper)(dParent, dChild, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, 0]
	          }
	        }]
	      });
	      setTimeout(function (_) {
	        _this3.isPopperReady = true;
	        _this3.isPopperDone = true;
	      }, 0);
	      setTimeout(function (_) {
	        _this3.scrollToSelectedUser();
	      }, 200);
	    },
	    scrollToSelectedUser: function scrollToSelectedUser() {
	      if (this.$refs.inputsearch) {
	        this.$refs.inputsearch.focus();
	      }
	      var list = this.$refs.d_list;
	      var selectedRef = this.$refs.selectedUser;
	      var selectedEl = Array.isArray(selectedRef) ? selectedRef[0] : selectedRef;
	      if (list && selectedEl) {
	        list.scrollTop = selectedEl.offsetTop - list.clientHeight / 2 + selectedEl.clientHeight / 2;
	      }
	    },
	    setDropdown: function setDropdown() {
	      var _this4 = this;
	
	      this.isDropDown = !this.isDropDown;
	      if (this.isDropDown) {
	        setTimeout(function (_) {
	          _this4.createPopper();
	        }, 0);
	      } else {
	        this.isPopperReady = false;
	        this.isPopperDone = false;
	        this.search = '';
	      }
	    },
	    setDropdownFromClick: function setDropdownFromClick() {
	      if (!this.isDropDown) {
	        return;
	      }
	      this.setDropdown();
	    }
	  },
	  mounted: function mounted() {
	    if (this.preSelectedUserId) {
	      this.selectedUserId = this.preSelectedUserId;
	    }
	    this.$store.dispatch('getUsers');
	  },
	  beforeDestroy: function beforeDestroy() {
	    var dChild = this.$refs.d_child;
	    if (dChild) {
	      dChild.remove();
	    }
	  }
	};

/***/ }),
/* 853 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'spinner',
	  props: {
	    color: {
	      type: String,
	      default: 'white'
	    },
	    size: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 854 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    tabs: {
	      type: Array,
	      default: function _default() {
	        return [{ id: 'minutes', title: 'Show as minutes' }, { id: 'hours', title: 'Show as hours' }];
	      }
	    },
	    selected: {
	      type: String,
	      default: 'minutes'
	    },
	    isLarge: {
	      type: Boolean,
	      default: false
	    },
	    flatDesign: {
	      type: Boolean,
	      default: false
	    }
	  },
	  methods: {
	    onSelect: function onSelect(tab) {
	      if (tab.disabled) return;
	      this.$emit('select', tab.id);
	    }
	  }
	};

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    val1: {
	      type: String,
	      default: '17/18'
	    },
	    val2: {
	      type: String,
	      default: '18/19'
	    },
	    value: {
	      default: 1
	    }
	  },
	  methods: {
	    setValue: function setValue(val) {
	      this.currValue = val;
	      this.$emit('changed', val);
	    },
	    checkValue: function checkValue(val) {
	      return this.value * 1 === val;
	    }
	  }
	};

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DateSelector = __webpack_require__(16);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'datepickerrange',
	  components: { dateselector: _DateSelector2.default },
	  props: {
	    allowSameDate: {
	      type: Boolean,
	      default: false
	    },
	    startdate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    enddate: {
	      default: function _default() {
	        return this.allowSameDate ? (0, _moment2.default)() : (0, _moment2.default)().add(1, 'days');
	      }
	    },
	    maximumDateRange: {
	      type: Number,
	      default: null },
	    minDate: {
	      default: null
	    },
	    maxDate: {
	      default: null
	    },
	    maxEndDate: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      start: this.startdate,
	      end: this.enddate
	    };
	  },
	
	  watch: {
	    enddate: function enddate() {
	      this.end = this.enddate;
	    },
	    startdate: function startdate() {
	      this.start = this.startdate;
	    }
	  },
	  methods: {
	    checkIfDatesAreMoreThanMaxRange: function checkIfDatesAreMoreThanMaxRange(startDate, endDate) {
	      if (!this.maximumDateRange || this.maximumDateRange <= 0) {
	        return false;
	      }
	
	      var start = (0, _moment2.default)(startDate);
	      var end = (0, _moment2.default)(endDate);
	      var dateDifference = end.diff(start, 'days');
	
	      return dateDifference > this.maximumDateRange;
	    },
	    setStartDate: function setStartDate(date) {
	      var _this = this;
	
	      if (this.startIsAfterEnd(date, this.end)) {
	        this.setEndDate(this.addDaysToEnd(date));
	      }
	      if (this.checkIfDatesAreMoreThanMaxRange(date, this.end)) {
	        var txt = this.$t('vue2.datepicker.max_date_range_start') + ' ' + this.maximumDateRange + ' ' + this.$t('vue2.datepicker.max_date_range_end');
	        _eventbus2.default.toast = { text: txt, 'success': false };
	        var newEndDate = (0, _moment2.default)(date).add(this.maximumDateRange, 'days');
	        this.setEndDate(newEndDate);
	      }
	      this.start = date;
	      setTimeout(function (_) {
	        _this.$emit('startchanged', _this.start);
	      }, 0);
	    },
	    setEndDate: function setEndDate(date) {
	      var _this2 = this;
	
	      if (this.maxEndDate && (0, _moment2.default)(date).isAfter((0, _moment2.default)(this.maxEndDate), 'day')) {
	        date = (0, _moment2.default)(this.maxEndDate);
	      }
	      if (this.startIsAfterEnd(this.start, date)) {
	        this.setStartDate(this.substractDaysToStart(date));
	      }
	      if (this.checkIfDatesAreMoreThanMaxRange(this.start, date)) {
	        var txt = this.$t('vue2.datepicker.max_date_range_start') + ' ' + this.maximumDateRange + ' ' + this.$t('vue2.datepicker.max_date_range_end');
	        _eventbus2.default.toast = { text: txt, 'success': false };
	        var newStartDate = (0, _moment2.default)(date).subtract(this.maximumDateRange, 'days');
	        this.setStartDate(newStartDate);
	      }
	      this.end = date;
	      setTimeout(function (_) {
	        _this2.$emit('endchanged', _this2.end);
	      });
	    },
	    startIsAfterEnd: function startIsAfterEnd(startDate, endDate) {
	      var start = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	      var end = (0, _moment2.default)(endDate).format('YYYY-MM-DD');
	      if (this.allowSameDate) {
	        return (0, _moment2.default)(start).isAfter(end);
	      } else {
	        return (0, _moment2.default)(start).isSameOrAfter(end);
	      }
	    },
	    addDaysToEnd: function addDaysToEnd(date) {
	      if (this.allowSameDate) {
	        return (0, _moment2.default)(date);
	      } else {
	        return (0, _moment2.default)(date).add(1, 'days');
	      }
	    },
	    substractDaysToStart: function substractDaysToStart(date) {
	      if (this.allowSameDate) {
	        return (0, _moment2.default)(date);
	      } else {
	        return (0, _moment2.default)(date).subtract(1, 'days');
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.setEndDate((0, _moment2.default)(this.enddate));
	    this.setStartDate((0, _moment2.default)(this.startdate));
	  }
	};

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    choose_period: 'Vælg periode'
	  },
	  nb: {
	    choose_period: 'Velg periode'
	  },
	  en: {
	    choose_period: 'Choose period'
	  }
	};
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default },
	  props: {
	    startDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    endDate: {
	      default: function _default() {
	        return (0, _moment2.default)().add(1, 'days');
	      }
	    },
	    selectedStartDate: {
	      default: function _default() {
	        return null;
	      }
	    },
	    selectedEndDate: {
	      default: function _default() {
	        return null;
	      }
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return window.USER && window.USER.language ? window.USER.language : 'en';
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    title: function title() {
	      if (!this.selectedStartDate || !this.selectedEndDate) {
	        return this.i18n['choose_period'];
	      }
	      var dateRangeId = (0, _moment2.default)(this.selectedStartDate).format('YYYY-MM-DD') + '_' + (0, _moment2.default)(this.selectedEndDate).format('YYYY-MM-DD');
	      var idx = this.shortcuts.findIndex(function (shortcut) {
	        return shortcut.id === dateRangeId;
	      });
	      if (idx < 0) {
	        return this.i18n['choose_period'];
	      } else {
	        return this.shortcuts[idx].title;
	      }
	    },
	    quartersInRange: function quartersInRange() {
	      var startDate = this.startDate;
	      var dateRanges = [];
	      var currentDate = (0, _moment2.default)(startDate);
	      var stopDate = (0, _moment2.default)(this.endDate);
	      while (currentDate <= stopDate) {
	        var intervalStart = (0, _moment2.default)(currentDate).format('YYYY-MM-DD');
	        var intervalEnd = (0, _moment2.default)(currentDate).add(3, 'months').subtract(1, 'days').format('YYYY-MM-DD');
	        dateRanges.push({ start: intervalStart, end: intervalEnd });
	        currentDate = (0, _moment2.default)(currentDate).add(3, 'months');
	      }
	      return dateRanges;
	    },
	    getFirstWeekShortcut: function getFirstWeekShortcut() {
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.startDate).add(6, 'days').format('YYYY-MM-DD');
	      var startTitle = (0, _moment2.default)(startDate).format('ll');
	      var endTitle = (0, _moment2.default)(endDate).format('ll');
	      return {
	        id: startDate + '_' + endDate,
	        title: startTitle + ' - ' + endTitle,
	        dateRange: {
	          start: startDate,
	          end: endDate
	        }
	      };
	    },
	    shortcuts: function shortcuts() {
	      var shortcuts = [this.getFirstWeekShortcut];
	      this.quartersInRange.forEach(function (range) {
	        var startTitle = (0, _moment2.default)(range.start).format('ll');
	        var endTitle = (0, _moment2.default)(range.end).format('ll');
	        var obj = {
	          id: range.start + '_' + range.end,
	          title: startTitle + ' - ' + endTitle,
	          dateRange: {
	            start: range.start,
	            end: range.end
	          }
	        };
	        shortcuts.push(obj);
	      });
	      return shortcuts;
	    }
	  }
	};

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _config = __webpack_require__(62);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _core = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DateSelector',
	  mixins: [_vueClickaway.mixin],
	  props: {
	    popperPlacement: {
	      default: 'bottom-start'
	    },
	
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)().utc();
	      }
	    },
	    isOpen: {
	      type: Boolean,
	      default: false
	    },
	    isOnlyShowFirstAndLastDateEachMonth: {
	      type: Boolean,
	      default: false
	    },
	    isShowInput: {
	      type: Boolean,
	      default: true
	    },
	    width100: {
	      type: Boolean,
	      default: false
	    },
	    minDate: {
	      default: null
	    },
	    maxDate: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      active: false,
	      isDropdownPopperDone: false,
	      chosenDate: this.date,
	      datepickerDate: (0, _moment2.default)(this.date),
	      weekends: _config2.default.showWeekends
	    };
	  },
	
	  watch: {
	    date: function date() {
	      this.chosenDate = this.date;
	      this.datepickerDate = (0, _moment2.default)(this.date);
	    }
	  },
	  computed: {
	    datePickerDateFormatted: function datePickerDateFormatted() {
	      return (0, _moment2.default)(this.datepickerDate).locale(this.locale).format('MMMM YYYY');
	    },
	    urlLocale: function urlLocale() {
	      var url = window.location.host;
	      var locale = 'en';
	      if (url.indexOf('.dk') > -1) {
	        locale = 'da';
	      }
	      if (url.indexOf('.no') > -1) {
	        locale = 'nb';
	      }
	      return locale;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    formatDate: function formatDate() {
	      return (0, _moment2.default)(this.chosenDate).locale(this.locale).format('dddd DD. MMMM YYYY');
	    },
	    today: function today() {
	      return _config2.default.now.format('YYYY-MM-DD');
	    },
	    weekDays: function weekDays() {
	      var ary = _moment2.default.weekdays();
	
	      var last = ary.shift();
	      ary.push(last);
	      return ary;
	    },
	    dates: function dates() {
	      var self = this;
	      var months = [];
	      var date = (0, _moment2.default)(this.datepickerDate).utc('MM-DD-YYYY');
	      var dates = [];
	
	      var startOfWeek = date.date(1).isoWeekday();
	
	      if (!this.weekends && startOfWeek > 5) {} else {
	        for (var i = 1; i < startOfWeek; i++) {
	          dates.push({
	            show: false,
	            showDate: '&nbsp;',
	            dayClass: 'hide'
	          });
	        }
	      }
	
	      function isFirstOrLastDayInMonth(date) {
	        var momentDate = (0, _moment2.default)(date);
	
	        var isFirstDay = momentDate.date() === 1;
	
	        var nextDay = momentDate.clone().add(1, 'day');
	
	        var isLastDay = nextDay.date() === 1;
	        return isFirstDay || isLastDay;
	      }
	
	      for (var _i = 1; _i <= date.daysInMonth(); _i++) {
	        var thisDate = (0, _moment2.default)(date).date(_i).utc('MM-DD-YYYY');
	        dates.push({
	          show: true,
	          date: thisDate,
	          showDate: thisDate.format('D'),
	          dayOfWeek: thisDate.isoWeekday(),
	          week: thisDate.isoWeek(),
	          isToday: self.isTodayDate(thisDate),
	          isSelected: self.isCurrentDate(thisDate),
	          id: thisDate.format('D'),
	          dayClass: 'd_' + thisDate.isoWeekday(),
	          isDisabled: this.isDateDisabled(thisDate, isFirstOrLastDayInMonth)
	        });
	      }
	      months.push({
	        date: dates
	      });
	      return months;
	    },
	    weekNumbers: function weekNumbers() {
	      var weeks = [];
	      this.dates[0].date.forEach(function (date) {
	        var idx = weeks.indexOf(date.week);
	        if (idx < 0 && date.week) {
	          weeks.push(date.week);
	        }
	      });
	      return weeks;
	    }
	  },
	  methods: {
	    createPopper: function createPopper() {
	      var parentPopper = this.$refs.date_input_field;
	      var childPopper = this.$refs.child_popper;
	      document.getElementById('djs-content-container').appendChild(childPopper);
	      (0, _core.createPopper)(parentPopper, childPopper, {
	        placement: this.popperPlacement,
	        modifiers: [{
	          name: 'flip',
	          options: {
	            fallbackPlacements: ['top', 'right', 'left']
	          }
	        }, {
	          name: 'offset',
	          options: {
	            offset: [0, 5]
	          }
	        }]
	      });
	    },
	    isDateDisabled: function isDateDisabled(thisDate, isFirstOrLastDayInMonth) {
	      if (this.isOnlyShowFirstAndLastDateEachMonth && !isFirstOrLastDayInMonth(thisDate)) {
	        return true;
	      }
	      var dayStr = (0, _moment2.default)(thisDate).format('YYYY-MM-DD');
	      if (this.minDate && dayStr < (0, _moment2.default)(this.minDate).format('YYYY-MM-DD')) {
	        return true;
	      }
	      if (this.maxDate && dayStr > (0, _moment2.default)(this.maxDate).format('YYYY-MM-DD')) {
	        return true;
	      }
	      return false;
	    },
	    openDatePicker: function openDatePicker(e) {
	      var _this = this;
	
	      this.active = true;
	      this.$nextTick(function (_) {
	        _this.createPopper();
	        _this.isDropdownPopperDone = true;
	      });
	    },
	    closeDatePicker: function closeDatePicker() {
	      var self = this;
	      this.isDropdownPopperDone = false;
	      this.active = false;
	      this.$emit('close');
	
	      setTimeout(function () {
	        self.datepickerDate = (0, _moment2.default)(self.chosenDate);
	      }, 100);
	    },
	    isCurrentDate: function isCurrentDate(date) {
	      var chosen = (0, _moment2.default)(this.chosenDate).format('YYYY-MM-DD');
	      var datePickerDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      return chosen === datePickerDate;
	    },
	    isTodayDate: function isTodayDate(date) {
	      return (0, _moment2.default)(date).format('Y-MM-DD') === this.today;
	    },
	    setDate: function setDate(date) {
	      if (date.isDisabled) {
	        return;
	      }
	      this.chosenDate = date.date;
	      this.$emit('changed', date.date);
	      this.closeDatePicker();
	    },
	    prevMonth: function prevMonth() {
	      this.datepickerDate = (0, _moment2.default)(this.datepickerDate).subtract(1, 'month').date(2);
	    },
	    nextMonth: function nextMonth() {
	      this.datepickerDate = (0, _moment2.default)(this.datepickerDate).add(1, 'month').date(2);
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    if (this.isOpen) {
	      this.$nextTick(function (_) {
	        _this2.openDatePicker();
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$refs.child_popper) {
	      this.$refs.child_popper.remove();
	    }
	  }
	};

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vueClickaway = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DateSelector',
	  mixins: [_vueClickaway.mixin],
	  props: {
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    theCalendarDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    active: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    today: function today() {
	      return (0, _moment2.default)().format('YYYY-MM-DD');
	    },
	    weekdays: function weekdays() {
	      var days = [];
	      for (var i = 1; i <= 7; i++) {
	        days.push((0, _moment2.default)().isoWeekday(i).format('ddd'));
	      }
	      return days;
	    },
	    weeks: function weeks() {
	      var week = [];
	      var date = (0, _moment2.default)(this.date).utc().date(1);
	      var daysInMonth = (0, _moment2.default)(this.date).daysInMonth();
	      week.push((0, _moment2.default)(date).isoWeek());
	      for (var i = 1; i <= daysInMonth; i++) {
	        var thisDate = (0, _moment2.default)(date).date(i);
	        var weekNum = thisDate.isoWeek();
	        if (week[week.length - 1] !== weekNum) {
	          week.push(weekNum);
	        }
	      }
	      return week;
	    },
	    datesInWeeks: function datesInWeeks() {
	      var weeks = [];
	      var date = (0, _moment2.default)(this.date).utc();
	      var startOfMonth = (0, _moment2.default)(date.startOf('month'));
	      var weeksInMonth = this.weeks.length;
	      var startWeek = (0, _moment2.default)(startOfMonth).isoWeek();
	      var thisMonth = (0, _moment2.default)(date).month();
	      for (var i = 0; i < weeksInMonth; i++) {
	        var weekNum = startWeek + i;
	        var dates = [];
	        for (var j = 1; j <= 7; j++) {
	          var thisDate = (0, _moment2.default)(date).isoWeek(weekNum).isoWeekday(j);
	          if (thisMonth !== (0, _moment2.default)(date).isoWeek(weekNum).isoWeekday(j).month()) {
	            dates.push({
	              show: false,
	              showDate: '&nbsp;',
	              dayClass: 'hide'
	            });
	          } else {
	            dates.push({
	              show: true,
	              date: thisDate.format('YYYY-MM-DD'),
	              showDate: thisDate.format('D'),
	              dayOfWeek: thisDate.isoWeekday(),
	              week: thisDate.isoWeek(),
	              isToday: this.isTodayDate(thisDate),
	              isSelected: this.isCurrentDate(thisDate),
	              id: thisDate.format('D'),
	              dayClass: 'd_' + thisDate.isoWeekday()
	            });
	          }
	        }
	        weeks.push({
	          'week': weekNum,
	          'dates': dates
	        });
	      }
	      return weeks;
	    }
	  },
	  methods: {
	    closeDatePicker: function closeDatePicker() {
	      this.active = false;
	    },
	    isCurrentDate: function isCurrentDate(date) {
	      var datePickerDate = (0, _moment2.default)(this.theCalendarDate).format('YYYY-MM-DD');
	      var theDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      return theDate === datePickerDate;
	    },
	    isTodayDate: function isTodayDate(date) {
	      return (0, _moment2.default)(date).format('Y-MM-DD') === (0, _moment2.default)().format('YYYY-MM-DD');
	    },
	    setDate: function setDate(date) {
	      this.$emit('changed', (0, _moment2.default)(date.date).format('YYYY-MM-DD'));
	    }
	  }
	};

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _config = __webpack_require__(62);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    date: {
	      default: function _default() {
	        return _config2.default.now;
	      }
	    },
	    weekends: {
	      default: true
	    },
	    locale: {
	      default: window.USER && window.USER.locale ? window.USER.locale : 'en'
	    }
	  },
	  computed: {
	    isMon: function isMon() {
	      return this.isDay(1);
	    },
	    isTue: function isTue() {
	      return this.isDay(2);
	    },
	    isWed: function isWed() {
	      return this.isDay(3);
	    },
	    isTur: function isTur() {
	      return this.isDay(4);
	    },
	    isFri: function isFri() {
	      return this.isDay(5);
	    },
	    isSat: function isSat() {
	      return this.isDay(6);
	    },
	    isSun: function isSun() {
	      return this.isDay(7);
	    }
	  },
	  methods: {
	    isToday: function isToday(date) {
	      return (0, _moment2.default)(date).format('DD-MM-YYYY') === _config2.default.now.format('DD-MM-YYYY');
	    },
	    setDay: function setDay(dayNum) {
	      var newDate = (0, _moment2.default)(this.date).isoWeekday(dayNum);
	      this.$emit('changed', newDate);
	    },
	    isDay: function isDay(dayNum) {
	      return (0, _moment2.default)(this.date).format('') === (0, _moment2.default)(this.date).isoWeekday(dayNum).format('');
	    },
	    day: function day(weekday) {
	      return (0, _moment2.default)(this.date).locale(this.locale).isoWeekday(weekday).format('ddd');
	    }
	  }
	};

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DatePickerRange = __webpack_require__(22);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _vueClickaway = __webpack_require__(9);
	
	var _core = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    select_dates: 'Vælg datoer',
	    submit: 'Indlæs',
	    this_week: 'Denne uge',
	    this_month: 'Denne måned',
	    school_year: 'Skoleåret',
	    custom: 'Tilpasset'
	  },
	  en: {
	    select_dates: 'Select Dates',
	    submit: 'Submit',
	    this_week: 'This week',
	    this_month: 'This month',
	    school_year: 'School year',
	    custom: 'Custom'
	  },
	  nb: {
	    select_dates: 'Velg datoer',
	    submit: 'Submit',
	    this_week: 'Denne uke',
	    this_month: 'Denne måned',
	    school_year: 'Skoleåret',
	    custom: 'Tilpasset'
	  }
	};
	
	exports.default = {
	  components: { Datepickerrange: _DatePickerRange2.default, DDropdown: _DDropdown2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    maximumDateRange: {
	      type: Number,
	      default: null },
	    allowSameDate: {
	      type: Boolean,
	      default: false
	    },
	    startDate: {
	      default: function _default() {
	        return (0, _moment2.default)().startOf('isoWeek');
	      }
	    },
	    endDate: {
	      default: function _default() {
	        return (0, _moment2.default)().endOf('isoWeek');
	      }
	    },
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    dateShortCutsProps: {
	      type: Array,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isDateDropdown: false,
	      isPopperReady: false,
	      isPopperDone: false,
	      initialStartDate: (0, _moment2.default)(),
	      initialEndDate: (0, _moment2.default)()
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    quartersInRange: function quartersInRange() {
	      var startDate = this.startDate;
	      var dateRanges = [];
	      var currentDate = (0, _moment2.default)(startDate);
	      var stopDate = (0, _moment2.default)(this.endDate);
	      while (currentDate <= stopDate) {
	        var intervalStart = (0, _moment2.default)(currentDate).format('YYYY-MM-DD');
	        var intervalEnd = (0, _moment2.default)(currentDate).add(3, 'months').subtract(1, 'days').format('YYYY-MM-DD');
	        dateRanges.push({ start: intervalStart, end: intervalEnd });
	        currentDate = (0, _moment2.default)(currentDate).add(3, 'months');
	      }
	      return dateRanges;
	    },
	    schoolYears: function schoolYears() {
	      return this.$store.state.schoolYears;
	    },
	    activeSchoolYears: function activeSchoolYears() {
	      return this.schoolYears.filter(function (schoolYear) {
	        return schoolYear.active;
	      });
	    },
	    schoolYear: function schoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    dateShortCuts: function dateShortCuts() {
	      var _this = this;
	
	      if (this.dateShortCutsProps) {
	        return this.dateShortCutsProps;
	      }
	      var custom = [{ title: this.i18n['this_week'], startDate: (0, _moment2.default)(this.date).startOf('isoWeek'), endDate: (0, _moment2.default)(this.date).endOf('isoWeek') }, { title: this.i18n['this_month'], startDate: (0, _moment2.default)(this.date).startOf('month'), endDate: (0, _moment2.default)(this.date).endOf('month') }];
	      var schoolYears = this.activeSchoolYears.map(function (schoolYear) {
	        return {
	          title: _this.i18n['school_year'] + ' ' + schoolYear.name,
	          startDate: (0, _moment2.default)(schoolYear.employee_time_start).startOf('day'),
	          endDate: (0, _moment2.default)(schoolYear.employee_time_end).endOf('day')
	        };
	      });
	      return custom.concat(schoolYears);
	    },
	    activeShortCutTitle: function activeShortCutTitle() {
	      var _this2 = this;
	
	      var idx = this.dateShortCuts.findIndex(function (shortCut) {
	        return (0, _moment2.default)(shortCut.startDate).isSame(_this2.startDate, 'day') && (0, _moment2.default)(shortCut.endDate).isSame(_this2.endDate, 'day');
	      });
	      return idx < 0 ? this.i18n['custom'] : this.dateShortCuts[idx].title;
	    },
	    dateRangeFormatted: function dateRangeFormatted() {
	      var startFormat = this.startDate.format('D.');
	      if (!(0, _moment2.default)(this.startDate).isSame(this.endDate, 'month')) {
	        startFormat = this.startDate.format('D. MMM');
	      }
	      if (!(0, _moment2.default)(this.startDate).isSame(this.endDate, 'year')) {
	        startFormat = this.startDate.format('D. MMM, YYYY');
	      }
	      var endFormat = this.endDate.format('D. MMM, YYYY');
	      return startFormat + ' - ' + endFormat;
	    }
	  },
	  methods: {
	    setDropdown: function setDropdown() {
	      var _this3 = this;
	
	      this.isDropDown = !this.isDropDown;
	      if (this.isDropDown) {
	        setTimeout(function (_) {
	          _this3.createPopper();
	        }, 0);
	      } else {
	        this.isPopperReady = false;
	        this.isPopperDone = false;
	      }
	    },
	    openIsDateDropdown: function openIsDateDropdown() {
	      var _this4 = this;
	
	      this.isDateDropdown = true;
	      this.$nextTick(function (_) {
	        _this4.createPopper();
	      });
	    },
	    closeIsDateDropdown: function closeIsDateDropdown() {
	      this.isDropdownPopperDone = false;
	      this.isDateDropdown = false;
	    },
	    createPopper: function createPopper() {
	      var _this5 = this;
	
	      this.isPopperReady = false;
	      this.isPopperDone = false;
	      var dChild = this.$refs.child_popper;
	      var dParent = this.$refs.date_input_button;
	      if (this.appendToBody) {
	        document.getElementById('djs-body-click').appendChild(dChild);
	      }
	      (0, _core.createPopper)(dParent, dChild, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, -1]
	          }
	        }]
	      });
	      setTimeout(function (_) {
	        _this5.isPopperReady = true;
	        _this5.isPopperDone = true;
	      }, 0);
	    },
	    setDateFromShortCut: function setDateFromShortCut(dateShortCut) {
	      var start = dateShortCut.startDate;
	      var end = dateShortCut.endDate;
	      this.$emit('startChanged', start);
	      this.$emit('endChanged', end);
	      this.$emit('datesChanged', { start: start, end: end });
	    },
	    setStartDate: function setStartDate(date) {
	      this.initialStartDate = date;
	    },
	    setEndDate: function setEndDate(date) {
	      this.initialEndDate = date;
	    },
	    submitDateRange: function submitDateRange() {
	      this.$emit('startChanged', this.initialStartDate);
	      this.$emit('endChanged', this.initialEndDate);
	      var start = this.initialStartDate;
	      var end = this.initialEndDate;
	      this.$emit('datesChanged', { start: start, end: end });
	      this.isDateDropdown = false;
	    },
	    closeDoDatepickerDropdown: function closeDoDatepickerDropdown() {
	      this.isDateDropdown = false;
	    }
	  }
	};

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    date: {
	      default: (0, _moment2.default)()
	    },
	    startDate: {
	      default: null
	    },
	    endDate: {
	      default: null
	    }
	  },
	  computed: {
	    weekDate: function weekDate() {
	      return (0, _moment2.default)(this.date);
	    },
	    weeksInYear: function weeksInYear() {
	      var startDate = (0, _moment2.default)(this.startDate).startOf('isoweek');
	      var endDate = (0, _moment2.default)(this.endDate).endOf('isoweek');
	      var weeksBetweenStartAndFinish = (0, _moment2.default)(endDate).diff(startDate, 'week');
	      var self = this;
	      var startWeek = (0, _moment2.default)(this.startDate).isoWeek();
	      var weeks = [];
	      for (var i = startWeek; i <= startWeek + weeksBetweenStartAndFinish; i++) {
	        var date = (0, _moment2.default)(self.startDate).isoWeek(i);
	        weeks.push({
	          date: date,
	          weekNum: date.isoWeek(),
	          isChosenWeek: self.isChosenWeek(date),
	          isThisWeek: self.isThisWeek(date),
	          tooltipDate: self.tooltipDate(date)
	        });
	      }
	      return weeks;
	    },
	    startDateInYear: function startDateInYear() {
	      return (0, _moment2.default)(this.startDate).format('YYYY');
	    },
	    endDateInYear: function endDateInYear() {
	      return (0, _moment2.default)(this.endDate).format('YYYY');
	    }
	  },
	  methods: {
	    tooltipDate: function tooltipDate(date) {
	      var start = (0, _moment2.default)(date).startOf('isoweek');
	      var start2 = (0, _moment2.default)(date).startOf('isoweek').format('DD. MMM');
	      var startFormat = start.format('DD');
	      var end = (0, _moment2.default)(date).endOf('isoweek');
	      var endFormat = (0, _moment2.default)(date).endOf('isoweek').format('DD. MMM YYYY');
	
	      if ((0, _moment2.default)(start).format('MM') === (0, _moment2.default)(end).format('MM')) {
	        return startFormat + ' - ' + endFormat;
	      } else {
	        return start2 + ' - ' + endFormat;
	      }
	    },
	    setDate: function setDate(date) {
	      this.$emit('changed', date);
	    },
	    isChosenWeek: function isChosenWeek(date) {
	      return this.weekDate.isoWeek() === (0, _moment2.default)(date).isoWeek() && this.weekDate.format('YYYY') === (0, _moment2.default)(date).format('YYYY');
	    },
	    isThisWeek: function isThisWeek(date) {
	      return (0, _moment2.default)(date).isoWeek() === (0, _moment2.default)().isoWeek() && (0, _moment2.default)(date).format('YYYY') === (0, _moment2.default)().format('YYYY');
	    }
	  }
	};

/***/ }),
/* 863 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    deleteSetupWidgetOpen: function deleteSetupWidgetOpen() {
	      this.$store.dispatch('deleteUserSetting', 'setupWidgetOpen');
	    },
	    deleteKlass: function deleteKlass() {
	      this.$store.dispatch('deleteUserSetting', 'setup_widget_progress_klass');
	    },
	    deleteUser: function deleteUser() {
	      this.$store.dispatch('deleteUserSetting', 'setup_widget_progress_users');
	    },
	    deleteRoom: function deleteRoom() {
	      this.$store.dispatch('deleteUserSetting', 'setup_widget_progress_rooms');
	    },
	    deleteMerge: function deleteMerge() {
	      this.$store.dispatch('deleteUserSetting', 'setup_widget_progress_merge');
	    },
	    deleteScheduling: function deleteScheduling() {
	      this.$store.dispatch('deleteUserSetting', 'setup_widget_progress_scheduling');
	    },
	    deleteVacation: function deleteVacation() {
	      this.$store.dispatch('deleteUserSetting', 'setup_widget_progress_vacation');
	    }
	  }
	};

/***/ }),
/* 864 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    setupWidget: {
	      type: Boolean,
	      default: false
	    }
	  }
	};

/***/ }),
/* 865 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    bottom: {
	      default: -4
	    },
	    right: {
	      default: 0
	    }
	  },
	  computed: {
	    activeOnboardingStep: function activeOnboardingStep() {
	      return this.$store.state.onboardingStep;
	    },
	    show: function show() {
	      return this.activeOnboardingStep * 1 === 5;
	    }
	  }
	};

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _StepDoughnut = __webpack_require__(334);
	
	var _StepDoughnut2 = _interopRequireDefault(_StepDoughnut);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _OnboardArrow = __webpack_require__(417);
	
	var _OnboardArrow2 = _interopRequireDefault(_OnboardArrow);
	
	var _DoYouTube = __webpack_require__(408);
	
	var _DoYouTube2 = _interopRequireDefault(_DoYouTube);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { doughnut: _StepDoughnut2.default, arrow: _OnboardArrow2.default, doYouTube: _DoYouTube2.default },
	  computed: {
	    showModal: function showModal() {
	      return _eventbus2.default.showSetupWidget;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    activeOnboardingStep: function activeOnboardingStep() {
	      return this.$store.state.onboardingStep;
	    },
	    showOnboardingArrow: function showOnboardingArrow() {
	      return _eventbus2.default.showOnboardingArrow;
	    },
	    klassCals: function klassCals() {
	      return this.$store.getters.allKlassCalendarsInHash;
	    },
	    stepNumbers: function stepNumbers() {
	      if (this.country === 'dk') {
	        return this.stepsDK;
	      } else if (this.country === 'no') {
	        return this.stepsNO;
	      } else {
	        return this.stepsEN;
	      }
	    },
	    stepsLength: function stepsLength() {
	      return this.stepNumbers.length;
	    },
	    howManyDone: function howManyDone() {
	      var doneSteps = this.stepNumbers.filter(function (obj) {
	        return obj.done === true;
	      });
	      return doneSteps.length;
	    }
	  },
	  watch: {
	    userSettings: function userSettings(val, oldVal) {
	      var obj = this.userSettings;
	      this.progressed = (0, _keys2.default)(obj).filter(function (key) {
	        return key.startsWith('setup_widget_progress');
	      });
	      this.checkProgress();
	    },
	    showModal: function showModal(val, oldVal) {
	      console.log('showModal', val);
	    }
	  },
	  data: function data() {
	    return {
	      animateSlide: false,
	      onboardArrowTopPx: 0,
	      showLocalOnboardingArrow: false,
	      progressed: [],
	      country: window.SCHOOL.country.toLowerCase(),
	      stepsNO: [{
	        title: 'Opprett klasser - (0:36)',
	        videoid: 'P9lc_0-64kc',
	        guide: 'https://www.youtube.com/watch?v=P9lc_0-64kc&feature=youtu.be',
	        dbName: 'setup_widget_progress_klass',
	        done: false,
	        stepNum: 1
	      }, {
	        title: 'Opprett lærere/brukere - (0:44)',
	        videoid: 'X-w0i3MFeL4',
	        guide: 'https://www.youtube.com/watch?v=X-w0i3MFeL4&feature=youtu.be',
	        dbName: 'setup_widget_progress_users',
	        done: false,
	        stepNum: 2
	      }, {
	        title: 'Opprett lokaler - (0:37)',
	        videoid: '8FoyUOiwdPk',
	        guide: 'https://www.youtube.com/watch?v=8FoyUOiwdPk&feature=youtu.be',
	        dbName: 'setup_widget_progress_rooms',
	        done: false,
	        stepNum: 3
	      }, {
	        title: 'Opprett fellestimeplaner - (2:09)',
	        videoid: '39daX1u0238',
	        guide: 'https://www.youtube.com/watch?v=DI4d0auYfg4&feature=youtu.be',
	        dbName: 'setup_widget_progress_merge',
	        done: false,
	        stepNum: 4
	      }, {
	        title: 'Legg inn ferier og helligdager - (0:39)',
	        videoid: 'KmLDUVlzhXA',
	        guide: 'https://www.youtube.com/watch?v=KmLDUVlzhXA&feature=youtu.be',
	        dbName: 'setup_widget_progress_vacation',
	        done: false,
	        stepNum: 5
	      }, {
	        title: 'Timeplanlegging i klasser - (2:55)',
	        videoid: 's6b7b07ZHl0',
	        guide: 'https://www.youtube.com/watch?v=s6b7b07ZHl0&feature=youtu.be',
	        dbName: 'setup_widget_progress_scheduling',
	        done: false,
	        stepNum: 6
	      }],
	      stepsDK: [{
	        title: 'Opret klasser - (1:01)',
	        videoid: '5gjODdkqRDI',
	        guide: 'https://www.youtube.com/watch?v=5gjODdkqRDI&feature=youtu.be',
	        dbName: 'setup_widget_progress_klass',
	        done: false,
	        stepNum: 1
	      }, {
	        title: 'Opret lærere/brugere - (0:41)',
	        videoid: 'YtujiFzH50A',
	        guide: 'https://www.youtube.com/watch?v=YtujiFzH50A&feature=youtu.be',
	        dbName: 'setup_widget_progress_users',
	        done: false,
	        stepNum: 2
	      }, {
	        title: 'Opret lokaler - (0:39)',
	        videoid: '2XQjHWLvyrM',
	        guide: 'https://www.youtube.com/watch?v=2XQjHWLvyrM&feature=youtu.be',
	        dbName: 'setup_widget_progress_rooms',
	        done: false,
	        stepNum: 3
	      }, {
	        title: 'Opret fletteskemaer - (02:41)',
	        videoid: 'VNt1m80YEsI',
	        guide: 'https://www.youtube.com/watch?v=VNt1m80YEsI&feature=youtu.be',
	        dbName: 'setup_widget_progress_merge',
	        done: false,
	        stepNum: 4
	      }, {
	        title: 'Indtast feriedage - (0:39)',
	        videoid: '0XB5A0xr-N0',
	        guide: 'https://www.youtube.com/watch?v=0XB5A0xr-N0&feature=youtu.be',
	        dbName: 'setup_widget_progress_vacation',
	        done: false,
	        stepNum: 5
	      }, {
	        title: 'Skemalægning i klasser - (2:25)',
	        videoid: '7NR8_EygcoM',
	        guide: 'https://www.youtube.com/watch?v=7NR8_EygcoM&feature=youtu.be',
	        dbName: 'setup_widget_progress_scheduling',
	        done: false,
	        stepNum: 6
	      }],
	      stepsEN: [{
	        title: 'Create grades/groups - (0:52)',
	        videoid: 'WdXydJxGFpI',
	        guide: 'https://youtu.be/WdXydJxGFpI',
	        dbName: 'setup_widget_progress_klass',
	        done: false,
	        stepNum: 1
	      }, {
	        title: 'Create teachers - (0:43)',
	        videoid: 'D83kXuPIZzE',
	        guide: 'https://youtu.be/D83kXuPIZzE',
	        dbName: 'setup_widget_progress_users',
	        done: false,
	        stepNum: 2
	      }, {
	        title: 'Create classrooms / locations - (1:01)',
	        videoid: 'UBI-WnWOtdQ',
	        guide: 'https://youtu.be/UBI-WnWOtdQ',
	        dbName: 'setup_widget_progress_rooms',
	        done: false,
	        stepNum: 3
	      }, {
	        title: 'Choose school holidays - (0:36)',
	        videoid: 'CkUvNQQgMoQ',
	        guide: 'https://youtu.be/CkUvNQQgMoQ',
	        dbName: 'setup_widget_progress_vacation',
	        done: false,
	        stepNum: 5
	      }, {
	        title: 'Create shared calendar - (2:56)',
	        videoid: 'aIvpXbHwYeA',
	        guide: 'https://youtu.be/aIvpXbHwYeA',
	        dbName: 'setup_widget_progress_merge',
	        done: false,
	        stepNum: 4
	      }, {
	        title: 'Create subjects - (2:31)',
	        videoid: 'EpEfabVl7yw',
	        guide: 'https://youtu.be/EpEfabVl7yw',
	        dbName: 'setup_widget_progress_subjects',
	        done: false,
	        stepNum: 6
	      }, {
	        title: 'Schedule classes  - (3:31)',
	        videoid: 'UXZpf-wAh-U',
	        guide: 'https://youtu.be/UXZpf-wAh-U',
	        dbName: 'setup_widget_progress_scheduling',
	        done: false,
	        stepNum: 7
	      }]
	    };
	  },
	
	  methods: {
	    fireWhenDataIsReady: function fireWhenDataIsReady() {
	      this.findNextStep();
	      if (this.userSettings.setupWidgetOpen !== false) {
	        _eventbus2.default.showSetupWidget = true;
	      }
	    },
	    findNextStep: function findNextStep() {
	      this.showLocalOnboardingArrow = false;
	      for (var i = 0; i < this.stepNumbers.length; i++) {
	        if (!this.stepNumbers[i].done) {
	          this.calcOnboardArrowTop(i);
	          return;
	        }
	      }
	    },
	    calcOnboardArrowTop: function calcOnboardArrowTop(nextStepIdx) {
	      if (document.querySelectorAll('.js-onboard-item-click')[nextStepIdx]) {
	        var nextStepBCRTop = document.querySelectorAll('.js-onboard-item-click')[nextStepIdx].getBoundingClientRect().top;
	        this.onboardArrowTopPx = nextStepBCRTop - 8;
	        this.showLocalOnboardingArrow = true;
	      }
	    },
	    openYouTube: function openYouTube(videoid) {
	      _eventbus2.default.youTubeVideoId = videoid;
	      _eventbus2.default.isOpenYouTubePopup = true;
	    },
	    checkProgress: function checkProgress() {
	      for (var i = 0; i < this.progressed.length; i++) {
	        for (var j = 0; j < this.stepNumbers.length; j++) {
	          if (this.stepNumbers[j].dbName === this.progressed[i]) {
	            this.stepNumbers[j].done = true;
	          }
	        }
	      }
	      this.fireWhenDataIsReady();
	    },
	    setShowModal: function setShowModal(panel) {
	      if (this.showModal) {
	        this.animateSlide = true;
	        this.closeModal(panel);
	      } else {
	        this.animateSlide = true;
	        this.openModal(panel);
	      }
	    },
	    openModal: function openModal() {
	      _eventbus2.default.showSetupWidget = true;
	      this.$store.dispatch('updateUserSettings', { 'setupWidgetOpen': true });
	      var wrapper = document.querySelector('#djs-content-container');
	      if (!wrapper.classList.contains('djs_setup_widget_open')) {
	        wrapper.classList.add('djs_setup_widget_open');
	      }
	    },
	    closeModal: function closeModal() {
	      _eventbus2.default.showSetupWidget = false;
	      this.$store.dispatch('updateUserSettings', { 'setupWidgetOpen': false });
	      document.querySelector('#djs-content-container').classList.remove('djs_setup_widget_open');
	    },
	    showIntercom: function showIntercom() {
	      window.Intercom('show');
	    },
	    stepFnc: function stepFnc(stepNum, title) {
	      _eventbus2.default.showOnboardingArrow = true;
	      this.$store.commit('setOnboardingStep', stepNum);
	      window.Intercom('trackEvent', 'Watched Onboarding Video: ' + title);
	      if (stepNum === 5) {
	        setTimeout(function () {
	          var el = document.querySelector('.js-onboarding-arrow-planning .djs-header-dropdown-click');
	          el.click();
	        }, 500);
	      }
	    },
	    isCalIdAKlass: function isCalIdAKlass(calId) {
	      if (this.klassCals[calId]) {
	        return true;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    var settings = JSON.parse(window.USER.settings.replace(/&quot;/g, '"'));
	    if (settings.setupWidgetOpen !== false) {
	      _eventbus2.default.showSetupWidget = true;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (!this.$helpers.getSessionStorage('doSession')) {
	      window.Intercom('trackEvent', 'Session Device ' + this.$helpers.checkUserDevice());
	    }
	
	    this.$helpers.setSessionStorage('doSession', true);
	
	    window.addEventListener('vue_dropped_subject', function (e) {
	      if (window.SCHOOL.state === 'demo' && _this.isCalIdAKlass(e.detail.cal_id)) {
	        window.Intercom('trackEvent', 'Dropped Event In Class');
	        _this.$store.dispatch('updateUserSettings', { 'setup_widget_progress_scheduling': true });
	      }
	    }, false);
	
	    window.addEventListener('vue_dropped_subject_no_teacher', function (e) {
	      if (window.SCHOOL.state === 'demo' && _this.isCalIdAKlass(e.detail.cal_id)) {
	        window.Intercom('trackEvent', 'Fail No Teacher On Subject In Class');
	      }
	    }, false);
	  }
	};

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  mounted: function mounted() {
	    if (window.location.href.indexOf('intro=true') > -1) {
	      var el = document.querySelector('.js-onboarding-arrow-planning').getBoundingClientRect();
	      this.$el.style.top = el.bottom + 0 + 'px';
	      this.$el.style.left = el.left + (el.width / 2 - 20) + 'px';
	      this.$el.style.display = 'block';
	    }
	  }
	};

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(17);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _Header = __webpack_require__(1708);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _WeekSelecter = __webpack_require__(106);
	
	var _WeekSelecter2 = _interopRequireDefault(_WeekSelecter);
	
	var _WeekPlan = __webpack_require__(1710);
	
	var _WeekPlan2 = _interopRequireDefault(_WeekPlan);
	
	var _DCalendar = __webpack_require__(53);
	
	var _DCalendar2 = _interopRequireDefault(_DCalendar);
	
	var _AppToggle = __webpack_require__(11);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _config = __webpack_require__(62);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    desktopHeader: _Header2.default,
	    weekSelector: _WeekSelecter2.default,
	    weekplan: _WeekPlan2.default,
	    DCalendar: _DCalendar2.default,
	    AppToggle: _AppToggle2.default
	  },
	  props: {
	    calId: {},
	    schoolName: {},
	    i18n: {}
	  },
	  data: function data() {
	    return {
	      allEvents: [],
	      date: _config2.default.now,
	      today: _config2.default.now,
	      locale: window.USER.locale,
	      calInfo: '',
	      isLoading: false,
	      isShowWeekends: false,
	      isCalNoBgColors: false,
	      startTime: '06:00:00',
	      endTime: '17:00:00',
	      intervalId: null,
	      isCalendarInPrintMode: false
	    };
	  },
	
	  computed: {
	    activeCalendarDate: function activeCalendarDate() {
	      return (0, _moment2.default)(this.date).locale('en').format('YYYY-MM-DD');
	    },
	    weekStartDate: function weekStartDate() {
	      return (0, _moment2.default)(this.date).isoWeekday(1).locale('en').format('YYYY-MM-DD 00:00');
	    },
	    weekEndDate: function weekEndDate() {
	      return (0, _moment2.default)(this.date).isoWeekday(7).locale('en').format('YYYY-MM-DD 23:59');
	    },
	    isNotToday: function isNotToday() {
	      return (0, _moment2.default)(this.date).locale('en').format('YYYY-MM-DD') !== (0, _moment2.default)(this.today).locale('en').format('YYYY-MM-DD');
	    },
	    isNotThisWeek: function isNotThisWeek() {
	      return (0, _moment2.default)(this.date).isoWeek() !== (0, _moment2.default)(this.today).isoWeek();
	    },
	    showDate: function showDate() {
	      try {
	        if (this.locale === 'nn' || this.locale === 'nb') {
	          return (0, _moment2.default)(this.date).locale(this.locale).format('MMMM YYYY');
	        }
	        return (0, _moment2.default)(this.date)._d.toLocaleDateString(this.locale, { month: 'long', year: 'numeric' });
	      } catch (e) {
	        return (0, _moment2.default)(this.date).format('LL');
	      }
	    }
	  },
	  watch: {
	    calInfo: function calInfo() {
	      if (this.calInfo && this.calInfo.view_state > -1) {
	        var state = this.calInfo.view_state * 1;
	        if (state === 0) {
	          this.startTime = '06:00:00';
	          this.endTime = '17:00:00';
	          this.isShowWeekends = false;
	        } else if (state === 1) {
	          this.startTime = '06:00:00';
	          this.endTime = '17:00:00';
	          this.isShowWeekends = true;
	        } else {
	          this.startTime = '00:00:00';
	          this.endTime = '23:00:00';
	          this.isShowWeekends = true;
	        }
	      }
	    }
	  },
	  methods: {
	    getSchoolInfo: function getSchoolInfo() {
	      var _this = this;
	
	      _docendo2.default.calendar(this.calId, function (data) {
	        _this.calInfo = data;
	      });
	    },
	    getLessons: function getLessons() {
	      var _this2 = this;
	
	      this.isLoading = true;
	      _docendo2.default.publicEventsFromCalendar(this.calId, this.weekStartDate, this.weekEndDate, function (data) {
	        var events = data;
	        if (typeof data === 'string') {
	          try {
	            events = JSON.parse(data);
	          } catch (e) {
	            events = [];
	          }
	        }
	        var parsed = Array.isArray(events) ? events : [];
	        var calId = _this2.calId * 1;
	        for (var i = 0; i < parsed.length; i++) {
	          var ev = parsed[i];
	
	          delete ev.collision;
	          delete ev.away;
	
	          var calendars = ev.calendars || [];
	          var groups = [];
	          var teachers = [];
	          for (var j = 0; j < calendars.length; j++) {
	            var cal = calendars[j];
	            if (cal.calendar_type === 'klass' && cal.calendar_id !== calId) {
	              groups.push(cal.name);
	            } else if (cal.calendar_type === 'user') {
	              teachers.push(cal.name);
	            }
	          }
	          ev.group = groups.join(', ');
	          ev.teacher = teachers.join(', ');
	          ev.room = ev.room || '';
	          ev.canceled = ev.canceled || false;
	          ev.away = false;
	          ev.has_substitute = ev.has_substitute || false;
	
	          ev.duration = (0, _moment2.default)(ev.end).diff((0, _moment2.default)(ev.start), 'minutes');
	
	          var desc = (ev.description || '').replace(/<[^>]*>/g, '').trim();
	          var goal = (ev.learning_goal || '').replace(/<[^>]*>/g, '').trim();
	          var studentNotes = (ev.notes_for_students || '').replace(/<[^>]*>/g, '').trim();
	          var teacherNotes = (ev.teacher_notes || '').replace(/<[^>]*>/g, '').trim();
	          ev.has_notes = !!(desc || goal || studentNotes || teacherNotes);
	        }
	        _this2.allEvents = parsed;
	        _this2.isLoading = false;
	      }, function () {
	        _this2.isLoading = false;
	      });
	    },
	    setDate: function setDate(date) {
	      this.date = date;
	      this.getLessons();
	    },
	    nextWeek: function nextWeek() {
	      var date = (0, _moment2.default)(this.date).add(7, 'days');
	      this.setDate(date);
	    },
	    prevWeek: function prevWeek() {
	      var date = (0, _moment2.default)(this.date).subtract(7, 'days');
	      this.setDate(date);
	    },
	    setToday: function setToday() {
	      this.setDate(this.today);
	    },
	    showEvent: function showEvent(event) {
	      var eventData = event.obj || event;
	      var calendars = eventData.calendars || [];
	      var groups = [];
	      var teachers = [];
	      var rooms = [];
	      for (var i = 0; i < calendars.length; i++) {
	        var cal = calendars[i];
	        if (cal.calendar_type === 'klass' && cal.calendar_id !== this.calId) {
	          groups.push(cal.name);
	        } else if (cal.calendar_type === 'user') {
	          teachers.push(cal.name);
	        } else if (cal.calendar_type === 'room') {
	          rooms.push(cal.name);
	        }
	      }
	      var duration = (0, _moment2.default)(eventData.end).diff((0, _moment2.default)(eventData.start), 'minutes');
	      var mappedEvent = {
	        title: eventData.title,
	        color: eventData.color,
	        start: eventData.start,
	        end: eventData.end,
	        duration: duration,
	        group: groups.join(', '),
	        teacher: teachers.join(', '),
	        room: rooms.join(', '),
	        description: eventData.description || '',
	        learning_goal: eventData.learning_goal || '',
	        notes_for_students: eventData.notes_for_students || '',
	        canceled: eventData.canceled || false,
	        away: eventData.away || false
	      };
	      this.$emit('eventClick', mappedEvent);
	    },
	    setLocale: function setLocale(val) {
	      this.locale = val;
	      this.$emit('setLocale', val);
	    },
	    print: function print() {
	      var _this3 = this;
	
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	      if (!WinPrint) {
	        return;
	      }
	      this.isCalendarInPrintMode = true;
	      this.$nextTick(function () {
	        setTimeout(function () {
	          var weekplanEl = _this3.$el.querySelector('#printCalendar .weekplan');
	          var hasNotes = _this3.$el.querySelector('#printCalendar .day_change_header') || _this3.$el.querySelector('#printCalendar .week_note');
	          if (weekplanEl && !hasNotes) {
	            weekplanEl.classList.add('hide');
	          }
	          var printEl = document.getElementById('printCalendar');
	          if (!printEl) {
	            WinPrint.close();
	            _this3.isCalendarInPrintMode = false;
	            return;
	          }
	          var prtHtml = printEl.innerHTML;
	          var stylesHtml = '';
	
	          var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')));
	
	          for (var _i = 0; _i < _arr.length; _i++) {
	            var node = _arr[_i];
	            stylesHtml += node.outerHTML;
	          }
	          var title = (_this3.calInfo.name || 'Docendo').replace(/</g, '');
	          WinPrint.document.write('<!DOCTYPE html><html><head><title>' + title + '</title>' + stylesHtml + '<style>html,body{-webkit-print-color-adjust:exact;print-color-adjust:exact}</style></head><body>' + prtHtml + '</body></html>');
	          var afterPrint = function afterPrint() {
	            WinPrint.close();
	            _this3.isCalendarInPrintMode = false;
	            if (weekplanEl) {
	              weekplanEl.classList.remove('hide');
	            }
	          };
	          WinPrint.onafterprint = afterPrint;
	          setTimeout(function () {
	            WinPrint.document.close();
	            WinPrint.focus();
	            WinPrint.print();
	          }, 1000);
	        }, 500);
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (window.location.href && window.location.href.indexOf('?update') > -1) {
	      this.intervalId = setInterval(this.getLessons, 300000);
	    }
	  },
	  mounted: function mounted() {
	    this.getSchoolInfo();
	    this.getLessons();
	    if (this.$helpers.getCookie('calendar_current_date_public') && this.$helpers.getCookie('calendar_current_date')) {
	      this.setDate(this.$helpers.getCookie('calendar_current_date'));
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.intervalId) {
	      clearInterval(this.intervalId);
	    }
	  }
	};

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DCalendar = __webpack_require__(53);
	
	var _DCalendar2 = _interopRequireDefault(_DCalendar);
	
	var _SmartScreen = __webpack_require__(1709);
	
	var _SmartScreen2 = _interopRequireDefault(_SmartScreen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DCalendar: _DCalendar2.default, SmartScreen: _SmartScreen2.default },
	  props: {
	    calendarId: {},
	    calendar: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      startDate: (0, _moment2.default)().startOf('isoWeek'),
	      endDate: (0, _moment2.default)().endOf('isoWeek'),
	      events: [],
	      isLoadingEvents: false
	    };
	  },
	
	  computed: {
	    calendarName: function calendarName() {
	      return this.calendar ? this.calendar.name : '';
	    }
	  },
	  methods: {
	    getCalendarEvents: function getCalendarEvents() {
	      var _this = this;
	
	      this.isLoadingEvents = true;
	      _docendo2.default.publicEventsFromCalendar(this.calendarId, this.startDate, this.endDate, function (success) {
	        _this.events = success && success.length > 0 ? JSON.parse(success) : [];
	        _this.isLoadingEvents = false;
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.getCalendarEvents();
	  }
	};

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SetLocale = __webpack_require__(362);
	
	var _SetLocale2 = _interopRequireDefault(_SetLocale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { setLocale: _SetLocale2.default },
	  props: ['calname', 'schoolname'],
	  data: function data() {
	    return {
	      locale: 'en'
	    };
	  },
	
	  methods: {
	    emitLocale: function emitLocale(val) {
	      this.locale = val;
	      this.$emit('locale', val);
	    }
	  },
	  updated: function updated() {
	    document.title = this.calname;
	  }
	};

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    calendarId: {
	      default: 285799
	    }
	  },
	  data: function data() {
	    return {
	      date: (0, _moment2.default)(),
	      events: [],
	      isLoadingEvents: false,
	      refreshTimeout: null,
	      fontSize: '16px',
	      scrollInterval: null
	    };
	  },
	
	  computed: {
	    computedStyle: function computedStyle() {
	      return {
	        fontSize: this.fontSize
	      };
	    },
	    dateFormatted: function dateFormatted() {
	      return (0, _moment2.default)(this.date).format('dddd LL');
	    },
	    latestUpdate: function latestUpdate() {
	      return (0, _moment2.default)(this.date).format('LL LTS');
	    },
	    eventsFiltered: function eventsFiltered() {
	      var _this = this;
	
	      return this.events.filter(function (event) {
	        return (0, _moment2.default)(event.start).locale('en').format('YYYY-MM-DD') === (0, _moment2.default)(_this.date).locale('en').format('YYYY-MM-DD');
	      });
	    },
	    eventsSorted: function eventsSorted() {
	      return this.eventsFiltered.sort(function (a, b) {
	        return (0, _moment2.default)(a.start).unix() - (0, _moment2.default)(b.start).unix();
	      });
	    },
	    eventsWithProps: function eventsWithProps() {
	      return this.eventsSorted.map(function (event) {
	        return (0, _extends3.default)({}, event, {
	          vEventTime: (0, _moment2.default)(event.start).format('LT') + ' - ' + (0, _moment2.default)(event.end).format('LT'),
	          vRooms: event.calendars.filter(function (cal) {
	            return cal.calendar_type === 'room';
	          }).map(function (cal) {
	            return cal.name;
	          }).join(', '),
	          vTeachers: event.calendars.filter(function (cal) {
	            return cal.calendar_type === 'user';
	          }).map(function (cal) {
	            return cal.name;
	          }).join(', '),
	          vStudents: event.calendars.filter(function (cal) {
	            return cal.calendar_type === 'student';
	          }).map(function (cal) {
	            return cal.name;
	          }).join(', ')
	        });
	      });
	    }
	  },
	  watch: {
	    events: function events(val) {
	      var _this2 = this;
	
	      this.$nextTick(function (_) {
	        _this2.checkForUrlParamScroll();
	      });
	    }
	  },
	  methods: {
	    checkScrollable: function checkScrollable() {
	      var publicAppElement = document.querySelector('.public-app');
	      var viewportHeight = window.innerHeight;
	
	      if (publicAppElement.offsetHeight > viewportHeight) {
	        console.log('The .public-app element is taller than the viewport and can be scrolled.');
	
	        this.startAutoScroll();
	      } else {
	        console.log('The .public-app element is not taller than the viewport and cannot be scrolled.');
	      }
	    },
	    startAutoScroll: function startAutoScroll() {
	      var scrollDirection = 1;
	      var scrollSpeed = 1;
	
	      var autoScrollPage = function autoScrollPage() {
	        window.scrollBy(0, scrollSpeed * scrollDirection);
	
	        if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
	          scrollDirection = -1;
	        } else if (window.scrollY <= 0) {
	          scrollDirection = 1;
	        }
	      };
	      clearInterval(this.scrollInterval);
	      this.scrollInterval = setInterval(autoScrollPage, 30);
	    },
	    setupRefresh: function setupRefresh() {
	      var _this3 = this;
	
	      this.getCalendarEvents();
	
	      this.refreshTimeout = setInterval(function () {
	        _this3.date = (0, _moment2.default)();
	        _this3.getCalendarEvents();
	      }, 600000);
	    },
	    getCalendarEvents: function getCalendarEvents() {
	      var _this4 = this;
	
	      this.isLoadingEvents = true;
	      var startDate = (0, _moment2.default)(this.date);
	      var endDate = (0, _moment2.default)(this.date).add(1, 'days');
	      _docendo2.default.publicEventsFromCalendar(this.calendarId, startDate, endDate, function (success) {
	        _this4.events = success && success.length > 0 ? JSON.parse(success) : [];
	        _this4.isLoadingEvents = false;
	        _this4.$nextTick(function (_) {});
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    updateFontSizeFromUrl: function updateFontSizeFromUrl() {
	      var hash = window.location.hash;
	
	      if (hash.includes('?')) {
	        var queryString = hash.split('?')[1];
	        var urlParams = new window.URLSearchParams(queryString);
	        var fontsize = urlParams.get('fontsize');
	
	        if (fontsize) {
	          this.fontSize = fontsize + 'px';
	        }
	      }
	    },
	    checkForUrlParamScroll: function checkForUrlParamScroll() {
	      var hash = window.location.hash;
	
	      if (hash.includes('?')) {
	        var queryString = hash.split('?')[1];
	        var urlParams = new window.URLSearchParams(queryString);
	        var autoscroll = urlParams.get('autoscroll');
	
	        if (autoscroll && autoscroll === 'true') {
	          console.log('Autoscroll is enabled');
	
	          this.checkScrollable();
	        } else {
	          console.log('Autoscroll is disabled');
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.setupRefresh();
	    this.updateFontSizeFromUrl();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.refreshTimeout);
	  }
	};

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _WeekPlanLesson = __webpack_require__(1711);
	
	var _WeekPlanLesson2 = _interopRequireDefault(_WeekPlanLesson);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    events: {},
	    calId: {},
	    date: {
	      default: (0, _moment2.default)().utc()
	    },
	    calview: {},
	    locale: {}
	  },
	  data: function data() {
	    return {
	      weekNote: ''
	    };
	  },
	
	  watch: {
	    date: function date() {
	      this.getWeekNote();
	      this.createLocaleDate(this.date);
	    }
	  },
	  components: {
	    dWeekPlanLesson: _WeekPlanLesson2.default
	  },
	  computed: {
	    weekNoteWithLineBreaks: function weekNoteWithLineBreaks() {
	      return this.weekNote.replace(/(?:\r\n|\r|\n)/g, '<br/>');
	    },
	    eventsWithNotes: function eventsWithNotes() {
	      var allDates = [];
	      for (var i = 1; i < 8; i++) {
	        var date = (0, _moment2.default)(this.date).isoWeekday(i).locale('en').format('YYYY-MM-DD');
	        var arr = this.filterLesson(i).concat();
	        arr.sort(function compare(a, b) {
	          var dateA = new Date(a.start);
	          var dateB = new Date(b.start);
	          return dateA - dateB;
	        });
	        allDates.push({ date: date, lessons: arr });
	      }
	      return allDates;
	    }
	  },
	  methods: {
	    createLocaleDate: function createLocaleDate(mom) {
	      if (this.locale === 'nn') {
	        return (0, _moment2.default)(mom).format('dddd DD. MMMM');
	      }
	      try {
	        return (0, _moment2.default)(mom)._d.toLocaleDateString(this.locale, { weekday: 'long', month: 'long', day: '2-digit' });
	      } catch (e) {
	        return (0, _moment2.default)(mom).format('LL');
	      }
	    },
	    getWeekNote: function getWeekNote() {
	      var _this = this;
	
	      var isoWeek = (0, _moment2.default)(this.date).isoWeek().toString().length < 2 ? '0' + (0, _moment2.default)(this.date).isoWeek() : (0, _moment2.default)(this.date).isoWeek();
	      var week = (0, _moment2.default)(this.date).endOf('week').locale('en').format('YYYY') + 'W' + isoWeek;
	      _docendo2.default.weeknote(this.calId, week, function (data) {
	        _this.weekNote = data.note;
	      });
	    },
	    filterLesson: function filterLesson(dayNum) {
	      var _this2 = this;
	
	      return this.events.filter(function (lesson) {
	        var lessonDate = (0, _moment2.default)(lesson.start).locale('en').format('YYYY-MM-DD');
	        var day = (0, _moment2.default)(_this2.date).isoWeekday(dayNum).locale('en').format('YYYY-MM-DD');
	        return (0, _moment2.default)(lessonDate).isSame(day) && lesson.has_notes;
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.getWeekNote();
	  }
	};

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['event', 'date'],
	  computed: {
	    learningGoal: function learningGoal() {
	      return this.event.learning_goal;
	    },
	    description: function description() {
	      return this.event.description;
	    },
	    notes_for_students: function notes_for_students() {
	      return this.event.notes_for_students;
	    }
	  }
	};

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DatepickerMobile = __webpack_require__(1699);
	
	var _DatepickerMobile2 = _interopRequireDefault(_DatepickerMobile);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    theCalendarDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    active: {
	      type: Boolean,
	      default: false
	    },
	    dateChange: {}
	  },
	  components: { mobileDatepicker: _DatepickerMobile2.default },
	  data: function data() {
	    return {
	      calendars: [],
	      translateX: 0,
	      panStart: 0,
	      panCurrent: 0,
	      isScrolling: false,
	      isActive: false
	    };
	  },
	
	  watch: {
	    active: function active(val) {
	      var _this = this;
	
	      if (val) {
	        setTimeout(function (_) {
	          _this.isActive = true;
	        });
	      } else {
	        this.isActive = false;
	      }
	    }
	  },
	  methods: {
	    addThreeCalendars: function addThreeCalendars() {
	      this.addCal(this.date);
	      var prev = (0, _moment2.default)(this.date).subtract(1, 'months');
	      var next = (0, _moment2.default)(this.date).add(1, 'months');
	      this.addCal(prev);
	      this.addCal(next);
	    },
	    addCal: function addCal(date) {
	      var calDate = (0, _moment2.default)(date).locale('en').format('YYYY-MM-DD');
	      var calDateStartOfMonth = (0, _moment2.default)(calDate).startOf('month');
	      var dateStartOfMonth = (0, _moment2.default)(this.date).startOf('month');
	      var diff = (0, _moment2.default)(calDateStartOfMonth).diff(dateStartOfMonth, 'months', false);
	      var disX = 100 * diff;
	      this.calendars.push({ date: calDate, style: disX });
	    },
	    updateCal: function updateCal(date) {
	      var calDate = (0, _moment2.default)(this.date).locale('en').format('YYYY-MM-DD');
	      for (var i = 0; i < 3; i++) {
	        var calDateStartOfMonth = (0, _moment2.default)(calDate).startOf('month');
	        var dateStartOfMonth = (0, _moment2.default)(this.calendars[i].date).startOf('month');
	        var dateDiff = (0, _moment2.default)(calDateStartOfMonth).diff(dateStartOfMonth, 'months');
	        if (dateDiff === -2) {
	          var prevDate = (0, _moment2.default)(date).subtract(1, 'months').locale('en').format('YYYY-MM-DD');
	          var x = this.translateX + 100;
	          this.calendars[i].date = prevDate;
	          this.calendars[i].style = -x;
	        }
	        if (dateDiff === 2) {
	          var nextDate = (0, _moment2.default)(date).add(1, 'months').locale('en').format('YYYY-MM-DD');
	          var _x = this.translateX - 100;
	          this.calendars[i].date = nextDate;
	          this.calendars[i].style = -_x;
	        }
	      }
	    },
	    setPanStart: function setPanStart(e) {
	      this.panStart = e.srcEvent.pageX || e.pointers[0].pageX;
	    },
	    onPan: function onPan(e) {
	      e.preventDefault();
	      this.panCurrent = e.srcEvent.pageX || e.pointers[0].pageX;
	      var element = document.querySelector('.days-container');
	      var distanceX = this.panCurrent - this.panStart;
	      var percentage = distanceX / element.getBoundingClientRect().width * 100;
	      var range = this.translateX + percentage;
	      element.style.transitionDuration = '0ms';
	      element.style.webkitTransform = 'translate3d(' + range + '%, 0,0)';
	    },
	    onPanEnd: function onPanEnd(e) {
	      var _this2 = this;
	
	      var element = document.querySelector('.days-container');
	      element.style.transitionDuration = '0ms';
	      element.style.webkitTransform = 'translate3d(' + 0 + '%, 0,0)';
	      var distanceX = this.panCurrent - this.panStart;
	      if (Math.abs(distanceX) < 55) {
	        this.scrollToDate(this.translateX, 5);
	      } else {
	        if (distanceX > 55) {
	          this.translateX = this.translateX + 100;
	          this.scrollToDate(this.translateX, 35);
	          var date = (0, _moment2.default)(this.date).subtract(1, 'months').locale('en').format('YYYY-MM-DD');
	          this.$emit('changed', date);
	          setTimeout(function () {
	            _this2.updateCal(_this2.date);
	          }, 200);
	        } else {
	          this.translateX = this.translateX - 100;
	          this.scrollToDate(this.translateX, 35);
	          var _date = (0, _moment2.default)(this.date).add(1, 'months').locale('en').format('YYYY-MM-DD');
	          this.$emit('changed', _date);
	          setTimeout(function () {
	            _this2.updateCal(_this2.date);
	          }, 200);
	        }
	      }
	      this.panStart = null;
	    },
	    scrollToDate: function scrollToDate(scroolX, speed) {
	      var element = document.querySelector('.days-container');
	      element.style.webkitTransform = 'translate3d(' + scroolX + '%, 0,0)';
	      element.style.transition = '0.' + speed + 's';
	    },
	    setCalDate: function setCalDate(date) {
	      this.translateX = 0;
	      this.scrollToDate(0, 0);
	      this.$emit('setDate', date);
	    }
	  },
	  mounted: function mounted() {
	    this.addThreeCalendars();
	  }
	};

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DayCal = __webpack_require__(1714);
	
	var _DayCal2 = _interopRequireDefault(_DayCal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['date', 'dateChange', 'viewState', 'locale', 'lessons', 'i18n'],
	  components: { dayCal: _DayCal2.default },
	  data: function data() {
	    return {
	      height: 300
	    };
	  },
	
	  methods: {
	    onTap: function onTap(lesson) {
	      this.$emit('eventClicked', lesson);
	    },
	    calculateHeightForCalendar: function calculateHeightForCalendar() {
	      var bottom = document.querySelector('.day-select__container').getBoundingClientRect().bottom;
	      var windowHeight = window.innerHeight;
	      this.height = windowHeight - bottom - 55;
	    },
	    setScrollTop: function setScrollTop(val) {
	      this.$el.scrollTop = val.top - 20;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.calculateHeightForCalendar();
	    window.addEventListener('resize', function () {
	      _this.calculateHeightForCalendar();
	    });
	  }
	};

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DayCalEvent = __webpack_require__(1715);
	
	var _DayCalEvent2 = _interopRequireDefault(_DayCalEvent);
	
	var _NowIndicator = __webpack_require__(1716);
	
	var _NowIndicator2 = _interopRequireDefault(_NowIndicator);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _config = __webpack_require__(62);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _eventTypeOrder = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    date: {
	      default: function _default() {
	        return _config2.default.now;
	      }
	    },
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    viewState: {
	      type: Number,
	      default: 0
	    },
	    locale: {
	      default: window.USER && window.USER.locale ? window.USER.locale : 'en'
	    },
	    i18n: {}
	  },
	  components: { calEvent: _DayCalEvent2.default, nowIndicator: _NowIndicator2.default },
	  data: function data() {
	    return {
	      slotHeight: 40,
	      correctEvents: [],
	      firstEvent: true
	    };
	  },
	
	  computed: {
	    start: function start() {
	      if (this.viewState !== 2) {
	        return 6;
	      } else {
	        return 0;
	      }
	    },
	    end: function end() {
	      if (this.viewState !== 2) {
	        return 18;
	      } else {
	        return 24;
	      }
	    },
	    isToday: function isToday() {
	      var date = (0, _moment2.default)(this.date).locale('en').format('YYYY-MM-DD');
	      var today = (0, _moment2.default)().locale('en').format('YYYY-MM-DD');
	      return (0, _moment2.default)(date).isSame(today);
	    },
	    dayLessons: function dayLessons() {
	      var _this = this;
	
	      return this.events.filter(function (lesson) {
	        var lessonDate = (0, _moment2.default)(lesson.start).locale('en').format('YYYY-MM-DD');
	        var day = (0, _moment2.default)(_this.date).locale('en').format('YYYY-MM-DD');
	        return (0, _moment2.default)(lessonDate).isSame(day);
	      });
	    },
	    hours: function hours() {
	      var hours = [];
	      for (var i = this.start; i <= this.end; i++) {
	        hours.push(i);
	      }
	      return hours;
	    },
	    hoursInLocale: function hoursInLocale() {
	      var _this2 = this;
	
	      var localeHours = [];
	      this.hours.forEach(function (h) {
	        var mom = (0, _moment2.default)().set({ hour: h, minutes: 0, seconds: 0 });
	        localeHours.push((0, _moment2.default)(mom).locale(_this2.locale).format('LT'));
	      });
	      return localeHours;
	    }
	  },
	  watch: {
	    dayLessons: function dayLessons() {
	      this.correctEvents = [];
	      this.setWidthAndLeft();
	      this.firstEvent = true;
	    }
	  },
	  methods: {
	    onTap: function onTap(lesson) {
	      this.$emit('eventClicked', lesson);
	    },
	    getHeightOfTimeSlots: function getHeightOfTimeSlots() {
	      var height = document.getElementsByClassName('time-slot')[1].getBoundingClientRect().height;
	      this.slotHeight = height;
	    },
	    eventTop: function eventTop(event) {
	      var calStartTime = (0, _moment2.default)(event.start).hour(this.start).minutes('0');
	      var eventStartTime = (0, _moment2.default)(event.start);
	      var duration = (0, _moment2.default)(eventStartTime).diff(calStartTime);
	      return this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    },
	    eventHeight: function eventHeight(event) {
	      var duration = (0, _moment2.default)(event.end).diff(event.start);
	      return this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    },
	    eventBottom: function eventBottom(event) {
	      var calStartTime = (0, _moment2.default)(event.end).hour(this.start).minutes('0');
	      var eventEndTime = (0, _moment2.default)(event.end);
	      var duration = (0, _moment2.default)(eventEndTime).diff(calStartTime);
	      return this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    },
	    collidesWith: function collidesWith(a, b) {
	      return a.bottom > b.top && a.top < b.bottom;
	    },
	    packEvents: function packEvents(columns) {
	      var n = columns.length;
	      for (var i = 0; i < n; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev = col[j];
	          var colSpan = this.expandEvent(ev, i, columns);
	          col[j].left = i / n * 100;
	          col[j].width = 100 * colSpan / n;
	          this.correctEvents.push(col[j]);
	
	          if (this.firstEvent) {
	            this.$emit('lessonsUpdate', this.correctEvents[0]);
	          }
	          this.firstEvent = false;
	        }
	      }
	    },
	    expandEvent: function expandEvent(ev, iColumn, columns) {
	      var colSpan = 1;
	      for (var i = iColumn + 1; i < columns.length; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev1 = col[j];
	          if (this.collidesWith(ev, ev1)) {
	            return colSpan;
	          }
	        }
	        colSpan++;
	      }
	      return colSpan;
	    },
	    setWidthAndLeft: function setWidthAndLeft() {
	      var _this3 = this;
	
	      var cluster = [];
	      var lastEventEnding = null;
	      var events = this.dayLessons.map(function (elem) {
	        var top = _this3.eventTop(elem);
	        var height = _this3.eventHeight(elem);
	        var bottom = _this3.eventBottom(elem);
	        return {
	          'obj': elem,
	          'top': top,
	          'height': height,
	          'bottom': bottom
	        };
	      });
	
	      events = events.sort(function (e1, e2) {
	        return e1.top - e2.top || e2.bottom - e1.bottom;
	      });
	      for (var i = 0; i < events.length; i++) {
	        var e = events[i];
	        if (lastEventEnding !== null && e.top >= lastEventEnding) {
	          this.packCluster(cluster);
	          cluster = [];
	          lastEventEnding = null;
	        }
	        cluster.push(e);
	        if (lastEventEnding === null || e.bottom > lastEventEnding) {
	          lastEventEnding = e.bottom;
	        }
	      }
	      if (cluster.length > 0) {
	        this.packCluster(cluster);
	      }
	    },
	    packCluster: function packCluster(cluster) {
	      var _this4 = this;
	
	      var columns = [];
	      cluster.sort(_eventTypeOrder.compareEventsByType).forEach(function (e) {
	        var col = columns.find(function (col) {
	          return col.every(function (ev) {
	            return !_this4.collidesWith(ev, e);
	          });
	        });
	        if (col) {
	          col.push(e);
	        } else {
	          columns.push([e]);
	        }
	      });
	      columns.forEach(function (col) {
	        return col.sort(function (a, b) {
	          return a.top - b.top;
	        });
	      });
	      this.packEvents(columns);
	    }
	  },
	  mounted: function mounted() {
	    this.getHeightOfTimeSlots();
	  }
	};

/***/ }),
/* 877 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['event', 'start', 'i18n'],
	  data: function data() {
	    return {
	      slotHeight: 40
	    };
	  },
	
	  computed: {
	    styleObject: function styleObject() {
	      var styleObject = {
	        borderColor: this.event.obj.color,
	        height: this.event.height + 'px',
	        top: this.event.top - 1 + 'px',
	        left: this.event.left + '%',
	        width: this.event.width + '%'
	      };
	      return styleObject;
	    }
	  },
	  methods: {
	    getEventWarningLabel: function getEventWarningLabel(eventObj) {
	      if (eventObj.canceled) {
	        return this.i18n.canceled;
	      }
	      if (eventObj.away) {
	        return this.i18n.out_of_school;
	      }
	    }
	  }
	};

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    start: {
	      default: 6
	    },
	    slotHeight: {
	      default: 40
	    }
	  },
	  computed: {
	    top: function top() {
	      return this.eventTop();
	    }
	  },
	  methods: {
	    eventTop: function eventTop() {
	      var calStartTime = (0, _moment2.default)().hour(this.start).minutes('0');
	      var eventStartTime = (0, _moment2.default)();
	      var duration = (0, _moment2.default)(eventStartTime).diff(calStartTime);
	      return this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    }
	  }
	};

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    isNotToday: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: {
	    className: function className() {
	      return _eventbus2.default.sideWideAnnouncement ? 'true' : '';
	    }
	  },
	  methods: {
	    prev: function prev(e) {
	      e.preventDefault();
	      this.$emit('prev');
	    },
	    next: function next(e) {
	      e.preventDefault();
	      this.$emit('next');
	    },
	    preventZoom: function preventZoom(e) {
	      e.preventDefault();
	    }
	  }
	};

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    date: {
	      default: (0, _moment2.default)().format('YYYY-MM-DD')
	    },
	    showdatepicker: {},
	    calname: {},
	    schoolname: {},
	    anyWeekNotes: {
	      type: Boolean,
	      default: false
	    },
	    locale: {
	      default: window.USER && window.USER.locale ? window.USER.locale : 'en'
	    }
	  },
	  computed: {
	    weekNum: function weekNum() {
	      return (0, _moment2.default)(this.date).isoWeek();
	    },
	    isMonth: function isMonth() {
	      return (0, _moment2.default)(this.date).locale(this.locale).format('MMMM, YYYY');
	    }
	  },
	  methods: {
	    sendClick: function sendClick() {
	      this.$emit('monthClick');
	    }
	  }
	};

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(1718);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _DaySelect = __webpack_require__(1700);
	
	var _DaySelect2 = _interopRequireDefault(_DaySelect);
	
	var _PanContainer = __webpack_require__(1712);
	
	var _PanContainer2 = _interopRequireDefault(_PanContainer);
	
	var _CalContainer = __webpack_require__(1713);
	
	var _CalContainer2 = _interopRequireDefault(_CalContainer);
	
	var _FooterNav = __webpack_require__(1717);
	
	var _FooterNav2 = _interopRequireDefault(_FooterNav);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _config = __webpack_require__(62);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ShowEvent = __webpack_require__(420);
	
	var _ShowEvent2 = _interopRequireDefault(_ShowEvent);
	
	var _Container = __webpack_require__(1722);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SideNav = __webpack_require__(1720);
	
	var _SideNav2 = _interopRequireDefault(_SideNav);
	
	var _CalContainer3 = __webpack_require__(1721);
	
	var _CalContainer4 = _interopRequireDefault(_CalContainer3);
	
	var _SiteWideAnnouncement = __webpack_require__(1724);
	
	var _SiteWideAnnouncement2 = _interopRequireDefault(_SiteWideAnnouncement);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DAppCalendarNav = __webpack_require__(1484);
	
	var _DAppCalendarNav2 = _interopRequireDefault(_DAppCalendarNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DAppCalendarNav: _DAppCalendarNav2.default,
	    publicHeader: _Header2.default,
	    daySelector: _DaySelect2.default,
	    calContainer: _CalContainer2.default,
	    showEvent: _ShowEvent2.default,
	    panContainer: _PanContainer2.default,
	    footerNav: _FooterNav2.default,
	    weekplan: _Container2.default,
	    sidenav: _SideNav2.default,
	    weekCalendar: _CalContainer4.default,
	    announcement: _SiteWideAnnouncement2.default
	  },
	  props: ['calId', 'viewState', 'weekplan', 'schoolName', 'calName', 'i18n'],
	  data: function data() {
	    return {
	      chosenView: 1,
	      oldChosenView: 1,
	      allEvents: [],
	      date: _config2.default.now,
	      today: _config2.default.now,
	      dateChange: false,
	      locale: _moment2.default.locale(),
	      datePickerDate: _config2.default.now,
	      showdatepicker: false,
	      isDatePickerReady: false,
	      weeknote: '',
	      menu: false,
	      start: _config2.default.now,
	      end: _config2.default.now,
	      load: true
	    };
	  },
	
	  watch: {
	    showdatepicker: function showdatepicker() {
	      this.showdatepicker === false ? this.datePickerDate = this.date : null;
	    },
	    date: function date(val, oldVal) {
	      if ((0, _moment2.default)(val).isoWeek() !== (0, _moment2.default)(oldVal).isoWeek()) {
	        this.getWeekNote();
	      }
	    },
	    chosenView: function chosenView(val, oldval) {
	      this.oldChosenView = oldval;
	      try {
	        if (typeof Storage !== 'undefined') {
	          window.localStorage.setItem('chosenView', this.chosenView);
	        }
	      } catch (e) {}
	      this.getLessons();
	    }
	  },
	  computed: {
	    isNotToday: function isNotToday() {
	      return (0, _moment2.default)(this.date).locale('en').format('YYYY-MM-DD') !== (0, _moment2.default)(this.today).locale('en').format('YYYY-MM-DD');
	    }
	  },
	  methods: {
	    getView: function getView(val) {
	      this.chosenView = val;
	    },
	    setDate: function setDate(date) {
	      this.date = date;
	      this.datePickerDate = date;
	      this.dateChange = !this.dateChange;
	      this.getLessons();
	      this.closeDatepicker();
	    },
	    closeDatepicker: function closeDatepicker() {
	      this.showdatepicker = false;
	      this.isDatePickerReady = false;
	    },
	    setDatePickerDate: function setDatePickerDate(date) {
	      this.datePickerDate = date;
	    },
	    parseEvents: function parseEvents(data) {
	      var events = data;
	      if (typeof data === 'string') {
	        try {
	          events = JSON.parse(data);
	        } catch (e) {
	          events = [];
	        }
	      }
	      var parsed = Array.isArray(events) ? events : [];
	      var calId = this.calId * 1;
	      for (var i = 0; i < parsed.length; i++) {
	        var ev = parsed[i];
	
	        delete ev.collision;
	        delete ev.away;
	
	        var calendars = ev.calendars || [];
	        var groups = [];
	        var teachers = [];
	        var rooms = [];
	        for (var j = 0; j < calendars.length; j++) {
	          var cal = calendars[j];
	          if (cal.calendar_type === 'klass' && cal.calendar_id !== calId) {
	            groups.push(cal.name);
	          } else if (cal.calendar_type === 'user') {
	            teachers.push(cal.name);
	          } else if (cal.calendar_type === 'room') {
	            rooms.push(cal.name);
	          }
	        }
	        ev.group = groups.join(', ');
	        ev.teacher = teachers.join(', ');
	        ev.room = rooms.join(', ');
	        ev.canceled = ev.canceled || false;
	        ev.away = false;
	        ev.has_substitute = ev.has_substitute || false;
	
	        var startMoment = (0, _moment2.default)(ev.start);
	        var endMoment = (0, _moment2.default)(ev.end);
	        ev.duration = endMoment.diff(startMoment, 'minutes');
	
	        var desc = (ev.description || '').replace(/<[^>]*>/g, '').trim();
	        var goal = (ev.learning_goal || '').replace(/<[^>]*>/g, '').trim();
	        var studentNotes = (ev.notes_for_students || '').replace(/<[^>]*>/g, '').trim();
	        var teacherNotes = (ev.teacher_notes || '').replace(/<[^>]*>/g, '').trim();
	        ev.has_notes = !!(desc || goal || studentNotes || teacherNotes);
	      }
	      return parsed;
	    },
	    getLessons: function getLessons() {
	      var _this = this;
	
	      var timer;
	
	      _eventbus2.default.loadingEvents = true;
	      timer = setTimeout(function () {
	        _this.load = true;
	      }, 300);
	      var date = (0, _moment2.default)(this.date).locale('en').format('YYYY-MM-DD');
	      if (this.chosenView !== 1) {
	        this.start = (0, _moment2.default)(date).startOf('isoWeek').locale('en').format('YYYY-MM-DD 00:00');
	        this.end = (0, _moment2.default)(date).endOf('isoWeek').locale('en').format('YYYY-MM-DD 23:59');
	      } else {
	        this.start = (0, _moment2.default)(date).startOf('day').locale('en').format('YYYY-MM-DD 00:00');
	        this.end = (0, _moment2.default)(date).endOf('day').locale('en').format('YYYY-MM-DD 23:59');
	      }
	      _docendo2.default.publicEventsFromCalendar(this.calId, this.start, this.end, function (data) {
	        clearTimeout(timer);
	        _this.load = false;
	        _eventbus2.default.loadingEvents = false;
	        _this.allEvents = _this.parseEvents(data);
	      }, function () {
	        clearTimeout(timer);
	        _this.load = false;
	        _eventbus2.default.loadingEvents = false;
	      });
	    },
	    getWeekNote: function getWeekNote() {
	      var _this2 = this;
	
	      var isoWeek = (0, _moment2.default)(this.date).isoWeek().toString().length < 2 ? '0' + (0, _moment2.default)(this.date).isoWeek() : (0, _moment2.default)(this.date).isoWeek();
	      var week = (0, _moment2.default)(this.date).endOf('week').locale('en').format('YYYY') + 'W' + isoWeek;
	      _docendo2.default.weeknote(this.calId, week, function (data) {
	        if (data.note === undefined) {
	          _this2.weeknote = '';
	        } else {
	          _this2.weeknote = data.note;
	        }
	      });
	    },
	    prev: function prev() {
	      var prevDate = void 0;
	      if (this.chosenView !== 1) {
	        prevDate = (0, _moment2.default)(this.date).subtract(7, 'days').isoWeekday(1);
	      } else {
	        prevDate = (0, _moment2.default)(this.date).subtract(1, 'days');
	      }
	      this.setDate(prevDate);
	    },
	    next: function next() {
	      var nextDate = void 0;
	      if (this.chosenView !== 1) {
	        nextDate = (0, _moment2.default)(this.date).add(7, 'days').isoWeekday(1);
	      } else {
	        nextDate = (0, _moment2.default)(this.date).add(1, 'days');
	      }
	      this.setDate(nextDate);
	    },
	    showEvent: function showEvent(event) {
	      this.$emit('eventClick', event);
	    },
	    setLocale: function setLocale(val) {
	      this.locale = val;
	      this.$emit('setLocale', val);
	    },
	    closeWeekPlan: function closeWeekPlan() {
	      this.chosenView = this.oldChosenView;
	    },
	    setMenu: function setMenu() {
	      this.closeDatepicker();
	      this.menu = true;
	    },
	    toggleDatePicker: function toggleDatePicker() {
	      var _this3 = this;
	
	      if (!this.showdatepicker) {
	        this.showdatepicker = true;
	        setTimeout(function (_) {
	          _this3.isDatePickerReady = true;
	        }, 0);
	      } else {
	        this.closeDatepicker();
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    try {
	      if (typeof Storage !== 'undefined') {
	        if (window.localStorage.getItem('chosenView') !== null) {
	          this.chosenView = window.localStorage.getItem('chosenView') * 1;
	        }
	      }
	    } catch (e) {}
	  },
	  mounted: function mounted() {
	    this.getLessons();
	    this.getWeekNote();
	  },
	  updated: function updated() {
	    document.title = this.calName;
	  }
	};

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SetLocale = __webpack_require__(362);
	
	var _SetLocale2 = _interopRequireDefault(_SetLocale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { setLocale: _SetLocale2.default },
	  props: {
	    menu: {
	      default: false
	    },
	    schoolName: {},
	    calName: {},
	    chosenView: {
	      default: 1
	    }
	  },
	  data: function data() {
	    return {
	      view: this.chosenView,
	      startX: 0,
	      currentX: 0,
	      translate: 0,
	      translateX: -105 + '%',
	      touchingSideNav: false
	    };
	  },
	
	  watch: {
	    chosenView: function chosenView() {
	      this.view = this.chosenView;
	    },
	    menu: function menu(val) {
	      if (val) {
	        this.translateX = 0 + '%';
	      } else {
	        this.translateX = -105 + '%';
	      }
	    }
	  },
	  methods: {
	    onPanStart: function onPanStart(e) {
	      this.touchingSideNav = true;
	      this.startX = e.srcEvent.pageX;
	      window.requestAnimationFrame(this.update);
	    },
	    onPanEnd: function onPanEnd(e) {
	      this.touchingSideNav = false;
	      if (this.translate < 0) {
	        this.$emit('close');
	      }
	    },
	    moveMenu: function moveMenu(e) {
	      if (!this.touchingSideNav) {
	        return;
	      }
	      this.currentX = e.srcEvent.pageX;
	      this.translate = Math.min(0, this.currentX - this.startX);
	    },
	    update: function update() {
	      if (!this.touchingSideNav) {
	        return;
	      }
	      window.requestAnimationFrame(this.update);
	      this.translateX = Math.min(0, this.currentX - this.startX) + 'px';
	    },
	    setView: function setView(num) {
	      this.$emit('close');
	      this.view = num;
	    },
	    sendView: function sendView() {
	      this.$emit('afterLeave', this.view);
	    },
	    emitLocale: function emitLocale(val) {
	      this.$emit('locale', val);
	    }
	  }
	};

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DCalendar = __webpack_require__(53);
	
	var _DCalendar2 = _interopRequireDefault(_DCalendar);
	
	var _WeekPlan = __webpack_require__(418);
	
	var _WeekPlan2 = _interopRequireDefault(_WeekPlan);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['lessons', 'date', 'dateChange', 'viewState', 'calId', 'weeknote', 'locale', 'i18n'],
	  components: { DCalendar: _DCalendar2.default, weekplan: _WeekPlan2.default },
	  computed: {
	    activeDate: function activeDate() {
	      return (0, _moment2.default)(this.date).locale('en').format('YYYY-MM-DD');
	    },
	    startTime: function startTime() {
	      var state = this.viewState * 1;
	      if (state === 2) return '00:00:00';
	      return '06:00:00';
	    },
	    endTime: function endTime() {
	      var state = this.viewState * 1;
	      if (state === 2) return '23:00:00';
	      return '18:00:00';
	    },
	    isShowWeekends: function isShowWeekends() {
	      var state = this.viewState * 1;
	      return state > 0;
	    },
	    calHeight: function calHeight() {
	      var startHour = parseInt(this.startTime);
	      var endHour = parseInt(this.endTime);
	      var hours = endHour - startHour;
	      var headerHeight = 50;
	
	      return headerHeight + hours * 2 * 20;
	    },
	    calRangeView: function calRangeView() {
	      var s = (0, _moment2.default)(this.date).locale(this.locale || 'da').isoWeekday(1);
	      var e = (0, _moment2.default)(this.date).locale(this.locale || 'da').isoWeekday(7);
	      var start = s.format('DD.');
	      var start2 = s.format('DD. MMM');
	      var end = e.format('DD. MMM YYYY');
	
	      if (s.format('MM') === e.format('MM')) {
	        return start + ' - ' + end;
	      } else {
	        return start2 + ' - ' + end;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      height: 300
	    };
	  },
	
	  methods: {
	    onTap: function onTap(event) {
	      var eventData = event.obj || event;
	      this.$emit('eventClicked', eventData);
	    },
	    calculateHeightForCalendar: function calculateHeightForCalendar() {
	      var windowHeight = window.innerHeight;
	      this.height = windowHeight - 55 - 55;
	    },
	    setScrollTop: function setScrollTop(val) {
	      this.$el.scrollTop = val.top - 20;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.addEventListener('resize', function () {
	      _this.calculateHeightForCalendar();
	    });
	    this.calculateHeightForCalendar();
	  }
	};

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _WeekPlan = __webpack_require__(418);
	
	var _WeekPlan2 = _interopRequireDefault(_WeekPlan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { weekplan: _WeekPlan2.default },
	  props: ['calId', 'events', 'date', 'weeknote', 'locale'],
	  data: function data() {
	    return {
	      height: 300
	    };
	  },
	
	  computed: {
	    calRangeView: function calRangeView() {
	      var s = (0, _moment2.default)(this.date).isoWeekday(1);
	      var e = (0, _moment2.default)(this.date).isoWeekday(7);
	      var start = s.locale(this.locale).format('ll');
	      var end = e.locale(this.locale).format('ll');
	      return start + ' - ' + end;
	    }
	  },
	  methods: {
	    onTap: function onTap(lesson) {
	      this.$emit('eventClicked', lesson);
	    },
	    calculateHeightForCalendar: function calculateHeightForCalendar() {
	      var windowHeight = window.innerHeight;
	      this.height = windowHeight - 80 - 55;
	    },
	    close: function close() {
	      this.$emit('close');
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.addEventListener('resize', function () {
	      _this.calculateHeightForCalendar();
	    });
	    this.calculateHeightForCalendar();
	  }
	};

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _WeekPlanLesson = __webpack_require__(1723);
	
	var _WeekPlanLesson2 = _interopRequireDefault(_WeekPlanLesson);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    dWeekPlanLesson: _WeekPlanLesson2.default
	  },
	  props: {
	    events: {},
	    calId: {},
	    date: {
	      default: (0, _moment2.default)().utc()
	    },
	    weeknote: {
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      weekNote: ''
	    };
	  },
	
	  computed: {
	    weekNoteWithLineBreaks: function weekNoteWithLineBreaks() {
	      return this.weeknote.replace(/(?:\r\n|\r|\n)/g, '<br/>');
	    },
	    isLoading: function isLoading() {
	      return _eventbus2.default.loadingEvents;
	    },
	    eventsWithNotes: function eventsWithNotes() {
	      var allDates = [];
	      for (var i = 1; i < 8; i++) {
	        var date = (0, _moment2.default)(this.date).isoWeekday(i).locale('en').format('YYYY-MM-DD');
	        var arr = this.filterLesson(i).concat();
	        allDates.push({ date: date, lessons: arr });
	      }
	      return allDates;
	    },
	    anyNotes: function anyNotes() {
	      return this.events.find(function (event) {
	        if (event.has_notes) {
	          return event.has_notes;
	        }
	      });
	    }
	  },
	  methods: {
	    filterLesson: function filterLesson(dayNum) {
	      var _this = this;
	
	      return this.events.filter(function (lesson) {
	        var lessonDate = (0, _moment2.default)(lesson.start).locale('en').format('YYYY-MM-DD');
	        var day = (0, _moment2.default)(_this.date).isoWeekday(dayNum).locale('en').format('YYYY-MM-DD');
	        return (0, _moment2.default)(lessonDate).isSame(day) && lesson.has_notes;
	      });
	    }
	  }
	};

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['event', 'date'],
	  methods: {
	    checkLengthWithoutHTML: function checkLengthWithoutHTML(text) {
	      return text.replace(/<(?:.|\n)*?>/gm, '');
	    }
	  }
	};

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShowEvent = __webpack_require__(420);
	
	var _ShowEvent2 = _interopRequireDefault(_ShowEvent);
	
	var _DesktopView = __webpack_require__(1706);
	
	var _DesktopView2 = _interopRequireDefault(_DesktopView);
	
	var _DesktopVue = __webpack_require__(1707);
	
	var _DesktopVue2 = _interopRequireDefault(_DesktopVue);
	
	var _MobileView = __webpack_require__(1719);
	
	var _MobileView2 = _interopRequireDefault(_MobileView);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    out_of_school: 'Ude af huset',
	    canceled: 'Aflyst'
	  },
	  en: {
	    out_of_school: 'Out of school',
	    canceled: 'Canceled'
	  },
	  nb: {
	    out_of_school: 'Utenfor skolen',
	    canceled: 'Avlyst'
	  }
	};
	
	exports.default = {
	  components: {
	    DesktopVue: _DesktopVue2.default,
	    showEvent: _ShowEvent2.default,
	    desktop: _DesktopView2.default,
	    app: _MobileView2.default
	  },
	  props: {
	    calId: {
	      type: Number,
	      default: 405264
	    }
	  },
	  data: function data() {
	    return {
	      calendar: null,
	      view: 'desktop',
	      isMobile: false,
	      activeEvent: null,
	      viewState: 0,
	      calName: '',
	      schoolName: '',
	      locale: window.USER && window.USER.locale ? window.USER.locale : 'en'
	    };
	  },
	
	  computed: {
	    i18n: function i18n() {
	      var loc = this.locale || 'en';
	      return I18N[loc] || I18N['en'];
	    }
	  },
	  methods: {
	    setLocale: function setLocale(val) {
	      this.locale = val;
	    },
	    setActiveEvent: function setActiveEvent(event) {
	      this.activeEvent = event;
	    },
	    getSchoolInfo: function getSchoolInfo() {
	      var _this = this;
	
	      _docendo2.default.calendar(this.calId, function (data) {
	        _this.calendar = data;
	        _this.calName = data.name;
	        _this.viewState = data.view_state;
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.isMobile = /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	    this.getSchoolInfo();
	    if (window.location.href && window.location.href.indexOf('smartscreen') > -1) {
	      this.view = 'smartscreen';
	    }
	  }
	};

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    event: {
	      type: Object
	    },
	    locale: {
	      default: window.USER && window.USER.locale ? window.USER.locale : 'en'
	    },
	    i18n: {}
	  },
	  computed: {
	    eventMinutes: function eventMinutes() {
	      var hours = Math.floor(this.event.duration / 60);
	      var minutes = this.event.duration - hours * 60;
	      return minutes;
	    },
	    eventHours: function eventHours() {
	      return Math.floor(this.event.duration / 60);
	    },
	    dayAndDate: function dayAndDate() {
	      if (this.locale === 'nn' || this.locale === 'nb') {
	        return (0, _moment2.default)(this.event.start).format('dddd DD. MMMM YYYY');
	      }
	      try {
	        return (0, _moment2.default)(this.event.start)._d.toLocaleDateString(this.locale, {
	          weekday: 'long',
	          month: 'long',
	          day: '2-digit',
	          year: 'numeric'
	        });
	      } catch (e) {
	        return (0, _moment2.default)(this.event.start).format('LL');
	      }
	    }
	  },
	  methods: {
	    checkLengthWithoutHTML: function checkLengthWithoutHTML(text) {
	      return text.replace(/<(?:.|\n)*?>/gm, '');
	    },
	    close: function close() {
	      this.$emit('close');
	    }
	  }
	};

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      videoid: 'GUsvPp2uuGk',
	      seen: false,
	      isActive: false,
	      isDone: false,
	      w: 320,
	      h: 200
	    };
	  },
	
	  methods: {
	    setSeen: function setSeen() {
	      var _this = this;
	
	      this.isActive = false;
	      this.isDone = true;
	      setTimeout(function () {
	        _this.seen = true;
	      }, 300);
	
	      _eventbus2.default.sideWideAnnouncement = false;
	      try {
	        if (typeof Storage !== 'undefined') {
	          window.localStorage.setItem('publicNewsSeen', true);
	        }
	      } catch (e) {}
	    },
	    getMobileOperatingSystem: function getMobileOperatingSystem() {
	      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	
	      if (/windows phone/i.test(userAgent)) {
	        this.videoid = 'GUsvPp2uuGk';
	      }
	      if (/android/i.test(userAgent)) {
	        this.videoid = 'Idpmc8dcFV0';
	      }
	
	      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	        this.videoid = 'Vkw-bVsvkq4';
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    try {
	      if (typeof Storage !== 'undefined') {
	        if (window.localStorage.getItem('publicNewsSeen') !== null) {
	          this.seen = window.localStorage.getItem('publicNewsSeen');
	        } else {
	          this.w = window.innerWidth;
	          _eventbus2.default.sideWideAnnouncement = true;
	        }
	      }
	    } catch (e) {}
	    this.getMobileOperatingSystem();
	  }
	};

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _config = __webpack_require__(62);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    date: {
	      type: Object,
	      default: function _default() {
	        return (0, _moment2.default)(_config2.default.now).set({ 'hour': 8, 'minutes': 0 });
	      }
	    },
	    customClass: {
	      default: 'd-time-change-input'
	    },
	    width: {
	      type: [Number, String],
	      default: null
	    }
	  },
	  computed: {
	    widthStyle: function widthStyle() {
	      if (this.width == null || this.width === '') {
	        return null;
	      }
	      var value = typeof this.width === 'number' ? this.width + 'px' : this.width;
	      return { width: value };
	    }
	  },
	  watch: {
	    date: function date() {
	      if (this.active === false) {
	        this.$refs.input.value = (0, _moment2.default)(this.date).format('LT');
	      }
	    }
	  },
	  data: function data() {
	    return {
	      active: false
	    };
	  },
	
	  methods: {
	    updateValue: function updateValue(val) {
	      this.$emit('changed', val);
	    },
	    formatValue: function formatValue() {
	      this.$emit('blur');
	      this.$refs.input.value = (0, _moment2.default)(this.date).format('LT');
	      this.active = false;
	    },
	
	    selectAll: function selectAll(event) {
	      setTimeout(function () {
	        event.target.select();
	      }, 0);
	      this.active = true;
	    }
	  },
	  mounted: function mounted() {
	    this.$refs.input.value = (0, _moment2.default)(this.date).format('LT');
	  }
	};

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Toast = __webpack_require__(1725);
	
	var _Toast2 = _interopRequireDefault(_Toast);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { toast: _Toast2.default },
	  data: function data() {
	    return {
	      toasts: []
	    };
	  },
	
	  computed: {
	    messageFromOtherComponent: function messageFromOtherComponent() {
	      return _eventbus2.default.toast;
	    }
	  },
	  watch: {
	    messageFromOtherComponent: function messageFromOtherComponent() {
	      var text = this.messageFromOtherComponent.text;
	      var status = this.messageFromOtherComponent.success;
	      var position = this.messageFromOtherComponent.position ? this.messageFromOtherComponent.position : null;
	      this.pushToast(text, status, position);
	    }
	  },
	  methods: {
	    pushToast: function pushToast(text, success, position) {
	      this.toasts.push({
	        id: Date.now(),
	        text: text,
	        success: success,
	        position: position
	      });
	    },
	    removeNow: function removeNow(id) {
	      for (var i = 0; i < this.toasts.length; i++) {
	        if (this.toasts[i].id === id) {
	          this.toasts.splice(i, 1);
	        }
	      }
	    },
	    remove: function remove(id) {
	      var _this = this;
	
	      setTimeout(function () {
	        for (var i = 0; i < _this.toasts.length; i++) {
	          if (_this.toasts[i].id === id) {
	            _this.toasts.splice(i, 1);
	          }
	        }
	      }, 6500);
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    _docendo2.default.bind('new_notification', function (data) {
	      _this2.pushToast(data.message, true);
	    });
	  }
	};

/***/ }),
/* 892 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['index', 'toast', 'arrayLength'],
	  computed: {
	    styleObj: function styleObj() {
	      return { top: 60 * -this.index + this.arrayLength * 60 + 'px' };
	    },
	    leftBottom: function leftBottom() {
	      return true;
	    }
	  },
	  methods: {
	    remove: function remove() {
	      this.$emit('remove', this.toast.id);
	    }
	  },
	  mounted: function mounted() {
	    this.remove();
	  }
	};

/***/ }),
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 979 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 980 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 981 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 982 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 983 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 984 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 985 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 986 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 987 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 988 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 989 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 990 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 991 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 992 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 993 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 994 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 995 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 996 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 997 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 999 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1167 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1251 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1255 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1259 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1261 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1262 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1266 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1268 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1270 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1273 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1275 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1276 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1277 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1278 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1292 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1293 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1323 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1325 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1326 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1340 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1344 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1401 */,
/* 1402 */,
/* 1403 */
/***/ (function(module, exports) {

	module.exports = {"da":{"activerecord":{"attributes":{"calendar":{"name":"Navn"},"group":{"country":"Land","demo_expiry":"Demoperiode udløb","description":"Beskrivelse","institution_number":"Institutionsnummer","name":"Navn","open":"Åben?","si_name":"Navn i SkoleIntra","visible":"Synlig?"},"institution":{"number":"Institutionsnummer"},"lesson":{"count_hours":"Tæl timer"},"material":{"class":"Klassetrin","description":"Beskrivelse","documenttypes":"Dokumenttype","klassetrin":"Klassetrin","status":"Status","subjects":"Fag","tag_list":"Tag list","thefile":"Materiale","title":"Titel"},"notification":{"body":"Brødtekst","header":"Overskrift","sitewide":"Site wide","url":"URL"},"post":{"body":"Indhold","published":"Publiceret?","titel":"Titel"},"room":{"name":"Navn","navn":"Navn","si_name":"Navn i SkoleIntra"},"signup":{"already_in_use":"er allerede brugt","country":"Land","email":"Email","password":"Kodeord","password_can_not_be_email":"kan ikke være din email","password_can_not_be_school_name":"kan ikke være skolens navn","password_can_not_be_user_name":"kan ikke være dit navn","password_confirmation":"Bekræft kodeord","school_name":"Skolenavn","terms_of_service":"Betingelser","user_name":"Dit navn"},"subject":{"calendar":"Kalender","color":"Farve","default_duration":"Normal varighed","hours":"Timer","name":"Navn","si_name":"Navn i SkoleIntra","subject_type":"Briktype"},"subject_period":{"hours_per_week":"Timer per uge","total_hours":"Timer i alt"},"user":{"Email":"Email","Fag":"Fag","Initialer":"Initialer","Klassetrin":"Klassetrin","Navn":"Navn","Sprog":"Sprog","assigned_preparation_hours":"Forberedelse","assigned_teaching_hours":"Undervisningstid","assigned_total_hours":"Timer i år","description":"Beskrivelse","email":"Email","groups":"Groups","name":"Navn","organisation":"Skole","password":"Kodeord","password_confirmation":"Bekræftelse af kodeord","primary_school":"Primær skole","remember_me":"Remember me"}},"errors":{"models":{"group":{"attributes":{"institution_number":{"taken":"er allerede oprettet"}}}}},"models":{"calendar":"skema","group":"gruppe","institution":"institution","lesson":"modul","material":"materiale","post":"indlæg","room":"lokale","signup":"Signup","subject":"brik","subject_period":"fagperiode","user":"bruger","user/calendar_transfer":"Calendar transfer"}},"calendars":{"administration":{"archive_merge_table":"Arkivering af et fletteskema gør det usynligt på forsiden","archive_room":"Arkivering af et lokale gør det usynligt på forsiden"},"calendar_hours_count":{"andet_halvår":"2. halvår","første_halvår":"1. halvår","indeværende_uge":"Indeværende uge","skoleår_til_dato":"Skoleår til dato"},"calendar_sidebar":{"skema":" Skema"},"copy_paste":{"indsæt":"Indsæt","indsæt_resten_af_året":"Indsæt + resten af året","kopiér":"Kopiér"},"delete_merge_calendar_button":{"delete_merge_calendar":"Slet fletteskema","dette_kan_ikke_fortrydes":"Dette kan ikke fortrydes.","ja_slet_dette_fletteskema":"Ja","nej":"Nej","slet_dette_fletteskema":"Slet dette fletteskema?"},"delete_week_button":{"der_vil_kun_blive_slettet_de_lektioner_som_er_lagt_ind_i_denne_kalender":"Der vil kun blive slettet de lektioner, som er lagt ind i denne kalender.","dette_kan_ikke_fortrydes":"Dette kan ikke fortrydes","ja_slet_ugens_lektioner":"Ja, slet ugens lektioner.","lektioner":"Slet ugens lektioner...","nej":"Nej","vil_du_slette_alle_ugens_lektioner":"Vil du slette alle ugens lektioner?"},"events_with_notes_or_substitutes":{"hvis_du_kopierer_et_skema_frem_bliver_vikardækninger_fravær_i_personlige_kalendre_og_noter_på_lektionerne_ikke_gemt":"Hvis du kopierer et skema frem bliver vikardækninger i personlige kalendre og noter på lektionerne ikke gemt.","ja_jeg_vil_overskrive_disse":"Ja, jeg vil overskrive disse","lektioner_med_noter_vikardækning_eller_fravær":"Lektioner med noter"},"expand":{"skift_visning_mellem_arbejdsuge_weekender_og_fuld_uge":"Skift visning mellem skoleuge"},"explain_copy_in_background":{"der_kan_gå_5-10_minutter":"Der kan gå 5-10 minutter.","du_får_en_notifikation_på":"Du får en notifikation på","du_kan_fortsætte_med_at_arbejde_i_andre_kalendre":"Du kan fortsætte med at arbejde i andre kalendre.","forsiden":"forsiden","kopierer_kalenderen_frem":"Kopierer kalenderen frem i tid","når_kopieringen_er_afsluttet":"når kopieringen er afsluttet.","ok":"Ok"},"group":{"flet_med_fletteskemaer":"Flet med fletteskemaer...","flet_med_skema":"Flet med fletteskema","se_elevskema":"Se elevskema","vælg_skema":"Vælg skema:"},"group_hours":{"total":"Total","type":"Type"},"merge":{"dette_skema_er_flettet_ind_i":"Dette skema er flettet ind i:","hvis_du_vil_slette_dette_fletteskema_skal_du_først":"Hvis du vil slette dette fletteskema skal du først fjerne indfletningen i ovenstående skemaer.","vælg_kalender":"Vælg kalender:"},"merge_with_selector":{"flet":"Flet ind"},"new":{"nyt_fletteskema":"Nyt fletteskema","opret_fletteskema":"Opret fletteskema"},"public":{"mobile_guide":"Guide til at vise skema på mobil og tablets.","print_in_black_white":"Print uden farve","printing_guide":"Guide til print","se_skemaet_på":"Se skemaet på"},"room":{"vælg_skema":"Vælg skema: "},"subject_hours":{"anden_tid_i_perioden":"Anden tid i perioden","er_du_tilknyttet":"Er du tilknyttet flere brikker i samme tidsrum? Din optælling fordeles ligeligt på de viste brikker.","flextid_for_året":"Flextid for året","fravær_i_perioden":"Fravær i perioden","til":"til","timer":"timer","undervisning_i_perioden":"Undervisning i perioden"},"user":{"apple_kalender":"Apple Kalender","google_kalender":"Google Kalender","google_opdaterer_kalenderen_ca_tre_gange_i_døgnet":"Google opdaterer kalenderen ca. tre gange i døgnet.","ical":"iCal","kopiér_webaddresen_herunder_og_kopier_den_ind_i_den_eksterne_kalender_hvor_du_gerne_vil_have_den":"Kopiér webaddresen herunder og kopier den ind i den eksterne kalender, hvor du gerne vil have den vist.","outlook":"Outlook","se_evt_guides_nedenfor_i_forhold_til_hvordan_du_skal_gøre":"Se evt. guides nedenfor i forhold til hvordan du skal gøre.","siden":"siden.","sidst_hentet":"Sidst hentet","tilføj_dit_skema_til_ekstern_kalender":"Tilføj dit skema til ekstern kalender","vælg_kalender":"Vælg kalender: "},"user_hours":{"undervisningstid":"Undervisningstid"},"week_note":{"week_notes":"Ugenotater"},"week_plan":{"content":"Indhold","internal_notes":"Vikarnoter","learning_goal":"Læringsmål","pupil_preparation":"Elevforberedelse","subject":"Fag"},"week_plan_and_note":{"week":"Uge","week_plan":"Ugeplan"}},"controllers":{"ws":{"events":{"you_are_no_longer_substitute":"%{creator} fjernede dig som vikar i %{subject} i %{klass}, %{time}","you_are_substitute":"%{creator} gjorde dig til vikar i %{subject} i %{klass}, %{time}"}}},"da_only":{"add_user_with_uni":"Tilføj bruger(e) med UNI-Login","click_to_login_with_unilogin":"Klik her for at logge på med Uni-login","fictive_user_text":"Brugeren har en kalender og det vil være muligt at tilføje brugeren som underviser i skolens skemaer. Dette kan bruges til lærere som ikke er ansat endnu eller vikarer uden unilogin. Brugeren kan ikke logge på docendo.","guide_link_parentintra":"Guide til link i klassens forældreIntra","lærere_på_skoleintra":"Lærere på SkoleIntra","opdatér_profil_fra_uni-c":"Opdatér profil fra UNI-C","parent_portal":"ForældreIntra","show_tables_parentintra":"Vis skemaer i ForældreIntra","skriv_brikken_skoleintra":"Skriv hvad brikken hedder i SkoleIntra","uni_login":"UNI-Login","vis_skema_i_skoleintra":"Vis skema i SkoleIntra","website_portal":"Hjemmeside / Skoleporten"},"date":{"formats":{"iso":"%Y-%m-%d"}},"demo":{"firstlogin":{"kom_igang":"Kom igang med Docendo","velkommen":"Velkommen til docendo. Se introvideoen og klik kom igang, når du er klar."}},"devise":{"confirmations":{"new":{"resend_confirmation_instructions":"Send bekræftelsesinstruktioner"}},"failure":{"invited":"Du har en afventende invitation, accepter den for at få adgang."},"invitations":{"edit":{"header":"Vælg dit kodeord","password":"Kodeord","password_confirmation":"Bekræft kodeord","submit_button":"Sæt mit kodeord"},"invitation_removed":"Din invitation er blevet slettet.","invitation_token_invalid":"Invitationsnøglen er ikke gyldig.","new":{"header":"Send en invitation","submit_button":"Send invitation"},"no_invitations_remaining":"Ingen invitationer tilbage","send_instructions":"En invitation er blevet sendt til %{email}.","updated":"Dit kodeord er gemt. Du er nu logget ind.","updated_not_active":"Dit kodeord er gemt."},"mailer":{"confirmation_instructions":{"confirm_my_account":"Bekræft min konto","you_can_confirm_your_account_email_through_the_link_below":"Du kan bekræfte din konto-mail via linket nedenfor:"},"invitation_instructions":{"accept":"Acceptér invitation","accept_until":"Invitationen udløber %{due_date}.","contact_us":"Hvis du har spørgsmål, er du velkommen til at kontakte os på kontakt@docendo.dk","from_school":"Du er netop blevet inviteret til Docendo – Fleksibel Skemalægning på %{school_name}.","hello":"Hej %{email}","regards_html":"<p>Med venlig hilsen,<br/>\nDit Docendo Team<br/>\nhttps://docendo.dk</p>","someone_invited_you":"For at acceptere invitationen skal du klikke på dette link:","subject":"Instruktioner til invitation"},"reset_password_instructions":{"change_my_password":"Ændr mit password","change_password_link_requested":"Du kan ændre dit kodeord via linket herunder.","greeting":"Hej","wont_change":"Hvis du ikke gør noget vil dit kodeord ikke blive ændret."},"unlock_instructions":{"click_the_link_below_to_unlock_your_account":"Klik på linket nedenfor for at låse din konto op.","unlock_my_account":"Lås min konto op","your_account_has_been_locked_due_to_an_excessive_number_of_unsuccessful_sign_in_attempts":"Din konto er blevet låst grundet et stort antal forsøg på login."}},"passwords":{"edit":{"change_my_password":"Skift mit kodeord","change_your_password":"Skift dit kodeord","confirm_new_password":"Bekræft nyt kodeord","new_password":"Nyt kodeord"},"new":{"forgot_your_password":"Glemt dit kodeord?","send_me_reset_password_instructions":"Send mig instruktioner om nulstillelse af kodeord"}},"registrations":{"edit":{"are_you_sure":"Er du sikker?","cancel_my_account":"Afmeld min konto","current_password":"Nuværende kodeord","password":"kodeord","password_confirmation":"gentag kodeord","update":"Update"}},"sessions":{"new":{"brugernavn":"Brugernavn","create_a_free_trial":"Opret en gratis prøveperiode","kodeord":"Kodeord","log_ind":"Log ind","log_ind_med":"Log ind med Uni-login","log_ind_med_mail_og_kodeord":"Log ind med mail og kodeord","log_ind_på_docendo":"Log ind på docendo","no_account":"Har du ikke en konto?"}},"shared":{"links":{"didn":"Modtog ikke bekræftelses-instruktioner?","didn_2":"Modtog ikke unlock-instruktioner?","forgot_your_password":"Glemt dit kodeord?","sign_in":"Log ind","sign_up":"Sign up"}},"unlocks":{"new":{"resend_unlock_instructions":"Send unlock-instruktioner igen"}}},"events":{"event_debug":{"brugere":"Brugere: ","ejerkalender":"Ejerkalender: ","grupper":"Grupper: ","kalendre":"Kalendre: ","lokaler":"Lokaler: "},"replace_room":{"erstat_fremadrettet_på_dette_fag":"Erstat fremadrettet på dette fag","og_resten_af_året":" og resten af året?","på":" på"},"replace_user":{"erstat_fremadrettet_på_dette_fag":"Erstat fremadrettet på dette fag","klik_her_for_at_gå_til_kalenderen_for":"Klik her for at gå til kalenderen for","med":"Med:","og_resten_af_året":" og resten af året?","på":" på"},"show":{"agenda":"Agenda","agenda_placeholder":"F.eks: 1. Opfølgning fra sidst, 2. Oplæg fra...","content":"Indhold","decisions_and_resume":"Beslutninger og resumé","decisions_and_resume_placeholder":"F.eks.: Ulla undersøger med udskolingen om vi kan...","denne_lektion_tæller_som":"Denne lektion tæller som:","er_du_sikker":"Er du sikker?","external_links":"Mine læringsmål og forløb","find_vikar":"Find vikar","gå_til_kalender_for_denne_lektion":"Gå til kalender for denne lektion","internal_notes":"Vikarnoter","jump_to_calendar_for_event":"Hop til kalender for denne brik","learning_goal":"Læringsmål","location":"Lokale","meeting_purpose":"Formål med mødet","meeting_purpose_placeholder":"F.eks.: Vi skal være dygtige til...","only_visible_internally":"kun synligt for undervisere","pupil_preparation":"Elevforberedelse","slet_brik":"Slet brik","slet_fra_denne_kalender":"Slet kun i denne kalender","substitutes":"Vikarer","swappable_lessons":"Følgende lektioner kan byttes med den valgte lektion","søg_og_vælg":"Søg og vælg","søg_og_vælg_vikar":"Søg og vælg vikar","teachers":"Undervisere","undervisere_lokaler_noter":"Undervisere","vacant":"Underviser og lokale er ledige for nedenstående fag","vælg_klasser":"Vælg klasser","vælg_lokation":"Vælg lokale"},"show_public":{"agenda":"Agenda","content":"Indhold","decisions_and_resume":"Beslutninger og resumé","external_links":"Mine læringsmål og kurser","jump_to_calendar_for_event":"Hop til kalender for denne brik","learning_goal":"Hvad skal vi lære?","location":"Lokale","meeting_purpose":"Formål med mødet","pupil_preparation":"Elevforberedelse","substitutes":"Vikarer","teachers":"Undervisere"}},"groups":{"about":{"om":"Om"},"admin":{"assign_hours_employees":"Tildel timer til ansatte","classes_and_subjects":"på klasser og fag","more_tables":"se flere skemaer sammen","show_to_parents":"Vis for forældre","status":"tildeling og status","substitutes":"Vikarpulje","supplement":"Tillæg","year":"2016-2017"},"calendars_setup":{"copy_link":"Kopier link","copy_link_table_insert":"Kopier linket til det klasseskema, du gerne vil abonnere på - og indsæt det","docendo_extern_calendar":"Docendo-skemaer kan vises I eksterne kalendre. Kopier linket ud for skemaet nedenfor og indsæt det i den eksterne kalender. Følg slides til højre for hjælp til opsætningen.","find_in_google_cal":"Guide til integration i egen kalender","google_calendar":"Google Kalender","guide_integration_own_cal":"Guide til integration i egen kalender","guide_setup_schoolport":"Guide til opsætning på skoleporten","guide_setup_table_elevintra":"Guide til opsætning af skema i klassens ElevIntra","guide_step_copy":"Klik på ’kopiér link’ ud for skemaet, du vil sætte op - og følg guiden til højre.","ical_google_outlook":"iCal","integrate_tables":"Integrer skemaer i iCal, Google eller Outlook","links_for_each_class":"Ønsker I at vise skemaer for hver enkelt klasse på klassens ElevIntra, kan I benytte jer af linkene for hver klasse nedenfor.","outlook":"Outlook","parentintra_seperate_class":"Ønsker I at vise skemaer for hver enkelt klasse på klassens ForældreIntra, kan I benytte jer af linkene for hver klasse nedenfor.","show_table_selected":"Vis udvalgte skemaer på Skoleporten","show_tables_elevintra":"Vis skemaer på ElevIntra","substitutes_teachers_show_public":"Dagens fraværende","substitutes_teachers_show_public_explain":"Ønsker I at vise information om dagens fraværende på infoskærm, kan nedenstående link bruges til opsætningen.","text_set_x":"Kryds af nedenfor, hvilke skemaer I vil have vist via linket. Til højre finder I en guide til opsætning af skemaer på SkolePorten.","text_show_tables":"For at vise skemaer til elever og forældre kan I linke til skemaerne direkte fra jeres hjemmeside/Skoleporten med dette link:","vaelg_alle":"Vælg alle"},"create_klass":{"evt_vaelg":"Evt. vælg import af fag og timer svarende til klassetrinnet","import_af_fag":"Import af fag?","import_norm":"Ønsker du at importere og oprette fag med norm-timer fra UVM? Så vælg det klassetrin der passer til klassen her:","klassens_navn":"Klassens navn","opret_en_ny_klasse_for":"Opret en ny klasse","skriv_klassens_navn":"Skriv klassens navn"},"delete_popup":{"brikker_som_slettes_kun_fra_denne_kalender":"Brikker som slettes kun fra denne kalender","den_har":"Den har:","denne_handling_kan_ikke_fortrydes":"Denne handling kan ikke fortrydes!","indlæg_som_slettes":"indlæg som slettes","kalendere_som_slettes":"Kalendere som slettes","lektioner_i_kalenderen":"lektioner i kalenderen","medlemmer_som_ikke_længere_vil_kunne_bruge_gruppen":"medlemmer som ikke længere vil kunne bruge gruppen","skriv_slet_gruppen_herunder":"Skriv \"Slet gruppen\" herunder:","slet_gruppen":"Slet gruppen","uploadet":"uploadet"},"edit":{"redigér_gruppe":"Redigér gruppe"},"flextime":{"flextime":"Flextid","flextime_teacher_appear":"Kun lærere som har brugt flextid optræder i listen."},"flextime_activator":{"aktivering_af_flextid":"Aktivering af flextid","aktiveringen_giver_alle_ansatte_brikker_til_flextid_i_deres_egen_kalender":"Aktiveringen giver alle ansatte brikker til flextid i deres egen kalender.","aktivér_flextid":"Aktivér flextid"},"form":{"fejl_forhindrede_denne_gruppe_i_at_blive_gemt":" fejl forhindrede denne gruppe i at blive gemt:","skriv_hvad_gruppen_hedder":"Skriv hvad gruppen hedder","skriv_om_gruppen":"Skriv om gruppen"},"hours":{"press_empty_bricks":"Tryk i tomme felter for at oprette brikken i klassen."},"merge_calendars":{"merge_tables":"Fletteskemaer","new_merge_table":"Nyt fletteskema"},"mine":{"ikke_medlem_af_nogen_grupper_endnu":"Ikke medlem af nogen grupper endnu."},"multical":{"help_for_table":"Hjælp til skemaoverblik","today":"I dag","vaelg_klasse":"Vælg klasse","vaelg_lokale":"Vælg lokale","vaelg_person":"Vælg person"},"newother":{"fejl_forhindrede_denne_kalender_i_at_blive_gemt":" fejl forhindrede denne kalender i at blive gemt:","opret_anden_kalender":"Opret anden kalender","opret_kalender":"Opret kalender","skriv_evt_kalen":"Skriv evt. noget om kalenderen","skriv_hvad_kalen":"Skriv hvad kalenderen skal hedde..."},"pay_supplement":{"get":"Hent","minutes":"Minutter","show_supplement":"Vis tillæg","supplement_type":"Tillægstype"},"school":{"video":"Video"},"schools":{"vælg_skole":"Vælg skole"},"show":{"bliv_medlem":"Bliv medlem","class_year":"klasse/årgang","filer":"Filer:","forlad_gruppen":"Forlad gruppen","gruppen":"gruppen...","indlæg":"Indlæg:","opret_team":"Opret team"},"substitute_pool":{"details":"Detaljer","hours":"timer","mistakes_look":"fejl, se nedenfor","notice":"Bemærk","notice_list_item_1":"Vikartimer tælles med i det samlede antal undervisningstimer for underviseren","notice_list_item_2":"Vikartimer vil i underviserens egen kalender være angivet som det fag, der vikaries i - f.eks. \"Dansk\"","pool":"Pulje","rest":"Rest","substitute_hours_per_month":"Vikartimer brugt pr. måned","substitute_overview":"Vikaroverblik","there_was":"Der var","total_substitute_pool":"Total vikarpulje:","total_used_substitute_hours":"Total brugte vikartimer:","total_used_substitute_hours ":"Total brugte vikartimer:","used":"Brugt","vis_timer":"Vis timer"},"users":{"ical":"ical:","initials":"Initialer","users":"Brugere"}},"import":{"csv_overview":{"i_fil":"I fil:","ikke-fundne_klasser_oprettes_i_skoleåret_hvor_der_importeres_til":"Ikke-fundne klasser oprettes i skoleåret hvor der importeres til","ikke-fundne_lokaler_oprettes":"Ikke-fundne lokaler oprettes","ikke-fundne_lærere_oprettes_med_initialer":"Ikke-fundne lærere oprettes med initialer","ikke_fundet":"Ikke fundet","import":"Import","kontrollér_at_disse_er_rigtige":"Kontrollér at disse er rigtige","lagt_sammen":"Lagt sammen: ","lokaler":"Lokaler","lærerer":"Lærere","ringetider":"Ringetider","til_uge":"Til uge: "},"result":{"der_var_nogle_fejl":"Der var nogle fejl","import_afsluttet":"Import afsluttet","ingen_fejl_i_import":"Ingen fejl i import"}},"jobs":{"copy_events_year_job":{"calendar_is_copied":"Kalenderen %{calendar_name} er kopieret"}},"js":{"all_day":"Hele dagen","calculating_and_controlling":"Indsætter, beregner og kontrollerer for kollisioner...","changes_may_not_be_saved":"Ændringer, du har foretaget, gemmes muligvis ikke","click_keyboard_shortcuts_to_copy":"Klik ⌘ + C for at kopiere","close_without_saving":"Vil du lukke uden at gemme?","copied":"Kopieret","error_occured":"Der er opstået en fejl."},"layouts":{"application":{"dage":"dage","der_er_ikke":"Der er ikke forbindelse til docendo. Dette kan skyldes at du ikke har forbindelse til internettet.","din_profil":"Din profil","hjem":"Hjem","kurser":"Kurser","køb_nu":"Køb nu","log_ud":"Log ud","profil":"Profil","prøveperiode_slutter_om":"Prøveperiode slutter om","skal_slettes_for_sig_selv":"skal slettes for sig selv.","skift_kodeord":"Skift kodeord","slet_indlæg":"Slet indlæg","soeg":"Søg","vil_du_deaktivere":"Vil du deaktivere skolen?","Ønsker_du_at_slette_dit_indlæg":"Ønsker du at slette dit indlæg?"},"blank":{"der_er_ikke":"Der er ikke"},"devise":{"book_en_gratis_demo":"Book en gratis demo","docendodk":"docendo.dk","kontakt":"kontakt","log_ind_med":"Log ind med","log_ind_med_email":"Log ind med email","login":"Login","med_en_fuldt_integreret":"Med en fuldt integreret","om_docendo":"Om Docendo","om_os":"om os","tlf_70_40_02_10":"Tlf. 70 40 02 10","udviklet_i_samarbejde_med_ledere_lærere_og_pædagoger":"Udviklet i samarbejde med ledere","uni":"UNI"},"public":{"skal_slettes_for_sig_selv":"skal slettes for sig selv.","slet_indlæg":"Slet indlæg","Ønsker_du_at_slette_dit_indlæg":"Ønsker du at slette dit indlæg?"},"schools":{"users":{"create_user_by_alias":"Opret fiktiv bruger","create_user_by_email":"Opret bruger med email","create_user_by_unilogin":"Opret bruger med unilogin","merge_users":"Læg brugerprofiler sammen","transfer_calendar":"Overtag skema i periode"}}},"materials":{"details":{"antal_downloads":"Antal downloads:","beskrivelse":"Beskrivelse:","detaljer_om_filen":"Detaljer om filen","dialog_om_filen":"Dialog om filen","dokumenttype":"Dokumenttype:","klassetrin":"Klassetrin:","status":"Status:","uploadet_af":"Uploadet af: "},"edit":{"redigér_fil":"Redigér fil","vis":"Vis"},"form":{"dit_materiale_er_gemt":"Dit materiale er gemt","fejl_forhindrede_dette_materiale_i_at_blive_gemt":" fejl forhindrede dette materiale i at blive gemt:","filnavn":"Filnavn: ","gem_materiale":"Gem materiale","skriv_noget_relevant":"Skriv noget relevant","titel_på_fil":"Titel på fil","venligst_udfyld_nogle_informationer_om_materialet":"Venligst udfyld nogle informationer om materialet","vælg_dine_fag":"Vælg dine fag","vælg_dokumenttype":"Vælg dokumenttype(r)...","vælg_dokumenttyper":"Vælg dokumenttyper","vælg_klassetrin":"Vælg klassetrin","vælg_status":"Vælg status"},"index":{"antal_hentede":"Antal hentede","klassetrin":"Klassetrin"},"material":{"fra":"fra","mere_info":"Mere info","uploadet_af":"uploadet af"},"new":{"gem_materiale":"Gem materiale"},"new1":{"attach_files":"Vedhæft materiale"},"popedit":{"dit_materiale_er_gemt":"Dit materiale er gemt","erstat_materiale":"Erstat materiale:","fejl_forhindrede_dette_materiale_i_at_blive_gemt":"fejl forhindrede dette materiale i at blive gemt:","gem_materiale":"Gem materiale","giv_nogle_informationer_om_materialet":"Giv nogle informationer om materialet","vælg_dine_fag":"Vælg dine fag","vælg_dokument":"Vælg dokumenttyper","vælg_klassetrin":"Vælg klasse","vælg_status":"Vælg status"},"show":{"beskrivelse":"Beskrivelse:","group":"Gruppe:","post":"Post:","tags":"Tags: ","user":"Bruger:"},"sidebar":{"nyeste":"Nyeste","populære":"Populære","se_alle":"Se alle"},"upload":{"del_et_materiale":"Del et materiale","upload":"upload.","vælg_et_dokument":"Vælg et dokument"}},"models":{"calendar":{"beregn_timer":"Beregn timer","flex_ind":"Flex ind","flex_ud":"Flex ud"},"group":{"alle":"Alle","already_created":"er allerede oprettet","share_with":"Del med","skolen":"Skolen","team":"Team","ukendt":"ukendt"},"group_school":{"importerede":"Importerede","med":"med","oprettede_klasse":"Oprettede klasse","oprettede_lærer":"Oprettede lærer","uden_lærer_i":"uden lærer i"},"import_lesson":{"invalid":"Ugyldig"},"material":{"skal_vælges":"skal vælges"},"pay_supplement_rule_school_camp":{"lejrskole":"Lejrskole"},"pay_supplement_rule_substitute":{"ekstern_vikar":"Ekstern vikar"},"post":{"synes_godt_om":"Synes godt om"},"subject_period":{"timer_uge":"Timer/uge"},"user":{"ukendt":"ukendt"}},"notifications":{"form":{"indhold":"Indhold:","link_https__skal_tilføjes_hvis_linket_er_eksternt":"Link: ('https://' skal tilføjes, hvis linket er eksternt)","notifikationer":"Notifikationer","overskrift":"Overskrift:"},"index":{"notifikationer":"Notifikationer","opret_ny":"Opret ny","siden":"siden"},"notification":{"siden":"siden"},"show":{"brugere":"brugere","link":"Link: ","læst_af":"Læst af","notifikationer":"Notifikationer","sendt_til":"Synlig for","sidst_opdateret":"Sidst opdateret: ","skrevet_af":"Skrevet af"}},"posts":{"edit":{"redigér_indlæg":"Redigér indlæg","vis":"Vis"},"form":{"del_noget":"Del noget...","fejl_forhindrede":"fejl forhindrede dette indlæg i at blive gemt","tilføj_kommentar":"Tilføj kommentar..."},"new":{"nyt_indlæg":"Nyt indlæg"},"post":{"antal_downloads":"Antal downloads","comments":"Kommentarer","from":"fra","show":"Vis","since_in_group":"siden i gruppen","slet_indlæg":"Slet indlæg"},"show":{"bruger":"Bruger:","indhold":"Indhold:"}},"rack_dev_mark":{"development":"development"},"repitition":{"add":"Tilføj","administration":"Administration","aktivitet":"Aktivitet","all_calendars":"alle kalendere","annuller":"Annuller","archive":"Arkivér","brikker":"Brikker","brugeradministration":"Brugeradministration","calendaradministration":"Kalenderadministration","choose":"Vælg","chooselanguage":"Vælg sprog","create":"Opret","dagens_fraværende":"Dagens fraværende","dagens_vikarer":"Dagens vikarer","dearchive":"Dearkivér","delete":"Slet","deleting":"Sletter","din_kalender":"Din kalender","docendo":"Docendo - fleksibel skemalægning","email":"Email","enddate":"Slut dato","endtime":"Sluttidspunkt","errors":"fejl","fag":"Fag","feriekalender":"Feriekalender","fjern":"Fjern","fjern_brugere":"Fjern brugere","flextidsoversigt":"Flextidsoversigt","fra_og_med":"fra og med","from":"fra","gem":"Gem","hour":"time","timeopgoerelse":"Timeopgørelse","kalender":"Kalender","klass":"klasse","klasser":"Klasser","klasser_lille":"klasser","kr":"kr","langfravær":"Længerevarende fravær","lesson":"lektionen","luk":"Luk","materialer":"Materialer","medlem":"medlem","medlemmer":"medlemmer","merge_calendar":"fletteskema","merge_calendars":"fletteskemaer","målstyring":"Målstyring","navn":"Navn","none":"Ingen","opgaveoversigt":"Opgaveoversigt","opret":"Opret","opret_brik":"Opret brik","opret_fraværsgrund":" Opret fravær","opret_tilføj_bruger":"Opret/tilføj bruger","oprettet":"Oprettet:","other_calendar":"anden kalender","other_calendars":"andre kalendere","planlægning":"Planlægning","processing":"Behandler","rediger":"Redigér","replace":"Erstat","replace_lesson":"Erstat lektion","room":"lokale","rooms":"lokaler","se_kalender":"Se kalender","search":"søg","search_for":"søg på","select_user":"Vælg bruger","send":"Send","show":"Vis","skema":"Skema","skemaoverblik":"Skemaoverblik","skole":"Skole","skoler":"Skoler","skoleår":"Skoleår","skriv":"Skriv...","startdate":"Start dato","starttime":"Starttidspunkt","substitute":"Vikardækning","superadmin":"Superadmin","support":"Support","swap":"byt","swap_lesson":"Byt lektion","tilbage":"Tilbage","tildel_timer":"Tildel timer","timefordeling":"Timefordeling","timer":"Timer","timeudtraek":"Timeudtræk","titel":"Titel","today":"I dag","unauthorized_access":{"help":"Din bruger er ikke tilknyttet en aktiv skole på Docendo. Mener du, dette er en fejl, bedes du kontakte din skoles administration for at blive tilknyttet skolen.","no_access":"Du har ingen adgang."},"until":"til","user":"bruger","users":"brugere","vikardækning":"Vikardækning","vikarpuljer":"Vikarpuljer","vis_skemaer_til_elever":"Ekstern visning","with":"med","yearplan":"Årsplanlægning","Årsoverblik":"Årsoverblik","år":"År","årsplanlægning":"Årsplanlægning"},"rooms":{"create_room":"Opret lokale","edit":{"er_du_sikker":"Er du sikker?","redigér_lokale":"Redigér lokale","slet_lokale":"Slet lokale"},"form":{"fejl_forhindrede_dette_lokale_i_at_blive_gemt":"fejl forhindrede dette lokale i at blive gemt:"},"new":{"nyt_lokale":"Nyt lokale"},"room_is_not_created":"Lokalet findes ikke","rooms":{"new_room":"Nyt lokale","rooms":"Lokaler"}},"schools":{"calendar_transfers":{"new":{"activity_count":"Aktiviteter","from_date":"Fra dato","have_calendar":"Har skema","including_both":"begge inklusive","period":"Periode","receive_calendar":"Skal overtage skema","replacee_in_period":"Fraværende i perioden","replacement_in_period":"Overtager i perioden","title":"Lad en bruger overtage en anden brugers skema i en periode, f.eks. ved barsel eller længerevarende fravær.","to_date":"Til dato","transfer":"Overfør","transfer_calendar_for_a_period":"Overtag skema i periode","warning":"Overtagelse af skema kan ikke fortrydes."}},"onboarding":{"administration_and_counting":"Administration og tælling","assign_user_hours":"Tildel timer til undervisere","create_calendars":"Opret kalendere","create_classes":"Opret klasser","create_fixed_hours":"Opret faste bånd","create_merge_calendars":"Opret fletteskemaer","create_other_calendars":"Opret andre kalendere","create_rooms":"Opret lokaler","create_school_year":"Opret skoleår","create_teachers":"Opret undervisere","create_your_school":"Opsætning af din skole i Docendo","follow_the_steps":"Følg trinene herunder for at komme godt i gang med jeres skemalægning","import_of_schedules":"Import af skemaer?","import_of_schedules_content":"Hvis I ønsker det, kan vi også importere jeres nuværende skemaer fra SkoleIntra eller Tabulex. Send en email til vores kundesupport, hvor I skriver jeres ringetider og vedhæfter jeres skemafiler.","make_room_bindings":"Evt. lav lokalebindinger","scheduling_classes_calendars":"Skemalægning i elevskemaer","select_vacationdays":"Indtast feriedage","show_calendars_to_students":"Vis skemaer til elever og forældre","student_scheduling":"Læg klassernes skemaer","user_tasks":"Opgaveoversigt til undervisere"},"user_merges":{"new":{"merge_on_this_user":"Sammenlæg på denne bruger","title":"Læg to brugere sammen – f.eks. i tilfælde af to ens brugere, eller hvis en bruger uden login skal erstattes med en bruger med login. Alle skemaaktiviteter samles på én bruger.","warning":"Sammenlægningen kan ikke fortrydes."}},"users":{"index":{"actions":"Handlinger","help":"Tryk på billedet for at indsætte et nyt. Initialer kan redigeres.","photo":"Foto"},"user":{"invite":"Invitér","remove":"Fjern"}}},"search":{"post":{"siden_i_gruppen":"siden i gruppen"},"search_content_type_filter":{"alle":"Alle","grupper":"Grupper","opdateringer":"Opdateringer","profiler":"Profiler","vis_resultater_for":"Vis resultater for"},"search_filter":{"filtre":"Filtre","type_af_materiale":"Type af materiale","vælg_dine_fag":"Vælg dine fag","vælg_dokumenttyper":"Vælg dokumenttyper","vælg_fag":"Vælg fag","vælg_klassetrin":"Vælg klassetrin","vælg_status":"Vælg status"},"search_results":{"antal_hentede":"Antal hentede","grupper":"Grupper","klassetrin":"Klassetrin","none":"Desværre - vi kunne ikke finde noget","opdateringer":"Opdateringer","profiler":"Profiler","viser_Res_for":"Viser resultater for"}},"sidebars":{"get_started_new_year":{"assign_hours_employees":"Tildel timer til ansatte","follow_steps":"Følg trinene herunder","get_started":"Kom i gang","other_calendars":"andre kalendere","time_distribution":"Timefordeling på klasser"},"school":{"other_calendars":"Andre kalendere (fx. teamkalender)"},"substitution_links":{"assign_substitutes":"tildel dagens vikarer","substitute_cover":"Vikardæk"}},"signups":{"by_existing_users":{"new":{"already_user":"Bruger din skole allerede Docendo, men du kan ikke få adgang? Kontakt din skoles kontor for at få adgang.","try_free":"Prøv Docendo - gratis i 14 dage"}},"new":{"create_signup":"Opret","i_accept":"Jeg accepterer","password_rule":"(mindst 8 tegn)","signup":"Opret 14 dages prøveperiode","terms_of_service":"betingelserne"}},"subject_periods":{"edit":{"antal_uger":"Antal uger","fordel_timer_i_perioden":"Fordel timer i perioden","opdatér":"Opdatér","skoledage_i_perioden":"Skoledage i perioden","slet":"Slet","timer_i_perioden":"Timer i perioden"}},"subjects":{"edit":{"arkiver":"Arkivér","arkiver_denne_brik_den_vil_ikke_længere_være_synlig":"Arkivér denne brik? Den vil ikke længere være synlig.","arkiverer":"Arkiverer...","er_du_sikker":"Er du sikker?","redigér_brik":"Redigér brik","slet_brik":"Slet brik","vil_du_arkivere_denne_brik":"Vil du arkivere denne brik? Den vil ikke længere være synlig.  Brikker der er lagt i skemaer forbliver."},"inner_edit":{"absence":"Fravær","absence_description":"sygdom, ferie etc.","anden_tid":"Anden tid","anden_tid_description":"ikke undervisning.","antal_minutter_modul":"Skriv hvor mange minutter et modul normalt varer","antal_timer_på_år":"Skriv hvor mange timer, der skal bruges i løbet af i år...","bevægelse":"Bevægelse","bevægelse_description":"tæller 100 % og uafhængigt af andre brikker i samme tidsrum.","fag":"Fag","fag_description":"tæller timer for klassen. To samtidige brikker tæller halvt.","fejl_forhindrede_denne_brik_i_at_blive_gemt":"fejl forhindrede denne brik i at blive gemt","frame":"Temavisning","frame_description":"kan bruges til at markere temaer og anderledes dage i skemaet. Brikken er synlig for elever/forældre, mens fag-brikker, der ligger samtidig med tema-brikken, ikke er synlige. Fagbrikker tæller 100% i tidsrummet, og temabrikken tæller ikke.","klasser_andre_kalendre":"Klasser/Andre kalendre","lokation":"Lokation","normal_varighed_i_minutter":"Normal varighed (i minutter)","oovrig_tid":"Øvrig tid","oovrig_tid_description":"ikke undervisning, ikke elev-relateret.","optional":"Valgfag/hold","optional_description":"tæller 100 % og uafhængigt af andre brikker i samme tidsrum.","pause":"Pause","pause_description":"andre lektioner bør ikke overlappe med en pause.","ressource":"Ressource","ressource_description":"bruges til at markere ressourcer i skemaet. Tæller ikke fra andre brikker. Vises som standard ikke i elev- og forældreskema.","skriv_et_bogstav_for_at_søge":"Skriv et bogstav for at søge...","skriv_hvad_brikken_hedder":"Skriv hvad brikken hedder...","sygdom_ferie_etc":"sygdom, ferie etc.","timer_på_årsbasis":"Timer (i skoleåret)","underviser":"Underviser","uuv":"UUV","uuv_description":" tæller selvstændigt på understøttende undervisning.","vælg_briktype":"Vælg briktype","vælg_farve":"Vælg farve","vælg_klasser":"Søg og vælg klasser"},"new":{"ny_brik":"Ny brik"},"subject_accordion_menu":{"absence":"Fravær","break":"Pause","exercise":"Bevægelse","flextime":"Flextid","frame":"Temavisning","optional":"Valgfag/hold","other_stuff":"Øvrig tid","other_tasks":"Andre opgaver","pay_supplement":"Tillæg","person_resource":"Undervisningsressourcer","resource":"Ressource","subject":"Fag","supplemental":"Understøttende undervisning"},"subject_draggable":{"hours_per_year":"t/år","per_week":"/uge"},"ws_edit":{"er_du_sikker":"Er du sikker?","opdater_brik":"Opdater brik","redigér_brik":"Redigér brik","slet_brik":"Slet brik"}},"substitutes":{"edit":{"i_dag":"i dag","ingen_lektioner_for":"Ingen lektioner for ","klasse":"Klasse","også_tilknyttet":"Også tilknyttet","se_alle":"Se alle","se_mindre":"Se mindre","søg_og_vælg":"Søg og vælg","vikar":"Vikar","vikar_for":"Vikar for","vikarnoter":"Vikarnoter"},"known_absence":{"byt":"Byt","feriedage":"Feriedage","fraværende_med_lektioner":"Fraværende med lektioner","kalenderen_for_7b":"Kalenderen for 7.b","kursus":"Kursus","lektioner":"lektioner","lektioner_der_kan_byttes_med":"Lektioner der kan byttes med:","lektioner_der_skal_håndteres":"Lektioner der skal håndteres:","opret_fravær":"Opret fravær","opret_planlagt_fravær":"Opret planlagt fravær","syg":"Syg"},"substitute_day":{"klasse":"Klasse"},"substitutes_edit":{"fraværsårsager_og_skemaoverblik":"Fraværsårsager og skemaoverblik","tilføj_kalendre":"Tilføj kalendre","vælg_klasse":"Vælg klasse","vælg_lokale":"Vælg lokale","vælg_person":"Vælg person","vælg_person_vikardækning":"Vælg person(er)"},"substitutes_show":{"ingen_vikarer_i_dag":"Ingen vikarer i dag"},"substitutes_show_teachers":{"ingen_fraværende_i_dag":"Ingen fraværende i dag"}},"time":{"formats":{"day_only":"%A","devise":{"mailer":{"invitation_instructions":{"accept_until_format":"d. %B %d, %Y %I:%M"}}},"time_only":"%H:%M"}},"unilogin":{"welcome":{"create_a_trial":"Vil du oprette en prøveperiode?","eller":"eller","enten_giver_din_stilling_dig_ikke_mulighed_for_at_kigge_med_eller_også_er_din_skole_er_ikke_på_docendo_endnu":"Enten giver din stilling dig ikke mulighed for at kigge med eller også er din skole er ikke på docendo endnu.","hvis_du_vil_have_din_skole_på_docendo_så":"Hvis du vil have din skole på Docendo så","kontakt_os":"kontakt os","prøv_en_demoperiode":"opret en gratis prøveperiode","student_or_parent":"Er du elev eller forælder?","student_or_parent_info":"Leder du efter dit eller dit barns klasseskema, skal dette typisk findes på skolens Elev-/ForældreIntra eller på skolens hjemmeside. Vi anbefaler, at du kontakter skolens administration, hvis du ikke har adgang til skemaerne.","velkommen":"Velkommen"}},"users":{"assign_user_hours":{"anden_tid":"Anden tid","der_var":"Der var","fejl_se_nedenfor":"fejl. Se nedenfor","lommeregner":"Lommeregner","skemalagt":"Skemalagt","tildeling_af_timer":"Tildeling af timer","tildelt":"Tildelt","total_på_år":"Total på år","undervisning":"Undervisning","Øvrig_tid":"Øvrig tid"},"create":{"add_user":"Opret/tilføj bruger","add_user_with_uni":"Tilføj bruger(e) med UNI-Login","create_teacher":"Opret underviser","fictive_user":"Fiktiv bruger","fictive_user_text":"Brugeren har en kalender og det vil være muligt at tilføje brugeren som underviser i skolens skemaer. Dette kan bruges til lærere som ikke er ansat endnu eller vikarer uden unilogin. Brugeren kan ikke logge på docendo.","notify_user_more_users":"Du skal selv give brugerne besked om tilføjelsen. Du kan skrive flere brugernavne i feltet herunder, adskil med mellemrum.","user_does_not_exist":"Underviseren eksisterer ikke","user_with_email":"Bruger med email","user_with_email_text":"Bruges til at oprette brugere med email. Brugeren kan logge ind med mail og kodeord. Der bliver sendt en mail til brugeren med instruktioner."},"edit":{"annullér":"Annullér","redigér_bruger":"Redigér bruger"},"files_for_download":{"files_to_download":"Filer til download"},"form":{"andre_undervisere_vide":"Hvad kan andre undervisere have brug for at vide om dig?","beskrivelse":"Beskrivelse","du_kan_skrive_om_dine_interesser_fag_klassetrin_færdigheder_etc":"Du kan skrive om dine interesser","email":"E-mail","fejl_forhindrede_denne_bruger_i_at_blive_gemt":"fejl forhindrede denne bruger i at blive gemt:","fjern_profilbillede":"Fjern profilbillede","hvilke_fag":"Hvilke fag","hvilke_klassetrin_underviser":"(Hvilke klassetrin underviser du?)","initialer":"Initialer","initialer_på_skolen":"Initialer på skolen","klassetrin":"Klassetrin","opdatér_profil_fra_uni-c":"Opdatér profil fra UNI-C","profilbillede":"Profilbillede","skriv_dit_navn":"Skriv dit navn","upload_nyt_profilbillede":"Upload nyt profilbillede?","vælg_dine_fag":"Vælg dine fag","vælg_dine_klassetrin":"Vælg dine klassetrin"},"hours":{"skoleåret":"Skoleåret"},"hours_list":{"_vikartimer":"vikartimer","min":"min","vikartimer":"Vikartimer"},"hours_status":{"anden_tid":"Anden tid","ingen_data":"Ingen data","tildelt":"Tildelt","undervisning":"Undervisning","øvrig_tid":"Øvrig tid"},"list_all":{"alle":"Alle"},"members":{"personale":"Personale","se_alle":"Se alle"},"net_promoter_scores":{"new":{"nps_question":"Hvor sandsynligt er det, at du vil anbefale docendo til en ven eller kollega?","question_one":"Hvad er den vigtigste årsag til den karakter, du gav?","reason":"Vi bygger et skemalægningsprogram til mennesker. Og det er svært at gøre godt - medmindre at dig der bruger det, fortæller os, hvordan du synes, at vi skal gøre det. Vi håber derfor, at du vil hjælpe os ved at besvare de følgende to spørgsmål.","very_likely":"Meget sandsynligt","very_unlikely":"Ikke sandsynligt"}},"password":{"bekræft_nyt_kodeord":"Bekræft nyt kodeord","fejl":" fejl:","nyt_kodeord":"Nyt kodeord","skift_kodeord":"Skift kodeord"},"profile":{"klassetrin":"Klassetrin","om_mig":"Om mig","underviser_i":"Underviser i"},"remove_users_list":{"delete_user":"Fjern bruger","press_remove_to_remove":"Klik 'fjern' for at fjerne en bruger fra skolen.","remove_list_item_1":"Når en bruger bliver fjernet har vedkommende ikke længere adgang til skolens grupper eller kalendere. ","remove_list_item_2":"Brugeren bliver ikke fjernet fra lektionerne på skolen.","remove_list_item_3":"Brugeren bliver ikke slettet fra docendo men har blot ikke adgang til skolen længere."},"show":{"aktivitet":"Aktivitet","filer":"Filer:","grupper":"Grupper","indlæg":"Indlæg:","medlem_i":"Medlem i:"},"si_teachers_list":{"træk_læreren_fra_venstre_til_højre_for_at_tildele_initialer":"Træk læreren fra venstre til højre for at tildele initialer"},"substitute":{"følgene_lærere_er_ledige_i_tidsrummet":"Følgende lærere er ledige i tidsrummet","ingen_lærere_er_ledige_i_tidsrummet":"Ingen lærere er ledige i tidsrummet","kl":"kl.","vælg_vikar":"Vælg vikar"},"tasks_status":{"fag_opgave":"Fag/opgave","lagt_i_skema":"Lagt i skema","tildelt":"Tildelt","tilhører":"Tilhører","total":"Total"},"user_item_abandoned_user":{"grupper":"Grupper: ","indlæg":"Indlæg: ","kalenderaftaler":"Kalenderaftaler: ","material_count":"Material count: "},"user_item_profile_calendar_lastseen":{"se_profil":"Se profil","se_tildeling":"Se tildeling"},"user_item_remove_user":{"delete_user":"Slet bruger"},"user_item_select_substitute":{"vælg_som_vikar":"Vælg som vikar"},"user_merge_details":{"aftaler":"Skemalagte aktiviteter","groups":"Skoler"}},"views":{"pagination":{"first":"Første","last":"Sidste","next":"Næste","previous":"Tidligere","truncate":"..."}},"vue":{"buy":{"a_user_is":"En bruger er en medarbejder som har en kalender og/eller et login, dvs. en underviser, en pædagog, en vikar o.lign.","billed_monthly_or_yearly":"Vil du faktureres månedligt eller årligt?","buy":"Køb","buy_access_for_school_users":"Køb adgang til skolens brugere","call_us_at":"Ring til","choose_the_right_price":"Vælg den rette pris for jer","discount":"Rabat","error":"Fejl","go_to_home":"Klik her for at gå til forsiden","institution":"institution","missing_inputs":"Du mangler at udfylde nogle felter","month":"måned","only_pay_per":"Betal kun for de brugere, der skal kunne skemalægges og/eller have et login","pay_for_unlimited_users_and_get":"Betal for skolens samlede elevtal - og få et ubegrænset antal brugere på","payment_info":"Betalingsinfo","per_month":"Pr. måned","per_student":"pr. elev","per_user":"pr. bruger","per_year":"Pr. år","popular":"populær","price":"pris","questions":"Spørgsmål","save_2":"Spar 2%","school_name":"Skolens navn","subscription_info":"Abonnementsinfo","thanks_for_buying":"Tak for dit køb.","total":"Total","total_student_number":"Skolens samlede elevtal","unlimited":"Ubegrænset","write_number_of_students":"Skriv skolens samlede elevtal - og få ubegrænset antal brugere på *","write_number_of_users":"Skriv det antal brugere, som skal kunne skemalægges og/eller have et login *","your_email":"Din email","your_invoice":"Din faktura","your_name":"Dit navn","your_phonenumber":"Dit telefonnummer"},"deleteday":{"delete_day_or_week":"Slet dag/ugen","whole_week":"Hele ugen"},"intro_home":{"step1_title":"Velkommen til Docendo","step3_title":"Navigation til alle funktioner","step4_content":"Her kan du finde navigationen til alle skemaer, lokaler og personalekalendere i Docendo","step4_title":"Navigation til alle skemaer og kalendere","step5_content":"Vi har på forhånd udfyldt et klasseskema (4A - DEMO), som du kan redigere i, så du hurtigt kan få en fornemmelse af mulighederne i Docendo. Slå dig løs!","step5_title":"Se et demo-klasseskema"},"public":{"app":{"sidenav":{"changeview":"Skift visning","showday":"Vis dag","showweek":"Vis uge","showweekplan":"Vis ugeplan"}},"no_notes":"Ingen noter til ugen"},"recent_users":{"last_seen":"sidst set","never_logged_in":"aldrig været logget ind"},"sidenav":{"merge_calendar_special":"flette-skemaer"},"vacations_days_selector":{"choose_period":"Vælg periode","school_days":"skoledage","school_year":"Skoleår","vacation_for_pupils":"Feriekalender for elever"},"year_planning":{"distribute_hours_over_year":"Fordel timer i perioden","hours_during_period":"Timer i perioden","norm":"Norm","number_of_weeks":"Antal uger","planned":"Planlagt","school_days_during_period":"Skoledage i perioden"}}}}

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

	module.exports = {"a11y":{"mainNav":"Hovednavigation","openMenu":"Åbn menu","closeMenu":"Luk menu","changeSchool":"Skift skole","clearSearch":"Ryd søgning","showStudents":"Vis/skjul elever","close":"Luk","loading":"Indlæser"},"copycalendar":{"copy":"Kopier","paste":"Indsæt","pasteThisWeek":"Indsæt i denne uge","weekSelected":"uge valgt","weeksSelected":"uger valgt","markWeeksFrom":"Markér uger fra","allWeeks":"Alle uger","oddWeeks":"Ulige uger","evenWeeks":"Lige uger","unselectAll":"Fravælg alle","deleteLessonsInSelectedWeeks":"Slet og erstat lektioner i de valgte uger","absenceWillNotBeDeleted":"fravær slettes ikke","noticationMessage":"Kopieringen er i gang. Det kan tage nogle minutter. Du kan i mellemtiden arbejde i andre skemaer.","copiedFrom":"Kopieret fra","noSubstitutesOrNotes":"Der er ingen lektioner med vikarer eller noter i de valgte uger","youAreAboutToDelete":"Du er ved at slette,","lesson":"lektion","lessons":"lektioner","withSubstitutesOrNotes":"med vikarer eller noter","week":"Uge"},"homevideoes":{"video":"Video","video_guide":"Videoguides","introduction":"Introduktion til Docendo","watch_intro":"Se introduktion til docendo","klass_schedule":"Klasseskema","klass_schedule_overview":"Overblik over klasseskemaet","teacher_calendar":"Underviserkalender","teacher_calendar_overview":"Rundtur i underviserens kalender","notes_weekplan":"Noter & ugeplan","notes_weekplan_overview":"Udnyt noter & ugeplaner","learn_to_substitute":"Lær at vikardække med Docendo"},"vSelect":{"choose_persons":"Vælg person(er)"},"substitute_hours":{"title":"Timeudtræk for undervisere og vikarer","choose_period":"Vælg periode","all":"Alle","teaching":"Undervisning","substitute_hours":"Vikartimer","absence":"Fravær","choose_persons":"Vælg person(er)","work_days":"arbejdsdage","calendar_event":"kalenderaktivitet","calendar_events":"kalenderaktiviteter","substitute_for":"Vikar for","substitute_hour":"Vikartime","other_tasks":"Andre opgaver","other_stuff":"Øvrig tid","total":"Total","hours":"timer","hour":"time","min":"min","shortcuts":"Genveje","show_all_absent":"Vis alle fraværende i perioden","getting_all":"Henter alle","absent_in_the_period":"fraværende i perioden","there_is_no_one_absent":"Der er ingen fraværende i perioden","days_with_absence":"Dage med fravær"},"notifications":{"notifications":"notifikationer","all":"Alle","unread":"Ulæste","mark_all_as_read":"Markér alle som læste","sent_from":"Sendt fra","mark_as":"Marker som","read":"Læst","not_read":"Ulæst","no_new_notifications":"Ingen nye notifikationer"},"presence":{"work_hours":"Arbejdstider","set_work_hours":"Indtast arbejdstider","choose_weeks_for_work_hours":"Vælg uger for arbejdstiden","work_hours_in_the_week":"Timer i ugen","cancel":"Annullér","copy_to_multiple_weeks":"Indsæt i flere uger","back":"Tilbage","save":"Gem","times_may_not_overlap":"Tider må ikke overlappe hinanden","hours":"timer","minutes":"min","h":"t","m":"m","present":"Til stede","not_present":"Ikke til stede","total_working_hours":"Skemalagt arbejdetid for året","edit_default_times":"Rediger standardtider","default_work_hours":"Standard arbejdstider"},"createusers":{"create_users":"Opret bruger(e)","login_options":"Login mulighed(er)","can_be_added_later":"kan evt. tilføjes senere","must_be_added":"Skal udfyldes","name":"Navn","mail":"email","placeholder_name":"Navn Efternavn","placeholder_email":"navn@skolemail.dk","email_error_text":"Det ligner ikke en rigtig email!","add_more":"Tilføj flere","create":"Opret","user":"bruger","users":"brugere","user_created":"Bruger oprettet!","users_created":"Brugere oprettet!","feide_is_already_used_for":"Feide er allerede tilføjet"},"createuser_button":{"create_user":"Opret bruger"},"toast":{"something_went_wrong":"Noget gik galt"},"subject":{"azure":"Azurblå","blue":"Blå","bronze":"Bronze","brown":"Brun","coral":"Koral","grey":"Grå","green":"Grøn","purple":"Lilla","lightblue":"Lyseblå","lightblue2":"Lyseblå2","lightbrown":"Lysebrun","lightgreen":"Lysegrøn","lightyellow":"Lysegul","lightyellow2":"Lysegul2","lightpurple":"Lyselilla","lightred":"Lyserød","marinoblue":"Marineblå","darkblue":"Mørkeblå","darkgreen":"Mørkegrøn","darkyellow":"Mørkegul","darkpurple":"Mørkelilla","darkorange":"Mørkeorange","darkorange2":"Mørkeorange2","orange":"Orange","red":"Rød","red2":"Rød2","skal_vaelges":"skal vælges","turkis":"Turkis"},"createklass":{"create_klasses":"Opret klasse(r)","schoolyear":"Skoleår","klass_name":"Klassens navn","klass_step":"Klassetrin til import af fag (valgfrit)","import_subjects_question":"Ønsker du at importére basisfagene for klassen?","import_subjects_done":"Disse fag vil blive oprettet i klassen","subjects_for":"Fag for","klass":"klasse","klasses":"klasser","hoursPrYear":"t/år","grade":"klasse","warning_text":"Klasser kan ikke have samme navn","succes_text":"Klasse(r) blev oprettet!","creating":"Opretter,","import_subject_to_the_klass":"Importer fag til klasser","subjects_created_successfully":"Fagene er oprettet"},"createrooms":{"create_rooms":"Opret lokale(r)","room_name":"Lokalets navn","placeholder":"Idrætshallen","room":"lokale","rooms":"lokaler","warning_text":"Lokaler kan ikke have samme navn","succes_text":"Lokale(r) blev oprettet!","creating":"Opretter"},"createroom_button":{"create_room":"Opret lokale"},"editCalendarEditName":{"edit_name":"Redigér navnet","calendar_name":"Kalenderens navn","warning_text":"Navnet må ikke være tomt","update_name":"Opdatér navnet","success_text":"Navnet er opdateret!"},"editCalendarMenu":{"edit_name":"Rediger navn","delete_calendar":"Slet kalender","remove_calendar":"Arkiver kalender","delete_klass":"Slet klasse","delete_club":"Slet SFO","delete_kindergarten":"Slet stue","remove_room":"Arkiver lokale","remove_merge":"Arkiver fletteskema","view":"Visning","5_days":"5 dage","7_days":"7 dage","7_days_and_24_hours":"7 dage, 24 timer","lock":"Lås kalenderen","unlock":"Lås op","calendar_is_locked":"Kalenderen er låst","merge_with_merge_calendars":"Flet med fletteskemaer","merge_with_calendar":"Flet ind i kalender","is_merged":"Er flettet ind i","can_be_merged_into":"Kan flettes ind i","see_public_view":"Se elevvisning","active_public_view":"Aktiver elevvisning","show_grid":"Vis ringetider","hide_grid":"Skjul ringetider"},"editCalendarDelete":{"delete_calendar":"Slet kalender","deleting_this_calendar":"Du er ved at slette kalenderen","all_data_will_be_deleted":"Alle kalenderaktiviteter vil blive slettet PERMANENT, og data kan IKKE GENSKABES.","validator_name":"slet kalenderen","write":"Skriv","if_you_want_to_delete":"hvis du vil slette denne kalender","you_have_to_write":"Du skal skrive","success_text":"Kalenderen er slettet"},"setupWidget":{"do_steps_for_scheduling":"6 trin for at komme i gang med skemalægningen","get_going_easy":"Kom i gang","follow_these_steps":"Følg vejledninger i videoerne","write_us":"Chat med os","support_forum":"Supportforum"},"createmerge":{"create_merge":"Opret fletteskema(er)","name":"Navn","placeholder":"Pauser","calendar":"kalender","calendars":"kalendere","warning_text":"Kalendere kan ikke have samme navn","succes_text":"Kalender(e) blev oprettet!"},"sidenav":{"not_created_klass":"Du har ikke oprettet nogen klasser","not_created_users":"Du har ikke oprettet nogen brugere","not_created_rooms":"Du har ikke oprettet nogen lokaler","not_created_merge":"Du har ikke oprettet nogen fletteskemaer","not_created_other":"Andre Kalendere bruges til teammøder og lignende. <a href=\"https://help.docendo.dk/da/knowledgebase/13-andre-kalendere/docs/19-andre-kalendere-til-moder-og-andre-opgaver-der-ikke-er-undervisning\" target=\"_blank\">Læs mere om Andre Kalendere</a>"},"year_transfer":{"copy_klasses_from":"Kopier kalendere fra skoleåret","to":"til","copy_nothing":"Kopier intet","klass_name":"Kalendar navn","klass_name_desc":"Kopierer en kalender med samme navn til det nye skoleår - uden brikker.","klass_name_and_subjects":"Kalenderens navn og brikker inkl. årsnorm","klass_name_and_subjects_desc":"Kopierer en kalendar med samme navn og alle oprettede brikker inkl. årsnorm til det nye skoleår.","klass_name_and_subjects_with_teachers":"Kalenderens navn og brikker inkl. årsnorm og tilknyttede undervisere og lokaler","klass_name_and_subjects_with_teachers_desc":"Kopierer en kalender med samme navn i det nye skoleår - og alle oprettede brikker inkl. årsnorm og tilknyttede undervisere og lokaler.","choose_all":"Vælg alle","img_src_one":"http://support.docendo.dk/img/transferyear/1DK.png","img_src_two":"http://support.docendo.dk/img/transferyear/2DK.png","img_src_three":"http://support.docendo.dk/img/transferyear/3DK.png","year_transfer_link":"Vil du oprette klasser med navne og brikker fra sidste skoleår? Klik her","from_week_33_in":"fra uge 33 i","to_week_33_in":"til uge 33 i","klass_name_and_subjects_with_teachers_and_schedules":"Klassens navn og brikker inkl. årsnorm og tilknyttede undervisere, lokaler og skemaer","calendar_already_exist":"kalenderen eksisterer allerede","everything_is_copied_except":"Alt kopieres undtagen evt. tilknyttede klasser","everything_is_copied_except_tooltip":"Hvis der er mere end en klasse tilknyttet brikkerne, bliver disse ikke kopieret, da de tilknyttede klasser tilhører det forrige skoleår","and_schedules":"og skema","from_week":"Fra uge","to_week":"Til uge"},"assign_users_hours":{"assign_hours":"Årsnorm","search_a_name":"Søg på navn","work_hours":"Arbejdstid","teaching":"Undervisning","substitute_hours":"Vikartimer","absence":"Fravær","name":"Navn","assigned":"Tildelt","scheduled":"Skemalagt","diff":"Forskel","update":"Opdatér tal","applies_to_the_period":"Gælder for perioden","tasks":"Øvrige opgaver","preparation":"Forberedelse"},"tagging":{"tagging_users":"Gruppering af brugere","users_selected_from":"brugere valgt af","add_tag_to":"Tilføj tag til","select_persons_first":"Vælg personer først","select_all":"Vælg alle","unselect_all":"Fravælg alle","already_created":"Allerede oprettede","example_tags":"Eks. Lærer, Vikar, Team","create_tag":"Opret tag","search_tag":"Vælg gruppe","create_tags":"Opret tags","with":"med","you_have_created_zero_tags":"Du har oprettet 0 tags"},"dselect":{"no_matching_results":"Ingen matchende resultater","placeholder":"Søg på person","create_user":"Opret bruger,","in_same_klass":"I samme klasse","placeholder_calendars":"Søg og vælg"},"substitution":{"substitution":"Vikardækning","none_absent":"Ingen fraværende","number_absent_today":"Antal fraværende i dag","today":"I dag","create_absence":"Opret fraværende","who":"Hvem","person_must_be_filled":"Person skal udfyldes","reason":"Årsag","choose_absence_reason":"Vælg fraværsårsag","create":"Opret","reason_must_be_filled":"Årsag skal udfyldes","date":"Dato","time":"Tid","absent_period":"Fraværsperiode","do_you_want_to_delete_the_absent_reason":"Vil du slette fraværsårsagen","yes":"Ja","cancel":"Annullér","substitutes_will_not_be_removed":"Vikarer på lektioner vil IKKE blive fjernet. Så fjern evt. disse inden.","subject":"Fag","class":"Klasse","other_users":"Også tilknyttet","substitute":"Vikar","substitute_notes":"Vikarnoter","todays_lessons":"Dagens lektioner","see_all":"Se alle","see_less":"Se færre","absence_is_created_in_a_calendar":"Fraværet er oprettet i en kalendar, og skal derfor slettes i denne.","go_to_calendar":"Gå til kalender","deleting_absence_from":"Sletter fraværet fra","to":"til","choose_absence_user":"Vælg en eller flere undervisere","absence_notes":"Evt. note til fraværet","add_sub_to_several_lesson":"Sæt en vikar på flere lektioner","find_sub_for":"Find vikar til","lessons":"lektioner","finding_available_subs":"Finder ledige vikarer","select_lessons_to_substitute":"Vælg lektioner der skal vikardækkes","overlap":"overlap","available":"Ledig","working_hours":"Arbejdstid","busy":"Optaget","do_you_want_to_save":"Vil du gerne gemme dine ændringer","no_close_without_saving":"Luk uden at gemme","yes_save_my_changes":"Ja, gem mine ændringer","lessons_updated":"Lektioner opdateret","lessons_without_sub":"Lektioner uden vikar","lessons_with_sub":"Lektioner med vikar","all_lessons":"Alle lektioner","no_lessons_without_subs":"Ingen lektioner uden vikar","no_lessons_with_sub":"Ingen lektioner med vikar","no_lessons":"Ingen lektioner","remove_sub_from_all_lessons":"Fjern som vikar på alle lektioner","do_you_want_to_remove":"Vil du fjerne","as_sub_on":"som vikar på","or_on_all_lessons":"eller på alle lektioner","remove_from_all_lessons":"Fjern fra alle lektioner","just_this_lessons":"Kun på denne lektion","choose_period_lessons":"Vælg en periode for at se lektioner","from_selected_date_onwards":"Fra valgt dato og frem","entire_period":"Hele perioden","selected_date":"Valgt dato","lessons_that_overlap_in_class":"Samtidig i klassen","delete_lesson":"Slet lektion","settings":"Indstillinger","include_reservations":"Medtag reservationer i vikardækningen","show_overlapping_class_badge":"Vis +ikon ved personer samtidig i klassen"},"substitution_user":{"multiple_days":"Flere dage","lessons_on_day":"Lektioner på dagen","lessons_affected_by_absence":"Lektioner påvirket af fravær","absent":"Fraværende"},"substitution_show":{"show_all_lessons":"Vis alle lektioner","show_the_absent":"Vis fraværende","lessons":"Lektioner","choosen_lessons":"Valgte lektioner"},"sub_scheduler":{"filter_substitutes":"Filtrér i vikarer","sub_pools":"Vikarpuljer","todays_absent":"Dagens fraværende","potential_subs":"Potentielle vikarer","choose_sub":"Vælg vikar","status":"Status","sort_after":"Sortér efter forslag","set_priorities":"Vælg prioriteringer","sorting_will_be_based_on":"Sortering sker ud fra","has_canceled_hours":"Har aflyste timer i tidsrummet","already_on_lesson":"Også tilknyttet på lektionen","is_in_same_class_at_the_same_time":"Er i klassen samtidig","has_hours_in_class_on_day":"Har timer i klassen på dagen","multiple_lessons_in_same_classes":"+2 undervisere samtidig i en anden klasse","not_occupied_with_available_lesson":"Ledig med Rådighedstime","not_occupied_with_work_hours":"Ledig med arbejdstid","not_occupied_without_work_hours":"Ledig uden arbejdstid - men med fag på dagen","multiple_on_a_lesson":"+2 samtidig i en anden klasse","not_occupied_without_lessons_on_the_day":"Ingen lektioner på dagen","occupied":"Optaget","occupied_in_selected":"Optaget i {occupied} af {total}","it_will_also_be_sorted_based_on_tags_in_common":"Ovenstående sorteres også ud fra antal tags til fælles med den fraværende","absent_people":"Fraværende","substitutes":"Vikarer","out_of":"ud af","potential_substitutes":"Potentielle vikarer","pool":"Pulje","choose_filters":"Vælg filtre","list":"Liste","schedules_overview":"Skemaoverblik","is_substituted":"Er vikardækket"},"sub_scheduler_item":{"prolonged_absence":"Længerevarende","also_on_lesson":"Også tilknyttet"},"sub_scheduler_popover":{"substitute_for":"Vikardæk for","handled":"Håndteret","not_handled":"Ikke håndteret","handled_for_absence":"Håndteret for alle fraværende","pending":"Afventer"},"sub_scheduler_sub_pools":{"substitute_hours":"Vikartimer","difference":"Forskel","assigned":"Tildelt","scheduled":"Skemalagt"},"IEWarning":{"you_are_using_a_IE_or_Edge_to_get":"OBS! Du bruger Internet Explorer / Edge. For at få","a_faster_and_better_experience":"en hurtigere og bedre oplevelse","we_recommend_that_you_switch_to_these_browsers":"anbefaler vi, at du skifter til en af disse gratis browsere","or":"eller"},"dashboard":{"welcome":"Velkommen","start_by_setting_up":"Start med opsætning af","steps_completed":"Trin fuldført","step":"Trin","tutorial":"Videoguide","follow_the_steps":"Følg Setup Guiden"},"delete_day_or_week":{"cant_delete":"Kunne ikke slettes. Prøv igen."},"user_event_list":{"absence":"Fravær","teaching":"Undervisning","substitute_hours":"Vikartimer","from":"fra","to":"til","no_matching_events":"Listen er tom","total":"Sum","close":"Luk"},"weekplan_2":{"no_events_this_week":"Ingen lektioner i ugen"},"event_form":{"delete_events_onward":"Slet lektioner fremadrettet","are_you_sure":"Er du sikker?","do_you_want_to_delete_this_and_all_in_same_timeslot":"Vil du gerne slette denne lektion, og alle der ligger på samme ugedag og i samme tidsrum fremadrettet?","cancel":"Annuller"},"calendar_export":{"export_calendar":"Eksporter kalender","export_calendar_to":"Eksporter kalender til ...","copy_the_url_and_insert":"Kopier følgende URL og indsæt den i den eksterne kalender","guide_to":"Guide til","guide_to_export_calendar":"Guide til at eksportere til Outlook, Google eller iCalendar,","create_a_link_on_mobile":"Opsætning af klasseskemaer på mobilen"},"common":{"groups":"Grupper","search":"Søg","show_print_hours":"Vis Beregn timer","show_as_blocks":"Vis som blokke","show_as_table":"Vis som tabel","show_as_list":"Vis som liste","add":"Tilføj","submit":"Gem","create":"Opret","edit":"Redigér","save":"Gem","saved":"Gemt","dont_save":"Gem ikke","select":"Vælg","cancel":"Annuller","update":"Opdater","yes":"Ja","no":"Nej","save_changes":"Vil du gemme dine ændringer?","are_you_sure_you_want_to_delete":"Er du sikker på, at du gerne vil slette","ago":"siden","min":"min","class":"Klasse","classes":"Klasser","classes_sidenav":"Klasser","teacher":"Underviser","room":"Lokale","substitute":"Vikar","rename":"Omdøb","delete":"Slet","add_user":"Tilføj bruger","press":"Tryk","user":"Bruger","users":"Brugere","rooms":"Lokaler","merge_calendar":"Fletteskema","merge_calendars":"Fletteskemaer","merge_calendars_sidenav":"Flette-skemaer","other_calendar":"Anden kalender","other_calendars":"Andre kalendere","close":"Luk","must_be_filled":"Skal udfyldes","something_went_wrong":"Noget gik galt","show_weekends":"Vis weekender","calendar":"Kalender","in":"i","search_for":"søg på","remove":"Fjern","none_created":"Ingen oprettet","log":"Historik","no_calendars_found":"Ingen kalendere fundet..","done":"Færdig","is_deleted":"er slettet,","choose_school":"Vælg skole","no_active_school_years":"Der er ingen aktive skoleår. Bed en administrator om at åbne op.","show_more":"Vis flere","show_less":"Skjul flere","search_name_or_initials":"Søg på navn eller initialer","hide_calendars":"Skjul kalendere på fag","hide_dates":"Skjul datoer"},"weeknote_log":{"saved_versions":"Gemte versioner af ugenoten","activity":"Historik","no_saved_versions":"Ingen gemte versioner","choose_versions_to_compare":"Vælg versioner til sammenligning","current_version":"Aktuel version"},"show_event":{"this_lesson_counts_as":"Denne lektion tæller som"},"permissions":{"can_request_absence":"Fravær - Kan anmode om fravær","can_handle_absence_requests":"Fravær - Kan godkende anmodninger om fravær","roles":"Roller","create_new_role":"Opret ny rolle","users":"Brugere som er","users_assigned_role":"brugere tildelt rollen","add_user_to":"Tilføj bruger til","role":"rolle","permissions":"Tilladelser som","change_permissions_for_role":"Ændre tilladelser for rollen","rename_role":"Omdøb rollen","delete_role":"Slet rollen","give_role_a_title":"Giv rollen et navn","choose_new_name":"Vælg nyt navn","you_cant_delete_a_role_that_has_users":"Du kan ikke slette en rolle, der har brugere tilknyttet","give_the_following_user_a_new_role":"Giv følgende brugere en ny rolle","can_change_substitution":"Vikardækning - Kan tilgå og ændre Vikardækning","can_send_substitute_sms":"Vikardækning - Kan sende SMS'er","can_manage_absence_reasons":"Vikardækning - Kan oprette og ændre Fraværsårsager","can_do_most_stuff":"Kan gøre det meste","can_edit_own_notes":"Skema - Kan redigere noter","can_export":"Kan eksportere til Docendo ZEN","can_manage_assigned_hours":"Årsnorm - Kan tilgå og ændre Årsnorm","can_see_assigned_hours":"Årsnorm - Kan tilgå Årsnorm","can_manage_school_years":"Kan ændre i skoleår","can_manage_sms":"Kan anvende SMS","can_manage_substitute_hours":"Kan ændre i vikarpuljer","can_manage_tasks":"Fagfordelingen - Kan ændre i fag og opgaver","can_manage_users":"Kan håndtere brugere","can_see_other_calendars":"Skema - Kan se alle kalendere","can_manage_calendars":"Kalendere - Kan oprette, slette og redigere kalendere","can_setup_aula":"Kan ændre opsætning til Aula","change_role":"Ændre rolle","role_desc_administrator":"En administrator har adgang til alle funktioner i Docendo, og kan håndtere rettigheder for alle roller.","role_desc_read_only_user":"En skrivebeskyttet bruger har som udgangspunkt kun adgang til egen kalender, og brugeren kan ikke se eller ændre i andre kalendere eller tilgå vikardækning og andre administrative funktioner. Denne rolle kan dog tildeles adgang til udvalgte funktioner.","role_desc_regular_user":"En Normal Bruger kan redigere skemaer og tilgå de fleste funktioner, men kan ikke tilføje, ændre eller slette brugere og årsnormsperioder/skoleår eller ændre Aula-opsætning.","role_updated":"Rollen er opdateret","role_deleted":"Rollen er slettet","role_created":"Rollen er oprettet","can_see_other_subject_requests":"Fagønsker - Kan se andres ønsker","can_edit_subject_requests":"Fagønsker - Kan ønske fag (når der er åben for Fagønsker)","can_see_subjects_distribution_page":"Fagfordelingen - Kan tilgå fagfordelingen","can_see_others_task_overviews":"Opgaveoversigt - Kan se andres opgaveoversigt","can_see_own_task_overview":"Opgaveoversigt - Kan se sin egen opgaveoversigt","can_change_task_overview":"Opgaveoversigt - Kan vælge, om brikker vises på opgaveoversigten","can_see_others_hour_overviews":"Timeopgørelse - Kan se andres timeopgørelse","can_see_own_hour_overview":"Timeopgørelse - Kan se sin egen timeopgørelse","can_edit_own_presence":"Arbejdstid - Kan redigere sin egen arbejdstid","can_edit_others_presence":"Arbejdstid - Kan redigere andres arbejdstid","can_edit_user_year_notes":"Opgaveoversigt - Kan skrive og redigere noter hos andre","can_send_substitute_email":"Vikardækning - Kan sende emails","select_role_to_base_new_on":"Vælg en rolle, den nye skal baseres på"},"calendars":{"calendars":"Kalendere","edit_calendars":"Slet / omdøb kalendere","copy_calendars":"Kopier kalendere","archive":"Arkivér","show":"Se","hide":"Skjul","archived":"arkiverede","unarchive":"Gendan","write_name":"Skriv navn","selected_of":"valgt af","select_calendars_to_copy":"Vælg kalendere der skal kopieres","copy":"Kopier","select_week_to_copy_from":"Vælg uge der skal kopieres fra","select_weeks_that_week":"Vælg uger som uge","must_be_copied_to":"skal kopieres til","do_you_want_to_delete":"Vil du slette","print_calendars":"Print kalendere","add_presence":"Tilføj arbejdstider","delete_events_in_date_range":"Slet alt skemalagt i et datointerval","delete":"Slet"},"sms":{"sms":"SMS","do_you_want_to_delete_the_template":"Vil du slette standard besked","template_sms_deleted":"Standard besked slettet","an_error_occured":"Der opstod en fejl","add_number":"Tilføj mobilnummer","number_must_be_8_digits":"Telefonummer skal være 8 cifre","number_deleted":"Telefonnummer slettet","number_added_awaiting":"Nummeret tilføjet. Afventer bekræftelse","edit":"Redigér","new":"Ny","standard_sms":"standard besked","title":"Titel","to_show_in_list":"til visning i listen","ex_you_are_sub":"Eks. Du er blevet vikar","insert_today_to":"Indsæt [today] for få dagen eks.","updated_sms_template":"Opdaterede besked","created_sms_template":"Oprettede besked","message":"Besked","subject":"Emnefelt"},"subs_ongoing_absence":{"delete_absence":"Slet fravær","change_start_and_end_date":"Ændre start- og slutdato","ongoing_absence":"Løbende fravær","ongoing_absence_explained":"Løbende fravær forlænges automatisk, når den oprindelige slutdato er nået. Slutdatoen er den forventede sidste dato for fraværet. Fraværet forlænges med én dag ad gangen, indtil du afslutter fraværet.","date_label":"Dato (inkl. begge dage)","absence_will_be_deleted":"Fravær slettes","remove_subs_and_delete_absence":"Fjern vikarer og slet fravær","keep_subs_and_delete_absence":"Behold vikarer og slet fravær","remove_subs_and_update":"Fjern vikarer og opdater","keep_subs_and_update":"Behold vikarer og opdater","remove_subs_and_stop_ongoing_absence":"Fjern vikarer og stop løbende fravær","keep_subs_and_stop_ongoing_absence":"Behold vikarer og stop løbende fravær","confirm_date_and_stop_ongoing_absence":"Bekræft datoer og stop løbende fravær","update_dates":"Opdater datoer","checking_for_substitutes":"Tjekker for vikarer","lessons_with_substitutes":"Lektioner med vikar","no_subs_on_lessons":"Ingen vikarer på lektioner i de dage fraværet slettes","of":"af","lessons_that_will_have_subs_removed":"lektioner får slettet vikarer","select_all":"Vælg alle","unselect_all":"Fravælg alle","remove_sub":"Fjern vikar","teachers_with_ongoing_absence":"Undervisere med løbende fravær","no_teachers_with_ongoing_absence":"Ingen undervisere med løbende fravær","absence_will_be_prolonged_in":"Forlænges om","edit_stop":"Redigér / stop","subs_removed":"Vikarer fjernet","absence_deleted":"Fravær slettet","auto_created_today":"Oprettet automatisk i dag","absence_updated":"Fravær opdateret","stop_ongoing_absence":"Stop løbende fravær","cant_be_ongoing_absence":"Løbende fravær kan ikke oprettes med slutdato tidligere end dags dato","auto_created":"Oprettet automatisk"},"zen_import":{"import_from_zen":"Importer skemasæt fra ZEN til Docendo","choose_version":"Vælg skemasæt","you_have_no_created_any_versions":"Du har ikke oprettet nogen skemasæt i ZEN","last_updated":"Seneste ændring","choose_schoolyear":"Vælg skoleår","insert_in_week":"Indsæt i uge","insert_schedules":"Indsæt skemaer","week":"Uge","schedules_are_being_inserted":"Skemaer indsættes i uge","changes_from_import":"Ændringer ifm. import","changes_from_import_help":"Se og fortryd de ændringer en import har lavet på kalendere og fag.","no_imports":"Der er endnu ikke foretaget nogen importer","view_changes":"Se ændringer","import_processing":"Importen behandles…","no_changes_in_import":"Importen medførte ingen ændringer","created_calendars_title":"Oprettede kalendere","changed_calendars_title":"Ændrede kalendere","created_subjects_title":"Oprettede brikker","changed_subjects_title":"Opdaterede brikker","created_title":"Oprettet","changed_title":"Ændret","type_column":"Type","type_calendar":"Kalender","type_subject":"Brik","delete":"Slet","undo_change":"Fortryd ændring","confirm":"Er du sikker?","yes":"Ja","cancel":"Annuller","done_deleted":"Slettet","done_reverted":"Fortrudt","field_name":"Navn","field_color":"Farve","imported":"Importeret","calendars_label":"kalendere","subjects_label":"brikker","download_to_excel":"Download til Excel","excel_calendar":"Kalender","excel_field":"Felt","excel_old_value":"Før","excel_new_value":"Efter"},"create_calendars":{"other_calendar":"Opret andre kalendere","other_calendar_placeholder":"Eks. Team kalender"},"create_subject":{"create_subject":"Opret brik","subject_is_not_created_in_this_school_year":"Brikken er oprettet. Vær dog opmærksom på, at den er tilknyttet et skoleår, som ikke matcher den aktuelle dato."},"task_overview":{"task_overview":"Opgaveoversigt","hour_overview":"Timeopgørelse","task_and_hour_overview":"Opgaveoversigt og timeopgørelse","no_tasks_assigned":"Ingen opgaver tildelt","transfer_scheduled_to_assigned":"Overfør skemalagt til tildelt","transfer_scheduled_only_full_period":"Kun muligt når hele perioden er valgt","transfer_scheduled_already_equal":"Tildelt og skemalagt er allerede ens","transfer_scheduled_success":"{name}: tildelt ændret fra {from} til {to}","transfer_scheduled_no_permission":"Du har ikke rettighed til at ændre timer på den skole, brikken hører til","transfer_scheduled_other_calendar_hours":"{name} kan ikke overføres, fordi {calendars} har sit eget timetal på brikken, som vises i stedet. Ret det under Redigér.","assign_teacher_to_subject_title":"Underviseren er ikke på brikken","assign_teacher_to_subject_text":"{teacher} har lektioner i {name} ({calendar}), men er ikke tilknyttet selve brikken. Vil du tildele {teacher} til brikken, så du kan overføre timer og redigere?","assign_teacher_to_subject_confirm":"Tildel underviser","assign_teacher_to_subject_success":"{teacher} er tildelt {name}","distribution":"Fordeling","work_hours":"Arbejdstid","teaching":"Undervisning","tasks":"Øvrige Opgaver","preparation":"Forberedelse","show_scheduled_hours":"Vis skemalagte timer","coming_soon":"Kommer snart","belongs_to":"Tilhører","absence":"Fravær","reset":"Nulstil dato","club":"SFO","substitute_hours":"Vikartimer","showing_scheduled_hours_from":"Viser skemalagte timer fra","rest":"Rest","pool":"Lokalpulje","unknown":"Rådighedstimer","diff_from_total_workhours":"For mange timer fordelt ift. arbejdstid","rest_missing_tooltip":"{hours} timer mangler at blive fordelt","rest_too_many_tooltip":"{hours} timer for mange fordelt ift. arbejdstid","rest_balanced_tooltip":"Alle timer er fordelt"},"standard_settings":{"standard_setting":"Standard indstilling","set_default_start_and_endtime":"Sæt standard start- og sluttid"},"print_all_calendars":{"loading":"Henter lektioner for alle kalendere. Det kan tage noget tid..","no_calendars":"Det er 0 kalendere med lektioner","are_you_ready_to_print":"Er du klar til at printe?","print":"Print","this_calendar":"Denne kalender","this_calendar_with_weekplan":"Kalender m. ugeplan","all_classes":"Alle klasser","all_teachers":"Alle undervisere","all_rooms":"Alle lokaler","only_printing_calendars_with_lessons":"Printer kun kalendere med lektioner","show_print_without_bg_colors":"print uden baggrundsfarver","event_font_size":"Skriftstørrelse","custom":"Vælg kalendere"},"edit_event":{"teachers":"Personale","substitutes":"Vikar","rooms":"Lokale","klass":"Klasse","swap_headline":"Følgende lektioner kan bytte plads med den valgte lektion","swap_desc":"Byt-funktionen bruges til at bytte en eksisterende lektion med en anden lektion, der allerede er planlagt til et andet tidspunkt i samme kalender. Det betyder, at man kan flytte en planlagt lektion til et andet tidspunkt og erstatte den med en anden lektion fra samme kalender. Følgende lektioner kan byttes med den valgte lektion uden at skabe dobbeltbookinger, da undervisere og lokaler er ledige i de nye tidsrum.","swap_no_lessons":"Desværre ingen lektioner at bytte med...","select":"Vælg","replace_headline":"Erstat lektionen med en ny","replace_desc":"Erstat-funktionen bruges til at erstatte en eksisterende lektion med en ny (ikke-skemalagt) lektion fra et udvalgt fag. Der er muligt at erstatte lektionen med en ny fra nedenstående fag, da både underviser og lokale er ledige.","replace_no_lessons":"Desværre ingen lektioner at erstatte med...","lesson_updated":"Lektionen er opdateret"},"students":{"all":"Alle","activated_schedules":"Aktiverede elevskemaer","student":"elev","students":"elever","created_student":"Elev oprettet","delete_student":"Slet elev?","add_student":"Tilføj fra anden klasse","create_student":"Opret elev","students_with_same_name":"Følgene elever har et lignende navn","users_with_same_name":"Følgene brugere har et lignende navn","latest_updated":"Senest opdateret","is_already_in_the_klass":"Er allerede i klassen","without_a_group":"uden klasse","has_no_groups":"Ingen klasser tilknyttet","name":"navn","feide":"feide","feide_is_already_used":"Dette Feide er allerde brugt","import_students":"Importer elever","groups":"grupper","without_group":"Uden klasse","calendar":"kalender","remove":"Fjern","of":"af","students_in":"elever i","the_group":"klassen","select_all":"Vælg alle","unselect_all":"Fravælg alle","insert_multiple_students":"Indsæt liste med elevnavne. Skift linje efter hver elev.","create_multiple_students":"Opret flere elever på en gang","to_be_scheduled":"Skemalægges"},"set_standard_duration":{"lessons_duration":"Lektionslængde","minutes":"minutter","set_standard_duration_for_the_school":"Sæt standard lektionslængde for skolen","standard_duration_for_the_school":"Standard lektionslængde for skolen","the_number_must_be_divisible_by_five":"Minuttallet skal gå op i 5","this_setting_will_be_selected_if_nothing_else_is":"Denne indstilling bruges, hvis ikke andet er valgt","standard_duration_can_be_selected_for_each_course":"Standardvarigheden for et fag kan altid ændres for hvert enkelt fag","already_created_courses_want_be_updated":"Allerede oprettede fag vil ikke blive opdateret","set_standard_length_for_zen":"Standard lektionslængden bruges til at udregne antal lektioner for et ugeskema i Docendo ZEN."},"club":{"club":"SFO","club_calendar":"SFO kalender","create_club_calendar":"Opret SFO kalender","not_created_club":"Med et SFO-skema kan du oprette SFO-tid for pædagoger adskilt fra skole-tid"},"calendar_view":{"next_week_disabled_tooltip":"Mangler du en uge? Skolens administratorer kan redigere skoleårets varighed under ⚙️ > 'Skoleår'"},"calendar_view_day":{"remove":"Fjern","add":"Tilføj","replace":"Erstat","actions_for":"Handlinger for","onwards":"fremadrettet","remove_onwards":"Fjern fremadrettet","do_you_want_to_remove":"Vil du fjerne","on_all_lessons_from":"på alle lektioner fra og med","and_onwards":"og på alle lektioner fremover","add_onwards":"Tilføj fremadrettet","do_you_want_to_add":"Vil du tilføje","on_all":"på alle","lessons":"lektioner","onwards_which_include":"fremadrettet? Dette inkluderer lektioner fra og med","and_all_onwards":"og på alle fremtidige lektioner","with_on_all":"med på alle","select_the_person_to_replace":"Vælg den kalender du gerne vil erstatte","select_person":"Vælg kalender","replace_onwards":"Erstat fremadrettet","set_end_date":"Sæt slutdato","until_and_including":"til og med"},"eventTypes":{"subject":"Fag","optional":"Valgfag/Hold","supplemental":"UUV","frame":"Temavisning","break":"Pause","resource":"Ressource (skjult)","person_resource":"Ressource (skjult)","other_tasks":"Anden tid","other_stuff":"Øvrig tid","available":"Rådighedstime","person_resource_visible":"Ressource (synlig)","club":"SFO tid","additional_tasks":"Øvrige opgaver","preparation":"Forberedelse","with_kids":"Tid med børn","without_kids":"Tid uden børn","pool":"Lokalpulje","absence":"Fravær","_extra_time_at_start_of_day_":"Ekstra tid før første lektion","_extra_time_between_events_":"Ekstra tid mellem timer","_extra_time_if_shorter_than_":"Ekstra tid når dagen er for kort","reservation":"Reservation","activity":"Aktivitet"},"task_versions":{"task_overview":"Opgaveoversigt","versions":"Versioner","save_print_task_overviews":"Gem/print opgaveoversigter","save_new_version_task_overviews":"Gem en ny version opgaveoversigter","print_latest_version_task_overviews":"Print nyeste version af opgaveoversigter","saved_message":"Gemt","delete_message":"Slet","confirm_delete_message":"Vil du slette","delete_warning_message":"Versioner der slettes kan ikke genskabes","annual_norm":"Årsnorm","save_task_overview_version":"Gem version af opgaveoversigt","version_title":"Titel for versionen af opgaveoversigten","auto_name_description":"Navngives automatisk med dags dato, hvis du ikke skriver en titel","what_is_version":"Hvad er en version?","saved_task_overview_description":"En gemt opgaveoversigt viser et øjebliksbillede af medarbejderens opgaveoversigt, som den så ud på det tidspunkt, hvor versionen af opgaveoversigten blev gemt. Det svarer til at lave en udskrift eller PDF med detaljer om, hvordan opgaveoversigten så ud på det givne tidspunkt.","find_saved_versions":"Hvor kan jeg finde gemte versioner?","find_saved_versions_description":"Du kan finde gemte versioner ved at navigere til \"Opgaveoversigt\" for de enkelte personer. Her vil der være en dropdown-menu, hvor de alle gemte versioner i skoleåret er tilgængelige for gennemsyn.","select_personnel":"Vælg personale","go_back":"Tilbage","select_min_user":"Der skal vælges minimum en bruger","save_for_selected_users":"Gem for","save_for_selected_users_of":"af","print_latest_version":"Print alles nyeste version af opgaveoversigten","no_saved_versions":"Ingen versioner er gemt","save_new_version":"Gem ny version","save_version":"Gem version"},"deleted_subjects_log":{"deleted_log":"Log over slettede","no_lessons_deleted":"Der er ikke slettet nogle lektioner fra denne brik","lesson":"Lektionen","deleted":"Slettet"},"create_activity":{"create_activity":"Opret aktivitet","create_activity_for":"Opret aktivitet for","title":"titel","search_or_create":"Søg eller opret","created":"Oprettet","create_new_subject_for":"Opret ny brik for","choose_subject_type":"Vælg briktype","the_selected_date_is_outside_schoolyears":"Den valgte dato er uden for alle aktive skoleår","set_as_substitute":"Sæt på som vikar","set_as_substitute_help":"Brugeren sættes på aktiviteten som vikar. Timerne trækker fra brugerens vikarpulje, og brugeren vises under Dagens vikarer – f.eks. når der sendes SMS til dagens vikarer."},"datepicker":{"max_date_range_start":"Der kan max hentes","max_date_range_end":"dages interval"},"request_absence":{"request_absence":"Anmod om fravær"},"public_calendar":{"black_white":"Sort/hvid"},"special_days":{"title":"Omlagte dage","intro":"Omlæg en eller flere dage for udvalgte klasser, f.eks. en motionsdag, emnedag eller første skoledag. Der kopieres ikke ind i klassernes datoer med omlagte dage, og de overskrives derfor ikke. Omlagte dage kan desuden fratrække uv-timer fra klassens normale fag, der skulle have lagt.","create":"Opret omlagt dag","edit":"Rediger omlagt dag","refresh_reductions":"Opdater reduktioner","reductions_updated":"Reduktioner er opdateret","none_created":"Der er ikke oprettet nogen omlagte dage endnu","loading":"Henter omlagte dage","name":"Navn","name_placeholder":"F.eks. Motionsdag","start_date":"Fra dato","end_date":"Til dato","period":"Periode","day":"dag","days":"dage","pick_dates_hint":"Klik på en dag for at vælge fra- og til-dato","reduct":"Reducer på fagtimer i klassen","reduct_hint":"Når den er slået til, reduceres klassernes timer for perioden.","reduct_yes":"Ja","reduct_no":"Nej","classes":"Klasser","select_classes":"Vælg klasser","select_all":"Vælg alle","clear":"Ryd","no_classes_selected":"Vælg mindst én klasse","actions":"Handlinger","delete":"Slet","save":"Gem","cancel":"Annuller","linked_subjects":"Tilknyttede brikker","subjects_delete_hint":"Markerede brikker slettes sammen med dagen. Resten bevares og løsrives fra dagen.","subject_cannot_delete":"Kan ikke slettes","confirm_delete_title":"Slet","confirm_delete_text":"Den omlagte dag slettes.","saved":"Gemt","deleted_toast":"Den omlagte dag blev slettet","error_toast":"Noget gik galt. Prøv igen."},"helpdesk":{"hero_eyebrow":"Svar, guides og opdateringer","hero_title":"Hvad kan vi hjælpe dig med?","hero_subtitle":"Find svaret, og kom videre med din dag.","search_placeholder":"Søg i hjælpeartikler…","back_to":"Tilbage til","latest_news":"Seneste nyhed","read_news":"Læs nyheden","earlier_news":"Tidligere nyheder","popular_articles":"Populære artikler","find_by_topic":"Find hjælp efter emne","footer_help":"Brug for mere hjælp? Vores support hjælper dig videre.","back":"Tilbage","articles_about":"Artikler om:","categories":"Kategorier","related_articles":"Relaterede artikler","copy_link":"Kopiér link","link_copied":"Link kopieret!","back_to_start":"Tilbage til start","search_results":"Søgeresultater","no_results":"Vi fandt ingen artikler, der matcher din søgning.","no_articles":"Der er endnu ingen hjælpeartikler.","clear_search":"Ryd søgning","uncategorized":"Øvrigt","article":"artikel","articles":"artikler","language":"Sprog"},"school_users":{"title":"Brugere","stil_intro":"STIL har ændret måden, Unilogins oprettes på. Vi anbefaler, at I importerer brugere fra STIL i stedet for at oprette dem manuelt.","stil_read_more":"Læs mere","stil_import":"Import af brugere fra STIL","merge_users":"Flet brugere","transfer_calendar":"Overfør kalender","create":"Opret bruger","edit":"Rediger bruger","actions":"Handlinger","edit_action":"Rediger","search_placeholder":"Søg på navn, initialer, login eller telefon","users":"brugere","none":"Der er ingen brugere på skolen","no_results":"Ingen brugere matcher søgningen","name":"Navn","initials":"Initialer","login":"Login","email":"Email","phone":"Telefon","ssn":"CPR-nummer","unilogin":"Unilogin","unilogin_hint":"(8 eller 10 tegn)","feide":"Feide","employee_id":"Medarbejder-id","employee_id_hint":"(valgfrit id som skolen kan bruge)","last_seen":"Sidst set","never_logged_in":"Aldrig logget ind","change_photo":"Skift billede","not_editable_yet":"Kan endnu ikke ændres her","see_tasks":"Se opgaveoversigt","cancel":"Annuller","save":"Gem","saved":"Brugeren er gemt","error_toast":"Noget gik galt. Prøv igen."}}

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

	module.exports = {"en":{"activerecord":{"attributes":{"calendar":{"name":"Name"},"group":{"country":"Country","demo_expiry":"Demo expired","description":"Description:","institution_number":null,"name":"Name","open":"Open?","si_name":null,"visible":"Visible?"},"institution":{"number":"Institution number"},"lesson":{"count_hours":"Count hours"},"material":{"class":"Grade/group","description":"Description:","documenttypes":"Type of document","klassetrin":"Grade/group","status":"Status","subjects":"Subject","tag_list":"Tag list","thefile":"File","title":"Title"},"notification":{"body":"Body text","header":"Title","sitewide":null,"url":"URL"},"post":{"body":"Content","published":"Published?","titel":"Title"},"room":{"name":"Name","navn":"Name","si_name":null},"signup":{"already_in_use":"already in use","country":"Country","email":"E-mail","password":"Password","password_can_not_be_email":"cannot be your e-mail","password_can_not_be_school_name":"cannot be the name of your school","password_can_not_be_user_name":"cannot be your name","password_confirmation":"Confirm password","school_name":"School name","terms_of_service":"Terms of service","user_name":"Your name"},"subject":{"calendar":"Calendar","color":"Color","default_duration":"Standard duration (minutes)","hours":"Hours","name":"Subject title","si_name":null,"subject_type":"Type"},"subject_period":{"hours_per_week":"Hours per week","total_hours":"Total hours"},"user":{"Email":"E-mail","Fag":"Subject","Initialer":"Initials","Klassetrin":"Grade","Navn":"Name","Sprog":"Language","assigned_preparation_hours":"Preparation","assigned_teaching_hours":"Assigned teaching hours","assigned_total_hours":"Teaching hours (year)","description":"Description: ","email":"E-mail","groups":"Groups","name":"Name","organisation":"School","password":"Password","password_confirmation":"Confirm password","primary_school":"Your main school","remember_me":"Remember me"}},"errors":{"models":{"group":{"attributes":{"institution_number":{"taken":null}}}}},"models":{"calendar":"schedule","group":"group","institution":"school","lesson":"lesson","material":"material","post":"post","room":"location / classroom","signup":"Signup","subject":"subject","subject_period":"Subject period","user":"user","user/calendar_transfer":"Calendar transfer"}},"calendars":{"administration":{"archive_merge_table":"Archiving a shared calendar will make it invisible on the home page","archive_room":"Archiving a location will make it invisible on the homepage"},"calendar_hours_count":{"andet_halvår":"2nd half of year","første_halvår":"1st half of year","indeværende_uge":"Current week","skoleår_til_dato":"School year to date"},"calendar_sidebar":{"skema":"Schedule"},"copy_paste":{"indsæt":"Paste","indsæt_resten_af_året":"Paste + rest of school year","kopiér":"Copy week"},"delete_merge_calendar_button":{"delete_merge_calendar":"Delete shared calendar","dette_kan_ikke_fortrydes":"This action can't be undone","ja_slet_dette_fletteskema":"Yes","nej":"No","slet_dette_fletteskema":"Delete this shared calendar?"},"delete_week_button":{"der_vil_kun_blive_slettet_de_lektioner_som_er_lagt_ind_i_denne_kalender":"Only events originally placed in this calendar will be deleted.","dette_kan_ikke_fortrydes":"This action can't be undone","ja_slet_ugens_lektioner":"Yes, delete everything this week.","lektioner":"Delete lessons this week...","nej":"No","vil_du_slette_alle_ugens_lektioner":"Do you want to delete all lessons this week?"},"events_with_notes_or_substitutes":{"hvis_du_kopierer_et_skema_frem_bliver_vikardækninger_fravær_i_personlige_kalendre_og_noter_på_lektionerne_ikke_gemt":"By copying and pasting this week all substitute settings and notes will be overwritten.","ja_jeg_vil_overskrive_disse":"Yes, I want to overwrite ","lektioner_med_noter_vikardækning_eller_fravær":"Lessons with notes"},"expand":{"skift_visning_mellem_arbejdsuge_weekender_og_fuld_uge":"Change view (full week/24hours)"},"explain_copy_in_background":{"der_kan_gå_5-10_minutter":"Estimated time: 2-5 minutes","du_får_en_notifikation_på":"You will receive a notification","du_kan_fortsætte_med_at_arbejde_i_andre_kalendre":"You will receive a notification when complete. You can close this window and continue. ","forsiden":"the front page","kopierer_kalenderen_frem":"Copying","når_kopieringen_er_afsluttet":"when the action is complete.","ok":"OK"},"group":{"flet_med_fletteskemaer":"Merge with shared calendars...","flet_med_skema":"Merge with shared calendar","se_elevskema":"View student schedule","vælg_skema":"Choose schedule"},"group_hours":{"total":"Total","type":"Type"},"merge":{"dette_skema_er_flettet_ind_i":"This schedule has been merged with:","hvis_du_vil_slette_dette_fletteskema_skal_du_først":"In order to delete this shared calendar you have to merge out of the above schedules.","vælg_kalender":"Choose schedule:"},"merge_with_selector":{"flet":"Merge"},"new":{"nyt_fletteskema":"New shared calendar","opret_fletteskema":"Create shared calendar"},"public":{"mobile_guide":"Guide: schedule on mobile and tablets.","print_in_black_white":"Print w/o color","printing_guide":"Print guide","se_skemaet_på":"See this schedule on"},"room":{"vælg_skema":"Choose schedule:"},"subject_hours":{"anden_tid_i_perioden":"Non-student related activities","er_du_tilknyttet":"In case you have more than one subject in the same period, time will be equally distributed. ","flextid_for_året":"Flexible hours by year","fravær_i_perioden":"Absence in this period of time","til":"to","timer":"hours","undervisning_i_perioden":"Teaching"},"user":{"apple_kalender":"Apple Calendar","google_kalender":"Google Calendar","google_opdaterer_kalenderen_ca_tre_gange_i_døgnet":"Google fetches information around 3 times a day","ical":"iCal","kopiér_webaddresen_herunder_og_kopier_den_ind_i_den_eksterne_kalender_hvor_du_gerne_vil_have_den":"Copy the URL and insert in the external calendar.","outlook":"Outlook","se_evt_guides_nedenfor_i_forhold_til_hvordan_du_skal_gøre":null,"siden":"ago.","sidst_hentet":"Last fetched","tilføj_dit_skema_til_ekstern_kalender":"External calendar: add your schedule","vælg_kalender":"Choose schedule"},"user_hours":{"undervisningstid":"Teaching"},"week_note":{"week_notes":"Week notes - general"},"week_plan":{"content":"Content","internal_notes":"Teachers notes","learning_goal":"Learning goal","pupil_preparation":"Homework","subject":"Subject"},"week_plan_and_note":{"week":"Week","week_plan":"Notes"}},"controllers":{"ws":{"events":{"you_are_no_longer_substitute":"%{creator} removed you as substitute teacher in %{subject} in %{klass}, %{time}","you_are_substitute":"%{creator} added you as substitute teacher in%{subject} in %{klass}, %{time}"}}},"da_only":{"add_user_with_uni":null,"click_to_login_with_unilogin":null,"fictive_user_text":"A calendar will be created for the fictive user, but the user will not be able to log in.","guide_link_parentintra":null,"lærere_på_skoleintra":null,"opdatér_profil_fra_uni-c":null,"parent_portal":null,"show_tables_parentintra":null,"skriv_brikken_skoleintra":null,"uni_login":null,"vis_skema_i_skoleintra":"Set up for external view","website_portal":"Website"},"date":{"formats":{"iso":"%Y-%m-%d"}},"demo":{"firstlogin":{"kom_igang":"Get started with Docendo","velkommen":"Welcome to Docenday! Watch intro video and click 'Get started' when you're ready."}},"devise":{"confirmations":{"new":{"resend_confirmation_instructions":"Send confirmation instructions"}},"failure":{"invited":"You have a pending invitation, accept it to finish creating your account."},"invitations":{"edit":{"header":"Set your password","password":"Password","password_confirmation":"Confirm password","submit_button":"Set my password"},"invitation_removed":"Your invitation was removed.","invitation_token_invalid":"The invitation token provided is not valid!","new":{"header":"Send invitation","submit_button":"Send an invitation"},"no_invitations_remaining":"No invitations remaining","send_instructions":"An invitation email has been sent to %{email}.","updated":"Your password was set successfully. You are now signed in.","updated_not_active":"Your password was set successfully."},"mailer":{"confirmation_instructions":{"confirm_my_account":"Confirm my account","you_can_confirm_your_account_email_through_the_link_below":"Use link below to confirm your account mail:"},"invitation_instructions":{"accept":"Accept invitation","accept_until":"This invitation will be due in %{due_date}.","contact_us":"If you have any questions you are welcome to contact us at kontakt@docendo.dk","from_school":"You have been invited to Docendo at %{school_name}.","hello":"Hello %{email}","regards_html":"<p>Regards,<br/>\nThe Docendo Team<br/>\nhttps://docendo.co</p>","someone_invited_you":"To accept the invitation click the link below","subject":"Invitation instructions"},"reset_password_instructions":{"change_my_password":"Change password","change_password_link_requested":"You can change your password through the link below. ","greeting":"Hello","wont_change":"Without any action, your password will not be changed. "},"unlock_instructions":{"click_the_link_below_to_unlock_your_account":"Click link below to unlock your account.","unlock_my_account":"Unlock my account.","your_account_has_been_locked_due_to_an_excessive_number_of_unsuccessful_sign_in_attempts":"Your account has been locked due to an excessive number of unsuccessful sign in attempts"}},"passwords":{"edit":{"change_my_password":"Change my password","change_your_password":"Change your password","confirm_new_password":"Confirm new password","new_password":"New password"},"new":{"forgot_your_password":"Forgot your password?","send_me_reset_password_instructions":"I want to receive instructions how to reset my password."}},"registrations":{"edit":{"are_you_sure":"Are you sure?","cancel_my_account":"Cancel my account","current_password":"Current password","password":"password","password_confirmation":"confirm password","update":"Update"}},"sessions":{"new":{"brugernavn":"User name","create_a_free_trial":"Create free trial","kodeord":"Password","log_ind":"Log in","log_ind_med":null,"log_ind_med_mail_og_kodeord":"Log in with e-mail and password","log_ind_på_docendo":"Log in","no_account":"Don't have an account?"}},"shared":{"links":{"didn":"Didn't receive instructions?","didn_2":"Didn't receive unlock instructions?","forgot_your_password":"Forgotten your password?","sign_in":"Log in","sign_up":"Sign up"}},"unlocks":{"new":{"resend_unlock_instructions":"Send unlock instructions again"}}},"events":{"event_debug":{"brugere":"Users:","ejerkalender":"Original calendar:","grupper":"Groups:","kalendre":"Schedules:","lokaler":"Locations:"},"replace_room":{"erstat_fremadrettet_på_dette_fag":"Replace from date onwards","og_resten_af_året":"and the rest of the year?","på":"on"},"replace_user":{"erstat_fremadrettet_på_dette_fag":"Replace from date onwards on this subject","klik_her_for_at_gå_til_kalenderen_for":"Click here to go to the schedule for","med":"With:","og_resten_af_året":"and the rest of the year?","på":"on"},"show":{"agenda":"Agenda","agenda_placeholder":"Example: 1. Follow-up on last meeting, 2. Mike will make a presentation of...","content":"Content","decisions_and_resume":"Decisions and summary","decisions_and_resume_placeholder":"Example: John will ask the teachers from...","denne_lektion_tæller_som":"This lesson counts as:","er_du_sikker":"Are you sure?","external_links":"My learning goals and courses","find_vikar":"Find substitute","gå_til_kalender_for_denne_lektion":"Go to schedule for this lesson","internal_notes":"Teachers/substitute notes","jump_to_calendar_for_event":"Go to calendar for this item","learning_goal":"Learning goal","location":"Location","meeting_purpose":"Purpose of the meeting","meeting_purpose_placeholder":"Example: Finalize content for...","only_visible_internally":"Visible only for teachers/staff","pupil_preparation":"Student preparation","slet_brik":"Delete item","slet_fra_denne_kalender":"Delete from this calendar only","substitutes":"Substitute","swappable_lessons":"The following lessons kan be switched around with the chosen lesson","søg_og_vælg":"Choose teacher","søg_og_vælg_vikar":"Search and choose substitute","teachers":"Teachers","undervisere_lokaler_noter":"Teachers","vacant":"Teacher and location vacant for the following subjects","vælg_klasser":"Choose grades/groups","vælg_lokation":"Choose location"},"show_public":{"agenda":"Agenda","content":"Content","decisions_and_resume":"Decisions and summary","external_links":"Learning goals","jump_to_calendar_for_event":"Go to calendar of this event","learning_goal":"What are our learning goals?","location":"Location","meeting_purpose":"Purpose of the meeting","pupil_preparation":"Student preparation","substitutes":"Substitutes","teachers":"Teachers"}},"groups":{"about":{"om":"About"},"admin":{"assign_hours_employees":"Assign hours","classes_and_subjects":"on grades/groups and subjects","more_tables":"See multiple schedules at the same time","show_to_parents":"Show to parents/students","status":"status","substitutes":"Substitutes ","supplement":"Supplement","year":"2016-2017"},"calendars_setup":{"copy_link":"Copy link","copy_link_table_insert":"Copy schedule link","docendo_extern_calendar":"Copy link and use in external calendar (iCal, Google Calendar, Outlook).","find_in_google_cal":"Guide: Docendo integration in external calendar","google_calendar":"Google Calendar","guide_integration_own_cal":"Guide: Docendo integration in external calendar","guide_setup_schoolport":"Setup guide","guide_setup_table_elevintra":null,"guide_step_copy":"Click on 'copy link' on the schedule you want to set up, and follow the instructions to the right.","ical_google_outlook":"iCal","integrate_tables":"Integrate schedules in iCal, Google or Outlook","links_for_each_class":"Distribute links to schedules individually by using the links below.","outlook":"Outlook","parentintra_seperate_class":null,"show_table_selected":"Show selected schedules","show_tables_elevintra":null,"substitutes_teachers_show_public":"Todays absent teachers","substitutes_teachers_show_public_explain":"Use link below to display information about absent teachers on info screen.","text_set_x":"Tick off the schedules you want shown through the link.","text_show_tables":"By pasting this URL on your website, students and parents will be able to view the schedules.","vaelg_alle":"Choose all"},"create_klass":{"evt_vaelg":"Do you want to import subjects and total amount of hours? Choose grade below:","import_af_fag":"Import subjects?","import_norm":"Do you want to import and set up subjects with corresponding assigned hours? Choose the grade corresponing to your grades/groups here:","klassens_navn":"Grade/group name","opret_en_ny_klasse_for":"Create new grade/group","skriv_klassens_navn":"Enter grade/group name"},"delete_popup":{"brikker_som_slettes_kun_fra_denne_kalender":"Items that will be deleted from this schedule","den_har":"It has:","denne_handling_kan_ikke_fortrydes":"This can not be undone.","indlæg_som_slettes":"posts that will be deleted","kalendere_som_slettes":"Schedules that will be deleted","lektioner_i_kalenderen":"lessons in the schedule","medlemmer_som_ikke_længere_vil_kunne_bruge_gruppen":"members that will no longer be able to use the group","skriv_slet_gruppen_herunder":"Write \"Delete group\" below:","slet_gruppen":"Delete group","uploadet":"uploaded"},"edit":{"redigér_gruppe":"Edit group"},"flextime":{"flextime":"Flexible hours","flextime_teacher_appear":"Only teachers using flexible hours will appear on the list."},"flextime_activator":{"aktivering_af_flextid":"Activation of flexible hours","aktiveringen_giver_alle_ansatte_brikker_til_flextid_i_deres_egen_kalender":"The activation give every employee the possibility of flexible hours in their calendars. ","aktivér_flextid":"Activate flexible hours"},"form":{"fejl_forhindrede_denne_gruppe_i_at_blive_gemt":"error prevented this group from being saved:","skriv_hvad_gruppen_hedder":"Enter the name of the group","skriv_om_gruppen":"Enter information about the group"},"hours":{"press_empty_bricks":"Click empty fields to create subject or adjust amount of subject hours."},"merge_calendars":{"merge_tables":"Shared calendars","new_merge_table":"Shared calendars"},"mine":{"ikke_medlem_af_nogen_grupper_endnu":"Not member of any groups yet."},"multical":{"help_for_table":null,"today":"Today","vaelg_klasse":"Choose grade/group","vaelg_lokale":"Choose location","vaelg_person":"Choose person"},"newother":{"fejl_forhindrede_denne_kalender_i_at_blive_gemt":"errors prevented this calendar from being saved:","opret_anden_kalender":"Create other calendar","opret_kalender":"Create calendar","skriv_evt_kalen":"Add something about the calendar","skriv_hvad_kalen":"Enter the name of the schedule..."},"pay_supplement":{"get":"Get","minutes":"Minutes","show_supplement":"Show supplement","supplement_type":"Type of supplement"},"school":{"video":"Video"},"schools":{"vælg_skole":"Choose school"},"show":{"bliv_medlem":"Become member","class_year":"grade/group/year","filer":"Files:","forlad_gruppen":"Leave group","gruppen":"group...","indlæg":"Posts:","opret_team":"Create team"},"substitute_pool":{"details":"Details","hours":"hours","mistakes_look":"errors, details below","notice":"Notice","notice_list_item_1":"Substitute hours are calculated as part of the total amount of teaching hours for the teacher.","notice_list_item_2":"Substitute lessons are displayed in the substitute's calendar as the name of the original lesson, eg. 'Math', 'Science'.","pool":"Pool","rest":"Remaining","substitute_hours_per_month":"Substitute hours used per month","substitute_overview":"Substitute overview","there_was":"There was","total_substitute_pool":"Total substitute pool:","total_used_substitute_hours":"Used substitute hours in total:","total_used_substitute_hours ":"Total used substitute hours:","used":"Used","vis_timer":"Show "},"users":{"ical":"iCal:","initials":"Initials","users":"Staff"}},"import":{"csv_overview":{"i_fil":"In file:","ikke-fundne_klasser_oprettes_i_skoleåret_hvor_der_importeres_til":"Grades/groupses not found will be imported to the school year which is currently being imported to. ","ikke-fundne_lokaler_oprettes":"Locations not found are being created","ikke-fundne_lærere_oprettes_med_initialer":"Teachers not found will be created by initials. ","ikke_fundet":"Not found","import":"Import","kontrollér_at_disse_er_rigtige":"Please check information for errors.","lagt_sammen":"Added together: ","lokaler":"Locations","lærerer":"Teachers","ringetider":"Phone hours","til_uge":"Until week: "},"result":{"der_var_nogle_fejl":"Error(s) occured","import_afsluttet":"Import finished","ingen_fejl_i_import":"No errors in import"}},"jobs":{"copy_events_year_job":{"calendar_is_copied":"The calendar %{calendar_name} has been copied"}},"js":{"all_day":"All day","calculating_and_controlling":"Copying and calculating...","changes_may_not_be_saved":"Changes you have made will not be saved","click_keyboard_shortcuts_to_copy":"To copy: ⌘ + C or ctrl + C","close_without_saving":"Close without saving?","copied":"Copied!","error_occured":"An error has occured."},"layouts":{"application":{"dage":"days","der_er_ikke":"Connection lost! Check your internet connection.","din_profil":"Your profile","hjem":"Home","kurser":"Courses","køb_nu":"Buy now","log_ud":"Log out","profil":"Profile","prøveperiode_slutter_om":"Trial ends in","skal_slettes_for_sig_selv":"must be deleted on its own. ","skift_kodeord":"Change password","slet_indlæg":"Delete post","soeg":"Search","vil_du_deaktivere":"Do you want to deactivate the school?","Ønsker_du_at_slette_dit_indlæg":"Do you want to delete your post?"},"blank":{"der_er_ikke":"There's not"},"devise":{"book_en_gratis_demo":"Book a free demo","docendodk":null,"kontakt":"Contact","log_ind_med":"Log in with","log_ind_med_email":"Log in (E-mail)","login":"Login","med_en_fuldt_integreret":null,"om_docendo":"About Docendo","om_os":"About us","tlf_70_40_02_10":"Phone: (+45) 70 40 02 10","udviklet_i_samarbejde_med_ledere_lærere_og_pædagoger":null,"uni":null},"public":{"skal_slettes_for_sig_selv":null,"slet_indlæg":"Delete post","Ønsker_du_at_slette_dit_indlæg":"Do you want to delete your post?"},"schools":{"users":{"create_user_by_alias":"Create fictional staff member","create_user_by_email":"Create user with e-mail","create_user_by_unilogin":null,"merge_users":"Merge users","transfer_calendar":"Transfer calendar (periodic)"}}},"materials":{"details":{"antal_downloads":"Amount of downloads:","beskrivelse":"Description:","detaljer_om_filen":"About the file","dialog_om_filen":"Dialogue about the file","dokumenttype":"Type of document","klassetrin":"Grades:","status":"Status:","uploadet_af":"Uploaded by:"},"edit":{"redigér_fil":"Edit file","vis":"Show"},"form":{"dit_materiale_er_gemt":"Your material has been saved","fejl_forhindrede_dette_materiale_i_at_blive_gemt":"error(s) prevented this materiale from being saved:","filnavn":"File name:","gem_materiale":"Save material","skriv_noget_relevant":"Write something relevant","titel_på_fil":"Title","venligst_udfyld_nogle_informationer_om_materialet":"Please enter information about the item","vælg_dine_fag":"Choose your subjects","vælg_dokumenttype":null,"vælg_dokumenttyper":"Choose document types","vælg_klassetrin":"Choose grade","vælg_status":"Choose status"},"index":{"antal_hentede":"Downloaded number of times","klassetrin":"Grade"},"material":{"fra":"from","mere_info":"More info","uploadet_af":"uploaded by"},"new":{"gem_materiale":"Save"},"new1":{"attach_files":"Attach files"},"popedit":{"dit_materiale_er_gemt":null,"erstat_materiale":null,"fejl_forhindrede_dette_materiale_i_at_blive_gemt":null,"gem_materiale":null,"giv_nogle_informationer_om_materialet":"Enter information about the material","vælg_dine_fag":"Choose your subjects","vælg_dokument":"Choose document types","vælg_klassetrin":"Choose grade","vælg_status":"Choose status"},"show":{"beskrivelse":"Description:","group":"Group:","post":"Post:","tags":"Tags:","user":"User:"},"sidebar":{"nyeste":"Newest","populære":"Popular","se_alle":"Show all"},"upload":{"del_et_materiale":null,"upload":"upload.","vælg_et_dokument":"Choose a document"}},"models":{"calendar":{"beregn_timer":"Calculate time","flex_ind":"Flex in","flex_ud":"Flex out"},"group":{"alle":"All","already_created":"has already been created","share_with":"Share with","skolen":"The school","team":"Team","ukendt":"unknown"},"group_school":{"importerede":"Imported","med":"with","oprettede_klasse":"Created grade/group","oprettede_lærer":"Created teacher","uden_lærer_i":"without teacher in"},"import_lesson":{"invalid":"Invalid"},"material":{"skal_vælges":"Must be chosen"},"pay_supplement_rule_school_camp":{"lejrskole":null},"pay_supplement_rule_substitute":{"ekstern_vikar":"External substitute"},"post":{"synes_godt_om":"Like"},"subject_period":{"timer_uge":"Hours/week"},"user":{"ukendt":"unknown"}},"notifications":{"form":{"indhold":"Contents:","link_https__skal_tilføjes_hvis_linket_er_eksternt":null,"notifikationer":"Notifications","overskrift":"Title:"},"index":{"notifikationer":"Notifications","opret_ny":"Create new","siden":"ago"},"notification":{"siden":"ago"},"show":{"brugere":"users","link":"Link:","læst_af":"Read by","notifikationer":"Notifications","sendt_til":"Visible to","sidst_opdateret":"Last updated:","skrevet_af":"Posted by"}},"posts":{"edit":{"redigér_indlæg":"Edit post","vis":"Show"},"form":{"del_noget":"Write something...","fejl_forhindrede":"errors prevented this post from being saved","tilføj_kommentar":"Add comment..."},"new":{"nyt_indlæg":"New post"},"post":{"antal_downloads":"Number of downloads","comments":"Comments","from":"from","show":"Show","since_in_group":"ago in group","slet_indlæg":"Delete post"},"show":{"bruger":"User:","indhold":"Contents:"}},"rack_dev_mark":{"development":"development"},"repitition":{"add":"Add","administration":"Administration","aktivitet":"Activity","all_calendars":"All calendars","annuller":"Cancel","archive":"Archive","brikker":"Activities","brugeradministration":"User management","calendaradministration":"Calendar administration","choose":"Choose","chooselanguage":"Choose language","create":"Create","dagens_fraværende":"Absent today","dagens_vikarer":"Substitutes today","dearchive":"Unarchive","delete":"Delete","deleting":"Deleting","din_kalender":"Your schedule","docendo":"Docendo - flexible scheduling","email":"E-mail","enddate":"End date","endtime":"End time","errors":"errors","fag":"Subjects","feriekalender":"Holiday calendar","fjern":"Remove","fjern_brugere":"Remove users","flextidsoversigt":"Overview of flexible hours","fra_og_med":"from","from":"from","gem":"Save","hour":"hour","timeopgoerelse":"Hours statement","kalender":"Schedule","klass":"grade/group","klasser":"Grades/ groups","klasser_lille":"grades/groups","kr":null,"langfravær":"Prolonged absence","lesson":"the lesson","luk":"Close","materialer":"Materials","medlem":"member","medlemmer":"members","merge_calendar":"shared calendar","merge_calendars":"shared calendars","målstyring":null,"navn":"name","none":"None","opgaveoversigt":"Task overview","opret":"Create","opret_brik":"Create subject","opret_fraværsgrund":"Create absence reason","opret_tilføj_bruger":"Add user","oprettet":"Created:","other_calendar":"other calendar","other_calendars":"other calendars","planlægning":"Planning","processing":"Processing","rediger":"Edit","replace":"Replace","replace_lesson":"Replace lesson","room":"location","rooms":"locations","se_kalender":"See schedule","search":"search","search_for":"search for","select_user":"Select user","send":"Send","show":"Show","skema":"Schedule","skemaoverblik":"Schedule overview","skole":"School","skoler":"Schools","skoleår":"School year","skriv":"...","startdate":"Start date","starttime":"Start time","substitute":"Teacher substitutes","superadmin":"Superadmin","support":"Support","swap":"swap","swap_lesson":"Swap lesson","tilbage":"Back","tildel_timer":"Assign hours","timefordeling":"Subject hours","timer":"Hours","timeudtraek":"Activity overview","titel":"Title","today":"Today","unauthorized_access":{"help":"Your user is not associated with a school on Docendo. Please contact your school administration.","no_access":"You don't have access."},"until":"until","user":"user","users":"users","vikardækning":"Substitutes","vikarpuljer":"Substitute pools","vis_skemaer_til_elever":"External view","with":"with","yearplan":"Year planning","Årsoverblik":"Year overview","år":"Year","årsplanlægning":"Year planning"},"rooms":{"create_room":"Create room","edit":{"er_du_sikker":"Are you sure?","redigér_lokale":"Edit location","slet_lokale":"Delete location"},"form":{"fejl_forhindrede_dette_lokale_i_at_blive_gemt":"error(s) prevented this location from being saved:"},"new":{"nyt_lokale":"New location"},"room_is_not_created":"Room does not exist","rooms":{"new_room":"New location","rooms":"Locations"}},"schools":{"calendar_transfers":{"new":{"activity_count":"Activities","from_date":"From","have_calendar":"Has a calendar ","including_both":"start & end dates included","period":"Period","receive_calendar":"Will receive calendar ","replacee_in_period":"Takes over the schedule","replacement_in_period":"Temporary replacement","title":"Let a user take over another user's calendar activities - eg. in case of maternity leave etc.","to_date":"Until","transfer":"Transfer","transfer_calendar_for_a_period":"Transfer calendar","warning":"Can not be undone."}},"onboarding":{"administration_and_counting":"Administration and counting ","assign_user_hours":"Assign hours to teachers","create_calendars":"Create schedules","create_classes":"Create grades/groups","create_fixed_hours":"Create shared calendars","create_merge_calendars":"Create shared calendars","create_other_calendars":"Create other calendars","create_rooms":"Create locations","create_school_year":"Create school year","create_teachers":"Create teachers","create_your_school":"Setup of your school","follow_the_steps":"Follow these steps to get started","import_of_schedules":"Import of existing schedules?","import_of_schedules_content":"If wanted, we'll import your existing schedules from a CSV-file. Send us a mail, and you'll receive instructions.","make_room_bindings":"If wanted, add location","scheduling_classes_calendars":"Scheduling grades/groups","select_vacationdays":"Enter vacation days","show_calendars_to_students":"Make schedules available to students/parents.","student_scheduling":"Create grade/group schedules","user_tasks":"Task overview for teachers"},"user_merges":{"new":{"merge_on_this_user":"Merge on this user","title":"Merge users in case of two similar users etc. All scheduled activities will be merged on one user.","warning":"Merge can't be undone."}},"users":{"index":{"actions":"Actions","help":"Click on picture to insert new picture. Initials are editable. ","photo":"Photo"},"user":{"invite":"Invite","remove":"Remove"}}},"search":{"post":{"siden_i_gruppen":"ago in the group"},"search_content_type_filter":{"alle":"All","grupper":"Groups","opdateringer":"Updates","profiler":"Profiles","vis_resultater_for":"Show results for"},"search_filter":{"filtre":"Filters","type_af_materiale":"Type of material","vælg_dine_fag":"Choose your subjects","vælg_dokumenttyper":"Choose document types","vælg_fag":"Choose subject","vælg_klassetrin":"Choose grade","vælg_status":"Choose status"},"search_results":{"antal_hentede":"Number of downloads","grupper":"Groups","klassetrin":"Grades","none":"We're sorry - no matches!","opdateringer":"Updates","profiler":"Profiles","viser_Res_for":"Show results for"}},"sidebars":{"get_started_new_year":{"assign_hours_employees":"Assign hours to employees","follow_steps":"Follow the steps below","get_started":"Get started","other_calendars":"other calendars","time_distribution":"Distribution of subjects and hours in grades/groups"},"school":{"other_calendars":"Other calendars (eg. team calendars)"},"substitution_links":{"assign_substitutes":"Assign substitutes","substitute_cover":"Substitutes"}},"signups":{"by_existing_users":{"new":{"already_user":"Can't log in? Contact your school administration to get access. ","try_free":"Try Docendo for free for 14 days"}},"new":{"create_signup":"Sign up","i_accept":"I accept","password_rule":"(at least 8 characters)","signup":"Create demo","terms_of_service":"Terms of service"}},"subject_periods":{"edit":{"antal_uger":"Weeks","fordel_timer_i_perioden":"Distribute lessons in the chosen period","opdatér":"Update","skoledage_i_perioden":"School days in this period","slet":"Delete","timer_i_perioden":"Hours in this period"}},"subjects":{"edit":{"arkiver":"Archive","arkiver_denne_brik_den_vil_ikke_længere_være_synlig":"Archive this item? It will no longer be visible.","arkiverer":"Archiving ","er_du_sikker":"Are you sure?","redigér_brik":"Edit","slet_brik":"Delete","vil_du_arkivere_denne_brik":"Do you want to archive this? It will no longer be visible."},"inner_edit":{"absence":"Absence","absence_description":"Reason of absence","anden_tid":"Other tasks","anden_tid_description":"not teaching.","antal_minutter_modul":"Enter the standard length (minutes) of subjects","antal_timer_på_år":"Enter amount of hours per year","bevægelse":"Exercise","bevægelse_description":"fully counting and independent from other activtites in the same period of time. ","fag":"Subject","fag_description":"counting hours for the grade/group. Two simultaneous activities counts as halves. ","fejl_forhindrede_denne_brik_i_at_blive_gemt":"errors occured","frame":"Theme","frame_description":"can be used for marking themes and special days in the grade/group schedule. The themed activity is visible for the pupils and parents, while grades/groups that are overlapping the themed activity will not be visible. Lessons are fully counting, and the themed activity is not.","klasser_andre_kalendre":"Classes/Other calendars","lokation":"Location","normal_varighed_i_minutter":"Standard duration (minutes)","oovrig_tid":"Additional tasks","oovrig_tid_description":"not grades/groups and teaching, non-pupil related.","optional":"Optional grades/groups","optional_description":"Fully counting and independent from other activities in the same time period.","pause":"Break","pause_description":"Subjects should not overlap with breaks.","ressource":"Ressource","ressource_description":"can be used to register ressources. Is not visible to students/parents.","skriv_et_bogstav_for_at_søge":"Search...","skriv_hvad_brikken_hedder":"Enter the name of the subject/event","sygdom_ferie_etc":"Sick leave, holidays etc.","timer_på_årsbasis":"Total hours (in school year)","underviser":"Teacher","uuv":null,"uuv_description":null,"vælg_briktype":"Choose subject type","vælg_farve":"Choose color","vælg_klasser":"Search and choose grades"},"new":{"ny_brik":"New subject"},"subject_accordion_menu":{"absence":"Absence","break":"Break","exercise":"Exercise","flextime":"Flexible hours","frame":"Theme","optional":"Electives","other_stuff":"Additional tasks","other_tasks":"Other tasks","pay_supplement":"Supplement","person_resource":"Ressource","resource":"Ressource","subject":"Subject","supplemental":"Supplement grades/groups"},"subject_draggable":{"hours_per_year":"h/year","per_week":"/week"},"ws_edit":{"er_du_sikker":"Are you sure?","opdater_brik":"Update subject","redigér_brik":"Edit subject","slet_brik":"Delete subject"}},"substitutes":{"edit":{"i_dag":"Today","ingen_lektioner_for":"No lessons for","klasse":"Grade/group","også_tilknyttet":"Also on this lesson","se_alle":"See all","se_mindre":"View less","søg_og_vælg":"Search and choose","vikar":"Substitute","vikar_for":"Substitute for","vikarnoter":"Substitute notes"},"known_absence":{"byt":"Swap","feriedage":"Holidays","fraværende_med_lektioner":"Absent teachers with lessons","kalenderen_for_7b":null,"kursus":"Course","lektioner":"lessons","lektioner_der_kan_byttes_med":"Lessons that can be swapped:","lektioner_der_skal_håndteres":"Lessons to be administered:","opret_fravær":"Add absence","opret_planlagt_fravær":"Enter absence","syg":null},"substitute_day":{"klasse":"Grade/group"},"substitutes_edit":{"fraværsårsager_og_skemaoverblik":"Absence reasons & schedule overview","tilføj_kalendre":"Add schedules","vælg_klasse":"Choose grade/group","vælg_lokale":"Choose location","vælg_person":"Choose person","vælg_person_vikardækning":"Choose person(s)"},"substitutes_show":{"ingen_vikarer_i_dag":"No substitutes today"},"substitutes_show_teachers":{"ingen_fraværende_i_dag":"There's nobody absent today"}},"time":{"formats":{"day_only":null,"devise":{"mailer":{"invitation_instructions":{"accept_until_format":"%B %d, %Y %I:%M %p"}}},"time_only":"%H:%M"}},"unilogin":{"welcome":{"create_a_trial":"Create a free trial?","eller":"or","enten_giver_din_stilling_dig_ikke_mulighed_for_at_kigge_med_eller_også_er_din_skole_er_ikke_på_docendo_endnu":"You do not have access to Docendo.","hvis_du_vil_have_din_skole_på_docendo_så":"If your school would like to use Docendo, then","kontakt_os":"contact us","prøv_en_demoperiode":"start a free trial","student_or_parent":"Are you a student or parent?","student_or_parent_info":"If you are looking for your own or your childs schedule, this should typically be found on the schools website. We recommend that you contact the school administration if you can't find the schedule.","velkommen":"Welcome"}},"users":{"assign_user_hours":{"anden_tid":"Other tasks","der_var":"There was","fejl_se_nedenfor":"errors. See details below.","lommeregner":"Calculator","skemalagt":"Scheduled","tildeling_af_timer":"Assign hours","tildelt":"Assigned","total_på_år":"Year total","undervisning":"Teaching","Øvrig_tid":"Additional tasks"},"create":{"add_user":"Add user","add_user_with_uni":null,"create_teacher":"Create teacher","fictive_user":"User without login","fictive_user_text":"The user can be used in scheduling but does not have a login. ","notify_user_more_users":"You must provide users with a message about the addition. You can enter multiple usernames in the field below, separated by spaces.","user_does_not_exist":"Teacher does not exist","user_with_email":"User with e-mail","user_with_email_text":"Add user with e-mail. The user can log in with e-mail and password. The user will receive instructions."},"edit":{"annullér":"Cancel","redigér_bruger":"Edit user"},"files_for_download":{"files_to_download":"Files to download"},"form":{"andre_undervisere_vide":"What would other teachers want to know about you?","beskrivelse":"Description","du_kan_skrive_om_dine_interesser_fag_klassetrin_færdigheder_etc":"you can write about your interests","email":"E-mail","fejl_forhindrede_denne_bruger_i_at_blive_gemt":"error(s) kept this user from being saved. ","fjern_profilbillede":"Remove profile picture","hvilke_fag":"Which subjects","hvilke_klassetrin_underviser":"(What grades do you teach?)","initialer":"Initials","initialer_på_skolen":"Initials","klassetrin":"Grades","opdatér_profil_fra_uni-c":null,"profilbillede":"Profile picture","skriv_dit_navn":"Enter your name","upload_nyt_profilbillede":"Upload new profile picture?","vælg_dine_fag":"Choose your subjects","vælg_dine_klassetrin":"Choose your grades"},"hours":{"skoleåret":"School year"},"hours_list":{"_vikartimer":"Substitute hours","min":"min","vikartimer":"Substitute hours"},"hours_status":{"anden_tid":"Other tasks","ingen_data":"No data","tildelt":"Assigned","undervisning":"Teaching","øvrig_tid":"Additional tasks"},"list_all":{"alle":"All"},"members":{"personale":"Staff","se_alle":"See all"},"net_promoter_scores":{"new":{"nps_question":"How likely is it that you would recommend docendo to a friend or colleague?","question_one":"What is the most important reason for your score?","reason":"We are making a scheduling tool for people. This is hard to do without the people using it giving us feedback on how to make it better. We hope you'll help us by answering the two following questions. ","very_likely":"Very likely","very_unlikely":"Not likely"}},"password":{"bekræft_nyt_kodeord":"Confirm new password","fejl":"error:","nyt_kodeord":"New password","skift_kodeord":"Change password"},"profile":{"klassetrin":"Grade","om_mig":"About me","underviser_i":"Teach in"},"remove_users_list":{"delete_user":"Delete user","press_remove_to_remove":"Click 'remove' to remove user from Docendo.","remove_list_item_1":"When a user is removed, he or she no longer has access to the school's calendars.","remove_list_item_2":"The user will NOT be removed from lessons.","remove_list_item_3":"The user will be deleted from the school."},"show":{"aktivitet":"Activity","filer":"Files:","grupper":"Groups","indlæg":"Posts:","medlem_i":"Has been a member for:"},"si_teachers_list":{"træk_læreren_fra_venstre_til_højre_for_at_tildele_initialer":"Drag the teacher from left to right to assign initials"},"substitute":{"følgene_lærere_er_ledige_i_tidsrummet":"The following teachers are available in this time.","ingen_lærere_er_ledige_i_tidsrummet":"No teachers are available in this time.","kl":null,"vælg_vikar":"Choose substitute"},"tasks_status":{"fag_opgave":"Subject/task","lagt_i_skema":"Scheduled","tildelt":"Assigned","tilhører":"Belongs to","total":"Total"},"user_item_abandoned_user":{"grupper":"Groups:","indlæg":"Posts:","kalenderaftaler":"Items in calendar:","material_count":null},"user_item_profile_calendar_lastseen":{"se_profil":"View profile","se_tildeling":null},"user_item_remove_user":{"delete_user":"Delete user"},"user_item_select_substitute":{"vælg_som_vikar":"Choose as substitute"},"user_merge_details":{"aftaler":"Scheduled items","groups":"Schools"}},"views":{"pagination":{"first":"First","last":"Last","next":"Next","previous":"Earlier","truncate":"..."}},"vue":{"buy":{"a_user_is":"A user is an employee who has a calendar and/or a login.","billed_monthly_or_yearly":"Monthly of yearly billing?","buy":"Buy","buy_access_for_school_users":"Buy acess for school staff","call_us_at":"Call us at","choose_the_right_price":"Choose the right price for your school","discount":"Discount","error":"Error","go_to_home":"Click here for 'Home'","institution":"institution","missing_inputs":"You need to fill in all of the fields.","month":"month","only_pay_per":"Only pay for the users able to make schedules and/or have a login.","pay_for_unlimited_users_and_get":"Pay for the schools total number of students, and get an unlimited number of users on","payment_info":"Payment info","per_month":"Per month","per_student":"per student","per_user":"per user","per_year":"Per year","popular":"popular","price":"price","questions":"Questions","save_2":"Save 2%","school_name":"School name","subscription_info":"Subscription info","thanks_for_buying":"Thanks for your purchase.","total":"Total","total_student_number":"Total number of students","unlimited":"Unlimited","write_number_of_students":"Enter the total number of students - gain access for unlimited amount of users.","write_number_of_users":"Enter the total amount of users that will be used in scheduling or will have access to Docendo *","your_email":"Your e-mail","your_invoice":"Your invoice","your_name":"Your name","your_phonenumber":"Your phone number"},"deleteday":{"delete_day_or_week":"Delete day/week","whole_week":"Whole week"},"intro_home":{"step1_title":"Welcome to Docendo","step3_title":null,"step4_content":null,"step4_title":null,"step5_content":null,"step5_title":null},"public":{"app":{"sidenav":{"changeview":"Change view","showday":"Show day","showweek":"Show week","showweekplan":"Show weekplan"}},"no_notes":"No notes for the week"},"recent_users":{"last_seen":"last seen","never_logged_in":"never logged in"},"sidenav":{"merge_calendar_special":"shared calendars"},"vacations_days_selector":{"choose_period":"Choose period","school_days":"school days","school_year":"school year","vacation_for_pupils":"School year and holidays"},"year_planning":{"distribute_hours_over_year":"Distribute hours","hours_during_period":"Hours","norm":"Assigned","number_of_weeks":"Amount of weeks","planned":"Planned","school_days_during_period":"School days during period"}}}}

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

	module.exports = {"a11y":{"mainNav":"Main navigation","openMenu":"Open menu","closeMenu":"Close menu","changeSchool":"Change school","clearSearch":"Clear search","showStudents":"Show/hide students","close":"Close","loading":"Loading"},"copycalendar":{"copy":"Copy","paste":"Paste","pasteThisWeek":"Paste in this week","weekSelected":"week selected","weeksSelected":"weeks selected","markWeeksFrom":"Select weeks from","allWeeks":"All weeks","oddWeeks":"Odd weeks","evenWeeks":"Even weeks","unselectAll":"Unselect all","deleteLessonsInSelectedWeeks":"Delete and replace lessons in selected weeks","absenceWillNotBeDeleted":"absence will not be deleted","noticationMessage":"Inserting...","copiedFrom":"Copied from","noSubstitutesOrNotes":"There are no lessons with substitutes or notes in the selected weeks","youAreAboutToDelete":"You are about to delete","lesson":"lesson","lessons":"lessons","withSubstitutesOrNotes":"with substitutes or notes","week":"week"},"homevideoes":{"video":"Video","video_guide":"Video guides","introduction":"Introduction to Docendo","watch_intro":"See intro to Docendo","klass_schedule":"Grade/group timetable","klass_schedule_overview":"Overblik over klasseskemaet","teacher_calendar":"Teacher's schedule","teacher_calendar_overview":"About the teacher schedule","notes_weekplan":"Notes & week plan","notes_weekplan_overview":"Use notes & week plans","learn_to_substitute":"Learn how to manage substitute teachers"},"vSelect":{"choose_persons":"Select user(s)"},"substitute_hours":{"title":"Show events for teachers","choose_period":"Choose period","all":"All","teaching":"Teaching","substitute_hours":"Substitute hours","absence":"Absence","work_days":"day(s)","lessons":"lesson(s)","calendar_event":"calendar event","calendar_events":"calendar events","substitute_for":"Substitute for","substitute_hour":"Substitute hour","other_tasks":"Other tasks","other_stuff":"Other stuff","total":"Total","hours":"hours","hour":"hour","min":"min","shortcuts":"Shortcuts","show_all_absent":"Show all absent during the period","getting_all":"Getting all","absent_in_the_period":"absent during the period","there_is_no_one_absent":"There are no absences during the period","days_with_absence":"Days with absence"},"notifications":{"notifications":"notifications","all":"All","unread":"Unread","mark_all_as_read":"Mark all as read","sent_from":"Sent from","mark_as":"Mark as","read":"Read","not_read":"Unread","no_new_notifications":"No new notifications"},"presence":{"work_hours":"Working hours","set_work_hours":"Enter your working hours","choose_weeks_for_work_hours":"Choose weeks","work_hours_in_the_week":"Total hours in week","cancel":"Cancel","copy_to_multiple_weeks":"Copy to multiple weeks","back":"Back","save":"Save","times_may_not_overlap":"Times may not overlap","hours":"hours","minutes":"min","h":"h","m":"m","present":"Present","not_present":"Not present","total_working_hours":"Working hours for the year","edit_default_times":"Edit default times","default_work_hours":"Default working hours"},"createusers":{"create_users":"Create staff member(s)","login_options":"Login option(s)","can_be_added_later":"can be added later","must_be_added":"Is required","name":"Name","mail":"email","placeholder_name":"Name Lastname","placeholder_email":"name@schoolmail.com","email_error_text":"It doesn't look like an email address","add_more":"Add more","create":"Create","user":"staff member","users":"staff members","user_created":"Staff member created!","users_created":"Staff created!","feide_is_already_used_for":"Feide is already used for"},"createuser_button":{"create_user":"Create staff member"},"toast":{"something_went_wrong":"Something went wrong"},"subject":{"azure":"Azure","blue":"Blue","bronze":"Bronze","brown":"Brown","coral":"Coral","grey":"Grey","green":"Green","purple":"Purple","lightblue":"Light blue","lightblue2":"Lighter blue","lightbrown":"Light brown","lightgreen":"Light green","lightyellow":"Light yellow","lightyellow2":"Lighter yellow","lightpurple":"Light purple","lightred":"Light red","marinoblue":"Navy","darkblue":"Dark blue","darkgreen":"Dark green","darkyellow":"Dark yellow","darkpurple":"Dark purple","darkorange":"Dark orange","darkorange2":"Darker orange","orange":"Orange","red":"Red","red2":"Dark red","turkis":"Turquoise"},"createklass":{"create_klasses":"Create grade(s)/group(s)","schoolyear":"School year","klass_name":"Grade/group name","klass_step":"Grade/group step for import of courses (optional)","import_subjects_question":"Do you want to import subjects for this grade/group?","import_subjects_done":"These subjects will be created in the grade/group","subjects_for":"Courses for","klass":"grade/group","klasses":"grades/groups","hoursPrYear":"h/year","grade":"grade","warning_text":"Grades/groups can't have the same name","succes_text":"(s) created!","creating":"Creating","import_subject_to_the_klass":"Import courses into grades/groups","subjects_created_successfully":"Courses are created"},"createrooms":{"create_rooms":"Create location(s)","room_name":"Location name","placeholder":"Science classroom","room":"location","rooms":"locations","warning_text":"Locations can't have the same name","succes_text":"Location(s) created!","creating":"Creating"},"createroom_button":{"create_room":"Create location"},"editCalendarEditName":{"edit_name":"Edit name","calendar_name":"Calendar name","warning_text":"Name can not be empty","update_name":"Update name","success_text":"Name is updated!"},"editCalendarMenu":{"edit_name":"Edit name","delete_calendar":"Delete calendar","remove_calendar":"Archive calendar","delete_klass":"Delete class","delete_club":"Delete club","delete_kindergarten":"Delete kindergarten room","remove_room":"Archive location","remove_merge":"Archive shared calendar","view":"View","5_days":"5 days","7_days":"7 days","7_days_and_24_hours":"7 days, 24 hours","lock":"Lock calendar","unlock":"Unlock","calendar_is_locked":"Calendar is locked","merge_with_merge_calendars":"Merge with shared calendars","merge_with_calendar":"Merge into calendar","is_merged":"Is merged into","can_be_merged_into":"Can be merged into","see_public_view":"View student display","active_public_view":"Activate student display","show_grid":"Show grid","hide_grid":"Hide grid"},"editCalendarDelete":{"delete_calendar":"Delete calendar","deleting_this_calendar":"You are about to delete this calendar","all_data_will_be_deleted":"All calendar activities will be deleted PERMANENT, and data can not be restored.","validator_name":"delete calendar","write":"write","if_you_want_to_delete":"if you want to delete this calendar","you_have_to_write":"You have to write","success_text":"Calendar deleted"},"setupWidget":{"do_steps_for_scheduling":"Follow these 4 steps to get started","get_going_easy":"Quick Guide","follow_these_steps":"Follow the tutorials in the videos","write_us":"Chat with us","support_forum":"Support forum"},"createmerge":{"create_merge":"Create shared calendar(s)","name":"Name","placeholder":"Breaks","calendar":"calendar","calendars":"calendars","warning_text":"Calendars can not have the same name","succes_text":"Calendar(s) created!"},"sidenav":{"not_created_klass":"You have not created any grades/groups","not_created_users":"You have not created any staff members","not_created_rooms":"You have not created any classrooms/locations","not_created_merge":"You have not created any merge calendars","not_created_other":"You have not created any other calendars"},"year_transfer":{"copy_klasses_from":"Copy calendars from the school year","to":"to","copy_nothing":"Do not copy","klass_name":"Calendar name","klass_name_desc":"Copy a calendar with the same name to the new school year, without courses.","klass_name_and_subjects":"Calendar name and courses, incl. requiered hours of instruction.","klass_name_and_subjects_desc":"Copy a calendar with the same name and courses to the new school year, incl. requiered hours of instruction.","klass_name_and_subjects_with_teachers":"Calendar name and courses, incl. requiered hours of instruction, aswell as teachers and classrooms.","klass_name_and_subjects_with_teachers_desc":"Copy a calendar with the same name and courses, incl. required hours of instruction. Teachers and classrooms attached to the courses will also be copied.","choose_all":"Choose all","img_src_one":"http://support.docendo.dk/img/transferyear/1EN.png","img_src_two":"http://support.docendo.dk/img/transferyear/2NO.png","img_src_three":"http://support.docendo.dk/img/transferyear/3EN.png","year_transfer_link":"Do you want to create grades/groups with names and subjects from last school year? click here","from_week_33_in":"from week 33 in","to_week_33_in":"to week 33 in","klass_name_and_subjects_with_teachers_and_schedules":"Grades/groups and courses incl. requiered hours of instruction and associated teachers, classrooms and schedules","calendar_already_exist":"the calendar already exists","everything_is_copied_except":"Everything is copied except associated grades","everything_is_copied_except_tooltip":"If there are more than one class associated with the pieces, these will not be copied as the associated classes belong to the previous school year","and_schedules":"and schedules","from_week":"From week","to_week":"To week"},"assign_users_hours":{"assign_hours":"Assign hours","search_a_name":"Search by name","work_hours":"Working hours","teaching":"Teaching","substitute_hours":"Substitute hours","absence":"Absence","name":"Name","assigned":"Assigned","scheduled":"Scheduled","diff":"Difference","update":"Update numbers","applies_to_the_period":"Applies to the period","tasks":"Tasks","preparation":"Preparation"},"tagging":{"tagging_users":"Grouping of staff members","users_selected_from":"Staff selected from","add_tag_to":"Add tag to","select_persons_first":"Select staff members first","select_all":"Select all","unselect_all":"Unselect all","already_created":"Already created","example_tags":"Eg. Teachers, Teams, Substitutes","create_tag":"Create tag","search_tag":"Select group","create_tags":"Create tags","with":"with","you_have_created_zero_tags":"You have created 0 tags"},"dselect":{"no_matching_results":"No matching results","placeholder":"Search for a staff member","create_user":"Create staff member,","in_same_klass":"In same grade/group","placeholder_calendars":"Search and select"},"substitution":{"substitution":"Substitutes","none_absent":"No absence","number_absent_today":"Number of teachers absent","today":"Today","create_absence":"Add absence","who":"Who","person_must_be_filled":"Name must be filled in","reason":"Reason for absence","choose_absence_reason":"Choose reason for absense","create":"Add","reason_must_be_filled":"Reason must be filled in","date":"Date","time":"Time","absent_period":"Period of absence","do_you_want_to_delete_the_absent_reason":"Do you want do delete reason of absence","yes":"Yes","cancel":"Cancel","substitutes_will_not_be_removed":"Substitutes on lessons will not be deleted. These can be deleted beforehand.","subject":"Subject","class":"Grade/group","other_users":"Other staff members","substitute":"Substitutes","substitute_notes":"Substitute notes","todays_lessons":"Todays lessons","see_all":"View all","see_less":"View less","absence_is_created_in_a_calendar":"Ansence is added in a calendar, and has to be deleted from this calendar.","go_to_calendar":"Go to calendar","deleting_absence_from":"Delete absence from","to":"to","choose_absence_user":"Choose absent teacher","absence_notes":"Note for absence","add_sub_to_several_lesson":"Add substitute to several lessons","find_sub_for":"Find substitute for","lessons":"lessons","finding_available_subs":"Searching for available substitutes","select_lessons_to_substitute":"Select lessons to substitute","overlap":"overlap","available":"Available","working_hours":"Working hours","busy":"Busy","do_you_want_to_save":"Do you want to save","no_close_without_saving":"No, close without saving","yes_save_my_changes":"Yes, save my changes","lessons_updated":"Lessons updated","lessons_without_sub":"Lessons without substitute","lessons_with_sub":"Lessons with substitute","all_lessons":"All lessons","no_lessons_without_subs":"No lessons without substitute","no_lessons_with_sub":"No lessons with substitute","no_lessons":"No lessons","remove_sub_from_all_lessons":"Remove as a substitute for all lessons","do_you_want_to_remove":"Do you want to remove","as_sub_on":"as a substitute on","or_on_all_lessons":"or on all lessons","remove_from_all_lessons":"Remove from all lessons","just_this_lessons":"Only this lesson","choose_period_lessons":"Select a period to view lessons","from_selected_date_onwards":"From the selected date onwards","entire_period":"The entire period","selected_date":"Selected date","lessons_that_overlap_in_class":"Also in grade/group","delete_lesson":"Delete lesson","settings":"Settings","include_reservations":"Include reservations in substitute coverage","show_overlapping_class_badge":"Show + icon for people simultaneously in the class"},"substitution_user":{"multiple_days":"Multiple days","lessons_on_day":"Lessons this day","lessons_affected_by_absence":"Lessons affected by absence","absent":"Absent"},"substitution_show":{"show_all_lessons":"View all lessons","show_the_absent":"View absence","lessons":"Lessons","choosen_lessons":"Selected lessons"},"sub_scheduler":{"filter_substitutes":"Filtrate substitutes","sub_pools":"Substitute pools","todays_absent":"Todays absence","potential_subs":"Potential substitute","choose_sub":"Select substitute","status":"Status","sort_after":"Sort after suggestions","set_priorities":"Set priorities","sorting_will_be_based_on":"Sorting based on","has_canceled_hours":"Has canceled hours in the time slot","already_on_lesson":"Additional teachers on same lesson","is_in_same_class_at_the_same_time":"Is in the same grade/group at the same time","has_hours_in_class_on_day":"Has lessons in the same grade/group on the day","multiple_lessons_in_same_classes":"+2 teachers simultaneously in another grade/group","not_occupied_with_available_lesson":"Available with 'On-Call'-event","not_occupied_with_work_hours":"Available within working hours","not_occupied_without_work_hours":"Available outside working hours","not_occupied_without_lessons_on_the_day":"Available w/o any lessons","occupied":"Occupied","occupied_in_selected":"Occupied in {occupied} of {total}","it_will_also_be_sorted_based_on_tags_in_common":"The sorting also takes into account the number of tags in common with the absent teacher.","absent_people":"Absent","substitutes":"Substitutes","out_of":"out of","potential_substitutes":"Potential substitutes","pool":"Pool","choose_filters":"Select filters","list":"List","schedules_overview":"Schedules","is_substituted":"Is substituted"},"sub_scheduler_item":{"prolonged_absence":"Prolonged absence","also_on_lesson":"Also in lesson"},"sub_scheduler_popover":{"substitute_for":"Find substitute for","handled":"Covered","not_handled":"Not handled","handled_for_absence":"Handled for all absentees","pending":"Pending"},"sub_scheduler_sub_pools":{"substitute_hours":"Substitute hours","difference":"Difference","assigned":"Assigned","scheduled":"Scheduled"},"IEWarning":{"you_are_using_a_IE_or_Edge_to_get":"NB! You are using Internet Explorer/Edge. To get","a_faster_and_better_experience":"a faster and better experience","we_recommend_that_you_switch_to_these_browsers":"we recommend switching to","or":"or"},"dashboard":{"welcome":"Welcome","start_by_setting_up":"Start by setting up","steps_completed":"Steps completed","step":"Step","tutorial":"Tutorial","follow_the_steps":"Follow the quick guide"},"delete_day_or_week":{"cant_delete":"Couldn't delete. Try again."},"user_event_list":{"absence":"Absence","teaching":"Teaching","substitute_hours":"Substitute hours","from":"from","to":"to","no_matching_events":"List is empty","total":"Total","close":"Close"},"weekplan_2":{"no_events_this_week":"No lessons this week"},"event_form":{"delete_events_onward":"Delete this and on same timeslot forward","are_you_sure":"Are you sure?","do_you_want_to_delete_this_and_all_in_same_timeslot":"Would you like to delete this lesson and all that lie on the same day of the week and in the same time period going forward?","cancel":"Cancel"},"calendar_export":{"export_calendar":"Export calendar","export_calendar_to":"Export calendar to ...","copy_the_url_and_insert":"Copy this URL and paste it into the external calendar","guide_to":"Guide to","guide_to_export_calendar":"Guide on how to export to Outlook, Google or iCalendar,","create_a_link_on_mobile":"Setting up class schedules on mobile"},"common":{"groups":"Groups","search":"Search","show_print_hours":"Show calculated hours","show_as_blocks":"Show as blocks","show_as_table":"Show as table","show_as_list":"Show as list","add":"Add","save":"Save","saved":"Saved","dont_save":"Don't save","create":"Create","cancel":"Cancel","update":"Update","delete":"Delete","select":"Select","edit":"Edit","yes":"Yes","no":"No","save_changes":"Do you wish to save your changes?","ago":"ago","min":"min","class":"Grade/group","classes":"Grades/groups","classes_sidenav":"Grades/ groups","teacher":"Teacher","room":"Room","substitute":"Substitute","rename":"Rename","add_user":"Add staff member","press":"Press","user":"Staff member","users":"Staff","rooms":"Locations","shared_calendars":"Shared calendars","merge_calendar":"Shared calendar","merge_calendars":"Shared calendars","merge_calendars_sidenav":"Shared calendars","other_calendar":"Other calendar","other_calendars":"Other calendars","close":"Close","must_be_filled":"Required","something_went_wrong":"Something went wrong","show_weekends":"Show weekends","calendar":"Calendar","in":"in","search_for":"search for","remove":"Remove","none_created":"Ingen opprettet","log":"Activity log","no_calendars_found":"No calendars found..","done":"Done","is_deleted":"is deleted","choose_school":"Choose school","no_active_school_years":"There are no active school years. Ask an administrator to open one.","show_more":"Show more","show_less":"Show less","search_name_or_initials":"Search name or initials","hide_calendars":"Hide calendars","hide_dates":"Hide dates"},"weeknote_log":{"saved_versions":"Saved versions of the weeknote Gemte versioner af ugenoten","activity":"Activity log","no_saved_versions":"No saved versions","choose_versions_to_compare":"Choose versions to compare","current_version":"Current version"},"show_event":{"this_lesson_counts_as":"This lesson counts as"},"permissions":{"can_edit_subject_requests":"Can request subjects (when Subject Requests are open)","can_see_other_subject_requests":"Subject requests – Can see others' requests","roles":"Roles","create_new_role":"Create new role","users":"Staff that are","users_assigned_role":"staff assigned role","add_user_to":"Add staff to","role":"role","permissions":"Permissions as","change_permissions_for_role":"Change permissions for role","rename_role":"Rename role","delete_role":"Delete role","give_role_a_title":"Give role a new name","choose_new_name":"Choose a new name","you_cant_delete_a_role_that_has_users":"You can't delete a role that has staff assigned","give_the_following_user_a_new_role":"Give the following staff a new role","can_change_substitution":"Can access Substitution Management","can_do_most_stuff":"Can do must stuff","can_edit_own_notes":"Can edit notes","can_export":"Can export data to Docendo ZEN","can_manage_absence_reasons":"Can manage absence reasons","can_manage_assigned_hours":"Can change Assigned Hours","can_see_assigned_hours":"Can see Assigned Hours","can_manage_school_years":"Can create and edit school years","can_manage_sms":"Can send SMS","can_manage_substitute_hours":"Can create, delete and edit substitute hours","can_manage_tasks":"Can manage tasks","can_manage_users":"Can create, edit and delete staff","can_see_other_calendars":"Can see schools calendars","can_manage_calendars":"Can create, edit and delete calenders","can_setup_aula":"Can change export to Aula","change_role":"Change role","role_desc_administrator":"An administrator can access all features and edit permissions for all roles.","role_desc_read_only_user":"A read only user can only access the user's own schedule, and the user can't edit anything or see other schedules. This role can be given the permission to edit notes from the user's own schedule.","role_desc_regular_user":"A regular user can access all schedules and most features, but the user can't add, edit or delete staff members and school years.","role_updated":"Role is updated","role_deleted":"Role is deleted","role_created":"Role is created","can_see_subjects_distribution_page":"Can access subjects distribution page","can_see_others_task_overviews":"Can see others task overview","can_see_own_task_overview":"Can see own task overview","can_change_task_overview":"Can choose whether subjects appear on the task overview","can_see_others_hour_overviews":"Can see others hours statement","can_see_own_hour_overview":"Can see own hours statement","can_edit_own_presence":"Can edit own working hours","can_edit_others_presence":"Can edit other working hours","can_edit_user_year_notes":"Can write and edit notes in others' task overview","can_send_substitute_email":"Can send emails","select_role_to_base_new_on":"Select a role to base the new one on","done":"Done"},"calendars":{"calendars":"Calendars","edit_calendars":"Delete / rename calendars","copy_calendars":"Copy calendars","archive":"Remove","show":"Show","hide":"Hide","archived":"removed","unarchive":"Restore","write_name":"Write name","selected_of":"selected by","select_calendars_to_copy":"Select calendars to copy","copy":"Copy","select_week_to_copy_from":"Select week to copy from","select_weeks_that_week":"Select weeks as week","must_be_copied_to":"must be copied to","print_calendars":"Print calendars","add_presence":"Add working hours","delete_events_in_date_range":"Delete events in date range","delete":"Delete"},"sms":{"sms":"SMS","do_you_want_to_delete_the_template":"Do you want to delete this template","template_sms_deleted":"Template deleted","an_error_occured":"There was an error","add_number":"Add mobile number","number_must_be_8_digits":"Mobile number must be 8 digits","number_deleted":"Mobile number deleted","number_added_awaiting":"Mobile number added. Awaiting approval","edit":"Edit","new":"New","standard_sms":"Template","title":"Title","to_show_in_list":"to show on the list","ex_you_are_sub":"Eg. \"You have new assignments as a substitute teacher...\"","insert_today_to":"Insert [today] in template for the name of today, eg.","updated_sms_template":"Updated template","created_sms_template":"Created template,","message":"Message","subject":"Subject"},"subs_ongoing_absence":{"delete_absence":"Delete absence","change_start_and_end_date":"Edit start/end date","ongoing_absence":"Ongoing absence","ongoing_absence_explained":"Continuous absence is automatically extended when the original end date is reached. The end date is the expected last date of absence. The absence is extended by one day at a time until you end the absence.","date_label":"Date (first/last date included)","absence_will_be_deleted":"Absence will be deleted","remove_subs_and_delete_absence":"Remove subs and delete absence","keep_subs_and_delete_absence":"Keep subs and delete absence","remove_subs_and_update":"Remove subs and update","keep_subs_and_update":"Keep subs and update","remove_subs_and_stop_ongoing_absence":"Remove subs and stop continuous absence","keep_subs_and_stop_ongoing_absence":"Keep subs and stop continuous absence","confirm_date_and_stop_ongoing_absence":"Confirm date and stop continuous absence","update_dates":"Update dates","checking_for_substitutes":"Checking for substitutes","lessons_with_substitutes":"Classes with substitute","no_subs_on_lessons":"No substitutes on the dates chosen for deletion of absence","of":"of","lessons_that_will_have_subs_removed":"classes where subs will be removed","select_all":"Select all","unselect_all":"Clear","remove_sub":"Remove substitute","teachers_with_ongoing_absence":"Continuous absent teachers","no_teachers_with_ongoing_absence":"No continuously absent teachers","absence_will_be_prolonged_in":"Will be extended in","edit_stop":"Edit / stop","subs_removed":"Substitutes removed","absence_deleted":"Absence deleted","auto_created_today":"Autogenerated today","absence_updated":"Absence updated","stop_ongoing_absence":"Stop continuous absence","cant_be_ongoing_absence":"Continuous absence cannot be created with an end date earlier than today's date","auto_created":"Autogenerated"},"zen_import":{"import_from_zen":"Import schedules from ZEN to Docendo","choose_version":"Choose version","you_have_no_created_any_versions":"You haven't created any schedules in Docendo ZEN","last_updated":"Last updated","choose_schoolyear":"Choose schoolyear","insert_in_week":"Insert in week","insert_schedules":"Insert schedules","week":"Week","schedules_are_being_inserted":"Schedules will be inserted into week","changes_from_import":"Changes from import","changes_from_import_help":"Review and undo the changes an import made to calendars and subjects.","no_imports":"No imports have been made yet","view_changes":"View changes","import_processing":"The import is being processed…","no_changes_in_import":"The import did not result in any changes","created_calendars_title":"Created calendars","changed_calendars_title":"Changed calendars","created_subjects_title":"Created subjects","changed_subjects_title":"Changed subjects","created_title":"Created","changed_title":"Changed","type_column":"Type","type_calendar":"Calendar","type_subject":"Subject","delete":"Delete","undo_change":"Undo change","confirm":"Are you sure?","yes":"Yes","cancel":"Cancel","done_deleted":"Deleted","done_reverted":"Undone","field_name":"Name","field_color":"Color","imported":"Imported","calendars_label":"calendars","subjects_label":"subjects","download_to_excel":"Download to Excel","excel_calendar":"Calendar","excel_field":"Field","excel_old_value":"Before","excel_new_value":"After"},"create_calendars":{"other_calendar":"Create other calendar","other_calendar_placeholder":"E.g. Meeting calendar"},"create_subject":{"create_subject":"Create course","subject_is_not_created_in_this_school_year":"The course has been created. However, please be aware that it is associated with a school year that does not match the current date."},"task_overview":{"task_overview":"Task overview","hour_overview":"Hours statement","task_and_hour_overview":"Task overview and hours statement","no_tasks_assigned":"No tasks assigned","transfer_scheduled_to_assigned":"Transfer scheduled to assigned","transfer_scheduled_only_full_period":"Only possible when the whole period is selected","transfer_scheduled_already_equal":"Assigned and scheduled are already equal","transfer_scheduled_success":"{name}: assigned changed from {from} to {to}","transfer_scheduled_no_permission":"You don't have permission to change hours at the school this subject belongs to","transfer_scheduled_other_calendar_hours":"{name} can't be transferred, because {calendars} has its own hours on the subject, which are shown instead. Change it under Edit.","assign_teacher_to_subject_title":"The teacher is not on the subject","assign_teacher_to_subject_text":"{teacher} has lessons in {name} ({calendar}) but is not assigned to the subject itself. Do you want to assign {teacher} to the subject, so you can transfer hours and edit?","assign_teacher_to_subject_confirm":"Assign teacher","assign_teacher_to_subject_success":"{teacher} is assigned to {name}","distribution":"Distribution","work_hours":"Work hours","teaching":"Teaching","tasks":"Tasks","preparation":"Preparation","show_scheduled_hours":"Show scheduled hours","coming_soon":"Coming soon","belongs_to":"Calendar","absence":"Absence","reset":"Reset dates","club":"Club","substitute_hours":"Substitute hours","showing_scheduled_hours_from":"Showing scheduled hours from","rest":"Remainder","pool":"Custom pool","unknown":"On-call","diff_from_total_workhours":"Too many hours assigned compared to work time","rest_missing_tooltip":"{hours} hours not yet assigned","rest_too_many_tooltip":"{hours} hours too many assigned compared to work time","rest_balanced_tooltip":"All hours assigned"},"standard_settings":{"standard_setting":"Standard setting","set_default_start_and_endtime":"Set default start and end time"},"print_all_calendars":{"loading":"Getting events for all calendars. It may take some time..","no_calendars":"There is 0 calendars with lessons","are_you_ready_to_print":"Are you ready to print?","print":"Print","this_calendar_with_weekplan":"Calendar w. weekplan","this_calendar":"This calendar","all_classes":"All grades/groups","all_teachers":"All teachers","all_rooms":"All rooms","only_printing_calendars_with_lessons":"Only printing calendars with lessons","show_print_without_bg_colors":"Print without background colors","event_font_size":"Font size","custom":"Choose Calendars"},"edit_event":{"teachers":"Staff","substitutes":"Substitutes","rooms":"Rooms","klass":"Grades / groups","swap_headline":"The following lessons can swap times with the selected lesson","swap_desc":"The 'Swap' function is used to swap an existing lesson with another scheduled lesson from a different time in the same calendar. This means that one can move a scheduled lesson to a different time and replace it with another lesson from the same calendar. The following lessons are possible to swap with the selected lesson, as both the teacher and classroom will be available during the new time slots.","swap_no_lessons":"Unfortunately, there are no lessons to swap with...","select":"Select","replace_headline":"Replace the lesson with a new","replace_desc":"The 'Replace' function is used to replace an existing lesson with a new (non-scheduled) lesson from a selected course. It is possible to replace the lesson with a new one from the following courses, since both the teacher and the classroom are available.","replace_no_lessons":"Unfortunately, there are no lessons to replace with...","lesson_updated":"The lesson has been updated"},"students":{"all":"All","activated_schedules":"Activated student schedules","student":"student","students":"students","created_student":"Created student","delete_student":"Delete student?","add_student":"Add from another group","create_student":"Create student","students_with_same_name":"Following students has a similar name","users_with_same_name":"Following users has a similar name","latest_updated":"Last updated","is_already_in_the_klass":"Is already in the group","without_a_group":"without a group","has_no_groups":"Has no groups","name":"name","feide":"feide","feide_is_already_used":"Feide is already used","import_students":"Import students","groups":"groups","without_group":"without a group","calendar":"calendar","remove":"Remove","of":"of","students_in":"students in","the_group":"the group","select_all":"Select all","unselect_all":"Unselect all","insert_multiple_students":"Insert list of student names. Change line after each student.","create_multiple_students":"Create multiple students at once","to_be_scheduled":"To be scheduled"},"set_standard_duration":{"lessons_duration":"Lessons length","minutes":"minutes","set_standard_duration_for_the_school":"Standard lesson length","standard_duration_for_the_school":"Set standard lessons length for all lessons","the_number_must_be_divisible_by_five":"Number of minutes must be divisible by five","this_setting_will_be_selected_if_nothing_else_is":"This setting will be selected, if nothing else is done","standard_duration_can_be_selected_for_each_course":"Standard lessons length can be changed for each course","already_created_courses_want_be_updated":"Courses already created will not be affected by this change","set_standard_length_for_zen":"The default lesson length is used to calculate the number of lessons for a weekly schedule in Docendo ZEN."},"club":{"club":"Club","club_calendar":"Club calendar","create_club_calendar":"Create club calender","not_created_club":"With a club calendar, you can create club time for educators separate from school time"},"calendar_view":{"next_week_disabled_tooltip":"Missing a week? School administrators can edit the school year duration under ⚙️ > 'School years'"},"calendar_view_day":{"remove":"Remove","add":"Add","replace":"Replace","actions_for":"Actions for","onwards":"onwards","remove_onwards":"Remove onwards","do_you_want_to_remove":"Do you want to remove","on_all_lessons_from":"on all lessons from and including","and_onwards":"and all future lessons","add_onwards":"Add onwards","do_you_want_to_add":"Do you want to add","on_all":"on all","lessons":"lessons","onwards_which_include":"onwards? This includes lessons from and including","and_all_onwards":"and all future lessons","with_on_all":"with on all","select_the_person_to_replace":"Select the calendar to replace","select_person":"Select calendar","replace_onwards":"Replace onwards","set_end_date":"Set end date","until_and_including":"until and including"},"eventTypes":{"subject":"Subject","optional":"Optional grades/groups","supplemental":"UUV","frame":"Theme","break":"Break","resource":"Resource (hidden)","person_resource":"Resource (hidden)","other_tasks":"Other tasks","other_stuff":"Additional tasks","available":"On-call","person_resource_visible":"Resource (Visible)","club":"SFO time","additional_tasks":"Not teaching","preparation":"Preparation","with_kids":"Tid med børn","without_kids":"Tid uden børn","pool":"Custom pool","absence":"Absence","_extra_time_at_start_of_day_":"Extra time before first lesson","_extra_time_between_events_":"Extra time between lessons","_extra_time_if_shorter_than_":"Extra time when the day is too short","activity":"Activity"},"task_versions":{"task_overview":"Task Overview","versions":"Versions","save_print_task_overviews":"Save/Print task overviews","save_new_version_task_overviews":"Save a new version of task overviews","print_latest_version_task_overviews":"Print latest version of task overviews","saved_message":"Saved","delete_message":"Delete","confirm_delete_message":"Do you want to delete","delete_warning_message":"Deleted versions cannot be recovered","annual_norm":"Annual Norm","save_task_overview_version":"Save task overview version","version_title":"Title for task overview version","auto_name_description":"Automatically named with today's date if you don't provide a title","what_is_version":"What is a version?","saved_task_overview_description":"A saved task overview shows a snapshot of the employee's task overview as it appeared at the time when the task overview version was saved. It is equivalent to making a printout or PDF with details of how the task overview looked at that particular moment.","find_saved_versions":"Where can I find saved versions?","find_saved_versions_description":"You can find saved versions by navigating to the \"Task Overview\" for each individual. There will be a dropdown menu where all the saved versions within the school year are available for review.","select_personnel":"Select personnel","go_back":"Back","select_min_user":"At least one user must be selected","save_for_selected_users":"Save for","save_for_selected_users_of":"out of","print_latest_version":"Print latest version of task overview for all","no_saved_versions":"No versions are saved","save_new_version":"Save new version","save_version":"Save version"},"deleted_subjects_log":{"deleted_log":"Deleted Log","no_lessons_deleted":"No events have been deleted from this subjects","lesson":"Lesson","deleted":"Deleted"},"create_activity":{"create_activity":"Create event","create_activity_for":"Create event for","title":"title","search_or_create":"Search or create","created":"Created","create_new_subject_for":"Create new course for","choose_subject_type":"Choose course category","the_selected_date_is_outside_schoolyears":"The selected date is outside all active school years","set_as_substitute":"Assign as substitute","set_as_substitute_help":"The user is put on the activity as a substitute. The hours are deducted from the user's substitute pool, and the user is shown under Substitutes today – e.g. when sending SMS to today's substitutes."},"datepicker":{"max_date_range_start":"You can fetch a maximum of","max_date_range_end":"days interval"},"request_absence":{"request_absence":"Request absence"},"public_calendar":{"black_white":"Black/white"},"special_days":{"title":"Special days","intro":"Rearrange one or more days for selected classes, e.g. a sports day, theme day or first day of school. Rearranged days in classes are excluded when copying and are therefore not overwritten. The days can also be deducted from the class's teaching hours based on the class's normal subject hours.","create":"Create special day","edit":"Edit special day","refresh_reductions":"Update reductions","reductions_updated":"Reductions updated","none_created":"No special days created yet","loading":"Loading special days","name":"Name","name_placeholder":"e.g. Sports day","start_date":"From date","end_date":"To date","period":"Period","day":"day","days":"days","pick_dates_hint":"Click a day to choose start and end date","reduct":"Reduce hours in the class","reduct_hint":"When enabled, the classes' hours are reduced for the period.","reduct_yes":"Yes","reduct_no":"No","classes":"Classes","select_classes":"Select classes","select_all":"Select all","clear":"Clear","no_classes_selected":"Select at least one class","actions":"Actions","delete":"Delete","save":"Save","cancel":"Cancel","linked_subjects":"Linked subjects (they are detached from the day)","confirm_delete_title":"Delete","confirm_delete_text":"The special day is deleted.","saved":"Saved","deleted_toast":"The special day was deleted","error_toast":"Something went wrong. Please try again."},"helpdesk":{"hero_eyebrow":"Answers, guides and updates","hero_title":"What can we help you with?","hero_subtitle":"Find the answer and get on with your day.","search_placeholder":"Search help articles…","back_to":"Back to","latest_news":"Latest news","read_news":"Read the news","earlier_news":"Earlier news","popular_articles":"Popular articles","find_by_topic":"Find help by topic","footer_help":"Need more help? Our support team will help you out.","back":"Back","articles_about":"Articles about:","categories":"Categories","related_articles":"Related articles","copy_link":"Copy link","link_copied":"Link copied!","back_to_start":"Back to start","search_results":"Search results","no_results":"We couldn't find any articles matching your search.","no_articles":"There are no help articles yet.","clear_search":"Clear search","uncategorized":"Other","article":"article","articles":"articles","language":"Language"},"school_users":{"title":"Users","stil_intro":"STIL has changed how Unilogins are created. We recommend importing users from STIL instead of creating them manually.","stil_read_more":"Read more","stil_import":"Import users from STIL","merge_users":"Merge users","transfer_calendar":"Transfer calendar","create":"Create user","edit":"Edit user","actions":"Actions","edit_action":"Edit","search_placeholder":"Search by name, initials, login or phone","users":"users","none":"There are no users at the school","no_results":"No users match the search","name":"Name","initials":"Initials","login":"Login","email":"Email","phone":"Phone","ssn":"Social security number","unilogin":"Unilogin","unilogin_hint":"(8 or 10 characters)","feide":"Feide","employee_id":"Employee ID","employee_id_hint":"(optional ID for the school's own use)","last_seen":"Last seen","never_logged_in":"Never logged in","change_photo":"Change photo","not_editable_yet":"Cannot be changed here yet","see_tasks":"See task overview","cancel":"Cancel","save":"Save","saved":"The user has been saved","error_toast":"Something went wrong. Please try again."}}

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

	module.exports = {"nb":{"activerecord":{"attributes":{"calendar":{"name":"Navn"},"group":{"country":"Land","demo_expiry":"Demoperiode utløp","description":"Beskrivelse","institution_number":"Institusjonsnummer","name":"Navn","open":"Åpen?","si_name":"-","visible":"Synlig?"},"institution":{"number":"Institusjonsnummer"},"lesson":{"count_hours":"Tell timer"},"material":{"class":"Klassetrinn","description":"Beskrivelse","documenttypes":"Dokumenttype","klassetrin":"Klassetrinn","status":"Status","subjects":"Fag","tag_list":null,"thefile":"Materiale","title":"Tittel"},"notification":{"body":"Brødtekst","header":"Overskrift","sitewide":null,"url":"URL"},"post":{"body":"Innhold","published":"Publisert?","titel":"Tittel"},"room":{"name":"Navn","navn":"Navn","si_name":"Navn i SkoleIntra"},"signup":{"already_in_use":"er allerede i brug","country":"Land","email":"E-post","password":"Passord","password_can_not_be_email":"kan ikke være din email","password_can_not_be_school_name":"kan ikke være skolens navn","password_can_not_be_user_name":"kan ikke være ditt navn","password_confirmation":"Bekreft passord","school_name":"Skolens navn","terms_of_service":"Betingelser","user_name":"Ditt navn"},"subject":{"calendar":"Kalender","color":"Farge","default_duration":"Normal varighet","hours":"Timer","name":"Navn","si_name":"Navn i SkoleIntra","subject_type":"Type"},"subject_period":{"hours_per_week":"Timer per uke","total_hours":"Timer i alt"},"user":{"Email":"E-mail","Fag":"Fag","Initialer":"Initialer ","Klassetrin":"Klassetrinn","Navn":"Navn","Sprog":"Språk","assigned_preparation_hours":"Forberedelse","assigned_teaching_hours":"Undervisningstid","assigned_total_hours":"Timer i år","description":"Beskrivelse","email":"E-post","groups":"Grupper","name":"Navn","organisation":"Skole","password":"Passord","password_confirmation":"Bekreftelse av passord","primary_school":"Primærskole","remember_me":"Husk meg"}},"errors":{"models":{"group":{"attributes":{"institution_number":{"taken":"er allerede opprettet "}}}}},"models":{"calendar":"timeplan","group":"gruppe","institution":"institusjon","lesson":"modul","material":"materiale","post":"innlegg","room":"lokale","signup":null,"subject":"fag","subject_period":"fagperiode","user":"bruker","user/calendar_transfer":"Overføring av kalender"}},"calendars":{"administration":{"archive_merge_table":"Hvis du arkiverer en fellestimeplan, blir den usynlig på forsiden.","archive_room":"Hvis du arkiverer et lokale, blir det usynligt på forsiden."},"calendar_hours_count":{"andet_halvår":"2. halvår","første_halvår":"1. halvår","indeværende_uge":"Denne uken","skoleår_til_dato":"Skoleår til dato"},"calendar_sidebar":{"skema":"timeplan"},"copy_paste":{"indsæt":"Sett inn","indsæt_resten_af_året":"Sett inn + resten av året","kopiér":"Kopier"},"delete_merge_calendar_button":{"delete_merge_calendar":"Slett fellestimeplan","dette_kan_ikke_fortrydes":"Dette kan ikke angres.","ja_slet_dette_fletteskema":"Ja, slett denne fellestimeplanen.","nej":"Nei","slet_dette_fletteskema":"Slett denne fellestimeplanen?"},"delete_week_button":{"der_vil_kun_blive_slettet_de_lektioner_som_er_lagt_ind_i_denne_kalender":"Det er kun timene som er lagt inn i denne kalenderen som blir slettet. ","dette_kan_ikke_fortrydes":"Dette kan ikke angres","ja_slet_ugens_lektioner":"Ja, slett ukens timer. ","lektioner":"Slett ukens timer...","nej":"Nei","vil_du_slette_alle_ugens_lektioner":"Vil du slette alle ukens timer?"},"events_with_notes_or_substitutes":{"hvis_du_kopierer_et_skema_frem_bliver_vikardækninger_fravær_i_personlige_kalendre_og_noter_på_lektionerne_ikke_gemt":"Hvis du kopierer timeplanen fremover for året vil ikke vikarer, fravær i personlige kalendere og notater til timene bli lagret.","ja_jeg_vil_overskrive_disse":"Ja, jeg vil overskrive disse.","lektioner_med_noter_vikardækning_eller_fravær":"Timer med notater"},"expand":{"skift_visning_mellem_arbejdsuge_weekender_og_fuld_uge":"Bytt visning mellom skoleuke, full uke og 24 timer"},"explain_copy_in_background":{"der_kan_gå_5-10_minutter":"Det kan ta 5-10 minutter.","du_får_en_notifikation_på":"Du får et varsel","du_kan_fortsætte_med_at_arbejde_i_andre_kalendre":"Du kan fortsette med å arbeide i andre kalendere.","forsiden":"forsiden","kopierer_kalenderen_frem":"Kopierer kalenderen frem i tid.","når_kopieringen_er_afsluttet":"når kopieringen er avsluttet. ","ok":"Ok"},"group":{"flet_med_fletteskemaer":"Flett med fellestimeplan...","flet_med_skema":"Flett med timeplan","se_elevskema":"Se elevtimeplan","vælg_skema":"Velg timeplan"},"group_hours":{"total":"Totalt","type":"Type"},"merge":{"dette_skema_er_flettet_ind_i":"Denne timeplan er flettet inn i:","hvis_du_vil_slette_dette_fletteskema_skal_du_først":"Hvis du vil slette denne fellestimeplanem, må du først fjerne flettingen i timeplanene ovenfor.","vælg_kalender":"Velg kalender:"},"merge_with_selector":{"flet":"Flett inn"},"new":{"nyt_fletteskema":"Ny fellestimeplan","opret_fletteskema":"Opprett fellestimeplan"},"public":{"mobile_guide":"Veiledning for mobil og nettbrett","print_in_black_white":"Skriv ut uten farge","printing_guide":"Veiledning for utskrift","se_skemaet_på":"Se timeplan på"},"room":{"vælg_skema":"Velg timeplan:"},"subject_hours":{"anden_tid_i_perioden":"Annen tid i perioden","er_du_tilknyttet":"er du tilknyttet","flextid_for_året":"Fleksitid for året","fravær_i_perioden":"Fravær i perioden","til":"til","timer":"timer","undervisning_i_perioden":"Undervisning i perioden"},"user":{"apple_kalender":"Apple Kalender","google_kalender":"Google Kalender","google_opdaterer_kalenderen_ca_tre_gange_i_døgnet":"Google oppdaterer kalenderen ca. tre ganger i døgnet.","ical":"iCal","kopiér_webaddresen_herunder_og_kopier_den_ind_i_den_eksterne_kalender_hvor_du_gerne_vil_have_den":"Kopier nettadressen under og legg inn i den eksterne kalenderen. ","outlook":"Outlook","se_evt_guides_nedenfor_i_forhold_til_hvordan_du_skal_gøre":"Se evt. veiledning nedenfor som viser hva du skal gjøre.","siden":"siden.","sidst_hentet":"Det ble sist lastet ned","tilføj_dit_skema_til_ekstern_kalender":"Legg timeplanen inn i en ekstern kalender","vælg_kalender":"Velg kalender:"},"user_hours":{"undervisningstid":"Undervisningstid"},"week_note":{"week_notes":"Ukenotater"},"week_plan":{"content":"Innhold","internal_notes":"Vikarnotater","learning_goal":"Læringsmål","pupil_preparation":"Lekser","subject":"Fag"},"week_plan_and_note":{"week":"Uke","week_plan":"Ukeplan"}},"controllers":{"ws":{"events":{"you_are_no_longer_substitute":"%{creator} fjernet deg som vikar i %{subject} i %{klass}, %{time}","you_are_substitute":"%{creator} gjorde deg til vikar i %{subject} i %{klass}, %{time}"}}},"da_only":{"add_user_with_uni":"Tilføy bruker(e) med Feide","click_to_login_with_unilogin":"Klik her for at logge på med Uni-login","fictive_user_text":"Brukeren har en kalender, og det vil være mulig å legge til brukeren som lærer i timeplaner. Brukeren kan ikke logge på Docendo.","guide_link_parentintra":"Guide til link i klassens forældreIntra","lærere_på_skoleintra":"Lærere på SkoleIntra","opdatér_profil_fra_uni-c":"Opdatér profil fra UNI-C","parent_portal":"ForældreIntra","show_tables_parentintra":"Vis skemaer i ForældreIntra","skriv_brikken_skoleintra":"Skriv hvad brikken hedder i SkoleIntra","uni_login":"-","vis_skema_i_skoleintra":"Vis timeplan for elever/foreldre","website_portal":"Skolens hjemmeside"},"date":{"formats":{"iso":"%Y-%m-%d"}},"demo":{"firstlogin":{"kom_igang":"Kom i gang","velkommen":"Velkommen"}},"devise":{"confirmations":{"new":{"resend_confirmation_instructions":"Send bekreftelsesinstruksjoner"}},"failure":{"invited":"Du har en invitasjon på vent, aksepter denne for å få adgang. "},"invitations":{"edit":{"header":"Velg passord. ","password":"Passord","password_confirmation":"Bekreft passord","submit_button":"Lagre passord"},"invitation_removed":"Invitasjonen din er blitt slettet. ","invitation_token_invalid":"Invitasjonen er ikke gyldig. ","new":{"header":"Send invitasjon","submit_button":"Send invitasjon"},"no_invitations_remaining":"Ingen flere invitasjoner. ","send_instructions":"En invitasjonsmail har blitt sendt til %{email}.","updated":"Passordet er blitt lagret. Du er nå logget inn. ","updated_not_active":"Passordet er lagret. "},"mailer":{"confirmation_instructions":{"confirm_my_account":"Bekreft kontoen min","you_can_confirm_your_account_email_through_the_link_below":"Du kan bekrefte din mail via linken under:"},"invitation_instructions":{"accept":"Aksepter invitasjon","accept_until":"Invitasjonen utløper %{due_date}.","contact_us":"Hvis du har spørsmål, kontakt oss gjerne på kontakt@docendo.no","from_school":"Du er akkurat blitt invitert til Docendo – Fleksibel Timeplanlegging på %{school_name}.","hello":"Hei %{email}","regards_html":"<p>Med venlig hilsen,<br/>\nDit Docendo Team<br/>\nhttps://docendo.no</p>","someone_invited_you":"For å akseptere invitasjonen, trykk på denne linken ","subject":"Instruksjoner til invitasjonen"},"reset_password_instructions":{"change_my_password":"Endre mitt passord","change_password_link_requested":"Du kan endre passordet via linken under. ","greeting":"Hei","wont_change":"Hvis du ikke gjør noe vil passordet ikke endres. "},"unlock_instructions":{"click_the_link_below_to_unlock_your_account":"Klikk på linken nedenfor for å låse opp kontoen din.","unlock_my_account":"Lås opp kontoen min.","your_account_has_been_locked_due_to_an_excessive_number_of_unsuccessful_sign_in_attempts":"Kontoen din har blitt låst på grunn av et stort antall påloggingsforsøk."}},"passwords":{"edit":{"change_my_password":"Bytt mitt passord","change_your_password":"Bytt passord","confirm_new_password":"Bekreft nytt passord","new_password":"Nytt passord"},"new":{"forgot_your_password":"Glemt ditt passord?","send_me_reset_password_instructions":"Send meg instruksjoner om nullstillingav passord"}},"registrations":{"edit":{"are_you_sure":"Er du sikker?","cancel_my_account":"Slett min konto","current_password":"Nåværende passord","password":"passord","password_confirmation":"Gjenta passord","update":"Oppdater"}},"sessions":{"new":{"brugernavn":"Brukernavn","create_a_free_trial":"Opprett en gratis prøveversjon","kodeord":"Passord","log_ind":"Logg på","log_ind_med":"Logg inn med Feide","log_ind_med_mail_og_kodeord":"Logg på med e-post og passord","log_ind_på_docendo":"Logg på docendo","no_account":"Ingen konto?"}},"shared":{"links":{"didn":"Fikk du ikke bekreftelsesinstruksjoner?","didn_2":"Fikk du ikke unlock-instruksjoner?","forgot_your_password":"Glemt ditt passord?","sign_in":"Logg på","sign_up":"Meld deg på"}},"unlocks":{"new":{"resend_unlock_instructions":"Send unlock-instruksjoner igjen"}}},"events":{"event_debug":{"brugere":"Brukere:","ejerkalender":"Eierkalender:","grupper":"Grupper: ","kalendre":"Kalendere:","lokaler":"Lokaler: "},"replace_room":{"erstat_fremadrettet_på_dette_fag":"Erstatt fremover på dette faget","og_resten_af_året":"og resten av året?","på":"på"},"replace_user":{"erstat_fremadrettet_på_dette_fag":"Erstatt fremover på dette faget","klik_her_for_at_gå_til_kalenderen_for":"Klikk her for å gå til kalenderen for","med":"Med:","og_resten_af_året":"og resten av året?","på":"på"},"show":{"agenda":"Agenda","agenda_placeholder":"F.eks: 1. Oppfølging fra sist, 2. Opplegg fra...","content":"Innhold","decisions_and_resume":"Beslutninger og oppsummering","decisions_and_resume_placeholder":"F.eks.: Henriette undersøker med ungdomstrinnet om vi kan...","denne_lektion_tæller_som":"Denne timen teller som:","er_du_sikker":"Er du sikker?","external_links":"Mine læringsmål og forløp","find_vikar":"Finn vikar","gå_til_kalender_for_denne_lektion":"Gå til kalenderen for denne timen","internal_notes":"Vikarnotater","jump_to_calendar_for_event":"Hopp til kalender for dette faget","learning_goal":"Hva skal vi lære?","location":"Lokale","meeting_purpose":"Formål med møtet","meeting_purpose_placeholder":"F.eks.: Vi skal være flinke på å...","only_visible_internally":"Bare synlig for undervisere","pupil_preparation":"Lekser","slet_brik":"Slett fag","slet_fra_denne_kalender":"Slett kun i denne kalenderen","substitutes":"Vikarer","swappable_lessons":"Følgende timer og tidspunkt kan byttes med valgt time","søg_og_vælg":"Søk og velg","søg_og_vælg_vikar":"Søk og velg vikar","teachers":"Undervisere","undervisere_lokaler_noter":"Undervisere","vacant":"Underviser og lokale er ledige for fagene/timene under","vælg_klasser":"Velg klasser","vælg_lokation":"Velg lokale"},"show_public":{"agenda":"Agenda","content":"Innhold","decisions_and_resume":"Beslutninger og resymé","external_links":"Mine læringsmål og kurs","jump_to_calendar_for_event":"Hopp til kalenderen for dette faget","learning_goal":"Hva skal vi lære?","location":"Lokale","meeting_purpose":"Formål med møtet","pupil_preparation":"Lekser","substitutes":"Vikarer","teachers":"Undervisere"}},"groups":{"about":{"om":"Om"},"admin":{"assign_hours_employees":"Tildel timer til ansatte","classes_and_subjects":"på klasser og fag","more_tables":"se flere timeplaner sammen","show_to_parents":"Vis for foreldre","status":"tildeling og status","substitutes":"Vikarpulje","supplement":"Tillegg","year":"2016-2017"},"calendars_setup":{"copy_link":"Kopier link","copy_link_table_insert":"Kopier linken til den klassens timeplan du gjerne vil abonnere på - og sett inn","docendo_extern_calendar":"Docendo-timeplaner kan vises i eksterne kalendere. Kopier linken ved siden av timeplanen nedenfor og sett inn i ekstern kalender. Følg slides til høyre for hjelp til oppsett.","find_in_google_cal":"Veiledning for integrasjon i egen kalender","google_calendar":"Google Kalender","guide_integration_own_cal":"Veiledning for integrasjon i egen kalender","guide_setup_schoolport":"Veiledning for oppsett på Fronter/ItsLearning","guide_setup_table_elevintra":"Veiledning for oppsett av timeplan i klassens ElevIntra","guide_step_copy":"Klikk på ’Kopier link’ ved siden av timeplanen du vil sette opp - og følg veiledningen til høyre.","ical_google_outlook":"iCal","integrate_tables":"Integrer timeplaner i iCal, Google eller Outlook","links_for_each_class":"Ønsker dere å vise timeplaner for hver enkelt klasse, kan dere benytte linkene for hver klasse nedenfor.","outlook":"Outlook","parentintra_seperate_class":"Ønsker dere å vise timeplaner for hver enkelt klasse på klassens ForeldreIntra, kan dere benytte linkene for hver klasse nedenfor.","show_table_selected":"Vis utvalgte timeplaner på hjemmeside","show_tables_elevintra":"Vis timeplaner på ElevIntra","substitutes_teachers_show_public":"Dagens fraværende","substitutes_teachers_show_public_explain":"Informasjon om dagens fraværende undervisere kan vises på f.eks infoskjerm. Bruk linken under til oppsetting. ","text_set_x":"Kryss av nedenfor hvilke timeplaner som ønskes vist via linken.","text_show_tables":"For å gjøre timeplanene tilgjengelige for elever og foreldre kan denne nettadressen legges ut på f.eks. skolens hjemmeside eller It's Learning:","vaelg_alle":"Velg alle"},"create_klass":{"evt_vaelg":"Evt. velg import av fag og timer som svarer til klassetrinnet","import_af_fag":"Import av fag?","import_norm":"Ønsker du å importere og opprette fag med fastsatt timetall? Velg i så fall det klassetrinnet som klassen tilhører her: ","klassens_navn":"Klassens navn","opret_en_ny_klasse_for":"Opprett en ny klasse","skriv_klassens_navn":"Skriv klassens navn"},"delete_popup":{"brikker_som_slettes_kun_fra_denne_kalender":"Fag som slettes bare fra denne kalenderen","den_har":"Den har:","denne_handling_kan_ikke_fortrydes":"Denne handlingen kan ikke angres!","indlæg_som_slettes":"innlegg som slettes.","kalendere_som_slettes":"Kalendere som slettes.","lektioner_i_kalenderen":"timer i kalenderen.","medlemmer_som_ikke_længere_vil_kunne_bruge_gruppen":"medlemmer som ikke lenger vil kunne bruke gruppen.","skriv_slet_gruppen_herunder":"Skriv 'Slett gruppen' nedenfor:","slet_gruppen":"Slett gruppen","uploadet":"Lastet opp"},"edit":{"redigér_gruppe":"Rediger gruppe"},"flextime":{"flextime":"Fleksitid","flextime_teacher_appear":"Bare lærere som har brukt fleksitid vises i listen."},"flextime_activator":{"aktivering_af_flextid":"Aktivering av fleksitid","aktiveringen_giver_alle_ansatte_brikker_til_flextid_i_deres_egen_kalender":"Aktiveringen gir alle ansatte brikker for fleksitid i egen kalender.","aktivér_flextid":"Aktiver fleksitid"},"form":{"fejl_forhindrede_denne_gruppe_i_at_blive_gemt":"feil forhindret at denne gruppen ble lagret:","skriv_hvad_gruppen_hedder":"Skriv hva gruppen heter","skriv_om_gruppen":"Skriv om gruppen"},"hours":{"press_empty_bricks":"Trykk i tomme felt for å opprette fag/legge inn timer i klassen."},"merge_calendars":{"merge_tables":"Fellestimeplan","new_merge_table":"Ny fellestimeplan"},"mine":{"ikke_medlem_af_nogen_grupper_endnu":"Ikke medlem av noen grupper ennå."},"multical":{"help_for_table":"Hjelp til timeplanoversikt","today":"I dag","vaelg_klasse":"Velg klasse","vaelg_lokale":"Velg lokale","vaelg_person":"Velg person"},"newother":{"fejl_forhindrede_denne_kalender_i_at_blive_gemt":"feil forhindret at denne kalenderen ble lagret:","opret_anden_kalender":"Opprett en annen kalender","opret_kalender":"Opprett kalender","skriv_evt_kalen":"Skriv evt. noe om kalenderen","skriv_hvad_kalen":"Skriv hva kalenderen vil bli navngitt..."},"pay_supplement":{"get":"Hent","minutes":"Minutter","show_supplement":"Vis tillegg","supplement_type":"Tilleggstype"},"school":{"video":"Video"},"schools":{"vælg_skole":"Velg skole"},"show":{"bliv_medlem":"Bli medlem","class_year":"klasse/årgang","filer":"Filer:","forlad_gruppen":"Forlat gruppen","gruppen":"gruppen...","indlæg":"Innlegg:","opret_team":"Opprett gruppe"},"substitute_pool":{"details":"Detaljer","hours":"timer","mistakes_look":"feil","notice":"Merk","notice_list_item_1":"Vikartimer telles med i samlet antall undervisningstimer for underviseren","notice_list_item_2":"Vikartimer er i underviserens egen kalender angitt som det faget det vikaries i - f.eks. 'Norsk'","pool":"Pulje","rest":"Rest","substitute_hours_per_month":"Vikartimer brukt pr. måned","substitute_overview":"Vikaroversikt","there_was":"Det var","total_substitute_pool":"Total vikarpulje:","total_used_substitute_hours":"Totalt brukte vikartimer:","total_used_substitute_hours ":"Totalt brukte vikartimer:","used":"Brukt","vis_timer":"Se timer"},"users":{"ical":"ical:","initials":"Initialer","users":"Brukere"}},"import":{"csv_overview":{"i_fil":"I fil:","ikke-fundne_klasser_oprettes_i_skoleåret_hvor_der_importeres_til":"Klasser som ikke er funnet, opprettes i skoleåret som det importeres til","ikke-fundne_lokaler_oprettes":"Lokaler som ikke er funnet, opprettes","ikke-fundne_lærere_oprettes_med_initialer":"Lærere som ikke er funnet, opprettes med initialer","ikke_fundet":"Ikke funnet","import":"Import","kontrollér_at_disse_er_rigtige":"Kontroller at disse er riktige","lagt_sammen":"Lagt sammen: ","lokaler":"Lokaler","lærerer":"Lærere","ringetider":"Ringetider","til_uge":"Til uke:"},"result":{"der_var_nogle_fejl":"Det var noen feil","import_afsluttet":"Import fullført","ingen_fejl_i_import":"Ingen feil i import."}},"jobs":{"copy_events_year_job":{"calendar_is_copied":"Kalenderen %{calendar_name} er kopiert"}},"js":{"all_day":"Hele dagen","calculating_and_controlling":"Setter inn og beregner tid...","changes_may_not_be_saved":"Endringer du har gjort lagres ikke","click_keyboard_shortcuts_to_copy":"Klikk på ⌘ + C  eller ctrl + C for å kopiere","close_without_saving":"Ønsker du å lukke uten å lagre?","copied":"Kopiert","error_occured":"En feil har oppstått."},"layouts":{"application":{"dage":"dager","der_er_ikke":"Det er ikke forbindelse til Docendo. Dette kan skyldes at du ikke har forbindelse til internett.","din_profil":"Din profil","hjem":"Hjem","kurser":"Kurs","køb_nu":"Kjøp nå","log_ud":"Logg ut","profil":"Profil","prøveperiode_slutter_om":"Prøveperioden avsluttes om","skal_slettes_for_sig_selv":"skal slettes for seg selv.","skift_kodeord":"Bytt passord","slet_indlæg":"Slett innlegg","soeg":"Søk","vil_du_deaktivere":"Vil du deaktivere skolen?","Ønsker_du_at_slette_dit_indlæg":"Ønsker du å slette ditt innlegg?"},"blank":{"der_er_ikke":"Det er ikke"},"devise":{"book_en_gratis_demo":"Book en gratis demo","docendodk":"docendo.no","kontakt":"kontakt","log_ind_med":"Logg inn med","log_ind_med_email":"Logg på med e-post","login":"Logg inn ","med_en_fuldt_integreret":"Med en fullt integrert","om_docendo":"Om docendo","om_os":"om oss","tlf_70_40_02_10":"Telefonnummer: +45 70 40 02 10","udviklet_i_samarbejde_med_ledere_lærere_og_pædagoger":"Utviklet i samarbeid med ledere, lærere og pedagoger","uni":null},"public":{"skal_slettes_for_sig_selv":"skal slettes for seg selv.","slet_indlæg":"Slett innlegg","Ønsker_du_at_slette_dit_indlæg":"Ønsker du å slette innlegget ditt?"},"schools":{"users":{"create_user_by_alias":"Oprett bruker uten innlogging","create_user_by_email":"Opprett bruker med e-mail","create_user_by_unilogin":"Opprett bruker med Feide","merge_users":"Slå sammen brukere","transfer_calendar":"Ta over timeplan"}}},"materials":{"details":{"antal_downloads":"Antall nedlastinger:","beskrivelse":"Beskrivelse:","detaljer_om_filen":"Detaljer om filen","dialog_om_filen":"Dialog om filen","dokumenttype":"Dokumenttype:","klassetrin":"Klassetrinn:","status":"Status:","uploadet_af":"Lastet opp av:"},"edit":{"redigér_fil":"Rediger fil","vis":"Vis"},"form":{"dit_materiale_er_gemt":"Materialet ditt er lagret","fejl_forhindrede_dette_materiale_i_at_blive_gemt":"feil forhindret at dette materialet ble lagret:","filnavn":"Filnavn: ","gem_materiale":"Lagre materiale","skriv_noget_relevant":"Skriv noe relevant","titel_på_fil":"Tittel på fil","venligst_udfyld_nogle_informationer_om_materialet":"Vennligst fyll ut informasjon om materialet","vælg_dine_fag":"Velg dine fag","vælg_dokumenttype":"Velg dokumenttype(r)","vælg_dokumenttyper":"Velg dokumenttyper","vælg_klassetrin":"Velg klassetrinn","vælg_status":"Velg status"},"index":{"antal_hentede":"Antall hentede","klassetrin":"Klassetrinn"},"material":{"fra":"fra","mere_info":"Mer info","uploadet_af":"lastet opp av"},"new":{"gem_materiale":"Lagre materiale"},"new1":{"attach_files":"Legg ved materiale"},"popedit":{"dit_materiale_er_gemt":"Materialet ditt er lagret","erstat_materiale":"Erstatt materiale:","fejl_forhindrede_dette_materiale_i_at_blive_gemt":"feil forhindret at dette materialet ble lagret:","gem_materiale":"Lagre materiale","giv_nogle_informationer_om_materialet":"Gi informasjon om materialet","vælg_dine_fag":"Velg dine fag","vælg_dokument":"Velg dokumenttyper","vælg_klassetrin":"Velg klasse","vælg_status":"Velg status"},"show":{"beskrivelse":"Beskrivelse:","group":"Gruppe:","post":"Innlegg:","tags":"Koder:","user":"Bruker:"},"sidebar":{"nyeste":"Nyeste","populære":"Populære","se_alle":"Se alle"},"upload":{"del_et_materiale":"Del materiale","upload":"Last opp.","vælg_et_dokument":"Velg et dokument"}},"models":{"calendar":{"beregn_timer":"Beregn timer","flex_ind":"Fleks inn","flex_ud":"Fleks ut"},"group":{"alle":"Alle","already_created":"er allerede opprettet","share_with":"Del med","skolen":"Skolen","team":"Gruppe","ukendt":"ukjent"},"group_school":{"importerede":"Importerte","med":"med","oprettede_klasse":"Opprettet klasse","oprettede_lærer":"Opprettet lærer","uden_lærer_i":"uten lærer i"},"import_lesson":{"invalid":"Ugyldig"},"material":{"skal_vælges":"Må velges"},"pay_supplement_rule_school_camp":{"lejrskole":"Leirskole"},"pay_supplement_rule_substitute":{"ekstern_vikar":"Ekstern vikar"},"post":{"synes_godt_om":"Liker"},"subject_period":{"timer_uge":"Timer/uke"},"user":{"ukendt":"ukjent"}},"notifications":{"form":{"indhold":"Innhold:","link_https__skal_tilføjes_hvis_linket_er_eksternt":"Link: ('https://' må legges til hvis linken er ekstern)","notifikationer":"Meldinger","overskrift":"Overskrift:"},"index":{"notifikationer":"Meldinger","opret_ny":"Opprett ny","siden":"siden"},"notification":{"siden":"siden"},"show":{"brugere":"brukere","link":"Link: ","læst_af":"Lest av","notifikationer":"Meldinger","sendt_til":"Synlig for","sidst_opdateret":"Sist oppdatert:","skrevet_af":"Skrevet av"}},"posts":{"edit":{"redigér_indlæg":"Rediger innlegg","vis":"Vis"},"form":{"del_noget":"Del noe...","fejl_forhindrede":"feil forhindret at dette innlegget ble lagret","tilføj_kommentar":"Tilføy kommentar..."},"new":{"nyt_indlæg":"Nytt innlegg"},"post":{"antal_downloads":"Antall nedlastinger","comments":"Kommentarer","from":"fra","show":"Vis","since_in_group":"siden i gruppen","slet_indlæg":"Slett innlegg"},"show":{"bruger":"Bruker:","indhold":"Innhold:"}},"rack_dev_mark":{"development":"Utvikling"},"repitition":{"add":"Legg til","administration":"Administrasjon","aktivitet":"Aktivitet","all_calendars":"alle kalendere","annuller":"Avbryt","archive":"Arkiver","brikker":"Fag","brugeradministration":"Brukeradministrasjon","calendaradministration":"Kalenderadministrasjon","choose":"Velg","chooselanguage":"Velg språk","create":"Opprett","dagens_fraværende":"Dagens fraværende","dagens_vikarer":"Dagens vikarer","dearchive":"Dearkiver","delete":"Slett","deleting":"Sletter","din_kalender":"Din kalender","docendo":"Docendo - Fleksibel timeplanlegging","email":"E-post","enddate":"Sluttdato","endtime":"Sluttid","errors":"feil","fag":"Fag","feriekalender":"Feriekalender","fjern":"Fjern","fjern_brugere":"Fjern brukere","flextidsoversigt":"Fleksitidsoversikt","fra_og_med":"fra","from":"fra","gem":"Lagre","hour":"time","timeopgoerelse":"Timeregnskap","kalender":"Kalender","klass":"klasse","klasser":"Klasser","klasser_lille":"klasser","kr":"kr","langfravær":"Langtidsfravær","lesson":"timen","luk":"Lukk","materialer":"Materialer","medlem":"medlem","medlemmer":"medlemmer","merge_calendar":"fellestimeplan","merge_calendars":"fellestimeplaner","målstyring":"Målstyring","navn":"Navn","none":"Ingen","opgaveoversigt":"Oppgaveoversikt","opret":"Opprett","opret_brik":"Opprett fag","opret_fraværsgrund":"Opprett fraværsårsak","opret_tilføj_bruger":"Opprett/tilføy bruker","oprettet":"Opprettet:","other_calendar":"annen kalender","other_calendars":"andre kalendere","planlægning":"Planlegging","processing":"Behandler","rediger":"Redigér","replace":"Erstatt","replace_lesson":"Erstatt time","room":"lokale","rooms":"lokaler","se_kalender":"Se kalender","search":"søk","search_for":"søk etter","select_user":"Velg bruker","send":"Send","show":"Vis","skema":"Timeplan","skemaoverblik":"Timeplanoversikt","skole":"Skole","skoler":"Skoler","skoleår":"Skoleår","skriv":"Skriv...","startdate":"Startdato","starttime":"Starttid","substitute":" Vikardekning","superadmin":"Superadmin","support":"Support","swap":"bytt","swap_lesson":"Bytt time","tilbage":"Tilbake","tildel_timer":"Tildele timer","timefordeling":"Timefordeling","timer":"Timer","timeudtraek":"Timeuttrekk","titel":"Tittel","today":"I dag","unauthorized_access":{"help":"Brukeren din er ikke knyttet til en aktiv skole på Docendo. Mener du at dette er feil, kontakt skoleadministrasjonen for å bli knyttet til skolen. ","no_access":"Du har ikke adgang. "},"until":"til","user":"bruker","users":"brukere","vikardækning":"Vikardekning","vikarpuljer":"Vikarpuljer","vis_skemaer_til_elever":"Ekstern visning av timeplaner","with":"med","yearplan":"Årsplanlegging","Årsoverblik":"Årsoversikt","år":"År","årsplanlægning":"Årsplanlegging"},"rooms":{"create_room":"Opprett lokale","edit":{"er_du_sikker":"Er du sikker?","redigér_lokale":"Rediger lokale","slet_lokale":"Slett lokale"},"form":{"fejl_forhindrede_dette_lokale_i_at_blive_gemt":"feil forhindret at dette lokalet ble lagret:"},"new":{"nyt_lokale":"Nytt lokale"},"room_is_not_created":"Lokalet eksisterer ikke","rooms":{"new_room":"Nytt lokale","rooms":"Lokaler"}},"schools":{"calendar_transfers":{"new":{"activity_count":"Aktiviteter","from_date":"Fra dato","have_calendar":"Har timeplan som skal overdras","including_both":"begge datoer inkludert","period":"Periode","receive_calendar":"Skal overta timeplan","replacee_in_period":"Overdrar timeplan","replacement_in_period":"Overtar i perioden ","title":"La en bruker overta en annen brukers timeplan for en periode, for eksempel ved fødselspermisjon eller langvarig fravær.","to_date":"Til dato","transfer":"Overfør","transfer_calendar_for_a_period":"Ta over timeplan","warning":"Kan ikke angres."}},"onboarding":{"administration_and_counting":"Administrasjon og telling","assign_user_hours":"Tildel timer til lærere","create_calendars":"Opprett timeplaner","create_classes":"Opprett klasser","create_fixed_hours":"Opprett felles pauser","create_merge_calendars":"Opprett fellestimeplaner","create_other_calendars":"Opprett andre kalendere","create_rooms":"Opprett lokaler","create_school_year":"Opprett skoleår","create_teachers":"Opprett lærere/brukere","create_your_school":"Opprett skolen i Docendo","follow_the_steps":"Følg trinnene nedenfor for å komme i gang med planleggingen","import_of_schedules":"Importere timeplaner?","import_of_schedules_content":"Hvis du ønsker, kan vi også importere dine eksisterende timeplaner fra CSV-fil. Send en mail til oss, og du vil motta instruksjoner.","make_room_bindings":"Binding av lokaler","scheduling_classes_calendars":"Timeplanlegging i klasser","select_vacationdays":"Legg inn ferier og helligdager","show_calendars_to_students":"Vis timeplaner for elever og foreldre","student_scheduling":"Timeplanlegging for klassene","user_tasks":"Oppgaveoversikt til lærere"},"user_merges":{"new":{"merge_on_this_user":"Slå sammen på denne brukeren","title":"Slå sammen brukere. For eksempel i tilfelle av to identiske brukere eller hvis en bruker uten innlogging må byttes ut med en bruker med innlogging. Alle aktiviteter samles inn på en bruker. ","warning":"Du kan ikke angre handlingen."}},"users":{"index":{"actions":"Handlinger","help":"Trykk på bildet for å sette inn et nytt. Initialer kan redigeres.","photo":"Foto"},"user":{"invite":"Inviter","remove":"Fjern"}}},"search":{"post":{"siden_i_gruppen":"siden i gruppen"},"search_content_type_filter":{"alle":"Alle","grupper":"Grupper","opdateringer":"Oppdateringer","profiler":"Profiler","vis_resultater_for":"Vis resultater for"},"search_filter":{"filtre":"Filtre","type_af_materiale":"Type av materiale","vælg_dine_fag":"Velg dine fag","vælg_dokumenttyper":"Velg dokumenttyper","vælg_fag":"Velg fag","vælg_klassetrin":"Velg klassetrinn","vælg_status":"Velg status"},"search_results":{"antal_hentede":"Antall hentet","grupper":"Grupper","klassetrin":"Klassetrinn","none":"Dessverre - vi kunne ikke finne noe","opdateringer":"Oppdateringer","profiler":"Profiler","viser_Res_for":"Viser resultater for"}},"sidebars":{"get_started_new_year":{"assign_hours_employees":"Tildel timer til ansatte","follow_steps":"Følg trinnene nedenfor","get_started":"Kom i gang","other_calendars":"andre kalendere","time_distribution":"Timefordeling på klasser"},"school":{"other_calendars":"Andre kalendere (f.eks. team-kalender)"},"substitution_links":{"assign_substitutes":"Legg til dagens vikarer","substitute_cover":"Vikardekk"}},"signups":{"by_existing_users":{"new":{"already_user":"Bruker allerede skolen din Docendo, men du har ikke adgang? Kontakt skoleadministrasjonen for å få adgang. ","try_free":"Prøv Docendo gratis i 14 dager"}},"new":{"create_signup":"Opprett","i_accept":"Jeg aksepterer","password_rule":"(minst 8 tegn)","signup":"Opprett demo","terms_of_service":"betingelserne"}},"subject_periods":{"edit":{"antal_uger":"Antall uker","fordel_timer_i_perioden":"Fordel timer i perioden","opdatér":"Oppdater","skoledage_i_perioden":"Skoledager i perioden","slet":"Slett","timer_i_perioden":"Timer i perioden"}},"subjects":{"edit":{"arkiver":"Arkiver","arkiver_denne_brik_den_vil_ikke_længere_være_synlig":"Arkiver dette faget? Det vil ikke lenger være synlig","arkiverer":"Lagre","er_du_sikker":"Er du sikker?","redigér_brik":"Rediger fag","slet_brik":"Slett fag","vil_du_arkivere_denne_brik":"Ønsker du å arkivere dette faget? Det vil da ikke lengre være synlig, men timer som er lagt inn i timeplanen forblir."},"inner_edit":{"absence":"Fravær","absence_description":"sykdom, ferier osv.","anden_tid":"Annen tid","anden_tid_description":"ikke undervisning. ","antal_minutter_modul":"Skriv hvor mange minutter en modul normalt varer","antal_timer_på_år":"Angi det totale antall timer for året","bevægelse":"Bevegelse","bevægelse_description":"teller 100% og uavhengig av andre aktiviteter i samme tidsrom. ","fag":"Fag","fag_description":"teller timer for klassen.","fejl_forhindrede_denne_brik_i_at_blive_gemt":"feil forhindret at dette fag ble lagret","frame":"Temavisning","frame_description":"kan brukes til å markere temaer og spesielle dager/uker i timeplanen. Temavisning er synlig for elever/foreldre, og kan kombineres med fag. Fag teller 100% i perioden, og temaet teller ikke.","klasser_andre_kalendre":"Klasser/Andre kalendere","lokation":"Lokale","normal_varighed_i_minutter":"Normal varighet (i minutter)","oovrig_tid":"Øvrig tid","oovrig_tid_description":"ikke undervisning, ikke elevrelatert. ","optional":"Valgfag/gruppe","optional_description":"teller 100% og uavhengig av andre aktiviteter i samme tidsrom. ","pause":"Pause","pause_description":"andre timer bør ikke overlapper med en pause.","ressource":"Ressurs","ressource_description":"brukes til å markere ressursene i timeplanen. Teller ikke fra andre fag. Vises som standard ikke i elev- og foreldretimeplan.","skriv_et_bogstav_for_at_søge":"Skriv en bokstav for å søke...","skriv_hvad_brikken_hedder":"Skriv hva faget heter...","sygdom_ferie_etc":"sykdom, ferier osv. ","timer_på_årsbasis":"Timer(i skoleåret)","underviser":"Underviser","uuv":"UUV","uuv_description":null,"vælg_briktype":"Velg type","vælg_farve":"Velg farge","vælg_klasser":"Søk og velg klasser"},"new":{"ny_brik":"Nytt fag"},"subject_accordion_menu":{"absence":"Fravær","break":"Pause","exercise":"Bevegelse","flextime":"Fleksitid","frame":"Temavisning","optional":"Valgfag/gruppe","other_stuff":"Annet","other_tasks":"Andre oppgaver","pay_supplement":"Tillegg","person_resource":"Undervisningsressurser","resource":"Ressurs","subject":"Fag","supplemental":"Støtteundervisning"},"subject_draggable":{"hours_per_year":"t/år","per_week":"/uke"},"ws_edit":{"er_du_sikker":"Er du sikker?","opdater_brik":"Oppdater fag","redigér_brik":"Rediger fag","slet_brik":"Slett fag"}},"substitutes":{"edit":{"i_dag":"i dag","ingen_lektioner_for":"Ingen timer for","klasse":"Klasse","også_tilknyttet":"Også tilknyttet","se_alle":"Se alle","se_mindre":"Se mindre","søg_og_vælg":"Søk og velg","vikar":"Vikar","vikar_for":"Vikar for","vikarnoter":"Vikarnotater"},"known_absence":{"byt":"Bytt","feriedage":"Feriedager","fraværende_med_lektioner":"Fraværende med timer","kalenderen_for_7b":"Kalenderen til 7b","kursus":"Kurs","lektioner":"timer","lektioner_der_kan_byttes_med":"Timer som kan byttes: ","lektioner_der_skal_håndteres":"Timer som skal håndteres: ","opret_fravær":"Opprett fravær","opret_planlagt_fravær":"Opprett planlagt fravær","syg":"Syk"},"substitute_day":{"klasse":"Klasse"},"substitutes_edit":{"fraværsårsager_og_skemaoverblik":"Fraværsårsaker og timeplanoversikt","tilføj_kalendre":"Tilføy kalendere","vælg_klasse":"Velg klasse","vælg_lokale":"Velg lokale","vælg_person":"Velg person","vælg_person_vikardækning":"Velg person(er)"},"substitutes_show":{"ingen_vikarer_i_dag":"Ingen vikarer i dag"},"substitutes_show_teachers":{"ingen_fraværende_i_dag":"Ingen fraværende i dag"}},"time":{"formats":{"day_only":"%A","devise":{"mailer":{"invitation_instructions":{"accept_until_format":"d. %B %d, %Y %I:%M"}}},"time_only":"%H:%M"}},"unilogin":{"welcome":{"create_a_trial":"Start en gratis prøveperiode!","eller":"eller","enten_giver_din_stilling_dig_ikke_mulighed_for_at_kigge_med_eller_også_er_din_skole_er_ikke_på_docendo_endnu":"Du har ikke tilgang til denne siden, eller så er skolen din enda ikke på Docendo.","hvis_du_vil_have_din_skole_på_docendo_så":"Hvis du ønsker skolen din på Docendo så","kontakt_os":"kontakt oss","prøv_en_demoperiode":"Start en gratis prøveperiode","student_or_parent":"Er du elev eller foresatt?","student_or_parent_info":"Hvis du ser etter din eller ditt barns timeplan, bør denne vanligvis finnes på skolens nettside. Vi anbefaler at du kontakter skolens administrasjon hvis du ikke har tilgang til timeplanen.","velkommen":"Velkommen"}},"users":{"assign_user_hours":{"anden_tid":"Annen tid","der_var":"Det var","fejl_se_nedenfor":"feil. Se nedenfor","lommeregner":"Kalkulator","skemalagt":"Timeplanlagt","tildeling_af_timer":"Tildeling av timer","tildelt":"Tildelt","total_på_år":"Totalt i året","undervisning":"Undervisning","Øvrig_tid":"Øvrig tid"},"create":{"add_user":"Opprett bruker","add_user_with_uni":"- ","create_teacher":"Opprett underviser","fictive_user":"Bruker uten innlogging","fictive_user_text":"Brukeren har en kalender og det er mulig å legge til brukeren som underviser i skolens timeplaner. Dette kan brukes for lærere som ennå ikke er ansatt, eller vikarer uten unilogin. Brukeren kan ikke logge på Docendo.","notify_user_more_users":"Du må selv gi brukerne en melding om tilføyelsen. Du kan skrive flere brukernavn i feltet nedenfor, adskilt med mellomrom.","user_does_not_exist":"Underviseren eksisterer ikke","user_with_email":"Bruker med e-post","user_with_email_text":"Brukes til å opprette brukere med e-post. Brukeren kan logge på med e-post og passord. Det blir sendt en e-post til brukeren med instruksjoner."},"edit":{"annullér":"Annuller","redigér_bruger":"Rediger bruker"},"files_for_download":{"files_to_download":"Filer til nedlasting"},"form":{"andre_undervisere_vide":"Hva kan andre undervisere trenge å vite om deg?","beskrivelse":"Beskrivelse","du_kan_skrive_om_dine_interesser_fag_klassetrin_færdigheder_etc":"Du kan skrive om dine interesser","email":"E-mail","fejl_forhindrede_denne_bruger_i_at_blive_gemt":"feil forhindret at denne brukeren ble lagret:","fjern_profilbillede":"Fjern profilbilde","hvilke_fag":"Hvilke fag","hvilke_klassetrin_underviser":"(Hvilke klassetrinn underviser du?)","initialer":"Initialer","initialer_på_skolen":"Initialer på skolen","klassetrin":"Klassetrinn","opdatér_profil_fra_uni-c":"Oppdater profil fra UNI-C","profilbillede":"Profilbilde","skriv_dit_navn":"Skriv ditt navn","upload_nyt_profilbillede":"Last opp nytt profilbilde?","vælg_dine_fag":"Velg dine fag","vælg_dine_klassetrin":"Velg dine klassetrinn"},"hours":{"skoleåret":"Skoleåret"},"hours_list":{"_vikartimer":"vikartimer","min":"min.","vikartimer":"Vikartimer"},"hours_status":{"anden_tid":"Annen tid","ingen_data":"Ingen data","tildelt":"Tildelt","undervisning":"Undervisning","øvrig_tid":"Øvrig tid"},"list_all":{"alle":"Alle"},"members":{"personale":"Personale","se_alle":"Se alle"},"net_promoter_scores":{"new":{"nps_question":"Hvor sannsynlig er det at du vil anbefale Docendo til en venn eller kollega?","question_one":"Hva er den viktigste årsaken til karakteren du gav? ","reason":"Vi lager et timeplanleggingsprogram til mennesker, og dette er vanskelig å gjøre med mindre vi får tilbakemeldinger fra de som bruker programmet. Vi håper derfor at du vil hjelpe oss med å besvare de to følgende spørsmål. ","very_likely":"Svært sannsynlig","very_unlikely":"Lite sannsynlig"}},"password":{"bekræft_nyt_kodeord":"Bekreft nytt passord","fejl":"feil:","nyt_kodeord":"Nytt passord","skift_kodeord":"Bytt passord"},"profile":{"klassetrin":"Klassetrinn","om_mig":"Om meg","underviser_i":"Underviser i"},"remove_users_list":{"delete_user":"Fjern bruker","press_remove_to_remove":"Klikk på ''Fjern'' for å fjerne en bruker fra skolen.","remove_list_item_1":"Når en bruker blir fjernet, har vedkommende ikke lenger tilgang til skolens grupper eller kalendere.","remove_list_item_2":"Brukeren blir ikke fjernet fra timene på skolen.","remove_list_item_3":"Brukeren blir ikke slettet fra Docendo, men har ikke tilgang til skolen lenger."},"show":{"aktivitet":"Aktivitet","filer":"Filer:","grupper":"Grupper","indlæg":"Innlegg:","medlem_i":"Medlem i:"},"si_teachers_list":{"træk_læreren_fra_venstre_til_højre_for_at_tildele_initialer":"Dra læreren fra venstre mot høyre for å tildele initialer"},"substitute":{"følgene_lærere_er_ledige_i_tidsrummet":"Følgende lærere er ledige i tidsrommet","ingen_lærere_er_ledige_i_tidsrummet":"Ingen lærere er ledige i tidsrommet","kl":"kl.","vælg_vikar":"Velg vikar"},"tasks_status":{"fag_opgave":"Fag/oppgave","lagt_i_skema":"Lagt i timeplan","tildelt":"Tildelt","tilhører":"Timeplan","total":"Totalt"},"user_item_abandoned_user":{"grupper":"Grupper: ","indlæg":"Innlegg:","kalenderaftaler":"Kalenderavtaler:","material_count":"Material count: "},"user_item_profile_calendar_lastseen":{"se_profil":"Se profil","se_tildeling":"Se tildeling"},"user_item_remove_user":{"delete_user":"Fjern bruker"},"user_item_select_substitute":{"vælg_som_vikar":"Velg som vikar"},"user_merge_details":{"aftaler":"Planlagte aktiviteter","groups":"Skoler"}},"views":{"pagination":{"first":"Første","last":"Siste","next":"Neste","previous":"Tidligere","truncate":"..."}},"vue":{"buy":{"a_user_is":"En bruker er en ansatt som har en kalender og / eller innlogging, dvs. en lærer, en pedagog, en vikar etc.","billed_monthly_or_yearly":"Betal månedlig eller årlig","buy":"Kjøp","buy_access_for_school_users":"Kjøp tilgang til skolens brukere","call_us_at":"Ring oss på","choose_the_right_price":"Velg riktig pris for jer","discount":"Rabatt","error":"Feil","go_to_home":"Klikk her for å gå til forsiden","institution":"institusjon","missing_inputs":"Du mangler å fylle ut noen felter","month":"måned","only_pay_per":"Betal kun for de brukere som skal kunne planlegges for, og/eller ha en innlogging","pay_for_unlimited_users_and_get":"Betal for skolens totale elevtall - og få et ubegrenset antall brukere","payment_info":"Betalingsinformasjon","per_month":"Pr. måned","per_student":"pr. elev","per_user":"pr. bruker","per_year":"Pr. år","popular":"populær","price":"pris","questions":"Spørsmål","save_2":"Spar 2%","school_name":"Skolens navn","subscription_info":"Abonnementsinformasjon","thanks_for_buying":"Takk for ditt kjøp.","total":"Total","total_student_number":"Skolens totale antall elever","unlimited":"Ubegrenset","write_number_of_students":"Skriv skolens totale elevtall - og få ubegrenset antall brukere *","write_number_of_users":"Skriv inn antall brukere som vil være i stand til å logge inn / bli planlagt for","your_email":"E-posten din","your_invoice":"Din faktura","your_name":"ditt navn","your_phonenumber":"Telefonnummeret ditt"},"deleteday":{"delete_day_or_week":"Slett dag/uke","whole_week":"Hele uken"},"intro_home":{"step1_title":"Velkommen til Docendo","step3_title":"Navigasjon til alle funksjoner","step4_content":"Her finner du navigasjon til alle timeplaner i Docendo.","step4_title":"Navigasjon til alle timeplaner og kalendere.","step5_content":"Vi har oprettet en demo-timeplan for 4A (4A - DEMO) som du kan redigere, slik at du raskt kan få en følelse av mulighetene i Docendo.","step5_title":"Se demo-timeplan"},"public":{"app":{"sidenav":{"changeview":"Endre visning","showday":"Vis dag","showweek":"Vis uke","showweekplan":"Vis ukeplan"}},"no_notes":"Ingen notater for uken"},"recent_users":{"last_seen":"sist sett","never_logged_in":"aldri logget inn"},"sidenav":{"merge_calendar_special":"felles-timeplaner"},"vacations_days_selector":{"choose_period":"Velg periode","school_days":"skoledager","school_year":"Skoleår","vacation_for_pupils":"Ferier og helligdager"},"year_planning":{"distribute_hours_over_year":"Fordel timer i perioden","hours_during_period":"Timer i perioden","norm":"Fastsatt timetall","number_of_weeks":"Antall uker","planned":"Planlagt","school_days_during_period":"Skoledager i perioden"}}}}

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

	module.exports = {"a11y":{"mainNav":"Hovednavigasjon","openMenu":"Åpne meny","closeMenu":"Lukk meny","changeSchool":"Bytt skole","clearSearch":"Tøm søk","showStudents":"Vis/skjul elever","close":"Lukk","loading":"Laster"},"copycalendar":{"copy":"Kopier","paste":"Sett inn","pasteThisWeek":"Sett inn i denne uken","weekSelected":"uke valgt","weeksSelected":"uker valgt","markWeeksFrom":"Velg uker fra","allWeeks":"Alle uker","oddWeeks":"Oddetallsuker","evenWeeks":"Partallsuker","unselectAll":"Fjern valgte uker","deleteLessonsInSelectedWeeks":"Slett nåværende innhold i de valgte ukene","absenceWillNotBeDeleted":"fraværet vil ikke bli slettet","noticationMessage":"Kopierer","copiedFrom":"Kopieret fra","noSubstitutesOrNotes":"Ingen leksjoner med vikarer eller notater i de valgte ukene.","youAreAboutToDelete":"Du er i ferd med å slette,","lesson":"time","lessons":"timer","withSubstitutesOrNotes":"med vikarer eller notater","week":"Uke"},"homevideoes":{"video":"Video","video_guide":"Videoguides","introduction":"Introduksjon","watch_intro":"Se introduksjon til Docendo","klass_schedule":"Klassetimeplan","klass_schedule_overview":"Oversikt over klassens timeplan","teacher_calendar":"Undervisers kalender","teacher_calendar_overview":"Rundtur i underviserens kalender","notes_weekplan":"Notater & ukeplan","notes_weekplan_overview":"Bruk notater & ukeplaner","learn_to_substitute":"Lær å vikardekke med Docendo"},"vSelect":{"choose_persons":"Velg person(er)"},"substitute_hours":{"title":"Trekk ut timer for undervisere","choose_period":"Velg periode","all":"Alle","teaching":"Undervisning","substitute_hours":"Vikartimer","absence":"Fravær","choose_persons":"Velg person(er)","work_days":"dager","lessons":"undervisningstimer","calendar_event":"kalenderaktivitet","calendar_events":"kalenderaktiviteter","substitute_for":"Vikar for","substitute_hour":"Vikartime","other_tasks":"Andre oppgaver","other_stuff":"Øvrig tid","total":"Total","hours":"timer","hour":"time","min":"min","shortcuts":"Snarveier","show_all_absent":"Vis alle fraværende i perioden","getting_all":"Henter alle","absent_in_the_period":"fraværende i perioden","there_is_no_one_absent":"Det er ingen fravær i perioden","days_with_absence":"Dager med fravær"},"notifications":{"notifications":"Varsler","all":"Alle","unread":"Uleste","mark_all_as_read":"Merk alle som lest","sent_from":"Sendt fra","mark_as":"Merk som","read":"Lest","not_read":"Ulest","no_new_notifications":"Ingen nye varsler"},"presence":{"work_hours":"Arbeidstider","set_work_hours":"Legg inn arbeidstid","choose_weeks_for_work_hours":"Velg uker for arbeidstid","work_hours_in_the_week":"Timer i uken","cancel":"Angre","copy_to_multiple_weeks":"Sett inn i flere uker","back":"Tilbake","save":"Lagre","times_may_not_overlap":"Tidspunkt kan ikke overlappe","hours":"timer","minutes":"min","h":"t","m":"m","present":"Tilstede","not_present":"Ikke tilstede","total_working_hours":"Arbeidstid for året","edit_default_times":"Rediger standardtider","default_work_hours":"Standard arbeidstid"},"createusers":{"create_users":"Opprett bruker(e)","login_options":"Login mulighet(er)","can_be_added_later":"kan legges til senere","must_be_added":"Fylles ut","name":"Navn","mail":"mail","placeholder_name":"Fornavn etternavn","placeholder_email":"navn@skolemail.no","email_error_text":"Ugyldig e-mail","add_more":"Legg til flere","create":"Opprett","user":"bruker","users":"brukere","user_created":"Bruker opprettet!","users_created":"Brukere opprettet!","feide_is_already_used_for":"Feide er allerede lagt til"},"createuser_button":{"create_user":"Opprett bruker"},"toast":{"something_went_wrong":"Noe gikk galt"},"subject":{"azure":"Azurblå","blue":"Blå","bronze":"Bronse","brown":"Brun","coral":"Korall","grey":"Grå","green":"Grønn","purple":"Lilla","lightblue":"Lyseblå","lightblue2":"Lyseblå2","lightbrown":"Lysebrun","lightgreen":"Lysegrønn","lightyellow":"Lysegul","lightyellow2":"Lysegul2","lightpurple":"Lyselilla","lightred":"Rosa","marinoblue":"Marineblå","darkblue":"Mørkeblå","darkgreen":"Mørkegrønn","darkyellow":"Mørkegul","darkpurple":"Mørk lilla","darkorange":"Mørkoransje","darkorange2":"Mørkoransje2","orange":"Oransje","red":"Rød","red2":"Rød2","turkis":"Turkis"},"createklass":{"create_klasses":"Opprett klasse(r)","schoolyear":"Skoleår","klass_name":"Klassens navn","klass_step":"Klassetrinn for import av fag (valgfritt)","import_subjects_question":"Ønsker du å importere basisfagene for klassen?","import_subjects_done":"Disse fagene vil bli opprettet i klassen","subjects_for":"Fag for","klass":"klasse","klasses":"klasser","hoursPrYear":"t/år","grade":"klasse","warning_text":"Klasser kan ikke ha samme navn","succes_text":"Klasse(r) ble opprettet","creating":"Oppretter","import_subject_to_the_klass":"Importer fag til klasser","subjects_created_successfully":"Fag ble opprettet"},"createrooms":{"create_rooms":"Opprett rom","room_name":"Navn på rom","placeholder":"Idrettshallen","room":"rom","rooms":"rom","warning_text":"Rom kan ikke ha samme navn","succes_text":"Rom(-mene) ble opprettet!","creating":"Oppretter"},"creating":"Oppretter","createroom_button":{"create_room":"Opprett rom"},"editCalendarEditName":{"edit_name":"Rediger navn","calendar_name":"Kalenderens navn","warning_text":"Navnet kan ikke stå blankt","update_name":"Oppdater navn","success_text":"Navnet er oppdatert!"},"editCalendarMenu":{"edit_name":"Rediger navn","delete_calendar":"Slett kalender","remove_calendar":"Arkiver kalender","delete_klass":"Slett klasse","delete_club":"Slett SFO","delete_kindergarten":"Slett avdeling","remove_room":"Arkiver rom","remove_merge":"Arkiver fellestimeplan","view":"Visning","5_days":"5 dager","7_days":"7 dager","7_days_and_24_hours":"7 dager, 24 timer","lock":"Lås kalenderen","unlock":"Lås opp","calendar_is_locked":"Kalenderen er låst","merge_with_merge_calendars":"Synkroniser med fellestimeplan","merge_with_calendar":"Synkroniser med klasser","is_merged":"Er synkronisert med","can_be_merged_into":"Kan synkroniseres med","see_public_view":"Se elevvisning","active_public_view":"Aktiver elevvisning","show_grid":"Vis ringetider","hide_grid":"Skjul ringetider"},"editCalendarDelete":{"delete_calendar":"Slett kalender","deleting_this_calendar":"Du er i ferd med å slette kalenderen","all_data_will_be_deleted":"Alle kalenderaktiviteter vil bli slettet permanent, og denne informasjonen kan ikke gjenopprettes.","validator_name":"slett kalenderen","write":"Skriv","if_you_want_to_delete":"hvis du vil slette denne kalenderen","you_have_to_write":"Du må skrive","success_text":"Kalenderen er slettet"},"setupWidget":{"do_steps_for_scheduling":"6 steg for å komme i gang med timeplanleggingen","get_going_easy":"Kom i gang","follow_these_steps":"Følg veiledningene i videoene","write_us":"Chat med oss","support_forum":"Supportforum"},"createmerge":{"create_merge":"Opprett fellestimeplan(er)","name":"Navn","placeholder":"Pauser","calendar":"kalender","calendars":"kalendere","warning_text":"Kalendere kan ikke ha samme navn","succes_text":"Kalender(e) ble opprettet!"},"sidenav":{"not_created_klass":"Du har ikke opprettet noen klasser","not_created_users":"Du har ikke opprettet noen brukere","not_created_rooms":"Du har ikke opprettet noen rom","not_created_merge":"Du har ikke opprettet noen fellestimeplaner","not_created_other":"Du har ikke opprettet noen andre kalendere"},"year_transfer":{"copy_klasses_from":"Kopier kalendere fra skoleåret","to":"til","copy_nothing":"Ikke kopier","klass_name":"Kalendernavn","klass_name_desc":"Kopierer en kalender med samme navn til det nye skoleåret, uten fag.","klass_name_and_subjects":"Navnet på kalenderen og fag inkl. timetall","klass_name_and_subjects_desc":"Kopierer en kalender med samme navn og fag inkl. timetall til det nye skoleåret.","klass_name_and_subjects_with_teachers":"Navnet på kalenderen og fag inkl. timetall og tilknyttede undervisere og rom","klass_name_and_subjects_with_teachers_desc":"Kopierer en kalender med samme navn til det nye skoleåret, i tillegg til fag inkl. timetall og tilknyttede undervisere og rom.","choose_all":"Velg alle","img_src_one":"http://support.docendo.dk/img/transferyear/1NO.png","img_src_two":"http://support.docendo.dk/img/transferyear/2NO.png","img_src_three":"http://support.docendo.dk/img/transferyear/3NO.png","year_transfer_link":"Vil du opprette klasser med navn og fag fra siste skoleår? Klikk her","from_week_33_in":"fra uke 33 i","to_week_33_in":"til uke 33 i","klass_name_and_subjects_with_teachers_and_schedules":"Klassens navn og fag inkl. timetall og tilknyttede undervisere, rom og timeplaner","calendar_already_exist":"kalenderen eksisterer allerede","everything_is_copied_except":"Alt kopieres undtagen evt. tilknyttede klasser","everything_is_copied_except_tooltip":"Hvis det er mer enn én klasse knyttet til brikkene, blir disse ikke kopiert, da de tilknyttede klassene tilhører det forrige skoleåret","and_schedules":"og skema","from_week":"Fra uke","to_week":"Til uke"},"assign_users_hours":{"assign_hours":"Tildel timer","search_a_name":"Søk etter navn","work_hours":"Arbeidstid","teaching":"Undervisning","substitute_hours":"Vikartimer","absence":"Fravær","name":"Navn","assigned":"Tildelt","scheduled":"Planlagt","diff":"Differanse","update":"Oppdater tall","applies_to_the_period":"Gjelder perioden","tasks":"Oppgaver","preparation":"Forberedelse"},"tagging":{"tagging_users":"Gruppering av brukere","users_selected_from":"brukere valgt av","add_tag_to":"Legg til","select_persons_first":"Velg personer først","select_all":"Velg alle","unselect_all":"Velg ingen","already_created":"Allerede opprettet","example_tags":"Eks. Lærer, Vikar, Team","create_tag":"Opprett tagg","search_tag":"Velg gruppe","create_tags":"Opprett tagg","with":"med","you_have_created_zero_tags":"Du har opprettet 0 taggs"},"dselect":{"no_matching_results":"Ingen matchende resultater","create_user":"Opprett bruker","placeholder":"Søk etter person","in_same_klass":"I samme klasse","placeholder_calendars":"Søk og velg"},"substitution":{"substitution":"Fraværs- og vikarhåndtering","none_absent":"Ingen fraværende","number_absent_today":"Antall fraværende i dag","today":"I dag","create_absence":"Opprett fraværende","who":"Hvem","person_must_be_filled":"Person må utfylles","reason":"Årsak","choose_absence_reason":"Velg fraværsårsak","create":"Opprett","reason_must_be_filled":"Årsak må utfylles","date":"Dato","time":"Tid","absent_period":"Fraværsperiode","do_you_want_to_delete_the_absent_reason":"Vil du slette fraværsårsaken","yes":"Ja","cancel":"Annuller","substitutes_will_not_be_removed":"Vikarer i timeplaner vil IKKE bli fjernet. Fjern evt. disse først.","subject":"Fag","class":"Klasse","other_users":"Også tilknyttet","substitute":"Vikar","substitute_notes":"Vikarnotater","todays_lessons":"Dagens timer","see_all":"Se alle","see_less":"Se mindre","absence_is_created_in_a_calendar":"Fraværet er lagt inn en kalender, og må derfor slettes i denne.","go_to_calendar":"Gå til kalender","deleting_absence_from":"Slett fraværet for","to":"til","choose_absence_user":"Velg en eller flere lærere","absence_notes":"Notat for fravær","add_sub_to_several_lesson":"Sett en vikar på flere leksjoner","find_sub_for":"Finn vikar til","lessons":"leksjoner","finding_available_subs":"Finne tilgjengelig vikarer","select_lessons_to_substitute":"Velg leksjoner som skal dekkes av vikarer","overlap":"overlapping","available":"Tilgjengelig","working_hours":"Arbeidstid","busy":"Opptatt","do_you_want_to_save":"Vil du lagre endringene dine","no_close_without_saving":"Nei, lukk uten å lagre","yes_save_my_changes":"Ja, lagre endringene mine","lessons_updated":"Leksjoner oppdatert","lessons_without_sub":"Leksjoner uten vikarer","lessons_with_sub":"Leksjoner med vikarer","all_lessons":"Alle leksjoner","no_lessons_without_subs":"Ingen leksjoner uten vikarer","no_lessons_with_sub":"Ingen leksjoner med vikarer","no_lessons":"Ingen leksjoner","remove_sub_from_all_lessons":"Fjern som vikar for alle leksjoner","do_you_want_to_remove":"Vil du fjerne","as_sub_on":"som vikar på","or_on_all_lessons":"eller i alle leksjoner","remove_from_all_lessons":"Fjern fra alle leksjoner","just_this_lessons":"Bare i denne leksjonen","choose_period_lessons":"Velg en periode for å se leksjoner","from_selected_date_onwards":"Fra valgt dato og videre","entire_period":"Hele perioden","selected_date":"Valgt dato","lessons_that_overlap_in_class":"Samtidig i klassen","delete_lesson":"Slett leksjon","settings":"Innstillinger","include_reservations":"Ta med reservasjoner i vikardekning","show_overlapping_class_badge":"Vis +ikon ved personer samtidig i klassen"},"substitution_user":{"multiple_days":"Flere dager","lessons_on_day":"Undervisningstimer denne dag","lessons_affected_by_absence":"Timer påvirket av fravær","absent":"Fraværende"},"substitution_show":{"show_all_lessons":"Vis alle timer","show_the_absent":"Vis fraværende","lessons":"Timer","choosen_lessons":"Valgte timer"},"sub_scheduler":{"filter_substitutes":"Filtrer vikarer","sub_pools":"Vikarpuljer","todays_absent":"Dagens fraværende","potential_subs":"Mulige vikarer","choose_sub":"Velg vikar","status":"Status","sort_after":"Sorter etter forslag","set_priorities":"Velg prioriteringer","sorting_will_be_based_on":"Sorteringen baseres på","has_canceled_hours":"Har avlyste timer i tidsrommet","already_on_lesson":"Også tilknyttet timen","not_occupied_with_available_lesson":"Ledig m/rådighetstime","not_occupied_with_work_hours":"Ledig m/arbeidstid","not_occupied_without_work_hours":"Ledig u/arbeidstid","multiple_lessons_in_same_classes":"+2 lærere samtidig i en annen klasse","not_occupied_without_lessons_on_the_day":"Ledig u/timer på dagen","is_in_same_class_at_the_same_time":"Er i klassen samtidig","has_hours_in_class_on_day":"Har timer i klassen på dagen","occupied":"Opptatt","occupied_in_selected":"Opptatt i {occupied} av {total}","it_will_also_be_sorted_based_on_tags_in_common":"Sorteringen skjer også ut fra antall taggs til felles med den fraværende","absent_people":"Fraværende","substitutes":"Vikarer","out_of":"av","potential_substitutes":"Potensielle vikarer","pool":"Pulje","choose_filters":"Velg filtre","list":"Liste","schedules_overview":"Timeplanoverblikk","is_substituted":"Er vikar-dekket"},"sub_scheduler_item":{"prolonged_absence":"Langtidsfravær","also_on_lesson":"Også tilknyttet"},"sub_scheduler_popover":{"substitute_for":"Sett inn vikar for","handled":"Håndtert","not_handled":"Ikke håndtert","handled_for_absence":"Håndtert for alle fraværende","pending":"Avventer"},"sub_scheduler_sub_pools":{"substitute_hours":"Vikartimer","difference":"Forskjell","assigned":"Tildelt","scheduled":"Planlagt"},"IEWarning":{"you_are_using_a_IE_or_Edge_to_get":"OBS! Du bruker Internet Explorer/Edge. For å få","a_faster_and_better_experience":"en raskere og bedre opplevelse","we_recommend_that_you_switch_to_these_browsers":"anbefaler vi at du bytter til en av disse gratis nettleserne","or":"eller"},"dashboard":{"welcome":"Velkommen","start_by_setting_up":"Kom i gang  med Docendo","steps_completed":"Steg gjennomført","step":"Steg","tutorial":"Video","follow_the_steps":"Følg oppsettingsguiden"},"delete_day_or_week":{"cant_delete":"Kunne ikke slette. Prøv igjen."},"user_event_list":{"teaching":"Undervisning","substitute_hours":"Vikartimer","absence":"Fravær","from":"fra","to":"til","no_matching_events":"List is empty","total":"Total","close":"Lukk"},"weekplan_2":{"no_events_this_week":"Ingen leksjoner denne uken"},"event_form":{"delete_events_onward":"Slett dette og alt for samme tid fremover","are_you_sure":"Er du sikker?","do_you_want_to_delete_this_and_all_in_same_timeslot":"Vil du slette denne leksjonen og alt som er på samme ukedag og i samme tidsrom fremover?","cancel":"Avbryt"},"calendar_export":{"export_calendar":"Eksporter kalender","export_calendar_to":"Eksporter kalenderen til...","copy_the_url_and_insert":"Kopier følgende URL og sett inn i den eksterne kalenderen","guide_to":"Veiledning til","guide_to_export_calendar":"Instruksjoner for eksport til en ekstern kalender","create_a_link_on_mobile":"Sette opp timeplaner på mobil"},"common":{"search":"Søk","groups":"Grupper","show_print_hours":"Vis beregn timer","show_as_blocks":"Vis som blokker","show_as_list":"Vis som liste","add":"Legg til","save":"Lagre","saved":"Lagret","dont_save":"Ikke lagre","create":"Opprett","cancel":"Annuller","update":"Oppdater","edit":"Redigere","delete":"Slett","select":"Velg","yes":"Ja","no":"Nei","save_changes":"Ønsker du å lagre endringene?","ago":"siden","min":"min","class":"Klasse","classes":"Klasser","classes_sidenav":"Klasser","teacher":"Underviser","room":"Rom","substitute":"Vikarer","add_user":"Tilføy bruker","press":"Trykk","user":"Bruker","users":"Brukere","rooms":"Rom","merge_calendar":"Fellestimeplan","merge_calendars":"Fellestimeplan","merge_calendars_sidenav":"Felles-timeplaner","other_calendar":"kalender","other_calendars":"Andre kalendere","close":"Lukk","must_be_filled":"Må utfylles","something_went_wrong":"Noe gikk galt","show_weekends":"Vis helger","calendar":"Kalender","in":"i","search_for":"søk etter","remove":"Fjern","none_created":"None created","log":"Historikk","no_calendars_found":"Ingen kalendere funnet..","done":"Ferdig","is_deleted":"er slettet","choose_school":"Velg skole","no_active_school_years":"Det er ingen aktive skoleår. Be en administrator om å åpne opp.","show_more":"Vis flere","show_less":"Skjul flere","search_name_or_initials":"Søk på navn eller initialer","hide_calendars":"Skjul kalendere","hide_dates":"Skjul datoer"},"weeknote_log":{"saved_versions":"Lagrede versjoner av ukentlige notater","activity":"Historikk","no_saved_versions":"Ingen lagrede versjoner","choose_versions_to_compare":"Velg versjoner for sammenligning","current_version":"Gjeldende versjon"},"show_event":{"this_lesson_counts_as":"Denne leksjonen teller som"},"permissions":{"can_request_absence":"Fravær - Kan sende forespørsel om fravær","can_handle_absence_requests":"Fravær - Kan godkjenne forespørsler om fravær","roles":"Roller","create_new_role":"Opprett ny rolle","users":"Brukere","users_assigned_role":"brukere tildelt rollen","add_user_to":"Tilføy bruker","role":"rolle","permissions":"Tillatelser","change_permissions_for_role":"Endre tillatelser for rollen","rename_role":"Endre navn på rollen","delete_role":"Slett rollen","give_role_a_title":"Gi rollen et navn","choose_new_name":"Velg nytt navn","you_cant_delete_a_role_that_has_users":"Du kan ikke slette en rolle som har brukere tilknyttet","give_the_following_user_a_new_role":"Gi følgende brukere en ny rolle","can_change_substitution":"Vikarhåndtering - Tilgang til vikarhåndteringen","can_send_substitute_sms":"Vikarhåndtering - Kan sende SMS'er","can_do_most_stuff":"Kan gjøre det meste","can_edit_own_notes":"Timeplan - Kan redigere notater","can_export":"Kan eksportere til Docendo ZEN","can_manage_absence_reasons":"Vikarhåndtering - Kan opprette, slette og redigere fraværsårsaker","can_manage_assigned_hours":"Tildele timer - Kan redigere i Tildele timer","can_see_assigned_hours":"Tildele timer - Tilgang til Tildele timer","can_manage_school_years":"Kan redigere skoleår","can_manage_sms":"Kan sende SMS","can_manage_substitute_hours":"Kan redigere vikartimer","can_manage_tasks":"Kan redigere Oppgaver","can_manage_users":"Kan håndtere brukere","can_see_other_calendars":"Timeplan - Kan se alle kalendere","can_manage_calendars":"Kan opprette, slette og redigere kalendere","change_role":"Endre rolle","role_desc_administrator":"En administrator har tilgang til alle funksjoner i Docendo, og kan redigere brukerrettigheter for alle roller.","role_desc_read_only_user":"En bruker med lesetilgang har som utgangspunkt kun adgang til egen kalender, og brukeren kan ikke se eller redigere andre kalendere eller bruke vikarhåndteringen og andre administrative funksjoner. Denne rolle kan derimot tildeles tilgang til utvalgte funksjoner.","role_desc_regular_user":"En Vanlig bruker har tilgang til alle timeplaner/kalendere og de fleste funksjoner, men kan ikke tilføye, endre eller slette brukere og skoleår.","role_updated":"Rollen er oppdatert","role_deleted":"Rollen er slettet","role_created":"Rollen er opprettet","can_see_other_subject_requests":"Fagønsker - Kan se andres ønsker","can_edit_subject_requests":"Fagønsker - Kan ønske fag (når det er åpnet for Fagønsker)","can_see_subjects_distribution_page":"Fag- og lærerfordeling - Tilgang til fag- og lærerfordeling","can_see_others_task_overviews":"Oppgaveoversikt - Kan se andres oppgaveoversikt","can_see_own_task_overview":"Oppgaveoversikt - Kan se sin egen oppgaveoversikt","can_change_task_overview":"Oppgaveoversikt - Kan velge om fag vises på oppgaveoversikten","can_see_others_hour_overviews":"Timeregnskap - Kan se andres timeregnskap","can_see_own_hour_overview":"Timeregnskap - Kan se sitt eget timeregnskap","can_edit_own_presence":"Arbeidstid - Kan redigere sin egen arbeidstid","can_edit_others_presence":"Arbeidstid - Kan redigere andres arbeidstid","can_edit_user_year_notes":"Oppgaveoversikt - Kan skrive og redigere notater hos andre","can_send_substitute_email":"Vikarhåndtering - Kan sende emails","select_role_to_base_new_on":"Velg en rolle den nye skal baseres på"},"calendars":{"calendars":"Kalendere","edit_calendars":"Slett / gi nytt navn til kalendere","copy_calendars":"Kopier kalendere","archive":"Fjern","show":"Se","hide":"Skjul","archived":"fjernet","unarchive":"Gjenopprett","write_name":"Skriv navn","selected_of":"valgt av","select_calendars_to_copy":"Velg kalendere som skal kopieres","copy":"Kopier","select_week_to_copy_from":"Velg uke å kopiere fra","select_weeks_that_week":"Velg uker som uke","must_be_copied_to":"må kopieres til","print_calendars":"Skrive ut kalendere","add_presence":"Legg til arbeidstid","do_you_want_to_delete":"Ønsker du å slette","delete_events_in_date_range":"Slett hendelser i datointervallet"},"sms":{"sms":"Melding","do_you_want_to_delete_the_template":"Vil du slette meldingen","template_sms_deleted":"Meldingen er slettet","an_error_occured":"Det oppsto en feil","add_number":"Legg til mobilnummer","number_must_be_8_digits":"Telefonnummer må være 8 sifre","number_deleted":"Telefonnummer slettet","number_added_awaiting":"Nummeret er lagt til. Venter på bekreftelse","edit":"Rediger","new":"Ny","standard_sms":"standard-meldingen","title":"Tittel","to_show_in_list":"til visning i listen","ex_you_are_sub":"Eks. Du er blitt vikar","insert_today_to":"Sett inn [today] for få dagen eks.","updated_sms_template":"Oppdaterte meldingen","created_sms_template":"Opprettet meldingen,","message":"Beskjed","subject":"Emne"},"subs_ongoing_absence":{"delete_absence":"Slett fravær","change_start_and_end_date":"Endre start- og sluttdato","ongoing_absence":"Løpende lengre fravær","ongoing_absence_explained":"Løpende fravær forlenges automatisk når den opprinnelige sluttdatoen for fraværet er nådd. Sluttdatoen er den forventede siste dato for fraværet. Fraværet forlenges med én dag om gangen frem til man avslutter fraværet.","date_label":"Dato (inkl. begge dager)","absence_will_be_deleted":"Fravær slettes","remove_subs_and_delete_absence":"Fjern vikarer og slett fravær","keep_subs_and_delete_absence":"Behold vikarer og slett fravær","remove_subs_and_update":"Fjern vikarer og oppdater","keep_subs_and_update":"Behold vikarer og oppdater","remove_subs_and_stop_ongoing_absence":"Fjern vikarer og stopp løpende fravær","keep_subs_and_stop_ongoing_absence":"Behold vikarer og stopp løpende fravær","confirm_date_and_stop_ongoing_absence":"Bekreft datoer og stopp løpende fravær","update_dates":"Oppdater datoer","checking_for_substitutes":"Ser etter vikarer vikarer","lessons_with_substitutes":"Timer med vikar","no_subs_on_lessons":"Ingen vikarer er planlagt i de dagene fraværet slettes","of":"av","lessons_that_will_have_subs_removed":"timer får slettet vikarer","select_all":"Velg alle","unselect_all":"Fjern alle","remove_sub":"Fjern vikar","teachers_with_ongoing_absence":"Undervisere med løpende fravær","no_teachers_with_ongoing_absence":"Ingen undervisere med løpende fravær","absence_will_be_prolonged_in":"Forlenges om","edit_stop":"Rediger/stopp","subs_removed":"Vikarer fjernet","absence_deleted":"Fravær slettet","auto_created_today":"Opprettet automatisk i dag","absence_updated":"Fravær oppdatert","stop_ongoing_absence":"Stopp løpende fravær","cant_be_ongoing_absence":"Løpende fravær kan ikke opprettes med en sluttdato tidligere enn dagens dato","auto_created":"Opprettet automatisk"},"zen_import":{"import_from_zen":"Importer timeplanversjonene fra ZEN til Docendo","choose_version":"Velg timeplanversjoner","you_have_no_created_any_versions":"Du har ikke opprettet timeplanversjoner i ZEN","last_updated":"Siste endring","choose_schoolyear":"Velg skoleår","insert_in_week":"Sett inn i uke","insert_schedules":"Sett inn timeplaner","week":"Uke","schedules_are_being_inserted":"Timeplaner settes inn i uke","changes_from_import":"Endringer ifm. import","changes_from_import_help":"Se og angre endringene en import har gjort på kalendere og fag.","no_imports":"Det er ikke gjort noen importer ennå","view_changes":"Se endringer","import_processing":"Importen behandles…","no_changes_in_import":"Importen førte ikke til noen endringer","created_calendars_title":"Opprettede kalendere","changed_calendars_title":"Endrede kalendere","created_subjects_title":"Opprettede brikker","changed_subjects_title":"Oppdaterte brikker","created_title":"Opprettet","changed_title":"Endret","type_column":"Type","type_calendar":"Kalender","type_subject":"Brikke","delete":"Slett","undo_change":"Angre endring","confirm":"Er du sikker?","yes":"Ja","cancel":"Avbryt","done_deleted":"Slettet","done_reverted":"Angret","field_name":"Navn","field_color":"Farge","imported":"Importert","calendars_label":"kalendere","subjects_label":"brikker","download_to_excel":"Last ned til Excel","excel_calendar":"Kalender","excel_field":"Felt","excel_old_value":"Før","excel_new_value":"Etter"},"create_calendars":{"other_calendar":"Opprett annen kalender","other_calendar_placeholder":"Eks. møtekalender"},"create_subject":{"create_subject":"Opprett fag","subject_is_not_created_in_this_school_year":"Brikken er opprettet. Vær imidlertid oppmerksom på at den er tilknyttet et skoleår som ikke matcher den nåværende datoen."},"task_overview":{"task_overview":"Oppgaveoversikt","hour_overview":"Timeregnskap","task_and_hour_overview":"Oppgaveoversikt og timeregnskap","no_tasks_assigned":"Ingen oppgaver tildelt","transfer_scheduled_to_assigned":"Overfør planlagt til tildelt","transfer_scheduled_only_full_period":"Kun mulig når hele perioden er valgt","transfer_scheduled_already_equal":"Tildelt og planlagt er allerede like","transfer_scheduled_success":"{name}: tildelt endret fra {from} til {to}","transfer_scheduled_no_permission":"Du har ikke rettighet til å endre timer på skolen brikken hører til","transfer_scheduled_other_calendar_hours":"{name} kan ikke overføres, fordi {calendars} har sitt eget timetall på brikken, som vises i stedet. Endre det under Rediger.","assign_teacher_to_subject_title":"Læreren er ikke på brikken","assign_teacher_to_subject_text":"{teacher} har timer i {name} ({calendar}), men er ikke knyttet til selve brikken. Vil du tildele {teacher} til brikken, slik at du kan overføre timer og redigere?","assign_teacher_to_subject_confirm":"Tildel lærer","assign_teacher_to_subject_success":"{teacher} er tildelt {name}","distribution":"Fordeling","work_hours":"Arbeidstid","teaching":"Undervisning","tasks":"Oppgaver","preparation":"Forberedelse","show_scheduled_hours":"Vis planlagte timer","coming_soon":"Kommer snart","belongs_to":"Tilhører","absence":"Fravær'","reset":"Tilbakestill datoer","club":"SFO","substitute_hours":"Vikartimer","showing_scheduled_hours_from":"Viser planlagte timer fra","rest":"Rest","pool":"Planleggingsdager","unknown":"Beredskapstimer","diff_from_total_workhours":"For mange timer fordelt i forhold til arbeidstid","rest_missing_tooltip":"{hours} timer mangler å bli fordelt","rest_too_many_tooltip":"{hours} timer for mye fordelt i forhold til arbeidstid","rest_balanced_tooltip":"Alle timer er fordelt"},"standard_settings":{"standard_setting":"Standardinnstilling","set_default_start_and_endtime":"Angi standard start- og sluttid"},"print_all_calendars":{"loading":"Henter alle timeplaner. Det kan ta litt tid..","no_calendars":"Det er 0 kalendere med leksjoner","are_you_ready_to_print":"Er du klar til å skrive ut?","print":"Skrive ut","this_calendar":"Denne kalenderen","this_calendar_with_weekplan":"Kalender m. ukeplan","all_classes":"Alle klasser","all_teachers":"Alle lærere","all_rooms":"Alle rom","only_printing_calendars_with_lessons":"Printer kun timeplaner med timer","show_print_without_bg_colors":"Print uten bakgrunnsfarger","event_font_size":"Skriftstørrelse","custom":"Velg kalendere"},"edit_event":{"teachers":"Lærere","substitutes":"Vikarer","rooms":"Rom","klass":"Klasser","swap_headline":"Følgende leksjoner kan byttes med den valgte leksjon","swap_desc":"Bytt-funksjonen brukes til å bytte ut en eksisterende leksjon med en annen planlagt leksjon fra en annen tid i samme kalender. Dette betyr at man kan flytte en planlagt leksjon til en annen tid og erstatte den med en annen leksjon fra samme kalender. Følgende leksjoner er mulige å bytte med den valgte leksjonen, siden både læreren og klasserommet vil være tilgjengelige i de nye tidspunktene.","swap_no_lessons":"Dessverre ingen leksjoner å bytte med...","select":"Velg","replace_headline":"Erstat leksjonen med en ny","replace_desc":"Erstat-funksjonen brukes til å erstatte en eksisterende leksjon med en ny (ikke-planlagt) leksjon fra et valgt fag. Det er mulig å erstatte leksjonen med en ny fra de følgende fagene, siden både læreren og rommet er tilgjengelig.","replace_no_lessons":"Dessverre ingen leksjoner å erstatte med...","lesson_updated":"Leksjonen er oppdatert"},"students":{"all":"Alle","activated_schedules":"Aktiverte elevtimeplaner","student":"elev","students":"elever","created_student":"Elev opprettet","delete_student":"Fjern elev?","add_student":"Legg til fra andre klasse","create_student":"Opprett elev","students_with_same_name":"Følgende elever har et lignende navn","users_with_same_name":"Følgende brukere har et lignende navn","latest_updated":"Senest oppdatert","is_already_in_the_klass":"Er allerede i klassen","without_a_group":"uten klasse","has_no_groups":"Ingen klasser tilknyttet","name":"navn","feide":"feide","feide_is_already_used":"Dette Feide er allerede i bruk","import_students":"Importer elever","groups":"grupper","without_group":"Uten klasse","calendar":"kalender","remove":"fjern","of":"av","students_in":"elever i","the_group":"klassen","select_all":"Velg alle","unselect_all":"Fravelg alle","insert_multiple_students":"Sett inn liste over elevnavn. Bytt linje etter hver elev.","create_multiple_students":"Opprett flere elever samtidig","to_be_scheduled":"Kan planlegges"},"set_standard_duration":{"lessons_duration":"Timelengde","minutes":"minutter","set_standard_duration_for_the_school":"Standard timelengde på skolen","standard_duration_for_the_school":"Angi standard timelengde for skolens undervisningstimer","the_number_must_be_divisible_by_five":"Minuttallet må gå opp i 5","this_setting_will_be_selected_if_nothing_else_is":"Denne innstillingen vil gjelde, hvis man ikke velger annet.","standard_duration_can_be_selected_for_each_course":"Timelengden kan alltid endres for hvert enkelt fag","already_created_courses_want_be_updated":"Fag som allerede er opprettet vil ikke oppdateres","set_standard_length_for_zen":"Standardlengde på skoletimene brukes til å utregne antall leksjoner/timer i uken i en timeplan i Docendo ZEN."},"club":{"club":"SFO","club_calendar":"SFO-kalender","create_club_calendar":"Opprett SFO-kalender","not_created_club":"Med en timeplan for SFO kan du planlegge SFO-tid for ansatte uavhengig fra skoleundervisning"},"calendar_view":{"next_week_disabled_tooltip":"Mangler du en uke? Skolens administratorer kan redigere skoleårets varighet under ⚙️ > 'Skoleår'"},"calendar_view_day":{"remove":"Fjern","add":"Legg til","replace":"Erstatt","actions_for":"Handlinger for","onwards":"fremover","remove_onwards":"Fjern fremover","do_you_want_to_remove":"Ønsker du å fjerne","on_all_lessons_from":"på alle leksjoner fra og med","and_onwards":"og på alle fremtidige leksjoner","add_onwards":"Legg til fremover","do_you_want_to_add":"Ønsker du å legge til","on_all":"på alle","lessons":"leksjoner","onwards_which_include":"fremover? Dette inkluderer leksjoner fra og med","and_all_onwards":"og på alle fremtidige leksjoner","with_on_all":"med på alle","select_the_person_to_replace":"Velg kalenderen du vil erstatte","select_person":"Velg kalender","replace_onwards":"Erstatt fremover","set_end_date":"Sett sluttdato","until_and_including":"til og med"},"eventTypes":{"subject":"Fag","optional":"Valgfag/gruppe","supplemental":"UUV","frame":"Temavisning","break":"Pause","resource":"Ressurs (skjult)","person_resource":"Ressurs (skjult)","other_tasks":"Annen tid","other_stuff":"Øvrig tid","available":"Rådighetstime","person_resource_visible":"Ressurs (Vises for elever)","club":"SFO tid","additional_tasks":"Øvrige oppgaver","preparation":"Forberedelse","with_kids":"Tid med børn","without_kids":"Tid uden børn","pool":"Planleggingsdager","absence":"Fravær","_extra_time_at_start_of_day_":"Ekstra tid før første leksjon","_extra_time_between_events_":"Ekstra tid mellom timer","_extra_time_if_shorter_than_":"Ekstra tid når dagen er for kort","activity":"Aktivitet"},"task_versions":{"task_overview":"Oppgaveoversikt","versions":"Versjoner","save_print_task_overviews":"Lag/skriv ut oppgaveoversikter","save_new_version_task_overviews":"Lag en ny versjon av oppgaveoversikter","print_latest_version_task_overviews":"Skriv ut nyeste versjon av oppgaveoversikter","saved_message":"Lagret","delete_message":"Slett","confirm_delete_message":"Ønsker du å slette","delete_warning_message":"Slettede versjoner kan ikke gjenopprettes","annual_norm":"Årsnorm","save_task_overview_version":"Lagre versjon av oppgaveoversikt","version_title":"Tittel for versjon av oppgaveoversikten","auto_name_description":"Navngis automatisk med dagens dato hvis du ikke angir en tittel","what_is_version":"Hva er en versjon?","saved_task_overview_description":"En lagret oppgaveoversikt viser et øyeblikksbilde av medarbeiderens oppgaveoversikt slik den så ut på tidspunktet da versjonen av oppgaveoversikten ble lagret. Det tilsvarer å lage en utskrift eller PDF med detaljer om hvordan oppgaveoversikten så ut på det gitte tidspunktet.","find_saved_versions":"Hvor kan jeg finne lagrede versjoner?","find_saved_versions_description":"Du kan finne lagrede versjoner ved å navigere til \"Oppgaveoversikt\" for hver enkelt person. Her vil det være en rullegardinmeny der alle lagrede versjoner i skoleåret er tilgjengelige for gjennomsyn.","select_personnel":"Velg personale","go_back":"Tilbake","select_min_user":"Minst én bruker må velges","save_for_selected_users":"Lagre for","save_for_selected_users_of":"av","print_latest_version":"Skriv ut nyeste versjon av oppgaveoversikt for alle","no_saved_versions":"Ingen versjoner er lagret","save_new_version":"Lagre ny versjon","save_version":"Lagre versjon"},"deleted_subjects_log":{"deleted_log":"Log over slettede","no_lessons_deleted":"Ingen leksjoner er slettet fra denne brikken","lesson":"Leksjonen","deleted":"Slettet"},"create_activity":{"create_activity":"Opprett aktivitet","create_activity_for":"Opprett aktivitet for","title":"tittel","search_or_create":"Søk eller opprett","created":"Opprettet","create_new_subject_for":"Opprett nytt fag for","choose_subject_type":"Velg type","the_selected_date_is_outside_schoolyears":"Den valgte datoen er utenfor alle aktive skoleår","set_as_substitute":"Sett inn som vikar","set_as_substitute_help":"Brukeren settes på aktiviteten som vikar. Timene trekkes fra brukerens vikarpulje, og brukeren vises under Dagens vikarer – f.eks. når det sendes SMS til dagens vikarer."},"datepicker":{"max_date_range_start":"Du kan maks hente","max_date_range_end":"dagers intervall"},"request_absence":{"request_absence":"Be om fravær"},"public_calendar":{"black_white":"Svart/hvitt"},"special_days":{"title":"Omlagte dager","intro":"Legg om en eller flere dager for utvalgte klasser, f.eks. en aktivitetsdag, temadag eller første skoledag. Omlagte dager i klasser utelates ved kopiering og overskrives dermed ikke. Dagene kan i tillegg trekkes fra klassens UV-timetall basert på klassens normale fagtimer.","create":"Opprett omlagt dag","edit":"Rediger omlagt dag","refresh_reductions":"Oppdater reduksjoner","reductions_updated":"Reduksjoner er oppdatert","none_created":"Det er ikke opprettet noen omlagte dager ennå","loading":"Henter omlagte dager","name":"Navn","name_placeholder":"f.eks. Aktivitetsdag","start_date":"Fra dato","end_date":"Til dato","period":"Periode","day":"dag","days":"dager","pick_dates_hint":"Klikk på en dag for å velge fra- og til-dato","reduct":"Reduser timer i klassen","reduct_hint":"Når den er på, reduseres klassenes timer for perioden.","reduct_yes":"Ja","reduct_no":"Nei","classes":"Klasser","select_classes":"Velg klasser","select_all":"Velg alle","clear":"Tøm","no_classes_selected":"Velg minst én klasse","actions":"Handlinger","delete":"Slett","save":"Lagre","cancel":"Avbryt","linked_subjects":"Tilknyttede fag (de løsrives fra dagen)","confirm_delete_title":"Slett","confirm_delete_text":"Den omlagte dagen slettes.","saved":"Lagret","deleted_toast":"Den omlagte dagen ble slettet","error_toast":"Noe gikk galt. Prøv igjen."},"helpdesk":{"hero_eyebrow":"Svar, guider og oppdateringer","hero_title":"Hva kan vi hjelpe deg med?","hero_subtitle":"Finn svaret, og kom videre med dagen din.","search_placeholder":"Søk i hjelpeartikler…","back_to":"Tilbake til","latest_news":"Siste nytt","read_news":"Les nyheten","earlier_news":"Tidligere nyheter","popular_articles":"Populære artikler","find_by_topic":"Finn hjelp etter emne","footer_help":"Trenger du mer hjelp? Supporten vår hjelper deg videre.","back":"Tilbake","articles_about":"Artikler om:","categories":"Kategorier","related_articles":"Relaterte artikler","copy_link":"Kopier lenke","link_copied":"Lenke kopiert!","back_to_start":"Tilbake til start","search_results":"Søkeresultater","no_results":"Vi fant ingen artikler som samsvarer med søket ditt.","no_articles":"Det finnes ingen hjelpeartikler ennå.","clear_search":"Tøm søk","uncategorized":"Annet","article":"artikkel","articles":"artikler","language":"Språk"},"school_users":{"title":"Brukere","stil_intro":"STIL har endret måten Unilogins opprettes på. Vi anbefaler at dere importerer brukere fra STIL i stedet for å opprette dem manuelt.","stil_read_more":"Les mer","stil_import":"Import av brukere fra STIL","merge_users":"Slå sammen brukere","transfer_calendar":"Overfør kalender","create":"Opprett bruker","edit":"Rediger bruker","actions":"Handlinger","edit_action":"Rediger","search_placeholder":"Søk på navn, initialer, innlogging eller telefon","users":"brukere","none":"Det er ingen brukere på skolen","no_results":"Ingen brukere samsvarer med søket","name":"Navn","initials":"Initialer","login":"Innlogging","email":"E-post","phone":"Telefon","ssn":"Personnummer","unilogin":"Unilogin","unilogin_hint":"(8 eller 10 tegn)","feide":"Feide","employee_id":"Ansatt-ID","employee_id_hint":"(valgfri ID som skolen kan bruke)","last_seen":"Sist sett","never_logged_in":"Aldri logget inn","change_photo":"Bytt bilde","not_editable_yet":"Kan ikke endres her ennå","see_tasks":"Se oppgaveoversikt","cancel":"Avbryt","save":"Lagre","saved":"Brukeren er lagret","error_toast":"Noe gikk galt. Prøv igjen."}}

/***/ }),
/* 1409 */,
/* 1410 */,
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 193,
		"./af.js": 193,
		"./ar": 201,
		"./ar-dz": 194,
		"./ar-dz.js": 194,
		"./ar-kw": 195,
		"./ar-kw.js": 195,
		"./ar-ly": 196,
		"./ar-ly.js": 196,
		"./ar-ma": 197,
		"./ar-ma.js": 197,
		"./ar-ps": 198,
		"./ar-ps.js": 198,
		"./ar-sa": 199,
		"./ar-sa.js": 199,
		"./ar-tn": 200,
		"./ar-tn.js": 200,
		"./ar.js": 201,
		"./az": 202,
		"./az.js": 202,
		"./be": 203,
		"./be.js": 203,
		"./bg": 204,
		"./bg.js": 204,
		"./bm": 205,
		"./bm.js": 205,
		"./bn": 207,
		"./bn-bd": 206,
		"./bn-bd.js": 206,
		"./bn.js": 207,
		"./bo": 208,
		"./bo.js": 208,
		"./br": 209,
		"./br.js": 209,
		"./bs": 210,
		"./bs.js": 210,
		"./ca": 211,
		"./ca.js": 211,
		"./cs": 212,
		"./cs.js": 212,
		"./cv": 213,
		"./cv.js": 213,
		"./cy": 214,
		"./cy.js": 214,
		"./da": 215,
		"./da.js": 215,
		"./de": 218,
		"./de-at": 216,
		"./de-at.js": 216,
		"./de-ch": 217,
		"./de-ch.js": 217,
		"./de.js": 218,
		"./dv": 219,
		"./dv.js": 219,
		"./el": 220,
		"./el.js": 220,
		"./en-au": 221,
		"./en-au.js": 221,
		"./en-ca": 222,
		"./en-ca.js": 222,
		"./en-gb": 223,
		"./en-gb.js": 223,
		"./en-ie": 224,
		"./en-ie.js": 224,
		"./en-il": 225,
		"./en-il.js": 225,
		"./en-in": 226,
		"./en-in.js": 226,
		"./en-nz": 227,
		"./en-nz.js": 227,
		"./en-sg": 228,
		"./en-sg.js": 228,
		"./eo": 229,
		"./eo.js": 229,
		"./es": 233,
		"./es-do": 230,
		"./es-do.js": 230,
		"./es-mx": 231,
		"./es-mx.js": 231,
		"./es-us": 232,
		"./es-us.js": 232,
		"./es.js": 233,
		"./et": 234,
		"./et.js": 234,
		"./eu": 235,
		"./eu.js": 235,
		"./fa": 236,
		"./fa.js": 236,
		"./fi": 237,
		"./fi.js": 237,
		"./fil": 238,
		"./fil.js": 238,
		"./fo": 239,
		"./fo.js": 239,
		"./fr": 242,
		"./fr-ca": 240,
		"./fr-ca.js": 240,
		"./fr-ch": 241,
		"./fr-ch.js": 241,
		"./fr.js": 242,
		"./fy": 243,
		"./fy.js": 243,
		"./ga": 244,
		"./ga.js": 244,
		"./gd": 245,
		"./gd.js": 245,
		"./gl": 246,
		"./gl.js": 246,
		"./gom-deva": 247,
		"./gom-deva.js": 247,
		"./gom-latn": 248,
		"./gom-latn.js": 248,
		"./gu": 249,
		"./gu.js": 249,
		"./he": 250,
		"./he.js": 250,
		"./hi": 251,
		"./hi.js": 251,
		"./hr": 252,
		"./hr.js": 252,
		"./hu": 253,
		"./hu.js": 253,
		"./hy-am": 254,
		"./hy-am.js": 254,
		"./id": 255,
		"./id.js": 255,
		"./is": 256,
		"./is.js": 256,
		"./it": 258,
		"./it-ch": 257,
		"./it-ch.js": 257,
		"./it.js": 258,
		"./ja": 259,
		"./ja.js": 259,
		"./jv": 260,
		"./jv.js": 260,
		"./ka": 261,
		"./ka.js": 261,
		"./kk": 262,
		"./kk.js": 262,
		"./km": 263,
		"./km.js": 263,
		"./kn": 264,
		"./kn.js": 264,
		"./ko": 265,
		"./ko.js": 265,
		"./ku": 267,
		"./ku-kmr": 266,
		"./ku-kmr.js": 266,
		"./ku.js": 267,
		"./ky": 268,
		"./ky.js": 268,
		"./lb": 269,
		"./lb.js": 269,
		"./lo": 270,
		"./lo.js": 270,
		"./lt": 271,
		"./lt.js": 271,
		"./lv": 272,
		"./lv.js": 272,
		"./me": 273,
		"./me.js": 273,
		"./mi": 274,
		"./mi.js": 274,
		"./mk": 275,
		"./mk.js": 275,
		"./ml": 276,
		"./ml.js": 276,
		"./mn": 277,
		"./mn.js": 277,
		"./mr": 278,
		"./mr.js": 278,
		"./ms": 280,
		"./ms-my": 279,
		"./ms-my.js": 279,
		"./ms.js": 280,
		"./mt": 281,
		"./mt.js": 281,
		"./my": 282,
		"./my.js": 282,
		"./nb": 283,
		"./nb.js": 283,
		"./ne": 284,
		"./ne.js": 284,
		"./nl": 286,
		"./nl-be": 285,
		"./nl-be.js": 285,
		"./nl.js": 286,
		"./nn": 287,
		"./nn.js": 287,
		"./oc-lnc": 288,
		"./oc-lnc.js": 288,
		"./pa-in": 289,
		"./pa-in.js": 289,
		"./pl": 290,
		"./pl.js": 290,
		"./pt": 292,
		"./pt-br": 291,
		"./pt-br.js": 291,
		"./pt.js": 292,
		"./ro": 293,
		"./ro.js": 293,
		"./ru": 294,
		"./ru.js": 294,
		"./sd": 295,
		"./sd.js": 295,
		"./se": 296,
		"./se.js": 296,
		"./si": 297,
		"./si.js": 297,
		"./sk": 298,
		"./sk.js": 298,
		"./sl": 299,
		"./sl.js": 299,
		"./sq": 300,
		"./sq.js": 300,
		"./sr": 302,
		"./sr-cyrl": 301,
		"./sr-cyrl.js": 301,
		"./sr.js": 302,
		"./ss": 303,
		"./ss.js": 303,
		"./sv": 304,
		"./sv.js": 304,
		"./sw": 305,
		"./sw.js": 305,
		"./ta": 306,
		"./ta.js": 306,
		"./te": 307,
		"./te.js": 307,
		"./tet": 308,
		"./tet.js": 308,
		"./tg": 309,
		"./tg.js": 309,
		"./th": 310,
		"./th.js": 310,
		"./tk": 311,
		"./tk.js": 311,
		"./tl-ph": 312,
		"./tl-ph.js": 312,
		"./tlh": 313,
		"./tlh.js": 313,
		"./tr": 314,
		"./tr.js": 314,
		"./tzl": 315,
		"./tzl.js": 315,
		"./tzm": 317,
		"./tzm-latn": 316,
		"./tzm-latn.js": 316,
		"./tzm.js": 317,
		"./ug-cn": 318,
		"./ug-cn.js": 318,
		"./uk": 319,
		"./uk.js": 319,
		"./ur": 320,
		"./ur.js": 320,
		"./uz": 322,
		"./uz-latn": 321,
		"./uz-latn.js": 321,
		"./uz.js": 322,
		"./vi": 323,
		"./vi.js": 323,
		"./x-pseudo": 324,
		"./x-pseudo.js": 324,
		"./yo": 325,
		"./yo.js": 325,
		"./zh-cn": 326,
		"./zh-cn.js": 326,
		"./zh-hk": 327,
		"./zh-hk.js": 327,
		"./zh-mo": 328,
		"./zh-mo.js": 328,
		"./zh-tw": 329,
		"./zh-tw.js": 329
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1411;


/***/ }),
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/frame.c31a116.png";

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/optional.0efc797.png";

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/subject.68609e0.png";

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/googlecalendar1.6721a2e.png";

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/googlecalendar2.b96f28d.png";

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/googlecalendar3.f6d1a39.png";

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ical-icon.83f4eb8.jpg";

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ical_1.4ae01c4.png";

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/outlook-icon.9fb38e9.png";

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/outlook1.7e31322.png";

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/outlook2.877ff05.png";

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 1433 */,
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1337)
	
	/* script */
	__vue_exports__ = __webpack_require__(453)
	
	/* template */
	var __vue_template__ = __webpack_require__(2104)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(978)
	
	/* script */
	__vue_exports__ = __webpack_require__(454)
	
	/* template */
	var __vue_template__ = __webpack_require__(1726)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0031812d"
	
	module.exports = __vue_exports__


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1071)
	
	/* script */
	__vue_exports__ = __webpack_require__(455)
	
	/* template */
	var __vue_template__ = __webpack_require__(1824)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2a15b7f0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1261)
	
	/* script */
	__vue_exports__ = __webpack_require__(457)
	
	/* template */
	var __vue_template__ = __webpack_require__(2026)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-790d2854"
	
	module.exports = __vue_exports__


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1203)
	
	/* script */
	__vue_exports__ = __webpack_require__(458)
	
	/* template */
	var __vue_template__ = __webpack_require__(1963)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-644890bc"
	
	module.exports = __vue_exports__


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1345)
	
	/* script */
	__vue_exports__ = __webpack_require__(459)
	
	/* template */
	var __vue_template__ = __webpack_require__(2112)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-be090830"
	
	module.exports = __vue_exports__


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(995)
	
	/* script */
	__vue_exports__ = __webpack_require__(460)
	
	/* template */
	var __vue_template__ = __webpack_require__(1744)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-07078da5"
	
	module.exports = __vue_exports__


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(997)
	
	/* script */
	__vue_exports__ = __webpack_require__(461)
	
	/* template */
	var __vue_template__ = __webpack_require__(1746)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-07b4aa4a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1311)
	
	/* script */
	__vue_exports__ = __webpack_require__(464)
	
	/* template */
	var __vue_template__ = __webpack_require__(2076)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a45e855e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1108)
	
	/* script */
	__vue_exports__ = __webpack_require__(465)
	
	/* template */
	var __vue_template__ = __webpack_require__(1867)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3a5c1e24"
	
	module.exports = __vue_exports__


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1185)
	
	/* script */
	__vue_exports__ = __webpack_require__(466)
	
	/* template */
	var __vue_template__ = __webpack_require__(1944)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1086)
	
	/* script */
	__vue_exports__ = __webpack_require__(467)
	
	/* template */
	var __vue_template__ = __webpack_require__(1842)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-31c11c66"
	
	module.exports = __vue_exports__


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1394)
	
	/* script */
	__vue_exports__ = __webpack_require__(468)
	
	/* template */
	var __vue_template__ = __webpack_require__(2165)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f43488ea"
	
	module.exports = __vue_exports__


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1233)
	
	/* script */
	__vue_exports__ = __webpack_require__(469)
	
	/* template */
	var __vue_template__ = __webpack_require__(1996)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6f33ea8f"
	
	module.exports = __vue_exports__


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1013)
	
	/* script */
	__vue_exports__ = __webpack_require__(471)
	
	/* template */
	var __vue_template__ = __webpack_require__(1762)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-105dd92a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1087)
	
	/* script */
	__vue_exports__ = __webpack_require__(473)
	
	/* template */
	var __vue_template__ = __webpack_require__(1843)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-31d3b1d4"
	
	module.exports = __vue_exports__


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1044)
	
	/* script */
	__vue_exports__ = __webpack_require__(475)
	
	/* template */
	var __vue_template__ = __webpack_require__(1794)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1ee5674d"
	
	module.exports = __vue_exports__


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1034)
	
	/* script */
	__vue_exports__ = __webpack_require__(477)
	
	/* template */
	var __vue_template__ = __webpack_require__(1783)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1aa916e9"
	
	module.exports = __vue_exports__


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1213)
	
	/* script */
	__vue_exports__ = __webpack_require__(479)
	
	/* template */
	var __vue_template__ = __webpack_require__(1973)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6718fcd4"
	
	module.exports = __vue_exports__


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1352)
	
	/* script */
	__vue_exports__ = __webpack_require__(481)
	
	/* template */
	var __vue_template__ = __webpack_require__(2119)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c4cf6db2"
	
	module.exports = __vue_exports__


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1238)
	
	/* script */
	__vue_exports__ = __webpack_require__(482)
	
	/* template */
	var __vue_template__ = __webpack_require__(2003)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-70d41f56"
	
	module.exports = __vue_exports__


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1072)
	
	/* script */
	__vue_exports__ = __webpack_require__(483)
	
	/* template */
	var __vue_template__ = __webpack_require__(1825)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2a55050e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1167)
	
	/* script */
	__vue_exports__ = __webpack_require__(484)
	
	/* template */
	var __vue_template__ = __webpack_require__(1926)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-55ed903a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1231)
	
	/* script */
	__vue_exports__ = __webpack_require__(485)
	
	/* template */
	var __vue_template__ = __webpack_require__(1994)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6dc8227f"
	
	module.exports = __vue_exports__


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1214)
	
	/* script */
	__vue_exports__ = __webpack_require__(486)
	
	/* template */
	var __vue_template__ = __webpack_require__(1974)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6730c6d4"
	
	module.exports = __vue_exports__


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1036)
	
	/* script */
	__vue_exports__ = __webpack_require__(488)
	
	/* template */
	var __vue_template__ = __webpack_require__(1785)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1b085928"
	
	module.exports = __vue_exports__


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(981)
	
	/* script */
	__vue_exports__ = __webpack_require__(489)
	
	/* template */
	var __vue_template__ = __webpack_require__(1729)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-02278584"
	
	module.exports = __vue_exports__


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(982)
	
	/* script */
	__vue_exports__ = __webpack_require__(490)
	
	/* template */
	var __vue_template__ = __webpack_require__(1731)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-02f6ec14"
	
	module.exports = __vue_exports__


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1192)
	
	/* script */
	__vue_exports__ = __webpack_require__(492)
	
	/* template */
	var __vue_template__ = __webpack_require__(1952)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5fd39edd"
	
	module.exports = __vue_exports__


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1367)
	
	/* script */
	__vue_exports__ = __webpack_require__(494)
	
	/* template */
	var __vue_template__ = __webpack_require__(2136)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d99ac434"
	
	module.exports = __vue_exports__


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1307)
	
	/* script */
	__vue_exports__ = __webpack_require__(495)
	
	/* template */
	var __vue_template__ = __webpack_require__(2072)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9f21d0ec"
	
	module.exports = __vue_exports__


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1308)
	
	/* script */
	__vue_exports__ = __webpack_require__(496)
	
	/* template */
	var __vue_template__ = __webpack_require__(2073)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a0b98898"
	
	module.exports = __vue_exports__


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1010)
	
	/* script */
	__vue_exports__ = __webpack_require__(498)
	
	/* template */
	var __vue_template__ = __webpack_require__(1759)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0f88a6a9"
	
	module.exports = __vue_exports__


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1196)
	
	/* script */
	__vue_exports__ = __webpack_require__(499)
	
	/* template */
	var __vue_template__ = __webpack_require__(1956)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-610026e6"
	
	module.exports = __vue_exports__


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1207)
	
	/* script */
	__vue_exports__ = __webpack_require__(500)
	
	/* template */
	var __vue_template__ = __webpack_require__(1967)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1041)
	
	/* script */
	__vue_exports__ = __webpack_require__(502)
	
	/* template */
	var __vue_template__ = __webpack_require__(1791)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1e3bd68b"
	
	module.exports = __vue_exports__


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(986)
	
	/* script */
	__vue_exports__ = __webpack_require__(504)
	
	/* template */
	var __vue_template__ = __webpack_require__(1735)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1119)
	
	/* script */
	__vue_exports__ = __webpack_require__(506)
	
	/* template */
	var __vue_template__ = __webpack_require__(1879)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-42707fe6"
	
	module.exports = __vue_exports__


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1369)
	
	/* script */
	__vue_exports__ = __webpack_require__(507)
	
	/* template */
	var __vue_template__ = __webpack_require__(2138)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-db23bb08"
	
	module.exports = __vue_exports__


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1256)
	
	/* script */
	__vue_exports__ = __webpack_require__(508)
	
	/* template */
	var __vue_template__ = __webpack_require__(2021)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7814e750"
	
	module.exports = __vue_exports__


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1299)
	
	/* script */
	__vue_exports__ = __webpack_require__(509)
	
	/* template */
	var __vue_template__ = __webpack_require__(2064)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-98b610bc"
	
	module.exports = __vue_exports__


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(510)
	
	/* template */
	var __vue_template__ = __webpack_require__(1924)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1263)
	
	/* script */
	__vue_exports__ = __webpack_require__(511)
	
	/* template */
	var __vue_template__ = __webpack_require__(2028)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7a073072"
	
	module.exports = __vue_exports__


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1370)
	
	/* script */
	__vue_exports__ = __webpack_require__(512)
	
	/* template */
	var __vue_template__ = __webpack_require__(2139)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-dbf319dc"
	
	module.exports = __vue_exports__


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(513)
	
	/* template */
	var __vue_template__ = __webpack_require__(2142)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(514)
	
	/* template */
	var __vue_template__ = __webpack_require__(1873)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1258)
	
	/* script */
	__vue_exports__ = __webpack_require__(515)
	
	/* template */
	var __vue_template__ = __webpack_require__(2023)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-78da7ab5"
	
	module.exports = __vue_exports__


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(517)
	
	/* template */
	var __vue_template__ = __webpack_require__(1821)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1065)
	
	/* script */
	__vue_exports__ = __webpack_require__(518)
	
	/* template */
	var __vue_template__ = __webpack_require__(1816)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-275da70c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1118)
	
	/* script */
	__vue_exports__ = __webpack_require__(519)
	
	/* template */
	var __vue_template__ = __webpack_require__(1878)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-41df31b4"
	
	module.exports = __vue_exports__


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1136)
	
	/* template */
	var __vue_template__ = __webpack_require__(1895)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1088)
	
	/* script */
	__vue_exports__ = __webpack_require__(521)
	
	/* template */
	var __vue_template__ = __webpack_require__(1844)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3347a2de"
	
	module.exports = __vue_exports__


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1391)
	
	/* script */
	__vue_exports__ = __webpack_require__(522)
	
	/* template */
	var __vue_template__ = __webpack_require__(2162)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f2036002"
	
	module.exports = __vue_exports__


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1076)
	
	/* script */
	__vue_exports__ = __webpack_require__(523)
	
	/* template */
	var __vue_template__ = __webpack_require__(1829)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2c057be8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1075)
	
	/* script */
	__vue_exports__ = __webpack_require__(525)
	
	/* template */
	var __vue_template__ = __webpack_require__(1828)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2be6e1c6"
	
	module.exports = __vue_exports__


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1026)
	
	/* script */
	__vue_exports__ = __webpack_require__(526)
	
	/* template */
	var __vue_template__ = __webpack_require__(1775)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-15649ecc"
	
	module.exports = __vue_exports__


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1254)
	
	/* script */
	__vue_exports__ = __webpack_require__(527)
	
	/* template */
	var __vue_template__ = __webpack_require__(2019)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-77a9deef"
	
	module.exports = __vue_exports__


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1025)
	
	/* script */
	__vue_exports__ = __webpack_require__(528)
	
	/* template */
	var __vue_template__ = __webpack_require__(1774)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-153776aa"
	
	module.exports = __vue_exports__


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1127)
	
	/* script */
	__vue_exports__ = __webpack_require__(530)
	
	/* template */
	var __vue_template__ = __webpack_require__(1886)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1030)
	
	/* script */
	__vue_exports__ = __webpack_require__(531)
	
	/* template */
	var __vue_template__ = __webpack_require__(1779)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-197b3206"
	
	module.exports = __vue_exports__


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1016)
	
	/* script */
	__vue_exports__ = __webpack_require__(532)
	
	/* template */
	var __vue_template__ = __webpack_require__(1765)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1198c775"
	
	module.exports = __vue_exports__


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1239)
	
	/* script */
	__vue_exports__ = __webpack_require__(533)
	
	/* template */
	var __vue_template__ = __webpack_require__(2004)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-70fdd330"
	
	module.exports = __vue_exports__


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1223)
	
	/* script */
	__vue_exports__ = __webpack_require__(534)
	
	/* template */
	var __vue_template__ = __webpack_require__(1985)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6a2667ca"
	
	module.exports = __vue_exports__


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1336)
	
	/* script */
	__vue_exports__ = __webpack_require__(542)
	
	/* template */
	var __vue_template__ = __webpack_require__(2103)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b7f02108"
	
	module.exports = __vue_exports__


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1001)
	
	/* script */
	__vue_exports__ = __webpack_require__(543)
	
	/* template */
	var __vue_template__ = __webpack_require__(1750)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-088a62da"
	
	module.exports = __vue_exports__


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1097)
	
	/* script */
	__vue_exports__ = __webpack_require__(548)
	
	/* template */
	var __vue_template__ = __webpack_require__(1855)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1249)
	
	/* script */
	__vue_exports__ = __webpack_require__(549)
	
	/* template */
	var __vue_template__ = __webpack_require__(2014)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-74fb6dcf"
	
	module.exports = __vue_exports__


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1275)
	
	/* script */
	__vue_exports__ = __webpack_require__(550)
	
	/* template */
	var __vue_template__ = __webpack_require__(2040)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7f19439c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(552)
	
	/* template */
	var __vue_template__ = __webpack_require__(2121)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1007)
	
	/* script */
	__vue_exports__ = __webpack_require__(553)
	
	/* template */
	var __vue_template__ = __webpack_require__(1756)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0b87a766"
	
	module.exports = __vue_exports__


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1252)
	
	/* script */
	__vue_exports__ = __webpack_require__(554)
	
	/* template */
	var __vue_template__ = __webpack_require__(2017)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-777a068e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1390)
	
	/* script */
	__vue_exports__ = __webpack_require__(555)
	
	/* template */
	var __vue_template__ = __webpack_require__(2161)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f10bee34"
	
	module.exports = __vue_exports__


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1015)
	
	/* script */
	__vue_exports__ = __webpack_require__(557)
	
	/* template */
	var __vue_template__ = __webpack_require__(1764)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-117f370b"
	
	module.exports = __vue_exports__


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1194)
	
	/* script */
	__vue_exports__ = __webpack_require__(558)
	
	/* template */
	var __vue_template__ = __webpack_require__(1954)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-60a5ecdf"
	
	module.exports = __vue_exports__


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1020)
	
	/* script */
	__vue_exports__ = __webpack_require__(559)
	
	/* template */
	var __vue_template__ = __webpack_require__(1769)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-139df671"
	
	module.exports = __vue_exports__


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(561)
	
	/* template */
	var __vue_template__ = __webpack_require__(1730)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1374)
	
	/* script */
	__vue_exports__ = __webpack_require__(562)
	
	/* template */
	var __vue_template__ = __webpack_require__(2144)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e0a00a9c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1146)
	
	/* script */
	__vue_exports__ = __webpack_require__(563)
	
	/* template */
	var __vue_template__ = __webpack_require__(1906)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4b33942e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1282)
	
	/* script */
	__vue_exports__ = __webpack_require__(564)
	
	/* template */
	var __vue_template__ = __webpack_require__(2048)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8402db10"
	
	module.exports = __vue_exports__


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(566)
	
	/* template */
	var __vue_template__ = __webpack_require__(2000)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(570)
	
	/* template */
	var __vue_template__ = __webpack_require__(1904)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1159)
	
	/* script */
	__vue_exports__ = __webpack_require__(572)
	
	/* template */
	var __vue_template__ = __webpack_require__(1918)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5223cada"
	
	module.exports = __vue_exports__


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1247)
	
	/* script */
	__vue_exports__ = __webpack_require__(573)
	
	/* template */
	var __vue_template__ = __webpack_require__(2012)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7470078c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1222)
	
	/* script */
	__vue_exports__ = __webpack_require__(576)
	
	/* template */
	var __vue_template__ = __webpack_require__(1984)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-69ebd77e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1268)
	
	/* script */
	__vue_exports__ = __webpack_require__(578)
	
	/* template */
	var __vue_template__ = __webpack_require__(2033)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7ad68305"
	
	module.exports = __vue_exports__


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(994)
	
	/* script */
	__vue_exports__ = __webpack_require__(579)
	
	/* template */
	var __vue_template__ = __webpack_require__(1743)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1378)
	
	/* script */
	__vue_exports__ = __webpack_require__(580)
	
	/* template */
	var __vue_template__ = __webpack_require__(2148)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e4ba18a2"
	
	module.exports = __vue_exports__


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(581)
	
	/* template */
	var __vue_template__ = __webpack_require__(1790)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(584)
	
	/* template */
	var __vue_template__ = __webpack_require__(1803)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1265)
	
	/* script */
	__vue_exports__ = __webpack_require__(587)
	
	/* template */
	var __vue_template__ = __webpack_require__(2030)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1131)
	
	/* script */
	__vue_exports__ = __webpack_require__(588)
	
	/* template */
	var __vue_template__ = __webpack_require__(1890)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-44e94f52"
	
	module.exports = __vue_exports__


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1046)
	
	/* script */
	__vue_exports__ = __webpack_require__(589)
	
	/* template */
	var __vue_template__ = __webpack_require__(1796)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2048d4bd"
	
	module.exports = __vue_exports__


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1091)
	
	/* script */
	__vue_exports__ = __webpack_require__(591)
	
	/* template */
	var __vue_template__ = __webpack_require__(1847)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-33d00cc7"
	
	module.exports = __vue_exports__


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1128)
	
	/* script */
	__vue_exports__ = __webpack_require__(593)
	
	/* template */
	var __vue_template__ = __webpack_require__(1887)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1135)
	
	/* script */
	__vue_exports__ = __webpack_require__(594)
	
	/* template */
	var __vue_template__ = __webpack_require__(1894)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4791d929"
	
	module.exports = __vue_exports__


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1096)
	
	/* script */
	__vue_exports__ = __webpack_require__(595)
	
	/* template */
	var __vue_template__ = __webpack_require__(1854)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-36534b01"
	
	module.exports = __vue_exports__


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1228)
	
	/* script */
	__vue_exports__ = __webpack_require__(597)
	
	/* template */
	var __vue_template__ = __webpack_require__(1990)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1230)
	
	/* script */
	__vue_exports__ = __webpack_require__(598)
	
	/* template */
	var __vue_template__ = __webpack_require__(1993)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6d69f84a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1092)
	
	/* script */
	__vue_exports__ = __webpack_require__(599)
	
	/* template */
	var __vue_template__ = __webpack_require__(1848)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1148)
	
	/* script */
	__vue_exports__ = __webpack_require__(600)
	
	/* template */
	var __vue_template__ = __webpack_require__(1908)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(998)
	
	/* script */
	__vue_exports__ = __webpack_require__(601)
	
	/* template */
	var __vue_template__ = __webpack_require__(1747)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(602)
	
	/* template */
	var __vue_template__ = __webpack_require__(1999)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(603)
	
	/* template */
	var __vue_template__ = __webpack_require__(1858)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1271)
	
	/* script */
	__vue_exports__ = __webpack_require__(604)
	
	/* template */
	var __vue_template__ = __webpack_require__(2036)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7d5532c8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1272)
	
	/* script */
	__vue_exports__ = __webpack_require__(605)
	
	/* template */
	var __vue_template__ = __webpack_require__(2037)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7e282bfb"
	
	module.exports = __vue_exports__


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(984)
	
	/* script */
	__vue_exports__ = __webpack_require__(606)
	
	/* template */
	var __vue_template__ = __webpack_require__(1733)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-03679bb0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(990)
	
	/* script */
	__vue_exports__ = __webpack_require__(607)
	
	/* template */
	var __vue_template__ = __webpack_require__(1739)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1160)
	
	/* script */
	__vue_exports__ = __webpack_require__(611)
	
	/* template */
	var __vue_template__ = __webpack_require__(1919)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5391cb55"
	
	module.exports = __vue_exports__


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1149)
	
	/* script */
	__vue_exports__ = __webpack_require__(612)
	
	/* template */
	var __vue_template__ = __webpack_require__(1909)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4e1ec158"
	
	module.exports = __vue_exports__


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1164)
	
	/* script */
	__vue_exports__ = __webpack_require__(613)
	
	/* template */
	var __vue_template__ = __webpack_require__(1922)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-548b08fd"
	
	module.exports = __vue_exports__


/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1389)
	
	/* script */
	__vue_exports__ = __webpack_require__(614)
	
	/* template */
	var __vue_template__ = __webpack_require__(2160)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f10a4072"
	
	module.exports = __vue_exports__


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1300)
	
	/* script */
	__vue_exports__ = __webpack_require__(615)
	
	/* template */
	var __vue_template__ = __webpack_require__(2065)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-990cc956"
	
	module.exports = __vue_exports__


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1002)
	
	/* script */
	__vue_exports__ = __webpack_require__(617)
	
	/* template */
	var __vue_template__ = __webpack_require__(1751)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-098a0e7e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1035)
	
	/* script */
	__vue_exports__ = __webpack_require__(618)
	
	/* template */
	var __vue_template__ = __webpack_require__(1784)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1ade1de9"
	
	module.exports = __vue_exports__


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1288)
	
	/* script */
	__vue_exports__ = __webpack_require__(619)
	
	/* template */
	var __vue_template__ = __webpack_require__(2053)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8911cb34"
	
	module.exports = __vue_exports__


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1259)
	
	/* script */
	__vue_exports__ = __webpack_require__(620)
	
	/* template */
	var __vue_template__ = __webpack_require__(2024)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-78ea03d4"
	
	module.exports = __vue_exports__


/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(621)
	
	/* template */
	var __vue_template__ = __webpack_require__(1818)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1179)
	
	/* script */
	__vue_exports__ = __webpack_require__(622)
	
	/* template */
	var __vue_template__ = __webpack_require__(1938)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-58eff32a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1012)
	
	/* script */
	__vue_exports__ = __webpack_require__(623)
	
	/* template */
	var __vue_template__ = __webpack_require__(1761)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-100ca672"
	
	module.exports = __vue_exports__


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1115)
	
	/* script */
	__vue_exports__ = __webpack_require__(624)
	
	/* template */
	var __vue_template__ = __webpack_require__(1875)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3f8b2a84"
	
	module.exports = __vue_exports__


/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1360)
	
	/* script */
	__vue_exports__ = __webpack_require__(625)
	
	/* template */
	var __vue_template__ = __webpack_require__(2129)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d20fdc52"
	
	module.exports = __vue_exports__


/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1220)
	
	/* script */
	__vue_exports__ = __webpack_require__(626)
	
	/* template */
	var __vue_template__ = __webpack_require__(1982)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6963107e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1133)
	
	/* script */
	__vue_exports__ = __webpack_require__(628)
	
	/* template */
	var __vue_template__ = __webpack_require__(1892)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-46ceca22"
	
	module.exports = __vue_exports__


/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1102)
	
	/* script */
	__vue_exports__ = __webpack_require__(629)
	
	/* template */
	var __vue_template__ = __webpack_require__(1861)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-378d8e2c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1342)
	
	/* script */
	__vue_exports__ = __webpack_require__(636)
	
	/* template */
	var __vue_template__ = __webpack_require__(2109)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-bc5396c8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1332)
	
	/* script */
	__vue_exports__ = __webpack_require__(637)
	
	/* template */
	var __vue_template__ = __webpack_require__(2099)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b64843ac"
	
	module.exports = __vue_exports__


/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1297)
	
	/* script */
	__vue_exports__ = __webpack_require__(638)
	
	/* template */
	var __vue_template__ = __webpack_require__(2062)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-946810a4"
	
	module.exports = __vue_exports__


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1267)
	
	/* script */
	__vue_exports__ = __webpack_require__(640)
	
	/* template */
	var __vue_template__ = __webpack_require__(2032)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7ac1b34a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1057)
	
	/* script */
	__vue_exports__ = __webpack_require__(641)
	
	/* template */
	var __vue_template__ = __webpack_require__(1808)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-248faf67"
	
	module.exports = __vue_exports__


/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1206)
	
	/* script */
	__vue_exports__ = __webpack_require__(642)
	
	/* template */
	var __vue_template__ = __webpack_require__(1966)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-65072162"
	
	module.exports = __vue_exports__


/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1101)
	
	/* script */
	__vue_exports__ = __webpack_require__(643)
	
	/* template */
	var __vue_template__ = __webpack_require__(1860)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-378cee1b"
	
	module.exports = __vue_exports__


/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1043)
	
	/* script */
	__vue_exports__ = __webpack_require__(644)
	
	/* template */
	var __vue_template__ = __webpack_require__(1793)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1eab22a0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1202)
	
	/* script */
	__vue_exports__ = __webpack_require__(645)
	
	/* template */
	var __vue_template__ = __webpack_require__(1962)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-640bc18d"
	
	module.exports = __vue_exports__


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1226)
	
	/* script */
	__vue_exports__ = __webpack_require__(646)
	
	/* template */
	var __vue_template__ = __webpack_require__(1988)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6b4415f6"
	
	module.exports = __vue_exports__


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1343)
	
	/* script */
	__vue_exports__ = __webpack_require__(647)
	
	/* template */
	var __vue_template__ = __webpack_require__(2110)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-bcb177ca"
	
	module.exports = __vue_exports__


/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1095)
	
	/* script */
	__vue_exports__ = __webpack_require__(648)
	
	/* template */
	var __vue_template__ = __webpack_require__(1852)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3600f47a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1142)
	
	/* script */
	__vue_exports__ = __webpack_require__(652)
	
	/* template */
	var __vue_template__ = __webpack_require__(1901)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-49da139c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1038)
	
	/* script */
	__vue_exports__ = __webpack_require__(656)
	
	/* template */
	var __vue_template__ = __webpack_require__(1787)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1ca9fa21"
	
	module.exports = __vue_exports__


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1204)
	
	/* script */
	__vue_exports__ = __webpack_require__(657)
	
	/* template */
	var __vue_template__ = __webpack_require__(1964)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-645d57ba"
	
	module.exports = __vue_exports__


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1208)
	
	/* script */
	__vue_exports__ = __webpack_require__(658)
	
	/* template */
	var __vue_template__ = __webpack_require__(1968)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-65d22297"
	
	module.exports = __vue_exports__


/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1082)
	
	/* script */
	__vue_exports__ = __webpack_require__(661)
	
	/* template */
	var __vue_template__ = __webpack_require__(1837)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2e5c7d82"
	
	module.exports = __vue_exports__


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1129)
	
	/* script */
	__vue_exports__ = __webpack_require__(662)
	
	/* template */
	var __vue_template__ = __webpack_require__(1888)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-44af353d"
	
	module.exports = __vue_exports__


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1349)
	
	/* script */
	__vue_exports__ = __webpack_require__(663)
	
	/* template */
	var __vue_template__ = __webpack_require__(2116)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c0615e10"
	
	module.exports = __vue_exports__


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1348)
	
	/* script */
	__vue_exports__ = __webpack_require__(664)
	
	/* template */
	var __vue_template__ = __webpack_require__(2115)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c0452f0e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1347)
	
	/* script */
	__vue_exports__ = __webpack_require__(665)
	
	/* template */
	var __vue_template__ = __webpack_require__(2114)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c029000c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1346)
	
	/* script */
	__vue_exports__ = __webpack_require__(666)
	
	/* template */
	var __vue_template__ = __webpack_require__(2113)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c00cd10a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1017)
	
	/* script */
	__vue_exports__ = __webpack_require__(668)
	
	/* template */
	var __vue_template__ = __webpack_require__(1766)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-11b82438"
	
	module.exports = __vue_exports__


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1116)
	
	/* script */
	__vue_exports__ = __webpack_require__(669)
	
	/* template */
	var __vue_template__ = __webpack_require__(1876)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3fe44b62"
	
	module.exports = __vue_exports__


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1305)
	
	/* script */
	__vue_exports__ = __webpack_require__(671)
	
	/* template */
	var __vue_template__ = __webpack_require__(2070)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9df5b962"
	
	module.exports = __vue_exports__


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(985)
	
	/* script */
	__vue_exports__ = __webpack_require__(674)
	
	/* template */
	var __vue_template__ = __webpack_require__(1734)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-03a53a2c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1047)
	
	/* script */
	__vue_exports__ = __webpack_require__(675)
	
	/* template */
	var __vue_template__ = __webpack_require__(1797)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-20eb7604"
	
	module.exports = __vue_exports__


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1061)
	
	/* script */
	__vue_exports__ = __webpack_require__(676)
	
	/* template */
	var __vue_template__ = __webpack_require__(1812)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-25cfadf3"
	
	module.exports = __vue_exports__


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1089)
	
	/* script */
	__vue_exports__ = __webpack_require__(679)
	
	/* template */
	var __vue_template__ = __webpack_require__(1845)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-335ab610"
	
	module.exports = __vue_exports__


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1177)
	
	/* script */
	__vue_exports__ = __webpack_require__(680)
	
	/* template */
	var __vue_template__ = __webpack_require__(1936)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-57f23845"
	
	module.exports = __vue_exports__


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1235)
	
	/* script */
	__vue_exports__ = __webpack_require__(681)
	
	/* template */
	var __vue_template__ = __webpack_require__(1998)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6fc22468"
	
	module.exports = __vue_exports__


/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1054)
	
	/* script */
	__vue_exports__ = __webpack_require__(682)
	
	/* template */
	var __vue_template__ = __webpack_require__(1805)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-23bb6e6d"
	
	module.exports = __vue_exports__


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1053)
	
	/* script */
	__vue_exports__ = __webpack_require__(683)
	
	/* template */
	var __vue_template__ = __webpack_require__(1804)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-23b9a224"
	
	module.exports = __vue_exports__


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1313)
	
	/* script */
	__vue_exports__ = __webpack_require__(684)
	
	/* template */
	var __vue_template__ = __webpack_require__(2078)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a5f33b8e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1138)
	
	/* script */
	__vue_exports__ = __webpack_require__(685)
	
	/* template */
	var __vue_template__ = __webpack_require__(1897)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4861f947"
	
	module.exports = __vue_exports__


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(999)
	
	/* script */
	__vue_exports__ = __webpack_require__(686)
	
	/* template */
	var __vue_template__ = __webpack_require__(1748)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-07c581fb"
	
	module.exports = __vue_exports__


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(992)
	
	/* script */
	__vue_exports__ = __webpack_require__(687)
	
	/* template */
	var __vue_template__ = __webpack_require__(1741)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-06500c9a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1045)
	
	/* script */
	__vue_exports__ = __webpack_require__(689)
	
	/* template */
	var __vue_template__ = __webpack_require__(1795)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1fa0e8f0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1285)
	
	/* script */
	__vue_exports__ = __webpack_require__(690)
	
	/* template */
	var __vue_template__ = __webpack_require__(2051)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-873e152a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1381)
	
	/* script */
	__vue_exports__ = __webpack_require__(692)
	
	/* template */
	var __vue_template__ = __webpack_require__(2151)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e7e207f0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1387)
	
	/* script */
	__vue_exports__ = __webpack_require__(693)
	
	/* template */
	var __vue_template__ = __webpack_require__(2158)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f0c4a276"
	
	module.exports = __vue_exports__


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1331)
	
	/* script */
	__vue_exports__ = __webpack_require__(694)
	
	/* template */
	var __vue_template__ = __webpack_require__(2098)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b5a02d0e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1055)
	
	/* script */
	__vue_exports__ = __webpack_require__(695)
	
	/* template */
	var __vue_template__ = __webpack_require__(1806)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-23fd2210"
	
	module.exports = __vue_exports__


/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1365)
	
	/* script */
	__vue_exports__ = __webpack_require__(696)
	
	/* template */
	var __vue_template__ = __webpack_require__(2134)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d9321a64"
	
	module.exports = __vue_exports__


/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1354)
	
	/* script */
	__vue_exports__ = __webpack_require__(697)
	
	/* template */
	var __vue_template__ = __webpack_require__(2122)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c6982942"
	
	module.exports = __vue_exports__


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1385)
	
	/* script */
	__vue_exports__ = __webpack_require__(698)
	
	/* template */
	var __vue_template__ = __webpack_require__(2155)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-eca5c450"
	
	module.exports = __vue_exports__


/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1143)
	
	/* script */
	__vue_exports__ = __webpack_require__(699)
	
	/* template */
	var __vue_template__ = __webpack_require__(1902)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4a497fec"
	
	module.exports = __vue_exports__


/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1319)
	
	/* script */
	__vue_exports__ = __webpack_require__(700)
	
	/* template */
	var __vue_template__ = __webpack_require__(2086)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ac05b468"
	
	module.exports = __vue_exports__


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1106)
	
	/* script */
	__vue_exports__ = __webpack_require__(701)
	
	/* template */
	var __vue_template__ = __webpack_require__(1865)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3a3b379c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1246)
	
	/* script */
	__vue_exports__ = __webpack_require__(702)
	
	/* template */
	var __vue_template__ = __webpack_require__(2011)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7452aed4"
	
	module.exports = __vue_exports__


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(704)
	
	/* template */
	var __vue_template__ = __webpack_require__(1853)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1170)
	
	/* script */
	__vue_exports__ = __webpack_require__(705)
	
	/* template */
	var __vue_template__ = __webpack_require__(1929)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-57221aa6"
	
	module.exports = __vue_exports__


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1327)
	
	/* script */
	__vue_exports__ = __webpack_require__(706)
	
	/* template */
	var __vue_template__ = __webpack_require__(2094)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b18fc178"
	
	module.exports = __vue_exports__


/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1060)
	
	/* script */
	__vue_exports__ = __webpack_require__(707)
	
	/* template */
	var __vue_template__ = __webpack_require__(1811)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-25869126"
	
	module.exports = __vue_exports__


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1124)
	
	/* script */
	__vue_exports__ = __webpack_require__(708)
	
	/* template */
	var __vue_template__ = __webpack_require__(1884)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-43e2343f"
	
	module.exports = __vue_exports__


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1274)
	
	/* script */
	__vue_exports__ = __webpack_require__(709)
	
	/* template */
	var __vue_template__ = __webpack_require__(2039)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7eddef3d"
	
	module.exports = __vue_exports__


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1320)
	
	/* script */
	__vue_exports__ = __webpack_require__(710)
	
	/* template */
	var __vue_template__ = __webpack_require__(2087)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ac764cac"
	
	module.exports = __vue_exports__


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1351)
	
	/* script */
	__vue_exports__ = __webpack_require__(712)
	
	/* template */
	var __vue_template__ = __webpack_require__(2118)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c3632bf0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1014)
	
	/* script */
	__vue_exports__ = __webpack_require__(713)
	
	/* template */
	var __vue_template__ = __webpack_require__(1763)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-10601e56"
	
	module.exports = __vue_exports__


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1211)
	
	/* script */
	__vue_exports__ = __webpack_require__(725)
	
	/* template */
	var __vue_template__ = __webpack_require__(1971)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-66c82bcd"
	
	module.exports = __vue_exports__


/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1078)
	
	/* script */
	__vue_exports__ = __webpack_require__(726)
	
	/* template */
	var __vue_template__ = __webpack_require__(1832)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2cde8ebf"
	
	module.exports = __vue_exports__


/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1303)
	
	/* script */
	__vue_exports__ = __webpack_require__(727)
	
	/* template */
	var __vue_template__ = __webpack_require__(2068)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9d87c752"
	
	module.exports = __vue_exports__


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1083)
	
	/* script */
	__vue_exports__ = __webpack_require__(731)
	
	/* template */
	var __vue_template__ = __webpack_require__(1838)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2f998cac"
	
	module.exports = __vue_exports__


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1037)
	
	/* script */
	__vue_exports__ = __webpack_require__(732)
	
	/* template */
	var __vue_template__ = __webpack_require__(1786)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1c8bdc89"
	
	module.exports = __vue_exports__


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1039)
	
	/* script */
	__vue_exports__ = __webpack_require__(733)
	
	/* template */
	var __vue_template__ = __webpack_require__(1788)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1ce3ee74"
	
	module.exports = __vue_exports__


/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1189)
	
	/* script */
	__vue_exports__ = __webpack_require__(734)
	
	/* template */
	var __vue_template__ = __webpack_require__(1949)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5ec8b891"
	
	module.exports = __vue_exports__


/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1296)
	__webpack_require__(1295)
	
	/* script */
	__vue_exports__ = __webpack_require__(735)
	
	/* template */
	var __vue_template__ = __webpack_require__(2061)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9319a330"
	
	module.exports = __vue_exports__


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1098)
	
	/* script */
	__vue_exports__ = __webpack_require__(736)
	
	/* template */
	var __vue_template__ = __webpack_require__(1856)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-366dccd5"
	
	module.exports = __vue_exports__


/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1074)
	
	/* script */
	__vue_exports__ = __webpack_require__(737)
	
	/* template */
	var __vue_template__ = __webpack_require__(1827)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2b02dd76"
	
	module.exports = __vue_exports__


/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1318)
	
	/* script */
	__vue_exports__ = __webpack_require__(741)
	
	/* template */
	var __vue_template__ = __webpack_require__(2085)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-abff5332"
	
	module.exports = __vue_exports__


/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(989)
	
	/* script */
	__vue_exports__ = __webpack_require__(742)
	
	/* template */
	var __vue_template__ = __webpack_require__(1738)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-052ac37a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1334)
	
	/* script */
	__vue_exports__ = __webpack_require__(746)
	
	/* template */
	var __vue_template__ = __webpack_require__(2101)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b77cc42a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1380)
	
	/* script */
	__vue_exports__ = __webpack_require__(747)
	
	/* template */
	var __vue_template__ = __webpack_require__(2150)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e69a1cb8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1178)
	
	/* script */
	__vue_exports__ = __webpack_require__(748)
	
	/* template */
	var __vue_template__ = __webpack_require__(1937)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-583d95d0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1070)
	
	/* script */
	__vue_exports__ = __webpack_require__(749)
	
	/* template */
	var __vue_template__ = __webpack_require__(1823)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2a147321"
	
	module.exports = __vue_exports__


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(751)
	
	/* template */
	var __vue_template__ = __webpack_require__(2156)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1224)
	
	/* script */
	__vue_exports__ = __webpack_require__(752)
	
	/* template */
	var __vue_template__ = __webpack_require__(1986)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6b1035a2"
	
	module.exports = __vue_exports__


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1241)
	
	/* script */
	__vue_exports__ = __webpack_require__(753)
	
	/* template */
	var __vue_template__ = __webpack_require__(2006)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-71f48356"
	
	module.exports = __vue_exports__


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1379)
	
	/* script */
	__vue_exports__ = __webpack_require__(755)
	
	/* template */
	var __vue_template__ = __webpack_require__(2149)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e59bcd5c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1221)
	
	/* script */
	__vue_exports__ = __webpack_require__(756)
	
	/* template */
	var __vue_template__ = __webpack_require__(1983)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1069)
	
	/* script */
	__vue_exports__ = __webpack_require__(757)
	
	/* template */
	var __vue_template__ = __webpack_require__(1822)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-29c2dc02"
	
	module.exports = __vue_exports__


/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1103)
	
	/* script */
	__vue_exports__ = __webpack_require__(758)
	
	/* template */
	var __vue_template__ = __webpack_require__(1862)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-38380940"
	
	module.exports = __vue_exports__


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1270)
	
	/* script */
	__vue_exports__ = __webpack_require__(759)
	
	/* template */
	var __vue_template__ = __webpack_require__(2035)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7cb284f7"
	
	module.exports = __vue_exports__


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1067)
	
	/* script */
	__vue_exports__ = __webpack_require__(760)
	
	/* template */
	var __vue_template__ = __webpack_require__(1819)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-28f80768"
	
	module.exports = __vue_exports__


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1085)
	
	/* script */
	__vue_exports__ = __webpack_require__(761)
	
	/* template */
	var __vue_template__ = __webpack_require__(1841)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-31bbfc94"
	
	module.exports = __vue_exports__


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1382)
	
	/* script */
	__vue_exports__ = __webpack_require__(762)
	
	/* template */
	var __vue_template__ = __webpack_require__(2152)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ea006af8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(763)
	
	/* template */
	var __vue_template__ = __webpack_require__(2080)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1114)
	
	/* script */
	__vue_exports__ = __webpack_require__(764)
	
	/* template */
	var __vue_template__ = __webpack_require__(1874)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3f559256"
	
	module.exports = __vue_exports__


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1302)
	
	/* script */
	__vue_exports__ = __webpack_require__(765)
	
	/* template */
	var __vue_template__ = __webpack_require__(2067)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1191)
	
	/* script */
	__vue_exports__ = __webpack_require__(766)
	
	/* template */
	var __vue_template__ = __webpack_require__(1951)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5f3c020a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1084)
	
	/* script */
	__vue_exports__ = __webpack_require__(767)
	
	/* template */
	var __vue_template__ = __webpack_require__(1840)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-319c306a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1186)
	
	/* script */
	__vue_exports__ = __webpack_require__(768)
	
	/* template */
	var __vue_template__ = __webpack_require__(1946)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5d630828"
	
	module.exports = __vue_exports__


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1130)
	
	/* script */
	__vue_exports__ = __webpack_require__(769)
	
	/* template */
	var __vue_template__ = __webpack_require__(1889)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1234)
	
	/* script */
	__vue_exports__ = __webpack_require__(770)
	
	/* template */
	var __vue_template__ = __webpack_require__(1997)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6f7191d3"
	
	module.exports = __vue_exports__


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1048)
	
	/* script */
	__vue_exports__ = __webpack_require__(772)
	
	/* template */
	var __vue_template__ = __webpack_require__(1798)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2176c8f8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1229)
	
	/* script */
	__vue_exports__ = __webpack_require__(773)
	
	/* template */
	var __vue_template__ = __webpack_require__(1991)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6ca3bcd3"
	
	module.exports = __vue_exports__


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1269)
	
	/* script */
	__vue_exports__ = __webpack_require__(774)
	
	/* template */
	var __vue_template__ = __webpack_require__(2034)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7c5facf7"
	
	module.exports = __vue_exports__


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1183)
	
	/* script */
	__vue_exports__ = __webpack_require__(775)
	
	/* template */
	var __vue_template__ = __webpack_require__(1942)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5b586c20"
	
	module.exports = __vue_exports__


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1199)
	
	/* script */
	__vue_exports__ = __webpack_require__(776)
	
	/* template */
	var __vue_template__ = __webpack_require__(1959)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-638e61a8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1357)
	
	/* script */
	__vue_exports__ = __webpack_require__(778)
	
	/* template */
	var __vue_template__ = __webpack_require__(2126)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-cc10cc3e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1176)
	
	/* script */
	__vue_exports__ = __webpack_require__(779)
	
	/* template */
	var __vue_template__ = __webpack_require__(1935)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-57e202ea"
	
	module.exports = __vue_exports__


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1388)
	
	/* script */
	__vue_exports__ = __webpack_require__(781)
	
	/* template */
	var __vue_template__ = __webpack_require__(2159)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f1056088"
	
	module.exports = __vue_exports__


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1042)
	
	/* script */
	__vue_exports__ = __webpack_require__(783)
	
	/* template */
	var __vue_template__ = __webpack_require__(1792)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1e98ca56"
	
	module.exports = __vue_exports__


/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1144)
	
	/* script */
	__vue_exports__ = __webpack_require__(784)
	
	/* template */
	var __vue_template__ = __webpack_require__(1903)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4aa78638"
	
	module.exports = __vue_exports__


/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1112)
	
	/* script */
	__vue_exports__ = __webpack_require__(786)
	
	/* template */
	var __vue_template__ = __webpack_require__(1871)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3f17a134"
	
	module.exports = __vue_exports__


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1315)
	
	/* script */
	__vue_exports__ = __webpack_require__(788)
	
	/* template */
	var __vue_template__ = __webpack_require__(2082)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a83f7420"
	
	module.exports = __vue_exports__


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1361)
	
	/* script */
	__vue_exports__ = __webpack_require__(789)
	
	/* template */
	var __vue_template__ = __webpack_require__(2130)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1294)
	
	/* script */
	__vue_exports__ = __webpack_require__(791)
	
	/* template */
	var __vue_template__ = __webpack_require__(2060)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-90a5b738"
	
	module.exports = __vue_exports__


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1281)
	
	/* script */
	__vue_exports__ = __webpack_require__(792)
	
	/* template */
	var __vue_template__ = __webpack_require__(2047)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-81db8b00"
	
	module.exports = __vue_exports__


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1140)
	
	/* script */
	__vue_exports__ = __webpack_require__(793)
	
	/* template */
	var __vue_template__ = __webpack_require__(1899)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4919a4ba"
	
	module.exports = __vue_exports__


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1100)
	
	/* script */
	__vue_exports__ = __webpack_require__(794)
	
	/* template */
	var __vue_template__ = __webpack_require__(1859)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-377012df"
	
	module.exports = __vue_exports__


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1324)
	
	/* script */
	__vue_exports__ = __webpack_require__(795)
	
	/* template */
	var __vue_template__ = __webpack_require__(2091)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-aff3b038"
	
	module.exports = __vue_exports__


/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1298)
	
	/* script */
	__vue_exports__ = __webpack_require__(796)
	
	/* template */
	var __vue_template__ = __webpack_require__(2063)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-95ca2a2a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1363)
	
	/* script */
	__vue_exports__ = __webpack_require__(797)
	
	/* template */
	var __vue_template__ = __webpack_require__(2132)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d46d202a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1153)
	
	/* script */
	__vue_exports__ = __webpack_require__(799)
	
	/* template */
	var __vue_template__ = __webpack_require__(1913)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5047da95"
	
	module.exports = __vue_exports__


/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1188)
	
	/* script */
	__vue_exports__ = __webpack_require__(800)
	
	/* template */
	var __vue_template__ = __webpack_require__(1948)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1301)
	
	/* script */
	__vue_exports__ = __webpack_require__(801)
	
	/* template */
	var __vue_template__ = __webpack_require__(2066)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9a9eba8a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(803)
	
	/* template */
	var __vue_template__ = __webpack_require__(2058)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1158)
	
	/* script */
	__vue_exports__ = __webpack_require__(804)
	
	/* template */
	var __vue_template__ = __webpack_require__(1917)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-51914942"
	
	module.exports = __vue_exports__


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1325)
	
	/* script */
	__vue_exports__ = __webpack_require__(805)
	
	/* template */
	var __vue_template__ = __webpack_require__(2092)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b036b964"
	
	module.exports = __vue_exports__


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1321)
	
	/* script */
	__vue_exports__ = __webpack_require__(808)
	
	/* template */
	var __vue_template__ = __webpack_require__(2088)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ad750fde"
	
	module.exports = __vue_exports__


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1201)
	
	/* script */
	__vue_exports__ = __webpack_require__(809)
	
	/* template */
	var __vue_template__ = __webpack_require__(1961)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-64023200"
	
	module.exports = __vue_exports__


/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1248)
	
	/* script */
	__vue_exports__ = __webpack_require__(813)
	
	/* template */
	var __vue_template__ = __webpack_require__(2013)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-74a3044f"
	
	module.exports = __vue_exports__


/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1137)
	
	/* script */
	__vue_exports__ = __webpack_require__(814)
	
	/* template */
	var __vue_template__ = __webpack_require__(1896)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-480c8896"
	
	module.exports = __vue_exports__


/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1329)
	
	/* script */
	__vue_exports__ = __webpack_require__(816)
	
	/* template */
	var __vue_template__ = __webpack_require__(2096)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b1d9e9c8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1190)
	
	/* script */
	__vue_exports__ = __webpack_require__(818)
	
	/* template */
	var __vue_template__ = __webpack_require__(1950)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5f022bbd"
	
	module.exports = __vue_exports__


/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1287)
	__webpack_require__(1286)
	
	/* script */
	__vue_exports__ = __webpack_require__(821)
	
	/* template */
	var __vue_template__ = __webpack_require__(2052)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8747714c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1019)
	
	/* script */
	__vue_exports__ = __webpack_require__(822)
	
	/* template */
	var __vue_template__ = __webpack_require__(1768)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-136b76ff"
	
	module.exports = __vue_exports__


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1155)
	__webpack_require__(1154)
	
	/* script */
	__vue_exports__ = __webpack_require__(824)
	
	/* template */
	var __vue_template__ = __webpack_require__(1914)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-505775f7"
	
	module.exports = __vue_exports__


/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1283)
	
	/* script */
	__vue_exports__ = __webpack_require__(827)
	
	/* template */
	var __vue_template__ = __webpack_require__(2049)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1310)
	
	/* script */
	__vue_exports__ = __webpack_require__(831)
	
	/* template */
	var __vue_template__ = __webpack_require__(2075)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a35d590a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1009)
	
	/* script */
	__vue_exports__ = __webpack_require__(832)
	
	/* template */
	var __vue_template__ = __webpack_require__(1758)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0e48602e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1225)
	
	/* script */
	__vue_exports__ = __webpack_require__(833)
	
	/* template */
	var __vue_template__ = __webpack_require__(1987)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6b10cf5a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1397)
	
	/* script */
	__vue_exports__ = __webpack_require__(834)
	
	/* template */
	var __vue_template__ = __webpack_require__(2168)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f9cdee8e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1147)
	
	/* script */
	__vue_exports__ = __webpack_require__(836)
	
	/* template */
	var __vue_template__ = __webpack_require__(1907)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4b6592c5"
	
	module.exports = __vue_exports__


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1371)
	
	/* template */
	var __vue_template__ = __webpack_require__(2140)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1330)
	
	/* script */
	__vue_exports__ = __webpack_require__(841)
	
	/* template */
	var __vue_template__ = __webpack_require__(2097)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b216f258"
	
	module.exports = __vue_exports__


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1304)
	
	/* script */
	__vue_exports__ = __webpack_require__(844)
	
	/* template */
	var __vue_template__ = __webpack_require__(2069)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9de6840a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1277)
	
	/* script */
	__vue_exports__ = __webpack_require__(845)
	
	/* template */
	var __vue_template__ = __webpack_require__(2042)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7f660a7f"
	
	module.exports = __vue_exports__


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1209)
	
	/* script */
	__vue_exports__ = __webpack_require__(850)
	
	/* template */
	var __vue_template__ = __webpack_require__(1969)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-667a63b1"
	
	module.exports = __vue_exports__


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1280)
	
	/* script */
	__vue_exports__ = __webpack_require__(855)
	
	/* template */
	var __vue_template__ = __webpack_require__(2046)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-808ab164"
	
	module.exports = __vue_exports__


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1171)
	
	/* script */
	__vue_exports__ = __webpack_require__(859)
	
	/* template */
	var __vue_template__ = __webpack_require__(1930)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-572d5dac"
	
	module.exports = __vue_exports__


/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1195)
	
	/* script */
	__vue_exports__ = __webpack_require__(860)
	
	/* template */
	var __vue_template__ = __webpack_require__(1955)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-60f51688"
	
	module.exports = __vue_exports__


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(863)
	
	/* template */
	var __vue_template__ = __webpack_require__(2043)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(996)
	
	/* script */
	__vue_exports__ = __webpack_require__(865)
	
	/* template */
	var __vue_template__ = __webpack_require__(1745)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-07adafc2"
	
	module.exports = __vue_exports__


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1094)
	
	/* script */
	__vue_exports__ = __webpack_require__(866)
	
	/* template */
	var __vue_template__ = __webpack_require__(1851)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-354eb704"
	
	module.exports = __vue_exports__


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* template */
	var __vue_template__ = __webpack_require__(1834)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1150)
	
	/* script */
	__vue_exports__ = __webpack_require__(867)
	
	/* template */
	var __vue_template__ = __webpack_require__(1910)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4e6d4768"
	
	module.exports = __vue_exports__


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1109)
	
	/* script */
	__vue_exports__ = __webpack_require__(868)
	
	/* template */
	var __vue_template__ = __webpack_require__(1868)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3b657902"
	
	module.exports = __vue_exports__


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1077)
	
	/* script */
	__vue_exports__ = __webpack_require__(869)
	
	/* template */
	var __vue_template__ = __webpack_require__(1831)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2c2af81c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1111)
	
	/* script */
	__vue_exports__ = __webpack_require__(870)
	
	/* template */
	var __vue_template__ = __webpack_require__(1870)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3f169b42"
	
	module.exports = __vue_exports__


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1051)
	
	/* script */
	__vue_exports__ = __webpack_require__(871)
	
	/* template */
	var __vue_template__ = __webpack_require__(1801)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2279ff9a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1120)
	
	/* script */
	__vue_exports__ = __webpack_require__(872)
	
	/* template */
	var __vue_template__ = __webpack_require__(1880)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-42c7094d"
	
	module.exports = __vue_exports__


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1242)
	
	/* script */
	__vue_exports__ = __webpack_require__(873)
	
	/* template */
	var __vue_template__ = __webpack_require__(2007)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1243)
	
	/* script */
	__vue_exports__ = __webpack_require__(874)
	
	/* template */
	var __vue_template__ = __webpack_require__(2008)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-737baac9"
	
	module.exports = __vue_exports__


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1024)
	
	/* script */
	__vue_exports__ = __webpack_require__(875)
	
	/* template */
	var __vue_template__ = __webpack_require__(1773)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-141e3622"
	
	module.exports = __vue_exports__


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1292)
	
	/* script */
	__vue_exports__ = __webpack_require__(876)
	
	/* template */
	var __vue_template__ = __webpack_require__(2057)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8d8163be"
	
	module.exports = __vue_exports__


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1340)
	
	/* script */
	__vue_exports__ = __webpack_require__(877)
	
	/* template */
	var __vue_template__ = __webpack_require__(2107)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-bbeecbae"
	
	module.exports = __vue_exports__


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1141)
	
	/* script */
	__vue_exports__ = __webpack_require__(878)
	
	/* template */
	var __vue_template__ = __webpack_require__(1900)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-49ad9ab0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1262)
	
	/* script */
	__vue_exports__ = __webpack_require__(879)
	
	/* template */
	var __vue_template__ = __webpack_require__(2027)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7967a35a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1166)
	
	/* script */
	__vue_exports__ = __webpack_require__(880)
	
	/* template */
	var __vue_template__ = __webpack_require__(1925)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-553cbdab"
	
	module.exports = __vue_exports__


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1005)
	
	/* script */
	__vue_exports__ = __webpack_require__(881)
	
	/* template */
	var __vue_template__ = __webpack_require__(1754)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0a698985"
	
	module.exports = __vue_exports__


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1173)
	
	/* script */
	__vue_exports__ = __webpack_require__(882)
	
	/* template */
	var __vue_template__ = __webpack_require__(1932)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-57b1d2c4"
	
	module.exports = __vue_exports__


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(983)
	
	/* script */
	__vue_exports__ = __webpack_require__(883)
	
	/* template */
	var __vue_template__ = __webpack_require__(1732)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-03156f74"
	
	module.exports = __vue_exports__


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1232)
	
	/* script */
	__vue_exports__ = __webpack_require__(884)
	
	/* template */
	var __vue_template__ = __webpack_require__(1995)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6e49ff2d"
	
	module.exports = __vue_exports__


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1172)
	
	/* script */
	__vue_exports__ = __webpack_require__(886)
	
	/* template */
	var __vue_template__ = __webpack_require__(1931)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5738d0d9"
	
	module.exports = __vue_exports__


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1236)
	
	/* script */
	__vue_exports__ = __webpack_require__(889)
	
	/* template */
	var __vue_template__ = __webpack_require__(2001)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-708361c0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1168)
	
	/* script */
	__vue_exports__ = __webpack_require__(892)
	
	/* template */
	var __vue_template__ = __webpack_require__(1927)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5633e290"
	
	module.exports = __vue_exports__


/***/ }),
/* 1726 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticStyle: {
	      "background-color": "lightgray",
	      "padding": "10px",
	      "width": "200px",
	      "position": "fixed",
	      "height": "100vh"
	    }
	  }, [_vm._l((_vm.components), function(component, index) {
	    return _c('div', [_c('button', {
	      on: {
	        "click": function($event) {
	          return _vm.select(index)
	        }
	      }
	    }, [_vm._v(_vm._s(component.name))])])
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "descripton"
	  }, [_vm._v(_vm._s(_vm.currentComponent.description))])], 2), _vm._v(" "), _c('div', {
	    staticClass: "component_container"
	  }, [_c(_vm.currentComponent, {
	    tag: "component"
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1727 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.showModal) ? _c('modal', {
	    attrs: {
	      "maxWidth": "600px",
	      "top": "4px"
	    },
	    on: {
	      "close": _vm.close
	    }
	  }, [_c('template', {
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "add-lesson__header",
	    style: ({
	      'backgroundColor': _vm.color ? _vm.color : '#fff'
	    })
	  }, [_c('h2', [_vm._v(_vm._s(_vm.name.length > 0 ? _vm.name : _vm.i18n[_vm.locale]['create_subject']))]), _vm._v(" "), _c('div', {
	    staticClass: "add-lesson__calendars"
	  }, [_vm._v("\n        " + _vm._s(_vm.showMasterCalendarName) + "\n      ")]), _vm._v(" "), (_vm.theActiveTab === 0 && !_vm.showDbErrorText && _vm.canSeeTaskOverviewToggle) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: false,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window'
	      }),
	      expression: "{\n             arrow: false,\n             animateFill: false,\n             animation: 'shift-away',\n             zIndex: '999999992',\n             boundary: 'window'}"
	    }],
	    staticClass: "add-lesson__header__task-overview",
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['show_on_task_overview_desc']
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleTaskOverview.apply(null, arguments)
	      }
	    }
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_on_task_overview']))]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "propOn": _vm.taskOverview,
	      "allowChanges": false
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.editSubject && !_vm.showDbErrorText) ? _c('div', {
	    staticClass: "add-lesson__header__tabs"
	  }, [_c('div', {
	    staticClass: "add-lesson__header__tabs__tab",
	    class: {
	      'tab--is-active': _vm.theActiveTab === 0
	    },
	    on: {
	      "click": function($event) {
	        _vm.theActiveTab = 0
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale].edit_subject) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "add-lesson__header__tabs__tab",
	    class: {
	      'tab--is-active': _vm.theActiveTab === 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.theActiveTab = 1
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale].activity) + "\n        ")]), _vm._v(" "), (_vm.isShowSubjectsPools) ? _c('div', {
	    staticClass: "add-lesson__header__tabs__tab",
	    class: {
	      'tab--is-active': _vm.theActiveTab === 4
	    },
	    on: {
	      "click": _vm.onClickPoolsTab
	    }
	  }, [_vm._v("\n          Puljer\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "add-lesson__header__tabs__tab",
	    class: {
	      'tab--is-active': _vm.theActiveTab === 3
	    },
	    on: {
	      "click": function($event) {
	        _vm.theActiveTab = 3
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale].scheduled_events) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "add-lesson__header__tabs__tab",
	    class: {
	      'tab--is-active': _vm.theActiveTab === 2
	    },
	    on: {
	      "click": function($event) {
	        _vm.theActiveTab = 2
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale].deleted_lessons) + "\n        ")])]) : _vm._e()]), _vm._v(" "), (_vm.isLoadingSchoolCalenders || _vm.isLoadingTheEditSubject) ? _c('div', {
	    staticClass: "add-lesson__form add-lesson__loading-container"
	  }, [_c('Loader', {
	    attrs: {
	      "bgColor": "#f6f9fc"
	    }
	  })], 1) : _c('div', {
	    staticClass: "add-lesson__form"
	  }, [(_vm.showDbErrorText) ? _c('div', {
	    staticClass: "db-error-div"
	  }, [_c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].can_not_find_subject))])]) : [(_vm.theActiveTab === 2) ? _c('div', {
	    staticClass: "add-lesson__form__content"
	  }, [_c('SubjectFormLogDeletedEvents', {
	    attrs: {
	      "subject": _vm.editSubject
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 3) ? _c('div', {
	    staticClass: "add-lesson__form__content"
	  }, [_c('SubjectFormScheduledEvents', {
	    attrs: {
	      "subject": _vm.editSubject
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 4) ? _c('div', {
	    staticClass: "add-lesson__form__content"
	  }, [(!_vm.poolsSubject) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#f6f9fc"
	    }
	  }) : _c('SubjectFormCalendarHours', {
	    attrs: {
	      "subject": _vm.poolsSubject
	    },
	    on: {
	      "subjectHoursSaved": _vm.onSubjectHoursSaved
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 1) ? _c('div', {
	    staticClass: "add-lesson__form__content"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale].latest_activity))]), _vm._v(" "), _c('SubjectFormLog', {
	    attrs: {
	      "subject": _vm.editSubject
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 0) ? _c('div', {
	    staticClass: "add-lesson__form__content"
	  }, [_c('div', {
	    staticClass: "input-group__flex"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['subject_title']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    ref: "name",
	    class: {
	      'input--error': _vm.formErrors['name']
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale]['ex_subject']
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('name')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['name']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['name'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), (_vm.isShowNorwegianPreparationDropdown) ? _c('div', {
	    staticClass: "input-group",
	    staticStyle: {
	      "max-width": "100px"
	    }
	  }, [_c('label', [_vm._v("Årsramme")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.preparation),
	      expression: "preparation",
	      modifiers: {
	        "number": true
	      }
	    }],
	    staticClass: "d-input__select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return _vm._n(val)
	        });
	        _vm.preparation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.preparationOptionsForNorway), function(prep) {
	    return _c('option', {
	      key: prep
	    }, [_vm._v("\n                  " + _vm._s(prep) + "\n                ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isCalendarKlass) ? _c('div', {
	    staticClass: "input-group input-group__subject-codes"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['subject_code']))]), _vm._v(" "), (_vm.isSchoolFromDenmark) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.subjectCode),
	      expression: "subjectCode",
	      modifiers: {
	        "number": true
	      }
	    }],
	    staticClass: "d-input__select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return _vm._n(val)
	        });
	        _vm.subjectCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": ''
	    }
	  }), _vm._v(" "), _vm._l((_vm.standardSubjectCodes), function(subject) {
	    return _c('option', {
	      key: subject.subject_code,
	      domProps: {
	        "value": subject.subject_code
	      }
	    }, [_vm._v("\n                  " + _vm._s(subject.fagkode) + " - " + _vm._s(subject.name) + "\n                ")])
	  })], 2) : _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.subjectCode),
	      expression: "subjectCode",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.subjectCode)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.subjectCode = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_teacher']))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "user",
	      "showTags": true,
	      "preSelectedItems": _vm.preSelectedTeacherCalendarIds,
	      "itemsThatCantBeDeleted": _vm.lockedTeacherCalendarIds,
	      "showCreateButton": false,
	      "sortSelectedByName": true
	    },
	    on: {
	      "update": _vm.setSelectedUsers
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-location"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_room']))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "room",
	      "preSelectedItems": _vm.roomCalendarIds,
	      "showCreateButton": false
	    },
	    on: {
	      "update": _vm.setSelectedRooms
	    }
	  })], 1), _vm._v(" "), (!_vm.isPossibleToAddKlasses && _vm.isAllowedToAddKlasses) ? _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.setIsPossibleToAddKlasses
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_klass']) + "?")]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropdown"
	    }
	  }, [(_vm.isPossibleToAddKlasses) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-calendar4"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_klass']))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "klass",
	      "calendarId": _vm.calendarId,
	      "showTags": true,
	      "preSelectedItems": _vm.klassCalendarIds,
	      "showCreateButton": false
	    },
	    on: {
	      "update": _vm.setSelectedKlass
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), (!_vm.isPossibleToAddClub && _vm.isAllowedToAddClub) ? _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.setIsPossibleToAddClub
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_club']) + "?\n          ")]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropdown"
	    }
	  }, [(_vm.isPossibleToAddClub) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-calendar4"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_club']))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "club",
	      "calendarId": _vm.calendarId,
	      "showTags": true,
	      "preSelectedItems": _vm.clubCalendarIds,
	      "showCreateButton": false
	    },
	    on: {
	      "update": _vm.setSelectedClub
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__flex"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['hours_in_school_year']))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: false,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	        onShow: function () { return _vm.isHoursDisabled; }
	      }),
	      expression: "{\n                     arrow: false,\n                     animateFill: false,\n                     animation: 'shift-away',\n                     zIndex: '999999992',\n                     boundary: 'window',\n                     onShow: () => isHoursDisabled\n                   }"
	    }],
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['hours_disabled_desc']
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.hours),
	      expression: "hours",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "inputLessonCount",
	    class: {
	      'input--error': _vm.formErrors['hours'],
	      'input--disabled': _vm.isHoursDisabled
	    },
	    attrs: {
	      "type": "number",
	      "disabled": _vm.isHoursDisabled
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  })]), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), (_vm.showDanishPreparationFactorBesideHours && !_vm.isDanishPrepBinaryOnOwnRow) ? _c('DkPreparationFactorControl', {
	    attrs: {
	      "subject-type": _vm.subjectType,
	      "school-prep-factor": _vm.schoolSettings.prepFactor,
	      "labels": _vm.danishPreparationControlLabels,
	      "wrap-class": "input-group"
	    },
	    model: {
	      value: (_vm.preparation),
	      callback: function($$v) {
	        _vm.preparation = $$v
	      },
	      expression: "preparation"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['standard_duration']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.defaultDuration),
	      expression: "defaultDuration"
	    }],
	    class: {
	      'input--error': _vm.formErrors['defaultDuration']
	    },
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.defaultDuration)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.defaultDuration = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['defaultDuration']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['defaultDuration'][_vm.locale]))]) : _vm._e()])], 1), _vm._v(" "), (_vm.showDanishPreparationFactorBesideHours && _vm.isDanishPrepBinaryOnOwnRow) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('DkPreparationFactorControl', {
	    attrs: {
	      "subject-type": _vm.subjectType,
	      "school-prep-factor": _vm.schoolSettings.prepFactor,
	      "labels": _vm.danishPreparationControlLabels,
	      "wrap-class": "input-group dk-prep-factor-full-width"
	    },
	    model: {
	      value: (_vm.preparation),
	      callback: function($$v) {
	        _vm.preparation = $$v
	      },
	      expression: "preparation"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_color']))]), _vm._v(" "), _c('ColorPicker', {
	    attrs: {
	      "initialColor": _vm.color
	    },
	    on: {
	      "changedColor": _vm.setSubjectColor
	    }
	  })], 1), _vm._v(" "), (_vm.calendarType === 'klass' && _vm.klassStudents.length > 0) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.students.students')))]), _vm._v(" "), _c('StudentsOnSubject', {
	    attrs: {
	      "calendarId": _vm.calendarId,
	      "isNotEditSubject": _vm.isEditSubject,
	      "studentCalendarIds": _vm.studentCalendarIds
	    },
	    on: {
	      "changed": _vm.setStudentCalendarIds
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.isShowSchool) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', [(!_vm.theSchoolForTheSubject) ? _c('h3', [_vm._v(_vm._s(_vm.activeSchool.name))]) : _c('h3', [_vm._v(_vm._s(_vm.theSchoolForTheSubject.name) + "\n                "), (_vm.theActiveSchoolYearForTheSubject) ? _c('span', {
	    staticClass: "small-text"
	  }, [_vm._v(", " + _vm._s(_vm.theActiveSchoolYearForTheSubject.name))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.isShowSchoolYearSelector) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_school_year']))]), _vm._v(" "), _c('ChangeSchoolYear', {
	    staticStyle: {
	      "width": "50%"
	    },
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_subject_type']))]), _vm._v(" "), _c('SubjectTypePicker', {
	    attrs: {
	      "calendarType": _vm.calendarType,
	      "subjectType": _vm.subjectType
	    },
	    on: {
	      "change": _vm.selectSubjectType
	    }
	  })], 1), _vm._v(" "), (_vm.editSubject) ? _c('div', {
	    staticClass: "edit-subject add-lesson__footer"
	  }, [_c('div', {
	    staticClass: "input-group input-group__submit"
	  }, [_c('div', {
	    staticClass: "input-group__submit__left"
	  }, [(_vm.editSubjectCanBeDeleted) ? _c('button', {
	    staticClass: "hint--right bttn--warning",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['delete_subject']
	    },
	    on: {
	      "click": _vm.deleteEditSubject
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })]) : _c('div', {
	    staticClass: "hint--right",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['cannot_delete']
	    }
	  }, [_c('button', {
	    staticClass: "bttn bttn--disabled"
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__submit__right"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))]), _vm._v(" "), (_vm.editSubject) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.updateSubject
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['update_subject']) + "\n                ")]) : _vm._e()])])]) : _c('div', {
	    staticClass: "input-group input-group__submit add-lesson__footer"
	  }, [_c('div', {
	    staticClass: "input-group__submit__left"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "input-group__submit__right"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.createSubject
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_subject']))])])])], 1) : _vm._e()], _vm._v(" "), (_vm.subjectsWithSameName.length > 0) ? _c('SubjectFormDeleteSubjects', {
	    attrs: {
	      "subjectsWithSameName": _vm.subjectsWithSameName
	    },
	    on: {
	      "close": _vm.closeModalSubjectsWithSameName,
	      "keep": _vm.keepExistingSubjects,
	      "delete": _vm.deleteExistingSubjects
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showPoolsConfirm) ? _c('SubjectPoolsUpdateConfirm', {
	    attrs: {
	      "subject": _vm.editSubject,
	      "newHours": _vm.hours
	    },
	    on: {
	      "updateAll": _vm.onPoolsConfirmUpdateAll,
	      "subjectOnly": _vm.onPoolsConfirmSubjectOnly,
	      "close": _vm.onPoolsConfirmClose
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showAssignTeacherToEventsConfirm) ? _c('SubjectAssignTeacherToEventsConfirm', {
	    attrs: {
	      "teacherNames": _vm.assignTeacherToEventsNames,
	      "initialDate": _vm.assignTeacherToEventsInitialDate,
	      "mode": _vm.assignTeacherToEventsAction,
	      "calendarKind": _vm.assignTeacherToEventsKind,
	      "color": _vm.color,
	      "subjectName": _vm.name
	    },
	    on: {
	      "confirm": _vm.onAssignTeacherToEventsConfirm,
	      "skip": _vm.onAssignTeacherToEventsSkip
	    }
	  }) : _vm._e()], 2)])], 2) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1728 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "small"
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#ffffff"
	    }
	  }) : _c('line-chart', {
	    attrs: {
	      "chart-data": _vm.datacollection,
	      "options": _vm.options
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "is-bg-overlay": true
	    }
	  }, [_c('div', {
	    staticClass: "modal-merges",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [(_vm.isMergeCalendar) ? _c('h2', [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.merge_with_calendar')))]) : _c('h2', [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.merge_with_merge_calendars')))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [(_vm.isLoadingMerges) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc",
	      "isSmall": true
	    }
	  }) : [(_vm.isMergeCalendar) ? _c('div', [(_vm.calendarsMerged.length > 0) ? _c('label', {
	    staticClass: "d-label d-label__divider d-label__divider--top"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.is_merged')))]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.calendarsMerged), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "modal-merges__item",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.unMergeCalendarFromMergeCalendar(calendar)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v(_vm._s(calendar.name) + "\n                "), _c('span', {
	      staticClass: "do-pill marg-05-rem"
	    }, [_vm._v(_vm._s(calendar.year))])]), _vm._v(" "), (_vm.theLoaderId === calendar.id) ? _c('div', {
	      staticClass: "do-spinner do-spinner--custom-marg"
	    }) : _c('div', {
	      staticClass: "do-switch do-switch--active"
	    })])
	  }), 0), _vm._v(" "), _c('label', {
	    staticClass: "d-label d-label__divider"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.can_be_merged_into')))]), _vm._v(" "), _c('ul', _vm._l((_vm.possibleToMerge), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "modal-merges__item",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.mergeCalendarFromMergeCalendar(calendar)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v(_vm._s(calendar.name) + "\n                "), _c('span', {
	      staticClass: "do-pill marg-05-rem"
	    }, [_vm._v(_vm._s(calendar.year))])]), _vm._v(" "), (_vm.theLoaderId === calendar.id) ? _c('div', {
	      staticClass: "do-spinner do-spinner--custom-marg"
	    }) : _c('div', {
	      staticClass: "do-switch"
	    })])
	  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.isMergeCalendar) ? _c('ul', _vm._l((_vm.allMergeCalendars), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "modal-merges__item",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.toggleMergeCalendar(calendar)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v(_vm._s(calendar.name)), (calendar.archived) ? _c('span', {
	      staticClass: "do-pill do-pill--yellow marg-05-rem"
	    }, [_vm._v("Archived")]) : _vm._e()]), _vm._v(" "), (_vm.theLoaderId === calendar.id) ? _c('div', {
	      staticClass: "do-spinner do-spinner--custom-marg"
	    }) : _c('div', {
	      staticClass: "do-switch",
	      class: {
	        'do-switch--active': calendar.vIsMerged
	      }
	    })])
	  }), 0) : _vm._e()]], 2), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.done')))])])])])
	},staticRenderFns: []}

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-kindergarten__color-picker"
	  }, [_vm._v("\n  " + _vm._s(_vm.hours) + "\n")])
	},staticRenderFns: []}

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "user text-dark"
	  }, [(!_vm.user && !_vm.calendar) ? _c('Loader', {
	    staticStyle: {
	      "margin-top": "200px"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isSubHeader) ? _c('div', {
	    staticClass: "sub-header"
	  }, [_c('p', {
	    staticClass: "sub-header__title"
	  }, [_vm._v("\n      " + _vm._s(_vm.theSelectedUser.name) + "\n      "), _c('span', {
	    staticClass: "sub-header__title-divider icon-arrow-right4"
	  })]), _vm._v(" "), _c('a', {
	    class: {
	      'active': _vm.theView === 'calendar'
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setTheView('calendar')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.calendar')))]), _vm._v(" "), (_vm.canSeeTaskOverview) ? _c('a', {
	    class: {
	      'active': _vm.theView === 'tasks'
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setTheView('tasks')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.task_overview')))]) : _vm._e(), _vm._v(" "), (_vm.canSeeHourOverview) ? _c('a', {
	    class: {
	      'active': _vm.theView === 'hours'
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setTheView('hours')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.hour_overview')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInUp"
	    }
	  }, [(_vm.user && _vm.calendar && _vm.theView === 'tasks') ? _c('TaskOverviewPage', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "isCanSeeOtherUsers": false,
	      "user_id": _vm.theSelectedUser.userId,
	      "user_calendar_id": _vm.theSelectedUser.calendarId,
	      "user_name": _vm.theSelectedUser.name
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInUp"
	    }
	  }, [(_vm.user && _vm.calendar && _vm.theView === 'hours') ? _c('UserTasks', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "isCanSeeOtherUsers": false,
	      "user_id": _vm.theSelectedUser.userId,
	      "user_calendar_id": _vm.theSelectedUser.calendarId,
	      "user_name": _vm.theSelectedUser.name
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInUp"
	    }
	  }, [(_vm.user && _vm.calendar && _vm.theView === 'calendar') ? _c('div', [_c('week-selector', {
	    attrs: {
	      "startDate": _vm.weekSelectorStartDate,
	      "endDate": _vm.weekSelectorEndDate,
	      "date": _vm.activeCalendarDate
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "printCalendar"
	    }
	  }, [_c('div', {
	    staticClass: "user-calendar"
	  }, [_c('div', {
	    staticClass: "user-calendar__header"
	  }, [_c('div', {
	    staticClass: "user-calendar__header__left"
	  }, [_c('SelectCalendar', {
	    staticClass: "marg-1-right",
	    attrs: {
	      "isMultiple": _vm.userHasPermission('can_see_other_calendars')
	    }
	  }), _vm._v(" "), (_vm.isUsersCalendar) ? _c('UserPresence', {
	    attrs: {
	      "calid": _vm.user.user_calendar_id,
	      "activeCalendarDate": _vm.activeCalendarDate
	    },
	    on: {
	      "saved": _vm.presenceCall
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "user-calendar__header__right"
	  }, [(_vm.userCanRequestAbsence) ? _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        _vm.isShowAbsenceRequest = true
	      }
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('vue2.request_absence.request_absence')) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('Print', {
	    attrs: {
	      "onlyPrintThisCalendar": true,
	      "calendarId": _vm.theActiveCalendarId,
	      "activeCalendarDate": _vm.activeCalendarDate
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn no-print",
	    class: {
	      'bttn--disabled': _vm.isNotThisWeek
	    },
	    on: {
	      "click": _vm.today
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('repitition.today')) + "\n              ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn icon-arrow-left4 no-print",
	    on: {
	      "click": _vm.prevWeek
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	        onShow: function () { return _vm.isAtMaxWeek; }
	      }),
	      expression: "{\n                arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => isAtMaxWeek\n                }"
	    }],
	    attrs: {
	      "content": _vm.isAtMaxWeek ? _vm.$t('vue2.calendar_view.next_week_disabled_tooltip') : ''
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn icon-arrow-right4 no-print",
	    class: {
	      'bttn--disabled': _vm.isAtMaxWeek
	    },
	    attrs: {
	      "disabled": _vm.isAtMaxWeek
	    },
	    on: {
	      "click": _vm.nextWeek
	    }
	  })])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-calendar__calendar__container",
	    class: {
	      'd-calendar__calendar__container--print-mode': _vm.isCalendarInPrintMode
	    }
	  }, [_c('DCalendar', {
	    attrs: {
	      "isEditable": _vm.isEditable,
	      "isCalendarInPrintMode": _vm.isCalendarInPrintMode,
	      "isShowWeekends": _vm.isShowWeekends,
	      "startTime": _vm.startTime,
	      "endTime": _vm.endTime,
	      "date": _vm.activeCalendarDate,
	      "events": _vm.dCalendarEvents,
	      "calendarId": _vm.calendar.id,
	      "calendarName": _vm.calendar.name,
	      "isEventsClickable": true,
	      "isLoadingEvents": _vm.isEventsLoading
	    },
	    on: {
	      "onEventClick": _vm.setActiveEvent
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "user-calendar__footer no-print"
	  }, [(_vm.isUsersCalendar) ? _c('ExportCalendar', {
	    attrs: {
	      "calLink": _vm.iCalUrl
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.isShowWeekPlan) ? _c('DWeekplan', {
	    attrs: {
	      "isInPrintMode": _vm.isInPrintMode,
	      "isReadOnly": _vm.isInPrintMode || !_vm.userHasPermission('can_edit_own_notes')
	    }
	  }) : _vm._e()], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "zoomIn"
	    }
	  }, [(_vm.activeEvent) ? _c('DCalendarShowEvent', {
	    attrs: {
	      "canEditEvent": _vm.isEditable,
	      "canEditNotes": _vm.userHasPermission('can_edit_own_notes'),
	      "event": _vm.activeEvent,
	      "calendar": _vm.calendar,
	      "initCalendarId": _vm.calendar.id,
	      "isInDCalendar": true
	    },
	    on: {
	      "updated": _vm.readEvents,
	      "close": _vm.closeShowEvent
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.isShowAbsenceRequest) ? _c('UserRequest', {
	    on: {
	      "close": function($event) {
	        _vm.isShowAbsenceRequest = false
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-touch', {
	    staticClass: "day-cal__overlay",
	    style: ({
	      height: _vm.height + 'px'
	    })
	  }, [_c('div', {
	    staticClass: "cal-wrapper",
	    style: ({
	      height: _vm.calHeight + 'px'
	    })
	  }, [_c('DCalendar', {
	    key: _vm.activeDate + '_' + _vm.locale,
	    attrs: {
	      "isEditable": false,
	      "isShowWeekends": _vm.isShowWeekends,
	      "startTime": _vm.startTime,
	      "endTime": _vm.endTime,
	      "date": _vm.activeDate,
	      "events": _vm.lessons,
	      "calendarId": _vm.calId,
	      "isEventsClickable": true,
	      "localeOverride": _vm.locale
	    },
	    on: {
	      "onEventClick": _vm.onTap
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "pad-10 weekplan-header marg-20-top"
	  }, [_c('span', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.calRangeView))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('calendars.week_plan_and_note.week_plan')))])]), _vm._v(" "), _c('weekplan', {
	    staticClass: "pad-10",
	    attrs: {
	      "weeknote": _vm.weeknote,
	      "calId": _vm.calId,
	      "date": _vm.date,
	      "events": _vm.lessons
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1733 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container"
	  }, [_c('div', {
	    staticClass: "d-guides"
	  }, [_c('StilGuides', {
	    attrs: {
	      "video-id": 'etaeiteazYM?start=112',
	      "textForLink": "Guide: Se videoguide for ressourceforbrug"
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "text-link",
	    attrs: {
	      "target": "_blank",
	      "href": "https://test-data.stil.dk/grundskoleindberetning/Vejledninger/2022/1012/Praktisk%20vejledning_Ressourceforbrug_2022.pdf"
	    }
	  }, [_vm._v("Læs\n      officiel vejledning fra STIL")]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', {
	    staticClass: "center"
	  }, [_c('tr', [_c('th', {
	    staticStyle: {
	      "min-width": "225px"
	    }
	  }, [_c('div', {
	    staticClass: "filter-and-select"
	  }, [_c('span', {
	    staticClass: "icon-filter"
	  }), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.activeUserFilter),
	      expression: "activeUserFilter"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.activeUserFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.stilStillingerWithCount), function(stilStilling) {
	    return _c('option', {
	      domProps: {
	        "value": stilStilling.value
	      }
	    }, [_vm._v("\n              " + _vm._s(stilStilling.title) + " (" + _vm._s(stilStilling.count) + ")\n            ")])
	  }), 0)])]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Arbejdstimer")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Fagopdelt undervisning")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Understøttende undervisning")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('tr', {
	    staticClass: "thead-second-row"
	  }, [_c('th', [_c('div', {
	    staticClass: "select-all-and-button"
	  }, [_c('p', {
	    staticClass: "select-all",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.selectedUsers.length < 1) ? _c('span', [_vm._v("Vælg alle")]) : _c('span', [_vm._v("Fravælg alle")])]), _vm._v(" "), (_vm.selectedUsers.length < 1) ? _c('div', {
	    staticClass: "hint--bottom-left",
	    attrs: {
	      "aria-label": "Vælg brugere først"
	    }
	  }, [_c('button', {
	    staticClass: "no-print bttn bttn--disabled"
	  }, [_vm._v("\n              Indsæt på valgte\n            ")])]) : _c('button', {
	    staticClass: "up__button",
	    on: {
	      "click": function($event) {
	        _vm.isInsertOnMore = true
	      }
	    }
	  }, [_vm._v("Indsæt på valgte")])])]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredUsersWithVProps), function(user, userIdx) {
	    return _c('tr', {
	      key: user.id
	    }, [_c('td', {
	      staticClass: "td__select-user",
	      class: {
	        'td__select-user--selected': _vm.theActiveUserId === user.id
	      },
	      on: {
	        "click": function($event) {
	          return _vm.selectUser(user.id)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "name-and-title"
	    }, [_c('div', {
	      staticClass: "name-and-title__checkbox"
	    }, [_c('div', {
	      staticClass: "d-checkbox",
	      class: {
	        'd-checkbox--active': _vm.getIsUserSelected(user.id)
	      }
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('div', [(user.v_stil_stilling_title) ? _c('p', {
	      staticClass: "d-pill"
	    }, [_vm._v("\n              " + _vm._s(user.v_stil_stilling_title) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "hint--right",
	      attrs: {
	        "aria-label": _vm.theActiveUserId !== user.id ? 'Se opgaveoversigt' : 'Luk opgaveoversigt'
	      }
	    }, [_c('div', {
	      staticClass: "icon__bg-circle",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setTheActiveUserId(user.id)
	        }
	      }
	    }, [(_vm.theActiveUserId !== user.id) ? _c('span', {
	      staticClass: "icon-clipboard2"
	    }) : _c('span', {
	      staticClass: "icon-cross2"
	    })])])])]), _vm._v(" "), (_vm.theActiveUserId === user.id) ? _c('StilRessourceTasks', {
	      attrs: {
	        "userId": user.id,
	        "schoolYear": _vm.activeSchoolYear,
	        "startDate": _vm.activeSchoolYear.employee_time_start,
	        "endDate": _vm.activeSchoolYear.employee_time_end
	      }
	    }) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_hours_total_normal),
	        expression: "user.v_stil_hours_total_normal"
	      }],
	      class: {
	        'number--empty': !user.v_stil_hours_total_normal
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (user.v_stil_hours_total_normal)
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateUser(user, 'stil_hours_40_B', $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(user, "v_stil_hours_total_normal", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_hours_total_special),
	        expression: "user.v_stil_hours_total_special"
	      }],
	      class: {
	        'number--empty': !user.v_stil_hours_total_special
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (user.v_stil_hours_total_special)
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateUser(user, 'stil_hours_50_B', $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(user, "v_stil_hours_total_special", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_hours_fag_normal),
	        expression: "user.v_stil_hours_fag_normal"
	      }],
	      class: {
	        'number--empty': !user.v_stil_hours_fag_normal
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (user.v_stil_hours_fag_normal)
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateUser(user, 'stil_hours_40_A1', $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(user, "v_stil_hours_fag_normal", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_hours_fag_special),
	        expression: "user.v_stil_hours_fag_special"
	      }],
	      class: {
	        'number--empty': !user.v_stil_hours_fag_special
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (user.v_stil_hours_fag_special)
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateUser(user, 'stil_hours_50_A1', $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(user, "v_stil_hours_fag_special", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_hours_uuv_normal),
	        expression: "user.v_stil_hours_uuv_normal"
	      }],
	      class: {
	        'number--empty': !user.v_stil_hours_uuv_normal
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (user.v_stil_hours_uuv_normal)
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateUser(user, 'stil_hours_40_A22', $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(user, "v_stil_hours_uuv_normal", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_hours_uuv_special),
	        expression: "user.v_stil_hours_uuv_special"
	      }],
	      class: {
	        'number--empty': !user.v_stil_hours_uuv_special
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (user.v_stil_hours_uuv_special)
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateUser(user, 'stil_hours_50_A22', $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(user, "v_stil_hours_uuv_special", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_hours_other_normal),
	        expression: "user.v_stil_hours_other_normal"
	      }],
	      class: {
	        'number--empty': !user.v_stil_hours_other_normal
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (user.v_stil_hours_other_normal)
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateUser(user, 'stil_hours_40_A33', $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(user, "v_stil_hours_other_normal", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_hours_other_special),
	        expression: "user.v_stil_hours_other_special"
	      }],
	      class: {
	        'number--empty': !user.v_stil_hours_other_special
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (user.v_stil_hours_other_special)
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateUser(user, 'stil_hours_50_A33', $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(user, "v_stil_hours_other_special", $event.target.value)
	        }
	      }
	    })])])
	  }), 0)]), _vm._v(" "), (_vm.isInsertOnMore) ? _c('GrundskoleIndberetningRessourceInsertModal', {
	    attrs: {
	      "selectedUsers": _vm.selectedUserObjects,
	      "schoolId": _vm.schoolId
	    },
	    on: {
	      "updateRessource": _vm.updateRessourceFromModal,
	      "close": _vm.closeInsertOnMore
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "italic"
	  }, [_vm._v("Bemærk: I skal indberette, hvor mange undervisningsressourcer (målt i arbejdstimer), som skolen\n      råder over, og hvordan skolen planlægger at bruge de undervisningsressourcer"), _c('br'), _vm._v("\n      Arbejdstiden for en fuldstidslærer er 1924 timer. Ud af dette findes et skøn for tid brugt på: Undervisning, UUV\n      og Øvrig tid med eleverne (f.eks. elevsamtaler, gårdvagt og pause med eleverne)")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Øvrig tid med eleverne"), _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("(f.eks. elevsamtaler,\n        gårdvagt og pauser med eleverne)")])])
	}]}

/***/ }),
/* 1734 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', {
	    key: _vm.item.id,
	    class: {
	      'is-archived': _vm.isArchived
	    }
	  }, [_c('td', [_vm._v(_vm._s(_vm.item.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "width": "60%",
	      "position": "relative"
	    }
	  }, [(_vm.isShowModal) ? _c('CostCentersCenterCalendarsModal', {
	    attrs: {
	      "calendars": _vm.calendars,
	      "selected-ids": _vm.selectedIds
	    },
	    on: {
	      "close": function($event) {
	        _vm.isShowModal = false
	      },
	      "submit": _vm.onModalSubmit
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "cost-center-actions"
	  }, [(!_vm.isInSchoolSalarySettings && !_vm.isArchived) ? _c('div', {
	    staticClass: "click-container",
	    on: {
	      "!click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        _vm.isShowModal = true
	      }
	    }
	  }, [_c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Kalendere',
	      "tags": _vm.calendarNames,
	      "numberOfSelectedTagsToShow": 20,
	      "selectedTags": _vm.selectedNames
	    },
	    on: {
	      "select": _vm.noop,
	      "clear": _vm.noop,
	      "close": _vm.noop
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isArchived) ? _c('button', {
	    staticClass: "do-bttn do-bttn--small",
	    class: {
	      'do-bttn--loading': _vm.isUpdating
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.$emit('archive', _vm.item)
	      }
	    }
	  }, [_vm._v("\n        Arkivér\n      ")]) : _vm._e()])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1735 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "left-panel",
	    class: {
	      'panelActive': this.selectedWeeks.length > 0 && this.deleteEvents
	    }
	  }, [(_vm.isLoading) ? _c('spinner') : [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.lessons.length === 0),
	      expression: "lessons.length === 0"
	    }]
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.noSubstitutesOrNotes')))])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.lessons.length !== 0),
	      expression: "lessons.length !== 0"
	    }]
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.youAreAboutToDelete')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.lessons.length) + " " + _vm._s(_vm.lessons.length === 1 ? _vm.$t('vue2.copycalendar.lesson') : _vm.$t('vue2.copycalendar.lessons')) + " " + _vm._s(_vm.$t('vue2.copycalendar.withSubstitutesOrNotes')))]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('ul', _vm._l((_vm.sortedLesson), function(lesson, index) {
	    return _c('li', {
	      key: lesson.id
	    }, [(!_vm.isSameDate(index)) ? _c('p', {
	      staticClass: "headline"
	    }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.copycalendar.week')) + " " + _vm._s(_vm._f("showWeek")(lesson.event_time_start)) + "\n        ")]) : _vm._e(), _vm._v(" "), (lesson.has_notes) ? _c('span', {
	      staticClass: "icon-file-text2"
	    }) : _vm._e(), _vm._v(" "), (lesson.has_substitute) ? _c('span', {
	      staticClass: "icon-users"
	    }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm._f("showDateAndTime")(lesson.event_time_start)) + "\n        " + _vm._s(lesson.title) + "\n      ")])
	  }), 0)]], 2)
	},staticRenderFns: []}

/***/ }),
/* 1736 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-group text-dark"
	  }, [(_vm.isShowLabel) ? _c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n['absence_reason']))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "choose-subject"
	  }, [(_vm.isLoadingSubjects) ? _c('div', {
	    staticClass: "choose-subject__spinner"
	  }, [_c('div', {
	    staticClass: "do-spinner"
	  })]) : _c('dSelect', {
	    attrs: {
	      "items": _vm.sortedSubjects,
	      "resetCounter": _vm.resetCounter,
	      "multiple": false,
	      "placeholder": _vm.$t('vue2.common.search'),
	      "itemSpaceBetween": true,
	      "itemsSelected": _vm.selectedSubjectArr,
	      "isShowRemoveButton": false
	    },
	    on: {
	      "enter": function($event) {
	        _vm.isCreateAbsenceReason = true
	      },
	      "update": _vm.setSubject,
	      "searchText": _vm.setTheSearchText,
	      "onSearchTextDebounced": _vm.onSearchTextDebounced,
	      "close": _vm.onCloseDSelect
	    },
	    scopedSlots: _vm._u([_vm._l((_vm.sortedSubjects), function(item, index) {
	      return {
	        key: "test",
	        fn: function(slotProps) {
	          return [_c('div', {
	            staticClass: "choose-subject__event_type"
	          }, [_vm._v("\n          " + _vm._s(slotProps.item.vSubjectType) + "\n        ")])]
	        }
	      }
	    })], null, true)
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1737 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-week-selector week-selector overflow no-print text-dark"
	  }, [(_vm.startDate) ? _c('ul', {
	    staticClass: "week-selector__weeks"
	  }, [_c('li', {
	    staticClass: "disabled"
	  }, [_vm._v(_vm._s(_vm.startDateInYear))]), _vm._v(" "), _vm._l((_vm.weeksInYear), function(week) {
	    return _c('li', [_c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: false,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n      arrow: false,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n        }"
	      }],
	      staticClass: "pointer",
	      class: [{
	        'active': week.isChosenWeek,
	        'isThisWeek': week.isThisWeek
	      }],
	      attrs: {
	        "content": week.tooltipDate
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setDate(week.date)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(week.weekNum) + "\n      ")])])
	  }), _vm._v(" "), _c('li', {
	    staticClass: "disabled week-selector__weeks__right"
	  }, [_vm._v(_vm._s(_vm.endDateInYear))])], 2) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "task-create text-dark"
	  }, [_c('DModal', {
	    attrs: {
	      "show-close": false
	    },
	    on: {
	      "close": _vm.close
	    }
	  }, [_c('div', {
	    staticClass: "task-create__modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "task-create__header",
	    class: {
	      'task-create__header--create-subject': _vm.canSchedule
	    },
	    style: ({
	      'backgroundColor': _vm.color
	    })
	  }, [_c('div', {
	    staticClass: "task-create__header-main"
	  }, [_c('h3', [(_vm.name.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_task']))]) : _c('span', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), (_vm.canCopyToSharedCalendar) ? _c('DDropdown', {
	    staticClass: "task-create__header-menu",
	    attrs: {
	      "isBottomStart": false,
	      "propOffset": [0, 8]
	    }
	  }, [_c('ul', {
	    staticClass: "task-create__copy-calendar-list",
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', {
	    staticClass: "task-create__menu-heading"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_to_shared_calendar']))]), _vm._v(" "), _vm._l((_vm.copyCalendarOptions), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      on: {
	        "click": function($event) {
	          return _vm.copyTaskToSharedCalendar(calendar.id)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-clipboard2"
	    }), _vm._v(" " + _vm._s(calendar.name) + "\n              ")])
	  })], 2)]) : _vm._e()], 1), _vm._v(" "), (_vm.isShowSamletTid) ? _c('div', {
	    staticClass: "task-create__total-time"
	  }, [_c('span', {
	    staticClass: "task-create__total-time-value"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['total_time']) + ": " + _vm._s(_vm.samletTid.total) + " " + _vm._s(_vm.i18n[_vm.locale]['hours_unit']))]), _vm._v(" "), _c('span', {
	    staticClass: "task-create__total-time-breakdown"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['teaching']) + " " + _vm._s(_vm.samletTid.teaching) + " " + _vm._s(_vm.i18n[_vm.locale]['hours_unit']) + " · " + _vm._s(_vm.i18n[_vm.locale]['preparation']) + " " + _vm._s(_vm.samletTid.prep) + " " + _vm._s(_vm.i18n[_vm.locale]['hours_unit']))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "task-create__close icon__bg-circle",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('form', {
	    staticClass: "task-create__body",
	    attrs: {
	      "id": "task-create"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [(_vm.isLoadingFreshData) ? _c('div', {
	    staticClass: "task-create__loading-overlay"
	  }, [_c('div', {
	    staticClass: "do-spinner"
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "task-create__form"
	  }, [(!_vm.quickCreate) ? [_c('div', {
	    staticClass: "input-group__flex input-group__flex--top-row"
	  }, [_c('div', {
	    staticClass: "input-group input-group__title input-flex-2"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['task_title']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    ref: "name",
	    staticClass: "d-input",
	    class: {
	      'input--error': _vm.formErrors['name']
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale]['ex_task']
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('name')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['name']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['name'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__hours-top"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['hours']) + " ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.hours),
	      expression: "hours",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "inputLessonCount",
	    staticClass: "d-input",
	    class: {
	      'input--error': _vm.formErrors['hours']
	    },
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "blur": [function($event) {
	        return _vm.removeErrors('hours')
	      }, function($event) {
	        return _vm.$forceUpdate()
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = _vm._n($event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), (_vm.isShowNorwegianPreparationDropdown) ? _c('div', {
	    staticClass: "input-group input-group__preparation"
	  }, [_c('label', [_vm._v("Årsramme")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preparation),
	      expression: "preparation"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.preparation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.preparation = $event.target.value
	      }
	    }
	  })]) : (_vm.isShowDanishPreparationFactorField && !_vm.isDanishPrepBinaryOnOwnRow) ? _c('DkPreparationFactorControl', {
	    attrs: {
	      "subject-type": _vm.subjectType,
	      "school-prep-factor": _vm.schoolSettings.prepFactor,
	      "labels": _vm.danishPreparationControlLabels,
	      "input-class": "d-input",
	      "wrap-class": "input-group input-group__preparation"
	    },
	    model: {
	      value: (_vm.preparation),
	      callback: function($$v) {
	        _vm.preparation = $$v
	      },
	      expression: "preparation"
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.isDanishPrepBinaryOnOwnRow) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('DkPreparationFactorControl', {
	    attrs: {
	      "subject-type": _vm.subjectType,
	      "school-prep-factor": _vm.schoolSettings.prepFactor,
	      "labels": _vm.danishPreparationControlLabels,
	      "input-class": "d-input",
	      "wrap-class": "input-group input-group__preparation dk-prep-factor-full-width"
	    },
	    model: {
	      value: (_vm.preparation),
	      callback: function($$v) {
	        _vm.preparation = $$v
	      },
	      expression: "preparation"
	    }
	  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_user']))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "USER",
	      "preSelectedItems": _vm.calendars,
	      "showTags": true,
	      "itemsThatCantBeDeleted": _vm.usersWithEvents
	    },
	    on: {
	      "update": _vm.setSelectedUsers
	    }
	  })], 1), _vm._v(" "), (!_vm.quickCreate) ? [_c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "create-as-subject"
	  }, [_c('div', {
	    staticClass: "create-as-subject__inner",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleDateFields.apply(null, arguments)
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "propOn": _vm.isShowDateFields,
	      "allowChanges": false
	    }
	  }), _vm._v(" "), _c('label', {
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_dates_on_overview']))])], 1)])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropdown"
	    }
	  }, [(_vm.isShowDateFields) ? _c('div', {
	    staticClass: "input-group__flex"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['from_date']))]), _vm._v(" "), _c('div', {
	    staticClass: "date-field"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.fromDate || _vm.today,
	      "width100": true
	    },
	    on: {
	      "changed": _vm.setFromDate
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['to_date']))]), _vm._v(" "), _c('div', {
	    staticClass: "date-field"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.toDate || _vm.today,
	      "width100": true
	    },
	    on: {
	      "changed": _vm.setToDate
	    }
	  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_type']))]), _vm._v(" "), _c('SubjectFormSubjectType', {
	    attrs: {
	      "calendar-type": "user",
	      "subject-type": _vm.subjectType,
	      "isInTasks": true
	    },
	    on: {
	      "change": _vm.setSubjectType
	    }
	  })], 1)] : _vm._e(), _vm._v(" "), (_vm.quickCreate) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['hours_as']) + " "), _c('span', {
	    staticClass: "pill pill--grey hint--top-right",
	    attrs: {
	      "aria-label": "Vælg briktype for at ændre"
	    }
	  }, [_vm._v(_vm._s(_vm.hoursType))])]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__flex"
	  }, [_c('div', {
	    staticStyle: {
	      "width": "50%"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.hours),
	      expression: "hours",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "inputLessonCount",
	    staticClass: "d-input",
	    class: {
	      'input--error': _vm.formErrors['hours']
	    },
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "blur": [function($event) {
	        return _vm.removeErrors('hours')
	      }, function($event) {
	        return _vm.$forceUpdate()
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = _vm._n($event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (!_vm.quickCreate) ? [_c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "create-as-subject",
	    class: {
	      'create-as-subject--disabled': _vm.cannotChangeCanSchedule
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: (_vm.cannotChangeCanSchedule ? {
	        arrow: true,
	        placement: 'top'
	      } : {
	        trigger: 'manual'
	      }),
	      expression: "cannotChangeCanSchedule ? { arrow: true, placement: 'top' } : { trigger: 'manual' }"
	    }],
	    staticClass: "create-as-subject__inner",
	    class: {
	      'create-as-subject__inner--disabled': _vm.cannotChangeCanSchedule
	    },
	    attrs: {
	      "content": _vm.cannotChangeCanScheduleTooltip
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleCanSchedule.apply(null, arguments)
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "propOn": _vm.canSchedule,
	      "allowChanges": false
	    },
	    on: {
	      "changed": _vm.setIsCreateAsSubject
	    }
	  }), _vm._v(" "), _c('label', {
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['can_be_scheduled']))])], 1)])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropdown"
	    }
	  }, [(_vm.canSchedule) ? _c('div', [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['duration']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.duration),
	      expression: "duration",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "inputLessonCount",
	    staticClass: "d-input",
	    class: {
	      'input--error': _vm.formErrors['duration']
	    },
	    staticStyle: {
	      "width": "50%"
	    },
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.duration)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "blur": [function($event) {
	        return _vm.removeErrors('duration')
	      }, function($event) {
	        return _vm.$forceUpdate()
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.duration = _vm._n($event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['duration']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['duration'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropdown"
	    }
	  }, [(_vm.isCreateInOtherCalendarAnOption && !_vm.editTask) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_in_calendar']))]), _vm._v(" "), _c('SelectOtherCal', {
	    attrs: {
	      "selectedCalendarId": _vm.selectedOtherCalendarId,
	      "calendarType": _vm.taskCalendarType
	    },
	    on: {
	      "changed": _vm.setSelectedOtherCalendarId
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), (_vm.editTask && _vm.getOtherCalendarName(_vm.selectedOtherCalendarId)) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['created_in_calendar']))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.getOtherCalendarName(_vm.selectedOtherCalendarId)))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_color']))]), _vm._v(" "), _c('color-picker', {
	    attrs: {
	      "initialColor": _vm.color
	    },
	    on: {
	      "changedColor": _vm.setColor
	    }
	  })], 1)], 1) : _vm._e()])] : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__submit task-create__footer"
	  }, [_c('div', {
	    staticClass: "input-group__submit__left"
	  }, [(_vm.editTask) ? [(_vm.usersWithEvents.length < 1) ? _c('button', {
	    staticClass: "hint--right bttn--warning",
	    attrs: {
	      "aria-label": "Slet opgaven"
	    },
	    on: {
	      "click": _vm.deleteTask
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })]) : _c('div', {
	    staticClass: "hint--right",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['cannot_be_deleted']
	    }
	  }, [_c('button', {
	    staticClass: "bttn bttn--disabled"
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })])])] : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))])], 2), _vm._v(" "), _c('div', {
	    staticClass: "input-group__submit__right"
	  }, [(!_vm.editTask) ? [_c('button', {
	    staticClass: "do-bttn",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmittingTask
	    },
	    on: {
	      "click": function($event) {
	        return _vm.createTask(true)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['save_and_new']) + "\n                ")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'top',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n                          placement: 'top',\n                          zIndex: 12312312312312\n                        }"
	    }],
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmittingTask
	    },
	    attrs: {
	      "content": _vm.saveKeyTooltip
	    },
	    on: {
	      "click": function($event) {
	        return _vm.createTask(false)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['save_and_close']) + "\n                ")])] : _vm._e(), _vm._v(" "), (_vm.editTask) ? _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'top',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n                        placement: 'top',\n                        zIndex: 12312312312312\n                      }"
	    }],
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmittingTask
	    },
	    attrs: {
	      "content": _vm.saveKeyTooltip
	    },
	    on: {
	      "click": _vm.updateTask
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['update_task']) + "\n              ")]) : _vm._e()], 2)])], 2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-overlay animatedFast fadeIn"
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1739 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "insert brutto text-dark brutto-container",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-container__header"
	  }, [_c('h2', [_vm._v("Indsæt ressourceforbrug på flere")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__body"
	  }, [_c('div', {
	    staticClass: "brutto-container__body__left"
	  }, [_c('ul', {
	    staticClass: "brutto__items"
	  }, _vm._l((_vm.items), function(item, idx) {
	    return _c('li', {
	      key: item.id,
	      staticClass: "brutto__items__item__container"
	    }, [_c('div', {
	      staticClass: "brutto__items__item"
	    }, [_c('span', {
	      staticClass: "norm-title"
	    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', [_c('div', {
	      staticClass: "d-input-group__input"
	    }, [_c('span', {
	      staticClass: "label"
	    }, [_vm._v("Normalklasse")]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.nHours),
	        expression: "item.nHours"
	      }],
	      attrs: {
	        "type": "number"
	      },
	      domProps: {
	        "value": (item.nHours)
	      },
	      on: {
	        "focus": function($event) {
	          return $event.target.select()
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "nHours", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "d-input-group__input"
	    }, [_c('span', {
	      staticClass: "label"
	    }, [_vm._v("Special klasse")]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.sHours),
	        expression: "item.sHours"
	      }],
	      attrs: {
	        "type": "number"
	      },
	      domProps: {
	        "value": (item.sHours)
	      },
	      on: {
	        "focus": function($event) {
	          return $event.target.select()
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "sHours", $event.target.value)
	        }
	      }
	    })])])])])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__footer"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-primary",
	    class: [{
	      'bttn--loading': _vm.isSaving
	    }],
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("\n        Gem\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1740 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "delete-events text-dark"
	  }, [(!_vm.isInDCalendar) ? _c('div', {
	    staticClass: "delete-event__options"
	  }, [_c('DDropdown', [_c('ul', {
	    staticClass: "large-list",
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', {
	    on: {
	      "click": _vm.setDelete
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale].delete_events_onward))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isReadyForModal) ? _c('div', {
	    ref: "d_modal_delete_event"
	  }, [(_vm.isModal) ? _c('Modal', {
	    on: {
	      "close": _vm.closeModal
	    }
	  }, [_c('div', {
	    staticClass: "delete-events___modal text-dark",
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "delete-events___modal__header",
	    style: ({
	      backgroundColor: _vm.bgColor
	    })
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale].are_you_sure))])]), _vm._v(" "), _c('div', {
	    staticClass: "delete-events___modal__form"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale].do_you_want_to_delete_this_and_all_in_same_timeslot))]), _vm._v(" "), _c('div', {
	    staticClass: "delete-events___modal__footer"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.closeModal.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].cancel))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn--warning bttn--red bttn marg-10-left",
	    on: {
	      "click": _vm.deleteEvents
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale].delete_events_onward) + "\n            ")])])])])]) : _vm._e()], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-dark pad-1"
	  }, [_c('div', {
	    staticClass: "page-header marg-1-bottom"
	  }, [_c('h2', [_vm._v("Ansættelser")]), _vm._v(" "), (_vm.isOrganisationsEnabled) ? _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        _vm.isOrganisationsModal = true
	      }
	    }
	  }, [_vm._v("\n      Organisationer\n    ")]) : _vm._e()]), _vm._v(" "), _c('SalarySettingsUsersOpus', {
	    attrs: {
	      "isSalaryIntegrationActive": true,
	      "users": _vm.usersWithEmployments,
	      "employments": _vm.employments,
	      "tags": _vm.tags,
	      "isShowEmploymentNumber": true,
	      "confirmRemoveTemplateOnTagClick": true,
	      "filtersStorageKey": "tjenestenumreFilters",
	      "rowActionLabel": "Indtast tjenestenummer",
	      "emitEditSsn": true
	    },
	    on: {
	      "setTheEditUser": _vm.openImport,
	      "editSsn": _vm.openImport
	    }
	  }), _vm._v(" "), (_vm.theImportUser) ? _c('EmploymentImportModal', {
	    attrs: {
	      "user": _vm.theImportUser,
	      "numberLabel": "Tjenestenummer",
	      "maxLength": 5
	    },
	    on: {
	      "close": function($event) {
	        _vm.theImportUser = null
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isOrganisationsModal) ? _c('SalaryOrganisationsModal', {
	    on: {
	      "close": function($event) {
	        _vm.isOrganisationsModal = false
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "spinner"
	  }, [_c('div', {
	    staticClass: "bounce1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce3"
	  })])
	}]}

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "shortcuts text-dark"
	  }, [_c('div', {
	    staticClass: "shortcuts__buttons"
	  }, [_c('label', {
	    staticClass: "marg-10-right"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.shortcuts')) + ":")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.getAbsentUsers
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.show_all_absent')))]), _vm._v(" "), (_vm.isShowExternalShortCuts) ? _c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "isBottomStart": true,
	      "propOffset": [5, 5]
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn dropdown-button",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("Rapporter "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, _vm._l((_vm.schoolLinks), function(schoolLink) {
	    return _c('li', {
	      key: schoolLink.link,
	      staticClass: "li-links__link"
	    }, [_c('a', {
	      attrs: {
	        "href": schoolLink.link,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(schoolLink.title) + "\n            "), _c('svg', {
	      staticClass: "tw-icon w-6 h-6",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
	      }
	    })])])])
	  }), 0)]) : _vm._e()], 1), _vm._v(" "), (_vm.isShowAbsentUsers) ? _c('div', {
	    staticClass: "shortcuts__overlay__bg",
	    on: {
	      "click": _vm.close
	    }
	  }) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "slideUp"
	    }
	  }, [(_vm.isShowAbsentUsers) ? _c('div', {
	    ref: "overlay",
	    staticClass: "shortcuts__overlay text-dark",
	    attrs: {
	      "id": "printList"
	    }
	  }, [_c('div', {
	    staticClass: "shortcuts__overlay__header"
	  }, [_c('h2', {
	    staticClass: "text-dark"
	  }, [(_vm.isLoading) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.getting_all')))]) : _c('span', [_vm._v(_vm._s(_vm.absentUsers.length))]), _vm._v("\n          " + _vm._s(_vm.$t('vue2.substitute_hours.absent_in_the_period')) + " " + _vm._s(_vm.startDateFormatted) + " - " + _vm._s(_vm.endDateFormatted) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "shortcuts__overlay__header__buttons"
	  }, [_c('button', {
	    staticClass: "no-print",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "shortcuts__overlay__close icon__bg-circle no-print",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader') : _c('div', {
	    staticClass: "shortcuts__users"
	  }, [_c('div', {
	    staticClass: "filters__for__reasons no-print"
	  }, [_c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n['filter_reasons'],
	      "tags": _vm.absenceEventsTypes,
	      "selectedTags": _vm.selectedReasonsToFilter
	    },
	    on: {
	      "select": _vm.toggleFilter,
	      "clear": function($event) {
	        _vm.selectedReasonsToFilter = []
	      }
	    }
	  })], 1), _vm._v(" "), (_vm.absenceEvents.length < 1) ? _c('h4', {
	    staticClass: "italic"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.there_is_no_one_absent')))]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.visibleAbsentUsers), function(absentUser) {
	    return _c('li', {
	      key: absentUser.userCalendarId,
	      staticClass: "shortcuts-user text-dark"
	    }, [_c('div', {
	      staticClass: "shortcuts-user__header"
	    }, [_c('div', {
	      staticClass: "shortcuts-user__header__name"
	    }, [_vm._v(_vm._s(absentUser.name))]), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.days_with_absence')) + ":")]), _vm._v("\n                " + _vm._s(absentUser.days.length) + "\n              ")])]), _vm._v(" "), _c('ul', {
	      staticClass: "text-dark"
	    }, _vm._l((absentUser.days), function(day) {
	      return _c('li', {
	        key: day.date
	      }, [_c('ul', {
	        staticClass: "events__list"
	      }, _vm._l((day.items), function(item) {
	        return _c('li', {
	          key: item.key,
	          staticClass: "events__list__event"
	        }, [_c('div', {
	          staticClass: "events__list__event__meta"
	        }, [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.$filters.ddd(item.event.start))) + " " + _vm._s(_vm.$filters.LL(item.event.start)) + "\n                      kl. " + _vm._s(_vm.$filters.LT(item.event.start)) + " -\n                      "), (item.isMultiDay) ? [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.$filters.ddd(item.event.end))) + " " + _vm._s(_vm.$filters.LL(item.event.end)) + " kl.")] : _vm._e(), _vm._v("\n                      " + _vm._s(_vm.$filters.LT(item.event.end)) + ",\n                      "), _c('b', [_vm._v(_vm._s(item.event.title))]), _vm._v(" "), (item.serial) ? _c('span', {
	          staticClass: "events__list__event__period"
	        }, [_vm._v("\n                        (" + _vm._s(_vm.i18n['period']) + ": " + _vm._s(_vm.$filters.LL(item.serial.from_date)) + " -\n                        " + _vm._s(item.serial.to_date ? _vm.$filters.LL(item.serial.to_date) : _vm.i18n['ongoing']) + ")\n                      ")]) : _vm._e()], 2), _vm._v(" "), (item.hasNote) ? _c('div', {
	          staticClass: "events__list__event__note"
	        }, [_c('span', {
	          staticClass: "icon-pencil"
	        }), _vm._v(" "), _c('div', {
	          domProps: {
	            "innerHTML": _vm._s(item.event.teacher_notes)
	          }
	        })]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.duration))])])
	      }), 0)])
	    }), 0)])
	  }), 0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.hasMoreAbsentUsers),
	      expression: "hasMoreAbsentUsers"
	    }],
	    ref: "loadMoreSentinel",
	    staticClass: "shortcuts__load-more no-print"
	  }, [_c('Loader', {
	    attrs: {
	      "isSmall": true
	    }
	  })], 1)])], 1) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "users-hours text-dark"
	  }, [_c('div', {
	    staticClass: "users-hours__header"
	  }, [_c('h2', [_vm._v("Årsnormsopgørelse for " + _vm._s(_vm.numberOfWorkDaysInPeriod) + " arbejdsdage")]), _vm._v(" "), _c('div', {
	    staticClass: "user-tasks__header__right"
	  }, [(!_vm.isDatesPristine) ? _c('p', {
	    staticClass: "d-link",
	    on: {
	      "click": _vm.resetDates
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), _c('DatePickerRange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('setIsShowEmploymentEnded', true)
	      }
	    }
	  }, [_vm._v("Brudt ansættelse")]), _vm._v(" "), _c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "isBottomStart": false,
	      "propOffset": [5, 5]
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_c('span', {
	    staticClass: "icon-more2"
	  })]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', {
	    on: {
	      "click": _vm.updateUserHours
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.assign_users_hours.update')) + "\n          ")])])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "user-table-container"
	  }, [(_vm.isLoadingUpdatedNumbers) ? _c('div', {
	    staticClass: "user-table-container__loader",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('Loader', {
	    attrs: {
	      "is-small": true
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('table', {
	    staticClass: "user-table"
	  }, [_c('thead', [_c('tr', [_c('thUser', {
	    attrs: {
	      "rowspan": "3",
	      "sort-prop": "name",
	      "title": _vm.$t('vue2.assign_users_hours.name'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('th', {
	    staticClass: "working-hours",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.work_hours')))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('tr', [_c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_total_hours_assigned_in_period",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_total_hours_actual",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_total_hours_diff",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "with-kids-color",
	    attrs: {
	      "sort-prop": "v_with_kids_assigned_in_period",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "with-kids-color",
	    attrs: {
	      "sort-prop": "v_with_kids_actual",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "with-kids-color",
	    attrs: {
	      "sort-prop": "v_with_kids_diff",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "without-kids-color",
	    attrs: {
	      "sort-prop": "v_without_kids_assigned_in_period",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "without-kids-color",
	    attrs: {
	      "sort-prop": "v_without_kids_actual",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "without-kids-color",
	    attrs: {
	      "sort-prop": "v_without_kids_diff",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_with_and_without_kids_assigned_in_period",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_with_and_without_kids_actual",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_with_and_without_kids_diff",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  })], 1)]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedUsers), function(user) {
	    return _c('tr', {
	      key: user.id,
	      staticClass: "tr-user"
	    }, [_c('th', {
	      staticClass: "tr-user__name"
	    }, [_c('div', {
	      staticClass: "tr-user__name__inner"
	    }, [_c('p', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('div', {
	      staticClass: "tr-user__name__bttn icon__bg-circle hint--right",
	      attrs: {
	        "aria-label": "Årsnormsoversigt"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheActiveUserInAssignHours(user)
	        }
	      }
	    }, [_c('svg', {
	      staticClass: "icon-chart tw-icon tw-icon--small",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24"
	      }
	    }, [_c('path', {
	      staticClass: "primary",
	      attrs: {
	        "d": "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm11 4a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z"
	      }
	    }), _vm._v(" "), _c('path', {
	      staticClass: "secondary",
	      attrs: {
	        "d": "M8 11a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm4-2a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z"
	      }
	    })])])])]), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !_vm.isDatesPristine; }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
	      }],
	      staticClass: "number td-presence",
	      class: {
	        'is-number--calculated': !_vm.isDatesPristine
	      },
	      attrs: {
	        "content": _vm.createTooltip(user.v_assigned_total_hours)
	      }
	    }, [(!_vm.isDatesPristine) ? _c('span', {
	      staticClass: "icon-clock"
	    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_total_hours_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
	      staticClass: "number td-presence",
	      attrs: {
	        "aria-label": user.v_total_hours_actual
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "number td-presence number__scale-indicator",
	      style: (_vm.scaleIndicator(user.v_total_hours_diff)),
	      attrs: {
	        "aria-label": user.v_total_hours_diff
	      }
	    }), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !_vm.isDatesPristine; }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
	      }],
	      staticClass: "number with-kids-color",
	      class: {
	        'is-number--calculated': !_vm.isDatesPristine
	      },
	      attrs: {
	        "content": _vm.createTooltip(user.v_total_with_kids)
	      }
	    }, [(!_vm.isDatesPristine) ? _c('span', {
	      staticClass: "icon-clock"
	    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_with_kids_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
	      staticClass: "number with-kids-color",
	      attrs: {
	        "aria-label": user.v_with_kids_actual
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "number with-kids-color number__scale-indicator",
	      style: (_vm.scaleIndicator(user.v_with_kids_diff)),
	      attrs: {
	        "aria-label": user.v_with_kids_diff
	      }
	    }), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !_vm.isDatesPristine; }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
	      }],
	      staticClass: "number without-kids-color",
	      class: {
	        'is-number--calculated': !_vm.isDatesPristine
	      },
	      attrs: {
	        "content": _vm.createTooltip(user.v_total_without_kids)
	      }
	    }, [(!_vm.isDatesPristine) ? _c('span', {
	      staticClass: "icon-clock"
	    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_without_kids_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
	      staticClass: "number without-kids-color",
	      attrs: {
	        "aria-label": user.v_without_kids_actual
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "number without-kids-color number__scale-indicator",
	      style: (_vm.scaleIndicator(user.v_without_kids_diff)),
	      attrs: {
	        "aria-label": user.v_without_kids_diff
	      }
	    }), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !_vm.isDatesPristine; }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
	      }],
	      staticClass: "number td-presence",
	      class: {
	        'is-number--calculated': !_vm.isDatesPristine
	      },
	      attrs: {
	        "content": _vm.createTooltip(user.v_assigned_total_hours)
	      }
	    }, [(!_vm.isDatesPristine) ? _c('span', {
	      staticClass: "icon-clock"
	    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_total_hours_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
	      staticClass: "number td-presence",
	      attrs: {
	        "aria-label": user.v_with_and_without_kids_actual
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "number td-presence number__scale-indicator",
	      style: (_vm.scaleIndicator(user.v_with_and_without_kids_diff)),
	      attrs: {
	        "aria-label": user.v_with_and_without_kids_diff
	      }
	    })])
	  }), 0)])]), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": _vm.closeTheUserToShowTasks
	    }
	  }, [_c('div', {
	    staticClass: "user-task__container",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "user-task__container__header"
	  }, [_c('h2'), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": _vm.closeTheUserToShowTasks
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('UserTasks', {
	    attrs: {
	      "initialStartDate": _vm.startDate,
	      "initialEndDate": _vm.endDate,
	      "user_id": _vm.theUserToShowTasks.id,
	      "user_calendar_id": _vm.theUserToShowTasks.user_calendar_id,
	      "user_name": _vm.theUserToShowTasks.name,
	      "isShowPrintButton": false,
	      "isCanSeeOtherUsers": false
	    }
	  }) : _vm._e()], 1)]) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticClass: "with-kids-color",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('div', [_vm._v("Med børn")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticClass: "without-kids-color",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('div', [_vm._v("Uden børn")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticClass: "working-hours",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('div', [_vm._v("Med + uden børn")])])
	}]}

/***/ }),
/* 1745 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "onboard-arrow",
	    style: ([{
	      right: _vm.right + 'px'
	    }, {
	      bottom: _vm.bottom + 'px'
	    }])
	  }, [_c('div', {
	    staticClass: "arrow_box no-print animated infinite onboarding_animate"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1746 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ul', {
	    staticClass: "doTable__items text-dark"
	  }, [(_vm.kindergartenCalendarsWithProps.length === 0) ? _c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen stuer oprettet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.kindergartenCalendarsWithProps), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "doTable__klass"
	    }, [_c('div', {
	      staticClass: "doTable__klass__header"
	    }, [_c('div', [_vm._v(_vm._s(calendar.name))]), _vm._v(" "), _c('div', [_c('button', {
	      on: {
	        "click": function($event) {
	          return _vm.setIsCreate(calendar)
	        }
	      }
	    }, [_vm._v("Opret brik på stuen")])])]), _vm._v(" "), _c('ul', {
	      staticClass: "subjects"
	    }, [(calendar.v_tasks_with_kids.length < 1) ? _c('h4', {
	      staticClass: "text-explainer"
	    }, [_vm._v("Ingen brikker oprettet")]) : _vm._e(), _vm._v(" "), _vm._l((calendar.v_tasks_with_kids), function(subject) {
	      return _c('li', {
	        key: subject.id,
	        staticClass: "subjects_subject",
	        style: ({
	          'background': subject.color
	        }),
	        on: {
	          "click": function($event) {
	            return _vm.setEditSubject(subject)
	          }
	        }
	      }, [_vm._v("\n          " + _vm._s(subject.name) + " (" + _vm._s(subject.hours) + ")\n        ")])
	    })], 2)])
	  }), _vm._v(" "), (_vm.isSubjectModal) ? _c('CreateSubjectForm', {
	    attrs: {
	      "showModal": _vm.isSubjectModal,
	      "initCalendarId": _vm.activeCalendarId,
	      "editSubject": _vm.theEditSubject,
	      "editSubjectId": _vm.theEditSubjectId
	    },
	    on: {
	      "close": _vm.closeSubjectModal,
	      "createSubject": _vm.createNewSubject,
	      "updateSubject": _vm.updateSubject,
	      "deleteSubject": _vm.deleteSubject
	    }
	  }) : _vm._e()], 2), _vm._v(" "), _c('AnnualNormWithoutKids', {
	    attrs: {
	      "isWithKids": true
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1747 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-profile__form"
	  }, [(_vm.canEdit) ? _c('div', {
	    staticClass: "d-profile__form__edit",
	    on: {
	      "click": function($event) {
	        _vm.isEditable = !_vm.isEditable
	      }
	    }
	  }, [(!_vm.isEditable) ? [_vm._v(_vm._s(_vm.$t('vue2.common.edit')))] : [_vm._v("Afslut redigering")]], 2) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-profile__form__body"
	  }, [_c('h3', [_vm._v("Undervisningskompetencer (Linjefag)")]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.competencies.length < 1 && !_vm.isEditable) ? _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n      Ingen fag er tilføjet som kompetence\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "marg-1-top"
	  }, [(_vm.isEditable) ? [_vm._m(0), _vm._v(" "), _c('label', {
	    staticClass: "d-label marg-1-top marg-1-bottom"
	  }, [_vm._v("Tilføj op til seks kompetencer")]), _vm._v(" "), _c('DSelect', {
	    attrs: {
	      "items": _vm.standardSubjectsWithVProps,
	      "itemsSelected": _vm.userCompetencies,
	      "show": true,
	      "placeholder": "Tilføj kompetence"
	    },
	    on: {
	      "update": function($event) {
	        return _vm.updateSubjectOnUser($event)
	      }
	    }
	  })] : _vm._e(), _vm._v(" "), (!_vm.isEditable) ? _c('ul', {
	    staticClass: "linjefag linjefag--not-empty"
	  }, _vm._l((_vm.userCompetencies), function(subject) {
	    return _c('li', {
	      staticClass: "d-pill"
	    }, [_vm._v("\n          " + _vm._s(subject.name) + "\n        ")])
	  }), 0) : _vm._e()], 2)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "div-explainer"
	  }, [_c('h3', [_vm._v("L eller K?")]), _vm._v(" "), _c('p', {
	    staticClass: "text-explainer"
	  }, [_c('b', [_vm._v("(L) Linjefag")]), _vm._v(": At have undervisningskompetence i et fag betyder, at\n            underviseren har haft det pågældende fag som linjefag på læreruddannelsen eller som ekstra linjefag på et\n            senere tidspunkt.")]), _vm._v(" "), _c('p', {
	    staticClass: "text-explainer"
	  }, [_c('b', [_vm._v("(K) Tilsvarende kompetence")]), _vm._v(": At have kompetence svarende til\n            undervisningskompetence betyder, at underviseren for eksempel har en efteruddannelse, videreuddannelse,\n            kompetencegivende uddannelse eller et længerevarende kursusforløb, der vurderes at give kompetence\n            svarende\n            til undervisningskompetence.")])])
	}]}

/***/ }),
/* 1748 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sd-fravaer text-dark"
	  }, [_c('h2', {
	    staticClass: "marg-1-bottom capitalize"
	  }, [_vm._v("Fraværsindberetninger")]), _vm._v(" "), (_vm.isNoConfiguration) ? [_vm._m(0)] : [_c('div', {
	    staticClass: "sd-fravaer__header"
	  }, [_c('div', {
	    staticClass: "sd-fravaer__header__left"
	  }, [_c('Tabs', {
	    attrs: {
	      "tabs": _vm.viewTabs,
	      "selected": _vm.viewTab
	    },
	    on: {
	      "select": _vm.onSelectViewTab
	    }
	  }), _vm._v(" "), (_vm.viewTab === 'employments') ? [_c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Personer',
	      "tags": _vm.personNames,
	      "selectedTags": _vm.selectedPersonNames,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg personer'
	    },
	    on: {
	      "select": _vm.togglePersonName,
	      "clear": function($event) {
	        _vm.selectedPersonNames = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Grupper',
	      "tags": _vm.userTags,
	      "selectedTags": _vm.selectedUserTags,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg grupper'
	    },
	    on: {
	      "select": _vm.toggleUserTag,
	      "clear": function($event) {
	        _vm.selectedUserTags = []
	      }
	    }
	  }), _vm._v(" "), (_vm.employmentTitles.length > 1) ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Ansættelser',
	      "tags": _vm.employmentTitles,
	      "selectedTags": _vm.selectedEmploymentTitles,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg stilling'
	    },
	    on: {
	      "select": _vm.toggleEmploymentTitle,
	      "clear": function($event) {
	        _vm.selectedEmploymentTitles = []
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.organisations.length > 1) ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Organisationer',
	      "tags": _vm.organisations,
	      "selectedTags": _vm.selectedOrganisations,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg organisation'
	    },
	    on: {
	      "select": _vm.toggleOrganisation,
	      "clear": function($event) {
	        _vm.selectedOrganisations = []
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "sd-fravaer__count"
	  }, [_vm._v("\n            Viser " + _vm._s(_vm.filteredRows.length) + " af " + _vm._s(_vm.allRows.length) + " ansættelser\n          ")])] : [_c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Personer',
	      "tags": _vm.uniqueNames,
	      "selectedTags": _vm.selectedNames,
	      "numberOfSelectedTagsToShow": 2,
	      "placeholder": 'Vælg personer'
	    },
	    on: {
	      "select": _vm.toggleName,
	      "clear": function($event) {
	        _vm.selectedNames = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Fraværstype',
	      "tags": _vm.uniqueAbsenceTypes,
	      "selectedTags": _vm.selectedAbsenceTypes,
	      "numberOfSelectedTagsToShow": 2,
	      "placeholder": 'Vælg fraværstype'
	    },
	    on: {
	      "select": _vm.toggleAbsenceType,
	      "clear": function($event) {
	        _vm.selectedAbsenceTypes = []
	      }
	    }
	  })]], 2), _vm._v(" "), (_vm.viewTab !== 'employments') ? _c('div', {
	    staticClass: "sd-fravaer__header__right"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--small",
	    attrs: {
	      "disabled": _vm.isLoading
	    },
	    on: {
	      "click": _vm.readFravaer
	    }
	  }, [_vm._v("\n          Opdater\n        ")])]) : _vm._e()]), _vm._v(" "), (_vm.viewTab === 'employments') ? _c('div', {
	    staticClass: "sd-fravaer__toolbar"
	  }, [_c('DoDatePickerRange', {
	    attrs: {
	      "allowSameDate": true,
	      "startDate": _vm.autoStartDate,
	      "endDate": _vm.autoEndDate,
	      "maximumDateRange": 365
	    },
	    on: {
	      "startChanged": function($event) {
	        _vm.autoStartDate = $event
	      },
	      "endChanged": function($event) {
	        _vm.autoEndDate = $event
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    staticStyle: {
	      "font-size": "11px"
	    },
	    on: {
	      "click": _vm.openAutomaticIndberetning
	    }
	  }, [_vm._v("\n        Indberet fravær\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.viewTab === 'outbox') ? _c('div', {
	    staticClass: "sd-fravaer__info"
	  }, [_vm._v("\n      Fraværsindberetninger i udbakken sendes automatisk til SD senere på dagen. Du kan slette dem, så længe de ligger her.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "sd-fravaer__body"
	  }, [(_vm.viewTab === 'employments') ? [(_vm.isLoadingEmployments) ? _c('Loader') : _c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("NAVN")]), _vm._v(" "), _c('th', [_vm._v("ANSÆTTELSE")]), _vm._v(" "), _c('th', [_vm._v("ORGANISATION")])])]), _vm._v(" "), (_vm.filteredRows.length === 0) ? _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": 3
	    }
	  }, [_vm._v("Ingen ansættelser fundet")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.groupedRows), function(group) {
	    return _c('tbody', {
	      key: group.userId,
	      staticClass: "user-group"
	    }, _vm._l((group.rows), function(row) {
	      return _c('tr', {
	        key: row.id,
	        staticClass: "employment-row"
	      }, [_c('td', {
	        staticClass: "bold"
	      }, [_vm._v(_vm._s(row.userName))]), _vm._v(" "), _c('td', {
	        staticClass: "td-organisation"
	      }, [_vm._v("\n              " + _vm._s(row.employmentNumber) + " - " + _vm._s(row.employmentTitle) + "\n            ")]), _vm._v(" "), _c('td', {
	        staticClass: "td-organisation"
	      }, [_vm._v(_vm._s(row.organisation))])])
	    }), 0)
	  })], 2)] : [(_vm.isLoading) ? _c('Loader') : _c('table', {
	    staticClass: "do-table do-table--striped"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "td-created"
	  }, [_vm._v("OPRETTET")]), _vm._v(" "), _c('th', [_vm._v("NAVN")]), _vm._v(" "), _c('th', [_vm._v("ANSÆTTELSE")]), _vm._v(" "), _c('th', [_vm._v("FRAVÆRSTYPE")]), _vm._v(" "), _c('th', {
	    staticClass: "td-date"
	  }, [_vm._v("DATO")]), _vm._v(" "), _c('th', {
	    staticClass: "td-units"
	  }, [_vm._v("DAGE")]), _vm._v(" "), _c('th', {
	    staticClass: "td-units"
	  }, [_vm._v("TIMER")]), _vm._v(" "), _c('th', {
	    staticClass: "td-created-by"
	  }, [_vm._v("OPRETTET AF")]), _vm._v(" "), _c('th', {
	    staticClass: "td-status"
	  }, [_vm._v("STATUS")]), _vm._v(" "), _c('th', {
	    staticClass: "th-actions"
	  })])]), _vm._v(" "), _c('tbody', [(_vm.displayedRows.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": 10
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.viewTab === 'outbox' ? 'Udbakken er tom' : 'Ingen afsendte fraværsindberetninger') + "\n            ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayedRows), function(item) {
	    return _c('tr', {
	      key: item.vKey,
	      staticClass: "fravaer-row"
	    }, [_c('td', {
	      staticClass: "td-created"
	    }, [_vm._v(_vm._s(item.vCreatedAt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vUserName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vEmploymentNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vAbsenceType))]), _vm._v(" "), _c('td', {
	      staticClass: "td-date"
	    }, [_vm._v(_vm._s(item.vDato))]), _vm._v(" "), _c('td', {
	      staticClass: "td-units"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(item.dage)))]), _vm._v(" "), _c('td', {
	      staticClass: "td-units"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(item.timer)))]), _vm._v(" "), _c('td', {
	      staticClass: "td-created-by"
	    }, [_vm._v(_vm._s(item.vCreatedBy))]), _vm._v(" "), _c('td', {
	      staticClass: "td-status"
	    }, [_c('span', {
	      staticClass: "status-pill",
	      class: 'status-pill--' + item.state
	    }, [_vm._v(_vm._s(_vm.stateLabel(item.state)))])]), _vm._v(" "), _c('td', {
	      staticClass: "td-actions"
	    }, [(_vm.viewTab === 'outbox' && item.can_delete) ? _c('button', {
	      staticClass: "do-bttn do-bttn--small do-bttn--danger",
	      attrs: {
	        "disabled": _vm.deletingIds.includes(item.vKey)
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.deleteRow(item)
	        }
	      }
	    }, [_vm._v("\n                Slet\n              ")]) : _vm._e()])])
	  })], 2)])]], 2)], _vm._v(" "), (_vm.isAutoFravaerOpen) ? _c('SdAutoFravaer', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "absenceCodes": _vm.absenceCodes,
	      "startDate": _vm.autoStartDate,
	      "endDate": _vm.autoEndDate
	    },
	    on: {
	      "startChanged": function($event) {
	        _vm.autoStartDate = $event
	      },
	      "endChanged": function($event) {
	        _vm.autoEndDate = $event
	      },
	      "created": _vm.onAutoFravaerCreated,
	      "close": function($event) {
	        _vm.isAutoFravaerOpen = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.deleteCandidate) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isSubmitButtonLoading": _vm.deletingIds.includes(_vm.deleteCandidate.vKey)
	    },
	    on: {
	      "close": function($event) {
	        _vm.deleteCandidate = null
	      },
	      "confirm": _vm.confirmDeleteRow
	    }
	  }, [_c('div', {
	    staticClass: "delete-confirm__details",
	    attrs: {
	      "slot": "custom_warning"
	    },
	    slot: "custom_warning"
	  }, [_vm._v("\n      " + _vm._s(_vm.deleteCandidate.vUserName) + " – " + _vm._s(_vm.deleteCandidate.vAbsenceType) + " (" + _vm._s(_vm.deleteCandidate.vDato) + ")\n    ")])]) : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sd-fravaer-no-config"
	  }, [_c('h2', [_c('i', [_vm._v("Skolens Silkeborg Data-integration er ikke konfigureret korrekt. Kontakt Docendo for at få hjælp til\n          opsætningen - enten på chat eller email.")])])])
	}]}

/***/ }),
/* 1749 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.isIEorEdge) ? _c('div', {
	    staticClass: "ie-warning"
	  }, [_c('h2', {
	    staticStyle: {
	      "font-weight": "lighter"
	    }
	  }, [_c('span', {
	    staticClass: "icon-warning"
	  }), _vm._v("\n    " + _vm._s(_vm.$t('vue2.IEWarning.you_are_using_a_IE_or_Edge_to_get')) + "\n    "), _c('span', {
	    staticStyle: {
	      "font-weight": "bold",
	      "font-style": "italic"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.IEWarning.a_faster_and_better_experience')))]), _vm._v("\n    " + _vm._s(_vm.$t('vue2.IEWarning.we_recommend_that_you_switch_to_these_browsers')) + ":\n    "), _c('a', {
	    staticClass: "text-blue",
	    attrs: {
	      "href": "https://www.google.com/chrome/",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n      Google Chrome")]), _vm._v("\n    " + _vm._s(_vm.$t('vue2.IEWarning.or')) + "\n    "), _c('a', {
	    attrs: {
	      "href": "https://www.mozilla.org/firefox/new/",
	      "target": "_blank"
	    }
	  }, [_vm._v("Firefox")])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1750 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.close),
	      expression: "close"
	    }],
	    staticClass: "d-select text-dark",
	    class: {
	      'openFromBottom': _vm.openFromBottom
	    }
	  }, [_c('div', {
	    staticClass: "width-100 no-print",
	    class: {
	      'box-shadow': _vm.boxShadow
	    }
	  }, [_c('div', {
	    staticClass: "d-select__input-look",
	    class: {
	      'active': _vm.showDropdown
	    },
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._l((_vm.usersThatAreSelected), function(selectedUser) {
	    return _c('div', {
	      staticClass: "d-select__selected__item",
	      class: {
	        'readyToDelete': _vm.isReadyToDelete(selectedUser)
	      }
	    }, [_vm._v("\n        " + _vm._s(selectedUser.name) + "\n        "), (_vm.userOccEvents(selectedUser) && _vm.userOccEvents(selectedUser).length > 0) ? [_c('div', {
	      staticClass: "icon-warning item__icon-warning marg-5-left",
	      class: {
	        'item_icon__hide': selectedUser.occupied.events.length === 1 && selectedUser.occupied.events[0].event_type === 'presence' || selectedUser.isOnLesson && selectedUser.occupied.events.length === 1
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "d-select__selected__item__secret-label"
	    }, _vm._l((_vm.userOccEvents(selectedUser)), function(event, index) {
	      return (index < 3) ? _c('div', {
	        staticClass: "d-select__selected__item__secret-label__event"
	      }, [_vm._v("\n              " + _vm._s(event.title) + "\n            ")]) : _vm._e()
	    }), 0)] : _vm._e(), _vm._v(" "), (!selectedUser.isErrorUser) ? _c('div', {
	      staticClass: "d-select__selected__item__remove",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.removeUser(selectedUser)
	        }
	      }
	    }, [_c('span', [_vm._v("×")])]) : _vm._e()], 2)
	  }), _vm._v(" "), (_vm.isLoading) ? [_c('spinner', {
	    staticStyle: {
	      "margin": "7px 0 0 0"
	    },
	    attrs: {
	      "color": "blue",
	      "size": "small"
	    }
	  })] : [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchText),
	      expression: "searchText"
	    }],
	    ref: "inputfield",
	    staticClass: "d-select__header__search",
	    class: [{
	      'show': _vm.showDropdown
	    }, {
	      'input-active': _vm.searchText.length > 0 || _vm.selectedUsers.length < 1
	    }],
	    attrs: {
	      "type": "search",
	      "placeholder": _vm.placeholderText
	    },
	    domProps: {
	      "value": (_vm.searchText)
	    },
	    on: {
	      "keypress": [function($event) {
	        return _vm.selectWithKeyboard('', $event)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.selectWithKeyboard('enter')
	      }],
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
	        $event.preventDefault();
	        return _vm.selectWithKeyboard('down')
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
	        $event.preventDefault();
	        return _vm.selectWithKeyboard('up')
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
	        return _vm.deleteUserWithKeyboard.apply(null, arguments)
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchText = $event.target.value
	      }
	    }
	  })]], 2), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
	    staticClass: "d-select__items"
	  }, [_c('ul', {
	    ref: "dropdown",
	    staticClass: "d-select__items__container"
	  }, [(_vm.isUpdatingUsers) ? [_c('li', {
	    staticClass: "item-template flex space-between"
	  }, [_c('spinner', {
	    staticStyle: {
	      "margin": "4px 0 0 0"
	    },
	    attrs: {
	      "color": "blue",
	      "size": "small"
	    }
	  })], 1)] : _vm._l((_vm.searchedUsers), function(item, index) {
	    return [_c('li', {
	      key: item.user_id,
	      class: [{
	          'isReadyForSelection': _vm.isSelectedWithKeyboard(item)
	        },
	        {
	          'item_is_selected': _vm.isSelected(item)
	        }
	      ],
	      on: {
	        "mouseenter": function($event) {
	          return _vm.setIsReadyForSelection(item, index)
	        },
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.toggleUser(item)
	        }
	      }
	    }, [(item.occupied && item.occupied.events.length > 0) ? [_c('div', {
	      staticClass: "item-template isOccupied",
	      class: [{
	          'item-is-present': item.occupied.events.length === 1 && item.occupied.events[0].event_type === 'presence'
	        },
	        {
	          'item-is-already-attached': item.isOnLesson
	        }
	      ]
	    }, [(item.icon) ? _c('span', {
	      staticClass: "marg-10-right",
	      class: item.icon
	    }) : _vm._e(), _vm._v(" "), (item.default_thumb_url) ? _c('img', {
	      attrs: {
	        "src": item.default_thumb_url,
	        "alt": ""
	      }
	    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "warning-signs"
	    }, [_vm._l((item.occupied.events), function(event) {
	      return [(event.event_type !== 'presence') ? [(item.isOnLesson && item.currentEventId === event.event_id) ? _c('div', {
	        staticClass: "marg-10-left"
	      }, [_c('span', {
	        staticClass: "icon-user"
	      }), _vm._v(" " + _vm._s(_vm.i18n['also_assigned']) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('div', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (item.currentEventId !== event.event_id),
	          expression: "item.currentEventId !== event.event_id"
	        }],
	        staticClass: "marg-10-left warning-signs__sign"
	      }, [_c('span', {
	        staticClass: "icon-warning"
	      }), _vm._v(" " + _vm._s(event.title) + "\n                      ")])] : _vm._e(), _vm._v(" "), _c('div', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (item.occupied.events.length === 1 && event.event_type === 'presence'),
	          expression: "item.occupied.events.length === 1 && event.event_type === 'presence'"
	        }],
	        staticClass: "marg-10-left"
	      }, [_c('span', {
	        staticClass: "icon-clock"
	      }), _vm._v(" " + _vm._s(_vm.i18n['working_hours']) + ": " + _vm._s(_vm._f("localeTime")(event.event_time_start)) + " -\n                      " + _vm._s(_vm._f("localeTime")(event.event_time_end)) + "\n                    ")])]
	    })], 2)])] : _c('div', {
	      staticClass: "item-template"
	    }, [(item.icon) ? _c('span', {
	      staticClass: "marg-10-right",
	      class: item.icon
	    }) : _vm._e(), _vm._v(" "), (item.default_thumb_url) ? _c('img', {
	      attrs: {
	        "src": item.default_thumb_url,
	        "alt": ""
	      }
	    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))])])], 2)]
	  })], 2), _vm._v(" "), (_vm.searchedUsers.length < 1) ? _c('div', {
	    staticClass: "no-match"
	  }, [_vm._t("noMatch", function() {
	    return [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.dselect.no_matching_results')))])]
	  })], 2) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeIn"
	    }
	  }, [(_vm.subFromIsOnLesson !== null) ? _c('div', {
	    staticClass: "subModal__bg"
	  }, [_c('div', {
	    staticClass: "subModal"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['would_you_like_to_set']) + " " + _vm._s(_vm.subFromIsOnLesson.name) + " " + _vm._s(_vm.i18n['as_a_substitute_instead_of_teacher']) + "?")]), _vm._v(" "), _c('div', {
	    staticClass: "subModal__buttons"
	  }, [_c('button', {
	    on: {
	      "click": _vm.setSubFromIsOnLesson
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['yes']))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn-simple bttn",
	    on: {
	      "click": function($event) {
	        _vm.subFromIsOnLesson = null
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['no']))])])])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1751 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container"
	  }, [_c('div', {
	    staticClass: "d-guides"
	  }, [_c('StilGuides', {
	    attrs: {
	      "video-id": '5Id4TeuHMvI?start=233',
	      "textForLink": "Guide: Se videoguide for kompetencedækning"
	    }
	  }), _vm._v(" "), (_vm.isShowSubjects) ? _c('p', {
	    staticClass: "italic"
	  }, [_c('b', [_vm._v("Bemærk:")]), _vm._v(" Opret, slet eller redigere fag påvirker kun indberetningsdata'en - ikke i resten af Docendo")]) : _vm._e()], 1), _vm._v(" "), (_vm.usersSorted.length < 1) ? _c('h3', {
	    staticClass: "text-explainer text-explainer__error"
	  }, [_c('svg', {
	    staticClass: "tw-icon icon-important",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
	    }
	  })]), _vm._v("\n    Der er ingen personer udfyldt med stilling og CPR. Gå tilbage til \"1. Undervisningskompetencer\"\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.usersSorted), function(user) {
	    return _c('KompetenceIndberetningDaekningUser', {
	      attrs: {
	        "user": user,
	        "klokketimetyper": _vm.klokketimetyper,
	        "dbStilData": _vm.dbStilData
	      },
	      on: {
	        "updateStil": function($event) {
	          return _vm.$emit('updateStil', $event)
	        }
	      }
	    })
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 1752 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "d_parent",
	    staticClass: "other-cal",
	    class: {
	      'other-cal--active': _vm.isDropDown
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.setDropdownFromClick),
	      expression: "setDropdownFromClick"
	    }],
	    staticClass: "other-cal__selected d-input",
	    on: {
	      "click": _vm.setDropdown
	    }
	  }, [_c('div', [_vm._v(_vm._s(_vm.selectedCalendar))]), _vm._v(" "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), (_vm.isDropDown) ? _c('ul', {
	    ref: "d_child",
	    staticClass: "other-cal__options",
	    class: {
	      'd-dropdown--animate': _vm.isPopperReady,
	      'd-dropdown--show': _vm.isPopperDone
	    }
	  }, [_c('li', {
	    class: {
	      'item--active': _vm.selectedCalendarId === null
	    },
	    on: {
	      "click": function($event) {
	        return _vm.selectCalendar(null)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-users"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['own_calendars']) + "\n    ")]), _vm._v(" "), _vm._l((_vm.otherCalendars), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      class: {
	        'item--active': _vm.selectedCalendarId === calendar.id
	      },
	      on: {
	        "click": function($event) {
	          return _vm.selectCalendar(calendar.id)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-clipboard2"
	    }), _vm._v(" " + _vm._s(calendar.name) + "\n    ")])
	  })], 2) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1753 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "duty-schedule text-dark"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fadeOut"
	    }
	  }, [(_vm.isInitialLoading) ? _c('DoSplash') : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-wrapper"
	  }, [_c('WeekSelecter', {
	    attrs: {
	      "date": _vm.date,
	      "startDate": _vm.schoolYear.employee_time_start,
	      "endDate": _vm.schoolYear.employee_time_end
	    },
	    on: {
	      "changed": function($event) {
	        return _vm.setDate($event)
	      }
	    }
	  }), _vm._v(" "), _c('DutySchedulePlan', {
	    attrs: {
	      "theCreateEventObj": _vm.theCreateEventObj,
	      "usersCalIdsHash": _vm.allUsersInCalIdHash,
	      "calendars": _vm.kindergartenCalendars,
	      "isEventsLoading": _vm.isEventsLoading,
	      "date": _vm.date,
	      "events": _vm.events,
	      "eventsInHash": _vm.eventsInUserCalendarIdHash,
	      "userNorms": _vm.userNorms,
	      "theNewlyCreatedSubject": _vm.theNewlyCreatedSubject,
	      "schoolSettings": _vm.schoolSettings,
	      "isCreateOpeningHours": _vm.isCreateOpeningHours,
	      "openingHours": _vm.openingHours
	    },
	    on: {
	      "createSubject": _vm.onCreateSubject,
	      "createEvent": _vm.onCreateEvent,
	      "editEvent": _vm.onEditEvent,
	      "setIsCreateOpeningHours": _vm.setIsCreateOpeningHours,
	      "today": _vm.setToday,
	      "next": _vm.setNext,
	      "prev": _vm.setPrev
	    }
	  }), _vm._v(" "), (_vm.theCreateEventObj) ? _c('CreateEvent', {
	    attrs: {
	      "openingHours": _vm.openingHours,
	      "user": _vm.theCreateEventObj.user,
	      "initDate": _vm.theCreateEventObj.date,
	      "initSubject": _vm.theCreateEventObj.subject,
	      "emitEvent": true
	    },
	    on: {
	      "addANewEvent": _vm.onAddedEvent,
	      "close": _vm.onCloseCreateEvent
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theEditEventObj) ? _c('CreateEvent', {
	    attrs: {
	      "user": _vm.theEditEventObj.user,
	      "editEvent": _vm.theEditEventObj.event,
	      "emitEvent": true,
	      "openingHours": _vm.openingHours
	    },
	    on: {
	      "updatedEvent": _vm.onUpdatedEvent,
	      "deletedEvent": _vm.onDeletedEvent,
	      "close": _vm.onCloseCreateEvent
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theCreateSubjectCalendar) ? _c('CreateSubject', {
	    attrs: {
	      "calendarAndUsers": _vm.theCreateSubjectCalendar,
	      "schoolId": _vm.schoolId,
	      "schoolYearId": _vm.schoolYearId
	    },
	    on: {
	      "created": _vm.onNewSubjectCreated,
	      "close": function($event) {
	        return _vm.onCreateSubject(null)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isCreateOpeningHours) ? _c('DutyScheduleOpeningHours', {
	    attrs: {
	      "propOpeningHours": _vm.openingHours
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsCreateOpeningHours(false)
	      }
	    }
	  }) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1754 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "public-app"
	  }, [_c('public-header', {
	    attrs: {
	      "locale": _vm.locale,
	      "showdatepicker": _vm.showdatepicker,
	      "date": _vm.datePickerDate
	    },
	    on: {
	      "monthClick": _vm.toggleDatePicker,
	      "menu": _vm.setMenu
	    }
	  }), _vm._v(" "), (_vm.showdatepicker) ? _c('pan-container', {
	    attrs: {
	      "active": _vm.isDatePickerReady,
	      "date": _vm.datePickerDate,
	      "theCalendarDate": _vm.date
	    },
	    on: {
	      "changed": _vm.setDatePickerDate,
	      "setDate": _vm.setDate
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showdatepicker) ? _c('v-touch', {
	    staticClass: "overlay",
	    on: {
	      "tap": _vm.closeDatepicker
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.chosenView === 1) ? _c('day-selector', {
	    attrs: {
	      "date": _vm.date,
	      "locale": _vm.locale
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.load),
	      expression: "load"
	    }],
	    staticClass: "load-spinner mobile"
	  }, [_c('div', {
	    staticClass: "icon-docendo animated pulse infinite"
	  })]), _vm._v(" "), (_vm.chosenView === 1) ? _c('cal-container', {
	    attrs: {
	      "i18n": _vm.i18n,
	      "locale": _vm.locale,
	      "date": _vm.date,
	      "dateChange": _vm.dateChange,
	      "lessons": _vm.allEvents,
	      "viewState": _vm.viewState
	    },
	    on: {
	      "eventClicked": _vm.showEvent,
	      "update:date": function($event) {
	        _vm.date = $event
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.chosenView === 2) ? _c('weekplan', {
	    attrs: {
	      "calId": _vm.calId,
	      "date": _vm.date,
	      "events": _vm.allEvents,
	      "locale": _vm.locale,
	      "weeknote": _vm.weeknote
	    },
	    on: {
	      "close": _vm.closeWeekPlan
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.chosenView === 3) ? _c('week-calendar', {
	    attrs: {
	      "calId": _vm.calId,
	      "i18n": _vm.i18n,
	      "date": _vm.date,
	      "dateChange": _vm.dateChange,
	      "lessons": _vm.allEvents,
	      "weeknote": _vm.weeknote,
	      "viewState": _vm.viewState,
	      "locale": _vm.locale
	    },
	    on: {
	      "eventClicked": _vm.showEvent,
	      "update:date": function($event) {
	        _vm.date = $event
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('footer-nav', {
	    attrs: {
	      "isNotToday": _vm.isNotToday
	    },
	    on: {
	      "today": function($event) {
	        return _vm.setDate(_vm.today)
	      },
	      "prev": _vm.prev,
	      "next": _vm.next
	    }
	  }), _vm._v(" "), _c('sidenav', {
	    attrs: {
	      "menu": _vm.menu,
	      "chosenView": _vm.chosenView,
	      "schoolName": _vm.schoolName,
	      "calName": _vm.calName
	    },
	    on: {
	      "update:chosenView": function($event) {
	        _vm.chosenView = $event
	      },
	      "update:chosen-view": function($event) {
	        _vm.chosenView = $event
	      },
	      "close": function($event) {
	        _vm.menu = false
	      },
	      "afterLeave": _vm.getView,
	      "locale": _vm.setLocale
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1755 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "modal"
	    }
	  }, [(_vm.show) ? _c('div', [_c('div', {
	    class: {
	      'modal-mask': _vm.show_modal_mask
	    }
	  }, [_c('div', {
	    staticClass: "modal-wrapper"
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.clickAway),
	      expression: "clickAway"
	    }],
	    ref: "modalContent",
	    staticClass: "modal-container",
	    class: {
	      'modal_from_bottom': _vm.modal_from_bottom
	    },
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-modal": "true",
	      "aria-label": _vm.ariaLabel || null
	    }
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('div', {
	    staticClass: "font-large close-cross",
	    attrs: {
	      "role": "button",
	      "tabindex": "0",
	      "aria-label": _vm.$t('vue2.a11y.close')
	    },
	    on: {
	      "click": _vm.removeModal,
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.stopPropagation();
	        return _vm.removeModal.apply(null, arguments)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        $event.stopPropagation();
	        return _vm.removeModal.apply(null, arguments)
	      }]
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2 pointer",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _vm._t("header", function() {
	    return [_vm._v("default header")]
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_vm._t("body", function() {
	    return [_vm._v("default body")]
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_vm._t("footer", function() {
	    return [_c('button', {
	      staticClass: "bttn bttn_simple right marg-10"
	    }, [_vm._v("\n                Ok\n\n              ")]), _vm._v(" "), _c('button', {
	      staticClass: "bttn bttn_simple right marg-10"
	    }, [_vm._v("\n                Gem\n\n              ")])]
	  })], 2)])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1756 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-create-task-for-user"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.editEvent ? 'Rediger' : 'Opret') + " vagt til " + _vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-group"
	  }, [_c('div', {
	    staticClass: "time-changer__group"
	  }, [_c('TimeChanger', {
	    attrs: {
	      "showIcon": true,
	      "start": _vm.startTime,
	      "end": _vm.endTime,
	      "isFiveMinutesInterval": false
	    },
	    on: {
	      "updateStart": _vm.setStartTime,
	      "updateEnd": _vm.setEndTime
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-group"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.date
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer",
	    class: {
	      'do-modal__footer--flex': _vm.editEvent
	    }
	  }, [(_vm.editEvent) ? _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.onDelete
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer__right"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (_vm.editEvent) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.onSubmitEditEvent
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.update')) + "\n        ")]) : [(!_vm.isValidated) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n          ")]) : _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n          ")])]], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 1757 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.showModal) ? _c('modal', {
	    on: {
	      "close": _vm.close
	    }
	  }, [(_vm.propIsLoading) ? _c('template', {
	    slot: "body"
	  }, [_c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  })], 1) : _c('template', {
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "add-lesson__header",
	    style: ({
	      'backgroundColor': _vm.color ? _vm.color : '#fff'
	    })
	  }, [_c('h2', [_vm._v(_vm._s(_vm.name.length > 0 ? _vm.name : !_vm.isActivities ? _vm.i18n[_vm.locale]['create_subject'] : 'Opret aktivitet'))]), _vm._v(" "), _c('div', {
	    staticClass: "add-lesson__calendars"
	  }, [_vm._v("\n          " + _vm._s(_vm.showMasterCalendarName) + "\n        ")]), _vm._v(" "), (_vm.activeTab === 'edit' && !_vm.isActivities && _vm.canSeeTaskOverviewToggle) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: false,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window'
	      }),
	      expression: "{\n               arrow: false,\n               animateFill: false,\n               animation: 'shift-away',\n               zIndex: '999999992',\n               boundary: 'window'}"
	    }],
	    staticClass: "add-lesson__header__task-overview",
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['show_on_task_overview_desc']
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleTaskOverview.apply(null, arguments)
	      }
	    }
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_on_task_overview']))]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "propOn": _vm.taskOverview,
	      "allowChanges": false
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.editSubject && !_vm.isActivities) ? _c('div', {
	    staticClass: "add-lesson__header__tabs"
	  }, [_c('div', {
	    staticClass: "add-lesson__header__tabs__tab",
	    class: {
	      'tab--is-active': _vm.activeTab === 'edit'
	    },
	    on: {
	      "click": function($event) {
	        _vm.activeTab = 'edit'
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].edit_subject) + "\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "add-lesson__header__tabs__tab",
	    class: {
	      'tab--is-active': _vm.activeTab === 'history'
	    },
	    on: {
	      "click": function($event) {
	        _vm.activeTab = 'history'
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].activity) + "\n          ")]), _vm._v(" "), (_vm.isShowSubjectsPools) ? _c('div', {
	    staticClass: "add-lesson__header__tabs__tab",
	    class: {
	      'tab--is-active': _vm.activeTab === 'calendarHours'
	    },
	    on: {
	      "click": _vm.onClickCalendarHoursTab
	    }
	  }, [_vm._v("\n            Puljer\n          ")]) : _vm._e(), _vm._v(" "), (_vm.isReductionsActive && _vm.isShowReductions) ? _c('div', {
	    staticClass: "add-lesson__header__tabs__tab",
	    class: {
	      'tab--is-active': _vm.activeTab === 'reductions'
	    },
	    on: {
	      "click": function($event) {
	        _vm.activeTab = 'reductions'
	      }
	    }
	  }, [_vm._v("\n            Reduktioner\n          ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "add-lesson__form"
	  }, [(_vm.activeTab === 'history') ? _c('div', {
	    staticClass: "add-lesson__form__content"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale].latest_activity))]), _vm._v(" "), _c('SubjectFormLog', {
	    attrs: {
	      "subject": _vm.editSubject
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'reductions') ? _c('div', {
	    staticClass: "add-lesson__form__content"
	  }, [_c('h2', [_vm._v("Reduktioner")]), _vm._v(" "), _c('SubjectFormReductions', {
	    attrs: {
	      "subject": _vm.editSubject
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'calendarHours') ? _c('div', {
	    staticClass: "add-lesson__form__content"
	  }, [_c('SubjectFormCalendarHours', {
	    attrs: {
	      "subject": _vm.editSubject
	    },
	    on: {
	      "subjectHoursSaved": _vm.onSubjectHoursSaved
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'edit') ? _c('div', {
	    staticClass: "add-lesson__form__content"
	  }, [(_vm.editSubject) ? [(_vm.isShowSubjectsRequest && _vm.subjectRequestedBy) ? _c('div', {
	    staticClass: "subjects-requested-by do-warning"
	  }, [_c('label', {
	    staticClass: "do-label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['requested_by']))]), _vm._v(" " + _vm._s(_vm.subjectRequestedBy) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.editSubject && _vm.showDanishPreparationFactorBesideHours && !_vm.isDanishPrepBinaryOnOwnRow) ? [_c('div', {
	    staticClass: "input-group input-group__flex"
	  }, [_c('div', {
	    staticClass: "flex-"
	  }, [_c('label', [_vm._v(_vm._s(_vm.hoursLabel))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: (_vm.hoursDisabledTippy),
	      expression: "hoursDisabledTippy"
	    }],
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['hours_disabled_desc']
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.hours),
	      expression: "hours",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "inputLessonCount",
	    staticClass: "do-input",
	    class: {
	      'input--error': _vm.formErrors['hours'],
	      'input--disabled': _vm.isHoursDisabled
	    },
	    attrs: {
	      "type": "number",
	      "disabled": _vm.isHoursDisabled
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  })]), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), _c('DkPreparationFactorControl', {
	    attrs: {
	      "subject-type": _vm.subjectType,
	      "school-prep-factor": _vm.schoolSettings.prepFactor,
	      "labels": _vm.danishPreparationControlLabels,
	      "wrap-class": "flex-1"
	    },
	    model: {
	      value: (_vm.preparation),
	      callback: function($$v) {
	        _vm.preparation = $$v
	      },
	      expression: "preparation"
	    }
	  })], 1)] : (_vm.editSubject && _vm.showDanishPreparationFactorBesideHours && _vm.isDanishPrepBinaryOnOwnRow) ? [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.hoursLabel))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: (_vm.hoursDisabledTippy),
	      expression: "hoursDisabledTippy"
	    }],
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['hours_disabled_desc']
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.hours),
	      expression: "hours",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "inputLessonCount",
	    staticClass: "do-input",
	    class: {
	      'input--error': _vm.formErrors['hours'],
	      'input--disabled': _vm.isHoursDisabled
	    },
	    attrs: {
	      "type": "number",
	      "disabled": _vm.isHoursDisabled
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  })]), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('DkPreparationFactorControl', {
	    attrs: {
	      "subject-type": _vm.subjectType,
	      "school-prep-factor": _vm.schoolSettings.prepFactor,
	      "labels": _vm.danishPreparationControlLabels,
	      "wrap-class": "input-group dk-prep-factor-full-width"
	    },
	    model: {
	      value: (_vm.preparation),
	      callback: function($$v) {
	        _vm.preparation = $$v
	      },
	      expression: "preparation"
	    }
	  })], 1)] : (_vm.editSubject) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.hoursLabel))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: (_vm.hoursDisabledTippy),
	      expression: "hoursDisabledTippy"
	    }],
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['hours_disabled_desc']
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.hours),
	      expression: "hours",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "inputLessonCount",
	    staticClass: "do-input",
	    class: {
	      'input--error': _vm.formErrors['hours'],
	      'input--disabled': _vm.isHoursDisabled
	    },
	    attrs: {
	      "type": "number",
	      "disabled": _vm.isHoursDisabled
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  })]), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.calendarType !== 'user') ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_teacher']))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "USER",
	      "showTags": true,
	      "preSelectedItems": _vm.userCalendarIds,
	      "sortSelectedByName": true
	    },
	    on: {
	      "update": _vm.setSelectedUsers
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-location"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_room']))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "ROOM",
	      "preSelectedItems": _vm.roomCalendarIds
	    },
	    on: {
	      "update": _vm.setSelectedRooms
	    }
	  })], 1), _vm._v(" "), (!_vm.isPossibleToAddKlasses && _vm.isAllowedToAddKlasses) ? _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": function($event) {
	        _vm.isPossibleToAddKlasses = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_klass']) + "?")]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropdown"
	    }
	  }, [(_vm.isPossibleToAddKlasses) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-calendar4"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_klass']))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "klass",
	      "calendarId": _vm.calendarId,
	      "showTags": true,
	      "preSelectedItems": _vm.klassCalendarIds,
	      "showCreateButton": false
	    },
	    on: {
	      "update": _vm.setSelectedKlass
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "date-toggle"
	  }, [_c('div', {
	    staticClass: "date-toggle__inner",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleDateFields.apply(null, arguments)
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "propOn": _vm.isShowDateFields,
	      "allowChanges": false
	    }
	  }), _vm._v(" "), _c('label', {
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_dates_on_overview']))])], 1)])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropdown"
	    }
	  }, [(_vm.isShowDateFields) ? _c('div', {
	    staticClass: "input-group__flex"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['from_date']))]), _vm._v(" "), _c('div', {
	    staticClass: "date-field"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.fromDate || _vm.today,
	      "width100": true
	    },
	    on: {
	      "changed": _vm.setFromDate
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['to_date']))]), _vm._v(" "), _c('div', {
	    staticClass: "date-field"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.toDate || _vm.today,
	      "width100": true
	    },
	    on: {
	      "changed": _vm.setToDate
	    }
	  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('p', {
	    staticClass: "text-blue advanced-settings__link",
	    on: {
	      "click": function($event) {
	        _vm.isEditSubjectAdvanced = !_vm.isEditSubjectAdvanced
	      }
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale]['more_settings']) + "\n              ")])])] : _vm._e(), _vm._v(" "), (!_vm.editSubject || _vm.isEditSubjectAdvanced) ? [_c('div', {
	    staticClass: "input-group__flex"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['subject_title']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    ref: "name",
	    staticClass: "do-input",
	    class: {
	      'input--error': _vm.formErrors['name']
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.isActivities ? 'Eks. Motionsdag' : _vm.i18n[_vm.locale]['ex_subject']
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('name')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['name']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['name'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), (_vm.isShowNorwegianPreparationDropdown) ? _c('div', {
	    staticClass: "input-group",
	    staticStyle: {
	      "max-width": "100px"
	    }
	  }, [_c('label', [_vm._v("Årsramme")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.preparation),
	      expression: "preparation",
	      modifiers: {
	        "number": true
	      }
	    }],
	    staticClass: "d-input__select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return _vm._n(val)
	        });
	        _vm.preparation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.preparationOptionsForNorway), function(prep) {
	    return _c('option', {
	      key: prep
	    }, [_vm._v("\n                    " + _vm._s(prep) + "\n                  ")])
	  }), 0)]) : (_vm.showDanishPreparationFactorInTitleRow && !_vm.isDanishPrepBinaryOnOwnRow) ? _c('div', {
	    staticClass: "input-group",
	    staticStyle: {
	      "max-width": "160px"
	    }
	  }, [_c('DkPreparationFactorControl', {
	    attrs: {
	      "subject-type": _vm.subjectType,
	      "school-prep-factor": _vm.schoolSettings.prepFactor,
	      "labels": _vm.danishPreparationControlLabels
	    },
	    model: {
	      value: (_vm.preparation),
	      callback: function($$v) {
	        _vm.preparation = $$v
	      },
	      expression: "preparation"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__subject-codes",
	    staticStyle: {
	      "max-width": "100px"
	    }
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['subject_code']))]), _vm._v(" "), (_vm.isSchoolFromDenmark) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.subjectCode),
	      expression: "subjectCode",
	      modifiers: {
	        "number": true
	      }
	    }],
	    staticClass: "d-input__select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return _vm._n(val)
	        });
	        _vm.subjectCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": ''
	    }
	  }), _vm._v(" "), _vm._l((_vm.standardSubjectCodes), function(subject) {
	    return _c('option', {
	      key: subject.subject_code,
	      domProps: {
	        "value": subject.subject_code
	      }
	    }, [_vm._v("\n                  " + _vm._s(subject.fagkode) + " - " + _vm._s(subject.name) + "\n                ")])
	  })], 2) : _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.subjectCode),
	      expression: "subjectCode",
	      modifiers: {
	        "number": true
	      }
	    }],
	    staticClass: "do-input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.subjectCode)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.subjectCode = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  })])]), _vm._v(" "), (_vm.showDanishPreparationFactorInTitleRow && _vm.isDanishPrepBinaryOnOwnRow) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('DkPreparationFactorControl', {
	    attrs: {
	      "subject-type": _vm.subjectType,
	      "school-prep-factor": _vm.schoolSettings.prepFactor,
	      "labels": _vm.danishPreparationControlLabels,
	      "wrap-class": "input-group dk-prep-factor-full-width"
	    },
	    model: {
	      value: (_vm.preparation),
	      callback: function($$v) {
	        _vm.preparation = $$v
	      },
	      expression: "preparation"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (!_vm.editSubject && !_vm.isEditSubjectAdvanced) ? _c('div', {
	    staticClass: "input-group input-group__flex"
	  }, [_c('div', {
	    staticClass: "flex-"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['hours_in_school_year']))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: (_vm.hoursDisabledTippy),
	      expression: "hoursDisabledTippy"
	    }],
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['hours_disabled_desc']
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.hours),
	      expression: "hours",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "inputLessonCount",
	    staticClass: "do-input",
	    class: {
	      'input--error': _vm.formErrors['hours'],
	      'input--disabled': _vm.isHoursDisabled
	    },
	    attrs: {
	      "type": "number",
	      "disabled": _vm.isHoursDisabled
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "blur": [function($event) {
	        return _vm.removeErrors('hours')
	      }, function($event) {
	        return _vm.$forceUpdate()
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = _vm._n($event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), (_vm.showDanishPreparationFactorBesideHours && !_vm.isDanishPrepBinaryOnOwnRow) ? _c('DkPreparationFactorControl', {
	    attrs: {
	      "subject-type": _vm.subjectType,
	      "school-prep-factor": _vm.schoolSettings.prepFactor,
	      "labels": _vm.danishPreparationControlLabels,
	      "wrap-class": "flex-1"
	    },
	    model: {
	      value: (_vm.preparation),
	      callback: function($$v) {
	        _vm.preparation = $$v
	      },
	      expression: "preparation"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "flex-1"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['standard_duration']))]), _vm._v(" "), _c('div', {
	    staticClass: "input-group--flex"
	  }, [_c('div', {
	    staticClass: "flex-1"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.defaultDuration),
	      expression: "defaultDuration"
	    }],
	    ref: "input_default_duration",
	    staticClass: "do-input",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.defaultDuration)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.defaultDuration = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['defaultDuration']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['defaultDuration'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), (_vm.userCanManageSchool) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true
	      }),
	      expression: "{\n          arrow: true\n        }"
	    }],
	    staticClass: "input-group--flex__setting-icon",
	    attrs: {
	      "content": _vm.$t('vue2.set_standard_duration.set_standard_duration_for_the_school')
	    }
	  }, [_c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.isOpenDurationModal = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-wrench"
	  })])]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), (!_vm.editSubject && !_vm.isEditSubjectAdvanced && _vm.showDanishPreparationFactorBesideHours && _vm.isDanishPrepBinaryOnOwnRow) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('DkPreparationFactorControl', {
	    attrs: {
	      "subject-type": _vm.subjectType,
	      "school-prep-factor": _vm.schoolSettings.prepFactor,
	      "labels": _vm.danishPreparationControlLabels,
	      "wrap-class": "input-group dk-prep-factor-full-width"
	    },
	    model: {
	      value: (_vm.preparation),
	      callback: function($$v) {
	        _vm.preparation = $$v
	      },
	      expression: "preparation"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (!_vm.calendarId) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_class']))]), _vm._v(" "), _c('DSelectKlass', {
	    on: {
	      "add": _vm.addKlass,
	      "remove": _vm.removeKlass
	    }
	  }), _vm._v(" "), (_vm.formErrors['calendarId']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['calendarId'][_vm.locale]))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_color']))]), _vm._v(" "), _c('ColorPicker', {
	    attrs: {
	      "initialColor": _vm.color
	    },
	    on: {
	      "changedColor": _vm.setSubjectColor
	    }
	  })], 1), _vm._v(" "), (!_vm.isActivities) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_subject_type']))]), _vm._v(" "), _c('SubjectTypePicker', {
	    attrs: {
	      "calendarType": _vm.calendarType,
	      "subjectType": _vm.subjectType,
	      "showActivities": _vm.showActivities
	    },
	    on: {
	      "change": _vm.selectSubjectType
	    }
	  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.editSubject) ? _c('div', {
	    staticClass: "edit-subject add-lesson__footer"
	  }, [_c('div', {
	    staticClass: "input-group input-group__submit"
	  }, [_c('div', {
	    staticClass: "input-group__submit__left"
	  }, [(_vm.editSubjectCanBeDeleted) ? _c('button', {
	    staticClass: "hint--right bttn--warning",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['delete_subject']
	    },
	    on: {
	      "click": _vm.deleteEditSubject
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })]) : _c('div', {
	    staticClass: "hint--right",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['cannot_delete']
	    }
	  }, [_c('button', {
	    staticClass: "bttn bttn--disabled"
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__submit__right"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))]), _vm._v(" "), (_vm.editSubject) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.updateSubject
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['update_subject']) + "\n                ")]) : _vm._e()])])]) : _c('div', {
	    staticClass: "input-group input-group__submit add-lesson__footer"
	  }, [_c('div', {
	    staticClass: "input-group__submit__left"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "input-group__submit__right"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.createSubject
	    }
	  }, [_vm._v("\n                " + _vm._s(!_vm.isActivities ? _vm.i18n[_vm.locale]['create_subject'] : 'Opret aktivitet') + "\n              ")])])])], 2) : _vm._e()])])], 2) : _vm._e(), _vm._v(" "), _c('StandardDurationSetting', {
	    attrs: {
	      "isOpenModal": _vm.isOpenDurationModal
	    },
	    on: {
	      "close": function($event) {
	        _vm.isOpenDurationModal = false
	      },
	      "submit": _vm.saveUpdatedDuration
	    }
	  }), _vm._v(" "), (_vm.subjectsWithSameName.length > 0) ? _c('SubjectFormDeleteSubjects', {
	    attrs: {
	      "subjectsWithSameName": _vm.subjectsWithSameName
	    },
	    on: {
	      "close": _vm.closeModalSubjectsWithSameName,
	      "keep": _vm.keepExistingSubjects,
	      "delete": _vm.deleteExistingSubjects
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showPoolsConfirm) ? _c('SubjectPoolsUpdateConfirm', {
	    attrs: {
	      "subject": _vm.editSubject,
	      "newHours": _vm.hours
	    },
	    on: {
	      "updateAll": _vm.onPoolsConfirmUpdateAll,
	      "subjectOnly": _vm.onPoolsConfirmSubjectOnly,
	      "close": _vm.onPoolsConfirmClose
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showAssignTeacherToEventsConfirm) ? _c('SubjectAssignTeacherToEventsConfirm', {
	    attrs: {
	      "teacherNames": _vm.assignTeacherToEventsNames,
	      "initialDate": _vm.assignTeacherToEventsInitialDate,
	      "mode": _vm.assignTeacherToEventsAction,
	      "calendarKind": _vm.assignTeacherToEventsKind,
	      "color": _vm.color,
	      "subjectName": _vm.name
	    },
	    on: {
	      "confirm": _vm.onAssignTeacherToEventsConfirm,
	      "skip": _vm.onAssignTeacherToEventsSkip
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1758 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "d-modal"
	    }
	  }, [_c('div', {
	    staticClass: "zen-export-overlay"
	  }, [_c('div', {
	    staticClass: "zen-export"
	  }, [_c('div', {
	    staticClass: "zen-export__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.t.title))]), _vm._v(" "), _c('div', {
	    staticClass: "zen-export__header-actions"
	  }, [(!_vm.isLoading) ? _c('div', {
	    staticClass: "zen-export__duration"
	  }, [_c('div', {
	    staticClass: "zen-export__duration-row"
	  }, [_c('label', {
	    staticClass: "zen-export__duration-label",
	    attrs: {
	      "for": "zen-export-duration-input"
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('vue2.set_standard_duration.standard_duration_for_the_school')) + "\n                "), _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom',
	        maxWidth: 320,
	        boundary: 'window',
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992'
	      }),
	      expression: "{\n                    arrow: true,\n                    placement: 'bottom',\n                    maxWidth: 320,\n                    boundary: 'window',\n                    animateFill: false,\n                    animation: 'shift-away',\n                    zIndex: '999999992'\n                  }"
	    }],
	    staticClass: "zen-export__duration-info",
	    attrs: {
	      "content": _vm.$t('vue2.set_standard_duration.set_standard_length_for_zen')
	    }
	  }, [_vm._v("ⓘ")])]), _vm._v(" "), _c('div', {
	    staticClass: "zen-export__duration-inputwrap"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.durationInputMinutes),
	      expression: "durationInputMinutes",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "durationInput",
	    staticClass: "zen-export__duration-input",
	    attrs: {
	      "id": "zen-export-duration-input",
	      "type": "number",
	      "maxlength": "4"
	    },
	    domProps: {
	      "value": (_vm.durationInputMinutes)
	    },
	    on: {
	      "blur": [_vm.onStandardDurationBlur, function($event) {
	        return _vm.$forceUpdate()
	      }],
	      "focus": _vm.onStandardDurationFocus,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.durationInputMinutes = _vm._n($event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "zen-export__duration-suffix"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.set_standard_duration.minutes')))])])]), _vm._v(" "), (!_vm.isAValidStandardDuration) ? _c('p', {
	    staticClass: "zen-export__duration-error"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.set_standard_duration.the_number_must_be_divisible_by_five')) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "zen-export__close icon-cross2",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "zen-export__tabs"
	  }, [_c('Tabs', {
	    attrs: {
	      "tabs": _vm.calendarTabs,
	      "selected": _vm.activeTab,
	      "isLarge": true
	    },
	    on: {
	      "select": function($event) {
	        _vm.activeTab = $event
	      }
	    }
	  }), _vm._v(" "), (!_vm.isLoading) ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.t.filter_title,
	      "tags": _vm.uniqueSubjectTitles,
	      "selectedTags": _vm.selectedSubjectTitleFilters,
	      "numberOfSelectedTagsToShow": 1
	    },
	    on: {
	      "select": _vm.toggleSelectedSubjectTitleFilters,
	      "clear": _vm.clearSelectedSubjectTitleFilters
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.t.filter_type,
	      "tags": _vm.uniqueSubjectTypeFilterTags,
	      "selectedTags": _vm.selectedSubjectTypeFilters,
	      "numberOfSelectedTagsToShow": 1
	    },
	    on: {
	      "select": _vm.toggleSelectedSubjectTypeFilters,
	      "clear": _vm.clearSelectedSubjectTypeFilters
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.calendarFilterTitle,
	      "tags": _vm.uniqueCalendarNames,
	      "selectedTags": _vm.selectedCalendarNameFilters,
	      "numberOfSelectedTagsToShow": 1
	    },
	    on: {
	      "select": _vm.toggleSelectedCalendarNameFilters,
	      "clear": _vm.clearSelectedCalendarNameFilters
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "zen-export__toolbar"
	  }, [_c('div', {
	    staticClass: "zen-export__toolbar-left"
	  }, [_c('span', {
	    staticClass: "zen-export__toggle-all",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.allChecked ? _vm.t.deselect_all : _vm.t.select_all) + "\n          ")]), _vm._v(" "), _c('span', {
	    staticClass: "zen-export__count zen-export__count--tab"
	  }, [_vm._v("\n            " + _vm._s(_vm.tabCountText) + "\n          ")])]), _vm._v(" "), _c('span', {
	    staticClass: "zen-export__count"
	  }, [_vm._v("\n          " + _vm._s(_vm.totalCountText) + "\n        ")])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#f6f9fc"
	    }
	  }) : [_c('div', {
	    staticClass: "zen-export__body"
	  }, [(_vm.groupedRows.length > 0) ? _c('div', {
	    staticClass: "zen-export__tables"
	  }, _vm._l((_vm.groupedRows), function(group) {
	    return _c('table', {
	      key: group.calendarId,
	      staticClass: "do-table zen-table"
	    }, [_c('thead', [_c('tr', [_c('th', {
	      staticClass: "zen-table__th zen-table__th--check",
	      on: {
	        "click": function($event) {
	          return _vm.toggleGroup(group)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "d-checkbox",
	      class: {
	        'd-checkbox--active': _vm.isGroupAllChecked(group)
	      }
	    })]), _vm._v(" "), _c('th', {
	      staticStyle: {
	        "width": "24px"
	      }
	    }), _vm._v(" "), _c('th', {
	      staticClass: "zen-table__th zen-table__th--name",
	      attrs: {
	        "colspan": "1"
	      }
	    }, [_vm._v("\n                    " + _vm._s(group.calendarName) + "\n                  ")]), _vm._v(" "), _c('th', {
	      staticClass: "zen-table__th"
	    }, [_vm._v(_vm._s(_vm.t.th_type))]), _vm._v(" "), _c('th', {
	      staticClass: "zen-table__th"
	    }, [_vm._v(_vm._s(_vm.t.th_teachers))]), _vm._v(" "), _c('th', {
	      staticClass: "zen-table__th"
	    }, [_vm._v(_vm._s(_vm.t.th_rooms))]), _vm._v(" "), _c('th', {
	      staticClass: "zen-table__th"
	    }, [_vm._v(_vm._s(_vm.t.th_klasses))]), _vm._v(" "), _c('th', {
	      staticClass: "zen-table__th zen-table__th--numeric"
	    }, [_vm._v(_vm._s(_vm.t.th_hours))]), _vm._v(" "), _c('th', {
	      staticClass: "zen-table__th zen-table__th--numeric"
	    }, [_vm._v(_vm._s(_vm.t.th_lessons_per_week))]), _vm._v(" "), _c('th', {
	      staticClass: "zen-table__th zen-table__th--events"
	    }, [_vm._v(_vm._s(_vm.t.th_events))])])]), _vm._v(" "), _c('tbody', [(group.subjects.length === 0) ? _c('tr', [_c('td', {
	      staticClass: "zen-table__empty",
	      attrs: {
	        "colspan": "10"
	      }
	    }, [_vm._v(_vm._s(_vm.t.no_pieces))])]) : _vm._e(), _vm._v(" "), _vm._l((group.subjects), function(row) {
	      return _c('tr', {
	        key: row.id,
	        staticClass: "zen-table__row",
	        class: {
	          'zen-table__row--unchecked': !_vm.isRowChecked(row)
	        },
	        on: {
	          "click": function($event) {
	            return _vm.toggleRow(row)
	          }
	        }
	      }, [_c('td', {
	        staticClass: "zen-table__td zen-table__td--check"
	      }, [_c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': _vm.isRowChecked(row)
	        }
	      })]), _vm._v(" "), _c('td', {
	        staticClass: "zen-table__td zen-table__td--color"
	      }, [_c('span', {
	        staticClass: "zen-table__color-dot",
	        style: ({
	          background: row.color
	        })
	      })]), _vm._v(" "), _c('td', {
	        staticClass: "zen-table__td zen-table__td--name"
	      }, [_vm._v("\n                    " + _vm._s(row.subjectName) + "\n                  ")]), _vm._v(" "), _c('td', {
	        staticClass: "zen-table__td zen-table__td--type"
	      }, [_vm._v("\n                    " + _vm._s(row.typeName) + "\n                  ")]), _vm._v(" "), _c('td', {
	        staticClass: "zen-table__td"
	      }, [_vm._v("\n                    " + _vm._s(row.teachers) + "\n                  ")]), _vm._v(" "), _c('td', {
	        staticClass: "zen-table__td"
	      }, [_vm._v("\n                    " + _vm._s(row.rooms) + "\n                  ")]), _vm._v(" "), _c('td', {
	        staticClass: "zen-table__td"
	      }, [_vm._v("\n                    " + _vm._s(row.otherKlasses) + "\n                  ")]), _vm._v(" "), _c('td', {
	        staticClass: "zen-table__td zen-table__td--numeric"
	      }, [_vm._v("\n                    " + _vm._s(row.hours) + "\n                  ")]), _vm._v(" "), _c('td', {
	        staticClass: "zen-table__td zen-table__td--numeric"
	      }, [_vm._v("\n                    " + _vm._s(row.lessonsPerWeek) + "\n                  ")]), _vm._v(" "), _c('td', {
	        staticClass: "zen-table__td zen-table__td--events",
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	          }
	        }
	      }, [_c('input', {
	        staticClass: "zen-table__input",
	        attrs: {
	          "type": "number",
	          "min": "0"
	        },
	        domProps: {
	          "value": _vm.rowEvents(row)
	        },
	        on: {
	          "change": function($event) {
	            return _vm.onEventsInput(row, $event)
	          }
	        }
	      })])])
	    })], 2)])
	  }), 0) : _c('div', {
	    staticClass: "zen-export__empty"
	  }, [(_vm.activeRows.length === 0) ? [_vm._v("\n              " + _vm._s(_vm.t.no_pieces_in_calendar_type) + "\n            ")] : [_vm._v("\n              " + _vm._s(_vm.t.no_pieces_match_filters) + "\n            ")]], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "zen-export__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.t.cancel))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    attrs: {
	      "disabled": _vm.isExporting
	    },
	    on: {
	      "click": _vm.saveAndExport
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.isExporting ? _vm.t.transferring : _vm.t.transfer_to_zen) + "\n          ")])])]], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 1759 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "external text-dark"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['external_view']))]), _vm._v(" "), _c('ul', {
	    staticClass: "d-tabs"
	  }, [_c('li', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': _vm.theActiveTab === 0
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheActiveTab(0)
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.i18n[_vm.locale]['calendars']) + "\n    ")]), _vm._v(" "), _c('li', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': _vm.theActiveTab === 1
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheActiveTab(1)
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.i18n[_vm.locale]['absent_today']) + "\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [(_vm.theActiveTab === 1) ? [_c('h2', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_absent_today']))]), _vm._v(" "), _c('div', {
	    staticClass: "absence-activate marg-1-bottom"
	  }, [_c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['activate_view']))]), _vm._v(" "), _c('div', {
	    staticClass: "absence-activate__toggle",
	    on: {
	      "click": _vm.toggleAbsentTodayView
	    }
	  }, [(_vm.isAbsentTodaySaving) ? _c('loader', {
	    staticStyle: {
	      "margin": "0"
	    },
	    attrs: {
	      "isExtraSmall": true,
	      "bg-color": "#fff"
	    }
	  }) : _c('app-toggle', {
	    attrs: {
	      "prop-on": _vm.isAbsentTodayEnabled,
	      "allow-changes": false
	    }
	  })], 1)]), _vm._v(" "), (_vm.isAbsentTodayEnabled) ? [_c('p', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_absent_today_desc']))]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": _vm.absence
	    }
	  }, [_vm._v(_vm._s(_vm.absence))])] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 0) ? [_c('h2', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_selected_schedules']))]), _vm._v(" "), _c('p', [(_vm.studentCalendars.length === 0) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_selected_schedules_desc']) + ":")]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_selected_schedules_desc_with_students']) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "href": _vm.publicLink,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.publicLink))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['use_update_in_url']))]), _vm._v(" "), (_vm.studentCalendars.length === 0) ? _c('h4', {
	    staticClass: "marg-1-bottom marg-1-top"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['selected_the_schedules']))]) : _c('h4', {
	    staticClass: "marg-1-bottom marg-1-top"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['selected_the_schedules_with_students']))]), _vm._v(" "), (_vm.isLoadingCalendars) ? _c('loader', {
	    staticStyle: {
	      "margin": "100px 200px"
	    },
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : _c('table', {
	    staticClass: "d-table marg-2-top external__toggle-calendars"
	  }, [_c('thead', {
	    staticClass: "d-table__header"
	  }, [_c('th'), _vm._v(" "), _c('th', [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true
	      }),
	      expression: "{\n          arrow: true\n        }"
	    }],
	    staticClass: "inline-block",
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['access_schedule_without_login']
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['visible_via_link']) + " "), _c('span', {
	    staticClass: "icon-question3"
	  })])]), _vm._v(" "), _c('th', [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true
	      }),
	      expression: "{\n          arrow: true\n        }"
	    }],
	    staticClass: "inline-block text-link pointer",
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['visible_via_link_tooltip']
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowMobileGuide(true)
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['schedules_on_desktop_mobile']) + " "), _c('span', {
	    staticClass: "icon-question3"
	  })])]), _vm._v(" "), _c('th', [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true
	      }),
	      expression: "{\n          arrow: true\n        }"
	    }],
	    staticClass: "inline-block",
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['schedules_on_desktop_mobile_tooltip']
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_schedules_until']) + " "), _c('span', {
	    staticClass: "icon-question3"
	  })])]), _vm._v(" "), _c('th', [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true
	      }),
	      expression: "{\n      arrow: true\n    }"
	    }],
	    staticClass: "pointer inline-block text-link",
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['integrations_with_google']
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowICalGuide(true)
	      }
	    }
	  }, [_vm._v("Google, Apple, Outlook "), _c('span', {
	    staticClass: "icon-question3"
	  })])])]), _vm._v(" "), _c('thead', {
	    staticClass: "d-table__header d-table__header__first"
	  }, [_c('th', {
	    staticClass: "th-hover",
	    on: {
	      "click": function($event) {
	        _vm.isShowKlass = !_vm.isShowKlass
	      }
	    }
	  }, [_c('span', {
	    staticClass: "marg-1-right",
	    class: [{
	      'icon-arrow-up': _vm.isShowKlass
	    }, {
	      'icon-arrow-down': !_vm.isShowKlass
	    }]
	  }), _vm._v("\n          " + _vm._s(_vm.calendarsWithProps.length) + "\n          " + _vm._s(_vm.calendarsWithProps.length !== 1 ? _vm.i18n[_vm.locale]['grade'] : _vm.i18n[_vm.locale]['grades']) + "\n        ")]), _vm._v(" "), _c('th', {
	    staticClass: "toggle-all-calendars"
	  }, [(_vm.isShowKlass) ? [(_vm.isToggleLoading === 'klass') ? _c('loader', {
	    staticStyle: {
	      "margin": "0"
	    },
	    attrs: {
	      "isExtraSmall": true,
	      "bg-color": "#f6f9fc"
	    }
	  }) : _c('div', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleAllKlassCalendars.apply(null, arguments)
	      }
	    }
	  }, [(_vm.isAnyKlassCalendarsWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n            ")])] : _vm._e()], 2), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), (_vm.isShowKlass) ? _c('tbody', [(_vm.calendarsWithProps.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "text-explainer",
	    staticStyle: {
	      "padding": "8px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_grades_created']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.calendarsWithProps), function(calendar) {
	    return [_c('tr', {
	      key: calendar.id,
	      class: {
	        'tr-calendar--is-open': calendar.v_is_open
	      }
	    }, [_c('td', {
	      class: {
	        'name-and-toggle': calendar.students && calendar.students.length > 0
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveKlassCalendar(calendar)
	        }
	      }
	    }, [(calendar.students && calendar.students.length > 0) ? _c('div', {
	      staticClass: "d-toggle-arrow"
	    }) : _vm._e(), _vm._v("\n              " + _vm._s(calendar.name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "inline-block",
	      on: {
	        "click": function($event) {
	          return _vm.toggleAnonymousAccess(calendar)
	        }
	      }
	    }, [_c('app-toggle', {
	      attrs: {
	        "prop-on": calendar.anonymous_access,
	        "allow-changes": false
	      }
	    })], 1)]), _vm._v(" "), _c('td', [(calendar.anonymous_access) ? _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_public_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_public_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "400px"
	      }
	    }, [(!calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__no-end-date"
	    }, [_c('p', {
	      staticClass: "text-explainer"
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
	      staticClass: "hint--right",
	      attrs: {
	        "aria-label": _vm.i18n[_vm.locale]['set_a_date']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "icon__bg-circle"
	    }, [_c('span', {
	      staticClass: "icon-calendar4"
	    })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container"
	    }, [_c('DateSelector', {
	      staticStyle: {
	        "width": "210px"
	      },
	      attrs: {
	        "date": _vm.theActiveDatePickerDate,
	        "isOpen": true
	      },
	      on: {
	        "changed": function($event) {
	          return _vm.updatePublishUntilDate(calendar, $event)
	        },
	        "close": function($event) {
	          return _vm.closeDatepicker(calendar)
	        }
	      }
	    }), _vm._v(" "), (calendar.published_until) ? _c('button', {
	      staticClass: "bttn bttn-danger calendar__datepicker-container__button",
	      on: {
	        "click": function($event) {
	          return _vm.deleteActiveDatePicker(calendar)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
	    }, [_c('div', {
	      staticClass: "datepicker-input pointer pos-relative",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (calendar.v_formatted_date),
	        expression: "calendar.v_formatted_date"
	      }],
	      attrs: {
	        "id": "inputfield",
	        "type": "text",
	        "readonly": ""
	      },
	      domProps: {
	        "value": (calendar.v_formatted_date)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(calendar, "v_formatted_date", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "icon-calendar4 input-icon"
	    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_ical_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_ical_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n              ")])])]), _vm._v(" "), (calendar.v_is_open) ? _c('tr', {
	      staticClass: "tr-student--tr-thead d-table__header"
	    }, [_c('th', [_vm._v(_vm._s(_vm.activeStudentCalenders.length) + " "), (_vm.activeStudentCalenders.length === 1) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['student']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['students']))])]), _vm._v(" "), _c('th', {
	      staticClass: "toggle-all-calendars"
	    }, [(_vm.isToggleLoading === 'students') ? _c('loader', {
	      staticStyle: {
	        "margin": "0"
	      },
	      attrs: {
	        "isExtraSmall": true,
	        "bg-color": "#f6f9fc"
	      }
	    }) : _c('div', {
	      staticClass: "inline-block pointer",
	      on: {
	        "click": _vm.toggleAllStudentCalendars
	      }
	    }, [(_vm.isAnyActiveStudentCalendersWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n              ")])], 1), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeStudentCalenders), function(student, key) {
	      return (calendar.v_is_open) ? _c('tr', {
	        key: student.id,
	        staticClass: "tr-student--tr",
	        class: {
	          'tr-student--tr-thead--first': _vm.activeStudentCalenders.length > 1 && key === 0
	        }
	      }, [_c('td', [_vm._v("\n              " + _vm._s(student.name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', {
	        staticClass: "inline-block",
	        on: {
	          "click": function($event) {
	            return _vm.toggleAnonymousAccess(student)
	          }
	        }
	      }, [_c('app-toggle', {
	        attrs: {
	          "prop-on": student.anonymous_access,
	          "allow-changes": false
	        }
	      })], 1)]), _vm._v(" "), _c('td', [(student.anonymous_access) ? _c('button', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            onShow: _vm.hideTippy,
	            trigger: 'manual',
	            arrow: true,
	            placement: 'top',
	            zIndex: 2147483010
	          }),
	          expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	        }],
	        staticClass: "bttn bttn--white bttn--small",
	        attrs: {
	          "content": _vm.i18n[_vm.locale]['copied'] + ' ' + student.v_public_link
	        },
	        on: {
	          "click": function($event) {
	            return _vm.copyToClipboard(student.v_public_link, $event)
	          }
	        }
	      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	        staticStyle: {
	          "width": "400px"
	        }
	      }, [(!student.published_until && _vm.theActiveDatePickerId !== student.id) ? _c('div', {
	        staticClass: "calendar__no-end-date"
	      }, [_c('p', {
	        staticClass: "text-explainer"
	      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
	        staticClass: "hint--right",
	        attrs: {
	          "aria-label": _vm.i18n[_vm.locale]['set_a_date']
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setActiveDatePicker(student)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "icon__bg-circle"
	      }, [_c('span', {
	        staticClass: "icon-calendar4"
	      })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === student.id) ? _c('div', {
	        staticClass: "calendar__datepicker-container"
	      }, [_c('DateSelector', {
	        staticStyle: {
	          "width": "210px"
	        },
	        attrs: {
	          "date": _vm.theActiveDatePickerDate,
	          "isOpen": true
	        },
	        on: {
	          "changed": function($event) {
	            return _vm.updatePublishUntilDate(student, $event)
	          },
	          "close": function($event) {
	            return _vm.closeDatepicker(student)
	          }
	        }
	      }), _vm._v(" "), (student.published_until) ? _c('button', {
	        staticClass: "bttn bttn-danger calendar__datepicker-container__button",
	        on: {
	          "click": function($event) {
	            return _vm.deleteActiveDatePicker(student)
	          }
	        }
	      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (student.published_until && _vm.theActiveDatePickerId !== student.id) ? _c('div', {
	        staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
	      }, [_c('div', {
	        staticClass: "datepicker-input pointer pos-relative",
	        on: {
	          "click": function($event) {
	            return _vm.setActiveDatePicker(student)
	          }
	        }
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (student.v_formatted_date),
	          expression: "student.v_formatted_date"
	        }],
	        attrs: {
	          "type": "text",
	          "readonly": ""
	        },
	        domProps: {
	          "value": (student.v_formatted_date)
	        },
	        on: {
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(student, "v_formatted_date", $event.target.value)
	          }
	        }
	      }), _vm._v(" "), _c('div', {
	        staticClass: "icon-calendar4 input-icon"
	      })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            onShow: _vm.hideTippy,
	            trigger: 'manual',
	            arrow: true,
	            placement: 'top',
	            zIndex: 2147483010
	          }),
	          expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	        }],
	        staticClass: "bttn bttn--white bttn--small",
	        attrs: {
	          "content": _vm.i18n[_vm.locale]['copied'] + ' ' + student.v_ical_link
	        },
	        on: {
	          "click": function($event) {
	            return _vm.copyToClipboard(student.v_ical_link, $event)
	          }
	        }
	      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n              ")])])]) : _vm._e()
	    })]
	  })], 2) : _vm._e(), _vm._v(" "), _c('thead', {
	    staticClass: "d-table__header d-table__header__first"
	  }, [_c('th', {
	    staticClass: "th-hover",
	    on: {
	      "click": function($event) {
	        _vm.isShowRooms = !_vm.isShowRooms
	      }
	    }
	  }, [_c('span', {
	    staticClass: "marg-1-right",
	    class: [{
	      'icon-arrow-up': _vm.isShowRooms
	    }, {
	      'icon-arrow-down': !_vm.isShowRooms
	    }]
	  }), _vm._v("\n          " + _vm._s(_vm.roomCalendarsWithProps.length) + "\n          " + _vm._s(_vm.roomCalendarsWithProps.length !== 1 ? _vm.i18n[_vm.locale]['rooms'] : _vm.i18n[_vm.locale]['room']) + "\n        ")]), _vm._v(" "), _c('th', {
	    staticClass: "toggle-all-calendars"
	  }, [(_vm.isShowRooms) ? [(_vm.isToggleLoading === 'rooms') ? _c('loader', {
	    staticStyle: {
	      "margin": "0"
	    },
	    attrs: {
	      "isExtraSmall": true,
	      "bg-color": "#f6f9fc"
	    }
	  }) : _c('div', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleAllRoomCalendars.apply(null, arguments)
	      }
	    }
	  }, [(_vm.isAnyRoomCalendarsWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n            ")])] : _vm._e()], 2), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), (_vm.isShowRooms) ? _c('tbody', [(_vm.roomCalendarsWithProps.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "text-explainer",
	    staticStyle: {
	      "padding": "8px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_rooms_created']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.roomCalendarsWithProps), function(calendar) {
	    return _c('tr', {
	      key: calendar.id
	    }, [_c('td', [_c('span', {
	      staticClass: "icon-location"
	    }), _vm._v(" " + _vm._s(calendar.name))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "inline-block",
	      on: {
	        "click": function($event) {
	          return _vm.toggleAnonymousAccess(calendar)
	        }
	      }
	    }, [_c('app-toggle', {
	      attrs: {
	        "prop-on": calendar.anonymous_access,
	        "allow-changes": false
	      }
	    })], 1)]), _vm._v(" "), _c('td', [(calendar.anonymous_access) ? _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_public_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_public_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "400px"
	      }
	    }, [(!calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__no-end-date"
	    }, [_c('p', {
	      staticClass: "text-explainer"
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
	      staticClass: "hint--right",
	      attrs: {
	        "aria-label": _vm.i18n[_vm.locale]['set_a_date']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "icon__bg-circle"
	    }, [_c('span', {
	      staticClass: "icon-calendar4"
	    })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container"
	    }, [_c('DateSelector', {
	      staticStyle: {
	        "width": "210px"
	      },
	      attrs: {
	        "date": _vm.theActiveDatePickerDate,
	        "isOpen": true
	      },
	      on: {
	        "changed": function($event) {
	          return _vm.updatePublishUntilDate(calendar, $event)
	        },
	        "close": function($event) {
	          return _vm.closeDatepicker(calendar)
	        }
	      }
	    }), _vm._v(" "), (calendar.published_until) ? _c('button', {
	      staticClass: "bttn bttn-danger calendar__datepicker-container__button",
	      on: {
	        "click": function($event) {
	          return _vm.deleteActiveDatePicker(calendar)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n              ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
	    }, [_c('div', {
	      staticClass: "datepicker-input pointer pos-relative",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (calendar.v_formatted_date),
	        expression: "calendar.v_formatted_date"
	      }],
	      attrs: {
	        "type": "text",
	        "readonly": ""
	      },
	      domProps: {
	        "value": (calendar.v_formatted_date)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(calendar, "v_formatted_date", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "icon-calendar4 input-icon"
	    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_ical_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_ical_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n            ")])])])
	  })], 2) : _vm._e(), _vm._v(" "), _c('thead', {
	    staticClass: "d-table__header d-table__header__first"
	  }, [_c('th', {
	    staticClass: "th-hover",
	    on: {
	      "click": function($event) {
	        _vm.isShowUsers = !_vm.isShowUsers
	      }
	    }
	  }, [_c('span', {
	    staticClass: "marg-1-right",
	    class: [{
	      'icon-arrow-up': _vm.isShowUsers
	    }, {
	      'icon-arrow-down': !_vm.isShowUsers
	    }]
	  }), _vm._v("\n          " + _vm._s(_vm.userCalendarsWithProps.length) + "\n          " + _vm._s(_vm.userCalendarsWithProps.length !== 1 ? _vm.i18n[_vm.locale]['users'] : _vm.i18n[_vm.locale]['user']) + "\n        ")]), _vm._v(" "), _c('th', {
	    staticClass: "toggle-all-calendars"
	  }, [(_vm.isShowUsers) ? [(_vm.isToggleLoading === 'users') ? _c('loader', {
	    staticStyle: {
	      "margin": "0"
	    },
	    attrs: {
	      "isExtraSmall": true,
	      "bg-color": "#f6f9fc"
	    }
	  }) : _c('div', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleAllUsersCalendars.apply(null, arguments)
	      }
	    }
	  }, [(_vm.isAnyUserCalendarsWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n            ")])] : _vm._e()], 2), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), (_vm.isShowUsers) ? _c('tbody', [(_vm.userCalendarsWithProps.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "text-explainer",
	    staticStyle: {
	      "padding": "8px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_users_created']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.userCalendarsWithProps), function(calendar) {
	    return _c('tr', {
	      key: calendar.id
	    }, [_c('td', [_c('span', {
	      staticClass: "icon-location"
	    }), _vm._v(" " + _vm._s(calendar.name))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "inline-block",
	      on: {
	        "click": function($event) {
	          return _vm.toggleAnonymousAccess(calendar)
	        }
	      }
	    }, [_c('app-toggle', {
	      attrs: {
	        "prop-on": calendar.anonymous_access,
	        "allow-changes": false
	      }
	    })], 1)]), _vm._v(" "), _c('td', [(calendar.anonymous_access) ? _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_public_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_public_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "400px"
	      }
	    }, [(!calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__no-end-date"
	    }, [_c('p', {
	      staticClass: "text-explainer"
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
	      staticClass: "hint--right",
	      attrs: {
	        "aria-label": _vm.i18n[_vm.locale]['set_a_date']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "icon__bg-circle"
	    }, [_c('span', {
	      staticClass: "icon-calendar4"
	    })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container"
	    }, [_c('DateSelector', {
	      staticStyle: {
	        "width": "210px"
	      },
	      attrs: {
	        "date": _vm.theActiveDatePickerDate,
	        "isOpen": true
	      },
	      on: {
	        "changed": function($event) {
	          return _vm.updatePublishUntilDate(calendar, $event)
	        },
	        "close": function($event) {
	          return _vm.closeDatepicker(calendar)
	        }
	      }
	    }), _vm._v(" "), (calendar.published_until) ? _c('button', {
	      staticClass: "bttn bttn-danger calendar__datepicker-container__button",
	      on: {
	        "click": function($event) {
	          return _vm.deleteActiveDatePicker(calendar)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n              ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
	    }, [_c('div', {
	      staticClass: "datepicker-input pointer pos-relative",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (calendar.v_formatted_date),
	        expression: "calendar.v_formatted_date"
	      }],
	      attrs: {
	        "type": "text",
	        "readonly": ""
	      },
	      domProps: {
	        "value": (calendar.v_formatted_date)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(calendar, "v_formatted_date", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "icon-calendar4 input-icon"
	    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_ical_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_ical_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n            ")])])])
	  })], 2) : _vm._e(), _vm._v(" "), _c('thead', {
	    staticClass: "d-table__header d-table__header__first"
	  }, [_c('th', {
	    staticClass: "th-hover",
	    on: {
	      "click": function($event) {
	        _vm.isShowMergeCalendars = !_vm.isShowMergeCalendars
	      }
	    }
	  }, [_c('span', {
	    staticClass: "marg-1-right",
	    class: [{
	      'icon-arrow-up': _vm.isShowMergeCalendars
	    }, {
	      'icon-arrow-down': !_vm.isShowMergeCalendars
	    }]
	  }), _vm._v("\n          " + _vm._s(_vm.mergeCalendarsWithProps.length) + "\n          " + _vm._s(_vm.mergeCalendarsWithProps.length !== 1 ? _vm.i18n[_vm.locale]['merge_calendars'] : _vm.i18n[_vm.locale]['merge_calendar']) + "\n        ")]), _vm._v(" "), _c('th', {
	    staticClass: "toggle-all-calendars"
	  }, [(_vm.isShowMergeCalendars) ? [(_vm.isToggleLoading === 'merge') ? _c('loader', {
	    staticStyle: {
	      "margin": "0"
	    },
	    attrs: {
	      "isExtraSmall": true,
	      "bg-color": "#f6f9fc"
	    }
	  }) : _c('div', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleAllMergeCalendars.apply(null, arguments)
	      }
	    }
	  }, [(_vm.isAnyMergeCalendarsWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n            ")])] : _vm._e()], 2), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), (_vm.isShowMergeCalendars) ? _c('tbody', [(_vm.mergeCalendarsWithProps.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "text-explainer",
	    staticStyle: {
	      "padding": "8px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_merge_created']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.mergeCalendarsWithProps), function(calendar) {
	    return _c('tr', {
	      key: calendar.id
	    }, [_c('td', [_c('span', {
	      staticClass: "icon-clipboard2"
	    }), _vm._v(" " + _vm._s(calendar.name))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "inline-block",
	      on: {
	        "click": function($event) {
	          return _vm.toggleAnonymousAccess(calendar)
	        }
	      }
	    }, [_c('app-toggle', {
	      attrs: {
	        "prop-on": calendar.anonymous_access,
	        "allow-changes": false
	      }
	    })], 1)]), _vm._v(" "), _c('td', [(calendar.anonymous_access) ? _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_public_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_public_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "400px"
	      }
	    }, [(!calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__no-end-date"
	    }, [_c('p', {
	      staticClass: "text-explainer"
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
	      staticClass: "hint--right",
	      attrs: {
	        "aria-label": _vm.i18n[_vm.locale]['set_a_date']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "icon__bg-circle"
	    }, [_c('span', {
	      staticClass: "icon-calendar4"
	    })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container"
	    }, [_c('DateSelector', {
	      staticStyle: {
	        "width": "210px"
	      },
	      attrs: {
	        "date": _vm.theActiveDatePickerDate,
	        "isOpen": true
	      },
	      on: {
	        "changed": function($event) {
	          return _vm.updatePublishUntilDate(calendar, $event)
	        },
	        "close": function($event) {
	          return _vm.closeDatepicker(calendar)
	        }
	      }
	    }), _vm._v(" "), (calendar.published_until) ? _c('button', {
	      staticClass: "bttn bttn-danger calendar__datepicker-container__button",
	      on: {
	        "click": function($event) {
	          return _vm.deleteActiveDatePicker(calendar)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n              ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
	    }, [_c('div', {
	      staticClass: "datepicker-input pointer pos-relative",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (calendar.v_formatted_date),
	        expression: "calendar.v_formatted_date"
	      }],
	      attrs: {
	        "type": "text",
	        "readonly": ""
	      },
	      domProps: {
	        "value": (calendar.v_formatted_date)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(calendar, "v_formatted_date", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "icon-calendar4 input-icon"
	    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_ical_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_ical_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n            ")])])])
	  })], 2) : _vm._e(), _vm._v(" "), _c('thead', {
	    staticClass: "d-table__header d-table__header__first"
	  }, [_c('th', {
	    staticClass: "th-hover",
	    on: {
	      "click": function($event) {
	        _vm.isShowOtherCalendars = !_vm.isShowOtherCalendars
	      }
	    }
	  }, [_c('span', {
	    staticClass: "marg-1-right",
	    class: [{
	      'icon-arrow-up': _vm.isShowOtherCalendars
	    }, {
	      'icon-arrow-down': !_vm.isShowOtherCalendars
	    }]
	  }), _vm._v("\n          " + _vm._s(_vm.otherCalendarsWithProps.length) + "\n          " + _vm._s(_vm.otherCalendarsWithProps.length !== 1 ? _vm.i18n[_vm.locale]['other'] : _vm.i18n[_vm.locale]['other']) + "\n        ")]), _vm._v(" "), _c('th', {
	    staticClass: "toggle-all-calendars"
	  }, [(_vm.isShowOtherCalendars) ? [(_vm.isToggleLoading === 'other') ? _c('loader', {
	    staticStyle: {
	      "margin": "0"
	    },
	    attrs: {
	      "isExtraSmall": true,
	      "bg-color": "#f6f9fc"
	    }
	  }) : _c('div', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleAllOtherCalendars.apply(null, arguments)
	      }
	    }
	  }, [(_vm.isAnyOtherCalendarsWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n            ")])] : _vm._e()], 2), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), (_vm.isShowOtherCalendars) ? _c('tbody', [(_vm.otherCalendarsWithProps.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "text-explainer",
	    staticStyle: {
	      "padding": "8px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_other_created']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.otherCalendarsWithProps), function(calendar) {
	    return _c('tr', {
	      key: calendar.id
	    }, [_c('td', [_c('span', {
	      staticClass: "icon-clipboard2"
	    }), _vm._v(" " + _vm._s(calendar.name))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "inline-block",
	      on: {
	        "click": function($event) {
	          return _vm.toggleAnonymousAccess(calendar)
	        }
	      }
	    }, [_c('app-toggle', {
	      attrs: {
	        "prop-on": calendar.anonymous_access,
	        "allow-changes": false
	      }
	    })], 1)]), _vm._v(" "), _c('td', [(calendar.anonymous_access) ? _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_public_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_public_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "400px"
	      }
	    }, [(!calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__no-end-date"
	    }, [_c('p', {
	      staticClass: "text-explainer"
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
	      staticClass: "hint--right",
	      attrs: {
	        "aria-label": _vm.i18n[_vm.locale]['set_a_date']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "icon__bg-circle"
	    }, [_c('span', {
	      staticClass: "icon-calendar4"
	    })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container"
	    }, [_c('DateSelector', {
	      staticStyle: {
	        "width": "210px"
	      },
	      attrs: {
	        "date": _vm.theActiveDatePickerDate,
	        "isOpen": true
	      },
	      on: {
	        "changed": function($event) {
	          return _vm.updatePublishUntilDate(calendar, $event)
	        },
	        "close": function($event) {
	          return _vm.closeDatepicker(calendar)
	        }
	      }
	    }), _vm._v(" "), (calendar.published_until) ? _c('button', {
	      staticClass: "bttn bttn-danger calendar__datepicker-container__button",
	      on: {
	        "click": function($event) {
	          return _vm.deleteActiveDatePicker(calendar)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n              ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
	    }, [_c('div', {
	      staticClass: "datepicker-input pointer pos-relative",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (calendar.v_formatted_date),
	        expression: "calendar.v_formatted_date"
	      }],
	      attrs: {
	        "type": "text",
	        "readonly": ""
	      },
	      domProps: {
	        "value": (calendar.v_formatted_date)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(calendar, "v_formatted_date", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "icon-calendar4 input-icon"
	    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_ical_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_ical_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n            ")])])])
	  })], 2) : _vm._e(), _vm._v(" "), _c('thead', {
	    staticClass: "d-table__header d-table__header__first"
	  }, [_c('th', {
	    staticClass: "th-hover",
	    on: {
	      "click": function($event) {
	        _vm.isShowClubCalendars = !_vm.isShowClubCalendars
	      }
	    }
	  }, [_c('span', {
	    staticClass: "marg-1-right",
	    class: [{
	      'icon-arrow-up': _vm.isShowClubCalendars
	    }, {
	      'icon-arrow-down': !_vm.isShowClubCalendars
	    }]
	  }), _vm._v("\n          " + _vm._s(_vm.clubCalendarsWithProps.length) + "\n          " + _vm._s(_vm.clubCalendarsWithProps.length !== 1 ? _vm.i18n[_vm.locale]['club'] : _vm.i18n[_vm.locale]['club']) + "\n        ")]), _vm._v(" "), _c('th', {
	    staticClass: "toggle-all-calendars"
	  }, [(_vm.isShowClubCalendars) ? [(_vm.isToggleLoading === 'club') ? _c('loader', {
	    staticStyle: {
	      "margin": "0"
	    },
	    attrs: {
	      "isExtraSmall": true,
	      "bg-color": "#f6f9fc"
	    }
	  }) : _c('div', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleAllClubCalendars.apply(null, arguments)
	      }
	    }
	  }, [(_vm.isAnyClubCalendarsWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n            ")])] : _vm._e()], 2), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), (_vm.isShowClubCalendars) ? _c('tbody', [(_vm.clubCalendarsWithProps.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "text-explainer",
	    staticStyle: {
	      "padding": "8px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_club_created']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.clubCalendarsWithProps), function(calendar) {
	    return _c('tr', {
	      key: calendar.id
	    }, [_c('td', [_c('span', {
	      staticClass: "icon-clipboard2"
	    }), _vm._v(" " + _vm._s(calendar.name))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "inline-block",
	      on: {
	        "click": function($event) {
	          return _vm.toggleAnonymousAccess(calendar)
	        }
	      }
	    }, [_c('app-toggle', {
	      attrs: {
	        "prop-on": calendar.anonymous_access,
	        "allow-changes": false
	      }
	    })], 1)]), _vm._v(" "), _c('td', [(calendar.anonymous_access) ? _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_public_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_public_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "400px"
	      }
	    }, [(!calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__no-end-date"
	    }, [_c('p', {
	      staticClass: "text-explainer"
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
	      staticClass: "hint--right",
	      attrs: {
	        "aria-label": _vm.i18n[_vm.locale]['set_a_date']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "icon__bg-circle"
	    }, [_c('span', {
	      staticClass: "icon-calendar4"
	    })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container"
	    }, [_c('DateSelector', {
	      staticStyle: {
	        "width": "210px"
	      },
	      attrs: {
	        "date": _vm.theActiveDatePickerDate,
	        "isOpen": true
	      },
	      on: {
	        "changed": function($event) {
	          return _vm.updatePublishUntilDate(calendar, $event)
	        },
	        "close": function($event) {
	          return _vm.closeDatepicker(calendar)
	        }
	      }
	    }), _vm._v(" "), (calendar.published_until) ? _c('button', {
	      staticClass: "bttn bttn-danger calendar__datepicker-container__button",
	      on: {
	        "click": function($event) {
	          return _vm.deleteActiveDatePicker(calendar)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n              ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
	    }, [_c('div', {
	      staticClass: "datepicker-input pointer pos-relative",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (calendar.v_formatted_date),
	        expression: "calendar.v_formatted_date"
	      }],
	      attrs: {
	        "type": "text",
	        "readonly": ""
	      },
	      domProps: {
	        "value": (calendar.v_formatted_date)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(calendar, "v_formatted_date", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "icon-calendar4 input-icon"
	    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_ical_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_ical_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n            ")])])])
	  })], 2) : _vm._e()])] : _vm._e()], 2), _vm._v(" "), _c('export-calendar', {
	    attrs: {
	      "isShowButton": false,
	      "isShowFromProp": _vm.isShowICalGuide
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsShowICalGuide(false)
	      }
	    }
	  }), _vm._v(" "), _c('CalendarOnMobileGuides', {
	    attrs: {
	      "isShowFromProp": _vm.isShowMobileGuide
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsShowMobileGuide(false)
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1760 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "grid grid-pad box-size subs-today-grid"
	  }, [_c('div', {
	    staticClass: "subs-today text-dark"
	  }, [_c('div', {
	    staticClass: "subs-today__header"
	  }, [(_vm.isSubsToday) ? _c('h1', [_vm._v(_vm._s(_vm.substitutesToday.length) + " " + _vm._s(_vm.i18n[_vm.locale]['subs']) + ", "), _c('span', {
	    staticClass: "headline-date"
	  }, [_vm._v(_vm._s(_vm.formattedDayDate))])]) : _c('h1', [_vm._v(_vm._s(_vm.absentToday.length) + " " + _vm._s(_vm.i18n[_vm.locale]['absent']) + ", "), _c('span', {
	    staticClass: "headline-date"
	  }, [_vm._v(_vm._s(_vm.formattedDayDate))])]), _vm._v(" "), _c('div', {
	    staticClass: "subs-today__header__right no-print"
	  }, [_c('button', {
	    staticClass: "date-buttons marg-5-right",
	    class: {
	      'bttn--disabled': _vm.getIsToday
	    },
	    on: {
	      "click": _vm.setToday
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale]['today']) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "date-buttons marg-5-right",
	    on: {
	      "click": _vm.prevDay
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-left4"
	  })]), _vm._v(" "), _c('DatePicker', {
	    attrs: {
	      "date": _vm.date
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "marg-5-left date-buttons",
	    on: {
	      "click": _vm.nextDay
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-right4"
	  })]), _vm._v(" "), (_vm.isSubsToday) ? _c('button', {
	    staticClass: "marg-1-left",
	    on: {
	      "click": _vm.asyncLoadXLSXAndDownload
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['download']) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "marg-1-left",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "marg-1-left marg-1-right",
	    on: {
	      "click": _vm.startSlider
	    }
	  }, [(_vm.isSlider) ? _c('span', {
	    staticClass: "icon-shrink7"
	  }) : _c('span', {
	    staticClass: "icon-enlarge2"
	  })])], 1)]), _vm._v(" "), (_vm.isLoading) ? _c('Loader') : _vm._e(), _vm._v(" "), (_vm.isSubsToday && !_vm.isLoading && _vm.substitutesToday.length < 1) ? _c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_subs_today']) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isSubsToday && !_vm.isLoading && _vm.absentToday.length < 1) ? _c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_one_absent_today']) + "\n    ")]) : _c('div', {
	    staticClass: "users-today__container"
	  }, [_vm._l((_vm.usersInArraysSlider), function(userRow, key) {
	    return (!_vm.isSlider || key === _vm.theSliderIndex) ? _c('div', {
	      staticClass: "subs-grid"
	    }, _vm._l((userRow), function(user) {
	      return _c('div', {
	        key: user.id,
	        staticClass: "subs-today__sub",
	        attrs: {
	          "data-user-id": user.id
	        }
	      }, [_c('h3', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _vm._l((user.absence), function(absence) {
	        return _c('p', {
	          staticClass: "subs-today__sub__absence"
	        }, [_vm._v(_vm._s(absence.title) + " -\n            " + _vm._s(absence.timeFormatted) + "\n          ")])
	      }), _vm._v(" "), (user.events.length < 1) ? _c('p', {
	        staticClass: "text-explainer marg-1-top"
	      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_lessons_effected']))]) : _vm._e(), _vm._v(" "), (user.events.length > 0) ? _c('table', {
	        staticClass: "d-table"
	      }, [_c('thead', [_c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['course']))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['grade']))]), _vm._v(" "), (_vm.isShowRooms) ? _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['room']))]) : _vm._e(), _vm._v(" "), _c('th', {
	        class: {
	          'd-table__subs-for': !_vm.isShowRooms
	        }
	      }, [(!_vm.isSubsToday) ? [_vm._v(_vm._s(_vm.i18n[_vm.locale]['sub']))] : [_vm._v(_vm._s(_vm.i18n[_vm.locale]['sub_for']))]], 2)]), _vm._v(" "), _c('tbody', _vm._l((user.events), function(event) {
	        return _c('tr', {
	          key: event.id,
	          class: {
	            'subs-today__event--canceled': event.canceled
	          }
	        }, [_c('td', [(event.canceled) ? _c('div', {
	          staticClass: "subs-today__event-canceled-label"
	        }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['canceled']))]) : _vm._e(), _vm._v(" "), _c('div', {
	          staticClass: "subs-today__event-title"
	        }, [_vm._v(_vm._s(event.title))]), _vm._v(" "), _c('span', {
	          staticClass: "subs-today__event-time"
	        }, [_vm._v(_vm._s(event.timeFormatted))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(event.grades))]), _vm._v(" "), (_vm.isShowRooms) ? _c('td', [_vm._v(_vm._s(event.rooms))]) : _vm._e(), _vm._v(" "), _c('td', [(!_vm.isSubsToday) ? [_vm._v(_vm._s(event.substitute))] : [_vm._v(_vm._s(event.substitute_for))]], 2)])
	      }), 0)]) : _vm._e()], 2)
	    }), 0) : _vm._e()
	  }), _vm._v(" "), (_vm.isSlider) ? _c('div', {
	    staticClass: "users-today__slider-pager marg-2-top"
	  }, [_c('p', [_vm._v(_vm._s(_vm.theSliderIndex + 1) + " / " + _vm._s(_vm.userInRows.length))]), _vm._v(" "), (_vm.userInRows.length > 1) ? _c('div', {
	    staticClass: "d-progress"
	  }, [_c('div', {
	    staticClass: "d-progress__bar",
	    style: ({
	      'width': _vm.animatePercentage
	    })
	  })]) : _vm._e()]) : _vm._e()], 2)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1761 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container"
	  }, [_c('div', {
	    staticClass: "d-guides"
	  }, [_c('StilGuides', {
	    attrs: {
	      "video-id": '5Id4TeuHMvI',
	      "textForLink": "Guide: Se videoguide for kompetenceindberetning i Docendo"
	    }
	  }), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-filters"
	  }, [_c('div', {
	    staticClass: "d-filters__filter",
	    class: {
	      'd-filters__filter--active': _vm.activeUserFilter === 0
	    },
	    on: {
	      "click": function($event) {
	        _vm.activeUserFilter = 0
	      }
	    }
	  }, [_vm._v("Indberettes\n      "), _c('div', {
	    staticClass: "d-pill"
	  }, [_vm._v(_vm._s(_vm.filledUsers.length))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-filters__filter",
	    class: {
	      'd-filters__filter--active': _vm.activeUserFilter === 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.activeUserFilter = 1
	      }
	    }
	  }, [_vm._v("Indberettes ikke\n      "), _c('div', {
	    staticClass: "d-pill"
	  }, [_vm._v(_vm._s(_vm.unfilledUsers.length))])])]), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "d-table__sorter d-table__name",
	    class: {
	      'd-table__sorter--active': _vm.sortProperty === 'name'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortProperty('name')
	      }
	    }
	  }, [_vm._v("Navn "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "d-table__sorter",
	    class: {
	      'd-table__sorter--active': _vm.sortProperty === 'v_stil_stilling'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortProperty('v_stil_stilling')
	      }
	    }
	  }, [_vm._v("Stilling "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', [_vm._v("CPR")]), _vm._v(" "), _c('th', [_vm._v("Kompetencer: (L: Linjefag, K: Tilsvarende kompetencer)")])])]), _vm._v(" "), _c('tbody', [(_vm.filteredUsersWithVProps.length < 1) ? _c('tr', [_vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedUsers), function(user, userIdx) {
	    return _c('tr', {
	      key: user.id
	    }, [_c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_stilling),
	        expression: "user.v_stil_stilling"
	      }],
	      staticClass: "timetal-select",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(user, "v_stil_stilling", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, function($event) {
	          return _vm.updateUser(user, 'stil_stilling', $event.target.value)
	        }]
	      }
	    }, [_c('option', {
	      attrs: {
	        "value": "LA"
	      }
	    }, [_vm._v("Lærer")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "BH"
	      }
	    }, [_vm._v("Børnehaveklasseleder")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "PA"
	      }
	    }, [_vm._v("Pædagog")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "LE"
	      }
	    }, [_vm._v("Leder")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "AN"
	      }
	    }, [_vm._v("Andre med undervisningsopgaver")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "KO"
	      }
	    }, [_vm._v("Konsulenter")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "undtaget"
	      }
	    }, [_vm._v("Ingen undervisningsopgaver (ikke indberet)")])])]), _vm._v(" "), _c('td', [_c('input', {
	      staticStyle: {
	        "width": "110px"
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": user.v_ssn
	      },
	      on: {
	        "keydown": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	          return _vm.updateUser(user, 'ssn', $event.target.value, true)
	        },
	        "blur": function($event) {
	          return _vm.updateUser(user, 'ssn', $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('div', {
	      staticStyle: {
	        "width": "400px"
	      },
	      on: {
	        "click": function($event) {
	          _vm.theEditUserId = user.id
	        }
	      }
	    }, [(user.v_isTheEditUser) ? _c('DSelect', {
	      attrs: {
	        "show": true,
	        "items": _vm.standardSubjectsWithVProps,
	        "itemsSelected": user.v_competencies,
	        "placeholder": "Tilføj kompetence"
	      },
	      on: {
	        "close": function($event) {
	          _vm.theEditUserId = null
	        },
	        "update": function($event) {
	          return _vm.updateSubjectOnUser($event, user)
	        }
	      }
	    }) : _c('ul', {
	      staticClass: "linjefag linjefag--not-empty",
	      staticStyle: {
	        "width": "400px"
	      }
	    }, [(user.v_competencies.length === 0) ? _c('li', {
	      staticClass: "linjefag__add"
	    }, [_vm._v("\n              Tilføj op til seks kompetencer\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((user.v_competencies), function(subject) {
	      return _c('li', {
	        staticClass: "d-pill"
	      }, [_vm._v("\n              " + _vm._s(subject.name) + "\n            ")])
	    })], 2)], 1)])])
	  })], 2)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-explainer"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://statistik.uni-c.dk/linjefag/Dokumentation/Generelvejledning2026.pdf",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n        Link til STIL's egen vejledning")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Linjefag (L):")]), _vm._v(" At have undervisningskompetence i et fag betyder, at underviseren har haft det\n        pågældende fag som linjefag på læreruddannelsen eller som ekstra linjefag på et senere tidspunkt.")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Tilsvarende kompetence (K):")]), _vm._v(" At have kompetence svarende til undervisningskompetence betyder, at\n        underviseren for eksempel har en efteruddannelse, videreuddannelse, kompetencegivende uddannelse eller et\n        længerevarende kursusforløb, der vurderes at give kompetence svarende til undervisningskompetence.")]), _vm._v(" "), _c('p', [_vm._v("Skolens leder må foretage et skøn i denne forbindelse. En underviser kan samlet set maks. have\n        kompetencer (undervisningskompetence og tilsvarende\n        kompetence) i seks fag")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Ikke indberet person:")]), _vm._v(" Personale der ikke skal indberettes sættes til stillingen \"Ingen\n        undervisningsopgaver (ikke indberet)\"")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen skal ikke indberetes")])])
	}]}

/***/ }),
/* 1762 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "user-table-container"
	  }, [_c('table', {
	    staticClass: "user-table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "th-sorter name",
	    class: {
	      active: _vm.sortKey === 'name'
	    },
	    attrs: {
	      "rowspan": "3"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('name')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.name')) + "\n          "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]), _vm._v(" "), _c('th', {
	    staticClass: "working-hours",
	    attrs: {
	      "colspan": _vm.numberOfCols
	    }
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.work_hours')))])]), _vm._v(" "), (_vm.isShowRestColumnFinal) ? _c('th', {
	    staticClass: "rest-hours",
	    attrs: {
	      "colspan": "1"
	    }
	  }, [_vm._v("Rest")]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "teaching-hours",
	    attrs: {
	      "colspan": _vm.numberOfCols
	    }
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.teaching')))])]), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? _c('th', {
	    staticClass: "task-hours",
	    attrs: {
	      "colspan": _vm.numberOfCols
	    }
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.tasks')))])]) : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? _c('th', {
	    staticClass: "prep-hours",
	    attrs: {
	      "colspan": _vm.numberOfCols
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.assign_users_hours.preparation')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isLocalPoolActivated) ? _c('th', {
	    staticClass: "prep-hours",
	    attrs: {
	      "colspan": _vm.numberOfCols
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.localPoolTitle) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "absence-hours",
	    attrs: {
	      "colspan": "1"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.absence')))]), _vm._v(" "), _c('th', {
	    staticClass: "sub-hours",
	    attrs: {
	      "colspan": _vm.numberOfCols
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.substitute_hours')))]), _vm._v(" "), (_vm.isSFOActive) ? _c('th', {
	    staticClass: "club-hours",
	    attrs: {
	      "colspan": _vm.numberOfCols
	    }
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.club')))])]) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.viewSettings.show_assigned.active) ? _c('th', {
	    staticClass: "th-sorter assigned_total_hours",
	    class: {
	      active: _vm.sortKey === 'assigned_total_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('assigned_total_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')) + "\n          "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter actual_total_hours",
	    class: {
	      active: _vm.sortKey === 'actual_total_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('actual_total_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n          "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('th', {
	    staticClass: "th-sorter diff_total_hours",
	    class: {
	      active: _vm.sortKey === 'diff_total_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('diff_total_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')) + "\n          "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]) : _vm._e(), _vm._v(" "), (_vm.isShowRestColumnFinal) ? _c('th', {
	    staticClass: "th-sorter rest_hours",
	    class: {
	      active: _vm.sortKey === 'rest_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('rest_hours')
	      }
	    }
	  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('th', {
	    staticClass: "th-sorter assigned_teaching_hours",
	    class: {
	      active: _vm.sortKey === 'assigned_teaching_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('assigned_teaching_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')) + "\n          "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter actual_teaching_hours",
	    class: {
	      active: _vm.sortKey === 'actual_teaching_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('actual_teaching_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n          "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('th', {
	    staticClass: "th-sorter diff_teaching_hours",
	    class: {
	      active: _vm.sortKey === 'diff_teaching_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('diff_teaching_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')) + "\n          "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]) : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? [(_vm.viewSettings.show_assigned.active) ? _c('th', {
	    staticClass: "th-sorter assigned_additional_task_hours",
	    class: {
	      active: _vm.sortKey === 'assigned_additional_task_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('assigned_additional_task_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')) + "\n            "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter actual_additional_task_hours",
	    class: {
	      active: _vm.sortKey === 'actual_additional_task_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('actual_additional_task_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n            "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('th', {
	    staticClass: "th-sorter diff_additional_task_hours",
	    class: {
	      active: _vm.sortKey === 'diff_additional_task_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('diff_additional_task_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')) + "\n            "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? [(_vm.viewSettings.show_assigned.active) ? _c('th', {
	    staticClass: "th-sorter assigned_preparation_hours",
	    class: {
	      active: _vm.sortKey === 'assigned_preparation_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('assigned_preparation_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')) + "\n            "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter actual_preparation_hours",
	    class: {
	      active: _vm.sortKey === 'actual_preparation_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('actual_preparation_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n            "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('th', {
	    staticClass: "th-sorter diff_preparation_hours",
	    class: {
	      active: _vm.sortKey === 'diff_preparation_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('diff_preparation_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')) + "\n            "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isLocalPoolActivated) ? [(_vm.viewSettings.show_assigned.active) ? _c('th', {
	    staticClass: "th-sorter assigned_pool_hours",
	    class: {
	      active: _vm.sortKey === 'assigned_pool_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('assigned_pool_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')) + "\n            "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter actual_pool_hours",
	    class: {
	      active: _vm.sortKey === 'actual_pool_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('actual_pool_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n            "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('th', {
	    staticClass: "th-sorter diff_pool_hours",
	    class: {
	      active: _vm.sortKey === 'diff_pool_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('diff_pool_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')) + "\n            "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter actual_absence_hours",
	    class: {
	      active: _vm.sortKey === 'actual_absence_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('actual_absence_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n          "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('th', {
	    staticClass: "th-sorter substitute_pool_hours",
	    class: {
	      active: _vm.sortKey === 'substitute_pool_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('substitute_pool_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')) + "\n          "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter actual_substitute_hours",
	    class: {
	      active: _vm.sortKey === 'actual_substitute_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('actual_substitute_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n          "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('th', {
	    staticClass: "th-sorter diff_substitute_hours",
	    class: {
	      active: _vm.sortKey === 'diff_substitute_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('diff_substitute_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')) + "\n          "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]) : _vm._e(), _vm._v(" "), (_vm.isSFOActive) ? [(_vm.viewSettings.show_assigned.active) ? _c('th', {
	    staticClass: "th-sorter assigned_club_hours",
	    class: {
	      active: _vm.sortKey === 'assigned_club_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('assigned_club_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')) + "\n            "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter actual_club_hours",
	    class: {
	      active: _vm.sortKey === 'actual_club_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('actual_club_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n            "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('th', {
	    staticClass: "th-sorter diff_club_hours",
	    class: {
	      active: _vm.sortKey === 'diff_club_hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('diff_club_hours')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')) + "\n            "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]) : _vm._e()] : _vm._e()], 2)]), _vm._v(" "), _c('tbody', {
	    staticClass: "user-table__body"
	  }, _vm._l((_vm.filteredData), function(user) {
	    return _c('tr', {
	      key: user.id,
	      staticClass: "tr-user",
	      class: {
	        'tr-user--cant-edit': !_vm.theUserCanManageAssignedHours || (_vm.isPoolsDeactivated && !_vm.isAssignedPoolFromNormWhenPoolsDeactivated)
	      }
	    }, [_c('th', {
	      staticClass: "tr-user__name"
	    }, [_c('div', {
	      staticClass: "tr-user__name__inner"
	    }, [_c('p', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('div', {
	      staticClass: "tr-user__name__bttn icon__bg-circle hint--right",
	      attrs: {
	        "aria-label": _vm.$t('vue2.task_overview.task_and_hour_overview')
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheUserToShowTasksFor(user)
	        }
	      }
	    }, [_c('svg', {
	      staticClass: "icon-chart tw-icon tw-icon--small",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24"
	      }
	    }, [_c('path', {
	      staticClass: "primary",
	      attrs: {
	        "d": "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm11 4a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z"
	      }
	    }), _vm._v(" "), _c('path', {
	      staticClass: "secondary",
	      attrs: {
	        "d": "M8 11a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm4-2a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z"
	      }
	    })])])])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !_vm.isDatesPristine; }
	        }),
	        expression: "{\n                  arrow: true,\n                  animateFill: false,\n                  animation : 'shift-away',\n                  zIndex: '999999992',\n                  boundary: 'window',\n                  onShow: () => !isDatesPristine\n                }"
	      }],
	      staticClass: "number number_edit td-presence",
	      class: {
	        'is-number--calculated': !_vm.isDatesPristine
	      },
	      attrs: {
	        "content": _vm.createTooltip(user.assigned_total_hours)
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.openEditFromRow(user, user.assigned_total_hours, 'assigned_total_hours', $event)
	        }
	      }
	    }, [(!_vm.isDatesPristine) ? _c('span', {
	      staticClass: "icon-clock"
	    }) : _vm._e(), _vm._v("\n        " + _vm._s(user.v_total_hours_assigned_in_period) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          placement: 'right',
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return user.vIsPedagogog === true; }
	        }),
	        expression: "{\n                  placement: 'right',\n                  arrow: true,\n                  animateFill: false,\n                  animation : 'shift-away',\n                  zIndex: '999999992',\n                  boundary: 'window',\n                  onShow: () => user.vIsPedagogog === true\n                }"
	      }],
	      staticClass: "number td-presence",
	      class: {
	        'td-presence--pedagog': user.vIsPedagogog
	      },
	      attrs: {
	        "aria-label": user.actual_total_hours,
	        "content": "For pædagoger tælles arbejdstid som summen af alle skemalagte timer i kalenderen – uanset om de er sat som undervisning, SFO, vikar eller andre opgaver."
	      }
	    }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	      staticClass: "number td-presence number__scale-indicator",
	      style: (_vm.scaleIndicator(user.diff_total_hours)),
	      attrs: {
	        "aria-label": user.diff_total_hours
	      }
	    }) : _vm._e(), _vm._v(" "), (_vm.isShowRestColumnFinal) ? _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          content: ("<div>\n                    <div class='do-flex-labels'>Arbejdstid: <span>" + (user.assigned_total_hours) + "</span></div>\n                    <div class='do-flex-labels'>Tildelte timer: <span>" + (user.sum_hours) + "</span></div>\n                  </div>"),
	          allowHTML: true,
	          arrow: true,
	          placement: 'left'
	        }),
	        expression: "{\n        content: `<div>\n                    <div class='do-flex-labels'>Arbejdstid: <span>${user.assigned_total_hours}</span></div>\n                    <div class='do-flex-labels'>Tildelte timer: <span>${user.sum_hours}</span></div>\n                  </div>`,\n        allowHTML: true,\n        arrow: true,\n        placement: 'left'\n      }"
	      }],
	      staticClass: "number pointer td-rest number__scale-indicator",
	      style: (_vm.scaleIndicator(user.rest_hours)),
	      attrs: {
	        "aria-label": user.rest_hours
	      }
	    }) : _vm._e(), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	      staticClass: "number number_edit td-teaching",
	      attrs: {
	        "aria-label": user.assigned_teaching_hours
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.openEditFromRow(user, user.assigned_teaching_hours, 'assigned_teaching_hours', $event)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "number td-teaching",
	      attrs: {
	        "aria-label": user.actual_teaching_hours
	      }
	    }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	      staticClass: "number number__scale-indicator td-teaching",
	      style: (_vm.scaleIndicator(user.diff_teaching_hours)),
	      attrs: {
	        "aria-label": user.diff_teaching_hours
	      }
	    }) : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? [(_vm.viewSettings.show_assigned.active) ? _c('td', {
	      staticClass: "number number_edit td-tasks",
	      attrs: {
	        "aria-label": user.assigned_additional_task_hours
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.openEditFromRow(user, user.assigned_additional_task_hours, 'assigned_additional_task_hours', $event)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "number td-tasks",
	      attrs: {
	        "aria-label": user.actual_additional_task_hours
	      }
	    }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	      staticClass: "number number__scale-indicator td-tasks",
	      style: (_vm.scaleIndicator(user.diff_additional_task_hours)),
	      attrs: {
	        "aria-label": user.diff_additional_task_hours
	      }
	    }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? [(_vm.viewSettings.show_assigned.active) ? _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          content: _vm.getPrepFactorTooltipContent(user),
	          arrow: true,
	          placement: 'top',
	          onShow: function () { return _vm.isShowPrepFactorCalculation; }
	        }),
	        expression: "{\n        content: getPrepFactorTooltipContent(user),\n        arrow: true,\n        placement: 'top',\n        onShow: () => isShowPrepFactorCalculation\n      }"
	      }],
	      staticClass: "number number_edit td-preparation",
	      attrs: {
	        "aria-label": user.assigned_preparation_hours
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.openEditFromRow(user, user.assigned_preparation_hours, 'assigned_preparation_hours', $event)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "number td-preparation",
	      attrs: {
	        "aria-label": user.actual_preparation_hours
	      }
	    }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	      staticClass: "number number__scale-indicator td-preparation",
	      style: (_vm.scaleIndicator(user.diff_preparation_hours)),
	      attrs: {
	        "aria-label": user.diff_preparation_hours
	      }
	    }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isLocalPoolActivated) ? [(_vm.viewSettings.show_assigned.active) ? _c('td', {
	      staticClass: "number number_edit td-preparation",
	      attrs: {
	        "aria-label": user.assigned_pool_hours
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.openEditFromRow(user, user.assigned_pool_hours, 'assigned_pool_hours', $event)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "number td-preparation",
	      attrs: {
	        "aria-label": user.actual_pool_hours
	      }
	    }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	      staticClass: "number number__scale-indicator td-preparation",
	      style: (_vm.scaleIndicator(user.diff_pool_hours)),
	      attrs: {
	        "aria-label": user.diff_pool_hours
	      }
	    }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "number pointer td-absence",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setActiveUserFor(user, 'absence')
	        }
	      }
	    }, [_c('div', {
	      staticClass: "tr-user__text"
	    }, [_vm._v("\n          " + _vm._s(user.actual_absence_hours) + "\n        ")])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	      staticClass: "number number_edit td-sub-hours",
	      attrs: {
	        "aria-label": user.substitute_pool_hours
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.openEditFromRow(user, user.substitute_pool_hours, 'substitute_pool_hours', $event)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "number pointer td-sub-hours",
	      attrs: {
	        "aria-label": user.actual_substitute_hours
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setActiveUserFor(user, 'substituteHours')
	        }
	      }
	    }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	      staticClass: "number number__scale-indicator td-sub-hours",
	      style: (_vm.scaleIndicator(user.diff_substitute_hours)),
	      attrs: {
	        "aria-label": user.diff_substitute_hours
	      }
	    }) : _vm._e(), _vm._v(" "), (_vm.isSFOActive) ? [(_vm.viewSettings.show_assigned.active) ? _c('td', {
	      staticClass: "number number_edit td-club",
	      attrs: {
	        "aria-label": user.assigned_club_hours
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.openEditFromRow(user, user.assigned_club_hours, 'assigned_club_hours', $event)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "number td-club",
	      attrs: {
	        "aria-label": user.actual_club_hours
	      }
	    }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	      staticClass: "number number__scale-indicator td-club",
	      style: (_vm.scaleIndicator(user.diff_club_hours)),
	      attrs: {
	        "aria-label": user.diff_club_hours
	      }
	    }) : _vm._e()] : _vm._e()], 2)
	  }), 0)]), _vm._v(" "), (_vm.theEditNumberUserId) ? _c('div', {
	    ref: "popper_child",
	    staticClass: "popper_child"
	  }, [_c('transition', {
	    attrs: {
	      "name": "scale"
	    }
	  }, [(_vm.isDropdownPopperDone) ? _c('div', {
	    staticClass: "number__input-opened"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.theEditNumberNumber),
	      expression: "theEditNumberNumber",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "focus",
	      rawName: "v-focus"
	    }, {
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeEditing),
	      expression: "closeEditing"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.theEditNumberNumber)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.doneEditing.apply(null, arguments)
	      },
	      "change": function($event) {
	        _vm.theEditNumberNumber = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn--primary",
	    class: {
	      'bttn--small--loading': _vm.isUpdatingNumber
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.doneEditing.apply(null, arguments)
	      }
	    }
	  }, [(!_vm.isUpdatingNumber) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.common.save')))]) : _vm._e()])]) : _vm._e()])], 1) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column-width"
	  }, [_vm._v("Rest\n          "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])
	}]}

/***/ }),
/* 1763 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "students text-dark"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isShowModal = true
	      }
	    }
	  }, [_vm._v(" " + _vm._s(_vm.isEditSubject) + " " + _vm._s(_vm.studentCalendarIds.length) + " " + _vm._s(_vm.$t('vue2.students.of')) + " " + _vm._s(_vm.klassStudents.length) + " " + _vm._s(_vm.$t('vue2.students.students')) + "\n  ")]), _vm._v(" "), (_vm.isShowModal) ? _c('DModal', {
	    attrs: {
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal__students",
	    staticStyle: {
	      "width": "400px"
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.studentsSelected.length) + " " + _vm._s(_vm.$t('vue2.students.of')) + " " + _vm._s(_vm.klassStudents.length) + "\n          " + _vm._s(_vm.$t('vue2.students.students_in')) + " 1.a")]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": _vm.closeStudentModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-modal__content__add-student"
	  }, [_c('transition-group'), _vm._v(" "), (!_vm.isAddStudentFromAnotherGroup) ? _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": function($event) {
	        _vm.isAddStudentFromAnotherGroup = true
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.students.add_student')))]) : _c('DSelect', {
	    staticClass: "marg-1-bottom",
	    attrs: {
	      "items": _vm.studentsFromOtherGroups,
	      "itemsSelected": [],
	      "placeholder": _vm.$t('vue2.students.add_student'),
	      "showSelectedUsers": false
	    },
	    on: {
	      "add": function($event) {
	        return _vm.addStudentToSubject($event)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "students__student__header border-1-bottom border-1-top"
	  }, [_c('p', {
	    on: {
	      "click": _vm.selectAll
	    }
	  }, [(_vm.studentsSelected.length === _vm.klassStudents.length) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.unselect_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.select_all')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "border-1-bottom"
	  }, [_c('ul', {
	    staticClass: "students students__list"
	  }, _vm._l((_vm.studentsSorted), function(student) {
	    return _c('li', {
	      staticClass: "students__student",
	      on: {
	        "click": function($event) {
	          return _vm.toggleInStudentsSelected(student.id)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "students__student__name"
	    }, [_c('div', {
	      staticClass: "d-checkbox",
	      class: {
	        'd-checkbox--active': _vm.isInStudentsSelected(student.id)
	      }
	    }), _vm._v(" "), _c('div', [_vm._v("\n                  " + _vm._s(student.name) + "\n                ")])]), _vm._v(" "), _c('div', {
	      staticClass: "student__grade"
	    }, _vm._l((_vm.getStudentKlasses(student)), function(klass, key) {
	      return _c('span', [(key > 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(" " + _vm._s(klass.name))])
	    }), 0)])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "bttn bttn-simple marg-1-right",
	    on: {
	      "click": _vm.closeStudentModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1764 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-button__multiple no-print"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212,
	      }),
	      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212,\n             }"
	    }],
	    staticClass: "do-button__multiple__bttn icon-arrow-left4 no-print",
	    attrs: {
	      "content": _vm.tooltipArrowLeft
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('prev')
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "no-print do-button__multiple__bttn",
	    class: {
	      'bttn--disabled': _vm.isToday
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('today')
	      }
	    }
	  }, [_vm._v("\n    I dag\n  ")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212,
	      }),
	      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212,\n             }"
	    }],
	    staticClass: "do-button__multiple__bttn icon-arrow-right4",
	    attrs: {
	      "content": _vm.tooltipArrowRight
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('next')
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1765 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-cal__subjects no-print",
	    class: {
	      'd-cal__subjects--dragging': _vm.isDraggingSubject
	    },
	    on: {
	      "pointerenter": _vm.onMouseEnter,
	      "pointerleave": _vm.onMouseLeave
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "fadeIn"
	    }
	  }, [(_vm.deleteSubject) ? _c('div', {
	    staticClass: "d-cal__subjects--trashcan",
	    class: {
	      'd-cal__subjects--trashcan--hovered': _vm.isDCalATrashcan
	    }
	  }, [_c('div', {
	    staticClass: "icon-bin"
	  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue2.common.delete')) + " " + _vm._s(_vm.deleteSubject.title))])]) : _vm._e()]), _vm._v(" "), _c('CreateSubject', {
	    attrs: {
	      "calendarId": _vm.calendarId,
	      "isInDCalendar": true
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "d-cal__subjects__container"
	  }, [(_vm.isShowImportSubjectsOption) ? _c('ImportSubjectsToKlass', {
	    attrs: {
	      "calendarId": _vm.calendarId
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isSubjectsLoading) ? _c('Loader', {
	    staticClass: "d-cal__subjects__container__loader",
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "d-acc"
	  }, _vm._l((_vm.subjectsInCategoriesSorted), function(subjectsCat) {
	    return _c('li', {
	      key: subjectsCat.type,
	      staticClass: "d-acc__container",
	      class: {
	        'd-acc__container--closed': _vm.theActiveAcc !== subjectsCat.type
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setTheActiveAcc(subjectsCat.type)
	        }
	      }
	    }, [_c('h4', [_vm._v(_vm._s(subjectsCat.v_title))]), _vm._v(" "), _c('transition', {
	      attrs: {
	        "name": "accordion"
	      },
	      on: {
	        "enter": _vm.startTrans,
	        "after-enter": _vm.endTrans,
	        "before-leave": _vm.startTrans,
	        "after-leave": _vm.endTrans
	      }
	    }, [(_vm.theActiveAcc === subjectsCat.type) ? _c('div', [_c('transition-group', {
	      staticClass: "d-acc__container__body",
	      attrs: {
	        "name": "list-complete",
	        "tag": "ul"
	      }
	    }, _vm._l((_vm.activeSubjects), function(subject) {
	      return _c('li', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: (_vm.tippySettings(subject)),
	          expression: "tippySettings(subject)"
	        }],
	        key: subject.id,
	        staticClass: "list-complete-item d-cal__subjects__subject",
	        class: {
	          'd-cal__subjects__subject--not-editable': !subject.v_is_editable
	        },
	        style: ([{
	            'borderColor': subject.color
	          },
	          {
	            'backgroundColor': subject.color
	          }
	        ]),
	        attrs: {
	          "subject": subject,
	          "content": _vm.tippyContent(subject),
	          "draggable": "false"
	        },
	        on: {
	          "dragstart": function($event) {
	            $event.preventDefault();
	          },
	          "click": function($event) {
	            $event.preventDefault();
	            $event.stopPropagation();
	          },
	          "pointerdown": function($event) {
	            $event.preventDefault();
	            return _vm.onMouseDown(subject, $event)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "d-cal__subjects__subject__left"
	      }, [_vm._v("\n                  " + _vm._s(subject.title) + "\n                ")]), _vm._v(" "), _c('div', {
	        staticClass: "d-cal__subjects__subject__right"
	      }, [(subject.v_must_have_teacher && subject.v_cal_types.users.length < 1) ? _c('div', {
	        staticClass: "subject-draggable__slider"
	      }, [_c('div', {
	        staticClass: "d-cal__subjects__subject__subject_info"
	      }, [_vm._v("\n                      " + _vm._s(subject.v_hours) + _vm._s(_vm.i18n[_vm.locale]['hours_per_year']) + "\n                    ")]), _vm._v(" "), _c('div', {
	        staticClass: "d-cal__subjects__subject__remember-teacher"
	      }, [_c('span', {
	        staticClass: "icon-user3"
	      }), _vm._v(_vm._s(_vm.i18n[_vm.locale]['add']) + "\n                    ")])]) : _c('div', {
	        staticClass: "d-cal__subjects__subject__subject_info"
	      }, [(subject.v_hours) ? [_vm._v(_vm._s(subject.v_hours) + _vm._s(_vm.i18n[_vm.locale]['hours_per_year']) + "\n                    ")] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
	        staticClass: "subject__details"
	      }, [(subject.v_cal_types.rooms.length > 0) ? _c('span', {
	        staticClass: "icon-location"
	      }) : _vm._e(), _vm._v(" "), (subject.v_cal_types.users.length > 0) ? _c('span', {
	        staticClass: "icon-user"
	      }) : _vm._e()])])
	    }), 0)], 1) : _vm._e()])], 1)
	  }), 0)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1766 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sub-salary"
	  }, [_c('div', {
	    staticClass: "sub-salary__header"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "sub-salary__header__left"
	  }, [_vm._m(1), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--with-icon",
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowSalarySettings(true)
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "mr-2 h-4 w-4",
	    attrs: {
	      "width": "15",
	      "height": "15",
	      "viewBox": "0 0 15 15",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M5.5 3C4.67157 3 4 3.67157 4 4.5C4 5.32843 4.67157 6 5.5 6C6.32843 6 7 5.32843 7 4.5C7 3.67157 6.32843 3 5.5 3ZM3 5C3.01671 5 3.03323 4.99918 3.04952 4.99758C3.28022 6.1399 4.28967 7 5.5 7C6.71033 7 7.71978 6.1399 7.95048 4.99758C7.96677 4.99918 7.98329 5 8 5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H8C7.98329 4 7.96677 4.00082 7.95048 4.00242C7.71978 2.86009 6.71033 2 5.5 2C4.28967 2 3.28022 2.86009 3.04952 4.00242C3.03323 4.00082 3.01671 4 3 4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H3ZM11.9505 10.9976C11.7198 12.1399 10.7103 13 9.5 13C8.28967 13 7.28022 12.1399 7.04952 10.9976C7.03323 10.9992 7.01671 11 7 11H1.5C1.22386 11 1 10.7761 1 10.5C1 10.2239 1.22386 10 1.5 10H7C7.01671 10 7.03323 10.0008 7.04952 10.0024C7.28022 8.8601 8.28967 8 9.5 8C10.7103 8 11.7198 8.8601 11.9505 10.0024C11.9668 10.0008 11.9833 10 12 10H13.5C13.7761 10 14 10.2239 14 10.5C14 10.7761 13.7761 11 13.5 11H12C11.9833 11 11.9668 10.9992 11.9505 10.9976ZM8 10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5C11 11.3284 10.3284 12 9.5 12C8.67157 12 8 11.3284 8 10.5Z",
	      "fill": "currentColor",
	      "fill-rule": "evenodd",
	      "clip-rule": "evenodd"
	    }
	  })]), _vm._v("\n        Opsætning\n      ")]), _vm._v(" "), (_vm.isSchoolSelectorOn) ? _c('SchoolsSelector', {
	    attrs: {
	      "permission": _vm.permission,
	      "schools": _vm.userSchools,
	      "selectedSchoolIds": _vm.selectedSchoolIds
	    },
	    on: {
	      "toggleSchool": _vm.toggleSchool
	    }
	  }) : _vm._e(), _vm._v(" "), _c('DoDatePickerRange', {
	    attrs: {
	      "allowSameDate": true,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate,
	      "dateShortCutsProps": _vm.dateShortCuts,
	      "maximumDateRange": 89
	    },
	    on: {
	      "startChanged": _vm.startDateChanged,
	      "endChanged": _vm.endDateChanged,
	      "datesChanged": _vm.datesChanged
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "sub-salary__sub-header"
	  }, [_c('SalaryFilters', {
	    attrs: {
	      "activeFilter": _vm.activeFilter,
	      "userDaysSorted": _vm.userDaysSorted,
	      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive
	    },
	    on: {
	      "change": function($event) {
	        return _vm.setFilter($event)
	      }
	    }
	  }), _vm._v(" "), (_vm.activeFilter === 'approved' && _vm.userDaysApproved.length > 0) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit text-dark no-print",
	    class: {
	      'do-bttn--loading': _vm.isBulkSending
	    },
	    attrs: {
	      "disabled": _vm.isBulkSending
	    },
	    on: {
	      "click": function($event) {
	        return _vm.openBulkSendConfirm()
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.bulkSendButtonLabel) + "\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "sub-salary__body"
	  }, [(_vm.isLoading) ? _c('Loader') : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.usersAndEventsFiltered.length < 1) ? _c('h2', {
	    staticClass: "text-explainer marg-1-top"
	  }, [(_vm.selectedSchoolIds.length > 0) ? [_vm._v("Ingen vikartimer i perioden")] : [_vm._v("Ingen skoler valgt")]], 2) : [_c('ul', {
	    staticClass: "user-list"
	  }, _vm._l((_vm.usersPackedInDaysWithProps), function(user) {
	    return _c('li', {
	      staticClass: "user-list__user"
	    }, [_c('div', {
	      staticClass: "user-list__user__header"
	    }, [_c('h4', [_vm._v(_vm._s(user.v_user_name) + "\n            ")]), _vm._v(" "), _c('div', {
	      staticClass: "user-list__user__header__right"
	    }, [_c('ul', _vm._l((user.v_user_sums), function(sum) {
	      return _c('li', {
	        key: sum.vId,
	        class: {
	          'user-list__user__footer__sums__sum--not-set': sum.employment_not_set
	        }
	      }, [_vm._v("\n                  " + _vm._s(sum.employment_title) + " " + _vm._s(sum.costCenter ? '[' + sum.costCenter + '] ' : '') + "\n                  "), _c('b', [_vm._v(_vm._s(sum.minutes_humanized))])])
	    }), 0), _vm._v(" "), _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
	      }],
	      staticClass: "do-bttn do-bttn--small no-print",
	      attrs: {
	        "content": "Se alle dage på personen"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveUserId(user.user_id)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-enlarge2"
	    })])])]), _vm._v(" "), _vm._l((user.days), function(userDay) {
	      return _c('table', {
	        key: userDay.day,
	        staticClass: "user-list__user__table",
	        class: {
	          'user-list__user__table--active': userDay.v_is_open
	        }
	      }, [_c('thead', {
	        on: {
	          "click": function($event) {
	            return _vm.setTheActiveUserDay(userDay)
	          }
	        }
	      }, [_c('tr', [_c('th', [_vm._v(_vm._s(userDay.v_date_formatted) + "\n                "), (userDay.error && Object.keys(userDay.error).length) ? _c('span', {
	        staticClass: "do-pill do-pill--yellow"
	      }, [_vm._v("\n                  Overførselsfejl\n                ")]) : _vm._e()]), _vm._v(" "), (userDay.v_is_open) ? _c('th', [_vm._v("Kalender")]) : _vm._e(), _vm._v(" "), (userDay.v_is_open) ? _c('th', [_vm._v("Type")]) : _vm._e(), _vm._v(" "), (userDay.v_is_open) ? _c('th', [_vm._v("Vikar for")]) : _vm._e(), _vm._v(" "), (userDay.v_is_open) ? _c('th', [_vm._v("Ansættelse")]) : _vm._e(), _vm._v(" "), (_vm.isSalaryIntegrationActive && userDay.v_is_open) ? _c('th', [_vm._v("Lønkode")]) : _vm._e(), _vm._v(" "), (_vm.costCenters.length > 0 && userDay.v_is_open) ? _c('th', [_vm._v("Omkostningssted")]) : _vm._e(), _vm._v(" "), (userDay.v_is_open) ? _c('th', {
	        staticClass: "no-print"
	      }) : _vm._e(), _vm._v(" "), _c('th', {
	        staticClass: "user-list__user__table__arrow"
	      }, [(userDay.v_unfilled) ? _c('svg', {
	        staticClass: "tw-icon tw-icon--red",
	        attrs: {
	          "viewBox": "0 0 24 24",
	          "fill": "none",
	          "stroke": "currentColor",
	          "stroke-width": "2",
	          "stroke-linecap": "round",
	          "stroke-linejoin": "round"
	        }
	      }, [_c('path', {
	        attrs: {
	          "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
	        }
	      }), _vm._v(" "), _c('line', {
	        attrs: {
	          "x1": "12",
	          "y1": "9",
	          "x2": "12",
	          "y2": "13"
	        }
	      }), _vm._v(" "), _c('line', {
	        attrs: {
	          "x1": "12",
	          "y1": "17",
	          "x2": "12.01",
	          "y2": "17"
	        }
	      })]) : _vm._e(), _vm._v(" "), (!userDay.v_is_open) ? _c('span', {
	        staticClass: "icon-arrow-up4"
	      }) : _c('span', {
	        staticClass: "icon-arrow-down4"
	      })])])]), _vm._v(" "), (userDay.v_is_open) ? [_c('SalarySubsPerfUserDay', {
	        attrs: {
	          "user": user,
	          "userDay": userDay,
	          "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive,
	          "salaryCodes": _vm.salaryCodes,
	          "costCenters": _vm.costCenters
	        },
	        on: {
	          "updatePropOnLesson": _vm.updatePropOnLesson
	        }
	      }), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
	        attrs: {
	          "colspan": _vm.isSalaryIntegrationActive ? 9 : _vm.costCenters.length > 0 ? 8 : 7
	        }
	      }, [_c('div', {
	        staticClass: "user-list__user__footer"
	      }, [_vm._l((_vm.parseUserErrors(userDay.error)), function(error, index) {
	        return (userDay.error) ? _c('span', {
	          key: index,
	          staticClass: "do-pill do-pill--yellow do-pill--with-icon"
	        }, [_c('svg', {
	          staticClass: "tw-icon tw-icon--yellow",
	          attrs: {
	            "viewBox": "0 0 24 24",
	            "fill": "none",
	            "stroke": "currentColor",
	            "stroke-width": "2",
	            "stroke-linecap": "round",
	            "stroke-linejoin": "round"
	          }
	        }, [_c('path', {
	          attrs: {
	            "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
	          }
	        }), _vm._v(" "), _c('line', {
	          attrs: {
	            "data-v-050a44fb": "",
	            "x1": "12",
	            "y1": "9",
	            "x2": "12",
	            "y2": "13"
	          }
	        }), _vm._v(" "), _c('line', {
	          attrs: {
	            "x1": "12",
	            "y1": "17",
	            "x2": "12.01",
	            "y2": "17"
	          }
	        })]), _vm._v("\n                      " + _vm._s(error) + "\n                    ")]) : _vm._e()
	      }), _vm._v(" "), _c('ul', {
	        staticClass: "user-list__user__footer__sums"
	      }, _vm._l((userDay.v_sums), function(sum) {
	        return _c('li', {
	          key: sum.vId,
	          class: {
	            'user-list__user__footer__sums__sum--not-set': sum.employment_not_set
	          }
	        }, [_vm._v("\n                        " + _vm._s(sum.employment_title) + " " + _vm._s(sum.costCenter ? '[' + sum.costCenter + ']: ' : '') + "\n                        "), _c('b', [_vm._v(_vm._s(sum.minutes_humanized))]), _vm._v(" "), _c('button', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              onShow: _vm.hideTippy,
	              trigger: 'manual',
	              arrow: true,
	              placement: 'top',
	              zIndex: 2147483010
	            }),
	            expression: "{\n                                  onShow: hideTippy,\n                                  trigger: 'manual',\n                                  arrow: true,\n                                  placement : 'top',\n                                  zIndex: 2147483010\n                                }"
	          }],
	          staticClass: "bttn bttn--white bttn--small do-copy-bttn",
	          attrs: {
	            "content": 'Kopieret ' + sum.minutes_to_copy
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              $event.preventDefault();
	              return _vm.copyToClipboard(sum.minutes_to_copy, $event)
	            }
	          }
	        }, [_c('svg', {
	          attrs: {
	            "xmlns": "http://www.w3.org/2000/svg",
	            "height": "48",
	            "viewBox": "0 0 48 48",
	            "width": "48"
	          }
	        }, [_c('path', {
	          attrs: {
	            "d": "M0 0h48v48h-48z",
	            "fill": "none"
	          }
	        }), _vm._v(" "), _c('path', {
	          attrs: {
	            "d": "M32 2h-24c-2.21 0-4 1.79-4 4v28h4v-28h24v-4zm6 8h-22c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h22c2.21 0 4-1.79 4-4v-28c0-2.21-1.79-4-4-4zm0 32h-22v-28h22v28z"
	          }
	        })])])])
	      }), 0), _vm._v(" "), (userDay.state === 'draft') ? [(_vm.getIsDayValidated(userDay)) ? _c('button', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: true,
	            animateFill: false,
	            animation: 'shift-away',
	            zIndex: '999999992',
	            boundary: 'window'
	          }),
	          expression: "{\n                          arrow: true,\n                          animateFill: false,\n                          animation : 'shift-away',\n                          zIndex: '999999992',\n                          boundary: 'window'\n                        }"
	        }],
	        staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled",
	        attrs: {
	          "content": _vm.validationTxt
	        }
	      }, [_vm._v("\n                        Godkend\n                      ")]) : _c('button', {
	        staticClass: "do-bttn do-bttn--submit",
	        class: {
	          'do-bttn--submit--loading': _vm.getIsSubmitting(userDay)
	        },
	        on: {
	          "click": function($event) {
	            return _vm.approveDay(userDay)
	          }
	        }
	      }, [_vm._v("Godkend\n                      ")])] : _vm._e(), _vm._v(" "), (userDay.state === 'approved') ? _c('div', {
	        staticClass: "submit-buttons"
	      }, [_c('button', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: true,
	            animateFill: false,
	            animation: 'shift-away',
	            zIndex: '999999992',
	            boundary: 'window'
	          }),
	          expression: "{\n                          arrow: true,\n                          animateFill: false,\n                          animation : 'shift-away',\n                          zIndex: '999999992',\n                          boundary: 'window'\n                        }"
	        }],
	        staticClass: "do-bttn do-bttn--danger",
	        class: {
	          'do-bttn--submit--loading': _vm.getIsSubmitting(userDay)
	        },
	        attrs: {
	          "content": 'Dagen vil blive genberegnet'
	        },
	        on: {
	          "click": function($event) {
	            return _vm.unApproveDay(userDay)
	          }
	        }
	      }, [_vm._v("\n                        Fortryd godkendelse\n                      ")]), _vm._v(" "), _c('button', {
	        staticClass: "do-bttn do-bttn--submit",
	        class: {
	          'do-bttn--submit--loading': _vm.getIsSubmitting(userDay)
	        },
	        on: {
	          "click": function($event) {
	            return _vm.changeStateIsSent(userDay)
	          }
	        }
	      }, [_vm._v("\n                        " + _vm._s(_vm.isSalaryIntegrationActive ? 'Send til lønsystem' : 'Er indberettet') + "\n                      ")])]) : _vm._e(), _vm._v(" "), (userDay.approved_at) ? _c('span', {
	        staticClass: "do-approved-by"
	      }, [_vm._v("\n                      " + _vm._s(userDay.v_approved) + "\n                    ")]) : _vm._e()], 2)])])])] : _vm._e()], 2)
	    })], 2)
	  }), 0)]], 2), _vm._v(" "), (_vm.activeUserId) ? _c('SalarySubsPerfUser', {
	    attrs: {
	      "activeUserId": _vm.activeUserId,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate,
	      "usersPackedInDaysWithProps": _vm.usersPackedInDaysWithProps,
	      "userDaysSorted": _vm.userDaysSorted,
	      "activeFilter": _vm.activeFilter,
	      "theUserDaySubmitting": _vm.theUserDaySubmitting,
	      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive,
	      "isOpusIntegrationActive": _vm.isOpusIntegrationActive,
	      "salaryCodes": _vm.salaryCodes,
	      "costCenters": _vm.costCenters,
	      "schoolId": _vm.schoolId,
	      "isBulkSending": _vm.isBulkSending
	    },
	    on: {
	      "updatePropOnLesson": _vm.updatePropOnLesson,
	      "setFilter": function($event) {
	        return _vm.setFilter($event)
	      },
	      "approveDay": function($event) {
	        return _vm.approveDay($event)
	      },
	      "unApproveDay": function($event) {
	        return _vm.unApproveDay($event)
	      },
	      "changeStateIsSent": function($event) {
	        return _vm.changeStateIsSent($event)
	      },
	      "bulkSendUserDays": _vm.openBulkSendConfirm,
	      "close": function($event) {
	        return _vm.setActiveUserId(null)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowSalarySettings) ? _c('SalarySettings', {
	    attrs: {
	      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive,
	      "isSDIntegrationActive": _vm.isSDIntegrationActive
	    },
	    on: {
	      "update": _vm.onUpdate,
	      "close": function($event) {
	        return _vm.setIsShowSalarySettings(false)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isConfirmBulkSend) ? _c('DModal', {
	    attrs: {
	      "showClose": false,
	      "isBgOverlay": true,
	      "isCloseOnEsc": !_vm.isBulkSending,
	      "isCloseOnBgClick": !_vm.isBulkSending,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": _vm.cancelBulkSend
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal--small text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.bulkSendButtonLabel))]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.cancelBulkSend
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('p', [_vm._v(_vm._s(_vm.bulkSendConfirmText))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1-right"
	  }, [_c('div', {
	    staticClass: "d-modal__buttons__child"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    attrs: {
	      "disabled": _vm.isBulkSending
	    },
	    on: {
	      "click": _vm.cancelBulkSend
	    }
	  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isBulkSending,
	      'do-bttn--submit--disabled': _vm.isBulkSending
	    },
	    attrs: {
	      "disabled": _vm.isBulkSending
	    },
	    on: {
	      "click": _vm.bulkSendApprovedDays
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.bulkSendButtonLabel) + "\n          ")])])])])]) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sub-salary__header__left"
	  }, [_c('h1', [_vm._v("Vikarløn")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "do-bttn do-bttn--with-icon",
	    attrs: {
	      "href": "https://app.docendo.dk/app#/helpdesk?article=285",
	      "target": "_blank"
	    }
	  }, [_c('span', {
	    staticClass: "icon-question3"
	  }), _vm._v("\n        Guide\n      ")])
	}]}

/***/ }),
/* 1767 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('svg', {
	    staticClass: "icon-logo-docendo",
	    attrs: {
	      "enable-background": "new 16.5 363.8 484.1 110.9",
	      "viewBox": "16.5 363.8 484.1 110.9",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "m118 473.3c-10.9 0-18.9-2.9-24.1-8.7-5.1-5.8-7.7-14.5-7.7-26.2 0-13.4 3.1-23.8 9.3-31.3 6.2-7.4 15.2-11.2 26.9-11.2 10.9 0 18.9 2.9 24.1 8.7 5.1 5.8 7.7 14.5 7.7 26.2 0 13.4-3.1 23.8-9.3 31.2-6.2 7.6-15.2 11.3-26.9 11.3zm2.9-10.1c5.7 0 9.9-2.2 12.4-6.5 2.6-4.3 3.8-11 3.8-20 0-10.4-1.3-18-4-23.1-2.6-5-7.2-7.5-13.6-7.5-5.7 0-9.9 2.2-12.4 6.5-2.6 4.3-3.8 11-3.8 20.1 0 10.3 1.3 18 4 23 2.6 5 7.1 7.5 13.6 7.5zm71.7 10.7c-12.4 0-21.2-2.6-26.4-7.8s-7.8-14.1-7.8-26.7c0-13.9 3.3-24.5 9.9-31.9 6.6-7.3 16.6-11 30.1-11 6.6 0 11.4.6 14.3 1.8 3 1.2 4.5 3.1 4.5 5.5 0 3-1.1 5.9-3.2 8.6-7.5-3.9-14-5.9-19.3-5.9-7 0-11.9 2.2-14.9 6.7-2.9 4.4-4.4 11.4-4.4 20.9 0 9.8 1.4 17.1 4.3 22.1s8.1 7.4 15.7 7.4c5.8 0 12.5-1.9 20.1-5.8 1.7 2.3 2.5 4.7 2.5 7.1 0 2.9-2.6 5.1-7.8 6.6-5.2 1.6-11.1 2.4-17.6 2.4zm61.2-77.7c9.3 0 16.3 2.2 20.8 6.6s6.8 11.7 6.8 21.9c0 4.5-.8 7.6-2.4 9.3-1.6 1.8-5.1 2.6-10.6 2.6h-33.3c.1 8.2 1.7 14.6 4.9 19.3s8.8 7 16.9 7c7.5 0 14.6-2 21-5.9 2.2 2.2 3.2 4.4 3.2 6.9 0 3.4-2.8 5.7-8.3 7.1-5.6 1.4-11.8 2-18.8 2-12.9 0-22.1-2.7-27.7-8.2s-8.4-14.6-8.4-27.6c0-12.7 3.2-22.8 9.5-30.1 6.4-7.2 15.1-10.9 26.4-10.9zm-2.9 10.1c-5 0-8.8 1.8-11.5 5.4-2.6 3.6-4 9.2-4.3 16.9h7.8c8.2 0 13.9-.2 16.9-.5s4.7-.9 5.2-1.6c.5-.8.7-2.2.7-4.2 0-5-1.3-8.9-3.8-11.7-2.5-2.9-6.1-4.3-11-4.3zm56.5.9c5-3.3 9.9-5.8 14.7-7.3 4.9-1.6 9.2-2.3 13-2.3 6.7 0 11.7 1.5 15.1 4.6s5.1 9 5.1 17.7c0 27 .4 41.4 1.2 43s2.6 2.4 5.4 2.3c.6 1.5.8 2.9.8 4.4 0 1.4-.4 2.3-1.3 2.7-.9.5-2.4.7-4.8.7-7 0-11.3-.1-12.8-.3-1.6-.2-2.6-.7-3.2-1.6s-.8-2.3-.8-4.4v-32.5c0-10.4-1.1-17.2-3.3-20.7-2.2-3.4-5.7-5.1-10.6-5.1-4.2 0-7.8 1.2-10.8 3.5s-4.6 6.6-4.6 12.7v15.9c0 8.9.2 17.1.5 24.6h8.4c.6 1.3.9 2.7.9 4.2 0 1.4-.3 2.3-.8 2.8-.6.5-1.6.8-3.2.8h-29.6c-.7-1.6-1-3.1-1-4.5 0-1.1.3-1.9.8-2.5.6-.5 1.5-.8 2.7-.8h5.2c.4-8 .6-17.8.6-29.4 0-14.8-.6-23.4-1.7-25.8-1.2-2.4-3.4-3.5-6.6-3.5-.7-1.4-1-2.9-1-4.4 0-1.4.5-2.2 1.6-2.6s7.7-.8 20-1.2c.4 2.4.4 5.3.1 9zm156.5 66.7c-10.9 0-18.9-2.9-24.1-8.7-5.1-5.8-7.7-14.5-7.7-26.2 0-13.4 3.1-23.8 9.3-31.3 6.2-7.4 15.2-11.2 26.9-11.2 10.9 0 18.9 2.9 24.1 8.7 5.1 5.8 7.7 14.5 7.7 26.2 0 13.4-3.1 23.8-9.3 31.2-6.2 7.5-15.2 11.3-26.9 11.3zm2.9-10.2c5.7 0 9.9-2.2 12.4-6.5 2.6-4.3 3.8-11 3.8-20 0-10.4-1.3-18-4-23.1-2.6-5-7.2-7.5-13.6-7.5-5.7 0-9.9 2.2-12.4 6.5-2.6 4.3-3.8 11-3.8 20.1 0 10.3 1.3 18 4 23 2.6 5 7.1 7.6 13.6 7.5zm-422.3 10.1c1.6 0 3.1-.1 4.6-.3 2.3-.3 4.6-.7 6.9-1.4 3.9-1.1 8.2-3.1 12.7-5.8 8.4-5.9 13.5-14.9 13.5-25.1-.1-4.2-.1-9-.1-14.4v-54c0-2.5-.7-8.6-7.7-8.6-8.8 0-10 6.7-9.1 12.9.7 4.6.9 4.8 1.1 9s.3 8.2.3 11.9c-1.8-.5-3.6-.8-5.6-1.1s-4.4-.5-7.3-.5c-12.2 0-21.4 3.7-27.5 11s-9.2 18-9.2 31.9c0 12.7 2.3 21.6 6.9 26.7s11.2 7.7 19.7 7.7h1.1zm-6.6-17.8c-2.6-5.2-3.8-12.3-3.8-21.3 0-10.3 1.3-17.6 4-21.8s7-6.3 13.1-6.3c3.3 0 6.3.4 8.9 1.2s4.8 1.7 6.6 2.7v30.8c0 8.2-.5 13.3-1.5 15.4s-2.8 3.8-5.5 5.1-5.6 1.9-8.8 1.9c-6.1.1-10.4-2.5-13-7.7zm352.3 18.1c1.6 0 3.1-.1 4.6-.3 2.3-.3 4.6-.7 6.9-1.4 3.9-1.1 8.2-3.1 12.7-5.8 8.4-5.9 13.5-14.9 13.5-25.1-.1-4.2-.1-9-.1-14.4v-54c0-2.5-.7-8.6-7.7-8.6-8.8 0-10 6.7-9.1 12.9.7 4.6.9 4.8 1.1 9s.3 8.2.3 11.9c-1.8-.5-3.6-.8-5.6-1.1s-4.4-.5-7.3-.5c-12.2 0-21.4 3.7-27.5 11s-9.2 18-9.2 31.9c0 12.7 2.3 21.6 6.9 26.7s11.2 7.7 19.7 7.7h1.1zm-6.6-17.8c-2.6-5.2-3.8-12.3-3.8-21.3 0-10.3 1.3-17.6 4-21.8s7-6.3 13.1-6.3c3.3 0 6.3.4 8.9 1.2s4.8 1.7 6.6 2.7v30.8c0 8.2-.5 13.3-1.5 15.4s-2.8 3.8-5.5 5.1-5.6 1.9-8.8 1.9c-6.1.1-10.4-2.5-13-7.7z"
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1768 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['edit_absence_request']))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('UserAbsence', {
	    attrs: {
	      "selectedSubject": _vm.selectedSubject,
	      "resetCounter": _vm.resetAbsenceCounter
	    },
	    on: {
	      "setSubject": _vm.setSelectedSubject
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n['date']))]), _vm._v(" "), _c('DatepickerRange', {
	    attrs: {
	      "allowSameDate": true,
	      "startdate": _vm.initStartDate,
	      "enddate": _vm.initEndDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "time-changer__group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n['time']))]), _vm._v(" "), _c('TimeChanger', {
	    attrs: {
	      "showIcon": true,
	      "start": _vm.startTime,
	      "end": _vm.endTime,
	      "isFiveMinutesInterval": false
	    },
	    on: {
	      "updateStart": _vm.setStartTime,
	      "updateEnd": _vm.setEndTime
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-group marg-1-top"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n['optional_note']))]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.note),
	      expression: "note"
	    }],
	    staticClass: "do-input",
	    domProps: {
	      "value": (_vm.note)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.note = $event.target.value
	      }
	    }
	  })])], 1), _vm._v(" "), (_vm.selectedTab === 'request') ? _c('div', {
	    staticClass: "d-modal__buttons d-modal__buttons__flex",
	    staticStyle: {
	      "padding": "1rem"
	    }
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window'
	      }),
	      expression: "{\n                arrow: true,\n                animateFill: false,\n                animation : 'shift-away',\n                zIndex: '999999992',\n                boundary: 'window'\n              }"
	    }],
	    staticClass: "do-bttn do-bttn--danger",
	    class: {
	      'do-bttn--loading': _vm.isDeleting
	    },
	    attrs: {
	      "content": _vm.i18n['delete_request_tooltip']
	    },
	    on: {
	      "click": _vm.deleteRequest
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "do-submit-buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.update')) + "\n        ")]) : _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.update')) + "\n        ")])])]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1769 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-plan"
	  }, [_c('table', {
	    staticClass: "d-table d-table__stue"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('div', {
	    staticClass: "do-container"
	  }, [_c('div', {
	    staticClass: "do-container__left"
	  }, [_c('DDropdown', {
	    staticClass: "title--grey"
	  }, [_c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.createCalendars('kindergarten')
	      }
	    }
	  }, [_vm._v("\n                  Opret stuer\n                ")]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.setIsCreateOpeningHours(true)
	      }
	    }
	  }, [_vm._v("\n                  Åbningstider\n                ")])])]), _vm._v("\n            Uge " + _vm._s(_vm.currentWeek) + "\n            "), _c('DutyScheduleNav', {
	    on: {
	      "today": function($event) {
	        return _vm.$emit('today')
	      },
	      "next": function($event) {
	        return _vm.$emit('next')
	      },
	      "prev": function($event) {
	        return _vm.$emit('prev')
	      }
	    }
	  }), _vm._v(" "), _c('CopyMultipleCalendarsCopy', {
	    attrs: {
	      "initCopyDate": _vm.date
	    },
	    on: {
	      "submit": function($event) {
	        return _vm.copyCals($event)
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "copy-button-title"
	    },
	    slot: "copy-button-title"
	  }, [_vm._v("Kopier")])])], 1), _vm._v(" "), (_vm.isEventsLoading) ? _c('div', {
	    staticClass: "do-spinner"
	  }) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.days), function(day) {
	    return _c('th', {
	      key: day.dateFormatted
	    }, [_vm._v(_vm._s(day.dateFormatted))])
	  })], 2)]), _vm._v(" "), _vm._l((_vm.calendars), function(calendar) {
	    return _c('DutyScheduleCalendar', {
	      attrs: {
	        "calendar": calendar,
	        "date": _vm.date,
	        "days": _vm.days,
	        "events": _vm.events,
	        "usersCalIdsHash": _vm.usersCalIdsHash,
	        "eventsInHash": _vm.eventsInHash,
	        "theCreateEventObj": _vm.theCreateEventObj,
	        "userNorms": _vm.userNorms,
	        "theNewlyCreatedSubject": _vm.theNewlyCreatedSubject,
	        "openingHours": _vm.openingHours
	      },
	      on: {
	        "createSubject": function($event) {
	          return _vm.$emit('createSubject', $event)
	        },
	        "createEvent": function($event) {
	          return _vm.$emit('createEvent', $event)
	        },
	        "editEvent": function($event) {
	          return _vm.$emit('editEvent', $event)
	        }
	      }
	    })
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1770 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-dark do-calendar__wrapper",
	    class: {
	      'do-calendar__wrapper--dragging': _vm.isDragging
	    }
	  }, [(_vm.isDeviceMobile) ? _c('div', {
	    ref: "do_calendar_frontend_lock",
	    staticClass: "do-calendar-frontend-lock",
	    on: {
	      "click": _vm.setIsLockedFromFrontend
	    }
	  }, [_c('div', {
	    staticClass: "do-calendar-frontend-lock__inner"
	  }, [(_vm.isLockedFromFrontend) ? _c('span', {
	    staticClass: "icon-lock5"
	  }) : _c('span', {
	    staticClass: "icon-unlocked2"
	  })])]) : _vm._e(), _vm._v(" "), _c('week-selector', {
	    attrs: {
	      "startDate": _vm.weekSelectorStartDate,
	      "endDate": _vm.weekSelectorEndDate,
	      "date": _vm.activeCalendarDate
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "printCalendar"
	    }
	  }, [_c('div', {
	    staticClass: "d-calendar do-calendar"
	  }, [_c('div', {
	    staticClass: "d-calendar__header do-calendar__header",
	    staticStyle: {
	      "min-height": "54px"
	    }
	  }, [(_vm.calendar) ? _c('DCalendarHeader', {
	    attrs: {
	      "isLoadingEvents": _vm.isEventsLoading,
	      "activeCalendarDate": _vm.activeCalendarDate,
	      "calendarId": _vm.theActiveCalendarId,
	      "initCalendar": _vm.calendar,
	      "dates": _vm.calendarDates,
	      "hasHotKeys": true,
	      "showGrid": _vm.showGrid,
	      "isMultiple": _vm.userHasPermission('can_see_other_calendars')
	    },
	    on: {
	      "updateEvents": _vm.readEvents,
	      "updateCalendar": function($event) {
	        return _vm.readEvents(true)
	      },
	      "next": _vm.nextWeek,
	      "prev": _vm.prevWeek,
	      "today": _vm.today,
	      "toggleGrid": _vm.toggleGrid,
	      "copyCalendarModalOpen": function($event) {
	        return _vm.setIsCopyCalendarModalOpen($event)
	      }
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-calendar__calendar__container",
	    class: {
	      'd-calendar__calendar__container--print-mode': _vm.isCalendarInPrintMode
	    }
	  }, [_c('DCalendar', {
	    attrs: {
	      "showGrid": _vm.showGrid,
	      "calendar": _vm.calendar,
	      "isEditable": _vm.isEditable,
	      "isLocked": _vm.isLocked,
	      "isCalendarInPrintMode": _vm.isCalendarInPrintMode,
	      "isShowWeekends": _vm.isShowWeekends,
	      "startTime": _vm.startTime,
	      "endTime": _vm.endTime,
	      "date": _vm.activeCalendarDate,
	      "events": _vm.dCalendarEvents,
	      "calendarId": _vm.theActiveCalendarId,
	      "calendarName": _vm.calendarName,
	      "firstDayOfWeek": _vm.firstDayOfWeek,
	      "isEventsClickable": true,
	      "isAbsenceEditable": _vm.getIsAbsenceEditable,
	      "isCopyCalendarModalOpen": _vm.isCopyCalendarModalOpen
	    },
	    on: {
	      "onEventClick": _vm.setActiveEvent,
	      "dates": _vm.setCalendarDates,
	      "onDragging": _vm.setIsDragging
	    }
	  })], 1)]), _vm._v(" "), (_vm.isShowWeekPlan) ? _c('DWeekplan', {
	    attrs: {
	      "isInPrintMode": _vm.isInPrintMode,
	      "isReadOnly": _vm.isInPrintMode || !_vm.userHasPermission('can_edit_own_notes')
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "zoomIn"
	    }
	  }, [(_vm.activeEvent) ? _c('DCalendarShowEvent', {
	    attrs: {
	      "isDCalendarInROR": true,
	      "canEditEvent": true,
	      "canEditNotes": _vm.userHasPermission('can_edit_own_notes'),
	      "event": _vm.activeEvent,
	      "calendar": _vm.calendar,
	      "initCalendarId": _vm.theActiveCalendarId,
	      "isInDCalendar": true
	    },
	    on: {
	      "updated": _vm.readEvents,
	      "close": _vm.closeShowEvent,
	      "submitDeleteEventOnward": function($event) {
	        return _vm.readEvents(true)
	      }
	    }
	  }) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1771 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('DSelect', {
	    attrs: {
	      "items": _vm.klassCalendars,
	      "isLoading": _vm.isLoading,
	      "itemsSelected": _vm.selectedKlasses,
	      "multiple": false,
	      "placeholder": _vm.i18n[_vm.locale]['search']
	    },
	    on: {
	      "add": _vm.add,
	      "remove": _vm.remove,
	      "update": _vm.setSelectedKasses
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1772 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "onboard-arrow",
	    class: {
	      'is-in-setup-widget': _vm.setupWidget
	    }
	  }, [_c('div', {
	    staticClass: "arrow_box no-print animated infinite onboarding_animate"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1773 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-touch', {
	    staticClass: "day-cal__overlay"
	  }, [_c('div', {
	    staticClass: "days-container",
	    style: ({
	      height: _vm.height + 'px'
	    })
	  }, [_c('div', {
	    staticClass: "day"
	  }, [_c('day-cal', {
	    attrs: {
	      "locale": _vm.locale,
	      "i18n": _vm.i18n,
	      "date": _vm.date,
	      "events": _vm.lessons,
	      "viewState": _vm.viewState
	    },
	    on: {
	      "eventClicked": _vm.onTap,
	      "lessonsUpdate": _vm.setScrollTop
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 1774 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', {
	    staticClass: "only-print"
	  }, [_vm._v(_vm._s(_vm.calendarName))]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedCalendarId),
	      expression: "selectedCalendarId"
	    }],
	    staticClass: "no-desktop no-print",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedCalendarId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.nativeSelect]
	    }
	  }, _vm._l((_vm.sortedCalendars), function(calendar) {
	    return _c('option', {
	      domProps: {
	        "value": calendar.id
	      }
	    }, [_vm._v(_vm._s(calendar.name))])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "d-container no-mobile no-print",
	    class: {
	      'd-container--active': _vm.isDropDown
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.setDropdownFromClick),
	      expression: "setDropdownFromClick"
	    }],
	    ref: "d_parent",
	    staticClass: "d-select__selected",
	    on: {
	      "click": _vm.setDropdown
	    }
	  }, [_c('h1', [_vm._v(_vm._s(_vm.calendarName))]), _vm._v(" "), (_vm.isSelectLoading) ? _c('div', {
	    staticClass: "d-spinner"
	  }) : _c('svg', {
	    staticClass: "tw-icon tw-icon-cheveron-selection",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "fill-rule": "evenodd",
	      "d": "M8.7 9.7a1 1 0 1 1-1.4-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 1 1-1.4 1.4L12 6.42l-3.3 3.3zm6.6 4.6a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
	    }
	  })])]), _vm._v(" "), (_vm.isDropDown) ? _c('div', {
	    ref: "d_child",
	    staticClass: "d-select__dropdown",
	    class: {
	      'd-dropdown--animate': _vm.isPopperReady,
	      'd-dropdown--show': _vm.isPopperDone
	    }
	  }, [_c('div', {
	    ref: "ref_d_select_input_container",
	    staticClass: "d-select-input",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-search5"
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search),
	      expression: "search"
	    }],
	    ref: "inputsearch",
	    attrs: {
	      "type": "search"
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('ul', {
	    ref: "ref_d_select_calendar_dropdown",
	    staticClass: "d-select__dropdown__container"
	  }, [_vm._l((_vm.calendarQuery), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "d-list-item",
	      class: [{
	          'd-list-item--highlighted': _vm.getIsTheKeyboardSelected(calendar)
	        },
	        {
	          'd-list-item--selected': calendar.v_selected
	        }
	      ],
	      on: {
	        "click": function($event) {
	          return _vm.selectCalendar(calendar.id)
	        },
	        "mouseenter": function($event) {
	          return _vm.setTheKeyboardSelected(calendar)
	        },
	        "mousemove": _vm.onMouseMove
	      }
	    }, [_vm._v("\n          " + _vm._s(calendar.name) + " "), _c('span', {
	      staticClass: "icon-checkmark-circle"
	    })])
	  }), _vm._v(" "), (_vm.isSchoolCalendarsLoading) ? _c('li', {
	    staticClass: "d-select__dropdown__spinner-container"
	  }, [_c('div', {
	    staticClass: "d-spinner"
	  })]) : _vm._e(), _vm._v(" "), (_vm.calendarQuery.length === 0 && !_vm.isSchoolCalendarsLoading) ? _c('li', {
	    staticClass: "d-list-item text-explainer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.no_calendars_found')) + "\n        ")]) : _vm._e()], 2)]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1775 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-calendar-list"
	  }, [_c('div', {
	    staticClass: "d-calendar-list__header",
	    class: {
	      'd-calendar-list__header--flex': _vm.isCalendarInPrintMode
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.calendarName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dateRangeFormatted))])]), _vm._v(" "), _c('table', [_c('tbody', [(_vm.eventsSortedInDays.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "text-explainer pad-1"
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n['no_lessons']) + "\n      ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.eventsSortedInDays), function(event) {
	    return _c('tr', {
	      key: event.id,
	      class: {
	        'tr--is-day': event.type && event.type === 'dayDate'
	      }
	    }, [(event.type && event.type === 'dayDate') ? [_c('td', {
	      attrs: {
	        "colspan": "4"
	      }
	    }, [_c('div', [_c('p', [_vm._v(_vm._s(event.showDay))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(event.showDate))])])])] : [_c('td', [_c('div', {
	      staticClass: "lesson"
	    }, [_vm._v("\n            " + _vm._s(event.v_start) + " - " + _vm._s(event.v_end) + "\n            "), _c('div', {
	      staticClass: "lesson__dot",
	      style: ({
	        'backgroundColor': event.color
	      })
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(event.title)), (event.group.length > 0) ? [_vm._v(", " + _vm._s(event.group))] : _vm._e()], 2)])]), _vm._v(" "), _c('td', [(event.teacher.length > 0) ? _c('span', {
	      staticClass: "icon-user"
	    }) : _vm._e(), _vm._v(" " + _vm._s(event.teacher) + "\n        ")]), _vm._v(" "), _c('td', [(event.substitutes.length > 0) ? _c('span', {
	      staticClass: "icon-users3"
	    }) : _vm._e(), _vm._v(" " + _vm._s(event.substitutes) + "\n        ")]), _vm._v(" "), _c('td', [(event.room.length > 0) ? _c('span', {
	      staticClass: "icon-location"
	    }) : _vm._e(), _vm._v(" " + _vm._s(event.room) + "\n        ")])]], 2)
	  })], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 1776 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "organisations-modal text-dark",
	    class: {
	      'organisations-modal--full': _vm.isFullSize
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "organisations-modal__header"
	  }, [_c('h2', [_vm._v("Organisationer")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle organisations-modal__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "organisations-modal__tabs"
	  }, [_c('Tabs', {
	    attrs: {
	      "tabs": _vm.theTabs,
	      "selected": _vm.activeTab,
	      "isLarge": true
	    },
	    on: {
	      "select": _vm.setActiveTab
	    }
	  })], 1), _vm._v(" "), (_vm.activeTab === 'select') ? [_c('div', {
	    staticClass: "organisations-modal__content"
	  }, [_c('p', {
	    staticClass: "organisations-modal__explainer"
	  }, [_vm._v("\n          Vælg de organisationer, der skal hentes ansættelser ud fra.\n        ")]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  }) : [(_vm.organisations.length === 0) ? _c('p', {
	    staticClass: "italic"
	  }, [_vm._v("\n            Der blev ikke fundet nogen organisationer.\n          ")]) : _c('ul', {
	    staticClass: "organisations-modal__list"
	  }, _vm._l((_vm.organisations), function(organisation) {
	    return _c('li', {
	      key: organisation,
	      staticClass: "organisations-modal__list__item",
	      class: {
	        'organisations-modal__list__item--active': _vm.isSelected(organisation)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleOrganisation(organisation)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "organisations-modal__list__item__name"
	    }, [_c('span', {
	      staticClass: "icon-home2"
	    }), _vm._v(" "), _c('div', [_vm._v("\n                  " + _vm._s(organisation) + "\n                  "), _c('div', {
	      staticClass: "organisations-modal__list__item__counts"
	    }, [_vm._v("\n                    " + _vm._s(_vm.organisationCounts(organisation).total) + "\n                    " + _vm._s(_vm.organisationCounts(organisation).total === 1 ? 'ansættelse' : 'ansættelser') + ",\n                    heraf " + _vm._s(_vm.organisationCounts(organisation).withTemplate) + " med stillingskategori\n                  ")])])]), _vm._v(" "), (_vm.isSelected(organisation)) ? _c('div', {
	      staticClass: "icon__checkmark"
	    }, [_c('span', {
	      staticClass: "icon-checkmark-circle"
	    })]) : _vm._e()])
	  }), 0)]], 2), _vm._v(" "), _c('div', {
	    staticClass: "organisations-modal__buttons"
	  }, [_c('span', {
	    staticClass: "organisations-modal__count"
	  }, [_vm._v("\n          Valgt " + _vm._s(_vm.selectedOrganisations.length) + " af " + _vm._s(_vm.organisations.length) + "\n        ")]), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': _vm.isLoading || _vm.isSaving,
	      'do-bttn--submit--loading': _vm.isSaving
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("\n            Gem\n          ")])])])] : _vm._e(), _vm._v(" "), (_vm.activeTab === 'outside') ? [_c('div', {
	    staticClass: "organisations-modal__content organisations-modal__content--full"
	  }, [_c('p', {
	    staticClass: "organisations-modal__explainer"
	  }, [_vm._v("\n          Løn- og fraværsoverførsler på ansættelser, hvis organisation ikke er blandt de valgte.\n          Brug listen til at finde overførsler, der ved en fejl er lavet på en forkert organisation.\n        ")]), _vm._v(" "), (_vm.outsideData && _vm.outsideData.salary_organisations.length === 0) ? _c('p', {
	    staticClass: "organisations-modal__warning"
	  }, [_vm._v("\n          Der er ikke valgt nogen organisationer endnu, så alle ansættelser vises.\n          Vælg organisationer under \"1. Vælg organisationer\".\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isLoadingOutside) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  }) : (_vm.outsideData) ? [_c('div', {
	    staticClass: "organisations-modal__outside-summary"
	  }, [_c('span', [_vm._v("\n              " + _vm._s(_vm.outsideEmployments.length) + "\n              " + _vm._s(_vm.outsideEmployments.length === 1 ? 'ansættelse' : 'ansættelser') + "\n              uden for de valgte organisationer, heraf\n              " + _vm._s(_vm.employmentsWithTransfers.length) + " med overførsler\n            ")]), _vm._v(" "), (_vm.outsideEmployments.length > _vm.employmentsWithTransfers.length) ? _c('label', {
	    staticClass: "organisations-modal__outside-toggle"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.isShowAllOutside),
	      expression: "isShowAllOutside"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.isShowAllOutside) ? _vm._i(_vm.isShowAllOutside, null) > -1 : (_vm.isShowAllOutside)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.isShowAllOutside,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.isShowAllOutside = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.isShowAllOutside = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.isShowAllOutside = $$c
	        }
	      }
	    }
	  }), _vm._v("\n              Vis også ansættelser uden overførsler\n            ")]) : _vm._e()]), _vm._v(" "), (_vm.shownEmployments.length === 0) ? _c('p', {
	    staticClass: "italic"
	  }, [_vm._v("\n            Ingen overførsler fundet uden for de valgte organisationer.\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.shownEmployments), function(employment) {
	    return _c('div', {
	      key: employment.employment_id,
	      staticClass: "outside-employment"
	    }, [_c('div', {
	      staticClass: "outside-employment__header"
	    }, [_c('div', {
	      staticClass: "outside-employment__header__who"
	    }, [_c('strong', [_vm._v(_vm._s(employment.user_name))]), _vm._v(" "), _c('span', {
	      staticClass: "outside-employment__header__number"
	    }, [_vm._v("\n                  " + _vm._s(employment.employment_number)), (employment.source_title) ? [_vm._v(" - " + _vm._s(employment.source_title))] : _vm._e()], 2), _vm._v(" "), _vm._l((employment.positions), function(position) {
	      return (position.title) ? _c('div', {
	        key: position.school_employment_id,
	        staticClass: "d-tag"
	      }, [_vm._v("\n                  " + _vm._s(position.title) + "\n                ")]) : _vm._e()
	    })], 2), _vm._v(" "), _c('div', {
	      staticClass: "do-pill do-pill--small do-pill--yellow"
	    }, [_vm._v("\n                " + _vm._s(employment.organisation || 'Ingen organisation') + "\n              ")])]), _vm._v(" "), (employment.v_salary_days.length > 0) ? _c('div', {
	      staticClass: "outside-employment__section"
	    }, [_c('h4', [_vm._v("Vikarløn - dage")]), _vm._v(" "), _c('table', {
	      staticClass: "outside-table"
	    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', [_vm._v("Tid på ansættelsen")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Godkendt")])])]), _vm._v(" "), _c('tbody', _vm._l((employment.v_salary_days), function(day) {
	      return _c('tr', {
	        key: 'day-' + day.id
	      }, [_c('td', [_vm._v(_vm._s(_vm.formatDate(day.day)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(day.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatMinutes(day.v_minutes)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(day.state))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(day.approved_at)))])])
	    }), 0)])]) : _vm._e(), _vm._v(" "), (employment.v_kmd_rows.length > 0) ? _c('div', {
	      staticClass: "outside-employment__section"
	    }, [_c('h4', [_vm._v("Engangsydelser - OPUS")]), _vm._v(" "), _c('table', {
	      staticClass: "outside-table"
	    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Lønart")]), _vm._v(" "), _c('th', [_vm._v("Antal")]), _vm._v(" "), _c('th', [_vm._v("Beløb")]), _vm._v(" "), _c('th', [_vm._v("Omk.sted")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Sendt")])])]), _vm._v(" "), _c('tbody', _vm._l((employment.v_kmd_rows), function(row, idx) {
	      return _c('tr', {
	        key: 'kmd-' + idx
	      }, [_c('td', [_vm._v(_vm._s(_vm.formatDate(row.Startdato)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.Loenart))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.Antal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.Beloeb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.Afv_Omkostningssted || '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.v_status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(row.v_created_at)))])])
	    }), 0)])]) : _vm._e(), _vm._v(" "), (employment.sd_engangsydelser.length > 0) ? _c('div', {
	      staticClass: "outside-employment__section"
	    }, [_c('h4', [_vm._v("Engangsydelser - SD")]), _vm._v(" "), _c('table', {
	      staticClass: "outside-table"
	    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Lønart")]), _vm._v(" "), _c('th', [_vm._v("Enheder")]), _vm._v(" "), _c('th', [_vm._v("Sats")]), _vm._v(" "), _c('th', [_vm._v("Dage")]), _vm._v(" "), _c('th', [_vm._v("Timer")]), _vm._v(" "), _c('th', [_vm._v("Beskrivelse")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Godkendt")])])]), _vm._v(" "), _c('tbody', _vm._l((employment.sd_engangsydelser), function(ydelse) {
	      return _c('tr', {
	        key: 'sdy-' + ydelse.id
	      }, [_c('td', [_vm._v(_vm._s(_vm.formatSdDate(ydelse)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ydelse.loenart))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ydelse.enheder))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ydelse.sats))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ydelse.dage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ydelse.timer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ydelse.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ydelse.state))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(ydelse.approved_at)))])])
	    }), 0)])]) : _vm._e(), _vm._v(" "), (employment.sd_fravaer.length > 0) ? _c('div', {
	      staticClass: "outside-employment__section"
	    }, [_c('h4', [_vm._v("Fravær - SD")]), _vm._v(" "), _c('table', {
	      staticClass: "outside-table"
	    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Periode")]), _vm._v(" "), _c('th', [_vm._v("Lønart")]), _vm._v(" "), _c('th', [_vm._v("Dage")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Godkendt")])])]), _vm._v(" "), _c('tbody', _vm._l((employment.sd_fravaer), function(fravaer) {
	      return _c('tr', {
	        key: 'sdf-' + fravaer.id
	      }, [_c('td', [_vm._v(_vm._s(_vm.formatPeriod(fravaer.startdato, fravaer.slutdato)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fravaer.loenart))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fravaer.dagdecimal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fravaer.state))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(fravaer.approved_at)))])])
	    }), 0)])]) : _vm._e(), _vm._v(" "), (employment.sd_loenaendringer.length > 0) ? _c('div', {
	      staticClass: "outside-employment__section"
	    }, [_c('h4', [_vm._v("Lønændringer - SD")]), _vm._v(" "), _c('table', {
	      staticClass: "outside-table"
	    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Deltidskode")]), _vm._v(" "), _c('th', [_vm._v("Løndecimal")]), _vm._v(" "), _c('th', [_vm._v("Beskæftigelsesdecimal")]), _vm._v(" "), _c('th', [_vm._v("Årstimetal")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Godkendt")])])]), _vm._v(" "), _c('tbody', _vm._l((employment.sd_loenaendringer), function(aendring) {
	      return _c('tr', {
	        key: 'sdl-' + aendring.id
	      }, [_c('td', [_vm._v(_vm._s(_vm.formatDate(aendring.dato)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(aendring.deltidskode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(aendring.loendecimal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(aendring.beskaeftigelsesdecimal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(aendring.aarstimetal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(aendring.state))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(aendring.approved_at)))])])
	    }), 0)])]) : _vm._e(), _vm._v(" "), (employment.sd_tillaeg.length > 0) ? _c('div', {
	      staticClass: "outside-employment__section"
	    }, [_c('h4', [_vm._v("Tillæg - SD")]), _vm._v(" "), _c('table', {
	      staticClass: "outside-table"
	    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Ændringskode")]), _vm._v(" "), _c('th', [_vm._v("Tillægsnummer")]), _vm._v(" "), _c('th', [_vm._v("Enheder")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Godkendt")])])]), _vm._v(" "), _c('tbody', _vm._l((employment.sd_tillaeg), function(tillaeg) {
	      return _c('tr', {
	        key: 'sdt-' + tillaeg.id
	      }, [_c('td', [_vm._v(_vm._s(_vm.formatDate(tillaeg.dato)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tillaeg.aendringskode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tillaeg.tillaegsnummer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tillaeg.enheder))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tillaeg.state))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(tillaeg.approved_at)))])])
	    }), 0)])]) : _vm._e(), _vm._v(" "), (employment.salary_supplements.length > 0) ? _c('div', {
	      staticClass: "outside-employment__section"
	    }, [_c('h4', [_vm._v("Ydelser og tillæg")]), _vm._v(" "), _c('table', {
	      staticClass: "outside-table"
	    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Lønkode")]), _vm._v(" "), _c('th', [_vm._v("Skoleår")]), _vm._v(" "), _c('th', [_vm._v("Enheder")]), _vm._v(" "), _c('th', [_vm._v("Rater")]), _vm._v(" "), _c('th', [_vm._v("Periode")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Godkendt")])])]), _vm._v(" "), _c('tbody', _vm._l((employment.salary_supplements), function(supplement) {
	      return _c('tr', {
	        key: 'sup-' + supplement.id
	      }, [_c('td', [_vm._v(_vm._s(supplement.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(supplement.school_year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(supplement.units))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(supplement.installments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatPeriod(supplement.valid_from, supplement.valid_to)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(supplement.state))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(supplement.approved_at)))])])
	    }), 0)])]) : _vm._e(), _vm._v(" "), (employment.absences.length > 0) ? _c('div', {
	      staticClass: "outside-employment__section"
	    }, [_c('h4', [_vm._v("Fravær")]), _vm._v(" "), _c('table', {
	      staticClass: "outside-table"
	    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Årsag")]), _vm._v(" "), _c('th', [_vm._v("Periode")]), _vm._v(" "), _c('th', [_vm._v("Tid")]), _vm._v(" "), _c('th', [_vm._v("Fraværskode")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((employment.absences), function(absence) {
	      return _c('tr', {
	        key: 'abs-' + absence.event_serial_id
	      }, [_c('td', [_vm._v(_vm._s(absence.subject_name))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.formatDate(absence.from_date)) + "\n                    "), (absence.ongoing) ? [_vm._v("- løbende")] : (absence.to_date && absence.to_date !== absence.from_date) ? [_vm._v("- " + _vm._s(_vm.formatDate(absence.to_date)))] : _vm._e()], 2), _vm._v(" "), _c('td', [(absence.use_time) ? [_vm._v(_vm._s(absence.from_time) + " - " + _vm._s(absence.to_time))] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(absence.kmd_absence_code || absence.sd_absence_code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(absence.state))])])
	    }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.transfersCount(employment) === 0) ? _c('p', {
	      staticClass: "italic organisations-modal__no-transfers"
	    }, [_vm._v("\n              Ingen overførsler på denne ansættelse.\n            ")]) : _vm._e()])
	  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "organisations-modal__buttons"
	  }, [_c('span'), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("\n            Luk\n          ")])])])] : _vm._e(), _vm._v(" "), (_vm.activeTab === 'unused') ? [_c('div', {
	    staticClass: "organisations-modal__content organisations-modal__content--full"
	  }, [_c('p', {
	    staticClass: "organisations-modal__explainer"
	  }, [_vm._v("\n          Ansættelser uden for de valgte organisationer, som intet er bogført på -\n          hverken vikarløn, ydelser eller fravær. De kan slettes, uden at skolen mister noget.\n        ")]), _vm._v(" "), (_vm.isUnusedLoaded && _vm.school && Array.isArray(_vm.school.salary_organisations) && _vm.school.salary_organisations.length === 0) ? _c('p', {
	    staticClass: "organisations-modal__warning"
	  }, [_vm._v("\n          Der er ikke valgt nogen organisationer endnu, så alle ubrugte ansættelser vises.\n          Vælg organisationer under \"1. Vælg organisationer\".\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isLoadingUnused) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  }) : (_vm.isUnusedLoaded) ? [(_vm.unusedEmployments.length === 0) ? _c('p', {
	    staticClass: "italic"
	  }, [_vm._v("\n            Ingen ubrugte ansættelser uden for de valgte organisationer.\n          ")]) : _c('table', {
	    staticClass: "outside-table outside-table--boxed"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Medarbejder")]), _vm._v(" "), _c('th', [_vm._v("Ansættelse")]), _vm._v(" "), _c('th', [_vm._v("Titel")]), _vm._v(" "), _c('th', [_vm._v("Organisation")]), _vm._v(" "), _c('th', [_vm._v("Periode")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.unusedEmployments), function(position) {
	    return _c('tr', {
	      key: 'unused-' + position.id
	    }, [_c('td', [_vm._v(_vm._s(_vm.userName(position.user_id)))]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(position.employment_number)), (position.source_title) ? [_vm._v(" - " + _vm._s(position.source_title))] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(position.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(position.organisation || 'Ingen organisation'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatPeriod(position.start_date, position.end_date)))])])
	  }), 0)])] : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "organisations-modal__buttons"
	  }, [(_vm.isConfirmingUnusedDelete) ? _c('span', {
	    staticClass: "organisations-modal__count"
	  }, [_vm._v("\n          Er du sikker? " + _vm._s(_vm.unusedEmployments.length) + "\n          " + _vm._s(_vm.unusedEmployments.length === 1 ? 'ansættelse markeres' : 'ansættelser markeres') + " som slettet.\n        ")]) : _c('span'), _vm._v(" "), _c('div', [(_vm.isConfirmingUnusedDelete) ? [_c('button', {
	    staticClass: "do-bttn",
	    attrs: {
	      "disabled": _vm.isDeletingUnused
	    },
	    on: {
	      "click": function($event) {
	        _vm.isConfirmingUnusedDelete = false
	      }
	    }
	  }, [_vm._v("\n              Fortryd\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': _vm.isDeletingUnused,
	      'do-bttn--submit--loading': _vm.isDeletingUnused
	    },
	    on: {
	      "click": _vm.deleteUnused
	    }
	  }, [_vm._v("\n              Ja, slet " + _vm._s(_vm.unusedEmployments.length) + "\n              " + _vm._s(_vm.unusedEmployments.length === 1 ? 'ansættelse' : 'ansættelser') + "\n            ")])] : [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("\n              Luk\n            ")]), _vm._v(" "), (_vm.unusedEmployments.length > 0) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': _vm.isLoadingUnused
	    },
	    on: {
	      "click": function($event) {
	        _vm.isConfirmingUnusedDelete = true
	      }
	    }
	  }, [_vm._v("\n              Slet " + _vm._s(_vm.unusedEmployments.length) + " ubrugte\n              " + _vm._s(_vm.unusedEmployments.length === 1 ? 'ansættelse' : 'ansættelser') + "\n            ")]) : _vm._e()]], 2)])] : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1777 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickOutside),
	      expression: "onClickOutside"
	    }],
	    staticClass: "d-dropdown-container",
	    class: {
	      'd-dropdown-container--active': _vm.isDropDown
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.setDropdownFromClick),
	      expression: "setDropdownFromClick"
	    }],
	    ref: "d_parent",
	    staticClass: "d-dropdown__title",
	    on: {
	      "click": _vm.setDropdown
	    }
	  }, [_vm._t("title"), _vm._v(" "), (_vm.isShowDots) ? _c('div', {
	    staticClass: "d-dropdown__title__circle"
	  }, [_vm._t("d-dropdown__icon", function() {
	    return [_c('span', {
	      staticClass: "icon-more2"
	    })]
	  })], 2) : _vm._e()], 2), _vm._v(" "), (_vm.isDropDown) ? _c('div', {
	    ref: "d_child",
	    staticClass: "d-dropdown text-dark",
	    class: {
	      'd-dropdown--animate': _vm.isPopperReady,
	      'd-dropdown--show': _vm.isPopperDone
	    },
	    attrs: {
	      "id": "d-dropdown__d-child"
	    }
	  }, [_vm._t("list", function() {
	    return [_vm._m(0)]
	  })], 2) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', [_c('li', [_vm._v("Rename")]), _vm._v(" "), _c('li', [_vm._v("Help")]), _vm._v(" "), _c('li', {
	    staticClass: "d-item-warning"
	  }, [_vm._v("Try")])])
	}]}

/***/ }),
/* 1778 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-wizard"
	  }, [_c('div', {
	    staticClass: "d-wizard__filters",
	    class: {
	      'd-wizard__filters--locked': _vm.isClosed
	    }
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label marg-05-bottom"
	  }, [_vm._v("Vælg medarbejder")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.userId),
	      expression: "userId"
	    }],
	    staticClass: "do-select",
	    attrs: {
	      "disabled": _vm.isClosed
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.userId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": ""
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Vælg person")]), _vm._v(" "), _vm._l((_vm.users), function(user) {
	    return _c('option', {
	      key: user.id,
	      domProps: {
	        "value": user.id
	      }
	    }, [_vm._v("\n          " + _vm._s(user.name) + "\n        ")])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Første og sidste arbejdsdag (begge dage inklusiv)")]), _vm._v(" "), _c('DatePickerRange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate,
	      "allowSameDate": true
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  })], 1)]), _vm._v(" "), (_vm.errorMessage) ? _c('p', {
	    staticClass: "d-wizard__error"
	  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), (!_vm.isPeriodValid) ? _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Vælg en medarbejder og en periode for at se opgørelsen.")]) : (_vm.isLoadingStatement && !_vm.statement) ? _c('div', {
	    staticClass: "d-wizard__loading"
	  }, [_vm._v("Henter timeopgørelse...")]) : _vm._e(), _vm._v(" "), (_vm.isPeriodValid && _vm.statement) ? [_c('div', {
	    staticClass: "d-wizard__status",
	    class: {
	      'd-wizard__status--closed': _vm.isClosed
	    }
	  }, [(_vm.isClosed) ? _c('span', [_c('b', [_vm._v("Opgørelsen er lukket")]), _vm._v(" " + _vm._s(_vm.closedLabel) + ". Genåbn den for at ændre periode eller opgørelsesmetode.\n      ")]) : _c('span', [_vm._v("Opgørelsen er åben og kan ændres. Luk den, når den er færdig.")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    class: {
	      'do-bttn--submit': !_vm.isClosed
	    },
	    attrs: {
	      "disabled": _vm.isTogglingClosed || _vm.isLoadingStatement
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setClosed(!_vm.isClosed)
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.isClosed ? 'Genåbn opgørelse' : 'Gem og luk opgørelse') + "\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-overview"
	  }, [_c('section', {
	    staticClass: "d-overview__col"
	  }, [_c('h3', {
	    staticClass: "d-overview__title"
	  }, [_vm._v("Oprindelig "), _c('span', [_vm._v(_vm._s(_vm.schoolYearName))])]), _vm._v(" "), (_vm.isLoadingOriginal) ? _c('div', {
	    staticClass: "d-wizard__loading"
	  }, [_vm._v("Henter årsnorm...")]) : [_c('table', {
	    staticClass: "d-table d-table__overview"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.originalNormBody), function(item) {
	    return _c('tr', {
	      key: item.title
	    }, [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(item.value))])])
	  }), 0), _vm._v(" "), (_vm.originalNormFooter) ? _c('tfoot', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.originalNormFooter.title))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.originalNormFooter.value))])])]) : _vm._e()]), _vm._v(" "), _c('table', {
	    staticClass: "d-table d-table__overview"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Arbejdstid")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.formatShare(_vm.originalWorkHours)))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.format(_vm.originalWorkHours)))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.format(_vm.originalScheduledTotal)))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.format(_vm.originalWorkHours - _vm.originalScheduledTotal)))])]), _vm._v(" "), _vm._l((_vm.summaryTypes), function(type) {
	    return _c('tr', {
	      key: 'original-' + type
	    }, [_c('td', [_vm._v(_vm._s(_vm.getMasterTypeTitle(type)))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.formatShare(_vm.originalByType(type).assigned)))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.format(_vm.originalByType(type).assigned)))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.format(_vm.originalByType(type).scheduled)))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.format(_vm.originalByType(type).assigned - _vm.originalByType(type).scheduled)))])])
	  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                Rest\n                "), (_vm.restLabel(_vm.originalRest)) ? _c('span', {
	    class: ['d-overview__rest-status', _vm.restBadgeClass(_vm.originalRest)]
	  }, [_vm._v(_vm._s(_vm.restLabel(_vm.originalRest)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.formatShare(_vm.originalRest)))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_c('span', {
	    class: _vm.restBadgeClass(_vm.originalRest)
	  }, [_vm._v(_vm._s(_vm.formatSigned(_vm.originalRest)))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])], 2)])]], 2), _vm._v(" "), _c('section', {
	    staticClass: "d-overview__col d-overview__col--active"
	  }, [_c('h3', {
	    staticClass: "d-overview__title"
	  }, [_vm._v("Opgjort "), _c('span', [_vm._v(_vm._s(_vm.periodFormatted))])]), _vm._v(" "), _c('table', {
	    staticClass: "d-table d-table__overview"
	  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Periode")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.periodFormatted))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ansættelsesgrad")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.employmentPercentLabel))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Timeansættelse pr. uge")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.format(_vm.hoursPerWeek)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bruttotid "), _c('span', {
	    staticClass: "d-overview__days"
	  }, [_vm._v("(" + _vm._s(_vm.formatDays(_vm.statement.brutto_dage)) + " dage)")])]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.format(_vm.statement.brutto_tid_i_timer)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Søgnehelligdage "), _c('span', {
	    staticClass: "d-overview__days"
	  }, [_vm._v("(" + _vm._s(_vm.formatDays(_vm.statement.helligdage_dage)) + " dage)")]), _vm._v(" "), (_vm.holidays.length) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        zIndex: 999999992
	      }),
	      expression: "{arrow: true, zIndex: 999999992}"
	    }],
	    staticClass: "icon-question3",
	    attrs: {
	      "content": _vm.holidaysTooltip
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.format(_vm.statement.soegne_helligdage_i_timer)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    staticClass: "d-overview__vacation"
	  }, [_vm._v("\n                Ferie\n                "), _c('input', {
	    staticClass: "d-overview__input",
	    attrs: {
	      "type": "text",
	      "inputmode": "decimal",
	      "disabled": _vm.isClosed
	    },
	    domProps: {
	      "value": _vm.numberInput('vacation_days_taken')
	    },
	    on: {
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "mouseup": function($event) {
	        $event.preventDefault();
	      },
	      "input": function($event) {
	        return _vm.setNumber('vacation_days_taken', $event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.flushNumberSave('vacation_days_taken')
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "d-overview__days"
	  }, [_vm._v("dage afholdt i perioden")])])]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.format(_vm.statement.feriedage_i_timer)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Elevdage i perioden")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.schoolDaysInPeriod))])])]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', [_vm._v("Arbejdstid "), _c('span', {
	    staticClass: "d-overview__days"
	  }, [_vm._v("(" + _vm._s(_vm.formatDays(_vm.statement.arbejdsdage)) + " dage)")])]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.format(_vm.periodWorkHours)))])])])]), _vm._v(" "), _c('table', {
	    staticClass: "d-table d-table__overview"
	  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Arbejdstid")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: (_vm.explanationTippy),
	      expression: "explanationTippy"
	    }],
	    staticClass: "icon-question3 d-overview__help",
	    attrs: {
	      "content": _vm.workHoursExplanation
	    }
	  }), _vm._v("\n              " + _vm._s(_vm.format(_vm.periodWorkHours)) + "\n            ")])]), _vm._v(" "), _vm._l((_vm.summaryTypes), function(type) {
	    return _c('tr', {
	      key: 'period-' + type
	    }, [_c('td', [_vm._v(_vm._s(_vm.getMasterTypeTitle(type)))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: (_vm.explanationTippy),
	        expression: "explanationTippy"
	      }],
	      staticClass: "icon-question3 d-overview__help",
	      attrs: {
	        "content": _vm.typeExplanation(type)
	      }
	    }), _vm._v("\n              " + _vm._s(_vm.format(_vm.groupHoursByType(type))) + "\n            ")])])
	  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Rest\n              "), (_vm.restLabel(_vm.rest)) ? _c('span', {
	    class: ['d-overview__rest-status', _vm.restBadgeClass(_vm.rest)]
	  }, [_vm._v(_vm._s(_vm.restLabel(_vm.rest)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: (_vm.explanationTippy),
	      expression: "explanationTippy"
	    }],
	    staticClass: "icon-question3 d-overview__help",
	    attrs: {
	      "content": _vm.restExplanation
	    }
	  }), _vm._v(" "), _c('span', {
	    class: _vm.restBadgeClass(_vm.rest)
	  }, [_vm._v(_vm._s(_vm.formatSigned(_vm.rest)))])])])], 2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "d-wizard__intro"
	  }, [_c('h3', {
	    staticClass: "d-overview__title"
	  }, [_vm._v("Timeopgørelse for perioden")]), _vm._v(" "), _c('div', {
	    staticClass: "do-warning d-wizard__legend"
	  }, [_c('b', [_vm._v("Opgørelsesmetode:")]), _vm._v(" "), _c('ol', {
	    staticClass: "d-wizard__legend-list"
	  }, _vm._l((_vm.methods), function(method) {
	    return _c('li', {
	      key: method.id
	    }, [_c('b', [_vm._v(_vm._s(method.title) + ":")]), _vm._v(" " + _vm._s(method.description))])
	  }), 0)])]), _vm._v(" "), (!_vm.groups.length) ? _c('p', [_vm._v("Der er ingen opgaver for personen i perioden.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.groups), function(group) {
	    return _c('table', {
	      key: group.type,
	      staticClass: "do-table",
	      class: {
	        'do-table--locked': _vm.isClosed
	      }
	    }, [_c('thead', [_c('tr', [_c('th', {
	      attrs: {
	        "rowspan": "2"
	      }
	    }, [_vm._v(_vm._s(group.title))]), _vm._v(" "), _c('th', {
	      staticClass: "d-dates",
	      attrs: {
	        "rowspan": "2"
	      }
	    }, [_vm._v("Dato")]), _vm._v(" "), _c('th', {
	      attrs: {
	        "rowspan": "2"
	      }
	    }, [_vm._v("Tildelt")]), _vm._v(" "), _c('th', {
	      attrs: {
	        "rowspan": "2"
	      }
	    }, [_vm._v("Skemalagt")]), _vm._v(" "), _c('th', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          zIndex: 999999992
	        }),
	        expression: "{arrow: true, zIndex: 999999992}"
	      }],
	      staticClass: "d-method-group",
	      attrs: {
	        "colspan": _vm.methods.length,
	        "content": "Vælg én metode for hver linje. Timerne i perioden regnes ud fra den valgte metode."
	      }
	    }, [_vm._v("\n            Vælg opgørelsesmetode "), _c('span', {
	      staticClass: "icon-question3"
	    })]), _vm._v(" "), _c('th', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          zIndex: 999999992
	        }),
	        expression: "{arrow: true, zIndex: 999999992}"
	      }],
	      attrs: {
	        "rowspan": "2",
	        "content": "Timerne i perioden efter den valgte metode. Ved Egen vurdering tastes tallet her."
	      }
	    }, [_vm._v("\n            Timer i perioden "), _c('span', {
	      staticClass: "icon-question3"
	    })])]), _vm._v(" "), _c('tr', _vm._l((_vm.methods), function(method) {
	      return _c('th', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: true,
	            zIndex: 999999992
	          }),
	          expression: "{arrow: true, zIndex: 999999992}"
	        }],
	        key: method.id,
	        staticClass: "d-method",
	        attrs: {
	          "content": method.description
	        }
	      }, [_vm._v("\n            " + _vm._s(method.title) + " "), _c('span', {
	        staticClass: "icon-question3"
	      })])
	    }), 0)]), _vm._v(" "), _c('tbody', [_vm._l((group.rows), function(row) {
	      return _c('tr', {
	        key: row.key
	      }, [_c('td', [_vm._v(_vm._s(row.task.name)), (row.task.substitute) ? _c('span', [_vm._v(" (vikar)")]) : _vm._e()]), _vm._v(" "), _c('td', {
	        staticClass: "d-dates"
	      }, [_vm._v(_vm._s(_vm.formatDateRange(row.task.from_date, row.task.to_date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.format(row.assigned)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.format(row.scheduled)))]), _vm._v(" "), _vm._l((_vm.methods), function(method) {
	        return _c('td', {
	          key: method.id,
	          staticClass: "d-method",
	          class: {
	            'd-method--selected': _vm.rowState(row).method === method.id
	          },
	          on: {
	            "click": function($event) {
	              return _vm.setMethod(row, method.id)
	            }
	          }
	        }, [_c('label', {
	          staticClass: "d-method__label"
	        }, [_c('input', {
	          attrs: {
	            "type": "radio",
	            "name": 'method-' + row.key,
	            "disabled": _vm.isClosed
	          },
	          domProps: {
	            "value": method.id,
	            "checked": _vm.rowState(row).method === method.id
	          },
	          on: {
	            "change": function($event) {
	              return _vm.setMethod(row, method.id)
	            }
	          }
	        })])])
	      }), _vm._v(" "), _c('td', {
	        staticClass: "d-period-hours"
	      }, [(_vm.isManualMethod(_vm.rowState(row).method)) ? _c('input', {
	        ref: 'period-' + row.key,
	        refInFor: true,
	        staticClass: "d-method__input",
	        attrs: {
	          "type": "text",
	          "inputmode": "decimal",
	          "disabled": _vm.isClosed
	        },
	        domProps: {
	          "value": _vm.rowState(row).manual[_vm.rowState(row).method]
	        },
	        on: {
	          "input": function($event) {
	            _vm.setManual(row, _vm.rowState(row).method, $event.target.value)
	          }
	        }
	      }) : _c('b', [_vm._v(_vm._s(_vm.format(_vm.rowHours(row))))])])], 2)
	    }), _vm._v(" "), _c('tr', {
	      staticClass: "d-diff"
	    }, [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.format(group.assigned)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.format(group.scheduled)))]), _vm._v(" "), _c('td', {
	      attrs: {
	        "colspan": _vm.methods.length
	      }
	    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.format(_vm.groupHours(group))))])])], 2)])
	  })] : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_c('h4', [_vm._v("Grundoplysninger")])]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("Timer")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_c('h4', [_vm._v("Fordeling")])]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("Tildelt")]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("Skemalagt")]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("Forskel")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_c('h4', [_vm._v("Grundoplysninger")])]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("Timer")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_c('h4', [_vm._v("Fordeling")])]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("Timer i perioden")])])])
	}]}

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "alert alert--small"
	  }, [_c('h4', [_vm._v("\n    " + _vm._s(_vm.i18n['following_persons_are_on_the_lesson_but_not_on_school']) + " " + _vm._s(_vm.activeSchoolName) + ".\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-cal__group"
	  }, _vm._l((_vm.usersNotOnSchool), function(calendar) {
	    return _c('div', {
	      key: calendar.calendar_id,
	      staticClass: "d-cal-not-on-school",
	      attrs: {
	        "data-cal-id": calendar.calendar_id
	      }
	    }, [_vm._v("\n      " + _vm._s(calendar.name) + " "), (calendar.substitute) ? _c('span', {
	      staticClass: "do-pill do-pill--custom"
	    }, [_vm._v(_vm._s(_vm.i18n['sub']))]) : _vm._e(), _vm._v(" "), (!_vm.isEventOwner(calendar)) ? _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'top'
	        }),
	        expression: "{\n                    arrow: true,\n                    placement : 'top'\n                  }"
	      }],
	      staticClass: "icon__bg-circle icon__bg-circle--danger icon__bg-circle--x-small",
	      attrs: {
	        "content": _vm.i18n['remove']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheRemoveCalendar(calendar)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-cross2"
	    })]) : _vm._e()])
	  }), 0), _vm._v(" "), (_vm.theRemoveCalendar) ? _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setTheRemoveCalendar(null)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal__d-calendar text-dark",
	    class: {
	      'd-modal__d-calendar--with-actions': true
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__d-calendar__header text-dark"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.theRemoveCalendar.name))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.setTheRemoveCalendar(null)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__d-calendar__content"
	  }, [_c('div', {
	    staticClass: "alert width-100"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n['remove']) + " " + _vm._s(_vm.theRemoveCalendar.name) + " " + _vm._s(_vm.i18n['from_this_lesson']) + "?")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-danger width-100",
	    attrs: {
	      "disabled": _vm.isRemoving
	    },
	    on: {
	      "click": function($event) {
	        return _vm.removeCalendar(_vm.theRemoveCalendar)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['remove']) + "\n            " + _vm._s(_vm.theRemoveCalendar.name) + " " + _vm._s(_vm.i18n['from_this_lesson']) + "\n          ")])]), _vm._v(" "), _c('div', {
	    staticClass: "alert"
	  }, [_c('h4', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n['remove_or_replace']) + " " + _vm._s(_vm.theRemoveCalendar.name) + " " + _vm._s(_vm.i18n['on']) + "\n            " + _vm._s(_vm.event.title) + " " + _vm._s(_vm.i18n['onwards']) + "?")]), _vm._v(" "), _c('CalendarViewDayRemoveOrReplace', {
	    staticClass: "width-100 d-event__actions--custom",
	    attrs: {
	      "isPossibleToAdd": false,
	      "event": _vm.event,
	      "calendar": _vm.theRemoveCalendar,
	      "calendars": _vm.userCalendars
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose
	    }
	  })], 1)])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1780 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.close),
	      expression: "close"
	    }],
	    staticClass: "pos-relative inline-block"
	  }, [_c('button', {
	    staticClass: "dropup-button",
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._v(_vm._s(_vm.buttonText))]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropup"
	    }
	  }, [_c('ul', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "dropup-content bg-white large-box-shadow rounded"
	  }, [_vm._t("list", function() {
	    return [_c('li', [_vm._v("Three")]), _vm._v(" "), _c('li', [_vm._v("Two")]), _vm._v(" "), _c('li', [_vm._v("One")])]
	  })], 2)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1781 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-filters text-dark"
	  }, [_c('div', {
	    staticClass: "do-filters__selected"
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickOutside),
	      expression: "onClickOutside"
	    }],
	    staticClass: "do-filters__dropdown__container"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn__filter",
	    on: {
	      "click": function($event) {
	        _vm.isShowDropdown = !_vm.isShowDropdown
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-filter"
	  }), _vm._v("\n        " + _vm._s(_vm.i18n['substitutes']) + "\n        "), _c('div', {
	    staticClass: "do-filters__divider"
	  }), _vm._v(" "), (_vm.allSelectedFiltersLength === 0) ? _c('span', {
	    staticClass: "do-filters__selected-filters"
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n['select_filters']) + "\n        ")]) : [_c('span', {
	    staticClass: "do-badge"
	  }, [_vm._v("\n            " + _vm._s(_vm.allSelectedFiltersLength) + " " + _vm._s(_vm.i18n['selected']) + "\n          ")])]], 2), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-dropdown"
	    }
	  }, [(_vm.isShowDropdown) ? _c('div', {
	    staticClass: "do-filters__dropdown"
	  }, [_c('button', {
	    staticClass: "do-filters__button-transparent",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('clearAll')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['clear_all']))]), _vm._v(" "), (_vm.isSortable) ? _c('h4', {
	    staticClass: "do-filters__section-title"
	  }, [_c('span', {
	    staticClass: "icon-filter"
	  }), _vm._v("\n            " + _vm._s(_vm.i18n['filters']) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "do-filters__dropdown__item"
	  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n['filter_by_criteria']))]), _vm._v(" "), _vm._l((_vm.quickFilters), function(quickFilter) {
	    return _c('button', {
	      key: quickFilter.value,
	      staticClass: "do-bttn__quick-filter",
	      class: {
	        'do-bttn__quick-filter--selected': _vm.getIsQuickFilterSelected(quickFilter)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.$emit('toggleQuickFilter', quickFilter)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-checkmark-circle"
	    }), _vm._v("\n              " + _vm._s(_vm.i18n[quickFilter.titleKey]) + "\n            ")])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "do-filters__dropdown__item"
	  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n['filter_by_group']))]), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n['groups'],
	      "tags": _vm.tags,
	      "selectedTags": _vm.selectedTags
	    },
	    on: {
	      "select": function($event) {
	        return _vm.$emit('select', $event)
	      },
	      "clear": function($event) {
	        return _vm.$emit('clear')
	      }
	    }
	  }), _vm._v(" "), (_vm.isPresenceOption && _vm.selectedTags.length > 0) ? _c('div', {
	    staticClass: "do-filters__presence"
	  }, [_c('span', {
	    staticClass: "do-filters__presence__label"
	  }, [_vm._v(_vm._s(_vm.i18n['only_with_work_hours']))]), _vm._v(" "), _vm._l((_vm.selectedTags), function(tag) {
	    return _c('button', {
	      key: tag,
	      staticClass: "do-bttn__quick-filter do-bttn__quick-filter--small",
	      class: {
	        'do-bttn__quick-filter--selected': _vm.groupsRequiringPresence.includes(tag)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.$emit('togglePresenceGroup', tag)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-checkmark-circle"
	    }), _vm._v("\n                " + _vm._s(tag) + "\n              ")])
	  })], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-filters__dropdown__item"
	  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n['filter_by_blocks']))]), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n['blocks'],
	      "tags": _vm.eventTitleTags,
	      "selectedTags": _vm.selectedEventTitles
	    },
	    on: {
	      "select": function($event) {
	        return _vm.$emit('selectEventTitle', $event)
	      },
	      "clear": function($event) {
	        return _vm.$emit('clearEventTitles')
	      }
	    }
	  })], 1), _vm._v(" "), (_vm.isSortable) ? _c('div', {
	    staticClass: "do-filters__sort"
	  }, [_c('div', {
	    staticClass: "do-filters__sort__header"
	  }, [_c('h4', {
	    staticClass: "do-filters__section-title"
	  }, [_c('span', {
	    staticClass: "icon-shuffle2"
	  }), _vm._v("\n                " + _vm._s(_vm.i18n['sorting']) + "\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "do-filters__sort__toggle"
	  }, [_vm._v("\n                " + _vm._s(_vm.i18n['sort_by_filters']) + "\n                "), _c('AppToggle', {
	    attrs: {
	      "propOn": _vm.isSortActive
	    },
	    on: {
	      "changed": _vm.onToggleSort
	    }
	  })], 1)]), _vm._v(" "), _c('p', {
	    staticClass: "do-filters__sort__hint"
	  }, [_vm._v("\n              " + _vm._s(_vm.sortHint) + "\n            ")]), _vm._v(" "), _c('draggable', {
	    attrs: {
	      "value": _vm.sortItems,
	      "disabled": !_vm.isSortActive
	    },
	    on: {
	      "input": _vm.onSortInput
	    }
	  }, [_c('transition-group', {
	    staticClass: "do-filters__sort__list",
	    class: {
	      'do-filters__sort__list--inactive': !_vm.isSortActive
	    },
	    attrs: {
	      "type": "transition",
	      "name": "do-filters-sort",
	      "tag": "div"
	    }
	  }, _vm._l((_vm.sortItems), function(item, idx) {
	    return _c('div', {
	      key: item.key,
	      staticClass: "do-filters__sort__item"
	    }, [_c('div', {
	      staticClass: "do-filters__sort__item__number"
	    }, [_vm._v(_vm._s(idx + 1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getSortItemTitle(item)))]), _vm._v(" "), _c('span', {
	      staticClass: "do-filters__sort__item__type"
	    }, [_vm._v(_vm._s(_vm.i18n['type_' + item.type]))]), _vm._v(" "), _c('span', {
	      staticClass: "icon-menu do-filters__sort__item__handle"
	    })])
	  }), 0)], 1)], 1) : _vm._e()]) : _vm._e()])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 1782 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "subjects text-dark",
	    class: {
	      'subjects--is-activities': _vm.isActivities
	    }
	  }, [(_vm.noActiveSchoolYears) ? _c('Banner') : _vm._e(), _vm._v(" "), (!_vm.isActivities) ? _c('div', {
	    staticClass: "subjects-header"
	  }, [_c('div', {
	    staticClass: "subjects-header__left"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['headline']))]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['subjects'],
	      "tags": _vm.subjectTypeFilters,
	      "selectedTags": _vm.selectedSubjectTypeFilters
	    },
	    on: {
	      "select": _vm.toggleSelectedSubjectTypeFilters,
	      "clear": _vm.clearSelectedSubjectTypeFilters
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['grades'],
	      "tags": _vm.klassTags,
	      "selectedTags": _vm.selectedKlassFilters
	    },
	    on: {
	      "select": _vm.toggleKlassTag,
	      "clear": _vm.clearSelectedKlassFilters
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "subjects-header__right"
	  }, [(!_vm.isLoading && _vm.klassesWithoutSubjects.length > 0 && _vm.schoolIsFromDK) ? _c('button', {
	    staticClass: "do-bttn do-bttn--large",
	    on: {
	      "click": _vm.setImportSubjects
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['import_subjects']) + "\n      ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "color": "blue"
	    }
	  }) : [(_vm.klassIds.length < 1) ? _c('div', [_c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_classes_first']))])]) : _c('div', {
	    staticClass: "subjects-table",
	    style: ({
	      'width': _vm.tableWidth
	    })
	  }, [_c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', {
	    ref: "tableHead"
	  }, [_c('tr', [_c('th', {
	    staticStyle: {
	      "min-width": "160px"
	    }
	  }), _vm._v(" "), _vm._l((_vm.klassHeaderColumns), function(cal) {
	    return _c('th', {
	      key: cal.id
	    }, [_c('div', {
	      staticClass: "column-name"
	    }, [_vm._v(_vm._s(cal.vName))]), _vm._v(" "), _c('div', {
	      staticClass: "column-hours"
	    }, [_vm._v(_vm._s(cal.vTotalHours))])])
	  })], 2)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.filteredKlassIds), function(calId) {
	    return _c('td', {
	      key: calId,
	      staticClass: "td-create-bttn-container"
	    }, [_c('button', {
	      staticClass: "do-bttn td-bttn--small",
	      on: {
	        "click": function($event) {
	          return _vm.setCreateInCalendarId(calId)
	        }
	      }
	    }, [_vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale]['create']) + "\n              ")])])
	  })], 2), _vm._v(" "), (!_vm.isActivities) ? _c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.filteredKlassIds), function(calId) {
	    return _c('td', {
	      key: calId,
	      staticClass: "td-create-bttn-container"
	    }, [_c('button', {
	      staticClass: "do-bttn td-bttn--small",
	      on: {
	        "click": function($event) {
	          return _vm.openKlassRoomModal(calId)
	        }
	      }
	    }, [_vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale]['edit']) + "\n              ")])])
	  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.visibleSubjectsTable), function(row) {
	    return _c('tr', {
	      key: row.id
	    }, [_c('th', [_c('div', {
	      staticClass: "th-wrench-icon-container"
	    }, [_vm._v("\n              " + _vm._s(row.name) + "\n              "), _c('span', {
	      staticClass: "icon__bg-circle icon__bg-circle--small th-wrench-icon icon-wrench",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.openBulkColorModal(row)
	        }
	      }
	    })])]), _vm._v(" "), _vm._l((row.cells), function(cell) {
	      return [(cell.hasSubject) ? _c('td', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: true,
	            onShow: function () { return !!cell.v_tooltip; }
	          }),
	          expression: "{\n                  arrow: true,\n                  onShow: () => !!cell.v_tooltip\n                }"
	        }],
	        key: cell.calId,
	        staticClass: "td__subject",
	        class: [{
	            'td__subject--has-user': cell.v_subjectHasTeachers
	          },
	          {
	            'td__subject--has-room': cell.v_subjectHasRooms
	          },
	          {
	            'td__subject-has-other-klass': cell.v_subjectOtherKlasses && cell.v_subjectOtherKlasses.length > 0
	          }
	        ],
	        style: ({
	          '--subjectBgColor': cell.klass.color
	        }),
	        attrs: {
	          "aria-hours": cell.vHours,
	          "content": cell.v_tooltip
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setEditSubject(cell.klass)
	          }
	        }
	      }) : _c('td', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            animateFill: false,
	            animation: 'shift-away',
	            zIndex: '999999992',
	            boundary: 'window'
	          }),
	          expression: "{\n                  animateFill: false,\n                  animation : 'shift-away',\n                  zIndex: '999999992',\n                  boundary: 'window'\n                }"
	        }],
	        key: cell.calId,
	        staticClass: "td__create-subject",
	        attrs: {
	          "content": cell.createTooltip
	        },
	        on: {
	          "click": function($event) {
	            if ($event.target !== $event.currentTarget) { return null; }
	            return _vm.setIsCreateSubject(row.rawSubject, cell.klass)
	          }
	        }
	      }, [(_vm.isCreateSubject(row.rawSubject, cell.klass)) ? _c('AddSubject', {
	        attrs: {
	          "subject": row.rawSubject,
	          "calendar": cell.klass,
	          "propHours": _vm.lastCreatedHoursBySubjectId[row.rawSubject.id]
	        },
	        on: {
	          "createSubject": _vm.createExistingSubjectInCal,
	          "close": _vm.closeIsCreateSubject
	        }
	      }) : _vm._e()], 1)]
	    })], 2)
	  })], 2)])])], _vm._v(" "), (_vm.isBulkColorModalOpen) ? _c('modal', {
	    on: {
	      "close": _vm.closeBulkColorModal
	    }
	  }, [_c('template', {
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "bulk-color-modal__header",
	    style: ({
	      'backgroundColor': _vm.bulkColor || '#A0A5EF'
	    })
	  }, [_c('h2', [_vm._v(_vm._s(_vm.bulkColorRow ? _vm.bulkColorRow.name : ''))])]), _vm._v(" "), _c('div', {
	    staticClass: "bulk-color-modal__body"
	  }, [_c('div', {
	    staticClass: "bulk-color-modal__section"
	  }, [_c('div', {
	    staticClass: "d-label-and-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.bulkNameEnabled = !_vm.bulkNameEnabled
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['change_title'] || 'Skift titel'))]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "propOn": _vm.bulkNameEnabled,
	      "allowChanges": false
	    }
	  })], 1), _vm._v(" "), (_vm.bulkNameEnabled) ? _c('div', {
	    staticClass: "bulk-color-modal__field"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.bulkName),
	      expression: "bulkName"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.bulkColorRow ? _vm.bulkColorRow.name : ''
	    },
	    domProps: {
	      "value": (_vm.bulkName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.bulkName = $event.target.value
	      }
	    }
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "bulk-color-modal__section"
	  }, [_c('div', {
	    staticClass: "d-label-and-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.bulkHoursEnabled = !_vm.bulkHoursEnabled
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['change_hours'] || 'Opdater klokketimer i skoleåret'))]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "propOn": _vm.bulkHoursEnabled,
	      "allowChanges": false
	    }
	  })], 1), _vm._v(" "), (_vm.bulkHoursEnabled) ? _c('div', {
	    staticClass: "bulk-color-modal__field"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.bulkHours),
	      expression: "bulkHours",
	      modifiers: {
	        "number": true
	      }
	    }],
	    staticClass: "do-input",
	    attrs: {
	      "type": "number",
	      "min": "0",
	      "step": "0.01",
	      "placeholder": _vm.bulkColorRow && _vm.bulkColorRow.rawSubject ? String(_vm.bulkColorRow.rawSubject.hours || 0) : ''
	    },
	    domProps: {
	      "value": (_vm.bulkHours)
	    },
	    on: {
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.bulkHours = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "bulk-color-modal__section"
	  }, [_c('div', {
	    staticClass: "d-label-and-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.bulkSubjectTypeEnabled = !_vm.bulkSubjectTypeEnabled
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['change_subject_type'] || 'Skift briktype'))]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "propOn": _vm.bulkSubjectTypeEnabled,
	      "allowChanges": false
	    }
	  })], 1), _vm._v(" "), (_vm.bulkSubjectTypeEnabled) ? _c('div', {
	    staticClass: "bulk-color-modal__field"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.bulkSubjectType),
	      expression: "bulkSubjectType"
	    }],
	    staticClass: "d-input__select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.bulkSubjectType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "disabled": ""
	    }
	  }, [_vm._v("--")]), _vm._v(" "), _vm._l((_vm.bulkSubjectTypeOptions), function(t) {
	    return _c('option', {
	      key: t.value,
	      domProps: {
	        "value": t.value
	      }
	    }, [_vm._v(_vm._s(t.name))])
	  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "bulk-color-modal__section"
	  }, [_c('div', {
	    staticClass: "d-label-and-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.bulkColorEnabled = !_vm.bulkColorEnabled
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['change_color'] || 'Skift farve'))]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "propOn": _vm.bulkColorEnabled,
	      "allowChanges": false
	    }
	  })], 1), _vm._v(" "), (_vm.bulkColorEnabled) ? _c('div', {
	    staticClass: "bulk-color-modal__field"
	  }, [_c('ColorPicker', {
	    attrs: {
	      "initialColor": _vm.bulkColor
	    },
	    on: {
	      "changedColor": _vm.setBulkColor
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "bulk-color-modal__section"
	  }, [_c('div', {
	    staticClass: "d-label-and-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.bulkRoomEnabled = !_vm.bulkRoomEnabled
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_c('span', {
	    staticClass: "icon-location"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['change_room'] || 'Skift lokale'))]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "propOn": _vm.bulkRoomEnabled,
	      "allowChanges": false
	    }
	  })], 1), _vm._v(" "), (_vm.bulkRoomEnabled) ? _c('div', {
	    staticClass: "bulk-color-modal__field"
	  }, [_c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "ROOM",
	      "isMultiple": false,
	      "preSelectedItems": []
	    },
	    on: {
	      "update": _vm.setBulkRoom
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "bulk-color-modal__actions"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    attrs: {
	      "disabled": _vm.bulkColorLoading
	    },
	    on: {
	      "click": _vm.closeBulkColorModal
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel'] || 'Annullér'))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.bulkColorLoading
	    },
	    attrs: {
	      "disabled": _vm.bulkColorLoading || (!_vm.bulkColorEnabled && !_vm.bulkRoomEnabled && !_vm.bulkNameEnabled && !_vm.bulkHoursEnabled && !_vm.bulkSubjectTypeEnabled && !_vm.bulkPreparationEnabled)
	    },
	    on: {
	      "click": _vm.saveBulkColor
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['update'] || 'Opdatér'))])])])])], 2) : _vm._e(), _vm._v(" "), (_vm.isKlassRoomModalOpen) ? _c('modal', {
	    on: {
	      "close": _vm.closeKlassRoomModal
	    }
	  }, [_c('template', {
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "bulk-color-modal__header",
	    style: ({
	      'backgroundColor': '#468AD7'
	    })
	  }, [_c('h2', [_vm._v(_vm._s(_vm.klassRoomName))])]), _vm._v(" "), _c('div', {
	    staticClass: "bulk-color-modal__body"
	  }, [_c('div', {
	    staticClass: "bulk-color-modal__section"
	  }, [_c('label', {
	    staticClass: "bulk-color-modal__label"
	  }, [_c('span', {
	    staticClass: "icon-location"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_room_to_klass']))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "ROOM",
	      "isMultiple": false,
	      "preSelectedItems": _vm.klassRoomSelected
	    },
	    on: {
	      "update": _vm.setKlassRoom
	    }
	  })], 1), _vm._v(" "), (_vm.klassRoomSubjects.length > 0) ? _c('div', {
	    staticClass: "bulk-color-modal__section"
	  }, [_c('label', {
	    staticClass: "bulk-color-modal__label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select_subjects']))]), _vm._v(" "), _c('ul', {
	    staticClass: "klass-room-subjects"
	  }, _vm._l((_vm.klassRoomSubjects), function(subj) {
	    return _c('li', {
	      key: subj.id,
	      staticClass: "klass-room-subjects__item",
	      on: {
	        "click": function($event) {
	          return _vm.toggleKlassRoomSubject(subj.id)
	        }
	      }
	    }, [_c('input', {
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "checked": !_vm.klassRoomExcluded[subj.id]
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.toggleKlassRoomSubject(subj.id)
	        }
	      }
	    }), _vm._v(" "), _c('span', {
	      staticClass: "klass-room-subjects__color",
	      style: ({
	        'backgroundColor': subj.cell.klass.color
	      })
	    }), _vm._v(" "), _c('span', {
	      staticClass: "klass-room-subjects__name"
	    }, [_vm._v(_vm._s(subj.name))])])
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "bulk-color-modal__actions"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    attrs: {
	      "disabled": _vm.klassRoomLoading
	    },
	    on: {
	      "click": _vm.closeKlassRoomModal
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--loading': _vm.klassRoomLoading
	    },
	    attrs: {
	      "disabled": _vm.klassRoomLoading || _vm.klassRoomSelected.length === 0
	    },
	    on: {
	      "click": _vm.saveKlassRoom
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['update']))])])])])], 2) : _vm._e(), _vm._v(" "), (_vm.isSubjectModal) ? _c('SubjectForm', {
	    attrs: {
	      "propCalendarId": _vm.createInCalendarId,
	      "showModal": _vm.isSubjectModal,
	      "editSubject": _vm.editSubject,
	      "isActivities": _vm.isActivities
	    },
	    on: {
	      "close": _vm.closeModal,
	      "createSubject": _vm.createNewSubject,
	      "updateSubject": _vm.updateSubject,
	      "deleteSubject": _vm.deleteSubject,
	      "saveAndShowTab": _vm.saveAndShowTab
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1783 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false,
	      "placeInTop": true
	    }
	  }, [_c('div', {
	    staticClass: "do-modal do-modal__edit-user-norm",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2', [_vm._v("Rediger " + _vm._s(_vm.user.name))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "do-spinner__container"
	  }, [_c('div', {
	    staticClass: "do-spinner do-spinner--large"
	  })]) : _vm._e(), _vm._v(" "), _c('AssignHoursNormList', {
	    attrs: {
	      "isNetto": false,
	      "schoolYear": _vm.schoolYear,
	      "theEditUserNorm": _vm.theEditUserNorm
	    },
	    on: {
	      "updated": _vm.setItemsToSave,
	      "changedSum": _vm.setNettoTime
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isUpdating
	    },
	    on: {
	      "click": _vm.onUpdate
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.update')) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1784 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('th', {
	    attrs: {
	      "colspan": "8"
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.user.vName) + "\n  ")])]), _vm._v(" "), _c('tbody', [(_vm.user.vFag.length > 0) ? _c('tr', {
	    staticClass: "tr__header"
	  }, [_c('td', [_vm._v("Fag")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("Lærerklokketimer")]), _vm._v(" "), _c('td', {
	    staticClass: "klokketime-td"
	  }, [_vm._v("Lærerklokketimer type")])]) : _vm._e(), _vm._v(" "), (_vm.user.vFag.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "text-explainer",
	    attrs: {
	      "colspan": "8"
	    }
	  }, [_vm._v("\n      Brugeren har ingen fag\n    ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.user.vFag), function(fag) {
	    return _c('tr', [_c('td', [_c('div', {
	      staticClass: "subject"
	    }, [_vm._v("\n        " + _vm._s(fag.fag_navn) + " (" + _vm._s(fag.klasse_klokketimer) + ")\n      ")])]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "100%"
	      }
	    }, [_vm._v("\n      " + _vm._s(fag.klassebetegnelse) + "\n    ")]), _vm._v(" "), _c('td', [_c('input', {
	      staticClass: "d-input__small",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": fag.learer_klokketimer
	      },
	      on: {
	        "focus": function($event) {
	          return $event.target.select()
	        },
	        "keyup": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	          return _vm.updateStilKlasseFagLaerer(_vm.user, fag, 'klokketimer', $event.target.value, $event.target)
	        },
	        "blur": function($event) {
	          return _vm.updateStilKlasseFagLaerer(_vm.user, fag, 'klokketimer', $event.target.value, $event.target)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('select', {
	      staticClass: "d-select__small",
	      domProps: {
	        "value": fag.klokketimer_type
	      },
	      on: {
	        "change": function($event) {
	          return _vm.updateStilKlasseFagLaerer(_vm.user, fag, 'klokketimer_type', $event.target.value)
	        }
	      }
	    }, _vm._l((_vm.klokketimetyper), function(type, key) {
	      return _c('option', {
	        domProps: {
	          "value": key
	        }
	      }, [_vm._v(_vm._s(type))])
	    }), 0)])])
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1785 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.isVisible) ? _c('div', {
	    staticClass: "calendar-bulk-actions"
	  }, [_c('button', {
	    staticClass: "do-bttn calendar-bulk-actions__clear",
	    on: {
	      "click": _vm.clearSelection
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.i18n[_vm.locale]['cancel_selection']) + "\n  ")]), _vm._v(" "), _c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "isBottomStart": false,
	      "isCloseOnDropdownClick": true,
	      "propOffset": [0, 8]
	    },
	    scopedSlots: _vm._u([{
	      key: "title",
	      fn: function() {
	        return [_c('button', {
	          staticClass: "do-bttn calendar-bulk-actions__bttn",
	          attrs: {
	            "id": "vue-popper__massehandling_button"
	          }
	        }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['bulk_actions']) + " (" + _vm._s(_vm.selectedEventIds.length) + ")\n        "), _c('span', {
	          staticClass: "icon-arrow-down5"
	        })])]
	      },
	      proxy: true
	    }, {
	      key: "list",
	      fn: function() {
	        return [_c('ul', [_c('li', {
	          on: {
	            "click": _vm.startBulkCopy
	          }
	        }, [_c('span', {
	          staticClass: "icon-clipboard2"
	        }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['copy_events']) + "\n        ")]), _vm._v(" "), _c('li', {
	          on: {
	            "click": function($event) {
	              return _vm.openDeleteModal('cancel')
	            }
	          }
	        }, [_c('span', {
	          staticClass: "icon-notification22"
	        }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['cancel_events']) + "\n        ")]), _vm._v(" "), _c('li', {
	          on: {
	            "click": function($event) {
	              return _vm.openDeleteModal('uncancel')
	            }
	          }
	        }, [_c('span', {
	          staticClass: "icon-checkmark4"
	        }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['uncancel_events']) + "\n        ")]), _vm._v(" "), _c('li', {
	          on: {
	            "click": function($event) {
	              return _vm.openDeleteModal('away')
	            }
	          }
	        }, [_c('span', {
	          staticClass: "icon-notification22"
	        }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['away_events']) + "\n        ")]), _vm._v(" "), _c('li', {
	          on: {
	            "click": function($event) {
	              return _vm.openDeleteModal('unaway')
	            }
	          }
	        }, [_c('span', {
	          staticClass: "icon-checkmark4"
	        }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['unaway_events']) + "\n        ")]), _vm._v(" "), _c('li', {
	          staticClass: "d-item-warning",
	          on: {
	            "click": function($event) {
	              return _vm.openDeleteModal('week')
	            }
	          }
	        }, [_c('span', {
	          staticClass: "icon-bin"
	        }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['delete_in_week']) + "\n        ")]), _vm._v(" "), _c('li', {
	          staticClass: "d-item-warning",
	          on: {
	            "click": function($event) {
	              return _vm.openDeleteModal('onward')
	            }
	          }
	        }, [_c('span', {
	          staticClass: "icon-bin"
	        }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['delete_events_onward']) + "\n        ")])])]
	      },
	      proxy: true
	    }], null, false, 3712525313)
	  }), _vm._v(" "), _c('CopyEvent', {
	    attrs: {
	      "bulk": true
	    }
	  }), _vm._v(" "), (_vm.isDeleteModal) ? _c('Modal', {
	    on: {
	      "close": _vm.closeDeleteModal
	    }
	  }, [_c('div', {
	    staticClass: "bulk-delete__modal text-dark",
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "bulk-delete__modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['are_you_sure']))])]), _vm._v(" "), _c('div', {
	    staticClass: "bulk-delete__modal__form"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.deleteQuestion))]), _vm._v(" "), _c('div', {
	    staticClass: "bulk-delete__modal__footer"
	  }, [_c('button', {
	    attrs: {
	      "disabled": _vm.isDeleting
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.closeDeleteModal.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['cancel']) + "\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn--warning bttn marg-10-left",
	    class: {
	      'bttn--red': _vm.deleteMode !== 'uncancel' && _vm.deleteMode !== 'unaway'
	    },
	    attrs: {
	      "disabled": _vm.isDeleting
	    },
	    on: {
	      "click": _vm.confirmDelete
	    }
	  }, [(_vm.isDeleting) ? _c('span', {
	    staticClass: "bulk-delete__spinner"
	  }) : [_vm._v(_vm._s(_vm.confirmButtonLabel))]], 2)])])])]) : _vm._e()], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1786 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "request-subjects text-dark"
	  }, [_vm._m(0), _vm._v(" "), (_vm.isLoading || _vm.isLoadingSubjectsRequests) ? _c('Loader') : _c('div', {
	    staticClass: "request-subjects-grid"
	  }, [_c('RequestSubjectsUser', {
	    attrs: {
	      "user": _vm.user,
	      "assignedTeaching": _vm.assignedSubjectsTeaching,
	      "assignedOther": _vm.assignedSubjectsOther,
	      "showAssignedSubjects": _vm.canShowAssignedSubjects,
	      "userSubjectsTeaching": _vm.userRequestedTeachingSubjects,
	      "userSubjectsOther": _vm.userRequestedOtherSubjects,
	      "allCalendarsInHash": _vm.allCalendarsInHash,
	      "loadingSubjects": _vm.loadingSubjects,
	      "isPoolsDeactivated": _vm.isPoolsDeactivated,
	      "poolTeachingHours": _vm.poolTeachingHours,
	      "poolOtherHours": _vm.poolOtherHours,
	      "hasOtherSubjects": _vm.hasOtherSubjects,
	      "showLessonsPerWeek": _vm.isLessonsPerWeekActive,
	      "subjectDefaultDuration": _vm.subjectDefaultDuration
	    },
	    on: {
	      "removeSubject": function($event) {
	        return _vm.onSetSubjectRequest($event)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "doTable"
	  }, [_c('div', {
	    staticClass: "subject-dist__header"
	  }, [_c('div', {
	    staticClass: "subject-dist__header__left"
	  }, [(_vm.selectedTab === 'Fag') ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Klasser',
	      "tags": _vm.klassTags,
	      "selectedTags": _vm.selectedKlassFilters
	    },
	    on: {
	      "select": _vm.toggleKlassTag,
	      "clear": function($event) {
	        _vm.selectedKlassFilters = []
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'Fag') ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Status på fag',
	      "tags": _vm.statusFilters,
	      "selectedTags": _vm.selectedStatusFilters
	    },
	    on: {
	      "select": _vm.toggleSelectedStatusFilters,
	      "clear": function($event) {
	        _vm.selectedStatusFilters = []
	      }
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.isSchoolDanish) ? _c('div', {
	    staticClass: "label-with-toggle",
	    on: {
	      "click": function($event) {
	        _vm.showLessonsPerWeek = !_vm.showLessonsPerWeek
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Se undervisning i lektioner")]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.showLessonsPerWeek
	    },
	    on: {
	      "changed": function($event) {
	        _vm.showLessonsPerWeek = $event
	      }
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), (_vm.selectedTab === 'Opgaver') ? _c('table', {
	    staticClass: "do-table do-table__tasks"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', {
	    staticClass: "td-number"
	  }, [_vm._v("Timer")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tasks), function(task) {
	    return _c('tr', {
	      key: task.id
	    }, [_c('td', [_c('button', {
	      staticClass: "do-bttn do-bttn--request-subject marg-1-right",
	      on: {
	        "click": function($event) {
	          _vm.onSetSubjectRequest(task.id)
	        }
	      }
	    }, [_vm._v("\n              Ønsk\n            ")]), _vm._v("\n            " + _vm._s(task.name) + "\n          ")]), _vm._v(" "), _c('td', {
	      staticClass: "td-number"
	    }, [_vm._v(_vm._s(task.hours))])])
	  }), 0)]) : _c('ul', {
	    staticClass: "doTable__items"
	  }, _vm._l((_vm.filteredKlassCals), function(klassCal, idx) {
	    return _c('li', {
	      key: klassCal.id,
	      staticClass: "doTable__klass"
	    }, [_c('div', {
	      staticClass: "doTable__klass__header"
	    }, [_c('div', [_vm._v(_vm._s(klassCal.name))])]), _vm._v(" "), _c('ul', {
	      staticClass: "subjects"
	    }, _vm._l((klassCal.vSubjects), function(subject) {
	      return _c('li', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: true,
	            onShow: function () { return subject.vRequestedBy.length > 0 || subject.vHasTeachers; }
	          }),
	          expression: "{\n          arrow: true,\n          onShow: () => subject.vRequestedBy.length > 0 || subject.vHasTeachers\n        }"
	        }],
	        key: subject.id,
	        staticClass: "subjects_subject",
	        class: [{
	          'subject--has-user': subject.vRequestedBy.length > 0
	        }],
	        style: ({
	          'background': subject.color
	        }),
	        attrs: {
	          "content": !subject.vHasTeachers ? 'Ønsket af ' + subject.vRequestedBy : subject.vUserNames + ' er valgt'
	        }
	      }, [_vm._v("\n\n              " + _vm._s(subject.name) + " (" + _vm._s(_vm.isLessonsPerWeekActive && subject.master_type !== 'other' ? subject.vLessonsPerWeek : subject.vHours) + ")\n              "), (!subject.vHasTeachers) ? _c('button', {
	        staticClass: "do-bttn do-bttn--request-subject",
	        class: {
	          'do-bttn--remove': subject.vIsRequestedByUser
	        },
	        on: {
	          "click": function($event) {
	            return _vm.onSetSubjectRequest(subject.id)
	          }
	        }
	      }, [(subject.vIsLoading) ? _c('div', {
	        staticClass: "do-spinner do-spinner__small"
	      }) : [_vm._v("\n                  " + _vm._s(subject.vIsRequestedByUser ? 'Fjern ønske' : 'Ønsk') + "\n                ")]], 2) : _vm._e()])
	    }), 0)])
	  }), 0)])], 1)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "request-subjects__header"
	  }, [_c('h1', [_vm._v("Ønsker til fagfordelingen")])])
	}]}

/***/ }),
/* 1787 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true,
	      "appendToBody": true,
	      "isCloseOnEsc": !_vm.theEditUser
	    },
	    on: {
	      "close": _vm.onClose
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-create-task-for-user"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__content text-dark"
	  }, [_c('div', {
	    staticClass: "d-modal__content__sidebar"
	  }, [_c('h2', [_vm._v("Opsætning af vikarløn")]), _vm._v(" "), _c('ul', {
	    staticClass: "d-modal__content__sidebar__nav"
	  }, _vm._l((_vm.tabs), function(tab) {
	    return _c('li', {
	      staticClass: "d-modal__content__sidebar__nav-item",
	      class: {
	        'd-modal__content__sidebar__nav-item--active': tab.id === _vm.theActiveTab
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheActiveTab(tab.id)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(tab.title) + "\n          ")])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content__body"
	  }, [_c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.onClose
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), (_vm.isInitLoading) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  }) : [(_vm.theActiveTab === 1) ? _c('SalarySettingsUsers', {
	    attrs: {
	      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive
	    },
	    on: {
	      "setEditUser": _vm.setEditUser,
	      "changedMade": function($event) {
	        _vm.isChangesMade = true
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 2) ? _c('SalaryRule1', {
	    attrs: {
	      "schoolIds": [_vm.schoolId],
	      "config": _vm.config,
	      "propRules": _vm.rules,
	      "schoolSubstituteRules": _vm.schoolSubstituteRules
	    },
	    on: {
	      "changedMade": function($event) {
	        _vm.isChangesMade = true
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 3) ? _c('SalaryRule2', {
	    attrs: {
	      "config": _vm.config,
	      "propRules": _vm.rules
	    },
	    on: {
	      "onSubmit": _vm.updateSchoolConfiguration
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 4) ? _c('SalaryRule3', {
	    attrs: {
	      "config": _vm.config,
	      "propRules": _vm.rules
	    },
	    on: {
	      "onSubmit": _vm.updateSchoolConfiguration
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 5) ? _c('SalaryRule4', {
	    attrs: {
	      "config": _vm.config,
	      "propRules": _vm.rules
	    },
	    on: {
	      "onSubmit": _vm.updateSchoolConfiguration
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 6) ? _c('CostCenters', {
	    attrs: {
	      "isInSchoolSalarySettings": false,
	      "costCenterRules": _vm.costCenterRules
	    },
	    on: {
	      "updateCostCenterRules": _vm.updateCostCenterRules
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 7) ? _c('SalaryCodes', {
	    attrs: {
	      "isInSchoolSalarySettings": false
	    }
	  }) : _vm._e()]], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 1788 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "request-subjects__user text-dark"
	  }, [_c('div', {
	    staticClass: "request-subjects__user__header"
	  }, [_c('h2', {
	    staticClass: "pad-1"
	  }, [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "request-subjects__subsection"
	  }, [_c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_vm._m(0), _vm._v(" "), _c('th', {
	    staticClass: "number"
	  }, [_vm._v(_vm._s(_vm.displaySumTeaching))])])]), _vm._v(" "), _c('tbody', [(_vm.userSubjectsTeaching.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Ingen undervisning ønsket")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.userSubjectsTeaching), function(subject) {
	    return _c('tr', {
	      key: subject.id
	    }, [_c('td', {
	      staticClass: "td-delete"
	    }, [(!_vm.loadingSubjects[subject.id]) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true
	        }),
	        expression: "{ arrow: true }"
	      }],
	      staticClass: "icon__bg-circle icon-bin",
	      attrs: {
	        "content": "Fjern ønske"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.$emit('removeSubject', subject.id)
	        }
	      }
	    }) : _c('div', {
	      staticClass: "do-spinner do-spinner-small"
	    })]), _vm._v(" "), _c('td', {
	      staticClass: "td-subjects"
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          onShow: function () { return subject.vRequestedBy.length > 0; }
	        }),
	        expression: "{\n          arrow: true,\n          onShow: () => subject.vRequestedBy.length > 0\n        }"
	      }],
	      staticClass: "subjects_subject subjects_subject__simple",
	      class: {
	        'subjects_subject--has-user': subject.vRequestedBy.length > 0
	      },
	      style: ([{
	        'border-left-color': subject.color
	      }, {
	        'background-color': subject.color
	      }]),
	      attrs: {
	        "content": !subject.vHasTeachers ? 'Ønsket af ' + subject.vRequestedBy : subject.vUserNames + ' er valgt'
	      }
	    }, [_vm._v("\n            " + _vm._s(subject.name) + "\n          ")])]), _vm._v(" "), _c('td', {
	      staticClass: "td-calendars"
	    }, [_vm._v(_vm._s(subject.vKlass))]), _vm._v(" "), _c('td', {
	      staticClass: "number"
	    }, [_vm._v("\n          " + _vm._s(_vm.showLessonsPerWeek ? subject.vLessonsPerWeek : subject.vHours) + "\n        ")])])
	  })], 2)])]), _vm._v(" "), (_vm.userSubjectsOther.length > 0 && _vm.showOtherTasks) ? _c('div', {
	    staticClass: "request-subjects__subsection"
	  }, [_c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_vm._m(1), _vm._v(" "), _c('th', {
	    staticClass: "number text--grey"
	  }, [_vm._v(_vm._s(_vm.sumOfHoursOther))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.userSubjectsOther), function(subject) {
	    return _c('tr', {
	      key: subject.id
	    }, [_c('td', {
	      staticClass: "td-delete"
	    }, [(!_vm.loadingSubjects[subject.id]) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true
	        }),
	        expression: "{ arrow: true }"
	      }],
	      staticClass: "icon__bg-circle icon-bin",
	      attrs: {
	        "content": "Fjern ønske"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.$emit('removeSubject', subject.id)
	        }
	      }
	    }) : _c('div', {
	      staticClass: "do-spinner do-spinner-small"
	    })]), _vm._v(" "), _c('td', {
	      staticClass: "td-subjects"
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          onShow: function () { return subject.vRequestedBy.length > 0; }
	        }),
	        expression: "{\n          arrow: true,\n          onShow: () => subject.vRequestedBy.length > 0\n        }"
	      }],
	      staticClass: "subjects_subject subjects_subject__simple",
	      class: {
	        'subjects_subject--has-user': subject.vRequestedBy.length > 0
	      },
	      style: ([{
	        'border-left-color': subject.color
	      }, {
	        'background-color': subject.color
	      }]),
	      attrs: {
	        "content": !subject.vHasTeachers ? 'Ønsket af ' + subject.vRequestedBy : subject.vUserNames + ' er valgt'
	      }
	    }, [_vm._v("\n            " + _vm._s(subject.name) + "\n          ")])]), _vm._v(" "), _c('td', {
	      staticClass: "td-calendars"
	    }, [_vm._v(_vm._s(subject.vKlass))]), _vm._v(" "), _c('td', {
	      staticClass: "number"
	    }, [_vm._v("\n          " + _vm._s(subject.vHours) + "\n        ")])])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.showAssignedSubjects) ? _c('div', {
	    staticClass: "request-subjects__user__section"
	  }, [_c('table', {
	    staticClass: "d-table request-subjects__assigned"
	  }, [_c('thead', {
	    staticStyle: {
	      "padding": "0"
	    }
	  }, [_c('tr', {
	    on: {
	      "click": function($event) {
	        _vm.isAssignedTeachingOpen = !_vm.isAssignedTeachingOpen
	      }
	    }
	  }, [_c('th', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_c('div', {
	    staticClass: "request-subjects__toggle"
	  }, [_c('span', {
	    staticClass: "request-subjects__toggle__left"
	  }, [_c('h4', [_vm._v("Tildelt undervisning")]), _vm._v(" "), _c('span', {
	    class: _vm.isAssignedTeachingOpen ? 'icon-arrow-up4' : 'icon-arrow-down4'
	  })])])]), _vm._v(" "), _c('th', {
	    staticClass: "number text--grey"
	  }, [_vm._v(_vm._s(_vm.displayAssignedSumTeaching))])])]), _vm._v(" "), (_vm.isAssignedTeachingOpen) ? _c('tbody', [(_vm.assignedTeaching.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Ingen fag eller undervisningsopgaver tildelt")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.assignedTeaching), function(subject) {
	    return _c('tr', {
	      key: subject.rowId || subject.id
	    }, [_c('td', {
	      staticClass: "td-subjects td-subjects--assigned"
	    }, [_c('div', {
	      staticClass: "subjects_subject subjects_subject__simple",
	      style: ([{
	        'border-left-color': subject.color
	      }, {
	        'background-color': subject.color
	      }])
	    }, [_vm._v("\n            " + _vm._s(subject.name) + "\n          ")])]), _vm._v(" "), _c('td', {
	      staticClass: "td-calendars"
	    }, [_c('div', [_vm._v(_vm._s(subject.vKlass))])]), _vm._v(" "), _c('td', {
	      staticClass: "number"
	    }, [_vm._v("\n          " + _vm._s(_vm.displayHours(subject.vHours)) + "\n        ")])])
	  })], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showAssignedSubjects && _vm.showOtherTasks && !_vm.showPoolInfo) ? _c('div', {
	    staticClass: "request-subjects__user__section"
	  }, [_c('table', {
	    staticClass: "d-table request-subjects__assigned"
	  }, [_c('thead', {
	    staticStyle: {
	      "padding": "0"
	    }
	  }, [_c('tr', {
	    on: {
	      "click": function($event) {
	        _vm.isAssignedOtherOpen = !_vm.isAssignedOtherOpen
	      }
	    }
	  }, [_c('th', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_c('div', {
	    staticClass: "request-subjects__toggle"
	  }, [_c('span', {
	    staticClass: "request-subjects__toggle__left"
	  }, [_c('h4', [_vm._v("Tildelt øvrige opgaver")]), _vm._v(" "), _c('span', {
	    class: _vm.isAssignedOtherOpen ? 'icon-arrow-up4' : 'icon-arrow-down4'
	  })])])]), _vm._v(" "), _c('th', {
	    staticClass: "number text--grey"
	  }, [_vm._v(_vm._s(_vm.assignedSumOther))])])]), _vm._v(" "), (_vm.isAssignedOtherOpen) ? _c('tbody', [(_vm.assignedOther.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Ingen øvrige opgaver tildelt")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.assignedOther), function(subject) {
	    return _c('tr', {
	      key: subject.rowId || subject.id
	    }, [_c('td', {
	      staticClass: "td-subjects td-subjects--assigned"
	    }, [_c('div', {
	      staticClass: "subjects_subject subjects_subject__simple",
	      style: ([{
	        'border-left-color': subject.color
	      }, {
	        'background-color': subject.color
	      }])
	    }, [_vm._v("\n            " + _vm._s(subject.name) + "\n          ")])]), _vm._v(" "), _c('td', {
	      staticClass: "td-calendars"
	    }, [_c('div', [_vm._v(_vm._s(subject.vKlass))])]), _vm._v(" "), _c('td', {
	      staticClass: "number"
	    }, [_vm._v("\n          " + _vm._s(_vm.formatHours(subject.vHours)) + "\n        ")])])
	  })], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showAssignedSubjects) ? _c('table', {
	    staticClass: "d-table request-subjects__total"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": !_vm.showPoolInfo ? 3 : 2
	    }
	  }, [_c('h4', [_vm._v("Samlet")])]), _vm._v(" "), (_vm.showPoolInfo) ? _c('td', {
	    staticClass: "number text--grey"
	  }, [_vm._v(_vm._s(_vm.displayTotalTeachingCombined))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Ønsket undervisning")]), _vm._v(" "), _c('td', {
	    staticClass: "number text-dark"
	  }, [_vm._v(_vm._s(_vm.displaySumTeaching))])]), _vm._v(" "), _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Tildelt undervisning")]), _vm._v(" "), _c('td', {
	    staticClass: "number text-dark"
	  }, [_vm._v(_vm._s(_vm.displayAssignedSumTeaching))])]), _vm._v(" "), (_vm.showOtherPoolInfo) ? [_c('tr', [_c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Ønsket øvrige opgaver")]), _vm._v(" "), _c('td', {
	    staticClass: "number text-dark"
	  }, [_vm._v(_vm._s(_vm.sumOfHoursOther))])]), _vm._v(" "), _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Tildelt øvrige opgaver")]), _vm._v(" "), _c('td', {
	    staticClass: "number text-dark"
	  }, [_vm._v(_vm._s(_vm.assignedSumOther))])])] : _vm._e(), _vm._v(" "), (_vm.showPoolInfo) ? [_c('tr', {
	    staticClass: "pool-summary"
	  }, [_c('td', [_c('span', {
	    staticClass: "pool-label"
	  }, [_vm._v("UV-pulje")]), _vm._v(" "), _c('span', {
	    staticClass: "pool-value"
	  }, [_vm._v(_vm._s(_vm.displayPoolTeachingHours))])]), _vm._v(" "), _c('td', [_c('span', {
	    staticClass: "pool-label"
	  }, [_vm._v("Ønsket og tildelt")]), _vm._v(" "), _c('span', {
	    staticClass: "pool-value"
	  }, [_vm._v(_vm._s(_vm.displayTotalTeachingCombined))])]), _vm._v(" "), _c('td', [_c('span', {
	    staticClass: "pool-label"
	  }, [_vm._v("Rest")]), _vm._v(" "), _c('span', {
	    staticClass: "pool-value",
	    class: {
	      'pool-value--negative': parseFloat(_vm.teachingDiff) < 0
	    }
	  }, [_vm._v(_vm._s(_vm.displayTeachingDiff))])])])] : _vm._e(), _vm._v(" "), (!_vm.showPoolInfo) ? [(_vm.showOtherTasks) ? _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Ønsket øvrige opgaver")]), _vm._v(" "), _c('td', {
	    staticClass: "number text-dark"
	  }, [_vm._v(_vm._s(_vm.sumOfHoursOther))])]) : _vm._e(), _vm._v(" "), (_vm.showOtherTasks) ? _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Tildelt øvrige opgaver")]), _vm._v(" "), _c('td', {
	    staticClass: "number text-dark"
	  }, [_vm._v(_vm._s(_vm.assignedSumOther))])]) : _vm._e(), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', {
	    staticClass: "number text-dark"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.totalSumOfHours))])])])] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showAssignedSubjects && _vm.showOtherTasks && _vm.showPoolInfo) ? _c('div', {
	    staticClass: "request-subjects__user__section"
	  }, [_c('table', {
	    staticClass: "d-table request-subjects__assigned marg-1-top"
	  }, [_c('thead', {
	    staticStyle: {
	      "padding": "0"
	    }
	  }, [_c('tr', {
	    on: {
	      "click": function($event) {
	        _vm.isAssignedOtherOpen = !_vm.isAssignedOtherOpen
	      }
	    }
	  }, [_c('th', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_c('div', {
	    staticClass: "request-subjects__toggle"
	  }, [_c('span', {
	    staticClass: "request-subjects__toggle__left"
	  }, [_c('h4', [_vm._v("Tildelt øvrige opgaver")]), _vm._v(" "), _c('span', {
	    class: _vm.isAssignedOtherOpen ? 'icon-arrow-up4' : 'icon-arrow-down4'
	  })])])]), _vm._v(" "), _c('th', {
	    staticClass: "number text-dark"
	  }, [_vm._v(_vm._s(_vm.assignedSumOther))])])]), _vm._v(" "), (_vm.isAssignedOtherOpen) ? _c('tbody', [(_vm.assignedOther.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Ingen øvrige opgaver tildelt")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.assignedOther), function(subject) {
	    return _c('tr', {
	      key: subject.rowId || subject.id
	    }, [_c('td', {
	      staticClass: "td-subjects td-subjects--assigned"
	    }, [_c('div', {
	      staticClass: "subjects_subject subjects_subject__simple",
	      style: ([{
	        'border-left-color': subject.color
	      }, {
	        'background-color': subject.color
	      }])
	    }, [_vm._v("\n            " + _vm._s(subject.name) + "\n          ")])]), _vm._v(" "), _c('td', {
	      staticClass: "td-calendars"
	    }, [_c('div', [_vm._v(_vm._s(subject.vKlass))])]), _vm._v(" "), _c('td', {
	      staticClass: "number"
	    }, [_vm._v("\n          " + _vm._s(_vm.formatHours(subject.vHours)) + "\n        ")])])
	  })], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showOtherPoolInfo) ? _c('table', {
	    staticClass: "d-table request-subjects__total"
	  }, [_c('tbody', [_c('tr', {
	    staticClass: "pool-summary"
	  }, [_c('td', [_c('span', {
	    staticClass: "pool-label"
	  }, [_vm._v("Øvrig-pulje")]), _vm._v(" "), _c('span', {
	    staticClass: "pool-value"
	  }, [_vm._v(_vm._s(_vm.poolOtherHours))])]), _vm._v(" "), _c('td', [_c('span', {
	    staticClass: "pool-label"
	  }, [_vm._v("Ønsket og tildelt")]), _vm._v(" "), _c('span', {
	    staticClass: "pool-value"
	  }, [_vm._v(_vm._s(_vm.totalOtherCombined))])]), _vm._v(" "), _c('td', [_c('span', {
	    staticClass: "pool-label"
	  }, [_vm._v("Rest")]), _vm._v(" "), _c('span', {
	    staticClass: "pool-value",
	    class: {
	      'pool-value--negative': parseFloat(_vm.otherDiff) < 0
	    }
	  }, [_vm._v(_vm._s(_vm.otherDiff))])])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('h4', [_vm._v("Dine ønsker – Undervisning")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('h4', [_vm._v("Dine ønsker – Øvrige opgaver")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_c('strong', [_vm._v("I alt")])])
	}]}

/***/ }),
/* 1789 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "loader",
	    class: [{
	      'loader--small': _vm.isSmall
	    }, {
	      'loader--modal': _vm.isLoaderModal
	    }, {
	      'loader--extra-small': _vm.isExtraSmall
	    }],
	    style: (_vm.styleObj),
	    attrs: {
	      "role": "status",
	      "aria-live": "polite",
	      "aria-label": _vm.$t('vue2.a11y.loading')
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1790 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-search",
	    on: {
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "search-wrapper"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search),
	      expression: "search"
	    }],
	    ref: "search_input",
	    staticClass: "search-wrapper__search",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('repitition.search_for') + ' ' + _vm.$t('repitition.skole')
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
	        $event.preventDefault();
	        return _vm.focusOption(0)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.chooseFirst.apply(null, arguments)
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "list-search__body"
	  }, [_c('ul', _vm._l((_vm.searchList), function(option, index) {
	    return _c('li', [_c('a', {
	      staticClass: "js-list-search-option",
	      attrs: {
	        "href": option.url,
	        "data-no-turbolink": "true"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.chooseItem(option)
	        },
	        "keydown": [function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
	          $event.preventDefault();
	          return _vm.focusOption(index + 1)
	        }, function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
	          $event.preventDefault();
	          return _vm.focusOption(index - 1)
	        }, function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "home", undefined, $event.key, undefined)) { return null; }
	          $event.preventDefault();
	          return _vm.focusOption(0)
	        }, function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "end", undefined, $event.key, undefined)) { return null; }
	          $event.preventDefault();
	          return _vm.focusOption(_vm.searchList.length - 1)
	        }]
	      }
	    }, [_vm._v(_vm._s(option.name))])])
	  }), 0)])])
	},staticRenderFns: []}

/***/ }),
/* 1791 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-copy-cals text-dark"
	  }, [_c('div', {
	    staticClass: "d-acc",
	    class: {
	      'd-acc--open': _vm.isAccOpen
	    }
	  }, [_c('div', {
	    staticClass: "d-acc__header",
	    on: {
	      "click": _vm.toggleIsAccOpen
	    }
	  }, [_c('div', {
	    staticClass: "d-acc__header__left"
	  }, [_c('div', {
	    staticClass: "d-toggle-arrow",
	    class: {
	      'd-toggle-arrow--open': _vm.isAccOpen
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.title) + " (" + _vm._s(_vm.calendarsExclArchivedWithoutFilters.length) + ")")])])]), _vm._v(" "), (_vm.isAccOpen) ? _c('ul', {
	    staticClass: "d-copy-cals__list"
	  }, [(_vm.calType === 'user') ? _c('li', {
	    staticClass: "select-all-item d-copy-cals__list__header select-all-item d-copy-cals__list__header__filters"
	  }, [_c('TaggingFilter', {
	    attrs: {
	      "schoolid": _vm.schoolId,
	      "showHowMany": false,
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters
	    },
	    on: {
	      "set": _vm.setTagFromFilter,
	      "remove": _vm.removeTagFromFilter
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "select-all-item d-copy-cals__list__header"
	  }, [_c('p', {
	    staticClass: "d-acc__header__select-all",
	    on: {
	      "click": _vm.toggleAllKlasses
	    }
	  }, [(_vm.selectedCalIds.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.select_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-copy-cals__list__header__right"
	  }, [_c('p', [_vm._v(_vm._s(_vm.selectedCalIds.length) + " " + _vm._s(_vm.$t('vue2.calendars.selected_of')) + " " + _vm._s(_vm.calendarsExclArchived.length))]), _vm._v(" "), (_vm.selectedCalIds.length < 1) ? _c('button', {
	    staticClass: "bttn--disabled hint--bottom-left",
	    attrs: {
	      "aria-label": this.$t('vue2.calendars.select_calendars_to_copy')
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendars.copy')) + "\n          ")]) : _c('CopyButton', {
	    attrs: {
	      "calType": _vm.calType
	    },
	    on: {
	      "open": function($event) {
	        _vm.isCopyOpen = true
	      },
	      "close": function($event) {
	        _vm.isCopyOpen = false
	      },
	      "submit": function($event) {
	        return _vm.copyCals($event)
	      }
	    }
	  })], 1)]), _vm._v(" "), _vm._l((_vm.calendarsExclArchived), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "d-copy-cals__cal",
	      class: {
	        'd-copy-cals__cal--selected': _vm.getIsInSelectedCalIds(calendar.id)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toogleCal(calendar.id)
	        }
	      }
	    }, [_vm._m(0, true), _vm._v("\n        " + _vm._s(calendar.name) + "\n      ")])
	  })], 2) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-copy-cals__cal__selector"
	  }, [_c('div', {
	    staticClass: "checkbox"
	  })])
	}]}

/***/ }),
/* 1792 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312313"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('div', [_c('h2', [_vm._v("Beregn UV-tillæg for tidsbegrænset periode")]), _vm._v(" "), _c('p', {
	    staticClass: "tuv__subtitle"
	  }, [_vm._v(_vm._s(_vm.userName))])]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('p', {
	    staticClass: "tuv__intro"
	  }, [_vm._v("\n        Ansættelsen har en afvigende periode. Beregn UV-tillægget ud fra skoledage og UV-tid, så det matcher\n        den faktiske periode. Tillægget lægges som kladde i listen og sendes ikke til lønsystemet.\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "tuv__facts"
	  }, [_c('div', {
	    staticClass: "tuv__fact"
	  }, [_c('span', {
	    staticClass: "tuv__fact-label"
	  }, [_vm._v("Ansættelsesgrad")]), _vm._v(" "), _c('span', {
	    staticClass: "tuv__fact-value"
	  }, [_vm._v(_vm._s(_vm.ansaettelsesgradPercent != null ? _vm.formatPercent(_vm.ansaettelsesgradPercent) : '—'))])]), _vm._v(" "), _c('div', {
	    staticClass: "tuv__fact"
	  }, [_c('span', {
	    staticClass: "tuv__fact-label"
	  }, [_vm._v("Periode")]), _vm._v(" "), _c('span', {
	    staticClass: "tuv__fact-value"
	  }, [_vm._v(_vm._s(_vm.periodLabel))])]), _vm._v(" "), _c('div', {
	    staticClass: "tuv__fact"
	  }, [_c('span', {
	    staticClass: "tuv__fact-label"
	  }, [_vm._v("Bruttotid")]), _vm._v(" "), _c('span', {
	    staticClass: "tuv__fact-value"
	  }, [_vm._v(_vm._s(_vm.yearNormHours != null ? _vm.formatDecimal(_vm.yearNormHours) : '—'))])]), _vm._v(" "), _c('div', {
	    staticClass: "tuv__fact"
	  }, [_c('span', {
	    staticClass: "tuv__fact-label"
	  }, [_vm._v("Lønkode")]), _vm._v(" "), _c('span', {
	    staticClass: "tuv__fact-value"
	  }, [_vm._v(_vm._s(_vm.salaryCodeLabel))])])]), _vm._v(" "), _c('div', {
	    staticClass: "do-form-row"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Skoledage i skoleåret")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.schoolDaysInYear),
	      expression: "schoolDaysInYear"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "number",
	      "min": "0",
	      "inputmode": "numeric",
	      "placeholder": "fx 200"
	    },
	    domProps: {
	      "value": (_vm.schoolDaysInYear)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.schoolDaysInYear = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Skoledage i periode")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.schoolDaysInPeriod),
	      expression: "schoolDaysInPeriod"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "number",
	      "min": "0",
	      "inputmode": "numeric",
	      "placeholder": "fx 46"
	    },
	    domProps: {
	      "value": (_vm.schoolDaysInPeriod)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.schoolDaysInPeriod = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("UV-grænse")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.graense),
	      expression: "graense"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "text",
	      "inputmode": "decimal",
	      "placeholder": "750"
	    },
	    domProps: {
	      "value": (_vm.graense)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.graense = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Justeret timetal")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.adjustedHours),
	      expression: "adjustedHours"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "text",
	      "inputmode": "decimal",
	      "placeholder": "Total UV-tid for perioden"
	    },
	    domProps: {
	      "value": (_vm.adjustedHours)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.adjustedHours = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "tuv__hint"
	  }, [_vm._v("\n          Som standard tæller al tildelt UV-tid med i beregningen. Hvis kun de skemalagte timer i perioden skal\n          bruges, rettes timetallet her. Husk også at opdatere opgaveoversigten, da det er den der danner grundlag\n          for løntilsagnet.\n        ")])]), _vm._v(" "), (_vm.isCalcValid) ? _c('div', {
	    staticClass: "tuv__result"
	  }, [_c('div', {
	    staticClass: "tuv__result-steps"
	  }, [_c('div', {
	    staticClass: "tuv__result-row"
	  }, [_c('span', [_vm._v("UV-timer omregnet til fuld tid")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDecimal(_vm.uvOmregnetFuldtid)))])]), _vm._v(" "), _c('div', {
	    staticClass: "tuv__result-row"
	  }, [_c('span', [_vm._v("Overskud over grænse (fuld tid)")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDecimal(_vm.surplusFuldtid)))])])]), _vm._v(" "), _c('div', {
	    staticClass: "tuv__result-total"
	  }, [_c('span', [_vm._v("UV-tillæg der udbetales i perioden")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatDecimal(_vm.resultUnits)) + " timer")])]), _vm._v(" "), (_vm.resultUnits > 0) ? _c('div', {
	    staticClass: "tuv__result-row tuv__result-row--sub"
	  }, [_c('span', [_vm._v("Fordeles på")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDecimal(_vm.unitsPerInstallment)) + " enh./md · " + _vm._s(_vm.installments) + " " + _vm._s(_vm.installments === 1 ? 'måned' : 'måneder'))])]) : _vm._e(), _vm._v(" "), (_vm.resultUnits <= 0) ? _c('p', {
	    staticClass: "tuv__result-note"
	  }, [_vm._v("\n          UV-tiden er under grænsen i perioden – der dannes ikke noget tillæg.\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.salaryCodeId) ? _c('p', {
	    staticClass: "tuv__result-note"
	  }, [_vm._v("\n        Stillingskategorien mangler en \"Lønkode over UV-grænse\", så der kan ikke dannes et tillæg.\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', {
	    staticClass: "d-modal__buttons__left"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons__right"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSaving
	    },
	    attrs: {
	      "disabled": !_vm.isValid || _vm.isSaving
	    },
	    on: {
	      "click": _vm.generate
	    }
	  }, [_vm._v("\n          Dan UV-tillæg i listen\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1793 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "faste-tillaeg text-dark"
	  }, [_c('h2', {
	    staticClass: "marg-1-bottom capitalize"
	  }, [_vm._v("Faste tillæg")]), _vm._v(" "), _c('div', {
	    staticClass: "faste-tillaeg__header"
	  }, [_c('div', {
	    staticClass: "faste-tillaeg__header__left"
	  }, [_c('Tabs', {
	    attrs: {
	      "tabs": _vm.viewTabs,
	      "selected": _vm.viewTab
	    },
	    on: {
	      "select": _vm.onSelectViewTab
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Personer',
	      "tags": _vm.personNames,
	      "selectedTags": _vm.selectedNames,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg personer'
	    },
	    on: {
	      "select": _vm.toggleName,
	      "clear": function($event) {
	        _vm.selectedNames = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Grupper',
	      "tags": _vm.tags,
	      "selectedTags": _vm.selectedTags,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg grupper'
	    },
	    on: {
	      "select": _vm.toggleTag,
	      "clear": function($event) {
	        _vm.selectedTags = []
	      }
	    }
	  }), _vm._v(" "), (_vm.employmentTitles.length > 1) ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Ansættelser',
	      "tags": _vm.employmentTitles,
	      "selectedTags": _vm.selectedEmploymentTitles,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg stilling'
	    },
	    on: {
	      "select": _vm.toggleEmploymentTitle,
	      "clear": function($event) {
	        _vm.selectedEmploymentTitles = []
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.organisations.length > 1) ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Organisationer',
	      "tags": _vm.organisations,
	      "selectedTags": _vm.selectedOrganisations,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg organisation'
	    },
	    on: {
	      "select": _vm.toggleOrganisation,
	      "clear": function($event) {
	        _vm.selectedOrganisations = []
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.viewTab === 'opus') ? _c('span', {
	    staticClass: "faste-tillaeg__count"
	  }, [_vm._v("\n        Viser " + _vm._s(_vm.filteredRows.length) + " af " + _vm._s(_vm.allRows.length) + " ansættelser\n      ")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.viewTab === 'opus') ? _c('div', {
	    staticClass: "faste-tillaeg__toolbar"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'top',
	        animateFill: false,
	        animation: 'shift-away',
	        boundary: 'window'
	      }),
	      expression: "{\n            arrow: true,\n            placement: 'top',\n            animateFill: false,\n            animation: 'shift-away',\n            boundary: 'window'\n          }"
	    }],
	    staticClass: "faste-tillaeg__toolbar__wrap",
	    attrs: {
	      "content": _vm.selectedEmploymentIds.length === 0 ? 'Vælg personer først' : ''
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': _vm.selectedEmploymentIds.length === 0
	    },
	    attrs: {
	      "disabled": _vm.selectedEmploymentIds.length === 0
	    },
	    on: {
	      "click": _vm.openBulkCreate
	    }
	  }, [_vm._v("\n        Opret faste tillæg\n      ")])]), _vm._v(" "), _c('DDropdown', {
	    attrs: {
	      "isBottomStart": true,
	      "isShowDots": false,
	      "propOffset": [0, 8]
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    staticStyle: {
	      "font-size": "11px"
	    },
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("\n        Beregn tillæg automatisk "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "beregn-menu",
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, _vm._l((_vm.visibleBeregnOptions), function(option) {
	    return _c('li', {
	      key: option.id,
	      on: {
	        "click": function($event) {
	          return _vm.selectBeregnOption(option)
	        }
	      }
	    }, [_vm._v("\n          " + _vm._s(option.label) + "\n        ")])
	  }), 0)]), _vm._v(" "), (_vm.selectedEmploymentIds.length > 0) ? _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.cancelBatchMode
	    }
	  }, [_vm._v("Annuller valg")]) : _vm._e(), _vm._v(" "), (_vm.selectedEmploymentIds.length > 0) ? _c('span', {
	    staticClass: "faste-tillaeg__count"
	  }, [_vm._v("\n      " + _vm._s(_vm.selectedEmploymentIds.length) + " valgt\n    ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "faste-tillaeg__body"
	  }, [(_vm.isLoadingEmployments) ? _c('Loader') : (_vm.viewTab === 'opus') ? _c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "td-check do-table__toggle-all",
	    on: {
	      "click": _vm.toggleAllSelected
	    }
	  }, [_c('div', {
	    staticClass: "do-checkbox",
	    class: {
	      'do-checkbox--selected': _vm.isAllFilteredSelected
	    }
	  })]), _vm._v(" "), _c('th', [_vm._v("NAVN")]), _vm._v(" "), _c('th', [_vm._v("ANSÆTTELSE")]), _vm._v(" "), _c('th', [_vm._v("ORGANISATION")]), _vm._v(" "), _c('th', {
	    staticClass: "th-actions"
	  })])]), _vm._v(" "), (_vm.filteredRows.length === 0) ? _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": 5
	    }
	  }, [_vm._v("Ingen ansættelser fundet")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.groupedRows), function(group) {
	    return _c('tbody', {
	      key: group.userId,
	      staticClass: "user-group"
	    }, _vm._l((group.rows), function(row) {
	      return _c('tr', {
	        key: row.id,
	        staticClass: "fast-tillaeg-row",
	        class: {
	          'is-selected': _vm.isRowSelected(row)
	        },
	        on: {
	          "click": function($event) {
	            return _vm.onRowClick(row)
	          }
	        }
	      }, [_c('td', {
	        staticClass: "td-check",
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.onCheckboxClick(row)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "do-checkbox",
	        class: {
	          'do-checkbox--selected': _vm.isRowSelected(row)
	        }
	      })]), _vm._v(" "), _c('td', {
	        staticClass: "bold"
	      }, [_vm._v(_vm._s(row.userName))]), _vm._v(" "), _c('td', {
	        staticClass: "td-organisation"
	      }, [_vm._v("\n          " + _vm._s(row.employmentNumber) + " - " + _vm._s(row.employmentTitle) + "\n        ")]), _vm._v(" "), _c('td', {
	        staticClass: "td-organisation"
	      }, [_vm._v(_vm._s(row.organisation))]), _vm._v(" "), _c('td', {
	        staticClass: "td-actions"
	      }, [(!_vm.isBatchMode) ? _c('button', {
	        staticClass: "do-bttn do-bttn--small row-action-btn",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.openSingleCreate(row)
	          }
	        }
	      }, [_vm._v("Opret fast tillæg")]) : _vm._e()])])
	    }), 0)
	  })], 2) : [_c('div', {
	    staticClass: "faste-tillaeg__outbox-bar"
	  }, [_c('span', {
	    staticClass: "faste-tillaeg__outbox-info"
	  }, [(_vm.isLoadingOutbox) ? [_vm._v("Indlæser…")] : (_vm.viewTab === 'sent') ? [_vm._v("\n            Afsendte og godkendte tillæg i OPUS. Klik på \"Opdater\"-knappen for at se den aktuelle status.\n          ")] : [_vm._v("\n            Tillæg i udbakken behandles løbende af OPUS. Klik på \"Opdater\"-knappen for at se den aktuelle status.\n          ")]], 2), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--small",
	    attrs: {
	      "disabled": _vm.isLoadingOutbox
	    },
	    on: {
	      "click": _vm.loadOutbox
	    }
	  }, [_vm._v("\n          Opdater\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--small",
	    class: {
	      'do-bttn--loading': _vm.isDownloadingOutbox
	    },
	    attrs: {
	      "disabled": _vm.isLoadingOutbox || _vm.isDownloadingOutbox || _vm.currentOutboxRows.length === 0
	    },
	    on: {
	      "click": _vm.downloadOutboxExcel
	    }
	  }, [_vm._v("\n          Download til excel\n        ")])]), _vm._v(" "), (_vm.isLoadingOutbox) ? _c('Loader') : _c('table', {
	    staticClass: "do-table do-table--striped"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "sortable td-created",
	    on: {
	      "click": function($event) {
	        return _vm.sortOutbox('created_at')
	      }
	    }
	  }, [_vm._v("OPRETTET "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "sortable",
	    on: {
	      "click": function($event) {
	        return _vm.sortOutbox('user')
	      }
	    }
	  }, [_vm._v("NAVN "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "sortable",
	    on: {
	      "click": function($event) {
	        return _vm.sortOutbox('employment')
	      }
	    }
	  }, [_vm._v("ANSÆTTELSE "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "sortable td-loenkode",
	    on: {
	      "click": function($event) {
	        return _vm.sortOutbox('loenkode')
	      }
	    }
	  }, [_vm._v("LØNKODE "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "sortable td-units",
	    on: {
	      "click": function($event) {
	        return _vm.sortOutbox('antal')
	      }
	    }
	  }, [_vm._v("ENHEDER "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "sortable td-units",
	    on: {
	      "click": function($event) {
	        return _vm.sortOutbox('beloeb')
	      }
	    }
	  }, [_vm._v("BELØB "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "sortable td-date",
	    on: {
	      "click": function($event) {
	        return _vm.sortOutbox('fra')
	      }
	    }
	  }, [_vm._v("FRA "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "sortable td-date",
	    on: {
	      "click": function($event) {
	        return _vm.sortOutbox('til')
	      }
	    }
	  }, [_vm._v("TIL "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "sortable",
	    on: {
	      "click": function($event) {
	        return _vm.sortOutbox('operation')
	      }
	    }
	  }, [_vm._v("HANDLING "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "sortable",
	    on: {
	      "click": function($event) {
	        return _vm.sortOutbox('created_by')
	      }
	    }
	  }, [_vm._v("OPRETTET AF "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "sortable td-status",
	    on: {
	      "click": function($event) {
	        return _vm.sortOutbox('state')
	      }
	    }
	  }, [_vm._v("STATUS "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), (_vm.viewTab === 'outbox') ? _c('th', {
	    staticClass: "th-actions"
	  }) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.currentOutboxRows.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": _vm.viewTab === 'outbox' ? 12 : 11
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.viewTab === 'sent' ? 'Ingen afsendte ændringer' : 'Ingen afventende ændringer i udbakken') + "\n          ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.currentOutboxRows), function(row) {
	    return _c('tr', {
	      key: row.vRowKey,
	      staticClass: "outbox-row"
	    }, [_c('td', {
	      staticClass: "td-created"
	    }, [_vm._v(_vm._s(row.vCreatedAt))]), _vm._v(" "), _c('td', {
	      staticClass: "bold"
	    }, [_vm._v(_vm._s(row.vUserName))]), _vm._v(" "), _c('td', {
	      staticClass: "td-organisation"
	    }, [_vm._v(_vm._s(row.vEmploymentLabel))]), _vm._v(" "), _c('td', {
	      staticClass: "td-loenkode"
	    }, [_vm._v(_vm._s(row.vLoenart))]), _vm._v(" "), _c('td', {
	      staticClass: "td-units"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(row.antal)))]), _vm._v(" "), _c('td', {
	      staticClass: "td-units"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(row.beloeb)))]), _vm._v(" "), _c('td', {
	      staticClass: "td-date"
	    }, [_vm._v(_vm._s(row.vFraDato))]), _vm._v(" "), _c('td', {
	      staticClass: "td-date"
	    }, [_vm._v(_vm._s(row.vTilDato))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.operationLabel(row.operation)))]), _vm._v(" "), _c('td', [(row.vCreatedByName) ? [_vm._v(_vm._s(row.vCreatedByName))] : (row.vCreatedById != null) ? _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'top',
	          animateFill: false,
	          animation: 'shift-away',
	          boundary: 'window'
	        }),
	        expression: "{\n                    arrow: true,\n                    placement: 'top',\n                    animateFill: false,\n                    animation: 'shift-away',\n                    boundary: 'window'\n                  }"
	      }],
	      staticClass: "italic",
	      attrs: {
	        "content": 'Bruger-id: ' + row.vCreatedById
	      }
	    }, [_vm._v("\n              Tidligere ansat\n            ")]) : [_vm._v("—")]], 2), _vm._v(" "), _c('td', {
	      staticClass: "td-status"
	    }, [_c('span', {
	      staticClass: "do-pill do-pill--small",
	      class: _vm.statePillClass(row)
	    }, [_vm._v("\n              " + _vm._s(_vm.stateLabel(row)) + "\n            ")]), _vm._v(" "), _vm._l((_vm.resultMessages(row)), function(msg, i) {
	      return _c('div', {
	        key: i,
	        staticClass: "outbox-msg",
	        class: {
	          'outbox-msg--error': msg.type === 'E'
	        }
	      }, [_vm._v("\n              " + _vm._s(msg.code) + ": " + _vm._s(msg.text) + "\n            ")])
	    })], 2), _vm._v(" "), (_vm.viewTab === 'outbox') ? _c('td', {
	      staticClass: "td-actions"
	    }, [(row.state === 'failed') ? _c('button', {
	      staticClass: "do-bttn do-bttn--small do-bttn--danger",
	      attrs: {
	        "disabled": _vm.deletingIds.includes(row.id)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.deleteFailedRow(row)
	        }
	      }
	    }, [_vm._v("\n              Slet\n            ")]) : _vm._e()]) : _vm._e()])
	  })], 2)])]], 2), _vm._v(" "), (_vm.activeRow) ? _c('FasteTillaegModal', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "employmentId": _vm.activeRow.employmentId,
	      "employment": _vm.activeRow.employment,
	      "userName": _vm.activeRow.userName
	    },
	    on: {
	      "close": function($event) {
	        _vm.activeRow = null
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.createEmploymentIds.length > 0) ? _c('CreateFastTillaeg', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "employmentIds": _vm.createEmploymentIds,
	      "subtitle": _vm.createSubtitle
	    },
	    on: {
	      "created": _vm.onBulkCreated,
	      "close": _vm.closeCreate
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowTidsbegraenset) ? _c('TidsbegraensetUvModal', {
	    on: {
	      "created": function($event) {
	        _vm.isShowTidsbegraenset = false
	      },
	      "close": function($event) {
	        _vm.isShowTidsbegraenset = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.rowToDelete) ? _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312313"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "isCloseOnBgClick": false,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        _vm.rowToDelete = null
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal--small",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Slet linje")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        _vm.rowToDelete = null
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('p', [_vm._v("Er du sikker på, at du vil slette denne fejlede linje fra udbakken? Handlingen kan ikke fortrydes.")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', {
	    staticClass: "d-modal__buttons__child"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        _vm.rowToDelete = null
	      }
	    }
	  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--danger",
	    class: {
	      'do-bttn--submit--loading': _vm.deletingIds.includes(_vm.rowToDelete.id)
	    },
	    attrs: {
	      "disabled": _vm.deletingIds.includes(_vm.rowToDelete.id)
	    },
	    on: {
	      "click": _vm.confirmDeleteFailedRow
	    }
	  }, [_vm._v("\n            Slet linje\n          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.isShowBeregnModal) ? _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312313"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "isCloseOnBgClick": false,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": _vm.closeBeregnModal
	    }
	  }, [_c('div', {
	    staticClass: "beregn-modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "beregn-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.beregnModalTitle))]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle beregn-modal__close",
	    on: {
	      "click": _vm.closeBeregnModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "beregn-modal__content"
	  }, [_c('Supplements', {
	    attrs: {
	      "isInOpusModal": true,
	      "beregningType": _vm.beregnType,
	      "sendToOpusTrigger": _vm.sendToOpusTrigger
	    },
	    on: {
	      "approveState": function($event) {
	        _vm.opusApproveState = $event
	      }
	    }
	  })], 1), _vm._v(" "), (_vm.opusApproveState.canApprove) ? _c('div', {
	    staticClass: "beregn-modal__footer"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'top',
	        animateFill: false,
	        animation: 'shift-away',
	        boundary: 'window',
	        onShow: function () { return _vm.sendToOpusTooltip !== ''; }
	      }),
	      expression: "{\n                arrow: true,\n                placement: 'top',\n                animateFill: false,\n                animation: 'shift-away',\n                boundary: 'window',\n                onShow: () => sendToOpusTooltip !== ''\n              }"
	    }],
	    staticClass: "send-to-opus-wrap",
	    attrs: {
	      "content": _vm.sendToOpusTooltip
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.opusApproveState.isApproving,
	      'do-bttn--submit--disabled': _vm.opusApproveState.count === 0 || _vm.opusApproveState.missingEmployment
	    },
	    attrs: {
	      "disabled": _vm.opusApproveState.isApproving || _vm.opusApproveState.count === 0 || _vm.opusApproveState.missingEmployment
	    },
	    on: {
	      "click": _vm.triggerSendToOpus
	    }
	  }, [_vm._v("\n            Send til OPUS\n          ")])])]) : _vm._e()])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1794 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "employment-rates",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "employment-rates__header"
	  }, [_c('h2', [_vm._v("Ansættelsesgrader"), (_vm.schoolYearName) ? _c('span', [_vm._v(" " + _vm._s(_vm.schoolYearName))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "employment-rates__body"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "do-spinner__container"
	  }, [_c('div', {
	    staticClass: "do-spinner do-spinner--large"
	  })]) : _c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "is-clickable",
	    on: {
	      "click": function($event) {
	        return _vm.setSort('name')
	      }
	    }
	  }, [_vm._v("\n            Navn\n            "), (_vm.sort.key === 'name') ? _c('span', [_vm._v(_vm._s(_vm.sort.dir === 'asc' ? '▲' : '▼'))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.columns), function(col) {
	    return _c('th', {
	      key: 'h-' + col,
	      staticClass: "is-clickable",
	      on: {
	        "click": function($event) {
	          return _vm.setSort(col)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(_vm.columnLabel(col)) + "\n            "), (_vm.sort.key === col) ? _c('span', [_vm._v(_vm._s(_vm.sort.dir === 'asc' ? '▲' : '▼'))]) : _vm._e()])
	  })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.displayedRows), function(row) {
	    return _c('tr', {
	      key: row.id
	    }, [_c('td', {
	      staticClass: "bold"
	    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _vm._l((_vm.columns), function(col) {
	      return _c('td', {
	        key: 'c-' + row.id + '-' + col
	      }, [_vm._v("\n            " + _vm._s(row.values[col]) + "\n          ")])
	    })], 2)
	  }), _vm._v(" "), (!_vm.displayedRows.length) ? _c('tr', [_c('td', {
	    staticClass: "employment-rates__empty",
	    attrs: {
	      "colspan": _vm.columns.length + 1
	    }
	  }, [_vm._v("\n            Ingen data for det valgte skoleår\n          ")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "employment-rates__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("Luk")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isDownloading
	    },
	    attrs: {
	      "disabled": _vm.isLoading || !_vm.displayedRows.length
	    },
	    on: {
	      "click": _vm.asyncLoadXLSXAndDownload
	    }
	  }, [_vm._v("\n        Download til Excel\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1795 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "grid grid-pad box-size"
	  }, [_c('div', {
	    staticClass: "col-1-1 box-size"
	  }, [_c('isIEOrEdge'), _vm._v(" "), _c('div', {
	    staticClass: "dashboard text-dark"
	  }, [(_vm.isOnboarding) ? _c('div', {
	    staticClass: "box box-overview flex pad-0"
	  }, [_c('div', {
	    staticClass: "flex-1 box-overview__name"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.dashboard.welcome')) + " " + _vm._s(_vm.userName) + "!")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('vue2.dashboard.start_by_setting_up')) + " " + _vm._s(_vm.schoolName))])]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.openSetupWidget
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.dashboard.follow_the_steps')))]), _vm._v(" "), _c('div', {
	    staticClass: "flex bg-light-blue flex-1 steps-graph"
	  }, [_c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.dashboard.steps_completed')))]), _vm._v(" "), _c('doughnut', {
	    attrs: {
	      "animate": true,
	      "steps": _vm.steps.length,
	      "stepNum": _vm.howManyDone
	    }
	  })], 1)])]) : _c('div', [_c('h1', [_vm._v(_vm._s(_vm.schoolName) + " ")])]), _vm._v(" "), _c('div', {
	    staticClass: "dashboard-boxes"
	  }, _vm._l((_vm.steps), function(step, key) {
	    return (key < 4) ? _c('dashboardBox', {
	      key: step.dbName,
	      attrs: {
	        "step": step,
	        "isOnboarding": _vm.isOnboarding
	      }
	    }) : _vm._e()
	  }), 1), _vm._v(" "), _c('div', {
	    staticClass: "dashboard-boxes"
	  }, _vm._l((_vm.steps), function(step, key) {
	    return (key >= 4) ? _c('dashboardBox', {
	      key: step.dbName,
	      attrs: {
	        "step": step,
	        "isOnboarding": _vm.isOnboarding
	      }
	    }) : _vm._e()
	  }), 1), _vm._v(" "), _c('div', {
	    staticClass: "slide-up",
	    class: {
	      'active': _vm.showSlideUp
	    }
	  }, [_c('div', {
	    staticClass: "slide-up__close",
	    on: {
	      "click": function($event) {
	        return _vm.setShowSlideUp(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "slide-up__content box"
	  }, [_c('vacationDaySelector', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showSlideUp),
	      expression: "showSlideUp"
	    }],
	    attrs: {
	      "school-id": _vm.schoolId,
	      "emit-event-on-load": false,
	      "initial-year": _vm.schoolYear
	    },
	    on: {
	      "schoolDays": _vm.setSchoolDays
	    }
	  })], 1)])])], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showSlideUp),
	      expression: "showSlideUp"
	    }],
	    staticClass: "modal-mask"
	  })])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1796 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "permissions__col__body__users__list__user",
	    class: {
	      index: _vm.index
	    }
	  }, [_c('div', {
	    staticClass: "user-clickable",
	    on: {
	      "click": _vm.toggleUserSelection
	    }
	  }, [_c('div', {
	    staticClass: "user-checkbox",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox",
	      "id": 'user-checkbox-' + _vm.source.id
	    },
	    domProps: {
	      "checked": _vm.isSelected
	    },
	    on: {
	      "change": _vm.handleCheckboxChange
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": 'user-checkbox-' + _vm.source.id
	    }
	  })]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": _vm.source.default_thumb_url,
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.source.name))])]), _vm._v(" "), (_vm.selectedUsers.length === 0) ? _c('div', {
	    staticClass: "role-change__selector role-change__selector__placeholder",
	    class: {
	      'role-change__selector--active': _vm.source.id === _vm.activeChangeId
	    },
	    attrs: {
	      "data-user-id": _vm.source.id
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setChangeRole.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.permissions.change_role')) + "\n  ")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1797 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-add-calendar-to-cost-center"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Vælg kalendere")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('Tabs', {
	    attrs: {
	      "tabs": _vm.tabs,
	      "selected": _vm.activeTab
	    },
	    on: {
	      "select": function($event) {
	        _vm.activeTab = $event
	      }
	    }
	  }), _vm._v(" "), _c('table', {
	    staticClass: "do-table do-table__items marg-1-top"
	  }, [_c('thead', [_c('tr', [_c('th', [_c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.toggleSelectAll
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.isAllChecked ? 'Fravælg alle' : 'Vælg alle ') + "\n            ")])]), _vm._v(" "), _c('th', [_vm._v("Navn")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.filteredCalendars), function(calendar) {
	    return _c('tr', {
	      key: calendar.id,
	      class: {
	        'row-selected': _vm.localSelectedIds.indexOf(calendar.id) > -1
	      },
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleOne(calendar.id)
	        }
	      }
	    }, [_c('td', {
	      staticStyle: {
	        "width": "80px"
	      }
	    }, [_c('input', {
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "checked": _vm.localSelectedIds.indexOf(calendar.id) > -1
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.toggleOne(calendar.id)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(calendar.name))])])
	  }), _vm._v(" "), (_vm.filteredCalendars.length === 0) ? _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_c('i', [_vm._v("Ingen kalendere")])])]) : _vm._e()], 2)])], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__buttons do-modal__buttons--end"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n      ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': _vm.isSubmitting,
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.onSubmit
	    }
	  }, [_vm._v("\n        Gem\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1798 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.user) ? _c('div', {
	    staticClass: "subs-panel"
	  }, [_c('div', {
	    staticClass: "slide-in__mask animated fadeIn",
	    on: {
	      "click": _vm.close
	    }
	  }), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "slideIn"
	    }
	  }, [(_vm.animate) ? _c('div', {
	    staticClass: "slide-in text-dark"
	  }, [_c('div', {
	    staticClass: "slide-in__header"
	  }, [_c('div', {
	    staticClass: "slide-in__header__close pointer icon__bg-circle",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('vue2.substitution.add_sub_to_several_lesson')))])]), _vm._v(" "), _c('div', {
	    staticClass: "slide-in__grid"
	  }, [_c('div', {
	    staticClass: "slide-in__content"
	  }, [_c('div', {
	    staticClass: "slide-in__content__header"
	  }, [_c('div', {
	    staticClass: "slide-in__content__header__left"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.user.default_thumb_url,
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "flex"
	  }, _vm._l((_vm.absenceReasons), function(absence) {
	    return _c('AbsenceReason', {
	      key: absence.id,
	      attrs: {
	        "user_calendar_id": _vm.user.user_calendar_id,
	        "reason": absence
	      },
	      on: {
	        "close": _vm.close
	      }
	    })
	  }), 1)]), _vm._v(" "), _c('div', {
	    staticClass: "slide-in__content__body"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.choose_period_lessons')))]), _vm._v(" "), _c('DoDatePickerRange', {
	    staticClass: "marg-1-bottom",
	    attrs: {
	      "dateShortCutsProps": _vm.dateShortCutsSorted,
	      "allowSameDate": true,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate
	    },
	    on: {
	      "datesChanged": _vm.setDates
	    }
	  }), _vm._v(" "), _c('SubsUserPanelLessons', {
	    attrs: {
	      "dates": _vm.absentDates,
	      "isSubStatusPendingActive": _vm.isSubStatusPendingActive,
	      "calendarId": _vm.user.user_calendar_id,
	      "subToAdd": _vm.subToAdd
	    },
	    on: {
	      "changed": _vm.updateSelectedEventIds,
	      "updatedArr": _vm.updateDbEventsWithSubs
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "slide-in__sidebar"
	  }, [_c('SubsUserPanelSubs', {
	    attrs: {
	      "selectedEvents": _vm.selectedEvents
	    },
	    on: {
	      "addSub": _vm.addSubToEvents
	    }
	  })], 1)]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeUp"
	    }
	  }, [(_vm.dbEventsWithSubs.length > 0) ? _c('div', {
	    staticClass: "slide-in__footer shadow"
	  }, [_c('button', {
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "marg-10-left bttn bttn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.save')) + _vm._s(_vm.saveCountSuffix) + "\n          ")])]) : _vm._e()])], 1) : _vm._e()]), _vm._v(" "), (_vm.isClosingWithoutSaving) ? _c('DModal', {
	    attrs: {
	      "showClose": false
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.substitution.do_you_want_to_save')) + "?")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        _vm.isClosingWithoutSaving = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body"
	  }, [_c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "marg-10-right",
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.substitution.no_close_without_saving')) + "\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.yes_save_my_changes')))])])])])]) : _vm._e()], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-dark box vacations-days__wrapper"
	  }, [(_vm.isKindergarten) ? _c('h1', [_vm._v("Lukkedage")]) : _c('h1', [_vm._v(_vm._s(_vm.$t('vue.vacations_days_selector.vacation_for_pupils')))]), _vm._v(" "), _c('div', {
	    staticClass: "flex"
	  }, [_c('div', {
	    staticClass: "marg-20-right flex align-center"
	  }, [(_vm.isKindergarten) ? _c('span', {
	    staticClass: "font-large"
	  }, [_vm._v("Periode")]) : _c('span', {
	    staticClass: "font-large"
	  }, [_vm._v(_vm._s(_vm.$t('vue.vacations_days_selector.school_year')) + " ")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedSchoolYearIndex),
	      expression: "selectedSchoolYearIndex"
	    }],
	    staticClass: "marg-1-left like-date-picker",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedSchoolYearIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.onSchoolYearChanged]
	    }
	  }, _vm._l((_vm.activeSchoolYears), function(schoolYear, index) {
	    return _c('option', {
	      domProps: {
	        "value": index
	      }
	    }, [_vm._v("\n          " + _vm._s(schoolYear.name) + "\n        ")])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "marg-1-left marg-1-right"
	  }, [_c('date-picker-range', {
	    staticClass: "inline-block",
	    attrs: {
	      "startdate": _vm.currFromDate,
	      "enddate": _vm.currToDate
	    },
	    on: {
	      "startchanged": _vm.onStartDateChanged,
	      "endchanged": _vm.onEndDateChanged
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "marg-20-right flex align-center pointer"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.includeWeekends),
	      expression: "includeWeekends"
	    }],
	    staticClass: "pointer",
	    attrs: {
	      "id": "weekendToggle",
	      "type": "checkbox",
	      "title": "Include weekends"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.includeWeekends) ? _vm._i(_vm.includeWeekends, null) > -1 : (_vm.includeWeekends)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.includeWeekends,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.includeWeekends = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.includeWeekends = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.includeWeekends = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "marg-05-left pointer",
	    staticStyle: {
	      "font-weight": "normal"
	    },
	    attrs: {
	      "for": "weekendToggle"
	    }
	  }, [_vm._v("Include weekends")])])]), _vm._v(" "), _c('div', {
	    staticClass: "vacations-days-selector__year-calendar"
	  }, [_c('h2', {
	    staticClass: "marg-10-bottom"
	  }, [(_vm.isKindergarten) ? [_vm._v("Institutionen har åbent " + _vm._s(_vm.schoolDaysCount) + " dage")] : [_vm._v(_vm._s(_vm.schoolDaysCount) + " " + _vm._s(_vm.$t('vue.vacations_days_selector.school_days')))]], 2), _vm._v(" "), _c('direct-day-selector', {
	    attrs: {
	      "from-date": _vm.currFromDate,
	      "to-date": _vm.currToDate,
	      "selected-days": _vm.initialSelectedDates,
	      "include-weekends": _vm.includeWeekends
	    },
	    on: {
	      "toggled": _vm.dayToggled
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tasks text-dark",
	    class: {
	      'tasks--with-kids': _vm.isWithKids
	    }
	  }, [_c('div', {
	    staticClass: "tasks-header"
	  }, [_c('h4', [_vm._v("Personalets kalender")]), _vm._v(" "), _c('button', {
	    class: {
	      'submit-button create-btn': !_vm.isWithKids
	    },
	    on: {
	      "click": _vm.setCreateNewTask
	    }
	  }, [_vm._v("\n      Opret opgave for personale\n    ")]), _vm._v(" "), (_vm.isTaskModal) ? _c('CreateTask', {
	    attrs: {
	      "editTask": _vm.theEditTask,
	      "activeFilter": _vm.theActiveFilter
	    },
	    on: {
	      "create": _vm.createTask,
	      "close": _vm.closeUpdateTask
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedTasksWithProps), function(task) {
	    return _c('tr', {
	      key: task.id
	    }, [_c('td', {
	      staticClass: "task__task"
	    }, [_c('div', {
	      staticClass: "task__name"
	    }, [_c('div', {
	      class: [{
	        'td-subject--hidden': !task.can_schedule
	      }, {
	        'td-subject': task.can_schedule
	      }],
	      style: ({
	        'background-color': task.color
	      }),
	      on: {
	        "click": function($event) {
	          return _vm.setEditTask(task)
	        }
	      }
	    }, [_vm._v(_vm._s(task.name) + "\n          ")])])]), _vm._v(" "), _c('td', {
	      staticClass: "task__hours"
	    }, [_vm._v(_vm._s(task.hours))]), _vm._v(" "), _c('td', {
	      staticClass: "task__calendars",
	      class: {
	        'd-select-lookalike': !task.v_is_active_d_select && task.v_staff_names.length < 1
	      },
	      attrs: {
	        "aria-placeholder-label": "Søg og vælg"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDSelect(task)
	        }
	      }
	    }, [(task.v_is_active_d_select) ? _c('DSelectCalendarIds', {
	      directives: [{
	        name: "on-clickaway",
	        rawName: "v-on-clickaway",
	        value: (_vm.closeDSelect),
	        expression: "closeDSelect"
	      }, {
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: function () { return _vm.usersWithEvents(task).length > 0; },
	          arrow: true,
	          placement: 'bottom'
	        }),
	        expression: "{\n                              onShow: () => usersWithEvents(task).length > 0,\n                              arrow: true,\n                              placement : 'bottom'\n                            }"
	      }],
	      attrs: {
	        "show": _vm.activeDSelectShow,
	        "itemType": "USER",
	        "preSelectedItems": task.user_calendar_ids,
	        "itemsThatCantBeDeleted": _vm.usersWithEvents(task),
	        "showTags": false,
	        "content": _vm.getUserNames(_vm.usersWithEvents(task)) + ' har skemalagte aktiviteter og kan ikke slettes'
	      },
	      on: {
	        "update": function($event) {
	          return _vm.setSelectedUsers($event, task)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (!task.v_is_active_d_select && task.v_staff_names.length > 0) ? _c('div', {
	      staticClass: "task__users"
	    }, _vm._l((task.v_staff_names), function(user) {
	      return _c('p', [_vm._v(_vm._s(user))])
	    }), 0) : _vm._e()], 1)])
	  }), 0)]), _vm._v(" "), (_vm.tasks.length < 1) ? _c('div', {
	    staticClass: "explainer-div"
	  }, [_vm._v("Ikke oprettet nogen opgaver uden børn")]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "task__task"
	  }, [_vm._v("Opgave")]), _vm._v(" "), _c('th', {
	    staticClass: "task__hours"
	  }, [_vm._v("Timer")]), _vm._v(" "), _c('th', {
	    staticClass: "task__calendars"
	  }, [_vm._v("Personale")])])])
	}]}

/***/ }),
/* 1801 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-smartscreen",
	    style: (_vm.computedStyle)
	  }, [_c('div', {
	    staticClass: "do-smartscreen__header"
	  }, [_c('div', {
	    staticClass: "do-smartscreen__header__left"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.dateFormatted))])]), _vm._v(" "), _c('div', {
	    staticClass: "do-smartscreen__header__right"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("\n        Senest opdateret: " + _vm._s(_vm.latestUpdate) + "\n      ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "table-container"
	  }, [_c('table', {
	    staticClass: "d-table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.eventsWithProps.length === 0) ? _c('tr', [_c('th', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen lektioner")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.eventsWithProps), function(event) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(event.vEventTime) + " " + _vm._s(event.title))]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(event.vRooms) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(event.vTeachers) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(event.vStudents))])])
	  })], 2)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Tidspunkt")]), _vm._v(" "), _c('th', [_vm._v("Lokale")]), _vm._v(" "), _c('th', [_vm._v("Lærer")]), _vm._v(" "), _c('th', [_vm._v("Elever")])])])
	}]}

/***/ }),
/* 1802 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-container",
	    class: {
	      'd-container--active': _vm.isDropDown
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.setDropdownFromClick),
	      expression: "setDropdownFromClick"
	    }],
	    ref: "d_parent",
	    staticClass: "d-select__selected",
	    on: {
	      "click": _vm.setDropdown
	    }
	  }, [_c('h5', [_vm._v(_vm._s(_vm.selectedUser ? _vm.selectedUser.name : _vm.userName))]), _vm._v(" "), _c('svg', {
	    staticClass: "tw-icon tw-icon-cheveron-selection",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "fill-rule": "evenodd",
	      "d": "M8.7 9.7a1 1 0 1 1-1.4-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 1 1-1.4 1.4L12 6.42l-3.3 3.3zm6.6 4.6a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
	    }
	  })])]), _vm._v(" "), (_vm.isDropDown) ? _c('div', {
	    ref: "d_child",
	    staticClass: "d-select__dropdown",
	    class: {
	      'd-dropdown--animate': _vm.isPopperReady,
	      'd-dropdown--show': _vm.isPopperDone
	    }
	  }, [_c('div', {
	    staticClass: "d-select-input",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-search5"
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search),
	      expression: "search"
	    }],
	    ref: "inputsearch",
	    attrs: {
	      "type": "search"
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('ul', {
	    ref: "d_list"
	  }, _vm._l((_vm.usersQuery), function(user) {
	    return _c('li', {
	      ref: _vm.selectedUser && user.id === _vm.selectedUser.id ? 'selectedUser' : null,
	      refInFor: true,
	      class: {
	        'user--is-selected': _vm.selectedUser && user.id === _vm.selectedUser.id
	      },
	      on: {
	        "click": function($event) {
	          return _vm.selectUser(user.id)
	        }
	      }
	    }, [_c('p', [_vm._v(_vm._s(user.name))])])
	  }), 0)]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1803 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login"
	  }, [_c('a', {
	    on: {
	      "click": _vm.login
	    }
	  }, [_vm._v("Login")])])
	},staticRenderFns: []}

/***/ }),
/* 1804 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "isCloseOnBgClick": false,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('div', [_c('h2', [_vm._v("Opret faste tillæg")]), _vm._v(" "), _c('p', {
	    staticClass: "d-modal__subtitle"
	  }, [_vm._v(_vm._s(_vm.subtitleText))])]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "create-form__grid"
	  }, [_c('div', {
	    staticClass: "d-input-group cf-tillaeg"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Lønkode *")]), _vm._v(" "), _c('DSelect', {
	    ref: "tillaegSelect",
	    attrs: {
	      "items": _vm.salaryCodesForDSelect,
	      "multiple": false,
	      "placeholder": 'Vælg tillæg',
	      "itemsSelected": _vm.selectedSalaryCodeForDSelect,
	      "isShowRemoveButton": false
	    },
	    on: {
	      "add": _vm.onSelectTillaeg,
	      "remove": function($event) {
	        return _vm.onSelectTillaeg(null)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group cf-antal"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Enheder pr. måned *")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.antal),
	      expression: "antal"
	    }],
	    staticClass: "d-input width-100",
	    attrs: {
	      "type": "text",
	      "inputmode": "decimal",
	      "placeholder": "Indtast antal"
	    },
	    domProps: {
	      "value": (_vm.antal)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.antal = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group cf-start"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Startdato *")]), _vm._v(" "), _c('DateSelector', {
	    staticClass: "width-100",
	    attrs: {
	      "date": _vm.startDato,
	      "width100": true
	    },
	    on: {
	      "changed": function($event) {
	        _vm.startDato = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group cf-slut"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Slutdato *")]), _vm._v(" "), _c('DateSelector', {
	    staticClass: "width-100",
	    attrs: {
	      "date": _vm.endDato,
	      "width100": true
	    },
	    on: {
	      "changed": function($event) {
	        _vm.endDato = $event
	      }
	    }
	  })], 1)]), _vm._v(" "), (_vm.validationMessage) ? _c('p', {
	    staticClass: "text-explainer text-explainer--danger"
	  }, [_vm._v(_vm._s(_vm.validationMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', {
	    staticClass: "d-modal__buttons__child"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'top',
	        animateFill: false,
	        animation: 'shift-away',
	        boundary: 'window',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n                  arrow: true,\n                    placement : 'top',\n                    animateFill: false,\n                    animation : 'shift-away',\n                    boundary: 'window',\n                    zIndex: 12312312312312\n                  }"
	    }],
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting,
	      'do-bttn--submit--disabled': !_vm.isValid
	    },
	    attrs: {
	      "disabled": !_vm.isValid || _vm.isSubmitting,
	      "content": _vm.saveKeyTooltip
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.submitButtonLabel) + "\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1805 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "isCloseOnBgClick": false,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('div', [_c('h2', [_vm._v(_vm._s(_vm.employmentIds.length === 1 ? 'Opret engangsydelse' : 'Opret engangsydelser'))]), _vm._v(" "), _c('p', {
	    staticClass: "d-modal__subtitle"
	  }, [_vm._v(_vm._s(_vm.subtitleText))])]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "create-form__grid"
	  }, [_c('div', {
	    staticClass: "d-input-group cf-loenart"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Lønart *")]), _vm._v(" "), _c('DSelect', {
	    ref: "loenartSelect",
	    attrs: {
	      "items": _vm.salaryCodesForDSelect,
	      "multiple": false,
	      "placeholder": 'Vælg lønart',
	      "itemsSelected": _vm.selectedSalaryCodeForDSelect,
	      "isShowRemoveButton": false
	    },
	    on: {
	      "add": _vm.onSelectLoenart,
	      "remove": function($event) {
	        return _vm.onSelectLoenart(null)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group cf-antal"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Antal")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.antal),
	      expression: "antal"
	    }],
	    staticClass: "d-input width-100",
	    attrs: {
	      "type": "text",
	      "inputmode": "decimal",
	      "disabled": _vm.satsHasValue,
	      "placeholder": "Indtast antal"
	    },
	    domProps: {
	      "value": (_vm.antal)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.antal = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group cf-beloeb"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Beløb")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sats),
	      expression: "sats"
	    }],
	    staticClass: "d-input width-100",
	    attrs: {
	      "type": "text",
	      "inputmode": "decimal",
	      "disabled": _vm.antalHasValue,
	      "placeholder": "Indtast beløb"
	    },
	    domProps: {
	      "value": (_vm.sats)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.sats = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "cf-hint text-explainer"
	  }, [_vm._v("\n          Angiv enten Antal (taksten for lønarten anvendes) eller Beløb. De to felter kan ikke udfyldes samtidig.\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group cf-dato"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Aktivitetsdato *")]), _vm._v(" "), _c('DateSelector', {
	    staticClass: "width-100",
	    attrs: {
	      "date": _vm.dato,
	      "width100": true
	    },
	    on: {
	      "changed": function($event) {
	        return _vm.setDato($event)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group cf-omk"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Afvigende omkostningssted")]), _vm._v(" "), _c('DSelect', {
	    attrs: {
	      "items": _vm.costCentersForDSelect,
	      "multiple": false,
	      "placeholder": 'Vælg afvigende omkostningssted (valgfri)',
	      "itemsSelected": _vm.selectedCostCenterForDSelect,
	      "isShowRemoveButton": true
	    },
	    on: {
	      "add": _vm.onSelectCostCenter,
	      "remove": function($event) {
	        return _vm.onSelectCostCenter(null)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group cf-beskrivelse"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Beskrivelse")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.description),
	      expression: "description"
	    }],
	    staticClass: "d-input width-100",
	    attrs: {
	      "type": "text",
	      "placeholder": "Indtast beskrivelse (valgfri)"
	    },
	    domProps: {
	      "value": (_vm.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.description = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), (_vm.validationMessage) ? _c('p', {
	    staticClass: "text-explainer text-explainer--danger"
	  }, [_vm._v(_vm._s(_vm.validationMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', {
	    staticClass: "d-modal__buttons__child"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'right',
	        animateFill: false,
	        animation: 'shift-away',
	        boundary: 'window',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n                  arrow: true,\n                    placement : 'right',\n                    animateFill: false,\n                    animation : 'shift-away',\n                    boundary: 'window',\n                    zIndex: 12312312312312\n                  }"
	    }],
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting,
	      'do-bttn--submit--disabled': !_vm.isValid
	    },
	    attrs: {
	      "disabled": !_vm.isValid || _vm.isSubmitting,
	      "content": _vm.saveKeyTooltip
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.submitButtonLabel) + "\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1806 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "school-data"
	  }, [_c('div', {
	    staticClass: "school-data__header"
	  }, [_c('div', {
	    staticClass: "school-data__header__left"
	  }, [_c('h1', [_vm._v("Vikardækning")]), _vm._v(" "), _c('changeSchoolYear', {
	    staticClass: "marg-1-right",
	    attrs: {
	      "white-theme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "school-data__header__right"
	  }, [(!_vm.isDatesPristine) ? _c('p', {
	    staticClass: "d-link",
	    on: {
	      "click": _vm.resetDates
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), _c('Datepickerrange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  })], 1)]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
	    staticClass: "loader-container"
	  }, [_c('Loader'), _vm._v(" "), _c('h4', [_vm._v("Snup en kop kaffe, det kan tage et par minutter")])], 1) : [_c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n      Berørte timer er lektioner, hvor en lærer har registreret fravær, eller hvor der er sat en vikar på.\n      De fordeles på: dækket af vikar, medlærer til stede uden vikar, aflyst, ude af huset og ikke dækket.\n      \"% med vikarnoter\" er andelen af lektioner med fravær, hvor der er skrevet vikarnoter.\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "school-data__toolbar"
	  }, [_c('Tabs', {
	    attrs: {
	      "tabs": _vm.viewTabs,
	      "selected": _vm.viewMode
	    },
	    on: {
	      "select": function($event) {
	        _vm.viewMode = $event
	      }
	    }
	  }), _vm._v(" "), _c('Tabs', {
	    attrs: {
	      "tabs": _vm.sortTabs,
	      "selected": _vm.sortMode
	    },
	    on: {
	      "select": function($event) {
	        _vm.sortMode = $event
	      }
	    }
	  })], 1), _vm._v(" "), (_vm.viewMode === 'grades') ? _c('SchoolDataCoverageTable', {
	    attrs: {
	      "title": "Årgang",
	      "rows": _vm.gradeRows
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.viewMode === 'klasses') ? _c('SchoolDataCoverageTable', {
	    attrs: {
	      "title": "Klasse",
	      "rows": _vm.klassRows
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.viewMode === 'subjects') ? _c('SchoolDataCoverageTable', {
	    attrs: {
	      "title": "Fag",
	      "rows": _vm.subjectRows
	    }
	  }) : _vm._e()]], 2)
	},staticRenderFns: []}

/***/ }),
/* 1807 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'do-calendar__header': _vm.activeCalendarDate
	    }
	  }, [_c('div', {
	    staticClass: "d-cal__header text-dark"
	  }, [_c('div', {
	    staticClass: "d-cal__header__left"
	  }, [(_vm.userHasPermission('can_see_other_calendars')) ? _c('DCalendarSelect', {
	    attrs: {
	      "calendar": _vm.calendar
	    }
	  }) : _c('h2', [_vm._v(_vm._s(_vm.calendarName))]), _vm._v(" "), (_vm.activeCalendarDate) ? [_c('div', {
	    staticClass: "do-button__multiple no-print"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212,
	        onShow: function () { return _vm.hasHotKeys; }
	      }),
	      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212,\n               onShow: () => hasHotKeys\n             }"
	    }],
	    staticClass: "do-button__multiple__bttn icon-arrow-left4 no-print",
	    attrs: {
	      "content": _vm.tooltipArrowLeft
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('prev')
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "no-print do-button__multiple__bttn",
	    class: {
	      'bttn--disabled': _vm.isToday
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('today')
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('repitition.today')) + "\n          ")]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	        onShow: function () { return _vm.isAtMaxWeek || _vm.hasHotKeys; }
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => isAtMaxWeek || hasHotKeys\n            }"
	    }],
	    attrs: {
	      "content": _vm.isAtMaxWeek ? _vm.$t('vue2.calendar_view.next_week_disabled_tooltip') : _vm.tooltipArrowRight
	    }
	  }, [_c('button', {
	    staticClass: "do-button__multiple__bttn icon-arrow-right4",
	    class: {
	      'bttn--disabled': _vm.isAtMaxWeek
	    },
	    attrs: {
	      "disabled": _vm.isAtMaxWeek
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('next')
	      }
	    }
	  })])])] : _vm._e(), _vm._v(" "), (_vm.dates) ? _c('h3', {
	    staticClass: "do-calendar__date"
	  }, [_vm._v(_vm._s(_vm.calendarDateInterval))]) : _vm._e(), _vm._v(" "), (_vm.isLoadingEvents) ? _c('div', {
	    staticClass: "do-spinner"
	  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "d-cal__header__right no-print"
	  }, [(_vm.activeCalendarDate) ? _c('CalendarBulkActions') : _vm._e(), _vm._v(" "), (!_vm.hasBulkSelection) ? [(_vm.isMergeCalendar) ? _c('button', {
	    class: {
	      'do-bttn': _vm.activeCalendarDate
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowMergeCalendars(true)
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.editCalendarMenu.merge_with_calendar')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.userCanRequestAbsence) ? _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        _vm.isShowAbsenceRequest = true
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.request_absence.request_absence')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.canEditPresence) ? _c('UserPresence', {
	    attrs: {
	      "calid": _vm.calendarId,
	      "firstDayOfTheWeek": _vm.firstDayOfTheWeek,
	      "activeCalendarDate": _vm.activeCalendarDate,
	      "isModalLeft": true
	    },
	    on: {
	      "saved": function($event) {
	        return _vm.$emit('updateEvents')
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.activeCalendarDate) ? _c('div', {
	    staticClass: "do-calculate-hours"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        _vm.isShowCalculateHours = !_vm.isShowCalculateHours
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['calculate_hours']) + "\n          "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInDown"
	    }
	  }, [(_vm.isShowCalculateHours) ? _c('div', {
	    staticClass: "do-calculate-hours__dropdown"
	  }, [_c('div', {
	    staticClass: "do-calculate-hours__dropdown__header",
	    on: {
	      "click": function($event) {
	        _vm.isShowCalculateHours = false
	      }
	    }
	  }, [_c('div', {
	    staticClass: "icon__bg-circle"
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('CalculateHours', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "calendarId": _vm.calendarId,
	      "date": _vm.activeCalendarDate
	    }
	  })], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('CopyCalendar', {
	    attrs: {
	      "calid": _vm.calendarId,
	      "calendarType": _vm.calendarType,
	      "activeCalendarDate": _vm.activeCalendarDate,
	      "initCalendar": _vm.initCalendar
	    },
	    on: {
	      "copyCalendarModalOpen": function($event) {
	        return _vm.$emit('copyCalendarModalOpen', $event)
	      }
	    }
	  }), _vm._v(" "), _c('Print', {
	    attrs: {
	      "calendarId": _vm.calendarId,
	      "activeCalendarDate": _vm.activeCalendarDate
	    }
	  }), _vm._v(" "), (_vm.activeCalendarDate) ? _c('DCalendarHeaderDelete', {
	    attrs: {
	      "calendarId": _vm.calendarId,
	      "firstDayOfTheWeek": _vm.firstDayOfTheWeek,
	      "date": _vm.activeCalendarDate
	    },
	    on: {
	      "update": function($event) {
	        return _vm.$emit('updateCalendar')
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "isBottomStart": false,
	      "propOffset": [5, 5]
	    }
	  }, [_c('button', {
	    class: {
	      'do-bttn': _vm.activeCalendarDate
	    },
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_c('span', {
	    staticClass: "icon-more2"
	  })]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [(_vm.userCanToggleViewState) ? _c('li', {
	    on: {
	      "click": _vm.toggleCalendarGrid
	    }
	  }, [(_vm.showGrid) ? [_vm._v("\n              " + _vm._s(_vm.$t('vue2.editCalendarMenu.hide_grid')) + "\n            ")] : [_vm._v("\n              " + _vm._s(_vm.$t('vue2.editCalendarMenu.show_grid')) + "\n            ")]], 2) : _vm._e(), _vm._v(" "), (_vm.canBeLocked) ? _c('li', {
	    on: {
	      "click": _vm.toggleCalendarLock
	    }
	  }, [(_vm.isLocked) ? [_c('span', {
	    staticClass: "icon-lock5"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.editCalendarMenu.unlock')) + "\n            ")] : [_vm._v("\n              " + _vm._s(_vm.$t('vue2.editCalendarMenu.lock')) + "\n            ")]], 2) : _vm._e(), _vm._v(" "), (_vm.canSeePublicCalendar) ? _c('li', {
	    on: {
	      "click": _vm.openPublicCalendar
	    }
	  }, [(_vm.isAnonymousAccessActivated) ? [_vm._v("\n              " + _vm._s(_vm.$t('vue2.editCalendarMenu.see_public_view')) + "\n            ")] : [_vm._v("\n              " + _vm._s(_vm.$t('vue2.editCalendarMenu.active_public_view')) + "\n            ")]], 2) : _vm._e(), _vm._v(" "), (_vm.canSeeMergeWithMergeCalendars) ? _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowMergeCalendars(true)
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.editCalendarMenu.merge_with_merge_calendars')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.canSeeExportCalendar) ? _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowExportCalendarModal(true)
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.calendar_export.export_calendar')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.canToggleViewState) ? _c('li', [_c('span', {
	    staticClass: "icon-arrow-left4"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.editCalendarMenu.view')) + "\n            "), _c('ul', [_c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.toggleCalendarView(0)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.5_days')))]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.toggleCalendarView(1)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.7_days')))]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.toggleCalendarView(2)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.7_days_and_24_hours')))])])]) : _vm._e(), _vm._v(" "), (_vm.canEditName) ? _c('li', {
	    on: {
	      "click": _vm.openEditNameModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-pencil"
	  }), _vm._v("\n            " + _vm._s(_vm.$t('vue2.editCalendarMenu.edit_name')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.canBeDeleted) ? _c('li', {
	    staticClass: "d-item-warning",
	    on: {
	      "click": _vm.openDeleteModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v("\n            " + _vm._s(_vm.deleteCalendarText) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.canBeArchived) ? _c('li', {
	    staticClass: "d-item-warning",
	    on: {
	      "click": _vm.archiveCalendar
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v(" " + _vm._s(_vm.removeCalendarText) + "\n          ")]) : _vm._e()])]), _vm._v(" "), (_vm.isLocked) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'left'
	      }),
	      expression: "{arrow: true,placement : 'left'}"
	    }],
	    attrs: {
	      "content": _vm.$t('vue2.editCalendarMenu.calendar_is_locked')
	    }
	  }, [(true) ? _c('div', {
	    staticClass: "d-cal__header__right__lock icon__bg-circle",
	    on: {
	      "click": _vm.toggleCalendarLock
	    }
	  }, [_c('span', {
	    staticClass: "icon-lock5"
	  })]) : _c('div', {
	    staticClass: "d-cal__header__right__lock"
	  }, [_c('span', {
	    staticClass: "icon-lock5"
	  })])]) : _vm._e()] : _vm._e()], 2)]), _vm._v(" "), (_vm.calendar) ? _c('EditCalendarEditName', {
	    attrs: {
	      "calendar": _vm.calendar
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.calendar) ? _c('EditCalendarDelete', {
	    attrs: {
	      "calendar": _vm.calendar
	    }
	  }) : _vm._e(), _vm._v(" "), _c('ExportCalendar', {
	    attrs: {
	      "isShowButton": false,
	      "isShowFromProp": _vm.isShowExportCalendarModal,
	      "calLink": _vm.iCalUrl
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsShowExportCalendarModal(false)
	      }
	    }
	  }), _vm._v(" "), (_vm.isShowMergeCalendars) ? _c('CalendarMergeModal', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "calendarId": _vm.calendarId,
	      "calendar": _vm.calendar
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsShowMergeCalendars(false)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowCalculateHours) ? _c('div', {
	    staticClass: "bg-overlay do-datepicker__dropdown__overlay",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        if ($event.target !== $event.currentTarget) { return null; }
	        _vm.isShowCalculateHours = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowAbsenceRequest) ? _c('UserRequest', {
	    on: {
	      "close": function($event) {
	        _vm.isShowAbsenceRequest = false
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1808 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "isCloseOnBgClick": false,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Opret fraværsindberetning")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Vælg ansat *")]), _vm._v(" "), _c('DSelect', {
	    ref: "userSelect",
	    attrs: {
	      "items": _vm.filteredUsers,
	      "multiple": false,
	      "placeholder": 'Vælg ansat',
	      "itemsSelected": _vm.itemsSelectedForDSelect,
	      "isShowRemoveButton": false
	    },
	    on: {
	      "add": _vm.onSelectUser,
	      "remove": function($event) {
	        return _vm.onSelectUser(null)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Ansættelse *")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.employmentId),
	      expression: "employmentId"
	    }],
	    staticClass: "height-34 do-select width-100",
	    attrs: {
	      "disabled": !_vm.userId || !_vm.hasEmploymentsWithNumber
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.employmentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.employments), function(employment) {
	    return _c('option', {
	      key: employment.id,
	      domProps: {
	        "value": employment.id
	      }
	    }, [_vm._v("\n            " + _vm._s(employment.title) + " - " + _vm._s(employment.employment_number) + "\n          ")])
	  }), 0), _vm._v(" "), (_vm.userId && !_vm.hasEmploymentsWithNumber) ? _c('p', {
	    staticClass: "text-explainer marg-05-top"
	  }, [_vm._v("\n          Den valgte bruger har ingen ansættelser med tjenestenummer\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Fraværstype *")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.absenceType),
	      expression: "absenceType"
	    }],
	    staticClass: "height-34 do-select width-100",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.absenceType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.absenceTypes), function(type) {
	    return _c('option', {
	      key: type.value,
	      domProps: {
	        "value": type.value
	      }
	    }, [_vm._v("\n            " + _vm._s(type.label) + "\n          ")])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group-flex"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Startdato *")]), _vm._v(" "), _c('DateSelector', {
	    staticClass: "width-100",
	    attrs: {
	      "date": _vm.startDate,
	      "width100": true
	    },
	    on: {
	      "changed": function($event) {
	        return _vm.setStartDate($event)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Slutdato")]), _vm._v(" "), _c('DateSelector', {
	    staticClass: "width-100",
	    attrs: {
	      "date": _vm.endDate,
	      "width100": true
	    },
	    on: {
	      "changed": function($event) {
	        return _vm.setEndDate($event)
	      }
	    }
	  })], 1)]), _vm._v(" "), (_vm.validationMessage) ? _c('p', {
	    staticClass: "text-explainer",
	    staticStyle: {
	      "margin-top": "8px"
	    }
	  }, [_vm._v(_vm._s(_vm.validationMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', {
	    staticClass: "d-modal__buttons__child"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'right',
	        animateFill: false,
	        animation: 'shift-away',
	        boundary: 'window',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n                  arrow: true,\n                    placement : 'right',\n                    animateFill: false,\n                    animation : 'shift-away',\n                    boundary: 'window',\n                    zIndex: 12312312312312\n                  }"
	    }],
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting,
	      'do-bttn--submit--disabled': !_vm.isValid
	    },
	    attrs: {
	      "disabled": !_vm.isValid || _vm.isSubmitting,
	      "content": _vm.saveKeyTooltip
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n          Send til OPUS\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1809 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal"
	  }, [(!_vm.isReadOnly) ? _c('div', {
	    staticClass: "d-guides"
	  }, [_c('h4', [_vm._v("Vejledning")]), _vm._v(" "), _vm._m(0), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), _c('GrundskoleIndberetningTimetalFag', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "undervisningskema": _vm.undervisningskema,
	      "fagFraStil": _vm.fagFraStil,
	      "isReadOnly": _vm.isReadOnly
	    },
	    on: {
	      "update": _vm.updateSubject,
	      "updateKonfirmation": _vm.updateKonfirmation,
	      "updatePraktik": _vm.updatePraktik,
	      "setTolaerer": _vm.setTolaerer,
	      "setForanstaltning": _vm.setForanstaltning,
	      "nulstilKlasse": _vm.nulstilKlasse
	    }
	  }), _vm._v(" "), _c('GrundskoleIndberetningTimetalFagSpecial', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "undervisningskema": _vm.undervisningskema,
	      "isReadOnly": _vm.isReadOnly
	    },
	    on: {
	      "update": _vm.updateSubject,
	      "updateKonfirmation": _vm.updateKonfirmation,
	      "updatePraktik": _vm.updatePraktik,
	      "setTolaerer": _vm.setTolaerer,
	      "setForanstaltning": _vm.setForanstaltning
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "italic"
	  }, [_vm._v("\n      I dette skema skal der indtastes oplysninger om de årlige undervisningstimer, som skolen planlægger at give\n      eleverne i de enkelte fag på hver årgang. Bemærk, at timetallene skal opgøres som undervisningstimer á 60\n      minutter.\n      Der er automatisk importeret timetal fra UVM, som I har mulighed for at tilpasse. Hvis I ikke ønsker at bruge\n      disse tal – eller ikke ønsker at indberette for en årgang – kan I blot klikke på \"Nulstil\".\n      "), _c('br'), _vm._v(" "), _c('a', {
	    staticClass: "text-link",
	    attrs: {
	      "target": "_blank",
	      "href": "https://test-data.stil.dk/grundskoleindberetning/Vejledninger/2024/1012/Praktisk%20vejledning_Antal%20elever%20og%20undervisningstimer_folkeskoler_2024.pdf"
	    }
	  }, [_vm._v("\n        Læs den officielle vejledning fra STIL her\n      ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('b', [_vm._v("Vær særlig opmærksom på:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("1) Tysk og Fransk skal udfyldes, da de står med 0."), _c('br'), _vm._v("2) Vælg hvilken årgang konfirmationsforberedelse finder\n        sted.")])
	}]}

/***/ }),
/* 1810 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('table', {
	    staticClass: "calendars-hours-table"
	  }, [_vm._m(0), _vm._v(" "), _c('tr', {
	    staticClass: "calendar-item calendar-item--subject"
	  }, [_vm._m(1), _vm._v(" "), _c('td', [_c('input', {
	    staticClass: "do-input",
	    attrs: {
	      "type": "number",
	      "step": "0.1"
	    },
	    domProps: {
	      "value": _vm.subjectHoursInput
	    },
	    on: {
	      "focus": _vm.selectAll,
	      "input": function($event) {
	        _vm.subjectHoursInput = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSavingSubjectHours,
	      'do-bttn--submit--disabled': !_vm.isSubjectHoursChanged
	    },
	    attrs: {
	      "disabled": _vm.isSavingSubjectHours || !_vm.isSubjectHoursChanged
	    },
	    on: {
	      "click": _vm.submitSubjectHours
	    }
	  }, [_vm._v("\n          Gem\n        ")])])]), _vm._v(" "), _vm._l((_vm.sortedRows), function(row) {
	    return _c('tr', {
	      key: row.calendar_id,
	      staticClass: "calendar-item"
	    }, [_c('td', [_vm._v("\n        " + _vm._s(_vm.calendarName(row.calendar_id)) + "\n        "), (_vm.differsFromSubject(row)) ? _c('div', {
	      staticClass: "do-pill do-pill--yellow calendars-hours-pill"
	    }, [_vm._v("afviger fra brikken (" + _vm._s(_vm.subjectDefaultHours()) + ")")]) : _vm._e()]), _vm._v(" "), (_vm.isEditable(row.calendar_id)) ? _c('td', [_c('input', {
	      staticClass: "do-input",
	      attrs: {
	        "type": "number",
	        "step": "0.1",
	        "placeholder": _vm.fallbackPlaceholder(row)
	      },
	      domProps: {
	        "value": row.hours
	      },
	      on: {
	        "focus": _vm.selectAll,
	        "input": function($event) {
	          return _vm.onInput(row.calendar_id, $event.target.value)
	        }
	      }
	    })]) : _c('td', [_c('span', [_vm._v("\n          " + _vm._s(_vm.displayHours(row)) + "\n          "), _c('div', {
	      staticClass: "do-pill do-pill--yellow calendars-hours-pill"
	    }, [_vm._v(_vm._s(_vm.displayHoursSource(row)))])])]), _vm._v(" "), _c('td', [(_vm.isEditable(row.calendar_id)) ? _c('button', {
	      staticClass: "do-bttn do-bttn--submit",
	      class: {
	        'do-bttn--submit--loading': _vm.savingRows[row.calendar_id],
	        'do-bttn--submit--disabled': !_vm.isChanged(row)
	      },
	      attrs: {
	        "disabled": _vm.savingRows[row.calendar_id] || !_vm.isChanged(row)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.submitRow(row.calendar_id)
	        }
	      }
	    }, [_vm._v("\n          Gem\n        ")]) : _vm._e()])])
	  })], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('th'), _vm._v(" "), _c('th', [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Klokketimer i skoleåret")])]), _vm._v(" "), _c('th')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('strong', [_vm._v("Brikken")])])
	}]}

/***/ }),
/* 1811 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "sds-schedule text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "sds-schedule__header"
	  }, [_c('h2', [_vm._v("Skemalæg brikker")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle sds-schedule__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "sds-schedule__content"
	  }, [_c('p', {
	    staticClass: "sds-schedule__period"
	  }, [_vm._v(_vm._s(_vm.periodLabel))]), _vm._v(" "), (_vm.rows.length > 1) ? _c('div', {
	    staticClass: "sds-schedule__common"
	  }, [_c('span', {
	    staticClass: "sds-schedule__common__label"
	  }, [_vm._v("Samme tid for alle:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.commonStart),
	      expression: "commonStart"
	    }],
	    staticClass: "sds-schedule__input sds-schedule__input--common",
	    attrs: {
	      "type": "time"
	    },
	    domProps: {
	      "value": (_vm.commonStart)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.commonStart = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "sds-schedule__common__sep"
	  }, [_vm._v("–")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.commonEnd),
	      expression: "commonEnd"
	    }],
	    staticClass: "sds-schedule__input sds-schedule__input--common",
	    attrs: {
	      "type": "time"
	    },
	    domProps: {
	      "value": (_vm.commonEnd)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.commonEnd = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.rows.length === 0) ? _c('p', {
	    staticClass: "sds-schedule__empty"
	  }, [_vm._v("Der er ingen brikker at skemalægge.")]) : _c('table', {
	    staticClass: "do-table do-table--striped sds-schedule__table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "sds-schedule__cell-name"
	  }, [_vm._v("Brik")]), _vm._v(" "), _c('th', {
	    staticClass: "sds-schedule__cell-classes"
	  }, [_vm._v("Klasser")]), _vm._v(" "), _c('th', {
	    staticClass: "sds-schedule__cell-time"
	  }, [_vm._v("Fra")]), _vm._v(" "), _c('th', {
	    staticClass: "sds-schedule__cell-time"
	  }, [_vm._v("Til")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row) {
	    return _c('tr', {
	      key: row.subject.id,
	      class: {
	        'sds-schedule__row--error': row.error
	      }
	    }, [_c('td', {
	      staticClass: "sds-schedule__cell-name"
	    }, [_c('span', {
	      staticClass: "sds-schedule__pill",
	      style: ({
	        backgroundColor: row.subject.color
	      })
	    }, [_vm._v(_vm._s(row.subject.name))])]), _vm._v(" "), _c('td', {
	      staticClass: "sds-schedule__cell-classes"
	    }, [_vm._v(_vm._s(_vm.classNames(row.subject) || '–'))]), _vm._v(" "), _c('td', {
	      staticClass: "sds-schedule__cell-time"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (row.start),
	        expression: "row.start"
	      }],
	      staticClass: "sds-schedule__input",
	      attrs: {
	        "type": "time"
	      },
	      domProps: {
	        "value": (row.start)
	      },
	      on: {
	        "change": function($event) {
	          row.error = false
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(row, "start", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', {
	      staticClass: "sds-schedule__cell-time"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (row.end),
	        expression: "row.end"
	      }],
	      staticClass: "sds-schedule__input",
	      attrs: {
	        "type": "time"
	      },
	      domProps: {
	        "value": (row.end)
	      },
	      on: {
	        "change": function($event) {
	          row.error = false
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(row, "end", $event.target.value)
	        }
	      }
	    })])])
	  }), 0)]), _vm._v(" "), (_vm.timeError) ? _c('p', {
	    staticClass: "sds-schedule__error"
	  }, [_vm._v("Sluttid skal være efter starttid for alle brikker.")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "sds-schedule__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    attrs: {
	      "disabled": _vm.isScheduling
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--loading': _vm.isScheduling
	    },
	    attrs: {
	      "disabled": _vm.isScheduling || _vm.rows.length === 0
	    },
	    on: {
	      "click": _vm.runSchedule
	    }
	  }, [_vm._v("Skemalæg")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1812 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "employment-templates text-dark"
	  }, [_c('div', {
	    staticClass: "employment-templates__header"
	  }, [_c('h2', [_vm._v("Stillingskategorier")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.openCreate
	    }
	  }, [_vm._v("\n      Opret stillingskategori\n    ")])]), _vm._v(" "), (_vm.isLoading) ? _c('div', [_c('Loader')], 1) : _c('table', {
	    staticClass: "do-table do-table--striped"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Titel")]), _vm._v(" "), _c('th', [_vm._v("Vikarløn")]), _vm._v(" "), _c('th', [_vm._v("Std. Lønkode ved vikarløn")]), _vm._v(" "), _c('th', [_vm._v("Std. Omkostningssted ved vikarløn ")]), _vm._v(" "), _c('th', [_vm._v("UV-grænse")]), _vm._v(" "), _c('th', [_vm._v("Lønkode")]), _vm._v(" "), (_vm.showSpecialSkoleSalaryCodeColumn) ? _c('th', [_vm._v("Spec-skole lønkode")]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  })])]), _vm._v(" "), _c('tbody', [(_vm.templates.length === 0) ? _c('tr', [_c('td', {
	    attrs: {
	      "colspan": _vm.emptyColspan
	    }
	  }, [_c('i', [_vm._v("Ingen stillingskategorier oprettet")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.templates), function(tpl) {
	    return _c('tr', {
	      key: tpl.id
	    }, [_c('td', [_vm._v(_vm._s(tpl.title))]), _vm._v(" "), _c('td', [(tpl.manual_salary) ? _c('span', {
	      staticClass: "do-pill do-pill--small do-pill--yellow"
	    }, [_vm._v("Vikarløn")]) : _c('span', {
	      staticClass: "muted"
	    }, [_vm._v("—")])]), _vm._v(" "), _c('td', [(tpl.manual_salary) ? [(_vm.salaryCodeTitle(tpl.salary_code_id)) ? _c('span', [_vm._v(_vm._s(_vm.salaryCodeTitle(tpl.salary_code_id)))]) : _c('i', {
	      staticClass: "muted"
	    }, [_vm._v("—")])] : _c('i', {
	      staticClass: "muted"
	    }, [_vm._v("—")])], 2), _vm._v(" "), _c('td', [(tpl.omkostningssted) ? [(_vm.costCenterTitle(tpl.omkostningssted)) ? _c('span', [_vm._v(_vm._s(_vm.costCenterTitle(tpl.omkostningssted)))]) : _c('i', {
	      staticClass: "muted"
	    }, [_vm._v("—")])] : _c('i', {
	      staticClass: "muted"
	    }, [_vm._v("—")])], 2), _vm._v(" "), _c('td', [(!tpl.manual_salary && tpl.hour_limit) ? [_vm._v("\n          " + _vm._s(tpl.hour_limit) + "\n        ")] : _c('i', {
	      staticClass: "muted"
	    }, [_vm._v("—")])], 2), _vm._v(" "), _c('td', [(!tpl.manual_salary && tpl.hour_limit_salary_code_id) ? [(_vm.salaryCodeTitle(tpl.hour_limit_salary_code_id)) ? _c('span', [_vm._v(_vm._s(_vm.salaryCodeTitle(tpl.hour_limit_salary_code_id)))]) : _c('i', {
	      staticClass: "muted"
	    }, [_vm._v("—")])] : _c('i', {
	      staticClass: "muted"
	    }, [_vm._v("—")])], 2), _vm._v(" "), (_vm.showSpecialSkoleSalaryCodeColumn) ? _c('td', [(!tpl.manual_salary && tpl.special_hour_limit_salary_code_id) ? [(_vm.salaryCodeTitle(tpl.special_hour_limit_salary_code_id)) ? _c('span', [_vm._v(_vm._s(_vm.salaryCodeTitle(tpl.special_hour_limit_salary_code_id)))]) : _c('i', {
	      staticClass: "muted"
	    }, [_vm._v("—")])] : _c('i', {
	      staticClass: "muted"
	    }, [_vm._v("—")])], 2) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "actions"
	    }, [_c('div', {
	      staticClass: "icon__bg-circle",
	      attrs: {
	        "title": "Redigér"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.openEdit(tpl)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-pencil"
	    })])])])
	  })], 2)]), _vm._v(" "), (_vm.isTemplateModalOpen) ? _c('DoEmploymentTemplate', {
	    attrs: {
	      "theEditEmploymentTemplate": _vm.editTemplate
	    },
	    on: {
	      "created": _vm.onTemplateCreated,
	      "updated": _vm.onTemplateUpdated,
	      "deleted": _vm.onTemplateDeleted,
	      "close": _vm.closeTemplateModal
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1813 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "active-user"
	  }, [(_vm.showCloseCross) ? _c('div', {
	    staticClass: "active-user__close-cross",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "active-user__title"
	  }, [_c('div', {
	    staticClass: "active-user__title__bttn icon__bg-circle hint--right",
	    attrs: {
	      "aria-label": _vm.$t('vue2.task_overview.task_and_hour_overview')
	    },
	    on: {
	      "click": _vm.emitShowUserTasks
	    }
	  }, [_c('svg', {
	    staticClass: "icon-chart tw-icon tw-icon--small",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm11 4a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M8 11a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm4-2a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z"
	    }
	  })])]), _vm._v(" "), _c('h2', {
	    staticClass: "marg-10-bottom"
	  }, [_vm._v(_vm._s(_vm.allUsersInHash[_vm.activeUserId].name))])]), _vm._v(" "), (_vm.canSeeSubjectRequests && _vm.userSubjectRequests.length > 0) ? _c('button', {
	    staticClass: "marg-10-bottom do-bttn do-bttn--small",
	    on: {
	      "click": _vm.openSubjectRequests
	    }
	  }, [_vm._v("Se fagønsker (" + _vm._s(_vm.userSubjectRequests.length) + ")")]) : _vm._e(), _vm._v(" "), _c('TasksTable', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['subjects'],
	      "hoursTitle": "UV",
	      "id": "teaching",
	      "tasks": _vm.getAllUserSubjectsAndTeachingTasks,
	      "user": _vm.allUsersInHash[_vm.activeUserId],
	      "userCalendarId": _vm.userCalId,
	      "assignedHours": _vm.getUserAssignedTeachingHours(_vm.activeUserId),
	      "isTeaching": true,
	      "isPoolsDeactivated": _vm.isPoolsDeactivated,
	      "showLessonsPerWeek": _vm.showLessonsPerWeek
	    },
	    on: {
	      "edit": _vm.setEditSubject,
	      "setActiveSubject": _vm.setActiveSubject,
	      "setActiveTaskSubject": _vm.setActiveTaskSubject
	    }
	  }), _vm._v(" "), _c('TasksTable', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['additional_tasks'],
	      "id": "tasks",
	      "hoursTitle": "Øvrig",
	      "user": _vm.allUsersInHash[_vm.activeUserId],
	      "tasks": _vm.getAllUserTasksTask,
	      "userCalendarId": _vm.userCalId,
	      "assignedHours": _vm.getUserAssignedTaskHours(_vm.activeUserId),
	      "isPoolsDeactivated": _vm.isPoolsDeactivated
	    },
	    on: {
	      "edit": _vm.setEditSubject,
	      "setActiveSubject": _vm.setActiveSubject,
	      "setActiveTaskSubject": _vm.setActiveTaskSubject
	    }
	  }), _vm._v(" "), _c('TasksTable', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['preparation'],
	      "id": "preperation",
	      "hoursTitle": "Forb.",
	      "user": _vm.allUsersInHash[_vm.activeUserId],
	      "tasks": _vm.getAllUserTasksPrep,
	      "userCalendarId": _vm.userCalId,
	      "assignedHours": _vm.getUserAssignedPreparationHours(_vm.activeUserId),
	      "isPoolsDeactivated": _vm.isPoolsDeactivated
	    },
	    on: {
	      "edit": _vm.setEditSubject,
	      "setActiveSubject": _vm.setActiveSubject,
	      "setActiveTaskSubject": _vm.setActiveTaskSubject
	    }
	  }), _vm._v(" "), (_vm.getAllUserTasksClub.length > 0) ? _c('TasksTable', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['club'],
	      "id": "club",
	      "hoursTitle": "SFO.",
	      "user": _vm.allUsersInHash[_vm.activeUserId],
	      "tasks": _vm.getAllUserTasksClub,
	      "userCalendarId": _vm.userCalId,
	      "assignedHours": _vm.getUserAssignedClubHours(_vm.activeUserId),
	      "isPoolsDeactivated": _vm.isPoolsDeactivated
	    },
	    on: {
	      "edit": _vm.setEditSubject,
	      "setActiveSubject": _vm.setActiveSubject,
	      "setActiveTaskSubject": _vm.setActiveTaskSubject
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isSchoolFeatureLocalePool && _vm.getAllUserTasksPool.length > 0) ? _c('TasksTable', {
	    attrs: {
	      "title": _vm.localPoolTitle,
	      "id": "pool",
	      "hoursTitle": _vm.localPoolTitle,
	      "user": _vm.allUsersInHash[_vm.activeUserId],
	      "tasks": _vm.getAllUserTasksPool,
	      "userCalendarId": _vm.userCalId,
	      "assignedHours": _vm.getUserAssignedPoolHours(_vm.activeUserId),
	      "isPoolsDeactivated": _vm.isPoolsDeactivated
	    },
	    on: {
	      "edit": _vm.setEditSubject,
	      "setActiveSubject": _vm.setActiveSubject,
	      "setActiveTaskSubject": _vm.setActiveTaskSubject
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.getAllUserTasksAvailable.length > 0) ? _c('TasksTable', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['available'],
	      "id": "available",
	      "hoursTitle": "Råd.",
	      "user": _vm.allUsersInHash[_vm.activeUserId],
	      "tasks": _vm.getAllUserTasksAvailable,
	      "userCalendarId": _vm.userCalId,
	      "assignedHours": 0,
	      "isPoolsDeactivated": _vm.isPoolsDeactivated
	    },
	    on: {
	      "edit": _vm.setEditSubject,
	      "setActiveSubject": _vm.setActiveSubject,
	      "setActiveTaskSubject": _vm.setActiveTaskSubject
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "active-user__agreements"
	  }, [_c('SubjectsDistributionUserAgreements', {
	    attrs: {
	      "userId": _vm.activeUserId
	    }
	  })], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-modal"
	    }
	  }, [(_vm.showSubjectRequests) ? _c('DModal', {
	    on: {
	      "close": function($event) {
	        _vm.showSubjectRequests = false
	      }
	    }
	  }, [_c('div', {
	    staticClass: "subject-requests-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('h3', {
	    staticClass: "subject-requests-modal__title"
	  }, [_vm._v("Fagønsker for " + _vm._s(_vm.allUsersInHash[_vm.activeUserId].name))]), _vm._v(" "), (_vm.isLoadingSubjectRequests) ? _c('div', {
	    staticClass: "subject-requests-modal__loading"
	  }, [_c('div', {
	    staticClass: "do-spinner"
	  })]) : [(_vm.userSubjectRequests.length > 0) ? _c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Fag")]), _vm._v(" "), _c('th', [_vm._v("Klasse")]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("Timer")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.userSubjectRequests), function(subject) {
	    return _c('tr', {
	      key: subject.id
	    }, [_c('td', [_c('div', {
	      staticClass: "subjects_subject",
	      style: ({
	        'background-color': subject.color
	      })
	    }, [_vm._v("\n                    " + _vm._s(subject.name) + "\n                  ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject.vKlass))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(subject.vHours))])])
	  }), 0)]) : _c('p', {
	    staticClass: "subject-requests-modal__empty"
	  }, [_vm._v("Ingen fagønsker registreret")])]], 2)]) : _vm._e()], 1), _vm._v(" "), (_vm.showSubjectRequests) ? _c('div', {
	    staticClass: "bg-overlay",
	    on: {
	      "click": function($event) {
	        _vm.showSubjectRequests = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-modal"
	    }
	  }, [(_vm.theActiveSubject && _vm.getTheActiveSubject) ? _c('DModal', {
	    staticStyle: {
	      "border-radius": "4px"
	    },
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": _vm.closeActiveSubject
	    }
	  }, [_c('SubjectsDistributionUserEditHours', {
	    attrs: {
	      "slot": "insertComponent",
	      "subject": _vm.getTheActiveSubject,
	      "teacher": _vm.getTheActiveUser,
	      "task": _vm.theActiveTask
	    },
	    on: {
	      "close": _vm.closeActiveSubject
	    },
	    slot: "insertComponent"
	  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.theActiveSubject && _vm.getTheActiveSubject) ? _c('div', {
	    staticClass: "bg-overlay",
	    on: {
	      "click": _vm.closeActiveSubject
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "datepickerrange"
	  }, [_c('div', {
	    staticClass: "dateselector dateselector-start"
	  }, [_c('dateselector', {
	    attrs: {
	      "date": _vm.start,
	      "minDate": _vm.minDate,
	      "maxDate": _vm.maxDate
	    },
	    on: {
	      "changed": _vm.setStartDate
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "dateselector dateselector-line"
	  }, [_vm._v("\n    -\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "dateselector dateselector-end"
	  }, [_c('dateselector', {
	    attrs: {
	      "date": _vm.end,
	      "minDate": _vm.minDate,
	      "maxDate": _vm.maxEndDate
	    },
	    on: {
	      "changed": _vm.setEndDate
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1815 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Hvilken ansættelse skal det tælle som?")]), _c('br'), _vm._v(" "), _c('select', {
	    staticClass: "do-select",
	    domProps: {
	      "value": _vm.selectedEmploymentTitle
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onChange($event.target.value)
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "value": ""
	    }
	  }, [_vm._v("Vælg ansættelse")]), _vm._v(" "), _vm._l((_vm.employmentToSelectForRules), function(employmentsType) {
	    return _c('option', {
	      domProps: {
	        "value": employmentsType
	      }
	    }, [_vm._v("\n      " + _vm._s(employmentsType) + "\n    ")])
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1816 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-create-task-for-user"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.create_activity.create_activity_for')) + " " + _vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.create_activity.title')))]), _vm._v(" "), _c('div', {
	    staticClass: "choose-subject"
	  }, [_c('dSelect', {
	    attrs: {
	      "items": _vm.sortedSubjects,
	      "receiveData": _vm.theNewSubject,
	      "multiple": false,
	      "placeholder": _vm.$t('vue2.create_activity.search_or_create'),
	      "itemSpaceBetween": true
	    },
	    on: {
	      "enter": _vm.onCreateNewSubject,
	      "update": _vm.setSubject,
	      "searchText": _vm.setTheSearchText,
	      "onSearchTextDebounced": _vm.onSearchTextDebounced,
	      "close": _vm.onCloseDSelect
	    },
	    scopedSlots: _vm._u([_vm._l((_vm.sortedSubjects), function(item, index) {
	      return {
	        key: "test",
	        fn: function(slotProps) {
	          return [_c('div', {
	            staticClass: "choose-subject__event_type"
	          }, [_vm._v("\n                " + _vm._s(slotProps.item.vSubjectType) + "\n              ")])]
	        }
	      }
	    })], null, true)
	  }, [_vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "noMatch"
	    },
	    slot: "noMatch"
	  }, [_c('h4', {
	    staticClass: "create-subject-link",
	    on: {
	      "click": _vm.onCreateNewSubject
	    }
	  }, [_vm._v("\n                + " + _vm._s(_vm.$t('vue2.substitution.create')) + ": \"" + _vm._s(_vm.theSearchText) + "\"\n              ")])])]), _vm._v(" "), (_vm.isShowCreateSubjectButton) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window'
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
	    }],
	    staticClass: "icon__bg-circle create-new-subject",
	    attrs: {
	      "content": _vm.$t("vue2.substitution.create") + " \"" + _vm.theSearchText + "\" "
	    },
	    on: {
	      "click": _vm.onCreateNewSubject
	    }
	  }, [_c('span', {
	    staticClass: "d-icon-plus"
	  })]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-group"
	  }, [_c('div', {
	    staticClass: "time-changer__group"
	  }, [_c('TimeChanger', {
	    attrs: {
	      "showIcon": true,
	      "start": _vm.startTime,
	      "end": _vm.endTime,
	      "isFiveMinutesInterval": false
	    },
	    on: {
	      "updateStart": _vm.setStartTime,
	      "updateEnd": _vm.setEndTime
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-group"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.date
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  })], 1), _vm._v(" "), (_vm.showSubstituteOption) ? _c('div', {
	    staticClass: "d-group"
	  }, [_c('div', {
	    staticClass: "set-as-substitute",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.isSetAsSubstitute = !_vm.isSetAsSubstitute
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "propOn": _vm.isSetAsSubstitute,
	      "allowChanges": false
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "d-label set-as-substitute__label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.create_activity.set_as_substitute')))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        boundary: 'window',
	        placement: 'top',
	        zIndex: '999999992'
	      }),
	      expression: "{\n                  arrow: true,\n                  animateFill: false,\n                  animation: 'shift-away',\n                  boundary: 'window',\n                  placement: 'top',\n                  zIndex: '999999992'\n                }"
	    }],
	    staticClass: "set-as-substitute__help",
	    attrs: {
	      "content": _vm.$t('vue2.create_activity.set_as_substitute_help')
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-question3 d-label__help"
	  })])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")]) : _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1817 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tbody', {
	    staticClass: "do-tbody"
	  }, [_c('tr', {
	    staticClass: "calendar-header"
	  }, [_c('td', [_c('div', {
	    staticClass: "calendar-header__title"
	  }, [_c('DDropdown', [_c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.$emit('createSubject', {
	          calendar: _vm.calendar,
	          users: _vm.users
	        })
	      }
	    }
	  }, [_vm._v("\n            Tilføj person til stue\n          ")])])]), _vm._v("\n      " + _vm._s(_vm.calendar.name) + "\n    ")], 1)]), _vm._v(" "), _c('td', {
	    staticClass: "norm"
	  }, [_vm._v("Norm")]), _vm._v(" "), _c('td', {
	    staticClass: "norm"
	  }, [_vm._v("I ugen")]), _vm._v(" "), _vm._l((_vm.eventsInDays), function(day) {
	    return _c('td', {
	      key: day.dateId
	    }, [_c('div', {
	      staticClass: "calendar__header__day"
	    }, [_c('div', [_c('DutySchedulePlanCalendarDayStats', {
	      attrs: {
	        "openingHours": _vm.openingHours,
	        "hours": day.v_formattedTime
	      }
	    })], 1)])])
	  })], 2), _vm._v(" "), _vm._l((_vm.usersWithCalc), function(user) {
	    return _c('tr', {
	      key: ("user-row-" + (user.id)),
	      staticClass: "user-row"
	    }, [_c('td', [_c('div', {
	      staticClass: "user-name"
	    }, [_c('DDropdown', {
	      staticClass: "title--grey",
	      on: {
	        "open": function($event) {
	          return _vm.readUserSubject(user)
	        }
	      }
	    }, [_c('ul', {
	      attrs: {
	        "slot": "list"
	      },
	      slot: "list"
	    }, [(_vm.isLoadingTheUserSubject) ? _c('li', [_c('div', {
	      staticClass: "do-spinner"
	    })]) : _c('li', {
	      staticClass: "d-item-warning",
	      on: {
	        "click": function($event) {
	          return _vm.setTheDeleteUser(user)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    }), _vm._v(" " + _vm._s(_vm.theUserSubject && _vm.theUserSubject.can_delete ? 'Slet' : 'Fjern') + " fra\n            stue\n          ")])])]), _vm._v("\n      " + _vm._s(user.name) + "\n    ")], 1)]), _vm._v(" "), _c('td', {
	      staticClass: "norm"
	    }, [_vm._v(_vm._s(user.v_employment))]), _vm._v(" "), _c('td', {
	      staticClass: "norm"
	    }, [_vm._v(_vm._s(user.v_events.v_minutesFormatted))]), _vm._v(" "), _vm._l((_vm.days), function(day) {
	      return _c('td', {
	        key: ("day-cell-" + (user.id) + "-" + (day.dateFormatted))
	      }, [_c('DutyScheduleCalendarUserDay', {
	        attrs: {
	          "user": user,
	          "date": day.date,
	          "eventsInHash": _vm.eventsInHash,
	          "subjectsInUserCalIdHash": _vm.subjectsInUserCalIdHash,
	          "theCreateEventObj": _vm.theCreateEventObj
	        },
	        on: {
	          "createEvent": function($event) {
	            return _vm.$emit('createEvent', $event)
	          },
	          "editEvent": function($event) {
	            return _vm.$emit('editEvent', $event)
	          }
	        }
	      })], 1)
	    })], 2)
	  }), _vm._v(" "), (_vm.theDeleteUser) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isSubmitButtonLoading": _vm.isDeletingUserSubject
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setTheDeleteUser(null)
	      },
	      "confirm": _vm.deleteUserSubject
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1818 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DSelect', {
	    attrs: {
	      "items": _vm.itemsFiltered,
	      "itemsSelected": _vm.itemsSelectedFormatted,
	      "placeholder": "Tilføj underviser",
	      "isDeleteAllAnOption": false,
	      "show": true
	    },
	    on: {
	      "update": _vm.update,
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('h4', {
	    attrs: {
	      "slot": "noMatch"
	    },
	    slot: "noMatch"
	  }, [_vm._v("Ingen personer matcher")])])
	},staticRenderFns: []}

/***/ }),
/* 1819 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "grid grid-pad box-size",
	    staticStyle: {
	      "overflow": "initial"
	    }
	  }, [_c('div', {
	    staticClass: "col-1-1 text-dark"
	  }, [_c('div', {
	    staticClass: "substitution"
	  }, [_c('div', {
	    staticClass: "header width-100"
	  }, [_c('div', {
	    staticClass: "flex space-between align-center"
	  }, [_c('div', {
	    staticClass: "substitution__header__left flex align-center"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.substitution.substitution')))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeSubstitutionSettings),
	      expression: "closeSubstitutionSettings"
	    }],
	    staticClass: "substitution__settings",
	    class: {
	      'substitution__settings--open': _vm.isSubstitutionSettingsOpen
	    }
	  }, [_c('button', {
	    staticClass: "substitution__settings__toggle",
	    attrs: {
	      "type": "button",
	      "aria-expanded": _vm.isSubstitutionSettingsOpen ? 'true' : 'false',
	      "aria-label": _vm.$t('vue2.substitution.settings')
	    },
	    on: {
	      "click": function($event) {
	        _vm.isSubstitutionSettingsOpen = !_vm.isSubstitutionSettingsOpen
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-more2"
	  })]), _vm._v(" "), (_vm.isSubstitutionSettingsOpen) ? _c('div', {
	    staticClass: "substitution__settings__dropdown"
	  }, [_c('div', {
	    staticClass: "substitution__settings__label"
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.substitution.settings')) + "\n                ")]), _vm._v(" "), _c('button', {
	    staticClass: "substitution__settings__item",
	    class: {
	      'substitution__settings__item--active': _vm.includeReservationsInSubstitution
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.toggleIncludeReservations
	    }
	  }, [_c('span', {
	    staticClass: "substitution__settings__checkbox",
	    class: {
	      'substitution__settings__checkbox--checked': _vm.includeReservationsInSubstitution
	    },
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "substitution__settings__item-text"
	  }, [_vm._v("\n                    " + _vm._s(_vm.$t('vue2.substitution.include_reservations')) + "\n                  ")])]), _vm._v(" "), _c('button', {
	    staticClass: "substitution__settings__item",
	    class: {
	      'substitution__settings__item--active': _vm.showOverlappingClassBadgeInSubstitution
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.toggleShowOverlappingClassBadge
	    }
	  }, [_c('span', {
	    staticClass: "substitution__settings__checkbox",
	    class: {
	      'substitution__settings__checkbox--checked': _vm.showOverlappingClassBadgeInSubstitution
	    },
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "substitution__settings__item-text"
	  }, [_vm._v("\n                    " + _vm._s(_vm.$t('vue2.substitution.show_overlapping_class_badge')) + "\n                  ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "substitution__header__right"
	  }, [_c('SubsAbsentWithoutEnd'), _vm._v(" "), (_vm.userCanSeeInternalNote) ? _c('SubsNote', {
	    attrs: {
	      "date": _vm.getDate
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isClassOnTripSchool) ? _c('button', {
	    staticClass: "marg-10-right no-print aku-button",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModalClassOnTrip(true)
	      }
	    }
	  }, [_vm._v("\n              Opret klassefravær\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.localSchedulerView) ? _c('button', {
	    staticClass: "marg-10-right no-print",
	    staticStyle: {
	      "height": "38px",
	      "width": "38px"
	    },
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "date-buttons marg-5-right",
	    class: {
	      inactive: _vm.isToday
	    },
	    on: {
	      "click": _vm.setToday
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.substitution.today')) + "\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "date-buttons marg-5-right",
	    on: {
	      "click": _vm.prevDay
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-left4"
	  })]), _vm._v(" "), _c('DatePicker', {
	    attrs: {
	      "date": _vm.getDate
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "marg-5-left date-buttons",
	    on: {
	      "click": _vm.nextDay
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-right4"
	  })]), _vm._v(" "), _c('SubstitutionCreate', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "users": _vm.allUsersSortedOnName,
	      "usersWithOngoingAbsenceInHash": _vm.usersWithOngoingAbsenceInHash,
	      "allUsersInCalIdHash": _vm.allUsersInCalIdHash
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "sub-header__subHeader"
	  }, [_c('Tabs', {
	    attrs: {
	      "tabs": _vm.absentTabs,
	      "selected": _vm.currentAbsentTabId
	    },
	    on: {
	      "select": _vm.onAbsentTabSelect
	    }
	  }), _vm._v(" "), _c('app-flipper-button', {
	    attrs: {
	      "preselectedTab": _vm.activeTab
	    },
	    on: {
	      "update": _vm.setSchedulerView
	    }
	  })], 1), _vm._v(" "), ((_vm.isLoadingSchoolCalenders || _vm.dataIsLoading) && !_vm.localSchedulerView) ? _c('spinner', {
	    staticStyle: {
	      "margin-top": "150px"
	    },
	    attrs: {
	      "color": "blue"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.localSchedulerView && !_vm.dataIsLoading && !_vm.isLoadingSchoolCalenders) ? _vm._l((_vm.absentUsers), function(user, idx) {
	    return _c('SubsUser', {
	      key: user.id,
	      attrs: {
	        "user": user,
	        "activeDSelect": _vm.activeDSelect,
	        "date": _vm.getDate,
	        "allEvents": _vm.allEvents,
	        "calsAndEventIds": _vm.calsAndEventIds,
	        "allEventsInAHash": _vm.allEventsInAHash,
	        "allUsersSortedOnName": _vm.allUsersSortedOnName,
	        "allUsersAndEvents": _vm.allUsersAndEvents,
	        "allCalendarsInAHash": _vm.allCalendarsInAHash,
	        "longAbsentListInHash": _vm.longAbsentListInHash,
	        "absentUsersHandledHash": _vm.absentUsersHandledHash,
	        "isSubStatusPendingActive": _vm.isSubStatusPendingActive
	      },
	      on: {
	        "splitLesson": _vm.setSplitLesson,
	        "setActiveDSelect": _vm.setActiveDSelect,
	        "selectedUser": function($event) {
	          _vm.selectedUser = user
	        },
	        "removeSubs": _vm.setRemoveSubsFromEvent,
	        "showLog": _vm.showEventLog
	      }
	    })
	  }) : _vm._e(), _vm._v(" "), (_vm.localSchedulerView) ? [_c('div', {
	    staticClass: "sub-scheduler"
	  }, [_c('div', {
	    staticClass: "sub-scheduler__header"
	  }, [_c('div', {
	    staticClass: "sub-scheduler__header__left"
	  }, [_c('div', {
	    staticClass: "sub-scheduler__filters sub-scheduler__filters__subzen"
	  }, [_c('SchedulerSort', {
	    attrs: {
	      "selected": _vm.selectedSort,
	      "locale": _vm.locale,
	      "groupTags": _vm.tags,
	      "selectedGroupTags": _vm.priorityGroupTags
	    },
	    on: {
	      "onSortBy": _vm.onSortBy,
	      "toggleGroupTag": _vm.togglePriorityGroupTag,
	      "clearAllGroupTags": _vm.clearAllPriorityGroupTags
	    }
	  }), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInLeft"
	    }
	  }, [(_vm.selectedSort === 'subzen') ? _c('scheduler-prioritizer', {
	    attrs: {
	      "propsIsPrioritizerActive": _vm.isPrioritizerActive
	    },
	    on: {
	      "setIsPrioritizerActive": function($event) {
	        _vm.isPrioritizerActive = $event
	      }
	    }
	  }) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "sub-scheduler__header__right sub-scheduler__header__right__filters"
	  }, [(_vm.hasAbsentUsers) ? _c('Tabs', {
	    attrs: {
	      "flatDesign": true,
	      "tabs": _vm.lessonViewTabs,
	      "selected": _vm.selectedLessonViewTabId
	    },
	    on: {
	      "select": _vm.onLessonViewTabSelect
	    }
	  }) : _vm._e(), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['in_the_class_this_day'],
	      "tags": _vm.classTags,
	      "selectedTags": _vm.selectedClassFilters
	    },
	    on: {
	      "select": _vm.toggleClassFilter,
	      "clear": _vm.clearAllClassFilters
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['absent'],
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFiltersAbsentUsers
	    },
	    on: {
	      "select": _vm.toggleAbsentFilter,
	      "clear": _vm.clearAllAbsentFilters
	    }
	  }), _vm._v(" "), _c('DoFilters', {
	    attrs: {
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters,
	      "selectedQuickFilters": _vm.selectedQuickFilters,
	      "eventTitleTags": _vm.eventTitleTags,
	      "selectedEventTitles": _vm.selectedEventTitleFilters,
	      "isSortable": true,
	      "sortItems": _vm.filterSortItems,
	      "isSortActive": _vm.isFilterSortActive,
	      "isPresenceOption": true,
	      "groupsRequiringPresence": _vm.groupsRequiringPresence
	    },
	    on: {
	      "select": _vm.toggleTag,
	      "clear": _vm.clearAllTags,
	      "toggleQuickFilter": function($event) {
	        return _vm.toggleQuickFilter($event)
	      },
	      "clearAll": _vm.clearAllFiltersForSubs,
	      "selectEventTitle": _vm.toggleEventTitleFilter,
	      "clearEventTitles": _vm.clearAllEventTitleFilters,
	      "sortItems": _vm.setFilterSortOrder,
	      "toggleSort": _vm.setIsFilterSortActive,
	      "togglePresenceGroup": _vm.togglePresenceGroup
	    }
	  })], 1)]), _vm._v(" "), _c('scheduler', {
	    attrs: {
	      "title": _vm.text,
	      "subsTitle": _vm.subsHeadline,
	      "items": _vm.absentAndSubs,
	      "isSortOnName": _vm.sortOnName,
	      "date": _vm.getDate,
	      "isSubStatusPendingActive": _vm.isSubStatusPendingActive,
	      "allCalendarsInHash": _vm.allCalendarsInAHash,
	      "longAbsentListInHash": _vm.longAbsentListInHash,
	      "isHideEventsNotOverlappingAbsence": _vm.isHideEventsNotOverlappingAbsence,
	      "selectedEventTitleFilters": _vm.selectedEventTitleFilters,
	      "selectedQuickFilters": _vm.selectedQuickFilters,
	      "selectedClassFilters": _vm.selectedClassFilters,
	      "selectedGroupFilters": _vm.appliedFilters
	    },
	    on: {
	      "removeSubs": _vm.setRemoveSubsFromEvent,
	      "showLog": _vm.showEventLog,
	      "setCreateEventOnUser": _vm.setCreateEventOnUser,
	      "splitLesson": _vm.setSplitLesson,
	      "editTimes": _vm.setEditTimesLesson,
	      "setTheOutOfSchoolLesson": function($event) {
	        return _vm.setTheOutOfSchoolLesson($event)
	      },
	      "setIsCancelLesson": function($event) {
	        return _vm.setIsCancelLesson($event)
	      }
	    }
	  })], 1)] : _vm._e()], 2), _vm._v(" "), (_vm.activeSplitLesson !== null) ? _c('splitLesson', {
	    attrs: {
	      "lesson": _vm.activeSplitLesson
	    },
	    on: {
	      "submitted": _vm.onSubmittedSplitEvent,
	      "closeSplitEvent": _vm.closeSplitLesson
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theEditTimesLesson) ? _c('SubsEventEditTimes', {
	    attrs: {
	      "lesson": _vm.theEditTimesLesson
	    },
	    on: {
	      "updated": _vm.onEditTimesUpdated,
	      "close": function($event) {
	        return _vm.setEditTimesLesson(null)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isModal) ? _c('AppModal', {
	    attrs: {
	      "submitTxt": _vm.i18n[_vm.locale]['button_text']
	    },
	    on: {
	      "close": function($event) {
	        _vm.isModal = false
	      },
	      "submit": _vm.removeSubs
	    }
	  }, [_c('h2', {
	    staticClass: "pad-10",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['remove_subs']) + "\n      ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['substitutes_for']))]), _vm._v(" "), _c('ul', {
	    staticClass: "marg-20-top marg-20-bottom bold text-blue"
	  }, _vm._l((_vm.userAndLessonAndSubsToBeDeleted.subsForTheSubToBeRemoved), function(sub) {
	    return _c('li', {
	      key: sub
	    }, [_vm._v("\n            " + _vm._s(_vm.allUsersInCalIdHash[sub].name) + "\n          ")])
	  }), 0), _vm._v(" "), _c('p', {
	    staticClass: "marg-5-bottom"
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale]['has_to_remove_subs']) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale]['click_on_remove_all']) + "\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.eventChangesEvent) ? _c('AppModal', {
	    attrs: {
	      "submitTxt": "OK",
	      "isShowFooter": false
	    },
	    on: {
	      "close": function($event) {
	        _vm.eventChangesEvent = null
	      }
	    }
	  }, [_c('h2', {
	    staticClass: "pad-10",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.eventChangesEvent.title))]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('EventChanges', {
	    attrs: {
	      "event-id": _vm.eventChangesEvent.id
	    }
	  })], 1)]) : _vm._e()], 1), _vm._v(" "), (_vm.activeAbsenceReason) ? _c('SubsEditAbsence') : _vm._e(), _vm._v(" "), (_vm.activeAbsentUser) ? _c('SubsUserPanel', {
	    attrs: {
	      "activeDate": _vm.getDate,
	      "isSubStatusPendingActive": _vm.isSubStatusPendingActive
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setActiveAbsentUser(null)
	      },
	      "readEvents": _vm.readEvents
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.createEventOnUser && _vm.createEventOnUser.user) ? _c('CreateTask', {
	    attrs: {
	      "user": _vm.createEventOnUser.user,
	      "initDate": _vm.createEventOnUser.date,
	      "showSubstituteOption": true
	    },
	    on: {
	      "close": function($event) {
	        _vm.setCreateEventOnUser(null)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isModalClassOnTrip) ? _c('ClassOnTrip', {
	    attrs: {
	      "initDate": _vm.getDate
	    },
	    on: {
	      "onCreatedEvents": _vm.readEvents,
	      "close": function($event) {
	        return _vm.setIsModalClassOnTrip(false)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theOutOfSchoolLesson) ? _c('DModalOutOfSchoolLesson', {
	    attrs: {
	      "event": _vm.theOutOfSchoolLesson,
	      "eventIdProp": 'id'
	    },
	    on: {
	      "updated": _vm.onOutOfSchoolLessonUpdated,
	      "close": function($event) {
	        return _vm.setTheOutOfSchoolLesson(null)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theCancelLesson) ? _c('DModalCancelLesson', {
	    attrs: {
	      "event": _vm.theCancelLesson,
	      "eventIdProp": 'id'
	    },
	    on: {
	      "updated": _vm.onCancelLessonUpdated,
	      "close": function($event) {
	        return _vm.setIsCancelLesson(null)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.schoolHasFeatureSMS) ? _c('SendMessages') : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1820 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "copy-rotate text-dark"
	  }, [_c('button', {
	    ref: "copy_calendars_button",
	    class: {
	      'do-bttn': _vm.activeCalendarDate
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleDropdown.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("Rotating schedule\n  ")]), _vm._v(" "), (_vm.isDropdown) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "copy-calendars__panel"
	  }, [_c('div', {
	    staticClass: "copy-rotate__header"
	  }, [_c('h3', [_vm._v("Rotating schedule:\n            "), (!_vm.isSeeDates) ? [_vm._v("Select days to copy")] : [_vm._v("Select dates to insert")]], 2), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": _vm.closeDropdown
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "copy-rotate__body"
	  }, [(!_vm.isSeeDates) ? _c('div', [(_vm.isLoading || _vm.isLoadingSchoolSettings) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : [_c('div', {
	    staticClass: "d-copy-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("\n                Number of days\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-number-picker"
	  }, [_c('button', {
	    on: {
	      "click": _vm.subtractDay
	    }
	  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.numberOfDays),
	      expression: "numberOfDays"
	    }],
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.numberOfDays)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.numberOfDays = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.addDay
	    }
	  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', [_c('ul', {
	    staticClass: "copy-rotate__number-of-days"
	  }, _vm._l((_vm.daysToCopy), function(day, index) {
	    return _c('li', {
	      key: index
	    }, [_c('p', {
	      staticClass: "d-circle"
	    }, [_vm._v(_vm._s(day.label))]), _vm._v(" "), _c('DateSelector', {
	      attrs: {
	        "date": day.date
	      },
	      on: {
	        "changed": function($event) {
	          return _vm.setDayToCopyDate($event, index)
	        }
	      }
	    })], 1)
	  }), 0)])]], 2) : _vm._e(), _vm._v(" "), (_vm.isSeeDates) ? _c('CopyCalendarRotateDates', {
	    attrs: {
	      "initStartDate": _vm.initStartPasteDate,
	      "schoolId": _vm.schoolId,
	      "daysToCopy": _vm.daysToCopy
	    },
	    on: {
	      "pasteDates": _vm.setPasteDates
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "copy-rotate__footer"
	  }, [(_vm.isSeeDates) ? _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isSeeDates = false
	      }
	    }
	  }, [_vm._v("Back to number of days")]) : _vm._e(), _vm._v(" "), (!_vm.isSeeDates) ? _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isSeeDates = true
	      }
	    }
	  }, [_vm._v("See dates")]) : _vm._e(), _vm._v(" "), (_vm.isSeeDates) ? _c('button', {
	    staticClass: "bttn bttn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Submit days")]) : _vm._e()])])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1821 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('CreateTaskForm', {
	    attrs: {
	      "user": _vm.user,
	      "date": _vm.date,
	      "theNewlyCreatedSubject": _vm.theNewlyCreatedSubject,
	      "showSubstituteOption": _vm.showSubstituteOption
	    },
	    on: {
	      "setDate": _vm.setDate,
	      "close": function($event) {
	        return _vm.$emit('close')
	      },
	      "createNewSubject": function($event) {
	        return _vm.setCreateNewSubject($event)
	      },
	      "onCreatedEvent": _vm.onCreatedEvent
	    }
	  }), _vm._v(" "), (_vm.theCreateNewSubjectName) ? _c('CreateTaskNewSubject', {
	    attrs: {
	      "user": _vm.user,
	      "date": _vm.date,
	      "title": _vm.theCreateNewSubjectName
	    },
	    on: {
	      "newSubject": _vm.onNewSubject,
	      "close": function($event) {
	        return _vm.setCreateNewSubject(null)
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.styleObj.left !== -10),
	      expression: "styleObj.left !== -10"
	    }]
	  }, [_c('div', {
	    staticClass: "do-scheduler__line",
	    style: ([{
	        left: _vm.styleObj.left + 'px'
	      },
	      {
	        backgroundColor: this.styleObj.color
	      }
	    ])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "do-scheduler__line",
	    style: ([{
	        right: _vm.styleObj.right + 'px'
	      },
	      {
	        backgroundColor: this.styleObj.color
	      }
	    ])
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1823 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.teachersInKlassSameTime.length > 0),
	      expression: "teachersInKlassSameTime.length > 0"
	    }]
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_c('span', {
	    staticClass: "icon-users"
	  }), _vm._v("\n    " + _vm._s(_vm.$t('vue2.substitution.lessons_that_overlap_in_class')) + "\n  ")]), _vm._v(" "), _c('ul', [_vm._l((_vm.teachersInKlassSameTime), function(userAndLesson, key) {
	    return (_vm.isShowAllTeachers || key < _vm.numberOfTeachersToShow) ? _c('li', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'left',
	          boundary: 'window',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  arrow: true,\n                  placement: 'left',\n                  boundary: 'window',\n                  zIndex: 2147483010\n                }"
	      }],
	      key: userAndLesson.user.user_calendar_id,
	      staticClass: "small-lesson",
	      class: {
	        'user--is-absent': userAndLesson.user.v_overlapping_absence.length > 0
	      },
	      style: ({
	        'border-left-color': userAndLesson.lesson.color
	      }),
	      attrs: {
	        "content": userAndLesson.user.v_overlapping_absence.length < 1 ? userAndLesson.lesson.v_title : userAndLesson.user.v_overlapping_absence
	      }
	    }, [(userAndLesson.user.v_is_substitute) ? _c('span', {
	      staticClass: "icon-users"
	    }) : _vm._e(), _vm._v("\n      " + _vm._s(userAndLesson.user.name) + "\n    ")]) : _vm._e()
	  }), _vm._v(" "), (_vm.teachersInKlassSameTime.length > _vm.numberOfTeachersToShow) ? _c('li', {
	    staticClass: "text-link",
	    on: {
	      "click": function($event) {
	        _vm.isShowAllTeachers = !_vm.isShowAllTeachers
	      }
	    }
	  }, [(!_vm.isShowAllTeachers) ? [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.show_more')) + " (" + _vm._s(_vm.numberOfTeachersHidden) + ")\n      ")] : [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.show_less')) + "\n      ")]], 2) : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1824 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "absence-reasons text-dark pad-1"
	  }, [_c('div', {
	    staticClass: "absence-reasons__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['absence_reasons']))]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'bottom'\n                }"
	    }],
	    staticClass: "do-bttn do-bttn--submit",
	    attrs: {
	      "content": '<p class=' + 'tooltip-shortcut' + '>' + _vm.$t('vue2.common.press') + '<span>N</span></p>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setIsCreateAbsenceReason(true)
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.i18n['create_absence']) + "\n    ")])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader') : [(_vm.absenceReasonsActive.length === 0) ? _c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n['no_absence_reasons_created']))]) : _c('AbsenceReasonsTable', {
	    attrs: {
	      "items": _vm.absenceReasonsActive,
	      "isAbsenceRequestActivated": _vm.isAbsenceRequestActivated,
	      "isAbsenceIntegrationActive": _vm.isAbsenceIntegrationActive,
	      "absenceCodes": _vm.absenceCodes,
	      "sdAbsenceCodes": _vm.sdAbsenceCodes,
	      "salarySystem": _vm.salarySystem
	    },
	    on: {
	      "editAbsencePrivate": _vm.editAbsencePrivate,
	      "editAbsenceCanRequest": _vm.editAbsenceCanRequest,
	      "editAbsenceOngoing": _vm.editAbsenceOngoing,
	      "editAbsenceCode": _vm.editAbsenceCode,
	      "toggleArchived": _vm.toggleArchived
	    }
	  }), _vm._v(" "), (_vm.absenceReasonsArchived.length > 0) ? _c('p', {
	    staticClass: "text-link marg-1-top",
	    on: {
	      "click": function($event) {
	        _vm.isShowArchived = !_vm.isShowArchived
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.isShowArchived ? _vm.i18n['hide_archived'] : _vm.i18n['show_archived']) + "\n      " + _vm._s('(' + _vm.absenceReasonsArchived.length + ')'))]) : _vm._e(), _vm._v(" "), (_vm.isShowArchived && _vm.absenceReasonsArchived.length > 0) ? _c('AbsenceReasonsTable', {
	    attrs: {
	      "items": _vm.absenceReasonsArchived,
	      "isAbsenceRequestActivated": _vm.isAbsenceRequestActivated,
	      "isAbsenceIntegrationActive": _vm.isAbsenceIntegrationActive,
	      "absenceCodes": _vm.absenceCodes,
	      "sdAbsenceCodes": _vm.sdAbsenceCodes,
	      "salarySystem": _vm.salarySystem
	    },
	    on: {
	      "editAbsencePrivate": _vm.editAbsencePrivate,
	      "toggleArchived": _vm.toggleArchived
	    }
	  }) : _vm._e()], _vm._v(" "), (_vm.isCreateAbsenceReason) ? _c('AbsenceReasonsCreate', {
	    attrs: {
	      "absenceCodes": _vm.absenceCodes,
	      "sdAbsenceCodes": _vm.sdAbsenceCodes,
	      "isAbsenceIntegrationActive": _vm.isAbsenceIntegrationActive,
	      "salarySystem": _vm.salarySystem
	    },
	    on: {
	      "create": _vm.handleCreateReason,
	      "cancel": function($event) {
	        return _vm.setIsCreateAbsenceReason(false)
	      }
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1825 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "selector"
	  }, [_c('span', {
	    staticClass: "icon-checkmark-circle",
	    class: {
	      active: _vm.institutionNumberConfirmed
	    }
	  }), _vm._v("\n    Institutionsnummer\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    Bekræft dit institutionsnummer\n    850999\n    "), _c('button', {
	    on: {
	      "click": _vm.institutionNumberConfirmedClick
	    }
	  }, [_vm._v("Ja det er korrekt")])]), _vm._v(" "), _c('div', {
	    staticClass: "selector"
	  }, [_c('span', {
	    staticClass: "icon-checkmark-circle",
	    class: {
	      active: _vm.dataAgreementConfirmed
	    }
	  }), _vm._v("\n    Dataaftale godkendt\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    Din skole har godkendt dataaftalen.\n    Din skole har ikke godkendt dataaftalen.\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "selector"
	  }, [_c('span', {
	    staticClass: "icon-checkmark-circle",
	    class: {
	      active: _vm.locationsConfirmed
	    }
	  }), _vm._v("\n    Lokaler oprettet i Aula\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    Lokaler er oprettet i Aula\n    "), _c('button', {
	    on: {
	      "click": _vm.locationsConfirmedClick
	    }
	  }, [_vm._v("Ja det er korrekt")])]), _vm._v(" "), _c('div', {
	    staticClass: "selector"
	  }, [_c('span', {
	    staticClass: "icon-checkmark-circle",
	    class: {
	      active: _vm.usersImported
	    }
	  }), _vm._v("\n    Brugere importeret\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    35 ud af 45 brugere er importeret.\n    "), _c('button', {
	    on: {
	      "click": _vm.usersImportedClick
	    }
	  }, [_vm._v("Vis brugere der kan importeres")])]), _vm._v(" "), _c('div', {
	    staticClass: "selector"
	  }, [_c('span', {
	    staticClass: "icon-checkmark-circle",
	    class: {
	      active: _vm.groupsImported
	    }
	  }), _vm._v("\n    Grupper importeret\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    15 ud af 18 grupper er importeret.\n    "), _c('button', {
	    on: {
	      "click": _vm.groupsImportedClick
	    }
	  }, [_vm._v("Vis grupper der kan importeres")])])])
	},staticRenderFns: []}

/***/ }),
/* 1826 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('table', {
	    staticClass: "d-table d-table__tasks"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'name'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortKey('name')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.getI18n(_vm.title)) + "\n      "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'calendar'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortKey('calendar')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.task_overview.belongs_to')) + "\n      "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "td-dates"
	  }, [(_vm.hasAnyDates) ? [_vm._v("Dato")] : _vm._e()], 2), _vm._v(" "), (!_vm.isOnlyShowScheduled) ? _c('th', {
	    staticClass: "is-number th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortKey('hours')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.assign_users_hours.assigned')) + "\n      "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
	    staticClass: "th-sorter is-number",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'actual'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortKey('actual')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n      "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled && !_vm.isOnlyShowScheduled) ? _c('th', {
	    staticClass: "th-sorter is-number",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'diff'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortKey('diff')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.assign_users_hours.diff')) + "\n      "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.tasks.length < 1) ? _c('tr', [_c('td', {
	    staticStyle: {
	      "width": "90%"
	    }
	  }, [_c('div', {
	    staticClass: "italic",
	    staticStyle: {
	      "padding": "4px"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.no_tasks_assigned')))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), (_vm.isShowScheduled) ? _c('td') : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td') : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedTasks), function(task) {
	    return _c('tr', {
	      key: task.id,
	      class: {
	        'user-tasks__row--editable': _vm.canEditTask(task)
	      },
	      attrs: {
	        "data-task-id": task.id,
	        "title": _vm.canEditTask(task) ? _vm.$t('vue2.common.edit') : null
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onTaskClick(task)
	        },
	        "contextmenu": function($event) {
	          return _vm.onTaskContextMenu($event, task)
	        }
	      }
	    }, [_c('td', [_c('div', {
	      staticClass: "task-with-edit"
	    }, [(task.can_schedule === 't') ? _c('div', {
	      staticClass: "subjects_subject",
	      style: ({
	        'background': task.color
	      })
	    }, [_vm._v("\n          " + _vm._s(task.name) + "\n        ")]) : _c('div', {
	      staticClass: "subjects_subject subjects_subject--not-subject"
	    }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
	      staticClass: "td-calendars"
	    }, [_vm._v("\n      " + _vm._s(_vm.getCalendarNames(task)) + "\n    ")]), _vm._v(" "), _c('td', {
	      staticClass: "td-dates"
	    }, [_vm._v(_vm._s(_vm.formatDateRange(task.from_date, task.to_date)))]), _vm._v(" "), (!_vm.isOnlyShowScheduled) ? _c('td', {
	      staticClass: "is-number"
	    }, [_c('span', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (!_vm.getIsHideTaskHours(task)),
	        expression: "!getIsHideTaskHours(task)"
	      }]
	    }, [_vm._v(_vm._s(_vm.getTasksHours(task)))])]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.getTaskActual(task)))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled && !_vm.isOnlyShowScheduled) ? _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(task.diff))]) : _vm._e()])
	  })], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), (!_vm.isOnlyShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'hours'
	    }
	  }, [_vm._v(_vm._s(_vm.sumOfHours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'actual'
	    }
	  }, [_vm._v(_vm._s(_vm.sumOfActual) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled && !_vm.isOnlyShowScheduled) ? _c('td', {
	    staticClass: "total-hours is-number",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'diff'
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.sumOfDiff) + "\n    ")]) : _vm._e()])])]), _vm._v(" "), (_vm.contextMenu) ? _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeContextMenu),
	      expression: "closeContextMenu"
	    }],
	    staticClass: "d-dropdown d-dropdown--show user-tasks__context-menu text-dark",
	    style: ({
	      top: _vm.contextMenu.y + 'px',
	      left: _vm.contextMenu.x + 'px'
	    })
	  }, [_c('ul', [_c('li', {
	    class: {
	      'user-tasks__context-menu__item--disabled': !!_vm.getTransferDisabledReason(_vm.contextMenu.task)
	    },
	    attrs: {
	      "title": _vm.getTransferDisabledReason(_vm.contextMenu.task)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onTransferScheduled(_vm.contextMenu.task)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-left4"
	  }), _vm._v("\n      " + _vm._s(_vm.$t('vue2.task_overview.transfer_scheduled_to_assigned')) + "\n      "), _c('span', {
	    staticClass: "user-tasks__context-menu__values"
	  }, [_vm._v("(" + _vm._s(_vm.getTasksHours(_vm.contextMenu.task) || 0) + " → " + _vm._s(_vm.getTaskActual(_vm.contextMenu.task)) + ")")])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.onEditFromContextMenu(_vm.contextMenu.task)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-pencil"
	  }), _vm._v("\n      " + _vm._s(_vm.$t('vue2.common.edit')) + "\n    ")])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1827 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "subject-table"
	  }, _vm._l((_vm.filteredKlassCals), function(klassCal) {
	    return _c('table', {
	      key: klassCal.id,
	      staticClass: "do-table"
	    }, [_c('thead', [_c('tr', [(_vm.isEditingDates) ? _c('th', {
	      staticClass: "subject-table__th subject-table__th--select"
	    }) : _vm._e(), _vm._v(" "), _c('th', {
	      staticClass: "subject-table__th subject-table__th--name"
	    }, [_vm._v(_vm._s(klassCal.name))]), _vm._v(" "), _c('th', {
	      staticClass: "subject-table__th subject-table__th--type"
	    }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
	      staticClass: "subject-table__th subject-table__th--teachers"
	    }, [_vm._v("Personale")]), _vm._v(" "), (_vm.showDates) ? _c('th', {
	      staticClass: "subject-table__th subject-table__th--date"
	    }, [_vm._v("\n          Startdato\n          "), _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'top'
	        }),
	        expression: "{ arrow: true, placement: 'top' }"
	      }],
	      staticClass: "icon-wrench subject-table__wrench",
	      attrs: {
	        "content": "Rediger datoer på flere fag"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.$emit('toggleEditDates')
	        }
	      }
	    })]) : _vm._e(), _vm._v(" "), (_vm.showDates) ? _c('th', {
	      staticClass: "subject-table__th subject-table__th--date"
	    }, [_vm._v("\n          Slutdato\n          "), _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'top'
	        }),
	        expression: "{ arrow: true, placement: 'top' }"
	      }],
	      staticClass: "icon-wrench subject-table__wrench",
	      attrs: {
	        "content": "Rediger datoer på flere fag"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.$emit('toggleEditDates')
	        }
	      }
	    })]) : _vm._e(), _vm._v(" "), (_vm.showSubjectsRequest) ? _c('th', {
	      staticClass: "subject-table__th subject-table__th--requested"
	    }, [_vm._v("Ønsket af")]) : _vm._e(), _vm._v(" "), _c('th', {
	      staticClass: "subject-table__th subject-table__th--rooms"
	    }, [_vm._v("Lokaler")]), _vm._v(" "), _c('th', {
	      staticClass: "subject-table__th subject-table__th--klasses"
	    }, [_vm._v("Klasser")]), _vm._v(" "), _c('th', {
	      staticClass: "subject-table__th subject-table__th--lessons"
	    }, [_vm._v("Lek. pr. uge: " + _vm._s(_vm.totalLessons(klassCal.vSubjects)))]), _vm._v(" "), _c('th', {
	      staticClass: "subject-table__th subject-table__th--hours"
	    }, [_vm._v("Timer: " + _vm._s(_vm.totalHours(klassCal.vSubjects, klassCal.id)))])])]), _vm._v(" "), _c('tbody', [(klassCal.vSubjects.length === 0) ? _c('tr', [_c('td', {
	      staticClass: "subject-table__empty",
	      attrs: {
	        "colspan": 7 + (_vm.showSubjectsRequest ? 1 : 0) + (_vm.showDates ? 2 : 0) + (_vm.isEditingDates ? 1 : 0)
	      }
	    }, [_vm._v("Ingen fag")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedSubjects(klassCal.vSubjects)), function(subject) {
	      return _c('tr', {
	        key: subject.id,
	        staticClass: "subject-table__row",
	        class: {
	          'subject-table__row--selected': _vm.isEditingDates && _vm.selectedSubjectIds.indexOf(subject.id) >= 0
	        },
	        on: {
	          "click": function($event) {
	            return _vm.onRowClick(subject, klassCal.id)
	          }
	        }
	      }, [(_vm.isEditingDates) ? _c('td', {
	        staticClass: "subject-table__td subject-table__td--select",
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.$emit('toggleSubjectSelection', subject.id)
	          }
	        }
	      }, [_c('input', {
	        attrs: {
	          "type": "checkbox"
	        },
	        domProps: {
	          "checked": _vm.selectedSubjectIds.indexOf(subject.id) >= 0
	        }
	      })]) : _vm._e(), _vm._v(" "), _c('td', {
	        staticClass: "subject-table__td subject-table__td--name"
	      }, [_c('span', {
	        staticClass: "subject-table__color-dot",
	        style: ({
	          background: subject.color
	        })
	      }), _vm._v("\n          " + _vm._s(subject.name) + "\n        ")]), _vm._v(" "), _c('td', {
	        staticClass: "subject-table__td subject-table__td--type"
	      }, [_vm._v("\n          " + _vm._s(_vm.subjectTypeLabel(subject.subject_type)) + "\n        ")]), _vm._v(" "), _c('td', {
	        staticClass: "subject-table__td subject-table__td--teachers"
	      }, [(_vm.showTeacherPoolHours && subject.vTeachersWithPool && subject.vTeachersWithPool.length) ? _vm._l((subject.vTeachersWithPool), function(teacher, teacherIdx) {
	        return _c('span', {
	          key: teacherIdx,
	          staticClass: "subject-table__teacher"
	        }, [(teacherIdx > 0) ? [_vm._v(", ")] : _vm._e(), _vm._v(_vm._s(teacher.name)), (teacher.hours != null) ? _c('span', {
	          staticClass: "subject-table__teacher-pool"
	        }, [_vm._v(" (" + _vm._s(_vm.formatTeacherPoolHours(teacher.hours, subject)) + ")")]) : _vm._e()], 2)
	      }) : [_vm._v("\n            " + _vm._s(subject.vUserNames && subject.vUserNames.length ? subject.vUserNames.join(', ') : '') + "\n          ")]], 2), _vm._v(" "), (_vm.showDates) ? _c('td', {
	        staticClass: "subject-table__td subject-table__td--date"
	      }, [_vm._v("\n          " + _vm._s(_vm.formatDate(subject.from_date)) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showDates) ? _c('td', {
	        staticClass: "subject-table__td subject-table__td--date"
	      }, [_vm._v("\n          " + _vm._s(_vm.formatDate(subject.to_date)) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showSubjectsRequest) ? _c('td', {
	        staticClass: "subject-table__td subject-table__td--requested"
	      }, [_vm._v("\n          " + _vm._s(subject.vRequestedBy && subject.vRequestedBy.length ? subject.vRequestedBy.join(', ') : '') + "\n        ")]) : _vm._e(), _vm._v(" "), _c('td', {
	        staticClass: "subject-table__td subject-table__td--rooms"
	      }, [_vm._v("\n          " + _vm._s(_vm.getRoomNames(subject)) + "\n        ")]), _vm._v(" "), _c('td', {
	        staticClass: "subject-table__td subject-table__td--klasses"
	      }, [_vm._v("\n          " + _vm._s(subject.v_subjectOtherKlasses && subject.v_subjectOtherKlasses.length ? subject.v_subjectOtherKlasses.join(', ') : '') + "\n        ")]), _vm._v(" "), _c('td', {
	        staticClass: "subject-table__td subject-table__td--lessons"
	      }, [(_vm.isExcludedFromLessons(subject)) ? _c('span', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: false,
	            placement: 'left'
	          }),
	          expression: "{ arrow: false, placement: 'left' }"
	        }],
	        staticClass: "subject-table__excluded-icon",
	        attrs: {
	          "content": "Tæller ikke med i totalen"
	        }
	      }, [_vm._v("ⓘ")]) : _vm._e(), _vm._v("\n          " + _vm._s(subject.vLessonsPerWeek) + "\n        ")]), _vm._v(" "), _c('td', {
	        staticClass: "subject-table__td subject-table__td--hours"
	      }, [(_vm.isExcludedFromLessons(subject)) ? _c('span', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: false,
	            placement: 'left'
	          }),
	          expression: "{ arrow: false, placement: 'left' }"
	        }],
	        staticClass: "subject-table__excluded-icon",
	        attrs: {
	          "content": "Tæller ikke med i totalen"
	        }
	      }, [_vm._v("ⓘ")]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.getHoursForKlass(subject, klassCal.id)) + "\n        ")])])
	    })], 2)])
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 1828 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "isBottomStart": false,
	      "propOffset": [5, 5]
	    }
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	        trigger: 'click'
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              trigger : 'click'\n            }"
	    }],
	    staticClass: "do-bttn",
	    attrs: {
	      "slot": "title",
	      "content": _vm.$t('vue.deleteday.delete_day_or_week')
	    },
	    slot: "title"
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', {
	    staticClass: "d-item-warning",
	    on: {
	      "click": function($event) {
	        return _vm.setIsConfirmDeletion('week')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue.deleteday.whole_week')) + "\n      ")]), _vm._v(" "), _vm._l((_vm.weekDays), function(day) {
	    return _c('li', {
	      staticClass: "capitalize",
	      on: {
	        "click": function($event) {
	          return _vm.setIsConfirmDeletion(day)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(day.name) + "\n      ")])
	  })], 2)]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-modal"
	    }
	  }, [(_vm.isConfirmDeletion) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isSubmitButtonLoading": _vm.isDeleting
	    },
	    on: {
	      "close": _vm.closeIsConfirmDelete,
	      "confirm": _vm.onConfirmDelete
	    }
	  }, [_c('h3', {
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_vm._v(_vm._s(_vm.theDeleteText))])]) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1829 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "d_cal_dragged",
	    staticClass: "d-cal__subjects__subject__dragged",
	    style: (_vm.styleObj)
	  }, [_vm._v("\n  " + _vm._s(_vm.subjectTitle) + "\n")])
	},staticRenderFns: []}

/***/ }),
/* 1830 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('input', {
	    ref: "input",
	    class: _vm.customClass,
	    style: (_vm.widthStyle),
	    on: {
	      "input": function($event) {
	        return _vm.updateValue($event.target.value)
	      },
	      "focus": _vm.selectAll,
	      "blur": _vm.formatValue
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1831 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-public"
	  }, [_c('div', {
	    staticClass: "do-public__header"
	  }, [_vm._m(0), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.calendarName))])]), _vm._v(" "), _c('div', {
	    staticClass: "do-public__body"
	  }, [(!_vm.calendar) ? _c('div', {
	    staticClass: "do-spinner__container"
	  }, [_c('div', {
	    staticClass: "do-spinner do-spinner--large"
	  })]) : _c('div', [_c('SmartScreen', {
	    attrs: {
	      "calendarId": _vm.calendarId
	    }
	  })], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "logo"
	    }
	  }, [_c('span', {
	    staticClass: "icon-docendo",
	    attrs: {
	      "id": "d-icon"
	    }
	  })])
	}]}

/***/ }),
/* 1832 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "subject-form__reductions"
	  }, [(_vm.isLoadingReductions) ? _c('Loader', {
	    attrs: {
	      "bg-color": '#f6f9fc'
	    }
	  }) : _c('table', {
	    staticClass: "do-table do-table--striped"
	  }, [_c('thead', [_c('th'), _vm._v(" "), _c('th', {
	    staticClass: "td-number td-sum"
	  }, [_vm._v(_vm._s(_vm.totalReductionHours))])]), _vm._v(" "), _c('tbody', [(_vm.subjectReductionsSorted.length === 0) ? _c('tr', [_c('p', {
	    staticClass: "pad-1 italic"
	  }, [_vm._v("Ingen reduktioner")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.subjectReductionsSorted), function(subjectReduction) {
	    return _c('tr', {
	      key: subjectReduction.id
	    }, [_c('td', [_vm._v("\n        " + _vm._s(subjectReduction.vActivityTitle) + " (" + _vm._s(subjectReduction.vActivityReductionHours) + ")\n      ")]), _vm._v(" "), _c('td', {
	      staticClass: "td-number"
	    }, [_vm._v(_vm._s(subjectReduction.vFormattedHours))])])
	  })], 2)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1833 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.emitClickAway),
	      expression: "emitClickAway"
	    }],
	    staticClass: "sub-popover__content"
	  }, [(_vm.isActiveEvents) ? [_c('div', {
	    staticClass: "sub-popover__content__active__lessons__header"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.activeEvents.length === 1 ? _vm.i18n[this.locale]['lesson'] : _vm.i18n[this.locale]['lessons']) + " " + _vm._s(_vm.i18n[this.locale]['selected']) + " ")])]), _vm._v(" "), _c('div', {
	    staticClass: "sub-popover__container"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.activeEventsStatus),
	      expression: "activeEventsStatus"
	    }],
	    staticClass: "do-select active-events__select",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.activeEventsStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.setStatusOnActiveEvents($event.target.value)
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "value": ""
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[this.locale]['choose_status']))]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[this.locale]['set_handled']))]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[this.locale]['set_not_handled']))])]), _vm._v(" "), _c('div', {
	    staticClass: "active-events__select"
	  }, [_c('d-select-subs-active-events', {
	    attrs: {
	      "possibleSubs": _vm.possibleSubs,
	      "activeEvents": _vm.activeEvents,
	      "isLoading": _vm.isActiveEventsLoading,
	      "placeholder": _vm.$t('vue2.sub_scheduler.choose_sub'),
	      "addClass": ['small-font']
	    },
	    on: {
	      "add": _vm.addSubToActiveEvents
	    }
	  })], 1), _vm._v(" "), (_vm.hasActiveEventsWithSubs) ? _c('button', {
	    staticClass: "do-bttn do-bttn--danger",
	    staticStyle: {
	      "margin": "0.5rem",
	      "width": "calc(100% - 1rem)"
	    },
	    attrs: {
	      "disabled": _vm.isActiveEventsLoading || _vm.activeEvents.length < 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.isConfirmRemoveSubs = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-user-minus",
	    staticStyle: {
	      "margin-right": "6px"
	    }
	  }), _vm._v("\n        " + _vm._s(_vm.i18n[this.locale]['remove_substitutes']) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isConfirmRemoveSubs) ? _c('ModalConfirmation', {
	    attrs: {
	      "isSubmitButtonLoading": _vm.isActiveEventsLoading,
	      "appendToBody": true,
	      "isShowConfirmDeleteMessage": false,
	      "showClose": false
	    },
	    on: {
	      "close": function($event) {
	        _vm.isConfirmRemoveSubs = false
	      },
	      "confirm": _vm.confirmRemoveSubs
	    }
	  }, [_c('h3', {
	    staticClass: "pad-1",
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_vm._v(_vm._s(_vm.i18n[this.locale]['remove_substitutes']) + "?")]), _vm._v(" "), _c('div', {
	    staticClass: "pad-1",
	    attrs: {
	      "slot": "custom_warning"
	    },
	    slot: "custom_warning"
	  }, [_c('p', {
	    staticClass: "marg-0-top"
	  }, [_vm._v(_vm._s(_vm.i18n[this.locale]['confirm_remove_substitutes_text']))]), _vm._v(" "), _c('table', {
	    staticClass: "do-table do-table--striped",
	    staticStyle: {
	      "font-size": "11px"
	    }
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "text-align": "left"
	    }
	  }, [_vm._v("Vikar")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "left"
	    }
	  }, [_vm._v("Vikar for")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.subsRemovalList), function(row, idx) {
	    return _c('tr', {
	      key: 'rm-' + idx
	    }, [_c('td', [_vm._v(_vm._s(row.subName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.forName))])])
	  }), 0)])]), _vm._v(" "), _c('p', {
	    attrs: {
	      "slot": "confirmText"
	    },
	    slot: "confirmText"
	  }, [_vm._v(_vm._s(_vm.i18n[this.locale]['remove_substitutes']))])]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "active-events"
	  }, _vm._l((_vm.activeEvents), function(activeEvent) {
	    return _c('li', {
	      key: activeEvent.calendar_id + activeEvent.event_id,
	      staticClass: "active-events__event",
	      class: {
	        'active-events__event--handled': activeEvent.lesson && activeEvent.lesson.v_status && activeEvent.lesson.v_status === 1
	      }
	    }, [_c('div', {
	      staticClass: "active-events__event__border-left",
	      style: ({
	        'backgroundColor': activeEvent.lesson.color
	      })
	    }), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(activeEvent.lesson.title))]), _vm._v(", "), _c('i', [_vm._v(_vm._s(activeEvent.lessonLTTime))])]), _vm._v(" "), _c('p', [_c('span', {
	      staticClass: "icon-user2"
	    }), _vm._v(_vm._s(activeEvent.user_to_substitute))]), _vm._v(" "), (activeEvent.selectedSubs && activeEvent.selectedSubs.length > 0) ? _c('p', [_c('span', {
	      staticClass: "icon-users3"
	    }), _vm._v("\n                " + _vm._s(activeEvent.selectedSubs.map(function (u) { return u.name; }).join(', ')) + "\n              ")]) : _vm._e()]), _vm._v(" "), (_vm.isActiveEventsLoading) ? _c('div', {
	      staticClass: "do-spinner"
	    }) : _vm._e()])
	  }), 0)], 1)] : [_c('div', {
	    staticClass: "sub-popover__content__header",
	    style: ({
	      'backgroundColor': _vm.lesson.color
	    })
	  }, [(_vm.lesson.event_type === 'absence') ? _c('h3', [_vm._v(_vm._s(_vm.getUser(_vm.lesson.calendar_id)))]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.lesson.title) + ",\n        "), _vm._l((_vm.klassesOnLesson), function(klass) {
	    return _c('a', {
	      staticClass: "link-white marg-5-right",
	      attrs: {
	        "href": klass.url,
	        "target": "blank"
	      }
	    }, [_vm._v("\n          " + _vm._s(klass.name) + "\n          "), _c('span', {
	      staticClass: "icon-calendar5",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "clock-and-delete"
	  }, [_c('p', [_c('span', {
	    staticClass: "icon-clock"
	  }), _vm._v(" " + _vm._s(_vm._f("time")(_vm.lesson.start)) + " - " + _vm._s(_vm._f("time")(_vm.lesson.end)))]), _vm._v(" "), (_vm.lesson.event_type !== 'absence') ? _c('DDropdown', {
	    attrs: {
	      "closeFromProp": _vm.propToCloseDropdown
	    }
	  }, [_c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [(!_vm.lesson.away) ? _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setActiveSplitLesson(_vm.lesson)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-wrench"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['split_lesson']) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setActiveEditTimes(_vm.lesson)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-clock"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['edit_times']) + "\n            ")]), _vm._v(" "), _c('li', {
	    staticClass: "d-item-warning",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.onDeletedLesson(_vm.lesson)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.substitution.delete_lesson')) + "\n            ")]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.$emit('setTheOutOfSchoolLesson', _vm.lesson)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-home2 icon-home2-away"
	  }), _vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale].out_of_school) + "\n            ")]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.$emit('setIsCancelLesson', _vm.lesson)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-notification22"
	  }), _vm._v("\n              " + _vm._s(!_vm.isCanceled ? _vm.i18n[_vm.locale].cancel_event : _vm.i18n[_vm.locale].uncancel_event) + "\n            ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-show-event__header__do-warning__container"
	  }, [(_vm.isCanceled) ? _c('div', {
	    staticClass: "d-show-event__header__do-warning do-warning do-warning--canceled"
	  }, [_c('span', {
	    staticClass: "icon-notification22"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale].canceled) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.isAway) ? _c('div', {
	    staticClass: "d-show-event__header__do-warning do-warning"
	  }, [_c('span', {
	    staticClass: "icon-home2 icon-home2-away",
	    staticStyle: {
	      "margin-right": "2px"
	    }
	  }), _vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].out_of_school) + "\n          ")]) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "sub-popover__container"
	  }, [(_vm.lesson.event_type !== 'absence') ? [_c('ul', {
	    staticClass: "sub-popover__content__body"
	  }, [_c('li', [_c('label', {
	    staticClass: "d-label"
	  }, [_c('span', {
	    staticClass: "icon-users"
	  }), _vm._v("\n              " + _vm._s(_vm.$t('vue2.sub_scheduler.choose_sub')) + "\n            ")]), _vm._v(" "), _c('dSelectSub', {
	    staticStyle: {
	      "font-size": "11px"
	    },
	    attrs: {
	      "addClass": ['small-font'],
	      "user": _vm.user,
	      "eventId": _vm.lesson.id,
	      "startTime": _vm.lesson.start,
	      "endTime": _vm.lesson.end,
	      "subs": _vm.substitutesOnLesson,
	      "othersOnLesson": _vm.othersOnLesson
	    },
	    on: {
	      "addedSubFromTeachers": function($event) {
	        _vm.propStatus = 1
	      },
	      "add": _vm.addSubstitute,
	      "remove": _vm.removeSubstitute
	    }
	  })], 1), _vm._v(" "), _c('li', [_c('label', {
	    staticClass: "d-label"
	  }, [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v("\n              " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.substitute_for')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), (_vm.othersOnLesson.length > 0) ? _c('li', [_c('label', {
	    staticClass: "d-label"
	  }, [_c('span', {
	    staticClass: "icon-users"
	  }), _vm._v("\n              " + _vm._s(_vm.$t('vue2.substitution.other_users')) + "\n            ")]), _vm._v(" "), _c('div', [_vm._l((_vm.othersOnLesson), function(other, idx) {
	    return (idx < _vm.showAllOnLesson) ? _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          zIndex: 123123123123,
	          onShow: function () { return other.v_isUserAbsentFromLesson.length > 0; }
	        }),
	        expression: "{\n                  arrow: true,\n                  zIndex: 123123123123,\n                  onShow: () => other.v_isUserAbsentFromLesson.length > 0\n                }"
	      }],
	      key: other.id,
	      class: {
	        'user--is-absent': other.v_isUserAbsentFromLesson.length > 0
	      },
	      attrs: {
	        "content": other.v_isUserAbsentFromLesson
	      }
	    }, [_vm._v(" " + _vm._s(other.name)), (idx < _vm.othersOnLesson.length - 1) ? _c('span', [_vm._v(",")]) : _vm._e()]) : _vm._e()
	  }), _vm._v(" "), _c('p', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAllOnLesson < _vm.othersOnLesson.length),
	      expression: "showAllOnLesson < othersOnLesson.length"
	    }],
	    staticClass: "text-blue pointer",
	    on: {
	      "click": function($event) {
	        _vm.showAllOnLesson = _vm.othersOnLesson.length
	      }
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('vue2.substitution.see_all')) + "\n              ")]), _vm._v(" "), _c('p', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAllOnLesson > 3),
	      expression: "showAllOnLesson > 3"
	    }],
	    staticClass: "text-blue pointer",
	    on: {
	      "click": function($event) {
	        _vm.showAllOnLesson = 3
	      }
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('vue2.substitution.see_less')))])], 2)]) : _vm._e(), _vm._v(" "), _c('LessonOverlapInKlass', {
	    attrs: {
	      "lesson": _vm.lesson
	    }
	  }), _vm._v(" "), _c('li', [_c('label', {
	    staticClass: "d-label"
	  }, [_c('span', {
	    staticClass: "icon-checkmark-circle"
	  }), _vm._v("\n              " + _vm._s(_vm.$t('vue2.sub_scheduler.status')) + "\n            ")]), _vm._v(" "), _c('lessonsSubstitutionStatus', {
	    attrs: {
	      "dropdown-placement": "bottom-start",
	      "user": _vm.user,
	      "statusProp": _vm.propStatus,
	      "lesson": _vm.lesson,
	      "othersOnLesson": _vm.othersOnLesson,
	      "userCalendarId": _vm.user.user_calendar_id,
	      "isSubStatusPendingActive": _vm.isSubStatusPendingActive
	    }
	  })], 1), _vm._v(" "), _c('li', [_c('label', {
	    staticClass: "d-label"
	  }, [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v("\n              " + _vm._s(_vm.i18n[this.locale]['edit_teachers']) + "\n            ")]), _vm._v(" "), (!_vm.isEditTeacher) ? _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.isEditTeacher = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-wrench"
	  })]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInLeft"
	    }
	  }, [(_vm.isEditTeacher) ? _c('div', [_c('Loader', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isUpdatingSubstitutes),
	      expression: "isUpdatingSubstitutes"
	    }],
	    staticStyle: {
	      "margin": "2rem auto"
	    },
	    attrs: {
	      "bgColor": "#fff",
	      "isExtraSmall": true
	    }
	  }), _vm._v(" "), _c('DSelectCalendars', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isUpdatingSubstitutes),
	      expression: "!isUpdatingSubstitutes"
	    }],
	    attrs: {
	      "itemType": "user",
	      "isDeleteAllAnOption": false,
	      "showTags": true,
	      "event": _vm.lesson,
	      "eventId": _vm.lesson.id,
	      "preSelectedItems": _vm.usersOnLesson,
	      "itemsThatCantBeDeleted": _vm.userCalIdsSubstituted,
	      "itemsUnselectable": [],
	      "showCreateButton": false,
	      "isLoadingProp": _vm.isUpdatingTeachers
	    },
	    on: {
	      "update": function($event) {
	        return _vm.setUsers($event)
	      }
	    }
	  })], 1) : _vm._e()])], 1)], 1)] : [_c('div', {
	    staticClass: "pad-10",
	    staticStyle: {
	      "font-size": "12px"
	    }
	  }, [_c('AbsenceReason', {
	    attrs: {
	      "user_calendar_id": _vm.user.user_calendar_id,
	      "reason": _vm.lesson,
	      "internalNote": _vm.lesson.teacher_notes
	    },
	    on: {
	      "showLog": function($event) {
	        return _vm.showLog(_vm.lesson)
	      },
	      "close": _vm.emitClose
	    }
	  })], 1)], _vm._v(" "), _c('div', {
	    staticClass: "sub-popover__content__note"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_c('span', {
	    staticClass: "icon-pencil"
	  }), _vm._v(" "), (_vm.lesson.event_type === 'absence') ? [_vm._v(_vm._s(_vm.$t('vue2.substitution.absence_notes')))] : [_vm._v(_vm._s(_vm.$t('vue2.substitution.substitute_notes')))]], 2), _vm._v(" "), _c('weip', {
	    attrs: {
	      "noteType": "teacher_notes",
	      "textInput": _vm.lesson.teacher_notes,
	      "lesson": _vm.lesson
	    },
	    on: {
	      "close": _vm.updateTeacherNote
	    }
	  })], 1)], 2)]], 2)
	},staticRenderFns: []}

/***/ }),
/* 1834 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c("div")
	},staticRenderFns: []}

/***/ }),
/* 1835 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Tidsbegrænset undervisningstillæg")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content text-dark"
	  }, [_c('p', {
	    staticClass: "tuv__intro"
	  }, [_vm._v("\n        Beregn UV-tillæg for en tidsbegrænset ansættelse ud fra skoledage og UV-tid, og send et fast tillæg\n        for perioden direkte til " + _vm._s(_vm.salaryTargetLabel) + " på baggrund af beregningen.\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "do-form-row"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Vælg ansat")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.userId),
	      expression: "userId"
	    }],
	    staticClass: "height-34 do-select width-100",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.userId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.onUserChange]
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "value": ""
	    }
	  }, [_vm._v("Vælg ansat")]), _vm._v(" "), _vm._l((_vm.users), function(user) {
	    return _c('option', {
	      key: user.id,
	      domProps: {
	        "value": user.id
	      }
	    }, [_vm._v(_vm._s(user.name))])
	  })], 2)]), _vm._v(" "), (_vm.userId) ? _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Vælg ansættelse")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.employmentId),
	      expression: "employmentId"
	    }],
	    staticClass: "height-34 do-select width-100",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.employmentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.onEmploymentChange]
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }), _vm._v(" "), _vm._l((_vm.userEmployments), function(emp) {
	    return _c('option', {
	      key: emp.id,
	      domProps: {
	        "value": emp.id
	      }
	    }, [_vm._v(_vm._s(emp.label))])
	  })], 2), _vm._v(" "), (_vm.userEmployments.length === 0) ? _c('p', {
	    staticClass: "tuv__hint"
	  }, [_vm._v("\n            Ingen " + _vm._s(_vm.salaryTargetLabel) + "-ansættelse med stillingskategori fundet for personen.\n          ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.userId) ? [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "isLoaderModal": true
	    }
	  }) : [_c('div', {
	    staticClass: "tuv__facts"
	  }, [_c('div', {
	    staticClass: "tuv__fact"
	  }, [_c('span', {
	    staticClass: "tuv__fact-label"
	  }, [_vm._v("Ansættelsesgrad")]), _vm._v(" "), _c('span', {
	    staticClass: "tuv__fact-value"
	  }, [_vm._v(_vm._s(_vm.ansaettelsesgradPercent != null ? _vm.formatPercent(_vm.ansaettelsesgradPercent) : '—'))])]), _vm._v(" "), _c('div', {
	    staticClass: "tuv__fact"
	  }, [_c('span', {
	    staticClass: "tuv__fact-label"
	  }, [_vm._v("Periode (årsnorm)")]), _vm._v(" "), _c('span', {
	    staticClass: "tuv__fact-value"
	  }, [_vm._v(_vm._s(_vm.periodLabel))])]), _vm._v(" "), _c('div', {
	    staticClass: "tuv__fact"
	  }, [_c('span', {
	    staticClass: "tuv__fact-label"
	  }, [_vm._v("Bruttotid")]), _vm._v(" "), _c('span', {
	    staticClass: "tuv__fact-value"
	  }, [_vm._v(_vm._s(_vm.yearNormHours != null ? _vm.formatDecimal(_vm.yearNormHours) : '—'))])])]), _vm._v(" "), _c('div', {
	    staticClass: "do-form-row"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Lønkode")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.salaryCodeId),
	      expression: "salaryCodeId"
	    }],
	    staticClass: "height-34 do-select width-100",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.salaryCodeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }), _vm._v(" "), _vm._l((_vm.selectableSalaryCodes), function(salaryCode) {
	    return _c('option', {
	      key: salaryCode.id,
	      domProps: {
	        "value": salaryCode.id
	      }
	    }, [_vm._v("\n                  " + _vm._s(salaryCode.vSupplementTitle || salaryCode.code) + "\n                ")])
	  })], 2)]), _vm._v(" "), (_vm.salarySystem !== 'SD') ? _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Omkostningssted")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.costCenterId),
	      expression: "costCenterId"
	    }],
	    staticClass: "height-34 do-select width-100",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.costCenterId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }), _vm._v(" "), _vm._l((_vm.costCenters), function(costCenter) {
	    return _c('option', {
	      key: costCenter.id,
	      domProps: {
	        "value": costCenter.id
	      }
	    }, [_vm._v("\n                  " + _vm._s(_vm.costCenterLabel(costCenter)) + "\n                ")])
	  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "do-form-row"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Skoledage i skoleåret")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.schoolDaysInYear),
	      expression: "schoolDaysInYear"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "number",
	      "min": "0",
	      "inputmode": "numeric",
	      "placeholder": "fx 200"
	    },
	    domProps: {
	      "value": (_vm.schoolDaysInYear)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.schoolDaysInYear = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Skoledage i periode")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.schoolDaysInPeriod),
	      expression: "schoolDaysInPeriod"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "number",
	      "min": "0",
	      "inputmode": "numeric",
	      "placeholder": "fx 46"
	    },
	    domProps: {
	      "value": (_vm.schoolDaysInPeriod)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.schoolDaysInPeriod = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("UV-grænse")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.graense),
	      expression: "graense"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "text",
	      "inputmode": "decimal",
	      "placeholder": "750"
	    },
	    domProps: {
	      "value": (_vm.graense)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.graense = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Justeret timetal")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.adjustedHours),
	      expression: "adjustedHours"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "text",
	      "inputmode": "decimal",
	      "placeholder": "Total UV-tid for perioden"
	    },
	    domProps: {
	      "value": (_vm.adjustedHours)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.adjustedHours = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "tuv__hint"
	  }, [_vm._v("\n              Som standard tæller "), _c('strong', [_vm._v("alt tildelt")]), _vm._v(" UV-tid med. Hvis kun det skemalagte for perioden skal\n              tælle med, så ret timetallet til det.\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "tuv__scheduled"
	  }, [_c('span', [_vm._v("\n                Skemalagt undervisning i perioden:\n                "), (!_vm.isLoadingScheduled) ? _c('strong', [_vm._v(_vm._s(_vm.scheduledInPeriod != null ? _vm.formatDecimal(_vm.scheduledInPeriod) + ' timer' : 'ukendt'))]) : _c('em', [_vm._v("henter…")])]), _vm._v(" "), (!_vm.isLoadingScheduled && _vm.scheduledInPeriod != null) ? _c('button', {
	    staticClass: "tuv__use-scheduled",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.useScheduled
	    }
	  }, [_vm._v("\n                Brug skemalagt\n              ")]) : _vm._e()])]), _vm._v(" "), (_vm.isCalcValid) ? _c('div', {
	    staticClass: "tuv__result"
	  }, [_c('div', {
	    staticClass: "tuv__result-steps"
	  }, [_c('div', {
	    staticClass: "tuv__result-row"
	  }, [_c('span', [_vm._v("UV-timer omregnet til fuld tid")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDecimal(_vm.uvOmregnetFuldtid)))])]), _vm._v(" "), _c('div', {
	    staticClass: "tuv__result-row"
	  }, [_c('span', [_vm._v("Overskud over grænse (fuld tid)")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDecimal(_vm.surplusFuldtid)))])])]), _vm._v(" "), _c('div', {
	    staticClass: "tuv__result-total"
	  }, [_c('span', [_vm._v("UV-tillæg der udbetales i perioden")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatDecimal(_vm.resultUnits)) + " timer")])]), _vm._v(" "), (_vm.resultUnits > 0) ? _c('div', {
	    staticClass: "tuv__result-row tuv__result-row--sub"
	  }, [_c('span', [_vm._v("Sendes som fast tillæg til " + _vm._s(_vm.salaryTargetLabel))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDecimal(_vm.unitsPerInstallment)) + " enh./md · " + _vm._s(_vm.installments) + " " + _vm._s(_vm.installments === 1 ? 'måned' : 'måneder'))])]) : _vm._e(), _vm._v(" "), (_vm.resultUnits <= 0) ? _c('p', {
	    staticClass: "tuv__result-note"
	  }, [_vm._v("\n              UV-tiden er under grænsen i perioden – der er ingen UV-tid at oprette tillæg for.\n            ")]) : _vm._e()]) : _vm._e()]] : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', {
	    staticClass: "d-modal__buttons__left"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons__right"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSaving
	    },
	    attrs: {
	      "disabled": !_vm.isValid || _vm.isSaving || _vm.isLoading
	    },
	    on: {
	      "click": _vm.create
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.submitButtonLabel) + "\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1836 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeWithoutSubmit),
	      expression: "closeWithoutSubmit"
	    }],
	    staticClass: "user-phonenumber"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fadeInRight",
	      "mode": "out-in"
	    }
	  }, [(!_vm.isEdit) ? _c('div', {
	    key: "showNumber",
	    staticClass: "current-number",
	    on: {
	      "click": _vm.setEdit
	    }
	  }, [(!_vm.isPendingConfirmation && _vm.number.length < 8) ? _c('p', {
	    staticClass: "pointer link"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.sms.add_number')))]) : _vm._e(), _vm._v(" "), (_vm.number.length > 7) ? _c('div', {
	    staticClass: "current-number__number flex align-center"
	  }, [_vm._v("\n        " + _vm._s(_vm.number) + "\n      ")]) : _vm._e()]) : _c('div', {
	    key: "editNumber",
	    staticClass: "add-number"
	  }, [_c('div', {
	    staticClass: "input-group hint",
	    class: _vm.hintClass,
	    attrs: {
	      "aria-label": _vm.$t('vue2.sms.number_must_be_8_digits')
	    }
	  }, [_c('div', {
	    staticClass: "flex-group"
	  }, [_c('div', {
	    staticClass: "flag__input-lookalike active-country"
	  }, [_c('img', {
	    staticClass: "country-flag",
	    attrs: {
	      "src": _vm.activeCountry.flag,
	      "alt": ""
	    }
	  }), _vm._v("+" + _vm._s(_vm.activeCountry.countryCode) + "\n            "), _c('DDropdown', [_c('span', {
	    staticClass: "icon-arrow-down5",
	    attrs: {
	      "slot": "d-dropdown__icon"
	    },
	    slot: "d-dropdown__icon"
	  }), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, _vm._l((_vm.countries), function(country) {
	    return _c('li', {
	      key: country.countryCode,
	      staticClass: "country-select__item",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveCountry(country)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "country-select__item__name"
	    }, [_c('img', {
	      staticClass: "country-flag",
	      attrs: {
	        "src": country.flag,
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(country.name))])]), _vm._v("\n                  +" + _vm._s(country.countryCode) + "\n                ")])
	  }), 0)])], 1), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.number),
	      expression: "number"
	    }],
	    ref: "inputfield",
	    staticClass: "input_phonenumber",
	    class: {
	      'input--error': _vm.showWarning
	    },
	    attrs: {
	      "type": "phonenumber",
	      "autocomplete": "off",
	      "placeholder": _vm.$t('vue2.sms.add_number')
	    },
	    domProps: {
	      "value": (_vm.number)
	    },
	    on: {
	      "keypress": function($event) {
	        return _vm.inputKeypress($event)
	      },
	      "keyup": [_vm.inputKeyup, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "submit", undefined, $event.key, undefined)) { return null; }
	        return _vm.keyPressEnter.apply(null, arguments)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        return _vm.closeWithoutSubmit.apply(null, arguments)
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.number = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.isNumberChanged) ? _c('button', {
	    staticClass: "submit-button",
	    class: [{
	        'submit-button--disabled': !_vm.isValidNumber && !_vm.isNumberBeingDeleted
	      },
	      {
	        'submit-button--delete': _vm.isNumberBeingDeleted
	      }
	    ],
	    attrs: {
	      "aria-label": _vm.$t('vue2.sms.number_must_be_8_digits')
	    },
	    on: {
	      "click": _vm.submitNumber,
	      "mouseenter": _vm.onMouseOver,
	      "mouseleave": _vm.onMouseLeave
	    }
	  }, [_c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isNumberBeingDeleted),
	      expression: "isNumberBeingDeleted"
	    }]
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.delete')) + " ")]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isNumberBeingDeleted),
	      expression: "!isNumberBeingDeleted"
	    }]
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])]) : _c('button', {
	    staticClass: "close-button",
	    on: {
	      "click": function($event) {
	        return _vm.closeWithoutSubmit('button')
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.close')) + "\n          ")])])])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1837 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true,
	      "placeInTop": _vm.isSalaryIntegrationActive
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark",
	    class: {
	      'd-modal--full-width': _vm.isSalaryIntegrationActive
	    },
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-create-task-for-user"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content",
	    class: {
	      'd-modal__content--no-employments': _vm.filteredEmployment.length === 0
	    }
	  }, [_c('table', {
	    staticClass: "do-table",
	    class: {
	      'do-table--max-width': !_vm.isSalaryIntegrationActive
	    }
	  }, [_c('thead', [(_vm.isSalaryIntegrationActive) ? [_c('th', [_vm._v("Ansættelse")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.isSalarySystemSD ? 'Tjenestenummer' : 'Ansættelsesnummer'))]), _vm._v(" "), (!_vm.isSalarySystemSD) ? _c('th', [_vm._v("Organisation")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Stillingskategori")]), _vm._v(" "), _c('th', {
	    staticClass: "td-subsalary-toggler"
	  }, [_vm._v("Vikarløn")]), _vm._v(" "), _c('th', [_vm._v("Std. lønkode ved vikarløn")]), _vm._v(" "), _c('th', [_vm._v("Std. omkostningsted ved vikarløn")])] : [_c('th', [_vm._v("\n            Ansættelse\n          ")]), _vm._v(" "), (_vm.filteredEmployment.length !== 0) ? _c('th', {
	    staticClass: "center"
	  }, [_vm._v("\n            Vikarløn\n          ")]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "td--delete"
	  })]], 2), _vm._v(" "), _c('tbody', [(_vm.filteredEmployment.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "text-explainer",
	    staticStyle: {
	      "font-weight": "normal"
	    }
	  }, [_vm._v("Ingen aktive ansættelser")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredEmployment), function(employment) {
	    return _c('tr', {
	      key: employment.id,
	      class: {
	        'employment--error': employment.v_has_error
	      }
	    }, [(_vm.isSalaryIntegrationActive) ? [_c('td', [_vm._v(_vm._s(employment.source_title ? employment.source_title : employment.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(employment.employment_number))]), _vm._v(" "), (!_vm.isSalarySystemSD) ? _c('td', [_vm._v(_vm._s(employment.organisation))]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "spinner-flex"
	    }, [_c('select', {
	      staticClass: "do-select",
	      domProps: {
	        "value": employment.employment_template_id
	      },
	      on: {
	        "change": function($event) {
	          return _vm.setEmploymentTemplate(employment, $event.target.value)
	        }
	      }
	    }, [_c('option', {
	      attrs: {
	        "disabled": "",
	        "value": ""
	      }
	    }), _vm._v(" "), _vm._l((_vm.employmentTemplates), function(s) {
	      return _c('option', {
	        key: s.id,
	        domProps: {
	          "value": s.id
	        }
	      }, [_vm._v("\n                    " + _vm._s(s.title) + "\n                  ")])
	    })], 2), _vm._v(" "), (_vm.isSavingTemplate) ? _c('div', {
	      staticClass: "do-spinner"
	    }) : _vm._e()])]), _vm._v(" "), _c('td', {
	      staticClass: "td-subsalary-toggler"
	    }, [(employment.employment_template_id) ? _c('div', {
	      staticClass: "d-input-group--toggler",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setIsManualSalary(employment, !employment.manual_salary)
	        }
	      }
	    }, [_c('AppToggle', {
	      attrs: {
	        "allowChanges": false,
	        "propOn": employment.manual_salary
	      }
	    })], 1) : _vm._e()]), _vm._v(" "), _c('td', [(employment.manual_salary) ? _c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (employment.salary_code_id),
	        expression: "employment.salary_code_id"
	      }],
	      staticClass: "do-select",
	      on: {
	        "change": function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(employment, "salary_code_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }
	      }
	    }, [_c('option', {
	      attrs: {
	        "disabled": "",
	        "value": ""
	      }
	    }), _vm._v(" "), _vm._l((_vm.salaryCodes), function(s) {
	      return _c('option', {
	        key: s.id,
	        domProps: {
	          "value": s.id
	        }
	      }, [_vm._v("\n                  " + _vm._s(s.vTitle) + "\n                ")])
	    })], 2) : _vm._e()]), _vm._v(" "), _c('td', [(employment.manual_salary) ? _c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (employment.default_omkostningssted),
	        expression: "employment.default_omkostningssted"
	      }],
	      staticClass: "do-select",
	      on: {
	        "change": function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(employment, "default_omkostningssted", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }
	      }
	    }, _vm._l((_vm.costCenters), function(costCenter) {
	      return _c('option', {
	        key: costCenter.code,
	        domProps: {
	          "value": costCenter.code
	        }
	      }, [_vm._v("\n                  " + _vm._s(costCenter.title) + "\n                ")])
	    }), 0) : _vm._e()])] : _vm._e(), _vm._v(" "), (!_vm.isSalaryIntegrationActive) ? [_c('td', [_vm._v(_vm._s(employment.title))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "d-input-group--toggler d-input-group--toggler--manual",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setIsManualSalary(employment, !employment.manual_salary)
	        }
	      }
	    }, [_c('AppToggle', {
	      attrs: {
	        "allowChanges": false,
	        "propOn": employment.manual_salary
	      }
	    })], 1)]), _vm._v(" "), _c('td', {
	      staticClass: "td--delete"
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: false,
	          placement: 'right',
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n              arrow: false,\n              placement: 'right',\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'}"
	      }],
	      staticClass: "icon__bg-circle icon__bg-circle--danger",
	      attrs: {
	        "content": employment['can_delete?'] ? 'Slet ansættelsen' : 'Arkiver ansættelsen'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setDeleteEmployment(employment)
	        }
	      }
	    }, [(employment['can_delete?']) ? _c('span', {
	      staticClass: "icon-bin"
	    }) : _c('svg', {
	      staticClass: "tw-icon",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24",
	        "fill": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "d": "M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "d": "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "d": "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z"
	      }
	    })])])])] : _vm._e()], 2)
	  })], 2)]), _vm._v(" "), (_vm.user.v_oldEmployments && _vm.user.v_oldEmployments.length > 0) ? _c('p', {
	    staticClass: "text-link pointer marg-1-top",
	    on: {
	      "click": _vm.setIsShowOldEmployment
	    }
	  }, [(!_vm.isShowOldEmployment) ? [_vm._v("Se")] : [_vm._v("Skjul")], _vm._v("\n        arkiverede ansættelser\n      ")], 2) : _vm._e(), _vm._v(" "), (_vm.isShowOldEmployment) ? _c('ul', _vm._l((_vm.user.v_oldEmployments), function(employment) {
	    return _c('li', {
	      staticClass: "d-employment-item d-employment-item--deleted"
	    }, [_vm._v("\n          " + _vm._s(employment.title) + "\n        ")])
	  }), 0) : _vm._e()]), _vm._v(" "), (_vm.filteredEmployment.length !== 0) ? _c('div', {
	    staticClass: "d-modal__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSaving
	    },
	    on: {
	      "click": _vm.saveChanges
	    }
	  }, [_vm._v("\n        Gem\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.theDeleteEmployment) ? _c('DModal', {
	    attrs: {
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "d-modal__delete-employment",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Er du sikker?")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        _vm.theDeleteEmployment = null
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body"
	  }, [_c('p', [_vm._v("Er du sikker på, at du vil du " + _vm._s(_vm.theDeleteEmployment['can_delete?'] ? 'slette' : 'arkivere') + "\n            ansættelsen som "), _c('b', [_vm._v(_vm._s(_vm.theDeleteEmployment.title))]), _vm._v(" for\n            "), _c('b', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" hos "), _c('b', [_vm._v(_vm._s(_vm.school.name ? _vm.school.name : 'docendo'))])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.theDeleteEmployment['can_delete?']) ? _c('p', [_c('i', [_vm._v("Bemærk: Ansættelsen har ikke været brugt, og vil derfor\n            blive slettet permanent.")])]) : _c('p', [_c('i', [_vm._v("Bemærk: Ansættelsen har været brugt og vil derfor blive arkiveret, så den ikke kan anvendes\n            igen. Tidligere data vil dog ikke blive slettet.")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        _vm.theDeleteEmployment = null
	      }
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), (_vm.theDeleteEmployment['can_delete?']) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": function($event) {
	        return _vm.deleteEmployment(_vm.theDeleteEmployment)
	      }
	    }
	  }, [_vm._v("Slet ansættelsen\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.theDeleteEmployment['can_delete?'] && _vm.theDeleteEmployment['can_archive?']) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": function($event) {
	        return _vm.archiveEmployment(_vm.theDeleteEmployment)
	      }
	    }
	  }, [_vm._v("\n              Arkiver ansættelsen\n            ")]) : _vm._e()])])])]) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1838 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "scaleUp"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.addSubject),
	      expression: "addSubject"
	    }],
	    staticClass: "subject",
	    style: ({
	      'background-color': _vm.subject.color
	    })
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.hours),
	      expression: "hours"
	    }],
	    ref: "count",
	    staticClass: "subject__input-number",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.addSubject.apply(null, arguments)
	      },
	      "focus": _vm.selectAll,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = $event.target.value
	      }
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1839 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('DSelect', {
	    attrs: {
	      "items": _vm.itemsWithOccupation,
	      "event": _vm.event,
	      "isDeleteAllAnOption": _vm.isDeleteAllAnOption,
	      "itemsUnselectable": _vm.itemsUnselectable,
	      "isLoadingAvailability": _vm.isLoading,
	      "isLoading": _vm.isLoadingProp,
	      "itemsSelected": _vm.selectedItems,
	      "itemsThatCantBeDeleted": _vm.itemsThatCantBeDeleted,
	      "multiple": _vm.isMultiple,
	      "placeholder": _vm.i18n[_vm.locale]['search'],
	      "appendToBody": _vm.appendToBody,
	      "calculate-position": _vm.withPopper,
	      "show": _vm.show,
	      "showCreateButton": _vm.showCreateButton,
	      "newUserCalendarId": _vm.newUserCalendarId,
	      "disableAddMore": _vm.disableAddMore,
	      "isShowCollisions": true
	    },
	    on: {
	      "update": _vm.setSelectedItems,
	      "createNew": _vm.createNew,
	      "showCalendar": _vm.showCalendar
	    }
	  }, [(_vm.disableAddMore) ? _c('h4', {
	    attrs: {
	      "slot": "noMatch"
	    },
	    slot: "noMatch"
	  }, [_vm._v(_vm._s(_vm.disableAddMoreMessage))]) : _vm._e()]), _vm._v(" "), (_vm.activeCalendar) ? _c('CalendarViewDay', {
	    attrs: {
	      "event": _vm.event,
	      "date": _vm.date,
	      "calendar": _vm.activeCalendar,
	      "calendars": _vm.items
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose,
	      "close": function($event) {
	        _vm.activeCalendar = null
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1840 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "edit-times-event"
	  }, [(_vm.showModal) ? _c('AppModal', {
	    attrs: {
	      "submitTxt": _vm.i18n[_vm.locale].btn,
	      "isShowFooter": false
	    },
	    on: {
	      "close": _vm.closeModal
	    }
	  }, [_c('h1', {
	    attrs: {
	      "slot": "header"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].edit_times) + " " + _vm._s(_vm.lesson.title) + ", " + _vm._s(_vm._f("showDate")(_vm.lesson.start)))]), _vm._v(" "), _c('div', {
	    staticClass: "form",
	    attrs: {
	      "slot": "body"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "origin-lesson"
	  }, [_c('p', {
	    staticClass: "label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].current_times))]), _vm._v(" "), _c('div', {
	    staticClass: "flex border pad-10 relative"
	  }, [_c('p', [_vm._v(_vm._s(_vm.lesson.title))]), _vm._v(" "), _c('div', {
	    staticClass: "lesson_times"
	  }, [_c('div', [_vm._v(", kl. " + _vm._s(_vm.$filters.LT(_vm.lesson.start)))]), _vm._v(" "), _c('div', {
	    staticClass: "lesson_times__seperator"
	  }, [_vm._v(" -")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$filters.LT(_vm.lesson.end)))])]), _vm._v(" "), _c('div', {
	    staticClass: "marg-10-left"
	  }, [_vm._v("\n            (" + _vm._s(_vm.i18n[_vm.locale].duration) + ": " + _vm._s(_vm.oldDuration) + " " + _vm._s(_vm.i18n[_vm.locale].minutes) + ")\n          ")])])]), _vm._v(" "), _c('h3', {
	    staticClass: "marg-24-top flex align-center"
	  }, [_c('span', {
	    staticClass: "icon-clock"
	  }), _c('span', {
	    staticClass: "marg-5-left"
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale].new_times) + "\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "flex align-center edit-times-input-wrapper"
	  }, [_c('TimeChanger', {
	    attrs: {
	      "start": _vm.lesson.start,
	      "end": _vm.lesson.end,
	      "addClass": "edit-times-inputs"
	    },
	    on: {
	      "updateStart": _vm.updateStartTime,
	      "updateEnd": _vm.updateEndTime
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "marg-10-left"
	  }, [_vm._v("\n          (" + _vm._s(_vm.i18n[_vm.locale].duration) + ": " + _vm._s(_vm.newDuration) + " " + _vm._s(_vm.i18n[_vm.locale].minutes) + ")\n        ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer modal-footer__flex"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.closeModal.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.submit.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1841 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "intern-notes-container text-dark"
	  }, [_c('button', {
	    staticClass: "open-button",
	    on: {
	      "click": function($event) {
	        _vm.isOpen = !_vm.isOpen
	      }
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence')) + "\n    "), (_vm.absentUsersSorted.length > 0) ? _c('div', {
	    staticClass: "dot--for-autogenered hint--bottom",
	    attrs: {
	      "aria-label": _vm.$t('vue2.subs_ongoing_absence.ongoing_absence')
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.absentUsersSorted.length) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "slideInRight"
	    }
	  }, [(_vm.isOpen) ? _c('div', {
	    staticClass: "subs-note",
	    class: {
	      'subs-note--is-open': _vm.isOpen
	    }
	  }, [_c('div', {
	    staticClass: "subs-note__container"
	  }, [_c('div', {
	    staticClass: "subs-note__container__header"
	  }, [_c('div', {
	    staticClass: "subs-note__container__header__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.isOpen = !_vm.isOpen
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.teachers_with_ongoing_absence')))])]), _vm._v(" "), _c('div', {
	    staticClass: "subs-note__container__body"
	  }, [(_vm.absentUsersSorted.length < 1) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.no_teachers_with_ongoing_absence')))]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.absentUsersSorted), function(user) {
	    return _c('li', {
	      staticClass: "absent-user shadow"
	    }, [_c('div', {
	      staticClass: "absent-user__badges right marg-5-left"
	    }, [(_vm.getIsUserAbsenceAutogeneratedToday(user)) ? _c('div', {
	      staticClass: "badge badge--small badge--orange"
	    }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.auto_created')) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "absent-user__name"
	    }, [_c('img', {
	      attrs: {
	        "src": user.default_thumb_url,
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(user && user.name ? user.name : ''))])]), _vm._v(" "), _c('ul', _vm._l((user.reasons), function(reason) {
	      return _c('li', [_c('h4', [_vm._v(_vm._s(_vm.getReasonTitle(reason)) + " "), (reason.kmd_absence_code_id) ? _c('span', {
	        staticClass: "do-opus-badge"
	      }, [_vm._v("Åbenstående i OPUS")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('span', {
	        staticClass: "icon-calendar4"
	      }), _vm._v(" " + _vm._s(_vm.formatDate(reason.from_date)) + " -\n                    " + _vm._s(_vm.formatDate(reason.to_date)) + "\n                  ")]), _vm._v(" "), _c('div', [_c('span', {
	        staticClass: "icon-clock"
	      }), _vm._v(" " + _vm._s(_vm._f("showTime")(reason.from_time)) + " -\n                    " + _vm._s(_vm._f("showTime")(reason.to_time)) + "\n                  ")]), _vm._v(" "), _c('div', {
	        staticClass: "actions"
	      }, [_c('button', {
	        staticClass: "bttn bttn-primary shadow",
	        on: {
	          "click": function($event) {
	            return _vm.setTheEditAbsenceReason(reason)
	          }
	        }
	      }, [_vm._v("\n                      " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.edit_stop')) + "\n                    ")])])])
	    }), 0)])
	  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeIn"
	    }
	  }, [(_vm.isOpen) ? _c('div', {
	    staticClass: "bg-overlay",
	    on: {
	      "click": function($event) {
	        _vm.isOpen = false
	      }
	    }
	  }) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1842 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "items-list"
	  }, [_c('ul', {
	    staticClass: "items"
	  }, [(!_vm.isEditPeriod) ? _c('li', {
	    staticClass: "items__item"
	  }, [_c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v("Periode")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_vm._v("\n          " + _vm._s(_vm.dateRangeFormatted) + "\n          "), _c('div', {
	    staticClass: "hint--right",
	    attrs: {
	      "aria-label": "Redigér periode"
	    }
	  }, [_c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.isEditPeriod = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-wrench"
	  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.isEditPeriod) ? [_c('li', {
	    staticClass: "items__item"
	  }, [_c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v("Startdato")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.startDate
	    },
	    on: {
	      "changed": _vm.setStartDate
	    }
	  })], 1)])]), _vm._v(" "), _c('li', {
	    staticClass: "items__item"
	  }, [_c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v("Slutdato")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.endDate
	    },
	    on: {
	      "changed": _vm.setEndDate
	    }
	  })], 1)])])] : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "items__item"
	  }, [_c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v("Stillingsprosenten")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("%")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.employmentPercentage.hours),
	      expression: "employmentPercentage.hours"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.employmentPercentage.hours)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.employmentPercentageChanged($event.target.value)
	      },
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.employmentPercentage, "hours", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('li', {
	    staticClass: "items__item",
	    class: {
	      'items__item--fixed': _vm.workingHours.isFixed
	    }
	  }, [_c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v(_vm._s(_vm.workingHours.title))]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("timer")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.workingHours.hours),
	      expression: "workingHours.hours"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.workingHours.hours)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onEditWorkingHours($event.target.value)
	      },
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.workingHours, "hours", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('li', {
	    staticClass: "items__item",
	    class: {
	      'items__item--fixed': _vm.planleggingsdager.isFixed
	    }
	  }, [_c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v(_vm._s(_vm.planleggingsdager.title))]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("timer")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.planleggingsdager.hours),
	      expression: "planleggingsdager.hours"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.planleggingsdager.hours)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onEditPlanleggingsdager($event.target.value)
	      },
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.planleggingsdager, "hours", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "item__total"
	  }, [_c('p', [_vm._v("Sum arbeidstid i 38 uker")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.workingHoursWithoutPlanleggingsdager) + " timer")])]), _vm._v(" "), (true) ? _c('label', {
	    staticClass: "d-label marg-1-bottom"
	  }, [_vm._v("Reduksjon til undervisning")]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.subtractedItems), function(subtractItem, idx) {
	    return _c('li', {
	      key: subtractItem.id,
	      staticClass: "subtract-item items__item"
	    }, [(subtractItem.id === 'reduction_employee_percentage') ? [_c('p', {
	      staticStyle: {
	        "margin-left": "19px"
	      }
	    }, [_vm._v("\n          Stillingsprosenten reduksjon")]), _c('p', [_vm._v(_vm._s(subtractItem.hours) + "%")])] : [_c('div', {
	      staticClass: "subtract-item__title"
	    }, [_c('div', {
	      staticClass: "d-input-group__input__close icon__bg-circle icon__bg-circle--danger",
	      on: {
	        "click": function($event) {
	          return _vm.deleteItem(subtractItem)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-cross2"
	    })]), _vm._v("\n            " + _vm._s(subtractItem.title) + "\n          ")]), _vm._v(" "), (subtractItem.isOwn) ? _c('div', {
	      staticClass: "input-group__input"
	    }, [_c('span', {
	      staticClass: "label"
	    }, [_vm._v(_vm._s(subtractItem.unit ? subtractItem.unit : 'timer'))]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (subtractItem.hours),
	        expression: "subtractItem.hours"
	      }],
	      attrs: {
	        "type": "number"
	      },
	      domProps: {
	        "value": (subtractItem.hours)
	      },
	      on: {
	        "focus": function($event) {
	          return $event.target.select()
	        },
	        "change": function($event) {
	          return _vm.setSubtractedItemValue(subtractItem, $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(subtractItem, "hours", $event.target.value)
	        }
	      }
	    })]) : _c('p', [_vm._v(_vm._s(subtractItem.hours) + "%")])]], 2)
	  }), 0)], 2), _vm._v(" "), _c('ul', {
	    staticClass: "items",
	    attrs: {
	      "id": "items__list"
	    }
	  }, [(_vm.isAddNew) ? _c('li', {
	    staticClass: "items__item items__item__add__new"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newItemTitle),
	      expression: "newItemTitle"
	    }],
	    ref: "add_new_input",
	    attrs: {
	      "type": "text",
	      "placeholder": ""
	    },
	    domProps: {
	      "value": (_vm.newItemTitle)
	    },
	    on: {
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.addOwn.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newItemTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "items__item__add__new__buttons"
	  }, [_c('button', {
	    staticClass: "bttn",
	    on: {
	      "click": _vm.reset
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-primary",
	    on: {
	      "click": _vm.addOwn
	    }
	  }, [_vm._v("Gem")])])]) : _vm._e()]), _vm._v(" "), _c('DDropdown', {
	    staticClass: "add-more__dropdown",
	    attrs: {
	      "isShowDots": false
	    }
	  }, [(!_vm.isAddNew) ? _c('p', {
	    staticClass: "items__item__add",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("+ Legg til reduksjon")]) : _vm._e(), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('label', {
	    staticClass: "d-label d-label__headline"
	  }, [_vm._v("Livsfasetiltak")]), _vm._v(" "), _vm._l((_vm.possibleStandardItems), function(possibleItem, idx) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.addFromStandard(possibleItem)
	        }
	      }
	    }, [_vm._v(_vm._s(possibleItem.title) + "\n      ")])
	  }), _vm._v(" "), _c('li', {
	    staticClass: "items__item__add",
	    staticStyle: {
	      "border-top": "1px solid #ddd",
	      "margin-top": "0.5rem"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setIsAddNew(true)
	      }
	    }
	  }, [_vm._v("+\n        Lag din egen\n      ")])], 2)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1843 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "do-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2', [_vm._v("Deaktiver puljer")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [_c('div', {
	    staticClass: "d-explainer-box text-explainer text-explainer__error"
	  }, [_c('svg', {
	    staticClass: "tw-icon icon-help",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"
	    }
	  })]), _vm._v("\n        Deaktiver puljer for Undervisning, Øvrige opgaver m.m., så systemet i stedet beregner en samlet pulje baseret på det samlede antal timer allokeret på brikker.\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-label-and-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setDeactivatePoolsActive.apply(null, arguments)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label color-dark"
	  }, [_vm._v("Deaktiver puljer")]), _vm._v(" "), _c('div', {
	    staticClass: "do-switch",
	    class: {
	      'do-switch--active': _vm.isDeactivatePoolsActive
	    }
	  })]), _vm._v(" "), (_vm.canConfigureAssignedPoolNormWhenPoolsDeactivated && _vm.isDeactivatePoolsActive) ? [_c('div', {
	    staticClass: "d-explainer-box text-explainer marg-1-top"
	  }, [_c('svg', {
	    staticClass: "tw-icon icon-help",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"
	    }
	  })]), _vm._v("\n          Brug puljen fra " + _vm._s(_vm.localPoolTitle) + " i stedet for summen af " + _vm._s(_vm.localPoolTitle) + "-brikker i sammentællingen.\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-label-and-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setAssignedPoolFromNormActive.apply(null, arguments)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label color-dark"
	  }, [_vm._v(_vm._s(_vm.localPoolTitle) + " fra årsnorm")]), _vm._v(" "), _c('div', {
	    staticClass: "do-switch",
	    class: {
	      'do-switch--active': _vm.isAssignedPoolFromNormActive
	    }
	  })])] : _vm._e()], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 1844 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "dayCalContainer",
	    staticClass: "day-cal__event-container",
	    class: {
	      'day-cal__event-container--no-bg-colors': _vm.isCalNoBgColors
	    }
	  }, [_c('div', {
	    staticClass: "day-cal__event-container__events"
	  }, _vm._l((_vm.correctEvents), function(event) {
	    return _c('div', {
	      key: event.obj.event_key,
	      staticClass: "day-cal__event",
	      class: [{
	        'day-cal__event--is-away': event.obj.away
	      }, {
	        'day-cal__event--is-canceled': event.obj.canceled
	      }, {
	        'fc-bgevent__presence': event.obj.event_type === 'presence'
	      }, {
	        'day-cal__event--clickable': _vm.isEventsClickable
	      }],
	      style: ({
	        'borderColor': event.obj.color,
	        'height': event.height + 'px',
	        'top': (event.top - 1) + 'px',
	        'left': event.left + '%',
	        'width': event.width + '%'
	      }),
	      attrs: {
	        "data-cols": event.cols ? event.cols : 1
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onEventClick(event, $event)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "day-cal__event__content",
	      style: ({
	        fontSize: _vm.eventFontSize !== 10 ? _vm.eventFontSize + 'px' : ''
	      })
	    }, [_c('div', {
	      staticClass: "day-cal__event__content__header"
	    }, [_c('div', {
	      staticClass: "d-cal__event-title"
	    }, [(event.obj.away) ? _c('span', {
	      staticClass: "icon-home2 icon-home2-away icon-home2-away--schedules"
	    }) : _vm._e(), _vm._v(_vm._s(event.obj.title))]), _vm._v(" "), _c('div', {
	      staticClass: "d-cal__event-time"
	    }, [_c('span', {
	      staticClass: "d-cal__event-time__start"
	    }, [_vm._v(_vm._s(event.obj.event_starttime))]), _vm._v(" "), _c('span', {
	      staticClass: "d-cal__event-time__end"
	    }, [_vm._v(_vm._s(event.obj.event_endtime))]), _vm._v(" "), _c('span', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (event.obj.has_notes && !_vm.isCalendarInPrintMode),
	        expression: "event.obj.has_notes && !isCalendarInPrintMode"
	      }],
	      staticClass: "d-cal__event-meta icon-file-text2"
	    }), _vm._v(" "), _c('span', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (event.obj.has_substitute),
	        expression: "event.obj.has_substitute"
	      }],
	      staticClass: "d-cal__event-meta icon-users3"
	    }), _vm._v(" "), (event.obj.collision || event.obj.away || event.obj.canceled) ? _c('div', {
	      staticClass: "d-cal__event-meta d-cal__event-meta__fixed d-cal__event-meta--warning",
	      class: {
	        'd-cal__event-meta__fixed--canceled': event.obj.canceled
	      }
	    }, [(event.obj.canceled) ? _c('span', {
	      staticClass: "icon-notification22"
	    }) : _c('svg', {
	      staticClass: "tw-icon tw-icon--warning",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
	      }
	    })]), _vm._v("\n              " + _vm._s(_vm.getEventWarningLabel(event.obj)) + "\n            ")]) : _vm._e()])]), _vm._v(" "), (!_vm.isHideCalendars) ? [_c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (event.obj.teacher),
	        expression: "event.obj.teacher"
	      }],
	      staticClass: "day-cal__event__calendar"
	    }, [_c('span', {
	      staticClass: "icon-user"
	    }), _vm._v("\n            " + _vm._s(event.obj.teacher) + "\n          ")]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (event.obj.group),
	        expression: "event.obj.group"
	      }],
	      staticClass: "day-cal__event__calendar"
	    }, [_c('span', {
	      staticClass: "icon-users"
	    }), _vm._v("\n            " + _vm._s(event.obj.group) + "\n          ")]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (event.obj.room),
	        expression: "event.obj.room"
	      }],
	      staticClass: "day-cal__event__calendar"
	    }, [_c('span', {
	      staticClass: "icon-location"
	    }), _vm._v("\n            " + _vm._s(event.obj.room) + "\n          ")]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (event.obj.students),
	        expression: "event.obj.students"
	      }],
	      staticClass: "day-cal__event__calendar"
	    }, [_c('span', {
	      staticClass: "icon-users5"
	    }), _vm._v("\n            " + _vm._s(event.obj.students) + "\n          ")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
	      staticClass: "day-cal__event__bg",
	      style: ({
	        backgroundColor: event.obj.color
	      })
	    }), _vm._v(" "), _c('div', {
	      staticClass: "day-cal__event__sider",
	      style: ({
	        backgroundColor: event.obj.color
	      })
	    })])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 1845 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "loenbroek text-dark"
	  }, [_c('h2', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v("Lønbrøker")]), _vm._v(" "), (_vm.isNoSDConfiguration) ? [_vm._m(0)] : [_c('div', {
	    staticClass: "one-time-supplements__header"
	  }, [_c('Tabs', {
	    staticClass: "marg-1-bottom",
	    attrs: {
	      "tabs": _vm.tabsList,
	      "selected": _vm.activeFilter
	    },
	    on: {
	      "select": _vm.setFilter
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Personer',
	      "tags": _vm.uniqueNames,
	      "selectedTags": _vm.selectedNames,
	      "numberOfSelectedTagsToShow": 2,
	      "placeholder": 'Vælg personer'
	    },
	    on: {
	      "select": _vm.toggleName,
	      "clear": _vm.clearNames
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "one-time-supplements__body"
	  }, [(_vm.isLoading) ? _c('Loader') : [(_vm.activeFilter === 'draft') ? _c('div', {
	    staticClass: "do-table__filters"
	  }, [_c('span', {
	    staticClass: "loenbroek__info"
	  }, [_vm._v("\n            Lønbrøker i udbakken sendes automatisk til lønsystemet senere på dagen. Du kan redigere eller slette dem, så længe de ligger her.\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.createLoenbroek
	    }
	  }, [_vm._v("\n            Opret lønbrøk\n          ")])]) : _vm._e(), _vm._v(" "), _c('table', {
	    staticClass: "do-table",
	    class: {
	      'do-table--can-edit': _vm.activeFilter === 'draft'
	    }
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "th-sorter td-created",
	    class: {
	      'th-sorter--active': !_vm.isSortPristine && _vm.sortBy === 'vCreatedAt'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('vCreatedAt')
	      }
	    }
	  }, [_vm._v("\n              Oprettet "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'name'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('name')
	      }
	    }
	  }, [_vm._v("\n              Navn "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'tjenestenummer'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('tjenestenummer')
	      }
	    }
	  }, [_vm._v("\n              Tjenestenummer "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter td-date",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'date'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('date')
	      }
	    }
	  }, [_vm._v("\n              Dato "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'aarstimetal'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('aarstimetal')
	      }
	    }
	  }, [_vm._v("\n              Årsnorm "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'loendecimal'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('loendecimal')
	      }
	    }
	  }, [_vm._v("\n              Løndecimal "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'beskaeftigelsesdecimal'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('beskaeftigelsesdecimal')
	      }
	    }
	  }, [_vm._v("\n              Beskæftigelsesdecimal "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), (_vm.activeFilter === 'sent') ? _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'vApprovedAt'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('vApprovedAt')
	      }
	    }
	  }, [_vm._v("\n              Sendt til lønsystem "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]) : _vm._e(), _vm._v(" "), (_vm.activeFilter === 'sent') ? _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'vApprovedBy'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('vApprovedBy')
	      }
	    }
	  }, [_vm._v("\n              Godkendt af "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.displayedLoenbroeker.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": _vm.activeFilter === 'sent' ? 9 : 7
	    }
	  }, [_vm._v("\n              Ingen lønbrøker fundet\n            ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayedLoenbroeker), function(item) {
	    return _c('tr', {
	      key: item.id,
	      on: {
	        "click": function($event) {
	          return _vm.setEditItem(item)
	        }
	      }
	    }, [_c('td', {
	      staticClass: "td-created"
	    }, [_vm._v(_vm._s(item.vCreatedAt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vUserName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.tjenestenummer))]), _vm._v(" "), _c('td', {
	      staticClass: "td-date"
	    }, [_vm._v(_vm._s(item.vDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.aarstimetal || '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.loendecimal != null ? _vm.formatDecimal(item.loendecimal) : '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.beskaeftigelsesdecimal != null ? _vm.formatDecimal(item.beskaeftigelsesdecimal) : '—'))]), _vm._v(" "), (_vm.activeFilter === 'sent') ? _c('td', [_vm._v(_vm._s(item.vApprovedAt))]) : _vm._e(), _vm._v(" "), (_vm.activeFilter === 'sent') ? _c('td', [_vm._v(_vm._s(item.vApprovedBy))]) : _vm._e()])
	  })], 2)])]], 2)], _vm._v(" "), (_vm.isShowLoenbroekModal) ? _c('LoenbroekModal', {
	    attrs: {
	      "theEditItem": _vm.theEditItem
	    },
	    on: {
	      "close": function($event) {
	        _vm.isShowLoenbroekModal = false
	      },
	      "created": _vm.onCreated,
	      "deleted": _vm.onDeleted
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "one-time-supplements-no-sd"
	  }, [_c('h2', [_c('i', [_vm._v("Skolens SD-integration er ikke konfigureret korrekt. Kontakt Docendo for at få hjælp til opsætningen -\n          enten på chat eller email.")])])])
	}]}

/***/ }),
/* 1846 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-create-task-for-user"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [(_vm.isEditing) ? _c('h2', [_vm._v("Redigér")]) : _c('h2', [_vm._v("Opret")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Navn")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    ref: "input_title",
	    staticClass: "d-input",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.placeholder1
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onSubmit.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.theType === 'omkostningssteder' ? 'Kode' : 'Lønart'))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.code),
	      expression: "code"
	    }],
	    staticClass: "d-input",
	    class: {
	      'd-input--invalid': _vm.showCodeError
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.placeholder2
	    },
	    domProps: {
	      "value": (_vm.code)
	    },
	    on: {
	      "blur": function($event) {
	        _vm.touched.code = true
	      },
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onSubmit.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.code = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.showCodeError) ? _c('p', {
	    staticClass: "field-error"
	  }, [_vm._v(_vm._s(_vm.codeError))]) : _vm._e()]), _vm._v(" "), (_vm.isSalaryCode) ? _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Tillægsnummer "), _c('span', {
	    staticClass: "d-label__optional"
	  }, [_vm._v("(valgfrit)")])]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tillaegsnummer),
	      expression: "tillaegsnummer"
	    }],
	    ref: "input_tillaegsnummer",
	    staticClass: "d-input",
	    class: {
	      'd-input--invalid': _vm.showTillaegsnummerError
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.tillaegsnummer)
	    },
	    on: {
	      "blur": function($event) {
	        _vm.touched.tillaegsnummer = true
	      },
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onSubmit.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.tillaegsnummer = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.showTillaegsnummerError) ? _c('p', {
	    staticClass: "field-error"
	  }, [_vm._v(_vm._s(_vm.tillaegsnummerError))]) : _vm._e(), _vm._v(" "), (_vm.tillaegsnummerHelp) ? _c('p', {
	    staticClass: "field-help"
	  }, [_vm._v(_vm._s(_vm.tillaegsnummerHelp))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.submitError) ? _c('p', {
	    staticClass: "submit-error"
	  }, [_vm._v(_vm._s(_vm.submitError))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': !_vm.isValid || _vm.isSubmitting,
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.onSubmit
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.isEditing ? 'Opdatér' : 'Opret') + "\n        ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1847 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "presence-for-users text-dark"
	  }, [_c('div', {
	    staticClass: "d-table-layout"
	  }, [_c('div', {
	    staticClass: "d-table-layout__col"
	  }, [_c('div', {
	    staticClass: "d-table-layout__header"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_presence_to_many_user']))]), _vm._v(" "), _c('div', {
	    staticClass: "d-table-layout__header__right"
	  }, [_c('p', [_vm._v(_vm._s(_vm.selectedIdsLength) + " " + _vm._s(_vm.i18n[_vm.locale]['of']) + " " + _vm._s(_vm.usersFiltered.length))]), _vm._v(" "), (_vm.selectedIdsLength < 1) ? _c('div', {
	    staticClass: "hint--bottom-left",
	    attrs: {
	      "aria-label": _vm.$t('vue2.tagging.select_persons_first')
	    }
	  }, [_c('button', {
	    staticClass: "up__button no-print bttn bttn--disabled"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.presence.work_hours')) + "\n              "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })])]) : _c('PresenceUser', {
	    attrs: {
	      "firstDayOfWeek": _vm.firstDayOfWeek
	    },
	    on: {
	      "save": _vm.savePresence
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-table-layout__header"
	  }, [_c('div', [(_vm.selectedIdsLength < 1) ? _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.selectAll
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.tagging.select_all')))]) : _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.unSelectAll
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))])]), _vm._v(" "), _c('TaggingFilter', {
	    attrs: {
	      "users": _vm.usersWithProps,
	      "showHowMany": false,
	      "tags": _vm.tags,
	      "selectedTags": _vm.selectedTags,
	      "schoolid": _vm.schoolId
	    },
	    on: {
	      "set": _vm.setTag,
	      "remove": _vm.removeTag
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-table-layout__body"
	  }, [(_vm.isLoadingSchoolCalenders) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  }) : [(_vm.usersWithProps.length < 1) ? _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_users_created']))]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "presence__user-list"
	  }, _vm._l((_vm.usersWithProps), function(user) {
	    return _c('li', {
	      key: user.id,
	      class: {
	        'user--selected': user.v_isSelected
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleUser(user.id)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "d-checkbox",
	      class: {
	        'd-checkbox--active': user.v_isSelected
	      }
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])])
	  }), 0)]], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 1848 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-profile text-dark"
	  }, [(_vm.schoolIsFromDenmark) ? [(!_vm.theUser || !_vm.schoolId) ? _c('Loader') : [_c('div', {
	    staticClass: "marg-1-top"
	  }), _vm._v(" "), _c('ProfileSubjects', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "canEdit": _vm.isUserCanEdit,
	      "schoolId": _vm.schoolId,
	      "user": _vm.user
	    }
	  })]] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1849 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-dark"
	  }, [(_vm.isAllLoaded && !_vm.salarySystem) ? _c('ChooseSalarySystem', {
	    attrs: {
	      "schoolId": _vm.schoolId
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isInOpusModal) ? _c('div', {
	    staticClass: "d-sub-header"
	  }, _vm._l((_vm.menu), function(item) {
	    return _c('p', {
	      key: item.key,
	      staticClass: "d-sub-header__link",
	      class: {
	        'd-sub-header__link--active': _vm.activePage === item.key
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActivePage(item.key)
	        }
	      }
	    }, [_vm._v("\n      " + _vm._s(item.label) + "\n    ")])
	  }), 0) : _vm._e(), _vm._v(" "), (_vm.isAllLoaded && _vm.activeTab) ? [_c(_vm.activeTab.component, _vm._b({
	    tag: "component",
	    on: {
	      "select": _vm.onTemplateSelected,
	      "onTemplateCreated": _vm.onTemplateCreated,
	      "onTemplateUpdated": _vm.onTemplateUpdated,
	      "onTemplateDeleted": _vm.onTemplateDeleted,
	      "approveState": function($event) {
	        return _vm.$emit('approveState', $event)
	      }
	    }
	  }, 'component', _vm.getPropsFor(_vm.activeTab.key), false))] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1850 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('DSelect', {
	    attrs: {
	      "items": _vm.items,
	      "itemsSelected": _vm.selectedItems,
	      "itemsThatCantBeDeleted": _vm.itemsThatCantBeDeleted,
	      "multiple": _vm.isMultiple,
	      "placeholder": _vm.i18n[_vm.locale]['search'],
	      "appendToBody": _vm.appendToBody,
	      "calculate-position": _vm.withPopper,
	      "show": _vm.show,
	      "showCreateButton": _vm.showCreateButton,
	      "newUserCalendarId": _vm.newUserCalendarId
	    },
	    on: {
	      "update": _vm.setSelectedItems,
	      "add": _vm.add,
	      "remove": _vm.remove,
	      "createNew": _vm.createNew
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1851 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "setup-widget text-dark",
	    class: [{
	      setupWidgetOpen: _vm.showModal
	    }, {
	      animateSlide: _vm.animateSlide
	    }]
	  }, [_c('div', {
	    staticClass: "setup-widget__button",
	    on: {
	      "click": _vm.setShowModal
	    }
	  }, [_c('div', {
	    staticClass: "setup-widget__button__text"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.setupWidget.get_going_easy')))]), _vm._v(" "), _c('div', {
	    staticClass: "pointer setup-widget__button__close"
	  }, [(_vm.showModal) ? _c('span', {
	    staticClass: "icon-cross2"
	  }) : _c('span', {
	    staticClass: "icon-arrow-up4"
	  })])]), _vm._v(" "), (_vm.showModal && _vm.activeOnboardingStep === 0 && _vm.showLocalOnboardingArrow) ? _c('arrow', {
	    style: ({
	      'top': _vm.onboardArrowTopPx + 'px'
	    }),
	    attrs: {
	      "setupWidget": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "setup-widget__header"
	  }, [_c('div', {
	    staticClass: "onboarding_section"
	  }, [_c('div', {
	    staticClass: "setup-widget__header pad-20 pad-0-top"
	  }, [_c('h1', {
	    staticClass: "center text-white"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.setupWidget.get_going_easy')))]), _vm._v(" "), _c('doughnut', {
	    attrs: {
	      "animate": true,
	      "steps": _vm.stepsLength,
	      "stepNum": _vm.howManyDone
	    }
	  })], 1)]), _vm._v(" "), _c('ul', {
	    staticClass: "setup-widget__steps"
	  }, _vm._l((_vm.stepNumbers), function(step, index) {
	    return _c('li', {
	      staticClass: "setup-widget__steps__step js-onboard-item-click js-setupWidgetEvent",
	      class: {
	        'isDone': step.done
	      },
	      on: {
	        "click": function($event) {
	          return _vm.stepFnc(step.stepNum, step.title)
	        }
	      }
	    }, [(step.guide.length > 1) ? [_c('div', {
	      staticClass: "youtube-popup js-setupWidgetEvent step__button__video-guide",
	      on: {
	        "click": function($event) {
	          return _vm.openYouTube(step.videoid)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "step__number js-setupWidgetEvent",
	      class: {
	        stepNumberDone: step.done
	      }
	    }, [(step.done) ? _c('span', {
	      staticClass: "icon-checkmark4 js-setupWidgetEvent"
	    }) : _c('span', {
	      staticClass: "step__number__play icon-play4 js-setupWidgetEvent"
	    })]), _vm._v(" "), _c('span', {
	      staticClass: "step-text js-setupWidgetEvent"
	    }, [_vm._v(" " + _vm._s(step.title))])])] : [_c('div', {
	      staticClass: "js-setupWidgetEvent step__button__video-guide"
	    }, [_c('span', {
	      staticClass: "step__number js-setupWidgetEvent",
	      class: {
	        stepNumberDone: step.done
	      }
	    }, [(step.done) ? _c('span', {
	      staticClass: "icon-checkmark4 js-setupWidgetEvent"
	    }) : _c('span', {
	      staticClass: "js-setupWidgetEvent"
	    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('span', {
	      staticClass: "step-text js-setupWidgetEvent"
	    }, [_vm._v(" " + _vm._s(step.title))])])]], 2)
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "support-section"
	  }, [_c('div', {
	    staticClass: "support-section__list"
	  }, [_c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.showIntercom.apply(null, arguments)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-bubbles4"
	  }), _vm._v("\n        " + _vm._s(_vm.$t('vue2.setupWidget.write_us')))]), _vm._v(" "), (_vm.country === 'dk') ? [_c('a', {
	    attrs: {
	      "href": "http://support.docendo.dk/"
	    }
	  }, [_c('span', {
	    staticClass: "icon-question3"
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.setupWidget.support_forum')) + "\n        ")])] : _vm._e()], 2)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1852 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "opus-absence text-dark"
	  }, [_c('h2', {
	    staticClass: "marg-1-bottom capitalize"
	  }, [_vm._v("Fraværsindberetninger")]), _vm._v(" "), (_vm.isNoConfiguration) ? [_vm._m(0)] : [_c('div', {
	    staticClass: "opus-absence__header"
	  }, [_c('div', {
	    staticClass: "opus-absence__header__left"
	  }, [_c('DoDatePickerRange', {
	    attrs: {
	      "allowSameDate": true,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate,
	      "maximumDateRange": 365
	    },
	    on: {
	      "startChanged": _vm.startDateChanged,
	      "endChanged": _vm.endDateChanged
	    }
	  }), _vm._v(" "), _c('Tabs', {
	    attrs: {
	      "tabs": _vm.tabsList,
	      "selected": _vm.selectedTab
	    },
	    on: {
	      "select": function($event) {
	        _vm.selectedTab = $event
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Personer',
	      "tags": _vm.uniqueNames,
	      "selectedTags": _vm.selectedNames,
	      "numberOfSelectedTagsToShow": 2,
	      "placeholder": 'Vælg personer'
	    },
	    on: {
	      "select": _vm.toggleName,
	      "clear": _vm.clearNames
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Fraværstype',
	      "tags": _vm.uniqueAbsenceTypes,
	      "selectedTags": _vm.selectedAbsenceTypes,
	      "numberOfSelectedTagsToShow": 2,
	      "placeholder": 'Vælg fraværstype'
	    },
	    on: {
	      "select": _vm.toggleAbsenceType,
	      "clear": _vm.clearAbsenceTypes
	    }
	  })], 1), _vm._v(" "), (_vm.isOpusAbsenceActivated) ? _c('div', {
	    staticClass: "opus-absence__header__right"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        _vm.isShowQuotasModal = true
	      }
	    }
	  }, [_vm._v("Vis kvoter")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "opus-absence__body"
	  }, [(_vm.isLoading) ? _c('Loader') : [_c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "th-sorter td-created",
	    class: {
	      'th-sorter--active': !_vm.isSortPristine && _vm.sortBy === 'vCreatedAt'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('vCreatedAt')
	      }
	    }
	  }, [_vm._v("\n              Oprettet "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'name'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('name')
	      }
	    }
	  }, [_vm._v("\n              Navn "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'employment_number'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('employment_number')
	      }
	    }
	  }, [_vm._v("\n              Ansættelse "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'absence_type_text'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('absence_type_text')
	      }
	    }
	  }, [_vm._v("\n              Fraværstype "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter td-date",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'start_date'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('start_date')
	      }
	    }
	  }, [_vm._v("\n              Startdato "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter td-date",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'end_date'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('end_date')
	      }
	    }
	  }, [_vm._v("\n              Slutdato "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter td-units",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'absence_days'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('absence_days')
	      }
	    }
	  }, [_vm._v("\n              Dage "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter td-units",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'absence_hours'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('absence_hours')
	      }
	    }
	  }, [_vm._v("\n              Timer "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter td-status",
	    class: {
	      'th-sorter--active': !_vm.isSortPristine && _vm.sortBy === 'state'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('state')
	      }
	    }
	  }, [_vm._v("\n              Status "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), (_vm.selectedTab !== 'queued') ? _c('th', {
	    staticClass: "td-error"
	  }, [_vm._v("\n              Besked\n            ")]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "td-action"
	  })])]), _vm._v(" "), _c('tbody', [(_vm.displayedAbsences.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": _vm.selectedTab !== 'queued' ? 11 : 10
	    }
	  }, [_vm._v("\n              Ingen fraværsindberetninger fundet\n            ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayedAbsences), function(item) {
	    return _c('tr', {
	      key: item.id
	    }, [_c('td', {
	      staticClass: "td-created"
	    }, [_vm._v(_vm._s(item.vCreatedAt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vUserName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vEmploymentNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vAbsenceTypeText))]), _vm._v(" "), _c('td', {
	      staticClass: "td-date"
	    }, [_vm._v(_vm._s(item.vStartDate))]), _vm._v(" "), _c('td', {
	      staticClass: "td-date"
	    }, [_vm._v(_vm._s(item.ongoing ? 'Åbenstående' : item.vEndDate))]), _vm._v(" "), _c('td', {
	      staticClass: "td-units"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(item.absence_days)))]), _vm._v(" "), _c('td', {
	      staticClass: "td-units"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(item.absence_hours)))]), _vm._v(" "), _c('td', {
	      staticClass: "td-status"
	    }, [(item.state === 'error') ? _c('span', {
	      staticClass: "status-pill status-pill--error"
	    }, [_vm._v("Fejlet")]) : (item.state === 'queued' || !item.state) ? _c('span', {
	      staticClass: "status-pill status-pill--pending"
	    }, [_vm._v("Afventer")]) : (item.state === 'ok') ? _c('span', {
	      staticClass: "status-pill status-pill--ok"
	    }, [_vm._v("Gennemført")]) : _c('span', {
	      staticClass: "status-pill status-pill--pending"
	    }, [_vm._v("Afventer")])]), _vm._v(" "), (_vm.selectedTab !== 'queued') ? _c('td', {
	      staticClass: "td-error"
	    }, [(item.error && item.error.length > 0) ? _c('div', {
	      staticClass: "message-list"
	    }, _vm._l((item.error), function(err, idx) {
	      return _c('span', {
	        key: idx,
	        class: {
	          'message-error': err.StatusType === 'E',
	          'message-warning': err.StatusType === 'W'
	        }
	      }, [_vm._v("\n                  " + _vm._s(err.MessageText) + "\n                ")])
	    }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "td-action"
	    }, [_c('div', {
	      staticClass: "td-action__buttons"
	    }, [(_vm.isOpusAbsenceActivated && item.employment_id) ? _c('button', {
	      staticClass: "do-bttn do-bttn--small",
	      attrs: {
	        "disabled": !_vm.isOpusEmployment(item.employment),
	        "title": _vm.isOpusEmployment(item.employment) ? 'Se personens fravær, som det er registreret i KMD Opus' : 'Ansættelsen er ikke en Opus-ansættelse'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.openKmdAbsence(item)
	        }
	      }
	    }, [_c('span', [_vm._v("Se i Opus")])]) : _vm._e(), _vm._v(" "), (item.state === 'error') ? _c('button', {
	      staticClass: "do-bttn do-bttn--small",
	      class: {
	        'do-bttn--loading': item.isRetrying
	      },
	      attrs: {
	        "disabled": item.isRetrying
	      },
	      on: {
	        "click": function($event) {
	          return _vm.retrySend(item)
	        }
	      }
	    }, [_c('span', [_vm._v("Send igen")])]) : _vm._e()])])])
	  })], 2)])]], 2)], _vm._v(" "), (_vm.isShowCreateOpusAbsence) ? _c('CreateOpusAbsence', {
	    attrs: {
	      "schoolId": _vm.schoolId
	    },
	    on: {
	      "created": function($event) {
	        return _vm.onCreated($event)
	      },
	      "close": function($event) {
	        return _vm.setIsShowCreateOpusAbsence(false)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowQuotasModal) ? _c('KmdQuotasModal', {
	    on: {
	      "close": function($event) {
	        _vm.isShowQuotasModal = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.kmdAbsenceItem) ? _c('KmdOpusAbsenceModal', {
	    attrs: {
	      "employmentId": _vm.kmdAbsenceItem.employment_id,
	      "userName": String(_vm.kmdAbsenceItem.vUserName || ''),
	      "employmentLabel": String(_vm.kmdAbsenceItem.vEmploymentNumber || ''),
	      "transfer": _vm.kmdAbsenceItem,
	      "absenceTypeCode": _vm.getAbsenceTypeCode(_vm.kmdAbsenceItem.kmd_absence_code_id)
	    },
	    on: {
	      "close": function($event) {
	        _vm.kmdAbsenceItem = null
	      }
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "opus-absence-no-config"
	  }, [_c('h2', [_c('i', [_vm._v("Skolens Opus-integration er ikke konfigureret korrekt. Kontakt Docendo for at få hjælp til opsætningen -\n          enten på chat eller email.")])])])
	}]}

/***/ }),
/* 1853 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.html)
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1854 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('d-modal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true
	    }
	  }, [_c('div', {
	    staticClass: "print-all-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "print-calendars__header border-1-bottom text-dark"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.print_latest_version')))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "print-all-modal__body"
	  }, [(!_vm.isShowUserSelectModal) ? _c('div', {
	    attrs: {
	      "id": "printTaskOverviews"
	    }
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  }) : [(_vm.sortedUsers.length < 1) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.task_versions.no_saved_versions')) + "\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
	    return _c('TaskOverviewUser', {
	      key: user.user.id,
	      attrs: {
	        "user": user.user,
	        "version": user.version,
	        "schoolThresholdToHideTaskHours": _vm.schoolThresholdToHideTaskHours,
	        "isHideTaskHoursUnderThreshold": _vm.isHideTaskHoursUnderThreshold
	      }
	    })
	  })]], 2) : _vm._e()]), _vm._v(" "), (_vm.isShowUserSelectModal) ? _c('d-modal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true
	    }
	  }, [_c('div', {
	    staticClass: "d-modal__content d-modal__content__hide-task-hours",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-container__header"
	  }, [_c('h3', [_vm._v("Vælg brugere til udskrift")])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__body"
	  }, [(_vm.tags.length > 0) ? _c('div', {
	    staticClass: "brutto__users__header"
	  }, [_c('filterTags', {
	    attrs: {
	      "users": _vm.usersSortedOnNameWithTags,
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters
	    },
	    on: {
	      "set": _vm.setTagFromFilter,
	      "remove": _vm.removeTagFromFilter
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "brutto__users__list__header",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.selectedUserIds.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.select_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))])]), _vm._v(" "), _c('ul', {
	    staticClass: "brutto__users__list"
	  }, _vm._l((_vm.filteredUsersOnTags), function(user) {
	    return _c('li', {
	      key: user.id,
	      staticClass: "brutto__users__user",
	      class: {
	        'is-selected': _vm.getIsUserSelected(user)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleUser(user)
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(user.name) + "\n            ")])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__footer"
	  }, [_c('div', {
	    staticClass: "input-group input-group__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setIsHideTaskHoursUnderThreshold.apply(null, arguments)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label marg-1-right"
	  }, [_vm._v("Skjul timepuljer på opgaver under " + _vm._s(_vm.schoolThresholdToHideTaskHours) + "\n              timer")]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isHideTaskHoursUnderThreshold
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__print_buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isLoadingPrint
	    },
	    on: {
	      "click": _vm.startPrint
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.print')) + "\n            ")])])])])]) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1855 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickOutside),
	      expression: "onClickOutside"
	    }],
	    staticClass: "do-filters-popover text-dark"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn__filter",
	    on: {
	      "click": function($event) {
	        _vm.isShowDropdown = !_vm.isShowDropdown
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-filter"
	  }), _vm._v("\n    " + _vm._s(_vm.title || _vm.i18n['filters']) + "\n    "), _c('div', {
	    staticClass: "do-filters__divider"
	  }), _vm._v(" "), (_vm.selectedCount === 0) ? _c('span', {
	    staticClass: "do-filters__selected-filters"
	  }, [_vm._v("\n      " + _vm._s(_vm.i18n['select_filters']) + "\n    ")]) : _c('span', {
	    staticClass: "do-badge"
	  }, [_vm._v("\n      " + _vm._s(_vm.selectedCount) + " " + _vm._s(_vm.i18n['selected']) + "\n      "), _c('span', {
	    staticClass: "icon-cross2 do-filters-popover__clear",
	    attrs: {
	      "title": _vm.i18n['clear_all']
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.$emit('clearAll')
	      }
	    }
	  })])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-dropdown"
	    }
	  }, [(_vm.isShowDropdown) ? _c('div', {
	    staticClass: "do-filters-popover__dropdown"
	  }, [(_vm.selectedCount > 0) ? _c('button', {
	    staticClass: "do-filters__button-transparent",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('clearAll')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['clear_all']))]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1856 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "print-popup"
	  }, [_vm._l((_vm.usersFilteredWithTags), function(user) {
	    return (!_vm.isUserFiltered(user)) ? _c('div', {
	      key: user.id,
	      staticClass: "user"
	    }, [_c('h4', [_vm._v("Opgaveoversigt " + _vm._s(_vm.activeSchoolYear.name))]), _vm._v(" "), _c('SubjectsDistributionUser', {
	      attrs: {
	        "activeUserId": user.id,
	        "showCloseCross": false
	      }
	    })], 1) : _vm._e()
	  }), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "modal"
	    }
	  }, [(_vm.isPrintSettingsModal) ? _c('DModal', {
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal__content",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "modal__content__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('h2', [_vm._v("Print " + _vm._s(_vm.usersFilteredWithTags.length - _vm.filteredUsers.length) + " undervisere")]), _vm._v(" "), _c('label', {
	    staticClass: "print-form__label"
	  }, [_vm._v("Fravælg evt. undervisere")]), _vm._v(" "), _c('ul', {
	    staticClass: "user-list"
	  }, _vm._l((_vm.usersFilteredWithTags), function(user) {
	    return _c('li', {
	      key: user.id,
	      staticClass: "user-list__item",
	      class: {
	        'user-list__item--disabled': _vm.isUserFiltered(user)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleFilteredUser(user)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(user.name) + "\n          ")])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "modal__content__buttons"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("Luk")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-primary",
	    on: {
	      "click": _vm.print
	    }
	  }, [_vm._v("Print")])])])]) : _vm._e()], 1)], 2)
	},staticRenderFns: []}

/***/ }),
/* 1857 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "d-event__actions text-dark"
	  }, [(_vm.isPossibleToAdd) ? _c('h3', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.actions_for')) + " \"" + _vm._s(_vm.event.title) + "\"\n    " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards ')) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "d-event__actions__action",
	    class: {
	      'd-event__actions__action--open': _vm.getTheShowAction('remove')
	    }
	  }, [_c('h4', {
	    on: {
	      "click": function($event) {
	        return _vm.setTheShowAction('remove')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.calendar_view_day.remove_onwards')) + "\n      "), _c('svg', {
	    staticClass: "tw-icon w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M19.5 8.25l-7.5 7.5-7.5-7.5"
	    }
	  })])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "accordion"
	    },
	    on: {
	      "enter": _vm.start,
	      "after-enter": _vm.end,
	      "before-leave": _vm.start,
	      "after-leave": _vm.end
	    }
	  }, [(_vm.getTheShowAction('remove')) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.do_you_want_to_remove')) + " " + _vm._s(_vm.calendar.name) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.on_all')) + " \"" + _vm._s(_vm.event.title) + "\"-" + _vm._s(_vm.$t('vue2.calendar_view_day.lessons')) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards_which_include')) + " " + _vm._s(_vm.eventStartFormatted) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.and_all_onwards')) + ".")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-danger",
	    on: {
	      "click": function($event) {
	        return _vm.openOnwardConfirm('remove')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.remove')) + "\n          " + _vm._s(_vm.calendar.name) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards')) + "\n        ")])]) : _vm._e()])], 1), _vm._v(" "), (_vm.isPossibleToAdd) ? _c('li', {
	    staticClass: "d-event__actions__action",
	    class: {
	      'd-event__actions__action--open': _vm.getTheShowAction('add')
	    }
	  }, [_c('h4', {
	    on: {
	      "click": function($event) {
	        return _vm.setTheShowAction('add')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.calendar_view_day.add_onwards')) + "\n      "), _c('svg', {
	    staticClass: "tw-icon w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M19.5 8.25l-7.5 7.5-7.5-7.5"
	    }
	  })])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "accordion"
	    },
	    on: {
	      "enter": _vm.start,
	      "after-enter": _vm.end,
	      "before-leave": _vm.start,
	      "after-leave": _vm.end
	    }
	  }, [(_vm.getTheShowAction('add')) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.do_you_want_to_add')) + " " + _vm._s(_vm.calendar.name) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.on_all')) + " \"" + _vm._s(_vm.event.title) + "\"-" + _vm._s(_vm.$t('vue2.calendar_view_day.lessons')) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards_which_include')) + " " + _vm._s(_vm.eventStartFormatted) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.and_all_onwards')) + ".")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": function($event) {
	        return _vm.openOnwardConfirm('add')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.add')) + " " + _vm._s(_vm.calendar.name) + "\n          " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards')) + "\n        ")])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "d-event__actions__action",
	    class: {
	      'd-event__actions__action--open': _vm.getTheShowAction('replace')
	    }
	  }, [_c('h4', {
	    on: {
	      "click": function($event) {
	        return _vm.setTheShowAction('replace')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.replace_onwards')) + "\n      "), _c('svg', {
	    staticClass: "tw-icon w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M19.5 8.25l-7.5 7.5-7.5-7.5"
	    }
	  })])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "accordion"
	    },
	    on: {
	      "enter": _vm.start,
	      "after-enter": _vm.end,
	      "before-leave": _vm.start,
	      "after-leave": _vm.end
	    }
	  }, [(_vm.getTheShowAction('replace')) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.select_the_person_to_replace')) + " " + _vm._s(_vm.calendar.name) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.with_on_all')) + " \"" + _vm._s(_vm.event.title) + "\"-" + _vm._s(_vm.$t('vue2.calendar_view_day.lessons')) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards_which_include')) + " " + _vm._s(_vm.eventStartFormatted) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.and_all_onwards')))]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.theReplaceWithCalendarId),
	      expression: "theReplaceWithCalendarId"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.theReplaceWithCalendarId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "selected": ""
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.select_person')) + "..")]), _vm._v(" "), _vm._l((_vm.selectableCalendars), function(cal) {
	    return _c('option', {
	      key: cal.id,
	      domProps: {
	        "value": cal.id
	      }
	    }, [_vm._v(_vm._s(cal.name))])
	  })], 2), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.theReplaceWithCalendarId && _vm.theReplaceWithCalendarId !== _vm.calendar.id),
	      expression: "theReplaceWithCalendarId && theReplaceWithCalendarId !== calendar.id"
	    }],
	    on: {
	      "click": function($event) {
	        return _vm.openOnwardConfirm('replace')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.replace')) + " " + _vm._s(_vm.calendar.name) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards')) + "\n        ")])]) : _vm._e()])], 1), _vm._v(" "), (_vm.onwardConfirmMode) ? _c('CalendarViewDayOnwardConfirm', {
	    attrs: {
	      "mode": _vm.onwardConfirmMode,
	      "calendarName": _vm.calendar.name,
	      "minDate": _vm.eventStartDate
	    },
	    on: {
	      "close": function($event) {
	        _vm.onwardConfirmMode = null
	      },
	      "confirm": _vm.onOnwardConfirm
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1858 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', _vm._l((_vm.users), function(user) {
	    return _c('div', {
	      ref: "tooltip",
	      refInFor: true,
	      staticClass: "recent_user activity_avatar onlinepeeps"
	    }, [_c('a', {
	      staticClass: "hint--top-left",
	      attrs: {
	        "href": user.url,
	        "aria-label": _vm.tooltiptitle(user)
	      }
	    }, [_c('img', {
	      staticClass: "ag",
	      attrs: {
	        "src": user.thumb,
	        "alt": user.name,
	        "height": "50",
	        "width": "50"
	      }
	    })]), _vm._v(" "), (user.last_seen_one_hour_ago) ? _c('div', {
	      staticClass: "bg-green pos-absolute bottom-0 right-0 rounded-50",
	      attrs: {
	        "id": "indicatoronline"
	      }
	    }) : _vm._e()])
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 1859 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', {
	    staticClass: "d-table-tr",
	    class: {
	      'd-table-tr--odd': _vm.index % 2 === 1
	    }
	  }, [_c('td', {
	    on: {
	      "click": function($event) {
	        return _vm.toggleSubject(_vm.subject)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-checkbox",
	    class: {
	      'd-checkbox--active': _vm.isSelected
	    }
	  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.subject.subject.name))]), _vm._v(" "), (!_vm.isSupplements) ? _c('td', [(_vm.subject.calendar) ? [_vm._v("\n      " + _vm._s(_vm.subject.calendar.name) + "\n    ")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('td', [(_vm.subject.subject.calendar) ? [_vm._v("\n      " + _vm._s(_vm.subject.subject.calendar.name) + "\n    ")] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.subject.v_type))]), _vm._v(" "), (_vm.isSupplements) ? _c('td', [(_vm.subject.calendar) ? [_vm._v("\n      " + _vm._s(_vm.subject.calendar.name) + "\n    ")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (!_vm.isSupplements) ? _c('td', [_vm._v(_vm._s(_vm.subject.v_DefaultCategory && _vm.subject.v_DefaultCategory.name))]) : _vm._e(), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'left',
	        arrow: false,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	        onShow: function () { return _vm.selectedSubjects.length > 0; }
	      }),
	      expression: "{\n          placement: 'left',\n              arrow: false,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => selectedSubjects.length > 0\n          }"
	    }],
	    attrs: {
	      "content": 'Tildel til flere i stedet'
	    }
	  }, [(!_vm.isSupplements && _vm.taskCategories.length > 0) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.subject.selected_task_category_id),
	      expression: "subject.selected_task_category_id"
	    }],
	    staticClass: "do-select",
	    class: {
	      'do-select--disabled': _vm.selectedSubjects.length > 0
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.subject, "selected_task_category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        return _vm.updateSubjectTaskCategory(_vm.subject, $event.target.value)
	      }]
	    }
	  }, _vm._l((_vm.taskCategories), function(taskCategory, key) {
	    return _c('option', {
	      key: taskCategory.id,
	      domProps: {
	        "value": taskCategory.id
	      }
	    }, [_vm._v("\n        " + _vm._s(taskCategory.name) + "\n      ")])
	  }), 0) : _vm._e(), _vm._v(" "), (_vm.isSupplements && _vm.salaryCodes.length > 0) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.subject.salary_code_id),
	      expression: "subject.salary_code_id"
	    }],
	    staticClass: "do-select width-100",
	    class: {
	      'do-select--disabled': _vm.selectedSubjects.length > 0
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.subject, "salary_code_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        return _vm.updateSubjectTaskCategory(_vm.subject, $event.target.value)
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }), _vm._v(" "), _vm._l((_vm.salaryCodes), function(salaryCode, key) {
	    return _c('option', {
	      key: salaryCode.id,
	      domProps: {
	        "value": salaryCode.id
	      }
	    }, [_vm._v("\n        " + _vm._s(salaryCode.vSupplementTitle) + "\n      ")])
	  })], 2) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1860 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "isCloseOnBgClick": false,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('div', [_c('h2', [_vm._v("Indberettede engangsydelser i OPUS")]), _vm._v(" "), _c('p', {
	    staticClass: "d-modal__subtitle"
	  }, [_vm._v("\n            " + _vm._s(_vm.userName) + " · " + _vm._s(_vm.employmentLabel) + "\n          ")])]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__toolbar"
	  }, [_c('DoDatePickerRange', {
	    attrs: {
	      "allowSameDate": true,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate,
	      "maximumDateRange": 365,
	      "dateShortCutsProps": _vm.dateShortCuts
	    },
	    on: {
	      "startChanged": _vm.startDateChanged,
	      "endChanged": _vm.endDateChanged
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.openCreate
	    }
	  }, [_vm._v("\n          Opret engangsydelse\n        ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "isLoaderModal": true
	    }
	  }) : [_c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "td-date"
	  }, [_vm._v("DATO")]), _vm._v(" "), _c('th', {
	    staticClass: "td-loenkode"
	  }, [_vm._v("LØNKODE")]), _vm._v(" "), _c('th', {
	    staticClass: "td-units"
	  }, [_vm._v("ENHEDER")]), _vm._v(" "), _c('th', {
	    staticClass: "td-units"
	  }, [_vm._v("BELØB")]), _vm._v(" "), _c('th', [_vm._v("OMK.STED")]), _vm._v(" "), _c('th', {
	    staticClass: "td-system"
	  }, [_vm._v("SYSTEM")]), _vm._v(" "), _c('th', {
	    staticClass: "td-status"
	  }, [_vm._v("STATUS")]), _vm._v(" "), _c('th', {
	    staticClass: "th-actions"
	  })])]), _vm._v(" "), _c('tbody', [(_vm.displayedPayments.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": 8
	    }
	  }, [_vm._v("\n                Ingen engangsydelser i OPUS for perioden\n              ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayedPayments), function(row) {
	    return _c('tr', {
	      key: row.id,
	      staticClass: "engangsydelse-row"
	    }, [_c('td', {
	      staticClass: "td-date"
	    }, [_vm._v(_vm._s(row.vDato))]), _vm._v(" "), _c('td', {
	      staticClass: "td-loenkode"
	    }, [_vm._v(_vm._s(row.vLoenart))]), _vm._v(" "), _c('td', {
	      staticClass: "td-units"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(row.antal)))]), _vm._v(" "), _c('td', {
	      staticClass: "td-units"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(row.beloeb)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.afv_omkostningssted || '—'))]), _vm._v(" "), _c('td', {
	      staticClass: "td-system"
	    }, [_vm._v(_vm._s(row.afsendelses_system || '—'))]), _vm._v(" "), _c('td', {
	      staticClass: "td-status"
	    }, [_c('span', {
	      staticClass: "do-pill do-pill--small",
	      class: row.statusClass
	    }, [_vm._v(_vm._s(row.vStatus))])]), _vm._v(" "), _c('td', {
	      staticClass: "td-actions"
	    }, [(row.vStatus === 'I OPUS') ? _c('button', {
	      staticClass: "do-bttn do-bttn--small modregn-btn",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.openModregn(row)
	        }
	      }
	    }, [_vm._v("Modregn")]) : _vm._e()])])
	  })], 2)])]], 2)])]), _vm._v(" "), (_vm.isShowCreate) ? _c('CreateEngangsydelse', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "employmentIds": [_vm.employmentId],
	      "subtitle": _vm.effectiveCreateSubtitle,
	      "prefill": _vm.createPrefill
	    },
	    on: {
	      "created": _vm.onCreated,
	      "close": _vm.closeCreate
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1861 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "reporting"
	  }, [_c('a', {
	    staticClass: "d-back-link",
	    attrs: {
	      "href": "/calendar"
	    }
	  }, [_vm._v("Tilbage til Docendo")]), _vm._v(" "), _c('div', {
	    staticClass: "reporting__header"
	  }, [_c('div', {
	    staticClass: "reporting__header__right"
	  }, [_c('h1', [_vm._v("Timetalsindberetning")]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1)]), _vm._v(" "), (_vm.isLoadingStilData || !_vm.isUserLoaded) ? _c('div', {
	    staticStyle: {
	      "width": "500px"
	    }
	  }, [_c('Loader')], 1) : _vm._e(), _vm._v(" "), (_vm.isUserLoaded && _vm.userHasNoEmail) ? _c('div', {
	    staticClass: "d-form alert"
	  }, [_c('h3', [_vm._v("Der skal udfyldes en email for at benytte timetalsindberetning")]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', [_vm._v("Din email")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.userEmailInput),
	      expression: "userEmailInput",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    ref: "user_email_input",
	    class: {
	      'input--error': _vm.userEmailFormErrors['email']
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.userEmailInput)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('email')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.userEmailInput = $event.target.value.trim()
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), (_vm.userEmailFormErrors['email']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.createusers.email_error_text')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-form__submit"
	  }, [_c('button', {
	    staticClass: "bttn submit-button",
	    class: [{
	        'bttn--loading': _vm.isSavingUserEmail
	      },
	      {
	        'submit-button--disabled': _vm.isSaveButtonForUserEmailDisabled
	      }
	    ],
	    on: {
	      "click": _vm.submitUserEmail
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.isUserLoaded && !_vm.isLoadingStilData && !_vm.userHasNoEmail) ? [_c('div', {
	    staticClass: "reporting-content"
	  }, [_c('div', {
	    staticClass: "reporting__table"
	  }, [_c('GrundskoleIndberetningTimetal', {
	    attrs: {
	      "stilData": _vm.stilData
	    },
	    on: {
	      "update": _vm.update,
	      "updateSubject": _vm.updateSubject,
	      "updateKonfirmation": _vm.updateKonfirmation,
	      "updatePraktik": _vm.updatePraktik,
	      "setTolaerer": _vm.setTolaerer,
	      "setForanstaltning": _vm.setForanstaltning,
	      "nulstilKlasse": _vm.nulstilKlasse
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "submit-bttn__container"
	  }, [_c('button', {
	    staticClass: "bttn bttn--primary",
	    class: {
	      'bttn--loading': _vm.isSendingToStil
	    },
	    staticStyle: {
	      "width": "165px"
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Afslut og indberet\n        ")])])])] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1862 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-scheduler-sort"
	  }, [_c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "propOffset": [0, 8],
	      "isCloseOnDropdownClick": false
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn__filter",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_c('span', {
	    staticClass: "icon-shuffle2"
	  }), _vm._v("\n      " + _vm._s(_vm.i18n['sort_by']) + "\n    ")]), _vm._v(" "), _c('ul', {
	    staticClass: "do-filters__filter__dropdown",
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', {
	    staticClass: "do-filters__filter__dropdown__item do-filters__filter__dropdown__item--group-top",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	      }
	    }
	  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n['group_at_top']))]), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": '',
	      "placeholder": _vm.i18n['group_placeholder'],
	      "tags": _vm.groupTags,
	      "selectedTags": _vm.selectedGroupTags,
	      "numberOfSelectedTagsToShow": 1
	    },
	    on: {
	      "select": _vm.toggleGroupTag,
	      "clear": _vm.clearAllGroupTags
	    }
	  })], 1), _vm._v(" "), _vm._l((_vm.options), function(option) {
	    return _c('li', {
	      key: option.value,
	      staticClass: "do-filters__filter__dropdown__item",
	      class: {
	        'do-filters__filter__dropdown__item--selected': option.selected
	      },
	      on: {
	        "click": function($event) {
	          return _vm.select(option.value)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(option.name) + "\n        "), _c('svg', {
	      staticClass: "tw-icon icon-check",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24"
	      }
	    }, [_c('circle', {
	      staticClass: "primary",
	      attrs: {
	        "cx": "12",
	        "cy": "12",
	        "r": "10"
	      }
	    }), _vm._v(" "), _c('path', {
	      staticClass: "secondary",
	      attrs: {
	        "d": "M10 14.59l6.3-6.3a1 1 0 0 1 1.4 1.42l-7 7a1 1 0 0 1-1.4 0l-3-3a1 1 0 0 1 1.4-1.42l2.3 2.3z"
	      }
	    })])])
	  })], 2)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1863 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "absence-reasons__absence"
	  }, [_c('div', [_c('div', {
	    staticClass: "absence-reasons__absence__title"
	  }, [_c('p', {
	    staticClass: "absence-reasons__absence__title-text"
	  }, [_c('b', [_vm._v(_vm._s(_vm.reason.title))]), _vm._v(" "), (_vm.hasSdAbsenceCode) ? _c('span', {
	    staticClass: "do-sd-badge"
	  }, [_vm._v("SD")]) : _vm._e(), _vm._v(" "), (_vm.hasOpusAbsenceCode) ? _c('span', {
	    staticClass: "do-opus-badge"
	  }, [_vm._v("OPUS")]) : _vm._e()]), _vm._v(" "), _c('p', [(_vm.isOngoing) ? _c('span', {
	    staticClass: "badge badge--orange badge--small badge--clickable",
	    on: {
	      "click": _vm.setTheEditAbsenceReason
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence')))]) : _vm._e(), _vm._v(" "), (!_vm.isOngoing && _vm.getIsAbsenceMultipleDays) ? _c('span', {
	    staticClass: "badge badge--small"
	  }, [_vm._v(" " + _vm._s(_vm.$t('vue2.substitution_user.multiple_days')))]) : _vm._e()])]), _vm._v(" "), _c('p', [(_vm.getSerialListItem) ? [_vm._v("\n        " + _vm._s(_vm.formatDate(_vm.getSerialListItem.from_date)) + "\n        - " + _vm._s(_vm.formatDate(_vm.getSerialListItem.to_date)) + ", " + _vm._s(_vm.showTime(_vm.reason.start)) + " - " + _vm._s(_vm.showTime(_vm.reason.end)) + "\n      ")] : [_vm._v("\n        " + _vm._s(_vm.showDate(_vm.reason.start)) + " -\n        "), _c('span', [_vm._v(_vm._s(_vm.showTime(_vm.reason.end)))])]], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "absence-reasons__absence__right"
	  }, [_c('div', {
	    staticClass: "absence-reasons__absence__right__edits"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'left'
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'left'\n                }"
	    }],
	    staticClass: "icon-bin icon__bg-circle icon__bg-circle--danger deleteAbsence",
	    attrs: {
	      "content": _vm.$t('vue2.common.delete')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setReadyToDelete(_vm.reason)
	      }
	    }
	  }), _vm._v(" "), (_vm.getSerialListItem) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'left'
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'left'\n                }"
	    }],
	    staticClass: "icon-wrench icon__bg-circle",
	    attrs: {
	      "content": _vm.$t('vue2.common.edit')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheEditAbsenceReason(_vm.reason)
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'left'
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'left'\n                }"
	    }],
	    staticClass: "icon-clock icon__bg-circle",
	    attrs: {
	      "content": _vm.$t('vue2.common.log')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.showLog(_vm.reason)
	      }
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1864 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.setDropdownFromClick),
	      expression: "setDropdownFromClick"
	    }],
	    ref: "role_child",
	    staticClass: "role-change",
	    class: {
	      'role-change--active': _vm.isDropDown
	    }
	  }, [(_vm.isDropDown) ? _c('div', {
	    staticClass: "role-change__dropdown__container"
	  }, [_c('transition', {
	    attrs: {
	      "name": "d-dropdown"
	    }
	  }, [(_vm.isDropdownPopperDone) ? _c('div', {
	    staticClass: "role-change__dropdown"
	  }, [_c('ul', _vm._l((_vm.roles), function(role) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setRole(role)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(role.v_title) + "\n          ")])
	  }), 0)]) : _vm._e()])], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1865 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "school-users text-dark"
	  }, [_c('div', {
	    staticClass: "school-users__header"
	  }, [_c('div', {
	    staticClass: "school-users__header__text"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.school_users.title')))]), _vm._v(" "), (_vm.isDK) ? _c('p', {
	    staticClass: "do-pill do-pill--yellow school-users__intro"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.school_users.stil_intro')) + "\n        "), _c('a', {
	    attrs: {
	      "href": "https://viden.stil.dk/pages/viewpage.action?pageId=161059151",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.stil_read_more')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "school-users__header__actions"
	  }, [(_vm.isDK) ? _c('a', {
	    staticClass: "do-bttn",
	    attrs: {
	      "href": _vm.stilImportUrl
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.stil_import')))]) : _vm._e(), _vm._v(" "), _c('a', {
	    staticClass: "do-bttn",
	    attrs: {
	      "href": _vm.mergeUsersUrl
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.merge_users')))]), _vm._v(" "), _c('a', {
	    staticClass: "do-bttn",
	    attrs: {
	      "href": _vm.transferCalendarUrl
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.transfer_calendar')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.openCreate
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.create')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "school-users__toolbar"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search),
	      expression: "search"
	    }],
	    staticClass: "d-input school-users__search",
	    attrs: {
	      "type": "search",
	      "placeholder": _vm.$t('vue2.school_users.search_placeholder')
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (!_vm.isLoading) ? _c('span', {
	    staticClass: "school-users__count"
	  }, [_vm._v(_vm._s(_vm.countLabel))]) : _vm._e()]), _vm._v(" "), (_vm.isLoading) ? _c('Loader') : _c('table', {
	    staticClass: "do-table do-table--striped school-users__table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "school-users__cell--photo"
	  }), _vm._v(" "), _c('th', {
	    staticClass: "school-users__cell--initials school-users__sortable",
	    on: {
	      "click": function($event) {
	        return _vm.setSort('initials')
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.school_users.initials')) + " "), _c('span', {
	    staticClass: "school-users__sort"
	  }, [_vm._v(_vm._s(_vm.sortIndicator('initials')))])]), _vm._v(" "), _c('th', {
	    staticClass: "school-users__cell--name school-users__sortable",
	    on: {
	      "click": function($event) {
	        return _vm.setSort('name')
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.school_users.name')) + " "), _c('span', {
	    staticClass: "school-users__sort"
	  }, [_vm._v(_vm._s(_vm.sortIndicator('name')))])]), _vm._v(" "), _c('th', {
	    staticClass: "school-users__cell--login"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.login')))]), _vm._v(" "), _c('th', {
	    staticClass: "school-users__cell--phone"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.phone')))]), _vm._v(" "), _c('th', {
	    staticClass: "school-users__cell--seen school-users__sortable",
	    on: {
	      "click": function($event) {
	        return _vm.setSort('last_seen')
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.school_users.last_seen')) + " "), _c('span', {
	    staticClass: "school-users__sort"
	  }, [_vm._v(_vm._s(_vm.sortIndicator('last_seen')))])]), _vm._v(" "), _c('th', {
	    staticClass: "school-users__cell--actions"
	  })])]), _vm._v(" "), _c('tbody', [(_vm.visibleUsers.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": "7"
	    }
	  }, [_vm._v(_vm._s(_vm.search ? _vm.$t('vue2.school_users.no_results') : _vm.$t('vue2.school_users.none')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.visibleUsers), function(user) {
	    return _c('tr', {
	      key: user.id,
	      staticClass: "school-users__row",
	      on: {
	        "click": function($event) {
	          return _vm.openEdit(user)
	        }
	      }
	    }, [_c('td', {
	      staticClass: "school-users__cell--photo"
	    }, [_c('img', {
	      staticClass: "school-users__avatar",
	      attrs: {
	        "src": user.default_thumb_url,
	        "alt": user.name,
	        "width": "36",
	        "height": "36"
	      }
	    })]), _vm._v(" "), _c('td', {
	      staticClass: "school-users__cell--initials"
	    }, [_vm._v(_vm._s(user.initials))]), _vm._v(" "), _c('td', {
	      staticClass: "school-users__cell--name"
	    }, [_c('span', {
	      staticClass: "school-users__name"
	    }, [_vm._v(_vm._s(user.name))]), _vm._v(" "), (user.employee_id) ? _c('span', {
	      staticClass: "school-users__sub"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.employee_id')) + " " + _vm._s(user.employee_id))]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticClass: "school-users__cell--login"
	    }, _vm._l((_vm.logins(user)), function(login) {
	      return _c('div', {
	        key: login.type,
	        staticClass: "school-users__login"
	      }, [_c('span', {
	        staticClass: "school-users__login__type"
	      }, [_vm._v(_vm._s(login.type))]), _vm._v(" " + _vm._s(login.value) + "\n          ")])
	    }), 0), _vm._v(" "), _c('td', {
	      staticClass: "school-users__cell--phone"
	    }, [_vm._v(_vm._s(_vm.formatPhone(user.phone)))]), _vm._v(" "), _c('td', {
	      staticClass: "school-users__cell--seen"
	    }, [_c('span', {
	      class: {
	        'school-users__never': !user.last_seen
	      }
	    }, [_vm._v(_vm._s(_vm.lastSeen(user)))])]), _vm._v(" "), _c('td', {
	      staticClass: "school-users__cell--actions",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	        }
	      }
	    }, [_c('DDropdown', {
	      attrs: {
	        "isShowDots": false,
	        "isBottomStart": false,
	        "appendToBody": false,
	        "propOffset": [0, 4],
	        "closeFromProp": _vm.closeActionsMenu
	      }
	    }, [_c('button', {
	      staticClass: "do-bttn do-bttn--small",
	      attrs: {
	        "slot": "title",
	        "type": "button"
	      },
	      slot: "title"
	    }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.school_users.actions')) + " "), _c('span', {
	      staticClass: "icon-arrow-down5"
	    })]), _vm._v(" "), _c('ul', {
	      attrs: {
	        "slot": "list"
	      },
	      slot: "list"
	    }, _vm._l((_vm.actions), function(action) {
	      return _c('li', {
	        key: action.key,
	        on: {
	          "click": function($event) {
	            return _vm.runAction(action, user)
	          }
	        }
	      }, [_c('span', {
	        class: action.icon
	      }), _vm._v(" " + _vm._s(action.label) + "\n              ")])
	    }), 0)])], 1)])
	  })], 2)]), _vm._v(" "), (_vm.editingUser) ? _c('SchoolUserModal', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "user": _vm.editingUser
	    },
	    on: {
	      "saved": _vm.onSaved,
	      "imageChanged": _vm.readList,
	      "close": function($event) {
	        _vm.editingUser = null
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1866 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "flex align-center",
	    class: _vm.addClass
	  }, [_c('div', {
	    class: {
	      'input-with-icon': _vm.showIcon
	    }
	  }, [_c('div', {
	    class: {
	      'icon': _vm.showIcon,
	      'icon-clock': _vm.showIcon
	    }
	  }), _vm._v(" "), _c('time-input', {
	    attrs: {
	      "date": _vm.startTime,
	      "width": _vm.inputWidth
	    },
	    on: {
	      "changed": _vm.setStartTime
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "timepicker timepicker-line"
	  }, [_vm._v("\n    -\n  ")]), _vm._v(" "), _c('div', {
	    class: {
	      'input-with-icon': _vm.showIcon
	    }
	  }, [_c('div', {
	    class: {
	      'icon': _vm.showIcon,
	      'icon-clock': _vm.showIcon
	    }
	  }), _vm._v(" "), _c('time-input', {
	    attrs: {
	      "date": _vm.endTime,
	      "width": _vm.inputWidth
	    },
	    on: {
	      "changed": _vm.setEndTime
	    }
	  })], 1), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.utcStart),
	      expression: "utcStart"
	    }],
	    staticClass: "none",
	    attrs: {
	      "name": "event_start",
	      "type": "hidden"
	    },
	    domProps: {
	      "value": (_vm.utcStart)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.utcStart = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.utcEnd),
	      expression: "utcEnd"
	    }],
	    staticClass: "none",
	    attrs: {
	      "name": "event_end",
	      "type": "hidden"
	    },
	    domProps: {
	      "value": (_vm.utcEnd)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.utcEnd = $event.target.value
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1867 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "annual-norm text-dark"
	  }, [_c('div', {
	    staticClass: "d-header"
	  }, [_c('div', {
	    staticClass: "d-header__left"
	  }, [_c('h1', [_vm._v("Arbeidstidsplan")]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1)]), _vm._v(" "), (_vm.isLoading && !_vm.isUpdatingTasks) ? _c('Loader') : [_c('div', {
	    staticClass: "d-tabs"
	  }, [_c('div', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': !_vm.viewIsResult
	    },
	    on: {
	      "click": function($event) {
	        _vm.viewIsResult = false
	      }
	    }
	  }, [_vm._v("\n        Arbeidsåret\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs__container"
	  }, [(_vm.viewIsResult) ? [_c('AnnualNormResult', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "users": _vm.userWithProps
	    }
	  })] : _c('div', {
	    staticClass: "annual-norm__body"
	  }, [_c('div', {
	    staticClass: "annual-norm__body__left"
	  }, [_c('ArbeidsplanAssignHoursNorm', {
	    staticClass: "marg-1-bottom",
	    on: {
	      "updateUsersHours": _vm.readAssignedHours
	    }
	  }), _vm._v(" "), _c('ul', _vm._l((_vm.userWithProps), function(user) {
	    return _c('li', {
	      key: user.user_calendar_id,
	      staticClass: "user-item",
	      class: {
	        'user-item--active': user.v_is_active_user
	      }
	    }, [_c('div', {
	      staticClass: "user-item__body",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveUserId(user.id)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "user-item__name"
	    }, [(user.default_thumb_url) ? _c('img', {
	      staticClass: "user-item__name__img",
	      attrs: {
	        "src": user.default_thumb_url,
	        "alt": ""
	      }
	    }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('div', {
	      staticClass: "user-item__right"
	    }, [_c('div', {
	      staticClass: "user-item__hours"
	    }, [_c('p', [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v("Årsverk")]), _c('span', [_vm._v(_vm._s(user.v_assigned_total_hours))])]), _vm._v(" "), _c('p', [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v("Undervisning")]), _c('span', [_vm._v(_vm._s(user.v_total_teaching_percentage_label))])]), _vm._v(" "), _c('p', [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v("Oppgaver")]), _c('span', [_vm._v(_vm._s(user.v_user_tasks_hours_label))])])]), _vm._v(" "), _c('div', {
	      staticClass: "user-item__arrow"
	    }, [(!user.v_is_active_user) ? _c('span', {
	      staticClass: "icon-arrow-right4"
	    }) : _c('span', {
	      staticClass: "icon-arrow-down4"
	    })])])]), _vm._v(" "), (user.v_is_active_user) ? _c('ArbeidsplanUser', {
	      attrs: {
	        "user": _vm.activeUser,
	        "activeNorm": _vm.activeNorm,
	        "activeNormFormatted": _vm.activeNormFormatted
	      }
	    }) : _vm._e()], 1)
	  }), 0)], 1), _vm._v(" "), _c('div', {
	    staticClass: "annual-norm__body__right"
	  }, [_c('div', {
	    staticClass: "annual-norm__body__right__header"
	  }, [_c('div', {
	    staticClass: "flipper-buttons"
	  }, [_c('button', {
	    staticClass: "flipper-buttons__button",
	    class: {
	      'active': !_vm.isTasksView
	    },
	    on: {
	      "click": function($event) {
	        _vm.isTasksView = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-year-planning"
	  }), _vm._v("\n                Fag\n              ")]), _vm._v(" "), _c('button', {
	    staticClass: "flipper-buttons__button",
	    class: {
	      'active': _vm.isTasksView
	    },
	    on: {
	      "click": function($event) {
	        _vm.isTasksView = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-file-text"
	  }), _vm._v("\n                Oppgaver\n              ")])])]), _vm._v(" "), (!_vm.isTasksView) ? _c('ArbeidsplanSubjects', {
	    on: {
	      "setIsCreate": _vm.setIsCreateSubject,
	      "setEditSubject": _vm.setEditSubject
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isTasksView) ? _c('SubjectsDistributionTasks') : _vm._e()], 1)])], 2)], _vm._v(" "), (_vm.isSubjectModal) ? _c('CreateSubjectForm', {
	    attrs: {
	      "showModal": _vm.isSubjectModal,
	      "initCalendarId": _vm.activeCalendarId,
	      "editSubject": _vm.theEditSubject,
	      "editSubjectId": _vm.theEditSubjectId
	    },
	    on: {
	      "close": _vm.closeSubjectModal,
	      "createSubject": _vm.createNewSubject,
	      "updateSubject": _vm.updateSubject,
	      "deleteSubject": _vm.deleteSubject
	    }
	  }) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-modal"
	    }
	  }, [(_vm.isConfirmDeletion) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$store.commit('setConfirmDeletion', false)
	      },
	      "confirm": _vm.confirmDelete
	    }
	  }, [_c('h3', {
	    staticStyle: {
	      "padding": "1rem 1rem 0 1rem"
	    },
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_vm._v(_vm._s(_vm.itemToDelete.name))])]) : _vm._e()], 1)], 2)
	},staticRenderFns: []}

/***/ }),
/* 1868 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "desktop-wrapper"
	  }, [_c('desktop-header', {
	    attrs: {
	      "calname": _vm.calInfo.name,
	      "schoolname": _vm.schoolName
	    },
	    on: {
	      "locale": _vm.setLocale,
	      "print": _vm.print
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "wrapper"
	  }, [_c('week-selector', {
	    attrs: {
	      "startDate": _vm.calInfo.start_date,
	      "endDate": _vm.calInfo.end_date,
	      "date": _vm.date
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "printCalendar"
	    }
	  }, [_c('h2', {
	    staticClass: "only-print print-calendar-name"
	  }, [_vm._v(_vm._s(_vm.calInfo.name))]), _vm._v(" "), _c('div', {
	    staticClass: "box cal-container"
	  }, [_c('div', {
	    staticClass: "cal-container__header"
	  }, [_c('div', {
	    staticClass: "cal-container__header--left"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.showDate))])]), _vm._v(" "), _c('div', {
	    staticClass: "cal-container__header--right"
	  }, [_c('div', {
	    staticClass: "cal-toggle no-print",
	    on: {
	      "click": function($event) {
	        _vm.isCalNoBgColors = !_vm.isCalNoBgColors
	      }
	    }
	  }, [_c('label', {
	    staticClass: "cal-toggle__label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.public_calendar.black_white')))]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isCalNoBgColors
	    }
	  })], 1), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn no-print",
	    class: {
	      'bttn--disabled': !_vm.isNotThisWeek
	    },
	    on: {
	      "click": _vm.setToday
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('repitition.today')) + "\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn icon-arrow-left4 no-print",
	    on: {
	      "click": _vm.prevWeek
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn icon-arrow-right4 no-print",
	    on: {
	      "click": _vm.nextWeek
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-calendar__calendar__container",
	    class: {
	      'd-calendar__calendar__container--print-mode': _vm.isCalendarInPrintMode
	    }
	  }, [_c('DCalendar', {
	    key: _vm.activeCalendarDate + '_' + _vm.locale,
	    attrs: {
	      "isEditable": false,
	      "isCalendarInPrintMode": _vm.isCalendarInPrintMode,
	      "isShowWeekends": _vm.isShowWeekends,
	      "isCalNoBgColors": _vm.isCalNoBgColors,
	      "startTime": _vm.startTime,
	      "endTime": _vm.endTime,
	      "date": _vm.activeCalendarDate,
	      "events": _vm.allEvents,
	      "calendarId": _vm.calId,
	      "calendarName": _vm.calInfo.name || '',
	      "isEventsClickable": true,
	      "isLoadingEvents": _vm.isLoading,
	      "localeOverride": _vm.locale
	    },
	    on: {
	      "onEventClick": _vm.showEvent
	    }
	  })], 1)]), _vm._v(" "), _c('weekplan', {
	    attrs: {
	      "locale": _vm.locale,
	      "calId": _vm.calId,
	      "date": _vm.date,
	      "events": _vm.allEvents,
	      "calview": 'agendaWeek'
	    }
	  })], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1869 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  }) : [_c('div', {
	    staticClass: "do-table__filters"
	  }, [_c('div', {
	    staticClass: "do-table__filters__left"
	  }, [_c('Tabs', {
	    staticStyle: {
	      "height": "26px"
	    },
	    attrs: {
	      "tabs": _vm.templateTabs,
	      "selected": _vm.selectedTemplateTab,
	      "isLarge": false
	    },
	    on: {
	      "select": function($event) {
	        _vm.selectedTemplateTab = $event
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": "Personer",
	      "tags": _vm.personNames,
	      "selectedTags": _vm.selectedNames,
	      "numberOfSelectedTagsToShow": 1
	    },
	    on: {
	      "select": _vm.toggleName,
	      "clear": function($event) {
	        _vm.selectedNames = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": "Grupper",
	      "tags": _vm.tags,
	      "selectedTags": _vm.selectedTags,
	      "numberOfSelectedTagsToShow": 1
	    },
	    on: {
	      "select": _vm.toggleTag,
	      "clear": function($event) {
	        _vm.selectedTags = []
	      }
	    }
	  }), _vm._v(" "), (_vm.employmentTitles.length > 1) ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": "Ansættelser",
	      "tags": _vm.employmentTitles,
	      "selectedTags": _vm.selectedEmploymentTitles,
	      "numberOfSelectedTagsToShow": 1
	    },
	    on: {
	      "select": _vm.toggleEmploymentTitle,
	      "clear": function($event) {
	        _vm.selectedEmploymentTitles = []
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.organisations.length > 1) ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": "Organisationer",
	      "tags": _vm.organisations,
	      "selectedTags": _vm.selectedOrganisations,
	      "numberOfSelectedTagsToShow": 1
	    },
	    on: {
	      "select": _vm.selectedOrganisation,
	      "clear": function($event) {
	        _vm.selectedOrganisations = []
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "do-table__filters__add__explainer-text"
	  }, [_vm._v("Viser " + _vm._s(_vm.filteredUsers.length) + " af " + _vm._s(_vm.users.length) + " brugere")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-table__filters__add"
	  }, [_c('DoEmploymentDropdown', {
	    attrs: {
	      "employmentTypes": _vm.employmentTemplates,
	      "selectedEmploymentIds": _vm.selectedEmploymentIds
	    },
	    on: {
	      "onTemplateCreated": _vm.onTemplateCreated,
	      "onTemplateUpdated": _vm.onTemplateUpdated,
	      "onTemplateDeleted": _vm.onTemplateDeleted,
	      "select": _vm.onTemplateSelected
	    }
	  }), _vm._v(" "), (_vm.isSubmitting) ? _c('div', {
	    staticClass: "do-spinner"
	  }) : _c('span', [_vm._v("Valgt " + _vm._s(_vm.selectedEmploymentIds.length) + " " + _vm._s(_vm.selectedEmploymentIds.length === 1 ? 'ansættelse' : 'ansættelser'))])], 1)]), _vm._v(" "), _c('SalarySettingsUsersTable', {
	    attrs: {
	      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive,
	      "filteredUsers": _vm.filteredUsers,
	      "isImportOfEmployments": true,
	      "employmentTemplates": _vm.employmentTemplates,
	      "selectedEmploymentIds": _vm.selectedEmploymentIds,
	      "isShowEmploymentNumber": _vm.isShowEmploymentNumber,
	      "rowActionLabel": _vm.rowActionLabel
	    },
	    on: {
	      "toggleEmployment": _vm.toggleEmployment,
	      "toggleAllEmployments": _vm.toggleAllEmployments,
	      "editEmployment": _vm.onEditEmployment,
	      "setTheEditUser": function($event) {
	        return _vm.$emit('setTheEditUser', $event)
	      },
	      "editSsn": _vm.onEditSsn,
	      "removeEmployment": function($event) {
	        _vm.employmentRemovalTarget = $event
	      }
	    }
	  }), _vm._v(" "), (_vm.theSsnUser) ? _c('SalarySsnModal', {
	    attrs: {
	      "user": _vm.theSsnUser
	    },
	    on: {
	      "close": function($event) {
	        _vm.theSsnUser = null
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.templateRemovalTarget) ? _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true
	    },
	    on: {
	      "close": _vm.cancelRemoveTemplate
	    }
	  }, [_c('div', {
	    staticClass: "remove-template-modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "remove-template-modal__header"
	  }, [_c('h2', [_vm._v("Fjern stillingskategori")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle remove-template-modal__close",
	    on: {
	      "click": _vm.cancelRemoveTemplate
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "remove-template-modal__content"
	  }, [_c('p', [_vm._v("\n            Ønsker du at fjerne stillingskategorien\n            "), (_vm.templateRemovalTarget.employment.title) ? _c('strong', [_vm._v(_vm._s(_vm.templateRemovalTarget.employment.title))]) : _vm._e(), _vm._v("\n            fra ansættelsen på "), _c('strong', [_vm._v(_vm._s(_vm.templateRemovalTarget.user.name))]), _vm._v("?\n          ")])]), _vm._v(" "), _c('div', {
	    staticClass: "remove-template-modal__buttons"
	  }, [_c('div'), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.cancelRemoveTemplate
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': _vm.isRemovingTemplate,
	      'do-bttn--submit--loading': _vm.isRemovingTemplate
	    },
	    on: {
	      "click": _vm.confirmRemoveTemplate
	    }
	  }, [_vm._v("\n              Fjern\n            ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.employmentRemovalTarget) ? _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true
	    },
	    on: {
	      "close": _vm.cancelRemoveEmployment
	    }
	  }, [_c('div', {
	    staticClass: "remove-template-modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "remove-template-modal__header"
	  }, [_c('h2', [_vm._v("Fjern ansættelse")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle remove-template-modal__close",
	    on: {
	      "click": _vm.cancelRemoveEmployment
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "remove-template-modal__content"
	  }, [_c('p', [_vm._v("\n            Vil du fjerne ansættelsen\n            "), _c('strong', [(_vm.employmentRemovalTarget.employment.employment_number) ? [_vm._v(_vm._s(_vm.employmentRemovalTarget.employment.employment_number) + " -")] : _vm._e(), _vm._v("\n              " + _vm._s(_vm.employmentRemovalTarget.employment.source_title || _vm.employmentRemovalTarget.employment.title) + "\n            ")], 2), _vm._v("\n            for "), _c('strong', [_vm._v(_vm._s(_vm.employmentRemovalTarget.user.name))]), _vm._v(" i Docendo?\n          ")]), _vm._v(" "), _c('p', [_vm._v("Den vil stadig være i lønsystemet.")])]), _vm._v(" "), _c('div', {
	    staticClass: "remove-template-modal__buttons"
	  }, [_c('div'), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.cancelRemoveEmployment
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': _vm.isRemovingEmployment,
	      'do-bttn--submit--loading': _vm.isRemovingEmployment
	    },
	    on: {
	      "click": _vm.confirmRemoveEmployment
	    }
	  }, [_vm._v("\n              Fjern ansættelse\n            ")])])])])]) : _vm._e()]], 2)
	},staticRenderFns: []}

/***/ }),
/* 1870 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "flex"
	  }, [_c('div', {
	    staticClass: "header-container box-shadow"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "nav"
	  }, [_c('div', {
	    staticClass: "nav-left"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.calname))])]), _vm._v(" "), _c('div', {
	    staticClass: "nav-right no-print"
	  }, [_c('set-locale', {
	    on: {
	      "locale": _vm.emitLocale
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "print-button marg-5-left",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('print')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })])], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "docendo-logo box-shadow no-print"
	  }, [_c('span', {
	    staticClass: "icon-docendo docendo-logo__icon",
	    attrs: {
	      "id": "d-icon"
	    }
	  })])
	}]}

/***/ }),
/* 1871 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-grouping text-dark"
	  }, [_c('div', {
	    staticClass: "d-grouping__header"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.tagging.tagging_users')))]), _vm._v(" "), _c('div', {
	    staticClass: "d-grid-table"
	  }, [_c('div', {
	    staticClass: "d-grid-table__column d-grid-table__column-1"
	  }, [_c('div', {
	    staticClass: "d-grid-table__column-header"
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n['groups']) + "\n        ")]), _vm._v(" "), _c('ul', [_c('li', {
	    staticClass: "tags-li__create"
	  }, [_c('button', {
	    staticClass: "btn btn-trans",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModal(true)
	      }
	    }
	  }, [_vm._v("\n              + " + _vm._s(_vm.i18n['create_a_new_group']) + "\n            ")])]), _vm._v(" "), _c('li', {
	    class: {
	      'filter--active': !_vm.activeTag
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setActiveTag(null)
	      }
	    }
	  }, [_c('div', [_vm._v(_vm._s(_vm.i18n['all']))]), _vm._v(" "), _c('div', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v("\n              " + _vm._s(_vm.usersSortedOnName.length) + "\n            ")])]), _vm._v(" "), _vm._l((_vm.tagsWithProps), function(tag) {
	    return _c('li', {
	      key: tag.v_name,
	      ref: "droppable_elements",
	      refInFor: true,
	      staticClass: "tag-filter",
	      class: [{
	        'filter--active': _vm.activeTag === tag.v_name
	      }],
	      on: {
	        "click": function($event) {
	          return _vm.setActiveTag(tag.v_name)
	        },
	        "dragover": function($event) {
	          $event.preventDefault();
	        },
	        "dragenter": function($event) {
	          $event.preventDefault();
	          return _vm.dragEnter(tag, $event)
	        },
	        "dragleave": function($event) {
	          $event.preventDefault();
	          return _vm.dragLeave.apply(null, arguments)
	        },
	        "drop": function($event) {
	          $event.preventDefault();
	          return _vm.drop(tag, $event)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "tags-li__left"
	    }, [_c('DDropdown', [_c('ul', {
	      attrs: {
	        "slot": "list"
	      },
	      slot: "list"
	    }, [_c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.setTheEditTag(tag)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-pencil"
	    }), _vm._v(" " + _vm._s(_vm.$t('vue2.common.rename')) + "\n                  ")]), _vm._v(" "), _c('li', {
	      staticClass: "d-item-warning",
	      on: {
	        "click": function($event) {
	          return _vm.setTheDeleteTag(tag)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    }), _vm._v("\n                    " + _vm._s(_vm.$t('vue2.common.delete')) + "\n                  ")])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(tag.v_name))])], 1), _vm._v(" "), _c('div', [_c('span', {
	      staticClass: "icon-user"
	    }), _vm._v("\n              " + _vm._s(tag.v_number_of_persons) + "\n            ")])])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "d-grid-table__column d-grid-table__column-3"
	  }, [_c('div', {
	    staticClass: "d-grid-table__column-header"
	  }, [_c('div', {
	    staticClass: "d-grid-table__column-header__left"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.users')) + "\n            "), (_vm.activeTag) ? [_vm._v(" " + _vm._s(_vm.i18n['in_the_group']) + ": "), _c('span', {
	    staticClass: "icon-price-tag2 marg-5-right marg-1-left"
	  }), _vm._v(_vm._s(_vm.activeTag) + "\n            ")] : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "d-grid-table__column-header__right"
	  }, [_c('div', [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "isSmall": true,
	      "bg-color": "#f6f9fc"
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.activeTag) ? _c('DSelect', {
	    staticClass: "marg-1-left",
	    attrs: {
	      "items": _vm.usersForDSelect,
	      "itemsSelected": [],
	      "placeholder": _vm.$t('vue2.common.add_user'),
	      "showSelectedUsers": false
	    },
	    on: {
	      "add": function($event) {
	        return _vm.addUserToTag($event)
	      }
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('ul', [_c('li', {
	    staticClass: "users-list-header"
	  }, [_c('span', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.usersSelectedForDrag.length < 1) ? [_vm._v(_vm._s(_vm.$t('vue2.tagging.select_all')))] : [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))]], 2)]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
	    return _c('li', {
	      key: user.id,
	      staticClass: "user-in-list",
	      class: {
	        'isSelected': user.v_isSelectedForDrag
	      },
	      attrs: {
	        "draggable": "true"
	      },
	      on: {
	        "dragover": function($event) {
	          $event.stopPropagation();
	        },
	        "dragstart": function($event) {
	          $event.stopPropagation();
	          return _vm.dragStart(user, $event)
	        },
	        "dragend": function($event) {
	          $event.stopPropagation();
	          return _vm.dragEnd(user, $event)
	        },
	        "drop": function($event) {
	          $event.preventDefault();
	          return _vm.drop(user, $event)
	        }
	      }
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          boundary: 'window',
	          arrow: false,
	          placement: 'left-start'
	        }),
	        expression: "{boundary: 'window', arrow: false, placement : 'left-start'}"
	      }],
	      staticClass: "user-in-list__left",
	      attrs: {
	        "content": _vm.i18n['drag_and_drop_explained']
	      }
	    }, [_c('svg', {
	      staticStyle: {
	        "enable-background": "new 0 0 572.156 572.156"
	      },
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "xmlns:xlink": "http://www.w3.org/1999/xlink",
	        "version": "1.1",
	        "id": "Capa_1",
	        "x": "0px",
	        "y": "0px",
	        "width": "13px",
	        "height": "13px",
	        "viewBox": "0 0 572.156 572.156",
	        "xml:space": "preserve"
	      }
	    }, [_c('g', [_c('polygon', {
	      attrs: {
	        "points": "495.405,241.769 418.657,197.457 418.657,258.115 314.042,258.115 314.042,153.498 374.699,153.498    330.389,76.751 286.078,0 241.769,76.751 197.457,153.498 258.115,153.498 258.115,258.115 153.498,258.115 153.498,197.457    76.751,241.767 0,286.078 76.751,330.387 153.498,374.699 153.498,314.042 258.115,314.042 258.115,418.657 197.457,418.657    241.767,495.405 286.078,572.156 330.387,495.405 374.699,418.657 314.042,418.657 314.042,314.042 418.657,314.042    418.657,374.699 495.405,330.389 572.156,286.078  "
	      }
	    })]), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g')]), _vm._v(" "), _c('div', {
	      staticClass: "icon__bg-circle",
	      on: {
	        "click": function($event) {
	          return _vm.setUsersSelectedForDrag(user)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "d-checkbox",
	      class: {
	        'd-checkbox--active': false
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "user-name"
	    }, [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('div', {
	      staticClass: "user-tags"
	    }, _vm._l((user.user_tags), function(tag) {
	      return _c('div', {
	        staticClass: "d-tag"
	      }, [_c('div', {
	        staticClass: "d-tag__text"
	      }, [_vm._v(_vm._s(tag))]), _vm._v(" "), _c('div', {
	        staticClass: "icon-cross2 d-tag__icon",
	        on: {
	          "click": function($event) {
	            return _vm.deleteTagFromUser(user, tag)
	          }
	        }
	      })])
	    }), 0)])
	  })], 2)])])]), _vm._v(" "), (_vm.isModal) ? _c('DModal', {
	    attrs: {
	      "showClose": false,
	      "is-bg-overlay": true
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [(!_vm.theEditTag && !_vm.theDeleteTag) ? _c('span', [_vm._v(_vm._s(_vm.i18n['create_group']))]) : _vm._e(), _vm._v(" "), (_vm.theEditTag && !_vm.theDeleteTag) ? _c('span', [_vm._v(_vm._s(_vm.i18n['edit_group']))]) : _vm._e(), _vm._v(" "), (_vm.theDeleteTag) ? _c('span', [_vm._v(_vm._s(_vm.i18n['delete_group']))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "role-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body"
	  }, [(!_vm.theDeleteTag) ? _c('div', {
	    staticClass: "d-input-group marg-1-bottom"
	  }, [_c('label', {
	    staticClass: "d-label marg-5-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n['name_for_group']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.tagTitle),
	      expression: "tagTitle",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "focus",
	      rawName: "v-focus"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.tagTitle)
	    },
	    on: {
	      "change": function($event) {
	        _vm.tagTitle = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (!_vm.theDeleteTag && !_vm.theEditTag) ? _c('div', {
	    staticClass: "d-input-group marg-2-bottom"
	  }, [_c('label', {
	    staticClass: "d-label marg-5-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n['select_a_user']))]), _vm._v(" "), _c('DSelectUsers', {
	    on: {
	      "update": _vm.setSelectedUsers
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "marg-10-right",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.theEditTag && !_vm.theDeleteTag) ? _c('button', {
	    staticClass: "submit-button",
	    class: [{
	        'submit-button--disabled': _vm.tagTitle.length < 1 || _vm.selectedUserIds.length === 0
	      },
	      {
	        'submit-button--loading': _vm.isButtonLoading
	      }
	    ],
	    on: {
	      "click": _vm.createTag
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.create')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.theEditTag) ? _c('button', {
	    staticClass: "submit-button",
	    class: [{
	        'submit-button--disabled': _vm.tagTitle.length < 1
	      },
	      {
	        'submit-button--loading': _vm.isButtonLoading
	      }
	    ],
	    on: {
	      "click": _vm.editTag
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.save')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.theDeleteTag) ? _c('button', {
	    staticClass: "submit-button submit-button--danger",
	    class: {
	      'submit-button--loading': _vm.isButtonLoading
	    },
	    on: {
	      "click": _vm.deleteTag
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.delete')) + "\n          ")]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    ref: "customdrag",
	    staticClass: "d-custom-drag",
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.i18n['add']) + " " + _vm._s(_vm.usersSelectedForDrag.length) + "\n    "), (_vm.usersSelectedForDrag.length === 1) ? [_vm._v(" " + _vm._s(_vm.$t('vue2.common.user')))] : [_vm._v(" " + _vm._s(_vm.$t('vue2.common.users')))]], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1872 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "d_question",
	    staticClass: "d-question",
	    on: {
	      "mouseenter": function($event) {
	        _vm.isHovered = true
	      },
	      "mouseleave": function($event) {
	        _vm.isHovered = false
	      }
	    }
	  }, [_c('div', {
	    ref: "d_popover",
	    staticClass: "d-question__answer",
	    class: {
	      'd-question__answer--show': _vm.isHovered
	    }
	  }, [_vm._t("answer", function() {
	    return [_c('p', [_vm._v("Her er svar på dine spørgsmål")])]
	  })], 2), _vm._v(" "), _c('svg', {
	    attrs: {
	      "width": "16px",
	      "height": "16px",
	      "viewBox": "0 0 16 16"
	    }
	  }, [_c('g', {
	    attrs: {
	      "id": "Artboard-2",
	      "stroke": "none",
	      "stroke-width": "1",
	      "fill": "none",
	      "fill-rule": "evenodd"
	    }
	  }, [_c('g', {
	    attrs: {
	      "id": "Group-2"
	    }
	  }, [_c('circle', {
	    attrs: {
	      "id": "Oval-10",
	      "fill": "#a2a3a6",
	      "cx": "8",
	      "cy": "8",
	      "r": "8"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M7.354,9.657 L7.354,9.294 C7.354,7.732 9.059,7.292 9.059,6.148 C9.059,5.51 8.652,5.191 8.014,5.191 C7.343,5.191 6.826,5.609 6.826,6.445 L5.473,6.445 C5.473,4.729 6.573,3.948 8.102,3.948 C9.389,3.948 10.533,4.608 10.533,6.005 C10.533,7.666 8.663,8.183 8.663,9.437 L8.663,9.657 L7.354,9.657 Z M7.156,11.373 C7.156,10.878 7.464,10.559 8.003,10.559 C8.509,10.559 8.85,10.878 8.85,11.34 C8.85,11.813 8.509,12.143 8.003,12.143 C7.464,12.143 7.156,11.813 7.156,11.373 Z",
	      "id": "?",
	      "fill": "#FFFFFF"
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 1873 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bttn",
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createuser_button.create_user')))])
	},staticRenderFns: []}

/***/ }),
/* 1874 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weekdays-selector"
	  }, [_c('h3', [_vm._v("Kun specifikke dag/dage")]), _vm._v(" "), _c('app-toogler', {
	    attrs: {
	      "propOn": false
	    },
	    on: {
	      "changed": _vm.setSelectorActive
	    }
	  }), _vm._v(" "), (_vm.isSelectorActive) ? _c('div', {
	    staticClass: "weekdays"
	  }, _vm._l((_vm.weekDays), function(day, idx) {
	    return _c('div', {
	      staticClass: "weekday",
	      class: {
	        'isSelected': _vm.isInList(day)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleDay(day, idx)
	        }
	      }
	    }, [_vm._v("\n      " + _vm._s(_vm.$filters.dddd(day.date)) + "\n    ")])
	  }), 0) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1875 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container marg-1-top"
	  }, [_c('h4', {
	    staticClass: "uppercase marg-1-bottom"
	  }, [_vm._v("Fag")]), _vm._v(" "), (_vm.personaleUdenKorrekteOplysninger.length === 0 && _vm.fagUdenKorrekteOplysninger.length === 0) ? _c('h3', [_vm._v("Alt er udfyldt\n    korrekt")]) : _vm._e(), _vm._v(" "), (_vm.personaleUdenKorrekteOplysninger.length > 0 || _vm.fagUdenKorrekteOplysninger.length > 0) ? _c('div', {
	    staticClass: "d-attention"
	  }, [_c('svg', {
	    staticClass: "tw-icon icon-important",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
	    }
	  })]), _vm._v(" "), _c('h3', [_vm._v("Følgende fag mangler oplysninger")]), _vm._v(" "), _c('p', [_vm._v("Gå til step 3. \"Fag\" og tilføj oplysningerne eller slet faget, hvis faget ikke skal indberettes.")]), _vm._v(" "), _c('table', {
	    staticClass: "d-table d-table__borders"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.fagUdenKorrekteOplysninger), function(fag, key) {
	    return _c('tr', {
	      key: fag.fag_id
	    }, [_c('td', [_vm._v(_vm._s(fag.klasse) + ", " + _vm._s(fag.fag_navn))]), _vm._v(" "), _c('td', _vm._l((fag.errors), function(error, errorIdx) {
	      return _c('span', {
	        staticClass: "fag-errors"
	      }, [_vm._v(_vm._s(error)), (errorIdx + 1 < fag.errors.length) ? [_vm._v(", ")] : _vm._e()], 2)
	    }), 0)])
	  }), 0)])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('th', [_vm._v("Fag")]), _vm._v(" "), _c('th', [_vm._v("Fejl")])])
	}]}

/***/ }),
/* 1876 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "showClose": false,
	      "isBgOverlay": true,
	      "isCloseOnEsc": !_vm.activeOpusUser
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal__full-width",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.userName) + " "), _c('span', {
	    staticClass: "d-tag marg-1-left"
	  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__header__right"
	  }, [(_vm.canBulkSendUserDays) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit no-print",
	    class: {
	      'do-bttn--submit--loading': _vm.isBulkSending,
	      'do-bttn--submit--disabled': _vm.isBulkSending
	    },
	    attrs: {
	      "disabled": _vm.isBulkSending
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('bulkSendUserDays', _vm.user.days)
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.bulkSendButtonLabel) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isOpusIntegrationActive) ? _c('button', {
	    staticClass: "do-bttn no-print",
	    on: {
	      "click": function($event) {
	        return _vm.setActiveOpusUser(_vm.user)
	      }
	    }
	  }, [_vm._v("\n          Se i OPUS\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn no-print",
	    on: {
	      "click": function($event) {
	        _vm.isShowUserTable = !_vm.isShowUserTable
	      }
	    }
	  }, [_vm._v("\n          Vis tabel\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn no-print",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle no-print",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content",
	    attrs: {
	      "id": "printUserSalary"
	    }
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.user) ? _c('h4', {
	    staticClass: "italic"
	  }, [_vm._v("\n        Ikke flere dage på brugeren i "), _c('span', {
	    staticClass: "d-tag"
	  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.isLoading) ? _c('div', {
	    staticClass: "user-list__user"
	  }, [_c('h2', {
	    staticClass: "only-print marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.user && _vm.user.v_user_name ? _vm.user.v_user_name : '') + " "), _c('span', {
	    staticClass: "d-tag marg-1-left"
	  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
	    staticClass: "user-list__user__header"
	  }, [_c('h4', [_vm._v("Samlet timer for perioden i "), _c('span', {
	    staticClass: "d-tag"
	  }, [_vm._v(_vm._s(_vm.title))]), _c('br'), _vm._v(_vm._s(_vm.titleOfPeriod))]), _vm._v(" "), _c('ul', _vm._l((_vm.user.v_user_sums), function(sum) {
	    return _c('li', {
	      key: sum.vId,
	      class: {
	        'user-list__user__footer__sums__sum--not-set': sum.employment_not_set
	      }
	    }, [_vm._v("\n              " + _vm._s(sum.employment_title) + " " + _vm._s(sum.costCenter ? '[' + sum.costCenter + '] ' : '') + "\n              "), _c('b', [_vm._v(_vm._s(sum.minutes_humanized))])])
	  }), 0)]), _vm._v(" "), (_vm.isShowUserTable) ? _c('SalarySubsPerfUserTable', {
	    attrs: {
	      "user": _vm.user,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate
	    },
	    on: {
	      "close": function($event) {
	        _vm.isShowUserTable = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('table', {
	    staticClass: "user-list__user__table user-list__user__table--active"
	  }, [_vm._l((_vm.user.days), function(userDay) {
	    return [_c('tr', {
	      staticClass: "user-list__user__table__header"
	    }, [_c('th', [_vm._v(_vm._s(userDay.v_date_formatted))]), _vm._v(" "), _c('th', [_vm._v("Kalender")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Vikar for")]), _vm._v(" "), _c('th', [_vm._v("Ansættelse")]), _vm._v(" "), (_vm.isSalaryIntegrationActive) ? _c('th', [_vm._v("Lønkode")]) : _vm._e(), _vm._v(" "), (_vm.costCenters.length > 0) ? _c('th', [_vm._v("Omkostningssted")]) : _vm._e(), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
	      staticClass: "no-print"
	    })]), _vm._v(" "), _c('SalarySubsPerfUserDay', {
	      attrs: {
	        "user": _vm.user,
	        "userDay": userDay,
	        "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive,
	        "salaryCodes": _vm.salaryCodes,
	        "costCenters": _vm.costCenters
	      },
	      on: {
	        "updatePropOnLesson": function($event) {
	          return _vm.$emit('updatePropOnLesson', $event)
	        }
	      }
	    }), _vm._v(" "), _c('tr', {
	      key: 'foot-' + userDay.day,
	      staticClass: "user-list__user__table__footer"
	    }, [_c('td', {
	      attrs: {
	        "colspan": _vm.isSalaryIntegrationActive ? 10 : _vm.costCenters.length > 0 ? 9 : 8
	      }
	    }, [_c('div', {
	      staticClass: "user-list__user__footer"
	    }, [_c('ul', {
	      staticClass: "user-list__user__footer__sums"
	    }, _vm._l((userDay.v_sums), function(sum) {
	      return _c('li', {
	        key: sum.vId,
	        class: {
	          'user-list__user__footer__sums__sum--not-set': sum.employment_not_set
	        }
	      }, [_vm._v("\n                      " + _vm._s(sum.employment_title) + " " + _vm._s(sum.costCenter ? '[' + sum.costCenter + '] ' : '') + "\n                      "), _c('b', [_vm._v(_vm._s(sum.minutes_humanized))])])
	    }), 0), _vm._v(" "), (userDay.state === 'draft') ? [(_vm.getIsDayValidated(userDay)) ? _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n                      arrow: true,\n                      animateFill: false,\n                      animation : 'shift-away',\n                      zIndex: '999999992',\n                      boundary: 'window'\n                    }"
	      }],
	      staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled no-print",
	      attrs: {
	        "content": _vm.validationTxt
	      }
	    }, [_vm._v("\n                      Godkend\n                    ")]) : _c('button', {
	      staticClass: "do-bttn do-bttn--submit no-print",
	      class: {
	        'do-bttn--submit--loading': _vm.getIsSubmitting(userDay)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.$emit('approveDay', userDay)
	        }
	      }
	    }, [_vm._v("\n                      Godkend\n                    ")])] : _vm._e(), _vm._v(" "), (userDay.state === 'approved') ? _c('div', {
	      staticClass: "submit-buttons no-print"
	    }, [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n                      arrow: true,\n                      animateFill: false,\n                      animation : 'shift-away',\n                      zIndex: '999999992',\n                      boundary: 'window'\n                    }"
	      }],
	      staticClass: "do-bttn do-bttn--danger no-print",
	      class: {
	        'do-bttn--submit--loading': _vm.getIsSubmitting(userDay)
	      },
	      attrs: {
	        "content": 'Dagen vil blive genberegnet'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.$emit('unApproveDay', userDay)
	        }
	      }
	    }, [_vm._v("\n                      Fortryd godkendelse\n                    ")]), _vm._v(" "), _c('button', {
	      staticClass: "do-bttn do-bttn--submit no-print",
	      class: {
	        'do-bttn--submit--loading': _vm.getIsSubmitting(userDay)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.$emit('changeStateIsSent', userDay)
	        }
	      }
	    }, [_vm._v("\n                      " + _vm._s(_vm.isSalaryIntegrationActive ? 'Send til lønsystem' : 'Er indberettet') + "\n                    ")])]) : _vm._e(), _vm._v(" "), (userDay.approved_at) ? _c('span', {
	      staticClass: "do-approved-by"
	    }, [_vm._v("\n                    " + _vm._s(userDay.v_approved) + "\n                  ")]) : _vm._e()], 2)])])]
	  })], 2)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.activeOpusUser) ? _c('SalarySubsPerfUserOpusModal', {
	    attrs: {
	      "user": _vm.activeOpusUser,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate,
	      "schoolId": _vm.schoolId
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setActiveOpusUser(null)
	      }
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1877 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-dark"
	  }, [(_vm.isAllLoaded && !_vm.salarySystem) ? _c('ChooseSalarySystem', {
	    attrs: {
	      "schoolId": _vm.schoolId
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-sub-header"
	  }, _vm._l((_vm.menu), function(item) {
	    return _c('p', {
	      key: item.key,
	      staticClass: "d-sub-header__link",
	      class: {
	        'd-sub-header__link--active': _vm.activePage === item.key
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActivePage(item.key)
	        }
	      }
	    }, [_vm._v("\n      " + _vm._s(item.label) + "\n    ")])
	  }), 0), _vm._v(" "), (_vm.isAllLoaded && _vm.activeTab) ? [_c(_vm.activeTab.component, _vm._b({
	    tag: "component",
	    on: {
	      "select": _vm.onTemplateSelected,
	      "onTemplateCreated": _vm.onTemplateCreated,
	      "onTemplateUpdated": _vm.onTemplateUpdated,
	      "onTemplateDeleted": _vm.onTemplateDeleted
	    }
	  }, 'component', _vm.getPropsFor(_vm.activeTab.key), false))] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1878 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.create_activity.create_new_subject_for')) + " " + _vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.create_activity.title')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.subjectName),
	      expression: "subjectName"
	    }],
	    ref: "d_title_input",
	    staticClass: "d-input",
	    staticStyle: {
	      "height": "34px"
	    },
	    attrs: {
	      "id": "d-title-input-for-new-subject"
	    },
	    domProps: {
	      "value": (_vm.subjectName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.subjectName = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.create_activity.choose_subject_type')))]), _vm._v(" "), _c('SubjectFormSubjectType', {
	    attrs: {
	      "calendarType": 'user'
	    },
	    on: {
	      "change": _vm.setSubjectType
	    }
	  })], 1), _vm._v(" "), (!_vm.isLoadingUserSchools && _vm.isUserHasMultipleSchools) ? _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.choose_school')))]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.theActiveSchoolId),
	      expression: "theActiveSchoolId"
	    }],
	    staticClass: "d-select-with-options",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.theActiveSchoolId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.userSchools), function(school) {
	    return _c('option', {
	      key: school.id,
	      domProps: {
	        "value": school.id
	      }
	    }, [_vm._v("\n            " + _vm._s(school.name) + "\n          ")])
	  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")]) : _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1879 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dates text-dark"
	  }, [_c('div', {
	    staticClass: "dates__header"
	  }, [_c('ChangeSchoolYear', {
	    staticClass: "fit-content dates__change-schoolyear",
	    attrs: {
	      "whiteTheme": true
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "dates-input-group"
	  }, [_c('label', [_vm._v("Select the start and end dates for insertion")]), _vm._v(" "), _c('Datepickerrange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  })], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : _c('div', {
	    staticClass: "dates-input-group marg-1-top"
	  }, [_c('p', {
	    staticClass: "text-explainer"
	  }, [_c('b', [_vm._v("Hint:")]), _vm._v(" Click on a day to exclude/include day in rotation")]), _vm._v(" "), _vm._l((_vm.groupedDatesByMonth), function(monthData, month) {
	    return _c('div', {
	      key: month,
	      staticClass: "cal-month"
	    }, [_c('h3', [_vm._v(_vm._s(month))]), _vm._v(" "), _c('ul', {
	      staticClass: "cal-month__header"
	    }, [_c('li', [_vm._v("Mon")]), _vm._v(" "), _c('li', [_vm._v("Tue")]), _vm._v(" "), _c('li', [_vm._v("Wed")]), _vm._v(" "), _c('li', [_vm._v("Thu")]), _vm._v(" "), _c('li', [_vm._v("Fri")]), _vm._v(" "), _c('li', [_vm._v("Sat")]), _vm._v(" "), _c('li', [_vm._v("Sun")])]), _vm._v(" "), _c('ul', {
	      staticClass: "cal-month__body"
	    }, [_vm._l((monthData.emptyDays), function(n) {
	      return _c('li', [_vm._v(" ")])
	    }), _vm._v(" "), _vm._l((monthData.dates), function(dateObj, i) {
	      return _c('li', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: true,
	            zIndex: 123123123123
	          }),
	          expression: "{\n                  arrow: true,\n                  zIndex: 123123123123\n                }"
	        }],
	        key: i,
	        staticClass: "cal-month__body__day",
	        class: [{
	            'cal-month__body__day--can-be-toggled': !dateObj.isVacationDay && !dateObj.isWeekend
	          },
	          {
	            'cal-month__body__day--holiday': dateObj.isVacationDay
	          },
	          {
	            'cal-month__body__day--inactive': !dateObj.isIncluded
	          },
	          {
	            'cal-month__body__day--is-weekend': dateObj.isWeekend
	          }
	        ],
	        attrs: {
	          "content": dateObj.isWeekend ? 'Weekend' : dateObj.isVacationDay ? 'Vacation day' : dateObj.isIncluded ? 'Exclude day in rotation' : 'Include day in rotation'
	        },
	        on: {
	          "click": function($event) {
	            return _vm.toggleDate(dateObj)
	          }
	        }
	      }, [_c('p', {
	        staticClass: "cal-month__body__date"
	      }, [_vm._v(_vm._s(dateObj.formattedDate))]), _vm._v(" "), (dateObj.dayToInsert) ? _c('p', {
	        staticClass: "cal-month__body__date__to-insert"
	      }, [_vm._v(_vm._s(dateObj.dayToInsert.label))]) : _vm._e()])
	    })], 2)])
	  })], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1880 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "marg-20-top weekplan"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('h2', {
	    staticClass: "marg-20-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('calendars.week_plan_and_note.week_plan')))]), _vm._v(" "), (_vm.weekNote !== undefined && _vm.weekNote.length) ? _c('div', {
	    staticClass: "week_note"
	  }, [_c('div', {
	    staticClass: "week_note__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.weekNoteWithLineBreaks)
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('ul', [_vm._l((_vm.eventsWithNotes), function(day) {
	    return [(day.lessons.length !== 0) ? _c('li', {
	      staticClass: "day_change"
	    }, [_c('div', {
	      staticClass: "day_change_header"
	    }, [_c('h3', [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.createLocaleDate(day.date))))])]), _vm._v(" "), _c('div', {
	      staticClass: "grid grid grid-responsive"
	    }, [_c('div', {
	      staticClass: "col-2-12 box-size"
	    }, [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.subject')))])]), _vm._v(" "), _c('div', {
	      staticClass: "col-10-12"
	    }, [_c('div', {
	      staticClass: "col-1-3"
	    }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.learning_goal')))])])]), _vm._v(" "), _c('div', {
	      staticClass: "col-1-3"
	    }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.content')) + " ")])])]), _vm._v(" "), _c('div', {
	      staticClass: "col-1-3"
	    }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.pupil_preparation')))])])])])]), _vm._v(" "), _vm._l((day.lessons), function(event) {
	      return [_c('d-week-plan-lesson', {
	        attrs: {
	          "event": event,
	          "date": _vm.date
	        }
	      })]
	    })], 2) : _vm._e()]
	  })], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 1881 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal__user__settings__notifications text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['user_settings']))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), (_vm.isSMSActive) ? _c('div', {
	    staticClass: "d-input-group__group"
	  }, [_c('div', {
	    staticClass: "d-input-group input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['mobile_number']))]), _vm._v(" "), _c('div', {
	    staticClass: "flex-group",
	    class: {
	      'animated shake': _vm.isAnimatePhone
	    }
	  }, [_c('div', {
	    staticClass: "flag__input-lookalike active-country"
	  }, [_c('img', {
	    staticClass: "country-flag",
	    attrs: {
	      "src": _vm.activeCountry.flag,
	      "alt": ""
	    }
	  }), _vm._v("+" + _vm._s(_vm.activeCountry.countryCode) + "\n              "), _c('DDropdown', [_c('span', {
	    staticClass: "icon-arrow-down5",
	    attrs: {
	      "slot": "d-dropdown__icon"
	    },
	    slot: "d-dropdown__icon"
	  }), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, _vm._l((_vm.countries), function(country) {
	    return _c('li', {
	      key: country.countryCode,
	      staticClass: "country-select__item",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveCountry(country)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "country-select__item__name"
	    }, [_c('img', {
	      staticClass: "country-flag",
	      attrs: {
	        "src": country.flag,
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(country.name))])]), _vm._v("\n                    + " + _vm._s(country.countryCode) + "\n                  ")])
	  }), 0)])], 1), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.phone),
	      expression: "phone"
	    }],
	    ref: "input_phone",
	    staticClass: "d-input",
	    class: {
	      'input--error': !_vm.isPhoneValid
	    },
	    domProps: {
	      "value": (_vm.phone)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.onPhoneKeyup($event.target.value)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.phone = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (!_vm.isPhoneValid) ? _c('span', {
	    staticClass: "error-text marg-1-top"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['number_must_be_8_digits']))]) : _vm._e()]), _vm._v(" "), (_vm.user.unconfirmed_phone) ? _c('div', {
	    staticClass: "d-label d-pill",
	    class: {
	      'animated shake': _vm.isAnimatePhoneUnconfirmed
	    }
	  }, [_c('svg', {
	    staticClass: "w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
	    }
	  })]), _vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale]['awaiting_approval']) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.hideSMSToggle && (_vm.user.v_phone_setting === 'active' || _vm.user.v_phone_setting === 'deactivated')) ? _c('div', {
	    staticClass: "d-input-group marg-2-top"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['receive_sms']))]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group__toggle",
	    on: {
	      "click": function($event) {
	        return _vm.toggleSetting('phone')
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.receiveSMS
	    }
	  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isEmailActive) ? _c('div', {
	    staticClass: "d-input-group__group"
	  }, [_c('div', {
	    staticClass: "d-input-group input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['email']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    staticClass: "d-input",
	    class: {
	      'input--error': !_vm.isEmailValid
	    },
	    staticStyle: {
	      "height": "40px"
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.onEmailKeyup($event.target.value)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (!_vm.isEmailValid) ? _c('span', {
	    staticClass: "error-text marg-1-top"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['use_a_valid_email']))]) : _vm._e()]), _vm._v(" "), (!_vm.hideEmailToggle && (_vm.user.v_email_setting === 'active' || _vm.user.v_email_setting === 'deactivated')) ? _c('div', {
	    staticClass: "d-input-group marg-2-top"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['receive_email']))]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group__toggle",
	    on: {
	      "click": function($event) {
	        _vm.receiveEmails = !_vm.receiveEmails
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.receiveEmails
	    }
	  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group d-input-group__submit"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-primary",
	    class: [{
	      ' bttn--loading': _vm.isSubmitting
	    }, {
	      'bttn-primary--disabled': !this.isEmailValid || !this.isPhoneValid
	    }],
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1882 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "to-user text-dark"
	  }, [_c('h1', {
	    staticClass: "to-user__headline",
	    class: {
	      'only-print': !_vm.showHeadline
	    }
	  }, [_vm._v(_vm._s(_vm.user.name) + ", " + _vm._s(_vm.schoolYear)), (_vm.version.vTitle) ? _c('span', {
	    staticClass: "to-d-pill"
	  }, [_vm._v(_vm._s(_vm.version.vTitle))]) : _vm._e()]), _vm._v(" "), (_vm.userNorm.length > 0) ? _c('table', {
	    staticClass: "d-table marg-1-bottom d-table__overview"
	  }, [_c('thead', [_c('tr', [_c('th', [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.annual_norm')))])]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.userNormFormatted), function(item, idx) {
	    return (idx < _vm.userNormFormatted.length - 1) ? _c('tr', {
	      key: item.title
	    }, [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(item.value))])]) : _vm._e()
	  }), 0), _vm._v(" "), _c('tfoot', _vm._l((_vm.userNormFormatted), function(item, idx) {
	    return (idx === _vm.userNormFormatted.length - 1) ? _c('tr', {
	      key: item.title
	    }, [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(item.value))])]) : _vm._e()
	  }), 0)]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.userPoolsFormatted).length > 0) ? _c('table', {
	    staticClass: "d-table marg-1-bottom d-table__overview"
	  }, [_c('thead', [_c('tr', [_c('th', [_c('h4', [_vm._v(_vm._s(_vm.i18n['pools']))])]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.userPoolsFormatted), function(pool, prop) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(prop))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v("\n        " + _vm._s(pool) + "\n      ")])])
	  }), _vm._v(" "), (_vm.rest) ? _c('tr', [_c('td', [_vm._v("Rest")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.rest) + "\n      ")])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.schoolSettingShownOwnPools && _vm.schoolSettingShownOwnPools.length > 0) ? _c('UserTasksOverviewOwnPools', {
	    attrs: {
	      "schoolSettingShownOwnPools": _vm.schoolSettingShownOwnPools,
	      "isShowScheduled": false,
	      "userTasks": _vm.tasksByMasterType
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.tasksByMasterType && _vm.tasksByMasterType.length > 0) ? _c('TaskOverviewUserTasks', {
	    attrs: {
	      "user": _vm.user,
	      "tasks": _vm.tasks,
	      "tasksByMasterType": _vm.tasksByMasterType,
	      "schoolThresholdToHideTaskHours": _vm.schoolThresholdToHideTaskHours,
	      "isHideTaskHoursUnderThreshold": _vm.isHideTaskHoursUnderThreshold,
	      "canEditTasks": _vm.canEditTasks
	    },
	    on: {
	      "editTask": _vm.onEditTask
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.canEditNotes && _vm.userIdNumber) ? _c('SubjectsDistributionUserAgreements', {
	    attrs: {
	      "userId": _vm.userIdNumber,
	      "userAgreements": _vm.userAgreements,
	      "isReadAgreements": false
	    }
	  }) : (_vm.userAgreements && _vm.userAgreements.length > 0) ? _c('div', {
	    staticClass: "to-agreements"
	  }, [_c('div', {
	    staticClass: "to-agreements__header"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n['notes']))])]), _vm._v(" "), _c('div', {
	    staticClass: "to-agreements__body",
	    domProps: {
	      "innerHTML": _vm._s(_vm.userAgreements)
	    }
	  })]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1883 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "user-tasks text-dark"
	  }, [(_vm.isShowHeader) ? _c('div', {
	    staticClass: "user-tasks__header no-print"
	  }, [_c('div', {
	    staticClass: "user-tasks__header__left"
	  }, [_c('h2', {
	    staticClass: "user-tasks__header__left__inner"
	  }, [(!_vm.isCanSeeOtherUsers) ? _c('h2', [_vm._v(_vm._s(_vm.user.name))]) : _c('SelectUser', {
	    attrs: {
	      "preSelectedUserId": _vm.user_id,
	      "userName": _vm.user_name,
	      "path": "hours"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "no-mobile"
	  }, [_vm._v("-")]), _vm._v(" "), (_vm.isKindergarten) ? _c('p', [_vm._v("Årsnormsoversigt")]) : _c('p', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.hour_overview')))])], 1), _vm._v(" "), (!_vm.initialStartDate) ? _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "user-tasks__header__right"
	  }, [(!_vm.isStartOrEndDateChanged) ? _c('p', {
	    staticClass: "d-link",
	    on: {
	      "click": _vm.resetDates
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), (_vm.activeSchoolYear) ? _c('DatePickerRangeShortcuts', {
	    attrs: {
	      "startDate": _vm.activeSchoolYear.employee_time_start,
	      "endDate": _vm.activeSchoolYear.employee_time_end,
	      "selectedStartDate": _vm.startDate,
	      "selectedEndDate": _vm.endDate
	    },
	    on: {
	      "shortcutSelected": _vm.setDatesFromRange
	    }
	  }) : _vm._e(), _vm._v(" "), _c('DatePickerRange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate,
	      "maxEndDate": _vm.activeSchoolYear ? _vm.activeSchoolYear.employee_time_end : null
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  }), _vm._v(" "), (_vm.isShowPrintButton) ? _c('button', {
	    staticClass: "no-mobile marg-1-left",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled && _vm.isShowHeader) ? _c('div', {
	    staticClass: "d-box marg-1-bottom no-mobile"
	  }, [_c('UserTasksChart', {
	    attrs: {
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate,
	      "calendarId": _vm.user.user_calendar_id
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.isLoadingTasksForUser) ? _c('Loader') : _c('div', {
	    staticClass: "marg-1-bottom"
	  }, [_c('UserTasksOverview', {
	    attrs: {
	      "user": _vm.user,
	      "dates": _vm.dates,
	      "activeUserId": this.user.id,
	      "isInUserCalendar": true,
	      "isKindergarten": _vm.isKindergarten,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate,
	      "isShowHeader": _vm.isShowHeader,
	      "isPoolsDeactivated": _vm.isPoolsDeactivated,
	      "schoolPrepFactor": _vm.schoolPrepFactor,
	      "isPreviewAsEmployee": _vm.isPreviewAsEmployee,
	      "canEditTasks": _vm.canEditTasks
	    },
	    on: {
	      "changedIsShowScheduled": _vm.setIsShowScheduled,
	      "editSubject": _vm.setEditSubject
	    }
	  })], 1), _vm._v(" "), (_vm.isSubjectModal) ? _c('SubjectForm', {
	    attrs: {
	      "showModal": _vm.isSubjectModal,
	      "editSubject": _vm.editSubject,
	      "propIsLoading": _vm.isSubjectLoading,
	      "allowDanishPreparationFactorUi": true
	    },
	    on: {
	      "deleteSubject": _vm.deleteSubject,
	      "close": _vm.closeSubjectModal,
	      "updateSubject": _vm.updateSubject,
	      "saveAndShowTab": _vm.saveAndShowTab
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1884 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true,
	      "placeInTop": true,
	      "isCloseOnEsc": !_vm.isSubjectModal,
	      "isCloseOnBgClick": !_vm.isSubjectModal
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "sdl text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "sdl__header"
	  }, [_c('h2', [_vm._v("Brikker på " + _vm._s(_vm.dayTitle))]), _vm._v(" "), _c('div', {
	    staticClass: "sdl__header__actions"
	  }, [_c('button', {
	    ref: "createButton",
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('create')
	      }
	    }
	  }, [_vm._v("Opret flere brikker")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle sdl__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "sdl__content"
	  }, [(_vm.subjects.length === 0) ? _c('p', {
	    staticClass: "sdl__empty"
	  }, [_vm._v("Der er ikke oprettet nogen brikker for denne dag endnu.")]) : _c('table', {
	    staticClass: "do-table do-table--striped sdl__table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "sdl__col-name"
	  }, [_vm._v("Brik")]), _vm._v(" "), _c('th', {
	    staticClass: "sdl__col-classes"
	  }, [_vm._v("Klasser")]), _vm._v(" "), _c('th', {
	    staticClass: "sdl__col-teachers"
	  }, [_vm._v("Undervisere")]), _vm._v(" "), _c('th', {
	    staticClass: "sdl__col-hours"
	  }, [_vm._v("Timer")]), _vm._v(" "), _c('th', {
	    staticClass: "sdl__col-actions"
	  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.subjects), function(subject) {
	    return _c('tr', {
	      key: subject.id
	    }, [_c('td', {
	      staticClass: "sdl__col-name"
	    }, [_c('span', {
	      staticClass: "sdl__pill",
	      style: ({
	        backgroundColor: subject.color
	      })
	    }, [_vm._v(_vm._s(subject.name))])]), _vm._v(" "), _c('td', {
	      staticClass: "sdl__col-classes"
	    }, [_vm._v(_vm._s(_vm.classNames(subject) || '–'))]), _vm._v(" "), _c('td', {
	      staticClass: "sdl__col-teachers"
	    }, [_vm._v(_vm._s(_vm.teacherNames(subject) || '–'))]), _vm._v(" "), _c('td', {
	      staticClass: "sdl__col-hours"
	    }, [_vm._v(_vm._s(_vm.formatHours(subject.hours)))]), _vm._v(" "), _c('td', {
	      staticClass: "sdl__col-actions"
	    }, [(_vm.confirmingDeleteId === subject.id) ? [_c('span', {
	      staticClass: "sdl__confirm-text"
	    }, [_vm._v("Slet brik?")]), _vm._v(" "), _c('button', {
	      staticClass: "do-bttn do-bttn--small do-bttn--danger",
	      class: {
	        'do-bttn--loading': _vm.isDeleting
	      },
	      attrs: {
	        "disabled": _vm.isDeleting
	      },
	      on: {
	        "click": function($event) {
	          return _vm.runDelete(subject)
	        }
	      }
	    }, [_vm._v("Slet")]), _vm._v(" "), _c('button', {
	      staticClass: "do-bttn do-bttn--small",
	      attrs: {
	        "disabled": _vm.isDeleting
	      },
	      on: {
	        "click": function($event) {
	          _vm.confirmingDeleteId = null
	        }
	      }
	    }, [_vm._v("Fortryd")])] : [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'bottom'
	        }),
	        expression: "{arrow: true, placement: 'bottom'}"
	      }],
	      staticClass: "do-bttn do-bttn--small",
	      attrs: {
	        "aria-label": "Rediger brik",
	        "content": 'Rediger brik'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.startEdit(subject)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-pencil"
	    })]), _vm._v(" "), (_vm.canDeleteSubject(subject)) ? _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'bottom'
	        }),
	        expression: "{arrow: true, placement: 'bottom'}"
	      }],
	      staticClass: "do-bttn do-bttn--small do-bttn--danger",
	      attrs: {
	        "aria-label": "Slet brik",
	        "content": 'Slet brik'
	      },
	      on: {
	        "click": function($event) {
	          _vm.confirmingDeleteId = subject.id
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })]) : _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'bottom'
	        }),
	        expression: "{arrow: true, placement: 'bottom'}"
	      }],
	      staticClass: "do-bttn do-bttn--small do-bttn--disabled",
	      attrs: {
	        "aria-label": "Kan ikke slettes",
	        "disabled": "",
	        "content": 'Kan ikke slettes, da brikken er skemalagt'
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })])]], 2)])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "sdl__buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    attrs: {
	      "disabled": _vm.subjects.length === 0
	    },
	    on: {
	      "click": _vm.openSchedule
	    }
	  }, [_vm._v("Skemalæg brikker")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("Luk")])]), _vm._v(" "), (_vm.isScheduleModal) ? _c('SpecialDayScheduleModal', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "specialDay": _vm.specialDay,
	      "subjects": _vm.subjects,
	      "klassCalendars": _vm.klassCalendars
	    },
	    on: {
	      "scheduled": _vm.onScheduled,
	      "close": function($event) {
	        _vm.isScheduleModal = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isSubjectModal) ? _c('SubjectForm', {
	    attrs: {
	      "showModal": _vm.isSubjectModal,
	      "editSubject": _vm.editSubject,
	      "propIsLoading": _vm.isSubjectLoading,
	      "allowDanishPreparationFactorUi": true
	    },
	    on: {
	      "deleteSubject": _vm.handleDeleteSubject,
	      "close": _vm.closeSubjectModal,
	      "updateSubject": _vm.updateSubject,
	      "saveAndShowTab": _vm.saveAndShowTab
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1885 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "helpdesk"
	  }, [_c('div', {
	    staticClass: "helpdesk__hero"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "helpdesk__hero-inner"
	  }, [_c('header', {
	    staticClass: "helpdesk__topbar"
	  }, [_c('div', {
	    staticClass: "helpdesk__brand"
	  }, [_c('a', {
	    staticClass: "helpdesk__logo-link",
	    attrs: {
	      "href": _vm.homeUrl,
	      "aria-label": "Docendo"
	    }
	  }, [_c('span', {
	    staticClass: "helpdesk__logo-back"
	  }, [_vm._v("← " + _vm._s(_vm.$t('vue2.helpdesk.back_to')))]), _vm._v(" "), _c('do-logo', {
	    staticClass: "helpdesk__logo"
	  })], 1), _vm._v(" "), _c('button', {
	    staticClass: "helpdesk__brand-name",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.goHome
	    }
	  }, [_vm._v("Helpdesk")])]), _vm._v(" "), _c('div', {
	    staticClass: "helpdesk__topbar-right"
	  }, [_c('div', {
	    staticClass: "helpdesk__langs",
	    attrs: {
	      "role": "group",
	      "aria-label": _vm.$t('vue2.helpdesk.language')
	    }
	  }, _vm._l((_vm.localeOptions), function(opt) {
	    return _c('button', {
	      key: opt.code,
	      staticClass: "helpdesk__lang",
	      class: {
	        'helpdesk__lang--active': _vm.locale === opt.code
	      },
	      attrs: {
	        "type": "button",
	        "aria-label": opt.label,
	        "aria-pressed": _vm.locale === opt.code ? 'true' : 'false',
	        "title": opt.label
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setLocale(opt.code)
	        }
	      }
	    }, [_c('img', {
	      staticClass: "helpdesk__lang-flag",
	      attrs: {
	        "src": opt.flag,
	        "alt": opt.label
	      }
	    })])
	  }), 0)])]), _vm._v(" "), _c('p', {
	    staticClass: "helpdesk__eyebrow"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.hero_eyebrow')))]), _vm._v(" "), _c('h1', {
	    staticClass: "helpdesk__title"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.hero_title')))]), _vm._v(" "), _c('p', {
	    staticClass: "helpdesk__subtitle"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.hero_subtitle')))]), _vm._v(" "), _c('div', {
	    staticClass: "helpdesk__search"
	  }, [_c('span', {
	    staticClass: "helpdesk__search-icon icon-search5"
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchQuery),
	      expression: "searchQuery"
	    }],
	    ref: "searchInput",
	    staticClass: "helpdesk__search-input",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('vue2.helpdesk.search_placeholder')
	    },
	    domProps: {
	      "value": (_vm.searchQuery)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchQuery = $event.target.value
	      }, _vm.onSearchInput],
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        return _vm.clearSearch.apply(null, arguments)
	      }
	    }
	  }), _vm._v(" "), (_vm.searchQuery) ? _c('button', {
	    staticClass: "helpdesk__search-clear icon-cross2",
	    attrs: {
	      "type": "button",
	      "aria-label": _vm.$t('vue2.helpdesk.clear_search')
	    },
	    on: {
	      "click": _vm.clearSearch
	    }
	  }) : _vm._e()])])]), _vm._v(" "), (_vm.showSubheader) ? _c('div', {
	    staticClass: "helpdesk__subheader"
	  }, [_c('div', {
	    staticClass: "helpdesk__subheader-inner",
	    class: {
	      'helpdesk__subheader-inner--wide': !!_vm.activeArticle
	    }
	  }, [(_vm.activeArticle) ? [_c('span', {
	    staticClass: "helpdesk__crumb-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.articles_about')))]), _vm._v(" "), (_vm.articleCategory) ? _c('a', {
	    staticClass: "helpdesk__crumb-link",
	    on: {
	      "click": function($event) {
	        return _vm.openCategory(_vm.articleCategory)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.articleCategory))]) : _vm._e()] : [_c('button', {
	    staticClass: "helpdesk__crumb-back",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.closeCategory
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-left4"
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.helpdesk.back')) + "\n        ")]), _vm._v(" "), _c('span', {
	    staticClass: "helpdesk__crumb-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.articles_about')))]), _vm._v(" "), _c('span', {
	    staticClass: "helpdesk__crumb-pill"
	  }, [_vm._v(_vm._s(_vm.activeCategory))]), _vm._v(" "), (_vm.categoryDescription(_vm.activeCategory)) ? _c('span', {
	    staticClass: "helpdesk__crumb-desc"
	  }, [_vm._v("\n          " + _vm._s(_vm.categoryDescription(_vm.activeCategory)) + "\n        ")]) : _vm._e()]], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "helpdesk__body"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "helpdesk__container"
	  }, [_vm._m(1)]) : (_vm.isSearching || _vm.searchQuery) ? _c('div', {
	    staticClass: "helpdesk__container"
	  }, [_c('button', {
	    staticClass: "helpdesk__back",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.clearSearch
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-left4"
	  }), _vm._v("\n        " + _vm._s(_vm.$t('vue2.helpdesk.back_to_start')) + "\n      ")]), _vm._v(" "), _c('h2', {
	    staticClass: "helpdesk__section-title"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.helpdesk.search_results')) + "\n        "), _c('span', {
	    staticClass: "helpdesk__section-hint"
	  }, [_vm._v("\"" + _vm._s(_vm.searchQuery) + "\"")])]), _vm._v(" "), (_vm.isSearching) ? _c('div', {
	    staticClass: "helpdesk__loading helpdesk__loading--inline"
	  }, [_c('div', {
	    staticClass: "helpdesk__spinner"
	  })]) : (_vm.searchResults.length) ? _c('ul', {
	    staticClass: "helpdesk__article-list"
	  }, _vm._l((_vm.searchResults), function(article) {
	    return _c('li', {
	      key: article.id,
	      staticClass: "helpdesk__article-item",
	      on: {
	        "click": function($event) {
	          return _vm.openArticle(article.id)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "helpdesk__article-icon icon-file-text"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "helpdesk__article-title"
	    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('span', {
	      staticClass: "helpdesk__article-arrow icon-arrow-right4"
	    })])
	  }), 0) : _c('p', {
	    staticClass: "helpdesk__empty"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.no_results')))])]) : (_vm.activeArticle) ? _c('div', {
	    staticClass: "helpdesk__container helpdesk__container--article"
	  }, [_c('div', {
	    staticClass: "helpdesk__layout"
	  }, [_c('aside', {
	    staticClass: "helpdesk__sidebar"
	  }, [(_vm.articleCategory) ? _c('button', {
	    staticClass: "helpdesk__back-pill",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.openCategory(_vm.articleCategory)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-left4"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "helpdesk__back-pill-text"
	  }, [_vm._v(_vm._s(_vm.articleCategory))])]) : _vm._e(), _vm._v(" "), (_vm.relatedArticles.length) ? [_c('h3', {
	    staticClass: "helpdesk__sidebar-title"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.related_articles')))]), _vm._v(" "), _c('ul', {
	    staticClass: "helpdesk__related-list"
	  }, _vm._l((_vm.relatedArticles), function(article) {
	    return _c('li', {
	      key: article.id,
	      staticClass: "helpdesk__related-item",
	      on: {
	        "click": function($event) {
	          return _vm.openArticle(article.id)
	        }
	      }
	    }, [_vm._v("\n                " + _vm._s(article.title) + "\n              ")])
	  }), 0)] : _vm._e()], 2), _vm._v(" "), _c('article', {
	    staticClass: "helpdesk__main helpdesk__article-card"
	  }, [_c('div', {
	    staticClass: "helpdesk__article-top"
	  }, [_c('h1', {
	    staticClass: "helpdesk__article-heading"
	  }, [_vm._v(_vm._s(_vm.activeArticle.title))]), _vm._v(" "), _c('button', {
	    staticClass: "helpdesk__share",
	    class: {
	      'helpdesk__share--done': _vm.shareCopied
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.shareArticle
	    }
	  }, [_c('span', {
	    class: _vm.shareCopied ? 'icon-checkmark4' : 'icon-clipboard2'
	  }), _vm._v("\n              " + _vm._s(_vm.shareCopied ? _vm.$t('vue2.helpdesk.link_copied') : _vm.$t('vue2.helpdesk.copy_link')) + "\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "helpdesk__article-body",
	    domProps: {
	      "innerHTML": _vm._s(_vm.articleHtml)
	    }
	  })])])]) : (_vm.activeCategory) ? _c('div', {
	    staticClass: "helpdesk__container helpdesk__container--wide"
	  }, [_c('div', {
	    staticClass: "helpdesk__layout"
	  }, [_c('aside', {
	    staticClass: "helpdesk__sidebar"
	  }, [_c('h3', {
	    staticClass: "helpdesk__sidebar-title"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.categories')))]), _vm._v(" "), _c('ul', {
	    staticClass: "helpdesk__sidebar-list"
	  }, _vm._l((_vm.categories), function(cat) {
	    return _c('li', {
	      key: cat.name,
	      staticClass: "helpdesk__sidebar-item",
	      class: {
	        'helpdesk__sidebar-item--active': cat.name === _vm.activeCategory
	      },
	      on: {
	        "click": function($event) {
	          return _vm.openCategory(cat.name)
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(cat.name) + "\n            ")])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "helpdesk__main"
	  }, [_vm._l((_vm.articlesInActiveCategory), function(article) {
	    return _c('div', {
	      key: article.id,
	      staticClass: "helpdesk__result-card",
	      on: {
	        "click": function($event) {
	          return _vm.openArticle(article.id)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "helpdesk__result-icon icon-file-text"
	    }), _vm._v(" "), _c('div', {
	      staticClass: "helpdesk__result-content"
	    }, [_c('h4', {
	      staticClass: "helpdesk__result-title"
	    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), (_vm.articleExcerpt(article)) ? _c('p', {
	      staticClass: "helpdesk__result-excerpt"
	    }, [_vm._v("\n                " + _vm._s(_vm.articleExcerpt(article)) + "\n              ")]) : _vm._e()])])
	  }), _vm._v(" "), (!_vm.articlesInActiveCategory.length) ? _c('p', {
	    staticClass: "helpdesk__empty"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.helpdesk.no_articles')) + "\n          ")]) : _vm._e()], 2)])]) : _c('div', {
	    staticClass: "helpdesk__container helpdesk__home"
	  }, [(_vm.featuredNews) ? _c('section', {
	    staticClass: "helpdesk__news"
	  }, [_c('div', {
	    staticClass: "helpdesk__news-main"
	  }, [_c('div', {
	    staticClass: "helpdesk__news-top"
	  }, [_c('span', {
	    staticClass: "helpdesk__news-eyebrow"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.helpdesk.latest_news'))), (_vm.featuredNewsDate) ? [_vm._v(" · " + _vm._s(_vm.featuredNewsDate))] : _vm._e()], 2)]), _vm._v(" "), _c('h2', {
	    staticClass: "helpdesk__news-title"
	  }, [_vm._v(_vm._s(_vm.featuredNews.title))]), _vm._v(" "), _c('button', {
	    staticClass: "helpdesk__news-button",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.openArticle(_vm.featuredNews.id)
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.helpdesk.read_news')) + "\n            "), _c('span', {
	    staticClass: "icon-arrow-right4"
	  })])]), _vm._v(" "), (_vm.olderNews.length) ? _c('div', {
	    staticClass: "helpdesk__news-side"
	  }, [_c('h3', {
	    staticClass: "helpdesk__news-side-title"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.earlier_news')))]), _vm._v(" "), _c('ul', {
	    staticClass: "helpdesk__news-list"
	  }, _vm._l((_vm.olderNews), function(article) {
	    return _c('li', {
	      key: article.id,
	      staticClass: "helpdesk__news-item",
	      on: {
	        "click": function($event) {
	          return _vm.openArticle(article.id)
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(article.title) + "\n            ")])
	  }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostVisited.length) ? _c('section', {
	    staticClass: "helpdesk__section"
	  }, [_c('h2', {
	    staticClass: "helpdesk__section-title"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.popular_articles')))]), _vm._v(" "), _c('ul', {
	    staticClass: "helpdesk__popular"
	  }, _vm._l((_vm.mostVisited), function(article) {
	    return _c('li', {
	      key: article.id,
	      staticClass: "helpdesk__popular-item",
	      on: {
	        "click": function($event) {
	          return _vm.openArticle(article.id)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "helpdesk__popular-icon icon-file-text"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "helpdesk__popular-title"
	    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('span', {
	      staticClass: "helpdesk__popular-arrow icon-arrow-right4"
	    })])
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('section', {
	    staticClass: "helpdesk__section"
	  }, [_c('div', {
	    staticClass: "helpdesk__section-head"
	  }, [_c('h2', {
	    staticClass: "helpdesk__section-title"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.find_by_topic')))])]), _vm._v(" "), (_vm.topicCategories.length) ? _c('div', {
	    staticClass: "helpdesk__grid"
	  }, _vm._l((_vm.topicCategories), function(cat, index) {
	    return _c('button', {
	      key: cat.name,
	      staticClass: "helpdesk__card",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.openCategory(cat.name)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "helpdesk__card-icon",
	      class: {
	        'helpdesk__card-icon--image': !!cat.icon
	      }
	    }, [(cat.icon) ? _c('img', {
	      attrs: {
	        "src": cat.icon,
	        "alt": ""
	      }
	    }) : [_vm._v(_vm._s(index + 1))]], 2), _vm._v(" "), _c('span', {
	      staticClass: "helpdesk__card-content"
	    }, [_c('span', {
	      staticClass: "helpdesk__card-title"
	    }, [_vm._v(_vm._s(cat.name))]), _vm._v(" "), (cat.description) ? _c('span', {
	      staticClass: "helpdesk__card-desc"
	    }, [_vm._v(_vm._s(cat.description))]) : _vm._e(), _vm._v(" "), _c('span', {
	      staticClass: "helpdesk__card-count"
	    }, [_vm._v("\n                " + _vm._s(cat.count) + " " + _vm._s(cat.count === 1 ? _vm.$t('vue2.helpdesk.article') : _vm.$t('vue2.helpdesk.articles')) + " →\n              ")])])])
	  }), 0) : _c('p', {
	    staticClass: "helpdesk__empty"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.no_articles')))])]), _vm._v(" "), _c('p', {
	    staticClass: "helpdesk__footer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.footer_help')))])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "helpdesk__hero-bg"
	  }, [_c('div', {
	    staticClass: "helpdesk__hero-bg__triangle"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "helpdesk__loading"
	  }, [_c('div', {
	    staticClass: "helpdesk__spinner"
	  })])
	}]}

/***/ }),
/* 1886 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark d-modal__select-teacher-for-sub",
	    staticStyle: {
	      "width": "400px"
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['which_teacher_will']) + " " + _vm._s(_vm.substitute.name) + " " + _vm._s(_vm.i18n[_vm.locale]['be_substitute_for']) + "?")]), _vm._v(" "), _c('ul', _vm._l((_vm.teachers), function(teacher) {
	    return _c('li', {
	      key: teacher.id,
	      staticClass: "select-teacher-for-sub__teacher"
	    }, [_vm._v("\n          " + _vm._s(teacher.name) + "\n          "), _c('button', {
	      staticClass: "bttn bttn-primary",
	      staticStyle: {
	        "padding": "2px 1rem"
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.$emit('select', teacher)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('vue2.common.select')))])])
	  }), 0)])])])
	},staticRenderFns: []}

/***/ }),
/* 1887 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.event && !_vm.event.deleted) ? _c('div', {
	    staticClass: "up__event"
	  }, [_c('div', {
	    staticClass: "up__event-edit"
	  }, [_c('timechanger', {
	    staticClass: "time-changer__create-presence",
	    class: {
	      'input-warning': _vm.event.tempIntersect
	    },
	    attrs: {
	      "lang": "da",
	      "start": _vm.event.start,
	      "end": _vm.event.end,
	      "isFiveMinutesInterval": false
	    },
	    on: {
	      "updateStart": _vm.updateStart,
	      "updateEnd": _vm.updateEnd
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "up__event-delete pointer",
	    on: {
	      "click": _vm.deleteEvent
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross3"
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "up__event-sum"
	  }, [_vm._v("\n    " + _vm._s(_vm.duration) + "\n  ")])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1888 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-ssn-modal"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("CPR-nummer")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ssn),
	      expression: "ssn"
	    }],
	    ref: "ssn_input",
	    staticClass: "d-input",
	    class: {
	      'is-invalid': !!_vm.error
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": "ddmmåå-nnnn",
	      "inputmode": "numeric",
	      "maxlength": "11"
	    },
	    domProps: {
	      "value": (_vm.ssn)
	    },
	    on: {
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onSubmit.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.ssn = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.error) ? _c('p', {
	    staticClass: "text-explainer marg-05-top"
	  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]), _vm._v(" "), _c('p', {
	    staticClass: "ssn-explainer"
	  }, [_vm._v("\n        Docendo henter ansættelser fra lønsystemet ved at matche på CPR-numre. Det sker automatisk hver nat.\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div'), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': !_vm.isValid || _vm.isSubmitting,
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.onSubmit
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1889 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "intern-notes-container"
	  }, [_c('button', {
	    staticClass: "open-button",
	    on: {
	      "click": function($event) {
	        _vm.isOpen = !_vm.isOpen
	      }
	    }
	  }, [_vm._v("Interne noter "), (_vm.noteText.length > 1) ? _c('div', {
	    staticClass: "dot"
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "subs-note",
	    class: {
	      'subs-note--is-open': _vm.isOpen
	    }
	  }, [_c('div', {
	    staticClass: "subs-note__container"
	  }, [_c('div', {
	    staticClass: "subs-note__container__header"
	  }, [_c('div', {
	    staticClass: "subs-note__container__header__close",
	    on: {
	      "click": function($event) {
	        _vm.isOpen = !_vm.isOpen
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('h2', [_vm._v("Dagens interne noter")])]), _vm._v(" "), _c('div', {
	    staticClass: "subs-note__container__body"
	  }, [_c('h3', [_vm._v("Noter til " + _vm._s(_vm.showDate))]), _vm._v(" "), _c('div', {
	    staticClass: "subs-note__container__note"
	  }, [_c('AppEIPWYZIWYG', {
	    attrs: {
	      "textInput": _vm.noteText
	    },
	    on: {
	      "close": _vm.updateNoteText
	    }
	  })], 1)])])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeIn"
	    }
	  }, [(_vm.isOpen) ? _c('div', {
	    staticClass: "bg-overlay",
	    on: {
	      "click": function($event) {
	        _vm.isOpen = false
	      }
	    }
	  }) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1890 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "permissions"
	  }, [_c('div', {
	    staticClass: "permissions__col"
	  }, [_c('div', {
	    staticClass: "permissions__col__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.permissions.roles')))])]), _vm._v(" "), _c('div', {
	    staticClass: "permissions__col__body"
	  }, [_c('ul', [(_vm.isLoadingRoles) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff",
	      "size": "small"
	    }
	  }) : _vm._l((_vm.rolesWithMeta), function(role) {
	    return _c('li', {
	      key: role.id,
	      staticClass: "permissions__roles__role",
	      class: {
	        'permissions__roles__role--is-active': _vm.isActiveRole(role)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveRole(role)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "role__left"
	    }, [_c('p', [_vm._v(_vm._s(role.v_title))])]), _vm._v(" "), _c('div', {
	      staticClass: "role__right"
	    }, [_c('span', {
	      staticClass: "role__number-of-user"
	    }, [_c('span', {
	      staticClass: "icon-user"
	    }), _vm._v("\n            " + _vm._s(role.user_ids.length) + "\n            ")]), _vm._v(" "), (role.name !== 'Administrator' && role.name !== 'Regular user' && role.name !== 'Read only user') ? _c('DDropdown', {
	      staticClass: "role-dropdown"
	    }, [_c('ul', {
	      attrs: {
	        "slot": "list"
	      },
	      slot: "list"
	    }, [_c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.setTheEditRole(role)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-pencil"
	    }), _vm._v(" " + _vm._s(_vm.$t('vue2.common.rename')) + "\n                ")]), _vm._v(" "), (role.user_ids.length > 0) ? _c('li', {
	      staticClass: "d-item-warning d-item-warning--disabled hint--right",
	      attrs: {
	        "aria-label": _vm.$t('vue2.permissions.you_cant_delete_a_role_that_has_users')
	      }
	    }, [_c('div', {
	      staticClass: "d-item-warning--disabled__inner"
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    }), _vm._v("\n                    " + _vm._s(_vm.$t('vue2.common.delete')) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (role.user_ids.length === 0) ? _c('li', {
	      staticClass: "d-item-warning",
	      on: {
	        "click": function($event) {
	          return _vm.setTheDeleteRole(role)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    }), _vm._v("\n                  " + _vm._s(_vm.$t('vue2.common.delete')) + "\n                ")]) : _vm._e()])]) : _vm._e()], 1)])
	  }), _vm._v(" "), (!_vm.isLoadingRoles) ? _c('li', {
	    staticClass: "permissions__roles__role__create"
	  }, [_c('button', {
	    staticClass: "btn btn-trans",
	    on: {
	      "click": function($event) {
	        return _vm.setIsRoleModal(true)
	      }
	    }
	  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.permissions.create_new_role')) + "\n          ")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "permissions__col"
	  }, [_c('div', {
	    staticClass: "permissions__col__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.permissions.users')) + " "), _c('span', {
	    staticClass: "lowercase"
	  }, [_vm._v(_vm._s(_vm.activeRole ? _vm.activeRole.v_title : ''))])])]), _vm._v(" "), _c('div', {
	    staticClass: "permissions__col__body"
	  }, [_c('div', {
	    staticClass: "permissions__col__body__users"
	  }, [(_vm.selectedUsers.length === 0) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('DSelect', {
	    attrs: {
	      "items": _vm.usersForDSelect,
	      "itemsSelected": [],
	      "placeholder": _vm.$t('vue2.common.add_user'),
	      "showSelectedUsers": false
	    },
	    on: {
	      "add": function($event) {
	        return _vm.addUserToRole($event)
	      }
	    }
	  })], 1) : _c('div', {
	    staticClass: "input-group"
	  }, [_c('select', {
	    staticClass: "do-select width-100",
	    on: {
	      "change": function($event) {
	        return _vm.addUserToRoleForMultipleUsers($event.target.value)
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "disabled": "",
	      "selected": ""
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.permissions.change_role')))]), _vm._v(" "), _vm._l((_vm.selectableRoles), function(role) {
	    return _c('option', {
	      key: role.id,
	      attrs: {
	        "disabled": role.id === _vm.activeRole.id
	      },
	      domProps: {
	        "value": role.id
	      }
	    }, [_vm._v("\n              " + _vm._s(role.v_title) + "\n            ")])
	  })], 2)]), _vm._v(" "), (_vm.usersWithActiveRole.length > 0) ? _c('div', {
	    staticClass: "permissions__col__body__users__header"
	  }, [_c('div', {
	    staticClass: "select-all-container"
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox",
	      "id": 'select-all-checkbox'
	    },
	    domProps: {
	      "checked": _vm.areAllUsersSelected
	    },
	    on: {
	      "change": _vm.toggleSelectAll
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "select-all-label",
	    attrs: {
	      "for": 'select-all-checkbox'
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.areAllUsersSelected ? _vm.i18n['unselect_all'] : _vm.i18n['select_all']) + "\n            ")])]), _vm._v(" "), (_vm.selectedUsers.length > 0) ? _c('span', {
	    staticClass: "selected-count"
	  }, [_vm._v("\n            " + _vm._s(_vm.selectedUsers.length) + " " + _vm._s(_vm.i18n['selected']) + " \n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "permissions__col__body__users__list"
	  }, [_c('virtual-list', {
	    staticStyle: {
	      "height": "500px",
	      "overflow-y": "auto"
	    },
	    attrs: {
	      "estimate-size": 40,
	      "keeps": 20,
	      "data-key": 'id',
	      "data-sources": _vm.usersWithActiveRole,
	      "data-component": _vm.itemComponent,
	      "extra-props": {
	        selectableRoles: _vm.selectableRoles,
	        selectedUsers: _vm.selectedUsers,
	        onUserSelectionChanged: _vm.handleUserSelectionChanged
	      }
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "permissions__col"
	  }, [_c('div', {
	    staticClass: "permissions__col__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.permissions.permissions')) + " "), _c('span', {
	    staticClass: "lowercase"
	  }, [_vm._v(_vm._s(_vm.activeRole && _vm.activeRole.v_title))])])]), _vm._v(" "), _c('div', {
	    staticClass: "permissions__col__body"
	  }, [(_vm.getRoleDesc.length > 0) ? _c('p', {
	    staticClass: "role__desc"
	  }, [_vm._v(_vm._s(_vm.getRoleDesc))]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "permissions__permissions"
	  }, _vm._l((_vm.activePermissions), function(permission) {
	    return _c('li', {
	      key: permission.permission,
	      staticClass: "permissions__permissions__permission",
	      attrs: {
	        "data-permission": permission.permission
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          $event.preventDefault();
	          return _vm.togglePermissionToRole(permission.permission)
	        }
	      }
	    }, [(_vm.getIsPermissioni18n(permission.permission)) ? _c('p', [_vm._v(_vm._s(_vm.getIsPermissioni18n(permission.permission)))]) : _c('p', [_vm._v(_vm._s(permission.vTitle))]), _vm._v(" "), _c('app-toggle', {
	      attrs: {
	        "propOn": _vm.isPermissionInActiveRole(permission.permission)
	      }
	    })], 1)
	  }), 0)])]), _vm._v(" "), (_vm.isRoleModal) ? _c('DModal', {
	    attrs: {
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "role-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "role-modal__header"
	  }, [_c('h2', [(!_vm.theEditRole && !_vm.theDeleteRole) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.permissions.create_new_role')))]) : _vm._e(), _vm._v(" "), (_vm.theEditRole && !_vm.theDeleteRole) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.permissions.rename_role')))]) : _vm._e(), _vm._v(" "), (_vm.theDeleteRole) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.permissions.delete_role')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "role-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.setIsRoleModal(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "role-modal__body"
	  }, [(!_vm.theDeleteRole) ? _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [(!_vm.theEditRole) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.permissions.give_role_a_title')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.permissions.choose_new_name')))])]), _vm._v(" "), _c('input', {
	    ref: "roleCreateInputField",
	    staticClass: "box-shadow bg-white animated",
	    class: {
	      'shake': _vm.isSavingWithoutInput
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm.createNewRoleName
	    },
	    on: {
	      "input": _vm.onInput
	    }
	  })]) : _vm._e(), _vm._v(" "), (!_vm.theDeleteRole) ? _c('div', {
	    staticClass: "d-group marg-1-top"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.permissions.select_role_to_base_new_on')))]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.existingRoleToCopyId),
	      expression: "existingRoleToCopyId"
	    }],
	    staticClass: "do-select width-100",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.existingRoleToCopyId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.rolesToCopy), function(role) {
	    return _c('option', {
	      key: role.id,
	      domProps: {
	        "value": role.id
	      }
	    }, [_vm._v("\n              " + _vm._s(role.v_title) + "\n            ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.theDeleteRole && _vm.theDeleteRole.user_ids.length < 1) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.common.are_you_sure_you_want_to_delete')) + "\n            "), _c('span', {
	    staticClass: "text-danger"
	  }, [_vm._v("\"" + _vm._s(_vm.theDeleteRole.v_title) + "\"")]), _vm._v(" " + _vm._s(_vm.$t('vue2.permissions.role')) + " ?")])]) : _vm._e(), _vm._v(" "), (_vm.theDeleteRole && _vm.theDeleteRole.user_ids.length > 0) ? _c('div', {
	    staticClass: "unable-to-delete-warning"
	  }, [_c('h3', {
	    staticClass: "text-danger"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.permissions.you_cant_delete_a_role_that_has_users')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.permissions.give_the_following_user_a_new_role')))]), _vm._v(" "), _c('ul', {
	    staticClass: "permissions__col__body__users__list"
	  }, _vm._l((_vm.usersWithActiveRole), function(user) {
	    return _c('li', {
	      staticClass: "permissions__col__body__users__list__user"
	    }, [_c('div', [_c('img', {
	      attrs: {
	        "src": user.default_thumb_url,
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])])])
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "submit-buttons marg-10-top"
	  }, [_c('button', {
	    staticClass: "marg-5-right",
	    on: {
	      "click": function($event) {
	        return _vm.setIsRoleModal(false)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.theDeleteRole && !_vm.isInputFieldLength) ? _c('button', {
	    staticClass: "submit-button bttn--disabled",
	    on: {
	      "click": _vm.onNoInput
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.create')) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.theEditRole && _vm.isInputFieldLength) ? _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.createNewRole
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.create')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.theEditRole && _vm.isInputFieldLength) ? _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.updateRoleName
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.rename')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.theDeleteRole && _vm.theDeleteRole.user_ids.length < 1) ? _c('button', {
	    staticClass: "bttn bttn-danger",
	    on: {
	      "click": _vm.deleteRole
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.delete')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.theDeleteRole && _vm.theDeleteRole.user_ids.length > 0) ? _c('button', {
	    staticClass: "bttn bttn--danger bttn--disabled"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.delete')) + "\n          ")]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.isRoleModal) ? _c('div', {
	    staticClass: "bg-overlay"
	  }) : _vm._e(), _vm._v(" "), _c('PermissionsUserChange', {
	    attrs: {
	      "roles": _vm.selectableRoles
	    },
	    on: {
	      "set": function($event) {
	        return _vm.setRole($event)
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1891 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    ref: "d_modal",
	    staticClass: "modal-wrapper",
	    class: [{
	      'no-print': !_vm.isPrintable
	    }, {
	      'modal-wrapper--printable': _vm.isPrintable
	    }, {
	      'js-no-close': _vm.appendToBody
	    }, {
	      'modal-wrapper--from-top': _vm.placeInTop
	    }],
	    style: (_vm.zIndex ? {
	      zIndex: _vm.zIndex
	    } : null),
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    ref: "modalContent",
	    staticClass: "modal",
	    style: ({
	      top: !_vm.placeInTop ? '0px' : _vm.pxFromTop + 'rem'
	    }),
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-modal": "true",
	      "aria-label": _vm.ariaLabel || null
	    }
	  }, [(_vm.showClose) ? _c('button', {
	    staticClass: "close-cross",
	    attrs: {
	      "type": "button",
	      "aria-label": _vm.$t('vue2.a11y.close')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]) : _vm._e(), _vm._v(" "), _vm._t("insertComponent", function() {
	    return [_c('h2', [_vm._v("Hello")])]
	  })], 2), _vm._v(" "), (_vm.isBgOverlay) ? _c('div', {
	    staticClass: "bg-overlay animateFast fadeIn",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.onBgClick.apply(null, arguments)
	      }
	    }
	  }) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1892 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-tasks",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	      }
	    }
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "isSmall": true
	    }
	  }) : [_c('table', {
	    staticClass: "d-table__inner"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "width": "75%"
	    }
	  }, [_vm._v("Tildelt arbejdstid")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm.tildeltArbejdstid))])]), _vm._v(" "), _c('tr', [_c('th', {
	    staticStyle: {
	      "width": "75%"
	    }
	  }, [_vm._v("Tildelt Undervisningstid")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm.tildeltUndervisning))])]), _vm._v(" "), _c('tr', [_c('th', {
	    staticStyle: {
	      "width": "75%"
	    }
	  }, [_vm._v("Tildelt Undervisningstid uden UUV")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm.tildeltUndervisningUdenUUV))])])])]), _vm._v(" "), _vm._l((_vm.tasksInTypes), function(type, idx) {
	    return _c('table', {
	      staticClass: "d-table__inner"
	    }, [_c('thead', {
	      staticClass: "d-table__inner__thead__small"
	    }, [_c('tr', [_c('th', {
	      staticStyle: {
	        "width": "75%"
	      }
	    }, [_vm._v("\n          " + _vm._s(type.title) + "\n        ")]), _vm._v(" "), _c('th', {
	      staticClass: "text-right"
	    }, [_vm._v("\n          " + _vm._s(type.sum) + "\n        ")])])]), _vm._v(" "), _c('tbody', [(type.events.length < 1) ? _c('tr', [_c('td', {
	      staticClass: "text-explainer"
	    }, [_vm._v("Ingen "), (idx === 0) ? _c('span', [_vm._v("lektioner")]) : _vm._e(), (idx === 1) ? _c('span', [_vm._v("UUV")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm._l((type.events), function(task) {
	      return _c('tr', [_c('td', {
	        staticStyle: {
	          "width": "75%"
	        }
	      }, [_c('div', {
	        staticClass: "subject-and-calendar"
	      }, [_c('div', {
	        staticClass: "d-subject",
	        style: ({
	          'border-left-color': task.color
	        })
	      }, [_vm._v(_vm._s(task.name))]), _vm._v("\n            " + _vm._s(task.calendar) + "\n          ")])]), _vm._v(" "), _c('td', {
	        staticClass: "text-right"
	      }, [_vm._v(_vm._s(task.hours))])])
	    })], 2)])
	  })]], 2)
	},staticRenderFns: []}

/***/ }),
/* 1893 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "user-requests-list text-dark",
	    class: {
	      'user-requests-list--user': _vm.isUserView
	    }
	  }, [(!_vm.isUserView) ? _c('h1', [_vm._v(_vm._s(_vm.i18n['absence_requests']))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "user-requests-list__toolbar marg-1-bottom"
	  }, [_c('Tabs', {
	    attrs: {
	      "selected": _vm.selectedTab,
	      "tabs": _vm.tabs
	    },
	    on: {
	      "select": function($event) {
	        _vm.selectedTab = $event
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n['school_year'],
	      "tags": _vm.schoolYearTags,
	      "selectedTags": _vm.selectedSchoolYears
	    },
	    on: {
	      "select": _vm.toggleSchoolYear,
	      "clear": function($event) {
	        _vm.selectedSchoolYears = []
	      }
	    }
	  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('Loader') : _c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', {
	    staticClass: "do-table__header"
	  }, [_c('tr', [_c('th', {
	    staticClass: "th-sorter td-created",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'created_at'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('created_at')
	      },
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.setSort('created_at')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n['created']) + " "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'vUserName'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('vUserName')
	      },
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.setSort('vUserName')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n['who']) + " "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter td-date",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'start_time'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('start_time')
	      },
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.setSort('start_time')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n['from']) + " "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter td-date",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'end_time'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('end_time')
	      },
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.setSort('end_time')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n['to']) + " "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'vSubjectTitle'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('vSubjectTitle')
	      },
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.setSort('vSubjectTitle')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n['reason']) + " "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'request_note'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('request_note')
	      },
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.setSort('request_note')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n['note']) + " "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), (_vm.selectedTab !== 'requested') ? _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'response_note'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('response_note')
	      },
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.setSort('response_note')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n['note_back']) + " "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]) : _vm._e(), _vm._v(" "), (_vm.selectedTab !== 'requested') ? _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'vResponderName'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('vResponderName')
	      },
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.setSort('vResponderName')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n['answered_by']) + " "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'requested') ? _c('th') : _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'state'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('state')
	      },
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.setSort('state')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n['status']) + " "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])])]), _vm._v(" "), _c('tbody', [(_vm.sortedRequests.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "italic text-align-left",
	    attrs: {
	      "colspan": "7"
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.emptyTableTitle) + "\n      ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedRequests), function(request) {
	    return _c('tr', {
	      key: request.id,
	      on: {
	        "click": function($event) {
	          return _vm.setTheEditRequest(request)
	        }
	      }
	    }, [_c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
	      }],
	      staticClass: "td-created",
	      attrs: {
	        "content": request.vCreated
	      }
	    }, [_vm._v("\n        " + _vm._s(request.vCreatedTimeAgo) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.vUserName))]), _vm._v(" "), _c('td', {
	      staticClass: "td-date"
	    }, [_vm._v(_vm._s(request.vStart))]), _vm._v(" "), _c('td', {
	      staticClass: "td-date"
	    }, [_vm._v(_vm._s(request.vEnd))]), _vm._v(" "), _c('td', [_c('span', {
	      staticClass: "do-pill do-pill--white"
	    }, [_vm._v(_vm._s(request.vSubjectTitle))])]), _vm._v(" "), _c('td', {
	      staticClass: "italic"
	    }, [_vm._v(_vm._s(request.request_note))]), _vm._v(" "), (_vm.selectedTab !== 'requested') ? _c('td', {
	      staticClass: "italic"
	    }, [_vm._v(_vm._s(request.response_note))]) : _vm._e(), _vm._v(" "), (_vm.selectedTab !== 'requested') ? _c('td', [_vm._v(_vm._s(request.vResponderName))]) : _vm._e(), _vm._v(" "), _c('td', [(!_vm.isUserView && _vm.selectedTab === 'requested') ? _c('button', {
	      staticClass: "do-bttn",
	      on: {
	        "click": function($event) {
	          _vm.theAnswerRequest = request
	        }
	      }
	    }, [_vm._v("\n          " + _vm._s(_vm.i18n['answer']) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isUserView && request.state === 'requested') ? _c('div', {
	      staticClass: "d-bagde d-badge--yellow"
	    }, [_vm._v("\n          " + _vm._s(_vm.i18n['pending']) + "\n        ")]) : (request.state === 'approved') ? _c('div', {
	      staticClass: "d-bagde d-badge--green"
	    }, [_vm._v("\n          " + _vm._s(_vm.i18n['approved']) + "\n        ")]) : _vm._e(), _vm._v(" "), (request.state === 'rejected') ? _c('div', {
	      staticClass: "d-bagde"
	    }, [_vm._v("\n          " + _vm._s(_vm.i18n['rejected']) + "\n        ")]) : _vm._e()])])
	  })], 2)]), _vm._v(" "), (_vm.theAnswerRequest) ? _c('UserRequestListAnswer', {
	    attrs: {
	      "request": _vm.theAnswerRequest
	    },
	    on: {
	      "submitted": _vm.onSubmittedAnswer,
	      "close": _vm.onCloseAnswerRequest
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theEditRequest) ? _c('UserRequestForm', {
	    attrs: {
	      "editRequest": _vm.theEditRequest
	    },
	    on: {
	      "submitted": _vm.onSubmittedAnswer,
	      "close": function($event) {
	        _vm.theEditRequest = null
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1894 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "relative"
	  }, [_c('div', {
	    staticClass: "week-picker__content flex"
	  }, [_c('div', {
	    staticClass: "content"
	  }, _vm._l((_vm.weeks), function(week, index) {
	    return _c('div', {
	      directives: [{
	        name: "tooltip",
	        rawName: "v-tooltip"
	      }],
	      key: week.serverDate,
	      staticClass: "number hint--top",
	      class: [{
	        'isSelected': week.isSelected
	      }, {
	        'isCopyWeek': week.isCopyWeek
	      }],
	      attrs: {
	        "aria-label": _vm._f("tooltipDate")(week.date)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleWeek(index)
	        }
	      }
	    }, [_c('span', {
	      class: {
	        'isNow': week.isNow
	      }
	    }, [_vm._v("\n            " + _vm._s(week.weekNum) + "\n          ")])])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "sortcuts"
	  }, [(!_vm.calid) ? _c('select', {
	    staticClass: "copy-week-picker-school-year-selector",
	    domProps: {
	      "value": _vm.activeSchoolYear.id
	    },
	    on: {
	      "change": _vm.setActiveSchoolYear
	    }
	  }, _vm._l((_vm.activeSchoolYears), function(year) {
	    return _c('option', {
	      key: year.id,
	      domProps: {
	        "value": year.id
	      }
	    }, [_vm._v("\n          " + _vm._s(year.name) + "\n        ")])
	  }), 0) : _vm._e(), _vm._v(" "), _c('ul', [_c('li', {
	    staticClass: "sortcuts__headline"
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.markWeeksFrom')) + "\n            "), _c('div', {
	    staticClass: "no-tag",
	    class: {
	      'tag': !_vm.showStartPasteWeek
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm._f("week")(_vm.startPasteWeek)) + "\n              "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.showStartPasteWeek),
	      expression: "!showStartPasteWeek"
	    }],
	    staticClass: "icon-cross2 pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.eraseStartDate.apply(null, arguments)
	      }
	    }
	  })])])]), _c('li', [_c('span', {
	    staticClass: "sortcut__clickable",
	    on: {
	      "click": _vm.selectAll
	    }
	  }, [_c('span', {
	    staticClass: "bttn width-100 btn-trans"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.allWeeks')) + "\n                ")])])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "sortcut__clickable",
	    on: {
	      "click": _vm.selectOddWeeks
	    }
	  }, [_c('span', {
	    staticClass: "bttn width-100 btn-trans"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.oddWeeks')) + "\n               ")])])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "sortcut__clickable",
	    on: {
	      "click": _vm.selectEvenWeeks
	    }
	  }, [_c('span', {
	    staticClass: "bttn width-100 btn-trans"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.evenWeeks')) + "\n               ")])])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "sortcut__clickable",
	    on: {
	      "click": _vm.removeAllSelectedWeeks
	    }
	  }, [_c('span', {
	    staticClass: "bttn btn-trans width-100 btn-remove"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.unselectAll')) + "\n               ")])])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1895 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-app__cal__nav"
	  }, [_c('div', {
	    staticClass: "d-app__cal__nav__btn",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.$emit('prev')
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M15.75 19.5L8.25 12l7.5-7.5"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-app__cal__nav__btn d-app__cal__nav__btn__center",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.$emit('today')
	      }
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('repitition.today')) + "\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-app__cal__nav__btn",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.$emit('next')
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M8.25 4.5l7.5 7.5-7.5 7.5"
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 1896 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "d-table marg-1-bottom d-table__overview"
	  }, [_c('thead', [_c('tr', [_vm._m(0), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.work_hours')))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        animateFill: false,
	        animation: 'shift-away',
	        onShow: function () { return _vm.isDateIntervalChanged; }
	      }),
	      expression: "{\n          animateFill: false,\n          animation : 'shift-away',\n        onShow: () => isDateIntervalChanged\n      }"
	    }],
	    staticClass: "is-number",
	    class: {
	      'is-number--calculated': _vm.isDateIntervalChanged
	    },
	    attrs: {
	      "content": _vm.tooltipContent
	    }
	  }, [(_vm.isDateIntervalChanged) ? _c('span', {
	    staticClass: "icon-clock"
	  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.assignedTotalHoursForPeriod) + "\n    ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_total_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator(_vm.diffTotalHoursForPeriod))
	  }, [_vm._v("\n      " + _vm._s(_vm.diffTotalHoursForPeriod) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Med børn")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        animateFill: false,
	        animation: 'shift-away',
	        onShow: function () { return _vm.isDateIntervalChanged; }
	      }),
	      expression: "{\n          animateFill: false,\n          animation : 'shift-away',\n        onShow: () => isDateIntervalChanged\n      }"
	    }],
	    staticClass: "is-number",
	    class: {
	      'is-number--calculated': _vm.isDateIntervalChanged
	    },
	    attrs: {
	      "content": _vm.createTooltip(_vm.assignedHoursWithKids)
	    }
	  }, [(_vm.isDateIntervalChanged) ? _c('span', {
	    staticClass: "icon-clock"
	  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.assignedHoursWithKidsInPeriod) + "\n    ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.userActualWithKids))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator(_vm.diffHoursWithKidsForPeriod))
	  }, [_vm._v(_vm._s(_vm.diffHoursWithKidsForPeriod))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Uden børn")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        animateFill: false,
	        animation: 'shift-away',
	        onShow: function () { return _vm.isDateIntervalChanged; }
	      }),
	      expression: "{\n          animateFill: false,\n          animation : 'shift-away',\n        onShow: () => isDateIntervalChanged\n      }"
	    }],
	    staticClass: "is-number",
	    class: {
	      'is-number--calculated': _vm.isDateIntervalChanged
	    },
	    attrs: {
	      "content": _vm.createTooltip(_vm.assignedHoursWithoutKids)
	    }
	  }, [(_vm.isDateIntervalChanged) ? _c('span', {
	    staticClass: "icon-clock"
	  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.assignedHoursWithoutKidsInPeriod) + "\n    ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.userActualWithoutKids))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator(_vm.diffHoursWithoutKidsForPeriod))
	  }, [_vm._v(_vm._s(_vm.diffHoursWithoutKidsForPeriod))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Med børn + Uden børn")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        animateFill: false,
	        animation: 'shift-away',
	        onShow: function () { return _vm.isDateIntervalChanged; }
	      }),
	      expression: "{\n          animateFill: false,\n          animation : 'shift-away',\n        onShow: () => isDateIntervalChanged\n      }"
	    }],
	    staticClass: "is-number",
	    class: {
	      'is-number--calculated': _vm.isDateIntervalChanged
	    },
	    attrs: {
	      "content": _vm.tooltipContent
	    }
	  }, [(_vm.isDateIntervalChanged) ? _c('span', {
	    staticClass: "icon-clock"
	  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.assignedTotalHoursForPeriod) + "\n    ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.userWithKidsAndWithout))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator(_vm.userDiffWithKidsAndWithout))
	  }, [_vm._v("\n      " + _vm._s(_vm.userDiffWithKidsAndWithout) + "\n    ")]) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', [_c('h4', [_vm._v("Oversigt")])])
	}]}

/***/ }),
/* 1897 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sd-faste-tillaeg text-dark"
	  }, [_c('h2', {
	    staticClass: "marg-1-bottom capitalize"
	  }, [_vm._v("Faste tillæg")]), _vm._v(" "), (_vm.isNoConfiguration) ? [_vm._m(0)] : [_c('div', {
	    staticClass: "sd-faste-tillaeg__header"
	  }, [_c('div', {
	    staticClass: "sd-faste-tillaeg__header__left"
	  }, [_c('Tabs', {
	    attrs: {
	      "tabs": _vm.viewTabs,
	      "selected": _vm.viewTab
	    },
	    on: {
	      "select": _vm.onSelectViewTab
	    }
	  }), _vm._v(" "), (_vm.viewTab === 'employments') ? [_c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Personer',
	      "tags": _vm.personNames,
	      "selectedTags": _vm.selectedPersonNames,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg personer'
	    },
	    on: {
	      "select": _vm.togglePersonName,
	      "clear": function($event) {
	        _vm.selectedPersonNames = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Grupper',
	      "tags": _vm.userTags,
	      "selectedTags": _vm.selectedUserTags,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg grupper'
	    },
	    on: {
	      "select": _vm.toggleUserTag,
	      "clear": function($event) {
	        _vm.selectedUserTags = []
	      }
	    }
	  }), _vm._v(" "), (_vm.employmentTitles.length > 1) ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Ansættelser',
	      "tags": _vm.employmentTitles,
	      "selectedTags": _vm.selectedEmploymentTitles,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg stilling'
	    },
	    on: {
	      "select": _vm.toggleEmploymentTitle,
	      "clear": function($event) {
	        _vm.selectedEmploymentTitles = []
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.organisations.length > 1) ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Organisationer',
	      "tags": _vm.organisations,
	      "selectedTags": _vm.selectedOrganisations,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg organisation'
	    },
	    on: {
	      "select": _vm.toggleOrganisation,
	      "clear": function($event) {
	        _vm.selectedOrganisations = []
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "sd-faste-tillaeg__count"
	  }, [_vm._v("\n            Viser " + _vm._s(_vm.filteredRows.length) + " af " + _vm._s(_vm.allRows.length) + " ansættelser\n          ")])] : [_c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Personer',
	      "tags": _vm.uniqueNames,
	      "selectedTags": _vm.selectedNames,
	      "numberOfSelectedTagsToShow": 2,
	      "placeholder": 'Vælg personer'
	    },
	    on: {
	      "select": _vm.toggleName,
	      "clear": function($event) {
	        _vm.selectedNames = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Lønkode',
	      "tags": _vm.uniqueTillaeg,
	      "selectedTags": _vm.selectedTillaeg,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg lønkode'
	    },
	    on: {
	      "select": _vm.toggleTillaeg,
	      "clear": function($event) {
	        _vm.selectedTillaeg = []
	      }
	    }
	  })]], 2), _vm._v(" "), (_vm.viewTab !== 'employments') ? _c('div', {
	    staticClass: "sd-faste-tillaeg__header__right"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--small",
	    attrs: {
	      "disabled": _vm.isLoading
	    },
	    on: {
	      "click": _vm.readTillaeger
	    }
	  }, [_vm._v("\n          Opdater\n        ")])]) : _vm._e()]), _vm._v(" "), (_vm.viewTab === 'employments') ? _c('div', {
	    staticClass: "sd-faste-tillaeg__toolbar"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'top',
	        animateFill: false,
	        animation: 'shift-away',
	        boundary: 'window'
	      }),
	      expression: "{\n              arrow: true,\n              placement: 'top',\n              animateFill: false,\n              animation: 'shift-away',\n              boundary: 'window'\n            }"
	    }],
	    staticClass: "sd-faste-tillaeg__toolbar__wrap",
	    attrs: {
	      "content": _vm.selectedEmploymentIds.length === 0 ? 'Vælg personer først' : ''
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': _vm.selectedEmploymentIds.length === 0
	    },
	    attrs: {
	      "disabled": _vm.selectedEmploymentIds.length === 0
	    },
	    on: {
	      "click": _vm.openBulkCreate
	    }
	  }, [_vm._v("\n          Opret faste tillæg\n        ")])]), _vm._v(" "), _c('DDropdown', {
	    attrs: {
	      "isBottomStart": true,
	      "isShowDots": false,
	      "propOffset": [0, 8]
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    staticStyle: {
	      "font-size": "11px"
	    },
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("\n          Beregn tillæg automatisk "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "beregn-menu",
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, _vm._l((_vm.visibleBeregnOptions), function(option) {
	    return _c('li', {
	      key: option.id,
	      on: {
	        "click": function($event) {
	          return _vm.selectBeregnOption(option)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(option.label) + "\n          ")])
	  }), 0)]), _vm._v(" "), (_vm.selectedEmploymentIds.length > 0) ? _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.cancelBatchMode
	    }
	  }, [_vm._v("Annuller valg")]) : _vm._e(), _vm._v(" "), (_vm.selectedEmploymentIds.length > 0) ? _c('span', {
	    staticClass: "sd-faste-tillaeg__count"
	  }, [_vm._v("\n        " + _vm._s(_vm.selectedEmploymentIds.length) + " valgt\n      ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.viewTab === 'outbox') ? _c('div', {
	    staticClass: "sd-faste-tillaeg__info"
	  }, [_vm._v("\n      Faste tillæg i udbakken sendes automatisk til SD senere på dagen. Du kan slette dem, så længe de ligger her.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "sd-faste-tillaeg__body"
	  }, [(_vm.viewTab === 'employments') ? [(_vm.isLoadingEmployments) ? _c('Loader') : _c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "td-check do-table__toggle-all",
	    on: {
	      "click": _vm.toggleAllSelected
	    }
	  }, [_c('div', {
	    staticClass: "do-checkbox",
	    class: {
	      'do-checkbox--selected': _vm.isAllFilteredSelected
	    }
	  })]), _vm._v(" "), _c('th', [_vm._v("NAVN")]), _vm._v(" "), _c('th', [_vm._v("ANSÆTTELSE")]), _vm._v(" "), _c('th', [_vm._v("ORGANISATION")]), _vm._v(" "), _c('th', {
	    staticClass: "th-row-actions"
	  })])]), _vm._v(" "), (_vm.filteredRows.length === 0) ? _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": 5
	    }
	  }, [_vm._v("Ingen ansættelser fundet")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.groupedRows), function(group) {
	    return _c('tbody', {
	      key: group.userId,
	      staticClass: "user-group"
	    }, _vm._l((group.rows), function(row) {
	      return _c('tr', {
	        key: row.id,
	        staticClass: "fast-tillaeg-row",
	        class: {
	          'is-selected': _vm.isRowSelected(row)
	        },
	        on: {
	          "click": function($event) {
	            return _vm.onRowClick(row)
	          }
	        }
	      }, [_c('td', {
	        staticClass: "td-check",
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.onCheckboxClick(row)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "do-checkbox",
	        class: {
	          'do-checkbox--selected': _vm.isRowSelected(row)
	        }
	      })]), _vm._v(" "), _c('td', {
	        staticClass: "bold"
	      }, [_vm._v(_vm._s(row.userName))]), _vm._v(" "), _c('td', {
	        staticClass: "td-organisation"
	      }, [_vm._v("\n              " + _vm._s(row.employmentNumber) + " - " + _vm._s(row.employmentTitle) + "\n            ")]), _vm._v(" "), _c('td', {
	        staticClass: "td-organisation"
	      }, [_vm._v(_vm._s(row.organisation))]), _vm._v(" "), _c('td', {
	        staticClass: "td-row-actions"
	      }, [(!_vm.isBatchMode) ? _c('button', {
	        staticClass: "do-bttn do-bttn--small row-action-btn",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.openSingleCreate(row)
	          }
	        }
	      }, [_vm._v("Opret fast tillæg")]) : _vm._e()])])
	    }), 0)
	  })], 2)] : [(_vm.isLoading) ? _c('Loader') : _c('table', {
	    staticClass: "do-table do-table--striped"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "sortable td-created",
	    on: {
	      "click": function($event) {
	        return _vm.sortEntries('created_at')
	      }
	    }
	  }, [_vm._v("OPRETTET "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "sortable",
	    on: {
	      "click": function($event) {
	        return _vm.sortEntries('user')
	      }
	    }
	  }, [_vm._v("NAVN "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "sortable",
	    on: {
	      "click": function($event) {
	        return _vm.sortEntries('employment')
	      }
	    }
	  }, [_vm._v("ANSÆTTELSE "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "sortable",
	    on: {
	      "click": function($event) {
	        return _vm.sortEntries('tillaeg')
	      }
	    }
	  }, [_vm._v("TILLÆG "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "sortable td-units",
	    on: {
	      "click": function($event) {
	        return _vm.sortEntries('antal')
	      }
	    }
	  }, [_vm._v("ANTAL "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "sortable td-date",
	    on: {
	      "click": function($event) {
	        return _vm.sortEntries('fra')
	      }
	    }
	  }, [_vm._v("FRA "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "sortable td-date",
	    on: {
	      "click": function($event) {
	        return _vm.sortEntries('til')
	      }
	    }
	  }, [_vm._v("TIL "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "sortable td-created-by",
	    on: {
	      "click": function($event) {
	        return _vm.sortEntries('created_by')
	      }
	    }
	  }, [_vm._v("OPRETTET AF "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "sortable td-status",
	    on: {
	      "click": function($event) {
	        return _vm.sortEntries('state')
	      }
	    }
	  }, [_vm._v("STATUS "), _c('span', {
	    staticClass: "icon-menu-open sort-icon"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-actions"
	  })])]), _vm._v(" "), _c('tbody', [(_vm.displayedPairs.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": 10
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.viewTab === 'outbox' ? 'Udbakken er tom' : 'Ingen afsendte faste tillæg') + "\n            ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayedPairs), function(pair) {
	    return _c('tr', {
	      key: pair.vRowKey,
	      staticClass: "tillaeg-row"
	    }, [_c('td', {
	      staticClass: "td-created"
	    }, [_vm._v(_vm._s(pair.vCreatedAt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pair.vUserName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pair.vEmploymentNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pair.vTillaeg))]), _vm._v(" "), _c('td', {
	      staticClass: "td-units"
	    }, [_vm._v(_vm._s(pair.vEnheder))]), _vm._v(" "), _c('td', {
	      staticClass: "td-date"
	    }, [_vm._v(_vm._s(pair.vFraDato))]), _vm._v(" "), _c('td', {
	      staticClass: "td-date"
	    }, [_vm._v(_vm._s(pair.vTilDato))]), _vm._v(" "), _c('td', {
	      staticClass: "td-created-by"
	    }, [_vm._v(_vm._s(pair.vCreatedBy))]), _vm._v(" "), _c('td', {
	      staticClass: "td-status"
	    }, [_c('span', {
	      staticClass: "status-pill",
	      class: 'status-pill--' + pair.state
	    }, [_vm._v(_vm._s(_vm.stateLabel(pair.state)))])]), _vm._v(" "), _c('td', {
	      staticClass: "td-actions"
	    }, [(_vm.viewTab === 'outbox' && pair.can_delete) ? _c('button', {
	      staticClass: "do-bttn do-bttn--small do-bttn--danger",
	      attrs: {
	        "disabled": _vm.isDeleting(pair)
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.deletePair(pair)
	        }
	      }
	    }, [_vm._v("\n                Slet\n              ")]) : _vm._e()])])
	  })], 2)])]], 2)], _vm._v(" "), (_vm.createEmploymentIds.length > 0) ? _c('SdCreateFastTillaeg', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "employmentIds": _vm.createEmploymentIds,
	      "subtitle": _vm.createSubtitle
	    },
	    on: {
	      "created": _vm.onCreated,
	      "close": _vm.closeCreate
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowTidsbegraenset) ? _c('TidsbegraensetUvModal', {
	    on: {
	      "created": function($event) {
	        _vm.isShowTidsbegraenset = false
	      },
	      "close": function($event) {
	        _vm.isShowTidsbegraenset = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowBeregnModal) ? _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312313"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "isCloseOnBgClick": false,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": _vm.closeBeregnModal
	    }
	  }, [_c('div', {
	    staticClass: "beregn-modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "beregn-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.beregnModalTitle))]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle beregn-modal__close",
	    on: {
	      "click": _vm.closeBeregnModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "beregn-modal__content"
	  }, [_c('Supplements', {
	    attrs: {
	      "isInOpusModal": true,
	      "beregningType": _vm.beregnType,
	      "sendToOpusTrigger": _vm.sendToSdTrigger
	    },
	    on: {
	      "approveState": function($event) {
	        _vm.sdApproveState = $event
	      }
	    }
	  })], 1), _vm._v(" "), (_vm.sdApproveState.canApprove) ? _c('div', {
	    staticClass: "beregn-modal__footer"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'top',
	        animateFill: false,
	        animation: 'shift-away',
	        boundary: 'window',
	        onShow: function () { return _vm.sendToSdTooltip !== ''; }
	      }),
	      expression: "{\n                arrow: true,\n                placement: 'top',\n                animateFill: false,\n                animation: 'shift-away',\n                boundary: 'window',\n                onShow: () => sendToSdTooltip !== ''\n              }"
	    }],
	    staticClass: "send-to-sd-wrap",
	    attrs: {
	      "content": _vm.sendToSdTooltip
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.sdApproveState.isApproving,
	      'do-bttn--submit--disabled': _vm.sdApproveState.count === 0 || _vm.sdApproveState.missingEmployment
	    },
	    attrs: {
	      "disabled": _vm.sdApproveState.isApproving || _vm.sdApproveState.count === 0 || _vm.sdApproveState.missingEmployment
	    },
	    on: {
	      "click": _vm.triggerSendToSd
	    }
	  }, [_vm._v("\n            Send til SD\n          ")])])]) : _vm._e()])]) : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sd-faste-tillaeg-no-config"
	  }, [_c('h2', [_c('i', [_vm._v("Skolens Silkeborg Data-integration er ikke konfigureret korrekt. Kontakt Docendo for at få hjælp til\n          opsætningen - enten på chat eller email.")])])])
	}]}

/***/ }),
/* 1898 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "showClose": false,
	      "isBgOverlay": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__header__right"
	  }, [_c('button', {
	    staticClass: "do-bttn no-print",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle no-print",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content",
	    attrs: {
	      "id": "printUserSalaryTable"
	    }
	  }, [_c('h4', {
	    staticClass: "only-print"
	  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('div', {
	    staticClass: "salarySubsPerfUserTable"
	  }, _vm._l((_vm.tablesSorted), function(table) {
	    return _c('div', {
	      key: table.rowKey
	    }, [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                                  onShow: hideTippy,\n                                  trigger: 'manual',\n                                  arrow: true,\n                                  placement : 'top',\n                                  zIndex: 2147483010\n                                }"
	      }],
	      staticClass: "do-bttn do-bttn--custom-height do-copy-bttn no-print marg-1-bottom width-100",
	      attrs: {
	        "content": 'Kopieret tabel for ' + table.title
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyTableDayCounts(table, $event)
	        }
	      }
	    }, [_vm._v("\n            Kopier tabel for "), _c('br'), _vm._v(" " + _vm._s(table.title) + "\n          ")]), _vm._v(" "), _c('table', {
	      staticClass: "d-table"
	    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(table.title))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(table.minutes))])])]), _vm._v(" "), _c('tbody', _vm._l((table.dates), function(date, index) {
	      return _c('tr', {
	        key: index
	      }, [_c('td', [_vm._v(_vm._s(date.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(date.dayCount))])])
	    }), 0)])])
	  }), 0)])])])
	},staticRenderFns: []}

/***/ }),
/* 1899 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "task-overview-settings__tasks"
	  }, [(_vm.isInitLoad) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : [_c('div', {
	    staticClass: "do-table__filters"
	  }, [_c('div', {
	    staticClass: "do-table__filters__left"
	  }, [_c('DoFiltersFilter', {
	    attrs: {
	      "title": "Personer",
	      "tags": _vm.persons,
	      "selectedTags": _vm.selectedPersons,
	      "numberOfSelectedTagsToShow": 1
	    },
	    on: {
	      "select": _vm.onSelectPerson,
	      "clear": function($event) {
	        _vm.selectedPersons = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": "Grupper",
	      "tags": _vm.tags,
	      "selectedTags": _vm.selectedTags,
	      "numberOfSelectedTagsToShow": 1
	    },
	    on: {
	      "select": _vm.onSelectTags,
	      "clear": function($event) {
	        _vm.selectedTags = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": "Briktyper",
	      "tags": _vm.subjectTypes,
	      "selectedTags": _vm.selectedTypes,
	      "numberOfSelectedTagsToShow": 1
	    },
	    on: {
	      "select": _vm.onSelectType,
	      "clear": function($event) {
	        _vm.selectedTypes = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": "Fag/Opgaver",
	      "tags": _vm.subjectNames,
	      "selectedTags": _vm.selectedSubjectsNames,
	      "numberOfSelectedTagsToShow": 1
	    },
	    on: {
	      "select": _vm.onSelectSubject,
	      "clear": function($event) {
	        _vm.selectedSubjectsNames = []
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-table__filters__add"
	  }, [_c('span', [_vm._v("Viser " + _vm._s(_vm.filteredSubjects.length) + " af " + _vm._s(_vm.subjects.length))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickAway),
	      expression: "onClickAway"
	    }],
	    staticClass: "do-dropdown",
	    class: {
	      'do-dropdown--open': _vm.isDropdown
	    }
	  }, [(_vm.selectedSubjects.length < 1) ? _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'left',
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window'
	      }),
	      expression: "{\n                  placement: 'left',\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n              }"
	    }],
	    staticClass: "do-dropdown__toggler do-bttn do-bttn--submit do-bttn--submit--disabled",
	    attrs: {
	      "content": "Vælg brikker først"
	    }
	  }, [_vm._v("\n            Tildel " + _vm._s(!_vm.isSupplements ? 'kategori' : 'lønkode') + " til " + _vm._s(_vm.selectedSubjects.length) + " "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]) : _c('button', {
	    staticClass: "do-dropdown__toggler do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.setIsDropdown
	    }
	  }, [_vm._v("\n            Tildel " + _vm._s(!_vm.isSupplements ? 'kategori' : 'lønkode') + " til " + _vm._s(_vm.selectedSubjects.length) + " "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "do-dropdown"
	    }
	  }, [(_vm.isDropdown) ? _c('div', {
	    staticClass: "do-dropdown__dropdown"
	  }, [(!_vm.isSupplements) ? _c('ul', [(_vm.taskCategories.length === 0) ? _c('li', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen kategorier oprettet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.taskCategories), function(taskCategory, key) {
	    return _c('li', {
	      staticClass: "do-dropdown__dropdown__item",
	      on: {
	        "click": function($event) {
	          return _vm.setTasksCategory(taskCategory)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "do-dropdown__dropdown__item__name"
	    }, [_vm._v("\n                    " + _vm._s(taskCategory.name) + "\n                  ")])])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.isSupplements) ? _c('ul', [(_vm.salaryCodes.length === 0) ? _c('li', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen lønkoder oprettet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.salaryCodes), function(salaryCode, key) {
	    return _c('li', {
	      staticClass: "do-dropdown__dropdown__item",
	      on: {
	        "click": function($event) {
	          return _vm.setTasksCategory(salaryCode)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "do-dropdown__dropdown__item__name"
	    }, [_vm._v("\n                    " + _vm._s(salaryCode.vSupplementTitle) + "\n                  ")])])
	  })], 2) : _vm._e()]) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "do-table-wrapper"
	  }, [_c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "do-table__toggle-all",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.selectedSubjects.length === 0) ? [_vm._v("\n              " + _vm._s(_vm.$t('vue2.tagging.select_all')) + "\n            ")] : [_vm._v("\n              Fravælg\n            ")]], 2), _vm._v(" "), _c('th', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('subject.name')
	      }
	    }
	  }, [_vm._v("Titel "), (_vm.sortKey === 'subject.name') ? _c('span', [_vm._v(_vm._s(_vm.sortIcon))]) : _vm._e()]), _vm._v(" "), (!_vm.isSupplements) ? _c('th', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('calendar.name')
	      }
	    }
	  }, [_vm._v("Person "), (_vm.sortKey === 'calendar.name') ? _c('span', [_vm._v(_vm._s(_vm.sortIcon))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('subject.calendar.name')
	      }
	    }
	  }, [_vm._v("Klasse / kalender "), (_vm.sortKey === 'subject.calendar.name') ? _c('span', {
	    staticClass: "pointer"
	  }, [_vm._v(_vm._s(_vm.sortIcon))]) : _vm._e()]), _vm._v(" "), _c('th', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('v_type')
	      }
	    }
	  }, [_vm._v("Briktype "), (_vm.sortKey === 'v_type') ? _c('span', [_vm._v(_vm._s(_vm.sortIcon))]) : _vm._e()]), _vm._v(" "), (_vm.isSupplements) ? _c('th', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('calendar.name')
	      }
	    }
	  }, [_vm._v("Person "), (_vm.sortKey === 'calendar.name') ? _c('span', [_vm._v(_vm._s(_vm.sortIcon))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isSupplements) ? _c('th', [_vm._v("Standard kategori")]) : _vm._e(), _vm._v(" "), (!_vm.isSupplements) ? _c('th', [_vm._v("Egen kategori")]) : _vm._e(), _vm._v(" "), (_vm.isSupplements) ? _c('th', [_vm._v("Lønkode")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('virtual-list', {
	    style: ({
	      maxHeight: 80 + 'vh',
	      overflowY: 'auto'
	    }),
	    attrs: {
	      "estimate-size": 40,
	      "keeps": 40,
	      "data-key": 'id',
	      "data-sources": _vm.sortedSubjects,
	      "data-component": _vm.itemComponent,
	      "extra-props": {
	        selectedSubjectIds: _vm.selectedSubjectIds,
	        selectedSubjects: _vm.selectedSubjects,
	        taskCategories: _vm.taskCategories,
	        toggleSubject: _vm.toggleSubject,
	        updateSubjectTaskCategory: _vm.updateSubjectTaskCategory,
	        isSupplements: _vm.isSupplements,
	        salaryCodes: _vm.salaryCodes
	      }
	    }
	  })], 1)])])]], 2)
	},staticRenderFns: []}

/***/ }),
/* 1900 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "now-marker",
	    style: ({
	      top: _vm.top + 'px'
	    })
	  })
	},staticRenderFns: []}

/***/ }),
/* 1901 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickAway),
	      expression: "onClickAway"
	    }],
	    staticClass: "do-dropdown",
	    class: {
	      'do-dropdown--open': _vm.isOpen
	    }
	  }, [_c('button', {
	    staticClass: "do-dropdown__toggler do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': _vm.isDisabled
	    },
	    attrs: {
	      "disabled": _vm.isDisabled
	    },
	    on: {
	      "click": _vm.toggleOpen
	    }
	  }, [_vm._v("\n    Tilføj stillingskategori "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "do-dropdown"
	    }
	  }, [(_vm.isOpen) ? _c('div', {
	    staticClass: "do-dropdown__dropdown"
	  }, [_c('ul', [_vm._l((_vm.employmentTypes), function(employmentType) {
	    return _c('li', {
	      key: employmentType.id,
	      staticClass: "do-dropdown__dropdown__item",
	      on: {
	        "click": function($event) {
	          return _vm.selectEmploymentType(employmentType)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "do-dropdown__dropdown__item__name"
	    }, [(employmentType.manual_salary) ? _c('span', {
	      staticClass: "icon-users"
	    }) : _c('span', {
	      staticClass: "icon-user"
	    }), _vm._v("\n            " + _vm._s(employmentType.title) + "\n          ")]), _vm._v(" "), _c('div', {
	      staticClass: "icon__bg-circle",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.openEdit(employmentType)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-pencil"
	    })])])
	  }), _vm._v(" "), _c('li', {
	    staticClass: "do-dropdown__dropdown__item do-dropdown__dropdown__item--add",
	    on: {
	      "click": function($event) {
	        return _vm.setTemplateModalOpen(true)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "btn-trans"
	  }, [_vm._v("\n            " + _vm._s(_vm.createNewTitleText) + "\n          ")])])], 2)]) : _vm._e()]), _vm._v(" "), (_vm.isTemplateModalOpen) ? _c('DoEmploymentTemplate', {
	    attrs: {
	      "theEditEmploymentTemplate": _vm.editTemplate
	    },
	    on: {
	      "created": function($event) {
	        return _vm.$emit('onTemplateCreated')
	      },
	      "updated": function($event) {
	        return _vm.$emit('onTemplateUpdated')
	      },
	      "deleted": function($event) {
	        return _vm.$emit('onTemplateDeleted')
	      },
	      "close": _vm.closeTemplateModal
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1902 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "school-data"
	  }, [_c('div', {
	    staticClass: "school-data__header"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "school-data__header__right"
	  }, [_c('Datepickerrange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.readEvents
	    }
	  }, [_vm._v("Søg")])], 1)]), _vm._v(" "), (!_vm.isReadEventsClick) ? _c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Vælg datoer og klik \"Søg\"")]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
	    staticClass: "loader-container"
	  }, [_c('Loader'), _vm._v(" "), _c('h4', [_vm._v("Henter lektioner fra en længere periode - det kan tage et par minutter")])], 1) : _vm._e(), _vm._v(" "), (_vm.isReadEventsClick && !_vm.isLoading) ? [(_vm.subEventsWithAbsenceType.length < 1) ? _c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Der er ingen vikartimer i perioden")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedAbsenceTypesWithLessons), function(absenceType, prop) {
	    return _c('table', {
	      staticClass: "d-acc-body-table",
	      class: {
	        'd-acc-body-table--open': absenceType['isOpen']
	      }
	    }, [_c('thead', {
	      staticClass: "d-acc-body-table__first__header",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveAcc(prop, absenceType)
	        }
	      }
	    }, [_c('tr', [_c('th', {
	      attrs: {
	        "colspan": "3"
	      }
	    }, [_vm._v(_vm._s(prop) + ": " + _vm._s(absenceType['formattedDuration']))])])]), _vm._v(" "), (_vm.theActiveAcc === prop) ? _c('thead', {
	      staticClass: "d-acc-body-table__second__header"
	    }, [_c('tr', _vm._l((_vm.sortColumns), function(column) {
	      return _c('th', {
	        key: column.key,
	        staticClass: "th-sorter",
	        class: {
	          'th-sorter--active': _vm.sortKey === column.key
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setSortKey(column.key)
	          }
	        }
	      }, [_vm._v("\n          " + _vm._s(column.label) + "\n          "), (_vm.sortKey === column.key) ? _c('span', [_vm._v(_vm._s(_vm.sortOrder === 1 ? '▲' : '▼'))]) : _vm._e()])
	    }), 0)]) : _vm._e(), _vm._v(" "), (_vm.theActiveAcc === prop) ? _c('tbody', _vm._l((_vm.sortLessons(absenceType['lessons'])), function(lesson) {
	      return _c('tr', {
	        key: lesson.id
	      }, [_c('td', [_vm._v(_vm._s(lesson.vTimestamp) + ", " + _vm._s(lesson.title) + ", " + _vm._s(lesson.vKlasses))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(lesson.substitute))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(lesson.substituteFor))])])
	    }), 0) : _vm._e()])
	  })] : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "school-data__header__left"
	  }, [_c('h1', [_vm._v("Vikartimer ift. Fraværstyper")])])
	}]}

/***/ }),
/* 1903 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal--full-width text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.closeFilters.apply(null, arguments)
	      }
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Se og rediger UV-grænser")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "isLoaderModal": true
	    }
	  }) : [_c('div', {
	    staticClass: "uv-limits__toolbar"
	  }, [_c('div', {
	    staticClass: "uv-limits__filters",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('Tabs', {
	    staticClass: "uv-limits__tabs",
	    attrs: {
	      "tabs": [{
	          id: 'all',
	          title: 'Alle'
	        },
	        {
	          id: 'with',
	          title: 'Med UV-grænse (' + _vm.rowsWithTemplate + ')'
	        },
	        {
	          id: 'without',
	          title: 'Uden UV-grænse (' + _vm.rowsWithoutTemplate + ')'
	        }
	      ],
	      "selected": _vm.templateTab
	    },
	    on: {
	      "select": function($event) {
	        _vm.templateTab = $event
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Personer',
	      "tags": _vm.uniqueNames,
	      "selectedTags": _vm.selectedNames,
	      "closeFromProp": _vm.closeFiltersCount,
	      "numberOfSelectedTagsToShow": 4,
	      "placeholder": 'Vælg personer'
	    },
	    on: {
	      "select": _vm.toggleName,
	      "clear": _vm.clearNames
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Grupper',
	      "tags": _vm.uniqueGroups,
	      "selectedTags": _vm.selectedGroups,
	      "closeFromProp": _vm.closeFiltersCount,
	      "numberOfSelectedTagsToShow": 4,
	      "placeholder": 'Vælg grupper'
	    },
	    on: {
	      "select": _vm.toggleGroup,
	      "clear": _vm.clearGroups
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Ansættelse',
	      "tags": _vm.uniqueEmploymentTitles,
	      "selectedTags": _vm.selectedEmploymentTitles,
	      "closeFromProp": _vm.closeFiltersCount,
	      "numberOfSelectedTagsToShow": 4,
	      "placeholder": 'Vælg ansættelser'
	    },
	    on: {
	      "select": _vm.toggleEmploymentTitle,
	      "clear": _vm.clearEmploymentTitles
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "uv-limits__bulk-bar"
	  }, [_c('div', {
	    staticClass: "uv-limits__bulk-bar-left"
	  }, [(!_vm.isBulkMode) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.enableBulkMode
	    }
	  }, [_vm._v("\n            Tildel stillingskategori til flere\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.isBulkMode) ? _c('span', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "propOffset": [0, 8],
	      "isBottomStart": false,
	      "isCloseOnDropdownClick": true,
	      "closeFromProp": _vm.closeFiltersCount
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn uv-limits__edit-templates-bttn",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("\n                Rediger stillingskategorier\n                "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "uv-limits__templates-dropdown",
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('ul', {
	    staticClass: "uv-limits__templates-dropdown__list"
	  }, [(_vm.employmentTemplates.length === 0) ? _c('li', {
	    staticClass: "italic"
	  }, [_vm._v("Ingen stillingskategorier oprettet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.employmentTemplates), function(template) {
	    return _c('li', {
	      key: template.id,
	      staticClass: "uv-limits__templates-dropdown__item",
	      on: {
	        "click": function($event) {
	          return _vm.openEditTemplate(template)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "uv-limits__templates-dropdown__item-title"
	    }, [_vm._v("\n                      " + _vm._s(template.title) + "\n                      "), _c('span', {
	      staticClass: "uv-limits__templates-dropdown__item-limit"
	    }, [_vm._v("\n                        UV-grænse: " + _vm._s(template.hour_limit ? template.hour_limit : '—') + "\n                      ")])]), _vm._v(" "), _c('div', {
	      staticClass: "icon__bg-circle",
	      attrs: {
	        "title": "Redigér UV-grænse og lønkode"
	      }
	    }, [_c('span', {
	      staticClass: "icon-pencil"
	    })])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "uv-limits__templates-dropdown__create",
	    on: {
	      "click": _vm.openCreateTemplate
	    }
	  }, [_c('div', {
	    staticClass: "btn-trans"
	  }, [_vm._v("\n                    Opret stillingskategori\n                  ")])])])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isBulkMode) ? _c('p', {
	    staticClass: "text-explainer uv-limits__explainer"
	  }, [_vm._v("\n            UV-grænser og lønkoder sættes på stillingskategorierne. UV-timer vises fra tildelt undervisning.\n          ")]) : [_c('span', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.selectedCount) + " valgt")]), _vm._v(" "), (_vm.selectedCount > 0) ? _c('span', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "propOffset": [0, 8],
	      "isBottomStart": true,
	      "isCloseOnDropdownClick": true,
	      "closeFromProp": _vm.closeFiltersCount
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit uv-limits__bulk-submit-bttn",
	    class: {
	      'do-bttn--submit--loading': _vm.isSavingBulkTemplates
	    },
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("\n                Vælg stillingskategori til " + _vm._s(_vm.selectedCount) + " "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [(_vm.employmentTemplates.length === 0) ? _c('li', {
	    staticClass: "italic"
	  }, [_vm._v("Ingen stillingskategorier oprettet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.employmentTemplates), function(template) {
	    return _c('li', {
	      key: template.id,
	      on: {
	        "click": function($event) {
	          return _vm.assignTemplateToSelected(template)
	        }
	      }
	    }, [_vm._v("\n                    " + _vm._s(_vm.templateOptionLabel(template)) + "\n                  ")])
	  })], 2)])], 1) : _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'top',
	        animateFill: false,
	        animation: 'shift-away',
	        boundary: 'window',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n                arrow: true,\n                placement: 'top',\n                animateFill: false,\n                animation: 'shift-away',\n                boundary: 'window',\n                zIndex: 12312312312312\n              }"
	    }],
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled uv-limits__bulk-submit-bttn",
	    attrs: {
	      "content": "Vælg personer først"
	    }
	  }, [_vm._v("\n              Vælg stillingskategori til de valgte "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.disableBulkMode
	    }
	  }, [_vm._v("\n              Annuller\n            ")])]], 2), _vm._v(" "), (_vm.tidsbegraensetCount > 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom',
	        animateFill: false,
	        animation: 'shift-away',
	        boundary: 'window',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n            arrow: true,\n            placement: 'bottom',\n            animateFill: false,\n            animation: 'shift-away',\n            boundary: 'window',\n            zIndex: 12312312312312\n          }"
	    }],
	    staticClass: "do-badge do-badge--yellow",
	    attrs: {
	      "content": _vm.tidsbegraensetCount + (_vm.tidsbegraensetCount === 1 ? ' ansættelse har' : ' ansættelser har') + ' en afvigende periode med UV-timer. Klik på \'Beregn timer\' for at danne et UV-tillæg for perioden.'
	    }
	  }, [_c('span', {
	    staticClass: "icon-warning"
	  }), _vm._v("\n          " + _vm._s(_vm.tidsbegraensetCount) + " " + _vm._s(_vm.tidsbegraensetCount === 1 ? 'ansættelse' : 'ansættelser') + " med afvigende periode\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "uv-limits__table-scroll"
	  }, [_c('table', {
	    staticClass: "do-table do-table--striped"
	  }, [_c('thead', [_c('tr', [(_vm.isBulkMode) ? _c('th', {
	    staticClass: "uv-limits__select-cell",
	    on: {
	      "click": _vm.toggleAllVisibleEmployments
	    }
	  }, [_c('div', {
	    staticClass: "do-checkbox",
	    class: {
	      'do-checkbox--selected': _vm.areAllVisibleEmploymentsSelected
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', [_vm._v("Stillingskategori")]), _vm._v(" "), _c('th', [_vm._v("UV-grænse")]), _vm._v(" "), _c('th', [_vm._v("Lønkode")]), _vm._v(" "), (_vm.showSpecialSkoleSalaryCodeColumn) ? _c('th', [_vm._v("Spec-skole lønkode")]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "uv-limits__narrow uv-limits__sortable",
	    class: {
	      'uv-limits__sortable--active': _vm.uvHoursSort
	    },
	    on: {
	      "click": _vm.toggleUvHoursSort
	    }
	  }, [_vm._v("\n              UV-timer\n              "), _c('span', {
	    staticClass: "icon-menu-open uv-limits__sort-icon",
	    class: {
	      'uv-limits__sort-icon--asc': _vm.uvHoursSort === 'asc',
	      'uv-limits__sort-icon--muted': !_vm.uvHoursSort
	    }
	  })]), _vm._v(" "), _c('th', [_vm._v("Ansættelse")]), _vm._v(" "), (_vm.isSalaryIntegrationActive) ? _c('th', [_vm._v("Ansættelsesnummer")]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "uv-limits__narrow"
	  }, [_vm._v("Lønbrøk")]), _vm._v(" "), _c('th', {
	    staticClass: "uv-limits__narrow"
	  }, [_vm._v("Bruttotid")]), _vm._v(" "), _c('th', [_vm._v("Startdato")]), _vm._v(" "), _c('th', [_vm._v("Slutdato")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [(_vm.filteredRows.length === 0) ? _c('tr', [_c('td', {
	    attrs: {
	      "colspan": _vm.emptyColspan
	    }
	  }, [_c('i', [_vm._v("Ingen personer matcher filtrene")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredRows), function(row) {
	    return _c('tr', {
	      key: row.key,
	      class: {
	        'uv-limits__row--selectable': _vm.isBulkMode && _vm.isSelectableRow(row),
	        'is-selected': _vm.isBulkMode && _vm.isRowSelected(row),
	        'uv-limits__row--inactive': !row.employment && _vm.isSalaryIntegrationActive
	      },
	      on: {
	        "click": function($event) {
	          _vm.isBulkMode && _vm.toggleRow(row)
	        }
	      }
	    }, [(_vm.isBulkMode) ? _c('td', {
	      staticClass: "uv-limits__select-cell"
	    }, [(row.employment) ? _c('div', {
	      staticClass: "do-checkbox",
	      class: {
	        'do-checkbox--selected': _vm.isEmploymentSelected(row.employment.id)
	      }
	    }) : _vm._e(), _vm._v(" "), (!row.employment && !_vm.isSalaryIntegrationActive) ? _c('div', {
	      staticClass: "do-checkbox",
	      class: {
	        'do-checkbox--selected': _vm.isUserWithoutEmploymentSelected(row.user.id)
	      }
	    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(row.user.name))]), _vm._v(" "), (_vm.hasDataIssues(row.user.id)) ? _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'right',
	          animateFill: false,
	          animation: 'shift-away',
	          boundary: 'window',
	          zIndex: 12312312312312
	        }),
	        expression: "{\n                  arrow: true,\n                  placement: 'right',\n                  animateFill: false,\n                  animation: 'shift-away',\n                  boundary: 'window',\n                  zIndex: 12312312312312\n                }"
	      }],
	      staticClass: "uv-limits__warning",
	      attrs: {
	        "content": _vm.dataIssuesTitle(row.user.id)
	      }
	    }, [_c('span', {
	      staticClass: "icon-warning"
	    })]) : _vm._e()]), _vm._v(" "), _c('td', {
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	        }
	      }
	    }, [_c('div', {
	      staticClass: "uv-limits__template-cell"
	    }, [(row.employment) ? _c('select', {
	      staticClass: "do-select width-100",
	      domProps: {
	        "value": row.employment.employment_template_id || ''
	      },
	      on: {
	        "change": function($event) {
	          return _vm.setEmploymentTemplate(row.employment, $event.target.value)
	        }
	      }
	    }, [_c('option', {
	      attrs: {
	        "value": ""
	      }
	    }), _vm._v(" "), _vm._l((_vm.employmentTemplates), function(template) {
	      return _c('option', {
	        key: template.id,
	        domProps: {
	          "value": template.id
	        }
	      }, [_vm._v("\n                    " + _vm._s(_vm.templateOptionLabel(template)) + "\n                  ")])
	    })], 2) : (!_vm.isSalaryIntegrationActive) ? _c('select', {
	      staticClass: "do-select width-100",
	      on: {
	        "change": function($event) {
	          return _vm.createEmploymentForUser(row.user, $event.target.value)
	        }
	      }
	    }, [_c('option', {
	      attrs: {
	        "disabled": "",
	        "selected": "",
	        "value": ""
	      }
	    }), _vm._v(" "), _vm._l((_vm.employmentTemplates), function(template) {
	      return _c('option', {
	        key: template.id,
	        domProps: {
	          "value": template.id
	        }
	      }, [_vm._v("\n                    " + _vm._s(_vm.templateOptionLabel(template)) + "\n                  ")])
	    })], 2) : _c('span', {
	      staticClass: "muted"
	    }, [_vm._v("—")])]), _vm._v(" "), (row.employment && row.isLastForUser && !_vm.isSalaryIntegrationActive) ? _c('div', {
	      staticClass: "uv-limits__add-employment"
	    }, [(_vm.addingForRowKey === row.key) ? _c('select', {
	      staticClass: "do-select width-100",
	      on: {
	        "change": function($event) {
	          _vm.createEmploymentForUser(row.user, $event.target.value);
	          _vm.addingForRowKey = null
	        }
	      }
	    }, [_c('option', {
	      attrs: {
	        "disabled": "",
	        "selected": "",
	        "value": ""
	      }
	    }, [_vm._v("Vælg stillingskategori")]), _vm._v(" "), _vm._l((_vm.employmentTemplates), function(template) {
	      return _c('option', {
	        key: template.id,
	        domProps: {
	          "value": template.id
	        }
	      }, [_vm._v("\n                    " + _vm._s(_vm.templateOptionLabel(template)) + "\n                  ")])
	    })], 2) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.template && row.template.hour_limit ? row.template.hour_limit : '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.template && row.template.hour_limit_salary_code_id ? _vm.salaryCodeLoenart(row.template.hour_limit_salary_code_id) : '—'))]), _vm._v(" "), (_vm.showSpecialSkoleSalaryCodeColumn) ? _c('td', [_vm._v(_vm._s(row.template && row.template.special_hour_limit_salary_code_id ? _vm.salaryCodeTitle(row.template.special_hour_limit_salary_code_id) : '—'))]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "uv-limits__narrow"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(_vm.assignedTeachingHours(row.user.id))))]), _vm._v(" "), _c('td', {
	      staticClass: "uv-limits__secondary"
	    }, [_vm._v(_vm._s(row.employment ? _vm.employmentTitle(row.employment) : 'Ingen aktive ansættelser'))]), _vm._v(" "), (_vm.isSalaryIntegrationActive) ? _c('td', {
	      staticClass: "uv-limits__secondary"
	    }, [_vm._v(_vm._s(row.employment && row.employment.employment_number ? row.employment.employment_number : '—'))]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "uv-limits__narrow uv-limits__secondary",
	      class: {
	        'uv-limits__missing': _vm.ansaettelsesgradIssue(row.user.id)
	      }
	    }, [(_vm.ansaettelsesgradIssue(row.user.id)) ? [_vm._v("Mangler")] : [_vm._v(_vm._s(_vm.formatDecimal(_vm.weeklyHours(row.user.id))))]], 2), _vm._v(" "), _c('td', {
	      staticClass: "uv-limits__narrow uv-limits__secondary",
	      class: {
	        'uv-limits__missing': _vm.bruttotidIssue(row.user.id)
	      }
	    }, [(_vm.bruttotidIssue(row.user.id)) ? [_vm._v("Mangler")] : [_vm._v(_vm._s(_vm.formatDecimal(_vm.bruttoTime(row.user.id))))]], 2), _vm._v(" "), _c('td', {
	      staticClass: "uv-limits__secondary",
	      class: {
	        'uv-limits__missing': _vm.startDateIssue(row.user.id),
	        'uv-limits__deviant': _vm.isTidsbegraensetRow(row) && _vm.startIsDeviant(row)
	      }
	    }, [(_vm.startDateIssue(row.user.id)) ? [_vm._v("Mangler")] : [_vm._v(_vm._s(_vm.formatDate(_vm.periodStart(row.user.id))))]], 2), _vm._v(" "), _c('td', {
	      staticClass: "uv-limits__secondary",
	      class: {
	        'uv-limits__missing': _vm.endDateIssue(row.user.id),
	        'uv-limits__deviant': _vm.isTidsbegraensetRow(row) && _vm.endIsDeviant(row)
	      }
	    }, [(_vm.endDateIssue(row.user.id)) ? [_vm._v("Mangler")] : [_vm._v(_vm._s(_vm.formatDate(_vm.periodEnd(row.user.id))))]], 2), _vm._v(" "), _c('td', {
	      staticClass: "uv-limits__actions-cell",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	        }
	      }
	    }, [(_vm.isTidsbegraensetRow(row)) ? _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'left',
	          animateFill: false,
	          animation: 'shift-away',
	          boundary: 'window',
	          zIndex: 12312312312312
	        }),
	        expression: "{\n                  arrow: true,\n                  placement: 'left',\n                  animateFill: false,\n                  animation: 'shift-away',\n                  boundary: 'window',\n                  zIndex: 12312312312312\n                }"
	      }],
	      staticClass: "do-bttn uv-limits__beregn-bttn",
	      attrs: {
	        "content": "Afvigende periode (ikke 1/8 – 31/7). Beregn UV-tillæg for den faktiske periode og dan et supplement i listen."
	      },
	      on: {
	        "click": function($event) {
	          return _vm.openBeregn(row)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-warning"
	    }), _vm._v(" Beregn timer\n              ")]) : _vm._e()])])
	  })], 2)])])]], 2), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("Luk")])]), _vm._v(" "), (_vm.isTemplateModalOpen) ? _c('DoEmploymentTemplate', {
	    attrs: {
	      "theEditEmploymentTemplate": _vm.editTemplate,
	      "forceHourLimitMode": true
	    },
	    on: {
	      "created": _vm.onTemplateSaved,
	      "updated": _vm.onTemplateSaved,
	      "close": _vm.closeTemplateModal
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.beregnRow) ? _c('UvLimitTidsbegraensetModal', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "schoolYearId": _vm.schoolYearId,
	      "userId": _vm.beregnRow.user.id,
	      "userName": _vm.beregnRow.user.name,
	      "employmentId": _vm.beregnRow.employment.id,
	      "ansaettelsesgradPercent": _vm.employmentPercentage(_vm.beregnRow.user.id),
	      "yearNormHours": _vm.bruttoTime(_vm.beregnRow.user.id),
	      "periodStart": _vm.periodStart(_vm.beregnRow.user.id),
	      "periodEnd": _vm.periodEnd(_vm.beregnRow.user.id),
	      "assignedTeachingHours": _vm.assignedTeachingHours(_vm.beregnRow.user.id),
	      "initialGraense": _vm.beregnRow.template ? _vm.beregnRow.template.hour_limit : null,
	      "salaryCodeId": _vm.beregnRow.template ? _vm.beregnRow.template.hour_limit_salary_code_id : null
	    },
	    on: {
	      "created": _vm.onBeregnCreated,
	      "close": function($event) {
	        _vm.beregnRow = null
	      }
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1904 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vue-full-cal-event-panel"
	  }, [_c('transition', {
	    attrs: {
	      "name": "zoomIn"
	    }
	  }, [(_vm.eventId) ? _c('DCalendarShowEvent', {
	    attrs: {
	      "isInitEventLoading": !_vm.event || _vm.isEventsLoading,
	      "event": _vm.event,
	      "initCalendarId": _vm.calendarId
	    },
	    on: {
	      "submitDeleteEventOnward": _vm.onEventUpdated,
	      "close": _vm.onClose,
	      "updated": _vm.onEventUpdated
	    }
	  }) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1905 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-wrapper",
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "bg-overlay fadeIn animated",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        $event.stopPropagation();
	        return _vm.$emit('close')
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "modal fadeInUp animated",
	    style: (_vm.modalStyle)
	  }, [_c('div', {
	    staticClass: "modal__close icon__bg-circle",
	    style: ({
	      'color': _vm.closeCrossColor
	    }),
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _vm._t("body", function() {
	    return [_c('h1', [_vm._v("Vil du slette?")])]
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1906 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('AppModal', {
	    attrs: {
	      "show": _vm.openFromOtherComponent
	    },
	    on: {
	      "close": _vm.setCloseModal
	    }
	  }, [_vm._v(">\n  "), _c('h1', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarDelete.delete_calendar')))]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "marg-10-bottom"
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.editCalendarDelete.deleting_this_calendar')) + ":")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.calName))])]), _vm._v(" "), _c('div', {
	    staticClass: "marg-10-bottom"
	  }, [_c('h3', {
	    staticClass: "warning-text bold"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.editCalendarDelete.all_data_will_be_deleted')) + "\n        ")])]), _vm._v(" "), _c('p', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarDelete.write')) + " \"" + _vm._s(_vm.$t('vue2.editCalendarDelete.validator_name')) + "\" -\n        " + _vm._s(_vm.$t('vue2.editCalendarDelete.if_you_want_to_delete')) + ":")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.validatorText),
	      expression: "validatorText"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.validatorText)
	    },
	    on: {
	      "keyup": _vm.validateInput,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.validatorText = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "flex flex-end align-center pad-10",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [(!_vm.validateInput()) ? _c('p', {
	    staticClass: "warning-text marg-10-right"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.editCalendarDelete.you_have_to_write')) + " \"" + _vm._s(_vm.$t('vue2.editCalendarDelete.validator_name')) + "\"\n    ")]) : _vm._e(), _vm._v(" "), (_vm.validateInput()) ? _c('button', {
	    staticClass: "submit-btn bttn--warning",
	    on: {
	      "click": _vm.submitDelete
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.editCalendarDelete.delete_calendar')) + "\n    ")]) : _c('button', {
	    staticClass: "submit-btn--disabled"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.editCalendarDelete.delete_calendar')) + "\n    ")])])])
	},staticRenderFns: []}

/***/ }),
/* 1907 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "flipper-buttons"
	  }, [_c('button', {
	    staticClass: "flipper-buttons__button",
	    class: {
	      'active': _vm.isActiveTab(1)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTab(1)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-year-planning"
	  }), _vm._v("\n    " + _vm._s(_vm.$t('vue2.sub_scheduler.schedules_overview')) + "\n  ")]), _vm._v(" "), _c('button', {
	    staticClass: "flipper-buttons__button",
	    class: {
	      'active': _vm.isActiveTab(0)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTab(0)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-file-text"
	  }), _vm._v("\n    " + _vm._s(_vm.$t('vue2.sub_scheduler.list')) + "\n  ")])])
	},staticRenderFns: []}

/***/ }),
/* 1908 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-profile__form"
	  }, [(!_vm.isEditable && _vm.canEdit) ? _c('div', {
	    staticClass: "d-profile__form__edit",
	    on: {
	      "click": function($event) {
	        _vm.isEditable = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.edit')))]) : _vm._e(), _vm._v(" "), (!_vm.isEditable) ? _c('div', {
	    staticClass: "d-input-group__un-edit"
	  }, [_c('h3', [_vm._v("CPR nummer")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.ssnHidden))])]) : [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', [_vm._v("CPR nummer")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.ssn),
	      expression: "ssn",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    class: {
	      'input--error': _vm.formErrors['ssn']
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.ssn)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('ssn')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.ssn = $event.target.value.trim()
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['ssn']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v("\n        " + _vm._s(_vm.formErrors['ssn']) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-profile__form__submit"
	  }, [_c('button', {
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn submit-button",
	    class: [{
	        'bttn--loading': _vm.isSaving
	      },
	      {
	        'submit-button--disabled': _vm.isSaveButtonDisabled
	      }
	    ],
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])]], 2)
	},staticRenderFns: []}

/***/ }),
/* 1909 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal",
	    class: {
	      'd-timetal--read-only': _vm.isReadOnly
	    }
	  }, [_c('div', {
	    staticClass: "d-timetal__container"
	  }, [_c('h4', {
	    staticClass: "uppercase"
	  }, [_vm._v("Undervisning i specialklasser")]), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.grades), function(grade) {
	    return _c('th', {
	      key: grade.value
	    }, [_vm._v(_vm._s(grade.title))])
	  })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.fagMedVProps), function(fag) {
	    return (!_vm.isReadOnly) ? _c('tr', {
	      key: fag.fagkode
	    }, [_c('td', [_vm._v(_vm._s(fag.title))]), _vm._v(" "), _vm._l((fag.klasser), function(klasse) {
	      return _c('td', {
	        class: [{
	          'td-is-obligatorisk': klasse.v_obligatorisk
	        }, {
	          'td-is-checkbox': klasse.hasOwnProperty('checkbox')
	        }]
	      }, [(klasse.hasOwnProperty('num')) ? _c('input', {
	        staticClass: "d-input",
	        attrs: {
	          "type": "number"
	        },
	        domProps: {
	          "value": klasse.num
	        },
	        on: {
	          "blur": function($event) {
	            return _vm.updateCell(klasse.v_originalObject, $event.target.value)
	          }
	        }
	      }) : _vm._e(), _vm._v(" "), (klasse.hasOwnProperty('checkbox') && fag._type === 'konfirmation') ? _c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': fag.v_fag.klassetrin * 1 === klasse.value * 1
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setKonfirmation(fag.v_fag, klasse.value)
	          }
	        }
	      }) : _vm._e(), _vm._v(" "), (klasse.hasOwnProperty('checkbox') && fag._type === 'praktik') ? _c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': fag.praktikkode === 'J'
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setPraktik(fag)
	          }
	        }
	      }) : _vm._e()])
	    })], 2) : _vm._e()
	  }), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized"
	  }, [_c('td', [_vm._v("Obligatorisk fagopdelt undervisning i alt")]), _vm._v(" "), _vm._l((_vm.obligatoriskFagopdelt), function(timer) {
	    return _c('td', [_vm._v(_vm._s(timer))])
	  })], 2), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized d-explainer"
	  }, [_c('td', [_vm._v("Minimumstimetal")]), _vm._v(" "), _vm._l((_vm.minimumFagopdelt), function(num, key) {
	    return _c('td', [_vm._v("(" + _vm._s(num) + ")")])
	  })], 2), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized"
	  }, [_c('td', [_vm._v("Øvrig fagopdelt undervisning i alt")]), _vm._v(" "), _vm._l((_vm.ovrigFagopdelt), function(timer) {
	    return _c('td', [_vm._v(_vm._s(timer))])
	  })], 2), _vm._v(" "), _vm._l((_vm.uuv), function(uuvfag) {
	    return (!_vm.isReadOnly) ? _c('tr', [_c('td', [_vm._v(_vm._s(uuvfag.title))]), _vm._v(" "), _vm._l((uuvfag.klasser), function(klasse) {
	      return _c('td', [(klasse.hasOwnProperty('num')) ? _c('input', {
	        staticClass: "d-input",
	        attrs: {
	          "type": "number"
	        },
	        domProps: {
	          "value": klasse.num
	        },
	        on: {
	          "blur": function($event) {
	            return _vm.updateCell(klasse.v_originalObject, $event.target.value)
	          }
	        }
	      }) : _vm._e()])
	    })], 2) : _vm._e()
	  }), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized"
	  }, [_c('td', [_vm._v("Skoleårets samlede længde\n          (= Obligatorisk fagopdelt undervisning\n          + øvrige fag + Understøttende undervisning)\n        ")]), _vm._v(" "), _vm._l((_vm.sammentaelling), function(timer) {
	    return _c('td', [_vm._v(_vm._s(timer))])
	  })], 2), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized d-explainer"
	  }, [_c('td', [_vm._v("Mindstekrav til skoleårets samlede længde")]), _vm._v(" "), _vm._l((_vm.totalMinimum), function(num, key) {
	    return _c('td', [(num > 0) ? _c('span', [_vm._v("(" + _vm._s(num) + ")")]) : _vm._e()])
	  })], 2), _vm._v(" "), _vm._l((_vm.tolaererArr), function(tolaerer) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(tolaerer.title))]), _vm._v(" "), _vm._l((tolaerer.klasser), function(klasse) {
	      return _c('td', {
	        staticClass: "td-is-checkbox"
	      }, [_c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': klasse && klasse.godkendelseskode && klasse.godkendelseskode === 'J'
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setTolaerer(klasse)
	          }
	        }
	      })])
	    })], 2)
	  }), _vm._v(" "), _vm._l((_vm.foranstaltningerMedProps), function(foranstaltning) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(foranstaltning.title))]), _vm._v(" "), _vm._l((foranstaltning.klasser), function(klasse) {
	      return _c('td', {
	        staticClass: "td-is-checkbox"
	      }, [_c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': klasse && klasse.godkendelseskode && klasse.godkendelseskode === 'J'
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setForanstaltning(klasse)
	          }
	        }
	      })])
	    })], 2)
	  })], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 1910 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "position": "fixed",
	      "z-index": "100000",
	      "display": "none"
	    }
	  }, [_c('div', {
	    staticClass: "arrow_box no-print animated infinite onboarding_animate"
	  })])
	}]}

/***/ }),
/* 1911 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dialog"
	  }, [_c('div', {
	    staticClass: "dialog-header",
	    style: ({
	      backgroundColor: _vm.event.color
	    })
	  }, [_c('div', {
	    staticClass: "header-top"
	  }, [_c('v-touch', {
	    staticClass: "no-desktop",
	    on: {
	      "tap": _vm.close
	    }
	  }, [_c('div', {
	    staticClass: "font-large close-tap"
	  }, [_c('span', {
	    staticClass: "icon-cross2 pointer"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "font-large no-mobile close-tap",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2 pointer"
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "header-body"
	  }, [_c('div', {
	    staticClass: "d-show-event__header__do-warning__container"
	  }, [(_vm.event && _vm.event.canceled) ? _c('div', {
	    staticClass: "d-show-event__header__do-warning do-warning do-warning--canceled"
	  }, [_c('span', {
	    staticClass: "icon-notification22"
	  }), _vm._v("\n          " + _vm._s(_vm.i18n.canceled) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.event && _vm.event.away) ? _c('div', {
	    staticClass: "d-show-event__header__do-warning do-warning"
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n.out_of_school))]) : _vm._e()]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.event.index))]), _vm._v(" "), _c('section', {
	    staticClass: "dialog-body"
	  }, [_c('div', {
	    staticClass: "dialog-icon"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.event.title))])])]), _vm._v(" "), _c('section', {
	    staticClass: "dialog-body"
	  }, [_c('div', {
	    staticClass: "dialog-icon"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text"
	  }, [_c('p', [_vm._v(_vm._s(_vm.dayAndDate))])])]), _vm._v(" "), _c('section', {
	    staticClass: "dialog-body"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text"
	  }, [_c('b', [_vm._v(_vm._s(_vm.$filters.LT(_vm.event.start)) + " - " + _vm._s(_vm.$filters.LT(_vm.event.end)))]), _vm._v(" "), _c('span', [_vm._v("(\n            "), (_vm.eventHours >= 1) ? _c('span', [_vm._v(_vm._s(_vm.eventHours) + " " + _vm._s(_vm.eventHours > 1 ? _vm.$t('calendars.subject_hours.timer') : _vm.$t('repitition.hour')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.eventMinutes >= 1) ? _c('span', [_vm._v(_vm._s(_vm.eventMinutes + ' min'))]) : _vm._e(), _vm._v("\n          )")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "dialog__dialog-body"
	  }, [_c('ul', [(_vm.event.group) ? _c('li', {
	    staticClass: "pad-15-0 border-bottom"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text"
	  }, [_c('b', [_vm._v(_vm._s(_vm.event.group))])])]) : _vm._e(), _vm._v(" "), (_vm.event.teacher) ? _c('li', {
	    staticClass: "pad-15-0 border-bottom"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text"
	  }, [_c('b', [_vm._v(_vm._s(_vm.event.teacher))])])]) : _vm._e(), _vm._v(" "), (_vm.event.room) ? _c('li', {
	    staticClass: "pad-15-0 border-bottom"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text"
	  }, [_c('b', [_vm._v(_vm._s(_vm.event.room))])])]) : _vm._e(), _vm._v(" "), (_vm.checkLengthWithoutHTML(_vm.event.learning_goal)) ? _c('li', {
	    staticClass: "pad-15-0 border-bottom"
	  }, [_c('div', {
	    staticClass: "dialog-text marg-10-bottom"
	  }, [_c('b', {
	    style: ({
	      color: _vm.event.color
	    })
	  }, [_vm._v(_vm._s(_vm.$t('calendars.week_plan.learning_goal')))])]), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.learning_goal)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.checkLengthWithoutHTML(_vm.event.description)) ? _c('li', {
	    staticClass: "pad-15-0 border-bottom"
	  }, [_c('div', {
	    staticClass: "dialog-text marg-10-bottom"
	  }, [_c('b', {
	    style: ({
	      color: _vm.event.color
	    })
	  }, [_vm._v(_vm._s(_vm.$t('calendars.week_plan.content')) + " ")])]), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.description)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.checkLengthWithoutHTML(_vm.event.notes_for_students)) ? _c('li', {
	    staticClass: "pad-15-0 border-bottom"
	  }, [_c('div', {
	    staticClass: "dialog-text marg-10-bottom"
	  }, [_c('b', {
	    style: ({
	      color: _vm.event.color
	    })
	  }, [_vm._v(_vm._s(_vm.$t('calendars.week_plan.pupil_preparation')))])]), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.notes_for_students)
	    }
	  })]) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dialog-icon"
	  }, [_c('span', {
	    staticClass: "icon-clock"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dialog-icon",
	    staticStyle: {
	      "margin-top": "-1px"
	    }
	  }, [_c('span', {
	    staticClass: "icon-calendar4"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dialog-icon"
	  }, [_c('span', {
	    staticClass: "icon-user"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dialog-icon"
	  }, [_c('span', {
	    staticClass: "icon-location"
	  })])
	}]}

/***/ }),
/* 1912 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('d-select', {
	    attrs: {
	      "items": _vm.usersForList,
	      "itemsSelected": _vm.selectedUsers,
	      "eventId": _vm.eventId,
	      "allDataLoaded": _vm.allDataLoaded,
	      "show": _vm.show,
	      "addClass": _vm.addClass
	    },
	    on: {
	      "remove": _vm.removeUser,
	      "add": _vm.addUser,
	      "addIsOnLesson": _vm.addedIsOnLesson,
	      "update": _vm.setSelectedUsers,
	      "show": _vm.getUsers
	    }
	  }), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeIn"
	    }
	  }, [(_vm.subFromIsOnLesson !== null) ? _c('div', {
	    staticClass: "subModal__bg"
	  }, [_c('div', {
	    staticClass: "subModal"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['would_you_like_to_set']) + " " + _vm._s(_vm.subFromIsOnLesson.name) + " " + _vm._s(_vm.i18n['as_a_substitute_instead_of_teacher']) + "?")]), _vm._v(" "), _c('div', {
	    staticClass: "subModal__buttons"
	  }, [_c('button', {
	    on: {
	      "click": _vm.setSubFromIsOnLesson
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['yes']))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn-simple bttn",
	    on: {
	      "click": function($event) {
	        _vm.subFromIsOnLesson = null
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['no']))])])])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1913 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-team-calendar__header"
	  }, [_c('div', {
	    staticClass: "d-team-calendar__header__header"
	  }, [_c('div', {
	    staticClass: "d-team-calendar__header__header__left team-d-tabs"
	  }, [_c('div', {
	    staticClass: "team-d-tabs__tab",
	    class: {
	      'team-d-tabs__tab--active': _vm.theTab === 1
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTab(1)
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['custom']) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "team-d-tabs__tab",
	    class: {
	      'team-d-tabs__tab--active': _vm.theTab === 2
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTab(2)
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['shortcuts']) + "\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-team-calendar__header__header__right"
	  }, [_c('button', {
	    staticClass: "marg-5-right",
	    class: [{
	      inactive: _vm.isToday
	    }, 'no-print'],
	    on: {
	      "click": _vm.today
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('repitition.today')) + "\n      ")]), _vm._v(" "), _c('button', {
	    staticClass: "icon-arrow-left4 no-print marg-5-right",
	    on: {
	      "click": _vm.prev
	    }
	  }), _vm._v(" "), _c('DatePicker', {
	    attrs: {
	      "popperPlacement": "bottom-end",
	      "date": _vm.date
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "icon-arrow-right4 no-print marg-5-left",
	    on: {
	      "click": _vm.next
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.theTab === 1),
	      expression: "theTab === 1"
	    }],
	    staticClass: "team-d-tabs__tab__content"
	  }, [_c('dSelectAll', {
	    staticClass: "marg-1-bottom",
	    attrs: {
	      "show-tags": true,
	      "showCreateButton": false,
	      "itemsSelected": _vm.itemsSelected
	    },
	    on: {
	      "add": function($event) {
	        return _vm.dSelectUsersUpdated('add')
	      },
	      "remove": function($event) {
	        return _vm.dSelectUsersUpdated('remove')
	      },
	      "update": function($event) {
	        return _vm.dSelectUsersUpdated('update', $event)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "cal-container__header"
	  }, [_c('div', {
	    staticClass: "cal-container__header--left"
	  }, [_c('div', {
	    staticClass: "d-cal-views"
	  }, [_c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('resourceTimeGridDay')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('resourceTimeGridDay')
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_day']) + "\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('resourceTimeGridFiveDay')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('resourceTimeGridFiveDay')
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_week']) + "\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('overlayWeek')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('overlayWeek')
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_overlay_week']) + "\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('listView')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('listView')
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_list']) + "\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('schedulerView')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('schedulerView')
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_scheduler']) + "\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('presenceTable')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('presenceTable')
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_presence_table']) + "\n          ")])]), _vm._v(" "), (_vm.calview !== 'schedulerView' && _vm.calview !== 'presenceTable') ? _c('DDropdown', {
	    attrs: {
	      "isShowDots": false
	    }
	  }, [_c('button', {
	    staticClass: "d-teamcalendar__saved-views__scroll bttn-simple",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("\n            " + _vm._s(_vm.theSelectedScrollOption) + "\n            "), _c('svg', {
	    staticClass: "w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24",
	      "fill": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "fill-rule": "evenodd",
	      "d": "M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z",
	      "clip-rule": "evenodd"
	    }
	  })])]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, _vm._l((_vm.scrollOptions), function(view) {
	    return _c('li', {
	      staticClass: "d-teamcalendar__saved-views__view",
	      on: {
	        "click": function($event) {
	          return _vm.setSelectedScrollOption(view)
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(view.title) + "\n            ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.calview == 'resourceTimeGridDay' || _vm.calview == 'resourceTimeGridFiveDay') ? _c('button', {
	    staticClass: "marg-5-left",
	    on: {
	      "click": _vm.setIsShowSettings
	    }
	  }, [_c('span', {
	    staticClass: "icon-wrench"
	  })]) : _vm._e(), _vm._v(" "), (_vm.calview !== 'schedulerView') ? _c('button', {
	    staticClass: "marg-5-left",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "bttn-with-svg",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('updateEvents')
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
	    }
	  })])]), _vm._v(" "), (_vm.isDragAndDropPossible && (_vm.calview == 'resourceTimeGridDay' || _vm.calview == 'resourceTimeGridFiveDay')) ? _c('div', {
	    staticClass: "d-team-calendar__header__drag-toggle marg-5-left no-print",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.$emit('setIsDragAndDropOn', !_vm.isDragAndDropOn)
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "propOn": _vm.isDragAndDropOn,
	      "allowChanges": false
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['edit_schedules']))])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isShowSettings) ? _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    staticStyle: {
	      "width": "400px"
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.standard_settings.standard_setting')))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.isShowSettings = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-input-group marg-1-bottom"
	  }, [_c('label', {
	    staticClass: "d-input marg-05-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.standard_settings.set_default_start_and_endtime')))]), _vm._v(" "), _c('TimeChanger', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "showIcon": true,
	      "start": _vm.standardStartTime,
	      "end": _vm.standardEndTime
	    },
	    on: {
	      "updateStart": _vm.setStandardStartTime,
	      "updateEnd": _vm.setStandardEndTime
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group d-input-group__is-toggle"
	  }, [_c('div', {
	    staticClass: "d-input-group__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setCustomNumberOfDays(!_vm.isSetCustomNumberOfDays)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-input"
	  }, [_vm._v("Set custom number of days")]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "propOn": _vm.isSetCustomNumberOfDays
	    }
	  })], 1), _vm._v(" "), (_vm.isSetCustomNumberOfDays) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.numberOfDays),
	      expression: "numberOfDays"
	    }],
	    ref: "input_custom_number_of_days",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.numberOfDays)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.numberOfDays = $event.target.value
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), (!_vm.isSetCustomNumberOfDays) ? _c('div', {
	    staticClass: "d-input-group d-input-group__is-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setIsShowWeekends(!_vm.isShowWeekends)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-input-group__toggle"
	  }, [_c('label', {
	    staticClass: "d-input"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.show_weekends')))]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "propOn": _vm.isShowWeekends,
	      "allowChanges": false
	    }
	  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "bttn bttn-simple marg-1-right",
	    on: {
	      "click": function($event) {
	        _vm.isShowSettings = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')) + "\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.submitStandardSettings
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])])])]) : _vm._e(), _vm._v(" "), _c('TeamCalendarHeaderSaveView', {
	    attrs: {
	      "itemsSelected": _vm.itemsSelected
	    },
	    on: {
	      "setSavedView": _vm.setSavedView
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.theTab === 2),
	      expression: "theTab === 2"
	    }],
	    staticClass: "team-d-tabs__tab__content team-d-tabs__tab__content__header"
	  }, [_c('div', {
	    staticClass: "d-cal-views"
	  }, [_c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('scheduler__all_cals')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('scheduler__all_cals')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['all_calendars']) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('scheduler__all_klass')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('scheduler__all_klass')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['all_classes']) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('scheduler__all_users')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('scheduler__all_users')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['all_users']) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('scheduler')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('scheduler')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['room_overview']) + "\n      ")]), _vm._v(" "), (_vm.userHasPermission('can_do_most_stuff')) ? [_c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('doubleBookings')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('doubleBookings')
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale]['show_double_bookings']) + "\n        ")])] : _vm._e()], 2), _vm._v(" "), (_vm.calview !== 'doubleBookings') ? [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['sort_by']))]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.theSortOptionForAllSchedules),
	      expression: "theSortOptionForAllSchedules"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.theSortOptionForAllSchedules = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.setChangedSortOption(_vm.theSortOptionForAllSchedules)
	      }]
	    }
	  }, _vm._l((_vm.sortOptionsForAllSchedules), function(option) {
	    return _c('option', {
	      domProps: {
	        "value": option.value
	      }
	    }, [_vm._v(_vm._s(option.title))])
	  }), 0)] : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1914 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "answer-modal",
	    class: {
	      'answer-modal--with-sidebar': _vm.isShowAbsenceSidebar
	    }
	  }, [_c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    class: {
	      'd-modal--with-opus': _vm.isShowSalaryInfoBox
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['answer_absence_request']))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__header-actions"
	  }, [(!_vm.isShowAbsenceSidebar) ? _c('button', {
	    staticClass: "do-bttn do-bttn--small",
	    on: {
	      "click": function($event) {
	        _vm.isShowAbsenceSidebar = true
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n['show_absent']) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content-wrapper"
	  }, [_c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', [_c('b', [_vm._v(_vm._s(_vm.request.vUserName) + ":")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.request.vSubjectTitle) + ",")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.request.vStart) + " -")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.request.vEnd))])]), _vm._v(" "), _c('tr', {
	    staticStyle: {
	      "border-top": "1px solid #e2e8f0"
	    }
	  }, [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v(_vm._s(_vm.request.request_note))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "marg-1-top"
	  }, [_c('label', {
	    staticClass: "d-label marg-05-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n['absence_reason']))]), _vm._v(" "), _c('UserAbsence', {
	    attrs: {
	      "isShowLabel": false,
	      "selectedSubject": {
	        id: _vm.request.subject_id
	      }
	    },
	    on: {
	      "setSubject": _vm.updateRequestSubject
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n['date']))]), _vm._v(" "), _c('DatepickerRange', {
	    attrs: {
	      "allowSameDate": true,
	      "startdate": _vm.initStartDate,
	      "enddate": _vm.initEndDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "time-changer__group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n['time']))]), _vm._v(" "), _c('TimeChanger', {
	    attrs: {
	      "showIcon": true,
	      "start": _vm.startTime,
	      "end": _vm.endTime,
	      "isFiveMinutesInterval": false
	    },
	    on: {
	      "updateStart": _vm.setStartTime,
	      "updateEnd": _vm.setEndTime
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "marg-1-top"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n['reply_note']))]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.note),
	      expression: "note"
	    }, {
	      name: "focus",
	      rawName: "v-focus"
	    }],
	    staticClass: "do-input do-textarea",
	    domProps: {
	      "value": (_vm.note)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.note = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), (_vm.isShowSdInfoBox) ? _c('div', {
	    staticClass: "opus-info-box"
	  }, [_c('div', {
	    staticClass: "do-sd-badge do-opus-badge--large opus-info__header"
	  }, [_vm._v("SD")]), _vm._v(" "), (_vm.userEmployments.length > 0) ? _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Ansættelse")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedEmploymentId),
	      expression: "selectedEmploymentId"
	    }],
	    staticClass: "do-select",
	    class: {
	      'do-select--error': _vm.showValidationErrors && !_vm.isEmploymentValid
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedEmploymentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("— Vælg ansættelsesnummer —")]), _vm._v(" "), _vm._l((_vm.userEmployments), function(employment) {
	    return _c('option', {
	      key: employment.id,
	      domProps: {
	        "value": employment.id
	      }
	    }, [_vm._v("\n              " + _vm._s(employment.title) + " - " + _vm._s(employment.employment_number || employment.id) + "\n            ")])
	  })], 2), _vm._v(" "), (_vm.showValidationErrors && !_vm.isEmploymentValid) ? _c('span', {
	    staticClass: "error-message"
	  }, [_vm._v("\n            Ansættelsesnummer skal vælges\n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Fraværsårsag")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__reason-display"
	  }, [(_vm.getSDAbsence) ? _c('span', {
	    staticClass: "opus-info__reason-code"
	  }, [_vm._v("\n              " + _vm._s(_vm.getSDAbsence.loenart) + _vm._s(_vm.getSDAbsence.title ? ' - ' + _vm.getSDAbsence.title : '') + "\n            ")]) : _vm._e()])]), _vm._v(" "), (_vm.isSdOngoingAllowed) ? _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Åbenstående")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__toggle-row"
	  }, [_c('div', {
	    staticClass: "do-opus-toggle",
	    on: {
	      "click": function($event) {
	        _vm.isOngoing = !_vm.isOngoing
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "prop-on": _vm.isOngoing
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Indberet som åbenstående")])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Tid")]), _vm._v(" "), (_vm.useTime) ? _c('div', {
	    staticClass: "opus-info__date-text"
	  }, [_vm._v("\n            " + _vm._s(_vm.formatTime(_vm.startTime)) + " - " + _vm._s(_vm.formatTime(_vm.endTime)) + "\n          ")]) : _c('div', {
	    staticClass: "opus-info__date-text"
	  }, [_vm._v("\n            Hel dag\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
	  }, [_c('div', {
	    staticClass: "do-opus-toggle",
	    on: {
	      "click": function($event) {
	        _vm.useTime = !_vm.useTime
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "prop-on": !_vm.useTime
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Indberet som hel dag")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isShowOpusInfoBox) ? _c('div', {
	    staticClass: "opus-info-box"
	  }, [_c('div', {
	    staticClass: "do-opus-badge do-opus-badge--large opus-info__header"
	  }, [_vm._v("Opus")]), _vm._v(" "), (_vm.userEmployments.length > 0) ? _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Ansættelse")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedEmploymentId),
	      expression: "selectedEmploymentId"
	    }],
	    staticClass: "do-select",
	    class: {
	      'do-select--error': _vm.showValidationErrors && !_vm.isEmploymentValid
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedEmploymentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.onEmploymentChange]
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("— Vælg ansættelsesnummer —")]), _vm._v(" "), _vm._l((_vm.userEmployments), function(employment) {
	    return _c('option', {
	      key: employment.id,
	      domProps: {
	        "value": employment.id
	      }
	    }, [_vm._v("\n              " + _vm._s(employment.title) + " - " + _vm._s(employment.employment_number || employment.id) + "\n            ")])
	  })], 2), _vm._v(" "), (_vm.showValidationErrors && !_vm.isEmploymentValid) ? _c('span', {
	    staticClass: "error-message"
	  }, [_vm._v("\n            Ansættelsesnummer skal vælges\n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Fraværsårsag")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__reason-display"
	  }, [(_vm.getOPUSAbsence) ? _c('span', {
	    staticClass: "opus-info__reason-code"
	  }, [_vm._v("\n              " + _vm._s(_vm.getOPUSAbsence.absence_type) + _vm._s(_vm.getOPUSAbsence.absence_type_text ? ' - ' + _vm.getOPUSAbsence.absence_type_text : '') + "\n            ")]) : _vm._e()]), _vm._v(" "), (_vm.isShowExtraInformation) ? _c('div', {
	    staticClass: "opus-info__extra-info"
	  }, [(_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'Maternity') ? [_c('label', {
	    staticClass: "opus-info__label opus-info__label--secondary"
	  }, [_vm._v("Ekstra information til barselssager")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
	    staticClass: "do-spinner do-spinner--small"
	  }) : (_vm.additionalDataError) ? _c('div', {
	    staticClass: "opus-info__error"
	  }, [_c('span', {
	    staticClass: "opus-info__error-icon"
	  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAdditionalData),
	      expression: "selectedAdditionalData"
	    }],
	    staticClass: "do-select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
	    return _c('option', {
	      key: option.MaternityCaseKey,
	      domProps: {
	        "value": option.MaternityCaseKey
	      }
	    }, [_vm._v("\n                  " + _vm._s(option.ExpectedDeliveryDate) + " - " + _vm._s(option.MaternityCaseKey) + "\n                ")])
	  })], 2) : (_vm.hasLoadedAdditionalData) ? _c('p', {
	    staticClass: "opus-info__note"
	  }, [_vm._v("\n                Der er ingen barselssager tilknyttet denne medarbejder i Opus.\n              ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'Reason') ? [_c('label', {
	    staticClass: "opus-info__label opus-info__label--secondary"
	  }, [_vm._v("Ekstra information til tjenestefri")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
	    staticClass: "do-spinner do-spinner--small"
	  }) : (_vm.additionalDataError) ? _c('div', {
	    staticClass: "opus-info__error"
	  }, [_c('span', {
	    staticClass: "opus-info__error-icon"
	  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAdditionalData),
	      expression: "selectedAdditionalData"
	    }],
	    staticClass: "do-select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
	    return _c('option', {
	      key: option.ReasonCode,
	      domProps: {
	        "value": option.ReasonCode
	      }
	    }, [_vm._v("\n                  " + _vm._s(option.ReasonCodeText) + " - " + _vm._s(option.ReasonCode) + "\n                ")])
	  })], 2) : (_vm.hasLoadedAdditionalData) ? _c('p', {
	    staticClass: "opus-info__note"
	  }, [_vm._v("\n                Der er ingen tjenestefri årsager tilknyttet denne medarbejder i Opus.\n              ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'WorkInjury') ? [_c('label', {
	    staticClass: "opus-info__label opus-info__label--secondary"
	  }, [_vm._v("Ekstra information til arbejdsskader")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
	    staticClass: "do-spinner do-spinner--small"
	  }) : (_vm.additionalDataError) ? _c('div', {
	    staticClass: "opus-info__error"
	  }, [_c('span', {
	    staticClass: "opus-info__error-icon"
	  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAdditionalData),
	      expression: "selectedAdditionalData"
	    }],
	    staticClass: "do-select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
	    return _c('option', {
	      key: option.AccidentNumber,
	      domProps: {
	        "value": option.AccidentNumber
	      }
	    }, [_vm._v("\n                  " + _vm._s(option.AccidentDate) + " - " + _vm._s(option.AccidentNumber) + "\n                ")])
	  })], 2) : (_vm.hasLoadedAdditionalData) ? _c('p', {
	    staticClass: "opus-info__note"
	  }, [_vm._v("\n                Der er ingen arbejdsskadesager tilknyttet denne medarbejder i Opus.\n              ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'Child') ? [_c('label', {
	    staticClass: "opus-info__label opus-info__label--secondary"
	  }, [_vm._v("Ekstra information til omsorgsdage")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
	    staticClass: "do-spinner do-spinner--small"
	  }) : (_vm.additionalDataError) ? _c('div', {
	    staticClass: "opus-info__error"
	  }, [_c('span', {
	    staticClass: "opus-info__error-icon"
	  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAdditionalData),
	      expression: "selectedAdditionalData"
	    }],
	    staticClass: "do-select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
	    return _c('option', {
	      key: option.ChildNumber,
	      domProps: {
	        "value": option.ChildNumber
	      }
	    }, [_vm._v("\n                  " + _vm._s(option.FirstName) + " " + _vm._s(option.LastName) + " - " + _vm._s(option.ChildNumber) + "\n                ")])
	  })], 2) : (_vm.hasLoadedAdditionalData) ? _c('p', {
	    staticClass: "opus-info__note"
	  }, [_vm._v("\n                Der er ingen barn tilknyttet denne medarbejder i Opus.\n              ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.showValidationErrors && !_vm.isAdditionalDataValid) ? _c('span', {
	    staticClass: "error-message"
	  }, [_vm._v("\n              Ekstra information skal vælges\n            ")]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), (_vm.isOpusAllowOpen) ? _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Åbenstående")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__toggle-row"
	  }, [_c('div', {
	    staticClass: "do-opus-toggle",
	    on: {
	      "click": function($event) {
	        _vm.isOngoing = !_vm.isOngoing
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "prop-on": _vm.isOngoing
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Indberet som åbenstående")])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Tid")]), _vm._v(" "), (_vm.useTime) ? _c('div', {
	    staticClass: "opus-info__date-text"
	  }, [_vm._v("\n            " + _vm._s(_vm.formatTime(_vm.startTime)) + " - " + _vm._s(_vm.formatTime(_vm.endTime)) + "\n          ")]) : _c('div', {
	    staticClass: "opus-info__date-text"
	  }, [_vm._v("\n            Hel dag\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
	  }, [_c('div', {
	    staticClass: "do-opus-toggle",
	    on: {
	      "click": function($event) {
	        _vm.useTime = !_vm.useTime
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "prop-on": !_vm.useTime
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Indberet som hel dag")])], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons d-modal__buttons__flex"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    class: {
	      'do-bttn--loading': _vm.isLoadingRejected
	    },
	    on: {
	      "click": _vm.rejectRequest
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n['reject']) + "\n      ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    class: {
	      'do-bttn--loading': _vm.isLoadingApprove
	    },
	    on: {
	      "click": _vm.approveRequest
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n['approve']) + "\n      ")])])])]), _vm._v(" "), (_vm.isShowAbsenceSidebar) ? _c('UserRequestAbsenceSidebar', {
	    attrs: {
	      "date": _vm.startDate,
	      "requesterId": _vm.request.request_by_id
	    },
	    on: {
	      "close": function($event) {
	        _vm.isShowAbsenceSidebar = false
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1915 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "items-list"
	  }, [_c('ul', {
	    staticClass: "items"
	  }, [(!_vm.isEditPeriod) ? _c('li', {
	    staticClass: "items__item"
	  }, [(_vm.isKindergarten || _vm.isBruttoTid) ? _c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v("Periode")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_vm._v("\n          " + _vm._s(_vm.dateRangeFormatted) + "\n          "), _c('div', {
	    staticClass: "hint--right",
	    attrs: {
	      "aria-label": "Redigér periode"
	    }
	  }, [_c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": _vm.onClickEditPeriod
	    }
	  }, [_c('span', {
	    staticClass: "icon-wrench"
	  })])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isEditPeriod) ? [_c('div', {
	    staticClass: "calc-method"
	  }, [_c('h3', [_vm._v("Vælg beregningsmetode")]), _vm._v(" "), _c('p', [_vm._v("Planlægges der for et helt skoleår/arbejdsår udgør arbejdstiden 1924 timer. Planlægges der for en del af et\n          skoleår/arbejdsår kan I selv vælge, hvilke af flg. metoder arbejdstiden skal beregnes ud fra.")]), _vm._v(" "), _c('ul', {
	    staticClass: "d-radio-group"
	  }, _vm._l((_vm.waysToCalculate), function(way) {
	    return _c('li', {
	      key: way.value,
	      staticClass: "d-radio-group__radio",
	      class: {
	        'd-radio-group__radio--selected': _vm.theSelectedWayToCalculate === way.value
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheSelectedWayToCalculate(way.value)
	        }
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.theSelectedWayToCalculate),
	        expression: "theSelectedWayToCalculate"
	      }],
	      attrs: {
	        "type": "radio",
	        "id": 'subject_subject_type_' + way.value
	      },
	      domProps: {
	        "value": way.value,
	        "checked": _vm._q(_vm.theSelectedWayToCalculate, way.value)
	      },
	      on: {
	        "change": function($event) {
	          _vm.theSelectedWayToCalculate = way.value
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      staticClass: "calc-method__label",
	      attrs: {
	        "for": 'subject_subject_type_' + way.value
	      },
	      domProps: {
	        "innerHTML": _vm._s(way.title)
	      }
	    })])
	  }), 0), _vm._v(" "), _c('p', [_vm._v("I nedenstående udregnes automatisk søgnehelligdage i perioden. Men du skal selv indtaste om den ansatte har\n          ferie, der ikke er brugt – altså både gammel ferie og ny optjent ferie")])]), _vm._v(" "), _c('li', {
	    staticClass: "items__item"
	  }, [_c('div', {
	    staticClass: "items__item__content",
	    class: {
	      'items__item__content--error': _vm.isErrorInStartDate
	    }
	  }, [_c('p', [_vm._v("Startdato")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.startDate,
	      "isOnlyShowFirstAndLastDateEachMonth": _vm.theSelectedWayToCalculate === 'month'
	    },
	    on: {
	      "changed": _vm.setStartDate
	    }
	  })], 1)]), _vm._v(" "), (_vm.isErrorInStartDate) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v("Skal være den første eller sidste dag i måneden")]) : _vm._e()]), _vm._v(" "), _c('li', {
	    staticClass: "items__item"
	  }, [_c('div', {
	    staticClass: "items__item__content",
	    class: {
	      'items__item__content--error': _vm.isErrorInEndDate
	    }
	  }, [_c('p', [_vm._v("Slutdato")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('DateSelector', {
	    attrs: {
	      "isOnlyShowFirstAndLastDateEachMonth": _vm.theSelectedWayToCalculate === 'month',
	      "date": _vm.endDate
	    },
	    on: {
	      "changed": _vm.setEndDate
	    }
	  })], 1)]), _vm._v(" "), (_vm.isErrorInEndDate) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v("Skal være den første eller sidste dag i måneden")]) : _vm._e()])] : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "items__item"
	  }, [_c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v("Timeansættelse pr. uge")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("timer")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.hoursPerWeek.hours),
	      expression: "hoursPerWeek.hours"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.hoursPerWeek.hours)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.hoursPerWeekChanged($event.target.value, true)
	      },
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.hoursPerWeek, "hours", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), (_vm.isBruttoTid) ? _c('li', {
	    staticClass: "items__item"
	  }, [_c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v("Beskæftigelsesgrad")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("%")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.employmentPercentage.hours),
	      expression: "employmentPercentage.hours"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.employmentPercentage.hours)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.employmentPercentageChanged($event.target.value)
	      },
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.employmentPercentage, "hours", $event.target.value)
	      }
	    }
	  })])])]) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "items__item",
	    class: {
	      'items__item--fixed': _vm.workingHours.isFixed
	    }
	  }, [_c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v(_vm._s(_vm.workingHours.title))]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("timer")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.workingHours.hours),
	      expression: "workingHours.hours"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.workingHours.hours)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onEditWorkingHours($event.target.value)
	      },
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.workingHours, "hours", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('ul', _vm._l((_vm.subtractedItems), function(subtractItem, idx) {
	    return _c('li', {
	      key: subtractItem.id,
	      staticClass: "subtract-item items__item",
	      class: {
	        'subtract-item--fixed': subtractItem.isFixed
	      }
	    }, [_c('div', {
	      staticClass: "subtract-item__title"
	    }, [_c('div', {
	      staticClass: "d-input-group__input__close icon__bg-circle icon__bg-circle--danger",
	      on: {
	        "click": function($event) {
	          return _vm.deleteItem(subtractItem)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-cross2"
	    })]), _vm._v("\n          " + _vm._s(subtractItem.title) + "\n          "), (subtractItem.id === 'holidays') ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away'
	        }),
	        expression: "{arrow: true, animateFill: false, animation: 'shift-away'}"
	      }],
	      staticClass: "icon__bg-circle holidays-settings-bttn",
	      attrs: {
	        "content": _vm.isOnlyPartOfSchoolYear ? 'Vis helligdage i perioden' : 'Redigér standard for søgnehelligdage'
	      },
	      on: {
	        "click": _vm.onClickEditHolidaysStandard
	      }
	    }, [_c('span', {
	      staticClass: "icon-wrench"
	    })]) : _vm._e(), _vm._v(" "), (subtractItem.id === 'local_agreement_adjustment') ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away'
	        }),
	        expression: "{arrow: true, animateFill: false, animation: 'shift-away'}"
	      }],
	      staticClass: "icon__bg-circle holidays-settings-bttn",
	      attrs: {
	        "content": "Redigér standard for tilpasning til lokalaftale"
	      },
	      on: {
	        "click": _vm.onClickEditLocalAgreementStandard
	      }
	    }, [_c('span', {
	      staticClass: "icon-wrench"
	    })]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "input-group__input"
	    }, [_c('span', {
	      staticClass: "label"
	    }, [_vm._v(_vm._s(subtractItem.unit ? subtractItem.unit : 'timer'))]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (subtractItem.hours),
	        expression: "subtractItem.hours"
	      }],
	      attrs: {
	        "type": "number"
	      },
	      domProps: {
	        "value": (subtractItem.hours)
	      },
	      on: {
	        "focus": function($event) {
	          return $event.target.select()
	        },
	        "change": function($event) {
	          return _vm.setSubtractedItemValue(subtractItem, $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(subtractItem, "hours", $event.target.value)
	        }
	      }
	    })])])
	  }), 0)], 2), _vm._v(" "), _c('ul', {
	    staticClass: "items",
	    attrs: {
	      "id": "items__list"
	    }
	  }, [(_vm.isAddNew) ? _c('li', {
	    staticClass: "items__item items__item__add__new"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newItemTitle),
	      expression: "newItemTitle"
	    }],
	    ref: "add_new_input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Eks. Særlig reduktion"
	    },
	    domProps: {
	      "value": (_vm.newItemTitle)
	    },
	    on: {
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.addOwn.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newItemTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "items__item__add__new__buttons"
	  }, [_c('button', {
	    staticClass: "bttn",
	    on: {
	      "click": _vm.reset
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-primary",
	    on: {
	      "click": _vm.addOwn
	    }
	  }, [_vm._v("Gem")])])]) : _vm._e()]), _vm._v(" "), _c('DDropdown', {
	    staticClass: "add-more__dropdown",
	    attrs: {
	      "isShowDots": false
	    }
	  }, [(!_vm.isAddNew) ? _c('p', {
	    staticClass: "items__item__add",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("+ Tilføj reduktion")]) : _vm._e(), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('label', {
	    staticClass: "d-label d-label__headline"
	  }, [_vm._v("Vælg fra standard")]), _vm._v(" "), _vm._l((_vm.possibleStandardItems), function(possibleItem, idx) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.addFromStandard(possibleItem)
	        }
	      }
	    }, [_vm._v(_vm._s(possibleItem.title) + "\n      ")])
	  }), _vm._v(" "), _c('li', {
	    staticClass: "items__item__add",
	    staticStyle: {
	      "border-top": "1px solid #ddd",
	      "margin-top": "0.5rem"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setIsAddNew(true)
	      }
	    }
	  }, [_vm._v("+\n        Opret egen\n      ")])], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "item__total"
	  }, [_c('p', [_vm._v("Arbejdstid")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.nettoTime) + " timer")])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1916 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "user-agreements"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale].notes_for) + " " + _vm._s(_vm.activeSchoolYear.name))]), _vm._v(" "), (_vm.userCanEditAgreementNote) ? _c('div', [_c('AppEIPWYZIWYG', {
	    attrs: {
	      "textInput": _vm.agreements
	    },
	    on: {
	      "close": _vm.updateAgreements
	    }
	  })], 1) : _c('div', {
	    staticClass: "user-agreements__notes"
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.agreements)
	    }
	  }), _vm._v(" "), (_vm.agreements.length < 1) ? _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen noter")]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1917 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.showVersionsMenu) ? _c('div', {
	    staticClass: "task-overview"
	  }, [_c('div', {
	    staticClass: "to-versions"
	  }, [(_vm.isUserSchoolAdmin && _vm.sortedVersions.length < 1 && _vm.savedStatements.length < 1) ? _c('button', {
	    staticClass: "d-drop-box to-versions__save-bttn",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.openSaveModal
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.task_versions.save_version')) + "\n    ")]) : _c('DDropdown', {
	    attrs: {
	      "isShowDots": false
	    }
	  }, [_c('div', {
	    staticClass: "d-drop-box",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.versions')) + " "), _c('span', {
	    staticClass: "icon-arrow-down52"
	  })]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [(_vm.savedStatements.length) ? [_c('li', {
	    staticClass: "to-versions__heading"
	  }, [_vm._v("Opgørelser af ansættelse")]), _vm._v(" "), _vm._l((_vm.savedStatements), function(statement) {
	    return _c('li', {
	      key: 'statement-' + statement.id,
	      on: {
	        "click": function($event) {
	          _vm.activeStatement = statement
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(_vm.statementTitle(statement)) + "\n          ")])
	  }), _vm._v(" "), (_vm.sortedVersions.length) ? _c('li', {
	    staticClass: "to-versions__heading to-versions__save--divider"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.task_versions.versions')) + "\n          ")]) : _vm._e()] : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedVersions), function(version) {
	    return _c('li', {
	      key: version.id,
	      on: {
	        "click": function($event) {
	          return _vm.selectVersion(version)
	        }
	      }
	    }, [_vm._v("\n          " + _vm._s(version.vTitle) + "\n        ")])
	  }), _vm._v(" "), (_vm.isUserSchoolAdmin) ? _c('li', {
	    staticClass: "to-versions__save",
	    class: {
	      'to-versions__save--divider': _vm.sortedVersions.length > 0 || _vm.savedStatements.length > 0
	    },
	    on: {
	      "click": _vm.openSaveModal
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.task_versions.save_new_version')) + "\n        ")]) : _vm._e()], 2)])], 1), _vm._v(" "), (_vm.activeVersion) ? _c('DModal', {
	    attrs: {
	      "showClose": false,
	      "isBgOverlay": true,
	      "appendToBody": true,
	      "isPrintable": true
	    },
	    on: {
	      "close": function($event) {
	        _vm.activeVersion = null
	      }
	    }
	  }, [_c('div', {
	    staticClass: "to-versions__modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "to-versions__modal__header no-print"
	  }, [_c('div', {
	    staticClass: "to-versions__modal__header__left pad-1-left"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.activeVersionId),
	      expression: "activeVersionId"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.activeVersionId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.selectVersionFromId(_vm.activeVersionId)
	      }]
	    }
	  }, _vm._l((_vm.sortedVersions), function(version) {
	    return _c('option', {
	      key: version.id,
	      domProps: {
	        "value": version.id
	      }
	    }, [_vm._v("\n            " + _vm._s(version.vTitle) + "\n          ")])
	  }), 0), _vm._v(" "), _c('span', {
	    staticClass: "pad-1-left"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.task_versions.saved_message')) + ": " + _vm._s(_vm.versionDateFormatted) + "\n          ")])]), _vm._v(" "), _c('div', {
	    staticClass: "to-versions__modal__header__right"
	  }, [_c('DDropdown', {
	    attrs: {
	      "isBottomStart": false
	    }
	  }, [_c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', {
	    on: {
	      "click": _vm.printVersion
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.print_all_calendars.print')) + "\n              ")]), _vm._v(" "), (_vm.isUserSchoolAdmin) ? _c('li', {
	    staticClass: "d-item-warning",
	    on: {
	      "click": _vm.setWarningToDelete
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.task_versions.delete_message')) + "\n              ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": function($event) {
	        _vm.activeVersion = null
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])], 1)]), _vm._v(" "), _c('div', {
	    ref: "versionBody",
	    staticClass: "to-versions__modal__body"
	  }, [_c('TaskOverviewUser', {
	    attrs: {
	      "user": _vm.user,
	      "version": _vm.activeVersion
	    }
	  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.activeStatement) ? _c('DModal', {
	    attrs: {
	      "appendToBody": true,
	      "isBgOverlay": true,
	      "showClose": false
	    },
	    on: {
	      "close": _vm.closeStatement
	    }
	  }, [_c('div', {
	    staticClass: "do-modal to-statement text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.activeStatementTitle))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": _vm.closeStatement
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body to-statement__body"
	  }, [_c('AssignHoursWorkedHoursStatement', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "users": [_vm.user],
	      "savedStatement": _vm.activeStatement
	    },
	    on: {
	      "title": function($event) {
	        _vm.activeStatementTitle = $event
	      }
	    }
	  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isDeleteWarningActive) ? _c('DModal', {
	    staticStyle: {
	      "z-index": "999999999"
	    },
	    attrs: {
	      "appendToBody": true,
	      "isBgOverlay": true,
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "brutto-warning text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-warning__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.common.are_you_sure_you_want_to_delete')) + "?")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": function($event) {
	        _vm.isDeleteWarningActive = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-warning__body"
	  }, [_c('svg', {
	    staticClass: "tw-icon tw-icon--red",
	    attrs: {
	      "viewBox": "0 0 24 24",
	      "fill": "none",
	      "stroke": "currentColor",
	      "stroke-width": "2",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "9",
	      "x2": "12",
	      "y2": "13"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "17",
	      "x2": "12.01",
	      "y2": "17"
	    }
	  })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.confirm_delete_message')) + " " + _vm._s(_vm.activeVersion.vTitle) + "?")]), _vm._v(" "), _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.task_versions.delete_warning_message')) + "\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-warning__footer"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isDeleteWarningActive = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn--warning bttn-danger bttn-primary--small",
	    class: [{
	      'bttn--loading': _vm.isSaving
	    }],
	    on: {
	      "click": _vm.deleteVersion
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.delete')) + "\n      ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isSaveModalActive) ? _c('DModal', {
	    attrs: {
	      "appendToBody": true,
	      "isBgOverlay": true,
	      "showClose": false
	    },
	    on: {
	      "close": _vm.closeSaveModal
	    }
	  }, [_c('div', {
	    staticClass: "to-save-version text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "to-save-version__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.save_task_overview_version')))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": _vm.closeSaveModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "to-save-version__body"
	  }, [_c('h4', {
	    staticClass: "marg-05-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.version_title')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newVersionTitle),
	      expression: "newVersionTitle"
	    }],
	    ref: "version_name_input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.newVersionTitle)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.saveVersion.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newVersionTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "text-desc"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.auto_name_description')))])]), _vm._v(" "), _c('div', {
	    staticClass: "to-save-version__footer"
	  }, [_c('button', {
	    on: {
	      "click": _vm.closeSaveModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-primary",
	    class: {
	      'bttn--loading': _vm.isSaving
	    },
	    on: {
	      "click": _vm.saveVersion
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])]) : _vm._e()], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1918 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-events text-dark"
	  }, [(_vm.type === 'swap') ? [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.edit_event.swap_headline')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue2.edit_event.swap_desc')))]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? [_c('Tabs', {
	    staticClass: "marg-1-top marg-1-bottom",
	    attrs: {
	      "tabs": _vm.tabs,
	      "selected": _vm.selectedTab
	    },
	    on: {
	      "select": _vm.selectTab
	    }
	  }), _vm._v(" "), (!_vm.isLoading && _vm.filteredEventsVProps.length < 1) ? _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.edit_event.swap_no_lessons')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.filteredEventsVProps), function(event) {
	    return _c('li', {
	      key: event.id,
	      staticClass: "d-event",
	      style: ({
	        'backgroundColor': event.color
	      })
	    }, [_c('div', {
	      staticClass: "d-event__content"
	    }, [_c('b', [_vm._v(_vm._s(event.vTitle) + ",")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(event.vDateAndTime))])]), _vm._v(" "), _c('button', {
	      staticClass: "bttn",
	      class: {
	        'bttn--loading': _vm.isSubmittingEventId === event.id
	      },
	      on: {
	        "click": function($event) {
	          return _vm.eventSwap(event)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.edit_event.select')) + "\n          ")])])
	  }), 0)] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.type === 'replace') ? [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.edit_event.replace_headline')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue2.edit_event.replace_desc')))]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.subjects.length < 1) ? _c('p', {
	    staticClass: "text-explainer marg-2-top"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.edit_event.replace_no_lessons')) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('ul', _vm._l((_vm.subjectsVProps), function(subject) {
	    return _c('li', {
	      key: subject.id,
	      staticClass: "d-subject",
	      style: ({
	        'backgroundColor': subject.color
	      })
	    }, [_c('div', [_vm._v(_vm._s(subject.vTitle))]), _vm._v(" "), _c('button', {
	      staticClass: "bttn",
	      class: {
	        'bttn--loading': _vm.isSubmittingSubjectId === subject.id
	      },
	      on: {
	        "click": function($event) {
	          return _vm.replaceEvent(subject)
	        }
	      }
	    }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.edit_event.select')) + "\n        ")])])
	  }), 0) : _vm._e()] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1919 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal",
	    class: {
	      'd-timetal--read-only': _vm.isReadOnly
	    }
	  }, [_c('div', {
	    staticClass: "d-timetal__container"
	  }, [_vm._m(0), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.grades), function(grade) {
	    return _c('th', {
	      key: grade.value
	    }, [_vm._v(_vm._s(grade.title))])
	  })], 2)]), _vm._v(" "), _c('tbody', [(!_vm.isReadOnly) ? _c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.grades), function(grade) {
	    return _c('td', {
	      staticClass: "td-is-checkbox"
	    }, [_c('button', {
	      staticClass: "bttn bttn--small hint--top",
	      attrs: {
	        "aria-label": "Sæt alle klassens fag til nul"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.nulstilKlasse(grade)
	        }
	      }
	    }, [_vm._v("Nulstil\n          ")])])
	  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.fagMedVProps), function(fag) {
	    return (!_vm.isReadOnly) ? _c('tr', {
	      key: fag.fagkode
	    }, [_c('td', [_vm._v(_vm._s(fag.title))]), _vm._v(" "), _vm._l((fag.klasser), function(klasse) {
	      return _c('td', {
	        class: [{
	          'td-is-obligatorisk': klasse.v_obligatorisk
	        }, {
	          'td-is-checkbox': klasse.hasOwnProperty('checkbox')
	        }]
	      }, [(klasse.hasOwnProperty('num')) ? _c('input', {
	        staticClass: "d-input",
	        attrs: {
	          "type": "number"
	        },
	        domProps: {
	          "value": klasse.num
	        },
	        on: {
	          "blur": function($event) {
	            return _vm.updateCell(klasse.v_originalObject, $event.target.value)
	          }
	        }
	      }) : _vm._e(), _vm._v(" "), (klasse.hasOwnProperty('checkbox') && fag._type === 'konfirmation') ? _c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': fag.v_fag.klassetrin * 1 === klasse.value * 1
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setKonfirmation(fag.v_fag, klasse.value)
	          }
	        }
	      }) : _vm._e(), _vm._v(" "), (klasse.hasOwnProperty('checkbox') && fag._type === 'praktik') ? _c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': fag.praktikkode === 'J'
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setPraktik(fag)
	          }
	        }
	      }) : _vm._e()])
	    })], 2) : _vm._e()
	  }), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized"
	  }, [_c('td', [_vm._v("Obligatorisk fagopdelt undervisning i alt")]), _vm._v(" "), _vm._l((_vm.obligatoriskFagopdelt), function(timer) {
	    return _c('td', [_vm._v(_vm._s(timer))])
	  })], 2), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized d-explainer"
	  }, [_c('td', [_vm._v("Minimumstimetal")]), _vm._v(" "), _vm._l((_vm.minimumFagopdelt), function(num, key) {
	    return _c('td', [_vm._v("(" + _vm._s(num) + ")")])
	  })], 2), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized"
	  }, [_c('td', [_vm._v("Øvrig fagopdelt undervisning i alt")]), _vm._v(" "), _vm._l((_vm.ovrigFagopdelt), function(timer) {
	    return _c('td', [_vm._v(_vm._s(timer))])
	  })], 2), _vm._v(" "), _vm._l((_vm.uuv), function(uuvfag) {
	    return (!_vm.isReadOnly) ? _c('tr', [_c('td', [_vm._v(_vm._s(uuvfag.title))]), _vm._v(" "), _vm._l((uuvfag.klasser), function(klasse) {
	      return _c('td', [(klasse.hasOwnProperty('num')) ? _c('input', {
	        staticClass: "d-input",
	        attrs: {
	          "type": "number"
	        },
	        domProps: {
	          "value": klasse.num
	        },
	        on: {
	          "blur": function($event) {
	            return _vm.updateCell(klasse.v_originalObject, $event.target.value)
	          }
	        }
	      }) : _vm._e()])
	    })], 2) : _vm._e()
	  }), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized"
	  }, [_c('td', [_vm._v("Skoleårets samlede længde\n          (= Obligatorisk fagopdelt undervisning\n          + øvrige fag + Understøttende undervisning)\n        ")]), _vm._v(" "), _vm._l((_vm.sammentaelling), function(timer) {
	    return _c('td', [_vm._v(_vm._s(timer))])
	  })], 2), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized d-explainer"
	  }, [_c('td', [_vm._v("Mindstekrav til skoleårets samlede længde")]), _vm._v(" "), _vm._l((_vm.totalMinimum), function(num, key) {
	    return _c('td', [(num > 0) ? _c('span', [_vm._v("(" + _vm._s(num) + ")")]) : _vm._e()])
	  })], 2), _vm._v(" "), _vm._l((_vm.tolaererArr), function(tolaerer) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(tolaerer.title))]), _vm._v(" "), _vm._l((tolaerer.klasser), function(klasse) {
	      return _c('td', {
	        staticClass: "td-is-checkbox"
	      }, [_c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': klasse && klasse.godkendelseskode && klasse.godkendelseskode === 'J'
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setTolaerer(klasse)
	          }
	        }
	      })])
	    })], 2)
	  }), _vm._v(" "), _vm._l((_vm.foranstaltningerMedProps), function(foranstaltning) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(foranstaltning.title))]), _vm._v(" "), _vm._l((foranstaltning.klasser), function(klasse) {
	      return _c('td', {
	        staticClass: "td-is-checkbox"
	      }, [_c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': klasse && klasse.godkendelseskode && klasse.godkendelseskode === 'J'
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setForanstaltning(klasse)
	          }
	        }
	      })])
	    })], 2)
	  })], 2)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container__header"
	  }, [_c('h4', {
	    staticClass: "uppercase"
	  }, [_vm._v("UNDERVISNING I NORMALKLASSER")])])
	}]}

/***/ }),
/* 1920 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    ref: "child_popper",
	    staticClass: "popper-container"
	  }, [(_vm.isTooltip) ? _c('div', {
	    staticClass: "desc__info text-dark"
	  }, [(_vm.isTooltipPopperDone) ? _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.activeSubjectTypeDesc)
	    }
	  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "subject-types text-dark",
	    class: {
	      'subject-types--focus': _vm.isFormElementActive
	    }
	  }, _vm._l((_vm.activeSubjectTypes), function(subjectType) {
	    return _c('div', {
	      key: subjectType.value,
	      staticClass: "subject-types__type",
	      class: {
	        'subject-types__type--selected': _vm.selectedtype === subjectType.value
	      },
	      on: {
	        "click": function($event) {
	          _vm.selectedtype = subjectType.value
	        }
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selectedtype),
	        expression: "selectedtype"
	      }],
	      attrs: {
	        "type": "radio",
	        "name": "subject[subject_type]",
	        "id": 'subject_subject_type_' + subjectType.value
	      },
	      domProps: {
	        "value": subjectType.value,
	        "checked": _vm._q(_vm.selectedtype, subjectType.value)
	      },
	      on: {
	        "change": function($event) {
	          _vm.selectedtype = subjectType.value
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": 'subject_subject_type_' + subjectType.value
	      },
	      domProps: {
	        "innerHTML": _vm._s(subjectType.name)
	      }
	    }), _vm._v(" "), _c('div', {
	      ref: "parent_popper",
	      refInFor: true,
	      staticClass: "desc",
	      on: {
	        "mouseenter": function($event) {
	          return _vm.showTooltip(subjectType.desc, $event)
	        },
	        "mouseleave": _vm.hideTooltip
	      }
	    }, [_c('svg', {
	      attrs: {
	        "width": "16px",
	        "height": "16px",
	        "viewBox": "0 0 16 16"
	      }
	    }, [_c('g', {
	      attrs: {
	        "id": "Artboard-2",
	        "stroke": "none",
	        "stroke-width": "1",
	        "fill": "none",
	        "fill-rule": "evenodd"
	      }
	    }, [_c('g', {
	      attrs: {
	        "id": "Group-2"
	      }
	    }, [_c('circle', {
	      attrs: {
	        "id": "Oval-10",
	        "fill": "#a2a3a6",
	        "cx": "8",
	        "cy": "8",
	        "r": "8"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "d": "M7.354,9.657 L7.354,9.294 C7.354,7.732 9.059,7.292 9.059,6.148 C9.059,5.51 8.652,5.191 8.014,5.191 C7.343,5.191 6.826,5.609 6.826,6.445 L5.473,6.445 C5.473,4.729 6.573,3.948 8.102,3.948 C9.389,3.948 10.533,4.608 10.533,6.005 C10.533,7.666 8.663,8.183 8.663,9.437 L8.663,9.657 L7.354,9.657 Z M7.156,11.373 C7.156,10.878 7.464,10.559 8.003,10.559 C8.509,10.559 8.85,10.878 8.85,11.34 C8.85,11.813 8.509,12.143 8.003,12.143 C7.464,12.143 7.156,11.813 7.156,11.373 Z",
	        "id": "?",
	        "fill": "#FFFFFF"
	      }
	    })])])])])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 1921 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isInPrintMode || _vm.eventsFiltered.length > 0) ? _c('ul', {
	    ref: "d_weekplan",
	    staticClass: "weekplan box text-dark",
	    class: {
	      'weekplan--editable': !_vm.isReadOnly
	    }
	  }, [(!_vm.isInViewport) ? _c('div', {
	    staticClass: "weekplan-placeholder box",
	    style: (_vm.placeholderHeight)
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale].weekplan))]), _vm._v(" "), (_vm.isWeekplanHasLesson) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isInViewport) ? [_c('div', {
	    ref: "d_eip",
	    staticClass: "deip-holder",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [(_vm.activeEvent) ? _c('EIP', {
	    attrs: {
	      "activeEIP": _vm.activeEIP,
	      "lesson": _vm.activeEvent,
	      "noteType": _vm.activeNoteType,
	      "isUploadFile": false,
	      "isClosingWithoutSaving": _vm.isClosingWithoutSaving,
	      "isSaving": _vm.isSavingEIP
	    },
	    on: {
	      "changed": _vm.setIsEditorChangedWithoutSave,
	      "close": _vm.closeEip
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('h2', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].weekplan))]), _vm._v(" "), (_vm.weekNote !== undefined && _vm.calendar && _vm.calendar.type === 'klass') ? _c('div', {
	    staticClass: "week_note"
	  }, [(_vm.isReadOnly) ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.weekNote)
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isReadOnly) ? _c('div', {
	    staticClass: "weekplan--grid__note",
	    class: [{
	      'weekplan--grid__note--open': _vm.activeEventId === _vm.calendar.id + '_' + 'weeknote'
	    }, {
	      'weekplan--grid__note--empty': _vm.weekNote.length < 1
	    }],
	    attrs: {
	      "id": _vm.calendar.id + '_' + 'weeknote'
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setActiveEip(null, 'weeknote', _vm.calendar.id + '_' + 'weeknote', $event)
	      }
	    }
	  }, [(_vm.activeEventId !== _vm.calendar.id + '_' + 'weeknote') ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.weekNote)
	    }
	  }) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isWeekplanHasLesson) ? _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].no_events_this_week))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.eventsWithinDays), function(day, key) {
	    return (day.lessons.length !== 0) ? _c('li', {
	      key: day.date,
	      staticClass: "weekplan__day-change"
	    }, [_c('h3', [_vm._v(_vm._s(_vm.filterLocaleDate(day.date)))]), _vm._v(" "), _c('div', {
	      staticClass: "weekplan__grid day-change__headline"
	    }, [_c('p', {
	      staticClass: "weekplan__grid__title"
	    }, [(_vm.calendar.type !== 'other') ? void 0 : _vm._e()], 2), _vm._v(" "), _c('p', [(_vm.calendar.type !== 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].learning_goal))] : _vm._e(), _vm._v(" "), (_vm.calendar.type === 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].meeting_purpose))] : _vm._e()], 2), _vm._v(" "), _c('p', [(_vm.calendar.type !== 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].content))] : _vm._e(), _vm._v(" "), (_vm.calendar.type === 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].agenda))] : _vm._e()], 2), _c('p', [(_vm.calendar.type !== 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].pupil_preparation))] : _vm._e(), _vm._v(" "), (_vm.calendar.type === 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].decisions_and_resume))] : _vm._e()], 2), _vm._v(" "), _c('p', [(_vm.calendar.type !== 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].teacher_notes))] : _vm._e()], 2), _vm._v(" "), (_vm.calendar.type === 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].internal_notes))] : _vm._e()], 2), _vm._v(" "), _c('ul', _vm._l((day.lessons), function(event) {
	      return _c('li', {
	        key: event.event_id,
	        staticClass: "week-plan__lesson__box week-plan__lesson__note weekplan__grid",
	        class: {
	          'lesson__notes--readonly': _vm.isReadOnly
	        },
	        style: ({
	          borderColor: event.color
	        })
	      }, [_c('div', {
	        staticClass: "weekplan__grid__title"
	      }, [_c('span', {
	        staticClass: "bold"
	      }, [_vm._v(_vm._s(event.title))]), (_vm.isCalendarAUser && event.vKlasses) ? _c('span', [_vm._v(", " + _vm._s(event.vKlasses))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$filters.timeStamp(event.start)) + " - " + _vm._s(_vm.$filters.timeStamp(event.end))), _c('br')])]), _vm._v(" "), _c('div', {
	        staticClass: "weekplan--grid__note",
	        class: [{
	          'weekplan--grid__note--open': _vm.activeEventId === event.event_id + '_' + 'learning_goal'
	        }, {
	          'weekplan--grid__note--empty': event.learning_goal.length < 1
	        }],
	        attrs: {
	          "id": event.event_id + '_' + 'learning_goal'
	        },
	        on: {
	          "click": function($event) {
	            $event.preventDefault();
	            return _vm.setActiveEip(event, 'learning_goal', event.event_id + '_' + 'learning_goal', $event)
	          }
	        }
	      }, [(_vm.activeEventId !== event.event_id + '_' + 'learning_goal') ? _c('span', {
	        domProps: {
	          "innerHTML": _vm._s(event.learning_goal)
	        }
	      }) : _vm._e()]), _vm._v(" "), _c('div', {
	        staticClass: "weekplan--grid__note",
	        class: [{
	          'weekplan--grid__note--open': _vm.activeEventId === event.event_id + '_' + 'description'
	        }, {
	          'weekplan--grid__note--empty': event.description.length < 1
	        }],
	        attrs: {
	          "id": event.event_id + '_' + 'description'
	        },
	        on: {
	          "click": function($event) {
	            $event.preventDefault();
	            return _vm.setActiveEip(event, 'description', event.event_id + '_' + 'description', $event)
	          }
	        }
	      }, [(_vm.activeEventId !== event.event_id + '_' + 'description') ? _c('span', {
	        domProps: {
	          "innerHTML": _vm._s(event.description)
	        }
	      }) : _vm._e()]), _vm._v(" "), _c('div', {
	        staticClass: "weekplan--grid__note",
	        class: [{
	          'weekplan--grid__note--open': _vm.activeEventId === event.event_id + '_' + 'notes_for_students'
	        }, {
	          'weekplan--grid__note--empty': event.notes_for_students.length < 1
	        }],
	        attrs: {
	          "id": event.event_id + '_' + 'notes_for_students'
	        },
	        on: {
	          "click": function($event) {
	            $event.preventDefault();
	            return _vm.setActiveEip(event, 'notes_for_students', event.event_id + '_' + 'notes_for_students', $event)
	          }
	        }
	      }, [(_vm.activeEventId !== event.event_id + '_' + 'notes_for_students') ? _c('span', {
	        domProps: {
	          "innerHTML": _vm._s(event.notes_for_students)
	        }
	      }) : _vm._e()]), _vm._v(" "), _c('div', {
	        staticClass: "weekplan--grid__note",
	        class: [{
	          'weekplan--grid__note--open': _vm.activeEventId === event.event_id + '_' + 'teacher_notes'
	        }, {
	          'weekplan--grid__note--empty': event.teacher_notes.length < 1
	        }],
	        attrs: {
	          "id": event.event_id + '_' + 'teacher_notes'
	        },
	        on: {
	          "click": function($event) {
	            $event.preventDefault();
	            return _vm.setActiveEip(event, 'teacher_notes', event.event_id + '_' + 'teacher_notes', $event)
	          }
	        }
	      }, [(_vm.activeEventId !== event.event_id + '_' + 'teacher_notes') ? _c('span', {
	        domProps: {
	          "innerHTML": _vm._s(event.teacher_notes)
	        }
	      }) : _vm._e()])])
	    }), 0)]) : _vm._e()
	  })] : _vm._e()], 2) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1922 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container"
	  }, [_c('div', {
	    staticClass: "d-guides"
	  }, [_c('StilGuides', {
	    attrs: {
	      "video-id": 'etaeiteazYM?start=67',
	      "textForLink": "Guide: Se videoguide for Personalets alder og køn"
	    }
	  }), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-filters"
	  }, [_c('div', {
	    staticClass: "d-filters__filter",
	    class: {
	      'd-filters__filter--active': _vm.activeFilter === 0
	    },
	    on: {
	      "click": function($event) {
	        _vm.activeFilter = 0
	      }
	    }
	  }, [_vm._v("Alle\n      "), _c('div', {
	    staticClass: "d-pill"
	  }, [_vm._v(_vm._s(_vm.usersWithVProps.length))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-filters__filter",
	    class: {
	      'd-filters__filter--active': _vm.activeFilter === 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.activeFilter = 1
	      }
	    }
	  }, [_vm._v("Ikke udfyldte\n      "), _c('div', {
	    staticClass: "d-pill"
	  }, [_vm._v(_vm._s(_vm.unfilledUsers.length))])])]), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredUsersWithVProps), function(user, userIdx) {
	    return _c('tr', {
	      key: user.id
	    }, [_c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.gender),
	        expression: "user.gender"
	      }],
	      staticClass: "timetal-select",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(user, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, function($event) {
	          return _vm.updateUser(user, 'gender', $event.target.value)
	        }]
	      }
	    }, [_c('option', {
	      attrs: {
	        "value": "female"
	      }
	    }, [_vm._v("Kvinde")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "male"
	      }
	    }, [_vm._v("Mand")])])]), _vm._v(" "), _c('td', [_c('input', {
	      attrs: {
	        "type": "date"
	      },
	      domProps: {
	        "value": user.v_birthday
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateUser(user, 'dob', $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_stilling),
	        expression: "user.v_stil_stilling"
	      }],
	      staticClass: "timetal-select",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(user, "v_stil_stilling", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, function($event) {
	          return _vm.updateUser(user, 'stil_stilling', $event.target.value)
	        }]
	      }
	    }, [_c('option', {
	      attrs: {
	        "value": "LA"
	      }
	    }, [_vm._v("Lærer")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "BH"
	      }
	    }, [_vm._v("Børnehaveklasseleder")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "PA"
	      }
	    }, [_vm._v("Pædagog")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "LE"
	      }
	    }, [_vm._v("Leder")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "AN"
	      }
	    }, [_vm._v("Andre med undervisningsopgaver")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "undtaget"
	      }
	    }, [_vm._v("Ingen undervisningsopgaver (ikke indberet)")])])])])
	  }), 0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "italic"
	  }, [_vm._v("Bemærk: Det er de personaler, som er ansat på skolen pr. 5. september 2022, der skal\n      indberettes.\n      "), _c('br'), _vm._v("Personale der ikke skal indberettes sættes til \"Ingen undervisningsopgaver (ikke indberet)\"")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "d-table__name"
	  }, [_vm._v("Navn")]), _vm._v(" "), _c('th', [_vm._v("Mand / Kvinde")]), _vm._v(" "), _c('th', [_vm._v("Fødselsdato")]), _vm._v(" "), _c('th', [_vm._v("Stilling")])])])
	}]}

/***/ }),
/* 1923 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "user-overview-tabs"
	  }, [(_vm.tabs.length > 1) ? _c('div', {
	    staticClass: "user-overview-tabs__tabs no-print"
	  }, [_c('Tabs', {
	    attrs: {
	      "tabs": _vm.tabs,
	      "selected": _vm.activeView,
	      "isLarge": true
	    },
	    on: {
	      "select": function($event) {
	        _vm.theView = $event
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeView === 'tasks') ? _c('TaskOverviewPage', {
	    attrs: {
	      "user_id": _vm.user.id,
	      "user_calendar_id": _vm.user.user_calendar_id,
	      "user_name": _vm.user.name,
	      "isCanSeeOtherUsers": false
	    }
	  }) : _c('UserTasks', {
	    attrs: {
	      "user_id": _vm.user.id,
	      "user_calendar_id": _vm.user.user_calendar_id,
	      "user_name": _vm.user.name,
	      "initialStartDate": _vm.initialStartDate,
	      "initialEndDate": _vm.initialEndDate,
	      "initialIsShowScheduled": _vm.initialIsShowScheduled,
	      "isShowPrintButton": true,
	      "isCanSeeOtherUsers": false
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1924 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bttn",
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createroom_button.create_room')))])
	},staticRenderFns: []}

/***/ }),
/* 1925 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "flex"
	  }, [_c('div', {
	    staticClass: "header-container box-shadow"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "nav"
	  }, [_c('div', {
	    staticClass: "nav-left"
	  }, [_c('v-touch', {
	    staticClass: "touch-container mobile-nav",
	    on: {
	      "tap": _vm.sendClick
	    }
	  }, [_c('div', {
	    staticClass: "flex"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.isMonth))]), _vm._v(" "), _c('span', {
	    staticClass: "icon",
	    class: {
	      'icon-arrow-up5': !_vm.showdatepicker,
	      'icon-arrow-down5': _vm.showdatepicker
	    }
	  })])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "nav-right"
	  }, [_c('v-touch', {
	    staticClass: "pad-10-right",
	    on: {
	      "tap": function($event) {
	        return _vm.$emit('menu')
	      }
	    }
	  }, [_c('button', {
	    staticClass: "left-button nav-button"
	  }, [_c('span', {
	    staticClass: "icon-menu"
	  })])])], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "docendo-logo box-shadow"
	  }, [_c('span', {
	    staticClass: "icon-docendo docendo-logo__icon",
	    attrs: {
	      "id": "d-icon"
	    }
	  })])
	}]}

/***/ }),
/* 1926 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "basis-overview text-dark"
	  }, [_c('div', {
	    staticClass: "basis-overview__header"
	  }, [_c('h1', [_vm._v("Basis Hours")]), _vm._v(" "), _c('div', {
	    staticClass: "basis-overview__dates"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "do-spinner"
	  }) : _vm._e(), _vm._v(" "), _c('Tabs', {
	    attrs: {
	      "tabs": [{
	        id: 'hours',
	        title: 'Hours'
	      }, {
	        id: 'minutes',
	        title: 'Minutes'
	      }],
	      "selected": _vm.theSelectedTab
	    },
	    on: {
	      "select": function($event) {
	        _vm.theSelectedTab = $event
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    class: {
	      'do-bttn--loading': _vm.isDownloading
	    },
	    on: {
	      "click": _vm.asyncLoadXLSXAndDownload
	    }
	  }, [_vm._v("Download\n        to excel\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "do-button__multiple"
	  }, [_c('button', {
	    staticClass: "do-button__multiple__bttn icon-arrow-left4",
	    on: {
	      "click": _vm.setPrevWeek
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "do-button__multiple__bttn",
	    class: {
	      'bttn--disabled': _vm.isThisWeek
	    },
	    on: {
	      "click": _vm.setThisWeek
	    }
	  }, [_vm._v("This\n          week\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-button__multiple__bttn icon-arrow-right4",
	    on: {
	      "click": _vm.setNextWeek
	    }
	  })]), _vm._v(" "), _c('DatePickerRange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "basis-overview__body"
	  }, [_c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', _vm._l((_vm.col1), function(col) {
	    return _c('th', {
	      style: ({
	        backgroundColor: col.color ? col.color : null
	      }),
	      attrs: {
	        "rowspan": col.rowspan ? col.rowspan : 1,
	        "colspan": col.colspan ? col.colspan : 1
	      }
	    }, [_c('div', [_vm._v("\n            " + _vm._s(col.name) + "\n          ")])])
	  }), 0), _vm._v(" "), _c('tr', _vm._l((_vm.col2), function(col) {
	    return _c('th', {
	      style: ({
	        backgroundColor: col.color ? col.color : null
	      }),
	      attrs: {
	        "rowspan": col.rowspan ? col.rowspan : 1,
	        "colspan": col.colspan ? col.colspan : 1
	      }
	    }, [_vm._v("\n          " + _vm._s(col.name) + "\n        ")])
	  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.usersWithVEvents), function(user) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(user.employee_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.openEdit(user, user.v_presence, 'weeklyHours', $event)
	        }
	      }
	    }, [_vm._v("\n          " + _vm._s(user.v_presence) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_subject))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_break))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_tasks))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_preparation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_substitute_teaching))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_substitute_not_teaching))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_hours_left))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_absence))])])
	  }), 0)]), _vm._v(" "), (_vm.theEditNumberUser) ? _c('div', {
	    ref: "popper_child",
	    staticClass: "popper_child"
	  }, [_c('transition', {
	    attrs: {
	      "name": "scale"
	    }
	  }, [(_vm.isDropdownPopperDone) ? _c('div', {
	    staticClass: "number__input-opened"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.theEditNumberNumber),
	      expression: "theEditNumberNumber",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "focus",
	      rawName: "v-focus"
	    }, {
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeEditing),
	      expression: "closeEditing"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.theEditNumberNumber)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.doneEditing.apply(null, arguments)
	      },
	      "change": function($event) {
	        _vm.theEditNumberNumber = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn--primary",
	    class: {
	      'bttn--small--loading': _vm.isUpdatingNumber
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.doneEditing.apply(null, arguments)
	      }
	    }
	  }, [(!_vm.isUpdatingNumber) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.common.save')))]) : _vm._e()])]) : _vm._e()])], 1) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1927 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "toast",
	    class: [{
	      'toastSuccess': _vm.toast.success
	    }, {
	      'toast--left-bottom': _vm.leftBottom
	    }, {
	      'animated fadeInDown': !_vm.leftBottom
	    }, {
	      'animateFast fadeInUp': _vm.leftBottom
	    }],
	    style: (_vm.styleObj)
	  }, [_c('div', {
	    staticClass: "toast-content"
	  }, [(_vm.toast.success) ? _c('div', {
	    staticClass: "toast__icon toast_icon__success icon-checkmark-circle"
	  }) : _vm._e(), _vm._v(" "), (!_vm.toast.success) ? _c('div', {
	    staticClass: "toast__icon toast_icon__bell icon-bell"
	  }) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.toast.text))])]), _vm._v(" "), _c('div', {
	    staticClass: "cross pointer",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('removeNow', _vm.toast.id)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1928 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-shortcuts__container"
	  }, [_c('DDropdown', {
	    attrs: {
	      "isShowDots": false
	    }
	  }, [_c('div', {
	    staticClass: "d-drop-box",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v(_vm._s(_vm.title) + " "), _c('span', {
	    staticClass: "icon-arrow-down52"
	  })]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, _vm._l((_vm.shortcuts), function(shortcut) {
	    return _c('li', {
	      key: shortcut.val,
	      on: {
	        "click": function($event) {
	          return _vm.$emit('shortcutSelected', shortcut.dateRange)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(shortcut.title) + "\n      ")])
	  }), 0)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1929 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true,
	      "ariaLabel": "Omlagt dag"
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "sdc text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "sdc__topbar"
	  }, [_c('div', {
	    staticClass: "sdc__topbar__main"
	  }, [_c('div', {
	    staticClass: "sdc__field sdc__field--title"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Navn")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.title),
	      expression: "form.title"
	    }, {
	      name: "focus",
	      rawName: "v-focus"
	    }],
	    ref: "input_title",
	    staticClass: "d-input",
	    attrs: {
	      "type": "text",
	      "placeholder": "F.eks. Motionsdag"
	    },
	    domProps: {
	      "value": (_vm.form.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.form, "title", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "sdc__field sdc__field--classes"
	  }, [_c('div', {
	    staticClass: "sdc__label-row"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Klasser")]), _vm._v(" "), _c('button', {
	    staticClass: "sdc__link",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.toggleAllClasses
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.allClassesSelected ? 'Ryd' : 'Vælg alle') + "\n            ")])]), _vm._v(" "), _c('DSelectCals', {
	    attrs: {
	      "items": _vm.klassCalendars,
	      "itemsSelected": _vm.selectedClasses,
	      "placeholder": "Vælg klasser"
	    },
	    on: {
	      "update": _vm.onClassesUpdate
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "sdc__field sdc__field--toggle"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Reducer på fagtimer i klassen")]), _vm._v(" "), _c('div', {
	    staticClass: "sdc__toggler",
	    class: {
	      'sdc__toggler--active': _vm.form.reduct
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.form.reduct = !_vm.form.reduct
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.form.reduct
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "sdc__toggler__text"
	  }, [_vm._v(_vm._s(_vm.form.reduct ? 'Ja' : 'Nej'))])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle sdc__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "sdc__body"
	  }, [(_vm.isLoadingExisting) ? _c('Loader') : [_c('div', {
	    staticClass: "sdc__calendar-head"
	  }, [(_vm.rangeStart) ? _c('span', {
	    staticClass: "sdc__period"
	  }, [_vm._v(_vm._s(_vm.rangeLabel))]) : _c('span', {
	    staticClass: "sdc__period sdc__period--empty"
	  }, [_vm._v("Klik på en dag for at vælge fra- og til-dato")]), _vm._v(" "), (_vm.rangeStart) ? _c('button', {
	    staticClass: "sdc__link",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.clearRange
	    }
	  }, [_vm._v("Ryd")]) : _vm._e()]), _vm._v(" "), (_vm.hasTriedSave && _vm.selectedClasses.length === 0) ? _c('p', {
	    staticClass: "sdc__warning"
	  }, [_vm._v("Vælg mindst én klasse")]) : _vm._e(), _vm._v(" "), (_vm.hasTriedSave && !_vm.rangeStart) ? _c('p', {
	    staticClass: "sdc__warning"
	  }, [_vm._v("Vælg en periode i kalenderen")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "sdc__calendar"
	  }, _vm._l((_vm.months), function(month) {
	    return _c('div', {
	      key: month.key,
	      staticClass: "sdc__month-row"
	    }, [_c('div', {
	      staticClass: "sdc__month-name"
	    }, [_vm._v(_vm._s(month.label))]), _vm._v(" "), _c('div', {
	      staticClass: "sdc__days"
	    }, _vm._l((month.days), function(day) {
	      return _c('div', {
	        key: day.date,
	        staticClass: "sdc__day",
	        class: {
	          'sdc__day--out': !day.selectable,
	          'sdc__day--weekend': day.isWeekend,
	          'sdc__day--in-range': _vm.isInRange(day),
	          'sdc__day--start': day.date === _vm.rangeStart,
	          'sdc__day--end': day.date === _vm.effectiveEnd
	        },
	        on: {
	          "click": function($event) {
	            return _vm.selectDay(day)
	          }
	        }
	      }, [_vm._v("\n                " + _vm._s(day.label) + "\n              ")])
	    }), 0)])
	  }), 0)]], 2), _vm._v(" "), _c('div', {
	    staticClass: "sdc__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    attrs: {
	      "disabled": _vm.isSaving
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': !_vm.isValid || _vm.isSaving,
	      'do-bttn--submit--loading': _vm.isSaving
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("Gem")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1930 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "datepicker-container text-dark"
	  }, [_c('div', {
	    staticClass: "datepicker-panel no-select box-shadow",
	    class: {
	      'no_weekends': !_vm.weekends
	    },
	    attrs: {
	      "id": "datepicker-panel"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "calBoxContainer"
	    }
	  }, [_c('div', {
	    staticClass: "datepicker-cells",
	    attrs: {
	      "id": "calBox"
	    }
	  }, [_c('ul', {
	    staticClass: "week-row"
	  }, _vm._l((_vm.weekdays), function(day) {
	    return _c('li', {
	      key: day,
	      staticClass: "datepicker-cell"
	    }, [_vm._v(_vm._s(day) + "\n          ")])
	  }), 0), _vm._v(" "), _vm._l((_vm.datesInWeeks), function(weeks) {
	    return _c('div', {
	      staticClass: "week-row"
	    }, _vm._l((weeks.dates), function(date) {
	      return _c('div', {
	        class: 'datepicker-cell ' + date.dayClass
	      }, [_c('v-touch', {
	        on: {
	          "tap": function($event) {
	            return _vm.setDate(date)
	          }
	        }
	      }, [(date.show) ? _c('span', {
	        staticClass: "number",
	        class: [{
	          isToday: date.isToday,
	          active: date.isSelected
	        }]
	      }, [_vm._v("\n                    " + _vm._s(date.showDate) + "\n                ")]) : _c('span', {
	        staticClass: "number",
	        class: [{
	          isToday: date.isToday,
	          active: date.isSelected
	        }]
	      }, [_vm._v("\n                    " + _vm._s(date.showDate) + "\n              ")])])], 1)
	    }), 0)
	  })], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 1931 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('div', {
	    staticClass: "box grid grid-responsive week_notes_lesson_note",
	    style: ({
	      borderColor: _vm.event.color
	    })
	  }, [_c('div', {
	    staticClass: "col-2-12 box-size"
	  }, [_c('h3', {
	    style: ({
	      color: _vm.event.color
	    })
	  }, [_vm._v(_vm._s(_vm.event.title))]), _vm._v(" "), _c('span', {
	    staticClass: "bold"
	  }, [_c('span', {
	    staticClass: "icon-clock"
	  }), _vm._v(" " + _vm._s(_vm.$filters.timeStamp(_vm.event.start)) + " - " + _vm._s(_vm.$filters.timeStamp(_vm.event.end))), _c('br')])]), _vm._v(" "), _c('div', {
	    staticClass: "col-10-12"
	  }, [(_vm.checkLengthWithoutHTML(_vm.event.learning_goal)) ? _c('div', {
	    staticClass: "col-1-3"
	  }, [_c('p', {
	    style: ({
	      color: _vm.event.color
	    })
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.learning_goal')))])]), _vm._v(" "), _c('div', {
	    staticClass: "word-break",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.learning_goal)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.checkLengthWithoutHTML(_vm.event.description)) ? _c('div', {
	    staticClass: "col-1-3"
	  }, [_c('p', {
	    style: ({
	      color: _vm.event.color
	    })
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.content')) + " ")])]), _vm._v(" "), _c('div', {
	    staticClass: "word-break",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.description)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.checkLengthWithoutHTML(_vm.event.notes_for_students)) ? _c('div', {
	    staticClass: "col-1-3"
	  }, [_c('p', {
	    style: ({
	      color: _vm.event.color
	    })
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.pupil_preparation')))])]), _vm._v(" "), _c('div', {
	    staticClass: "word-break",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.notes_for_students)
	    }
	  })]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 1932 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "nav",
	    class: {
	      notTouchingSideNav: !_vm.touchingSideNav
	    },
	    style: ({
	      webkitTransform: 'translateX(' + _vm.translateX + ')'
	    }),
	    on: {
	      "transitionend": _vm.sendView
	    }
	  }, [_c('div', {
	    staticClass: "header"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.calName))])]), _vm._v(" "), _c('div', {
	    staticClass: "nav-menu"
	  }, [_c('ul', {
	    staticClass: "nav-menu__list"
	  }, [_c('li', {
	    staticClass: "nav-title"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue.public.app.sidenav.changeview')) + "\n          ")]), _vm._v(" "), _c('v-touch', {
	    staticClass: "list-item",
	    on: {
	      "tap": function($event) {
	        return _vm.setView(1)
	      }
	    }
	  }, [_c('li', [_vm._v(_vm._s(_vm.$t('vue.public.app.sidenav.showday')))])]), _vm._v(" "), _c('v-touch', {
	    staticClass: "list-item",
	    on: {
	      "tap": function($event) {
	        return _vm.setView(3)
	      }
	    }
	  }, [_c('li', [_vm._v(_vm._s(_vm.$t('vue.public.app.sidenav.showweek')))])]), _vm._v(" "), _c('v-touch', {
	    staticClass: "list-item",
	    on: {
	      "tap": function($event) {
	        return _vm.setView(2)
	      }
	    }
	  }, [_c('li', [_vm._v(_vm._s(_vm.$t('vue.public.app.sidenav.showweekplan')))])]), _vm._v(" "), _c('div', {
	    staticClass: "divider"
	  }), _vm._v(" "), _c('li', {
	    staticClass: "nav-title"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('repitition.chooselanguage')) + "\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "list-item"
	  }, [_c('set-locale', {
	    on: {
	      "locale": _vm.emitLocale
	    }
	  })], 1)], 1)])]), _vm._v(" "), (_vm.menu) ? _c('v-touch', {
	    on: {
	      "panstart": _vm.onPanStart,
	      "panend": _vm.onPanEnd,
	      "pan": _vm.moveMenu,
	      "tap": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "drag-target"
	  })]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "opacity"
	    }
	  }, [(_vm.menu) ? _c('div', {
	    staticClass: "nav-overlay"
	  }) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1933 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tbody', {
	    staticClass: "user-list__user__table__tbody"
	  }, _vm._l((_vm.events), function(event) {
	    return _c('tr', {
	      key: event.event_id,
	      staticClass: "user-list__user__table__event",
	      class: {
	        'user-list__user__table__event--special': event.v_is_special,
	        'user-list__user__table__event--zeroed': event.zero
	      }
	    }, [_c('td', [_vm._v(_vm._s(event.v_start_and_endtime) + " | "), (event.v_is_special) ? _c('span', {
	      staticClass: "d-tag"
	    }, [_vm._v(_vm._s(event.title))]) : _c('b', [_vm._v(_vm._s(event.title))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(event.v_calendar_name))]), _vm._v(" "), _c('td', [_c('span', {
	      staticClass: "d-tag"
	    }, [_vm._v(_vm._s(event.v_event_type_name))])]), _vm._v(" "), _c('td', [_vm._v("\n    " + _vm._s(event.v_substitute_for_name) + "\n    "), (event.v_substitute_for_employments.length > 0) ? _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return event.v_substitute_for_employments.length > 1; }
	        }),
	        expression: "{\n                          arrow: true,\n                          animateFill: false,\n                          animation : 'shift-away',\n                          zIndex: '999999992',\n                          boundary: 'window',\n                          onShow: () => event.v_substitute_for_employments.length > 1\n                        }"
	      }],
	      staticClass: "d-tag",
	      attrs: {
	        "content": event.v_substitute_for_employments
	      }
	    }, [_vm._v("\n                    " + _vm._s(event.v_substitute_for_employments[0]) + "\n                    "), (event.v_substitute_for_employments.length > 1) ? [_vm._v("m.fl.")] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticClass: "td-employment"
	    }, [_c('div', {
	      staticClass: "td-employment__value"
	    }, [(_vm.userDay.state === 'draft') ? [(_vm.user.v_user_active_employments.length < 1) ? _c('p', {
	      staticClass: "text-explainer"
	    }, [_vm._v("Ingen ansættelser")]) : _c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model.number",
	        value: (event.employment_id),
	        expression: "event.employment_id",
	        modifiers: {
	          "number": true
	        }
	      }, {
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !!event.v_employment_details_tip; }
	        }),
	        expression: "{\n                  arrow: true,\n                  animateFill: false,\n                  animation: 'shift-away',\n                  zIndex: '999999992',\n                  boundary: 'window',\n                  onShow: () => !!event.v_employment_details_tip\n                }"
	      }],
	      staticClass: "no-print",
	      attrs: {
	        "content": event.v_employment_details_tip
	      },
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return _vm._n(val)
	          });
	          _vm.$set(event, "employment_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, function($event) {
	          return _vm.updatePropOnLesson('employment_id', _vm.user, _vm.userDay, event, $event.target.value)
	        }]
	      }
	    }, _vm._l((_vm.user.v_user_active_employments), function(userEmployment) {
	      return _c('option', {
	        key: userEmployment.id,
	        domProps: {
	          "value": Number(userEmployment.id)
	        }
	      }, [_vm._v("\n            " + _vm._s(userEmployment.title) + "\n          ")])
	    }), 0), _vm._v(" "), _c('span', {
	      staticClass: "only-print",
	      class: {
	        'italic': event.v_employment_id_title === 'Ingen valgt'
	      }
	    }, [_vm._v("\n          " + _vm._s(event.v_employment_id_title) + "\n        ")])] : _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !!event.v_employment_details_tip; }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation: 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !!event.v_employment_details_tip\n            }"
	      }],
	      class: {
	        'd-tag': event.v_employment_id_title && event.v_employment_id_title !== 'Ingen valgt'
	      },
	      attrs: {
	        "content": event.v_employment_details_tip
	      }
	    }, [_vm._v(_vm._s(event.v_employment_id_title) + "\n      ")]), _vm._v(" "), (event.v_employment_source_tip) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n          arrow: true,\n          animateFill: false,\n          animation: 'shift-away',\n          zIndex: '999999992',\n          boundary: 'window'\n        }"
	      }],
	      staticClass: "td-employment__help no-print",
	      attrs: {
	        "content": event.v_employment_source_tip
	      }
	    }, [_c('span', {
	      staticClass: "icon-question3"
	    })]) : _vm._e()], 2)]), _vm._v(" "), (_vm.isSalaryIntegrationActive) ? _c('td', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model.number",
	        value: (event.salary_code_id),
	        expression: "event.salary_code_id",
	        modifiers: {
	          "number": true
	        }
	      }],
	      staticClass: "do-select",
	      attrs: {
	        "disabled": _vm.userDay.state !== 'draft'
	      },
	      on: {
	        "input": function($event) {
	          return _vm.updatePropOnLesson('salary_code_id', _vm.user, _vm.userDay, event, $event.target.value)
	        },
	        "change": function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return _vm._n(val)
	          });
	          _vm.$set(event, "salary_code_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }
	      }
	    }, [_c('option', {
	      attrs: {
	        "value": ""
	      }
	    }), _vm._v(" "), _vm._l((_vm.salaryCodes), function(salaryCode) {
	      return _c('option', {
	        key: salaryCode.id,
	        domProps: {
	          "value": salaryCode.id
	        }
	      }, [_vm._v("\n        " + _vm._s(salaryCode.name) + "\n      ")])
	    })], 2)]) : _vm._e(), _vm._v(" "), (_vm.costCenters.length > 0) ? _c('td', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (event.afv_omkostningssted),
	        expression: "event.afv_omkostningssted"
	      }],
	      staticClass: "no-print",
	      attrs: {
	        "disabled": _vm.userDay.state !== 'draft'
	      },
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(event, "afv_omkostningssted", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, function($event) {
	          return _vm.updatePropOnLesson('afv_omkostningssted', _vm.user, _vm.userDay, event, event.afv_omkostningssted)
	        }]
	      }
	    }, [_c('option', {
	      domProps: {
	        "value": null
	      }
	    }), _vm._v(" "), _vm._l((_vm.costCenters), function(costCenter) {
	      return _c('option', {
	        key: costCenter.code,
	        domProps: {
	          "value": costCenter.code
	        }
	      }, [_vm._v("\n        " + _vm._s(costCenter.title) + "\n      ")])
	    })], 2)]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n    " + _vm._s(event.minutes) + " min.\n  ")]), _vm._v(" "), _c('td', {
	      staticClass: "td-zero-toggle no-print"
	    }, [(_vm.userDay.state === 'draft') ? _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n        arrow: true,\n        animateFill: false,\n        animation: 'shift-away',\n        zIndex: '999999992',\n        boundary: 'window'\n      }"
	      }],
	      staticClass: "do-zero-bttn",
	      class: {
	        'do-zero-bttn--active': event.zero
	      },
	      attrs: {
	        "content": event.zero ? 'Gendan linje' : 'Nulstil linje'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.updatePropOnLesson('zero', _vm.user, _vm.userDay, event, !event.zero)
	        }
	      }
	    }, [(!event.zero) ? _c('span', {
	      staticClass: "icon-bin"
	    }) : _c('svg', {
	      staticClass: "do-zero-bttn__undo-icon",
	      attrs: {
	        "viewBox": "0 0 24 24",
	        "fill": "none",
	        "stroke": "currentColor",
	        "stroke-width": "2.5",
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round"
	      }
	    }, [_c('polyline', {
	      attrs: {
	        "points": "1 4 1 10 7 10"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "d": "M3.51 15a9 9 0 1 0 2.13-9.36L1 10"
	      }
	    })])]) : _vm._e()])])
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 1934 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "export-calendar text-dark"
	  }, [(_vm.isShowButton) ? _c('button', {
	    staticClass: "bttn bttn--is-loading",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModal(true)
	      }
	    }
	  }, [(_vm.calLink === 'loading') ? _c('spinner', {
	    staticStyle: {
	      "margin": "0"
	    },
	    attrs: {
	      "size": "small",
	      "color": "blue"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.calLink.length > 0 && _vm.calLink !== 'loading') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.export_calendar')))]) : _vm._e(), _vm._v(" "), (_vm.calLink.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.guide_to_export_calendar')))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isModal) ? _c('d-modal', {
	    attrs: {
	      "show-close": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "modal__left"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.export_calendar_to')))]), _vm._v(" "), _c('ul', {
	    staticClass: "export-calendar__cals"
	  }, _vm._l((_vm.integrations), function(integration) {
	    return _c('li', {
	      key: integration.id,
	      class: {
	        'cal--is-active': _vm.theActiveIntegration === integration.id
	      },
	      on: {
	        "click": function($event) {
	          _vm.theActiveIntegration = integration.id
	        }
	      }
	    }, [_c('div', {
	      staticClass: "integration-img",
	      style: ({
	        'background-image': 'url(' + integration.icon + ')'
	      })
	    }), _vm._v("\n              " + _vm._s(integration.title) + "\n            ")])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "modal__right"
	  }, [(_vm.calLink.length > 0) ? [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.copy_the_url_and_insert')))]), _vm._v(" "), _c('input', {
	    staticClass: "marg-20-bottom",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm.calLink
	    },
	    on: {
	      "click": function($event) {
	        return $event.target.select()
	      }
	    }
	  })] : _vm._e(), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.guide_to')) + " " + _vm._s(_vm.integrations[_vm.theActiveIntegration].title))]), _vm._v(" "), _vm._l((_vm.integrations[_vm.theActiveIntegration].imgs), function(img) {
	    return _c('img', {
	      attrs: {
	        "src": img,
	        "alt": ""
	      }
	    })
	  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.isModal) ? _c('div', {
	    staticClass: "bg-overlay",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1935 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-create-task-for-user"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Status fra oprettelsen")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [(_vm.errorUsers.length > 0) ? _c('div', {
	    staticClass: "show-response__banner show-response__banner--warning"
	  }, [_c('span', {
	    staticClass: "icon-warning show-response__banner__icon"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "show-response__banner__text"
	  }, [_c('strong', [_vm._v("\n            " + _vm._s(_vm.errorUsers.length) + "\n            " + _vm._s(_vm.errorUsers.length === 1 ? 'bruger kom ikke med på listen' : 'brugere kom ikke med på listen') + "\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            " + _vm._s(_vm.errorUsers.length === 1 ? 'Denne bruger har' : 'Disse brugere har') + " opgaver med lønkode og burde\n            have fået et tillæg, men mangler en oplysning. Ret det i siden 'Årsnorm', og hent opgaver med\n            lønkoder igen.\n          ")])])]) : _c('div', {
	    staticClass: "show-response__banner show-response__banner--ok"
	  }, [_c('span', {
	    staticClass: "icon-checkmark-circle show-response__banner__icon"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "show-response__banner__text"
	  }, [_c('strong', [_vm._v("Alle relevante brugere kom med")]), _vm._v(" "), _c('p', [_vm._v("Der er ingen brugere med opgaver med lønkode, der mangler oplysninger.")])])]), _vm._v(" "), _c('Tabs', {
	    attrs: {
	      "tabs": _vm.computedTabs,
	      "selected": _vm.selectedTab
	    },
	    on: {
	      "select": function($event) {
	        _vm.selectedTab = $event
	      }
	    }
	  }), _vm._v(" "), _c('table', {
	    staticClass: "do-table marg-1-top"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Navn")]), _vm._v(" "), (_vm.selectedTab === 'error') ? _c('th', [_vm._v("Hvad mangler")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'error') ? _c('th', [_vm._v("Sådan løser du det")]) : _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', [(_vm.usersFiltered.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": _vm.selectedTab === 'error' ? 3 : 2
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.selectedTab === 'error' ? 'Ingen brugere mangler oplysninger' : 'Ingen brugere blev oprettet') + "\n          ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.usersFiltered), function(user) {
	    return _c('tr', {
	      key: user.user_id,
	      class: {
	        'show-response__row--error': user.result === 'error'
	      }
	    }, [_c('td', [_vm._v(_vm._s(user.user_name))]), _vm._v(" "), (_vm.selectedTab === 'error') ? [_c('td', [_c('span', {
	      staticClass: "do-warning"
	    }, [_vm._v(_vm._s(_vm.errorDescription(user.error)))])]), _vm._v(" "), _c('td', {
	      staticClass: "show-response__hint"
	    }, [_vm._v(_vm._s(_vm.errorHint(user.error)))])] : _c('td', [_c('span', {
	      staticClass: "show-response__ok"
	    }, [_vm._v("✔️ Oprettet")])])], 2)
	  })], 2)])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 1936 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "isCloseOnBgClick": false,
	      "placeInTop": true,
	      "appendToBody": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-create-task-for-user"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [(_vm.theEditItem) ? _c('h2', [_vm._v("Redigér lønbrøk")]) : _c('h2', [_vm._v("Opret lønbrøk")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Vælg ansat *")]), _vm._v(" "), _c('DSelect', {
	    ref: "userSelect",
	    attrs: {
	      "items": _vm.filteredUsers,
	      "multiple": false,
	      "placeholder": 'Vælg ansat',
	      "itemsSelected": _vm.itemsSelectedForDSelect,
	      "isShowRemoveButton": false
	    },
	    on: {
	      "add": _vm.onSelectUser,
	      "remove": function($event) {
	        return _vm.onSelectUser(null)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Ansættelse *")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.employmentId),
	      expression: "employmentId"
	    }],
	    staticClass: "height-34 do-select width-100",
	    attrs: {
	      "disabled": !_vm.userId || !_vm.hasEmploymentsWithNumber
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.employmentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.employments), function(employment) {
	    return _c('option', {
	      key: employment.id,
	      domProps: {
	        "value": employment.id
	      }
	    }, [_vm._v("\n                " + _vm._s(employment.title) + " - " + _vm._s(employment.employment_number) + "\n                ")])
	  }), 0), _vm._v(" "), (_vm.userId && !_vm.hasEmploymentsWithNumber) ? _c('p', {
	    staticClass: "text-explainer marg-05-top"
	  }, [_vm._v("\n                Den valgte bruger har ingen ansættelser med tjenestenummer\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs-container marg-05-top"
	  }, [_c('Tabs', {
	    attrs: {
	      "tabs": _vm.tabs,
	      "selected": _vm.activeTab
	    },
	    on: {
	      "select": _vm.changeTab
	    }
	  })], 1), _vm._v(" "), (_vm.activeTab === 'timer') ? _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Årsnorm")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aarstimetal),
	      expression: "aarstimetal"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Timer"
	    },
	    domProps: {
	      "value": (_vm.aarstimetal)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.aarstimetal = $event.target.value
	      }, _vm.onHoursInput]
	    }
	  }), _vm._v(" "), (_vm.hoursError) ? _c('p', {
	    staticClass: "text-explainer marg-05-top",
	    staticStyle: {
	      "color": "#e53e3e"
	    }
	  }, [_vm._v("\n                Maksimal værdi er 1924\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'loenbroek') ? _c('div', {
	    staticClass: "d-input-group-flex"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Løndecimal")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.loendecimal),
	      expression: "loendecimal"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Løndecimal",
	      "inputmode": "decimal",
	      "pattern": "[0-9]+([,\\.][0-9]{1,2})?"
	    },
	    domProps: {
	      "value": (_vm.loendecimal)
	    },
	    on: {
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.loendecimal = $event.target.value
	      }, _vm.onLoendecimalInput]
	    }
	  }), _vm._v(" "), (_vm.loendecimalError) ? _c('p', {
	    staticClass: "text-explainer marg-05-top",
	    staticStyle: {
	      "color": "#e53e3e"
	    }
	  }, [_vm._v("\n                    Maksimal værdi er 1\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Beskæftigelsesdecimal")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.beskaefftigelsesdecimal),
	      expression: "beskaefftigelsesdecimal"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Beskæftigelsesdecimal",
	      "inputmode": "decimal",
	      "pattern": "[0-9]+([,\\.][0-9]{1,2})?"
	    },
	    domProps: {
	      "value": (_vm.beskaefftigelsesdecimal)
	    },
	    on: {
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.beskaefftigelsesdecimal = $event.target.value
	      }, _vm.onBeskaaefftigelsesdecimalInput]
	    }
	  }), _vm._v(" "), (_vm.beskaefftigelsesdecimalError) ? _c('p', {
	    staticClass: "text-explainer marg-05-top",
	    staticStyle: {
	      "color": "#e53e3e"
	    }
	  }, [_vm._v("\n                    Maksimal værdi er 1\n                ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Dato det skal gælde fra")]), _vm._v(" "), _c('DateSelector', {
	    staticClass: "width-100",
	    attrs: {
	      "date": _vm.startDate,
	      "width100": true
	    },
	    on: {
	      "changed": function($event) {
	        return _vm.setDate($event)
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', {
	    staticClass: "d-modal__buttons__child"
	  }, [(_vm.theEditItem) ? _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        _vm.isDeleteModal = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons__child"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), (!_vm.theEditItem) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': !_vm.isValid || _vm.isSubmitting,
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.onSubmit
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.theEditItem ? 'Opret ny' : 'Gem') + "\n        ")]) : _vm._e()])]), _vm._v(" "), (_vm.isDeleteModal) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isSubmitButtonLoading": _vm.isDeleting
	    },
	    on: {
	      "close": function($event) {
	        _vm.isDeleteModal = false
	      },
	      "confirm": _vm.deleteEditItem
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1937 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-group text-dark"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Temavisning")]), _vm._v(" "), _c('div', {
	    staticClass: "choose-subject"
	  }, [(_vm.isLoadingSubjects) ? _c('div', {
	    staticClass: "choose-subject__spinner"
	  }, [_c('div', {
	    staticClass: "do-spinner"
	  })]) : _c('dSelect', {
	    attrs: {
	      "items": _vm.sortedSubjects,
	      "receiveData": _vm.theNewSubject,
	      "multiple": false,
	      "placeholder": _vm.$t('vue2.create_activity.search_or_create'),
	      "itemSpaceBetween": true
	    },
	    on: {
	      "enter": _vm.onCreateNewSubject,
	      "update": _vm.setSubject,
	      "searchText": _vm.setTheSearchText,
	      "onSearchTextDebounced": _vm.onSearchTextDebounced,
	      "close": _vm.onCloseDSelect
	    },
	    scopedSlots: _vm._u([_vm._l((_vm.sortedSubjects), function(item, index) {
	      return {
	        key: "test",
	        fn: function(slotProps) {
	          return [_c('div', {
	            staticClass: "choose-subject__event_type"
	          }, [_vm._v("\n          " + _vm._s(slotProps.item.vSubjectType) + "\n        ")])]
	        }
	      }
	    })], null, true)
	  }, [_vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "noMatch"
	    },
	    slot: "noMatch"
	  }, [_c('h4', {
	    staticClass: "create-subject-link",
	    on: {
	      "click": _vm.onCreateNewSubject
	    }
	  }, [_vm._v("\n          + " + _vm._s(_vm.$t('vue2.substitution.create')) + ": \"" + _vm._s(_vm.theSearchText) + "\"\n        ")])])]), _vm._v(" "), (_vm.isShowCreateSubjectButton) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window'
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
	    }],
	    staticClass: "icon__bg-circle create-new-subject",
	    attrs: {
	      "content": _vm.$t("vue2.substitution.create") + " \"" + _vm.theSearchText + "\" "
	    },
	    on: {
	      "click": _vm.onCreateNewSubject
	    }
	  }, [_c('span', {
	    staticClass: "d-icon-plus"
	  })]) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1938 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true
	    },
	    on: {
	      "close": _vm.close
	    }
	  }, [_c('template', {
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "add-lesson__header",
	    style: ({
	      'backgroundColor': _vm.color ? _vm.color : '#2c81ba'
	    })
	  }, [_c('h2', [_vm._v("Opret fag i " + _vm._s(_vm.theCreateSubject.klassebetegnelse))]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "add-lesson__form"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v("Titel*")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    ref: "inputTitle",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.title = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v("Fagkode*")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fagkode),
	      expression: "fagkode"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.fagkode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.standardSubjects), function(fag) {
	    return _c('option', {
	      key: fag.fagkode,
	      domProps: {
	        "value": fag.fagkode
	      }
	    }, [_vm._v("\n            " + _vm._s(fag.fagkode) + ": " + _vm._s(fag.name) + "\n          ")])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v("Klassetimer på året*")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.klokketimer),
	      expression: "klokketimer"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.klokketimer)
	    },
	    on: {
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.klokketimer = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__submit"
	  }, [_c('div', {
	    staticClass: "input-group__submit__left"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "input-group__submit__right"
	  }, [_c('button', {
	    staticClass: "marg-1-right bg-white",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isFormValid) ? _c('div', {
	    staticClass: "hint--top-left",
	    attrs: {
	      "aria-label": "Udfyld formularen"
	    }
	  }, [_c('button', {
	    staticClass: "submit-button submit-button--disabled"
	  }, [_vm._v("Opret")])]) : _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Opret")])])])])], 2)
	},staticRenderFns: []}

/***/ }),
/* 1939 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "users-hours text-dark"
	  }, [_c('div', {
	    staticClass: "users-hours__header"
	  }, [_c('div', {
	    staticClass: "users-hours__header__left"
	  }, [_c('h1', {
	    staticClass: "marg-20-right"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assign_hours')))]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  }), _vm._v(" "), (!_vm.isInitalLoad) ? _c('p', {
	    staticClass: "marg-10-left"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.showing_scheduled_hours_from')) + " " + _vm._s(_vm._f("yearFormat")(_vm.startDate)) + " - " + _vm._s(_vm._f("yearFormat")(_vm.endDate)))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "user-tasks__header__right"
	  }, [(!_vm.isDatesPristine) ? _c('p', {
	    staticClass: "d-link",
	    on: {
	      "click": _vm.resetDates
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), (_vm.activeSchoolYear) ? _c('DatePickerRangeShortcuts', {
	    staticClass: "marg-1-right",
	    attrs: {
	      "startDate": _vm.activeSchoolYear.employee_time_start,
	      "endDate": _vm.activeSchoolYear.employee_time_end,
	      "selectedStartDate": _vm.startDate,
	      "selectedEndDate": _vm.endDate
	    },
	    on: {
	      "shortcutSelected": _vm.setDatesFromRange
	    }
	  }) : _vm._e(), _vm._v(" "), _c('DatePickerRange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": function($event) {
	        return _vm.setEndDate($event, true)
	      }
	    }
	  }), _vm._v(" "), (_vm.isShowPrintButton) ? _c('button', {
	    staticClass: "marg-1-left",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "users border"
	  }, [(_vm.isLoadingUpdatedNumbers && !_vm.isInitalLoad && !this.numberOfWorkDaysInPeriod) ? _c('div', {
	    staticClass: "users--loading"
	  }, [_c('Spinner', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "users-header users-header-second"
	  }, [_c('div', {
	    staticClass: "flex-left"
	  }, [_c('div', {
	    staticClass: "users-user__meta"
	  }, [_c('div', [_c('input', {
	    staticClass: "users-header__searchfield",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('vue2.assign_users_hours.search_a_name')
	    },
	    on: {
	      "input": _vm.debounceSearch
	    }
	  })]), _vm._v(" "), _c('DoFiltersFilter', {
	    staticClass: "marg-1-left",
	    attrs: {
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters
	    },
	    on: {
	      "select": _vm.toggleTagFilter,
	      "clear": _vm.clearTagFilters
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "flex-right users-header-second__buttons"
	  }, [(_vm.isShowPrintTaskOverviewModal) ? _c('PrintTaskOverviews', {
	    attrs: {
	      "tags": _vm.tags,
	      "theUserCanManageAssignedHours": _vm.theUserCanManageAssignedHours,
	      "schoolThresholdToHideTaskHours": _vm.schoolThresholdToHideTaskHours
	    },
	    on: {
	      "close": function($event) {
	        _vm.isShowPrintTaskOverviewModal = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowSaveVersionTaskOverviewModal) ? _c('SaveTaskOverview', {
	    on: {
	      "close": function($event) {
	        _vm.isShowSaveVersionTaskOverviewModal = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowDeleteTaskOverviewsModal) ? _c('DeleteTaskOverviews', {
	    attrs: {
	      "tags": _vm.tags
	    },
	    on: {
	      "close": function($event) {
	        _vm.isShowDeleteTaskOverviewsModal = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('AssignHoursNorm', {
	    attrs: {
	      "prepFactor": _vm.schoolPrepFactor,
	      "isLocalPoolActivated": _vm.isLocalPoolActivated,
	      "isPoolsDeactivated": _vm.isPoolsDeactivated,
	      "isKindergarten": false,
	      "tags": _vm.tags
	    },
	    on: {
	      "updateUsersHours": _vm.getUsersHours
	    }
	  }) : _vm._e(), _vm._v(" "), _c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "isBottomStart": false,
	      "propOffset": [5, 5]
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_c('span', {
	    staticClass: "icon-more2"
	  })]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [(_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.setIsDeactivatePoolsModalVisible(true)
	      }
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.isPoolsDeactivated ? 'Aktiver puljer' : 'Deaktiver puljer') + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.isPoolsDeactivated && _vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
	    on: {
	      "click": _vm.toggleShowRestColumn
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.isShowRestColumn ? 'Skjul rest' : 'Vis rest') + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.setIsChangePrepFactorModal(true)
	      }
	    }
	  }, [_vm._v("\n              " + _vm._s(!_vm.schoolPrepFactor ? 'Aktiver forbereldesesfaktor' : 'Forberedelsesfaktor ' + _vm.schoolPrepFactor) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.setIsModalPedagogicalSetting(true)
	      }
	    }
	  }, [_vm._v("\n              Grupper med pædagogoptælling\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.isShowTaskOverviewSettings = true
	      }
	    }
	  }, [_vm._v("\n              Design opgaveoversigter\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.isShowSaveVersionTaskOverviewModal = true
	      }
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.task_versions.save_new_version_task_overviews')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.isShowPrintTaskOverviewModal = true
	      }
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.task_versions.print_latest_version_task_overviews')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.isShowDeleteTaskOverviewsModal = true
	      }
	    }
	  }, [_vm._v("\n              Håndter versioner af opgaveoversigter\n            ")]) : _vm._e(), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.asyncLoadXLSXAndDownload
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.i18n['download_to_excel']) + "\n            ")]), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.isShowEmploymentRatesModal = true
	      }
	    }
	  }, [_vm._v("\n              Vis ansættelsesgrader\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.isShowAvgTeachingHoursModal = true
	      }
	    }
	  }, [_vm._v("\n              Gennemsnits undervisningstal\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isPoolsDeactivated && _vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.isShowTransferRestModal = true
	      }
	    }
	  }, [_vm._v("\n              Overfør positiv rest til brik\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSchoolFromCO) ? _c('li', {
	    on: {
	      "click": _vm.setIsChangeViewModal
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['change_view']))]) : _vm._e(), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.updateUserHours
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.assign_users_hours.update')) + "\n            ")]), _vm._v(" "), (_vm.isSchoolDanish) ? _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowEmploymentEnded(true)
	      }
	    }
	  }, [_vm._v("\n              Brudt ansættelse\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSchoolSystem && _vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.isShowWorkedHoursStatement = true
	      }
	    }
	  }, [_vm._v("\n              Opgørelse af ansættelse\n            ")]) : _vm._e()])])], 1)]), _vm._v(" "), (_vm.isInitalLoad || _vm.isLoadingSubjectsOrTasks) ? _c('div', {
	    staticStyle: {
	      "margin": "100px auto"
	    }
	  }, [_c('Spinner', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  })], 1) : _c('AllUsers', {
	    attrs: {
	      "theUserCanManageAssignedHours": _vm.theUserCanManageAssignedHours,
	      "prepFactor": _vm.schoolPrepFactor,
	      "isPrepFactorForSubstitutePools": _vm.isPrepFactorForSubstitutePools,
	      "viewSettings": _vm.viewSettings,
	      "schoolid": _vm.schoolId,
	      "users": _vm.filteredUsers,
	      "isDatesPristine": _vm.isDatesPristine,
	      "numberOfWorkDays": _vm.numberOfWorkDays,
	      "numberOfWorkDaysInPeriod": _vm.numberOfWorkDaysInPeriod,
	      "isLocalPoolActivated": _vm.isLocalPoolActivated,
	      "locale": _vm.locale,
	      "isPoolsDeactivated": _vm.isPoolsDeactivated,
	      "isShowRestColumn": _vm.isShowRestColumn
	    },
	    on: {
	      "setActiveUser": _vm.setActiveUser,
	      "setTheUserToShowTasks": _vm.setTheUserToShowTasks,
	      "updatedUser": _vm.updatedUser
	    }
	  })], 1), _vm._v(" "), (_vm.isChangeViewModal) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": _vm.setIsChangeViewModal
	    }
	  }, [_c('div', {
	    staticClass: "modal-assign-hours-view",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['change_view']))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": _vm.setIsChangeViewModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [_c('ul', _vm._l((_vm.viewSettingsI18N), function(setting, key) {
	    return _c('li', {
	      key: key,
	      staticClass: "modal-assign-hours-view__item",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setViewSetting(key, setting.active)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v(_vm._s(setting.title))]), _vm._v(" "), _c('div', {
	      staticClass: "do-switch",
	      class: {
	        'do-switch--active': setting.active
	      }
	    })])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.setIsChangeViewModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.done')))])])])]) : _vm._e(), _vm._v(" "), (_vm.activeUserId) ? _c('ShowUserAbsence', {
	    attrs: {
	      "eventsFilter": _vm.activeUserEventFilter,
	      "userId": _vm.activeUserId
	    },
	    on: {
	      "close": function($event) {
	        _vm.activeUserId = null
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false,
	      "isPrintable": true
	    },
	    on: {
	      "close": _vm.closeTheUserToShowTasks
	    }
	  }, [_c('div', {
	    staticClass: "user-task__container",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "user-task__container__header no-print"
	  }, [_c('h2'), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": _vm.closeTheUserToShowTasks
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('UserOverviewTabs', {
	    attrs: {
	      "user": _vm.theUserToShowTasks,
	      "initialView": "hours",
	      "initialStartDate": _vm.startDate,
	      "initialEndDate": _vm.endDate
	    }
	  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.isModalPedagogicalSetting) ? _c('ModalPedagogicalSetting', {
	    attrs: {
	      "tags": _vm.tags,
	      "schoolId": _vm.schoolId,
	      "preSelectedTags": _vm.userTagsToShowSum,
	      "preSelectedTagsSumWorkHours": _vm.userTagsForSumWorkHours
	    },
	    on: {
	      "saved": _vm.getUsersHours,
	      "close": function($event) {
	        return _vm.setIsModalPedagogicalSetting(false)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isChangePrepFactorModal) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsChangePrepFactorModal(false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "do-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2', [_vm._v("Forberedelsesfaktor")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.setIsChangePrepFactorModal(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [_c('div', {
	    staticClass: "d-explainer-box text-explainer text-explainer__error"
	  }, [_c('svg', {
	    staticClass: "tw-icon icon-help",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"
	    }
	  })]), _vm._v("\n          Aktivering af forberedelsesfaktor gør, at timer til forberedelse automatisk opdateres, når undervisning\n          tildeles til en underviser.\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-label-and-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setIsThePrepFactorActive.apply(null, arguments)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label color-dark"
	  }, [_vm._v("Aktiver forberedelsesfaktor")]), _vm._v(" "), _c('div', {
	    staticClass: "do-switch",
	    class: {
	      'do-switch--active': _vm.isThePrepFactorActive
	    }
	  })]), _vm._v(" "), (_vm.isThePrepFactorActive) ? _c('div', {
	    staticClass: "prep-factor-input marg-1-bottom"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Indtast jeres forberedelsesfaktor")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.thePrepFactor),
	      expression: "thePrepFactor"
	    }],
	    ref: "the_prep_factor_input",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.thePrepFactor)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.savePrepFactor.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.thePrepFactor = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.isThePrepFactorActive) ? _c('div', {
	    staticClass: "d-label-and-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.isThePrepFactorForSubstitutePools = !_vm.isThePrepFactorForSubstitutePools
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label color-dark"
	  }, [_vm._v("Medregn forberedelsesfaktor for vikarpuljer")]), _vm._v(" "), _c('div', {
	    staticClass: "do-switch",
	    class: {
	      'do-switch--active': _vm.isThePrepFactorForSubstitutePools
	    }
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn marg-1-right",
	    on: {
	      "click": function($event) {
	        return _vm.setIsChangePrepFactorModal(false)
	      }
	    }
	  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSavingPrepFactor
	    },
	    on: {
	      "click": _vm.savePrepFactor
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isShowEmploymentEnded) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsShowEmploymentEnded(false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "do-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2', [_vm._v("Brudt ansættelse")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowEmploymentEnded(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [_c('AssignHoursEmploymentEnded', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "users": _vm.usersForList
	    }
	  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isShowWorkedHoursStatement) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": function($event) {
	        _vm.isShowWorkedHoursStatement = false
	      }
	    }
	  }, [_c('div', {
	    staticClass: "do-modal do-modal--fullscreen",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.workedHoursStatementTitle))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": function($event) {
	        _vm.isShowWorkedHoursStatement = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [_c('AssignHoursWorkedHoursStatement', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "users": _vm.usersForList
	    },
	    on: {
	      "title": function($event) {
	        _vm.workedHoursStatementTitle = $event
	      }
	    }
	  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isShowTaskOverviewSettings) ? _c('TaskOverviewSettings', {
	    on: {
	      "close": function($event) {
	        _vm.isShowTaskOverviewSettings = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isDeactivatePoolsModalVisible) ? _c('AssignHoursDeactivatePoolsModal', {
	    attrs: {
	      "isPoolsDeactivated": _vm.isPoolsDeactivated
	    },
	    on: {
	      "reReadNumbers": _vm.reReadNumbers,
	      "close": function($event) {
	        return _vm.setIsDeactivatePoolsModalVisible(false)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowEmploymentRatesModal) ? _c('AssignHoursEmploymentRates', {
	    on: {
	      "close": function($event) {
	        _vm.isShowEmploymentRatesModal = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowAvgTeachingHoursModal) ? _c('AvgTeachingHoursModal', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "schoolYearId": _vm.activeSchoolYear.id
	    },
	    on: {
	      "close": function($event) {
	        _vm.isShowAvgTeachingHoursModal = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowTransferRestModal) ? _c('AssignHoursTransferRestModal', {
	    attrs: {
	      "users": _vm.usersWithPositiveRest,
	      "schoolId": _vm.schoolId,
	      "schoolYearId": _vm.activeSchoolYear.id,
	      "isLocalPoolActivated": _vm.isLocalPoolActivated
	    },
	    on: {
	      "transferred": _vm.readSubjectsAndTasks,
	      "close": function($event) {
	        _vm.isShowTransferRestModal = false
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1940 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": _vm.onCancel
	    }
	  }, [_c('div', {
	    staticClass: "do-modal do-modal__reasons-form",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n.create_absence))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [(_vm.isAbsenceIntegrationActive && _vm.isSalarySystemKMD) ? _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label marg-025-bottom"
	  }, [_vm._v("Vælg fraværsårsag fra OPUS")]), _vm._v(" "), _c('DSelect', {
	    key: 'absenceCode-' + _vm.resetDSelectCounter,
	    ref: "absenceCodeSelect",
	    attrs: {
	      "items": _vm.absenceCodesForDSelect,
	      "multiple": false,
	      "placeholder": 'Vælg kode fra OPUS',
	      "itemsSelected": _vm.selectedAbsenceCodeForDSelect,
	      "isShowRemoveButton": false
	    },
	    on: {
	      "add": _vm.onSelectAbsenceCode,
	      "remove": function($event) {
	        return _vm.onSelectAbsenceCode(null)
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAbsenceIntegrationActive && _vm.isSalarySystemSD) ? _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label marg-025-bottom"
	  }, [_vm._v("Vælg fraværsårsag fra SD")]), _vm._v(" "), _c('DSelect', {
	    key: 'sdAbsenceCode-' + _vm.resetDSelectCounter,
	    ref: "sdAbsenceCodeSelect",
	    attrs: {
	      "items": _vm.sdAbsenceCodesForDSelect,
	      "multiple": false,
	      "placeholder": 'Vælg kode fra SD',
	      "itemsSelected": _vm.selectedSdAbsenceCodeForDSelect,
	      "isShowRemoveButton": false
	    },
	    on: {
	      "add": _vm.onSelectSdAbsenceCode,
	      "remove": function($event) {
	        return _vm.onSelectSdAbsenceCode(null)
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-group marg-1-top"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n.title))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "focus",
	      rawName: "v-focus"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newReasonTitle),
	      expression: "newReasonTitle"
	    }],
	    staticClass: "d-input",
	    class: {
	      'd-input--error': _vm.errors.newReasonTitle
	    },
	    domProps: {
	      "value": (_vm.newReasonTitle)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onCreate.apply(null, arguments)
	      },
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newReasonTitle = $event.target.value
	      }, _vm.clearErrors]
	    }
	  }), _vm._v(" "), (_vm.errors.newReasonTitle) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.errors.newReasonTitle))]) : _vm._e()]), _vm._v(" "), (_vm.shouldShowDefaultOngoing) ? _c('div', {
	    staticClass: "d-label-and-toggle marg-1-top",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.defaultOngoing = !_vm.defaultOngoing
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n.default_ongoing))]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "propOn": _vm.defaultOngoing,
	      "allowChanges": false
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-label-and-toggle marg-1-top",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.canRequest = !_vm.canRequest
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n.can_be_requested))]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "propOn": _vm.canRequest,
	      "allowChanges": false
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-label-and-toggle marg-1-top",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.defaultPrivate = !_vm.defaultPrivate
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n.hide_title))]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "propOn": _vm.defaultPrivate,
	      "allowChanges": false
	    }
	  })], 1), _vm._v(" "), _c('p', {
	    staticClass: "marg-1-top italic"
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.i18n.default_private_explained)
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isCreating
	    },
	    on: {
	      "click": _vm.onCreate
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.create')) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1941 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    class: {
	      'd-modal--with-sidebar': _vm.isShowQuotasSidebar && _vm.isQuotaVisible
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['absence_request']))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "user-request__body"
	  }, [_c('div', {
	    staticClass: "d-modal__content"
	  }, [(_vm.isShowTabs) ? _c('Tabs', {
	    staticClass: "marg-1-bottom",
	    attrs: {
	      "selected": _vm.selectedTab,
	      "tabs": [{
	          id: 'request',
	          title: _vm.i18n['tab_request']
	        },
	        {
	          id: 'list',
	          title: _vm.i18n['tab_list']
	        }
	      ]
	    },
	    on: {
	      "select": function($event) {
	        _vm.selectedTab = $event
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'list') ? _c('UserRequestList', {
	    attrs: {
	      "isUserView": true
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'request') ? [(_vm.isMultipleSchoolsActive && !_vm.activeSchoolId) ? [_c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n['select_school']))]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.activeSchoolId),
	      expression: "activeSchoolId"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.activeSchoolId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.onChangeActiveSchoolId]
	    }
	  }, _vm._l((_vm.userSchoolsSorted), function(school) {
	    return _c('option', {
	      domProps: {
	        "value": school.id
	      }
	    }, [_vm._v("\n                  " + _vm._s(school.name) + "\n                ")])
	  }), 0)])] : (_vm.activeSchoolId) ? [_c('div', {
	    staticClass: "do-spinner__container"
	  }, [_c('div', {
	    staticClass: "do-spinner do-spinner--large"
	  })])] : [_c('UserAbsence', {
	    attrs: {
	      "resetCounter": _vm.resetAbsenceCounter
	    },
	    on: {
	      "setSubject": _vm.setSelectedSubject
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n['date']))]), _vm._v(" "), _c('DatepickerRange', {
	    attrs: {
	      "allowSameDate": true,
	      "startdate": _vm.date
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "time-changer__group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n['time']))]), _vm._v(" "), _c('TimeChanger', {
	    attrs: {
	      "showIcon": true,
	      "start": _vm.startTime,
	      "end": _vm.endTime,
	      "isFiveMinutesInterval": false
	    },
	    on: {
	      "updateStart": _vm.setStartTime,
	      "updateEnd": _vm.setEndTime
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-group marg-1-top"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n['optional_note']))]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.note),
	      expression: "note"
	    }],
	    staticClass: "do-input",
	    domProps: {
	      "value": (_vm.note)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.note = $event.target.value
	      }
	    }
	  })])]] : _vm._e()], 2), _vm._v(" "), (_vm.selectedTab === 'request') ? _c('div', {
	    staticClass: "d-modal__buttons d-modal__buttons__padding",
	    staticStyle: {
	      "padding": "1rem"
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.create')) + "\n        ")]) : _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.create')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isShowQuotasSidebar) ? _c('aside', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isQuotaVisible),
	      expression: "isQuotaVisible"
	    }],
	    staticClass: "user-request__sidebar"
	  }, [_c('UserQuota', {
	    attrs: {
	      "userId": _vm.user.id,
	      "isSidebar": true
	    },
	    on: {
	      "visibility": function($event) {
	        _vm.isQuotaVisible = $event
	      }
	    }
	  })], 1) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 1942 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "doScheduler",
	    staticClass: "do-scheduler",
	    style: ({
	      maxHeight: _vm.schedulerMaxHeight + 'px'
	    })
	  }, [_c('ul', {
	    staticClass: "do-scheduler__list",
	    style: ({
	      'width': _vm.slotWidth * 48 + 'px'
	    })
	  }, [_c('ul', {
	    staticClass: "scheduler__header__times"
	  }, _vm._l((_vm.hoursInLocale), function(number) {
	    return _c('li', {
	      style: ({
	        minWidth: _vm.slotWidth * 2 + 'px'
	      })
	    }, [_vm._v(_vm._s(number))])
	  }), 0), _vm._v(" "), _vm._l((_vm.calendarsWithEvents), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "do-scheduler__list__item",
	      style: ({
	        height: (_vm.slotHeight * calendar.vColumns) + 'px'
	      })
	    }, [_c('div', {
	      staticClass: "do-scheduler__list__item__name"
	    }, [_c('h4', [_vm._v(_vm._s(calendar.name))])]), _vm._v(" "), _c('ul', {
	      staticClass: "do-scheduler__item__events",
	      style: ({
	        'width': _vm.slotWidth * 48 + 'px',
	        height: (_vm.slotHeight * calendar.vColumns) + 'px'
	      })
	    }, [_vm._l((calendar.vPresence), function(presence) {
	      return _c('li', {
	        staticClass: "do-scheduler__item__events__presence",
	        style: ({
	          left: presence.left + 'px',
	          right: presence.right + 'px'
	        })
	      })
	    }), _vm._v(" "), _vm._l((calendar.vEvents), function(event) {
	      return _c('li', {
	        key: event.id,
	        staticClass: "do-scheduler__item__events__event",
	        style: (_vm.getEventStyle(event))
	      }, [_c('div', {
	        staticClass: "do-scheduler__item__events__event__title"
	      }, [_vm._v(_vm._s(event.title))]), _vm._v(" "), _c('div', {
	        staticClass: "do-scheduler__item__events__event__klass"
	      }, [_vm._v(_vm._s(event.vKlasses))])])
	    })], 2)])
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1943 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('DModal', {
	    staticStyle: {
	      "z-index": "123123"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true,
	      "appendToBody": true,
	      "pxFromTop": _vm.isSupplements ? 1 : 2,
	      "isCloseOnEsc": !_vm.isCreateCategory && !_vm.theEditTask && !_vm.isWatchGuide
	    },
	    on: {
	      "close": _vm.onClose
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    class: {
	      'd-modal__supplements': _vm.isSupplements
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [(_vm.isSupplements) ? _c('div', {
	    staticClass: "d-modal__header d-modal__header__supplements"
	  }, [_c('h3', [_vm._v("Tilføj tillægstyper")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle",
	    on: {
	      "click": _vm.onClose
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content text-dark"
	  }, [(!_vm.isSupplements) ? _c('div', {
	    staticClass: "d-modal__content__sidebar"
	  }, [_c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.onClose
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('h2', [_vm._v("Design opgaveoversigter")]), _vm._v(" "), _c('ul', {
	    staticClass: "d-modal__content__sidebar__nav"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    attrs: {
	      "id": "do-bttn--watch-guide"
	    },
	    on: {
	      "click": function($event) {
	        _vm.isWatchGuide = true
	      }
	    }
	  }, [_vm._v("Se guide")]), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
	    return _c('li', {
	      staticClass: "d-modal__content__sidebar__nav-item",
	      class: {
	        'd-modal__content__sidebar__nav-item--active': tab.id === _vm.theActiveTab
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheActiveTab(tab.id)
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(tab.title) + "\n            ")])
	  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content__body"
	  }, [(_vm.isInitLoading) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  }) : [(_vm.theActiveTab === 1) ? _c('TaskOverviewSettingsCategories', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "schoolYearId": _vm.schoolYearId,
	      "schoolYear": _vm.schoolYear,
	      "locale": _vm.locale,
	      "taskCategories": _vm.taskCategories,
	      "dbSubjectTypes": _vm.dbSubjectTypes,
	      "subjects": _vm.subjects
	    },
	    on: {
	      "onDeleteTaskCategory": _vm.onDeleteTaskCategory,
	      "updateCategory": _vm.onUpdateCategory,
	      "setCreateCategory": _vm.setCreateCategory,
	      "onSetEditTask": _vm.onSetEditTask
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 2) ? _c('TaskOverviewSettingsCategoriesTasks', {
	    attrs: {
	      "taskCategories": _vm.taskCategoriesSorted,
	      "schoolId": _vm.schoolId,
	      "schoolYearId": _vm.schoolYearId,
	      "subjects": _vm.subjects,
	      "allCalendarsInHash": _vm.allCalendarsInHash,
	      "allUsersInHash": _vm.allUsersInHash,
	      "tags": _vm.tags,
	      "isSupplements": _vm.isSupplements
	    },
	    on: {
	      "setCreateCategory": _vm.setCreateCategory,
	      "updateSubjects": _vm.updateSubjects
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 3) ? _c('TaskOverviewSettingsSettings', {
	    attrs: {
	      "taskCategories": _vm.taskCategories
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 4) ? _c('TaskOverviewSettingsUserTasks', {
	    attrs: {
	      "theActiveUserId": _vm.theActiveUserIdForExample,
	      "users": _vm.users,
	      "schoolYear": _vm.schoolYear
	    },
	    on: {
	      "setTheActiveUserId": _vm.setTheActiveUserIdForExample
	    }
	  }) : _vm._e()]], 2), _vm._v(" "), (_vm.isCreateCategory) ? _c('TaskOverviewSettingsCategoryCreate', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "schoolYearId": _vm.schoolYearId,
	      "taskCategories": _vm.taskCategories
	    },
	    on: {
	      "close": function($event) {
	        _vm.isCreateCategory = false
	      },
	      "onNewCategory": _vm.onNewCategory
	    }
	  }) : _vm._e()], 1)])]), _vm._v(" "), (_vm.isWatchGuide) ? _c('DModal', {
	    staticStyle: {
	      "z-index": "12312323"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true,
	      "appendToBody": true,
	      "isCloseOnEsc": !_vm.isCreateCategory && !_vm.theEditTask
	    },
	    on: {
	      "close": function($event) {
	        _vm.isWatchGuide = false
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal--guide",
	    staticStyle: {
	      "width": "90vw"
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        _vm.isWatchGuide = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content__guide text-dark"
	  }, [_c('TaskOverviewSettingsGuide')], 1)])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1944 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "brutto brutto--kindergarten text-dark"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.setIsNormModal
	    }
	  }, [_vm._v("Tildel årsverk")]), _vm._v(" "), (_vm.isActive) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "brutto-container",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-container__header"
	  }, [_c('h2', [_vm._v("Tildel årsverk")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__body"
	  }, [_c('div', {
	    staticClass: "brutto-container__body__left"
	  }, [_c('h3', [_vm._v("Arbeidsåret")]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs__content"
	  }, [_c('ArbeidsplanAssignHoursNormList', {
	    attrs: {
	      "isNetto": _vm.activeTab === 1,
	      "schoolYear": _vm.activeSchoolYear,
	      "theEditUserNorm": _vm.theEditUserNorm
	    },
	    on: {
	      "updated": _vm.setItemsToSave,
	      "changedSum": _vm.setNettoTime
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "brutto__items__item__container brutto__items__item__container__notefield"
	  }, [_c('div', {
	    staticClass: "label-with-toggle",
	    on: {
	      "click": _vm.setIsShowAgreement
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Legg til et notat til valgte personer")]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isShowAgreement
	    }
	  })], 1), _vm._v(" "), (_vm.isShowAgreement) ? _c('AppEIPWYZIWYG', {
	    attrs: {
	      "isKeepOpen": true,
	      "is-open": true,
	      "isInTestOfSaveButton": false
	    },
	    on: {
	      "changed": _vm.updateAgreements
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowAgreement) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_c('svg', {
	    staticClass: "icon-archive tw-icon",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M5.23 3h13.54a2 2 0 0 1 1.98 2.22l-1.55 14A2 2 0 0 1 17.2 21H6.79a2 2 0 0 1-1.99-1.78l-1.55-14A2 2 0 0 1 5.23 3z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M10.59 14l-2.3-2.3a1 1 0 0 1 1.42-1.4L12 12.58l2.3-2.3a1 1 0 0 1 1.4 1.42L13.42 14l2.3 2.3a1 1 0 0 1-1.42 1.4L12 15.42l-2.3 2.3a1 1 0 1 1-1.4-1.42L10.58 14zM4 3h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5c0-1.1.9-2 2-2z"
	    }
	  })]), _vm._v("\n              Merk at hvis det allerede står noe i personens notatfelt, vil dette bli slettet.\n            ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "brutto__users"
	  }, [(_vm.tags.length > 0) ? _c('div', {
	    staticClass: "brutto__users__header"
	  }, [_c('filterTags', {
	    attrs: {
	      "users": _vm.usersSortedOnNameWithTags,
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters
	    },
	    on: {
	      "set": _vm.setTagFromFilter,
	      "remove": _vm.removeTagFromFilter
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "brutto__users__list__header",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.selectedUsers.length < 1) ? _c('span', [_vm._v("Velg alle")]) : _c('span', [_vm._v("Fjern valg")])]), _vm._v(" "), _c('ul', {
	    staticClass: "brutto__users__list"
	  }, _vm._l((_vm.filteredUsers), function(user) {
	    return _c('li', {
	      key: user.id,
	      staticClass: "brutto__users__user",
	      class: {
	        'is-selected': _vm.getIsUserSelected(user)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleUser(user)
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(user.name) + "\n              "), _c('div', {
	      staticClass: "icon__bg-circle d-edit-btn",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.editUserNorm(user)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-wrench"
	    })])])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__footer"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isActive = false
	      }
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        onShow: function () { return _vm.selectedUsers.length < 1; }
	      }),
	      expression: "{\n                  arrow: true,\n                  onShow: () => selectedUsers.length < 1\n                }"
	    }],
	    staticClass: "bttn bttn-primary",
	    class: [{
	      'bttn-primary--disabled': _vm.selectedUsers.length < 1
	    }, {
	      'bttn--loading': _vm.isSaving
	    }],
	    attrs: {
	      "content": "Der skal vælges minimum en bruger"
	    },
	    on: {
	      "click": function($event) {
	        _vm.isWarningActive = true
	      }
	    }
	  }, [_vm._v("Lagre\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isWarningActive) ? _c('DModal', {
	    staticStyle: {
	      "z-index": "999999999"
	    },
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "brutto-warning",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-warning__header"
	  }, [_c('h2', [_vm._v("Gem og erstat?")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": function($event) {
	        _vm.isWarningActive = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-warning__body"
	  }, [_c('svg', {
	    staticClass: "tw-icon tw-icon--red",
	    attrs: {
	      "viewBox": "0 0 24 24",
	      "fill": "none",
	      "stroke": "currentColor",
	      "stroke-width": "2",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "9",
	      "x2": "12",
	      "y2": "13"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "17",
	      "x2": "12.01",
	      "y2": "17"
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n          Du er i ferd med å tildele arbeidstid på " + _vm._s(_vm.nettoTime) + " til de valgte brukerne. Hvis det allerede er tildelt arbeidstid, vil denne bli erstattet.\n        ")])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-warning__footer"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isWarningActive = false
	      }
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-primary bttn-primary--small",
	    class: [{
	      'bttn--loading': _vm.isSaving
	    }],
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("\n          Lagre og erstatt\n        ")])])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1945 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    on: {
	      "click": _vm.emitClick
	    }
	  }, [_vm._v("TEST " + _vm._s(_vm.message))])
	},staticRenderFns: []}

/***/ }),
/* 1946 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "split-event"
	  }, [(_vm.showModal) ? _c('AppModal', {
	    attrs: {
	      "submitTxt": _vm.i18n[_vm.locale].btn,
	      "isShowFooter": false
	    },
	    on: {
	      "close": _vm.closeModal
	    }
	  }, [_c('h1', {
	    attrs: {
	      "slot": "header"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].split) + " " + _vm._s(_vm.lesson.title) + ", " + _vm._s(_vm._f("showDate")(_vm.lesson.start)))]), _vm._v(" "), _c('div', {
	    staticClass: "form",
	    attrs: {
	      "slot": "body"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "origin-lesson"
	  }, [_c('p', {
	    staticClass: "label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].original_lesson))]), _vm._v(" "), _c('div', {
	    staticClass: "flex border pad-10 relative"
	  }, [_c('p', [_vm._v(_vm._s(_vm.lesson.title))]), _vm._v(" "), _c('div', {
	    staticClass: "lesson_times"
	  }, [_c('div', [_vm._v(", kl. " + _vm._s(_vm.$filters.LT(_vm.lesson.start)))]), _vm._v(" "), _c('div', {
	    staticClass: "lesson_times__seperator"
	  }, [_vm._v(" -")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$filters.LT(_vm.lesson.end)))])]), _vm._v(" "), _c('div', {
	    staticClass: "marg-10-left"
	  }, [_vm._v("\n            (" + _vm._s(_vm.i18n[_vm.locale].duration) + ": " + _vm._s(_vm.oldDuration) + " " + _vm._s(_vm.i18n[_vm.locale].minutes) + ")\n          ")])])]), _vm._v(" "), _c('h3', {
	    staticClass: "marg-24-top flex align-center"
	  }, [_c('span', {
	    staticClass: "icon-clock"
	  }), _c('span', {
	    staticClass: "marg-5-left"
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale].when_is_the_split) + "\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "flex align-center split-input-wrapper"
	  }, [_c('timeInput', {
	    staticClass: "split-lesson-input",
	    attrs: {
	      "refs": "timeinput",
	      "id": "focus",
	      "date": _vm.newLessonStart
	    },
	    on: {
	      "changed": _vm.setStartTime
	    }
	  })], 1), _vm._v(" "), _c('p', {
	    staticClass: "label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].split_lessons) + " ")]), _vm._v(" "), _c('div', {
	    staticClass: "flex border pad-10 marg-5-bottom relative"
	  }, [_c('p', [_vm._v(_vm._s(_vm.lesson.title))]), _vm._v(" "), _c('div', {
	    staticClass: "lesson_times"
	  }, [_c('div', [_vm._v(", " + _vm._s(_vm.$filters.LT(_vm.lesson.start)))]), _vm._v(" "), _c('div', {
	    staticClass: "lesson_times__seperator"
	  }, [_vm._v(" -")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$filters.LT(_vm.newLessonStart)))])]), _vm._v(" "), _c('div', {
	    staticClass: "marg-10-left"
	  }, [_vm._v("\n          (" + _vm._s(_vm.i18n[_vm.locale].duration) + ": " + _vm._s(_vm.lessonDuration) + " " + _vm._s(_vm.i18n[_vm.locale].minutes) + ")\n        ")])]), _vm._v(" "), _c('div', {
	    staticClass: "flex border pad-10 relative"
	  }, [_c('div', {
	    staticClass: "lesson__border-left",
	    staticStyle: {
	      "{borderColor": "lesson.color}"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.lesson.title))]), _vm._v(" "), _c('div', {
	    staticClass: "lesson_times"
	  }, [_c('div', [_vm._v(", " + _vm._s(_vm.$filters.LT(_vm.newLessonStart)))]), _vm._v(" "), _c('div', {
	    staticClass: "lesson_times__seperator"
	  }, [_vm._v(" -")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$filters.LT(_vm.lesson.end)))])]), _vm._v(" "), _c('div', {
	    staticClass: "marg-10-left"
	  }, [_vm._v("\n          (" + _vm._s(_vm.i18n[_vm.locale].duration) + ": " + _vm._s(_vm.newLessonDuration) + " " + _vm._s(_vm.i18n[_vm.locale].minutes) + ")\n        ")])]), _vm._v(" "), _c('p', {
	    staticClass: "italic"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].everything_will_be_cloned))]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer modal-footer__flex"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.closeModal.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.submit.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1947 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-mask",
	    class: {
	      'modal-mask--responsive': _vm.modalResponsive,
	      'modal-mask--flex-container': _vm.modalFlexContainer
	    }
	  }, [_c('div', {
	    staticClass: "modal-wrapper"
	  }, [_c('div', {
	    ref: "modalContent",
	    staticClass: "modal-container",
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-modal": "true",
	      "aria-label": _vm.ariaLabel || null
	    }
	  }, [_c('div', {
	    staticClass: "modal-header",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_vm._t("header", function() {
	    return [_vm._v("default header")]
	  }), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle close-cross",
	    attrs: {
	      "role": "button",
	      "tabindex": "0",
	      "aria-label": _vm.$t('vue2.a11y.close')
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.$emit('close')
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.stopPropagation();
	        return _vm.$emit('close')
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        $event.stopPropagation();
	        return _vm.$emit('close')
	      }]
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2 pointer",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_vm._t("body", function() {
	    return [_vm._v("\n          default body\n        ")]
	  })], 2), _vm._v(" "), (_vm.isShowFooter) ? _c('div', {
	    staticClass: "modal-footer"
	  }, [_vm._t("footer", function() {
	    return [_c('button', {
	      staticClass: "bttn create-btn right marg-10",
	      on: {
	        "click": function($event) {
	          return _vm.$emit('submit')
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(_vm.submitTxt) + "\n          ")])]
	  })], 2) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 1948 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-teamcalendar__saved-views text-dark"
	  }, [(_vm.itemsSelected.length > 0) ? _c('button', {
	    staticClass: "bttn bttn-blue",
	    on: {
	      "click": _vm.setIsSaveModal
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['save_view']) + "\n  ")]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.savedViews).length > 0) ? _c('DDropdown', {
	    attrs: {
	      "isShowDots": false
	    }
	  }, [_c('button', {
	    staticClass: "d-teamcalendar__saved-views__title bttn-simple",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("\n      " + _vm._s(_vm.i18n['saved_views']) + "\n      "), _c('svg', {
	    staticClass: "w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24",
	      "fill": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "fill-rule": "evenodd",
	      "d": "M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z",
	      "clip-rule": "evenodd"
	    }
	  })])]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, _vm._l((_vm.savedViews), function(view, prop) {
	    return _c('li', {
	      staticClass: "d-teamcalendar__saved-views__view",
	      on: {
	        "click": function($event) {
	          return _vm.selectView(view, prop)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(prop) + "\n        "), _c('div', {
	      staticClass: "icon__bg-circle icon__bg-circle--danger icon__bg-circle--small",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setDeleteItemConfirm(prop)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })])])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isSaveModal) ? _c('DModal', {
	    attrs: {
	      "is-bg-overlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": _vm.closeIsSaveModal
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['create_new_view']))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": _vm.closeIsSaveModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n['give_the_view_a_title']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    ref: "is_save_modal_input",
	    staticClass: "d-input marg-1-top",
	    attrs: {
	      "disabled": _vm.isInputTitleDisabled,
	      "placeholder": _vm.i18n['ex_title']
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.saveView.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.title = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (Object.keys(_vm.savedViews).length > 0) ? _c('div', {
	    staticClass: "d-input-group marg-2-top"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n['or_overwrite_existing']))]), _vm._v(" "), _c('select', {
	    staticClass: "d-teamcalendar__saved-views__select",
	    on: {
	      "change": function($event) {
	        return _vm.setReplaceExisting($event.target.value)
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "selected": ""
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['choose_existing']))]), _vm._v(" "), _vm._l((_vm.savedViews), function(view, prop) {
	    return _c('option', [_vm._v("\n              " + _vm._s(prop) + "\n            ")])
	  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "bttn bttn-simple marg-10-right",
	    on: {
	      "click": _vm.closeIsSaveModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), (_vm.title.length < 1) ? _c('button', {
	    staticClass: "bttn submit-button submit-button--disabled"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.create')) + "\n        ")]) : _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.saveView
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.create')))])])])]) : _vm._e(), _vm._v(" "), (_vm.isConfirmModal) ? _c('ModalConfirmation', {
	    attrs: {
	      "show-close": false
	    },
	    on: {
	      "close": function($event) {
	        _vm.isConfirmModal = false
	      },
	      "confirm": _vm.deleteItem
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1949 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "school-camps"
	  }, [_c('div', {
	    staticClass: "school-camps__header"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n[_vm.locale].title))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.openCreateModal
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].create))])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "color": "blue"
	    }
	  }) : _c('table', {
	    staticClass: "do-table do-table--striped"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].camp_title))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].classes))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].from_date))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].to_date))]), _vm._v(" "), _c('th', {
	    staticClass: "th-hours"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].teaching_hours))]), _vm._v(" "), _c('th', {
	    staticClass: "th-hours"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].remaining_hours))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].users))]), _vm._v(" "), _c('th', {
	    staticClass: "th-actions"
	  })])]), _vm._v(" "), _c('tbody', [(_vm.camps.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "school-camps__empty",
	    attrs: {
	      "colspan": "8"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].no_camps))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.camps), function(camp) {
	    return _c('tr', {
	      key: camp.id,
	      staticClass: "camp-row",
	      on: {
	        "click": function($event) {
	          return _vm.openEditModal(camp)
	        }
	      }
	    }, [_c('td', {
	      staticClass: "td-title"
	    }, [_vm._v(_vm._s(camp.title))]), _vm._v(" "), _c('td', {
	      staticClass: "td-calendars"
	    }, [_vm._v(_vm._s(_vm.getCalendarNamesByType(camp.calendar_ids, 'klass')))]), _vm._v(" "), _c('td', {
	      staticClass: "td-datetime"
	    }, [_vm._v(_vm._s(_vm.formatDateTime(camp.from_time)))]), _vm._v(" "), _c('td', {
	      staticClass: "td-datetime"
	    }, [_vm._v(_vm._s(_vm.formatDateTime(camp.to_time)))]), _vm._v(" "), _c('td', {
	      staticClass: "td-hours"
	    }, [_vm._v(_vm._s(camp.teaching_hours != null ? parseFloat(camp.teaching_hours.toFixed(2)) : ''))]), _vm._v(" "), _c('td', {
	      staticClass: "td-hours"
	    }, [_vm._v(_vm._s(camp.remaining_hours != null ? parseFloat(camp.remaining_hours.toFixed(2)) : ''))]), _vm._v(" "), _c('td', {
	      staticClass: "td-calendars"
	    }, [_vm._v(_vm._s(_vm.getCalendarNamesByType(camp.calendar_ids, 'user')))]), _vm._v(" "), _c('td', {
	      staticClass: "td-actions",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	        }
	      }
	    }, [_c('button', {
	      staticClass: "do-bttn do-bttn--small",
	      on: {
	        "click": function($event) {
	          return _vm.openEditModal(camp)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-pencil"
	    })]), _vm._v(" "), _c('button', {
	      staticClass: "do-bttn do-bttn--small do-bttn--danger",
	      on: {
	        "click": function($event) {
	          _vm.theDeleteCamp = camp
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })])])])
	  })], 2)]), _vm._v(" "), (_vm.isModal) ? _c('div', {
	    staticClass: "camp-create text-dark"
	  }, [_c('DModal', {
	    attrs: {
	      "show-close": false,
	      "placeInTop": true
	    },
	    on: {
	      "close": _vm.closeModal
	    }
	  }, [_c('div', {
	    staticClass: "camp-create__modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "camp-create__header"
	  }, [_c('h3', [(!_vm.theEditCamp) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].create))]) : _c('span', [_vm._v(_vm._s(_vm.form.title))])]), _vm._v(" "), _c('div', {
	    staticClass: "camp-create__close icon__bg-circle",
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('form', {
	    staticClass: "camp-create__body",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "camp-create__grid"
	  }, [_c('div', {
	    staticClass: "camp-create__form"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale].camp_title))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.title),
	      expression: "form.title"
	    }],
	    ref: "titleInput",
	    staticClass: "d-input",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale].title_placeholder
	    },
	    domProps: {
	      "value": (_vm.form.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.form, "title", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-list2"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale].add_classes))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "klass",
	      "preSelectedItems": _vm.form.klassCalendarIds
	    },
	    on: {
	      "update": _vm.setSelectedKlasses
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale].add_users))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "USER",
	      "preSelectedItems": _vm.form.userCalendarIds,
	      "showTags": true
	    },
	    on: {
	      "update": _vm.setSelectedUsers
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "date-time-input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale].from_date))]), _vm._v(" "), _c('div', {
	    staticClass: "date-time-row"
	  }, [_c('div', {
	    staticClass: "date-field date-time-row__date"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.form.fromTime,
	      "width100": true,
	      "minDate": _vm.schoolYearMinDate,
	      "maxDate": _vm.schoolYearMaxDate
	    },
	    on: {
	      "changed": _vm.onFromDateChanged
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "input-with-icon"
	  }, [_c('div', {
	    staticClass: "icon icon-clock"
	  }), _vm._v(" "), _c('time-input', {
	    attrs: {
	      "date": _vm.form.fromTime
	    },
	    on: {
	      "changed": _vm.onStartTimeInput
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "date-time-input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale].to_date))]), _vm._v(" "), _c('div', {
	    staticClass: "date-time-row"
	  }, [_c('div', {
	    staticClass: "date-field date-time-row__date"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.form.toTime,
	      "width100": true,
	      "minDate": _vm.schoolYearMinDate,
	      "maxDate": _vm.schoolYearMaxDate
	    },
	    on: {
	      "changed": _vm.onToDateChanged
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "input-with-icon"
	  }, [_c('div', {
	    staticClass: "icon icon-clock"
	  }), _vm._v(" "), _c('time-input', {
	    attrs: {
	      "date": _vm.form.toTime
	    },
	    on: {
	      "changed": _vm.onEndTimeInput
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "input-group marg-1-top"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale].available_time))]), _vm._v(" "), _c('div', {
	    staticClass: "camp-toggle"
	  }, [_c('div', {
	    staticClass: "camp-toggle__option",
	    class: {
	      'camp-toggle__option--selected': _vm.form.useAdditionalTasks
	    },
	    on: {
	      "click": function($event) {
	        _vm.form.useAdditionalTasks = true
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "radio",
	      "name": "use_additional_tasks"
	    },
	    domProps: {
	      "checked": _vm.form.useAdditionalTasks
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "camp-toggle__option-text"
	  }, [_c('span', {
	    staticClass: "bold"
	  }, [_vm._v("Indregnes i arbejdstiden (1/3) som øvrig opgave")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].add_to_tasks))])])]), _vm._v(" "), _c('div', {
	    staticClass: "camp-toggle__option",
	    class: {
	      'camp-toggle__option--selected': !_vm.form.useAdditionalTasks
	    },
	    on: {
	      "click": function($event) {
	        _vm.form.useAdditionalTasks = false
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "radio",
	      "name": "use_additional_tasks"
	    },
	    domProps: {
	      "checked": !_vm.form.useAdditionalTasks
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "camp-toggle__option-text"
	  }, [_c('span', {
	    staticClass: "bold"
	  }, [_vm._v("Udbetales som engangsydelse")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].pay_out))])])])])])]), _vm._v(" "), (_vm.selectedUsers.length > 0) ? _c('div', {
	    staticClass: "camp-create__sidebar"
	  }, [_c('div', {
	    staticClass: "camp-create__sidebar-desc"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n[_vm.locale].existing_hours))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale].existing_hours_desc))])]), _vm._v(" "), _c('table', {
	    staticClass: "do-table do-table--striped"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].person))]), _vm._v(" "), _c('th', {
	    staticClass: "td-number"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].in_schedule))]), _vm._v(" "), _c('th', {
	    staticClass: "th-hours"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].hours_label))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedUsers), function(user) {
	    return _c('tr', {
	      key: user.id
	    }, [_c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
	      staticClass: "td-number"
	    }, [_vm._v("\n                      " + _vm._s(_vm.formatMinutesToHours(_vm.scheduledHours[user.id])) + "t\n                    ")]), _vm._v(" "), _c('td', {
	      staticClass: "td-hours"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model.number",
	        value: (_vm.form.existingHours[user.id]),
	        expression: "form.existingHours[user.id]",
	        modifiers: {
	          "number": true
	        }
	      }],
	      staticClass: "d-input td-hours__input",
	      attrs: {
	        "type": "number",
	        "placeholder": "0",
	        "min": "0",
	        "step": "any"
	      },
	      domProps: {
	        "value": (_vm.form.existingHours[user.id])
	      },
	      on: {
	        "focus": function($event) {
	          return $event.target.select()
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.form.existingHours, user.id, _vm._n($event.target.value))
	        },
	        "blur": function($event) {
	          return _vm.$forceUpdate()
	        }
	      }
	    })])])
	  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__submit marg-1-top"
	  }, [_c('div', {
	    staticClass: "input-group__submit__left"
	  }, [(_vm.theEditCamp) ? [_c('button', {
	    staticClass: "bttn--warning",
	    on: {
	      "click": function($event) {
	        _vm.theDeleteCamp = _vm.theEditCamp
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })])] : _vm._e(), _vm._v(" "), _c('a', {
	    staticClass: "camp-create__guide",
	    attrs: {
	      "href": "https://app.docendo.dk/app#/helpdesk?article=239",
	      "target": "_blank"
	    }
	  }, [_c('span', {
	    staticClass: "icon-question3"
	  }), _vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale].guide) + "\n              ")])], 2), _vm._v(" "), _c('div', {
	    staticClass: "input-group__submit__right"
	  }, [_c('button', {
	    staticClass: "marg-1-right do-bttn",
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].cancel))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSaving
	    },
	    attrs: {
	      "disabled": !_vm.isFormValid
	    },
	    on: {
	      "click": _vm.saveCamp
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.theEditCamp ? _vm.i18n[_vm.locale].save : _vm.i18n[_vm.locale].create) + "\n              ")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-overlay animatedFast fadeIn"
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.theDeleteCamp) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isSubmitButtonLoading": _vm.isDeleting
	    },
	    on: {
	      "close": function($event) {
	        _vm.theDeleteCamp = null
	      },
	      "confirm": _vm.deleteCamp
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1950 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "d-table d-table__tasks"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'name'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortKey('name')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.getI18n(_vm.title)) + "\n      "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'calendar'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortKey('calendar')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.task_overview.belongs_to')) + "\n      "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
	    staticClass: "th-sorter is-number",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'actual'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortKey('actual')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n      "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.tasksGrouped), function(taskGroup) {
	    return [_c('tr', {
	      staticClass: "d-table__second-header"
	    }, [_c('th', {
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_vm._v("\n        " + _vm._s(_vm.getI18n(taskGroup.masterType)) + "\n      ")]), _vm._v(" "), _c('th', {
	      staticClass: "is-number"
	    }, [(_vm.isShowScheduled) ? [_vm._v(_vm._s(_vm.toFixedIfNecessary(taskGroup.sum, 2)))] : _vm._e()], 2)]), _vm._v(" "), _vm._l((taskGroup.events), function(task) {
	      return _c('tr', {
	        key: task.id,
	        attrs: {
	          "data-task-id": task.id
	        }
	      }, [_c('td', [_c('div', {
	        staticClass: "task-with-edit"
	      }, [(task.can_schedule === 't') ? _c('div', {
	        staticClass: "subjects_subject",
	        style: ({
	          'background': task.color
	        })
	      }, [_vm._v("\n            " + _vm._s(task.name) + "\n          ")]) : _c('div', {
	        staticClass: "subjects_subject subjects_subject--not-subject"
	      }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
	        staticClass: "td-calendars"
	      }, [_vm._v("\n        " + _vm._s(task.calendar) + "\n      ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	        staticClass: "is-number"
	      }, [_vm._v(_vm._s(_vm.getTaskActual(task)))]) : _vm._e()])
	    })]
	  })], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'actual'
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.sumOfActual) + "\n    ")]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 1951 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activeAbsenceReason) ? _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true
	    },
	    on: {
	      "close": _vm.close
	    }
	  }, [_c('div', {
	    staticClass: "text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [(_vm.isActiveAbsenceReasonIsReadyToDelete) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.delete_absence')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.change_start_and_end_date')))])]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body d-modal__body--edit-absence",
	    class: {
	      'd-modal__body--edit-absence--with-opus': _vm.isShowSalaryInfoBox
	    }
	  }, [_c('div', {
	    staticClass: "d-modal__body--edit-absence__header"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.showUser.default_thumb_url,
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "absent-user__name"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.showUser.name))]), _vm._v(" "), _c('div', {
	    staticClass: "reason"
	  }, [_c('p', [_vm._v(_vm._s(_vm.getReasonTitle(_vm.activeAbsenceReason)))]), _vm._v(" "), _c('p', [(_vm.isOngoing && _vm.isAbsenceOngoing) ? _c('span', {
	    staticClass: "badge badge--orange badge--small"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence')))]) : _vm._e(), _vm._v(" "), (!_vm.isOngoing && _vm.getIsAbsenceMultipleDays) ? _c('span', {
	    staticClass: "badge badge--small"
	  }, [_vm._v(" " + _vm._s(_vm.$t('vue2.substitution_user.multiple_days')))]) : _vm._e()])]), _vm._v(" "), _c('p', [(_vm.getSerialListItem) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.formatDate(_vm.getSerialListItem.from_date)) + "\n            - " + _vm._s(_vm.formatDate(_vm.getSerialListItem.to_date)) + ", " + _vm._s(_vm._f("showTime")(_vm.getSerialListItem.from_time)) + " - " + _vm._s(_vm._f("showTime")(_vm.getSerialListItem.to_time)) + "\n          ")]) : _c('span', [_vm._v("\n            " + _vm._s(_vm._f("showDate")(_vm.activeAbsenceReason.start)) + " -\n            "), _c('span', [_vm._v(_vm._s(_vm._f("showTime")(_vm.activeAbsenceReason.end)))])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body--edit-absence__flex"
	  }, [_c('div', {
	    staticClass: "d-modal__body--edit-absence__left"
	  }, [_c('div', {
	    staticClass: "d-modal__body--edit-absence__body"
	  }, [(!_vm.isActiveAbsenceReasonIsReadyToDelete) ? _c('div', {
	    staticClass: "d-modal__page-1"
	  }, [(_vm.hasSentSdFravaer) ? _c('div', {
	    staticClass: "do-warning marg-1-bottom"
	  }, [_vm._v("\n                Fraværet er allerede sendt til SD. Ændrer du datoerne, sendes en rettelse ved næste\n                automatiske indberetning. Andre ændringer, fx af årsagen, rettes ikke automatisk og\n                skal ændres direkte i SD."), (_vm.hasDraftSdFravaer && !_vm.isReasonChangedAwayFromSd) ? [_vm._v("\n                Usendte indberetninger i udbakken opdateres med dine ændringer.")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isReasonChangedAwayFromSd) ? _c('div', {
	    staticClass: "do-warning marg-1-bottom"
	  }, [_vm._v("\n                Den valgte årsag har ingen SD-kode, men fraværet har usendte SD-indberetninger i\n                udbakken. De opdateres ikke ved årsagsskift og vil stadig blive sendt med den\n                oprindelige årsag. Slet dem i udbakken under Løn og Fravær →\n                Fraværsindberetninger, hvis de ikke skal sendes.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.reason) ? _c('div', {
	    staticClass: "d-modal__body--edit-absence__body__input-group"
	  }, [_c('label', {
	    staticClass: "d-label marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.reason')))]), _vm._v(" "), _c('div', {
	    staticClass: "absence-reason"
	  }, [_c('div', [_c('DSelect', {
	    attrs: {
	      "items": _vm.subsAbsenceReasonsSorted,
	      "multiple": false,
	      "items-selected": _vm.reason,
	      "placeholder": _vm.$t('vue2.substitution.choose_absence_reason')
	    },
	    on: {
	      "update": _vm.setReason
	    },
	    scopedSlots: _vm._u([(_vm.isAbsenceIntegrationActive) ? {
	      key: "item-badge",
	      fn: function(ref) {
	        var item = ref.item;
	
	        return [(item.kmd_absence_code_id) ? _c('span', {
	          staticClass: "do-opus-badge"
	        }, [_vm._v("OPUS")]) : _vm._e(), _vm._v(" "), (item.sd_absence_code_id) ? _c('span', {
	          staticClass: "do-sd-badge"
	        }, [_vm._v("SD")]) : _vm._e()]
	      }
	    } : null], null, true)
	  }, [_vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "noMatch"
	    },
	    slot: "noMatch"
	  }, [_c('h4', [_vm._v("\n                          " + _vm._s(_vm.$t('vue2.dselect.no_matching_results')) + "\n                        ")])])])], 1)]), _vm._v(" "), (_vm.showErrors) ? _c('span', {
	    staticClass: "error-message"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.reason_must_be_filled')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body--edit-absence__body__input-group"
	  }, [_c('label', {
	    staticClass: "d-label marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.date_label')))]), _vm._v(" "), _c('div', {
	    staticClass: "flex"
	  }, [_c('DatepickerRange', {
	    attrs: {
	      "allowSameDate": true,
	      "startdate": _vm.originalStart,
	      "enddate": _vm.originalEnd
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "absence-no-end-date",
	    class: [{
	      'absence-no-end-date--active': _vm.isAbsenceOngoing
	    }, {
	      'absence-no-end-date--disabled': !_vm.isOngoingAbsenceAllowed
	    }]
	  }, [(!_vm.isOngoingAbsenceAllowed) ? _c('div', {
	    staticClass: "absence-no-end-date--not-allowed"
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "absence-no-end-date__inner",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        _vm.isAbsenceOngoing = !_vm.isAbsenceOngoing
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "prop-on": _vm.isAbsenceOngoing
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence')))])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
	    attrs: {
	      "slot": "answer"
	    },
	    slot: "answer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence_explained')))])])], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body--edit-absence__body__input-group"
	  }, [_c('label', {
	    staticClass: "d-label marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.time')))]), _vm._v(" "), _c('TimeChanger', {
	    attrs: {
	      "showIcon": true,
	      "start": _vm.startTime,
	      "end": _vm.endTime
	    },
	    on: {
	      "updateStart": _vm.setStartTime,
	      "updateEnd": _vm.setEndTime
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.deleteAbsenceFollowingDates.length > 0) ? _c('p', [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.absence_will_be_deleted')))]), _vm._v(" "), _vm._l((_vm.deleteAbsenceFollowingDates), function(date, idx) {
	    return _c('span', [(idx > 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.formatDate(date)))])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.isActiveAbsenceReasonIsReadyToDelete && _vm.hasSdFravaer) ? _c('div', {
	    staticClass: "do-warning marg-1-bottom"
	  }, [(_vm.hasSentSdFravaer) ? [_vm._v("\n                Fraværet er allerede sendt til SD. Sendte indberetninger trækkes ikke tilbage, når\n                fraværet slettes, og skal korrigeres manuelt i SD.\n              ")] : _vm._e(), _vm._v(" "), (_vm.hasDraftSdFravaer) ? [_vm._v("\n                " + _vm._s(_vm.hasSentSdFravaer ? 'Usendte indberetninger' : 'Fraværets usendte indberetninger') + "\n                i udbakken slettes sammen med fraværet.\n              ")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.originalDatesNotInNewRange.length > 0) ? _c('div', {
	    staticClass: "d-modal__page-2"
	  }, [_c('SubsDeleteAbsence', {
	    attrs: {
	      "calendarId": this.activeAbsenceReason.calendar_id,
	      "firstRange": _vm.originalDatesNotInNewRangeMinimum,
	      "lastRange": _vm.originalDatesNotInNewRangeMaximum,
	      "dates": _vm.originalDatesNotInNewRange,
	      "startTime": _vm.startTime,
	      "endTime": _vm.endTime
	    },
	    on: {
	      "lessonsWithSubs": _vm.setLessonsWithSubs,
	      "gotLessons": function($event) {
	        _vm.isLessonsLoaded = true
	      },
	      "changed": _vm.setDeleteSubs
	    }
	  })], 1) : _vm._e()])]), _vm._v(" "), (_vm.isShowSalaryInfoBox) ? _c('div', {
	    staticClass: "edit-absence__opus-sidebar"
	  }, [(!_vm.isLoadedSalarySystemInfo) ? _c('div', {
	    staticClass: "edit-absence__opus-loading"
	  }, [_c('div', {
	    staticClass: "do-spinner"
	  })]) : _vm._e(), _vm._v(" "), (_vm.isLoadedSalarySystemInfo && _vm.isShowSdInfoBox) ? _c('div', {
	    staticClass: "edit-absence__opus-content"
	  }, [_c('div', {
	    staticClass: "do-sd-badge do-opus-badge--large opus-info__header"
	  }, [_vm._v("SD")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Ansættelse")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedEmploymentId),
	      expression: "selectedEmploymentId"
	    }],
	    staticClass: "do-select",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedEmploymentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.onEmploymentChange($event.target.value)
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("— Vælg ansættelsesnummer —")]), _vm._v(" "), _vm._l((_vm.userEmployments), function(employment) {
	    return _c('option', {
	      key: employment.id,
	      domProps: {
	        "value": employment.id
	      }
	    }, [_vm._v("\n                  " + _vm._s(employment.title) + " - " + _vm._s(employment.employment_number || employment.id) + "\n                ")])
	  })], 2), _vm._v(" "), (!_vm.isEmploymentSelected && _vm.showErrors) ? _c('span', {
	    staticClass: "error-message"
	  }, [_vm._v("\n                Ansættelsesnummer skal vælges\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Fraværsårsag")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__reason-display"
	  }, [(_vm.getSDAbsence) ? _c('span', {
	    staticClass: "opus-info__reason-code"
	  }, [_vm._v("\n                  " + _vm._s(_vm.getSDAbsence.loenart) + _vm._s(_vm.getSDAbsence.title ? ' - ' + _vm.getSDAbsence.title : '') + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Dato")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__date-text"
	  }, [(_vm.isAbsenceOngoing) ? _c('span', [_vm._v(_vm._s(_vm.startDateFormatted) + " - Åbenstående")]) : _c('span', [_vm._v(_vm._s(_vm.dateRangeFormatted) + " "), _c('span', {
	    staticClass: "opus-info__date-days"
	  }, [_vm._v("(" + _vm._s(_vm.dateRangeDaysFormatted) + ")")])])]), _vm._v(" "), (_vm.isOngoingAbsenceAllowed) ? _c('div', {
	    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
	  }, [_c('div', {
	    staticClass: "do-opus-whole-day-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.setIsAbsenceOngoing(!_vm.isAbsenceOngoing)
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "prop-on": _vm.isAbsenceOngoing
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Indberet som åbenstående")])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
	    staticClass: "text-dark",
	    attrs: {
	      "slot": "answer"
	    },
	    slot: "answer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence_explained')))])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Tid")]), _vm._v(" "), (_vm.useTime) ? _c('div', {
	    staticClass: "opus-info__date-text"
	  }, [_vm._v("\n                " + _vm._s(_vm.startTime.format('HH:mm')) + " - " + _vm._s(_vm.endTime.format('HH:mm')) + " "), _c('span', {
	    staticClass: "opus-info__date-days"
	  }, [_vm._v("(" + _vm._s(_vm.timeRangeHoursFormatted) + ")")])]) : _c('div', {
	    staticClass: "opus-info__date-text"
	  }, [_vm._v("\n                Hel dag\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
	  }, [_c('div', {
	    staticClass: "do-opus-whole-day-toggle",
	    on: {
	      "click": function($event) {
	        _vm.useTime = !_vm.useTime
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "prop-on": !_vm.useTime
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Indberet som hel dag")])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
	    staticClass: "text-dark",
	    attrs: {
	      "slot": "answer"
	    },
	    slot: "answer"
	  }, [_vm._v("Toggle fra for at indberette timebaseret fravær, hvis fraværet kun gælder en del af dagen.")])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isLoadedSalarySystemInfo && _vm.isShowOpusInfoBox) ? _c('div', {
	    staticClass: "edit-absence__opus-content"
	  }, [_c('div', {
	    staticClass: "do-opus-badge do-opus-badge--large opus-info__header"
	  }, [_vm._v("Opus")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Ansættelse")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedEmploymentId),
	      expression: "selectedEmploymentId"
	    }],
	    staticClass: "do-select",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedEmploymentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.onEmploymentChange($event.target.value)
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("— Vælg ansættelsesnummer —")]), _vm._v(" "), _vm._l((_vm.userEmployments), function(employment) {
	    return _c('option', {
	      key: employment.id,
	      domProps: {
	        "value": employment.id
	      }
	    }, [_vm._v("\n                  " + _vm._s(employment.title) + " - " + _vm._s(employment.employment_number || employment.id) + "\n                ")])
	  })], 2), _vm._v(" "), (!_vm.isEmploymentSelected && _vm.showErrors) ? _c('span', {
	    staticClass: "error-message"
	  }, [_vm._v("\n                Ansættelsesnummer skal vælges\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Fraværsårsag")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__reason-display"
	  }, [(_vm.getOPUSAbsence) ? _c('span', {
	    staticClass: "opus-info__reason-code"
	  }, [_vm._v("\n                  " + _vm._s(_vm.getOPUSAbsence.absence_type) + _vm._s(_vm.getOPUSAbsence.absence_type_text ? ' - ' + _vm.getOPUSAbsence.absence_type_text : '') + "\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.isShowExtraInformation) ? _c('div', {
	    staticClass: "opus-info__extra-info"
	  }, [(_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'Maternity') ? [_c('label', {
	    staticClass: "opus-info__label opus-info__label--secondary"
	  }, [_vm._v("Ekstra information til barselssager")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
	    staticClass: "do-spinner do-spinner--small"
	  }) : (_vm.additionalDataError) ? _c('div', {
	    staticClass: "opus-info__error"
	  }, [_c('span', {
	    staticClass: "opus-info__error-icon"
	  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAdditionalData),
	      expression: "selectedAdditionalData"
	    }],
	    staticClass: "do-select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
	    return _c('option', {
	      key: option.MaternityCaseKey,
	      domProps: {
	        "value": option.MaternityCaseKey
	      }
	    }, [_vm._v("\n                      " + _vm._s(option.ExpectedDeliveryDate) + " - " + _vm._s(option.MaternityCaseKey) + "\n                    ")])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasLoadedAdditionalData && _vm.additionalDataOptions.length === 0) ? _c('p', {
	    staticClass: "opus-info__note"
	  }, [_vm._v("\n                    Der er ingen barselssager tilknyttet denne medarbejder i Opus.\n                  ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'Reason') ? [_c('label', {
	    staticClass: "opus-info__label opus-info__label--secondary"
	  }, [_vm._v("Ekstra information til tjenestefri")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
	    staticClass: "do-spinner do-spinner--small"
	  }) : (_vm.additionalDataError) ? _c('div', {
	    staticClass: "opus-info__error"
	  }, [_c('span', {
	    staticClass: "opus-info__error-icon"
	  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAdditionalData),
	      expression: "selectedAdditionalData"
	    }],
	    staticClass: "do-select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
	    return _c('option', {
	      key: option.ReasonCode,
	      domProps: {
	        "value": option.ReasonCode
	      }
	    }, [_vm._v("\n                      " + _vm._s(option.ReasonCodeText) + " - " + _vm._s(option.ReasonCode) + "\n                    ")])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasLoadedAdditionalData && _vm.additionalDataOptions.length === 0) ? _c('p', {
	    staticClass: "opus-info__note"
	  }, [_vm._v("\n                    Der er ingen tjenestefri årsager tilknyttet denne medarbejder i Opus.\n                  ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'WorkInjury') ? [_c('label', {
	    staticClass: "opus-info__label opus-info__label--secondary"
	  }, [_vm._v("Ekstra information til arbejdsskader")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
	    staticClass: "do-spinner do-spinner--small"
	  }) : (_vm.additionalDataError) ? _c('div', {
	    staticClass: "opus-info__error"
	  }, [_c('span', {
	    staticClass: "opus-info__error-icon"
	  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAdditionalData),
	      expression: "selectedAdditionalData"
	    }],
	    staticClass: "do-select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
	    return _c('option', {
	      key: option.AccidentNumber,
	      domProps: {
	        "value": option.AccidentNumber
	      }
	    }, [_vm._v("\n                      " + _vm._s(option.AccidentDate) + " - " + _vm._s(option.AccidentNumber) + "\n                    ")])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasLoadedAdditionalData && _vm.additionalDataOptions.length === 0) ? _c('p', {
	    staticClass: "opus-info__note"
	  }, [_vm._v("\n                    Der er ingen arbejdsskadesager tilknyttet denne medarbejder i Opus.\n                  ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'Child') ? [_c('label', {
	    staticClass: "opus-info__label opus-info__label--secondary"
	  }, [_vm._v("Ekstra information til omsorgsdage")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
	    staticClass: "do-spinner do-spinner--small"
	  }) : (_vm.additionalDataError) ? _c('div', {
	    staticClass: "opus-info__error"
	  }, [_c('span', {
	    staticClass: "opus-info__error-icon"
	  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAdditionalData),
	      expression: "selectedAdditionalData"
	    }],
	    staticClass: "do-select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
	    return _c('option', {
	      key: option.ChildNumber,
	      domProps: {
	        "value": option.ChildNumber
	      }
	    }, [_vm._v("\n                      " + _vm._s(option.FirstName) + " " + _vm._s(option.LastName) + " - " + _vm._s(option.ChildNumber) + "\n                    ")])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasLoadedAdditionalData && _vm.additionalDataOptions.length === 0) ? _c('p', {
	    staticClass: "opus-info__note"
	  }, [_vm._v("\n                    Der er ingen barn tilknyttet denne medarbejder i Opus.\n                  ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.isAdditionalDataSelected && _vm.showErrors) ? _c('span', {
	    staticClass: "error-message"
	  }, [_vm._v("\n                  " + _vm._s(_vm.additionalDataValidationError) + "\n                ")]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Dato")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__date-text"
	  }, [(_vm.isAbsenceOngoing) ? _c('span', [_vm._v(_vm._s(_vm.startDateFormatted) + " →")]) : _c('span', [_vm._v(_vm._s(_vm.dateRangeFormatted) + " "), _c('span', {
	    staticClass: "opus-info__date-days"
	  }, [_vm._v("(" + _vm._s(_vm.dateRangeDaysFormatted) + ")")])])]), _vm._v(" "), (_vm.isOpusAllowOpen) ? _c('div', {
	    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
	  }, [_c('div', {
	    staticClass: "do-opus-whole-day-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.setIsAbsenceOngoing(!_vm.isAbsenceOngoing)
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "prop-on": _vm.isAbsenceOngoing
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Indberet som åbenstående")])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
	    staticClass: "text-dark",
	    attrs: {
	      "slot": "answer"
	    },
	    slot: "answer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence_explained')))])])], 1) : (!_vm.isOpusAllowOpen) ? _c('p', {
	    staticClass: "opus-info__note--muted"
	  }, [_vm._v("\n                Åbenstående fravær er ikke muligt for denne fraværsårsag\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Tid")]), _vm._v(" "), (_vm.useTime) ? _c('div', {
	    staticClass: "opus-info__date-text"
	  }, [_vm._v("\n                " + _vm._s(_vm.startTime.format('HH:mm')) + " - " + _vm._s(_vm.endTime.format('HH:mm')) + " "), _c('span', {
	    staticClass: "opus-info__date-days"
	  }, [_vm._v("(" + _vm._s(_vm.timeRangeHoursFormatted) + ")")])]) : _c('div', {
	    staticClass: "opus-info__date-text"
	  }, [_vm._v("\n                Hel dag\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
	  }, [_c('div', {
	    staticClass: "do-opus-whole-day-toggle",
	    on: {
	      "click": function($event) {
	        _vm.useTime = !_vm.useTime
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "prop-on": !_vm.useTime
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Indberet som hel dag")])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
	    staticClass: "text-dark",
	    attrs: {
	      "slot": "answer"
	    },
	    slot: "answer"
	  }, [_vm._v("Toggle fra for at indberette timebaseret fravær, hvis fraværet kun gælder en del af dagen.")])])], 1)])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons d-modal__body--edit-absence__actions"
	  }, [_c('div', [(!_vm.isActiveAbsenceReasonIsReadyToDelete) ? _c('button', {
	    staticClass: "bttn bttn-danger marg-5-right",
	    on: {
	      "click": function($event) {
	        return _vm.$store.commit('setIsActiveAbsenceReasonIsReadyToDelete', true)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body--edit-absence__actions__right"
	  }, [_c('button', {
	    staticClass: "marg-5-right",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (_vm.isActiveAbsenceReasonIsReadyToDelete) ? [_c('button', {
	    staticClass: "submit-button submit-button--danger",
	    on: {
	      "click": _vm.removeSubsAndDeleteAbsence
	    }
	  }, [(_vm.eventsToRemovedSubs.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.remove_subs_and_delete_absence')))]) : _vm._e(), _vm._v(" "), (_vm.lessonsWithSubs.length > 0 && _vm.eventsToRemovedSubs.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.keep_subs_and_delete_absence')))]) : _vm._e(), _vm._v(" "), (_vm.lessonsWithSubs.length < 1 && _vm.eventsToRemovedSubs.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.delete_absence')))]) : _vm._e()])] : [(_vm.originalDatesNotInNewRange.length > 0) ? _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.removeSubsAndUpdateAbsence
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.common.update')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.originalDatesNotInNewRange.length < 1 && this.eventsToRemovedSubs.length < 1) ? _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.updateDates
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.common.update')) + "\n            ")]) : _vm._e()]], 2)])])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1952 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ModalConfirmation', {
	    attrs: {
	      "isShowConfirmDeleteMessage": false,
	      "appendToBody": true,
	      "customWidth": "420px",
	      "ariaLabel": _vm.title
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('h3', {
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('template', {
	    slot: "custom_warning"
	  }, [_c('p', {
	    staticClass: "onward-confirm__intro"
	  }, [_vm._v(_vm._s(_vm.applyOnwardsText))]), _vm._v(" "), _c('div', {
	    staticClass: "onward-confirm__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleEndDate.apply(null, arguments)
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "propOn": _vm.hasEndDate,
	      "allowChanges": false
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.i18n.choose_end_date))])], 1), _vm._v(" "), (_vm.hasEndDate) ? _c('div', {
	    staticClass: "onward-confirm__date"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.enddate,
	      "minDate": _vm.minDate,
	      "width100": true
	    },
	    on: {
	      "changed": _vm.setEndDate
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), _c('template', {
	    slot: "confirm_buttons"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n.cancel))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn",
	    class: {
	      'bttn-danger': _vm.mode === 'remove'
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.onConfirm.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.confirmLabel) + "\n    ")])])], 2)
	},staticRenderFns: []}

/***/ }),
/* 1953 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tags-filter text-dark",
	    class: {
	      'flex_columns': _vm.columns
	    }
	  }, [_c('div', {
	    staticClass: "tags_filter__selected"
	  }, [_c('div', {
	    staticClass: "icon-filter"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "tags_filter__selected"
	  }, [_c('ul', _vm._l((_vm.selectedTags), function(tag) {
	    return _c('li', [_c('tag', {
	      attrs: {
	        "tag": tag
	      },
	      on: {
	        "remove": _vm.removeTag
	      }
	    })], 1)
	  }), 0)])]), _vm._v(" "), (!_vm.active) ? _c('button', {
	    staticClass: "btn-trans tags-filter__header__s-btn",
	    on: {
	      "click": function($event) {
	        _vm.active = true
	      }
	    }
	  }, [_vm._v("+\n    " + _vm._s(_vm.searchText.length > 1 ? _vm.searchText : _vm.$t('vue2.tagging.search_tag')) + "\n  ")]) : _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.hideActive),
	      expression: "hideActive"
	    }],
	    staticClass: "tags-filter-wrapper"
	  }, [_c('div', {
	    staticClass: "tags-filter__header"
	  }, [_c('span', {
	    staticClass: "icon-search5"
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "focus",
	      rawName: "v-focus"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tagText),
	      expression: "tagText"
	    }],
	    staticClass: "tags-filter__header__search",
	    class: {
	      'show': _vm.showDropdown
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.tagText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.tagText = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tags_filter__tags",
	    class: {
	      'show': _vm.showDropdown
	    }
	  }, [(!_vm.isShowNoTagsText && (_vm.tags.length === 0)) ? _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.dselect.no_matching_results')))]) : _vm._e(), _vm._v(" "), _c('h4', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.tags.length < 1 && _vm.isShowNoTagsText),
	      expression: "tags.length < 1 && isShowNoTagsText"
	    }]
	  }, [_vm._v(_vm._s(_vm.$t('vue2.tagging.you_have_created_zero_tags')) + "\n        "), _c('a', {
	    attrs: {
	      "href": '/schools/' + _vm.schoolid + '/groups/#/'
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.tagging.create_tags')))])]), _vm._v(" "), _c('h4', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.filteredTags.length < 1 && _vm.tags.length > 0),
	      expression: "filteredTags.length < 1 && tags.length > 0"
	    }]
	  }, [_vm._v("0 " + _vm._s(_vm.$t('vue2.tagging.with')) + " \"" + _vm._s(_vm.tagText) + "\"")]), _vm._v(" "), _c('ul', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.filteredTags.length > 0),
	      expression: "filteredTags.length > 0"
	    }]
	  }, _vm._l((_vm.notSelectedTags), function(tag) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.setTag(tag)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-price-tag2"
	    }), _vm._v(" " + _vm._s(tag) + " "), (_vm.showHowMany) ? _c('span', [_vm._v("(" + _vm._s(_vm.howManyWithTag(tag)) + ")")]) : _vm._e()])
	  }), 0)])])])
	},staticRenderFns: []}

/***/ }),
/* 1954 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Åbningstider")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Dag")]), _vm._v(" "), _c('th', [_vm._v("Åbner")]), _vm._v(" "), _c('th', [_vm._v("Lukker")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.openingHours), function(time, day) {
	    return _c('tr', {
	      key: day
	    }, [_c('td', [_vm._v(_vm._s(_vm.getDayName(day)))]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (time.open),
	        expression: "time.open"
	      }],
	      attrs: {
	        "type": "time"
	      },
	      domProps: {
	        "value": (time.open)
	      },
	      on: {
	        "change": function($event) {
	          return _vm.formatTime(day, 'open')
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(time, "open", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (time.close),
	        expression: "time.close"
	      }],
	      attrs: {
	        "type": "time"
	      },
	      domProps: {
	        "value": (time.close)
	      },
	      on: {
	        "change": function($event) {
	          return _vm.formatTime(day, 'close')
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(time, "close", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: false,
	          placement: 'right'
	        }),
	        expression: "{\n                  arrow: false,\n                  placement : 'right'\n                }"
	      }],
	      staticClass: "icon__bg-circle icon__bg-circle--danger",
	      attrs: {
	        "content": 'Slet'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.deleteDay(day)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })])])])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSaving
	    },
	    on: {
	      "click": _vm.saveOpeningHours
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1955 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "day-select__container"
	  }, [_c('ul', {
	    staticClass: "flex-1 weekdays"
	  }, _vm._l((7), function(n) {
	    return _c('li', [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.day(n))))])
	  }), 0), _vm._v(" "), _c('ul', {
	    staticClass: "flex flex-1",
	    attrs: {
	      "id": "select_day"
	    }
	  }, [_c('li', {
	    class: {
	      'isToday': _vm.isToday(_vm.date)
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.setDay(1)
	      }
	    }
	  }, [_c('div', {
	    class: [_vm.isMon ? 'active' : '']
	  }, [_vm._v(_vm._s(_vm.$filters.D(_vm.$filters.dayOfWeek(_vm.date, 1))))])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.setDay(2)
	      }
	    }
	  }, [_c('div', {
	    class: [_vm.isTue ? 'active' : '']
	  }, [_vm._v(_vm._s(_vm.$filters.D(_vm.$filters.dayOfWeek(_vm.date, 2))))])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.setDay(3)
	      }
	    }
	  }, [_c('div', {
	    class: [_vm.isWed ? 'active' : '']
	  }, [_vm._v(_vm._s(_vm.$filters.D(_vm.$filters.dayOfWeek(_vm.date, 3))))])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setDay(4)
	      }
	    }
	  }, [_c('div', {
	    class: [_vm.isTur ? 'active' : '']
	  }, [_vm._v(_vm._s(_vm.$filters.D(_vm.$filters.dayOfWeek(_vm.date, 4))))])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setDay(5)
	      }
	    }
	  }, [_c('div', {
	    class: [_vm.isFri ? 'active' : '']
	  }, [_vm._v(_vm._s(_vm.$filters.D(_vm.$filters.dayOfWeek(_vm.date, 5))))])]), _vm._v(" "), (_vm.weekends) ? _c('li', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setDay(6)
	      }
	    }
	  }, [_c('div', {
	    class: [_vm.isSat ? 'active' : '']
	  }, [_vm._v(_vm._s(_vm.$filters.D(_vm.$filters.dayOfWeek(_vm.date, 6))))])]) : _vm._e(), _vm._v(" "), (_vm.weekends) ? _c('li', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setDay(7)
	      }
	    }
	  }, [_c('div', {
	    class: [_vm.isSun ? 'active' : '']
	  }, [_vm._v(_vm._s(_vm.$filters.D(_vm.$filters.dayOfWeek(_vm.date, 7))))])]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1956 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "onward-end-date"
	  }, [_c('label', {
	    staticClass: "onward-end-date__toggle"
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": !!_vm.enddate
	    },
	    on: {
	      "change": _vm.onToggle
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), (_vm.enddate) ? _c('DateSelector', {
	    attrs: {
	      "date": _vm.enddate,
	      "minDate": _vm.minDate,
	      "width100": true
	    },
	    on: {
	      "changed": _vm.onDateChanged
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1957 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.clickaway),
	      expression: "clickaway"
	    }],
	    staticClass: "no-print"
	  }, [_c('div', {
	    staticClass: "sidebar-nav"
	  }, [_c('nav', {
	    staticClass: "nav",
	    attrs: {
	      "aria-label": _vm.$t('vue2.a11y.mainNav')
	    }
	  }, [(_vm.userHasPermission('can_see_other_calendars') || (_vm.userHasMultipleSchools && !_vm.userHasPermission('can_see_other_calendars'))) ? _c('div', {
	    staticClass: "docendo-logo box-shadow"
	  }, [_c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.open === false),
	      expression: "open === false"
	    }],
	    staticClass: "docendo-logo__icon icon-docendo",
	    attrs: {
	      "role": "button",
	      "tabindex": "0",
	      "aria-label": _vm.$t('vue2.a11y.openMenu'),
	      "aria-expanded": _vm.open ? 'true' : 'false'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.openSideNav(0)
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.openSideNav(0)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        return _vm.openSideNav(0)
	      }]
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.open === true),
	      expression: "open === true"
	    }],
	    staticClass: "icon-cross2 font-large",
	    staticStyle: {
	      "padding": "18px"
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0",
	      "aria-label": _vm.$t('vue2.a11y.closeMenu'),
	      "aria-expanded": _vm.open ? 'true' : 'false'
	    },
	    on: {
	      "click": _vm.closeSideNav,
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.closeSideNav.apply(null, arguments)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        return _vm.closeSideNav.apply(null, arguments)
	      }]
	    }
	  })]) : _vm._e(), _vm._v(" "), (!_vm.userHasPermission('can_see_other_calendars') && !_vm.userHasMultipleSchools) ? _c('div', {
	    staticClass: "docendo-logo docendo-logo__not-active box-shadow"
	  }, [_c('span', {
	    staticClass: "docendo-logo__icon icon-docendo"
	  })]) : _vm._e(), _vm._v(" "), (_vm.userHasPermission('can_see_other_calendars') && _vm.activeSchool) ? _c('ul', {
	    on: {
	      "click": _vm.openSideNav
	    }
	  }, [(_vm.isKindergarten) ? _c('li', {
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.goToDutySchedule.apply(null, arguments)
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.goToDutySchedule.apply(null, arguments)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        return _vm.goToDutySchedule.apply(null, arguments)
	      }]
	    }
	  }, [_c('div', {
	    staticClass: "icons icon-users5 gtm",
	    attrs: {
	      "data-gtm": "SideNav__club",
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n          Vagtplan\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isKindergarten) ? _c('li', {
	    staticClass: "js-intro js-intro-sidebar-nav__kindergarten gtm",
	    class: {
	      active: _vm.isActive(7)
	    },
	    attrs: {
	      "data-gtm": "SideNav__club",
	      "role": "button",
	      "tabindex": "0",
	      "aria-current": _vm.isActive(7) ? 'true' : null
	    },
	    on: {
	      "click": function($event) {
	        return _vm.chooseCals(7)
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.activateNav(7)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        return _vm.activateNav(7)
	      }]
	    }
	  }, [_c('div', {
	    staticClass: "icons icon-users5 gtm",
	    attrs: {
	      "data-gtm": "SideNav__club",
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n          Stuer\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isKindergarten) ? _c('li', {
	    staticClass: "js-intro js-intro-sidebar-nav__klass gtm test-2",
	    class: {
	      active: _vm.isActive(1)
	    },
	    attrs: {
	      "data-gtm": "SideNav__klass",
	      "role": "button",
	      "tabindex": "0",
	      "aria-current": _vm.isActive(1) ? 'true' : null
	    },
	    on: {
	      "click": function($event) {
	        return _vm.chooseCals(1)
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.activateNav(1)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        return _vm.activateNav(1)
	      }]
	    }
	  }, [_c('div', {
	    staticClass: "icons icon-calendar4 gtm",
	    attrs: {
	      "data-gtm": "SideNav__klass",
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.classes_sidenav')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "js-intro js-intro-sidebar-nav__users gtm",
	    class: {
	      active: _vm.isActive(2)
	    },
	    attrs: {
	      "data-gtm": "SideNav__users",
	      "role": "button",
	      "tabindex": "0",
	      "aria-current": _vm.isActive(2) ? 'true' : null
	    },
	    on: {
	      "click": function($event) {
	        return _vm.chooseCals(2)
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.activateNav(2)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        return _vm.activateNav(2)
	      }]
	    }
	  }, [_c('div', {
	    staticClass: "icons icon-users gtm",
	    attrs: {
	      "data-gtm": "SideNav__users",
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.users')) + "\n        ")]), _vm._v(" "), _c('li', {
	    staticClass: "js-intro js-intro-sidebar-nav__location gtm",
	    class: {
	      active: _vm.isActive(3)
	    },
	    attrs: {
	      "data-gtm": "SideNav__location",
	      "role": "button",
	      "tabindex": "0",
	      "aria-current": _vm.isActive(3) ? 'true' : null
	    },
	    on: {
	      "click": function($event) {
	        return _vm.chooseCals(3)
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.activateNav(3)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        return _vm.activateNav(3)
	      }]
	    }
	  }, [_c('div', {
	    staticClass: "icons icon-location gtm",
	    attrs: {
	      "data-gtm": "SideNav__location",
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.rooms')) + "\n        ")]), _vm._v(" "), (!_vm.isKindergarten) ? _c('li', {
	    staticClass: "js-intro js-intro-sidebar-nav__merge gtm",
	    class: {
	      active: _vm.isActive(4)
	    },
	    attrs: {
	      "data-gtm": "SideNav__merge",
	      "role": "button",
	      "tabindex": "0",
	      "aria-current": _vm.isActive(4) ? 'true' : null
	    },
	    on: {
	      "click": function($event) {
	        return _vm.chooseCals(4)
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.activateNav(4)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        return _vm.activateNav(4)
	      }]
	    }
	  }, [_c('div', {
	    staticClass: "icons icon-calendar-week gtm",
	    attrs: {
	      "data-gtm": "SideNav__merge",
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.merge_calendars_sidenav')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "js-intro js-intro-sidebar-nav__other gtm",
	    class: {
	      active: _vm.isActive(5)
	    },
	    attrs: {
	      "data-gtm": "SideNav__other",
	      "role": "button",
	      "tabindex": "0",
	      "aria-current": _vm.isActive(5) ? 'true' : null
	    },
	    on: {
	      "click": function($event) {
	        return _vm.chooseCals(5)
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.activateNav(5)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        return _vm.activateNav(5)
	      }]
	    }
	  }, [_c('div', {
	    staticClass: "icons icon-clipboard2 gtm",
	    attrs: {
	      "data-gtm": "SideNav__other",
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.other_calendars')) + "\n        ")]), _vm._v(" "), (_vm.isSchoolSFOActive && !_vm.isKindergarten) ? _c('li', {
	    staticClass: "js-intro js-intro-sidebar-nav__club gtm",
	    class: {
	      active: _vm.isActive(6)
	    },
	    attrs: {
	      "data-gtm": "SideNav__club",
	      "role": "button",
	      "tabindex": "0",
	      "aria-current": _vm.isActive(6) ? 'true' : null
	    },
	    on: {
	      "click": function($event) {
	        return _vm.chooseCals(6)
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.activateNav(6)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        return _vm.activateNav(6)
	      }]
	    }
	  }, [_c('div', {
	    staticClass: "icons icon-users5 gtm",
	    attrs: {
	      "data-gtm": "SideNav__club",
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.club.club')) + "\n        ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "sidebar-nav__snow"
	  }, _vm._l((_vm.snowflakes), function(flake, index) {
	    return _c('span', {
	      key: 'snowflake-' + index,
	      staticClass: "sidebar-nav__snowflake",
	      style: ({
	        left: flake.left + '%',
	        animationDuration: flake.duration + 's',
	        animationDelay: flake.delay + 's',
	        width: flake.size + 'px',
	        height: flake.size + 'px',
	        opacity: flake.opacity
	      })
	    })
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "sidebar-nav__container",
	    class: [{
	      sidebar_nav_container_show: _vm.open
	    }]
	  }, [_c('div', {
	    staticClass: "sidebar-nav__container__header box-shadow flex"
	  }, [_c('div', {
	    staticClass: "flex flex-vertical-center",
	    staticStyle: {
	      "width": "85%"
	    }
	  }, [_c('h2', [(_vm.activeSchool) ? _c('a', {
	    staticClass: "link-white",
	    attrs: {
	      "href": '/schools/' + _vm.activeSchool.id
	    }
	  }, [_vm._v(_vm._s(_vm.activeSchool.name))]) : _vm._e()])]), _vm._v(" "), _c('span', {
	    ref: "changeSchoolToggle",
	    staticClass: "icon-arrow-down5 arrow-dropdown",
	    class: {
	      active: _vm.changeSchoolDropdown
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0",
	      "aria-label": _vm.$t('vue2.a11y.changeSchool'),
	      "aria-expanded": _vm.changeSchoolDropdown ? 'true' : 'false'
	    },
	    on: {
	      "click": _vm.toggleChangeSchoolDropdown,
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.toggleChangeSchoolDropdown.apply(null, arguments)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        return _vm.toggleChangeSchoolDropdown.apply(null, arguments)
	      }]
	    }
	  }), _vm._v(" "), (_vm.changeSchoolDropdown) ? _c('div', {
	    staticClass: "sidebar-nav__container--dropdown bg-light-blue box-shadow pos-absolute z-index-1000 text-white width-100 box-sizing"
	  }, [_c('list-with-search', {
	    attrs: {
	      "selected": _vm.activeSchool,
	      "options": _vm.allSchools
	    },
	    on: {
	      "choose": _vm.toggleChangeSchoolDropdown,
	      "close": _vm.closeChangeSchoolDropdown
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), (!_vm.isLoading && _vm.yearCals.length < 1) ? [_c('div', {
	    staticClass: "no-cals"
	  }, [_c('div', {
	    staticClass: "no-cals__icon"
	  }, [_c('span', {
	    class: _vm.activeType.icon
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "no-cals__text",
	    domProps: {
	      "innerHTML": _vm._s(_vm.notCreatedAnyTextString)
	    }
	  })])] : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "create-link__container"
	  }, [(_vm.isActive(1) && _vm.userHasPermission('can_manage_calendars')) ? _c('a', {
	    staticClass: "create-cal__button",
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.createKlasses.apply(null, arguments)
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.createKlasses.apply(null, arguments)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        return _vm.createKlasses.apply(null, arguments)
	      }]
	    }
	  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
	    staticClass: "lowercase"
	  }, [_vm._v(_vm._s(_vm.activeType.title))]), _vm._v(" "), (_vm.activeOnboardingStep === 1 && _vm.showOnboardingArrow) ? _c('onboardArrow') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isActive(2) && _vm.userHasPermission('can_manage_users')) ? _c('a', {
	    staticClass: "create-cal__button",
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.createUsers.apply(null, arguments)
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.createUsers.apply(null, arguments)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        return _vm.createUsers.apply(null, arguments)
	      }]
	    }
	  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
	    staticClass: "lowercase"
	  }, [_vm._v(_vm._s(_vm.activeType.title))]), _vm._v(" "), (_vm.activeOnboardingStep === 2 && _vm.showOnboardingArrow) ? _c('onboardArrow') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isActive(3) && _vm.userHasPermission('can_manage_calendars')) ? _c('a', {
	    staticClass: "create-cal__button",
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.createCalendars(_vm.activeType.type)
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.createCalendars(_vm.activeType.type)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        return _vm.createCalendars(_vm.activeType.type)
	      }]
	    }
	  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
	    staticClass: "lowercase"
	  }, [_vm._v(_vm._s(_vm.activeType.title))]), _vm._v(" "), (_vm.activeOnboardingStep === 3 && _vm.showOnboardingArrow) ? _c('onboardArrow') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isActive(4) && _vm.userHasPermission('can_manage_calendars')) ? _c('a', {
	    staticClass: "create-cal__button",
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.createCalendars(_vm.activeType.type)
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.createCalendars(_vm.activeType.type)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        return _vm.createCalendars(_vm.activeType.type)
	      }]
	    }
	  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
	    staticClass: "lowercase"
	  }, [_vm._v(_vm._s(_vm.activeType.title))]), _vm._v(" "), (_vm.activeOnboardingStep === 4 && _vm.showOnboardingArrow) ? _c('onboardArrow') : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm.isActive(5) || _vm.isActive(6) || _vm.isActive(7)) && _vm.userHasPermission('can_manage_calendars')) ? _c('a', {
	    staticClass: "create-cal__button",
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.createCalendars(_vm.activeType.type)
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.createCalendars(_vm.activeType.type)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        return _vm.createCalendars(_vm.activeType.type)
	      }]
	    }
	  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
	    staticClass: "lowercase"
	  }, [_vm._v(_vm._s(_vm.activeType.title))])]) : _vm._e()]), _vm._v(" "), (_vm.activeType.hasSchoolYear) ? _c('ChangeSchoolYear', {
	    staticStyle: {
	      "margin": "10px 15px 0"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.yearCals.length > 0) ? _c('div', {
	    staticClass: "sidebar-nav__search"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search),
	      expression: "search"
	    }],
	    ref: "searchfield",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('vue2.common.search_for') + ' ' + _vm.searchName,
	      "id": "searchfield"
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
	        $event.preventDefault();
	        return _vm.focusCalLink(0)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.chooseFirstCalLink.apply(null, arguments)
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.search !== ''),
	      expression: "search !== ''"
	    }],
	    staticClass: "sidebar-nav__search__cross pointer icon-cross2",
	    attrs: {
	      "role": "button",
	      "tabindex": "0",
	      "aria-label": _vm.$t('vue2.a11y.clearSearch')
	    },
	    on: {
	      "click": _vm.clearSearch,
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.clearSearch.apply(null, arguments)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        return _vm.clearSearch.apply(null, arguments)
	      }]
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.userHasPermission('can_see_other_calendars')) ? _c('div', {
	    staticClass: "sidebar-nav__container__body"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticStyle: {
	      "margin-top": "100px"
	    }
	  }, [_c('Loader', {
	    attrs: {
	      "bg-color": "#3e4450"
	    }
	  })], 1) : [_c('ul', {
	    ref: "calList",
	    staticClass: "nav__cal-list",
	    on: {
	      "keydown": _vm.onCalListKeydown
	    }
	  }, _vm._l((_vm.searchCals), function(cal) {
	    return _c('li', {
	      key: cal.id
	    }, [(cal.type !== 'klass') ? [(_vm.userHasPermission('can_do_most_stuff')) ? _c('a', {
	      attrs: {
	        "href": cal.url
	      }
	    }, [_vm._v(_vm._s(cal.name ? cal.name : cal.url))]) : _c('a', {
	      attrs: {
	        "role": "button",
	        "tabindex": "0"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.setActiveCalendarId(cal.id)
	        },
	        "keydown": [function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	          $event.preventDefault();
	          return _vm.setActiveCalendarId(cal.id)
	        }, function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	          $event.preventDefault();
	          return _vm.setActiveCalendarId(cal.id)
	        }]
	      }
	    }, [_vm._v(_vm._s(cal.name ? cal.name : cal.url))])] : _vm._e(), _vm._v(" "), (cal.type === 'klass') ? _c('div', {
	      staticClass: "nav__cal-list__item",
	      class: {
	        'nav__cal-list__item--open': _vm.isStudentsActiveForCal(cal.id)
	      }
	    }, [(_vm.userHasPermission('can_do_most_stuff')) ? _c('a', {
	      attrs: {
	        "href": cal.url
	      }
	    }, [_vm._v(_vm._s(cal.name ? cal.name : cal.url))]) : _c('a', {
	      attrs: {
	        "role": "button",
	        "tabindex": "0"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.setActiveCalendarId(cal.id)
	        },
	        "keydown": [function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	          $event.preventDefault();
	          return _vm.setActiveCalendarId(cal.id)
	        }, function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	          $event.preventDefault();
	          return _vm.setActiveCalendarId(cal.id)
	        }]
	      }
	    }, [_vm._v(_vm._s(cal.name ? cal.name : cal.url))]), _vm._v(" "), (cal.students && cal.students.length > 0) ? _c('div', {
	      attrs: {
	        "role": "button",
	        "tabindex": "0",
	        "aria-label": _vm.$t('vue2.a11y.showStudents'),
	        "aria-expanded": _vm.isStudentsActiveForCal(cal.id) ? 'true' : 'false'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheStudentsActiveForCal(cal.id)
	        },
	        "keydown": [function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	          return _vm.setTheStudentsActiveForCal(cal.id)
	        }, function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	          $event.preventDefault();
	          return _vm.setTheStudentsActiveForCal(cal.id)
	        }]
	      }
	    }, [_c('span', {
	      staticClass: "icon-arrow-down52",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isStudentsActiveForCal(cal.id)) ? _c('ul', {
	      staticClass: "nav__cal-list__item__students"
	    }, _vm._l((_vm.getCalStudents(cal.students)), function(student) {
	      return _c('li', [(_vm.userHasPermission('can_do_most_stuff')) ? _c('a', {
	        attrs: {
	          "href": student.url
	        }
	      }, [_vm._v(_vm._s(student.name ? student.name : student.url))]) : _c('a', {
	        attrs: {
	          "role": "button",
	          "tabindex": "0"
	        },
	        on: {
	          "click": function($event) {
	            $event.preventDefault();
	            return _vm.setActiveCalendarId(student.id)
	          },
	          "keydown": [function($event) {
	            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	            $event.preventDefault();
	            return _vm.setActiveCalendarId(student.id)
	          }, function($event) {
	            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	            $event.preventDefault();
	            return _vm.setActiveCalendarId(student.id)
	          }]
	        }
	      }, [_vm._v(_vm._s(student.name ? student.name : student.url))])])
	    }), 0) : _vm._e()], 2)
	  }), 0)]], 2) : _vm._e()], 2), _vm._v(" "), (_vm.userHasPermission('can_see_other_calendars') && _vm.activeSchool) ? _c('TeamCalendar') : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1958 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "create-subject"
	  }, [(!_vm.isHideCreateButton) ? _c('button', {
	    staticClass: "width-100",
	    class: [{
	      'do-bttn': _vm.isInDCalendar
	    }, {
	      'bttn': !_vm.isInDCalendar
	    }],
	    on: {
	      "click": function($event) {
	        _vm.isSubjectModal = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-clipboard2"
	  }), _vm._v("\n    " + _vm._s(_vm.$t('vue2.create_subject.create_subject')) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.isSubjectModal) ? _c('CreateSubjectForm', {
	    attrs: {
	      "showModal": _vm.isSubjectModal,
	      "initCalendarId": _vm.calendarId,
	      "editSubject": _vm.editSubject,
	      "editSubjectId": _vm.editSubjectId,
	      "isInDCalendar": _vm.isInDCalendar
	    },
	    on: {
	      "close": _vm.closeModal,
	      "setTheEditSubject": _vm.setTheEditSubject,
	      "createSubject": _vm.createNewSubject,
	      "updateSubject": _vm.updateSubject,
	      "deleteSubject": _vm.deleteSubject
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1959 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-subs"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fadeOut"
	    }
	  }, [(_vm.isInitialLoading) ? _c('DoSplash', {
	    key: "initial-splash"
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-subs__header"
	  }, [_c('div', {
	    staticClass: "do-subs__header__div"
	  }, [_c('h1', [_vm._v("Vikardækning")]), _vm._v(" "), _c('DoChangeDayNav', {
	    attrs: {
	      "date": _vm.date
	    },
	    on: {
	      "today": function($event) {
	        return _vm.setDate('today')
	      },
	      "prev": function($event) {
	        return _vm.setDate('prev')
	      },
	      "next": function($event) {
	        return _vm.setDate('next')
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dateFormatted))]), _vm._v(" "), (_vm.isLoadingEvents) ? _c('div', {
	    staticClass: "do-spinner"
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-subs__header__div"
	  }, [_c('label', [_vm._v("Antal fraværende: " + _vm._s(_vm.absentUsers.length))])])]), _vm._v(" "), _c('div', {
	    staticClass: "do-subs__body"
	  }, [_c('Scheduler', {
	    attrs: {
	      "events": _vm.events,
	      "klassCalendars": _vm.klassCalendars,
	      "userCalendars": _vm.userCalendars,
	      "allCalendarsInHash": _vm.allCalendarsInHash
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1960 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeDropdown),
	      expression: "closeDropdown"
	    }],
	    staticClass: "copy-calendars text-dark"
	  }, [_c('button', {
	    ref: "copy_calendars_button",
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.openDropdown.apply(null, arguments)
	      }
	    }
	  }, [_vm._t("copy-button-title", function() {
	    return [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.copy')))]
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-arrow-down5 marg-5-left"
	  })], 2), _vm._v(" "), (_vm.isDropdown) ? _c('div', {
	    ref: "copy_calendars_panel",
	    staticClass: "copy-calendars__ref"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fadeInDown"
	    }
	  }, [(_vm.isDropdownPopperDone) ? _c('div', {
	    staticClass: "copy-calendars__panel"
	  }, [_c('h3', {
	    style: ({
	      'backgroundColor': '#468ad7'
	    })
	  }, [(!_vm.copyDate) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.calendars.select_week_to_copy_from')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.calendars.select_weeks_that_week')) + " " + _vm._s(_vm.showWeek(_vm.copyDate)) + " " + _vm._s(_vm.$t('vue2.calendars.must_be_copied_to')))])]), _vm._v(" "), _c('div', {
	    staticClass: "copy-calendars__panel__container"
	  }, [_c('div', {
	    staticClass: "weeks-container"
	  }, [_c('ul', {
	    staticClass: "weeks"
	  }, [(_vm.weeks.length < 1) ? [_c('Spinner', {
	    staticStyle: {
	      "margin-bottom": "100px"
	    },
	    attrs: {
	      "color": "blue"
	    }
	  })] : _vm._l((_vm.weeks), function(week) {
	    return _c('li', {
	      key: week.serverDate,
	      staticClass: "weeks__week hint--top",
	      class: [{
	        'weeks__week--is-selected': _vm.isWeekSelected(week)
	      }, {
	        'weeks__week--is-copy-week': _vm.isCopyWeek(week)
	      }],
	      attrs: {
	        "aria-label": _vm.tooltipDate(week.date)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setSelectedWeek(week)
	        }
	      }
	    }, [_vm._v("\n                  " + _vm._s(_vm.showWeek(week.date)) + "\n                  "), (_vm.isNow(week)) ? _c('span', {
	      staticClass: "weeks__week__now-indicator"
	    }) : _vm._e()])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "copy-calendars__panel__sidebar"
	  }, [_c('transition', {
	    attrs: {
	      "name": "slide-fade",
	      "mode": "out-in"
	    }
	  }, [(!_vm.copyDate) ? _c('div', {
	    key: "1",
	    staticClass: "text-explainer"
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('vue2.calendars.select_week_to_copy_from')) + "\n              ")]) : _c('div', {
	    key: "2"
	  }, [_c('h4', [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.copycalendar.markWeeksFrom')) + " " + _vm._s(_vm.showWeek(_vm.copyDate)))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn width-100 btn-trans",
	    on: {
	      "click": _vm.addAllWeeksOnward
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.copycalendar.allWeeks')) + "\n                ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn width-100 btn-trans",
	    on: {
	      "click": _vm.selectOddWeeks
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.copycalendar.oddWeeks')) + "\n                ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn width-100 btn-trans",
	    on: {
	      "click": _vm.selectEvenWeeks
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.copycalendar.evenWeeks')) + "\n                ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn btn-trans width-100 btn-remove",
	    on: {
	      "click": _vm.removeAllSelectedWeeks
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.copycalendar.unselectAll')) + "\n                ")])])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "copy-calendars__panel__footer"
	  }, [_c('div', {
	    staticClass: "delete-option"
	  }, [_c('label', {
	    attrs: {
	      "for": "checkbox"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.deleteLessonsInSelectedWeeks')))]), _vm._v(" "), (_vm.calType === 'user') ? _c('span', [_vm._v(" (" + _vm._s(_vm.$t('vue2.copycalendar.absenceWillNotBeDeleted')) + ")")]) : _vm._e()]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.isDeleteEvents),
	      expression: "isDeleteEvents"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "id": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.isDeleteEvents) ? _vm._i(_vm.isDeleteEvents, null) > -1 : (_vm.isDeleteEvents)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.isDeleteEvents,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.isDeleteEvents = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.isDeleteEvents = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.isDeleteEvents = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), (_vm.selectedWeeks.length < 1) ? _c('button', {
	    staticClass: "bttn bttn--disabled"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.paste')) + "\n          ")]) : _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.paste')))])])]) : _vm._e()])], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1961 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.userId) ? _c('modal', {
	    attrs: {
	      "closeCrossColor": "#ccc"
	    },
	    on: {
	      "close": _vm.close
	    }
	  }, [_c('div', {
	    staticClass: "events__modal text-dark",
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "events__modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('h3', [(_vm.eventsFilter === 'absence') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.user_event_list.absence')))]) : _vm._e(), _vm._v(" "), (_vm.eventsFilter === 'subject') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.user_event_list.teaching')))]) : _vm._e(), (_vm.eventsFilter === 'substituteHours') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.user_event_list.substitute_hours')))]) : _vm._e(), _vm._v("  " + _vm._s(_vm.$t('vue2.user_event_list.from')) + " " + _vm._s(_vm.$filters.LL(_vm.start)) + " " + _vm._s(_vm.$t('vue2.user_event_list.to')) + " " + _vm._s(_vm.$filters.LL(_vm.end)))])]), _vm._v(" "), _c('div', {
	    staticClass: "events__modal__body"
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }) : [(_vm.filteredEvents.length < 1) ? _c('h4', {
	    staticClass: "text--explainer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.user_event_list.no_matching_events')))]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "events__list"
	  }, [_vm._l((_vm.sortedEvents), function(event) {
	    return _c('li', {
	      key: event.event_id
	    }, [_c('p', [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.$filters.ddd(event.start_time))) + " " + _vm._s(_vm.$filters.LL(event.start_time)) + " kl. " + _vm._s(_vm.$filters.LT(event.start_time)) + " -\n              " + _vm._s(_vm.$filters.LT(event.end_time)) + ", " + _vm._s(event.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDuration(event)))])])
	  }), _vm._v(" "), _c('li', [_c('b', [_vm._v(_vm._s(_vm.$t('vue2.user_event_list.total')))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.totalDuration))])])], 2)]], 2), _vm._v(" "), _c('div', {
	    staticClass: "events__modal__footer"
	  }, [_c('button', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.user_event_list.close')))])])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1962 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "isCloseOnBgClick": false,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('div', [_c('h2', [_vm._v("Aktive faste tillæg i OPUS")]), _vm._v(" "), _c('p', {
	    staticClass: "d-modal__subtitle"
	  }, [_vm._v("\n          " + _vm._s(_vm.userName) + " · " + _vm._s(_vm.employmentLabel) + "\n        ")])]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__toolbar d-modal__toolbar--end"
	  }, [(!_vm.isShowCreate) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.openCreate
	    }
	  }, [_vm._v("\n        Opret fast tillæg\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [(_vm.isShowCreate) ? _c('div', {
	    staticClass: "create-form"
	  }, [_c('h3', {
	    staticClass: "create-form__title"
	  }, [_vm._v("Nyt fast tillæg")]), _vm._v(" "), _c('div', {
	    staticClass: "create-form__grid"
	  }, [_c('div', {
	    staticClass: "d-input-group create-form__loenkode"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Lønkode *")]), _vm._v(" "), _c('DSelect', {
	    ref: "loenkodeSelect",
	    attrs: {
	      "items": _vm.salaryCodesForDSelect,
	      "multiple": false,
	      "placeholder": 'Vælg lønkode',
	      "itemsSelected": _vm.selectedSalaryCodeForDSelect,
	      "isShowRemoveButton": false
	    },
	    on: {
	      "add": _vm.onSelectLoenkode,
	      "remove": function($event) {
	        return _vm.onSelectLoenkode(null)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group create-form__antal"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("\n              Antal *\n              "), _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        boundary: 'window',
	        placement: 'top',
	        zIndex: 12312312312314
	      }),
	      expression: "{\n                      arrow: true,\n                      animateFill: false,\n                      animation: 'shift-away',\n                      boundary: 'window',\n                      placement: 'top',\n                      zIndex: 12312312312314\n                    }"
	    }],
	    staticClass: "icon-question3 d-label__help",
	    attrs: {
	      "content": "Antal enheder pr. måned, der ganges med satsen for den valgte lønkode. Satsen er defineret i KMD OPUS.<br><br>Eksempel: Hvis satsen for den valgte lønkode er 500 kr., og du angiver 2 enheder, udbetales 1.000 kr. pr. måned."
	    }
	  })]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.createForm.antal),
	      expression: "createForm.antal"
	    }],
	    staticClass: "d-input width-100",
	    attrs: {
	      "type": "text",
	      "inputmode": "decimal",
	      "placeholder": "Indtast antal"
	    },
	    domProps: {
	      "value": (_vm.createForm.antal)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.createForm, "antal", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group create-form__beloeb"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Beløb")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.createForm.beloeb),
	      expression: "createForm.beloeb"
	    }],
	    staticClass: "d-input width-100",
	    attrs: {
	      "type": "text",
	      "inputmode": "decimal",
	      "placeholder": "(valgfri)"
	    },
	    domProps: {
	      "value": (_vm.createForm.beloeb)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.createForm, "beloeb", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "create-form__hint text-explainer"
	  }, [_vm._v("\n            Udfyld Antal, Beløb eller begge afhængigt af lønkoden.\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group create-form__start"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Startdato *")]), _vm._v(" "), _c('DateSelector', {
	    staticClass: "width-100",
	    attrs: {
	      "date": _vm.createForm.startdato,
	      "width100": true
	    },
	    on: {
	      "changed": function($event) {
	        _vm.createForm.startdato = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group create-form__slut"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Slutdato *")]), _vm._v(" "), (!_vm.createForm.noEndDate) ? _c('DateSelector', {
	    staticClass: "width-100",
	    attrs: {
	      "date": _vm.createForm.stopdato,
	      "width100": true
	    },
	    on: {
	      "changed": function($event) {
	        _vm.createForm.stopdato = $event
	      }
	    }
	  }) : _c('input', {
	    staticClass: "d-input width-100",
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm.openEndedDateLabel
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "create-form__no-end-date"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.createForm.noEndDate),
	      expression: "createForm.noEndDate"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.createForm.noEndDate) ? _vm._i(_vm.createForm.noEndDate, null) > -1 : (_vm.createForm.noEndDate)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.createForm.noEndDate,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.createForm, "noEndDate", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.createForm, "noEndDate", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.createForm, "noEndDate", $$c)
	        }
	      }, _vm.onToggleNoEndDate]
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Uden slutdato")])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group create-form__cost-center"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Afvigende omkostningssted")]), _vm._v(" "), _c('DSelect', {
	    attrs: {
	      "items": _vm.costCentersForDSelect,
	      "multiple": false,
	      "placeholder": 'Vælg afvigende omkostningssted (valgfri)',
	      "itemsSelected": _vm.selectedCostCenterForDSelect,
	      "isShowRemoveButton": true
	    },
	    on: {
	      "add": _vm.onSelectCostCenter,
	      "remove": function($event) {
	        return _vm.onSelectCostCenter(null)
	      }
	    }
	  })], 1)]), _vm._v(" "), (_vm.createOverlapWarning) ? _c('p', {
	    staticClass: "text-explainer create-form__warning"
	  }, [_vm._v("\n          " + _vm._s(_vm.createOverlapWarning) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.createValidationMessage) ? _c('p', {
	    staticClass: "text-explainer text-explainer--danger"
	  }, [_vm._v("\n          " + _vm._s(_vm.createValidationMessage) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "create-form__actions"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.closeCreate
	    }
	  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isCreating,
	      'do-bttn--submit--disabled': !_vm.isCreateValid
	    },
	    attrs: {
	      "disabled": !_vm.isCreateValid || _vm.isCreating
	    },
	    on: {
	      "click": _vm.submitCreate
	    }
	  }, [_vm._v("\n            Send til OPUS\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "isLoaderModal": true
	    }
	  }) : [_c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "td-loenkode"
	  }, [_vm._v("LØNKODE")]), _vm._v(" "), _c('th', {
	    staticClass: "td-units"
	  }, [_vm._v("ENHEDER")]), _vm._v(" "), _c('th', {
	    staticClass: "td-units"
	  }, [_vm._v("BELØB")]), _vm._v(" "), _c('th', {
	    staticClass: "td-date"
	  }, [_vm._v("FRA")]), _vm._v(" "), _c('th', {
	    staticClass: "td-date"
	  }, [_vm._v("TIL")]), _vm._v(" "), _c('th', [_vm._v("OMK.STED")]), _vm._v(" "), _c('th', {
	    staticClass: "th-actions"
	  })])]), _vm._v(" "), _c('tbody', [(_vm.displayedPayments.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": 7
	    }
	  }, [_vm._v("\n              Ingen faste tillæg i OPUS\n            ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayedPayments), function(row) {
	    return _c('tr', {
	      key: row.id != null ? row.id : row.objekt_id,
	      staticClass: "fast-tillaeg-row"
	    }, [_c('td', {
	      staticClass: "td-loenkode"
	    }, [_vm._v(_vm._s(row.vLoenart))]), _vm._v(" "), _c('td', {
	      staticClass: "td-units"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(row.antal)))]), _vm._v(" "), _c('td', {
	      staticClass: "td-units"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(row.beloeb)))]), _vm._v(" "), _c('td', {
	      staticClass: "td-date"
	    }, [_vm._v(_vm._s(row.vFraDato))]), _vm._v(" "), _c('td', {
	      staticClass: "td-date"
	    }, [_vm._v(_vm._s(row.vTilDato))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.afv_omkostningssted || '—'))]), _vm._v(" "), _c('td', {
	      staticClass: "td-actions"
	    }, [_c('DDropdown', {
	      attrs: {
	        "isBottomStart": false,
	        "isShowDots": false
	      }
	    }, [_c('button', {
	      staticClass: "do-bttn do-bttn--small",
	      attrs: {
	        "slot": "title"
	      },
	      slot: "title"
	    }, [_vm._v("\n                  Handlinger "), _c('span', {
	      staticClass: "icon-arrow-down5"
	    })]), _vm._v(" "), _c('ul', {
	      staticClass: "action-menu",
	      attrs: {
	        "slot": "list"
	      },
	      slot: "list"
	    }, [_c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.openStop(row)
	        }
	      }
	    }, [_vm._v("Sæt stopdato")]), _vm._v(" "), _c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.openExtend(row)
	        }
	      }
	    }, [_vm._v("Forlæng")]), _vm._v(" "), _c('li', {
	      staticClass: "d-item-warning",
	      on: {
	        "click": function($event) {
	          return _vm.openDelete(row)
	        }
	      }
	    }, [_vm._v("Slet")])])])], 1)])
	  })], 2)])]], 2)])]), _vm._v(" "), (_vm.rowToStop) ? _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312313"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "isCloseOnBgClick": false,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": _vm.closeAction
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal--small",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Stop fast tillæg")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.closeAction
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('p', [_vm._v("Tillægget stopper på den valgte dato. Dette kan ikke fortrydes.")]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Stopdato *")]), _vm._v(" "), _c('DateSelector', {
	    staticClass: "width-100",
	    attrs: {
	      "date": _vm.stopDate,
	      "maxDate": _vm.stopMaxDate,
	      "width100": true
	    },
	    on: {
	      "changed": function($event) {
	        _vm.stopDate = $event
	      }
	    }
	  })], 1), _vm._v(" "), (_vm.actionError) ? _c('p', {
	    staticClass: "text-explainer text-explainer--danger"
	  }, [_vm._v(_vm._s(_vm.actionError))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', {
	    staticClass: "d-modal__buttons__child"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.closeAction
	    }
	  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmittingAction
	    },
	    attrs: {
	      "disabled": _vm.isSubmittingAction || !_vm.stopDate
	    },
	    on: {
	      "click": _vm.submitStop
	    }
	  }, [_vm._v("\n            Stop tillæg\n          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.rowToExtend) ? _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312313"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "isCloseOnBgClick": false,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": _vm.closeAction
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal--small",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Forlæng fast tillæg")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.closeAction
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('p', [_vm._v("Der oprettes et nyt tillæg med samme lønart, beløb og bemærkning fra den nuværende stopdato til den nye\n          dato.")]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Ny slutdato *")]), _vm._v(" "), _c('DateSelector', {
	    staticClass: "width-100",
	    attrs: {
	      "date": _vm.extendDate,
	      "minDate": _vm.extendMinDate,
	      "width100": true
	    },
	    on: {
	      "changed": function($event) {
	        _vm.extendDate = $event
	      }
	    }
	  })], 1), _vm._v(" "), (_vm.actionError) ? _c('p', {
	    staticClass: "text-explainer text-explainer--danger"
	  }, [_vm._v(_vm._s(_vm.actionError))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', {
	    staticClass: "d-modal__buttons__child"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.closeAction
	    }
	  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmittingAction
	    },
	    attrs: {
	      "disabled": _vm.isSubmittingAction || !_vm.extendDate
	    },
	    on: {
	      "click": _vm.submitExtend
	    }
	  }, [_vm._v("\n            Forlæng tillæg\n          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.rowToDelete) ? _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312313"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "isCloseOnBgClick": false,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": _vm.closeAction
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal--small",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Slet fast tillæg")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.closeAction
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('p', [_vm._v("Er du sikker på, at du vil slette dette tillæg helt? Det fjernes fra lønsystemet og kan ikke\n          gendannes.")]), _vm._v(" "), (_vm.actionError) ? _c('p', {
	    staticClass: "text-explainer text-explainer--danger"
	  }, [_vm._v(_vm._s(_vm.actionError))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', {
	    staticClass: "d-modal__buttons__child"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.closeAction
	    }
	  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--danger",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmittingAction
	    },
	    attrs: {
	      "disabled": _vm.isSubmittingAction
	    },
	    on: {
	      "click": _vm.submitDelete
	    }
	  }, [_vm._v("\n            Slet tillæg\n          ")])])])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1963 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "academy"
	  }, [_vm._m(0), _vm._v(" "), _c('header', {
	    staticClass: "academy__header"
	  }, [_c('div', {
	    staticClass: "academy__header-left"
	  }, [_c('a', {
	    staticClass: "academy__logo-link",
	    attrs: {
	      "href": "/calendar"
	    }
	  }, [_c('span', {
	    staticClass: "academy__logo-back"
	  }, [_vm._v("← Tilbage til")]), _vm._v(" "), _c('svg', {
	    staticClass: "academy__logo",
	    attrs: {
	      "enable-background": "new 16.5 363.8 484.1 110.9",
	      "viewBox": "16.5 363.8 484.1 110.9",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "fill": "#ffffff",
	      "d": "m118 473.3c-10.9 0-18.9-2.9-24.1-8.7-5.1-5.8-7.7-14.5-7.7-26.2 0-13.4 3.1-23.8 9.3-31.3 6.2-7.4 15.2-11.2 26.9-11.2 10.9 0 18.9 2.9 24.1 8.7 5.1 5.8 7.7 14.5 7.7 26.2 0 13.4-3.1 23.8-9.3 31.2-6.2 7.6-15.2 11.3-26.9 11.3zm2.9-10.1c5.7 0 9.9-2.2 12.4-6.5 2.6-4.3 3.8-11 3.8-20 0-10.4-1.3-18-4-23.1-2.6-5-7.2-7.5-13.6-7.5-5.7 0-9.9 2.2-12.4 6.5-2.6 4.3-3.8 11-3.8 20.1 0 10.3 1.3 18 4 23 2.6 5 7.1 7.5 13.6 7.5zm71.7 10.7c-12.4 0-21.2-2.6-26.4-7.8s-7.8-14.1-7.8-26.7c0-13.9 3.3-24.5 9.9-31.9 6.6-7.3 16.6-11 30.1-11 6.6 0 11.4.6 14.3 1.8 3 1.2 4.5 3.1 4.5 5.5 0 3-1.1 5.9-3.2 8.6-7.5-3.9-14-5.9-19.3-5.9-7 0-11.9 2.2-14.9 6.7-2.9 4.4-4.4 11.4-4.4 20.9 0 9.8 1.4 17.1 4.3 22.1s8.1 7.4 15.7 7.4c5.8 0 12.5-1.9 20.1-5.8 1.7 2.3 2.5 4.7 2.5 7.1 0 2.9-2.6 5.1-7.8 6.6-5.2 1.6-11.1 2.4-17.6 2.4zm61.2-77.7c9.3 0 16.3 2.2 20.8 6.6s6.8 11.7 6.8 21.9c0 4.5-.8 7.6-2.4 9.3-1.6 1.8-5.1 2.6-10.6 2.6h-33.3c.1 8.2 1.7 14.6 4.9 19.3s8.8 7 16.9 7c7.5 0 14.6-2 21-5.9 2.2 2.2 3.2 4.4 3.2 6.9 0 3.4-2.8 5.7-8.3 7.1-5.6 1.4-11.8 2-18.8 2-12.9 0-22.1-2.7-27.7-8.2s-8.4-14.6-8.4-27.6c0-12.7 3.2-22.8 9.5-30.1 6.4-7.2 15.1-10.9 26.4-10.9zm-2.9 10.1c-5 0-8.8 1.8-11.5 5.4-2.6 3.6-4 9.2-4.3 16.9h7.8c8.2 0 13.9-.2 16.9-.5s4.7-.9 5.2-1.6c.5-.8.7-2.2.7-4.2 0-5-1.3-8.9-3.8-11.7-2.5-2.9-6.1-4.3-11-4.3zm56.5.9c5-3.3 9.9-5.8 14.7-7.3 4.9-1.6 9.2-2.3 13-2.3 6.7 0 11.7 1.5 15.1 4.6s5.1 9 5.1 17.7c0 27 .4 41.4 1.2 43s2.6 2.4 5.4 2.3c.6 1.5.8 2.9.8 4.4 0 1.4-.4 2.3-1.3 2.7-.9.5-2.4.7-4.8.7-7 0-11.3-.1-12.8-.3-1.6-.2-2.6-.7-3.2-1.6s-.8-2.3-.8-4.4v-32.5c0-10.4-1.1-17.2-3.3-20.7-2.2-3.4-5.7-5.1-10.6-5.1-4.2 0-7.8 1.2-10.8 3.5s-4.6 6.6-4.6 12.7v15.9c0 8.9.2 17.1.5 24.6h8.4c.6 1.3.9 2.7.9 4.2 0 1.4-.3 2.3-.8 2.8-.6.5-1.6.8-3.2.8h-29.6c-.7-1.6-1-3.1-1-4.5 0-1.1.3-1.9.8-2.5.6-.5 1.5-.8 2.7-.8h5.2c.4-8 .6-17.8.6-29.4 0-14.8-.6-23.4-1.7-25.8-1.2-2.4-3.4-3.5-6.6-3.5-.7-1.4-1-2.9-1-4.4 0-1.4.5-2.2 1.6-2.6s7.7-.8 20-1.2c.4 2.4.4 5.3.1 9zm156.5 66.7c-10.9 0-18.9-2.9-24.1-8.7-5.1-5.8-7.7-14.5-7.7-26.2 0-13.4 3.1-23.8 9.3-31.3 6.2-7.4 15.2-11.2 26.9-11.2 10.9 0 18.9 2.9 24.1 8.7 5.1 5.8 7.7 14.5 7.7 26.2 0 13.4-3.1 23.8-9.3 31.2-6.2 7.5-15.2 11.3-26.9 11.3zm2.9-10.2c5.7 0 9.9-2.2 12.4-6.5 2.6-4.3 3.8-11 3.8-20 0-10.4-1.3-18-4-23.1-2.6-5-7.2-7.5-13.6-7.5-5.7 0-9.9 2.2-12.4 6.5-2.6 4.3-3.8 11-3.8 20.1 0 10.3 1.3 18 4 23 2.6 5 7.1 7.6 13.6 7.5zm-422.3 10.1c1.6 0 3.1-.1 4.6-.3 2.3-.3 4.6-.7 6.9-1.4 3.9-1.1 8.2-3.1 12.7-5.8 8.4-5.9 13.5-14.9 13.5-25.1-.1-4.2-.1-9-.1-14.4v-54c0-2.5-.7-8.6-7.7-8.6-8.8 0-10 6.7-9.1 12.9.7 4.6.9 4.8 1.1 9s.3 8.2.3 11.9c-1.8-.5-3.6-.8-5.6-1.1s-4.4-.5-7.3-.5c-12.2 0-21.4 3.7-27.5 11s-9.2 18-9.2 31.9c0 12.7 2.3 21.6 6.9 26.7s11.2 7.7 19.7 7.7h1.1zm-6.6-17.8c-2.6-5.2-3.8-12.3-3.8-21.3 0-10.3 1.3-17.6 4-21.8s7-6.3 13.1-6.3c3.3 0 6.3.4 8.9 1.2s4.8 1.7 6.6 2.7v30.8c0 8.2-.5 13.3-1.5 15.4s-2.8 3.8-5.5 5.1-5.6 1.9-8.8 1.9c-6.1.1-10.4-2.5-13-7.7zm352.3 18.1c1.6 0 3.1-.1 4.6-.3 2.3-.3 4.6-.7 6.9-1.4 3.9-1.1 8.2-3.1 12.7-5.8 8.4-5.9 13.5-14.9 13.5-25.1-.1-4.2-.1-9-.1-14.4v-54c0-2.5-.7-8.6-7.7-8.6-8.8 0-10 6.7-9.1 12.9.7 4.6.9 4.8 1.1 9s.3 8.2.3 11.9c-1.8-.5-3.6-.8-5.6-1.1s-4.4-.5-7.3-.5c-12.2 0-21.4 3.7-27.5 11s-9.2 18-9.2 31.9c0 12.7 2.3 21.6 6.9 26.7s11.2 7.7 19.7 7.7h1.1zm-6.6-17.8c-2.6-5.2-3.8-12.3-3.8-21.3 0-10.3 1.3-17.6 4-21.8s7-6.3 13.1-6.3c3.3 0 6.3.4 8.9 1.2s4.8 1.7 6.6 2.7v30.8c0 8.2-.5 13.3-1.5 15.4s-2.8 3.8-5.5 5.1-5.6 1.9-8.8 1.9c-6.1.1-10.4-2.5-13-7.7z"
	    }
	  })])]), _vm._v(" "), _c('span', {
	    staticClass: "academy__header-divider"
	  }, [_vm._v("Academy")]), _vm._v(" "), _c('span', {
	    staticClass: "academy__header-sep"
	  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
	    staticClass: "academy__school-name"
	  }, [_vm._v(_vm._s(_vm.schoolName))])]), _vm._v(" "), _c('nav', {
	    staticClass: "academy__tabs"
	  }, [_vm._l((_vm.academyTabs), function(tab) {
	    return [(!tab.comingSoon) ? _c('button', {
	      key: tab.id,
	      staticClass: "academy__tab",
	      class: {
	        'academy__tab--active': _vm.activeShowcaseId === tab.id
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.switchShowcase(tab.id)
	        }
	      }
	    }, [_vm._v("\n          " + _vm._s(tab.label) + "\n        ")]) : _c('span', {
	      key: 'soon-' + tab.label,
	      staticClass: "academy__tab academy__tab--soon",
	      attrs: {
	        "aria-disabled": "true"
	      }
	    }, [_c('span', {
	      staticClass: "academy__tab-label"
	    }, [_vm._v(_vm._s(tab.label))]), _vm._v(" "), _c('span', {
	      staticClass: "academy__tab-soon-note"
	    }, [_vm._v("Kommer snart")])])]
	  })], 2)]), _vm._v(" "), (!_vm.isLoading && _vm.videos.length) ? _c('div', {
	    staticClass: "academy__body"
	  }, [_c('div', {
	    staticClass: "academy__player-section"
	  }, [_c('div', {
	    staticClass: "academy__player-wrap"
	  }, [_c('iframe', {
	    ref: "vimeoPlayer",
	    attrs: {
	      "src": _vm.activeVideoSrc,
	      "frameborder": "0",
	      "allow": "autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media",
	      "allowfullscreen": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "academy__video-info"
	  }, [_c('h2', {
	    staticClass: "academy__video-title"
	  }, [_vm._v(_vm._s(_vm.activeVideo.name))]), _vm._v(" "), (_vm.activeVideo.description_html) ? _c('div', {
	    staticClass: "academy__video-desc",
	    domProps: {
	      "innerHTML": _vm._s(_vm.activeVideo.description_html)
	    }
	  }) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "academy__playlist"
	  }, _vm._l((_vm.videos), function(video, index) {
	    return _c('div', {
	      key: video.uri,
	      staticClass: "academy__playlist-item",
	      class: {
	        'academy__playlist-item--active': _vm.activeVideo && _vm.activeVideo.uri === video.uri
	      },
	      on: {
	        "click": function($event) {
	          return _vm.selectVideo(video)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "academy__playlist-item-left"
	    }, [_c('i', {
	      staticClass: "academy__play-icon"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "academy__playlist-number"
	    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('span', {
	      staticClass: "academy__playlist-name"
	    }, [_vm._v(_vm._s(video.name))])]), _vm._v(" "), _c('span', {
	      staticClass: "academy__playlist-duration"
	    }, [_vm._v("(" + _vm._s(_vm.formatDuration(video.duration)) + ")")]), _vm._v(" "), _c('div', {
	      staticClass: "academy__playlist-progress"
	    }, [_c('div', {
	      staticClass: "academy__playlist-progress-bar",
	      style: ({
	        width: _vm.getProgress(video) + '%'
	      })
	    })])])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
	    staticClass: "academy__loading"
	  }, [_c('div', {
	    staticClass: "academy__spinner"
	  })]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && !_vm.videos.length) ? _c('div', {
	    staticClass: "academy__empty"
	  }, [_c('p', [_vm._v("Ingen videoer fundet.")])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "academy__hero"
	  }, [_c('div', {
	    staticClass: "academy__hero-bg"
	  }, [_c('div', {
	    staticClass: "academy__hero-bg__triangle"
	  })])])
	}]}

/***/ }),
/* 1964 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-create-task-for-user"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [(_vm.isCreateNewEmploymentTitle) ? [_vm._v("Tilføj ny ansættelse")] : [_vm._v("Er det til vikarer?")]], 2), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [(_vm.isCreateNewEmploymentTitle) ? _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Titel")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    ref: "title_input",
	    staticClass: "d-input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.title = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('label', {
	    staticClass: "d-label",
	    staticStyle: {
	      "margin": "0 1rem"
	    }
	  }, [_vm._v("Skal personale med denne ansættelse inkluderes i\n        vikarlønindberetningen?")]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group d-input-group--toggler",
	    class: {
	      'd-input-group--toggler--active': _vm.isManualSalary
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.$emit('setIsManualSalary', !_vm.isManualSalary)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Skal indberettes som vikarløn\n        ")]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isManualSalary
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValid) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
	  }, [_vm._v("\n          Tilføj til " + _vm._s(_vm.selectedUsers.length) + " " + _vm._s(_vm.selectedUsers.length === 1 ? 'person' : 'personer') + "\n        ")]) : _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.onSubmit
	    }
	  }, [_vm._v("\n          Tilføj til " + _vm._s(_vm.selectedUsers.length) + " " + _vm._s(_vm.selectedUsers.length === 1 ? 'person' : 'personer') + "\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1965 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "appendToBody": true,
	      "zIndex": 1000000000
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal__d-calendar text-dark",
	    class: {
	      'd-modal__d-calendar--with-actions': _vm.isShowActions
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__d-calendar__header text-dark"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.calendar.name))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__d-calendar__content"
	  }, [_c('div', {
	    staticClass: "d-modal__d-calendar__container"
	  }, [_c('DCalendar', {
	    attrs: {
	      "calendarId": _vm.calendar.id,
	      "isShowWeek": false,
	      "date": _vm.date,
	      "events": _vm.events,
	      "isLoadingEvents": _vm.isEventsLoading
	    }
	  })], 1), _vm._v(" "), (_vm.isShowActions) ? _c('CalendarViewDayRemoveOrReplace', {
	    attrs: {
	      "event": _vm.event,
	      "calendar": _vm.calendar,
	      "calendars": _vm.calendars
	    },
	    on: {
	      "updateAndClose": function($event) {
	        return _vm.$emit('updateAndClose')
	      }
	    }
	  }) : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 1966 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "engangsydelser text-dark"
	  }, [_c('h2', {
	    staticClass: "marg-1-bottom capitalize"
	  }, [_vm._v("Engangsydelser")]), _vm._v(" "), (_vm.isNoConfiguration) ? [_vm._m(0)] : [_c('div', {
	    staticClass: "engangsydelser__header"
	  }, [_c('div', {
	    staticClass: "engangsydelser__header__left"
	  }, [_c('Tabs', {
	    attrs: {
	      "tabs": _vm.viewTabs,
	      "selected": _vm.viewTab
	    },
	    on: {
	      "select": _vm.onSelectViewTab
	    }
	  }), _vm._v(" "), (_vm.viewTab === 'opus') ? [_c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Personer',
	      "tags": _vm.personNames,
	      "selectedTags": _vm.selectedPersonNames,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg personer'
	    },
	    on: {
	      "select": _vm.togglePersonName,
	      "clear": function($event) {
	        _vm.selectedPersonNames = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Grupper',
	      "tags": _vm.userTags,
	      "selectedTags": _vm.selectedUserTags,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg grupper'
	    },
	    on: {
	      "select": _vm.toggleUserTag,
	      "clear": function($event) {
	        _vm.selectedUserTags = []
	      }
	    }
	  }), _vm._v(" "), (_vm.employmentTitles.length > 1) ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Ansættelser',
	      "tags": _vm.employmentTitles,
	      "selectedTags": _vm.selectedEmploymentTitles,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg stilling'
	    },
	    on: {
	      "select": _vm.toggleEmploymentTitle,
	      "clear": function($event) {
	        _vm.selectedEmploymentTitles = []
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.organisations.length > 1) ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Organisationer',
	      "tags": _vm.organisations,
	      "selectedTags": _vm.selectedOrganisations,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg organisation'
	    },
	    on: {
	      "select": _vm.toggleOrganisation,
	      "clear": function($event) {
	        _vm.selectedOrganisations = []
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "engangsydelser__count"
	  }, [_vm._v("\n            Viser " + _vm._s(_vm.filteredRows.length) + " af " + _vm._s(_vm.allRows.length) + " ansættelser\n          ")])] : [_c('DoDatePickerRange', {
	    attrs: {
	      "allowSameDate": true,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate,
	      "maximumDateRange": 365
	    },
	    on: {
	      "startChanged": _vm.startDateChanged,
	      "endChanged": _vm.endDateChanged
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Personer',
	      "tags": _vm.uniqueNames,
	      "selectedTags": _vm.selectedNames,
	      "numberOfSelectedTagsToShow": 2,
	      "placeholder": 'Vælg personer'
	    },
	    on: {
	      "select": _vm.toggleName,
	      "clear": _vm.clearNames
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Lønkode',
	      "tags": _vm.uniqueLoenart,
	      "selectedTags": _vm.selectedLoenart,
	      "numberOfSelectedTagsToShow": 2,
	      "placeholder": 'Vælg lønkode'
	    },
	    on: {
	      "select": _vm.toggleLoenart,
	      "clear": _vm.clearLoenart
	    }
	  })]], 2), _vm._v(" "), (_vm.viewTab !== 'opus') ? _c('div', {
	    staticClass: "engangsydelser__header__right"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--small",
	    attrs: {
	      "disabled": _vm.isLoading
	    },
	    on: {
	      "click": _vm.readEngangsydelser
	    }
	  }, [_vm._v("\n          Opdater\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--small",
	    class: {
	      'do-bttn--loading': _vm.isDownloadingExcel
	    },
	    attrs: {
	      "disabled": _vm.isLoading || _vm.isDownloadingExcel || _vm.displayedEngangsydelser.length === 0
	    },
	    on: {
	      "click": _vm.downloadExcel
	    }
	  }, [_vm._v("\n          Download til excel\n        ")])]) : _vm._e()]), _vm._v(" "), (_vm.viewTab === 'opus') ? _c('div', {
	    staticClass: "engangsydelser__toolbar"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'top',
	        animateFill: false,
	        animation: 'shift-away',
	        boundary: 'window'
	      }),
	      expression: "{\n              arrow: true,\n              placement: 'top',\n              animateFill: false,\n              animation: 'shift-away',\n              boundary: 'window'\n            }"
	    }],
	    staticClass: "engangsydelser__toolbar__wrap",
	    attrs: {
	      "content": _vm.selectedEmploymentIds.length === 0 ? 'Vælg personer først' : ''
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': _vm.selectedEmploymentIds.length === 0
	    },
	    attrs: {
	      "disabled": _vm.selectedEmploymentIds.length === 0
	    },
	    on: {
	      "click": _vm.openBulkCreate
	    }
	  }, [_vm._v("\n          Opret engangsydelser\n        ")])]), _vm._v(" "), (_vm.selectedEmploymentIds.length > 0) ? _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.cancelBatchMode
	    }
	  }, [_vm._v("Annuller valg")]) : _vm._e(), _vm._v(" "), (_vm.selectedEmploymentIds.length > 0) ? _c('span', {
	    staticClass: "engangsydelser__count"
	  }, [_vm._v("\n        " + _vm._s(_vm.selectedEmploymentIds.length) + " valgt\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "engangsydelser__body"
	  }, [(_vm.viewTab === 'opus') ? [(_vm.isLoadingEmployments) ? _c('Loader') : _c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "td-check do-table__toggle-all",
	    on: {
	      "click": _vm.toggleAllSelected
	    }
	  }, [_c('div', {
	    staticClass: "do-checkbox",
	    class: {
	      'do-checkbox--selected': _vm.isAllFilteredSelected
	    }
	  })]), _vm._v(" "), _c('th', [_vm._v("NAVN")]), _vm._v(" "), _c('th', [_vm._v("ANSÆTTELSE")]), _vm._v(" "), _c('th', [_vm._v("ORGANISATION")]), _vm._v(" "), _c('th', {
	    staticClass: "th-row-actions"
	  })])]), _vm._v(" "), (_vm.filteredRows.length === 0) ? _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": 5
	    }
	  }, [_vm._v("Ingen ansættelser fundet")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.groupedRows), function(group) {
	    return _c('tbody', {
	      key: group.userId,
	      staticClass: "user-group"
	    }, _vm._l((group.rows), function(row) {
	      return _c('tr', {
	        key: row.id,
	        staticClass: "employment-row",
	        class: {
	          'is-selected': _vm.isRowSelected(row)
	        },
	        on: {
	          "click": function($event) {
	            return _vm.onRowClick(row)
	          }
	        }
	      }, [_c('td', {
	        staticClass: "td-check",
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.onCheckboxClick(row)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "do-checkbox",
	        class: {
	          'do-checkbox--selected': _vm.isRowSelected(row)
	        }
	      })]), _vm._v(" "), _c('td', {
	        staticClass: "bold"
	      }, [_vm._v(_vm._s(row.userName))]), _vm._v(" "), _c('td', {
	        staticClass: "td-organisation"
	      }, [_vm._v("\n              " + _vm._s(row.employmentNumber) + " - " + _vm._s(row.employmentTitle) + "\n            ")]), _vm._v(" "), _c('td', {
	        staticClass: "td-organisation"
	      }, [_vm._v(_vm._s(row.organisation))]), _vm._v(" "), _c('td', {
	        staticClass: "td-row-actions"
	      }, [(!_vm.isBatchMode) ? _c('button', {
	        staticClass: "do-bttn do-bttn--small row-action-btn",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.openViewModal(row)
	          }
	        }
	      }, [_vm._v("Se engangsydelser")]) : _vm._e()])])
	    }), 0)
	  })], 2)] : [(_vm.isLoading) ? _c('Loader') : _c('table', {
	    staticClass: "do-table do-table--striped"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "th-sorter td-created",
	    class: {
	      'th-sorter--active': !_vm.isSortPristine && _vm.sortBy === 'vCreatedAt'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('vCreatedAt')
	      }
	    }
	  }, [_vm._v("\n              OPRETTET "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'name'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('name')
	      }
	    }
	  }, [_vm._v("\n              NAVN "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'employment_number'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('employment_number')
	      }
	    }
	  }, [_vm._v("\n              ANSÆTTELSE "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'loenart'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('loenart')
	      }
	    }
	  }, [_vm._v("\n              LØNKODE "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter td-units",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'antal'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('antal')
	      }
	    }
	  }, [_vm._v("\n              ENHEDER "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter td-units",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'beloeb'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('beloeb')
	      }
	    }
	  }, [_vm._v("\n              BELØB "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter td-date",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'dato'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('dato')
	      }
	    }
	  }, [_vm._v("\n              DATO "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', [_vm._v("\n              OPRETTET AF\n            ")]), _vm._v(" "), _c('th', [_vm._v("\n              STATUS\n            ")]), _vm._v(" "), _c('th', {
	    staticClass: "th-actions"
	  })])]), _vm._v(" "), _c('tbody', [(_vm.displayedEngangsydelser.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": 10
	    }
	  }, [_vm._v("\n              Ingen engangsydelser fundet\n            ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayedEngangsydelser), function(item, index) {
	    return _c('tr', {
	      key: item.parentId + '-' + item.engangsydelseIndex + '-' + index,
	      staticClass: "engangsydelse-row"
	    }, [_c('td', {
	      staticClass: "td-created"
	    }, [_vm._v(_vm._s(item.vCreatedAt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vUserName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vEmploymentNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vLoenart))]), _vm._v(" "), _c('td', {
	      staticClass: "td-units"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(item.antal)))]), _vm._v(" "), _c('td', {
	      staticClass: "td-units"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(item.beloeb)))]), _vm._v(" "), _c('td', {
	      staticClass: "td-date"
	    }, [_vm._v(_vm._s(item.vDato))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vCreatedBy))]), _vm._v(" "), _c('td', {
	      staticClass: "td-status"
	    }, [_c('span', {
	      staticClass: "engangsydelse-status",
	      class: 'engangsydelse-status--' + item.status,
	      attrs: {
	        "title": item.vMessageText
	      }
	    }, [_vm._v("\n                " + _vm._s(_vm.statusLabel(item.status)) + "\n              ")]), _vm._v(" "), (item.status === 'error' && item.vMessageText) ? _c('div', {
	      staticClass: "engangsydelse-status__message",
	      attrs: {
	        "title": item.vMessageText
	      }
	    }, [_vm._v("\n                " + _vm._s(item.vMessageText) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticClass: "td-actions"
	    }, [(item.status === 'success') ? _c('button', {
	      staticClass: "do-bttn do-bttn--small modregn-btn",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.openModpostering(item)
	        }
	      }
	    }, [_vm._v("Modregn")]) : _vm._e()])])
	  })], 2)])]], 2)], _vm._v(" "), (_vm.createEmploymentIds.length > 0) ? _c('CreateEngangsydelse', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "employmentIds": _vm.createEmploymentIds,
	      "subtitle": _vm.createSubtitle,
	      "prefill": _vm.createPrefill
	    },
	    on: {
	      "created": _vm.onCreated,
	      "close": _vm.closeCreate
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.activeRow) ? _c('EngangsydelserModal', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "employmentId": _vm.activeRow.employmentId,
	      "employment": _vm.activeRow.employment,
	      "userId": _vm.activeRow.userId,
	      "userName": _vm.activeRow.userName,
	      "employmentNumber": _vm.activeRow.employmentNumber
	    },
	    on: {
	      "created": _vm.onViewModalCreated,
	      "close": function($event) {
	        _vm.activeRow = null
	      }
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "engangsydelser-no-config"
	  }, [_c('h2', [_c('i', [_vm._v("Skolens Opus-integration er ikke konfigureret korrekt. Kontakt Docendo for at få hjælp til opsætningen -\n          enten på chat eller email.")])])])
	}]}

/***/ }),
/* 1967 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "collisions shadow text-dark"
	  }, [_c('div', {
	    staticClass: "collisions__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['double_bookings']) + ", " + _vm._s(_vm.formattedDate))]), _vm._v(" "), _c('div', {
	    staticClass: "collisions__date-changer"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.$emit('prevDay')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-left4"
	  })]), _vm._v(" "), _c('button', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.$emit('nextDay')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-right4"
	  })])])]), _vm._v(" "), _c('ul', {
	    staticClass: "collisions__content"
	  }, [_c('li', {
	    staticClass: "collisions__lesson collisions__lesson__header"
	  }, [_c('div', [_vm._v(_vm._s(_vm.collisions.length) + " "), (_vm.collisions.length === 1) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['double_booking']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['double_bookings']))])])]), _vm._v(" "), (_vm.isLoading) ? _c('li', {
	    staticClass: "collisions__loader"
	  }, [_c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.eventsWithOverlappingEvents.length < 1) ? _c('li', {
	    staticClass: "collisions__lesson text-explainer"
	  }, [_vm._v("\n      " + _vm._s(_vm.i18n[_vm.locale]['no_double_bookings']) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.eventsWithOverlappingEvents), function(event) {
	    return _c('li', {
	      key: event.event_id,
	      staticClass: "collisions__lesson",
	      style: ({
	        'border-left-color': event.color
	      }),
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          _vm.activeEvent = event
	        }
	      }
	    }, [_c('div', [_vm._v("\n        " + _vm._s(event.v_start) + " - " + _vm._s(event.v_end) + " | "), _c('b', [_vm._v(_vm._s(event.title))]), _vm._v(", "), _c('i', [_vm._v(_vm._s(event.v_owner_calendar_name))])]), _vm._v(" "), _c('div', {
	      staticClass: "overlapping-calendars"
	    }, [_vm._l((event.v_overlapping_cals_with_events), function(overlappingCalendar) {
	      return (overlappingCalendar.idx < 3) ? _c('div', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: true,
	            zIndex: '999999992',
	            boundary: 'window'
	          }),
	          expression: "{\n               arrow: true,\n               zIndex: '999999992',\n               boundary: 'window'}"
	        }],
	        key: overlappingCalendar.calendar.id,
	        staticClass: "overlapping-calendar shadow",
	        attrs: {
	          "content": overlappingCalendar.lessons.map(function (overlappingCalendarEvent) { return overlappingCalendarEvent.v_event_title; })
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            _vm.activeCalendar = overlappingCalendar.calendar
	          }
	        }
	      }, [_c('span', {
	        staticClass: "icon-warning"
	      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(overlappingCalendar.calendar.name ? overlappingCalendar.calendar.name : ''))])]) : _vm._e()
	    }), _vm._v(" "), (event.v_number_of_overlapping_events > 3) ? _c('div', [_vm._v("\n          + " + _vm._s(event.v_number_of_overlapping_events - 3) + " " + _vm._s(_vm.i18n[_vm.locale]['more']) + "\n        ")]) : _vm._e()], 2)])
	  })], 2), _vm._v(" "), (_vm.activeCalendar) ? _c('CalendarViewDay', {
	    attrs: {
	      "date": _vm.date,
	      "calendar": _vm.activeCalendar
	    },
	    on: {
	      "close": function($event) {
	        _vm.activeCalendar = null
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "zoomIn"
	    }
	  }, [(_vm.activeEvent) ? _c('DCalendarShowEvent', {
	    attrs: {
	      "event": _vm.activeEvent,
	      "initCalendarId": _vm.activeEvent.calendar_id,
	      "showSettings": false
	    },
	    on: {
	      "updated": _vm.onEventUpdated,
	      "close": _vm.closeShowEvent
	    }
	  }) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1968 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "salary-settings-users"
	  }, [(_vm.isSalaryIntegrationActive) ? _c('SalarySettingsUsersOpus', {
	    attrs: {
	      "users": _vm.usersWithEmployments,
	      "tags": _vm.tags,
	      "employments": _vm.employments,
	      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive
	    },
	    on: {
	      "setTheEditUser": _vm.setTheEditUser,
	      "editEmployment": _vm.setTheEditUserEmployment
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isSalaryIntegrationActive) ? [_c('div', {
	    staticClass: "do-table__filters"
	  }, [_c('div', {
	    staticClass: "do-table__filters__left"
	  }, [_c('Tabs', {
	    staticStyle: {
	      "height": "26px"
	    },
	    attrs: {
	      "tabs": _vm.theTabs,
	      "selected": _vm.theSelectedTab,
	      "isLarge": false
	    },
	    on: {
	      "select": function($event) {
	        _vm.theSelectedTab = $event
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Grupper',
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters,
	      "numberOfSelectedTagsToShow": 6,
	      "placeholder": 'Vælg grupper'
	    },
	    on: {
	      "select": _vm.setTagFromFilter,
	      "clear": _vm.clearAllTags
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-table__filters__add"
	  }, [_c('span', [_vm._v(_vm._s(_vm.selectedUsers.length) + " af " + _vm._s(_vm.filteredUsers.length))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickAway),
	      expression: "onClickAway"
	    }],
	    staticClass: "do-dropdown",
	    class: {
	      'do-dropdown--open': _vm.isDropdown
	    }
	  }, [(_vm.selectedUsers.length < 1) ? _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'left',
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window'
	      }),
	      expression: "{\n                  placement: 'left',\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n              }"
	    }],
	    staticClass: "do-dropdown__toggler do-bttn do-bttn--submit do-bttn--submit--disabled",
	    attrs: {
	      "content": "Vælg personale først"
	    }
	  }, [_vm._v("\n            Tilføj ansættelser "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]) : _c('button', {
	    staticClass: "do-dropdown__toggler do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.setIsDropdown
	    }
	  }, [_vm._v("\n            Tilføj ansættelser "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "do-dropdown"
	    }
	  }, [(_vm.isDropdown) ? _c('div', {
	    staticClass: "do-dropdown__dropdown"
	  }, [_c('ul', [_vm._l((_vm.employmentsTypesForDropdown), function(employmentType) {
	    return _c('li', {
	      staticClass: "do-dropdown__dropdown__item",
	      class: {
	        'do-dropdown__dropdown__item--active': employmentType.v_isSelected
	      },
	      on: {
	        "click": function($event) {
	          return _vm.selectedEmploymentsType(employmentType.v_title)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "do-dropdown__dropdown__item__name"
	    }, [_c('span', {
	      staticClass: "icon-user"
	    }), _vm._v("\n                    " + _vm._s(employmentType.v_title) + "\n                  ")]), _vm._v(" "), (employmentType.v_isSelected) ? _c('div', {
	      staticClass: "icon__checkmark"
	    }, [_c('span', {
	      staticClass: "icon-checkmark-circle"
	    })]) : _vm._e()])
	  }), _vm._v(" "), _c('li', {
	    staticClass: "do-dropdown__dropdown__item do-dropdown__dropdown__item--add",
	    on: {
	      "click": function($event) {
	        return _vm.setIsCreateNewEmploymentTitle(true)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "btn-trans"
	  }, [_vm._v("\n                    Opret ny stillingskategori\n                  ")])])], 2), _vm._v(" "), _c('div', {
	    staticClass: "do-dropdown__dropdown__buttons"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	        onShow: function () { return _vm.selectedEmployments.length < 1 || _vm.selectedUsers.length < 1; }
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => selectedEmployments.length < 1 || selectedUsers.length < 1\n            }"
	    }],
	    staticClass: "do-bttn do-bttn--submit",
	    class: [{
	      'do-bttn--submit--disabled': _vm.selectedEmployments.length < 1 || _vm.selectedUsers.length < 1
	    }, {
	      'do-bttn--submit--loading': _vm.isSubmittingUsers
	    }],
	    attrs: {
	      "content": "Vælg personer og ansættelser først"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setIsAddExistingEmploymentsToUsers(true)
	      }
	    }
	  }, [_vm._v("\n                  Gem\n                ")])])]) : _vm._e()])], 1)])]), _vm._v(" "), _c('table', {
	    staticClass: "do-table do-table__user-employments"
	  }, [_c('thead', [_c('th', {
	    staticClass: "do-table__toggle-all",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.selectedUsers.length === 0) ? [_vm._v("\n          " + _vm._s(_vm.$t('vue2.tagging.select_all')) + "\n        ")] : [_vm._v("\n          " + _vm._s(_vm.$t('vue2.tagging.unselect_all')) + "\n        ")]], 2), _vm._v(" "), _c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', [_vm._v("Stillingskategori")])]), _vm._v(" "), _c('tbody', {
	    ref: "d-b"
	  }, _vm._l((_vm.filteredUsers), function(user) {
	    return _c('tr', {
	      key: user.id,
	      on: {
	        "click": function($event) {
	          return _vm.toggleUser(user)
	        }
	      }
	    }, [_c('td', [_c('div', {
	      staticClass: "d-checkbox",
	      class: {
	        'd-checkbox--active': user.v_isSelected
	      }
	    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
	      staticClass: "d-tags"
	    }, [_vm._l((user.v_employments), function(employment) {
	      return _c('div', {
	        staticClass: "d-tag",
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.setTheEditUserEmployment({
	              user: user,
	              employment: employment
	            })
	          }
	        }
	      }, [_vm._v("\n            " + _vm._s(employment.title) + "\n            "), (employment.manual_salary) ? _c('div', {
	        staticClass: "do-pill do-pill--small do-pill--yellow"
	      }, [_vm._v("Vikarløn")]) : _vm._e()])
	    }), _vm._v(" "), (user.v_employments.length === 0) ? _c('p', {
	      staticClass: "italic font-small"
	    }, [_vm._v("Ingen ansættelser")]) : _vm._e()], 2), _vm._v(" "), _c('td', [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
	      }],
	      staticClass: "icon__bg-circle",
	      attrs: {
	        "content": "Redigér ansættelser"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setTheEditUser(user)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-wrench"
	    })])])])
	  }), 0)])] : _vm._e(), _vm._v(" "), (_vm.theEditUser) ? _c('SalarySettingsUsersUser', {
	    attrs: {
	      "user": _vm.theEditUser,
	      "theEditEmployment": _vm.theEditUserEmployment,
	      "school": _vm.school,
	      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setTheEditUser(null)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isAddEmploymentModal) ? _c('SalarySettingsCreateEmploymentType', {
	    attrs: {
	      "selectedUsers": _vm.selectedUsers,
	      "isManualSalary": _vm.isManualSalary,
	      "isCreateNewEmploymentTitle": _vm.isCreateNewEmploymentTitle
	    },
	    on: {
	      "setIsManualSalary": _vm.setIsManualSalary,
	      "save": _vm.saveForUsers,
	      "close": function($event) {
	        return _vm.setIsAddExistingEmploymentsToUsers(false)
	      }
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1969 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.userSchoolsSorted.length > 1) ? _c('div', {
	    staticClass: "school-selector text-dark"
	  }, [_c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "propOffset": [0, 8]
	    },
	    scopedSlots: _vm._u([{
	      key: "title",
	      fn: function() {
	        return [_c('button', {
	          staticClass: "do-bttn do-bttn--with-icon"
	        }, [_vm._v("\n        " + _vm._s(_vm.selectedTitle) + "\n        "), _c('svg', {
	          staticClass: "tw-icon tw-icon-cheveron-selection",
	          attrs: {
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 24 24"
	          }
	        }, [_c('path', {
	          staticClass: "secondary",
	          attrs: {
	            "fill-rule": "evenodd",
	            "d": "M8.7 9.7a1 1 0 1 1-1.4-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 1 1-1.4 1.4L12 6.42l-3.3 3.3zm6.6 4.6a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
	          }
	        })])])]
	      },
	      proxy: true
	    }, {
	      key: "list",
	      fn: function() {
	        return [_c('ul', {
	          staticClass: "school-selector__list text-dark",
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	            }
	          }
	        }, _vm._l((_vm.userSchoolsSorted), function(school) {
	          return _c('li', {
	            key: school.id,
	            staticClass: "school-selector__list__item",
	            class: {
	              'school-selector__list__item--disabled': school.v_has_permission
	            },
	            on: {
	              "click": function($event) {
	                return _vm.toggleSchool(school)
	              }
	            }
	          }, [_vm._v("\n          " + _vm._s(school.name) + "\n          "), (school.v_is_selected) ? _c('svg', {
	            staticClass: "tw-icon icon-check",
	            attrs: {
	              "xmlns": "http://www.w3.org/2000/svg",
	              "viewBox": "0 0 24 24"
	            }
	          }, [_c('circle', {
	            staticClass: "primary",
	            attrs: {
	              "cx": "12",
	              "cy": "12",
	              "r": "10"
	            }
	          }), _vm._v(" "), _c('path', {
	            staticClass: "secondary",
	            attrs: {
	              "d": "M10 14.59l6.3-6.3a1 1 0 0 1 1.4 1.42l-7 7a1 1 0 0 1-1.4 0l-3-3a1 1 0 0 1 1.4-1.42l2.3 2.3z"
	            }
	          })]) : _vm._e()])
	        }), 0)]
	      },
	      proxy: true
	    }], null, false, 1138270715)
	  })], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1970 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isSubmitButtonLoading": _vm.isSubmitting,
	      "customWidth": '650px',
	      "noMarginOnButton": true,
	      "appendToBody": _vm.appendToBody,
	      "isShowConfirmDeleteMessage": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      },
	      "confirm": _vm.onConfirmDelete
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "custom_warning"
	    },
	    slot: "custom_warning"
	  }, [_c('div', {
	    staticClass: "away_warning"
	  }, [(_vm.uncancelGroups.length > 0) ? _c('div', {
	    staticClass: "away_warning__lessons"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.i18n.lessons_will_be_restored))]), _vm._v(" "), _vm._l((_vm.uncancelGroups), function(grp) {
	    return _c('div', {
	      key: 'u_' + grp.name
	    }, [_c('table', {
	      staticClass: "away_warning__lessons__table"
	    }, [_c('tbody', _vm._l((grp.events), function(ev) {
	      return _c('tr', {
	        key: ev.event_id + '_' + grp.name,
	        staticClass: "marg-0-5-top"
	      }, [_c('td', [_vm._v("\n                " + _vm._s(grp.name) + " | " + _vm._s(ev.title) + "\n                "), _c('span', {
	        staticClass: "text-gray"
	      }, [_vm._v("(" + _vm._s(_vm.humanTime(ev.start, ev.end)) + ")")])])])
	    }), 0)])])
	  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "away_warning__text"
	  }, [_c('h4', {
	    staticClass: "marg-0-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n.confirm_delete_title))]), _vm._v(" "), _c('p', {
	    staticClass: "pad-1 italic"
	  }, [_vm._v(_vm._s(_vm.i18n.confirm_delete_text))]), _vm._v(" "), (_vm.uncancelGroups.length === 0) ? _c('p', {
	    staticClass: "pad-1 italic pad-0-top"
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n.no_lessons_to_restore) + "\n        ")]) : _vm._e()])])]), _vm._v(" "), _c('p', {
	    attrs: {
	      "slot": "confirmText"
	    },
	    slot: "confirmText"
	  }, [_vm._v(_vm._s(_vm.i18n.delete))])])
	},staticRenderFns: []}

/***/ }),
/* 1971 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "log-deleted-events text-dark"
	  }, [_c('h2', {
	    staticClass: "marg-5-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.deleted_subjects_log.deleted_log')) + " \"" + _vm._s(_vm.subject.name) + "\"")]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }) : _c('div', [(_vm.sortedLog.length < 1) ? _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.deleted_subjects_log.no_lessons_deleted')))]) : _vm._e(), _vm._v(" "), (_vm.sortedLog.length > 0) ? _c('ul', {
	    staticClass: "log-deleted-events__list"
	  }, [_c('li', {
	    staticClass: "log-deleted-events__event log-deleted-events__event__header"
	  }, [_c('div', [_c('b', [_vm._v(_vm._s(_vm.$t('vue2.deleted_subjects_log.lesson')))])]), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.$t('vue2.deleted_subjects_log.deleted')))])])]), _vm._v(" "), _vm._l((_vm.sortedLog), function(logEvent) {
	    return _c('li', {
	      key: logEvent.id,
	      staticClass: "log-deleted-events__event"
	    }, [_c('div', {
	      staticClass: "log-deleted-events__event__event-datetime subject-event",
	      style: ({
	        'backgroundColor': _vm.subject.color
	      })
	    }, [_vm._v("\n          " + _vm._s(logEvent.v_eventDate) + "\n        ")]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'top'
	        }),
	        expression: "{\n          arrow: true,\n          placement : 'top'\n                }"
	      }],
	      staticClass: "text-greyed",
	      attrs: {
	        "content": logEvent.v_formattedDate
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin text-greyed"
	    }), _vm._v("\n          " + _vm._s(logEvent.name) + " -\n          " + _vm._s(logEvent.v_humanizedDate) + " " + _vm._s(_vm.$t('vue2.common.ago')) + "\n        ")])])
	  })], 2) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1972 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-print text-dark"
	  }, [_c('div', {
	    staticClass: "d-print__container no-print"
	  }, [_c('button', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.setDropdownFromClick),
	      expression: "setDropdownFromClick"
	    }],
	    staticClass: "d-print__button",
	    class: {
	      'do-bttn': _vm.activeCalendarDate
	    },
	    attrs: {
	      "slot": "title"
	    },
	    on: {
	      "click": function($event) {
	        _vm.onlyPrintThisCalendar ? _vm.printThis() : _vm.setIsDropdown()
	      }
	    },
	    slot: "title"
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  }), _vm._v(" "), (!_vm.onlyPrintThisCalendar) ? _c('span', {
	    staticClass: "icon-arrow-down5"
	  }) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropdown"
	    }
	  }, [(_vm.isDropdown && !_vm.onlyPrintThisCalendar) ? _c('div', {
	    staticClass: "d-print__container__dropdown"
	  }, [_c('ul', [_c('li', {
	    on: {
	      "click": _vm.printThis
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.this_calendar')))]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.selectType({
	          type: 'multiple_calendars'
	        })
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.print_all_calendars.custom')) + "\n          ")]), _vm._v(" "), _vm._l((_vm.calendarTypes), function(type) {
	    return _c('li', {
	      key: type.type,
	      on: {
	        "click": function($event) {
	          return _vm.selectType(type)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(type.title) + "\n          ")])
	  })], 2)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
	    staticClass: "print-all text-dark"
	  }, [(_vm.isShowModal) ? _c('d-modal', {
	    attrs: {
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "print-all-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "print-calendars__header border-1-bottom"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.only_printing_calendars_with_lessons')))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": _vm.setIsShowModalFalse
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "print-all-modal__body"
	  }, [_c('div', [_c('PrintCalendars', {
	    attrs: {
	      "showDSelect": _vm.printCalendarType === 'multiple_calendars',
	      "calendarIds": _vm.calendarIds,
	      "start-date": _vm.startDate,
	      "end-date": _vm.endDate,
	      "date": _vm.date,
	      "firstDayOfWeek": _vm.firstDayOfWeek
	    },
	    on: {
	      "updateCalendars": function($event) {
	        return _vm.updateSelectedCalendar($event)
	      },
	      "clear": _vm.clearSelectedCalendars
	    }
	  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isShowModal) ? _c('div', {
	    staticClass: "bg-overlay",
	    on: {
	      "click": _vm.setIsShowModalFalse
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1973 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": _vm.close
	    }
	  }, [_c('div', {
	    staticClass: "d-modal transfer-rest text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Overfør positiv rest til brik")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "transfer-rest__table-scroll"
	  }, [_c('table', {
	    staticClass: "do-table do-table--striped"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "transfer-rest__check"
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.users.length === 0
	    },
	    domProps: {
	      "checked": _vm.isAllSelected
	    },
	    on: {
	      "change": _vm.toggleAll
	    }
	  })]), _vm._v(" "), _c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', {
	    staticClass: "transfer-rest__narrow"
	  }, [_vm._v("Arbejdstid")]), _vm._v(" "), _c('th', {
	    staticClass: "transfer-rest__narrow"
	  }, [_vm._v("Rest")])])]), _vm._v(" "), _c('tbody', [(_vm.users.length === 0) ? _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_c('i', [_vm._v("Ingen personer har positiv rest")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.users), function(user) {
	    return _c('tr', {
	      key: user.id,
	      staticClass: "transfer-rest__row",
	      on: {
	        "click": function($event) {
	          return _vm.toggleUser(user.id)
	        }
	      }
	    }, [_c('td', {
	      staticClass: "transfer-rest__check"
	    }, [_c('input', {
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "checked": _vm.isSelected(user.id)
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.toggleUser(user.id)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('td', {
	      staticClass: "transfer-rest__narrow"
	    }, [_vm._v(_vm._s(_vm.formatHours(user.assigned_total_hours)))]), _vm._v(" "), _c('td', {
	      staticClass: "transfer-rest__narrow"
	    }, [_vm._v(_vm._s(_vm.formatHours(user.rest)))])])
	  })], 2), _vm._v(" "), (_vm.users.length > 0) ? _c('tfoot', [_c('tr', [_c('td', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('strong', [_vm._v(_vm._s(_vm.selectedUsers.length) + " af " + _vm._s(_vm.users.length) + " valgt")])]), _vm._v(" "), _c('td', {
	    staticClass: "transfer-rest__narrow"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.formatHours(_vm.selectedRestSum)))])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "transfer-rest__target"
	  }, [_c('div', {
	    staticClass: "transfer-rest__modes"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    class: {
	      'do-bttn--active': _vm.mode === 'new'
	    },
	    on: {
	      "click": function($event) {
	        _vm.mode = 'new'
	      }
	    }
	  }, [_vm._v("\n            Opret ny brik\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    class: {
	      'do-bttn--active': _vm.mode === 'existing'
	    },
	    attrs: {
	      "disabled": _vm.existingBriks.length === 0
	    },
	    on: {
	      "click": function($event) {
	        _vm.mode = 'existing'
	      }
	    }
	  }, [_vm._v("\n            Vælg eksisterende brik\n          ")])]), _vm._v(" "), (_vm.mode === 'new') ? [_c('div', {
	    staticClass: "transfer-rest__fields"
	  }, [_c('div', {
	    staticClass: "transfer-rest__field transfer-rest__field--wide"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Brikkens titel")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newBrik.name),
	      expression: "newBrik.name"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Eks. Rest til fordeling"
	    },
	    domProps: {
	      "value": (_vm.newBrik.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newBrik, "name", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "transfer-rest__field"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Type")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newBrik.subject_type),
	      expression: "newBrik.subject_type"
	    }],
	    staticClass: "d-input__select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.newBrik, "subject_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.allowedTypes), function(t) {
	    return _c('option', {
	      key: t.value,
	      domProps: {
	        "value": t.value
	      }
	    }, [_vm._v(_vm._s(t.name))])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "transfer-rest__field"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Farve")]), _vm._v(" "), _c('ColorPicker', {
	    attrs: {
	      "initialColor": _vm.newBrik.color
	    },
	    on: {
	      "changedColor": function($event) {
	        _vm.newBrik.color = $event
	      }
	    }
	  })], 1)] : [_c('div', {
	    staticClass: "transfer-rest__field"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Brik")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedBrikKey),
	      expression: "selectedBrikKey"
	    }],
	    staticClass: "d-input__select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedBrikKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": ""
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("-- Vælg brik --")]), _vm._v(" "), _vm._l((_vm.existingBriks), function(brik) {
	    return _c('option', {
	      key: brik.key,
	      domProps: {
	        "value": brik.key
	      }
	    }, [_vm._v("\n                " + _vm._s(brik.name) + " (" + _vm._s(_vm.typeName(brik.subject_type)) + ")\n              ")])
	  })], 2), _vm._v(" "), _c('p', {
	    staticClass: "transfer-rest__hint"
	  }, [_vm._v("\n              Resten lægges oven i personens nuværende timer på brikken. Personer, der ikke har brikken, får den tilføjet.\n            ")])])]], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    attrs: {
	      "disabled": _vm.isSaving
	    },
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSaving
	    },
	    attrs: {
	      "disabled": !_vm.canSubmit
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n        Overfør til " + _vm._s(_vm.selectedUsers.length) + " " + _vm._s(_vm.selectedUsers.length === 1 ? 'person' : 'personer') + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1974 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "pricing-container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "pricing-container__right"
	  }, [_c('h2', [_vm._v("En stærk samlet pakke til jeres skole")]), _vm._v(" "), _c('ul', {
	    staticClass: "pricing-features"
	  }, [_vm._l((_vm.features), function(feature) {
	    return _c('li', [_c('span', {
	      staticClass: "icon-checkmark4 color-blue"
	    }), _vm._v(" " + _vm._s(feature))])
	  }), _vm._v(" "), _c('li', [_vm._v("... og meget mere")])], 2), _vm._v(" "), _c('h4', [_vm._v("Betaling hver måned eller årligt")]), _vm._v(" "), _c('p', [_vm._v("I bestemmer selv, om I vil faktureres hver måned eller hvert år")]), _vm._v(" "), _c('h4', [_vm._v("Prøv gratis i 30 dage")]), _vm._v(" "), _c('p', [_vm._v("Du kan prøve Docendo i 30 dage helt gratis. Du binder dig ikke til at købe systemet, og vi beder ikke\n        om dine kontooplysninger.\n        Efter 30 dage bestemmer du selv, om du vil fortsætte med Docendo.\n      ")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pricing-container__left"
	  }, [_c('div', {
	    staticClass: "pricing-box"
	  }, [_c('h2', [_vm._v("Skolens samlede elevtal")]), _vm._v(" "), _c('p', [_vm._v("Betal for skolens samlede elevtal - og få et ubegrænset antal brugere på")]), _vm._v(" "), _c('h3', [_vm._v("5"), _c('span', {
	    staticClass: "text-grey",
	    staticStyle: {
	      "font-size": "16px"
	    }
	  }, [_vm._v("kr")])]), _vm._v(" "), _c('p', [_vm._v("pr. elev / måned\n          ")]), _c('p', [_vm._v("+ 499 kr pr. måned i licens pr. institution"), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "font-small"
	  }, [_vm._v("Alle priser er eksklusiv moms")])]), _vm._v(" "), _c('p')])])
	}]}

/***/ }),
/* 1975 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "do-table do-table__user-employments",
	    class: {
	      'do-table__user-employments--import': _vm.isSalaryIntegrationActive
	    }
	  }, [_c('thead', [_c('th', {
	    staticClass: "th-check",
	    attrs: {
	      "title": _vm.selectedEmploymentIds.length === 0 ? _vm.$t('vue2.tagging.select_all') : _vm.$t('vue2.tagging.unselect_all')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('toggleAllEmployments')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "check-wrapper"
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox",
	      "readonly": ""
	    },
	    domProps: {
	      "checked": _vm.isAllVisibleSelected,
	      "indeterminate": _vm.isIndeterminateVisible
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  })])]), _vm._v(" "), _c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', [_vm._v("CPR")]), _vm._v(" "), _c('th', [_vm._v("Ansættelse")]), _vm._v(" "), _c('th', [_vm._v("Periode")]), _vm._v(" "), _c('th', {
	    staticClass: "td-percent"
	  }, [_vm._v("Beskæftigelse")]), _vm._v(" "), _c('th', [_vm._v("Organisation")]), _vm._v(" "), _c('th', [_vm._v("Stillingskategori")]), _vm._v(" "), _c('th', {
	    staticClass: "td-subsalary"
	  }, [_vm._v("Vikarløn")]), _vm._v(" "), _c('th', [_vm._v("Std. Lønkode")]), _vm._v(" "), _c('th', [_vm._v("Std. Omkostningsted")]), _vm._v(" "), (_vm.rowActionLabel) ? _c('th', {
	    staticClass: "th-row-actions"
	  }) : _vm._e()]), _vm._v(" "), _c('tbody', {
	    ref: "d-b"
	  }, [_vm._l((_vm.filteredUsers), function(user) {
	    return (_vm.isSalaryIntegrationActive) ? [_c('tbody', {
	      key: 'user-' + user.id,
	      staticClass: "user-group"
	    }, [_vm._l((user.v_employments), function(employment) {
	      return _c('tr', {
	        key: 'employment-' + employment.id
	      }, [_c('td', {
	        staticClass: "td-check",
	        attrs: {
	          "title": "Vælg/fravælg ansættelse"
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.$emit('toggleEmployment', employment)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "check-wrapper"
	      }, [_c('input', {
	        attrs: {
	          "type": "checkbox",
	          "readonly": ""
	        },
	        domProps: {
	          "checked": _vm.isEmploymentSelected(employment.id)
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	          }
	        }
	      })])]), _vm._v(" "), _c('td', {
	        class: {
	          'td-organisation': !_vm.hasStillingskategori(employment)
	        }
	      }, [_c('div', {
	        staticClass: "name-cell"
	      }, [_c('strong', [_vm._v(_vm._s(user.name))])])]), _vm._v(" "), _c('td', {
	        staticClass: "td-ssn",
	        class: {
	          'td-organisation': !!user.ssn
	        }
	      }, [(user.ssn) ? _c('span', [_vm._v(_vm._s(_vm.formatSsn(user.ssn)))]) : _c('span', {
	        staticClass: "text-link",
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.$emit('editSsn', user)
	          }
	        }
	      }, [_vm._v("Indtast CPR")])]), _vm._v(" "), _c('td', {
	        staticClass: "td-organisation"
	      }, [(_vm.isShowEmploymentNumber) ? [_vm._v(_vm._s(employment.employment_number) + " -")] : _vm._e(), _vm._v("\n        " + _vm._s(employment.source_title ? employment.source_title : employment.title) + "\n      ")], 2), _vm._v(" "), _c('td', {
	        staticClass: "td-organisation td-period"
	      }, [_vm._v(_vm._s(_vm.formatEmploymentPeriod(employment)))]), _vm._v(" "), _c('td', {
	        staticClass: "td-organisation td-percent"
	      }, [_vm._v(_vm._s(_vm.formatEmploymentPercent(employment.employment_percent)))]), _vm._v(" "), _c('td', {
	        staticClass: "td-organisation"
	      }, [_vm._v(_vm._s(employment.organisation))]), _vm._v(" "), _c('td', [(_vm.hasStillingskategori(employment)) ? _c('span', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: (_vm.isStillingskategoriFromOtherSchool(employment) ? {
	            arrow: true,
	            animateFill: false,
	            animation: 'shift-away',
	            zIndex: '999999992',
	            boundary: 'window'
	          } : {
	            trigger: 'manual'
	          }),
	          expression: "isStillingskategoriFromOtherSchool(employment) ? {\n                    arrow: true,\n                    animateFill: false,\n                    animation: 'shift-away',\n                    zIndex: '999999992',\n                    boundary: 'window'\n                  } : { trigger: 'manual' }"
	        }],
	        staticClass: "d-tag d-tag--inline",
	        class: {
	          'd-tag--from-other-school': _vm.isStillingskategoriFromOtherSchool(employment),
	          'd-tag--inline--clickable': !_vm.isStillingskategoriFromOtherSchool(employment)
	        },
	        attrs: {
	          "content": _vm.isStillingskategoriFromOtherSchool(employment) ? 'Kommer fra anden skole' : null
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.onStillingskategoriClick(user, employment)
	          }
	        }
	      }, [_vm._v("\n              " + _vm._s(employment.title) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	        staticClass: "td-subsalary"
	      }, [(_vm.showEmploymentSalaryFields(employment)) ? _c('span', {
	        staticClass: "do-pill do-pill--small do-custom-pill do-pill--yellow"
	      }, [_vm._v("Vikarløn\n          ")]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.showEmploymentSalaryFields(employment)) ? _c('span', {
	        staticClass: "do-pill do-pill--small do-custom-pill do-pill--multiline"
	      }, [_vm._v("\n          " + _vm._s(_vm.getDefaultSalaryCodeName(employment.salary_code_id)) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.showEmploymentSalaryFields(employment) && employment.default_omkostningssted) ? _c('span', {
	        staticClass: "do-pill do-pill--small do-custom-pill do-pill--multiline"
	      }, [_vm._v("\n          " + _vm._s(_vm.getCostCenterName(employment.default_omkostningssted)) + "\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.rowActionLabel) ? _c('td', {
	        staticClass: "td-row-actions"
	      }, [_c('div', {
	        staticClass: "row-action-btns"
	      }, [_c('button', {
	        staticClass: "row-action-btn",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.$emit('removeEmployment', {
	              user: user,
	              employment: employment
	            })
	          }
	        }
	      }, [_vm._v("Fjern ansættelse")]), _vm._v(" "), (user.ssn) ? _c('button', {
	        staticClass: "row-action-btn",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.setTheEditUser(user)
	          }
	        }
	      }, [_vm._v("Opret ny ansættelse")]) : _vm._e()])]) : _vm._e()])
	    }), _vm._v(" "), (user.v_employments.length === 0) ? _c('tr', {
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setTheEditUser(user)
	        }
	      }
	    }, [_c('td', {
	      staticClass: "td-check"
	    }), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "name-cell"
	    }, [_c('b', [_vm._v(_vm._s(user.name))])])]), _vm._v(" "), _c('td', {
	      staticClass: "td-ssn",
	      class: {
	        'td-organisation': !!user.ssn
	      }
	    }, [(user.ssn) ? _c('span', [_vm._v(_vm._s(_vm.formatSsn(user.ssn)))]) : _c('span', {
	      staticClass: "text-link",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.$emit('editSsn', user)
	        }
	      }
	    }, [_vm._v("Indtast CPR")])]), _vm._v(" "), _c('td', [(_vm.rowActionLabel && user.ssn) ? _c('span', {
	      staticClass: "text-link",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setTheEditUser(user)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.rowActionLabel))]) : _vm._e()]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	      staticClass: "td-percent"
	    }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	      staticClass: "td-subsalary"
	    }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), (_vm.rowActionLabel) ? _c('td', {
	      staticClass: "td-row-actions"
	    }) : _vm._e()]) : _vm._e()], 2)] : _vm._l((_vm.filteredUsers), function(user) {
	      return _c('tr', {
	        key: user.id
	      }, [_c('td', {
	        attrs: {
	          "colspan": "1"
	        }
	      }), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
	        staticClass: "d-tags",
	        attrs: {
	          "colspan": "6"
	        }
	      }, [_vm._l((user.v_employments), function(employment) {
	        return _c('div', {
	          key: employment.id,
	          staticClass: "d-tag",
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.$emit('toggleEmployment', employment)
	            }
	          }
	        }, [_c('input', {
	          staticClass: "td-check__inline",
	          attrs: {
	            "type": "checkbox",
	            "readonly": ""
	          },
	          domProps: {
	            "checked": _vm.isEmploymentSelected(employment.id)
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	            }
	          }
	        }), _vm._v("\n          " + _vm._s(employment.title) + "\n          "), (employment.organisation) ? _c('div', {
	          staticClass: "d-tag d-tag--inner"
	        }, [_vm._v(_vm._s(employment.organisation))]) : _vm._e(), _vm._v(" "), (employment.manual_salary) ? _c('div', {
	          staticClass: "do-pill do-pill--small do-pill--yellow"
	        }, [_vm._v("Vikarløn")]) : _vm._e()])
	      }), _vm._v(" "), (user.v_employments.length === 0 && _vm.isShowNoEmploymentsText) ? _c('p', {
	        staticClass: "italic font-small"
	      }, [_vm._v("Ingen\n          ansættelser")]) : _vm._e()], 2)])
	    })
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1976 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DSelect', {
	    attrs: {
	      "items": _vm.itemsFiltered,
	      "show": _vm.show,
	      "itemsSelected": _vm.itemsSelected,
	      "placeholder": _vm.placeholder,
	      "isDeleteAllAnOption": false
	    },
	    on: {
	      "update": _vm.update,
	      "multiPaste": _vm.onMultiPaste,
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('h4', {
	    attrs: {
	      "slot": "noMatch"
	    },
	    slot: "noMatch"
	  }, [_vm._v("En person må have max seks kompetencer")])])
	},staticRenderFns: []}

/***/ }),
/* 1977 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cost-centers",
	    class: {
	      'cost-centers-container': _vm.isInSchoolSalarySettings
	    }
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": _vm.isInSchoolSalarySettings ? '#edf0f5' : '#fff'
	    }
	  }) : [_c('table', {
	    staticClass: "do-table do-table__items do-table--striped"
	  }, [_c('thead', [_c('th', [_vm._v("Kode")]), _vm._v(" "), _c('th', [_vm._v("Omkostningssted")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "60%"
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": function($event) {
	        return _vm.setIsCreateItemModal(true)
	      }
	    }
	  }, [_vm._v("\n          Opret omkostningssted\n        ")])])]), _vm._v(" "), _c('tbody', [(_vm.costCenters.length === 0) ? _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_c('i', [_vm._v("Ingen oprettet")])]), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.costCenters), function(cc) {
	    return _c('CostCentersCenter', {
	      key: cc.id,
	      attrs: {
	        "item": cc,
	        "calendars": _vm.calendars,
	        "calendarNames": _vm.calendarNames,
	        "initialSelectedCalendarIds": _vm.getInitialIdsFor(cc.id),
	        "isInSchoolSalarySettings": _vm.isInSchoolSalarySettings,
	        "isUpdating": _vm.updatingCostCenterId === cc.id
	      },
	      on: {
	        "save": _vm.onSaveRule,
	        "archive": _vm.archiveCostCenter
	      }
	    })
	  })], 2)]), _vm._v(" "), (_vm.archivedCostCenters.length > 0) ? _c('p', {
	    staticClass: "text-link marg-1-top",
	    on: {
	      "click": function($event) {
	        _vm.isShowArchived = !_vm.isShowArchived
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.isShowArchived ? 'Skjul arkiverede' : 'Vis arkiverede') + "\n      " + _vm._s('(' + _vm.archivedCostCenters.length + ')') + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isShowArchived && _vm.archivedCostCenters.length > 0) ? _c('table', {
	    staticClass: "do-table do-table__items do-table--striped marg-1-top"
	  }, [_c('thead', [_c('th', [_vm._v("Kode")]), _vm._v(" "), _c('th', [_vm._v("Omkostningssted")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "60%"
	    }
	  })]), _vm._v(" "), _c('tbody', _vm._l((_vm.archivedCostCenters), function(cc) {
	    return _c('CostCentersCenter', {
	      key: cc.id,
	      attrs: {
	        "item": cc,
	        "calendars": _vm.calendars,
	        "calendarNames": _vm.calendarNames,
	        "initialSelectedCalendarIds": _vm.getInitialIdsFor(cc.id),
	        "isInSchoolSalarySettings": _vm.isInSchoolSalarySettings,
	        "isUpdating": _vm.updatingCostCenterId === cc.id
	      },
	      on: {
	        "save": _vm.onSaveRule,
	        "archive": _vm.archiveCostCenter
	      }
	    })
	  }), 1)]) : _vm._e()], _vm._v(" "), (_vm.isCreateItemModal) ? _c('TableCreateModal', {
	    attrs: {
	      "theType": 'omkostningssteder',
	      "theEditItem": _vm.theEditItem,
	      "isSubmitting": _vm.isSubmitting,
	      "isDeleting": _vm.isDeleting
	    },
	    on: {
	      "onSubmit": _vm.onCreate,
	      "close": _vm.setIsCreateItemModal
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1978 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isSubmitButtonLoading": _vm.isCancellingLesson,
	      "isShowConfirmDeleteMessage": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      },
	      "confirm": _vm.onConfirmCancelLesson
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "custom_warning"
	    },
	    slot: "custom_warning"
	  }, [(!_vm.isCanceled) ? [_c('h4', [_vm._v(_vm._s(_vm.i18n.confirm_cancel_title))]), _vm._v(" "), _c('p', {
	    staticClass: "pad-1 italic pad-0-top"
	  }, [_vm._v(_vm._s(_vm.i18n.confirm_cancel_text))])] : [_c('h4', [_vm._v(_vm._s(_vm.i18n.confirm_uncancel_title))]), _vm._v(" "), _c('p', {
	    staticClass: "pad-1 italic"
	  }, [_vm._v(_vm._s(_vm.i18n.confirm_uncancel_text))])]], 2), _vm._v(" "), _c('p', {
	    attrs: {
	      "slot": "confirmText"
	    },
	    slot: "confirmText"
	  }, [_vm._v(_vm._s(!_vm.isCanceled ? _vm.i18n.cancel_event : _vm.i18n.uncancel_event))])])
	},staticRenderFns: []}

/***/ }),
/* 1979 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.visibleCategories.length > 0) ? _c('table', {
	    staticClass: "d-table marg-1-bottom d-table__overview"
	  }, [_c('thead', [_c('tr', [_vm._m(0), _vm._v(" "), _c('th', {
	    staticClass: "is-number",
	    staticStyle: {
	      "width": "70%"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.visibleCategories), function(taskCategory) {
	    return _c('UserTasksOverviewOwnPoolsPool', {
	      attrs: {
	        "taskCategory": taskCategory,
	        "isShowScheduled": _vm.isShowScheduled,
	        "is-date-interval-changed": _vm.isDateIntervalChanged
	      }
	    })
	  }), 1)]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', [_c('h4', [_vm._v("Puljer")])])
	}]}

/***/ }),
/* 1980 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "log"
	  }, [(_vm.isLoading) ? _c('Spinner', {
	    staticStyle: {
	      "padding-bottom": "50px"
	    },
	    attrs: {
	      "color": "blue"
	    }
	  }) : _c('div', {
	    staticClass: "log-list"
	  }, [(_vm.sortedActivities.length < 1) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].there_is_no_logged_activity))]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.packedActivities), function(activity) {
	    return _c('li', {
	      key: activity.at,
	      staticClass: "activity"
	    }, [_c('div', {
	      staticClass: "activity__headline"
	    }, [(_vm.usersHash[activity.by.id]) ? _c('div', {
	      staticClass: "user"
	    }, [_c('img', {
	      attrs: {
	        "src": _vm.getUserImg(activity),
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.getUserName(activity)))])]) : _vm._e(), _vm._v(" "), _c('p', {
	      staticClass: "activity__headline__timestamp hint--top-left",
	      attrs: {
	        "aria-label": _vm.formatDate(activity.at)
	      }
	    }, [_vm._v("\n            " + _vm._s(_vm.getDuration(activity.at)) + " " + _vm._s(_vm.i18n[_vm.locale].ago) + "\n          ")])]), _vm._v(" "), _c('ul', {
	      staticClass: "activity-changes"
	    }, _vm._l((activity.changes), function(change) {
	      return _c('li', {
	        key: change.at,
	        staticClass: "activity-changes__change"
	      }, [_c('div', {
	        domProps: {
	          "innerHTML": _vm._s(_vm.humanizeChange(change))
	        }
	      })])
	    }), 0)])
	  }), 0)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1981 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "public-app"
	  }, [(_vm.isMobile) ? _c('app', {
	    attrs: {
	      "calId": _vm.calId,
	      "viewState": _vm.viewState,
	      "schoolName": _vm.schoolName,
	      "calName": _vm.calName,
	      "i18n": _vm.i18n
	    },
	    on: {
	      "setLocale": _vm.setLocale,
	      "eventClick": _vm.setActiveEvent
	    }
	  }) : [(_vm.view === 'desktop') ? _c('desktop', {
	    attrs: {
	      "calId": _vm.calId,
	      "schoolName": _vm.schoolName,
	      "viewState": _vm.viewState,
	      "i18n": _vm.i18n
	    },
	    on: {
	      "eventClick": _vm.setActiveEvent,
	      "setLocale": _vm.setLocale
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.view === 'smartscreen') ? _c('desktopVue', {
	    attrs: {
	      "calendarId": _vm.calId,
	      "calendar": _vm.calendar
	    }
	  }) : _vm._e()], _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "aniZoomIn"
	    }
	  }, [(_vm.activeEvent !== null) ? _c('show-event', {
	    attrs: {
	      "locale": _vm.locale,
	      "event": _vm.activeEvent,
	      "i18n": _vm.i18n
	    },
	    on: {
	      "close": function($event) {
	        _vm.activeEvent = null
	      }
	    }
	  }) : _vm._e()], 1)], 2)
	},staticRenderFns: []}

/***/ }),
/* 1982 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "resume"
	  }, [_c('table', {
	    staticClass: "d-table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.personale), function(persona) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(persona.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(persona.numberOfMales))])])
	  }), 0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Stillingstype")]), _vm._v(" "), _c('th', [_vm._v("Alder")])])])
	}]}

/***/ }),
/* 1983 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window'
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
	    }],
	    staticClass: "icon__bg-circle",
	    class: {
	      'icon__bg-circle--active': _vm.isPrioritizerActive
	    },
	    attrs: {
	      "content": _vm.$t('vue2.sub_scheduler.set_priorities')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setIsPrioritizerActive(true)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cog2"
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInLeft"
	    }
	  }, [(_vm.isPrioritizerActive) ? _c('div', {
	    staticClass: "sub-scheduler__filters__subzen__priorities"
	  }, [_c('div', {
	    staticClass: "sub-scheduler__filters__subzen__priorities__header"
	  }, [_c('h3', [_vm._v("\n          " + _vm._s(_vm.$t('vue2.sub_scheduler.set_priorities')) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle sub-scheduler__filters__subzen__priorities__close",
	    on: {
	      "click": function($event) {
	        return _vm.setIsPrioritizerActive(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), (_vm.isEditable) ? _c('div', {
	    staticClass: "pad-10-bottom"
	  }, [_c('draggable', {
	    on: {
	      "change": _vm.onChange
	    },
	    model: {
	      value: (_vm.list),
	      callback: function($$v) {
	        _vm.list = $$v
	      },
	      expression: "list"
	    }
	  }, [_c('transition-group', {
	    attrs: {
	      "type": "transition",
	      "name": "flip-list"
	    }
	  }, _vm._l((_vm.list), function(element, key) {
	    return _c('div', {
	      key: element[0],
	      staticClass: "sub-scheduler__filters__subzen__priorities__priority"
	    }, [_c('div', {
	      staticClass: "sub-scheduler__filters__subzen__priorities__priority__number"
	    }, [_vm._v(_vm._s(key + 1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getItemTitle(element[0])))])])
	  }), 0)], 1)], 1) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "border-1-top sub-scheduler__unAvailableItems"
	  }, _vm._l((_vm.unAvailableItems), function(item, key) {
	    return _c('li', {
	      staticClass: "sub-scheduler__filters__subzen__priorities__priority sub-scheduler__filters__subzen__priorities__priority--not-moveable"
	    }, [_c('div', {
	      staticClass: "sub-scheduler__filters__subzen__priorities__priority__number"
	    }, [_vm._v(_vm._s(_vm.list.length + 1 + key))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getItemTitle(item[0])))])])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "sub-scheduler__filters__subzen__priorities__footer pad-10-bottom"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isPrioritizerActive = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.presence.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-primary marg-10-left",
	    class: {
	      'bttn-primary--disabled': !_vm.isChangeHasBeenMade
	    },
	    on: {
	      "click": _vm.onSave
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.presence.save')) + "\n        ")])])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1984 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "omni-chat no-print"
	  }, [_c('div', {
	    staticClass: "omni-chat__button",
	    on: {
	      "click": _vm.setOpenChat
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "scaleIn",
	      "mode": "out-in"
	    }
	  }, [(!_vm.isShowChat) ? _c('svg', {
	    key: "chatClosed",
	    staticClass: "icon-chat-group-alt tw-icon--small",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('rect', {
	    staticClass: "secondary",
	    attrs: {
	      "width": "16",
	      "height": "13",
	      "x": "2",
	      "y": "2",
	      "rx": "2"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M6 16V8c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v13a1 1 0 0 1-1.7.7L16.58 18H8a2 2 0 0 1-2-2z"
	    }
	  })]) : _c('svg', {
	    key: "chatOpen",
	    staticClass: "tw-icon--small icon-close",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "fill-rule": "evenodd",
	      "d": "M15.78 14.36a1 1 0 0 1-1.42 1.42l-2.82-2.83-2.83 2.83a1 1 0 1 1-1.42-1.42l2.83-2.82L7.3 8.7a1 1 0 0 1 1.42-1.42l2.83 2.83 2.82-2.83a1 1 0 0 1 1.42 1.42l-2.83 2.83 2.83 2.82z"
	    }
	  })])])], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "chatFadeIn"
	    }
	  }, [(_vm.isShowChat) ? _c('div', {
	    staticClass: "omni-chat__container"
	  }, [_c('div', [_c('div', {
	    staticClass: "omni-chat__container__header"
	  }, [_c('div', {
	    staticClass: "omni-chat__logo"
	  }, [_c('span', {
	    staticClass: "icon-docendo"
	  })]), _vm._v(" "), _c('h1', [_vm._v("Hej 👋")]), _vm._v(" "), _c('p', [_vm._v("Vi er dit Docendo-team. Vi står klar til at svare på dine spørgsmål :)")])]), _vm._v(" "), _c('div', {
	    staticClass: "omni-chat__container__body"
	  }, [_c('div', {
	    staticClass: "omni-chat__container__body__box"
	  }, [_c('h4', [_vm._v("Skriv en email eller ring til os")]), _vm._v(" "), _c('div', {
	    staticClass: "customer-support__imgs"
	  }, [_c('img', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom',
	        zIndex: 2147483010
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  zIndex: 2147483010\n                }"
	    }],
	    attrs: {
	      "src": _vm.anne,
	      "alt": "Anne",
	      "content": "Anne"
	    }
	  }), _vm._v(" "), _c('img', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom',
	        zIndex: 2147483010
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  zIndex: 2147483010\n                }"
	    }],
	    attrs: {
	      "src": _vm.henrik,
	      "alt": "Henrik",
	      "content": "Henrik"
	    }
	  }), _vm._v(" "), _c('img', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom',
	        zIndex: 2147483010
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  zIndex: 2147483010\n                }"
	    }],
	    attrs: {
	      "src": _vm.jeppe,
	      "alt": "Jeppe",
	      "content": "Jeppe"
	    }
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
	    staticClass: "support-options"
	  }, [_c('li', [_c('span', {
	    staticClass: "icon-question3"
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://help.docendo.dk/da"
	    }
	  }, [_vm._v("Se supportforum")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "icon-envelop"
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "mailto:kontakt@docendo.dk"
	    }
	  }, [_vm._v("kontakt@docendo.dk")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "icon-phone2"
	  }), _vm._v(" +45 43 31 06 12")])]), _vm._v(" "), _c('a', {
	    staticClass: "bttn bttn--primary bttn--primary--chat",
	    attrs: {
	      "target": "_blank",
	      "href": "mailto:kontakt@docendo.dk?subject=Supporthenvendelse"
	    }
	  }, [_vm._v("Send os en email")]), _vm._v(" "), _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Chatsupport vender snart tilbage. Du kan altid sende os en email eller ringe, hvis du har spørgsmål.")])])])])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1985 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "scheduler_user",
	    style: ({
	      'min-height': 40 * _vm.rows + 'px'
	    })
	  }, [_vm._l((_vm.correctEvents), function(event) {
	    return _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          zIndex: 123123123123,
	          onShow: function () { return event.obj.v_has_teachers; }
	        }),
	        expression: "{\n                  arrow: true,\n                  zIndex: 123123123123,\n                  onShow: () => event.obj.v_has_teachers\n                }"
	      }],
	      key: event.obj.id,
	      ref: _vm.calEvent,
	      refInFor: true,
	      staticClass: "day-cal__event day-cal__event__lesson",
	      style: ([{
	          'top': event.row * 26 + 'px'
	        },
	        {
	          'left': event.left + 'px'
	        },
	        {
	          'right': event.right + 'px'
	        },
	        {
	          'height': '25px'
	        }
	      ]),
	      attrs: {
	        "content": event.obj.v_user_names,
	        "aria-label": event.othersOnLesson
	      }
	    }, [_c('div', {
	      staticClass: "day-cal__event__content"
	    }, [_c('div', {
	      staticClass: "day-cal__event__content__title"
	    }, [_c('span', {
	      staticClass: "nowrap day-cal__event__content__title__title"
	    }, [_vm._v(_vm._s(event.obj.title))]), _vm._v(" "), (event.obj.v_groups.length > 0) ? _c('span', {
	      staticClass: "nowrap day-cal__event__content__title__grade"
	    }, [_vm._v(_vm._s(event.obj.v_group_names))]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "day-cal__event__bg",
	      style: ({
	        backgroundColor: event.obj.color ? event.obj.color : '#ccc'
	      })
	    }), _vm._v(" "), _c('div', {
	      staticClass: "day-cal__event__sider",
	      style: ({
	        backgroundColor: event.obj.color ? event.obj.color : '#ccc'
	      })
	    })])])
	  }), _vm._v(" "), _vm._l((_vm.userPresenceForPlacing), function(presence) {
	    return _c('div', {
	      key: presence.obj.id,
	      staticClass: "day-cal__event work_hours",
	      style: ([{
	          'left': presence.left + 'px'
	        },
	        {
	          'right': presence.right + 'px'
	        }
	      ])
	    })
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 1986 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "scheduler"
	  }, [(_vm.activeUser !== null) ? _c('SchedulerSubsSubstituteHours', {
	    attrs: {
	      "item": _vm.activeUser,
	      "itemBCR": _vm.activeUserBCR
	    }
	  }) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "scheduler__header"
	  }, [_c('li', [_c('b', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "scroll",
	      rawName: "v-scroll",
	      value: (_vm.handleScrollTop),
	      expression: "handleScrollTop"
	    }],
	    ref: "topDiv",
	    staticClass: "do-scroller do-scroller--hide"
	  }, [_c('ul', {
	    staticClass: "scheduler__header__times"
	  }, _vm._l((_vm.hoursInLocale), function(number) {
	    return _c('li', [_vm._v(_vm._s(_vm.$filters.LT(number)))])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "scheduler__container",
	    class: {
	      'scheduler__container--loading': _vm.dataIsLoading
	    }
	  }, [(_vm.dataIsLoading) ? _c('div', {
	    staticClass: "scheduler__container__loader"
	  }, [_c('Loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "do-scroller__container"
	  }, [_c('div', {
	    directives: [{
	      name: "scroll",
	      rawName: "v-scroll",
	      value: (_vm.handleScrollLeft),
	      expression: "handleScrollLeft"
	    }],
	    ref: "leftDiv",
	    staticClass: "do-scroller do-scroller-max-height do-scroller--hide do-scroller__users",
	    style: ({
	      maxHeight: _vm.schedulerMaxHeight + 'px',
	      paddingBottom: _vm.isVerticalScrollbar ? '15px' : '0px'
	    })
	  }, [_c('ul', {
	    staticClass: "scheduler__users"
	  }, _vm._l((_vm.items), function(item, idx) {
	    return _c('li', {
	      key: item.id,
	      class: {
	        'item-is-headline': item.headline
	      },
	      style: ({
	        'height': _vm.getUserRowHeight(item)
	      })
	    }, [(item.headline) ? _c('div', {
	      staticClass: "scheduler__users__headline"
	    }, [_c('div', {
	      staticClass: "scheduler__users__user__name"
	    }, [_vm._v(_vm._s(_vm.subsTitle))]), _vm._v(" "), _c('div', {
	      staticClass: "scheduler__users__user__subpools scheduler__users__user__subpools__title"
	    }, [_vm._v("\n                " + _vm._s(_vm.$t('vue2.sub_scheduler.pool')) + "\n              ")])]) : _c('div', {
	      staticClass: "scheduler__users__user",
	      class: [{
	          'scheduler__users__user--absence-autogenerated': _vm.isAbsenceAutoGenerated(item)
	        },
	        {
	          'scheduler__users__user--not-absent': item.dayAbsence.length < 1
	        }
	      ]
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: false,
	          animateFill: false,
	          placement: 'right',
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return item.dayAbsence.length < 1; }
	        }),
	        expression: "{\n              arrow: false,\n              animateFill: false,\n              placement: 'right',\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => item.dayAbsence.length < 1\n            }"
	      }],
	      staticClass: "scheduler__users__user__name",
	      attrs: {
	        "title": _vm.i18n.create_activity
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setCreateEventOnUserOnNotAbsentUser(item)
	        }
	      }
	    }, [_vm._v("\n                " + _vm._s(item.name) + "\n                "), (_vm.isAbsenceAutoGenerated(item)) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: "right",
	          animation: "fade"
	        }),
	        expression: "{ arrow: true, placement : \"right\", animation : \"fade\" }"
	      }],
	      staticClass: "absence-generated-sign",
	      attrs: {
	        "title": _vm.i18n.auto_created
	      }
	    }, [_c('svg', {
	      staticClass: "tw-icon tw-icon-important",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24"
	      }
	    }, [_c('path', {
	      staticClass: "primary",
	      attrs: {
	        "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
	      }
	    }), _vm._v(" "), _c('path', {
	      staticClass: "secondary",
	      attrs: {
	        "d": "M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
	      }
	    })])]) : _vm._e(), _vm._v(" "), (item.dayAbsence.length > 0) ? _c('DDropdown', [_c('ul', {
	      staticStyle: {
	        "width": "180px"
	      },
	      attrs: {
	        "slot": "list"
	      },
	      slot: "list"
	    }, [_c('li', [_c('a', {
	      staticClass: "marg-5-left text-link",
	      attrs: {
	        "href": '/calendars/' + item.user_calendar_id,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(_vm.i18n.go_to_calendar))])]), _vm._v(" "), _c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.setActiveAbsentUser(item)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n.add_sub_to_multiple_lessons))]), _vm._v(" "), _c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.setCreateEventOnUser(item)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n.create_activity))])])]) : _vm._e()], 1), _vm._v(" "), (item.dayAbsence.length === 0) ? _c('div', {
	      staticClass: "scheduler__users__user__subpools cursor-help",
	      on: {
	        "mouseenter": function($event) {
	          return _vm.setActiveUser(item, $event)
	        },
	        "mouseleave": function($event) {
	          _vm.activeUser = null
	        }
	      }
	    }, [_vm._v("\n                " + _vm._s(_vm._f("round")(item.subPoolsDiff)) + "\n              ")]) : _c('div', {
	      ref: 'absence_status_dropdown__parent___' + item.id,
	      refInFor: true,
	      staticClass: "scheduler__users__user__handled",
	      class: {
	        'scheduler__users__user__handled--loading': _vm.getIsUserHandlerLoading(item.id)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheAbsentUserHandledDropdown(item)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "scheduler__users__user__handled__handler",
	      class: _vm.schedulerUserHandledCls(item)
	    })])])])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "scheduler__cal"
	  }, [_c('div', {
	    staticClass: "do-scroller__container"
	  }, [_c('div', {
	    directives: [{
	      name: "scroll",
	      rawName: "v-scroll",
	      value: (_vm.handleScrollRight),
	      expression: "handleScrollRight"
	    }],
	    ref: "rightDiv",
	    staticClass: "do-scroller do-scroller-max-height do-scroller--hide",
	    style: ({
	      maxHeight: _vm.schedulerMaxHeight + 'px'
	    })
	  }, [_c('ul', {
	    staticClass: "scheduler__cal__ress"
	  }, [_c('ul', {
	    staticClass: "scheduler__cal__ress__items"
	  }, _vm._l((_vm.items), function(user) {
	    return _c('SchedulerItem', {
	      key: user.id,
	      attrs: {
	        "user": user,
	        "locale": _vm.locale,
	        "allEvents": _vm.allEvents,
	        "isSubStatusPendingActive": _vm.isSubStatusPendingActive,
	        "allCalendarsInHash": _vm.allCalendarsInHash,
	        "longAbsentListInHash": _vm.longAbsentListInHash,
	        "activeEvents": _vm.activeEvents,
	        "isActiveEventsLoading": _vm.isActiveEventsLoading,
	        "theActiveEventsLoadingOnCalendarId": _vm.theActiveEventsLoadingOnCalendarId,
	        "isHideEventsNotOverlappingAbsence": _vm.isHideEventsNotOverlappingAbsence,
	        "selectedEventTitleFilters": _vm.selectedEventTitleFilters,
	        "selectedQuickFilters": _vm.selectedQuickFilters,
	        "selectedClassFilters": _vm.selectedClassFilters,
	        "selectedGroupFilters": _vm.selectedGroupFilters
	      },
	      on: {
	        "onChooseSubType": _vm.onChooseSubType,
	        "rows": function($event) {
	          return _vm.setRows($event, user.id)
	        }
	      }
	    })
	  }), 1), _vm._v(" "), _c('ul', {
	    staticClass: "scheduler__cal__timeslots"
	  }, _vm._l((_vm.hoursInLocale.length * 2), function(n) {
	    return _c('li')
	  }), 0), _vm._v(" "), (_vm.activeEvents.length < 1) ? _c('SchedulerRulers') : _vm._e(), _vm._v(" "), _vm._l((_vm.activeEvents), function(event) {
	    return _c('SchedulerRulers', {
	      attrs: {
	        "lesson": event
	      }
	    })
	  })], 2)]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "zoomIn"
	    }
	  }, [((_vm.activeEvent && _vm.activeEvent.obj) || _vm.activeEvents.length > 0) ? _c('div', {
	    staticClass: "sub-popover"
	  }, [_c('div', {
	    staticClass: "icon__bg-circle close-cross",
	    on: {
	      "click": _vm.closePopover
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('SchedulerPopover', {
	    attrs: {
	      "activeEventId": _vm.activeEvent,
	      "user": _vm.schedulerUser,
	      "locale": _vm.locale,
	      "activeEvents": _vm.activeEvents,
	      "possibleSubs": _vm.items
	    },
	    on: {
	      "chooseSubType": _vm.onChooseSubType,
	      "removeSubs": _vm.removeSubs,
	      "clickaway": _vm.closePopover,
	      "close": _vm.closePopover,
	      "showLog": _vm.showLog,
	      "deleteEvent": _vm.setDeleteEvent,
	      "splitLesson": function($event) {
	        return _vm.$emit('splitLesson', $event)
	      },
	      "editTimes": function($event) {
	        return _vm.$emit('editTimes', $event)
	      },
	      "setTheOutOfSchoolLesson": function($event) {
	        return _vm.$emit('setTheOutOfSchoolLesson', $event)
	      },
	      "setIsCancelLesson": function($event) {
	        return _vm.$emit('setIsCancelLesson', $event)
	      }
	    }
	  })], 1) : _vm._e()])], 1)])]), _vm._v(" "), (_vm.theAbsentUserHandledDropdown !== null) ? _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeSubStatusDropdown),
	      expression: "closeSubStatusDropdown"
	    }],
	    ref: "absence_status_dropdown",
	    staticClass: "scheduler__users__user__handled__dropdown"
	  }, [_c('div', {
	    staticClass: "popper-arrow"
	  }), _vm._v(" "), _c('ul', {
	    staticClass: "scheduler__users__user__handled__absense__reasons"
	  }, _vm._l((_vm.theAbsentUserHandledDropdown.dayAbsence), function(absence) {
	    return _c('li', {
	      staticClass: "scheduler__users__user__handled__absense__reasons__reason"
	    }, [_c('h4', [_vm._v(_vm._s(_vm.getAbsenceTitle(absence)))]), _vm._v(" "), _c('ul', [_c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.setAbsenceStatus(_vm.theAbsentUserHandledDropdown, 0)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.not_handled')) + "\n          ")]), _vm._v(" "), _c('li', {
	      staticClass: "scheduler__users__user__handled__absense__reasons__reason--handled",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setAbsenceStatus(_vm.theAbsentUserHandledDropdown, 1)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.handled')) + "\n          ")])])])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.theTeacherOrSubObj) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "do-modal__choose-as-sub-or-teacher",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2'), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['should']) + " " + _vm._s(_vm.theSubName) + " " + _vm._s(_vm.i18n['be_appointed']) + "?")]), _vm._v(" "), (_vm.isLoadingEvent) ? _c('div', {
	    staticClass: "d-spinner__container"
	  }, [_c('div', {
	    staticClass: "do-spinner do-spinner--large"
	  })]) : [_c('button', {
	    staticClass: "do-bttn do-bttn__option",
	    class: {
	      'do-bttn--loading': _vm.isLoadingEvent
	    },
	    on: {
	      "click": _vm.setAsSub
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n['as_a_substitute']) + "\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn__option",
	    class: {
	      'do-bttn--loading': _vm.isLoadingEvent
	    },
	    on: {
	      "click": _vm.setAsTeacher
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n['as_a_teacher']) + "\n          ")])]], 2)])]) : _vm._e(), _vm._v(" "), (_vm.theDeleteEvent && !_vm.theDeleteEvent.away) ? _c('ModalConfirmation', {
	    attrs: {
	      "appendToBody": true
	    },
	    on: {
	      "close": function($event) {
	        _vm.theDeleteEvent = null
	      },
	      "confirm": _vm.deleteTheDeleteEvent
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theDeleteEvent && _vm.theDeleteEvent.away) ? _c('DModalDeleteAwayEvent', {
	    attrs: {
	      "event": _vm.theDeleteEvent,
	      "eventIdProp": 'id',
	      "appendToBody": true
	    },
	    on: {
	      "deleted": _vm.onAwayEventDeleted,
	      "close": function($event) {
	        _vm.theDeleteEvent = null
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1987 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "zen-import text-dark"
	  }, [_c('div', {
	    staticClass: "zen-hero-bg"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "zen-import-container"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.zen_import.import_from_zen')))]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
	    staticClass: "box"
	  }, [_c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  })], 1) : [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label d-label--white"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.choose_version')))]), _vm._v(" "), (_vm.schedules.length < 1) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.zen_import.you_have_no_created_any_versions')) + "\n        ")]) : _c('div', {
	    staticClass: "zen-schedules"
	  }, [_c('div', {
	    staticClass: "zen-schedule zen-schedule__header"
	  }, [_c('div', {
	    staticClass: "zen-schedule__left"
	  }), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.last_updated')))])])]), _vm._v(" "), _vm._l((_vm.schedules), function(schedule) {
	    return _c('div', {
	      key: schedule.scheduleUuid,
	      staticClass: "zen-schedule",
	      class: {
	        'zen-schedule--selected': _vm.isSelected(schedule.scheduleUuid)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveSchedule(schedule.scheduleUuid)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "zen-schedule__left"
	    }, [_c('div', {
	      staticClass: "d-radio",
	      class: {
	        'd-radio--selected': _vm.isSelected(schedule.scheduleUuid)
	      }
	    }), _vm._v(" "), _c('p', {
	      staticClass: "zen-schedule__title"
	    }, [_vm._v(_vm._s(schedule.title))])]), _vm._v(" "), _c('p', {
	      staticClass: "zen-schedule__modified"
	    }, [_c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'right'
	        }),
	        expression: "{\n                  arrow: true,\n                  placement : 'right'\n                }"
	      }],
	      staticClass: "zen-schedule__modified__date hint--right",
	      attrs: {
	        "content": _vm.showDate(schedule.modifiedAt)
	      }
	    }, [_vm._v(_vm._s(_vm.showHumanizeDate(schedule.modifiedAt)))])])])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.choose_schoolyear')))]), _vm._v(" "), _c('ChangeSchoolYear', {
	    staticStyle: {
	      "max-width": "210px"
	    },
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.insert_in_week')))]), _vm._v(" "), _c('DatePicker', {
	    attrs: {
	      "type": _vm.datepickerType,
	      "lang": _vm.datepickerLang,
	      "value-type": "YYYY-MM-DD",
	      "format": _vm.datepickerFormat
	    },
	    model: {
	      value: (_vm.theDate),
	      callback: function($$v) {
	        _vm.theDate = $$v
	      },
	      expression: "theDate"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [(_vm.schedules.length < 1) ? _c('button', {
	    staticClass: "bttn bttn--primary bttn--large bttn--primary--disabled"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.zen_import.insert_schedules')) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isSendingData && _vm.schedules.length > 0) ? _c('button', {
	    staticClass: "bttn bttn--primary bttn--large",
	    on: {
	      "click": _vm.submitSchudules
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.insert_schedules')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isSendingData) ? _c('button', {
	    staticClass: "bttn bttn--primary bttn--large bttn--loading"
	  }) : _vm._e()])], _vm._v(" "), _c('ZenImportChanges')], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1988 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "showClose": false,
	      "isBgOverlay": true,
	      "isCloseOnBgClick": false,
	      "appendToBody": true,
	      "placeInTop": true,
	      "autoFocusField": false,
	      "ariaLabel": "Fravær i KMD Opus"
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('div', [_c('h2', [_vm._v("Fravær i KMD Opus")]), _vm._v(" "), _c('p', {
	    staticClass: "d-modal__person"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.userName || 'Ukendt'))]), _vm._v(" "), (_vm.employmentLabel) ? _c('span', {
	    staticClass: "d-modal__person__employment"
	  }, [_vm._v("· " + _vm._s(_vm.employmentLabel))]) : _vm._e()]), _vm._v(" "), _c('p', {
	    staticClass: "d-modal__subtitle"
	  }, [_vm._v("\n          Viser fraværet, som det er registreret i KMD Opus lige nu. Data hentes direkte fra KMD, når vinduet åbnes, og når du klikker på Indlæs.\n        ")])]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), (_vm.transfer) ? _c('div', {
	    staticClass: "transfer-card"
	  }, [_c('div', {
	    staticClass: "transfer-card__title"
	  }, [_vm._v("Valgt indberetning")]), _vm._v(" "), _c('div', {
	    staticClass: "transfer-card__grid"
	  }, [_c('div', {
	    staticClass: "transfer-card__field"
	  }, [_c('span', {
	    staticClass: "transfer-card__label"
	  }, [_vm._v("Fraværstype")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.transferTypeText || 'Ukendt'))])]), _vm._v(" "), _c('div', {
	    staticClass: "transfer-card__field"
	  }, [_c('span', {
	    staticClass: "transfer-card__label"
	  }, [_vm._v("Startdato")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.transferStartLabel))])]), _vm._v(" "), _c('div', {
	    staticClass: "transfer-card__field"
	  }, [_c('span', {
	    staticClass: "transfer-card__label"
	  }, [_vm._v("Slutdato")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.transferEndLabel))])]), _vm._v(" "), _c('div', {
	    staticClass: "transfer-card__field"
	  }, [_c('span', {
	    staticClass: "transfer-card__label"
	  }, [_vm._v("Dage")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDecimal(_vm.transfer.absence_days)))])]), _vm._v(" "), _c('div', {
	    staticClass: "transfer-card__field"
	  }, [_c('span', {
	    staticClass: "transfer-card__label"
	  }, [_vm._v("Timer")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDecimal(_vm.transfer.absence_hours)))])]), _vm._v(" "), _c('div', {
	    staticClass: "transfer-card__field"
	  }, [_c('span', {
	    staticClass: "transfer-card__label"
	  }, [_vm._v("Status")]), _vm._v(" "), _c('span', [(_vm.transfer.state === 'error') ? _c('span', {
	    staticClass: "status-pill status-pill--error"
	  }, [_vm._v("Fejlet")]) : (_vm.transfer.state === 'ok') ? _c('span', {
	    staticClass: "status-pill status-pill--ok"
	  }, [_vm._v("Gennemført")]) : _c('span', {
	    staticClass: "status-pill status-pill--pending"
	  }, [_vm._v("Afventer")])])])]), _vm._v(" "), (_vm.transferMessages.length > 0) ? _c('div', {
	    staticClass: "transfer-card__messages"
	  }, [_c('span', {
	    staticClass: "transfer-card__label"
	  }, [_vm._v("Besked")]), _vm._v(" "), _vm._l((_vm.transferMessages), function(msg, idx) {
	    return _c('span', {
	      key: idx,
	      class: {
	        'message-error': msg.StatusType === 'E',
	        'message-warning': msg.StatusType === 'W'
	      }
	    }, [_vm._v("\n          " + _vm._s(msg.MessageText) + "\n        ")])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.matchStatus === 'match') ? _c('div', {
	    staticClass: "transfer-card__result transfer-card__result--match"
	  }, [_vm._v("\n        " + _vm._s(_vm.matchCount === 1 ? '1 tilsvarende post fundet i Opus' : _vm.matchCount + ' tilsvarende poster fundet i Opus') + ". Den er markeret med Match i tabellen.\n      ")]) : (_vm.matchStatus === 'other_type') ? _c('div', {
	    staticClass: "transfer-card__result transfer-card__result--warning"
	  }, [_vm._v("\n        Ingen post med samme type, men " + _vm._s(_vm.otherTypeOverlapCount) + " " + _vm._s(_vm.otherTypeOverlapCount === 1 ? 'overlappende post' : 'overlappende poster') + " med anden type: " + _vm._s(_vm.otherTypeOverlapCodes) + "\n      ")]) : (_vm.matchStatus === 'not_covered') ? _c('div', {
	    staticClass: "transfer-card__result transfer-card__result--warning"
	  }, [_vm._v("\n        Den valgte periode dækker ikke indberetningens datoer. Vælg en periode, der dækker " + _vm._s(_vm.transferStartLabel) + " - " + _vm._s(_vm.transferEndLabel) + ", og klik på Indlæs.\n      ")]) : (_vm.matchStatus === 'no_match') ? _c('div', {
	    staticClass: "transfer-card__result transfer-card__result--none"
	  }, [_vm._v("\n        Ingen tilsvarende post fundet i Opus\n      ")]) : (_vm.matchStatus === 'unknown_type') ? _c('div', {
	    staticClass: "transfer-card__result transfer-card__result--warning"
	  }, [_vm._v("\n        Indberetningens fraværstype kendes ikke, så der kan ikke søges efter en tilsvarende post i Opus.\n        "), (_vm.otherTypeOverlapCount > 0) ? [_vm._v("\n          " + _vm._s(_vm.otherTypeOverlapCount) + " " + _vm._s(_vm.otherTypeOverlapCount === 1 ? 'post' : 'poster') + " i Opus overlapper perioden: " + _vm._s(_vm.otherTypeOverlapCodes) + "\n        ")] : _vm._e()], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__toolbar"
	  }, [_c('div', {
	    staticClass: "d-modal__toolbar__filters"
	  }, [_c('DoDatePickerRange', {
	    attrs: {
	      "allowSameDate": true,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate,
	      "maximumDateRange": _vm.maximumDateRange,
	      "dateShortCutsProps": _vm.dateShortCuts
	    },
	    on: {
	      "startChanged": function($event) {
	        _vm.startDate = $event
	      },
	      "endChanged": function($event) {
	        _vm.endDate = $event
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--loading': _vm.isLoading
	    },
	    attrs: {
	      "disabled": _vm.isLoading
	    },
	    on: {
	      "click": _vm.readKmdAbsence
	    }
	  }, [_c('span', [_vm._v("Indlæs")])]), _vm._v(" "), (_vm.hasLoaded && !_vm.isLoading && _vm.isPeriodChanged) ? _c('span', {
	    staticClass: "d-modal__hint"
	  }, [_vm._v("\n          Perioden er ændret. Klik på Indlæs for at hente den fra KMD.\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.hasLoaded && !_vm.isLoading && !_vm.errorMessage) ? _c('span', {
	    staticClass: "d-modal__count"
	  }, [_vm._v("\n        " + _vm._s(_vm.rows.length) + " " + _vm._s(_vm.rows.length === 1 ? 'fraværsperiode' : 'fraværsperioder') + " · " + _vm._s(_vm.loadedPeriodLabel) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "d-modal__status"
	  }, [_c('Loader', {
	    attrs: {
	      "isSmall": true
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "d-modal__progress"
	  }, [_vm._v("Henter fravær fra KMD Opus…")])], 1) : (_vm.errorMessage) ? _c('div', {
	    staticClass: "d-modal__error"
	  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : (_vm.hasLoaded && _vm.rows.length === 0) ? _c('p', {
	    staticClass: "d-modal__empty"
	  }, [_vm._v("\n        Der er ikke registreret fravær i KMD Opus i perioden " + _vm._s(_vm.loadedPeriodLabel) + ".\n      ")]) : (_vm.hasLoaded) ? _c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Fraværstype")]), _vm._v(" "), _c('th', {
	    staticClass: "td-date"
	  }, [_vm._v("Startdato")]), _vm._v(" "), _c('th', {
	    staticClass: "td-date"
	  }, [_vm._v("Slutdato")]), _vm._v(" "), (_vm.hasTimes) ? _c('th', {
	    staticClass: "td-time"
	  }, [_vm._v("Tid")]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("Dage")]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("Timer")]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("Kalenderdage")]), _vm._v(" "), _c('th', {
	    staticClass: "td-origin"
	  }, [_vm._v("Oprettet i")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row) {
	    return _c('tr', {
	      key: row.key,
	      class: {
	        'row--match': row.isMatch,
	        'row--overlap': row.isOtherTypeOverlap
	      }
	    }, [_c('td', [_vm._v("\n            " + _vm._s(row.typeText || 'Ukendt fraværstype') + "\n            "), (row.typeCode) ? _c('span', {
	      staticClass: "type-code"
	    }, [_vm._v("(" + _vm._s(row.typeCode) + ")")]) : _vm._e(), _vm._v(" "), (row.isMatch) ? _c('span', {
	      staticClass: "match-badge"
	    }, [_vm._v("Match")]) : _vm._e(), _vm._v(" "), (row.isOtherTypeOverlap) ? _c('span', {
	      staticClass: "overlap-badge"
	    }, [_vm._v("Overlapper, anden type")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticClass: "td-date"
	    }, [_vm._v(_vm._s(row.vStartDate))]), _vm._v(" "), _c('td', {
	      staticClass: "td-date"
	    }, [_vm._v(_vm._s(row.vEndDate))]), _vm._v(" "), (_vm.hasTimes) ? _c('td', {
	      staticClass: "td-time"
	    }, [_vm._v(_vm._s(row.vTime))]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(row.days)))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(row.hours)))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(row.calendarDays)))]), _vm._v(" "), _c('td', {
	      staticClass: "td-origin"
	    }, [(row.isFromDocendo) ? _c('span', {
	      staticClass: "status-pill status-pill--docendo"
	    }, [_vm._v("Oprettet i docendo")]) : _c('span', {
	      staticClass: "status-pill status-pill--opus"
	    }, [_vm._v("Oprettet i Opus")])])])
	  }), 0)]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 1989 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-tag"
	  }, [_c('div', {
	    staticClass: "d-tag__text"
	  }, [_vm._v(_vm._s(_vm.tag))]), _vm._v(" "), _c('div', {
	    staticClass: "icon-cross2 d-tag__icon",
	    on: {
	      "click": function($event) {
	        return _vm.remove(_vm.tag)
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1990 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "print-calendars text-dark",
	    attrs: {
	      "id": "printCalendars"
	    }
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "loader-container"
	  }, [_c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.loading')))])], 1) : [(_vm.calendars.length < 1) ? _c('h2', {
	    staticClass: "explainer-text italic pad-20"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.no_calendars')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.calendars), function(calendar) {
	    return _c('div', {
	      key: calendar.id,
	      staticClass: "d-calendar"
	    }, [(_vm.theViewSetting !== 'list') ? _c('h2', {
	      staticClass: "text-dark"
	    }, [_vm._v(_vm._s(calendar.name))]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "calculate-hours-wrapper"
	    }, [(_vm.isPrintHours) ? _c('CalculateHours', {
	      staticClass: "print-calculate-hours",
	      attrs: {
	        "isShowOptions": false,
	        "schoolId": _vm.schoolId,
	        "calendarId": calendar.id,
	        "date": _vm.date
	      }
	    }) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "d-calendar__calendar__container d-calendar__calendar__container--print-mode",
	      class: [{
	        'd-calendar__calendar__container--print-mode--is-list': _vm.theViewSetting === 'list'
	      }, {
	        'd-calendar__calendar__container--print-mode--is-print-hours': _vm.isPrintHours
	      }]
	    }, [(_vm.theViewSetting === 'blocks') ? _c('DCalendarPrint', {
	      attrs: {
	        "isCalendarInPrintMode": true,
	        "isShowWeekends": _vm.isShowWeekends,
	        "startTime": _vm.startTime,
	        "endTime": _vm.endTime,
	        "date": _vm.date,
	        "events": calendar.events,
	        "calendarId": calendar.id,
	        "calendarName": calendar.name,
	        "firstDayOfWeek": _vm.firstDayOfWeek
	      }
	    }) : _vm._e(), _vm._v(" "), (_vm.theViewSetting === 'calendar' || _vm.theViewSetting === 'list') ? _c('DCalendar', {
	      attrs: {
	        "isCalendarInPrintMode": true,
	        "isShowWeekends": _vm.isShowWeekends,
	        "isHideCalendars": _vm.isHideCalendars,
	        "isHideDates": _vm.isHideDates,
	        "isCalNoBgColors": _vm.isCalNoBgColors,
	        "eventFontSize": _vm.eventFontSize,
	        "startTime": _vm.startTime,
	        "endTime": _vm.endTime,
	        "date": _vm.date,
	        "events": calendar.events,
	        "calendarId": calendar.id,
	        "calendarName": calendar.name,
	        "isShowAsList": _vm.theViewSetting === 'list',
	        "firstDayOfWeek": _vm.firstDayOfWeek
	      }
	    }) : _vm._e()], 1)], 1)])
	  })], _vm._v(" "), (_vm.isShowPrintButton) ? _c('DModal', {
	    staticClass: "modal-print-button",
	    class: {
	      'modal-print-button--hide': !_vm.isShowPrintButton
	    },
	    attrs: {
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "d-modal__content d-modal__print_button",
	    class: {
	      'd-modal__print_button--wide': _vm.showDSelect
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [(_vm.showDSelect) ? _c('div', {
	    staticClass: "custom-select-calendars"
	  }, [_c('label', {
	    staticClass: "d-label marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.custom')))]), _vm._v(" "), _c('DSelectCals', {
	    attrs: {
	      "appendToBody": true
	    },
	    on: {
	      "updateItems": function($event) {
	        return _vm.dSelectCalsUpdated('update', $event)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "custom-select-calendars__submit"
	  }, [(!_vm.isCalendarsSelected) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.setIsCalendarsSelected
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.showDSelect || _vm.isCalendarsSelected),
	      expression: "!showDSelect || isCalendarsSelected"
	    }],
	    staticClass: "d-modal__print_button__settings"
	  }, [_c('div', {
	    staticClass: "d-input-group marg-1-bottom",
	    staticStyle: {
	      "margin": "0"
	    }
	  }, [_c('label', {
	    staticClass: "d-input marg-05-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.standard_settings.set_default_start_and_endtime')))]), _vm._v(" "), _c('TimeChanger', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "showIcon": true,
	      "start": _vm.startTimeDate,
	      "end": _vm.endTimeDate
	    },
	    on: {
	      "updateStart": _vm.setStartTime,
	      "updateEnd": _vm.setEndTime
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.changeSetting('isHideDates', !_vm.isHideDates)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.hide_dates')))]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isHideDates
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.changeSetting('isShowWeekends', !_vm.isShowWeekends)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.show_weekends')))]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isShowWeekends
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setViewSetting('list')
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.show_as_list')))]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.theViewSetting === 'list'
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setViewSetting('blocks')
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.show_as_blocks')))]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.theViewSetting === 'blocks'
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.changeSetting('isPrintHours', !_vm.isPrintHours)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.show_print_hours')))]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isPrintHours
	    }
	  })], 1), _vm._v(" "), (_vm.theViewSetting === 'calendar') ? _c('div', {
	    staticClass: "input-group input-group__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.changeSetting('isCalNoBgColors', !_vm.isCalNoBgColors)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.show_print_without_bg_colors')))]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isCalNoBgColors
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.changeSetting('isHideCalendars', !_vm.isHideCalendars)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.hide_calendars')))]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isHideCalendars
	    }
	  })], 1), _vm._v(" "), (_vm.theViewSetting === 'calendar') ? _c('div', {
	    staticClass: "input-group input-group__toggle"
	  }, [_c('label', {
	    staticClass: "d-label marg-1-right"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.event_font_size')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.eventFontSize),
	      expression: "eventFontSize"
	    }],
	    attrs: {
	      "type": "range",
	      "name": "vol",
	      "min": "4",
	      "max": "16"
	    },
	    domProps: {
	      "value": (_vm.eventFontSize)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.changeSetting('eventFontSize', _vm.eventFontSize)
	      },
	      "__r": function($event) {
	        _vm.eventFontSize = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons d-modal__print_button__submit",
	    class: {
	      'd-modal__print_button__submit--space': _vm.hasUserPrintSettings
	    }
	  }, [_c('p', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.hasUserPrintSettings),
	      expression: "hasUserPrintSettings"
	    }],
	    staticClass: "text-link",
	    on: {
	      "click": _vm.resetPrintSettings
	    }
	  }, [_vm._v("Nulstil")]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__print_button__submit--right"
	  }, [_c('button', {
	    staticClass: "marg-1-right do-bttn",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.print
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.print')))])])])])])]) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1991 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "lessons text-dark"
	  }, [_c('div', {
	    staticClass: "lessons__filters"
	  }, [_c('Tabs', {
	    attrs: {
	      "tabs": _vm.tabsList,
	      "selected": _vm.activeFilter
	    },
	    on: {
	      "select": _vm.setFilter
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.$t('vue2.substitution.subject'),
	      "tags": _vm.subjectTitles,
	      "selectedTags": _vm.selectedSubjectTitles
	    },
	    on: {
	      "select": _vm.toggleSubjectTitle,
	      "clear": _vm.clearSubjectTitles
	    }
	  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('div', [_c('Loader', {
	    staticStyle: {
	      "margin-top": "10rem"
	    },
	    attrs: {
	      "isSmall": true
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.eventsSortedInDays.length < 1) ? _c('div', {
	    staticClass: "no-lessons-text"
	  }, [_c('h4', {
	    staticClass: "text-explainer"
	  }, [(_vm.activeFilter === 'lessonsWithoutSub') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitution.no_lessons_without_subs')))]) : _vm._e(), _vm._v(" "), (_vm.activeFilter === 'lessonsWithSub') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitution.no_lessons_with_sub')))]) : _vm._e(), _vm._v(" "), (_vm.activeFilter === '') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitution.no_lessons')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.eventsSortedInDays.length > 0) ? _c('div', {
	    staticClass: "marg-1-top"
	  }, [_c('div', {
	    staticClass: "subs-days-container__header"
	  }, [_c('p', {
	    staticClass: "select-all-item",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.visibleSelectedEventIds.length === 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.select_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.unselect_all')))])]), _vm._v(" "), _c('p', {
	    staticClass: "select-all-item",
	    on: {
	      "click": _vm.toggleAll
	    }
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "subs-days-container rounded shadow"
	  }, _vm._l((_vm.eventsSortedInDays), function(day) {
	    return _c('li', [_c('div', {
	      staticClass: "day__header"
	    }, [_c('div', {
	      staticClass: "day__header__left"
	    }, [_c('label', [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.$filters.ddd(day.date))) + ", " + _vm._s(_vm.$filters.LL(day.date)))]), _vm._v(" "), _vm._l((_vm.getDayAbsenceTimes(day.date)), function(time) {
	      return _c('span', {
	        staticClass: "badge badge--orange badge--small"
	      }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.user_event_list.absence')) + " " + _vm._s(time) + "\n            ")])
	    })], 2)]), _vm._v(" "), _c('ul', {
	      staticClass: "sub-lessons"
	    }, _vm._l((day.events), function(event) {
	      return _c('li', {
	        key: event.event_id,
	        staticClass: "d-lesson",
	        class: {
	          'd-lesson--active': _vm.isInEventIdsToAddSub(event.event_id) || (_vm.activeLesson && event.event_id === _vm.activeLesson.event_id)
	        },
	        style: ({
	          'border-color': event.color
	        }),
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            $event.preventDefault();
	            return _vm.toggleEvent(event.event_id)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "d-lesson__left"
	      }, [_c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': _vm.isInEventIdsToAddSub(event.event_id)
	        }
	      }), _vm._v(" "), _c('div', {
	        staticClass: "d-lesson__title"
	      }, [_c('span', {
	        staticClass: "d-lesson__time"
	      }, [_vm._v(_vm._s(_vm.$filters.LT(event.start)) + " - " + _vm._s(_vm.$filters.LT(event.end)))]), _vm._v("\n                " + _vm._s(event.title) + "\n                "), _vm._l((_vm.getClasses(event)), function(klass) {
	        return _c('span', [_vm._v(", " + _vm._s(klass.name))])
	      })], 2)]), _vm._v(" "), _c('div', {
	        staticClass: "sub-selector",
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	          }
	        }
	      }, [(_vm.getSubstitute(event).length > 0) ? _c('span', {
	        staticClass: "icon-users"
	      }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getSubstitute(event)), function(sub) {
	        return _c('p', {
	          staticClass: "sub-name"
	        }, [_c('b', [_vm._v(_vm._s(sub.name))]), _vm._v(" "), _c('span', {
	          staticClass: "icon-cross2",
	          on: {
	            "click": function($event) {
	              return _vm.setIsAskRemoveAll(true, event, sub)
	            }
	          }
	        })])
	      })], 2)])
	    }), 0)])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isAskRemoveAll) ? _c('DModal', {
	    attrs: {
	      "show-close": false
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.substitution.remove_sub_from_all_lessons')) + "?")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.setIsAskRemoveAll(false, null, null)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.substitution.do_you_want_to_remove')) + " " + _vm._s(_vm.activeSub.name) + "\n          " + _vm._s(_vm.$t('vue2.substitution.as_sub_on')) + " \""), _c('span', [_c('span', {
	    staticClass: "d-lesson__time"
	  }, [_vm._v(_vm._s(_vm.$filters.LT(_vm.activeLesson.start)) + " - " + _vm._s(_vm.$filters.LT(_vm.activeLesson.end)))]), _vm._v(_vm._s(_vm.activeLesson.title)), _vm._l((_vm.getClasses(_vm.activeLesson)), function(klass) {
	    return _c('span', [_vm._v(", " + _vm._s(klass.name))])
	  })], 2), _vm._v("\" -\n          " + _vm._s(_vm.$t('vue2.substitution.or_on_all_lessons')) + "?\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "marg-10-right",
	    on: {
	      "click": _vm.removeSubFromAllLessons
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.substitution.remove_from_all_lessons')) + "\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.removeSubFromActiveLesson
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.substitution.just_this_lessons')) + "\n          ")])])])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1992 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('dropup', {
	    attrs: {
	      "button-text": _vm.$t('vue.deleteday.delete_day_or_week'),
	      "show": _vm.showDropUp
	    },
	    on: {
	      "open": _vm.dropUp,
	      "close": function($event) {
	        _vm.showDropUp = false
	      }
	    }
	  }, [_c('template', {
	    slot: "list"
	  }, [_vm._l((_vm.weekDaysLocale), function(weekdayNum) {
	    return _c('li', {
	      key: weekdayNum,
	      on: {
	        "click": function($event) {
	          return _vm.setIsConfirmDeletion(weekdayNum)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(_vm.formattedDate(weekdayNum)) + "\n      ")])
	  }), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.setIsConfirmDeletion('week')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue.deleteday.whole_week')))])], 2)], 2), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-modal"
	    }
	  }, [(_vm.isConfirmDeletion) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": _vm.closeIsConfirmDelete,
	      "confirm": _vm.confirmDelete
	    }
	  }, [_c('h3', {
	    staticStyle: {
	      "padding": "1rem 1rem 0rem 1rem"
	    },
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_vm._v(_vm._s(_vm.theDeleteText))])]) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1993 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "week-to-print"
	  }, [_c('div', {
	    staticClass: "week-to-print__header"
	  }, [_c('change-school-year', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "weeks-container"
	  }, [_c('ul', {
	    staticClass: "weeks"
	  }, [(_vm.weeks.length < 1) ? [_c('Spinner', {
	    staticStyle: {
	      "margin-bottom": "100px"
	    },
	    attrs: {
	      "color": "blue"
	    }
	  })] : _vm._l((_vm.weeks), function(week) {
	    return _c('li', {
	      key: week.serverDate,
	      staticClass: "weeks__week hint--top",
	      attrs: {
	        "aria-label": _vm.tooltipDate(week.date)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setSelectedWeek(week)
	        }
	      }
	    }, [_vm._v("\n          " + _vm._s(_vm.showWeek(week.date)) + "\n          "), (_vm.isNow(week)) ? _c('span', {
	      staticClass: "weeks__week__now-indicator"
	    }) : _vm._e()])
	  })], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 1994 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box"
	  }, [(_vm.isCountryDK) ? _c('div', [_c('h1', {
	    staticClass: "primary-color"
	  }, [_vm._v("Kontakt os, hvis du ønsker at få fuld adgang til Docendo")]), _vm._v(" "), _c('ul', {
	    staticClass: "docendo-contact-options"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('h4', [_vm._v("Eller skriv en chatbesked")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn--primary",
	    on: {
	      "click": _vm.openCrispChat
	    }
	  }, [_vm._v("Skriv en chatbesked")])])]), _vm._v(" "), _c('Pricing')], 1) : _vm._e(), _vm._v(" "), (!_vm.isCountryDK) ? _c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t('vue.buy.buy_access_for_school_users')))]), _vm._v(" "), _c('div', {
	    staticClass: "col-1-2 marg-20-bottom"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue.buy.a_user_is')))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.countryIsDkOrNo) ? _c('h2', [_vm._v(_vm._s(_vm.$t('vue.buy.choose_the_right_price')))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.countryIsDkOrNo) ? _c('div', {
	    staticClass: "marg-20-bottom flex"
	  }, [_c('div', {
	    staticClass: "col-1-2"
	  }, [_c('div', {
	    staticClass: "pointer border rounded pad-20 center",
	    class: {
	      'active': _vm.isSelectedModel(1),
	      'notActive': _vm.isSelectedModel(2)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.selectModel(1)
	      }
	    }
	  }, [_c('h3', {
	    staticClass: "font-large marg-10-bottom"
	  }, [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.$t('vue.buy.per_user'))))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
	    staticClass: "marg-10-bottom"
	  }, [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.$t('vue.buy.price'))) + " " + _vm._s(_vm.$t('vue.buy.per_user')))]), _vm._v(" "), _c('p', {
	    staticClass: "text-blue bold blue-price"
	  }, [_vm._v(_vm._s(_vm.userPrice) + " " + _vm._s(_vm.currency))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue.buy.per_user')) + " / " + _vm._s(_vm.$t('vue.buy.month')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
	    staticClass: "marg-10-bottom"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue.buy.only_pay_per')) + "\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "cta-button"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('repitition.choose')) + "\n            ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-1-2"
	  }, [_c('div', {
	    staticClass: "pointer pos-relative border rounded pad-20 center",
	    class: {
	      'active': _vm.isSelectedModel(2),
	      'notActive': _vm.isSelectedModel(1)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.selectModel(2)
	      }
	    }
	  }, [_c('h3', {
	    staticClass: "font-large marg-10-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue.buy.unlimited')))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
	    staticClass: "marg-10-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue.buy.total_student_number')))]), _vm._v(" "), _c('p', {
	    staticClass: "text-blue bold blue-price"
	  }, [_vm._v(_vm._s(_vm.pupilsPrice) + " " + _vm._s(_vm.currency))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue.buy.per_student')) + " / " + _vm._s(_vm.$t('vue.buy.month')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
	    staticClass: "marg-10-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue.buy.pay_for_unlimited_users_and_get')))]), _vm._v(" "), _c('button', {
	    staticClass: "cta-button"
	  }, [_vm._v(_vm._s(_vm.$t('repitition.choose')))])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedModel !== null) ? _c('div', [_c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('vue.buy.subscription_info')))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isSelectedModel(1)) ? _c('div', [_c('div', {
	    staticClass: "form-group large-margin form-group__input"
	  }, [_c('label', [_vm._v("\n              " + _vm._s(_vm.$t('vue.buy.write_number_of_users')) + "\n            ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number.lazy",
	      value: (_vm.users),
	      expression: "users",
	      modifiers: {
	        "number": true,
	        "lazy": true
	      }
	    }],
	    staticClass: "type_number",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.users)
	    },
	    on: {
	      "change": function($event) {
	        _vm.users = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.isSelectedModel(2)) ? _c('div', [_c('div', {
	    staticClass: "form-group large-margin form-group__input"
	  }, [_c('label', [_vm._v("\n              " + _vm._s(_vm.$t('vue.buy.write_number_of_students')) + "\n            ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number.lazy",
	      value: (_vm.pupils),
	      expression: "pupils",
	      modifiers: {
	        "number": true,
	        "lazy": true
	      }
	    }],
	    staticClass: "type_number",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.pupils)
	    },
	    on: {
	      "change": function($event) {
	        _vm.pupils = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('vue.buy.billed_monthly_or_yearly')))]), _vm._v(" "), _c('div', {
	    staticClass: "form-group large-margin form-group__radiobuttons"
	  }, [_c('br'), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.interval),
	      expression: "interval",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "monthly",
	      "value": "1"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.interval, _vm._n("1"))
	    },
	    on: {
	      "change": function($event) {
	        _vm.interval = _vm._n("1")
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "monthly"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue.buy.per_month')))])]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.interval),
	      expression: "interval",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "yearly",
	      "value": "2"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.interval, _vm._n("2"))
	    },
	    on: {
	      "change": function($event) {
	        _vm.interval = _vm._n("2")
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "yearly"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue.buy.per_year')) + " "), _c('span', {
	    staticClass: "discount"
	  }, [_vm._v(_vm._s(_vm.$t('vue.buy.save_2')) + " ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "billing-bill large-margin"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue.buy.your_invoice')))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "flex"
	  }, [_c('p', [_vm._v("1 " + _vm._s(_vm.$t('vue.buy.institution')))]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.$t('vue.buy.per_year') : _vm.$t('vue.buy.per_month')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.monthlyInstitutionPrice * 12 : _vm.monthlyInstitutionPrice * 1) + " " + _vm._s(_vm.currency) + "\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    class: {
	      'invalid-price': _vm.selectedModel !== 1
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.users === '' ? '0' : _vm.users) + " "), _c('span', [_vm._v(_vm._s(_vm.$t('repitition.users')))])]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.$t('vue.buy.per_year') : _vm.$t('vue.buy.per_month')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.userAmount * 12 : _vm.userAmount) + " " + _vm._s(_vm.currency) + "\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    class: {
	      'invalid-price': _vm.selectedModel !== 2
	    }
	  }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('vue.buy.unlimited'))), _c('span', [_vm._v(" " + _vm._s(_vm.$t('repitition.users')))])]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.$t('vue.buy.per_year') : _vm.$t('vue.buy.per_month')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("0 " + _vm._s(_vm.currency))])]), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    class: {
	      'invalid-price': _vm.selectedModel !== 2
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.pupils === "" || _vm.pupils < 0 ? '0' : _vm.pupils) + " "), _c('span', [_vm._v(_vm._s(_vm.$t('vue.buy.discount')))])]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.$t('vue.buy.per_year') : _vm.$t('vue.buy.per_month')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.pupilAmount * 12 : _vm.pupilAmount) + " " + _vm._s(_vm.currency) + "\n            ")])]), _vm._v(" "), (_vm.yearlyPayment) ? _c('div', {
	    staticClass: "flex bg-discount"
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('vue.buy.discount')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue.buy.per_year')))]), _vm._v(" "), _c('p', [_vm._v("-" + _vm._s(_vm.yearlySavings) + " " + _vm._s(_vm.currency))])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "flex"
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('vue.buy.total')))]), _vm._v(" "), _c('p', [(_vm.yearlyPayment) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue.buy.per_year')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue.buy.per_month')))])]), _vm._v(" "), _c('p', {
	    staticClass: "total-amount"
	  }, [_vm._v(_vm._s(_vm.totalAmount) + " " + _vm._s(_vm.currency))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('vue.buy.payment_info')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-group__input"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue.buy.school_name')) + " *")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.schoolName),
	      expression: "schoolName"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.schoolName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.schoolName = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-group__input"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.$t('vue.buy.your_name'))) + " *")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-group__input"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue.buy.your_email')) + " *")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-group__input"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue.buy.your_phonenumber')) + " *")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.phone),
	      expression: "phone"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.phone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.phone = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "cta-button",
	    attrs: {
	      "disabled": !_vm.buyButtonEnabled
	    },
	    on: {
	      "click": _vm.buyClick
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue.buy.buy')) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-1-2"
	  }, [_c('div', {
	    staticClass: "center"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue.buy.questions')) + " ?")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('vue.buy.call_us_at')) + " +45 43 31 06 12")])])]), _vm._v(" "), _c('modal', {
	    attrs: {
	      "show": _vm.showModal,
	      "close_on_click_away": true
	    },
	    on: {
	      "close": _vm.closedModal
	    }
	  }, [_c('h1', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.modalHeader))]), _vm._v(" "), _c('div', {
	    staticClass: "flex flex-vertical-center",
	    staticStyle: {
	      "flex-direction": "row",
	      "justify-content": "center",
	      "align-items": "center",
	      "height": "100%"
	    },
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.modalBody)
	    }
	  })]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  })])], 1) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('h4', [_vm._v("Ring til os på")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "tel:43310612"
	    }
	  }, [_vm._v("43 31 06 12")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('h4', [_vm._v("Skriv en en email")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "mailto:kontakt@docendo.dk"
	    }
	  }, [_vm._v("kontakt@docendo.dk")])])
	}]}

/***/ }),
/* 1995 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-touch', {
	    staticClass: "week-container"
	  }, [_c('div', {
	    staticClass: "header box-shadow"
	  }, [_c('span', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.calRangeView))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('calendars.week_plan_and_note.week_plan')))]), _vm._v(" "), _c('v-touch', {
	    staticClass: "close",
	    on: {
	      "tap": _vm.close
	    }
	  }, [_c('div', {
	    staticClass: "font-large close-tap"
	  }, [_c('span', {
	    staticClass: "icon-cross2 pointer"
	  })])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "container",
	    style: ({
	      height: _vm.height + 'px'
	    })
	  }, [_c('div', {
	    staticClass: "body"
	  }, [_c('weekplan', {
	    staticClass: "weekplan-container",
	    attrs: {
	      "calId": _vm.calId,
	      "date": _vm.date,
	      "events": _vm.events,
	      "weeknote": _vm.weeknote
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 1996 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "user-item__tasks"
	  }, [(!_vm.activeNorm) ? _c('Loader', {
	    attrs: {
	      "isSmall": true,
	      "bg-color": "#fff"
	    }
	  }) : _c('table', {
	    staticClass: "d-table d-table__norm d-table__tasks marg-10-bottom"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "d-table__title",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_c('h4', [_vm._v("Årsverk")])])])]), _vm._v(" "), _c('tbody', [(_vm.activeNorm.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "italic"
	  }, [_vm._v("Ikke tildelt årsverk")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeNormFormatted), function(item) {
	    return (_vm.activeNorm.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.value))])]) : _vm._e()
	  })], 2)]), _vm._v(" "), _c('table', {
	    staticClass: "d-table d-table__norm d-table__tasks marg-10-bottom"
	  }, [_c('tbody', [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_c('b', [_vm._v(_vm._s(_vm.planfestet))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Undervisning")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.user.v_user_subjects_hours_label))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Oppgaver")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.user.v_user_tasks_hours_label))])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_c('b', [_vm._v(_vm._s(_vm.egenDisponibel))])])])])]), _vm._v(" "), _c('table', {
	    staticClass: "d-table d-table__tasks marg-10-bottom"
	  }, [_c('thead', [_c('tr', [_vm._m(2), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.user.v_total_teaching_percentage_label) + "\n      ")]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.user.v_user_subjects_hours_label) + "\n      ")])])]), _vm._v(" "), _c('tbody', [(_vm.user.v_user_subjects.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "italic"
	  }, [_vm._v("Ingen undervisning")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.user.v_user_subjects), function(task) {
	    return _c('tr', {
	      key: task.id
	    }, [_c('td', [_c('div', {
	      staticClass: "task-with-edit"
	    }, [(task.can_schedule || !task.hasOwnProperty('can_schedule')) ? _c('div', {
	      staticClass: "subjects_subject subjects_subject__simple",
	      style: ([{
	        'border-left-color': task.color
	      }, {
	        'background-color': task.color
	      }])
	    }, [_vm._v("\n            " + _vm._s(task.name) + "\n          ")]) : _c('div', {
	      staticClass: "subjects_subject subjects_subject--not-subject"
	    }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v("\n        " + _vm._s(task.v_calendar) + "\n      ")]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v("\n        " + _vm._s(task.v_percentage_label) + "\n      ")]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v("\n        " + _vm._s(task.v_hours_label) + "\n      ")])])
	  })], 2)]), _vm._v(" "), _c('table', {
	    staticClass: "d-table d-table__tasks marg-10-bottom"
	  }, [_c('thead', [_c('tr', [_vm._m(3), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.user.v_user_tasks_hours_label))])])]), _vm._v(" "), _c('tbody', [(_vm.user.v_user_tasks.length < 1) ? _c('tr', [_c('td', [_vm._v("Ingen oppgaver")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.user.v_user_tasks), function(task) {
	    return _c('tr', {
	      key: task.id
	    }, [_c('td', [_c('div', {
	      staticClass: "task-with-edit"
	    }, [(task.can_schedule || !task.hasOwnProperty('can_schedule')) ? _c('div', {
	      staticClass: "subjects_subject subjects_subject__simple",
	      style: ([{
	        'border-left-color': task.color
	      }, {
	        'background-color': task.color
	      }])
	    }, [_vm._v("\n            " + _vm._s(task.name) + "\n          ")]) : _c('div', {
	      staticClass: "subjects_subject subjects_subject--not-subject"
	    }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v("\n        " + _vm._s(task.v_hours_label) + "\n      ")])])
	  })], 2)]), _vm._v(" "), _c('SubjectsDistributionUserAgreements', {
	    attrs: {
	      "userId": _vm.user.id,
	      "userAgreements": _vm.activeUserAgreements,
	      "isReadAgreements": false
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('b', [_vm._v("Sum planfestet arbeidstid")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('b', [_vm._v("Sum egendisponibel resttid")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticClass: "d-table__title",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_c('div', {
	    staticClass: "d-table__title__header"
	  }, [_c('h4', [_vm._v("Undervisning")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticClass: "d-table__title"
	  }, [_c('h4', [_vm._v("Oppgaver")])])
	}]}

/***/ }),
/* 1997 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sub border marg-20-bottom"
	  }, [_c('div', {
	    staticClass: "sub__user-header space-between flex align-center"
	  }, [_c('div', {
	    staticClass: "flex align-center"
	  }, [_c('img', {
	    staticClass: "marg-20-right rounded sub__user-img",
	    attrs: {
	      "src": _vm.user.default_thumb_url,
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('DDropdown', [_c('ul', {
	    staticStyle: {
	      "width": "180px"
	    },
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', [_c('a', {
	    staticClass: "marg-5-left text-link",
	    attrs: {
	      "href": '/calendars/' + _vm.user.user_calendar_id,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['see_calendar']))])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.setActiveAbsentUser(_vm.user)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].add_sub_to_multiple_lessons))])])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "sub__user-header__right"
	  }, [_c('div', {
	    staticClass: "absence-status"
	  }, [_c('label', {
	    staticClass: "d-label marg-10-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['absent_handled']))]), _vm._v(" "), _c('div', {
	    staticClass: "absence__status",
	    on: {
	      "click": function($event) {
	        return _vm.setSubStatusDropdown(12)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dot",
	    class: _vm.schedulerUserHandledCls(_vm.user)
	  }), _vm._v(" "), (_vm.isSubStatusDropdown(12)) ? _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeSubStatusDropdown),
	      expression: "closeSubStatusDropdown"
	    }],
	    staticClass: "dropdown absence__status__dropdown sub-status__dropdown",
	    class: {
	      'sub-status__dropdown--loading': _vm.isSubmittingAbsenceStatus
	    }
	  }, [(_vm.isSubmittingAbsenceStatus) ? _c('div', {
	    staticClass: "do-spinner__container"
	  }, [_c('div', {
	    staticClass: "do-spinner do-spinner--large"
	  })]) : _vm._e(), _vm._v(" "), _c('ul', [_c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setAbsenceStatus(0)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dot dot-white"
	  }), _vm._v("\n                " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.not_handled')) + "\n              ")]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setAbsenceStatus(1)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dot"
	  }), _vm._v("\n                " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.handled')) + "\n              ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "absence-reasons"
	  }, _vm._l((_vm.absenceReasons), function(reason) {
	    return _c('div', {
	      staticClass: "absence-reasons__absence"
	    }, [_c('p', {
	      staticClass: "absence-reasons__absence__note"
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['note']) + ":")]), _vm._v(" "), _c('weip', {
	      attrs: {
	        "lesson": reason,
	        "noteType": "teacher_notes"
	      },
	      on: {
	        "close": _vm.updateTeacherNote
	      }
	    })], 1), _vm._v(" "), _c('div', [_c('div', {
	      staticClass: "absence-reasons__absence__title"
	    }, [_c('p', [_c('b', [_vm._v(_vm._s(reason.title))])]), _vm._v(" "), (reason.event_serial_id) ? _c('p', [(_vm.getIsAbsenceOngoing(reason)) ? [(_vm.getIsAbsenceAutoGenerated(reason)) ? _c('span', {
	      staticClass: "badge badge--orange-warning badge--small badge--clickable",
	      on: {
	        "click": function($event) {
	          return _vm.setTheEditAbsenceReason(reason)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['auto_created']))]) : _c('span', {
	      staticClass: "badge badge--orange badge--small badge--clickable",
	      on: {
	        "click": function($event) {
	          return _vm.setTheEditAbsenceReason(reason)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['ongoing_absence']))])] : _vm._e(), _vm._v(" "), (!_vm.getIsAbsenceOngoing(reason) && _vm.getIsAbsenceMultipleDays(reason)) ? _c('span', {
	      staticClass: "badge badge--small"
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['multiple_days']))]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('p', [(_vm.getSerialListItem(reason)) ? [_vm._v("\n                " + _vm._s(_vm.formatDate(_vm.getSerialListItem(reason).from_date)) + "\n                - " + _vm._s(_vm.formatDate(_vm.getSerialListItem(reason).to_date)) + ", " + _vm._s(_vm.showTime(reason.start)) + " -\n                " + _vm._s(_vm.showTime(reason.end)) + "\n              ")] : [_vm._v("\n                " + _vm._s(_vm.absenceDate(reason.start)) + " -\n                "), _c('span', [_vm._v(_vm._s(_vm.showTime(reason.end)))])]], 2)]), _vm._v(" "), _c('div', {
	      staticClass: "absence-reasons__absence__right"
	    }, [_c('div', {
	      staticClass: "absence-reasons__absence__right__edits"
	    }, [_c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'top'
	        }),
	        expression: "{\n                  arrow: true,\n                  placement : 'top'\n                }"
	      }],
	      staticClass: "icon-bin icon__bg-circle deleteAbsence",
	      attrs: {
	        "content": _vm.$t('vue2.common.delete')
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setReadyToDelete(reason)
	        }
	      }
	    }), _vm._v(" "), (_vm.getSerialListItem(reason)) ? _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'top'
	        }),
	        expression: "{\n                  arrow: true,\n                  placement : 'top'\n                }"
	      }],
	      staticClass: "icon-wrench icon__bg-circle",
	      attrs: {
	        "content": _vm.$t('vue2.common.edit')
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheEditAbsenceReason(reason)
	        }
	      }
	    }) : _vm._e()]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'left'
	        }),
	        expression: "{\n                  arrow: true,\n                  placement : 'left'\n                }"
	      }],
	      staticClass: "activity-log icon__bg-circle",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['log']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showLog(reason)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-clock"
	    })])])])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "sub-body"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['lessons_on_day']) + ": " + _vm._s(_vm.sortedEvents.length) + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.i18n[_vm.locale]['lessons_affected_by_absence']) + ": " + _vm._s(_vm.overlappingArr.length) + "\n    ")]), _vm._v(" "), (_vm.sortedEvents.length > 0) ? _c('table', {
	    staticClass: "sub-table"
	  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.showDate(_vm.sortedEvents[0].start))))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['subject']))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['class']))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['same_time']))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['substitute']))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['substitute_notes']))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['status']))])]), _vm._v(" "), _vm._l((_vm.sortedEvents), function(lesson, lessonIdx) {
	    return _c('tr', {
	      key: _vm.user.id + '_' + lesson.id,
	      staticClass: "sub-lesson",
	      class: [{
	        'lesson-overlaps': lesson.v_isOverlapping
	      }, {
	        'sub-lesson__absence-overlap--handled': lesson.v_status && lesson.v_status !== 2
	      }, {
	        'sub-lesson__absence-overlap--pending': lesson.v_status === 2
	      }],
	      attrs: {
	        "data-uuid": _vm.user.id + '_' + lesson.id
	      }
	    }, [_c('td', {
	      staticClass: "sub-lesson__time",
	      attrs: {
	        "aria-i18n": _vm.i18n[_vm.locale]['absent']
	      }
	    }, [_c('div', {
	      staticClass: "sub-lesson__time__content"
	    }, [_c('div', [_vm._v(_vm._s(_vm.$filters.LT(lesson.start)) + " - " + _vm._s(_vm.$filters.LT(lesson.end)))]), _vm._v(" "), _c('button', {
	      staticClass: "bttn bttn-sub-small hint--right",
	      attrs: {
	        "aria-label": _vm.i18n[_vm.locale]['split_lesson']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveSplitLesson(lesson)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-wrench"
	    })])])]), _vm._v(" "), _c('td', {
	      staticClass: "sub-lesson__title"
	    }, [_vm._v("\n          " + _vm._s(lesson.title) + "\n        ")]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "100px"
	      }
	    }, _vm._l((lesson.klassesAndOther), function(cal) {
	      return _c('a', {
	        key: cal.id,
	        attrs: {
	          "href": cal.url
	        }
	      }, [_vm._v("\n            " + _vm._s(cal.name) + "\n          ")])
	    }), 0), _vm._v(" "), _c('td', {
	      staticClass: "sub-lesson__others"
	    }, [(lesson.v_others.length > 0) ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.i18n[_vm.locale].on_the_lesson))])]) : _vm._e(), _vm._v(" "), _vm._l((lesson.v_others), function(user, othersIdx) {
	      return (othersIdx < 3 || lesson.showAllOtherOnLesson) ? _c('div', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: false,
	            zIndex: 123123123123,
	            placement: 'top-start',
	            onShow: function () { return user.v_isUserAbsentFromLesson.length > 0; }
	          }),
	          expression: "{\n                  arrow: false,\n                  zIndex: 123123123123,\n                  placement : 'top-start',\n                  onShow: () => user.v_isUserAbsentFromLesson.length > 0\n                }"
	        }],
	        key: user.id,
	        staticClass: "sub-lesson__others__user",
	        class: {
	          'sub-lesson__others__user--absent': user.v_isUserAbsentFromLesson.length > 0
	        },
	        attrs: {
	          "content": user.v_isUserAbsentFromLesson
	        }
	      }, [(user.v_isUserAbsentFromLesson.length > 0) ? _c('span', {
	        staticClass: "icon-warning"
	      }) : _c('span', {
	        staticClass: "icon-user"
	      }), _vm._v("\n            " + _vm._s(user.name) + "\n          ")]) : _vm._e()
	    }), _vm._v(" "), (lesson.v_others.length > 3 && !lesson.showAllOtherOnLesson) ? _c('span', {
	      staticClass: "text-blue pointer",
	      on: {
	        "click": function($event) {
	          return _vm.setShowOtherOnLesson(lesson.id)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].see_all))]) : _vm._e(), _vm._v(" "), (lesson.showAllOtherOnLesson) ? _c('span', {
	      staticClass: "text-blue pointer",
	      on: {
	        "click": function($event) {
	          return _vm.setShowOtherOnLesson(null)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].see_less))]) : _vm._e(), _vm._v(" "), (lesson.otherLessonsInKlassThatOverlap.length > 0) ? _c('div', {
	      staticClass: "other_in_klass"
	    }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.i18n[_vm.locale].same_time_in_class))])]), _vm._v(" "), _vm._l((lesson.otherLessonsInKlassThatOverlap), function(otherLesson, otherKey) {
	      return (otherKey < 2 || lesson.showOtherLessonsInKlassThatOverlap) ? _c('div', {
	        key: otherLesson.id,
	        staticClass: "lesson",
	        style: ({
	          'borderLeft': '2px solid ' + otherLesson.color + ''
	        })
	      }, [_vm._v("\n              " + _vm._s(otherLesson.title) + ", " + _vm._s(_vm.$filters.LT(otherLesson.start)) + " - " + _vm._s(_vm.$filters.LT(otherLesson.end)) + "\n              "), _vm._l((otherLesson.users), function(user, key) {
	        return (key < 2 || otherLesson.showAllUsers) ? _c('div', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              arrow: false,
	              placement: 'top',
	              onShow: function () { return user.v_isUserAbsent; }
	            }),
	            expression: "{\n                     arrow: false,\n                     placement: 'top',\n                     onShow: () => user.v_isUserAbsent\n                   }"
	          }],
	          key: user.id,
	          class: {
	            'other-lesson-user--absent': user.v_isUserAbsent
	          },
	          attrs: {
	            "content": user.v_absenceInfo
	          }
	        }, [(user.v_isUserAbsent) ? _c('span', {
	          staticClass: "icon-warning"
	        }) : _c('span', {
	          staticClass: "icon-user"
	        }), _vm._v("\n                " + _vm._s(user.name) + "\n              ")]) : _vm._e()
	      }), _vm._v(" "), (otherLesson.users.length > 2 && !otherLesson.showAllUsers) ? _c('span', {
	        staticClass: "text-blue pointer",
	        on: {
	          "click": function($event) {
	            return _vm.setOtherLessonShowAllUsers(otherLesson.id)
	          }
	        }
	      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].see_all))]) : _vm._e(), _vm._v(" "), (otherLesson.showAllUsers) ? _c('span', {
	        staticClass: "text-blue pointer",
	        on: {
	          "click": function($event) {
	            return _vm.setOtherLessonShowAllUsers(null)
	          }
	        }
	      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].see_less))]) : _vm._e()], 2) : _vm._e()
	    })], 2) : _vm._e(), _vm._v(" "), (lesson.otherLessonsInKlassThatOverlap.length > 2 && !lesson.showOtherLessonsInKlassThatOverlap) ? _c('span', {
	      staticClass: "text-blue pointer",
	      on: {
	        "click": function($event) {
	          return _vm.setShowOtherLessonsInKlassThatOverlap(lesson.id)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].view_all_lessons))]) : _vm._e(), _vm._v(" "), (lesson.showOtherLessonsInKlassThatOverlap) ? _c('span', {
	      staticClass: "text-blue pointer",
	      on: {
	        "click": function($event) {
	          return _vm.setShowOtherLessonsInKlassThatOverlap(null)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].view_less_lessons))]) : _vm._e()], 2), _vm._v(" "), _c('td', {
	      class: {
	        'd-select-lookalike': !_vm.openDSelect(lesson) && lesson.v_subs.length === 0
	      },
	      staticStyle: {
	        "width": "40%"
	      },
	      attrs: {
	        "aria-placeholder-label": _vm.i18n[_vm.locale]['search']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setDSelect(lesson, lessonIdx)
	        }
	      }
	    }, [(_vm.openDSelect(lesson)) ? _c('dSelectSub', {
	      attrs: {
	        "show": _vm.openDSelect(lesson),
	        "items": _vm.usersForDSelect,
	        "startTime": lesson.start,
	        "endTime": lesson.end,
	        "user": _vm.user,
	        "eventId": lesson.id,
	        "itemsSelected": lesson.v_subs,
	        "othersOnLesson": lesson.v_others,
	        "isUpdatingUsers": _vm.isUpdatingPotentialSubs
	      },
	      on: {
	        "add": function($event) {
	          return _vm.addSubstitute($event, lesson)
	        },
	        "remove": function($event) {
	          return _vm.removeSubstitute($event, lesson)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (!_vm.openDSelect(lesson) && lesson.v_subs.length > 0) ? _c('div', {
	      staticClass: "d-select__input-look"
	    }, _vm._l((lesson.v_subs), function(sub) {
	      return _c('div', {
	        key: sub.id,
	        staticClass: "d-select__selected__item",
	        class: {
	          'd-select__seleted__item--is-error-user': sub.isErrorUser
	        }
	      }, [_vm._v("\n              " + _vm._s(sub.name) + "\n              "), (_vm.subLessonsThatOverlap(lesson, sub.dayAllEvents).length > 0) ? _c('div', {
	        staticClass: "item__icon-warning marg-5-left hint--error hint--top",
	        attrs: {
	          "aria-label": _vm.textFromSubLessonsThatOverlap(lesson, sub.dayEvents)
	        }
	      }) : _vm._e(), _vm._v(" "), (!sub.isErrorUser) ? _c('div', {
	        staticClass: "d-select__selected__item__remove",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.removeSubstitute(sub, lesson)
	          }
	        }
	      }, [_vm._v("×\n              ")]) : _vm._e()])
	    }), 0) : _vm._e()], 1), _vm._v(" "), _c('td', {
	      staticClass: "sub_teacher_notes",
	      class: [{
	          'icon-pencil eip-lookalike eip-lookalike--empty': !_vm.isActiveEIP(lessonIdx) && lesson.teacher_notes.length < 1
	        },
	        {
	          'eip-lookalike eip-filled': !_vm.isActiveEIP(lessonIdx) && lesson.teacher_notes.length > 0
	        }
	      ],
	      staticStyle: {
	        "width": "250px"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveEIP(lessonIdx)
	        }
	      }
	    }, [(!_vm.isActiveEIP(lessonIdx)) ? _c('div', {
	      domProps: {
	        "innerHTML": _vm._s(lesson.teacher_notes)
	      }
	    }) : _vm._e(), _vm._v(" "), (_vm.isActiveEIP(lessonIdx)) ? _c('weip', {
	      attrs: {
	        "noteType": "teacher_notes",
	        "lesson": lesson,
	        "isOpen": true
	      },
	      on: {
	        "close": _vm.updateTeacherNote
	      }
	    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "20px"
	      }
	    }, [(lesson.v_substituted && !_vm.isSubStatusPendingActive) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          placement: 'left',
	          arrow: false,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n              placement: 'left',\n              arrow: false,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n          }"
	      }],
	      staticClass: "flex set-status",
	      attrs: {
	        "content": _vm.$t('vue2.sub_scheduler.is_substituted')
	      }
	    }, [_c('div', {
	      staticClass: "dot"
	    })]) : _c('div', {
	      staticClass: "flex set-status pointer",
	      on: {
	        "click": function($event) {
	          return _vm.setSubStatusDropdown(lesson.id)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "dot",
	      class: [_vm.statusDotClass(lesson), {
	        'dot--loading': lesson.v_isLoading
	      }]
	    }), _vm._v(" "), _c('div', {
	      staticClass: "arrow icon-arrow-down"
	    }), _vm._v(" "), (_vm.isSubStatusDropdown(lesson.id)) ? _c('div', {
	      directives: [{
	        name: "on-clickaway",
	        rawName: "v-on-clickaway",
	        value: (_vm.closeSubStatusDropdown),
	        expression: "closeSubStatusDropdown"
	      }],
	      staticClass: "dropdown sub-status__dropdown"
	    }, [_c('ul', [(!lesson.v_substituted) ? _c('li', {
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setSubStatus(lesson, 0)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "dot dot-white"
	    }), _vm._v("\n                  " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.not_handled')) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.isSubStatusPendingActive) ? _c('li', {
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setSubStatus(lesson, 2)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "dot dot-yellow"
	    }), _vm._v("\n                  " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.pending')) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('li', {
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setSubStatus(lesson, 1)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "dot"
	    }), _vm._v("\n                  " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.handled')) + "\n                ")])])]) : _vm._e()])])])
	  })], 2) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1998 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "isCloseOnBgClick": false,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('div', [_c('h2', [_vm._v("Automatisk indberetning")]), _vm._v(" "), _c('p', {
	    staticClass: "d-modal__subtitle"
	  }, [_vm._v("\n          Opretter fraværsindberetninger ud fra fravær registreret i Vikardækning i den valgte periode.\n        ")])]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content",
	    class: {
	      'd-modal__content--scroll': _vm.createdFravaer !== null
	    }
	  }, [(_vm.createdFravaer === null) ? [_c('div', {
	    staticClass: "auto-period"
	  }, [_c('span', {
	    staticClass: "bold"
	  }, [_vm._v("Periode:")]), _vm._v(" "), _c('DoDatePickerRange', {
	    attrs: {
	      "allowSameDate": true,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate,
	      "maximumDateRange": 365
	    },
	    on: {
	      "startChanged": function($event) {
	        return _vm.$emit('startChanged', $event)
	      },
	      "endChanged": function($event) {
	        return _vm.$emit('endChanged', $event)
	      }
	    }
	  })], 1), _vm._v(" "), _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n          Fravær der allerede er indberettet, springes over. Åbenstående fravær indberettes uden slutdato —\n          når fraværet senere afsluttes, oprettes en ny indberetning med den rigtige slutdato ved næste kørsel.\n          Indberetningerne lægges i udbakken og sendes automatisk til SD.\n        ")]), _vm._v(" "), (_vm.errorMessage) ? _c('p', {
	    staticClass: "text-explainer text-explainer--danger"
	  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()] : [(_vm.createdFravaer.length === 0) ? _c('p', {
	    staticClass: "italic"
	  }, [_vm._v("\n          Der blev ikke fundet nyt fravær i perioden. Alt fravær er enten allerede indberettet eller mangler\n          fraværskode/ansættelse.\n        ")]) : [_c('p', [_vm._v(_vm._s(_vm.createdFravaer.length) + " " + _vm._s(_vm.createdFravaer.length === 1 ? 'fraværsindberetning' : 'fraværsindberetninger') + " blev lagt i udbakken:")]), _vm._v(" "), _c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("NAVN")]), _vm._v(" "), _c('th', [_vm._v("FRAVÆRSTYPE")]), _vm._v(" "), _c('th', [_vm._v("FRA")]), _vm._v(" "), _c('th', [_vm._v("TIL")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.createdRows), function(item) {
	    return _c('tr', {
	      key: item.id
	    }, [_c('td', {
	      staticClass: "bold"
	    }, [_vm._v(_vm._s(item.vUserName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vAbsenceType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vStartdato))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vSlutdato))])])
	  }), 0)])]]], 2), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', {
	    staticClass: "d-modal__buttons__child"
	  }, [(_vm.createdFravaer === null) ? [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting,
	      'do-bttn--submit--disabled': !_vm.isValid
	    },
	    attrs: {
	      "disabled": !_vm.isValid || _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n            Hent og opret indberetninger\n          ")])] : _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.finish
	    }
	  }, [_vm._v("Luk")])], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 1999 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "quillelement",
	    staticClass: "quill-on-lesson"
	  }, [_c('weip', {
	    attrs: {
	      "textInput": _vm.text,
	      "isInTestOfSaveButton": false,
	      "noteType": _vm.noteType
	    },
	    on: {
	      "changed": _vm.changed
	    }
	  }), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.serverText),
	      expression: "serverText"
	    }],
	    staticClass: "none",
	    attrs: {
	      "name": 'event[' + _vm.noteType + ']',
	      "id": 'event_' + _vm.noteType,
	      "type": "hidden"
	    },
	    domProps: {
	      "value": (_vm.serverText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.serverText = $event.target.value
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2000 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    ref: "copy_event_button",
	    attrs: {
	      "id": "vue-popper__copy_event_button"
	    },
	    on: {
	      "click": _vm.openCopyEventDropdown
	    }
	  }, [_vm._v("\n  " + _vm._s(_vm.$t('vue2.copycalendar.copy')) + " "), _c('span', {
	    staticClass: "icon-arrow-down5 marg-5-left"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2001 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.seen) ? _c('div', {
	    staticClass: "banner",
	    class: {
	      active: _vm.isActive,
	      'isDone': _vm.isDone
	    }
	  }, [_c('div', {
	    staticClass: "banner-header"
	  }, [_c('div', {
	    staticClass: "banner-header__text pointer"
	  }, [_c('span', {
	    on: {
	      "click": function($event) {
	        _vm.isActive = !_vm.isActive
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-play3"
	  }), _vm._v(" VIDEO: Føj til startskærm")])]), _vm._v(" "), _c('div', {
	    staticClass: "close",
	    on: {
	      "click": _vm.setSeen
	    }
	  }, [_c('span', {
	    staticClass: "black-close box-shadow icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "banner-body"
	  }, [_c('youtube', {
	    attrs: {
	      "video-id": _vm.videoid,
	      "player-width": _vm.w,
	      "player-height": _vm.h
	    }
	  })], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2002 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.isOpenModal) ? _c('DModal', {
	    staticClass: "d-modal standard-duration",
	    attrs: {
	      "showClose": false,
	      "isBgOverlay": true
	    },
	    on: {
	      "close": _vm.closeModal
	    }
	  }, [_c('template', {
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.set_standard_duration.set_standard_duration_for_the_school')))]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.set_standard_duration.standard_duration_for_the_school')))]), _vm._v(" "), _c('div', {
	    staticClass: "input-minutes-container"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.inputDuration),
	      expression: "inputDuration"
	    }],
	    ref: "duration_input",
	    attrs: {
	      "type": "number",
	      "id": "standard-duration-input",
	      "maxlength": "4"
	    },
	    domProps: {
	      "value": (_vm.inputDuration)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.inputDuration = $event.target.value
	      }
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.set_standard_duration.minutes')) + "\n        ")]), _vm._v(" "), (!_vm.isAValidDuration) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.set_standard_duration.the_number_must_be_divisible_by_five')) + " ")]) : _vm._e()]), _vm._v(" "), (_vm.isForImportInZEN) ? _c('h4', {
	    staticClass: "marg-2-top standard-duration__explained text-explainer"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.set_standard_duration.set_standard_length_for_zen')) + "\n      ")]) : _c('div', {
	    staticClass: "marg-2-top"
	  }, [_c('ul', {
	    staticClass: "disc"
	  }, [_c('li', [_vm._v(_vm._s(_vm.$t('vue2.set_standard_duration.this_setting_will_be_selected_if_nothing_else_is')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('vue2.set_standard_duration.standard_duration_can_be_selected_for_each_course')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('vue2.set_standard_duration.already_created_courses_want_be_updated')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "marg-5-right",
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isAValidDuration) ? _c('button', {
	    staticClass: "submit-button submit-button--disabled"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")]) : _c('button', {
	    staticClass: "submit-button submit-button--danger bttn bttn--primary",
	    class: {
	      'bttn--loading': _vm.isButtonLoading
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])])], 2) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2003 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "do-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2', [_vm._v("Grupper med pædagogoptælling")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [_c('section', {
	    staticClass: "modal-section"
	  }, [_c('h4', [_vm._v("Grupper uden forberedelsesfaktor")]), _vm._v(" "), _c('p', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v("\n          For disse grupper sættes\n          forberedelsesfaktoren\n          til 0, så undervisningstimer ikke automatisk udløser forberedelsestid.\n          "), _c('a', {
	    attrs: {
	      "href": "https://docendohelp.crisp.help/da/article/optaelling-af-timer-pa-paedagoger-arsnorm-1ww8w39",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, [_vm._v("Læs evt. mere i den uddybende vejledning")]), _vm._v(".\n        ")]), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Grupper',
	      "tags": _vm.tags,
	      "selectedTags": _vm.selectedTags,
	      "numberOfSelectedTagsToShow": 6,
	      "placeholder": 'Vælg grupper'
	    },
	    on: {
	      "select": _vm.toggleTag,
	      "clear": _vm.clearTags
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "modal-section marg-2-top"
	  }, [_c('h4', [_vm._v("Grupper hvor arbejdstid tælles som sum af alle skemalagte timer")]), _vm._v(" "), _c('p', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v("\n          For disse grupper tælles\n          skemalagt arbejdstid\n          som summen af alle skemalagte timer (fx SFO-tid, UV-tid, vikartimer osv.) i stedet for backendens beregnede arbejdstid.\n        ")]), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Grupper',
	      "tags": _vm.tags,
	      "selectedTags": _vm.selectedTagsSumWorkHours,
	      "numberOfSelectedTagsToShow": 6,
	      "placeholder": 'Vælg grupper'
	    },
	    on: {
	      "select": _vm.toggleTagSumWorkHours,
	      "clear": _vm.clearTagsSumWorkHours
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn marg-1-right",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSaving
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 2004 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "scheduler"
	  }, [_c('ul', {
	    staticClass: "scheduler__header"
	  }, [_c('li', [_c('b', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "scroll",
	      rawName: "v-scroll",
	      value: (_vm.handleScrollTop),
	      expression: "handleScrollTop"
	    }],
	    ref: "topDiv",
	    staticClass: "do-scroller do-scroller--hide"
	  }, [_c('ul', {
	    staticClass: "scheduler__header__times"
	  }, _vm._l((_vm.hoursInLocale), function(number) {
	    return _c('li', [_vm._v(_vm._s(_vm.$filters.LT(number)))])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "scheduler__container"
	  }, [_c('div', {
	    staticClass: "do-scroller__container"
	  }, [_c('div', {
	    directives: [{
	      name: "scroll",
	      rawName: "v-scroll",
	      value: (_vm.handleScrollLeft),
	      expression: "handleScrollLeft"
	    }],
	    ref: "leftDiv",
	    staticClass: "do-scroller do-scroller-max-height do-scroller--hide do-scroller__users"
	  }, [_c('ul', {
	    staticClass: "scheduler__users"
	  }, _vm._l((_vm.itemsSorted), function(item, idx) {
	    return _c('li', {
	      key: item.id,
	      class: {
	        'item-is-headline': item.headline
	      },
	      style: ({
	        'height': 40 * _vm.rows[item.id] + 'px'
	      })
	    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "scheduler__cal"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "scheduler__cal--loading"
	  }, [_c('Spinner', {
	    staticStyle: {
	      "margin-top": "-120px"
	    },
	    attrs: {
	      "color": "blue"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "do-scroller__container"
	  }, [_c('div', {
	    directives: [{
	      name: "scroll",
	      rawName: "v-scroll",
	      value: (_vm.handleScrollRight),
	      expression: "handleScrollRight"
	    }],
	    ref: "rightDiv",
	    staticClass: "do-scroller do-scroller-max-height do-scroller--hide"
	  }, [_c('ul', {
	    staticClass: "scheduler__cal__ress"
	  }, [_c('ul', {
	    staticClass: "scheduler__cal__ress__items"
	  }, _vm._l((_vm.itemsSorted), function(item) {
	    return _c('SchedulerItem', {
	      key: item.id,
	      attrs: {
	        "user": item
	      },
	      on: {
	        "rows": function($event) {
	          return _vm.setRows($event, item.id)
	        }
	      }
	    })
	  }), 1), _vm._v(" "), _c('ul', {
	    staticClass: "scheduler__cal__timeslots"
	  }, _vm._l((_vm.hoursInLocale.length * 2), function(n) {
	    return _c('li')
	  }), 0)])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2005 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.isDropdown) ? _c('div', {
	    ref: "copy_event_panel",
	    staticClass: "copy-event text-dark"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fadeInDown"
	    }
	  }, [(_vm.isDropdownPopperDone) ? _c('div', {
	    staticClass: "copy-event__panel"
	  }, [_c('h3', {
	    style: ({
	      'backgroundColor': _vm.event.color
	    })
	  }, [(_vm.isBulk) ? [_vm._v("\n          " + _vm._s(_vm.$t('vue2.copycalendar.copy')) + " " + _vm._s(_vm.bulkEventIds.length) + " " + _vm._s(_vm.bulkLessonsLabel) + "\n        ")] : [_vm._v("\n          " + _vm._s(_vm.$t('vue2.copycalendar.copy')) + " " + _vm._s(_vm.event.title) + ", " + _vm._s(_vm.showDateAndTime) + "\n        ")]], 2), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle copy-event__panel__close-cross",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.closeDropdown.apply(null, arguments)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "copy-event__panel__container"
	  }, [_c('div', {
	    staticClass: "weeks-container"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.componentActiveSchoolYearId),
	      expression: "componentActiveSchoolYearId"
	    }],
	    staticClass: "school-year-selector",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.componentActiveSchoolYearId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.activeSchoolYears), function(year) {
	    return _c('option', {
	      key: year.id,
	      domProps: {
	        "value": year.id
	      }
	    }, [_vm._v("\n              " + _vm._s(year.name) + "\n            ")])
	  }), 0), _vm._v(" "), _c('ul', {
	    staticClass: "weeks"
	  }, [(_vm.weeks.length < 1) ? [_c('Spinner', {
	    staticStyle: {
	      "margin-bottom": "100px"
	    },
	    attrs: {
	      "color": "blue"
	    }
	  })] : _vm._l((_vm.weeks), function(week) {
	    return _c('li', {
	      key: week.serverDate,
	      staticClass: "weeks__week hint--top",
	      class: [{
	          'weeks__week--is-selected': _vm.isWeekSelected(week)
	        },
	        {
	          'weeks__week--is-copy-week': _vm.isCopyWeek(week)
	        }
	      ],
	      attrs: {
	        "aria-label": _vm.tooltipDate(week.date)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setSelectedWeek(week)
	        }
	      }
	    }, [_vm._v("\n                " + _vm._s(_vm._f("showWeek")(week.date)) + "\n                "), (_vm.isNow(week)) ? _c('span', {
	      staticClass: "weeks__week__now-indicator"
	    }) : _vm._e()])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "copy-event__panel__sidebar"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.markWeeksFrom')) + "\n            " + _vm._s(_vm._f("showWeek")(_vm.copyDate)))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn width-100 btn-trans",
	    on: {
	      "click": _vm.addAllWeeksOnward
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.copycalendar.allWeeks')) + "\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn width-100 btn-trans",
	    on: {
	      "click": _vm.selectOddWeeks
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.copycalendar.oddWeeks')) + "\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn width-100 btn-trans",
	    on: {
	      "click": _vm.selectEvenWeeks
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.copycalendar.evenWeeks')) + "\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn btn-trans width-100 btn-remove",
	    on: {
	      "click": _vm.removeAllSelectedWeeks
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.copycalendar.unselectAll')) + "\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "copy-event__panel__footer"
	  }, [(_vm.selectedWeeks.length < 1) ? _c('button', {
	    staticClass: "bttn bttn--disabled"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.paste')) + "\n        ")]) : _c('button', {
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.paste')))])])]) : _vm._e()]), _vm._v(" "), (_vm.isDropdown) ? _c('div', {
	    ref: "d_copy_event_overlay",
	    staticClass: "copy-event__overlay",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.closeDropdown.apply(null, arguments)
	      }
	    }
	  }) : _vm._e()], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2006 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "scheduler_user",
	    class: [{
	        'isAbsence': _vm.user.dayAbsence.length > 0
	      },
	      {
	        'isPotentialSub': _vm.user.dayAbsence.length < 1
	      },
	      {
	        'item-is-headline': _vm.user.headline
	      }
	    ],
	    style: ({
	      'min-height': _vm.userMinHeight
	    }),
	    on: {
	      "mouseenter": function($event) {
	        _vm.isShowSelectButton = true
	      },
	      "mouseleave": function($event) {
	        _vm.isShowSelectButton = false
	      }
	    }
	  }, [_vm._l((_vm.correctEventsFiltered), function(event) {
	    return _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return event.obj.hasOwnProperty('v_is_event_from_other_school'); }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => event.obj.hasOwnProperty('v_is_event_from_other_school')\n            }"
	      }],
	      key: _vm.user.id + '_' + event.obj.id,
	      ref: _vm.calEvent,
	      refInFor: true,
	      staticClass: "day-cal__event day-cal__event__lesson",
	      class: [{
	          'isActiveEvent animated bigPulseTwo infinite': _vm.activeEvent && event.obj.id === _vm.activeEvent.obj.id && _vm.activeUser && _vm.user.id === _vm.activeUser.id
	        },
	        {
	          'day-cal__event__handled': event.obj.v_status === 1
	        },
	        {
	          'day-cal__event__pending': event.obj.v_status === 2
	        },
	        {
	          'day-cal__event day-cal__event__lesson--from-other-school': event.obj.v_is_event_from_other_school
	        },
	        {
	          'day_cal__event__lesson__overlaps_absent': event.overlapsAbsent,
	          'day_cal__event__lesson__canceled': event.obj.canceled
	        },
	        event.subs.length > 0 ? 'hint--left hint--success' : 'hint--right'
	      ],
	      style: ([{
	          'top': event.row * 26 + _vm.hasAbsence + 'px'
	        },
	        {
	          'left': event.left + 'px'
	        },
	        {
	          'right': event.right + 'px'
	        },
	        {
	          'height': '25px'
	        }
	      ]),
	      attrs: {
	        "data-key": _vm.user.id + '_' + event.obj.id,
	        "content": _vm.i18n['from_another_school'],
	        "aria-label": _vm.allOnLessonHumanized(event)
	      }
	    }, [_c('div', {
	      staticClass: "day-cal__event__content",
	      on: {
	        "click": function($event) {
	          return _vm.setPopover(event, $event)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "day-cal__event__subs"
	    }, [(event.othersOnLessonForBadge.length > 0) ? _c('div', {
	      staticClass: "day-cal__event__other"
	    }, [_vm._v("\n          +"), _c('span', {
	      staticClass: "icon-user"
	    })]) : _vm._e(), _vm._v(" "), _vm._l((event.subs), function(sub) {
	      return _c('img', {
	        staticClass: "day-cal__event__subs__img",
	        attrs: {
	          "src": sub && sub.default_thumb_url ? sub.default_thumb_url : '',
	          "alt": sub && sub.name ? sub.name : ''
	        }
	      })
	    })], 2), _vm._v(" "), _c('div', {
	      staticClass: "day-cal__event__content__title"
	    }, [_c('span', {
	      staticClass: "nowrap day-cal__event__content__title__title"
	    }, [_vm._v(_vm._s(event.obj.title))]), _vm._v(" "), (event.klassesOnLesson.length > 0) ? _c('span', {
	      staticClass: "nowrap day-cal__event__content__title__grade"
	    }, [_vm._v(_vm._s(event.klassesAsString))]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "day-cal__event__bg",
	      style: ({
	        backgroundColor: event.obj.color
	      })
	    }), _vm._v(" "), _c('div', {
	      staticClass: "day-cal__event__sider",
	      style: ({
	        backgroundColor: event.obj.color
	      })
	    })])])
	  }), _vm._v(" "), _vm._l((_vm.userPresenceForPlacing), function(presence) {
	    return (_vm.userAbsence.length < 1) ? _c('div', {
	      key: presence.obj.id,
	      staticClass: "day-cal__event work_hours",
	      style: ([{
	          'left': presence.left + 'px'
	        },
	        {
	          'right': presence.right + 'px'
	        }
	      ])
	    }) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.userAbsenceForPlacing), function(absence) {
	    return _c('div', {
	      key: absence.obj.id,
	      staticClass: "user_absence pointer",
	      class: {
	        'user_absence--stacked': absence.stackTop > 0
	      },
	      style: ([{
	          'left': absence.left + 'px'
	        },
	        {
	          'right': absence.right + 'px'
	        },
	        {
	          'top': absence.stackTop + 'px'
	        },
	        {
	          'height': absence.stackHeight
	        }
	      ]),
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setPopover(absence)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "user_absence__text",
	      domProps: {
	        "innerHTML": _vm._s(_vm.getAbsenceTitle(absence.obj))
	      }
	    })])
	  }), _vm._v(" "), (_vm.isShowSetAsSubButton) ? _c('div', {
	    staticClass: "select-user__button",
	    class: {
	      'select-user__button--loading': _vm.selectButtonLoading
	    },
	    style: ({
	      left: (_vm.styleObj.left + 2) + 'px',
	      right: (_vm.styleObj.right + 2) + 'px',
	      backgroundColor: _vm.styleObj.color
	    }),
	    on: {
	      "click": _vm.setAddSubstitute
	    }
	  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeEventsFiltered), function(activeEvent) {
	    return _c('div', {
	      staticClass: "select-user__button",
	      class: {
	        'select-user__button--loading': _vm.isActiveEventsLoading
	      },
	      style: ({
	        left: (activeEvent.left + 2) + 'px',
	        right: (activeEvent.right + 2) + 'px',
	        backgroundColor: activeEvent.color
	      }),
	      on: {
	        "click": _vm.addSubToActiveEvents
	      }
	    })
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 2007 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('div', {
	    staticClass: "box grid grid-responsive week_notes_lesson_note",
	    style: ({
	      borderColor: _vm.event.color
	    })
	  }, [_c('div', {
	    staticClass: "col-2-12 box-size"
	  }, [_c('span', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.event.title) + "\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.$filters.timeStamp(_vm.event.start)) + " - " + _vm._s(_vm.$filters.timeStamp(_vm.event.end))), _c('br')])]), _vm._v(" "), _c('div', {
	    staticClass: "col-10-12"
	  }, [_c('div', {
	    staticClass: "col-1-3"
	  }, [_c('div', {
	    staticClass: "word-break",
	    domProps: {
	      "innerHTML": _vm._s(_vm.learningGoal)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-1-3"
	  }, [_c('div', {
	    staticClass: "word-break",
	    domProps: {
	      "innerHTML": _vm._s(_vm.description)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-1-3"
	  }, [_c('div', {
	    staticClass: "word-break",
	    domProps: {
	      "innerHTML": _vm._s(_vm.notes_for_students)
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 2008 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-touch', {
	    staticClass: "day-cal__overlay",
	    attrs: {
	      "pan-options": {
	        direction: 'horizontal',
	        threshold: 4
	      }
	    },
	    on: {
	      "panleft": _vm.onPan,
	      "panright": _vm.onPan,
	      "panstart": _vm.setPanStart,
	      "panend": _vm.onPanEnd
	    }
	  }, [_c('div', {
	    staticClass: "days-container",
	    style: ({
	      transform: 'translate3d(' + _vm.translateX + '%, 0, 0)'
	    })
	  }, [_vm._l((_vm.calendars), function(cal) {
	    return [_c('div', {
	      staticClass: "day",
	      style: ({
	        webkitTransform: 'translate3d(' + cal.style + '%, 0,0)'
	      })
	    }, [_c('transition', {
	      attrs: {
	        "name": "fadeDown"
	      }
	    }, [_c('mobile-datepicker', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.isActive),
	        expression: "isActive"
	      }],
	      attrs: {
	        "date": cal.date,
	        "theCalendarDate": _vm.theCalendarDate
	      },
	      on: {
	        "changed": _vm.setCalDate
	      }
	    })], 1)], 1)]
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2009 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'salary-settings-container': _vm.isInSchoolSalarySettings
	    }
	  }, [(_vm.isLoadingSalaryCodes) ? _c('Loader', {
	    attrs: {
	      "bg-color": _vm.isInSchoolSalarySettings ? '#edf0f5' : '#fff'
	    }
	  }) : _c('table', {
	    staticClass: "do-table do-table--striped do-table--fixed"
	  }, [_c('thead', [_c('th', {
	    staticClass: "td-loenart"
	  }, [_vm._v("Lønart")]), _vm._v(" "), _c('th', {
	    staticClass: "td-tillaegsnummer"
	  }, [_vm._v("Tillægsnummer")]), _vm._v(" "), _c('th', {
	    staticClass: "td-navn"
	  }, [_c('div', {
	    staticClass: "th-text-and-button"
	  }, [_vm._v("\n        Navn\n        "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": function($event) {
	        return _vm.setIsCreateItemModal(true)
	      }
	    }
	  }, [_vm._v("\n          Opret ny lønkode\n        ")])])])]), _vm._v(" "), _c('tbody', [(_vm.items.length === 0) ? _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('i', [_vm._v("Ingen oprettet")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(item) {
	    return _c('tr', {
	      key: item.code
	    }, [_c('td', {
	      staticClass: "td-loenart"
	    }, [_vm._v(_vm._s(item.code))]), _vm._v(" "), _c('td', {
	      staticClass: "td-tillaegsnummer"
	    }, [_vm._v(_vm._s(item.tillaegsnummer ? item.tillaegsnummer : ''))]), _vm._v(" "), _c('td', {
	      staticClass: "td-navn"
	    }, [_vm._v(_vm._s(item.name))])])
	  })], 2)]), _vm._v(" "), (_vm.isCreateItemModal) ? _c('TableCreateModal', {
	    attrs: {
	      "theType": 'lønkoder',
	      "theEditItem": _vm.theEditItem,
	      "isSubmitting": _vm.isSubmitting,
	      "isDeleting": _vm.isDeleting,
	      "salarySystem": _vm.salarySystem,
	      "submitError": _vm.submitError
	    },
	    on: {
	      "close": _vm.setIsCreateItemModal,
	      "onSubmit": _vm.onCreate
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2010 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-container",
	    class: {
	      'd-container--active': _vm.isDropDown
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.setDropdownFromClick),
	      expression: "setDropdownFromClick"
	    }],
	    ref: "d_parent",
	    staticClass: "d-select__selected",
	    class: {
	      'd-select__selected__dropdown': _vm.isMultiple && _vm.sortedCalendars.length > 1
	    },
	    on: {
	      "click": _vm.setDropdown
	    }
	  }, [_c('h5', [_vm._v(_vm._s(_vm.activeCalendarName))]), _vm._v(" "), _c('svg', {
	    staticClass: "tw-icon tw-icon-cheveron-selection",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "fill-rule": "evenodd",
	      "d": "M8.7 9.7a1 1 0 1 1-1.4-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 1 1-1.4 1.4L12 6.42l-3.3 3.3zm6.6 4.6a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
	    }
	  })])]), _vm._v(" "), (_vm.isDropDown) ? _c('div', {
	    ref: "d_child",
	    staticClass: "d-select__dropdown",
	    class: {
	      'd-dropdown--animate': _vm.isPopperReady,
	      'd-dropdown--show': _vm.isPopperDone
	    }
	  }, [_c('div', {
	    staticClass: "d-select-input",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-search5"
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search),
	      expression: "search"
	    }],
	    ref: "inputsearch",
	    attrs: {
	      "type": "search"
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('ul', _vm._l((_vm.calendarQuery), function(calendar) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.selectCalendar(calendar.id)
	        }
	      }
	    }, [_c('p', [_vm._v(_vm._s(calendar.name))])])
	  }), 0)]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2011 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrapper",
	    staticStyle: {
	      "height": "1600px"
	    },
	    attrs: {
	      "id": "djs-body-click"
	    }
	  }, [_c('div', {
	    staticClass: "header"
	  }), _vm._v(" "), _c('SideNav'), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin": "1rem 1rem 1rem 75px"
	    },
	    attrs: {
	      "id": "djs-content-container"
	    }
	  }, [_c('AssignHours')], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2012 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "calendar-guide text-dark"
	  }, [(_vm.isModal) ? _c('d-modal', {
	    attrs: {
	      "show-close": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "modal__left"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.create_a_link_on_mobile')))]), _vm._v(" "), _c('ul', {
	    staticClass: "export-calendar__cals"
	  }, _vm._l((_vm.integrations), function(integration) {
	    return _c('li', {
	      key: integration.id,
	      class: {
	        'cal--is-active': _vm.theActiveIntegration === integration.id
	      },
	      on: {
	        "click": function($event) {
	          _vm.theActiveIntegration = integration.id
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(integration.title) + "\n            ")])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "modal__right"
	  }, [_c('h4', {
	    staticClass: "marg-2-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.guide_to')) + " " + _vm._s(_vm.integrations[_vm.theActiveIntegration].title))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.theActiveIntegration === 0),
	      expression: "theActiveIntegration === 0"
	    }],
	    staticClass: "embed-container"
	  }, [_c('iframe', {
	    attrs: {
	      "src": "https://www.youtube.com/embed/Vkw-bVsvkq4",
	      "frameborder": "0",
	      "allowfullscreen": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.theActiveIntegration === 1),
	      expression: "theActiveIntegration === 1"
	    }],
	    staticClass: "embed-container"
	  }, [_c('iframe', {
	    attrs: {
	      "src": "https://www.youtube.com/embed/Idpmc8dcFV0",
	      "frameborder": "0",
	      "allowfullscreen": ""
	    }
	  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.isModal) ? _c('div', {
	    staticClass: "bg-overlay",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2013 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-box"
	  }, [_c('div', {
	    staticClass: "user-tasks__header"
	  }, [_c('div', [(_vm.isShowScheduled) ? _c('label', {
	    staticClass: "d-label no-print"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.task_overview.showing_scheduled_hours_from')) + " " + _vm._s(_vm.dates) + " (" + _vm._s(_vm.numberOfWorkDaysInPeriod) + "\n        " + _vm._s(_vm.i18n['work_days']) + ")\n      ")]) : _vm._e(), _vm._v(" "), _c('h4', {
	    staticClass: "only-print"
	  }, [_vm._v(_vm._s(_vm.user.name) + ", " + _vm._s(_vm.dates))])]), _vm._v(" "), (_vm.isShowHeader) ? _c('div', {
	    staticClass: "d-input-group no-print no-mobile"
	  }, [_c('label', {
	    staticClass: "d-label",
	    staticStyle: {
	      "margin-bottom": "6px"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.show_scheduled_hours')) + " ")]), _vm._v(" "), _c('div', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.setIsShowScheduled(!_vm.isShowScheduled)
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "propOn": _vm.isShowScheduled
	    }
	  })], 1)]) : _vm._e()]), _vm._v(" "), (_vm.userNorm.length > 0) ? _c('table', {
	    staticClass: "d-table marg-1-bottom d-table__overview"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.userNormFormatted), function(item, idx) {
	    return (idx < _vm.userNorm.length - 1) ? _c('tr', {
	      key: item.title
	    }, [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(item.value))])]) : _vm._e()
	  }), 0), _vm._v(" "), _c('tfoot', _vm._l((_vm.userNormFormatted), function(item, idx) {
	    return (idx === _vm.userNorm.length - 1) ? _c('tr', {
	      key: item.title
	    }, [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(item.value))])]) : _vm._e()
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isKindergarten) ? _c('UserTasksOverviewKindergarten', {
	    attrs: {
	      "isShowScheduled": _vm.isShowScheduled,
	      "isDateIntervalChanged": _vm.isDateIntervalChanged,
	      "assignedTotalHoursForYear": _vm.getUserHoursOverview.assigned_total_hours,
	      "assignedTotalHoursForPeriod": _vm.assignedTotalHoursForPeriod,
	      "diffTotalHoursForPeriod": _vm.diffTotalHoursForPeriod,
	      "userActualHours": _vm.userActualHours,
	      "getUserHoursOverview": _vm.getUserHoursOverview,
	      "tooltipContent": _vm.tooltipContent,
	      "numberOfWorkDays": _vm.numberOfWorkDays,
	      "numberOfWorkDaysInPeriod": _vm.numberOfWorkDaysInPeriod
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isKindergarten) ? _c('table', {
	    staticClass: "d-table marg-1-bottom d-table__overview"
	  }, [_c('thead', [_c('tr', [_c('th', [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.distribution')))])]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.getIsCategoryVisible('work_hours')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.work_hours')))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v("100%")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        animateFill: false,
	        animation: 'shift-away',
	        onShow: function () { return _vm.isDateIntervalChanged; }
	      }),
	      expression: "{\n          animateFill: false,\n          animation : 'shift-away',\n        onShow: () => isDateIntervalChanged\n      }"
	    }],
	    staticClass: "is-number",
	    class: {
	      'is-number--calculated': _vm.isDateIntervalChanged
	    },
	    attrs: {
	      "content": _vm.schoolTooltipContent
	    }
	  }, [(_vm.isDateIntervalChanged) ? _c('span', {
	    staticClass: "icon-clock"
	  }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.assignedTotalHoursForPeriod) + "\n      ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_total_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator(_vm.diffTotalHoursForPeriod))
	  }, [_vm._v("\n        " + _vm._s(_vm.diffTotalHoursForPeriod) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getIsCategoryVisible('teaching')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.teaching')))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfTeaching))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.assigned_teaching_hours))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_teaching_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator(_vm.getUserHoursOverview.diff_teaching_hours))
	  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.diff_teaching_hours) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getIsCategoryVisible('tasks')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.tasks')))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfTasks))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.assigned_additional_task_hours))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_additional_task_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.diff_additional_task_hours) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getIsCategoryVisible('preparation')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.preparation')))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfPrep))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.assigned_preparation_hours))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_preparation_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.diff_preparation_hours) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getUserHoursOverview.assigned_pool_hours > 0 && _vm.getIsCategoryVisible('pool')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.localPoolTitle))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfPool))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.assigned_pool_hours))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_pool_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.diff_pool_hours) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getUserHoursOverview.substitute_pool_hours > 0 && _vm.getIsCategoryVisible('substitute_hours')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.substitute_hours')))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfSubPool))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.substitute_pool_hours))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_substitute_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator(_vm.getUserHoursOverview.diff_substitute_hours))
	  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.diff_substitute_hours) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getUserHoursOverview.assigned_club_hours > 0 && _vm.getIsCategoryVisible('club')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.club')))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfClub))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.assigned_club_hours))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_club_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator(_vm.getUserHoursOverview.diff_club_hours))
	  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.diff_club_hours) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isSchoolGlHjortespring && _vm.getIsCategoryVisible('teaching_and_club')) ? _c('tr', [_c('td', [_vm._v("Undervisning + SFO")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.assigned_teaching_hours + _vm.getUserHoursOverview.assigned_club_hours) + "\n      ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.actual_teaching_hours + _vm.getUserHoursOverview.actual_club_hours) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator((_vm.getUserHoursOverview.assigned_teaching_hours + _vm.getUserHoursOverview.assigned_club_hours) - (_vm.getUserHoursOverview.actual_teaching_hours + _vm.getUserHoursOverview.actual_club_hours)))
	  }, [_vm._v("\n        " + _vm._s(_vm.toFixedIfNecessary((_vm.getUserHoursOverview.assigned_club_hours + _vm.getUserHoursOverview.assigned_teaching_hours) - (_vm.getUserHoursOverview.actual_teaching_hours + _vm.getUserHoursOverview.actual_club_hours))) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isShowSubsAndTeachingActive && _vm.getIsCategoryVisible('teaching_and_sub')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.titleForTeachingAndSubstituteHoursTotal))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.substitute_pool_hours + _vm.getUserHoursOverview.assigned_teaching_hours) + "\n      ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.toFixedIfNecessary(_vm.getUserHoursOverview.actual_teaching_hours + _vm.getUserHoursOverview.actual_substitute_hours)) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator((_vm.getUserHoursOverview.substitute_pool_hours + _vm.getUserHoursOverview.assigned_teaching_hours) - (_vm.getUserHoursOverview.actual_teaching_hours + _vm.getUserHoursOverview.actual_substitute_hours)))
	  }, [_vm._v("\n        " + _vm._s(_vm.toFixedIfNecessary((_vm.getUserHoursOverview.substitute_pool_hours + _vm.getUserHoursOverview.assigned_teaching_hours) - (_vm.getUserHoursOverview.actual_teaching_hours + _vm.getUserHoursOverview.actual_substitute_hours))) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getUserAssignedTotalHours > 0) ? _c('tr', [_c('td', [(_vm.getDistributionDifference < 0) ? _c('span', {
	    staticClass: "d-bagde d-badge--warning"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.diff_from_total_workhours')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.rest')))])]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getPercentageOfDifference))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [(_vm.getDistributionDifference > 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        animateFill: false,
	        animation: 'shift-away'
	      }),
	      expression: "{animateFill: false, animation: 'shift-away'}"
	    }],
	    staticClass: "d-bagde d-badge--green",
	    attrs: {
	      "content": _vm.$t('vue2.task_overview.rest_missing_tooltip', {
	        hours: _vm.getDistributionDifference
	      })
	    }
	  }, [_vm._v("-" + _vm._s(_vm.getDistributionDifference))]) : (_vm.getDistributionDifference < 0) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        animateFill: false,
	        animation: 'shift-away'
	      }),
	      expression: "{animateFill: false, animation: 'shift-away'}"
	    }],
	    staticClass: "d-bagde d-badge--warning",
	    attrs: {
	      "content": _vm.$t('vue2.task_overview.rest_too_many_tooltip', {
	        hours: _vm.toFixedIfNecessary(Math.abs(_vm.getDistributionDifference))
	      })
	    }
	  }, [_vm._v("+" + _vm._s(_vm.toFixedIfNecessary(Math.abs(_vm.getDistributionDifference))))]) : _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        animateFill: false,
	        animation: 'shift-away'
	      }),
	      expression: "{animateFill: false, animation: 'shift-away'}"
	    }],
	    attrs: {
	      "content": _vm.$t('vue2.task_overview.rest_balanced_tooltip')
	    }
	  }, [_vm._v("0")])]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.schoolSettingShownOwnPools.length > 0) ? _c('UserTasksOverviewOwnPools', {
	    attrs: {
	      "schoolSettingShownOwnPools": _vm.schoolSettingShownOwnPools,
	      "isShowScheduled": _vm.isShowScheduled,
	      "isDateIntervalChanged": _vm.isDateIntervalChanged,
	      "userTasks": _vm.userTasksFiltered
	    }
	  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.userTasksFiltered), function(tasks) {
	    return _c('div', {
	      staticClass: "marg-1-bottom"
	    }, [(tasks.title === 'substitute_hours') ? _c('UserTasksTableSubstituteHours', {
	      attrs: {
	        "title": tasks.title,
	        "tasks": tasks.tasks,
	        "userCalendarId": _vm.user.user_calendar_id,
	        "userId": _vm.user.id,
	        "assignedHours": _vm.getUserAssignedTeachingHours,
	        "isShowScheduled": _vm.isShowScheduled
	      }
	    }) : _c('UserTasksTable', {
	      attrs: {
	        "title": tasks.title,
	        "tasks": tasks.tasks,
	        "userCalendarId": _vm.user.user_calendar_id,
	        "userId": _vm.user.id,
	        "assignedHours": _vm.getUserAssignedTeachingHours,
	        "isShowScheduled": _vm.isShowScheduled,
	        "isPreviewAsEmployee": _vm.isPreviewAsEmployee,
	        "schoolThresholdToHideTaskHours": _vm.schoolThresholdToHideTaskHours,
	        "canEditTasks": _vm.canEditTasks,
	        "userCalendarIdForTransfer": _vm.user.user_calendar_id,
	        "isFullPeriodSelected": _vm.isFullPeriodSelected,
	        "canTransferScheduled": _vm.canTransferScheduled
	      },
	      on: {
	        "edit": _vm.setEditSubject,
	        "transferScheduled": _vm.transferScheduledToAssigned,
	        "assignTeacher": _vm.openAssignTeacherDialog
	      }
	    })], 1)
	  }), _vm._v(" "), (_vm.isKmdUserQuotaActive && _vm.canSeeKmdUserQuota) ? _c('UserQuota', {
	    attrs: {
	      "userId": _vm.user.id,
	      "date": _vm.startDate
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "active-user__agreements"
	  }, [_c('SubjectsDistributionUserAgreements', {
	    attrs: {
	      "isReadAgreements": false,
	      "userAgreements": _vm.userAgreements,
	      "userId": _vm.activeUserId
	    }
	  })], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-modal"
	    }
	  }, [(_vm.theActiveSubject) ? _c('DModal', {
	    staticStyle: {
	      "border-radius": "4px"
	    },
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": function($event) {
	        _vm.theActiveSubject = null
	      }
	    }
	  }, [_c('SubjectsDistributionUserEditHours', {
	    attrs: {
	      "slot": "insertComponent",
	      "subject": _vm.getTheActiveSubject,
	      "teacher": _vm.getTheActiveUser
	    },
	    on: {
	      "close": function($event) {
	        _vm.theActiveSubject = null
	      }
	    },
	    slot: "insertComponent"
	  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.theActiveSubject) ? _c('div', {
	    staticClass: "bg-overlay",
	    on: {
	      "click": function($event) {
	        _vm.theActiveSubject = null
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.assignTeacherTask) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false,
	      "ariaLabel": _vm.$t('vue2.task_overview.assign_teacher_to_subject_title')
	    },
	    on: {
	      "close": _vm.closeAssignTeacherDialog
	    }
	  }, [_c('div', {
	    staticClass: "do-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.assign_teacher_to_subject_title')))])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body user-tasks__assign-teacher-body"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.task_overview.assign_teacher_to_subject_text', {
	    teacher: _vm.user.name,
	    name: _vm.assignTeacherTask.name,
	    calendar: _vm.assignTeacherTask.calendar
	  })) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer"
	  }, [_c('div', {
	    staticClass: "do-modal__footer__right"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.closeAssignTeacherDialog
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isAssigningTeacher
	    },
	    attrs: {
	      "disabled": _vm.isAssigningTeacher
	    },
	    on: {
	      "click": _vm.assignTeacherToTask
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.task_overview.assign_teacher_to_subject_confirm')) + "\n          ")])])])])]) : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("Timer")])])])
	}]}

/***/ }),
/* 2014 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-header"
	  }, [_c('div', {
	    staticClass: "do-nav do-nav__left"
	  }, [_c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "to": '/plan/' + _vm.schoolId,
	      "active-class": "nav-item--selected"
	    }
	  }, [_c('span', {
	    staticClass: "icon-calendar2"
	  }), _vm._v("\n      Vagtplan\n    ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "to": '/show',
	      "active-class": "nav-item--selected"
	    }
	  }, [_c('span', {
	    staticClass: "icon-clock"
	  }), _vm._v("\n      Arbejdstider\n    ")])], 1), _vm._v(" "), _vm._m(0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "do-nav nav__right"
	  }, [_c('li')])
	}]}

/***/ }),
/* 2015 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticClass: "th-sorter",
	    class: [_vm.sortProp, {
	      'active': _vm.activeSortKey === _vm.sortProp
	    }],
	    on: {
	      "click": _vm.sortBy
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.title) + "\n  "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2016 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "switch",
	    on: {
	      "click": _vm.toggleIsOn
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.isOn),
	      expression: "isOn"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "id": "do-switch"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.isOn) ? _vm._i(_vm.isOn, null) > -1 : (_vm.isOn)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.isOn,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.isOn = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.isOn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.isOn = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "slider round",
	    attrs: {
	      "for": "do-switch"
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2017 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.create_activity.create_new_subject_for')) + " " + _vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.create_activity.title')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.subjectName),
	      expression: "subjectName"
	    }],
	    ref: "d_title_input",
	    staticClass: "d-input",
	    staticStyle: {
	      "height": "34px"
	    },
	    attrs: {
	      "id": "d-title-input-for-new-subject"
	    },
	    domProps: {
	      "value": (_vm.subjectName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.subjectName = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.create_activity.choose_subject_type')))]), _vm._v(" "), _c('SubjectFormSubjectType', {
	    attrs: {
	      "calendarType": 'user'
	    },
	    on: {
	      "change": _vm.setSubjectType
	    }
	  })], 1), _vm._v(" "), (!_vm.isLoadingUserSchools && _vm.isUserHasMultipleSchools) ? _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.choose_school')))]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.theActiveSchoolId),
	      expression: "theActiveSchoolId"
	    }],
	    staticClass: "d-select-with-options",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.theActiveSchoolId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.userSchools), function(school) {
	    return _c('option', {
	      key: school.id,
	      domProps: {
	        "value": school.id
	      }
	    }, [_vm._v("\n            " + _vm._s(school.name) + "\n          ")])
	  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")]) : _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 2018 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "calendar-navigation"
	  }, [_c('button', {
	    staticClass: "nav-button",
	    on: {
	      "click": function($event) {
	        return _vm.navigate('previous')
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "icon",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M15.75 19.5L8.25 12l7.5-7.5"
	    }
	  })])]), _vm._v(" "), _c('button', {
	    staticClass: "nav-button center-button",
	    on: {
	      "click": _vm.goToToday
	    }
	  }, [_vm._v("I dag")]), _vm._v(" "), _c('button', {
	    staticClass: "nav-button",
	    on: {
	      "click": function($event) {
	        return _vm.navigate('next')
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "icon",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M8.25 4.5l7.5 7.5-7.5 7.5"
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2019 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-cal-print text-dark"
	  }, [_c('ul', {
	    staticClass: "d-cal-print__cal"
	  }, _vm._l((_vm.weekDays), function(weekDay) {
	    return _c('li', {
	      key: weekDay.date,
	      staticClass: "d-cal-print__cal__day"
	    }, [_c('ul', [_c('li', {
	      staticClass: "d-cal-print__cal__day__header"
	    }, [_vm._v(_vm._s(weekDay.formatted))]), _vm._v(" "), (weekDay.events.length < 1) ? _c('p', {
	      staticClass: "text-explainer center"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.no_lessons')))]) : _vm._e(), _vm._v(" "), _vm._l((weekDay.events), function(event) {
	      return _c('li', {
	        key: event.event_key,
	        staticClass: "d-cal-print__event",
	        class: {
	          'd-cal-print__event--presence': event.event_type === 'presence'
	        },
	        style: ({
	          backgroundColor: event.color
	        })
	      }, [_c('div', {
	        staticClass: "d-cal-print__event__header"
	      }, [_c('div', {
	        staticClass: "d-cal-print__event__title"
	      }, [_vm._v("\n              " + _vm._s(event.title) + "\n            ")]), _vm._v(" "), _c('div', {
	        staticClass: "d-cal-print__event__time"
	      }, [_vm._v("\n              " + _vm._s(event.event_starttime) + "-" + _vm._s(event.event_endtime) + "\n            ")])]), _vm._v(" "), (event.teacher) ? _c('div', {
	        staticClass: "day-cal__event__calendar"
	      }, [_c('span', {
	        staticClass: "icon-user"
	      }), _vm._v("\n            " + _vm._s(event.teacher) + "\n          ")]) : _vm._e(), _vm._v(" "), (event.room) ? _c('div', {
	        staticClass: "day-cal__event__calendar"
	      }, [_c('span', {
	        staticClass: "icon-location"
	      }), _vm._v("\n            " + _vm._s(event.room) + "\n          ")]) : _vm._e(), _vm._v(" "), (event.group) ? _c('div', {
	        staticClass: "day-cal__event__calendar"
	      }, [_c('span', {
	        staticClass: "icon-users"
	      }), _vm._v("\n            " + _vm._s(event.group) + "\n          ")]) : _vm._e(), _vm._v(" "), (event.students) ? _c('div', {
	        staticClass: "day-cal__event__calendar"
	      }, [_c('span', {
	        staticClass: "icon-users5"
	      }), _vm._v("\n            " + _vm._s(event.students) + "\n          ")]) : _vm._e()])
	    })], 2)])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2020 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal--width text-dark",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-create-task-for-user"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Vælg jeres lønsystem")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "loader-container"
	  }, [_c('Loader', {
	    attrs: {
	      "bgColor": "#f6f9fc"
	    }
	  })], 1) : _c('div', {
	    staticClass: "d-boxes"
	  }, _vm._l((_vm.systems), function(system) {
	    return _c('div', {
	      key: system.value,
	      staticClass: "d-boxes__box",
	      class: {
	        'd-boxes__box--selected': _vm.selected === system.value
	      },
	      on: {
	        "click": function($event) {
	          _vm.selected = system.value
	        }
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selected),
	        expression: "selected"
	      }],
	      attrs: {
	        "type": "radio",
	        "id": 'd-boxes__box_' + system.value
	      },
	      domProps: {
	        "value": system.value,
	        "checked": _vm._q(_vm.selected, system.value)
	      },
	      on: {
	        "change": function($event) {
	          _vm.selected = system.value
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": 'd-boxes__box_' + system.value
	      },
	      domProps: {
	        "innerHTML": _vm._s(system.name)
	      }
	    })])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isLoading
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 2021 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pos-relative"
	  }, [_c('Modal', {
	    attrs: {
	      "show": _vm.showModal,
	      "show_modal_sidebar": _vm.showImportSubjects
	    },
	    on: {
	      "close": _vm.setCloseModal
	    }
	  }, [_c('h1', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [(_vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.createklass.create_klasses')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.createklass.import_subject_to_the_klass')))])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "tabs"
	  }, [(_vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('div', {
	    staticClass: "title"
	  }, [_c('h3', {
	    staticClass: "flex align-center"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createklass.schoolyear')) + "\n            "), _c('ChangeSchoolYear', {
	    staticStyle: {
	      "margin-left": "10px"
	    },
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1)]) : _vm._e()]), _vm._v(" "), (_vm.activeSchoolYears.length > 1 && _vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('a', {
	    attrs: {
	      "href": _vm.copySubjectsSchoolYearUrl
	    }
	  }, [_vm._v("\n        >> " + _vm._s(_vm.$t('vue2.year_transfer.year_transfer_link')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "content pos-relative"
	  }, [_c('div', {
	    staticClass: "flex modal-form__titles"
	  }, [_c('h3', {
	    staticClass: "flex-1"
	  }, [(_vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.createklass.klass_name')))]) : _c('span', [_vm._v("Klasser uden fag")])]), _vm._v(" "), (_vm.showImportSubjects) ? _c('h3', {
	    staticClass: "flex-2"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createklass.klass_step')))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.klasses), function(klass, key) {
	    return _c('div', {
	      key: klass.id,
	      staticClass: "modal-form-group",
	      class: [{
	        'bgDelete': klass.deleteClass
	      }, {
	        'modal-form-group__already_created_klass': _vm.alreadyCreatedKlassesToImportSubjectTo.length > 0
	      }, {
	        'modal-form-group--first': key === 0
	      }]
	    }, [_c('div', {
	      staticClass: "flex create-form"
	    }, [(_vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('div', {
	      staticClass: "flex-1"
	    }, [_c('input', {
	      ref: 'klass-' + klass.id,
	      refInFor: true,
	      staticClass: "namefield",
	      class: [{
	        'missing-input': !klass.isValid
	      }, {
	        'missing-input': klass.isSameName
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": "1.a"
	      },
	      on: {
	        "input": function($event) {
	          return _vm.checkAllForText(klass, key, $event.target.value)
	        }
	      }
	    })]) : _c('div', {
	      staticClass: "flex-1 create-form__name"
	    }, [_vm._v("\n              " + _vm._s(klass.name) + "\n            ")]), _vm._v(" "), (_vm.showImportSubjects) ? _c('div', {
	      staticClass: "import-klass flex-2"
	    }, _vm._l((_vm.stepNumbers), function(klassStep, key) {
	      return _c('div', {
	        staticClass: "import-klass__step",
	        class: [{
	            'lastStep': key === (_vm.stepNumbers.length - 1)
	          },
	          {
	            'firstStep': key === 0
	          },
	          {
	            'isActive': klass.template === klassStep
	          }
	        ],
	        on: {
	          "click": function($event) {
	            return _vm.setKlassImport(klass, klassStep, $event)
	          },
	          "mouseenter": function($event) {
	            return _vm.mouseOverStep(klassStep, $event, klass)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "import-klass__step__inner"
	      }, [_vm._v(_vm._s(klassStep))])])
	    }), 0) : _vm._e()]), _vm._v(" "), (_vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('div', {
	      staticClass: "delete__user",
	      on: {
	        "click": function($event) {
	          return _vm.removeKlass(klass)
	        },
	        "mouseenter": function($event) {
	          return _vm.addDeleteClass(klass)
	        },
	        "mouseleave": function($event) {
	          return _vm.removeDeleteClass(klass)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-cross2"
	    })]) : _vm._e()])
	  }), _vm._v(" "), _c('div', [(_vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('div', {
	    staticClass: "add-more-button",
	    on: {
	      "click": _vm.pushNewKlass
	    }
	  }, [_c('span', {
	    staticClass: "plus--icon"
	  }, [_vm._v("\n            +\n          ")]), _vm._v(" "), _c('span', {
	    staticClass: "add-more-button__text"
	  }, [_vm._v(" " + _vm._s(_vm.$t('vue2.createusers.add_more')))])]) : _vm._e()])], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "flex flex-end pad-10",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [(_vm.someWithSameName) ? _c('p', {
	    staticClass: "error-message marg-20-right warning-text"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createklass.warning_text')))]) : _vm._e(), _vm._v(" "), (_vm.showInactiveButton) ? _c('button', {
	    staticClass: "submit-btn--disabled"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.createusers.create')) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.showInactiveButton && !_vm.isAwaitingServerResponse) ? _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.submitOrSetDuration
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.buttonText) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.showInactiveButton && _vm.isAwaitingServerResponse) ? _c('button', {
	    staticClass: "submit-button submit-button--loading"
	  }) : _vm._e(), _vm._v(" "), _c('StandardDurationSetting', {
	    attrs: {
	      "isOpenModal": _vm.isOpenDurationModal
	    },
	    on: {
	      "close": function($event) {
	        _vm.isOpenDurationModal = false
	      },
	      "submit": _vm.saveDuration
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "width-100",
	    attrs: {
	      "slot": "sidebar"
	    },
	    slot: "sidebar"
	  }, [(!_vm.klassStepIsSelected) ? _c('div', {
	    staticClass: "explainer-text align-center pad-20"
	  }, [_c('div', {
	    staticClass: "marg-10-right"
	  }, [_c('span', {
	    staticClass: "icon-ask icon-question3"
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createklass.import_subjects_question')))])]) : _c('div', {
	    staticClass: "explainer-text align-center pad-20"
	  }, [_c('div', {
	    staticClass: "marg-10-right"
	  }, [_c('span', {
	    staticClass: "step-is-choosen icon-checkmark-circle"
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createklass.import_subjects_done')))])]), _vm._v(" "), _c('ShowSubjects', {
	    attrs: {
	      "arrowPosition": _vm.subjectsArrowPosition,
	      "activeKlassStep": _vm.activeKlassStep,
	      "klassStepIsSelected": _vm.klassStepIsSelected,
	      "country": _vm.country
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "small-arrow",
	    style: ({
	      top: _vm.subjectsArrowPosition + 5 + 'px'
	    })
	  })], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2022 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeClick),
	      expression: "closeClick"
	    }],
	    ref: "d_show_event",
	    staticClass: "d-show-event",
	    class: {
	      'd-show-event__changes-made': _vm.isChangesMade
	    },
	    attrs: {
	      "data-event-id": _vm.event ? _vm.event.event_id : ''
	    }
	  }, [(!_vm.isEveryThingReady) ? _c('div', {
	    staticClass: "d-show-event__init-loader"
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212
	      }),
	      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212\n             }"
	    }],
	    staticClass: "d-show-event__close d-show-event__close__loader icon__bg-circle",
	    attrs: {
	      "content": _vm.escTooltip
	    },
	    on: {
	      "click": _vm.closeClick
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  })], 1) : _c('div', {
	    staticClass: "d-show-event__content"
	  }, [_c('div', {
	    ref: "d_show_event_header",
	    staticClass: "d-show-event__header",
	    style: ({
	      backgroundColor: _vm.event.color
	    })
	  }, [_c('div', {
	    staticClass: "d-show-event__header__do-warning__container"
	  }, [(_vm.isCanceled) ? _c('div', {
	    staticClass: "d-show-event__header__do-warning do-warning do-warning--canceled"
	  }, [_c('span', {
	    staticClass: "icon-notification22"
	  }), _vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale].canceled) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isAway) ? _c('div', {
	    staticClass: "d-show-event__header__do-warning do-warning"
	  }, [_c('span', {
	    staticClass: "icon-home2 icon-home2-away",
	    staticStyle: {
	      "margin-right": "2px"
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale].out_of_school))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    ref: "copy_event_button",
	    staticClass: "d-show-event__header__top",
	    attrs: {
	      "id": "vue-popper__copy_event_button"
	    }
	  }, [(_vm.isCanEditEvent) ? [(_vm.event.calendar_id !== _vm.calendarId) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212
	      }),
	      expression: "{\n        placement: 'bottom',\n        zIndex: 1212121212\n      }"
	    }],
	    staticClass: "icon__bg-circle",
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['go_to_calendar']
	    },
	    on: {
	      "click": _vm.goToCalendarForLesson
	    }
	  }, [_c('svg', {
	    staticClass: "tw-icon w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.event.calendar_id !== _vm.calendarId && _vm.eventMainCalendarType === 'merge') ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212
	      }),
	      expression: "{\n        placement: 'bottom',\n        zIndex: 1212121212\n      }"
	    }],
	    staticClass: "icon__bg-circle dialog-header__bin",
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['only_delete_this']
	    },
	    on: {
	      "click": _vm.setIsConfirmDeleteMerge
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin pointer"
	  })]) : _vm._e(), _vm._v(" "), (_vm.isPossibleToDelete) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212
	      }),
	      expression: "{\n        placement: 'bottom',\n        zIndex: 1212121212\n      }"
	    }],
	    staticClass: "icon__bg-circle dialog-header__bin",
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['delete_event']
	    },
	    on: {
	      "click": function($event) {
	        _vm.isConfirmDelete = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin pointer"
	  })]) : _vm._e(), _vm._v(" "), (_vm.event.calendar_id === _vm.calendarId && _vm.showSettings && _vm.event.event_type !== 'absence') ? _c('DDropdown', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 12121212
	      }),
	      expression: "{placement: 'bottom', zIndex: 12121212}"
	    }],
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['settings']
	    }
	  }, [_c('ul', {
	    staticClass: "large-list",
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', {
	    on: {
	      "click": _vm.openCopyEventDropdown
	    }
	  }, [_c('span', {
	    staticClass: "icon-clipboard2"
	  }), _vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale]['copy_event_onward']) + "\n              ")]), _vm._v(" "), _c('li', {
	    staticClass: "d-item-warning",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.setIsDeleteOnWard.apply(null, arguments)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale].delete_events_onward) + "\n              ")]), _vm._v(" "), _c('li', {
	    staticClass: "d-cancel-lesson-item",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setIsCancelLesson(true)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-notification22"
	  }), _vm._v("\n                " + _vm._s(!_vm.isCanceled ? _vm.i18n[_vm.locale].cancel_event : _vm.i18n[_vm.locale].uncancel_event) + "\n              ")]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setIsOutOfSchoolLesson(true)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-home2 icon-home2-away"
	  }), _vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale].out_of_school) + "\n              ")])])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212
	      }),
	      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212\n             }"
	    }],
	    staticClass: "d-show-event__close icon__bg-circle",
	    attrs: {
	      "content": _vm.escTooltip
	    },
	    on: {
	      "click": _vm.closeClick
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])], 2), _vm._v(" "), (_vm.isDeleteOnWard) ? _c('DeleteEventOnward', {
	    attrs: {
	      "isInDCalendar": true,
	      "event": _vm.event
	    },
	    on: {
	      "submit": _vm.submitDeleteEventOnward,
	      "close": function($event) {
	        _vm.isDeleteOnWard = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isInDCalendar) ? _c('CopyEvent') : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-show-event__header__text"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.event.title))]), _vm._v(" "), (_vm.isCanEditEvent && _vm.event.calendar_id !== _vm.calendarId) ? _c('h4', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom-start',
	        zIndex: 1212121212
	      }),
	      expression: "{\n              placement: 'bottom-start',\n              zIndex: 1212121212\n            }"
	    }],
	    class: {
	      'd-show-event__header__text__calendar-link': _vm.event.calendar_id !== _vm.calendarId
	    },
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['go_to_calendar']
	    },
	    on: {
	      "click": _vm.goToCalendarForLesson
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.getCalendarName) + "\n          "), _c('svg', {
	    staticClass: "tw-icon w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
	    }
	  })])]) : _c('h4', [_vm._v(_vm._s(_vm.getCalendarName))])]), _vm._v(" "), (!_vm.isEventLoading) ? [_c('div', {
	    staticClass: "d-show-event__header__text--with-icon"
	  }, [_c('div', {
	    staticClass: "dialog-icon"
	  }, [(_vm.isCanEditEvent) ? _c('span', {
	    staticClass: "icon-calendar4"
	  }) : _vm._e()]), _vm._v(" "), (!_vm.isCanEditEvent) ? _c('div', {
	    staticClass: "dialog-text dialog-text__time"
	  }, [_vm._v("\n            " + _vm._s(_vm.dayAndDate) + "\n          ")]) : _c('div', {
	    staticClass: "dialog-text dialog-text__date"
	  }, [(!_vm.isEditDate) ? _c('p', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212
	      }),
	      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212\n             }"
	    }],
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['edit_date']
	    },
	    on: {
	      "click": function($event) {
	        _vm.isEditDate = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.dayAndDate))]) : _c('DateSelector', {
	    attrs: {
	      "isOpen": true,
	      "date": _vm.startDate
	    },
	    on: {
	      "changed": _vm.setStartDate
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-show-event__header__text--with-icon"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text dialog-text__time"
	  }, [(!_vm.isCanEditEvent) ? _c('div', {
	    staticClass: "dialog-text__time__time"
	  }, [_c('span', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.formattedEventStart) + " - " + _vm._s(_vm.formattedEventEnd))]), _vm._v("\n              (" + _vm._s(_vm.formattedDuration) + ")\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isCanEditEvent) ? _c('TimeChanger', {
	    attrs: {
	      "start": _vm.event.start,
	      "end": _vm.event.end,
	      "addClass": "doc-times"
	    },
	    on: {
	      "updateStart": _vm.updateStartTime,
	      "updateEnd": _vm.updateEndTime
	    }
	  }) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "zoomIn"
	    }
	  }, [(_vm.isChangesMade) ? _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n                  placement : 'bottom',\n                  zIndex: 12312312312312\n                }"
	    }],
	    staticClass: "bttn-primary bttn box-shadow",
	    attrs: {
	      "content": _vm.saveKeyTooltip
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('vue2.common.save')) + "\n              ")]) : _vm._e()])], 1)])] : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-show-event__header__tabs"
	  }, [_c('div', {
	    staticClass: "d-show-event__header__tabs__tab",
	    class: {
	      'd-show-event__header__tabs__tab--active': _vm.isTheActiveTab(0)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheActiveTab(0)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-pencil"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.common.edit')) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-show-event__header__tabs__tab",
	    class: {
	      'd-show-event__header__tabs__tab--active': _vm.isTheActiveTab(1)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheActiveTab(1)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-clock"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['activity']) + "\n        ")]), _vm._v(" "), (_vm.isShowReplaceAndSwap) ? _c('div', {
	    staticClass: "d-show-event__header__tabs__tab",
	    class: {
	      'd-show-event__header__tabs__tab--active': _vm.isTheActiveTab(2)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheActiveTab(2)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-shuffle"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['swap_lesson']) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isShowReplaceAndSwap) ? _c('div', {
	    staticClass: "d-show-event__header__tabs__tab",
	    class: {
	      'd-show-event__header__tabs__tab--active': _vm.isTheActiveTab(3)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheActiveTab(3)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-shuffle"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['replace_lesson']) + "\n        ")]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
	    staticClass: "d-show-event__body",
	    style: ({
	      maxHeight: ("calc(100vh - " + _vm.dShowEventBodyMaxHeight + "px)")
	    })
	  }, [(_vm.isEventLoading) ? _c('Loader', {
	    staticStyle: {
	      "margin-top": "40px"
	    },
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }) : [(_vm.isTheActiveTab(0)) ? _c('div', {
	    staticClass: "d-show-event__form"
	  }, [(!_vm.isCanEditEvent) ? [(_vm.eventUsers.length > 0 && _vm.event.event_type !== 'absence') ? _c('div', {
	    staticClass: "input-group input-group--uneditable"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.teachers')))]), _vm._v(" "), _c('div', {
	    staticClass: "event-cals"
	  }, _vm._l((_vm.eventUsers), function(user) {
	    return _c('div', {
	      key: user.calendar_id,
	      staticClass: "event-cals__cal",
	      class: {
	        'event-cals__cal--sub': user.v_sub
	      }
	    }, [(user.v_sub) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'bottom',
	          zIndex: 1231231231233,
	          boundary: 'window'
	        }),
	        expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  zIndex: 1231231231233,\n                  boundary: 'window'\n                }"
	      }],
	      staticClass: "d-select__selected__item__warning icon__bg-circle icon__bg-circle--small",
	      attrs: {
	        "content": user.v_sub
	      }
	    }, [_c('span', {
	      staticClass: "icon-users3"
	    })]) : _vm._e(), _vm._v("\n                  " + _vm._s(user.name) + "\n                ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.eventSubstitutes.length > 0 && _vm.event.event_type !== 'absence') ? _c('div', {
	    staticClass: "input-group input-group--uneditable"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-users3"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.substitutes')))]), _vm._v(" "), _c('div', {
	    staticClass: "event-cals"
	  }, _vm._l((_vm.eventSubstitutes), function(cal) {
	    return _c('div', {
	      key: cal.calendar_id,
	      staticClass: "event-cals__cal"
	    }, [_vm._v("\n                  " + _vm._s(cal.name) + "\n                ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.eventRooms.length > 0 && _vm.event.event_type !== 'absence') ? _c('div', {
	    staticClass: "input-group input-group--uneditable"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-location"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.rooms')))]), _vm._v(" "), _c('div', {
	    staticClass: "event-cals"
	  }, _vm._l((_vm.eventRooms), function(cal) {
	    return _c('div', {
	      key: cal.calendar_id,
	      staticClass: "event-cals__cal"
	    }, [_vm._v("\n                  " + _vm._s(cal.name) + "\n                ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.eventKlasses.length > 0 && _vm.event.event_type !== 'absence') ? _c('div', {
	    staticClass: "input-group input-group--uneditable"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-calendar4"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.klass')))]), _vm._v(" "), _c('div', {
	    staticClass: "event-cals"
	  }, _vm._l((_vm.eventKlasses), function(cal) {
	    return _c('div', {
	      key: cal.calendar_id,
	      staticClass: "event-cals__cal"
	    }, [_vm._v("\n                  " + _vm._s(cal.name) + "\n                ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.eventStudents.length > 0 && _vm.event.event_type !== 'absence') ? _c('div', {
	    staticClass: "input-group input-group--uneditable"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-calendar4"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.students.students')))]), _vm._v(" "), _c('div', {
	    staticClass: "event-cals"
	  }, _vm._l((_vm.eventStudents), function(cal) {
	    return _c('div', {
	      key: cal.calendar_id,
	      staticClass: "event-cals__cal"
	    }, [_vm._v("\n                  " + _vm._s(cal.name) + "\n                ")])
	  }), 0)]) : _vm._e()] : [(_vm.usersNotOnSchool.length > 0) ? _c('DCalendarShowEventUsersNotOnSchool', {
	    attrs: {
	      "usersNotOnSchool": _vm.usersNotOnSchool,
	      "event": _vm.event,
	      "activeSchoolName": _vm.activeSchoolName
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.event.event_type !== 'absence') ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.teachers')))]), _vm._v(" "), _c('DSelectCalendars', {
	    attrs: {
	      "itemType": "user",
	      "showTags": true,
	      "event": _vm.event,
	      "eventId": _vm.event.event_id,
	      "preSelectedItems": _vm.userCalendarIds,
	      "itemsThatCantBeDeleted": _vm.usersWithSubstitute,
	      "itemsUnselectable": _vm.substituteCalendarIds,
	      "showCreateButton": false,
	      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
	      "eventSchoolCalendars": _vm.eventSchoolCalendars,
	      "eventSchoolUsers": _vm.eventSchoolUsers,
	      "eventSchoolYears": _vm.eventSchoolYears,
	      "isDeleteAllAnOption": _vm.substituteCalendarIds.length === 0
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose,
	      "update": _vm.setSelectedUsers
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.event.event_type !== 'reservation' && _vm.event.event_type !== 'absence' && (_vm.userCalendarIds.length > 0 || this.ownerCalendarType === 'user')) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-users3"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.substitutes')))]), _vm._v(" "), _c('DSelectCalendars', {
	    attrs: {
	      "itemType": "user",
	      "showTags": true,
	      "event": _vm.event,
	      "eventId": _vm.event.event_id,
	      "preSelectedItems": _vm.substituteCalendarIds,
	      "itemsUnselectable": _vm.userCalendarIds,
	      "includeEventCalendar": true,
	      "showCreateButton": false,
	      "disableAddMore": _vm.possibleTeachersToSub.length < 1,
	      "disableAddMoreMessage": _vm.i18n[_vm.locale]['only_one_substitute_per_teacher'],
	      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
	      "eventSchoolCalendars": _vm.eventSchoolCalendars,
	      "eventSchoolUsers": _vm.eventSchoolUsers,
	      "eventSchoolYears": _vm.eventSchoolYears
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose,
	      "update": _vm.setSelectedSubstitutes
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.event.event_type !== 'absence') ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-location"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.rooms')))]), _vm._v(" "), _c('DSelectCalendars', {
	    attrs: {
	      "itemType": "room",
	      "event": _vm.event,
	      "eventId": _vm.event.event_id,
	      "preSelectedItems": _vm.roomCalendarIds,
	      "showCreateButton": false,
	      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
	      "eventSchoolCalendars": _vm.eventSchoolCalendars,
	      "eventSchoolUsers": _vm.eventSchoolUsers,
	      "eventSchoolYears": _vm.eventSchoolYears
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose,
	      "update": _vm.setSelectedRooms
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeEventTypeToSelect === 'kindergarten') ? [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-clipboard2"
	  }), _vm._v(" Stuer")]), _vm._v(" "), _c('DSelectCalendars', {
	    attrs: {
	      "itemType": "kindergarten",
	      "event": _vm.event,
	      "eventId": _vm.event.event_id,
	      "preSelectedItems": _vm.kindergartenCalendarsIds,
	      "showCreateButton": false,
	      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
	      "eventSchoolCalendars": _vm.eventSchoolCalendars,
	      "eventSchoolUsers": _vm.eventSchoolUsers,
	      "eventSchoolYears": _vm.eventSchoolYears
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose,
	      "update": _vm.setSelectedKindergartenCalendar
	    }
	  })], 1)] : _vm._e(), _vm._v(" "), (_vm.activeEventTypeToSelect === 'club') ? [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-clipboard2"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.club.club')))]), _vm._v(" "), _c('DSelectCalendars', {
	    attrs: {
	      "itemType": "club",
	      "event": _vm.event,
	      "eventId": _vm.event.event_id,
	      "preSelectedItems": _vm.clubCalendarsIds,
	      "showCreateButton": false,
	      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
	      "eventSchoolCalendars": _vm.eventSchoolCalendars,
	      "eventSchoolUsers": _vm.eventSchoolUsers,
	      "eventSchoolYears": _vm.eventSchoolYears
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose,
	      "update": _vm.setSelectedClubCalendar
	    }
	  })], 1)] : _vm._e(), _vm._v(" "), (_vm.activeEventTypeToSelect === 'other') ? [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-clipboard2"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.common.other_calendars')))]), _vm._v(" "), _c('DSelectCalendars', {
	    attrs: {
	      "itemType": "other",
	      "event": _vm.event,
	      "eventId": _vm.event.event_id,
	      "preSelectedItems": _vm.otherCalendarsIds,
	      "showCreateButton": false,
	      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
	      "eventSchoolCalendars": _vm.eventSchoolCalendars,
	      "eventSchoolUsers": _vm.eventSchoolUsers,
	      "eventSchoolYears": _vm.eventSchoolYears
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose,
	      "update": _vm.setSelectedOtherCalendar
	    }
	  })], 1)] : _vm._e(), _vm._v(" "), (_vm.activeEventTypeToSelect === 'klass') ? [(_vm.event.event_type !== 'reservation' && _vm.event.event_type !== 'absence' && !_vm.isShowKlass) ? _c('div', {
	    staticClass: "input-group input-group__label-link"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.isShowKlass),
	      expression: "isShowKlass"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.isShowKlass) ? _vm._i(_vm.isShowKlass, null) > -1 : (_vm.isShowKlass)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.isShowKlass,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.isShowKlass = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.isShowKlass = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.isShowKlass = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "d-link-text",
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowKlass(true)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].add_grade))])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInLeft"
	    },
	    on: {
	      "after-enter": _vm.onKlassDSelectTransitionDone
	    }
	  }, [(_vm.event.event_type !== 'absence' && _vm.isShowKlass) ? _c('div', {
	    staticClass: "input-group input-group__grades"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-calendar4"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.klass')))]), _vm._v(" "), _c('DSelectCalendars', {
	    attrs: {
	      "itemType": "klass",
	      "event": _vm.event,
	      "eventId": _vm.event.event_id,
	      "preSelectedItems": _vm.klassCalendarIds,
	      "showCreateButton": false,
	      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
	      "eventSchoolCalendars": _vm.eventSchoolCalendars,
	      "eventSchoolUsers": _vm.eventSchoolUsers,
	      "eventSchoolYears": _vm.eventSchoolYears
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose,
	      "update": _vm.setSelectedKlasses
	    }
	  })], 1) : _vm._e()])] : _vm._e(), _vm._v(" "), (_vm.isStudentsActivated && _vm.event.event_type !== 'absence' && _vm.event.event_type !== 'reservation') ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-location"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.students.students')))]), _vm._v(" "), _c('DSelectCalendars', {
	    attrs: {
	      "itemType": "student",
	      "event": _vm.event,
	      "eventId": _vm.event.event_id,
	      "preSelectedItems": _vm.studentCalendarIds,
	      "showCreateButton": false,
	      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
	      "eventSchoolCalendars": _vm.eventSchoolCalendars,
	      "eventSchoolUsers": _vm.eventSchoolUsers,
	      "eventSchoolYears": _vm.eventSchoolYears
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose,
	      "update": _vm.setSelectedStudents
	    }
	  })], 1) : _vm._e()], _vm._v(" "), (_vm.isShowLearningGoal && (_vm.event.learning_goal.length > 0 || _vm.event.event_type !== 'absence') && (_vm.canEditNotes || (!_vm.canEditNotes && _vm.event.learning_goal.length > 0))) ? _c('div', {
	    staticClass: "d-notes"
	  }, [_c('label', {
	    style: ({
	      'color': _vm.event.color
	    })
	  }, [(!_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].learning_goal))]) : _vm._e(), _vm._v(" "), (_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].meeting_purpose))]) : _vm._e()]), _vm._v(" "), (!_vm.canEditNotes) ? _c('div', {
	    staticClass: "dialog-text__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.learning_goal)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.canEditNotes) ? _c('weip', {
	    attrs: {
	      "isInDCalendar": true,
	      "isInTestOfSaveButton": false,
	      "lesson": _vm.event,
	      "noteType": "learning_goal"
	    },
	    on: {
	      "changed": function($event) {
	        return _vm.setNoteChanges($event, 'learning_goal')
	      }
	    }
	  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isShowOnlyNotes && (_vm.event.description.length > 0 || _vm.event.event_type !== 'absence') && (_vm.canEditNotes || (!_vm.canEditNotes && _vm.event.description.length > 0))) ? _c('div', {
	    staticClass: "d-notes"
	  }, [_c('label', {
	    style: ({
	      'color': _vm.event.color
	    })
	  }, [(!_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].content))]) : _vm._e(), _vm._v(" "), (_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].agenda))]) : _vm._e()]), _vm._v(" "), (_vm.canEditNotes) ? _c('weip', {
	    attrs: {
	      "isInDCalendar": true,
	      "isInTestOfSaveButton": false,
	      "lesson": _vm.event,
	      "noteType": "description"
	    },
	    on: {
	      "changed": function($event) {
	        return _vm.setNoteChanges($event, 'description')
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.canEditNotes) ? _c('div', {
	    staticClass: "dialog-text__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.description)
	    }
	  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isShowNotesForStudent && (_vm.event.notes_for_students.length > 0 || _vm.event.event_type !== 'absence') && _vm.canEditNotes || (!_vm.canEditNotes && _vm.event.notes_for_students.length > 0)) ? _c('div', {
	    staticClass: "d-notes"
	  }, [_c('label', {
	    style: ({
	      'color': _vm.event.color
	    })
	  }, [(!_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].pupil_preparation))]) : _vm._e(), _vm._v(" "), (_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].decisions_and_resume))]) : _vm._e()]), _vm._v(" "), (_vm.canEditNotes) ? _c('weip', {
	    attrs: {
	      "isInDCalendar": true,
	      "isInTestOfSaveButton": false,
	      "lesson": _vm.event,
	      "noteType": "notes_for_students"
	    },
	    on: {
	      "changed": function($event) {
	        return _vm.setNoteChanges($event, 'notes_for_students')
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.canEditNotes) ? _c('div', {
	    staticClass: "dialog-text__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.notes_for_students)
	    }
	  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isShowTeacherNotes && _vm.canEditNotes || (!_vm.canEditNotes && _vm.event.teacher_notes.length > 0)) ? _c('div', {
	    staticClass: "d-notes"
	  }, [_c('label', {
	    style: ({
	      'color': _vm.event.color
	    })
	  }, [(!_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].teacher_notes))]) : _vm._e(), _vm._v(" "), (_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].internal_notes))]) : _vm._e()]), _vm._v(" "), (_vm.canEditNotes) ? _c('weip', {
	    attrs: {
	      "isInDCalendar": true,
	      "isInTestOfSaveButton": false,
	      "lesson": _vm.event,
	      "noteType": "teacher_notes"
	    },
	    on: {
	      "changed": function($event) {
	        return _vm.setNoteChanges($event, 'teacher_notes')
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.canEditNotes) ? _c('div', {
	    staticClass: "dialog-text__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.teacher_notes)
	    }
	  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.event.event_type !== 'frame') ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-clock"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['this_lesson_counts_as']))]), _vm._v(" "), _c('p', {
	    staticClass: "lesson-count-as"
	  }, [_vm._v(_vm._s(_vm.eventTypeTranslated) + ": " + _vm._s(_vm.eventDurationForCalendar))])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isTheActiveTab(1)) ? _c('div', {
	    staticClass: "d-show-event__form"
	  }, [_c('EventChanges', {
	    attrs: {
	      "event": _vm.event,
	      "event-id": _vm.event.event_id
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTheActiveTab(2)) ? _c('div', {
	    staticClass: "d-show-event__form"
	  }, [_c('EventSwapOrReplace', {
	    attrs: {
	      "propEvent": _vm.event,
	      "type": "swap"
	    },
	    on: {
	      "update": _vm.updateAndClose
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTheActiveTab(3)) ? _c('div', {
	    staticClass: "d-show-event__form"
	  }, [_c('EventSwapOrReplace', {
	    attrs: {
	      "propEvent": _vm.event,
	      "type": "replace"
	    },
	    on: {
	      "update": _vm.updateAndClose
	    }
	  })], 1) : _vm._e()]], 2), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeUp"
	    }
	  }, [(_vm.isChangesMade) ? _c('div', {
	    staticClass: "d-show-event__footer"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'top',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n                  placement : 'top',\n                  zIndex: 12312312312312\n                }"
	    }],
	    staticClass: "bttn-primary bttn box-shadow",
	    attrs: {
	      "disabled": _vm.isUpdating,
	      "content": _vm.saveKeyTooltip
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn box-shadow marg-1-left",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.dont_save')))])]) : _vm._e()]), _vm._v(" "), (_vm.isConfirmDelete && !_vm.isAway) ? _c('ModalConfirmation', {
	    staticClass: "d-modal--from-top",
	    attrs: {
	      "show-close": false,
	      "appendToBody": true,
	      "isOnlyOwnCalendarText": _vm.isOnlyOwnCalendarTextWarning
	    },
	    on: {
	      "close": _vm.closeIsConfirmDelete,
	      "confirm": _vm.deleteEvent
	    }
	  }, [(_vm.originalSubstituteCalendarIds.length > 0) ? _c('div', {
	    staticClass: "d-custom-warning alert",
	    attrs: {
	      "slot": "custom_warning"
	    },
	    slot: "custom_warning"
	  }, [_c('span', {
	    staticClass: "icon-users3"
	  }), _vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['you_are_about_to_delete_substitutes']) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isConfirmDelete && _vm.isAway) ? _c('DModalDeleteAwayEvent', {
	    attrs: {
	      "event": _vm.event,
	      "appendToBody": true
	    },
	    on: {
	      "deleted": _vm.onAwayEventDeleted,
	      "close": _vm.closeIsConfirmDelete
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isConfirmRemoveOwnerAsSubstitute) ? _c('ModalConfirmation', {
	    staticClass: "d-modal--from-top",
	    attrs: {
	      "show-close": false,
	      "appendToBody": true,
	      "isShowConfirmDeleteMessage": false
	    },
	    on: {
	      "close": function($event) {
	        _vm.isConfirmRemoveOwnerAsSubstitute = false
	      },
	      "confirm": _vm.confirmRemoveOwnerAsSubstitute
	    }
	  }, [_c('div', {
	    staticClass: "d-custom-warning alert",
	    attrs: {
	      "slot": "custom_warning"
	    },
	    slot: "custom_warning"
	  }, [_c('span', {
	    staticClass: "icon-users3"
	  }), _vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['remove_owner_as_substitute']) + "\n      ")]), _vm._v(" "), _c('template', {
	    slot: "confirmText"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['ok']))])], 2) : _vm._e(), _vm._v(" "), (_vm.subToSelectWhoToSubFor) ? _c('DCalendarsShowEventSubFor', {
	    attrs: {
	      "substitute": _vm.subToSelectWhoToSubFor,
	      "teachers": _vm.possibleTeachersToSub
	    },
	    on: {
	      "select": _vm.setTeacherToSub,
	      "cancel": _vm.cancelSubToSelectWhoToSubFor
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.isClosingWithoutSaving && !_vm.isEventLoading) ? _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal__closing-without-saving text-dark",
	    staticStyle: {
	      "width": "400px"
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.common.save_changes')))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unsaved_changes_will_be_lost']))])]), _vm._v(" "), _c('div', {
	    staticClass: "doc-modal__footer"
	  }, [_c('button', {
	    staticClass: "bttn bttn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")]), _vm._v(" "), _c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.dont_save')))]), _vm._v(" "), _c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.isClosingWithoutSaving = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))])])])]) : _vm._e(), _vm._v(" "), (_vm.isCancelLesson) ? _c('DModalCancelLesson', {
	    attrs: {
	      "event": _vm.event
	    },
	    on: {
	      "updated": _vm.onEventUpdated,
	      "close": function($event) {
	        return _vm.setIsCancelLesson(false)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isOutOfSchoolLesson) ? _c('DModalOutOfSchoolLesson', {
	    attrs: {
	      "event": _vm.event
	    },
	    on: {
	      "updated": _vm.onEventUpdated,
	      "close": function($event) {
	        return _vm.setIsOutOfSchoolLesson(false)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isChangesMade) ? _c('div', {
	    staticClass: "d-show-event__overlay",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.closeClick.apply(null, arguments)
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dialog-icon"
	  }, [_c('span', {
	    staticClass: "icon-clock"
	  })])
	}]}

/***/ }),
/* 2023 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "flex modal-form__titles"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('vue2.createusers.name')) + "*")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('vue2.createusers.login_options')) + " -\n      "), _c('span', {
	    staticClass: "text-grey italic font-small"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createusers.can_be_added_later')))])])]), _vm._v(" "), _vm._l((_vm.users), function(user, key) {
	    return _c('div', {
	      staticClass: "modal-form-group",
	      class: {
	        'hoverDanger': user.userHoverDanger
	      }
	    }, [_c('div', {
	      staticClass: "create-form"
	    }, [_c('div', {
	      staticClass: "create-form__name"
	    }, [_c('input', {
	      staticClass: "namefield",
	      class: {
	        'inputError': !user.nameIsValid
	      },
	      attrs: {
	        "type": "text",
	        "placeholder": _vm.$t('vue2.createusers.placeholder_name')
	      },
	      on: {
	        "input": function($event) {
	          return _vm.checkAllForText($event.target.value, 'username', key)
	        },
	        "blur": function($event) {
	          return _vm.validate(user, key)
	        },
	        "focus": function($event) {
	          return _vm.unValidate(user, key)
	        }
	      }
	    }), _vm._v(" "), (!user.nameIsValid) ? _c('span', {
	      staticClass: "error-text"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.createusers.must_be_added')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "create-form__login"
	    }, [(_vm.country.toLowerCase() === 'dk') ? _c('div', [_c('input', {
	      staticClass: "UniLogin",
	      class: {
	        'inputPristine': user.unilogin.length < 1
	      },
	      attrs: {
	        "type": "text",
	        "placeholder": "uni-login"
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.validate(user, key)
	        },
	        "focus": function($event) {
	          return _vm.unValidate(user, key)
	        },
	        "input": function($event) {
	          return _vm.checkAllForText($event.target.value, 'unilogin', key)
	        }
	      }
	    })]) : _vm._e(), _vm._v(" "), (_vm.country.toLowerCase() === 'no') ? _c('div', [_c('input', {
	      staticClass: "feide",
	      class: [{
	        'inputPristine': user.feide.length < 1
	      }, {
	        'input--error': _vm.getIsUserWithSameFeide(user)
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": "feide"
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.validate(user, key)
	        },
	        "focus": function($event) {
	          return _vm.unValidate(user, key)
	        },
	        "input": function($event) {
	          return _vm.checkAllForText($event.target.value, 'feide', key)
	        }
	      }
	    }), _vm._v(" "), (_vm.getIsUserWithSameFeide(user)) ? _c('p', {
	      staticClass: "error-text"
	    }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.createusers.feide_is_already_used_for')) + " " + _vm._s(_vm.userWithSameFeide.name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
	      class: [{
	        'inputError': !user.validEmail
	      }, {
	        'inputPristine': user.email.length < 1
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": _vm.$t('vue2.createusers.mail')
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.validateEmail(user, $event.target.value, key)
	        },
	        "keyup": function($event) {
	          return _vm.checkEmailAndAllForText(user, $event.target.value, key)
	        },
	        "focus": function($event) {
	          return _vm.unValidate(user, key)
	        }
	      }
	    }), _vm._v(" "), (!user.validEmail) ? _c('span', {
	      staticClass: "error-text"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.createusers.email_error_text')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	      staticClass: "delete__user",
	      on: {
	        "click": function($event) {
	          return _vm.removeUser(user)
	        },
	        "mouseenter": function($event) {
	          return _vm.setHoverDanger(key)
	        },
	        "mouseleave": function($event) {
	          return _vm.removeHoverDanger(key)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-cross2"
	    })])])
	  }), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "add-more-button",
	    on: {
	      "click": _vm.pushNewUser
	    }
	  }, [_c('span', {
	    staticClass: "plus--icon"
	  }, [_vm._v("\n            +\n          ")]), _vm._v(" "), _c('span', {
	    staticClass: "add-more-button__text"
	  }, [_vm._v(" " + _vm._s(_vm.$t('vue2.createusers.add_more')))])])])], 2)
	},staticRenderFns: []}

/***/ }),
/* 2024 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container",
	    class: {
	      'd-timetal__container__width': !_vm.isShowSubjects
	    }
	  }, [_c('div', {
	    staticClass: "d-guides"
	  }, [_c('StilGuides', {
	    attrs: {
	      "video-id": _vm.videoGuideId,
	      "textForLink": _vm.videoGuideText
	    }
	  }), _vm._v(" "), (_vm.isShowSubjects) ? _c('p', {
	    staticClass: "italic"
	  }, [_c('b', [_vm._v("Bemærk:")]), _vm._v(" Opret, slet eller redigere fag påvirker kun\n      indberetningsdata'en - ikke i resten af Docendo")]) : _vm._e()], 1), _vm._v(" "), _c('table', {
	    staticClass: "d-table",
	    class: {
	      'd-table__subjects': _vm.isShowSubjects
	    }
	  }, [(!_vm.isShowSubjects) ? _c('thead', [_c('tr', {
	    staticClass: "tr--one"
	  }, [_c('th', [_vm._v("Klasse")]), _vm._v(" "), _c('th', [_vm._v("Klassetrin")]), _vm._v(" "), _c('th', [_vm._v("Spor")]), _vm._v(" "), _c('th', [_c('div', {
	    staticClass: "th__title-and-button"
	  }, [_vm._v("\n          Klassetype\n        "), _c('button', {
	    on: {
	      "click": _vm.setIsModalCreateGrade
	    }
	  }, [_vm._v("Opret klasse")])])])])]) : _vm._e(), _vm._v(" "), _c('tbody', [_vm._l((_vm.klasserMedProps), function(klasse) {
	    return [_c('tr', {
	      staticClass: "tr--one pos-relative"
	    }, [_c('td', {
	      staticClass: "grade-name"
	    }, [(!_vm.isShowSubjects) ? _c('div', {
	      staticClass: "hint--top-right d-hidden__dropdown",
	      attrs: {
	        "aria-label": "Slet klasse og fag fra indberetningen"
	      }
	    }, [_c('button', {
	      staticClass: "icon__bg-circle icon__bg-circle--danger",
	      on: {
	        "click": function($event) {
	          return _vm.setTheDeleteGrade(klasse)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })])]) : _vm._e(), _vm._v("\n          " + _vm._s(klasse.klassebetegnelse) + "\n          "), (_vm.isShowSubjects) ? _c('button', {
	      staticClass: "klasse__create__btn",
	      on: {
	        "click": function($event) {
	          _vm.theCreateSubject = klasse
	        }
	      }
	    }, [_vm._v("\n            Opret fag\n          ")]) : _vm._e()]), _vm._v(" "), _c('td', [(!_vm.isShowSubjects) ? _c('select', {
	      staticClass: "d-select__small",
	      domProps: {
	        "value": klasse.klassetrin
	      },
	      on: {
	        "change": function($event) {
	          return _vm.updateStilKlasse(klasse, 'klassetrin', $event.target.value)
	        }
	      }
	    }, _vm._l((_vm.klassetrin), function(standardKlasse) {
	      return _c('option', {
	        key: standardKlasse
	      }, [_vm._v("\n              " + _vm._s(standardKlasse) + "\n            ")])
	    }), 0) : _vm._e()]), _vm._v(" "), _c('td', [(!_vm.isShowSubjects) ? _c('input', {
	      staticClass: "d-input__small",
	      attrs: {
	        "type": "text",
	        "maxlength": "10"
	      },
	      domProps: {
	        "value": klasse.spor
	      },
	      on: {
	        "input": function($event) {
	          return _vm.checkSporMaxLength($event)
	        },
	        "blur": function($event) {
	          return _vm.updateStilKlasse(klasse, 'spor', $event.target.value, $event.target)
	        }
	      }
	    }) : _vm._e()]), _vm._v(" "), _c('td', [(!_vm.isShowSubjects) ? _c('select', {
	      staticClass: "d-select__small",
	      domProps: {
	        "value": klasse.klasse_type
	      },
	      on: {
	        "change": function($event) {
	          return _vm.updateStilKlasse(klasse, 'klasse_type', $event.target.value)
	        }
	      }
	    }, _vm._l((_vm.klasseTyper), function(klasseType, key) {
	      return _c('option', {
	        key: key,
	        domProps: {
	          "value": key
	        }
	      }, [_vm._v("\n              " + _vm._s(klasseType) + "\n            ")])
	    }), 0) : _vm._e()])]), _vm._v(" "), (_vm.isShowSubjects) ? [_c('tr', {
	      staticClass: "tr__header"
	    }, [_c('td', [_vm._v("Fag")]), _vm._v(" "), _c('td', [_vm._v("Fagkode")]), _vm._v(" "), _c('td', [_vm._v("Klassetimer")]), _vm._v(" "), _c('td', [_vm._v("Underviser(e)")])]), _vm._v(" "), _vm._l((klasse.fag), function(fag) {
	      return _c('tr', {
	        key: fag.fag_id,
	        staticClass: "tr__two"
	      }, [_c('td', [_c('div', {
	        staticClass: "hint--top-right fag-delete-bin",
	        attrs: {
	          "aria-label": "Slet fra indberetningen"
	        }
	      }, [_c('button', {
	        staticClass: "icon__bg-circle icon__bg-circle--danger",
	        on: {
	          "click": function($event) {
	            return _vm.setTheDeleteSubject(klasse, fag)
	          }
	        }
	      }, [_c('span', {
	        staticClass: "icon-bin"
	      })])]), _vm._v("\n            " + _vm._s(fag.fag_navn) + "\n          ")]), _vm._v(" "), _c('td', [_c('select', {
	        staticClass: "d-select__small",
	        domProps: {
	          "value": fag.fagkode
	        },
	        on: {
	          "change": function($event) {
	            return _vm.updateStilKlasseFag(klasse, fag, 'fagkode', $event.target.value)
	          }
	        }
	      }, _vm._l((_vm.standardSubjects), function(fag) {
	        return _c('option', {
	          domProps: {
	            "value": fag.fagkode
	          }
	        }, [_vm._v("\n                " + _vm._s(fag.fagkode) + ": " + _vm._s(fag.name) + "\n              ")])
	      }), 0)]), _vm._v(" "), _c('td', [_c('input', {
	        staticClass: "d-input__small",
	        attrs: {
	          "type": "text"
	        },
	        domProps: {
	          "value": fag.klokketimer
	        },
	        on: {
	          "focus": function($event) {
	            return $event.target.select()
	          },
	          "keyup": function($event) {
	            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	            _vm.updateStilKlasseFag(klasse, fag, 'klokketimer', $event.target.value, $event.target)
	          },
	          "blur": function($event) {
	            _vm.updateStilKlasseFag(klasse, fag, 'klokketimer', $event.target.value, $event.target)
	          }
	        }
	      })]), _vm._v(" "), _c('td', [_c('div', {
	        staticStyle: {
	          "width": "400px"
	        },
	        on: {
	          "click": function($event) {
	            _vm.theEditTeacher = fag.fag_id
	          }
	        }
	      }, [(fag.v_is_the_edit_teacher) ? _c('DSelect', {
	        attrs: {
	          "items": _vm.users,
	          "itemsSelected": fag.laerere,
	          "usersSSNHash": _vm.usersSSNHash
	        },
	        on: {
	          "update": function($event) {
	            _vm.updateStilKlasseFag(klasse, fag, 'laerere', $event)
	          },
	          "close": function($event) {
	            _vm.theEditTeacher = null
	          }
	        }
	      }) : _c('ul', {
	        staticClass: "d-select__container",
	        class: {
	          'd-select__container--empty': fag.laerere.length < 1
	        }
	      }, [(fag.laerere.length < 1) ? _c('li', {
	        staticClass: "d-select__container__add"
	      }, [_vm._v("\n                  Tilføj minimun en underviser\n                ")]) : _vm._e(), _vm._v(" "), _vm._l((fag.laerere), function(user) {
	        return _c('li', {
	          staticClass: "d-pill",
	          class: {
	            'd-pill--error': user.v_no_cpr
	          }
	        }, [_vm._v("\n                  " + _vm._s(user.v_name) + "\n                ")])
	      })], 2)], 1)])])
	    })] : _vm._e()]
	  })], 2)]), _vm._v(" "), (_vm.theDeleteSubject || _vm.theDeleteGrade) ? _c('ModalConfirmation', {
	    attrs: {
	      "propLocale": "da",
	      "showClose": false
	    },
	    on: {
	      "close": _vm.closeModalConfirm,
	      "confirm": _vm.confirmDelete
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theCreateSubject) ? _c('KompetenceIndberetningKlasserFagForm', {
	    attrs: {
	      "theCreateSubject": _vm.theCreateSubject,
	      "standardSubjects": _vm.standardSubjects
	    },
	    on: {
	      "save": _vm.saveNewSubject,
	      "close": function($event) {
	        _vm.theCreateSubject = null
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isModalCreateGrade) ? _c('KompetenceIndberetningCreateKlasseModal', {
	    on: {
	      "save": _vm.saveNewGrade,
	      "close": _vm.setIsModalCreateGrade
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2025 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weekplan"
	  }, [(_vm.weeknote !== undefined && _vm.weeknote.length && !_vm.isLoading) ? _c('div', {
	    staticClass: "week_note"
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.weekNoteWithLineBreaks)
	    }
	  })]) : _c('div', [(!_vm.anyNotes && !_vm.isLoading) ? _c('span', [_vm._v("\n    " + _vm._s(_vm.$t('vue.public.no_notes')) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('ul', [_vm._l((_vm.eventsWithNotes), function(day) {
	    return [(day.lessons.length !== 0) ? _c('li', {
	      staticClass: "day_change"
	    }, [_c('div', {
	      staticClass: "day_change_header"
	    }, [_c('h3', [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.$filters.dateNoYear(day.date))))])]), _vm._v(" "), _vm._l((day.lessons), function(event) {
	      return [_c('d-week-plan-lesson', {
	        attrs: {
	          "event": event,
	          "date": _vm.date
	        }
	      })]
	    })], 2) : _vm._e()]
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2026 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "do-table",
	    class: {
	      'is-absence-integration-active': _vm.isAbsenceIntegrationActive
	    }
	  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), (_vm.isAbsenceIntegrationActive && _vm.isSalarySystemKMD) ? _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n            }"
	    }],
	    staticClass: "hide-title-th width-40 text-left",
	    attrs: {
	      "content": "Fraværskoden er den kode, der skal bruges i Opus, når en medarbejder har fravær. Vælges en kode, vil der automatisk blive oprettet en fraværsindberetning i Opus."
	    }
	  }, [_vm._v("Fraværskode i OPUS "), _c('span', {
	    staticClass: "icon-question3"
	  })]) : _vm._e(), _vm._v(" "), (_vm.isAbsenceIntegrationActive && _vm.isSalarySystemSD) ? _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n            }"
	    }],
	    staticClass: "hide-title-th width-40 text-left",
	    attrs: {
	      "content": "Fraværskoden er den kode, der skal bruges i SD, når en medarbejder har fravær. Vælges en kode, vil der automatisk blive oprettet en fraværsindberetning i SD."
	    }
	  }, [_vm._v("Fraværskode i SD "), _c('span', {
	    staticClass: "icon-question3"
	  })]) : _vm._e(), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n            }"
	    }],
	    staticClass: "hide-title-th",
	    attrs: {
	      "content": _vm.tooltipForHideTitle
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['hide_title']) + " "), _c('span', {
	    staticClass: "icon-question3"
	  })]), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n            }"
	    }],
	    staticClass: "hide-title-th",
	    attrs: {
	      "content": _vm.tooltipForDefaultOngoing
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['default_ongoing']) + " "), _c('span', {
	    staticClass: "icon-question3"
	  })]), _vm._v(" "), (_vm.isAbsenceRequestActivated) ? _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n            }"
	    }],
	    staticClass: "hide-title-th",
	    attrs: {
	      "content": _vm.tooltipForCanBeRequested
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['can_be_requested']) + " "), _c('span', {
	    staticClass: "icon-question3"
	  })]) : _vm._e(), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(reason) {
	    return _c('tr', {
	      key: reason.id
	    }, [_c('td', [_vm._v(_vm._s(reason.name))]), _vm._v(" "), (_vm.isAbsenceIntegrationActive && _vm.isSalarySystemKMD) ? _c('td', {
	      staticClass: "width-40"
	    }, [(reason.kmd_absence_code_id && _vm.editingAbsenceCodeId !== reason.id) ? _c('div', {
	      staticClass: "absence-code-display"
	    }, [_c('span', {
	      staticClass: "absence-code-text"
	    }, [_vm._v(_vm._s(_vm.getAbsenceCodeName(reason.kmd_absence_code_id, false)))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isAbsenceIntegrationActive && _vm.isSalarySystemSD) ? _c('td', {
	      staticClass: "width-40"
	    }, [(reason.sd_absence_code_id) ? _c('div', {
	      staticClass: "absence-code-display"
	    }, [_c('span', {
	      staticClass: "absence-code-text"
	    }, [_vm._v(_vm._s(_vm.getAbsenceCodeName(reason.sd_absence_code_id, true)))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "hide-title-td"
	    }, [_c('div', {
	      staticClass: "do-table-flex",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.onToggleDefaultPrivate(reason)
	        }
	      }
	    }, [_c('AppToggle', {
	      attrs: {
	        "propOn": reason.default_private,
	        "allowChanges": false
	      }
	    })], 1)]), _vm._v(" "), _c('td', {
	      staticClass: "hide-title-td"
	    }, [_c('div', {
	      staticClass: "do-table-flex default-ongoing-wrapper",
	      class: {
	        'default-ongoing-disabled': _vm.isDefaultOngoingDisabled(reason)
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.onToggleDefaultOngoing(reason)
	        }
	      }
	    }, [(_vm.isDefaultOngoingDisabled(reason)) ? _c('div', {
	      staticClass: "default-ongoing-overlay"
	    }) : _vm._e(), _vm._v(" "), _c('AppToggle', {
	      attrs: {
	        "propOn": reason.default_ongoing,
	        "allowChanges": false
	      }
	    })], 1)]), _vm._v(" "), (_vm.isAbsenceRequestActivated) ? _c('td', {
	      staticClass: "hide-title-td"
	    }, [_c('div', {
	      staticClass: "do-table-flex",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.onToggleCanRequest(reason)
	        }
	      }
	    }, [_c('AppToggle', {
	      attrs: {
	        "propOn": reason.can_request,
	        "allowChanges": false
	      }
	    })], 1)]) : _vm._e(), _vm._v(" "), _c('td', [_c('button', {
	      staticClass: "do-bttn do-bttn--small",
	      class: {
	        'do-bttn--loading': _vm.theUpdatingReasonId === reason.id
	      },
	      on: {
	        "click": function($event) {
	          return _vm.$emit('toggleArchived', reason)
	        }
	      }
	    }, [_vm._v(_vm._s(reason.archived ? _vm.i18n['dearchive'] : _vm.i18n['archive']) + "\n      ")])])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2027 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "footer-nav",
	    class: _vm.className
	  }, [_c('v-touch', {
	    on: {
	      "tap": _vm.prev,
	      "doubletap": _vm.preventZoom
	    }
	  }, [_c('div', {
	    staticClass: "icon-arrow-left4 no-print left-button"
	  })]), _vm._v(" "), _c('v-touch', {
	    staticClass: "today-button",
	    class: {
	      notActive: !_vm.isNotToday
	    },
	    on: {
	      "tap": function($event) {
	        return _vm.$emit('today')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "center-button"
	  }, [_vm._v(_vm._s(_vm.$t('repitition.today')))])]), _vm._v(" "), _c('v-touch', {
	    on: {
	      "tap": _vm.next
	    }
	  }, [_c('div', {
	    staticClass: "icon-arrow-right4 no-print right-button"
	  })])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2028 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "create-students"
	  }, [_c('button', {
	    staticClass: "bttn bttn--primary",
	    staticStyle: {
	      "width": "200px"
	    },
	    on: {
	      "click": _vm.setIsShowModal
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('vue2.students.create_student')) + "\n  ")]), _vm._v(" "), (_vm.isShowModal) ? _c('Modal', {
	    attrs: {
	      "is-bg-overlay": true,
	      "show-close": false,
	      "show": true
	    },
	    on: {
	      "close": _vm.setCloseModal
	    }
	  }, [_c('div', {
	    staticClass: "doc-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "doc-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.common.create')) + " "), (!_vm.isCreateMultipleStudents) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.student')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.students')))])]), _vm._v(" "), _c('div', {
	    staticClass: "doc-modal__close icon__bg-circle",
	    on: {
	      "click": _vm.setCloseModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), (_vm.isCreateMultipleStudents) ? _c('div', {
	    staticClass: "doc-modal__body"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.students.insert_multiple_students')))]), _vm._v(" "), _c('div', {
	    staticClass: "textarea-placeholder-container"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.theBulkStudentsStr),
	      expression: "theBulkStudentsStr"
	    }],
	    staticStyle: {
	      "height": "400px"
	    },
	    attrs: {
	      "spellcheck": "false",
	      "autocapitalize": "none",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": (_vm.theBulkStudentsStr)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.theBulkStudentsStr = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isShowTextAreaPlaceholder),
	      expression: "isShowTextAreaPlaceholder"
	    }],
	    staticClass: "textarea-placeholder-container__placeholder"
	  }, [_vm._v("\n              Anne Anker\n              "), _c('br'), _vm._v(" Ella Madsen\n              "), _c('br'), _vm._v(" Michael Thomsen\n            ")])])])]) : _vm._l((_vm.students), function(student, key) {
	    return _c('div', {
	      staticClass: "doc-modal__body"
	    }, [(_vm.isFeideActive) ? _c('div', {
	      staticClass: "d-input-group"
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.students.feide')))]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (student.feide),
	        expression: "student.feide"
	      }],
	      ref: "feide",
	      refInFor: true,
	      staticClass: "d-input feide",
	      class: [{
	        'input--error': _vm.isFeideAlreadyCreated
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": ""
	      },
	      domProps: {
	        "value": (student.feide)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(student, "feide", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), (_vm.isFeideAlreadyCreated) ? _c('p', {
	      staticClass: "text--error"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.students.feide_is_already_used')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "d-input-group"
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.students.name')))]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (student.name),
	        expression: "student.name"
	      }],
	      ref: "studentname",
	      refInFor: true,
	      staticClass: "d-input namefield",
	      class: [{
	        'missing-input': false
	      }],
	      attrs: {
	        "type": "text",
	        "id": 'studentname_' + key,
	        "placeholder": ""
	      },
	      domProps: {
	        "value": (student.name)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(student, "name", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('SearchForCalendar', {
	      attrs: {
	        "query": student.name
	      }
	    }), _vm._v(" "), (student.name.length < 1) ? _c('p', {
	      staticClass: "text-blue pointer text-link",
	      on: {
	        "click": function($event) {
	          _vm.isCreateMultipleStudents = !_vm.isCreateMultipleStudents
	        }
	      }
	    }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.students.create_multiple_students')))]) : _vm._e()], 1)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "doc-modal__footer"
	  }, [_c('button', {
	    staticClass: "marg-1-right",
	    on: {
	      "click": _vm.setCloseModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "submit-button bttn--shadow",
	    class: {
	      'create-form__submit': _vm.showInactiveButton
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.create')) + " "), (!_vm.isCreateMultipleStudents) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.student')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.students')))])])])], 2)]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2029 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.klassHasNoSubjects && _vm.theCalendar) ? _c('p', {
	    staticClass: "center italic text-dark marg-on-top"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_subjects_created']) + "\n  "), _c('span', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.setImportSubjects
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['import_subjects']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['or_click_on_create_subject']))]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2030 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.close),
	      expression: "close"
	    }],
	    staticClass: "header-nav__item header-nav__item__notifications pos-relative no-selection js-toggle-notifications",
	    class: {
	      active: _vm.show
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggle($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "inline-block",
	    class: {
	      'animated swing infinite': _vm.unReadCounter
	    }
	  }, [_c('span', {
	    staticClass: "icon-bell js-toggle-notifications",
	    staticStyle: {
	      "margin-right": "0",
	      "font-size": "13px"
	    }
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.unReadCounter),
	      expression: "unReadCounter"
	    }],
	    staticClass: "notify-number js-toggle-notifications"
	  }, [_vm._v(_vm._s(_vm.unReadCounter))]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.show) ? _c('div', {
	    staticClass: "notifications_list pos-absolute bg-white rounded"
	  }, [_c('div', {
	    staticClass: "notifications__header popup_header"
	  }, [_c('h4', {
	    staticClass: "left marg-10-left"
	  }, [_vm._v(_vm._s(_vm.unReadCounter) + " " + _vm._s(_vm.$t('vue2.notifications.notifications')))]), _vm._v(" "), _c('div', {
	    staticClass: "notifications__header__tabs"
	  }, [_c('button', {
	    staticClass: "bttn right",
	    class: {
	      bttn_active: _vm.onlyUnreadMessagesActive
	    },
	    on: {
	      "click": _vm.getMessagesUnread
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.notifications.unread')) + "\n\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn right",
	    class: {
	      bttn_active: !_vm.onlyUnreadMessagesActive
	    },
	    on: {
	      "click": _vm.getMessages
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.notifications.all')) + "\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "notifications__body js-notifications-body-scroll"
	  }, [_c('div', [(_vm.isInitialLoad) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff",
	      "isSmall": true
	    }
	  }) : _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.messages.length === 0),
	      expression: "messages.length === 0"
	    }],
	    staticClass: "pad-20 center"
	  }, [_c('div', {
	    staticClass: "icon-checkmark-circle marg-10-bottom",
	    staticStyle: {
	      "font-size": "22px"
	    }
	  }), _vm._v("\n            " + _vm._s(_vm.$t('vue2.notifications.no_new_notifications')) + "\n          ")]), _vm._v(" "), _vm._l((_vm.messages), function(message, index) {
	    return _c('div', {
	      key: message.id,
	      staticClass: "notifations__body__message clearfix overflow pos-relative"
	    }, [_c('a', {
	      staticClass: "flex",
	      class: {
	        is_read: message.read
	      },
	      attrs: {
	        "href": message.link
	      }
	    }, [_c('div', {
	      staticClass: "notifications__message__image-wrapper",
	      on: {
	        "click": function($event) {
	          return _vm.readStatusRead($event, index, message.id, true)
	        }
	      }
	    }, [_c('img', {
	      staticClass: "notifications__body__message__image rounded",
	      attrs: {
	        "src": message.user.profile_image_thumb,
	        "alt": ""
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "notifications__body__message__header",
	      on: {
	        "click": function($event) {
	          return _vm.readStatusRead($event, index, message.id, true)
	        }
	      }
	    }, [_c('p', {
	      staticClass: "text-dark bold marg-10-bottom"
	    }, [_vm._v(_vm._s(message.header))]), _vm._v(" "), _c('p', {
	      staticClass: "text-dark"
	    }, [_vm._v(_vm._s(message.body))]), _vm._v(" "), _c('div', {
	      staticClass: "notifications_body__message__footer"
	    }, [_c('span', [_vm._v(_vm._s(_vm.$t('vue2.notifications.sent_from')) + " " + _vm._s(message.user.name) + " - " + _vm._s(_vm.$filters.fromNow(message.created_at)))])])]), _vm._v(" "), _c('div', {
	      staticClass: "notifications__body__message__isread css_show_tooltip",
	      on: {
	        "click": function($event) {
	          return _vm.changeReadStatus($event, index, message.id, !message.read)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "mark_as_read",
	      class: {
	        is_read: message.read
	      }
	    }, [_c('span', {
	      staticClass: "icon-checkmark4"
	    })])])])])
	  })], 2), _vm._v(" "), (_vm.messages.length > 4 && !_vm.isAllLoaded) ? _c('div', {
	    directives: [{
	      name: "observe-visibility",
	      rawName: "v-observe-visibility",
	      value: (_vm.handleScrolledToBottom),
	      expression: "handleScrolledToBottom"
	    }],
	    staticClass: "message-loader",
	    attrs: {
	      "div": ""
	    }
	  }, [_c('Loader', {
	    staticStyle: {
	      "margin": "0 auto"
	    },
	    attrs: {
	      "bg-color": "#fff",
	      "isSmall": true
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.unReadCounter),
	      expression: "unReadCounter"
	    }],
	    staticClass: "notifications__footer box-sizing"
	  }, [_c('span', {
	    staticClass: "pointer pad-10-0 notifications__footer__link",
	    on: {
	      "click": _vm.markAllAsRead
	    }
	  }, [_c('span', {
	    staticClass: "icon-checkmark-circle marg-10-right"
	  }), _vm._v("\n        " + _vm._s(_vm.$t('vue2.notifications.mark_all_as_read')) + "\n      ")])])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2031 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "subject-dist__edit-hours"
	  }, [_c('div', {
	    staticClass: "subject-dist__edit-hours__header",
	    style: ({
	      'background-color': _vm.subject.color
	    })
	  }, [_c('h4', [_vm._v(_vm._s(_vm.subject.name) + ", " + _vm._s(_vm.getAllKlasses))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle close-subject_edit",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "subject-dist__edit-hours__body"
	  }, [_c('h2', {
	    staticClass: "marg-20-bottom"
	  }, [_vm._v(_vm._s(_vm.getAllKlasses) + " " + _vm._s(_vm.i18n[_vm.locale].has) + " " + _vm._s(_vm.subject.hours) + "\n      " + _vm._s(_vm.i18n[_vm.locale].hours_in_school_year))]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', {
	    staticClass: "label--large"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].add_new_hours_for) + " " + _vm._s(_vm.teacher.name))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.hours),
	      expression: "hours"
	    }],
	    ref: "input_hours",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "focus": _vm.selectAll,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "submit-buttons marg-20-top"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].cancel))]), _vm._v(" "), _c('button', {
	    staticClass: "submit-button marg-10-left",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].update))])])])])
	},staticRenderFns: []}

/***/ }),
/* 2032 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "isCloseOnBgClick": false,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('div', [_c('h2', [_vm._v("Opret faste tillæg")]), _vm._v(" "), _c('p', {
	    staticClass: "d-modal__subtitle"
	  }, [_vm._v(_vm._s(_vm.subtitleText))])]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "create-form__grid"
	  }, [_c('div', {
	    staticClass: "d-input-group cf-loenkode"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Lønkode *")]), _vm._v(" "), _c('DSelect', {
	    ref: "loenkodeSelect",
	    attrs: {
	      "items": _vm.salaryCodesForDSelect,
	      "multiple": false,
	      "placeholder": 'Vælg lønkode',
	      "itemsSelected": _vm.selectedSalaryCodeForDSelect,
	      "isShowRemoveButton": false
	    },
	    on: {
	      "add": _vm.onSelectLoenkode,
	      "remove": function($event) {
	        return _vm.onSelectLoenkode(null)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group cf-antal"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Enheder pr. måned *")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.antal),
	      expression: "antal"
	    }],
	    staticClass: "d-input width-100",
	    attrs: {
	      "type": "text",
	      "inputmode": "decimal",
	      "placeholder": "Indtast antal"
	    },
	    domProps: {
	      "value": (_vm.antal)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.antal = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group cf-beloeb"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.beloebAllowed ? 'Beløb *' : 'Beløb'))]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'top',
	        animateFill: false,
	        animation: 'shift-away',
	        boundary: 'window',
	        zIndex: 12312312312312,
	        onShow: function () { return !_vm.beloebAllowed; }
	      }),
	      expression: "{\n                  arrow: true,\n                  placement: 'top',\n                  animateFill: false,\n                  animation: 'shift-away',\n                  boundary: 'window',\n                  zIndex: 12312312312312,\n                  onShow: () => !beloebAllowed\n                }"
	    }],
	    staticClass: "cf-beloeb__field",
	    attrs: {
	      "content": _vm.beloebAllowed ? '' : 'Kræver løbenummer 0'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.beloeb),
	      expression: "beloeb"
	    }],
	    staticClass: "d-input width-100",
	    attrs: {
	      "type": "text",
	      "inputmode": "decimal",
	      "disabled": !_vm.beloebAllowed,
	      "placeholder": _vm.beloebAllowed ? 'Indtast beløb' : ''
	    },
	    domProps: {
	      "value": (_vm.beloeb)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.beloeb = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('p', {
	    staticClass: "cf-hint text-explainer"
	  }, [_vm._v("\n          " + _vm._s(_vm.beloebHint) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group cf-start"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Startdato *")]), _vm._v(" "), _c('DateSelector', {
	    staticClass: "width-100",
	    attrs: {
	      "date": _vm.startDato,
	      "width100": true
	    },
	    on: {
	      "changed": function($event) {
	        _vm.startDato = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group cf-slut"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Slutdato *")]), _vm._v(" "), (!_vm.noEndDate) ? _c('DateSelector', {
	    staticClass: "width-100",
	    attrs: {
	      "date": _vm.endDato,
	      "width100": true
	    },
	    on: {
	      "changed": function($event) {
	        _vm.endDato = $event
	      }
	    }
	  }) : _c('input', {
	    staticClass: "d-input width-100",
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm.openEndedDateLabel
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "cf-no-end-date"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.noEndDate),
	      expression: "noEndDate"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.noEndDate) ? _vm._i(_vm.noEndDate, null) > -1 : (_vm.noEndDate)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.noEndDate,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.noEndDate = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.noEndDate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.noEndDate = $$c
	        }
	      }, _vm.onToggleNoEndDate]
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Uden slutdato")])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group cf-omk"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Afvigende omkostningssted")]), _vm._v(" "), _c('DSelect', {
	    attrs: {
	      "items": _vm.costCentersForDSelect,
	      "multiple": false,
	      "placeholder": 'Vælg afvigende omkostningssted (valgfri)',
	      "itemsSelected": _vm.selectedCostCenterForDSelect,
	      "isShowRemoveButton": true
	    },
	    on: {
	      "add": _vm.onSelectCostCenter,
	      "remove": function($event) {
	        return _vm.onSelectCostCenter(null)
	      }
	    }
	  })], 1)]), _vm._v(" "), (_vm.validationMessage) ? _c('p', {
	    staticClass: "text-explainer text-explainer--danger"
	  }, [_vm._v("\n        " + _vm._s(_vm.validationMessage) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', {
	    staticClass: "d-modal__buttons__child"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'top',
	        animateFill: false,
	        animation: 'shift-away',
	        boundary: 'window',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n                  arrow: true,\n                    placement : 'top',\n                    animateFill: false,\n                    animation : 'shift-away',\n                    boundary: 'window',\n                    zIndex: 12312312312312\n                  }"
	    }],
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting,
	      'do-bttn--submit--disabled': !_vm.isValid
	    },
	    attrs: {
	      "disabled": _vm.isSubmitting,
	      "content": _vm.saveKeyTooltip
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.submitButtonLabel) + "\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2033 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-1-1 text-dark"
	  }, [_c('div', {
	    staticClass: "flex column"
	  }, [_c('div', {
	    staticClass: "hours_show__header width-100"
	  }, [_c('div', {
	    staticClass: "flex space-between"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.title')))]), _vm._v(" "), _c('h1', {
	    staticClass: "only-print right"
	  }, [_vm._v(_vm._s(_vm.$filters.L(_vm.startDate)) + " - " + _vm._s(_vm.$filters.L(_vm.endDate)))]), _vm._v(" "), _c('div', {
	    staticClass: "flex align-center"
	  }, [_c('p', {
	    staticClass: "marg-10-right bold no-print"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.choose_period')))]), _vm._v(" "), _c('datePickerRange', {
	    staticClass: "inline-block align-center flex no-print",
	    attrs: {
	      "allowSameDate": true,
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.startDateChanged,
	      "endchanged": _vm.endDateChanged
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "marg-10-left no-print",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })])], 1)]), _vm._v(" "), _c('HoursShowShortcuts', {
	    attrs: {
	      "start": _vm.start,
	      "end": _vm.end
	    }
	  }), _vm._v(" "), _c('dSelectUsers', {
	    attrs: {
	      "showTags": true,
	      "showCreateButton": false
	    },
	    on: {
	      "usersUpdated": _vm.syncUsers
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "filters marg-20-top marg-10-bottom flex"
	  }, [_c('div', {
	    staticClass: "fl-icon icon-filter"
	  }), _vm._v(" "), _c('button', {
	    staticClass: "filter",
	    class: {
	      'active': _vm.filterIsActive(null)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setEventsFilter(null)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.all')) + "\n      ")]), _vm._v(" "), _c('button', {
	    staticClass: "filter",
	    class: {
	      'active': _vm.filterIsActive('subject')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setEventsFilter('subject')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.teaching')) + "\n      ")]), _vm._v(" "), _c('button', {
	    staticClass: "filter",
	    class: {
	      'active': _vm.filterIsActive('substituteHours')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setEventsFilter('substituteHours')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.substitute_hours')) + "\n      ")]), _vm._v(" "), _c('button', {
	    staticClass: "filter",
	    class: {
	      'active': _vm.filterIsActive('absence')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setEventsFilter('absence')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.absence')) + "\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "hours_show__body width-100"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticStyle: {
	      "margin-top": "100px"
	    }
	  }, [_c('Spinner', {
	    attrs: {
	      "color": "blue"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "user-list"
	  }, _vm._l((_vm.usersAndEventsWithProps), function(user) {
	    return _c('li', {
	      key: user.user_id,
	      staticClass: "user-list__user"
	    }, [_c('div', {
	      staticClass: "user-list__user__header"
	    }, [_c('h2', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('div', {
	      staticClass: "user-list__user__right"
	    }, [_c('p', [_vm._v(_vm._s(Object.keys(user.v_events_filtered).length) + " " + _vm._s(_vm.$t('vue2.substitute_hours.work_days')) + ": "), _c('b', [_vm._v(_vm._s(user.v_all_days_duration))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.v_filter_events.length) + "\n                "), (user.v_filter_events.length < 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.calendar_event')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.calendar_events')))]), _vm._v(":\n                "), _c('b', [_vm._v(_vm._s(_vm.getSumDuration(user.v_filter_events)))])])])]), _vm._v(" "), _c('ul', {
	      staticClass: "user-list__events"
	    }, _vm._l((user.v_events_filtered), function(dayEvents) {
	      return _c('li', {
	        key: dayEvents[0].start_time,
	        staticClass: "user-list__events_day"
	      }, [_c('div', {
	        staticClass: "user-list__events_day__header"
	      }, [_c('div', [_c('span', {
	        staticClass: "day-headline"
	      }, [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.$filters.ddd(dayEvents[0].start_time))) + ", " + _vm._s(_vm.$filters.LL(dayEvents[0].start_time)))]), _vm._v(",\n                  kl. " + _vm._s(_vm.$filters.LT(dayEvents[0].start_time)) + " - " + _vm._s(_vm.$filters.LT(dayEvents[dayEvents.length - 1].end_time)) + ", " + _vm._s(_vm.getDayDuration(dayEvents)) + "\n                ")]), _vm._v(" "), _c('div', {
	        staticClass: "user-list__events_day__header__day-events"
	      }, [_c('p', [_vm._v(_vm._s(dayEvents.length) + "\n                    "), (dayEvents.length < 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.calendar_event')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.calendar_events')))]), _vm._v(" -\n                    " + _vm._s(_vm.getSumDuration(dayEvents)) + "\n                  ")])])]), _vm._v(" "), _c('ul', {
	        staticClass: "user-list__event_day__lessons"
	      }, _vm._l((dayEvents), function(event) {
	        return _c('li', {
	          key: event.event_id,
	          staticClass: "lesson",
	          style: ({
	            'borderColor': event.color
	          })
	        }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.$filters.LT(event.start_time)) + " - " + _vm._s(_vm.$filters.LT(event.end_time)) + " | " + _vm._s(event.title) + " "), (_vm.eventHasAnyKlass(event.klasses)) ? _c('span', [_vm._v(",")]) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("klassList")(event.klasses)) + "\n                  ")]), _vm._v(" "), (event.substitute_for) ? _c('div', [_c('span', {
	          staticClass: "icon-users3"
	        }), _vm._v(_vm._s(_vm.$t('vue2.substitute_hours.substitute_for')) + ":\n                    " + _vm._s(event.substitute_for) + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.getEventDuration(event)) + "\n                  ")])])
	      }), 0)])
	    }), 0)])
	  }), 0)])])])
	},staticRenderFns: []}

/***/ }),
/* 2034 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "select-subs"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.find_sub_for')) + " ")]), _vm._v(" "), _c('div', {
	    staticClass: "select-subs__header"
	  }, [_c('DoFiltersFilter', {
	    attrs: {
	      "tags": _vm.tags,
	      "selectedTags": _vm.selectedTags
	    },
	    on: {
	      "select": _vm.toggleSelectedTags,
	      "clear": _vm.clearSelectedTags
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "select-subs__header"
	  }, [_c('input', {
	    staticClass: "search-user",
	    attrs: {
	      "type": "search",
	      "placeholder": _vm.$t('vue2.common.search_name_or_initials')
	    },
	    on: {
	      "input": _vm.debounceSearch
	    }
	  })]), _vm._v(" "), _c('ul', [(_vm.usersSorted.length === 0) ? _c('li', {
	    staticClass: "italic"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.dselect.no_matching_results')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.usersSorted), function(user, index) {
	    return _c('li', {
	      key: user.id,
	      staticClass: "select-subs__sub shadow"
	    }, [_c('div', {
	      staticClass: "select-subs__sub__header"
	    }, [_c('div', [_c('p', {
	      staticClass: "select-subs__sub__name"
	    }, [_vm._v(_vm._s(user.name))]), _vm._v(" "), (_vm.isLoadingAvailability) ? _c('p', {
	      staticClass: "select-subs__sub__status__loader linear-background"
	    }) : (_vm.availabilityByCalendarId[user.user_calendar_id]) ? _c('a', {
	      staticClass: "select-subs__sub__status",
	      class: {
	        'select-subs__sub__status--ok': _vm.isFullyAvailable(user)
	      },
	      attrs: {
	        "href": '/calendars/' + user.user_calendar_id,
	        "target": "_blank"
	      }
	    }, [_vm._v("\n            " + _vm._s(_vm.statusText(user)) + "\n          ")]) : _vm._e()])]), _vm._v(" "), _c('button', {
	      staticClass: "bttn",
	      on: {
	        "click": function($event) {
	          return _vm.addSub(user)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.select')) + "\n      ")])])
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2035 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "scheduler__users__user__subpools__meta",
	    style: ([{
	        'left': _vm.itemBCR.right + 4 + 'px'
	      },
	      {
	        'top': _vm.posTop + 'px'
	      }
	    ])
	  }, [_c('table', [_c('thead', {
	    staticClass: "subPools__table__header"
	  }, [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.sub_scheduler_sub_pools.substitute_hours')) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('vue2.sub_scheduler_sub_pools.difference')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('vue2.sub_scheduler_sub_pools.assigned')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('vue2.sub_scheduler_sub_pools.scheduled')))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.itemSubPoolDiff))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.itemSubPool))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.substituteHours))])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2036 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "request-subjects text-dark"
	  }, [_c('div', {
	    staticClass: "request-subjects__header"
	  }, [_c('div', {
	    staticClass: "request-subjects__header__left"
	  }, [_c('h1', [_vm._v("Reduktioner")]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--large do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isRefreshingOrLoadingSubjects
	    },
	    on: {
	      "click": _vm.refreshReductions
	    }
	  }, [_vm._v("\n      Opdater reduktioner\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "request-subjects-grid"
	  }, [_c('div', {
	    staticClass: "doTable"
	  }, [_c('div', {
	    staticClass: "subject-dist__header"
	  }, [_c('div', {
	    staticClass: "subject-dist__header__left"
	  }, [_c('Tabs', {
	    attrs: {
	      "tabs": _vm.tabsList,
	      "selected": _vm.selectedTab,
	      "isLarge": true
	    },
	    on: {
	      "select": _vm.onSelectTab
	    }
	  }), _vm._v(" "), (_vm.selectedTab === 'Fag') ? _c('div', {
	    staticClass: "do-search"
	  }, [_c('input', {
	    staticClass: "do-input",
	    attrs: {
	      "type": "search",
	      "placeholder": "Søg på fag"
	    },
	    on: {
	      "input": _vm.debounceSearch
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'Fag') ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Klasser',
	      "tags": _vm.klassTags,
	      "selectedTags": _vm.selectedKlassFilters
	    },
	    on: {
	      "select": _vm.toggleKlassTag,
	      "clear": function($event) {
	        _vm.selectedKlassFilters = []
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isRefreshingOrLoadingSubjects) ? _c('Loader', {
	    staticStyle: {
	      "margin": "0"
	    },
	    attrs: {
	      "is-extra-small": true
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.selectedTab === 'Aktiviteter') ? _c('BulkCreateSubjects', {
	    attrs: {
	      "isActivities": true,
	      "prop-is-subject-modal": _vm.isCreateActivityModal
	    },
	    on: {
	      "closeSubjectModal": function($event) {
	        return _vm.setIsCreateActivityModal(false)
	      }
	    }
	  }) : _c('ul', {
	    staticClass: "doTable__items"
	  }, _vm._l((_vm.filteredKlassCals), function(klassCal, idx) {
	    return _c('li', {
	      key: klassCal.id,
	      staticClass: "doTable__klass"
	    }, [_c('div', {
	      staticClass: "doTable__klass__header"
	    }, [_c('div', [_vm._v(_vm._s(klassCal.name))]), _vm._v(" "), _c('p', [_c('label', [_vm._v("FØR")]), _vm._v(" " + _vm._s(klassCal.vSubjectsSumRaw) + " "), _c('label', [_vm._v("|")]), _vm._v(" "), _c('label', [_vm._v("EFTER")]), _vm._v(" " + _vm._s(klassCal.vSubjectsSum))])]), _vm._v(" "), _c('ul', {
	      staticClass: "grade-subjects"
	    }, _vm._l((klassCal.vSubjects), function(subject) {
	      return _c('li', {
	        key: subject.id,
	        staticClass: "grade-subjects_subject",
	        style: ({
	          'background': subject.color
	        }),
	        on: {
	          "click": function($event) {
	            return _vm.setEditSubject(subject)
	          }
	        }
	      }, [_vm._v("\n              " + _vm._s(subject.name) + " (" + _vm._s(subject.vHours) + ")\n            ")])
	    }), 0)])
	  }), 0)], 1)]), _vm._v(" "), (_vm.editSubject) ? _c('SubjectForm', {
	    attrs: {
	      "showModal": _vm.editSubject,
	      "editSubject": _vm.editSubject,
	      "propTab": 'reductions',
	      "isActivities": true
	    },
	    on: {
	      "close": _vm.closeEditSubjectModal,
	      "deleteSubject": _vm.deleteSubject,
	      "updateSubject": _vm.updateSubject
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2037 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "reporting"
	  }, [_c('a', {
	    staticClass: "d-back-link",
	    attrs: {
	      "href": "/calendar"
	    }
	  }, [_vm._v("Tilbage til Docendo")]), _vm._v(" "), _c('div', {
	    staticClass: "reporting__header"
	  }, [_c('div', {
	    staticClass: "reporting__header__right"
	  }, [_c('h1', [_vm._v("Grundskoleindberetning")]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1), _vm._v(" "), _c('StilGuides', {
	    attrs: {
	      "is-button": true
	    }
	  })], 1), _vm._v(" "), (_vm.isLoadingStilData || !_vm.isUserLoaded) ? _c('div', {
	    staticStyle: {
	      "width": "500px"
	    }
	  }, [_c('Loader')], 1) : _vm._e(), _vm._v(" "), (_vm.isUserLoaded && _vm.userHasNoEmail) ? _c('div', {
	    staticClass: "d-form alert"
	  }, [_c('h3', [_vm._v("Der skal udfyldes en email for at benytte grundskoleindberetningen")]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', [_vm._v("Din email")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.userEmailInput),
	      expression: "userEmailInput",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    ref: "user_email_input",
	    class: {
	      'input--error': _vm.userEmailFormErrors['email']
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.userEmailInput)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('email')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.userEmailInput = $event.target.value.trim()
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), (_vm.userEmailFormErrors['email']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.createusers.email_error_text')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-form__submit"
	  }, [_c('button', {
	    staticClass: "bttn submit-button",
	    class: [{
	        'bttn--loading': _vm.isSavingUserEmail
	      },
	      {
	        'submit-button--disabled': _vm.isSaveButtonForUserEmailDisabled
	      }
	    ],
	    on: {
	      "click": _vm.submitUserEmail
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.isUserLoaded && !_vm.isLoadingStilData && !_vm.userHasNoEmail) ? [_c('div', {
	    staticClass: "d-tabs"
	  }, [_c('div', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': _vm.theActiveTab === 0
	    },
	    on: {
	      "click": function($event) {
	        _vm.theActiveTab = 0
	      }
	    }
	  }, [_vm._v("\n        1. Personalets alder og køn\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': _vm.theActiveTab === 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.theActiveTab = 1
	      }
	    }
	  }, [_vm._v("\n        2. Ressourceforbrug\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': _vm.theActiveTab === 2
	    },
	    on: {
	      "click": function($event) {
	        _vm.theActiveTab = 2
	      }
	    }
	  }, [_vm._v("\n        3. Antal elever og undervisningstimer\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': _vm.theActiveTab === 3
	    },
	    on: {
	      "click": function($event) {
	        _vm.theActiveTab = 3
	      }
	    }
	  }, [_vm._v("\n        Resumé og indberetning\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "reporting-content"
	  }, [_c('div', {
	    staticClass: "reporting__table"
	  }, [(_vm.theActiveTab === 0) ? _c('GrundskoleIndberetningUsers') : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 1) ? _c('GrundskoleIndberetningRessource', {
	    attrs: {
	      "stilData": _vm.stilData
	    },
	    on: {
	      "updateStil": _vm.updateRessource
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 2) ? _c('GrundskoleIndberetningTimetal', {
	    attrs: {
	      "stilData": _vm.stilData
	    },
	    on: {
	      "update": _vm.update,
	      "updateSubject": _vm.updateSubject,
	      "updateKonfirmation": _vm.updateKonfirmation,
	      "updatePraktik": _vm.updatePraktik,
	      "setTolaerer": _vm.setTolaerer,
	      "setForanstaltning": _vm.setForanstaltning,
	      "nulstilKlasse": _vm.nulstilKlasse
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 3) ? _c('GrundskoleIndberetningResume') : _vm._e()], 1)])] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 2038 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-splash"
	  }, [_c('div', {
	    staticClass: "do-splash__contanier"
	  }, [_c('DoLogo', {
	    attrs: {
	      "id": "do-logo"
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2039 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true,
	      "ariaLabel": _vm.headerTitle
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "sds text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "sds__header",
	    style: ({
	      backgroundColor: _vm.color
	    })
	  }, [_c('h2', [_vm._v(_vm._s(_vm.headerTitle))]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle sds__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "sds__body"
	  }, [_c('div', {
	    staticClass: "sds__form"
	  }, [_c('div', {
	    staticClass: "sds__group"
	  }, [_c('label', {
	    staticClass: "sds__label"
	  }, [_vm._v("Brikkens navn")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    ref: "input_name",
	    staticClass: "sds__input",
	    class: {
	      'sds__input--error': _vm.nameError
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": "Eks. Motionsdag"
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "keyup": function($event) {
	        _vm.nameError = false
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.nameError) ? _c('p', {
	    staticClass: "sds__error"
	  }, [_vm._v("Brikken skal have et navn")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "sds__group"
	  }, [_c('label', {
	    staticClass: "sds__label"
	  }, [_vm._v("Klokketimer i skoleåret")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.hours),
	      expression: "hours",
	      modifiers: {
	        "number": true
	      }
	    }],
	    staticClass: "sds__input",
	    attrs: {
	      "type": "number",
	      "min": "0"
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "sds__group"
	  }, [_c('label', {
	    staticClass: "sds__label"
	  }, [_vm._v("Vælg farve")]), _vm._v(" "), _c('ColorPicker', {
	    attrs: {
	      "initialColor": _vm.color
	    },
	    on: {
	      "changedColor": function($event) {
	        _vm.color = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "sds__group"
	  }, [_c('label', {
	    staticClass: "sds__label"
	  }, [_vm._v("Vælg briktype")]), _vm._v(" "), _c('SubjectTypePicker', {
	    attrs: {
	      "calendarType": "klass",
	      "subjectType": _vm.subjectType
	    },
	    on: {
	      "change": function($event) {
	        _vm.subjectType = $event
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "sds__classes"
	  }, [_c('div', {
	    staticClass: "sds__classes__top"
	  }, [_c('div', {
	    staticClass: "sds__classes__top__left"
	  }, [_c('Tabs', {
	    staticClass: "sds__tabs",
	    attrs: {
	      "tabs": _vm.modeTabs,
	      "selected": _vm.mode
	    },
	    on: {
	      "select": _vm.setMode
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "sds__classes__head"
	  }, [(_vm.mode === 'per_class') ? _c('button', {
	    staticClass: "do-bttn do-bttn--small",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.addRow
	    }
	  }, [_vm._v("Tilføj brik")]) : _vm._e()])]), _vm._v(" "), (_vm.rowsError) ? _c('p', {
	    staticClass: "sds__error"
	  }, [_vm._v("Vælg mindst én klasse")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "sds__table"
	  }, [(_vm.rows.length > 0 || _vm.existingSubjects.length > 0) ? _c('div', {
	    staticClass: "sds__table__head"
	  }, [_c('div', {
	    staticClass: "sds__col sds__col--title"
	  }, [_vm._v("Brik")]), _vm._v(" "), _c('div', {
	    staticClass: "sds__col sds__col--class"
	  }, [_vm._v("Klasser")]), _vm._v(" "), _c('div', {
	    staticClass: "sds__col sds__col--teachers"
	  }, [_vm._v("Undervisere")]), _vm._v(" "), _c('div', {
	    staticClass: "sds__col sds__col--hours"
	  }, [_vm._v("Timer")]), _vm._v(" "), _c('div', {
	    staticClass: "sds__col sds__col--remove"
	  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.existingSubjects), function(subject) {
	    return _c('div', {
	      key: 'ex-' + subject.id,
	      staticClass: "sds__row sds__row--existing"
	    }, [_c('div', {
	      staticClass: "sds__col sds__col--title"
	    }, [_c('span', {
	      staticClass: "sds__pill",
	      style: ({
	        backgroundColor: subject.color
	      })
	    }, [_vm._v(_vm._s(subject.name))])]), _vm._v(" "), _c('div', {
	      staticClass: "sds__col sds__col--class"
	    }, [_vm._v(_vm._s(_vm.existingKlasseNames(subject) || '–'))]), _vm._v(" "), _c('div', {
	      staticClass: "sds__col sds__col--teachers"
	    }, [_vm._v(_vm._s(_vm.existingTeacherNames(subject) || '–'))]), _vm._v(" "), _c('div', {
	      staticClass: "sds__col sds__col--hours"
	    }, [_vm._v(_vm._s(_vm.formatHours(subject.hours)))]), _vm._v(" "), _c('div', {
	      staticClass: "sds__col sds__col--remove"
	    }, [_c('span', {
	      staticClass: "sds__row__badge"
	    }, [_vm._v("Oprettet")])])])
	  }), _vm._v(" "), _vm._l((_vm.rows), function(row) {
	    return _c('div', {
	      key: row.uid,
	      staticClass: "sds__row",
	      class: {
	        'sds__row--empty': row.klassIds.length === 0,
	        'sds__row--error': row.klassError
	      }
	    }, [_c('div', {
	      staticClass: "sds__col sds__col--title"
	    }, [_c('span', {
	      staticClass: "sds__pill",
	      style: ({
	        backgroundColor: _vm.color
	      })
	    }, [_vm._v(_vm._s(_vm.name || 'Brik'))])]), _vm._v(" "), _c('div', {
	      staticClass: "sds__col sds__col--class"
	    }, [_c('DSelectCalendarIds', {
	      key: 'k-' + row.uid,
	      attrs: {
	        "itemType": "klass",
	        "showTags": false,
	        "preSelectedItems": row.klassIds,
	        "showCreateButton": false
	      },
	      on: {
	        "update": function($event) {
	          return _vm.setKlasses(row, $event)
	        }
	      }
	    }), _vm._v(" "), (row.klassError) ? _c('p', {
	      staticClass: "sds__error sds__error--row"
	    }, [_vm._v("Brikken skal have minimum en klasse")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	      staticClass: "sds__col sds__col--teachers"
	    }, [_c('DSelectCalendarIds', {
	      key: 't-' + row.uid,
	      attrs: {
	        "itemType": "user",
	        "showTags": true,
	        "preSelectedItems": row.teacherIds,
	        "showCreateButton": false
	      },
	      on: {
	        "update": function($event) {
	          return _vm.setTeachers(row, $event)
	        }
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "sds__col sds__col--hours"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model.number",
	        value: (row.hours),
	        expression: "row.hours",
	        modifiers: {
	          "number": true
	        }
	      }],
	      staticClass: "sds__input",
	      attrs: {
	        "type": "number",
	        "min": "0"
	      },
	      domProps: {
	        "value": (row.hours)
	      },
	      on: {
	        "focus": function($event) {
	          return _vm.selectAllOnFocus($event)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(row, "hours", _vm._n($event.target.value))
	        },
	        "blur": function($event) {
	          return _vm.$forceUpdate()
	        }
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "sds__col sds__col--remove"
	    }, [(_vm.mode === 'per_class') ? _c('div', {
	      staticClass: "icon__bg-circle sds__row__remove",
	      attrs: {
	        "role": "button",
	        "tabindex": "0",
	        "aria-label": "Fjern række"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.removeRow(row)
	        },
	        "keydown": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	          return _vm.removeRow(row)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })]) : _vm._e()])])
	  }), _vm._v(" "), (_vm.rows.length === 0) ? _c('p', {
	    staticClass: "sds__hint"
	  }, [_vm._v("Ingen klasser tilføjet endnu.")]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "sds__footer"
	  }, [_c('div', {
	    staticClass: "sds__footer__warnings"
	  }, [(_vm.duplicateKlassNames.length > 0) ? _c('p', {
	    staticClass: "sds__footer__warning"
	  }, [_c('span', {
	    staticClass: "icon-warning"
	  }), _vm._v("\n          Flere brikker har samme klasse: " + _vm._s(_vm.duplicateKlassNames.join(', ')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.missingKlassNames.length > 0) ? _c('p', {
	    staticClass: "sds__footer__warning"
	  }, [_c('span', {
	    staticClass: "icon-warning"
	  }), _vm._v("\n          Mangler klasse: " + _vm._s(_vm.missingKlassNames.join(', ')) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    attrs: {
	      "disabled": _vm.isSaving
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': _vm.isSaving,
	      'do-bttn--submit--loading': _vm.isSaving
	    },
	    on: {
	      "click": _vm.create
	    }
	  }, [_vm._v("Opret " + _vm._s(_vm.brikLabel))])])])])
	},staticRenderFns: []}

/***/ }),
/* 2040 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "docendo-connection-indicator"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.is_connected),
	      expression: "!is_connected"
	    }],
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "id": "connection_lost"
	    }
	  }, [_vm._v("Genopretter forbindelse...")])])
	},staticRenderFns: []}

/***/ }),
/* 2041 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.searchedCalendars.length > 0 && _vm.query.length > 1) ? _c('div', {
	    staticClass: "search-for-calendar"
	  }, [_c('div', {
	    staticClass: "search-for-calendar__header"
	  }, [_vm._m(0), _vm._v(" "), (_vm.calendarType === 'users') ? _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.students.users_with_same_name')))]) : _vm._e(), _vm._v(" "), (_vm.calendarType === 'students') ? _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.students.students_with_same_name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "search-for-calendar__body"
	  }, [_c('ul', {
	    staticClass: "search-for-calendar__calendars"
	  }, _vm._l((_vm.searchedCalendars), function(calendar) {
	    return _c('li', {
	      staticClass: "search-for-calendar__calendar"
	    }, [_c('div', {
	      staticClass: "cal-name"
	    }, [_vm._v(_vm._s(calendar.name))]), _vm._v(" "), _c('div', {
	      staticClass: "cal-klasses"
	    }, _vm._l((_vm.getStudentKlasses(calendar)), function(klass, key) {
	      return _c('span', [(key !== 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n            " + _vm._s(klass.name))])
	    }), 0)])
	  }), 0)])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "search-for-calendar__left"
	  }, [_c('div', {
	    staticClass: "search-for-calendar__warning"
	  }, [_c('span', {
	    staticClass: "icon-warning"
	  })])])
	}]}

/***/ }),
/* 2042 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-button__multiple no-print"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212,
	      }),
	      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212,\n             }"
	    }],
	    staticClass: "do-button__multiple__bttn icon-arrow-left4 no-print",
	    attrs: {
	      "content": _vm.tooltipArrowLeft
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('prev')
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "no-print do-button__multiple__bttn",
	    class: {
	      'bttn--disabled': _vm.isToday
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('today')
	      }
	    }
	  }, [_vm._v("\n    I dag\n  ")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212,
	      }),
	      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212,\n             }"
	    }],
	    staticClass: "do-button__multiple__bttn icon-arrow-right4",
	    attrs: {
	      "content": _vm.tooltipArrowRight
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('next')
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2043 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v("Slet onboarding steps")]), _vm._v(" "), _c('div', {
	    staticClass: "flex"
	  }, [_c('button', {
	    on: {
	      "click": _vm.deleteSetupWidgetOpen
	    }
	  }, [_vm._v("Slet Setup widget åben?")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.deleteKlass
	    }
	  }, [_vm._v("Slet klasse")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.deleteUser
	    }
	  }, [_vm._v("Slet Bruger")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.deleteRoom
	    }
	  }, [_vm._v("Slet Lokale")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.deleteMerge
	    }
	  }, [_vm._v("Slet Merge")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.deleteVacation
	    }
	  }, [_vm._v("Slet ferie")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.deleteScheduling
	    }
	  }, [_vm._v("Slet skemalægning")])])])
	},staticRenderFns: []}

/***/ }),
/* 2044 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "spinner",
	    class: [_vm.color, _vm.size],
	    attrs: {
	      "role": "status",
	      "aria-label": _vm.$t('vue2.a11y.loading')
	    }
	  }, [_c('div', {
	    staticClass: "bounce1",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce2",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce3",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2045 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickAway),
	      expression: "onClickAway"
	    }],
	    ref: "d_select",
	    staticClass: "d-select text-dark",
	    class: {
	      'openFromBottom': _vm.openFromBottom
	    }
	  }, [_c('div', {
	    staticClass: "width-100 no-print"
	  }, [_c('div', {
	    ref: "toggle",
	    staticClass: "d-select__input-look",
	    class: {
	      'active': _vm.showDropdown
	    },
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._l((_vm.selectedItems), function(selectedItem) {
	    return _c('div', {
	      key: selectedItem.id,
	      staticClass: "d-select__selected__item",
	      class: [{
	          'readyToDelete': _vm.isReadyToDelete(selectedItem)
	        },
	        {
	          'd-select__selected__item--is-in-event': _vm.isInEvent
	        },
	        {
	          'd-select__selected__item--cant-be-removed': _vm.isInItemsThatCantBeDeleted(selectedItem)
	        }
	      ]
	    }, [(_vm.isInEvent) ? [(_vm.isLoadingAvailability) ? _c('div', {
	      staticClass: "d-select__selected__item__spinner__container"
	    }, [_c('div', {
	      staticClass: "d-select__selected__item__spinner"
	    })]) : [(_vm.isShowCollisions && selectedItem.v_occupation && selectedItem.v_occupation.length > 0) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'bottom',
	          zIndex: 1231231231233,
	          boundary: 'window'
	        }),
	        expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  zIndex: 1231231231233,\n                  boundary: 'window'\n                }"
	      }],
	      staticClass: "d-select__selected__item__warning icon__bg-circle icon__bg-circle--small",
	      attrs: {
	        "content": _vm.getCollisionText(selectedItem)
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.showCalendar(selectedItem)
	        }
	      }
	    }, [_c('svg', {
	      staticClass: "tw-icon tw-icon--warning",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
	      }
	    })])]) : _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'bottom',
	          zIndex: 1231231231233,
	          boundary: 'window'
	        }),
	        expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  zIndex: 1231231231233,\n                  boundary: 'window'\n                }"
	      }],
	      staticClass: "icon__bg-circle icon__bg-circle--small",
	      attrs: {
	        "content": _vm.i18n['see_calendar']
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.showCalendar(selectedItem)
	        }
	      }
	    }, [_c('svg', {
	      staticClass: "tw-icon tw-icon--calendar",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
	      }
	    })])])]] : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "d-select__selected__item__name",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.showCalendar(selectedItem)
	        }
	      }
	    }, [_vm._v("\n          " + _vm._s(selectedItem.name) + "\n        ")]), _vm._v(" "), (!_vm.isInItemsThatCantBeDeleted(selectedItem)) ? _c('div', {
	      staticClass: "d-select__selected__item__remove icon__bg-circle icon__bg-circle--small icon__bg-circle--danger",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.removeUser(selectedItem)
	        }
	      }
	    }, [_c('svg', {
	      staticClass: "tw-icon--close",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24",
	        "width": "24",
	        "height": "24"
	      }
	    }, [_c('path', {
	      staticClass: "secondary",
	      attrs: {
	        "fill-rule": "evenodd",
	        "d": "M15.78 14.36a1 1 0 0 1-1.42 1.42l-2.82-2.83-2.83 2.83a1 1 0 1 1-1.42-1.42l2.83-2.82L7.3 8.7a1 1 0 0 1 1.42-1.42l2.83 2.83 2.82-2.83a1 1 0 0 1 1.42 1.42l-2.83 2.83 2.83 2.82z"
	      }
	    })])]) : _vm._e()], 2)
	  }), _vm._v(" "), (_vm.selectedItems.length > 0 && _vm.isDeleteAllAnOption && _vm.itemsThatCantBeDeleted.length === 0) ? _c('div', {
	    staticClass: "d-select__delete-all",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.removeAllUsers.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'top',
	        zIndex: 1231231231233,
	        animation: 'hift-away'
	      }),
	      expression: "{\n               arrow: true,\n                  placement : 'top',\n                  zIndex: 1231231231233,\n                  animation: 'hift-away'\n                }"
	    }],
	    staticClass: "icon__bg-circle",
	    attrs: {
	      "content": _vm.i18n['delete_all']
	    }
	  }, [_vm._m(0)])]) : _vm._e(), _vm._v(" "), (_vm.isLoadingAvailability) ? _c('Loader', {
	    staticClass: "input__spinner",
	    staticStyle: {
	      "margin": "6px 5px 0 5px"
	    },
	    attrs: {
	      "isExtraSmall": true,
	      "bg-color": "#fff",
	      "color": "blue",
	      "size": "small"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    staticClass: "input__spinner",
	    staticStyle: {
	      "margin": "6px 5px 0 5px"
	    },
	    attrs: {
	      "isExtraSmall": true,
	      "bg-color": "#fff",
	      "color": "blue",
	      "size": "small"
	    }
	  }) : [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchText),
	      expression: "searchText"
	    }],
	    ref: "inputfield",
	    staticClass: "d-select__header__search",
	    class: [{
	      'show': _vm.showDropdown
	    }, {
	      'input-active': _vm.searchText.length > 0 || _vm.selectedItems.length < 1
	    }],
	    attrs: {
	      "type": "search",
	      "placeholder": _vm.placeholderText
	    },
	    domProps: {
	      "value": (_vm.searchText)
	    },
	    on: {
	      "focus": _vm.open,
	      "paste": _vm.handlePaste,
	      "keypress": function($event) {
	        return _vm.selectWithKeyboard('', $event)
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.selectWithKeyboard('enter')
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
	        $event.preventDefault();
	        return _vm.selectWithKeyboard('down')
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
	        $event.preventDefault();
	        return _vm.selectWithKeyboard('up')
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
	        return _vm.selectWithKeyboard('tab')
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
	        return _vm.deleteUserWithKeyboard.apply(null, arguments)
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchText = $event.target.value
	      }
	    }
	  })]], 2), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
	    directives: [{
	      name: "append-to-body",
	      rawName: "v-append-to-body"
	    }],
	    ref: "d_select__items",
	    staticClass: "d-select__items"
	  }, [_c('ul', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'left-start',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'left-start',\n                  zIndex: 12312312312312\n                }"
	    }],
	    ref: "dropdown",
	    staticClass: "d-select__items__container text-dark",
	    attrs: {
	      "content": _vm.metaKeyTooltip
	    },
	    on: {
	      "scroll": _vm.handleScroll
	    }
	  }, [_vm._l((_vm.searchedUsers), function(item, index) {
	    return [(index < _vm.maxLimit) ? _c('li', {
	      key: item.id,
	      class: [{
	          'isReadyForSelection': _vm.isSelectedWithKeyboard(item)
	        },
	        {
	          'item_is_selected': _vm.isSelected(item)
	        }
	      ],
	      on: {
	        "mouseenter": function($event) {
	          return _vm.setIsReadyForSelection(item, index)
	        },
	        "mousemove": function($event) {
	          _vm.isMouseMoved = true
	        },
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.toggleUser(item)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "item-template",
	      class: [{
	          'item-template--occupied': _vm.isShowCollisions && item.v_occupation && item.v_occupation.length > 0
	        },
	        {
	          'item-template--presence': _vm.isShowCollisions && item.v_presence && item.v_presence.length > 0 && item.v_occupation && item.v_occupation.length < 1
	        }
	      ]
	    }, [_c('div', {
	      staticClass: "item-template__left"
	    }, [(item.icon) ? _c('span', {
	      staticClass: "marg-10-right",
	      class: item.icon
	    }) : _vm._e(), _vm._v(" "), (item.default_thumb_url) ? _c('img', {
	      attrs: {
	        "src": item.default_thumb_url,
	        "alt": ""
	      }
	    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (_vm.showCalendarYear) ? _c('div', {
	      staticClass: "item-template__calendar-year"
	    }, [_vm._v(_vm._s(item.year))]) : _vm._e(), _vm._v(" "), (_vm.isShowCollisions && item.v_occupation && item.v_occupation.length > 0) ? _c('ul', {
	      staticClass: "item-template__occupations"
	    }, [_c('span', {
	      staticClass: "icon-warning"
	    }), _vm._v(" "), _vm._l((item.v_occupation), function(event) {
	      return _c('li', {
	        key: event.event_id
	      }, [_vm._v(_vm._s(event.title))])
	    })], 2) : _vm._e()])]) : _vm._e()]
	  }), _vm._v(" "), (_vm.searchedUsers.length > _vm.maxLimit) ? _c('li', {
	    ref: "infinite_scroll",
	    staticClass: "infinite-scroll__bottom"
	  }, [_c('Loader', {
	    staticStyle: {
	      "margin": "12px"
	    },
	    attrs: {
	      "is-extra-small": true,
	      "bg-color": "#fff"
	    }
	  })], 1) : _vm._e()], 2), _vm._v(" "), (_vm.showCreateButton && _vm.searchedUsers.length < 1) ? [(_vm.searchedUsers.length < 1 || (_vm.searchText.length > 0 && _vm.searchedUsers.length < 1)) ? _c('div', {
	    staticClass: "no-match"
	  }, [(_vm.searchText.length < 1) ? _c('h4', {
	    staticClass: "create-new-item create-new-item--explained"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.dselect.type_to_create')) + "\n          ")]) : _c('h4', {
	    staticClass: "create-new-item",
	    on: {
	      "click": _vm.createNew
	    }
	  }, [_vm._v("\n            + " + _vm._s(_vm.$t('vue2.common.create')) + " " + _vm._s(_vm.searchText) + "\n          ")])]) : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.showCreateButton && _vm.searchedUsers.length < 1) ? _c('div', {
	    staticClass: "no-match",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_vm._t("noMatch", function() {
	    return [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.dselect.no_matching_results')))])]
	  })], 2) : _vm._e()], 2) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-select__delete-all__inner"
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])
	}]}

/***/ }),
/* 2046 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "switch"
	  }, [_c('span', {
	    staticClass: "switch-label",
	    class: {
	      'active': _vm.checkValue(1)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setValue(1)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.val1))]), _vm._v(" "), _c('span', {
	    staticClass: "switch-label",
	    class: {
	      'active': _vm.checkValue(2)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setValue(2)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.val2))]), _vm._v(" "), _c('span', {
	    staticClass: "switch-selection",
	    class: {
	      'value-right': _vm.checkValue(2)
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2047 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "1231231231223312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": false,
	      "placeInTop": true,
	      "appendToBody": true,
	      "isCloseOnEsc": true
	    },
	    on: {
	      "close": _vm.onClose
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "tasks-create-category"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [(!_vm.theEditCategory) ? [_vm._v("Opret ny kategori")] : [_vm._v("Rediger kategori")]], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Titel")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    ref: "title_input",
	    staticClass: "d-input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "keyup": [function($event) {
	        _vm.isTitleAlreadyCreated = false
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.createCategory.apply(null, arguments)
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.title = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.isTitleAlreadyCreated) ? _c('p', {
	    staticClass: "text--error"
	  }, [_vm._v("Titel er allerede brugt")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: [{
	      'do-bttn--submit--loading': _vm.isSubmitting
	    }, {
	      'do-bttn--submit--disabled': _vm.title.length < 1
	    }],
	    on: {
	      "click": _vm.createCategory
	    }
	  }, [_vm._v("\n          Opret\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2048 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('AppModal', {
	    attrs: {
	      "show": _vm.openFromOtherComponent
	    },
	    on: {
	      "close": _vm.setCloseModal
	    }
	  }, [_vm._v(">\n  "), _c('h1', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarEditName.edit_name')))]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.editCalendarEditName.calendar_name')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.calName),
	      expression: "calName"
	    }],
	    class: {
	      'missing-input': !_vm.validateInput()
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.calName)
	    },
	    on: {
	      "keyup": _vm.validateInput,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.calName = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "flex flex-end align-center pad-10",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [(!_vm.validateInput()) ? _c('p', {
	    staticClass: "warning-text marg-10-right"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.editCalendarEditName.warning_text')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.validateInput()) ? _c('button', {
	    staticClass: "submit-btn",
	    on: {
	      "click": _vm.submitNewName
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.editCalendarEditName.update_name')) + "\n    ")]) : _c('button', {
	    staticClass: "submit-btn--disabled"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.editCalendarEditName.update_name')) + "\n    ")])])])
	},staticRenderFns: []}

/***/ }),
/* 2049 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "qeip qeip--active text-dark"
	  }, [_c('div', [_c('quill-editor', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "content": _vm.text,
	      "options": _vm.editorOption
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onEditorChange($event)
	      },
	      "ready": function($event) {
	        return _vm.onEditorReady($event)
	      }
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "toolbar",
	      "id": "toolbar"
	    },
	    slot: "toolbar"
	  }, [_c('button', {
	    staticClass: "ql-bold hint--bottom",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['bold']
	    }
	  }, [_vm._v("Bold")]), _vm._v(" "), _c('button', {
	    staticClass: "ql-italic hint--bottom",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['italic']
	    }
	  }, [_vm._v("Italic")]), _vm._v(" "), _c('button', {
	    staticClass: "ql-underline hint--bottom",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['underline']
	    }
	  }, [_vm._v("Underline")]), _vm._v(" "), _c('button', {
	    staticClass: "ql-list hint--bottom",
	    attrs: {
	      "value": "ordered",
	      "aria-label": _vm.i18n[_vm.locale]['list_ordered']
	    }
	  }, [_vm._v("Ordered\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "ql-list hint--bottom",
	    attrs: {
	      "value": "bullet",
	      "aria-label": _vm.i18n[_vm.locale]['list_bullets']
	    }
	  }, [_vm._v("bullet")]), _vm._v(" "), _c('button', {
	    staticClass: "hint--bottom",
	    attrs: {
	      "id": "custom-button",
	      "aria-label": _vm.i18n[_vm.locale]['insert_link']
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setIsLinkModal(true)
	      }
	    }
	  }, [_c('svg', {
	    attrs: {
	      "viewBox": "0 0 18 18"
	    }
	  }, [_c('line', {
	    staticClass: "ql-stroke",
	    attrs: {
	      "x1": "7",
	      "x2": "11",
	      "y1": "7",
	      "y2": "11"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "ql-even ql-stroke",
	    attrs: {
	      "d": "M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "ql-even ql-stroke",
	    attrs: {
	      "d": "M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z"
	    }
	  })])])])]), _vm._v(" "), (_vm.isInTestOfSaveButton) ? _c('div', {
	    staticClass: "save-buttons"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.cancel.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isChanged) ? _c('button', {
	    staticClass: "submit-button submit-button--disabled",
	    class: {
	      'submit-button--loading': _vm.isSaving
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")]) : _c('button', {
	    staticClass: "submit-button",
	    class: {
	      'submit-button--loading': _vm.isSaving
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.save.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.save')) + "\n      ")])]) : _vm._e()], 1), _vm._v(" "), (_vm.isShowModalTeleportClosingWithoutSaving) ? _c('div', {
	    ref: "d_modal_teleport_alert",
	    staticClass: "d-modal__teleport"
	  }, [(_vm.isClosingWithoutSaving) ? _c('div', {
	    staticClass: "bg-overlay"
	  }) : _vm._e(), _vm._v(" "), (_vm.isClosingWithoutSaving) ? _c('DModal', {
	    staticClass: "ap",
	    attrs: {
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "quill-modal quill-modal__save-changes",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('h4', {
	    staticClass: "marg-20-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save_changes')))]), _vm._v(" "), _c('div', {
	    staticClass: "save-buttons"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.cancelModal.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "submit-button",
	    class: {
	      'submit-button--loading': _vm.isSaving
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.saveModal.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.save')) + "\n          ")])])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isShowModalTeleport) ? _c('div', {
	    ref: "d_modal_teleport",
	    staticClass: "d-modal__teleport"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isLinkModal),
	      expression: "isLinkModal"
	    }],
	    staticClass: "bg-overlay"
	  }), _vm._v(" "), _c('DModal', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isLinkModal),
	      expression: "isLinkModal"
	    }],
	    on: {
	      "close": function($event) {
	        return _vm.setIsLinkModal(false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "quill-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "quill-modal__content"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['link_text_label']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.linkText),
	      expression: "linkText"
	    }],
	    ref: "linkTextInput",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale]['link_text_placeholder']
	    },
	    domProps: {
	      "value": (_vm.linkText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.linkText = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['link_link_label']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.link),
	      expression: "link"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale]['link_link_placeholder']
	    },
	    domProps: {
	      "value": (_vm.link)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.link = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "quill-modal__footer"
	  }, [_c('button', {
	    on: {
	      "!click": function($event) {
	        $event.preventDefault();
	        return _vm.setIsLinkModal(false)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
	    staticClass: "bttn bttn-primary submit-button submit-button--disabled"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['insert_link']) + "\n            ")]) : _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "!click": function($event) {
	        $event.preventDefault();
	        return _vm.insertLink.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['insert_link']) + "\n            ")])])])])])], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2050 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [(_vm.editsms) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.sms.edit')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.sms.new')))]), _vm._v("\n        " + _vm._s(_vm.$t('vue2.sms.standard_sms')))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.sms.subject')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    ref: "titleInput",
	    class: {
	      'input--error': _vm.errors.title
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('vue2.sms.ex_you_are_sub')
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.resetValidation('title')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.title = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.title) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.errors.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group marg-10-top"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.sms.message')))]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body),
	      expression: "body"
	    }],
	    ref: "smsbodyinput",
	    class: {
	      'input--error': _vm.errors.body
	    },
	    domProps: {
	      "value": (_vm.body)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.resetValidation('body')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.body = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.body) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.errors.body))]) : _vm._e()]), _vm._v(" "), _c('button', {
	    staticClass: "bttn--small marg-5-top",
	    on: {
	      "click": _vm.insertToday
	    }
	  }, [_vm._v(_vm._s(_vm.today))]), _vm._v(" "), _c('span', {
	    staticClass: "d-desc link",
	    on: {
	      "click": _vm.insertToday
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.sms.insert_today_to')) + " \"" + _vm._s(_vm.today) + "\"")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "bttn bttn-simple marg-10-right",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (_vm.editsms) ? _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.updateTemplate
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.update')) + "\n      ")]) : _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.create')))])])])])
	},staticRenderFns: []}

/***/ }),
/* 2051 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cals box cals-classes",
	    class: _vm.step.uniClass
	  }, [(_vm.isOnboarding) ? _c('div', {
	    staticClass: "onboard-pill"
	  }, [_c('span', {
	    staticClass: "onboard-pill__status",
	    class: {
	      'onboard-pill__status__done': _vm.step.done
	    }
	  }, [(_vm.step.done) ? _c('span', {
	    staticClass: "icon-checkmark4 js-setupWidgetEvent"
	  }) : _vm._e()]), _vm._v(" " + _vm._s(_vm.$t('vue2.dashboard.step')) + " " + _vm._s(_vm.step.stepNum) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.step.icon) ? _c('span', {
	    staticClass: "cals_icon",
	    class: _vm.step.icon
	  }) : _vm._e(), _vm._v(" "), (_vm.step.stepNum < 6 && _vm.isLoading) ? _c('spinner', {
	    staticStyle: {
	      "margin-top": "30px"
	    },
	    attrs: {
	      "color": "blue",
	      "size": "small"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step.number >= 0 && !_vm.isLoading) ? _c('h6', [_vm._v(_vm._s(_vm.step.number))]) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.step.title))]), _vm._v(" "), (_vm.step.desc && _vm.isOnboarding) ? _c('p', {
	    staticClass: "step-desc"
	  }, [_vm._v(_vm._s(_vm.step.desc))]) : _vm._e(), _vm._v(" "), (!_vm.isOnboarding) ? [(_vm.step.buttonText) ? _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.step.action
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.step.buttonText) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isSchoolFromNorway) ? _c('button', {
	    staticClass: "bttn bttn-simple youtube-popup",
	    on: {
	      "click": function($event) {
	        return _vm.seeTutorial(_vm.step)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-play3"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.dashboard.tutorial')) + " (" + _vm._s(_vm.step.guideDuration) + ")\n    ")]) : _vm._e()] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 2052 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "absence-sidebar text-dark"
	  }, [_c('div', {
	    staticClass: "absence-sidebar__header"
	  }, [_c('div', {
	    staticClass: "absence-sidebar__header__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.i18n['absent_on_date']))])]), _vm._v(" "), _c('div', {
	    staticClass: "absence-sidebar__date-nav"
	  }, [_c('button', {
	    staticClass: "date-buttons",
	    on: {
	      "click": _vm.prevDay
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-left4"
	  })]), _vm._v(" "), _c('DateSelector', {
	    attrs: {
	      "date": _vm.selectedDate,
	      "width100": true
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "date-buttons",
	    on: {
	      "click": _vm.nextDay
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-right4"
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "absence-sidebar__body"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "absence-sidebar__spinner"
	  }, [_c('div', {
	    staticClass: "do-spinner"
	  })]) : (_vm.absentUsers.length < 1) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n['no_one_absent']))]) : _c('ul', _vm._l((_vm.absentUsers), function(user) {
	    return _c('li', {
	      key: user.id,
	      staticClass: "absent-user shadow",
	      class: {
	        'absent-user--requester': user.isRequester
	      }
	    }, [_c('div', {
	      staticClass: "absent-user__name"
	    }, [_vm._v(_vm._s(user.name))]), _vm._v(" "), _vm._l((user.absence), function(absence, idx) {
	      return _c('div', {
	        key: idx,
	        staticClass: "absent-user__absence"
	      }, [_c('b', [_vm._v(_vm._s(absence.title))]), _vm._v(" "), _c('span', [_c('span', {
	        staticClass: "icon-clock"
	      }), _vm._v(" " + _vm._s(absence.timeRange))]), _vm._v(" "), (absence.dateRange) ? _c('span', [_c('span', {
	        staticClass: "icon-calendar4"
	      }), _vm._v(" " + _vm._s(absence.dateRange))]) : _vm._e()])
	    })], 2)
	  }), 0)])])
	},staticRenderFns: []}

/***/ }),
/* 2053 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container"
	  }, [(_vm.error) ? _c('div', {
	    staticClass: "text-explainer text-explainer__error"
	  }, [_c('h3', [_c('svg', {
	    staticClass: "tw-icon icon-important",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
	    }
	  }), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
	    }
	  })]), _vm._v("\n    Der er stadig oplysninger der skal udfyldes før der kan indberettes\n    ")]), _vm._v(" "), _c('h4', [_vm._v("Fejlmeddelelse fra STIL:")]), _vm._v(" "), _c('p', {
	    staticClass: "error-message"
	  }, [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.klasserUdenFag.length > 0) ? _c('div', {
	    staticClass: "d-attention"
	  }, [_c('svg', {
	    staticClass: "tw-icon icon-important",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
	    }
	  }), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
	    }
	  })]), _vm._v(" "), _c('h3', [_vm._v("Følgende klasser har ingen fag, og skal derfor ikke indberettes.")]), _vm._v(" "), _c('p', [_vm._v("Slet dem i denne liste, hvis de ikke skal indberettes")]), _vm._v(" "), _c('table', {
	    staticClass: "d-table d-table__borders"
	  }, [_c('tbody', _vm._l((_vm.klasserUdenFag), function(klasse, key) {
	    return _c('tr', {
	      key: klasse.klasse_id
	    }, [_c('td', [_c('div', {
	      staticClass: "grade-name"
	    }, [_c('div', {
	      staticClass: "hint--top-right d-hidden__dropdown",
	      attrs: {
	        "aria-label": 'Slet ' + klasse.klassebetegnelse + ' fra indberetningen'
	      }
	    }, [_c('button', {
	      staticClass: "icon__bg-circle icon__bg-circle--danger",
	      on: {
	        "click": function($event) {
	          return _vm.confirmDeleteGrade(klasse)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })])]), _vm._v("\n          " + _vm._s(klasse.klassebetegnelse) + "\n          ")])])])
	  }), 0)])]) : _vm._e(), _vm._v(" "), _c('IndberetetPersonale', {
	    attrs: {
	      "stilData": _vm.stilData
	    }
	  }), _vm._v(" "), _c('IndberetFag', {
	    attrs: {
	      "stilData": _vm.stilData
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "submit-bttn__container"
	  }, [(_vm.error) ? _c('div', {
	    staticClass: "hint--left",
	    attrs: {
	      "aria-label": "Der er stadig oplysninger der skal udfyldes før der kan indberettes"
	    }
	  }, [_c('button', {
	    staticClass: "bttn bttn--primary bttn--primary--disabled",
	    staticStyle: {
	      "width": "165px"
	    }
	  }, [_vm._v("\n        Afslut og indberet\n      ")])]) : _c('button', {
	    staticClass: "bttn bttn--primary",
	    class: {
	      'bttn--loading': _vm.isSendingToStil
	    },
	    staticStyle: {
	      "width": "165px"
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Afslut og indberet\n    ")])]), _vm._v(" "), (_vm.messageFromStil.length > 0) ? _c('DModal', {
	    attrs: {
	      "is-bg-overlay": true,
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "doc-modal__header"
	  }, [_c('h2', [_vm._v("Svar fra STIL")]), _vm._v(" "), _c('div', {
	    staticClass: "doc-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.messageFromStil = ''
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "doc-modal__body"
	  }, [_c('p', {
	    staticClass: "message-from-stil"
	  }, [_vm._v("\"" + _vm._s(_vm.messageFromStil) + "\"")])])])]) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container__header"
	  }, [_c('h2', {
	    staticClass: "uppercase"
	  }, [_vm._v("Resume")])])
	}]}

/***/ }),
/* 2054 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "modal"
	    }
	  }, [(_vm.show) ? _c('div', {
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        return _vm.$emit('removeModal')
	      }
	    }
	  }, [_c('div', {
	    class: [{
	      'modal-mask': _vm.show_modal_mask
	    }, {
	      'modal-add-sidebar': _vm.show_modal_sidebar
	    }]
	  }, [_c('div', {
	    staticClass: "modal-wrapper"
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.clickAway),
	      expression: "clickAway"
	    }],
	    staticClass: "modal-container"
	  }, [_c('div', {
	    staticClass: "modal-left"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_vm._t("header", function() {
	    return [_vm._v("default header")]
	  }), _vm._v(" "), _c('div', {
	    staticClass: "font-large close-cross icon__bg-circle js-modalCloseEvent",
	    on: {
	      "click": _vm.removeModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2 pointer js-modalCloseEvent"
	  })])], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_vm._t("body", function() {
	    return [_vm._v("default body")]
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_vm._t("footer", function() {
	    return [_c('button', {
	      staticClass: "bttn bttn_simple right marg-10"
	    }, [_vm._v("\n                  Ok\n                ")]), _vm._v(" "), _c('button', {
	      staticClass: "bttn bttn_simple right marg-10"
	    }, [_vm._v("\n                  Gem\n                ")])]
	  })], 2)]), _vm._v(" "), (_vm.show_modal_sidebar) ? _c('div', {
	    staticClass: "modal-right"
	  }, [_c('div', {
	    staticClass: "modal-sidebar"
	  }, [_vm._t("sidebar")], 2)]) : _vm._e()])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2055 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-datepicker"
	  }, [_c('div', {
	    staticClass: "do-datepicker__buttons"
	  }, [_c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "propOffset": [0, 5]
	    }
	  }, [_c('button', {
	    staticClass: "bttn-with-icon",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("\n        " + _vm._s(_vm.activeShortCutTitle) + "\n        "), _c('svg', {
	    staticClass: "tw-icon tw-icon-cheveron-down",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "fill-rule": "evenodd",
	      "d": "M15.3 10.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
	    }
	  })])]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, _vm._l((_vm.dateShortCuts), function(dateShortCut) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.setDateFromShortCut(dateShortCut)
	        }
	      }
	    }, [_vm._v("\n          " + _vm._s(dateShortCut.title) + "\n        ")])
	  }), 0)]), _vm._v(" "), (_vm.isDateDropdown) ? _c('div', {
	    ref: "child_popper",
	    staticClass: "do-datepicker__dropdown",
	    class: {
	      'd-dropdown--animate': _vm.isPopperReady,
	      'd-dropdown--show': _vm.isPopperDone
	    }
	  }, [_c('div', {
	    staticClass: "do-datepicker__dropdown__header"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n['select_dates']))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.isDateDropdown = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-datepicker__dropdown__body"
	  }, [_c('Datepickerrange', {
	    attrs: {
	      "allowSameDate": _vm.allowSameDate,
	      "maximumDateRange": _vm.maximumDateRange,
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-datepicker__dropdown__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.submitDateRange
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['submit']))])])]) : _vm._e(), _vm._v(" "), _c('button', {
	    ref: "date_input_button",
	    on: {
	      "click": _vm.openIsDateDropdown
	    }
	  }, [_c('span', {
	    staticClass: "icon-calendar4"
	  }), _vm._v("\n      " + _vm._s(_vm.dateRangeFormatted) + "\n    ")])], 1), _vm._v(" "), (_vm.isDateDropdown) ? _c('div', {
	    staticClass: "bg-overlay do-datepicker__dropdown__overlay",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.closeIsDateDropdown.apply(null, arguments)
	      }
	    }
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2056 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickAway),
	      expression: "onClickAway"
	    }],
	    ref: "d_select",
	    staticClass: "d-select text-dark",
	    class: {
	      'openFromBottom': _vm.openFromBottom,
	      'd-select--single-select': !_vm.multiple
	    }
	  }, [_c('div', {
	    staticClass: "width-100 no-print",
	    class: {
	      'box-shadow': _vm.boxShadow
	    }
	  }, [_c('div', {
	    ref: "toggle",
	    staticClass: "d-select__input-look",
	    class: {
	      'active': _vm.showDropdown
	    },
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._l((_vm.selectedUsers), function(selectedUser) {
	    return _c('div', {
	      staticClass: "d-select__selected__item",
	      class: [{
	          'readyToDelete': _vm.isReadyToDelete(selectedUser)
	        },
	        {
	          'd-select__selected__item--item-is-error': selectedUser.isErrorUser
	        }
	      ]
	    }, [_vm._v("\n        " + _vm._s(selectedUser.name) + "\n        "), _vm._t("item_identifier", null, {
	      "userId": selectedUser.user_calendar_id
	    }), _vm._v(" "), (_vm.userOccEvents(selectedUser) && _vm.userOccEvents(selectedUser).length > 0) ? [_c('div', {
	      staticClass: "icon-warning item__icon-warning marg-5-left",
	      class: {
	        'item_icon__hide': selectedUser.occupied.events.length === 1 && selectedUser.occupied.events[0].event_type === 'presence' || selectedUser.isOnLesson && selectedUser.occupied.events.length === 1
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "d-select__selected__item__secret-label"
	    }, [_c('div', {
	      staticClass: "icon-warning"
	    }), _vm._v(" "), _vm._l((_vm.userOccEvents(selectedUser)), function(event, index) {
	      return (index < 3) ? _c('div', {
	        staticClass: "d-select__selected__item__secret-label__event"
	      }, [_vm._v("\n              " + _vm._s(event.title) + "\n            ")]) : _vm._e()
	    })], 2)] : _vm._e(), _vm._v(" "), (_vm.isShowRemoveButton && !selectedUser.isErrorUser) ? _c('div', {
	      staticClass: "d-select__selected__item__remove",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.removeUser(selectedUser)
	        }
	      }
	    }, [_c('span', [_vm._v("×")])]) : (!_vm.isShowRemoveButton) ? _c('div', {
	      staticClass: "d-select__selected__item__menu-open"
	    }, [_c('span', {
	      staticClass: "icon-menu-open"
	    })]) : _vm._e()], 2)
	  }), _vm._v(" "), (_vm.isLoading) ? [_c('spinner', {
	    staticStyle: {
	      "margin": "7px 0 0 0"
	    },
	    attrs: {
	      "color": "blue",
	      "size": "small"
	    }
	  })] : [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchText),
	      expression: "searchText"
	    }],
	    ref: "inputfield",
	    staticClass: "d-select__header__search",
	    class: [{
	      'show': _vm.showDropdown
	    }, {
	      'input-active': _vm.searchText.length > 0 || _vm.selectedUsers.length < 1
	    }],
	    attrs: {
	      "type": "search",
	      "placeholder": _vm.placeholderText
	    },
	    domProps: {
	      "value": (_vm.searchText)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchText = $event.target.value
	      }, _vm.debounceSearch],
	      "keypress": function($event) {
	        return _vm.selectWithKeyboard('', $event)
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.selectWithKeyboard('enter', $event)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
	        $event.preventDefault();
	        return _vm.selectWithKeyboard('down')
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
	        $event.preventDefault();
	        return _vm.selectWithKeyboard('up')
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
	        return _vm.deleteUserWithKeyboard.apply(null, arguments)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
	        return _vm.onTabKeyDown.apply(null, arguments)
	      }]
	    }
	  })]], 2), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
	    ref: "d_select__items",
	    staticClass: "d-select__items text-dark",
	    class: _vm.addClass
	  }, [_c('ul', {
	    ref: "dropdown",
	    staticClass: "d-select__items__container",
	    on: {
	      "scroll": _vm.handleScroll
	    }
	  }, [_vm._l((_vm.searchedUsers), function(item, index) {
	    return [(index < _vm.maxLimit) ? _c('li', {
	      key: item.user_id,
	      class: [{
	          'isReadyForSelection': _vm.isSelectedWithKeyboard(item)
	        },
	        {
	          'item_is_selected': _vm.isSelected(item)
	        }
	      ],
	      on: {
	        "mouseenter": function($event) {
	          return _vm.setIsReadyForSelection(item, index)
	        },
	        "click": function($event) {
	          return _vm.toggleUser(item)
	        }
	      }
	    }, [(item.occupied && item.occupied.events.length > 0) ? [_c('div', {
	      staticClass: "item-template isOccupied",
	      class: [{
	          'item-is-present': item.occupied.events.length === 1 && item.occupied.events[0].event_type === 'presence'
	        },
	        {
	          'item-is-already-attached': item.isOnLesson || item.isWithAvailability
	        }
	      ]
	    }, [_vm._t("occupied-item", function() {
	      return [(item.icon) ? _c('span', {
	        staticClass: "marg-10-right",
	        class: item.icon
	      }) : _vm._e(), _vm._v(" "), (item.default_thumb_url) ? _c('img', {
	        attrs: {
	          "src": item.default_thumb_url,
	          "alt": ""
	        }
	      }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	        staticClass: "warning-signs"
	      }, [_vm._l((item.occupied.events), function(event) {
	        return [(event.event_type !== 'presence') ? [(item.isOnLesson && item.currentEventId === event.event_id) ? _c('div', {
	          staticClass: "marg-10-left"
	        }, [_c('span', {
	          staticClass: "icon-user"
	        }), _vm._v(" " + _vm._s(_vm.i18n['also_assigned']) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
	          directives: [{
	            name: "show",
	            rawName: "v-show",
	            value: (item.currentEventId !== event.event_id),
	            expression: "item.currentEventId !== event.event_id"
	          }],
	          staticClass: "marg-10-left warning-signs__sign"
	        }, [_c('span', {
	          staticClass: "icon-warning"
	        }), _vm._v(" " + _vm._s(event.title) + "\n                        ")])] : _vm._e(), _vm._v(" "), _c('div', {
	          directives: [{
	            name: "show",
	            rawName: "v-show",
	            value: (item.occupied.events.length === 1 && event.event_type === 'presence'),
	            expression: "item.occupied.events.length === 1 && event.event_type === 'presence'"
	          }],
	          staticClass: "marg-10-left"
	        }, [_c('span', {
	          staticClass: "icon-clock"
	        }), _vm._v(" " + _vm._s(_vm.i18n['working_hours']) + ":\n                        " + _vm._s(_vm._f("localeTime")(event.event_time_start)) + " -\n                        " + _vm._s(_vm._f("localeTime")(event.event_time_end)) + "\n                      ")])]
	      })], 2)]
	    }, {
	      "item": item
	    })], 2)] : _c('div', {
	      staticClass: "item-template",
	      class: {
	        'item-template--space-between': _vm.itemSpaceBetween
	      }
	    }, [(item.icon) ? _c('span', {
	      staticClass: "marg-10-right",
	      class: item.icon
	    }) : _vm._e(), _vm._v(" "), (item.default_thumb_url) ? _c('img', {
	      attrs: {
	        "src": item.default_thumb_url,
	        "alt": ""
	      }
	    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._t("item-badge", null, {
	      "item": item
	    })], 2)], 2) : _vm._e()]
	  }), _vm._v(" "), (_vm.searchedUsers.length > _vm.maxLimit) ? _c('li', {
	    ref: "infinite_scroll",
	    staticClass: "infinite-scroll__bottom"
	  }, [_c('Loader', {
	    staticStyle: {
	      "margin": "12px"
	    },
	    attrs: {
	      "is-extra-small": true,
	      "bg-color": "#fff"
	    }
	  })], 1) : _vm._e()], 2), _vm._v(" "), (_vm.searchedUsers.length < 1) ? _c('div', {
	    staticClass: "no-match"
	  }, [_vm._t("noMatch", function() {
	    return [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.dselect.no_matching_results')))])]
	  })], 2) : _vm._e()]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2057 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "day-cal"
	  }, [_c('div', {
	    staticClass: "day-cal__container"
	  }, [_c('ul', {
	    staticClass: "day-cal__time-sidebar"
	  }, _vm._l((_vm.hoursInLocale), function(n) {
	    return _c('li', {
	      staticClass: "time-hours"
	    }, [_vm._v("\n          " + _vm._s(n) + "\n        ")])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('ul', {
	    staticClass: "day-cal__time-background"
	  }, [_vm._l((_vm.hours.length * 2), function(n) {
	    return _c('li', {
	      staticClass: "time-slot",
	      class: {
	        today: _vm.isToday
	      }
	    })
	  }), _vm._v(" "), (_vm.isToday) ? _c('now-indicator', {
	    attrs: {
	      "start": _vm.start,
	      "slotHeight": _vm.slotHeight
	    }
	  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "day-cal__event-container"
	  }, [_vm._l((_vm.correctEvents), function(event) {
	    return [_c('cal-event', {
	      attrs: {
	        "event": event,
	        "start": _vm.start,
	        "i18n": _vm.i18n
	      },
	      on: {
	        "eventClicked": _vm.onTap
	      }
	    })]
	  })], 2)])])])])
	},staticRenderFns: []}

/***/ }),
/* 2058 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._v(_vm._s(_vm.count))])
	},staticRenderFns: []}

/***/ }),
/* 2059 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    ref: "d_modal",
	    staticClass: "modal__confirm__delete-wrapper text-dark",
	    class: [{
	      'js-no-close': _vm.appendToBody
	    }, {
	      'modal__confirm__delete__wider': _vm.isShowDontAskAgain
	    }],
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    ref: "modalContent",
	    staticClass: "modal__confirm__delete",
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-modal": "true",
	      "aria-label": _vm.ariaLabel || null
	    }
	  }, [(_vm.showClose) ? _c('div', {
	    staticClass: "close-cross icon__bg-circle",
	    attrs: {
	      "role": "button",
	      "tabindex": "0",
	      "aria-label": _vm.i18n.cancel
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.stopPropagation();
	        return _vm.$emit('close')
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        $event.stopPropagation();
	        return _vm.$emit('close')
	      }]
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]) : _vm._e(), _vm._v(" "), _vm._t("insertComponent", function() {
	    return [_c('div', {
	      staticClass: "modal__confirm__delete__template",
	      style: ({
	        width: _vm.customWidth
	      }),
	      attrs: {
	        "slot": "insertComponent"
	      },
	      slot: "insertComponent"
	    }, [_c('div', {
	      staticClass: "modal__confirm__header"
	    }, [_c('div', {
	      staticClass: "modal__confirm__delete__close icon__bg-circle",
	      attrs: {
	        "role": "button",
	        "tabindex": "0",
	        "aria-label": _vm.i18n.cancel
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.$emit('close')
	        },
	        "keydown": [function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	          $event.stopPropagation();
	          return _vm.$emit('close')
	        }, function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	          $event.preventDefault();
	          $event.stopPropagation();
	          return _vm.$emit('close')
	        }]
	      }
	    }, [_c('span', {
	      staticClass: "icon-cross2",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })]), _vm._v(" "), _vm._t("item"), _vm._v(" "), (_vm.isShowConfirmDeleteMessage) ? [(!_vm.isOnlyOwnCalendarText) ? _c('h4', [_vm._v(_vm._s(_vm.i18n.are_you_sure))]) : _vm._e(), _vm._v(" "), (_vm.isOnlyOwnCalendarText) ? _c('h4', [_vm._v(_vm._s(_vm.i18n.are_you_sure_own_calendar))]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "custom-warning"
	    }, [_vm._t("custom_warning")], 2), _vm._v(" "), _c('div', {
	      staticClass: "modal__confirm__delete__buttons",
	      class: {
	        'modal__confirm__delete__buttons__no-margin': _vm.noMarginOnButton
	      }
	    }, [(_vm.isShowDontAskAgain) ? _c('div', {
	      staticClass: "do-checkbox-group"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.isDontAskAgain),
	        expression: "isDontAskAgain"
	      }],
	      staticClass: "form-check-input",
	      attrs: {
	        "type": "checkbox",
	        "id": "dontAskAgain"
	      },
	      domProps: {
	        "checked": Array.isArray(_vm.isDontAskAgain) ? _vm._i(_vm.isDontAskAgain, null) > -1 : (_vm.isDontAskAgain)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.isDontAskAgain,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.isDontAskAgain = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (_vm.isDontAskAgain = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.isDontAskAgain = $$c
	          }
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      staticClass: "d-label form-check-label",
	      attrs: {
	        "for": "dontAskAgain"
	      }
	    }, [_vm._v(_vm._s(_vm.i18n.dont_ask_me_again))])]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "modal__confirm__delete__buttons__buttons"
	    }, [_vm._t("confirm_buttons", function() {
	      return [_c('button', {
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.$emit('close')
	          }
	        }
	      }, [_vm._v(_vm._s(_vm.i18n.cancel))]), _vm._v(" "), _c('button', {
	        ref: "submit_bttn",
	        staticClass: "bttn bttn--danger",
	        class: {
	          'bttn--loading': _vm.isSubmitButtonLoading
	        },
	        on: {
	          "keyup": [function($event) {
	            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	            return _vm.onConfirm.apply(null, arguments)
	          }, function($event) {
	            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	            return _vm.$emit('close')
	          }],
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.onConfirm.apply(null, arguments)
	          }
	        }
	      }, [_vm._t("confirmText", function() {
	        return [_vm._v(_vm._s(_vm.i18n.delete))]
	      })], 2)]
	    })], 2)])], 2)])]
	  })], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 2060 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "to-categories"
	  }, [_c('div', {
	    staticClass: "to-categories-container"
	  }, [_c('div', {
	    staticClass: "to-categories__header"
	  }, [_c('h3', [_vm._v("Opgaveoversigt kategorier " + _vm._s(_vm.schoolYear.name))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('setCreateCategory', true)
	      }
	    }
	  }, [_vm._v("\n        Opret ny kategori\n      ")])]), _vm._v(" "), (_vm.taskCategories.length < 1) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen kategorier")]) : _vm._e(), _vm._v(" "), _c('draggable', {
	    on: {
	      "change": _vm.onChangeOrder
	    },
	    model: {
	      value: (_vm.taskCategoriesOrder),
	      callback: function($$v) {
	        _vm.taskCategoriesOrder = $$v
	      },
	      expression: "taskCategoriesOrder"
	    }
	  }, [_c('transition-group', {
	    attrs: {
	      "type": "transition",
	      "name": "flip-list",
	      "tag": "ul"
	    }
	  }, _vm._l((_vm.taskCategoriesOrder), function(taskCategory, key) {
	    return _c('li', {
	      key: taskCategory.id,
	      staticClass: "to-categories-container__category__container"
	    }, [_c('div', {
	      staticClass: "to-categories-container__category"
	    }, [_c('div', [_c('div', {
	      staticClass: "to-categories-container__category__number"
	    }, [_c('span', [_vm._v(_vm._s(key + 1))]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: false,
	          placement: 'top',
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n                    arrow: false,\n                      placement : 'top',\n                      animation : 'shift-away',\n                      zIndex: '999999992',\n                      boundary: 'window'\n                }"
	      }],
	      staticClass: "icon__bg-circle icon__bg-circle--move",
	      attrs: {
	        "content": 'Flyt op eller ned for at sortere'
	      }
	    }, [_c('svg', {
	      staticStyle: {
	        "enable-background": "new 0 0 572.156 572.156"
	      },
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "xmlns:xlink": "http://www.w3.org/1999/xlink",
	        "version": "1.1",
	        "id": "Capa_1",
	        "x": "0px",
	        "y": "0px",
	        "width": "13px",
	        "height": "13px",
	        "viewBox": "0 0 572.156 572.156",
	        "xml:space": "preserve"
	      }
	    }, [_c('g', [_c('polygon', {
	      attrs: {
	        "points": "495.405,241.769 418.657,197.457 418.657,258.115 314.042,258.115 314.042,153.498 374.699,153.498    330.389,76.751 286.078,0 241.769,76.751 197.457,153.498 258.115,153.498 258.115,258.115 153.498,258.115 153.498,197.457    76.751,241.767 0,286.078 76.751,330.387 153.498,374.699 153.498,314.042 258.115,314.042 258.115,418.657 197.457,418.657    241.767,495.405 286.078,572.156 330.387,495.405 374.699,418.657 314.042,418.657 314.042,314.042 418.657,314.042    418.657,374.699 495.405,330.389 572.156,286.078  "
	      }
	    })]), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g')])])]), _vm._v(" "), _c('div', {
	      staticClass: "to-categories-container__category__text"
	    }, [(_vm.getIsTheEditTask(taskCategory)) ? _c('div', {
	      staticClass: "to-input-and-button"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.theEditTask.name),
	        expression: "theEditTask.name"
	      }, {
	        name: "focus",
	        rawName: "v-focus"
	      }],
	      staticClass: "d-input",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (_vm.theEditTask.name)
	      },
	      on: {
	        "keyup": [function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	          return _vm.saveEditTask.apply(null, arguments)
	        }, function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	          $event.stopPropagation();
	          return _vm.setEditTask(null)
	        }],
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.theEditTask, "name", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('button', {
	      staticClass: "do-bttn do-bttn--submit",
	      class: {
	        'do-bttn--submit--loading': _vm.theUpdatingTaskId === taskCategory.id
	      },
	      on: {
	        "click": _vm.saveEditTask
	      }
	    }, [_vm._v("Gem\n                  ")]), _vm._v(" "), _c('button', {
	      staticClass: "do-bttn",
	      on: {
	        "click": function($event) {
	          return _vm.setEditTask(null)
	        }
	      }
	    }, [_vm._v("Annuller")]), _vm._v(" "), (taskCategory.v_is_used_on_subjects.length === 0) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: false,
	          placement: 'top',
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n                        arrow: false,\n                      placement : 'top',\n                      animation : 'shift-away',\n                      zIndex: '999999992',\n                      boundary: 'window'\n                    }"
	      }],
	      staticClass: "icon__bg-circle icon__bg-circle--danger",
	      attrs: {
	        "content": _vm.$t('vue2.common.delete')
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheDeleteTaskCategory(taskCategory)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })]) : _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: false,
	          placement: 'top',
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n                  arrow: false,\n                  placement : 'top',\n                  animation : 'shift-away',\n                  zIndex: '999999992',\n                  boundary: 'window'\n                }"
	      }],
	      staticClass: "icon__bg-circle icon__bg-circle--danger cursor-not-allowed",
	      attrs: {
	        "content": 'Kan ikke slettes, da den bruges på ' + taskCategory.v_is_used_on_subjects.length + ' fag/opgaver'
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin",
	      staticStyle: {
	        "opacity": "0.5"
	      }
	    })])]) : [_vm._v("\n                  " + _vm._s(taskCategory.name) + "\n                  "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: false,
	          placement: 'top',
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n                  arrow: false,\n                  placement : 'top',\n                  animation : 'shift-away',\n                  zIndex: '999999992',\n                  boundary: 'window'\n                }"
	      }],
	      staticClass: "icon__bg-circle",
	      attrs: {
	        "content": _vm.$t('vue2.common.edit')
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setEditTask(taskCategory)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-pencil"
	    })])]], 2)]), _vm._v(" "), _c('div', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selectedItem),
	        expression: "selectedItem"
	      }],
	      staticClass: "do-select",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.selectedItem = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	        }, function($event) {
	          return _vm.onAddSubjectType(taskCategory, $event.target.value)
	        }]
	      }
	    }, [_c('option', {
	      attrs: {
	        "disabled": "",
	        "selected": "",
	        "value": "null"
	      }
	    }, [_vm._v("Tilføj briktype til kategorien")]), _vm._v(" "), _vm._l((_vm.getFilteredDbSubjectTypes(taskCategory)), function(option) {
	      return _c('option', {
	        domProps: {
	          "value": option.key
	        }
	      }, [_vm._v("\n                  " + _vm._s(option.v_title) + "\n                ")])
	    })], 2)])]), _vm._v(" "), _c('ul', {
	      ref: "droppable_elements",
	      refInFor: true,
	      staticClass: "to-categories-container__category__subject-types dropzone",
	      class: {
	        'dropzone--active': _vm.dragEvt && _vm.draggedFromCategoryId !== taskCategory.id
	      },
	      on: {
	        "dragover": function($event) {
	          $event.preventDefault();
	        },
	        "dragenter": function($event) {
	          $event.preventDefault();
	          return _vm.dragEnter(taskCategory, $event)
	        },
	        "dragleave": function($event) {
	          $event.preventDefault();
	          return _vm.dragLeave.apply(null, arguments)
	        },
	        "drop": function($event) {
	          $event.preventDefault();
	          return _vm.drop(taskCategory, $event)
	        }
	      }
	    }, [(taskCategory.v_subject_types.length === 0) ? _c('li', {
	      staticClass: "text-explainer"
	    }, [_vm._v("Ingen kategorier")]) : _vm._e(), _vm._v(" "), _vm._l((taskCategory.v_subject_types), function(subjectType) {
	      return _c('li', {
	        key: subjectType.key,
	        staticClass: "d-tag cursor-grab",
	        attrs: {
	          "draggable": "true"
	        },
	        on: {
	          "dragstart": function($event) {
	            $event.stopPropagation();
	            return _vm.dragStart(subjectType, taskCategory.id, $event)
	          },
	          "dragend": function($event) {
	            $event.stopPropagation();
	            return _vm.dragEnd(subjectType, $event)
	          },
	          "dragover": function($event) {
	            $event.stopPropagation();
	          },
	          "drop": function($event) {
	            $event.preventDefault();
	            return _vm.drop(taskCategory, $event)
	          }
	        }
	      }, [_vm._v("\n              " + _vm._s(subjectType.v_name) + "\n            ")])
	    })], 2)])
	  }), 0)], 1)], 1), _vm._v(" "), (_vm.theDeleteTaskCategory) ? _c('DModal', {
	    staticStyle: {
	      "z-index": "123123"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": false,
	      "placeInTop": true,
	      "appendToBody": true,
	      "isCloseOnEsc": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setTheDeleteTaskCategory(null)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "brutto-warning text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-warning__header"
	  }, [_c('h2', [_vm._v("Er du sikker")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": function($event) {
	        return _vm.setTheDeleteTaskCategory(null)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-warning__body"
	  }, [_c('svg', {
	    staticClass: "tw-icon tw-icon--red",
	    attrs: {
	      "viewBox": "0 0 24 24",
	      "fill": "none",
	      "stroke": "currentColor",
	      "stroke-width": "2",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "9",
	      "x2": "12",
	      "y2": "13"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "17",
	      "x2": "12.01",
	      "y2": "17"
	    }
	  })]), _vm._v(" "), (_vm.theDeleteTaskCategory.v_subject_types && _vm.theDeleteTaskCategory.v_subject_types.length > 0) ? [_c('h4', [_vm._v("Før du kan slette denne kategori, skal du vælge en ny kategori til dens standard briktyper.")]), _vm._v(" "), _c('ul', {
	    staticClass: "list-order-items"
	  }, _vm._l((_vm.theDeleteTaskCategory.v_subject_types), function(subjectType) {
	    return _c('li', {
	      key: subjectType.key
	    }, [_c('b', [_vm._v(_vm._s(subjectType.v_name))]), _vm._v(" "), _c('select', {
	      staticClass: "do-select",
	      domProps: {
	        "value": null
	      },
	      on: {
	        "change": function($event) {
	          return _vm.onChangeCategoryForSubjectType($event.target.value, subjectType.key)
	        }
	      }
	    }, [_c('option', {
	      attrs: {
	        "disabled": ""
	      },
	      domProps: {
	        "value": null
	      }
	    }, [_vm._v("Vælg ny kategori..")]), _vm._v(" "), _vm._l((_vm.getTaskCategoriesOrder), function(option) {
	      return _c('option', {
	        domProps: {
	          "value": option.id
	        }
	      }, [_vm._v("\n                  " + _vm._s(option.name) + "\n                ")])
	    })], 2)])
	  }), 0)] : _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n          Vil du slette kategorien permanent?\n        ")])], 2), _vm._v(" "), _c('div', {
	    staticClass: "brutto-warning__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.setTheDeleteTaskCategory(null)
	      }
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), (_vm.theDeleteTaskCategory.v_subject_types.length > 0) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
	  }, [_vm._v("Slet\n        ")]) : _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--danger",
	    class: [{
	      'do-bttn--submit--loading': _vm.theDeletedCategoryId === _vm.theDeleteTaskCategory.id
	    }],
	    on: {
	      "click": function($event) {
	        return _vm.deleteTaskCategory(_vm.theDeleteTaskCategory)
	      }
	    }
	  }, [_vm._v("Slet\n        ")])])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2061 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "subject-dist text-dark",
	    class: {
	      'subject-dist--print-table': _vm.isPrintingTable
	    }
	  }, [(_vm.noActiveSchoolYears) ? _c('Banner') : _vm._e(), _vm._v(" "), (_vm.isPrintUsers) ? _c('SubjectDistributionPrint', {
	    on: {
	      "close": _vm.closeIsPrintUsers
	    }
	  }) : [_c('div', {
	    staticClass: "subject-dist__header"
	  }, [_c('div', {
	    staticClass: "subject-dist__header__left"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.i18n[_vm.locale].subjects_for_teachers))]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "subject-dist__header__right"
	  }, [(_vm.userCanManageSchool) ? [_c('DDropdown', {
	    staticClass: "marg-05-right",
	    attrs: {
	      "isShowDots": false,
	      "isBottomStart": false,
	      "propOffset": [0, 8]
	    },
	    scopedSlots: _vm._u([{
	      key: "title",
	      fn: function() {
	        return [_c('button', {
	          staticClass: "do-bttn do-bttn--menu-button bttn-export",
	          attrs: {
	            "type": "button"
	          }
	        }, [_vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale].automatic_scheduling) + " "), _c('span', {
	          staticClass: "icon-menu-open"
	        })])]
	      },
	      proxy: true
	    }, {
	      key: "list",
	      fn: function() {
	        return [_c('ul', {
	          staticClass: "do-bttn--menu-button__list"
	        }, [_c('li', {
	          on: {
	            "click": function($event) {
	              _vm.isZenExportModal = true
	            }
	          }
	        }, [_vm._v("\n                  " + _vm._s(_vm.i18n[_vm.locale].transfer_subjects_to_zen) + "\n                ")]), _vm._v(" "), (_vm.theZENToken.length > 0) ? _c('li', [_c('a', {
	          staticClass: "zen-auto-schedule-menu__link",
	          attrs: {
	            "href": _vm.zenUrl,
	            "target": "_blank"
	          }
	        }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].go_to_zen))])]) : _vm._e()])]
	      },
	      proxy: true
	    }], null, false, 147009285)
	  })] : (_vm.theZENToken.length > 0) ? _c('a', {
	    staticClass: "do-bttn",
	    attrs: {
	      "href": _vm.zenUrl,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].go_to_zen))]) : _vm._e(), _vm._v(" "), _c('Tabs', {
	    attrs: {
	      "tabs": _vm.viewTabs,
	      "selected": _vm.selectedViewTabId
	    },
	    on: {
	      "select": _vm.onSelectView
	    }
	  })], 2)]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "color": "blue"
	    }
	  }) : _c('div', {
	    staticClass: "subject-dist__body"
	  }, [_c('div', {
	    staticClass: "doTable__users"
	  }, [_c('div', {
	    staticClass: "doTable__users__header"
	  }, [_c('DoFiltersFilter', {
	    attrs: {
	      "tags": _vm.groupTags,
	      "selectedTags": _vm.selectedGroupTags
	    },
	    on: {
	      "select": _vm.toggleGroupTag,
	      "clear": _vm.clearSelectedGroupTags
	    }
	  })], 1), _vm._v(" "), (!_vm.isPoolsDeactivated) ? _c('div', {
	    staticClass: "filter pointer"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.isShowOnlyTeacherWithTeachingTime),
	      expression: "isShowOnlyTeacherWithTeachingTime"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "id": "only-teachers-with-teaching_time"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.isShowOnlyTeacherWithTeachingTime) ? _vm._i(_vm.isShowOnlyTeacherWithTeachingTime, null) > -1 : (_vm.isShowOnlyTeacherWithTeachingTime)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.isShowOnlyTeacherWithTeachingTime,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.isShowOnlyTeacherWithTeachingTime = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.isShowOnlyTeacherWithTeachingTime = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.isShowOnlyTeacherWithTeachingTime = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "marg-5-left pointer no-select",
	    attrs: {
	      "for": "only-teachers-with-teaching_time"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].only_show_users_with_uv_time) + "\n          ")])]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "d-box users-list"
	  }, [_c('li', {
	    staticClass: "user-item user-item__header"
	  }, [_c('div', {
	    staticClass: "user-sorter",
	    class: {
	      'user-sorter--active': _vm.sortBy === 'name'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortBy('name')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].name) + "\n              "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "user-sorter",
	    class: {
	      'user-sorter--active': _vm.sortBy === 'teachingTimeDiff'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortBy('teachingTimeDiff')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].teaching_hours) + " "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]), _vm._v(" "), (_vm.sortedUsersFilteredWithTags.length < 1) ? _c('h4', {
	    staticClass: "explainer-text"
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].no_users_matches) + "\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedUsersFilteredWithTags), function(user) {
	    return _c('li', {
	      key: user.user_calendar_id,
	      staticClass: "user-item",
	      class: {
	        'user-item--is-open': user.id === _vm.activeUserId
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveUserId(user.id)
	        }
	      }
	    }, [(user.id !== _vm.activeUserId) ? _c('div', {
	      staticClass: "user-item__name"
	    }, [_c('div', {
	      staticClass: "user-item__name__bttn icon__bg-circle hint--right",
	      attrs: {
	        "aria-label": _vm.$t('vue2.task_overview.task_and_hour_overview')
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setTheUserToShowTasks(user)
	        }
	      }
	    }, [_c('svg', {
	      staticClass: "icon-chart tw-icon tw-icon--small",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24"
	      }
	    }, [_c('path', {
	      staticClass: "primary",
	      attrs: {
	        "d": "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm11 4a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z"
	      }
	    }), _vm._v(" "), _c('path', {
	      staticClass: "secondary",
	      attrs: {
	        "d": "M8 11a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm4-2a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z"
	      }
	    })])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])]) : _vm._e(), _vm._v(" "), (user.id !== _vm.activeUserId) ? _c('div', [(_vm.userHasAgreements(user.id)) ? _c('span', {
	      staticClass: "icon-file-text2"
	    }) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.isLessonsPerWeekActive ? _vm.userLessonsPerWeekMap[user.id] : _vm.userTeachingDiffMap[user.id]) + "\n              "), _c('span', {
	      staticClass: "icon-arrow-down4"
	    })]) : _vm._e(), _vm._v(" "), (user.id === _vm.activeUserId) ? _c('SubjectsDistributionUser', {
	      attrs: {
	        "activeUserId": _vm.activeUserId,
	        "isPoolsDeactivated": _vm.isPoolsDeactivated,
	        "showLessonsPerWeek": _vm.isLessonsPerWeekActive
	      },
	      on: {
	        "editSubject": _vm.setEditSubject,
	        "editTask": _vm.setEditTask,
	        "showUserTasks": _vm.setTheUserToShowTasks,
	        "close": _vm.resetActiveUserId
	      }
	    }) : _vm._e()], 1)
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "subjects-and-tasks"
	  }, [(_vm.isTasksNewView) ? _c('SubjectsDistributionTasksFromSubjects') : (_vm.isTasksView) ? _c('SubjectsDistributionTasks') : (_vm.isCampsView) ? _c('SchoolCamps') : [_c('div', {
	    staticClass: "subject-dist__header"
	  }, [_c('div', {
	    staticClass: "subject-dist__header__left"
	  }, [_c('DoFiltersPopover', {
	    attrs: {
	      "selectedCount": _vm.allSelectedFiltersCount
	    },
	    on: {
	      "clearAll": _vm.clearAllFilters
	    }
	  }, [_c('div', {
	    staticClass: "do-filters-popover__item"
	  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n[_vm.locale].filter_by_status))]), _vm._v(" "), _vm._l((_vm.subjectStatusFilters), function(statusFilter) {
	    return _c('button', {
	      key: statusFilter,
	      staticClass: "do-filters-popover__quick-filter",
	      class: {
	        'do-filters-popover__quick-filter--selected': _vm.selectedSubjectStatusFilters.includes(statusFilter)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleSelectedSubjectStatusFilters(statusFilter)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-checkmark-circle"
	    }), _vm._v("\n                    " + _vm._s(statusFilter) + "\n                  ")])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "do-filters-popover__item"
	  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n[_vm.locale].filter_by_grades))]), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['grades'],
	      "tags": _vm.klassTags,
	      "selectedTags": _vm.selectedKlassFilters
	    },
	    on: {
	      "select": _vm.toggleKlassTag,
	      "clear": _vm.clearSelectedKlassFilters
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-filters-popover__item"
	  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n[_vm.locale].filter_by_subjects))]), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['subjects'],
	      "tags": _vm.uniqueSubjects,
	      "selectedTags": _vm.selectedSubjectFilters
	    },
	    on: {
	      "select": _vm.toggleSelectedSubjectFilters,
	      "clear": _vm.clearSelectedSubjectFilters
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-filters-popover__item"
	  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n[_vm.locale].filter_by_type))]), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": "Type",
	      "tags": _vm.uniqueSubjectTypeLabels,
	      "selectedTags": _vm.selectedTypeFilters
	    },
	    on: {
	      "select": _vm.toggleSelectedTypeFilters,
	      "clear": _vm.clearSelectedTypeFilters
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-filters-popover__item"
	  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n[_vm.locale].filter_by_persons))]), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['persons'],
	      "tags": _vm.uniquePersons,
	      "selectedTags": _vm.selectedPersonFilters
	    },
	    on: {
	      "select": _vm.toggleSelectedPersonFilters,
	      "clear": _vm.clearSelectedPersonFilters
	    }
	  })], 1)])], 1), _vm._v(" "), _c('div', {
	    staticClass: "subject-dist__header__right"
	  }, [(_vm.isUpdatingSchoolYear) ? _c('div', {
	    staticClass: "do-spinner do-spinner--small"
	  }) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.isTableView) ? _c('DDropdown', {
	    staticClass: "marg-05-right",
	    attrs: {
	      "isShowDots": false,
	      "isBottomStart": false,
	      "propOffset": [0, 8]
	    },
	    scopedSlots: _vm._u([{
	      key: "title",
	      fn: function() {
	        return [_c('button', {
	          staticClass: "do-bttn do-bttn--menu-button"
	        }, [(_vm.isDownloadingExcel) ? _c('span', {
	          staticClass: "do-spinner do-spinner--small"
	        }) : _c('span', {
	          staticClass: "icon-printer3"
	        }), _vm._v(" "), _c('span', {
	          staticClass: "icon-menu-open"
	        })])]
	      },
	      proxy: true
	    }, {
	      key: "list",
	      fn: function() {
	        return [_c('ul', {
	          staticClass: "do-bttn--menu-button__list do-bttn--menu-button__list__print"
	        }, [_c('li', {
	          on: {
	            "click": _vm.printTable
	          }
	        }, [_c('span', {
	          staticClass: "icon-printer3"
	        }), _vm._v(" Print tabel \n                    ")]), _vm._v(" "), _c('li', {
	          on: {
	            "click": _vm.asyncLoadXLSXAndDownloadTable
	          }
	        }, [_c('span', {
	          staticClass: "icon-download"
	        }), _vm._v(" Download til excel\n                    ")])])]
	      },
	      proxy: true
	    }], null, false, 369774330)
	  }) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish) ? _c('DDropdown', {
	    staticClass: "marg-05-right",
	    attrs: {
	      "isShowDots": false,
	      "isBottomStart": false,
	      "isCloseOnDropdownClick": false,
	      "propOffset": [0, 8]
	    },
	    scopedSlots: _vm._u([{
	      key: "title",
	      fn: function() {
	        return [_c('button', {
	          staticClass: "do-bttn do-bttn--menu-button"
	        }, [_vm._v("Visning "), _c('span', {
	          staticClass: "icon-menu-open"
	        })])]
	      },
	      proxy: true
	    }, {
	      key: "list",
	      fn: function() {
	        return [_c('ul', {
	          staticClass: "do-bttn--menu-button__list"
	        }, [_c('li', {
	          on: {
	            "click": function($event) {
	              _vm.viewMode = _vm.viewMode === 'table' ? 'tiles' : 'table'
	            }
	          }
	        }, [_vm._v("\n                      Vis som tabel\n                      "), (_vm.viewMode === 'table') ? _c('span', {
	          staticClass: "icon-checkmark-circle"
	        }) : _vm._e()]), _vm._v(" "), (_vm.isShowSubjectsRequest) ? _c('li', {
	          on: {
	            "click": function($event) {
	              _vm.showSubjectsRequestInTable = !_vm.showSubjectsRequestInTable
	            }
	          }
	        }, [_vm._v("\n                      Vis fagønsker i tabellen\n                      "), (_vm.showSubjectsRequestInTable) ? _c('span', {
	          staticClass: "icon-checkmark-circle"
	        }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isTableView) ? _c('li', {
	          on: {
	            "click": function($event) {
	              _vm.showDatesInTable = !_vm.showDatesInTable
	            }
	          }
	        }, [_vm._v("\n                      Vis datoer i tabellen\n                      "), (_vm.showDatesInTable) ? _c('span', {
	          staticClass: "icon-checkmark-circle"
	        }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('li', {
	          on: {
	            "click": function($event) {
	              _vm.showLessonsPerWeek = !_vm.showLessonsPerWeek
	            }
	          }
	        }, [_vm._v("\n                      Vis i lektioner\n                      "), (_vm.showLessonsPerWeek) ? _c('span', {
	          staticClass: "icon-checkmark-circle"
	        }) : _vm._e()]), _vm._v(" "), _c('li', {
	          on: {
	            "click": function($event) {
	              _vm.showActivities = !_vm.showActivities
	            }
	          }
	        }, [_vm._v("\n                      Vis aktiviteter i klasserne\n                      "), (_vm.showActivities) ? _c('span', {
	          staticClass: "icon-checkmark-circle"
	        }) : _vm._e()]), _vm._v(" "), _c('li', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              arrow: true,
	              placement: 'left'
	            }),
	            expression: "{ arrow: true, placement: 'left' }"
	          }],
	          attrs: {
	            "content": "Slå til hvis ressourcetimer ikke skal medregnes i klassens totale timetal"
	          },
	          on: {
	            "click": _vm.toggleDoesRessCount
	          }
	        }, [_vm._v("\n                      Ikke medregn ressourcetimer\n                      "), (!_vm.doesRessCountInKlassTotalHours) ? _c('span', {
	          staticClass: "icon-checkmark-circle"
	        }) : _vm._e()])])]
	      },
	      proxy: true
	    }], null, false, 3599190612)
	  }) : _vm._e(), _vm._v(" "), (_vm.userCanManageSchool && _vm.isSchoolDanish) ? _c('DoButtonAndDate', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: false,
	        placement: 'top'
	      }),
	      expression: "{\n                  arrow: false,\n                  placement : 'top'\n                }"
	    }],
	    attrs: {
	      "content": "Fag kan ønskes af brugere med rettigheden",
	      "selectedDate": _vm.subjectsRequestEndDate
	    },
	    on: {
	      "dateChanged": _vm.onSetSubjectsRequestEndDate
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.isTableView && _vm.isEditingDates) ? _c('div', {
	    staticClass: "bulk-dates-bar"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.toggleSelectAllVisible
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.allVisibleSelected ? 'Fravælg alle' : 'Vælg alle') + "\n            ")]), _vm._v(" "), _c('span', {
	    staticClass: "bulk-dates-bar__count"
	  }, [_vm._v(_vm._s(_vm.selectedSubjectIds.length) + " valgt")]), _vm._v(" "), (_vm.selectedSubjectIds.length > 0) ? [_c('DatePickerRange', {
	    attrs: {
	      "startdate": _vm.bulkFromDate,
	      "enddate": _vm.bulkToDate,
	      "minDate": _vm.bulkDateMin,
	      "maxDate": _vm.bulkDateMax,
	      "maxEndDate": _vm.bulkDateMax,
	      "allowSameDate": true
	    },
	    on: {
	      "startchanged": _vm.setBulkFromDate,
	      "endchanged": _vm.setBulkToDate
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSavingBulkDates
	    },
	    attrs: {
	      "disabled": _vm.isSavingBulkDates
	    },
	    on: {
	      "click": _vm.saveBulkDates
	    }
	  }, [_vm._v("\n                Gem\n              ")])] : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn bulk-dates-bar__cancel",
	    on: {
	      "click": _vm.cancelEditDates
	    }
	  }, [_vm._v("Annuller")])], 2) : _vm._e(), _vm._v(" "), (_vm.isTableView) ? _c('SubjectsDistributionTable', {
	    attrs: {
	      "doesRessCountInKlassTotalHours": _vm.doesRessCountInKlassTotalHours,
	      "subjectDefaultDuration": _vm.subjectDefaultDuration,
	      "filteredKlassCals": _vm.filteredKlassCals,
	      "showLessonsPerWeek": _vm.showLessonsPerWeek,
	      "showTeacherPoolHours": _vm.showTeacherPoolHours,
	      "showSubjectsRequest": _vm.showSubjectsRequestInTable && _vm.isShowSubjectsRequest && Object.keys(_vm.subjectsRequestsInHash).length > 0,
	      "showDates": _vm.showDatesInTable,
	      "isEditingDates": _vm.isEditingDates,
	      "selectedSubjectIds": _vm.selectedSubjectIds
	    },
	    on: {
	      "editSubject": _vm.setEditSubject,
	      "toggleEditDates": _vm.toggleEditDates,
	      "toggleSubjectSelection": _vm.toggleSubjectSelection
	    }
	  }) : _c('div', {
	    staticClass: "doTable"
	  }, [(_vm.filteredKlassCals.length < 1) ? _c('h4', {
	    staticClass: "explainer-text"
	  }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale].no_klasses_matches) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "doTable__items"
	  }, _vm._l((_vm.filteredKlassCals), function(klassCal, idx) {
	    return _c('li', {
	      key: klassCal.id,
	      staticClass: "doTable__klass"
	    }, [_c('div', {
	      staticClass: "doTable__klass__header"
	    }, [_c('div', [_vm._v(_vm._s(klassCal.name))]), _vm._v(" "), _c('div', {
	      staticClass: "doTable__klass__header__flex"
	    }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale].hours_in_school_year) + ":")]), _vm._v(" "), _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: (klassCal.vHasReductions ? {
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        } : {
	          trigger: 'manual'
	        }),
	        expression: "klassCal.vHasReductions ? { arrow: true, animateFill: false, animation: 'shift-away', zIndex: '999999992', boundary: 'window' } : { trigger: 'manual' }"
	      }],
	      staticClass: "doTable__klass__header__hours",
	      attrs: {
	        "content": 'inkl. reduktioner'
	      }
	    }, [_vm._v(_vm._s(klassCal.vTotalHours))])])]), _vm._v(" "), _c('ul', {
	      staticClass: "subjects"
	    }, _vm._l((klassCal.vSubjects), function(subject) {
	      return _c('li', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: true,
	            onShow: function () { return !!subject.vTooltip; }
	          }),
	          expression: "{\n                  arrow: true,\n                  onShow: () => !!subject.vTooltip\n                }"
	        }],
	        key: subject.id,
	        staticClass: "subjects_subject",
	        class: [{
	          'subject--has-user': subject.vHasTeachers
	        }, {
	          'subject--has-room': subject.vHasRooms
	        }, {
	          'subject--has-request': subject.vRequestedBy.length > 0
	        }, {
	          'subject--has-other-klass': subject.v_subjectOtherKlasses && subject.v_subjectOtherKlasses.length > 0
	        }],
	        style: ({
	          'background': subject.color
	        }),
	        attrs: {
	          "content": subject.vTooltip
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setEditSubject(subject, klassCal.id)
	          }
	        }
	      }, [_vm._v("\n                  " + _vm._s(subject.name) + " (" + _vm._s(_vm.showLessonsPerWeek ? subject.vLessonsPerWeek : subject.vHours) + ") "), (subject.vIsPartiallyDistributed) ? _c('span', {
	        staticClass: "do-pill do-pill--yellow subject-remaining"
	      }, [_vm._v(_vm._s(_vm.showLessonsPerWeek ? subject.vRemainingLessonsPerWeek : subject.vRemainingHours.toFixed(1)) + " mangler")]) : _vm._e()])
	    }), 0)])
	  }), 0)])]], 2)])], _vm._v(" "), (_vm.isSubjectModal) ? _c('SubjectForm', {
	    attrs: {
	      "showModal": _vm.isSubjectModal,
	      "editSubject": _vm.editSubject,
	      "poolCalendarId": _vm.editSubjectPoolCalendarId,
	      "propIsLoading": _vm.isSubjectLoading,
	      "allowDanishPreparationFactorUi": true,
	      "isShowSubjectsRequest": _vm.isShowSubjectsRequest,
	      "subjectsRequestsInHash": _vm.subjectsRequestsInHash,
	      "showActivities": _vm.showActivities
	    },
	    on: {
	      "deleteSubject": _vm.deleteSubject,
	      "close": _vm.closeModal,
	      "updateSubject": _vm.updateSubject,
	      "saveAndShowTab": _vm.saveAndShowTab
	    }
	  }) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-modal"
	    }
	  }, [(_vm.isConfirmDeletion) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$store.commit('setConfirmDeletion', false)
	      },
	      "confirm": _vm.confirmDelete
	    }
	  }, [_c('h3', {
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_vm._v(_vm._s(_vm.itemToDelete.name))])]) : _vm._e()], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-modal"
	    }
	  }, [(_vm.theEditTask) ? _c('DModal', {
	    attrs: {
	      "showClose": false
	    }
	  }, [_c('SubjectsDistributionTasksCreate', {
	    attrs: {
	      "slot": "insertComponent",
	      "editTask": _vm.theEditTask
	    },
	    on: {
	      "close": function($event) {
	        _vm.theEditTask = null
	      }
	    },
	    slot: "insertComponent"
	  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false,
	      "isPrintable": true
	    },
	    on: {
	      "close": _vm.closeTheUserToShowTasks
	    }
	  }, [_c('div', {
	    staticClass: "user-task__container",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "user-task__container__header no-print"
	  }, [_c('h2'), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": _vm.closeTheUserToShowTasks
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('UserOverviewTabs', {
	    attrs: {
	      "user": _vm.theUserToShowTasks,
	      "initialView": "tasks",
	      "initialIsShowScheduled": false
	    }
	  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.isZenExportModal) ? _c('ZenExport', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "schoolYearId": _vm.activeSchoolYear.id
	    },
	    on: {
	      "close": function($event) {
	        _vm.isZenExportModal = false
	      },
	      "exported": _vm.onZenExported
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 2062 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-dark pad-1"
	  }, [_c('div', {
	    staticClass: "page-header marg-1-bottom"
	  }, [_c('h2', [_vm._v("Ansættelsesnumre")]), _vm._v(" "), (_vm.isOrganisationsEnabled) ? _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        _vm.isOrganisationsModal = true
	      }
	    }
	  }, [_vm._v("\n           Organisationer\n         ")]) : _vm._e()]), _vm._v(" "), _c('SalarySettingsUsersOpus', {
	    attrs: {
	      "isSalaryIntegrationActive": true,
	      "users": _vm.usersWithEmployments,
	      "employments": _vm.employments,
	      "tags": _vm.tags,
	      "isShowEmploymentNumber": true,
	      "confirmRemoveTemplateOnTagClick": true,
	      "filtersStorageKey": "ansaettelsesnumreFilters",
	      "rowActionLabel": "Indtast medarbejdernummer",
	      "emitEditSsn": true
	    },
	    on: {
	      "setTheEditUser": _vm.openImport,
	      "editSsn": _vm.openImport
	    }
	  }), _vm._v(" "), (_vm.theImportUser) ? _c('EmploymentImportModal', {
	    attrs: {
	      "user": _vm.theImportUser,
	      "numberLabel": "Medarbejdernummer",
	      "maxLength": 8,
	      "padLength": 8
	    },
	    on: {
	      "close": function($event) {
	        _vm.theImportUser = null
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isOrganisationsModal) ? _c('SalaryOrganisationsModal', {
	    on: {
	      "close": function($event) {
	        _vm.isOrganisationsModal = false
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2063 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "task-overview-settings__settings"
	  }, [_c('div', {
	    staticClass: "task-overview-settings__settings-container"
	  }, [_c('h2', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v("1. Skjul antal timer tildelt på visse opgaver")]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [_c('div', {
	    staticClass: "d-explainer-box text-explainer text-explainer__error"
	  }, [_c('svg', {
	    staticClass: "tw-icon icon-help",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"
	    }
	  })]), _vm._v("\n        Aktivér denne indstilling for at skjule timepuljen for alle opgaver med mindre end et bestemt antal timer\n        (f.eks. 60 timer) for alle andre end administratorer. Selve opgaverne vil stadig være synlige for lærerne, men\n        de vil ikke kunne se det specifikke antal timer, der er allokeret til dem.\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-label-and-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setIsActive.apply(null, arguments)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label color-dark"
	  }, [_vm._v("Skjul timepuljer")]), _vm._v(" "), _c('div', {
	    staticClass: "do-switch",
	    class: {
	      'do-switch--active': _vm.isActive
	    }
	  })]), _vm._v(" "), (_vm.isActive) ? _c('div', [_c('div', {
	    staticClass: "prep-factor-input marg-1-bottom"
	  }, [_c('p', {
	    staticClass: "italic"
	  }, [_vm._v("Indtast det antal timer, hvor timepuljen på opgaver skal skjules")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.thresholdToHideTaskHours),
	      expression: "thresholdToHideTaskHours"
	    }],
	    ref: "the_input_field",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.thresholdToHideTaskHours)
	    },
	    on: {
	      "blur": _vm.onSave,
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onSave.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.thresholdToHideTaskHours = $event.target.value
	      }
	    }
	  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "task-overview-settings__settings-container"
	  }, [_c('h2', [_vm._v("2. Visning af fordeling af puljer")]), _vm._v(" "), _c('h4', {
	    staticClass: "italic marg-1-bottom"
	  }, [_vm._v("Fordelingen er med til at give medarbejdere et overblik over deres arbejdstid og\n      puljer herunder som f.eks. undervisning.\n      Visse felter vises kun, hvis brugeren har fået tidelt timer timer i puljen f.eks. SFO.")]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group marg-1-bottom"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Titel på lokalpulje")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localPoolTitleDraft),
	      expression: "localPoolTitleDraft"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('vue2.task_overview.pool')
	    },
	    domProps: {
	      "value": (_vm.localPoolTitleDraft)
	    },
	    on: {
	      "blur": _vm.saveLocalPoolTitle,
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.saveLocalPoolTitle.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.localPoolTitleDraft = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-table__container"
	  }, [_c('table', {
	    staticClass: "d-table marg-1-bottom d-table__overview"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('div', {
	    staticClass: "td-toggler",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSettings('work_hours')
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.getIsOn('work_hours')
	    }
	  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Arbejdstid")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("100%")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n            1642.8\n          ")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("1586")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number",
	    staticStyle: {
	      "background-color": "rgba(62, 207, 142, 0.57)"
	    }
	  }, [_vm._v("56.8")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    staticClass: "td-toggler",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSettings('teaching')
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.getIsOn('teaching')
	    }
	  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Undervisning")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("49%")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("800")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("693.88")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number",
	    staticStyle: {
	      "background-color": "rgb(62, 207, 142)"
	    }
	  }, [_vm._v("106.13")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    staticClass: "td-toggler",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSettings('tasks')
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.getIsOn('tasks')
	    }
	  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Øvrige Opgaver")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("24%")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("400")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("398")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSettings('preparation')
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.getIsOn('preparation')
	    }
	  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Forberedelse")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("24%")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("400")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("400")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSettings('pool')
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.getIsOn('pool')
	    }
	  })], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.localPoolTitle))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("5%")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("80")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number",
	    staticStyle: {
	      "background-color": "rgba(62, 207, 142, 0.8)"
	    }
	  }, [_vm._v("80")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSettings('substitute_hours')
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.getIsOn('substitute_hours')
	    }
	  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Vikartimer")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("1%")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("20")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number",
	    staticStyle: {
	      "background-color": "rgba(62, 207, 142, 0.17)"
	    }
	  }, [_vm._v("17")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSettings('teaching_and_sub')
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.getIsOn('teaching_and_sub')
	    }
	  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Undervisning + Vikartimer (UV-timer)")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("820")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("696.88")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number",
	    staticStyle: {
	      "background-color": "rgb(62, 207, 142)"
	    }
	  }, [_vm._v("123.12")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSettings('club')
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.getIsOn('club')
	    }
	  })], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("3%")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("57.2")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.taskCategories), function(taskCategory) {
	    return _c('tr', {
	      key: taskCategory.id
	    }, [_c('td', [_c('div', {
	      staticClass: "td-toggler",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.toggleOwnPool(taskCategory.name)
	        }
	      }
	    }, [_c('AppToggle', {
	      attrs: {
	        "allowChanges": false,
	        "propOn": _vm.getIsOwnPoolOn(taskCategory.name)
	      }
	    })], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(taskCategory.name))])])
	  })], 2)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Vis")]), _vm._v(" "), _c('th', [_c('h4', [_vm._v("Standardpuljer")])]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("Tildelt")]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("Skemalagt")]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("Forskel")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('span', {
	    staticClass: "d-badge d-badge--warning"
	  }, [_vm._v("SFO")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_c('b', [_vm._v("Vis optælling fra egne kategorier")])])])
	}]}

/***/ }),
/* 2064 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "subject-list"
	  }, [_c('div', {
	    staticClass: "flex space-between"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.createklass.subjects_for')) + "\n      " + _vm._s(_vm.activeKlassStep)), (_vm.locale !== 'en') ? _c('span', [_vm._v(".")]) : _c('span', [_vm._v(_vm._s(_vm.classesNumberized))]), _vm._v("\n      " + _vm._s(_vm.$t('vue2.createklass.grade')) + "\n    ")])]), _vm._v(" "), (_vm.isLoading) ? _c('div', [_c('Spinner', {
	    attrs: {
	      "color": "blue"
	    }
	  })], 1) : _c('ul', _vm._l((_vm.activeSubjects), function(subject) {
	    return _c('li', {
	      staticClass: "subject-list__subject",
	      style: ({
	        backgroundColor: subject.color
	      })
	    }, [_c('div', [_vm._v(_vm._s(subject.subject))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("removeDecimal")(subject.hours)) + _vm._s(_vm.$t('vue2.createklass.hoursPrYear')))])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2065 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true
	    },
	    on: {
	      "close": _vm.close
	    }
	  }, [_c('template', {
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "add-lesson__header"
	  }, [_c('h2', [_vm._v("Opret klasse")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "add-lesson__form"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v("Klassenavn")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.klassebetegnelse),
	      expression: "klassebetegnelse"
	    }],
	    ref: "inputTitle",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.klassebetegnelse)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.submit.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.klassebetegnelse = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__submit"
	  }, [_c('div', {
	    staticClass: "input-group__submit__left"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "input-group__submit__right"
	  }, [_c('button', {
	    staticClass: "marg-1-right bg-white",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isFormValid) ? _c('div', {
	    staticClass: "hint--top-left",
	    attrs: {
	      "aria-label": "Udfyld formularen"
	    }
	  }, [_c('button', {
	    staticClass: "submit-button submit-button--disabled"
	  }, [_vm._v("Opret")])]) : _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Opret")])])])])], 2)
	},staticRenderFns: []}

/***/ }),
/* 2066 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "team-presence-table do-scroller__container"
	  }, [_c('div', {
	    staticClass: "do-scroller do-scroller-max-height"
	  }, [_c('table', {
	    staticClass: "team-presence-table__table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "team-presence-table__col-name"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['employee']))]), _vm._v(" "), _c('th', {
	    staticClass: "team-presence-table__col-total"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['week_total']))]), _vm._v(" "), _vm._l((_vm.weekDays), function(day) {
	    return _c('th', {
	      key: day.format('YYYY-MM-DD'),
	      staticClass: "team-presence-table__col-day"
	    }, [_c('span', {
	      staticClass: "team-presence-table__day-name"
	    }, [_vm._v(_vm._s(_vm.formatDayName(day)))]), _vm._v(" "), _c('span', {
	      staticClass: "team-presence-table__day-date"
	    }, [_vm._v(_vm._s(_vm.formatDayDate(day)))])])
	  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableRows), function(row) {
	    return _c('tr', {
	      key: row.calendarId,
	      staticClass: "team-presence-table__row"
	    }, [_c('td', {
	      staticClass: "team-presence-table__col-name"
	    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
	      staticClass: "team-presence-table__col-total"
	    }, [_vm._v(_vm._s(row.weekTotal))]), _vm._v(" "), _vm._l((_vm.weekDays), function(day) {
	      return _c('td', {
	        key: row.calendarId + '-' + day.format('YYYY-MM-DD'),
	        staticClass: "team-presence-table__col-day"
	      }, _vm._l((row.slotsByDay[day.format('YYYY-MM-DD')]), function(slot, idx) {
	        return _c('div', {
	          key: row.calendarId + '-' + day.format('YYYY-MM-DD') + '-' + idx,
	          staticClass: "team-presence-table__slot"
	        }, [_vm._v("\n            " + _vm._s(slot) + "\n          ")])
	      }), 0)
	    })], 2)
	  }), 0)])])])
	},staticRenderFns: []}

/***/ }),
/* 2067 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "subs-delete",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	      }
	    }
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "subs-delete-subs text-dark"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "subs-delete-subs__loader marg-2-top"
	  }, [_c('h3', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.checking_for_substitutes')))]), _vm._v(" "), _c('Loader', {
	    staticStyle: {
	      "margin-top": "1rem"
	    },
	    attrs: {
	      "isSmall": true
	    }
	  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.eventsSortedInDays.length < 1) ? _c('div', {
	    staticClass: "input-group-subs"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.lessons_with_substitutes')))]), _vm._v(" "), _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.no_subs_on_lessons')))])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.eventsSortedInDays.length > 0) ? _c('div', {
	    staticClass: "marg-1-top"
	  }, [_c('div', {
	    staticClass: "subs-days-container__header"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.eventsWithSubstitutes.length) + "\n        " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.lessons_with_substitutes')))]), _vm._v(" "), _c('p', {
	    staticClass: "select-all-item",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.eventsToRemovedSubs.length === 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.select_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.unselect_all')))])])]), _vm._v(" "), _c('ul', {
	    staticClass: "subs-days-container rounded shadow"
	  }, _vm._l((_vm.eventsSortedInDays), function(day) {
	    return _c('li', [_c('div', {
	      staticClass: "day__header"
	    }, [_c('label', [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.$filters.ddd(day.date))) + ", " + _vm._s(_vm.$filters.LL(day.date)))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.remove_sub')))])]), _vm._v(" "), _c('ul', {
	      staticClass: "sub-lessons"
	    }, _vm._l((day.events), function(event) {
	      return _c('li', {
	        key: event.event_id,
	        staticClass: "d-lesson",
	        class: {
	          'd-lesson--active': _vm.isInEventsToRemovedSubs(event)
	        },
	        style: ({
	          'border-color': event.color
	        }),
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            $event.preventDefault();
	            return _vm.toggleEvent(event)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "d-lesson__title"
	      }, [_c('span', {
	        staticClass: "d-lesson__time"
	      }, [_vm._v(_vm._s(_vm.$filters.LT(event.start)) + " - " + _vm._s(_vm.$filters.LT(event.end)))]), _vm._v("\n              " + _vm._s(event.title) + ", "), _vm._l((_vm.getClasses(event)), function(klass) {
	        return _c('span', [_vm._v(" " + _vm._s(klass.name))])
	      })], 2), _vm._v(" "), _c('div', {
	        staticClass: "sub-selector"
	      }, [_vm._l((_vm.getSubstitute(event)), function(sub) {
	        return _c('p', {
	          staticClass: "sub-name"
	        }, [_c('b', [_vm._v(_vm._s(sub.name))])])
	      }), _vm._v(" "), _c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': _vm.isInEventsToRemovedSubs(event)
	        }
	      })], 2)])
	    }), 0)])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.eventsToRemovedSubs.length !== 0 || _vm.eventsWithSubstitutes.length !== 0) ? _c('div', {
	    staticClass: "subs-delete__footer"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.eventsToRemovedSubs.length) + " " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.of')) + " " + _vm._s(_vm.eventsWithSubstitutes.length) + "\n      " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.lessons_that_will_have_subs_removed')))])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2068 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "scheduled-events text-dark"
	  }, [_c('h2', {
	    staticClass: "marg-5-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].scheduled_events) + " \"" + _vm._s(_vm.subject.name) + "\"")]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }) : _c('div', [(_vm.sortedEvents.length < 1) ? _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].no_scheduled_events))]) : _c('table', {
	    staticClass: "scheduled-events__table"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].date))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].weekday))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].time))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].calendars))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedEvents), function(event) {
	    return _c('tr', {
	      key: event.event_id
	    }, [_c('td', [_c('span', {
	      staticClass: "subject-event",
	      style: ({
	        'backgroundColor': _vm.subject.color
	      })
	    }, [_vm._v(_vm._s(event.v_date))])]), _vm._v(" "), _c('td', {
	      staticClass: "text-capitalize"
	    }, [_vm._v(_vm._s(event.v_weekday))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(event.v_time))]), _vm._v(" "), _c('td', {
	      staticClass: "text-greyed"
	    }, [_vm._v(_vm._s(event.v_calendars))])])
	  }), 0)]), _vm._v(" "), (_vm.sortedEvents.length > 0) ? _c('p', {
	    staticClass: "scheduled-events__count"
	  }, [_vm._v("\n      " + _vm._s(_vm.sortedEvents.length) + " " + _vm._s(_vm.i18n[_vm.locale].events_total) + "\n    ")]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2069 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-button-and-date"
	  }, [(_vm.isDatepickerOpen && _vm.selectedDate) ? _c('button', {
	    staticClass: "do-bttn do-bttn__filter do-bttn--danger-perm",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('dateChanged', null)
	      }
	    }
	  }, [_vm._v("\n    Luk for fagønsker\n  ")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn__filter",
	    on: {
	      "click": function($event) {
	        _vm.isDatepickerOpen = !_vm.isDatepickerOpen
	      }
	    }
	  }, [(!_vm.selectedDate) ? [_vm._v("\n      " + _vm._s(_vm.isDatepickerOpen ? 'Slutdato for fagønsker' : 'Åbn for fagønsker') + "\n    ")] : _vm._e(), _vm._v(" "), (_vm.selectedDate) ? [_vm._v("\n      Slutdato for fagønsker\n      "), _c('div', {
	    staticClass: "do-filters__divider"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "do-badge"
	  }, [_vm._v(_vm._s(_vm.selectedDateFormatted))])] : _vm._e()], 2), _vm._v(" "), (_vm.isDatepickerOpen) ? _c('div', {
	    staticClass: "do-button-and-date__datepicker"
	  }, [_c('DateSelector', {
	    staticStyle: {
	      "width": "210px"
	    },
	    attrs: {
	      "isOpen": true,
	      "isShowInput": false,
	      "date": _vm.selectedDate ? _vm.selectedDate : new Date()
	    },
	    on: {
	      "changed": function($event) {
	        return _vm.setDate($event)
	      },
	      "close": function($event) {
	        _vm.isDatepickerOpen = false
	      }
	    }
	  })], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2070 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "112313123"
	    },
	    attrs: {
	      "showClose": false,
	      "isBgOverlay": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal__opus",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Data fra KMD OPUS for " + _vm._s(_vm.user.v_user_name))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__header__right"
	  }, [_c('div', {
	    staticClass: "icon__bg-circle no-print",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }) : [_c('h3', [_vm._v("\n          For perioden " + _vm._s(_vm.titleOfPeriod) + "\n        ")]), _vm._v(" "), (_vm.oneTimePayments.length === 0) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen data for perioden")]) : _vm._e(), _vm._v(" "), (_vm.oneTimePayments.length > 0) ? _c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', [_c('tr', _vm._l((_vm.oneTimePayments[0]), function(value, key) {
	    return _c('th', {
	      key: key
	    }, [_vm._v("\n              " + _vm._s(key.replace('_', ' ')) + "\n            ")])
	  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.oneTimePayments), function(payment) {
	    return _c('tr', {
	      key: payment.id
	    }, _vm._l((payment), function(value, key) {
	      return _c('td', {
	        key: key
	      }, [_vm._v("\n              " + _vm._s(value || '-') + "\n            ")])
	    }), 0)
	  }), 0)]) : _vm._e()]], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 2071 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true
	    },
	    on: {
	      "close": _vm.onClose
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('div', [_c('h2', [_vm._v("Opret ansættelse")]), _vm._v(" "), _c('p', {
	    staticClass: "d-modal__subtitle"
	  }, [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.onClose
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), (_vm.step === 1) ? [_c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n          Ansættelsen hentes fra lønsystemet. Indtast det " + _vm._s(_vm.numberLabel.toLowerCase()) + ",\n          som ansættelsen har i lønsystemet, så importeres stilling, periode og\n          beskæftigelsesgrad automatisk.\n        ")]), _vm._v(" "), (_vm.needsCpr) ? _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("CPR-nummer")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cpr),
	      expression: "cpr"
	    }],
	    ref: "cpr_input",
	    staticClass: "d-input",
	    class: {
	      'is-invalid': !!_vm.cprError
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": "ddmmåå-nnnn",
	      "inputmode": "numeric",
	      "maxlength": "11"
	    },
	    domProps: {
	      "value": (_vm.cpr)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.cpr = $event.target.value
	      }, function($event) {
	        _vm.errorMessage = ''
	      }],
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onFetch.apply(null, arguments)
	      }
	    }
	  }), _vm._v(" "), (_vm.cprError) ? _c('p', {
	    staticClass: "text-explainer text-error marg-05-top"
	  }, [_vm._v(_vm._s(_vm.cprError))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("\n            " + _vm._s(_vm.numberLabel) + "\n            "), (_vm.maxLength) ? _c('span', {
	    staticStyle: {
	      "font-size": "7px"
	    }
	  }, [_vm._v("(max " + _vm._s(_vm.maxLength) + " cifre)")]) : _vm._e()]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.code),
	      expression: "code"
	    }],
	    ref: "number_input",
	    staticClass: "d-input",
	    class: {
	      'is-invalid': !!_vm.codeError || !!_vm.errorMessage
	    },
	    attrs: {
	      "type": "text",
	      "maxlength": _vm.maxLength || 20
	    },
	    domProps: {
	      "value": (_vm.code)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.code = $event.target.value
	      }, _vm.onCodeInput],
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onFetch.apply(null, arguments)
	      }
	    }
	  }), _vm._v(" "), (_vm.codeError) ? _c('p', {
	    staticClass: "text-explainer text-error marg-05-top"
	  }, [_vm._v(_vm._s(_vm.codeError))]) : (_vm.errorMessage) ? _c('p', {
	    staticClass: "text-explainer text-error marg-05-top"
	  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div'), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.onClose
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': !_vm.isValid || _vm.isSubmitting,
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.onFetch
	    }
	  }, [_vm._v("\n            Hent ansættelse\n          ")])])])] : [_c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "import-success"
	  }, [_c('p', {
	    staticClass: "import-success__title"
	  }, [_vm._v("Ansættelsen er hentet fra lønsystemet")]), _vm._v(" "), _vm._l((_vm.importedSchoolEmployments), function(employment) {
	    return _c('p', {
	      key: employment.id,
	      staticClass: "import-success__employment"
	    }, [_c('strong', [_vm._v(_vm._s(employment.employment_number) + " - " + _vm._s(employment.source_title || employment.title))]), _c('br'), _vm._v("\n            " + _vm._s(_vm.formatDate(employment.start_date)) + " – " + _vm._s(_vm.formatDate(employment.end_date)) + "\n            "), (employment.employment_percent) ? [_vm._v(" · " + _vm._s(_vm.formatPercent(employment.employment_percent)) + "%")] : _vm._e(), _vm._v(" "), (employment.organisation) ? [_vm._v(" · " + _vm._s(employment.organisation))] : _vm._e()], 2)
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Stillingskategori")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.employmentTemplateId),
	      expression: "employmentTemplateId"
	    }],
	    staticClass: "do-select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.employmentTemplateId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": ""
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Vælg stillingskategori")]), _vm._v(" "), _vm._l((_vm.employmentTemplates), function(template) {
	    return _c('option', {
	      key: template.id,
	      domProps: {
	        "value": template.id
	      }
	    }, [_vm._v("\n              " + _vm._s(template.title) + "\n            ")])
	  })], 2), _vm._v(" "), (_vm.errorMessage) ? _c('p', {
	    staticClass: "text-explainer text-error marg-05-top"
	  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div'), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.onSkipTemplate
	    }
	  }, [_vm._v("\n            Spring over\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': !_vm.employmentTemplateId || _vm.isSubmitting,
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.onAssignTemplate
	    }
	  }, [_vm._v("\n            Gem stillingskategori\n          ")])])])]], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2072 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-copy-cals text-dark"
	  }, [_c('div', {
	    staticClass: "d-acc",
	    class: {
	      'd-acc--open': _vm.isAccOpen
	    }
	  }, [_c('div', {
	    staticClass: "d-acc__header",
	    on: {
	      "click": _vm.toggleIsAccOpen
	    }
	  }, [_c('div', {
	    staticClass: "d-acc__header__left"
	  }, [_c('div', {
	    staticClass: "d-toggle-arrow",
	    class: {
	      'd-toggle-arrow--open': _vm.isAccOpen
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.title) + " (" + _vm._s(_vm.calendarsExclArchived.length) + ")")])])]), _vm._v(" "), (_vm.isAccOpen) ? _c('ul', {
	    staticClass: "d-copy-cals__list"
	  }, [_vm._l((_vm.calendarsExclArchived), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "d-copy-cals__cal"
	    }, [_c('div', {
	      staticClass: "d-copy-cals__cal__left"
	    }, [_vm._v("\n          " + _vm._s(calendar.name) + "\n        ")]), _vm._v(" "), _c('div', {
	      staticClass: "d-copy-cals__cal__right"
	    }, [_c('button', {
	      staticClass: "bttn bttn-simple bttn--small",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setEditCal(calendar.id)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-pencil"
	    })]), _vm._v(" "), (_vm.calType === 'room' || _vm.calType === 'merge') ? _c('button', {
	      staticClass: "bttn bttn-simple bttn--small",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.archiveCal(calendar.id)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.calendars.archive')) + "\n          ")]) : _c('button', {
	      staticClass: "bttn bttn-simple bttn--small bttn--warning",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setDeleteCal(calendar.id)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })])])])
	  }), _vm._v(" "), (_vm.archivedCalendars.length > 0) ? _c('li', {
	    staticClass: "archived-cals-toggler",
	    on: {
	      "click": function($event) {
	        _vm.isArchivedAccOpen = !_vm.isArchivedAccOpen
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-toggle-arrow",
	    class: {
	      'd-toggle-arrow--open': _vm.isArchivedAccOpen
	    }
	  }), _vm._v(" "), _c('p', [(!_vm.isArchivedAccOpen) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.calendars.show')) + " ")]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.calendars.hide')))]), _vm._v(" " + _vm._s(_vm.$t('vue2.calendars.archived')) + " (" + _vm._s(_vm.archivedCalendars.length) + ")")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.archivedCalendars), function(archivedCalendar) {
	    return (_vm.isArchivedAccOpen) ? _c('li', {
	      key: archivedCalendar.id,
	      staticClass: "archived-cal"
	    }, [_vm._v("\n        " + _vm._s(archivedCalendar.name) + "\n        "), (_vm.calType === 'room' || _vm.calType === 'merge') ? _c('button', {
	      staticClass: "bttn bttn-simple bttn--small",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.deArchiveCal(archivedCalendar.id)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('vue2.calendars.unarchive')) + "\n        ")]) : _vm._e()]) : _vm._e()
	  })], 2) : _vm._e()]), _vm._v(" "), (_vm.theActiveCalId) ? _c('DModal', {
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": function($event) {
	        _vm.theActiveCalId = null
	      }
	    }
	  }, [_c('template', {
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.editCalendarEditName.edit_name')))]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.closeUpdateCalName
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.calendars.write_name')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.theUpdateCalName),
	      expression: "theUpdateCalName",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    ref: "edit_name_input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.theUpdateCalName)
	    },
	    on: {
	      "change": function($event) {
	        _vm.theUpdateCalName = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "marg-5-right",
	    on: {
	      "click": _vm.closeUpdateCalName
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.updateCalName
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.update')))])])])])], 2) : _vm._e(), _vm._v(" "), (_vm.theDeleteCalId) ? _c('DModal', {
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": function($event) {
	        _vm.theDeleteCalId = null
	      }
	    }
	  }, [_c('template', {
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.calendars.do_you_want_to_delete')) + " \"" + _vm._s(_vm.deleteCalName) + "\"?")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.closeDeleteCalModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.editCalendarDelete.write')) + " \"" + _vm._s(_vm.deleteCalName) + "\"\n            " + _vm._s(_vm.$t('vue2.editCalendarDelete.if_you_want_to_delete')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.theDeleteCalName),
	      expression: "theDeleteCalName"
	    }],
	    ref: "delete_name_input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.theDeleteCalName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.theDeleteCalName = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('h4', {
	    staticClass: "text-danger marg-20-top"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarDelete.all_data_will_be_deleted')))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "marg-5-right",
	    on: {
	      "click": _vm.closeDeleteCalModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isDeleteCalValidated) ? _c('button', {
	    staticClass: "submit-button submit-button--disabled"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.delete')) + "\n          ")]) : _c('button', {
	    staticClass: "submit-button submit-button--danger",
	    on: {
	      "click": _vm.deleteCal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.delete')) + "\n          ")])])])])], 2) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2073 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-copy-cals text-dark"
	  }, [_c('div', {
	    staticClass: "d-acc",
	    class: {
	      'd-acc--open': _vm.isAccOpen
	    }
	  }, [_c('div', {
	    staticClass: "d-acc__header",
	    on: {
	      "click": _vm.toggleIsAccOpen
	    }
	  }, [_c('div', {
	    staticClass: "d-acc__header__left"
	  }, [_c('div', {
	    staticClass: "d-toggle-arrow",
	    class: {
	      'd-toggle-arrow--open': _vm.isAccOpen
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.title) + " (" + _vm._s(_vm.calendarsExclArchived.length) + ")")])])]), _vm._v(" "), (_vm.isAccOpen) ? _c('ul', {
	    staticClass: "d-copy-cals__list"
	  }, [_c('li', {
	    staticClass: "d-copy-cals__list__header"
	  }, [_c('p', {
	    staticClass: "d-acc__header__select-all select-all-item",
	    on: {
	      "click": _vm.toggleAllKlasses
	    }
	  }, [(_vm.selectedCalIds.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.select_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-copy-cals__list__header__right"
	  }, [_c('p', [_vm._v(_vm._s(_vm.selectedCalIds.length) + " " + _vm._s(_vm.$t('vue2.calendars.selected_of')) + " " + _vm._s(_vm.calendarsExclArchived.length))]), _vm._v(" "), (_vm.selectedCalIds.length < 1) ? _c('button', {
	    staticClass: "bttn--disabled hint--bottom-left",
	    attrs: {
	      "aria-label": this.$t('vue2.calendars.select_calendars_to_copy')
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.calendars.delete')) + " " + _vm._s(_vm.fromDateAndToDate) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.selectedCalIds.length > 0 && !_vm.isDeleting) ? _c('button', {
	    staticClass: "bttn bttn-danger hint--bottom-left",
	    attrs: {
	      "aria-label": "Both dates are included"
	    },
	    on: {
	      "click": _vm.deleteDays
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v("\n            " + _vm._s(_vm.$t('vue2.calendars.delete')) + " " + _vm._s(_vm.fromDateAndToDate) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.selectedCalIds.length > 0 && _vm.isDeleting) ? _c('button', {
	    staticClass: "bttn--disabled bttn-danger bttn--with-spinner"
	  }, [_c('Loader', {
	    staticStyle: {
	      "margin": "0 7px 0 0"
	    },
	    attrs: {
	      "is-extra-small": true
	    }
	  }), _vm._v("\n            " + _vm._s(_vm.$t('vue2.calendars.delete')) + " " + _vm._s(_vm.fromDateAndToDate) + "\n          ")], 1) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.calendarsExclArchived), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "d-copy-cals__cal",
	      class: {
	        'd-copy-cals__cal--selected': _vm.getIsInSelectedCalIds(calendar.id)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toogleCal(calendar.id)
	        }
	      }
	    }, [_vm._m(0, true), _vm._v("\n        " + _vm._s(calendar.name) + "\n      ")])
	  })], 2) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-copy-cals__cal__selector"
	  }, [_c('div', {
	    staticClass: "checkbox"
	  })])
	}]}

/***/ }),
/* 2074 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "satc-wrapper",
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.$emit('skip')
	      }
	    }
	  }, [_c('div', {
	    ref: "satc",
	    staticClass: "satc",
	    attrs: {
	      "role": "dialog",
	      "aria-modal": "true",
	      "aria-label": _vm.i18n.title,
	      "tabindex": "-1"
	    }
	  }, [_c('div', {
	    staticClass: "satc__header",
	    style: ({
	      backgroundColor: _vm.headerColor
	    })
	  }, [_c('div', {
	    staticClass: "satc__close icon__bg-circle",
	    attrs: {
	      "role": "button",
	      "tabindex": "0",
	      "aria-label": _vm.i18n.skip
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.$emit('skip')
	      },
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.stopPropagation();
	        return _vm.$emit('skip')
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
	        $event.preventDefault();
	        $event.stopPropagation();
	        return _vm.$emit('skip')
	      }]
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.introText))]), _vm._v(" "), (_vm.headerSubtitle) ? _c('div', {
	    staticClass: "satc__header__subtitle"
	  }, [_vm._v(_vm._s(_vm.headerSubtitle))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "satc__body"
	  }, [_c('div', {
	    staticClass: "satc__date"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n.from_date))]), _vm._v(" "), _c('DateSelector', {
	    attrs: {
	      "date": _vm.fromDate,
	      "width100": true
	    },
	    on: {
	      "changed": _vm.setFromDate
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "satc__date"
	  }, [_c('OnwardEndDate', {
	    attrs: {
	      "enddate": _vm.enddate,
	      "minDate": _vm.fromDate,
	      "label": _vm.i18n.set_end_date
	    },
	    on: {
	      "update:enddate": function($event) {
	        _vm.enddate = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "satc__actions"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.$emit('skip')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n.skip))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.onConfirm.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n.confirm))])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2075 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "zen-change-action"
	  }, [(_vm.isDone) ? _c('span', {
	    staticClass: "zen-change-action__done"
	  }, [_c('span', {
	    staticClass: "icon-checkmark"
	  }), _vm._v("\n    " + _vm._s(_vm.doneLabel) + "\n  ")]) : (_vm.isLoading) ? _c('button', {
	    staticClass: "zen-bttn",
	    attrs: {
	      "disabled": ""
	    }
	  }, [_c('span', {
	    staticClass: "zen-spinner"
	  })]) : (_vm.isConfirming) ? _c('div', {
	    staticClass: "zen-change-action__confirm"
	  }, [_c('span', {
	    staticClass: "zen-change-action__confirm-text"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.confirm')))]), _vm._v(" "), _c('button', {
	    staticClass: "zen-bttn zen-bttn--danger",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('confirm')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.zen_import.yes')) + "\n    ")]), _vm._v(" "), _c('button', {
	    staticClass: "zen-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('setState', 'idle')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.zen_import.cancel')) + "\n    ")])]) : _c('button', {
	    staticClass: "zen-bttn",
	    class: {
	      'zen-bttn--danger-outline': _vm.actionType === 'delete'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('setState', 'confirming')
	      }
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.actionLabel) + "\n  ")])])
	},staticRenderFns: []}

/***/ }),
/* 2076 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "users-hours text-dark"
	  }, [_c('div', {
	    staticClass: "users-hours__header"
	  }, [_c('h2', [_vm._v("Arbeidsplan for " + _vm._s(_vm.numberOfWorkDaysInPeriod) + " arbejdsdage")]), _vm._v(" "), _c('div', {
	    staticClass: "user-tasks__header__right"
	  }, [(!_vm.isDatesPristine) ? _c('p', {
	    staticClass: "d-link",
	    on: {
	      "click": _vm.resetDates
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), (_vm.activeSchoolYear) ? _c('DatePickerRangeShortcuts', {
	    staticClass: "marg-1-right",
	    attrs: {
	      "startDate": _vm.activeSchoolYear.employee_time_start,
	      "endDate": _vm.activeSchoolYear.employee_time_end,
	      "selectedStartDate": _vm.startDate,
	      "selectedEndDate": _vm.endDate
	    },
	    on: {
	      "shortcutSelected": _vm.setDatesFromRange
	    }
	  }) : _vm._e(), _vm._v(" "), _c('DatePickerRange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "marg-1-left bttn",
	    class: {
	      'bttn--loading': _vm.isLoadingUpdatedNumbers
	    },
	    on: {
	      "click": _vm.updateUserHours
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.assign_users_hours.update')) + "\n      ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "user-table-container"
	  }, [(_vm.isLoadingUpdatedNumbers) ? _c('div', {
	    staticClass: "user-table-container__loader",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('Loader', {
	    attrs: {
	      "is-small": true
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('table', {
	    staticClass: "user-table"
	  }, [_c('thead', [_c('tr', [_c('thUser', {
	    attrs: {
	      "rowspan": "3",
	      "sort-prop": "name",
	      "title": _vm.$t('vue2.assign_users_hours.name'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('th', {
	    staticClass: "working-hours",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.work_hours')))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('tr', [_c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_total_hours_assigned_in_period",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_total_hours_actual",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_total_hours_diff",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "with-kids-color",
	    attrs: {
	      "sort-prop": "v_with_kids_assigned_in_period",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "with-kids-color",
	    attrs: {
	      "sort-prop": "v_with_kids_actual",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "with-kids-color",
	    attrs: {
	      "sort-prop": "v_with_kids_diff",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "without-kids-color",
	    attrs: {
	      "sort-prop": "v_without_kids_assigned_in_period",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "without-kids-color",
	    attrs: {
	      "sort-prop": "v_without_kids_actual",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "without-kids-color",
	    attrs: {
	      "sort-prop": "v_without_kids_diff",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_with_and_without_kids_assigned_in_period",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_with_and_without_kids_actual",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_with_and_without_kids_diff",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  })], 1)]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedUsers), function(user) {
	    return _c('tr', {
	      key: user.id,
	      staticClass: "tr-user"
	    }, [_c('th', {
	      staticClass: "tr-user__name"
	    }, [_c('div', {
	      staticClass: "tr-user__name__inner"
	    }, [_c('p', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('div', {
	      staticClass: "tr-user__name__bttn icon__bg-circle hint--right",
	      attrs: {
	        "aria-label": "Årsnormsoversigt"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheActiveUserInAssignHours(user)
	        }
	      }
	    }, [_c('svg', {
	      staticClass: "icon-chart tw-icon tw-icon--small",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24"
	      }
	    }, [_c('path', {
	      staticClass: "primary",
	      attrs: {
	        "d": "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm11 4a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z"
	      }
	    }), _vm._v(" "), _c('path', {
	      staticClass: "secondary",
	      attrs: {
	        "d": "M8 11a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm4-2a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z"
	      }
	    })])])])]), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !_vm.isDatesPristine; }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
	      }],
	      staticClass: "number td-presence",
	      class: {
	        'is-number--calculated': !_vm.isDatesPristine
	      },
	      attrs: {
	        "content": _vm.createTooltip(user.v_assigned_total_hours)
	      }
	    }, [(!_vm.isDatesPristine) ? _c('span', {
	      staticClass: "icon-clock"
	    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_total_hours_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
	      staticClass: "number td-presence",
	      attrs: {
	        "aria-label": user.v_total_hours_actual
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "number td-presence number__scale-indicator",
	      style: (_vm.scaleIndicator(user.v_total_hours_diff)),
	      attrs: {
	        "aria-label": user.v_total_hours_diff
	      }
	    }), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !_vm.isDatesPristine; }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
	      }],
	      staticClass: "number with-kids-color",
	      class: {
	        'is-number--calculated': !_vm.isDatesPristine
	      },
	      attrs: {
	        "content": _vm.createTooltip(user.v_total_with_kids)
	      }
	    }, [(!_vm.isDatesPristine) ? _c('span', {
	      staticClass: "icon-clock"
	    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_with_kids_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
	      staticClass: "number with-kids-color",
	      attrs: {
	        "aria-label": user.v_with_kids_actual
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "number with-kids-color number__scale-indicator",
	      style: (_vm.scaleIndicator(user.v_with_kids_diff)),
	      attrs: {
	        "aria-label": user.v_with_kids_diff
	      }
	    }), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !_vm.isDatesPristine; }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
	      }],
	      staticClass: "number without-kids-color",
	      class: {
	        'is-number--calculated': !_vm.isDatesPristine
	      },
	      attrs: {
	        "content": _vm.createTooltip(user.v_total_without_kids)
	      }
	    }, [(!_vm.isDatesPristine) ? _c('span', {
	      staticClass: "icon-clock"
	    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_without_kids_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
	      staticClass: "number without-kids-color",
	      attrs: {
	        "aria-label": user.v_without_kids_actual
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "number without-kids-color number__scale-indicator",
	      style: (_vm.scaleIndicator(user.v_without_kids_diff)),
	      attrs: {
	        "aria-label": user.v_without_kids_diff
	      }
	    }), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !_vm.isDatesPristine; }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
	      }],
	      staticClass: "number td-presence",
	      class: {
	        'is-number--calculated': !_vm.isDatesPristine
	      },
	      attrs: {
	        "content": _vm.createTooltip(user.v_assigned_total_hours)
	      }
	    }, [(!_vm.isDatesPristine) ? _c('span', {
	      staticClass: "icon-clock"
	    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_total_hours_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
	      staticClass: "number td-presence",
	      attrs: {
	        "aria-label": user.v_with_and_without_kids_actual
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "number td-presence number__scale-indicator",
	      style: (_vm.scaleIndicator(user.v_with_and_without_kids_diff)),
	      attrs: {
	        "aria-label": user.v_with_and_without_kids_diff
	      }
	    })])
	  }), 0)])]), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": _vm.closeTheUserToShowTasks
	    }
	  }, [_c('div', {
	    staticClass: "user-task__container",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "user-task__container__header"
	  }, [_c('h2'), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": _vm.closeTheUserToShowTasks
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('UserTasks', {
	    attrs: {
	      "initialStartDate": _vm.startDate,
	      "initialEndDate": _vm.endDate,
	      "user_id": _vm.theUserToShowTasks.id,
	      "user_calendar_id": _vm.theUserToShowTasks.user_calendar_id,
	      "user_name": _vm.theUserToShowTasks.name,
	      "isShowPrintButton": false,
	      "isCanSeeOtherUsers": false
	    }
	  }) : _vm._e()], 1)]) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticClass: "with-kids-color",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('div', [_vm._v("Med børn")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticClass: "without-kids-color",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('div', [_vm._v("Uden børn")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticClass: "working-hours",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('div', [_vm._v("Med + uden børn")])])
	}]}

/***/ }),
/* 2077 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tasks-layout text-dark"
	  }, [_c('div', {
	    staticClass: "tasks-header"
	  }, [_c('div', {
	    staticClass: "tasks-header__left"
	  }, [_c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['task_names'],
	      "tags": _vm.taskNameLabels,
	      "selectedTags": _vm.selectedFilterTaskNames
	    },
	    on: {
	      "select": _vm.toggleFilterTaskNames,
	      "clear": function($event) {
	        _vm.selectedFilterTaskNames = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['brick_type'],
	      "tags": _vm.filterLabels,
	      "selectedTags": _vm.selectedFilterSubjectTypes
	    },
	    on: {
	      "select": _vm.toggleFilterSubjectTypes,
	      "clear": function($event) {
	        _vm.selectedFilterSubjectTypes = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['tasks_status'],
	      "tags": _vm.taskStatusFilters,
	      "selectedTags": _vm.selectedFilterTaskStatus
	    },
	    on: {
	      "select": _vm.toggleFilterTaskStatus,
	      "clear": function($event) {
	        _vm.selectedFilterTaskStatus = []
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "tasks-header__right"
	  }, [(_vm.isSubmittingTask) ? _c('div', {
	    staticClass: "do-spinner"
	  }) : _vm._e(), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{ arrow: true, placement: 'bottom' }"
	    }],
	    staticClass: "do-bttn do-bttn--menu-button",
	    attrs: {
	      "content": "Download til excel",
	      "disabled": _vm.isDownloading || !_vm.activeGroupData
	    },
	    on: {
	      "click": _vm.asyncLoadXLSXAndDownload
	    }
	  }, [(_vm.isDownloading) ? _c('span', {
	    staticClass: "do-spinner do-spinner--small"
	  }) : _c('span', {
	    staticClass: "icon-download"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.openCreateTask
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['create_tasks']) + "\n      ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "tasks-body"
	  }, [_c('div', {
	    staticClass: "tasks-sidebar",
	    class: {
	      'tasks-sidebar--collapsed': _vm.sidebarCollapsed
	    }
	  }, [_c('div', {
	    staticClass: "sidebar-header"
	  }, [(!_vm.sidebarCollapsed) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['tasks_label']) + " (" + _vm._s(_vm.filteredGroupedTasks.length) + " " + _vm._s(_vm.i18n[_vm.locale]['of']) + " " + _vm._s(_vm.totalGroupCount) + ")")]) : _vm._e(), _vm._v(" "), (!_vm.sidebarCollapsed) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit sidebar-create-btn",
	    on: {
	      "click": _vm.openCreateTask
	    }
	  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "sidebar-collapse-btn",
	    on: {
	      "click": function($event) {
	        _vm.sidebarCollapsed = !_vm.sidebarCollapsed
	      }
	    }
	  }, [_c('span', {
	    class: _vm.sidebarCollapsed ? 'icon-arrow-right4' : 'icon-arrow-left4'
	  })])]), _vm._v(" "), (!_vm.sidebarCollapsed) ? [(_vm.filteredGroupedTasks.length > 0) ? _c('ul', {
	    staticClass: "sidebar-list"
	  }, [_c('li', {
	    staticClass: "sidebar-item",
	    class: {
	      'sidebar-item--active': _vm.activeGroupName === '__all__'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setActiveGroup('__all__')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "sidebar-name"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['all']))]), _vm._v(" "), _c('span', {
	    staticClass: "sidebar-count"
	  }, [_vm._v(_vm._s(Math.round(_vm.allFilteredWeightedHours * 10) / 10) + " " + _vm._s(_vm.i18n[_vm.locale]['hours_short']))])]), _vm._v(" "), _vm._l((_vm.filteredGroupedTasks), function(group) {
	    return _c('li', {
	      key: group.name,
	      staticClass: "sidebar-item",
	      class: {
	        'sidebar-item--active': _vm.activeGroupName === group.name
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveGroup(group.name)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "sidebar-dot",
	      style: ({
	        backgroundColor: group.color
	      })
	    }), _vm._v(" "), _c('span', {
	      staticClass: "sidebar-name"
	    }, [_vm._v(_vm._s(group.name))]), _vm._v(" "), _c('span', {
	      staticClass: "sidebar-count"
	    }, [_vm._v(_vm._s(Math.round(group.weightedHours * 10) / 10) + " " + _vm._s(_vm.i18n[_vm.locale]['hours_short']))])])
	  })], 2) : _c('div', {
	    staticClass: "sidebar-empty"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_tasks']))])] : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "tasks-main"
	  }, [(_vm.activeGroupData) ? [_c('div', {
	    staticClass: "task-table-wrap"
	  }, [_c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "width": "220px"
	    }
	  }), _vm._v(" "), _c('th', {
	    staticClass: "d-table__number",
	    staticStyle: {
	      "width": "80px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['hours']))]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "120px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['type']))]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "min-width": "250px"
	    }
	  }, [_c('span', {
	    staticClass: "icon-user3"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['users']))]), _vm._v(" "), _c('th', {
	    staticClass: "d-table__number",
	    staticStyle: {
	      "width": "80px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['total']))]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "50px"
	    }
	  })])]), _vm._v(" "), _c('tbody', [(_vm.activeGroupName !== '__all__') ? _c('tr', {
	    staticClass: "task-table-row task-table-row--add",
	    on: {
	      "click": _vm.duplicateFromGroup
	    }
	  }, [_c('td', {
	    attrs: {
	      "colspan": "6"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['new_task']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeGroupData.tasks), function(task) {
	    return _c('tr', {
	      key: task.id
	    }, [_c('td', [_c('div', {
	      staticClass: "task__name"
	    }, [_c('div', {
	      class: [{
	        'td-subject--hidden': !task.can_schedule
	      }, {
	        'td-subject': task.can_schedule
	      }],
	      style: ({
	        'background-color': task.color
	      }),
	      on: {
	        "click": function($event) {
	          return _vm.setEditTask(task)
	        }
	      }
	    }, [_vm._v("\n                    " + _vm._s(task.name || '') + "\n                  ")])])]), _vm._v(" "), _c('td', {
	      staticClass: "d-table__number"
	    }, [_vm._v(_vm._s(task.hours ? parseFloat(task.hours.toFixed(2)) : 0))]), _vm._v(" "), _c('td', {
	      staticClass: "task-table-type"
	    }, [_vm._v(_vm._s(_vm.getTaskTypeLabel(task)))]), _vm._v(" "), _c('td', {
	      class: {
	        'd-select-lookalike': _vm.activeDSelect !== task.id && (task.user_calendar_ids || []).length < 1
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDSelect(task)
	        }
	      }
	    }, [(_vm.activeDSelect === task.id) ? _c('DSelectCalendarIds', {
	      directives: [{
	        name: "on-clickaway",
	        rawName: "v-on-clickaway",
	        value: (_vm.closeDSelect),
	        expression: "closeDSelect"
	      }],
	      attrs: {
	        "show": _vm.activeDSelectShow,
	        "itemType": "USER",
	        "preSelectedItems": task.user_calendar_ids || [],
	        "showTags": true,
	        "sortSelectedByName": true
	      },
	      on: {
	        "update": function($event) {
	          return _vm.setTableSelectedUsers($event, task)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (_vm.activeDSelect !== task.id && (task.user_calendar_ids || []).length > 0) ? _c('div', {
	      staticClass: "task__users"
	    }, _vm._l((_vm.getUserNames(task.user_calendar_ids || [])), function(name) {
	      return _c('p', {
	        key: name
	      }, [_vm._v(_vm._s(name))])
	    }), 0) : _vm._e()], 1), _vm._v(" "), _c('td', {
	      staticClass: "d-table__number"
	    }, [_vm._v(_vm._s(_vm.getTaskWeightedTotal(task)))]), _vm._v(" "), _c('td', {
	      staticClass: "task-table-actions"
	    }, [_c('button', {
	      staticClass: "task-table-copy",
	      attrs: {
	        "title": _vm.i18n[_vm.locale]['create_copy']
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.duplicateTask(task)
	        }
	      }
	    }, [_vm._v("+")])])])
	  })], 2)])])] : _c('div', {
	    staticClass: "main-empty"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select_task']))])], 2)]), _vm._v(" "), (_vm.isTaskModal) ? _c('CreateTask', {
	    attrs: {
	      "editTask": _vm.editTask,
	      "activeFilter": null,
	      "prefill": _vm.prefillTask,
	      "quickCreate": _vm.isQuickCreate,
	      "isLoadingFreshData": _vm.isLoadingFreshTask
	    },
	    on: {
	      "close": _vm.closeCreateTask,
	      "create": _vm.createTask,
	      "updateTask": _vm.updateTask
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2078 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sd-engangsydelser text-dark"
	  }, [_c('h2', {
	    staticClass: "marg-1-bottom capitalize"
	  }, [_vm._v("Engangsydelser")]), _vm._v(" "), (_vm.isNoConfiguration) ? [_vm._m(0)] : [_c('div', {
	    staticClass: "sd-engangsydelser__header"
	  }, [_c('div', {
	    staticClass: "sd-engangsydelser__header__left"
	  }, [_c('Tabs', {
	    attrs: {
	      "tabs": _vm.viewTabs,
	      "selected": _vm.viewTab
	    },
	    on: {
	      "select": _vm.onSelectViewTab
	    }
	  }), _vm._v(" "), (_vm.viewTab === 'employments') ? [_c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Personer',
	      "tags": _vm.personNames,
	      "selectedTags": _vm.selectedPersonNames,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg personer'
	    },
	    on: {
	      "select": _vm.togglePersonName,
	      "clear": function($event) {
	        _vm.selectedPersonNames = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Grupper',
	      "tags": _vm.userTags,
	      "selectedTags": _vm.selectedUserTags,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg grupper'
	    },
	    on: {
	      "select": _vm.toggleUserTag,
	      "clear": function($event) {
	        _vm.selectedUserTags = []
	      }
	    }
	  }), _vm._v(" "), (_vm.employmentTitles.length > 1) ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Ansættelser',
	      "tags": _vm.employmentTitles,
	      "selectedTags": _vm.selectedEmploymentTitles,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg stilling'
	    },
	    on: {
	      "select": _vm.toggleEmploymentTitle,
	      "clear": function($event) {
	        _vm.selectedEmploymentTitles = []
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.organisations.length > 1) ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Organisationer',
	      "tags": _vm.organisations,
	      "selectedTags": _vm.selectedOrganisations,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg organisation'
	    },
	    on: {
	      "select": _vm.toggleOrganisation,
	      "clear": function($event) {
	        _vm.selectedOrganisations = []
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "sd-engangsydelser__count"
	  }, [_vm._v("\n            Viser " + _vm._s(_vm.filteredRows.length) + " af " + _vm._s(_vm.allRows.length) + " ansættelser\n          ")])] : [_c('DoDatePickerRange', {
	    attrs: {
	      "allowSameDate": true,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate,
	      "maximumDateRange": 730
	    },
	    on: {
	      "startChanged": _vm.startDateChanged,
	      "endChanged": _vm.endDateChanged
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Personer',
	      "tags": _vm.uniqueNames,
	      "selectedTags": _vm.selectedNames,
	      "numberOfSelectedTagsToShow": 2,
	      "placeholder": 'Vælg personer'
	    },
	    on: {
	      "select": _vm.toggleName,
	      "clear": function($event) {
	        _vm.selectedNames = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Lønart',
	      "tags": _vm.uniqueLoenart,
	      "selectedTags": _vm.selectedLoenart,
	      "numberOfSelectedTagsToShow": 2,
	      "placeholder": 'Vælg lønart'
	    },
	    on: {
	      "select": _vm.toggleLoenart,
	      "clear": function($event) {
	        _vm.selectedLoenart = []
	      }
	    }
	  })]], 2), _vm._v(" "), (_vm.viewTab !== 'employments') ? _c('div', {
	    staticClass: "sd-engangsydelser__header__right"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--small",
	    attrs: {
	      "disabled": _vm.isLoading
	    },
	    on: {
	      "click": _vm.readEngangsydelser
	    }
	  }, [_vm._v("\n          Opdater\n        ")])]) : _vm._e()]), _vm._v(" "), (_vm.viewTab === 'employments') ? _c('div', {
	    staticClass: "sd-engangsydelser__toolbar"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'top',
	        animateFill: false,
	        animation: 'shift-away',
	        boundary: 'window'
	      }),
	      expression: "{\n              arrow: true,\n              placement: 'top',\n              animateFill: false,\n              animation: 'shift-away',\n              boundary: 'window'\n            }"
	    }],
	    staticClass: "sd-engangsydelser__toolbar__wrap",
	    attrs: {
	      "content": _vm.selectedEmploymentIds.length === 0 ? 'Vælg personer først' : ''
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': _vm.selectedEmploymentIds.length === 0
	    },
	    attrs: {
	      "disabled": _vm.selectedEmploymentIds.length === 0
	    },
	    on: {
	      "click": _vm.openBulkCreate
	    }
	  }, [_vm._v("\n          Opret engangsydelser\n        ")])]), _vm._v(" "), (_vm.selectedEmploymentIds.length > 0) ? _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.cancelBatchMode
	    }
	  }, [_vm._v("Annuller valg")]) : _vm._e(), _vm._v(" "), (_vm.selectedEmploymentIds.length > 0) ? _c('span', {
	    staticClass: "sd-engangsydelser__count"
	  }, [_vm._v("\n        " + _vm._s(_vm.selectedEmploymentIds.length) + " valgt\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.viewTab === 'outbox') ? _c('div', {
	    staticClass: "sd-engangsydelser__info"
	  }, [_vm._v("\n      Engangsydelser i udbakken sendes automatisk til SD senere på dagen. Du kan slette dem, så længe de ligger her.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "sd-engangsydelser__body"
	  }, [(_vm.viewTab === 'employments') ? [(_vm.isLoadingEmployments) ? _c('Loader') : _c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "td-check do-table__toggle-all",
	    on: {
	      "click": _vm.toggleAllSelected
	    }
	  }, [_c('div', {
	    staticClass: "do-checkbox",
	    class: {
	      'do-checkbox--selected': _vm.isAllFilteredSelected
	    }
	  })]), _vm._v(" "), _c('th', [_vm._v("NAVN")]), _vm._v(" "), _c('th', [_vm._v("ANSÆTTELSE")]), _vm._v(" "), _c('th', [_vm._v("ORGANISATION")]), _vm._v(" "), _c('th', {
	    staticClass: "th-row-actions"
	  })])]), _vm._v(" "), (_vm.filteredRows.length === 0) ? _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": 5
	    }
	  }, [_vm._v("Ingen ansættelser fundet")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.groupedRows), function(group) {
	    return _c('tbody', {
	      key: group.userId,
	      staticClass: "user-group"
	    }, _vm._l((group.rows), function(row) {
	      return _c('tr', {
	        key: row.id,
	        staticClass: "employment-row",
	        class: {
	          'is-selected': _vm.isRowSelected(row)
	        },
	        on: {
	          "click": function($event) {
	            return _vm.onRowClick(row)
	          }
	        }
	      }, [_c('td', {
	        staticClass: "td-check",
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.onCheckboxClick(row)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "do-checkbox",
	        class: {
	          'do-checkbox--selected': _vm.isRowSelected(row)
	        }
	      })]), _vm._v(" "), _c('td', {
	        staticClass: "bold"
	      }, [_vm._v(_vm._s(row.userName))]), _vm._v(" "), _c('td', {
	        staticClass: "td-organisation"
	      }, [_vm._v("\n              " + _vm._s(row.employmentNumber) + " - " + _vm._s(row.employmentTitle) + "\n            ")]), _vm._v(" "), _c('td', {
	        staticClass: "td-organisation"
	      }, [_vm._v(_vm._s(row.organisation))]), _vm._v(" "), _c('td', {
	        staticClass: "td-row-actions"
	      }, [(!_vm.isBatchMode) ? _c('button', {
	        staticClass: "do-bttn do-bttn--small row-action-btn",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.openSingleCreate(row)
	          }
	        }
	      }, [_vm._v("Opret engangsydelse")]) : _vm._e()])])
	    }), 0)
	  })], 2)] : [(_vm.isLoading) ? _c('Loader') : _c('table', {
	    staticClass: "do-table do-table--striped"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "th-sorter td-created",
	    class: {
	      'th-sorter--active': !_vm.isSortPristine && _vm.sortBy === 'vCreatedAt'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('vCreatedAt')
	      }
	    }
	  }, [_vm._v("\n              OPRETTET "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'name'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('name')
	      }
	    }
	  }, [_vm._v("\n              NAVN "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'employment_number'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('employment_number')
	      }
	    }
	  }, [_vm._v("\n              ANSÆTTELSE "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'loenart'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('loenart')
	      }
	    }
	  }, [_vm._v("\n              LØNART "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter td-units",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'antal'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('antal')
	      }
	    }
	  }, [_vm._v("\n              ANTAL "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter td-units",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'beloeb'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('beloeb')
	      }
	    }
	  }, [_vm._v("\n              BELØB "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', [_vm._v("BESKRIVELSE")]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter td-date",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'dato'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('dato')
	      }
	    }
	  }, [_vm._v("\n              DATO "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "td-created-by"
	  }, [_vm._v("OPRETTET AF")]), _vm._v(" "), _c('th', {
	    staticClass: "td-status"
	  }, [_vm._v("STATUS")]), _vm._v(" "), _c('th', {
	    staticClass: "th-actions"
	  })])]), _vm._v(" "), _c('tbody', [(_vm.displayedRows.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": 11
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.emptyTableText) + "\n            ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayedRows), function(item) {
	    return _c('tr', {
	      key: item.id,
	      staticClass: "engangsydelse-row"
	    }, [_c('td', {
	      staticClass: "td-created"
	    }, [_vm._v(_vm._s(item.vCreatedAt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vUserName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vEmploymentNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vLoenart))]), _vm._v(" "), _c('td', {
	      staticClass: "td-units"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(item.enheder)))]), _vm._v(" "), _c('td', {
	      staticClass: "td-units"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(item.sats)))]), _vm._v(" "), _c('td', {
	      staticClass: "td-description"
	    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', {
	      staticClass: "td-date"
	    }, [_vm._v(_vm._s(item.vDato))]), _vm._v(" "), _c('td', {
	      staticClass: "td-created-by"
	    }, [_vm._v(_vm._s(item.vCreatedBy))]), _vm._v(" "), _c('td', {
	      staticClass: "td-status"
	    }, [_c('span', {
	      staticClass: "status-pill",
	      class: 'status-pill--' + item.state
	    }, [_vm._v(_vm._s(_vm.stateLabel(item.state)))])]), _vm._v(" "), _c('td', {
	      staticClass: "td-actions"
	    }, [(_vm.viewTab === 'outbox' && item.can_delete) ? _c('button', {
	      staticClass: "do-bttn do-bttn--small do-bttn--danger",
	      attrs: {
	        "disabled": _vm.deletingIds.includes(item.id)
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.deleteRow(item)
	        }
	      }
	    }, [_vm._v("\n                Slet\n              ")]) : _vm._e()])])
	  })], 2)])]], 2)], _vm._v(" "), (_vm.createEmploymentIds.length > 0) ? _c('SdCreateEngangsydelse', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "employmentIds": _vm.createEmploymentIds,
	      "subtitle": _vm.createSubtitle
	    },
	    on: {
	      "created": _vm.onCreated,
	      "close": _vm.closeCreate
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sd-engangsydelser-no-config"
	  }, [_c('h2', [_c('i', [_vm._v("Skolens Silkeborg Data-integration er ikke konfigureret korrekt. Kontakt Docendo for at få hjælp til\n          opsætningen - enten på chat eller email.")])])])
	}]}

/***/ }),
/* 2079 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "toasts",
	    attrs: {
	      "role": "status",
	      "aria-live": "polite",
	      "aria-atomic": "false"
	    }
	  }, [(_vm.toasts.length > 0) ? [_c('transition-group', _vm._l((_vm.toasts), function(toast, index) {
	    return _c('div', {
	      key: toast.id
	    }, [_c('toast', {
	      attrs: {
	        "index": index,
	        "toast": toast,
	        "arrayLength": _vm.toasts.length
	      },
	      on: {
	        "remove": _vm.remove,
	        "removeNow": _vm.removeNow
	      }
	    })], 1)
	  }), 0)] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 2080 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DSelect', {
	    attrs: {
	      "items": _vm.dSelectItems,
	      "multiple": true,
	      "placeholder": _vm.$t('vue2.substitution.choose_absence_user')
	    },
	    on: {
	      "update": _vm.sendUpdate
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 2081 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('d-modal', {
	    attrs: {
	      "show-close": false
	    },
	    on: {
	      "close": _vm.close
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    staticStyle: {
	      "width": "400px"
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header",
	    style: ({
	      'background': _vm.firstInSubjectsWithSameName.color
	    })
	  }, [_c('h2', {
	    staticStyle: {
	      "color": "#ffffff"
	    }
	  }, [_vm._v("\""), _c('b', [_vm._v(_vm._s(_vm.firstInSubjectsWithSameName.name))]), _vm._v("\" " + _vm._s(_vm.i18n[_vm.locale]['exists']))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    staticStyle: {
	      "color": "#ffffff"
	    },
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['the_subject']) + ": \""), _c('b', [_vm._v(_vm._s(_vm.firstInSubjectsWithSameName.name))]), _vm._v("\" "), _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['already_exists']))])]), _vm._v(" "), (_vm.subjectsCanBeDeleted.length > 0) ? _c('h4', {
	    staticClass: "marg-1-top"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['do_you_want_to_delete']) + "?")]) : _vm._e(), _vm._v(" "), _c('table', {
	    staticClass: "klassesWithSubjects"
	  }, _vm._l((_vm.subjectsCanBeDeletedWithVProps), function(subject) {
	    return _c('tr', {
	      key: subject.id
	    }, [_c('td', [_vm._v(_vm._s(subject.v_calendar_name) + " ")]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "d-subject",
	      style: ({
	        'background': subject.color
	      })
	    }, [_vm._v(_vm._s(subject.name) + " (" + _vm._s(subject.hours) + ")")])])])
	  }), 0), _vm._v(" "), (_vm.subjectsCannotDelete.length > 0) ? _c('p', {
	    staticClass: "bold italic marg-1-top text-danger"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['subject_cannot_be_deleted']))]) : _vm._e(), _vm._v(" "), _c('table', {
	    staticClass: "klassesWithSubjects"
	  }, _vm._l((_vm.subjectsCannotDeleteWithVProps), function(subject) {
	    return _c('tr', {
	      key: subject.id
	    }, [_c('td', [_vm._v(_vm._s(_vm.subjectsCannotDelete.v_calendar_name) + " ")]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "d-subject d-subject--cannot-delete",
	      style: ({
	        'background': subject.color
	      })
	    }, [_vm._v("\n              " + _vm._s(subject.name) + " (" + _vm._s(subject.hours) + ")\n            ")])])])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "bttn marg-1-right",
	    on: {
	      "click": _vm.keepExistingSubjects
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_new_anyway']))]), _vm._v(" "), (_vm.subjectsCanBeDeleted.length > 0) ? _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.deleteExistingSubjects
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['delete']) + "\n      ")]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 2082 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false
	    },
	    on: {
	      "close": _vm.closeModal
	    }
	  }, [_c('div', {
	    staticClass: "dto text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "dto__header"
	  }, [_c('h2', [_vm._v("Håndter versioner af opgaveoversigter")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "dto__filters"
	  }, [_c('div', {
	    staticClass: "dto__filters__row"
	  }, [_c('div', {
	    staticClass: "dto__filters__field"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Skoleår")]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "dto__filters__field"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Titler")]), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": "Titler",
	      "tags": _vm.titleOptions,
	      "selectedTags": _vm.selectedTitles
	    },
	    on: {
	      "select": _vm.toggleTitle,
	      "clear": _vm.clearTitles
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "dto__filters__field"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Personer")]), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": "Personer",
	      "tags": _vm.personOptions,
	      "selectedTags": _vm.selectedPersons
	    },
	    on: {
	      "select": _vm.togglePerson,
	      "clear": _vm.clearPersons
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "dto__filters__field"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Grupper")]), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "tags": _vm.tags,
	      "selectedTags": _vm.selectedGroups
	    },
	    on: {
	      "select": _vm.toggleGroup,
	      "clear": _vm.clearGroups
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "dto__body"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "dto__loading"
	  }, [_c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  })], 1) : [(_vm.rows.length < 1) ? _c('p', {
	    staticClass: "dto__empty text-explainer"
	  }, [_vm._v("\n          Der er ingen gemte versioner for dette skoleår.\n        ")]) : (_vm.filteredRows.length < 1) ? _c('p', {
	    staticClass: "dto__empty text-explainer"
	  }, [_vm._v("\n          Ingen versioner matcher de valgte filtre.\n        ")]) : _c('table', {
	    staticClass: "dto__table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "dto__table__check"
	  }, [_c('div', {
	    staticClass: "do-checkbox",
	    class: {
	      'do-checkbox--selected': _vm.isAllFilteredSelected
	    },
	    on: {
	      "click": _vm.toggleSelectAll
	    }
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "dto__table__sortable",
	    on: {
	      "click": function($event) {
	        return _vm.setSort('name')
	      }
	    }
	  }, [_vm._v("\n                Navn "), (_vm.sortKey === 'name') ? _c('span', {
	    staticClass: "icon-menu-open dto__table__sort-icon",
	    class: {
	      'dto__table__sort-icon--desc': _vm.sortDir === 'desc'
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('th', {
	    staticClass: "dto__table__sortable",
	    on: {
	      "click": function($event) {
	        return _vm.setSort('title')
	      }
	    }
	  }, [_vm._v("\n                Titel "), (_vm.sortKey === 'title') ? _c('span', {
	    staticClass: "icon-menu-open dto__table__sort-icon",
	    class: {
	      'dto__table__sort-icon--desc': _vm.sortDir === 'desc'
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('th', {
	    staticClass: "dto__table__sortable",
	    on: {
	      "click": function($event) {
	        return _vm.setSort('createdAt')
	      }
	    }
	  }, [_vm._v("\n                Gemt "), (_vm.sortKey === 'createdAt') ? _c('span', {
	    staticClass: "icon-menu-open dto__table__sort-icon",
	    class: {
	      'dto__table__sort-icon--desc': _vm.sortDir === 'desc'
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('th', {
	    staticClass: "dto__table__actions"
	  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedRows), function(row) {
	    return _c('tr', {
	      key: row.id,
	      staticClass: "dto__table__row",
	      class: {
	        'dto__table__row--selected': _vm.isSelected(row.id)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleRow(row.id)
	        }
	      }
	    }, [_c('td', {
	      staticClass: "dto__table__check"
	    }, [_c('div', {
	      staticClass: "do-checkbox",
	      class: {
	        'do-checkbox--selected': _vm.isSelected(row.id)
	      }
	    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.createdAtFormatted))]), _vm._v(" "), _c('td', {
	      staticClass: "dto__table__actions"
	    }, [_c('button', {
	      staticClass: "do-bttn do-bttn--small do-bttn--warning bttn-danger",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.askDeleteRow(row)
	        }
	      }
	    }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.common.delete')) + "\n                ")]), _vm._v(" "), _c('button', {
	      staticClass: "do-bttn do-bttn--small",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.openRow(row)
	        }
	      }
	    }, [_vm._v("Åbn")]), _vm._v(" "), _c('button', {
	      staticClass: "do-bttn do-bttn--small",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.printRow(row)
	        }
	      }
	    }, [_vm._v("Print")])])])
	  }), 0)])]], 2), _vm._v(" "), _c('div', {
	    staticClass: "dto__footer"
	  }, [_c('span', {
	    staticClass: "dto__footer__count"
	  }, [_vm._v(_vm._s(_vm.selectedIds.length) + " valgt")]), _vm._v(" "), _c('div', {
	    staticClass: "dto__footer__buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': _vm.selectedIds.length < 1,
	      'do-bttn--submit--loading': _vm.isLoadingPrint
	    },
	    on: {
	      "click": _vm.startPrint
	    }
	  }, [_vm._v("\n          Print " + _vm._s(_vm.selectedIds.length) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--warning bttn-danger",
	    class: {
	      'bttn-primary--disabled': _vm.selectedIds.length < 1
	    },
	    on: {
	      "click": _vm.askDelete
	    }
	  }, [_vm._v("\n          Slet valgte\n        ")])])])])]), _vm._v(" "), (_vm.isPrinting) ? _c('div', {
	    staticClass: "dto-print-source",
	    attrs: {
	      "id": "printSelectedTaskOverviews",
	      "aria-hidden": "true"
	    }
	  }, _vm._l((_vm.rowsToPrint), function(row) {
	    return _c('TaskOverviewUser', {
	      key: row.id,
	      attrs: {
	        "user": _vm.userForRow(row),
	        "version": row.version,
	        "isHideTaskHoursUnderThreshold": true
	      }
	    })
	  }), 1) : _vm._e(), _vm._v(" "), (_vm.isDeleteWarningActive) ? _c('DModal', {
	    attrs: {
	      "appendToBody": true,
	      "isBgOverlay": true,
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "brutto-warning text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-warning__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.common.are_you_sure_you_want_to_delete')) + "?")])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-warning__body"
	  }, [_c('svg', {
	    staticClass: "tw-icon tw-icon--red",
	    attrs: {
	      "viewBox": "0 0 24 24",
	      "fill": "none",
	      "stroke": "currentColor",
	      "stroke-width": "2",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "9",
	      "x2": "12",
	      "y2": "13"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "17",
	      "x2": "12.01",
	      "y2": "17"
	    }
	  })]), _vm._v(" "), _c('h4', [_vm._v("Slet " + _vm._s(_vm.pendingDeleteIds.length) + " version(er)?")]), _vm._v(" "), _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.task_versions.delete_warning_message')) + "\n        ")])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-warning__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        _vm.isDeleteWarningActive = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--warning bttn-danger",
	    class: [{
	      'bttn--loading': _vm.isDeleting
	    }],
	    on: {
	      "click": _vm.deleteConfirmed
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.delete')) + "\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.activeVersion) ? _c('DModal', {
	    attrs: {
	      "appendToBody": true,
	      "isBgOverlay": true,
	      "showClose": false
	    },
	    on: {
	      "close": function($event) {
	        _vm.activeVersion = null
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dto-view text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "dto-view__header"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.activeUser ? _vm.activeUser.name : ''))]), _vm._v(" "), _c('div', {
	    staticClass: "dto-view__header__right"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--warning bttn-danger do-bttn--small",
	    on: {
	      "click": _vm.askDeleteActive
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.common.delete')) + "\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": function($event) {
	        _vm.activeVersion = null
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "dto-view__body"
	  }, [(_vm.activeUser) ? _c('TaskOverviewUser', {
	    attrs: {
	      "user": _vm.activeUser,
	      "version": _vm.activeVersion
	    }
	  }) : _vm._e()], 1)])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2083 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isSubmitButtonLoading": _vm.isSubmitting,
	      "customWidth": '650px',
	      "noMarginOnButton": true,
	      "isShowConfirmDeleteMessage": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      },
	      "confirm": _vm.onConfirmAwayStatus
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "custom_warning"
	    },
	    slot: "custom_warning"
	  }, [(!_vm.isAway) ? _c('div', {
	    staticClass: "away_warning"
	  }, [(_vm.canceledRows.length > 0) ? _c('div', {
	    staticClass: "away_warning__lessons"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.i18n.lessons_will_be_cancelled))]), _vm._v(" "), _c('table', {
	    staticClass: "away_warning__lessons__table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "away_warning__th-check"
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.allCancelSelected
	    },
	    on: {
	      "change": _vm.toggleAllCancel
	    }
	  })]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n.class_header))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n.lesson_header))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n.time_header))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.canceledRows), function(row) {
	    return _c('tr', {
	      key: row.event_id
	    }, [_c('td', {
	      staticClass: "away_warning__td-check"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selectedCancelIds),
	        expression: "selectedCancelIds"
	      }],
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "value": row.event_id,
	        "checked": Array.isArray(_vm.selectedCancelIds) ? _vm._i(_vm.selectedCancelIds, row.event_id) > -1 : (_vm.selectedCancelIds)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.selectedCancelIds,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = row.event_id,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.selectedCancelIds = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (_vm.selectedCancelIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.selectedCancelIds = $$c
	          }
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.klassNames))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('td', {
	      staticClass: "text-gray"
	    }, [_vm._v(_vm._s(_vm.humanTime(row.start, row.end)))])])
	  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "away_warning__text"
	  }, [_c('h4', {
	    staticClass: "marg-0-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n.confirm_away_title))]), _vm._v(" "), _c('p', {
	    staticClass: "pad-1 italic pad-0-top"
	  }, [_vm._v(_vm._s(_vm.i18n.confirm_away_text))]), _vm._v(" "), (_vm.canceledRows.length === 0) ? _c('p', {
	    staticClass: "pad-1 italic pad-0-top"
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n.no_lessons_to_cancel) + "\n        ")]) : _vm._e()])]) : _c('div', {
	    staticClass: "away_warning"
	  }, [(_vm.uncancelGroups.length > 0) ? _c('div', {
	    staticClass: "away_warning__lessons"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.i18n.lessons_will_be_restored))]), _vm._v(" "), _vm._l((_vm.uncancelGroups), function(grp) {
	    return _c('div', {
	      key: 'u_' + grp.name
	    }, [_c('table', {
	      staticClass: "away_warning__lessons__table"
	    }, [_c('tbody', _vm._l((grp.events), function(ev) {
	      return _c('tr', {
	        key: ev.event_id + '_' + grp.name,
	        staticClass: "marg-0-5-top"
	      }, [_c('td', [_vm._v("\n                " + _vm._s(grp.name) + " | " + _vm._s(ev.title) + "\n                "), _c('span', {
	        staticClass: "text-gray"
	      }, [_vm._v("(" + _vm._s(_vm.humanTime(ev.start, ev.end)) + ")")])])])
	    }), 0)])])
	  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "away_warning__text"
	  }, [_c('h4', {
	    staticClass: "marg-0-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n.confirm_unaway_title))]), _vm._v(" "), _c('p', {
	    staticClass: "pad-1 italic"
	  }, [_vm._v(_vm._s(_vm.i18n.confirm_unaway_text))]), _vm._v(" "), (_vm.uncancelGroups.length === 0) ? _c('p', {
	    staticClass: "pad-1 italic pad-0-top"
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n.no_lessons_to_restore) + "\n        ")]) : _vm._e()])])]), _vm._v(" "), _c('p', {
	    attrs: {
	      "slot": "confirmText"
	    },
	    slot: "confirmText"
	  }, [_vm._v(_vm._s(!_vm.isAway ? _vm.i18n.mark_as_away : _vm.i18n.unmark_as_away))])])
	},staticRenderFns: []}

/***/ }),
/* 2084 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "task-create text-dark"
	  }, [_c('DModal', {
	    attrs: {
	      "show-close": false
	    },
	    on: {
	      "close": _vm.close
	    }
	  }, [_c('div', {
	    staticClass: "task-create__modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "task-create__header",
	    class: {
	      'task-create__header--create-subject': _vm.canSchedule
	    },
	    style: ({
	      'backgroundColor': _vm.color
	    })
	  }, [_c('div', {
	    staticClass: "task-create__header-main"
	  }, [_c('h3', [(_vm.name.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_task']))]) : _c('span', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), (_vm.canCopyToSharedCalendar) ? _c('DDropdown', {
	    staticClass: "task-create__header-menu",
	    attrs: {
	      "isBottomStart": false,
	      "propOffset": [0, 8]
	    }
	  }, [_c('ul', {
	    staticClass: "task-create__copy-calendar-list",
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', {
	    staticClass: "task-create__menu-heading"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_to_shared_calendar']))]), _vm._v(" "), _vm._l((_vm.copyCalendarOptions), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      on: {
	        "click": function($event) {
	          return _vm.copyTaskToSharedCalendar(calendar.id)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-clipboard2"
	    }), _vm._v(" " + _vm._s(calendar.name) + "\n              ")])
	  })], 2)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "task-create__close icon__bg-circle",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('form', {
	    staticClass: "task-create__body",
	    attrs: {
	      "id": "task-create"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [(_vm.isLoadingFreshData) ? _c('div', {
	    staticClass: "task-create__loading-overlay"
	  }, [_c('div', {
	    staticClass: "do-spinner"
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "task-create__form"
	  }, [(!_vm.quickCreate) ? [_c('div', {
	    staticClass: "input-group__flex input-group__flex--top-row"
	  }, [_c('div', {
	    staticClass: "input-group input-group__title input-flex-2"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['task_title']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    ref: "name",
	    staticClass: "d-input",
	    class: {
	      'input--error': _vm.formErrors['name']
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale]['ex_task']
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('name')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['name']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['name'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__hours-top"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['hours']) + " ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.hours),
	      expression: "hours",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "inputLessonCount",
	    staticClass: "d-input",
	    class: {
	      'input--error': _vm.formErrors['hours']
	    },
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "blur": [function($event) {
	        return _vm.removeErrors('hours')
	      }, function($event) {
	        return _vm.$forceUpdate()
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = _vm._n($event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), (_vm.isShowNorwegianPreparationDropdown) ? _c('div', {
	    staticClass: "input-group input-group__preparation"
	  }, [_c('label', [_vm._v("Årsramme")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preparation),
	      expression: "preparation"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.preparation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.preparation = $event.target.value
	      }
	    }
	  })]) : (_vm.isShowDanishPreparationFactorField && !_vm.isDanishPrepBinaryOnOwnRow) ? _c('DkPreparationFactorControl', {
	    attrs: {
	      "subject-type": _vm.subjectType,
	      "school-prep-factor": _vm.schoolSettings.prepFactor,
	      "labels": _vm.danishPreparationControlLabels,
	      "input-class": "d-input",
	      "wrap-class": "input-group input-group__preparation"
	    },
	    model: {
	      value: (_vm.preparation),
	      callback: function($$v) {
	        _vm.preparation = $$v
	      },
	      expression: "preparation"
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.isDanishPrepBinaryOnOwnRow) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('DkPreparationFactorControl', {
	    attrs: {
	      "subject-type": _vm.subjectType,
	      "school-prep-factor": _vm.schoolSettings.prepFactor,
	      "labels": _vm.danishPreparationControlLabels,
	      "input-class": "d-input",
	      "wrap-class": "input-group input-group__preparation dk-prep-factor-full-width"
	    },
	    model: {
	      value: (_vm.preparation),
	      callback: function($$v) {
	        _vm.preparation = $$v
	      },
	      expression: "preparation"
	    }
	  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_user']))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "USER",
	      "preSelectedItems": _vm.calendars,
	      "showTags": true,
	      "itemsThatCantBeDeleted": _vm.usersWithEvents
	    },
	    on: {
	      "update": _vm.setSelectedUsers
	    }
	  })], 1), _vm._v(" "), (!_vm.quickCreate) ? [_c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "create-as-subject"
	  }, [_c('div', {
	    staticClass: "create-as-subject__inner",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleDateFields.apply(null, arguments)
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "propOn": _vm.isShowDateFields,
	      "allowChanges": false
	    }
	  }), _vm._v(" "), _c('label', {
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_dates_on_overview']))])], 1)])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropdown"
	    }
	  }, [(_vm.isShowDateFields) ? _c('div', {
	    staticClass: "input-group__flex"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['from_date']))]), _vm._v(" "), _c('div', {
	    staticClass: "date-field"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.fromDate || _vm.today,
	      "width100": true
	    },
	    on: {
	      "changed": _vm.setFromDate
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['to_date']))]), _vm._v(" "), _c('div', {
	    staticClass: "date-field"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.toDate || _vm.today,
	      "width100": true
	    },
	    on: {
	      "changed": _vm.setToDate
	    }
	  })], 1)])]) : _vm._e()]), _vm._v(" "), (!_vm.editTask) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_type']))]), _vm._v(" "), _c('SubjectFormSubjectType', {
	    attrs: {
	      "calendar-type": "user",
	      "subject-type": _vm.subjectType,
	      "isInTasks": true
	    },
	    on: {
	      "change": _vm.setSubjectType
	    }
	  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.quickCreate) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['hours_as']) + " "), _c('span', {
	    staticClass: "pill pill--grey hint--top-right",
	    attrs: {
	      "aria-label": "Vælg briktype for at ændre"
	    }
	  }, [_vm._v(_vm._s(_vm.hoursType))])]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__flex"
	  }, [_c('div', {
	    staticStyle: {
	      "width": "50%"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.hours),
	      expression: "hours",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "inputLessonCount",
	    staticClass: "d-input",
	    class: {
	      'input--error': _vm.formErrors['hours']
	    },
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "blur": [function($event) {
	        return _vm.removeErrors('hours')
	      }, function($event) {
	        return _vm.$forceUpdate()
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = _vm._n($event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (!_vm.quickCreate) ? [(!_vm.editTask) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "create-as-subject"
	  }, [_c('div', {
	    staticClass: "create-as-subject__inner",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.canSchedule = !_vm.canSchedule
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "propOn": _vm.canSchedule,
	      "allowChanges": false
	    },
	    on: {
	      "changed": _vm.setIsCreateAsSubject
	    }
	  }), _vm._v(" "), _c('label', {
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['can_be_scheduled']))])], 1)])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropdown"
	    }
	  }, [(_vm.canSchedule) ? _c('div', [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['duration']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.duration),
	      expression: "duration",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "inputLessonCount",
	    staticClass: "d-input",
	    class: {
	      'input--error': _vm.formErrors['duration']
	    },
	    staticStyle: {
	      "width": "50%"
	    },
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.duration)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "blur": [function($event) {
	        return _vm.removeErrors('duration')
	      }, function($event) {
	        return _vm.$forceUpdate()
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.duration = _vm._n($event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['duration']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['duration'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropdown"
	    }
	  }, [(_vm.isCreateInOtherCalendarAnOption && !_vm.editTask) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_in_calendar']))]), _vm._v(" "), _c('SelectOtherCal', {
	    attrs: {
	      "selectedCalendarId": _vm.selectedOtherCalendarId,
	      "calendarType": _vm.taskCalendarType
	    },
	    on: {
	      "changed": _vm.setSelectedOtherCalendarId
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), (_vm.editTask && _vm.getOtherCalendarName(_vm.selectedOtherCalendarId)) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['created_in_calendar']))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.getOtherCalendarName(_vm.selectedOtherCalendarId)))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_color']))]), _vm._v(" "), _c('color-picker', {
	    attrs: {
	      "initialColor": _vm.color
	    },
	    on: {
	      "changedColor": _vm.setColor
	    }
	  })], 1)], 1) : _vm._e()])] : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__submit task-create__footer"
	  }, [_c('div', {
	    staticClass: "input-group__submit__left"
	  }, [(_vm.editTask) ? [(_vm.usersWithEvents.length < 1) ? _c('button', {
	    staticClass: "hint--right bttn--warning",
	    attrs: {
	      "aria-label": "Slet opgaven"
	    },
	    on: {
	      "click": _vm.deleteTask
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })]) : _c('div', {
	    staticClass: "hint--right",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['cannot_be_deleted']
	    }
	  }, [_c('button', {
	    staticClass: "bttn bttn--disabled"
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })])])] : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))])], 2), _vm._v(" "), _c('div', {
	    staticClass: "input-group__submit__right"
	  }, [(!_vm.editTask) ? [_c('button', {
	    staticClass: "do-bttn",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmittingTask
	    },
	    on: {
	      "click": function($event) {
	        return _vm.createTask(true)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['save_and_new']) + "\n                ")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'top',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n                          placement: 'top',\n                          zIndex: 12312312312312\n                        }"
	    }],
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmittingTask
	    },
	    attrs: {
	      "content": _vm.saveKeyTooltip
	    },
	    on: {
	      "click": function($event) {
	        return _vm.createTask(false)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['save_and_close']) + "\n                ")])] : _vm._e(), _vm._v(" "), (_vm.editTask) ? _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'top',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n                        placement: 'top',\n                        zIndex: 12312312312312\n                      }"
	    }],
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmittingTask
	    },
	    attrs: {
	      "content": _vm.saveKeyTooltip
	    },
	    on: {
	      "click": _vm.updateTask
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['update_task']) + "\n              ")]) : _vm._e()], 2)])], 2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-overlay animatedFast fadeIn"
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2085 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tasks-layout text-dark"
	  }, [_c('div', {
	    staticClass: "tasks-header"
	  }, [_c('div', {
	    staticClass: "tasks-header__left"
	  }, [_c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['task_names'],
	      "tags": _vm.taskNameLabels,
	      "selectedTags": _vm.selectedFilterTaskNames
	    },
	    on: {
	      "select": _vm.toggleFilterTaskNames,
	      "clear": function($event) {
	        _vm.selectedFilterTaskNames = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['brick_type'],
	      "tags": _vm.filterLabels,
	      "selectedTags": _vm.selectedFilterSubjectTypes
	    },
	    on: {
	      "select": _vm.toggleFilterSubjectTypes,
	      "clear": function($event) {
	        _vm.selectedFilterSubjectTypes = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['tasks_status'],
	      "tags": _vm.taskStatusFilters,
	      "selectedTags": _vm.selectedFilterTaskStatus
	    },
	    on: {
	      "select": _vm.toggleFilterTaskStatus,
	      "clear": function($event) {
	        _vm.selectedFilterTaskStatus = []
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "tasks-header__right"
	  }, [(_vm.isSubmittingTask) ? _c('div', {
	    staticClass: "do-spinner"
	  }) : _vm._e(), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{ arrow: true, placement: 'bottom' }"
	    }],
	    staticClass: "do-bttn do-bttn--menu-button",
	    attrs: {
	      "content": "Download til excel",
	      "disabled": _vm.isDownloading || !_vm.activeGroupData
	    },
	    on: {
	      "click": _vm.asyncLoadXLSXAndDownload
	    }
	  }, [(_vm.isDownloading) ? _c('span', {
	    staticClass: "do-spinner do-spinner--small"
	  }) : _c('span', {
	    staticClass: "icon-download"
	  })]), _vm._v(" "), _c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "isBottomStart": false,
	      "isCloseOnDropdownClick": true,
	      "propOffset": [0, 8]
	    },
	    scopedSlots: _vm._u([{
	      key: "title",
	      fn: function() {
	        return [_c('button', {
	          staticClass: "do-bttn do-bttn--menu-button",
	          class: {
	            'do-bttn--active': _vm.bulkActionMode
	          }
	        }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['bulk_actions']) + " "), _c('span', {
	          staticClass: "icon-menu-open"
	        })])]
	      },
	      proxy: true
	    }, {
	      key: "list",
	      fn: function() {
	        return [_c('ul', {
	          staticClass: "do-bttn--menu-button__list"
	        }, [_c('li', {
	          on: {
	            "click": function($event) {
	              return _vm.startBulkAction('subject_type')
	            }
	          }
	        }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['change_type']) + "\n              "), (_vm.bulkActionMode && _vm.bulkActionType === 'subject_type') ? _c('span', {
	          staticClass: "icon-checkmark-circle"
	        }) : _vm._e()]), _vm._v(" "), _c('li', {
	          on: {
	            "click": function($event) {
	              return _vm.startBulkAction('hours')
	            }
	          }
	        }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['change_hours']) + "\n              "), (_vm.bulkActionMode && _vm.bulkActionType === 'hours') ? _c('span', {
	          staticClass: "icon-checkmark-circle"
	        }) : _vm._e()]), _vm._v(" "), _c('li', {
	          on: {
	            "click": function($event) {
	              return _vm.startBulkAction('dates')
	            }
	          }
	        }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['change_dates']) + "\n              "), (_vm.bulkActionMode && _vm.bulkActionType === 'dates') ? _c('span', {
	          staticClass: "icon-checkmark-circle"
	        }) : _vm._e()]), _vm._v(" "), _c('li', {
	          on: {
	            "click": function($event) {
	              return _vm.startBulkAction('delete')
	            }
	          }
	        }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['delete_subjects']) + "\n              "), (_vm.bulkActionMode && _vm.bulkActionType === 'delete') ? _c('span', {
	          staticClass: "icon-checkmark-circle"
	        }) : _vm._e()])])]
	      },
	      proxy: true
	    }])
	  }), _vm._v(" "), _c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "isBottomStart": false,
	      "isCloseOnDropdownClick": false,
	      "propOffset": [0, 8]
	    },
	    scopedSlots: _vm._u([{
	      key: "title",
	      fn: function() {
	        return [_c('button', {
	          staticClass: "do-bttn do-bttn--menu-button"
	        }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['view']) + " "), _c('span', {
	          staticClass: "icon-menu-open"
	        })])]
	      },
	      proxy: true
	    }, {
	      key: "list",
	      fn: function() {
	        return [_c('ul', {
	          staticClass: "do-bttn--menu-button__list"
	        }, [_c('li', {
	          on: {
	            "click": function($event) {
	              _vm.showCalendarInTable = !_vm.showCalendarInTable
	            }
	          }
	        }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['show_calendar_in_table']) + "\n              "), (_vm.showCalendarInTable) ? _c('span', {
	          staticClass: "icon-checkmark-circle"
	        }) : _vm._e()]), _vm._v(" "), _c('li', {
	          on: {
	            "click": function($event) {
	              _vm.showDatesInTable = !_vm.showDatesInTable
	            }
	          }
	        }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['show_dates_in_table']) + "\n              "), (_vm.showDatesInTable) ? _c('span', {
	          staticClass: "icon-checkmark-circle"
	        }) : _vm._e()]), _vm._v(" "), _c('li', {
	          on: {
	            "click": function($event) {
	              _vm.showUsersInTable = !_vm.showUsersInTable
	            }
	          }
	        }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['show_users_in_table']) + "\n              "), (_vm.showUsersInTable) ? _c('span', {
	          staticClass: "icon-checkmark-circle"
	        }) : _vm._e()]), _vm._v(" "), _c('li', {
	          on: {
	            "click": function($event) {
	              _vm.showTotalInTable = !_vm.showTotalInTable
	            }
	          }
	        }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['show_total_in_table']) + "\n              "), (_vm.showTotalInTable) ? _c('span', {
	          staticClass: "icon-checkmark-circle"
	        }) : _vm._e()]), _vm._v(" "), _c('li', {
	          on: {
	            "click": function($event) {
	              _vm.unmergeTasks = !_vm.unmergeTasks
	            }
	          }
	        }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['unmerge_tasks']) + "\n              "), (_vm.unmergeTasks) ? _c('span', {
	          staticClass: "icon-checkmark-circle"
	        }) : _vm._e()])])]
	      },
	      proxy: true
	    }])
	  }), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.openCreateTask
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['create_tasks']) + "\n      ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "tasks-body"
	  }, [_c('div', {
	    staticClass: "tasks-sidebar",
	    class: {
	      'tasks-sidebar--collapsed': _vm.sidebarCollapsed
	    }
	  }, [_c('div', {
	    staticClass: "sidebar-header"
	  }, [(!_vm.sidebarCollapsed) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['tasks_label']) + " (" + _vm._s(_vm.filteredGroupedTasks.length) + " " + _vm._s(_vm.i18n[_vm.locale]['of']) + " " + _vm._s(_vm.totalGroupCount) + ")")]) : _vm._e(), _vm._v(" "), (!_vm.sidebarCollapsed) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit sidebar-create-btn",
	    on: {
	      "click": _vm.openCreateTask
	    }
	  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "sidebar-collapse-btn",
	    on: {
	      "click": function($event) {
	        _vm.sidebarCollapsed = !_vm.sidebarCollapsed
	      }
	    }
	  }, [_c('span', {
	    class: _vm.sidebarCollapsed ? 'icon-arrow-right4' : 'icon-arrow-left4'
	  })])]), _vm._v(" "), (!_vm.sidebarCollapsed) ? [(_vm.filteredGroupedTasks.length > 0) ? _c('ul', {
	    staticClass: "sidebar-list"
	  }, [_c('li', {
	    staticClass: "sidebar-item",
	    class: {
	      'sidebar-item--active': _vm.activeGroupName === '__all__'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setActiveGroup('__all__')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "sidebar-name"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['all']))]), _vm._v(" "), _c('span', {
	    staticClass: "sidebar-count"
	  }, [_vm._v(_vm._s(Math.round(_vm.allFilteredWeightedHours * 10) / 10) + " " + _vm._s(_vm.i18n[_vm.locale]['hours_short']))])]), _vm._v(" "), _vm._l((_vm.filteredGroupedTasks), function(group) {
	    return _c('li', {
	      key: group.name,
	      staticClass: "sidebar-item",
	      class: {
	        'sidebar-item--active': _vm.activeGroupName === group.name
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveGroup(group.name)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "sidebar-name"
	    }, [_vm._v(_vm._s(group.name))]), _vm._v(" "), _c('span', {
	      staticClass: "sidebar-count"
	    }, [_vm._v(_vm._s(Math.round(group.weightedHours * 10) / 10) + " " + _vm._s(_vm.i18n[_vm.locale]['hours_short']))])])
	  })], 2) : _c('div', {
	    staticClass: "sidebar-empty"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_tasks']))])] : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "tasks-main"
	  }, [(_vm.activeGroupData) ? [(_vm.bulkActionMode) ? _c('div', {
	    staticClass: "bulk-action-bar"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.toggleSelectAllVisible
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.allVisibleSelected ? _vm.i18n[_vm.locale]['deselect_all'] : _vm.i18n[_vm.locale]['select_all_visible']) + "\n        ")]), _vm._v(" "), _c('span', {
	    staticClass: "bulk-action-bar__count"
	  }, [_vm._v(_vm._s(_vm.selectedRowIds.length) + " " + _vm._s(_vm.i18n[_vm.locale]['selected']))]), _vm._v(" "), (_vm.selectedRowIds.length > 0 && _vm.bulkActionType === 'subject_type') ? [_c('label', {
	    staticClass: "bulk-action-bar__label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['change_type']) + ":")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.bulkSubjectType),
	      expression: "bulkSubjectType"
	    }],
	    staticClass: "do-select d-input bulk-action-bar__select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.bulkSubjectType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "disabled": ""
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_type_placeholder']))]), _vm._v(" "), _vm._l((_vm.bulkSubjectTypeOptions), function(opt) {
	    return _c('option', {
	      key: opt.value,
	      domProps: {
	        "value": opt.value
	      }
	    }, [_vm._v(_vm._s(opt.label))])
	  })], 2), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isApplyingBulk
	    },
	    attrs: {
	      "disabled": !_vm.bulkSubjectType || _vm.isApplyingBulk
	    },
	    on: {
	      "click": _vm.applyBulkSubjectType
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['apply']) + "\n          ")])] : _vm._e(), _vm._v(" "), (_vm.selectedRowIds.length > 0 && _vm.bulkActionType === 'hours') ? [_c('label', {
	    staticClass: "bulk-action-bar__label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['change_hours']) + ":")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.bulkHours),
	      expression: "bulkHours",
	      modifiers: {
	        "number": true
	      }
	    }],
	    staticClass: "d-input bulk-action-bar__input",
	    attrs: {
	      "type": "number",
	      "placeholder": _vm.i18n[_vm.locale]['hours_placeholder'],
	      "min": "0",
	      "step": "0.25"
	    },
	    domProps: {
	      "value": (_vm.bulkHours)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.bulkHours = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isApplyingBulk
	    },
	    attrs: {
	      "disabled": _vm.bulkHours == null || _vm.bulkHours === '' || _vm.isApplyingBulk
	    },
	    on: {
	      "click": _vm.applyBulkHours
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['apply']) + "\n          ")])] : _vm._e(), _vm._v(" "), (_vm.selectedRowIds.length > 0 && _vm.bulkActionType === 'dates') ? [_c('label', {
	    staticClass: "bulk-action-bar__label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['change_dates']) + ":")]), _vm._v(" "), _c('DatePickerRange', {
	    attrs: {
	      "startdate": _vm.bulkFromDate,
	      "enddate": _vm.bulkToDate,
	      "minDate": _vm.bulkDateMin,
	      "maxDate": _vm.bulkDateMax,
	      "maxEndDate": _vm.bulkDateMax,
	      "allowSameDate": true
	    },
	    on: {
	      "startchanged": _vm.setBulkFromDate,
	      "endchanged": _vm.setBulkToDate
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isApplyingBulk
	    },
	    attrs: {
	      "disabled": !_vm.bulkFromDate || !_vm.bulkToDate || _vm.isApplyingBulk
	    },
	    on: {
	      "click": _vm.applyBulkDates
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['apply']) + "\n          ")])] : _vm._e(), _vm._v(" "), (_vm.selectedRowIds.length > 0 && _vm.bulkActionType === 'delete') ? [(_vm.skippedSubjectCount > 0) ? _c('span', {
	    staticClass: "bulk-action-bar__warning"
	  }, [_vm._v("\n            " + _vm._s(_vm.skippedSubjectCount) + " " + _vm._s(_vm.i18n[_vm.locale]['bulk_delete_skipped']) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--delete",
	    class: {
	      'do-bttn--submit--loading': _vm.isApplyingBulk
	    },
	    attrs: {
	      "disabled": _vm.deletableSubjectIds.length === 0 || _vm.isApplyingBulk
	    },
	    on: {
	      "click": _vm.applyBulkDelete
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['delete']) + " (" + _vm._s(_vm.deletableSubjectIds.length) + ")\n          ")])] : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn bulk-action-bar__cancel",
	    on: {
	      "click": _vm.cancelBulkAction
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale]['cancel']) + "\n        ")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "task-table-wrap"
	  }, [_c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [(_vm.bulkActionMode) ? _c('th', {
	    staticClass: "task-table-checkbox",
	    staticStyle: {
	      "width": "36px"
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.allVisibleSelected
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSelectAllVisible.apply(null, arguments)
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "220px"
	    }
	  }), _vm._v(" "), _c('th', {
	    staticClass: "d-table__number",
	    staticStyle: {
	      "width": "80px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['hours']))]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "120px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['type']))]), _vm._v(" "), (_vm.showCalendarInTable) ? _c('th', {
	    staticStyle: {
	      "width": "150px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['calendar']))]) : _vm._e(), _vm._v(" "), (_vm.showDatesInTable) ? _c('th', {
	    staticStyle: {
	      "width": "180px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['dates']))]) : _vm._e(), _vm._v(" "), (_vm.showUsersInTable) ? _c('th', {
	    staticStyle: {
	      "min-width": "250px"
	    }
	  }, [_c('span', {
	    staticClass: "icon-user3"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['users']))]) : _vm._e(), _vm._v(" "), (_vm.showTotalInTable) ? _c('th', {
	    staticClass: "d-table__number",
	    staticStyle: {
	      "width": "80px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['total']))]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "50px"
	    }
	  })])]), _vm._v(" "), _c('tbody', [(_vm.activeGroupName !== '__all__') ? _c('tr', {
	    staticClass: "task-table-row task-table-row--add",
	    on: {
	      "click": _vm.duplicateFromGroup
	    }
	  }, [_c('td', {
	    attrs: {
	      "colspan": _vm.visibleColumnCount
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['new_task']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeGroupData.tasks), function(task) {
	    return _c('tr', {
	      key: task._generatedId || task.id
	    }, [(_vm.bulkActionMode) ? _c('td', {
	      staticClass: "task-table-checkbox"
	    }, [_c('input', {
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "checked": _vm.isRowSelected(task)
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.toggleRowSelection(task)
	        }
	      }
	    })]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "task__name"
	    }, [_c('div', {
	      class: [{
	        'td-subject--hidden': !task.can_schedule
	      }, {
	        'td-subject': task.can_schedule
	      }],
	      style: ({
	        'background-color': task.color
	      }),
	      on: {
	        "click": function($event) {
	          return _vm.setEditTask(task)
	        }
	      }
	    }, [_vm._v("\n                    " + _vm._s(task.name || '') + "\n                  ")])])]), _vm._v(" "), _c('td', {
	      staticClass: "d-table__number"
	    }, [_vm._v(_vm._s(task.hours ? parseFloat(task.hours.toFixed(2)) : 0))]), _vm._v(" "), _c('td', {
	      staticClass: "task-table-type"
	    }, [_vm._v(_vm._s(_vm.getTaskTypeLabel(task)))]), _vm._v(" "), (_vm.showCalendarInTable) ? _c('td', {
	      staticClass: "task-table-calendar",
	      class: {
	        'task-table-calendar--own': task.in_user_calendar
	      }
	    }, [_vm._v("\n                " + _vm._s(_vm.getTaskCalendarLabel(task)) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.showDatesInTable) ? _c('td', {
	      staticClass: "task-table-dates"
	    }, [_vm._v("\n                " + _vm._s(_vm.getTaskDatesLabel(task)) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.showUsersInTable) ? _c('td', {
	      class: {
	        'd-select-lookalike': _vm.activeDSelect !== (task._generatedId || task.id) && (task.user_calendar_ids || []).length < 1
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDSelect(task)
	        }
	      }
	    }, [(_vm.activeDSelect === (task._generatedId || task.id)) ? _c('DSelectCalendarIds', {
	      directives: [{
	        name: "on-clickaway",
	        rawName: "v-on-clickaway",
	        value: (_vm.closeDSelect),
	        expression: "closeDSelect"
	      }],
	      attrs: {
	        "show": _vm.activeDSelectShow,
	        "itemType": "USER",
	        "preSelectedItems": task.user_calendar_ids || [],
	        "itemsThatCantBeDeleted": _vm.getUsersWithEvents(task),
	        "showTags": true,
	        "sortSelectedByName": true
	      },
	      on: {
	        "update": function($event) {
	          return _vm.setTableSelectedUsers($event, task)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (_vm.activeDSelect !== (task._generatedId || task.id) && (task.user_calendar_ids || []).length > 0) ? _c('div', {
	      staticClass: "task__users"
	    }, _vm._l((_vm.getUserNames(task.user_calendar_ids || [])), function(name) {
	      return _c('p', {
	        key: name
	      }, [_vm._v(_vm._s(name))])
	    }), 0) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showTotalInTable) ? _c('td', {
	      staticClass: "d-table__number"
	    }, [_vm._v(_vm._s(_vm.getTaskWeightedTotal(task)))]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "task-table-actions"
	    }, [_c('button', {
	      staticClass: "task-table-copy",
	      attrs: {
	        "title": _vm.i18n[_vm.locale]['create_copy']
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.duplicateTask(task)
	        }
	      }
	    }, [_vm._v("+")])])])
	  })], 2)])])] : _c('div', {
	    staticClass: "main-empty"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select_task']))])], 2)]), _vm._v(" "), (_vm.isTaskModal) ? _c('CreateTask', {
	    attrs: {
	      "editTask": _vm.editTask,
	      "activeFilter": null,
	      "prefill": _vm.prefillTask,
	      "quickCreate": _vm.isQuickCreate,
	      "isLoadingFreshData": _vm.isLoadingFreshTask
	    },
	    on: {
	      "close": _vm.closeCreateTask,
	      "create": _vm.createTask
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2086 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true,
	      "placeInTop": true,
	      "pxFromTop": 1,
	      "ariaLabel": _vm.$t('vue2.school_users.edit')
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal school-user-modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.school_users.edit')))]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "school-user-modal__profile"
	  }, [_c('label', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{arrow: true, placement: 'bottom'}"
	    }],
	    staticClass: "school-user-modal__avatar",
	    class: {
	      'school-user-modal__avatar--loading': _vm.isUploadingImage
	    },
	    attrs: {
	      "content": _vm.$t('vue2.school_users.change_photo')
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.thumbUrl,
	      "alt": _vm.user.name,
	      "width": "64",
	      "height": "64"
	    }
	  }), _vm._v(" "), _c('input', {
	    staticClass: "school-user-modal__file",
	    attrs: {
	      "type": "file",
	      "accept": "image/*"
	    },
	    on: {
	      "change": _vm.onImageSelected
	    }
	  })]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "school-user-modal__profile__name"
	  }, [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('div', {
	    staticClass: "school-user-modal__profile__seen"
	  }, [_vm._v(_vm._s(_vm.lastSeen))])])]), _vm._v(" "), _c('div', {
	    staticClass: "do-input-group-flex"
	  }, [_c('div', {
	    staticClass: "school-user-modal__grow"
	  }, [_c('label', {
	    staticClass: "d-label",
	    attrs: {
	      "for": "school-user-name"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.name')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.name),
	      expression: "form.name"
	    }, {
	      name: "focus",
	      rawName: "v-focus"
	    }],
	    staticClass: "d-input width-100",
	    attrs: {
	      "id": "school-user-name",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.form.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.form, "name", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "school-user-modal__initials"
	  }, [_c('label', {
	    staticClass: "d-label",
	    attrs: {
	      "for": "school-user-initials"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.initials')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.initials),
	      expression: "form.initials"
	    }],
	    staticClass: "d-input width-100",
	    attrs: {
	      "id": "school-user-initials",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.form.initials)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.form, "initials", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-input-group"
	  }, [_c('label', {
	    staticClass: "d-label",
	    attrs: {
	      "for": "school-user-email"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.email')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.email),
	      expression: "form.email"
	    }],
	    staticClass: "d-input width-100",
	    attrs: {
	      "id": "school-user-email",
	      "type": "email"
	    },
	    domProps: {
	      "value": (_vm.form.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.form, "email", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "do-input-group"
	  }, [_c('label', {
	    staticClass: "d-label",
	    attrs: {
	      "for": "school-user-phone"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.phone')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.phone),
	      expression: "form.phone"
	    }],
	    staticClass: "d-input width-100",
	    attrs: {
	      "id": "school-user-phone",
	      "type": "tel",
	      "placeholder": "12 34 56 78"
	    },
	    domProps: {
	      "value": (_vm.form.phone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.form, "phone", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.showSsn) ? _c('div', {
	    staticClass: "do-input-group"
	  }, [_c('label', {
	    staticClass: "d-label",
	    attrs: {
	      "for": "school-user-ssn"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.ssn')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.ssn),
	      expression: "form.ssn"
	    }],
	    staticClass: "d-input width-100",
	    attrs: {
	      "id": "school-user-ssn",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.form.ssn)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.form, "ssn", $event.target.value)
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.loginField) ? _c('div', {
	    staticClass: "do-input-group"
	  }, [_c('label', {
	    staticClass: "d-label",
	    attrs: {
	      "for": "school-user-login"
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.loginField.label) + "\n          "), (_vm.loginField.hint) ? _c('span', {
	    staticClass: "school-user-modal__label-hint"
	  }, [_vm._v(_vm._s(_vm.loginField.hint))]) : _vm._e()]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form[_vm.loginField.key]),
	      expression: "form[loginField.key]"
	    }],
	    staticClass: "d-input width-100",
	    attrs: {
	      "id": "school-user-login",
	      "type": "text",
	      "disabled": !_vm.isEditable(_vm.loginField.key)
	    },
	    domProps: {
	      "value": (_vm.form[_vm.loginField.key])
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.form, _vm.loginField.key, $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (!_vm.isEditable(_vm.loginField.key)) ? _c('p', {
	    staticClass: "school-user-modal__hint"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.not_editable_yet')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "do-input-group"
	  }, [_c('label', {
	    staticClass: "d-label",
	    attrs: {
	      "for": "school-user-employee-id"
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.school_users.employee_id')) + "\n          "), _c('span', {
	    staticClass: "school-user-modal__label-hint"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.employee_id_hint')))])]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.employee_id),
	      expression: "form.employee_id"
	    }],
	    staticClass: "d-input width-100",
	    attrs: {
	      "id": "school-user-employee-id",
	      "type": "text",
	      "disabled": !_vm.isEditable('employee_id')
	    },
	    domProps: {
	      "value": (_vm.form.employee_id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.form, "employee_id", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (!_vm.isEditable('employee_id')) ? _c('p', {
	    staticClass: "school-user-modal__hint"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.not_editable_yet')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', [_c('a', {
	    staticClass: "school-user-modal__link",
	    attrs: {
	      "href": _vm.tasksUrl
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.see_tasks')))])]), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "do-bttn",
	    attrs: {
	      "disabled": _vm.isSaving
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.school_users.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': !_vm.isValid || _vm.isSaving,
	      'do-bttn--submit--loading': _vm.isSaving
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.school_users.save')) + "\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2087 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "special-days text-dark"
	  }, [_c('div', {
	    staticClass: "special-days__header"
	  }, [_c('div', {
	    staticClass: "special-days__header__text"
	  }, [_c('div', {
	    staticClass: "special-days__header__title-row"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.special_days.title')))]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1), _vm._v(" "), _c('p', {
	    staticClass: "do-pill do-pill--yellow special-days__intro"
	  }, [_vm._v("Der kopieres ikke ind i datoer i klasseskemaerne med omlagte dage, og de overskrives derfor ikke. Omlagte dage kan desuden fratrække uv-timer fra klassens normale fagtimer, der skulle have lagt.")])]), _vm._v(" "), _c('div', {
	    staticClass: "special-days__header__actions"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    class: {
	      'do-bttn--loading': _vm.isRefreshingReductions
	    },
	    attrs: {
	      "disabled": !_vm.canCreate || _vm.isRefreshingReductions
	    },
	    on: {
	      "click": _vm.refreshReductions
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.special_days.refresh_reductions')) + "\n      ")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom',
	        allowHTML: true
	      }),
	      expression: "{arrow: true, placement: 'bottom', allowHTML: true}"
	    }],
	    staticClass: "do-bttn do-bttn--submit",
	    attrs: {
	      "disabled": !_vm.canCreate,
	      "content": _vm.shortcutTooltip
	    },
	    on: {
	      "click": _vm.openCreate
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.special_days.create')) + "\n      ")])])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader') : [_c('table', {
	    staticClass: "do-table do-table--striped special-days__table"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('vue2.special_days.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('vue2.special_days.period')))]), _vm._v(" "), _c('th', {
	    staticClass: "special-days__table__classes-col"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.classes')))]), _vm._v(" "), _c('th', {
	    staticClass: "special-days__table__reduct-col"
	  }, [_vm._v("Reducer")]), _vm._v(" "), _c('th', {
	    staticClass: "special-days__table__actions-col"
	  })])]), _vm._v(" "), _c('tbody', [(_vm.specialDays.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.none_created')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.specialDays), function(item) {
	    return _c('tr', {
	      key: item.id,
	      staticClass: "special-days__row",
	      on: {
	        "click": function($event) {
	          return _vm.openEdit(item)
	        }
	      }
	    }, [_c('td', {
	      staticClass: "special-days__table__name"
	    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatPeriod(item)))]), _vm._v(" "), _c('td', {
	      staticClass: "special-days__table__classes-col"
	    }, [_vm._v(_vm._s(_vm.classNames(item)))]), _vm._v(" "), _c('td', {
	      staticClass: "special-days__table__reduct-col"
	    }, [(item.reduct) ? _c('span', {
	      staticClass: "special-days__reduct-days"
	    }, [_vm._v(_vm._s(_vm.reductDaysLabel(item)))]) : _c('span', {
	      staticClass: "special-days__reduct-dash"
	    }, [_vm._v("–")])]), _vm._v(" "), _c('td', {
	      staticClass: "special-days__table__actions",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	        }
	      }
	    }, [(_vm.linkedSubjects(item).length === 0) ? _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'bottom',
	          allowHTML: true
	        }),
	        expression: "{arrow: true, placement: 'bottom', allowHTML: true}"
	      }],
	      staticClass: "do-bttn do-bttn--small",
	      attrs: {
	        "aria-label": "Opret brikker",
	        "content": 'Opret brikker'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.openSubjects(item)
	        }
	      }
	    }, [_vm._v("\n              Opret brikker\n            ")]) : _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'bottom',
	          allowHTML: true
	        }),
	        expression: "{arrow: true, placement: 'bottom', allowHTML: true}"
	      }],
	      staticClass: "do-bttn do-bttn--small",
	      attrs: {
	        "content": 'Se og rediger brikker'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.openSubjectsList(item, $event)
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(_vm.brikkerLabel(item)) + "\n            ")]), _vm._v(" "), _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'bottom',
	          allowHTML: true
	        }),
	        expression: "{arrow: true, placement: 'bottom', allowHTML: true}"
	      }],
	      staticClass: "do-bttn do-bttn--small",
	      attrs: {
	        "aria-label": _vm.$t('vue2.special_days.edit'),
	        "content": 'Rediger omlagt dag'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.openEdit(item)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-pencil"
	    })]), _vm._v(" "), _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'bottom',
	          allowHTML: true
	        }),
	        expression: "{arrow: true, placement: 'bottom', allowHTML: true}"
	      }],
	      staticClass: "do-bttn do-bttn--small do-bttn--danger",
	      attrs: {
	        "aria-label": _vm.$t('vue2.special_days.delete'),
	        "content": 'Slet omlagt dag'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.confirmDelete(item)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })])])])
	  })], 2)])], _vm._v(" "), (_vm.isModalOpen) ? _c('SpecialDayModal', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "schoolYearId": _vm.schoolYearId,
	      "specialDayId": _vm.editingId,
	      "klassCalendars": _vm.klassCalendars,
	      "defaultDate": _vm.schoolYearStartDate
	    },
	    on: {
	      "saved": _vm.onSaved,
	      "close": _vm.closeModal
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.subjectsForDay) ? _c('SpecialDaySubjectsModal', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "schoolYearId": _vm.schoolYearId,
	      "specialDay": _vm.subjectsForDay,
	      "klassCalendars": _vm.klassCalendars,
	      "existingSubjects": _vm.linkedSubjects(_vm.subjectsForDay)
	    },
	    on: {
	      "created": _vm.onSubjectsCreated,
	      "close": function($event) {
	        _vm.subjectsForDay = null
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.subjectsListForDay) ? _c('SpecialDaySubjectsListModal', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "schoolYearId": _vm.schoolYearId,
	      "specialDay": _vm.subjectsListForDay,
	      "klassCalendars": _vm.klassCalendars
	    },
	    on: {
	      "changed": _vm.onSubjectsChanged,
	      "create": _vm.openSubjectsFromList,
	      "close": function($event) {
	        _vm.subjectsListForDay = null
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isCalModalOpen) ? _c('SpecialDayCalendarModal', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "schoolYearId": _vm.schoolYearId,
	      "specialDayId": _vm.editingId,
	      "klassCalendars": _vm.klassCalendars,
	      "schoolYearStart": _vm.schoolYearStartDate,
	      "schoolYearEnd": _vm.schoolYearEndDate
	    },
	    on: {
	      "saved": _vm.onCalSaved,
	      "close": _vm.closeCalModal
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.deleting) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isShowConfirmDeleteMessage": false,
	      "isSubmitButtonLoading": _vm.isDeleting
	    },
	    on: {
	      "confirm": _vm.runDelete,
	      "close": function($event) {
	        _vm.deleting = null
	      }
	    }
	  }, [_c('template', {
	    slot: "item"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('vue2.special_days.confirm_delete_title')) + " " + _vm._s(_vm.deleting.title) + "?")]), _vm._v(" "), _c('p', {
	    staticClass: "special-days__confirm-text"
	  }, [_vm._v(_vm._s(_vm.formatPeriod(_vm.deleting)))]), _vm._v(" "), (_vm.linkedSubjects(_vm.deleting).length > 0) ? _c('div', {
	    staticClass: "special-days__confirm-subjects"
	  }, [_c('p', {
	    staticClass: "special-days__confirm-subjects__label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.linked_subjects')))]), _vm._v(" "), _c('table', {
	    staticClass: "special-days__confirm-subjects__table"
	  }, [_c('tbody', _vm._l((_vm.linkedSubjects(_vm.deleting)), function(subject) {
	    return _c('tr', {
	      key: subject.id,
	      staticClass: "special-days__confirm-subjects__row",
	      class: {
	        'special-days__confirm-subjects__row--disabled': !_vm.canDeleteSubject(subject)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleSubjectToDelete(subject)
	        }
	      }
	    }, [_c('td', {
	      staticClass: "special-days__confirm-subjects__check"
	    }, [_c('input', {
	      attrs: {
	        "type": "checkbox",
	        "disabled": !_vm.canDeleteSubject(subject)
	      },
	      domProps: {
	        "checked": _vm.subjectsToDelete.indexOf(subject.id) > -1
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	        },
	        "change": function($event) {
	          return _vm.toggleSubjectToDelete(subject)
	        }
	      }
	    })]), _vm._v(" "), _c('td', {
	      staticClass: "special-days__confirm-subjects__name"
	    }, [_c('span', {
	      staticClass: "special-days__confirm-subjects__dot",
	      style: ({
	        backgroundColor: subject.color
	      })
	    }), _vm._v("\n                " + _vm._s(subject.name) + "\n              ")]), _vm._v(" "), _c('td', {
	      staticClass: "special-days__confirm-subjects__note"
	    }, [(!_vm.canDeleteSubject(subject)) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.special_days.subject_cannot_delete')))]) : _vm._e()])])
	  }), 0)]), _vm._v(" "), _c('p', {
	    staticClass: "special-days__confirm-subjects__hint"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.subjects_delete_hint')))])]) : _vm._e()]), _vm._v(" "), _c('template', {
	    slot: "confirmText"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.delete')))])], 2) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 2088 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "to-user-tasks text-dark"
	  }, [_c('table', {
	    staticClass: "d-table marg-1-bottom d-table__overview"
	  }, _vm._l((_vm.tasksByMasterType), function(tasksType, prop) {
	    return _c('tbody', [_c('tr', {
	      staticClass: "tr-thead"
	    }, [_c('td', [_c('h4', [_vm._v(_vm._s(tasksType.title))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.belongs_to')))]), _vm._v(" "), _c('td', {
	      staticClass: "td-dates"
	    }, [(_vm.hasAnyDatesInGroup(tasksType)) ? [_vm._v("Dato")] : _vm._e()], 2), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')))])]), _vm._v(" "), _vm._l((tasksType.tasks), function(task) {
	      return _c('tr', {
	        key: task.id,
	        class: {
	          'to-user-tasks__row--editable': _vm.canEditTask(task)
	        },
	        attrs: {
	          "title": _vm.canEditTask(task) ? _vm.$t('vue2.common.edit') : null
	        },
	        on: {
	          "click": function($event) {
	            return _vm.onTaskClick(task)
	          }
	        }
	      }, [_c('td', [_vm._v(_vm._s(task.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getCalendarNames(task)))]), _vm._v(" "), _c('td', {
	        staticClass: "td-dates"
	      }, [_vm._v(_vm._s(_vm.formatDateRange(task.from_date, task.to_date)))]), _vm._v(" "), _c('td', {
	        staticClass: "is-number"
	      }, [(!_vm.getIsHideHours(task)) ? [_vm._v(_vm._s(_vm.formatHours(task.hours)))] : _vm._e()], 2)])
	    }), _vm._v(" "), (!_vm.getIsHideTotalHours(tasksType)) ? _c('tr', {
	      staticClass: "to-user_tasks__footer"
	    }, [_c('td', [_vm._v("I alt")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.formatHours(tasksType.totalHours)))])]) : _vm._e()], 2)
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2089 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.userHasPermissionToEdit) ? _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onPresenceClickaway),
	      expression: "onPresenceClickaway"
	    }],
	    staticClass: "user-presence inline-block",
	    class: [{
	      'user-presence__modal-left': _vm.isModalLeft
	    }, {
	      'user-presence__multiple-users': !_vm.calid
	    }]
	  }, [_c('button', {
	    staticClass: "up__button no-print",
	    class: {
	      'do-bttn': _vm.activeCalendarDate
	    },
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('vue2.presence.work_hours')) + "\n    "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInDown"
	    }
	  }, [(_vm.modal) ? _c('div', {
	    staticClass: "up-modal text-dark"
	  }, [_c('div', {
	    staticClass: "up-modal__header"
	  }, [_c('h2', {
	    staticClass: "text-blue"
	  }, [(!_vm.showWeekSelector) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.presence.set_work_hours')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.presence.choose_weeks_for_work_hours')))])]), _vm._v(" "), (!_vm.showWeekSelector && _vm.calid) ? _c('div', {
	    staticClass: "hint--left",
	    attrs: {
	      "aria-label": _vm.$t('vue2.presence.edit_default_times')
	    }
	  }, [_c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": _vm.openDefaultTimesSettings
	    }
	  }, [_c('span', {
	    staticClass: "icon-wrench"
	  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "up-modal__content",
	    class: {
	      'showweeks': _vm.showWeekSelector
	    }
	  }, [(_vm.isLoading) ? _c('div', {
	    staticStyle: {
	      "margin-bottom": "100px"
	    }
	  }, [_c('Spinner', {
	    attrs: {
	      "color": "blue"
	    }
	  })], 1) : _c('div', {
	    staticClass: "up-modal__content-slider",
	    class: {
	      'showweeks': _vm.showWeekSelector
	    }
	  }, [_c('div', {
	    class: {
	      'up-modal__content-slider--weekend-with-hours': _vm.hasWeekendEvents && !_vm.showWeekSelector
	    }
	  }, [_c('div', {
	    staticClass: "flex-table user-presence__table"
	  }, [_c('div', {
	    staticClass: "flex-tr flex-tr__header"
	  }, [_c('div', {
	    staticClass: "flex-td"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "flex-td"
	  }, [_c('span', {
	    staticClass: "text-normal"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.presence.work_hours_in_the_week')) + ":")]), _vm._v("\n                  " + _vm._s(_vm.durationAsHoursAndMin(_vm.totalDurationWeek)) + "\n                ")])]), _vm._v(" "), _vm._l((_vm.weekDays), function(weekDay) {
	    return _c('div', {
	      staticClass: "flex-tr tr-weekdays-hours"
	    }, [_c('div', {
	      staticClass: "flex-td flex-1 capitalize user-presence__table__first"
	    }, [_c('div', {
	      staticClass: "flex-td"
	    }, [_vm._v("\n                    " + _vm._s(_vm.$filters.dddd(weekDay)) + "\n                  ")]), _vm._v(" "), _c('div', {
	      staticClass: "flex-td"
	    }, [_c('button', {
	      class: {
	        'inactive': _vm.lastEventOfDayIsCloseToMidnight(weekDay)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.addEvent(weekDay)
	        }
	      }
	    }, [_c('span', [_vm._v("+")])])])]), _vm._v(" "), _c('div', {
	      staticClass: "flex-td flex-3 time-changer"
	    }, [_vm._l((_vm.events), function(event) {
	      return [(_vm.compareDates(event.start, weekDay)) ? [_c('EditEvent', {
	        key: event.id,
	        attrs: {
	          "event": event
	        },
	        on: {
	          "updateStart": _vm.updateStart,
	          "updateEnd": _vm.updateEnd,
	          "delete": _vm.deleteEvent,
	          "duration": _vm.setEventDurations
	        }
	      })] : _vm._e()]
	    })], 2)])
	  })], 2)]), _vm._v(" "), _c('div', [_c('WeekPicker', {
	    attrs: {
	      "date": _vm.activeCalendarDate,
	      "calid": _vm.calid
	    },
	    on: {
	      "weeks": _vm.setPastedWeeks,
	      "isWithinCalRange": _vm.setCurrentDateIsNotWithinCalendarRange
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "up-modal__footer"
	  }, [_c('button', {
	    staticClass: "bg-white",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.presence.cancel')) + "\n        ")]), _vm._v(" "), _c('div', [(_vm.intersections.length < 1) ? _c('div', [(!_vm.currentDateIsNotWithinCalendarRange) ? [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.showWeekSelector = !_vm.showWeekSelector
	      }
	    }
	  }, [(!_vm.showWeekSelector) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.presence.copy_to_multiple_weeks')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.presence.back')))])])] : _vm._e(), _vm._v(" "), (_vm.calid || _vm.pasteInWeeks.length > 0) ? _c('button', {
	    staticClass: "bg-white",
	    class: {
	      'bttn-passive': true
	    },
	    on: {
	      "click": _vm.savePresence
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.presence.save')) + "\n            ")]) : _vm._e()], 2) : _c('div', [_c('p', {
	    staticClass: "text-danger"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.presence.times_may_not_overlap')))])])])])]) : _vm._e()]), _vm._v(" "), (_vm.isShowSettings) ? _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true
	    },
	    on: {
	      "close": _vm.closeDefaultTimesSettings
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark",
	    staticStyle: {
	      "width": "400px"
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.presence.default_work_hours')))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": _vm.closeDefaultTimesSettings
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content text-dark"
	  }, [_c('label', {
	    staticClass: "d-input marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.standard_settings.set_default_start_and_endtime')))]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group-flex"
	  }, [_c('TimeChanger', {
	    attrs: {
	      "addClass": "presence-default-times",
	      "showIcon": true,
	      "inputWidth": 80,
	      "start": _vm.standardStartTime,
	      "end": _vm.standardEndTime,
	      "isFiveMinutesInterval": false
	    },
	    on: {
	      "updateStart": _vm.setStandardStartTime,
	      "updateEnd": _vm.setStandardEndTime
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "bttn bttn-simple marg-1-right",
	    on: {
	      "click": _vm.closeDefaultTimesSettings
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.submitStandardSettings
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])]) : _vm._e()], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2090 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.locale),
	      expression: "locale"
	    }],
	    attrs: {
	      "id": "locale-selector"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.locale = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.saveInLocalStorage]
	    }
	  }, _vm._l((_vm.langSorted), function(lang) {
	    return _c('option', {
	      domProps: {
	        "value": lang.code
	      }
	    }, [_vm._v("\n      " + _vm._s(lang.name)), (lang.nativeName && lang.nativeName.length > 0) ? _c('span', [_vm._v(" - ")]) : _vm._e(), _vm._v(_vm._s(lang.nativeName) + "\n    ")])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2091 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vimeo-container"
	  }, [_c('iframe', {
	    attrs: {
	      "src": _vm.videoSrc,
	      "frameborder": "0",
	      "allow": "autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media",
	      "allowfullscreen": "",
	      "title": "Guide til opgaveoversigt designeren"
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2092 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "to-live"
	  }, [(_vm.isLoading || !_vm.hasLoaded) ? _c('div', {
	    staticClass: "to-live__loader"
	  }, [_c('Loader', {
	    attrs: {
	      "bgColor": "#ffffff"
	    }
	  })], 1) : [(_vm.hasContent) ? _c('TaskOverviewUser', {
	    attrs: {
	      "user": _vm.user,
	      "version": _vm.liveVersion,
	      "showHeadline": false,
	      "canEditTasks": _vm.canEditTasks,
	      "canEditNotes": _vm.canEditNotes
	    },
	    on: {
	      "editTask": _vm.setEditSubject
	    }
	  }) : _c('p', {
	    staticClass: "to-live__empty text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_tasks']))])], _vm._v(" "), (_vm.isSubjectModal) ? _c('SubjectForm', {
	    attrs: {
	      "showModal": _vm.isSubjectModal,
	      "editSubject": _vm.editSubject,
	      "propIsLoading": _vm.isSubjectLoading,
	      "allowDanishPreparationFactorUi": true
	    },
	    on: {
	      "deleteSubject": _vm.deleteSubject,
	      "close": _vm.closeSubjectModal,
	      "updateSubject": _vm.updateSubject,
	      "saveAndShowTab": _vm.saveAndShowTab
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 2093 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ModalConfirmation', {
	    attrs: {
	      "isShowConfirmDeleteMessage": false,
	      "customWidth": "460px",
	      "ariaLabel": _vm.i18n.title
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('h3', {
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_vm._v(_vm._s(_vm.i18n.title))]), _vm._v(" "), _c('template', {
	    slot: "custom_warning"
	  }, [_c('p', {
	    staticClass: "spuc__intro"
	  }, [_vm._v(_vm._s(_vm.introText))]), _vm._v(" "), _c('table', {
	    staticClass: "spuc__table"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.i18n.calendar))]), _vm._v(" "), _c('th', {
	    staticClass: "spuc__num"
	  }, [_vm._v(_vm._s(_vm.i18n.current))]), _vm._v(" "), _c('th', {
	    staticClass: "spuc__num"
	  }, [_vm._v(_vm._s(_vm.i18n.new))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.poolRows), function(row) {
	    return _c('tr', {
	      key: row.calendarId
	    }, [_c('td', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
	      staticClass: "spuc__num spuc__old"
	    }, [_vm._v(_vm._s(row.hours))]), _vm._v(" "), _c('td', {
	      staticClass: "spuc__num spuc__newval"
	    }, [_vm._v(_vm._s(_vm.formattedNewHours))])])
	  }), 0)])]), _vm._v(" "), _c('template', {
	    slot: "confirm_buttons"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.$emit('subjectOnly')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n.only_subject))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn--submit",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.onUpdateAll.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n.update_all))])])], 2)
	},staticRenderFns: []}

/***/ }),
/* 2094 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true,
	      "placeInTop": true,
	      "pxFromTop": 1,
	      "ariaLabel": _vm.title
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal special-day-modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [(_vm.isLoadingExisting) ? _c('Loader') : [_c('div', {
	    staticClass: "do-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.name')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.title),
	      expression: "form.title"
	    }, {
	      name: "focus",
	      rawName: "v-focus"
	    }],
	    ref: "input_title",
	    staticClass: "d-input width-100",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('vue2.special_days.name_placeholder')
	    },
	    domProps: {
	      "value": (_vm.form.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.form, "title", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "do-input-group"
	  }, [_c('div', {
	    staticClass: "special-day-modal__label-row"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.classes')))]), _vm._v(" "), _c('button', {
	    staticClass: "special-day-modal__link",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.toggleAllClasses
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.allClassesSelected ? _vm.$t('vue2.special_days.clear') : _vm.$t('vue2.special_days.select_all')) + "\n            ")])]), _vm._v(" "), _c('DSelectCals', {
	    attrs: {
	      "items": _vm.klassCalendars,
	      "itemsSelected": _vm.selectedClasses,
	      "placeholder": _vm.$t('vue2.special_days.select_classes')
	    },
	    on: {
	      "update": _vm.onClassesUpdate
	    }
	  }), _vm._v(" "), (_vm.hasTriedSave && _vm.selectedClasses.length === 0) ? _c('p', {
	    staticClass: "special-day-modal__hint special-day-modal__hint--warning"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.special_days.no_classes_selected')) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-input-group-flex"
	  }, [_c('div', [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.start_date')))]), _vm._v(" "), _c('DateSelector', {
	    attrs: {
	      "date": _vm.startDateMoment,
	      "width100": true
	    },
	    on: {
	      "changed": _vm.onStartChanged
	    }
	  })], 1), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.end_date')))]), _vm._v(" "), _c('DateSelector', {
	    attrs: {
	      "date": _vm.endDateMoment,
	      "minDate": _vm.form.startDate,
	      "width100": true
	    },
	    on: {
	      "changed": _vm.onEndChanged
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "do-input-group do-input-group--toggler",
	    class: {
	      'do-input-group--toggler--active': _vm.form.reduct
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.form.reduct = !_vm.form.reduct
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.reduct')))]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.form.reduct
	    }
	  })], 1)]], 2), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div'), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "do-bttn",
	    attrs: {
	      "disabled": _vm.isSaving
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.special_days.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': !_vm.isValid || _vm.isSaving,
	      'do-bttn--submit--loading': _vm.isSaving
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.special_days.save')) + "\n        ")])])]), _vm._v(" "), (_vm.showRemovalWarning) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isShowConfirmDeleteMessage": false,
	      "appendToBody": true,
	      "isSubmitButtonLoading": _vm.isSaving
	    },
	    on: {
	      "confirm": _vm.confirmRemovalAndSave,
	      "close": function($event) {
	        _vm.showRemovalWarning = false
	      }
	    }
	  }, [_c('template', {
	    slot: "item"
	  }, [_c('h3', [_vm._v("Fjern klasser med brikker?")]), _vm._v(" "), _c('p', {
	    staticClass: "special-day-modal__warning__text"
	  }, [_vm._v("\n          Du fjerner klasser, der har brikker for denne omlagte dag: " + _vm._s(_vm.affectedRemovedClassNames.join(', ')) + ". Brikkerne slettes ikke automatisk.\n        ")])]), _vm._v(" "), _c('template', {
	    slot: "confirmText"
	  }, [_vm._v("Gem alligevel")])], 2) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2095 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "stil-guides"
	  }, [(_vm.isButton) ? _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isShowGuide = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-play"
	  }), _vm._v(" Se guide til indberetningen\n  ")]) : _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": function($event) {
	        _vm.isShowGuide = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.textForLink))]), _vm._v(" "), (_vm.isShowGuide) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true
	    },
	    on: {
	      "close": function($event) {
	        _vm.isShowGuide = false
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-embed",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-embed-container"
	  }, [_c('iframe', {
	    attrs: {
	      "src": _vm.videoLink,
	      "title": "YouTube video player",
	      "frameborder": "0",
	      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
	      "allowfullscreen": ""
	    }
	  })])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2096 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.taskCategory.title))]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        animateFill: false,
	        animation: 'shift-away',
	        onShow: function () { return _vm.isDateIntervalChanged; }
	      }),
	      expression: "{\n        animateFill: false,\n        animation : 'shift-away',\n      onShow: () => isDateIntervalChanged\n    }"
	    }],
	    staticClass: "is-number",
	    class: {
	      'is-number--calculated': _vm.isDateIntervalChanged
	    },
	    attrs: {
	      "content": _vm.schoolTooltipContent
	    }
	  }, [(_vm.isDateIntervalChanged) ? _c('span', {
	    staticClass: "icon-clock"
	  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.sumOfHours) + "\n  ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.sumOfActual))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n    " + _vm._s(_vm.sumOfDiff) + "\n  ")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2097 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "filters-container"
	  }, [_c('ul', {
	    ref: "dfilters",
	    staticClass: "filters"
	  }, [_c('div', {
	    staticClass: "filters__filter__activator",
	    style: ({
	      'left': _vm.left,
	      'width': _vm.width
	    })
	  }), _vm._v(" "), _vm._l((_vm.filters), function(filter, idx) {
	    return _c('li', {
	      staticClass: "filters__filter",
	      class: {
	        'filters__filter--active': _vm.isFilter(filter.value)
	      },
	      attrs: {
	        "id": 'filter_' + filter.value
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setFilter(filter)
	        }
	      }
	    }, [_vm._v("\n      " + _vm._s(filter.label) + "\n      "), _c('span', {
	      staticClass: "filter__length"
	    }, [_vm._v("(" + _vm._s(filter.length) + ")")])])
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2098 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "school-data"
	  }, [_c('div', {
	    staticClass: "school-data__header"
	  }, [_c('div', {
	    staticClass: "school-data__header__left"
	  }, [_c('h1', [_vm._v("Fraværets varighed")]), _vm._v(" "), _c('changeSchoolYear', {
	    staticClass: "marg-1-right",
	    attrs: {
	      "white-theme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "school-data__header__right"
	  }, [(!_vm.isDatesPristine) ? _c('p', {
	    staticClass: "d-link",
	    on: {
	      "click": _vm.resetDates
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), _c('Datepickerrange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  })], 1)]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
	    staticClass: "loader-container"
	  }, [_c('Loader'), _vm._v(" "), _c('h4', [_vm._v("Snup en kop kaffe, det kan tage et par minutter")])], 1) : [_c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n      Et fraværsforløb er sammenhængende hverdage med fravær for den samme medarbejder og den samme årsag.\n      Weekender afbryder ikke et forløb. Tallene viser antal forløb fordelt på, hvor mange dage de varede.\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "filters"
	  }, [_c('DoFiltersFilter', {
	    attrs: {
	      "title": "Årsager",
	      "tags": _vm.absenceReasons,
	      "selectedTags": _vm.selectedReasons
	    },
	    on: {
	      "select": _vm.toggleReason,
	      "clear": function($event) {
	        _vm.selectedReasons = []
	      }
	    }
	  })], 1), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Årsag")]), _vm._v(" "), _vm._l((_vm.buckets), function(bucket) {
	    return _c('th', {
	      key: bucket.id
	    }, [_vm._v(_vm._s(bucket.title))])
	  }), _vm._v(" "), _c('th', [_vm._v("Forløb i alt")]), _vm._v(" "), _c('th', [_vm._v("Fraværsdage i alt")]), _vm._v(" "), _c('th', [_vm._v("Personer")])], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.rows), function(row) {
	    return _c('tr', {
	      key: row.name,
	      class: {
	        'd-table__total': row.isTotal
	      }
	    }, [_c('td', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _vm._l((_vm.buckets), function(bucket) {
	      return _c('td', {
	        key: bucket.id
	      }, [_vm._v("\n          " + _vm._s(row.buckets[bucket.id]) + "\n          "), (row.buckets[bucket.id]) ? _c('span', {
	        staticClass: "d-table__share"
	      }, [_vm._v("(" + _vm._s(_vm.formatPercent(row.buckets[bucket.id], row.periods)) + ")")]) : _vm._e()])
	    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.periods))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.days))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.persons))])], 2)
	  }), _vm._v(" "), (_vm.rows.length < 2) ? _c('tr', [_c('td', {
	    staticClass: "text-center",
	    attrs: {
	      "colspan": _vm.buckets.length + 4
	    }
	  }, [_vm._v("Intet fravær i perioden")])]) : _vm._e()], 2)])]], 2)
	},staticRenderFns: []}

/***/ }),
/* 2099 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-modal__employment text-dark"
	  }, [_c('button', {
	    on: {
	      "click": _vm.openIsModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-pencil"
	  })]), _vm._v(" "), (_vm.isModal) ? _c('DModal', {
	    staticClass: "d-modal__employment-modal",
	    attrs: {
	      "showClose": false
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Ansættelser for " + _vm._s(_vm.userName))]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.closeIsModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body"
	  }, [(!_vm.isAllDoneLoading) ? _c('div', {
	    staticClass: "is-loading-container"
	  }, [_c('Loader', {
	    attrs: {
	      "isLoaderModal": true
	    }
	  })], 1) : [(_vm.userEmployments.length === 0) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen ansættelser oprettet")]) : _vm._e(), _vm._v(" "), (_vm.userEmployments.length > 0) ? _c('div', {
	    staticClass: "d-modal__employment__employments"
	  }, [_c('ul', [_c('li', {
	    staticClass: "d-modal__employment__employments__header"
	  }, [_c('div', [_vm._v("Ansættelse")]), _vm._v(" "), _c('div', [_vm._v("CPR NUMMER + EKSTRACIFFER")])]), _vm._v(" "), _vm._l((_vm.userEmploymentsWithTitle), function(userEmployment) {
	    return _c('li', {
	      key: userEmployment.id,
	      staticClass: "d-modal__employment__employments__employment"
	    }, [_c('div', {
	      staticClass: "d-modal__employment__employments__employment__container"
	    }, [_c('div', [_vm._v(_vm._s(userEmployment.title))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(userEmployment.employment_number))])]), _vm._v(" "), _c('span', {
	      staticClass: "icon__bg-circle icon__bg-circle--danger",
	      on: {
	        "click": function($event) {
	          return _vm.setDeleteEmployment(userEmployment)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })])])
	  }), _vm._v(" "), (_vm.userDeletedEmployments.length > 0) ? _c('li', {
	    staticClass: "text-blue text-link marg-1-bottom",
	    on: {
	      "click": function($event) {
	        _vm.isShowArchived = !_vm.isShowArchived
	      }
	    }
	  }, [(!_vm.isShowArchived) ? _c('span', [_vm._v("Se")]) : _vm._e(), (_vm.isShowArchived) ? _c('span', [_vm._v("Skjul")]) : _vm._e(), _vm._v(" tidligere ansættelser\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.deletedUserEmploymentsWithTitle), function(userEmployment) {
	    return (_vm.isShowArchived) ? _c('li', {
	      key: userEmployment.id,
	      staticClass: "d-modal__employment__employments__employment d-modal__employment__employments__employment--deleted"
	    }, [_c('div', {
	      staticClass: "d-modal__employment__employments__employment__container"
	    }, [_c('div', [_vm._v(_vm._s(userEmployment.title))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(userEmployment.employment_number))])])]) : _vm._e()
	  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [(!_vm.isCreateForm) ? _c('button', {
	    on: {
	      "click": function($event) {
	        return _vm.setIsCreateForm(true)
	      }
	    }
	  }, [_vm._v("Tilføj ansættelse")]) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "scaleIn",
	      "mode": "out-in"
	    }
	  }, [(_vm.isCreateForm) ? _c('div', {
	    staticClass: "d-modal__employment__form"
	  }, [_c('h4', [_vm._v("Tilføj ansættelse")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group-flex"
	  }, [_c('div', {
	    staticClass: "input-group flex-1 input-group__select"
	  }, [_c('label', [_vm._v("Ansættelsestype")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.createFormEmploymentTypeId),
	      expression: "createFormEmploymentTypeId"
	    }],
	    class: {
	      'input--error': _vm.formErrors['type']
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.createFormEmploymentTypeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.removeErrors('type')
	      }]
	    }
	  }, _vm._l((_vm.employmentTypesActive), function(employmentType) {
	    return _c('option', {
	      domProps: {
	        "value": employmentType.id
	      }
	    }, [_vm._v("\n                      " + _vm._s(employmentType.title) + "\n                    ")])
	  }), 0), _vm._v(" "), (_vm.formErrors['type']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['type']))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group flex-1"
	  }, [_c('label', [_vm._v("CPR nummer")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.createFormCPR),
	      expression: "createFormCPR",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    class: {
	      'input--error': _vm.formErrors['cpr']
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.createFormCPR)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('cpr')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.createFormCPR = $event.target.value.trim()
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['cpr']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['cpr']))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group flex-1 extra-ciffer-input"
	  }, [_c('label', [_vm._v("Ekstraciffer")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.createFormExtraCiffer),
	      expression: "createFormExtraCiffer",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    class: {
	      'input--error': _vm.formErrors['ciffer']
	    },
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.createFormExtraCiffer)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('ciffer')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.createFormExtraCiffer = $event.target.value.trim()
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['ciffer']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['ciffer']))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "marg-10-right",
	    on: {
	      "click": _vm.closeIsCreateForm
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.createEmployment
	    }
	  }, [_vm._v("Tilføj ansættelse")])])]) : _vm._e()])]], 2)])]) : _vm._e(), _vm._v(" "), (_vm.theDeleteEmployment) ? _c('DModal', {
	    attrs: {
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "d-modal__delete-employment",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Vil du slette ansættelsen?")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        _vm.theDeleteEmployment = null
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body"
	  }, [_c('p', [_vm._v("Vil du slette "), _c('b', [_c('i', [_vm._v(_vm._s(_vm.theDeleteEmployment.title))])]), _vm._v(" for " + _vm._s(_vm.userName))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "marg-10-right",
	    on: {
	      "click": function($event) {
	        _vm.theDeleteEmployment = null
	      }
	    }
	  }, [_vm._v("Nej")]), _vm._v(" "), _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.deleteEmployment
	    }
	  }, [_vm._v("Ja, slet ansættelsen")])])])])]) : _vm._e(), _vm._v(" "), (_vm.isModal) ? _c('div', {
	    staticClass: "bg-overlay"
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2100 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "lessons__filters"
	  }, [_c('Tabs', {
	    attrs: {
	      "tabs": _vm.tabsList,
	      "selected": _vm.activeFilter
	    },
	    on: {
	      "select": _vm.setFilter
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2101 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "d-table d-table__tasks marg-10-bottom",
	    class: {
	      'd-table--open': _vm.isOpen
	    }
	  }, [_c('thead', {
	    staticClass: "pointer acc-header",
	    on: {
	      "click": _vm.setIsOpen
	    }
	  }, [_c('tr', [_c('th', {
	    staticClass: "d-table__title"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
	    staticClass: "is-number d-table__thead__last"
	  }, [_c('div', {
	    staticClass: "number_and_acc"
	  }, [_vm._v("\n        " + _vm._s(_vm.showLessonsPerWeek ? _vm.sumOfLessonsPerWeek : _vm.sumOfHours) + "\n        "), (!_vm.isOpen) ? _c('span', {
	    staticClass: "icon-arrow-down4"
	  }) : _vm._e(), _vm._v(" "), (_vm.isOpen) ? _c('span', {
	    staticClass: "icon-arrow-up4"
	  }) : _vm._e()])])])]), _vm._v(" "), (_vm.isOpen) ? [_c('tbody', [(_vm.tasks.length < 1) ? _c('tr', [_c('td', {
	    staticStyle: {
	      "width": "90%"
	    }
	  }, [_c('div', {
	    staticClass: "italic",
	    staticStyle: {
	      "padding": "4px"
	    }
	  }, [_vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['no_subjects_assigned']))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedTasks), function(task) {
	    return _c('tr', {
	      key: task.id
	    }, [_c('td', [_c('div', {
	      staticClass: "task-with-edit",
	      on: {
	        "click": function($event) {
	          return _vm.setEditTask(task)
	        }
	      }
	    }, [(task.can_schedule || !task.hasOwnProperty('can_schedule')) ? _c('div', {
	      staticClass: "subjects_subject subjects_subject__simple",
	      style: ([{
	        'border-left-color': task.color
	      }, {
	        'background-color': task.color
	      }])
	    }, [_vm._v("\n            " + _vm._s(task.name) + "\n          ")]) : _c('div', {
	      staticClass: "subjects_subject subjects_subject--not-subject"
	    }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
	      staticClass: "td-calendars"
	    }, [(_vm.getShowCalendarIfNotOwn(task)) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.getShowCalendarIfNotOwn(task)) + "\n      ")]) : _vm._e()]), _vm._v(" "), (!task.hasOwnProperty('can_schedule')) ? _c('td', {
	      staticClass: "is-number subject-hours-for-person",
	      class: {
	        'subject-hours-for-person--is-modified': _vm.isSubjectHoursModified(task.id)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveSubject(task.id)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(_vm.showLessonsPerWeek ? task.vLessonsPerWeek : (task.vHours != null ? task.vHours.toFixed(1) : '–')) + "\n      ")]) : _c('td', {
	      staticClass: "is-number subject-hours-for-person",
	      class: {
	        'subject-hours-for-person--is-modified': _vm.getTaskSubjectId(task) && _vm.isSubjectHoursModified(_vm.getTaskSubjectId(task))
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveTaskSubject(task)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(_vm.showLessonsPerWeek ? task.vLessonsPerWeek : (task.vHours != null ? task.vHours.toFixed(1) : '–')) + "\n      ")])])
	  })], 2), _vm._v(" "), _c('tfoot', [(_vm.isOpen && _vm.tasksWithoutSubject.length > 0) ? [_c('tr', {
	    staticClass: "mini-table"
	  }, [_c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("Med brik")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    staticClass: "total-hours is-number"
	  }, [_vm._v("\n          " + _vm._s(_vm.showLessonsPerWeek ? _vm.sumOfLessonsWithSubject : _vm.sumOfHoursWithSubject) + "\n        ")])]), _vm._v(" "), _c('tr', {
	    staticClass: "mini-table"
	  }, [_c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("Uden brik")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    staticClass: "total-hours is-number"
	  }, [_vm._v("\n          " + _vm._s(_vm.showLessonsPerWeek ? _vm.sumOfLessonsWithoutSubject : _vm.sumOfHoursWithoutSubject) + "\n        ")])])] : _vm._e(), _vm._v(" "), _c('tr', {
	    staticClass: "tfoot-headline"
	  }, [_c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(!_vm.isPoolsDeactivated ? _vm.i18n[_vm.locale]['assigned'] : ''))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(!_vm.isPoolsDeactivated ? _vm.i18n[_vm.locale]['difference'] : ''))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.showLessonsPerWeek ? 'Lektioner' : _vm.i18n[_vm.locale]['time']))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(!_vm.isPoolsDeactivated ? (_vm.showLessonsPerWeek ? _vm.assignedLessonsPerWeek : _vm.assignedHours) : ''))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(!_vm.isPoolsDeactivated ? (_vm.showLessonsPerWeek ? _vm.getDiffLessons : _vm.getDiff) : ''))]), _vm._v(" "), _c('td', {
	    staticClass: "total-hours is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.showLessonsPerWeek ? _vm.sumOfLessonsPerWeek : _vm.sumOfHours) + "\n      ")])])], 2)] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 2102 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale].modal_title))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), (_vm.sms) ? _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "meta"
	  }, [_c('div', {
	    staticClass: "meta__row"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.i18n[_vm.locale].user) + ":")]), _vm._v(" " + _vm._s(_vm.activeUser && _vm.activeUser.name ? _vm.activeUser.name : '—'))]), _vm._v(" "), _c('div', {
	    staticClass: "meta__row"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.i18n[_vm.locale].sent) + ":")]), _vm._v(" " + _vm._s(_vm.humanTime))]), _vm._v(" "), _c('div', {
	    staticClass: "meta__row"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.i18n[_vm.locale].phone) + ":")]), _vm._v(" " + _vm._s(_vm.sms.phone || '—'))])]), _vm._v(" "), _c('div', {
	    staticClass: "message"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale].content))]), _vm._v(" "), _c('div', {
	    staticClass: "message__box"
	  }, [_vm._v(_vm._s(_vm.sms.message))])])]) : _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('i', [_vm._v(_vm._s(_vm.i18n[_vm.locale].no_previous))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].close))])])])])
	},staticRenderFns: []}

/***/ }),
/* 2103 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('d-select', {
	    attrs: {
	      "items": _vm.subsForSelect,
	      "itemsSelected": [],
	      "multiple": false,
	      "showSelectedUsers": false,
	      "placeholder": _vm.placeholder,
	      "addClass": _vm.addClass,
	      "isLoading": _vm.isLoading
	    },
	    on: {
	      "add": _vm.onAdd
	    },
	    scopedSlots: _vm._u([{
	      key: "occupied-item",
	      fn: function(ref) {
	        var item = ref.item;
	
	        return [(item.default_thumb_url) ? _c('img', {
	          attrs: {
	            "src": item.default_thumb_url,
	            "alt": ""
	          }
	        }) : _vm._e(), _vm._v(" "), _c('div', {
	          staticClass: "active-events-sub__meta"
	        }, [_c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	          staticClass: "active-events-sub__busy",
	          attrs: {
	            "title": item.occupiedTitles
	          }
	        }, [_c('span', {
	          staticClass: "icon-warning"
	        }), _vm._v("\n        " + _vm._s(item.occupiedLabel) + "\n      ")])])]
	      }
	    }])
	  })
	},staticRenderFns: []}

/***/ }),
/* 2104 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content_container",
	    attrs: {
	      "id": "djs-content-container"
	    }
	  }, [_c('docendo-connnection-indicator'), _vm._v(" "), _c('router-view', {
	    staticClass: "d-sidenav-active",
	    attrs: {
	      "name": "SideNav"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "page-width d-page-width",
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view', {
	    attrs: {
	      "name": "Header"
	    }
	  }), _vm._v(" "), _c('router-view', {
	    attrs: {
	      "name": "Navigation"
	    }
	  }), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('Toast')], 1)
	},staticRenderFns: []}

/***/ }),
/* 2105 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.noActiveSchoolYears) ? _c('div', {
	    staticClass: "banner"
	  }, [_c('div', {
	    staticClass: "banner__content"
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.common.no_active_school_years')))])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2106 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-filters"
	  }, [_c('div', {
	    staticClass: "do-filters__selected"
	  }, [_c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "propOffset": [0, 8],
	      "isCloseOnDropdownClick": false,
	      "closeFromProp": _vm.closeFromProp
	    },
	    on: {
	      "onClose": _vm.onCloseDropdown
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn__filter",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_c('span', {
	    staticClass: "icon-filter"
	  }), _vm._v("\n        " + _vm._s(_vm.resolvedTitle) + "\n        "), _c('div', {
	    staticClass: "do-filters__divider"
	  }), _vm._v(" "), (_vm.selectedTags.length === 0) ? _c('span', {
	    staticClass: "do-filters__selected-filters"
	  }, [_vm._v("\n          " + _vm._s(_vm.placeholder ? _vm.placeholder : _vm.i18n['select_filters']) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTags.length > _vm.numberOfSelectedTagsToShow) ? _c('span', {
	    staticClass: "do-badge"
	  }, [_vm._v("\n          " + _vm._s(_vm.selectedTags.length) + " " + _vm._s(_vm.i18n['selected']) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.selectedTags), function(selectedTag) {
	    return (_vm.selectedTags.length <= _vm.numberOfSelectedTagsToShow) ? _c('span', {
	      key: selectedTag,
	      staticClass: "do-badge"
	    }, [_vm._v("\n          " + _vm._s(selectedTag) + "\n        ")]) : _vm._e()
	  }), _vm._v(" "), (_vm.selectedTags.length > 0) ? _c('span', {
	    staticClass: "icon-cross2 do-filters__clear",
	    attrs: {
	      "title": _vm.i18n['clear_all']
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.clearAll.apply(null, arguments)
	      }
	    }
	  }) : _vm._e()], 2), _vm._v(" "), _c('ul', {
	    staticClass: "do-filters__filter__dropdown",
	    attrs: {
	      "slot": "list"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "list"
	  }, [_c('div', {
	    staticClass: "do-filters__filter__dropdown__header"
	  }, [(_vm.selectedTags.length === 0) ? _c('button', {
	    staticClass: "do-filters__button-transparent",
	    on: {
	      "click": _vm.selectAll
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['select_all']))]) : _c('button', {
	    staticClass: "do-filters__button-transparent",
	    on: {
	      "click": _vm.clearAll
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['clear_all']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.query),
	      expression: "query"
	    }, {
	      name: "focus",
	      rawName: "v-focus"
	    }],
	    attrs: {
	      "type": "search",
	      "placeholder": _vm.i18n['search_placeholder']
	    },
	    domProps: {
	      "value": (_vm.query)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.query = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _vm._l((_vm.filteredTags), function(item) {
	    return _c('li', {
	      key: item,
	      staticClass: "do-list-item",
	      on: {
	        "click": function($event) {
	          return _vm.select(item)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "do-checkbox",
	      class: {
	        'do-checkbox--selected': _vm.getIsItemSelected(item)
	      }
	    }), _vm._v("\n          " + _vm._s(item) + "\n        ")])
	  }), _vm._v(" "), (_vm.filteredTags.length === 0) ? _c('li', {
	    staticClass: "italic"
	  }, [_vm._v(_vm._s(_vm.i18n['no_results']))]) : _vm._e()], 2)])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2107 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-touch', {
	    on: {
	      "tap": function($event) {
	        return _vm.$emit('eventClicked', _vm.event.obj)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "day-cal__event",
	    class: {
	      'day-cal__event--is-canceled': _vm.event.obj.canceled
	    },
	    style: (_vm.styleObject)
	  }, [(_vm.event.obj.away || _vm.event.obj.canceled) ? _c('div', {
	    staticClass: "d-cal__event-meta d-cal__event-meta__fixed d-cal__event-meta--warning",
	    class: {
	      'd-cal__event-meta__fixed--canceled': _vm.event.obj.canceled
	    }
	  }, [(_vm.event.obj.canceled) ? _c('span', {
	    staticClass: "icon-notification22"
	  }) : _c('svg', {
	    staticClass: "tw-icon tw-icon--warning",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
	    }
	  })]), _vm._v("\n      " + _vm._s(_vm.getEventWarningLabel(_vm.event.obj)) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "day-cal__event__content"
	  }, [_c('span', [_vm._v(_vm._s(_vm.event.obj.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$filters.timeStamp(_vm.event.obj.start)) + " - " + _vm._s(_vm.$filters.timeStamp(_vm.event.obj.end)))]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.event.obj.has_notes),
	      expression: "event.obj.has_notes"
	    }],
	    staticClass: "notes-icon icon-file-text2"
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.event.obj.group),
	      expression: "event.obj.group"
	    }]
	  }, [_c('span', {
	    staticClass: "icon-users"
	  }), _vm._v(" " + _vm._s(_vm.event.obj.group))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.event.obj.teacher),
	      expression: "event.obj.teacher"
	    }]
	  }, [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.event.obj.teacher))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.event.obj.room),
	      expression: "event.obj.room"
	    }]
	  }, [_c('span', {
	    staticClass: "icon-location"
	  }), _vm._v(" " + _vm._s(_vm.event.obj.room))])]), _vm._v(" "), _c('div', {
	    staticClass: "day-cal__event__bg",
	    style: ({
	      backgroundColor: _vm.event.obj.color
	    })
	  }), _vm._v(" "), _c('div', {
	    staticClass: "day-cal__event__sider",
	    style: ({
	      backgroundColor: _vm.event.obj.color
	    })
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2108 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.sms.do_you_want_to_delete_the_template')) + "?")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.editsms.title))]), _vm._v(" "), _c('p', {
	    staticClass: "marg-1-bottom"
	  }, [_c('i', [_vm._v(_vm._s(_vm.editsms.body))])])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "bttn marg-10-right",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-danger",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.delete')))])])])])
	},staticRenderFns: []}

/***/ }),
/* 2109 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sms text-dark no-print text-dark"
	  }, [(!_vm.isOpen) ? _c('div', {
	    staticClass: "sms-header__toggler",
	    on: {
	      "click": function($event) {
	        return _vm.setOpen(!_vm.isOpen)
	      }
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']))]), _vm._v(" "), _c('div', {
	    staticClass: "close-icon sms-header__toggler__icon text-white"
	  }, [(_vm.isOpen) ? _c('span', {
	    staticClass: "icon-cross2"
	  }) : _c('span', {
	    staticClass: "icon-arrow-up4"
	  })])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "slideInUp"
	    },
	    on: {
	      "after-enter": _vm.onEnterComplete
	    }
	  }, [(_vm.isOpen) ? _c('div', {
	    staticClass: "sms-container"
	  }, [_c('div', {
	    staticClass: "sms-header__toggler",
	    on: {
	      "click": function($event) {
	        _vm.isOpen = !_vm.isOpen
	      }
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']))]), _vm._v(" "), _c('div', {
	    staticClass: "close-icon sms-header__toggler__icon text-white"
	  }, [(_vm.isOpen) ? _c('span', {
	    staticClass: "icon-cross2"
	  }) : _c('span', {
	    staticClass: "icon-arrow-up4"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "sms-body"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fadeOut"
	    }
	  }, [(_vm.noNumberForUser) ? _c('div', {
	    staticClass: "sms-body__signup"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    staticClass: "sms-body__signup__content box"
	  }, [_c('h2', {
	    staticClass: "text-blue"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['welcome_to_sms']))]), _vm._v(" "), _c('p', {
	    staticClass: "marg-10-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_your_number_to_send_sms']))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_your_number']))]), _vm._v("\n                " + _vm._s(_vm.user.phone) + "\n                "), _c('SmsAddNumber', {
	    staticClass: "marg-10-right",
	    attrs: {
	      "userid": _vm.user.id,
	      "updateThisUser": true,
	      "isEditFromStart": true
	    }
	  })], 1)])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "select-users"
	  }, [_c('div', {
	    staticClass: "users-header-second users-header-second__button"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--small",
	    on: {
	      "click": _vm.getSubsOfTheDay
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['todays_substitutes']) + "\n            ")]), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": '',
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters
	    },
	    on: {
	      "select": _vm.toggleTag,
	      "clear": _vm.clearAllTags
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchText),
	      expression: "searchText"
	    }],
	    staticClass: "users-header__searchfield",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('vue2.common.search')
	    },
	    domProps: {
	      "value": (_vm.searchText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchText = $event.target.value
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "list"
	  }, [_c('ul', {
	    staticClass: "users-list"
	  }, [_c('li', {
	    staticClass: "users-user users-user__header"
	  }, [(_vm.selectedUsers.length < 1) ? _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.setAllUsersSelected
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.tagging.select_all')) + "\n                ")]) : _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.removeAllSelectedUsers
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.tagging.unselect_all')) + "\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "users-user users-user__header__right"
	  }, [_c('p', {
	    staticClass: "last-sms-text last-sms-text--click",
	    on: {
	      "click": _vm.toggleSortByLast
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm.i18n[_vm.locale].last_sms) + "\n                    "), (_vm.sortMode === 'name') ? _c('span', {
	    staticClass: "icon-menu-open"
	  }) : _vm._e(), _vm._v(" "), (_vm.sortMode === 'last') ? _c('span', [_vm._v("▲")]) : _vm._e()]), _vm._v(" "), (_vm.isSMSActive) ? _c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['sms']))]) : _vm._e(), _vm._v(" "), (_vm.isEmailActive) ? _c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['email']))]) : _vm._e()])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? [(_vm.filteredUsers.length < 1) ? _c('p', {
	    staticClass: "pad-20"
	  }, [_c('i', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_users_matches']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user, idx) {
	    return _c('li', {
	      key: user.id,
	      ref: 'user_ ' + user.id,
	      refInFor: true,
	      staticClass: "users-user",
	      class: [{
	          'users-user--only': _vm.filteredUsers.length === 1
	        },
	        {
	          'isSelected': _vm.checkIfInList(user.id)
	        },
	        {
	          'user--has-no-active-contact': user.v_phone_setting !== 'active' && user.v_email_setting !== 'active'
	        },
	        {
	          'selectedWithoutContactForm': _vm.checkIfInListWithoutContactForm(user.id)
	        }
	      ]
	    }, [_c('div', {
	      staticClass: "users-user__meta",
	      on: {
	        "click": function($event) {
	          return _vm.setUser(user, idx, $event)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "users-choose",
	      class: {
	        'users-choose--disabled': user.v_phone_setting !== 'active' && user.v_email_setting !== 'active'
	      }
	    }, [_c('div', {
	      staticClass: "checkbox",
	      class: {
	        'checkboxChecked': _vm.checkIfInList(user)
	      }
	    }, [_c('span', {
	      staticClass: "checked"
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "users-img"
	    }, [_c('img', {
	      attrs: {
	        "src": user.img,
	        "alt": ""
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "users-name"
	    }, [_c('p', [_vm._v(_vm._s(user.name))]), _vm._v(" "), (user.v_last_sms_at) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'top'
	        }),
	        expression: "{\n                             arrow: true,\n                             placement : 'top'\n                           }"
	      }],
	      staticClass: "users__last-message",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['see_message']
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.showSent(user)
	        }
	      }
	    }, [_vm._v("\n                          " + _vm._s(user.v_last_sms_at_human) + "\n                      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	      staticClass: "users-last"
	    }, [_c('div', {
	      staticClass: "contact-options"
	    }, [(_vm.isSMSActive) ? _c('div', {
	      staticClass: "contact-options__option",
	      class: {
	        'contact-options__option--disabled': user.v_phone_setting === 'deactivated'
	      }
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true
	        }),
	        expression: "{\n                             arrow: true\n                           }"
	      }],
	      staticClass: "icon__bg-circle contact-options__option__phone",
	      attrs: {
	        "content": user.v_phone_tooltip
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setOption(user, 'phone')
	        }
	      }
	    }, [(user.v_phone_setting === 'no_number') ? _c('svg', {
	      staticClass: "d-hero-icon--add w-6 h-6",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M12 4.5v15m7.5-7.5h-15"
	      }
	    })]) : _vm._e(), _vm._v(" "), (user.v_phone_setting === 'active' || user.v_phone_setting === 'deactivated') ? _c('svg', {
	      staticClass: "d-hero-icon w-6 h-6",
	      class: {
	        'd-tw-icon--deactivated': user.v_phone_setting === 'deactivated'
	      },
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
	      }
	    })]) : _vm._e(), _vm._v(" "), (user.v_phone_setting === 'awaiting_approval') ? _c('svg', {
	      staticClass: "w-6 h-6 d-icon__awaiting-approval d-hero-icon",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
	      }
	    })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isEmailActive) ? _c('div', {
	      staticClass: "contact-options__option",
	      class: {
	        'contact-options__option--disabled': user.v_email_setting === 'deactivated'
	      }
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true
	        }),
	        expression: "{\n                             arrow: true\n                           }"
	      }],
	      staticClass: "icon__bg-circle",
	      attrs: {
	        "content": user.v_email_tooltip
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setOption(user, 'email')
	        }
	      }
	    }, [(user.v_email_setting === 'no_email') ? _c('svg', {
	      staticClass: "d-hero-icon--add w-6 h-6",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M12 4.5v15m7.5-7.5h-15"
	      }
	    })]) : _vm._e(), _vm._v(" "), (user.v_email_setting === 'active' || user.v_email_setting === 'deactivated') ? _c('svg', {
	      staticClass: "w-6 h-6",
	      class: {
	        'd-tw-icon--deactivated': user.v_email_setting === 'deactivated'
	      },
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
	      }
	    })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "contact-options__option contact-options__option__settings"
	    }, [_c('div', {
	      staticClass: "icon__bg-circle icon-more2",
	      on: {
	        "click": function($event) {
	          _vm.theActiveEditUser = user
	        }
	      }
	    })])])])])
	  })] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "send-sms"
	  }, [_c('div', {
	    staticClass: "users-header-second"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message_to']) + " " + _vm._s(_vm.selectedUsers.length))])]), _vm._v(" "), _c('div', {
	    staticClass: "send-sms__body"
	  }, [_c('div', {
	    staticClass: "send-sms__body__templates"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select_a_standard_template']))]), _vm._v(" "), (_vm.isLoadingTemplates) ? _c('div', [_c('spinner', {
	    attrs: {
	      "isSmall": true
	    }
	  })], 1) : _vm._l((_vm.templates), function(template) {
	    return _c('div', {
	      key: template.id,
	      staticClass: "standard-sms flex"
	    }, [_c('div', {
	      staticClass: "standard-sms__sub sms-template"
	    }, [_c('div', {
	      staticClass: "sms-template__title",
	      on: {
	        "click": function($event) {
	          return _vm.selectTemplate(template)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-file-text"
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(template.title))])]), _vm._v(" "), _c('d-dropdown', [_c('ul', {
	      attrs: {
	        "slot": "list"
	      },
	      slot: "list"
	    }, [_c('li', {
	      on: {
	        "click": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          return _vm.setTheEditTemplate(template)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('vue2.common.edit')))]), _vm._v(" "), _c('li', {
	      staticClass: "d-item-warning",
	      on: {
	        "click": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          _vm.theDeleteTemplate = template
	        }
	      }
	    }, [_vm._v("\n                        " + _vm._s(_vm.$t('vue2.common.delete')) + "\n                      ")])])])], 1)])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "standard-sms flex"
	  }, [_c('div', {
	    staticClass: "standard-sms__sub sms-template sms-template__create",
	    on: {
	      "click": function($event) {
	        _vm.isCreateTemplate = true
	      }
	    }
	  }, [_c('div', {
	    staticClass: "sms-template__title"
	  }, [_c('span', [_vm._v("+")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['create_a_standard_template']))])])])])], 2), _vm._v(" "), _c('div', {
	    staticClass: "send-sms__body__message"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['message']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.messageSubject),
	      expression: "messageSubject"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale]['subject']
	    },
	    domProps: {
	      "value": (_vm.messageSubject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.messageSubject = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.messageBody),
	      expression: "messageBody"
	    }],
	    ref: "sms",
	    staticClass: "marg-1-bottom marg-1-top",
	    class: {
	      'error-class': _vm.giveFeedback && _vm.noText
	    },
	    attrs: {
	      "placeholder": _vm.i18n[_vm.locale]['message']
	    },
	    domProps: {
	      "value": (_vm.messageBody)
	    },
	    on: {
	      "click": function($event) {
	        _vm.giveFeedback = false
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.messageBody = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.giveFeedback && _vm.noText) ? _c('span', {
	    staticClass: "error-text"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['message_must_be_filled']))]) : _vm._e(), _vm._v(" "), (_vm.noText || _vm.noReceiver) ? _c('button', {
	    staticClass: "submit-button width-100 submit-button--disabled",
	    on: {
	      "click": function($event) {
	        _vm.giveFeedback = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']) + "\n              ")]) : _c('button', {
	    staticClass: "submit-button width-100",
	    on: {
	      "click": _vm.sendMessage
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']) + "\n              ")])]), _vm._v(" "), _c('div', {
	    staticClass: "send-sms__body__receivers marg-1-left marg-1-right"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['recipients']))]), _vm._v(" "), (_vm.selectedUsers.length < 1) ? _c('p', {
	    staticClass: "explainer-text"
	  }, [_vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale]['select_recipients']))]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "receivers-container"
	  }, _vm._l((_vm.userSetSelected), function(user) {
	    return _c('li', {
	      staticClass: "receivers-container__receiver"
	    }, [_c('div', {
	      staticClass: "receiver__name"
	    }, [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('div', {
	      staticClass: "receiver__remove icon-cross2",
	      on: {
	        "click": function($event) {
	          return _vm.setUser(user, _vm.idx)
	        }
	      }
	    })])
	  }), 0)])])])], 1)]) : _vm._e()]), _vm._v(" "), (_vm.isCreateTemplate) ? _c('TemplateModal', {
	    attrs: {
	      "editsms": _vm.theEditTemplate,
	      "messageType": "email"
	    },
	    on: {
	      "close": _vm.closeTemplate,
	      "updated": _vm.readMessageTemplates
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theDeleteTemplate) ? _c('TemplateDelete', {
	    attrs: {
	      "editsms": _vm.theDeleteTemplate
	    },
	    on: {
	      "close": function($event) {
	        _vm.theDeleteTemplate = null
	      },
	      "updated": _vm.readMessageTemplates
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveEditUser) ? _c('SendMessagesUserSetting', {
	    attrs: {
	      "user": _vm.theActiveEditUser,
	      "isEmailActive": _vm.isEmailActive,
	      "isSMSActive": _vm.isSMSActive
	    },
	    on: {
	      "close": _vm.closeUserSetting
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowPastSMSes) ? _c('SendMessagesPastSmses', {
	    attrs: {
	      "activeUser": _vm.pastSmsModalUser,
	      "sms": _vm.pastSmsModalData
	    },
	    on: {
	      "close": function($event) {
	        _vm.isShowPastSMSes = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveEditUser) ? _c('div', {
	    staticClass: "bg-overlay"
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2110 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "showClose": false,
	      "isBgOverlay": true,
	      "isCloseOnBgClick": false,
	      "appendToBody": true,
	      "placeInTop": true,
	      "autoFocusField": false,
	      "isPrintable": true,
	      "ariaLabel": "Kvoter"
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('div', [_c('h2', [_vm._v("Kvoter")]), _vm._v(" "), _c('p', {
	    staticClass: "d-modal__subtitle"
	  }, [_vm._v("\n          Restkvote i KMD pr. " + _vm._s(_vm.quotaDateLabel) + ". Vælg en dato frem i tiden — f.eks. efter efterårsferien eller før påske — for at se, hvad der stadig skal afholdes inden udløb eller udbetaling.\n        ")])]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__date"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Restkvote pr.")]), _vm._v(" "), _c('DateSelector', {
	    attrs: {
	      "date": _vm.selectedDate
	    },
	    on: {
	      "changed": _vm.onDateChanged
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__select"
	  }, [(_vm.selectAll) ? _c('div', {
	    staticClass: "d-modal__all-selected"
	  }, [_c('span', [_vm._v("Alle medarbejdere"), (_vm.selectedUserCount > 0) ? _c('span', [_vm._v(" (" + _vm._s(_vm.selectedUserCount) + ")")]) : _vm._e()]), _vm._v(" "), _c('button', {
	    staticClass: "d-modal__all-selected__clear",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.clearSelectAll
	    }
	  }, [_vm._v("\n          Fravælg\n        ")])]) : [_c('DSelectUsers', {
	    attrs: {
	      "showTags": true,
	      "showCreateButton": false
	    },
	    on: {
	      "usersUpdated": _vm.onUsersUpdated
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn d-modal__select-all",
	    attrs: {
	      "type": "button",
	      "disabled": _vm.opusEmployments.length === 0
	    },
	    on: {
	      "click": _vm.selectAllUsers
	    }
	  }, [_vm._v("\n          Vælg alle\n        ")])]], 2), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__toolbar"
	  }, [_c('div', {
	    staticClass: "d-modal__toolbar__filters"
	  }, [(_vm.quotaTypes.length > 0) ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Kvotetype',
	      "tags": _vm.quotaTypes,
	      "selectedTags": _vm.selectedQuotaTypes,
	      "numberOfSelectedTagsToShow": 1,
	      "placeholder": 'Vælg kvotetype'
	    },
	    on: {
	      "select": _vm.toggleQuotaType,
	      "clear": function($event) {
	        _vm.selectedQuotaTypes = []
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.hasLoaded) ? _c('span', {
	    staticClass: "d-modal__count"
	  }, [_vm._v("\n          Viser " + _vm._s(_vm.filteredRows.length) + " af " + _vm._s(_vm.allRows.length) + " kvoter\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    class: {
	      'do-bttn--loading': _vm.isDownloadingExcel
	    },
	    attrs: {
	      "disabled": _vm.isLoading || _vm.isDownloadingExcel || _vm.filteredRows.length === 0
	    },
	    on: {
	      "click": _vm.downloadExcel
	    }
	  }, [_vm._v("\n        Download til excel\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [(!_vm.hasSelection) ? _c('p', {
	    staticClass: "d-modal__empty"
	  }, [_vm._v("\n        Vælg medarbejdere, en gruppe eller alle for at hente kvoter.\n      ")]) : (_vm.isLoading) ? _c('div', {
	    staticClass: "d-modal__status"
	  }, [_c('Loader', {
	    attrs: {
	      "isSmall": true
	    }
	  }), _vm._v(" "), (_vm.totalCount > 0) ? _c('p', {
	    staticClass: "d-modal__progress"
	  }, [_vm._v("\n          Henter kvoter… " + _vm._s(_vm.loadedCount) + " / " + _vm._s(_vm.totalCount) + " ansættelser\n        ")]) : _vm._e()], 1) : (_vm.errorMessage) ? _c('div', {
	    staticClass: "d-modal__error"
	  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : (_vm.hasLoaded && _vm.allRows.length === 0) ? _c('p', {
	    staticClass: "d-modal__empty"
	  }, [_vm._v("\n        Der blev ikke fundet nogen kvoter.\n      ")]) : (_vm.hasLoaded && _vm.filteredRows.length === 0) ? _c('p', {
	    staticClass: "d-modal__empty"
	  }, [_vm._v("\n        Ingen kvoter matcher de valgte filtre.\n      ")]) : _c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'userName'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('userName')
	      }
	    }
	  }, [_vm._v("\n            Navn "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), (_vm.hasGroupLabels) ? _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'userTagsLabel'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('userTagsLabel')
	      }
	    }
	  }, [_vm._v("\n            Grupper "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'employmentLabel'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('employmentLabel')
	      }
	    }
	  }, [_vm._v("\n            Ansættelse "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'quotaType'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('quotaType')
	      }
	    }
	  }, [_vm._v("\n            Kontotype "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter is-number",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'balance'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('balance')
	      }
	    }
	  }, [_vm._v("\n            Saldo "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter is-number",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'used'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('used')
	      }
	    }
	  }, [_vm._v("\n            Brugt "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter is-number",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'difference'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('difference')
	      }
	    }
	  }, [_vm._v("\n            Forskel "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortBy === 'periodLabel'
	    },
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSort('periodLabel')
	      }
	    }
	  }, [_vm._v("\n            Afholdelsesperiode "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredRows), function(row) {
	    return _c('tr', {
	      key: row.id
	    }, [_c('td', [_vm._v(_vm._s(row.userName))]), _vm._v(" "), (_vm.hasGroupLabels) ? _c('td', [_vm._v(_vm._s(row.userTagsLabel))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.employmentLabel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.quotaType))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(row.balance)))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(row.used)))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(row.difference)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.periodLabel))])])
	  }), 0)]), _vm._v(" "), (_vm.warningMessage) ? _c('p', {
	    staticClass: "d-modal__warning"
	  }, [_vm._v(_vm._s(_vm.warningMessage))]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 2111 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-create-task-for-user"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [(_vm.isEditing) ? _c('h2', [_vm._v("Redigér stillingskategori")]) : _c('h2', [_vm._v("Opret ny stillingskategori")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Titel")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    ref: "input_title",
	    staticClass: "d-input",
	    attrs: {
	      "type": "text",
	      "placeholder": "F.eks. Lærer"
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.title = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (!_vm.forceHourLimitMode && !_vm.hasHourLimit) ? _c('div', {
	    staticClass: "uv-limit-box"
	  }, [_c('div', {
	    staticClass: "d-input-group d-input-group--toggler uv-limit-box__toggle",
	    class: {
	      'd-input-group--toggler--active': _vm.localManualSalary
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setIsManualSalary(!_vm.localManualSalary)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Skal indberettes som vikarløn")]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.localManualSalary
	    }
	  })], 1), _vm._v(" "), (_vm.localManualSalary) ? _c('div', {
	    staticClass: "uv-limit-box__fields"
	  }, [_c('div', {
	    staticClass: "d-input-group-flex"
	  }, [_c('div', [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Standard lønkode")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.salaryCodeId),
	      expression: "salaryCodeId"
	    }],
	    staticClass: "do-select width-100",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.salaryCodeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "value": ""
	    }
	  }), _vm._v(" "), _vm._l((_vm.salaryCodes), function(salaryCode) {
	    return _c('option', {
	      key: salaryCode.id,
	      domProps: {
	        "value": salaryCode.id
	      }
	    }, [_vm._v("\n                  " + _vm._s(_vm.salaryCodeLabel(salaryCode)) + "\n                ")])
	  })], 2)]), _vm._v(" "), (_vm.costCenters.length > 0) ? _c('div', [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Standard omkostningsted")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.omkostningssted),
	      expression: "omkostningssted"
	    }],
	    staticClass: "do-select width-100",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.omkostningssted = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "value": ""
	    }
	  }), _vm._v(" "), _vm._l((_vm.costCenters), function(costCenter) {
	    return _c('option', {
	      key: costCenter.code,
	      domProps: {
	        "value": costCenter.code
	      }
	    }, [_vm._v("\n                  " + _vm._s(costCenter.title) + "\n                ")])
	  })], 2)]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.localManualSalary) ? _c('div', {
	    staticClass: "uv-limit-box"
	  }, [_c('div', {
	    staticClass: "d-input-group d-input-group--toggler uv-limit-box__toggle",
	    class: {
	      'd-input-group--toggler--active': _vm.hasHourLimit
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleHasHourLimit.apply(null, arguments)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Sæt UV-grænse (§ 5, stk. 2)")]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.hasHourLimit
	    }
	  })], 1), _vm._v(" "), (_vm.hasHourLimit) ? _c('div', {
	    staticClass: "uv-limit-box__fields"
	  }, [_c('div', {
	    staticClass: "d-input-group-flex"
	  }, [_c('div', [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("UV-grænse")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.hourLimit),
	      expression: "hourLimit"
	    }],
	    ref: "input_hour_limit",
	    staticClass: "d-input width-100",
	    attrs: {
	      "type": "number",
	      "min": "0",
	      "step": "1",
	      "placeholder": "F.eks. 750"
	    },
	    domProps: {
	      "value": (_vm.hourLimit)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hourLimit = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Lønkode over UV-grænse")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.hourLimitSalaryCodeId),
	      expression: "hourLimitSalaryCodeId"
	    }],
	    staticClass: "do-select width-100",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.hourLimitSalaryCodeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "value": ""
	    }
	  }), _vm._v(" "), _vm._l((_vm.salaryCodes), function(salaryCode) {
	    return _c('option', {
	      key: salaryCode.id,
	      domProps: {
	        "value": salaryCode.id
	      }
	    }, [_vm._v("\n                  " + _vm._s(_vm.salaryCodeLabel(salaryCode)) + "\n                ")])
	  })], 2)])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.localManualSalary && _vm.hasSpecialSalaryCode && !_vm.isSalarySystemSD) ? _c('div', {
	    staticClass: "uv-limit-box"
	  }, [_c('div', {
	    staticClass: "d-input-group d-input-group--toggler uv-limit-box__toggle",
	    class: {
	      'd-input-group--toggler--active': _vm.hasSpecialHourLimit
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleHasSpecialHourLimit.apply(null, arguments)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Specialskole uv-tillæg (§ 5, stk. 4)")]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.hasSpecialHourLimit
	    }
	  })], 1), _vm._v(" "), (_vm.hasSpecialHourLimit) ? _c('div', {
	    staticClass: "uv-limit-box__fields"
	  }, [_c('div', {
	    staticClass: "d-input-group-flex"
	  }, [_c('div', [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Lønkode spec-skole UV-tillæg")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.specialHourLimitSalaryCodeId),
	      expression: "specialHourLimitSalaryCodeId"
	    }],
	    staticClass: "do-select width-100",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.specialHourLimitSalaryCodeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }), _vm._v(" "), _vm._l((_vm.salaryCodes), function(salaryCode) {
	    return _c('option', {
	      key: salaryCode.id,
	      domProps: {
	        "value": salaryCode.id
	      }
	    }, [_vm._v("\n                  " + _vm._s(_vm.salaryCodeLabel(salaryCode)) + "\n                ")])
	  })], 2)])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isSalarySystemSD) ? _c('div', {
	    staticClass: "uv-limit-box"
	  }, [_c('div', {
	    staticClass: "d-input-group d-input-group--toggler uv-limit-box__toggle",
	    class: {
	      'd-input-group--toggler--active': _vm.enableEmploymentDecimal
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.enableEmploymentDecimal = !_vm.enableEmploymentDecimal
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Indsend lønbrøk")]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.enableEmploymentDecimal
	    }
	  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', [(_vm.isEditing) ? [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'top',
	        animateFill: false,
	        animation: 'shift-away',
	        boundary: 'window',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n              arrow: true,\n              placement: 'top',\n              animateFill: false,\n              animation: 'shift-away',\n              boundary: 'window',\n              zIndex: 12312312312312\n            }"
	    }],
	    staticClass: "do-bttn",
	    class: {
	      'do-bttn--submit--loading': _vm.isDeleting,
	      'do-bttn--delete-confirm': _vm.confirmingDelete,
	      'do-bttn--delete-disabled': _vm.isTemplateInUse || _vm.isLoadingUsage
	    },
	    attrs: {
	      "content": _vm.deleteButtonTitle
	    },
	    on: {
	      "click": _vm.onDeleteClick
	    }
	  }, [(_vm.confirmingDelete) ? _c('span', [_vm._v("Bekræft sletning")]) : _c('span', {
	    staticClass: "icon-bin"
	  })]), _vm._v(" "), (_vm.confirmingDelete && !_vm.isDeleting) ? _c('button', {
	    staticClass: "delete-cancel",
	    on: {
	      "click": function($event) {
	        _vm.confirmingDelete = false
	      }
	    }
	  }, [_vm._v("\n            Fortryd\n          ")]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--disabled': !_vm.isValid || _vm.isSubmitting,
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.onSubmit
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.isEditing ? 'Opdatér' : 'Opret') + "\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2112 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "annual-norm text-dark"
	  }, [_c('div', {
	    staticClass: "d-header"
	  }, [_c('div', {
	    staticClass: "d-header__left"
	  }, [_c('h1', [_vm._v("Årsnorm")]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1)]), _vm._v(" "), (_vm.isLoading && !_vm.isUpdatingTasks) ? _c('Loader') : [_c('div', {
	    staticClass: "d-tabs"
	  }, [_c('div', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': !_vm.viewIsResult
	    },
	    on: {
	      "click": function($event) {
	        _vm.viewIsResult = false
	      }
	    }
	  }, [_vm._v("\n        Tildel opgaver\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': _vm.viewIsResult
	    },
	    on: {
	      "click": function($event) {
	        _vm.viewIsResult = true
	      }
	    }
	  }, [_vm._v("\n        Se opgørelse\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs__container"
	  }, [(_vm.viewIsResult) ? [_c('AnnualNormResult', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "users": _vm.userWithProps
	    },
	    on: {
	      "setIsShowEmploymentEnded": _vm.setIsShowEmploymentEnded
	    }
	  })] : _c('div', {
	    staticClass: "annual-norm__body"
	  }, [_c('div', {
	    staticClass: "annual-norm__body__left"
	  }, [_c('AssignHoursNorm', {
	    staticClass: "marg-1-bottom",
	    attrs: {
	      "isKindergarten": true
	    },
	    on: {
	      "updateUsersHours": _vm.readAssignedHours
	    }
	  }), _vm._v(" "), _c('ul', _vm._l((_vm.userWithProps), function(user) {
	    return _c('li', {
	      key: user.user_calendar_id,
	      staticClass: "user-item",
	      class: {
	        'user-item--active': user.v_is_active_user
	      }
	    }, [_c('div', {
	      staticClass: "user-item__body",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveUserId(user.id)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "user-item__name"
	    }, [(user.default_thumb_url) ? _c('img', {
	      staticClass: "user-item__name__img",
	      attrs: {
	        "src": user.default_thumb_url,
	        "alt": ""
	      }
	    }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('div', {
	      staticClass: "user-item__right"
	    }, [_c('div', {
	      staticClass: "user-item__hours"
	    }, [_c('p', [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v("Arb. tid")]), _c('span', [_vm._v(_vm._s(user.v_assigned_total_hours))])]), _vm._v(" "), _c('p', [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v("Uden børn")]), _c('span', [_vm._v(_vm._s(user.v_total_without_kids))])]), _vm._v(" "), _c('p', [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v("Med børn")]), _c('span', [_vm._v(_vm._s(user.v_total_with_kids))])])]), _vm._v(" "), _c('div', {
	      staticClass: "user-item__arrow"
	    }, [(!user.v_is_active_user) ? _c('span', {
	      staticClass: "icon-arrow-right4"
	    }) : _c('span', {
	      staticClass: "icon-arrow-down4"
	    })])])]), _vm._v(" "), (user.v_is_active_user) ? _c('div', {
	      staticClass: "user-item__tasks"
	    }, [(!_vm.activeNorm) ? _c('Loader', {
	      attrs: {
	        "isSmall": true,
	        "bg-color": "#fff"
	      }
	    }) : _c('table', {
	      staticClass: "d-table d-table__norm d-table__tasks marg-10-bottom"
	    }, [_c('thead', [_c('tr', [_c('th', {
	      staticClass: "d-table__title",
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_c('h4', [_vm._v("Norm")])])])]), _vm._v(" "), _c('tbody', [(_vm.activeNorm.length < 1) ? _c('tr', [_c('td', [_vm._v("Ingen opgaver uden børn")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeNormFormatted), function(item) {
	      return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.value))])])
	    })], 2)]), _vm._v(" "), _c('table', {
	      staticClass: "d-table d-table__tasks marg-10-bottom"
	    }, [_c('thead', [_c('tr', [_c('th', {
	      staticClass: "d-table__title",
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_c('h4', [_vm._v("Opgaver uden børn")])])])]), _vm._v(" "), _c('tbody', [(user.v_user_tasks_without_kids.length < 1) ? _c('tr', [_c('td', [_vm._v("Ingen opgaver uden børn")])]) : _vm._e(), _vm._v(" "), _vm._l((user.v_user_tasks_without_kids), function(task) {
	      return _c('tr', {
	        key: task.id
	      }, [_c('td', [_c('div', {
	        staticClass: "task-with-edit"
	      }, [(task.can_schedule || !task.hasOwnProperty('can_schedule')) ? _c('div', {
	        staticClass: "subjects_subject subjects_subject__simple",
	        style: ([{
	          'border-left-color': task.color
	        }, {
	          'background-color': task.color
	        }])
	      }, [_vm._v("\n                          " + _vm._s(task.name) + "\n                        ")]) : _c('div', {
	        staticClass: "subjects_subject subjects_subject--not-subject"
	      }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
	        staticClass: "is-number"
	      }, [_vm._v("\n                      " + _vm._s(task.hours) + "\n                    ")])])
	    })], 2)]), _vm._v(" "), _c('table', {
	      staticClass: "d-table d-table__tasks marg-10-bottom"
	    }, [_c('thead', [_c('tr', [_c('th', {
	      staticClass: "d-table__title",
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_c('h4', [_vm._v("Opgaver med børn")])])])]), _vm._v(" "), _c('tbody', [(user.v_user_tasks_with_kids.length < 1) ? _c('tr', [_c('td', [_vm._v("Ingen opgaver med børn")])]) : _vm._e(), _vm._v(" "), _vm._l((user.v_user_tasks_with_kids), function(task) {
	      return _c('tr', {
	        key: task.id
	      }, [_c('td', [_c('div', {
	        staticClass: "task-with-edit"
	      }, [(task.can_schedule || !task.hasOwnProperty('can_schedule')) ? _c('div', {
	        staticClass: "subjects_subject subjects_subject__simple",
	        style: ([{
	          'border-left-color': task.color
	        }, {
	          'background-color': task.color
	        }])
	      }, [_vm._v("\n                          " + _vm._s(task.name) + "\n                        ")]) : _c('div', {
	        staticClass: "subjects_subject subjects_subject--not-subject"
	      }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
	        staticClass: "is-number"
	      }, [_vm._v("\n                      " + _vm._s(task.hours) + "\n                    ")])])
	    })], 2)])], 1) : _vm._e()])
	  }), 0)], 1), _vm._v(" "), _c('div', {
	    staticClass: "annual-norm__body__right"
	  }, [_c('div', {
	    staticClass: "annual-norm__body__right__header"
	  }, [_c('div', {
	    staticClass: "flipper-buttons"
	  }, [_c('button', {
	    staticClass: "flipper-buttons__button",
	    class: {
	      'active': _vm.isTasksView
	    },
	    on: {
	      "click": function($event) {
	        _vm.isTasksView = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-file-text"
	  }), _vm._v("\n                Uden børn\n              ")]), _vm._v(" "), _c('button', {
	    staticClass: "flipper-buttons__button",
	    class: {
	      'active': !_vm.isTasksView
	    },
	    on: {
	      "click": function($event) {
	        _vm.isTasksView = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-year-planning"
	  }), _vm._v("\n                Med børn\n              ")])])]), _vm._v(" "), (!_vm.isTasksView) ? _c('AnnualNormWithKids') : _vm._e(), _vm._v(" "), (_vm.isTasksView) ? _c('AnnualNormWithoutKids') : _vm._e()], 1)])], 2)], _vm._v(" "), (_vm.isShowEmploymentEnded) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsShowEmploymentEnded(false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "do-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2', [_vm._v("Brudt ansættelse")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowEmploymentEnded(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [_c('AssignHoursEmploymentEnded', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "users": _vm.userWithProps
	    }
	  })], 1)])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-modal"
	    }
	  }, [(_vm.isConfirmDeletion) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$store.commit('setConfirmDeletion', false)
	      },
	      "confirm": _vm.confirmDelete
	    }
	  }, [_c('h3', {
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_vm._v(_vm._s(_vm.itemToDelete.name))])]) : _vm._e()], 1)], 2)
	},staticRenderFns: []}

/***/ }),
/* 2113 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "salary-rules__rule-container"
	  }, [_c('div', {
	    staticClass: "d-input-group--toggler",
	    class: {
	      'd-input-group--toggler--active': _vm.isOn
	    },
	    on: {
	      "click": _vm.setIsOn
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("\n      Skal vikaren have ekstra løn før første lektion?\n    ")]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isOn
	    }
	  })], 1), _vm._v(" "), (_vm.isOn) ? _c('div', {
	    staticClass: "d-groups"
	  }, [_vm._l((_vm.atStartOfDay), function(timeItem, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "d-groups__group"
	    }, [_c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: false,
	          placement: 'right'
	        }),
	        expression: "{\n                  arrow: false,\n                  placement : 'right'\n                }"
	      }],
	      staticClass: "icon__bg-circle icon__bg-circle--danger d-groups__group__delete-item",
	      attrs: {
	        "content": 'Slet dette starttidspunkt'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.deleteItem(index)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "d-group"
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v("Angiv tidspunkt for første lektion")]), _vm._v(" "), _c('input', {
	      staticClass: "d-input",
	      attrs: {
	        "type": "time"
	      },
	      domProps: {
	        "value": timeItem.time
	      },
	      on: {
	        "input": function($event) {
	          return _vm.updateTime($event, index)
	        }
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "d-group"
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v("Hvor mange minutter skal vikaren have ekstra?")]), _vm._v(" "), _c('input', {
	      staticClass: "d-input",
	      attrs: {
	        "type": "number"
	      },
	      domProps: {
	        "value": timeItem.minutes
	      },
	      on: {
	        "input": function($event) {
	          return _vm.updateMinutes($event, index)
	        }
	      }
	    })])])
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn-trans",
	    on: {
	      "click": _vm.addTime
	    }
	  }, [_vm._v("+ Tilføj starttidspunkt")])], 2) : _vm._e(), _vm._v(" "), (_vm.isOn) ? _c('SalaryRulesRule', {
	    attrs: {
	      "subjectType": _vm.subjectType,
	      "propSelectedEmploymentTypeId": _vm.selectedEmploymentTitle
	    },
	    on: {
	      "change": _vm.setRuleEmployment
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isChangesMade) ? _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.onSubmit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2114 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "salary-rules__rule-container"
	  }, [_c('div', {
	    staticClass: "d-input-group--toggler",
	    class: {
	      'd-input-group--toggler--active': _vm.isOn
	    },
	    on: {
	      "click": _vm.setIsOn
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("\n      Skal vikaren have et minimum antal timer om dagen\n    ")]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isOn
	    }
	  })], 1), _vm._v(" "), (_vm.isOn) ? _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Hvor mange minutter skal vikaren minimum have?")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.minutes),
	      expression: "minutes"
	    }],
	    ref: "input_number",
	    staticClass: "d-input",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.minutes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.minutes = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.isOn) ? _c('SalaryRulesRule', {
	    attrs: {
	      "subjectType": _vm.subjectType,
	      "propSelectedEmploymentTypeId": _vm.selectedEmploymentTypeId
	    },
	    on: {
	      "change": _vm.setRuleEmployment
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isChangesMade) ? _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.onSubmit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2115 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "salary-rules__rule-container"
	  }, [_c('div', {
	    staticClass: "d-input-group--toggler",
	    class: {
	      'd-input-group--toggler--active': _vm.isOn
	    },
	    on: {
	      "click": _vm.setIsOn
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("\n      Skal mellemtimer automatisk give tid\n    ")]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isOn
	    }
	  })], 1), _vm._v(" "), (_vm.isOn) ? _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Hvor mange minutter skal mellemtimen max være?")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.minutes),
	      expression: "minutes"
	    }],
	    ref: "input_number",
	    staticClass: "d-input",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.minutes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.minutes = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.isOn) ? _c('SalaryRulesRule', {
	    attrs: {
	      "subjectType": _vm.subjectType,
	      "propSelectedEmploymentTypeId": _vm.selectedEmploymentTypeId
	    },
	    on: {
	      "change": _vm.setRuleEmployment
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isChangesMade) ? _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.onSubmit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2116 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "salary-rules__rule-container"
	  }, [(_vm.rules.length === 0) ? _c('h4', {
	    staticClass: "text-explainer",
	    staticStyle: {
	      "margin-top": "0"
	    }
	  }, [_vm._v("Ingen regler oprettet")]) : _vm._e(), _vm._v(" "), _c('draggable', {
	    staticClass: "salary-rules__rule-container__draggable",
	    on: {
	      "change": _vm.onChangeOrder
	    },
	    model: {
	      value: (_vm.rules),
	      callback: function($$v) {
	        _vm.rules = $$v
	      },
	      expression: "rules"
	    }
	  }, [_c('transition-group', {
	    attrs: {
	      "type": "transition",
	      "name": "flip-list",
	      "tag": "ul"
	    }
	  }, _vm._l((_vm.rules), function(rule, key) {
	    return _c('li', {
	      key: rule.id,
	      staticClass: "salary-rules__rule"
	    }, [_c('div', [_vm._v(_vm._s(key + 1))]), _vm._v(" "), _c('div', [_vm._v("\n          Hvis\n        ")]), _vm._v(" "), _c('div', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (rule.type),
	        expression: "rule.type"
	      }],
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(rule, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, function($event) {
	          return _vm.onChangeRuleType(rule, $event.target.value)
	        }]
	      }
	    }, _vm._l((_vm.ruleTypes), function(ruleType) {
	      return _c('option', {
	        domProps: {
	          "value": ruleType.value
	        }
	      }, [_vm._v("\n              " + _vm._s(ruleType.title) + "\n            ")])
	    }), 0)]), _vm._v(" "), (rule.type === 'employment_type') ? _c('div', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (rule.substituted_employment_title),
	        expression: "rule.substituted_employment_title"
	      }],
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(rule, "substituted_employment_title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, _vm.onChange]
	      }
	    }, _vm._l((_vm.employmentsTypesForFullTime), function(employmentsType) {
	      return _c('option', {
	        domProps: {
	          "value": employmentsType
	        }
	      }, [_vm._v("\n              " + _vm._s(employmentsType) + "\n            ")])
	    }), 0)]) : _vm._e(), _vm._v(" "), (rule.type === 'subject_type') ? _c('div', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (rule.subject_type),
	        expression: "rule.subject_type"
	      }],
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(rule, "subject_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, _vm.onChange]
	      }
	    }, _vm._l((_vm.subjectTypes), function(subjectType) {
	      return _c('option', {
	        domProps: {
	          "value": subjectType.value
	        }
	      }, [_vm._v("\n              " + _vm._s(subjectType.name) + "\n            ")])
	    }), 0)]) : _vm._e(), _vm._v(" "), (rule.type === 'subject_title') ? _c('div', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model.trim",
	        value: (rule.subject_title),
	        expression: "rule.subject_title",
	        modifiers: {
	          "trim": true
	        }
	      }],
	      ref: 'subjectTitleInput' + rule.id,
	      refInFor: true,
	      staticClass: "rule-input-text",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (rule.subject_title)
	      },
	      on: {
	        "keyup": _vm.onChange,
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(rule, "subject_title", $event.target.value.trim())
	        },
	        "blur": function($event) {
	          return _vm.$forceUpdate()
	        }
	      }
	    })]) : _vm._e(), _vm._v(" "), (rule.type === 'calendar_id') ? _c('div', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (rule.calendar_id),
	        expression: "rule.calendar_id"
	      }],
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(rule, "calendar_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, _vm.onChange]
	      }
	    }, _vm._l((_vm.calendars), function(calendar) {
	      return _c('option', {
	        domProps: {
	          "value": calendar.id
	        }
	      }, [_vm._v("\n              " + _vm._s(calendar.name) + "\n            ")])
	    }), 0)]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("skal det tælle som")]), _vm._v(" "), _c('div', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (rule.selected_employment_title),
	        expression: "rule.selected_employment_title"
	      }],
	      staticClass: "do-select",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(rule, "selected_employment_title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, _vm.onChange]
	      }
	    }, _vm._l((_vm.employmentToSelectForRules), function(employmentsType) {
	      return _c('option', {
	        domProps: {
	          "value": employmentsType
	        }
	      }, [_vm._v("\n              " + _vm._s(employmentsType) + "\n            ")])
	    }), 0)]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'left'
	        }),
	        expression: "{\n                  arrow: true,\n                  placement : 'left'\n                }"
	      }],
	      staticClass: "icon__bg-circle d-item-delete icon__bg-circle--danger",
	      attrs: {
	        "content": _vm.$t('vue2.common.delete')
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setRoleToDelete(rule)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })])])
	  }), 0)], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-buttons"
	  }, [_c('button', {
	    staticClass: "btn-trans",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.addNewRule.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("+ Tiløj regel")]), _vm._v(" "), (_vm.isChangeHasBeenMade) ? _c('div', {
	    staticClass: "do-submit-buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSaving
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.save')) + "\n      ")])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2117 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "isCloseOnBgClick": false,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('div', [_c('h2', [_vm._v(_vm._s(_vm.employmentIds.length === 1 ? 'Opret engangsydelse' : 'Opret engangsydelser'))]), _vm._v(" "), _c('p', {
	    staticClass: "d-modal__subtitle"
	  }, [_vm._v(_vm._s(_vm.subtitleText))])]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "create-form__grid"
	  }, [_c('div', {
	    staticClass: "d-input-group cf-loenart"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Lønkode *")]), _vm._v(" "), _c('DSelect', {
	    ref: "loenartSelect",
	    attrs: {
	      "items": _vm.salaryCodesForDSelect,
	      "multiple": false,
	      "placeholder": 'Vælg lønkode',
	      "itemsSelected": _vm.selectedSalaryCodeForDSelect,
	      "isShowRemoveButton": false
	    },
	    on: {
	      "add": _vm.onSelectLoenart,
	      "remove": function($event) {
	        return _vm.onSelectLoenart(null)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group cf-antal"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.beloebAllowed ? 'Antal' : 'Antal *'))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.antal),
	      expression: "antal"
	    }],
	    staticClass: "d-input width-100",
	    attrs: {
	      "type": "text",
	      "inputmode": "decimal",
	      "placeholder": "Indtast antal"
	    },
	    domProps: {
	      "value": (_vm.antal)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.antal = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group cf-beloeb"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.beloebAllowed ? 'Beløb *' : 'Beløb'))]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'top',
	        animateFill: false,
	        animation: 'shift-away',
	        boundary: 'window',
	        zIndex: 12312312312312,
	        onShow: function () { return !_vm.beloebAllowed; }
	      }),
	      expression: "{\n                  arrow: true,\n                  placement: 'top',\n                  animateFill: false,\n                  animation: 'shift-away',\n                  boundary: 'window',\n                  zIndex: 12312312312312,\n                  onShow: () => !beloebAllowed\n                }"
	    }],
	    staticClass: "cf-beloeb__field",
	    attrs: {
	      "content": _vm.beloebAllowed ? '' : 'Kræver løbenummer 0'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.beloeb),
	      expression: "beloeb"
	    }],
	    staticClass: "d-input width-100",
	    attrs: {
	      "type": "text",
	      "inputmode": "decimal",
	      "disabled": !_vm.beloebAllowed,
	      "placeholder": _vm.beloebAllowed ? 'Indtast beløb' : ''
	    },
	    domProps: {
	      "value": (_vm.beloeb)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.beloeb = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('p', {
	    staticClass: "cf-hint text-explainer"
	  }, [_vm._v("\n          " + _vm._s(_vm.beloebHint) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group cf-dato"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Aktivitetsdato *")]), _vm._v(" "), _c('DateSelector', {
	    staticClass: "width-100",
	    attrs: {
	      "date": _vm.dato,
	      "width100": true
	    },
	    on: {
	      "changed": function($event) {
	        return _vm.setDato($event)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group cf-omk"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Afvigende omkostningssted")]), _vm._v(" "), _c('DSelect', {
	    attrs: {
	      "items": _vm.costCentersForDSelect,
	      "multiple": false,
	      "placeholder": 'Vælg afvigende omkostningssted (valgfri)',
	      "itemsSelected": _vm.selectedCostCenterForDSelect,
	      "isShowRemoveButton": true
	    },
	    on: {
	      "add": _vm.onSelectCostCenter,
	      "remove": function($event) {
	        return _vm.onSelectCostCenter(null)
	      }
	    }
	  })], 1)]), _vm._v(" "), (_vm.validationMessage) ? _c('p', {
	    staticClass: "text-explainer text-explainer--danger"
	  }, [_vm._v(_vm._s(_vm.validationMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', {
	    staticClass: "d-modal__buttons__child"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'right',
	        animateFill: false,
	        animation: 'shift-away',
	        boundary: 'window',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n                  arrow: true,\n                    placement : 'right',\n                    animateFill: false,\n                    animation : 'shift-away',\n                    boundary: 'window',\n                    zIndex: 12312312312312\n                  }"
	    }],
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting,
	      'do-bttn--submit--disabled': !_vm.isValid
	    },
	    attrs: {
	      "disabled": !_vm.isValid || _vm.isSubmitting,
	      "content": _vm.saveKeyTooltip
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.submitButtonLabel) + "\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2118 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "grid grid-pad box-size text-dark",
	    staticStyle: {
	      "padding-top": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "col-1-1 box-size"
	  }, [_c('div', {
	    staticClass: "students-container"
	  }, [_c('div', {
	    staticClass: "students-container__header"
	  }, [_c('div', {
	    staticClass: "students-container__header__left"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.students.students')))]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "students-container__header__right feide-import"
	  }, [(_vm.isFeideImportActive) ? _c('div', {
	    staticClass: "feide-import"
	  }, [_c('img', {
	    attrs: {
	      "id": "feide-logo",
	      "src": _vm.feideLogo,
	      "alt": "Feide"
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "marg-1-right"
	  }, [_c('span', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.students.latest_updated')) + ":")]), _vm._v("\n              " + _vm._s(_vm.lastUpdateFromFeide))]), _vm._v(" "), _c('button', {
	    staticClass: "marg-1-right bttn--is-import",
	    staticStyle: {
	      "width": "120px",
	      "height": "34px"
	    },
	    on: {
	      "click": _vm.updateFromFeide
	    }
	  }, [(!_vm.isImporting) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.import_students')))]) : _c('Loader', {
	    staticStyle: {
	      "margin": "0",
	      "width": "20px",
	      "height": "20px"
	    },
	    attrs: {
	      "bg-color": "#f6f7f8"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), _c('CreateStudents')], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "students"
	  }, [_c('div', {
	    staticClass: "students__col students__col1"
	  }, [_c('div', {
	    staticClass: "students__col__header"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.students.groups')))])]), _vm._v(" "), _c('div', {
	    staticClass: "students__col__body",
	    style: (_vm.bodyStyleObj)
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : _c('ul', [_c('li', {
	    staticClass: "students__filters__filter",
	    class: {
	      'students__filters__filter--active': _vm.isTheActiveFilter('')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheActiveFilter('')
	      }
	    }
	  }, [_c('div', [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.students.all')) + "\n                ")]), _vm._v(" "), _c('div', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.students.length))])]), _vm._v(" "), _c('li', {
	    staticClass: "students__filters__filter",
	    class: {
	      'students__filters__filter--active': _vm.isTheActiveFilter('filter__activatedStudents')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheActiveFilter('filter__activatedStudents')
	      }
	    }
	  }, [_c('div', [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.students.activated_schedules')) + "\n                ")]), _vm._v(" "), _c('div', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.studentsActivated.length))])]), _vm._v(" "), _c('li', {
	    staticClass: "students__filters__filter",
	    class: {
	      'students__filters__filter--active': _vm.isTheActiveFilter('filter__students_without_groups')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheActiveFilter('filter__students_without_groups')
	      }
	    }
	  }, [_c('div', [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.students.without_group')) + "\n                ")]), _vm._v(" "), _c('div', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.studentsWithoutKlasses.length))])]), _vm._v(" "), _c('li', {
	    staticClass: "students__filters__filter students__filters__filter__title"
	  }, [_vm._v(_vm._s(_vm.localActivatedSchoolYear.name) + "\n              ")]), _vm._v(" "), _vm._l((_vm.klassCalendars), function(klass) {
	    return _c('li', {
	      ref: "droppable_elements",
	      refInFor: true,
	      staticClass: "students__filters__filter",
	      class: {
	        'students__filters__filter--active': _vm.isTheActiveFilter(klass.id)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheActiveFilter(klass.id)
	        },
	        "dragover": function($event) {
	          $event.preventDefault();
	        },
	        "dragenter": function($event) {
	          $event.preventDefault();
	          return _vm.dragEnter(klass, $event)
	        },
	        "dragleave": function($event) {
	          $event.preventDefault();
	          return _vm.dragLeave.apply(null, arguments)
	        },
	        "drop": function($event) {
	          $event.preventDefault();
	          return _vm.drop(klass, $event)
	        }
	      }
	    }, [_c('div', [_vm._v(_vm._s(klass.name))]), _vm._v(" "), _c('div', [_c('span', {
	      staticClass: "icon-user"
	    }), _vm._v(" " + _vm._s(klass.students ? klass.students.length : 0))])])
	  })], 2)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "students__col students__col2"
	  }, [_c('div', {
	    staticClass: "students__col__header students__col__header__students"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.students.students')))])]), _vm._v(" "), _c('div', {
	    ref: "students_col1_body",
	    staticClass: "students__col__body",
	    style: (_vm.bodyStyleObj)
	  }, [_c('table', {
	    staticClass: "students__table"
	  }, [_c('thead', [_c('tr', {
	    staticClass: "students__student students__student__header"
	  }, [_c('th', [_c('span', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.dragStudents.length < 1) ? [_vm._v(_vm._s(_vm.$t('vue2.tagging.select_all')))] : [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))]], 2)]), _vm._v(" "), _c('th', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.students.groups')) + " (" + _vm._s(_vm.localActivatedSchoolYear.name) + ")")]), _vm._v(" "), (_vm.isFeideActive) ? _c('th', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.students.feide')))]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.students.to_be_scheduled')))])])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : _c('tbody', _vm._l((_vm.filteredStudents), function(student) {
	    return _c('tr', {
	      key: student.id,
	      staticClass: "students__student",
	      class: {
	        'isSelected': student.v_isSelectedForDrag
	      },
	      attrs: {
	        "draggable": "true"
	      },
	      on: {
	        "dragstart": function($event) {
	          $event.stopPropagation();
	          return _vm.dragStart(student, $event)
	        },
	        "dragend": function($event) {
	          $event.stopPropagation();
	          return _vm.dragEnd(student, $event)
	        },
	        "dragover": function($event) {
	          $event.stopPropagation();
	        },
	        "drop": function($event) {
	          $event.preventDefault();
	          return _vm.drop(_vm.slot, $event)
	        },
	        "click": function($event) {
	          return _vm.setTheActiveStudent(student)
	        }
	      }
	    }, [_c('td', [_c('div', {
	      staticClass: "name-and-checkbox"
	    }, [_c('div', {
	      staticClass: "icon__bg-circle",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setStudentsSelectedForDrag(student)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "d-checkbox",
	      class: {
	        'd-checkbox--active': false
	      }
	    })]), _vm._v("\n                    " + _vm._s(student.name) + "\n                  ")])]), _vm._v(" "), _c('td', _vm._l((student.v_klasses), function(klass, key) {
	      return _c('span', [(key !== 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                " + _vm._s(klass.name))])
	    }), 0), _vm._v(" "), (_vm.isFeideActive) ? _c('td', [_vm._v("\n                  " + _vm._s(student.custom_data && student.custom_data.feide ? student.custom_data['feide'] : '') + "\n                ")]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "d-toggle",
	      class: {
	        'd-toggle--active': !student.archived_at
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.toggleStudentArchived(student)
	        }
	      }
	    })])])
	  }), 0)], 1)])])]), _vm._v(" "), (_vm.theActiveStudent) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false
	    },
	    on: {
	      "close": _vm.closeModal
	    }
	  }, [_c('div', {
	    staticClass: "doc-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "doc-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.theActiveStudent.name))]), _vm._v(" "), _c('div', {
	    staticClass: "doc-modal__close icon__bg-circle",
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "doc-modal__body"
	  }, [_c('div', {
	    staticClass: "d-input-group marg-1-bottom"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.students.name')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editName),
	      expression: "editName"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.editName)
	    },
	    on: {
	      "keyup": function($event) {
	        _vm.isEditStudentChanges = true
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.editName = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (_vm.isFeideActive) ? _c('div', {
	    staticClass: "d-input-group marg-1-bottom"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.students.feide')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editFeide),
	      expression: "editFeide"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.editFeide)
	    },
	    on: {
	      "keyup": function($event) {
	        _vm.isEditStudentChanges = true
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.editFeide = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label marg-05-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.students.groups')))]), _vm._v(" "), (_vm.getStudentRelations(_vm.theActiveStudent).length < 1) ? _c('div', {
	    staticClass: "doc-modal__student__klasses__no-klasses"
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.students.has_no_groups')))])]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "doc-modal__student__klasses"
	  }, _vm._l((_vm.getStudentRelations(_vm.theActiveStudent)), function(klass, key) {
	    return _c('li', {
	      staticClass: "doc-modal__student__klasses__klass",
	      class: {
	        'klass--is-danger': _vm.isHoverOnKlass
	      }
	    }, [_c('div', [_vm._v(_vm._s(klass.name))]), _vm._v(" "), _c('div', {
	      staticClass: "text-link",
	      on: {
	        "click": function($event) {
	          return _vm.removeFromKlass(klass)
	        },
	        "mouseenter": function($event) {
	          _vm.isHoverOnKlass = true
	        },
	        "mouseout": function($event) {
	          _vm.isHoverOnKlass = false
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('vue2.students.remove')) + "\n                  ")])])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "doc-modal__footer"
	  }, [_c('div', [_c('button', {
	    staticClass: "hint--right bttn--warning",
	    attrs: {
	      "aria-label": _vm.$t('vue2.students.delete_student')
	    },
	    on: {
	      "click": function($event) {
	        _vm.isEditStudentConfirmation = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInUp"
	    }
	  }, [(_vm.isEditStudentChanges) ? _c('div', [_c('button', {
	    staticClass: "bttn submit-button",
	    staticStyle: {
	      "width": "120px"
	    },
	    on: {
	      "click": _vm.submitModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n                ")])]) : _vm._e()])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isEditStudentConfirmation) ? _c('ModalConfirmation', {
	    on: {
	      "close": _vm.closeModal,
	      "confirm": _vm.deleteStudent
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    ref: "customdrag",
	    staticClass: "d-custom-drag",
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.common.add')) + " " + _vm._s(_vm.dragStudents.length) + "\n    "), (_vm.dragStudents.length === 1) ? [_vm._v(" " + _vm._s(_vm.$t('vue2.students.student')))] : [_vm._v(" " + _vm._s(_vm.$t('vue2.students.students')))]], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2119 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal--full-width text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.closeFilters.apply(null, arguments)
	      }
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Gennemsnits undervisningstal")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [(_vm.isLoading) ? _c('Loader') : [_c('div', {
	    staticClass: "avg-uv__toolbar"
	  }, [_c('div', {
	    staticClass: "avg-uv__filters",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Grupper',
	      "tags": _vm.uniqueGroups,
	      "selectedTags": _vm.selectedGroups,
	      "closeFromProp": _vm.closeFiltersCount,
	      "numberOfSelectedTagsToShow": 4,
	      "placeholder": 'Alle grupper'
	    },
	    on: {
	      "select": _vm.toggleGroup,
	      "clear": _vm.clearGroups
	    }
	  })], 1), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.asyncLoadXLSXAndDownload.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("\n            Download til Excel\n          ")])]), _vm._v(" "), _c('div', {
	    staticClass: "avg-uv__table-scroll"
	  }, [_c('table', {
	    staticClass: "do-table do-table--striped"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', {
	    staticClass: "avg-uv__narrow"
	  }, [_vm._v("Ansættelsesgrad")]), _vm._v(" "), _c('th', {
	    staticClass: "avg-uv__narrow"
	  }, [_vm._v("Timeansættelse pr. uge")]), _vm._v(" "), _c('th', {
	    staticClass: "avg-uv__narrow"
	  }, [_vm._v("Uv-timer")]), _vm._v(" "), _c('th', {
	    staticClass: "avg-uv__narrow"
	  }, [_vm._v("Normeret til fuldtid")])])]), _vm._v(" "), _c('tbody', [(_vm.filteredRows.length === 0) ? _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_c('i', [_vm._v("Ingen personer matcher filtrene")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredRows), function(row) {
	    return _c('tr', {
	      key: row.userId
	    }, [_c('td', [_c('strong', [_vm._v(_vm._s(row.name))])]), _vm._v(" "), _c('td', {
	      staticClass: "avg-uv__narrow"
	    }, [_vm._v(_vm._s(_vm.formatPercentage(row.employmentPercentage)))]), _vm._v(" "), _c('td', {
	      staticClass: "avg-uv__narrow"
	    }, [_vm._v(_vm._s(row.weeklyHours === null ? '' : _vm.formatDecimal(row.weeklyHours)))]), _vm._v(" "), _c('td', {
	      staticClass: "avg-uv__narrow"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(row.teachingHours)))]), _vm._v(" "), _c('td', {
	      staticClass: "avg-uv__narrow"
	    }, [_vm._v(_vm._s(row.normalizedToFullTime === null ? '' : _vm.formatDecimal(row.normalizedToFullTime)))])])
	  })], 2), _vm._v(" "), (_vm.filteredRows.length > 0) ? _c('tfoot', [_c('tr', {
	    staticClass: "avg-uv__summary"
	  }, [_c('td', {
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_c('strong', [_vm._v("Gennemsnit (normeret) — " + _vm._s(_vm.summary.count) + " medarbejdere")])]), _vm._v(" "), _c('td', {
	    staticClass: "avg-uv__narrow"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.summary.average === null ? '' : _vm.formatDecimal(_vm.summary.average)))])])])]) : _vm._e()])])]], 2), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("Luk")])])])])
	},staticRenderFns: []}

/***/ }),
/* 2120 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "brutto text-dark",
	    class: {
	      'brutto--kindergarten': _vm.isKindergarten
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.setIsNormModal
	    }
	  }, [_vm._v("Normberegning")]), _vm._v(" "), (_vm.isActive) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false,
	      "placeInTop": true
	    }
	  }, [_c('div', {
	    staticClass: "brutto-container brutto-container-denmark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-container__header"
	  }, [_c('h2', [_vm._v("Normberegning")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__body"
	  }, [_c('div', {
	    staticClass: "brutto-container__body__left"
	  }, [_c('div', {
	    staticClass: "d-tabs__header"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isEditWorkHours),
	      expression: "isEditWorkHours"
	    }],
	    staticClass: "d-tabs"
	  }, [_c('div', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': _vm.getIsActiveTab(0)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setActiveTab(0)
	      }
	    }
	  }, [_vm._v("\n                Bruttotid\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': _vm.getIsActiveTab(1)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setActiveTab(1)
	      }
	    }
	  }, [_vm._v("\n                Nettotid\n              ")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs__header__right",
	    class: {
	      'd-tabs__header__right--alone': !_vm.isEditWorkHours
	    }
	  }, [_c('div', {
	    staticClass: "label-with-toggle",
	    on: {
	      "click": function($event) {
	        _vm.isEditWorkHours = !_vm.isEditWorkHours
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Indsæt arbejdstid")]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isEditWorkHours
	    }
	  })], 1)])]), _vm._v(" "), (_vm.isEditWorkHours) ? _c('div', {
	    staticClass: "d-tabs__content"
	  }, [_c('AssignHoursNormList', {
	    attrs: {
	      "standardNettoHours": _vm.originalNettoTime,
	      "standardHolidayHours": _vm.originalHolidayHours,
	      "standardLocalAgreementHours": _vm.originalLocalAgreementHours,
	      "isNetto": _vm.activeTab === 1,
	      "isKindergarten": _vm.isKindergarten,
	      "schoolYear": _vm.activeSchoolYear,
	      "theEditUserNorm": _vm.theEditUserNorm
	    },
	    on: {
	      "onEditBrutto": function($event) {
	        return _vm.setActiveTab(0)
	      },
	      "onEditNetto": function($event) {
	        return _vm.setActiveTab(1)
	      },
	      "updated": _vm.setItemsToSave,
	      "changedSum": _vm.setNettoTime,
	      "onEditedStandardWorkingHours": function($event) {
	        return _vm.setIsShowNewNettoModal($event)
	      },
	      "onOpenHolidaysSettings": _vm.openHolidaysSettingsModal,
	      "onOpenLocalAgreementSettings": _vm.openLocalAgreementSettingsModal,
	      "changedEmploymentRate": _vm.onChangedEmploymentRate
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isKindergarten && (!_vm.isPoolsDeactivated || _vm.isAssignedPoolFromNormWhenPoolsDeactivated)) ? _c('div', {
	    staticClass: "more-norms"
	  }, [(_vm.isEditWorkHours && !_vm.isPoolsDeactivated) ? _c('div', {
	    staticClass: "rest-calculation"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Rest / Ikke fordelt på puljer")]), _vm._v("\n              " + _vm._s(_vm.restCalculation) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "brutto__items"
	  }, _vm._l((_vm.displayedNormPoolItems), function(item, idx) {
	    return _c('li', {
	      key: item.id,
	      staticClass: "brutto__items__item__container"
	    }, [_c('div', {
	      staticClass: "label-with-toggle",
	      on: {
	        "click": function($event) {
	          return _vm.toggleItemById(item.id)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v("Indsæt " + _vm._s(_vm.getItemName(item)))]), _vm._v(" "), _c('app-toggle', {
	      attrs: {
	        "allowChanges": false,
	        "propOn": _vm.isItemToggledById(item.id)
	      }
	    })], 1), _vm._v(" "), (_vm.isItemToggledById(item.id)) ? _c('div', {
	      staticClass: "brutto__items__item"
	    }, [_c('span', {
	      staticClass: "norm-title"
	    }, [_vm._v("\n                    " + _vm._s(_vm.getItemName(item)) + "\n                    "), (_vm.prepFactor && item.id === 'assigned_preparation_hours') ? _c('span', {
	      staticClass: "norm-title__sub"
	    }, [(_vm.substitutePoolHoursForPrep !== null) ? [_vm._v("\n                        " + _vm._s(_vm.prepFactor) + " Forberedelesfaktor * (" + _vm._s(_vm.hoursForTeaching) + " UV + " + _vm._s(_vm.substitutePoolHoursForPrep) + " vikar)\n                      ")] : [_vm._v("\n                        " + _vm._s(_vm.prepFactor) + " Forberedelesfaktor * " + _vm._s(_vm.hoursForTeaching) + " UV\n                      ")]], 2) : _vm._e()]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return _vm.isShowPrepFactorTooltip(item); }
	        }),
	        expression: "{\n                    arrow: true,\n                    animateFill: false,\n                    animation : 'shift-away',\n                    zIndex: '999999992',\n                    boundary: 'window',\n                    onShow: () => isShowPrepFactorTooltip(item)\n                  }"
	      }],
	      staticClass: "d-input-group__input",
	      attrs: {
	        "content": "Forberedelse opdateres automatisk ift. hvad der er tildelt i \"Undervisning\""
	      }
	    }, [(_vm.isEmploymentRateChanged && (item.id !== 'assigned_preparation_hours' && _vm.prepFactor)) ? _c('div', {
	      staticClass: "employment-rate-calculator"
	    }, [_vm._v("\n                      (" + _vm._s(_vm.formatEmploymentRateText(item)) + ")\n                    ")]) : _vm._e(), _vm._v(" "), _c('span', {
	      staticClass: "label"
	    }, [_vm._v(_vm._s(item.unit ? item.unit : 'timer'))]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.hours),
	        expression: "item.hours"
	      }],
	      attrs: {
	        "disabled": _vm.prepFactor && item.id === 'assigned_preparation_hours',
	        "type": "number"
	      },
	      domProps: {
	        "value": (item.hours)
	      },
	      on: {
	        "change": function($event) {
	          return _vm.onUpdatingHours(item, $event.target.value)
	        },
	        "focus": function($event) {
	          return $event.target.select()
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "hours", $event.target.value)
	        }
	      }
	    })])]) : _vm._e()])
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "brutto__items__item__container brutto__items__item__container__notefield",
	    class: {
	      'brutto__items__item__container__notefield--alone': _vm.isPoolsDeactivated
	    }
	  }, [_c('div', {
	    staticClass: "label-with-toggle",
	    on: {
	      "click": _vm.setIsShowAgreement
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Indsæt en note til de valgte personer")]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isShowAgreement
	    }
	  })], 1), _vm._v(" "), (_vm.isShowAgreement) ? _c('AppEIPWYZIWYG', {
	    attrs: {
	      "isKeepOpen": true,
	      "is-open": true,
	      "isInTestOfSaveButton": false
	    },
	    on: {
	      "changed": _vm.updateAgreements
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowAgreement) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_c('svg', {
	    staticClass: "icon-archive tw-icon",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M5.23 3h13.54a2 2 0 0 1 1.98 2.22l-1.55 14A2 2 0 0 1 17.2 21H6.79a2 2 0 0 1-1.99-1.78l-1.55-14A2 2 0 0 1 5.23 3z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M10.59 14l-2.3-2.3a1 1 0 0 1 1.42-1.4L12 12.58l2.3-2.3a1 1 0 0 1 1.4 1.42L13.42 14l2.3 2.3a1 1 0 0 1-1.42 1.4L12 15.42l-2.3 2.3a1 1 0 1 1-1.4-1.42L10.58 14zM4 3h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5c0-1.1.9-2 2-2z"
	    }
	  })]), _vm._v("\n              Bemærk at hvis der står noget i personens notefelt i forvejen vil dette blive slettet\n            ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "brutto__users",
	    class: {
	      'brutto__users--wide': _vm.showAllFields
	    }
	  }, [_c('div', {
	    staticClass: "brutto__users__header brutto__users__header__filters"
	  }, [_c('DoFiltersFilter', {
	    attrs: {
	      "users": _vm.usersSortedOnNameWithTags,
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters
	    },
	    on: {
	      "clear": function($event) {
	        _vm.appliedFilters = []
	      },
	      "select": _vm.toggleFilter
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "label-with-toggle",
	    on: {
	      "click": function($event) {
	        _vm.showAllFields = !_vm.showAllFields
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Vis alle felter")]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.showAllFields
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "norm-select-users__header"
	  }, [_c('div', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.toggleAllDisplayed
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.isAllDisplayedSelected ? 'Fravælg alle' : 'Vælg alle') + "\n            ")]), _vm._v(" "), _c('span', [_vm._v(" Viser " + _vm._s(_vm.filteredUsers.length) + " af " + _vm._s(_vm.usersSortedOnName.length))])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto__users__list"
	  }, [(_vm.isLoadingAllUsers || _vm.isLoadingUserYears) ? _c('div', {
	    staticClass: "do-spinner__container"
	  }, [_c('div', {
	    staticClass: "do-spinner do-spinner--large"
	  })]) : _c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
	    staticClass: "is-clickable",
	    on: {
	      "click": function($event) {
	        return _vm.setNormSort('name')
	      }
	    }
	  }, [_vm._v("\n                  Navn\n                  "), (_vm.normSort.key === 'name') ? _c('span', [_vm._v(_vm._s(_vm.normSort.dir === 'asc' ? '▲' : '▼'))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.coreColumns), function(col) {
	    return _c('th', {
	      key: 'h-core-' + col,
	      staticClass: "is-clickable",
	      on: {
	        "click": function($event) {
	          return _vm.setNormSort(col)
	        }
	      }
	    }, [_vm._v("\n                  " + _vm._s(_vm.shortNormTitle(col)) + "\n                  "), (_vm.normSort.key === col) ? _c('span', [_vm._v(_vm._s(_vm.normSort.dir === 'asc' ? '▲' : '▼'))]) : _vm._e()])
	  }), _vm._v(" "), _vm._l((_vm.extraColumns), function(col) {
	    return (_vm.showAllFields) ? _c('th', {
	      key: 'h-extra-' + col,
	      staticClass: "is-clickable",
	      on: {
	        "click": function($event) {
	          return _vm.setNormSort(col)
	        }
	      }
	    }, [_vm._v("\n                  " + _vm._s(_vm.shortNormTitle(col)) + "\n                  "), (_vm.normSort.key === col) ? _c('span', [_vm._v(_vm._s(_vm.normSort.dir === 'asc' ? '▲' : '▼'))]) : _vm._e()]) : _vm._e()
	  }), _vm._v(" "), _c('th')], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.normDisplayedRows), function(row) {
	    return _c('tr', {
	      key: row.id,
	      class: {
	        'is-selected': _vm.getIsUserSelected(row)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleUser(row)
	        }
	      }
	    }, [_c('td', [_c('div', {
	      staticClass: "do-checkbox",
	      class: {
	        'do-checkbox--selected': _vm.getIsUserSelected(row)
	      }
	    })]), _vm._v(" "), _c('td', {
	      staticClass: "bold"
	    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _vm._l((_vm.coreColumns), function(col) {
	      return _c('td', {
	        key: 'c-core-' + row.id + '-' + col
	      }, [_vm._v("\n                  " + _vm._s(row.values[col]) + "\n                ")])
	    }), _vm._v(" "), _vm._l((_vm.extraColumns), function(col) {
	      return (_vm.showAllFields) ? _c('td', {
	        key: 'c-extra-' + row.id + '-' + col
	      }, [_vm._v("\n                  " + _vm._s(row.values[col]) + "\n                ")]) : _vm._e()
	    }), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "icon__bg-circle d-edit-btn",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.editUserNorm(row)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-wrench"
	    })])])], 2)
	  }), 0)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__footer"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isActive = false
	      }
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        onShow: function () { return _vm.selectedUsers.length < 1; }
	      }),
	      expression: "{\n                  arrow: true,\n                  onShow: () => selectedUsers.length < 1\n                }"
	    }],
	    staticClass: "bttn bttn-primary",
	    class: [{
	      'bttn-primary--disabled': _vm.selectedUsers.length < 1
	    }, {
	      'bttn--loading': _vm.isSaving
	    }],
	    attrs: {
	      "content": "Der skal vælges minimum en bruger"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setIsWarningActive(true)
	      }
	    }
	  }, [_vm._v("Gem\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isWarningActive) ? _c('DModal', {
	    staticStyle: {
	      "z-index": "999999999"
	    },
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "brutto-warning",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-warning__header"
	  }, [_c('h2', [_vm._v("Gem og erstat?")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": function($event) {
	        _vm.isWarningActive = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-warning__body"
	  }, [_c('svg', {
	    staticClass: "tw-icon tw-icon--red",
	    attrs: {
	      "viewBox": "0 0 24 24",
	      "fill": "none",
	      "stroke": "currentColor",
	      "stroke-width": "2",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "9",
	      "x2": "12",
	      "y2": "13"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "17",
	      "x2": "12.01",
	      "y2": "17"
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n          Du er ved at tildele arbejdstid på " + _vm._s(_vm.nettoTime) + " til de valgte brugere. Hvis der i forvejen er tildelt en\n          arbejdstid vil dette blive erstattet.\n        ")])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-warning__footer"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isWarningActive = false
	      }
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-primary bttn-primary--small",
	    class: [{
	      'bttn--loading': _vm.isSaving
	    }],
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("Gem\n          og erstat\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.theNewNettoValue) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isShowConfirmDeleteMessage": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsShowNewNettoModal(null)
	      }
	    }
	  }, [_c('h4', {
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_vm._v("Vil du gemme " + _vm._s(_vm.theNewNettoValue) + " som den nye standard netto tid på skolen, så du ikke skal\n      taste det næste gang?")]), _vm._v(" "), _c('template', {
	    slot: "confirm_buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowNewNettoModal(null)
	      }
	    }
	  }, [_vm._v("\n        Ikke gem\n      ")]), _vm._v(" "), _c('button', {
	    ref: "submit_bttn",
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.saveNewNettoTime
	    }
	  }, [_vm._v("\n        Gem som ny standard\n      ")])])], 2) : _vm._e(), _vm._v(" "), (_vm.isShowHolidaysSettingsModal) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isShowConfirmDeleteMessage": false
	    },
	    on: {
	      "close": _vm.closeHolidaysSettingsModal
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "item",
	      "id": "holidays-settings"
	    },
	    slot: "item"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.holidaysSettingsReadOnly ? 'Helligdage i perioden' : 'Standard for søgnehelligdage'))]), _vm._v(" "), (!_vm.holidaysSettingsReadOnly) ? _c('p', [_vm._v("Indtast den standard for søgnehelligdage som skal bruges i skoleåret\n        "), _c('span', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.activeSchoolYearName))]), _vm._v(". Værdien gælder ved fuld tid og bliver automatisk skaleret\n        efter beskæftigelsesgrad.")]) : _c('p', [_vm._v("Her vises helligdagene i den valgte periode. Skolens standard for søgnehelligdage kan kun redigeres,\n        når perioden er hele skoleåret.")]), _vm._v(" "), (_vm.holidaysSettingsList.length) ? _c('div', {
	    staticClass: "holidays-settings__list"
	  }, [_c('div', {
	    staticClass: "holidays-settings__list__header"
	  }, [_c('span', [_vm._v("Helligdage i perioden")])]), _vm._v(" "), _c('ul', _vm._l((_vm.holidaysSettingsList), function(holiday) {
	    return _c('li', {
	      key: holiday.date,
	      class: {
	        'is-standard': holiday.isStandard,
	        'is-weekend': !holiday.isStandard
	      }
	    }, [(holiday.isStandard) ? _c('span', {
	      staticClass: "holidays-settings__number"
	    }, [_vm._v(_vm._s(holiday.standardIndex))]) : _c('span', {
	      staticClass: "holidays-settings__number holidays-settings__number--empty"
	    }, [_vm._v("—")]), _vm._v(" "), (holiday.name) ? _c('span', {
	      staticClass: "holidays-settings__name"
	    }, [_vm._v(_vm._s(holiday.name))]) : _vm._e(), _vm._v(" "), _c('span', {
	      staticClass: "holidays-settings__date"
	    }, [_vm._v(_vm._s(holiday.formatted))]), _vm._v(" "), (!holiday.isStandard) ? _c('span', {
	      staticClass: "holidays-settings__tag"
	    }, [_vm._v("weekend")]) : _vm._e()])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "holidays-settings__list__sum"
	  }, [_vm._v("\n          " + _vm._s(_vm.holidaysSettingsStandardCount) + " standard dage × 7,4 timer =\n          "), _c('span', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.holidaysSettingsCalculatedValue) + " timer")])])]) : _vm._e(), _vm._v(" "), (!_vm.holidaysSettingsReadOnly) ? _c('div', {
	    staticClass: "holidays-settings__input"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Timer ved fuld tid")]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group__input"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.holidaysSettingsValue),
	      expression: "holidaysSettingsValue"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.holidaysSettingsValue)
	    },
	    on: {
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.holidaysSettingsValue = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "label"
	  }, [_vm._v("timer")])])]) : _vm._e()]), _vm._v(" "), _c('template', {
	    slot: "confirm_buttons"
	  }, [_c('div', {
	    staticClass: "holidays-settings__buttons"
	  }, [(!_vm.holidaysSettingsReadOnly && _vm.originalHolidayHours > 0) ? _c('button', {
	    staticClass: "do-bttn bttn--danger",
	    on: {
	      "click": _vm.deleteHolidaysSettings
	    }
	  }, [_vm._v("\n        Nulstil\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "holidays-settings__buttons__right"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.closeHolidaysSettingsModal
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.holidaysSettingsReadOnly ? 'Luk' : 'Annullér') + "\n      ")]), _vm._v(" "), (!_vm.holidaysSettingsReadOnly) ? _c('button', {
	    ref: "submit_bttn",
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.saveHolidaysSettings
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.originalHolidayHours > 0 ? 'Opdater' : 'Gem') + "\n      ")]) : _vm._e()])])])], 2) : _vm._e(), _vm._v(" "), (_vm.isShowLocalAgreementSettingsModal) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isShowConfirmDeleteMessage": false
	    },
	    on: {
	      "close": _vm.closeLocalAgreementSettingsModal
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "item",
	      "id": "holidays-settings"
	    },
	    slot: "item"
	  }, [_c('h3', [_vm._v("Standard for tilpasning til lokalaftale")]), _vm._v(" "), _c('p', [_vm._v("Indtast den standardværdi for tilpasning til lokalaftale, som skal bruges. Værdien gælder ved fuld tid og\n        bliver automatisk skaleret efter beskæftigelsesgrad.")]), _vm._v(" "), _c('div', {
	    staticClass: "holidays-settings__input"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Timer ved fuld tid")]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group__input"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localAgreementSettingsValue),
	      expression: "localAgreementSettingsValue"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.localAgreementSettingsValue)
	    },
	    on: {
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.localAgreementSettingsValue = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "label"
	  }, [_vm._v("timer")])])])]), _vm._v(" "), _c('template', {
	    slot: "confirm_buttons"
	  }, [_c('div', {
	    staticClass: "holidays-settings__buttons"
	  }, [(_vm.originalLocalAgreementHours > 0) ? _c('button', {
	    staticClass: "do-bttn bttn--danger",
	    on: {
	      "click": _vm.deleteLocalAgreementSettings
	    }
	  }, [_vm._v("\n          Nulstil\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "holidays-settings__buttons__right"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.closeLocalAgreementSettingsModal
	    }
	  }, [_vm._v("\n            Annullér\n          ")]), _vm._v(" "), _c('button', {
	    ref: "submit_bttn",
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.saveLocalAgreementSettings
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.originalLocalAgreementHours > 0 ? 'Opdater' : 'Gem') + "\n          ")])])])])], 2) : _vm._e(), _vm._v(" "), (_vm.theNewStandardHoursForPool) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isShowConfirmDeleteMessage": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setTheNewStandardHoursForPool(null)
	      }
	    }
	  }, [_c('h4', {
	    staticStyle: {
	      "font-weight": "normal"
	    },
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_vm._v("\n      Vil du gemme "), _c('span', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.theNewStandardHoursForPool.hours) + " timer")]), _vm._v(" som den nye standard for\n      "), _c('span', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.theNewStandardHoursForPool.name) + "-puljen")]), _vm._v(", så du ikke behøver at indtaste det næste\n      gang?\n    ")]), _vm._v(" "), _c('template', {
	    slot: "confirm_buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.setTheNewStandardHoursForPool(null)
	      }
	    }
	  }, [_vm._v("\n        Ikke gem\n      ")]), _vm._v(" "), _c('button', {
	    ref: "submit_bttn",
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.saveNewStandardHours
	    }
	  }, [_vm._v("\n        Gem som ny standard\n      ")])])], 2) : _vm._e(), _vm._v(" "), (_vm.isModalAutoCalculateOpen) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isShowConfirmDeleteMessage": false
	    },
	    on: {
	      "close": function($event) {
	        _vm.isModalAutoCalculateOpen = false
	      }
	    }
	  }, [_c('h4', {
	    staticStyle: {
	      "font-weight": "normal"
	    },
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_c('h3', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v("Skal puljer automatisk opdateres?")]), _vm._v(" "), _c('ul', _vm._l((_vm.checkedItemsToUpdate), function(checkedItem) {
	    return _c('li', {
	      key: checkedItem.id
	    }, [_c('b', [_vm._v(_vm._s(checkedItem.name) + ":")]), _vm._v(" " + _vm._s(_vm.formatEmploymentRateText(checkedItem, true)) + "\n        ")])
	  }), 0)]), _vm._v(" "), _c('template', {
	    slot: "confirm_buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        _vm.isModalAutoCalculateOpen = false
	      }
	    }
	  }, [_vm._v("\n        Ikke opdatér\n      ")]), _vm._v(" "), _c('button', {
	    ref: "submit_bttn",
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.updateActivePoolsFromEmploymentRate
	    }
	  }, [_vm._v("\n        Opdatér puljer\n      ")])])], 2) : _vm._e(), _vm._v(" "), (_vm.theEditUser) ? _c('AssignHoursNormEditIUserModal', {
	    attrs: {
	      "user": _vm.theEditUser,
	      "schoolYear": _vm.activeSchoolYear,
	      "schoolId": _vm.schoolId
	    },
	    on: {
	      "updated": _vm.onUpdatedUserNorm,
	      "close": function($event) {
	        return _vm.setTheEditUser(null)
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2121 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('CreateTaskForm', {
	    attrs: {
	      "user": _vm.user,
	      "date": _vm.date,
	      "initSubject": _vm.initSubject,
	      "theNewlyCreatedSubject": _vm.theNewlyCreatedSubject,
	      "editEvent": _vm.editEvent,
	      "openingHours": _vm.openingHours
	    },
	    on: {
	      "setDate": _vm.setDate,
	      "close": function($event) {
	        return _vm.$emit('close')
	      },
	      "createNewSubject": function($event) {
	        return _vm.setCreateNewSubject($event)
	      },
	      "onCreatedEvent": _vm.onCreatedEvent,
	      "deleteEvent": _vm.onDeleteEvent,
	      "updatedEvent": function($event) {
	        return _vm.$emit('updatedEvent', $event)
	      }
	    }
	  }), _vm._v(" "), (_vm.theCreateNewSubjectName) ? _c('CreateTaskNewSubject', {
	    attrs: {
	      "user": _vm.user,
	      "date": _vm.date,
	      "title": _vm.theCreateNewSubjectName
	    },
	    on: {
	      "newSubject": _vm.onNewSubject,
	      "close": function($event) {
	        return _vm.setCreateNewSubject(null)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theDeleteEvent) ? _c('ModalConfirmation', {
	    attrs: {
	      "isSubmitButtonLoading": _vm.isDeleting
	    },
	    on: {
	      "confirm": _vm.deleteEvent,
	      "close": _vm.onCloseConfirmation
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2122 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "school-data-grade"
	  }, [_c('div', {
	    staticClass: "view-toggle"
	  }, [_c('Tabs', {
	    attrs: {
	      "tabs": _vm.tabs,
	      "selected": _vm.viewMode
	    },
	    on: {
	      "select": function($event) {
	        _vm.viewMode = $event
	      }
	    }
	  })], 1), _vm._v(" "), (_vm.viewMode === 'timer') ? _c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "rowspan": "2"
	    }
	  }, [_c('div', {
	    staticClass: "grade-title"
	  }, [(_vm.events.length > 0) ? _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.isShowMore = !_vm.isShowMore
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-down"
	  })]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.calendarName) + "\n        ")])]), _vm._v(" "), _c('th', [_vm._v("Antal skemabrikker")]), _vm._v(" "), _c('th', [_vm._v("Antal skemabrikker med vikar")]), _vm._v(" "), _c('th', [_vm._v("Antal klokketimer")]), _vm._v(" "), _c('th', [_vm._v("Antal klokketimer med vikar")]), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.events.length))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.eventsWithSub.length))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.eventsInHours))]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.eventsWithSubInHours))]), _vm._v(" "), _c('th')])]), _vm._v(" "), (_vm.isShowMore) ? _c('tbody', _vm._l((_vm.eventsInPools), function(subject, prop) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(prop))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject['events']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject['eventsWithSubs']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject['durationInHours']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject['durationWithSubsInHours']))]), _vm._v(" "), _c('td')])
	  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.viewMode === 'subs') ? _c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.calendarName))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.eventsWithSubInHours || 0))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.substitutesByKlass), function(klass) {
	    return _vm._l((klass.substitutes), function(sub) {
	      return _c('tr', {
	        key: sub.calendarId,
	        staticClass: "substitute-item"
	      }, [_c('td', [_vm._v(_vm._s(sub.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatMinutesToHours(sub.minutes)))])])
	    })
	  }), _vm._v(" "), (_vm.substitutesByKlass.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "text-center",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Ingen vikarer fundet")])]) : _vm._e()], 2)]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2123 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "donut-chart"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('svg', {
	    attrs: {
	      "width": "160",
	      "height": "160",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('g', [_c('circle', {
	    staticClass: "circle_animation-2",
	    attrs: {
	      "id": "circle-back",
	      "r": "60",
	      "cy": "81",
	      "cx": "81",
	      "stroke-width": "9",
	      "stroke": "#ffffff",
	      "fill": "none"
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "item",
	    class: [{
	      animateProgess: _vm.animate
	    }, _vm.stepClass]
	  }, [_c('h2', [_vm._v(_vm._s(_vm.stepNum) + "/" + _vm._s(_vm.steps))]), _vm._v(" "), _c('svg', {
	    attrs: {
	      "width": "160",
	      "height": "160",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('g', [_c('circle', {
	    staticClass: "circle_animation",
	    attrs: {
	      "id": "circle",
	      "r": "60",
	      "cy": "81",
	      "cx": "81",
	      "stroke-width": "9",
	      "stroke": "#3ecf8e",
	      "fill": "none"
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 2124 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.shouldRenderComponent) ? _c('div', {
	    staticClass: "user-quota marg-1-bottom text-dark",
	    class: {
	      'user-quota--sidebar': _vm.isSidebar
	    }
	  }, [_c('div', {
	    staticClass: "user-quota__body"
	  }, [_c('table', {
	    staticClass: "d-table user-quota__table"
	  }, [_c('thead', [_c('tr', [_c('th', [_c('div', {
	    staticClass: "user-quota__table-header"
	  }, [_c('div', {
	    staticClass: "user-quota__title-group"
	  }, [_c('h4', {
	    staticClass: "user-quota__title"
	  }, [_vm._v(_vm._s(_vm.i18n.userQuota))]), _vm._v(" "), (_vm.employments.length > 0) ? _c('div', {
	    staticClass: "user-quota__employment"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedEmploymentId),
	      expression: "selectedEmploymentId"
	    }],
	    staticClass: "do-select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedEmploymentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.employments), function(employment) {
	    return _c('option', {
	      key: employment.id,
	      domProps: {
	        "value": employment.id
	      }
	    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(employment.title) + " - " + _vm._s(employment.employment_number || employment.id) + "\n\t\t\t\t\t\t")])
	  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "user-quota__subtitle"
	  }, [_vm._v("Saldo i KMD pr. " + _vm._s(_vm.quotaDateLabel))])])]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.i18n.balance) + "\n\t\t\t")]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.i18n.used))]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.i18n.difference))])])]), _vm._v(" "), _c('tbody', [(_vm.isLoadingEmployments || _vm.isLoadingQuotas) ? _c('tr', [_vm._m(0)]) : (_vm.errorMessage) ? _c('tr', [_c('td', {
	    staticClass: "user-quota__status-cell",
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_c('div', {
	    staticClass: "user-quota__error"
	  }, [_vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")])])]) : (_vm.hasLoadedQuotas && _vm.sortedQuotas.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "user-quota__status-cell",
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_c('p', {
	    staticClass: "user-quota__empty"
	  }, [_vm._v("\n              " + _vm._s(_vm.i18n.noQuotas) + "\n            ")])])]) : _vm._l((_vm.sortedQuotas), function(quota) {
	    return _c('tr', {
	      key: quota.QuotaNumber
	    }, [_c('td', [_c('div', {
	      staticClass: "user-quota__quota-title"
	    }, [_vm._v(_vm._s(quota.QuotaTypaText || quota.QuotaType))]), _vm._v(" "), _c('div', {
	      staticClass: "user-quota__quota-meta"
	    }, [_vm._v("\n              " + _vm._s(_vm.i18n.deductionPeriod) + ": " + _vm._s(_vm.formatDateRange(quota.DeductionStartDate, quota.DeductionEndDate)) + "\n            ")])]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(quota.QuotaAccrued)))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(quota.QuotaUsed)))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.formatDecimal(quota.QuotaValue)))])])
	  })], 2)])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "user-quota__status-cell",
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_c('div', {
	    staticClass: "user-quota__loading"
	  }, [_c('div', {
	    staticClass: "do-spinner"
	  })])])
	}]}

/***/ }),
/* 2125 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DSelect', {
	    attrs: {
	      "items": _vm.allCals,
	      "isLoading": _vm.isLoading,
	      "itemsSelected": _vm.itemsSelected,
	      "allDataLoaded": _vm.allDataLoaded,
	      "multiple": true,
	      "appendToBody": _vm.appendToBody,
	      "placeholder": this.$t('vue2.dselect.placeholder_calendars')
	    },
	    on: {
	      "add": function($event) {
	        return _vm.$emit('add', $event)
	      },
	      "remove": function($event) {
	        return _vm.$emit('remove', $event)
	      },
	      "update": function($event) {
	        return _vm.$emit('updateItems', $event)
	      }
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 2126 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-create-task-for-user"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.editSupplement ? 'Rediger tillæg' : 'Opret tillæg'))]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "do-form-row"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Vælg ansat")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.userId),
	      expression: "userId"
	    }],
	    staticClass: "height-34 do-select width-100",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.userId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.onUserChange($event.target.value)
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "value": ""
	    }
	  }, [_vm._v("Vælg ansat")]), _vm._v(" "), _vm._l((_vm.usersSortedOnName), function(user) {
	    return _c('option', {
	      domProps: {
	        "value": user.id
	      }
	    }, [_vm._v("\n              " + _vm._s(user.name) + "\n            ")])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Brutto årsnorm")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.yearNormHours),
	      expression: "yearNormHours"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.yearNormHours)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.yearNormHours = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (!_vm.isCodeLocked) ? _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Lønkode")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.salaryCodeId),
	      expression: "salaryCodeId"
	    }],
	    staticClass: "height-34 do-select width-100",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.salaryCodeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }), _vm._v(" "), _vm._l((_vm.salaryCodes), function(salaryCode) {
	    return _c('option', {
	      key: salaryCode.id,
	      domProps: {
	        "value": salaryCode.id
	      }
	    }, [_vm._v("\n              " + _vm._s(salaryCode.vSupplementTitle) + "\n            ")])
	  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Omkostningssted")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.costCenterId),
	      expression: "costCenterId"
	    }],
	    staticClass: "height-34 do-select width-100",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.costCenterId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }), _vm._v(" "), _vm._l((_vm.costCenters), function(costCenter) {
	    return _c('option', {
	      key: costCenter.id,
	      domProps: {
	        "value": costCenter.id
	      }
	    }, [_vm._v("\n              " + _vm._s(_vm.costCenterLabel(costCenter)) + "\n            ")])
	  })], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "do-form-row"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Startdato")]), _vm._v(" "), _c('DateSelector', {
	    staticClass: "width-100",
	    attrs: {
	      "date": _vm.startDate,
	      "width100": true
	    },
	    on: {
	      "changed": function (val) { return _vm.startDate = val; }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Slutdato")]), _vm._v(" "), _c('DateSelector', {
	    attrs: {
	      "date": _vm.endDate,
	      "width100": true
	    },
	    on: {
	      "changed": function (val) { return _vm.endDate = val; }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Enheder i periode")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.units),
	      expression: "units"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "text",
	      "inputmode": "decimal"
	    },
	    domProps: {
	      "value": (_vm.units)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.units = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Antal udbetalinger")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.installments),
	      expression: "installments"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.installments)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.installments = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Enheder pr. måned")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.unitsPerInstallment),
	      expression: "unitsPerInstallment"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "text",
	      "inputmode": "decimal"
	    },
	    domProps: {
	      "value": (_vm.unitsPerInstallment)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.unitsPerInstallment = $event.target.value
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', {
	    staticClass: "d-modal__buttons__left"
	  }, [(_vm.editSupplement) ? _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        _vm.isConfirmDelete = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons__right"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    attrs: {
	      "disabled": !_vm.isValid
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.editSupplement ? 'Opdater' : 'Opret') + "\n        ")])])]), _vm._v(" "), (_vm.isConfirmDelete) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": function($event) {
	        _vm.isConfirmDelete = false
	      },
	      "confirm": function($event) {
	        return _vm.$emit('delete', _vm.editSupplement.id)
	      }
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2127 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "event-log text-dark pad-10"
	  }, [_c('h2', {
	    staticClass: "marg-10-bottom event-log__header"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['latest_activity']))]), _vm._v(" "), _c('div', {
	    staticClass: "el-items"
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.logsFormatted), function(activity) {
	    return _c('div', {
	      staticClass: "el-items__item marg-10-bottom"
	    }, [_c('div', {
	      staticClass: "el-info"
	    }, [_c('div', {
	      staticClass: "el-info-right"
	    }, [_c('div', {
	      staticClass: "el-info__headline"
	    }, [_c('p', [_c('b', [_vm._v(_vm._s(activity.by))])]), _vm._v(" "), _c('p', {
	      staticClass: "text-grey hint--top-left",
	      attrs: {
	        "aria-label": activity.vFormattedDate
	      }
	    }, [_vm._v("\n              " + _vm._s(activity.vDuration) + " " + _vm._s(_vm.i18n[_vm.locale].ago))])]), _vm._v(" "), (activity.changes) ? _c('div', {
	      staticClass: "el-items__item__changes"
	    }, _vm._l((activity.vHumanizedChanges), function(txt) {
	      return _c('p', {
	        domProps: {
	          "innerHTML": _vm._s(txt)
	        }
	      })
	    }), 0) : _c('div', {
	      staticClass: "el-items__item__changes"
	    }, [_c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['created']))])])])])])
	  }), _vm._v(" "), (!_vm.isLoading && _vm.sortedLogs.length < 1) ? _c('div', [_vm._v("\n      " + _vm._s(_vm.i18n[_vm.locale]['no_changes']) + "\n    ")]) : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2128 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.close),
	      expression: "close"
	    }],
	    staticClass: "copy-week text-dark no-print"
	  }, [(_vm.isShowCopyCalendarRotate) ? _c('CopyCalendarRotate', {
	    attrs: {
	      "calendarId": _vm.calid,
	      "activeCalendarDate": _vm.activeCalendarDate
	    }
	  }) : [(!_vm.isShowCopyCalendarRotate) ? _c('button', {
	    class: [{
	        'do-bttn': _vm.activeCalendarDate
	      },
	      {
	        'inactive': _vm.modal
	      },
	      {
	        'hint--left hint--always': _vm.isJustCopied
	      }
	    ],
	    attrs: {
	      "aria-label": _vm.tooptipCopyWeek
	    },
	    on: {
	      "click": _vm.getCopyDate
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.copycalendar.copy')) + "\n      "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]) : _vm._e(), _vm._v(" "), (_vm.currentDateIsNotWithinCalendarRange) ? _c('button', {
	    class: {
	      'do-bttn': _vm.activeCalendarDate
	    },
	    on: {
	      "click": _vm.submitThisWeek
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.copycalendar.pasteThisWeek')) + "\n    ")]) : _vm._e()], _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInDown"
	    }
	  }, [(_vm.modal) ? _c('div', {
	    staticClass: "week-picker"
	  }, [_c('div', {
	    staticClass: "week-picker__inner"
	  }, [_c('div', {
	    staticClass: "week-picker__header"
	  }, [_c('div', {
	    staticClass: "week-picker__header__left"
	  }, [_c('h2', {
	    staticClass: "text-blue"
	  }, [_vm._v("\n              " + _vm._s(_vm.selectedWeeks.length) + "\n              "), (_vm.selectedWeeks.length === 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.weekSelected')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.weeksSelected')))])]), _vm._v(" "), (_vm.schoolIsFromDenmark) ? _c('a', {
	    staticClass: "label-link",
	    attrs: {
	      "target": "_blank",
	      "href": "https://docendohelp.crisp.help/da/article/kopiering-af-uger-i-skemaerkalendere-1tka0r4/?bust=1737554247682"
	    }
	  }, [_c('label', {
	    staticClass: "do-pill animateFast fadeInLeftCustom"
	  }, [_c('span', {
	    staticClass: "label-text"
	  }, [_vm._v("Bemærk: Kopierer kun brikker lagt i denne kalender")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-question3 marg-1-left"
	  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle icon__bg-circle__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "week-picker__content flex"
	  }, [_c('div', {
	    staticClass: "content"
	  }, _vm._l((_vm.weeks), function(week, index) {
	    return _c('div', {
	      key: week.serverDate,
	      staticClass: "number hint--top",
	      class: [{
	        'isSelected': week.isSelected
	      }, {
	        'isCopyWeek': week.isCopyWeek
	      }],
	      attrs: {
	        "aria-label": _vm._f("tooltipDate")(week.date)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleWeek(index)
	        }
	      }
	    }, [_c('span', {
	      class: {
	        'isNow': week.isNow
	      }
	    }, [_vm._v("\n            " + _vm._s(week.weekNum) + "\n          ")])])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "sidebar"
	  }, [_c('ul', [_c('li', {
	    staticClass: "sidebar__headline"
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.markWeeksFrom')) + "\n                  "), _c('div', {
	    staticClass: "no-tag",
	    class: {
	      'tag': !_vm.showStartPasteWeek
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm._f("week")(_vm.startPasteWeek)) + "\n                    "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.showStartPasteWeek),
	      expression: "!showStartPasteWeek"
	    }],
	    staticClass: "icon-cross2 pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.eraseStartDate.apply(null, arguments)
	      }
	    }
	  })])])]), _c('li', [_c('span', {
	    staticClass: "sidebar__clickable",
	    on: {
	      "click": _vm.selectAll
	    }
	  }, [_c('span', {
	    staticClass: "bttn width-100 btn-trans"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.allWeeks')) + "\n                ")])])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "sidebar__clickable",
	    on: {
	      "click": _vm.selectOddWeeks
	    }
	  }, [_c('span', {
	    staticClass: "bttn width-100 btn-trans"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.oddWeeks')) + "\n               ")])])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "sidebar__clickable",
	    on: {
	      "click": _vm.selectEvenWeeks
	    }
	  }, [_c('span', {
	    staticClass: "bttn width-100 btn-trans"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.evenWeeks')) + "\n               ")])])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "sidebar__clickable",
	    on: {
	      "click": _vm.removeAllSelectedWeeks
	    }
	  }, [_c('span', {
	    staticClass: "bttn btn-trans width-100 btn-remove"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.unselectAll')) + "\n               ")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "week-picker__footer"
	  }, [_c('div', {
	    staticClass: "delete-option"
	  }, [_c('label', {
	    attrs: {
	      "for": "checkbox"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.deleteLessonsInSelectedWeeks')))]), _vm._v(" "), (_vm.calType === 'user') ? _c('span', [_vm._v(" (" + _vm._s(_vm.$t('vue2.copycalendar.absenceWillNotBeDeleted')) + ")")]) : _vm._e()]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.deleteEvents),
	      expression: "deleteEvents"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "id": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.deleteEvents) ? _vm._i(_vm.deleteEvents, null) > -1 : (_vm.deleteEvents)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.deleteEvents,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.deleteEvents = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.deleteEvents = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.deleteEvents = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "bttn--submit",
	    class: {
	      'inactive': _vm.noneSelected || _vm.notSubmit
	    },
	    on: {
	      "click": _vm.submitWeeks
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.paste')))])])])]), _vm._v(" "), _c('left-panel', {
	    attrs: {
	      "deleteEvents": _vm.deleteEvents,
	      "selectedWeeks": _vm.selectedWeeks,
	      "calId": _vm.calid
	    },
	    on: {
	      "load": _vm.setSubmit
	    }
	  })], 1) : _vm._e()])], 2)
	},staticRenderFns: []}

/***/ }),
/* 2129 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container"
	  }, [_c('h4', {
	    staticClass: "uppercase marg-1-bottom"
	  }, [_vm._v("Personale")]), _vm._v(" "), (_vm.personaleUdenKorrekteOplysninger.length > 0) ? _c('div', {
	    staticClass: "d-attention"
	  }, [_c('svg', {
	    staticClass: "tw-icon icon-important",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
	    }
	  }), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
	    }
	  })]), _vm._v(" "), _c('h3', [_vm._v("Følgende personer mangler enten CPR-nummer eller Stilling.")]), _vm._v(" "), _c('p', [_vm._v("Gå til step 1. Undervisningskompetencer for at tilføje. Sæt til \"Ikke indberet\", hvis personen ikke skal indberettes.")]), _vm._v(" "), _c('table', {
	    staticClass: "d-table d-table__borders"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.personaleUdenKorrekteOplysninger), function(user, key) {
	    return _c('tr', {
	      key: user.user_id
	    }, [_c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.cpr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.stilling))])])
	  }), 0)])]) : _vm._e(), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.groupedLaerereProps), function(group, key) {
	    return _c('tr', {
	      key: key
	    }, [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), _vm._l((group), function(prop) {
	      return _c('td', [_vm._v("\n        " + _vm._s(prop.length) + "\n      ")])
	    })], 2)
	  }), 0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('th'), _vm._v(" "), _c('th', [_vm._v("CPR")]), _vm._v(" "), _c('th', [_vm._v("STILLING")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('th', [_vm._v("Stilling")]), _vm._v(" "), _c('th', [_vm._v("Antal ansatte indberretes")]), _vm._v(" "), _c('th', [_vm._v("Heraf ansatte, der ikke er\n      registeret undervisningskompetencer for\n    ")])])
	}]}

/***/ }),
/* 2130 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "brutto text-dark"
	  }, [_c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "brutto-container",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-container__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.save_task_overview_version')))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__body"
	  }, [(_vm.theTab === 1) ? _c('div', {
	    staticClass: "brutto__users"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('h4', {
	    staticClass: "marg-05-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.version_title')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newVersionTitle),
	      expression: "newVersionTitle"
	    }],
	    ref: "version_name_input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.newVersionTitle)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        _vm.theTab = 2
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newVersionTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "text-desc"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.auto_name_description')))])]), _vm._v(" "), _c('div', {
	    staticClass: "save-versions__explained"
	  }, [_c('ul', {
	    staticClass: "d-event__actions text-dark"
	  }, [_c('li', {
	    staticClass: "d-event__actions__action",
	    class: {
	      'd-event__actions__action--open': _vm.getTheFAQAcc(0)
	    }
	  }, [_c('h4', {
	    on: {
	      "click": function($event) {
	        return _vm.setTheFAQAcc(0)
	      }
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.task_versions.what_is_version')) + "\n                  "), _c('svg', {
	    staticClass: "tw-icon w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M19.5 8.25l-7.5 7.5-7.5-7.5"
	    }
	  })])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "accordion"
	    },
	    on: {
	      "enter": _vm.start,
	      "after-enter": _vm.end,
	      "before-leave": _vm.start,
	      "after-leave": _vm.end
	    }
	  }, [(_vm.getTheFAQAcc(0)) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.saved_task_overview_description')))])]) : _vm._e()])], 1), _vm._v(" "), _c('li', {
	    staticClass: "d-event__actions__action",
	    class: {
	      'd-event__actions__action--open': _vm.getTheFAQAcc(1)
	    }
	  }, [_c('h4', {
	    on: {
	      "click": function($event) {
	        return _vm.setTheFAQAcc(1)
	      }
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.task_versions.find_saved_versions')) + "\n                  "), _c('svg', {
	    staticClass: "tw-icon w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M19.5 8.25l-7.5 7.5-7.5-7.5"
	    }
	  })])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "accordion"
	    },
	    on: {
	      "enter": _vm.start,
	      "after-enter": _vm.end,
	      "before-leave": _vm.start,
	      "after-leave": _vm.end
	    }
	  }, [(_vm.getTheFAQAcc(1)) ? _c('div', [_c('p', [_vm._v("\n                      " + _vm._s(_vm.$t('vue2.task_versions.find_saved_versions_description')) + "\n                    ")])]) : _vm._e()])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.theTab === 2) ? _c('div', {
	    staticClass: "brutto__users"
	  }, [(_vm.tags.length > 0) ? _c('div', {
	    staticClass: "brutto__users__header"
	  }, [_c('filterTags', {
	    attrs: {
	      "users": _vm.usersSortedOnNameWithTags,
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters
	    },
	    on: {
	      "set": _vm.setTagFromFilter,
	      "remove": _vm.removeTagFromFilter
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "brutto__users__list__header",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.selectedUsers.length < 1) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.$t('vue2.tagging.select_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))])]), _vm._v(" "), _c('ul', {
	    staticClass: "brutto__users__list"
	  }, _vm._l((_vm.filteredUsers), function(user) {
	    return _c('li', {
	      key: user.id,
	      staticClass: "brutto__users__user",
	      class: {
	        'is-selected': _vm.getIsUserSelected(user)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleUser(user)
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(user.name) + "\n            ")])
	  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__footer"
	  }, [(_vm.theTab === 2) ? _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.theTab = 1
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.go_back')))]) : _vm._e(), _vm._v(" "), (_vm.theTab === 1) ? _c('button', {
	    staticClass: "bttn bttn-primary",
	    on: {
	      "click": function($event) {
	        _vm.theTab = 2
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.task_versions.select_personnel')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.theTab === 2) ? _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        onShow: function () { return _vm.selectedUsers.length < 1; }
	      }),
	      expression: "{\n                  arrow: true,\n                  onShow: () => selectedUsers.length < 1\n                }"
	    }],
	    staticClass: "bttn bttn-primary",
	    class: [{
	      'bttn-primary--disabled': _vm.selectedUsers.length < 1
	    }, {
	      'bttn--loading': _vm.isSaving
	    }],
	    attrs: {
	      "content": _vm.$t('vue2.task_versions.select_min_user')
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.save_for_selected_users')) + " " + _vm._s(_vm.selectedUsers.length) + " " + _vm._s(_vm.$t('vue2.task_versions.save_for_selected_users_of')) + " " + _vm._s(_vm.filteredUsers.length) + "\n        ")]) : _vm._e()])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2131 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "datepicker-container text-dark",
	    class: {
	      'datepicker-container-100': _vm.width100
	    }
	  }, [(!_vm.isShowInput) ? _c('div', {
	    ref: "date_input_field",
	    staticStyle: {
	      "width": "0px",
	      "height": "0px"
	    }
	  }) : _c('div', {
	    staticClass: "datepicker-input pointer pos-relative"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formatDate),
	      expression: "formatDate"
	    }],
	    ref: "date_input_field",
	    class: {
	      'input-active': _vm.active
	    },
	    attrs: {
	      "id": "inputfield",
	      "type": "text",
	      "readonly": ""
	    },
	    domProps: {
	      "value": (_vm.formatDate)
	    },
	    on: {
	      "click": _vm.openDatePicker,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formatDate = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.active),
	      expression: "!active"
	    }],
	    staticClass: "icon-calendar4 input-icon",
	    on: {
	      "click": _vm.openDatePicker
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.active),
	      expression: "active"
	    }],
	    staticClass: "icon-cross2 input-icon",
	    on: {
	      "click": _vm.closeDatePicker
	    }
	  })]), _vm._v(" "), (_vm.active) ? _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeDatePicker),
	      expression: "closeDatePicker"
	    }],
	    ref: "child_popper",
	    staticClass: "popper-child__container text-dark"
	  }, [_c('div', {
	    staticClass: "datepicker-panel no-select",
	    class: [{
	      'no_weekends': !_vm.weekends
	    }, {
	      'datepicker-panel--show': _vm.isDropdownPopperDone
	    }],
	    attrs: {
	      "id": "datepicker-panel"
	    }
	  }, [_c('div', {
	    staticClass: "month-header overflow font-large"
	  }, [_c('div', {
	    staticClass: "arrow left pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.prevMonth.apply(null, arguments)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-left4"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "arrow right pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.nextMonth.apply(null, arguments)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-right4"
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "center bold",
	    attrs: {
	      "id": "headline"
	    }
	  }, [_vm._v(_vm._s(_vm.datePickerDateFormatted))])]), _vm._v(" "), _c('div', {
	    staticClass: "datepicker-with-weeknums"
	  }, [_c('div', {
	    staticClass: "datepicker-with-weeknums__week-numbers"
	  }, [_c('ul', _vm._l((_vm.weekNumbers), function(week) {
	    return _c('li', [_vm._v(_vm._s(week))])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "datepicker-with-weeknums__datepicker"
	  }, [_c('div', {
	    staticClass: "cal weekdays datepicker-cells"
	  }, _vm._l((_vm.weekDays), function(weekday) {
	    return _c('div', {
	      staticClass: "datepicker-cell weekday"
	    }, [_vm._v("\n              " + _vm._s(_vm.$filters.capitalize(weekday.substring(0, 3))) + "\n            ")])
	  }), 0), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "calBoxContainer"
	    }
	  }, [_c('div', {
	    staticClass: "datepicker-cells",
	    attrs: {
	      "id": "calBox"
	    }
	  }, _vm._l((_vm.dates[0].date), function(date) {
	    return _c('div', {
	      class: ['datepicker-cell ' + date.dayClass, {
	        'datepicker-cell--disabled': date.isDisabled
	      }],
	      attrs: {
	        "aria-label": date.date
	      }
	    }, [(date.show) ? _c('span', {
	      staticClass: "number",
	      class: [{
	        isToday: date.isToday,
	        active: date.isSelected
	      }],
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setDate(date)
	        }
	      }
	    }, [_vm._v(_vm._s(date.showDate))]) : _c('span', {
	      staticClass: "number",
	      class: [{
	        isToday: date.isToday,
	        active: date.isSelected
	      }]
	    }, [_vm._v(_vm._s(date.showDate))])])
	  }), 0)])])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2132 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "to-user-task-container"
	  }, [_c('div', {
	    staticClass: "to-user-task-container__header"
	  }, [(_vm.theActiveUser) ? _c('h2', {
	    staticClass: "to-user-title"
	  }, [_vm._v(_vm._s(_vm.theActiveUser.name))]) : _vm._e(), _vm._v(" "), _c('select', {
	    staticClass: "do-select",
	    domProps: {
	      "value": null
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$emit('setTheActiveUserId', $event.target.value)
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Skift bruger..")]), _vm._v(" "), _vm._l((_vm.users), function(user) {
	    return _c('option', {
	      key: user.id,
	      domProps: {
	        "value": user.id
	      }
	    }, [_vm._v("\n        " + _vm._s(user.name) + "\n      ")])
	  })], 2)]), _vm._v(" "), (_vm.schoolYear && _vm.theActiveUser) ? _c('UserTasks', {
	    attrs: {
	      "isShowHeader": false,
	      "initialStartDate": _vm.schoolYear.employee_time_start,
	      "initialEndDate": _vm.schoolYear.employee_time_end,
	      "user_id": _vm.theActiveUser.id,
	      "user_calendar_id": _vm.theActiveUser.user_calendar_id,
	      "user_name": _vm.theActiveUser.name,
	      "isShowPrintButton": false,
	      "initialIsShowScheduled": false,
	      "isCanSeeOtherUsers": false,
	      "isReactive": true,
	      "isPreviewAsEmployee": true
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2133 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-cal",
	    class: [{
	        'd-cal--multi': _vm.isMultiCalendar
	      },
	      {
	        'd-cal--am-pm': _vm.isLocaleEn
	      },
	      {
	        'd-cal--loading': _vm.isLoadingEvents
	      },
	      {
	        'd-cal--is-list-view': _vm.isShowAsList
	      },
	      {
	        'd-cal--highlight-events': _vm.isCopyCalendarModalOpen
	      }
	    ],
	    attrs: {
	      "id": 'calendar_dom_id_' + _vm.calendarDOMUuid
	    }
	  }, [(_vm.isLoadingEvents) ? _c('div', {
	    staticClass: "d-cal__events-loading"
	  }, [_c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.isShowAsList) ? _c('DCalendarList', {
	    attrs: {
	      "calendarName": _vm.calendarName,
	      "events": _vm.eventsWithMetaData,
	      "date": _vm.date,
	      "isShowWeekends": _vm.isShowWeekends,
	      "firstDayOfWeek": _vm.firstDayOfWeek,
	      "isCalendarInPrintMode": _vm.isCalendarInPrintMode
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isEditable && _vm.calendarId && !_vm.isLocked && !_vm.isMoveOnly) ? _c('DCalendarSubjects', {
	    attrs: {
	      "calendar-id": _vm.calendarId,
	      "dragActiveDate": _vm.dragActiveDate,
	      "school": _vm.school,
	      "locale": _vm.locale,
	      "deleteSubject": _vm.deleteSubject
	    },
	    on: {
	      "movedXY": _vm.setMovedXY,
	      "setDragLesson": _vm.setTheExternalEvent,
	      "setIsDraggingExternalEvent": _vm.setIsDraggingExternalEvent,
	      "doMouseUp": _vm.subjectsMouseUp,
	      "onMouseEnter": _vm.onMouseEnterSubjects,
	      "onMouseLeave": _vm.onMouseLeaveSubjects,
	      "setActiveSubjectBCR": _vm.setTheExternalEventBCR
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isShowAsList) ? _c('div', {
	    staticClass: "d-cal__week"
	  }, [(!_vm.isHideHeader) ? _c('div', {
	    staticClass: "d-cal__header"
	  }, [(_vm.isMultiCalendar) ? _c('div', {
	    staticClass: "d-cal__week__header__name",
	    class: {
	      'd-cal__week__header__name--no-sidebar': !_vm.showSidebar
	    }
	  }, [_vm._v(_vm._s(_vm.calendarName) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "d-cal__week__header"
	  }, [(_vm.showSidebar) ? _c('li', {
	    staticClass: "d-cal__week__header__day--weeknumber"
	  }, [(!_vm.isHideDates) ? [_vm._v(_vm._s((_vm.i18n[_vm.locale] || _vm.i18n['en']).week) + " " + _vm._s(_vm.theWeekNumber))] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.days), function(day) {
	    return _c('li', {
	      staticClass: "d-cal__week__header__day",
	      class: {
	        'd-cal__week__header__day--today': day.isToday
	      }
	    }, [_vm._v("\n          " + _vm._s(_vm.isHideDates ? day.dayName : day.date) + "\n          "), (day.isToday && !_vm.isCalendarInPrintMode) ? _c('span', [_vm._v(_vm._s(_vm.$t('repitition.today')))]) : _vm._e()])
	  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-cal__week__timed"
	  }, [(_vm.showSidebar) ? _c('ul', {
	    staticClass: "d-cal__week__timed__sidebar"
	  }, _vm._l((_vm.hoursInLocale), function(n, key) {
	    return _c('li', {
	      staticClass: "time"
	    }, [(key !== 0) ? _c('span', [_vm._v(_vm._s(n))]) : _vm._e()])
	  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-cal__week__timed__container"
	  }, [_c('ul', {
	    staticClass: "d-cal__week__timed__background"
	  }, [_c('ul', {
	    staticClass: "days-container"
	  }, _vm._l((_vm.days), function(day) {
	    return _c('li', {
	      staticClass: "days-container__day"
	    }, [(_vm.isEditable) ? _c('DCalendarDayDraggable', {
	      attrs: {
	        "calendar": _vm.calendar,
	        "isLocked": _vm.isLocked,
	        "events": _vm.eventsWithMetaData,
	        "calendarId": _vm.calendarId,
	        "calStartTime": _vm.calStartTime,
	        "calEndTime": _vm.calEndTime,
	        "slotHeight": _vm.slotHeight,
	        "isEventsClickable": _vm.isEventsClickable,
	        "date": day.day,
	        "dragLesson": _vm.theDragLesson,
	        "dragEventY": _vm.dragEventY,
	        "dragActiveDate": _vm.dragActiveDate,
	        "dragActiveDates": _vm.dragActiveDates,
	        "dragEventEnd": _vm.dragEventEnd,
	        "dragEventStart": _vm.dragEventStart,
	        "dragEventHeight": _vm.dragEventHeight,
	        "isResizingEvent": _vm.isResizingEvent,
	        "isSideResizingEvent": _vm.isSideResizingEvent,
	        "isDraggingEvent": _vm.isDraggingEvent,
	        "isDraggingExternalEvent": _vm.isDraggingExternalEvent,
	        "theExternalEvent": _vm.theExternalEvent,
	        "isCopyCalendarModalOpen": _vm.isCopyCalendarModalOpen,
	        "showGrid": _vm.showGrid,
	        "gridSlots": _vm.gridSlots,
	        "hoveredSlotIndex": _vm.hoveredSlotIndex,
	        "isMoveOnly": _vm.isMoveOnly
	      },
	      on: {
	        "moveEvent": function($event) {
	          return _vm.$emit('onEventMove', $event)
	        },
	        "setDragEventEnd": _vm.setDragEventEnd,
	        "setDragEventStart": _vm.setDragEventStart,
	        "setDragLesson": _vm.setTheDragLesson,
	        "setDragEventY": _vm.setDragEventY,
	        "setDragEventHeight": _vm.setDragEventHeight,
	        "setDragActiveDate": _vm.setDragActiveDate,
	        "setIsResizingEvent": _vm.setIsResizingEvent,
	        "setIsSideResizingEvent": _vm.setIsSideResizingEvent,
	        "setIsDraggingEvent": _vm.setIsDraggingEvent,
	        "onEventClick": _vm.onEventClick,
	        "onMouseUp": _vm.onMouseUpFromDragging,
	        "startSelectionDeleteDrag": _vm.startSelectionDeleteDrag,
	        "moveSelectionDeleteDrag": _vm.moveSelectionDeleteDrag,
	        "endSelectionDeleteDrag": _vm.endSelectionDeleteDrag,
	        "setIsDraggingExternalEvent": _vm.setIsDraggingExternalEvent,
	        "setTheDeleteSubjectCursorPlacement": _vm.setTheDeleteSubjectCursorPlacement,
	        "setHoveredSlotIndex": _vm.setHoveredSlotIndex
	      }
	    }) : _vm._e(), _vm._v(" "), (!_vm.isEditable) ? _c('DCalendarDay', {
	      attrs: {
	        "events": _vm.eventsWithMetaData,
	        "isCalendarInPrintMode": _vm.isCalendarInPrintMode,
	        "isCalNoBgColors": _vm.isCalNoBgColors,
	        "localeOverride": _vm.locale,
	        "calendarId": _vm.calendarId,
	        "isMobile": _vm.isMobile,
	        "calStartTime": _vm.calStartTime,
	        "calEndTime": _vm.calEndTime,
	        "slotHeight": _vm.slotHeight,
	        "isEventsClickable": _vm.isEventsClickable,
	        "eventFontSize": _vm.eventFontSize,
	        "date": day.day,
	        "isHideCalendars": _vm.isHideCalendars,
	        "isHideDates": _vm.isHideDates
	      },
	      on: {
	        "onPresenceClick": _vm.onPresenceClick,
	        "onEventClick": _vm.onEventClick
	      }
	    }) : _vm._e()], 1)
	  }), 0), _vm._v(" "), _vm._l((_vm.hoursInLocale.length * 2), function(n) {
	    return _c('li', {
	      key: n,
	      staticClass: "time-slot"
	    })
	  })], 2), _vm._v(" "), (_vm.showGrid && _vm.gridSlots.length > 0) ? _c('div', {
	    staticClass: "d-cal__grid-overlay"
	  }, _vm._l((_vm.gridSlots), function(slot) {
	    return _c('div', {
	      key: 'grid-' + slot.index,
	      staticClass: "d-cal__grid-slot",
	      class: {
	        'd-cal__grid-slot--hovered': _vm.hoveredSlotIndex === slot.index
	      },
	      style: ({
	        top: slot.topPx + 'px',
	        height: slot.heightPx + 'px'
	      })
	    }, [_c('span', {
	      staticClass: "d-cal__grid-slot__label"
	    }, [_vm._v(_vm._s(slot.label))])])
	  }), 0) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.movedY && (_vm.theExternalEvent || _vm.deleteSubject) && !_vm.dragActiveDate) ? _c('DCalendarDraggedSubject', {
	    attrs: {
	      "movedY": _vm.movedY,
	      "movedX": _vm.movedX,
	      "deleteSubject": _vm.deleteSubject,
	      "activeSubject": _vm.theExternalEvent,
	      "activeSubjectBCR": _vm.theExternalEventBCR
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isConfirmDeleteModal) ? _c('ModalConfirmation', {
	    staticClass: "d-modal--from-top",
	    attrs: {
	      "show-close": false,
	      "appendToBody": false,
	      "isShowDontAskAgain": true
	    },
	    on: {
	      "close": _vm.closeIsConfirmDelete,
	      "confirm": _vm.onConfirmDeleteEvent
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2134 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('th', [_vm._v("Skemalagte timer")]), _vm._v(" "), _c('th', [_vm._v("Berørte timer")]), _vm._v(" "), _c('th', [_vm._v("Vikar")]), _vm._v(" "), _c('th', [_vm._v("Medlærer, ingen vikar")]), _vm._v(" "), _c('th', [_vm._v("Aflyst")]), _vm._v(" "), _c('th', [_vm._v("Ude af huset")]), _vm._v(" "), _c('th', [_vm._v("Ikke dækket")]), _vm._v(" "), _c('th', [_vm._v("% af tiden med vikar")]), _vm._v(" "), _c('th', [_vm._v("% af berørte timer med vikar")]), _vm._v(" "), _c('th', [_vm._v("% med vikarnoter")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.rows), function(row) {
	    return _c('tr', {
	      key: row.name,
	      class: {
	        'd-table__total': row.isTotal
	      }
	    }, [_c('td', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatHours(row.totalMinutes)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatHours(row.affectedMinutes)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatHours(row.substitute)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatHours(row.coTeacher)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatHours(row.canceled)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatHours(row.away)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatHours(row.uncovered)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatPercent(row.substitute, row.totalMinutes)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatPercent(row.substitute, row.affectedMinutes)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatPercent(row.lessonsWithNotes, row.lessonsWithAbsence)))])])
	  }), _vm._v(" "), (_vm.rows.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "text-center",
	    attrs: {
	      "colspan": "11"
	    }
	  }, [_vm._v("Ingen data i perioden")])]) : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2135 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tabs-list",
	    class: {
	      'tabs-list--large': _vm.isLarge,
	      'tabs-list--flat': _vm.flatDesign
	    },
	    attrs: {
	      "role": "tablist"
	    }
	  }, _vm._l((_vm.tabs), function(tab) {
	    return _c('div', {
	      key: tab.id,
	      class: [
	        'tabs-list__tab',
	        {
	          'tabs-list__tab--selected': _vm.selected === tab.id,
	          'tabs-list__tab--disabled': tab.disabled
	        }
	      ],
	      attrs: {
	        "role": "tab",
	        "tabindex": "0",
	        "aria-selected": String(_vm.selected === tab.id),
	        "aria-disabled": tab.disabled ? 'true' : 'false'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onSelect(tab)
	        },
	        "keydown": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	          return _vm.onSelect(tab)
	        }
	      }
	    }, [_vm._v("\n    " + _vm._s(tab.title) + "\n  ")])
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 2136 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "calendars-bulk text-dark"
	  }, [_c('div', {
	    staticClass: "sub-header no-print"
	  }, [_c('p', {
	    staticClass: "sub-header__item sub-header__title"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendars.calendars')) + "\n      "), _c('span', {
	    staticClass: "sub-header__title-divider icon-arrow-right4"
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "sub-header__item",
	    class: {
	      'sub-header__item--active': _vm.selectedView === 'crudCalendars'
	    },
	    on: {
	      "click": function($event) {
	        _vm.selectedView = 'crudCalendars'
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendars.edit_calendars')))]), _vm._v(" "), _c('p', {
	    staticClass: "sub-header__item",
	    class: {
	      'sub-header__item--active': _vm.selectedView === 'copyCalendars'
	    },
	    on: {
	      "click": function($event) {
	        _vm.selectedView = 'copyCalendars'
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendars.copy_calendars')) + "\n    ")]), _vm._v(" "), (_vm.userHasPermissionToEditOthersPresence) ? _c('p', {
	    staticClass: "sub-header__item",
	    class: {
	      'sub-header__item--active': _vm.selectedView === 'presence'
	    },
	    on: {
	      "click": function($event) {
	        _vm.selectedView = 'presence'
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.calendars.add_presence')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('p', {
	    staticClass: "sub-header__item",
	    class: {
	      'sub-header__item--active': _vm.selectedView === 'deleteDays'
	    },
	    on: {
	      "click": function($event) {
	        _vm.selectedView = 'deleteDays'
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.calendars.delete_events_in_date_range')) + "\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "grid grid-pad min-height"
	  }, [_c('div', {
	    staticClass: "calendars-bulk__header"
	  }, [_c('div', {
	    staticClass: "calendars-bulk__header__left"
	  }, [_c('h1', {
	    staticClass: "marg-20-right text-dark"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendars.calendars')))]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "calendars-bulk__header__right"
	  }, [(_vm.selectedView === 'deleteDays') ? _c('Datepickerrange', {
	    attrs: {
	      "allow-same-date": true,
	      "startdate": _vm.fromDate,
	      "enddate": _vm.toDate
	    },
	    on: {
	      "startchanged": _vm.setFromDate,
	      "endchanged": _vm.setToDate
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.selectedView === 'crudCalendars') ? [_c('CalendarsBulkArchiveCalendar', {
	    attrs: {
	      "calendars": _vm.klassCalendars,
	      "calType": "klass",
	      "isOpen": true
	    }
	  }), _vm._v(" "), _c('CalendarsBulkArchiveCalendar', {
	    attrs: {
	      "calendars": _vm.roomCalendarsInclArchived,
	      "calType": "room"
	    }
	  }), _vm._v(" "), _c('CalendarsBulkArchiveCalendar', {
	    attrs: {
	      "calendars": _vm.mergeCalendarsInclArchived,
	      "calType": "merge"
	    }
	  }), _vm._v(" "), _c('CalendarsBulkArchiveCalendar', {
	    attrs: {
	      "calendars": _vm.otherCalendars,
	      "calType": "other"
	    }
	  })] : _vm._e(), _vm._v(" "), (_vm.selectedView === 'copyCalendars') ? [_c('CopyMultipleCalendars', {
	    attrs: {
	      "calendars": _vm.klassCalendars,
	      "calType": "klass",
	      "isOpen": true
	    }
	  }), _vm._v(" "), _c('CopyMultipleCalendars', {
	    attrs: {
	      "calendars": _vm.userCalendars,
	      "calType": "user"
	    }
	  }), _vm._v(" "), _c('CopyMultipleCalendars', {
	    attrs: {
	      "calendars": _vm.roomCalendarsInclArchived,
	      "calType": "room"
	    }
	  }), _vm._v(" "), _c('CopyMultipleCalendars', {
	    attrs: {
	      "calendars": _vm.mergeCalendarsInclArchived,
	      "calType": "merge"
	    }
	  }), _vm._v(" "), _c('CopyMultipleCalendars', {
	    attrs: {
	      "calendars": _vm.otherCalendars,
	      "calType": "other"
	    }
	  })] : _vm._e(), _vm._v(" "), (_vm.selectedView === 'presence') ? [_c('PresenceForUsers')] : _vm._e(), _vm._v(" "), (_vm.selectedView === 'deleteDays') ? [(_vm.klassCalendars.length > 0) ? _c('CalendarsDeleteEventsInDays', {
	    attrs: {
	      "fromDate": _vm.fromDate,
	      "toDate": _vm.toDate,
	      "calendars": _vm.klassCalendars,
	      "calType": "klass",
	      "isOpen": false
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.kindergartenCalendars.length > 0) ? _c('CalendarsDeleteEventsInDays', {
	    attrs: {
	      "fromDate": _vm.fromDate,
	      "toDate": _vm.toDate,
	      "calendars": _vm.kindergartenCalendars,
	      "calType": "Stuer",
	      "isOpen": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('CalendarsDeleteEventsInDays', {
	    attrs: {
	      "fromDate": _vm.fromDate,
	      "toDate": _vm.toDate,
	      "calendars": _vm.userCalendars,
	      "calType": "user",
	      "isOpen": false
	    }
	  }), _vm._v(" "), _c('CalendarsDeleteEventsInDays', {
	    attrs: {
	      "fromDate": _vm.fromDate,
	      "toDate": _vm.toDate,
	      "calendars": _vm.roomCalendarsInclArchived,
	      "calType": "room",
	      "isOpen": false
	    }
	  }), _vm._v(" "), _c('CalendarsDeleteEventsInDays', {
	    attrs: {
	      "fromDate": _vm.fromDate,
	      "toDate": _vm.toDate,
	      "calendars": _vm.otherCalendars,
	      "calType": "other",
	      "isOpen": false
	    }
	  })] : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2137 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "stil-overview d-timetal__container"
	  }, [_c('h4', {
	    staticClass: "uppercase"
	  }, [_vm._v("Personale")]), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.stilDataRess), function(userType, idx) {
	    return _c('tr', {
	      key: userType.id
	    }, [_c('td', [_vm._v(_vm._s(userType.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.number_of_usertype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.years_of_work))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_40_B))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_50_B))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_40_A1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_50_A1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_40_A22))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_50_A22))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_40_A33))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_50_A33))])])
	  }), 0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {
	    staticClass: "center"
	  }, [_c('tr', [_c('th', {
	    staticStyle: {
	      "min-width": "225px"
	    },
	    attrs: {
	      "rowspan": "2"
	    }
	  }), _vm._v(" "), _c('th', {
	    attrs: {
	      "rowspan": "2"
	    }
	  }, [_vm._v("Antal personer")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "rowspan": "2"
	    }
	  }, [_vm._v("Årsværk")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Arbejdstimer")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Fagopdelt undervisning")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Understøttende undervisning")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Øvrig tid med eleverne")])]), _vm._v(" "), _c('tr', {
	    staticClass: "thead-second-row"
	  }, [_c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")])])])
	}]}

/***/ }),
/* 2138 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('Modal', {
	    attrs: {
	      "show": _vm.showModal
	    },
	    on: {
	      "close": _vm.setCloseModal
	    }
	  }, [_c('h1', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [(_vm.theCreateCalendarsType === 'merge') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.createmerge.create_merge')))]) : _vm._e(), _vm._v(" "), (_vm.theCreateCalendarsType === 'other') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.create_calendars.other_calendar')))]) : _vm._e(), _vm._v(" "), (_vm.theCreateCalendarsType === 'room') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.createrooms.create_rooms')))]) : _vm._e(), _vm._v(" "), (_vm.theCreateCalendarsType === 'club') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.club.create_club_calendar')))]) : _vm._e(), _vm._v(" "), (_vm.theCreateCalendarsType === 'kindergarten') ? _c('span', [_vm._v("Opret stuer")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [(_vm.calendarTypeIsWithSchoolYear) ? _c('h3', {
	    staticClass: "flex align-center marg-1-bottom"
	  }, [(!_vm.isKindergarten) ? [_vm._v(_vm._s(_vm.$t('vue2.createklass.schoolyear')))] : [_vm._v("Periode")], _vm._v(" "), _c('ChangeSchoolYear', {
	    staticClass: "marg-1-left",
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "cr-content"
	  }, [_c('h3', {
	    staticClass: "modal-form__titles"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createmerge.name')))]), _vm._v(" "), _vm._l((_vm.calendars), function(cal) {
	    return _c('div', {
	      staticClass: "modal-form-group"
	    }, [_c('div', {
	      staticClass: "flex create-form"
	    }, [_c('div', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (cal.name),
	        expression: "cal.name"
	      }],
	      staticClass: "namefield",
	      class: {
	        'missing-input': cal.isSameName
	      },
	      attrs: {
	        "type": "text",
	        "placeholder": _vm.placeholderText
	      },
	      domProps: {
	        "value": (cal.name)
	      },
	      on: {
	        "keyup": _vm.checkAllForText,
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(cal, "name", $event.target.value)
	        }
	      }
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "delete__user",
	      on: {
	        "click": function($event) {
	          return _vm.removeCalendar(cal)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-cross2"
	    })])])
	  }), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "add-more-button",
	    on: {
	      "click": _vm.pushNewCalendar
	    }
	  }, [_c('span', {
	    staticClass: "plus--icon"
	  }, [_vm._v("\n            +\n          ")]), _vm._v(" "), _c('span', {
	    staticClass: "add-more-button__text"
	  }, [_vm._v(" " + _vm._s(_vm.$t('vue2.createusers.add_more')))])])])], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "flex flex-end pad-10",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [(_vm.someWithSameName) ? _c('p', {
	    staticClass: "error-message marg-20-right warning-text"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.createmerge.warning_text')))]) : _vm._e(), _vm._v(" "), (_vm.showInactiveButton) ? _c('button', {
	    staticClass: "submit-btn--disabled"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.createusers.create')) + "\n    ")]) : _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.buttonText) + "\n    ")])])])
	},staticRenderFns: []}

/***/ }),
/* 2139 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('Modal', {
	    attrs: {
	      "show": _vm.showModal
	    },
	    on: {
	      "close": _vm.setCloseModal
	    }
	  }, [_c('h1', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createusers.create_users')))]), _vm._v(" "), _c('div', {
	    staticClass: "cu",
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "cu-tab-content"
	  }, [_c('createUserForm', {
	    attrs: {
	      "country": _vm.country,
	      "pushname": _vm.pushNameFromSelect2
	    },
	    on: {
	      "editedUsers": _vm.setUsers,
	      "onNameInput": _vm.checkForDoubleNames
	    }
	  }), _vm._v(" "), (_vm.isSchoolSystem) ? _c('div', {
	    staticClass: "auto-users"
	  }, [(!_vm.showAutoUsersInput) ? _c('div', {
	    staticClass: "auto-users__button",
	    on: {
	      "click": _vm.openAutoUsersInput
	    }
	  }, [_c('span', {
	    staticClass: "plus--icon"
	  }, [_vm._v("+")]), _vm._v(" "), _c('span', {
	    staticClass: "auto-users__button-text"
	  }, [_vm._v("Auto brugere")])]) : _c('div', {
	    staticClass: "auto-users__form"
	  }, [_c('span', [_vm._v("Antal:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.autoUsersCount),
	      expression: "autoUsersCount",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "autoUsersCount",
	    staticClass: "auto-users__count",
	    attrs: {
	      "type": "number",
	      "min": "1",
	      "max": _vm.maxAutoUsers
	    },
	    domProps: {
	      "value": (_vm.autoUsersCount)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.createAutoUsers.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.autoUsersCount = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.createAutoUsers
	    }
	  }, [_vm._v("Opret " + _vm._s(_vm.autoUsersCount) + " brugere")]), _vm._v(" "), _c('span', {
	    staticClass: "auto-users__cancel",
	    on: {
	      "click": function($event) {
	        _vm.showAutoUsersInput = false
	      }
	    }
	  }, [_vm._v("Annuller")])])]) : _vm._e(), _vm._v(" "), (_vm.isTestSchool) ? _c('SearchForCalendar', {
	    staticStyle: {
	      "border-top": "1rem solid #edf0f5"
	    },
	    attrs: {
	      "query": _vm.activeInputName,
	      "calendarType": "users"
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
	    staticClass: "flex flex-end pad-10",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [(_vm.showInactiveButton) ? _c('button', {
	    staticClass: "create-form__submit"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.createusers.create')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.usersToSubmit.length > 0) ? _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.submitUsers
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.buttonText) + "\n    ")]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2140 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "button-spinner"
	  }, [_c('div', {
	    staticClass: "button-spinner__spinner"
	  })])
	}]}

/***/ }),
/* 2141 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "subject-form__prep-factor-wrap",
	    class: [_vm.wrapClass, {
	      'subject-form__prep-factor-wrap--binary': _vm.isBinaryPrepTask
	    }]
	  }, [(_vm.isBinaryPrepTask) ? [_c('div', {
	    staticClass: "d-label-and-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.onPrepToggle(!_vm.isPrepExtraOn)
	      }
	    }
	  }, [_c('label', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: (_vm.toggleTippyOptions),
	      expression: "toggleTippyOptions"
	    }],
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_vm._v(_vm._s(_vm.labels.prep_task_extra_toggle))]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "propOn": _vm.isPrepExtraOn,
	      "allowChanges": false
	    }
	  })], 1)] : [_c('label', {
	    staticStyle: {
	      "margin-bottom": "6px"
	    }
	  }, [_vm._v(_vm._s(_vm.labels.forb_faktor))]), _vm._v(" "), _c('div', {
	    staticClass: "input-group--flex subject-form__prep-factor-inner"
	  }, [(!_vm.isDanishPreparationFactorEditing) ? [_c('div', {
	    staticClass: "flex-1"
	  }, [_c('span', {
	    staticClass: "subject-form__prep-factor-display"
	  }, [_vm._v(_vm._s(_vm.formattedDanishPreparationFactor))])]), _vm._v(" "), _c('div', {
	    staticClass: "input-group--flex__setting-icon"
	  }, [_c('div', {
	    staticClass: "icon__bg-circle",
	    attrs: {
	      "role": "button",
	      "tabindex": "0"
	    },
	    on: {
	      "click": _vm.openDanishPreparationFactorEdit
	    }
	  }, [_c('span', {
	    staticClass: "icon-wrench"
	  })])])] : [_c('div', {
	    staticClass: "flex-1"
	  }, [_c('input', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: (_vm.numericTippyOptions),
	      expression: "numericTippyOptions"
	    }],
	    ref: "inputDanishPreparationFactor",
	    class: _vm.inputClass,
	    attrs: {
	      "type": "number",
	      "step": "0.01",
	      "min": "-1",
	      "max": "1"
	    },
	    domProps: {
	      "value": _vm.numericEditDraft
	    },
	    on: {
	      "input": _vm.onDanishPreparationFactorInput,
	      "blur": _vm.onDanishPreparationFactorBlur,
	      "focus": _vm.selectAllOnFocus
	    }
	  })])]], 2)]], 2)
	},staticRenderFns: []}

/***/ }),
/* 2142 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bttn",
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createuser_button.create_user')))])
	},staticRenderFns: []}

/***/ }),
/* 2143 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "school-year",
	    class: {
	      'white-theme': _vm.whiteTheme
	    }
	  }, [(_vm.schoolYears.length > 1) ? _c('select', {
	    staticClass: "school-year__select",
	    domProps: {
	      "value": _vm.activeSchoolYear.id
	    },
	    on: {
	      "change": function($event) {
	        return _vm.setActiveSchoolYear($event.target.value)
	      }
	    }
	  }, _vm._l((_vm.schoolYears), function(year) {
	    return _c('option', {
	      key: year.id,
	      domProps: {
	        "value": year.id
	      }
	    }, [_vm._v(_vm._s(year.name))])
	  }), 0) : _c('div', {
	    staticClass: "school-year__active"
	  }, [_c('p', [_vm._v(_vm._s(_vm.activeSchoolYear.name))])])])
	},staticRenderFns: []}

/***/ }),
/* 2144 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "td-user-day",
	    class: {
	      'td-user-day--active': _vm.isTheActiveDay
	    },
	    on: {
	      "click": _vm.setCreateEventOnUser
	    }
	  }, [_c('div', {
	    staticClass: "do-events"
	  }, [_vm._l((_vm.filteredEvents), function(event) {
	    return _c('div', {
	      key: event.event_id,
	      staticClass: "do-events__event do-events__event--edit",
	      style: ({
	        backgroundColor: event.color
	      }),
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.editEvent(event)
	        }
	      }
	    }, [_vm._v("\n      " + _vm._s(event.v_time) + "\n    ")])
	  }), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn--small btn-trans do-events__event__add-event"
	  }, [_vm._v("\n      + Tilføj vagt\n    ")])], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2145 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.showTutorial) ? _c('div', [_c('div', {
	    staticClass: "do-yt fadeIn js-dontCloseSidenav"
	  }, [_c('div', {
	    staticClass: "do-yt__container"
	  }, [_c('div', {
	    staticClass: "do-yt__container-close js-dontCloseSidenav",
	    on: {
	      "click": _vm.closeYouTubePopup
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2 js-dontCloseSidenav"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "do-yt__embed",
	    class: {
	      'scaleUp': _vm.classListTimeout
	    }
	  }, [_c('youtube', {
	    ref: "youtube",
	    attrs: {
	      "video-id": _vm.videoId,
	      "player-vars": _vm.videoVars
	    },
	    on: {
	      "ready": _vm.videoReady,
	      "cued": _vm.videoCued,
	      "playing": _vm.videoPlaying,
	      "ended": _vm.videoEnded
	    }
	  })], 1)])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2146 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "directDaySelector"
	  }, _vm._l((_vm.datesInMonths), function(month) {
	    return _c('div', {
	      staticClass: "directDaySelector__month-and-dates"
	    }, [_c('div', {
	      staticClass: "month"
	    }, [_vm._v(_vm._s(month.month.format("MMMM")))]), _vm._v(" "), _c('div', {
	      staticClass: "directDaySelector__month-and-dates__dates"
	    }, _vm._l((month.dates), function(date) {
	      return _c('div', {
	        staticClass: "day",
	        class: {
	          'isSelectable': date.isSelectable,
	          'isWeekend': date.isWeekend,
	          'isInRange': date.isInRange,
	          'isSelected': date.isSelected
	        },
	        on: {
	          "click": function($event) {
	            return _vm.toggle(date)
	          }
	        }
	      }, [_vm._v("\n        " + _vm._s(date.format("D")) + "\n      ")])
	    }), 0)])
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 2147 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "650px"
	    }
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label marg-05-bottom"
	  }, [_vm._v("Vælg medarbejder")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.theSelectedUserId),
	      expression: "theSelectedUserId"
	    }],
	    staticClass: "do-select",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.theSelectedUserId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.onUserIsSelected]
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": ""
	    }
	  }, [_vm._v("Vælg person")]), _vm._v(" "), _vm._l((_vm.users), function(user) {
	    return _c('option', {
	      key: user.id,
	      domProps: {
	        "value": user.id
	      }
	    }, [_vm._v("\n        " + _vm._s(user.name) + "\n      ")])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Indtast første og sidste arbejdsdag for personen (begge dage inklusiv)")]), _vm._v(" "), _c('div', {
	    staticClass: "d-group-flex"
	  }, [_c('DatePickerRange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": function($event) {
	        return _vm.setEndDate($event, true)
	      }
	    }
	  }), _vm._v(" "), (!_vm.isDatesPristine) ? _c('p', {
	    staticClass: "d-link",
	    on: {
	      "click": _vm.resetDates
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Antal feriedage afholdt i perioden")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.numberOfVacationDays),
	      expression: "numberOfVacationDays"
	    }],
	    staticClass: "d-input__number",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.numberOfVacationDays)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.numberOfVacationDays = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Timer pr. uge")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.hoursPerWeek),
	      expression: "hoursPerWeek"
	    }],
	    staticClass: "d-input__number",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.hoursPerWeek)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hoursPerWeek = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('h4', [_vm._v("Udregning")]), _vm._v(" "), _c('table', {
	    staticClass: "do-table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Antal dage")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfDays))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Antal dage uden weekender")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfDaysWithoutWeekends))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfDaysWithoutWeekendsInHours))])]), _vm._v(" "), _c('tr', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom',
	        onShow: function () { return _vm.hasAnyHolidays; }
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  onShow: () => hasAnyHolidays\n                }"
	    }],
	    attrs: {
	      "content": _vm.holidaysAsLabels
	    }
	  }, [_c('td', [_vm._v("Antal søgnehellidage på hverdage")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.filteredHolidays.length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.filteredHolidaysInHours))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Antal arbejdsdage fratrukket søgnehellidage")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfDaysWithoutWeekendsAndHolidays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfDaysWithoutWeekendsAndHolidaysInHours))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ferie afholdt")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfVacationDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfVacationDaysInHours))])]), _vm._v(" "), _c('tr', {
	    staticClass: "d-diff"
	  }, [_c('td', [_vm._v("Mulig arbejdstid")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfWorkDaysPossible))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfWorkDaysPossibleInHours))])]), _vm._v(" "), (_vm.userData) ? [_c('tr', {
	    staticClass: "d-diff"
	  }, [_vm._m(1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userActualHours))])]), _vm._v(" "), (_vm.userData) ? _c('tr', {
	    staticClass: "d-diff"
	  }, [_c('td', [_vm._v("Difference i arbejdstid")]), _vm._v(" "), _c('td'), _vm._v(" "), (_vm.userActualHoursDiff) ? _c('td', [_vm._v(_vm._s(_vm.userActualHoursDiff > 0 ? '+' : '') + _vm._s(_vm.userActualHoursDiff))]) : _vm._e()]) : _vm._e()] : _vm._e()], 2)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('th', [_vm._v("For perioden")]), _vm._v(" "), _c('th', [_vm._v("Dage")]), _vm._v(" "), _c('th', [_vm._v("Timer")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('b', [_vm._v("Præsteret arbejdstid")])])
	}]}

/***/ }),
/* 2148 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "lesson"
	  }, [_c('div', {
	    staticClass: "lesson-time",
	    style: ({
	      borderColor: _vm.event.color
	    })
	  }, [_vm._v("\n    " + _vm._s(_vm.$filters.LT(_vm.event.start_time)) + "\n    "), _c('br'), _vm._v("\n    " + _vm._s(_vm.$filters.LT(_vm.event.end_time)) + "\n  ")]), _vm._v(" "), _c('div', [_vm._v(" " + _vm._s(_vm.event.title)), (_vm.eventHasAnyKlass(_vm.event.klasses)) ? _c('span', [_vm._v(",")]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm._f("klassList")(_vm.event.klasses))), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "meta-info"
	  }, [_vm._v(_vm._s(_vm.showType))])]), _vm._v(" "), (_vm.event.substitute_for) ? _c('div', [_c('span', {
	    staticClass: "icon-users3"
	  }), _vm._v(_vm._s(_vm.$t('vue2.substitute_hours.substitute_for')) + ":\n    " + _vm._s(_vm.event.substitute_for) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "align-right"
	  }, [_vm._v(_vm._s(_vm.eventDuration))])])
	},staticRenderFns: []}

/***/ }),
/* 2149 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.isSubStatusPendingActive && _vm.getIsUserSubstituted) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'left',
	        arrow: false,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window'
	      }),
	      expression: "{\n            placement: 'left',\n             arrow: false,\n           animateFill: false,\n              animation : 'shift-away',\n            zIndex: '999999992',\n             boundary: 'window'\n          }"
	    }],
	    staticClass: "flex set-status",
	    attrs: {
	      "content": _vm.$t('vue2.sub_scheduler.is_substituted')
	    }
	  }, [_c('div', {
	    staticClass: "dot"
	  })]) : _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeDropDown),
	      expression: "closeDropDown"
	    }],
	    staticClass: "flex set-status pointer",
	    class: 'do-' + _vm.dropdownPlacement,
	    on: {
	      "click": function($event) {
	        _vm.showDropdown = true
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dot",
	    class: [_vm.statusDotClass, {
	      'mini-dot--loading': _vm.isSubmitting
	    }]
	  }), _vm._v(" "), _c('div', {
	    staticClass: "arrow icon-arrow-down"
	  }), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
	    staticClass: "dropdown sub-status__dropdown",
	    class: {
	      'sub-status__dropdown--loading': _vm.isSubmitting
	    }
	  }, [(_vm.isSubmitting) ? _c('div', {
	    staticClass: "do-spinner__container"
	  }, [_c('div', {
	    staticClass: "do-spinner do-spinner--large"
	  })]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "sub-status__dropdown__list"
	  }, [(!_vm.getIsUserSubstituted) ? _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setStatus(0)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dot dot-white"
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.not_handled')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isSubStatusPendingActive) ? _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setStatus(2)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dot dot-yellow"
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.pending')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setStatus(1)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dot"
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.handled')) + "\n        ")]), _vm._v(" "), (_vm.othersOnLessonAbsence.length > 0) ? _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setStatusForAll(1)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dot"
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.handled_for_absence')) + "\n        ")]) : _vm._e()])]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2150 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true,
	      "autoFocusField": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Opret klasse på tur")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Vælg klasser")]), _vm._v(" "), _c('DSelectCals', {
	    attrs: {
	      "items": _vm.klassCalendars,
	      "itemsSelected": _vm.selectedKlasses,
	      "multiple": true,
	      "placeholder": _vm.$t('vue2.dselect.placeholder_calendars'),
	      "showCalendarYear": true
	    },
	    on: {
	      "update": _vm.setSelectedKlasses
	    }
	  })], 1), _vm._v(" "), (_vm.selectedKlasses.length > 0) ? [_c('ClassOnTripSubject', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "calendarId": _vm.selectedKlasses[0]['id'],
	      "date": _vm.date,
	      "selectedSubject": _vm.selectedSubject
	    },
	    on: {
	      "setSubject": _vm.setSelectedSubject
	    }
	  })] : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Personale")]), _vm._v(" "), _c('DSelectCals', {
	    attrs: {
	      "items": _vm.userCalendars,
	      "itemsSelected": _vm.selectedUsers,
	      "multiple": true,
	      "placeholder": _vm.$t('vue2.dselect.placeholder_calendars')
	    },
	    on: {
	      "update": _vm.setSelectedUsers
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Dato")]), _vm._v(" "), _c('DateSelector', {
	    attrs: {
	      "date": _vm.date
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "time-changer__group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Tid")]), _vm._v(" "), _c('TimeChanger', {
	    attrs: {
	      "showIcon": true,
	      "start": _vm.startTime,
	      "end": _vm.endTime,
	      "isFiveMinutesInterval": false
	    },
	    on: {
	      "updateStart": _vm.setStartTime,
	      "updateEnd": _vm.setEndTime
	    }
	  })], 1)], 2), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons d-modal__buttons__padding",
	    staticStyle: {
	      "padding": "1rem 3rem"
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.create')) + "\n      ")]) : _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.create')) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 2151 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "school-data"
	  }, [_c('div', {
	    staticClass: "school-data__header"
	  }, [_c('div', {
	    staticClass: "school-data__header__left"
	  }, [_c('h1', [_vm._v("Skemalagte timer")]), _vm._v(" "), _c('changeSchoolYear', {
	    staticClass: "marg-1-right",
	    attrs: {
	      "white-theme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "school-data__header__right"
	  }, [(!_vm.isDatesPristine) ? _c('p', {
	    staticClass: "d-link",
	    on: {
	      "click": _vm.resetDates
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), _c('Datepickerrange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  })], 1)]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
	    staticClass: "loader-container"
	  }, [_c('Loader'), _vm._v(" "), _c('h4', [_vm._v("Snup en kop kaffe, det kan tage et par minutter")])], 1) : [(_vm.filteredCalendars.length < 1) ? _c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen klasser i skoleåret")]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.filteredCalendars), function(calendar) {
	    return _c('li', {
	      key: calendar.id
	    }, [_c('SchoolDataGrade', {
	      attrs: {
	        "calendar": calendar,
	        "eventsInHash": _vm.eventsInHash
	      }
	    })], 1)
	  }), 0)]], 2)
	},staticRenderFns: []}

/***/ }),
/* 2152 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'bottom'\n                }"
	    }],
	    staticClass: "create-btn",
	    attrs: {
	      "content": '<p class=' + 'tooltip-shortcut' + '>' + _vm.$t('vue2.common.press') + '<span>N</span></p>'
	    },
	    on: {
	      "click": _vm.setShowModal
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('vue2.substitution.create_absence')) + "\n  ")]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeIn"
	    }
	  }, [(_vm.showModal) ? _c('AppModal', {
	    attrs: {
	      "modalResponsive": true,
	      "isShowFooter": true,
	      "modalFlexContainer": _vm.isShowSalaryInfoBox || false
	    },
	    on: {
	      "close": _vm.closeModal
	    }
	  }, [_c('h2', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.create_absence')))]), _vm._v(" "), _c('div', {
	    staticClass: "create-absence__form create-absence__form--flex",
	    class: {
	      'create-absence__form--flex--opus-info-box': _vm.isShowSalaryInfoBox
	    },
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "create-absence__form-group-container__left"
	  }, [_c('div', {
	    staticClass: "create__form-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitution.who')))]), _vm._v(" "), _c('SubsCreateDSelect', {
	    attrs: {
	      "id": "create_absence_user",
	      "items": _vm.users
	    },
	    on: {
	      "update": _vm.setUsers
	    }
	  }), _vm._v(" "), (_vm.isAdditionalDataRequired && _vm.usersAbsent.length > 1) ? _c('span', {
	    staticClass: "error-message"
	  }, [_vm._v("\n              Der kan ikke oprettes fravær for flere medarbejdere på én gang, da denne årsag kræver ekstra information.\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.isUserSelected && _vm.showErrorMessages) ? _c('span', {
	    staticClass: "error-message"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.person_must_be_filled')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "create__form-group__flex-container"
	  }, [_c('div', {
	    staticClass: "create__form-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitution.reason')))]), _vm._v(" "), _c('div', {
	    staticClass: "absence-reason"
	  }, [_c('dSelect', {
	    attrs: {
	      "items": _vm.subsAbsenceReasonsSorted,
	      "receiveData": _vm.reasonCreated,
	      "multiple": false,
	      "placeholder": _vm.$t('vue2.substitution.choose_absence_reason'),
	      "itemSpaceBetween": true
	    },
	    on: {
	      "update": _vm.setReason,
	      "searchText": _vm.setReasonSearchText,
	      "onSearchTextDebounced": _vm.onSearchTextDebounced,
	      "enter": function($event) {
	        _vm.isCreateAbsenceReason = true
	      },
	      "close": _vm.onCloseDSelectAbsenceReasons
	    },
	    scopedSlots: _vm._u([(_vm.isAbsenceIntegrationActive) ? {
	      key: "item-badge",
	      fn: function(ref) {
	        var item = ref.item;
	
	        return [(item.kmd_absence_code_id) ? _c('span', {
	          staticClass: "do-opus-badge"
	        }, [_vm._v("OPUS")]) : _vm._e(), _vm._v(" "), (item.sd_absence_code_id) ? _c('span', {
	          staticClass: "do-sd-badge"
	        }, [_vm._v("SD")]) : _vm._e()]
	      }
	    } : null], null, true)
	  }, [_vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "noMatch"
	    },
	    slot: "noMatch"
	  }, [(_vm.userHasPermission('can_manage_absence_reasons')) ? _c('h4', {
	    staticClass: "create-absence-link",
	    on: {
	      "click": function($event) {
	        _vm.isCreateAbsenceReason = true
	      }
	    }
	  }, [_vm._v("\n                      + " + _vm._s(_vm.$t('vue2.substitution.create')) + ": \"" + _vm._s(_vm.reasonSearchText) + "\"\n                    ")]) : _c('h4', [_vm._v("\n                      " + _vm._s(_vm.$t('vue2.dselect.no_matching_results')) + "\n                    ")])])]), _vm._v(" "), (_vm.userHasPermission('can_manage_absence_reasons') && _vm.isShowCreateAbsenceReasonButton) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window'
	      }),
	      expression: "{\n                  arrow: true,\n                  animateFill: false,\n                  animation : 'shift-away',\n                  zIndex: '999999992',\n                  boundary: 'window'\n                }"
	    }],
	    staticClass: "icon__bg-circle absence-reasons__settings",
	    attrs: {
	      "content": _vm.$t("vue2.substitution.create") + " \"" + _vm.reasonSearchText + "\" " + _vm.i18n[_vm.locale]["as_a_new_reason"]
	    },
	    on: {
	      "click": function($event) {
	        _vm.isCreateAbsenceReason = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "d-icon-plus"
	  })]) : _vm._e()], 1), _vm._v(" "), (!_vm.isReasonSelected && _vm.showErrorMessages) ? _c('span', {
	    staticClass: "error-message"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.reason_must_be_filled')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "create__form-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitution.date')))]), _vm._v(" "), _c('div', {
	    staticClass: "date-picker-range-group"
	  }, [_c('DatepickerRange', {
	    attrs: {
	      "allowSameDate": true,
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  }), _vm._v(" "), (_vm.isOngoingAbsenceAllowed && !_vm.isShowSalaryInfoBox) ? _c('div', {
	    staticClass: "absence-no-end-date",
	    class: {
	      'absence-no-end-date--active': _vm.isAbsenceOngoing
	    }
	  }, [_c('div', {
	    staticClass: "absence-no-end-date__inner",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.setIsAbsenceOngoing(!_vm.isAbsenceOngoing)
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "prop-on": _vm.isAbsenceOngoing
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence')))])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
	    staticClass: "text-dark",
	    attrs: {
	      "slot": "answer"
	    },
	    slot: "answer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence_explained')))])])], 1) : (!_vm.isOngoingAbsenceDateAllowed && !_vm.isShowSalaryInfoBox) ? _c('div', {
	    staticClass: "absence-no-end-date"
	  }, [_c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.cant_be_ongoing_absence')))])]) : _vm._e()], 1), _vm._v(" "), (_vm.isAbsenceOnlyOnWeekend) ? _c('span', {
	    staticClass: "error-message"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['absence_only_on_weekend']))]) : _vm._e(), _vm._v(" "), (_vm.absentUsersWithOngoingAbsenceAlready.length > 0) ? _c('div', {
	    staticClass: "do-warning marg-1-top"
	  }, [_vm._l((_vm.absentUsersWithOngoingAbsenceAlready), function(user) {
	    return _c('b', {
	      key: user,
	      staticClass: "marg-05-right"
	    }, [_vm._v(_vm._s(user) + " ")])
	  }), _vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['already_has_ongoing_absence']) + "\n            ")], 2) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "create__form-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitution.time')))]), _vm._v(" "), _c('div', {
	    staticClass: "time-changer__group"
	  }, [_c('TimeChanger', {
	    attrs: {
	      "showIcon": true,
	      "start": _vm.startTime,
	      "end": _vm.endTime,
	      "isFiveMinutesInterval": false
	    },
	    on: {
	      "updateStart": _vm.setStartTime,
	      "updateEnd": _vm.setEndTime
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "hint--right",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['set_default_start_and_endtime']
	    }
	  }, [_c('div', {
	    staticClass: "icon__bg-circle time-changer__settings",
	    on: {
	      "click": function($event) {
	        _vm.isShowSettings = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cog2"
	  })])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "create__form-group create__form-group__note-to-absence"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['note_to_absence']))]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.noteForAbsentReason),
	      expression: "noteForAbsentReason"
	    }],
	    staticClass: "d-input",
	    domProps: {
	      "value": (_vm.noteForAbsentReason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.noteForAbsentReason = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), (_vm.isShowSalaryInfoBox) ? _c('div', {
	    staticClass: "create-absence__form-group-container__right"
	  }, [(!_vm.isLoadedSalarySystemInfo) ? _c('div', {
	    staticClass: "create-absence__salary-system-info-container"
	  }, [_c('div', {
	    staticClass: "do-spinner"
	  })]) : _vm._e(), _vm._v(" "), (_vm.isLoadedSalarySystemInfo && _vm.isShowSdInfoBox) ? _c('div', {
	    staticClass: "create-absence__salary-system-info"
	  }, [_c('div', {
	    staticClass: "do-sd-badge do-opus-badge--large opus-info__header"
	  }, [_vm._v("SD")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Ansættelse")]), _vm._v(" "), _c('div', {
	    staticClass: "users-employment-selection"
	  }, [_vm._l((_vm.usersAbsent), function(userCalendarId) {
	    return _c('div', {
	      key: userCalendarId,
	      staticClass: "marg-1-bottom"
	    }, [(_vm.usersAbsent.length > 1) ? _c('label', {
	      staticClass: "d-label marg-025-bottom"
	    }, [_vm._v(_vm._s(_vm.getUserName(userCalendarId)))]) : _vm._e(), _vm._v(" "), _c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selectedEmploymentIds[userCalendarId]),
	        expression: "selectedEmploymentIds[userCalendarId]"
	      }],
	      staticClass: "do-select",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(_vm.selectedEmploymentIds, userCalendarId, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, function($event) {
	          return _vm.onEmploymentChange(userCalendarId, $event.target.value)
	        }]
	      }
	    }, [_c('option', {
	      attrs: {
	        "value": ""
	      }
	    }, [_vm._v("— Vælg ansættelsesnummer —")]), _vm._v(" "), _vm._l((_vm.getUserEmployments(userCalendarId)), function(employment) {
	      return _c('option', {
	        key: employment.id,
	        domProps: {
	          "value": employment.id
	        }
	      }, [_vm._v("\n                      " + _vm._s(employment.title) + " - " + _vm._s(employment.employment_number || employment.id) + "\n                    ")])
	    })], 2)])
	  }), _vm._v(" "), (!_vm.isEmploymentSelected && _vm.showErrorMessages) ? _c('span', {
	    staticClass: "error-message"
	  }, [_vm._v("\n                  Ansættelsesnummer skal vælges for alle medarbejdere\n                ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Fraværsårsag")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__reason-display"
	  }, [(_vm.getSDAbsence) ? _c('span', {
	    staticClass: "opus-info__reason-code"
	  }, [_vm._v("\n                  " + _vm._s(_vm.getSDAbsence.loenart) + _vm._s(_vm.getSDAbsence.title ? ' - ' + _vm.getSDAbsence.title : '') + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Dato")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__date-text"
	  }, [(_vm.isAbsenceOngoing) ? _c('span', [_vm._v(_vm._s(_vm.startDateFormatted) + " - Åbenstående")]) : _c('span', [_vm._v(_vm._s(_vm.dateRangeFormatted) + " "), _c('span', {
	    staticClass: "opus-info__date-days"
	  }, [_vm._v("(" + _vm._s(_vm.dateRangeDaysFormatted) + ")")])])]), _vm._v(" "), (_vm.isOngoingAbsenceAllowed) ? _c('div', {
	    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
	  }, [_c('div', {
	    staticClass: "do-opus-whole-day-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.setIsAbsenceOngoing(!_vm.isAbsenceOngoing)
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "prop-on": _vm.isAbsenceOngoing
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Indberet som åbenstående")])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
	    staticClass: "text-dark",
	    attrs: {
	      "slot": "answer"
	    },
	    slot: "answer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence_explained')))])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Tid")]), _vm._v(" "), (_vm.useTime) ? _c('div', {
	    staticClass: "opus-info__date-text"
	  }, [_vm._v("\n                " + _vm._s(_vm.startTime.format('HH:mm')) + " - " + _vm._s(_vm.endTime.format('HH:mm')) + " "), _c('span', {
	    staticClass: "opus-info__date-days"
	  }, [_vm._v("(" + _vm._s(_vm.timeRangeHoursFormatted) + ")")])]) : _c('div', {
	    staticClass: "opus-info__date-text"
	  }, [_vm._v("\n                Hel dag\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
	  }, [_c('div', {
	    staticClass: "do-opus-whole-day-toggle",
	    on: {
	      "click": function($event) {
	        _vm.useTime = !_vm.useTime
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "prop-on": !_vm.useTime
	    },
	    on: {
	      "toggled": function($event) {
	        _vm.useTime = $event
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Indberet som hel dag")])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
	    staticClass: "text-dark",
	    attrs: {
	      "slot": "answer"
	    },
	    slot: "answer"
	  }, [_vm._v("Toggle fra for at indberette timebaseret fravær, hvis fraværet kun gælder en del af dagen.")])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isLoadedSalarySystemInfo && _vm.isShowOpusInfoBox) ? _c('div', {
	    staticClass: "create-absence__salary-system-info"
	  }, [_c('div', {
	    staticClass: "do-opus-badge do-opus-badge--large opus-info__header"
	  }, [_vm._v("Opus")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Ansættelse")]), _vm._v(" "), _c('div', {
	    staticClass: "users-employment-selection"
	  }, [_vm._l((_vm.usersAbsent), function(userCalendarId) {
	    return _c('div', {
	      key: userCalendarId,
	      staticClass: "marg-1-bottom"
	    }, [(_vm.usersAbsent.length > 1) ? _c('label', {
	      staticClass: "d-label marg-025-bottom"
	    }, [_vm._v(_vm._s(_vm.getUserName(userCalendarId)))]) : _vm._e(), _vm._v(" "), _c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selectedEmploymentIds[userCalendarId]),
	        expression: "selectedEmploymentIds[userCalendarId]"
	      }],
	      staticClass: "do-select",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(_vm.selectedEmploymentIds, userCalendarId, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, function($event) {
	          return _vm.onEmploymentChange(userCalendarId, $event.target.value)
	        }]
	      }
	    }, [_c('option', {
	      attrs: {
	        "value": ""
	      }
	    }, [_vm._v("— Vælg ansættelsesnummer —")]), _vm._v(" "), _vm._l((_vm.getUserEmployments(userCalendarId)), function(employment) {
	      return _c('option', {
	        key: employment.id,
	        domProps: {
	          "value": employment.id
	        }
	      }, [_vm._v("\n                      " + _vm._s(employment.title) + " - " + _vm._s(employment.employment_number || employment.id) + "\n                    ")])
	    })], 2)])
	  }), _vm._v(" "), (!_vm.isEmploymentSelected && _vm.showErrorMessages) ? _c('span', {
	    staticClass: "error-message"
	  }, [_vm._v("\n                  Ansættelsesnummer skal vælges for alle medarbejdere\n                ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Fraværsårsag")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__reason-display"
	  }, [(_vm.getOPUSAbsence) ? _c('span', {
	    staticClass: "opus-info__reason-code"
	  }, [_vm._v("\n                  " + _vm._s(_vm.getOPUSAbsence.absence_type) + _vm._s(_vm.getOPUSAbsence.absence_type_text ? ' - ' + _vm.getOPUSAbsence.absence_type_text : '') + "\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.isShowExtraInformation) ? _c('div', {
	    staticClass: "opus-info__extra-info"
	  }, [(_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'Maternity') ? [_c('label', {
	    staticClass: "opus-info__label opus-info__label--secondary"
	  }, [_vm._v("Ekstra information til barselssager")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
	    staticClass: "do-spinner do-spinner--small"
	  }) : (_vm.additionalDataError) ? _c('div', {
	    staticClass: "opus-info__error"
	  }, [_c('span', {
	    staticClass: "opus-info__error-icon"
	  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAdditionalData),
	      expression: "selectedAdditionalData"
	    }],
	    staticClass: "do-select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
	    return _c('option', {
	      key: option.MaternityCaseKey,
	      domProps: {
	        "value": option.MaternityCaseKey
	      }
	    }, [_vm._v("\n                      " + _vm._s(option.ExpectedDeliveryDate) + " - " + _vm._s(option.MaternityCaseKey) + "\n                    ")])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasLoadedAdditionalData && _vm.additionalDataOptions.length === 0) ? _c('p', {
	    staticClass: "opus-info__note"
	  }, [_vm._v("\n                    Der er ingen barselssager tilknyttet denne medarbejder i Opus.\n                  ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'Reason') ? [_c('label', {
	    staticClass: "opus-info__label opus-info__label--secondary"
	  }, [_vm._v("Ekstra information til tjenestefri")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
	    staticClass: "do-spinner do-spinner--small"
	  }) : (_vm.additionalDataError) ? _c('div', {
	    staticClass: "opus-info__error"
	  }, [_c('span', {
	    staticClass: "opus-info__error-icon"
	  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAdditionalData),
	      expression: "selectedAdditionalData"
	    }],
	    staticClass: "do-select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
	    return _c('option', {
	      key: option.ReasonCode,
	      domProps: {
	        "value": option.ReasonCode
	      }
	    }, [_vm._v("\n                      " + _vm._s(option.ReasonCodeText) + " - " + _vm._s(option.ReasonCode) + "\n                    ")])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasLoadedAdditionalData && _vm.additionalDataOptions.length === 0) ? _c('p', {
	    staticClass: "opus-info__note"
	  }, [_vm._v("\n                    Der er ingen tjenestefri årsager tilknyttet denne medarbejder i Opus.\n                  ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'WorkInjury') ? [_c('label', {
	    staticClass: "opus-info__label opus-info__label--secondary"
	  }, [_vm._v("Ekstra information til arbejdsskader")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
	    staticClass: "do-spinner do-spinner--small"
	  }) : (_vm.additionalDataError) ? _c('div', {
	    staticClass: "opus-info__error"
	  }, [_c('span', {
	    staticClass: "opus-info__error-icon"
	  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAdditionalData),
	      expression: "selectedAdditionalData"
	    }],
	    staticClass: "do-select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
	    return _c('option', {
	      key: option.AccidentNumber,
	      domProps: {
	        "value": option.AccidentNumber
	      }
	    }, [_vm._v("\n                      " + _vm._s(option.AccidentDate) + " - " + _vm._s(option.AccidentNumber) + "\n                    ")])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasLoadedAdditionalData && _vm.additionalDataOptions.length === 0) ? _c('p', {
	    staticClass: "opus-info__note"
	  }, [_vm._v("\n                    Der er ingen arbejdsskadesager tilknyttet denne medarbejder i Opus.\n                  ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'Child') ? [_c('label', {
	    staticClass: "opus-info__label opus-info__label--secondary"
	  }, [_vm._v("Ekstra information til omsorgsdage")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
	    staticClass: "do-spinner do-spinner--small"
	  }) : (_vm.additionalDataError) ? _c('div', {
	    staticClass: "opus-info__error"
	  }, [_c('span', {
	    staticClass: "opus-info__error-icon"
	  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAdditionalData),
	      expression: "selectedAdditionalData"
	    }],
	    staticClass: "do-select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
	    return _c('option', {
	      key: option.ChildNumber,
	      domProps: {
	        "value": option.ChildNumber
	      }
	    }, [_vm._v("\n                      " + _vm._s(option.FirstName) + " " + _vm._s(option.LastName) + " - " + _vm._s(option.ChildNumber) + "\n                    ")])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasLoadedAdditionalData && _vm.additionalDataOptions.length === 0) ? _c('p', {
	    staticClass: "opus-info__note"
	  }, [_vm._v("\n                    Der er ingen barn tilknyttet denne medarbejder i Opus.\n                  ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.isAdditionalDataSelected && _vm.showErrorMessages) ? _c('span', {
	    staticClass: "error-message"
	  }, [_vm._v("\n                    " + _vm._s(_vm.additionalDataValidationError) + "\n                  ")]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Dato")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__date-text"
	  }, [(_vm.isAbsenceOngoing) ? _c('span', [_vm._v(_vm._s(_vm.startDateFormatted) + " →")]) : _c('span', [_vm._v(_vm._s(_vm.dateRangeFormatted) + " "), _c('span', {
	    staticClass: "opus-info__date-days"
	  }, [_vm._v("(" + _vm._s(_vm.dateRangeDaysFormatted) + ")")])])]), _vm._v(" "), (_vm.isOngoingAbsenceAllowed) ? _c('div', {
	    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
	  }, [_c('div', {
	    staticClass: "do-opus-whole-day-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.setIsAbsenceOngoing(!_vm.isAbsenceOngoing)
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "prop-on": _vm.isAbsenceOngoing
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Indberet som åbenstående")])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
	    staticClass: "text-dark",
	    attrs: {
	      "slot": "answer"
	    },
	    slot: "answer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence_explained')))])])], 1) : (!_vm.isOpusAllowOpen) ? _c('p', {
	    staticClass: "opus-info__note--muted"
	  }, [_vm._v("\n                Åbenstående fravær er ikke muligt for denne fraværsårsag\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__field"
	  }, [_c('label', {
	    staticClass: "opus-info__label"
	  }, [_vm._v("Tid")]), _vm._v(" "), (_vm.useTime) ? _c('div', {
	    staticClass: "opus-info__date-text"
	  }, [_vm._v("\n                " + _vm._s(_vm.startTime.format('HH:mm')) + " - " + _vm._s(_vm.endTime.format('HH:mm')) + " "), _c('span', {
	    staticClass: "opus-info__date-days"
	  }, [_vm._v("(" + _vm._s(_vm.timeRangeHoursFormatted) + ")")])]) : _c('div', {
	    staticClass: "opus-info__date-text"
	  }, [_vm._v("\n                Hel dag\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
	  }, [_c('div', {
	    staticClass: "do-opus-whole-day-toggle",
	    on: {
	      "click": function($event) {
	        _vm.useTime = !_vm.useTime
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "prop-on": !_vm.useTime
	    },
	    on: {
	      "toggled": function($event) {
	        _vm.useTime = $event
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Indberet som hel dag")])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
	    staticClass: "text-dark",
	    attrs: {
	      "slot": "answer"
	    },
	    slot: "answer"
	  }, [_vm._v("Toggle fra for at indberette timebaseret fravær, hvis fraværet kun gælder en del af dagen.")])])], 1)])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'top',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n                  placement : 'top',\n                  zIndex: 12312312312312  \n                }"
	    }],
	    staticClass: "bttn create-btn right marg-10",
	    attrs: {
	      "content": _vm.saveKeyTooltip
	    },
	    on: {
	      "click": _vm.submitUser
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.substitution.create_absence')) + "\n        ")])])]) : _vm._e()], 1), _vm._v(" "), (_vm.isShowSettings) ? _c('DModal', {
	    on: {
	      "close": function($event) {
	        _vm.isShowSettings = false
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    staticStyle: {
	      "width": "400px"
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['standard_setting']))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.isShowSettings = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('label', {
	    staticClass: "d-input marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['set_default_start_and_endtime']))]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group-flex"
	  }, [_c('TimeChanger', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "showIcon": true,
	      "start": _vm.standardStartTime,
	      "end": _vm.standardEndTime,
	      "isFiveMinutesInterval": false
	    },
	    on: {
	      "updateStart": _vm.setStandardStartTime,
	      "updateEnd": _vm.setStandardEndTime
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "bttn bttn-simple marg-1-right",
	    on: {
	      "click": function($event) {
	        _vm.isShowSettings = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.submitStandardSettings
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isCreateAbsenceReason) ? _c('AbsenceReasonsCreate', {
	    attrs: {
	      "initTitle": _vm.reasonSearchText
	    },
	    on: {
	      "create": _vm.createAbsenceReason,
	      "cancel": function($event) {
	        _vm.isCreateAbsenceReason = false
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2153 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'right'
	      }),
	      expression: "{arrow: true,placement : 'right'}"
	    }],
	    staticClass: "team-calendar-activator text-dark no-print",
	    class: {
	      'team-calendar-activator--is-active': _vm.showTeamCalendar
	    },
	    attrs: {
	      "content": '<p class=' + 'tooltip-shortcut' + '>' + _vm.$t('vue2.common.press') + '<span>S</span></p>'
	    },
	    on: {
	      "click": _vm.toggleShowTeamCalendar
	    }
	  }, [_c('button', {
	    staticClass: "box-shadow submit-button button--rounded"
	  }, [(!_vm.showTeamCalendar) ? _c('span', {
	    staticClass: "icon-users"
	  }) : _c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.i18n[_vm.locale]['button_text'])
	    }
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeIn"
	    }
	  }, [(_vm.showTeamCalendar) ? _c('div', {
	    staticClass: "background-overlay"
	  }) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "slideUp"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showTeamCalendar),
	      expression: "showTeamCalendar"
	    }],
	    staticClass: "overlay-calendars text-dark"
	  }, [_c('div', {
	    staticClass: "team-calendar",
	    class: {
	      'team-calendar--week-view': _vm.calView === 'resourceTimeGridFiveDay' || _vm.calView === 'overlayWeek'
	    }
	  }, [_c('div', {
	    staticClass: "team-calendar__header flex space-between no-print"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['team_calendar']))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle team-calendar__close-cross pointer font-large no-print",
	    on: {
	      "click": _vm.closeTeamCalendar
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "team-calendar__body"
	  }, [_c('calHeader', {
	    attrs: {
	      "date": _vm.date,
	      "calview": _vm.calView,
	      "itemsSelected": _vm.selectedRess,
	      "selectedScrollOption": _vm.selectedScrollOption,
	      "isDragAndDropOn": _vm.isDragAndDropOn,
	      "isDragAndDropPossible": _vm.isUserCanEditCalendar
	    },
	    on: {
	      "setIsDragAndDropOn": _vm.setIsDragAndDropOn,
	      "dateChange": _vm.setDate,
	      "setView": _vm.setCalView,
	      "updateEvents": _vm.updateEvents,
	      "usersUpdated": _vm.setSelectedRess,
	      "changedSortOption": _vm.setSortOption,
	      "setSelectedScrollOption": _vm.setSelectedScrollOption
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "team-calendar__calendars",
	    class: {
	      'team-calendar__calendars--loading-events': _vm.isLoadingEvents && (_vm.isCalendarView || _vm.isPresenceTableView)
	    },
	    attrs: {
	      "id": "printTeamCalendar"
	    }
	  }, [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isLoadingEvents && (_vm.isCalendarView || _vm.isPresenceTableView)) ? _c('div', {
	    staticClass: "team-calendar__loader-container"
	  }, [_c('spinner', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }), _vm._v(" "), _c('h4', {
	    staticClass: "italic"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['loading_events']))])], 1) : _vm._e(), _vm._v(" "), (_vm.calView === 'doubleBookings') ? _c('Collisions', {
	    attrs: {
	      "date": _vm.date,
	      "show": _vm.showTeamCalendar
	    },
	    on: {
	      "prevDay": _vm.setPrevDay,
	      "nextDay": _vm.setNextDay,
	      "updated": function($event) {
	        _vm.hasChanges = true
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isPresenceTableView && _vm.selectedRess.length > 0 && !_vm.isLoading) ? _c('TeamCalendarPresenceTable', {
	    attrs: {
	      "calendars": _vm.selectedRess,
	      "events": _vm.events,
	      "date": _vm.date,
	      "locale": _vm.locale,
	      "isShowWeekends": _vm.isShowWeekends
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isSchedulerView && !_vm.isLoading) ? _c('dScheduler', {
	    attrs: {
	      "calendars": _vm.selectedRess,
	      "events": _vm.events,
	      "title": _vm.schedulerDate,
	      "isLoading": _vm.isLoadingEvents
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowSchedulerShortcut) ? _c('dScheduler', {
	    attrs: {
	      "title": _vm.schedulerDate,
	      "calendars": _vm.theSchedulerCalendars,
	      "isLoading": _vm.isLoadingEvents,
	      "events": _vm.theSchedulerEvents,
	      "sortBy": _vm.theSortOptionForAllSchedules
	    }
	  }) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "zoomIn"
	    }
	  }, [(_vm.activeEvent) ? _c('DCalendarShowEvent', {
	    attrs: {
	      "event": _vm.activeEvent,
	      "calendar": _vm.activeCalendar,
	      "initCalendarId": _vm.activeEventCalendarId
	    },
	    on: {
	      "updated": _vm.onEventUpdated,
	      "close": function($event) {
	        return _vm.setActiveEvent(null)
	      }
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.isOverlayWeekView && _vm.selectedRess.length > 0 && !_vm.isLoading) ? _c('div', {
	    staticClass: "calendar_container",
	    class: {
	      'calendar_container--side-scroll': _vm.selectedScrollOption === 'horizontal'
	    }
	  }, [_c('div', {
	    staticClass: "d-cals"
	  }, [_c('div', {
	    staticClass: "d-cals__calendar"
	  }, [(_vm.overlayCalendarLegend.length > 0) ? _c('div', {
	    staticClass: "overlay-legend"
	  }, _vm._l((_vm.overlayCalendarLegend), function(item) {
	    return _c('div', {
	      key: item.id,
	      staticClass: "overlay-legend__item"
	    }, [_c('span', {
	      staticClass: "overlay-legend__swatch",
	      style: ({
	        backgroundColor: item.color
	      })
	    }), _vm._v(" "), _c('span', {
	      staticClass: "overlay-legend__label"
	    }, [_vm._v(_vm._s(item.name))])])
	  }), 0) : _vm._e(), _vm._v(" "), _c('DCalendar', {
	    attrs: {
	      "initNumberOfDays": 5,
	      "isMultiCalendar": false,
	      "isShowStudents": true,
	      "date": _vm.date,
	      "isEventsClickable": _vm.isUserCanEditCalendar,
	      "events": _vm.overlayEvents,
	      "startTime": _vm.startTime,
	      "endTime": _vm.endTime,
	      "isShowWeek": true,
	      "isShowWeekends": true,
	      "calendarId": _vm.overlayCalendarId,
	      "calendarName": _vm.i18n[_vm.locale]['overlay_week_title'],
	      "showSidebar": true,
	      "isShowAsList": false
	    },
	    on: {
	      "onEventClick": _vm.setActiveEventForOverlay
	    }
	  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.selectedRess.length > 0 && _vm.isCalendarView && !_vm.isOverlayWeekView && !_vm.isPresenceTableView && !_vm.isLoading) ? _c('div', {
	    ref: "calContainerRef",
	    staticClass: "calendar_container",
	    class: {
	      'calendar_container--side-scroll': _vm.selectedScrollOption === 'horizontal'
	    }
	  }, [_c('div', {
	    staticClass: "d-cals"
	  }, _vm._l((_vm.selectedRess), function(calendar, idx) {
	    return _c('div', {
	      key: calendar.id,
	      staticClass: "d-cals__calendar"
	    }, [_c('DCalendar', {
	      attrs: {
	        "initNumberOfDays": _vm.userCustomNumberOfDays,
	        "isMultiCalendar": true,
	        "isShowStudents": true,
	        "date": _vm.date,
	        "isEventsClickable": _vm.isUserCanEditCalendar,
	        "isEditable": _vm.isDragAndDropActive,
	        "isMoveOnly": true,
	        "calendar": calendar,
	        "events": _vm.getCalendarEvents(calendar.id),
	        "startTime": _vm.startTime,
	        "endTime": _vm.endTime,
	        "isShowWeek": _vm.isShowWeek,
	        "isShowWeekends": _vm.isShowWeekends,
	        "calendarId": calendar.id,
	        "calendarName": calendar.name,
	        "showSidebar": idx % 5 === 0,
	        "isShowAsList": _vm.isListView
	      },
	      on: {
	        "onEventClick": function($event) {
	          return _vm.setActiveEvent($event, calendar)
	        },
	        "onEventMove": _vm.moveEvent
	      }
	    })], 1)
	  }), 0)]) : _vm._e()], 1)], 1)])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2154 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal"
	  }, [_c('div', {
	    staticClass: "d-timetal__container"
	  }, [_vm._m(0), _vm._v(" "), (_vm.isLoadingStilData) ? _c('div', {
	    staticStyle: {
	      "width": "500px"
	    }
	  }, [_c('Loader')], 1) : [_c('GrundskoleIndberetningTimetal', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "stilData": _vm.stilData,
	      "isReadOnly": true
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "submit-bttn__container"
	  }, [_c('button', {
	    staticClass: "bttn bttn--primary",
	    class: {
	      'bttn--loading': _vm.isSendingToStil
	    },
	    staticStyle: {
	      "width": "165px"
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Afslut og indberet\n        ")])])]], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container__header"
	  }, [_c('h2', {
	    staticClass: "uppercase"
	  }, [_vm._v("Resume")])])
	}]}

/***/ }),
/* 2155 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "school-data"
	  }, [_c('div', {
	    staticClass: "school-data__header"
	  }, [_c('div', {
	    staticClass: "school-data__header__left"
	  }, [_c('h1', [_vm._v("Vikarkontinuitet")]), _vm._v(" "), _c('changeSchoolYear', {
	    staticClass: "marg-1-right",
	    attrs: {
	      "white-theme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "school-data__header__right"
	  }, [(!_vm.isDatesPristine) ? _c('p', {
	    staticClass: "d-link",
	    on: {
	      "click": _vm.resetDates
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), _c('Datepickerrange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  })], 1)]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
	    staticClass: "loader-container"
	  }, [_c('Loader'), _vm._v(" "), _c('h4', [_vm._v("Snup en kop kaffe, det kan tage et par minutter")])], 1) : [_c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n      Viser for hver klasse og hvert fag, hvor mange forskellige vikarer der har dækket, og hvor stor en andel af vikartimerne den mest brugte vikar har haft.\n      En høj andel betyder, at det i høj grad er den samme vikar, der underviser.\n    ")]), _vm._v(" "), (_vm.klassRows.length < 1) ? _c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen vikartimer i perioden")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.klassRows), function(klass) {
	    return _c('table', {
	      key: klass.name,
	      staticClass: "d-table"
	    }, [_c('thead', [_c('tr', {
	      staticClass: "d-table__klass",
	      on: {
	        "click": function($event) {
	          return _vm.toggleKlass(klass.name)
	        }
	      }
	    }, [_c('th', [_c('span', {
	      class: _vm.openKlasses.indexOf(klass.name) > -1 ? 'icon-arrow-down4' : 'icon-arrow-right4'
	    }), _vm._v("\n          " + _vm._s(klass.name) + "\n        ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.formatHours(klass.minutes)) + " vikartimer")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(klass.substitutes.length) + " vikarer")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(klass.topSubstitute.name))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.formatPercent(klass.topSubstitute.minutes, klass.minutes)))])]), _vm._v(" "), (_vm.openKlasses.indexOf(klass.name) > -1) ? _c('tr', {
	      staticClass: "d-table__columns"
	    }, [_c('th', [_vm._v("Fag")]), _vm._v(" "), _c('th', [_vm._v("Vikartimer")]), _vm._v(" "), _c('th', [_vm._v("Antal vikarer")]), _vm._v(" "), _c('th', [_vm._v("Mest brugte vikar")]), _vm._v(" "), _c('th', [_vm._v("Andel for mest brugte vikar")])]) : _vm._e()]), _vm._v(" "), (_vm.openKlasses.indexOf(klass.name) > -1) ? _c('tbody', _vm._l((klass.subjects), function(subject) {
	      return _c('tr', {
	        key: subject.name
	      }, [_c('td', [_vm._v(_vm._s(subject.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatHours(subject.minutes)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject.substitutes.length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject.topSubstitute.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatPercent(subject.topSubstitute.minutes, subject.minutes)))])])
	    }), 0) : _vm._e()])
	  })]], 2)
	},staticRenderFns: []}

/***/ }),
/* 2156 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('AbsentToday', {
	    attrs: {
	      "is-subs-today": false,
	      "is-public": true
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 2157 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('DSelect', {
	    attrs: {
	      "items": _vm.usersAndTags,
	      "isLoading": _vm.isLoading,
	      "itemsSelected": _vm.selectedUsers,
	      "show": _vm.showDropDown,
	      "allDataLoaded": _vm.allDataLoaded,
	      "multiple": _vm.multiple
	    },
	    on: {
	      "add": _vm.addUser,
	      "remove": _vm.removeUser,
	      "show": _vm.setShow,
	      "update": _vm.setSelectedUsers,
	      "searchText": _vm.setCreateUserText
	    },
	    scopedSlots: _vm._u([{
	      key: "item_identifier",
	      fn: function(props) {
	        return [_vm._t("default", null, {
	          "slot": "item_identifier",
	          "userId": props.userId
	        })]
	      }
	    }], null, true)
	  }, [_vm._v(" "), (_vm.showCreateButton) ? _c('template', {
	    slot: "noMatch"
	  }, [_c('h4', [_c('span', {
	    staticClass: "marg-10-right pad-10"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.dselect.no_matching_results')) + " ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-blue bttn-inline",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.createCalendarOnDSelect.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.dselect.create_user')) + "\n        ")])])]) : _vm._e()], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2158 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "school-data"
	  }, [_c('div', {
	    staticClass: "school-data__header"
	  }, [_c('div', {
	    staticClass: "school-data__header__left"
	  }, [_c('h1', [_vm._v("Fraværstyper fordelt over måneder")]), _vm._v(" "), _c('changeSchoolYear', {
	    staticClass: "marg-1-right",
	    attrs: {
	      "white-theme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "school-data__header__right"
	  }, [(!_vm.isDatesPristine) ? _c('p', {
	    staticClass: "d-link",
	    on: {
	      "click": _vm.resetDates
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), _c('Datepickerrange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  })], 1)]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
	    staticClass: "loader-container"
	  }, [_c('Loader'), _vm._v(" "), _c('h4', [_vm._v("Snup en kop kaffe, det kan tage et par minutter")])], 1) : [_c('div', {
	    staticClass: "compare"
	  }, [_c('label', {
	    staticClass: "compare__toggle"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.isComparing),
	      expression: "isComparing"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.isComparing) ? _vm._i(_vm.isComparing, null) > -1 : (_vm.isComparing)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.isComparing,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.isComparing = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.isComparing = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.isComparing = $$c
	        }
	      }, _vm.readPreviousYearEvents]
	    }
	  }), _vm._v("\n        Sammenlign med året før\n      ")]), _vm._v(" "), (_vm.isComparing) ? _c('div', {
	    staticClass: "compare__chart"
	  }, [(_vm.isLoadingPreviousYear) ? _c('Loader') : _c('LineChart', {
	    attrs: {
	      "chart-data": _vm.comparisonChartData,
	      "options": _vm.chartOptions
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Årsag")]), _vm._v(" "), _vm._l((_vm.restructuredAbsenceData), function(monthData) {
	    return _c('th', {
	      key: monthData.month
	    }, [_vm._v(_vm._s(monthData.month))])
	  })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.visibleAbsenceTypes), function(type) {
	    return _c('tr', [_c('td', [_c('div', {
	      staticClass: "icon__bg-circle",
	      on: {
	        "click": function($event) {
	          return _vm.toggleHiddenAbsence(type)
	        }
	      }
	    }, [_c('svg', {
	      staticClass: "tw-icon",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24",
	        "fill": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "d": "M12 15a3 3 0 100-6 3 3 0 000 6z"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "fill-rule": "evenodd",
	        "d": "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z",
	        "clip-rule": "evenodd"
	      }
	    })])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(type))]), _vm._v(" "), _vm._l((_vm.restructuredAbsenceData), function(monthData) {
	      return _c('td', {
	        key: monthData.month
	      }, [_vm._v("\n        " + _vm._s(monthData[type]) + "\n      ")])
	    })], 2)
	  }), _vm._v(" "), (_vm.hiddenAbsenceTypes.length > 0) ? _c('tr', {
	    staticClass: "toggler",
	    on: {
	      "click": function($event) {
	        _vm.showHidden = !_vm.showHidden
	      }
	    }
	  }, [_c('td', {
	    attrs: {
	      "colspan": 2 + (_vm.restructuredAbsenceData.length * 1)
	    }
	  }, [(!_vm.showHidden) ? _c('p', {
	    staticClass: "hidden-toggler"
	  }, [_c('span', {
	    staticClass: "icon-arrow-right4"
	  }), _vm._v("Vis skjulte årsager (" + _vm._s(_vm.hiddenAbsenceTypes.length) + ")")]) : _c('p', {
	    staticClass: "hidden-toggler"
	  }, [_c('span', {
	    staticClass: "icon-arrow-down4"
	  }), _vm._v("Skjul skjulte årsager")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.hiddenAbsenceTypes), function(type) {
	    return (_vm.showHidden) ? _c('tr', [_c('td', [_c('div', {
	      staticClass: "icon__bg-circle",
	      on: {
	        "click": function($event) {
	          return _vm.toggleHiddenAbsence(type)
	        }
	      }
	    }, [_c('svg', {
	      staticClass: "tw-icon",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24",
	        "fill": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "d": "M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "d": "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "d": "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z"
	      }
	    })])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(type))]), _vm._v(" "), _vm._l((_vm.restructuredAbsenceData), function(monthData) {
	      return _c('td', {
	        key: monthData.month
	      }, [_vm._v("\n          " + _vm._s(monthData[type]) + "\n        ")])
	    })], 2) : _vm._e()
	  })], 2)])]], 2)
	},staticRenderFns: []}

/***/ }),
/* 2159 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "supplement-types text-dark",
	    class: {
	      'supplement-types--full': _vm.isInOpusModal
	    }
	  }, [_c('div', {
	    staticClass: "supplement-types__header"
	  }, [_c('div', {
	    staticClass: "supplement-types__header__left"
	  }, [_c('h2', [_vm._v("Faste tillæg")]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "white-theme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "supplement-types__header__left"
	  }, [(!_vm.isInOpusModal) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": function($event) {
	        return _vm.setIsCreateModal(true)
	      }
	    }
	  }, [_vm._v("Opret tillæg")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "supplement-types__header"
	  }, [_c('div', {
	    staticClass: "supplement-types__header__left"
	  }, [(!_vm.isInOpusModal) ? _c('Tabs', {
	    attrs: {
	      "tabs": _vm.supplementTabs,
	      "selected": _vm.selectedTab
	    },
	    on: {
	      "select": function($event) {
	        _vm.selectedTab = $event
	      }
	    }
	  }) : _c('Tabs', {
	    attrs: {
	      "tabs": _vm.stateTabs,
	      "selected": _vm.stateFilter
	    },
	    on: {
	      "select": function($event) {
	        _vm.stateFilter = $event
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    class: {
	      'do-bttn--loading': _vm.isDownloading
	    },
	    on: {
	      "click": _vm.asyncLoadXLSXAndDownloadSimple
	    }
	  }, [_vm._v("\n        Download til excel\n      ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "supplement-types__header__left"
	  }, [(_vm.response.length > 0) ? _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        _vm.isShowResponseModal = true
	      }
	    }
	  }, [_vm._v("Vis status")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === '(Lønbrøk)') ? _c('button', {
	    staticClass: "do-bttn",
	    class: {
	      'do-bttn--submit--loading': _vm.isGeneratingSupplementType === 'lønbrøk'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.generateSalarySupplements('lønbrøk')
	      }
	    }
	  }, [_vm._v("\n        Hent lønbrøk\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'undervisningstillæg') ? _c('button', {
	    staticClass: "do-bttn",
	    class: {
	      'do-bttn--submit--loading': _vm.isGeneratingSupplementType === 'undervisningstillæg'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.generateSalarySupplements('undervisningstillæg')
	      }
	    }
	  }, [_vm._v("\n        Hent UV-tillæg\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'undervisningstillæg') ? _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        _vm.isShowUvLimitsModal = true
	      }
	    }
	  }, [_vm._v("\n        Se og rediger UV-grænser\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'specialskoletillæg') ? _c('button', {
	    staticClass: "do-bttn",
	    class: {
	      'do-bttn--submit--loading': _vm.isGeneratingSupplementType === 'specialskoletillæg'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.generateSalarySupplements('specialskoletillæg')
	      }
	    }
	  }, [_vm._v("\n        Hent spec-skole UV-tillæg\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'specialskoletillæg') ? _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        _vm.isShowUvLimitsModal = true
	      }
	    }
	  }, [_vm._v("\n        Se og rediger UV-grænser\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'opgaver') ? _c('button', {
	    staticClass: "do-bttn",
	    class: {
	      'do-bttn--submit--loading': _vm.isGeneratingSupplementType === 'opgaver'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.generateSalarySupplements('opgaver')
	      }
	    }
	  }, [_vm._v("\n        Hent opgaver med lønkoder\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'opgaver') ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowTasksModal(true)
	      }
	    }
	  }, [_vm._v("\n        Tilføj lønkode til opgaver\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', [(_vm.isLoading) ? _c('div', [_c('Loader')], 1) : _c('table', {
	    staticClass: "do-table",
	    class: {
	      'do-table--fixed': _vm.isInOpusModal
	    }
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', {
	    class: {
	      'td-identitet': _vm.isInOpusModal
	    }
	  }, [_vm._v(_vm._s(_vm.isInOpusModal ? 'Ansættelse' : 'Identitet'))]), _vm._v(" "), _c('th', [_vm._v("Brutto årsnorm")]), _vm._v(" "), _c('th', {
	    staticClass: "width-period"
	  }, [_vm._v("Beregningsperiode")]), _vm._v(" "), _c('th', [_vm._v("Lønkode")]), _vm._v(" "), _c('th', [_vm._v("Omkostningssted")]), _vm._v(" "), _c('th', [_vm._v("Enheder i periode")]), _vm._v(" "), _c('th', [_vm._v("Antal udbetalinger")]), _vm._v(" "), _c('th', [_vm._v("Enh. pr måned")]), _vm._v(" "), (_vm.isInOpusModal && _vm.isSalaryIntegrationActive) ? _c('th', [_vm._v("Status")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.supplementsFiltered.length === 0) ? _c('tr', [_c('td', {
	    attrs: {
	      "colspan": (_vm.isInOpusModal && _vm.isSalaryIntegrationActive) ? 10 : 9
	    }
	  }, [_c('i', [_vm._v("Ingen oprettet i skoleåret")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.supplementsFiltered), function(supplement) {
	    return _c('tr', {
	      key: supplement.id,
	      staticClass: "supplement-list-item",
	      class: {
	        'supplement-list-item--locked': _vm.isInOpusModal && _vm.stateFilter === 'done'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setEditSupplement(supplement)
	        }
	      }
	    }, [_c('td', [_vm._v("\n          " + _vm._s(supplement.vUserName) + "\n        ")]), _vm._v(" "), (_vm.isInOpusModal) ? _c('td', {
	      staticClass: "td-identitet",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	        }
	      }
	    }, [(_vm.stateFilter === 'done') ? [_c('p', {
	      staticClass: "employment-selected"
	    }, [_vm._v(_vm._s(_vm.selectedEmploymentLabel(supplement)))])] : [_c('select', {
	      staticClass: "do-select",
	      attrs: {
	        "disabled": _vm.savingEmploymentIds.includes(supplement.id)
	      },
	      domProps: {
	        "value": supplement.employment_id || ''
	      },
	      on: {
	        "change": function($event) {
	          return _vm.onSelectEmployment(supplement, $event)
	        }
	      }
	    }, [_c('option', {
	      attrs: {
	        "value": ""
	      }
	    }, [_vm._v("Vælg ansættelse")]), _vm._v(" "), _vm._l((_vm.selectableEmploymentsForUser(supplement.user_id)), function(emp) {
	      return _c('option', {
	        key: emp.id,
	        domProps: {
	          "value": emp.id
	        }
	      }, [_vm._v("\n                " + _vm._s(_vm.employmentLabel(emp)) + "\n              ")])
	    })], 2), _vm._v(" "), (_vm.selectableEmploymentsForUser(supplement.user_id).length === 0) ? _c('span', {
	      staticClass: "employment-select__empty"
	    }, [_vm._v("\n              Ingen ansættelse med stillingskategori\n            ")]) : _vm._e()]], 2) : _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(supplement.year_norm_hours))]), _vm._v(" "), _c('td', {
	      staticClass: "width-period"
	    }, [_vm._v(_vm._s(_vm.formatPeriod(supplement.valid_period)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.salaryCodeDisplay(supplement)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.costCenterDisplay(supplement)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDecimal(supplement.units)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(supplement.installments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDecimal(supplement.units_per_installment)))]), _vm._v(" "), (_vm.isInOpusModal && _vm.isSalaryIntegrationActive) ? _c('td', [_c('span', {
	      staticClass: "supplement-state",
	      class: 'supplement-state--' + (supplement.state || 'draft')
	    }, [_vm._v("\n            " + _vm._s(_vm.stateLabel(supplement.state)) + "\n          ")])]) : _vm._e()])
	  })], 2)])]), _vm._v(" "), (_vm.isCreateModal) ? _c('CreateSupplement', {
	    attrs: {
	      "isSubmitting": _vm.isSubmitting,
	      "schoolId": _vm.schoolId,
	      "schoolYearId": _vm.schoolYearId,
	      "schoolYear": _vm.schoolYear,
	      "editSupplement": _vm.editSupplement,
	      "isInOpusModal": _vm.isInOpusModal
	    },
	    on: {
	      "save": _vm.createSupplement,
	      "update": _vm.updateSupplement,
	      "close": function($event) {
	        return _vm.setIsCreateModal(false)
	      },
	      "delete": _vm.deleteSupplement
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowTasksModal) ? _c('TaskOverviewSettings', {
	    attrs: {
	      "isSupplements": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsShowTasksModal(false)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowResponseModal) ? _c('ShowResponse', {
	    attrs: {
	      "users": _vm.response
	    },
	    on: {
	      "close": function($event) {
	        _vm.isShowResponseModal = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowUvLimitsModal) ? _c('UvLimitsModal', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "schoolYearId": _vm.schoolYearId
	    },
	    on: {
	      "supplement-created": _vm.readSupplements,
	      "close": function($event) {
	        _vm.isShowUvLimitsModal = false
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2160 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "reporting"
	  }, [_c('a', {
	    staticClass: "d-back-link",
	    attrs: {
	      "href": "/calendar"
	    }
	  }, [_vm._v("Tilbage til Docendo")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs"
	  }, _vm._l((_vm.theTabs), function(tab, prop) {
	    return _c('div', {
	      staticClass: "d-tabs__tab",
	      class: [{
	          'd__tabs__tab--inactive': tab.inactive
	        },
	        {
	          'd-tabs__tab--active': _vm.getIsTheActiveTab(prop)
	        }
	      ],
	      on: {
	        "click": function($event) {
	          return _vm.setTheActiveTab(tab, prop)
	        }
	      }
	    }, [_vm._v("\n      " + _vm._s(prop) + ". " + _vm._s(tab.title) + "\n    ")])
	  }), 0), _vm._v(" "), (_vm.isLoadingStilData) ? _c('div', {
	    staticStyle: {
	      "width": "500px"
	    }
	  }, [_c('Loader')], 1) : _c('div', {
	    staticClass: "reporting-content"
	  }, [_c('div', {
	    staticClass: "reporting__table"
	  }, [_c(_vm.theActiveComponent, {
	    tag: "component",
	    attrs: {
	      "standardSubjects": _vm.standardSubjects,
	      "stilData": _vm.stilData,
	      "dbStilData": _vm.dbStilData,
	      "isShowSubjects": _vm.isShowSubjects,
	      "usersSSNHash": _vm.usersSSNHash,
	      "klokketimetyper": _vm.klokketimetyper
	    },
	    on: {
	      "updateStil": _vm.updateStil,
	      "updateStilReportUser": _vm.updateStilReportUser
	    }
	  })], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "reporting__header"
	  }, [_c('div', {
	    staticClass: "reporting__header__right"
	  }, [_c('h1', [_vm._v("Kompetenceindberetning")])])])
	}]}

/***/ }),
/* 2161 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-create-task-for-user"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Opret person på " + _vm._s(_vm.calendar.name))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" Vælg personale ")]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "user",
	      "calendarIdsToHide": _vm.calendarIdsToHide,
	      "showTags": false,
	      "preSelectedItems": _vm.userCalendarIds,
	      "showCreateButton": false
	    },
	    on: {
	      "update": _vm.setSelectedUsers
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer"
	  }, [(!_vm.isValidated) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")]) : _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 2162 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "day-cal__event-container",
	    on: {
	      "pointerenter": _vm.onMouseEnterDay,
	      "pointerleave": _vm.onMouseLeaveDay
	    }
	  }, [(_vm.isDraggingEvent) ? _c('div', {
	    staticClass: "day-cal__event-container__events",
	    class: [{
	      'day-cal__event-container__events--active--resizing': _vm.isResizingEvent
	    }, {
	      'day-cal__event-container__events--active': _vm.dragLesson
	    }]
	  }, [(_vm.dragLesson && _vm.isActiveDay) ? _c('div', {
	    staticClass: "day-cal__event day-cal__event--dragged",
	    class: {
	      'day-cal__event--is-small': _vm.dragEventHeight < 20
	    },
	    style: ({
	      'borderColor': _vm.dragLesson.obj.color,
	      'height': _vm.dragEventHeight + 'px',
	      'top': (_vm.dragEventY - 1) + 'px',
	      'left': 0,
	      'width': '100%',
	      'zIndex': 100
	    }),
	    attrs: {
	      "data-cols": "1"
	    }
	  }, [_c('div', {
	    staticClass: "day-cal__event__content"
	  }, [_c('div', {
	    staticClass: "day-cal__event__content__header"
	  }, [_c('div', {
	    staticClass: "d-cal__event-title"
	  }, [_vm._v(_vm._s(_vm.dragLesson.obj.title))]), _vm._v(" "), _c('div', {
	    staticClass: "d-cal__event-time"
	  }, [_c('span', {
	    staticClass: "d-cal__event-time__start"
	  }, [_vm._v(_vm._s(_vm.dragEventStartTime) + " - " + _vm._s(_vm.dragEventEndTime))]), _vm._v(" "), (_vm.dragLesson.obj.has_notes) ? _c('span', {
	    staticClass: "d-cal__event-meta icon-file-text2"
	  }) : _vm._e(), _vm._v(" "), (_vm.dragLesson.obj.has_substitute) ? _c('span', {
	    staticClass: "d-cal__event-meta icon-users3"
	  }) : _vm._e()])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.dragLesson.obj.teacher),
	      expression: "dragLesson.obj.teacher"
	    }],
	    staticClass: "day-cal__event__calendar"
	  }, [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v("\n          " + _vm._s(_vm.dragLesson.obj.teacher) + "\n        ")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.dragLesson.obj.group),
	      expression: "dragLesson.obj.group"
	    }],
	    staticClass: "day-cal__event__calendar"
	  }, [_c('span', {
	    staticClass: "icon-users"
	  }), _vm._v("\n          " + _vm._s(_vm.dragLesson.obj.group) + "\n        ")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.dragLesson.obj.room),
	      expression: "dragLesson.obj.room"
	    }],
	    staticClass: "day-cal__event__calendar"
	  }, [_c('span', {
	    staticClass: "icon-location"
	  }), _vm._v("\n          " + _vm._s(_vm.dragLesson.obj.room) + "\n        ")])]), _vm._v(" "), _c('div', {
	    staticClass: "day-cal__event__bg",
	    staticStyle: {
	      "opacity": "1"
	    },
	    style: ({
	      backgroundColor: _vm.dragLesson.obj.color
	    })
	  }), _vm._v(" "), _c('div', {
	    staticClass: "day-cal__event__sider",
	    style: ({
	      backgroundColor: _vm.dragLesson.obj.color
	    })
	  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "day-cal__event-container__events",
	    class: {
	      'day-cal__event-container__events--highlighted': _vm.isCopyCalendarModalOpen
	    }
	  }, _vm._l((_vm.correctEvents), function(event) {
	    return _c('div', {
	      key: event.obj.event_key,
	      staticClass: "day-cal__event",
	      class: [{
	        'day-cal__event--is-away': event.obj.away
	      }, {
	        'day-cal__event--is-canceled': event.obj.canceled
	      }, {
	        'day-cal__event--has-warning': event.obj.collision
	      }, {
	        'day-cal__event--is-other-calendar': event.obj.v_other_calendar
	      }, {
	        'day-cal__event--is-locked': _vm.isLocked
	      }, {
	        'day-cal__event--is-small': event.height < 20
	      }, {
	        'day-cal__event--other-school': event.obj.v_other_school
	      }, {
	        'day-cal__event--editable': event.obj.v_is_editable
	      }, {
	        'day-cal__event--hide': _vm.dragLesson && _vm.dragLesson.obj.event_id === event.obj.event_id && _vm.isDraggingEvent
	      }, {
	        'fc-bgevent__presence': event.obj.event_type === 'presence'
	      }, {
	        'day-cal__event--clickable': _vm.isEventsClickable
	      }, {
	        'day-cal__event--availability': event.obj.rendering
	      }, {
	        'day-cal__event--selectable': _vm.isMultiSelectActive && _vm.isEventSelectable(event.obj)
	      }, {
	        'day-cal__event--selected': _vm.isMultiSelectActive && _vm.isEventSelected(event.obj)
	      }],
	      style: ({
	        'borderColor': event.obj.color,
	        'height': event.height + 'px',
	        'top': (event.top - 1) + 'px',
	        'left': event.left + '%',
	        'width': event.width + '%'
	      }),
	      attrs: {
	        "data-cols": event.cols ? event.cols : 1,
	        "data-subject-type": event.obj.event_type
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onNativeEventClick(event, $event)
	        },
	        "pointerdown": function($event) {
	          $event.preventDefault();
	          return _vm.onMouseDown(event, $event)
	        }
	      }
	    }, [(_vm.isMultiSelectActive && _vm.isEventSelectable(event.obj)) ? _c('div', {
	      staticClass: "day-cal__event__select js-no-click",
	      class: {
	        'day-cal__event__select--checked': _vm.isEventSelected(event.obj)
	      }
	    }, [(_vm.isEventSelected(event.obj)) ? _c('span', {
	      staticClass: "icon-checkmark4"
	    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!event.obj.v_other_school && event.obj.event_type !== 'presence') ? _c('div', {
	      staticClass: "day-cal__event__content",
	      class: {
	        'day-cal__event__content--loading': event.obj.v_is_loading
	      },
	      style: ({
	        'borderColor': event.obj.color
	      })
	    }, [_c('div', {
	      staticClass: "day-cal__event__content__header"
	    }, [_c('div', {
	      staticClass: "d-cal__event-title"
	    }, [(event.obj.v_other_calendar) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation: 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
	      }],
	      staticClass: "d-cal__event__other-calendar js-no-click",
	      attrs: {
	        "content": _vm.customTooltip(event.obj)
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          $event.preventDefault();
	          return _vm.goToCalendar(event.obj.calendar_id, $event)
	        }
	      }
	    }, [_c('svg', {
	      staticClass: "js-no-click tw-icon w-6 h-6",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": event.obj.color
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
	      }
	    })])]) : _vm._e(), _vm._v(" "), (event.obj.away) ? _c('span', {
	      staticClass: "icon-home2 icon-home2-away icon-home2-away--schedules"
	    }) : _vm._e(), _vm._v("\n            " + _vm._s(event.obj.title) + "\n          ")]), _vm._v(" "), _c('div', {
	      staticClass: "d-cal__event-time"
	    }, [_c('span', {
	      staticClass: "d-cal__event-time__start"
	    }, [_vm._v(_vm._s(event.obj.event_starttime) + " - " + _vm._s(event.obj.event_endtime))]), _vm._v(" "), (event.obj.has_notes) ? _c('span', {
	      staticClass: "d-cal__event-meta icon-file-text2"
	    }) : _vm._e(), _vm._v(" "), (event.obj.has_substitute) ? _c('span', {
	      staticClass: "d-cal__event-meta icon-users3"
	    }) : _vm._e(), _vm._v(" "), (event.obj.collision || event.obj.away || event.obj.canceled) ? _c('div', {
	      staticClass: "d-cal__event-meta d-cal__event-meta__fixed d-cal__event-meta--warning",
	      class: {
	        'd-cal__event-meta__fixed--canceled': event.obj.canceled
	      }
	    }, [(event.obj.canceled) ? _c('span', {
	      staticClass: "icon-notification22"
	    }) : _c('svg', {
	      staticClass: "tw-icon tw-icon--warning",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
	      }
	    })]), _vm._v("\n              " + _vm._s(_vm.getEventWarningLabel(event.obj)) + "\n            ")]) : _vm._e()])]), _vm._v(" "), (_vm.isCalendarTypeRoom && event.obj.group) ? _c('div', {
	      staticClass: "day-cal__event__calendar"
	    }, [_c('span', {
	      staticClass: "icon-users"
	    }), _vm._v("\n          " + _vm._s(event.obj.group) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (event.obj.teacher),
	        expression: "event.obj.teacher"
	      }],
	      staticClass: "day-cal__event__calendar"
	    }, [_c('span', {
	      staticClass: "icon-user"
	    }), _vm._v("\n          " + _vm._s(event.obj.teacher) + "\n        ")]), _vm._v(" "), (!_vm.isCalendarTypeRoom && event.obj.group) ? _c('div', {
	      staticClass: "day-cal__event__calendar"
	    }, [_c('span', {
	      staticClass: "icon-users"
	    }), _vm._v("\n          " + _vm._s(event.obj.group) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (event.obj.room),
	        expression: "event.obj.room"
	      }],
	      staticClass: "day-cal__event__calendar"
	    }, [_c('span', {
	      staticClass: "icon-location"
	    }), _vm._v("\n          " + _vm._s(event.obj.room) + "\n        ")]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (event.obj.students),
	        expression: "event.obj.students"
	      }],
	      staticClass: "day-cal__event__calendar"
	    }, [_c('span', {
	      staticClass: "icon-users5"
	    }), _vm._v("\n          " + _vm._s(event.obj.students) + "\n        ")])]) : _vm._e(), _vm._v(" "), (event.obj.v_other_school) ? _c('div', {
	      staticClass: "day-cal__event__content"
	    }, [_c('div', {
	      staticClass: "day-cal__event__content__header"
	    }, [_c('div', {
	      staticClass: "d-cal__event-title"
	    }, [_vm._v(_vm._s(_vm.i18n['other_school']))]), _vm._v(" "), _c('div', {
	      staticClass: "d-cal__event-time"
	    }, [_c('span', {
	      staticClass: "d-cal__event-time__start"
	    }, [_vm._v(_vm._s(event.obj.event_starttime) + " - " + _vm._s(event.obj.event_endtime))])])])]) : _vm._e(), _vm._v(" "), (event.obj.v_is_editable && !_vm.isLocked && !_vm.isMoveOnly && !event.obj.v_is_loading) ? _c('div', {
	      staticClass: "d-event__side__resizer"
	    }) : _vm._e(), _vm._v(" "), (event.obj.v_is_editable && !_vm.isLocked) ? _c('div', {
	      staticClass: "d-event__resizer"
	    }) : _vm._e(), _vm._v(" "), (event.obj.event_type !== 'presence') ? _c('div', {
	      staticClass: "day-cal__event__bg",
	      style: ({
	        backgroundColor: event.obj.color
	      })
	    }) : _vm._e(), _vm._v(" "), (!event.obj.v_other_calendar && event.obj.event_type !== 'presence') ? _c('div', {
	      staticClass: "day-cal__event__sider",
	      style: ({
	        backgroundColor: event.obj.color
	      })
	    }) : _vm._e()])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2163 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "task-overview-page"
	  }, [_c('div', {
	    staticClass: "user-tasks__header no-print"
	  }, [_c('div', {
	    staticClass: "user-tasks__header__left"
	  }, [_c('h2', {
	    staticClass: "user-tasks__header__left__inner"
	  }, [(!_vm.isCanSeeOtherUsers) ? _c('h2', [_vm._v(_vm._s(_vm.viewedUser.name))]) : _c('SelectUser', {
	    attrs: {
	      "preSelectedUserId": _vm.user_id,
	      "userName": _vm.user_name,
	      "path": "tasks"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "no-mobile"
	  }, [_vm._v("-")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.task_overview')))])], 1), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "user-tasks__header__right"
	  }, [(_vm.viewedUser && _vm.canUserSeeVersions) ? _c('TaskOverviewVersions', {
	    attrs: {
	      "user": _vm.viewedUser
	    }
	  }) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "no-mobile marg-1-left",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })])], 1)]), _vm._v(" "), _c('TaskOverviewLive', {
	    attrs: {
	      "user": _vm.viewedUser
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2164 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.weeknoteId) ? _c('div', {
	    staticClass: "weekplan-weeknote-log text-dark ww"
	  }, [_c('button', {
	    on: {
	      "click": _vm.setShowHistory
	    }
	  }, [_c('span', {
	    staticClass: "icon-clock"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.weeknote_log.activity')))]), _vm._v(" "), (_vm.isShowHistory) ? _c('DModal', {
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": _vm.close
	    }
	  }, [_c('div', {
	    staticClass: "ww-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "ww-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.weeknote_log.saved_versions')))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "ww-modal__body"
	  }, [_c('div', {
	    staticClass: "ww-modal__body__sidebar"
	  }, [(_vm.logSorted.length === 0) ? _c('h3', {
	    staticClass: "marg-20-bottom text-explainer italic"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.weeknote_log.no_saved_versions')))]) : _c('p', {
	    staticClass: "sidebar__headline"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.weeknote_log.choose_versions_to_compare')))]), _vm._v(" "), _c('ul', _vm._l((_vm.logSorted), function(activity, key) {
	    return _c('li', {
	      staticClass: "log-list__item",
	      class: {
	        'log-list__item--active': _vm.isInActiveIdx(key)
	      },
	      attrs: {
	        "aria-number": _vm.revertedKey(activity)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setVersion(activity)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "log-list__item__header"
	    }, [_c('div', [_vm._v(_vm._s(_vm.showHumanizedTime(activity.at)) + " " + _vm._s(_vm.$t('vue2.common.ago')))]), _vm._v(" "), (_vm.isNewestVersion(activity)) ? _c('div', {
	      staticClass: "pill"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.weeknote_log.current_version')))]) : _vm._e()]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(_vm.showUser(activity.by)))])])])])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "log-cards"
	  }, _vm._l((_vm.latestActivity), function(activity, key) {
	    return _c('div', {
	      staticClass: "log-cards__card"
	    }, [_c('div', {
	      staticClass: "log-cards__card__header"
	    }, [_c('h6', [_vm._v("\n                " + _vm._s(_vm.showHumanizedTime(activity.at)) + " " + _vm._s(_vm.$t('vue2.common.ago')) + "\n                "), (_vm.isNewestVersion(activity)) ? _c('span', {
	      staticClass: "pill"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.weeknote_log.current_version')))]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.showUser(activity.by)))]), _vm._v(", " + _vm._s(_vm.showDate(activity.at)))])]), _vm._v(" "), _c('div', {
	      staticClass: "log-cards__card__content",
	      domProps: {
	        "innerHTML": _vm._s(activity.note)
	      }
	    })])
	  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.isShowHistory) ? _c('div', {
	    staticClass: "bg-overlay"
	  }) : _vm._e()], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2165 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "d-show-only-checkbox",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.isShowOnlySubjectsWithoutTeacher = !_vm.isShowOnlySubjectsWithoutTeacher
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Vis kun fag uten underviser")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.isShowOnlySubjectsWithoutTeacher),
	      expression: "isShowOnlySubjectsWithoutTeacher"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.isShowOnlySubjectsWithoutTeacher) ? _vm._i(_vm.isShowOnlySubjectsWithoutTeacher, null) > -1 : (_vm.isShowOnlySubjectsWithoutTeacher)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.isShowOnlySubjectsWithoutTeacher,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.isShowOnlySubjectsWithoutTeacher = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.isShowOnlySubjectsWithoutTeacher = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.isShowOnlySubjectsWithoutTeacher = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "doTable__items text-dark"
	  }, [(_vm.calendarsWithProps.length === 0) ? _c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen klasser opprettet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.calendarsWithProps), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "doTable__klass"
	    }, [_c('div', {
	      staticClass: "doTable__klass__header"
	    }, [_c('div', [_vm._v(_vm._s(calendar.name))]), _vm._v(" "), _c('div', [_c('button', {
	      staticClass: "do-bttn",
	      on: {
	        "click": function($event) {
	          return _vm.setIsCreate(calendar)
	        }
	      }
	    }, [_vm._v("Opprett fag i klassen")])])]), _vm._v(" "), _c('ul', {
	      staticClass: "subjects"
	    }, [(calendar.v_subjects.length < 1) ? _c('h4', {
	      staticClass: "text-explainer"
	    }, [_vm._v("Ingen fag opprettet")]) : _vm._e(), _vm._v(" "), _vm._l((calendar.v_subjects), function(subject) {
	      return (_vm.isShowOnlySubjectsWithoutTeacher ? !subject.v_has_teacher : true) ? _c('li', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: true,
	            onShow: function () { return subject.v_has_teacher; }
	          }),
	          expression: "{\n                  arrow: true,\n                  onShow: () => subject.v_has_teacher\n                }"
	        }],
	        key: subject.id,
	        staticClass: "subjects_subject",
	        class: [{
	          'subject--has-user': subject.v_has_teacher
	        }, {
	          'subject--has-room': subject.v_has_room
	        }],
	        style: ({
	          'background': subject.color
	        }),
	        attrs: {
	          "content": subject.v_teacher_names
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setEditSubject(subject)
	          }
	        }
	      }, [_vm._v("\n          " + _vm._s(subject.name) + " (" + _vm._s(subject.hours) + ")\n        ")]) : _vm._e()
	    })], 2)])
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2166 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._l((_vm.colors), function(color, idx) {
	    return _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selectedColor),
	        expression: "selectedColor"
	      }],
	      key: idx,
	      ref: "inputradio",
	      refInFor: true,
	      staticClass: "hidden_field",
	      attrs: {
	        "type": "radio",
	        "name": "color"
	      },
	      domProps: {
	        "value": color.value,
	        "checked": _vm._q(_vm.selectedColor, color.value)
	      },
	      on: {
	        "change": function($event) {
	          _vm.selectedColor = color.value
	        }
	      }
	    })
	  }), _vm._v(" "), _c('ul', {
	    staticClass: "color-picker"
	  }, _vm._l((_vm.colors), function(color, idx) {
	    return _c('li', {
	      key: color.value,
	      staticClass: "color-picker__color hint--top",
	      class: {
	        'isActive': _vm.isSelectedColor(color.value)
	      },
	      style: ({
	        'backgroundColor': color.value
	      }),
	      attrs: {
	        "aria-label": color.title
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setColor(idx)
	        }
	      }
	    })
	  }), 0)], 2)
	},staticRenderFns: []}

/***/ }),
/* 2167 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-hours"
	  }, [(_vm.isShowOptions) ? _c('label', {
	    staticClass: "d-label marg-1-top"
	  }, [_vm._v(_vm._s(_vm.i18n['period_hours']))]) : _vm._e(), _vm._v(" "), (_vm.isShowOptions) ? _c('DoDatePickerRange', {
	    attrs: {
	      "date": _vm.date,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate
	    },
	    on: {
	      "datesChanged": _vm.setDates
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isDKSchool) ? _c('div', {
	    staticClass: "do-hours__controls",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.setShowLessons(!_vm.showLessons)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n['show_lessons']) + " (" + _vm._s(_vm.subjectDefaultDuration) + " min)")]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "propOn": _vm.showLessons
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "is-small": true,
	      "bg-color": "#ffffff"
	    }
	  }) : [_c('div', {
	    ref: "dropdown",
	    staticClass: "do-card--overflow",
	    style: ({
	      'maxHeight': _vm.maxHeight
	    })
	  }, [(_vm.hoursGrouped.length < 1) ? _c('h3', {
	    staticClass: "text-explainer marg-1-top"
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n['no_schedule']) + "\n      ")]) : _c('table', {
	    staticClass: "do-hours__table"
	  }, [_c('tbody', [_vm._l((_vm.hoursGroupedSorted), function(parentCat) {
	    return [_c('tr', {
	      staticClass: "do-hours__row do-hours__row--parent"
	    }, [_c('td', {
	      staticClass: "do-hours__cell do-hours__cell--title"
	    }, [_c('strong', [_vm._v(_vm._s(parentCat.vTitle))])]), _vm._v(" "), _c('td', {
	      staticClass: "do-hours__cell do-hours__cell--value"
	    }, [_c('strong', [_vm._v(_vm._s(parentCat.vHours))])]), _vm._v(" "), (_vm.showLessons) ? _c('td', {
	      staticClass: "do-hours__cell do-hours__cell--lessons"
	    }, [_c('strong', [_vm._v(_vm._s(parentCat.vLessons))])]) : _vm._e()]), _vm._v(" "), _vm._l((parentCat.subCategories), function(subCat) {
	      return [(parentCat.subCategories.length > 1) ? _c('tr', {
	        staticClass: "do-hours__row do-hours__row--sub"
	      }, [_c('td', {
	        staticClass: "do-hours__cell do-hours__cell--title"
	      }, [_vm._v(_vm._s(subCat.vTitle))]), _vm._v(" "), _c('td', {
	        staticClass: "do-hours__cell do-hours__cell--value"
	      }, [_vm._v(_vm._s(subCat.vHours))]), _vm._v(" "), (_vm.showLessons) ? _c('td', {
	        staticClass: "do-hours__cell do-hours__cell--lessons"
	      }, [_vm._v("\n                " + _vm._s(subCat.vLessons) + "\n              ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((subCat.subjects), function(subject) {
	        return [_c('tr', {
	          staticClass: "do-hours__row do-hours__row--subject"
	        }, [_c('td', {
	          staticClass: "do-hours__cell do-hours__cell--title"
	        }, [_vm._v(_vm._s(subject.vTitle))]), _vm._v(" "), _c('td', {
	          staticClass: "do-hours__cell do-hours__cell--value"
	        }, [_vm._v(_vm._s(subject.vHours))]), _vm._v(" "), (_vm.showLessons) ? _c('td', {
	          staticClass: "do-hours__cell do-hours__cell--lessons"
	        }, [_vm._v("\n                  " + _vm._s(subject.vLessons) + "\n                ")]) : _vm._e()])]
	      })]
	    })]
	  })], 2)])])]], 2)
	},staticRenderFns: []}

/***/ }),
/* 2168 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.isLoading || _vm.imports.length > 0) ? _c('div', {
	    staticClass: "zen-changes"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label d-label--white"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.changes_from_import')))]), _vm._v(" "), _c('p', {
	    staticClass: "zen-changes__help"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.changes_from_import_help')))]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
	    staticClass: "box"
	  }, [_c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  })], 1) : _c('div', {
	    staticClass: "zen-imports"
	  }, _vm._l((_vm.imports), function(imp) {
	    return _c('div', {
	      key: imp.id,
	      staticClass: "zen-import-row",
	      on: {
	        "click": function($event) {
	          return _vm.openImport(imp)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "zen-import-row__left"
	    }, [_c('p', {
	      staticClass: "zen-import-row__title"
	    }, [_vm._v(_vm._s(imp.title || _vm.$t('vue2.zen_import.import_from_zen')))]), _vm._v(" "), _c('p', {
	      staticClass: "zen-import-row__meta"
	    }, [_c('span', [_vm._v(_vm._s(_vm.showHumanizeDate(imp.created_at)))]), _vm._v(" "), (imp.summary) ? _c('span', {
	      staticClass: "zen-import-row__counts"
	    }, [_vm._v("\n              · " + _vm._s(_vm.calendarChangeCount(imp)) + " " + _vm._s(_vm.$t('vue2.zen_import.calendars_label')) + ",\n              " + _vm._s(_vm.subjectChangeCount(imp)) + " " + _vm._s(_vm.$t('vue2.zen_import.subjects_label')) + "\n            ")]) : _c('span', {
	      staticClass: "zen-import-row__processing"
	    }, [_vm._v("· " + _vm._s(_vm.$t('vue2.zen_import.import_processing')))])])]), _vm._v(" "), _c('button', {
	      staticClass: "bttn zen-view-bttn",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.openImport(imp)
	        }
	      }
	    }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.zen_import.view_changes')) + "\n        ")])])
	  }), 0)]), _vm._v(" "), (_vm.activeImport) ? _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "is-bg-overlay": true
	    },
	    on: {
	      "close": _vm.closeImport
	    }
	  }, [_c('div', {
	    staticClass: "zen-changes-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.activeImport.title || _vm.$t('vue2.zen_import.changes_from_import')))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": _vm.closeImport
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [(_vm.isEmptyImport) ? _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.zen_import.no_changes_in_import')) + "\n        ")]) : _vm._l((_vm.classGroups), function(group) {
	    return _c('section', {
	      key: group.calendarId,
	      staticClass: "zen-changes-group"
	    }, [_c('label', {
	      staticClass: "d-label d-label__divider"
	    }, [_vm._v(_vm._s(group.name))]), _vm._v(" "), (group.createdItems.length) ? _c('table', {
	      staticClass: "do-table do-table--striped zen-table"
	    }, [_c('thead', [_c('tr', [_c('th', {
	      staticClass: "zen-table__type"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.type_column')))]), _vm._v(" "), _c('th', {
	      staticClass: "zen-table__id"
	    }, [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('vue2.zen_import.field_name')))])])]), _vm._v(" "), _c('tbody', [_c('tr', {
	      staticClass: "zen-table__section"
	    }, [_c('td', {
	      attrs: {
	        "colspan": "3"
	      }
	    }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.created_title')))])]), _vm._v(" "), _vm._l((group.createdItems), function(item) {
	      return _c('tr', {
	        key: 'c-' + item.key
	      }, [_c('td', {
	        staticClass: "zen-table__type"
	      }, [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('td', {
	        staticClass: "zen-table__id"
	      }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))])])
	    })], 2)]) : _vm._e(), _vm._v(" "), (group.changedItems.length) ? _c('table', {
	      staticClass: "do-table do-table--striped zen-table"
	    }, [_c('thead', [_c('tr', [_c('th', {
	      staticClass: "zen-table__type"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.type_column')))]), _vm._v(" "), _c('th', {
	      staticClass: "zen-table__id"
	    }, [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('vue2.zen_import.field_name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('vue2.zen_import.excel_field')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('vue2.zen_import.excel_old_value')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('vue2.zen_import.excel_new_value')))])])]), _vm._v(" "), _c('tbody', [_c('tr', {
	      staticClass: "zen-table__section"
	    }, [_c('td', {
	      attrs: {
	        "colspan": "6"
	      }
	    }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.changed_title')))])]), _vm._v(" "), _vm._l((group.changedItems), function(item) {
	      return _c('tr', {
	        key: 'm-' + item.key
	      }, [_c('td', {
	        staticClass: "zen-table__type"
	      }, [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('td', {
	        staticClass: "zen-table__id"
	      }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', _vm._l((_vm.diffList(item.changes)), function(diff) {
	        return _c('div', {
	          key: diff.field
	        }, [_vm._v(_vm._s(diff.label))])
	      }), 0), _vm._v(" "), _c('td', _vm._l((_vm.diffList(item.changes)), function(diff) {
	        return _c('div', {
	          key: diff.field,
	          staticClass: "zen-diff__from"
	        }, [_vm._v(_vm._s(diff.from))])
	      }), 0), _vm._v(" "), _c('td', _vm._l((_vm.diffList(item.changes)), function(diff) {
	        return _c('div', {
	          key: diff.field,
	          staticClass: "zen-diff__to"
	        }, [_vm._v(_vm._s(diff.to))])
	      }), 0)])
	    })], 2)]) : _vm._e()])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer zen-changes-modal__footer"
	  }, [(!_vm.isEmptyImport) ? _c('button', {
	    staticClass: "do-bttn do-bttn--with-icon",
	    on: {
	      "click": _vm.asyncLoadXLSXAndDownload
	    }
	  }, [(_vm.isDownloadingExcel) ? _c('span', {
	    staticClass: "do-spinner do-spinner--small"
	  }) : _c('span', {
	    staticClass: "icon-download"
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.zen_import.download_to_excel')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.closeImport
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.done')))])])])]) : _vm._e()], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2169 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeEdit),
	      expression: "closeEdit"
	    }],
	    staticClass: "qeip text-dark",
	    class: {
	      'qeip--active': _vm.edit
	    },
	    on: {
	      "mousedown": function($event) {
	        _vm.isMouseDown = true
	      },
	      "mouseup": function($event) {
	        _vm.isMouseDown = false
	      }
	    }
	  }, [(!_vm.edit && _vm.textWithoutHTML.length < 1) ? _c('div', {
	    staticClass: "qeip--empty",
	    on: {
	      "click": _vm.setEdit
	    }
	  }, [_c('span', {
	    staticClass: "icon-pencil"
	  })]) : _vm._e(), _vm._v(" "), (!_vm.edit && _vm.textWithoutHTML.length > 0) ? _c('div', {
	    staticClass: "qeip--filled",
	    on: {
	      "click": _vm.setEdit
	    }
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.text)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.edit) ? _c('div', [_c('quill-editor', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "content": _vm.text,
	      "options": _vm.editorOption
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onEditorChange($event)
	      },
	      "ready": function($event) {
	        return _vm.onEditorReady($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-quill__toolbar",
	    attrs: {
	      "slot": "toolbar",
	      "id": 'toolbar_' + _vm.uniqueNum,
	      "data-num": _vm.uniqueNum
	    },
	    slot: "toolbar"
	  }, [_c('button', {
	    staticClass: "ql-bold hint--bottom",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['bold']
	    }
	  }, [_vm._v("Bold")]), _vm._v(" "), _c('button', {
	    staticClass: "ql-italic hint--bottom",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['italic']
	    }
	  }, [_vm._v("Italic")]), _vm._v(" "), _c('button', {
	    staticClass: "ql-underline hint--bottom",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['underline']
	    }
	  }, [_vm._v("Underline")]), _vm._v(" "), _c('button', {
	    staticClass: "ql-list hint--bottom",
	    attrs: {
	      "value": "ordered",
	      "aria-label": _vm.i18n[_vm.locale]['list_ordered']
	    }
	  }, [_vm._v("Ordered\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "ql-list hint--bottom",
	    attrs: {
	      "value": "bullet",
	      "aria-label": _vm.i18n[_vm.locale]['list_bullets']
	    }
	  }, [_vm._v("bullet")]), _vm._v(" "), _c('button', {
	    staticClass: "hint--bottom",
	    attrs: {
	      "id": "custom-button",
	      "aria-label": _vm.i18n[_vm.locale]['insert_link']
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setIsLinkModal(true)
	      }
	    }
	  }, [_c('svg', {
	    attrs: {
	      "viewBox": "0 0 18 18"
	    }
	  }, [_c('line', {
	    staticClass: "ql-stroke",
	    attrs: {
	      "x1": "7",
	      "x2": "11",
	      "y1": "7",
	      "y2": "11"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "ql-even ql-stroke",
	    attrs: {
	      "d": "M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "ql-even ql-stroke",
	    attrs: {
	      "d": "M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z"
	    }
	  })])])])]), _vm._v(" "), (_vm.isInTestOfSaveButton) ? _c('div', {
	    staticClass: "save-buttons"
	  }, [_c('button', {
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isChanged) ? _c('button', {
	    staticClass: "submit-button submit-button--disabled"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))]) : _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isClosingWithoutSaving) ? _c('div', {
	    staticClass: "bg-overlay"
	  }) : _vm._e(), _vm._v(" "), (_vm.isClosingWithoutSaving) ? _c('DModal', {
	    staticClass: "ap",
	    attrs: {
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "quill-modal quill-modal__save-changes",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('h4', {
	    staticClass: "marg-20-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save_changes')))]), _vm._v(" "), _c('div', {
	    staticClass: "save-buttons"
	  }, [_c('button', {
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])])])]) : _vm._e(), _vm._v(" "), (_vm.isLinkModal) ? _c('div', {
	    staticClass: "bg-overlay"
	  }) : _vm._e(), _vm._v(" "), (_vm.isLinkModal) ? _c('DModal', {
	    on: {
	      "close": function($event) {
	        return _vm.setIsLinkModal(false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "quill-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "quill-modal__content"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['link_text_label']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.linkText),
	      expression: "linkText"
	    }],
	    ref: "linkTextInput",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale]['link_text_placeholder']
	    },
	    domProps: {
	      "value": (_vm.linkText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.linkText = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['link_link_label']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.link),
	      expression: "link"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale]['link_link_placeholder']
	    },
	    domProps: {
	      "value": (_vm.link)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.link = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "quill-modal__footer"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setIsLinkModal(false)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
	    staticClass: "bttn bttn-primary submit-button submit-button--disabled"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['insert_link']) + "\n          ")]) : _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.insertLink.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['insert_link']) + "\n          ")])])])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2170 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sms text-dark no-print text-dark"
	  }, [(!_vm.isOpen) ? _c('div', {
	    staticClass: "sms-header__toggler",
	    on: {
	      "click": function($event) {
	        return _vm.setOpen(!_vm.isOpen)
	      }
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']))]), _vm._v(" "), _c('div', {
	    staticClass: "close-icon sms-header__toggler__icon text-white"
	  }, [(_vm.isOpen) ? _c('span', {
	    staticClass: "icon-cross2"
	  }) : _c('span', {
	    staticClass: "icon-arrow-up4"
	  })])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "slideInUp"
	    },
	    on: {
	      "after-enter": _vm.onEnterComplete
	    }
	  }, [(_vm.isOpen) ? _c('div', {
	    staticClass: "sms-container"
	  }, [_c('div', {
	    staticClass: "sms-header__toggler",
	    on: {
	      "click": function($event) {
	        _vm.isOpen = !_vm.isOpen
	      }
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']))]), _vm._v(" "), _c('div', {
	    staticClass: "close-icon sms-header__toggler__icon text-white"
	  }, [(_vm.isOpen) ? _c('span', {
	    staticClass: "icon-cross2"
	  }) : _c('span', {
	    staticClass: "icon-arrow-up4"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "sms-body"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fadeOut"
	    }
	  }, [(_vm.noNumberForUser) ? _c('div', {
	    staticClass: "sms-body__signup"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    staticClass: "sms-body__signup__content box"
	  }, [_c('h2', {
	    staticClass: "text-blue"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['welcome_to_sms']))]), _vm._v(" "), _c('p', {
	    staticClass: "marg-10-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_your_number_to_send_sms']))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_your_number']))]), _vm._v("\n                " + _vm._s(_vm.user.phone) + "\n                "), _c('SmsAddNumber', {
	    staticClass: "marg-10-right",
	    attrs: {
	      "userid": _vm.user.id,
	      "updateThisUser": true,
	      "isEditFromStart": true
	    }
	  })], 1)])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "select-users"
	  }, [_c('div', {
	    staticClass: "users-header-second users-header-second__button"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--small",
	    on: {
	      "click": _vm.getSubsOfTheDay
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['todays_substitutes']) + "\n            ")]), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": '',
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters
	    },
	    on: {
	      "select": _vm.toggleTag,
	      "clear": _vm.clearAllTags
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchText),
	      expression: "searchText"
	    }],
	    staticClass: "users-header__searchfield",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('vue2.common.search')
	    },
	    domProps: {
	      "value": (_vm.searchText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchText = $event.target.value
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "list"
	  }, [_c('ul', {
	    staticClass: "users-list"
	  }, [_c('li', {
	    staticClass: "users-user users-user__header"
	  }, [(_vm.selectedUsers.length < 1) ? _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.setAllUsersSelected
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.tagging.select_all')) + "\n                ")]) : _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.removeAllSelectedUsers
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.tagging.unselect_all')) + "\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "users-user users-user__header__right"
	  }, [_c('p', {
	    staticClass: "last-sms-text last-sms-text--click",
	    on: {
	      "click": _vm.toggleSortByLast
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm.i18n[_vm.locale].last_sms) + "\n                    "), (_vm.sortMode === 'name') ? _c('span', {
	    staticClass: "icon-menu-open"
	  }) : _vm._e(), _vm._v(" "), (_vm.sortMode === 'last') ? _c('span', [_vm._v("▲")]) : _vm._e()]), _vm._v(" "), (_vm.isSMSActive) ? _c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['sms']))]) : _vm._e(), _vm._v(" "), (_vm.isEmailActive) ? _c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['email']))]) : _vm._e()])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? [(_vm.filteredUsers.length < 1) ? _c('p', {
	    staticClass: "pad-20"
	  }, [_c('i', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_users_matches']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user, idx) {
	    return _c('li', {
	      key: user.id,
	      ref: 'user_ ' + user.id,
	      refInFor: true,
	      staticClass: "users-user",
	      class: [{
	          'users-user--only': _vm.filteredUsers.length === 1
	        },
	        {
	          'isSelected': _vm.checkIfInList(user.id)
	        },
	        {
	          'user--has-no-active-contact': user.v_phone_setting !== 'active' && user.v_email_setting !== 'active'
	        },
	        {
	          'selectedWithoutContactForm': _vm.checkIfInListWithoutContactForm(user.id)
	        }
	      ]
	    }, [_c('div', {
	      staticClass: "users-user__meta",
	      on: {
	        "click": function($event) {
	          return _vm.setUser(user, idx, $event)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "users-choose",
	      class: {
	        'users-choose--disabled': user.v_phone_setting !== 'active' && user.v_email_setting !== 'active'
	      }
	    }, [_c('div', {
	      staticClass: "checkbox",
	      class: {
	        'checkboxChecked': _vm.checkIfInList(user)
	      }
	    }, [_c('span', {
	      staticClass: "checked"
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "users-img"
	    }, [_c('img', {
	      attrs: {
	        "src": user.img,
	        "alt": ""
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "users-name"
	    }, [_c('p', [_vm._v(_vm._s(user.name))]), _vm._v(" "), (user.v_last_sms_at) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'top'
	        }),
	        expression: "{\n                             arrow: true,\n                             placement : 'top'\n                           }"
	      }],
	      staticClass: "users__last-message",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['see_message']
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.showSent(user)
	        }
	      }
	    }, [_vm._v("\n                          " + _vm._s(user.v_last_sms_at_human) + "\n                      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	      staticClass: "users-last"
	    }, [_c('div', {
	      staticClass: "contact-options"
	    }, [(_vm.isSMSActive) ? _c('div', {
	      staticClass: "contact-options__option",
	      class: {
	        'contact-options__option--disabled': user.v_phone_setting === 'deactivated'
	      }
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true
	        }),
	        expression: "{\n                             arrow: true\n                           }"
	      }],
	      staticClass: "icon__bg-circle contact-options__option__phone",
	      attrs: {
	        "content": user.v_phone_tooltip
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setOption(user, 'phone')
	        }
	      }
	    }, [(user.v_phone_setting === 'no_number') ? _c('svg', {
	      staticClass: "d-hero-icon--add w-6 h-6",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M12 4.5v15m7.5-7.5h-15"
	      }
	    })]) : _vm._e(), _vm._v(" "), (user.v_phone_setting === 'active' || user.v_phone_setting === 'deactivated') ? _c('svg', {
	      staticClass: "d-hero-icon w-6 h-6",
	      class: {
	        'd-tw-icon--deactivated': user.v_phone_setting === 'deactivated'
	      },
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
	      }
	    })]) : _vm._e(), _vm._v(" "), (user.v_phone_setting === 'awaiting_approval') ? _c('svg', {
	      staticClass: "w-6 h-6 d-icon__awaiting-approval d-hero-icon",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
	      }
	    })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isEmailActive) ? _c('div', {
	      staticClass: "contact-options__option",
	      class: {
	        'contact-options__option--disabled': user.v_email_setting === 'deactivated'
	      }
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true
	        }),
	        expression: "{\n                             arrow: true\n                           }"
	      }],
	      staticClass: "icon__bg-circle",
	      attrs: {
	        "content": user.v_email_tooltip
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setOption(user, 'email')
	        }
	      }
	    }, [(user.v_email_setting === 'no_email') ? _c('svg', {
	      staticClass: "d-hero-icon--add w-6 h-6",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M12 4.5v15m7.5-7.5h-15"
	      }
	    })]) : _vm._e(), _vm._v(" "), (user.v_email_setting === 'active' || user.v_email_setting === 'deactivated') ? _c('svg', {
	      staticClass: "w-6 h-6",
	      class: {
	        'd-tw-icon--deactivated': user.v_email_setting === 'deactivated'
	      },
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
	      }
	    })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "contact-options__option contact-options__option__settings"
	    }, [_c('div', {
	      staticClass: "icon__bg-circle icon-more2",
	      on: {
	        "click": function($event) {
	          _vm.theActiveEditUser = user
	        }
	      }
	    })])])])])
	  })] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "send-sms"
	  }, [_c('div', {
	    staticClass: "users-header-second"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message_to']) + " " + _vm._s(_vm.selectedUsers.length))])]), _vm._v(" "), _c('div', {
	    staticClass: "send-sms__body"
	  }, [_c('div', {
	    staticClass: "send-sms__body__templates"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select_a_standard_template']))]), _vm._v(" "), (_vm.isLoadingTemplates) ? _c('div', [_c('spinner', {
	    attrs: {
	      "isSmall": true
	    }
	  })], 1) : _vm._l((_vm.templates), function(template) {
	    return _c('div', {
	      key: template.id,
	      staticClass: "standard-sms flex"
	    }, [_c('div', {
	      staticClass: "standard-sms__sub sms-template"
	    }, [_c('div', {
	      staticClass: "sms-template__title",
	      on: {
	        "click": function($event) {
	          return _vm.selectTemplate(template)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-file-text"
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(template.title))])]), _vm._v(" "), _c('d-dropdown', [_c('ul', {
	      attrs: {
	        "slot": "list"
	      },
	      slot: "list"
	    }, [_c('li', {
	      on: {
	        "click": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          return _vm.setTheEditTemplate(template)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('vue2.common.edit')))]), _vm._v(" "), _c('li', {
	      staticClass: "d-item-warning",
	      on: {
	        "click": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          _vm.theDeleteTemplate = template
	        }
	      }
	    }, [_vm._v("\n                        " + _vm._s(_vm.$t('vue2.common.delete')) + "\n                      ")])])])], 1)])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "standard-sms flex"
	  }, [_c('div', {
	    staticClass: "standard-sms__sub sms-template sms-template__create",
	    on: {
	      "click": function($event) {
	        _vm.isCreateTemplate = true
	      }
	    }
	  }, [_c('div', {
	    staticClass: "sms-template__title"
	  }, [_c('span', [_vm._v("+")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['create_a_standard_template']))])])])])], 2), _vm._v(" "), _c('div', {
	    staticClass: "send-sms__body__message"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['message']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.messageSubject),
	      expression: "messageSubject"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale]['subject']
	    },
	    domProps: {
	      "value": (_vm.messageSubject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.messageSubject = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.messageBody),
	      expression: "messageBody"
	    }],
	    ref: "sms",
	    staticClass: "marg-1-bottom marg-1-top",
	    class: {
	      'error-class': _vm.giveFeedback && _vm.noText
	    },
	    attrs: {
	      "placeholder": _vm.i18n[_vm.locale]['message']
	    },
	    domProps: {
	      "value": (_vm.messageBody)
	    },
	    on: {
	      "click": function($event) {
	        _vm.giveFeedback = false
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.messageBody = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.giveFeedback && _vm.noText) ? _c('span', {
	    staticClass: "error-text"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['message_must_be_filled']))]) : _vm._e(), _vm._v(" "), (_vm.noText || _vm.noReceiver) ? _c('button', {
	    staticClass: "submit-button width-100 submit-button--disabled",
	    on: {
	      "click": function($event) {
	        _vm.giveFeedback = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']) + "\n              ")]) : _c('button', {
	    staticClass: "submit-button width-100",
	    on: {
	      "click": _vm.sendMessage
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']) + "\n              ")])]), _vm._v(" "), _c('div', {
	    staticClass: "send-sms__body__receivers marg-1-left marg-1-right"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['recipients']))]), _vm._v(" "), (_vm.selectedUsers.length < 1) ? _c('p', {
	    staticClass: "explainer-text"
	  }, [_vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale]['select_recipients']))]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "receivers-container"
	  }, _vm._l((_vm.userSetSelected), function(user) {
	    return _c('li', {
	      staticClass: "receivers-container__receiver"
	    }, [_c('div', {
	      staticClass: "receiver__name"
	    }, [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('div', {
	      staticClass: "receiver__remove icon-cross2",
	      on: {
	        "click": function($event) {
	          return _vm.setUser(user, _vm.idx)
	        }
	      }
	    })])
	  }), 0)])])])], 1)]) : _vm._e()]), _vm._v(" "), (_vm.isCreateTemplate) ? _c('TemplateModal', {
	    attrs: {
	      "editsms": _vm.theEditTemplate,
	      "messageType": "email"
	    },
	    on: {
	      "close": _vm.closeTemplate,
	      "updated": _vm.readMessageTemplates
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theDeleteTemplate) ? _c('TemplateDelete', {
	    attrs: {
	      "editsms": _vm.theDeleteTemplate
	    },
	    on: {
	      "close": function($event) {
	        _vm.theDeleteTemplate = null
	      },
	      "updated": _vm.readMessageTemplates
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveEditUser) ? _c('SendMessagesUserSetting', {
	    attrs: {
	      "user": _vm.theActiveEditUser,
	      "isEmailActive": _vm.isEmailActive,
	      "isSMSActive": _vm.isSMSActive
	    },
	    on: {
	      "close": _vm.closeUserSetting
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowPastSMSes) ? _c('SendMessagesPastSmses', {
	    attrs: {
	      "activeUser": _vm.pastSmsModalUser,
	      "sms": _vm.pastSmsModalData
	    },
	    on: {
	      "close": function($event) {
	        _vm.isShowPastSMSes = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveEditUser) ? _c('div', {
	    staticClass: "bg-overlay"
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

	var link = document.createElement('link');
	link.setAttribute('rel', 'manifest');
	link.setAttribute('href', __webpack_require__.p + "static/appmanifest.79c8be3a682f8272a7116a8e3c8cfc5b.json");
	document.head.appendChild(link);
	var manifest = {"name":"Docendo","short_name":"Docendo","theme_color":"#468ad7","background_color":"#468ad7","display":"standalone","icons":[{"src":"/app/static/icons/icon-72x72.f584413a724fc454007b3560d1c15b9d.png","sizes":"72x72","type":"image/png"},{"src":"/app/static/icons/icon-96x96.0e05086c44641ea344a819b88585ab47.png","sizes":"96x96","type":"image/png"},{"src":"/app/static/icons/icon-128x128.a855fd0e0c747c8095602abe2ef87059.png","sizes":"128x128","type":"image/png"},{"src":"/app/static/icons/icon-144x144.c7242051565445c99d4cd9f37db9da1f.png","sizes":"144x144","type":"image/png"},{"src":"/app/static/icons/icon-152x152.5b92e6ea3021ee7fe29ce0dbdf6162e9.png","sizes":"152x152","type":"image/png"},{"src":"/app/static/icons/icon-192x192.ebb3986f7be6530b978af6b82f44d8f3.png","sizes":"192x192","type":"image/png"},{"src":"/app/static/icons/icon-384x384.41378a54e0b40578c27271d92cc6b77d.png","sizes":"384x384","type":"image/png"},{"src":"/app/static/icons/icon-512x512.09293af4c248bb63ac6ebc0c27ef193e.png","sizes":"512x512","type":"image/png"}],"splash_pages":null};
	if(manifest.icons && manifest.icons.length){
	  for(var i in manifest.icons){
	    var link = document.createElement('link');
	    link.setAttribute('rel', 'apple-touch-icon');
	    link.setAttribute('sizes', manifest.icons[i].sizes);
	    link.setAttribute('href', manifest.icons[i].src);
	    document.head.appendChild(link);
	  }
	}
	if(manifest.display && (manifest.display == 'fullscreen' || manifest.display == 'standalone')){
	  var meta = document.createElement('meta');
	  meta.setAttribute('name', 'apple-mobile-web-app-capable');
	  meta.setAttribute('content', 'yes');
	  document.head.appendChild(meta);
	}
	if(manifest.theme_color){
	  var meta = document.createElement('meta');
	  meta.setAttribute('name', 'apple-mobile-web-app-status-bar-style');
	  meta.setAttribute('content', manifest.theme_color);
	  document.head.appendChild(meta);
	}


/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.6da8fb7cdb1db8e12cc9.js